(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire136b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire136b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bhfvP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $835d50b1b0b1438e$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $835d50b1b0b1438e$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $835d50b1b0b1438e$export$25062201e9e25d76; });

var $3pI8R = parcelRequire("3pI8R");

var $8kMfp = parcelRequire("8kMfp");
parcelRequire("eZVvM");
parcelRequire("hUOrI");
parcelRequire("65o8X");
parcelRequire("c2U8l");

parcelRequire("28Dco");
parcelRequire("geJaG");
parcelRequire("2mRmw");
parcelRequire("8JgfY");
var $835d50b1b0b1438e$export$ffb0004e005737fa = $3pI8R.Fragment;
function $835d50b1b0b1438e$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $8kMfp.h).call(props, "css")) return $3pI8R.jsx(type, props, key);
    return $3pI8R.jsx((0, $8kMfp.E), (0, $8kMfp.c)(type, props), key);
}
function $835d50b1b0b1438e$export$25062201e9e25d76(type, props, key) {
    if (!(0, $8kMfp.h).call(props, "css")) return $3pI8R.jsxs(type, props, key);
    return $3pI8R.jsxs((0, $8kMfp.E), (0, $8kMfp.c)(type, props), key);
}

});
parcelRegister("3pI8R", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8V93A"));

});
parcelRegister("8V93A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $67eaac1ef0310ec9$export$ffb0004e005737fa; }, function (v) { return $67eaac1ef0310ec9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $67eaac1ef0310ec9$export$34b9dba7ce09269b; }, function (v) { return $67eaac1ef0310ec9$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $67eaac1ef0310ec9$export$25062201e9e25d76; }, function (v) { return $67eaac1ef0310ec9$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67eaac1ef0310ec9$export$ffb0004e005737fa;
var $67eaac1ef0310ec9$export$34b9dba7ce09269b;
var $67eaac1ef0310ec9$export$25062201e9e25d76;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
var $67eaac1ef0310ec9$var$k = Symbol.for("react.element"), $67eaac1ef0310ec9$var$l = Symbol.for("react.fragment"), $67eaac1ef0310ec9$var$m = Object.prototype.hasOwnProperty, $67eaac1ef0310ec9$var$n = $eZVvM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $67eaac1ef0310ec9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $67eaac1ef0310ec9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$67eaac1ef0310ec9$var$m.call(a, b) && !$67eaac1ef0310ec9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $67eaac1ef0310ec9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $67eaac1ef0310ec9$var$n.current
    };
}
$67eaac1ef0310ec9$export$ffb0004e005737fa = $67eaac1ef0310ec9$var$l;
$67eaac1ef0310ec9$export$34b9dba7ce09269b = $67eaac1ef0310ec9$var$q;
$67eaac1ef0310ec9$export$25062201e9e25d76 = $67eaac1ef0310ec9$var$q;

});
parcelRegister("eZVvM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4hPUh"));

});
parcelRegister("4hPUh", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $31f1038d8b9efe40$export$dca3b0875bd9a954; }, function (v) { return $31f1038d8b9efe40$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $31f1038d8b9efe40$export$16fa2f45be04daa8; }, function (v) { return $31f1038d8b9efe40$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $31f1038d8b9efe40$export$ffb0004e005737fa; }, function (v) { return $31f1038d8b9efe40$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $31f1038d8b9efe40$export$e2c29f18771995cb; }, function (v) { return $31f1038d8b9efe40$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $31f1038d8b9efe40$export$221d75b3f55bb0bd; }, function (v) { return $31f1038d8b9efe40$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $31f1038d8b9efe40$export$5f8d39834fd61797; }, function (v) { return $31f1038d8b9efe40$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $31f1038d8b9efe40$export$74bf444e3cd11ea5; }, function (v) { return $31f1038d8b9efe40$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $31f1038d8b9efe40$export$ae55be85d98224ed; }, function (v) { return $31f1038d8b9efe40$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $31f1038d8b9efe40$export$3ba232387fd5d6dd; }, function (v) { return $31f1038d8b9efe40$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $31f1038d8b9efe40$export$e530037191fcd5d7; }, function (v) { return $31f1038d8b9efe40$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $31f1038d8b9efe40$export$fd42f52fd3ae1109; }, function (v) { return $31f1038d8b9efe40$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $31f1038d8b9efe40$export$c8a8987d4410bf2d; }, function (v) { return $31f1038d8b9efe40$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $31f1038d8b9efe40$export$d38cd72104c1f0e9; }, function (v) { return $31f1038d8b9efe40$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $31f1038d8b9efe40$export$7d1e3a5e95ceca43; }, function (v) { return $31f1038d8b9efe40$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $31f1038d8b9efe40$export$257a8862b851cb5b; }, function (v) { return $31f1038d8b9efe40$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $31f1038d8b9efe40$export$a8257692ac88316c; }, function (v) { return $31f1038d8b9efe40$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $31f1038d8b9efe40$export$488013bae63b21da; }, function (v) { return $31f1038d8b9efe40$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $31f1038d8b9efe40$export$7c73462e0d25e514; }, function (v) { return $31f1038d8b9efe40$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $31f1038d8b9efe40$export$7568632d0d33d16d; }, function (v) { return $31f1038d8b9efe40$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $31f1038d8b9efe40$export$88948ce120ea2619; }, function (v) { return $31f1038d8b9efe40$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $31f1038d8b9efe40$export$35808ee640e87ca7; }, function (v) { return $31f1038d8b9efe40$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $31f1038d8b9efe40$export$fae74005e78b1a27; }, function (v) { return $31f1038d8b9efe40$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $31f1038d8b9efe40$export$dc8fbce3eb94dc1e; }, function (v) { return $31f1038d8b9efe40$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $31f1038d8b9efe40$export$6a7bc4e911dc01cf; }, function (v) { return $31f1038d8b9efe40$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $31f1038d8b9efe40$export$6d9c69b0de29b591; }, function (v) { return $31f1038d8b9efe40$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $31f1038d8b9efe40$export$f680877a34711e37; }, function (v) { return $31f1038d8b9efe40$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $31f1038d8b9efe40$export$d5a552a76deda3c2; }, function (v) { return $31f1038d8b9efe40$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $31f1038d8b9efe40$export$aaabe4eda9ed9969; }, function (v) { return $31f1038d8b9efe40$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $31f1038d8b9efe40$export$e5c5a5f917a5871c; }, function (v) { return $31f1038d8b9efe40$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $31f1038d8b9efe40$export$1538c33de8887b59; }, function (v) { return $31f1038d8b9efe40$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $31f1038d8b9efe40$export$13e3392192263954; }, function (v) { return $31f1038d8b9efe40$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $31f1038d8b9efe40$export$b8f5890fc79d6aca; }, function (v) { return $31f1038d8b9efe40$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $31f1038d8b9efe40$export$60241385465d0a34; }, function (v) { return $31f1038d8b9efe40$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $31f1038d8b9efe40$export$306c0aa65ff9ec16; }, function (v) { return $31f1038d8b9efe40$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $31f1038d8b9efe40$export$7b286972b8d8ccbf; }, function (v) { return $31f1038d8b9efe40$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $31f1038d8b9efe40$export$83d89fbfd8236492; }, function (v) { return $31f1038d8b9efe40$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $31f1038d8b9efe40$export$dca3b0875bd9a954;
var $31f1038d8b9efe40$export$16fa2f45be04daa8;
var $31f1038d8b9efe40$export$ffb0004e005737fa;
var $31f1038d8b9efe40$export$e2c29f18771995cb;
var $31f1038d8b9efe40$export$221d75b3f55bb0bd;
var $31f1038d8b9efe40$export$5f8d39834fd61797;
var $31f1038d8b9efe40$export$74bf444e3cd11ea5;
var $31f1038d8b9efe40$export$ae55be85d98224ed;
var $31f1038d8b9efe40$export$3ba232387fd5d6dd;
var $31f1038d8b9efe40$export$e530037191fcd5d7;
var $31f1038d8b9efe40$export$fd42f52fd3ae1109;
var $31f1038d8b9efe40$export$c8a8987d4410bf2d;
var $31f1038d8b9efe40$export$d38cd72104c1f0e9;
var $31f1038d8b9efe40$export$7d1e3a5e95ceca43;
var $31f1038d8b9efe40$export$257a8862b851cb5b;
var $31f1038d8b9efe40$export$a8257692ac88316c;
var $31f1038d8b9efe40$export$488013bae63b21da;
var $31f1038d8b9efe40$export$7c73462e0d25e514;
var $31f1038d8b9efe40$export$7568632d0d33d16d;
var $31f1038d8b9efe40$export$88948ce120ea2619;
var $31f1038d8b9efe40$export$35808ee640e87ca7;
var $31f1038d8b9efe40$export$fae74005e78b1a27;
var $31f1038d8b9efe40$export$dc8fbce3eb94dc1e;
var $31f1038d8b9efe40$export$6a7bc4e911dc01cf;
var $31f1038d8b9efe40$export$6d9c69b0de29b591;
var $31f1038d8b9efe40$export$f680877a34711e37;
var $31f1038d8b9efe40$export$d5a552a76deda3c2;
var $31f1038d8b9efe40$export$aaabe4eda9ed9969;
var $31f1038d8b9efe40$export$e5c5a5f917a5871c;
var $31f1038d8b9efe40$export$1538c33de8887b59;
var $31f1038d8b9efe40$export$13e3392192263954;
var $31f1038d8b9efe40$export$b8f5890fc79d6aca;
var $31f1038d8b9efe40$export$60241385465d0a34;
var $31f1038d8b9efe40$export$306c0aa65ff9ec16;
var $31f1038d8b9efe40$export$7b286972b8d8ccbf;
var $31f1038d8b9efe40$export$83d89fbfd8236492;
"use strict";
var $31f1038d8b9efe40$var$l = Symbol.for("react.element"), $31f1038d8b9efe40$var$n = Symbol.for("react.portal"), $31f1038d8b9efe40$var$p = Symbol.for("react.fragment"), $31f1038d8b9efe40$var$q = Symbol.for("react.strict_mode"), $31f1038d8b9efe40$var$r = Symbol.for("react.profiler"), $31f1038d8b9efe40$var$t = Symbol.for("react.provider"), $31f1038d8b9efe40$var$u = Symbol.for("react.context"), $31f1038d8b9efe40$var$v = Symbol.for("react.forward_ref"), $31f1038d8b9efe40$var$w = Symbol.for("react.suspense"), $31f1038d8b9efe40$var$x = Symbol.for("react.memo"), $31f1038d8b9efe40$var$y = Symbol.for("react.lazy"), $31f1038d8b9efe40$var$z = Symbol.iterator;
function $31f1038d8b9efe40$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $31f1038d8b9efe40$var$z && a[$31f1038d8b9efe40$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $31f1038d8b9efe40$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $31f1038d8b9efe40$var$C = Object.assign, $31f1038d8b9efe40$var$D = {};
function $31f1038d8b9efe40$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $31f1038d8b9efe40$var$D;
    this.updater = e || $31f1038d8b9efe40$var$B;
}
$31f1038d8b9efe40$var$E.prototype.isReactComponent = {};
$31f1038d8b9efe40$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$31f1038d8b9efe40$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $31f1038d8b9efe40$var$F() {}
$31f1038d8b9efe40$var$F.prototype = $31f1038d8b9efe40$var$E.prototype;
function $31f1038d8b9efe40$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $31f1038d8b9efe40$var$D;
    this.updater = e || $31f1038d8b9efe40$var$B;
}
var $31f1038d8b9efe40$var$H = $31f1038d8b9efe40$var$G.prototype = new $31f1038d8b9efe40$var$F;
$31f1038d8b9efe40$var$H.constructor = $31f1038d8b9efe40$var$G;
$31f1038d8b9efe40$var$C($31f1038d8b9efe40$var$H, $31f1038d8b9efe40$var$E.prototype);
$31f1038d8b9efe40$var$H.isPureReactComponent = !0;
var $31f1038d8b9efe40$var$I = Array.isArray, $31f1038d8b9efe40$var$J = Object.prototype.hasOwnProperty, $31f1038d8b9efe40$var$K = {
    current: null
}, $31f1038d8b9efe40$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $31f1038d8b9efe40$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$31f1038d8b9efe40$var$J.call(b, d) && !$31f1038d8b9efe40$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $31f1038d8b9efe40$var$K.current
    };
}
function $31f1038d8b9efe40$var$N(a, b) {
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $31f1038d8b9efe40$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $31f1038d8b9efe40$var$l;
}
function $31f1038d8b9efe40$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $31f1038d8b9efe40$var$P = /\/+/g;
function $31f1038d8b9efe40$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $31f1038d8b9efe40$var$escape("" + a.key) : b.toString(36);
}
function $31f1038d8b9efe40$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $31f1038d8b9efe40$var$l:
                case $31f1038d8b9efe40$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $31f1038d8b9efe40$var$Q(h, 0) : d, $31f1038d8b9efe40$var$I(c) ? (e = "", null != a && (e = a.replace($31f1038d8b9efe40$var$P, "$&/") + "/"), $31f1038d8b9efe40$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($31f1038d8b9efe40$var$O(c) && (c = $31f1038d8b9efe40$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($31f1038d8b9efe40$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($31f1038d8b9efe40$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $31f1038d8b9efe40$var$Q(k, g);
        h += $31f1038d8b9efe40$var$R(k, b, e, f, c);
    }
    else if (f = $31f1038d8b9efe40$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $31f1038d8b9efe40$var$Q(k, g++), h += $31f1038d8b9efe40$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $31f1038d8b9efe40$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $31f1038d8b9efe40$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $31f1038d8b9efe40$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $31f1038d8b9efe40$var$U = {
    current: null
}, $31f1038d8b9efe40$var$V = {
    transition: null
}, $31f1038d8b9efe40$var$W = {
    ReactCurrentDispatcher: $31f1038d8b9efe40$var$U,
    ReactCurrentBatchConfig: $31f1038d8b9efe40$var$V,
    ReactCurrentOwner: $31f1038d8b9efe40$var$K
};
function $31f1038d8b9efe40$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$31f1038d8b9efe40$export$dca3b0875bd9a954 = {
    map: $31f1038d8b9efe40$var$S,
    forEach: function(a, b, e) {
        $31f1038d8b9efe40$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $31f1038d8b9efe40$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $31f1038d8b9efe40$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$31f1038d8b9efe40$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$31f1038d8b9efe40$export$16fa2f45be04daa8 = $31f1038d8b9efe40$var$E;
$31f1038d8b9efe40$export$ffb0004e005737fa = $31f1038d8b9efe40$var$p;
$31f1038d8b9efe40$export$e2c29f18771995cb = $31f1038d8b9efe40$var$r;
$31f1038d8b9efe40$export$221d75b3f55bb0bd = $31f1038d8b9efe40$var$G;
$31f1038d8b9efe40$export$5f8d39834fd61797 = $31f1038d8b9efe40$var$q;
$31f1038d8b9efe40$export$74bf444e3cd11ea5 = $31f1038d8b9efe40$var$w;
$31f1038d8b9efe40$export$ae55be85d98224ed = $31f1038d8b9efe40$var$W;
$31f1038d8b9efe40$export$3ba232387fd5d6dd = $31f1038d8b9efe40$var$X;
$31f1038d8b9efe40$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $31f1038d8b9efe40$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $31f1038d8b9efe40$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$31f1038d8b9efe40$var$J.call(b, f) && !$31f1038d8b9efe40$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$31f1038d8b9efe40$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $31f1038d8b9efe40$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $31f1038d8b9efe40$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$31f1038d8b9efe40$export$c8a8987d4410bf2d = $31f1038d8b9efe40$var$M;
$31f1038d8b9efe40$export$d38cd72104c1f0e9 = function(a) {
    var b = $31f1038d8b9efe40$var$M.bind(null, a);
    b.type = a;
    return b;
};
$31f1038d8b9efe40$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$31f1038d8b9efe40$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $31f1038d8b9efe40$var$v,
        render: a
    };
};
$31f1038d8b9efe40$export$a8257692ac88316c = $31f1038d8b9efe40$var$O;
$31f1038d8b9efe40$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $31f1038d8b9efe40$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $31f1038d8b9efe40$var$T
    };
};
$31f1038d8b9efe40$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $31f1038d8b9efe40$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$31f1038d8b9efe40$export$7568632d0d33d16d = function(a) {
    var b = $31f1038d8b9efe40$var$V.transition;
    $31f1038d8b9efe40$var$V.transition = {};
    try {
        a();
    } finally{
        $31f1038d8b9efe40$var$V.transition = b;
    }
};
$31f1038d8b9efe40$export$88948ce120ea2619 = $31f1038d8b9efe40$var$X;
$31f1038d8b9efe40$export$35808ee640e87ca7 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useCallback(a, b);
};
$31f1038d8b9efe40$export$fae74005e78b1a27 = function(a) {
    return $31f1038d8b9efe40$var$U.current.useContext(a);
};
$31f1038d8b9efe40$export$dc8fbce3eb94dc1e = function() {};
$31f1038d8b9efe40$export$6a7bc4e911dc01cf = function(a) {
    return $31f1038d8b9efe40$var$U.current.useDeferredValue(a);
};
$31f1038d8b9efe40$export$6d9c69b0de29b591 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useEffect(a, b);
};
$31f1038d8b9efe40$export$f680877a34711e37 = function() {
    return $31f1038d8b9efe40$var$U.current.useId();
};
$31f1038d8b9efe40$export$d5a552a76deda3c2 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useImperativeHandle(a, b, e);
};
$31f1038d8b9efe40$export$aaabe4eda9ed9969 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useInsertionEffect(a, b);
};
$31f1038d8b9efe40$export$e5c5a5f917a5871c = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useLayoutEffect(a, b);
};
$31f1038d8b9efe40$export$1538c33de8887b59 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useMemo(a, b);
};
$31f1038d8b9efe40$export$13e3392192263954 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useReducer(a, b, e);
};
$31f1038d8b9efe40$export$b8f5890fc79d6aca = function(a) {
    return $31f1038d8b9efe40$var$U.current.useRef(a);
};
$31f1038d8b9efe40$export$60241385465d0a34 = function(a) {
    return $31f1038d8b9efe40$var$U.current.useState(a);
};
$31f1038d8b9efe40$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useSyncExternalStore(a, b, e);
};
$31f1038d8b9efe40$export$7b286972b8d8ccbf = function() {
    return $31f1038d8b9efe40$var$U.current.useTransition();
};
$31f1038d8b9efe40$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("8kMfp", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $61159df79facf28e$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $61159df79facf28e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $61159df79facf28e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $61159df79facf28e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $61159df79facf28e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $61159df79facf28e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $61159df79facf28e$export$a9c23c6ac3fc3eca; });

var $eZVvM = parcelRequire("eZVvM");

var $hUOrI = parcelRequire("hUOrI");

var $65o8X = parcelRequire("65o8X");

var $c2U8l = parcelRequire("c2U8l");

var $bSAjr = parcelRequire("bSAjr");

var $geJaG = parcelRequire("geJaG");

var $2mRmw = parcelRequire("2mRmw");

var $8JgfY = parcelRequire("8JgfY");
var $61159df79facf28e$export$23f2a1d2818174ef = false;
/* import { type EmotionCache } from '@emotion/utils' */ var $61159df79facf28e$var$EmotionCacheContext = /* #__PURE__ */ $eZVvM.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $hUOrI.default)({
    key: "css"
}) : null);
var $61159df79facf28e$export$e7094788287c5e9b = $61159df79facf28e$var$EmotionCacheContext.Provider;
var $61159df79facf28e$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $eZVvM.useContext)($61159df79facf28e$var$EmotionCacheContext);
};
var $61159df79facf28e$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $eZVvM.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eZVvM.useContext)($61159df79facf28e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $61159df79facf28e$export$971d5caa766a69d7 = /* #__PURE__ */ $eZVvM.createContext({});
var $61159df79facf28e$export$3b14a55fb2447963 = function useTheme() {
    return $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
};
var $61159df79facf28e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $65o8X.default)({}, outerTheme, theme);
};
var $61159df79facf28e$var$createCacheWithTheme = /* #__PURE__ */ (0, $c2U8l.default)(function(outerTheme) {
    return (0, $c2U8l.default)(function(theme) {
        return $61159df79facf28e$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $61159df79facf28e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $61159df79facf28e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eZVvM.createElement($61159df79facf28e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $61159df79facf28e$export$8b22cf2602fb60ce(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eZVvM.createElement(Component, (0, $65o8X.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $eZVvM.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $bSAjr.default)(WithTheme, Component);
}
var $61159df79facf28e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $61159df79facf28e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $61159df79facf28e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($61159df79facf28e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$61159df79facf28e$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $61159df79facf28e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $geJaG.registerStyles)(cache, serialized, isStringTag);
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $geJaG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $61159df79facf28e$var$Emotion = /* #__PURE__ */ $61159df79facf28e$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$61159df79facf28e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $geJaG.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2mRmw.serializeStyles)(registeredStyles, undefined, $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($61159df79facf28e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $61159df79facf28e$var$typePropName && !$61159df79facf28e$export$23f2a1d2818174ef) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($61159df79facf28e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $eZVvM.createElement(WrappedComponent, newProps));
});
var $61159df79facf28e$export$a9c23c6ac3fc3eca = $61159df79facf28e$var$Emotion;

});
parcelRegister("hUOrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0aecc2f01744a2d$export$2e2bcd8739ae039; });

var $7Z4I8 = parcelRequire("7Z4I8");

var $kALlb = parcelRequire("kALlb");
var $fvohN = parcelRequire("fvohN");
var $iNPmF = parcelRequire("iNPmF");
var $lPlJK = parcelRequire("lPlJK");
var $dWdee = parcelRequire("dWdee");
var $lyqja = parcelRequire("lyqja");
parcelRequire("c2U8l");
parcelRequire("4vbT5");
var $d0aecc2f01744a2d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $kALlb.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $kALlb.token)(character)) break;
        (0, $kALlb.next)();
    }
    return (0, $kALlb.slice)(begin, (0, $kALlb.position));
};
var $d0aecc2f01744a2d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $kALlb.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $kALlb.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d0aecc2f01744a2d$var$identifierWithPointTracking((0, $kALlb.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $kALlb.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $kALlb.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fvohN.from)(character);
    }
    while (character = (0, $kALlb.next)());
    return parsed;
};
var $d0aecc2f01744a2d$var$getRules = function getRules(value, points) {
    return (0, $kALlb.dealloc)($d0aecc2f01744a2d$var$toRules((0, $kALlb.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d0aecc2f01744a2d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d0aecc2f01744a2d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d0aecc2f01744a2d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d0aecc2f01744a2d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d0aecc2f01744a2d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d0aecc2f01744a2d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $d0aecc2f01744a2d$var$prefix(value, length) {
    switch((0, $fvohN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lPlJK.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lPlJK.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MOZ) + value + (0, $lPlJK.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
        // order
        case 6165:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $lPlJK.WEBKIT) + value + (0, $fvohN.replace)(value, /(\w+).+(:[^]+)/, (0, $lPlJK.WEBKIT) + "box-$1$2" + (0, $lPlJK.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-item-" + (0, $fvohN.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-line-pack" + (0, $fvohN.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $lPlJK.WEBKIT) + "box-" + (0, $fvohN.replace)(value, "-grow", "") + (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $lPlJK.WEBKIT) + (0, $fvohN.replace)(value, /([^-])(transform)/g, "$1" + (0, $lPlJK.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fvohN.replace)((0, $fvohN.replace)((0, $fvohN.replace)(value, /(zoom-|grab)/, (0, $lPlJK.WEBKIT) + "$1"), /(image-set)/, (0, $lPlJK.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fvohN.replace)(value, /(image-set\([^]*)/, (0, $lPlJK.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fvohN.replace)((0, $fvohN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lPlJK.WEBKIT) + "box-pack:$3" + (0, $lPlJK.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $lPlJK.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fvohN.replace)(value, /(.+)-inline(.+)/, (0, $lPlJK.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fvohN.strlen)(value) - 1 - length > 6) switch((0, $fvohN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fvohN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fvohN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $lPlJK.WEBKIT) + "$2-$3" + "$1" + (0, $lPlJK.MOZ) + ((0, $fvohN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fvohN.indexof)(value, "stretch") ? $d0aecc2f01744a2d$var$prefix((0, $fvohN.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fvohN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fvohN.charat)(value, (0, $fvohN.strlen)(value) - 3 - (~(0, $fvohN.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fvohN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $lPlJK.WEBKIT) + ((0, $fvohN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $lPlJK.WEBKIT) + "$2$3" + "$1" + (0, $lPlJK.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fvohN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
    }
    return value;
}
var $d0aecc2f01744a2d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lPlJK.DECLARATION:
                element["return"] = $d0aecc2f01744a2d$var$prefix(element.value, element.length);
                break;
            case 0, $lPlJK.KEYFRAMES:
                return (0, $lyqja.serialize)([
                    (0, $kALlb.copy)(element, {
                        value: (0, $fvohN.replace)(element.value, "@", "@" + (0, $lPlJK.WEBKIT))
                    })
                ], callback);
            case 0, $lPlJK.RULESET:
                if (element.length) return (0, $fvohN.combine)(element.props, function(value) {
                    switch((0, $fvohN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(read-\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, (0, $lPlJK.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d0aecc2f01744a2d$var$defaultStylisPlugins = [
    $d0aecc2f01744a2d$var$prefixer
];
var $d0aecc2f01744a2d$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d0aecc2f01744a2d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" ");
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $d0aecc2f01744a2d$var$compat,
        $d0aecc2f01744a2d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $lyqja.stringify),
        (0, $dWdee.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $dWdee.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $lyqja.serialize)((0, $iNPmF.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7Z4I8.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7Z4I8", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $5d01e26819e97aad$export$9d753cd7ae895cce; });
var $5d01e26819e97aad$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $5d01e26819e97aad$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $5d01e26819e97aad$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $5d01e26819e97aad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$5d01e26819e97aad$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5d01e26819e97aad$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $5d01e26819e97aad$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("kALlb", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $efdbe4523f606a7a$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $efdbe4523f606a7a$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $efdbe4523f606a7a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $efdbe4523f606a7a$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $efdbe4523f606a7a$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $efdbe4523f606a7a$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $efdbe4523f606a7a$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $efdbe4523f606a7a$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $efdbe4523f606a7a$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $efdbe4523f606a7a$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $efdbe4523f606a7a$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $efdbe4523f606a7a$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $efdbe4523f606a7a$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $efdbe4523f606a7a$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $efdbe4523f606a7a$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $efdbe4523f606a7a$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $efdbe4523f606a7a$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $efdbe4523f606a7a$export$4254d4e2b3745c4c; });

var $fvohN = parcelRequire("fvohN");
var $efdbe4523f606a7a$export$53f1d5ea8de3d7c = 1;
var $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1;
var $efdbe4523f606a7a$export$f24224f1c91d8156 = 0;
var $efdbe4523f606a7a$export$5880b8b5730aff45 = 0;
var $efdbe4523f606a7a$export$c0306caf338ac095 = 0;
var $efdbe4523f606a7a$export$30a86d91af8ff6e6 = "";
function $efdbe4523f606a7a$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $efdbe4523f606a7a$export$53f1d5ea8de3d7c,
        column: $efdbe4523f606a7a$export$4e0c71f277ca26b3,
        length: length,
        return: ""
    };
}
function $efdbe4523f606a7a$export$784d13d8ee351f07(root, props) {
    return (0, $fvohN.assign)($efdbe4523f606a7a$export$35059013cd4a06db("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function $efdbe4523f606a7a$export$eba6f6f03b0a92e7() {
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$232faf9add678146() {
    $efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$5880b8b5730aff45 > 0 ? (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, --$efdbe4523f606a7a$export$5880b8b5730aff45) : 0;
    if ($efdbe4523f606a7a$export$4e0c71f277ca26b3--, $efdbe4523f606a7a$export$c0306caf338ac095 === 10) $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$53f1d5ea8de3d7c--;
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$48cfd1e771a65c4f() {
    $efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$5880b8b5730aff45 < $efdbe4523f606a7a$export$f24224f1c91d8156 ? (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, $efdbe4523f606a7a$export$5880b8b5730aff45++) : 0;
    if ($efdbe4523f606a7a$export$4e0c71f277ca26b3++, $efdbe4523f606a7a$export$c0306caf338ac095 === 10) $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$53f1d5ea8de3d7c++;
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$4d3fb11e950abb9e() {
    return (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, $efdbe4523f606a7a$export$5880b8b5730aff45);
}
function $efdbe4523f606a7a$export$e88cb2efb12ae807() {
    return $efdbe4523f606a7a$export$5880b8b5730aff45;
}
function $efdbe4523f606a7a$export$58adb3bec8346d0f(begin, end) {
    return (0, $fvohN.substr)($efdbe4523f606a7a$export$30a86d91af8ff6e6, begin, end);
}
function $efdbe4523f606a7a$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $efdbe4523f606a7a$export$2de70f21292aac9e(value) {
    return $efdbe4523f606a7a$export$53f1d5ea8de3d7c = $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$f24224f1c91d8156 = (0, $fvohN.strlen)($efdbe4523f606a7a$export$30a86d91af8ff6e6 = value), $efdbe4523f606a7a$export$5880b8b5730aff45 = 0, [];
}
function $efdbe4523f606a7a$export$45918ac1574455b1(value) {
    return $efdbe4523f606a7a$export$30a86d91af8ff6e6 = "", value;
}
function $efdbe4523f606a7a$export$410ac95b9ec204b8(type) {
    return (0, $fvohN.trim)($efdbe4523f606a7a$export$58adb3bec8346d0f($efdbe4523f606a7a$export$5880b8b5730aff45 - 1, $efdbe4523f606a7a$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $efdbe4523f606a7a$export$660b2ee2d4fb4eff(value) {
    return $efdbe4523f606a7a$export$45918ac1574455b1($efdbe4523f606a7a$export$5f8c09e3ae6f64e1($efdbe4523f606a7a$export$2de70f21292aac9e(value)));
}
function $efdbe4523f606a7a$export$7af1228ff777d175(type) {
    while($efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$4d3fb11e950abb9e())if ($efdbe4523f606a7a$export$c0306caf338ac095 < 33) $efdbe4523f606a7a$export$48cfd1e771a65c4f();
    else break;
    return $efdbe4523f606a7a$export$9e1725a4cfeada27(type) > 2 || $efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $efdbe4523f606a7a$export$5f8c09e3ae6f64e1(children) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())switch($efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$c0306caf338ac095)){
        case 0:
            (0, $fvohN.append)($efdbe4523f606a7a$export$c2ab62c7bf24634($efdbe4523f606a7a$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $fvohN.append)($efdbe4523f606a7a$export$410ac95b9ec204b8($efdbe4523f606a7a$export$c0306caf338ac095), children);
            break;
        default:
            (0, $fvohN.append)((0, $fvohN.from)($efdbe4523f606a7a$export$c0306caf338ac095), children);
    }
    return children;
}
function $efdbe4523f606a7a$export$955ba06d119e085e(index, count) {
    while(--count && $efdbe4523f606a7a$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($efdbe4523f606a7a$export$c0306caf338ac095 < 48 || $efdbe4523f606a7a$export$c0306caf338ac095 > 102 || $efdbe4523f606a7a$export$c0306caf338ac095 > 57 && $efdbe4523f606a7a$export$c0306caf338ac095 < 65 || $efdbe4523f606a7a$export$c0306caf338ac095 > 70 && $efdbe4523f606a7a$export$c0306caf338ac095 < 97) break;
    return $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$e88cb2efb12ae807() + (count < 6 && $efdbe4523f606a7a$export$4d3fb11e950abb9e() == 32 && $efdbe4523f606a7a$export$48cfd1e771a65c4f() == 32));
}
function $efdbe4523f606a7a$export$c889f2fcc19dbf12(type) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())switch($efdbe4523f606a7a$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $efdbe4523f606a7a$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $efdbe4523f606a7a$export$c889f2fcc19dbf12($efdbe4523f606a7a$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $efdbe4523f606a7a$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $efdbe4523f606a7a$export$48cfd1e771a65c4f();
            break;
    }
    return $efdbe4523f606a7a$export$5880b8b5730aff45;
}
function $efdbe4523f606a7a$export$4254d4e2b3745c4c(type, index) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())// //
    if (type + $efdbe4523f606a7a$export$c0306caf338ac095 === 57) break;
    else if (type + $efdbe4523f606a7a$export$c0306caf338ac095 === 84 && $efdbe4523f606a7a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$5880b8b5730aff45 - 1) + "*" + (0, $fvohN.from)(type === 47 ? type : $efdbe4523f606a7a$export$48cfd1e771a65c4f());
}
function $efdbe4523f606a7a$export$c2ab62c7bf24634(index) {
    while(!$efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$4d3fb11e950abb9e()))$efdbe4523f606a7a$export$48cfd1e771a65c4f();
    return $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$5880b8b5730aff45);
}

});
parcelRegister("fvohN", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $b49c96fd4bfe2527$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $b49c96fd4bfe2527$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $b49c96fd4bfe2527$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $b49c96fd4bfe2527$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $b49c96fd4bfe2527$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $b49c96fd4bfe2527$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $b49c96fd4bfe2527$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $b49c96fd4bfe2527$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $b49c96fd4bfe2527$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $b49c96fd4bfe2527$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $b49c96fd4bfe2527$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $b49c96fd4bfe2527$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $b49c96fd4bfe2527$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $b49c96fd4bfe2527$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $b49c96fd4bfe2527$export$2335f513bbd82c6d = Math.abs;
var $b49c96fd4bfe2527$export$6788812c4e6611e6 = String.fromCharCode;
var $b49c96fd4bfe2527$export$e6e34fd1f2686227 = Object.assign;
function $b49c96fd4bfe2527$export$d6af199866bfb566(value, length) {
    return $b49c96fd4bfe2527$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 0)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 1)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 2)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 3) : 0;
}
function $b49c96fd4bfe2527$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $b49c96fd4bfe2527$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $b49c96fd4bfe2527$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $b49c96fd4bfe2527$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $b49c96fd4bfe2527$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $b49c96fd4bfe2527$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $b49c96fd4bfe2527$export$36776f635604f274(value) {
    return value.length;
}
function $b49c96fd4bfe2527$export$f9084667e487ed46(value) {
    return value.length;
}
function $b49c96fd4bfe2527$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $b49c96fd4bfe2527$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}

});


parcelRegister("iNPmF", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $db04a589ffd10751$export$ef7acd7185315e22; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");

var $kALlb = parcelRequire("kALlb");
function $db04a589ffd10751$export$ef7acd7185315e22(value) {
    return (0, $kALlb.dealloc)($db04a589ffd10751$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $kALlb.alloc)(value), 0, [
        0
    ], value));
}
function $db04a589ffd10751$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $kALlb.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $fvohN.charat)(characters, length - 1) == 58) {
                if ((0, $fvohN.indexof)(characters += (0, $fvohN.replace)((0, $kALlb.delimit)(character), "&", "&\f"), "&\f") != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $kALlb.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $kALlb.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $kALlb.escaping)((0, $kALlb.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $kALlb.peek)()){
                case 42:
                case 47:
                    (0, $fvohN.append)($db04a589ffd10751$export$4a34f930e789283c((0, $kALlb.commenter)((0, $kALlb.next)(), (0, $kALlb.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $fvohN.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $fvohN.replace)(characters, /\f/g, "");
                    if (property > 0 && (0, $fvohN.strlen)(characters) - length) (0, $fvohN.append)(property > 32 ? $db04a589ffd10751$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1) : $db04a589ffd10751$export$f8483753829ec8f3((0, $fvohN.replace)(characters, " ", "") + ";", rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $fvohN.append)(reference = $db04a589ffd10751$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $db04a589ffd10751$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $fvohN.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $db04a589ffd10751$export$98e6a39c04603d36(value, reference, reference, rule && (0, $fvohN.append)($db04a589ffd10751$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $db04a589ffd10751$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $fvohN.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $kALlb.prev)() == 125) continue;
            }
            switch(characters += (0, $fvohN.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $fvohN.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $kALlb.peek)() === 45) characters += (0, $kALlb.delimit)((0, $kALlb.next)());
                    atrule = (0, $kALlb.peek)(), offset = length = (0, $fvohN.strlen)(type = characters += (0, $kALlb.identifier)((0, $kALlb.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $fvohN.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $db04a589ffd10751$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $fvohN.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $fvohN.substr)(value, post + 1, post = (0, $fvohN.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $fvohN.trim)(j > 0 ? rule[x] + " " + y : (0, $fvohN.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $kALlb.node)(value, root, parent, offset === 0 ? (0, $lPlJK.RULESET) : type, props, children, length);
}
function $db04a589ffd10751$export$4a34f930e789283c(value, root, parent) {
    return (0, $kALlb.node)(value, root, parent, (0, $lPlJK.COMMENT), (0, $fvohN.from)((0, $kALlb.char)()), (0, $fvohN.substr)(value, 2, -2), 0);
}
function $db04a589ffd10751$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $kALlb.node)(value, root, parent, (0, $lPlJK.DECLARATION), (0, $fvohN.substr)(value, 0, length), (0, $fvohN.substr)(value, length + 1, -1), length);
}

});
parcelRegister("lPlJK", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $fe3f38e75c5de6c7$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $fe3f38e75c5de6c7$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $fe3f38e75c5de6c7$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $fe3f38e75c5de6c7$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $fe3f38e75c5de6c7$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $fe3f38e75c5de6c7$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $fe3f38e75c5de6c7$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $fe3f38e75c5de6c7$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $fe3f38e75c5de6c7$export$d773506282b3cfe6; });
var $fe3f38e75c5de6c7$export$71ad59f2e432cfe8 = "-ms-";
var $fe3f38e75c5de6c7$export$2c0f367103c8d01c = "-moz-";
var $fe3f38e75c5de6c7$export$39dfd62a25e0fe93 = "-webkit-";
var $fe3f38e75c5de6c7$export$a29989082612d0d9 = "comm";
var $fe3f38e75c5de6c7$export$aa3a2e812ca8570d = "rule";
var $fe3f38e75c5de6c7$export$527d108ccf083c2b = "decl";
var $fe3f38e75c5de6c7$export$d3d35020fa5b54f0 = "@page";
var $fe3f38e75c5de6c7$export$500415a86c544f73 = "@media";
var $fe3f38e75c5de6c7$export$a763edbf796b780a = "@import";
var $fe3f38e75c5de6c7$export$2790aeb8b4e5c826 = "@charset";
var $fe3f38e75c5de6c7$export$1cc683e23b84b133 = "@viewport";
var $fe3f38e75c5de6c7$export$9447a5efea57e862 = "@supports";
var $fe3f38e75c5de6c7$export$ef011b4e114b1fba = "@document";
var $fe3f38e75c5de6c7$export$6aad947bda0f3f46 = "@namespace";
var $fe3f38e75c5de6c7$export$b44a8529a35fcb60 = "@keyframes";
var $fe3f38e75c5de6c7$export$2c16de31893252e6 = "@font-face";
var $fe3f38e75c5de6c7$export$3d846dd52e150c6f = "@counter-style";
var $fe3f38e75c5de6c7$export$22314bfbb57653fe = "@font-feature-values";
var $fe3f38e75c5de6c7$export$d773506282b3cfe6 = "@layer";

});


parcelRegister("dWdee", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $a25af40beae40c51$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $a25af40beae40c51$export$38bcb760f1d4871c; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");

var $kALlb = parcelRequire("kALlb");

var $lyqja = parcelRequire("lyqja");

var $j9jEI = parcelRequire("j9jEI");
function $a25af40beae40c51$export$5a7767152ae0305f(collection) {
    var length = (0, $fvohN.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $a25af40beae40c51$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $a25af40beae40c51$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $lPlJK.DECLARATION:
                element.return = (0, $j9jEI.prefix)(element.value, element.length, children);
                return;
            case 0, $lPlJK.KEYFRAMES:
                return (0, $lyqja.serialize)([
                    (0, $kALlb.copy)(element, {
                        value: (0, $fvohN.replace)(element.value, "@", "@" + (0, $lPlJK.WEBKIT))
                    })
                ], callback);
            case 0, $lPlJK.RULESET:
                if (element.length) return (0, $fvohN.combine)(element.props, function(value) {
                    switch((0, $fvohN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(read-\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, (0, $lPlJK.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
}
function $a25af40beae40c51$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $lPlJK.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $fvohN.combine)((0, $kALlb.tokenize)(value), function(value, index, children) {
                    switch((0, $fvohN.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $fvohN.substr)(value, 1, (0, $fvohN.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $fvohN.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $fvohN.sizeof)(children) > 1 ? "" : value;
                                case index = (0, $fvohN.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("lyqja", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $fb112e37b38a47f3$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $fb112e37b38a47f3$export$fac44ee5b035f737; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");
function $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    var length = (0, $fvohN.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $fb112e37b38a47f3$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $lPlJK.LAYER:
            if (element.children.length) break;
        case 0, $lPlJK.IMPORT:
        case 0, $lPlJK.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $lPlJK.COMMENT:
            return "";
        case 0, $lPlJK.KEYFRAMES:
            return element.return = element.value + "{" + $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $lPlJK.RULESET:
            element.value = element.props.join(",");
    }
    return (0, $fvohN.strlen)(children = $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

});

parcelRegister("j9jEI", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $df0e1ac8cf3763b0$export$82e9f45cca5ba907; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");
function $df0e1ac8cf3763b0$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $fvohN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lPlJK.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lPlJK.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $lPlJK.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MOZ) + value + (0, $lPlJK.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $fvohN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
        // order
        case 6165:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $lPlJK.WEBKIT) + value + (0, $fvohN.replace)(value, /(\w+).+(:[^]+)/, (0, $lPlJK.WEBKIT) + "box-$1$2" + (0, $lPlJK.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-item-" + (0, $fvohN.replace)(value, /flex-|-self/g, "") + (!(0, $fvohN.match)(value, /flex-|baseline/) ? (0, $lPlJK.MS) + "grid-row-" + (0, $fvohN.replace)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-line-pack" + (0, $fvohN.replace)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $lPlJK.WEBKIT) + "box-" + (0, $fvohN.replace)(value, "-grow", "") + (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $lPlJK.WEBKIT) + (0, $fvohN.replace)(value, /([^-])(transform)/g, "$1" + (0, $lPlJK.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fvohN.replace)((0, $fvohN.replace)((0, $fvohN.replace)(value, /(zoom-|grab)/, (0, $lPlJK.WEBKIT) + "$1"), /(image-set)/, (0, $lPlJK.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fvohN.replace)(value, /(image-set\([^]*)/, (0, $lPlJK.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fvohN.replace)((0, $fvohN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lPlJK.WEBKIT) + "box-pack:$3" + (0, $lPlJK.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $lPlJK.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $fvohN.match)(value, /flex-|baseline/)) return (0, $lPlJK.MS) + "grid-column-align" + (0, $fvohN.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $fvohN.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $fvohN.indexof)(value + (children = children[length].value), "span") ? value : (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "-start", "") + value + (0, $lPlJK.MS) + "grid-row-span:" + (~(0, $fvohN.indexof)(children, "span") ? (0, $fvohN.match)(children, /\d+/) : +(0, $fvohN.match)(children, /\d+/) - +(0, $fvohN.match)(value, /\d+/)) + ";";
            return (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $fvohN.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $lPlJK.MS) + (0, $fvohN.replace)((0, $fvohN.replace)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fvohN.replace)(value, /(.+)-inline(.+)/, (0, $lPlJK.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fvohN.strlen)(value) - 1 - length > 6) switch((0, $fvohN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fvohN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fvohN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $lPlJK.WEBKIT) + "$2-$3" + "$1" + (0, $lPlJK.MOZ) + ((0, $fvohN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fvohN.indexof)(value, "stretch") ? $df0e1ac8cf3763b0$export$82e9f45cca5ba907((0, $fvohN.replace)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $fvohN.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $lPlJK.MS) + a + ":" + b + f + (c ? (0, $lPlJK.MS) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $fvohN.charat)(value, length + 6) === 121) return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $fvohN.charat)(value, (0, $fvohN.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $fvohN.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $lPlJK.WEBKIT) + ((0, $fvohN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $lPlJK.WEBKIT) + "$2$3" + "$1" + (0, $lPlJK.MS) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $fvohN.replace)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}

});


parcelRegister("c2U8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c5136e092954a76$export$2e2bcd8739ae039; });
var $8c5136e092954a76$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4vbT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3473474772d4527d$export$2e2bcd8739ae039; });
function $3473474772d4527d$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("65o8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46e5f016cb65863b$export$2e2bcd8739ae039; });
function $46e5f016cb65863b$export$2e2bcd8739ae039() {
    return $46e5f016cb65863b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $46e5f016cb65863b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("bSAjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a60e7caca6e701b$export$2e2bcd8739ae039; });

var $28Dco = parcelRequire("28Dco");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $8a60e7caca6e701b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($28Dco)))(targetComponent, sourceComponent);
};

});
parcelRegister("28Dco", function(module, exports) {
"use strict";

var $kqafl = parcelRequire("kqafl");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $18eabc32537a5bde$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $18eabc32537a5bde$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $18eabc32537a5bde$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $18eabc32537a5bde$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $18eabc32537a5bde$var$TYPE_STATICS = {};
$18eabc32537a5bde$var$TYPE_STATICS[$kqafl.ForwardRef] = $18eabc32537a5bde$var$FORWARD_REF_STATICS;
$18eabc32537a5bde$var$TYPE_STATICS[$kqafl.Memo] = $18eabc32537a5bde$var$MEMO_STATICS;
function $18eabc32537a5bde$var$getStatics(component) {
    // React v16.11 and below
    if ($kqafl.isMemo(component)) return $18eabc32537a5bde$var$MEMO_STATICS;
     // React v16.12 and above
    return $18eabc32537a5bde$var$TYPE_STATICS[component["$$typeof"]] || $18eabc32537a5bde$var$REACT_STATICS;
}
var $18eabc32537a5bde$var$defineProperty = Object.defineProperty;
var $18eabc32537a5bde$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $18eabc32537a5bde$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $18eabc32537a5bde$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $18eabc32537a5bde$var$getPrototypeOf = Object.getPrototypeOf;
var $18eabc32537a5bde$var$objectPrototype = Object.prototype;
function $18eabc32537a5bde$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($18eabc32537a5bde$var$objectPrototype) {
            var inheritedComponent = $18eabc32537a5bde$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $18eabc32537a5bde$var$objectPrototype) $18eabc32537a5bde$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $18eabc32537a5bde$var$getOwnPropertyNames(sourceComponent);
        if ($18eabc32537a5bde$var$getOwnPropertySymbols) keys = keys.concat($18eabc32537a5bde$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $18eabc32537a5bde$var$getStatics(targetComponent);
        var sourceStatics = $18eabc32537a5bde$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$18eabc32537a5bde$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $18eabc32537a5bde$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $18eabc32537a5bde$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $18eabc32537a5bde$var$hoistNonReactStatics;

});
parcelRegister("kqafl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("f9CY9"));

});
parcelRegister("f9CY9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b085ecc2efba6e3a$export$2b8d127b894957b9; }, function (v) { return $b085ecc2efba6e3a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b085ecc2efba6e3a$export$cea3a54a6425200c; }, function (v) { return $b085ecc2efba6e3a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b085ecc2efba6e3a$export$a7c73072b1a182ae; }, function (v) { return $b085ecc2efba6e3a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b085ecc2efba6e3a$export$9f27bc3417b4524d; }, function (v) { return $b085ecc2efba6e3a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b085ecc2efba6e3a$export$db77ccec0bb4ccac; }, function (v) { return $b085ecc2efba6e3a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b085ecc2efba6e3a$export$8392c0c9d3dcbd35; }, function (v) { return $b085ecc2efba6e3a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b085ecc2efba6e3a$export$ffb0004e005737fa; }, function (v) { return $b085ecc2efba6e3a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b085ecc2efba6e3a$export$b624eff549462981; }, function (v) { return $b085ecc2efba6e3a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b085ecc2efba6e3a$export$7897aa7841a5380c; }, function (v) { return $b085ecc2efba6e3a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b085ecc2efba6e3a$export$602eac185826482c; }, function (v) { return $b085ecc2efba6e3a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b085ecc2efba6e3a$export$e2c29f18771995cb; }, function (v) { return $b085ecc2efba6e3a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b085ecc2efba6e3a$export$5f8d39834fd61797; }, function (v) { return $b085ecc2efba6e3a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b085ecc2efba6e3a$export$74bf444e3cd11ea5; }, function (v) { return $b085ecc2efba6e3a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b085ecc2efba6e3a$export$92387174baf9b227; }, function (v) { return $b085ecc2efba6e3a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b085ecc2efba6e3a$export$ec112efeb987d9c6; }, function (v) { return $b085ecc2efba6e3a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b085ecc2efba6e3a$export$b706b080d889d2c9; }, function (v) { return $b085ecc2efba6e3a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b085ecc2efba6e3a$export$5be5a87408f70ddc; }, function (v) { return $b085ecc2efba6e3a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b085ecc2efba6e3a$export$45a5e7f76e0caa8d; }, function (v) { return $b085ecc2efba6e3a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b085ecc2efba6e3a$export$455c2e768291efa6; }, function (v) { return $b085ecc2efba6e3a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b085ecc2efba6e3a$export$9522e17588c12572; }, function (v) { return $b085ecc2efba6e3a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b085ecc2efba6e3a$export$2110ac352bb060b9; }, function (v) { return $b085ecc2efba6e3a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b085ecc2efba6e3a$export$56885ab8b9c456ab; }, function (v) { return $b085ecc2efba6e3a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b085ecc2efba6e3a$export$d927fcb6adf8f9de; }, function (v) { return $b085ecc2efba6e3a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b085ecc2efba6e3a$export$b82d16f27459e05a; }, function (v) { return $b085ecc2efba6e3a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b085ecc2efba6e3a$export$522c17b4f5e123e8; }, function (v) { return $b085ecc2efba6e3a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b085ecc2efba6e3a$export$1aabd8a0274ecfd6; }, function (v) { return $b085ecc2efba6e3a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b085ecc2efba6e3a$export$9b621391a187a31a; }, function (v) { return $b085ecc2efba6e3a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b085ecc2efba6e3a$export$f5bbd400c2f4426f; }, function (v) { return $b085ecc2efba6e3a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b085ecc2efba6e3a$export$2b8d127b894957b9;
var $b085ecc2efba6e3a$export$cea3a54a6425200c;
var $b085ecc2efba6e3a$export$a7c73072b1a182ae;
var $b085ecc2efba6e3a$export$9f27bc3417b4524d;
var $b085ecc2efba6e3a$export$db77ccec0bb4ccac;
var $b085ecc2efba6e3a$export$8392c0c9d3dcbd35;
var $b085ecc2efba6e3a$export$ffb0004e005737fa;
var $b085ecc2efba6e3a$export$b624eff549462981;
var $b085ecc2efba6e3a$export$7897aa7841a5380c;
var $b085ecc2efba6e3a$export$602eac185826482c;
var $b085ecc2efba6e3a$export$e2c29f18771995cb;
var $b085ecc2efba6e3a$export$5f8d39834fd61797;
var $b085ecc2efba6e3a$export$74bf444e3cd11ea5;
var $b085ecc2efba6e3a$export$92387174baf9b227;
var $b085ecc2efba6e3a$export$ec112efeb987d9c6;
var $b085ecc2efba6e3a$export$b706b080d889d2c9;
var $b085ecc2efba6e3a$export$5be5a87408f70ddc;
var $b085ecc2efba6e3a$export$45a5e7f76e0caa8d;
var $b085ecc2efba6e3a$export$455c2e768291efa6;
var $b085ecc2efba6e3a$export$9522e17588c12572;
var $b085ecc2efba6e3a$export$2110ac352bb060b9;
var $b085ecc2efba6e3a$export$56885ab8b9c456ab;
var $b085ecc2efba6e3a$export$d927fcb6adf8f9de;
var $b085ecc2efba6e3a$export$b82d16f27459e05a;
var $b085ecc2efba6e3a$export$522c17b4f5e123e8;
var $b085ecc2efba6e3a$export$1aabd8a0274ecfd6;
var $b085ecc2efba6e3a$export$9b621391a187a31a;
var $b085ecc2efba6e3a$export$f5bbd400c2f4426f;
"use strict";
var $b085ecc2efba6e3a$var$b = "function" === typeof Symbol && Symbol.for, $b085ecc2efba6e3a$var$c = $b085ecc2efba6e3a$var$b ? Symbol.for("react.element") : 60103, $b085ecc2efba6e3a$var$d = $b085ecc2efba6e3a$var$b ? Symbol.for("react.portal") : 60106, $b085ecc2efba6e3a$var$e = $b085ecc2efba6e3a$var$b ? Symbol.for("react.fragment") : 60107, $b085ecc2efba6e3a$var$f = $b085ecc2efba6e3a$var$b ? Symbol.for("react.strict_mode") : 60108, $b085ecc2efba6e3a$var$g = $b085ecc2efba6e3a$var$b ? Symbol.for("react.profiler") : 60114, $b085ecc2efba6e3a$var$h = $b085ecc2efba6e3a$var$b ? Symbol.for("react.provider") : 60109, $b085ecc2efba6e3a$var$k = $b085ecc2efba6e3a$var$b ? Symbol.for("react.context") : 60110, $b085ecc2efba6e3a$var$l = $b085ecc2efba6e3a$var$b ? Symbol.for("react.async_mode") : 60111, $b085ecc2efba6e3a$var$m = $b085ecc2efba6e3a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b085ecc2efba6e3a$var$n = $b085ecc2efba6e3a$var$b ? Symbol.for("react.forward_ref") : 60112, $b085ecc2efba6e3a$var$p = $b085ecc2efba6e3a$var$b ? Symbol.for("react.suspense") : 60113, $b085ecc2efba6e3a$var$q = $b085ecc2efba6e3a$var$b ? Symbol.for("react.suspense_list") : 60120, $b085ecc2efba6e3a$var$r = $b085ecc2efba6e3a$var$b ? Symbol.for("react.memo") : 60115, $b085ecc2efba6e3a$var$t = $b085ecc2efba6e3a$var$b ? Symbol.for("react.lazy") : 60116, $b085ecc2efba6e3a$var$v = $b085ecc2efba6e3a$var$b ? Symbol.for("react.block") : 60121, $b085ecc2efba6e3a$var$w = $b085ecc2efba6e3a$var$b ? Symbol.for("react.fundamental") : 60117, $b085ecc2efba6e3a$var$x = $b085ecc2efba6e3a$var$b ? Symbol.for("react.responder") : 60118, $b085ecc2efba6e3a$var$y = $b085ecc2efba6e3a$var$b ? Symbol.for("react.scope") : 60119;
function $b085ecc2efba6e3a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b085ecc2efba6e3a$var$c:
                switch(a = a.type, a){
                    case $b085ecc2efba6e3a$var$l:
                    case $b085ecc2efba6e3a$var$m:
                    case $b085ecc2efba6e3a$var$e:
                    case $b085ecc2efba6e3a$var$g:
                    case $b085ecc2efba6e3a$var$f:
                    case $b085ecc2efba6e3a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b085ecc2efba6e3a$var$k:
                            case $b085ecc2efba6e3a$var$n:
                            case $b085ecc2efba6e3a$var$t:
                            case $b085ecc2efba6e3a$var$r:
                            case $b085ecc2efba6e3a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b085ecc2efba6e3a$var$d:
                return u;
        }
    }
}
function $b085ecc2efba6e3a$var$A(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$m;
}
$b085ecc2efba6e3a$export$2b8d127b894957b9 = $b085ecc2efba6e3a$var$l;
$b085ecc2efba6e3a$export$cea3a54a6425200c = $b085ecc2efba6e3a$var$m;
$b085ecc2efba6e3a$export$a7c73072b1a182ae = $b085ecc2efba6e3a$var$k;
$b085ecc2efba6e3a$export$9f27bc3417b4524d = $b085ecc2efba6e3a$var$h;
$b085ecc2efba6e3a$export$db77ccec0bb4ccac = $b085ecc2efba6e3a$var$c;
$b085ecc2efba6e3a$export$8392c0c9d3dcbd35 = $b085ecc2efba6e3a$var$n;
$b085ecc2efba6e3a$export$ffb0004e005737fa = $b085ecc2efba6e3a$var$e;
$b085ecc2efba6e3a$export$b624eff549462981 = $b085ecc2efba6e3a$var$t;
$b085ecc2efba6e3a$export$7897aa7841a5380c = $b085ecc2efba6e3a$var$r;
$b085ecc2efba6e3a$export$602eac185826482c = $b085ecc2efba6e3a$var$d;
$b085ecc2efba6e3a$export$e2c29f18771995cb = $b085ecc2efba6e3a$var$g;
$b085ecc2efba6e3a$export$5f8d39834fd61797 = $b085ecc2efba6e3a$var$f;
$b085ecc2efba6e3a$export$74bf444e3cd11ea5 = $b085ecc2efba6e3a$var$p;
$b085ecc2efba6e3a$export$92387174baf9b227 = function(a) {
    return $b085ecc2efba6e3a$var$A(a) || $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$l;
};
$b085ecc2efba6e3a$export$ec112efeb987d9c6 = $b085ecc2efba6e3a$var$A;
$b085ecc2efba6e3a$export$b706b080d889d2c9 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$k;
};
$b085ecc2efba6e3a$export$5be5a87408f70ddc = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$h;
};
$b085ecc2efba6e3a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b085ecc2efba6e3a$var$c;
};
$b085ecc2efba6e3a$export$455c2e768291efa6 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$n;
};
$b085ecc2efba6e3a$export$9522e17588c12572 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$e;
};
$b085ecc2efba6e3a$export$2110ac352bb060b9 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$t;
};
$b085ecc2efba6e3a$export$56885ab8b9c456ab = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$r;
};
$b085ecc2efba6e3a$export$d927fcb6adf8f9de = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$d;
};
$b085ecc2efba6e3a$export$b82d16f27459e05a = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$g;
};
$b085ecc2efba6e3a$export$522c17b4f5e123e8 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$f;
};
$b085ecc2efba6e3a$export$1aabd8a0274ecfd6 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$p;
};
$b085ecc2efba6e3a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b085ecc2efba6e3a$var$e || a === $b085ecc2efba6e3a$var$m || a === $b085ecc2efba6e3a$var$g || a === $b085ecc2efba6e3a$var$f || a === $b085ecc2efba6e3a$var$p || a === $b085ecc2efba6e3a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b085ecc2efba6e3a$var$t || a.$$typeof === $b085ecc2efba6e3a$var$r || a.$$typeof === $b085ecc2efba6e3a$var$h || a.$$typeof === $b085ecc2efba6e3a$var$k || a.$$typeof === $b085ecc2efba6e3a$var$n || a.$$typeof === $b085ecc2efba6e3a$var$w || a.$$typeof === $b085ecc2efba6e3a$var$x || a.$$typeof === $b085ecc2efba6e3a$var$y || a.$$typeof === $b085ecc2efba6e3a$var$v);
};
$b085ecc2efba6e3a$export$f5bbd400c2f4426f = $b085ecc2efba6e3a$var$z;

});




parcelRegister("geJaG", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $bd20fe35b785fff3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $bd20fe35b785fff3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $bd20fe35b785fff3$export$6f077d94b33a01aa; });
var $bd20fe35b785fff3$var$isBrowser = true;
function $bd20fe35b785fff3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $bd20fe35b785fff3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bd20fe35b785fff3$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $bd20fe35b785fff3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $bd20fe35b785fff3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("2mRmw", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $1b97077e6288ffb1$export$6321afa313b251b5; });

var $ilnGl = parcelRequire("ilnGl");

var $8sqzb = parcelRequire("8sqzb");

var $4vbT5 = parcelRequire("4vbT5");
var $1b97077e6288ffb1$var$isDevelopment = false;
var $1b97077e6288ffb1$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1b97077e6288ffb1$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1b97077e6288ffb1$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1b97077e6288ffb1$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $1b97077e6288ffb1$var$processStyleName = /* #__PURE__ */ (0, $4vbT5.default)(function(styleName) {
    return $1b97077e6288ffb1$var$isCustomProperty(styleName) ? styleName : styleName.replace($1b97077e6288ffb1$var$hyphenateRegex, "-$&").toLowerCase();
});
var $1b97077e6288ffb1$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($1b97077e6288ffb1$var$animationRegex, function(match, p1, p2) {
                $1b97077e6288ffb1$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1b97077e6288ffb1$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8sqzb.default)[key] !== 1 && !$1b97077e6288ffb1$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $1b97077e6288ffb1$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $1b97077e6288ffb1$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $1b97077e6288ffb1$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1b97077e6288ffb1$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1b97077e6288ffb1$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $1b97077e6288ffb1$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $1b97077e6288ffb1$var$cursor;
                var result = interpolation(mergedProps);
                $1b97077e6288ffb1$var$cursor = previousCursor;
                return $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $1b97077e6288ffb1$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($1b97077e6288ffb1$var$isProcessableValue(asString)) string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + $1b97077e6288ffb1$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $1b97077e6288ffb1$var$isDevelopment) throw new Error($1b97077e6288ffb1$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($1b97077e6288ffb1$var$isProcessableValue(value[_i])) string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + $1b97077e6288ffb1$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $1b97077e6288ffb1$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $1b97077e6288ffb1$var$cursor;
function $1b97077e6288ffb1$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $1b97077e6288ffb1$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $1b97077e6288ffb1$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1b97077e6288ffb1$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $ilnGl.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $1b97077e6288ffb1$var$cursor
    };
}

});
parcelRegister("ilnGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ac8ee7b734a93a$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d5ac8ee7b734a93a$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("8sqzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62858bd1b394830f$export$2e2bcd8739ae039; });
var $62858bd1b394830f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("8JgfY", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $65af22ef74f8f817$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $65af22ef74f8f817$export$811a713a7276cb9d; });

var $eZVvM = parcelRequire("eZVvM");
var $65af22ef74f8f817$var$syncFallback = function syncFallback(create) {
    return create();
};
var $65af22ef74f8f817$var$useInsertionEffect = $eZVvM.useInsertionEffect ? $eZVvM.useInsertionEffect : false;
var $65af22ef74f8f817$export$db21c7ffa21794e7 = $65af22ef74f8f817$var$useInsertionEffect || $65af22ef74f8f817$var$syncFallback;
var $65af22ef74f8f817$export$811a713a7276cb9d = $65af22ef74f8f817$var$useInsertionEffect || $eZVvM.useLayoutEffect;

});



parcelRegister("59jpj", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3bfcd8e655c52d03$export$ae55be85d98224ed; }, function (v) { return $3bfcd8e655c52d03$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3bfcd8e655c52d03$export$d39a5bbd09211389; }, function (v) { return $3bfcd8e655c52d03$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3bfcd8e655c52d03$export$882461b6382ed46c; }, function (v) { return $3bfcd8e655c52d03$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3bfcd8e655c52d03$export$466bfc07425424d5; }, function (v) { return $3bfcd8e655c52d03$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3bfcd8e655c52d03$export$cd75ccfd720a3cd4; }, function (v) { return $3bfcd8e655c52d03$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3bfcd8e655c52d03$export$fa8d919ba61d84db; }, function (v) { return $3bfcd8e655c52d03$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3bfcd8e655c52d03$export$757ceba2d55c277e; }, function (v) { return $3bfcd8e655c52d03$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3bfcd8e655c52d03$export$b3890eb0ae9dca99; }, function (v) { return $3bfcd8e655c52d03$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3bfcd8e655c52d03$export$502457920280e6be; }, function (v) { return $3bfcd8e655c52d03$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3bfcd8e655c52d03$export$c78a37762a8d58e1; }, function (v) { return $3bfcd8e655c52d03$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3bfcd8e655c52d03$export$dc54d992c10e8a18; }, function (v) { return $3bfcd8e655c52d03$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3bfcd8e655c52d03$export$83d89fbfd8236492; }, function (v) { return $3bfcd8e655c52d03$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3bfcd8e655c52d03$export$ae55be85d98224ed;
var $3bfcd8e655c52d03$export$d39a5bbd09211389;
var $3bfcd8e655c52d03$export$882461b6382ed46c;
var $3bfcd8e655c52d03$export$466bfc07425424d5;
var $3bfcd8e655c52d03$export$cd75ccfd720a3cd4;
var $3bfcd8e655c52d03$export$fa8d919ba61d84db;
var $3bfcd8e655c52d03$export$757ceba2d55c277e;
var $3bfcd8e655c52d03$export$b3890eb0ae9dca99;
var $3bfcd8e655c52d03$export$502457920280e6be;
var $3bfcd8e655c52d03$export$c78a37762a8d58e1;
var $3bfcd8e655c52d03$export$dc54d992c10e8a18;
var $3bfcd8e655c52d03$export$83d89fbfd8236492;
"use strict";

var $eZVvM = parcelRequire("eZVvM");

var $9kLo3 = parcelRequire("9kLo3");
function $3bfcd8e655c52d03$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3bfcd8e655c52d03$var$da = new Set, $3bfcd8e655c52d03$var$ea = {};
function $3bfcd8e655c52d03$var$fa(a, b) {
    $3bfcd8e655c52d03$var$ha(a, b);
    $3bfcd8e655c52d03$var$ha(a + "Capture", b);
}
function $3bfcd8e655c52d03$var$ha(a, b) {
    $3bfcd8e655c52d03$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3bfcd8e655c52d03$var$da.add(b[a]);
}
var $3bfcd8e655c52d03$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3bfcd8e655c52d03$var$ja = Object.prototype.hasOwnProperty, $3bfcd8e655c52d03$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3bfcd8e655c52d03$var$la = {}, $3bfcd8e655c52d03$var$ma = {};
function $3bfcd8e655c52d03$var$oa(a) {
    if ($3bfcd8e655c52d03$var$ja.call($3bfcd8e655c52d03$var$ma, a)) return !0;
    if ($3bfcd8e655c52d03$var$ja.call($3bfcd8e655c52d03$var$la, a)) return !1;
    if ($3bfcd8e655c52d03$var$ka.test(a)) return $3bfcd8e655c52d03$var$ma[a] = !0;
    $3bfcd8e655c52d03$var$la[a] = !0;
    return !1;
}
function $3bfcd8e655c52d03$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3bfcd8e655c52d03$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3bfcd8e655c52d03$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3bfcd8e655c52d03$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3bfcd8e655c52d03$var$ra = /[\-:]([a-z])/g;
function $3bfcd8e655c52d03$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3bfcd8e655c52d03$var$z.xlinkHref = new $3bfcd8e655c52d03$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3bfcd8e655c52d03$var$ta(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$z.hasOwnProperty(b) ? $3bfcd8e655c52d03$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3bfcd8e655c52d03$var$qa(b, c, e, d) && (c = null), d || null === e ? $3bfcd8e655c52d03$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3bfcd8e655c52d03$var$ua = $eZVvM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3bfcd8e655c52d03$var$va = Symbol.for("react.element"), $3bfcd8e655c52d03$var$wa = Symbol.for("react.portal"), $3bfcd8e655c52d03$var$ya = Symbol.for("react.fragment"), $3bfcd8e655c52d03$var$za = Symbol.for("react.strict_mode"), $3bfcd8e655c52d03$var$Aa = Symbol.for("react.profiler"), $3bfcd8e655c52d03$var$Ba = Symbol.for("react.provider"), $3bfcd8e655c52d03$var$Ca = Symbol.for("react.context"), $3bfcd8e655c52d03$var$Da = Symbol.for("react.forward_ref"), $3bfcd8e655c52d03$var$Ea = Symbol.for("react.suspense"), $3bfcd8e655c52d03$var$Fa = Symbol.for("react.suspense_list"), $3bfcd8e655c52d03$var$Ga = Symbol.for("react.memo"), $3bfcd8e655c52d03$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3bfcd8e655c52d03$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3bfcd8e655c52d03$var$Ja = Symbol.iterator;
function $3bfcd8e655c52d03$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3bfcd8e655c52d03$var$Ja && a[$3bfcd8e655c52d03$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3bfcd8e655c52d03$var$A = Object.assign, $3bfcd8e655c52d03$var$La;
function $3bfcd8e655c52d03$var$Ma(a) {
    if (void 0 === $3bfcd8e655c52d03$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3bfcd8e655c52d03$var$La = b && b[1] || "";
    }
    return "\n" + $3bfcd8e655c52d03$var$La + a;
}
var $3bfcd8e655c52d03$var$Na = !1;
function $3bfcd8e655c52d03$var$Oa(a, b) {
    if (!a || $3bfcd8e655c52d03$var$Na) return "";
    $3bfcd8e655c52d03$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3bfcd8e655c52d03$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3bfcd8e655c52d03$var$Ma(a) : "";
}
function $3bfcd8e655c52d03$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3bfcd8e655c52d03$var$Ma(a.type);
        case 16:
            return $3bfcd8e655c52d03$var$Ma("Lazy");
        case 13:
            return $3bfcd8e655c52d03$var$Ma("Suspense");
        case 19:
            return $3bfcd8e655c52d03$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3bfcd8e655c52d03$var$Oa(a.type, !1), a;
        case 11:
            return a = $3bfcd8e655c52d03$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3bfcd8e655c52d03$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3bfcd8e655c52d03$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3bfcd8e655c52d03$var$ya:
            return "Fragment";
        case $3bfcd8e655c52d03$var$wa:
            return "Portal";
        case $3bfcd8e655c52d03$var$Aa:
            return "Profiler";
        case $3bfcd8e655c52d03$var$za:
            return "StrictMode";
        case $3bfcd8e655c52d03$var$Ea:
            return "Suspense";
        case $3bfcd8e655c52d03$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3bfcd8e655c52d03$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3bfcd8e655c52d03$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3bfcd8e655c52d03$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3bfcd8e655c52d03$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3bfcd8e655c52d03$var$Qa(a.type) || "Memo";
        case $3bfcd8e655c52d03$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3bfcd8e655c52d03$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3bfcd8e655c52d03$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3bfcd8e655c52d03$var$Qa(b);
        case 8:
            return b === $3bfcd8e655c52d03$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3bfcd8e655c52d03$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3bfcd8e655c52d03$var$Ua(a) {
    var b = $3bfcd8e655c52d03$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3bfcd8e655c52d03$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3bfcd8e655c52d03$var$Ua(a));
}
function $3bfcd8e655c52d03$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3bfcd8e655c52d03$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3bfcd8e655c52d03$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3bfcd8e655c52d03$var$Ya(a, b) {
    var c = b.checked;
    return $3bfcd8e655c52d03$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3bfcd8e655c52d03$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3bfcd8e655c52d03$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3bfcd8e655c52d03$var$ab(a, b) {
    b = b.checked;
    null != b && $3bfcd8e655c52d03$var$ta(a, "checked", b, !1);
}
function $3bfcd8e655c52d03$var$bb(a, b) {
    $3bfcd8e655c52d03$var$ab(a, b);
    var c = $3bfcd8e655c52d03$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3bfcd8e655c52d03$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3bfcd8e655c52d03$var$cb(a, b.type, $3bfcd8e655c52d03$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3bfcd8e655c52d03$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3bfcd8e655c52d03$var$cb(a, b, c) {
    if ("number" !== b || $3bfcd8e655c52d03$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3bfcd8e655c52d03$var$eb = Array.isArray;
function $3bfcd8e655c52d03$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3bfcd8e655c52d03$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3bfcd8e655c52d03$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3bfcd8e655c52d03$var$p(91));
    return $3bfcd8e655c52d03$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3bfcd8e655c52d03$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3bfcd8e655c52d03$var$p(92));
            if ($3bfcd8e655c52d03$var$eb(c)) {
                if (1 < c.length) throw Error($3bfcd8e655c52d03$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3bfcd8e655c52d03$var$Sa(c)
    };
}
function $3bfcd8e655c52d03$var$ib(a, b) {
    var c = $3bfcd8e655c52d03$var$Sa(b.value), d = $3bfcd8e655c52d03$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3bfcd8e655c52d03$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3bfcd8e655c52d03$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3bfcd8e655c52d03$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3bfcd8e655c52d03$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3bfcd8e655c52d03$var$mb, $3bfcd8e655c52d03$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3bfcd8e655c52d03$var$mb = $3bfcd8e655c52d03$var$mb || document.createElement("div");
        $3bfcd8e655c52d03$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3bfcd8e655c52d03$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3bfcd8e655c52d03$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3bfcd8e655c52d03$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3bfcd8e655c52d03$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3bfcd8e655c52d03$var$pb).forEach(function(a) {
    $3bfcd8e655c52d03$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3bfcd8e655c52d03$var$pb[b] = $3bfcd8e655c52d03$var$pb[a];
    });
});
function $3bfcd8e655c52d03$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3bfcd8e655c52d03$var$pb.hasOwnProperty(a) && $3bfcd8e655c52d03$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3bfcd8e655c52d03$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3bfcd8e655c52d03$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3bfcd8e655c52d03$var$tb = $3bfcd8e655c52d03$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3bfcd8e655c52d03$var$ub(a, b) {
    if (b) {
        if ($3bfcd8e655c52d03$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3bfcd8e655c52d03$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3bfcd8e655c52d03$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3bfcd8e655c52d03$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3bfcd8e655c52d03$var$p(62));
    }
}
function $3bfcd8e655c52d03$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3bfcd8e655c52d03$var$wb = null;
function $3bfcd8e655c52d03$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3bfcd8e655c52d03$var$yb = null, $3bfcd8e655c52d03$var$zb = null, $3bfcd8e655c52d03$var$Ab = null;
function $3bfcd8e655c52d03$var$Bb(a) {
    if (a = $3bfcd8e655c52d03$var$Cb(a)) {
        if ("function" !== typeof $3bfcd8e655c52d03$var$yb) throw Error($3bfcd8e655c52d03$var$p(280));
        var b = a.stateNode;
        b && (b = $3bfcd8e655c52d03$var$Db(b), $3bfcd8e655c52d03$var$yb(a.stateNode, a.type, b));
    }
}
function $3bfcd8e655c52d03$var$Eb(a) {
    $3bfcd8e655c52d03$var$zb ? $3bfcd8e655c52d03$var$Ab ? $3bfcd8e655c52d03$var$Ab.push(a) : $3bfcd8e655c52d03$var$Ab = [
        a
    ] : $3bfcd8e655c52d03$var$zb = a;
}
function $3bfcd8e655c52d03$var$Fb() {
    if ($3bfcd8e655c52d03$var$zb) {
        var a = $3bfcd8e655c52d03$var$zb, b = $3bfcd8e655c52d03$var$Ab;
        $3bfcd8e655c52d03$var$Ab = $3bfcd8e655c52d03$var$zb = null;
        $3bfcd8e655c52d03$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3bfcd8e655c52d03$var$Bb(b[a]);
    }
}
function $3bfcd8e655c52d03$var$Gb(a, b) {
    return a(b);
}
function $3bfcd8e655c52d03$var$Hb() {}
var $3bfcd8e655c52d03$var$Ib = !1;
function $3bfcd8e655c52d03$var$Jb(a, b, c) {
    if ($3bfcd8e655c52d03$var$Ib) return a(b, c);
    $3bfcd8e655c52d03$var$Ib = !0;
    try {
        return $3bfcd8e655c52d03$var$Gb(a, b, c);
    } finally{
        if ($3bfcd8e655c52d03$var$Ib = !1, null !== $3bfcd8e655c52d03$var$zb || null !== $3bfcd8e655c52d03$var$Ab) $3bfcd8e655c52d03$var$Hb(), $3bfcd8e655c52d03$var$Fb();
    }
}
function $3bfcd8e655c52d03$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3bfcd8e655c52d03$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3bfcd8e655c52d03$var$p(231, b, typeof c));
    return c;
}
var $3bfcd8e655c52d03$var$Lb = !1;
if ($3bfcd8e655c52d03$var$ia) try {
    var $3bfcd8e655c52d03$var$Mb = {};
    Object.defineProperty($3bfcd8e655c52d03$var$Mb, "passive", {
        get: function() {
            $3bfcd8e655c52d03$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3bfcd8e655c52d03$var$Mb, $3bfcd8e655c52d03$var$Mb);
    window.removeEventListener("test", $3bfcd8e655c52d03$var$Mb, $3bfcd8e655c52d03$var$Mb);
} catch (a) {
    $3bfcd8e655c52d03$var$Lb = !1;
}
function $3bfcd8e655c52d03$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3bfcd8e655c52d03$var$Ob = !1, $3bfcd8e655c52d03$var$Pb = null, $3bfcd8e655c52d03$var$Qb = !1, $3bfcd8e655c52d03$var$Rb = null, $3bfcd8e655c52d03$var$Sb = {
    onError: function(a) {
        $3bfcd8e655c52d03$var$Ob = !0;
        $3bfcd8e655c52d03$var$Pb = a;
    }
};
function $3bfcd8e655c52d03$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3bfcd8e655c52d03$var$Ob = !1;
    $3bfcd8e655c52d03$var$Pb = null;
    $3bfcd8e655c52d03$var$Nb.apply($3bfcd8e655c52d03$var$Sb, arguments);
}
function $3bfcd8e655c52d03$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3bfcd8e655c52d03$var$Tb.apply(this, arguments);
    if ($3bfcd8e655c52d03$var$Ob) {
        if ($3bfcd8e655c52d03$var$Ob) {
            var l = $3bfcd8e655c52d03$var$Pb;
            $3bfcd8e655c52d03$var$Ob = !1;
            $3bfcd8e655c52d03$var$Pb = null;
        } else throw Error($3bfcd8e655c52d03$var$p(198));
        $3bfcd8e655c52d03$var$Qb || ($3bfcd8e655c52d03$var$Qb = !0, $3bfcd8e655c52d03$var$Rb = l);
    }
}
function $3bfcd8e655c52d03$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3bfcd8e655c52d03$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Xb(a) {
    if ($3bfcd8e655c52d03$var$Vb(a) !== a) throw Error($3bfcd8e655c52d03$var$p(188));
}
function $3bfcd8e655c52d03$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3bfcd8e655c52d03$var$Vb(a);
        if (null === b) throw Error($3bfcd8e655c52d03$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3bfcd8e655c52d03$var$Xb(e), a;
                if (f === d) return $3bfcd8e655c52d03$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3bfcd8e655c52d03$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3bfcd8e655c52d03$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3bfcd8e655c52d03$var$p(190));
    }
    if (3 !== c.tag) throw Error($3bfcd8e655c52d03$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3bfcd8e655c52d03$var$Zb(a) {
    a = $3bfcd8e655c52d03$var$Yb(a);
    return null !== a ? $3bfcd8e655c52d03$var$$b(a) : null;
}
function $3bfcd8e655c52d03$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3bfcd8e655c52d03$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$ac = $9kLo3.unstable_scheduleCallback, $3bfcd8e655c52d03$var$bc = $9kLo3.unstable_cancelCallback, $3bfcd8e655c52d03$var$cc = $9kLo3.unstable_shouldYield, $3bfcd8e655c52d03$var$dc = $9kLo3.unstable_requestPaint, $3bfcd8e655c52d03$var$B = $9kLo3.unstable_now, $3bfcd8e655c52d03$var$ec = $9kLo3.unstable_getCurrentPriorityLevel, $3bfcd8e655c52d03$var$fc = $9kLo3.unstable_ImmediatePriority, $3bfcd8e655c52d03$var$gc = $9kLo3.unstable_UserBlockingPriority, $3bfcd8e655c52d03$var$hc = $9kLo3.unstable_NormalPriority, $3bfcd8e655c52d03$var$ic = $9kLo3.unstable_LowPriority, $3bfcd8e655c52d03$var$jc = $9kLo3.unstable_IdlePriority, $3bfcd8e655c52d03$var$kc = null, $3bfcd8e655c52d03$var$lc = null;
function $3bfcd8e655c52d03$var$mc(a) {
    if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onCommitFiberRoot) try {
        $3bfcd8e655c52d03$var$lc.onCommitFiberRoot($3bfcd8e655c52d03$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3bfcd8e655c52d03$var$oc = Math.clz32 ? Math.clz32 : $3bfcd8e655c52d03$var$nc, $3bfcd8e655c52d03$var$pc = Math.log, $3bfcd8e655c52d03$var$qc = Math.LN2;
function $3bfcd8e655c52d03$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3bfcd8e655c52d03$var$pc(a) / $3bfcd8e655c52d03$var$qc | 0) | 0;
}
var $3bfcd8e655c52d03$var$rc = 64, $3bfcd8e655c52d03$var$sc = 4194304;
function $3bfcd8e655c52d03$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3bfcd8e655c52d03$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3bfcd8e655c52d03$var$tc(h) : (f &= g, 0 !== f && (d = $3bfcd8e655c52d03$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3bfcd8e655c52d03$var$tc(g) : 0 !== f && (d = $3bfcd8e655c52d03$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3bfcd8e655c52d03$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3bfcd8e655c52d03$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3bfcd8e655c52d03$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3bfcd8e655c52d03$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3bfcd8e655c52d03$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3bfcd8e655c52d03$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3bfcd8e655c52d03$var$yc() {
    var a = $3bfcd8e655c52d03$var$rc;
    $3bfcd8e655c52d03$var$rc <<= 1;
    0 === ($3bfcd8e655c52d03$var$rc & 4194240) && ($3bfcd8e655c52d03$var$rc = 64);
    return a;
}
function $3bfcd8e655c52d03$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3bfcd8e655c52d03$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3bfcd8e655c52d03$var$oc(b);
    a[b] = c;
}
function $3bfcd8e655c52d03$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3bfcd8e655c52d03$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3bfcd8e655c52d03$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3bfcd8e655c52d03$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3bfcd8e655c52d03$var$C = 0;
function $3bfcd8e655c52d03$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3bfcd8e655c52d03$var$Ec, $3bfcd8e655c52d03$var$Fc, $3bfcd8e655c52d03$var$Gc, $3bfcd8e655c52d03$var$Hc, $3bfcd8e655c52d03$var$Ic, $3bfcd8e655c52d03$var$Jc = !1, $3bfcd8e655c52d03$var$Kc = [], $3bfcd8e655c52d03$var$Lc = null, $3bfcd8e655c52d03$var$Mc = null, $3bfcd8e655c52d03$var$Nc = null, $3bfcd8e655c52d03$var$Oc = new Map, $3bfcd8e655c52d03$var$Pc = new Map, $3bfcd8e655c52d03$var$Qc = [], $3bfcd8e655c52d03$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3bfcd8e655c52d03$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3bfcd8e655c52d03$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3bfcd8e655c52d03$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3bfcd8e655c52d03$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3bfcd8e655c52d03$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3bfcd8e655c52d03$var$Pc.delete(b.pointerId);
    }
}
function $3bfcd8e655c52d03$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3bfcd8e655c52d03$var$Cb(b), null !== b && $3bfcd8e655c52d03$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3bfcd8e655c52d03$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3bfcd8e655c52d03$var$Lc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3bfcd8e655c52d03$var$Mc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3bfcd8e655c52d03$var$Nc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3bfcd8e655c52d03$var$Oc.set(f, $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3bfcd8e655c52d03$var$Pc.set(f, $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3bfcd8e655c52d03$var$Vc(a) {
    var b = $3bfcd8e655c52d03$var$Wc(a.target);
    if (null !== b) {
        var c = $3bfcd8e655c52d03$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3bfcd8e655c52d03$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3bfcd8e655c52d03$var$Ic(a.priority, function() {
                        $3bfcd8e655c52d03$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3bfcd8e655c52d03$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3bfcd8e655c52d03$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3bfcd8e655c52d03$var$wb = d;
            c.target.dispatchEvent(d);
            $3bfcd8e655c52d03$var$wb = null;
        } else return b = $3bfcd8e655c52d03$var$Cb(c), null !== b && $3bfcd8e655c52d03$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Zc(a, b, c) {
    $3bfcd8e655c52d03$var$Xc(a) && c.delete(b);
}
function $3bfcd8e655c52d03$var$$c() {
    $3bfcd8e655c52d03$var$Jc = !1;
    null !== $3bfcd8e655c52d03$var$Lc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Lc) && ($3bfcd8e655c52d03$var$Lc = null);
    null !== $3bfcd8e655c52d03$var$Mc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Mc) && ($3bfcd8e655c52d03$var$Mc = null);
    null !== $3bfcd8e655c52d03$var$Nc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Nc) && ($3bfcd8e655c52d03$var$Nc = null);
    $3bfcd8e655c52d03$var$Oc.forEach($3bfcd8e655c52d03$var$Zc);
    $3bfcd8e655c52d03$var$Pc.forEach($3bfcd8e655c52d03$var$Zc);
}
function $3bfcd8e655c52d03$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3bfcd8e655c52d03$var$Jc || ($3bfcd8e655c52d03$var$Jc = !0, $9kLo3.unstable_scheduleCallback($9kLo3.unstable_NormalPriority, $3bfcd8e655c52d03$var$$c)));
}
function $3bfcd8e655c52d03$var$bd(a) {
    function b(b) {
        return $3bfcd8e655c52d03$var$ad(b, a);
    }
    if (0 < $3bfcd8e655c52d03$var$Kc.length) {
        $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Kc[0], a);
        for(var c = 1; c < $3bfcd8e655c52d03$var$Kc.length; c++){
            var d = $3bfcd8e655c52d03$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3bfcd8e655c52d03$var$Lc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Lc, a);
    null !== $3bfcd8e655c52d03$var$Mc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Mc, a);
    null !== $3bfcd8e655c52d03$var$Nc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Nc, a);
    $3bfcd8e655c52d03$var$Oc.forEach(b);
    $3bfcd8e655c52d03$var$Pc.forEach(b);
    for(c = 0; c < $3bfcd8e655c52d03$var$Qc.length; c++)d = $3bfcd8e655c52d03$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3bfcd8e655c52d03$var$Qc.length && (c = $3bfcd8e655c52d03$var$Qc[0], null === c.blockedOn);)$3bfcd8e655c52d03$var$Vc(c), null === c.blockedOn && $3bfcd8e655c52d03$var$Qc.shift();
}
var $3bfcd8e655c52d03$var$cd = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$dd = !0;
function $3bfcd8e655c52d03$var$ed(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$C, f = $3bfcd8e655c52d03$var$cd.transition;
    $3bfcd8e655c52d03$var$cd.transition = null;
    try {
        $3bfcd8e655c52d03$var$C = 1, $3bfcd8e655c52d03$var$fd(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$C = e, $3bfcd8e655c52d03$var$cd.transition = f;
    }
}
function $3bfcd8e655c52d03$var$gd(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$C, f = $3bfcd8e655c52d03$var$cd.transition;
    $3bfcd8e655c52d03$var$cd.transition = null;
    try {
        $3bfcd8e655c52d03$var$C = 4, $3bfcd8e655c52d03$var$fd(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$C = e, $3bfcd8e655c52d03$var$cd.transition = f;
    }
}
function $3bfcd8e655c52d03$var$fd(a, b, c, d) {
    if ($3bfcd8e655c52d03$var$dd) {
        var e = $3bfcd8e655c52d03$var$Yc(a, b, c, d);
        if (null === e) $3bfcd8e655c52d03$var$hd(a, b, d, $3bfcd8e655c52d03$var$id, c), $3bfcd8e655c52d03$var$Sc(a, d);
        else if ($3bfcd8e655c52d03$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3bfcd8e655c52d03$var$Sc(a, d), b & 4 && -1 < $3bfcd8e655c52d03$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3bfcd8e655c52d03$var$Cb(e);
                null !== f && $3bfcd8e655c52d03$var$Ec(f);
                f = $3bfcd8e655c52d03$var$Yc(a, b, c, d);
                null === f && $3bfcd8e655c52d03$var$hd(a, b, d, $3bfcd8e655c52d03$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3bfcd8e655c52d03$var$hd(a, b, d, null, c);
    }
}
var $3bfcd8e655c52d03$var$id = null;
function $3bfcd8e655c52d03$var$Yc(a, b, c, d) {
    $3bfcd8e655c52d03$var$id = null;
    a = $3bfcd8e655c52d03$var$xb(d);
    a = $3bfcd8e655c52d03$var$Wc(a);
    if (null !== a) {
        if (b = $3bfcd8e655c52d03$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3bfcd8e655c52d03$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3bfcd8e655c52d03$var$id = a;
    return null;
}
function $3bfcd8e655c52d03$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3bfcd8e655c52d03$var$ec()){
                case $3bfcd8e655c52d03$var$fc:
                    return 1;
                case $3bfcd8e655c52d03$var$gc:
                    return 4;
                case $3bfcd8e655c52d03$var$hc:
                case $3bfcd8e655c52d03$var$ic:
                    return 16;
                case $3bfcd8e655c52d03$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3bfcd8e655c52d03$var$kd = null, $3bfcd8e655c52d03$var$ld = null, $3bfcd8e655c52d03$var$md = null;
function $3bfcd8e655c52d03$var$nd() {
    if ($3bfcd8e655c52d03$var$md) return $3bfcd8e655c52d03$var$md;
    var a, b = $3bfcd8e655c52d03$var$ld, c = b.length, d, e = "value" in $3bfcd8e655c52d03$var$kd ? $3bfcd8e655c52d03$var$kd.value : $3bfcd8e655c52d03$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3bfcd8e655c52d03$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3bfcd8e655c52d03$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3bfcd8e655c52d03$var$pd() {
    return !0;
}
function $3bfcd8e655c52d03$var$qd() {
    return !1;
}
function $3bfcd8e655c52d03$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3bfcd8e655c52d03$var$pd : $3bfcd8e655c52d03$var$qd;
        this.isPropagationStopped = $3bfcd8e655c52d03$var$qd;
        return this;
    }
    $3bfcd8e655c52d03$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3bfcd8e655c52d03$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3bfcd8e655c52d03$var$pd);
        },
        persist: function() {},
        isPersistent: $3bfcd8e655c52d03$var$pd
    });
    return b;
}
var $3bfcd8e655c52d03$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3bfcd8e655c52d03$var$td = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$sd), $3bfcd8e655c52d03$var$ud = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    view: 0,
    detail: 0
}), $3bfcd8e655c52d03$var$vd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$ud), $3bfcd8e655c52d03$var$wd, $3bfcd8e655c52d03$var$xd, $3bfcd8e655c52d03$var$yd, $3bfcd8e655c52d03$var$Ad = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3bfcd8e655c52d03$var$yd && ($3bfcd8e655c52d03$var$yd && "mousemove" === a.type ? ($3bfcd8e655c52d03$var$wd = a.screenX - $3bfcd8e655c52d03$var$yd.screenX, $3bfcd8e655c52d03$var$xd = a.screenY - $3bfcd8e655c52d03$var$yd.screenY) : $3bfcd8e655c52d03$var$xd = $3bfcd8e655c52d03$var$wd = 0, $3bfcd8e655c52d03$var$yd = a);
        return $3bfcd8e655c52d03$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3bfcd8e655c52d03$var$xd;
    }
}), $3bfcd8e655c52d03$var$Bd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ad), $3bfcd8e655c52d03$var$Cd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    dataTransfer: 0
}), $3bfcd8e655c52d03$var$Dd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Cd), $3bfcd8e655c52d03$var$Ed = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    relatedTarget: 0
}), $3bfcd8e655c52d03$var$Fd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ed), $3bfcd8e655c52d03$var$Gd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bfcd8e655c52d03$var$Hd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Gd), $3bfcd8e655c52d03$var$Id = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3bfcd8e655c52d03$var$Jd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Id), $3bfcd8e655c52d03$var$Kd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    data: 0
}), $3bfcd8e655c52d03$var$Ld = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Kd), $3bfcd8e655c52d03$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3bfcd8e655c52d03$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3bfcd8e655c52d03$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3bfcd8e655c52d03$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3bfcd8e655c52d03$var$Od[a]) ? !!b[a] : !1;
}
function $3bfcd8e655c52d03$var$zd() {
    return $3bfcd8e655c52d03$var$Pd;
}
var $3bfcd8e655c52d03$var$Qd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3bfcd8e655c52d03$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3bfcd8e655c52d03$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3bfcd8e655c52d03$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3bfcd8e655c52d03$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3bfcd8e655c52d03$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3bfcd8e655c52d03$var$Rd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Qd), $3bfcd8e655c52d03$var$Sd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3bfcd8e655c52d03$var$Td = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Sd), $3bfcd8e655c52d03$var$Ud = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd
}), $3bfcd8e655c52d03$var$Vd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ud), $3bfcd8e655c52d03$var$Wd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bfcd8e655c52d03$var$Xd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Wd), $3bfcd8e655c52d03$var$Yd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3bfcd8e655c52d03$var$Zd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Yd), $3bfcd8e655c52d03$var$$d = [
    9,
    13,
    27,
    32
], $3bfcd8e655c52d03$var$ae = $3bfcd8e655c52d03$var$ia && "CompositionEvent" in window, $3bfcd8e655c52d03$var$be = null;
$3bfcd8e655c52d03$var$ia && "documentMode" in document && ($3bfcd8e655c52d03$var$be = document.documentMode);
var $3bfcd8e655c52d03$var$ce = $3bfcd8e655c52d03$var$ia && "TextEvent" in window && !$3bfcd8e655c52d03$var$be, $3bfcd8e655c52d03$var$de = $3bfcd8e655c52d03$var$ia && (!$3bfcd8e655c52d03$var$ae || $3bfcd8e655c52d03$var$be && 8 < $3bfcd8e655c52d03$var$be && 11 >= $3bfcd8e655c52d03$var$be), $3bfcd8e655c52d03$var$ee = String.fromCharCode(32), $3bfcd8e655c52d03$var$fe = !1;
function $3bfcd8e655c52d03$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3bfcd8e655c52d03$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3bfcd8e655c52d03$var$ie = !1;
function $3bfcd8e655c52d03$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3bfcd8e655c52d03$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3bfcd8e655c52d03$var$fe = !0;
            return $3bfcd8e655c52d03$var$ee;
        case "textInput":
            return a = b.data, a === $3bfcd8e655c52d03$var$ee && $3bfcd8e655c52d03$var$fe ? null : a;
        default:
            return null;
    }
}
function $3bfcd8e655c52d03$var$ke(a, b) {
    if ($3bfcd8e655c52d03$var$ie) return "compositionend" === a || !$3bfcd8e655c52d03$var$ae && $3bfcd8e655c52d03$var$ge(a, b) ? (a = $3bfcd8e655c52d03$var$nd(), $3bfcd8e655c52d03$var$md = $3bfcd8e655c52d03$var$ld = $3bfcd8e655c52d03$var$kd = null, $3bfcd8e655c52d03$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3bfcd8e655c52d03$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3bfcd8e655c52d03$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3bfcd8e655c52d03$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3bfcd8e655c52d03$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3bfcd8e655c52d03$var$ne(a, b, c, d) {
    $3bfcd8e655c52d03$var$Eb(d);
    b = $3bfcd8e655c52d03$var$oe(b, "onChange");
    0 < b.length && (c = new $3bfcd8e655c52d03$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3bfcd8e655c52d03$var$pe = null, $3bfcd8e655c52d03$var$qe = null;
function $3bfcd8e655c52d03$var$re(a) {
    $3bfcd8e655c52d03$var$se(a, 0);
}
function $3bfcd8e655c52d03$var$te(a) {
    var b = $3bfcd8e655c52d03$var$ue(a);
    if ($3bfcd8e655c52d03$var$Wa(b)) return a;
}
function $3bfcd8e655c52d03$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3bfcd8e655c52d03$var$we = !1;
if ($3bfcd8e655c52d03$var$ia) {
    var $3bfcd8e655c52d03$var$xe;
    if ($3bfcd8e655c52d03$var$ia) {
        var $3bfcd8e655c52d03$var$ye = "oninput" in document;
        if (!$3bfcd8e655c52d03$var$ye) {
            var $3bfcd8e655c52d03$var$ze = document.createElement("div");
            $3bfcd8e655c52d03$var$ze.setAttribute("oninput", "return;");
            $3bfcd8e655c52d03$var$ye = "function" === typeof $3bfcd8e655c52d03$var$ze.oninput;
        }
        $3bfcd8e655c52d03$var$xe = $3bfcd8e655c52d03$var$ye;
    } else $3bfcd8e655c52d03$var$xe = !1;
    $3bfcd8e655c52d03$var$we = $3bfcd8e655c52d03$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3bfcd8e655c52d03$var$Ae() {
    $3bfcd8e655c52d03$var$pe && ($3bfcd8e655c52d03$var$pe.detachEvent("onpropertychange", $3bfcd8e655c52d03$var$Be), $3bfcd8e655c52d03$var$qe = $3bfcd8e655c52d03$var$pe = null);
}
function $3bfcd8e655c52d03$var$Be(a) {
    if ("value" === a.propertyName && $3bfcd8e655c52d03$var$te($3bfcd8e655c52d03$var$qe)) {
        var b = [];
        $3bfcd8e655c52d03$var$ne(b, $3bfcd8e655c52d03$var$qe, a, $3bfcd8e655c52d03$var$xb(a));
        $3bfcd8e655c52d03$var$Jb($3bfcd8e655c52d03$var$re, b);
    }
}
function $3bfcd8e655c52d03$var$Ce(a, b, c) {
    "focusin" === a ? ($3bfcd8e655c52d03$var$Ae(), $3bfcd8e655c52d03$var$pe = b, $3bfcd8e655c52d03$var$qe = c, $3bfcd8e655c52d03$var$pe.attachEvent("onpropertychange", $3bfcd8e655c52d03$var$Be)) : "focusout" === a && $3bfcd8e655c52d03$var$Ae();
}
function $3bfcd8e655c52d03$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3bfcd8e655c52d03$var$te($3bfcd8e655c52d03$var$qe);
}
function $3bfcd8e655c52d03$var$Ee(a, b) {
    if ("click" === a) return $3bfcd8e655c52d03$var$te(b);
}
function $3bfcd8e655c52d03$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3bfcd8e655c52d03$var$te(b);
}
function $3bfcd8e655c52d03$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3bfcd8e655c52d03$var$He = "function" === typeof Object.is ? Object.is : $3bfcd8e655c52d03$var$Ge;
function $3bfcd8e655c52d03$var$Ie(a, b) {
    if ($3bfcd8e655c52d03$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3bfcd8e655c52d03$var$ja.call(b, e) || !$3bfcd8e655c52d03$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3bfcd8e655c52d03$var$Ke(a, b) {
    var c = $3bfcd8e655c52d03$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3bfcd8e655c52d03$var$Je(c);
    }
}
function $3bfcd8e655c52d03$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3bfcd8e655c52d03$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3bfcd8e655c52d03$var$Me() {
    for(var a = window, b = $3bfcd8e655c52d03$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3bfcd8e655c52d03$var$Xa(a.document);
    }
    return b;
}
function $3bfcd8e655c52d03$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3bfcd8e655c52d03$var$Oe(a) {
    var b = $3bfcd8e655c52d03$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3bfcd8e655c52d03$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3bfcd8e655c52d03$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3bfcd8e655c52d03$var$Ke(c, f);
                var g = $3bfcd8e655c52d03$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3bfcd8e655c52d03$var$Pe = $3bfcd8e655c52d03$var$ia && "documentMode" in document && 11 >= document.documentMode, $3bfcd8e655c52d03$var$Qe = null, $3bfcd8e655c52d03$var$Re = null, $3bfcd8e655c52d03$var$Se = null, $3bfcd8e655c52d03$var$Te = !1;
function $3bfcd8e655c52d03$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3bfcd8e655c52d03$var$Te || null == $3bfcd8e655c52d03$var$Qe || $3bfcd8e655c52d03$var$Qe !== $3bfcd8e655c52d03$var$Xa(d) || (d = $3bfcd8e655c52d03$var$Qe, "selectionStart" in d && $3bfcd8e655c52d03$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3bfcd8e655c52d03$var$Se && $3bfcd8e655c52d03$var$Ie($3bfcd8e655c52d03$var$Se, d) || ($3bfcd8e655c52d03$var$Se = d, d = $3bfcd8e655c52d03$var$oe($3bfcd8e655c52d03$var$Re, "onSelect"), 0 < d.length && (b = new $3bfcd8e655c52d03$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3bfcd8e655c52d03$var$Qe)));
}
function $3bfcd8e655c52d03$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3bfcd8e655c52d03$var$We = {
    animationend: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationStart"),
    transitionend: $3bfcd8e655c52d03$var$Ve("Transition", "TransitionEnd")
}, $3bfcd8e655c52d03$var$Xe = {}, $3bfcd8e655c52d03$var$Ye = {};
$3bfcd8e655c52d03$var$ia && ($3bfcd8e655c52d03$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3bfcd8e655c52d03$var$We.animationend.animation, delete $3bfcd8e655c52d03$var$We.animationiteration.animation, delete $3bfcd8e655c52d03$var$We.animationstart.animation), "TransitionEvent" in window || delete $3bfcd8e655c52d03$var$We.transitionend.transition);
function $3bfcd8e655c52d03$var$Ze(a) {
    if ($3bfcd8e655c52d03$var$Xe[a]) return $3bfcd8e655c52d03$var$Xe[a];
    if (!$3bfcd8e655c52d03$var$We[a]) return a;
    var b = $3bfcd8e655c52d03$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3bfcd8e655c52d03$var$Ye) return $3bfcd8e655c52d03$var$Xe[a] = b[c];
    return a;
}
var $3bfcd8e655c52d03$var$$e = $3bfcd8e655c52d03$var$Ze("animationend"), $3bfcd8e655c52d03$var$af = $3bfcd8e655c52d03$var$Ze("animationiteration"), $3bfcd8e655c52d03$var$bf = $3bfcd8e655c52d03$var$Ze("animationstart"), $3bfcd8e655c52d03$var$cf = $3bfcd8e655c52d03$var$Ze("transitionend"), $3bfcd8e655c52d03$var$df = new Map, $3bfcd8e655c52d03$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3bfcd8e655c52d03$var$ff(a, b) {
    $3bfcd8e655c52d03$var$df.set(a, b);
    $3bfcd8e655c52d03$var$fa(b, [
        a
    ]);
}
for(var $3bfcd8e655c52d03$var$gf = 0; $3bfcd8e655c52d03$var$gf < $3bfcd8e655c52d03$var$ef.length; $3bfcd8e655c52d03$var$gf++){
    var $3bfcd8e655c52d03$var$hf = $3bfcd8e655c52d03$var$ef[$3bfcd8e655c52d03$var$gf], $3bfcd8e655c52d03$var$jf = $3bfcd8e655c52d03$var$hf.toLowerCase(), $3bfcd8e655c52d03$var$kf = $3bfcd8e655c52d03$var$hf[0].toUpperCase() + $3bfcd8e655c52d03$var$hf.slice(1);
    $3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$jf, "on" + $3bfcd8e655c52d03$var$kf);
}
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$$e, "onAnimationEnd");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$af, "onAnimationIteration");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$bf, "onAnimationStart");
$3bfcd8e655c52d03$var$ff("dblclick", "onDoubleClick");
$3bfcd8e655c52d03$var$ff("focusin", "onFocus");
$3bfcd8e655c52d03$var$ff("focusout", "onBlur");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$cf, "onTransitionEnd");
$3bfcd8e655c52d03$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3bfcd8e655c52d03$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3bfcd8e655c52d03$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3bfcd8e655c52d03$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3bfcd8e655c52d03$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3bfcd8e655c52d03$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3bfcd8e655c52d03$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3bfcd8e655c52d03$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3bfcd8e655c52d03$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3bfcd8e655c52d03$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3bfcd8e655c52d03$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3bfcd8e655c52d03$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3bfcd8e655c52d03$var$lf));
function $3bfcd8e655c52d03$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3bfcd8e655c52d03$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3bfcd8e655c52d03$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bfcd8e655c52d03$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bfcd8e655c52d03$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3bfcd8e655c52d03$var$Qb) throw a = $3bfcd8e655c52d03$var$Rb, $3bfcd8e655c52d03$var$Qb = !1, $3bfcd8e655c52d03$var$Rb = null, a;
}
function $3bfcd8e655c52d03$var$D(a, b) {
    var c = b[$3bfcd8e655c52d03$var$of];
    void 0 === c && (c = b[$3bfcd8e655c52d03$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3bfcd8e655c52d03$var$pf(b, a, 2, !1), c.add(d));
}
function $3bfcd8e655c52d03$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3bfcd8e655c52d03$var$pf(c, a, d, b);
}
var $3bfcd8e655c52d03$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3bfcd8e655c52d03$var$sf(a) {
    if (!a[$3bfcd8e655c52d03$var$rf]) {
        a[$3bfcd8e655c52d03$var$rf] = !0;
        $3bfcd8e655c52d03$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3bfcd8e655c52d03$var$mf.has(b) || $3bfcd8e655c52d03$var$qf(b, !1, a), $3bfcd8e655c52d03$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3bfcd8e655c52d03$var$rf] || (b[$3bfcd8e655c52d03$var$rf] = !0, $3bfcd8e655c52d03$var$qf("selectionchange", !1, b));
    }
}
function $3bfcd8e655c52d03$var$pf(a, b, c, d) {
    switch($3bfcd8e655c52d03$var$jd(b)){
        case 1:
            var e = $3bfcd8e655c52d03$var$ed;
            break;
        case 4:
            e = $3bfcd8e655c52d03$var$gd;
            break;
        default:
            e = $3bfcd8e655c52d03$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3bfcd8e655c52d03$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3bfcd8e655c52d03$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3bfcd8e655c52d03$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3bfcd8e655c52d03$var$Jb(function() {
        var d = f, e = $3bfcd8e655c52d03$var$xb(c), g = [];
        a: {
            var h = $3bfcd8e655c52d03$var$df.get(a);
            if (void 0 !== h) {
                var k = $3bfcd8e655c52d03$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3bfcd8e655c52d03$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3bfcd8e655c52d03$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3bfcd8e655c52d03$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3bfcd8e655c52d03$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3bfcd8e655c52d03$var$Vd;
                        break;
                    case $3bfcd8e655c52d03$var$$e:
                    case $3bfcd8e655c52d03$var$af:
                    case $3bfcd8e655c52d03$var$bf:
                        k = $3bfcd8e655c52d03$var$Hd;
                        break;
                    case $3bfcd8e655c52d03$var$cf:
                        k = $3bfcd8e655c52d03$var$Xd;
                        break;
                    case "scroll":
                        k = $3bfcd8e655c52d03$var$vd;
                        break;
                    case "wheel":
                        k = $3bfcd8e655c52d03$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3bfcd8e655c52d03$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3bfcd8e655c52d03$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3bfcd8e655c52d03$var$Kb(w, x), null != F && t.push($3bfcd8e655c52d03$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3bfcd8e655c52d03$var$wb && (n = c.relatedTarget || c.fromElement) && ($3bfcd8e655c52d03$var$Wc(n) || n[$3bfcd8e655c52d03$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3bfcd8e655c52d03$var$Wc(n) : null, null !== n && (J = $3bfcd8e655c52d03$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3bfcd8e655c52d03$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3bfcd8e655c52d03$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3bfcd8e655c52d03$var$ue(k);
                        u = null == n ? h : $3bfcd8e655c52d03$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3bfcd8e655c52d03$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3bfcd8e655c52d03$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3bfcd8e655c52d03$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3bfcd8e655c52d03$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3bfcd8e655c52d03$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3bfcd8e655c52d03$var$vf(t);
                                x = $3bfcd8e655c52d03$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3bfcd8e655c52d03$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3bfcd8e655c52d03$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3bfcd8e655c52d03$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3bfcd8e655c52d03$var$ve;
                else if ($3bfcd8e655c52d03$var$me(h)) {
                    if ($3bfcd8e655c52d03$var$we) na = $3bfcd8e655c52d03$var$Fe;
                    else {
                        na = $3bfcd8e655c52d03$var$De;
                        var xa = $3bfcd8e655c52d03$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3bfcd8e655c52d03$var$Ee);
                if (na && (na = na(a, d))) {
                    $3bfcd8e655c52d03$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3bfcd8e655c52d03$var$cb(h, "number", h.value);
            }
            xa = d ? $3bfcd8e655c52d03$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3bfcd8e655c52d03$var$me(xa) || "true" === xa.contentEditable) $3bfcd8e655c52d03$var$Qe = xa, $3bfcd8e655c52d03$var$Re = d, $3bfcd8e655c52d03$var$Se = null;
                    break;
                case "focusout":
                    $3bfcd8e655c52d03$var$Se = $3bfcd8e655c52d03$var$Re = $3bfcd8e655c52d03$var$Qe = null;
                    break;
                case "mousedown":
                    $3bfcd8e655c52d03$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3bfcd8e655c52d03$var$Te = !1;
                    $3bfcd8e655c52d03$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3bfcd8e655c52d03$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3bfcd8e655c52d03$var$Ue(g, c, e);
            }
            var $a;
            if ($3bfcd8e655c52d03$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3bfcd8e655c52d03$var$ie ? $3bfcd8e655c52d03$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3bfcd8e655c52d03$var$de && "ko" !== c.locale && ($3bfcd8e655c52d03$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3bfcd8e655c52d03$var$ie && ($a = $3bfcd8e655c52d03$var$nd()) : ($3bfcd8e655c52d03$var$kd = e, $3bfcd8e655c52d03$var$ld = "value" in $3bfcd8e655c52d03$var$kd ? $3bfcd8e655c52d03$var$kd.value : $3bfcd8e655c52d03$var$kd.textContent, $3bfcd8e655c52d03$var$ie = !0)), xa = $3bfcd8e655c52d03$var$oe(d, ba), 0 < xa.length && (ba = new $3bfcd8e655c52d03$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3bfcd8e655c52d03$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3bfcd8e655c52d03$var$ce ? $3bfcd8e655c52d03$var$je(a, c) : $3bfcd8e655c52d03$var$ke(a, c)) d = $3bfcd8e655c52d03$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3bfcd8e655c52d03$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3bfcd8e655c52d03$var$se(g, b);
    });
}
function $3bfcd8e655c52d03$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3bfcd8e655c52d03$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3bfcd8e655c52d03$var$Kb(a, c), null != f && d.unshift($3bfcd8e655c52d03$var$tf(a, f, e)), f = $3bfcd8e655c52d03$var$Kb(a, b), null != f && d.push($3bfcd8e655c52d03$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3bfcd8e655c52d03$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3bfcd8e655c52d03$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3bfcd8e655c52d03$var$Kb(c, f), null != k && g.unshift($3bfcd8e655c52d03$var$tf(c, k, h))) : e || (k = $3bfcd8e655c52d03$var$Kb(c, f), null != k && g.push($3bfcd8e655c52d03$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3bfcd8e655c52d03$var$xf = /\r\n?/g, $3bfcd8e655c52d03$var$yf = /\u0000|\uFFFD/g;
function $3bfcd8e655c52d03$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3bfcd8e655c52d03$var$xf, "\n").replace($3bfcd8e655c52d03$var$yf, "");
}
function $3bfcd8e655c52d03$var$Af(a, b, c) {
    b = $3bfcd8e655c52d03$var$zf(b);
    if ($3bfcd8e655c52d03$var$zf(a) !== b && c) throw Error($3bfcd8e655c52d03$var$p(425));
}
function $3bfcd8e655c52d03$var$Bf() {}
var $3bfcd8e655c52d03$var$Cf = null, $3bfcd8e655c52d03$var$Df = null;
function $3bfcd8e655c52d03$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3bfcd8e655c52d03$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3bfcd8e655c52d03$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3bfcd8e655c52d03$var$Hf = "function" === typeof Promise ? Promise : void 0, $3bfcd8e655c52d03$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3bfcd8e655c52d03$var$Hf ? function(a) {
    return $3bfcd8e655c52d03$var$Hf.resolve(null).then(a).catch($3bfcd8e655c52d03$var$If);
} : $3bfcd8e655c52d03$var$Ff;
function $3bfcd8e655c52d03$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3bfcd8e655c52d03$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3bfcd8e655c52d03$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3bfcd8e655c52d03$var$bd(b);
}
function $3bfcd8e655c52d03$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$Nf = Math.random().toString(36).slice(2), $3bfcd8e655c52d03$var$Of = "__reactFiber$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Pf = "__reactProps$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$uf = "__reactContainer$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$of = "__reactEvents$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Qf = "__reactListeners$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Rf = "__reactHandles$" + $3bfcd8e655c52d03$var$Nf;
function $3bfcd8e655c52d03$var$Wc(a) {
    var b = a[$3bfcd8e655c52d03$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3bfcd8e655c52d03$var$uf] || c[$3bfcd8e655c52d03$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3bfcd8e655c52d03$var$Mf(a); null !== a;){
                if (c = a[$3bfcd8e655c52d03$var$Of]) return c;
                a = $3bfcd8e655c52d03$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Cb(a) {
    a = a[$3bfcd8e655c52d03$var$Of] || a[$3bfcd8e655c52d03$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3bfcd8e655c52d03$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3bfcd8e655c52d03$var$p(33));
}
function $3bfcd8e655c52d03$var$Db(a) {
    return a[$3bfcd8e655c52d03$var$Pf] || null;
}
var $3bfcd8e655c52d03$var$Sf = [], $3bfcd8e655c52d03$var$Tf = -1;
function $3bfcd8e655c52d03$var$Uf(a) {
    return {
        current: a
    };
}
function $3bfcd8e655c52d03$var$E(a) {
    0 > $3bfcd8e655c52d03$var$Tf || (a.current = $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf], $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf] = null, $3bfcd8e655c52d03$var$Tf--);
}
function $3bfcd8e655c52d03$var$G(a, b) {
    $3bfcd8e655c52d03$var$Tf++;
    $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf] = a.current;
    a.current = b;
}
var $3bfcd8e655c52d03$var$Vf = {}, $3bfcd8e655c52d03$var$H = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$Vf), $3bfcd8e655c52d03$var$Wf = $3bfcd8e655c52d03$var$Uf(!1), $3bfcd8e655c52d03$var$Xf = $3bfcd8e655c52d03$var$Vf;
function $3bfcd8e655c52d03$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3bfcd8e655c52d03$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3bfcd8e655c52d03$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3bfcd8e655c52d03$var$$f() {
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
}
function $3bfcd8e655c52d03$var$ag(a, b, c) {
    if ($3bfcd8e655c52d03$var$H.current !== $3bfcd8e655c52d03$var$Vf) throw Error($3bfcd8e655c52d03$var$p(168));
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, b);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, c);
}
function $3bfcd8e655c52d03$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3bfcd8e655c52d03$var$p(108, $3bfcd8e655c52d03$var$Ra(a) || "Unknown", e));
    return $3bfcd8e655c52d03$var$A({}, c, d);
}
function $3bfcd8e655c52d03$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3bfcd8e655c52d03$var$Vf;
    $3bfcd8e655c52d03$var$Xf = $3bfcd8e655c52d03$var$H.current;
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, a);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, $3bfcd8e655c52d03$var$Wf.current);
    return !0;
}
function $3bfcd8e655c52d03$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3bfcd8e655c52d03$var$p(169));
    c ? (a = $3bfcd8e655c52d03$var$bg(a, b, $3bfcd8e655c52d03$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H), $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, a)) : $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, c);
}
var $3bfcd8e655c52d03$var$eg = null, $3bfcd8e655c52d03$var$fg = !1, $3bfcd8e655c52d03$var$gg = !1;
function $3bfcd8e655c52d03$var$hg(a) {
    null === $3bfcd8e655c52d03$var$eg ? $3bfcd8e655c52d03$var$eg = [
        a
    ] : $3bfcd8e655c52d03$var$eg.push(a);
}
function $3bfcd8e655c52d03$var$ig(a) {
    $3bfcd8e655c52d03$var$fg = !0;
    $3bfcd8e655c52d03$var$hg(a);
}
function $3bfcd8e655c52d03$var$jg() {
    if (!$3bfcd8e655c52d03$var$gg && null !== $3bfcd8e655c52d03$var$eg) {
        $3bfcd8e655c52d03$var$gg = !0;
        var a = 0, b = $3bfcd8e655c52d03$var$C;
        try {
            var c = $3bfcd8e655c52d03$var$eg;
            for($3bfcd8e655c52d03$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3bfcd8e655c52d03$var$eg = null;
            $3bfcd8e655c52d03$var$fg = !1;
        } catch (e) {
            throw null !== $3bfcd8e655c52d03$var$eg && ($3bfcd8e655c52d03$var$eg = $3bfcd8e655c52d03$var$eg.slice(a + 1)), $3bfcd8e655c52d03$var$ac($3bfcd8e655c52d03$var$fc, $3bfcd8e655c52d03$var$jg), e;
        } finally{
            $3bfcd8e655c52d03$var$C = b, $3bfcd8e655c52d03$var$gg = !1;
        }
    }
    return null;
}
var $3bfcd8e655c52d03$var$kg = [], $3bfcd8e655c52d03$var$lg = 0, $3bfcd8e655c52d03$var$mg = null, $3bfcd8e655c52d03$var$ng = 0, $3bfcd8e655c52d03$var$og = [], $3bfcd8e655c52d03$var$pg = 0, $3bfcd8e655c52d03$var$qg = null, $3bfcd8e655c52d03$var$rg = 1, $3bfcd8e655c52d03$var$sg = "";
function $3bfcd8e655c52d03$var$tg(a, b) {
    $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg++] = $3bfcd8e655c52d03$var$ng;
    $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg++] = $3bfcd8e655c52d03$var$mg;
    $3bfcd8e655c52d03$var$mg = a;
    $3bfcd8e655c52d03$var$ng = b;
}
function $3bfcd8e655c52d03$var$ug(a, b, c) {
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$rg;
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$sg;
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$qg;
    $3bfcd8e655c52d03$var$qg = a;
    var d = $3bfcd8e655c52d03$var$rg;
    a = $3bfcd8e655c52d03$var$sg;
    var e = 32 - $3bfcd8e655c52d03$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3bfcd8e655c52d03$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3bfcd8e655c52d03$var$rg = 1 << 32 - $3bfcd8e655c52d03$var$oc(b) + e | c << e | d;
        $3bfcd8e655c52d03$var$sg = f + a;
    } else $3bfcd8e655c52d03$var$rg = 1 << f | c << e | d, $3bfcd8e655c52d03$var$sg = a;
}
function $3bfcd8e655c52d03$var$vg(a) {
    null !== a.return && ($3bfcd8e655c52d03$var$tg(a, 1), $3bfcd8e655c52d03$var$ug(a, 1, 0));
}
function $3bfcd8e655c52d03$var$wg(a) {
    for(; a === $3bfcd8e655c52d03$var$mg;)$3bfcd8e655c52d03$var$mg = $3bfcd8e655c52d03$var$kg[--$3bfcd8e655c52d03$var$lg], $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg] = null, $3bfcd8e655c52d03$var$ng = $3bfcd8e655c52d03$var$kg[--$3bfcd8e655c52d03$var$lg], $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg] = null;
    for(; a === $3bfcd8e655c52d03$var$qg;)$3bfcd8e655c52d03$var$qg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null, $3bfcd8e655c52d03$var$sg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null, $3bfcd8e655c52d03$var$rg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null;
}
var $3bfcd8e655c52d03$var$xg = null, $3bfcd8e655c52d03$var$yg = null, $3bfcd8e655c52d03$var$I = !1, $3bfcd8e655c52d03$var$zg = null;
function $3bfcd8e655c52d03$var$Ag(a, b) {
    var c = $3bfcd8e655c52d03$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3bfcd8e655c52d03$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3bfcd8e655c52d03$var$qg ? {
                id: $3bfcd8e655c52d03$var$rg,
                overflow: $3bfcd8e655c52d03$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3bfcd8e655c52d03$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3bfcd8e655c52d03$var$Eg(a) {
    if ($3bfcd8e655c52d03$var$I) {
        var b = $3bfcd8e655c52d03$var$yg;
        if (b) {
            var c = b;
            if (!$3bfcd8e655c52d03$var$Cg(a, b)) {
                if ($3bfcd8e655c52d03$var$Dg(a)) throw Error($3bfcd8e655c52d03$var$p(418));
                b = $3bfcd8e655c52d03$var$Lf(c.nextSibling);
                var d = $3bfcd8e655c52d03$var$xg;
                b && $3bfcd8e655c52d03$var$Cg(a, b) ? $3bfcd8e655c52d03$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3bfcd8e655c52d03$var$I = !1, $3bfcd8e655c52d03$var$xg = a);
            }
        } else {
            if ($3bfcd8e655c52d03$var$Dg(a)) throw Error($3bfcd8e655c52d03$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3bfcd8e655c52d03$var$I = !1;
            $3bfcd8e655c52d03$var$xg = a;
        }
    }
}
function $3bfcd8e655c52d03$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3bfcd8e655c52d03$var$xg = a;
}
function $3bfcd8e655c52d03$var$Gg(a) {
    if (a !== $3bfcd8e655c52d03$var$xg) return !1;
    if (!$3bfcd8e655c52d03$var$I) return $3bfcd8e655c52d03$var$Fg(a), $3bfcd8e655c52d03$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3bfcd8e655c52d03$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3bfcd8e655c52d03$var$yg)) {
        if ($3bfcd8e655c52d03$var$Dg(a)) throw $3bfcd8e655c52d03$var$Hg(), Error($3bfcd8e655c52d03$var$p(418));
        for(; b;)$3bfcd8e655c52d03$var$Ag(a, b), b = $3bfcd8e655c52d03$var$Lf(b.nextSibling);
    }
    $3bfcd8e655c52d03$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3bfcd8e655c52d03$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3bfcd8e655c52d03$var$yg = null;
        }
    } else $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$xg ? $3bfcd8e655c52d03$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3bfcd8e655c52d03$var$Hg() {
    for(var a = $3bfcd8e655c52d03$var$yg; a;)a = $3bfcd8e655c52d03$var$Lf(a.nextSibling);
}
function $3bfcd8e655c52d03$var$Ig() {
    $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$xg = null;
    $3bfcd8e655c52d03$var$I = !1;
}
function $3bfcd8e655c52d03$var$Jg(a) {
    null === $3bfcd8e655c52d03$var$zg ? $3bfcd8e655c52d03$var$zg = [
        a
    ] : $3bfcd8e655c52d03$var$zg.push(a);
}
var $3bfcd8e655c52d03$var$Kg = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig;
function $3bfcd8e655c52d03$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3bfcd8e655c52d03$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3bfcd8e655c52d03$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3bfcd8e655c52d03$var$p(284));
        if (!c._owner) throw Error($3bfcd8e655c52d03$var$p(290, a));
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3bfcd8e655c52d03$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3bfcd8e655c52d03$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3bfcd8e655c52d03$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3bfcd8e655c52d03$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3bfcd8e655c52d03$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3bfcd8e655c52d03$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3bfcd8e655c52d03$var$Ha && $3bfcd8e655c52d03$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3bfcd8e655c52d03$var$Lg(a, b, c), d.return = a, d;
        d = $3bfcd8e655c52d03$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3bfcd8e655c52d03$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3bfcd8e655c52d03$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3bfcd8e655c52d03$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3bfcd8e655c52d03$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return c = $3bfcd8e655c52d03$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3bfcd8e655c52d03$var$Lg(a, null, b), c.return = a, c;
                case $3bfcd8e655c52d03$var$wa:
                    return b = $3bfcd8e655c52d03$var$Sg(b, a.mode, c), b.return = a, b;
                case $3bfcd8e655c52d03$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3bfcd8e655c52d03$var$eb(b) || $3bfcd8e655c52d03$var$Ka(b)) return b = $3bfcd8e655c52d03$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3bfcd8e655c52d03$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3bfcd8e655c52d03$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3bfcd8e655c52d03$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3bfcd8e655c52d03$var$eb(c) || $3bfcd8e655c52d03$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3bfcd8e655c52d03$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3bfcd8e655c52d03$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3bfcd8e655c52d03$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3bfcd8e655c52d03$var$eb(d) || $3bfcd8e655c52d03$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3bfcd8e655c52d03$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3bfcd8e655c52d03$var$Ka(h);
        if ("function" !== typeof l) throw Error($3bfcd8e655c52d03$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3bfcd8e655c52d03$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3bfcd8e655c52d03$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3bfcd8e655c52d03$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3bfcd8e655c52d03$var$Ha && $3bfcd8e655c52d03$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3bfcd8e655c52d03$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3bfcd8e655c52d03$var$ya ? (d = $3bfcd8e655c52d03$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3bfcd8e655c52d03$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3bfcd8e655c52d03$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3bfcd8e655c52d03$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3bfcd8e655c52d03$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3bfcd8e655c52d03$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3bfcd8e655c52d03$var$eb(f)) return n(a, d, f, h);
            if ($3bfcd8e655c52d03$var$Ka(f)) return t(a, d, f, h);
            $3bfcd8e655c52d03$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3bfcd8e655c52d03$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3bfcd8e655c52d03$var$Ug = $3bfcd8e655c52d03$var$Og(!0), $3bfcd8e655c52d03$var$Vg = $3bfcd8e655c52d03$var$Og(!1), $3bfcd8e655c52d03$var$Wg = $3bfcd8e655c52d03$var$Uf(null), $3bfcd8e655c52d03$var$Xg = null, $3bfcd8e655c52d03$var$Yg = null, $3bfcd8e655c52d03$var$Zg = null;
function $3bfcd8e655c52d03$var$$g() {
    $3bfcd8e655c52d03$var$Zg = $3bfcd8e655c52d03$var$Yg = $3bfcd8e655c52d03$var$Xg = null;
}
function $3bfcd8e655c52d03$var$ah(a) {
    var b = $3bfcd8e655c52d03$var$Wg.current;
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wg);
    a._currentValue = b;
}
function $3bfcd8e655c52d03$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3bfcd8e655c52d03$var$ch(a, b) {
    $3bfcd8e655c52d03$var$Xg = a;
    $3bfcd8e655c52d03$var$Zg = $3bfcd8e655c52d03$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3bfcd8e655c52d03$var$dh = !0), a.firstContext = null);
}
function $3bfcd8e655c52d03$var$eh(a) {
    var b = a._currentValue;
    if ($3bfcd8e655c52d03$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3bfcd8e655c52d03$var$Yg) {
            if (null === $3bfcd8e655c52d03$var$Xg) throw Error($3bfcd8e655c52d03$var$p(308));
            $3bfcd8e655c52d03$var$Yg = a;
            $3bfcd8e655c52d03$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3bfcd8e655c52d03$var$Yg = $3bfcd8e655c52d03$var$Yg.next = a;
    }
    return b;
}
var $3bfcd8e655c52d03$var$fh = null;
function $3bfcd8e655c52d03$var$gh(a) {
    null === $3bfcd8e655c52d03$var$fh ? $3bfcd8e655c52d03$var$fh = [
        a
    ] : $3bfcd8e655c52d03$var$fh.push(a);
}
function $3bfcd8e655c52d03$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3bfcd8e655c52d03$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3bfcd8e655c52d03$var$ih(a, d);
}
function $3bfcd8e655c52d03$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3bfcd8e655c52d03$var$jh = !1;
function $3bfcd8e655c52d03$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3bfcd8e655c52d03$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3bfcd8e655c52d03$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3bfcd8e655c52d03$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3bfcd8e655c52d03$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3bfcd8e655c52d03$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3bfcd8e655c52d03$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3bfcd8e655c52d03$var$ih(a, c);
}
function $3bfcd8e655c52d03$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bfcd8e655c52d03$var$Cc(a, c);
    }
}
function $3bfcd8e655c52d03$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3bfcd8e655c52d03$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3bfcd8e655c52d03$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3bfcd8e655c52d03$var$A({}, q, r);
                            break a;
                        case 2:
                            $3bfcd8e655c52d03$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3bfcd8e655c52d03$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3bfcd8e655c52d03$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3bfcd8e655c52d03$var$p(191, e));
            e.call(d);
        }
    }
}
var $3bfcd8e655c52d03$var$th = {}, $3bfcd8e655c52d03$var$uh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th), $3bfcd8e655c52d03$var$vh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th), $3bfcd8e655c52d03$var$wh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th);
function $3bfcd8e655c52d03$var$xh(a) {
    if (a === $3bfcd8e655c52d03$var$th) throw Error($3bfcd8e655c52d03$var$p(174));
    return a;
}
function $3bfcd8e655c52d03$var$yh(a, b) {
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$wh, b);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$vh, a);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, $3bfcd8e655c52d03$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3bfcd8e655c52d03$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3bfcd8e655c52d03$var$lb(b, a);
    }
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, b);
}
function $3bfcd8e655c52d03$var$zh() {
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$vh);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$wh);
}
function $3bfcd8e655c52d03$var$Ah(a) {
    $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
    var b = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
    var c = $3bfcd8e655c52d03$var$lb(b, a.type);
    b !== c && ($3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$vh, a), $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, c));
}
function $3bfcd8e655c52d03$var$Bh(a) {
    $3bfcd8e655c52d03$var$vh.current === a && ($3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$vh));
}
var $3bfcd8e655c52d03$var$L = $3bfcd8e655c52d03$var$Uf(0);
function $3bfcd8e655c52d03$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$Dh = [];
function $3bfcd8e655c52d03$var$Eh() {
    for(var a = 0; a < $3bfcd8e655c52d03$var$Dh.length; a++)$3bfcd8e655c52d03$var$Dh[a]._workInProgressVersionPrimary = null;
    $3bfcd8e655c52d03$var$Dh.length = 0;
}
var $3bfcd8e655c52d03$var$Fh = $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher, $3bfcd8e655c52d03$var$Gh = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$Hh = 0, $3bfcd8e655c52d03$var$M = null, $3bfcd8e655c52d03$var$N = null, $3bfcd8e655c52d03$var$O = null, $3bfcd8e655c52d03$var$Ih = !1, $3bfcd8e655c52d03$var$Jh = !1, $3bfcd8e655c52d03$var$Kh = 0, $3bfcd8e655c52d03$var$Lh = 0;
function $3bfcd8e655c52d03$var$P() {
    throw Error($3bfcd8e655c52d03$var$p(321));
}
function $3bfcd8e655c52d03$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3bfcd8e655c52d03$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3bfcd8e655c52d03$var$Nh(a, b, c, d, e, f) {
    $3bfcd8e655c52d03$var$Hh = f;
    $3bfcd8e655c52d03$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3bfcd8e655c52d03$var$Fh.current = null === a || null === a.memoizedState ? $3bfcd8e655c52d03$var$Oh : $3bfcd8e655c52d03$var$Ph;
    a = c(d, e);
    if ($3bfcd8e655c52d03$var$Jh) {
        f = 0;
        do {
            $3bfcd8e655c52d03$var$Jh = !1;
            $3bfcd8e655c52d03$var$Kh = 0;
            if (25 <= f) throw Error($3bfcd8e655c52d03$var$p(301));
            f += 1;
            $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = null;
            b.updateQueue = null;
            $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Qh;
            a = c(d, e);
        }while ($3bfcd8e655c52d03$var$Jh);
    }
    $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Rh;
    b = null !== $3bfcd8e655c52d03$var$N && null !== $3bfcd8e655c52d03$var$N.next;
    $3bfcd8e655c52d03$var$Hh = 0;
    $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = $3bfcd8e655c52d03$var$M = null;
    $3bfcd8e655c52d03$var$Ih = !1;
    if (b) throw Error($3bfcd8e655c52d03$var$p(300));
    return a;
}
function $3bfcd8e655c52d03$var$Sh() {
    var a = 0 !== $3bfcd8e655c52d03$var$Kh;
    $3bfcd8e655c52d03$var$Kh = 0;
    return a;
}
function $3bfcd8e655c52d03$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState = $3bfcd8e655c52d03$var$O = a : $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$O.next = a;
    return $3bfcd8e655c52d03$var$O;
}
function $3bfcd8e655c52d03$var$Uh() {
    if (null === $3bfcd8e655c52d03$var$N) {
        var a = $3bfcd8e655c52d03$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3bfcd8e655c52d03$var$N.next;
    var b = null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState : $3bfcd8e655c52d03$var$O.next;
    if (null !== b) $3bfcd8e655c52d03$var$O = b, $3bfcd8e655c52d03$var$N = a;
    else {
        if (null === a) throw Error($3bfcd8e655c52d03$var$p(310));
        $3bfcd8e655c52d03$var$N = a;
        a = {
            memoizedState: $3bfcd8e655c52d03$var$N.memoizedState,
            baseState: $3bfcd8e655c52d03$var$N.baseState,
            baseQueue: $3bfcd8e655c52d03$var$N.baseQueue,
            queue: $3bfcd8e655c52d03$var$N.queue,
            next: null
        };
        null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState = $3bfcd8e655c52d03$var$O = a : $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$O.next = a;
    }
    return $3bfcd8e655c52d03$var$O;
}
function $3bfcd8e655c52d03$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3bfcd8e655c52d03$var$Wh(a) {
    var b = $3bfcd8e655c52d03$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bfcd8e655c52d03$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3bfcd8e655c52d03$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3bfcd8e655c52d03$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3bfcd8e655c52d03$var$M.lanes |= m;
                $3bfcd8e655c52d03$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3bfcd8e655c52d03$var$He(d, b.memoizedState) || ($3bfcd8e655c52d03$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3bfcd8e655c52d03$var$M.lanes |= f, $3bfcd8e655c52d03$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3bfcd8e655c52d03$var$Xh(a) {
    var b = $3bfcd8e655c52d03$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bfcd8e655c52d03$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3bfcd8e655c52d03$var$He(f, b.memoizedState) || ($3bfcd8e655c52d03$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3bfcd8e655c52d03$var$Yh() {}
function $3bfcd8e655c52d03$var$Zh(a, b) {
    var c = $3bfcd8e655c52d03$var$M, d = $3bfcd8e655c52d03$var$Uh(), e = b(), f = !$3bfcd8e655c52d03$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3bfcd8e655c52d03$var$dh = !0);
    d = d.queue;
    $3bfcd8e655c52d03$var$$h($3bfcd8e655c52d03$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3bfcd8e655c52d03$var$O && $3bfcd8e655c52d03$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3bfcd8e655c52d03$var$bi(9, $3bfcd8e655c52d03$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3bfcd8e655c52d03$var$Q) throw Error($3bfcd8e655c52d03$var$p(349));
        0 !== ($3bfcd8e655c52d03$var$Hh & 30) || $3bfcd8e655c52d03$var$di(c, b, e);
    }
    return e;
}
function $3bfcd8e655c52d03$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3bfcd8e655c52d03$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bfcd8e655c52d03$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3bfcd8e655c52d03$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3bfcd8e655c52d03$var$ei(b) && $3bfcd8e655c52d03$var$fi(a);
}
function $3bfcd8e655c52d03$var$ai(a, b, c) {
    return c(function() {
        $3bfcd8e655c52d03$var$ei(b) && $3bfcd8e655c52d03$var$fi(a);
    });
}
function $3bfcd8e655c52d03$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3bfcd8e655c52d03$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3bfcd8e655c52d03$var$fi(a) {
    var b = $3bfcd8e655c52d03$var$ih(a, 1);
    null !== b && $3bfcd8e655c52d03$var$gi(b, a, 1, -1);
}
function $3bfcd8e655c52d03$var$hi(a) {
    var b = $3bfcd8e655c52d03$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3bfcd8e655c52d03$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3bfcd8e655c52d03$var$ii.bind(null, $3bfcd8e655c52d03$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3bfcd8e655c52d03$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3bfcd8e655c52d03$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bfcd8e655c52d03$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3bfcd8e655c52d03$var$ji() {
    return $3bfcd8e655c52d03$var$Uh().memoizedState;
}
function $3bfcd8e655c52d03$var$ki(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$Th();
    $3bfcd8e655c52d03$var$M.flags |= a;
    e.memoizedState = $3bfcd8e655c52d03$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3bfcd8e655c52d03$var$li(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3bfcd8e655c52d03$var$N) {
        var g = $3bfcd8e655c52d03$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3bfcd8e655c52d03$var$Mh(d, g.deps)) {
            e.memoizedState = $3bfcd8e655c52d03$var$bi(b, c, f, d);
            return;
        }
    }
    $3bfcd8e655c52d03$var$M.flags |= a;
    e.memoizedState = $3bfcd8e655c52d03$var$bi(1 | b, c, f, d);
}
function $3bfcd8e655c52d03$var$mi(a, b) {
    return $3bfcd8e655c52d03$var$ki(8390656, 8, a, b);
}
function $3bfcd8e655c52d03$var$$h(a, b) {
    return $3bfcd8e655c52d03$var$li(2048, 8, a, b);
}
function $3bfcd8e655c52d03$var$ni(a, b) {
    return $3bfcd8e655c52d03$var$li(4, 2, a, b);
}
function $3bfcd8e655c52d03$var$oi(a, b) {
    return $3bfcd8e655c52d03$var$li(4, 4, a, b);
}
function $3bfcd8e655c52d03$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3bfcd8e655c52d03$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3bfcd8e655c52d03$var$li(4, 4, $3bfcd8e655c52d03$var$pi.bind(null, b, a), c);
}
function $3bfcd8e655c52d03$var$ri() {}
function $3bfcd8e655c52d03$var$si(a, b) {
    var c = $3bfcd8e655c52d03$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bfcd8e655c52d03$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bfcd8e655c52d03$var$ti(a, b) {
    var c = $3bfcd8e655c52d03$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bfcd8e655c52d03$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bfcd8e655c52d03$var$ui(a, b, c) {
    if (0 === ($3bfcd8e655c52d03$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3bfcd8e655c52d03$var$dh = !0), a.memoizedState = c;
    $3bfcd8e655c52d03$var$He(c, b) || (c = $3bfcd8e655c52d03$var$yc(), $3bfcd8e655c52d03$var$M.lanes |= c, $3bfcd8e655c52d03$var$rh |= c, a.baseState = !0);
    return b;
}
function $3bfcd8e655c52d03$var$vi(a, b) {
    var c = $3bfcd8e655c52d03$var$C;
    $3bfcd8e655c52d03$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3bfcd8e655c52d03$var$Gh.transition;
    $3bfcd8e655c52d03$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3bfcd8e655c52d03$var$C = c, $3bfcd8e655c52d03$var$Gh.transition = d;
    }
}
function $3bfcd8e655c52d03$var$wi() {
    return $3bfcd8e655c52d03$var$Uh().memoizedState;
}
function $3bfcd8e655c52d03$var$xi(a, b, c) {
    var d = $3bfcd8e655c52d03$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bfcd8e655c52d03$var$zi(a)) $3bfcd8e655c52d03$var$Ai(b, c);
    else if (c = $3bfcd8e655c52d03$var$hh(a, b, c, d), null !== c) {
        var e = $3bfcd8e655c52d03$var$R();
        $3bfcd8e655c52d03$var$gi(c, a, d, e);
        $3bfcd8e655c52d03$var$Bi(c, b, d);
    }
}
function $3bfcd8e655c52d03$var$ii(a, b, c) {
    var d = $3bfcd8e655c52d03$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bfcd8e655c52d03$var$zi(a)) $3bfcd8e655c52d03$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3bfcd8e655c52d03$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3bfcd8e655c52d03$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3bfcd8e655c52d03$var$hh(a, b, e, d);
        null !== c && (e = $3bfcd8e655c52d03$var$R(), $3bfcd8e655c52d03$var$gi(c, a, d, e), $3bfcd8e655c52d03$var$Bi(c, b, d));
    }
}
function $3bfcd8e655c52d03$var$zi(a) {
    var b = a.alternate;
    return a === $3bfcd8e655c52d03$var$M || null !== b && b === $3bfcd8e655c52d03$var$M;
}
function $3bfcd8e655c52d03$var$Ai(a, b) {
    $3bfcd8e655c52d03$var$Jh = $3bfcd8e655c52d03$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3bfcd8e655c52d03$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bfcd8e655c52d03$var$Cc(a, c);
    }
}
var $3bfcd8e655c52d03$var$Rh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$P,
    useContext: $3bfcd8e655c52d03$var$P,
    useEffect: $3bfcd8e655c52d03$var$P,
    useImperativeHandle: $3bfcd8e655c52d03$var$P,
    useInsertionEffect: $3bfcd8e655c52d03$var$P,
    useLayoutEffect: $3bfcd8e655c52d03$var$P,
    useMemo: $3bfcd8e655c52d03$var$P,
    useReducer: $3bfcd8e655c52d03$var$P,
    useRef: $3bfcd8e655c52d03$var$P,
    useState: $3bfcd8e655c52d03$var$P,
    useDebugValue: $3bfcd8e655c52d03$var$P,
    useDeferredValue: $3bfcd8e655c52d03$var$P,
    useTransition: $3bfcd8e655c52d03$var$P,
    useMutableSource: $3bfcd8e655c52d03$var$P,
    useSyncExternalStore: $3bfcd8e655c52d03$var$P,
    useId: $3bfcd8e655c52d03$var$P,
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Oh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: function(a, b) {
        $3bfcd8e655c52d03$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3bfcd8e655c52d03$var$ki(4194308, 4, $3bfcd8e655c52d03$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3bfcd8e655c52d03$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3bfcd8e655c52d03$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3bfcd8e655c52d03$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3bfcd8e655c52d03$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3bfcd8e655c52d03$var$xi.bind(null, $3bfcd8e655c52d03$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3bfcd8e655c52d03$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3bfcd8e655c52d03$var$hi,
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        return $3bfcd8e655c52d03$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$hi(!1), b = a[0];
        a = $3bfcd8e655c52d03$var$vi.bind(null, a[1]);
        $3bfcd8e655c52d03$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3bfcd8e655c52d03$var$M, e = $3bfcd8e655c52d03$var$Th();
        if ($3bfcd8e655c52d03$var$I) {
            if (void 0 === c) throw Error($3bfcd8e655c52d03$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3bfcd8e655c52d03$var$Q) throw Error($3bfcd8e655c52d03$var$p(349));
            0 !== ($3bfcd8e655c52d03$var$Hh & 30) || $3bfcd8e655c52d03$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3bfcd8e655c52d03$var$mi($3bfcd8e655c52d03$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3bfcd8e655c52d03$var$bi(9, $3bfcd8e655c52d03$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3bfcd8e655c52d03$var$Th(), b = $3bfcd8e655c52d03$var$Q.identifierPrefix;
        if ($3bfcd8e655c52d03$var$I) {
            var c = $3bfcd8e655c52d03$var$sg;
            var d = $3bfcd8e655c52d03$var$rg;
            c = (d & ~(1 << 32 - $3bfcd8e655c52d03$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3bfcd8e655c52d03$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3bfcd8e655c52d03$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Ph = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$si,
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$$h,
    useImperativeHandle: $3bfcd8e655c52d03$var$qi,
    useInsertionEffect: $3bfcd8e655c52d03$var$ni,
    useLayoutEffect: $3bfcd8e655c52d03$var$oi,
    useMemo: $3bfcd8e655c52d03$var$ti,
    useReducer: $3bfcd8e655c52d03$var$Wh,
    useRef: $3bfcd8e655c52d03$var$ji,
    useState: function() {
        return $3bfcd8e655c52d03$var$Wh($3bfcd8e655c52d03$var$Vh);
    },
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        var b = $3bfcd8e655c52d03$var$Uh();
        return $3bfcd8e655c52d03$var$ui(b, $3bfcd8e655c52d03$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$Wh($3bfcd8e655c52d03$var$Vh)[0], b = $3bfcd8e655c52d03$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bfcd8e655c52d03$var$Yh,
    useSyncExternalStore: $3bfcd8e655c52d03$var$Zh,
    useId: $3bfcd8e655c52d03$var$wi,
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Qh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$si,
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$$h,
    useImperativeHandle: $3bfcd8e655c52d03$var$qi,
    useInsertionEffect: $3bfcd8e655c52d03$var$ni,
    useLayoutEffect: $3bfcd8e655c52d03$var$oi,
    useMemo: $3bfcd8e655c52d03$var$ti,
    useReducer: $3bfcd8e655c52d03$var$Xh,
    useRef: $3bfcd8e655c52d03$var$ji,
    useState: function() {
        return $3bfcd8e655c52d03$var$Xh($3bfcd8e655c52d03$var$Vh);
    },
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        var b = $3bfcd8e655c52d03$var$Uh();
        return null === $3bfcd8e655c52d03$var$N ? b.memoizedState = a : $3bfcd8e655c52d03$var$ui(b, $3bfcd8e655c52d03$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$Xh($3bfcd8e655c52d03$var$Vh)[0], b = $3bfcd8e655c52d03$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bfcd8e655c52d03$var$Yh,
    useSyncExternalStore: $3bfcd8e655c52d03$var$Zh,
    useId: $3bfcd8e655c52d03$var$wi,
    unstable_isNewReconciler: !1
};
function $3bfcd8e655c52d03$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3bfcd8e655c52d03$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3bfcd8e655c52d03$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3bfcd8e655c52d03$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3bfcd8e655c52d03$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3bfcd8e655c52d03$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bfcd8e655c52d03$var$R(), e = $3bfcd8e655c52d03$var$yi(a), f = $3bfcd8e655c52d03$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bfcd8e655c52d03$var$nh(a, f, e);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, e, d), $3bfcd8e655c52d03$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bfcd8e655c52d03$var$R(), e = $3bfcd8e655c52d03$var$yi(a), f = $3bfcd8e655c52d03$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bfcd8e655c52d03$var$nh(a, f, e);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, e, d), $3bfcd8e655c52d03$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3bfcd8e655c52d03$var$R(), d = $3bfcd8e655c52d03$var$yi(a), e = $3bfcd8e655c52d03$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3bfcd8e655c52d03$var$nh(a, e, d);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, d, c), $3bfcd8e655c52d03$var$oh(b, a, d));
    }
};
function $3bfcd8e655c52d03$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3bfcd8e655c52d03$var$Ie(c, d) || !$3bfcd8e655c52d03$var$Ie(e, f) : !0;
}
function $3bfcd8e655c52d03$var$Gi(a, b, c) {
    var d = !1, e = $3bfcd8e655c52d03$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3bfcd8e655c52d03$var$eh(f) : (e = $3bfcd8e655c52d03$var$Zf(b) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3bfcd8e655c52d03$var$Yf(a, e) : $3bfcd8e655c52d03$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3bfcd8e655c52d03$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3bfcd8e655c52d03$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3bfcd8e655c52d03$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3bfcd8e655c52d03$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3bfcd8e655c52d03$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3bfcd8e655c52d03$var$eh(f) : (f = $3bfcd8e655c52d03$var$Zf(b) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, e.context = $3bfcd8e655c52d03$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3bfcd8e655c52d03$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3bfcd8e655c52d03$var$Ei.enqueueReplaceState(e, e.state, null), $3bfcd8e655c52d03$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3bfcd8e655c52d03$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3bfcd8e655c52d03$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3bfcd8e655c52d03$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3bfcd8e655c52d03$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3bfcd8e655c52d03$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3bfcd8e655c52d03$var$Ni(a, b, c) {
    c = $3bfcd8e655c52d03$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3bfcd8e655c52d03$var$Oi || ($3bfcd8e655c52d03$var$Oi = !0, $3bfcd8e655c52d03$var$Pi = d);
        $3bfcd8e655c52d03$var$Li(a, b);
    };
    return c;
}
function $3bfcd8e655c52d03$var$Qi(a, b, c) {
    c = $3bfcd8e655c52d03$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3bfcd8e655c52d03$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3bfcd8e655c52d03$var$Li(a, b);
        "function" !== typeof d && (null === $3bfcd8e655c52d03$var$Ri ? $3bfcd8e655c52d03$var$Ri = new Set([
            this
        ]) : $3bfcd8e655c52d03$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3bfcd8e655c52d03$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3bfcd8e655c52d03$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3bfcd8e655c52d03$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3bfcd8e655c52d03$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3bfcd8e655c52d03$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3bfcd8e655c52d03$var$mh(-1, 1), b.tag = 2, $3bfcd8e655c52d03$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3bfcd8e655c52d03$var$Wi = $3bfcd8e655c52d03$var$ua.ReactCurrentOwner, $3bfcd8e655c52d03$var$dh = !1;
function $3bfcd8e655c52d03$var$Xi(a, b, c, d) {
    b.child = null === a ? $3bfcd8e655c52d03$var$Vg(b, null, c, d) : $3bfcd8e655c52d03$var$Ug(b, a.child, c, d);
}
function $3bfcd8e655c52d03$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3bfcd8e655c52d03$var$ch(b, e);
    d = $3bfcd8e655c52d03$var$Nh(a, b, c, d, f, e);
    c = $3bfcd8e655c52d03$var$Sh();
    if (null !== a && !$3bfcd8e655c52d03$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bfcd8e655c52d03$var$Zi(a, b, e);
    $3bfcd8e655c52d03$var$I && c && $3bfcd8e655c52d03$var$vg(b);
    b.flags |= 1;
    $3bfcd8e655c52d03$var$Xi(a, b, d, e);
    return b.child;
}
function $3bfcd8e655c52d03$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3bfcd8e655c52d03$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3bfcd8e655c52d03$var$bj(a, b, f, d, e);
        a = $3bfcd8e655c52d03$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3bfcd8e655c52d03$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3bfcd8e655c52d03$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3bfcd8e655c52d03$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3bfcd8e655c52d03$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3bfcd8e655c52d03$var$Ie(f, d) && a.ref === b.ref) {
            if ($3bfcd8e655c52d03$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3bfcd8e655c52d03$var$dh = !0);
            else return b.lanes = a.lanes, $3bfcd8e655c52d03$var$Zi(a, b, e);
        }
    }
    return $3bfcd8e655c52d03$var$cj(a, b, c, d, e);
}
function $3bfcd8e655c52d03$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj);
            $3bfcd8e655c52d03$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= d;
    $3bfcd8e655c52d03$var$Xi(a, b, e, c);
    return b.child;
}
function $3bfcd8e655c52d03$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3bfcd8e655c52d03$var$cj(a, b, c, d, e) {
    var f = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current;
    f = $3bfcd8e655c52d03$var$Yf(b, f);
    $3bfcd8e655c52d03$var$ch(b, e);
    c = $3bfcd8e655c52d03$var$Nh(a, b, c, d, f, e);
    d = $3bfcd8e655c52d03$var$Sh();
    if (null !== a && !$3bfcd8e655c52d03$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bfcd8e655c52d03$var$Zi(a, b, e);
    $3bfcd8e655c52d03$var$I && d && $3bfcd8e655c52d03$var$vg(b);
    b.flags |= 1;
    $3bfcd8e655c52d03$var$Xi(a, b, c, e);
    return b.child;
}
function $3bfcd8e655c52d03$var$hj(a, b, c, d, e) {
    if ($3bfcd8e655c52d03$var$Zf(c)) {
        var f = !0;
        $3bfcd8e655c52d03$var$cg(b);
    } else f = !1;
    $3bfcd8e655c52d03$var$ch(b, e);
    if (null === b.stateNode) $3bfcd8e655c52d03$var$ij(a, b), $3bfcd8e655c52d03$var$Gi(b, c, d), $3bfcd8e655c52d03$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3bfcd8e655c52d03$var$eh(l) : (l = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, l = $3bfcd8e655c52d03$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3bfcd8e655c52d03$var$Hi(b, g, d, l);
        $3bfcd8e655c52d03$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3bfcd8e655c52d03$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3bfcd8e655c52d03$var$Wf.current || $3bfcd8e655c52d03$var$jh ? ("function" === typeof m && ($3bfcd8e655c52d03$var$Di(b, c, m, d), k = b.memoizedState), (h = $3bfcd8e655c52d03$var$jh || $3bfcd8e655c52d03$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3bfcd8e655c52d03$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3bfcd8e655c52d03$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3bfcd8e655c52d03$var$eh(k) : (k = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, k = $3bfcd8e655c52d03$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3bfcd8e655c52d03$var$Hi(b, g, d, k);
        $3bfcd8e655c52d03$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3bfcd8e655c52d03$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3bfcd8e655c52d03$var$Wf.current || $3bfcd8e655c52d03$var$jh ? ("function" === typeof y && ($3bfcd8e655c52d03$var$Di(b, c, y, d), n = b.memoizedState), (l = $3bfcd8e655c52d03$var$jh || $3bfcd8e655c52d03$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3bfcd8e655c52d03$var$jj(a, b, c, d, f, e);
}
function $3bfcd8e655c52d03$var$jj(a, b, c, d, e, f) {
    $3bfcd8e655c52d03$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3bfcd8e655c52d03$var$dg(b, c, !1), $3bfcd8e655c52d03$var$Zi(a, b, f);
    d = b.stateNode;
    $3bfcd8e655c52d03$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3bfcd8e655c52d03$var$Ug(b, a.child, null, f), b.child = $3bfcd8e655c52d03$var$Ug(b, null, h, f)) : $3bfcd8e655c52d03$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3bfcd8e655c52d03$var$dg(b, c, !0);
    return b.child;
}
function $3bfcd8e655c52d03$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3bfcd8e655c52d03$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3bfcd8e655c52d03$var$ag(a, b.context, !1);
    $3bfcd8e655c52d03$var$yh(a, b.containerInfo);
}
function $3bfcd8e655c52d03$var$lj(a, b, c, d, e) {
    $3bfcd8e655c52d03$var$Ig();
    $3bfcd8e655c52d03$var$Jg(e);
    b.flags |= 256;
    $3bfcd8e655c52d03$var$Xi(a, b, c, d);
    return b.child;
}
var $3bfcd8e655c52d03$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3bfcd8e655c52d03$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3bfcd8e655c52d03$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3bfcd8e655c52d03$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, e & 1);
    if (null === a) {
        $3bfcd8e655c52d03$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3bfcd8e655c52d03$var$pj(g, d, 0, null), a = $3bfcd8e655c52d03$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3bfcd8e655c52d03$var$nj(c), b.memoizedState = $3bfcd8e655c52d03$var$mj, a) : $3bfcd8e655c52d03$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3bfcd8e655c52d03$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3bfcd8e655c52d03$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3bfcd8e655c52d03$var$Pg(h, f) : (f = $3bfcd8e655c52d03$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3bfcd8e655c52d03$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3bfcd8e655c52d03$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3bfcd8e655c52d03$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3bfcd8e655c52d03$var$qj(a, b) {
    b = $3bfcd8e655c52d03$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3bfcd8e655c52d03$var$sj(a, b, c, d) {
    null !== d && $3bfcd8e655c52d03$var$Jg(d);
    $3bfcd8e655c52d03$var$Ug(b, a.child, null, c);
    a = $3bfcd8e655c52d03$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3bfcd8e655c52d03$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3bfcd8e655c52d03$var$Ki(Error($3bfcd8e655c52d03$var$p(422))), $3bfcd8e655c52d03$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3bfcd8e655c52d03$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3bfcd8e655c52d03$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3bfcd8e655c52d03$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3bfcd8e655c52d03$var$nj(g);
        b.memoizedState = $3bfcd8e655c52d03$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3bfcd8e655c52d03$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3bfcd8e655c52d03$var$p(419));
        d = $3bfcd8e655c52d03$var$Ki(f, d, void 0);
        return $3bfcd8e655c52d03$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3bfcd8e655c52d03$var$dh || h) {
        d = $3bfcd8e655c52d03$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3bfcd8e655c52d03$var$ih(a, e), $3bfcd8e655c52d03$var$gi(d, a, e, -1));
        }
        $3bfcd8e655c52d03$var$tj();
        d = $3bfcd8e655c52d03$var$Ki(Error($3bfcd8e655c52d03$var$p(421)));
        return $3bfcd8e655c52d03$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3bfcd8e655c52d03$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(e.nextSibling);
    $3bfcd8e655c52d03$var$xg = b;
    $3bfcd8e655c52d03$var$I = !0;
    $3bfcd8e655c52d03$var$zg = null;
    null !== a && ($3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$rg, $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$sg, $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$qg, $3bfcd8e655c52d03$var$rg = a.id, $3bfcd8e655c52d03$var$sg = a.overflow, $3bfcd8e655c52d03$var$qg = b);
    b = $3bfcd8e655c52d03$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3bfcd8e655c52d03$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3bfcd8e655c52d03$var$bh(a.return, b, c);
}
function $3bfcd8e655c52d03$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3bfcd8e655c52d03$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3bfcd8e655c52d03$var$Xi(a, b, d.children, c);
    d = $3bfcd8e655c52d03$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3bfcd8e655c52d03$var$vj(a, c, b);
            else if (19 === a.tag) $3bfcd8e655c52d03$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3bfcd8e655c52d03$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3bfcd8e655c52d03$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3bfcd8e655c52d03$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3bfcd8e655c52d03$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3bfcd8e655c52d03$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3bfcd8e655c52d03$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3bfcd8e655c52d03$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3bfcd8e655c52d03$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3bfcd8e655c52d03$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3bfcd8e655c52d03$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3bfcd8e655c52d03$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3bfcd8e655c52d03$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3bfcd8e655c52d03$var$kj(b);
            $3bfcd8e655c52d03$var$Ig();
            break;
        case 5:
            $3bfcd8e655c52d03$var$Ah(b);
            break;
        case 1:
            $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$cg(b);
            break;
        case 4:
            $3bfcd8e655c52d03$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3bfcd8e655c52d03$var$oj(a, b, c);
                $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1);
                a = $3bfcd8e655c52d03$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3bfcd8e655c52d03$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3bfcd8e655c52d03$var$dj(a, b, c);
    }
    return $3bfcd8e655c52d03$var$Zi(a, b, c);
}
var $3bfcd8e655c52d03$var$zj, $3bfcd8e655c52d03$var$Aj, $3bfcd8e655c52d03$var$Bj, $3bfcd8e655c52d03$var$Cj;
$3bfcd8e655c52d03$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3bfcd8e655c52d03$var$Aj = function() {};
$3bfcd8e655c52d03$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3bfcd8e655c52d03$var$Ya(a, e);
                d = $3bfcd8e655c52d03$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3bfcd8e655c52d03$var$A({}, e, {
                    value: void 0
                });
                d = $3bfcd8e655c52d03$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3bfcd8e655c52d03$var$gb(a, e);
                d = $3bfcd8e655c52d03$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3bfcd8e655c52d03$var$Bf);
        }
        $3bfcd8e655c52d03$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3bfcd8e655c52d03$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3bfcd8e655c52d03$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3bfcd8e655c52d03$var$Dj(a, b) {
    if (!$3bfcd8e655c52d03$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3bfcd8e655c52d03$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3bfcd8e655c52d03$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3bfcd8e655c52d03$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3bfcd8e655c52d03$var$S(b), null;
        case 1:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), $3bfcd8e655c52d03$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3bfcd8e655c52d03$var$zh();
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
            $3bfcd8e655c52d03$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3bfcd8e655c52d03$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3bfcd8e655c52d03$var$zg && ($3bfcd8e655c52d03$var$Fj($3bfcd8e655c52d03$var$zg), $3bfcd8e655c52d03$var$zg = null));
            $3bfcd8e655c52d03$var$Aj(a, b);
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 5:
            $3bfcd8e655c52d03$var$Bh(b);
            var e = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3bfcd8e655c52d03$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3bfcd8e655c52d03$var$p(166));
                    $3bfcd8e655c52d03$var$S(b);
                    return null;
                }
                a = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
                if ($3bfcd8e655c52d03$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3bfcd8e655c52d03$var$Of] = b;
                    d[$3bfcd8e655c52d03$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3bfcd8e655c52d03$var$D("cancel", d);
                            $3bfcd8e655c52d03$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3bfcd8e655c52d03$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3bfcd8e655c52d03$var$lf.length; e++)$3bfcd8e655c52d03$var$D($3bfcd8e655c52d03$var$lf[e], d);
                            break;
                        case "source":
                            $3bfcd8e655c52d03$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3bfcd8e655c52d03$var$D("error", d);
                            $3bfcd8e655c52d03$var$D("load", d);
                            break;
                        case "details":
                            $3bfcd8e655c52d03$var$D("toggle", d);
                            break;
                        case "input":
                            $3bfcd8e655c52d03$var$Za(d, f);
                            $3bfcd8e655c52d03$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3bfcd8e655c52d03$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$hb(d, f), $3bfcd8e655c52d03$var$D("invalid", d);
                    }
                    $3bfcd8e655c52d03$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3bfcd8e655c52d03$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3bfcd8e655c52d03$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3bfcd8e655c52d03$var$Va(d);
                            $3bfcd8e655c52d03$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$Va(d);
                            $3bfcd8e655c52d03$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3bfcd8e655c52d03$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3bfcd8e655c52d03$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3bfcd8e655c52d03$var$Of] = b;
                    a[$3bfcd8e655c52d03$var$Pf] = d;
                    $3bfcd8e655c52d03$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3bfcd8e655c52d03$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3bfcd8e655c52d03$var$D("cancel", a);
                                $3bfcd8e655c52d03$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3bfcd8e655c52d03$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3bfcd8e655c52d03$var$lf.length; e++)$3bfcd8e655c52d03$var$D($3bfcd8e655c52d03$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3bfcd8e655c52d03$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3bfcd8e655c52d03$var$D("error", a);
                                $3bfcd8e655c52d03$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3bfcd8e655c52d03$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3bfcd8e655c52d03$var$Za(a, d);
                                e = $3bfcd8e655c52d03$var$Ya(a, d);
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3bfcd8e655c52d03$var$A({}, d, {
                                    value: void 0
                                });
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3bfcd8e655c52d03$var$hb(a, d);
                                e = $3bfcd8e655c52d03$var$gb(a, d);
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3bfcd8e655c52d03$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3bfcd8e655c52d03$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3bfcd8e655c52d03$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3bfcd8e655c52d03$var$ob(a, k) : "number" === typeof k && $3bfcd8e655c52d03$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3bfcd8e655c52d03$var$D("scroll", a) : null != k && $3bfcd8e655c52d03$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3bfcd8e655c52d03$var$Va(a);
                                $3bfcd8e655c52d03$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3bfcd8e655c52d03$var$Va(a);
                                $3bfcd8e655c52d03$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3bfcd8e655c52d03$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3bfcd8e655c52d03$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3bfcd8e655c52d03$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3bfcd8e655c52d03$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3bfcd8e655c52d03$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3bfcd8e655c52d03$var$p(166));
                c = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
                $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
                if ($3bfcd8e655c52d03$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3bfcd8e655c52d03$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3bfcd8e655c52d03$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3bfcd8e655c52d03$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3bfcd8e655c52d03$var$Of] = b, b.stateNode = d;
            }
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 13:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3bfcd8e655c52d03$var$I && null !== $3bfcd8e655c52d03$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3bfcd8e655c52d03$var$Hg(), $3bfcd8e655c52d03$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3bfcd8e655c52d03$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3bfcd8e655c52d03$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3bfcd8e655c52d03$var$p(317));
                        f[$3bfcd8e655c52d03$var$Of] = b;
                    } else $3bfcd8e655c52d03$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3bfcd8e655c52d03$var$S(b);
                    f = !1;
                } else null !== $3bfcd8e655c52d03$var$zg && ($3bfcd8e655c52d03$var$Fj($3bfcd8e655c52d03$var$zg), $3bfcd8e655c52d03$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3bfcd8e655c52d03$var$L.current & 1) ? 0 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 3) : $3bfcd8e655c52d03$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 4:
            return $3bfcd8e655c52d03$var$zh(), $3bfcd8e655c52d03$var$Aj(a, b), null === a && $3bfcd8e655c52d03$var$sf(b.stateNode.containerInfo), $3bfcd8e655c52d03$var$S(b), null;
        case 10:
            return $3bfcd8e655c52d03$var$ah(b.type._context), $3bfcd8e655c52d03$var$S(b), null;
        case 17:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), $3bfcd8e655c52d03$var$S(b), null;
        case 19:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            f = b.memoizedState;
            if (null === f) return $3bfcd8e655c52d03$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3bfcd8e655c52d03$var$Dj(f, !1);
                else {
                    if (0 !== $3bfcd8e655c52d03$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3bfcd8e655c52d03$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3bfcd8e655c52d03$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3bfcd8e655c52d03$var$B() > $3bfcd8e655c52d03$var$Gj && (b.flags |= 128, d = !0, $3bfcd8e655c52d03$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3bfcd8e655c52d03$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3bfcd8e655c52d03$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3bfcd8e655c52d03$var$I) return $3bfcd8e655c52d03$var$S(b), null;
                    } else 2 * $3bfcd8e655c52d03$var$B() - f.renderingStartTime > $3bfcd8e655c52d03$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3bfcd8e655c52d03$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3bfcd8e655c52d03$var$B(), b.sibling = null, c = $3bfcd8e655c52d03$var$L.current, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, d ? c & 1 | 2 : c & 1), b;
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 22:
        case 23:
            return $3bfcd8e655c52d03$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3bfcd8e655c52d03$var$fj & 1073741824) && ($3bfcd8e655c52d03$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3bfcd8e655c52d03$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3bfcd8e655c52d03$var$p(156, b.tag));
}
function $3bfcd8e655c52d03$var$Ij(a, b) {
    $3bfcd8e655c52d03$var$wg(b);
    switch(b.tag){
        case 1:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3bfcd8e655c52d03$var$zh(), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H), $3bfcd8e655c52d03$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3bfcd8e655c52d03$var$Bh(b), null;
        case 13:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3bfcd8e655c52d03$var$p(340));
                $3bfcd8e655c52d03$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L), null;
        case 4:
            return $3bfcd8e655c52d03$var$zh(), null;
        case 10:
            return $3bfcd8e655c52d03$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3bfcd8e655c52d03$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3bfcd8e655c52d03$var$Jj = !1, $3bfcd8e655c52d03$var$U = !1, $3bfcd8e655c52d03$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3bfcd8e655c52d03$var$V = null;
function $3bfcd8e655c52d03$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3bfcd8e655c52d03$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3bfcd8e655c52d03$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3bfcd8e655c52d03$var$W(a, b, d);
    }
}
var $3bfcd8e655c52d03$var$Nj = !1;
function $3bfcd8e655c52d03$var$Oj(a, b) {
    $3bfcd8e655c52d03$var$Cf = $3bfcd8e655c52d03$var$dd;
    a = $3bfcd8e655c52d03$var$Me();
    if ($3bfcd8e655c52d03$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3bfcd8e655c52d03$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3bfcd8e655c52d03$var$dd = !1;
    for($3bfcd8e655c52d03$var$V = b; null !== $3bfcd8e655c52d03$var$V;)if (b = $3bfcd8e655c52d03$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3bfcd8e655c52d03$var$V = a;
    else for(; null !== $3bfcd8e655c52d03$var$V;){
        b = $3bfcd8e655c52d03$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3bfcd8e655c52d03$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(163));
            }
        } catch (F) {
            $3bfcd8e655c52d03$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3bfcd8e655c52d03$var$V = a;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
    n = $3bfcd8e655c52d03$var$Nj;
    $3bfcd8e655c52d03$var$Nj = !1;
    return n;
}
function $3bfcd8e655c52d03$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3bfcd8e655c52d03$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3bfcd8e655c52d03$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3bfcd8e655c52d03$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3bfcd8e655c52d03$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3bfcd8e655c52d03$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3bfcd8e655c52d03$var$Of], delete b[$3bfcd8e655c52d03$var$Pf], delete b[$3bfcd8e655c52d03$var$of], delete b[$3bfcd8e655c52d03$var$Qf], delete b[$3bfcd8e655c52d03$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3bfcd8e655c52d03$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3bfcd8e655c52d03$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3bfcd8e655c52d03$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3bfcd8e655c52d03$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3bfcd8e655c52d03$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3bfcd8e655c52d03$var$Vj(a, b, c), a = a.sibling; null !== a;)$3bfcd8e655c52d03$var$Vj(a, b, c), a = a.sibling;
}
function $3bfcd8e655c52d03$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3bfcd8e655c52d03$var$Wj(a, b, c), a = a.sibling; null !== a;)$3bfcd8e655c52d03$var$Wj(a, b, c), a = a.sibling;
}
var $3bfcd8e655c52d03$var$X = null, $3bfcd8e655c52d03$var$Xj = !1;
function $3bfcd8e655c52d03$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3bfcd8e655c52d03$var$Zj(a, b, c), c = c.sibling;
}
function $3bfcd8e655c52d03$var$Zj(a, b, c) {
    if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onCommitFiberUnmount) try {
        $3bfcd8e655c52d03$var$lc.onCommitFiberUnmount($3bfcd8e655c52d03$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3bfcd8e655c52d03$var$U || $3bfcd8e655c52d03$var$Lj(c, b);
        case 6:
            var d = $3bfcd8e655c52d03$var$X, e = $3bfcd8e655c52d03$var$Xj;
            $3bfcd8e655c52d03$var$X = null;
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            $3bfcd8e655c52d03$var$X = d;
            $3bfcd8e655c52d03$var$Xj = e;
            null !== $3bfcd8e655c52d03$var$X && ($3bfcd8e655c52d03$var$Xj ? (a = $3bfcd8e655c52d03$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3bfcd8e655c52d03$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3bfcd8e655c52d03$var$X && ($3bfcd8e655c52d03$var$Xj ? (a = $3bfcd8e655c52d03$var$X, c = c.stateNode, 8 === a.nodeType ? $3bfcd8e655c52d03$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3bfcd8e655c52d03$var$Kf(a, c), $3bfcd8e655c52d03$var$bd(a)) : $3bfcd8e655c52d03$var$Kf($3bfcd8e655c52d03$var$X, c.stateNode));
            break;
        case 4:
            d = $3bfcd8e655c52d03$var$X;
            e = $3bfcd8e655c52d03$var$Xj;
            $3bfcd8e655c52d03$var$X = c.stateNode.containerInfo;
            $3bfcd8e655c52d03$var$Xj = !0;
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            $3bfcd8e655c52d03$var$X = d;
            $3bfcd8e655c52d03$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3bfcd8e655c52d03$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3bfcd8e655c52d03$var$Mj(c, b, g) : 0 !== (f & 4) && $3bfcd8e655c52d03$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3bfcd8e655c52d03$var$U && ($3bfcd8e655c52d03$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3bfcd8e655c52d03$var$W(c, b, h);
            }
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 21:
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3bfcd8e655c52d03$var$U = (d = $3bfcd8e655c52d03$var$U) || null !== c.memoizedState, $3bfcd8e655c52d03$var$Yj(a, b, c), $3bfcd8e655c52d03$var$U = d) : $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        default:
            $3bfcd8e655c52d03$var$Yj(a, b, c);
    }
}
function $3bfcd8e655c52d03$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3bfcd8e655c52d03$var$Kj);
        b.forEach(function(b) {
            var d = $3bfcd8e655c52d03$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3bfcd8e655c52d03$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3bfcd8e655c52d03$var$X = h.stateNode;
                        $3bfcd8e655c52d03$var$Xj = !1;
                        break a;
                    case 3:
                        $3bfcd8e655c52d03$var$X = h.stateNode.containerInfo;
                        $3bfcd8e655c52d03$var$Xj = !0;
                        break a;
                    case 4:
                        $3bfcd8e655c52d03$var$X = h.stateNode.containerInfo;
                        $3bfcd8e655c52d03$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3bfcd8e655c52d03$var$X) throw Error($3bfcd8e655c52d03$var$p(160));
            $3bfcd8e655c52d03$var$Zj(f, g, e);
            $3bfcd8e655c52d03$var$X = null;
            $3bfcd8e655c52d03$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3bfcd8e655c52d03$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3bfcd8e655c52d03$var$dk(b, a), b = b.sibling;
}
function $3bfcd8e655c52d03$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4) {
                try {
                    $3bfcd8e655c52d03$var$Pj(3, a, a.return), $3bfcd8e655c52d03$var$Qj(3, a);
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
                try {
                    $3bfcd8e655c52d03$var$Pj(5, a, a.return);
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 512 && null !== c && $3bfcd8e655c52d03$var$Lj(c, c.return);
            break;
        case 5:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 512 && null !== c && $3bfcd8e655c52d03$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3bfcd8e655c52d03$var$ob(e, "");
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3bfcd8e655c52d03$var$ab(e, f);
                    $3bfcd8e655c52d03$var$vb(h, g);
                    var l = $3bfcd8e655c52d03$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3bfcd8e655c52d03$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3bfcd8e655c52d03$var$nb(e, q) : "children" === m ? $3bfcd8e655c52d03$var$ob(e, q) : $3bfcd8e655c52d03$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3bfcd8e655c52d03$var$bb(e, f);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3bfcd8e655c52d03$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3bfcd8e655c52d03$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3bfcd8e655c52d03$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3bfcd8e655c52d03$var$Pf] = f;
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3bfcd8e655c52d03$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3bfcd8e655c52d03$var$bd(b.containerInfo);
            } catch (t) {
                $3bfcd8e655c52d03$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            break;
        case 13:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3bfcd8e655c52d03$var$fk = $3bfcd8e655c52d03$var$B()));
            d & 4 && $3bfcd8e655c52d03$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3bfcd8e655c52d03$var$U = (l = $3bfcd8e655c52d03$var$U) || m, $3bfcd8e655c52d03$var$ck(b, a), $3bfcd8e655c52d03$var$U = l) : $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3bfcd8e655c52d03$var$V = a, m = a.child; null !== m;){
                    for(q = $3bfcd8e655c52d03$var$V = m; null !== $3bfcd8e655c52d03$var$V;){
                        r = $3bfcd8e655c52d03$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3bfcd8e655c52d03$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3bfcd8e655c52d03$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3bfcd8e655c52d03$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3bfcd8e655c52d03$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3bfcd8e655c52d03$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3bfcd8e655c52d03$var$V = y) : $3bfcd8e655c52d03$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3bfcd8e655c52d03$var$rb("display", g));
                            } catch (t) {
                                $3bfcd8e655c52d03$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3bfcd8e655c52d03$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 4 && $3bfcd8e655c52d03$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3bfcd8e655c52d03$var$ck(b, a), $3bfcd8e655c52d03$var$ek(a);
    }
}
function $3bfcd8e655c52d03$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3bfcd8e655c52d03$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3bfcd8e655c52d03$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3bfcd8e655c52d03$var$ob(e, ""), d.flags &= -33);
                    var f = $3bfcd8e655c52d03$var$Uj(a);
                    $3bfcd8e655c52d03$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3bfcd8e655c52d03$var$Uj(a);
                    $3bfcd8e655c52d03$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(161));
            }
        } catch (k) {
            $3bfcd8e655c52d03$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3bfcd8e655c52d03$var$hk(a, b, c) {
    $3bfcd8e655c52d03$var$V = a;
    $3bfcd8e655c52d03$var$ik(a, b, c);
}
function $3bfcd8e655c52d03$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3bfcd8e655c52d03$var$V;){
        var e = $3bfcd8e655c52d03$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3bfcd8e655c52d03$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3bfcd8e655c52d03$var$U;
                h = $3bfcd8e655c52d03$var$Jj;
                var l = $3bfcd8e655c52d03$var$U;
                $3bfcd8e655c52d03$var$Jj = g;
                if (($3bfcd8e655c52d03$var$U = k) && !l) for($3bfcd8e655c52d03$var$V = e; null !== $3bfcd8e655c52d03$var$V;)g = $3bfcd8e655c52d03$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3bfcd8e655c52d03$var$jk(e) : null !== k ? (k.return = g, $3bfcd8e655c52d03$var$V = k) : $3bfcd8e655c52d03$var$jk(e);
                for(; null !== f;)$3bfcd8e655c52d03$var$V = f, $3bfcd8e655c52d03$var$ik(f, b, c), f = f.sibling;
                $3bfcd8e655c52d03$var$V = e;
                $3bfcd8e655c52d03$var$Jj = h;
                $3bfcd8e655c52d03$var$U = l;
            }
            $3bfcd8e655c52d03$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3bfcd8e655c52d03$var$V = f) : $3bfcd8e655c52d03$var$kk(a, b, c);
    }
}
function $3bfcd8e655c52d03$var$kk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3bfcd8e655c52d03$var$U || $3bfcd8e655c52d03$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3bfcd8e655c52d03$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3bfcd8e655c52d03$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3bfcd8e655c52d03$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3bfcd8e655c52d03$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3bfcd8e655c52d03$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3bfcd8e655c52d03$var$p(163));
                }
                $3bfcd8e655c52d03$var$U || b.flags & 512 && $3bfcd8e655c52d03$var$Rj(b);
            } catch (r) {
                $3bfcd8e655c52d03$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bfcd8e655c52d03$var$V = c;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
function $3bfcd8e655c52d03$var$gk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bfcd8e655c52d03$var$V = c;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
function $3bfcd8e655c52d03$var$jk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Qj(4, b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3bfcd8e655c52d03$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Rj(b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Rj(b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3bfcd8e655c52d03$var$W(b, b.return, k);
        }
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3bfcd8e655c52d03$var$V = h;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
var $3bfcd8e655c52d03$var$lk = Math.ceil, $3bfcd8e655c52d03$var$mk = $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher, $3bfcd8e655c52d03$var$nk = $3bfcd8e655c52d03$var$ua.ReactCurrentOwner, $3bfcd8e655c52d03$var$ok = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$K = 0, $3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Y = null, $3bfcd8e655c52d03$var$Z = 0, $3bfcd8e655c52d03$var$fj = 0, $3bfcd8e655c52d03$var$ej = $3bfcd8e655c52d03$var$Uf(0), $3bfcd8e655c52d03$var$T = 0, $3bfcd8e655c52d03$var$pk = null, $3bfcd8e655c52d03$var$rh = 0, $3bfcd8e655c52d03$var$qk = 0, $3bfcd8e655c52d03$var$rk = 0, $3bfcd8e655c52d03$var$sk = null, $3bfcd8e655c52d03$var$tk = null, $3bfcd8e655c52d03$var$fk = 0, $3bfcd8e655c52d03$var$Gj = Infinity, $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Oi = !1, $3bfcd8e655c52d03$var$Pi = null, $3bfcd8e655c52d03$var$Ri = null, $3bfcd8e655c52d03$var$vk = !1, $3bfcd8e655c52d03$var$wk = null, $3bfcd8e655c52d03$var$xk = 0, $3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = null, $3bfcd8e655c52d03$var$Ak = -1, $3bfcd8e655c52d03$var$Bk = 0;
function $3bfcd8e655c52d03$var$R() {
    return 0 !== ($3bfcd8e655c52d03$var$K & 6) ? $3bfcd8e655c52d03$var$B() : -1 !== $3bfcd8e655c52d03$var$Ak ? $3bfcd8e655c52d03$var$Ak : $3bfcd8e655c52d03$var$Ak = $3bfcd8e655c52d03$var$B();
}
function $3bfcd8e655c52d03$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3bfcd8e655c52d03$var$K & 2) && 0 !== $3bfcd8e655c52d03$var$Z) return $3bfcd8e655c52d03$var$Z & -$3bfcd8e655c52d03$var$Z;
    if (null !== $3bfcd8e655c52d03$var$Kg.transition) return 0 === $3bfcd8e655c52d03$var$Bk && ($3bfcd8e655c52d03$var$Bk = $3bfcd8e655c52d03$var$yc()), $3bfcd8e655c52d03$var$Bk;
    a = $3bfcd8e655c52d03$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3bfcd8e655c52d03$var$jd(a.type);
    return a;
}
function $3bfcd8e655c52d03$var$gi(a, b, c, d) {
    if (50 < $3bfcd8e655c52d03$var$yk) throw $3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = null, Error($3bfcd8e655c52d03$var$p(185));
    $3bfcd8e655c52d03$var$Ac(a, c, d);
    if (0 === ($3bfcd8e655c52d03$var$K & 2) || a !== $3bfcd8e655c52d03$var$Q) a === $3bfcd8e655c52d03$var$Q && (0 === ($3bfcd8e655c52d03$var$K & 2) && ($3bfcd8e655c52d03$var$qk |= c), 4 === $3bfcd8e655c52d03$var$T && $3bfcd8e655c52d03$var$Ck(a, $3bfcd8e655c52d03$var$Z)), $3bfcd8e655c52d03$var$Dk(a, d), 1 === c && 0 === $3bfcd8e655c52d03$var$K && 0 === (b.mode & 1) && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$fg && $3bfcd8e655c52d03$var$jg());
}
function $3bfcd8e655c52d03$var$Dk(a, b) {
    var c = a.callbackNode;
    $3bfcd8e655c52d03$var$wc(a, b);
    var d = $3bfcd8e655c52d03$var$uc(a, a === $3bfcd8e655c52d03$var$Q ? $3bfcd8e655c52d03$var$Z : 0);
    if (0 === d) null !== c && $3bfcd8e655c52d03$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3bfcd8e655c52d03$var$bc(c);
        if (1 === b) 0 === a.tag ? $3bfcd8e655c52d03$var$ig($3bfcd8e655c52d03$var$Ek.bind(null, a)) : $3bfcd8e655c52d03$var$hg($3bfcd8e655c52d03$var$Ek.bind(null, a)), $3bfcd8e655c52d03$var$Jf(function() {
            0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$jg();
        }), c = null;
        else {
            switch($3bfcd8e655c52d03$var$Dc(d)){
                case 1:
                    c = $3bfcd8e655c52d03$var$fc;
                    break;
                case 4:
                    c = $3bfcd8e655c52d03$var$gc;
                    break;
                case 16:
                    c = $3bfcd8e655c52d03$var$hc;
                    break;
                case 536870912:
                    c = $3bfcd8e655c52d03$var$jc;
                    break;
                default:
                    c = $3bfcd8e655c52d03$var$hc;
            }
            c = $3bfcd8e655c52d03$var$Fk(c, $3bfcd8e655c52d03$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3bfcd8e655c52d03$var$Gk(a, b) {
    $3bfcd8e655c52d03$var$Ak = -1;
    $3bfcd8e655c52d03$var$Bk = 0;
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    var c = a.callbackNode;
    if ($3bfcd8e655c52d03$var$Hk() && a.callbackNode !== c) return null;
    var d = $3bfcd8e655c52d03$var$uc(a, a === $3bfcd8e655c52d03$var$Q ? $3bfcd8e655c52d03$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3bfcd8e655c52d03$var$Ik(a, d);
    else {
        b = d;
        var e = $3bfcd8e655c52d03$var$K;
        $3bfcd8e655c52d03$var$K |= 2;
        var f = $3bfcd8e655c52d03$var$Jk();
        if ($3bfcd8e655c52d03$var$Q !== a || $3bfcd8e655c52d03$var$Z !== b) $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$Kk(a, b);
        for(;;)try {
            $3bfcd8e655c52d03$var$Lk();
            break;
        } catch (h) {
            $3bfcd8e655c52d03$var$Mk(a, h);
        }
        $3bfcd8e655c52d03$var$$g();
        $3bfcd8e655c52d03$var$mk.current = f;
        $3bfcd8e655c52d03$var$K = e;
        null !== $3bfcd8e655c52d03$var$Y ? b = 0 : ($3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Z = 0, b = $3bfcd8e655c52d03$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3bfcd8e655c52d03$var$xc(a), 0 !== e && (d = e, b = $3bfcd8e655c52d03$var$Nk(a, e)));
        if (1 === b) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, d), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
        if (6 === b) $3bfcd8e655c52d03$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3bfcd8e655c52d03$var$Ok(e) && (b = $3bfcd8e655c52d03$var$Ik(a, d), 2 === b && (f = $3bfcd8e655c52d03$var$xc(a), 0 !== f && (d = f, b = $3bfcd8e655c52d03$var$Nk(a, f))), 1 === b)) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, d), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3bfcd8e655c52d03$var$p(345));
                case 2:
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 3:
                    $3bfcd8e655c52d03$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3bfcd8e655c52d03$var$fk + 500 - $3bfcd8e655c52d03$var$B(), 10 < b)) {
                        if (0 !== $3bfcd8e655c52d03$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3bfcd8e655c52d03$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3bfcd8e655c52d03$var$Ff($3bfcd8e655c52d03$var$Pk.bind(null, a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk), b);
                        break;
                    }
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 4:
                    $3bfcd8e655c52d03$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3bfcd8e655c52d03$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3bfcd8e655c52d03$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3bfcd8e655c52d03$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3bfcd8e655c52d03$var$Ff($3bfcd8e655c52d03$var$Pk.bind(null, a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk), d);
                        break;
                    }
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 5:
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(329));
            }
        }
    }
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    return a.callbackNode === c ? $3bfcd8e655c52d03$var$Gk.bind(null, a) : null;
}
function $3bfcd8e655c52d03$var$Nk(a, b) {
    var c = $3bfcd8e655c52d03$var$sk;
    a.current.memoizedState.isDehydrated && ($3bfcd8e655c52d03$var$Kk(a, b).flags |= 256);
    a = $3bfcd8e655c52d03$var$Ik(a, b);
    2 !== a && (b = $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$tk = c, null !== b && $3bfcd8e655c52d03$var$Fj(b));
    return a;
}
function $3bfcd8e655c52d03$var$Fj(a) {
    null === $3bfcd8e655c52d03$var$tk ? $3bfcd8e655c52d03$var$tk = a : $3bfcd8e655c52d03$var$tk.push.apply($3bfcd8e655c52d03$var$tk, a);
}
function $3bfcd8e655c52d03$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3bfcd8e655c52d03$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Ck(a, b) {
    b &= ~$3bfcd8e655c52d03$var$rk;
    b &= ~$3bfcd8e655c52d03$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3bfcd8e655c52d03$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3bfcd8e655c52d03$var$Ek(a) {
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    $3bfcd8e655c52d03$var$Hk();
    var b = $3bfcd8e655c52d03$var$uc(a, 0);
    if (0 === (b & 1)) return $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), null;
    var c = $3bfcd8e655c52d03$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3bfcd8e655c52d03$var$xc(a);
        0 !== d && (b = d, c = $3bfcd8e655c52d03$var$Nk(a, d));
    }
    if (1 === c) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, b), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
    if (6 === c) throw Error($3bfcd8e655c52d03$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    return null;
}
function $3bfcd8e655c52d03$var$Qk(a, b) {
    var c = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3bfcd8e655c52d03$var$K = c, 0 === $3bfcd8e655c52d03$var$K && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$fg && $3bfcd8e655c52d03$var$jg());
    }
}
function $3bfcd8e655c52d03$var$Rk(a) {
    null !== $3bfcd8e655c52d03$var$wk && 0 === $3bfcd8e655c52d03$var$wk.tag && 0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$Hk();
    var b = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 1;
    var c = $3bfcd8e655c52d03$var$ok.transition, d = $3bfcd8e655c52d03$var$C;
    try {
        if ($3bfcd8e655c52d03$var$ok.transition = null, $3bfcd8e655c52d03$var$C = 1, a) return a();
    } finally{
        $3bfcd8e655c52d03$var$C = d, $3bfcd8e655c52d03$var$ok.transition = c, $3bfcd8e655c52d03$var$K = b, 0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$jg();
    }
}
function $3bfcd8e655c52d03$var$Hj() {
    $3bfcd8e655c52d03$var$fj = $3bfcd8e655c52d03$var$ej.current;
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$ej);
}
function $3bfcd8e655c52d03$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3bfcd8e655c52d03$var$Gf(c));
    if (null !== $3bfcd8e655c52d03$var$Y) for(c = $3bfcd8e655c52d03$var$Y.return; null !== c;){
        var d = c;
        $3bfcd8e655c52d03$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3bfcd8e655c52d03$var$$f();
                break;
            case 3:
                $3bfcd8e655c52d03$var$zh();
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
                $3bfcd8e655c52d03$var$Eh();
                break;
            case 5:
                $3bfcd8e655c52d03$var$Bh(d);
                break;
            case 4:
                $3bfcd8e655c52d03$var$zh();
                break;
            case 13:
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
                break;
            case 19:
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
                break;
            case 10:
                $3bfcd8e655c52d03$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3bfcd8e655c52d03$var$Hj();
        }
        c = c.return;
    }
    $3bfcd8e655c52d03$var$Q = a;
    $3bfcd8e655c52d03$var$Y = a = $3bfcd8e655c52d03$var$Pg(a.current, null);
    $3bfcd8e655c52d03$var$Z = $3bfcd8e655c52d03$var$fj = b;
    $3bfcd8e655c52d03$var$T = 0;
    $3bfcd8e655c52d03$var$pk = null;
    $3bfcd8e655c52d03$var$rk = $3bfcd8e655c52d03$var$qk = $3bfcd8e655c52d03$var$rh = 0;
    $3bfcd8e655c52d03$var$tk = $3bfcd8e655c52d03$var$sk = null;
    if (null !== $3bfcd8e655c52d03$var$fh) {
        for(b = 0; b < $3bfcd8e655c52d03$var$fh.length; b++)if (c = $3bfcd8e655c52d03$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3bfcd8e655c52d03$var$fh = null;
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mk(a, b) {
    do {
        var c = $3bfcd8e655c52d03$var$Y;
        try {
            $3bfcd8e655c52d03$var$$g();
            $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Rh;
            if ($3bfcd8e655c52d03$var$Ih) {
                for(var d = $3bfcd8e655c52d03$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3bfcd8e655c52d03$var$Ih = !1;
            }
            $3bfcd8e655c52d03$var$Hh = 0;
            $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = $3bfcd8e655c52d03$var$M = null;
            $3bfcd8e655c52d03$var$Jh = !1;
            $3bfcd8e655c52d03$var$Kh = 0;
            $3bfcd8e655c52d03$var$nk.current = null;
            if (null === c || null === c.return) {
                $3bfcd8e655c52d03$var$T = 1;
                $3bfcd8e655c52d03$var$pk = b;
                $3bfcd8e655c52d03$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3bfcd8e655c52d03$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3bfcd8e655c52d03$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3bfcd8e655c52d03$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3bfcd8e655c52d03$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3bfcd8e655c52d03$var$Si(f, l, b);
                            $3bfcd8e655c52d03$var$tj();
                            break a;
                        }
                        k = Error($3bfcd8e655c52d03$var$p(426));
                    }
                } else if ($3bfcd8e655c52d03$var$I && h.mode & 1) {
                    var J = $3bfcd8e655c52d03$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3bfcd8e655c52d03$var$Vi(J, g, h, f, b);
                        $3bfcd8e655c52d03$var$Jg($3bfcd8e655c52d03$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3bfcd8e655c52d03$var$Ji(k, h);
                4 !== $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 2);
                null === $3bfcd8e655c52d03$var$sk ? $3bfcd8e655c52d03$var$sk = [
                    f
                ] : $3bfcd8e655c52d03$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3bfcd8e655c52d03$var$Ni(f, k, b);
                            $3bfcd8e655c52d03$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3bfcd8e655c52d03$var$Ri || !$3bfcd8e655c52d03$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3bfcd8e655c52d03$var$Qi(f, h, b);
                                $3bfcd8e655c52d03$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3bfcd8e655c52d03$var$Sk(c);
        } catch (na) {
            b = na;
            $3bfcd8e655c52d03$var$Y === c && null !== c && ($3bfcd8e655c52d03$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3bfcd8e655c52d03$var$Jk() {
    var a = $3bfcd8e655c52d03$var$mk.current;
    $3bfcd8e655c52d03$var$mk.current = $3bfcd8e655c52d03$var$Rh;
    return null === a ? $3bfcd8e655c52d03$var$Rh : a;
}
function $3bfcd8e655c52d03$var$tj() {
    if (0 === $3bfcd8e655c52d03$var$T || 3 === $3bfcd8e655c52d03$var$T || 2 === $3bfcd8e655c52d03$var$T) $3bfcd8e655c52d03$var$T = 4;
    null === $3bfcd8e655c52d03$var$Q || 0 === ($3bfcd8e655c52d03$var$rh & 268435455) && 0 === ($3bfcd8e655c52d03$var$qk & 268435455) || $3bfcd8e655c52d03$var$Ck($3bfcd8e655c52d03$var$Q, $3bfcd8e655c52d03$var$Z);
}
function $3bfcd8e655c52d03$var$Ik(a, b) {
    var c = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 2;
    var d = $3bfcd8e655c52d03$var$Jk();
    if ($3bfcd8e655c52d03$var$Q !== a || $3bfcd8e655c52d03$var$Z !== b) $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Kk(a, b);
    for(;;)try {
        $3bfcd8e655c52d03$var$Tk();
        break;
    } catch (e) {
        $3bfcd8e655c52d03$var$Mk(a, e);
    }
    $3bfcd8e655c52d03$var$$g();
    $3bfcd8e655c52d03$var$K = c;
    $3bfcd8e655c52d03$var$mk.current = d;
    if (null !== $3bfcd8e655c52d03$var$Y) throw Error($3bfcd8e655c52d03$var$p(261));
    $3bfcd8e655c52d03$var$Q = null;
    $3bfcd8e655c52d03$var$Z = 0;
    return $3bfcd8e655c52d03$var$T;
}
function $3bfcd8e655c52d03$var$Tk() {
    for(; null !== $3bfcd8e655c52d03$var$Y;)$3bfcd8e655c52d03$var$Uk($3bfcd8e655c52d03$var$Y);
}
function $3bfcd8e655c52d03$var$Lk() {
    for(; null !== $3bfcd8e655c52d03$var$Y && !$3bfcd8e655c52d03$var$cc();)$3bfcd8e655c52d03$var$Uk($3bfcd8e655c52d03$var$Y);
}
function $3bfcd8e655c52d03$var$Uk(a) {
    var b = $3bfcd8e655c52d03$var$Vk(a.alternate, a, $3bfcd8e655c52d03$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3bfcd8e655c52d03$var$Sk(a) : $3bfcd8e655c52d03$var$Y = b;
    $3bfcd8e655c52d03$var$nk.current = null;
}
function $3bfcd8e655c52d03$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3bfcd8e655c52d03$var$Ej(c, b, $3bfcd8e655c52d03$var$fj), null !== c) {
                $3bfcd8e655c52d03$var$Y = c;
                return;
            }
        } else {
            c = $3bfcd8e655c52d03$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3bfcd8e655c52d03$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3bfcd8e655c52d03$var$T = 6;
                $3bfcd8e655c52d03$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3bfcd8e655c52d03$var$Y = b;
            return;
        }
        $3bfcd8e655c52d03$var$Y = b = a;
    }while (null !== b);
    0 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 5);
}
function $3bfcd8e655c52d03$var$Pk(a, b, c) {
    var d = $3bfcd8e655c52d03$var$C, e = $3bfcd8e655c52d03$var$ok.transition;
    try {
        $3bfcd8e655c52d03$var$ok.transition = null, $3bfcd8e655c52d03$var$C = 1, $3bfcd8e655c52d03$var$Wk(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$ok.transition = e, $3bfcd8e655c52d03$var$C = d;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Wk(a, b, c, d) {
    do $3bfcd8e655c52d03$var$Hk();
    while (null !== $3bfcd8e655c52d03$var$wk);
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3bfcd8e655c52d03$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3bfcd8e655c52d03$var$Bc(a, f);
    a === $3bfcd8e655c52d03$var$Q && ($3bfcd8e655c52d03$var$Y = $3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3bfcd8e655c52d03$var$vk || ($3bfcd8e655c52d03$var$vk = !0, $3bfcd8e655c52d03$var$Fk($3bfcd8e655c52d03$var$hc, function() {
        $3bfcd8e655c52d03$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3bfcd8e655c52d03$var$ok.transition;
        $3bfcd8e655c52d03$var$ok.transition = null;
        var g = $3bfcd8e655c52d03$var$C;
        $3bfcd8e655c52d03$var$C = 1;
        var h = $3bfcd8e655c52d03$var$K;
        $3bfcd8e655c52d03$var$K |= 4;
        $3bfcd8e655c52d03$var$nk.current = null;
        $3bfcd8e655c52d03$var$Oj(a, c);
        $3bfcd8e655c52d03$var$dk(c, a);
        $3bfcd8e655c52d03$var$Oe($3bfcd8e655c52d03$var$Df);
        $3bfcd8e655c52d03$var$dd = !!$3bfcd8e655c52d03$var$Cf;
        $3bfcd8e655c52d03$var$Df = $3bfcd8e655c52d03$var$Cf = null;
        a.current = c;
        $3bfcd8e655c52d03$var$hk(c, a, e);
        $3bfcd8e655c52d03$var$dc();
        $3bfcd8e655c52d03$var$K = h;
        $3bfcd8e655c52d03$var$C = g;
        $3bfcd8e655c52d03$var$ok.transition = f;
    } else a.current = c;
    $3bfcd8e655c52d03$var$vk && ($3bfcd8e655c52d03$var$vk = !1, $3bfcd8e655c52d03$var$wk = a, $3bfcd8e655c52d03$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3bfcd8e655c52d03$var$Ri = null);
    $3bfcd8e655c52d03$var$mc(c.stateNode, d);
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3bfcd8e655c52d03$var$Oi) throw $3bfcd8e655c52d03$var$Oi = !1, a = $3bfcd8e655c52d03$var$Pi, $3bfcd8e655c52d03$var$Pi = null, a;
    0 !== ($3bfcd8e655c52d03$var$xk & 1) && 0 !== a.tag && $3bfcd8e655c52d03$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3bfcd8e655c52d03$var$zk ? $3bfcd8e655c52d03$var$yk++ : ($3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = a) : $3bfcd8e655c52d03$var$yk = 0;
    $3bfcd8e655c52d03$var$jg();
    return null;
}
function $3bfcd8e655c52d03$var$Hk() {
    if (null !== $3bfcd8e655c52d03$var$wk) {
        var a = $3bfcd8e655c52d03$var$Dc($3bfcd8e655c52d03$var$xk), b = $3bfcd8e655c52d03$var$ok.transition, c = $3bfcd8e655c52d03$var$C;
        try {
            $3bfcd8e655c52d03$var$ok.transition = null;
            $3bfcd8e655c52d03$var$C = 16 > a ? 16 : a;
            if (null === $3bfcd8e655c52d03$var$wk) var d = !1;
            else {
                a = $3bfcd8e655c52d03$var$wk;
                $3bfcd8e655c52d03$var$wk = null;
                $3bfcd8e655c52d03$var$xk = 0;
                if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(331));
                var e = $3bfcd8e655c52d03$var$K;
                $3bfcd8e655c52d03$var$K |= 4;
                for($3bfcd8e655c52d03$var$V = a.current; null !== $3bfcd8e655c52d03$var$V;){
                    var f = $3bfcd8e655c52d03$var$V, g = f.child;
                    if (0 !== ($3bfcd8e655c52d03$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3bfcd8e655c52d03$var$V = l; null !== $3bfcd8e655c52d03$var$V;){
                                    var m = $3bfcd8e655c52d03$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3bfcd8e655c52d03$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3bfcd8e655c52d03$var$V = q;
                                    else for(; null !== $3bfcd8e655c52d03$var$V;){
                                        m = $3bfcd8e655c52d03$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3bfcd8e655c52d03$var$Sj(m);
                                        if (m === l) {
                                            $3bfcd8e655c52d03$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3bfcd8e655c52d03$var$V = r;
                                            break;
                                        }
                                        $3bfcd8e655c52d03$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3bfcd8e655c52d03$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3bfcd8e655c52d03$var$V = g;
                    else b: for(; null !== $3bfcd8e655c52d03$var$V;){
                        f = $3bfcd8e655c52d03$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3bfcd8e655c52d03$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3bfcd8e655c52d03$var$V = x;
                            break b;
                        }
                        $3bfcd8e655c52d03$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3bfcd8e655c52d03$var$V = w; null !== $3bfcd8e655c52d03$var$V;){
                    g = $3bfcd8e655c52d03$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3bfcd8e655c52d03$var$V = u;
                    else b: for(g = w; null !== $3bfcd8e655c52d03$var$V;){
                        h = $3bfcd8e655c52d03$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3bfcd8e655c52d03$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3bfcd8e655c52d03$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3bfcd8e655c52d03$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3bfcd8e655c52d03$var$V = F;
                            break b;
                        }
                        $3bfcd8e655c52d03$var$V = h.return;
                    }
                }
                $3bfcd8e655c52d03$var$K = e;
                $3bfcd8e655c52d03$var$jg();
                if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onPostCommitFiberRoot) try {
                    $3bfcd8e655c52d03$var$lc.onPostCommitFiberRoot($3bfcd8e655c52d03$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3bfcd8e655c52d03$var$C = c, $3bfcd8e655c52d03$var$ok.transition = b;
        }
    }
    return !1;
}
function $3bfcd8e655c52d03$var$Xk(a, b, c) {
    b = $3bfcd8e655c52d03$var$Ji(c, b);
    b = $3bfcd8e655c52d03$var$Ni(a, b, 1);
    a = $3bfcd8e655c52d03$var$nh(a, b, 1);
    b = $3bfcd8e655c52d03$var$R();
    null !== a && ($3bfcd8e655c52d03$var$Ac(a, 1, b), $3bfcd8e655c52d03$var$Dk(a, b));
}
function $3bfcd8e655c52d03$var$W(a, b, c) {
    if (3 === a.tag) $3bfcd8e655c52d03$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3bfcd8e655c52d03$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3bfcd8e655c52d03$var$Ri || !$3bfcd8e655c52d03$var$Ri.has(d))) {
                a = $3bfcd8e655c52d03$var$Ji(c, a);
                a = $3bfcd8e655c52d03$var$Qi(b, a, 1);
                b = $3bfcd8e655c52d03$var$nh(b, a, 1);
                a = $3bfcd8e655c52d03$var$R();
                null !== b && ($3bfcd8e655c52d03$var$Ac(b, 1, a), $3bfcd8e655c52d03$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3bfcd8e655c52d03$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3bfcd8e655c52d03$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3bfcd8e655c52d03$var$Q === a && ($3bfcd8e655c52d03$var$Z & c) === c && (4 === $3bfcd8e655c52d03$var$T || 3 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$Z & 130023424) === $3bfcd8e655c52d03$var$Z && 500 > $3bfcd8e655c52d03$var$B() - $3bfcd8e655c52d03$var$fk ? $3bfcd8e655c52d03$var$Kk(a, 0) : $3bfcd8e655c52d03$var$rk |= c);
    $3bfcd8e655c52d03$var$Dk(a, b);
}
function $3bfcd8e655c52d03$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3bfcd8e655c52d03$var$sc, $3bfcd8e655c52d03$var$sc <<= 1, 0 === ($3bfcd8e655c52d03$var$sc & 130023424) && ($3bfcd8e655c52d03$var$sc = 4194304)));
    var c = $3bfcd8e655c52d03$var$R();
    a = $3bfcd8e655c52d03$var$ih(a, b);
    null !== a && ($3bfcd8e655c52d03$var$Ac(a, b, c), $3bfcd8e655c52d03$var$Dk(a, c));
}
function $3bfcd8e655c52d03$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3bfcd8e655c52d03$var$Yk(a, c);
}
function $3bfcd8e655c52d03$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3bfcd8e655c52d03$var$p(314));
    }
    null !== d && d.delete(b);
    $3bfcd8e655c52d03$var$Yk(a, c);
}
var $3bfcd8e655c52d03$var$Vk;
$3bfcd8e655c52d03$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3bfcd8e655c52d03$var$Wf.current) $3bfcd8e655c52d03$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3bfcd8e655c52d03$var$dh = !1, $3bfcd8e655c52d03$var$yj(a, b, c);
            $3bfcd8e655c52d03$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3bfcd8e655c52d03$var$dh = !1, $3bfcd8e655c52d03$var$I && 0 !== (b.flags & 1048576) && $3bfcd8e655c52d03$var$ug(b, $3bfcd8e655c52d03$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3bfcd8e655c52d03$var$ij(a, b);
            a = b.pendingProps;
            var e = $3bfcd8e655c52d03$var$Yf(b, $3bfcd8e655c52d03$var$H.current);
            $3bfcd8e655c52d03$var$ch(b, c);
            e = $3bfcd8e655c52d03$var$Nh(null, b, d, a, e, c);
            var f = $3bfcd8e655c52d03$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3bfcd8e655c52d03$var$Zf(d) ? (f = !0, $3bfcd8e655c52d03$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3bfcd8e655c52d03$var$kh(b), e.updater = $3bfcd8e655c52d03$var$Ei, b.stateNode = e, e._reactInternals = b, $3bfcd8e655c52d03$var$Ii(b, d, a, c), b = $3bfcd8e655c52d03$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3bfcd8e655c52d03$var$I && f && $3bfcd8e655c52d03$var$vg(b), $3bfcd8e655c52d03$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3bfcd8e655c52d03$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3bfcd8e655c52d03$var$Zk(d);
                a = $3bfcd8e655c52d03$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3bfcd8e655c52d03$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3bfcd8e655c52d03$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3bfcd8e655c52d03$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3bfcd8e655c52d03$var$$i(null, b, d, $3bfcd8e655c52d03$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3bfcd8e655c52d03$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3bfcd8e655c52d03$var$kj(b);
                if (null === a) throw Error($3bfcd8e655c52d03$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3bfcd8e655c52d03$var$lh(a, b);
                $3bfcd8e655c52d03$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3bfcd8e655c52d03$var$Ji(Error($3bfcd8e655c52d03$var$p(423)), b);
                        b = $3bfcd8e655c52d03$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3bfcd8e655c52d03$var$Ji(Error($3bfcd8e655c52d03$var$p(424)), b);
                        b = $3bfcd8e655c52d03$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(b.stateNode.containerInfo.firstChild), $3bfcd8e655c52d03$var$xg = b, $3bfcd8e655c52d03$var$I = !0, $3bfcd8e655c52d03$var$zg = null, c = $3bfcd8e655c52d03$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3bfcd8e655c52d03$var$Ig();
                    if (d === e) {
                        b = $3bfcd8e655c52d03$var$Zi(a, b, c);
                        break a;
                    }
                    $3bfcd8e655c52d03$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3bfcd8e655c52d03$var$Ah(b), null === a && $3bfcd8e655c52d03$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3bfcd8e655c52d03$var$Ef(d, e) ? g = null : null !== f && $3bfcd8e655c52d03$var$Ef(d, f) && (b.flags |= 32), $3bfcd8e655c52d03$var$gj(a, b), $3bfcd8e655c52d03$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3bfcd8e655c52d03$var$Eg(b), null;
        case 13:
            return $3bfcd8e655c52d03$var$oj(a, b, c);
        case 4:
            return $3bfcd8e655c52d03$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3bfcd8e655c52d03$var$Ug(b, null, d, c) : $3bfcd8e655c52d03$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$Yi(a, b, d, e, c);
        case 7:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3bfcd8e655c52d03$var$He(f.value, g)) {
                        if (f.children === e.children && !$3bfcd8e655c52d03$var$Wf.current) {
                            b = $3bfcd8e655c52d03$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3bfcd8e655c52d03$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3bfcd8e655c52d03$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3bfcd8e655c52d03$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3bfcd8e655c52d03$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3bfcd8e655c52d03$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3bfcd8e655c52d03$var$ch(b, c), e = $3bfcd8e655c52d03$var$eh(e), d = d(e), b.flags |= 1, $3bfcd8e655c52d03$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3bfcd8e655c52d03$var$Ci(d, b.pendingProps), e = $3bfcd8e655c52d03$var$Ci(d.type, e), $3bfcd8e655c52d03$var$$i(a, b, d, e, c);
        case 15:
            return $3bfcd8e655c52d03$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$ij(a, b), b.tag = 1, $3bfcd8e655c52d03$var$Zf(d) ? (a = !0, $3bfcd8e655c52d03$var$cg(b)) : a = !1, $3bfcd8e655c52d03$var$ch(b, c), $3bfcd8e655c52d03$var$Gi(b, d, e), $3bfcd8e655c52d03$var$Ii(b, d, e, c), $3bfcd8e655c52d03$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3bfcd8e655c52d03$var$xj(a, b, c);
        case 22:
            return $3bfcd8e655c52d03$var$dj(a, b, c);
    }
    throw Error($3bfcd8e655c52d03$var$p(156, b.tag));
};
function $3bfcd8e655c52d03$var$Fk(a, b) {
    return $3bfcd8e655c52d03$var$ac(a, b);
}
function $3bfcd8e655c52d03$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3bfcd8e655c52d03$var$Bg(a, b, c, d) {
    return new $3bfcd8e655c52d03$var$$k(a, b, c, d);
}
function $3bfcd8e655c52d03$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3bfcd8e655c52d03$var$Zk(a) {
    if ("function" === typeof a) return $3bfcd8e655c52d03$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3bfcd8e655c52d03$var$Da) return 11;
        if (a === $3bfcd8e655c52d03$var$Ga) return 14;
    }
    return 2;
}
function $3bfcd8e655c52d03$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3bfcd8e655c52d03$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3bfcd8e655c52d03$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3bfcd8e655c52d03$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3bfcd8e655c52d03$var$ya:
            return $3bfcd8e655c52d03$var$Tg(c.children, e, f, b);
        case $3bfcd8e655c52d03$var$za:
            g = 8;
            e |= 8;
            break;
        case $3bfcd8e655c52d03$var$Aa:
            return a = $3bfcd8e655c52d03$var$Bg(12, c, b, e | 2), a.elementType = $3bfcd8e655c52d03$var$Aa, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Ea:
            return a = $3bfcd8e655c52d03$var$Bg(13, c, b, e), a.elementType = $3bfcd8e655c52d03$var$Ea, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Fa:
            return a = $3bfcd8e655c52d03$var$Bg(19, c, b, e), a.elementType = $3bfcd8e655c52d03$var$Fa, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Ia:
            return $3bfcd8e655c52d03$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3bfcd8e655c52d03$var$Ba:
                    g = 10;
                    break a;
                case $3bfcd8e655c52d03$var$Ca:
                    g = 9;
                    break a;
                case $3bfcd8e655c52d03$var$Da:
                    g = 11;
                    break a;
                case $3bfcd8e655c52d03$var$Ga:
                    g = 14;
                    break a;
                case $3bfcd8e655c52d03$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3bfcd8e655c52d03$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3bfcd8e655c52d03$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3bfcd8e655c52d03$var$Tg(a, b, c, d) {
    a = $3bfcd8e655c52d03$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3bfcd8e655c52d03$var$pj(a, b, c, d) {
    a = $3bfcd8e655c52d03$var$Bg(22, a, d, b);
    a.elementType = $3bfcd8e655c52d03$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3bfcd8e655c52d03$var$Qg(a, b, c) {
    a = $3bfcd8e655c52d03$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3bfcd8e655c52d03$var$Sg(a, b, c) {
    b = $3bfcd8e655c52d03$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3bfcd8e655c52d03$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3bfcd8e655c52d03$var$zc(0);
    this.expirationTimes = $3bfcd8e655c52d03$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3bfcd8e655c52d03$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3bfcd8e655c52d03$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3bfcd8e655c52d03$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3bfcd8e655c52d03$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3bfcd8e655c52d03$var$kh(f);
    return a;
}
function $3bfcd8e655c52d03$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3bfcd8e655c52d03$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3bfcd8e655c52d03$var$dl(a) {
    if (!a) return $3bfcd8e655c52d03$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3bfcd8e655c52d03$var$Vb(a) !== a || 1 !== a.tag) throw Error($3bfcd8e655c52d03$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3bfcd8e655c52d03$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3bfcd8e655c52d03$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3bfcd8e655c52d03$var$Zf(c)) return $3bfcd8e655c52d03$var$bg(a, c, b);
    }
    return b;
}
function $3bfcd8e655c52d03$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3bfcd8e655c52d03$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3bfcd8e655c52d03$var$dl(null);
    c = a.current;
    d = $3bfcd8e655c52d03$var$R();
    e = $3bfcd8e655c52d03$var$yi(c);
    f = $3bfcd8e655c52d03$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3bfcd8e655c52d03$var$nh(c, f, e);
    a.current.lanes = e;
    $3bfcd8e655c52d03$var$Ac(a, e, d);
    $3bfcd8e655c52d03$var$Dk(a, d);
    return a;
}
function $3bfcd8e655c52d03$var$fl(a, b, c, d) {
    var e = b.current, f = $3bfcd8e655c52d03$var$R(), g = $3bfcd8e655c52d03$var$yi(e);
    c = $3bfcd8e655c52d03$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3bfcd8e655c52d03$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3bfcd8e655c52d03$var$nh(e, b, g);
    null !== a && ($3bfcd8e655c52d03$var$gi(a, e, g, f), $3bfcd8e655c52d03$var$oh(a, e, g));
    return g;
}
function $3bfcd8e655c52d03$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3bfcd8e655c52d03$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3bfcd8e655c52d03$var$il(a, b) {
    $3bfcd8e655c52d03$var$hl(a, b);
    (a = a.alternate) && $3bfcd8e655c52d03$var$hl(a, b);
}
function $3bfcd8e655c52d03$var$jl() {
    return null;
}
var $3bfcd8e655c52d03$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3bfcd8e655c52d03$var$ll(a) {
    this._internalRoot = a;
}
$3bfcd8e655c52d03$var$ml.prototype.render = $3bfcd8e655c52d03$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3bfcd8e655c52d03$var$p(409));
    $3bfcd8e655c52d03$var$fl(a, b, null, null);
};
$3bfcd8e655c52d03$var$ml.prototype.unmount = $3bfcd8e655c52d03$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3bfcd8e655c52d03$var$Rk(function() {
            $3bfcd8e655c52d03$var$fl(null, a, null, null);
        });
        b[$3bfcd8e655c52d03$var$uf] = null;
    }
};
function $3bfcd8e655c52d03$var$ml(a) {
    this._internalRoot = a;
}
$3bfcd8e655c52d03$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3bfcd8e655c52d03$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3bfcd8e655c52d03$var$Qc.length && 0 !== b && b < $3bfcd8e655c52d03$var$Qc[c].priority; c++);
        $3bfcd8e655c52d03$var$Qc.splice(c, 0, a);
        0 === c && $3bfcd8e655c52d03$var$Vc(a);
    }
};
function $3bfcd8e655c52d03$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3bfcd8e655c52d03$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3bfcd8e655c52d03$var$pl() {}
function $3bfcd8e655c52d03$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3bfcd8e655c52d03$var$gl(g);
                f.call(a);
            };
        }
        var g = $3bfcd8e655c52d03$var$el(b, d, a, 0, null, !1, !1, "", $3bfcd8e655c52d03$var$pl);
        a._reactRootContainer = g;
        a[$3bfcd8e655c52d03$var$uf] = g.current;
        $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3bfcd8e655c52d03$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3bfcd8e655c52d03$var$gl(k);
            h.call(a);
        };
    }
    var k = $3bfcd8e655c52d03$var$bl(a, 0, !1, null, null, !1, !1, "", $3bfcd8e655c52d03$var$pl);
    a._reactRootContainer = k;
    a[$3bfcd8e655c52d03$var$uf] = k.current;
    $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3bfcd8e655c52d03$var$Rk(function() {
        $3bfcd8e655c52d03$var$fl(b, k, c, d);
    });
    return k;
}
function $3bfcd8e655c52d03$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3bfcd8e655c52d03$var$gl(g);
                h.call(a);
            };
        }
        $3bfcd8e655c52d03$var$fl(b, g, a, e);
    } else g = $3bfcd8e655c52d03$var$ql(c, b, a, e, d);
    return $3bfcd8e655c52d03$var$gl(g);
}
$3bfcd8e655c52d03$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3bfcd8e655c52d03$var$tc(b.pendingLanes);
                0 !== c && ($3bfcd8e655c52d03$var$Cc(b, c | 1), $3bfcd8e655c52d03$var$Dk(b, $3bfcd8e655c52d03$var$B()), 0 === ($3bfcd8e655c52d03$var$K & 6) && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$jg()));
            }
            break;
        case 13:
            $3bfcd8e655c52d03$var$Rk(function() {
                var b = $3bfcd8e655c52d03$var$ih(a, 1);
                if (null !== b) {
                    var c = $3bfcd8e655c52d03$var$R();
                    $3bfcd8e655c52d03$var$gi(b, a, 1, c);
                }
            }), $3bfcd8e655c52d03$var$il(a, 1);
    }
};
$3bfcd8e655c52d03$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3bfcd8e655c52d03$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3bfcd8e655c52d03$var$R();
            $3bfcd8e655c52d03$var$gi(b, a, 134217728, c);
        }
        $3bfcd8e655c52d03$var$il(a, 134217728);
    }
};
$3bfcd8e655c52d03$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3bfcd8e655c52d03$var$yi(a), c = $3bfcd8e655c52d03$var$ih(a, b);
        if (null !== c) {
            var d = $3bfcd8e655c52d03$var$R();
            $3bfcd8e655c52d03$var$gi(c, a, b, d);
        }
        $3bfcd8e655c52d03$var$il(a, b);
    }
};
$3bfcd8e655c52d03$var$Hc = function() {
    return $3bfcd8e655c52d03$var$C;
};
$3bfcd8e655c52d03$var$Ic = function(a, b) {
    var c = $3bfcd8e655c52d03$var$C;
    try {
        return $3bfcd8e655c52d03$var$C = a, b();
    } finally{
        $3bfcd8e655c52d03$var$C = c;
    }
};
$3bfcd8e655c52d03$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3bfcd8e655c52d03$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3bfcd8e655c52d03$var$Db(d);
                        if (!e) throw Error($3bfcd8e655c52d03$var$p(90));
                        $3bfcd8e655c52d03$var$Wa(d);
                        $3bfcd8e655c52d03$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3bfcd8e655c52d03$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3bfcd8e655c52d03$var$fb(a, !!c.multiple, b, !1);
    }
};
$3bfcd8e655c52d03$var$Gb = $3bfcd8e655c52d03$var$Qk;
$3bfcd8e655c52d03$var$Hb = $3bfcd8e655c52d03$var$Rk;
var $3bfcd8e655c52d03$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3bfcd8e655c52d03$var$Cb,
        $3bfcd8e655c52d03$var$ue,
        $3bfcd8e655c52d03$var$Db,
        $3bfcd8e655c52d03$var$Eb,
        $3bfcd8e655c52d03$var$Fb,
        $3bfcd8e655c52d03$var$Qk
    ]
}, $3bfcd8e655c52d03$var$tl = {
    findFiberByHostInstance: $3bfcd8e655c52d03$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3bfcd8e655c52d03$var$ul = {
    bundleType: $3bfcd8e655c52d03$var$tl.bundleType,
    version: $3bfcd8e655c52d03$var$tl.version,
    rendererPackageName: $3bfcd8e655c52d03$var$tl.rendererPackageName,
    rendererConfig: $3bfcd8e655c52d03$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3bfcd8e655c52d03$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3bfcd8e655c52d03$var$tl.findFiberByHostInstance || $3bfcd8e655c52d03$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3bfcd8e655c52d03$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3bfcd8e655c52d03$var$vl.isDisabled && $3bfcd8e655c52d03$var$vl.supportsFiber) try {
        $3bfcd8e655c52d03$var$kc = $3bfcd8e655c52d03$var$vl.inject($3bfcd8e655c52d03$var$ul), $3bfcd8e655c52d03$var$lc = $3bfcd8e655c52d03$var$vl;
    } catch (a) {}
}
$3bfcd8e655c52d03$export$ae55be85d98224ed = $3bfcd8e655c52d03$var$sl;
$3bfcd8e655c52d03$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3bfcd8e655c52d03$var$nl(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$cl(a, b, null, c);
};
$3bfcd8e655c52d03$export$882461b6382ed46c = function(a, b) {
    if (!$3bfcd8e655c52d03$var$nl(a)) throw Error($3bfcd8e655c52d03$var$p(299));
    var c = !1, d = "", e = $3bfcd8e655c52d03$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3bfcd8e655c52d03$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3bfcd8e655c52d03$var$uf] = b.current;
    $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3bfcd8e655c52d03$var$ll(b);
};
$3bfcd8e655c52d03$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3bfcd8e655c52d03$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3bfcd8e655c52d03$var$p(268, a));
    }
    a = $3bfcd8e655c52d03$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3bfcd8e655c52d03$export$cd75ccfd720a3cd4 = function(a) {
    return $3bfcd8e655c52d03$var$Rk(a);
};
$3bfcd8e655c52d03$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$ol(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$rl(null, a, b, !0, c);
};
$3bfcd8e655c52d03$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$nl(a)) throw Error($3bfcd8e655c52d03$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3bfcd8e655c52d03$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3bfcd8e655c52d03$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3bfcd8e655c52d03$var$uf] = b.current;
    $3bfcd8e655c52d03$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3bfcd8e655c52d03$var$ml(b);
};
$3bfcd8e655c52d03$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$ol(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$rl(null, a, b, !1, c);
};
$3bfcd8e655c52d03$export$502457920280e6be = function(a) {
    if (!$3bfcd8e655c52d03$var$ol(a)) throw Error($3bfcd8e655c52d03$var$p(40));
    return a._reactRootContainer ? ($3bfcd8e655c52d03$var$Rk(function() {
        $3bfcd8e655c52d03$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3bfcd8e655c52d03$var$uf] = null;
        });
    }), !0) : !1;
};
$3bfcd8e655c52d03$export$c78a37762a8d58e1 = $3bfcd8e655c52d03$var$Qk;
$3bfcd8e655c52d03$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3bfcd8e655c52d03$var$ol(c)) throw Error($3bfcd8e655c52d03$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3bfcd8e655c52d03$var$p(38));
    return $3bfcd8e655c52d03$var$rl(a, b, c, !1, d);
};
$3bfcd8e655c52d03$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9kLo3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6gNJm"));

});
parcelRegister("6gNJm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $490ad02655eeb816$export$c4744153514ff05d; }, function (v) { return $490ad02655eeb816$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $490ad02655eeb816$export$3e506c1ccc9cc1a7; }, function (v) { return $490ad02655eeb816$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $490ad02655eeb816$export$e26fe2ed2fa76875; }, function (v) { return $490ad02655eeb816$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $490ad02655eeb816$export$502329bbf4b505b1; }, function (v) { return $490ad02655eeb816$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $490ad02655eeb816$export$6e3807111c4874c4; }, function (v) { return $490ad02655eeb816$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $490ad02655eeb816$export$c27134553091fb3a; }, function (v) { return $490ad02655eeb816$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $490ad02655eeb816$export$33ee1acdc04fd2a2; }, function (v) { return $490ad02655eeb816$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $490ad02655eeb816$export$b00a404bbd5edef2; }, function (v) { return $490ad02655eeb816$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $490ad02655eeb816$export$8352ce38b91d0c62; }, function (v) { return $490ad02655eeb816$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $490ad02655eeb816$export$d66a1c1c77bd778b; }, function (v) { return $490ad02655eeb816$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $490ad02655eeb816$export$d3dfb8e4810cb555; }, function (v) { return $490ad02655eeb816$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $490ad02655eeb816$export$839f9183b0465a69; }, function (v) { return $490ad02655eeb816$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $490ad02655eeb816$export$72fdf0e06517287b; }, function (v) { return $490ad02655eeb816$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $490ad02655eeb816$export$4b844e58a3e414b4; }, function (v) { return $490ad02655eeb816$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $490ad02655eeb816$export$816d2913ae6b83b1; }, function (v) { return $490ad02655eeb816$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $490ad02655eeb816$export$61bcfe829111a1d0; }, function (v) { return $490ad02655eeb816$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $490ad02655eeb816$export$7ee8c9beb337bc3f; }, function (v) { return $490ad02655eeb816$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $490ad02655eeb816$export$b5836b71941fa3ed; }, function (v) { return $490ad02655eeb816$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $490ad02655eeb816$export$cf845f2c119da08a; }, function (v) { return $490ad02655eeb816$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $490ad02655eeb816$export$c4744153514ff05d;
var $490ad02655eeb816$export$3e506c1ccc9cc1a7;
var $490ad02655eeb816$export$e26fe2ed2fa76875;
var $490ad02655eeb816$export$502329bbf4b505b1;
var $490ad02655eeb816$export$6e3807111c4874c4;
var $490ad02655eeb816$export$c27134553091fb3a;
var $490ad02655eeb816$export$33ee1acdc04fd2a2;
var $490ad02655eeb816$export$b00a404bbd5edef2;
var $490ad02655eeb816$export$8352ce38b91d0c62;
var $490ad02655eeb816$export$d66a1c1c77bd778b;
var $490ad02655eeb816$export$d3dfb8e4810cb555;
var $490ad02655eeb816$export$839f9183b0465a69;
var $490ad02655eeb816$export$72fdf0e06517287b;
var $490ad02655eeb816$export$4b844e58a3e414b4;
var $490ad02655eeb816$export$816d2913ae6b83b1;
var $490ad02655eeb816$export$61bcfe829111a1d0;
var $490ad02655eeb816$export$7ee8c9beb337bc3f;
var $490ad02655eeb816$export$b5836b71941fa3ed;
var $490ad02655eeb816$export$cf845f2c119da08a;
"use strict";
function $490ad02655eeb816$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $490ad02655eeb816$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $490ad02655eeb816$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $490ad02655eeb816$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $490ad02655eeb816$var$g(C, c)) n < e && 0 > $490ad02655eeb816$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $490ad02655eeb816$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $490ad02655eeb816$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $490ad02655eeb816$var$l = performance;
    $490ad02655eeb816$export$c4744153514ff05d = function() {
        return $490ad02655eeb816$var$l.now();
    };
} else {
    var $490ad02655eeb816$var$p = Date, $490ad02655eeb816$var$q = $490ad02655eeb816$var$p.now();
    $490ad02655eeb816$export$c4744153514ff05d = function() {
        return $490ad02655eeb816$var$p.now() - $490ad02655eeb816$var$q;
    };
}
var $490ad02655eeb816$var$r = [], $490ad02655eeb816$var$t = [], $490ad02655eeb816$var$u = 1, $490ad02655eeb816$var$v = null, $490ad02655eeb816$var$y = 3, $490ad02655eeb816$var$z = !1, $490ad02655eeb816$var$A = !1, $490ad02655eeb816$var$B = !1, $490ad02655eeb816$var$D = "function" === typeof setTimeout ? setTimeout : null, $490ad02655eeb816$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $490ad02655eeb816$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $490ad02655eeb816$var$G(a) {
    for(var b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t); null !== b;){
        if (null === b.callback) $490ad02655eeb816$var$k($490ad02655eeb816$var$t);
        else if (b.startTime <= a) $490ad02655eeb816$var$k($490ad02655eeb816$var$t), b.sortIndex = b.expirationTime, $490ad02655eeb816$var$f($490ad02655eeb816$var$r, b);
        else break;
        b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
    }
}
function $490ad02655eeb816$var$H(a) {
    $490ad02655eeb816$var$B = !1;
    $490ad02655eeb816$var$G(a);
    if (!$490ad02655eeb816$var$A) {
        if (null !== $490ad02655eeb816$var$h($490ad02655eeb816$var$r)) $490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J);
        else {
            var b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
            null !== b && $490ad02655eeb816$var$K($490ad02655eeb816$var$H, b.startTime - a);
        }
    }
}
function $490ad02655eeb816$var$J(a, b) {
    $490ad02655eeb816$var$A = !1;
    $490ad02655eeb816$var$B && ($490ad02655eeb816$var$B = !1, $490ad02655eeb816$var$E($490ad02655eeb816$var$L), $490ad02655eeb816$var$L = -1);
    $490ad02655eeb816$var$z = !0;
    var c = $490ad02655eeb816$var$y;
    try {
        $490ad02655eeb816$var$G(b);
        for($490ad02655eeb816$var$v = $490ad02655eeb816$var$h($490ad02655eeb816$var$r); null !== $490ad02655eeb816$var$v && (!($490ad02655eeb816$var$v.expirationTime > b) || a && !$490ad02655eeb816$var$M());){
            var d = $490ad02655eeb816$var$v.callback;
            if ("function" === typeof d) {
                $490ad02655eeb816$var$v.callback = null;
                $490ad02655eeb816$var$y = $490ad02655eeb816$var$v.priorityLevel;
                var e = d($490ad02655eeb816$var$v.expirationTime <= b);
                b = $490ad02655eeb816$export$c4744153514ff05d();
                "function" === typeof e ? $490ad02655eeb816$var$v.callback = e : $490ad02655eeb816$var$v === $490ad02655eeb816$var$h($490ad02655eeb816$var$r) && $490ad02655eeb816$var$k($490ad02655eeb816$var$r);
                $490ad02655eeb816$var$G(b);
            } else $490ad02655eeb816$var$k($490ad02655eeb816$var$r);
            $490ad02655eeb816$var$v = $490ad02655eeb816$var$h($490ad02655eeb816$var$r);
        }
        if (null !== $490ad02655eeb816$var$v) var w = !0;
        else {
            var m = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
            null !== m && $490ad02655eeb816$var$K($490ad02655eeb816$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $490ad02655eeb816$var$v = null, $490ad02655eeb816$var$y = c, $490ad02655eeb816$var$z = !1;
    }
}
var $490ad02655eeb816$var$N = !1, $490ad02655eeb816$var$O = null, $490ad02655eeb816$var$L = -1, $490ad02655eeb816$var$P = 5, $490ad02655eeb816$var$Q = -1;
function $490ad02655eeb816$var$M() {
    return $490ad02655eeb816$export$c4744153514ff05d() - $490ad02655eeb816$var$Q < $490ad02655eeb816$var$P ? !1 : !0;
}
function $490ad02655eeb816$var$R() {
    if (null !== $490ad02655eeb816$var$O) {
        var a = $490ad02655eeb816$export$c4744153514ff05d();
        $490ad02655eeb816$var$Q = a;
        var b = !0;
        try {
            b = $490ad02655eeb816$var$O(!0, a);
        } finally{
            b ? $490ad02655eeb816$var$S() : ($490ad02655eeb816$var$N = !1, $490ad02655eeb816$var$O = null);
        }
    } else $490ad02655eeb816$var$N = !1;
}
var $490ad02655eeb816$var$S;
if ("function" === typeof $490ad02655eeb816$var$F) $490ad02655eeb816$var$S = function() {
    $490ad02655eeb816$var$F($490ad02655eeb816$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $490ad02655eeb816$var$T = new MessageChannel, $490ad02655eeb816$var$U = $490ad02655eeb816$var$T.port2;
    $490ad02655eeb816$var$T.port1.onmessage = $490ad02655eeb816$var$R;
    $490ad02655eeb816$var$S = function() {
        $490ad02655eeb816$var$U.postMessage(null);
    };
} else $490ad02655eeb816$var$S = function() {
    $490ad02655eeb816$var$D($490ad02655eeb816$var$R, 0);
};
function $490ad02655eeb816$var$I(a) {
    $490ad02655eeb816$var$O = a;
    $490ad02655eeb816$var$N || ($490ad02655eeb816$var$N = !0, $490ad02655eeb816$var$S());
}
function $490ad02655eeb816$var$K(a, b) {
    $490ad02655eeb816$var$L = $490ad02655eeb816$var$D(function() {
        a($490ad02655eeb816$export$c4744153514ff05d());
    }, b);
}
$490ad02655eeb816$export$3e506c1ccc9cc1a7 = 5;
$490ad02655eeb816$export$e26fe2ed2fa76875 = 1;
$490ad02655eeb816$export$502329bbf4b505b1 = 4;
$490ad02655eeb816$export$6e3807111c4874c4 = 3;
$490ad02655eeb816$export$c27134553091fb3a = null;
$490ad02655eeb816$export$33ee1acdc04fd2a2 = 2;
$490ad02655eeb816$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$490ad02655eeb816$export$8352ce38b91d0c62 = function() {
    $490ad02655eeb816$var$A || $490ad02655eeb816$var$z || ($490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J));
};
$490ad02655eeb816$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $490ad02655eeb816$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$490ad02655eeb816$export$d3dfb8e4810cb555 = function() {
    return $490ad02655eeb816$var$y;
};
$490ad02655eeb816$export$839f9183b0465a69 = function() {
    return $490ad02655eeb816$var$h($490ad02655eeb816$var$r);
};
$490ad02655eeb816$export$72fdf0e06517287b = function(a) {
    switch($490ad02655eeb816$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $490ad02655eeb816$var$y;
    }
    var c = $490ad02655eeb816$var$y;
    $490ad02655eeb816$var$y = b;
    try {
        return a();
    } finally{
        $490ad02655eeb816$var$y = c;
    }
};
$490ad02655eeb816$export$4b844e58a3e414b4 = function() {};
$490ad02655eeb816$export$816d2913ae6b83b1 = function() {};
$490ad02655eeb816$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $490ad02655eeb816$var$y;
    $490ad02655eeb816$var$y = a;
    try {
        return b();
    } finally{
        $490ad02655eeb816$var$y = c;
    }
};
$490ad02655eeb816$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $490ad02655eeb816$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $490ad02655eeb816$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $490ad02655eeb816$var$f($490ad02655eeb816$var$t, a), null === $490ad02655eeb816$var$h($490ad02655eeb816$var$r) && a === $490ad02655eeb816$var$h($490ad02655eeb816$var$t) && ($490ad02655eeb816$var$B ? ($490ad02655eeb816$var$E($490ad02655eeb816$var$L), $490ad02655eeb816$var$L = -1) : $490ad02655eeb816$var$B = !0, $490ad02655eeb816$var$K($490ad02655eeb816$var$H, c - d))) : (a.sortIndex = e, $490ad02655eeb816$var$f($490ad02655eeb816$var$r, a), $490ad02655eeb816$var$A || $490ad02655eeb816$var$z || ($490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J)));
    return a;
};
$490ad02655eeb816$export$b5836b71941fa3ed = $490ad02655eeb816$var$M;
$490ad02655eeb816$export$cf845f2c119da08a = function(a) {
    var b = $490ad02655eeb816$var$y;
    return function() {
        var c = $490ad02655eeb816$var$y;
        $490ad02655eeb816$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $490ad02655eeb816$var$y = c;
        }
    };
};

});



parcelRegister("1PAIo", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $155708affa38be82$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $155708affa38be82$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useBeforeUnload", function () { return $155708affa38be82$export$c0a586b329cae57d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("9B9bN")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("9B9bN")).useNavigate; });
/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");

var $lMGip = parcelRequire("lMGip");
var $9B9bN = parcelRequire("9B9bN");

var $lMGip = parcelRequire("lMGip");
function $155708affa38be82$var$_extends() {
    $155708affa38be82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $155708affa38be82$var$_extends.apply(this, arguments);
}
function $155708affa38be82$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $155708affa38be82$var$defaultMethod = "get";
const $155708affa38be82$var$defaultEncType = "application/x-www-form-urlencoded";
function $155708affa38be82$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $155708affa38be82$var$isButtonElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $155708affa38be82$var$isFormElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $155708affa38be82$var$isInputElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $155708affa38be82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $155708affa38be82$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$155708affa38be82$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $155708affa38be82$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $155708affa38be82$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $155708affa38be82$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $155708affa38be82$var$_formDataSupportsSubmitter = null;
function $155708affa38be82$var$isFormDataSubmitterSupported() {
    if ($155708affa38be82$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $155708affa38be82$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $155708affa38be82$var$_formDataSupportsSubmitter = true;
    }
    return $155708affa38be82$var$_formDataSupportsSubmitter;
}
const $155708affa38be82$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $155708affa38be82$var$getFormEncType(encType) {
    if (encType != null && !$155708affa38be82$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $155708affa38be82$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($155708affa38be82$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $lMGip.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $155708affa38be82$var$defaultMethod;
        encType = $155708affa38be82$var$getFormEncType(target.getAttribute("enctype")) || $155708affa38be82$var$defaultEncType;
        formData = new FormData(target);
    } else if ($155708affa38be82$var$isButtonElement(target) || $155708affa38be82$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $lMGip.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $155708affa38be82$var$defaultMethod;
        encType = $155708affa38be82$var$getFormEncType(target.getAttribute("formenctype")) || $155708affa38be82$var$getFormEncType(form.getAttribute("enctype")) || $155708affa38be82$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$155708affa38be82$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($155708affa38be82$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $155708affa38be82$var$defaultMethod;
        action = null;
        encType = $155708affa38be82$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $155708affa38be82$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $155708affa38be82$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $155708affa38be82$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $155708affa38be82$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $155708affa38be82$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $155708affa38be82$export$1f3f55432a00e06d(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $155708affa38be82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $155708affa38be82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9B9bN.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $155708affa38be82$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $155708affa38be82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $155708affa38be82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9B9bN.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $155708affa38be82$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $155708affa38be82$var$_extends({}, state, {
        errors: $155708affa38be82$var$deserializeErrors(state.errors)
    });
    return state;
}
function $155708affa38be82$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $lMGip.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $155708affa38be82$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eZVvM.createContext({
    isTransitioning: false
});
const $155708affa38be82$export$148fd98d095596d4 = /*#__PURE__*/ $eZVvM.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $155708affa38be82$var$START_TRANSITION = "startTransition";
const $155708affa38be82$var$startTransitionImpl = $eZVvM[$155708affa38be82$var$START_TRANSITION];
const $155708affa38be82$var$FLUSH_SYNC = "flushSync";
const $155708affa38be82$var$flushSyncImpl = $e4ZGj[$155708affa38be82$var$FLUSH_SYNC];
const $155708affa38be82$var$USE_ID = "useId";
const $155708affa38be82$var$useIdImpl = $eZVvM[$155708affa38be82$var$USE_ID];
function $155708affa38be82$var$startTransitionSafe(cb) {
    if ($155708affa38be82$var$startTransitionImpl) $155708affa38be82$var$startTransitionImpl(cb);
    else cb();
}
function $155708affa38be82$var$flushSyncSafe(cb) {
    if ($155708affa38be82$var$flushSyncImpl) $155708affa38be82$var$flushSyncImpl(cb);
    else cb();
}
class $155708affa38be82$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $155708affa38be82$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eZVvM.useState(router.state);
    let [pendingState, setPendingState] = $eZVvM.useState();
    let [vtContext, setVtContext] = $eZVvM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eZVvM.useState();
    let [transition, setTransition] = $eZVvM.useState();
    let [interruption, setInterruption] = $eZVvM.useState();
    let fetcherData = $eZVvM.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eZVvM.useCallback((cb)=>{
        if (v7_startTransition) $155708affa38be82$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eZVvM.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $155708affa38be82$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $155708affa38be82$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $155708affa38be82$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $155708affa38be82$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $155708affa38be82$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eZVvM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eZVvM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $155708affa38be82$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eZVvM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eZVvM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eZVvM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eZVvM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eZVvM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eZVvM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $eZVvM.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $155708affa38be82$var$MemoizedDataRoutes = /*#__PURE__*/ $eZVvM.memo($155708affa38be82$var$DataRoutes);
function $155708affa38be82$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $9B9bN.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $155708affa38be82$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $155708affa38be82$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $155708affa38be82$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $155708affa38be82$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $155708affa38be82$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $155708affa38be82$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eZVvM.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref7, $155708affa38be82$var$_excluded);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $155708affa38be82$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($155708affa38be82$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $lMGip.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $9B9bN.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $155708affa38be82$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eZVvM.createElement("a", $155708affa38be82$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $155708affa38be82$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eZVvM.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref8, $155708affa38be82$var$_excluded2);
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $9B9bN.useLocation)();
    let routerState = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $155708affa38be82$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $lMGip.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$a6c7ac8248d6e38a, $155708affa38be82$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $155708affa38be82$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eZVvM.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $155708affa38be82$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref9, $155708affa38be82$var$_excluded3);
    let submit = $155708affa38be82$export$47c85c6e3a081d3();
    let formAction = $155708affa38be82$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $eZVvM.createElement("form", $155708affa38be82$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $155708affa38be82$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $155708affa38be82$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $155708affa38be82$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($155708affa38be82$var$DataRouterHook || ($155708affa38be82$var$DataRouterHook = {}));
var $155708affa38be82$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($155708affa38be82$var$DataRouterStateHook || ($155708affa38be82$var$DataRouterStateHook = {}));
// Internal hooks
function $155708affa38be82$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $155708affa38be82$var$useDataRouterContext(hookName) {
    let ctx = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterContext));
    !ctx && (0, $lMGip.UNSAFE_invariant)(false);
    return ctx;
}
function $155708affa38be82$var$useDataRouterState(hookName) {
    let state = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterStateContext));
    !state && (0, $lMGip.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $155708affa38be82$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9B9bN.useNavigate)();
    let location = (0, $9B9bN.useLocation)();
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: relative
    });
    return $eZVvM.useCallback((event)=>{
        if ($155708affa38be82$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $lMGip.createPath)(location) === (0, $lMGip.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $155708affa38be82$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eZVvM.useRef($155708affa38be82$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eZVvM.useRef(false);
    let location = (0, $9B9bN.useLocation)();
    let searchParams = $eZVvM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $155708affa38be82$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9B9bN.useNavigate)();
    let setSearchParams = $eZVvM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $155708affa38be82$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $155708affa38be82$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $155708affa38be82$var$fetcherId = 0;
let $155708affa38be82$var$getUniqueFetcherId = ()=>"__" + String(++$155708affa38be82$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $155708affa38be82$export$47c85c6e3a081d3() {
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let currentRouteId = (0, $9B9bN.UNSAFE_useRouteId)();
    return $eZVvM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $155708affa38be82$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $155708affa38be82$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $155708affa38be82$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $155708affa38be82$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let routeContext = $eZVvM.useContext((0, $9B9bN.UNSAFE_RouteContext));
    !routeContext && (0, $lMGip.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $155708affa38be82$var$_extends({}, (0, $9B9bN.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9B9bN.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $lMGip.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $lMGip.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $155708affa38be82$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseFetcher);
    let state = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eZVvM.useContext($155708affa38be82$export$148fd98d095596d4);
    let route = $eZVvM.useContext((0, $9B9bN.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $lMGip.UNSAFE_invariant)(false);
    !route && (0, $lMGip.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $lMGip.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $155708affa38be82$var$useIdImpl ? $155708affa38be82$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eZVvM.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($155708affa38be82$var$getUniqueFetcherId());
    // Registration/cleanup
    $eZVvM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eZVvM.useCallback((href, opts)=>{
        !routeId && (0, $lMGip.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $155708affa38be82$export$47c85c6e3a081d3();
    let submit = $eZVvM.useCallback((target, opts)=>{
        submitImpl(target, $155708affa38be82$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eZVvM.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eZVvM.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$a7fed597f4b8afd8, $155708affa38be82$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $lMGip.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eZVvM.useMemo(()=>$155708affa38be82$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $155708affa38be82$export$fa996778a3a31087() {
    let state = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $155708affa38be82$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $155708affa38be82$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $155708affa38be82$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let location = (0, $9B9bN.useLocation)();
    let matches = (0, $9B9bN.useMatches)();
    let navigation = (0, $9B9bN.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $eZVvM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $155708affa38be82$var$usePageHide($eZVvM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $155708affa38be82$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($155708affa38be82$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $155708affa38be82$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($155708affa38be82$var$_extends({}, location, {
                    pathname: (0, $lMGip.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($155708affa38be82$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $155708affa38be82$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eZVvM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $155708affa38be82$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eZVvM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $155708affa38be82$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $9B9bN.useBlocker)(when);
    $eZVvM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eZVvM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $155708affa38be82$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eZVvM.useContext($155708affa38be82$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $lMGip.UNSAFE_invariant)(false);
    let { basename: basename } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.useViewTransitionState);
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $lMGip.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $lMGip.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $lMGip.matchPath)(path.pathname, nextPath) != null || (0, $lMGip.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("e4ZGj", function(module, exports) {
"use strict";
function $a401490b67f1055b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a401490b67f1055b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a401490b67f1055b$var$checkDCE();

module.exports = (parcelRequire("59jpj"));

});

parcelRegister("lMGip", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $fdbee3c530e2e75a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $fdbee3c530e2e75a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $fdbee3c530e2e75a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $fdbee3c530e2e75a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $fdbee3c530e2e75a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $fdbee3c530e2e75a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $fdbee3c530e2e75a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $fdbee3c530e2e75a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $fdbee3c530e2e75a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $fdbee3c530e2e75a$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $fdbee3c530e2e75a$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $fdbee3c530e2e75a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $fdbee3c530e2e75a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $fdbee3c530e2e75a$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $fdbee3c530e2e75a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $fdbee3c530e2e75a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $fdbee3c530e2e75a$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $fdbee3c530e2e75a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $fdbee3c530e2e75a$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $fdbee3c530e2e75a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $fdbee3c530e2e75a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $fdbee3c530e2e75a$var$_extends() {
    $fdbee3c530e2e75a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdbee3c530e2e75a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $fdbee3c530e2e75a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($fdbee3c530e2e75a$export$e19cd5f9376f8cee || ($fdbee3c530e2e75a$export$e19cd5f9376f8cee = {}));
const $fdbee3c530e2e75a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $fdbee3c530e2e75a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $fdbee3c530e2e75a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fdbee3c530e2e75a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $fdbee3c530e2e75a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $fdbee3c530e2e75a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
    }
    return $fdbee3c530e2e75a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $fdbee3c530e2e75a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fdbee3c530e2e75a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $fdbee3c530e2e75a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fdbee3c530e2e75a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fdbee3c530e2e75a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $fdbee3c530e2e75a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $fdbee3c530e2e75a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $fdbee3c530e2e75a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $fdbee3c530e2e75a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fdbee3c530e2e75a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $fdbee3c530e2e75a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fdbee3c530e2e75a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($fdbee3c530e2e75a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        let location = $fdbee3c530e2e75a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fdbee3c530e2e75a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        let location = $fdbee3c530e2e75a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fdbee3c530e2e75a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($fdbee3c530e2e75a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($fdbee3c530e2e75a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $fdbee3c530e2e75a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($fdbee3c530e2e75a$var$ResultType || ($fdbee3c530e2e75a$var$ResultType = {}));
const $fdbee3c530e2e75a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fdbee3c530e2e75a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $fdbee3c530e2e75a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($fdbee3c530e2e75a$var$isIndexRoute(route)) {
            let indexRoute = $fdbee3c530e2e75a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $fdbee3c530e2e75a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $fdbee3c530e2e75a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $fdbee3c530e2e75a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fdbee3c530e2e75a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fdbee3c530e2e75a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fdbee3c530e2e75a$var$flattenRoutes(routes);
    $fdbee3c530e2e75a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $fdbee3c530e2e75a$export$30d21fd6d7295f52(pathname);
        matches = $fdbee3c530e2e75a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fdbee3c530e2e75a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fdbee3c530e2e75a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fdbee3c530e2e75a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $fdbee3c530e2e75a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fdbee3c530e2e75a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $fdbee3c530e2e75a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $fdbee3c530e2e75a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fdbee3c530e2e75a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fdbee3c530e2e75a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $fdbee3c530e2e75a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $fdbee3c530e2e75a$var$paramRe = /^:[\w-]+$/;
const $fdbee3c530e2e75a$var$dynamicSegmentValue = 3;
const $fdbee3c530e2e75a$var$indexRouteValue = 2;
const $fdbee3c530e2e75a$var$emptySegmentValue = 1;
const $fdbee3c530e2e75a$var$staticSegmentValue = 10;
const $fdbee3c530e2e75a$var$splatPenalty = -2;
const $fdbee3c530e2e75a$var$isSplat = (s)=>s === "*";
function $fdbee3c530e2e75a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fdbee3c530e2e75a$var$isSplat)) initialScore += $fdbee3c530e2e75a$var$splatPenalty;
    if (index) initialScore += $fdbee3c530e2e75a$var$indexRouteValue;
    return segments.filter((s)=>!$fdbee3c530e2e75a$var$isSplat(s)).reduce((score, segment)=>score + ($fdbee3c530e2e75a$var$paramRe.test(segment) ? $fdbee3c530e2e75a$var$dynamicSegmentValue : segment === "" ? $fdbee3c530e2e75a$var$emptySegmentValue : $fdbee3c530e2e75a$var$staticSegmentValue), initialScore);
}
function $fdbee3c530e2e75a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fdbee3c530e2e75a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fdbee3c530e2e75a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fdbee3c530e2e75a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fdbee3c530e2e75a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fdbee3c530e2e75a$export$a5c6d149b50c1d86($fdbee3c530e2e75a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fdbee3c530e2e75a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $fdbee3c530e2e75a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fdbee3c530e2e75a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $fdbee3c530e2e75a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fdbee3c530e2e75a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fdbee3c530e2e75a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $fdbee3c530e2e75a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $fdbee3c530e2e75a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $fdbee3c530e2e75a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fdbee3c530e2e75a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fdbee3c530e2e75a$var$normalizeSearch(search),
        hash: $fdbee3c530e2e75a$var$normalizeHash(hash)
    };
}
function $fdbee3c530e2e75a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fdbee3c530e2e75a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $fdbee3c530e2e75a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $fdbee3c530e2e75a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $fdbee3c530e2e75a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $fdbee3c530e2e75a$var$_extends({}, toArg);
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $fdbee3c530e2e75a$var$getInvalidPathError("?", "pathname", "search", to));
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $fdbee3c530e2e75a$var$getInvalidPathError("#", "pathname", "hash", to));
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $fdbee3c530e2e75a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fdbee3c530e2e75a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $fdbee3c530e2e75a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $fdbee3c530e2e75a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $fdbee3c530e2e75a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $fdbee3c530e2e75a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $fdbee3c530e2e75a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $fdbee3c530e2e75a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $fdbee3c530e2e75a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $fdbee3c530e2e75a$export$4051a07651545597(data, init) {
    return new $fdbee3c530e2e75a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $fdbee3c530e2e75a$export$42a99a7a4bc0e76a extends Error {
}
class $fdbee3c530e2e75a$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $fdbee3c530e2e75a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $fdbee3c530e2e75a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $fdbee3c530e2e75a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $fdbee3c530e2e75a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $fdbee3c530e2e75a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $fdbee3c530e2e75a$var$unwrapTrackedPromise(value) {
    if (!$fdbee3c530e2e75a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $fdbee3c530e2e75a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $fdbee3c530e2e75a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $fdbee3c530e2e75a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fdbee3c530e2e75a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fdbee3c530e2e75a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $fdbee3c530e2e75a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $fdbee3c530e2e75a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $fdbee3c530e2e75a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $fdbee3c530e2e75a$var$validMutationMethods = new Set($fdbee3c530e2e75a$var$validMutationMethodsArr);
const $fdbee3c530e2e75a$var$validRequestMethodsArr = [
    "get",
    ...$fdbee3c530e2e75a$var$validMutationMethodsArr
];
const $fdbee3c530e2e75a$var$validRequestMethods = new Set($fdbee3c530e2e75a$var$validRequestMethodsArr);
const $fdbee3c530e2e75a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $fdbee3c530e2e75a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $fdbee3c530e2e75a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdbee3c530e2e75a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdbee3c530e2e75a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $fdbee3c530e2e75a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $fdbee3c530e2e75a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $fdbee3c530e2e75a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdbee3c530e2e75a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $fdbee3c530e2e75a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $fdbee3c530e2e75a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fdbee3c530e2e75a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $fdbee3c530e2e75a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fdbee3c530e2e75a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $fdbee3c530e2e75a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fdbee3c530e2e75a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $fdbee3c530e2e75a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fdbee3c530e2e75a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $fdbee3c530e2e75a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fdbee3c530e2e75a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fdbee3c530e2e75a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($fdbee3c530e2e75a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fdbee3c530e2e75a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fdbee3c530e2e75a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $fdbee3c530e2e75a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fdbee3c530e2e75a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $fdbee3c530e2e75a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fdbee3c530e2e75a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $fdbee3c530e2e75a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fdbee3c530e2e75a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $fdbee3c530e2e75a$var$findNearestBoundary(matches).route.id,
            {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fdbee3c530e2e75a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fdbee3c530e2e75a$var$isErrorResult(result) && $fdbee3c530e2e75a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fdbee3c530e2e75a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $fdbee3c530e2e75a$var$_extends({
            matches: updatedMatches || matches
        }, $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $fdbee3c530e2e75a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdbee3c530e2e75a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $fdbee3c530e2e75a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $fdbee3c530e2e75a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $fdbee3c530e2e75a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $fdbee3c530e2e75a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $fdbee3c530e2e75a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $fdbee3c530e2e75a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($fdbee3c530e2e75a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdbee3c530e2e75a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $fdbee3c530e2e75a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $fdbee3c530e2e75a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $fdbee3c530e2e75a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $fdbee3c530e2e75a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $fdbee3c530e2e75a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $fdbee3c530e2e75a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fdbee3c530e2e75a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fdbee3c530e2e75a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fdbee3c530e2e75a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdbee3c530e2e75a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fdbee3c530e2e75a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($fdbee3c530e2e75a$var$isRedirectResult(actionResult) || $fdbee3c530e2e75a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($fdbee3c530e2e75a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fdbee3c530e2e75a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($fdbee3c530e2e75a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($fdbee3c530e2e75a$var$isDeferredResult(actionResult)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fdbee3c530e2e75a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $fdbee3c530e2e75a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $fdbee3c530e2e75a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $fdbee3c530e2e75a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $fdbee3c530e2e75a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdbee3c530e2e75a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fdbee3c530e2e75a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) result = await $fdbee3c530e2e75a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!$fdbee3c530e2e75a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $fdbee3c530e2e75a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fdbee3c530e2e75a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fdbee3c530e2e75a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace : $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fdbee3c530e2e75a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($fdbee3c530e2e75a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $fdbee3c530e2e75a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $fdbee3c530e2e75a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $fdbee3c530e2e75a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $fdbee3c530e2e75a$var$ResultType.redirect,
                response: $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $fdbee3c530e2e75a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $fdbee3c530e2e75a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $fdbee3c530e2e75a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $fdbee3c530e2e75a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fdbee3c530e2e75a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fdbee3c530e2e75a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fdbee3c530e2e75a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fdbee3c530e2e75a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $fdbee3c530e2e75a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $fdbee3c530e2e75a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $fdbee3c530e2e75a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$fdbee3c530e2e75a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $fdbee3c530e2e75a$export$4d0306f8f6a4585b = Symbol("deferred");
function $fdbee3c530e2e75a$export$3336b097a6fbc59a(routes, opts) {
    $fdbee3c530e2e75a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdbee3c530e2e75a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $fdbee3c530e2e75a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdbee3c530e2e75a$var$createLocation("", $fdbee3c530e2e75a$export$fe53371bee54353d(url), null, "default");
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdbee3c530e2e75a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($fdbee3c530e2e75a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $fdbee3c530e2e75a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdbee3c530e2e75a$var$createLocation("", $fdbee3c530e2e75a$export$fe53371bee54353d(url), null, "default");
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdbee3c530e2e75a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fdbee3c530e2e75a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fdbee3c530e2e75a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fdbee3c530e2e75a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($fdbee3c530e2e75a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$fdbee3c530e2e75a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $fdbee3c530e2e75a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fdbee3c530e2e75a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $fdbee3c530e2e75a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $fdbee3c530e2e75a$var$isResponse(result) ? result : $fdbee3c530e2e75a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($fdbee3c530e2e75a$var$isDataStrategyResult(e) && $fdbee3c530e2e75a$var$isResponse(e.result)) {
                if (e.type === $fdbee3c530e2e75a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($fdbee3c530e2e75a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($fdbee3c530e2e75a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fdbee3c530e2e75a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $fdbee3c530e2e75a$var$_extends({}, context, {
                statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $fdbee3c530e2e75a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $fdbee3c530e2e75a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $fdbee3c530e2e75a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategy || $fdbee3c530e2e75a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($fdbee3c530e2e75a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $fdbee3c530e2e75a$export$fec11da027c70692(routes, context, error) {
    let newContext = $fdbee3c530e2e75a$var$_extends({}, context, {
        statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $fdbee3c530e2e75a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $fdbee3c530e2e75a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $fdbee3c530e2e75a$export$cae722b0cc860f13(to ? to : ".", $fdbee3c530e2e75a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $fdbee3c530e2e75a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fdbee3c530e2e75a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fdbee3c530e2e75a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $fdbee3c530e2e75a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $fdbee3c530e2e75a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$fdbee3c530e2e75a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fdbee3c530e2e75a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fdbee3c530e2e75a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fdbee3c530e2e75a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $fdbee3c530e2e75a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$fdbee3c530e2e75a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$fdbee3c530e2e75a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fdbee3c530e2e75a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $fdbee3c530e2e75a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $fdbee3c530e2e75a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $fdbee3c530e2e75a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($fdbee3c530e2e75a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $fdbee3c530e2e75a$var$shouldRevalidateLoader(match, $fdbee3c530e2e75a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $fdbee3c530e2e75a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fdbee3c530e2e75a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $fdbee3c530e2e75a$var$shouldRevalidateLoader(fetcherMatch, $fdbee3c530e2e75a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $fdbee3c530e2e75a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $fdbee3c530e2e75a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fdbee3c530e2e75a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$fdbee3c530e2e75a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $fdbee3c530e2e75a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$fdbee3c530e2e75a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $fdbee3c530e2e75a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $fdbee3c530e2e75a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $fdbee3c530e2e75a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$fdbee3c530e2e75a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $fdbee3c530e2e75a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $fdbee3c530e2e75a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $fdbee3c530e2e75a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $fdbee3c530e2e75a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $fdbee3c530e2e75a$var$ResultType.data,
                result: undefined
            });
        };
        return $fdbee3c530e2e75a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $fdbee3c530e2e75a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $fdbee3c530e2e75a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $fdbee3c530e2e75a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fdbee3c530e2e75a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: e
            };
        }
        if (type === $fdbee3c530e2e75a$var$ResultType.error) return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: new $fdbee3c530e2e75a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $fdbee3c530e2e75a$var$ResultType.error) {
        if ($fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $fdbee3c530e2e75a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: result,
            statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($fdbee3c530e2e75a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $fdbee3c530e2e75a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $fdbee3c530e2e75a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $fdbee3c530e2e75a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fdbee3c530e2e75a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $fdbee3c530e2e75a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fdbee3c530e2e75a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $fdbee3c530e2e75a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fdbee3c530e2e75a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fdbee3c530e2e75a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!$fdbee3c530e2e75a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $fdbee3c530e2e75a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fdbee3c530e2e75a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $fdbee3c530e2e75a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($fdbee3c530e2e75a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $fdbee3c530e2e75a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($fdbee3c530e2e75a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $fdbee3c530e2e75a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fdbee3c530e2e75a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $fdbee3c530e2e75a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $fdbee3c530e2e75a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fdbee3c530e2e75a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fdbee3c530e2e75a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $fdbee3c530e2e75a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $fdbee3c530e2e75a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fdbee3c530e2e75a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path) : path;
    return $fdbee3c530e2e75a$export$fe53371bee54353d($fdbee3c530e2e75a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $fdbee3c530e2e75a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $fdbee3c530e2e75a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $fdbee3c530e2e75a$var$ResultType.data || result.type === $fdbee3c530e2e75a$var$ResultType.error);
}
function $fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result) {
    return $fdbee3c530e2e75a$var$isResponse(result.result) && $fdbee3c530e2e75a$var$redirectStatusCodes.has(result.result.status);
}
function $fdbee3c530e2e75a$var$isDeferredResult(result) {
    return result.type === $fdbee3c530e2e75a$var$ResultType.deferred;
}
function $fdbee3c530e2e75a$var$isErrorResult(result) {
    return result.type === $fdbee3c530e2e75a$var$ResultType.error;
}
function $fdbee3c530e2e75a$var$isRedirectResult(result) {
    return (result && result.type) === $fdbee3c530e2e75a$var$ResultType.redirect;
}
function $fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fdbee3c530e2e75a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $fdbee3c530e2e75a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fdbee3c530e2e75a$var$isRedirectResponse(result) {
    if (!$fdbee3c530e2e75a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $fdbee3c530e2e75a$var$isValidMethod(method) {
    return $fdbee3c530e2e75a$var$validRequestMethods.has(method.toLowerCase());
}
function $fdbee3c530e2e75a$var$isMutationMethod(method) {
    return $fdbee3c530e2e75a$var$validMutationMethods.has(method.toLowerCase());
}
async function $fdbee3c530e2e75a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$fdbee3c530e2e75a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($fdbee3c530e2e75a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $fdbee3c530e2e75a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $fdbee3c530e2e75a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $fdbee3c530e2e75a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $fdbee3c530e2e75a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $fdbee3c530e2e75a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $fdbee3c530e2e75a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $fdbee3c530e2e75a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fdbee3c530e2e75a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fdbee3c530e2e75a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $fdbee3c530e2e75a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fdbee3c530e2e75a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $fdbee3c530e2e75a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $fdbee3c530e2e75a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fdbee3c530e2e75a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $fdbee3c530e2e75a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $fdbee3c530e2e75a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $fdbee3c530e2e75a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $fdbee3c530e2e75a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fdbee3c530e2e75a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("9B9bN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6fceb28f277b924b$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6fceb28f277b924b$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6fceb28f277b924b$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6fceb28f277b924b$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6fceb28f277b924b$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6fceb28f277b924b$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6fceb28f277b924b$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $6fceb28f277b924b$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $6fceb28f277b924b$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $6fceb28f277b924b$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6fceb28f277b924b$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6fceb28f277b924b$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6fceb28f277b924b$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6fceb28f277b924b$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $6fceb28f277b924b$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $6fceb28f277b924b$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $6fceb28f277b924b$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $6fceb28f277b924b$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $6fceb28f277b924b$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $6fceb28f277b924b$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6fceb28f277b924b$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6fceb28f277b924b$export$52b333d321859367; });
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eZVvM = parcelRequire("eZVvM");

var $lMGip = parcelRequire("lMGip");
function $6fceb28f277b924b$var$_extends() {
    $6fceb28f277b924b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fceb28f277b924b$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6fceb28f277b924b$export$3add0d5dce533e2e = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$145dfa71566a64dc = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$var$AwaitContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6fceb28f277b924b$export$26749e8557646306 = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$c7914228fb69b0f5 = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$9072aa6dd1f93057 = /*#__PURE__*/ $eZVvM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6fceb28f277b924b$var$RouteErrorContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $6fceb28f277b924b$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6fceb28f277b924b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $lMGip.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $6fceb28f277b924b$export$9c954a9d03d32f4a() {
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $6fceb28f277b924b$export$45d76561a5302f2b() {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $6fceb28f277b924b$export$1b3f31771c5d07c() {
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $6fceb28f277b924b$export$6c330e8992e8a295(pattern) {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    return $eZVvM.useMemo(()=>(0, $lMGip.matchPath)(pattern, (0, $lMGip.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6fceb28f277b924b$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6fceb28f277b924b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eZVvM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $6fceb28f277b924b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6fceb28f277b924b$var$useNavigateStable() : $6fceb28f277b924b$var$useNavigateUnstable();
}
function $6fceb28f277b924b$var$useNavigateUnstable() {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let dataRouterContext = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eZVvM.useRef(false);
    $6fceb28f277b924b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eZVvM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $lMGip.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $lMGip.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6fceb28f277b924b$var$OutletContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $6fceb28f277b924b$export$4138103a3ae699cc() {
    return $eZVvM.useContext($6fceb28f277b924b$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $6fceb28f277b924b$export$a3be3530d8e40d0b(context) {
    let outlet = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $6fceb28f277b924b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $6fceb28f277b924b$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eZVvM.useMemo(()=>(0, $lMGip.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $6fceb28f277b924b$export$5d3fca4a98652595(routes, locationArg) {
    return $6fceb28f277b924b$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6fceb28f277b924b$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: parentMatches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6fceb28f277b924b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $lMGip.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $lMGip.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $lMGip.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6fceb28f277b924b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $lMGip.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $lMGip.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6fceb28f277b924b$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $lMGip.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6fceb28f277b924b$var$DefaultErrorComponent() {
    let error = $6fceb28f277b924b$export$ed527bf60f6e05f2();
    let message = (0, $lMGip.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eZVvM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eZVvM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6fceb28f277b924b$var$defaultErrorElement = /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$DefaultErrorComponent, null);
class $6fceb28f277b924b$var$RenderErrorBoundary extends $eZVvM.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $6fceb28f277b924b$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6fceb28f277b924b$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $lMGip.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6fceb28f277b924b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6fceb28f277b924b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eZVvM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6fceb28f277b924b$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6fceb28f277b924b$var$DataRouterHook || {});
var $6fceb28f277b924b$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6fceb28f277b924b$var$DataRouterStateHook || {});
function $6fceb28f277b924b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $6fceb28f277b924b$var$useDataRouterContext(hookName) {
    let ctx = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    !ctx && (0, $lMGip.UNSAFE_invariant)(false);
    return ctx;
}
function $6fceb28f277b924b$var$useDataRouterState(hookName) {
    let state = $eZVvM.useContext($6fceb28f277b924b$export$145dfa71566a64dc);
    !state && (0, $lMGip.UNSAFE_invariant)(false);
    return state;
}
function $6fceb28f277b924b$var$useRouteContext(hookName) {
    let route = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    !route && (0, $lMGip.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6fceb28f277b924b$var$useCurrentRouteId(hookName) {
    let route = $6fceb28f277b924b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $lMGip.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6fceb28f277b924b$export$5fc8298006ad9e58() {
    return $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6fceb28f277b924b$export$d0fd4b7106de2769() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6fceb28f277b924b$export$600dc272ed516c15() {
    let dataRouterContext = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseRevalidator);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRevalidator);
    return $eZVvM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6fceb28f277b924b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseMatches);
    return $eZVvM.useMemo(()=>matches.map((m)=>(0, $lMGip.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6fceb28f277b924b$export$1448a5050d252c4d() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6fceb28f277b924b$export$fd5d37484eab868d(routeId) {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6fceb28f277b924b$export$fdc00f3f26066d5e() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseActionData);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6fceb28f277b924b$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eZVvM.useContext($6fceb28f277b924b$var$RouteErrorContext);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRouteError);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6fceb28f277b924b$export$78a72ddb39bdd145() {
    let value = $eZVvM.useContext($6fceb28f277b924b$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6fceb28f277b924b$export$17f53340677d5831() {
    let value = $eZVvM.useContext($6fceb28f277b924b$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6fceb28f277b924b$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6fceb28f277b924b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseBlocker);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eZVvM.useState("");
    let blockerFunction = $eZVvM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6fceb28f277b924b$var$_extends({}, currentLocation, {
                pathname: (0, $lMGip.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6fceb28f277b924b$var$_extends({}, nextLocation, {
                pathname: (0, $lMGip.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eZVvM.useEffect(()=>{
        let key = String(++$6fceb28f277b924b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eZVvM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $lMGip.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6fceb28f277b924b$var$useNavigateStable() {
    let { router: router } = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseNavigateStable);
    let id = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eZVvM.useRef(false);
    $6fceb28f277b924b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eZVvM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6fceb28f277b924b$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6fceb28f277b924b$var$alreadyWarned$1 = {};
function $6fceb28f277b924b$var$warningOnce(key, cond, message) {
    if (!cond && !$6fceb28f277b924b$var$alreadyWarned$1[key]) $6fceb28f277b924b$var$alreadyWarned$1[key] = true;
}
const $6fceb28f277b924b$var$alreadyWarned = {};
function $6fceb28f277b924b$var$warnOnce(key, message) {
    if (!$6fceb28f277b924b$var$alreadyWarned[message]) {
        $6fceb28f277b924b$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $6fceb28f277b924b$var$logDeprecation = (flag, msg, link)=>$6fceb28f277b924b$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $6fceb28f277b924b$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $6fceb28f277b924b$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $6fceb28f277b924b$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $6fceb28f277b924b$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $6fceb28f277b924b$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $6fceb28f277b924b$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $6fceb28f277b924b$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6fceb28f277b924b$var$START_TRANSITION = "startTransition";
const $6fceb28f277b924b$var$startTransitionImpl = $eZVvM[$6fceb28f277b924b$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6fceb28f277b924b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eZVvM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        if (v7_startTransition && $6fceb28f277b924b$var$startTransitionImpl) $6fceb28f277b924b$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eZVvM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eZVvM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eZVvM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eZVvM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eZVvM.useEffect(()=>$6fceb28f277b924b$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6fceb28f277b924b$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6fceb28f277b924b$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $6fceb28f277b924b$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $6fceb28f277b924b$var$startTransitionImpl ? $6fceb28f277b924b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>$6fceb28f277b924b$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $6fceb28f277b924b$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let navigate = $6fceb28f277b924b$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $lMGip.resolveTo)(to, (0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eZVvM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $6fceb28f277b924b$export$910ae8079b2c2852(props) {
    return $6fceb28f277b924b$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $6fceb28f277b924b$export$e7b0ac011bb776c6(_props) {
    (0, $lMGip.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $6fceb28f277b924b$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $lMGip.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eZVvM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6fceb28f277b924b$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $lMGip.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eZVvM.useMemo(()=>{
        let trailingPathname = (0, $lMGip.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $6fceb28f277b924b$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6fceb28f277b924b$export$5d3fca4a98652595($6fceb28f277b924b$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6fceb28f277b924b$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$ResolveAwait, null, children));
}
var $6fceb28f277b924b$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6fceb28f277b924b$var$AwaitRenderStatus || {});
const $6fceb28f277b924b$var$neverSettledPromise = new Promise(()=>{});
class $6fceb28f277b924b$var$AwaitErrorBoundary extends $eZVvM.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6fceb28f277b924b$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6fceb28f277b924b$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6fceb28f277b924b$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6fceb28f277b924b$var$AwaitRenderStatus.error : "_data" in promise ? $6fceb28f277b924b$var$AwaitRenderStatus.success : $6fceb28f277b924b$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6fceb28f277b924b$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error && promise._error instanceof (0, $lMGip.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6fceb28f277b924b$var$neverSettledPromise;
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6fceb28f277b924b$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6fceb28f277b924b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $6fceb28f277b924b$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eZVvM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eZVvM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6fceb28f277b924b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6fceb28f277b924b$export$e7b0ac011bb776c6) && (0, $lMGip.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $lMGip.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6fceb28f277b924b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6fceb28f277b924b$export$daf73786167a7f72(matches) {
    return $6fceb28f277b924b$var$_renderMatches(matches);
}
function $6fceb28f277b924b$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eZVvM.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eZVvM.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eZVvM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6fceb28f277b924b$export$f30f7e456d254e83(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6fceb28f277b924b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6fceb28f277b924b$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("9H773", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $70eda5aa689a1ed0$export$bf730a2d8bf68b42; }, function (v) { return $70eda5aa689a1ed0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $70eda5aa689a1ed0$export$bf730a2d8bf68b42;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
function $70eda5aa689a1ed0$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $70eda5aa689a1ed0$var$p = "function" === typeof Object.is ? Object.is : $70eda5aa689a1ed0$var$n, $70eda5aa689a1ed0$var$q = $eZVvM.useSyncExternalStore, $70eda5aa689a1ed0$var$r = $eZVvM.useRef, $70eda5aa689a1ed0$var$t = $eZVvM.useEffect, $70eda5aa689a1ed0$var$u = $eZVvM.useMemo, $70eda5aa689a1ed0$var$v = $eZVvM.useDebugValue;
$70eda5aa689a1ed0$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $70eda5aa689a1ed0$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $70eda5aa689a1ed0$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($70eda5aa689a1ed0$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $70eda5aa689a1ed0$var$q(a, c[0], c[1]);
    $70eda5aa689a1ed0$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $70eda5aa689a1ed0$var$v(d);
    return d;
};

});

parcelRegister("8pLEx", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $khNKv = parcelRequire("khNKv");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $khNKv !== "undefined" && "env" in $khNKv) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("eGpRj"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("khNKv", function(module, exports) {
// shim for using process in browser
var $ec4bfc4f11980bc9$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ec4bfc4f11980bc9$var$cachedSetTimeout;
var $ec4bfc4f11980bc9$var$cachedClearTimeout;
function $ec4bfc4f11980bc9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ec4bfc4f11980bc9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ec4bfc4f11980bc9$var$cachedSetTimeout = setTimeout;
        else $ec4bfc4f11980bc9$var$cachedSetTimeout = $ec4bfc4f11980bc9$var$defaultSetTimout;
    } catch (e) {
        $ec4bfc4f11980bc9$var$cachedSetTimeout = $ec4bfc4f11980bc9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ec4bfc4f11980bc9$var$cachedClearTimeout = clearTimeout;
        else $ec4bfc4f11980bc9$var$cachedClearTimeout = $ec4bfc4f11980bc9$var$defaultClearTimeout;
    } catch (e) {
        $ec4bfc4f11980bc9$var$cachedClearTimeout = $ec4bfc4f11980bc9$var$defaultClearTimeout;
    }
})();
function $ec4bfc4f11980bc9$var$runTimeout(fun) {
    if ($ec4bfc4f11980bc9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ec4bfc4f11980bc9$var$cachedSetTimeout === $ec4bfc4f11980bc9$var$defaultSetTimout || !$ec4bfc4f11980bc9$var$cachedSetTimeout) && setTimeout) {
        $ec4bfc4f11980bc9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ec4bfc4f11980bc9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ec4bfc4f11980bc9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ec4bfc4f11980bc9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ec4bfc4f11980bc9$var$runClearTimeout(marker) {
    if ($ec4bfc4f11980bc9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ec4bfc4f11980bc9$var$cachedClearTimeout === $ec4bfc4f11980bc9$var$defaultClearTimeout || !$ec4bfc4f11980bc9$var$cachedClearTimeout) && clearTimeout) {
        $ec4bfc4f11980bc9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ec4bfc4f11980bc9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ec4bfc4f11980bc9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ec4bfc4f11980bc9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ec4bfc4f11980bc9$var$queue = [];
var $ec4bfc4f11980bc9$var$draining = false;
var $ec4bfc4f11980bc9$var$currentQueue;
var $ec4bfc4f11980bc9$var$queueIndex = -1;
function $ec4bfc4f11980bc9$var$cleanUpNextTick() {
    if (!$ec4bfc4f11980bc9$var$draining || !$ec4bfc4f11980bc9$var$currentQueue) return;
    $ec4bfc4f11980bc9$var$draining = false;
    if ($ec4bfc4f11980bc9$var$currentQueue.length) $ec4bfc4f11980bc9$var$queue = $ec4bfc4f11980bc9$var$currentQueue.concat($ec4bfc4f11980bc9$var$queue);
    else $ec4bfc4f11980bc9$var$queueIndex = -1;
    if ($ec4bfc4f11980bc9$var$queue.length) $ec4bfc4f11980bc9$var$drainQueue();
}
function $ec4bfc4f11980bc9$var$drainQueue() {
    if ($ec4bfc4f11980bc9$var$draining) return;
    var timeout = $ec4bfc4f11980bc9$var$runTimeout($ec4bfc4f11980bc9$var$cleanUpNextTick);
    $ec4bfc4f11980bc9$var$draining = true;
    var len = $ec4bfc4f11980bc9$var$queue.length;
    while(len){
        $ec4bfc4f11980bc9$var$currentQueue = $ec4bfc4f11980bc9$var$queue;
        $ec4bfc4f11980bc9$var$queue = [];
        while(++$ec4bfc4f11980bc9$var$queueIndex < len)if ($ec4bfc4f11980bc9$var$currentQueue) $ec4bfc4f11980bc9$var$currentQueue[$ec4bfc4f11980bc9$var$queueIndex].run();
        $ec4bfc4f11980bc9$var$queueIndex = -1;
        len = $ec4bfc4f11980bc9$var$queue.length;
    }
    $ec4bfc4f11980bc9$var$currentQueue = null;
    $ec4bfc4f11980bc9$var$draining = false;
    $ec4bfc4f11980bc9$var$runClearTimeout(timeout);
}
$ec4bfc4f11980bc9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ec4bfc4f11980bc9$var$queue.push(new $ec4bfc4f11980bc9$var$Item(fun, args));
    if ($ec4bfc4f11980bc9$var$queue.length === 1 && !$ec4bfc4f11980bc9$var$draining) $ec4bfc4f11980bc9$var$runTimeout($ec4bfc4f11980bc9$var$drainQueue);
};
// v8 likes predictible objects
function $ec4bfc4f11980bc9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ec4bfc4f11980bc9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ec4bfc4f11980bc9$var$process.title = "browser";
$ec4bfc4f11980bc9$var$process.browser = true;
$ec4bfc4f11980bc9$var$process.env = {};
$ec4bfc4f11980bc9$var$process.argv = [];
$ec4bfc4f11980bc9$var$process.version = ""; // empty string to avoid regexp issues
$ec4bfc4f11980bc9$var$process.versions = {};
function $ec4bfc4f11980bc9$var$noop() {}
$ec4bfc4f11980bc9$var$process.on = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.addListener = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.once = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.off = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.removeListener = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.removeAllListeners = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.emit = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.prependListener = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.prependOnceListener = $ec4bfc4f11980bc9$var$noop;
$ec4bfc4f11980bc9$var$process.listeners = function(name) {
    return [];
};
$ec4bfc4f11980bc9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ec4bfc4f11980bc9$var$process.cwd = function() {
    return "/";
};
$ec4bfc4f11980bc9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ec4bfc4f11980bc9$var$process.umask = function() {
    return 0;
};

});

parcelRegister("eGpRj", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $ab090bfb89b623de$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("7Fd0f"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $ab090bfb89b623de$var$setup;

});
parcelRegister("7Fd0f", function(module, exports) {
/**
 * Helpers.
 */ var $594672e3509bf904$var$s = 1000;
var $594672e3509bf904$var$m = $594672e3509bf904$var$s * 60;
var $594672e3509bf904$var$h = $594672e3509bf904$var$m * 60;
var $594672e3509bf904$var$d = $594672e3509bf904$var$h * 24;
var $594672e3509bf904$var$w = $594672e3509bf904$var$d * 7;
var $594672e3509bf904$var$y = $594672e3509bf904$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $594672e3509bf904$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $594672e3509bf904$var$fmtLong(val) : $594672e3509bf904$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $594672e3509bf904$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $594672e3509bf904$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $594672e3509bf904$var$w;
        case "days":
        case "day":
        case "d":
            return n * $594672e3509bf904$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $594672e3509bf904$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $594672e3509bf904$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $594672e3509bf904$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $594672e3509bf904$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $594672e3509bf904$var$d) return Math.round(ms / $594672e3509bf904$var$d) + "d";
    if (msAbs >= $594672e3509bf904$var$h) return Math.round(ms / $594672e3509bf904$var$h) + "h";
    if (msAbs >= $594672e3509bf904$var$m) return Math.round(ms / $594672e3509bf904$var$m) + "m";
    if (msAbs >= $594672e3509bf904$var$s) return Math.round(ms / $594672e3509bf904$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $594672e3509bf904$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $594672e3509bf904$var$d) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$d, "day");
    if (msAbs >= $594672e3509bf904$var$h) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$h, "hour");
    if (msAbs >= $594672e3509bf904$var$m) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$m, "minute");
    if (msAbs >= $594672e3509bf904$var$s) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $594672e3509bf904$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});



parcelRegister("46xMb", function(module, exports) {
"use strict";
var $2fd1ec2e40671a2b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fd1ec2e40671a2b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2fd1ec2e40671a2b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2fd1ec2e40671a2b$var$__createBinding(result, mod, k);
    }
    $2fd1ec2e40671a2b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Device = void 0;
module.exports.detectDevice = $2fd1ec2e40671a2b$var$detectDevice;

var $kCoWz = parcelRequire("kCoWz");

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");

const $2fd1ec2e40671a2b$var$utils = $2fd1ec2e40671a2b$var$__importStar((parcelRequire("lghrF")));

const $2fd1ec2e40671a2b$var$ortc = $2fd1ec2e40671a2b$var$__importStar((parcelRequire("5Mq2W")));

var $7Whb6 = parcelRequire("7Whb6");

var $4ZvCd = parcelRequire("4ZvCd");

var $3TLmn = parcelRequire("3TLmn");

var $8vSu0 = parcelRequire("8vSu0");

var $jTGls = parcelRequire("jTGls");

var $6oohh = parcelRequire("6oohh");

var $l1Nf1 = parcelRequire("l1Nf1");

var $a2Xk2 = parcelRequire("a2Xk2");

var $cqkQU = parcelRequire("cqkQU");

var $5TVIx = parcelRequire("5TVIx");

var $3HogQ = parcelRequire("3HogQ");

var $bcHUy = parcelRequire("bcHUy");

var $5GCJE = parcelRequire("5GCJE");
const $2fd1ec2e40671a2b$var$logger = new $24uNv.Logger("Device");
function $2fd1ec2e40671a2b$var$detectDevice() {
    // React-Native.
    // NOTE: react-native-webrtc >= 1.75.0 is required.
    // NOTE: react-native-webrtc with Unified Plan requires version >= 106.0.0.
    if (typeof navigator === "object" && navigator.product === "ReactNative") {
        $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | React-Native detected");
        if (typeof RTCPeerConnection === "undefined") {
            $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | unsupported react-native-webrtc without RTCPeerConnection, forgot to call registerGlobals()?");
            return undefined;
        }
        if (typeof RTCRtpTransceiver !== "undefined") {
            $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | ReactNative UnifiedPlan handler chosen");
            return "ReactNativeUnifiedPlan";
        } else {
            $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | ReactNative PlanB handler chosen");
            return "ReactNative";
        }
    } else if (typeof navigator === "object" && typeof navigator.userAgent === "string") {
        var _browser_name, _engine_name, _os_name, _device_model;
        const ua = navigator.userAgent;
        const uaParser = new $kCoWz.UAParser(ua);
        $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | browser detected [ua:%s, parsed:%o]", ua, uaParser.getResult());
        const browser = uaParser.getBrowser();
        const browserName = (_browser_name = browser.name) === null || _browser_name === void 0 ? void 0 : _browser_name.toLowerCase();
        var _browser_major;
        const browserVersion = parseInt((_browser_major = browser.major) !== null && _browser_major !== void 0 ? _browser_major : "0");
        const engine = uaParser.getEngine();
        const engineName = (_engine_name = engine.name) === null || _engine_name === void 0 ? void 0 : _engine_name.toLowerCase();
        const os = uaParser.getOS();
        const osName = (_os_name = os.name) === null || _os_name === void 0 ? void 0 : _os_name.toLowerCase();
        var _os_version;
        const osVersion = parseFloat((_os_version = os.version) !== null && _os_version !== void 0 ? _os_version : "0");
        const device = uaParser.getDevice();
        const deviceModel = (_device_model = device.model) === null || _device_model === void 0 ? void 0 : _device_model.toLowerCase();
        const isIOS = osName === "ios" || deviceModel === "ipad";
        const isChrome = browserName && [
            "chrome",
            "chromium",
            "mobile chrome",
            "chrome webview",
            "chrome headless"
        ].includes(browserName);
        const isFirefox = browserName && [
            "firefox",
            "mobile firefox",
            "mobile focus"
        ].includes(browserName);
        const isSafari = browserName && [
            "safari",
            "mobile safari"
        ].includes(browserName);
        const isEdge = browserName && [
            "edge"
        ].includes(browserName);
        // Chrome, Chromium, and Edge.
        if ((isChrome || isEdge) && !isIOS && browserVersion >= 111) return "Chrome111";
        else if (isChrome && !isIOS && browserVersion >= 74 || isEdge && !isIOS && browserVersion >= 88) return "Chrome74";
        else if (isChrome && !isIOS && browserVersion >= 70) return "Chrome70";
        else if (isChrome && !isIOS && browserVersion >= 67) return "Chrome67";
        else if (isChrome && !isIOS && browserVersion >= 55) return "Chrome55";
        else if (isFirefox && !isIOS && browserVersion >= 120) return "Firefox120";
        else if (isFirefox && !isIOS && browserVersion >= 60) return "Firefox60";
        else if (isFirefox && isIOS && osVersion >= 14.3) return "Safari12";
        else if (isSafari && browserVersion >= 12 && typeof RTCRtpTransceiver !== "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
        else if (isSafari && browserVersion >= 11) return "Safari11";
        else if (isEdge && !isIOS && browserVersion >= 11 && browserVersion <= 18) return "Edge11";
        else if (engineName === "webkit" && isIOS && typeof RTCRtpTransceiver !== "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
        else if (engineName === "blink") {
            const match = ua.match(/(?:(?:Chrome|Chromium))[ /](\w+)/i);
            if (match) {
                const version = Number(match[1]);
                if (version >= 111) return "Chrome111";
                else if (version >= 74) return "Chrome74";
                else if (version >= 70) return "Chrome70";
                else if (version >= 67) return "Chrome67";
                else return "Chrome55";
            } else return "Chrome111";
        } else {
            $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | browser not supported [name:%s, version:%s]", browserName, browserVersion);
            return undefined;
        }
    } else {
        $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | unknown device");
        return undefined;
    }
}
class $2fd1ec2e40671a2b$var$Device {
    /**
     * The RTC handler name.
     */ get handlerName() {
        return this._handlerName;
    }
    /**
     * Whether the Device is loaded.
     */ get loaded() {
        return this._loaded;
    }
    /**
     * RTP capabilities of the Device for receiving media.
     *
     * @throws {InvalidStateError} if not loaded.
     */ get rtpCapabilities() {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        return this._recvRtpCapabilities;
    }
    /**
     * SCTP capabilities of the Device.
     *
     * @throws {InvalidStateError} if not loaded.
     */ get sctpCapabilities() {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        return this._sctpCapabilities;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Initialize the Device.
     */ async load({ routerRtpCapabilities: routerRtpCapabilities }) {
        $2fd1ec2e40671a2b$var$logger.debug("load() [routerRtpCapabilities:%o]", routerRtpCapabilities);
        // Temporal handler to get its capabilities.
        let handler;
        try {
            if (this._loaded) throw new $roix3.InvalidStateError("already loaded");
            // Clone given router RTP capabilities to not modify input data.
            const clonedRouterRtpCapabilities = $2fd1ec2e40671a2b$var$utils.clone(routerRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(clonedRouterRtpCapabilities);
            handler = this._handlerFactory();
            const nativeRtpCapabilities = await handler.getNativeRtpCapabilities();
            $2fd1ec2e40671a2b$var$logger.debug("load() | got native RTP capabilities:%o", nativeRtpCapabilities);
            // Clone obtained native RTP capabilities to not modify input data.
            const clonedNativeRtpCapabilities = $2fd1ec2e40671a2b$var$utils.clone(nativeRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(clonedNativeRtpCapabilities);
            // Get extended RTP capabilities.
            this._extendedRtpCapabilities = $2fd1ec2e40671a2b$var$ortc.getExtendedRtpCapabilities(clonedNativeRtpCapabilities, clonedRouterRtpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() | got extended RTP capabilities:%o", this._extendedRtpCapabilities);
            // Check whether we can produce audio/video.
            this._canProduceByKind.audio = $2fd1ec2e40671a2b$var$ortc.canSend("audio", this._extendedRtpCapabilities);
            this._canProduceByKind.video = $2fd1ec2e40671a2b$var$ortc.canSend("video", this._extendedRtpCapabilities);
            // Generate our receiving RTP capabilities for receiving media.
            this._recvRtpCapabilities = $2fd1ec2e40671a2b$var$ortc.getRecvRtpCapabilities(this._extendedRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(this._recvRtpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() | got receiving RTP capabilities:%o", this._recvRtpCapabilities);
            // Generate our SCTP capabilities.
            this._sctpCapabilities = await handler.getNativeSctpCapabilities();
            $2fd1ec2e40671a2b$var$logger.debug("load() | got native SCTP capabilities:%o", this._sctpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateSctpCapabilities(this._sctpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() succeeded");
            this._loaded = true;
            handler.close();
        } catch (error) {
            if (handler) handler.close();
            throw error;
        }
    }
    /**
     * Whether we can produce audio/video.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ canProduce(kind) {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        else if (kind !== "audio" && kind !== "video") throw new TypeError(`invalid kind "${kind}"`);
        return this._canProduceByKind[kind];
    }
    /**
     * Creates a Transport for sending media.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ createSendTransport({ id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        $2fd1ec2e40671a2b$var$logger.debug("createSendTransport()");
        return this.createTransport({
            direction: "send",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData
        });
    }
    /**
     * Creates a Transport for receiving media.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ createRecvTransport({ id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        $2fd1ec2e40671a2b$var$logger.debug("createRecvTransport()");
        return this.createTransport({
            direction: "recv",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData
        });
    }
    createTransport({ direction: direction, id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof iceParameters !== "object") throw new TypeError("missing iceParameters");
        else if (!Array.isArray(iceCandidates)) throw new TypeError("missing iceCandidates");
        else if (typeof dtlsParameters !== "object") throw new TypeError("missing dtlsParameters");
        else if (sctpParameters && typeof sctpParameters !== "object") throw new TypeError("wrong sctpParameters");
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Create a new Transport.
        const transport = new $7Whb6.Transport({
            direction: direction,
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData,
            handlerFactory: this._handlerFactory,
            extendedRtpCapabilities: this._extendedRtpCapabilities,
            canProduceByKind: this._canProduceByKind
        });
        // Emit observer event.
        this._observer.safeEmit("newtransport", transport);
        return transport;
    }
    /**
     * Create a new Device to connect to mediasoup server.
     *
     * @throws {UnsupportedError} if device is not supported.
     */ constructor({ handlerName: handlerName, handlerFactory: handlerFactory, Handler: Handler } = {}){
        // Loaded flag.
        this._loaded = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $2fd1ec2e40671a2b$var$logger.debug("constructor()");
        // Handle deprecated option.
        if (Handler) {
            $2fd1ec2e40671a2b$var$logger.warn("constructor() | Handler option is DEPRECATED, use handlerName or handlerFactory instead");
            if (typeof Handler === "string") handlerName = Handler;
            else throw new TypeError("non string Handler option no longer supported, use handlerFactory instead");
        }
        if (handlerName && handlerFactory) throw new TypeError("just one of handlerName or handlerInterface can be given");
        if (handlerFactory) this._handlerFactory = handlerFactory;
        else {
            if (handlerName) $2fd1ec2e40671a2b$var$logger.debug("constructor() | handler given: %s", handlerName);
            else {
                handlerName = $2fd1ec2e40671a2b$var$detectDevice();
                if (handlerName) $2fd1ec2e40671a2b$var$logger.debug("constructor() | detected handler: %s", handlerName);
                else throw new $roix3.UnsupportedError("device not supported");
            }
            switch(handlerName){
                case "Chrome111":
                    this._handlerFactory = $4ZvCd.Chrome111.createFactory();
                    break;
                case "Chrome74":
                    this._handlerFactory = $3TLmn.Chrome74.createFactory();
                    break;
                case "Chrome70":
                    this._handlerFactory = $8vSu0.Chrome70.createFactory();
                    break;
                case "Chrome67":
                    this._handlerFactory = $jTGls.Chrome67.createFactory();
                    break;
                case "Chrome55":
                    this._handlerFactory = $6oohh.Chrome55.createFactory();
                    break;
                case "Firefox120":
                    this._handlerFactory = $l1Nf1.Firefox120.createFactory();
                    break;
                case "Firefox60":
                    this._handlerFactory = $a2Xk2.Firefox60.createFactory();
                    break;
                case "Safari12":
                    this._handlerFactory = $cqkQU.Safari12.createFactory();
                    break;
                case "Safari11":
                    this._handlerFactory = $5TVIx.Safari11.createFactory();
                    break;
                case "Edge11":
                    this._handlerFactory = $3HogQ.Edge11.createFactory();
                    break;
                case "ReactNativeUnifiedPlan":
                    this._handlerFactory = $bcHUy.ReactNativeUnifiedPlan.createFactory();
                    break;
                case "ReactNative":
                    this._handlerFactory = $5GCJE.ReactNative.createFactory();
                    break;
                default:
                    throw new TypeError(`unknown handlerName "${handlerName}"`);
            }
        }
        // Create a temporal handler to get its name.
        const handler = this._handlerFactory();
        this._handlerName = handler.name;
        handler.close();
        this._extendedRtpCapabilities = undefined;
        this._recvRtpCapabilities = undefined;
        this._canProduceByKind = {
            audio: false,
            video: false
        };
        this._sctpCapabilities = undefined;
    }
}
module.exports.Device = $2fd1ec2e40671a2b$var$Device;

});
parcelRegister("kCoWz", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.39
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.39", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360" + SUFFIX_BROWSER
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic)\/([\w\.]+)/i // Wolvic
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        "tablet": [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("24uNv", function(module, exports) {
"use strict";
var $1823d83dc217d87a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

const $1823d83dc217d87a$var$debug_1 = $1823d83dc217d87a$var$__importDefault((parcelRequire("8pLEx")));
const $1823d83dc217d87a$var$APP_NAME = "mediasoup-client";
class $1823d83dc217d87a$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:${prefix}`);
            this._warn = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:WARN:${prefix}`);
            this._error = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $1823d83dc217d87a$var$debug_1.default)($1823d83dc217d87a$var$APP_NAME);
            this._warn = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:WARN`);
            this._error = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $1823d83dc217d87a$var$Logger;

});

parcelRegister("bwd9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnhancedEventEmitter = void 0;

var $evB0H = parcelRequire("evB0H");

var $24uNv = parcelRequire("24uNv");
const $862ce27f66a74ba3$var$logger = new $24uNv.Logger("EnhancedEventEmitter");
class $862ce27f66a74ba3$var$EnhancedEventEmitter extends $evB0H.EventEmitter {
    emit(eventName, ...args) {
        return super.emit(eventName, ...args);
    }
    /**
     * Special addition to the EventEmitter API.
     */ safeEmit(eventName, ...args) {
        const numListeners = super.listenerCount(eventName);
        try {
            return super.emit(eventName, ...args);
        } catch (error) {
            $862ce27f66a74ba3$var$logger.error("safeEmit() | event listener threw an error [eventName:%s]:%o", eventName, error);
            return Boolean(numListeners);
        }
    }
    on(eventName, listener) {
        super.on(eventName, listener);
        return this;
    }
    off(eventName, listener) {
        super.off(eventName, listener);
        return this;
    }
    addListener(eventName, listener) {
        super.on(eventName, listener);
        return this;
    }
    prependListener(eventName, listener) {
        super.prependListener(eventName, listener);
        return this;
    }
    once(eventName, listener) {
        super.once(eventName, listener);
        return this;
    }
    prependOnceListener(eventName, listener) {
        super.prependOnceListener(eventName, listener);
        return this;
    }
    removeListener(eventName, listener) {
        super.off(eventName, listener);
        return this;
    }
    removeAllListeners(eventName) {
        super.removeAllListeners(eventName);
        return this;
    }
    listenerCount(eventName) {
        return super.listenerCount(eventName);
    }
    listeners(eventName) {
        return super.listeners(eventName);
    }
    rawListeners(eventName) {
        return super.rawListeners(eventName);
    }
    constructor(){
        super();
        this.setMaxListeners(Infinity);
    }
}
module.exports.EnhancedEventEmitter = $862ce27f66a74ba3$var$EnhancedEventEmitter;

});
parcelRegister("evB0H", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $a900ab6e8c8f61fb$var$R = typeof Reflect === "object" ? Reflect : null;
var $a900ab6e8c8f61fb$var$ReflectApply = $a900ab6e8c8f61fb$var$R && typeof $a900ab6e8c8f61fb$var$R.apply === "function" ? $a900ab6e8c8f61fb$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $a900ab6e8c8f61fb$var$ReflectOwnKeys;
if ($a900ab6e8c8f61fb$var$R && typeof $a900ab6e8c8f61fb$var$R.ownKeys === "function") $a900ab6e8c8f61fb$var$ReflectOwnKeys = $a900ab6e8c8f61fb$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $a900ab6e8c8f61fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $a900ab6e8c8f61fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $a900ab6e8c8f61fb$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $a900ab6e8c8f61fb$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $a900ab6e8c8f61fb$var$EventEmitter() {
    $a900ab6e8c8f61fb$var$EventEmitter.init.call(this);
}
module.exports = $a900ab6e8c8f61fb$var$EventEmitter;
module.exports.once = $a900ab6e8c8f61fb$var$once;
// Backwards-compat with node 0.10.x
$a900ab6e8c8f61fb$var$EventEmitter.EventEmitter = $a900ab6e8c8f61fb$var$EventEmitter;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._events = undefined;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._eventsCount = 0;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $a900ab6e8c8f61fb$var$defaultMaxListeners = 10;
function $a900ab6e8c8f61fb$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($a900ab6e8c8f61fb$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $a900ab6e8c8f61fb$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $a900ab6e8c8f61fb$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $a900ab6e8c8f61fb$var$defaultMaxListeners = arg;
    }
});
$a900ab6e8c8f61fb$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$a900ab6e8c8f61fb$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $a900ab6e8c8f61fb$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $a900ab6e8c8f61fb$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $a900ab6e8c8f61fb$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $a900ab6e8c8f61fb$var$_getMaxListeners(this);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $a900ab6e8c8f61fb$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $a900ab6e8c8f61fb$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$a900ab6e8c8f61fb$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $a900ab6e8c8f61fb$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $a900ab6e8c8f61fb$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $a900ab6e8c8f61fb$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $a900ab6e8c8f61fb$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $a900ab6e8c8f61fb$var$_addListener(this, type, listener, false);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.on = $a900ab6e8c8f61fb$var$EventEmitter.prototype.addListener;
$a900ab6e8c8f61fb$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $a900ab6e8c8f61fb$var$_addListener(this, type, listener, true);
};
function $a900ab6e8c8f61fb$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $a900ab6e8c8f61fb$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $a900ab6e8c8f61fb$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.once = function once(type, listener) {
    $a900ab6e8c8f61fb$var$checkListener(listener);
    this.on(type, $a900ab6e8c8f61fb$var$_onceWrap(this, type, listener));
    return this;
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $a900ab6e8c8f61fb$var$checkListener(listener);
    this.prependListener(type, $a900ab6e8c8f61fb$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$a900ab6e8c8f61fb$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $a900ab6e8c8f61fb$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $a900ab6e8c8f61fb$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.off = $a900ab6e8c8f61fb$var$EventEmitter.prototype.removeListener;
$a900ab6e8c8f61fb$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $a900ab6e8c8f61fb$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $a900ab6e8c8f61fb$var$unwrapListeners(evlistener) : $a900ab6e8c8f61fb$var$arrayClone(evlistener, evlistener.length);
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $a900ab6e8c8f61fb$var$_listeners(this, type, true);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $a900ab6e8c8f61fb$var$_listeners(this, type, false);
};
$a900ab6e8c8f61fb$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $a900ab6e8c8f61fb$var$listenerCount.call(emitter, type);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.listenerCount = $a900ab6e8c8f61fb$var$listenerCount;
function $a900ab6e8c8f61fb$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $a900ab6e8c8f61fb$var$ReflectOwnKeys(this._events) : [];
};
function $a900ab6e8c8f61fb$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $a900ab6e8c8f61fb$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $a900ab6e8c8f61fb$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $a900ab6e8c8f61fb$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $a900ab6e8c8f61fb$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $a900ab6e8c8f61fb$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("roix3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidStateError = module.exports.UnsupportedError = void 0;
/**
 * Error indicating not support for something.
 */ class $05255eca12580f09$var$UnsupportedError extends Error {
    constructor(message){
        super(message);
        this.name = "UnsupportedError";
        if (Error.hasOwnProperty("captureStackTrace")) // Just in V8.
        // @ts-ignore
        Error.captureStackTrace(this, $05255eca12580f09$var$UnsupportedError);
        else this.stack = new Error(message).stack;
    }
}
module.exports.UnsupportedError = $05255eca12580f09$var$UnsupportedError;
/**
 * Error produced when calling a method in an invalid state.
 */ class $05255eca12580f09$var$InvalidStateError extends Error {
    constructor(message){
        super(message);
        this.name = "InvalidStateError";
        if (Error.hasOwnProperty("captureStackTrace")) // Just in V8.
        // @ts-ignore
        Error.captureStackTrace(this, $05255eca12580f09$var$InvalidStateError);
        else this.stack = new Error(message).stack;
    }
}
module.exports.InvalidStateError = $05255eca12580f09$var$InvalidStateError;

});

parcelRegister("lghrF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = $f7a89fe13fce6649$var$clone;
module.exports.generateRandomNumber = $f7a89fe13fce6649$var$generateRandomNumber;
module.exports.deepFreeze = $f7a89fe13fce6649$var$deepFreeze;
/**
 * Clones the given value.
 */ function $f7a89fe13fce6649$var$clone(value) {
    if (value === undefined) return undefined;
    else if (Number.isNaN(value)) return NaN;
    else if (typeof structuredClone === "function") // Available in Node >= 18.
    return structuredClone(value);
    else return JSON.parse(JSON.stringify(value));
}
/**
 * Generates a random positive integer.
 */ function $f7a89fe13fce6649$var$generateRandomNumber() {
    return Math.round(Math.random() * 10000000);
}
/**
 * Make an object or array recursively immutable.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze.
 */ function $f7a89fe13fce6649$var$deepFreeze(object) {
    // Retrieve the property names defined on object.
    const propNames = Reflect.ownKeys(object);
    // Freeze properties before freezing self.
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $f7a89fe13fce6649$var$deepFreeze(value);
    }
    return Object.freeze(object);
}

});

parcelRegister("5Mq2W", function(module, exports) {
"use strict";
var $4355a3b9dc9f6c65$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4355a3b9dc9f6c65$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4355a3b9dc9f6c65$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4355a3b9dc9f6c65$var$__createBinding(result, mod, k);
    }
    $4355a3b9dc9f6c65$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateRtpCapabilities = $4355a3b9dc9f6c65$var$validateRtpCapabilities;
module.exports.validateRtpParameters = $4355a3b9dc9f6c65$var$validateRtpParameters;
module.exports.validateSctpStreamParameters = $4355a3b9dc9f6c65$var$validateSctpStreamParameters;
module.exports.validateSctpCapabilities = $4355a3b9dc9f6c65$var$validateSctpCapabilities;
module.exports.getExtendedRtpCapabilities = $4355a3b9dc9f6c65$var$getExtendedRtpCapabilities;
module.exports.getRecvRtpCapabilities = $4355a3b9dc9f6c65$var$getRecvRtpCapabilities;
module.exports.getSendingRtpParameters = $4355a3b9dc9f6c65$var$getSendingRtpParameters;
module.exports.getSendingRemoteRtpParameters = $4355a3b9dc9f6c65$var$getSendingRemoteRtpParameters;
module.exports.reduceCodecs = $4355a3b9dc9f6c65$var$reduceCodecs;
module.exports.generateProbatorRtpParameters = $4355a3b9dc9f6c65$var$generateProbatorRtpParameters;
module.exports.canSend = $4355a3b9dc9f6c65$var$canSend;
module.exports.canReceive = $4355a3b9dc9f6c65$var$canReceive;

const $4355a3b9dc9f6c65$var$h264 = $4355a3b9dc9f6c65$var$__importStar((parcelRequire("irnzV")));

const $4355a3b9dc9f6c65$var$utils = $4355a3b9dc9f6c65$var$__importStar((parcelRequire("lghrF")));
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_MID = "probator";
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_SSRC = 1234;
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_CODEC_PAYLOAD_TYPE = 127;
/**
 * Validates RtpCapabilities. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCapabilities(caps) {
    if (typeof caps !== "object") throw new TypeError("caps is not an object");
    // codecs is optional. If unset, fill with an empty array.
    if (caps.codecs && !Array.isArray(caps.codecs)) throw new TypeError("caps.codecs is not an array");
    else if (!caps.codecs) caps.codecs = [];
    for (const codec of caps.codecs)$4355a3b9dc9f6c65$var$validateRtpCodecCapability(codec);
    // headerExtensions is optional. If unset, fill with an empty array.
    if (caps.headerExtensions && !Array.isArray(caps.headerExtensions)) throw new TypeError("caps.headerExtensions is not an array");
    else if (!caps.headerExtensions) caps.headerExtensions = [];
    for (const ext of caps.headerExtensions)$4355a3b9dc9f6c65$var$validateRtpHeaderExtension(ext);
}
/**
 * Validates RtpParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpParameters(params) {
    if (typeof params !== "object") throw new TypeError("params is not an object");
    // mid is optional.
    if (params.mid && typeof params.mid !== "string") throw new TypeError("params.mid is not a string");
    // codecs is mandatory.
    if (!Array.isArray(params.codecs)) throw new TypeError("missing params.codecs");
    for (const codec of params.codecs)$4355a3b9dc9f6c65$var$validateRtpCodecParameters(codec);
    // headerExtensions is optional. If unset, fill with an empty array.
    if (params.headerExtensions && !Array.isArray(params.headerExtensions)) throw new TypeError("params.headerExtensions is not an array");
    else if (!params.headerExtensions) params.headerExtensions = [];
    for (const ext of params.headerExtensions)$4355a3b9dc9f6c65$var$validateRtpHeaderExtensionParameters(ext);
    // encodings is optional. If unset, fill with an empty array.
    if (params.encodings && !Array.isArray(params.encodings)) throw new TypeError("params.encodings is not an array");
    else if (!params.encodings) params.encodings = [];
    for (const encoding of params.encodings)$4355a3b9dc9f6c65$var$validateRtpEncodingParameters(encoding);
    // rtcp is optional. If unset, fill with an empty object.
    if (params.rtcp && typeof params.rtcp !== "object") throw new TypeError("params.rtcp is not an object");
    else if (!params.rtcp) params.rtcp = {};
    $4355a3b9dc9f6c65$var$validateRtcpParameters(params.rtcp);
}
/**
 * Validates SctpStreamParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateSctpStreamParameters(params) {
    if (typeof params !== "object") throw new TypeError("params is not an object");
    // streamId is mandatory.
    if (typeof params.streamId !== "number") throw new TypeError("missing params.streamId");
    // ordered is optional.
    let orderedGiven = false;
    if (typeof params.ordered === "boolean") orderedGiven = true;
    else params.ordered = true;
    // maxPacketLifeTime is optional.
    if (params.maxPacketLifeTime && typeof params.maxPacketLifeTime !== "number") throw new TypeError("invalid params.maxPacketLifeTime");
    // maxRetransmits is optional.
    if (params.maxRetransmits && typeof params.maxRetransmits !== "number") throw new TypeError("invalid params.maxRetransmits");
    if (params.maxPacketLifeTime && params.maxRetransmits) throw new TypeError("cannot provide both maxPacketLifeTime and maxRetransmits");
    if (orderedGiven && params.ordered && (params.maxPacketLifeTime || params.maxRetransmits)) throw new TypeError("cannot be ordered with maxPacketLifeTime or maxRetransmits");
    else if (!orderedGiven && (params.maxPacketLifeTime || params.maxRetransmits)) params.ordered = false;
    // label is optional.
    if (params.label && typeof params.label !== "string") throw new TypeError("invalid params.label");
    // protocol is optional.
    if (params.protocol && typeof params.protocol !== "string") throw new TypeError("invalid params.protocol");
}
/**
 * Validates SctpCapabilities. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateSctpCapabilities(caps) {
    if (typeof caps !== "object") throw new TypeError("caps is not an object");
    // numStreams is mandatory.
    if (!caps.numStreams || typeof caps.numStreams !== "object") throw new TypeError("missing caps.numStreams");
    $4355a3b9dc9f6c65$var$validateNumSctpStreams(caps.numStreams);
}
/**
 * Generate extended RTP capabilities for sending and receiving.
 */ function $4355a3b9dc9f6c65$var$getExtendedRtpCapabilities(localCaps, remoteCaps) {
    const extendedRtpCapabilities = {
        codecs: [],
        headerExtensions: []
    };
    // Match media codecs and keep the order preferred by remoteCaps.
    for (const remoteCodec of remoteCaps.codecs || []){
        if ($4355a3b9dc9f6c65$var$isRtxCodec(remoteCodec)) continue;
        const matchingLocalCodec = (localCaps.codecs || []).find((localCodec)=>$4355a3b9dc9f6c65$var$matchCodecs(localCodec, remoteCodec, {
                strict: true,
                modify: true
            }));
        if (!matchingLocalCodec) continue;
        const extendedCodec = {
            mimeType: matchingLocalCodec.mimeType,
            kind: matchingLocalCodec.kind,
            clockRate: matchingLocalCodec.clockRate,
            channels: matchingLocalCodec.channels,
            localPayloadType: matchingLocalCodec.preferredPayloadType,
            localRtxPayloadType: undefined,
            remotePayloadType: remoteCodec.preferredPayloadType,
            remoteRtxPayloadType: undefined,
            localParameters: matchingLocalCodec.parameters,
            remoteParameters: remoteCodec.parameters,
            rtcpFeedback: $4355a3b9dc9f6c65$var$reduceRtcpFeedback(matchingLocalCodec, remoteCodec)
        };
        extendedRtpCapabilities.codecs.push(extendedCodec);
    }
    // Match RTX codecs.
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        const matchingLocalRtxCodec = localCaps.codecs.find((localCodec)=>$4355a3b9dc9f6c65$var$isRtxCodec(localCodec) && localCodec.parameters.apt === extendedCodec.localPayloadType);
        const matchingRemoteRtxCodec = remoteCaps.codecs.find((remoteCodec)=>$4355a3b9dc9f6c65$var$isRtxCodec(remoteCodec) && remoteCodec.parameters.apt === extendedCodec.remotePayloadType);
        if (matchingLocalRtxCodec && matchingRemoteRtxCodec) {
            extendedCodec.localRtxPayloadType = matchingLocalRtxCodec.preferredPayloadType;
            extendedCodec.remoteRtxPayloadType = matchingRemoteRtxCodec.preferredPayloadType;
        }
    }
    // Match header extensions.
    for (const remoteExt of remoteCaps.headerExtensions){
        const matchingLocalExt = localCaps.headerExtensions.find((localExt)=>$4355a3b9dc9f6c65$var$matchHeaderExtensions(localExt, remoteExt));
        if (!matchingLocalExt) continue;
        const extendedExt = {
            kind: remoteExt.kind,
            uri: remoteExt.uri,
            sendId: matchingLocalExt.preferredId,
            recvId: remoteExt.preferredId,
            encrypt: matchingLocalExt.preferredEncrypt,
            direction: "sendrecv"
        };
        switch(remoteExt.direction){
            case "sendrecv":
                extendedExt.direction = "sendrecv";
                break;
            case "recvonly":
                extendedExt.direction = "sendonly";
                break;
            case "sendonly":
                extendedExt.direction = "recvonly";
                break;
            case "inactive":
                extendedExt.direction = "inactive";
                break;
        }
        extendedRtpCapabilities.headerExtensions.push(extendedExt);
    }
    return extendedRtpCapabilities;
}
/**
 * Generate RTP capabilities for receiving media based on the given extended
 * RTP capabilities.
 */ function $4355a3b9dc9f6c65$var$getRecvRtpCapabilities(extendedRtpCapabilities) {
    const rtpCapabilities = {
        codecs: [],
        headerExtensions: []
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        const codec = {
            mimeType: extendedCodec.mimeType,
            kind: extendedCodec.kind,
            preferredPayloadType: extendedCodec.remotePayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.localParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpCapabilities.codecs.push(codec);
        // Add RTX codec.
        if (!extendedCodec.remoteRtxPayloadType) continue;
        const rtxCodec = {
            mimeType: `${extendedCodec.kind}/rtx`,
            kind: extendedCodec.kind,
            preferredPayloadType: extendedCodec.remoteRtxPayloadType,
            clockRate: extendedCodec.clockRate,
            parameters: {
                apt: extendedCodec.remotePayloadType
            },
            rtcpFeedback: []
        };
        rtpCapabilities.codecs.push(rtxCodec);
    // TODO: In the future, we need to add FEC, CN, etc, codecs.
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions not valid for receiving.
        if (extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "recvonly") continue;
        const ext = {
            kind: extendedExtension.kind,
            uri: extendedExtension.uri,
            preferredId: extendedExtension.recvId,
            preferredEncrypt: extendedExtension.encrypt,
            direction: extendedExtension.direction
        };
        rtpCapabilities.headerExtensions.push(ext);
    }
    return rtpCapabilities;
}
/**
 * Generate RTP parameters of the given kind for sending media.
 * NOTE: mid, encodings and rtcp fields are left empty.
 */ function $4355a3b9dc9f6c65$var$getSendingRtpParameters(kind, extendedRtpCapabilities) {
    const rtpParameters = {
        mid: undefined,
        codecs: [],
        headerExtensions: [],
        encodings: [],
        rtcp: {}
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        if (extendedCodec.kind !== kind) continue;
        const codec = {
            mimeType: extendedCodec.mimeType,
            payloadType: extendedCodec.localPayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.localParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpParameters.codecs.push(codec);
        // Add RTX codec.
        if (extendedCodec.localRtxPayloadType) {
            const rtxCodec = {
                mimeType: `${extendedCodec.kind}/rtx`,
                payloadType: extendedCodec.localRtxPayloadType,
                clockRate: extendedCodec.clockRate,
                parameters: {
                    apt: extendedCodec.localPayloadType
                },
                rtcpFeedback: []
            };
            rtpParameters.codecs.push(rtxCodec);
        }
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions of a different kind and those not valid for sending.
        if (extendedExtension.kind && extendedExtension.kind !== kind || extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "sendonly") continue;
        const ext = {
            uri: extendedExtension.uri,
            id: extendedExtension.sendId,
            encrypt: extendedExtension.encrypt,
            parameters: {}
        };
        rtpParameters.headerExtensions.push(ext);
    }
    return rtpParameters;
}
/**
 * Generate RTP parameters of the given kind suitable for the remote SDP answer.
 */ function $4355a3b9dc9f6c65$var$getSendingRemoteRtpParameters(kind, extendedRtpCapabilities) {
    const rtpParameters = {
        mid: undefined,
        codecs: [],
        headerExtensions: [],
        encodings: [],
        rtcp: {}
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        if (extendedCodec.kind !== kind) continue;
        const codec = {
            mimeType: extendedCodec.mimeType,
            payloadType: extendedCodec.localPayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.remoteParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpParameters.codecs.push(codec);
        // Add RTX codec.
        if (extendedCodec.localRtxPayloadType) {
            const rtxCodec = {
                mimeType: `${extendedCodec.kind}/rtx`,
                payloadType: extendedCodec.localRtxPayloadType,
                clockRate: extendedCodec.clockRate,
                parameters: {
                    apt: extendedCodec.localPayloadType
                },
                rtcpFeedback: []
            };
            rtpParameters.codecs.push(rtxCodec);
        }
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions of a different kind and those not valid for sending.
        if (extendedExtension.kind && extendedExtension.kind !== kind || extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "sendonly") continue;
        const ext = {
            uri: extendedExtension.uri,
            id: extendedExtension.sendId,
            encrypt: extendedExtension.encrypt,
            parameters: {}
        };
        rtpParameters.headerExtensions.push(ext);
    }
    // Reduce codecs' RTCP feedback. Use Transport-CC if available, REMB otherwise.
    if (rtpParameters.headerExtensions.some((ext)=>ext.uri === "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01")) for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "goog-remb");
    else if (rtpParameters.headerExtensions.some((ext)=>ext.uri === "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time")) for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "transport-cc");
    else for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "transport-cc" && fb.type !== "goog-remb");
    return rtpParameters;
}
/**
 * Reduce given codecs by returning an array of codecs "compatible" with the
 * given capability codec. If no capability codec is given, take the first
 * one(s).
 *
 * Given codecs must be generated by ortc.getSendingRtpParameters() or
 * ortc.getSendingRemoteRtpParameters().
 *
 * The returned array of codecs also include a RTX codec if available.
 */ function $4355a3b9dc9f6c65$var$reduceCodecs(codecs, capCodec) {
    const filteredCodecs = [];
    // If no capability codec is given, take the first one (and RTX).
    if (!capCodec) {
        filteredCodecs.push(codecs[0]);
        if ($4355a3b9dc9f6c65$var$isRtxCodec(codecs[1])) filteredCodecs.push(codecs[1]);
    } else {
        for(let idx = 0; idx < codecs.length; ++idx)if ($4355a3b9dc9f6c65$var$matchCodecs(codecs[idx], capCodec, {
            strict: true
        })) {
            filteredCodecs.push(codecs[idx]);
            if ($4355a3b9dc9f6c65$var$isRtxCodec(codecs[idx + 1])) filteredCodecs.push(codecs[idx + 1]);
            break;
        }
        if (filteredCodecs.length === 0) throw new TypeError("no matching codec found");
    }
    return filteredCodecs;
}
/**
 * Create RTP parameters for a Consumer for the RTP probator.
 */ function $4355a3b9dc9f6c65$var$generateProbatorRtpParameters(videoRtpParameters) {
    // Clone given reference video RTP parameters.
    videoRtpParameters = $4355a3b9dc9f6c65$var$utils.clone(videoRtpParameters);
    // This may throw.
    $4355a3b9dc9f6c65$var$validateRtpParameters(videoRtpParameters);
    const rtpParameters = {
        mid: $4355a3b9dc9f6c65$var$RTP_PROBATOR_MID,
        codecs: [],
        headerExtensions: [],
        encodings: [
            {
                ssrc: $4355a3b9dc9f6c65$var$RTP_PROBATOR_SSRC
            }
        ],
        rtcp: {
            cname: "probator"
        }
    };
    rtpParameters.codecs.push(videoRtpParameters.codecs[0]);
    rtpParameters.codecs[0].payloadType = $4355a3b9dc9f6c65$var$RTP_PROBATOR_CODEC_PAYLOAD_TYPE;
    rtpParameters.headerExtensions = videoRtpParameters.headerExtensions;
    return rtpParameters;
}
/**
 * Whether media can be sent based on the given RTP capabilities.
 */ function $4355a3b9dc9f6c65$var$canSend(kind, extendedRtpCapabilities) {
    return extendedRtpCapabilities.codecs.some((codec)=>codec.kind === kind);
}
/**
 * Whether the given RTP parameters can be received with the given RTP
 * capabilities.
 */ function $4355a3b9dc9f6c65$var$canReceive(rtpParameters, extendedRtpCapabilities) {
    // This may throw.
    $4355a3b9dc9f6c65$var$validateRtpParameters(rtpParameters);
    if (rtpParameters.codecs.length === 0) return false;
    const firstMediaCodec = rtpParameters.codecs[0];
    return extendedRtpCapabilities.codecs.some((codec)=>codec.remotePayloadType === firstMediaCodec.payloadType);
}
/**
 * Validates RtpCodecCapability. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCodecCapability(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    if (typeof codec !== "object") throw new TypeError("codec is not an object");
    // mimeType is mandatory.
    if (!codec.mimeType || typeof codec.mimeType !== "string") throw new TypeError("missing codec.mimeType");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    // Just override kind with media component of mimeType.
    codec.kind = mimeTypeMatch[1].toLowerCase();
    // preferredPayloadType is optional.
    if (codec.preferredPayloadType && typeof codec.preferredPayloadType !== "number") throw new TypeError("invalid codec.preferredPayloadType");
    // clockRate is mandatory.
    if (typeof codec.clockRate !== "number") throw new TypeError("missing codec.clockRate");
    // channels is optional. If unset, set it to 1 (just if audio).
    if (codec.kind === "audio") {
        if (typeof codec.channels !== "number") codec.channels = 1;
    } else delete codec.channels;
    // parameters is optional. If unset, set it to an empty object.
    if (!codec.parameters || typeof codec.parameters !== "object") codec.parameters = {};
    for (const key of Object.keys(codec.parameters)){
        let value = codec.parameters[key];
        if (value === undefined) {
            codec.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError(`invalid codec parameter [key:${key}s, value:${value}]`);
        // Specific parameters validation.
        if (key === "apt") {
            if (typeof value !== "number") throw new TypeError("invalid codec apt parameter");
        }
    }
    // rtcpFeedback is optional. If unset, set it to an empty array.
    if (!codec.rtcpFeedback || !Array.isArray(codec.rtcpFeedback)) codec.rtcpFeedback = [];
    for (const fb of codec.rtcpFeedback)$4355a3b9dc9f6c65$var$validateRtcpFeedback(fb);
}
/**
 * Validates RtcpFeedback. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtcpFeedback(fb) {
    if (typeof fb !== "object") throw new TypeError("fb is not an object");
    // type is mandatory.
    if (!fb.type || typeof fb.type !== "string") throw new TypeError("missing fb.type");
    // parameter is optional. If unset set it to an empty string.
    if (!fb.parameter || typeof fb.parameter !== "string") fb.parameter = "";
}
/**
 * Validates RtpHeaderExtension. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpHeaderExtension(ext) {
    if (typeof ext !== "object") throw new TypeError("ext is not an object");
    // kind is mandatory.
    if (ext.kind !== "audio" && ext.kind !== "video") throw new TypeError("invalid ext.kind");
    // uri is mandatory.
    if (!ext.uri || typeof ext.uri !== "string") throw new TypeError("missing ext.uri");
    // preferredId is mandatory.
    if (typeof ext.preferredId !== "number") throw new TypeError("missing ext.preferredId");
    // preferredEncrypt is optional. If unset set it to false.
    if (ext.preferredEncrypt && typeof ext.preferredEncrypt !== "boolean") throw new TypeError("invalid ext.preferredEncrypt");
    else if (!ext.preferredEncrypt) ext.preferredEncrypt = false;
    // direction is optional. If unset set it to sendrecv.
    if (ext.direction && typeof ext.direction !== "string") throw new TypeError("invalid ext.direction");
    else if (!ext.direction) ext.direction = "sendrecv";
}
/**
 * Validates RtpCodecParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCodecParameters(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    if (typeof codec !== "object") throw new TypeError("codec is not an object");
    // mimeType is mandatory.
    if (!codec.mimeType || typeof codec.mimeType !== "string") throw new TypeError("missing codec.mimeType");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    // payloadType is mandatory.
    if (typeof codec.payloadType !== "number") throw new TypeError("missing codec.payloadType");
    // clockRate is mandatory.
    if (typeof codec.clockRate !== "number") throw new TypeError("missing codec.clockRate");
    const kind = mimeTypeMatch[1].toLowerCase();
    // channels is optional. If unset, set it to 1 (just if audio).
    if (kind === "audio") {
        if (typeof codec.channels !== "number") codec.channels = 1;
    } else delete codec.channels;
    // parameters is optional. If unset, set it to an empty object.
    if (!codec.parameters || typeof codec.parameters !== "object") codec.parameters = {};
    for (const key of Object.keys(codec.parameters)){
        let value = codec.parameters[key];
        if (value === undefined) {
            codec.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError(`invalid codec parameter [key:${key}s, value:${value}]`);
        // Specific parameters validation.
        if (key === "apt") {
            if (typeof value !== "number") throw new TypeError("invalid codec apt parameter");
        }
    }
    // rtcpFeedback is optional. If unset, set it to an empty array.
    if (!codec.rtcpFeedback || !Array.isArray(codec.rtcpFeedback)) codec.rtcpFeedback = [];
    for (const fb of codec.rtcpFeedback)$4355a3b9dc9f6c65$var$validateRtcpFeedback(fb);
}
/**
 * Validates RtpHeaderExtensionParameteters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpHeaderExtensionParameters(ext) {
    if (typeof ext !== "object") throw new TypeError("ext is not an object");
    // uri is mandatory.
    if (!ext.uri || typeof ext.uri !== "string") throw new TypeError("missing ext.uri");
    // id is mandatory.
    if (typeof ext.id !== "number") throw new TypeError("missing ext.id");
    // encrypt is optional. If unset set it to false.
    if (ext.encrypt && typeof ext.encrypt !== "boolean") throw new TypeError("invalid ext.encrypt");
    else if (!ext.encrypt) ext.encrypt = false;
    // parameters is optional. If unset, set it to an empty object.
    if (!ext.parameters || typeof ext.parameters !== "object") ext.parameters = {};
    for (const key of Object.keys(ext.parameters)){
        let value = ext.parameters[key];
        if (value === undefined) {
            ext.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError("invalid header extension parameter");
    }
}
/**
 * Validates RtpEncodingParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpEncodingParameters(encoding) {
    if (typeof encoding !== "object") throw new TypeError("encoding is not an object");
    // ssrc is optional.
    if (encoding.ssrc && typeof encoding.ssrc !== "number") throw new TypeError("invalid encoding.ssrc");
    // rid is optional.
    if (encoding.rid && typeof encoding.rid !== "string") throw new TypeError("invalid encoding.rid");
    // rtx is optional.
    if (encoding.rtx && typeof encoding.rtx !== "object") throw new TypeError("invalid encoding.rtx");
    else if (encoding.rtx) {
        // RTX ssrc is mandatory if rtx is present.
        if (typeof encoding.rtx.ssrc !== "number") throw new TypeError("missing encoding.rtx.ssrc");
    }
    // dtx is optional. If unset set it to false.
    if (!encoding.dtx || typeof encoding.dtx !== "boolean") encoding.dtx = false;
    // scalabilityMode is optional.
    if (encoding.scalabilityMode && typeof encoding.scalabilityMode !== "string") throw new TypeError("invalid encoding.scalabilityMode");
}
/**
 * Validates RtcpParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtcpParameters(rtcp) {
    if (typeof rtcp !== "object") throw new TypeError("rtcp is not an object");
    // cname is optional.
    if (rtcp.cname && typeof rtcp.cname !== "string") throw new TypeError("invalid rtcp.cname");
    // reducedSize is optional. If unset set it to true.
    if (!rtcp.reducedSize || typeof rtcp.reducedSize !== "boolean") rtcp.reducedSize = true;
}
/**
 * Validates NumSctpStreams. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateNumSctpStreams(numStreams) {
    if (typeof numStreams !== "object") throw new TypeError("numStreams is not an object");
    // OS is mandatory.
    if (typeof numStreams.OS !== "number") throw new TypeError("missing numStreams.OS");
    // MIS is mandatory.
    if (typeof numStreams.MIS !== "number") throw new TypeError("missing numStreams.MIS");
}
function $4355a3b9dc9f6c65$var$isRtxCodec(codec) {
    if (!codec) return false;
    return /.+\/rtx$/i.test(codec.mimeType);
}
function $4355a3b9dc9f6c65$var$matchCodecs(aCodec, bCodec, { strict: strict = false, modify: modify = false } = {}) {
    const aMimeType = aCodec.mimeType.toLowerCase();
    const bMimeType = bCodec.mimeType.toLowerCase();
    if (aMimeType !== bMimeType) return false;
    if (aCodec.clockRate !== bCodec.clockRate) return false;
    if (aCodec.channels !== bCodec.channels) return false;
    // Per codec special checks.
    switch(aMimeType){
        case "video/h264":
            if (strict) {
                const aPacketizationMode = aCodec.parameters["packetization-mode"] || 0;
                const bPacketizationMode = bCodec.parameters["packetization-mode"] || 0;
                if (aPacketizationMode !== bPacketizationMode) return false;
                if (!$4355a3b9dc9f6c65$var$h264.isSameProfile(aCodec.parameters, bCodec.parameters)) return false;
                let selectedProfileLevelId;
                try {
                    selectedProfileLevelId = $4355a3b9dc9f6c65$var$h264.generateProfileLevelIdStringForAnswer(aCodec.parameters, bCodec.parameters);
                } catch (error) {
                    return false;
                }
                if (modify) {
                    if (selectedProfileLevelId) {
                        aCodec.parameters["profile-level-id"] = selectedProfileLevelId;
                        bCodec.parameters["profile-level-id"] = selectedProfileLevelId;
                    } else {
                        delete aCodec.parameters["profile-level-id"];
                        delete bCodec.parameters["profile-level-id"];
                    }
                }
            }
            break;
        case "video/vp9":
            if (strict) {
                const aProfileId = aCodec.parameters["profile-id"] || 0;
                const bProfileId = bCodec.parameters["profile-id"] || 0;
                if (aProfileId !== bProfileId) return false;
            }
            break;
    }
    return true;
}
function $4355a3b9dc9f6c65$var$matchHeaderExtensions(aExt, bExt) {
    if (aExt.kind && bExt.kind && aExt.kind !== bExt.kind) return false;
    if (aExt.uri !== bExt.uri) return false;
    return true;
}
function $4355a3b9dc9f6c65$var$reduceRtcpFeedback(codecA, codecB) {
    const reducedRtcpFeedback = [];
    for (const aFb of codecA.rtcpFeedback || []){
        const matchingBFb = (codecB.rtcpFeedback || []).find((bFb)=>bFb.type === aFb.type && (bFb.parameter === aFb.parameter || !bFb.parameter && !aFb.parameter));
        if (matchingBFb) reducedRtcpFeedback.push(matchingBFb);
    }
    return reducedRtcpFeedback;
}

});
parcelRegister("irnzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateProfileLevelIdStringForAnswer = module.exports.isSameProfile = module.exports.parseSdpProfileLevelId = module.exports.levelToString = module.exports.profileToString = module.exports.profileLevelIdToString = module.exports.parseProfileLevelId = module.exports.ProfileLevelId = module.exports.Level = module.exports.Profile = void 0;

var $7wuvv = parcelRequire("7wuvv");
const $d6cd09c9dd62c7a3$var$logger = new $7wuvv.Logger();
/**
 * Supported profiles.
 */ // ESLint absurdly complains about "'Profile' is already declared in
// the upper scope".
// eslint-disable-next-line no-shadow
var $d6cd09c9dd62c7a3$var$Profile;
(function(Profile) {
    Profile[Profile["ConstrainedBaseline"] = 1] = "ConstrainedBaseline";
    Profile[Profile["Baseline"] = 2] = "Baseline";
    Profile[Profile["Main"] = 3] = "Main";
    Profile[Profile["ConstrainedHigh"] = 4] = "ConstrainedHigh";
    Profile[Profile["High"] = 5] = "High";
    Profile[Profile["PredictiveHigh444"] = 6] = "PredictiveHigh444";
})($d6cd09c9dd62c7a3$var$Profile || (module.exports.Profile = $d6cd09c9dd62c7a3$var$Profile = {}));
/**
 * Supported levels.
 */ // ESLint absurdly complains about "'Level' is already declared in
// the upper scope".
// eslint-disable-next-line no-shadow
var $d6cd09c9dd62c7a3$var$Level;
(function(Level) {
    Level[Level["L1_b"] = 0] = "L1_b";
    Level[Level["L1"] = 10] = "L1";
    Level[Level["L1_1"] = 11] = "L1_1";
    Level[Level["L1_2"] = 12] = "L1_2";
    Level[Level["L1_3"] = 13] = "L1_3";
    Level[Level["L2"] = 20] = "L2";
    Level[Level["L2_1"] = 21] = "L2_1";
    Level[Level["L2_2"] = 22] = "L2_2";
    Level[Level["L3"] = 30] = "L3";
    Level[Level["L3_1"] = 31] = "L3_1";
    Level[Level["L3_2"] = 32] = "L3_2";
    Level[Level["L4"] = 40] = "L4";
    Level[Level["L4_1"] = 41] = "L4_1";
    Level[Level["L4_2"] = 42] = "L4_2";
    Level[Level["L5"] = 50] = "L5";
    Level[Level["L5_1"] = 51] = "L5_1";
    Level[Level["L5_2"] = 52] = "L5_2";
})($d6cd09c9dd62c7a3$var$Level || (module.exports.Level = $d6cd09c9dd62c7a3$var$Level = {}));
/**
 * Represents a parsed h264 profile-level-id value.
 */ class $d6cd09c9dd62c7a3$var$ProfileLevelId {
    constructor(profile, level){
        this.profile = profile;
        this.level = level;
    }
}
module.exports.ProfileLevelId = $d6cd09c9dd62c7a3$var$ProfileLevelId;
// Default ProfileLevelId.
//
// TODO: The default should really be profile Baseline and level 1 according to
// the spec: https://tools.ietf.org/html/rfc6184#section-8.1. In order to not
// break backwards compatibility with older versions of WebRTC where external
// codecs don't have any parameters, use profile ConstrainedBaseline level 3_1
// instead. This workaround will only be done in an interim period to allow
// external clients to update their code.
//
// http://crbug/webrtc/6337.
const $d6cd09c9dd62c7a3$var$DefaultProfileLevelId = new $d6cd09c9dd62c7a3$var$ProfileLevelId($d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline, $d6cd09c9dd62c7a3$var$Level.L3_1);
/**
 * Class for matching bit patterns such as "x1xx0000" where 'x' is allowed to
 * be either 0 or 1.
 */ class $d6cd09c9dd62c7a3$var$BitPattern {
    isMatch(value) {
        return this.masked_value === (value & this.mask);
    }
    constructor(str){
        this.mask = ~$d6cd09c9dd62c7a3$var$byteMaskString("x", str);
        this.masked_value = $d6cd09c9dd62c7a3$var$byteMaskString("1", str);
    }
}
/**
 * Class for converting between profile_idc/profile_iop to Profile.
 */ class $d6cd09c9dd62c7a3$var$ProfilePattern {
    constructor(profile_idc, profile_iop, profile){
        this.profile_idc = profile_idc;
        this.profile_iop = profile_iop;
        this.profile = profile;
    }
}
// This is from https://tools.ietf.org/html/rfc6184#section-8.1.
const $d6cd09c9dd62c7a3$var$ProfilePatterns = [
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x42, new $d6cd09c9dd62c7a3$var$BitPattern("x1xx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x4D, new $d6cd09c9dd62c7a3$var$BitPattern("1xxx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x58, new $d6cd09c9dd62c7a3$var$BitPattern("11xx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x42, new $d6cd09c9dd62c7a3$var$BitPattern("x0xx0000"), $d6cd09c9dd62c7a3$var$Profile.Baseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x58, new $d6cd09c9dd62c7a3$var$BitPattern("10xx0000"), $d6cd09c9dd62c7a3$var$Profile.Baseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x4D, new $d6cd09c9dd62c7a3$var$BitPattern("0x0x0000"), $d6cd09c9dd62c7a3$var$Profile.Main),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x64, new $d6cd09c9dd62c7a3$var$BitPattern("00000000"), $d6cd09c9dd62c7a3$var$Profile.High),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x64, new $d6cd09c9dd62c7a3$var$BitPattern("00001100"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0xF4, new $d6cd09c9dd62c7a3$var$BitPattern("00000000"), $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444)
];
/**
 * Parse profile level id that is represented as a string of 3 hex bytes.
 * Nothing will be returned if the string is not a recognized H264 profile
 * level id.
 */ function $d6cd09c9dd62c7a3$var$parseProfileLevelId(str) {
    // For level_idc=11 and profile_idc=0x42, 0x4D, or 0x58, the constraint set3
    // flag specifies if level 1b or level 1.1 is used.
    const ConstraintSet3Flag = 0x10;
    // The string should consist of 3 bytes in hexadecimal format.
    if (typeof str !== "string" || str.length !== 6) return undefined;
    const profile_level_id_numeric = parseInt(str, 16);
    if (profile_level_id_numeric === 0) return undefined;
    // Separate into three bytes.
    const level_idc = profile_level_id_numeric & 0xFF;
    const profile_iop = profile_level_id_numeric >> 8 & 0xFF;
    const profile_idc = profile_level_id_numeric >> 16 & 0xFF;
    // Parse level based on level_idc and constraint set 3 flag.
    let level;
    switch(level_idc){
        case $d6cd09c9dd62c7a3$var$Level.L1_1:
            level = (profile_iop & ConstraintSet3Flag) !== 0 ? $d6cd09c9dd62c7a3$var$Level.L1_b : $d6cd09c9dd62c7a3$var$Level.L1_1;
            break;
        case $d6cd09c9dd62c7a3$var$Level.L1:
        case $d6cd09c9dd62c7a3$var$Level.L1_2:
        case $d6cd09c9dd62c7a3$var$Level.L1_3:
        case $d6cd09c9dd62c7a3$var$Level.L2:
        case $d6cd09c9dd62c7a3$var$Level.L2_1:
        case $d6cd09c9dd62c7a3$var$Level.L2_2:
        case $d6cd09c9dd62c7a3$var$Level.L3:
        case $d6cd09c9dd62c7a3$var$Level.L3_1:
        case $d6cd09c9dd62c7a3$var$Level.L3_2:
        case $d6cd09c9dd62c7a3$var$Level.L4:
        case $d6cd09c9dd62c7a3$var$Level.L4_1:
        case $d6cd09c9dd62c7a3$var$Level.L4_2:
        case $d6cd09c9dd62c7a3$var$Level.L5:
        case $d6cd09c9dd62c7a3$var$Level.L5_1:
        case $d6cd09c9dd62c7a3$var$Level.L5_2:
            level = level_idc;
            break;
        // Unrecognized level_idc.
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`parseProfileLevelId() | unrecognized level_idc [str:${str}, level_idc:${level_idc}]`);
            return undefined;
    }
    // Parse profile_idc/profile_iop into a Profile enum.
    for (const pattern of $d6cd09c9dd62c7a3$var$ProfilePatterns){
        if (profile_idc === pattern.profile_idc && pattern.profile_iop.isMatch(profile_iop)) return new $d6cd09c9dd62c7a3$var$ProfileLevelId(pattern.profile, level);
    }
    $d6cd09c9dd62c7a3$var$logger.warn(`parseProfileLevelId() | unrecognized profile_idc/profile_iop combination [str:${str}, profile_idc:${profile_idc}, profile_iop:${profile_iop}]`);
    return undefined;
}
module.exports.parseProfileLevelId = $d6cd09c9dd62c7a3$var$parseProfileLevelId;
/**
 * Returns canonical string representation as three hex bytes of the profile
 * level id, or returns nothing for invalid profile level ids.
 */ function $d6cd09c9dd62c7a3$var$profileLevelIdToString(profile_level_id) {
    // Handle special case level == 1b.
    if (profile_level_id.level == $d6cd09c9dd62c7a3$var$Level.L1_b) switch(profile_level_id.profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            return "42f00b";
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            return "42100b";
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            return "4d100b";
        // Level 1_b is not allowed for other profiles.
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileLevelIdToString() | Level 1_b not is allowed for profile ${profile_level_id.profile}`);
            return undefined;
    }
    let profile_idc_iop_string;
    switch(profile_level_id.profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            profile_idc_iop_string = "42e0";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            profile_idc_iop_string = "4200";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            profile_idc_iop_string = "4d00";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh:
            profile_idc_iop_string = "640c";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.High:
            profile_idc_iop_string = "6400";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444:
            profile_idc_iop_string = "f400";
            break;
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileLevelIdToString() | unrecognized profile ${profile_level_id.profile}`);
            return undefined;
    }
    let levelStr = profile_level_id.level.toString(16);
    if (levelStr.length === 1) levelStr = `0${levelStr}`;
    return `${profile_idc_iop_string}${levelStr}`;
}
module.exports.profileLevelIdToString = $d6cd09c9dd62c7a3$var$profileLevelIdToString;
/**
 * Returns a human friendly name for the given profile.
 */ function $d6cd09c9dd62c7a3$var$profileToString(profile) {
    switch(profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            return "ConstrainedBaseline";
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            return "Baseline";
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            return "Main";
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh:
            return "ConstrainedHigh";
        case $d6cd09c9dd62c7a3$var$Profile.High:
            return "High";
        case $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444:
            return "PredictiveHigh444";
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileToString() | unrecognized profile ${profile}`);
            return undefined;
    }
}
module.exports.profileToString = $d6cd09c9dd62c7a3$var$profileToString;
/**
 * Returns a human friendly name for the given level.
 */ function $d6cd09c9dd62c7a3$var$levelToString(level) {
    switch(level){
        case $d6cd09c9dd62c7a3$var$Level.L1_b:
            return "1b";
        case $d6cd09c9dd62c7a3$var$Level.L1:
            return "1";
        case $d6cd09c9dd62c7a3$var$Level.L1_1:
            return "1.1";
        case $d6cd09c9dd62c7a3$var$Level.L1_2:
            return "1.2";
        case $d6cd09c9dd62c7a3$var$Level.L1_3:
            return "1.3";
        case $d6cd09c9dd62c7a3$var$Level.L2:
            return "2";
        case $d6cd09c9dd62c7a3$var$Level.L2_1:
            return "2.1";
        case $d6cd09c9dd62c7a3$var$Level.L2_2:
            return "2.2";
        case $d6cd09c9dd62c7a3$var$Level.L3:
            return "3";
        case $d6cd09c9dd62c7a3$var$Level.L3_1:
            return "3.1";
        case $d6cd09c9dd62c7a3$var$Level.L3_2:
            return "3.2";
        case $d6cd09c9dd62c7a3$var$Level.L4:
            return "4";
        case $d6cd09c9dd62c7a3$var$Level.L4_1:
            return "4.1";
        case $d6cd09c9dd62c7a3$var$Level.L4_2:
            return "4.2";
        case $d6cd09c9dd62c7a3$var$Level.L5:
            return "5";
        case $d6cd09c9dd62c7a3$var$Level.L5_1:
            return "5.1";
        case $d6cd09c9dd62c7a3$var$Level.L5_2:
            return "5.2";
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`levelToString() | unrecognized level ${level}`);
            return undefined;
    }
}
module.exports.levelToString = $d6cd09c9dd62c7a3$var$levelToString;
/**
 * Parse profile level id that is represented as a string of 3 hex bytes
 * contained in an SDP key-value map. A default profile level id will be
 * returned if the profile-level-id key is missing. Nothing will be returned
 * if the key is present but the string is invalid.
 */ function $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params = {}) {
    const profile_level_id = params["profile-level-id"];
    return profile_level_id ? $d6cd09c9dd62c7a3$var$parseProfileLevelId(profile_level_id) : $d6cd09c9dd62c7a3$var$DefaultProfileLevelId;
}
module.exports.parseSdpProfileLevelId = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId;
/**
 * Returns true if the parameters have the same H264 profile, i.e. the same
 * H264 profile (Baseline, High, etc).
 */ function $d6cd09c9dd62c7a3$var$isSameProfile(params1 = {}, params2 = {}) {
    const profile_level_id_1 = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params1);
    const profile_level_id_2 = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params2);
    // Compare H264 profiles, but not levels.
    return Boolean(profile_level_id_1 && profile_level_id_2 && profile_level_id_1.profile === profile_level_id_2.profile);
}
module.exports.isSameProfile = $d6cd09c9dd62c7a3$var$isSameProfile;
/**
 * Generate codec parameters that will be used as answer in an SDP negotiation
 * based on local supported parameters and remote offered parameters. Both
 * local_supported_params and remote_offered_params represent sendrecv media
 * descriptions, i.e they are a mix of both encode and decode capabilities. In
 * theory, when the profile in local_supported_params represent a strict
 * superset of the profile in remote_offered_params, we could limit the profile
 * in the answer to the profile in remote_offered_params.
 *
 * However, to simplify the code, each supported H264 profile should be listed
 * explicitly in the list of local supported codecs, even if they are redundant.
 * Then each local codec in the list should be tested one at a time against the
 * remote codec, and only when the profiles are equal should this function be
 * called. Therefore, this function does not need to handle profile intersection,
 * and the profile of local_supported_params and remote_offered_params must be
 * equal before calling this function. The parameters that are used when
 * negotiating are the level part of profile-level-id and
 * level-asymmetry-allowed.
 */ function $d6cd09c9dd62c7a3$var$generateProfileLevelIdStringForAnswer(local_supported_params = {}, remote_offered_params = {}) {
    // If both local and remote params do not contain profile-level-id, they are
    // both using the default profile. In this case, don't return anything.
    if (!local_supported_params["profile-level-id"] && !remote_offered_params["profile-level-id"]) {
        $d6cd09c9dd62c7a3$var$logger.warn("generateProfileLevelIdStringForAnswer() | profile-level-id missing in local and remote params");
        return undefined;
    }
    // Parse profile-level-ids.
    const local_profile_level_id = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(local_supported_params);
    const remote_profile_level_id = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(remote_offered_params);
    // The local and remote codec must have valid and equal H264 Profiles.
    if (!local_profile_level_id) throw new TypeError("invalid local_profile_level_id");
    if (!remote_profile_level_id) throw new TypeError("invalid remote_profile_level_id");
    if (local_profile_level_id.profile !== remote_profile_level_id.profile) throw new TypeError("H264 Profile mismatch");
    // Parse level information.
    const level_asymmetry_allowed = $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(local_supported_params) && $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(remote_offered_params);
    const local_level = local_profile_level_id.level;
    const remote_level = remote_profile_level_id.level;
    const min_level = $d6cd09c9dd62c7a3$var$minLevel(local_level, remote_level);
    // Determine answer level. When level asymmetry is not allowed, level upgrade
    // is not allowed, i.e., the level in the answer must be equal to or lower
    // than the level in the offer.
    const answer_level = level_asymmetry_allowed ? local_level : min_level;
    $d6cd09c9dd62c7a3$var$logger.debug(`generateProfileLevelIdStringForAnswer() | result [profile:${local_profile_level_id.profile}, level:${answer_level}]`);
    // Return the resulting profile-level-id for the answer parameters.
    return $d6cd09c9dd62c7a3$var$profileLevelIdToString(new $d6cd09c9dd62c7a3$var$ProfileLevelId(local_profile_level_id.profile, answer_level));
}
module.exports.generateProfileLevelIdStringForAnswer = $d6cd09c9dd62c7a3$var$generateProfileLevelIdStringForAnswer;
/**
 * Convert a string of 8 characters into a byte where the positions containing
 * character c will have their bit set. For example, c = 'x', str = "x1xx0000"
 * will return 0b10110000.
 */ function $d6cd09c9dd62c7a3$var$byteMaskString(c, str) {
    return Number(str[0] === c) << 7 | Number(str[1] === c) << 6 | Number(str[2] === c) << 5 | Number(str[3] === c) << 4 | Number(str[4] === c) << 3 | Number(str[5] === c) << 2 | Number(str[6] === c) << 1 | Number(str[7] === c) << 0;
}
// Compare H264 levels and handle the level 1b case.
function $d6cd09c9dd62c7a3$var$isLessLevel(a, b) {
    if (a === $d6cd09c9dd62c7a3$var$Level.L1_b) return b !== $d6cd09c9dd62c7a3$var$Level.L1 && b !== $d6cd09c9dd62c7a3$var$Level.L1_b;
    if (b === $d6cd09c9dd62c7a3$var$Level.L1_b) return a !== $d6cd09c9dd62c7a3$var$Level.L1;
    return a < b;
}
function $d6cd09c9dd62c7a3$var$minLevel(a, b) {
    return $d6cd09c9dd62c7a3$var$isLessLevel(a, b) ? a : b;
}
function $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(params = {}) {
    const level_asymmetry_allowed = params["level-asymmetry-allowed"];
    return level_asymmetry_allowed === true || level_asymmetry_allowed === 1 || level_asymmetry_allowed === "1";
}

});
parcelRegister("7wuvv", function(module, exports) {
"use strict";
var $57a32f9f887c155a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

const $57a32f9f887c155a$var$debug_1 = $57a32f9f887c155a$var$__importDefault((parcelRequire("8pLEx")));
const $57a32f9f887c155a$var$APP_NAME = "h264-profile-level-id";
class $57a32f9f887c155a$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:${prefix}`);
            this._warn = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:WARN:${prefix}`);
            this._error = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $57a32f9f887c155a$var$debug_1.default)($57a32f9f887c155a$var$APP_NAME);
            this._warn = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:WARN`);
            this._error = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $57a32f9f887c155a$var$Logger;

});



parcelRegister("7Whb6", function(module, exports) {
"use strict";
var $5c7b465ef60ea1c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5c7b465ef60ea1c9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5c7b465ef60ea1c9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c7b465ef60ea1c9$var$__createBinding(result, mod, k);
    }
    $5c7b465ef60ea1c9$var$__setModuleDefault(result, mod);
    return result;
};
var $5c7b465ef60ea1c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transport = void 0;

var $2ico7 = parcelRequire("2ico7");

const $5c7b465ef60ea1c9$var$queue_microtask_1 = $5c7b465ef60ea1c9$var$__importDefault((parcelRequire("53epZ")));

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");

const $5c7b465ef60ea1c9$var$utils = $5c7b465ef60ea1c9$var$__importStar((parcelRequire("lghrF")));

const $5c7b465ef60ea1c9$var$ortc = $5c7b465ef60ea1c9$var$__importStar((parcelRequire("5Mq2W")));

var $ckNpk = parcelRequire("ckNpk");

var $kYlAk = parcelRequire("kYlAk");

var $7caxm = parcelRequire("7caxm");

var $9SUdt = parcelRequire("9SUdt");
const $5c7b465ef60ea1c9$var$logger = new $24uNv.Logger("Transport");
class $5c7b465ef60ea1c9$var$ConsumerCreationTask {
    constructor(consumerOptions){
        this.consumerOptions = consumerOptions;
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
class $5c7b465ef60ea1c9$var$Transport extends $bwd9s.EnhancedEventEmitter {
    /**
     * Transport id.
     */ get id() {
        return this._id;
    }
    /**
     * Whether the Transport is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Transport direction.
     */ get direction() {
        return this._direction;
    }
    /**
     * RTC handler instance.
     */ get handler() {
        return this._handler;
    }
    /**
     * ICE gathering state.
     */ get iceGatheringState() {
        return this._iceGatheringState;
    }
    /**
     * Connection state.
     */ get connectionState() {
        return this._connectionState;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Close the Transport.
     */ close() {
        if (this._closed) return;
        $5c7b465ef60ea1c9$var$logger.debug("close()");
        this._closed = true;
        // Stop the AwaitQueue.
        this._awaitQueue.stop();
        // Close the handler.
        this._handler.close();
        // Change connection state to 'closed' since the handler may not emit
        // '@connectionstatechange' event.
        this._connectionState = "closed";
        // Close all Producers.
        for (const producer of this._producers.values())producer.transportClosed();
        this._producers.clear();
        // Close all Consumers.
        for (const consumer of this._consumers.values())consumer.transportClosed();
        this._consumers.clear();
        // Close all DataProducers.
        for (const dataProducer of this._dataProducers.values())dataProducer.transportClosed();
        this._dataProducers.clear();
        // Close all DataConsumers.
        for (const dataConsumer of this._dataConsumers.values())dataConsumer.transportClosed();
        this._dataConsumers.clear();
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated Transport (RTCPeerConnection) stats.
     *
     * @returns {RTCStatsReport}
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return this._handler.getTransportStats();
    }
    /**
     * Restart ICE connection.
     */ async restartIce({ iceParameters: iceParameters }) {
        $5c7b465ef60ea1c9$var$logger.debug("restartIce()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!iceParameters) throw new TypeError("missing iceParameters");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>await this._handler.restartIce(iceParameters), "transport.restartIce()");
    }
    /**
     * Update ICE servers.
     */ async updateIceServers({ iceServers: iceServers } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("updateIceServers()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!Array.isArray(iceServers)) throw new TypeError("missing iceServers");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>this._handler.updateIceServers(iceServers), "transport.updateIceServers()");
    }
    /**
     * Create a Producer.
     */ async produce({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, stopTracks: stopTracks = true, disableTrackOnPause: disableTrackOnPause = true, zeroRtpOnPause: zeroRtpOnPause = false, onRtpSender: onRtpSender, appData: appData = {} } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("produce() [track:%o]", track);
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!track) throw new TypeError("missing track");
        else if (this._direction !== "send") throw new $roix3.UnsupportedError("not a sending Transport");
        else if (!this._canProduceByKind[track.kind]) throw new $roix3.UnsupportedError(`cannot produce ${track.kind}`);
        else if (track.readyState === "ended") throw new $roix3.InvalidStateError("track ended");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (this.listenerCount("produce") === 0) throw new TypeError('no "produce" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            let normalizedEncodings;
            if (encodings && !Array.isArray(encodings)) throw TypeError("encodings must be an array");
            else if (encodings && encodings.length === 0) normalizedEncodings = undefined;
            else if (encodings) normalizedEncodings = encodings.map((encoding)=>{
                const normalizedEncoding = {
                    active: true
                };
                if (encoding.active === false) normalizedEncoding.active = false;
                if (typeof encoding.dtx === "boolean") normalizedEncoding.dtx = encoding.dtx;
                if (typeof encoding.scalabilityMode === "string") normalizedEncoding.scalabilityMode = encoding.scalabilityMode;
                if (typeof encoding.scaleResolutionDownBy === "number") normalizedEncoding.scaleResolutionDownBy = encoding.scaleResolutionDownBy;
                if (typeof encoding.maxBitrate === "number") normalizedEncoding.maxBitrate = encoding.maxBitrate;
                if (typeof encoding.maxFramerate === "number") normalizedEncoding.maxFramerate = encoding.maxFramerate;
                if (typeof encoding.adaptivePtime === "boolean") normalizedEncoding.adaptivePtime = encoding.adaptivePtime;
                if (typeof encoding.priority === "string") normalizedEncoding.priority = encoding.priority;
                if (typeof encoding.networkPriority === "string") normalizedEncoding.networkPriority = encoding.networkPriority;
                return normalizedEncoding;
            });
            const { localId: localId, rtpParameters: rtpParameters, rtpSender: rtpSender } = await this._handler.send({
                track: track,
                encodings: normalizedEncodings,
                codecOptions: codecOptions,
                codec: codec,
                onRtpSender: onRtpSender
            });
            try {
                // This will fill rtpParameters's missing fields with default values.
                $5c7b465ef60ea1c9$var$ortc.validateRtpParameters(rtpParameters);
                const { id: id } = await new Promise((resolve, reject)=>{
                    this.safeEmit("produce", {
                        kind: track.kind,
                        rtpParameters: rtpParameters,
                        appData: appData
                    }, resolve, reject);
                });
                const producer = new $ckNpk.Producer({
                    id: id,
                    localId: localId,
                    rtpSender: rtpSender,
                    track: track,
                    rtpParameters: rtpParameters,
                    stopTracks: stopTracks,
                    disableTrackOnPause: disableTrackOnPause,
                    zeroRtpOnPause: zeroRtpOnPause,
                    appData: appData
                });
                this._producers.set(producer.id, producer);
                this.handleProducer(producer);
                // Emit observer event.
                this._observer.safeEmit("newproducer", producer);
                return producer;
            } catch (error) {
                this._handler.stopSending(localId).catch(()=>{});
                throw error;
            }
        }, "transport.produce()")// This catch is needed to stop the given track if the command above
        // failed due to closed Transport.
        .catch((error)=>{
            if (stopTracks) try {
                track.stop();
            } catch (error2) {}
            throw error;
        });
    }
    /**
     * Create a Consumer to consume a remote Producer.
     */ async consume({ id: id, producerId: producerId, kind: kind, rtpParameters: rtpParameters, streamId: streamId, onRtpReceiver: onRtpReceiver, appData: appData = {} }) {
        $5c7b465ef60ea1c9$var$logger.debug("consume()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "recv") throw new $roix3.UnsupportedError("not a receiving Transport");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof producerId !== "string") throw new TypeError("missing producerId");
        else if (kind !== "audio" && kind !== "video") throw new TypeError(`invalid kind '${kind}'`);
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Clone given RTP parameters to not modify input data.
        const clonedRtpParameters = $5c7b465ef60ea1c9$var$utils.clone(rtpParameters);
        // Ensure the device can consume it.
        const canConsume = $5c7b465ef60ea1c9$var$ortc.canReceive(clonedRtpParameters, this._extendedRtpCapabilities);
        if (!canConsume) throw new $roix3.UnsupportedError("cannot consume this Producer");
        const consumerCreationTask = new $5c7b465ef60ea1c9$var$ConsumerCreationTask({
            id: id,
            producerId: producerId,
            kind: kind,
            rtpParameters: clonedRtpParameters,
            streamId: streamId,
            onRtpReceiver: onRtpReceiver,
            appData: appData
        });
        // Store the Consumer creation task.
        this._pendingConsumerTasks.push(consumerCreationTask);
        // There is no Consumer creation in progress, create it now.
        (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
            if (this._closed) return;
            if (this._consumerCreationInProgress === false) this.createPendingConsumers();
        });
        return consumerCreationTask.promise;
    }
    /**
     * Create a DataProducer
     */ async produceData({ ordered: ordered = true, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label = "", protocol: protocol = "", appData: appData = {} } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("produceData()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "send") throw new $roix3.UnsupportedError("not a sending Transport");
        else if (!this._maxSctpMessageSize) throw new $roix3.UnsupportedError("SCTP not enabled by remote Transport");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (this.listenerCount("producedata") === 0) throw new TypeError('no "producedata" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        if (maxPacketLifeTime || maxRetransmits) ordered = false;
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            const { dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters } = await this._handler.sendDataChannel({
                ordered: ordered,
                maxPacketLifeTime: maxPacketLifeTime,
                maxRetransmits: maxRetransmits,
                label: label,
                protocol: protocol
            });
            // This will fill sctpStreamParameters's missing fields with default values.
            $5c7b465ef60ea1c9$var$ortc.validateSctpStreamParameters(sctpStreamParameters);
            const { id: id } = await new Promise((resolve, reject)=>{
                this.safeEmit("producedata", {
                    sctpStreamParameters: sctpStreamParameters,
                    label: label,
                    protocol: protocol,
                    appData: appData
                }, resolve, reject);
            });
            const dataProducer = new $7caxm.DataProducer({
                id: id,
                dataChannel: dataChannel,
                sctpStreamParameters: sctpStreamParameters,
                appData: appData
            });
            this._dataProducers.set(dataProducer.id, dataProducer);
            this.handleDataProducer(dataProducer);
            // Emit observer event.
            this._observer.safeEmit("newdataproducer", dataProducer);
            return dataProducer;
        }, "transport.produceData()");
    }
    /**
     * Create a DataConsumer
     */ async consumeData({ id: id, dataProducerId: dataProducerId, sctpStreamParameters: sctpStreamParameters, label: label = "", protocol: protocol = "", appData: appData = {} }) {
        $5c7b465ef60ea1c9$var$logger.debug("consumeData()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "recv") throw new $roix3.UnsupportedError("not a receiving Transport");
        else if (!this._maxSctpMessageSize) throw new $roix3.UnsupportedError("SCTP not enabled by remote Transport");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof dataProducerId !== "string") throw new TypeError("missing dataProducerId");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Clone given SCTP stream parameters to not modify input data.
        const clonedSctpStreamParameters = $5c7b465ef60ea1c9$var$utils.clone(sctpStreamParameters);
        // This may throw.
        $5c7b465ef60ea1c9$var$ortc.validateSctpStreamParameters(clonedSctpStreamParameters);
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            const { dataChannel: dataChannel } = await this._handler.receiveDataChannel({
                sctpStreamParameters: clonedSctpStreamParameters,
                label: label,
                protocol: protocol
            });
            const dataConsumer = new $9SUdt.DataConsumer({
                id: id,
                dataProducerId: dataProducerId,
                dataChannel: dataChannel,
                sctpStreamParameters: clonedSctpStreamParameters,
                appData: appData
            });
            this._dataConsumers.set(dataConsumer.id, dataConsumer);
            this.handleDataConsumer(dataConsumer);
            // Emit observer event.
            this._observer.safeEmit("newdataconsumer", dataConsumer);
            return dataConsumer;
        }, "transport.consumeData()");
    }
    // This method is guaranteed to never throw.
    async createPendingConsumers() {
        this._consumerCreationInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingConsumerTasks.length === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("createPendingConsumers() | there is no Consumer to be created");
                return;
            }
            const pendingConsumerTasks = [
                ...this._pendingConsumerTasks
            ];
            // Clear pending Consumer tasks.
            this._pendingConsumerTasks = [];
            // Video Consumer in order to create the probator.
            let videoConsumerForProbator = undefined;
            // Fill options list.
            const optionsList = [];
            for (const task of pendingConsumerTasks){
                const { id: id, kind: kind, rtpParameters: rtpParameters, streamId: streamId, onRtpReceiver: onRtpReceiver } = task.consumerOptions;
                optionsList.push({
                    trackId: id,
                    kind: kind,
                    rtpParameters: rtpParameters,
                    streamId: streamId,
                    onRtpReceiver: onRtpReceiver
                });
            }
            try {
                const results = await this._handler.receive(optionsList);
                for(let idx = 0; idx < results.length; ++idx){
                    const task = pendingConsumerTasks[idx];
                    const result = results[idx];
                    const { id: id, producerId: producerId, kind: kind, rtpParameters: rtpParameters, appData: appData } = task.consumerOptions;
                    const { localId: localId, rtpReceiver: rtpReceiver, track: track } = result;
                    const consumer = new $kYlAk.Consumer({
                        id: id,
                        localId: localId,
                        producerId: producerId,
                        rtpReceiver: rtpReceiver,
                        track: track,
                        rtpParameters: rtpParameters,
                        appData: appData
                    });
                    this._consumers.set(consumer.id, consumer);
                    this.handleConsumer(consumer);
                    // If this is the first video Consumer and the Consumer for RTP probation
                    // has not yet been created, it's time to create it.
                    if (!this._probatorConsumerCreated && !videoConsumerForProbator && kind === "video") videoConsumerForProbator = consumer;
                    // Emit observer event.
                    this._observer.safeEmit("newconsumer", consumer);
                    task.resolve(consumer);
                }
            } catch (error) {
                for (const task of pendingConsumerTasks)task.reject(error);
            }
            // If RTP probation must be handled, do it now.
            if (videoConsumerForProbator) try {
                const probatorRtpParameters = $5c7b465ef60ea1c9$var$ortc.generateProbatorRtpParameters(videoConsumerForProbator.rtpParameters);
                await this._handler.receive([
                    {
                        trackId: "probator",
                        kind: "video",
                        rtpParameters: probatorRtpParameters
                    }
                ]);
                $5c7b465ef60ea1c9$var$logger.debug("createPendingConsumers() | Consumer for RTP probation created");
                this._probatorConsumerCreated = true;
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("createPendingConsumers() | failed to create Consumer for RTP probation:%o", error);
            }
        }, "transport.createPendingConsumers()").then(()=>{
            this._consumerCreationInProgress = false;
            // There are pending Consumer tasks, enqueue their creation.
            if (this._pendingConsumerTasks.length > 0) this.createPendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    pausePendingConsumers() {
        this._consumerPauseInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingPauseConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("pausePendingConsumers() | there is no Consumer to be paused");
                return;
            }
            const pendingPauseConsumers = Array.from(this._pendingPauseConsumers.values());
            // Clear pending pause Consumer map.
            this._pendingPauseConsumers.clear();
            try {
                const localIds = pendingPauseConsumers.map((consumer)=>consumer.localId);
                await this._handler.pauseReceiving(localIds);
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("pausePendingConsumers() | failed to pause Consumers:", error);
            }
        }, "transport.pausePendingConsumers").then(()=>{
            this._consumerPauseInProgress = false;
            // There are pending Consumers to be paused, do it.
            if (this._pendingPauseConsumers.size > 0) this.pausePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    resumePendingConsumers() {
        this._consumerResumeInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingResumeConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("resumePendingConsumers() | there is no Consumer to be resumed");
                return;
            }
            const pendingResumeConsumers = Array.from(this._pendingResumeConsumers.values());
            // Clear pending resume Consumer map.
            this._pendingResumeConsumers.clear();
            try {
                const localIds = pendingResumeConsumers.map((consumer)=>consumer.localId);
                await this._handler.resumeReceiving(localIds);
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("resumePendingConsumers() | failed to resume Consumers:", error);
            }
        }, "transport.resumePendingConsumers").then(()=>{
            this._consumerResumeInProgress = false;
            // There are pending Consumer to be resumed, do it.
            if (this._pendingResumeConsumers.size > 0) this.resumePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    closePendingConsumers() {
        this._consumerCloseInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingCloseConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("closePendingConsumers() | there is no Consumer to be closed");
                return;
            }
            const pendingCloseConsumers = Array.from(this._pendingCloseConsumers.values());
            // Clear pending close Consumer map.
            this._pendingCloseConsumers.clear();
            try {
                await this._handler.stopReceiving(pendingCloseConsumers.map((consumer)=>consumer.localId));
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("closePendingConsumers() | failed to close Consumers:", error);
            }
        }, "transport.closePendingConsumers").then(()=>{
            this._consumerCloseInProgress = false;
            // There are pending Consumer to be resumed, do it.
            if (this._pendingCloseConsumers.size > 0) this.closePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    handleHandler() {
        const handler = this._handler;
        handler.on("@connect", ({ dtlsParameters: dtlsParameters }, callback, errback)=>{
            if (this._closed) {
                errback(new $roix3.InvalidStateError("closed"));
                return;
            }
            this.safeEmit("connect", {
                dtlsParameters: dtlsParameters
            }, callback, errback);
        });
        handler.on("@icegatheringstatechange", (iceGatheringState)=>{
            if (iceGatheringState === this._iceGatheringState) return;
            $5c7b465ef60ea1c9$var$logger.debug("ICE gathering state changed to %s", iceGatheringState);
            this._iceGatheringState = iceGatheringState;
            if (!this._closed) this.safeEmit("icegatheringstatechange", iceGatheringState);
        });
        handler.on("@connectionstatechange", (connectionState)=>{
            if (connectionState === this._connectionState) return;
            $5c7b465ef60ea1c9$var$logger.debug("connection state changed to %s", connectionState);
            this._connectionState = connectionState;
            if (!this._closed) this.safeEmit("connectionstatechange", connectionState);
        });
    }
    handleProducer(producer) {
        producer.on("@close", ()=>{
            this._producers.delete(producer.id);
            if (this._closed) return;
            this._awaitQueue.push(async ()=>await this._handler.stopSending(producer.localId), "producer @close event").catch((error)=>$5c7b465ef60ea1c9$var$logger.warn("producer.close() failed:%o", error));
        });
        producer.on("@pause", (callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.pauseSending(producer.localId), "producer @pause event").then(callback).catch(errback);
        });
        producer.on("@resume", (callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.resumeSending(producer.localId), "producer @resume event").then(callback).catch(errback);
        });
        producer.on("@replacetrack", (track, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.replaceTrack(producer.localId, track), "producer @replacetrack event").then(callback).catch(errback);
        });
        producer.on("@setmaxspatiallayer", (spatialLayer, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.setMaxSpatialLayer(producer.localId, spatialLayer), "producer @setmaxspatiallayer event").then(callback).catch(errback);
        });
        producer.on("@setrtpencodingparameters", (params, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.setRtpEncodingParameters(producer.localId, params), "producer @setrtpencodingparameters event").then(callback).catch(errback);
        });
        producer.on("@getstats", (callback, errback)=>{
            if (this._closed) return errback(new $roix3.InvalidStateError("closed"));
            this._handler.getSenderStats(producer.localId).then(callback).catch(errback);
        });
    }
    handleConsumer(consumer) {
        consumer.on("@close", ()=>{
            this._consumers.delete(consumer.id);
            this._pendingPauseConsumers.delete(consumer.id);
            this._pendingResumeConsumers.delete(consumer.id);
            if (this._closed) return;
            // Store the Consumer into the close list.
            this._pendingCloseConsumers.set(consumer.id, consumer);
            // There is no Consumer close in progress, do it now.
            if (this._consumerCloseInProgress === false) this.closePendingConsumers();
        });
        consumer.on("@pause", ()=>{
            // If Consumer is pending to be resumed, remove from pending resume list.
            if (this._pendingResumeConsumers.has(consumer.id)) this._pendingResumeConsumers.delete(consumer.id);
            // Store the Consumer into the pending list.
            this._pendingPauseConsumers.set(consumer.id, consumer);
            // There is no Consumer pause in progress, do it now.
            (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
                if (this._closed) return;
                if (this._consumerPauseInProgress === false) this.pausePendingConsumers();
            });
        });
        consumer.on("@resume", ()=>{
            // If Consumer is pending to be paused, remove from pending pause list.
            if (this._pendingPauseConsumers.has(consumer.id)) this._pendingPauseConsumers.delete(consumer.id);
            // Store the Consumer into the pending list.
            this._pendingResumeConsumers.set(consumer.id, consumer);
            // There is no Consumer resume in progress, do it now.
            (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
                if (this._closed) return;
                if (this._consumerResumeInProgress === false) this.resumePendingConsumers();
            });
        });
        consumer.on("@getstats", (callback, errback)=>{
            if (this._closed) return errback(new $roix3.InvalidStateError("closed"));
            this._handler.getReceiverStats(consumer.localId).then(callback).catch(errback);
        });
    }
    handleDataProducer(dataProducer) {
        dataProducer.on("@close", ()=>{
            this._dataProducers.delete(dataProducer.id);
        });
    }
    handleDataConsumer(dataConsumer) {
        dataConsumer.on("@close", ()=>{
            this._dataConsumers.delete(dataConsumer.id);
        });
    }
    constructor({ direction: direction, id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData, handlerFactory: handlerFactory, extendedRtpCapabilities: extendedRtpCapabilities, canProduceByKind: canProduceByKind }){
        super();
        // Closed flag.
        this._closed = false;
        // Transport ICE gathering state.
        this._iceGatheringState = "new";
        // Transport connection state.
        this._connectionState = "new";
        // Map of Producers indexed by id.
        this._producers = new Map();
        // Map of Consumers indexed by id.
        this._consumers = new Map();
        // Map of DataProducers indexed by id.
        this._dataProducers = new Map();
        // Map of DataConsumers indexed by id.
        this._dataConsumers = new Map();
        // Whether the Consumer for RTP probation has been created.
        this._probatorConsumerCreated = false;
        // AwaitQueue instance to make async tasks happen sequentially.
        this._awaitQueue = new $2ico7.AwaitQueue();
        // Consumer creation tasks awaiting to be processed.
        this._pendingConsumerTasks = [];
        // Consumer creation in progress flag.
        this._consumerCreationInProgress = false;
        // Consumers pending to be paused.
        this._pendingPauseConsumers = new Map();
        // Consumer pause in progress flag.
        this._consumerPauseInProgress = false;
        // Consumers pending to be resumed.
        this._pendingResumeConsumers = new Map();
        // Consumer resume in progress flag.
        this._consumerResumeInProgress = false;
        // Consumers pending to be closed.
        this._pendingCloseConsumers = new Map();
        // Consumer close in progress flag.
        this._consumerCloseInProgress = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $5c7b465ef60ea1c9$var$logger.debug("constructor() [id:%s, direction:%s]", id, direction);
        this._id = id;
        this._direction = direction;
        this._extendedRtpCapabilities = extendedRtpCapabilities;
        this._canProduceByKind = canProduceByKind;
        this._maxSctpMessageSize = sctpParameters ? sctpParameters.maxMessageSize : null;
        // Clone and sanitize additionalSettings.
        const clonedAdditionalSettings = $5c7b465ef60ea1c9$var$utils.clone(additionalSettings) || {};
        delete clonedAdditionalSettings.iceServers;
        delete clonedAdditionalSettings.iceTransportPolicy;
        delete clonedAdditionalSettings.bundlePolicy;
        delete clonedAdditionalSettings.rtcpMuxPolicy;
        delete clonedAdditionalSettings.sdpSemantics;
        this._handler = handlerFactory();
        this._handler.run({
            direction: direction,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: clonedAdditionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            extendedRtpCapabilities: extendedRtpCapabilities
        });
        this._appData = appData || {};
        this.handleHandler();
    }
}
module.exports.Transport = $5c7b465ef60ea1c9$var$Transport;

});
parcelRegister("2ico7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwaitQueue = module.exports.AwaitQueueRemovedTaskError = module.exports.AwaitQueueStoppedError = void 0;

var $86d5L = parcelRequire("86d5L");
const $1ab6df368975d2f5$var$logger = new $86d5L.Logger();
/**
 * Custom Error derived class used to reject pending tasks once stop() method
 * has been called.
 */ class $1ab6df368975d2f5$var$AwaitQueueStoppedError extends Error {
    constructor(message){
        super(message !== null && message !== void 0 ? message : "AwaitQueue stopped");
        this.name = "AwaitQueueStoppedError";
        // @ts-ignore
        if (typeof Error.captureStackTrace === "function") // @ts-ignore
        Error.captureStackTrace(this, $1ab6df368975d2f5$var$AwaitQueueStoppedError);
    }
}
module.exports.AwaitQueueStoppedError = $1ab6df368975d2f5$var$AwaitQueueStoppedError;
/**
 * Custom Error derived class used to reject pending tasks once removeTask()
 * method has been called.
 */ class $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError extends Error {
    constructor(message){
        super(message !== null && message !== void 0 ? message : "AwaitQueue task removed");
        this.name = "AwaitQueueRemovedTaskError";
        // @ts-ignore
        if (typeof Error.captureStackTrace === "function") // @ts-ignore
        Error.captureStackTrace(this, $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError);
    }
}
module.exports.AwaitQueueRemovedTaskError = $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError;
class $1ab6df368975d2f5$var$AwaitQueue {
    get size() {
        return this.pendingTasks.size;
    }
    async push(task, name) {
        name = name !== null && name !== void 0 ? name : task.name;
        $1ab6df368975d2f5$var$logger.debug(`push() [name:${name}]`);
        if (typeof task !== "function") throw new TypeError("given task is not a function");
        if (name) try {
            Object.defineProperty(task, "name", {
                value: name
            });
        } catch (error) {}
        return new Promise((resolve, reject)=>{
            const pendingTask = {
                id: this.nextTaskId++,
                task: task,
                name: name,
                enqueuedAt: Date.now(),
                executedAt: undefined,
                completed: false,
                resolve: (result)=>{
                    // pendingTask.resolve() can only be called in execute() method. Since
                    // resolve() was called it means that the task successfully completed.
                    // However the task may have been stopped before it completed (via
                    // stop() or remove()) so its completed flag was already set. If this
                    // is the case, abort here since next task (if any) is already being
                    // executed.
                    if (pendingTask.completed) return;
                    pendingTask.completed = true;
                    // Remove the task from the queue.
                    this.pendingTasks.delete(pendingTask.id);
                    $1ab6df368975d2f5$var$logger.debug(`resolving task [name:${pendingTask.name}]`);
                    // Resolve the task with the obtained result.
                    resolve(result);
                    // Execute the next pending task (if any).
                    const [nextPendingTask] = this.pendingTasks.values();
                    // NOTE: During the resolve() callback the user app may have interacted
                    // with the queue. For instance, the app may have pushed a task while
                    // the queue was empty so such a task is already being executed. If so,
                    // don't execute it twice.
                    if (nextPendingTask && !nextPendingTask.executedAt) this.execute(nextPendingTask);
                },
                reject: (error)=>{
                    // pendingTask.reject() can be called within execute() method if the
                    // task completed with error. However it may have also been called in
                    // stop() or remove() methods (before or while being executed) so its
                    // completed flag was already set. If so, abort here since next task
                    // (if any) is already being executed.
                    if (pendingTask.completed) return;
                    pendingTask.completed = true;
                    // Remove the task from the queue.
                    this.pendingTasks.delete(pendingTask.id);
                    $1ab6df368975d2f5$var$logger.debug(`rejecting task [name:${pendingTask.name}]: %s`, String(error));
                    // Reject the task with the obtained error.
                    reject(error);
                    // Execute the next pending task (if any) unless stop() is running.
                    if (!this.stopping) {
                        const [nextPendingTask] = this.pendingTasks.values();
                        // NOTE: During the reject() callback the user app may have interacted
                        // with the queue. For instance, the app may have pushed a task while
                        // the queue was empty so such a task is already being executed. If so,
                        // don't execute it twice.
                        if (nextPendingTask && !nextPendingTask.executedAt) this.execute(nextPendingTask);
                    }
                }
            };
            // Append task to the queue.
            this.pendingTasks.set(pendingTask.id, pendingTask);
            // And execute it if this is the only task in the queue.
            if (this.pendingTasks.size === 1) this.execute(pendingTask);
        });
    }
    stop() {
        $1ab6df368975d2f5$var$logger.debug("stop()");
        this.stopping = true;
        for (const pendingTask of this.pendingTasks.values()){
            $1ab6df368975d2f5$var$logger.debug(`stop() | stopping task [name:${pendingTask.name}]`);
            pendingTask.reject(new $1ab6df368975d2f5$var$AwaitQueueStoppedError());
        }
        this.stopping = false;
    }
    remove(taskIdx) {
        $1ab6df368975d2f5$var$logger.debug(`remove() [taskIdx:${taskIdx}]`);
        const pendingTask = Array.from(this.pendingTasks.values())[taskIdx];
        if (!pendingTask) {
            $1ab6df368975d2f5$var$logger.debug(`stop() | no task with given idx [taskIdx:${taskIdx}]`);
            return;
        }
        pendingTask.reject(new $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError());
    }
    dump() {
        const now = Date.now();
        let idx = 0;
        return Array.from(this.pendingTasks.values()).map((pendingTask)=>({
                idx: idx++,
                task: pendingTask.task,
                name: pendingTask.name,
                enqueuedTime: pendingTask.executedAt ? pendingTask.executedAt - pendingTask.enqueuedAt : now - pendingTask.enqueuedAt,
                executionTime: pendingTask.executedAt ? now - pendingTask.executedAt : 0
            }));
    }
    async execute(pendingTask) {
        $1ab6df368975d2f5$var$logger.debug(`execute() [name:${pendingTask.name}]`);
        if (pendingTask.executedAt) throw new Error("task already being executed");
        pendingTask.executedAt = Date.now();
        try {
            const result = await pendingTask.task();
            // Resolve the task with its resolved result (if any).
            pendingTask.resolve(result);
        } catch (error) {
            // Reject the task with its rejected error.
            pendingTask.reject(error);
        }
    }
    constructor(){
        // Queue of pending tasks (map of PendingTasks indexed by id).
        this.pendingTasks = new Map();
        // Incrementing PendingTask id.
        this.nextTaskId = 0;
        // Whether stop() method is stopping all pending tasks.
        this.stopping = false;
    }
}
module.exports.AwaitQueue = $1ab6df368975d2f5$var$AwaitQueue;

});
parcelRegister("86d5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $8pLEx = parcelRequire("8pLEx");
const $5e590a0a8787efd3$var$LIB_NAME = "awaitqueue";
class $5e590a0a8787efd3$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:${prefix}`);
            this._warn = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:WARN:${prefix}`);
            this._error = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $8pLEx.default)($5e590a0a8787efd3$var$LIB_NAME);
            this._warn = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:WARN`);
            this._error = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $5e590a0a8787efd3$var$Logger;

});


parcelRegister("53epZ", function(module, exports) {
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $3ad86ab5cd139a90$var$promise;
module.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($3ad86ab5cd139a90$var$promise || ($3ad86ab5cd139a90$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));

});

parcelRegister("ckNpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Producer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $8fadad93d4ad3e47$var$logger = new $24uNv.Logger("Producer");
class $8fadad93d4ad3e47$var$Producer extends $bwd9s.EnhancedEventEmitter {
    /**
     * Producer id.
     */ get id() {
        return this._id;
    }
    /**
     * Local id.
     */ get localId() {
        return this._localId;
    }
    /**
     * Whether the Producer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Media kind.
     */ get kind() {
        return this._kind;
    }
    /**
     * Associated RTCRtpSender.
     */ get rtpSender() {
        return this._rtpSender;
    }
    /**
     * The associated track.
     */ get track() {
        return this._track;
    }
    /**
     * RTP parameters.
     */ get rtpParameters() {
        return this._rtpParameters;
    }
    /**
     * Whether the Producer is paused.
     */ get paused() {
        return this._paused;
    }
    /**
     * Max spatial layer.
     *
     * @type {Number | undefined}
     */ get maxSpatialLayer() {
        return this._maxSpatialLayer;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the Producer.
     */ close() {
        if (this._closed) return;
        $8fadad93d4ad3e47$var$logger.debug("close()");
        this._closed = true;
        this.destroyTrack();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $8fadad93d4ad3e47$var$logger.debug("transportClosed()");
        this._closed = true;
        this.destroyTrack();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated RTCRtpSender stats.
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return new Promise((resolve, reject)=>{
            this.safeEmit("@getstats", resolve, reject);
        });
    }
    /**
     * Pauses sending media.
     */ pause() {
        $8fadad93d4ad3e47$var$logger.debug("pause()");
        if (this._closed) {
            $8fadad93d4ad3e47$var$logger.error("pause() | Producer closed");
            return;
        }
        this._paused = true;
        if (this._track && this._disableTrackOnPause) this._track.enabled = false;
        if (this._zeroRtpOnPause) new Promise((resolve, reject)=>{
            this.safeEmit("@pause", resolve, reject);
        }).catch(()=>{});
        // Emit observer event.
        this._observer.safeEmit("pause");
    }
    /**
     * Resumes sending media.
     */ resume() {
        $8fadad93d4ad3e47$var$logger.debug("resume()");
        if (this._closed) {
            $8fadad93d4ad3e47$var$logger.error("resume() | Producer closed");
            return;
        }
        this._paused = false;
        if (this._track && this._disableTrackOnPause) this._track.enabled = true;
        if (this._zeroRtpOnPause) new Promise((resolve, reject)=>{
            this.safeEmit("@resume", resolve, reject);
        }).catch(()=>{});
        // Emit observer event.
        this._observer.safeEmit("resume");
    }
    /**
     * Replaces the current track with a new one or null.
     */ async replaceTrack({ track: track }) {
        $8fadad93d4ad3e47$var$logger.debug("replaceTrack() [track:%o]", track);
        if (this._closed) {
            // This must be done here. Otherwise there is no chance to stop the given
            // track.
            if (track && this._stopTracks) try {
                track.stop();
            } catch (error) {}
            throw new $roix3.InvalidStateError("closed");
        } else if (track && track.readyState === "ended") throw new $roix3.InvalidStateError("track ended");
        // Do nothing if this is the same track as the current handled one.
        if (track === this._track) {
            $8fadad93d4ad3e47$var$logger.debug("replaceTrack() | same track, ignored");
            return;
        }
        await new Promise((resolve, reject)=>{
            this.safeEmit("@replacetrack", track, resolve, reject);
        });
        // Destroy the previous track.
        this.destroyTrack();
        // Set the new track.
        this._track = track;
        // If this Producer was paused/resumed and the state of the new
        // track does not match, fix it.
        if (this._track && this._disableTrackOnPause) {
            if (!this._paused) this._track.enabled = true;
            else if (this._paused) this._track.enabled = false;
        }
        // Handle the effective track.
        this.handleTrack();
    }
    /**
     * Sets the video max spatial layer to be sent.
     */ async setMaxSpatialLayer(spatialLayer) {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._kind !== "video") throw new $roix3.UnsupportedError("not a video Producer");
        else if (typeof spatialLayer !== "number") throw new TypeError("invalid spatialLayer");
        if (spatialLayer === this._maxSpatialLayer) return;
        await new Promise((resolve, reject)=>{
            this.safeEmit("@setmaxspatiallayer", spatialLayer, resolve, reject);
        }).catch(()=>{});
        this._maxSpatialLayer = spatialLayer;
    }
    async setRtpEncodingParameters(params) {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (typeof params !== "object") throw new TypeError("invalid params");
        await new Promise((resolve, reject)=>{
            this.safeEmit("@setrtpencodingparameters", params, resolve, reject);
        });
    }
    onTrackEnded() {
        $8fadad93d4ad3e47$var$logger.debug('track "ended" event');
        this.safeEmit("trackended");
        // Emit observer event.
        this._observer.safeEmit("trackended");
    }
    handleTrack() {
        if (!this._track) return;
        this._track.addEventListener("ended", this.onTrackEnded);
    }
    destroyTrack() {
        if (!this._track) return;
        try {
            this._track.removeEventListener("ended", this.onTrackEnded);
            // Just stop the track unless the app set stopTracks: false.
            if (this._stopTracks) this._track.stop();
        } catch (error) {}
    }
    constructor({ id: id, localId: localId, rtpSender: rtpSender, track: track, rtpParameters: rtpParameters, stopTracks: stopTracks, disableTrackOnPause: disableTrackOnPause, zeroRtpOnPause: zeroRtpOnPause, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $8fadad93d4ad3e47$var$logger.debug("constructor()");
        this._id = id;
        this._localId = localId;
        this._rtpSender = rtpSender;
        this._track = track;
        this._kind = track.kind;
        this._rtpParameters = rtpParameters;
        this._paused = disableTrackOnPause ? !track.enabled : false;
        this._maxSpatialLayer = undefined;
        this._stopTracks = stopTracks;
        this._disableTrackOnPause = disableTrackOnPause;
        this._zeroRtpOnPause = zeroRtpOnPause;
        this._appData = appData || {};
        this.onTrackEnded = this.onTrackEnded.bind(this);
        // NOTE: Minor issue. If zeroRtpOnPause is true, we cannot emit the
        // '@replacetrack' event here, so RTCRtpSender.track won't be null.
        this.handleTrack();
    }
}
module.exports.Producer = $8fadad93d4ad3e47$var$Producer;

});

parcelRegister("kYlAk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consumer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $f44a278bf79cbd61$var$logger = new $24uNv.Logger("Consumer");
class $f44a278bf79cbd61$var$Consumer extends $bwd9s.EnhancedEventEmitter {
    /**
     * Consumer id.
     */ get id() {
        return this._id;
    }
    /**
     * Local id.
     */ get localId() {
        return this._localId;
    }
    /**
     * Associated Producer id.
     */ get producerId() {
        return this._producerId;
    }
    /**
     * Whether the Consumer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Media kind.
     */ get kind() {
        return this._track.kind;
    }
    /**
     * Associated RTCRtpReceiver.
     */ get rtpReceiver() {
        return this._rtpReceiver;
    }
    /**
     * The associated track.
     */ get track() {
        return this._track;
    }
    /**
     * RTP parameters.
     */ get rtpParameters() {
        return this._rtpParameters;
    }
    /**
     * Whether the Consumer is paused.
     */ get paused() {
        return this._paused;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the Consumer.
     */ close() {
        if (this._closed) return;
        $f44a278bf79cbd61$var$logger.debug("close()");
        this._closed = true;
        this.destroyTrack();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $f44a278bf79cbd61$var$logger.debug("transportClosed()");
        this._closed = true;
        this.destroyTrack();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated RTCRtpReceiver stats.
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return new Promise((resolve, reject)=>{
            this.safeEmit("@getstats", resolve, reject);
        });
    }
    /**
     * Pauses receiving media.
     */ pause() {
        $f44a278bf79cbd61$var$logger.debug("pause()");
        if (this._closed) {
            $f44a278bf79cbd61$var$logger.error("pause() | Consumer closed");
            return;
        }
        if (this._paused) {
            $f44a278bf79cbd61$var$logger.debug("pause() | Consumer is already paused");
            return;
        }
        this._paused = true;
        this._track.enabled = false;
        this.emit("@pause");
        // Emit observer event.
        this._observer.safeEmit("pause");
    }
    /**
     * Resumes receiving media.
     */ resume() {
        $f44a278bf79cbd61$var$logger.debug("resume()");
        if (this._closed) {
            $f44a278bf79cbd61$var$logger.error("resume() | Consumer closed");
            return;
        }
        if (!this._paused) {
            $f44a278bf79cbd61$var$logger.debug("resume() | Consumer is already resumed");
            return;
        }
        this._paused = false;
        this._track.enabled = true;
        this.emit("@resume");
        // Emit observer event.
        this._observer.safeEmit("resume");
    }
    onTrackEnded() {
        $f44a278bf79cbd61$var$logger.debug('track "ended" event');
        this.safeEmit("trackended");
        // Emit observer event.
        this._observer.safeEmit("trackended");
    }
    handleTrack() {
        this._track.addEventListener("ended", this.onTrackEnded);
    }
    destroyTrack() {
        try {
            this._track.removeEventListener("ended", this.onTrackEnded);
            this._track.stop();
        } catch (error) {}
    }
    constructor({ id: id, localId: localId, producerId: producerId, rtpReceiver: rtpReceiver, track: track, rtpParameters: rtpParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $f44a278bf79cbd61$var$logger.debug("constructor()");
        this._id = id;
        this._localId = localId;
        this._producerId = producerId;
        this._rtpReceiver = rtpReceiver;
        this._track = track;
        this._rtpParameters = rtpParameters;
        this._paused = !track.enabled;
        this._appData = appData || {};
        this.onTrackEnded = this.onTrackEnded.bind(this);
        this.handleTrack();
    }
}
module.exports.Consumer = $f44a278bf79cbd61$var$Consumer;

});

parcelRegister("7caxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataProducer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $53d1d3d9cc30e8ad$var$logger = new $24uNv.Logger("DataProducer");
class $53d1d3d9cc30e8ad$var$DataProducer extends $bwd9s.EnhancedEventEmitter {
    /**
     * DataProducer id.
     */ get id() {
        return this._id;
    }
    /**
     * Whether the DataProducer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * SCTP stream parameters.
     */ get sctpStreamParameters() {
        return this._sctpStreamParameters;
    }
    /**
     * DataChannel readyState.
     */ get readyState() {
        return this._dataChannel.readyState;
    }
    /**
     * DataChannel label.
     */ get label() {
        return this._dataChannel.label;
    }
    /**
     * DataChannel protocol.
     */ get protocol() {
        return this._dataChannel.protocol;
    }
    /**
     * DataChannel bufferedAmount.
     */ get bufferedAmount() {
        return this._dataChannel.bufferedAmount;
    }
    /**
     * DataChannel bufferedAmountLowThreshold.
     */ get bufferedAmountLowThreshold() {
        return this._dataChannel.bufferedAmountLowThreshold;
    }
    /**
     * Set DataChannel bufferedAmountLowThreshold.
     */ set bufferedAmountLowThreshold(bufferedAmountLowThreshold) {
        this._dataChannel.bufferedAmountLowThreshold = bufferedAmountLowThreshold;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the DataProducer.
     */ close() {
        if (this._closed) return;
        $53d1d3d9cc30e8ad$var$logger.debug("close()");
        this._closed = true;
        this._dataChannel.close();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $53d1d3d9cc30e8ad$var$logger.debug("transportClosed()");
        this._closed = true;
        this._dataChannel.close();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Send a message.
     *
     * @param {String|Blob|ArrayBuffer|ArrayBufferView} data.
     */ send(data) {
        $53d1d3d9cc30e8ad$var$logger.debug("send()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        this._dataChannel.send(data);
    }
    handleDataChannel() {
        this._dataChannel.addEventListener("open", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.debug('DataChannel "open" event');
            this.safeEmit("open");
        });
        this._dataChannel.addEventListener("error", (event)=>{
            if (this._closed) return;
            let { error: error } = event;
            if (!error) error = new Error("unknown DataChannel error");
            if (error.errorDetail === "sctp-failure") $53d1d3d9cc30e8ad$var$logger.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", error.sctpCauseCode, error.message);
            else $53d1d3d9cc30e8ad$var$logger.error('DataChannel "error" event: %o', error);
            this.safeEmit("error", error);
        });
        this._dataChannel.addEventListener("close", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.warn('DataChannel "close" event');
            this._closed = true;
            this.emit("@close");
            this.safeEmit("close");
            // Emit observer event.
            this._observer.safeEmit("close");
        });
        this._dataChannel.addEventListener("message", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.warn('DataChannel "message" event in a DataProducer, message discarded');
        });
        this._dataChannel.addEventListener("bufferedamountlow", ()=>{
            if (this._closed) return;
            this.safeEmit("bufferedamountlow");
        });
    }
    constructor({ id: id, dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $53d1d3d9cc30e8ad$var$logger.debug("constructor()");
        this._id = id;
        this._dataChannel = dataChannel;
        this._sctpStreamParameters = sctpStreamParameters;
        this._appData = appData || {};
        this.handleDataChannel();
    }
}
module.exports.DataProducer = $53d1d3d9cc30e8ad$var$DataProducer;

});

parcelRegister("9SUdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataConsumer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");
const $7324c39726fac176$var$logger = new $24uNv.Logger("DataConsumer");
class $7324c39726fac176$var$DataConsumer extends $bwd9s.EnhancedEventEmitter {
    /**
     * DataConsumer id.
     */ get id() {
        return this._id;
    }
    /**
     * Associated DataProducer id.
     */ get dataProducerId() {
        return this._dataProducerId;
    }
    /**
     * Whether the DataConsumer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * SCTP stream parameters.
     */ get sctpStreamParameters() {
        return this._sctpStreamParameters;
    }
    /**
     * DataChannel readyState.
     */ get readyState() {
        return this._dataChannel.readyState;
    }
    /**
     * DataChannel label.
     */ get label() {
        return this._dataChannel.label;
    }
    /**
     * DataChannel protocol.
     */ get protocol() {
        return this._dataChannel.protocol;
    }
    /**
     * DataChannel binaryType.
     */ get binaryType() {
        return this._dataChannel.binaryType;
    }
    /**
     * Set DataChannel binaryType.
     */ set binaryType(binaryType) {
        this._dataChannel.binaryType = binaryType;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the DataConsumer.
     */ close() {
        if (this._closed) return;
        $7324c39726fac176$var$logger.debug("close()");
        this._closed = true;
        this._dataChannel.close();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $7324c39726fac176$var$logger.debug("transportClosed()");
        this._closed = true;
        this._dataChannel.close();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    handleDataChannel() {
        this._dataChannel.addEventListener("open", ()=>{
            if (this._closed) return;
            $7324c39726fac176$var$logger.debug('DataChannel "open" event');
            this.safeEmit("open");
        });
        this._dataChannel.addEventListener("error", (event)=>{
            if (this._closed) return;
            let { error: error } = event;
            if (!error) error = new Error("unknown DataChannel error");
            if (error.errorDetail === "sctp-failure") $7324c39726fac176$var$logger.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", error.sctpCauseCode, error.message);
            else $7324c39726fac176$var$logger.error('DataChannel "error" event: %o', error);
            this.safeEmit("error", error);
        });
        this._dataChannel.addEventListener("close", ()=>{
            if (this._closed) return;
            $7324c39726fac176$var$logger.warn('DataChannel "close" event');
            this._closed = true;
            this.emit("@close");
            this.safeEmit("close");
            // Emit observer event.
            this._observer.safeEmit("close");
        });
        this._dataChannel.addEventListener("message", (event)=>{
            if (this._closed) return;
            this.safeEmit("message", event.data);
        });
    }
    constructor({ id: id, dataProducerId: dataProducerId, dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $7324c39726fac176$var$logger.debug("constructor()");
        this._id = id;
        this._dataProducerId = dataProducerId;
        this._dataChannel = dataChannel;
        this._sctpStreamParameters = sctpStreamParameters;
        this._appData = appData || {};
        this.handleDataChannel();
    }
}
module.exports.DataConsumer = $7324c39726fac176$var$DataConsumer;

});


parcelRegister("4ZvCd", function(module, exports) {
"use strict";
var $3a2562182f54bdd8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3a2562182f54bdd8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3a2562182f54bdd8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3a2562182f54bdd8$var$__createBinding(result, mod, k);
    }
    $3a2562182f54bdd8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome111 = void 0;

const $3a2562182f54bdd8$var$sdpTransform = $3a2562182f54bdd8$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $3a2562182f54bdd8$var$utils = $3a2562182f54bdd8$var$__importStar((parcelRequire("lghrF")));

const $3a2562182f54bdd8$var$ortc = $3a2562182f54bdd8$var$__importStar((parcelRequire("5Mq2W")));

const $3a2562182f54bdd8$var$sdpCommonUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("a2dIr")));

const $3a2562182f54bdd8$var$sdpUnifiedPlanUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("ghGMB")));

const $3a2562182f54bdd8$var$ortcUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $3a2562182f54bdd8$var$logger = new $24uNv.Logger("Chrome111");
const $3a2562182f54bdd8$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $3a2562182f54bdd8$var$Chrome111 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $3a2562182f54bdd8$var$Chrome111();
    }
    get name() {
        return "Chrome111";
    }
    close() {
        $3a2562182f54bdd8$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $3a2562182f54bdd8$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $3a2562182f54bdd8$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $3a2562182f54bdd8$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $3a2562182f54bdd8$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $3a2562182f54bdd8$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $3a2562182f54bdd8$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $3a2562182f54bdd8$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $3a2562182f54bdd8$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $3a2562182f54bdd8$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else {
            $3a2562182f54bdd8$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            this._pc.addEventListener("iceconnectionstatechange", ()=>{
                switch(this._pc.iceConnectionState){
                    case "checking":
                        this.emit("@connectionstatechange", "connecting");
                        break;
                    case "connected":
                    case "completed":
                        this.emit("@connectionstatechange", "connected");
                        break;
                    case "failed":
                        this.emit("@connectionstatechange", "failed");
                        break;
                    case "disconnected":
                        this.emit("@connectionstatechange", "disconnected");
                        break;
                    case "closed":
                        this.emit("@connectionstatechange", "closed");
                        break;
                }
            });
        }
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) {
            // Set rid and verify scalabilityMode in each encoding.
            // NOTE: Even if WebRTC allows different scalabilityMode (different number
            // of temporal layers) per simulcast stream, we need that those are the
            // same in all them, so let's pick up the highest value.
            // NOTE: If scalabilityMode is not given, Chrome will use L1T3.
            let maxTemporalLayers = 1;
            for (const encoding of encodings){
                const temporalLayers = encoding.scalabilityMode ? (0, $2VyLC.parse)(encoding.scalabilityMode).temporalLayers : 3;
                if (temporalLayers > maxTemporalLayers) maxTemporalLayers = temporalLayers;
            }
            encodings.forEach((encoding, idx)=>{
                encoding.rid = `r${idx}`;
                encoding.scalabilityMode = `L1T${maxTemporalLayers}`;
            });
        }
        const sendingRtpParameters = $3a2562182f54bdd8$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $3a2562182f54bdd8$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $3a2562182f54bdd8$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $3a2562182f54bdd8$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        const offer = await this._pc.createOffer();
        let localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $3a2562182f54bdd8$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $3a2562182f54bdd8$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $3a2562182f54bdd8$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $3a2562182f54bdd8$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $3a2562182f54bdd8$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $3a2562182f54bdd8$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $3a2562182f54bdd8$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $3a2562182f54bdd8$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $3a2562182f54bdd8$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $3a2562182f54bdd8$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $3a2562182f54bdd8$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $3a2562182f54bdd8$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $3a2562182f54bdd8$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $3a2562182f54bdd8$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome111 = $3a2562182f54bdd8$var$Chrome111;

});
parcelRegister("8j7qr", function(module, exports) {

$parcel$export(module.exports, "write", function () { return $60c5dba4668e0873$export$68d8715fc104d294; }, function (v) { return $60c5dba4668e0873$export$68d8715fc104d294 = v; });
$parcel$export(module.exports, "parse", function () { return $60c5dba4668e0873$export$98e6a39c04603d36; }, function (v) { return $60c5dba4668e0873$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "parseParams", function () { return $60c5dba4668e0873$export$ef804106d1571703; }, function (v) { return $60c5dba4668e0873$export$ef804106d1571703 = v; });
$parcel$export(module.exports, "parseFmtpConfig", function () { return $60c5dba4668e0873$export$dfeb1045bffe1ff8; }, function (v) { return $60c5dba4668e0873$export$dfeb1045bffe1ff8 = v; });
$parcel$export(module.exports, "parsePayloads", function () { return $60c5dba4668e0873$export$326874e595fb968b; }, function (v) { return $60c5dba4668e0873$export$326874e595fb968b = v; });
$parcel$export(module.exports, "parseRemoteCandidates", function () { return $60c5dba4668e0873$export$705b3971a35c200; }, function (v) { return $60c5dba4668e0873$export$705b3971a35c200 = v; });
$parcel$export(module.exports, "parseImageAttributes", function () { return $60c5dba4668e0873$export$1ca60456d3287987; }, function (v) { return $60c5dba4668e0873$export$1ca60456d3287987 = v; });
$parcel$export(module.exports, "parseSimulcastStreamList", function () { return $60c5dba4668e0873$export$c61d0126da4c310f; }, function (v) { return $60c5dba4668e0873$export$c61d0126da4c310f = v; });
var $60c5dba4668e0873$export$68d8715fc104d294;
var $60c5dba4668e0873$export$98e6a39c04603d36;
var $60c5dba4668e0873$export$ef804106d1571703;
var $60c5dba4668e0873$export$dfeb1045bffe1ff8;
var $60c5dba4668e0873$export$326874e595fb968b;
var $60c5dba4668e0873$export$705b3971a35c200;
var $60c5dba4668e0873$export$1ca60456d3287987;
var $60c5dba4668e0873$export$c61d0126da4c310f;

var $kH1X5 = parcelRequire("kH1X5");

var $6SdWi = parcelRequire("6SdWi");
$60c5dba4668e0873$export$68d8715fc104d294 = $6SdWi;
$60c5dba4668e0873$export$98e6a39c04603d36 = $kH1X5.parse;
$60c5dba4668e0873$export$ef804106d1571703 = $kH1X5.parseParams;
$60c5dba4668e0873$export$dfeb1045bffe1ff8 = $kH1X5.parseFmtpConfig; // Alias of parseParams().
$60c5dba4668e0873$export$326874e595fb968b = $kH1X5.parsePayloads;
$60c5dba4668e0873$export$705b3971a35c200 = $kH1X5.parseRemoteCandidates;
$60c5dba4668e0873$export$1ca60456d3287987 = $kH1X5.parseImageAttributes;
$60c5dba4668e0873$export$c61d0126da4c310f = $kH1X5.parseSimulcastStreamList;

});
parcelRegister("kH1X5", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $f1095667a9bba766$export$98e6a39c04603d36; }, function (v) { return $f1095667a9bba766$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "parseParams", function () { return $f1095667a9bba766$export$ef804106d1571703; }, function (v) { return $f1095667a9bba766$export$ef804106d1571703 = v; });
$parcel$export(module.exports, "parseFmtpConfig", function () { return $f1095667a9bba766$export$dfeb1045bffe1ff8; }, function (v) { return $f1095667a9bba766$export$dfeb1045bffe1ff8 = v; });
$parcel$export(module.exports, "parsePayloads", function () { return $f1095667a9bba766$export$326874e595fb968b; }, function (v) { return $f1095667a9bba766$export$326874e595fb968b = v; });
$parcel$export(module.exports, "parseRemoteCandidates", function () { return $f1095667a9bba766$export$705b3971a35c200; }, function (v) { return $f1095667a9bba766$export$705b3971a35c200 = v; });
$parcel$export(module.exports, "parseImageAttributes", function () { return $f1095667a9bba766$export$1ca60456d3287987; }, function (v) { return $f1095667a9bba766$export$1ca60456d3287987 = v; });
$parcel$export(module.exports, "parseSimulcastStreamList", function () { return $f1095667a9bba766$export$c61d0126da4c310f; }, function (v) { return $f1095667a9bba766$export$c61d0126da4c310f = v; });
var $f1095667a9bba766$export$98e6a39c04603d36;
var $f1095667a9bba766$export$ef804106d1571703;
// For backward compatibility - alias will be removed in 3.0.0
var $f1095667a9bba766$export$dfeb1045bffe1ff8;
var $f1095667a9bba766$export$326874e595fb968b;
var $f1095667a9bba766$export$705b3971a35c200;
var $f1095667a9bba766$export$1ca60456d3287987;
var $f1095667a9bba766$export$c61d0126da4c310f;
var $f1095667a9bba766$var$toIntIfInt = function(v) {
    return String(Number(v)) === v ? Number(v) : v;
};
var $f1095667a9bba766$var$attachProperties = function(match, location, names, rawName) {
    if (rawName && !names) location[rawName] = $f1095667a9bba766$var$toIntIfInt(match[1]);
    else {
        for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = $f1095667a9bba766$var$toIntIfInt(match[i + 1]);
    }
};
var $f1095667a9bba766$var$parseReg = function(obj, location, content) {
    var needsBlank = obj.name && obj.names;
    if (obj.push && !location[obj.push]) location[obj.push] = [];
    else if (needsBlank && !location[obj.name]) location[obj.name] = {};
    var keyLocation = obj.push ? {} : needsBlank ? location[obj.name] : location; // otherwise, named location or root
    $f1095667a9bba766$var$attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
    if (obj.push) location[obj.push].push(keyLocation);
};

var $h9s6v = parcelRequire("h9s6v");
var $f1095667a9bba766$var$validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
$f1095667a9bba766$export$98e6a39c04603d36 = function(sdp) {
    var session = {}, media = [], location = session; // points at where properties go under (one of the above)
    // parse lines we understand
    sdp.split(/(\r\n|\r|\n)/).filter($f1095667a9bba766$var$validLine).forEach(function(l) {
        var type = l[0];
        var content = l.slice(2);
        if (type === "m") {
            media.push({
                rtp: [],
                fmtp: []
            });
            location = media[media.length - 1]; // point at latest media line
        }
        for(var j = 0; j < ($h9s6v[type] || []).length; j += 1){
            var obj = $h9s6v[type][j];
            if (obj.reg.test(content)) return $f1095667a9bba766$var$parseReg(obj, location, content);
        }
    });
    session.media = media; // link it up
    return session;
};
var $f1095667a9bba766$var$paramReducer = function(acc, expr) {
    var s = expr.split(/=(.+)/, 2);
    if (s.length === 2) acc[s[0]] = $f1095667a9bba766$var$toIntIfInt(s[1]);
    else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
    return acc;
};
$f1095667a9bba766$export$ef804106d1571703 = function(str) {
    return str.split(/;\s?/).reduce($f1095667a9bba766$var$paramReducer, {});
};
$f1095667a9bba766$export$dfeb1045bffe1ff8 = $f1095667a9bba766$export$ef804106d1571703;
$f1095667a9bba766$export$326874e595fb968b = function(str) {
    return str.toString().split(" ").map(Number);
};
$f1095667a9bba766$export$705b3971a35c200 = function(str) {
    var candidates = [];
    var parts = str.split(" ").map($f1095667a9bba766$var$toIntIfInt);
    for(var i = 0; i < parts.length; i += 3)candidates.push({
        component: parts[i],
        ip: parts[i + 1],
        port: parts[i + 2]
    });
    return candidates;
};
$f1095667a9bba766$export$1ca60456d3287987 = function(str) {
    return str.split(" ").map(function(item) {
        return item.substring(1, item.length - 1).split(",").reduce($f1095667a9bba766$var$paramReducer, {});
    });
};
$f1095667a9bba766$export$c61d0126da4c310f = function(str) {
    return str.split(";").map(function(stream) {
        return stream.split(",").map(function(format) {
            var scid, paused = false;
            if (format[0] !== "~") scid = $f1095667a9bba766$var$toIntIfInt(format);
            else {
                scid = $f1095667a9bba766$var$toIntIfInt(format.substring(1, format.length));
                paused = true;
            }
            return {
                scid: scid,
                paused: paused
            };
        });
    });
};

});
parcelRegister("h9s6v", function(module, exports) {
var $c7c913c804974e64$var$grammar = module.exports = {
    v: [
        {
            name: "version",
            reg: /^(\d*)$/
        }
    ],
    o: [
        {
            // o=- 20518 0 IN IP4 203.0.113.1
            // NB: sessionId will be a String in most cases because it is huge
            name: "origin",
            reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
            names: [
                "username",
                "sessionId",
                "sessionVersion",
                "netType",
                "ipVer",
                "address"
            ],
            format: "%s %s %d %s IP%d %s"
        }
    ],
    // default parsing of these only (though some of these feel outdated)
    s: [
        {
            name: "name"
        }
    ],
    i: [
        {
            name: "description"
        }
    ],
    u: [
        {
            name: "uri"
        }
    ],
    e: [
        {
            name: "email"
        }
    ],
    p: [
        {
            name: "phone"
        }
    ],
    z: [
        {
            name: "timezones"
        }
    ],
    r: [
        {
            name: "repeats"
        }
    ],
    // k: [{}], // outdated thing ignored
    t: [
        {
            // t=0 0
            name: "timing",
            reg: /^(\d*) (\d*)/,
            names: [
                "start",
                "stop"
            ],
            format: "%d %d"
        }
    ],
    c: [
        {
            // c=IN IP4 10.47.197.26
            name: "connection",
            reg: /^IN IP(\d) (\S*)/,
            names: [
                "version",
                "ip"
            ],
            format: "IN IP%d %s"
        }
    ],
    b: [
        {
            // b=AS:4000
            push: "bandwidth",
            reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
            names: [
                "type",
                "limit"
            ],
            format: "%s:%s"
        }
    ],
    m: [
        {
            // m=video 51744 RTP/AVP 126 97 98 34 31
            // NB: special - pushes to session
            // TODO: rtp/fmtp should be filtered by the payloads found here?
            reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
            names: [
                "type",
                "port",
                "protocol",
                "payloads"
            ],
            format: "%s %d %s %s"
        }
    ],
    a: [
        {
            // a=rtpmap:110 opus/48000/2
            push: "rtp",
            reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
            names: [
                "payload",
                "codec",
                "rate",
                "encoding"
            ],
            format: function(o) {
                return o.encoding ? "rtpmap:%d %s/%s/%s" : o.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
            }
        },
        {
            // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
            // a=fmtp:111 minptime=10; useinbandfec=1
            push: "fmtp",
            reg: /^fmtp:(\d*) ([\S| ]*)/,
            names: [
                "payload",
                "config"
            ],
            format: "fmtp:%d %s"
        },
        {
            // a=control:streamid=0
            name: "control",
            reg: /^control:(.*)/,
            format: "control:%s"
        },
        {
            // a=rtcp:65179 IN IP4 193.84.77.194
            name: "rtcp",
            reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
            names: [
                "port",
                "netType",
                "ipVer",
                "address"
            ],
            format: function(o) {
                return o.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
            }
        },
        {
            // a=rtcp-fb:98 trr-int 100
            push: "rtcpFbTrrInt",
            reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
            names: [
                "payload",
                "value"
            ],
            format: "rtcp-fb:%s trr-int %d"
        },
        {
            // a=rtcp-fb:98 nack rpsi
            push: "rtcpFb",
            reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
            names: [
                "payload",
                "type",
                "subtype"
            ],
            format: function(o) {
                return o.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
            }
        },
        {
            // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
            // a=extmap:1/recvonly URI-gps-string
            // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
            push: "ext",
            reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
            names: [
                "value",
                "direction",
                "encrypt-uri",
                "uri",
                "config"
            ],
            format: function(o) {
                return "extmap:%d" + (o.direction ? "/%s" : "%v") + (o["encrypt-uri"] ? " %s" : "%v") + " %s" + (o.config ? " %s" : "");
            }
        },
        {
            // a=extmap-allow-mixed
            name: "extmapAllowMixed",
            reg: /^(extmap-allow-mixed)/
        },
        {
            // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
            push: "crypto",
            reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
            names: [
                "id",
                "suite",
                "config",
                "sessionConfig"
            ],
            format: function(o) {
                return o.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
            }
        },
        {
            // a=setup:actpass
            name: "setup",
            reg: /^setup:(\w*)/,
            format: "setup:%s"
        },
        {
            // a=connection:new
            name: "connectionType",
            reg: /^connection:(new|existing)/,
            format: "connection:%s"
        },
        {
            // a=mid:1
            name: "mid",
            reg: /^mid:([^\s]*)/,
            format: "mid:%s"
        },
        {
            // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
            name: "msid",
            reg: /^msid:(.*)/,
            format: "msid:%s"
        },
        {
            // a=ptime:20
            name: "ptime",
            reg: /^ptime:(\d*(?:\.\d*)*)/,
            format: "ptime:%d"
        },
        {
            // a=maxptime:60
            name: "maxptime",
            reg: /^maxptime:(\d*(?:\.\d*)*)/,
            format: "maxptime:%d"
        },
        {
            // a=sendrecv
            name: "direction",
            reg: /^(sendrecv|recvonly|sendonly|inactive)/
        },
        {
            // a=ice-lite
            name: "icelite",
            reg: /^(ice-lite)/
        },
        {
            // a=ice-ufrag:F7gI
            name: "iceUfrag",
            reg: /^ice-ufrag:(\S*)/,
            format: "ice-ufrag:%s"
        },
        {
            // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
            name: "icePwd",
            reg: /^ice-pwd:(\S*)/,
            format: "ice-pwd:%s"
        },
        {
            // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
            name: "fingerprint",
            reg: /^fingerprint:(\S*) (\S*)/,
            names: [
                "type",
                "hash"
            ],
            format: "fingerprint:%s %s"
        },
        {
            // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
            // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
            // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
            push: "candidates",
            reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
            names: [
                "foundation",
                "component",
                "transport",
                "priority",
                "ip",
                "port",
                "type",
                "raddr",
                "rport",
                "tcptype",
                "generation",
                "network-id",
                "network-cost"
            ],
            format: function(o) {
                var str = "candidate:%s %d %s %d %s %d typ %s";
                str += o.raddr != null ? " raddr %s rport %d" : "%v%v";
                // NB: candidate has three optional chunks, so %void middles one if it's missing
                str += o.tcptype != null ? " tcptype %s" : "%v";
                if (o.generation != null) str += " generation %d";
                str += o["network-id"] != null ? " network-id %d" : "%v";
                str += o["network-cost"] != null ? " network-cost %d" : "%v";
                return str;
            }
        },
        {
            // a=end-of-candidates (keep after the candidates line for readability)
            name: "endOfCandidates",
            reg: /^(end-of-candidates)/
        },
        {
            // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
            name: "remoteCandidates",
            reg: /^remote-candidates:(.*)/,
            format: "remote-candidates:%s"
        },
        {
            // a=ice-options:google-ice
            name: "iceOptions",
            reg: /^ice-options:(\S*)/,
            format: "ice-options:%s"
        },
        {
            // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
            push: "ssrcs",
            reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
            names: [
                "id",
                "attribute",
                "value"
            ],
            format: function(o) {
                var str = "ssrc:%d";
                if (o.attribute != null) {
                    str += " %s";
                    if (o.value != null) str += ":%s";
                }
                return str;
            }
        },
        {
            // a=ssrc-group:FEC 1 2
            // a=ssrc-group:FEC-FR 3004364195 1080772241
            push: "ssrcGroups",
            // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
            reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
            names: [
                "semantics",
                "ssrcs"
            ],
            format: "ssrc-group:%s %s"
        },
        {
            // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
            name: "msidSemantic",
            reg: /^msid-semantic:\s?(\w*) (\S*)/,
            names: [
                "semantic",
                "token"
            ],
            format: "msid-semantic: %s %s" // space after ':' is not accidental
        },
        {
            // a=group:BUNDLE audio video
            push: "groups",
            reg: /^group:(\w*) (.*)/,
            names: [
                "type",
                "mids"
            ],
            format: "group:%s %s"
        },
        {
            // a=rtcp-mux
            name: "rtcpMux",
            reg: /^(rtcp-mux)/
        },
        {
            // a=rtcp-rsize
            name: "rtcpRsize",
            reg: /^(rtcp-rsize)/
        },
        {
            // a=sctpmap:5000 webrtc-datachannel 1024
            name: "sctpmap",
            reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
            names: [
                "sctpmapNumber",
                "app",
                "maxMessageSize"
            ],
            format: function(o) {
                return o.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
            }
        },
        {
            // a=x-google-flag:conference
            name: "xGoogleFlag",
            reg: /^x-google-flag:([^\s]*)/,
            format: "x-google-flag:%s"
        },
        {
            // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
            push: "rids",
            reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
            names: [
                "id",
                "direction",
                "params"
            ],
            format: function(o) {
                return o.params ? "rid:%s %s %s" : "rid:%s %s";
            }
        },
        {
            // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
            // a=imageattr:* send [x=800,y=640] recv *
            // a=imageattr:100 recv [x=320,y=240]
            push: "imageattrs",
            reg: new RegExp(// a=imageattr:97
            "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
            names: [
                "pt",
                "dir1",
                "attrs1",
                "dir2",
                "attrs2"
            ],
            format: function(o) {
                return "imageattr:%s %s %s" + (o.dir2 ? " %s %s" : "");
            }
        },
        {
            // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
            // a=simulcast:recv 1;4,5 send 6;7
            name: "simulcast",
            reg: new RegExp(// a=simulcast:
            "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
            names: [
                "dir1",
                "list1",
                "dir2",
                "list2"
            ],
            format: function(o) {
                return "simulcast:%s %s" + (o.dir2 ? " %s %s" : "");
            }
        },
        {
            // old simulcast draft 03 (implemented by Firefox)
            //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
            // a=simulcast: recv pt=97;98 send pt=97
            // a=simulcast: send rid=5;6;7 paused=6,7
            name: "simulcast_03",
            reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
            names: [
                "value"
            ],
            format: "simulcast: %s"
        },
        {
            // a=framerate:25
            // a=framerate:29.97
            name: "framerate",
            reg: /^framerate:(\d+(?:$|\.\d+))/,
            format: "framerate:%s"
        },
        {
            // RFC4570
            // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
            name: "sourceFilter",
            reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
            names: [
                "filterMode",
                "netType",
                "addressTypes",
                "destAddress",
                "srcList"
            ],
            format: "source-filter: %s %s %s %s %s"
        },
        {
            // a=bundle-only
            name: "bundleOnly",
            reg: /^(bundle-only)/
        },
        {
            // a=label:1
            name: "label",
            reg: /^label:(.+)/,
            format: "label:%s"
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
            name: "sctpPort",
            reg: /^sctp-port:(\d+)$/,
            format: "sctp-port:%s"
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
            name: "maxMessageSize",
            reg: /^max-message-size:(\d+)$/,
            format: "max-message-size:%s"
        },
        {
            // RFC7273
            // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
            push: "tsRefClocks",
            reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
            names: [
                "clksrc",
                "clksrcExt"
            ],
            format: function(o) {
                return "ts-refclk:%s" + (o.clksrcExt != null ? "=%s" : "");
            }
        },
        {
            // RFC7273
            // a=mediaclk:direct=963214424
            name: "mediaClk",
            reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
            names: [
                "id",
                "mediaClockName",
                "mediaClockValue",
                "rateNumerator",
                "rateDenominator"
            ],
            format: function(o) {
                var str = "mediaclk:";
                str += o.id != null ? "id=%s %s" : "%v%s";
                str += o.mediaClockValue != null ? "=%s" : "";
                str += o.rateNumerator != null ? " rate=%s" : "";
                str += o.rateDenominator != null ? "/%s" : "";
                return str;
            }
        },
        {
            // a=keywds:keywords
            name: "keywords",
            reg: /^keywds:(.+)$/,
            format: "keywds:%s"
        },
        {
            // a=content:main
            name: "content",
            reg: /^content:(.+)/,
            format: "content:%s"
        },
        // BFCP https://tools.ietf.org/html/rfc4583
        {
            // a=floorctrl:c-s
            name: "bfcpFloorCtrl",
            reg: /^floorctrl:(c-only|s-only|c-s)/,
            format: "floorctrl:%s"
        },
        {
            // a=confid:1
            name: "bfcpConfId",
            reg: /^confid:(\d+)/,
            format: "confid:%s"
        },
        {
            // a=userid:1
            name: "bfcpUserId",
            reg: /^userid:(\d+)/,
            format: "userid:%s"
        },
        {
            // a=floorid:1
            name: "bfcpFloorId",
            reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
            names: [
                "id",
                "mStream"
            ],
            format: "floorid:%s mstrm:%s"
        },
        {
            // any a= that we don't understand is kept verbatim on media.invalid
            push: "invalid",
            names: [
                "value"
            ]
        }
    ]
};
// set sensible defaults to avoid polluting the grammar with boring details
Object.keys($c7c913c804974e64$var$grammar).forEach(function(key) {
    var objs = $c7c913c804974e64$var$grammar[key];
    objs.forEach(function(obj) {
        if (!obj.reg) obj.reg = /(.*)/;
        if (!obj.format) obj.format = "%s";
    });
});

});


parcelRegister("6SdWi", function(module, exports) {

var $h9s6v = parcelRequire("h9s6v");
// customized util.format - discards excess arguments and can void middle ones
var $50129943ef123419$var$formatRegExp = /%[sdv%]/g;
var $50129943ef123419$var$format = function(formatStr) {
    var i = 1;
    var args = arguments;
    var len = args.length;
    return formatStr.replace($50129943ef123419$var$formatRegExp, function(x) {
        if (i >= len) return x; // missing argument
        var arg = args[i];
        i += 1;
        switch(x){
            case "%%":
                return "%";
            case "%s":
                return String(arg);
            case "%d":
                return Number(arg);
            case "%v":
                return "";
        }
    });
// NB: we discard excess arguments - they are typically undefined from makeLine
};
var $50129943ef123419$var$makeLine = function(type, obj, location) {
    var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
    var args = [
        type + "=" + str
    ];
    if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
        var n = obj.names[i];
        if (obj.name) args.push(location[obj.name][n]);
        else args.push(location[obj.names[i]]);
    }
    else args.push(location[obj.name]);
    return $50129943ef123419$var$format.apply(null, args);
};
// RFC specified order
// TODO: extend this with all the rest
var $50129943ef123419$var$defaultOuterOrder = [
    "v",
    "o",
    "s",
    "i",
    "u",
    "e",
    "p",
    "c",
    "b",
    "t",
    "r",
    "z",
    "a"
];
var $50129943ef123419$var$defaultInnerOrder = [
    "i",
    "c",
    "b",
    "a"
];
module.exports = function(session, opts) {
    opts = opts || {};
    // ensure certain properties exist
    if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
    if (session.name == null) session.name = " "; // 's= ' must be there if no meaningful name set
    session.media.forEach(function(mLine) {
        if (mLine.payloads == null) mLine.payloads = "";
    });
    var outerOrder = opts.outerOrder || $50129943ef123419$var$defaultOuterOrder;
    var innerOrder = opts.innerOrder || $50129943ef123419$var$defaultInnerOrder;
    var sdp = [];
    // loop through outerOrder for matching properties on session
    outerOrder.forEach(function(type) {
        $h9s6v[type].forEach(function(obj) {
            if (obj.name in session && session[obj.name] != null) sdp.push($50129943ef123419$var$makeLine(type, obj, session));
            else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                sdp.push($50129943ef123419$var$makeLine(type, obj, el));
            });
        });
    });
    // then for each media line, follow the innerOrder
    session.media.forEach(function(mLine) {
        sdp.push($50129943ef123419$var$makeLine("m", $h9s6v.m[0], mLine));
        innerOrder.forEach(function(type) {
            $h9s6v[type].forEach(function(obj) {
                if (obj.name in mLine && mLine[obj.name] != null) sdp.push($50129943ef123419$var$makeLine(type, obj, mLine));
                else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                    sdp.push($50129943ef123419$var$makeLine(type, obj, el));
                });
            });
        });
    });
    return sdp.join("\r\n") + "\r\n";
};

});


parcelRegister("a2dIr", function(module, exports) {
"use strict";
var $74e4baf47efe9a17$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $74e4baf47efe9a17$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $74e4baf47efe9a17$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $74e4baf47efe9a17$var$__createBinding(result, mod, k);
    }
    $74e4baf47efe9a17$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractRtpCapabilities = $74e4baf47efe9a17$var$extractRtpCapabilities;
module.exports.extractDtlsParameters = $74e4baf47efe9a17$var$extractDtlsParameters;
module.exports.getCname = $74e4baf47efe9a17$var$getCname;
module.exports.applyCodecParameters = $74e4baf47efe9a17$var$applyCodecParameters;

const $74e4baf47efe9a17$var$sdpTransform = $74e4baf47efe9a17$var$__importStar((parcelRequire("8j7qr")));
/**
 * This function must be called with an SDP with 1 m=audio and 1 m=video
 * sections.
 */ function $74e4baf47efe9a17$var$extractRtpCapabilities({ sdpObject: sdpObject }) {
    // Map of RtpCodecParameters indexed by payload type.
    const codecsMap = new Map();
    // Array of RtpHeaderExtensions.
    const headerExtensions = [];
    // Whether a m=audio/video section has been already found.
    let gotAudio = false;
    let gotVideo = false;
    for (const m of sdpObject.media){
        const kind = m.type;
        switch(kind){
            case "audio":
                if (gotAudio) continue;
                gotAudio = true;
                break;
            case "video":
                if (gotVideo) continue;
                gotVideo = true;
                break;
            default:
                continue;
        }
        // Get codecs.
        for (const rtp of m.rtp){
            const codec = {
                kind: kind,
                mimeType: `${kind}/${rtp.codec}`,
                preferredPayloadType: rtp.payload,
                clockRate: rtp.rate,
                channels: rtp.encoding,
                parameters: {},
                rtcpFeedback: []
            };
            codecsMap.set(codec.preferredPayloadType, codec);
        }
        // Get codec parameters.
        for (const fmtp of m.fmtp || []){
            const parameters = $74e4baf47efe9a17$var$sdpTransform.parseParams(fmtp.config);
            const codec = codecsMap.get(fmtp.payload);
            if (!codec) continue;
            // Specials case to convert parameter value to string.
            if (parameters && parameters.hasOwnProperty("profile-level-id")) parameters["profile-level-id"] = String(parameters["profile-level-id"]);
            codec.parameters = parameters;
        }
        // Get RTCP feedback for each codec.
        for (const fb of m.rtcpFb || []){
            const feedback = {
                type: fb.type,
                parameter: fb.subtype
            };
            if (!feedback.parameter) delete feedback.parameter;
            // rtcp-fb payload is not '*', so just apply it to its corresponding
            // codec.
            if (fb.payload !== "*") {
                const codec = codecsMap.get(fb.payload);
                if (!codec) continue;
                codec.rtcpFeedback.push(feedback);
            } else {
                for (const codec of codecsMap.values())if (codec.kind === kind && !/.+\/rtx$/i.test(codec.mimeType)) codec.rtcpFeedback.push(feedback);
            }
        }
        // Get RTP header extensions.
        for (const ext of m.ext || []){
            // Ignore encrypted extensions (not yet supported in mediasoup).
            if (ext["encrypt-uri"]) continue;
            const headerExtension = {
                kind: kind,
                uri: ext.uri,
                preferredId: ext.value
            };
            headerExtensions.push(headerExtension);
        }
    }
    const rtpCapabilities = {
        codecs: Array.from(codecsMap.values()),
        headerExtensions: headerExtensions
    };
    return rtpCapabilities;
}
function $74e4baf47efe9a17$var$extractDtlsParameters({ sdpObject: sdpObject }) {
    let setup = sdpObject.setup;
    let fingerprint = sdpObject.fingerprint;
    if (!setup || !fingerprint) {
        const mediaObject = (sdpObject.media || []).find((m)=>m.port !== 0);
        if (mediaObject) {
            setup !== null && setup !== void 0 ? setup : setup = mediaObject.setup;
            fingerprint !== null && fingerprint !== void 0 ? fingerprint : fingerprint = mediaObject.fingerprint;
        }
    }
    if (!setup) throw new Error("no a=setup found at SDP session or media level");
    else if (!fingerprint) throw new Error("no a=fingerprint found at SDP session or media level");
    let role;
    switch(setup){
        case "active":
            role = "client";
            break;
        case "passive":
            role = "server";
            break;
        case "actpass":
            role = "auto";
            break;
    }
    const dtlsParameters = {
        role: role,
        fingerprints: [
            {
                algorithm: fingerprint.type,
                value: fingerprint.hash
            }
        ]
    };
    return dtlsParameters;
}
function $74e4baf47efe9a17$var$getCname({ offerMediaObject: offerMediaObject }) {
    const ssrcCnameLine = (offerMediaObject.ssrcs || []).find((line)=>line.attribute === "cname");
    if (!ssrcCnameLine) return "";
    return ssrcCnameLine.value;
}
/**
 * Apply codec parameters in the given SDP m= section answer based on the
 * given RTP parameters of an offer.
 */ function $74e4baf47efe9a17$var$applyCodecParameters({ offerRtpParameters: offerRtpParameters, answerMediaObject: answerMediaObject }) {
    for (const codec of offerRtpParameters.codecs){
        const mimeType = codec.mimeType.toLowerCase();
        // Avoid parsing codec parameters for unhandled codecs.
        if (mimeType !== "audio/opus") continue;
        const rtp = (answerMediaObject.rtp || []).find((r)=>r.payload === codec.payloadType);
        if (!rtp) continue;
        // Just in case.
        answerMediaObject.fmtp = answerMediaObject.fmtp || [];
        let fmtp = answerMediaObject.fmtp.find((f)=>f.payload === codec.payloadType);
        if (!fmtp) {
            fmtp = {
                payload: codec.payloadType,
                config: ""
            };
            answerMediaObject.fmtp.push(fmtp);
        }
        const parameters = $74e4baf47efe9a17$var$sdpTransform.parseParams(fmtp.config);
        switch(mimeType){
            case "audio/opus":
                {
                    const spropStereo = codec.parameters["sprop-stereo"];
                    if (spropStereo !== undefined) parameters.stereo = spropStereo ? 1 : 0;
                    break;
                }
        }
        // Write the codec fmtp.config back.
        fmtp.config = "";
        for (const key of Object.keys(parameters)){
            if (fmtp.config) fmtp.config += ";";
            fmtp.config += `${key}=${parameters[key]}`;
        }
    }
}

});

parcelRegister("ghGMB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRtpEncodings = $bdaf6ba95b3a5f06$var$getRtpEncodings;
module.exports.addLegacySimulcast = $bdaf6ba95b3a5f06$var$addLegacySimulcast;
function $bdaf6ba95b3a5f06$var$getRtpEncodings({ offerMediaObject: offerMediaObject }) {
    const ssrcs = new Set();
    for (const line of offerMediaObject.ssrcs || []){
        const ssrc = line.id;
        ssrcs.add(ssrc);
    }
    if (ssrcs.size === 0) throw new Error("no a=ssrc lines found");
    const ssrcToRtxSsrc = new Map();
    // First assume RTX is used.
    for (const line of offerMediaObject.ssrcGroups || []){
        if (line.semantics !== "FID") continue;
        let [ssrc, rtxSsrc] = line.ssrcs.split(/\s+/);
        ssrc = Number(ssrc);
        rtxSsrc = Number(rtxSsrc);
        if (ssrcs.has(ssrc)) {
            // Remove both the SSRC and RTX SSRC from the set so later we know
            // that they are already handled.
            ssrcs.delete(ssrc);
            ssrcs.delete(rtxSsrc);
            // Add to the map.
            ssrcToRtxSsrc.set(ssrc, rtxSsrc);
        }
    }
    // If the set of SSRCs is not empty it means that RTX is not being used, so
    // take media SSRCs from there.
    for (const ssrc of ssrcs)// Add to the map.
    ssrcToRtxSsrc.set(ssrc, null);
    const encodings = [];
    for (const [ssrc, rtxSsrc] of ssrcToRtxSsrc){
        const encoding = {
            ssrc: ssrc
        };
        if (rtxSsrc) encoding.rtx = {
            ssrc: rtxSsrc
        };
        encodings.push(encoding);
    }
    return encodings;
}
/**
 * Adds multi-ssrc based simulcast into the given SDP media section offer.
 */ function $bdaf6ba95b3a5f06$var$addLegacySimulcast({ offerMediaObject: offerMediaObject, numStreams: numStreams }) {
    if (numStreams <= 1) throw new TypeError("numStreams must be greater than 1");
    // Get the SSRC.
    const ssrcMsidLine = (offerMediaObject.ssrcs || []).find((line)=>line.attribute === "msid");
    if (!ssrcMsidLine) throw new Error("a=ssrc line with msid information not found");
    const [streamId, trackId] = ssrcMsidLine.value.split(" ");
    const firstSsrc = ssrcMsidLine.id;
    let firstRtxSsrc;
    // Get the SSRC for RTX.
    (offerMediaObject.ssrcGroups || []).some((line)=>{
        if (line.semantics !== "FID") return false;
        const ssrcs = line.ssrcs.split(/\s+/);
        if (Number(ssrcs[0]) === firstSsrc) {
            firstRtxSsrc = Number(ssrcs[1]);
            return true;
        } else return false;
    });
    const ssrcCnameLine = offerMediaObject.ssrcs.find((line)=>line.attribute === "cname");
    if (!ssrcCnameLine) throw new Error("a=ssrc line with cname information not found");
    const cname = ssrcCnameLine.value;
    const ssrcs = [];
    const rtxSsrcs = [];
    for(let i = 0; i < numStreams; ++i){
        ssrcs.push(firstSsrc + i);
        if (firstRtxSsrc) rtxSsrcs.push(firstRtxSsrc + i);
    }
    offerMediaObject.ssrcGroups = [];
    offerMediaObject.ssrcs = [];
    offerMediaObject.ssrcGroups.push({
        semantics: "SIM",
        ssrcs: ssrcs.join(" ")
    });
    for(let i = 0; i < ssrcs.length; ++i){
        const ssrc = ssrcs[i];
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId} ${trackId}`
        });
    }
    for(let i = 0; i < rtxSsrcs.length; ++i){
        const ssrc = ssrcs[i];
        const rtxSsrc = rtxSsrcs[i];
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "msid",
            value: `${streamId} ${trackId}`
        });
        offerMediaObject.ssrcGroups.push({
            semantics: "FID",
            ssrcs: `${ssrc} ${rtxSsrc}`
        });
    }
}

});

parcelRegister("eoJVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addNackSuppportForOpus = $a7b6f0140d985963$var$addNackSuppportForOpus;
/**
 * This function adds RTCP NACK support for OPUS codec in given capabilities.
 */ function $a7b6f0140d985963$var$addNackSuppportForOpus(rtpCapabilities) {
    var _codec_rtcpFeedback;
    for (const codec of rtpCapabilities.codecs || [])if ((codec.mimeType.toLowerCase() === "audio/opus" || codec.mimeType.toLowerCase() === "audio/multiopus") && !((_codec_rtcpFeedback = codec.rtcpFeedback) === null || _codec_rtcpFeedback === void 0 ? void 0 : _codec_rtcpFeedback.some((fb)=>fb.type === "nack" && !fb.parameter))) {
        if (!codec.rtcpFeedback) codec.rtcpFeedback = [];
        codec.rtcpFeedback.push({
            type: "nack"
        });
    }
}

});

parcelRegister("2ptPl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HandlerInterface = void 0;

var $bwd9s = parcelRequire("bwd9s");
class $1c150d9d3b627d37$var$HandlerInterface extends $bwd9s.EnhancedEventEmitter {
    constructor(){
        super();
    }
}
module.exports.HandlerInterface = $1c150d9d3b627d37$var$HandlerInterface;

});

parcelRegister("bqKhs", function(module, exports) {
"use strict";
var $852605c9611c3c84$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $852605c9611c3c84$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $852605c9611c3c84$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $852605c9611c3c84$var$__createBinding(result, mod, k);
    }
    $852605c9611c3c84$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoteSdp = void 0;

const $852605c9611c3c84$var$sdpTransform = $852605c9611c3c84$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $3sZKt = parcelRequire("3sZKt");
const $852605c9611c3c84$var$logger = new $24uNv.Logger("RemoteSdp");
class $852605c9611c3c84$var$RemoteSdp {
    updateIceParameters(iceParameters) {
        $852605c9611c3c84$var$logger.debug("updateIceParameters() [iceParameters:%o]", iceParameters);
        this._iceParameters = iceParameters;
        this._sdpObject.icelite = iceParameters.iceLite ? "ice-lite" : undefined;
        for (const mediaSection of this._mediaSections)mediaSection.setIceParameters(iceParameters);
    }
    updateDtlsRole(role) {
        $852605c9611c3c84$var$logger.debug("updateDtlsRole() [role:%s]", role);
        this._dtlsParameters.role = role;
        for (const mediaSection of this._mediaSections)mediaSection.setDtlsRole(role);
    }
    getNextMediaSectionIdx() {
        // If a closed media section is found, return its index.
        for(let idx = 0; idx < this._mediaSections.length; ++idx){
            const mediaSection = this._mediaSections[idx];
            if (mediaSection.closed) return {
                idx: idx,
                reuseMid: mediaSection.mid
            };
        }
        // If no closed media section is found, return next one.
        return {
            idx: this._mediaSections.length
        };
    }
    send({ offerMediaObject: offerMediaObject, reuseMid: reuseMid, offerRtpParameters: offerRtpParameters, answerRtpParameters: answerRtpParameters, codecOptions: codecOptions, extmapAllowMixed: extmapAllowMixed = false }) {
        const mediaSection = new $3sZKt.AnswerMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            plainRtpParameters: this._plainRtpParameters,
            planB: this._planB,
            offerMediaObject: offerMediaObject,
            offerRtpParameters: offerRtpParameters,
            answerRtpParameters: answerRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: extmapAllowMixed
        });
        // Unified-Plan with closed media section replacement.
        if (reuseMid) this._replaceMediaSection(mediaSection, reuseMid);
        else if (!this._midToIndex.has(mediaSection.mid)) this._addMediaSection(mediaSection);
        else this._replaceMediaSection(mediaSection);
    }
    receive({ mid: mid, kind: kind, offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId }) {
        const idx = this._midToIndex.get(mid);
        let mediaSection;
        if (idx !== undefined) mediaSection = this._mediaSections[idx];
        // Unified-Plan or different media kind.
        if (!mediaSection) {
            mediaSection = new $3sZKt.OfferMediaSection({
                iceParameters: this._iceParameters,
                iceCandidates: this._iceCandidates,
                dtlsParameters: this._dtlsParameters,
                plainRtpParameters: this._plainRtpParameters,
                planB: this._planB,
                mid: mid,
                kind: kind,
                offerRtpParameters: offerRtpParameters,
                streamId: streamId,
                trackId: trackId
            });
            // Let's try to recycle a closed media section (if any).
            // NOTE: Yes, we can recycle a closed m=audio section with a new m=video.
            const oldMediaSection = this._mediaSections.find((m)=>m.closed);
            if (oldMediaSection) this._replaceMediaSection(mediaSection, oldMediaSection.mid);
            else this._addMediaSection(mediaSection);
        } else {
            mediaSection.planBReceive({
                offerRtpParameters: offerRtpParameters,
                streamId: streamId,
                trackId: trackId
            });
            this._replaceMediaSection(mediaSection);
        }
    }
    pauseMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.pause();
    }
    resumeSendingMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.resume();
    }
    resumeReceivingMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.resume();
    }
    disableMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.disable();
    }
    /**
     * Closes media section. Returns true if the given MID corresponds to a m
     * section that has been indeed closed. False otherwise.
     *
     * NOTE: Closing the first m section is a pain since it invalidates the bundled
     * transport, so instead closing it we just disable it.
     */ closeMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        // NOTE: Closing the first m section is a pain since it invalidates the
        // bundled transport, so let's avoid it.
        if (mid === this._firstMid) {
            $852605c9611c3c84$var$logger.debug("closeMediaSection() | cannot close first media section, disabling it instead [mid:%s]", mid);
            this.disableMediaSection(mid);
            return false;
        }
        mediaSection.close();
        // Regenerate BUNDLE mids.
        this._regenerateBundleMids();
        return true;
    }
    muxMediaSectionSimulcast(mid, encodings) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.muxSimulcastStreams(encodings);
        this._replaceMediaSection(mediaSection);
    }
    planBStopReceiving({ mid: mid, offerRtpParameters: offerRtpParameters }) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.planBStopReceiving({
            offerRtpParameters: offerRtpParameters
        });
        this._replaceMediaSection(mediaSection);
    }
    sendSctpAssociation({ offerMediaObject: offerMediaObject }) {
        const mediaSection = new $3sZKt.AnswerMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            sctpParameters: this._sctpParameters,
            plainRtpParameters: this._plainRtpParameters,
            offerMediaObject: offerMediaObject
        });
        this._addMediaSection(mediaSection);
    }
    receiveSctpAssociation({ oldDataChannelSpec: oldDataChannelSpec = false } = {}) {
        const mediaSection = new $3sZKt.OfferMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            sctpParameters: this._sctpParameters,
            plainRtpParameters: this._plainRtpParameters,
            mid: "datachannel",
            kind: "application",
            oldDataChannelSpec: oldDataChannelSpec
        });
        this._addMediaSection(mediaSection);
    }
    getSdp() {
        // Increase SDP version.
        this._sdpObject.origin.sessionVersion++;
        return $852605c9611c3c84$var$sdpTransform.write(this._sdpObject);
    }
    _addMediaSection(newMediaSection) {
        if (!this._firstMid) this._firstMid = newMediaSection.mid;
        // Add to the vector.
        this._mediaSections.push(newMediaSection);
        // Add to the map.
        this._midToIndex.set(newMediaSection.mid, this._mediaSections.length - 1);
        // Add to the SDP object.
        this._sdpObject.media.push(newMediaSection.getObject());
        // Regenerate BUNDLE mids.
        this._regenerateBundleMids();
    }
    _replaceMediaSection(newMediaSection, reuseMid) {
        // Store it in the map.
        if (typeof reuseMid === "string") {
            const idx = this._midToIndex.get(reuseMid);
            if (idx === undefined) throw new Error(`no media section found for reuseMid '${reuseMid}'`);
            const oldMediaSection = this._mediaSections[idx];
            // Replace the index in the vector with the new media section.
            this._mediaSections[idx] = newMediaSection;
            // Update the map.
            this._midToIndex.delete(oldMediaSection.mid);
            this._midToIndex.set(newMediaSection.mid, idx);
            // Update the SDP object.
            this._sdpObject.media[idx] = newMediaSection.getObject();
            // Regenerate BUNDLE mids.
            this._regenerateBundleMids();
        } else {
            const idx = this._midToIndex.get(newMediaSection.mid);
            if (idx === undefined) throw new Error(`no media section found with mid '${newMediaSection.mid}'`);
            // Replace the index in the vector with the new media section.
            this._mediaSections[idx] = newMediaSection;
            // Update the SDP object.
            this._sdpObject.media[idx] = newMediaSection.getObject();
        }
    }
    _findMediaSection(mid) {
        const idx = this._midToIndex.get(mid);
        if (idx === undefined) throw new Error(`no media section found with mid '${mid}'`);
        return this._mediaSections[idx];
    }
    _regenerateBundleMids() {
        if (!this._dtlsParameters) return;
        this._sdpObject.groups[0].mids = this._mediaSections.filter((mediaSection)=>!mediaSection.closed).map((mediaSection)=>mediaSection.mid).join(" ");
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false }){
        // MediaSection instances with same order as in the SDP.
        this._mediaSections = [];
        // MediaSection indices indexed by MID.
        this._midToIndex = new Map();
        this._iceParameters = iceParameters;
        this._iceCandidates = iceCandidates;
        this._dtlsParameters = dtlsParameters;
        this._sctpParameters = sctpParameters;
        this._plainRtpParameters = plainRtpParameters;
        this._planB = planB;
        this._sdpObject = {
            version: 0,
            origin: {
                address: "0.0.0.0",
                ipVer: 4,
                netType: "IN",
                sessionId: 10000,
                sessionVersion: 0,
                username: "mediasoup-client"
            },
            name: "-",
            timing: {
                start: 0,
                stop: 0
            },
            media: []
        };
        // If ICE parameters are given, add ICE-Lite indicator.
        if (iceParameters && iceParameters.iceLite) this._sdpObject.icelite = "ice-lite";
        // If DTLS parameters are given, assume WebRTC and BUNDLE.
        if (dtlsParameters) {
            this._sdpObject.msidSemantic = {
                semantic: "WMS",
                token: "*"
            };
            // NOTE: We take the latest fingerprint.
            const numFingerprints = this._dtlsParameters.fingerprints.length;
            this._sdpObject.fingerprint = {
                type: dtlsParameters.fingerprints[numFingerprints - 1].algorithm,
                hash: dtlsParameters.fingerprints[numFingerprints - 1].value
            };
            this._sdpObject.groups = [
                {
                    type: "BUNDLE",
                    mids: ""
                }
            ];
        }
        // If there are plain RPT parameters, override SDP origin.
        if (plainRtpParameters) {
            this._sdpObject.origin.address = plainRtpParameters.ip;
            this._sdpObject.origin.ipVer = plainRtpParameters.ipVersion;
        }
    }
}
module.exports.RemoteSdp = $852605c9611c3c84$var$RemoteSdp;

});
parcelRegister("3sZKt", function(module, exports) {
"use strict";
var $2863e29a87d8438f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2863e29a87d8438f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2863e29a87d8438f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2863e29a87d8438f$var$__createBinding(result, mod, k);
    }
    $2863e29a87d8438f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OfferMediaSection = module.exports.AnswerMediaSection = module.exports.MediaSection = void 0;

const $2863e29a87d8438f$var$sdpTransform = $2863e29a87d8438f$var$__importStar((parcelRequire("8j7qr")));

const $2863e29a87d8438f$var$utils = $2863e29a87d8438f$var$__importStar((parcelRequire("lghrF")));
class $2863e29a87d8438f$var$MediaSection {
    get mid() {
        return String(this._mediaObject.mid);
    }
    get closed() {
        return this._mediaObject.port === 0;
    }
    getObject() {
        return this._mediaObject;
    }
    setIceParameters(iceParameters) {
        this._mediaObject.iceUfrag = iceParameters.usernameFragment;
        this._mediaObject.icePwd = iceParameters.password;
    }
    pause() {
        this._mediaObject.direction = "inactive";
    }
    disable() {
        this.pause();
        delete this._mediaObject.ext;
        delete this._mediaObject.ssrcs;
        delete this._mediaObject.ssrcGroups;
        delete this._mediaObject.simulcast;
        delete this._mediaObject.simulcast_03;
        delete this._mediaObject.rids;
        delete this._mediaObject.extmapAllowMixed;
    }
    close() {
        this.disable();
        this._mediaObject.port = 0;
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, planB: planB = false }){
        this._mediaObject = {};
        this._planB = planB;
        if (iceParameters) this.setIceParameters(iceParameters);
        if (iceCandidates) {
            this._mediaObject.candidates = [];
            for (const candidate of iceCandidates){
                const candidateObject = {};
                // mediasoup does mandates rtcp-mux so candidates component is always
                // RTP (1).
                candidateObject.component = 1;
                candidateObject.foundation = candidate.foundation;
                var _candidate_address;
                // Be ready for new candidate.address field in mediasoup server side
                // field and keep backward compatibility with deprecated candidate.ip.
                candidateObject.ip = (_candidate_address = candidate.address) !== null && _candidate_address !== void 0 ? _candidate_address : candidate.ip;
                candidateObject.port = candidate.port;
                candidateObject.priority = candidate.priority;
                candidateObject.transport = candidate.protocol;
                candidateObject.type = candidate.type;
                if (candidate.tcpType) candidateObject.tcptype = candidate.tcpType;
                this._mediaObject.candidates.push(candidateObject);
            }
            this._mediaObject.endOfCandidates = "end-of-candidates";
            this._mediaObject.iceOptions = "renomination";
        }
        if (dtlsParameters) this.setDtlsRole(dtlsParameters.role);
    }
}
module.exports.MediaSection = $2863e29a87d8438f$var$MediaSection;
class $2863e29a87d8438f$var$AnswerMediaSection extends $2863e29a87d8438f$var$MediaSection {
    setDtlsRole(role) {
        switch(role){
            case "client":
                this._mediaObject.setup = "active";
                break;
            case "server":
                this._mediaObject.setup = "passive";
                break;
            case "auto":
                this._mediaObject.setup = "actpass";
                break;
        }
    }
    resume() {
        this._mediaObject.direction = "recvonly";
    }
    muxSimulcastStreams(encodings) {
        var _layers_simulcastFormat_scid;
        if (!this._mediaObject.simulcast || !this._mediaObject.simulcast.list1) return;
        const layers = {};
        for (const encoding of encodings)if (encoding.rid) layers[encoding.rid] = encoding;
        const raw = this._mediaObject.simulcast.list1;
        const simulcastStreams = $2863e29a87d8438f$var$sdpTransform.parseSimulcastStreamList(raw);
        for (const simulcastStream of simulcastStreams)for (const simulcastFormat of simulcastStream)simulcastFormat.paused = !((_layers_simulcastFormat_scid = layers[simulcastFormat.scid]) === null || _layers_simulcastFormat_scid === void 0 ? void 0 : _layers_simulcastFormat_scid.active);
        this._mediaObject.simulcast.list1 = simulcastStreams.map((simulcastFormats)=>simulcastFormats.map((f)=>`${f.paused ? "~" : ""}${f.scid}`).join(",")).join(";");
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false, offerMediaObject: offerMediaObject, offerRtpParameters: offerRtpParameters, answerRtpParameters: answerRtpParameters, codecOptions: codecOptions, extmapAllowMixed: extmapAllowMixed = false }){
        super({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            planB: planB
        });
        this._mediaObject.mid = String(offerMediaObject.mid);
        this._mediaObject.type = offerMediaObject.type;
        this._mediaObject.protocol = offerMediaObject.protocol;
        if (!plainRtpParameters) {
            this._mediaObject.connection = {
                ip: "127.0.0.1",
                version: 4
            };
            this._mediaObject.port = 7;
        } else {
            this._mediaObject.connection = {
                ip: plainRtpParameters.ip,
                version: plainRtpParameters.ipVersion
            };
            this._mediaObject.port = plainRtpParameters.port;
        }
        switch(offerMediaObject.type){
            case "audio":
            case "video":
                this._mediaObject.direction = "recvonly";
                this._mediaObject.rtp = [];
                this._mediaObject.rtcpFb = [];
                this._mediaObject.fmtp = [];
                for (const codec of answerRtpParameters.codecs){
                    const rtp = {
                        payload: codec.payloadType,
                        codec: $2863e29a87d8438f$var$getCodecName(codec),
                        rate: codec.clockRate
                    };
                    if (codec.channels > 1) rtp.encoding = codec.channels;
                    this._mediaObject.rtp.push(rtp);
                    var _utils_clone;
                    const codecParameters = (_utils_clone = $2863e29a87d8438f$var$utils.clone(codec.parameters)) !== null && _utils_clone !== void 0 ? _utils_clone : {};
                    var _utils_clone1;
                    let codecRtcpFeedback = (_utils_clone1 = $2863e29a87d8438f$var$utils.clone(codec.rtcpFeedback)) !== null && _utils_clone1 !== void 0 ? _utils_clone1 : [];
                    if (codecOptions) {
                        const { opusStereo: opusStereo, opusFec: opusFec, opusDtx: opusDtx, opusMaxPlaybackRate: opusMaxPlaybackRate, opusMaxAverageBitrate: opusMaxAverageBitrate, opusPtime: opusPtime, opusNack: opusNack, videoGoogleStartBitrate: videoGoogleStartBitrate, videoGoogleMaxBitrate: videoGoogleMaxBitrate, videoGoogleMinBitrate: videoGoogleMinBitrate } = codecOptions;
                        const offerCodec = offerRtpParameters.codecs.find((c)=>c.payloadType === codec.payloadType);
                        switch(codec.mimeType.toLowerCase()){
                            case "audio/opus":
                            case "audio/multiopus":
                                if (opusStereo !== undefined) {
                                    offerCodec.parameters["sprop-stereo"] = opusStereo ? 1 : 0;
                                    codecParameters.stereo = opusStereo ? 1 : 0;
                                }
                                if (opusFec !== undefined) {
                                    offerCodec.parameters.useinbandfec = opusFec ? 1 : 0;
                                    codecParameters.useinbandfec = opusFec ? 1 : 0;
                                }
                                if (opusDtx !== undefined) {
                                    offerCodec.parameters.usedtx = opusDtx ? 1 : 0;
                                    codecParameters.usedtx = opusDtx ? 1 : 0;
                                }
                                if (opusMaxPlaybackRate !== undefined) codecParameters.maxplaybackrate = opusMaxPlaybackRate;
                                if (opusMaxAverageBitrate !== undefined) codecParameters.maxaveragebitrate = opusMaxAverageBitrate;
                                if (opusPtime !== undefined) {
                                    offerCodec.parameters.ptime = opusPtime;
                                    codecParameters.ptime = opusPtime;
                                }
                                // If opusNack is not set, we must remove NACK support for OPUS.
                                // Otherwise it would be enabled for those handlers that artificially
                                // announce it in their RTP capabilities.
                                if (!opusNack) {
                                    offerCodec.rtcpFeedback = offerCodec.rtcpFeedback.filter((fb)=>fb.type !== "nack" || fb.parameter);
                                    codecRtcpFeedback = codecRtcpFeedback.filter((fb)=>fb.type !== "nack" || fb.parameter);
                                }
                                break;
                            case "video/vp8":
                            case "video/vp9":
                            case "video/h264":
                            case "video/h265":
                                if (videoGoogleStartBitrate !== undefined) codecParameters["x-google-start-bitrate"] = videoGoogleStartBitrate;
                                if (videoGoogleMaxBitrate !== undefined) codecParameters["x-google-max-bitrate"] = videoGoogleMaxBitrate;
                                if (videoGoogleMinBitrate !== undefined) codecParameters["x-google-min-bitrate"] = videoGoogleMinBitrate;
                                break;
                        }
                    }
                    const fmtp = {
                        payload: codec.payloadType,
                        config: ""
                    };
                    for (const key of Object.keys(codecParameters)){
                        if (fmtp.config) fmtp.config += ";";
                        fmtp.config += `${key}=${codecParameters[key]}`;
                    }
                    if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
                    for (const fb of codecRtcpFeedback)this._mediaObject.rtcpFb.push({
                        payload: codec.payloadType,
                        type: fb.type,
                        subtype: fb.parameter
                    });
                }
                this._mediaObject.payloads = answerRtpParameters.codecs.map((codec)=>codec.payloadType).join(" ");
                this._mediaObject.ext = [];
                for (const ext of answerRtpParameters.headerExtensions){
                    // Don't add a header extension if not present in the offer.
                    const found = (offerMediaObject.ext || []).some((localExt)=>localExt.uri === ext.uri);
                    if (!found) continue;
                    this._mediaObject.ext.push({
                        uri: ext.uri,
                        value: ext.id
                    });
                }
                // Allow both 1 byte and 2 bytes length header extensions.
                if (extmapAllowMixed && offerMediaObject.extmapAllowMixed === "extmap-allow-mixed") this._mediaObject.extmapAllowMixed = "extmap-allow-mixed";
                // Simulcast.
                if (offerMediaObject.simulcast) {
                    this._mediaObject.simulcast = {
                        dir1: "recv",
                        list1: offerMediaObject.simulcast.list1
                    };
                    this._mediaObject.rids = [];
                    for (const rid of offerMediaObject.rids || []){
                        if (rid.direction !== "send") continue;
                        this._mediaObject.rids.push({
                            id: rid.id,
                            direction: "recv"
                        });
                    }
                } else if (offerMediaObject.simulcast_03) {
                    // eslint-disable-next-line camelcase
                    this._mediaObject.simulcast_03 = {
                        value: offerMediaObject.simulcast_03.value.replace(/send/g, "recv")
                    };
                    this._mediaObject.rids = [];
                    for (const rid of offerMediaObject.rids || []){
                        if (rid.direction !== "send") continue;
                        this._mediaObject.rids.push({
                            id: rid.id,
                            direction: "recv"
                        });
                    }
                }
                this._mediaObject.rtcpMux = "rtcp-mux";
                this._mediaObject.rtcpRsize = "rtcp-rsize";
                if (this._planB && this._mediaObject.type === "video") this._mediaObject.xGoogleFlag = "conference";
                break;
            case "application":
                // New spec.
                if (typeof offerMediaObject.sctpPort === "number") {
                    this._mediaObject.payloads = "webrtc-datachannel";
                    this._mediaObject.sctpPort = sctpParameters.port;
                    this._mediaObject.maxMessageSize = sctpParameters.maxMessageSize;
                } else if (offerMediaObject.sctpmap) {
                    this._mediaObject.payloads = sctpParameters.port;
                    this._mediaObject.sctpmap = {
                        app: "webrtc-datachannel",
                        sctpmapNumber: sctpParameters.port,
                        maxMessageSize: sctpParameters.maxMessageSize
                    };
                }
                break;
        }
    }
}
module.exports.AnswerMediaSection = $2863e29a87d8438f$var$AnswerMediaSection;
class $2863e29a87d8438f$var$OfferMediaSection extends $2863e29a87d8438f$var$MediaSection {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setDtlsRole(role) {
        // Always 'actpass'.
        this._mediaObject.setup = "actpass";
    }
    resume() {
        this._mediaObject.direction = "sendonly";
    }
    planBReceive({ offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId }) {
        const encoding = offerRtpParameters.encodings[0];
        const ssrc = encoding.ssrc;
        const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
        const payloads = this._mediaObject.payloads.split(" ");
        for (const codec of offerRtpParameters.codecs){
            if (payloads.includes(String(codec.payloadType))) continue;
            const rtp = {
                payload: codec.payloadType,
                codec: $2863e29a87d8438f$var$getCodecName(codec),
                rate: codec.clockRate
            };
            if (codec.channels > 1) rtp.encoding = codec.channels;
            this._mediaObject.rtp.push(rtp);
            const fmtp = {
                payload: codec.payloadType,
                config: ""
            };
            for (const key of Object.keys(codec.parameters)){
                if (fmtp.config) fmtp.config += ";";
                fmtp.config += `${key}=${codec.parameters[key]}`;
            }
            if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
            for (const fb of codec.rtcpFeedback)this._mediaObject.rtcpFb.push({
                payload: codec.payloadType,
                type: fb.type,
                subtype: fb.parameter
            });
        }
        this._mediaObject.payloads += ` ${offerRtpParameters.codecs.filter((codec)=>!this._mediaObject.payloads.includes(codec.payloadType)).map((codec)=>codec.payloadType).join(" ")}`;
        this._mediaObject.payloads = this._mediaObject.payloads.trim();
        if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: offerRtpParameters.rtcp.cname
        });
        this._mediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId || "-"} ${trackId}`
        });
        if (rtxSsrc) {
            if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                id: rtxSsrc,
                attribute: "cname",
                value: offerRtpParameters.rtcp.cname
            });
            this._mediaObject.ssrcs.push({
                id: rtxSsrc,
                attribute: "msid",
                value: `${streamId || "-"} ${trackId}`
            });
            // Associate original and retransmission SSRCs.
            this._mediaObject.ssrcGroups.push({
                semantics: "FID",
                ssrcs: `${ssrc} ${rtxSsrc}`
            });
        }
    }
    planBStopReceiving({ offerRtpParameters: offerRtpParameters }) {
        const encoding = offerRtpParameters.encodings[0];
        const ssrc = encoding.ssrc;
        const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
        this._mediaObject.ssrcs = this._mediaObject.ssrcs.filter((s)=>s.id !== ssrc && s.id !== rtxSsrc);
        if (rtxSsrc) this._mediaObject.ssrcGroups = this._mediaObject.ssrcGroups.filter((group)=>group.ssrcs !== `${ssrc} ${rtxSsrc}`);
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false, mid: mid, kind: kind, offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId, oldDataChannelSpec: oldDataChannelSpec = false }){
        super({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            planB: planB
        });
        this._mediaObject.mid = String(mid);
        this._mediaObject.type = kind;
        if (!plainRtpParameters) {
            this._mediaObject.connection = {
                ip: "127.0.0.1",
                version: 4
            };
            if (!sctpParameters) this._mediaObject.protocol = "UDP/TLS/RTP/SAVPF";
            else this._mediaObject.protocol = "UDP/DTLS/SCTP";
            this._mediaObject.port = 7;
        } else {
            this._mediaObject.connection = {
                ip: plainRtpParameters.ip,
                version: plainRtpParameters.ipVersion
            };
            this._mediaObject.protocol = "RTP/AVP";
            this._mediaObject.port = plainRtpParameters.port;
        }
        switch(kind){
            case "audio":
            case "video":
                {
                    this._mediaObject.direction = "sendonly";
                    this._mediaObject.rtp = [];
                    this._mediaObject.rtcpFb = [];
                    this._mediaObject.fmtp = [];
                    if (!this._planB) this._mediaObject.msid = `${streamId || "-"} ${trackId}`;
                    for (const codec of offerRtpParameters.codecs){
                        const rtp = {
                            payload: codec.payloadType,
                            codec: $2863e29a87d8438f$var$getCodecName(codec),
                            rate: codec.clockRate
                        };
                        if (codec.channels > 1) rtp.encoding = codec.channels;
                        this._mediaObject.rtp.push(rtp);
                        const fmtp = {
                            payload: codec.payloadType,
                            config: ""
                        };
                        for (const key of Object.keys(codec.parameters)){
                            if (fmtp.config) fmtp.config += ";";
                            fmtp.config += `${key}=${codec.parameters[key]}`;
                        }
                        if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
                        for (const fb of codec.rtcpFeedback)this._mediaObject.rtcpFb.push({
                            payload: codec.payloadType,
                            type: fb.type,
                            subtype: fb.parameter
                        });
                    }
                    this._mediaObject.payloads = offerRtpParameters.codecs.map((codec)=>codec.payloadType).join(" ");
                    this._mediaObject.ext = [];
                    for (const ext of offerRtpParameters.headerExtensions)this._mediaObject.ext.push({
                        uri: ext.uri,
                        value: ext.id
                    });
                    this._mediaObject.rtcpMux = "rtcp-mux";
                    this._mediaObject.rtcpRsize = "rtcp-rsize";
                    const encoding = offerRtpParameters.encodings[0];
                    const ssrc = encoding.ssrc;
                    const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
                    this._mediaObject.ssrcs = [];
                    this._mediaObject.ssrcGroups = [];
                    if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                        id: ssrc,
                        attribute: "cname",
                        value: offerRtpParameters.rtcp.cname
                    });
                    if (this._planB) this._mediaObject.ssrcs.push({
                        id: ssrc,
                        attribute: "msid",
                        value: `${streamId || "-"} ${trackId}`
                    });
                    if (rtxSsrc) {
                        if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                            id: rtxSsrc,
                            attribute: "cname",
                            value: offerRtpParameters.rtcp.cname
                        });
                        if (this._planB) this._mediaObject.ssrcs.push({
                            id: rtxSsrc,
                            attribute: "msid",
                            value: `${streamId || "-"} ${trackId}`
                        });
                        // Associate original and retransmission SSRCs.
                        this._mediaObject.ssrcGroups.push({
                            semantics: "FID",
                            ssrcs: `${ssrc} ${rtxSsrc}`
                        });
                    }
                    break;
                }
            case "application":
                // New spec.
                if (!oldDataChannelSpec) {
                    this._mediaObject.payloads = "webrtc-datachannel";
                    this._mediaObject.sctpPort = sctpParameters.port;
                    this._mediaObject.maxMessageSize = sctpParameters.maxMessageSize;
                } else {
                    this._mediaObject.payloads = sctpParameters.port;
                    this._mediaObject.sctpmap = {
                        app: "webrtc-datachannel",
                        sctpmapNumber: sctpParameters.port,
                        maxMessageSize: sctpParameters.maxMessageSize
                    };
                }
                break;
        }
    }
}
module.exports.OfferMediaSection = $2863e29a87d8438f$var$OfferMediaSection;
function $2863e29a87d8438f$var$getCodecName(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    return mimeTypeMatch[2];
}

});


parcelRegister("2VyLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $221bdfa450ca37de$var$parse;
const $221bdfa450ca37de$var$ScalabilityModeRegex = new RegExp("^[LS]([1-9]\\d{0,1})T([1-9]\\d{0,1})");
function $221bdfa450ca37de$var$parse(scalabilityMode) {
    const match = $221bdfa450ca37de$var$ScalabilityModeRegex.exec(scalabilityMode || "");
    if (match) return {
        spatialLayers: Number(match[1]),
        temporalLayers: Number(match[2])
    };
    else return {
        spatialLayers: 1,
        temporalLayers: 1
    };
}

});


parcelRegister("3TLmn", function(module, exports) {
"use strict";
var $2d6b3edc827220e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d6b3edc827220e6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2d6b3edc827220e6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2d6b3edc827220e6$var$__createBinding(result, mod, k);
    }
    $2d6b3edc827220e6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome74 = void 0;

const $2d6b3edc827220e6$var$sdpTransform = $2d6b3edc827220e6$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $2d6b3edc827220e6$var$utils = $2d6b3edc827220e6$var$__importStar((parcelRequire("lghrF")));

const $2d6b3edc827220e6$var$ortc = $2d6b3edc827220e6$var$__importStar((parcelRequire("5Mq2W")));

const $2d6b3edc827220e6$var$sdpCommonUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("a2dIr")));

const $2d6b3edc827220e6$var$sdpUnifiedPlanUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("ghGMB")));

const $2d6b3edc827220e6$var$ortcUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $2d6b3edc827220e6$var$logger = new $24uNv.Logger("Chrome74");
const $2d6b3edc827220e6$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $2d6b3edc827220e6$var$Chrome74 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $2d6b3edc827220e6$var$Chrome74();
    }
    get name() {
        return "Chrome74";
    }
    close() {
        $2d6b3edc827220e6$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $2d6b3edc827220e6$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $2d6b3edc827220e6$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $2d6b3edc827220e6$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $2d6b3edc827220e6$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $2d6b3edc827220e6$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $2d6b3edc827220e6$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $2d6b3edc827220e6$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $2d6b3edc827220e6$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $2d6b3edc827220e6$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $2d6b3edc827220e6$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else {
            $2d6b3edc827220e6$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            this._pc.addEventListener("iceconnectionstatechange", ()=>{
                switch(this._pc.iceConnectionState){
                    case "checking":
                        this.emit("@connectionstatechange", "connecting");
                        break;
                    case "connected":
                    case "completed":
                        this.emit("@connectionstatechange", "connected");
                        break;
                    case "failed":
                        this.emit("@connectionstatechange", "failed");
                        break;
                    case "disconnected":
                        this.emit("@connectionstatechange", "disconnected");
                        break;
                    case "closed":
                        this.emit("@connectionstatechange", "closed");
                        break;
                }
            });
        }
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $2d6b3edc827220e6$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $2d6b3edc827220e6$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $2d6b3edc827220e6$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $2d6b3edc827220e6$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $2d6b3edc827220e6$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $2d6b3edc827220e6$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        let offer = await this._pc.createOffer();
        let localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $2d6b3edc827220e6$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $2d6b3edc827220e6$var$sdpTransform.write(localSdpObject)
            };
        }
        $2d6b3edc827220e6$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $2d6b3edc827220e6$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            let newEncodings = $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            // Hack for VP9 SVC.
            if (hackVp9Svc) newEncodings = [
                newEncodings[0]
            ];
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $2d6b3edc827220e6$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $2d6b3edc827220e6$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $2d6b3edc827220e6$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $2d6b3edc827220e6$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $2d6b3edc827220e6$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $2d6b3edc827220e6$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $2d6b3edc827220e6$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $2d6b3edc827220e6$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $2d6b3edc827220e6$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $2d6b3edc827220e6$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome74 = $2d6b3edc827220e6$var$Chrome74;

});

parcelRegister("8vSu0", function(module, exports) {
"use strict";
var $632b7b2896c8ff16$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $632b7b2896c8ff16$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $632b7b2896c8ff16$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $632b7b2896c8ff16$var$__createBinding(result, mod, k);
    }
    $632b7b2896c8ff16$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome70 = void 0;

const $632b7b2896c8ff16$var$sdpTransform = $632b7b2896c8ff16$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $632b7b2896c8ff16$var$utils = $632b7b2896c8ff16$var$__importStar((parcelRequire("lghrF")));

const $632b7b2896c8ff16$var$ortc = $632b7b2896c8ff16$var$__importStar((parcelRequire("5Mq2W")));

const $632b7b2896c8ff16$var$sdpCommonUtils = $632b7b2896c8ff16$var$__importStar((parcelRequire("a2dIr")));

const $632b7b2896c8ff16$var$sdpUnifiedPlanUtils = $632b7b2896c8ff16$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $632b7b2896c8ff16$var$logger = new $24uNv.Logger("Chrome70");
const $632b7b2896c8ff16$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $632b7b2896c8ff16$var$Chrome70 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $632b7b2896c8ff16$var$Chrome70();
    }
    get name() {
        return "Chrome70";
    }
    close() {
        $632b7b2896c8ff16$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $632b7b2896c8ff16$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $632b7b2896c8ff16$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $632b7b2896c8ff16$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $632b7b2896c8ff16$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $632b7b2896c8ff16$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $632b7b2896c8ff16$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $632b7b2896c8ff16$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $632b7b2896c8ff16$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $632b7b2896c8ff16$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $632b7b2896c8ff16$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $632b7b2896c8ff16$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $632b7b2896c8ff16$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        const sendingRtpParameters = $632b7b2896c8ff16$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $632b7b2896c8ff16$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $632b7b2896c8ff16$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $632b7b2896c8ff16$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        let offer = await this._pc.createOffer();
        let localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (encodings && encodings.length > 1) {
            $632b7b2896c8ff16$var$logger.debug("send() | enabling legacy simulcast");
            localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
            };
        }
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $632b7b2896c8ff16$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
            };
        }
        $632b7b2896c8ff16$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // If encodings are given, apply them now.
        if (encodings) {
            $632b7b2896c8ff16$var$logger.debug("send() | applying given encodings");
            const parameters = transceiver.sender.getParameters();
            for(let idx = 0; idx < (parameters.encodings || []).length; ++idx){
                const encoding = parameters.encodings[idx];
                const desiredEncoding = encodings[idx];
                // Should not happen but just in case.
                if (!desiredEncoding) break;
                parameters.encodings[idx] = Object.assign(encoding, desiredEncoding);
            }
            await transceiver.sender.setParameters(parameters);
        }
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $632b7b2896c8ff16$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // Hack for VP9 SVC.
        if (hackVp9Svc) sendingRtpParameters.encodings = [
            sendingRtpParameters.encodings[0]
        ];
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $632b7b2896c8ff16$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $632b7b2896c8ff16$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $632b7b2896c8ff16$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $632b7b2896c8ff16$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $632b7b2896c8ff16$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $632b7b2896c8ff16$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $632b7b2896c8ff16$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $632b7b2896c8ff16$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $632b7b2896c8ff16$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $632b7b2896c8ff16$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $632b7b2896c8ff16$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome70 = $632b7b2896c8ff16$var$Chrome70;

});

parcelRegister("jTGls", function(module, exports) {
"use strict";
var $e7c40033e829def9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7c40033e829def9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7c40033e829def9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7c40033e829def9$var$__createBinding(result, mod, k);
    }
    $e7c40033e829def9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome67 = void 0;

const $e7c40033e829def9$var$sdpTransform = $e7c40033e829def9$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $e7c40033e829def9$var$utils = $e7c40033e829def9$var$__importStar((parcelRequire("lghrF")));

const $e7c40033e829def9$var$ortc = $e7c40033e829def9$var$__importStar((parcelRequire("5Mq2W")));

const $e7c40033e829def9$var$sdpCommonUtils = $e7c40033e829def9$var$__importStar((parcelRequire("a2dIr")));

const $e7c40033e829def9$var$sdpPlanBUtils = $e7c40033e829def9$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $e7c40033e829def9$var$logger = new $24uNv.Logger("Chrome67");
const $e7c40033e829def9$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $e7c40033e829def9$var$Chrome67 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $e7c40033e829def9$var$Chrome67();
    }
    get name() {
        return "Chrome67";
    }
    close() {
        $e7c40033e829def9$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $e7c40033e829def9$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $e7c40033e829def9$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $e7c40033e829def9$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $e7c40033e829def9$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $e7c40033e829def9$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $e7c40033e829def9$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $e7c40033e829def9$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $e7c40033e829def9$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $e7c40033e829def9$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $e7c40033e829def9$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $e7c40033e829def9$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $e7c40033e829def9$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $e7c40033e829def9$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addTrack(track, this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $e7c40033e829def9$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $e7c40033e829def9$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $e7c40033e829def9$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $e7c40033e829def9$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $e7c40033e829def9$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $e7c40033e829def9$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $e7c40033e829def9$var$sdpTransform.write(localSdpObject)
            };
        }
        $e7c40033e829def9$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $e7c40033e829def9$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $e7c40033e829def9$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        const rtpSender = this._pc.getSenders().find((s)=>s.track === track);
        // Insert into the map.
        this._mapSendLocalIdRtpSender.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("stopSending() [localId:%s]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        this._pc.removeTrack(rtpSender);
        if (rtpSender.track) this._sendStream.removeTrack(rtpSender.track);
        this._mapSendLocalIdRtpSender.delete(localId);
        const offer = await this._pc.createOffer();
        $e7c40033e829def9$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $e7c40033e829def9$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $e7c40033e829def9$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $e7c40033e829def9$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const oldTrack = rtpSender.track;
        await rtpSender.replaceTrack(track);
        // Remove the old track from the local stream.
        if (oldTrack) this._sendStream.removeTrack(oldTrack);
        // Add the new track to the local stream.
        if (track) this._sendStream.addTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $e7c40033e829def9$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $e7c40033e829def9$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $e7c40033e829def9$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $e7c40033e829def9$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $e7c40033e829def9$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $e7c40033e829def9$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $e7c40033e829def9$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = trackId;
            const mid = kind;
            const rtpReceiver = this._pc.getReceivers().find((r)=>r.track && r.track.id === localId);
            if (!rtpReceiver) throw new Error("new RTCRtpReceiver not");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters,
                rtpReceiver: rtpReceiver
            });
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $e7c40033e829def9$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $e7c40033e829def9$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const { rtpReceiver: rtpReceiver } = this._mapRecvLocalIdInfo.get(localId) || {};
        if (!rtpReceiver) throw new Error("associated RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $e7c40033e829def9$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $e7c40033e829def9$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $e7c40033e829def9$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of RTCRtpSender indexed by localId.
        this._mapSendLocalIdRtpSender = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome67 = $e7c40033e829def9$var$Chrome67;

});
parcelRegister("gWHYI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRtpEncodings = $c5642d4c0e9422d6$var$getRtpEncodings;
module.exports.addLegacySimulcast = $c5642d4c0e9422d6$var$addLegacySimulcast;
function $c5642d4c0e9422d6$var$getRtpEncodings({ offerMediaObject: offerMediaObject, track: track }) {
    // First media SSRC (or the only one).
    let firstSsrc;
    const ssrcs = new Set();
    for (const line of offerMediaObject.ssrcs || []){
        if (line.attribute !== "msid") continue;
        const trackId = line.value.split(" ")[1];
        if (trackId === track.id) {
            const ssrc = line.id;
            ssrcs.add(ssrc);
            if (!firstSsrc) firstSsrc = ssrc;
        }
    }
    if (ssrcs.size === 0) throw new Error(`a=ssrc line with msid information not found [track.id:${track.id}]`);
    const ssrcToRtxSsrc = new Map();
    // First assume RTX is used.
    for (const line of offerMediaObject.ssrcGroups || []){
        if (line.semantics !== "FID") continue;
        let [ssrc, rtxSsrc] = line.ssrcs.split(/\s+/);
        ssrc = Number(ssrc);
        rtxSsrc = Number(rtxSsrc);
        if (ssrcs.has(ssrc)) {
            // Remove both the SSRC and RTX SSRC from the set so later we know that they
            // are already handled.
            ssrcs.delete(ssrc);
            ssrcs.delete(rtxSsrc);
            // Add to the map.
            ssrcToRtxSsrc.set(ssrc, rtxSsrc);
        }
    }
    // If the set of SSRCs is not empty it means that RTX is not being used, so take
    // media SSRCs from there.
    for (const ssrc of ssrcs)// Add to the map.
    ssrcToRtxSsrc.set(ssrc, null);
    const encodings = [];
    for (const [ssrc, rtxSsrc] of ssrcToRtxSsrc){
        const encoding = {
            ssrc: ssrc
        };
        if (rtxSsrc) encoding.rtx = {
            ssrc: rtxSsrc
        };
        encodings.push(encoding);
    }
    return encodings;
}
/**
 * Adds multi-ssrc based simulcast into the given SDP media section offer.
 */ function $c5642d4c0e9422d6$var$addLegacySimulcast({ offerMediaObject: offerMediaObject, track: track, numStreams: numStreams }) {
    if (numStreams <= 1) throw new TypeError("numStreams must be greater than 1");
    let firstSsrc;
    let firstRtxSsrc;
    let streamId;
    // Get the SSRC.
    const ssrcMsidLine = (offerMediaObject.ssrcs || []).find((line)=>{
        if (line.attribute !== "msid") return false;
        const trackId = line.value.split(" ")[1];
        if (trackId === track.id) {
            firstSsrc = line.id;
            streamId = line.value.split(" ")[0];
            return true;
        } else return false;
    });
    if (!ssrcMsidLine) throw new Error(`a=ssrc line with msid information not found [track.id:${track.id}]`);
    // Get the SSRC for RTX.
    (offerMediaObject.ssrcGroups || []).some((line)=>{
        if (line.semantics !== "FID") return false;
        const ssrcs = line.ssrcs.split(/\s+/);
        if (Number(ssrcs[0]) === firstSsrc) {
            firstRtxSsrc = Number(ssrcs[1]);
            return true;
        } else return false;
    });
    const ssrcCnameLine = offerMediaObject.ssrcs.find((line)=>line.attribute === "cname" && line.id === firstSsrc);
    if (!ssrcCnameLine) throw new Error(`a=ssrc line with cname information not found [track.id:${track.id}]`);
    const cname = ssrcCnameLine.value;
    const ssrcs = [];
    const rtxSsrcs = [];
    for(let i = 0; i < numStreams; ++i){
        ssrcs.push(firstSsrc + i);
        if (firstRtxSsrc) rtxSsrcs.push(firstRtxSsrc + i);
    }
    offerMediaObject.ssrcGroups = offerMediaObject.ssrcGroups || [];
    offerMediaObject.ssrcs = offerMediaObject.ssrcs || [];
    offerMediaObject.ssrcGroups.push({
        semantics: "SIM",
        ssrcs: ssrcs.join(" ")
    });
    for(let i = 0; i < ssrcs.length; ++i){
        const ssrc = ssrcs[i];
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId} ${track.id}`
        });
    }
    for(let i = 0; i < rtxSsrcs.length; ++i){
        const ssrc = ssrcs[i];
        const rtxSsrc = rtxSsrcs[i];
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "msid",
            value: `${streamId} ${track.id}`
        });
        offerMediaObject.ssrcGroups.push({
            semantics: "FID",
            ssrcs: `${ssrc} ${rtxSsrc}`
        });
    }
}

});


parcelRegister("6oohh", function(module, exports) {
"use strict";
var $4a77d10083b62993$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a77d10083b62993$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4a77d10083b62993$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4a77d10083b62993$var$__createBinding(result, mod, k);
    }
    $4a77d10083b62993$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome55 = void 0;

const $4a77d10083b62993$var$sdpTransform = $4a77d10083b62993$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $4a77d10083b62993$var$utils = $4a77d10083b62993$var$__importStar((parcelRequire("lghrF")));

const $4a77d10083b62993$var$ortc = $4a77d10083b62993$var$__importStar((parcelRequire("5Mq2W")));

const $4a77d10083b62993$var$sdpCommonUtils = $4a77d10083b62993$var$__importStar((parcelRequire("a2dIr")));

const $4a77d10083b62993$var$sdpPlanBUtils = $4a77d10083b62993$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $4a77d10083b62993$var$logger = new $24uNv.Logger("Chrome55");
const $4a77d10083b62993$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $4a77d10083b62993$var$Chrome55 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $4a77d10083b62993$var$Chrome55();
    }
    get name() {
        return "Chrome55";
    }
    close() {
        $4a77d10083b62993$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $4a77d10083b62993$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $4a77d10083b62993$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $4a77d10083b62993$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $4a77d10083b62993$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $4a77d10083b62993$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $4a77d10083b62993$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $4a77d10083b62993$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $4a77d10083b62993$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $4a77d10083b62993$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $4a77d10083b62993$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $4a77d10083b62993$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $4a77d10083b62993$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $4a77d10083b62993$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $4a77d10083b62993$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addStream(this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $4a77d10083b62993$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $4a77d10083b62993$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $4a77d10083b62993$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $4a77d10083b62993$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $4a77d10083b62993$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $4a77d10083b62993$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $4a77d10083b62993$var$sdpTransform.write(localSdpObject)
            };
        }
        $4a77d10083b62993$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $4a77d10083b62993$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $4a77d10083b62993$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Insert into the map.
        this._mapSendLocalIdTrack.set(localId, track);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $4a77d10083b62993$var$logger.debug("stopSending() [localId:%s]", localId);
        const track = this._mapSendLocalIdTrack.get(localId);
        if (!track) throw new Error("track not found");
        this._mapSendLocalIdTrack.delete(localId);
        this._sendStream.removeTrack(track);
        this._pc.addStream(this._sendStream);
        const offer = await this._pc.createOffer();
        $4a77d10083b62993$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $4a77d10083b62993$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    track) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async setMaxSpatialLayer(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    spatialLayer) {
        throw new $roix3.UnsupportedError(" not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setRtpEncodingParameters(localId, params) {
        throw new $roix3.UnsupportedError("not supported");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getSenderStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $4a77d10083b62993$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $4a77d10083b62993$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $4a77d10083b62993$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $4a77d10083b62993$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $4a77d10083b62993$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $4a77d10083b62993$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $4a77d10083b62993$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const localId = trackId;
            const streamId = options.streamId || rtpParameters.rtcp.cname;
            const stream = this._pc.getRemoteStreams().find((s)=>s.id === streamId);
            const track = stream.getTrackById(localId);
            if (!track) throw new Error("remote track not found");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters
            });
            results.push({
                localId: localId,
                track: track
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $4a77d10083b62993$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $4a77d10083b62993$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getReceiverStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $4a77d10083b62993$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $4a77d10083b62993$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $4a77d10083b62993$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of sending MediaStreamTracks indexed by localId.
        this._mapSendLocalIdTrack = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome55 = $4a77d10083b62993$var$Chrome55;

});

parcelRegister("l1Nf1", function(module, exports) {
"use strict";
var $f4efe33e5949c95a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4efe33e5949c95a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f4efe33e5949c95a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f4efe33e5949c95a$var$__createBinding(result, mod, k);
    }
    $f4efe33e5949c95a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Firefox120 = void 0;

const $f4efe33e5949c95a$var$sdpTransform = $f4efe33e5949c95a$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $f4efe33e5949c95a$var$utils = $f4efe33e5949c95a$var$__importStar((parcelRequire("lghrF")));

const $f4efe33e5949c95a$var$ortc = $f4efe33e5949c95a$var$__importStar((parcelRequire("5Mq2W")));

const $f4efe33e5949c95a$var$sdpCommonUtils = $f4efe33e5949c95a$var$__importStar((parcelRequire("a2dIr")));

const $f4efe33e5949c95a$var$sdpUnifiedPlanUtils = $f4efe33e5949c95a$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $f4efe33e5949c95a$var$logger = new $24uNv.Logger("Firefox120");
const $f4efe33e5949c95a$var$SCTP_NUM_STREAMS = {
    OS: 16,
    MIS: 2048
};
class $f4efe33e5949c95a$var$Firefox120 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $f4efe33e5949c95a$var$Firefox120();
    }
    get name() {
        return "Firefox120";
    }
    close() {
        $f4efe33e5949c95a$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $f4efe33e5949c95a$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        // NOTE: We need to add a real video track to get the RID extension mapping,
        // otherwiser Firefox doesn't include it in the SDP.
        const canvas = document.createElement("canvas");
        // NOTE: Otherwise Firefox fails in next line.
        canvas.getContext("2d");
        const fakeStream = canvas.captureStream();
        const fakeVideoTrack = fakeStream.getVideoTracks()[0];
        try {
            pc.addTransceiver("audio", {
                direction: "sendrecv"
            });
            pc.addTransceiver(fakeVideoTrack, {
                direction: "sendrecv",
                sendEncodings: [
                    {
                        rid: "r0",
                        maxBitrate: 100000
                    },
                    {
                        rid: "r1",
                        maxBitrate: 500000
                    }
                ]
            });
            const offer = await pc.createOffer();
            try {
                canvas.remove();
            } catch (error) {}
            try {
                fakeVideoTrack.stop();
            } catch (error) {}
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $f4efe33e5949c95a$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                canvas.remove();
            } catch (error2) {}
            try {
                fakeVideoTrack.stop();
            } catch (error2) {}
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $f4efe33e5949c95a$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $f4efe33e5949c95a$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $f4efe33e5949c95a$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $f4efe33e5949c95a$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $f4efe33e5949c95a$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $f4efe33e5949c95a$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $f4efe33e5949c95a$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $f4efe33e5949c95a$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        // NOTE: Firefox does not implement pc.setConfiguration().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $f4efe33e5949c95a$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $f4efe33e5949c95a$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $f4efe33e5949c95a$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $f4efe33e5949c95a$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $f4efe33e5949c95a$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        // NOTE: Firefox fails sometimes to properly anticipate the closed media
        // section that it should use, so don't reuse closed media sections.
        //   https://github.com/versatica/mediasoup-client/issues/104
        //
        // const mediaSectionIdx = this._remoteSdp!.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        const offer = await this._pc.createOffer();
        let localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
        // In Firefox use DTLS role client even if we are the "offerer" since
        // Firefox does not respect ICE-Lite.
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        $f4efe33e5949c95a$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[localSdpObject.media.length - 1];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $f4efe33e5949c95a$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $f4efe33e5949c95a$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $f4efe33e5949c95a$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        transceiver.sender.replaceTrack(null);
        // NOTE: Cannot use stop() the transceiver due to the the note above in
        // send() method.
        // try
        // {
        // 	transceiver.stop();
        // }
        // catch (error)
        // {}
        this._pc.removeTrack(transceiver.sender);
        // NOTE: Cannot use closeMediaSection() due to the the note above in send()
        // method.
        // this._remoteSdp!.closeMediaSection(transceiver.mid);
        this._remoteSdp.disableMediaSection(transceiver.mid);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $f4efe33e5949c95a$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $f4efe33e5949c95a$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $f4efe33e5949c95a$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $f4efe33e5949c95a$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: "client",
                localSdpObject: localSdpObject
            });
            $f4efe33e5949c95a$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $f4efe33e5949c95a$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $f4efe33e5949c95a$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
            answer = {
                type: "answer",
                sdp: $f4efe33e5949c95a$var$sdpTransform.write(localSdpObject)
            };
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        $f4efe33e5949c95a$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(answer.sdp);
                await this.setupTransport({
                    localDtlsRole: "client",
                    localSdpObject: localSdpObject
                });
            }
            $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $f4efe33e5949c95a$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Firefox120 = $f4efe33e5949c95a$var$Firefox120;

});

parcelRegister("a2Xk2", function(module, exports) {
"use strict";
var $75081b6b137db910$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75081b6b137db910$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $75081b6b137db910$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75081b6b137db910$var$__createBinding(result, mod, k);
    }
    $75081b6b137db910$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Firefox60 = void 0;

const $75081b6b137db910$var$sdpTransform = $75081b6b137db910$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $75081b6b137db910$var$utils = $75081b6b137db910$var$__importStar((parcelRequire("lghrF")));

const $75081b6b137db910$var$ortc = $75081b6b137db910$var$__importStar((parcelRequire("5Mq2W")));

const $75081b6b137db910$var$sdpCommonUtils = $75081b6b137db910$var$__importStar((parcelRequire("a2dIr")));

const $75081b6b137db910$var$sdpUnifiedPlanUtils = $75081b6b137db910$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $75081b6b137db910$var$logger = new $24uNv.Logger("Firefox60");
const $75081b6b137db910$var$SCTP_NUM_STREAMS = {
    OS: 16,
    MIS: 2048
};
class $75081b6b137db910$var$Firefox60 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $75081b6b137db910$var$Firefox60();
    }
    get name() {
        return "Firefox60";
    }
    close() {
        $75081b6b137db910$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $75081b6b137db910$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        // NOTE: We need to add a real video track to get the RID extension mapping.
        const canvas = document.createElement("canvas");
        // NOTE: Otherwise Firefox fails in next line.
        canvas.getContext("2d");
        const fakeStream = canvas.captureStream();
        const fakeVideoTrack = fakeStream.getVideoTracks()[0];
        try {
            pc.addTransceiver("audio", {
                direction: "sendrecv"
            });
            const videoTransceiver = pc.addTransceiver(fakeVideoTrack, {
                direction: "sendrecv"
            });
            const parameters = videoTransceiver.sender.getParameters();
            const encodings = [
                {
                    rid: "r0",
                    maxBitrate: 100000
                },
                {
                    rid: "r1",
                    maxBitrate: 500000
                }
            ];
            parameters.encodings = encodings;
            await videoTransceiver.sender.setParameters(parameters);
            const offer = await pc.createOffer();
            try {
                canvas.remove();
            } catch (error) {}
            try {
                fakeVideoTrack.stop();
            } catch (error) {}
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $75081b6b137db910$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                canvas.remove();
            } catch (error2) {}
            try {
                fakeVideoTrack.stop();
            } catch (error2) {}
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $75081b6b137db910$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $75081b6b137db910$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $75081b6b137db910$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $75081b6b137db910$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $75081b6b137db910$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $75081b6b137db910$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $75081b6b137db910$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $75081b6b137db910$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        // NOTE: Firefox does not implement pc.setConfiguration().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $75081b6b137db910$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings) {
            encodings = $75081b6b137db910$var$utils.clone(encodings);
            if (encodings.length > 1) {
                encodings.forEach((encoding, idx)=>{
                    encoding.rid = `r${idx}`;
                });
                // Clone the encodings and reverse them because Firefox likes them
                // from high to low.
                encodings.reverse();
            }
        }
        const sendingRtpParameters = $75081b6b137db910$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $75081b6b137db910$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $75081b6b137db910$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $75081b6b137db910$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        // NOTE: Firefox fails sometimes to properly anticipate the closed media
        // section that it should use, so don't reuse closed media sections.
        //   https://github.com/versatica/mediasoup-client/issues/104
        //
        // const mediaSectionIdx = this._remoteSdp!.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        // NOTE: This is not spec compliants. Encodings should be given in addTransceiver
        // second argument, but Firefox does not support it.
        if (encodings) {
            const parameters = transceiver.sender.getParameters();
            parameters.encodings = encodings;
            await transceiver.sender.setParameters(parameters);
        }
        const offer = await this._pc.createOffer();
        let localSdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
        // In Firefox use DTLS role client even if we are the "offerer" since
        // Firefox does not respect ICE-Lite.
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        $75081b6b137db910$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $75081b6b137db910$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[localSdpObject.media.length - 1];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $75081b6b137db910$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $75081b6b137db910$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $75081b6b137db910$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings.reverse();
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        transceiver.sender.replaceTrack(null);
        // NOTE: Cannot use stop() the transceiver due to the the note above in
        // send() method.
        // try
        // {
        // 	transceiver.stop();
        // }
        // catch (error)
        // {}
        this._pc.removeTrack(transceiver.sender);
        // NOTE: Cannot use closeMediaSection() due to the the note above in send()
        // method.
        // this._remoteSdp!.closeMediaSection(transceiver.mid);
        this._remoteSdp.disableMediaSection(transceiver.mid);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $75081b6b137db910$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $75081b6b137db910$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        const parameters = transceiver.sender.getParameters();
        // NOTE: We require encodings given from low to high, however Firefox
        // requires them in reverse order, so do magic here.
        spatialLayer = parameters.encodings.length - 1 - spatialLayer;
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx >= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $75081b6b137db910$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $75081b6b137db910$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: "client",
                localSdpObject: localSdpObject
            });
            $75081b6b137db910$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $75081b6b137db910$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $75081b6b137db910$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
            answer = {
                type: "answer",
                sdp: $75081b6b137db910$var$sdpTransform.write(localSdpObject)
            };
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        $75081b6b137db910$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $75081b6b137db910$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(answer.sdp);
                await this.setupTransport({
                    localDtlsRole: "client",
                    localSdpObject: localSdpObject
                });
            }
            $75081b6b137db910$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $75081b6b137db910$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $75081b6b137db910$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Firefox60 = $75081b6b137db910$var$Firefox60;

});

parcelRegister("cqkQU", function(module, exports) {
"use strict";
var $90b816944fb0be26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90b816944fb0be26$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $90b816944fb0be26$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $90b816944fb0be26$var$__createBinding(result, mod, k);
    }
    $90b816944fb0be26$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safari12 = void 0;

const $90b816944fb0be26$var$sdpTransform = $90b816944fb0be26$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $90b816944fb0be26$var$utils = $90b816944fb0be26$var$__importStar((parcelRequire("lghrF")));

const $90b816944fb0be26$var$ortc = $90b816944fb0be26$var$__importStar((parcelRequire("5Mq2W")));

const $90b816944fb0be26$var$sdpCommonUtils = $90b816944fb0be26$var$__importStar((parcelRequire("a2dIr")));

const $90b816944fb0be26$var$sdpUnifiedPlanUtils = $90b816944fb0be26$var$__importStar((parcelRequire("ghGMB")));

const $90b816944fb0be26$var$ortcUtils = $90b816944fb0be26$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $90b816944fb0be26$var$logger = new $24uNv.Logger("Safari12");
const $90b816944fb0be26$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $90b816944fb0be26$var$Safari12 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $90b816944fb0be26$var$Safari12();
    }
    get name() {
        return "Safari12";
    }
    close() {
        $90b816944fb0be26$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $90b816944fb0be26$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $90b816944fb0be26$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $90b816944fb0be26$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $90b816944fb0be26$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $90b816944fb0be26$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $90b816944fb0be26$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $90b816944fb0be26$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $90b816944fb0be26$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $90b816944fb0be26$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $90b816944fb0be26$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        const sendingRtpParameters = $90b816944fb0be26$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $90b816944fb0be26$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $90b816944fb0be26$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $90b816944fb0be26$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        let offer = await this._pc.createOffer();
        let localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length > 1) {
            $90b816944fb0be26$var$logger.debug("send() | enabling legacy simulcast");
            localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $90b816944fb0be26$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $90b816944fb0be26$var$sdpTransform.write(localSdpObject)
            };
        }
        $90b816944fb0be26$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $90b816944fb0be26$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $90b816944fb0be26$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        if (this._closed) return;
        $90b816944fb0be26$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $90b816944fb0be26$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $90b816944fb0be26$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $90b816944fb0be26$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $90b816944fb0be26$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $90b816944fb0be26$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $90b816944fb0be26$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $90b816944fb0be26$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $90b816944fb0be26$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $90b816944fb0be26$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $90b816944fb0be26$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $90b816944fb0be26$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $90b816944fb0be26$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Safari12 = $90b816944fb0be26$var$Safari12;

});

parcelRegister("5TVIx", function(module, exports) {
"use strict";
var $44bedc4536a2ac68$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44bedc4536a2ac68$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $44bedc4536a2ac68$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $44bedc4536a2ac68$var$__createBinding(result, mod, k);
    }
    $44bedc4536a2ac68$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safari11 = void 0;

const $44bedc4536a2ac68$var$sdpTransform = $44bedc4536a2ac68$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $44bedc4536a2ac68$var$utils = $44bedc4536a2ac68$var$__importStar((parcelRequire("lghrF")));

const $44bedc4536a2ac68$var$ortc = $44bedc4536a2ac68$var$__importStar((parcelRequire("5Mq2W")));

const $44bedc4536a2ac68$var$sdpCommonUtils = $44bedc4536a2ac68$var$__importStar((parcelRequire("a2dIr")));

const $44bedc4536a2ac68$var$sdpPlanBUtils = $44bedc4536a2ac68$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $44bedc4536a2ac68$var$logger = new $24uNv.Logger("Safari11");
const $44bedc4536a2ac68$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $44bedc4536a2ac68$var$Safari11 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $44bedc4536a2ac68$var$Safari11();
    }
    get name() {
        return "Safari11";
    }
    close() {
        $44bedc4536a2ac68$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $44bedc4536a2ac68$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $44bedc4536a2ac68$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $44bedc4536a2ac68$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $44bedc4536a2ac68$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $44bedc4536a2ac68$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $44bedc4536a2ac68$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $44bedc4536a2ac68$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $44bedc4536a2ac68$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $44bedc4536a2ac68$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $44bedc4536a2ac68$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $44bedc4536a2ac68$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $44bedc4536a2ac68$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $44bedc4536a2ac68$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addTrack(track, this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $44bedc4536a2ac68$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $44bedc4536a2ac68$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $44bedc4536a2ac68$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $44bedc4536a2ac68$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $44bedc4536a2ac68$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $44bedc4536a2ac68$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $44bedc4536a2ac68$var$sdpTransform.write(localSdpObject)
            };
        }
        $44bedc4536a2ac68$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $44bedc4536a2ac68$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $44bedc4536a2ac68$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        const rtpSender = this._pc.getSenders().find((s)=>s.track === track);
        // Insert into the map.
        this._mapSendLocalIdRtpSender.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        if (rtpSender.track) this._sendStream.removeTrack(rtpSender.track);
        this._mapSendLocalIdRtpSender.delete(localId);
        const offer = await this._pc.createOffer();
        $44bedc4536a2ac68$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $44bedc4536a2ac68$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $44bedc4536a2ac68$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $44bedc4536a2ac68$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const oldTrack = rtpSender.track;
        await rtpSender.replaceTrack(track);
        // Remove the old track from the local stream.
        if (oldTrack) this._sendStream.removeTrack(oldTrack);
        // Add the new track to the local stream.
        if (track) this._sendStream.addTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $44bedc4536a2ac68$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $44bedc4536a2ac68$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $44bedc4536a2ac68$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $44bedc4536a2ac68$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $44bedc4536a2ac68$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $44bedc4536a2ac68$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $44bedc4536a2ac68$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const localId = trackId;
            const rtpReceiver = this._pc.getReceivers().find((r)=>r.track && r.track.id === localId);
            if (!rtpReceiver) throw new Error("new RTCRtpReceiver not");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters,
                rtpReceiver: rtpReceiver
            });
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $44bedc4536a2ac68$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $44bedc4536a2ac68$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const { rtpReceiver: rtpReceiver } = this._mapRecvLocalIdInfo.get(localId) || {};
        if (!rtpReceiver) throw new Error("associated RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $44bedc4536a2ac68$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of RTCRtpSender indexed by localId.
        this._mapSendLocalIdRtpSender = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Safari11 = $44bedc4536a2ac68$var$Safari11;

});

parcelRegister("3HogQ", function(module, exports) {
"use strict";
var $2b1836e0c9c002fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b1836e0c9c002fc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2b1836e0c9c002fc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2b1836e0c9c002fc$var$__createBinding(result, mod, k);
    }
    $2b1836e0c9c002fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Edge11 = void 0;

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $2b1836e0c9c002fc$var$utils = $2b1836e0c9c002fc$var$__importStar((parcelRequire("lghrF")));

const $2b1836e0c9c002fc$var$ortc = $2b1836e0c9c002fc$var$__importStar((parcelRequire("5Mq2W")));

const $2b1836e0c9c002fc$var$edgeUtils = $2b1836e0c9c002fc$var$__importStar((parcelRequire("gqu15")));

var $2ptPl = parcelRequire("2ptPl");
const $2b1836e0c9c002fc$var$logger = new $24uNv.Logger("Edge11");
class $2b1836e0c9c002fc$var$Edge11 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $2b1836e0c9c002fc$var$Edge11();
    }
    get name() {
        return "Edge11";
    }
    close() {
        $2b1836e0c9c002fc$var$logger.debug("close()");
        // Close the ICE gatherer.
        // NOTE: Not yet implemented by Edge.
        try {
            this._iceGatherer.close();
        } catch (error) {}
        // Close the ICE transport.
        try {
            this._iceTransport.stop();
        } catch (error) {}
        // Close the DTLS transport.
        try {
            this._dtlsTransport.stop();
        } catch (error) {}
        // Close RTCRtpSenders.
        for (const rtpSender of this._rtpSenders.values())try {
            rtpSender.stop();
        } catch (error) {}
        // Close RTCRtpReceivers.
        for (const rtpReceiver of this._rtpReceivers.values())try {
            rtpReceiver.stop();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $2b1836e0c9c002fc$var$logger.debug("getNativeRtpCapabilities()");
        return $2b1836e0c9c002fc$var$edgeUtils.getCapabilities();
    }
    async getNativeSctpCapabilities() {
        $2b1836e0c9c002fc$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: {
                OS: 0,
                MIS: 0
            }
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $2b1836e0c9c002fc$var$logger.debug("run()");
        this._sendingRtpParametersByKind = {
            audio: $2b1836e0c9c002fc$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $2b1836e0c9c002fc$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._remoteIceParameters = iceParameters;
        this._remoteIceCandidates = iceCandidates;
        this._remoteDtlsParameters = dtlsParameters;
        this._cname = `CNAME-${$2b1836e0c9c002fc$var$utils.generateRandomNumber()}`;
        this.setIceGatherer({
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy
        });
        this.setIceTransport();
        this.setDtlsTransport();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        // NOTE: Edge 11 does not implement iceGatherer.gater().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        $2b1836e0c9c002fc$var$logger.debug("restartIce()");
        this._remoteIceParameters = iceParameters;
        if (!this._transportReady) return;
        $2b1836e0c9c002fc$var$logger.debug("restartIce() | calling iceTransport.start()");
        this._iceTransport.start(this._iceGatherer, iceParameters, "controlling");
        for (const candidate of this._remoteIceCandidates)this._iceTransport.addRemoteCandidate(candidate);
        this._iceTransport.addRemoteCandidate({});
    }
    async getTransportStats() {
        return this._iceTransport.getStats();
    }
    async send(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    { track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        $2b1836e0c9c002fc$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "server"
        });
        $2b1836e0c9c002fc$var$logger.debug("send() | calling new RTCRtpSender()");
        const rtpSender = new RTCRtpSender(track, this._dtlsTransport);
        const rtpParameters = $2b1836e0c9c002fc$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        rtpParameters.codecs = $2b1836e0c9c002fc$var$ortc.reduceCodecs(rtpParameters.codecs, codec);
        const useRtx = rtpParameters.codecs.some((_codec)=>/.+\/rtx$/i.test(_codec.mimeType));
        if (!encodings) encodings = [
            {}
        ];
        for (const encoding of encodings){
            encoding.ssrc = $2b1836e0c9c002fc$var$utils.generateRandomNumber();
            if (useRtx) encoding.rtx = {
                ssrc: $2b1836e0c9c002fc$var$utils.generateRandomNumber()
            };
        }
        rtpParameters.encodings = encodings;
        // Fill RTCRtpParameters.rtcp.
        rtpParameters.rtcp = {
            cname: this._cname,
            reducedSize: true,
            mux: true
        };
        // NOTE: Convert our standard RTCRtpParameters into those that Edge
        // expects.
        const edgeRtpParameters = $2b1836e0c9c002fc$var$edgeUtils.mangleRtpParameters(rtpParameters);
        $2b1836e0c9c002fc$var$logger.debug("send() | calling rtpSender.send() [params:%o]", edgeRtpParameters);
        await rtpSender.send(edgeRtpParameters);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Store it.
        this._rtpSenders.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: rtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        $2b1836e0c9c002fc$var$logger.debug("stopSending() [localId:%s]", localId);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        this._rtpSenders.delete(localId);
        try {
            $2b1836e0c9c002fc$var$logger.debug("stopSending() | calling rtpSender.stop()");
            rtpSender.stop();
        } catch (error) {
            $2b1836e0c9c002fc$var$logger.warn("stopSending() | rtpSender.stop() failed:%o", error);
            throw error;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        if (track) $2b1836e0c9c002fc$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $2b1836e0c9c002fc$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        rtpSender.setTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        $2b1836e0c9c002fc$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        $2b1836e0c9c002fc$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    options) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receive(optionsList) {
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind } = options;
            $2b1836e0c9c002fc$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "server"
        });
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters } = options;
            $2b1836e0c9c002fc$var$logger.debug("receive() | calling new RTCRtpReceiver()");
            const rtpReceiver = new RTCRtpReceiver(this._dtlsTransport, kind);
            rtpReceiver.addEventListener("error", (event)=>{
                $2b1836e0c9c002fc$var$logger.error('rtpReceiver "error" event [event:%o]', event);
            });
            // NOTE: Convert our standard RTCRtpParameters into those that Edge
            // expects.
            const edgeRtpParameters = $2b1836e0c9c002fc$var$edgeUtils.mangleRtpParameters(rtpParameters);
            $2b1836e0c9c002fc$var$logger.debug("receive() | calling rtpReceiver.receive() [params:%o]", edgeRtpParameters);
            await rtpReceiver.receive(edgeRtpParameters);
            const localId = trackId;
            // Store it.
            this._rtpReceivers.set(localId, rtpReceiver);
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        for (const localId of localIds){
            $2b1836e0c9c002fc$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const rtpReceiver = this._rtpReceivers.get(localId);
            if (!rtpReceiver) throw new Error("RTCRtpReceiver not found");
            this._rtpReceivers.delete(localId);
            try {
                $2b1836e0c9c002fc$var$logger.debug("stopReceiving() | calling rtpReceiver.stop()");
                rtpReceiver.stop();
            } catch (error) {
                $2b1836e0c9c002fc$var$logger.warn("stopReceiving() | rtpReceiver.stop() failed:%o", error);
            }
        }
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        const rtpReceiver = this._rtpReceivers.get(localId);
        if (!rtpReceiver) throw new Error("RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async receiveDataChannel(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    options) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    setIceGatherer({ iceServers: iceServers, iceTransportPolicy: iceTransportPolicy }) {
        // @ts-ignore
        const iceGatherer = new RTCIceGatherer({
            iceServers: iceServers || [],
            gatherPolicy: iceTransportPolicy || "all"
        });
        iceGatherer.addEventListener("error", (event)=>{
            $2b1836e0c9c002fc$var$logger.error('iceGatherer "error" event [event:%o]', event);
        });
        // NOTE: Not yet implemented by Edge, which starts gathering automatically.
        try {
            iceGatherer.gather();
        } catch (error) {
            $2b1836e0c9c002fc$var$logger.debug("setIceGatherer() | iceGatherer.gather() failed: %s", error.toString());
        }
        this._iceGatherer = iceGatherer;
    }
    setIceTransport() {
        const iceTransport = new RTCIceTransport(this._iceGatherer);
        // NOTE: Not yet implemented by Edge.
        iceTransport.addEventListener("statechange", ()=>{
            switch(iceTransport.state){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
        // NOTE: Not standard, but implemented by Edge.
        iceTransport.addEventListener("icestatechange", ()=>{
            switch(iceTransport.state){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
        iceTransport.addEventListener("candidatepairchange", (event)=>{
            $2b1836e0c9c002fc$var$logger.debug('iceTransport "candidatepairchange" event [pair:%o]', event.pair);
        });
        this._iceTransport = iceTransport;
    }
    setDtlsTransport() {
        const dtlsTransport = new RTCDtlsTransport(this._iceTransport);
        // NOTE: Not yet implemented by Edge.
        dtlsTransport.addEventListener("statechange", ()=>{
            $2b1836e0c9c002fc$var$logger.debug('dtlsTransport "statechange" event [state:%s]', dtlsTransport.state);
        });
        // NOTE: Not standard, but implemented by Edge.
        dtlsTransport.addEventListener("dtlsstatechange", ()=>{
            $2b1836e0c9c002fc$var$logger.debug('dtlsTransport "dtlsstatechange" event [state:%s]', dtlsTransport.state);
            if (dtlsTransport.state === "closed") this.emit("@connectionstatechange", "closed");
        });
        dtlsTransport.addEventListener("error", (event)=>{
            $2b1836e0c9c002fc$var$logger.error('dtlsTransport "error" event [event:%o]', event);
        });
        this._dtlsTransport = dtlsTransport;
    }
    async setupTransport({ localDtlsRole: localDtlsRole }) {
        $2b1836e0c9c002fc$var$logger.debug("setupTransport()");
        // Get our local DTLS parameters.
        const dtlsParameters = this._dtlsTransport.getLocalParameters();
        dtlsParameters.role = localDtlsRole;
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        // Start the RTCIceTransport.
        this._iceTransport.start(this._iceGatherer, this._remoteIceParameters, "controlling");
        // Add remote ICE candidates.
        for (const candidate of this._remoteIceCandidates)this._iceTransport.addRemoteCandidate(candidate);
        // Also signal a 'complete' candidate as per spec.
        // NOTE: It should be {complete: true} but Edge prefers {}.
        // NOTE: If we don't signal end of candidates, the Edge RTCIceTransport
        // won't enter the 'completed' state.
        this._iceTransport.addRemoteCandidate({});
        // NOTE: Edge does not like SHA less than 256.
        this._remoteDtlsParameters.fingerprints = this._remoteDtlsParameters.fingerprints.filter((fingerprint)=>{
            return fingerprint.algorithm === "sha-256" || fingerprint.algorithm === "sha-384" || fingerprint.algorithm === "sha-512";
        });
        // Start the RTCDtlsTransport.
        this._dtlsTransport.start(this._remoteDtlsParameters);
        this._transportReady = true;
    }
    constructor(){
        super();
        // Map of RTCRtpSenders indexed by id.
        this._rtpSenders = new Map();
        // Map of RTCRtpReceivers indexed by id.
        this._rtpReceivers = new Map();
        // Next localId for sending tracks.
        this._nextSendLocalId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Edge11 = $2b1836e0c9c002fc$var$Edge11;

});
parcelRegister("gqu15", function(module, exports) {
"use strict";
var $bf565bafd617b619$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf565bafd617b619$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bf565bafd617b619$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bf565bafd617b619$var$__createBinding(result, mod, k);
    }
    $bf565bafd617b619$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCapabilities = $bf565bafd617b619$var$getCapabilities;
module.exports.mangleRtpParameters = $bf565bafd617b619$var$mangleRtpParameters;

const $bf565bafd617b619$var$utils = $bf565bafd617b619$var$__importStar((parcelRequire("lghrF")));
/**
 * Normalize ORTC based Edge's RTCRtpReceiver.getCapabilities() to produce a full
 * compliant ORTC RTCRtpCapabilities.
 */ function $bf565bafd617b619$var$getCapabilities() {
    const nativeCaps = RTCRtpReceiver.getCapabilities();
    const caps = $bf565bafd617b619$var$utils.clone(nativeCaps);
    var _caps_codecs;
    for (const codec of (_caps_codecs = caps.codecs) !== null && _caps_codecs !== void 0 ? _caps_codecs : []){
        // Rename numChannels to channels.
        // @ts-ignore
        codec.channels = codec.numChannels;
        // @ts-ignore
        delete codec.numChannels;
        // Add mimeType.
        // @ts-ignore (due to codec.name).
        codec.mimeType = codec.mimeType || `${codec.kind}/${codec.name}`;
        // NOTE: Edge sets some numeric parameters as string rather than number. Fix them.
        if (codec.parameters) {
            const parameters = codec.parameters;
            if (parameters.apt) parameters.apt = Number(parameters.apt);
            if (parameters["packetization-mode"]) parameters["packetization-mode"] = Number(parameters["packetization-mode"]);
        }
        // Delete emty parameter String in rtcpFeedback.
        for (const feedback of codec.rtcpFeedback || [])if (!feedback.parameter) feedback.parameter = "";
    }
    return caps;
}
/**
 * Generate RTCRtpParameters as ORTC based Edge likes.
 */ function $bf565bafd617b619$var$mangleRtpParameters(rtpParameters) {
    const params = $bf565bafd617b619$var$utils.clone(rtpParameters);
    // Rename mid to muxId.
    if (params.mid) {
        // @ts-ignore (due to muxId).
        params.muxId = params.mid;
        delete params.mid;
    }
    for (const codec of params.codecs){
        // Rename channels to numChannels.
        if (codec.channels) {
            // @ts-ignore.
            codec.numChannels = codec.channels;
            delete codec.channels;
        }
        // Add codec.name (requried by Edge).
        // @ts-ignore (due to name).
        if (codec.mimeType && !codec.name) // @ts-ignore (due to name).
        codec.name = codec.mimeType.split("/")[1];
        // Remove mimeType.
        // @ts-ignore
        delete codec.mimeType;
    }
    return params;
}

});


parcelRegister("bcHUy", function(module, exports) {
"use strict";
var $8282e08bfb18d5fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8282e08bfb18d5fc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8282e08bfb18d5fc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8282e08bfb18d5fc$var$__createBinding(result, mod, k);
    }
    $8282e08bfb18d5fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactNativeUnifiedPlan = void 0;

const $8282e08bfb18d5fc$var$sdpTransform = $8282e08bfb18d5fc$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $8282e08bfb18d5fc$var$utils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("lghrF")));

const $8282e08bfb18d5fc$var$ortc = $8282e08bfb18d5fc$var$__importStar((parcelRequire("5Mq2W")));

const $8282e08bfb18d5fc$var$sdpCommonUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("a2dIr")));

const $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("ghGMB")));

const $8282e08bfb18d5fc$var$ortcUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $8282e08bfb18d5fc$var$logger = new $24uNv.Logger("ReactNativeUnifiedPlan");
const $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan();
    }
    get name() {
        return "ReactNativeUnifiedPlan";
    }
    close() {
        $8282e08bfb18d5fc$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Free/dispose native MediaStream but DO NOT free/dispose native
        // MediaStreamTracks (that is parent's business).
        // @ts-ignore (proprietary API in react-native-webrtc).
        this._sendStream.release(/* releaseTracks */ false);
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $8282e08bfb18d5fc$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $8282e08bfb18d5fc$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $8282e08bfb18d5fc$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $8282e08bfb18d5fc$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $8282e08bfb18d5fc$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $8282e08bfb18d5fc$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $8282e08bfb18d5fc$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $8282e08bfb18d5fc$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $8282e08bfb18d5fc$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $8282e08bfb18d5fc$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $8282e08bfb18d5fc$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $8282e08bfb18d5fc$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $8282e08bfb18d5fc$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        let offer = await this._pc.createOffer();
        let localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $8282e08bfb18d5fc$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $8282e08bfb18d5fc$var$sdpTransform.write(localSdpObject)
            };
        }
        $8282e08bfb18d5fc$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        var _transceiver_mid;
        // We can now get the transceiver.mid.
        // NOTE: We cannot read generated MID on iOS react-native-webrtc 111.0.0
        // because transceiver.mid is not available until setRemoteDescription()
        // is called, so this is best effort.
        // Issue: https://github.com/react-native-webrtc/react-native-webrtc/issues/1404
        // NOTE: So let's fill MID in sendingRtpParameters later.
        // NOTE: This is fixed in react-native-webrtc 111.0.3.
        let localId = (_transceiver_mid = transceiver.mid) !== null && _transceiver_mid !== void 0 ? _transceiver_mid : undefined;
        if (!localId) $8282e08bfb18d5fc$var$logger.warn("send() | missing transceiver.mid (bug in react-native-webrtc, using a workaround");
        // Set MID.
        // NOTE: As per above, it could be unset yet.
        sendingRtpParameters.mid = localId;
        localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $8282e08bfb18d5fc$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            let newEncodings = $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            // Hack for VP9 SVC.
            if (hackVp9Svc) newEncodings = [
                newEncodings[0]
            ];
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Follow up of iOS react-native-webrtc 111.0.0 issue told above. Now yes,
        // we can read generated MID (if not done above) and fill sendingRtpParameters.
        // NOTE: This is fixed in react-native-webrtc 111.0.3 so this block isn't
        // needed starting from that version.
        if (!localId) {
            localId = transceiver.mid;
            sendingRtpParameters.mid = localId;
        }
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        if (this._closed) return;
        $8282e08bfb18d5fc$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $8282e08bfb18d5fc$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $8282e08bfb18d5fc$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $8282e08bfb18d5fc$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $8282e08bfb18d5fc$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $8282e08bfb18d5fc$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $8282e08bfb18d5fc$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $8282e08bfb18d5fc$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.ReactNativeUnifiedPlan = $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan;

});

parcelRegister("5GCJE", function(module, exports) {
"use strict";
var $423eec07d95d6603$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $423eec07d95d6603$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $423eec07d95d6603$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $423eec07d95d6603$var$__createBinding(result, mod, k);
    }
    $423eec07d95d6603$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactNative = void 0;

const $423eec07d95d6603$var$sdpTransform = $423eec07d95d6603$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $423eec07d95d6603$var$utils = $423eec07d95d6603$var$__importStar((parcelRequire("lghrF")));

const $423eec07d95d6603$var$ortc = $423eec07d95d6603$var$__importStar((parcelRequire("5Mq2W")));

const $423eec07d95d6603$var$sdpCommonUtils = $423eec07d95d6603$var$__importStar((parcelRequire("a2dIr")));

const $423eec07d95d6603$var$sdpPlanBUtils = $423eec07d95d6603$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $423eec07d95d6603$var$logger = new $24uNv.Logger("ReactNative");
const $423eec07d95d6603$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $423eec07d95d6603$var$ReactNative extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $423eec07d95d6603$var$ReactNative();
    }
    get name() {
        return "ReactNative";
    }
    close() {
        $423eec07d95d6603$var$logger.debug("close()");
        // Free/dispose native MediaStream but DO NOT free/dispose native
        // MediaStreamTracks (that is parent's business).
        // @ts-ignore (proprietary API in react-native-webrtc).
        this._sendStream.release(/* releaseTracks */ false);
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $423eec07d95d6603$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $423eec07d95d6603$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $423eec07d95d6603$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $423eec07d95d6603$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $423eec07d95d6603$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $423eec07d95d6603$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $423eec07d95d6603$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $423eec07d95d6603$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $423eec07d95d6603$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $423eec07d95d6603$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $423eec07d95d6603$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $423eec07d95d6603$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $423eec07d95d6603$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $423eec07d95d6603$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addStream(this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $423eec07d95d6603$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $423eec07d95d6603$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $423eec07d95d6603$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $423eec07d95d6603$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $423eec07d95d6603$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $423eec07d95d6603$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $423eec07d95d6603$var$sdpTransform.write(localSdpObject)
            };
        }
        $423eec07d95d6603$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $423eec07d95d6603$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $423eec07d95d6603$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Insert into the map.
        this._mapSendLocalIdTrack.set(localId, track);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $423eec07d95d6603$var$logger.debug("stopSending() [localId:%s]", localId);
        const track = this._mapSendLocalIdTrack.get(localId);
        if (!track) throw new Error("track not found");
        this._mapSendLocalIdTrack.delete(localId);
        this._sendStream.removeTrack(track);
        this._pc.addStream(this._sendStream);
        const offer = await this._pc.createOffer();
        $423eec07d95d6603$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $423eec07d95d6603$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    track) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async setMaxSpatialLayer(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    spatialLayer) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setRtpEncodingParameters(localId, params) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getSenderStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $423eec07d95d6603$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $423eec07d95d6603$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $423eec07d95d6603$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        const mapStreamId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters } = options;
            $423eec07d95d6603$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            let streamId = options.streamId || rtpParameters.rtcp.cname;
            // NOTE: In React-Native we cannot reuse the same remote MediaStream for new
            // remote tracks. This is because react-native-webrtc does not react on new
            // tracks generated within already existing streams, so force the streamId
            // to be different. See:
            // https://github.com/react-native-webrtc/react-native-webrtc/issues/401
            $423eec07d95d6603$var$logger.debug("receive() | forcing a random remote streamId to avoid well known bug in react-native-webrtc");
            streamId += `-hack-${$423eec07d95d6603$var$utils.generateRandomNumber()}`;
            mapStreamId.set(trackId, streamId);
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $423eec07d95d6603$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $423eec07d95d6603$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $423eec07d95d6603$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = trackId;
            const mid = kind;
            const streamId = mapStreamId.get(trackId);
            const stream = this._pc.getRemoteStreams().find((s)=>s.id === streamId);
            const track = stream.getTrackById(localId);
            if (!track) throw new Error("remote track not found");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters
            });
            results.push({
                localId: localId,
                track: track
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $423eec07d95d6603$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $423eec07d95d6603$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getReceiverStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $423eec07d95d6603$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $423eec07d95d6603$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $423eec07d95d6603$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of sending MediaStreamTracks indexed by localId.
        this._mapSendLocalIdTrack = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.ReactNative = $423eec07d95d6603$var$ReactNative;

});


parcelRegister("5Mrx3", function(module, exports) {
"use strict";
var $4356cabd4d4b59f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4356cabd4d4b59f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4356cabd4d4b59f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("46xMb")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("7Whb6")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("ckNpk")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("kYlAk")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("7caxm")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("9SUdt")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("5AoGB")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("cMUWc")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("2ptPl")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("roix3")), module.exports);

});
parcelRegister("5AoGB", function(module, exports) {
"use strict";
/**
 * The RTP capabilities define what mediasoup or an endpoint can receive at
 * media level.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cMUWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("23jSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCorrect = module.exports.isInSubnet = void 0;
function $17eb48748986953c$var$isInSubnet(address) {
    if (this.subnetMask < address.subnetMask) return false;
    if (this.mask(address.subnetMask) === address.mask()) return true;
    return false;
}
module.exports.isInSubnet = $17eb48748986953c$var$isInSubnet;
function $17eb48748986953c$var$isCorrect(defaultBits) {
    return function() {
        if (this.addressMinusSuffix !== this.correctForm()) return false;
        if (this.subnetMask === defaultBits && !this.parsedSubnet) return true;
        return this.parsedSubnet === String(this.subnetMask);
    };
}
module.exports.isCorrect = $17eb48748986953c$var$isCorrect;

});

parcelRegister("i0ccS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_SUBNET_STRING = module.exports.RE_ADDRESS = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 32;
module.exports.GROUPS = 4;
module.exports.RE_ADDRESS = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
module.exports.RE_SUBNET_STRING = /\/\d{1,2}$/;

});

parcelRegister("cqjLs", function(module, exports) {
(function() {
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (inBrowser && j_lm && navigator.appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Random number generator - requires a PRNG backend, e.g. prng4.js
    // For best results, put code like
    // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
    // in your main HTML document.
    var rng_state;
    var rng_pool;
    var rng_pptr;
    // Mix in a 32-bit integer into the pool
    function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= x >> 8 & 255;
        rng_pool[rng_pptr++] ^= x >> 16 & 255;
        rng_pool[rng_pptr++] ^= x >> 24 & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
    }
    // Mix in the current time (w/milliseconds) into the pool
    function rng_seed_time() {
        rng_seed_int(new Date().getTime());
    }
    // Initialize the pool with junk if needed.
    if (rng_pool == null) {
        rng_pool = new Array();
        rng_pptr = 0;
        var t;
        if (typeof window !== "undefined" && window.crypto) {
            if (window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for(t = 0; t < 32; ++t)rng_pool[rng_pptr++] = ua[t];
            } else if (navigator.appName == "Netscape" && navigator.appVersion < "5") {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
        }
        while(rng_pptr < rng_psize){
            t = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = t >>> 8;
            rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
    //rng_seed_int(window.screenX);
    //rng_seed_int(window.screenY);
    }
    function rng_get_byte() {
        if (rng_state == null) {
            rng_seed_time();
            rng_state = prng_newstate();
            rng_state.init(rng_pool);
            for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)rng_pool[rng_pptr] = 0;
            rng_pptr = 0;
        //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
    }
    function rng_get_bytes(ba) {
        var i;
        for(i = 0; i < ba.length; ++i)ba[i] = rng_get_byte();
    }
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = rng_get_bytes;
    // prng4.js - uses Arcfour as a PRNG
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = new Array();
    }
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    function ARC4init(key) {
        var i, j, t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    }
    function ARC4next() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    }
    Arcfour.prototype.init = ARC4init;
    Arcfour.prototype.next = ARC4next;
    // Plug in your RNG constructor here
    function prng_newstate() {
        return new Arcfour();
    }
    // Pool size must be a multiple of 4 and greater than 32.
    // An array of bytes the size of the pool will be passed to init()
    var rng_psize = 256;
    exports = module.exports = {
        default: BigInteger,
        BigInteger: BigInteger,
        SecureRandom: SecureRandom
    };
}).call(this);

});

parcelRegister("oXAYb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_URL_WITH_PORT = module.exports.RE_URL = module.exports.RE_ZONE_STRING = module.exports.RE_SUBNET_STRING = module.exports.RE_BAD_ADDRESS = module.exports.RE_BAD_CHARACTERS = module.exports.TYPES = module.exports.SCOPES = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 128;
module.exports.GROUPS = 8;
/**
 * Represents IPv6 address scopes
 * @memberof Address6
 * @static
 */ module.exports.SCOPES = {
    0: "Reserved",
    1: "Interface local",
    2: "Link local",
    4: "Admin local",
    5: "Site local",
    8: "Organization local",
    14: "Global",
    15: "Reserved"
};
/**
 * Represents IPv6 address types
 * @memberof Address6
 * @static
 */ module.exports.TYPES = {
    "ff01::1/128": "Multicast (All nodes on this interface)",
    "ff01::2/128": "Multicast (All routers on this interface)",
    "ff02::1/128": "Multicast (All nodes on this link)",
    "ff02::2/128": "Multicast (All routers on this link)",
    "ff05::2/128": "Multicast (All routers in this site)",
    "ff02::5/128": "Multicast (OSPFv3 AllSPF routers)",
    "ff02::6/128": "Multicast (OSPFv3 AllDR routers)",
    "ff02::9/128": "Multicast (RIP routers)",
    "ff02::a/128": "Multicast (EIGRP routers)",
    "ff02::d/128": "Multicast (PIM routers)",
    "ff02::16/128": "Multicast (MLDv2 reports)",
    "ff01::fb/128": "Multicast (mDNSv6)",
    "ff02::fb/128": "Multicast (mDNSv6)",
    "ff05::fb/128": "Multicast (mDNSv6)",
    "ff02::1:2/128": "Multicast (All DHCP servers and relay agents on this link)",
    "ff05::1:2/128": "Multicast (All DHCP servers and relay agents in this site)",
    "ff02::1:3/128": "Multicast (All DHCP servers on this link)",
    "ff05::1:3/128": "Multicast (All DHCP servers in this site)",
    "::/128": "Unspecified",
    "::1/128": "Loopback",
    "ff00::/8": "Multicast",
    "fe80::/10": "Link-local unicast"
};
/**
 * A regular expression that matches bad characters in an IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_CHARACTERS = /([^0-9a-f:/%])/gi;
/**
 * A regular expression that matches an incorrect IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_ADDRESS = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/gi;
/**
 * A regular expression that matches an IPv6 subnet
 * @memberof Address6
 * @static
 */ module.exports.RE_SUBNET_STRING = /\/\d{1,3}(?=%|$)/;
/**
 * A regular expression that matches an IPv6 zone
 * @memberof Address6
 * @static
 */ module.exports.RE_ZONE_STRING = /%.*$/;
module.exports.RE_URL = new RegExp(/^\[{0,1}([0-9a-f:]+)\]{0,1}/);
module.exports.RE_URL_WITH_PORT = new RegExp(/\[([0-9a-f:]+)\]:([0-9]{1,5})/);

});

parcelRegister("1Q0Pv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleGroup = module.exports.spanLeadingZeroes = module.exports.spanAll = module.exports.spanAllZeroes = void 0;

var $krCXC = parcelRequire("krCXC");
/**
 * @returns {String} the string with all zeroes contained in a <span>
 */ function $156b4a8789e90775$var$spanAllZeroes(s) {
    return s.replace(/(0+)/g, '<span class="zero">$1</span>');
}
module.exports.spanAllZeroes = $156b4a8789e90775$var$spanAllZeroes;
/**
 * @returns {String} the string with each character contained in a <span>
 */ function $156b4a8789e90775$var$spanAll(s, offset = 0) {
    const letters = s.split("");
    return letters.map((n, i)=>(0, $krCXC.sprintf)('<span class="digit value-%s position-%d">%s</span>', n, i + offset, $156b4a8789e90775$var$spanAllZeroes(n)) // XXX Use #base-2 .value-0 instead?
    ).join("");
}
module.exports.spanAll = $156b4a8789e90775$var$spanAll;
function $156b4a8789e90775$var$spanLeadingZeroesSimple(group) {
    return group.replace(/^(0+)/, '<span class="zero">$1</span>');
}
/**
 * @returns {String} the string with leading zeroes contained in a <span>
 */ function $156b4a8789e90775$var$spanLeadingZeroes(address) {
    const groups = address.split(":");
    return groups.map((g)=>$156b4a8789e90775$var$spanLeadingZeroesSimple(g)).join(":");
}
module.exports.spanLeadingZeroes = $156b4a8789e90775$var$spanLeadingZeroes;
/**
 * Groups an address
 * @returns {String} a grouped address
 */ function $156b4a8789e90775$var$simpleGroup(addressString, offset = 0) {
    const groups = addressString.split(":");
    return groups.map((g, i)=>{
        if (/group-v4/.test(g)) return g;
        return (0, $krCXC.sprintf)('<span class="hover-group group-%d">%s</span>', i + offset, $156b4a8789e90775$var$spanLeadingZeroesSimple(g));
    });
}
module.exports.simpleGroup = $156b4a8789e90775$var$simpleGroup;

});
parcelRegister("krCXC", function(module, exports) {

$parcel$export(module.exports, "sprintf", function () { return $ee248d0b2aaa6262$export$63151d8bb18a49f9; }, function (v) { return $ee248d0b2aaa6262$export$63151d8bb18a49f9 = v; });
/* global window, exports, define */ var $ee248d0b2aaa6262$export$63151d8bb18a49f9;
var $ee248d0b2aaa6262$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $ee248d0b2aaa6262$export$63151d8bb18a49f9 = sprintf;
    $ee248d0b2aaa6262$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

});


parcelRegister("1nZXs", function(module, exports) {
(function() {
    var expandIPv6, ipaddr, ipv4Part, ipv4Regexes, ipv6Part, ipv6Regexes, matchCIDR, root, zoneIndex;
    ipaddr = {};
    root = this;
    if (module !== null && module.exports) module.exports = ipaddr;
    else root["ipaddr"] = ipaddr;
    matchCIDR = function(first, second, partSize, cidrBits) {
        var part, shift;
        if (first.length !== second.length) throw new Error("ipaddr: cannot match CIDR for objects with different lengths");
        part = 0;
        while(cidrBits > 0){
            shift = partSize - cidrBits;
            if (shift < 0) shift = 0;
            if (first[part] >> shift !== second[part] >> shift) return false;
            cidrBits -= partSize;
            part += 1;
        }
        return true;
    };
    ipaddr.subnetMatch = function(address, rangeList, defaultName) {
        var k, len, rangeName, rangeSubnets, subnet;
        if (defaultName == null) defaultName = "unicast";
        for(rangeName in rangeList){
            rangeSubnets = rangeList[rangeName];
            if (rangeSubnets[0] && !(rangeSubnets[0] instanceof Array)) rangeSubnets = [
                rangeSubnets
            ];
            for(k = 0, len = rangeSubnets.length; k < len; k++){
                subnet = rangeSubnets[k];
                if (address.kind() === subnet[0].kind()) {
                    if (address.match.apply(address, subnet)) return rangeName;
                }
            }
        }
        return defaultName;
    };
    ipaddr.IPv4 = function() {
        function IPv4(octets) {
            var k, len, octet;
            if (octets.length !== 4) throw new Error("ipaddr: ipv4 octet count should be 4");
            for(k = 0, len = octets.length; k < len; k++){
                octet = octets[k];
                if (!(0 <= octet && octet <= 255)) throw new Error("ipaddr: ipv4 octet should fit in 8 bits");
            }
            this.octets = octets;
        }
        IPv4.prototype.kind = function() {
            return "ipv4";
        };
        IPv4.prototype.toString = function() {
            return this.octets.join(".");
        };
        IPv4.prototype.toNormalizedString = function() {
            return this.toString();
        };
        IPv4.prototype.toByteArray = function() {
            return this.octets.slice(0);
        };
        IPv4.prototype.match = function(other, cidrRange) {
            var ref;
            if (cidrRange === void 0) ref = other, other = ref[0], cidrRange = ref[1];
            if (other.kind() !== "ipv4") throw new Error("ipaddr: cannot match ipv4 address with non-ipv4 one");
            return matchCIDR(this.octets, other.octets, 8, cidrRange);
        };
        IPv4.prototype.SpecialRanges = {
            unspecified: [
                [
                    new IPv4([
                        0,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            broadcast: [
                [
                    new IPv4([
                        255,
                        255,
                        255,
                        255
                    ]),
                    32
                ]
            ],
            multicast: [
                [
                    new IPv4([
                        224,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ],
            linkLocal: [
                [
                    new IPv4([
                        169,
                        254,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            loopback: [
                [
                    new IPv4([
                        127,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            carrierGradeNat: [
                [
                    new IPv4([
                        100,
                        64,
                        0,
                        0
                    ]),
                    10
                ]
            ],
            "private": [
                [
                    new IPv4([
                        10,
                        0,
                        0,
                        0
                    ]),
                    8
                ],
                [
                    new IPv4([
                        172,
                        16,
                        0,
                        0
                    ]),
                    12
                ],
                [
                    new IPv4([
                        192,
                        168,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            reserved: [
                [
                    new IPv4([
                        192,
                        0,
                        0,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        0,
                        2,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        88,
                        99,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        198,
                        51,
                        100,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        203,
                        0,
                        113,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        240,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ]
        };
        IPv4.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        IPv4.prototype.toIPv4MappedAddress = function() {
            return ipaddr.IPv6.parse("::ffff:" + this.toString());
        };
        IPv4.prototype.prefixLengthFromSubnetMask = function() {
            var cidr, i, k, octet, stop, zeros, zerotable;
            zerotable = {
                0: 8,
                128: 7,
                192: 6,
                224: 5,
                240: 4,
                248: 3,
                252: 2,
                254: 1,
                255: 0
            };
            cidr = 0;
            stop = false;
            for(i = k = 3; k >= 0; i = k += -1){
                octet = this.octets[i];
                if (octet in zerotable) {
                    zeros = zerotable[octet];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 8) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 32 - cidr;
        };
        return IPv4;
    }();
    ipv4Part = "(0?\\d+|0x[a-f0-9]+)";
    ipv4Regexes = {
        fourOctet: new RegExp("^" + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "$", "i"),
        longValue: new RegExp("^" + ipv4Part + "$", "i")
    };
    ipaddr.IPv4.parser = function(string) {
        var match, parseIntAuto, part, shift, value;
        parseIntAuto = function(string) {
            if (string[0] === "0" && string[1] !== "x") return parseInt(string, 8);
            else return parseInt(string);
        };
        if (match = string.match(ipv4Regexes.fourOctet)) return function() {
            var k, len, ref, results;
            ref = match.slice(1, 6);
            results = [];
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                results.push(parseIntAuto(part));
            }
            return results;
        }();
        else if (match = string.match(ipv4Regexes.longValue)) {
            value = parseIntAuto(match[1]);
            if (value > 0xffffffff || value < 0) throw new Error("ipaddr: address outside defined range");
            return (function() {
                var k, results;
                results = [];
                for(shift = k = 0; k <= 24; shift = k += 8)results.push(value >> shift & 0xff);
                return results;
            })().reverse();
        } else return null;
    };
    ipaddr.IPv6 = function() {
        function IPv6(parts, zoneId) {
            var i, k, l, len, part, ref;
            if (parts.length === 16) {
                this.parts = [];
                for(i = k = 0; k <= 14; i = k += 2)this.parts.push(parts[i] << 8 | parts[i + 1]);
            } else if (parts.length === 8) this.parts = parts;
            else throw new Error("ipaddr: ipv6 part count should be 8 or 16");
            ref = this.parts;
            for(l = 0, len = ref.length; l < len; l++){
                part = ref[l];
                if (!(0 <= part && part <= 0xffff)) throw new Error("ipaddr: ipv6 part should fit in 16 bits");
            }
            if (zoneId) this.zoneId = zoneId;
        }
        IPv6.prototype.kind = function() {
            return "ipv6";
        };
        IPv6.prototype.toString = function() {
            return this.toNormalizedString().replace(/((^|:)(0(:|$))+)/, "::");
        };
        IPv6.prototype.toRFC5952String = function() {
            var bestMatchIndex, bestMatchLength, match, regex, string;
            regex = /((^|:)(0(:|$)){2,})/g;
            string = this.toNormalizedString();
            bestMatchIndex = 0;
            bestMatchLength = -1;
            while(match = regex.exec(string))if (match[0].length > bestMatchLength) {
                bestMatchIndex = match.index;
                bestMatchLength = match[0].length;
            }
            if (bestMatchLength < 0) return string;
            return string.substring(0, bestMatchIndex) + "::" + string.substring(bestMatchIndex + bestMatchLength);
        };
        IPv6.prototype.toByteArray = function() {
            var bytes, k, len, part, ref;
            bytes = [];
            ref = this.parts;
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                bytes.push(part >> 8);
                bytes.push(part & 0xff);
            }
            return bytes;
        };
        IPv6.prototype.toNormalizedString = function() {
            var addr, part, suffix;
            addr = (function() {
                var k, len, ref, results;
                ref = this.parts;
                results = [];
                for(k = 0, len = ref.length; k < len; k++){
                    part = ref[k];
                    results.push(part.toString(16));
                }
                return results;
            }).call(this).join(":");
            suffix = "";
            if (this.zoneId) suffix = "%" + this.zoneId;
            return addr + suffix;
        };
        IPv6.prototype.toFixedLengthString = function() {
            var addr, part, suffix;
            addr = (function() {
                var k, len, ref, results;
                ref = this.parts;
                results = [];
                for(k = 0, len = ref.length; k < len; k++){
                    part = ref[k];
                    results.push(part.toString(16).padStart(4, "0"));
                }
                return results;
            }).call(this).join(":");
            suffix = "";
            if (this.zoneId) suffix = "%" + this.zoneId;
            return addr + suffix;
        };
        IPv6.prototype.match = function(other, cidrRange) {
            var ref;
            if (cidrRange === void 0) ref = other, other = ref[0], cidrRange = ref[1];
            if (other.kind() !== "ipv6") throw new Error("ipaddr: cannot match ipv6 address with non-ipv6 one");
            return matchCIDR(this.parts, other.parts, 16, cidrRange);
        };
        IPv6.prototype.SpecialRanges = {
            unspecified: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                128
            ],
            linkLocal: [
                new IPv6([
                    0xfe80,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                10
            ],
            multicast: [
                new IPv6([
                    0xff00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                8
            ],
            loopback: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ]),
                128
            ],
            uniqueLocal: [
                new IPv6([
                    0xfc00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                7
            ],
            ipv4Mapped: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0
                ]),
                96
            ],
            rfc6145: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0,
                    0
                ]),
                96
            ],
            rfc6052: [
                new IPv6([
                    0x64,
                    0xff9b,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                96
            ],
            "6to4": [
                new IPv6([
                    0x2002,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                16
            ],
            teredo: [
                new IPv6([
                    0x2001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                32
            ],
            reserved: [
                [
                    new IPv6([
                        0x2001,
                        0xdb8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    32
                ]
            ]
        };
        IPv6.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        IPv6.prototype.isIPv4MappedAddress = function() {
            return this.range() === "ipv4Mapped";
        };
        IPv6.prototype.toIPv4Address = function() {
            var high, low, ref;
            if (!this.isIPv4MappedAddress()) throw new Error("ipaddr: trying to convert a generic ipv6 address to ipv4");
            ref = this.parts.slice(-2), high = ref[0], low = ref[1];
            return new ipaddr.IPv4([
                high >> 8,
                high & 0xff,
                low >> 8,
                low & 0xff
            ]);
        };
        IPv6.prototype.prefixLengthFromSubnetMask = function() {
            var cidr, i, k, part, stop, zeros, zerotable;
            zerotable = {
                0: 16,
                32768: 15,
                49152: 14,
                57344: 13,
                61440: 12,
                63488: 11,
                64512: 10,
                65024: 9,
                65280: 8,
                65408: 7,
                65472: 6,
                65504: 5,
                65520: 4,
                65528: 3,
                65532: 2,
                65534: 1,
                65535: 0
            };
            cidr = 0;
            stop = false;
            for(i = k = 7; k >= 0; i = k += -1){
                part = this.parts[i];
                if (part in zerotable) {
                    zeros = zerotable[part];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 16) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 128 - cidr;
        };
        return IPv6;
    }();
    ipv6Part = "(?:[0-9a-f]+::?)+";
    zoneIndex = "%[0-9a-z]{1,}";
    ipv6Regexes = {
        zoneIndex: new RegExp(zoneIndex, "i"),
        "native": new RegExp("^(::)?(" + ipv6Part + ")?([0-9a-f]+)?(::)?(" + zoneIndex + ")?$", "i"),
        transitional: new RegExp("^((?:" + ipv6Part + ")|(?:::)(?:" + ipv6Part + ")?)" + (ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part) + ("(" + zoneIndex + ")?$"), "i")
    };
    expandIPv6 = function(string, parts) {
        var colonCount, lastColon, part, replacement, replacementCount, zoneId;
        if (string.indexOf("::") !== string.lastIndexOf("::")) return null;
        zoneId = (string.match(ipv6Regexes["zoneIndex"]) || [])[0];
        if (zoneId) {
            zoneId = zoneId.substring(1);
            string = string.replace(/%.+$/, "");
        }
        colonCount = 0;
        lastColon = -1;
        while((lastColon = string.indexOf(":", lastColon + 1)) >= 0)colonCount++;
        if (string.substr(0, 2) === "::") colonCount--;
        if (string.substr(-2, 2) === "::") colonCount--;
        if (colonCount > parts) return null;
        replacementCount = parts - colonCount;
        replacement = ":";
        while(replacementCount--)replacement += "0:";
        string = string.replace("::", replacement);
        if (string[0] === ":") string = string.slice(1);
        if (string[string.length - 1] === ":") string = string.slice(0, -1);
        parts = function() {
            var k, len, ref, results;
            ref = string.split(":");
            results = [];
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                results.push(parseInt(part, 16));
            }
            return results;
        }();
        return {
            parts: parts,
            zoneId: zoneId
        };
    };
    ipaddr.IPv6.parser = function(string) {
        var addr, k, len, match, octet, octets, zoneId;
        if (ipv6Regexes["native"].test(string)) return expandIPv6(string, 8);
        else if (match = string.match(ipv6Regexes["transitional"])) {
            zoneId = match[6] || "";
            addr = expandIPv6(match[1].slice(0, -1) + zoneId, 6);
            if (addr.parts) {
                octets = [
                    parseInt(match[2]),
                    parseInt(match[3]),
                    parseInt(match[4]),
                    parseInt(match[5])
                ];
                for(k = 0, len = octets.length; k < len; k++){
                    octet = octets[k];
                    if (!(0 <= octet && octet <= 255)) return null;
                }
                addr.parts.push(octets[0] << 8 | octets[1]);
                addr.parts.push(octets[2] << 8 | octets[3]);
                return {
                    parts: addr.parts,
                    zoneId: addr.zoneId
                };
            }
        }
        return null;
    };
    ipaddr.IPv4.isIPv4 = ipaddr.IPv6.isIPv6 = function(string) {
        return this.parser(string) !== null;
    };
    ipaddr.IPv4.isValid = function(string) {
        var e;
        try {
            new this(this.parser(string));
            return true;
        } catch (error1) {
            e = error1;
            return false;
        }
    };
    ipaddr.IPv4.isValidFourPartDecimal = function(string) {
        if (ipaddr.IPv4.isValid(string) && string.match(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){3}$/)) return true;
        else return false;
    };
    ipaddr.IPv6.isValid = function(string) {
        var addr, e;
        if (typeof string === "string" && string.indexOf(":") === -1) return false;
        try {
            addr = this.parser(string);
            new this(addr.parts, addr.zoneId);
            return true;
        } catch (error1) {
            e = error1;
            return false;
        }
    };
    ipaddr.IPv4.parse = function(string) {
        var parts;
        parts = this.parser(string);
        if (parts === null) throw new Error("ipaddr: string is not formatted like ip address");
        return new this(parts);
    };
    ipaddr.IPv6.parse = function(string) {
        var addr;
        addr = this.parser(string);
        if (addr.parts === null) throw new Error("ipaddr: string is not formatted like ip address");
        return new this(addr.parts, addr.zoneId);
    };
    ipaddr.IPv4.parseCIDR = function(string) {
        var maskLength, match, parsed;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 32) {
                parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv4 CIDR range");
    };
    ipaddr.IPv4.subnetMaskFromPrefixLength = function(prefix) {
        var filledOctetCount, j, octets;
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 32) throw new Error("ipaddr: invalid IPv4 prefix length");
        octets = [
            0,
            0,
            0,
            0
        ];
        j = 0;
        filledOctetCount = Math.floor(prefix / 8);
        while(j < filledOctetCount){
            octets[j] = 255;
            j++;
        }
        if (filledOctetCount < 4) octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - prefix % 8;
        return new this(octets);
    };
    ipaddr.IPv4.broadcastAddressFromCIDR = function(string) {
        var cidr, error, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 4){
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }
            return new this(octets);
        } catch (error1) {
            error = error1;
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    ipaddr.IPv4.networkAddressFromCIDR = function(string) {
        var cidr, error, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 4){
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }
            return new this(octets);
        } catch (error1) {
            error = error1;
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    ipaddr.IPv6.parseCIDR = function(string) {
        var maskLength, match, parsed;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 128) {
                parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv6 CIDR range");
    };
    ipaddr.isValid = function(string) {
        return ipaddr.IPv6.isValid(string) || ipaddr.IPv4.isValid(string);
    };
    ipaddr.parse = function(string) {
        if (ipaddr.IPv6.isValid(string)) return ipaddr.IPv6.parse(string);
        else if (ipaddr.IPv4.isValid(string)) return ipaddr.IPv4.parse(string);
        else throw new Error("ipaddr: the address has neither IPv6 nor IPv4 format");
    };
    ipaddr.parseCIDR = function(string) {
        var e;
        try {
            return ipaddr.IPv6.parseCIDR(string);
        } catch (error1) {
            e = error1;
            try {
                return ipaddr.IPv4.parseCIDR(string);
            } catch (error1) {
                e = error1;
                throw new Error("ipaddr: the address has neither IPv6 nor IPv4 CIDR format");
            }
        }
    };
    ipaddr.fromByteArray = function(bytes) {
        var length;
        length = bytes.length;
        if (length === 4) return new ipaddr.IPv4(bytes);
        else if (length === 16) return new ipaddr.IPv6(bytes);
        else throw new Error("ipaddr: the binary input is neither an IPv6 nor IPv4 address");
    };
    ipaddr.process = function(string) {
        var addr;
        addr = this.parse(string);
        if (addr.kind() === "ipv6" && addr.isIPv4MappedAddress()) return addr.toIPv4Address();
        else return addr;
    };
}).call(this);

});

parcelRegister("9KvBE", function(module, exports) {

$parcel$export(module.exports, "encodePayload", function () { return $7190ed43dfcac9b8$export$144d64fe58dad441; });
$parcel$export(module.exports, "decodePayload", function () { return $7190ed43dfcac9b8$export$d10cc2e7f7566a2d; });
$parcel$export(module.exports, "createPacketEncoderStream", function () { return $7190ed43dfcac9b8$export$a525fb718e9c623a; });
$parcel$export(module.exports, "createPacketDecoderStream", function () { return $7190ed43dfcac9b8$export$552d20aac7500f47; });
$parcel$export(module.exports, "protocol", function () { return $7190ed43dfcac9b8$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "encodePacket", function () { return (parcelRequire("eB3mK")).encodePacket; });
$parcel$export(module.exports, "decodePacket", function () { return (parcelRequire("35Pvm")).decodePacket; });

var $eB3mK = parcelRequire("eB3mK");

var $35Pvm = parcelRequire("35Pvm");

var $5uu6L = parcelRequire("5uu6L");
const $7190ed43dfcac9b8$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $7190ed43dfcac9b8$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $eB3mK.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($7190ed43dfcac9b8$var$SEPARATOR));
        });
    });
};
const $7190ed43dfcac9b8$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($7190ed43dfcac9b8$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $35Pvm.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $7190ed43dfcac9b8$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $eB3mK.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $7190ed43dfcac9b8$var$TEXT_DECODER;
function $7190ed43dfcac9b8$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $7190ed43dfcac9b8$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $7190ed43dfcac9b8$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$7190ed43dfcac9b8$var$TEXT_DECODER) $7190ed43dfcac9b8$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 1) break;
                    const header = $7190ed43dfcac9b8$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 2) break;
                    const headerArray = $7190ed43dfcac9b8$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 8) break;
                    const headerArray = $7190ed43dfcac9b8$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $5uu6L.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < expectedLength) break;
                    const data = $7190ed43dfcac9b8$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $35Pvm.decodePacket)(isBinary ? data : $7190ed43dfcac9b8$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $5uu6L.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $7190ed43dfcac9b8$export$a51d6b395ff4c65a = 4;

});
parcelRegister("eB3mK", function(module, exports) {

$parcel$export(module.exports, "encodePacket", function () { return $aa0721c76827b58b$export$57852049361a8e62; });
$parcel$export(module.exports, "encodePacketToBinary", function () { return $aa0721c76827b58b$export$ec0c9b9013ee0ef5; });

var $5uu6L = parcelRequire("5uu6L");
const $aa0721c76827b58b$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $aa0721c76827b58b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $aa0721c76827b58b$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $aa0721c76827b58b$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($aa0721c76827b58b$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $aa0721c76827b58b$var$encodeBlobAsBase64(data, callback);
    } else if ($aa0721c76827b58b$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $aa0721c76827b58b$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $aa0721c76827b58b$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $5uu6L.PACKET_TYPES)[type] + (data || ""));
};
const $aa0721c76827b58b$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $aa0721c76827b58b$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $aa0721c76827b58b$var$TEXT_ENCODER;
function $aa0721c76827b58b$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($aa0721c76827b58b$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($aa0721c76827b58b$var$toArray).then(callback);
    else if ($aa0721c76827b58b$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $aa0721c76827b58b$var$isView(packet.data))) return callback($aa0721c76827b58b$var$toArray(packet.data));
    $aa0721c76827b58b$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$aa0721c76827b58b$var$TEXT_ENCODER) $aa0721c76827b58b$var$TEXT_ENCODER = new TextEncoder();
        callback($aa0721c76827b58b$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("5uu6L", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", function () { return $3ff71bed8ee045e7$export$c169aefb7330cccb; });
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", function () { return $3ff71bed8ee045e7$export$47791e8004edd485; });
$parcel$export(module.exports, "ERROR_PACKET", function () { return $3ff71bed8ee045e7$export$c718b5840781f8a7; });
const $3ff71bed8ee045e7$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$3ff71bed8ee045e7$export$c169aefb7330cccb["open"] = "0";
$3ff71bed8ee045e7$export$c169aefb7330cccb["close"] = "1";
$3ff71bed8ee045e7$export$c169aefb7330cccb["ping"] = "2";
$3ff71bed8ee045e7$export$c169aefb7330cccb["pong"] = "3";
$3ff71bed8ee045e7$export$c169aefb7330cccb["message"] = "4";
$3ff71bed8ee045e7$export$c169aefb7330cccb["upgrade"] = "5";
$3ff71bed8ee045e7$export$c169aefb7330cccb["noop"] = "6";
const $3ff71bed8ee045e7$export$47791e8004edd485 = Object.create(null);
Object.keys($3ff71bed8ee045e7$export$c169aefb7330cccb).forEach((key)=>{
    $3ff71bed8ee045e7$export$47791e8004edd485[$3ff71bed8ee045e7$export$c169aefb7330cccb[key]] = key;
});
const $3ff71bed8ee045e7$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("35Pvm", function(module, exports) {

$parcel$export(module.exports, "decodePacket", function () { return $2409ca8159bcb19c$export$4647901878f33f31; });

var $5uu6L = parcelRequire("5uu6L");

var $4efFz = parcelRequire("4efFz");
const $2409ca8159bcb19c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $2409ca8159bcb19c$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $2409ca8159bcb19c$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $2409ca8159bcb19c$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $5uu6L.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $5uu6L.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $5uu6L.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $5uu6L.PACKET_TYPES_REVERSE)[type]
    };
};
const $2409ca8159bcb19c$var$decodeBase64Packet = (data, binaryType)=>{
    if ($2409ca8159bcb19c$var$withNativeArrayBuffer) {
        const decoded = (0, $4efFz.decode)(data);
        return $2409ca8159bcb19c$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $2409ca8159bcb19c$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("4efFz", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $31449fde0ba50558$export$2f872c0f2117be69; });
// imported from https://github.com/socketio/base64-arraybuffer
const $31449fde0ba50558$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $31449fde0ba50558$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $31449fde0ba50558$var$chars.length; i++)$31449fde0ba50558$var$lookup[$31449fde0ba50558$var$chars.charCodeAt(i)] = i;
const $31449fde0ba50558$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $31449fde0ba50558$var$chars[bytes[i] >> 2];
        base64 += $31449fde0ba50558$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $31449fde0ba50558$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $31449fde0ba50558$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $31449fde0ba50558$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i)];
        encoded2 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("fbuXh", function(module, exports) {

$parcel$export(module.exports, "Emitter", function () { return $b0dfe52829d5f01f$export$4293555f241ae35a; });
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $b0dfe52829d5f01f$export$4293555f241ae35a(obj) {
    if (obj) return $b0dfe52829d5f01f$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $b0dfe52829d5f01f$var$mixin(obj) {
    for(var key in $b0dfe52829d5f01f$export$4293555f241ae35a.prototype)obj[key] = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.on = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.off = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeListener = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeAllListeners = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emitReserved = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("7zQLO", function(module, exports) {

$parcel$export(module.exports, "protocol", function () { return $5844bc5b363a789e$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "PacketType", function () { return $5844bc5b363a789e$export$84d4095e16c6fc19; });
$parcel$export(module.exports, "Encoder", function () { return $5844bc5b363a789e$export$a50aceb0e02a00aa; });
$parcel$export(module.exports, "Decoder", function () { return $5844bc5b363a789e$export$f9de6ca0bc043724; });

var $fbuXh = parcelRequire("fbuXh");

var $f2OZx = parcelRequire("f2OZx");

var $3g4Gz = parcelRequire("3g4Gz");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $5844bc5b363a789e$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $5844bc5b363a789e$export$a51d6b395ff4c65a = 5;
var $5844bc5b363a789e$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($5844bc5b363a789e$export$84d4095e16c6fc19 || ($5844bc5b363a789e$export$84d4095e16c6fc19 = {}));
class $5844bc5b363a789e$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT || obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.ACK) {
            if ((0, $3g4Gz.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT ? $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT : $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $f2OZx.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $5844bc5b363a789e$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $5844bc5b363a789e$export$f9de6ca0bc043724 extends (0, $fbuXh.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT : $5844bc5b363a789e$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $5844bc5b363a789e$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $3g4Gz.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($5844bc5b363a789e$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($5844bc5b363a789e$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $5844bc5b363a789e$export$84d4095e16c6fc19.CONNECT:
                return $5844bc5b363a789e$var$isObject(payload);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $5844bc5b363a789e$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $5844bc5b363a789e$var$isObject(payload);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT:
            case $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $5844bc5b363a789e$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.ACK:
            case $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $5844bc5b363a789e$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $f2OZx.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}

});
parcelRegister("f2OZx", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", function () { return $af3e98c77f2a1d1e$export$ac2edb9eb7af56f6; });
$parcel$export(module.exports, "reconstructPacket", function () { return $af3e98c77f2a1d1e$export$a00da3b1ec037a04; });

var $3g4Gz = parcelRequire("3g4Gz");
function $af3e98c77f2a1d1e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $af3e98c77f2a1d1e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $af3e98c77f2a1d1e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $3g4Gz.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $af3e98c77f2a1d1e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $af3e98c77f2a1d1e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $af3e98c77f2a1d1e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $af3e98c77f2a1d1e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $af3e98c77f2a1d1e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $af3e98c77f2a1d1e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $af3e98c77f2a1d1e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("3g4Gz", function(module, exports) {

$parcel$export(module.exports, "isBinary", function () { return $25f6802f9284f641$export$37488ff1135b1696; });
$parcel$export(module.exports, "hasBinary", function () { return $25f6802f9284f641$export$5234c529abdb5610; });
const $25f6802f9284f641$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $25f6802f9284f641$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $25f6802f9284f641$var$toString = Object.prototype.toString;
const $25f6802f9284f641$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $25f6802f9284f641$var$toString.call(Blob) === "[object BlobConstructor]";
const $25f6802f9284f641$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $25f6802f9284f641$var$toString.call(File) === "[object FileConstructor]";
function $25f6802f9284f641$export$37488ff1135b1696(obj) {
    return $25f6802f9284f641$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $25f6802f9284f641$var$isView(obj)) || $25f6802f9284f641$var$withNativeBlob && obj instanceof Blob || $25f6802f9284f641$var$withNativeFile && obj instanceof File;
}
function $25f6802f9284f641$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($25f6802f9284f641$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($25f6802f9284f641$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $25f6802f9284f641$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $25f6802f9284f641$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("frncS", function(module, exports) {
function $b3db60feabacccd5$var$_extends() {
    return module.exports = $b3db60feabacccd5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b3db60feabacccd5$var$_extends.apply(null, arguments);
}
module.exports = $b3db60feabacccd5$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("37KYO", function(module, exports) {
function $246677c56c45e428$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $246677c56c45e428$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cgitS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ed55096fbb69da0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $8ed55096fbb69da0$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8kMfp")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("aNuUP")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("aNuUP")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("aSyh5")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("jDDa9")).default; });
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $9Gy1A = parcelRequire("9Gy1A");

var $aNuUP = parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");

var $aSyh5 = parcelRequire("aSyh5");

var $jDDa9 = parcelRequire("jDDa9");
"use client";
function $8ed55096fbb69da0$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $9Gy1A.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $8ed55096fbb69da0$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("9Gy1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d26de1666ea60b$export$2e2bcd8739ae039; });

var $fTKeB = parcelRequire("fTKeB");
parcelRequire("65o8X");
parcelRequire("eZVvM");
parcelRequire("hMzFq");

parcelRequire("geJaG");
parcelRequire("2mRmw");
parcelRequire("8JgfY");
var $70d26de1666ea60b$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $70d26de1666ea60b$export$2e2bcd8739ae039 = (0, $fTKeB.default).bind();
$70d26de1666ea60b$var$tags.forEach(function(tagName) {
    $70d26de1666ea60b$export$2e2bcd8739ae039[tagName] = $70d26de1666ea60b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("fTKeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92fdb4d9636797d$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $hMzFq = parcelRequire("hMzFq");
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");

var $geJaG = parcelRequire("geJaG");

var $2mRmw = parcelRequire("2mRmw");

var $8JgfY = parcelRequire("8JgfY");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $b92fdb4d9636797d$var$testOmitPropsOnStringTag = (0, $hMzFq.default);
var $b92fdb4d9636797d$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $b92fdb4d9636797d$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $b92fdb4d9636797d$var$testOmitPropsOnStringTag : $b92fdb4d9636797d$var$testOmitPropsOnComponent;
};
var $b92fdb4d9636797d$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $b92fdb4d9636797d$var$isDevelopment = false;
var $b92fdb4d9636797d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $geJaG.registerStyles)(cache, serialized, isStringTag);
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $geJaG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $b92fdb4d9636797d$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $b92fdb4d9636797d$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $b92fdb4d9636797d$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $8kMfp.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $eZVvM.useContext((0, $8kMfp.T));
            }
            if (typeof props.className === "string") className = (0, $geJaG.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2mRmw.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $b92fdb4d9636797d$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($b92fdb4d9636797d$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $eZVvM.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $b92fdb4d9636797d$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $65o8X.default)({}, options, nextOptions, {
                shouldForwardProp: $b92fdb4d9636797d$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("hMzFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf22961bb12ad7a3$export$2e2bcd8739ae039; });

var $4vbT5 = parcelRequire("4vbT5");
// eslint-disable-next-line no-undef
var $cf22961bb12ad7a3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $cf22961bb12ad7a3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4vbT5.default)(function(prop) {
    return $cf22961bb12ad7a3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("aNuUP", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $7dc6762720818f23$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $7dc6762720818f23$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $7dc6762720818f23$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $7dc6762720818f23$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8kMfp")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("8kMfp")).w; });

var $8kMfp = parcelRequire("8kMfp");

var $eZVvM = parcelRequire("eZVvM");

var $geJaG = parcelRequire("geJaG");

var $8JgfY = parcelRequire("8JgfY");

var $2mRmw = parcelRequire("2mRmw");
parcelRequire("hUOrI");
parcelRequire("65o8X");
parcelRequire("c2U8l");

parcelRequire("28Dco");
var $7dc6762720818f23$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8kMfp.h).call(props, "css")) return $eZVvM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8kMfp.E);
    createElementArgArray[1] = (0, $8kMfp.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $eZVvM.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7dc6762720818f23$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8kMfp.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2mRmw.serializeStyles)([
        styles
    ], undefined, $eZVvM.useContext((0, $8kMfp.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eZVvM.useRef();
    (0, $8JgfY.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $8JgfY.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $geJaG.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $7dc6762720818f23$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2mRmw.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $7dc6762720818f23$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $7dc6762720818f23$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $7dc6762720818f23$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7dc6762720818f23$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $geJaG.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7dc6762720818f23$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $geJaG.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $7dc6762720818f23$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8kMfp.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $8kMfp.i)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2mRmw.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $geJaG.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $8kMfp.i)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7dc6762720818f23$var$merge(cache.registered, css, $7dc6762720818f23$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eZVvM.useContext((0, $8kMfp.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($7dc6762720818f23$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});



parcelRegister("aSyh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb988c305824bed$export$2e2bcd8739ae039; });
parcelRequire("eZVvM");


var $8kMfp = parcelRequire("8kMfp");

var $hUOrI = parcelRequire("hUOrI");

var $3pI8R = parcelRequire("3pI8R");
"use client";
let $7eb988c305824bed$var$cache;
if (typeof document === "object") $7eb988c305824bed$var$cache = (0, $hUOrI.default)({
    key: "css",
    prepend: true
});
function $7eb988c305824bed$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $7eb988c305824bed$var$cache ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8kMfp.C), {
        value: $7eb988c305824bed$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("jDDa9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c009b989499b2e$export$2e2bcd8739ae039; });
parcelRequire("eZVvM");


var $aNuUP = parcelRequire("aNuUP");

var $3pI8R = parcelRequire("3pI8R");
"use client";
function $e4c009b989499b2e$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $e4c009b989499b2e$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($e4c009b989499b2e$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $aNuUP.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("booPO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hojpr")).default; });

var $hojpr = parcelRequire("hojpr");

});
parcelRegister("hojpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca93bbd8bf8829f1$export$2e2bcd8739ae039; });

var $9u6aw = parcelRequire("9u6aw");
function $ca93bbd8bf8829f1$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $9u6aw.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("9u6aw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7bb36299a100a0$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $6e7bb36299a100a0$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("iH2bF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hYwJR")).default; });

var $hYwJR = parcelRequire("hYwJR");
$parcel$exportWildcard(module.exports, $hYwJR);

});
parcelRegister("hYwJR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $d1616f7ca43a9fa0$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $d1616f7ca43a9fa0$export$2e2bcd8739ae039; });

var $2ZVAX = parcelRequire("2ZVAX");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $d1616f7ca43a9fa0$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $d1616f7ca43a9fa0$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($d1616f7ca43a9fa0$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $d1616f7ca43a9fa0$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $d1616f7ca43a9fa0$export$aad197c7121a6651(Component) || fallback;
}
function $d1616f7ca43a9fa0$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $d1616f7ca43a9fa0$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $d1616f7ca43a9fa0$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $d1616f7ca43a9fa0$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $2ZVAX.ForwardRef:
            return $d1616f7ca43a9fa0$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $2ZVAX.Memo:
            return $d1616f7ca43a9fa0$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("2ZVAX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9HOh3"));

});
parcelRegister("9HOh3", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $710f209320be5e38$export$a7c73072b1a182ae; }, function (v) { return $710f209320be5e38$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $710f209320be5e38$export$9f27bc3417b4524d; }, function (v) { return $710f209320be5e38$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $710f209320be5e38$export$db77ccec0bb4ccac; }, function (v) { return $710f209320be5e38$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $710f209320be5e38$export$8392c0c9d3dcbd35; }, function (v) { return $710f209320be5e38$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $710f209320be5e38$export$ffb0004e005737fa; }, function (v) { return $710f209320be5e38$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $710f209320be5e38$export$b624eff549462981; }, function (v) { return $710f209320be5e38$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $710f209320be5e38$export$7897aa7841a5380c; }, function (v) { return $710f209320be5e38$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $710f209320be5e38$export$602eac185826482c; }, function (v) { return $710f209320be5e38$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $710f209320be5e38$export$e2c29f18771995cb; }, function (v) { return $710f209320be5e38$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $710f209320be5e38$export$5f8d39834fd61797; }, function (v) { return $710f209320be5e38$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $710f209320be5e38$export$74bf444e3cd11ea5; }, function (v) { return $710f209320be5e38$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $710f209320be5e38$export$998bcd577473dd93; }, function (v) { return $710f209320be5e38$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $710f209320be5e38$export$92387174baf9b227; }, function (v) { return $710f209320be5e38$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $710f209320be5e38$export$ec112efeb987d9c6; }, function (v) { return $710f209320be5e38$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $710f209320be5e38$export$b706b080d889d2c9; }, function (v) { return $710f209320be5e38$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $710f209320be5e38$export$5be5a87408f70ddc; }, function (v) { return $710f209320be5e38$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $710f209320be5e38$export$45a5e7f76e0caa8d; }, function (v) { return $710f209320be5e38$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $710f209320be5e38$export$455c2e768291efa6; }, function (v) { return $710f209320be5e38$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $710f209320be5e38$export$9522e17588c12572; }, function (v) { return $710f209320be5e38$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $710f209320be5e38$export$2110ac352bb060b9; }, function (v) { return $710f209320be5e38$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $710f209320be5e38$export$56885ab8b9c456ab; }, function (v) { return $710f209320be5e38$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $710f209320be5e38$export$d927fcb6adf8f9de; }, function (v) { return $710f209320be5e38$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $710f209320be5e38$export$b82d16f27459e05a; }, function (v) { return $710f209320be5e38$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $710f209320be5e38$export$522c17b4f5e123e8; }, function (v) { return $710f209320be5e38$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $710f209320be5e38$export$1aabd8a0274ecfd6; }, function (v) { return $710f209320be5e38$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $710f209320be5e38$export$3d6c20d97e46b957; }, function (v) { return $710f209320be5e38$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $710f209320be5e38$export$9b621391a187a31a; }, function (v) { return $710f209320be5e38$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $710f209320be5e38$export$f5bbd400c2f4426f; }, function (v) { return $710f209320be5e38$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $710f209320be5e38$export$a7c73072b1a182ae;
var $710f209320be5e38$export$9f27bc3417b4524d;
var $710f209320be5e38$export$db77ccec0bb4ccac;
var $710f209320be5e38$export$8392c0c9d3dcbd35;
var $710f209320be5e38$export$ffb0004e005737fa;
var $710f209320be5e38$export$b624eff549462981;
var $710f209320be5e38$export$7897aa7841a5380c;
var $710f209320be5e38$export$602eac185826482c;
var $710f209320be5e38$export$e2c29f18771995cb;
var $710f209320be5e38$export$5f8d39834fd61797;
var $710f209320be5e38$export$74bf444e3cd11ea5;
var $710f209320be5e38$export$998bcd577473dd93;
var $710f209320be5e38$export$92387174baf9b227;
var $710f209320be5e38$export$ec112efeb987d9c6;
var $710f209320be5e38$export$b706b080d889d2c9;
var $710f209320be5e38$export$5be5a87408f70ddc;
var $710f209320be5e38$export$45a5e7f76e0caa8d;
var $710f209320be5e38$export$455c2e768291efa6;
var $710f209320be5e38$export$9522e17588c12572;
var $710f209320be5e38$export$2110ac352bb060b9;
var $710f209320be5e38$export$56885ab8b9c456ab;
var $710f209320be5e38$export$d927fcb6adf8f9de;
var $710f209320be5e38$export$b82d16f27459e05a;
var $710f209320be5e38$export$522c17b4f5e123e8;
var $710f209320be5e38$export$1aabd8a0274ecfd6;
var $710f209320be5e38$export$3d6c20d97e46b957;
var $710f209320be5e38$export$9b621391a187a31a;
var $710f209320be5e38$export$f5bbd400c2f4426f;
"use strict";
var $710f209320be5e38$var$b = Symbol.for("react.element"), $710f209320be5e38$var$c = Symbol.for("react.portal"), $710f209320be5e38$var$d = Symbol.for("react.fragment"), $710f209320be5e38$var$e = Symbol.for("react.strict_mode"), $710f209320be5e38$var$f = Symbol.for("react.profiler"), $710f209320be5e38$var$g = Symbol.for("react.provider"), $710f209320be5e38$var$h = Symbol.for("react.context"), $710f209320be5e38$var$k = Symbol.for("react.server_context"), $710f209320be5e38$var$l = Symbol.for("react.forward_ref"), $710f209320be5e38$var$m = Symbol.for("react.suspense"), $710f209320be5e38$var$n = Symbol.for("react.suspense_list"), $710f209320be5e38$var$p = Symbol.for("react.memo"), $710f209320be5e38$var$q = Symbol.for("react.lazy"), $710f209320be5e38$var$t = Symbol.for("react.offscreen"), $710f209320be5e38$var$u;
$710f209320be5e38$var$u = Symbol.for("react.module.reference");
function $710f209320be5e38$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $710f209320be5e38$var$b:
                switch(a = a.type, a){
                    case $710f209320be5e38$var$d:
                    case $710f209320be5e38$var$f:
                    case $710f209320be5e38$var$e:
                    case $710f209320be5e38$var$m:
                    case $710f209320be5e38$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $710f209320be5e38$var$k:
                            case $710f209320be5e38$var$h:
                            case $710f209320be5e38$var$l:
                            case $710f209320be5e38$var$q:
                            case $710f209320be5e38$var$p:
                            case $710f209320be5e38$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $710f209320be5e38$var$c:
                return r;
        }
    }
}
$710f209320be5e38$export$a7c73072b1a182ae = $710f209320be5e38$var$h;
$710f209320be5e38$export$9f27bc3417b4524d = $710f209320be5e38$var$g;
$710f209320be5e38$export$db77ccec0bb4ccac = $710f209320be5e38$var$b;
$710f209320be5e38$export$8392c0c9d3dcbd35 = $710f209320be5e38$var$l;
$710f209320be5e38$export$ffb0004e005737fa = $710f209320be5e38$var$d;
$710f209320be5e38$export$b624eff549462981 = $710f209320be5e38$var$q;
$710f209320be5e38$export$7897aa7841a5380c = $710f209320be5e38$var$p;
$710f209320be5e38$export$602eac185826482c = $710f209320be5e38$var$c;
$710f209320be5e38$export$e2c29f18771995cb = $710f209320be5e38$var$f;
$710f209320be5e38$export$5f8d39834fd61797 = $710f209320be5e38$var$e;
$710f209320be5e38$export$74bf444e3cd11ea5 = $710f209320be5e38$var$m;
$710f209320be5e38$export$998bcd577473dd93 = $710f209320be5e38$var$n;
$710f209320be5e38$export$92387174baf9b227 = function() {
    return !1;
};
$710f209320be5e38$export$ec112efeb987d9c6 = function() {
    return !1;
};
$710f209320be5e38$export$b706b080d889d2c9 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$h;
};
$710f209320be5e38$export$5be5a87408f70ddc = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$g;
};
$710f209320be5e38$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $710f209320be5e38$var$b;
};
$710f209320be5e38$export$455c2e768291efa6 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$l;
};
$710f209320be5e38$export$9522e17588c12572 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$d;
};
$710f209320be5e38$export$2110ac352bb060b9 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$q;
};
$710f209320be5e38$export$56885ab8b9c456ab = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$p;
};
$710f209320be5e38$export$d927fcb6adf8f9de = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$c;
};
$710f209320be5e38$export$b82d16f27459e05a = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$f;
};
$710f209320be5e38$export$522c17b4f5e123e8 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$e;
};
$710f209320be5e38$export$1aabd8a0274ecfd6 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$m;
};
$710f209320be5e38$export$3d6c20d97e46b957 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$n;
};
$710f209320be5e38$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $710f209320be5e38$var$d || a === $710f209320be5e38$var$f || a === $710f209320be5e38$var$e || a === $710f209320be5e38$var$m || a === $710f209320be5e38$var$n || a === $710f209320be5e38$var$t || "object" === typeof a && null !== a && (a.$$typeof === $710f209320be5e38$var$q || a.$$typeof === $710f209320be5e38$var$p || a.$$typeof === $710f209320be5e38$var$g || a.$$typeof === $710f209320be5e38$var$h || a.$$typeof === $710f209320be5e38$var$l || a.$$typeof === $710f209320be5e38$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$710f209320be5e38$export$f5bbd400c2f4426f = $710f209320be5e38$var$v;

});




parcelRegister("lEj5y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gnWEo")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("gf69n")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("2XQzx")).default; });

var $gnWEo = parcelRequire("gnWEo");

var $gf69n = parcelRequire("gf69n");

var $2XQzx = parcelRequire("2XQzx");

});
parcelRegister("gnWEo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bedc4a15c73da3aa$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");

var $gf69n = parcelRequire("gf69n");

var $2nHCk = parcelRequire("2nHCk");

var $ktoFS = parcelRequire("ktoFS");

var $34Ozv = parcelRequire("34Ozv");

var $jHIoy = parcelRequire("jHIoy");

var $2XQzx = parcelRequire("2XQzx");
const $bedc4a15c73da3aa$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $bedc4a15c73da3aa$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $7Z8DW.default)(options, $bedc4a15c73da3aa$var$_excluded);
    const breakpoints = (0, $gf69n.default)(breakpointsInput);
    const spacing = (0, $ktoFS.default)(spacingInput);
    let muiTheme = (0, $hWP8m.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $65o8X.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $65o8X.default)({}, (0, $2nHCk.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2XQzx.default);
    muiTheme = args.reduce((acc, argument)=>(0, $hWP8m.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $65o8X.default)({}, (0, $jHIoy.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $34Ozv.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $bedc4a15c73da3aa$export$2e2bcd8739ae039 = $bedc4a15c73da3aa$var$createTheme;

});
parcelRegister("7Z8DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d04ef4777db1668$export$2e2bcd8739ae039; });
function $5d04ef4777db1668$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hWP8m", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $035f37d0c7040a9c$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $035f37d0c7040a9c$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");
function $035f37d0c7040a9c$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $035f37d0c7040a9c$var$deepClone(source) {
    if (!$035f37d0c7040a9c$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $035f37d0c7040a9c$var$deepClone(source[key]);
    });
    return output;
}
function $035f37d0c7040a9c$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $65o8X.default)({}, target) : target;
    if ($035f37d0c7040a9c$export$53b83ca8eaab0383(target) && $035f37d0c7040a9c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($035f37d0c7040a9c$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $035f37d0c7040a9c$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $035f37d0c7040a9c$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $035f37d0c7040a9c$export$53b83ca8eaab0383(source[key]) ? $035f37d0c7040a9c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("gf69n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd32d16147a79a70$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
const $bd32d16147a79a70$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $bd32d16147a79a70$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $bd32d16147a79a70$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $65o8X.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $bd32d16147a79a70$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $7Z8DW.default)(breakpoints, $bd32d16147a79a70$var$_excluded);
    const sortedValues = $bd32d16147a79a70$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $65o8X.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("2nHCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bbf9039396b40fa$export$2e2bcd8739ae039; });
const $1bbf9039396b40fa$var$shape = {
    borderRadius: 4
};
var $1bbf9039396b40fa$export$2e2bcd8739ae039 = $1bbf9039396b40fa$var$shape;

});

parcelRegister("ktoFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee79a7e86c1f806b$export$2e2bcd8739ae039; });

var $fwBcG = parcelRequire("fwBcG");
function $ee79a7e86c1f806b$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fwBcG.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fwBcG", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $b4d6b40d7c00ec9c$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $b4d6b40d7c00ec9c$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $b4d6b40d7c00ec9c$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $b4d6b40d7c00ec9c$export$6f98e8eaf0be1996; });


var $ivlTt = parcelRequire("ivlTt");

var $ce1Wd = parcelRequire("ce1Wd");

var $7ZfQq = parcelRequire("7ZfQq");

var $73RwQ = parcelRequire("73RwQ");
const $b4d6b40d7c00ec9c$var$properties = {
    m: "margin",
    p: "padding"
};
const $b4d6b40d7c00ec9c$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $b4d6b40d7c00ec9c$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b4d6b40d7c00ec9c$var$getCssProperties = (0, $73RwQ.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b4d6b40d7c00ec9c$var$aliases[prop]) prop = $b4d6b40d7c00ec9c$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $b4d6b40d7c00ec9c$var$properties[a];
    const direction = $b4d6b40d7c00ec9c$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $b4d6b40d7c00ec9c$var$spacingKeys = [
    ...$b4d6b40d7c00ec9c$export$aab52a0dde05ad8a,
    ...$b4d6b40d7c00ec9c$export$f8397d44f03ab6ad
];
function $b4d6b40d7c00ec9c$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $ce1Wd.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $b4d6b40d7c00ec9c$export$1def6f833384e3d1(theme) {
    return $b4d6b40d7c00ec9c$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $b4d6b40d7c00ec9c$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b4d6b40d7c00ec9c$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b4d6b40d7c00ec9c$var$getCssProperties(prop);
    const styleFromPropValue = $b4d6b40d7c00ec9c$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $ivlTt.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b4d6b40d7c00ec9c$var$style(props, keys) {
    const transformer = $b4d6b40d7c00ec9c$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b4d6b40d7c00ec9c$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7ZfQq.default), {});
}
function $b4d6b40d7c00ec9c$export$7ede87f9b603dd3c(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a);
}
$b4d6b40d7c00ec9c$export$7ede87f9b603dd3c.propTypes = {};
$b4d6b40d7c00ec9c$export$7ede87f9b603dd3c.filterProps = $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a;
function $b4d6b40d7c00ec9c$export$6f98e8eaf0be1996(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad);
}
$b4d6b40d7c00ec9c$export$6f98e8eaf0be1996.propTypes = {};
$b4d6b40d7c00ec9c$export$6f98e8eaf0be1996.filterProps = $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad;
function $b4d6b40d7c00ec9c$var$spacing(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$var$spacingKeys);
}
$b4d6b40d7c00ec9c$var$spacing.propTypes = {};
$b4d6b40d7c00ec9c$var$spacing.filterProps = $b4d6b40d7c00ec9c$var$spacingKeys;
var $b4d6b40d7c00ec9c$export$2e2bcd8739ae039 = $b4d6b40d7c00ec9c$var$spacing;

});
parcelRegister("ivlTt", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $d78c1ae28d5effac$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $d78c1ae28d5effac$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $d78c1ae28d5effac$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $d78c1ae28d5effac$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $d78c1ae28d5effac$export$980e6a259d807490; });

var $65o8X = parcelRequire("65o8X");


var $hWP8m = parcelRequire("hWP8m");

var $7ZfQq = parcelRequire("7ZfQq");
const $d78c1ae28d5effac$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $d78c1ae28d5effac$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$d78c1ae28d5effac$export$68c286be0e7e55b7[key]}px)`
};
function $d78c1ae28d5effac$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $d78c1ae28d5effac$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $d78c1ae28d5effac$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $65o8X.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7ZfQq.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $d78c1ae28d5effac$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $d78c1ae28d5effac$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $d78c1ae28d5effac$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $d78c1ae28d5effac$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $hWP8m.default)(prev, next), {});
    return $d78c1ae28d5effac$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $d78c1ae28d5effac$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $d78c1ae28d5effac$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $d78c1ae28d5effac$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $d78c1ae28d5effac$export$2e2bcd8739ae039 = $d78c1ae28d5effac$var$breakpoints;

});
parcelRegister("7ZfQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0a85539df49e43$export$2e2bcd8739ae039; });

var $hWP8m = parcelRequire("hWP8m");
function $5d0a85539df49e43$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $hWP8m.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $5d0a85539df49e43$export$2e2bcd8739ae039 = $5d0a85539df49e43$var$merge;

});


parcelRegister("ce1Wd", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $8e684bab4b6464fb$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $8e684bab4b6464fb$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $8e684bab4b6464fb$export$2e2bcd8739ae039; });

var $hojpr = parcelRequire("hojpr");


var $ivlTt = parcelRequire("ivlTt");
function $8e684bab4b6464fb$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $8e684bab4b6464fb$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $8e684bab4b6464fb$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $8e684bab4b6464fb$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $hojpr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $8e684bab4b6464fb$export$2e2bcd8739ae039 = $8e684bab4b6464fb$var$style;

});

parcelRegister("73RwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524255e38f674b8f$export$2e2bcd8739ae039; });
function $524255e38f674b8f$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("34Ozv", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $23d8f94f0a23bd3b$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $23d8f94f0a23bd3b$export$2e2bcd8739ae039; });

var $hojpr = parcelRequire("hojpr");

var $7ZfQq = parcelRequire("7ZfQq");

var $ce1Wd = parcelRequire("ce1Wd");

var $ivlTt = parcelRequire("ivlTt");

var $jHIoy = parcelRequire("jHIoy");
function $23d8f94f0a23bd3b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $23d8f94f0a23bd3b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $23d8f94f0a23bd3b$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $ce1Wd.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ce1Wd.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $ce1Wd.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $hojpr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $jHIoy.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $ivlTt.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $23d8f94f0a23bd3b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $7ZfQq.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $ivlTt.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($23d8f94f0a23bd3b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7ZfQq.default)(css, breakpointsValues);
                        }
                    } else css = (0, $7ZfQq.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $ivlTt.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $23d8f94f0a23bd3b$var$styleFunctionSx = $23d8f94f0a23bd3b$export$7d53d8bf2911e013();
$23d8f94f0a23bd3b$var$styleFunctionSx.filterProps = [
    "sx"
];
var $23d8f94f0a23bd3b$export$2e2bcd8739ae039 = $23d8f94f0a23bd3b$var$styleFunctionSx;

});
parcelRegister("jHIoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e58478679467ccff$export$2e2bcd8739ae039; });

var $fwBcG = parcelRequire("fwBcG");

var $dOJmG = parcelRequire("dOJmG");

var $d6drG = parcelRequire("d6drG");

var $eQnSg = parcelRequire("eQnSg");

var $fTpbm = parcelRequire("fTpbm");
const $e58478679467ccff$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $dOJmG.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $eQnSg.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $eQnSg.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $eQnSg.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fwBcG.padding)
    },
    pt: {
        style: (0, $fwBcG.padding)
    },
    pr: {
        style: (0, $fwBcG.padding)
    },
    pb: {
        style: (0, $fwBcG.padding)
    },
    pl: {
        style: (0, $fwBcG.padding)
    },
    px: {
        style: (0, $fwBcG.padding)
    },
    py: {
        style: (0, $fwBcG.padding)
    },
    padding: {
        style: (0, $fwBcG.padding)
    },
    paddingTop: {
        style: (0, $fwBcG.padding)
    },
    paddingRight: {
        style: (0, $fwBcG.padding)
    },
    paddingBottom: {
        style: (0, $fwBcG.padding)
    },
    paddingLeft: {
        style: (0, $fwBcG.padding)
    },
    paddingX: {
        style: (0, $fwBcG.padding)
    },
    paddingY: {
        style: (0, $fwBcG.padding)
    },
    paddingInline: {
        style: (0, $fwBcG.padding)
    },
    paddingInlineStart: {
        style: (0, $fwBcG.padding)
    },
    paddingInlineEnd: {
        style: (0, $fwBcG.padding)
    },
    paddingBlock: {
        style: (0, $fwBcG.padding)
    },
    paddingBlockStart: {
        style: (0, $fwBcG.padding)
    },
    paddingBlockEnd: {
        style: (0, $fwBcG.padding)
    },
    m: {
        style: (0, $fwBcG.margin)
    },
    mt: {
        style: (0, $fwBcG.margin)
    },
    mr: {
        style: (0, $fwBcG.margin)
    },
    mb: {
        style: (0, $fwBcG.margin)
    },
    ml: {
        style: (0, $fwBcG.margin)
    },
    mx: {
        style: (0, $fwBcG.margin)
    },
    my: {
        style: (0, $fwBcG.margin)
    },
    margin: {
        style: (0, $fwBcG.margin)
    },
    marginTop: {
        style: (0, $fwBcG.margin)
    },
    marginRight: {
        style: (0, $fwBcG.margin)
    },
    marginBottom: {
        style: (0, $fwBcG.margin)
    },
    marginLeft: {
        style: (0, $fwBcG.margin)
    },
    marginX: {
        style: (0, $fwBcG.margin)
    },
    marginY: {
        style: (0, $fwBcG.margin)
    },
    marginInline: {
        style: (0, $fwBcG.margin)
    },
    marginInlineStart: {
        style: (0, $fwBcG.margin)
    },
    marginInlineEnd: {
        style: (0, $fwBcG.margin)
    },
    marginBlock: {
        style: (0, $fwBcG.margin)
    },
    marginBlockStart: {
        style: (0, $fwBcG.margin)
    },
    marginBlockEnd: {
        style: (0, $fwBcG.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $d6drG.gap)
    },
    rowGap: {
        style: (0, $d6drG.rowGap)
    },
    columnGap: {
        style: (0, $d6drG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $fTpbm.sizingTransform)
    },
    maxWidth: {
        style: (0, $fTpbm.maxWidth)
    },
    minWidth: {
        transform: (0, $fTpbm.sizingTransform)
    },
    height: {
        transform: (0, $fTpbm.sizingTransform)
    },
    maxHeight: {
        transform: (0, $fTpbm.sizingTransform)
    },
    minHeight: {
        transform: (0, $fTpbm.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $e58478679467ccff$export$2e2bcd8739ae039 = $e58478679467ccff$var$defaultSxConfig;

});
parcelRegister("dOJmG", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a0f3226839926fa3$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a0f3226839926fa3$export$7a57f79000377ca2; });


var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $fwBcG = parcelRequire("fwBcG");

var $ivlTt = parcelRequire("ivlTt");
function $a0f3226839926fa3$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $a0f3226839926fa3$var$createBorderStyle(prop, transform) {
    return (0, $ce1Wd.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $a0f3226839926fa3$export$1edee58a52776cd9 = $a0f3226839926fa3$var$createBorderStyle("border", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$f9a7b6bd24892946 = $a0f3226839926fa3$var$createBorderStyle("borderTop", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$5abca33e6be905d2 = $a0f3226839926fa3$var$createBorderStyle("borderRight", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$e2ce9f12a980a822 = $a0f3226839926fa3$var$createBorderStyle("borderBottom", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$47658cca1a909427 = $a0f3226839926fa3$var$createBorderStyle("borderLeft", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$e7fb0694ba2404fc = $a0f3226839926fa3$var$createBorderStyle("borderColor");
const $a0f3226839926fa3$export$126a92c968acdb85 = $a0f3226839926fa3$var$createBorderStyle("borderTopColor");
const $a0f3226839926fa3$export$85cc51cb8fbb8c0e = $a0f3226839926fa3$var$createBorderStyle("borderRightColor");
const $a0f3226839926fa3$export$340b0327727f6d1a = $a0f3226839926fa3$var$createBorderStyle("borderBottomColor");
const $a0f3226839926fa3$export$60beef91a985b4bf = $a0f3226839926fa3$var$createBorderStyle("borderLeftColor");
const $a0f3226839926fa3$export$f9258c55612cbed7 = $a0f3226839926fa3$var$createBorderStyle("outline", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$621fe586efeb64b9 = $a0f3226839926fa3$var$createBorderStyle("outlineColor");
const $a0f3226839926fa3$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a0f3226839926fa3$export$7a57f79000377ca2.propTypes = {};
$a0f3226839926fa3$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $a0f3226839926fa3$var$borders = (0, $2AzUI.default)($a0f3226839926fa3$export$1edee58a52776cd9, $a0f3226839926fa3$export$f9a7b6bd24892946, $a0f3226839926fa3$export$5abca33e6be905d2, $a0f3226839926fa3$export$e2ce9f12a980a822, $a0f3226839926fa3$export$47658cca1a909427, $a0f3226839926fa3$export$e7fb0694ba2404fc, $a0f3226839926fa3$export$126a92c968acdb85, $a0f3226839926fa3$export$85cc51cb8fbb8c0e, $a0f3226839926fa3$export$340b0327727f6d1a, $a0f3226839926fa3$export$60beef91a985b4bf, $a0f3226839926fa3$export$7a57f79000377ca2, $a0f3226839926fa3$export$f9258c55612cbed7, $a0f3226839926fa3$export$621fe586efeb64b9);
var $a0f3226839926fa3$export$2e2bcd8739ae039 = $a0f3226839926fa3$var$borders;

});
parcelRegister("2AzUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e2acd4951a2ccdd$export$2e2bcd8739ae039; });

var $7ZfQq = parcelRequire("7ZfQq");
function $1e2acd4951a2ccdd$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7ZfQq.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $1e2acd4951a2ccdd$export$2e2bcd8739ae039 = $1e2acd4951a2ccdd$var$compose;

});


parcelRegister("d6drG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $989643e16a850b36$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $989643e16a850b36$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $989643e16a850b36$export$8a833ffa5f5dbeda; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $fwBcG = parcelRequire("fwBcG");

var $ivlTt = parcelRequire("ivlTt");

const $989643e16a850b36$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$5df9adcb0db95e1e.propTypes = {};
$989643e16a850b36$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $989643e16a850b36$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$ec60d70ff941a580.propTypes = {};
$989643e16a850b36$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $989643e16a850b36$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$8a833ffa5f5dbeda.propTypes = {};
$989643e16a850b36$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $989643e16a850b36$export$baf44164ca3a34e8 = (0, $ce1Wd.default)({
    prop: "gridColumn"
});
const $989643e16a850b36$export$8f7213a1cd01e832 = (0, $ce1Wd.default)({
    prop: "gridRow"
});
const $989643e16a850b36$export$b0e0abbc49ba668 = (0, $ce1Wd.default)({
    prop: "gridAutoFlow"
});
const $989643e16a850b36$export$bcd8b929d4b4142 = (0, $ce1Wd.default)({
    prop: "gridAutoColumns"
});
const $989643e16a850b36$export$e5039a674e14c828 = (0, $ce1Wd.default)({
    prop: "gridAutoRows"
});
const $989643e16a850b36$export$42bd9088661ffb03 = (0, $ce1Wd.default)({
    prop: "gridTemplateColumns"
});
const $989643e16a850b36$export$920682ae05b999bc = (0, $ce1Wd.default)({
    prop: "gridTemplateRows"
});
const $989643e16a850b36$export$1b88fbdd482fd33a = (0, $ce1Wd.default)({
    prop: "gridTemplateAreas"
});
const $989643e16a850b36$export$bdb486e40d52d26f = (0, $ce1Wd.default)({
    prop: "gridArea"
});
const $989643e16a850b36$var$grid = (0, $2AzUI.default)($989643e16a850b36$export$5df9adcb0db95e1e, $989643e16a850b36$export$ec60d70ff941a580, $989643e16a850b36$export$8a833ffa5f5dbeda, $989643e16a850b36$export$baf44164ca3a34e8, $989643e16a850b36$export$8f7213a1cd01e832, $989643e16a850b36$export$b0e0abbc49ba668, $989643e16a850b36$export$bcd8b929d4b4142, $989643e16a850b36$export$e5039a674e14c828, $989643e16a850b36$export$42bd9088661ffb03, $989643e16a850b36$export$920682ae05b999bc, $989643e16a850b36$export$1b88fbdd482fd33a, $989643e16a850b36$export$bdb486e40d52d26f);
var $989643e16a850b36$export$2e2bcd8739ae039 = $989643e16a850b36$var$grid;

});

parcelRegister("eQnSg", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $ace870f25fe00eeb$export$dbaffd4420ea0ac6; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");
function $ace870f25fe00eeb$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $ace870f25fe00eeb$export$35e9368ef982300f = (0, $ce1Wd.default)({
    prop: "color",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$export$2506f56c10355b33 = (0, $ce1Wd.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$export$8c5a050822fd698c = (0, $ce1Wd.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$var$palette = (0, $2AzUI.default)($ace870f25fe00eeb$export$35e9368ef982300f, $ace870f25fe00eeb$export$2506f56c10355b33, $ace870f25fe00eeb$export$8c5a050822fd698c);
var $ace870f25fe00eeb$export$2e2bcd8739ae039 = $ace870f25fe00eeb$var$palette;

});

parcelRegister("fTpbm", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $b91f86bf58963db2$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $b91f86bf58963db2$export$488fda99655ff65a; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $ivlTt = parcelRequire("ivlTt");
function $b91f86bf58963db2$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $b91f86bf58963db2$export$7e3df82ee760448c = (0, $ce1Wd.default)({
    prop: "width",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $ivlTt.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $b91f86bf58963db2$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$b91f86bf58963db2$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $b91f86bf58963db2$export$ee148fbbe8357dd2 = (0, $ce1Wd.default)({
    prop: "minWidth",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$ac607276a8fe9f0a = (0, $ce1Wd.default)({
    prop: "height",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$dc0d8bd0b94f8570 = (0, $ce1Wd.default)({
    prop: "maxHeight",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$a43cf604e12f3b17 = (0, $ce1Wd.default)({
    prop: "minHeight",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$ffed9f14fb65e276 = (0, $ce1Wd.default)({
    prop: "size",
    cssProperty: "width",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$905076ed6620e671 = (0, $ce1Wd.default)({
    prop: "size",
    cssProperty: "height",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$6ccc93f785106a58 = (0, $ce1Wd.default)({
    prop: "boxSizing"
});
const $b91f86bf58963db2$var$sizing = (0, $2AzUI.default)($b91f86bf58963db2$export$7e3df82ee760448c, $b91f86bf58963db2$export$488fda99655ff65a, $b91f86bf58963db2$export$ee148fbbe8357dd2, $b91f86bf58963db2$export$ac607276a8fe9f0a, $b91f86bf58963db2$export$dc0d8bd0b94f8570, $b91f86bf58963db2$export$a43cf604e12f3b17, $b91f86bf58963db2$export$6ccc93f785106a58);
var $b91f86bf58963db2$export$2e2bcd8739ae039 = $b91f86bf58963db2$var$sizing;

});



parcelRegister("2XQzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2289df3a0cc6ad38$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $2289df3a0cc6ad38$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("k2gEs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("34Ozv")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("34Ozv")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("bU7jb")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("jHIoy")).default; });

var $34Ozv = parcelRequire("34Ozv");

var $bU7jb = parcelRequire("bU7jb");

var $jHIoy = parcelRequire("jHIoy");

});
parcelRegister("bU7jb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aaa97f9bb9ae172$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");

var $jHIoy = parcelRequire("jHIoy");
const $8aaa97f9bb9ae172$var$_excluded = [
    "sx"
];
const $8aaa97f9bb9ae172$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $jHIoy.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $8aaa97f9bb9ae172$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $7Z8DW.default)(props, $8aaa97f9bb9ae172$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $8aaa97f9bb9ae172$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $hWP8m.isPlainObject)(result)) return systemProps;
        return (0, $65o8X.default)({}, systemProps, result);
    };
    else finalSx = (0, $65o8X.default)({}, systemProps, inSx);
    return (0, $65o8X.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("1yFU7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9u6aw")).default; });

var $9u6aw = parcelRequire("9u6aw");

});

parcelRegister("6Gv37", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3WZeB")).default; });

var $3WZeB = parcelRequire("3WZeB");

});
parcelRegister("3WZeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e0649cc841e6e7e$export$2e2bcd8739ae039; });
function $2e0649cc841e6e7e$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $2e0649cc841e6e7e$export$2e2bcd8739ae039 = $2e0649cc841e6e7e$var$clamp;

});


parcelRegister("kvR7a", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("aZjGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $d48On = parcelRequire("d48On");

var $rPxMG = parcelRequire("rPxMG");

var $cZMUv = parcelRequire("cZMUv");

var $3Vxa5 = parcelRequire("3Vxa5");

var $4ocSv = parcelRequire("4ocSv");

var $94t7D = parcelRequire("94t7D");

var $dYOPi = parcelRequire("dYOPi");

var $d4P6P = parcelRequire("d4P6P");

var $lDsJN = parcelRequire("lDsJN");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $cZMUv.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $rPxMG.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $cZMUv.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ResourceStore = function(_EventEmitter) {
    (0, $4ocSv.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $rPxMG.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $cZMUv.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $4ocSv.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $3Vxa5.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    (0, $cZMUv.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $d48On.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $d48On.default)(options) === "object") options = _objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $rPxMG.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    (0, $cZMUv.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    (0, $cZMUv.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $rPxMG.default)(this, Interpolator);
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $cZMUv.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $lDsJN.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $rPxMG.default)(this, Formatter);
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $cZMUv.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $4ocSv.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $rPxMG.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $cZMUv.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $d48On.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $d48On.default)(args[2]) === "object" || (0, $d48On.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $4ocSv.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $rPxMG.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $3Vxa5.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $94t7D.default)(_this, (0, $3Vxa5.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $cZMUv.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $d48On.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $d4P6P.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("d48On", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98327be4adf32d0d$export$2e2bcd8739ae039; });
function $98327be4adf32d0d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $98327be4adf32d0d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98327be4adf32d0d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("rPxMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $053a81471954ae9a$export$2e2bcd8739ae039; });
function $053a81471954ae9a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cZMUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97611f1a65b321a7$export$2e2bcd8739ae039; });

var $2afrY = parcelRequire("2afrY");
function $97611f1a65b321a7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $2afrY.default)(o.key), o);
    }
}
function $97611f1a65b321a7$export$2e2bcd8739ae039(e, r, t) {
    return r && $97611f1a65b321a7$var$_defineProperties(e.prototype, r), t && $97611f1a65b321a7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("2afrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19388003cddb44ed$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");

var $8ZEVp = parcelRequire("8ZEVp");
function $19388003cddb44ed$export$2e2bcd8739ae039(t) {
    var i = (0, $8ZEVp.default)(t, "string");
    return "symbol" == (0, $d48On.default)(i) ? i : i + "";
}

});
parcelRegister("8ZEVp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c3c41270c5bd65$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");
function $68c3c41270c5bd65$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $d48On.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $d48On.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3Vxa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dc06b2edb5373b2$export$2e2bcd8739ae039; });
function $2dc06b2edb5373b2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("4ocSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $332364a567063cf8$export$2e2bcd8739ae039; });

var $3XZxQ = parcelRequire("3XZxQ");
function $332364a567063cf8$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3XZxQ.default)(t, e);
}

});
parcelRegister("3XZxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e369f5411378101$export$2e2bcd8739ae039; });
function $2e369f5411378101$export$2e2bcd8739ae039(t, e) {
    return $2e369f5411378101$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2e369f5411378101$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("94t7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ab13d4363a362b$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");

var $3Vxa5 = parcelRequire("3Vxa5");
function $69ab13d4363a362b$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $d48On.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3Vxa5.default)(t);
}

});

parcelRegister("dYOPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d84e01f7e64413$export$2e2bcd8739ae039; });
function $a2d84e01f7e64413$export$2e2bcd8739ae039(t) {
    return $a2d84e01f7e64413$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a2d84e01f7e64413$export$2e2bcd8739ae039(t);
}

});

parcelRegister("d4P6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98534b50fcf80561$export$2e2bcd8739ae039; });

var $2afrY = parcelRequire("2afrY");
function $98534b50fcf80561$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $2afrY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("lDsJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc038837611b900a$export$2e2bcd8739ae039; });

var $luw9G = parcelRequire("luw9G");

var $7aanC = parcelRequire("7aanC");

var $8boX5 = parcelRequire("8boX5");

var $8KBa0 = parcelRequire("8KBa0");
function $fc038837611b900a$export$2e2bcd8739ae039(r) {
    return (0, $luw9G.default)(r) || (0, $7aanC.default)(r) || (0, $8boX5.default)(r) || (0, $8KBa0.default)();
}

});
parcelRegister("luw9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5557aeb35eafe0$export$2e2bcd8739ae039; });
function $fa5557aeb35eafe0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7aanC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537184d2ba980709$export$2e2bcd8739ae039; });
function $537184d2ba980709$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8boX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f52b4bf04904cc7$export$2e2bcd8739ae039; });

var $78tUI = parcelRequire("78tUI");
function $5f52b4bf04904cc7$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $78tUI.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $78tUI.default)(r, a) : void 0;
    }
}

});
parcelRegister("78tUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53207bfe34db9cd5$export$2e2bcd8739ae039; });
function $53207bfe34db9cd5$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8KBa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65ef71dd7acb5292$export$2e2bcd8739ae039; });
function $65ef71dd7acb5292$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("brkeu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $8541e91a69b79b55$export$306c0aa65ff9ec16; }, function (v) { return $8541e91a69b79b55$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8541e91a69b79b55$export$306c0aa65ff9ec16;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
function $8541e91a69b79b55$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8541e91a69b79b55$var$k = "function" === typeof Object.is ? Object.is : $8541e91a69b79b55$var$h, $8541e91a69b79b55$var$l = $eZVvM.useState, $8541e91a69b79b55$var$m = $eZVvM.useEffect, $8541e91a69b79b55$var$n = $eZVvM.useLayoutEffect, $8541e91a69b79b55$var$p = $eZVvM.useDebugValue;
function $8541e91a69b79b55$var$q(a, b) {
    var d = b(), f = $8541e91a69b79b55$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8541e91a69b79b55$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8541e91a69b79b55$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8541e91a69b79b55$var$m(function() {
        $8541e91a69b79b55$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8541e91a69b79b55$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8541e91a69b79b55$var$p(d);
    return d;
}
function $8541e91a69b79b55$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8541e91a69b79b55$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8541e91a69b79b55$var$t(a, b) {
    return b();
}
var $8541e91a69b79b55$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8541e91a69b79b55$var$t : $8541e91a69b79b55$var$q;
$8541e91a69b79b55$export$306c0aa65ff9ec16 = void 0 !== $eZVvM.useSyncExternalStore ? $eZVvM.useSyncExternalStore : $8541e91a69b79b55$var$u;

});

parcelRegister("aCYKL", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1sHSN.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("1sHSN", function(module, exports) {

var $gGNqj = parcelRequire("gGNqj");
/** Detect free variable `self`. */ var $110a722a72d260f8$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $110a722a72d260f8$var$root = $gGNqj || $110a722a72d260f8$var$freeSelf || Function("return this")();
module.exports = $110a722a72d260f8$var$root;

});
parcelRegister("gGNqj", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $c266e80d4ef72cab$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $c266e80d4ef72cab$var$freeGlobal;

});



parcelRegister("hLa8L", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");

var $6jS5F = parcelRequire("6jS5F");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1sHSN.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6jS5F;
module.exports = isBuffer;

});
parcelRegister("6jS5F", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $499e79a7d4850767$var$stubFalse() {
    return false;
}
module.exports = $499e79a7d4850767$var$stubFalse;

});


parcelRegister("1sJ0x", function(module, exports) {

var $gGNqj = parcelRequire("gGNqj");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gGNqj.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("99QKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
var $6aadde4af300d5e0$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $6aadde4af300d5e0$var$useCustomCompareEffect = function(effect, deps, depsEqual) {
    var ref = $eZVvM.useRef(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
    $eZVvM.useEffect(effect, ref.current);
};
module.exports.default = $6aadde4af300d5e0$var$useCustomCompareEffect;

});

parcelRegister("aqTHk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUWBZ = parcelRequire("iUWBZ");

var $79878983e3495663$var$react_1 = $iUWBZ.__importDefault((parcelRequire("2AWxB")));
module.exports.default = $79878983e3495663$var$react_1.default;

});
parcelRegister("iUWBZ", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $587e592597a56e11$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $587e592597a56e11$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $587e592597a56e11$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importDefault", function () { return $587e592597a56e11$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $587e592597a56e11$var$extendStatics = function(d, b) {
    $587e592597a56e11$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $587e592597a56e11$var$extendStatics(d, b);
};
function $587e592597a56e11$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $587e592597a56e11$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $587e592597a56e11$export$18ce0697a983be9b = function() {
    $587e592597a56e11$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $587e592597a56e11$export$18ce0697a983be9b.apply(this, arguments);
};
function $587e592597a56e11$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $587e592597a56e11$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $587e592597a56e11$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $587e592597a56e11$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $587e592597a56e11$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $587e592597a56e11$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $587e592597a56e11$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $587e592597a56e11$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $587e592597a56e11$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $587e592597a56e11$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $587e592597a56e11$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $587e592597a56e11$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $587e592597a56e11$export$45d3717a4c69092e(o, m, p);
}
function $587e592597a56e11$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $587e592597a56e11$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $587e592597a56e11$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($587e592597a56e11$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $587e592597a56e11$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $587e592597a56e11$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $587e592597a56e11$export$10c90e4f7922046c(v) {
    return this instanceof $587e592597a56e11$export$10c90e4f7922046c ? (this.v = v, this) : new $587e592597a56e11$export$10c90e4f7922046c(v);
}
function $587e592597a56e11$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $587e592597a56e11$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $587e592597a56e11$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $587e592597a56e11$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $587e592597a56e11$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $587e592597a56e11$export$19a8beecd37a4c45 === "function" ? $587e592597a56e11$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $587e592597a56e11$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $587e592597a56e11$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $587e592597a56e11$var$ownKeys = function(o) {
    $587e592597a56e11$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $587e592597a56e11$var$ownKeys(o);
};
function $587e592597a56e11$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $587e592597a56e11$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $587e592597a56e11$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $587e592597a56e11$var$__setModuleDefault(result, mod);
    return result;
}
function $587e592597a56e11$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $587e592597a56e11$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $587e592597a56e11$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $587e592597a56e11$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $587e592597a56e11$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $587e592597a56e11$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $587e592597a56e11$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $587e592597a56e11$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $587e592597a56e11$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $587e592597a56e11$export$2e2bcd8739ae039 = {
    __extends: $587e592597a56e11$export$a8ba968b8961cb8a,
    __assign: $587e592597a56e11$export$18ce0697a983be9b,
    __rest: $587e592597a56e11$export$3c9a16f847548506,
    __decorate: $587e592597a56e11$export$29e00dfd3077644b,
    __param: $587e592597a56e11$export$d5ad3fd78186038f,
    __esDecorate: $587e592597a56e11$export$3a84e1ae4e97e9b0,
    __runInitializers: $587e592597a56e11$export$d831c04e792af3d,
    __propKey: $587e592597a56e11$export$6a2a36740a146cb8,
    __setFunctionName: $587e592597a56e11$export$d1a06452d3489bc7,
    __metadata: $587e592597a56e11$export$f1db080c865becb9,
    __awaiter: $587e592597a56e11$export$1050f835b63b671e,
    __generator: $587e592597a56e11$export$67ebef60e6f28a6,
    __createBinding: $587e592597a56e11$export$45d3717a4c69092e,
    __exportStar: $587e592597a56e11$export$f33643c0debef087,
    __values: $587e592597a56e11$export$19a8beecd37a4c45,
    __read: $587e592597a56e11$export$8d051b38c9118094,
    __spread: $587e592597a56e11$export$afc72e2116322959,
    __spreadArrays: $587e592597a56e11$export$6388937ca91ccae8,
    __spreadArray: $587e592597a56e11$export$1216008129fb82ed,
    __await: $587e592597a56e11$export$10c90e4f7922046c,
    __asyncGenerator: $587e592597a56e11$export$e427f37a30a4de9b,
    __asyncDelegator: $587e592597a56e11$export$bbd80228419bb833,
    __asyncValues: $587e592597a56e11$export$e3b29a3d6162315f,
    __makeTemplateObject: $587e592597a56e11$export$4fb47efe1390b86f,
    __importStar: $587e592597a56e11$export$c21735bcef00d192,
    __importDefault: $587e592597a56e11$export$da59b14a69baef04,
    __classPrivateFieldGet: $587e592597a56e11$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $587e592597a56e11$export$d40a35129aaff81f,
    __classPrivateFieldIn: $587e592597a56e11$export$81fdc39f203e4e04,
    __addDisposableResource: $587e592597a56e11$export$88ac25d8e944e405,
    __disposeResources: $587e592597a56e11$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $587e592597a56e11$export$889dfb5d17574b0b
};

});

parcelRegister("2AWxB", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});


parcelRegister("jXblK", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("1urwW", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("jJBzg", function(module, exports) {
"use strict";
var $e5df5c7963016d05$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Wsxr = parcelRequire("7Wsxr");

var $e5df5c7963016d05$var$form_data_1 = $e5df5c7963016d05$var$__importDefault((parcelRequire("gGodY")));

var $kQznX = parcelRequire("kQznX");
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */ var $e5df5c7963016d05$var$isExtractableFileEnhanced = function(value) {
    return (0, $7Wsxr.isExtractableFile)(value) || value !== null && typeof value === "object" && typeof value.pipe === "function";
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */ function $e5df5c7963016d05$var$createRequestBody(query, variables, operationName, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $kQznX.defaultJsonSerializer;
    var _a = (0, $7Wsxr.extractFiles)({
        query: query,
        variables: variables,
        operationName: operationName
    }, "", $e5df5c7963016d05$var$isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) return jsonSerializer.stringify(clone);
        if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create request body with given variable type, array expected");
        // Batch support
        var payload = query.reduce(function(accu, currentQuery, index) {
            accu.push({
                query: currentQuery,
                variables: variables ? variables[index] : undefined
            });
            return accu;
        }, []);
        return jsonSerializer.stringify(payload);
    }
    var Form = typeof FormData === "undefined" ? $e5df5c7963016d05$var$form_data_1.default : FormData;
    var form = new Form();
    form.append("operations", jsonSerializer.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function(paths) {
        map[++i] = paths;
    });
    form.append("map", jsonSerializer.stringify(map));
    i = 0;
    files.forEach(function(paths, file) {
        form.append("".concat(++i), file);
    });
    return form;
}
module.exports.default = $e5df5c7963016d05$var$createRequestBody;

});
parcelRegister("7Wsxr", function(module, exports) {

$parcel$export(module.exports, "extractFiles", function () { return $017e005c1a243415$export$f5544efc2684376b; }, function (v) { return $017e005c1a243415$export$f5544efc2684376b = v; });
$parcel$export(module.exports, "isExtractableFile", function () { return $017e005c1a243415$export$f892d0f8e65523c3; }, function (v) { return $017e005c1a243415$export$f892d0f8e65523c3 = v; });
var $017e005c1a243415$export$5fcafa2ee375e60a;
var $017e005c1a243415$export$f5544efc2684376b;
var $017e005c1a243415$export$f892d0f8e65523c3;
"use strict";

$017e005c1a243415$export$5fcafa2ee375e60a = (parcelRequire("ceUxG"));

$017e005c1a243415$export$f5544efc2684376b = (parcelRequire("3kqQK"));

$017e005c1a243415$export$f892d0f8e65523c3 = (parcelRequire("1TebU"));

});
parcelRegister("ceUxG", function(module, exports) {
"use strict";
module.exports = function ReactNativeFile(_ref) {
    var uri = _ref.uri, name = _ref.name, type = _ref.type;
    this.uri = uri;
    this.name = name;
    this.type = type;
};

});

parcelRegister("3kqQK", function(module, exports) {
"use strict";

var $1TebU = parcelRequire("1TebU");
module.exports = function extractFiles(value, path, isExtractableFile) {
    if (path === void 0) path = "";
    if (isExtractableFile === void 0) isExtractableFile = $1TebU;
    var clone;
    var files = new Map();
    function addFile(paths, file) {
        var storedPaths = files.get(file);
        if (storedPaths) storedPaths.push.apply(storedPaths, paths);
        else files.set(file, paths);
    }
    if (isExtractableFile(value)) {
        clone = null;
        addFile([
            path
        ], value);
    } else {
        var prefix = path ? path + "." : "";
        if (typeof FileList !== "undefined" && value instanceof FileList) clone = Array.prototype.map.call(value, function(file, i) {
            addFile([
                "" + prefix + i
            ], file);
            return null;
        });
        else if (Array.isArray(value)) clone = value.map(function(child, i) {
            var result = extractFiles(child, "" + prefix + i, isExtractableFile);
            result.files.forEach(addFile);
            return result.clone;
        });
        else if (value && value.constructor === Object) {
            clone = {};
            for(var i in value){
                var result = extractFiles(value[i], "" + prefix + i, isExtractableFile);
                result.files.forEach(addFile);
                clone[i] = result.clone;
            }
        } else clone = value;
    }
    return {
        clone: clone,
        files: files
    };
};

});
parcelRegister("1TebU", function(module, exports) {
"use strict";

var $ceUxG = parcelRequire("ceUxG");
module.exports = function isExtractableFile(value) {
    return typeof File !== "undefined" && value instanceof File || typeof Blob !== "undefined" && value instanceof Blob || value instanceof $ceUxG;
};

});



parcelRegister("gGodY", function(module, exports) {
/* eslint-env browser */ module.exports = typeof self == "object" ? self.FormData : window.FormData;

});

parcelRegister("kQznX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultJsonSerializer = void 0;
module.exports.defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify
};

});


parcelRegister("1dirW", function(module, exports) {
(function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join("");
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push("=");
            }
            return base64.join("");
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("2uhSt", function(module, exports) {
var $1cfc403e6bd31422$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $1cfc403e6bd31422$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($1cfc403e6bd31422$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join("");
        }
    }
};
module.exports = $1cfc403e6bd31422$var$charenc;

});

parcelRegister("bGeEO", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($880efc96c81d3d2c$var$isBuffer(obj) || $880efc96c81d3d2c$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $880efc96c81d3d2c$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $880efc96c81d3d2c$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && $880efc96c81d3d2c$var$isBuffer(obj.slice(0, 0));
}

});

parcelRegister("1BSKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c3b619deaae89e$export$2e2bcd8739ae039; });
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");

var $k9qks = parcelRequire("k9qks");
const $12c3b619deaae89e$var$postLog = (data = {
    level: "debug",
    message: "",
    data: {}
})=>{
    if (!(0, $k9qks.isInPlayer)) return;
    (0, $a7H8f.default).post("http://localhost:134/log", data, {
        headers: {
            "Content-Type": "application/json"
        }
    }).catch(console.log);
};
const $12c3b619deaae89e$var$Logger = {
    log: (message, data)=>$12c3b619deaae89e$var$postLog({
            level: "info",
            message: message,
            data: data
        }),
    info: (message, data)=>$12c3b619deaae89e$var$postLog({
            level: "info",
            message: message,
            data: data
        }),
    warn: (message, data)=>$12c3b619deaae89e$var$postLog({
            level: "warn",
            message: message,
            data: data
        }),
    debug: (message, data)=>$12c3b619deaae89e$var$postLog({
            level: "debug",
            message: message,
            data: data
        }),
    error: (message, data)=>$12c3b619deaae89e$var$postLog({
            level: "error",
            message: message,
            data: data
        })
};
var $12c3b619deaae89e$export$2e2bcd8739ae039 = $12c3b619deaae89e$var$Logger;

});
parcelRegister("WCAkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a7H8f")).default; });

var $a7H8f = parcelRequire("a7H8f");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $0b035914f4106136$export$1c00760e9e5a4e95, AxiosError: $0b035914f4106136$export$c1fbed17c2f6a328, CanceledError: $0b035914f4106136$export$1ab0c6b20d94fa14, isCancel: $0b035914f4106136$export$3b22524397b493c6, CancelToken: $0b035914f4106136$export$fd08e3cb425f0d61, VERSION: $0b035914f4106136$export$a4ad2735b021c132, all: $0b035914f4106136$export$84bf76cd7afc7469, Cancel: $0b035914f4106136$export$848c9b7ead0df967, isAxiosError: $0b035914f4106136$export$fbafdbe06a5b5a9a, spread: $0b035914f4106136$export$3ae0fd4797ed47c8, toFormData: $0b035914f4106136$export$10ae0d317ea97f8b, AxiosHeaders: $0b035914f4106136$export$4e7d6ff0f3e6520, HttpStatusCode: $0b035914f4106136$export$a972f69c851492b3, formToJSON: $0b035914f4106136$export$86d7c59254d6a2c9, getAdapter: $0b035914f4106136$export$17ddc20a97d669e2, mergeConfig: $0b035914f4106136$export$7ec1ebcfa9d8bd6a } = (0, $a7H8f.default);

});
parcelRegister("a7H8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ec03f3f42b7c3c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $g57dZ = parcelRequire("g57dZ");

var $6TkId = parcelRequire("6TkId");

var $8FHSN = parcelRequire("8FHSN");

var $kXg7s = parcelRequire("kXg7s");

var $kKGuv = parcelRequire("kKGuv");

var $lMpcA = parcelRequire("lMpcA");

var $5zLKY = parcelRequire("5zLKY");

var $kBQOk = parcelRequire("kBQOk");

var $ie3yz = parcelRequire("ie3yz");

var $DThbK = parcelRequire("DThbK");

var $9NE6H = parcelRequire("9NE6H");

var $dyoH1 = parcelRequire("dyoH1");

var $c7TGZ = parcelRequire("c7TGZ");

var $hdRGz = parcelRequire("hdRGz");

var $u7vyD = parcelRequire("u7vyD");

var $fTG9u = parcelRequire("fTG9u");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $75ec03f3f42b7c3c$var$createInstance(defaultConfig) {
    const context = new (0, $6TkId.default)(defaultConfig);
    const instance = (0, $g57dZ.default)((0, $6TkId.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3v50U.default).extend(instance, (0, $6TkId.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3v50U.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $75ec03f3f42b7c3c$var$createInstance((0, $8FHSN.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $75ec03f3f42b7c3c$var$axios = $75ec03f3f42b7c3c$var$createInstance((0, $kXg7s.default));
// Expose Axios class to allow class inheritance
$75ec03f3f42b7c3c$var$axios.Axios = (0, $6TkId.default);
// Expose Cancel & CancelToken
$75ec03f3f42b7c3c$var$axios.CanceledError = (0, $lMpcA.default);
$75ec03f3f42b7c3c$var$axios.CancelToken = (0, $5zLKY.default);
$75ec03f3f42b7c3c$var$axios.isCancel = (0, $kBQOk.default);
$75ec03f3f42b7c3c$var$axios.VERSION = (0, $ie3yz.VERSION);
$75ec03f3f42b7c3c$var$axios.toFormData = (0, $DThbK.default);
// Expose AxiosError class
$75ec03f3f42b7c3c$var$axios.AxiosError = (0, $9NE6H.default);
// alias for CanceledError for backward compatibility
$75ec03f3f42b7c3c$var$axios.Cancel = $75ec03f3f42b7c3c$var$axios.CanceledError;
// Expose all/spread
$75ec03f3f42b7c3c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$75ec03f3f42b7c3c$var$axios.spread = (0, $dyoH1.default);
// Expose isAxiosError
$75ec03f3f42b7c3c$var$axios.isAxiosError = (0, $c7TGZ.default);
// Expose mergeConfig
$75ec03f3f42b7c3c$var$axios.mergeConfig = (0, $8FHSN.default);
$75ec03f3f42b7c3c$var$axios.AxiosHeaders = (0, $hdRGz.default);
$75ec03f3f42b7c3c$var$axios.formToJSON = (thing)=>(0, $kKGuv.default)((0, $3v50U.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$75ec03f3f42b7c3c$var$axios.getAdapter = (0, $u7vyD.default).getAdapter;
$75ec03f3f42b7c3c$var$axios.HttpStatusCode = (0, $fTG9u.default);
$75ec03f3f42b7c3c$var$axios.default = $75ec03f3f42b7c3c$var$axios;
var // this module should only have a default export
$75ec03f3f42b7c3c$export$2e2bcd8739ae039 = $75ec03f3f42b7c3c$var$axios;

});
parcelRegister("3v50U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c827f505a43dbf$export$2e2bcd8739ae039; });

var $g57dZ = parcelRequire("g57dZ");

var $khNKv = parcelRequire("khNKv");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $28c827f505a43dbf$var$toString } = Object.prototype;
const { getPrototypeOf: $28c827f505a43dbf$var$getPrototypeOf } = Object;
const $28c827f505a43dbf$var$kindOf = ((cache)=>(thing)=>{
        const str = $28c827f505a43dbf$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $28c827f505a43dbf$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$28c827f505a43dbf$var$kindOf(thing) === type;
};
const $28c827f505a43dbf$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $28c827f505a43dbf$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $28c827f505a43dbf$var$isUndefined = $28c827f505a43dbf$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $28c827f505a43dbf$var$isBuffer(val) {
    return val !== null && !$28c827f505a43dbf$var$isUndefined(val) && val.constructor !== null && !$28c827f505a43dbf$var$isUndefined(val.constructor) && $28c827f505a43dbf$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $28c827f505a43dbf$var$isArrayBuffer = $28c827f505a43dbf$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $28c827f505a43dbf$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $28c827f505a43dbf$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $28c827f505a43dbf$var$isString = $28c827f505a43dbf$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $28c827f505a43dbf$var$isFunction = $28c827f505a43dbf$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $28c827f505a43dbf$var$isNumber = $28c827f505a43dbf$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $28c827f505a43dbf$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $28c827f505a43dbf$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $28c827f505a43dbf$var$isPlainObject = (val)=>{
    if ($28c827f505a43dbf$var$kindOf(val) !== "object") return false;
    const prototype = $28c827f505a43dbf$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $28c827f505a43dbf$var$isDate = $28c827f505a43dbf$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $28c827f505a43dbf$var$isFile = $28c827f505a43dbf$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $28c827f505a43dbf$var$isBlob = $28c827f505a43dbf$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $28c827f505a43dbf$var$isFileList = $28c827f505a43dbf$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $28c827f505a43dbf$var$isStream = (val)=>$28c827f505a43dbf$var$isObject(val) && $28c827f505a43dbf$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $28c827f505a43dbf$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $28c827f505a43dbf$var$isFunction(thing.append) && ((kind = $28c827f505a43dbf$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $28c827f505a43dbf$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $28c827f505a43dbf$var$isURLSearchParams = $28c827f505a43dbf$var$kindOfTest("URLSearchParams");
const [$28c827f505a43dbf$var$isReadableStream, $28c827f505a43dbf$var$isRequest, $28c827f505a43dbf$var$isResponse, $28c827f505a43dbf$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($28c827f505a43dbf$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $28c827f505a43dbf$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $28c827f505a43dbf$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($28c827f505a43dbf$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $28c827f505a43dbf$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $28c827f505a43dbf$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $28c827f505a43dbf$var$isContextDefined = (context)=>!$28c827f505a43dbf$var$isUndefined(context) && context !== $28c827f505a43dbf$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $28c827f505a43dbf$var$merge() {
    const { caseless: caseless } = $28c827f505a43dbf$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $28c827f505a43dbf$var$findKey(result, key) || key;
        if ($28c827f505a43dbf$var$isPlainObject(result[targetKey]) && $28c827f505a43dbf$var$isPlainObject(val)) result[targetKey] = $28c827f505a43dbf$var$merge(result[targetKey], val);
        else if ($28c827f505a43dbf$var$isPlainObject(val)) result[targetKey] = $28c827f505a43dbf$var$merge({}, val);
        else if ($28c827f505a43dbf$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $28c827f505a43dbf$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $28c827f505a43dbf$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $28c827f505a43dbf$var$forEach(b, (val, key)=>{
        if (thisArg && $28c827f505a43dbf$var$isFunction(val)) a[key] = (0, $g57dZ.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $28c827f505a43dbf$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $28c827f505a43dbf$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $28c827f505a43dbf$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $28c827f505a43dbf$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $28c827f505a43dbf$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $28c827f505a43dbf$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($28c827f505a43dbf$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$28c827f505a43dbf$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $28c827f505a43dbf$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $28c827f505a43dbf$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $28c827f505a43dbf$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $28c827f505a43dbf$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $28c827f505a43dbf$var$isHTMLForm = $28c827f505a43dbf$var$kindOfTest("HTMLFormElement");
const $28c827f505a43dbf$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $28c827f505a43dbf$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $28c827f505a43dbf$var$isRegExp = $28c827f505a43dbf$var$kindOfTest("RegExp");
const $28c827f505a43dbf$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $28c827f505a43dbf$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $28c827f505a43dbf$var$freezeMethods = (obj)=>{
    $28c827f505a43dbf$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($28c827f505a43dbf$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$28c827f505a43dbf$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $28c827f505a43dbf$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $28c827f505a43dbf$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $28c827f505a43dbf$var$noop = ()=>{};
const $28c827f505a43dbf$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $28c827f505a43dbf$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $28c827f505a43dbf$var$DIGIT = "0123456789";
const $28c827f505a43dbf$var$ALPHABET = {
    DIGIT: $28c827f505a43dbf$var$DIGIT,
    ALPHA: $28c827f505a43dbf$var$ALPHA,
    ALPHA_DIGIT: $28c827f505a43dbf$var$ALPHA + $28c827f505a43dbf$var$ALPHA.toUpperCase() + $28c827f505a43dbf$var$DIGIT
};
const $28c827f505a43dbf$var$generateString = (size = 16, alphabet = $28c827f505a43dbf$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $28c827f505a43dbf$var$isSpecCompliantForm(thing) {
    return !!(thing && $28c827f505a43dbf$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $28c827f505a43dbf$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($28c827f505a43dbf$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $28c827f505a43dbf$var$isArray(source) ? [] : {};
                $28c827f505a43dbf$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$28c827f505a43dbf$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $28c827f505a43dbf$var$isAsyncFn = $28c827f505a43dbf$var$kindOfTest("AsyncFunction");
const $28c827f505a43dbf$var$isThenable = (thing)=>thing && ($28c827f505a43dbf$var$isObject(thing) || $28c827f505a43dbf$var$isFunction(thing)) && $28c827f505a43dbf$var$isFunction(thing.then) && $28c827f505a43dbf$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $28c827f505a43dbf$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $28c827f505a43dbf$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $28c827f505a43dbf$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $28c827f505a43dbf$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $28c827f505a43dbf$var$isFunction($28c827f505a43dbf$var$_global.postMessage));
const $28c827f505a43dbf$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($28c827f505a43dbf$var$_global) : typeof $khNKv !== "undefined" && $khNKv.nextTick || $28c827f505a43dbf$var$_setImmediate;
var // *********************
$28c827f505a43dbf$export$2e2bcd8739ae039 = {
    isArray: $28c827f505a43dbf$var$isArray,
    isArrayBuffer: $28c827f505a43dbf$var$isArrayBuffer,
    isBuffer: $28c827f505a43dbf$var$isBuffer,
    isFormData: $28c827f505a43dbf$var$isFormData,
    isArrayBufferView: $28c827f505a43dbf$var$isArrayBufferView,
    isString: $28c827f505a43dbf$var$isString,
    isNumber: $28c827f505a43dbf$var$isNumber,
    isBoolean: $28c827f505a43dbf$var$isBoolean,
    isObject: $28c827f505a43dbf$var$isObject,
    isPlainObject: $28c827f505a43dbf$var$isPlainObject,
    isReadableStream: $28c827f505a43dbf$var$isReadableStream,
    isRequest: $28c827f505a43dbf$var$isRequest,
    isResponse: $28c827f505a43dbf$var$isResponse,
    isHeaders: $28c827f505a43dbf$var$isHeaders,
    isUndefined: $28c827f505a43dbf$var$isUndefined,
    isDate: $28c827f505a43dbf$var$isDate,
    isFile: $28c827f505a43dbf$var$isFile,
    isBlob: $28c827f505a43dbf$var$isBlob,
    isRegExp: $28c827f505a43dbf$var$isRegExp,
    isFunction: $28c827f505a43dbf$var$isFunction,
    isStream: $28c827f505a43dbf$var$isStream,
    isURLSearchParams: $28c827f505a43dbf$var$isURLSearchParams,
    isTypedArray: $28c827f505a43dbf$var$isTypedArray,
    isFileList: $28c827f505a43dbf$var$isFileList,
    forEach: $28c827f505a43dbf$var$forEach,
    merge: $28c827f505a43dbf$var$merge,
    extend: $28c827f505a43dbf$var$extend,
    trim: $28c827f505a43dbf$var$trim,
    stripBOM: $28c827f505a43dbf$var$stripBOM,
    inherits: $28c827f505a43dbf$var$inherits,
    toFlatObject: $28c827f505a43dbf$var$toFlatObject,
    kindOf: $28c827f505a43dbf$var$kindOf,
    kindOfTest: $28c827f505a43dbf$var$kindOfTest,
    endsWith: $28c827f505a43dbf$var$endsWith,
    toArray: $28c827f505a43dbf$var$toArray,
    forEachEntry: $28c827f505a43dbf$var$forEachEntry,
    matchAll: $28c827f505a43dbf$var$matchAll,
    isHTMLForm: $28c827f505a43dbf$var$isHTMLForm,
    hasOwnProperty: $28c827f505a43dbf$var$hasOwnProperty,
    hasOwnProp: $28c827f505a43dbf$var$hasOwnProperty,
    reduceDescriptors: $28c827f505a43dbf$var$reduceDescriptors,
    freezeMethods: $28c827f505a43dbf$var$freezeMethods,
    toObjectSet: $28c827f505a43dbf$var$toObjectSet,
    toCamelCase: $28c827f505a43dbf$var$toCamelCase,
    noop: $28c827f505a43dbf$var$noop,
    toFiniteNumber: $28c827f505a43dbf$var$toFiniteNumber,
    findKey: $28c827f505a43dbf$var$findKey,
    global: $28c827f505a43dbf$var$_global,
    isContextDefined: $28c827f505a43dbf$var$isContextDefined,
    ALPHABET: $28c827f505a43dbf$var$ALPHABET,
    generateString: $28c827f505a43dbf$var$generateString,
    isSpecCompliantForm: $28c827f505a43dbf$var$isSpecCompliantForm,
    toJSONObject: $28c827f505a43dbf$var$toJSONObject,
    isAsyncFn: $28c827f505a43dbf$var$isAsyncFn,
    isThenable: $28c827f505a43dbf$var$isThenable,
    setImmediate: $28c827f505a43dbf$var$_setImmediate,
    asap: $28c827f505a43dbf$var$asap
};

});
parcelRegister("g57dZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb52b79c31554adc$export$2e2bcd8739ae039; });
"use strict";
function $bb52b79c31554adc$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("6TkId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5047f21c521b531d$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $flOXD = parcelRequire("flOXD");

var $3oXSf = parcelRequire("3oXSf");

var $9aMTC = parcelRequire("9aMTC");

var $8FHSN = parcelRequire("8FHSN");

var $kSWF8 = parcelRequire("kSWF8");

var $2wmIW = parcelRequire("2wmIW");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
const $5047f21c521b531d$var$validators = (0, $2wmIW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $5047f21c521b531d$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $8FHSN.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2wmIW.default).assertOptions(transitional, {
            silentJSONParsing: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean),
            forcedJSONParsing: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean),
            clarifyTimeoutError: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $3v50U.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2wmIW.default).assertOptions(paramsSerializer, {
                encode: $5047f21c521b531d$var$validators.function,
                serialize: $5047f21c521b531d$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $3v50U.default).merge(headers.common, headers[config.method]);
        headers && (0, $3v50U.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $hdRGz.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9aMTC.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9aMTC.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $8FHSN.default)(this.defaults, config);
        const fullPath = (0, $kSWF8.default)(config.baseURL, config.url);
        return (0, $flOXD.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $3oXSf.default)(),
            response: new (0, $3oXSf.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $3v50U.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5047f21c521b531d$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $8FHSN.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $3v50U.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $8FHSN.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $5047f21c521b531d$var$Axios.prototype[method] = generateHTTPMethod();
    $5047f21c521b531d$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $5047f21c521b531d$export$2e2bcd8739ae039 = $5047f21c521b531d$var$Axios;

});
parcelRegister("flOXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2d058ef59ec0625$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $kivv9 = parcelRequire("kivv9");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $b2d058ef59ec0625$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $b2d058ef59ec0625$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $b2d058ef59ec0625$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $3v50U.default).isURLSearchParams(params) ? params.toString() : new (0, $kivv9.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("kivv9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6deca3f04bff0a$export$2e2bcd8739ae039; });

var $DThbK = parcelRequire("DThbK");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $ec6deca3f04bff0a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $ec6deca3f04bff0a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $DThbK.default)(params, this, options);
}
const $ec6deca3f04bff0a$var$prototype = $ec6deca3f04bff0a$var$AxiosURLSearchParams.prototype;
$ec6deca3f04bff0a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$ec6deca3f04bff0a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $ec6deca3f04bff0a$var$encode);
    } : $ec6deca3f04bff0a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $ec6deca3f04bff0a$export$2e2bcd8739ae039 = $ec6deca3f04bff0a$var$AxiosURLSearchParams;

});
parcelRegister("DThbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $077e855763e662bb$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $9ZtKp = parcelRequire("9ZtKp");

var $437dT = parcelRequire("437dT");
var $077e855763e662bb$require$Buffer = $437dT.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $077e855763e662bb$var$isVisitable(thing) {
    return (0, $3v50U.default).isPlainObject(thing) || (0, $3v50U.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $077e855763e662bb$var$removeBrackets(key) {
    return (0, $3v50U.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $077e855763e662bb$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $077e855763e662bb$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $077e855763e662bb$var$isFlatArray(arr) {
    return (0, $3v50U.default).isArray(arr) && !arr.some($077e855763e662bb$var$isVisitable);
}
const $077e855763e662bb$var$predicates = (0, $3v50U.default).toFlatObject((0, $3v50U.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $077e855763e662bb$var$toFormData(obj, formData, options) {
    if (!(0, $3v50U.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $9ZtKp.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $3v50U.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $3v50U.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $3v50U.default).isSpecCompliantForm(formData);
    if (!(0, $3v50U.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $3v50U.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $3v50U.default).isBlob(value)) throw new (0, $9NE6H.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $3v50U.default).isArrayBuffer(value) || (0, $3v50U.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $077e855763e662bb$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $3v50U.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $3v50U.default).isArray(value) && $077e855763e662bb$var$isFlatArray(value) || ((0, $3v50U.default).isFileList(value) || (0, $3v50U.default).endsWith(key, "[]")) && (arr = (0, $3v50U.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $077e855763e662bb$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3v50U.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $077e855763e662bb$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($077e855763e662bb$var$isVisitable(value)) return true;
        formData.append($077e855763e662bb$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($077e855763e662bb$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $077e855763e662bb$var$isVisitable
    });
    function build(value, path) {
        if ((0, $3v50U.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $3v50U.default).forEach(value, function each(el, key) {
            const result = !((0, $3v50U.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3v50U.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $3v50U.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $077e855763e662bb$export$2e2bcd8739ae039 = $077e855763e662bb$var$toFormData;

});
parcelRegister("9NE6H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7227cd0fd7e0dd2c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $7227cd0fd7e0dd2c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $3v50U.default).inherits($7227cd0fd7e0dd2c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $3v50U.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $7227cd0fd7e0dd2c$var$prototype = $7227cd0fd7e0dd2c$var$AxiosError.prototype;
const $7227cd0fd7e0dd2c$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $7227cd0fd7e0dd2c$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($7227cd0fd7e0dd2c$var$AxiosError, $7227cd0fd7e0dd2c$var$descriptors);
Object.defineProperty($7227cd0fd7e0dd2c$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$7227cd0fd7e0dd2c$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($7227cd0fd7e0dd2c$var$prototype);
    (0, $3v50U.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $7227cd0fd7e0dd2c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $7227cd0fd7e0dd2c$export$2e2bcd8739ae039 = $7227cd0fd7e0dd2c$var$AxiosError;

});

parcelRegister("9ZtKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7460e2c89bd4d79e$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $7460e2c89bd4d79e$export$2e2bcd8739ae039 = null;

});

parcelRegister("437dT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $2f2d0b949a472f04$export$a143d493d941bafc; }, function (v) { return $2f2d0b949a472f04$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $2f2d0b949a472f04$export$f99ded8fe4b79145; }, function (v) { return $2f2d0b949a472f04$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $2f2d0b949a472f04$export$a143d493d941bafc;
var $2f2d0b949a472f04$export$e4cf37d7f6fb9e0a;
var $2f2d0b949a472f04$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $2f2d0b949a472f04$export$599f31c3813fae4d;
"use strict";

var $7Yc3h = parcelRequire("7Yc3h");

var $khZcF = parcelRequire("khZcF");

var $fENvJ = parcelRequire("fENvJ");
$2f2d0b949a472f04$export$a143d493d941bafc = $2f2d0b949a472f04$var$Buffer;
$2f2d0b949a472f04$export$e4cf37d7f6fb9e0a = $2f2d0b949a472f04$var$SlowBuffer;
$2f2d0b949a472f04$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $2f2d0b949a472f04$var$typedArraySupport();
$2f2d0b949a472f04$export$599f31c3813fae4d = $2f2d0b949a472f04$var$kMaxLength();
function $2f2d0b949a472f04$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $2f2d0b949a472f04$var$kMaxLength() {
    return $2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $2f2d0b949a472f04$var$createBuffer(that, length) {
    if ($2f2d0b949a472f04$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $2f2d0b949a472f04$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $2f2d0b949a472f04$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2f2d0b949a472f04$var$Buffer(arg, encodingOrOffset, length) {
    if (!$2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $2f2d0b949a472f04$var$Buffer)) return new $2f2d0b949a472f04$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $2f2d0b949a472f04$var$allocUnsafe(this, arg);
    }
    return $2f2d0b949a472f04$var$from(this, arg, encodingOrOffset, length);
}
$2f2d0b949a472f04$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$2f2d0b949a472f04$var$Buffer._augment = function(arr) {
    arr.__proto__ = $2f2d0b949a472f04$var$Buffer.prototype;
    return arr;
};
function $2f2d0b949a472f04$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $2f2d0b949a472f04$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $2f2d0b949a472f04$var$fromString(that, value, encodingOrOffset);
    return $2f2d0b949a472f04$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2f2d0b949a472f04$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2f2d0b949a472f04$var$from(null, value, encodingOrOffset, length);
};
if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $2f2d0b949a472f04$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $2f2d0b949a472f04$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $2f2d0b949a472f04$var$Buffer[Symbol.species] === $2f2d0b949a472f04$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($2f2d0b949a472f04$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $2f2d0b949a472f04$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $2f2d0b949a472f04$var$alloc(that, size, fill, encoding) {
    $2f2d0b949a472f04$var$assertSize(size);
    if (size <= 0) return $2f2d0b949a472f04$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $2f2d0b949a472f04$var$createBuffer(that, size).fill(fill, encoding) : $2f2d0b949a472f04$var$createBuffer(that, size).fill(fill);
    return $2f2d0b949a472f04$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2f2d0b949a472f04$var$Buffer.alloc = function(size, fill, encoding) {
    return $2f2d0b949a472f04$var$alloc(null, size, fill, encoding);
};
function $2f2d0b949a472f04$var$allocUnsafe(that, size) {
    $2f2d0b949a472f04$var$assertSize(size);
    that = $2f2d0b949a472f04$var$createBuffer(that, size < 0 ? 0 : $2f2d0b949a472f04$var$checked(size) | 0);
    if (!$2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2f2d0b949a472f04$var$Buffer.allocUnsafe = function(size) {
    return $2f2d0b949a472f04$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2f2d0b949a472f04$var$Buffer.allocUnsafeSlow = function(size) {
    return $2f2d0b949a472f04$var$allocUnsafe(null, size);
};
function $2f2d0b949a472f04$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$2f2d0b949a472f04$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $2f2d0b949a472f04$var$byteLength(string, encoding) | 0;
    that = $2f2d0b949a472f04$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $2f2d0b949a472f04$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $2f2d0b949a472f04$var$checked(array.length) | 0;
    that = $2f2d0b949a472f04$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $2f2d0b949a472f04$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $2f2d0b949a472f04$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $2f2d0b949a472f04$var$fromArrayLike(that, array);
    return that;
}
function $2f2d0b949a472f04$var$fromObject(that, obj) {
    if ($2f2d0b949a472f04$var$Buffer.isBuffer(obj)) {
        var len = $2f2d0b949a472f04$var$checked(obj.length) | 0;
        that = $2f2d0b949a472f04$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $2f2d0b949a472f04$var$isnan(obj.length)) return $2f2d0b949a472f04$var$createBuffer(that, 0);
            return $2f2d0b949a472f04$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $fENvJ(obj.data)) return $2f2d0b949a472f04$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $2f2d0b949a472f04$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2f2d0b949a472f04$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2f2d0b949a472f04$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $2f2d0b949a472f04$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2f2d0b949a472f04$var$Buffer.alloc(+length);
}
$2f2d0b949a472f04$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$2f2d0b949a472f04$var$Buffer.compare = function compare(a, b) {
    if (!$2f2d0b949a472f04$var$Buffer.isBuffer(a) || !$2f2d0b949a472f04$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2f2d0b949a472f04$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$2f2d0b949a472f04$var$Buffer.concat = function concat(list, length) {
    if (!$fENvJ(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2f2d0b949a472f04$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $2f2d0b949a472f04$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$2f2d0b949a472f04$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2f2d0b949a472f04$var$byteLength(string, encoding) {
    if ($2f2d0b949a472f04$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $2f2d0b949a472f04$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $2f2d0b949a472f04$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $2f2d0b949a472f04$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2f2d0b949a472f04$var$Buffer.byteLength = $2f2d0b949a472f04$var$byteLength;
function $2f2d0b949a472f04$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $2f2d0b949a472f04$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $2f2d0b949a472f04$var$utf8Slice(this, start, end);
        case "ascii":
            return $2f2d0b949a472f04$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $2f2d0b949a472f04$var$latin1Slice(this, start, end);
        case "base64":
            return $2f2d0b949a472f04$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $2f2d0b949a472f04$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$2f2d0b949a472f04$var$Buffer.prototype._isBuffer = true;
function $2f2d0b949a472f04$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2f2d0b949a472f04$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$2f2d0b949a472f04$var$swap(this, i, i + 1);
    return this;
};
$2f2d0b949a472f04$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $2f2d0b949a472f04$var$swap(this, i, i + 3);
        $2f2d0b949a472f04$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2f2d0b949a472f04$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $2f2d0b949a472f04$var$swap(this, i, i + 7);
        $2f2d0b949a472f04$var$swap(this, i + 1, i + 6);
        $2f2d0b949a472f04$var$swap(this, i + 2, i + 5);
        $2f2d0b949a472f04$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2f2d0b949a472f04$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $2f2d0b949a472f04$var$utf8Slice(this, 0, length);
    return $2f2d0b949a472f04$var$slowToString.apply(this, arguments);
};
$2f2d0b949a472f04$var$Buffer.prototype.equals = function equals(b) {
    if (!$2f2d0b949a472f04$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $2f2d0b949a472f04$var$Buffer.compare(this, b) === 0;
};
$2f2d0b949a472f04$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $2f2d0b949a472f04$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$2f2d0b949a472f04$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$2f2d0b949a472f04$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2f2d0b949a472f04$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $2f2d0b949a472f04$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2f2d0b949a472f04$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2f2d0b949a472f04$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2f2d0b949a472f04$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $2f2d0b949a472f04$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2f2d0b949a472f04$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2f2d0b949a472f04$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2f2d0b949a472f04$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2f2d0b949a472f04$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2f2d0b949a472f04$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2f2d0b949a472f04$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2f2d0b949a472f04$var$utf8Write(buf, string, offset, length) {
    return $2f2d0b949a472f04$var$blitBuffer($2f2d0b949a472f04$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2f2d0b949a472f04$var$asciiWrite(buf, string, offset, length) {
    return $2f2d0b949a472f04$var$blitBuffer($2f2d0b949a472f04$var$asciiToBytes(string), buf, offset, length);
}
function $2f2d0b949a472f04$var$latin1Write(buf, string, offset, length) {
    return $2f2d0b949a472f04$var$asciiWrite(buf, string, offset, length);
}
function $2f2d0b949a472f04$var$base64Write(buf, string, offset, length) {
    return $2f2d0b949a472f04$var$blitBuffer($2f2d0b949a472f04$var$base64ToBytes(string), buf, offset, length);
}
function $2f2d0b949a472f04$var$ucs2Write(buf, string, offset, length) {
    return $2f2d0b949a472f04$var$blitBuffer($2f2d0b949a472f04$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2f2d0b949a472f04$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $2f2d0b949a472f04$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $2f2d0b949a472f04$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $2f2d0b949a472f04$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $2f2d0b949a472f04$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $2f2d0b949a472f04$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $2f2d0b949a472f04$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2f2d0b949a472f04$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2f2d0b949a472f04$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7Yc3h.fromByteArray(buf);
    else return $7Yc3h.fromByteArray(buf.slice(start, end));
}
function $2f2d0b949a472f04$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2f2d0b949a472f04$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $2f2d0b949a472f04$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2f2d0b949a472f04$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $2f2d0b949a472f04$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2f2d0b949a472f04$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2f2d0b949a472f04$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2f2d0b949a472f04$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2f2d0b949a472f04$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $2f2d0b949a472f04$var$toHex(buf[i]);
    return out;
}
function $2f2d0b949a472f04$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2f2d0b949a472f04$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $2f2d0b949a472f04$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $2f2d0b949a472f04$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2f2d0b949a472f04$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$2f2d0b949a472f04$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2f2d0b949a472f04$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2f2d0b949a472f04$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2f2d0b949a472f04$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2f2d0b949a472f04$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2f2d0b949a472f04$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2f2d0b949a472f04$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f2d0b949a472f04$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2f2d0b949a472f04$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2f2d0b949a472f04$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return $khZcF.read(this, offset, true, 23, 4);
};
$2f2d0b949a472f04$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 4, this.length);
    return $khZcF.read(this, offset, false, 23, 4);
};
$2f2d0b949a472f04$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 8, this.length);
    return $khZcF.read(this, offset, true, 52, 8);
};
$2f2d0b949a472f04$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkOffset(offset, 8, this.length);
    return $khZcF.read(this, offset, false, 52, 8);
};
function $2f2d0b949a472f04$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2f2d0b949a472f04$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$2f2d0b949a472f04$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f2d0b949a472f04$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f2d0b949a472f04$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $2f2d0b949a472f04$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$2f2d0b949a472f04$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $2f2d0b949a472f04$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $2f2d0b949a472f04$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $2f2d0b949a472f04$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$2f2d0b949a472f04$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $2f2d0b949a472f04$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $2f2d0b949a472f04$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $2f2d0b949a472f04$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $2f2d0b949a472f04$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $2f2d0b949a472f04$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $2f2d0b949a472f04$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $2f2d0b949a472f04$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$2f2d0b949a472f04$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $2f2d0b949a472f04$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $2f2d0b949a472f04$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $2f2d0b949a472f04$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $2f2d0b949a472f04$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $khZcF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2f2d0b949a472f04$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2f2d0b949a472f04$var$writeFloat(this, value, offset, true, noAssert);
};
$2f2d0b949a472f04$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2f2d0b949a472f04$var$writeFloat(this, value, offset, false, noAssert);
};
function $2f2d0b949a472f04$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $2f2d0b949a472f04$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $khZcF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2f2d0b949a472f04$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2f2d0b949a472f04$var$writeDouble(this, value, offset, true, noAssert);
};
$2f2d0b949a472f04$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2f2d0b949a472f04$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2f2d0b949a472f04$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$2f2d0b949a472f04$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2f2d0b949a472f04$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$2f2d0b949a472f04$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $2f2d0b949a472f04$var$Buffer.isBuffer(val) ? val : $2f2d0b949a472f04$var$utf8ToBytes(new $2f2d0b949a472f04$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $2f2d0b949a472f04$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $2f2d0b949a472f04$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $2f2d0b949a472f04$var$stringtrim(str).replace($2f2d0b949a472f04$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $2f2d0b949a472f04$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $2f2d0b949a472f04$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $2f2d0b949a472f04$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $2f2d0b949a472f04$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2f2d0b949a472f04$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2f2d0b949a472f04$var$base64ToBytes(str) {
    return $7Yc3h.toByteArray($2f2d0b949a472f04$var$base64clean(str));
}
function $2f2d0b949a472f04$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $2f2d0b949a472f04$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("7Yc3h", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5cd77c3c3797fc79$export$d622b2ad8d90c771; }, function (v) { return $5cd77c3c3797fc79$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5cd77c3c3797fc79$export$6100ba28696e12de; }, function (v) { return $5cd77c3c3797fc79$export$6100ba28696e12de = v; });
var $5cd77c3c3797fc79$export$a48f0734ac7c2329;
var $5cd77c3c3797fc79$export$d622b2ad8d90c771;
var $5cd77c3c3797fc79$export$6100ba28696e12de;
"use strict";
$5cd77c3c3797fc79$export$a48f0734ac7c2329 = $5cd77c3c3797fc79$var$byteLength;
$5cd77c3c3797fc79$export$d622b2ad8d90c771 = $5cd77c3c3797fc79$var$toByteArray;
$5cd77c3c3797fc79$export$6100ba28696e12de = $5cd77c3c3797fc79$var$fromByteArray;
var $5cd77c3c3797fc79$var$lookup = [];
var $5cd77c3c3797fc79$var$revLookup = [];
var $5cd77c3c3797fc79$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5cd77c3c3797fc79$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5cd77c3c3797fc79$var$i = 0, $5cd77c3c3797fc79$var$len = $5cd77c3c3797fc79$var$code.length; $5cd77c3c3797fc79$var$i < $5cd77c3c3797fc79$var$len; ++$5cd77c3c3797fc79$var$i){
    $5cd77c3c3797fc79$var$lookup[$5cd77c3c3797fc79$var$i] = $5cd77c3c3797fc79$var$code[$5cd77c3c3797fc79$var$i];
    $5cd77c3c3797fc79$var$revLookup[$5cd77c3c3797fc79$var$code.charCodeAt($5cd77c3c3797fc79$var$i)] = $5cd77c3c3797fc79$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5cd77c3c3797fc79$var$revLookup["-".charCodeAt(0)] = 62;
$5cd77c3c3797fc79$var$revLookup["_".charCodeAt(0)] = 63;
function $5cd77c3c3797fc79$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5cd77c3c3797fc79$var$byteLength(b64) {
    var lens = $5cd77c3c3797fc79$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5cd77c3c3797fc79$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5cd77c3c3797fc79$var$toByteArray(b64) {
    var tmp;
    var lens = $5cd77c3c3797fc79$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5cd77c3c3797fc79$var$Arr($5cd77c3c3797fc79$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i)] << 18 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i)] << 2 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i)] << 10 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5cd77c3c3797fc79$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5cd77c3c3797fc79$var$tripletToBase64(num) {
    return $5cd77c3c3797fc79$var$lookup[num >> 18 & 0x3F] + $5cd77c3c3797fc79$var$lookup[num >> 12 & 0x3F] + $5cd77c3c3797fc79$var$lookup[num >> 6 & 0x3F] + $5cd77c3c3797fc79$var$lookup[num & 0x3F];
}
function $5cd77c3c3797fc79$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5cd77c3c3797fc79$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5cd77c3c3797fc79$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5cd77c3c3797fc79$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5cd77c3c3797fc79$var$lookup[tmp >> 2] + $5cd77c3c3797fc79$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5cd77c3c3797fc79$var$lookup[tmp >> 10] + $5cd77c3c3797fc79$var$lookup[tmp >> 4 & 0x3F] + $5cd77c3c3797fc79$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("khZcF", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $ec54dee44fc3cb6b$export$aafa59e2e03f2942; }, function (v) { return $ec54dee44fc3cb6b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $ec54dee44fc3cb6b$export$68d8715fc104d294; }, function (v) { return $ec54dee44fc3cb6b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ec54dee44fc3cb6b$export$aafa59e2e03f2942;
var $ec54dee44fc3cb6b$export$68d8715fc104d294;
$ec54dee44fc3cb6b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ec54dee44fc3cb6b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRegister("fENvJ", function(module, exports) {
var $b660ff47802cf98d$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $b660ff47802cf98d$var$toString.call(arr) == "[object Array]";
};

});





parcelRegister("3oXSf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a20eb58aa5e62a$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
class $27a20eb58aa5e62a$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $3v50U.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $27a20eb58aa5e62a$export$2e2bcd8739ae039 = $27a20eb58aa5e62a$var$InterceptorManager;

});

parcelRegister("9aMTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6adaf9f3d041815a$export$2e2bcd8739ae039; });

var $3V8y5 = parcelRequire("3V8y5");

var $kBQOk = parcelRequire("kBQOk");

var $kXg7s = parcelRequire("kXg7s");

var $lMpcA = parcelRequire("lMpcA");

var $hdRGz = parcelRequire("hdRGz");

var $u7vyD = parcelRequire("u7vyD");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $6adaf9f3d041815a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $lMpcA.default)(null, config);
}
function $6adaf9f3d041815a$export$2e2bcd8739ae039(config) {
    $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
    config.headers = (0, $hdRGz.default).from(config.headers);
    // Transform request data
    config.data = (0, $3V8y5.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $u7vyD.default).getAdapter(config.adapter || (0, $kXg7s.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $3V8y5.default).call(config, config.transformResponse, response);
        response.headers = (0, $hdRGz.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $kBQOk.default)(reason)) {
            $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $3V8y5.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $hdRGz.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("3V8y5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dad5395bbfc09d9$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $kXg7s = parcelRequire("kXg7s");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
function $2dad5395bbfc09d9$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $kXg7s.default);
    const context = response || config;
    const headers = (0, $hdRGz.default).from(context.headers);
    let data = context.data;
    (0, $3v50U.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("kXg7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f415d24cc60d6449$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $i6Q6y = parcelRequire("i6Q6y");

var $DThbK = parcelRequire("DThbK");

var $5DJ2h = parcelRequire("5DJ2h");

var $7d3hU = parcelRequire("7d3hU");

var $kKGuv = parcelRequire("kKGuv");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f415d24cc60d6449$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3v50U.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3v50U.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f415d24cc60d6449$var$defaults = {
    transitional: (0, $i6Q6y.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $3v50U.default).isObject(data);
            if (isObjectPayload && (0, $3v50U.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $3v50U.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $kKGuv.default)(data)) : data;
            if ((0, $3v50U.default).isArrayBuffer(data) || (0, $3v50U.default).isBuffer(data) || (0, $3v50U.default).isStream(data) || (0, $3v50U.default).isFile(data) || (0, $3v50U.default).isBlob(data) || (0, $3v50U.default).isReadableStream(data)) return data;
            if ((0, $3v50U.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $3v50U.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $5DJ2h.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $3v50U.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $DThbK.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f415d24cc60d6449$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f415d24cc60d6449$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $3v50U.default).isResponse(data) || (0, $3v50U.default).isReadableStream(data)) return data;
            if (data && (0, $3v50U.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $9NE6H.default).from(e, (0, $9NE6H.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7d3hU.default).classes.FormData,
        Blob: (0, $7d3hU.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $3v50U.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f415d24cc60d6449$var$defaults.headers[method] = {};
});
var $f415d24cc60d6449$export$2e2bcd8739ae039 = $f415d24cc60d6449$var$defaults;

});
parcelRegister("i6Q6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2f1346fa5b7b03b$export$2e2bcd8739ae039; });
"use strict";
var $d2f1346fa5b7b03b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("5DJ2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b38772a4e1a80a$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $DThbK = parcelRequire("DThbK");

var $7d3hU = parcelRequire("7d3hU");
"use strict";
function $41b38772a4e1a80a$export$2e2bcd8739ae039(data, options) {
    return (0, $DThbK.default)(data, new (0, $7d3hU.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7d3hU.default).isNode && (0, $3v50U.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("7d3hU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53fc4c36fbcb255f$export$2e2bcd8739ae039; });

var $jCEAt = parcelRequire("jCEAt");

var $apNCA = parcelRequire("apNCA");
var $53fc4c36fbcb255f$export$2e2bcd8739ae039 = {
    ...$apNCA,
    ...(0, $jCEAt.default)
};

});
parcelRegister("jCEAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4910cb750aa2caa$export$2e2bcd8739ae039; });

var $2ft8D = parcelRequire("2ft8D");

var $12SIP = parcelRequire("12SIP");

var $bd05w = parcelRequire("bd05w");
var $e4910cb750aa2caa$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $2ft8D.default,
        FormData: $12SIP.default,
        Blob: $bd05w.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("2ft8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3395c1f6b69cf4$export$2e2bcd8739ae039; });

var $kivv9 = parcelRequire("kivv9");
"use strict";
var $1a3395c1f6b69cf4$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $kivv9.default);

});

parcelRegister("12SIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c306d026dd009a7$export$2e2bcd8739ae039; });
"use strict";
var $0c306d026dd009a7$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("bd05w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8290fa15a267d616$export$2e2bcd8739ae039; });
"use strict";
var $8290fa15a267d616$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("apNCA", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $7952baef442d2e59$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $7952baef442d2e59$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $7952baef442d2e59$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $7952baef442d2e59$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $7952baef442d2e59$export$f710a83a91838a36; });
const $7952baef442d2e59$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $7952baef442d2e59$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $7952baef442d2e59$export$c0bcc9250309d66 = $7952baef442d2e59$export$c4996c4b7b93b0bf && (!$7952baef442d2e59$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($7952baef442d2e59$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $7952baef442d2e59$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $7952baef442d2e59$export$f710a83a91838a36 = $7952baef442d2e59$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("kKGuv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b9105b11fc0a07$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $f1b9105b11fc0a07$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $3v50U.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $f1b9105b11fc0a07$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $f1b9105b11fc0a07$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $3v50U.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3v50U.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $3v50U.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $3v50U.default).isArray(target[name])) target[name] = $f1b9105b11fc0a07$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3v50U.default).isFormData(formData) && (0, $3v50U.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $3v50U.default).forEachEntry(formData, (name, value)=>{
            buildPath($f1b9105b11fc0a07$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $f1b9105b11fc0a07$export$2e2bcd8739ae039 = $f1b9105b11fc0a07$var$formDataToJSON;

});


parcelRegister("hdRGz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c89d4b6c235d293e$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $jtNGc = parcelRequire("jtNGc");
"use strict";
const $c89d4b6c235d293e$var$$internals = Symbol("internals");
function $c89d4b6c235d293e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c89d4b6c235d293e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3v50U.default).isArray(value) ? value.map($c89d4b6c235d293e$var$normalizeValue) : String(value);
}
function $c89d4b6c235d293e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c89d4b6c235d293e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c89d4b6c235d293e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3v50U.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3v50U.default).isString(value)) return;
    if ((0, $3v50U.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3v50U.default).isRegExp(filter)) return filter.test(value);
}
function $c89d4b6c235d293e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c89d4b6c235d293e$var$buildAccessors(obj, header) {
    const accessorName = (0, $3v50U.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c89d4b6c235d293e$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $3v50U.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c89d4b6c235d293e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $3v50U.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $3v50U.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $3v50U.default).isString(header) && (header = header.trim()) && !$c89d4b6c235d293e$var$isValidHeaderName(header)) setHeaders((0, $jtNGc.default)(header), valueOrRewrite);
        else if ((0, $3v50U.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c89d4b6c235d293e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3v50U.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c89d4b6c235d293e$var$parseTokens(value);
                if ((0, $3v50U.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $3v50U.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c89d4b6c235d293e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3v50U.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $3v50U.default).findKey(self, _header);
                if (key && (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $3v50U.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $3v50U.default).forEach(this, (value, header)=>{
            const key = (0, $3v50U.default).findKey(headers, header);
            if (key) {
                self[key] = $c89d4b6c235d293e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c89d4b6c235d293e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c89d4b6c235d293e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $3v50U.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $3v50U.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c89d4b6c235d293e$var$$internals] = this[$c89d4b6c235d293e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c89d4b6c235d293e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $3v50U.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c89d4b6c235d293e$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $3v50U.default).reduceDescriptors($c89d4b6c235d293e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3v50U.default).freezeMethods($c89d4b6c235d293e$var$AxiosHeaders);
var $c89d4b6c235d293e$export$2e2bcd8739ae039 = $c89d4b6c235d293e$var$AxiosHeaders;

});
parcelRegister("jtNGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e7431247a6cf7c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $e2e7431247a6cf7c$var$ignoreDuplicateOf = (0, $3v50U.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $e2e7431247a6cf7c$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $e2e7431247a6cf7c$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("kBQOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0103a75c7439fbd$export$2e2bcd8739ae039; });
"use strict";
function $f0103a75c7439fbd$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("lMpcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb1a13da6a986b4$export$2e2bcd8739ae039; });

var $9NE6H = parcelRequire("9NE6H");

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $fdb1a13da6a986b4$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $9NE6H.default).call(this, message == null ? "canceled" : message, (0, $9NE6H.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $3v50U.default).inherits($fdb1a13da6a986b4$var$CanceledError, (0, $9NE6H.default), {
    __CANCEL__: true
});
var $fdb1a13da6a986b4$export$2e2bcd8739ae039 = $fdb1a13da6a986b4$var$CanceledError;

});

parcelRegister("u7vyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a8a0634cdb1446$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9ZtKp = parcelRequire("9ZtKp");

var $kE5AP = parcelRequire("kE5AP");

var $hYrZb = parcelRequire("hYrZb");

var $9NE6H = parcelRequire("9NE6H");
const $05a8a0634cdb1446$var$knownAdapters = {
    http: (0, $9ZtKp.default),
    xhr: (0, $kE5AP.default),
    fetch: (0, $hYrZb.default)
};
(0, $3v50U.default).forEach($05a8a0634cdb1446$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $05a8a0634cdb1446$var$renderReason = (reason)=>`- ${reason}`;
const $05a8a0634cdb1446$var$isResolvedHandle = (adapter)=>(0, $3v50U.default).isFunction(adapter) || adapter === null || adapter === false;
var $05a8a0634cdb1446$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $3v50U.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$05a8a0634cdb1446$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $05a8a0634cdb1446$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $9NE6H.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($05a8a0634cdb1446$var$renderReason).join("\n") : " " + $05a8a0634cdb1446$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $9NE6H.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $05a8a0634cdb1446$var$knownAdapters
};

});
parcelRegister("kE5AP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f07be1c0aa864c09$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $gn43Q = parcelRequire("gn43Q");

var $i6Q6y = parcelRequire("i6Q6y");

var $9NE6H = parcelRequire("9NE6H");

var $lMpcA = parcelRequire("lMpcA");

var $goOIP = parcelRequire("goOIP");

var $7d3hU = parcelRequire("7d3hU");

var $hdRGz = parcelRequire("hdRGz");

var $5Unwm = parcelRequire("5Unwm");

var $l5Miv = parcelRequire("l5Miv");
const $f07be1c0aa864c09$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $f07be1c0aa864c09$export$2e2bcd8739ae039 = $f07be1c0aa864c09$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $l5Miv.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $hdRGz.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $hdRGz.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gn43Q.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $9NE6H.default)("Request aborted", (0, $9NE6H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $9NE6H.default)("Network Error", (0, $9NE6H.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $i6Q6y.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $9NE6H.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $9NE6H.default).ETIMEDOUT : (0, $9NE6H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $3v50U.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3v50U.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $5Unwm.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $5Unwm.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $lMpcA.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $goOIP.default)(_config.url);
        if (protocol && (0, $7d3hU.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $9NE6H.default)("Unsupported protocol " + protocol + ":", (0, $9NE6H.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gn43Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beb1f1c215096f3a$export$2e2bcd8739ae039; });

var $9NE6H = parcelRequire("9NE6H");
"use strict";
function $beb1f1c215096f3a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $9NE6H.default)("Request failed with status code " + response.status, [
        (0, $9NE6H.default).ERR_BAD_REQUEST,
        (0, $9NE6H.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("goOIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf063b8e669a2e39$export$2e2bcd8739ae039; });
"use strict";
function $bf063b8e669a2e39$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("5Unwm", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $44d46d7c6f14494c$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $44d46d7c6f14494c$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $44d46d7c6f14494c$export$5d35863c355a22a9; });

var $ewQkV = parcelRequire("ewQkV");

var $7T2Jh = parcelRequire("7T2Jh");

var $3v50U = parcelRequire("3v50U");
const $44d46d7c6f14494c$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $ewQkV.default)(50, 250);
    return (0, $7T2Jh.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $44d46d7c6f14494c$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $44d46d7c6f14494c$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $3v50U.default).asap(()=>fn(...args));

});
parcelRegister("ewQkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93ca6c3363686fc$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a93ca6c3363686fc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a93ca6c3363686fc$export$2e2bcd8739ae039 = $a93ca6c3363686fc$var$speedometer;

});

parcelRegister("7T2Jh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bdfc973d1d99d71$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5bdfc973d1d99d71$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5bdfc973d1d99d71$export$2e2bcd8739ae039 = $5bdfc973d1d99d71$var$throttle;

});


parcelRegister("l5Miv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5af87764c538378$export$2e2bcd8739ae039; });

var $7d3hU = parcelRequire("7d3hU");

var $3v50U = parcelRequire("3v50U");

var $i9umf = parcelRequire("i9umf");

var $4aeNs = parcelRequire("4aeNs");

var $kSWF8 = parcelRequire("kSWF8");

var $8FHSN = parcelRequire("8FHSN");

var $hdRGz = parcelRequire("hdRGz");

var $flOXD = parcelRequire("flOXD");
var $f5af87764c538378$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $8FHSN.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $hdRGz.default).from(headers);
    newConfig.url = (0, $flOXD.default)((0, $kSWF8.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $3v50U.default).isFormData(data)) {
        if ((0, $7d3hU.default).hasStandardBrowserEnv || (0, $7d3hU.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7d3hU.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $3v50U.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $i9umf.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4aeNs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("i9umf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3709dafab5b3d77$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $7d3hU = parcelRequire("7d3hU");
"use strict";
var $d3709dafab5b3d77$export$2e2bcd8739ae039 = (0, $7d3hU.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $7d3hU.default).navigator && /(msie|trident)/i.test((0, $7d3hU.default).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $3v50U.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("4aeNs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308392efe60e2164$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $7d3hU = parcelRequire("7d3hU");
var $308392efe60e2164$export$2e2bcd8739ae039 = (0, $7d3hU.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $3v50U.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $3v50U.default).isString(path) && cookie.push("path=" + path);
        (0, $3v50U.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("kSWF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3465af50e9c02a0$export$2e2bcd8739ae039; });

var $fS9SV = parcelRequire("fS9SV");

var $18LNB = parcelRequire("18LNB");
"use strict";
function $f3465af50e9c02a0$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $fS9SV.default)(requestedURL)) return (0, $18LNB.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("fS9SV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8e3911595ee8d46$export$2e2bcd8739ae039; });
"use strict";
function $b8e3911595ee8d46$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("18LNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d4b9db04d517e80$export$2e2bcd8739ae039; });
"use strict";
function $0d4b9db04d517e80$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("8FHSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65043143de50ffea$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
const $65043143de50ffea$var$headersToObject = (thing)=>thing instanceof (0, $hdRGz.default) ? {
        ...thing
    } : thing;
function $65043143de50ffea$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $3v50U.default).isPlainObject(target) && (0, $3v50U.default).isPlainObject(source)) return (0, $3v50U.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3v50U.default).isPlainObject(source)) return (0, $3v50U.default).merge({}, source);
        else if ((0, $3v50U.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $3v50U.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3v50U.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($65043143de50ffea$var$headersToObject(a), $65043143de50ffea$var$headersToObject(b), true)
    };
    (0, $3v50U.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $3v50U.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("hYrZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d15dbfa5975cd945$export$2e2bcd8739ae039; });

var $7d3hU = parcelRequire("7d3hU");

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $8dHIy = parcelRequire("8dHIy");

var $gtTC9 = parcelRequire("gtTC9");

var $hdRGz = parcelRequire("hdRGz");

var $5Unwm = parcelRequire("5Unwm");

var $l5Miv = parcelRequire("l5Miv");

var $gn43Q = parcelRequire("gn43Q");
const $d15dbfa5975cd945$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $d15dbfa5975cd945$var$isReadableStreamSupported = $d15dbfa5975cd945$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $d15dbfa5975cd945$var$encodeText = $d15dbfa5975cd945$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $d15dbfa5975cd945$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $d15dbfa5975cd945$var$supportsRequestStream = $d15dbfa5975cd945$var$isReadableStreamSupported && $d15dbfa5975cd945$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $7d3hU.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE = 65536;
const $d15dbfa5975cd945$var$supportsResponseStream = $d15dbfa5975cd945$var$isReadableStreamSupported && $d15dbfa5975cd945$var$test(()=>(0, $3v50U.default).isReadableStream(new Response("").body));
const $d15dbfa5975cd945$var$resolvers = {
    stream: $d15dbfa5975cd945$var$supportsResponseStream && ((res)=>res.body)
};
$d15dbfa5975cd945$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$d15dbfa5975cd945$var$resolvers[type] && ($d15dbfa5975cd945$var$resolvers[type] = (0, $3v50U.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $9NE6H.default)(`Response type '${type}' is not supported`, (0, $9NE6H.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $d15dbfa5975cd945$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $3v50U.default).isBlob(body)) return body.size;
    if ((0, $3v50U.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $7d3hU.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $3v50U.default).isArrayBufferView(body) || (0, $3v50U.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $3v50U.default).isURLSearchParams(body)) body = body + "";
    if ((0, $3v50U.default).isString(body)) return (await $d15dbfa5975cd945$var$encodeText(body)).byteLength;
};
const $d15dbfa5975cd945$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $3v50U.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $d15dbfa5975cd945$var$getBodyLength(body) : length;
};
var $d15dbfa5975cd945$export$2e2bcd8739ae039 = $d15dbfa5975cd945$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $l5Miv.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $8dHIy.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $d15dbfa5975cd945$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $d15dbfa5975cd945$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $3v50U.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $5Unwm.progressEventDecorator)(requestContentLength, (0, $5Unwm.progressEventReducer)((0, $5Unwm.asyncDecorator)(onUploadProgress)));
                data = (0, $gtTC9.trackStream)(_request.body, $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $3v50U.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $d15dbfa5975cd945$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($d15dbfa5975cd945$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $3v50U.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $5Unwm.progressEventDecorator)(responseContentLength, (0, $5Unwm.progressEventReducer)((0, $5Unwm.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $gtTC9.trackStream)(response.body, $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $d15dbfa5975cd945$var$resolvers[(0, $3v50U.default).findKey($d15dbfa5975cd945$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $gn43Q.default)(resolve, reject, {
                data: responseData,
                headers: (0, $hdRGz.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $9NE6H.default)("Network Error", (0, $9NE6H.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $9NE6H.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("8dHIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc1730af4ed7d42$export$2e2bcd8739ae039; });

var $lMpcA = parcelRequire("lMpcA");

var $9NE6H = parcelRequire("9NE6H");

var $3v50U = parcelRequire("3v50U");
const $5fc1730af4ed7d42$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $9NE6H.default) ? err : new (0, $lMpcA.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $9NE6H.default)(`timeout ${timeout} of ms exceeded`, (0, $9NE6H.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $3v50U.default).asap(unsubscribe);
        return signal;
    }
};
var $5fc1730af4ed7d42$export$2e2bcd8739ae039 = $5fc1730af4ed7d42$var$composeSignals;

});

parcelRegister("gtTC9", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $bffa7e9c613844aa$export$b0119225647bd83; });
const $bffa7e9c613844aa$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $bffa7e9c613844aa$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $bffa7e9c613844aa$var$readStream(iterable))yield* $bffa7e9c613844aa$export$71b051935044bd5d(chunk, chunkSize);
};
const $bffa7e9c613844aa$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $bffa7e9c613844aa$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $bffa7e9c613844aa$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("2wmIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d60326b81386a4f$export$2e2bcd8739ae039; });

var $ie3yz = parcelRequire("ie3yz");

var $9NE6H = parcelRequire("9NE6H");
"use strict";
const $1d60326b81386a4f$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $1d60326b81386a4f$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $1d60326b81386a4f$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1d60326b81386a4f$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $ie3yz.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $9NE6H.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $9NE6H.default).ERR_DEPRECATED);
        if (version && !$1d60326b81386a4f$var$deprecatedWarnings[opt]) {
            $1d60326b81386a4f$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1d60326b81386a4f$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $9NE6H.default)("options must be an object", (0, $9NE6H.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $9NE6H.default)("option " + opt + " must be " + result, (0, $9NE6H.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $9NE6H.default)("Unknown option " + opt, (0, $9NE6H.default).ERR_BAD_OPTION);
    }
}
var $1d60326b81386a4f$export$2e2bcd8739ae039 = {
    assertOptions: $1d60326b81386a4f$var$assertOptions,
    validators: $1d60326b81386a4f$var$validators
};

});
parcelRegister("ie3yz", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $d44c4b0d5eb593bb$export$a4ad2735b021c132; });
const $d44c4b0d5eb593bb$export$a4ad2735b021c132 = "1.7.7";

});



parcelRegister("5zLKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f544163c01037c$export$2e2bcd8739ae039; });

var $lMpcA = parcelRequire("lMpcA");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $40f544163c01037c$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $40f544163c01037c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $lMpcA.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $40f544163c01037c$export$2e2bcd8739ae039 = $40f544163c01037c$var$CancelToken;

});

parcelRegister("dyoH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9de19ad8955d98a8$export$2e2bcd8739ae039; });
"use strict";
function $9de19ad8955d98a8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("c7TGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d4156daca8bc0cb$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
function $8d4156daca8bc0cb$export$2e2bcd8739ae039(payload) {
    return (0, $3v50U.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("fTG9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92cb099b93a4235$export$2e2bcd8739ae039; });
const $b92cb099b93a4235$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($b92cb099b93a4235$var$HttpStatusCode).forEach(([key, value])=>{
    $b92cb099b93a4235$var$HttpStatusCode[value] = key;
});
var $b92cb099b93a4235$export$2e2bcd8739ae039 = $b92cb099b93a4235$var$HttpStatusCode;

});



parcelRegister("k9qks", function(module, exports) {

$parcel$export(module.exports, "isInWebView", function () { return $eab9124cc0664417$export$b3fd30c977a64b95; });
$parcel$export(module.exports, "isInPlayer", function () { return $eab9124cc0664417$export$bdc0eb7bf5752345; });
$parcel$export(module.exports, "isPWA", function () { return $eab9124cc0664417$export$fd1f485a98885089; });
$parcel$export(module.exports, "isVirtualKeyboardEnabled", function () { return $eab9124cc0664417$export$895047d75a8eda04; });
var $eab9124cc0664417$var$_a;
const $eab9124cc0664417$export$b3fd30c977a64b95 = "ReactNativeWebView" in window;
const $eab9124cc0664417$export$bdc0eb7bf5752345 = navigator && navigator.userAgent && navigator.userAgent.includes("Castit"); // we're setting the display mode to fullscreen in the manifest.json
const $eab9124cc0664417$export$fd1f485a98885089 = !!(($eab9124cc0664417$var$_a = window === null || window === void 0 ? void 0 : window.matchMedia("(display-mode: fullscreen)")) === null || $eab9124cc0664417$var$_a === void 0 ? void 0 : $eab9124cc0664417$var$_a.matches); /**
                                                                                                                                                                                  * Disable virtual keyboard if we are inside a webview
                                                                                                                                                                                  */ 
const $eab9124cc0664417$export$895047d75a8eda04 = !$eab9124cc0664417$export$b3fd30c977a64b95;

});


parcelRegister("dBZzI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Status", function () { return $9e8e7e92676675e6$export$96e9906d6d93a972; });
$parcel$export(module.exports, "default", function () { return $9e8e7e92676675e6$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $2EcOP = parcelRequire("2EcOP");

var $e8m2I = parcelRequire("e8m2I");

var $81BVN = parcelRequire("81BVN");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $ljukC = parcelRequire("ljukC");

var $jnPOB = parcelRequire("jnPOB");

var $kCXUJ = parcelRequire("kCXUJ");

var $b275P = parcelRequire("b275P");

var $8YEKz = parcelRequire("8YEKz");

var $3pTPw = parcelRequire("3pTPw");

var $ezhXm = parcelRequire("ezhXm");

var $bICkB = parcelRequire("bICkB");

var $bblWJ = parcelRequire("bblWJ");

var $euQZL = parcelRequire("euQZL");

var $bzcXF = parcelRequire("bzcXF");
const $9e8e7e92676675e6$export$96e9906d6d93a972 = {
    Connecting: "connecting",
    Ringing: "ringing",
    Open: "open",
    Error: "error",
    Close: "close"
};
const $9e8e7e92676675e6$var$ContactButton = (0, $e8m2I.default)((0, $ljukC.motion).button)(({ theme: theme })=>({
        margin: "0 2.5rem",
        minWidth: "16.4rem",
        padding: "1.5rem",
        borderRadius: "1rem",
        background: theme.palette.primary.main,
        h3: {
            color: theme.palette.background.default
        },
        "&:disabled": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.primary.main).lighten(0.4).hex()
        }
    }));
function $9e8e7e92676675e6$var$getPreference(receiver, namespace, action) {
    var _a, _b;
    if (!receiver) return false;
    if (!namespace) return false;
    const preference = (_a = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _a === void 0 ? void 0 : _a[namespace];
    return !!((preference === null || preference === void 0 ? void 0 : preference.enabled) && ((_b = preference === null || preference === void 0 ? void 0 : preference.channel) === null || _b === void 0 ? void 0 : _b[action]));
}
function $9e8e7e92676675e6$var$getAutoPreference(receiver, namespace, action) {
    var _a, _b;
    if (!receiver) return false;
    if (!namespace) return false;
    const preference = (_a = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _a === void 0 ? void 0 : _a[namespace];
    return !!((preference === null || preference === void 0 ? void 0 : preference.enabled) && ((_b = preference === null || preference === void 0 ? void 0 : preference.autoChannel) === null || _b === void 0 ? void 0 : _b[action]));
}
const $9e8e7e92676675e6$var$ContactPage = ()=>{
    var _a;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "call"
    ]);
    const history = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)();
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/contact\/${id}\/?$`).test(pathname);
    const disabled = !(id && pathname.endsWith(id)); // usePageTracking({
    //   page: "contact",
    // });
    // const { trackEvent } = useEventTracking();
    const { data: accessEventData } = (0, $dMu0R.useQuery)([
        `access/event/${id}`
    ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
            id: id
        }), {
        retry: false,
        staleTime: 60000,
        onError: ()=>{
            history("/", {
                replace: true
            });
        }
    });
    const namespace = (0, $eZVvM.useMemo)(()=>{
        var _a;
        switch((_a = accessEventData === null || accessEventData === void 0 ? void 0 : accessEventData.accessEvent) === null || _a === void 0 ? void 0 : _a.type){
            case "Food":
                return "foodDelivery";
            case "Package":
                return "packageDelivery";
            case "Guest":
            case "Visitor":
                return "visitor";
            case "MeetingAttendee":
                return "meetingAttendee";
            default:
                return undefined;
        }
    }, [
        accessEventData
    ]);
    const receiver = (_a = accessEventData === null || accessEventData === void 0 ? void 0 : accessEventData.accessEvent) === null || _a === void 0 ? void 0 : _a.receiver;
    const autoEmail = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getAutoPreference(receiver, namespace, "email"), [
        accessEventData
    ]);
    const autoSMS = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getAutoPreference(receiver, namespace, "sms"), [
        accessEventData
    ]);
    const availableForCall = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getPreference(receiver, namespace, "call"), [
        accessEventData
    ]);
    const availableForPing = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getPreference(receiver, namespace, "ping"), [
        accessEventData
    ]);
    const availableForSMS = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getPreference(receiver, namespace, "sms"), [
        accessEventData
    ]);
    const availableForVideoCall = (0, $eZVvM.useMemo)(()=>$9e8e7e92676675e6$var$getPreference(receiver, namespace, "videoCall"), [
        accessEventData
    ]);
    (0, $b275P.default)(()=>{
        history("/", {
            replace: true
        });
    }, 20000, disabled);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $3pTPw.default), {
                        to: "/"
                    }),
                    (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                        disableAnimation: !mainRoute
                    }, {
                        children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h1"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `call:title.${autoEmail || autoSMS ? "email-sms" : "no-email-sms"}`
                            })
                        }))
                    })),
                    !!(receiver === null || receiver === void 0 ? void 0 : receiver.phone) && (0, $bhfvP.jsxs)("div", Object.assign({
                        className: "call__buttons"
                    }, {
                        children: [
                            (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                disabled: !mainRoute
                            }, {
                                children: (0, $bhfvP.jsx)($9e8e7e92676675e6$var$ContactButton, Object.assign({
                                    disabled: !availableForCall,
                                    onClick: ()=>{
                                        // trackEvent({ type: "contact_button_click", value: "call" });
                                        history({
                                            pathname: `call`
                                        });
                                    }
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                        variant: "h3"
                                    }, {
                                        children: t("call:callBtn")
                                    }))
                                }))
                            })),
                            (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                disabled: !mainRoute
                            }, {
                                children: (0, $bhfvP.jsx)($9e8e7e92676675e6$var$ContactButton, Object.assign({
                                    disabled: !availableForPing,
                                    onClick: ()=>{
                                        // trackEvent({ type: "contact_button_click", value: "ping" });
                                        history({
                                            pathname: `ping`
                                        });
                                    }
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                        variant: "h3"
                                    }, {
                                        children: t("call:pingBtn")
                                    }))
                                }))
                            })),
                            (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                disabled: !mainRoute
                            }, {
                                children: (0, $bhfvP.jsx)($9e8e7e92676675e6$var$ContactButton, Object.assign({
                                    disabled: !availableForSMS,
                                    onClick: ()=>{
                                        // trackEvent({ type: "contact_button_click", value: "sms" });
                                        history({
                                            pathname: `message`
                                        });
                                    }
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                        variant: "h3"
                                    }, {
                                        children: t("call:smsBtn")
                                    }))
                                }))
                            })),
                            (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                disabled: !mainRoute
                            }, {
                                children: (0, $bhfvP.jsx)($9e8e7e92676675e6$var$ContactButton, Object.assign({
                                    disabled: !availableForVideoCall,
                                    onClick: ()=>{
                                        // trackEvent({ type: "contact_button_click", value: "video" });
                                        history({
                                            pathname: "video"
                                        });
                                    }
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                        variant: "h3"
                                    }, {
                                        children: t("call:callVideoBtn")
                                    }))
                                }))
                            }))
                        ]
                    }))
                ]
            })),
            !!(receiver === null || receiver === void 0 ? void 0 : receiver.phone) && (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
                children: [
                    (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "call",
                        element: (0, $bhfvP.jsx)((0, $bblWJ.default), {
                            type: "employee"
                        })
                    }),
                    (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "ping",
                        element: (0, $bhfvP.jsx)((0, $bblWJ.default), {
                            type: "employee"
                        })
                    }),
                    (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "message",
                        element: (0, $bhfvP.jsx)((0, $bICkB.default), {})
                    }),
                    (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "video",
                        element: (0, $bhfvP.jsx)((0, $euQZL.default), {})
                    })
                ]
            })
        ]
    });
};
var $9e8e7e92676675e6$export$2e2bcd8739ae039 = $9e8e7e92676675e6$var$ContactPage;

});
parcelRegister("dMu0R", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $f3477643ab9132fd$export$dd0a697e1782aedd; });

var $g3yHX = parcelRequire("g3yHX");
var $fM1qe = parcelRequire("fM1qe");

var $1DNFb = parcelRequire("1DNFb");
"use client";
function $f3477643ab9132fd$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $1DNFb.useBaseQuery)(parsedOptions, (0, $fM1qe.QueryObserver));
}

});
parcelRegister("g3yHX", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $ba1711d24f3cec9f$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $ba1711d24f3cec9f$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $ba1711d24f3cec9f$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $ba1711d24f3cec9f$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $ba1711d24f3cec9f$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $ba1711d24f3cec9f$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $ba1711d24f3cec9f$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $ba1711d24f3cec9f$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $ba1711d24f3cec9f$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $ba1711d24f3cec9f$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $ba1711d24f3cec9f$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $ba1711d24f3cec9f$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $ba1711d24f3cec9f$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $ba1711d24f3cec9f$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $ba1711d24f3cec9f$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $ba1711d24f3cec9f$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $ba1711d24f3cec9f$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $ba1711d24f3cec9f$export$17619bac5b909b23; });
// TYPES
// UTILS
const $ba1711d24f3cec9f$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $ba1711d24f3cec9f$export$8793edee2d425525() {
    return undefined;
}
function $ba1711d24f3cec9f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $ba1711d24f3cec9f$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $ba1711d24f3cec9f$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $ba1711d24f3cec9f$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $ba1711d24f3cec9f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $ba1711d24f3cec9f$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $ba1711d24f3cec9f$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $ba1711d24f3cec9f$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $ba1711d24f3cec9f$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $ba1711d24f3cec9f$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $ba1711d24f3cec9f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$ba1711d24f3cec9f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $ba1711d24f3cec9f$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($ba1711d24f3cec9f$export$5fcb678681417b54(mutation.options.mutationKey) !== $ba1711d24f3cec9f$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$ba1711d24f3cec9f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $ba1711d24f3cec9f$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $ba1711d24f3cec9f$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $ba1711d24f3cec9f$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$ba1711d24f3cec9f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $ba1711d24f3cec9f$export$2f07189bb9fa26a7(a, b) {
    return $ba1711d24f3cec9f$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $ba1711d24f3cec9f$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$ba1711d24f3cec9f$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $ba1711d24f3cec9f$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $ba1711d24f3cec9f$export$7a8558113332b71e(a) && $ba1711d24f3cec9f$export$7a8558113332b71e(b);
    if (array || $ba1711d24f3cec9f$export$53b83ca8eaab0383(a) && $ba1711d24f3cec9f$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $ba1711d24f3cec9f$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $ba1711d24f3cec9f$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $ba1711d24f3cec9f$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $ba1711d24f3cec9f$export$53b83ca8eaab0383(o) {
    if (!$ba1711d24f3cec9f$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$ba1711d24f3cec9f$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $ba1711d24f3cec9f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $ba1711d24f3cec9f$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $ba1711d24f3cec9f$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $ba1711d24f3cec9f$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $ba1711d24f3cec9f$export$4304cb76768ca134(callback) {
    $ba1711d24f3cec9f$export$e772c8ff12451969(0).then(callback);
}
function $ba1711d24f3cec9f$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $ba1711d24f3cec9f$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $ba1711d24f3cec9f$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("fM1qe", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $e9731b8b751e5a7c$export$a06cf8c0066f0d4c; });

var $g3yHX = parcelRequire("g3yHX");

var $bq3DV = parcelRequire("bq3DV");

var $aQMrm = parcelRequire("aQMrm");

var $4QcTI = parcelRequire("4QcTI");

var $lodjx = parcelRequire("lodjx");
class $e9731b8b751e5a7c$export$a06cf8c0066f0d4c extends (0, $4QcTI.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($e9731b8b751e5a7c$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $e9731b8b751e5a7c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $e9731b8b751e5a7c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $g3yHX.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $e9731b8b751e5a7c$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($e9731b8b751e5a7c$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $g3yHX.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $g3yHX.isServer) || this.currentResult.isStale || !(0, $g3yHX.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $g3yHX.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $g3yHX.isServer) || this.options.enabled === false || !(0, $g3yHX.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $aQMrm.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $e9731b8b751e5a7c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $e9731b8b751e5a7c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $lodjx.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $g3yHX.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $g3yHX.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $e9731b8b751e5a7c$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $g3yHX.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $lodjx.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $bq3DV.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $e9731b8b751e5a7c$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $e9731b8b751e5a7c$var$shouldFetchOnMount(query, options) {
    return $e9731b8b751e5a7c$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $e9731b8b751e5a7c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $e9731b8b751e5a7c$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $e9731b8b751e5a7c$var$isStale(query, options);
    }
    return false;
}
function $e9731b8b751e5a7c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $e9731b8b751e5a7c$var$isStale(query, options);
}
function $e9731b8b751e5a7c$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $e9731b8b751e5a7c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $g3yHX.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});
parcelRegister("bq3DV", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $b0290676e0263165$export$520687f44db6e1ab; });

var $g3yHX = parcelRequire("g3yHX");
function $b0290676e0263165$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $g3yHX.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $g3yHX.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $b0290676e0263165$export$520687f44db6e1ab = $b0290676e0263165$export$316a8efd03cd1458();

});

parcelRegister("aQMrm", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $c3a85528c3e1f733$export$6bf54661be5b02cf; });

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
class $c3a85528c3e1f733$export$86f1af424b2ca4de extends (0, $4QcTI.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $g3yHX.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
}
const $c3a85528c3e1f733$export$6bf54661be5b02cf = new $c3a85528c3e1f733$export$86f1af424b2ca4de();

});
parcelRegister("4QcTI", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $ae7fab194a0bd0f0$export$d26086b469ecdbcc; });
class $ae7fab194a0bd0f0$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

});


parcelRegister("lodjx", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $b44fbc2359bc526e$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $b44fbc2359bc526e$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $b44fbc2359bc526e$export$2cbd00fe8a2c8d85; });

var $aQMrm = parcelRequire("aQMrm");

var $6lhov = parcelRequire("6lhov");

var $g3yHX = parcelRequire("g3yHX");
function $b44fbc2359bc526e$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $b44fbc2359bc526e$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $6lhov.onlineManager).isOnline() : true;
}
class $b44fbc2359bc526e$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $b44fbc2359bc526e$export$986cc6445c1d323(value) {
    return value instanceof $b44fbc2359bc526e$export$a8430ed4188f35a9;
}
function $b44fbc2359bc526e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $b44fbc2359bc526e$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $aQMrm.focusManager).isFocused() || config.networkMode !== "always" && !(0, $6lhov.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $b44fbc2359bc526e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $g3yHX.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($b44fbc2359bc526e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("6lhov", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $e7b8d779d24bc673$export$b113e788b2dd3fdc; });

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
const $e7b8d779d24bc673$var$onlineEvents = [
    "online",
    "offline"
];
class $e7b8d779d24bc673$export$58774fb55d5ff7fc extends (0, $4QcTI.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $g3yHX.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $e7b8d779d24bc673$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $e7b8d779d24bc673$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $e7b8d779d24bc673$export$b113e788b2dd3fdc = new $e7b8d779d24bc673$export$58774fb55d5ff7fc();

});



parcelRegister("1DNFb", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $d5da050c930796de$export$fff0865807e996c5; });

var $eZVvM = parcelRequire("eZVvM");

var $bq3DV = parcelRequire("bq3DV");

var $l7YCt = parcelRequire("l7YCt");

var $2bmJH = parcelRequire("2bmJH");

var $gdPnm = parcelRequire("gdPnm");

var $j2xBj = parcelRequire("j2xBj");

var $2rBQf = parcelRequire("2rBQf");

var $9g6md = parcelRequire("9g6md");
"use client";
function $d5da050c930796de$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $gdPnm.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $j2xBj.useIsRestoring)();
    const errorResetBoundary = (0, $2bmJH.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $9g6md.ensureStaleTime)(defaultedOptions);
    (0, $2rBQf.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2rBQf.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $eZVvM.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $l7YCt.useSyncExternalStore)($eZVvM.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $bq3DV.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $eZVvM.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $9g6md.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $9g6md.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2rBQf.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("l7YCt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $774bf12fc2dddcb2$export$306c0aa65ff9ec16; });

var $7Vn1d = parcelRequire("7Vn1d");
"use client";
const $774bf12fc2dddcb2$export$306c0aa65ff9ec16 = (0, $7Vn1d.useSyncExternalStore);

});
parcelRegister("7Vn1d", function(module, exports) {
"use strict";

module.exports = (parcelRequire("brkeu"));

});


parcelRegister("2bmJH", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $4b19e984a279dd74$export$50dfac555130cafd; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
function $4b19e984a279dd74$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $4b19e984a279dd74$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $eZVvM.createContext($4b19e984a279dd74$var$createValue()); // HOOK
const $4b19e984a279dd74$export$50dfac555130cafd = ()=>$eZVvM.useContext($4b19e984a279dd74$var$QueryErrorResetBoundaryContext); // COMPONENT
const $4b19e984a279dd74$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $eZVvM.useState(()=>$4b19e984a279dd74$var$createValue());
    return /*#__PURE__*/ $eZVvM.createElement($4b19e984a279dd74$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRegister("gdPnm", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $f811184975d3f387$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $f811184975d3f387$export$45604f0cc8ae667b; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $f811184975d3f387$export$2fba198b5b2e37fa = /*#__PURE__*/ $eZVvM.createContext(undefined);
const $f811184975d3f387$var$QueryClientSharingContext = /*#__PURE__*/ $eZVvM.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $f811184975d3f387$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $f811184975d3f387$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $f811184975d3f387$export$2fba198b5b2e37fa;
}
const $f811184975d3f387$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $eZVvM.useContext($f811184975d3f387$var$getQueryClientContext(context, $eZVvM.useContext($f811184975d3f387$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $f811184975d3f387$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $eZVvM.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $f811184975d3f387$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $eZVvM.createElement($f811184975d3f387$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $eZVvM.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("j2xBj", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $49487944b51be185$export$4da0178d6b5f553; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $49487944b51be185$var$IsRestoringContext = /*#__PURE__*/ $eZVvM.createContext(false);
const $49487944b51be185$export$4da0178d6b5f553 = ()=>$eZVvM.useContext($49487944b51be185$var$IsRestoringContext);
const $49487944b51be185$export$593807d4e94f9621 = $49487944b51be185$var$IsRestoringContext.Provider;

});

parcelRegister("2rBQf", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $461ec4f7a42e2a45$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $461ec4f7a42e2a45$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $461ec4f7a42e2a45$export$1fbcf724762d607; });

var $eZVvM = parcelRequire("eZVvM");

var $gCLDX = parcelRequire("gCLDX");
"use client";
const $461ec4f7a42e2a45$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $461ec4f7a42e2a45$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $eZVvM.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $461ec4f7a42e2a45$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $gCLDX.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("gCLDX", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $cc480274c2f0a0dc$export$2072f68e6c3507cf; });
function $cc480274c2f0a0dc$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("9g6md", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $9250632acfb0dd13$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $9250632acfb0dd13$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $9250632acfb0dd13$export$defdc11a9c9acfcf; });
const $9250632acfb0dd13$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $9250632acfb0dd13$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $9250632acfb0dd13$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $9250632acfb0dd13$export$e0a3f29513afe430(result, isRestoring);
const $9250632acfb0dd13$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("4NAAR", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("iUQ9M")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("9GLBV")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("9yd0C")).initReactI18next; });

var $iUQ9M = parcelRequire("iUQ9M");

var $93vPE = parcelRequire("93vPE");

var $9GLBV = parcelRequire("9GLBV");

var $kyRf9 = parcelRequire("kyRf9");

var $fJ8IM = parcelRequire("fJ8IM");

var $jAKxm = parcelRequire("jAKxm");

var $8jA9R = parcelRequire("8jA9R");

var $6X3fC = parcelRequire("6X3fC");

var $9yd0C = parcelRequire("9yd0C");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");

var $kntWR = parcelRequire("kntWR");
var $37e81fbe123e81d5$export$324d90190a8b822a = function date() {
    return "";
};
var $37e81fbe123e81d5$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $37e81fbe123e81d5$export$98e628dec113755e = function number() {
    return "";
};
var $37e81fbe123e81d5$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $37e81fbe123e81d5$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $37e81fbe123e81d5$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};

});
parcelRegister("iUQ9M", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $dc55ea30a4790efa$export$8d6a9236f2e3f2ce; });

var $d4P6P = parcelRequire("d4P6P");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $93vPE = parcelRequire("93vPE");
parcelRequire("kntWR");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");
var $dc55ea30a4790efa$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $dc55ea30a4790efa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc55ea30a4790efa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc55ea30a4790efa$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc55ea30a4790efa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc55ea30a4790efa$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $5ZjiC.default)(_ref, $dc55ea30a4790efa$var$_excluded);
    var _ref2 = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $93vPE.Trans)($dc55ea30a4790efa$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}

});
parcelRegister("5ZjiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45c19eaf785d6b06$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");
function $45c19eaf785d6b06$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $7Z8DW.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("93vPE", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $697d1610cfaf9539$export$8d6a9236f2e3f2ce; });

var $5ZjiC = parcelRequire("5ZjiC");

var $d48On = parcelRequire("d48On");

var $d4P6P = parcelRequire("d4P6P");

var $eZVvM = parcelRequire("eZVvM");

var $2iXoq = parcelRequire("2iXoq");

var $2vBHm = parcelRequire("2vBHm");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");
var $697d1610cfaf9539$var$_excluded = [
    "format"
], $697d1610cfaf9539$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $697d1610cfaf9539$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $697d1610cfaf9539$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $697d1610cfaf9539$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $697d1610cfaf9539$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $697d1610cfaf9539$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $697d1610cfaf9539$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $697d1610cfaf9539$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $eZVvM.isValidElement)(child);
    });
}
function $697d1610cfaf9539$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $697d1610cfaf9539$var$mergeProps(source, target) {
    var newTarget = $697d1610cfaf9539$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $697d1610cfaf9539$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $697d1610cfaf9539$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $eZVvM.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $697d1610cfaf9539$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $2vBHm.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $d48On.default)(child) === "object") {
            var format = child.format, clone = (0, $5ZjiC.default)(child, $697d1610cfaf9539$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $2vBHm.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $2vBHm.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $697d1610cfaf9539$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $697d1610cfaf9539$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($697d1610cfaf9539$var$hasChildren(child)) getData($697d1610cfaf9539$var$getChildren(child));
            else if ((0, $d48On.default)(child) === "object" && !(0, $eZVvM.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $2iXoq.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $697d1610cfaf9539$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $697d1610cfaf9539$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $697d1610cfaf9539$var$getAsArray(reactNode);
        var astNodes = $697d1610cfaf9539$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $697d1610cfaf9539$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $eZVvM.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $697d1610cfaf9539$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $d48On.default)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $d48On.default)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($697d1610cfaf9539$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $eZVvM.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $eZVvM.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $d48On.default)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $eZVvM.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $697d1610cfaf9539$var$getAsArray(children || []));
    return $697d1610cfaf9539$var$getChildren(result[0]);
}
function $697d1610cfaf9539$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $5ZjiC.default)(_ref, $697d1610cfaf9539$var$_excluded2);
    var i18n = i18nFromProps || (0, $fGjmH.getI18n)();
    if (!i18n) {
        (0, $2vBHm.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, (0, $bcyLK.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $697d1610cfaf9539$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $697d1610cfaf9539$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $eZVvM.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("2iXoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1adb5566e5d8b266$export$2e2bcd8739ae039; });

var $1b5eE = parcelRequire("1b5eE");
var $1adb5566e5d8b266$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $1adb5566e5d8b266$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($1b5eE)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($1adb5566e5d8b266$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $1adb5566e5d8b266$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $1adb5566e5d8b266$var$i = /^\s*$/, $1adb5566e5d8b266$var$s = Object.create(null);
function $1adb5566e5d8b266$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($1adb5566e5d8b266$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $1adb5566e5d8b266$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $1adb5566e5d8b266$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($1adb5566e5d8b266$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $1adb5566e5d8b266$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $1adb5566e5d8b266$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $1adb5566e5d8b266$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $1adb5566e5d8b266$var$a("", t);
        }, "");
    }
};
var $1adb5566e5d8b266$export$2e2bcd8739ae039 = $1adb5566e5d8b266$var$c;

});
parcelRegister("1b5eE", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("2vBHm", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $1d3bb823911155af$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $1d3bb823911155af$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $1d3bb823911155af$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $1d3bb823911155af$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $1d3bb823911155af$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $1d3bb823911155af$export$be63e0664592e141; });
function $1d3bb823911155af$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $1d3bb823911155af$var$alreadyWarned = {};
function $1d3bb823911155af$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $1d3bb823911155af$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $1d3bb823911155af$var$alreadyWarned[args[0]] = new Date();
    $1d3bb823911155af$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $1d3bb823911155af$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $1d3bb823911155af$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $1d3bb823911155af$var$loadedClb(i18n, cb));
}
function $1d3bb823911155af$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $1d3bb823911155af$var$loadedClb(i18n, cb));
}
function $1d3bb823911155af$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $1d3bb823911155af$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $1d3bb823911155af$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $1d3bb823911155af$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $1d3bb823911155af$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRegister("bcyLK", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $827bc923f0c9e9c0$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $827bc923f0c9e9c0$export$212bb2fc580a90a8; });

var $d4P6P = parcelRequire("d4P6P");

var $7x6uV = parcelRequire("7x6uV");
function $827bc923f0c9e9c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $827bc923f0c9e9c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $827bc923f0c9e9c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $827bc923f0c9e9c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $827bc923f0c9e9c0$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $7x6uV.unescape)
};
function $827bc923f0c9e9c0$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $827bc923f0c9e9c0$var$defaultOptions = $827bc923f0c9e9c0$var$_objectSpread($827bc923f0c9e9c0$var$_objectSpread({}, $827bc923f0c9e9c0$var$defaultOptions), options);
}
function $827bc923f0c9e9c0$export$212bb2fc580a90a8() {
    return $827bc923f0c9e9c0$var$defaultOptions;
}

});
parcelRegister("7x6uV", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $57c0a7c77a42674b$export$e8bacd2802a88316; });
var $57c0a7c77a42674b$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $57c0a7c77a42674b$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $57c0a7c77a42674b$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $57c0a7c77a42674b$var$htmlEntities[m];
};
var $57c0a7c77a42674b$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($57c0a7c77a42674b$var$matchHtmlEntity, $57c0a7c77a42674b$var$unescapeHtmlEntity);
};

});


parcelRegister("fGjmH", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $b6a9ccbe65d47561$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $b6a9ccbe65d47561$export$64af334f494c2f47; });
var $b6a9ccbe65d47561$var$i18nInstance;
function $b6a9ccbe65d47561$export$a039134f2fc7e0(instance) {
    $b6a9ccbe65d47561$var$i18nInstance = instance;
}
function $b6a9ccbe65d47561$export$64af334f494c2f47() {
    return $b6a9ccbe65d47561$var$i18nInstance;
}

});


parcelRegister("kntWR", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $ed5d2fc36c8008df$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $ed5d2fc36c8008df$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $ed5d2fc36c8008df$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("bcyLK")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("fGjmH")).getI18n; });

var $d4P6P = parcelRequire("d4P6P");

var $rPxMG = parcelRequire("rPxMG");

var $cZMUv = parcelRequire("cZMUv");

var $eZVvM = parcelRequire("eZVvM");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");

var $9yd0C = parcelRequire("9yd0C");
function $ed5d2fc36c8008df$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ed5d2fc36c8008df$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ed5d2fc36c8008df$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ed5d2fc36c8008df$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ed5d2fc36c8008df$export$5603ab5ced17ce64 = (0, $eZVvM.createContext)();
var $ed5d2fc36c8008df$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $rPxMG.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $cZMUv.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $ed5d2fc36c8008df$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $ed5d2fc36c8008df$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($ed5d2fc36c8008df$var$_objectSpread($ed5d2fc36c8008df$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $ed5d2fc36c8008df$export$704200e5d0b9e8f() {
    var i18n = (0, $fGjmH.getI18n)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("9yd0C", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $6f416155aab8c75e$export$ae7e14d40d89f296; });

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");
var $6f416155aab8c75e$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $bcyLK.setDefaults)(instance.options.react);
        (0, $fGjmH.setI18n)(instance);
    }
};

});



parcelRegister("9GLBV", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $70dcf7cd96e44425$export$9fc83ad70ead8663; });

var $eq5hl = parcelRequire("eq5hl");

var $d4P6P = parcelRequire("d4P6P");

var $d48On = parcelRequire("d48On");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("kntWR");
var $bcyLK = parcelRequire("bcyLK");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");

var $2vBHm = parcelRequire("2vBHm");
function $70dcf7cd96e44425$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70dcf7cd96e44425$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70dcf7cd96e44425$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70dcf7cd96e44425$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $70dcf7cd96e44425$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $eZVvM.useRef)();
    (0, $eZVvM.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $70dcf7cd96e44425$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $kntWR.ReportNamespaces)();
    if (!i18n) {
        (0, $2vBHm.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $d48On.default)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $2vBHm.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $70dcf7cd96e44425$var$_objectSpread($70dcf7cd96e44425$var$_objectSpread($70dcf7cd96e44425$var$_objectSpread({}, (0, $bcyLK.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $2vBHm.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $eZVvM.useState)(getT), _useState2 = (0, $eq5hl.default)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $70dcf7cd96e44425$var$usePrevious(joinedNS);
    var isMounted = (0, $eZVvM.useRef)(true);
    (0, $eZVvM.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $2vBHm.loadLanguages)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $2vBHm.loadNamespaces)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $eZVvM.useRef)(true);
    (0, $eZVvM.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $2vBHm.loadLanguages)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $2vBHm.loadNamespaces)(i18n, namespaces, function() {
            return resolve();
        });
    });
}

});
parcelRegister("eq5hl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f796a78370f597$export$2e2bcd8739ae039; });

var $luw9G = parcelRequire("luw9G");

var $lulrr = parcelRequire("lulrr");

var $8boX5 = parcelRequire("8boX5");

var $8KBa0 = parcelRequire("8KBa0");
function $a7f796a78370f597$export$2e2bcd8739ae039(r, e) {
    return (0, $luw9G.default)(r) || (0, $lulrr.default)(r, e) || (0, $8boX5.default)(r, e) || (0, $8KBa0.default)();
}

});
parcelRegister("lulrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa4d0831f718cbeb$export$2e2bcd8739ae039; });
function $fa4d0831f718cbeb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});



parcelRegister("kyRf9", function(module, exports) {

var $d4P6P = parcelRequire("d4P6P");

var $eq5hl = parcelRequire("eq5hl");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $9GLBV = parcelRequire("9GLBV");

var $2vBHm = parcelRequire("2vBHm");
var $ef8048ab007a8ed4$var$_excluded = [
    "forwardedRef"
];
function $ef8048ab007a8ed4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef8048ab007a8ed4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ef8048ab007a8ed4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ef8048ab007a8ed4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef8048ab007a8ed4$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $5ZjiC.default)(_ref, $ef8048ab007a8ed4$var$_excluded);
            var _useTranslation = (0, $9GLBV.useTranslation)(ns, $ef8048ab007a8ed4$var$_objectSpread($ef8048ab007a8ed4$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $eq5hl.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $ef8048ab007a8ed4$var$_objectSpread($ef8048ab007a8ed4$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $eZVvM.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $2vBHm.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $eZVvM.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $eZVvM.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRegister("fJ8IM", function(module, exports) {

var $eq5hl = parcelRequire("eq5hl");

var $5ZjiC = parcelRequire("5ZjiC");

var $9GLBV = parcelRequire("9GLBV");
var $b731d2d624026f9e$var$_excluded = [
    "ns",
    "children"
];
function $b731d2d624026f9e$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $5ZjiC.default)(props, $b731d2d624026f9e$var$_excluded);
    var _useTranslation = (0, $9GLBV.useTranslation)(ns, options), _useTranslation2 = (0, $eq5hl.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRegister("jAKxm", function(module, exports) {

var $eZVvM = parcelRequire("eZVvM");

var $kntWR = parcelRequire("kntWR");
function $e4357a66f8dcac4e$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $eZVvM.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $eZVvM.createElement)((0, $kntWR.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("8jA9R", function(module, exports) {

var $d4P6P = parcelRequire("d4P6P");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $6X3fC = parcelRequire("6X3fC");

var $kntWR = parcelRequire("kntWR");

var $2vBHm = parcelRequire("2vBHm");
var $60dc25562a3fb5a0$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $60dc25562a3fb5a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $60dc25562a3fb5a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $60dc25562a3fb5a0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $60dc25562a3fb5a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $60dc25562a3fb5a0$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $5ZjiC.default)(_ref, $60dc25562a3fb5a0$var$_excluded);
            (0, $6X3fC.useSSR)(initialI18nStore, initialLanguage);
            return (0, $eZVvM.createElement)(WrappedComponent, $60dc25562a3fb5a0$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $kntWR.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $2vBHm.getDisplayName)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRegister("6X3fC", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $50fac64f6d0abc9e$export$3526fb65ade8d8b7; });

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("kntWR");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");
function $50fac64f6d0abc9e$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRegister("2EcOP", function(module, exports) {

var $3P6wt = parcelRequire("3P6wt");

var $cx9dG = parcelRequire("cx9dG");
const $1ed942bf934ce4b3$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $1ed942bf934ce4b3$var$hashedModelKeys = {};
for (const model of Object.keys($cx9dG))$1ed942bf934ce4b3$var$hashedModelKeys[[
    ...$cx9dG[model].labels
].sort().join("")] = model;
const $1ed942bf934ce4b3$var$limiters = {};
function $1ed942bf934ce4b3$var$Color(object, model) {
    if (!(this instanceof $1ed942bf934ce4b3$var$Color)) return new $1ed942bf934ce4b3$var$Color(object, model);
    if (model && model in $1ed942bf934ce4b3$var$skippedModels) model = null;
    if (model && !(model in $cx9dG)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $1ed942bf934ce4b3$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $3P6wt.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $cx9dG[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $cx9dG[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $1ed942bf934ce4b3$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $1ed942bf934ce4b3$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $1ed942bf934ce4b3$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $cx9dG[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $1ed942bf934ce4b3$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($1ed942bf934ce4b3$var$limiters[this.model]) {
        channels = $cx9dG[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $1ed942bf934ce4b3$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$1ed942bf934ce4b3$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $3P6wt.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $3P6wt.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $3P6wt.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $cx9dG[this.model];
        const { labels: labels } = $cx9dG[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $1ed942bf934ce4b3$var$Color([
            ...this.color.map($1ed942bf934ce4b3$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $1ed942bf934ce4b3$var$getset("rgb", 0, $1ed942bf934ce4b3$var$maxfn(255)),
    green: $1ed942bf934ce4b3$var$getset("rgb", 1, $1ed942bf934ce4b3$var$maxfn(255)),
    blue: $1ed942bf934ce4b3$var$getset("rgb", 2, $1ed942bf934ce4b3$var$maxfn(255)),
    hue: $1ed942bf934ce4b3$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $1ed942bf934ce4b3$var$getset("hsl", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    lightness: $1ed942bf934ce4b3$var$getset("hsl", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    saturationv: $1ed942bf934ce4b3$var$getset("hsv", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    value: $1ed942bf934ce4b3$var$getset("hsv", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    chroma: $1ed942bf934ce4b3$var$getset("hcg", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    gray: $1ed942bf934ce4b3$var$getset("hcg", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    white: $1ed942bf934ce4b3$var$getset("hwb", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    wblack: $1ed942bf934ce4b3$var$getset("hwb", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    cyan: $1ed942bf934ce4b3$var$getset("cmyk", 0, $1ed942bf934ce4b3$var$maxfn(100)),
    magenta: $1ed942bf934ce4b3$var$getset("cmyk", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    yellow: $1ed942bf934ce4b3$var$getset("cmyk", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    black: $1ed942bf934ce4b3$var$getset("cmyk", 3, $1ed942bf934ce4b3$var$maxfn(100)),
    x: $1ed942bf934ce4b3$var$getset("xyz", 0, $1ed942bf934ce4b3$var$maxfn(95.047)),
    y: $1ed942bf934ce4b3$var$getset("xyz", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    z: $1ed942bf934ce4b3$var$getset("xyz", 2, $1ed942bf934ce4b3$var$maxfn(108.833)),
    l: $1ed942bf934ce4b3$var$getset("lab", 0, $1ed942bf934ce4b3$var$maxfn(100)),
    a: $1ed942bf934ce4b3$var$getset("lab", 1),
    b: $1ed942bf934ce4b3$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        return $cx9dG[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        return $3P6wt.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $3P6wt.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $1ed942bf934ce4b3$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $1ed942bf934ce4b3$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($cx9dG)){
    if ($1ed942bf934ce4b3$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $cx9dG[model];
    // Conversion methods
    $1ed942bf934ce4b3$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $1ed942bf934ce4b3$var$Color(this);
        if (args.length > 0) return new $1ed942bf934ce4b3$var$Color(args, model);
        return new $1ed942bf934ce4b3$var$Color([
            ...$1ed942bf934ce4b3$var$assertArray($cx9dG[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $1ed942bf934ce4b3$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $1ed942bf934ce4b3$var$zeroArray(args, channels);
        return new $1ed942bf934ce4b3$var$Color(color, model);
    };
}
function $1ed942bf934ce4b3$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $1ed942bf934ce4b3$var$roundToPlace(places) {
    return function(number) {
        return $1ed942bf934ce4b3$var$roundTo(number, places);
    };
}
function $1ed942bf934ce4b3$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($1ed942bf934ce4b3$var$limiters[m] || ($1ed942bf934ce4b3$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $1ed942bf934ce4b3$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $1ed942bf934ce4b3$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $1ed942bf934ce4b3$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
module.exports = $1ed942bf934ce4b3$var$Color;

});
parcelRegister("3P6wt", function(module, exports) {
/* MIT license */ 
var $gQAMy = parcelRequire("gQAMy");

var $jolcQ = parcelRequire("jolcQ");
var $2c8b31d40c57a2bc$var$hasOwnProperty = Object.hasOwnProperty;
var $2c8b31d40c57a2bc$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $2c8b31d40c57a2bc$var$name in $gQAMy)if ($2c8b31d40c57a2bc$var$hasOwnProperty.call($gQAMy, $2c8b31d40c57a2bc$var$name)) $2c8b31d40c57a2bc$var$reverseNames[$gQAMy[$2c8b31d40c57a2bc$var$name]] = $2c8b31d40c57a2bc$var$name;
var $2c8b31d40c57a2bc$var$cs = module.exports = {
    to: {},
    get: {}
};
$2c8b31d40c57a2bc$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $2c8b31d40c57a2bc$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $2c8b31d40c57a2bc$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $2c8b31d40c57a2bc$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$2c8b31d40c57a2bc$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$2c8b31d40c57a2bc$var$hasOwnProperty.call($gQAMy, match[1])) return null;
        rgb = $gQAMy[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $2c8b31d40c57a2bc$var$clamp(rgb[i], 0, 255);
    rgb[3] = $2c8b31d40c57a2bc$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$2c8b31d40c57a2bc$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $2c8b31d40c57a2bc$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$2c8b31d40c57a2bc$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $2c8b31d40c57a2bc$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$2c8b31d40c57a2bc$var$cs.to.hex = function() {
    var rgba = $jolcQ(arguments);
    return "#" + $2c8b31d40c57a2bc$var$hexDouble(rgba[0]) + $2c8b31d40c57a2bc$var$hexDouble(rgba[1]) + $2c8b31d40c57a2bc$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $2c8b31d40c57a2bc$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$2c8b31d40c57a2bc$var$cs.to.rgb = function() {
    var rgba = $jolcQ(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$2c8b31d40c57a2bc$var$cs.to.rgb.percent = function() {
    var rgba = $jolcQ(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$2c8b31d40c57a2bc$var$cs.to.hsl = function() {
    var hsla = $jolcQ(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$2c8b31d40c57a2bc$var$cs.to.hwb = function() {
    var hwba = $jolcQ(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$2c8b31d40c57a2bc$var$cs.to.keyword = function(rgb) {
    return $2c8b31d40c57a2bc$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $2c8b31d40c57a2bc$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $2c8b31d40c57a2bc$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

});
parcelRegister("gQAMy", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRegister("jolcQ", function(module, exports) {
"use strict";

var $iSub0 = parcelRequire("iSub0");
var $e1e0b5537c966d2a$var$concat = Array.prototype.concat;
var $e1e0b5537c966d2a$var$slice = Array.prototype.slice;
var $e1e0b5537c966d2a$var$swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($iSub0(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $e1e0b5537c966d2a$var$concat.call(results, $e1e0b5537c966d2a$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$e1e0b5537c966d2a$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($e1e0b5537c966d2a$var$swizzle(arguments));
    };
};

});
parcelRegister("iSub0", function(module, exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

});



parcelRegister("cx9dG", function(module, exports) {

var $dE2RQ = parcelRequire("dE2RQ");

var $fOWRq = parcelRequire("fOWRq");
const $91ffb7eb2bd2ce71$var$convert = {};
const $91ffb7eb2bd2ce71$var$models = Object.keys($dE2RQ);
function $91ffb7eb2bd2ce71$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $91ffb7eb2bd2ce71$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$91ffb7eb2bd2ce71$var$models.forEach((fromModel)=>{
    $91ffb7eb2bd2ce71$var$convert[fromModel] = {};
    Object.defineProperty($91ffb7eb2bd2ce71$var$convert[fromModel], "channels", {
        value: $dE2RQ[fromModel].channels
    });
    Object.defineProperty($91ffb7eb2bd2ce71$var$convert[fromModel], "labels", {
        value: $dE2RQ[fromModel].labels
    });
    const routes = $fOWRq(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $91ffb7eb2bd2ce71$var$convert[fromModel][toModel] = $91ffb7eb2bd2ce71$var$wrapRounded(fn);
        $91ffb7eb2bd2ce71$var$convert[fromModel][toModel].raw = $91ffb7eb2bd2ce71$var$wrapRaw(fn);
    });
});
module.exports = $91ffb7eb2bd2ce71$var$convert;

});
parcelRegister("dE2RQ", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $gQAMy = parcelRequire("gQAMy");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $9ef13c34dab61823$var$reverseKeywords = {};
for (const key of Object.keys($gQAMy))$9ef13c34dab61823$var$reverseKeywords[$gQAMy[key]] = key;
const $9ef13c34dab61823$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
module.exports = $9ef13c34dab61823$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($9ef13c34dab61823$var$convert)){
    if (!("channels" in $9ef13c34dab61823$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $9ef13c34dab61823$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($9ef13c34dab61823$var$convert[model].labels.length !== $9ef13c34dab61823$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $9ef13c34dab61823$var$convert[model];
    delete $9ef13c34dab61823$var$convert[model].channels;
    delete $9ef13c34dab61823$var$convert[model].labels;
    Object.defineProperty($9ef13c34dab61823$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($9ef13c34dab61823$var$convert[model], "labels", {
        value: labels
    });
}
$9ef13c34dab61823$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $9ef13c34dab61823$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $9ef13c34dab61823$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$9ef13c34dab61823$var$convert.rgb.keyword = function(rgb) {
    const reversed = $9ef13c34dab61823$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($gQAMy)){
        const value = $gQAMy[keyword];
        // Compute comparative distance
        const distance = $9ef13c34dab61823$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$9ef13c34dab61823$var$convert.keyword.rgb = function(keyword) {
    return $gQAMy[keyword];
};
$9ef13c34dab61823$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.lab = function(rgb) {
    const xyz = $9ef13c34dab61823$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$9ef13c34dab61823$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$9ef13c34dab61823$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$9ef13c34dab61823$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$9ef13c34dab61823$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$9ef13c34dab61823$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $9ef13c34dab61823$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$9ef13c34dab61823$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $9ef13c34dab61823$var$convert.rgb.ansi16($9ef13c34dab61823$var$convert.hsv.rgb(args), args[2]);
};
$9ef13c34dab61823$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$9ef13c34dab61823$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$9ef13c34dab61823$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$9ef13c34dab61823$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$9ef13c34dab61823$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$9ef13c34dab61823$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$9ef13c34dab61823$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$9ef13c34dab61823$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$9ef13c34dab61823$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$9ef13c34dab61823$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$9ef13c34dab61823$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.hsv = $9ef13c34dab61823$var$convert.gray.hsl;
$9ef13c34dab61823$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$9ef13c34dab61823$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$9ef13c34dab61823$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});

parcelRegister("fOWRq", function(module, exports) {

var $dE2RQ = parcelRequire("dE2RQ");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $b8492f050d1c8c15$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($dE2RQ);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $b8492f050d1c8c15$var$deriveBFS(fromModel) {
    const graph = $b8492f050d1c8c15$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($dE2RQ[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $b8492f050d1c8c15$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $b8492f050d1c8c15$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $dE2RQ[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $b8492f050d1c8c15$var$link($dE2RQ[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $b8492f050d1c8c15$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $b8492f050d1c8c15$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});



parcelRegister("e8m2I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a2e949ed07e863$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("gW9L2")).default; });

var $5TKmV = parcelRequire("5TKmV");

var $2Uans = parcelRequire("2Uans");

var $hDdqv = parcelRequire("hDdqv");

var $gW9L2 = parcelRequire("gW9L2");

var $7Ocfa = parcelRequire("7Ocfa");
"use client";
const $a4a2e949ed07e863$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($5TKmV)))({
    themeId: (0, $hDdqv.default),
    defaultTheme: $2Uans.default,
    rootShouldForwardProp: $gW9L2.default
});
var $a4a2e949ed07e863$export$2e2bcd8739ae039 = $a4a2e949ed07e863$var$styled;

});
parcelRegister("5TKmV", function(module, exports) {
"use strict";

var $cKrja = parcelRequire("cKrja");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44b60eacf0f66ef8$var$createStyled;
module.exports.shouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $44b60eacf0f66ef8$var$_extends2 = $cKrja((parcelRequire("frncS")));

var $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2 = $cKrja((parcelRequire("37KYO")));

var $44b60eacf0f66ef8$var$_styledEngine = $44b60eacf0f66ef8$var$_interopRequireWildcard((parcelRequire("cgitS")));

var $hWP8m = parcelRequire("hWP8m");

var $44b60eacf0f66ef8$var$_capitalize = $cKrja((parcelRequire("booPO")));

var $44b60eacf0f66ef8$var$_getDisplayName = $cKrja((parcelRequire("iH2bF")));

var $44b60eacf0f66ef8$var$_createTheme = $cKrja((parcelRequire("lEj5y")));

var $44b60eacf0f66ef8$var$_styleFunctionSx = $cKrja((parcelRequire("k2gEs")));
const $44b60eacf0f66ef8$var$_excluded = [
    "ownerState"
], $44b60eacf0f66ef8$var$_excluded2 = [
    "variants"
], $44b60eacf0f66ef8$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $44b60eacf0f66ef8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($44b60eacf0f66ef8$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $44b60eacf0f66ef8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $44b60eacf0f66ef8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $44b60eacf0f66ef8$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $44b60eacf0f66ef8$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $44b60eacf0f66ef8$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $44b60eacf0f66ef8$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $44b60eacf0f66ef8$var$_createTheme.default)();
const $44b60eacf0f66ef8$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $44b60eacf0f66ef8$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $44b60eacf0f66ef8$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $44b60eacf0f66ef8$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $44b60eacf0f66ef8$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(_ref, $44b60eacf0f66ef8$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $44b60eacf0f66ef8$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$44b60eacf0f66ef8$var$processStyleArg(resolvedStyle, (0, $44b60eacf0f66ef8$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $44b60eacf0f66ef8$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $44b60eacf0f66ef8$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $44b60eacf0f66ef8$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $44b60eacf0f66ef8$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $44b60eacf0f66ef8$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $44b60eacf0f66ef8$var$_styleFunctionSx.default)((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
            theme: $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $44b60eacf0f66ef8$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $44b60eacf0f66ef8$var$defaultOverridesResolver($44b60eacf0f66ef8$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $44b60eacf0f66ef8$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $44b60eacf0f66ef8$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($44b60eacf0f66ef8$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $44b60eacf0f66ef8$var$_styledEngine.default)(tag, (0, $44b60eacf0f66ef8$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $hWP8m.isPlainObject)(stylesArg)) return (props)=>$44b60eacf0f66ef8$var$processStyleArg(stylesArg, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    theme: $44b60eacf0f66ef8$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $44b60eacf0f66ef8$var$processStyleArg(slotStyle, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $44b60eacf0f66ef8$var$processStyleArg({
                    variants: themeVariants
                }, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("cKrja", function(module, exports) {
function $947ef6bede0b1763$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $947ef6bede0b1763$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2Uans", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21d8dc776959fb7e$export$2e2bcd8739ae039; });

var $jcEiP = parcelRequire("jcEiP");
"use client";
const $21d8dc776959fb7e$var$defaultTheme = (0, $jcEiP.default)();
var $21d8dc776959fb7e$export$2e2bcd8739ae039 = $21d8dc776959fb7e$var$defaultTheme;

});
parcelRegister("jcEiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfae66918ab7b5ac$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $hWP8m = parcelRequire("hWP8m");

var $34Ozv = parcelRequire("34Ozv");
var $jHIoy = parcelRequire("jHIoy");

var $gnWEo = parcelRequire("gnWEo");


var $j45Vd = parcelRequire("j45Vd");

var $kSr0I = parcelRequire("kSr0I");

var $29U26 = parcelRequire("29U26");

var $bYEyB = parcelRequire("bYEyB");

var $dm8Bt = parcelRequire("dm8Bt");

var $l0G1l = parcelRequire("l0G1l");
const $dfae66918ab7b5ac$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $dfae66918ab7b5ac$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $7Z8DW.default)(options, $dfae66918ab7b5ac$var$_excluded);
    if (options.vars) throw new Error((0, $9u6aw.default)(18));
    const palette = (0, $kSr0I.default)(paletteInput);
    const systemTheme = (0, $gnWEo.default)(options);
    let muiTheme = (0, $hWP8m.default)(systemTheme, {
        mixins: (0, $j45Vd.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $bYEyB.default).slice(),
        typography: (0, $29U26.default)(palette, typographyInput),
        transitions: (0, $dm8Bt.default)(transitionsInput),
        zIndex: (0, $65o8X.default)({}, (0, $l0G1l.default))
    });
    muiTheme = (0, $hWP8m.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $hWP8m.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $65o8X.default)({}, (0, $jHIoy.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $34Ozv.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $dfae66918ab7b5ac$var$warnedOnce = false;
function $dfae66918ab7b5ac$export$c469355549431d9b(...args) {
    return $dfae66918ab7b5ac$var$createTheme(...args);
}
var $dfae66918ab7b5ac$export$2e2bcd8739ae039 = $dfae66918ab7b5ac$var$createTheme;

});
parcelRegister("j45Vd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de12fbfe653fcf7a$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");
function $de12fbfe653fcf7a$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $65o8X.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("kSr0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f32dcd805ea953f7$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $hWP8m = parcelRequire("hWP8m");

var $9b0pf = parcelRequire("9b0pf");

var $ePFP9 = parcelRequire("ePFP9");

var $2Hfls = parcelRequire("2Hfls");

var $2jlQt = parcelRequire("2jlQt");

var $d9mVe = parcelRequire("d9mVe");

var $jqz4p = parcelRequire("jqz4p");

var $4LSJ6 = parcelRequire("4LSJ6");

var $kQXuN = parcelRequire("kQXuN");

var $2ySmQ = parcelRequire("2ySmQ");
const $f32dcd805ea953f7$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $f32dcd805ea953f7$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $ePFP9.default).white,
        default: (0, $ePFP9.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $f32dcd805ea953f7$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $ePFP9.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $ePFP9.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $f32dcd805ea953f7$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $9b0pf.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $9b0pf.darken)(intent.main, tonalOffsetDark);
    }
}
function $f32dcd805ea953f7$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $4LSJ6.default)[200],
        light: (0, $4LSJ6.default)[50],
        dark: (0, $4LSJ6.default)[400]
    };
    return {
        main: (0, $4LSJ6.default)[700],
        light: (0, $4LSJ6.default)[400],
        dark: (0, $4LSJ6.default)[800]
    };
}
function $f32dcd805ea953f7$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2jlQt.default)[200],
        light: (0, $2jlQt.default)[50],
        dark: (0, $2jlQt.default)[400]
    };
    return {
        main: (0, $2jlQt.default)[500],
        light: (0, $2jlQt.default)[300],
        dark: (0, $2jlQt.default)[700]
    };
}
function $f32dcd805ea953f7$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $d9mVe.default)[500],
        light: (0, $d9mVe.default)[300],
        dark: (0, $d9mVe.default)[700]
    };
    return {
        main: (0, $d9mVe.default)[700],
        light: (0, $d9mVe.default)[400],
        dark: (0, $d9mVe.default)[800]
    };
}
function $f32dcd805ea953f7$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kQXuN.default)[400],
        light: (0, $kQXuN.default)[300],
        dark: (0, $kQXuN.default)[700]
    };
    return {
        main: (0, $kQXuN.default)[700],
        light: (0, $kQXuN.default)[500],
        dark: (0, $kQXuN.default)[900]
    };
}
function $f32dcd805ea953f7$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2ySmQ.default)[400],
        light: (0, $2ySmQ.default)[300],
        dark: (0, $2ySmQ.default)[700]
    };
    return {
        main: (0, $2ySmQ.default)[800],
        light: (0, $2ySmQ.default)[500],
        dark: (0, $2ySmQ.default)[900]
    };
}
function $f32dcd805ea953f7$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $jqz4p.default)[400],
        light: (0, $jqz4p.default)[300],
        dark: (0, $jqz4p.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $jqz4p.default)[500],
        dark: (0, $jqz4p.default)[900]
    };
}
function $f32dcd805ea953f7$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $7Z8DW.default)(palette, $f32dcd805ea953f7$var$_excluded);
    const primary = palette.primary || $f32dcd805ea953f7$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $f32dcd805ea953f7$var$getDefaultSecondary(mode);
    const error = palette.error || $f32dcd805ea953f7$var$getDefaultError(mode);
    const info = palette.info || $f32dcd805ea953f7$var$getDefaultInfo(mode);
    const success = palette.success || $f32dcd805ea953f7$var$getDefaultSuccess(mode);
    const warning = palette.warning || $f32dcd805ea953f7$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $9b0pf.getContrastRatio)(background, $f32dcd805ea953f7$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $f32dcd805ea953f7$export$55ce6f3a06c59543.text.primary : $f32dcd805ea953f7$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $65o8X.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $9u6aw.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $9u6aw.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $f32dcd805ea953f7$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $f32dcd805ea953f7$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $f32dcd805ea953f7$export$55ce6f3a06c59543,
        light: $f32dcd805ea953f7$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $hWP8m.default)((0, $65o8X.default)({
        // A collection of common colors.
        common: (0, $65o8X.default)({}, (0, $ePFP9.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2Hfls.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("9b0pf", function(module, exports) {
"use strict";

var $cKrja = parcelRequire("cKrja");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $6ae574cb2ebbc3ad$var$alpha;
module.exports.blend = $6ae574cb2ebbc3ad$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $6ae574cb2ebbc3ad$var$darken;
module.exports.decomposeColor = $6ae574cb2ebbc3ad$var$decomposeColor;
module.exports.emphasize = $6ae574cb2ebbc3ad$var$emphasize;
module.exports.getContrastRatio = $6ae574cb2ebbc3ad$var$getContrastRatio;
module.exports.getLuminance = $6ae574cb2ebbc3ad$var$getLuminance;
module.exports.hexToRgb = $6ae574cb2ebbc3ad$var$hexToRgb;
module.exports.hslToRgb = $6ae574cb2ebbc3ad$var$hslToRgb;
module.exports.lighten = $6ae574cb2ebbc3ad$var$lighten;
module.exports.private_safeAlpha = $6ae574cb2ebbc3ad$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $6ae574cb2ebbc3ad$var$private_safeDarken;
module.exports.private_safeEmphasize = $6ae574cb2ebbc3ad$var$private_safeEmphasize;
module.exports.private_safeLighten = $6ae574cb2ebbc3ad$var$private_safeLighten;
module.exports.recomposeColor = $6ae574cb2ebbc3ad$var$recomposeColor;
module.exports.rgbToHex = $6ae574cb2ebbc3ad$var$rgbToHex;

var $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2 = $cKrja((parcelRequire("1yFU7")));

var $6ae574cb2ebbc3ad$var$_clamp = $cKrja((parcelRequire("6Gv37")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $6ae574cb2ebbc3ad$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $6ae574cb2ebbc3ad$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $6ae574cb2ebbc3ad$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $6ae574cb2ebbc3ad$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $6ae574cb2ebbc3ad$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $6ae574cb2ebbc3ad$var$decomposeColor($6ae574cb2ebbc3ad$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $6ae574cb2ebbc3ad$var$colorChannel = (color)=>{
    const decomposedColor = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $6ae574cb2ebbc3ad$var$colorChannel;
const $6ae574cb2ebbc3ad$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $6ae574cb2ebbc3ad$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $6ae574cb2ebbc3ad$var$private_safeColorChannel;
function $6ae574cb2ebbc3ad$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $6ae574cb2ebbc3ad$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    return `#${values.map((n, i)=>$6ae574cb2ebbc3ad$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $6ae574cb2ebbc3ad$var$hslToRgb(color) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $6ae574cb2ebbc3ad$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $6ae574cb2ebbc3ad$var$getLuminance(color) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $6ae574cb2ebbc3ad$var$decomposeColor($6ae574cb2ebbc3ad$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $6ae574cb2ebbc3ad$var$getContrastRatio(foreground, background) {
    const lumA = $6ae574cb2ebbc3ad$var$getLuminance(foreground);
    const lumB = $6ae574cb2ebbc3ad$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$alpha(color, value) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    value = $6ae574cb2ebbc3ad$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeAlpha(color, value, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$darken(color, coefficient) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    coefficient = $6ae574cb2ebbc3ad$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$lighten(color, coefficient) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    coefficient = $6ae574cb2ebbc3ad$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$emphasize(color, coefficient = 0.15) {
    return $6ae574cb2ebbc3ad$var$getLuminance(color) > 0.5 ? $6ae574cb2ebbc3ad$var$darken(color, coefficient) : $6ae574cb2ebbc3ad$var$lighten(color, coefficient);
}
function $6ae574cb2ebbc3ad$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $6ae574cb2ebbc3ad$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $6ae574cb2ebbc3ad$var$decomposeColor(background);
    const overlayColor = $6ae574cb2ebbc3ad$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $6ae574cb2ebbc3ad$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});

parcelRegister("ePFP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acc6457e87554c52$export$2e2bcd8739ae039; });
const $acc6457e87554c52$var$common = {
    black: "#000",
    white: "#fff"
};
var $acc6457e87554c52$export$2e2bcd8739ae039 = $acc6457e87554c52$var$common;

});

parcelRegister("2Hfls", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f6b80255be92d2b$export$2e2bcd8739ae039; });
const $1f6b80255be92d2b$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1f6b80255be92d2b$export$2e2bcd8739ae039 = $1f6b80255be92d2b$var$grey;

});

parcelRegister("2jlQt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1aee4d22735d5325$export$2e2bcd8739ae039; });
const $1aee4d22735d5325$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $1aee4d22735d5325$export$2e2bcd8739ae039 = $1aee4d22735d5325$var$purple;

});

parcelRegister("d9mVe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $992de574f1606f4a$export$2e2bcd8739ae039; });
const $992de574f1606f4a$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $992de574f1606f4a$export$2e2bcd8739ae039 = $992de574f1606f4a$var$red;

});

parcelRegister("jqz4p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e24ba6338a2f77c2$export$2e2bcd8739ae039; });
const $e24ba6338a2f77c2$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $e24ba6338a2f77c2$export$2e2bcd8739ae039 = $e24ba6338a2f77c2$var$orange;

});

parcelRegister("4LSJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $379600ba82adc55b$export$2e2bcd8739ae039; });
const $379600ba82adc55b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $379600ba82adc55b$export$2e2bcd8739ae039 = $379600ba82adc55b$var$blue;

});

parcelRegister("kQXuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e6d095e9e71fca$export$2e2bcd8739ae039; });
const $f2e6d095e9e71fca$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $f2e6d095e9e71fca$export$2e2bcd8739ae039 = $f2e6d095e9e71fca$var$lightBlue;

});

parcelRegister("2ySmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dd8edf8f9af94d4$export$2e2bcd8739ae039; });
const $1dd8edf8f9af94d4$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $1dd8edf8f9af94d4$export$2e2bcd8739ae039 = $1dd8edf8f9af94d4$var$green;

});


parcelRegister("29U26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1927e300ae895ce9$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");
const $1927e300ae895ce9$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $1927e300ae895ce9$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1927e300ae895ce9$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $1927e300ae895ce9$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $1927e300ae895ce9$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $1927e300ae895ce9$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $7Z8DW.default)(_ref, $1927e300ae895ce9$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $65o8X.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $1927e300ae895ce9$var$defaultFontFamily ? {
            letterSpacing: `${$1927e300ae895ce9$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $1927e300ae895ce9$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $1927e300ae895ce9$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $hWP8m.default)((0, $65o8X.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("bYEyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b84c214fa0b5975$export$2e2bcd8739ae039; });
const $8b84c214fa0b5975$var$shadowKeyUmbraOpacity = 0.2;
const $8b84c214fa0b5975$var$shadowKeyPenumbraOpacity = 0.14;
const $8b84c214fa0b5975$var$shadowAmbientShadowOpacity = 0.12;
function $8b84c214fa0b5975$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $8b84c214fa0b5975$var$shadows = [
    "none",
    $8b84c214fa0b5975$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8b84c214fa0b5975$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8b84c214fa0b5975$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8b84c214fa0b5975$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8b84c214fa0b5975$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8b84c214fa0b5975$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8b84c214fa0b5975$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8b84c214fa0b5975$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8b84c214fa0b5975$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8b84c214fa0b5975$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8b84c214fa0b5975$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8b84c214fa0b5975$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8b84c214fa0b5975$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8b84c214fa0b5975$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8b84c214fa0b5975$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8b84c214fa0b5975$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8b84c214fa0b5975$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8b84c214fa0b5975$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8b84c214fa0b5975$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8b84c214fa0b5975$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8b84c214fa0b5975$export$2e2bcd8739ae039 = $8b84c214fa0b5975$var$shadows;

});

parcelRegister("dm8Bt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b9400e6897b1153$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
const $9b9400e6897b1153$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $9b9400e6897b1153$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $9b9400e6897b1153$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9b9400e6897b1153$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $9b9400e6897b1153$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $9b9400e6897b1153$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $65o8X.default)({}, $9b9400e6897b1153$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $65o8X.default)({}, $9b9400e6897b1153$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $7Z8DW.default)(options, $9b9400e6897b1153$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $9b9400e6897b1153$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $9b9400e6897b1153$var$formatMs(delay)}`).join(",");
    };
    return (0, $65o8X.default)({
        getAutoHeightDuration: $9b9400e6897b1153$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("l0G1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ba3183d1973706$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f4ba3183d1973706$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f4ba3183d1973706$export$2e2bcd8739ae039 = $f4ba3183d1973706$var$zIndex;

});



parcelRegister("hDdqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd607e6564742347$export$2e2bcd8739ae039; });
var $cd607e6564742347$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("gW9L2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c549a1c63ae66a43$export$2e2bcd8739ae039; });

var $7Ocfa = parcelRequire("7Ocfa");
const $c549a1c63ae66a43$var$rootShouldForwardProp = (prop)=>(0, $7Ocfa.default)(prop) && prop !== "classes";
var $c549a1c63ae66a43$export$2e2bcd8739ae039 = $c549a1c63ae66a43$var$rootShouldForwardProp;

});
parcelRegister("7Ocfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af6b33d880b74bd$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $5af6b33d880b74bd$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $5af6b33d880b74bd$export$2e2bcd8739ae039 = $5af6b33d880b74bd$var$slotShouldForwardProp;

});



parcelRegister("81BVN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d7bd7102f196281$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $bU7jb = parcelRequire("bU7jb");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $iDCHz = parcelRequire("iDCHz");

var $3eF6d = parcelRequire("3eF6d");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $5d7bd7102f196281$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $5d7bd7102f196281$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $iDCHz.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $3eF6d.getTypographyUtilityClass), classes);
};
const $5d7bd7102f196281$export$140e2f5526d3cad8 = (0, $e8m2I.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $iDCHz.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $5d7bd7102f196281$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $5d7bd7102f196281$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $5d7bd7102f196281$var$transformDeprecatedColors = (color)=>{
    return $5d7bd7102f196281$var$colorTransformations[color] || color;
};
const $5d7bd7102f196281$var$Typography = /*#__PURE__*/ $eZVvM.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $5d7bd7102f196281$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $bU7jb.default)((0, $65o8X.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $5d7bd7102f196281$var$defaultVariantMapping } = props, other = (0, $7Z8DW.default)(props, $5d7bd7102f196281$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $5d7bd7102f196281$var$defaultVariantMapping[variant]) || "span";
    const classes = $5d7bd7102f196281$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($5d7bd7102f196281$export$140e2f5526d3cad8, (0, $65o8X.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className)
    }, other));
});
var $5d7bd7102f196281$export$2e2bcd8739ae039 = $5d7bd7102f196281$var$Typography;

});
parcelRegister("fmwLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15676348d56fc1ae$export$2e2bcd8739ae039; });
function $15676348d56fc1ae$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $15676348d56fc1ae$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $15676348d56fc1ae$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $15676348d56fc1ae$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15676348d56fc1ae$export$2e2bcd8739ae039 = $15676348d56fc1ae$export$4f5d2d50c9deca37;

});

parcelRegister("9HTTf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71137bcc41c0338b$export$2e2bcd8739ae039; });
function $71137bcc41c0338b$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("8C83T", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $64582037ee8abf00$export$2440da353cedad43; });

var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");


var $tqb3u = parcelRequire("tqb3u");

var $3pI8R = parcelRequire("3pI8R");
"use client";
function $64582037ee8abf00$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $tqb3u.default), (0, $65o8X.default)({}, props));
}
var $64582037ee8abf00$export$2e2bcd8739ae039 = $64582037ee8abf00$var$DefaultPropsProvider;
function $64582037ee8abf00$export$2440da353cedad43(params) {
    return (0, $tqb3u.useDefaultProps)(params);
}

});
parcelRegister("tqb3u", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $058703d126f1b454$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $058703d126f1b454$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");


var $8XBeX = parcelRequire("8XBeX");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $058703d126f1b454$var$PropsContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
function $058703d126f1b454$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)($058703d126f1b454$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $058703d126f1b454$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $8XBeX.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $8XBeX.default)(config, props);
    return props;
}
function $058703d126f1b454$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $eZVvM.useContext($058703d126f1b454$var$PropsContext);
    return $058703d126f1b454$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $058703d126f1b454$export$2e2bcd8739ae039 = $058703d126f1b454$var$DefaultPropsProvider;

});
parcelRegister("8XBeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6860b88ec3aae518$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");
function $6860b88ec3aae518$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $65o8X.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $65o8X.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $65o8X.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $6860b88ec3aae518$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("iDCHz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d919e3e348f37215$export$2e2bcd8739ae039; });

var $hojpr = parcelRequire("hojpr");
var $d919e3e348f37215$export$2e2bcd8739ae039 = (0, $hojpr.default);

});

parcelRegister("3eF6d", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $25b28f5866789c98$export$24c1f8f60cbac79e; });

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $25b28f5866789c98$export$24c1f8f60cbac79e(slot) {
    return (0, $8QgsE.default)("MuiTypography", slot);
}
const $25b28f5866789c98$var$typographyClasses = (0, $dvQev.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $25b28f5866789c98$export$2e2bcd8739ae039 = $25b28f5866789c98$var$typographyClasses;

});
parcelRegister("dvQev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d66b0007285ac75$export$2e2bcd8739ae039; });

var $8QgsE = parcelRequire("8QgsE");
function $9d66b0007285ac75$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $8QgsE.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("8QgsE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66fff2ea26bc86db$export$2e2bcd8739ae039; });

var $hI2HT = parcelRequire("hI2HT");
const $66fff2ea26bc86db$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $66fff2ea26bc86db$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $66fff2ea26bc86db$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $hI2HT.default).generate(componentName)}-${slot}`;
}
function $66fff2ea26bc86db$export$34c0130b1f3e8ae3(slot) {
    return $66fff2ea26bc86db$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("hI2HT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce48a54a23a9229a$export$2e2bcd8739ae039; });
const $ce48a54a23a9229a$var$defaultGenerator = (componentName)=>componentName;
const $ce48a54a23a9229a$var$createClassNameGenerator = ()=>{
    let generate = $ce48a54a23a9229a$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $ce48a54a23a9229a$var$defaultGenerator;
        }
    };
};
const $ce48a54a23a9229a$var$ClassNameGenerator = $ce48a54a23a9229a$var$createClassNameGenerator();
var $ce48a54a23a9229a$export$2e2bcd8739ae039 = $ce48a54a23a9229a$var$ClassNameGenerator;

});





parcelRegister("ljukC", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $d5f8329c0fec877c$export$e25e478948902b8b; });

var $27Emm = parcelRequire("27Emm");

var $1PkBt = parcelRequire("1PkBt");
const $d5f8329c0fec877c$export$e25e478948902b8b = /*@__PURE__*/ (0, $27Emm.createDOMMotionComponentProxy)((0, $1PkBt.createMotionComponent));

});
parcelRegister("27Emm", function(module, exports) {

$parcel$export(module.exports, "createDOMMotionComponentProxy", function () { return $6d14c395f011340c$export$3af29c0efb268f04; });

function $6d14c395f011340c$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("1PkBt", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $9af8b63a91e66f97$export$46b7e4b9dc6110c3; });

var $aR9JM = parcelRequire("aR9JM");

var $58IoD = parcelRequire("58IoD");

var $fqXV2 = parcelRequire("fqXV2");

var $94Wls = parcelRequire("94Wls");

var $iPm9H = parcelRequire("iPm9H");

var $c9jLa = parcelRequire("c9jLa");
const $9af8b63a91e66f97$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $iPm9H.createMotionComponentFactory)({
    ...(0, $aR9JM.animations),
    ...(0, $fqXV2.gestureAnimations),
    ...(0, $58IoD.drag),
    ...(0, $94Wls.layout)
}, (0, $c9jLa.createDomVisualElement));

});
parcelRegister("aR9JM", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $2f2fe01eb9524666$export$7f9953c70dacfd7f; });

var $2m5ri = parcelRequire("2m5ri");

var $fU0gm = parcelRequire("fU0gm");
const $2f2fe01eb9524666$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $2m5ri.AnimationFeature)
    },
    exit: {
        Feature: (0, $fU0gm.ExitAnimationFeature)
    }
};

});
parcelRegister("2m5ri", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $e12a2d5689ea866d$export$b45b3fe5caabdca; });

var $gv2sY = parcelRequire("gv2sY");

var $9g72J = parcelRequire("9g72J");

var $5a6cH = parcelRequire("5a6cH");
class $e12a2d5689ea866d$export$b45b3fe5caabdca extends (0, $5a6cH.Feature) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $gv2sY.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $9g72J.createAnimationState)(node));
    }
}

});
parcelRegister("gv2sY", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $5f57867e26bb4108$export$aa71198ceeaf53ce; });
function $5f57867e26bb4108$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("9g72J", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $d0e9c38c2e7d04fb$export$bb53502b7a672aa8; });

var $gv2sY = parcelRequire("gv2sY");

var $cICIq = parcelRequire("cICIq");

var $cbHwA = parcelRequire("cbHwA");

var $hjEsj = parcelRequire("hjEsj");

var $46bzG = parcelRequire("46bzG");

var $g0oUH = parcelRequire("g0oUH");

var $amfuh = parcelRequire("amfuh");

var $kvY0h = parcelRequire("kvY0h");
const $d0e9c38c2e7d04fb$var$reversePriorityOrder = [
    ...(0, $g0oUH.variantPriorityOrder)
].reverse();
const $d0e9c38c2e7d04fb$var$numAnimationTypes = (0, $g0oUH.variantPriorityOrder).length;
function $d0e9c38c2e7d04fb$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $amfuh.animateVisualElement)(visualElement, animation, options)));
}
function $d0e9c38c2e7d04fb$export$bb53502b7a672aa8(visualElement) {
    let animate = $d0e9c38c2e7d04fb$var$animateList(visualElement);
    let state = $d0e9c38c2e7d04fb$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $46bzG.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $kvY0h.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $d0e9c38c2e7d04fb$var$numAnimationTypes; i++){
            const type = $d0e9c38c2e7d04fb$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $hjEsj.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $gv2sY.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $d0e9c38c2e7d04fb$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $cICIq.isKeyframesTarget)(next) && (0, $cICIq.isKeyframesTarget)(prev)) valueHasChanged = !(0, $cbHwA.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $d0e9c38c2e7d04fb$var$createState();
            isInitialRender = true;
        }
    };
}
function $d0e9c38c2e7d04fb$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $cbHwA.shallowCompare)(next, prev);
    return false;
}
function $d0e9c38c2e7d04fb$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $d0e9c38c2e7d04fb$var$createState() {
    return {
        animate: $d0e9c38c2e7d04fb$var$createTypeState(true),
        whileInView: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileHover: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileTap: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileDrag: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileFocus: $d0e9c38c2e7d04fb$var$createTypeState(),
        exit: $d0e9c38c2e7d04fb$var$createTypeState()
    };
}

});
parcelRegister("cICIq", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $2bdc4589d20a7f85$export$9153ad4c4999f4a0; });
const $2bdc4589d20a7f85$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});

parcelRegister("cbHwA", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $a156fe7855a1d3a0$export$90e866afbd6b9f1a; });
function $a156fe7855a1d3a0$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("hjEsj", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $b50d6f2544a29792$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $b50d6f2544a29792$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("46bzG", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $27459a0b09d3428c$export$7b1b1c981f4f0558; });

var $hCNbI = parcelRequire("hCNbI");
function $27459a0b09d3428c$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $hCNbI.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("hCNbI", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $cefff5a56c58fb78$export$d68f140c4d9b48bc; });
function $cefff5a56c58fb78$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $cefff5a56c58fb78$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $cefff5a56c58fb78$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $cefff5a56c58fb78$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("g0oUH", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $6d707c97a45dfb5d$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $6d707c97a45dfb5d$export$1405a65085f40b9; });
const $6d707c97a45dfb5d$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $6d707c97a45dfb5d$export$1405a65085f40b9 = [
    "initial",
    ...$6d707c97a45dfb5d$export$16e45afcc206d3a8
];

});

parcelRegister("amfuh", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $951caf5829a5f65c$export$ff62cf473653f109; });

var $46bzG = parcelRequire("46bzG");

var $3SQSk = parcelRequire("3SQSk");

var $1VBIb = parcelRequire("1VBIb");
function $951caf5829a5f65c$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $1VBIb.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $1VBIb.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $46bzG.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $3SQSk.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("3SQSk", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $4cc3664aaaf403fe$export$68cacfeee78d98d2; });

var $jBNTi = parcelRequire("jBNTi");

var $iNmcA = parcelRequire("iNmcA");

var $46TzZ = parcelRequire("46TzZ");

var $dyEGF = parcelRequire("dyEGF");

var $5IkJq = parcelRequire("5IkJq");

var $l6BwZ = parcelRequire("l6BwZ");

var $2Nl6b = parcelRequire("2Nl6b");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $4cc3664aaaf403fe$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $4cc3664aaaf403fe$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $4cc3664aaaf403fe$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $dyEGF.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $5IkJq.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $2Nl6b.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $l6BwZ.addValueToWillChange)(visualElement, key);
        value.start((0, $iNmcA.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $jBNTi.transformProps).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $2Nl6b.frame).update(()=>{
            transitionEnd && (0, $46TzZ.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("jBNTi", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $f6b89e753c7819bf$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $f6b89e753c7819bf$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $f6b89e753c7819bf$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $f6b89e753c7819bf$export$7b42a0094fb00b6e = new Set($f6b89e753c7819bf$export$280dc01950909d86);

});

parcelRegister("iNmcA", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $4b50812d6d66c8b3$export$90b3dfc33ff3548; });

var $51Nkl = parcelRequire("51Nkl");

var $lezyG = parcelRequire("lezyG");

var $dyEGF = parcelRequire("dyEGF");

var $gq1eE = parcelRequire("gq1eE");

var $Udiys = parcelRequire("Udiys");

var $hS7A2 = parcelRequire("hS7A2");

var $2Nl6b = parcelRequire("2Nl6b");

var $7tQu5 = parcelRequire("7tQu5");

var $fuLD7 = parcelRequire("fuLD7");

var $kwGwM = parcelRequire("kwGwM");

var $1Ygmt = parcelRequire("1Ygmt");
const $4b50812d6d66c8b3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $dyEGF.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $51Nkl.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $1Ygmt.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $lezyG.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $51Nkl.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $51Nkl.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $Udiys.instantAnimationState).current || (0, $gq1eE.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $hS7A2.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $2Nl6b.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $kwGwM.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $7tQu5.AcceleratedAnimation).supports(options)) return new (0, $7tQu5.AcceleratedAnimation)(options);
        else return new (0, $fuLD7.MainThreadAnimation)(options);
    };

});
parcelRegister("51Nkl", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("lezyG", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $9b331d1887e7c201$export$262124b154b9f1c0; });

var $jBNTi = parcelRequire("jBNTi");
const $9b331d1887e7c201$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $9b331d1887e7c201$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $9b331d1887e7c201$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $9b331d1887e7c201$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $9b331d1887e7c201$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $9b331d1887e7c201$var$keyframesTransition;
    else if ((0, $jBNTi.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $9b331d1887e7c201$var$criticallyDampedSpring(keyframes[1]) : $9b331d1887e7c201$var$underDampedSpring;
    return $9b331d1887e7c201$var$ease;
};

});

parcelRegister("dyEGF", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $a03b6c3e80f89fb5$export$7c1391340308742e; });
function $a03b6c3e80f89fb5$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}

});

parcelRegister("gq1eE", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $77ec403776d67d5f$export$dd826089e3c5e502; });
const $77ec403776d67d5f$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("Udiys", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $a02175ba83759089$export$888a3d84909f9e3d; });
const $a02175ba83759089$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("hS7A2", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $898d86da5e16a777$export$14de59408fad90b; });
const $898d86da5e16a777$var$isNotNull = (value)=>value !== null;
function $898d86da5e16a777$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($898d86da5e16a777$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("2Nl6b", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $acdac96acb68981d$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $acdac96acb68981d$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $acdac96acb68981d$export$fff89137e9e818ce; });
$parcel$export(module.exports, "frameSteps", function () { return $acdac96acb68981d$export$1811c3a7e3af92f0; });

var $k1qMD = parcelRequire("k1qMD");

var $lMJcW = parcelRequire("lMJcW");
const { schedule: $acdac96acb68981d$export$2cef06c20297c17d, cancel: $acdac96acb68981d$export$ec99c0ef4978dccb, state: $acdac96acb68981d$export$fff89137e9e818ce, steps: $acdac96acb68981d$export$1811c3a7e3af92f0 } = (0, $lMJcW.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $k1qMD.noop), true);

});
parcelRegister("k1qMD", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $586d62dcd567427e$export$8793edee2d425525; });
const $586d62dcd567427e$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("lMJcW", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $8779983df53b5129$export$510b0596a933801a; });

var $gq1eE = parcelRequire("gq1eE");

var $kSKwg = parcelRequire("kSKwg");
const $8779983df53b5129$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $8779983df53b5129$var$maxElapsed = 40;
function $8779983df53b5129$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $8779983df53b5129$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $kSKwg.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $gq1eE.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $8779983df53b5129$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $8779983df53b5129$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $8779983df53b5129$export$71ecace0a033b35a.length; i++)steps[$8779983df53b5129$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("kSKwg", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $7e6a806b6d97fda2$export$b995e5e85f5c8289; });
function $7e6a806b6d97fda2$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});



parcelRegister("7tQu5", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", function () { return $9d5b900ea23f213e$export$2a45abb4e6513325; });

var $gaRIG = parcelRequire("gaRIG");

var $6U7Ex = parcelRequire("6U7Ex");

var $02TSt = parcelRequire("02TSt");

var $j2xQU = parcelRequire("j2xQU");

var $k1qMD = parcelRequire("k1qMD");

var $51Nkl = parcelRequire("51Nkl");

var $fAUnX = parcelRequire("fAUnX");

var $jIJAr = parcelRequire("jIJAr");

var $fuLD7 = parcelRequire("fuLD7");

var $3Aa9a = parcelRequire("3Aa9a");

var $cqecV = parcelRequire("cqecV");

var $dXlO2 = parcelRequire("dXlO2");

var $c3sBf = parcelRequire("c3sBf");

var $hS7A2 = parcelRequire("hS7A2");

var $9E1W6 = parcelRequire("9E1W6");

var $1r5os = parcelRequire("1r5os");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9d5b900ea23f213e$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9d5b900ea23f213e$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $9d5b900ea23f213e$var$requiresPregeneratedKeyframes(options) {
    return (0, $fAUnX.isGenerator)(options.type) || options.type === "spring" || !(0, $dXlO2.isWaapiSupportedEasing)(options.ease);
}
function $9d5b900ea23f213e$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $fuLD7.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $9d5b900ea23f213e$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $9d5b900ea23f213e$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $9d5b900ea23f213e$var$sampleDelta,
        ease: "linear"
    };
}
const $9d5b900ea23f213e$var$unsupportedEasingFunctions = {
    anticipate: $gaRIG.anticipate,
    backInOut: $6U7Ex.backInOut,
    circInOut: $02TSt.circInOut
};
function $9d5b900ea23f213e$var$isUnsupportedEase(key) {
    return key in $9d5b900ea23f213e$var$unsupportedEasingFunctions;
}
class $9d5b900ea23f213e$export$2a45abb4e6513325 extends (0, $jIJAr.BaseAnimation) {
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $9E1W6.supportsLinearEasing)() && $9d5b900ea23f213e$var$isUnsupportedEase(ease)) ease = $9d5b900ea23f213e$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($9d5b900ea23f213e$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $9d5b900ea23f213e$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $cqecV.startWaapiAnimation)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $c3sBf.attachTimeline)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $hS7A2.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $51Nkl.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $51Nkl.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $51Nkl.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $k1qMD.noop;
            const { animation: animation } = resolved;
            (0, $c3sBf.attachTimeline)(animation, timeline);
        }
        return 0, $k1qMD.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $fuLD7.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $51Nkl.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $9d5b900ea23f213e$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $9d5b900ea23f213e$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return (0, $1r5os.supportsWaapi)() && name && (0, $3Aa9a.acceleratedValues).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $j2xQU.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}

});
parcelRegister("gaRIG", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $9dcd65fff942a904$export$6b0af63b873d419e; });

var $6U7Ex = parcelRequire("6U7Ex");
const $9dcd65fff942a904$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $6U7Ex.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("6U7Ex", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $92e5ce9e557d421b$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $92e5ce9e557d421b$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $92e5ce9e557d421b$export$ddc5fd596f6c71b2; });

var $hgM6L = parcelRequire("hgM6L");

var $47GNT = parcelRequire("47GNT");

var $53YhN = parcelRequire("53YhN");
const $92e5ce9e557d421b$export$77edfce482316a60 = /*@__PURE__*/ (0, $hgM6L.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $92e5ce9e557d421b$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $53YhN.reverseEasing)($92e5ce9e557d421b$export$77edfce482316a60);
const $92e5ce9e557d421b$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $47GNT.mirrorEasing)($92e5ce9e557d421b$export$b01116c84cdfe1a2);

});
parcelRegister("hgM6L", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $b6590af9d56d7dfd$export$2c575fa1d20488bd; });

var $k1qMD = parcelRequire("k1qMD");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b6590af9d56d7dfd$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b6590af9d56d7dfd$var$subdivisionPrecision = 0.0000001;
const $b6590af9d56d7dfd$var$subdivisionMaxIterations = 12;
function $b6590af9d56d7dfd$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b6590af9d56d7dfd$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b6590af9d56d7dfd$var$subdivisionPrecision && ++i < $b6590af9d56d7dfd$var$subdivisionMaxIterations);
    return currentT;
}
function $b6590af9d56d7dfd$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $k1qMD.noop;
    const getTForX = (aX)=>$b6590af9d56d7dfd$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b6590af9d56d7dfd$var$calcBezier(getTForX(t), mY1, mY2);
}

});

parcelRegister("47GNT", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $5f47d83f34a7c58a$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $5f47d83f34a7c58a$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("53YhN", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $e04d864cbb1a7b33$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $e04d864cbb1a7b33$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});



parcelRegister("02TSt", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $14c56a73b42f85a3$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $14c56a73b42f85a3$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $14c56a73b42f85a3$export$30d3455eee55bed5; });

var $47GNT = parcelRequire("47GNT");

var $53YhN = parcelRequire("53YhN");
const $14c56a73b42f85a3$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $14c56a73b42f85a3$export$c8d67a19199d1a50 = (0, $53YhN.reverseEasing)($14c56a73b42f85a3$export$e444123e42d03385);
const $14c56a73b42f85a3$export$30d3455eee55bed5 = (0, $47GNT.mirrorEasing)($14c56a73b42f85a3$export$e444123e42d03385);

});

parcelRegister("j2xQU", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $30d54e4a4fa013cf$export$4983792d11b61017; });

var $lrwqE = parcelRequire("lrwqE");

var $ik3NL = parcelRequire("ik3NL");

var $iomcl = parcelRequire("iomcl");

var $3UM7S = parcelRequire("3UM7S");

var $76Oqp = parcelRequire("76Oqp");

var $2LsSg = parcelRequire("2LsSg");

var $9FDyD = parcelRequire("9FDyD");
class $30d54e4a4fa013cf$export$4983792d11b61017 extends (0, $2LsSg.KeyframeResolver) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $iomcl.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $ik3NL.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $3UM7S.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $76Oqp.findDimensionValueType)(origin);
        const targetType = (0, $76Oqp.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $3UM7S.isNumOrPxType)(originType) && (0, $3UM7S.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $lrwqE.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $9FDyD.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $3UM7S.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $3UM7S.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}

});
parcelRegister("lrwqE", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $2a0ef451ef0a1bb4$export$e56af863d5645d5f; });

var $aZFM3 = parcelRequire("aZFM3");
function $2a0ef451ef0a1bb4$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $aZFM3.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("aZFM3", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $cb9f01153b2a3d05$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $cb9f01153b2a3d05$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("ik3NL", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $a97f9a67f71f7d90$export$289398774300c991; });

var $anHVs = parcelRequire("anHVs");

var $dVmba = parcelRequire("dVmba");

var $iomcl = parcelRequire("iomcl");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a97f9a67f71f7d90$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $a97f9a67f71f7d90$export$b9f0c1f373aee2b0(current) {
    const match = $a97f9a67f71f7d90$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $a97f9a67f71f7d90$var$maxDepth = 4;
function $a97f9a67f71f7d90$export$289398774300c991(current, element, depth = 1) {
    (0, $anHVs.invariant)(depth <= $a97f9a67f71f7d90$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a97f9a67f71f7d90$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $dVmba.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $iomcl.isCSSVariableToken)(fallback) ? $a97f9a67f71f7d90$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("anHVs", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $bde5dfec70eede58$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $bde5dfec70eede58$export$f5708dca728d7177; });

var $k1qMD = parcelRequire("k1qMD");
let $bde5dfec70eede58$export$491112666e282270 = (0, $k1qMD.noop);
let $bde5dfec70eede58$export$f5708dca728d7177 = (0, $k1qMD.noop);
var $bde5dfec70eede58$var$check, $bde5dfec70eede58$var$message, $bde5dfec70eede58$var$check1, $bde5dfec70eede58$var$message1;

});

parcelRegister("dVmba", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $bda2c785ae6c314a$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $bda2c785ae6c314a$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});

parcelRegister("iomcl", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $ebebb008c5329c80$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $ebebb008c5329c80$export$31f9caa2600b5723; });
const $ebebb008c5329c80$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $ebebb008c5329c80$export$9de1236619d9e756 = /*@__PURE__*/ $ebebb008c5329c80$var$checkStringStartsWith("--");
const $ebebb008c5329c80$var$startsAsVariableToken = /*@__PURE__*/ $ebebb008c5329c80$var$checkStringStartsWith("var(--");
const $ebebb008c5329c80$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $ebebb008c5329c80$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $ebebb008c5329c80$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $ebebb008c5329c80$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});


parcelRegister("3UM7S", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $3d2ccea53c634da1$export$c66c0d5db2a205d; });
$parcel$export(module.exports, "isNumOrPxType", function () { return $3d2ccea53c634da1$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $3d2ccea53c634da1$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $3d2ccea53c634da1$export$781d46a8aa670d52; });

var $jBNTi = parcelRequire("jBNTi");

var $cb614 = parcelRequire("cb614");

var $gZMJv = parcelRequire("gZMJv");
const $3d2ccea53c634da1$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $3d2ccea53c634da1$export$8e5250d1aa9bf370 = (v)=>v === (0, $cb614.number) || v === (0, $gZMJv.px);
const $3d2ccea53c634da1$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $3d2ccea53c634da1$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $3d2ccea53c634da1$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $3d2ccea53c634da1$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $3d2ccea53c634da1$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $3d2ccea53c634da1$var$nonTranslationalTransformKeys = (0, $jBNTi.transformPropOrder).filter((key)=>!$3d2ccea53c634da1$var$transformKeys.has(key));
function $3d2ccea53c634da1$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $3d2ccea53c634da1$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $3d2ccea53c634da1$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $3d2ccea53c634da1$var$getTranslateFromMatrix(4, 13),
    y: $3d2ccea53c634da1$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$3d2ccea53c634da1$export$781d46a8aa670d52.translateX = $3d2ccea53c634da1$export$781d46a8aa670d52.x;
$3d2ccea53c634da1$export$781d46a8aa670d52.translateY = $3d2ccea53c634da1$export$781d46a8aa670d52.y;

});
parcelRegister("cb614", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $70d95d5465e99a63$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $70d95d5465e99a63$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $70d95d5465e99a63$export$dcdf75081b88279d; });

var $g7qLA = parcelRequire("g7qLA");
const $70d95d5465e99a63$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $70d95d5465e99a63$export$58f0f39f63f3cf42 = {
    ...$70d95d5465e99a63$export$98e628dec113755e,
    transform: (v)=>(0, $g7qLA.clamp)(0, 1, v)
};
const $70d95d5465e99a63$export$dcdf75081b88279d = {
    ...$70d95d5465e99a63$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("g7qLA", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $922cbf6b96b336a1$export$7d15b64cf5a3a4c4; });
const $922cbf6b96b336a1$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("gZMJv", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $a5596f9db4a91b91$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $a5596f9db4a91b91$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $a5596f9db4a91b91$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $a5596f9db4a91b91$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $a5596f9db4a91b91$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $a5596f9db4a91b91$export$44e2e1705876d7ed; });
const $a5596f9db4a91b91$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $a5596f9db4a91b91$export$41fc368e1a942b97 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("deg");
const $a5596f9db4a91b91$export$626336c2cd4b14de = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("%");
const $a5596f9db4a91b91$export$91c0eda1d06bf008 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("px");
const $a5596f9db4a91b91$export$f91e8c45a95a32f2 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("vh");
const $a5596f9db4a91b91$export$aed3d7b7d206c196 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("vw");
const $a5596f9db4a91b91$export$44e2e1705876d7ed = {
    ...$a5596f9db4a91b91$export$626336c2cd4b14de,
    parse: (v)=>$a5596f9db4a91b91$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$a5596f9db4a91b91$export$626336c2cd4b14de.transform(v * 100)
};

});


parcelRegister("76Oqp", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $d88a34dd2eb7fed0$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $d88a34dd2eb7fed0$export$eefdd52e3ccae428; });

var $cb614 = parcelRequire("cb614");

var $gZMJv = parcelRequire("gZMJv");

var $31XMl = parcelRequire("31XMl");

var $bEEAd = parcelRequire("bEEAd");
/**
 * A list of value types commonly used for dimensions
 */ const $d88a34dd2eb7fed0$export$d176691c1998a1f5 = [
    (0, $cb614.number),
    (0, $gZMJv.px),
    (0, $gZMJv.percent),
    (0, $gZMJv.degrees),
    (0, $gZMJv.vw),
    (0, $gZMJv.vh),
    (0, $bEEAd.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d88a34dd2eb7fed0$export$eefdd52e3ccae428 = (v)=>$d88a34dd2eb7fed0$export$d176691c1998a1f5.find((0, $31XMl.testValueType)(v));

});
parcelRegister("31XMl", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $b11710ae4d65c274$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $b11710ae4d65c274$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("bEEAd", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $f360ac2d58659cbe$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $f360ac2d58659cbe$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});


parcelRegister("2LsSg", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $fe4a5825614f738f$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $fe4a5825614f738f$export$74d34ca3182f1750; });

var $3UM7S = parcelRequire("3UM7S");

var $2Nl6b = parcelRequire("2Nl6b");
const $fe4a5825614f738f$var$toResolve = new Set();
let $fe4a5825614f738f$var$isScheduled = false;
let $fe4a5825614f738f$var$anyNeedsMeasurement = false;
function $fe4a5825614f738f$var$measureAllKeyframes() {
    if ($fe4a5825614f738f$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($fe4a5825614f738f$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $3UM7S.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $fe4a5825614f738f$var$anyNeedsMeasurement = false;
    $fe4a5825614f738f$var$isScheduled = false;
    $fe4a5825614f738f$var$toResolve.forEach((resolver)=>resolver.complete());
    $fe4a5825614f738f$var$toResolve.clear();
}
function $fe4a5825614f738f$var$readAllKeyframes() {
    $fe4a5825614f738f$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $fe4a5825614f738f$var$anyNeedsMeasurement = true;
    });
}
function $fe4a5825614f738f$export$78b96d2a12593b05() {
    $fe4a5825614f738f$var$readAllKeyframes();
    $fe4a5825614f738f$var$measureAllKeyframes();
}
class $fe4a5825614f738f$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $fe4a5825614f738f$var$toResolve.add(this);
            if (!$fe4a5825614f738f$var$isScheduled) {
                $fe4a5825614f738f$var$isScheduled = true;
                (0, $2Nl6b.frame).read($fe4a5825614f738f$var$readAllKeyframes);
                (0, $2Nl6b.frame).resolveKeyframes($fe4a5825614f738f$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $fe4a5825614f738f$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $fe4a5825614f738f$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}

});

parcelRegister("9FDyD", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $6e5af34ab30ee3d2$export$8cc4958f8e540f37; });

var $4H4W5 = parcelRequire("4H4W5");

var $b2nJp = parcelRequire("b2nJp");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $6e5af34ab30ee3d2$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $6e5af34ab30ee3d2$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$6e5af34ab30ee3d2$var$invalidTemplates.has(keyframe) && (0, $4H4W5.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $b2nJp.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("4H4W5", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $5470142997ed61da$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $5470142997ed61da$export$83a0e34f1302825b; });

var $1xfyP = parcelRequire("1xfyP");

var $luJmg = parcelRequire("luJmg");

var $3i8PP = parcelRequire("3i8PP");

var $4KyQl = parcelRequire("4KyQl");
function $5470142997ed61da$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $3i8PP.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $luJmg.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $5470142997ed61da$var$NUMBER_TOKEN = "number";
const $5470142997ed61da$var$COLOR_TOKEN = "color";
const $5470142997ed61da$var$VAR_TOKEN = "var";
const $5470142997ed61da$var$VAR_FUNCTION_TOKEN = "var(";
const $5470142997ed61da$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $5470142997ed61da$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $5470142997ed61da$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($5470142997ed61da$var$complexRegex, (parsedValue)=>{
        if ((0, $1xfyP.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($5470142997ed61da$var$COLOR_TOKEN);
            values.push((0, $1xfyP.color).parse(parsedValue));
        } else if (parsedValue.startsWith($5470142997ed61da$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($5470142997ed61da$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($5470142997ed61da$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $5470142997ed61da$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($5470142997ed61da$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $5470142997ed61da$var$parseComplexValue(v) {
    return $5470142997ed61da$export$b61fc7c44bf646d5(v).values;
}
function $5470142997ed61da$var$createTransformer(source) {
    const { split: split, types: types } = $5470142997ed61da$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $5470142997ed61da$var$NUMBER_TOKEN) output += (0, $4KyQl.sanitize)(v[i]);
                else if (type === $5470142997ed61da$var$COLOR_TOKEN) output += (0, $1xfyP.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $5470142997ed61da$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $5470142997ed61da$var$getAnimatableNone(v) {
    const parsed = $5470142997ed61da$var$parseComplexValue(v);
    const transformer = $5470142997ed61da$var$createTransformer(v);
    return transformer(parsed.map($5470142997ed61da$var$convertNumbersToZero));
}
const $5470142997ed61da$export$83a0e34f1302825b = {
    test: $5470142997ed61da$var$test,
    parse: $5470142997ed61da$var$parseComplexValue,
    createTransformer: $5470142997ed61da$var$createTransformer,
    getAnimatableNone: $5470142997ed61da$var$getAnimatableNone
};

});
parcelRegister("1xfyP", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $8682243b2d1255c3$export$35e9368ef982300f; });

var $6u7kv = parcelRequire("6u7kv");

var $4QIZP = parcelRequire("4QIZP");

var $f7tm9 = parcelRequire("f7tm9");
const $8682243b2d1255c3$export$35e9368ef982300f = {
    test: (v)=>(0, $f7tm9.rgba).test(v) || (0, $6u7kv.hex).test(v) || (0, $4QIZP.hsla).test(v),
    parse: (v)=>{
        if ((0, $f7tm9.rgba).test(v)) return (0, $f7tm9.rgba).parse(v);
        else if ((0, $4QIZP.hsla).test(v)) return (0, $4QIZP.hsla).parse(v);
        else return (0, $6u7kv.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $f7tm9.rgba).transform(v) : (0, $4QIZP.hsla).transform(v);
    }
};

});
parcelRegister("6u7kv", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $40533b9b2b27af1c$export$834dfc94dde4b3d8; });

var $f7tm9 = parcelRequire("f7tm9");

var $eynr6 = parcelRequire("eynr6");
function $40533b9b2b27af1c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $40533b9b2b27af1c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $eynr6.isColorString)("#"),
    parse: $40533b9b2b27af1c$var$parseHex,
    transform: (0, $f7tm9.rgba).transform
};

});
parcelRegister("f7tm9", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $96f36da889b7860b$export$4e46ac54fc82cf3b; });

var $g7qLA = parcelRequire("g7qLA");

var $cb614 = parcelRequire("cb614");

var $4KyQl = parcelRequire("4KyQl");

var $eynr6 = parcelRequire("eynr6");
const $96f36da889b7860b$var$clampRgbUnit = (v)=>(0, $g7qLA.clamp)(0, 255, v);
const $96f36da889b7860b$export$7a99c86b5b1f4c9e = {
    ...(0, $cb614.number),
    transform: (v)=>Math.round($96f36da889b7860b$var$clampRgbUnit(v))
};
const $96f36da889b7860b$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $eynr6.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $eynr6.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(red) + ", " + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(green) + ", " + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $4KyQl.sanitize)((0, $cb614.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("4KyQl", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $7783f10d67c88e2e$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $7783f10d67c88e2e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("eynr6", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $23c84f4c68564ae4$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $23c84f4c68564ae4$export$73d6f35be992df24; });

var $3i8PP = parcelRequire("3i8PP");

var $btWva = parcelRequire("btWva");

var $b0slD = parcelRequire("b0slD");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $23c84f4c68564ae4$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $b0slD.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $btWva.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $23c84f4c68564ae4$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $3i8PP.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("3i8PP", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $341661bf74982dea$export$2444ca58c08448e4; });
const $341661bf74982dea$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("btWva", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $b51844c84c34bde2$export$b931b78cbb3caf86; });
function $b51844c84c34bde2$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("b0slD", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $f8d90bbc61e53af1$export$ed808ff6ecd39e8d; });
const $f8d90bbc61e53af1$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("4QIZP", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $6a42a864380d6ae9$export$810b04175080204c; });

var $cb614 = parcelRequire("cb614");

var $gZMJv = parcelRequire("gZMJv");

var $4KyQl = parcelRequire("4KyQl");

var $eynr6 = parcelRequire("eynr6");
const $6a42a864380d6ae9$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $eynr6.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $eynr6.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $gZMJv.percent).transform((0, $4KyQl.sanitize)(saturation)) + ", " + (0, $gZMJv.percent).transform((0, $4KyQl.sanitize)(lightness)) + ", " + (0, $4KyQl.sanitize)((0, $cb614.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("luJmg", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $f59c0f6630173981$export$740b69c5fad25dba; });
const $f59c0f6630173981$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("b2nJp", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $7ea9939be3c3d3fe$export$cea0cedcb94873b5; });

var $4H4W5 = parcelRequire("4H4W5");

var $IRj3t = parcelRequire("IRj3t");

var $e5pkd = parcelRequire("e5pkd");
function $7ea9939be3c3d3fe$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $e5pkd.getDefaultValueType)(key);
    if (defaultValueType !== (0, $IRj3t.filter)) defaultValueType = (0, $4H4W5.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("IRj3t", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $d814c116bbc362d7$export$3dea766d36a8935f; });

var $4H4W5 = parcelRequire("4H4W5");

var $3i8PP = parcelRequire("3i8PP");
/**
 * Properties that should default to 1 or 100%
 */ const $d814c116bbc362d7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $d814c116bbc362d7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $3i8PP.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $d814c116bbc362d7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $d814c116bbc362d7$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $d814c116bbc362d7$export$3dea766d36a8935f = {
    ...(0, $4H4W5.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($d814c116bbc362d7$var$functionRegex);
        return functions ? functions.map($d814c116bbc362d7$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("e5pkd", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $21740e929035fdb6$export$67d1babe0338d23b; });

var $1xfyP = parcelRequire("1xfyP");

var $IRj3t = parcelRequire("IRj3t");

var $iandk = parcelRequire("iandk");
/**
 * A map of default value types for common values
 */ const $21740e929035fdb6$export$98cd7c72c5a731fb = {
    ...(0, $iandk.numberValueTypes),
    color: // Color props
    $1xfyP.color,
    backgroundColor: (0, $1xfyP.color),
    outlineColor: (0, $1xfyP.color),
    fill: (0, $1xfyP.color),
    stroke: (0, $1xfyP.color),
    // Border props
    borderColor: (0, $1xfyP.color),
    borderTopColor: (0, $1xfyP.color),
    borderRightColor: (0, $1xfyP.color),
    borderBottomColor: (0, $1xfyP.color),
    borderLeftColor: (0, $1xfyP.color),
    filter: $IRj3t.filter,
    WebkitFilter: (0, $IRj3t.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $21740e929035fdb6$export$67d1babe0338d23b = (key)=>$21740e929035fdb6$export$98cd7c72c5a731fb[key];

});
parcelRegister("iandk", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $5490b350038d9669$export$eec14432cd1cb67b; });

var $cb614 = parcelRequire("cb614");

var $gZMJv = parcelRequire("gZMJv");

var $52Ofh = parcelRequire("52Ofh");

var $9Rjmd = parcelRequire("9Rjmd");

var $gLIdR = parcelRequire("gLIdR");
const $5490b350038d9669$export$eec14432cd1cb67b = {
    ...(0, $52Ofh.browserNumberValueTypes),
    ...(0, $9Rjmd.transformValueTypes),
    zIndex: (0, $gLIdR.int),
    size: (0, $gZMJv.px),
    // SVG
    fillOpacity: (0, $cb614.alpha),
    strokeOpacity: (0, $cb614.alpha),
    numOctaves: (0, $gLIdR.int)
};

});
parcelRegister("52Ofh", function(module, exports) {

$parcel$export(module.exports, "browserNumberValueTypes", function () { return $326d6b7c609893c3$export$2fb74b0a4e7d7c4a; });

var $gZMJv = parcelRequire("gZMJv");
const $326d6b7c609893c3$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $gZMJv.px),
    borderTopWidth: (0, $gZMJv.px),
    borderRightWidth: (0, $gZMJv.px),
    borderBottomWidth: (0, $gZMJv.px),
    borderLeftWidth: (0, $gZMJv.px),
    borderRadius: (0, $gZMJv.px),
    radius: (0, $gZMJv.px),
    borderTopLeftRadius: (0, $gZMJv.px),
    borderTopRightRadius: (0, $gZMJv.px),
    borderBottomRightRadius: (0, $gZMJv.px),
    borderBottomLeftRadius: (0, $gZMJv.px),
    // Positioning props
    width: (0, $gZMJv.px),
    maxWidth: (0, $gZMJv.px),
    height: (0, $gZMJv.px),
    maxHeight: (0, $gZMJv.px),
    top: (0, $gZMJv.px),
    right: (0, $gZMJv.px),
    bottom: (0, $gZMJv.px),
    left: (0, $gZMJv.px),
    // Spacing props
    padding: (0, $gZMJv.px),
    paddingTop: (0, $gZMJv.px),
    paddingRight: (0, $gZMJv.px),
    paddingBottom: (0, $gZMJv.px),
    paddingLeft: (0, $gZMJv.px),
    margin: (0, $gZMJv.px),
    marginTop: (0, $gZMJv.px),
    marginRight: (0, $gZMJv.px),
    marginBottom: (0, $gZMJv.px),
    marginLeft: (0, $gZMJv.px),
    // Misc
    backgroundPositionX: (0, $gZMJv.px),
    backgroundPositionY: (0, $gZMJv.px)
};

});

parcelRegister("9Rjmd", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $e04c285b44adb0c2$export$f2e4285fee37e26; });

var $cb614 = parcelRequire("cb614");

var $gZMJv = parcelRequire("gZMJv");
const $e04c285b44adb0c2$export$f2e4285fee37e26 = {
    rotate: (0, $gZMJv.degrees),
    rotateX: (0, $gZMJv.degrees),
    rotateY: (0, $gZMJv.degrees),
    rotateZ: (0, $gZMJv.degrees),
    scale: $cb614.scale,
    scaleX: (0, $cb614.scale),
    scaleY: (0, $cb614.scale),
    scaleZ: (0, $cb614.scale),
    skew: (0, $gZMJv.degrees),
    skewX: (0, $gZMJv.degrees),
    skewY: (0, $gZMJv.degrees),
    distance: (0, $gZMJv.px),
    translateX: (0, $gZMJv.px),
    translateY: (0, $gZMJv.px),
    translateZ: (0, $gZMJv.px),
    x: (0, $gZMJv.px),
    y: (0, $gZMJv.px),
    z: (0, $gZMJv.px),
    perspective: (0, $gZMJv.px),
    transformPerspective: (0, $gZMJv.px),
    opacity: (0, $cb614.alpha),
    originX: (0, $gZMJv.progressPercentage),
    originY: (0, $gZMJv.progressPercentage),
    originZ: (0, $gZMJv.px)
};

});

parcelRegister("gLIdR", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $44cab0f7ae8cb868$export$7d260a2a5f8bc19e; });

var $cb614 = parcelRequire("cb614");
const $44cab0f7ae8cb868$export$7d260a2a5f8bc19e = {
    ...(0, $cb614.number),
    transform: Math.round
};

});






parcelRegister("fAUnX", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $e953c71f76f79b0f$export$6ab7812f1bac68be; });
function $e953c71f76f79b0f$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}

});

parcelRegister("jIJAr", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", function () { return $70769c28f13a896e$export$d1e4f34b9c2550c1; });

var $1lF7N = parcelRequire("1lF7N");

var $2LsSg = parcelRequire("2LsSg");

var $Udiys = parcelRequire("Udiys");

var $4FX6b = parcelRequire("4FX6b");

var $hS7A2 = parcelRequire("hS7A2");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $70769c28f13a896e$var$MAX_RESOLVE_DELAY = 40;
class $70769c28f13a896e$export$d1e4f34b9c2550c1 {
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $70769c28f13a896e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $2LsSg.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $1lF7N.time).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $4FX6b.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $Udiys.instantAnimationState).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $hS7A2.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $1lF7N.time).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
}

});
parcelRegister("1lF7N", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1; });

var $gq1eE = parcelRequire("gq1eE");

var $2Nl6b = parcelRequire("2Nl6b");
let $7fbfc6b5a4b6f06f$var$now;
function $7fbfc6b5a4b6f06f$var$clearTime() {
    $7fbfc6b5a4b6f06f$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($7fbfc6b5a4b6f06f$var$now === undefined) $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1.set((0, $2Nl6b.frameData).isProcessing || (0, $gq1eE.MotionGlobalConfig).useManualTiming ? (0, $2Nl6b.frameData).timestamp : performance.now());
        return $7fbfc6b5a4b6f06f$var$now;
    },
    set: (newTime)=>{
        $7fbfc6b5a4b6f06f$var$now = newTime;
        queueMicrotask($7fbfc6b5a4b6f06f$var$clearTime);
    }
};

});

parcelRegister("4FX6b", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $d815b55018768770$export$1b109e6c9968df4f; });

var $anHVs = parcelRequire("anHVs");

var $fAUnX = parcelRequire("fAUnX");

var $ixFXY = parcelRequire("ixFXY");
function $d815b55018768770$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $d815b55018768770$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ixFXY.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $ixFXY.isAnimatable)(targetKeyframe, name);
    (0, $anHVs.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $d815b55018768770$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $fAUnX.isGenerator)(type)) && velocity;
}

});
parcelRegister("ixFXY", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $83342a437e84093a$export$65676b58b122bc38; });

var $4H4W5 = parcelRequire("4H4W5");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $83342a437e84093a$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4H4W5.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});



parcelRegister("fuLD7", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", function () { return $41a172794ed2cf55$export$fd98d9cca67a58bc; });

var $2LsSg = parcelRequire("2LsSg");

var $627Xw = parcelRequire("627Xw");

var $bZ19O = parcelRequire("bZ19O");

var $6dpBw = parcelRequire("6dpBw");

var $jIJAr = parcelRequire("jIJAr");

var $ebjvn = parcelRequire("ebjvn");

var $4qEgb = parcelRequire("4qEgb");

var $a1kM0 = parcelRequire("a1kM0");

var $51Nkl = parcelRequire("51Nkl");

var $g7qLA = parcelRequire("g7qLA");


var $40pyx = parcelRequire("40pyx");

var $hS7A2 = parcelRequire("hS7A2");

var $fAUnX = parcelRequire("fAUnX");
const $41a172794ed2cf55$var$generators = {
    decay: (0, $bZ19O.inertia),
    inertia: $bZ19O.inertia,
    tween: (0, $6dpBw.keyframes),
    keyframes: (0, $6dpBw.keyframes),
    spring: $627Xw.spring
};
const $41a172794ed2cf55$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $41a172794ed2cf55$export$fd98d9cca67a58bc extends (0, $jIJAr.BaseAnimation) {
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $fAUnX.isGenerator)(type) ? type : $41a172794ed2cf55$var$generators[type] || (0, $6dpBw.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $6dpBw.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $ebjvn.pipe)($41a172794ed2cf55$var$percentToProgress, (0, $4qEgb.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $a1kM0.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $g7qLA.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $hS7A2.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $51Nkl.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $51Nkl.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $51Nkl.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $51Nkl.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $40pyx.frameloopDriver), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $2LsSg.KeyframeResolver);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}
// Legacy interface
function $41a172794ed2cf55$export$ee9b76de7353d815(options) {
    return new $41a172794ed2cf55$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("627Xw", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $fdc5cd0ebd232846$export$b36281d89752ae66; });

var $51Nkl = parcelRequire("51Nkl");

var $2ckBC = parcelRequire("2ckBC");

var $l4pUb = parcelRequire("l4pUb");
const $fdc5cd0ebd232846$var$durationKeys = [
    "duration",
    "bounce"
];
const $fdc5cd0ebd232846$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $fdc5cd0ebd232846$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $fdc5cd0ebd232846$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$fdc5cd0ebd232846$var$isSpringType(options, $fdc5cd0ebd232846$var$physicsKeys) && $fdc5cd0ebd232846$var$isSpringType(options, $fdc5cd0ebd232846$var$durationKeys)) {
        const derived = (0, $l4pUb.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $fdc5cd0ebd232846$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $fdc5cd0ebd232846$var$getSpringOptions({
        ...options,
        velocity: -(0, $51Nkl.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $51Nkl.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $l4pUb.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $51Nkl.secondsToMilliseconds)(initialVelocity) : (0, $2ckBC.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("2ckBC", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $f9daaa93eaf4768e$export$854187271d233eb5; });

var $lrERE = parcelRequire("lrERE");
const $f9daaa93eaf4768e$var$velocitySampleDuration = 5; // ms
function $f9daaa93eaf4768e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $f9daaa93eaf4768e$var$velocitySampleDuration, 0);
    return (0, $lrERE.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("lrERE", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $8c9e7236f0507fd5$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8c9e7236f0507fd5$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("l4pUb", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $3b0a63a5b7236b15$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $3b0a63a5b7236b15$export$5f679887c3a78b15; });

var $anHVs = parcelRequire("anHVs");

var $g7qLA = parcelRequire("g7qLA");

var $51Nkl = parcelRequire("51Nkl");
const $3b0a63a5b7236b15$var$safeMin = 0.001;
const $3b0a63a5b7236b15$export$a3cdb76e84ee608e = 0.01;
const $3b0a63a5b7236b15$export$1824b851fad8862b = 10.0;
const $3b0a63a5b7236b15$export$ff08f2d53484465 = 0.05;
const $3b0a63a5b7236b15$export$201ca48e54038115 = 1;
function $3b0a63a5b7236b15$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $anHVs.warning)(duration <= (0, $51Nkl.secondsToMilliseconds)($3b0a63a5b7236b15$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $g7qLA.clamp)($3b0a63a5b7236b15$export$ff08f2d53484465, $3b0a63a5b7236b15$export$201ca48e54038115, dampingRatio);
    duration = (0, $g7qLA.clamp)($3b0a63a5b7236b15$export$a3cdb76e84ee608e, $3b0a63a5b7236b15$export$1824b851fad8862b, (0, $51Nkl.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $3b0a63a5b7236b15$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $3b0a63a5b7236b15$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $3b0a63a5b7236b15$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $3b0a63a5b7236b15$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$3b0a63a5b7236b15$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $3b0a63a5b7236b15$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $51Nkl.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $3b0a63a5b7236b15$var$rootIterations = 12;
function $3b0a63a5b7236b15$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $3b0a63a5b7236b15$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $3b0a63a5b7236b15$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("bZ19O", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $945bade90b0df180$export$ee3ff3a17106998; });

var $627Xw = parcelRequire("627Xw");

var $2ckBC = parcelRequire("2ckBC");
function $945bade90b0df180$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $627Xw.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $2ckBC.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("6dpBw", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $368c79393381aaea$export$d25ddfdf17c3ad3e; });

var $9niWn = parcelRequire("9niWn");

var $a7Rqg = parcelRequire("a7Rqg");

var $4epY9 = parcelRequire("4epY9");

var $fQNef = parcelRequire("fQNef");

var $ge4Ka = parcelRequire("ge4Ka");

var $02DiB = parcelRequire("02DiB");
function $368c79393381aaea$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $9niWn.easeInOut)).splice(0, values.length - 1);
}
function $368c79393381aaea$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $a7Rqg.isEasingArray)(ease) ? ease.map((0, $4epY9.easingDefinitionToFunction)) : (0, $4epY9.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $02DiB.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $ge4Ka.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $fQNef.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $368c79393381aaea$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("9niWn", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $17ffe7dfa5e6cb5e$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $17ffe7dfa5e6cb5e$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $17ffe7dfa5e6cb5e$export$c07234257a03d5e9; });

var $hgM6L = parcelRequire("hgM6L");
const $17ffe7dfa5e6cb5e$export$929e5a82286172a6 = /*@__PURE__*/ (0, $hgM6L.cubicBezier)(0.42, 0, 1, 1);
const $17ffe7dfa5e6cb5e$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $hgM6L.cubicBezier)(0, 0, 0.58, 1);
const $17ffe7dfa5e6cb5e$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $hgM6L.cubicBezier)(0.42, 0, 0.58, 1);

});

parcelRegister("a7Rqg", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $d528cf77d3d9476f$export$216948827bbdc797; });
const $d528cf77d3d9476f$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("4epY9", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $7b66960f57cc2a17$export$ef97fe084f156ca4; });

var $anHVs = parcelRequire("anHVs");

var $hgM6L = parcelRequire("hgM6L");

var $k1qMD = parcelRequire("k1qMD");

var $9niWn = parcelRequire("9niWn");

var $02TSt = parcelRequire("02TSt");

var $6U7Ex = parcelRequire("6U7Ex");

var $gaRIG = parcelRequire("gaRIG");

var $27SQz = parcelRequire("27SQz");
const $7b66960f57cc2a17$var$easingLookup = {
    linear: (0, $k1qMD.noop),
    easeIn: $9niWn.easeIn,
    easeInOut: $9niWn.easeInOut,
    easeOut: $9niWn.easeOut,
    circIn: $02TSt.circIn,
    circInOut: $02TSt.circInOut,
    circOut: $02TSt.circOut,
    backIn: $6U7Ex.backIn,
    backInOut: $6U7Ex.backInOut,
    backOut: $6U7Ex.backOut,
    anticipate: $gaRIG.anticipate
};
const $7b66960f57cc2a17$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $27SQz.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $anHVs.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $hgM6L.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $anHVs.invariant)($7b66960f57cc2a17$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $7b66960f57cc2a17$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("27SQz", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $14d9938e6f21d101$export$ff43f99925d7366b; });
const $14d9938e6f21d101$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});


parcelRegister("fQNef", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $ecfcb692edde2fe9$export$89e29e4ab65e70a9; });

var $anHVs = parcelRequire("anHVs");

var $g7qLA = parcelRequire("g7qLA");

var $ebjvn = parcelRequire("ebjvn");

var $3iMBi = parcelRequire("3iMBi");

var $k1qMD = parcelRequire("k1qMD");

var $4qEgb = parcelRequire("4qEgb");
function $ecfcb692edde2fe9$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $4qEgb.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $k1qMD.noop) : ease;
            mixer = (0, $ebjvn.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ecfcb692edde2fe9$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $anHVs.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ecfcb692edde2fe9$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3iMBi.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $g7qLA.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("ebjvn", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $af408ce9d401e7be$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $af408ce9d401e7be$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $af408ce9d401e7be$export$a4627e546088548d = (...transformers)=>transformers.reduce($af408ce9d401e7be$var$combineFunctions);

});

parcelRegister("3iMBi", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $12bda51f70c7265a$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $12bda51f70c7265a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("4qEgb", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $ce4dee409deddbf1$export$2c9e8a9632a706b2; });

var $ctkhO = parcelRequire("ctkhO");

var $adhut = parcelRequire("adhut");
function $ce4dee409deddbf1$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $adhut.mixNumber)(from, to, p);
    const mixer = (0, $ctkhO.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("ctkhO", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $961ea9031ece4213$export$36ec24672cd098e0; });

var $adhut = parcelRequire("adhut");

var $drfdB = parcelRequire("drfdB");

var $ebjvn = parcelRequire("ebjvn");

var $anHVs = parcelRequire("anHVs");

var $1xfyP = parcelRequire("1xfyP");

var $4H4W5 = parcelRequire("4H4W5");

var $iomcl = parcelRequire("iomcl");

var $bZCE1 = parcelRequire("bZCE1");

var $eQyoy = parcelRequire("eQyoy");
function $961ea9031ece4213$var$mixNumber(a, b) {
    return (p)=>(0, $adhut.mixNumber)(a, b, p);
}
function $961ea9031ece4213$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $961ea9031ece4213$var$mixNumber;
    else if (typeof a === "string") return (0, $iomcl.isCSSVariableToken)(a) ? (0, $eQyoy.mixImmediate) : (0, $1xfyP.color).test(a) ? (0, $drfdB.mixColor) : $961ea9031ece4213$export$65516310a87d8205;
    else if (Array.isArray(a)) return $961ea9031ece4213$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $1xfyP.color).test(a) ? (0, $drfdB.mixColor) : $961ea9031ece4213$export$ebc23b6840c51ba1;
    return 0, $eQyoy.mixImmediate;
}
function $961ea9031ece4213$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$961ea9031ece4213$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $961ea9031ece4213$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $961ea9031ece4213$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $961ea9031ece4213$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $961ea9031ece4213$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4H4W5.complex).createTransformer(target);
    const originStats = (0, $4H4W5.analyseComplexValue)(origin);
    const targetStats = (0, $4H4W5.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $bZCE1.invisibleValues).has(origin) && !targetStats.values.length || (0, $bZCE1.invisibleValues).has(target) && !originStats.values.length) return (0, $bZCE1.mixVisibility)(origin, target);
        return (0, $ebjvn.pipe)($961ea9031ece4213$export$3bbefa2f402845c4($961ea9031ece4213$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $anHVs.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $eQyoy.mixImmediate)(origin, target);
    }
};

});
parcelRegister("adhut", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $443836d22b4ddf64$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $443836d22b4ddf64$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("drfdB", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $388e816e2bafe060$export$51e568cf5c039bac; });

var $adhut = parcelRequire("adhut");

var $anHVs = parcelRequire("anHVs");

var $8lQ81 = parcelRequire("8lQ81");

var $6u7kv = parcelRequire("6u7kv");

var $f7tm9 = parcelRequire("f7tm9");

var $4QIZP = parcelRequire("4QIZP");

var $eQyoy = parcelRequire("eQyoy");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $388e816e2bafe060$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $388e816e2bafe060$var$colorTypes = [
    (0, $6u7kv.hex),
    (0, $f7tm9.rgba),
    (0, $4QIZP.hsla)
];
const $388e816e2bafe060$var$getColorType = (v)=>$388e816e2bafe060$var$colorTypes.find((type)=>type.test(v));
function $388e816e2bafe060$var$asRGBA(color) {
    const type = $388e816e2bafe060$var$getColorType(color);
    (0, $anHVs.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $4QIZP.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $8lQ81.hslaToRgba)(model);
    return model;
}
const $388e816e2bafe060$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $388e816e2bafe060$var$asRGBA(from);
    const toRGBA = $388e816e2bafe060$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $eQyoy.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $adhut.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $f7tm9.rgba).transform(blended);
    };
};

});
parcelRegister("8lQ81", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $f1690968937689e7$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $f1690968937689e7$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f1690968937689e7$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f1690968937689e7$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f1690968937689e7$var$hueToRgb(p, q, hue);
        blue = $f1690968937689e7$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("eQyoy", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $46aeb136ddf49b53$export$a6f92d4bae65c0f1; });
function $46aeb136ddf49b53$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("bZCE1", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $df9242d58c65c8eb$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $df9242d58c65c8eb$export$fed62ccc3fb1a568; });
const $df9242d58c65c8eb$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $df9242d58c65c8eb$export$fed62ccc3fb1a568(origin, target) {
    if ($df9242d58c65c8eb$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});




parcelRegister("ge4Ka", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $a16957f4a918dd0e$export$24dbcec0b26e6d9d; });

var $6vLmd = parcelRequire("6vLmd");
function $a16957f4a918dd0e$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $6vLmd.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("6vLmd", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $1d20156facb00c0e$export$dafee61230cf05c6; });

var $adhut = parcelRequire("adhut");

var $3iMBi = parcelRequire("3iMBi");
function $1d20156facb00c0e$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3iMBi.progress)(0, remaining, i);
        offset.push((0, $adhut.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("02DiB", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $2e85e32b4fa74249$export$2a91b4e3a4539316; });
function $2e85e32b4fa74249$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("a1kM0", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorDuration", function () { return $5f5c6a0b469cfe6d$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8 = 20000;
function $5f5c6a0b469cfe6d$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("40pyx", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $aadc4aedc6f76650$export$c1033964b5ad7fef; });

var $1lF7N = parcelRequire("1lF7N");

var $2Nl6b = parcelRequire("2Nl6b");
const $aadc4aedc6f76650$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $2Nl6b.frame).update(passTimestamp, true),
        stop: ()=>(0, $2Nl6b.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $2Nl6b.frameData).isProcessing ? (0, $2Nl6b.frameData).timestamp : (0, $1lF7N.time).now()
    };
};

});


parcelRegister("3Aa9a", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $8614f0f2d4b1c4f3$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ const $8614f0f2d4b1c4f3$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});

parcelRegister("cqecV", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $57d250ae8c2a8823$export$d896de52f97cb615; });

var $dXlO2 = parcelRequire("dXlO2");
function $57d250ae8c2a8823$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $dXlO2.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("dXlO2", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return $1ea8880f4e4e0d5c$export$fcdd8f3f2160beda; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $1ea8880f4e4e0d5c$export$916ea73bcd3a6030; });

var $27SQz = parcelRequire("27SQz");

var $dFz3q = parcelRequire("dFz3q");

var $9E1W6 = parcelRequire("9E1W6");
function $1ea8880f4e4e0d5c$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $9E1W6.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in $1ea8880f4e4e0d5c$export$2cf569f5e2221176 || (0, $9E1W6.supportsLinearEasing)()) || (0, $27SQz.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($1ea8880f4e4e0d5c$export$fcdd8f3f2160beda));
}
const $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $1ea8880f4e4e0d5c$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $1ea8880f4e4e0d5c$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $9E1W6.supportsLinearEasing)()) return (0, $dFz3q.generateLinearEasing)(easing, duration);
    else if ((0, $27SQz.isBezierDefinition)(easing)) return $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$1ea8880f4e4e0d5c$export$916ea73bcd3a6030(segmentEasing, duration) || $1ea8880f4e4e0d5c$export$2cf569f5e2221176.easeOut);
    else return $1ea8880f4e4e0d5c$export$2cf569f5e2221176[easing];
}

});
parcelRegister("dFz3q", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $40a5a3f1abcc3cdb$export$66d3851e2b1ec912; });

var $3iMBi = parcelRequire("3iMBi");
// Create a linear easing point for every 10 ms
const $40a5a3f1abcc3cdb$var$resolution = 10;
const $40a5a3f1abcc3cdb$export$66d3851e2b1ec912 = (easing, duration // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / $40a5a3f1abcc3cdb$var$resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $3iMBi.progress)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});

parcelRegister("9E1W6", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $55a5ca433915f5db$export$866c1d07a1ac2ab; });

var $6wVpX = parcelRequire("6wVpX");
const $55a5ca433915f5db$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $6wVpX.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("6wVpX", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $72d52e419e00ea27$export$1964673d5ec13c3a; });

var $43e3g = parcelRequire("43e3g");

var $5n354 = parcelRequire("5n354");
function $72d52e419e00ea27$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $43e3g.memo)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $5n354.supportsFlags)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}

});
parcelRegister("43e3g", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $126e79f287d0cb5d$export$7c73462e0d25e514; });
function $126e79f287d0cb5d$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("5n354", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $477759e91af48477$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $477759e91af48477$export$e3ad02c335474dee = {
    linearEasing: undefined
};

});





parcelRegister("c3sBf", function(module, exports) {

$parcel$export(module.exports, "attachTimeline", function () { return $0365e8cc62acbaff$export$5bd0fcbc73622e13; });
function $0365e8cc62acbaff$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

});

parcelRegister("1r5os", function(module, exports) {

$parcel$export(module.exports, "supportsWaapi", function () { return $0f9b8eb08505935d$export$51ea9b46fb7a8c5d; });

var $43e3g = parcelRequire("43e3g");
const $0f9b8eb08505935d$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $43e3g.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));

});


parcelRegister("kwGwM", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return $5ecb99f0dadd77fe$export$c1e41718f71efe41; });

var $bfz4Y = parcelRequire("bfz4Y");
class $5ecb99f0dadd77fe$export$c1e41718f71efe41 {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $bfz4Y.supportsScrollTimeline)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
}

});
parcelRegister("bfz4Y", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $75489825f2e4ed1d$export$20d68f04f30763a5; });

var $43e3g = parcelRequire("43e3g");
const $75489825f2e4ed1d$export$20d68f04f30763a5 = (0, $43e3g.memo)(()=>window.ScrollTimeline !== undefined);

});


parcelRegister("1Ygmt", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $2968bc4cbdcade95$export$ca8e47dc8ed5a9d7; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $2968bc4cbdcade95$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

});


parcelRegister("46TzZ", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $ed22d17dd15df1fe$export$1f61c53461aff4a5; });

var $8Bbb1 = parcelRequire("8Bbb1");

var $4oNvX = parcelRequire("4oNvX");

var $46bzG = parcelRequire("46bzG");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ed22d17dd15df1fe$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4oNvX.motionValue)(value));
}
function $ed22d17dd15df1fe$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $46bzG.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $8Bbb1.resolveFinalValueInKeyframes)(target[key]);
        $ed22d17dd15df1fe$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("8Bbb1", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $c54e4fffade8783d$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $c54e4fffade8783d$export$5485128c47bd48bb; });

var $cICIq = parcelRequire("cICIq");
const $c54e4fffade8783d$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $c54e4fffade8783d$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cICIq.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});

parcelRegister("4oNvX", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $3ab7e3f68323748d$export$ce8bdc721e76545f; });

var $3BCsP = parcelRequire("3BCsP");

var $lrERE = parcelRequire("lrERE");


var $1lF7N = parcelRequire("1lF7N");

var $2Nl6b = parcelRequire("2Nl6b");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA = 30;
const $3ab7e3f68323748d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $3ab7e3f68323748d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $3ab7e3f68323748d$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $1lF7N.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $3ab7e3f68323748d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $3BCsP.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $2Nl6b.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($3ab7e3f68323748d$export$67fcd818a264039d.current) $3ab7e3f68323748d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $1lF7N.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $lrERE.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.11.11";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $1lF7N.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $3ab7e3f68323748d$export$ce8bdc721e76545f(init, options) {
    return new $3ab7e3f68323748d$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("3BCsP", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $f9840d42d34a21b8$export$e7dff9482a5fd23c; });

var $kzf7n = parcelRequire("kzf7n");
class $f9840d42d34a21b8$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $kzf7n.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $kzf7n.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}

});
parcelRegister("kzf7n", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $aecc3bef04e70b5b$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $aecc3bef04e70b5b$export$fe2d9b4e03920b4c; });
function $aecc3bef04e70b5b$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $aecc3bef04e70b5b$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $aecc3bef04e70b5b$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});




parcelRegister("5IkJq", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $c3da4d6612ac58d3$export$5f8d21e84d1d84fc; });

var $3vWfR = parcelRequire("3vWfR");
function $c3da4d6612ac58d3$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $3vWfR.optimizedAppearDataAttribute];
}

});
parcelRegister("3vWfR", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $525b989f99c32b36$export$8592e1c077c890a6; });

var $fQIMP = parcelRequire("fQIMP");
const $525b989f99c32b36$export$ed7b8fa9dbf0105d = "framerAppearId";
const $525b989f99c32b36$export$8592e1c077c890a6 = "data-" + (0, $fQIMP.camelToDash)($525b989f99c32b36$export$ed7b8fa9dbf0105d);

});
parcelRegister("fQIMP", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $8aa347481fb6b490$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $8aa347481fb6b490$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});



parcelRegister("l6BwZ", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $34a1e6a1b73b3167$export$3ac5aed310be0bee; });

var $aBGu1 = parcelRequire("aBGu1");
function $34a1e6a1b73b3167$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $aBGu1.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

});
parcelRegister("aBGu1", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $355931738376f294$export$98397f3adbf6259f; });

var $1y4u0 = parcelRequire("1y4u0");
function $355931738376f294$export$98397f3adbf6259f(value) {
    return Boolean((0, $1y4u0.isMotionValue)(value) && value.add);
}

});
parcelRegister("1y4u0", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $afd19ce5c54b9648$export$605d60a2578142d3; });
const $afd19ce5c54b9648$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});




parcelRegister("1VBIb", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $f68947d55150a093$export$4709dc300705b2af; });

var $46bzG = parcelRequire("46bzG");

var $3SQSk = parcelRequire("3SQSk");
function $f68947d55150a093$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $46bzG.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $3SQSk.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f68947d55150a093$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f68947d55150a093$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f68947d55150a093$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f68947d55150a093$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f68947d55150a093$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});


parcelRegister("kvY0h", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $1d057a3ddae45d79$export$6669f52f7ffa343b; });

var $hjEsj = parcelRequire("hjEsj");

var $g0oUH = parcelRequire("g0oUH");
const $1d057a3ddae45d79$var$numVariantProps = (0, $g0oUH.variantProps).length;
function $1d057a3ddae45d79$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $1d057a3ddae45d79$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $1d057a3ddae45d79$var$numVariantProps; i++){
        const name = (0, $g0oUH.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, $hjEsj.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

});


parcelRegister("5a6cH", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $f393de8400f417d7$export$6e91cf7616333d5; });
class $f393de8400f417d7$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}

});


parcelRegister("fU0gm", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $53c97979850eee6d$export$4989d1eb6104cc6c; });

var $5a6cH = parcelRequire("5a6cH");
let $53c97979850eee6d$var$id = 0;
class $53c97979850eee6d$export$4989d1eb6104cc6c extends (0, $5a6cH.Feature) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $53c97979850eee6d$var$id++;
    }
}

});


parcelRegister("58IoD", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $f61e96ba32376203$export$d7d5d435647ed5a0; });

var $dLxMp = parcelRequire("dLxMp");

var $ke27I = parcelRequire("ke27I");

var $7ygmr = parcelRequire("7ygmr");

var $8j6Ur = parcelRequire("8j6Ur");
const $f61e96ba32376203$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $ke27I.PanGesture)
    },
    drag: {
        Feature: (0, $dLxMp.DragGesture),
        ProjectionNode: (0, $8j6Ur.HTMLProjectionNode),
        MeasureLayout: $7ygmr.MeasureLayout
    }
};

});
parcelRegister("dLxMp", function(module, exports) {

$parcel$export(module.exports, "DragGesture", function () { return $df7139fffc0bd0da$export$5d97dc2872682820; });

var $5a6cH = parcelRequire("5a6cH");

var $k1qMD = parcelRequire("k1qMD");

var $9qGX9 = parcelRequire("9qGX9");
class $df7139fffc0bd0da$export$5d97dc2872682820 extends (0, $5a6cH.Feature) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $k1qMD.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $k1qMD.noop);
        this.removeListeners = (0, $k1qMD.noop);
        this.controls = new (0, $9qGX9.VisualElementDragControls)(node);
    }
}

});
parcelRegister("9qGX9", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $1a101a2ea5c41299$export$86bff71f18910307; });

var $anHVs = parcelRequire("anHVs");

var $fmqnM = parcelRequire("fmqnM");

var $2TAQS = parcelRequire("2TAQS");

var $dnjlm = parcelRequire("dnjlm");

var $6ChET = parcelRequire("6ChET");

var $hWwZH = parcelRequire("hWwZH");

var $5C3hG = parcelRequire("5C3hG");

var $heQzy = parcelRequire("heQzy");

var $5HNVc = parcelRequire("5HNVc");

var $4aRup = parcelRequire("4aRup");

var $dIeCo = parcelRequire("dIeCo");

var $jgx8I = parcelRequire("jgx8I");

var $3VmRs = parcelRequire("3VmRs");

var $adhut = parcelRequire("adhut");

var $gZMJv = parcelRequire("gZMJv");

var $iNmcA = parcelRequire("iNmcA");

var $7FwaV = parcelRequire("7FwaV");

var $l6BwZ = parcelRequire("l6BwZ");

var $2Nl6b = parcelRequire("2Nl6b");
const $1a101a2ea5c41299$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $1a101a2ea5c41299$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $4aRup.extractEventInfo)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $2TAQS.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $heQzy.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $gZMJv.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $3VmRs.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $2Nl6b.frame).postRender(()=>onDragStart(event, info));
            (0, $l6BwZ.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $1a101a2ea5c41299$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $heQzy.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $fmqnM.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $7FwaV.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $2Nl6b.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $hWwZH.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $dnjlm.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $hWwZH.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $hWwZH.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $heQzy.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $hWwZH.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $dnjlm.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $anHVs.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $5HNVc.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $hWwZH.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $dIeCo.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $dIeCo.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $heQzy.eachAxis)((axis)=>{
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $l6BwZ.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, $iNmcA.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $heQzy.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $heQzy.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $heQzy.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $adhut.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $dnjlm.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $heQzy.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $hWwZH.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $heQzy.eachAxis)((axis)=>{
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $adhut.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $1a101a2ea5c41299$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $6ChET.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $dnjlm.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $2Nl6b.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $jgx8I.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $heQzy.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $hWwZH.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $5C3hG.createBox)();
        this.visualElement = visualElement;
    }
}
function $1a101a2ea5c41299$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $1a101a2ea5c41299$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("fmqnM", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $ef854c4580045766$export$d9c66232c9c4689c; });

var $4aRup = parcelRequire("4aRup");

var $51Nkl = parcelRequire("51Nkl");

var $6ChET = parcelRequire("6ChET");

var $ebjvn = parcelRequire("ebjvn");

var $1hzCz = parcelRequire("1hzCz");

var $dpmqz = parcelRequire("dpmqz");

var $2Nl6b = parcelRequire("2Nl6b");
/**
 * @internal
 */ class $ef854c4580045766$export$d9c66232c9c4689c {
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $2Nl6b.cancelFrame)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $ef854c4580045766$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $1hzCz.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $2Nl6b.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $ef854c4580045766$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $2Nl6b.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $ef854c4580045766$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $ef854c4580045766$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $dpmqz.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $4aRup.extractEventInfo)(event);
        const initialInfo = $ef854c4580045766$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $2Nl6b.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $ef854c4580045766$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $ebjvn.pipe)((0, $6ChET.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $6ChET.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $6ChET.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
}
function $ef854c4580045766$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $ef854c4580045766$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $ef854c4580045766$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $ef854c4580045766$var$subtractPoint(point, $ef854c4580045766$var$lastDevicePoint(history)),
        offset: $ef854c4580045766$var$subtractPoint(point, $ef854c4580045766$var$startDevicePoint(history)),
        velocity: $ef854c4580045766$var$getVelocity(history, 0.1)
    };
}
function $ef854c4580045766$var$startDevicePoint(history) {
    return history[0];
}
function $ef854c4580045766$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $ef854c4580045766$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $ef854c4580045766$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $51Nkl.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $51Nkl.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("4aRup", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $3973bb66157269f5$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $3973bb66157269f5$export$c404e80f92c98d29; });

var $dpmqz = parcelRequire("dpmqz");
function $3973bb66157269f5$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $3973bb66157269f5$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $dpmqz.isPrimaryPointer)(event) && handler(event, $3973bb66157269f5$export$12f84bb882d06e1a(event));
};

});
parcelRegister("dpmqz", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $03138406f951404f$export$a4cf9c8a4b063a6e; });
const $03138406f951404f$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});


parcelRegister("6ChET", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $519633bd86d65117$export$fcff2e64e6676b81; });

var $jgx8I = parcelRequire("jgx8I");

var $4aRup = parcelRequire("4aRup");
function $519633bd86d65117$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $jgx8I.addDomEvent)(target, eventName, (0, $4aRup.addPointerInfo)(handler), options);
}

});
parcelRegister("jgx8I", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $372c30b69d6f2c21$export$b1d829ddf82884aa; });
function $372c30b69d6f2c21$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});


parcelRegister("1hzCz", function(module, exports) {

$parcel$export(module.exports, "distance2D", function () { return $3a80065f413f90ab$export$503a1d513f12e38b; });
const $3a80065f413f90ab$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $3a80065f413f90ab$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $3a80065f413f90ab$export$9f17032d917177de(a.x, b.x);
    const yDelta = $3a80065f413f90ab$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("2TAQS", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $1fad98f38f0015a9$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $1fad98f38f0015a9$export$1b3dd616664938e4; });
function $1fad98f38f0015a9$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $1fad98f38f0015a9$var$globalHorizontalLock = $1fad98f38f0015a9$export$518c5fc2dcb7974b("dragHorizontal");
const $1fad98f38f0015a9$var$globalVerticalLock = $1fad98f38f0015a9$export$518c5fc2dcb7974b("dragVertical");
function $1fad98f38f0015a9$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $1fad98f38f0015a9$var$globalVerticalLock();
    else if (drag === "x") lock = $1fad98f38f0015a9$var$globalHorizontalLock();
    else {
        const openHorizontal = $1fad98f38f0015a9$var$globalHorizontalLock();
        const openVertical = $1fad98f38f0015a9$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $1fad98f38f0015a9$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $1fad98f38f0015a9$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});

parcelRegister("dnjlm", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $fa1715e05876aeaf$export$dedd81df7bc1307; });
function $fa1715e05876aeaf$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("hWwZH", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $747d608f57b73033$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $747d608f57b73033$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $747d608f57b73033$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $747d608f57b73033$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $747d608f57b73033$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $747d608f57b73033$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $747d608f57b73033$export$7c5eaef8f4723d22; });

var $3iMBi = parcelRequire("3iMBi");

var $3VmRs = parcelRequire("3VmRs");

var $g7qLA = parcelRequire("g7qLA");

var $adhut = parcelRequire("adhut");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $747d608f57b73033$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $adhut.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $adhut.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $747d608f57b73033$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $747d608f57b73033$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $747d608f57b73033$export$690c180aa5775042(layoutBox.x, left, right),
        y: $747d608f57b73033$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $747d608f57b73033$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $747d608f57b73033$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $747d608f57b73033$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $747d608f57b73033$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $747d608f57b73033$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $3VmRs.calcLength)(source);
    const targetLength = (0, $3VmRs.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $3iMBi.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3iMBi.progress)(source.min, source.max - targetLength, target.min);
    return (0, $g7qLA.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $747d608f57b73033$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $747d608f57b73033$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $747d608f57b73033$export$7c5eaef8f4723d22(dragElastic = $747d608f57b73033$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $747d608f57b73033$export$a3366d3bac43a742;
    return {
        x: $747d608f57b73033$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $747d608f57b73033$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $747d608f57b73033$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});
parcelRegister("3VmRs", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $ef13499fe6809d49$export$c1c127004b72a37; });
$parcel$export(module.exports, "isNear", function () { return $ef13499fe6809d49$export$28d0384c4b79bde2; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $ef13499fe6809d49$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $ef13499fe6809d49$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $ef13499fe6809d49$export$2785bfcc929c5650; });

var $adhut = parcelRequire("adhut");
const $ef13499fe6809d49$var$SCALE_PRECISION = 0.0001;
const $ef13499fe6809d49$var$SCALE_MIN = 1 - $ef13499fe6809d49$var$SCALE_PRECISION;
const $ef13499fe6809d49$var$SCALE_MAX = 1 + $ef13499fe6809d49$var$SCALE_PRECISION;
const $ef13499fe6809d49$var$TRANSLATE_PRECISION = 0.01;
const $ef13499fe6809d49$var$TRANSLATE_MIN = 0 - $ef13499fe6809d49$var$TRANSLATE_PRECISION;
const $ef13499fe6809d49$var$TRANSLATE_MAX = 0 + $ef13499fe6809d49$var$TRANSLATE_PRECISION;
function $ef13499fe6809d49$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $ef13499fe6809d49$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $adhut.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $ef13499fe6809d49$export$c1c127004b72a37(target) / $ef13499fe6809d49$export$c1c127004b72a37(source);
    delta.translate = (0, $adhut.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $ef13499fe6809d49$var$SCALE_MIN && delta.scale <= $ef13499fe6809d49$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $ef13499fe6809d49$var$TRANSLATE_MIN && delta.translate <= $ef13499fe6809d49$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $ef13499fe6809d49$export$c0d25e96fc67d310(delta, source, target, origin) {
    $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $ef13499fe6809d49$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $ef13499fe6809d49$export$c1c127004b72a37(relative);
}
function $ef13499fe6809d49$export$426154f9d100f99(target, relative, parent) {
    $ef13499fe6809d49$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $ef13499fe6809d49$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $ef13499fe6809d49$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $ef13499fe6809d49$export$c1c127004b72a37(layout);
}
function $ef13499fe6809d49$export$2785bfcc929c5650(target, layout, parent) {
    $ef13499fe6809d49$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $ef13499fe6809d49$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("5C3hG", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $170bad49d6474b42$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $170bad49d6474b42$export$6459fc9e86be362e; });
const $170bad49d6474b42$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $170bad49d6474b42$export$3d227df54007d73a = ()=>({
        x: $170bad49d6474b42$export$ff25708b37f72782(),
        y: $170bad49d6474b42$export$ff25708b37f72782()
    });
const $170bad49d6474b42$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $170bad49d6474b42$export$6459fc9e86be362e = ()=>({
        x: $170bad49d6474b42$export$6db76765312617ac(),
        y: $170bad49d6474b42$export$6db76765312617ac()
    });

});

parcelRegister("heQzy", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $7d553f96a693c19c$export$b789de563eb43b1; });
function $7d553f96a693c19c$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("5HNVc", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $af396e08e7154fa7$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $af396e08e7154fa7$export$6a597be7a7940a96; });

var $dIeCo = parcelRequire("dIeCo");

var $aHGN6 = parcelRequire("aHGN6");
function $af396e08e7154fa7$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $dIeCo.convertBoundingBoxToBox)((0, $dIeCo.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $af396e08e7154fa7$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $af396e08e7154fa7$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $aHGN6.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $aHGN6.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("dIeCo", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $0d09a26902ac99cd$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $0d09a26902ac99cd$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $0d09a26902ac99cd$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0d09a26902ac99cd$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0d09a26902ac99cd$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0d09a26902ac99cd$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("aHGN6", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $9bd1f649500a03c5$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $9bd1f649500a03c5$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $9bd1f649500a03c5$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $9bd1f649500a03c5$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $9bd1f649500a03c5$export$a807a5ce5ebb3895; });

var $adhut = parcelRequire("adhut");

var $aOn1d = parcelRequire("aOn1d");
/**
 * Scales a point based on a factor and an originPoint
 */ function $9bd1f649500a03c5$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $9bd1f649500a03c5$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $9bd1f649500a03c5$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $9bd1f649500a03c5$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $9bd1f649500a03c5$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $9bd1f649500a03c5$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $9bd1f649500a03c5$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $9bd1f649500a03c5$export$d80074982803af5c(box, { x: x, y: y }) {
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $9bd1f649500a03c5$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $9bd1f649500a03c5$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $9bd1f649500a03c5$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $aOn1d.hasTransform)(node.latestValues)) $9bd1f649500a03c5$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX && treeScale.x > $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX && treeScale.y > $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $9bd1f649500a03c5$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $9bd1f649500a03c5$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $adhut.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $9bd1f649500a03c5$export$58b16271041fbfb(box, transform) {
    $9bd1f649500a03c5$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $9bd1f649500a03c5$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("aOn1d", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $e6914cf5f005c58a$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $e6914cf5f005c58a$export$a545127cf1fbb600; });
$parcel$export(module.exports, "has2DTranslate", function () { return $e6914cf5f005c58a$export$bf80f5f8f4dc327f; });
function $e6914cf5f005c58a$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $e6914cf5f005c58a$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$e6914cf5f005c58a$var$isIdentityScale(scale) || !$e6914cf5f005c58a$var$isIdentityScale(scaleX) || !$e6914cf5f005c58a$var$isIdentityScale(scaleY);
}
function $e6914cf5f005c58a$export$a545127cf1fbb600(values) {
    return $e6914cf5f005c58a$export$bdf30dca883ea463(values) || $e6914cf5f005c58a$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $e6914cf5f005c58a$export$bf80f5f8f4dc327f(values) {
    return $e6914cf5f005c58a$var$is2DTranslate(values.x) || $e6914cf5f005c58a$var$is2DTranslate(values.y);
}
function $e6914cf5f005c58a$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("7FwaV", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", function () { return $8cc2e4c5ec757f0a$export$d533d84f9871c879; });
// Fixes https://github.com/framer/motion/issues/2270
const $8cc2e4c5ec757f0a$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});



parcelRegister("ke27I", function(module, exports) {

$parcel$export(module.exports, "PanGesture", function () { return $06e74a33ef2dab00$export$b4f8f1ee75ce5859; });

var $fmqnM = parcelRequire("fmqnM");

var $6ChET = parcelRequire("6ChET");

var $5a6cH = parcelRequire("5a6cH");

var $k1qMD = parcelRequire("k1qMD");

var $7FwaV = parcelRequire("7FwaV");

var $2Nl6b = parcelRequire("2Nl6b");
const $06e74a33ef2dab00$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $2Nl6b.frame).postRender(()=>handler(event, info));
    };
class $06e74a33ef2dab00$export$b4f8f1ee75ce5859 extends (0, $5a6cH.Feature) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $fmqnM.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $7FwaV.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $06e74a33ef2dab00$var$asyncHandler(onPanSessionStart),
            onStart: $06e74a33ef2dab00$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $2Nl6b.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $6ChET.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $k1qMD.noop);
    }
}

});

parcelRegister("7ygmr", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $ceff8b5500f61dba$export$779f5fb01ad751cd; });

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $h28QO = parcelRequire("h28QO");

var $heYxd = parcelRequire("heYxd");

var $lPrUj = parcelRequire("lPrUj");

var $lcpcj = parcelRequire("lcpcj");

var $lKcdl = parcelRequire("lKcdl");

var $bQTEk = parcelRequire("bQTEk");

var $fwXkk = parcelRequire("fwXkk");

var $2g0zK = parcelRequire("2g0zK");

var $2Nl6b = parcelRequire("2Nl6b");
"use client";
class $ceff8b5500f61dba$var$MeasureLayoutWithContext extends (0, $eZVvM.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $fwXkk.addScaleCorrector)($ceff8b5500f61dba$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $lcpcj.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $2Nl6b.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $2g0zK.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $ceff8b5500f61dba$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $h28QO.usePresence)();
    const layoutGroup = (0, $eZVvM.useContext)((0, $heYxd.LayoutGroupContext));
    return (0, $3pI8R.jsx)($ceff8b5500f61dba$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $eZVvM.useContext)((0, $lPrUj.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $ceff8b5500f61dba$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $lKcdl.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $lKcdl.correctBorderRadius),
    borderTopRightRadius: (0, $lKcdl.correctBorderRadius),
    borderBottomLeftRadius: (0, $lKcdl.correctBorderRadius),
    borderBottomRightRadius: (0, $lKcdl.correctBorderRadius),
    boxShadow: (0, $bQTEk.correctBoxShadow)
};

});
parcelRegister("h28QO", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $713a31a7394b6900$export$2a8c16d82a0a0e26; });

var $eZVvM = parcelRequire("eZVvM");

var $4J6gH = parcelRequire("4J6gH");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $713a31a7394b6900$export$2a8c16d82a0a0e26() {
    const context = (0, $eZVvM.useContext)((0, $4J6gH.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $eZVvM.useId)();
    (0, $eZVvM.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $eZVvM.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $713a31a7394b6900$export$8249053f690ea39a() {
    return $713a31a7394b6900$export$ee27c052bca048fb((0, $eZVvM.useContext)((0, $4J6gH.PresenceContext)));
}
function $713a31a7394b6900$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});
parcelRegister("4J6gH", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $530f496ded9f62d9$export$f224e4635b6f8ce2; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @public
 */ const $530f496ded9f62d9$export$f224e4635b6f8ce2 = (0, $eZVvM.createContext)(null);

});


parcelRegister("heYxd", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $7e2e92a55d7a9c1e$export$a3579ca508007a95; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $7e2e92a55d7a9c1e$export$a3579ca508007a95 = (0, $eZVvM.createContext)({});

});

parcelRegister("lPrUj", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $e945ab81c792e439$export$da5f7b802957459a; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $e945ab81c792e439$export$da5f7b802957459a = (0, $eZVvM.createContext)({});

});

parcelRegister("lcpcj", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $8984818e8f2095fa$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $8984818e8f2095fa$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("lKcdl", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $7250ef2cfea8923f$export$5eafb6257a5844c; });

var $gZMJv = parcelRequire("gZMJv");
function $7250ef2cfea8923f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $7250ef2cfea8923f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $gZMJv.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $7250ef2cfea8923f$export$fafff692be55225d(latest, node.target.x);
        const y = $7250ef2cfea8923f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("bQTEk", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $6a0d39815295fa9d$export$eb0bc629e74dcf8; });

var $adhut = parcelRequire("adhut");

var $4H4W5 = parcelRequire("4H4W5");
const $6a0d39815295fa9d$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4H4W5.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4H4W5.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $adhut.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});

parcelRegister("fwXkk", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $8e2ec80617e1ef23$export$91ddd985b97788d1; });
$parcel$export(module.exports, "addScaleCorrector", function () { return $8e2ec80617e1ef23$export$de9e7791c71225fd; });
const $8e2ec80617e1ef23$export$91ddd985b97788d1 = {};
function $8e2ec80617e1ef23$export$de9e7791c71225fd(correctors) {
    Object.assign($8e2ec80617e1ef23$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("2g0zK", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $4ec28bebfef34728$export$bb76eed83315504c; });

var $lMJcW = parcelRequire("lMJcW");
const { schedule: $4ec28bebfef34728$export$bb76eed83315504c, cancel: $4ec28bebfef34728$export$3252729004b8456e } = (0, $lMJcW.createRenderBatcher)(queueMicrotask, false);

});


parcelRegister("8j6Ur", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $3503f60faeb40f4f$export$b61a9eb3dbde8858; });

var $dvEPg = parcelRequire("dvEPg");

var $iNTw6 = parcelRequire("iNTw6");
const $3503f60faeb40f4f$export$b91509fcf893b648 = {
    current: undefined
};
const $3503f60faeb40f4f$export$b61a9eb3dbde8858 = (0, $dvEPg.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$3503f60faeb40f4f$export$b91509fcf893b648.current) {
            const documentNode = new (0, $iNTw6.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $3503f60faeb40f4f$export$b91509fcf893b648.current = documentNode;
        }
        return $3503f60faeb40f4f$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("dvEPg", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $58387390232a1cd0$export$a84b61f69daa9da0; });

var $3BCsP = parcelRequire("3BCsP");

var $eE1Ve = parcelRequire("eE1Ve");

var $ek279 = parcelRequire("ek279");

var $aHGN6 = parcelRequire("aHGN6");

var $3VmRs = parcelRequire("3VmRs");

var $go2R4 = parcelRequire("go2R4");

var $dyEGF = parcelRequire("dyEGF");

var $crKnd = parcelRequire("crKnd");

var $fr4WZ = parcelRequire("fr4WZ");

var $fwXkk = parcelRequire("fwXkk");

var $5e5Hg = parcelRequire("5e5Hg");

var $heQzy = parcelRequire("heQzy");

var $aOn1d = parcelRequire("aOn1d");

var $a60ax = parcelRequire("a60ax");

var $ajp7r = parcelRequire("ajp7r");

var $lcpcj = parcelRequire("lcpcj");

var $3Rdwx = parcelRequire("3Rdwx");

var $adhut = parcelRequire("adhut");

var $is2J0 = parcelRequire("is2J0");

var $3m3Kz = parcelRequire("3m3Kz");

var $g7qLA = parcelRequire("g7qLA");

var $2Nl6b = parcelRequire("2Nl6b");

var $k1qMD = parcelRequire("k1qMD");

var $1lF7N = parcelRequire("1lF7N");

var $2g0zK = parcelRequire("2g0zK");

var $5IkJq = parcelRequire("5IkJq");

var $5C3hG = parcelRequire("5C3hG");
const $58387390232a1cd0$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $58387390232a1cd0$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $58387390232a1cd0$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $58387390232a1cd0$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $58387390232a1cd0$var$animationTarget = 1000;
let $58387390232a1cd0$var$id = 0;
function $58387390232a1cd0$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $5IkJq.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $2Nl6b.frame), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $58387390232a1cd0$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $3BCsP.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $is2J0.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $3Rdwx.delay)(resizeUnblockUpdate, 250);
                    if ((0, $lcpcj.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $lcpcj.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($58387390232a1cd0$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $58387390232a1cd0$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $crKnd.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $dyEGF.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $58387390232a1cd0$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $2Nl6b.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($58387390232a1cd0$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($58387390232a1cd0$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($58387390232a1cd0$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($58387390232a1cd0$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($58387390232a1cd0$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($58387390232a1cd0$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $1lF7N.time).now();
            (0, $2Nl6b.frameData).delta = (0, $g7qLA.clamp)(0, 1000 / 60, now - (0, $2Nl6b.frameData).timestamp);
            (0, $2Nl6b.frameData).timestamp = now;
            (0, $2Nl6b.frameData).isProcessing = true;
            (0, $2Nl6b.frameSteps).update.process((0, $2Nl6b.frameData));
            (0, $2Nl6b.frameSteps).preRender.process((0, $2Nl6b.frameData));
            (0, $2Nl6b.frameSteps).render.process((0, $2Nl6b.frameData));
            (0, $2Nl6b.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $2g0zK.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($58387390232a1cd0$var$clearSnapshot);
            this.sharedNodes.forEach($58387390232a1cd0$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $2Nl6b.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $2Nl6b.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $5C3hG.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $crKnd.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $aOn1d.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $58387390232a1cd0$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $5C3hG.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($58387390232a1cd0$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $aHGN6.translateAxis)(box.x, scroll.offset.x);
                    (0, $aHGN6.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $5C3hG.createBox)();
            (0, $ek279.copyBoxInto)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $ek279.copyBoxInto)(boxWithoutScroll, box);
                    (0, $aHGN6.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $aHGN6.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $5C3hG.createBox)();
            (0, $ek279.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $aHGN6.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $aOn1d.hasTransform)(node.latestValues)) continue;
                (0, $aHGN6.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $aOn1d.hasTransform)(this.latestValues)) (0, $aHGN6.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $5C3hG.createBox)();
            (0, $ek279.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $aOn1d.hasTransform)(node.latestValues)) continue;
                (0, $aOn1d.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $5C3hG.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $ek279.copyBoxInto)(sourceBox, nodeBox);
                (0, $go2R4.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $aOn1d.hasTransform)(this.latestValues)) (0, $go2R4.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $2Nl6b.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $2Nl6b.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $5C3hG.createBox)();
                    this.relativeTargetOrigin = (0, $5C3hG.createBox)();
                    (0, $3VmRs.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $ek279.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $5C3hG.createBox)();
                this.targetWithTransforms = (0, $5C3hG.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $3VmRs.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $ek279.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $aHGN6.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $ek279.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $5C3hG.createBox)();
                    this.relativeTargetOrigin = (0, $5C3hG.createBox)();
                    (0, $3VmRs.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $ek279.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $aOn1d.hasScale)(this.parent.latestValues) || (0, $aOn1d.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $2Nl6b.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $ek279.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $aHGN6.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $5C3hG.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $ek279.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $ek279.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $3VmRs.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $crKnd.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $crKnd.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $5C3hG.createDelta)();
            this.projectionDelta = (0, $5C3hG.createDelta)();
            this.projectionDeltaWithTransform = (0, $5C3hG.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $5C3hG.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $5C3hG.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($58387390232a1cd0$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $58387390232a1cd0$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $58387390232a1cd0$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $3VmRs.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $58387390232a1cd0$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $crKnd.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $5C3hG.createBox)();
                    (0, $ek279.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $eE1Ve.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $2Nl6b.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $2Nl6b.frame).update(()=>{
                (0, $lcpcj.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $3m3Kz.animateSingleValue)(0, $58387390232a1cd0$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($58387390232a1cd0$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $58387390232a1cd0$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $5C3hG.createBox)();
                const xLength = (0, $3VmRs.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $3VmRs.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $ek279.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $aHGN6.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $3VmRs.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $fr4WZ.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $58387390232a1cd0$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $58387390232a1cd0$var$transformAxes.length; i++){
                $58387390232a1cd0$var$resetDistortingTransform(`rotate${$58387390232a1cd0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $58387390232a1cd0$var$resetDistortingTransform(`skew${$58387390232a1cd0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $58387390232a1cd0$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $ajp7r.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $ajp7r.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $aOn1d.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $5e5Hg.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $fwXkk.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $fwXkk.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $ajp7r.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($58387390232a1cd0$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $58387390232a1cd0$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.totalNodes = $58387390232a1cd0$var$metrics.resolvedTargetDeltas = $58387390232a1cd0$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($58387390232a1cd0$export$131f2f0cc5fe9609);
                this.nodes.forEach($58387390232a1cd0$var$resolveTargetDelta);
                this.nodes.forEach($58387390232a1cd0$var$calcProjection);
                this.nodes.forEach($58387390232a1cd0$export$c2664f37bc951031);
                if ($58387390232a1cd0$var$isDebug) window.MotionDebug.record($58387390232a1cd0$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $a60ax.FlatTree)();
        }
    };
}
function $58387390232a1cd0$var$updateLayout(node) {
    node.updateLayout();
}
function $58387390232a1cd0$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $heQzy.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3VmRs.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($58387390232a1cd0$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $heQzy.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3VmRs.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $5C3hG.createDelta)();
        (0, $3VmRs.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $5C3hG.createDelta)();
        if (isShared) (0, $3VmRs.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $3VmRs.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $crKnd.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $5C3hG.createBox)();
                    (0, $3VmRs.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $5C3hG.createBox)();
                    (0, $3VmRs.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $crKnd.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $58387390232a1cd0$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $58387390232a1cd0$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $58387390232a1cd0$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $58387390232a1cd0$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $58387390232a1cd0$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $58387390232a1cd0$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $58387390232a1cd0$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $58387390232a1cd0$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $58387390232a1cd0$var$calcProjection(node) {
    node.calcProjection();
}
function $58387390232a1cd0$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $58387390232a1cd0$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $58387390232a1cd0$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $adhut.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $adhut.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $58387390232a1cd0$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $adhut.mixNumber)(from.min, to.min, p);
    output.max = (0, $adhut.mixNumber)(from.max, to.max, p);
}
function $58387390232a1cd0$export$6ffd3e6ae339a132(output, from, to, p) {
    $58387390232a1cd0$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $58387390232a1cd0$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $58387390232a1cd0$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $58387390232a1cd0$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $58387390232a1cd0$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $58387390232a1cd0$var$roundPoint = $58387390232a1cd0$var$userAgentContains("applewebkit/") && !$58387390232a1cd0$var$userAgentContains("chrome/") ? Math.round : (0, $k1qMD.noop);
function $58387390232a1cd0$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $58387390232a1cd0$var$roundPoint(axis.min);
    axis.max = $58387390232a1cd0$var$roundPoint(axis.max);
}
function $58387390232a1cd0$var$roundBox(box) {
    $58387390232a1cd0$var$roundAxis(box.x);
    $58387390232a1cd0$var$roundAxis(box.y);
}
function $58387390232a1cd0$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $3VmRs.isNear)((0, $crKnd.aspectRatio)(snapshot), (0, $crKnd.aspectRatio)(layout), 0.2);
}
function $58387390232a1cd0$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}

});
parcelRegister("eE1Ve", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $6115e7b48b87f673$export$739e279c17d51c3d; });

var $02TSt = parcelRequire("02TSt");

var $3iMBi = parcelRequire("3iMBi");

var $adhut = parcelRequire("adhut");

var $k1qMD = parcelRequire("k1qMD");

var $gZMJv = parcelRequire("gZMJv");
const $6115e7b48b87f673$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $6115e7b48b87f673$var$numBorders = $6115e7b48b87f673$var$borders.length;
const $6115e7b48b87f673$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $6115e7b48b87f673$var$isPx = (value)=>typeof value === "number" || (0, $gZMJv.px).test(value);
function $6115e7b48b87f673$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $adhut.mixNumber)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $6115e7b48b87f673$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $adhut.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, 0, $6115e7b48b87f673$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $adhut.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $6115e7b48b87f673$var$numBorders; i++){
        const borderLabel = `border${$6115e7b48b87f673$var$borders[i]}Radius`;
        let followRadius = $6115e7b48b87f673$var$getRadius(follow, borderLabel);
        let leadRadius = $6115e7b48b87f673$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $6115e7b48b87f673$var$isPx(followRadius) === $6115e7b48b87f673$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $adhut.mixNumber)($6115e7b48b87f673$var$asNumber(followRadius), $6115e7b48b87f673$var$asNumber(leadRadius), progress), 0);
            if ((0, $gZMJv.percent).test(leadRadius) || (0, $gZMJv.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $adhut.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $6115e7b48b87f673$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $6115e7b48b87f673$var$easeCrossfadeIn = /*@__PURE__*/ $6115e7b48b87f673$var$compress(0, 0.5, (0, $02TSt.circOut));
const $6115e7b48b87f673$var$easeCrossfadeOut = /*@__PURE__*/ $6115e7b48b87f673$var$compress(0.5, 0.95, (0, $k1qMD.noop));
function $6115e7b48b87f673$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3iMBi.progress)(min, max, p));
    };
}

});

parcelRegister("ek279", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $f69304d5afe27751$export$c53fd88f45d77e4b; });
$parcel$export(module.exports, "copyAxisDeltaInto", function () { return $f69304d5afe27751$export$8ead6a7d6b225ef; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$c53fd88f45d77e4b(box, originBox) {
    $f69304d5afe27751$export$a0230ae482601ae8(box.x, originBox.x);
    $f69304d5afe27751$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("go2R4", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $dc5d198bbbf3edd7$export$73e1ad0a9694e25c; });

var $adhut = parcelRequire("adhut");

var $gZMJv = parcelRequire("gZMJv");

var $aHGN6 = parcelRequire("aHGN6");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $dc5d198bbbf3edd7$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $aHGN6.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $aHGN6.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $dc5d198bbbf3edd7$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $gZMJv.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $adhut.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $adhut.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $dc5d198bbbf3edd7$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $dc5d198bbbf3edd7$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $dc5d198bbbf3edd7$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $dc5d198bbbf3edd7$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $dc5d198bbbf3edd7$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $dc5d198bbbf3edd7$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(box.x, transforms, $dc5d198bbbf3edd7$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(box.y, transforms, $dc5d198bbbf3edd7$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("crKnd", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $886bcb20f3366154$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $886bcb20f3366154$export$8d5cf76bb7daff09; });
$parcel$export(module.exports, "boxEqualsRounded", function () { return $886bcb20f3366154$export$ef641b782d85522; });
$parcel$export(module.exports, "aspectRatio", function () { return $886bcb20f3366154$export$c5706146bc63213; });
$parcel$export(module.exports, "axisDeltaEquals", function () { return $886bcb20f3366154$export$444620505e28fe92; });

var $3VmRs = parcelRequire("3VmRs");
function $886bcb20f3366154$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $886bcb20f3366154$export$a7ec7642fe550fb6(delta) {
    return $886bcb20f3366154$var$isAxisDeltaZero(delta.x) && $886bcb20f3366154$var$isAxisDeltaZero(delta.y);
}
function $886bcb20f3366154$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $886bcb20f3366154$export$8d5cf76bb7daff09(a, b) {
    return $886bcb20f3366154$export$7a9a6f114ddd0fdb(a.x, b.x) && $886bcb20f3366154$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $886bcb20f3366154$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $886bcb20f3366154$export$ef641b782d85522(a, b) {
    return $886bcb20f3366154$export$22adf28bfca1c186(a.x, b.x) && $886bcb20f3366154$export$22adf28bfca1c186(a.y, b.y);
}
function $886bcb20f3366154$export$c5706146bc63213(box) {
    return (0, $3VmRs.calcLength)(box.x) / (0, $3VmRs.calcLength)(box.y);
}
function $886bcb20f3366154$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("fr4WZ", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $e5b4fbacfb22473f$export$39be5b2d82fc9dc7; });

var $kzf7n = parcelRequire("kzf7n");
class $e5b4fbacfb22473f$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $kzf7n.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $kzf7n.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}

});

parcelRegister("5e5Hg", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $3650b320a42adb91$export$d33653b270fe725c; });
function $3650b320a42adb91$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});

parcelRegister("a60ax", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $955760a84a2f4a81$export$1465d17e3de78a96; });

var $kzf7n = parcelRequire("kzf7n");

var $7qJ29 = parcelRequire("7qJ29");
class $955760a84a2f4a81$export$1465d17e3de78a96 {
    add(child) {
        (0, $kzf7n.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $kzf7n.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $7qJ29.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}

});
parcelRegister("7qJ29", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $f9679643622f85f4$export$d689d9dec5ad338; });
const $f9679643622f85f4$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("ajp7r", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $53c337dee8f3fdb5$export$fcc2206ecb6d74b; });

var $8Bbb1 = parcelRequire("8Bbb1");

var $1y4u0 = parcelRequire("1y4u0");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $53c337dee8f3fdb5$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $1y4u0.isMotionValue)(value) ? value.get() : value;
    return (0, $8Bbb1.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});

parcelRegister("3Rdwx", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $76504413525f8d84$export$1391212d75b2ee65; });

var $1lF7N = parcelRequire("1lF7N");

var $51Nkl = parcelRequire("51Nkl");

var $2Nl6b = parcelRequire("2Nl6b");
/**
 * Timeout defined in ms
 */ function $76504413525f8d84$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $1lF7N.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $2Nl6b.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $2Nl6b.frame).read(checkElapsed, true);
    return ()=>(0, $2Nl6b.cancelFrame)(checkElapsed);
}
function $76504413525f8d84$export$fcd451ca460f8a2a(callback, timeout) {
    return $76504413525f8d84$export$1391212d75b2ee65(callback, (0, $51Nkl.secondsToMilliseconds)(timeout));
}

});

parcelRegister("is2J0", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $6b7ef932b26b3539$export$17eda790a720ec57; });
function $6b7ef932b26b3539$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

});

parcelRegister("3m3Kz", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $34d9db4f3fd363f3$export$335a17c977067b99; });

var $iNmcA = parcelRequire("iNmcA");

var $4oNvX = parcelRequire("4oNvX");

var $1y4u0 = parcelRequire("1y4u0");
function $34d9db4f3fd363f3$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $1y4u0.isMotionValue)(value) ? value : (0, $4oNvX.motionValue)(value);
    motionValue$1.start((0, $iNmcA.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});


parcelRegister("iNTw6", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $f31e67b7be9ea466$export$2d029a49a09b6177; });

var $dvEPg = parcelRequire("dvEPg");

var $jgx8I = parcelRequire("jgx8I");
const $f31e67b7be9ea466$export$2d029a49a09b6177 = (0, $dvEPg.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $jgx8I.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("fqXV2", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $dadb9870f108e4b7$export$e5b72898e5a201f1; });

var $1Z1s9 = parcelRequire("1Z1s9");

var $6SeT6 = parcelRequire("6SeT6");

var $k1hOl = parcelRequire("k1hOl");

var $7edfY = parcelRequire("7edfY");
const $dadb9870f108e4b7$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $7edfY.InViewFeature)
    },
    tap: {
        Feature: (0, $k1hOl.PressGesture)
    },
    focus: {
        Feature: (0, $6SeT6.FocusGesture)
    },
    hover: {
        Feature: (0, $1Z1s9.HoverGesture)
    }
};

});
parcelRegister("1Z1s9", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $43173942d5616c32$export$93a81ea037eac456; });

var $6ChET = parcelRequire("6ChET");

var $ebjvn = parcelRequire("ebjvn");

var $2TAQS = parcelRequire("2TAQS");

var $5a6cH = parcelRequire("5a6cH");

var $2Nl6b = parcelRequire("2Nl6b");
function $43173942d5616c32$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $2TAQS.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $2Nl6b.frame).postRender(()=>callback(event, info));
    };
    return (0, $6ChET.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $43173942d5616c32$export$93a81ea037eac456 extends (0, $5a6cH.Feature) {
    mount() {
        this.unmount = (0, $ebjvn.pipe)($43173942d5616c32$var$addHoverEvent(this.node, true), $43173942d5616c32$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});

parcelRegister("6SeT6", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $8ba2e2c9068ea11a$export$d4826db40d47595b; });

var $jgx8I = parcelRequire("jgx8I");

var $5a6cH = parcelRequire("5a6cH");

var $ebjvn = parcelRequire("ebjvn");
class $8ba2e2c9068ea11a$export$d4826db40d47595b extends (0, $5a6cH.Feature) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $ebjvn.pipe)((0, $jgx8I.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $jgx8I.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}

});

parcelRegister("k1hOl", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $e79daae17b0515ea$export$f026abdbba7f0c9e; });

var $4aRup = parcelRequire("4aRup");

var $jgx8I = parcelRequire("jgx8I");

var $6ChET = parcelRequire("6ChET");

var $5a6cH = parcelRequire("5a6cH");

var $ebjvn = parcelRequire("ebjvn");

var $2TAQS = parcelRequire("2TAQS");

var $6ThQ0 = parcelRequire("6ThQ0");

var $k1qMD = parcelRequire("k1qMD");

var $2Nl6b = parcelRequire("2Nl6b");
function $e79daae17b0515ea$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $4aRup.extractEventInfo)(syntheticPointerEvent));
}
class $e79daae17b0515ea$export$f026abdbba7f0c9e extends (0, $5a6cH.Feature) {
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $2Nl6b.frame).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $2TAQS.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $2Nl6b.frame).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $6ChET.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $jgx8I.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $ebjvn.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $k1qMD.noop);
        this.removeEndListeners = (0, $k1qMD.noop);
        this.removeAccessibleListeners = (0, $k1qMD.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $6ThQ0.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $2Nl6b.frame).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $6ChET.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $6ChET.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $ebjvn.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $e79daae17b0515ea$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $2Nl6b.frame).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $jgx8I.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $e79daae17b0515ea$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $jgx8I.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $e79daae17b0515ea$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $jgx8I.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $ebjvn.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
}

});
parcelRegister("6ThQ0", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $b0540c4ff22b990c$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $b0540c4ff22b990c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $b0540c4ff22b990c$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("7edfY", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $1147643d182545be$export$150851c8cc2f0c72; });

var $5a6cH = parcelRequire("5a6cH");

var $f9T6l = parcelRequire("f9T6l");
const $1147643d182545be$var$thresholdNames = {
    some: 0,
    all: 1
};
class $1147643d182545be$export$150851c8cc2f0c72 extends (0, $5a6cH.Feature) {
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $1147643d182545be$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $f9T6l.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($1147643d182545be$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $1147643d182545be$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("f9T6l", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $65e6f67a48960f82$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $65e6f67a48960f82$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $65e6f67a48960f82$var$observers = new WeakMap();
const $65e6f67a48960f82$var$fireObserverCallback = (entry)=>{
    const callback = $65e6f67a48960f82$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $65e6f67a48960f82$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($65e6f67a48960f82$var$fireObserverCallback);
};
function $65e6f67a48960f82$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$65e6f67a48960f82$var$observers.has(lookupRoot)) $65e6f67a48960f82$var$observers.set(lookupRoot, {});
    const rootObservers = $65e6f67a48960f82$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($65e6f67a48960f82$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $65e6f67a48960f82$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $65e6f67a48960f82$var$initIntersectionObserver(options);
    $65e6f67a48960f82$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $65e6f67a48960f82$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("94Wls", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $74b97b9c8ba46a5b$export$b3219800bda33a1f; });

var $8j6Ur = parcelRequire("8j6Ur");

var $7ygmr = parcelRequire("7ygmr");
const $74b97b9c8ba46a5b$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $8j6Ur.HTMLProjectionNode),
        MeasureLayout: $7ygmr.MeasureLayout
    }
};

});

parcelRegister("iPm9H", function(module, exports) {

$parcel$export(module.exports, "createMotionComponentFactory", function () { return $2eed622a74005592$export$d86feac869a7f0d5; });

var $lx2ki = parcelRequire("lx2ki");

var $iyvcQ = parcelRequire("iyvcQ");

var $klcXS = parcelRequire("klcXS");

var $2CAiT = parcelRequire("2CAiT");

var $ki422 = parcelRequire("ki422");
function $2eed622a74005592$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $iyvcQ.isSVGComponent)(Component) ? (0, $klcXS.svgMotionConfig) : (0, $2CAiT.htmlMotionConfig);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $ki422.createUseRender)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $lx2ki.createRendererMotionComponent)(config);
    };
}

});
parcelRegister("lx2ki", function(module, exports) {

$parcel$export(module.exports, "createRendererMotionComponent", function () { return $432e5fbfa76001e9$export$c3ad4a902bccc2d8; });

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $iqmSy = parcelRequire("iqmSy");

var $gCkHn = parcelRequire("gCkHn");

var $8TEnB = parcelRequire("8TEnB");

var $3H1ir = parcelRequire("3H1ir");

var $fPfdn = parcelRequire("fPfdn");

var $cWb1X = parcelRequire("cWb1X");

var $khLRP = parcelRequire("khLRP");

var $heYxd = parcelRequire("heYxd");

var $jVIgz = parcelRequire("jVIgz");

var $h3uBC = parcelRequire("h3uBC");


var $2zBnu = parcelRequire("2zBnu");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $432e5fbfa76001e9$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $cWb1X.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $eZVvM.useContext)((0, $iqmSy.MotionConfigContext)),
            ...props,
            layoutId: $432e5fbfa76001e9$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $fPfdn.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $khLRP.isBrowser)) {
            $432e5fbfa76001e9$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $432e5fbfa76001e9$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $8TEnB.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $3pI8R.jsxs)((0, $gCkHn.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $3pI8R.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $3H1ir.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $eZVvM.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $h3uBC.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $432e5fbfa76001e9$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $eZVvM.useContext)((0, $heYxd.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $432e5fbfa76001e9$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $eZVvM.useContext)((0, $jVIgz.LazyContext)).strict;
}
function $432e5fbfa76001e9$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $2zBnu.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("iqmSy", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $2dbc4737509c69cd$export$22a697fb29aac98d; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @public
 */ const $2dbc4737509c69cd$export$22a697fb29aac98d = (0, $eZVvM.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("gCkHn", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $8416e26aea05018d$export$2285bbca2c666415; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $8416e26aea05018d$export$2285bbca2c666415 = (0, $eZVvM.createContext)({});

});

parcelRegister("8TEnB", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $26537fed9b9cd0d9$export$dc0335d73ab0b115; });

var $eZVvM = parcelRequire("eZVvM");

var $4J6gH = parcelRequire("4J6gH");

var $gCkHn = parcelRequire("gCkHn");

var $btbVU = parcelRequire("btbVU");

var $jVIgz = parcelRequire("jVIgz");

var $iqmSy = parcelRequire("iqmSy");

var $3vWfR = parcelRequire("3vWfR");

var $2g0zK = parcelRequire("2g0zK");

var $dnjlm = parcelRequire("dnjlm");

var $lPrUj = parcelRequire("lPrUj");
function $26537fed9b9cd0d9$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $eZVvM.useContext)((0, $gCkHn.MotionContext));
    const lazyContext = (0, $eZVvM.useContext)((0, $jVIgz.LazyContext));
    const presenceContext = (0, $eZVvM.useContext)((0, $4J6gH.PresenceContext));
    const reducedMotionConfig = (0, $eZVvM.useContext)((0, $iqmSy.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $eZVvM.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $eZVvM.useContext)((0, $lPrUj.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $26537fed9b9cd0d9$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $eZVvM.useRef)(false);
    (0, $eZVvM.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $3vWfR.optimizedAppearDataAttribute];
    const wantsHandoff = (0, $eZVvM.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $btbVU.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $2g0zK.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $eZVvM.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $26537fed9b9cd0d9$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $dnjlm.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("btbVU", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $e44af1c94b39ef8b$export$700979bc83e7db82; });

var $eZVvM = parcelRequire("eZVvM");

var $khLRP = parcelRequire("khLRP");
const $e44af1c94b39ef8b$export$700979bc83e7db82 = (0, $khLRP.isBrowser) ? (0, $eZVvM.useLayoutEffect) : (0, $eZVvM.useEffect);

});
parcelRegister("khLRP", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $be55fc6f5082c859$export$4e09c449d6c407f7; });
const $be55fc6f5082c859$export$4e09c449d6c407f7 = typeof window !== "undefined";

});


parcelRegister("jVIgz", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $4b00cbb57ffac2ad$export$40f10139ecf1f171; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $4b00cbb57ffac2ad$export$40f10139ecf1f171 = (0, $eZVvM.createContext)({
    strict: false
});

});


parcelRegister("3H1ir", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $868ea6e685ff4b28$export$c684914703d321fd; });

var $eZVvM = parcelRequire("eZVvM");

var $dnjlm = parcelRequire("dnjlm");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $868ea6e685ff4b28$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $eZVvM.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $dnjlm.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("fPfdn", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $2b4c9db25053aff3$export$c5638d843b37a176; });

var $eZVvM = parcelRequire("eZVvM");

var $gCkHn = parcelRequire("gCkHn");

var $9SIrc = parcelRequire("9SIrc");
function $2b4c9db25053aff3$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9SIrc.getCurrentTreeVariants)(props, (0, $eZVvM.useContext)((0, $gCkHn.MotionContext)));
    return (0, $eZVvM.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $2b4c9db25053aff3$var$variantLabelsAsDependency(initial),
        $2b4c9db25053aff3$var$variantLabelsAsDependency(animate)
    ]);
}
function $2b4c9db25053aff3$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("9SIrc", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $91578f775d616319$export$12fc32fc096a04a3; });

var $hjEsj = parcelRequire("hjEsj");

var $amSOg = parcelRequire("amSOg");
function $91578f775d616319$export$12fc32fc096a04a3(props, context) {
    if ((0, $amSOg.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $hjEsj.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $hjEsj.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("amSOg", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $2fc988fc3932ede6$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $2fc988fc3932ede6$export$ce46fa4165cdec40; });

var $gv2sY = parcelRequire("gv2sY");

var $hjEsj = parcelRequire("hjEsj");

var $g0oUH = parcelRequire("g0oUH");
function $2fc988fc3932ede6$export$4b3c3bd8d910d78d(props) {
    return (0, $gv2sY.isAnimationControls)(props.animate) || (0, $g0oUH.variantProps).some((name)=>(0, $hjEsj.isVariantLabel)(props[name]));
}
function $2fc988fc3932ede6$export$ce46fa4165cdec40(props) {
    return Boolean($2fc988fc3932ede6$export$4b3c3bd8d910d78d(props) || props.variants);
}

});



parcelRegister("cWb1X", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $a7d5fd5fe62217c2$export$449561ec5703cdc8; });

var $2zBnu = parcelRequire("2zBnu");
function $a7d5fd5fe62217c2$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $2zBnu.featureDefinitions)[key] = {
        ...(0, $2zBnu.featureDefinitions)[key],
        ...features[key]
    };
}

});
parcelRegister("2zBnu", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $7e4e689c8cf2db0f$export$65570e08d843624d; });
const $7e4e689c8cf2db0f$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $7e4e689c8cf2db0f$export$65570e08d843624d = {};
for(const key in $7e4e689c8cf2db0f$var$featureProps)$7e4e689c8cf2db0f$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$7e4e689c8cf2db0f$var$featureProps[key].some((name)=>!!props[name])
};

});


parcelRegister("h3uBC", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $bab999e721cfef49$export$28e2e4cce424ae23; });
const $bab999e721cfef49$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});


parcelRegister("iyvcQ", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $7a25186e874ea0c4$export$88f3fc2fd3766989; });

var $704yA = parcelRequire("704yA");
function $7a25186e874ea0c4$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $704yA.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("704yA", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $417e8ab9c81f2f0c$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $417e8ab9c81f2f0c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("klcXS", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $4cabf9b934404f74$export$44dabd3fae512e85; });

var $eSq4w = parcelRequire("eSq4w");

var $jXbLa = parcelRequire("jXbLa");

var $dn9wC = parcelRequire("dn9wC");

var $9XJiu = parcelRequire("9XJiu");

var $1nLX6 = parcelRequire("1nLX6");

var $i51l7 = parcelRequire("i51l7");

var $2Nl6b = parcelRequire("2Nl6b");
const $4cabf9b934404f74$export$44dabd3fae512e85 = {
    useVisualState: (0, $dn9wC.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $jXbLa.scrapeMotionValuesFromProps),
        createRenderState: (0, $9XJiu.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $2Nl6b.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $2Nl6b.frame).render(()=>{
                (0, $1nLX6.buildSVGAttrs)(renderState, latestValues, (0, $i51l7.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $eSq4w.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("eSq4w", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $1f21ae4b02cd1f42$export$c5f8399d19a7394b; });

var $fQIMP = parcelRequire("fQIMP");

var $1Ftdr = parcelRequire("1Ftdr");

var $a9InI = parcelRequire("a9InI");
function $1f21ae4b02cd1f42$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $1Ftdr.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $a9InI.camelCaseAttributes).has(key) ? (0, $fQIMP.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("1Ftdr", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $4b00b30c458e95a5$export$1a32bf6229c258c0; });
function $4b00b30c458e95a5$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("a9InI", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $06bd8852f57731ef$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $06bd8852f57731ef$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});


parcelRegister("jXbLa", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $168db84468a1c40a$export$16da615486abaa45; });

var $1y4u0 = parcelRequire("1y4u0");

var $2HvN2 = parcelRequire("2HvN2");

var $jBNTi = parcelRequire("jBNTi");
function $168db84468a1c40a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $2HvN2.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $1y4u0.isMotionValue)(props[key]) || (0, $1y4u0.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $jBNTi.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("2HvN2", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $aad167df34d77474$export$16da615486abaa45; });

var $aom2y = parcelRequire("aom2y");

var $1y4u0 = parcelRequire("1y4u0");
function $aad167df34d77474$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $1y4u0.isMotionValue)(style[key]) || prevProps.style && (0, $1y4u0.isMotionValue)(prevProps.style[key]) || (0, $aom2y.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("aom2y", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $80826fc63953baa9$export$6d27ce8e3de1c3cf; });

var $fwXkk = parcelRequire("fwXkk");

var $jBNTi = parcelRequire("jBNTi");
function $80826fc63953baa9$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $jBNTi.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $fwXkk.scaleCorrectors)[key] || key === "opacity");
}

});



parcelRegister("dn9wC", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $6a88e97517bacfe1$export$e91e107bc6d03a8e; });

var $eZVvM = parcelRequire("eZVvM");

var $gv2sY = parcelRequire("gv2sY");

var $4J6gH = parcelRequire("4J6gH");

var $hCNbI = parcelRequire("hCNbI");

var $gRpev = parcelRequire("gRpev");

var $ajp7r = parcelRequire("ajp7r");

var $gCkHn = parcelRequire("gCkHn");

var $amSOg = parcelRequire("amSOg");
function $6a88e97517bacfe1$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $6a88e97517bacfe1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $6a88e97517bacfe1$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $eZVvM.useContext)((0, $gCkHn.MotionContext));
        const presenceContext = (0, $eZVvM.useContext)((0, $4J6gH.PresenceContext));
        const make = ()=>$6a88e97517bacfe1$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $gRpev.useConstant)(make);
    };
function $6a88e97517bacfe1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $ajp7r.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $amSOg.isControllingVariants)(props);
    const isVariantNode$1 = (0, $amSOg.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $gv2sY.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $hCNbI.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}

});
parcelRegister("gRpev", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $75b40fe88a41e69d$export$fe4300aa8eebea86; });

var $eZVvM = parcelRequire("eZVvM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $75b40fe88a41e69d$export$fe4300aa8eebea86(init) {
    const ref = (0, $eZVvM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});


parcelRegister("9XJiu", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $74bf7a692303d66e$export$41be8b43e1c4d4f9; });

var $3u3l0 = parcelRequire("3u3l0");
const $74bf7a692303d66e$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $3u3l0.createHtmlRenderState)(),
        attrs: {}
    });

});
parcelRegister("3u3l0", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $e58ad7e50bcadcc4$export$8940b483cf52eeda; });
const $e58ad7e50bcadcc4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("1nLX6", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $a15ae55154733086$export$5475d24f125d7053; });

var $5adX2 = parcelRequire("5adX2");

var $fopZD = parcelRequire("fopZD");

var $4nJuD = parcelRequire("4nJuD");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $a15ae55154733086$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $5adX2.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $fopZD.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $4nJuD.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("5adX2", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $16e537b6cc739ae9$export$bb517f8b40f8e99d; });

var $18ZLX = parcelRequire("18ZLX");

var $iomcl = parcelRequire("iomcl");

var $jBNTi = parcelRequire("jBNTi");

var $dG6kZ = parcelRequire("dG6kZ");

var $iandk = parcelRequire("iandk");
function $16e537b6cc739ae9$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $jBNTi.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $iomcl.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $dG6kZ.getValueAsType)(value, (0, $iandk.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $18ZLX.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("18ZLX", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $bc45c17cb980b55d$export$bdc96e0d5c8f914; });

var $jBNTi = parcelRequire("jBNTi");

var $dG6kZ = parcelRequire("dG6kZ");

var $iandk = parcelRequire("iandk");
const $bc45c17cb980b55d$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $bc45c17cb980b55d$var$numTransforms = (0, $jBNTi.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $bc45c17cb980b55d$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $bc45c17cb980b55d$var$numTransforms; i++){
        const key = (0, $jBNTi.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $dG6kZ.getValueAsType)(value, (0, $iandk.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $bc45c17cb980b55d$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});
parcelRegister("dG6kZ", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $0a54f0d93dc3dd55$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $0a54f0d93dc3dd55$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});



parcelRegister("fopZD", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $2013b4939d3fefab$export$d4fbcfc8e5472155; });

var $gZMJv = parcelRequire("gZMJv");
function $2013b4939d3fefab$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $gZMJv.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2013b4939d3fefab$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2013b4939d3fefab$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2013b4939d3fefab$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("4nJuD", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $f03eba8d5cf6fce6$export$311b43f666da1d82; });

var $gZMJv = parcelRequire("gZMJv");
const $f03eba8d5cf6fce6$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f03eba8d5cf6fce6$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f03eba8d5cf6fce6$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f03eba8d5cf6fce6$var$dashKeys : $f03eba8d5cf6fce6$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $gZMJv.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $gZMJv.px).transform(length);
    const pathSpacing = (0, $gZMJv.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("i51l7", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $c3b8eaab2ba22eae$export$6328ce7565ea1049; });
const $c3b8eaab2ba22eae$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});


parcelRegister("2CAiT", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $df0b984375ed65d2$export$e13ea21d87ea57c8; });

var $dn9wC = parcelRequire("dn9wC");

var $2HvN2 = parcelRequire("2HvN2");

var $3u3l0 = parcelRequire("3u3l0");
const $df0b984375ed65d2$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $dn9wC.makeUseVisualState)({
        scrapeMotionValuesFromProps: $2HvN2.scrapeMotionValuesFromProps,
        createRenderState: (0, $3u3l0.createHtmlRenderState)
    })
};

});

parcelRegister("ki422", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $2dad14849bab4bc8$export$5d29104eefd89cc8; });

var $eZVvM = parcelRequire("eZVvM");

var $hngEY = parcelRequire("hngEY");

var $2Pkqq = parcelRequire("2Pkqq");

var $iyvcQ = parcelRequire("iyvcQ");

var $lVQnv = parcelRequire("lVQnv");

var $1y4u0 = parcelRequire("1y4u0");
function $2dad14849bab4bc8$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $iyvcQ.isSVGComponent)(Component) ? (0, $lVQnv.useSVGProps) : (0, $hngEY.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $2Pkqq.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $eZVvM.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $eZVvM.useMemo)(()=>(0, $1y4u0.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $eZVvM.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("hngEY", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $22929543408d6d1e$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $22929543408d6d1e$export$57be0a314572d87d; });

var $eZVvM = parcelRequire("eZVvM");

var $aom2y = parcelRequire("aom2y");

var $1y4u0 = parcelRequire("1y4u0");

var $5adX2 = parcelRequire("5adX2");

var $3u3l0 = parcelRequire("3u3l0");
function $22929543408d6d1e$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $1y4u0.isMotionValue)(source[key]) && !(0, $aom2y.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $22929543408d6d1e$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $eZVvM.useMemo)(()=>{
        const state = (0, $3u3l0.createHtmlRenderState)();
        (0, $5adX2.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $22929543408d6d1e$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $22929543408d6d1e$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $22929543408d6d1e$var$useInitialMotionValues(props, visualState));
    return style;
}
function $22929543408d6d1e$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $22929543408d6d1e$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});

parcelRegister("2Pkqq", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $16e3de3eec073e66$export$d697c39a2985a4c; });

var $aFJww = parcelRequire("aFJww");
let $16e3de3eec073e66$var$shouldForward = (key)=>!(0, $aFJww.isValidMotionProp)(key);
function $16e3de3eec073e66$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $16e3de3eec073e66$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $aFJww.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $16e3de3eec073e66$export$59d6962c470509a5((parcelRequire("hMzFq")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $16e3de3eec073e66$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($16e3de3eec073e66$var$shouldForward(key) || forwardMotionProps === true && (0, $aFJww.isValidMotionProp)(key) || !isDom && !(0, $aFJww.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("aFJww", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $97455d6caac48ac2$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $97455d6caac48ac2$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $97455d6caac48ac2$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $97455d6caac48ac2$var$validMotionProps.has(key);
}

});


parcelRegister("lVQnv", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $66f6100f03812232$export$84309c4f53cb1bd5; });

var $eZVvM = parcelRequire("eZVvM");

var $hngEY = parcelRequire("hngEY");

var $1nLX6 = parcelRequire("1nLX6");

var $9XJiu = parcelRequire("9XJiu");

var $i51l7 = parcelRequire("i51l7");
function $66f6100f03812232$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $eZVvM.useMemo)(()=>{
        const state = (0, $9XJiu.createSvgRenderState)();
        (0, $1nLX6.buildSVGAttrs)(state, visualState, (0, $i51l7.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $hngEY.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});



parcelRegister("c9jLa", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $71d1c7c53f513669$export$56ba0183203348f5; });

var $eZVvM = parcelRequire("eZVvM");

var $h6gEv = parcelRequire("h6gEv");

var $fEx2r = parcelRequire("fEx2r");

var $iyvcQ = parcelRequire("iyvcQ");
const $71d1c7c53f513669$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $iyvcQ.isSVGComponent)(Component) ? new (0, $fEx2r.SVGVisualElement)(options) : new (0, $h6gEv.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $eZVvM.Fragment)
    });
};

});
parcelRegister("h6gEv", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $6827870418fa71a4$export$23fea75b03ac16b3; });

var $5adX2 = parcelRequire("5adX2");

var $iomcl = parcelRequire("iomcl");

var $jBNTi = parcelRequire("jBNTi");

var $2HvN2 = parcelRequire("2HvN2");

var $1Ftdr = parcelRequire("1Ftdr");

var $e5pkd = parcelRequire("e5pkd");

var $5HNVc = parcelRequire("5HNVc");

var $1J3EB = parcelRequire("1J3EB");

var $1y4u0 = parcelRequire("1y4u0");
function $6827870418fa71a4$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $6827870418fa71a4$export$23fea75b03ac16b3 extends (0, $1J3EB.DOMVisualElement) {
    readValueFromInstance(instance, key) {
        if ((0, $jBNTi.transformProps).has(key)) {
            const defaultType = (0, $e5pkd.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $6827870418fa71a4$export$3735103072e4a80(instance);
            const value = ((0, $iomcl.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $5HNVc.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $5adX2.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $2HvN2.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $1y4u0.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $1Ftdr.renderHTML);
    }
}

});
parcelRegister("1J3EB", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $7a60681320743b3d$export$e49735c2a366bdc7; });

var $hN7Wp = parcelRequire("hN7Wp");

var $j2xQU = parcelRequire("j2xQU");
class $7a60681320743b3d$export$e49735c2a366bdc7 extends (0, $hN7Wp.VisualElement) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $j2xQU.DOMKeyframesResolver);
    }
}

});
parcelRegister("hN7Wp", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $febe57d551727e6e$export$fa8b653c0f3714e5; });

var $j2ZBW = parcelRequire("j2ZBW");

var $dsB0J = parcelRequire("dsB0J");

var $3BCsP = parcelRequire("3BCsP");

var $4oNvX = parcelRequire("4oNvX");

var $1y4u0 = parcelRequire("1y4u0");

var $jBNTi = parcelRequire("jBNTi");

var $amSOg = parcelRequire("amSOg");

var $ht7d7 = parcelRequire("ht7d7");

var $hCNbI = parcelRequire("hCNbI");


var $2zBnu = parcelRequire("2zBnu");

var $npPCx = parcelRequire("npPCx");

var $2LsSg = parcelRequire("2LsSg");

var $dVmba = parcelRequire("dVmba");

var $aZFM3 = parcelRequire("aZFM3");

var $blliH = parcelRequire("blliH");

var $4H4W5 = parcelRequire("4H4W5");

var $b2nJp = parcelRequire("b2nJp");

var $5C3hG = parcelRequire("5C3hG");

var $1lF7N = parcelRequire("1lF7N");

var $2Nl6b = parcelRequire("2Nl6b");
const $febe57d551727e6e$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $febe57d551727e6e$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $npPCx.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $dsB0J.hasReducedMotionListener).current) (0, $j2ZBW.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $dsB0J.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $npPCx.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $2Nl6b.cancelFrame)(this.notifyUpdate);
        (0, $2Nl6b.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $jBNTi.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $2Nl6b.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $2zBnu.featureDefinitions){
            const featureDefinition = (0, $2zBnu.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $5C3hG.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $febe57d551727e6e$var$propEventHandlers.length; i++){
            const key = $febe57d551727e6e$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $ht7d7.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $4oNvX.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $dVmba.isNumericalString)(value) || (0, $aZFM3.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $blliH.findValueType)(value) && (0, $4H4W5.complex).test(target)) value = (0, $b2nJp.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $1y4u0.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $1y4u0.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $hCNbI.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $1y4u0.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $3BCsP.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $2LsSg.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $1lF7N.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $2Nl6b.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $amSOg.isControllingVariants)(props);
        this.isVariantNode = (0, $amSOg.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $1y4u0.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
}

});
parcelRegister("j2ZBW", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $0647d51418a7f392$export$ca9f41fb23dded3d; });

var $khLRP = parcelRequire("khLRP");

var $dsB0J = parcelRequire("dsB0J");
function $0647d51418a7f392$export$ca9f41fb23dded3d() {
    (0, $dsB0J.hasReducedMotionListener).current = true;
    if (!(0, $khLRP.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $dsB0J.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $dsB0J.prefersReducedMotion).current = false;
}

});
parcelRegister("dsB0J", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $07afbcdb8c9ca91e$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $07afbcdb8c9ca91e$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $07afbcdb8c9ca91e$export$ff7706047246b98b = {
    current: null
};
const $07afbcdb8c9ca91e$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("ht7d7", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $a35449f22ddb2410$export$9a552858d5197f6e; });


var $4oNvX = parcelRequire("4oNvX");

var $1y4u0 = parcelRequire("1y4u0");
function $a35449f22ddb2410$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $1y4u0.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $1y4u0.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4oNvX.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4oNvX.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("npPCx", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $73d8d0321368e9d9$export$bc2a978a17abfdde; });
const $73d8d0321368e9d9$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("blliH", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $ab10937ce4422643$export$950e7e59ea1ffed7; });

var $1xfyP = parcelRequire("1xfyP");

var $4H4W5 = parcelRequire("4H4W5");

var $76Oqp = parcelRequire("76Oqp");

var $31XMl = parcelRequire("31XMl");
/**
 * A list of all ValueTypes
 */ const $ab10937ce4422643$var$valueTypes = [
    ...(0, $76Oqp.dimensionValueTypes),
    (0, $1xfyP.color),
    (0, $4H4W5.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $ab10937ce4422643$export$950e7e59ea1ffed7 = (v)=>$ab10937ce4422643$var$valueTypes.find((0, $31XMl.testValueType)(v));

});




parcelRegister("fEx2r", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $8cdbf68185ab9954$export$86bcdffbaf733d84; });

var $jXbLa = parcelRequire("jXbLa");

var $1J3EB = parcelRequire("1J3EB");

var $1nLX6 = parcelRequire("1nLX6");

var $fQIMP = parcelRequire("fQIMP");

var $a9InI = parcelRequire("a9InI");

var $jBNTi = parcelRequire("jBNTi");

var $eSq4w = parcelRequire("eSq4w");

var $e5pkd = parcelRequire("e5pkd");

var $5C3hG = parcelRequire("5C3hG");

var $i51l7 = parcelRequire("i51l7");
class $8cdbf68185ab9954$export$86bcdffbaf733d84 extends (0, $1J3EB.DOMVisualElement) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $jBNTi.transformProps).has(key)) {
            const defaultType = (0, $e5pkd.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $a9InI.camelCaseAttributes).has(key) ? (0, $fQIMP.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $jXbLa.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $1nLX6.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $eSq4w.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $i51l7.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $5C3hG.createBox);
    }
}

});




parcelRegister("jnPOB", function(module, exports) {

$parcel$export(module.exports, "client", function () { return $e1c85bb4e6b5abdf$export$388e0302ca0d9a41; });
$parcel$export(module.exports, "gql", function () { return (parcelRequire("g6uH4")).gql; });

var $aZjGj = parcelRequire("aZjGj");

var $g6uH4 = parcelRequire("g6uH4");
const $e1c85bb4e6b5abdf$var$CLIENT_TOKEN = (0, window.location.pathname.split("/")[2]);
const $e1c85bb4e6b5abdf$export$388e0302ca0d9a41 = new (0, $g6uH4.GraphQLClient)(`${"https://api.digitalreception.app"}/graphql`, {
    headers: ()=>({
            "Client-Token": $e1c85bb4e6b5abdf$var$CLIENT_TOKEN,
            "Accept-Language": (0, $aZjGj.default).language
        })
});

});
parcelRegister("g6uH4", function(module, exports) {
"use strict";
var $bb9504011f8acb95$var$__assign = module.exports && module.exports.__assign || function() {
    $bb9504011f8acb95$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb9504011f8acb95$var$__assign.apply(this, arguments);
};
var $bb9504011f8acb95$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bb9504011f8acb95$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bb9504011f8acb95$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bb9504011f8acb95$var$__createBinding(result, mod, k);
    }
    $bb9504011f8acb95$var$__setModuleDefault(result, mod);
    return result;
};
var $bb9504011f8acb95$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bb9504011f8acb95$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bb9504011f8acb95$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bb9504011f8acb95$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $bb9504011f8acb95$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = module.exports.GraphQLWebSocketClient = module.exports.gql = module.exports.batchRequests = module.exports.request = module.exports.rawRequest = module.exports.GraphQLClient = module.exports.ClientError = void 0;

var $bb9504011f8acb95$var$cross_fetch_1 = $bb9504011f8acb95$var$__importStar((parcelRequire("1urwW"))), $bb9504011f8acb95$var$CrossFetch = $bb9504011f8acb95$var$cross_fetch_1;

var $bb9504011f8acb95$var$createRequestBody_1 = $bb9504011f8acb95$var$__importDefault((parcelRequire("jJBzg")));

var $kQznX = parcelRequire("kQznX");

var $hyytw = parcelRequire("hyytw");

var $iaMvf = parcelRequire("iaMvf");
Object.defineProperty(module.exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $iaMvf.ClientError;
    }
});

var $gfzLa = parcelRequire("gfzLa");
/**
 * Convert the given headers configuration into a plain object.
 */ var $bb9504011f8acb95$var$resolveHeaders = function(headers) {
    var oHeaders = {};
    if (headers) {
        if (typeof Headers !== "undefined" && headers instanceof Headers || $bb9504011f8acb95$var$CrossFetch && $bb9504011f8acb95$var$CrossFetch.Headers && headers instanceof $bb9504011f8acb95$var$CrossFetch.Headers) oHeaders = $bb9504011f8acb95$var$HeadersInstanceToPlainObject(headers);
        else if (Array.isArray(headers)) headers.forEach(function(_a) {
            var name = _a[0], value = _a[1];
            oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */ var $bb9504011f8acb95$var$queryCleanner = function(str) {
    return str.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim();
};
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */ var $bb9504011f8acb95$var$buildGetQueryParams = function(_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName, jsonSerializer = _a.jsonSerializer;
    if (!Array.isArray(query)) {
        var search = [
            "query=".concat(encodeURIComponent($bb9504011f8acb95$var$queryCleanner(query)))
        ];
        if (variables) search.push("variables=".concat(encodeURIComponent(jsonSerializer.stringify(variables))));
        if (operationName) search.push("operationName=".concat(encodeURIComponent(operationName)));
        return search.join("&");
    }
    if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create query with given variable type, array expected");
    // Batch support
    var payload = query.reduce(function(accu, currentQuery, index) {
        accu.push({
            query: $bb9504011f8acb95$var$queryCleanner(currentQuery),
            variables: variables ? jsonSerializer.stringify(variables[index]) : undefined
        });
        return accu;
    }, []);
    return "query=".concat(encodeURIComponent(jsonSerializer.stringify(payload)));
};
/**
 * Fetch data using POST method
 */ var $bb9504011f8acb95$var$post = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(void 0, void 0, void 0, function() {
        var body, init;
        var _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    body = (0, $bb9504011f8acb95$var$createRequestBody_1.default)(query, variables, operationName, fetchOptions.jsonSerializer);
                    init = $bb9504011f8acb95$var$__assign({
                        method: "POST",
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, typeof body === "string" ? {
                            "Content-Type": "application/json"
                        } : {}), headers),
                        body: body
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $bb9504011f8acb95$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch(url, init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */ var $bb9504011f8acb95$var$get = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(void 0, void 0, void 0, function() {
        var queryParams, init;
        var _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    queryParams = $bb9504011f8acb95$var$buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                        jsonSerializer: fetchOptions.jsonSerializer
                    });
                    init = $bb9504011f8acb95$var$__assign({
                        method: "GET",
                        headers: headers
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $bb9504011f8acb95$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch("".concat(url, "?").concat(queryParams), init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * GraphQL Client.
 */ var $bb9504011f8acb95$var$GraphQLClient = /** @class */ function() {
    function GraphQLClient(url, options) {
        if (options === void 0) options = {};
        this.url = url;
        this.options = options;
    }
    GraphQLClient.prototype.rawRequest = function(queryOrOptions, variables, requestHeaders) {
        return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
            var rawRequestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, operationName;
            return $bb9504011f8acb95$var$__generator(this, function(_d) {
                rawRequestOptions = (0, $hyytw.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
                operationName = (0, $gfzLa.resolveRequestDocument)(rawRequestOptions.query).operationName;
                return [
                    2 /*return*/ ,
                    $bb9504011f8acb95$var$makeRequest({
                        url: url,
                        query: rawRequestOptions.query,
                        variables: rawRequestOptions.variables,
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.request = function(documentOrOptions) {
        var variablesAndRequestHeaders = [];
        for(var _i = 1; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 1] = arguments[_i];
        return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
            var variables, requestHeaders, requestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, _d, query, operationName;
            return $bb9504011f8acb95$var$__generator(this, function(_e) {
                variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
                requestOptions = (0, $hyytw.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
                _d = (0, $gfzLa.resolveRequestDocument)(requestOptions.document), query = _d.query, operationName = _d.operationName;
                return [
                    2 /*return*/ ,
                    $bb9504011f8acb95$var$makeRequest({
                        url: url,
                        query: query,
                        variables: requestOptions.variables,
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(requestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response.data;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.batchRequests = function(documentsOrOptions, requestHeaders) {
        var batchRequestOptions = (0, $hyytw.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        var url = this.url;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        var queries = batchRequestOptions.documents.map(function(_a) {
            var document = _a.document;
            return (0, $gfzLa.resolveRequestDocument)(document).query;
        });
        var variables = batchRequestOptions.documents.map(function(_a) {
            var variables = _a.variables;
            return variables;
        });
        return $bb9504011f8acb95$var$makeRequest({
            url: url,
            query: queries,
            variables: variables,
            headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then(function(response) {
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch(function(error) {
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    };
    GraphQLClient.prototype.setHeaders = function(headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ GraphQLClient.prototype.setHeader = function(key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-ignore
        headers[key] = value;
        else this.options.headers = (_a = {}, _a[key] = value, _a);
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ GraphQLClient.prototype.setEndpoint = function(value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}();
module.exports.GraphQLClient = $bb9504011f8acb95$var$GraphQLClient;
function $bb9504011f8acb95$var$makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? "POST" : _b, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, successfullyPassedErrorPolicy, headers_1, status_1, errors, rest, data, errorResult;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    fetcher = method.toUpperCase() === "POST" ? $bb9504011f8acb95$var$post : $bb9504011f8acb95$var$get;
                    isBathchingQuery = Array.isArray(query);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions,
                            middleware: middleware
                        })
                    ];
                case 1:
                    response = _c.sent();
                    return [
                        4 /*yield*/ ,
                        $bb9504011f8acb95$var$getResult(response, fetchOptions.jsonSerializer)
                    ];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function(_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    successfullyPassedErrorPolicy = !result.errors || fetchOptions.errorPolicy === "all" || fetchOptions.errorPolicy === "ignore";
                    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        errors = result.errors, rest = $bb9504011f8acb95$var$__rest(result, [
                            "errors"
                        ]);
                        data = fetchOptions.errorPolicy === "ignore" ? rest : result;
                        return [
                            2 /*return*/ ,
                            $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, isBathchingQuery ? {
                                data: data
                            } : data), {
                                headers: headers_1,
                                status: status_1
                            })
                        ];
                    } else {
                        errorResult = typeof result === "string" ? {
                            error: result
                        } : result;
                        throw new $iaMvf.ClientError($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, errorResult), {
                            status: response.status,
                            headers: response.headers
                        }), {
                            query: query,
                            variables: variables
                        });
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $bb9504011f8acb95$var$rawRequest(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = $hyytw.parseRawRequestExtendedArgs.apply(void 0, $bb9504011f8acb95$var$__spreadArray([
                urlOrOptions,
                query
            ], variablesAndRequestHeaders, false));
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.rawRequest($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.rawRequest = $bb9504011f8acb95$var$rawRequest;
function $bb9504011f8acb95$var$request(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = $hyytw.parseRequestExtendedArgs.apply(void 0, $bb9504011f8acb95$var$__spreadArray([
                urlOrOptions,
                document
            ], variablesAndRequestHeaders, false));
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.request($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.request = $bb9504011f8acb95$var$request;
function $bb9504011f8acb95$var$batchRequests(urlOrOptions, documents, requestHeaders) {
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = (0, $hyytw.parseBatchRequestsExtendedArgs)(urlOrOptions, documents, requestHeaders);
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.batchRequests($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.batchRequests = $bb9504011f8acb95$var$batchRequests;
module.exports.default = $bb9504011f8acb95$var$request;
/**
 * todo
 */ function $bb9504011f8acb95$var$getResult(response, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $kQznX.defaultJsonSerializer;
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var contentType, _a, _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    response.headers.forEach(function(value, key) {
                        if (key.toLowerCase() === "content-type") contentType = value;
                    });
                    if (!(contentType && (contentType.toLowerCase().startsWith("application/json") || contentType.toLowerCase().startsWith("application/graphql+json") || contentType.toLowerCase().startsWith("application/graphql-response+json")))) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = (_a = jsonSerializer).parse;
                    return [
                        4 /*yield*/ ,
                        response.text()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(_a, [
                            _c.sent()
                        ])
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        response.text()
                    ];
            }
        });
    });
}
function $bb9504011f8acb95$var$callOrIdentity(value) {
    return typeof value === "function" ? value() : value;
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ function $bb9504011f8acb95$var$gql(chunks) {
    var variables = [];
    for(var _i = 1; _i < arguments.length; _i++)variables[_i - 1] = arguments[_i];
    return chunks.reduce(function(accumulator, chunk, index) {
        return "".concat(accumulator).concat(chunk).concat(index in variables ? variables[index] : "");
    }, "");
}
module.exports.gql = $bb9504011f8acb95$var$gql;
/**
 * Convert Headers instance into regular object
 */ function $bb9504011f8acb95$var$HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}

var $kE4VN = parcelRequire("kE4VN");
Object.defineProperty(module.exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $kE4VN.GraphQLWebSocketClient;
    }
});

var $gfzLa = parcelRequire("gfzLa");
Object.defineProperty(module.exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $gfzLa.resolveRequestDocument;
    }
});

});
parcelRegister("hyytw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBatchRequestsExtendedArgs = module.exports.parseRawRequestExtendedArgs = module.exports.parseRequestExtendedArgs = module.exports.parseBatchRequestArgs = module.exports.parseRawRequestArgs = module.exports.parseRequestArgs = void 0;
function $cc805aab0d0d149a$var$parseRequestArgs(documentOrOptions, variables, requestHeaders) {
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestArgs = $cc805aab0d0d149a$var$parseRequestArgs;
function $cc805aab0d0d149a$var$parseRawRequestArgs(queryOrOptions, variables, requestHeaders) {
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestArgs = $cc805aab0d0d149a$var$parseRawRequestArgs;
function $cc805aab0d0d149a$var$parseBatchRequestArgs(documentsOrOptions, requestHeaders) {
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestArgs = $cc805aab0d0d149a$var$parseBatchRequestArgs;
function $cc805aab0d0d149a$var$parseRequestExtendedArgs(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestExtendedArgs = $cc805aab0d0d149a$var$parseRequestExtendedArgs;
function $cc805aab0d0d149a$var$parseRawRequestExtendedArgs(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestExtendedArgs = $cc805aab0d0d149a$var$parseRawRequestExtendedArgs;
function $cc805aab0d0d149a$var$parseBatchRequestsExtendedArgs(urlOrOptions, documents, requestHeaders) {
    return urlOrOptions.documents ? urlOrOptions : {
        url: urlOrOptions,
        documents: documents,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestsExtendedArgs = $cc805aab0d0d149a$var$parseBatchRequestsExtendedArgs;

});

parcelRegister("iaMvf", function(module, exports) {
"use strict";
var $d3aec8d42d5ea32e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientError = void 0;
var $d3aec8d42d5ea32e$var$ClientError = /** @class */ function(_super) {
    $d3aec8d42d5ea32e$var$__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
            response: response,
            request: request
        }));
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, ClientError);
        return _this;
    }
    ClientError.extractMessage = function(response) {
        try {
            return response.errors[0].message;
        } catch (e) {
            return "GraphQL Error (Code: ".concat(response.status, ")");
        }
    };
    return ClientError;
}(Error);
module.exports.ClientError = $d3aec8d42d5ea32e$var$ClientError;

});

parcelRegister("gfzLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = void 0;

var $bGJ9o = parcelRequire("bGJ9o");
var $3US94 = parcelRequire("3US94");
/**
 * helpers
 */ function $bd49c92f1faac39c$var$extractOperationName(document) {
    var _a;
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    });
    if (operationDefinitions.length === 1) operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    return operationName;
}
function $bd49c92f1faac39c$var$resolveRequestDocument(document) {
    if (typeof document === "string") {
        var operationName_1 = undefined;
        try {
            var parsedDocument = (0, $bGJ9o.parse)(document);
            operationName_1 = $bd49c92f1faac39c$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName_1
        };
    }
    var operationName = $bd49c92f1faac39c$var$extractOperationName(document);
    return {
        query: (0, $3US94.print)(document),
        operationName: operationName
    };
}
module.exports.resolveRequestDocument = $bd49c92f1faac39c$var$resolveRequestDocument;

});
parcelRegister("bGJ9o", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $9a86a9c04c231b48$export$98e6a39c04603d36; });

var $eWNNk = parcelRequire("eWNNk");

var $Pj6ey = parcelRequire("Pj6ey");

var $dBPrH = parcelRequire("dBPrH");

var $fjdXU = parcelRequire("fjdXU");

var $57dBv = parcelRequire("57dBv");

var $4c3Ij = parcelRequire("4c3Ij");

var $1rmQY = parcelRequire("1rmQY");
function $9a86a9c04c231b48$export$98e6a39c04603d36(source, options) {
    const parser = new $9a86a9c04c231b48$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, "tokenCount", {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $9a86a9c04c231b48$export$5303528d1070ff6f(source, options) {
    const parser = new $9a86a9c04c231b48$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $1rmQY.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $1rmQY.TokenKind).EOF);
    return value;
}
function $9a86a9c04c231b48$export$e14c466bd0916f7a(source, options) {
    const parser = new $9a86a9c04c231b48$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $1rmQY.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $1rmQY.TokenKind).EOF);
    return value;
}
function $9a86a9c04c231b48$export$28b8f402ccc88182(source, options) {
    const parser = new $9a86a9c04c231b48$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $1rmQY.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $1rmQY.TokenKind).EOF);
    return type;
}
class $9a86a9c04c231b48$export$7acfa6ed01010e37 {
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $1rmQY.TokenKind).NAME);
        return this.node(token, {
            kind: (0, $fjdXU.Kind).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).DOCUMENT,
            definitions: this.many((0, $1rmQY.TokenKind).SOF, this.parseDefinition, (0, $1rmQY.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $1rmQY.TokenKind).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $1rmQY.TokenKind).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $eWNNk.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $1rmQY.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, $fjdXU.Kind).OPERATION_DEFINITION,
            operation: (0, $Pj6ey.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $1rmQY.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $1rmQY.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $Pj6ey.OperationTypeNode).QUERY;
            case "mutation":
                return (0, $Pj6ey.OperationTypeNode).MUTATION;
            case "subscription":
                return (0, $Pj6ey.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $1rmQY.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $1rmQY.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $1rmQY.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $1rmQY.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $1rmQY.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, $fjdXU.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).SELECTION_SET,
            selections: this.many((0, $1rmQY.TokenKind).BRACE_L, this.parseSelection, (0, $1rmQY.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $1rmQY.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $1rmQY.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $fjdXU.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $1rmQY.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $1rmQY.TokenKind).PAREN_L, item, (0, $1rmQY.TokenKind).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $1rmQY.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $fjdXU.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $1rmQY.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $1rmQY.TokenKind).NAME)) return this.node(start, {
            kind: (0, $fjdXU.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $fjdXU.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $fjdXU.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $1rmQY.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $1rmQY.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $1rmQY.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $fjdXU.Kind).INT,
                    value: token.value
                });
            case (0, $1rmQY.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $fjdXU.Kind).FLOAT,
                    value: token.value
                });
            case (0, $1rmQY.TokenKind).STRING:
            case (0, $1rmQY.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $1rmQY.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $fjdXU.Kind).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $fjdXU.Kind).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $fjdXU.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $fjdXU.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, $1rmQY.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $1rmQY.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, $1rmQY.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $eWNNk.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $fjdXU.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $1rmQY.TokenKind).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).LIST,
            values: this.any((0, $1rmQY.TokenKind).BRACKET_L, item, (0, $1rmQY.TokenKind).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).OBJECT,
            fields: this.any((0, $1rmQY.TokenKind).BRACE_L, item, (0, $1rmQY.TokenKind).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $1rmQY.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $fjdXU.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $1rmQY.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $1rmQY.TokenKind).AT);
        return this.node(start, {
            kind: (0, $fjdXU.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $1rmQY.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $1rmQY.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, $fjdXU.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $1rmQY.TokenKind).BANG)) return this.node(start, {
            kind: (0, $fjdXU.Kind).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $fjdXU.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $1rmQY.TokenKind).STRING) || this.peek((0, $1rmQY.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $1rmQY.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $1rmQY.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, $fjdXU.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $1rmQY.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $1rmQY.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $1rmQY.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $1rmQY.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $1rmQY.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $1rmQY.TokenKind).PAREN_L, this.parseInputValueDef, (0, $1rmQY.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $1rmQY.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $1rmQY.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $1rmQY.TokenKind).EQUALS) ? this.delimitedMany((0, $1rmQY.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $1rmQY.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $1rmQY.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $eWNNk.syntaxError)(this._lexer.source, this._lexer.token.start, `${$9a86a9c04c231b48$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $1rmQY.TokenKind).BRACE_L, this.parseInputValueDef, (0, $1rmQY.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $1rmQY.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $1rmQY.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $1rmQY.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $1rmQY.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $fjdXU.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $1rmQY.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $dBPrH.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $Pj6ey.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $eWNNk.syntaxError)(this._lexer.source, token.start, `Expected ${$9a86a9c04c231b48$var$getTokenKindDesc(kind)}, found ${$9a86a9c04c231b48$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $1rmQY.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, $eWNNk.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${$9a86a9c04c231b48$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $1rmQY.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $eWNNk.syntaxError)(this._lexer.source, token.start, `Unexpected ${$9a86a9c04c231b48$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $1rmQY.TokenKind).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $eWNNk.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
    constructor(source, options = {}){
        const sourceObj = (0, $4c3Ij.isSource)(source) ? source : new (0, $4c3Ij.Source)(source);
        this._lexer = new (0, $57dBv.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $9a86a9c04c231b48$var$getTokenDesc(token) {
    const value = token.value;
    return $9a86a9c04c231b48$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $9a86a9c04c231b48$var$getTokenKindDesc(kind) {
    return (0, $57dBv.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

});
parcelRegister("eWNNk", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $966184e2967d08df$export$bbee0c6176c019d4; });

var $6Blkq = parcelRequire("6Blkq");
function $966184e2967d08df$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $6Blkq.GraphQLError)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}

});
parcelRegister("6Blkq", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $d4ff08156947db9c$export$92d6ed0888e7cb7f; });

var $1x2xQ = parcelRequire("1x2xQ");

var $56x3g = parcelRequire("56x3g");

var $eRWFv = parcelRequire("eRWFv");
function $d4ff08156947db9c$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $d4ff08156947db9c$export$92d6ed0888e7cb7f extends Error {
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $eRWFv.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $eRWFv.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $d4ff08156947db9c$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $d4ff08156947db9c$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $d4ff08156947db9c$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $56x3g.getLocation)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $56x3g.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, $1x2xQ.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $d4ff08156947db9c$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
}
function $d4ff08156947db9c$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $d4ff08156947db9c$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $d4ff08156947db9c$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}

});
parcelRegister("1x2xQ", function(module, exports) {

$parcel$export(module.exports, "isObjectLike", function () { return $57737acb315b6776$export$c10d0b04eaa80a43; });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $57737acb315b6776$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}

});

parcelRegister("56x3g", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $1ceca6d25a174c7b$export$e7fd20fad3cf4b5f; });

var $epqBO = parcelRequire("epqBO");
const $1ceca6d25a174c7b$var$LineRegExp = /\r\n|[\n\r]/g;
function $1ceca6d25a174c7b$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($1ceca6d25a174c7b$var$LineRegExp)){
        typeof match.index === "number" || (0, $epqBO.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});
parcelRegister("epqBO", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $33f6c61378d38cf6$export$f5708dca728d7177; });
function $33f6c61378d38cf6$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});


parcelRegister("eRWFv", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $58a37b762072b8f0$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $58a37b762072b8f0$export$867940333fd9f869; });

var $56x3g = parcelRequire("56x3g");
function $58a37b762072b8f0$export$96a9681e539deed(location) {
    return $58a37b762072b8f0$export$867940333fd9f869(location.source, (0, $56x3g.getLocation)(location.source, location.start));
}
function $58a37b762072b8f0$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $58a37b762072b8f0$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $58a37b762072b8f0$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $58a37b762072b8f0$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}

});



parcelRegister("Pj6ey", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $a87c0fcfdc9cb608$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $a87c0fcfdc9cb608$export$50792b0e93539fde; });
$parcel$export(module.exports, "QueryDocumentKeys", function () { return $a87c0fcfdc9cb608$export$4fcd777a40ccf407; });
$parcel$export(module.exports, "isNode", function () { return $a87c0fcfdc9cb608$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "OperationTypeNode", function () { return $a87c0fcfdc9cb608$export$f58c50edb4aef9d4; });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $a87c0fcfdc9cb608$export$18a2be9195644f38 {
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
}
class $a87c0fcfdc9cb608$export$50792b0e93539fde {
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}
const $a87c0fcfdc9cb608$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $a87c0fcfdc9cb608$var$kindValues = new Set(Object.keys($a87c0fcfdc9cb608$export$4fcd777a40ccf407));
function $a87c0fcfdc9cb608$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $a87c0fcfdc9cb608$var$kindValues.has(maybeKind);
}
/** Name */ var $a87c0fcfdc9cb608$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($a87c0fcfdc9cb608$export$f58c50edb4aef9d4 || ($a87c0fcfdc9cb608$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("dBPrH", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $3960a3421b7c8798$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $3960a3421b7c8798$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($3960a3421b7c8798$export$b45ffd2948484c41 || ($3960a3421b7c8798$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 
});

parcelRegister("fjdXU", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $70bec69a12cf3eb3$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $70bec69a12cf3eb3$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($70bec69a12cf3eb3$export$a84bdc57c5122798 || ($70bec69a12cf3eb3$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});

parcelRegister("57dBv", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $81adef851cb76886$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $81adef851cb76886$export$59ac0f4da287406a; });

var $eWNNk = parcelRequire("eWNNk");

var $Pj6ey = parcelRequire("Pj6ey");

var $e4VdH = parcelRequire("e4VdH");

var $6WYvM = parcelRequire("6WYvM");

var $1rmQY = parcelRequire("1rmQY");
class $81adef851cb76886$export$6168dc8908a6c652 {
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $1rmQY.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $81adef851cb76886$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $1rmQY.TokenKind).COMMENT);
        }
        return token;
    }
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $Pj6ey.Token)((0, $1rmQY.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
}
function $81adef851cb76886$export$59ac0f4da287406a(kind) {
    return kind === (0, $1rmQY.TokenKind).BANG || kind === (0, $1rmQY.TokenKind).DOLLAR || kind === (0, $1rmQY.TokenKind).AMP || kind === (0, $1rmQY.TokenKind).PAREN_L || kind === (0, $1rmQY.TokenKind).PAREN_R || kind === (0, $1rmQY.TokenKind).SPREAD || kind === (0, $1rmQY.TokenKind).COLON || kind === (0, $1rmQY.TokenKind).EQUALS || kind === (0, $1rmQY.TokenKind).AT || kind === (0, $1rmQY.TokenKind).BRACKET_L || kind === (0, $1rmQY.TokenKind).BRACKET_R || kind === (0, $1rmQY.TokenKind).BRACE_L || kind === (0, $1rmQY.TokenKind).PIPE || kind === (0, $1rmQY.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $81adef851cb76886$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $81adef851cb76886$var$isSupplementaryCodePoint(body, location) {
    return $81adef851cb76886$var$isLeadingSurrogate(body.charCodeAt(location)) && $81adef851cb76886$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $81adef851cb76886$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $81adef851cb76886$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $81adef851cb76886$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $1rmQY.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $81adef851cb76886$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $Pj6ey.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $81adef851cb76886$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $81adef851cb76886$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $81adef851cb76886$var$readBlockString(lexer, position);
                return $81adef851cb76886$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $6WYvM.isDigit)(code) || code === 0x002d) return $81adef851cb76886$var$readNumber(lexer, position, code);
         // Name
        if ((0, $6WYvM.isNameStart)(code)) return $81adef851cb76886$var$readName(lexer, position);
        throw (0, $eWNNk.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $81adef851cb76886$var$isUnicodeScalarValue(code) || $81adef851cb76886$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.`);
    }
    return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $81adef851cb76886$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($81adef851cb76886$var$isUnicodeScalarValue(code)) ++position;
        else if ($81adef851cb76886$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $81adef851cb76886$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $6WYvM.isDigit)(code)) throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $81adef851cb76886$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $81adef851cb76886$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $81adef851cb76886$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $6WYvM.isNameStart)(code)) throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.`);
    return $81adef851cb76886$var$createToken(lexer, isFloat ? (0, $1rmQY.TokenKind).FLOAT : (0, $1rmQY.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $81adef851cb76886$var$readDigits(lexer, start, firstCode) {
    if (!(0, $6WYvM.isDigit)(firstCode)) throw (0, $eWNNk.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${$81adef851cb76886$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $6WYvM.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $81adef851cb76886$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $81adef851cb76886$var$readEscapedUnicodeVariableWidth(lexer, position) : $81adef851cb76886$var$readEscapedUnicodeFixedWidth(lexer, position) : $81adef851cb76886$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($81adef851cb76886$var$isUnicodeScalarValue(code)) ++position;
        else if ($81adef851cb76886$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid character within String: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $eWNNk.syntaxError)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $81adef851cb76886$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$81adef851cb76886$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $81adef851cb76886$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $81adef851cb76886$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $81adef851cb76886$var$read16BitHexCode(body, position + 2);
    if ($81adef851cb76886$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($81adef851cb76886$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $81adef851cb76886$var$read16BitHexCode(body, position + 8);
            if ($81adef851cb76886$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $81adef851cb76886$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $81adef851cb76886$var$readHexDigit(body.charCodeAt(position)) << 12 | $81adef851cb76886$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $81adef851cb76886$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $81adef851cb76886$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $81adef851cb76886$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $81adef851cb76886$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $81adef851cb76886$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).BLOCK_STRING, start, position + 3, (0, $e4VdH.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($81adef851cb76886$var$isUnicodeScalarValue(code)) ++position;
        else if ($81adef851cb76886$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $eWNNk.syntaxError)(lexer.source, position, `Invalid character within String: ${$81adef851cb76886$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $eWNNk.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $81adef851cb76886$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $6WYvM.isNameContinue)(code)) ++position;
        else break;
    }
    return $81adef851cb76886$var$createToken(lexer, (0, $1rmQY.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRegister("e4VdH", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", function () { return $4f5c500b972ee9c1$export$d5ee19b441e8d2ae; });
$parcel$export(module.exports, "printBlockString", function () { return $4f5c500b972ee9c1$export$adb6ca997eeb1f45; });

var $6WYvM = parcelRequire("6WYvM");
function $4f5c500b972ee9c1$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $4f5c500b972ee9c1$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $4f5c500b972ee9c1$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $6WYvM.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $4f5c500b972ee9c1$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $4f5c500b972ee9c1$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $6WYvM.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $6WYvM.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRegister("6WYvM", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", function () { return $777ec053e15b9e34$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isDigit", function () { return $777ec053e15b9e34$export$727d9dbc4fbb948f; });
$parcel$export(module.exports, "isNameStart", function () { return $777ec053e15b9e34$export$45a677ea7cb6d5c8; });
$parcel$export(module.exports, "isNameContinue", function () { return $777ec053e15b9e34$export$d3f406ff46035894; });
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $777ec053e15b9e34$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $777ec053e15b9e34$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $777ec053e15b9e34$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $777ec053e15b9e34$export$45a677ea7cb6d5c8(code) {
    return $777ec053e15b9e34$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $777ec053e15b9e34$export$d3f406ff46035894(code) {
    return $777ec053e15b9e34$export$79c5d5217943d6a7(code) || $777ec053e15b9e34$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("1rmQY", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $07855383f6de9b98$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $07855383f6de9b98$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($07855383f6de9b98$export$8b9d26ab11394711 || ($07855383f6de9b98$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 
});


parcelRegister("4c3Ij", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $0b533b639e9a034d$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $0b533b639e9a034d$export$75135ee9ed6e435b; });

var $FIo2n = parcelRequire("FIo2n");

var $70BmP = parcelRequire("70BmP");

var $9g0Pj = parcelRequire("9g0Pj");
class $0b533b639e9a034d$export$1d2df86270c81ecb {
    get [Symbol.toStringTag]() {
        return "Source";
    }
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $FIo2n.devAssert)(false, `Body must be a string. Received: ${(0, $70BmP.inspect)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $FIo2n.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $FIo2n.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
}
function $0b533b639e9a034d$export$75135ee9ed6e435b(source) {
    return (0, $9g0Pj.instanceOf)(source, $0b533b639e9a034d$export$1d2df86270c81ecb);
}

});
parcelRegister("FIo2n", function(module, exports) {

$parcel$export(module.exports, "devAssert", function () { return $e99a4bcb22f5c6ab$export$b6cb5906f04696c8; });
function $e99a4bcb22f5c6ab$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("70BmP", function(module, exports) {

$parcel$export(module.exports, "inspect", function () { return $c0e2da5bb6eae193$export$9dec5d1b3b6a130d; });
const $c0e2da5bb6eae193$var$MAX_ARRAY_LENGTH = 10;
const $c0e2da5bb6eae193$var$MAX_RECURSIVE_DEPTH = 2;
function $c0e2da5bb6eae193$export$9dec5d1b3b6a130d(value) {
    return $c0e2da5bb6eae193$var$formatValue(value, []);
}
function $c0e2da5bb6eae193$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $c0e2da5bb6eae193$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $c0e2da5bb6eae193$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($c0e2da5bb6eae193$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $c0e2da5bb6eae193$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $c0e2da5bb6eae193$var$formatArray(value, seenValues);
    return $c0e2da5bb6eae193$var$formatObject(value, seenValues);
}
function $c0e2da5bb6eae193$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $c0e2da5bb6eae193$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $c0e2da5bb6eae193$var$MAX_RECURSIVE_DEPTH) return "[" + $c0e2da5bb6eae193$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $c0e2da5bb6eae193$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $c0e2da5bb6eae193$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $c0e2da5bb6eae193$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($c0e2da5bb6eae193$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($c0e2da5bb6eae193$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $c0e2da5bb6eae193$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("9g0Pj", function(module, exports) {

$parcel$export(module.exports, "instanceOf", function () { return $5880dbfab56dfcd1$export$ca03416d6c9e029e; });

var $70BmP = parcelRequire("70BmP");
/* c8 ignore next 3 */ const $5880dbfab56dfcd1$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $5880dbfab56dfcd1$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$5880dbfab56dfcd1$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $70BmP.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

});



parcelRegister("3US94", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $2e5a98d15d9b9f4a$export$c2d084dc44961371; });

var $e4VdH = parcelRequire("e4VdH");

var $8newg = parcelRequire("8newg");

var $aSuZ6 = parcelRequire("aSuZ6");
function $2e5a98d15d9b9f4a$export$c2d084dc44961371(ast) {
    return (0, $aSuZ6.visit)(ast, $2e5a98d15d9b9f4a$var$printDocASTReducer);
}
const $2e5a98d15d9b9f4a$var$MAX_LINE_LENGTH = 80;
const $2e5a98d15d9b9f4a$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$2e5a98d15d9b9f4a$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $2e5a98d15d9b9f4a$var$join([
                node.operation,
                $2e5a98d15d9b9f4a$var$join([
                    node.name,
                    varDefs
                ]),
                $2e5a98d15d9b9f4a$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $2e5a98d15d9b9f4a$var$wrap(" = ", defaultValue) + $2e5a98d15d9b9f4a$var$wrap(" ", $2e5a98d15d9b9f4a$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$2e5a98d15d9b9f4a$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $2e5a98d15d9b9f4a$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(args, ", "), ")");
            if (argsLine.length > $2e5a98d15d9b9f4a$var$MAX_LINE_LENGTH) argsLine = prefix + $2e5a98d15d9b9f4a$var$wrap("(\n", $2e5a98d15d9b9f4a$var$indent($2e5a98d15d9b9f4a$var$join(args, "\n")), "\n)");
            return $2e5a98d15d9b9f4a$var$join([
                argsLine,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $2e5a98d15d9b9f4a$var$wrap(" ", $2e5a98d15d9b9f4a$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$2e5a98d15d9b9f4a$var$join([
                "...",
                $2e5a98d15d9b9f4a$var$wrap("on ", typeCondition),
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$2e5a98d15d9b9f4a$var$wrap("", $2e5a98d15d9b9f4a$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $e4VdH.printBlockString)(value) : (0, $8newg.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $2e5a98d15d9b9f4a$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $2e5a98d15d9b9f4a$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "schema",
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "scalar",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "type",
                name,
                $2e5a98d15d9b9f4a$var$wrap("implements ", $2e5a98d15d9b9f4a$var$join(interfaces, " & ")),
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + name + ($2e5a98d15d9b9f4a$var$hasMultilineItems(args) ? $2e5a98d15d9b9f4a$var$wrap("(\n", $2e5a98d15d9b9f4a$var$indent($2e5a98d15d9b9f4a$var$join(args, "\n")), "\n)") : $2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(args, ", "), ")")) + ": " + type + $2e5a98d15d9b9f4a$var$wrap(" ", $2e5a98d15d9b9f4a$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                name + ": " + type,
                $2e5a98d15d9b9f4a$var$wrap("= ", defaultValue),
                $2e5a98d15d9b9f4a$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "interface",
                name,
                $2e5a98d15d9b9f4a$var$wrap("implements ", $2e5a98d15d9b9f4a$var$join(interfaces, " & ")),
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "union",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$wrap("= ", $2e5a98d15d9b9f4a$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "enum",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + $2e5a98d15d9b9f4a$var$join([
                "input",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$2e5a98d15d9b9f4a$var$wrap("", description, "\n") + "directive @" + name + ($2e5a98d15d9b9f4a$var$hasMultilineItems(args) ? $2e5a98d15d9b9f4a$var$wrap("(\n", $2e5a98d15d9b9f4a$var$indent($2e5a98d15d9b9f4a$var$join(args, "\n")), "\n)") : $2e5a98d15d9b9f4a$var$wrap("(", $2e5a98d15d9b9f4a$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $2e5a98d15d9b9f4a$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$2e5a98d15d9b9f4a$var$join([
                "extend schema",
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$2e5a98d15d9b9f4a$var$join([
                "extend scalar",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$join([
                "extend type",
                name,
                $2e5a98d15d9b9f4a$var$wrap("implements ", $2e5a98d15d9b9f4a$var$join(interfaces, " & ")),
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$join([
                "extend interface",
                name,
                $2e5a98d15d9b9f4a$var$wrap("implements ", $2e5a98d15d9b9f4a$var$join(interfaces, " & ")),
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$2e5a98d15d9b9f4a$var$join([
                "extend union",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$wrap("= ", $2e5a98d15d9b9f4a$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$2e5a98d15d9b9f4a$var$join([
                "extend enum",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$2e5a98d15d9b9f4a$var$join([
                "extend input",
                name,
                $2e5a98d15d9b9f4a$var$join(directives, " "),
                $2e5a98d15d9b9f4a$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $2e5a98d15d9b9f4a$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $2e5a98d15d9b9f4a$var$block(array) {
    return $2e5a98d15d9b9f4a$var$wrap("{\n", $2e5a98d15d9b9f4a$var$indent($2e5a98d15d9b9f4a$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $2e5a98d15d9b9f4a$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $2e5a98d15d9b9f4a$var$indent(str) {
    return $2e5a98d15d9b9f4a$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $2e5a98d15d9b9f4a$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("8newg", function(module, exports) {

$parcel$export(module.exports, "printString", function () { return $9214cc401d168bfe$export$3cdec7cf614a0ecc; });
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $9214cc401d168bfe$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($9214cc401d168bfe$var$escapedRegExp, $9214cc401d168bfe$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $9214cc401d168bfe$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $9214cc401d168bfe$var$escapedReplacer(str) {
    return $9214cc401d168bfe$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $9214cc401d168bfe$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

});

parcelRegister("aSuZ6", function(module, exports) {

$parcel$export(module.exports, "visit", function () { return $f7d395c86441022e$export$bf638b60ea8b89b7; });

var $FIo2n = parcelRequire("FIo2n");

var $70BmP = parcelRequire("70BmP");

var $Pj6ey = parcelRequire("Pj6ey");

var $fjdXU = parcelRequire("fjdXU");
const $f7d395c86441022e$export$a89c95c098ac2a58 = Object.freeze({});
function $f7d395c86441022e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $Pj6ey.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $fjdXU.Kind)))enterLeaveMap.set(kind, $f7d395c86441022e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $Pj6ey.isNode)(node) || (0, $FIo2n.devAssert)(false, `Invalid AST Node: ${(0, $70BmP.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $f7d395c86441022e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $Pj6ey.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $f7d395c86441022e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $fjdXU.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $f7d395c86441022e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $f7d395c86441022e$export$a89c95c098ac2a58) skipping[i] = $f7d395c86441022e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $f7d395c86441022e$export$a89c95c098ac2a58) skipping[i] = $f7d395c86441022e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $f7d395c86441022e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $f7d395c86441022e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $f7d395c86441022e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});



parcelRegister("kE4VN", function(module, exports) {
"use strict";
var $f07b5e54d9bdca7e$var$__assign = module.exports && module.exports.__assign || function() {
    $f07b5e54d9bdca7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f07b5e54d9bdca7e$var$__assign.apply(this, arguments);
};
var $f07b5e54d9bdca7e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f07b5e54d9bdca7e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLWebSocketClient = void 0;

var $iaMvf = parcelRequire("iaMvf");

var $gfzLa = parcelRequire("gfzLa");
var $f07b5e54d9bdca7e$var$CONNECTION_INIT = "connection_init";
var $f07b5e54d9bdca7e$var$CONNECTION_ACK = "connection_ack";
var $f07b5e54d9bdca7e$var$PING = "ping";
var $f07b5e54d9bdca7e$var$PONG = "pong";
var $f07b5e54d9bdca7e$var$SUBSCRIBE = "subscribe";
var $f07b5e54d9bdca7e$var$NEXT = "next";
var $f07b5e54d9bdca7e$var$ERROR = "error";
var $f07b5e54d9bdca7e$var$COMPLETE = "complete";
var $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage = /** @class */ function() {
    function GraphQLWebSocketMessage(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "type", {
        get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "id", {
        get: function() {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "payload", {
        get: function() {
            return this._payload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "text", {
        get: function() {
            var result = {
                type: this.type
            };
            if (this.id != null && this.id != undefined) result.id = this.id;
            if (this.payload != null && this.payload != undefined) result.payload = this.payload;
            return JSON.stringify(result);
        },
        enumerable: false,
        configurable: true
    });
    GraphQLWebSocketMessage.parse = function(data, f) {
        var _a = JSON.parse(data), type = _a.type, payload = _a.payload, id = _a.id;
        return new GraphQLWebSocketMessage(type, f(payload), id);
    };
    return GraphQLWebSocketMessage;
}();
var $f07b5e54d9bdca7e$var$GraphQLWebSocketClient = /** @class */ function() {
    function GraphQLWebSocketClient(socket, _a) {
        var onInit = _a.onInit, onAcknowledged = _a.onAcknowledged, onPing = _a.onPing, onPong = _a.onPong;
        var _this = this;
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.onopen = function(e) {
            return $f07b5e54d9bdca7e$var$__awaiter(_this, void 0, void 0, function() {
                var _a, _b, _c, _d;
                return $f07b5e54d9bdca7e$var$__generator(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            this.socketState.acknowledged = false;
                            this.socketState.subscriptions = {};
                            _b = (_a = socket).send;
                            _c = $f07b5e54d9bdca7e$var$ConnectionInit;
                            if (!onInit) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                onInit()
                            ];
                        case 1:
                            _d = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _d = null;
                            _e.label = 3;
                        case 3:
                            _b.apply(_a, [
                                _c.apply(void 0, [
                                    _d
                                ]).text
                            ]);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        socket.onclose = function(e) {
            _this.socketState.acknowledged = false;
            _this.socketState.subscriptions = {};
        };
        socket.onerror = function(e) {
            console.error(e);
        };
        socket.onmessage = function(e) {
            try {
                var message = $f07b5e54d9bdca7e$var$parseMessage(e.data);
                switch(message.type){
                    case $f07b5e54d9bdca7e$var$CONNECTION_ACK:
                        if (_this.socketState.acknowledged) console.warn("Duplicate CONNECTION_ACK message ignored");
                        else {
                            _this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $f07b5e54d9bdca7e$var$PING:
                        if (onPing) onPing(message.payload).then(function(r) {
                            return socket.send($f07b5e54d9bdca7e$var$Pong(r).text);
                        });
                        else socket.send($f07b5e54d9bdca7e$var$Pong(null).text);
                        return;
                    case $f07b5e54d9bdca7e$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!_this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !_this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                var _a = _this.socketState.subscriptions[message.id], query = _a.query, variables = _a.variables, subscriber = _a.subscriber;
                switch(message.type){
                    case $f07b5e54d9bdca7e$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $iaMvf.ClientError($f07b5e54d9bdca7e$var$__assign($f07b5e54d9bdca7e$var$__assign({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $f07b5e54d9bdca7e$var$ERROR:
                        subscriber.error && subscriber.error(new $iaMvf.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $f07b5e54d9bdca7e$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete _this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, "Unknown graphql-ws message.");
        };
    }
    GraphQLWebSocketClient.prototype.makeSubscribe = function(query, operationName, subscriber, variables) {
        var _this = this;
        var subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($f07b5e54d9bdca7e$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return function() {
            _this.socket.send($f07b5e54d9bdca7e$var$Complete(subscriptionId).text);
            delete _this.socketState.subscriptions[subscriptionId];
        };
    };
    GraphQLWebSocketClient.prototype.rawRequest = function(query, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.rawSubscribe(query, {
                next: function(data, extensions) {
                    return result = {
                        data: data,
                        extensions: extensions
                    };
                },
                error: reject,
                complete: function() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.request = function(document, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.subscribe(document, {
                next: function(data) {
                    return result = data;
                },
                error: reject,
                complete: function() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.subscribe = function(document, subscriber, variables) {
        var _a = (0, $gfzLa.resolveRequestDocument)(document), query = _a.query, operationName = _a.operationName;
        return this.makeSubscribe(query, operationName, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.rawSubscribe = function(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.ping = function(payload) {
        this.socket.send($f07b5e54d9bdca7e$var$Ping(payload).text);
    };
    GraphQLWebSocketClient.prototype.close = function() {
        this.socket.close(1000);
    };
    GraphQLWebSocketClient.PROTOCOL = "graphql-transport-ws";
    return GraphQLWebSocketClient;
}();
module.exports.GraphQLWebSocketClient = $f07b5e54d9bdca7e$var$GraphQLWebSocketClient;
// Helper functions
function $f07b5e54d9bdca7e$var$parseMessage(data, f) {
    if (f === void 0) f = function(a) {
        return a;
    };
    var m = $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $f07b5e54d9bdca7e$var$ConnectionInit(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$CONNECTION_INIT, payload);
}
function $f07b5e54d9bdca7e$var$Ping(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$PING, payload, undefined);
}
function $f07b5e54d9bdca7e$var$Pong(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$PONG, payload, undefined);
}
function $f07b5e54d9bdca7e$var$Subscribe(id, payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$SUBSCRIBE, payload, id);
}
function $f07b5e54d9bdca7e$var$Complete(id) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$COMPLETE, undefined, id);
}

});



parcelRegister("kCXUJ", function(module, exports) {

$parcel$export(module.exports, "QUERY_ACCESS_EVENT", function () { return $f045d4ea661ff0a3$export$cf0a2c204733fec0; });
$parcel$export(module.exports, "QUERY_EMPLOYEES", function () { return $f045d4ea661ff0a3$export$77575dde1010e853; });
$parcel$export(module.exports, "QUERY_DIGITAL_RECEPTION", function () { return $f045d4ea661ff0a3$export$e8f50cecae62c891; });
$parcel$export(module.exports, "QUERY_CURRENTLY_CHECKED_IN", function () { return $f045d4ea661ff0a3$export$d31fe08ab069cda5; });
$parcel$export(module.exports, "QUERY_DIGITAL_RECEPTION_PUBLIC", function () { return $f045d4ea661ff0a3$export$d908ec64cd7e661a; });

var $g6uH4 = parcelRequire("g6uH4");

var $fQgQB = parcelRequire("fQgQB");
const $f045d4ea661ff0a3$export$cf0a2c204733fec0 = (0, $g6uH4.gql)`
  query accessEvent($id: ID!) {
    accessEvent(id: $id) {
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      customReceiver {
        phone
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $f045d4ea661ff0a3$export$77575dde1010e853 = (0, $g6uH4.gql)`
  query employees(
    $filter: EmployeeFilterType
    $sort: EmployeeSortType
    $pagination: Pagination
  ) {
    employees(filter: $filter, sort: $sort, pagination: $pagination) {
      id
      fullName
      email
      phone
    }
  }
`;
const $f045d4ea661ff0a3$export$e8f50cecae62c891 = (0, $g6uH4.gql)`
  query digitalReception($id: ID!, $language: String) {
    digitalReception(id: $id, language: $language) {
      id
      client {
        id
        plan
        preferences {
          ...FragmentClientPreferences
        }
      }
      metadata
      language
      languages
      theme {
        ...FragmentDigitalReceptionTheme
      }
      schedules {
        ...FragmentScreenSchedule
      }
      entranceAgreement {
        ...FragmentEntranceAgreement
      }
      settings {
        ...FragmentDigitalReceptionSettings
      }
      building {
        title
        address
        city
        zipCode
        country
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_SCREEN_SCHEDULE)}
  ${(0, $fQgQB.FRAGMENT_CLIENT_PREFERENCES)}
  ${(0, $fQgQB.FRAGMENT_DIGITAL_RECEPTION_THEME)}
  ${(0, $fQgQB.FRAGMENT_ENTRANCE_AGREEMENT)}
  ${(0, $fQgQB.FRAGMENT_DIGITAL_RECEPTION_SETTINGS)}
`;
const $f045d4ea661ff0a3$export$d31fe08ab069cda5 = (0, $g6uH4.gql)`
  query currentlyCheckedIn(
    $companyId: ID
    $filter: AccessEventFilterType
    $pagination: Pagination
  ) {
    currentlyCheckedIn(
      companyId: $companyId
      filter: $filter
      pagination: $pagination
    ) {
      events {
        type
        owner {
          ...FragmentAccessEventOwner
        }
        receiver {
          fullName
        }
        metadata
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $f045d4ea661ff0a3$export$d908ec64cd7e661a = (0, $g6uH4.gql)`
  query digitalReception($input: InputDigitalReceptionPublic!) {
    digitalReceptionPublic(input: $input) {
      playerUrl
    }
  }
`;

});
parcelRegister("fQgQB", function(module, exports) {

$parcel$export(module.exports, "FRAGMENT_DIGITAL_RECEPTION_THEME", function () { return $b888c7dffef42c86$export$20b1cd0db2ebb3d4; });
$parcel$export(module.exports, "FRAGMENT_SCREEN_SCHEDULE", function () { return $b888c7dffef42c86$export$9a588ab82ba66959; });
$parcel$export(module.exports, "FRAGMENT_EMPLOYEE_PREFERENCES", function () { return $b888c7dffef42c86$export$b494824c1c2817cb; });
$parcel$export(module.exports, "FRAGMENT_CLIENT_PREFERENCES", function () { return $b888c7dffef42c86$export$c65ed6fe6a38c1e6; });
$parcel$export(module.exports, "FRAGMENT_OWNER", function () { return $b888c7dffef42c86$export$95933c24682aa981; });
$parcel$export(module.exports, "FRAGMENT_ENTRANCE_AGREEMENT", function () { return $b888c7dffef42c86$export$c6c01953d2fddc54; });
$parcel$export(module.exports, "FRAGMENT_DIGITAL_RECEPTION_SETTINGS", function () { return $b888c7dffef42c86$export$bb363c7221836f3c; });

var $g6uH4 = parcelRequire("g6uH4");
const $b888c7dffef42c86$export$20b1cd0db2ebb3d4 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionTheme on DigitalReceptionTheme {
    colors {
      primary
      background
      textPrimary
    }
    images {
      hero {
        id
        filename
        absolutePath
      }
      logo {
        id
        filename
        absolutePath
      }
    }
  }
`;
const $b888c7dffef42c86$export$c6ac7e71bcb9167c = (0, $g6uH4.gql)`
  fragment FragmentSchedule on Schedule {
    id

    weekdays

    startDate
    startTime

    endDate
    endTime

    disabled
  }
`;
const $b888c7dffef42c86$export$9a588ab82ba66959 = (0, $g6uH4.gql)`
  fragment FragmentScreenSchedule on ScreenSchedule {
    id
    type
    schedule {
      ...FragmentSchedule
    }
  }
  ${$b888c7dffef42c86$export$c6ac7e71bcb9167c}
`;
const $b888c7dffef42c86$export$6a8f18d8ea593ef6 = (0, $g6uH4.gql)`
  fragment FragmentPreferenceChannels on MemberGroupPreferenceChannels {
    sms
    call
    ping
    videoCall
  }
`;
const $b888c7dffef42c86$export$560f90d339047c88 = (0, $g6uH4.gql)`
  fragment FragmentPreferenceAutoChannels on MemberGroupPreferenceAutoChannels {
    email
    sms
    call
    ping
  }
`;
const $b888c7dffef42c86$export$91aaef8c1a4379e5 = (0, $g6uH4.gql)`
  fragment FragmentPreference on MemberGroupPreference {
    enabled
    channel {
      ...FragmentPreferenceChannels
    }
    autoChannel {
      ...FragmentPreferenceAutoChannels
    }
  }
  ${$b888c7dffef42c86$export$6a8f18d8ea593ef6}
  ${$b888c7dffef42c86$export$560f90d339047c88}
`;
const $b888c7dffef42c86$export$b494824c1c2817cb = (0, $g6uH4.gql)`
  fragment FragmentEmployeePreferences on MemberGroupPreferences {
    visitor {
      ...FragmentPreference
    }
    meetingAttendee {
      ...FragmentPreference
    }
    foodDelivery {
      ...FragmentPreference
    }
    packageDelivery {
      ...FragmentPreference
    }
  }
  ${$b888c7dffef42c86$export$91aaef8c1a4379e5}
`;
const $b888c7dffef42c86$export$7ca79fdf9789341e = (0, $g6uH4.gql)`
  fragment FragmentClientCompanyPreferences on ClientCompanyPreferences {
    employee {
      ...FragmentEmployeePreferences
    }
  }
  ${$b888c7dffef42c86$export$b494824c1c2817cb}
`;
const $b888c7dffef42c86$export$c65ed6fe6a38c1e6 = (0, $g6uH4.gql)`
  fragment FragmentClientPreferences on ClientPreferences {
    company {
      ...FragmentClientCompanyPreferences
    }
  }
  ${$b888c7dffef42c86$export$7ca79fdf9789341e}
`;
const $b888c7dffef42c86$export$95933c24682aa981 = (0, $g6uH4.gql)`
  fragment FragmentAccessEventOwner on AccessEventOwner {
    ... on Visitor {
      id
      type
      email
      fullName
    }
    ... on Employee {
      id
      type
      email
      fullName
      availablePreferences {
        ...FragmentEmployeePreferences
      }
    }
    ... on MeetingAttendee {
      id
      email
      fullName
      member {
        type
        email
        fullName
      }
    }
    ... on Guest {
      id
      fields {
        name
        value
      }
    }
  }
  ${$b888c7dffef42c86$export$b494824c1c2817cb}
`;
const $b888c7dffef42c86$export$675138ff75242c9b = (0, $g6uH4.gql)`
  fragment FragmentEntranceAgreementFile on EntranceAgreementFile {
    id
    title
    text
    file {
      id
      absolutePath
    }

    approvalRequired
    disabled
    validFrom
    validUntil
  }
`;
const $b888c7dffef42c86$export$c6c01953d2fddc54 = (0, $g6uH4.gql)`
  fragment FragmentEntranceAgreement on EntranceAgreement {
    id
    showFirst
    disabled
    validFrom
    validUntil
    files {
      ...FragmentEntranceAgreementFile
    }
  }
  ${$b888c7dffef42c86$export$675138ff75242c9b}
`;
const $b888c7dffef42c86$export$78412636be0d2636 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionLayoutOption on DigitalReceptionLayoutOption {
    enabled
    text
    registration {
      id
      fields {
        type
        label
        required
        code
        name
        manualCheckoutIdentifier
      }
    }
    isCustom
  }
`;
const $b888c7dffef42c86$export$18fc043402fabde6 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionLayout on DigitalReceptionLayout {
    welcomeMessage {
      ...FragmentDigitalReceptionLayoutOption
    }
    checkin {
      ...FragmentDigitalReceptionLayoutOption
    }
    integratedManualCheckin {
      ...FragmentDigitalReceptionLayoutOption
    }
    independentManualCheckin {
      ...FragmentDigitalReceptionLayoutOption
    }
    checkout {
      ...FragmentDigitalReceptionLayoutOption
    }
    manualCheckout {
      ...FragmentDigitalReceptionLayoutOption
    }
    package {
      ...FragmentDigitalReceptionLayoutOption
    }
    food {
      ...FragmentDigitalReceptionLayoutOption
    }
    callReception {
      ...FragmentDigitalReceptionLayoutOption
    }
    overview {
      ...FragmentDigitalReceptionLayoutOption
    }
    wifi {
      ...FragmentDigitalReceptionLayoutOption
    }
  }
  ${$b888c7dffef42c86$export$78412636be0d2636}
`;
const $b888c7dffef42c86$export$bb363c7221836f3c = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionSettings on DigitalReceptionSettings {
    support {
      phone
      email
    }
    layout {
      ...FragmentDigitalReceptionLayout
    }
    animations {
      enabled
    }
    receptionistPhone {
      primary
      backup
    }
    deliveryReceiver {
      fullName
      email
      phone
    }
    overview {
      code
      fields
    }
    wifi {
      qrCode
    }
    clock {
      enabled
      opacity
    }
  }
  ${$b888c7dffef42c86$export$18fc043402fabde6}
`;

});


parcelRegister("b275P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80856227b26cdfad$export$2e2bcd8739ae039; });

var $6CFWV = parcelRequire("6CFWV");
const $80856227b26cdfad$var$useIdleEffectWithDisable = (onIdle = ()=>null, timeout = 90000, disabled = false)=>{
    (0, $6CFWV.default)(()=>{
        if (!disabled) onIdle();
    }, timeout);
};
var $80856227b26cdfad$export$2e2bcd8739ae039 = $80856227b26cdfad$var$useIdleEffectWithDisable;

});
parcelRegister("6CFWV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d26d4f932899e13$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $k55lg = parcelRequire("k55lg");

var $8xLkR = parcelRequire("8xLkR");
const $4d26d4f932899e13$var$useIdleEffect = (onIdle, timeout = 180000)=>{
    const idle = (0, (/*@__PURE__*/$parcel$interopDefault($k55lg)))(timeout, false);
    const prevIdle = (0, (/*@__PURE__*/$parcel$interopDefault($8xLkR)))(idle);
    (0, $eZVvM.useEffect)(()=>{
        if (!prevIdle && idle) onIdle();
    }, [
        idle,
        prevIdle
    ]);
};
var $4d26d4f932899e13$export$2e2bcd8739ae039 = $4d26d4f932899e13$var$useIdleEffect;

});
parcelRegister("k55lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $6nbhO = parcelRequire("6nbhO");

var $5rwF9 = parcelRequire("5rwF9");
var $03c5d02dd7efa52a$var$defaultEvents = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
var $03c5d02dd7efa52a$var$oneMinute = 60e3;
var $03c5d02dd7efa52a$var$useIdle = function(ms, initialState, events) {
    if (ms === void 0) ms = $03c5d02dd7efa52a$var$oneMinute;
    if (initialState === void 0) initialState = false;
    if (events === void 0) events = $03c5d02dd7efa52a$var$defaultEvents;
    var _a = $eZVvM.useState(initialState), state = _a[0], setState = _a[1];
    $eZVvM.useEffect(function() {
        var mounted = true;
        var timeout;
        var localState = state;
        var set = function(newState) {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        var onEvent = $6nbhO.throttle(50, function() {
            if (localState) set(false);
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                return set(true);
            }, ms);
        });
        var onVisibility = function() {
            if (!document.hidden) onEvent();
        };
        for(var i = 0; i < events.length; i++)$5rwF9.on(window, events[i], onEvent);
        $5rwF9.on(document, "visibilitychange", onVisibility);
        timeout = setTimeout(function() {
            return set(true);
        }, ms);
        return function() {
            mounted = false;
            for(var i = 0; i < events.length; i++)$5rwF9.off(window, events[i], onEvent);
            $5rwF9.off(document, "visibilitychange", onVisibility);
        };
    }, [
        ms,
        events
    ]);
    return state;
};
module.exports.default = $03c5d02dd7efa52a$var$useIdle;

});
parcelRegister("6nbhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */ function $4a3da5460727821c$var$throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function $4a3da5460727821c$var$debounce(delay, atBegin, callback) {
    return callback === undefined ? $4a3da5460727821c$var$throttle(delay, atBegin, false) : $4a3da5460727821c$var$throttle(delay, callback, atBegin !== false);
}
module.exports.debounce = $4a3da5460727821c$var$debounce;
module.exports.throttle = $4a3da5460727821c$var$throttle;

});

parcelRegister("5rwF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNavigator = module.exports.isBrowser = module.exports.off = module.exports.on = module.exports.noop = void 0;
var $3f68cf7be4ebe020$var$noop = function() {};
module.exports.noop = $3f68cf7be4ebe020$var$noop;
function $3f68cf7be4ebe020$var$on(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
module.exports.on = $3f68cf7be4ebe020$var$on;
function $3f68cf7be4ebe020$var$off(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
module.exports.off = $3f68cf7be4ebe020$var$off;
module.exports.isBrowser = typeof window !== "undefined";
module.exports.isNavigator = typeof navigator !== "undefined";

});


parcelRegister("8xLkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $6OqFv = parcelRequire("6OqFv");
var $63861fa5f07d4f8c$var$strictEquals = function(prev, next) {
    return prev === next;
};
function $63861fa5f07d4f8c$var$usePreviousDistinct(value, compare) {
    if (compare === void 0) compare = $63861fa5f07d4f8c$var$strictEquals;
    var prevRef = $eZVvM.useRef();
    var curRef = $eZVvM.useRef(value);
    var isFirstMount = $6OqFv.useFirstMountState();
    if (!isFirstMount && !compare(curRef.current, value)) {
        prevRef.current = curRef.current;
        curRef.current = value;
    }
    return prevRef.current;
}
module.exports.default = $63861fa5f07d4f8c$var$usePreviousDistinct;

});
parcelRegister("6OqFv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFirstMountState = void 0;

var $eZVvM = parcelRequire("eZVvM");
function $4f5c195ed174124c$var$useFirstMountState() {
    var isFirst = $eZVvM.useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
module.exports.useFirstMountState = $4f5c195ed174124c$var$useFirstMountState;

});




parcelRegister("8YEKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6893897371819677$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $e8m2I = parcelRequire("e8m2I");

var $eGmvL = parcelRequire("eGmvL");
const $6893897371819677$var$MUITitle = (0, $e8m2I.default)("div")(({ theme: theme })=>({
        textAlign: "center",
        padding: "0 12rem",
        "@media screen and (orientation: landscape)": {
            position: "absolute",
            top: "0",
            height: "35.185%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            ".children": {
                padding: "0 8rem",
                minWidth: "107.7rem",
                height: "20rem",
                // backdropFilter: "blur(0.8rem)",
                background: "rgba(35, 35, 35, 0.825)",
                borderRadius: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                "& > *": {
                    color: theme.palette.background.default
                }
            }
        }
    }));
const $6893897371819677$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ children: children, className: className, disableAnimation: disableAnimation })=>{
    return (0, $bhfvP.jsx)($6893897371819677$var$MUITitle, Object.assign({
        className: className
    }, {
        children: (0, $bhfvP.jsx)((0, $eGmvL.default), Object.assign({
            disabled: disableAnimation
        }, {
            children: (0, $bhfvP.jsx)("div", Object.assign({
                className: "children"
            }, {
                children: children
            }))
        }))
    }));
});
var $6893897371819677$export$2e2bcd8739ae039 = $6893897371819677$var$Title;

});
parcelRegister("eGmvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06733bc80cd377$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $ljukC = parcelRequire("ljukC");

var $4yVoh = parcelRequire("4yVoh");

var $cD0nt = parcelRequire("cD0nt");
const $ab06733bc80cd377$var$reveal = {
    initial: {
        opacity: 0,
        y: 105
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        }
    }
};
const $ab06733bc80cd377$var$Reveal = (props)=>{
    const { children: children, disabled: disabled, className: className } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (!animationsEnabled) return children;
    return (0, $bhfvP.jsx)("div", Object.assign({
        style: {
            position: "relative",
            width: "fit-content",
            overflow: "hidden"
        },
        className: className
    }, {
        children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({}, !disabled && (0, $4yVoh.anim)($ab06733bc80cd377$var$reveal), {
            children: children
        }))
    }));
};
var $ab06733bc80cd377$export$2e2bcd8739ae039 = $ab06733bc80cd377$var$Reveal;

});
parcelRegister("4yVoh", function(module, exports) {

$parcel$export(module.exports, "anim", function () { return $3526daffea22ef7a$export$bd46b8ab3689edc4; });
$parcel$export(module.exports, "modalUp", function () { return $3526daffea22ef7a$export$1c33d2a8eb772259; });
$parcel$export(module.exports, "modalIn", function () { return $3526daffea22ef7a$export$755918b48c75c65a; });
const $3526daffea22ef7a$export$bd46b8ab3689edc4 = (variants)=>{
    return {
        variants: variants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        whileTap: "tap"
    };
};
const $3526daffea22ef7a$export$1c33d2a8eb772259 = {
    initial: {
        y: "100%"
    },
    animate: {
        y: 0,
        transition: {
            duration: 0.4,
            delay: 0.1,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        y: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $3526daffea22ef7a$export$755918b48c75c65a = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.4,
            delay: 0.1,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};

});

parcelRegister("cD0nt", function(module, exports) {

$parcel$export(module.exports, "useClientPlan", function () { return $93196b8a18a06646$export$81371f8c31556ab1; });
$parcel$export(module.exports, "useLayout", function () { return $93196b8a18a06646$export$f47430f7ffdcc134; });
$parcel$export(module.exports, "useReceptionistPhone", function () { return $93196b8a18a06646$export$9f30821ab9eba6a3; });
$parcel$export(module.exports, "useDeliveryReceiver", function () { return $93196b8a18a06646$export$2cd5f299e15b85fc; });
$parcel$export(module.exports, "useOverview", function () { return $93196b8a18a06646$export$626541a5c6f2cfa1; });
$parcel$export(module.exports, "useAnimationsEnabled", function () { return $93196b8a18a06646$export$765324f4cccd6e12; });
$parcel$export(module.exports, "useWifiQrCode", function () { return $93196b8a18a06646$export$43b49132ff30c8a3; });
$parcel$export(module.exports, "useClock", function () { return $93196b8a18a06646$export$ebd4152617a83c60; });
$parcel$export(module.exports, "useDigitalReceptionCountry", function () { return $93196b8a18a06646$export$ea9c10744d0b37bf; });
$parcel$export(module.exports, "useIdentificationCode", function () { return $93196b8a18a06646$export$9da223f01d1173b2; });
$parcel$export(module.exports, "default", function () { return $93196b8a18a06646$export$2e2bcd8739ae039; });

var $dMu0R = parcelRequire("dMu0R");

var $jXblK = parcelRequire("jXblK");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $jnPOB = parcelRequire("jnPOB");

var $cwDEq = parcelRequire("cwDEq");

var $kCXUJ = parcelRequire("kCXUJ");

var $219y6 = parcelRequire("219y6");
var $93196b8a18a06646$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $93196b8a18a06646$export$5118ea9943f64521 = ()=>{
    const { screenId: screenId } = (0, $cwDEq.useAppContext)();
    const [, { language: language }] = (0, $9GLBV.useTranslation)();
    const { online: online, storeData: storeData, getData: getData } = (0, $219y6.useOfflineContext)();
    return (0, $dMu0R.useQuery)([
        "digitalReception",
        {
            id: screenId,
            language: language,
            online: online
        }
    ], ()=>$93196b8a18a06646$var$__awaiter(void 0, void 0, void 0, function*() {
            try {
                const data = yield (0, $jnPOB.client).request((0, $kCXUJ.QUERY_DIGITAL_RECEPTION), {
                    id: screenId,
                    language: language
                });
                yield storeData(`/app/config/${language}`, data);
                return data;
            } catch (error) {
                const config = yield getData(`/app/config/${language}`);
                return config;
            }
        }), {
        enabled: !!screenId,
        staleTime: 300000,
        refetchInterval: 300000,
        keepPreviousData: true
    });
};
function $93196b8a18a06646$export$81371f8c31556ab1() {
    var _a, _b;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.plan;
}
function $93196b8a18a06646$export$f47430f7ffdcc134() {
    const { data: data, dataUpdatedAt: dataUpdatedAt } = $93196b8a18a06646$export$5118ea9943f64521(); // added to react to re-render when data is updated
    // this needs to be here for the preview to work in the CMS
    // dataUpdatedAt;
    return {
        welcomeMessage: (0, $jXblK.get)(data, `digitalReception.settings.layout.welcomeMessage`),
        checkin: (0, $jXblK.get)(data, "digitalReception.settings.layout.checkin"),
        integratedManualCheckin: (0, $jXblK.get)(data, "digitalReception.settings.layout.integratedManualCheckin"),
        independentManualCheckin: (0, $jXblK.get)(data, "digitalReception.settings.layout.independentManualCheckin"),
        checkout: (0, $jXblK.get)(data, "digitalReception.settings.layout.checkout"),
        manualCheckout: (0, $jXblK.get)(data, "digitalReception.settings.layout.manualCheckout"),
        packageDelivery: (0, $jXblK.get)(data, "digitalReception.settings.layout.package"),
        foodDelivery: (0, $jXblK.get)(data, "digitalReception.settings.layout.food"),
        callReception: (0, $jXblK.get)(data, "digitalReception.settings.layout.callReception"),
        overview: (0, $jXblK.get)(data, "digitalReception.settings.layout.overview"),
        wifi: (0, $jXblK.get)(data, "digitalReception.settings.layout.wifi")
    };
}
function $93196b8a18a06646$export$9f30821ab9eba6a3() {
    var _a, _b, _c;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.receptionistPhone) === null || _c === void 0 ? void 0 : _c.primary;
}
const $93196b8a18a06646$export$2cd5f299e15b85fc = ()=>{
    var _a, _b;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.deliveryReceiver;
};
const $93196b8a18a06646$export$626541a5c6f2cfa1 = ()=>{
    var _a, _b, _c, _d, _e, _f;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return {
        code: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.overview) === null || _c === void 0 ? void 0 : _c.code,
        fields: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.overview) === null || _f === void 0 ? void 0 : _f.fields
    };
};
const $93196b8a18a06646$export$765324f4cccd6e12 = ()=>{
    var _a, _b, _c;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.animations) === null || _c === void 0 ? void 0 : _c.enabled;
};
const $93196b8a18a06646$export$43b49132ff30c8a3 = ()=>{
    var _a, _b, _c;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.wifi) === null || _c === void 0 ? void 0 : _c.qrCode;
};
const $93196b8a18a06646$export$ebd4152617a83c60 = ()=>{
    var _a, _b;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.clock;
};
const $93196b8a18a06646$export$ea9c10744d0b37bf = ()=>{
    var _a, _b;
    const { data: data } = $93196b8a18a06646$export$5118ea9943f64521();
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.building) === null || _b === void 0 ? void 0 : _b.country;
};
const $93196b8a18a06646$export$9da223f01d1173b2 = ()=>{
    var _a, _b, _c, _d;
    const { integratedManualCheckin: integratedManualCheckin, independentManualCheckin: independentManualCheckin } = $93196b8a18a06646$export$f47430f7ffdcc134();
    let manualCheckoutGuestCode = "";
    if (!!(integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled)) manualCheckoutGuestCode = ((_b = (_a = integratedManualCheckin.registration) === null || _a === void 0 ? void 0 : _a.fields.find((field)=>!!field.manualCheckoutIdentifier)) === null || _b === void 0 ? void 0 : _b.code) || "";
    if (!!(independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled)) manualCheckoutGuestCode = ((_d = (_c = independentManualCheckin.registration) === null || _c === void 0 ? void 0 : _c.fields.find((field)=>!!field.manualCheckoutIdentifier)) === null || _d === void 0 ? void 0 : _d.code) || "";
    return manualCheckoutGuestCode;
};
var $93196b8a18a06646$export$2e2bcd8739ae039 = $93196b8a18a06646$export$5118ea9943f64521;

});
parcelRegister("cwDEq", function(module, exports) {

$parcel$export(module.exports, "useAppContext", function () { return $91e73b0c1d305339$export$fdc397e486fa83e7; });
$parcel$export(module.exports, "useAppConfig", function () { return $91e73b0c1d305339$export$a3e0ece8c3f698d7; });
$parcel$export(module.exports, "default", function () { return $91e73b0c1d305339$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");

var $1PAIo = parcelRequire("1PAIo");

var $gcLBF = parcelRequire("gcLBF");
var $gdPnm = parcelRequire("gdPnm");

var $e31rn = parcelRequire("e31rn");
const $91e73b0c1d305339$var$isDev = false;
const $91e73b0c1d305339$var$Status = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    (0, $e31rn.default)();
    return null;
});
const $91e73b0c1d305339$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(undefined);
const { Provider: $91e73b0c1d305339$var$Provider } = $91e73b0c1d305339$var$AppContext;
const $91e73b0c1d305339$export$fdc397e486fa83e7 = ()=>(0, $eZVvM.useContext)($91e73b0c1d305339$var$AppContext);
const $91e73b0c1d305339$export$a3e0ece8c3f698d7 = ()=>$91e73b0c1d305339$export$fdc397e486fa83e7().config;
const $91e73b0c1d305339$var$App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ children: children })=>{
    const basename = (0, $eZVvM.useMemo)(()=>{
        if ($91e73b0c1d305339$var$isDev) return "/";
        return window.location.pathname.split("/").filter(Boolean).slice(0, 4).join("/");
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>{
        const { location: { search: search, pathname: pathname } } = window;
        const query = (0, $f19az.default).parse(search);
        const paths = pathname.split("/");
        const screenId = $91e73b0c1d305339$var$isDev ? undefined : paths[4];
        const clientId = $91e73b0c1d305339$var$isDev ? undefined : paths[2];
        return {
            screenId: screenId,
            clientId: clientId,
            config: {
                theme: !!query.theme,
                connect: !!query.connect,
                preview: !!(query === null || query === void 0 ? void 0 : query.preview)
            }
        };
    }, []);
    const client = (0, $eZVvM.useMemo)(()=>{
        var _a;
        let options = {
            refetchInterval: 300000
        };
        if ((_a = value === null || value === void 0 ? void 0 : value.config) === null || _a === void 0 ? void 0 : _a.theme) options = {
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchInterval: undefined
        };
        const client = new (0, $gcLBF.QueryClient)({
            defaultOptions: {
                queries: options
            }
        });
        return client;
    }, []);
    return (0, $bhfvP.jsx)($91e73b0c1d305339$var$Provider, Object.assign({
        value: value
    }, {
        children: (0, $bhfvP.jsxs)((0, $gdPnm.QueryClientProvider), Object.assign({
            client: client
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $1PAIo.BrowserRouter), Object.assign({
                    basename: basename
                }, {
                    children: children
                })),
                (0, $bhfvP.jsx)($91e73b0c1d305339$var$Status, {})
            ]
        }))
    }));
});
var $91e73b0c1d305339$export$2e2bcd8739ae039 = $91e73b0c1d305339$var$App;

});
parcelRegister("f19az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeee0fdc8238e58f$export$2e2bcd8739ae039; });

var $aeDS2 = parcelRequire("aeDS2");
var $aeee0fdc8238e58f$export$2e2bcd8739ae039 = $aeDS2;

});
parcelRegister("aeDS2", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $773a23ad4506684d$export$f9380c9a627682d3; });
$parcel$export(module.exports, "parse", function () { return $773a23ad4506684d$export$98e6a39c04603d36; });
$parcel$export(module.exports, "stringify", function () { return $773a23ad4506684d$export$fac44ee5b035f737; });
$parcel$export(module.exports, "parseUrl", function () { return $773a23ad4506684d$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "stringifyUrl", function () { return $773a23ad4506684d$export$a8c1621ea79325d3; });
$parcel$export(module.exports, "pick", function () { return $773a23ad4506684d$export$357523c63a2253b9; });
$parcel$export(module.exports, "exclude", function () { return $773a23ad4506684d$export$44c361b8ec72ef7f; });

var $6RNQN = parcelRequire("6RNQN");

var $dnsI4 = parcelRequire("dnsI4");

var $9Zy2X = parcelRequire("9Zy2X");
const $773a23ad4506684d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $773a23ad4506684d$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $773a23ad4506684d$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $773a23ad4506684d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[",
                            $773a23ad4506684d$var$encode(index, options),
                            "]=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[]=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            ":list=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $773a23ad4506684d$var$encode(key, options),
                                keyValueSep,
                                $773a23ad4506684d$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $773a23ad4506684d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $773a23ad4506684d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $773a23ad4506684d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $773a23ad4506684d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $773a23ad4506684d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$773a23ad4506684d$var$decode(item, options)) : value === null ? value : $773a23ad4506684d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $773a23ad4506684d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$773a23ad4506684d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $773a23ad4506684d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $773a23ad4506684d$var$encode(value, options) {
    if (options.encode) return options.strict ? $773a23ad4506684d$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $773a23ad4506684d$var$decode(value, options) {
    if (options.decode) return (0, $6RNQN.default)(value);
    return value;
}
function $773a23ad4506684d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $773a23ad4506684d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $773a23ad4506684d$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $773a23ad4506684d$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $773a23ad4506684d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $773a23ad4506684d$export$f9380c9a627682d3(input) {
    input = $773a23ad4506684d$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $773a23ad4506684d$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $773a23ad4506684d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $773a23ad4506684d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $dnsI4.default)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $773a23ad4506684d$var$decode(value, options);
        formatter($773a23ad4506684d$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $773a23ad4506684d$var$parseValue(value2, options);
        else returnValue[key] = $773a23ad4506684d$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? $773a23ad4506684d$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $773a23ad4506684d$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $773a23ad4506684d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $773a23ad4506684d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $773a23ad4506684d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $773a23ad4506684d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $773a23ad4506684d$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $773a23ad4506684d$var$encode(key, options) + "=" + $773a23ad4506684d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $773a23ad4506684d$export$7a5253c0f62e0150(url, options) {
    var _url__split;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $dnsI4.default)(url, "#");
    if (url_ === undefined) url_ = url;
    var _url__split_;
    return {
        url: (_url__split_ = url_ === null || url_ === void 0 ? void 0 : (_url__split = url_.split("?")) === null || _url__split === void 0 ? void 0 : _url__split[0]) !== null && _url__split_ !== void 0 ? _url__split_ : "",
        query: $773a23ad4506684d$export$98e6a39c04603d36($773a23ad4506684d$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $773a23ad4506684d$var$decode(hash, options)
        } : {}
    };
}
function $773a23ad4506684d$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$773a23ad4506684d$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $773a23ad4506684d$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $773a23ad4506684d$export$f9380c9a627682d3(object.url);
    const query = {
        ...$773a23ad4506684d$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $773a23ad4506684d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $773a23ad4506684d$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$773a23ad4506684d$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $773a23ad4506684d$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$773a23ad4506684d$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $773a23ad4506684d$export$7a5253c0f62e0150(input, options);
    return $773a23ad4506684d$export$a8c1621ea79325d3({
        url: url,
        query: (0, $9Zy2X.includeKeys)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $773a23ad4506684d$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $773a23ad4506684d$export$357523c63a2253b9(input, exclusionFilter, options);
}

});
parcelRegister("6RNQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ffe5c9845671cef$export$2e2bcd8739ae039; });
const $4ffe5c9845671cef$var$token = "%[a-f0-9]{2}";
const $4ffe5c9845671cef$var$singleMatcher = new RegExp("(" + $4ffe5c9845671cef$var$token + ")|([^%]+?)", "gi");
const $4ffe5c9845671cef$var$multiMatcher = new RegExp("(" + $4ffe5c9845671cef$var$token + ")+", "gi");
function $4ffe5c9845671cef$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (e) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $4ffe5c9845671cef$var$decodeComponents(left), $4ffe5c9845671cef$var$decodeComponents(right));
}
function $4ffe5c9845671cef$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (e) {
        let tokens = input.match($4ffe5c9845671cef$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $4ffe5c9845671cef$var$decodeComponents(tokens, i).join("");
            tokens = input.match($4ffe5c9845671cef$var$singleMatcher) || [];
        }
        return input;
    }
}
function $4ffe5c9845671cef$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    let match = $4ffe5c9845671cef$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (e) {
            const result = $4ffe5c9845671cef$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $4ffe5c9845671cef$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $4ffe5c9845671cef$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (e) {
        // Fallback to a more advanced decoder
        return $4ffe5c9845671cef$var$customDecodeURIComponent(encodedURI);
    }
}

});

parcelRegister("dnsI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bd3b180673dda83$export$2e2bcd8739ae039; });
function $9bd3b180673dda83$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

});

parcelRegister("9Zy2X", function(module, exports) {

$parcel$export(module.exports, "includeKeys", function () { return $7464388b703ff115$export$ff05df6c2df24b52; });
function $7464388b703ff115$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $7464388b703ff115$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $7464388b703ff115$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $7464388b703ff115$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}

});



parcelRegister("gcLBF", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $11566bfa4ceb3c13$export$405d0624ed55a03f; });

var $g3yHX = parcelRequire("g3yHX");

var $lbL00 = parcelRequire("lbL00");

var $1AR2H = parcelRequire("1AR2H");

var $aQMrm = parcelRequire("aQMrm");

var $6lhov = parcelRequire("6lhov");

var $bq3DV = parcelRequire("bq3DV");

var $4dUyM = parcelRequire("4dUyM");

var $8Zibu = parcelRequire("8Zibu");
// CLASS
class $11566bfa4ceb3c13$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $aQMrm.focusManager).subscribe(()=>{
            if ((0, $aQMrm.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6lhov.onlineManager).subscribe(()=>{
            if ((0, $6lhov.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $g3yHX.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $bq3DV.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $bq3DV.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $bq3DV.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $bq3DV.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $bq3DV.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $bq3DV.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $g3yHX.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $g3yHX.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $4dUyM.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $g3yHX.hashQueryKey)(queryKey) === (0, $g3yHX.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $g3yHX.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $g3yHX.hashQueryKey)(mutationKey) === (0, $g3yHX.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $g3yHX.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $g3yHX.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $lbL00.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $1AR2H.MutationCache)();
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}

});
parcelRegister("lbL00", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $d62e30f4f1b95e54$export$5dde0cd941da8468; });

var $g3yHX = parcelRequire("g3yHX");

var $2pAwp = parcelRequire("2pAwp");

var $bq3DV = parcelRequire("bq3DV");

var $4QcTI = parcelRequire("4QcTI");
// CLASS
class $d62e30f4f1b95e54$export$5dde0cd941da8468 extends (0, $4QcTI.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $g3yHX.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $2pAwp.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $g3yHX.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $g3yHX.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}

});
parcelRegister("2pAwp", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $d931235dae4e7ac4$export$62297b13309008b2; });

var $g3yHX = parcelRequire("g3yHX");

var $8Zibu = parcelRequire("8Zibu");

var $bq3DV = parcelRequire("bq3DV");

var $lodjx = parcelRequire("lodjx");

var $6817H = parcelRequire("6817H");
// CLASS
class $d931235dae4e7ac4$export$62297b13309008b2 extends (0, $6817H.Removable) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $g3yHX.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $g3yHX.noop)).catch((0, $g3yHX.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $g3yHX.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $g3yHX.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $lodjx.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $lodjx.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $lodjx.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $lodjx.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $lodjx.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $bq3DV.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $d931235dae4e7ac4$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $d931235dae4e7ac4$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

});
parcelRegister("8Zibu", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $89b4e3aacb76f2c9$export$1cf3d545f2d4635c; });
const $89b4e3aacb76f2c9$export$1cf3d545f2d4635c = console;

});

parcelRegister("6817H", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $8726b2c54d7df87a$export$e09608847fcc8c59; });

var $g3yHX = parcelRequire("g3yHX");
class $8726b2c54d7df87a$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $g3yHX.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $g3yHX.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});



parcelRegister("1AR2H", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $4200bcb0fd468ff4$export$1fcfd9a244434844; });

var $bq3DV = parcelRequire("bq3DV");

var $30Kai = parcelRequire("30Kai");

var $g3yHX = parcelRequire("g3yHX");

var $4QcTI = parcelRequire("4QcTI");
// CLASS
class $4200bcb0fd468ff4$export$1fcfd9a244434844 extends (0, $4QcTI.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $30Kai.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $g3yHX.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $g3yHX.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $bq3DV.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $g3yHX.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}

});
parcelRegister("30Kai", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $4b158c2694492c68$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $4b158c2694492c68$export$a1659b54bac3252a; });

var $8Zibu = parcelRequire("8Zibu");

var $bq3DV = parcelRequire("bq3DV");

var $6817H = parcelRequire("6817H");

var $lodjx = parcelRequire("lodjx");
// CLASS
class $4b158c2694492c68$export$17b8b19c814bcf56 extends (0, $6817H.Removable) {
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $lodjx.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $lodjx.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $bq3DV.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.observers = [];
        this.state = config.state || $4b158c2694492c68$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $4b158c2694492c68$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

});


parcelRegister("4dUyM", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $74ae56171a5adfe6$export$84470d1367601e8d; });
function $74ae56171a5adfe6$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $74ae56171a5adfe6$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $74ae56171a5adfe6$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $74ae56171a5adfe6$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $74ae56171a5adfe6$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $74ae56171a5adfe6$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $74ae56171a5adfe6$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $74ae56171a5adfe6$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $74ae56171a5adfe6$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $74ae56171a5adfe6$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

});


parcelRegister("e31rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3a276930475c1a3$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");

var $f19az = parcelRequire("f19az");

var $jJnsE = parcelRequire("jJnsE");

var $bIHE3 = parcelRequire("bIHE3");

var $3hHqY = parcelRequire("3hHqY");

var $ghHeQ = parcelRequire("ghHeQ");

var $cwDEq = parcelRequire("cwDEq");

var $l4qYG = parcelRequire("l4qYG");
var $a3a276930475c1a3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a3a276930475c1a3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a3a276930475c1a3$var$useBoardStatus = ()=>{
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { screenId: screenId, clientId: clientId, config: config } = (0, $cwDEq.useAppContext)();
    const { scheduleScreensaver: scheduleScreensaver } = (0, $l4qYG.useSchedulesContext)();
    const onMessage = (0, $eZVvM.useCallback)((event)=>$a3a276930475c1a3$var$__awaiter(void 0, void 0, void 0, function*() {
            const { data: rawMessage } = event;
            try {
                const message = JSON.parse(rawMessage);
                if (!(message && message.action)) return;
                const predicate = ({ queryKey: queryKey })=>{
                    if (!(Array.isArray(queryKey) && queryKey.length)) return false;
                    const [key, params] = queryKey;
                    if (key !== "digitalReception") return false;
                    return "id" in params && params.id === screenId;
                };
                switch(message.action){
                    case "restart":
                        window.location.href = (0, $f19az.default).stringifyUrl({
                            url: `${window.location.origin}/client/${clientId}/board/${screenId}`,
                            query: config
                        });
                        break;
                    case "refresh":
                        {
                            const { digitalReception: digitalReception } = yield queryClient.fetchQuery([
                                "digitalReception",
                                {
                                    id: screenId
                                }
                            ]);
                            if (config.preview) break;
                            const sleepSchedules = (0, (/*@__PURE__*/$parcel$interopDefault($bIHE3)))(digitalReception === null || digitalReception === void 0 ? void 0 : digitalReception.schedules, (item)=>item.type === "sleep" && !item.schedule.disabled);
                            if (sleepSchedules.length > 0) scheduleScreensaver(sleepSchedules);
                            break;
                        }
                    case "update-digitalReception":
                        {
                            const { data: data } = message;
                            queryClient.setQueriesData({
                                predicate: predicate
                            }, (prev)=>{
                                // prettier-ignore
                                if (!(prev && prev.digitalReception && data && data.digitalReception)) return data;
                                const { digitalReception: prevDigitalReception } = prev, rest = $a3a276930475c1a3$var$__rest(prev, [
                                    "digitalReception"
                                ]);
                                const { digitalReception: partialDigitalReception } = data; // eslint-disable-next-line consistent-return
                                const digitalReception = (0, (/*@__PURE__*/$parcel$interopDefault($jJnsE)))(prevDigitalReception, partialDigitalReception, (obj, src)=>{
                                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3hHqY)))(obj)) return src;
                                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ghHeQ)))(obj)) return (0, (/*@__PURE__*/$parcel$interopDefault($jJnsE)))(obj, src);
                                    return src;
                                });
                                return Object.assign(Object.assign({}, rest), {
                                    digitalReception: digitalReception
                                });
                            });
                            break;
                        }
                    default:
                        break;
                }
            } catch (_a) {}
        }), []);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, []);
    return (0, $dMu0R.useQuery)([
        `network/board/${screenId}`
    ], ({ queryKey: [url] })=>{
        return new Promise((resolve, reject)=>{
            const baseURL = "https://api.digitalreception.app".replace(/(http)(s)?\:\/\//, "ws$2://");
            const socket = new WebSocket(`${baseURL}/${url}`);
            if (socket.readyState === WebSocket.OPEN) {
                resolve(true);
                return;
            }
            socket.onopen = function(e) {
                return resolve(e);
            };
            socket.onerror = function(error) {
                queryClient.invalidateQueries([
                    url
                ], {
                    exact: true
                });
                return reject(error);
            };
            socket.onmessage = function(event) {
                onMessage(event);
            };
            socket.onclose = ()=>{
                queryClient.invalidateQueries([
                    url
                ], {
                    exact: true
                });
                return reject(new Error("Socket close. Retry"));
            };
        });
    }, {
        retry: true,
        retryDelay: 5000,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        enabled: config === null || config === void 0 ? void 0 : config.connect
    });
};
var $a3a276930475c1a3$export$2e2bcd8739ae039 = $a3a276930475c1a3$var$useBoardStatus;

});
parcelRegister("jJnsE", function(module, exports) {

var $2zZZr = parcelRequire("2zZZr");

var $87EVA = parcelRequire("87EVA");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $e5d46b276d2f04f7$var$mergeWith = $87EVA(function(object, source, srcIndex, customizer) {
    $2zZZr(object, source, srcIndex, customizer);
});
module.exports = $e5d46b276d2f04f7$var$mergeWith;

});
parcelRegister("2zZZr", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $7PCa6 = parcelRequire("7PCa6");

var $hIy2P = parcelRequire("hIy2P");

var $6khZu = parcelRequire("6khZu");

var $ghHeQ = parcelRequire("ghHeQ");

var $gG7av = parcelRequire("gG7av");

var $7zKJO = parcelRequire("7zKJO");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $1e0eef8f3d27fcc7$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $hIy2P(source, function(srcValue, key) {
        stack || (stack = new $29kQd);
        if ($ghHeQ(srcValue)) $6khZu(object, source, key, srcIndex, $1e0eef8f3d27fcc7$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($7zKJO(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7PCa6(object, key, newValue);
        }
    }, $gG7av);
}
module.exports = $1e0eef8f3d27fcc7$var$baseMerge;

});
parcelRegister("29kQd", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");

var $40Drz = parcelRequire("40Drz");

var $1juPT = parcelRequire("1juPT");

var $1hWlM = parcelRequire("1hWlM");

var $iZe0I = parcelRequire("iZe0I");

var $3PQst = parcelRequire("3PQst");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $190c96a43ace7fa1$var$Stack(entries) {
    var data = this.__data__ = new $RaYJF(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$190c96a43ace7fa1$var$Stack.prototype.clear = $40Drz;
$190c96a43ace7fa1$var$Stack.prototype["delete"] = $1juPT;
$190c96a43ace7fa1$var$Stack.prototype.get = $1hWlM;
$190c96a43ace7fa1$var$Stack.prototype.has = $iZe0I;
$190c96a43ace7fa1$var$Stack.prototype.set = $3PQst;
module.exports = $190c96a43ace7fa1$var$Stack;

});
parcelRegister("RaYJF", function(module, exports) {

var $1wSTR = parcelRequire("1wSTR");

var $i2a4T = parcelRequire("i2a4T");

var $iX798 = parcelRequire("iX798");

var $6yIzX = parcelRequire("6yIzX");

var $apJYE = parcelRequire("apJYE");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $09fd77796af7d56f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$09fd77796af7d56f$var$ListCache.prototype.clear = $1wSTR;
$09fd77796af7d56f$var$ListCache.prototype["delete"] = $i2a4T;
$09fd77796af7d56f$var$ListCache.prototype.get = $iX798;
$09fd77796af7d56f$var$ListCache.prototype.has = $6yIzX;
$09fd77796af7d56f$var$ListCache.prototype.set = $apJYE;
module.exports = $09fd77796af7d56f$var$ListCache;

});
parcelRegister("1wSTR", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $11d35d9ae7bbb9d6$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $11d35d9ae7bbb9d6$var$listCacheClear;

});

parcelRegister("i2a4T", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/** Used for built-in method references. */ var $d2103b2e36e7943b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d2103b2e36e7943b$var$splice = $d2103b2e36e7943b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d2103b2e36e7943b$var$listCacheDelete(key) {
    var data = this.__data__, index = $4xB6E(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d2103b2e36e7943b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d2103b2e36e7943b$var$listCacheDelete;

});
parcelRegister("4xB6E", function(module, exports) {

var $8z8Gw = parcelRequire("8z8Gw");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $34e7070bbc939c9d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($8z8Gw(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $34e7070bbc939c9d$var$assocIndexOf;

});
parcelRegister("8z8Gw", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $63c85442e636aa60$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $63c85442e636aa60$var$eq;

});



parcelRegister("iX798", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dcc347c91c14deb0$var$listCacheGet(key) {
    var data = this.__data__, index = $4xB6E(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $dcc347c91c14deb0$var$listCacheGet;

});

parcelRegister("6yIzX", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4c687f7bb715a15c$var$listCacheHas(key) {
    return $4xB6E(this.__data__, key) > -1;
}
module.exports = $4c687f7bb715a15c$var$listCacheHas;

});

parcelRegister("apJYE", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $794fe74ebac1ae7e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4xB6E(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $794fe74ebac1ae7e$var$listCacheSet;

});


parcelRegister("40Drz", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2eb5c2363f13d634$var$stackClear() {
    this.__data__ = new $RaYJF;
    this.size = 0;
}
module.exports = $2eb5c2363f13d634$var$stackClear;

});

parcelRegister("1juPT", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0f4f7c29d1b71fd1$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $0f4f7c29d1b71fd1$var$stackDelete;

});

parcelRegister("1hWlM", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0f04a42152cc55ca$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $0f04a42152cc55ca$var$stackGet;

});

parcelRegister("iZe0I", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $03912c8f432f9172$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $03912c8f432f9172$var$stackHas;

});

parcelRegister("3PQst", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");

var $kbZZK = parcelRequire("kbZZK");

var $dtBcs = parcelRequire("dtBcs");
/** Used as the size to enable large array optimizations. */ var $2caed3a103a9951a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2caed3a103a9951a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $RaYJF) {
        var pairs = data.__data__;
        if (!$kbZZK || pairs.length < $2caed3a103a9951a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $dtBcs(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $2caed3a103a9951a$var$stackSet;

});
parcelRegister("kbZZK", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $eb34eca7f622df2a$var$Map = $llv3Q($1sHSN, "Map");
module.exports = $eb34eca7f622df2a$var$Map;

});
parcelRegister("llv3Q", function(module, exports) {

var $1Rvpy = parcelRequire("1Rvpy");

var $nfEOY = parcelRequire("nfEOY");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f8a3a73a62185d7a$var$getNative(object, key) {
    var value = $nfEOY(object, key);
    return $1Rvpy(value) ? value : undefined;
}
module.exports = $f8a3a73a62185d7a$var$getNative;

});
parcelRegister("1Rvpy", function(module, exports) {

var $2MN1q = parcelRequire("2MN1q");

var $2A0QU = parcelRequire("2A0QU");

var $ghHeQ = parcelRequire("ghHeQ");

var $kpFqz = parcelRequire("kpFqz");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $15b31b4ee095c0a2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $15b31b4ee095c0a2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $15b31b4ee095c0a2$var$funcProto = Function.prototype, $15b31b4ee095c0a2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $15b31b4ee095c0a2$var$funcToString = $15b31b4ee095c0a2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $15b31b4ee095c0a2$var$hasOwnProperty = $15b31b4ee095c0a2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $15b31b4ee095c0a2$var$reIsNative = RegExp("^" + $15b31b4ee095c0a2$var$funcToString.call($15b31b4ee095c0a2$var$hasOwnProperty).replace($15b31b4ee095c0a2$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $15b31b4ee095c0a2$var$baseIsNative(value) {
    if (!$ghHeQ(value) || $2A0QU(value)) return false;
    var pattern = $2MN1q(value) ? $15b31b4ee095c0a2$var$reIsNative : $15b31b4ee095c0a2$var$reIsHostCtor;
    return pattern.test($kpFqz(value));
}
module.exports = $15b31b4ee095c0a2$var$baseIsNative;

});
parcelRegister("2MN1q", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $ghHeQ = parcelRequire("ghHeQ");
/** `Object#toString` result references. */ var $2076173ac570d4ec$var$asyncTag = "[object AsyncFunction]", $2076173ac570d4ec$var$funcTag = "[object Function]", $2076173ac570d4ec$var$genTag = "[object GeneratorFunction]", $2076173ac570d4ec$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $2076173ac570d4ec$var$isFunction(value) {
    if (!$ghHeQ(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $jasl7(value);
    return tag == $2076173ac570d4ec$var$funcTag || tag == $2076173ac570d4ec$var$genTag || tag == $2076173ac570d4ec$var$asyncTag || tag == $2076173ac570d4ec$var$proxyTag;
}
module.exports = $2076173ac570d4ec$var$isFunction;

});
parcelRegister("jasl7", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $4YJwg = parcelRequire("4YJwg");

var $fsmmK = parcelRequire("fsmmK");
/** `Object#toString` result references. */ var $df44ef2cb3a51367$var$nullTag = "[object Null]", $df44ef2cb3a51367$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $df44ef2cb3a51367$var$symToStringTag = $lLnMZ ? $lLnMZ.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $df44ef2cb3a51367$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $df44ef2cb3a51367$var$undefinedTag : $df44ef2cb3a51367$var$nullTag;
    return $df44ef2cb3a51367$var$symToStringTag && $df44ef2cb3a51367$var$symToStringTag in Object(value) ? $4YJwg(value) : $fsmmK(value);
}
module.exports = $df44ef2cb3a51367$var$baseGetTag;

});
parcelRegister("lLnMZ", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Built-in value references. */ var $fd8070c4f2debf93$var$Symbol = $1sHSN.Symbol;
module.exports = $fd8070c4f2debf93$var$Symbol;

});

parcelRegister("4YJwg", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");
/** Used for built-in method references. */ var $3a0013353adbd6d6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3a0013353adbd6d6$var$hasOwnProperty = $3a0013353adbd6d6$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3a0013353adbd6d6$var$nativeObjectToString = $3a0013353adbd6d6$var$objectProto.toString;
/** Built-in value references. */ var $3a0013353adbd6d6$var$symToStringTag = $lLnMZ ? $lLnMZ.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3a0013353adbd6d6$var$getRawTag(value) {
    var isOwn = $3a0013353adbd6d6$var$hasOwnProperty.call(value, $3a0013353adbd6d6$var$symToStringTag), tag = value[$3a0013353adbd6d6$var$symToStringTag];
    try {
        value[$3a0013353adbd6d6$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3a0013353adbd6d6$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3a0013353adbd6d6$var$symToStringTag] = tag;
        else delete value[$3a0013353adbd6d6$var$symToStringTag];
    }
    return result;
}
module.exports = $3a0013353adbd6d6$var$getRawTag;

});

parcelRegister("fsmmK", function(module, exports) {
/** Used for built-in method references. */ var $b40ad1ee8d75fecf$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b40ad1ee8d75fecf$var$nativeObjectToString = $b40ad1ee8d75fecf$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b40ad1ee8d75fecf$var$objectToString(value) {
    return $b40ad1ee8d75fecf$var$nativeObjectToString.call(value);
}
module.exports = $b40ad1ee8d75fecf$var$objectToString;

});


parcelRegister("ghHeQ", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bdafc62116ece13d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $bdafc62116ece13d$var$isObject;

});


parcelRegister("2A0QU", function(module, exports) {

var $Mbrn4 = parcelRequire("Mbrn4");
/** Used to detect methods masquerading as native. */ var $1e0f9ad0ce4f66eb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($Mbrn4 && $Mbrn4.keys && $Mbrn4.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1e0f9ad0ce4f66eb$var$isMasked(func) {
    return !!$1e0f9ad0ce4f66eb$var$maskSrcKey && $1e0f9ad0ce4f66eb$var$maskSrcKey in func;
}
module.exports = $1e0f9ad0ce4f66eb$var$isMasked;

});
parcelRegister("Mbrn4", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Used to detect overreaching core-js shims. */ var $090d5ba5f6231071$var$coreJsData = $1sHSN["__core-js_shared__"];
module.exports = $090d5ba5f6231071$var$coreJsData;

});


parcelRegister("kpFqz", function(module, exports) {
/** Used for built-in method references. */ var $edc647193fc6f96d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $edc647193fc6f96d$var$funcToString = $edc647193fc6f96d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $edc647193fc6f96d$var$toSource(func) {
    if (func != null) {
        try {
            return $edc647193fc6f96d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $edc647193fc6f96d$var$toSource;

});


parcelRegister("nfEOY", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $045e4b54e42a7211$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $045e4b54e42a7211$var$getValue;

});



parcelRegister("dtBcs", function(module, exports) {

var $5ZqWy = parcelRequire("5ZqWy");

var $8ifhw = parcelRequire("8ifhw");

var $7T0sg = parcelRequire("7T0sg");

var $kD65d = parcelRequire("kD65d");

var $3DJK7 = parcelRequire("3DJK7");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9cfad6ea037af1c6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9cfad6ea037af1c6$var$MapCache.prototype.clear = $5ZqWy;
$9cfad6ea037af1c6$var$MapCache.prototype["delete"] = $8ifhw;
$9cfad6ea037af1c6$var$MapCache.prototype.get = $7T0sg;
$9cfad6ea037af1c6$var$MapCache.prototype.has = $kD65d;
$9cfad6ea037af1c6$var$MapCache.prototype.set = $3DJK7;
module.exports = $9cfad6ea037af1c6$var$MapCache;

});
parcelRegister("5ZqWy", function(module, exports) {

var $3TJBn = parcelRequire("3TJBn");

var $RaYJF = parcelRequire("RaYJF");

var $kbZZK = parcelRequire("kbZZK");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $45c78ca228d84e27$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $3TJBn,
        "map": new ($kbZZK || $RaYJF),
        "string": new $3TJBn
    };
}
module.exports = $45c78ca228d84e27$var$mapCacheClear;

});
parcelRegister("3TJBn", function(module, exports) {

var $85tAc = parcelRequire("85tAc");

var $jaCOP = parcelRequire("jaCOP");

var $9blWi = parcelRequire("9blWi");

var $cr0fb = parcelRequire("cr0fb");

var $2Cioi = parcelRequire("2Cioi");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2d69e1b5bf1157cd$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$2d69e1b5bf1157cd$var$Hash.prototype.clear = $85tAc;
$2d69e1b5bf1157cd$var$Hash.prototype["delete"] = $jaCOP;
$2d69e1b5bf1157cd$var$Hash.prototype.get = $9blWi;
$2d69e1b5bf1157cd$var$Hash.prototype.has = $cr0fb;
$2d69e1b5bf1157cd$var$Hash.prototype.set = $2Cioi;
module.exports = $2d69e1b5bf1157cd$var$Hash;

});
parcelRegister("85tAc", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5e35bce9957dee8c$var$hashClear() {
    this.__data__ = $5hhyA ? $5hhyA(null) : {};
    this.size = 0;
}
module.exports = $5e35bce9957dee8c$var$hashClear;

});
parcelRegister("5hhyA", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");
/* Built-in method references that are verified to be native. */ var $3d7c28b200d1a20d$var$nativeCreate = $llv3Q(Object, "create");
module.exports = $3d7c28b200d1a20d$var$nativeCreate;

});


parcelRegister("jaCOP", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df4d101f5b9fcd2d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $df4d101f5b9fcd2d$var$hashDelete;

});

parcelRegister("9blWi", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used to stand-in for `undefined` hash values. */ var $6af628cf22c60ed8$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $6af628cf22c60ed8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6af628cf22c60ed8$var$hasOwnProperty = $6af628cf22c60ed8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6af628cf22c60ed8$var$hashGet(key) {
    var data = this.__data__;
    if ($5hhyA) {
        var result = data[key];
        return result === $6af628cf22c60ed8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6af628cf22c60ed8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $6af628cf22c60ed8$var$hashGet;

});

parcelRegister("cr0fb", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used for built-in method references. */ var $90d83216985d9829$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $90d83216985d9829$var$hasOwnProperty = $90d83216985d9829$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $90d83216985d9829$var$hashHas(key) {
    var data = this.__data__;
    return $5hhyA ? data[key] !== undefined : $90d83216985d9829$var$hasOwnProperty.call(data, key);
}
module.exports = $90d83216985d9829$var$hashHas;

});

parcelRegister("2Cioi", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used to stand-in for `undefined` hash values. */ var $1e7d6571ccd0dc1d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $1e7d6571ccd0dc1d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $5hhyA && value === undefined ? $1e7d6571ccd0dc1d$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $1e7d6571ccd0dc1d$var$hashSet;

});



parcelRegister("8ifhw", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $609bdbca109826bf$var$mapCacheDelete(key) {
    var result = $i9hnu(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $609bdbca109826bf$var$mapCacheDelete;

});
parcelRegister("i9hnu", function(module, exports) {

var $aikhR = parcelRequire("aikhR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d3668c2526d990b3$var$getMapData(map, key) {
    var data = map.__data__;
    return $aikhR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $d3668c2526d990b3$var$getMapData;

});
parcelRegister("aikhR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $77eb526782a6fe33$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $77eb526782a6fe33$var$isKeyable;

});



parcelRegister("7T0sg", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5bde05c8b6704c1a$var$mapCacheGet(key) {
    return $i9hnu(this, key).get(key);
}
module.exports = $5bde05c8b6704c1a$var$mapCacheGet;

});

parcelRegister("kD65d", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f04c2b247c8c21b7$var$mapCacheHas(key) {
    return $i9hnu(this, key).has(key);
}
module.exports = $f04c2b247c8c21b7$var$mapCacheHas;

});

parcelRegister("3DJK7", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2a687f2e91804320$var$mapCacheSet(key, value) {
    var data = $i9hnu(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $2a687f2e91804320$var$mapCacheSet;

});




parcelRegister("7PCa6", function(module, exports) {

var $4b5Hj = parcelRequire("4b5Hj");

var $8z8Gw = parcelRequire("8z8Gw");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5b3ae600168d081d$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$8z8Gw(object[key], value) || value === undefined && !(key in object)) $4b5Hj(object, key, value);
}
module.exports = $5b3ae600168d081d$var$assignMergeValue;

});
parcelRegister("4b5Hj", function(module, exports) {

var $6l5GV = parcelRequire("6l5GV");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $30ac9bf0fb60a701$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $6l5GV) $6l5GV(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $30ac9bf0fb60a701$var$baseAssignValue;

});
parcelRegister("6l5GV", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");
var $49d91e69d437debb$var$defineProperty = function() {
    try {
        var func = $llv3Q(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $49d91e69d437debb$var$defineProperty;

});



parcelRegister("hIy2P", function(module, exports) {

var $j0K2P = parcelRequire("j0K2P");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ce60f4436d142a26$var$baseFor = $j0K2P();
module.exports = $ce60f4436d142a26$var$baseFor;

});
parcelRegister("j0K2P", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dd71bbe508c3fe5f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $dd71bbe508c3fe5f$var$createBaseFor;

});


parcelRegister("6khZu", function(module, exports) {

var $7PCa6 = parcelRequire("7PCa6");

var $aCYKL = parcelRequire("aCYKL");

var $I3BGa = parcelRequire("I3BGa");

var $2JrPW = parcelRequire("2JrPW");

var $8NITN = parcelRequire("8NITN");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $hOxVQ = parcelRequire("hOxVQ");

var $hLa8L = parcelRequire("hLa8L");

var $2MN1q = parcelRequire("2MN1q");

var $ghHeQ = parcelRequire("ghHeQ");

var $8fzzn = parcelRequire("8fzzn");

var $1OdLr = parcelRequire("1OdLr");

var $7zKJO = parcelRequire("7zKJO");

var $eBjvb = parcelRequire("eBjvb");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $49b290ea3e1ddf15$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $7zKJO(object, key), srcValue = $7zKJO(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7PCa6(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $3hHqY(srcValue), isBuff = !isArr && $hLa8L(srcValue), isTyped = !isArr && !isBuff && $1OdLr(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($3hHqY(objValue)) newValue = objValue;
            else if ($hOxVQ(objValue)) newValue = $2JrPW(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $aCYKL(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $I3BGa(srcValue, true);
            } else newValue = [];
        } else if ($8fzzn(srcValue) || $17tLN(srcValue)) {
            newValue = objValue;
            if ($17tLN(objValue)) newValue = $eBjvb(objValue);
            else if (!$ghHeQ(objValue) || $2MN1q(objValue)) newValue = $8NITN(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $7PCa6(object, key, newValue);
}
module.exports = $49b290ea3e1ddf15$var$baseMergeDeep;

});
parcelRegister("I3BGa", function(module, exports) {

var $bJemi = parcelRequire("bJemi");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $0846e865934f10f8$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $bJemi(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $0846e865934f10f8$var$cloneTypedArray;

});
parcelRegister("bJemi", function(module, exports) {

var $7OcN3 = parcelRequire("7OcN3");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $889f08ff2fbd1a83$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $7OcN3(result).set(new $7OcN3(arrayBuffer));
    return result;
}
module.exports = $889f08ff2fbd1a83$var$cloneArrayBuffer;

});
parcelRegister("7OcN3", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Built-in value references. */ var $5af71fc4b4055af4$var$Uint8Array = $1sHSN.Uint8Array;
module.exports = $5af71fc4b4055af4$var$Uint8Array;

});



parcelRegister("2JrPW", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1fd560858a42b95d$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $1fd560858a42b95d$var$copyArray;

});

parcelRegister("8NITN", function(module, exports) {

var $91gPb = parcelRequire("91gPb");

var $cnQD5 = parcelRequire("cnQD5");

var $757xh = parcelRequire("757xh");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6685ba537310abab$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$757xh(object) ? $91gPb($cnQD5(object)) : {};
}
module.exports = $6685ba537310abab$var$initCloneObject;

});
parcelRegister("91gPb", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");
/** Built-in value references. */ var $6911421007ee03ec$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $6911421007ee03ec$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ghHeQ(proto)) return {};
        if ($6911421007ee03ec$var$objectCreate) return $6911421007ee03ec$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $6911421007ee03ec$var$baseCreate;

});

parcelRegister("cnQD5", function(module, exports) {

var $4zjLY = parcelRequire("4zjLY");
/** Built-in value references. */ var $9040751b3cb0bf30$var$getPrototype = $4zjLY(Object.getPrototypeOf, Object);
module.exports = $9040751b3cb0bf30$var$getPrototype;

});
parcelRegister("4zjLY", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3539c4bfd0e647e3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $3539c4bfd0e647e3$var$overArg;

});


parcelRegister("757xh", function(module, exports) {
/** Used for built-in method references. */ var $527ed8819dc7b019$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $527ed8819dc7b019$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $527ed8819dc7b019$var$objectProto;
    return value === proto;
}
module.exports = $527ed8819dc7b019$var$isPrototype;

});


parcelRegister("17tLN", function(module, exports) {

var $cm4QR = parcelRequire("cm4QR");

var $iK9OP = parcelRequire("iK9OP");
/** Used for built-in method references. */ var $0d0d8993478cd3b0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d0d8993478cd3b0$var$hasOwnProperty = $0d0d8993478cd3b0$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $0d0d8993478cd3b0$var$propertyIsEnumerable = $0d0d8993478cd3b0$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $0d0d8993478cd3b0$var$isArguments = $cm4QR(function() {
    return arguments;
}()) ? $cm4QR : function(value) {
    return $iK9OP(value) && $0d0d8993478cd3b0$var$hasOwnProperty.call(value, "callee") && !$0d0d8993478cd3b0$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $0d0d8993478cd3b0$var$isArguments;

});
parcelRegister("cm4QR", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $8feb4d8605aba269$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8feb4d8605aba269$var$baseIsArguments(value) {
    return $iK9OP(value) && $jasl7(value) == $8feb4d8605aba269$var$argsTag;
}
module.exports = $8feb4d8605aba269$var$baseIsArguments;

});
parcelRegister("iK9OP", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $da5423b30b8d5d35$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $da5423b30b8d5d35$var$isObjectLike;

});



parcelRegister("3hHqY", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2644a6beee24c4cd$var$isArray = Array.isArray;
module.exports = $2644a6beee24c4cd$var$isArray;

});

parcelRegister("hOxVQ", function(module, exports) {

var $gyLmc = parcelRequire("gyLmc");

var $iK9OP = parcelRequire("iK9OP");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $cf816d5991d9f97e$var$isArrayLikeObject(value) {
    return $iK9OP(value) && $gyLmc(value);
}
module.exports = $cf816d5991d9f97e$var$isArrayLikeObject;

});
parcelRegister("gyLmc", function(module, exports) {

var $2MN1q = parcelRequire("2MN1q");

var $kpNNN = parcelRequire("kpNNN");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $c0e48e74e7951d24$var$isArrayLike(value) {
    return value != null && $kpNNN(value.length) && !$2MN1q(value);
}
module.exports = $c0e48e74e7951d24$var$isArrayLike;

});
parcelRegister("kpNNN", function(module, exports) {
/** Used as references for various `Number` constants. */ var $edccc6223fac6bf2$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $edccc6223fac6bf2$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $edccc6223fac6bf2$var$MAX_SAFE_INTEGER;
}
module.exports = $edccc6223fac6bf2$var$isLength;

});



parcelRegister("8fzzn", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $cnQD5 = parcelRequire("cnQD5");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $601b50d99805b4be$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $601b50d99805b4be$var$funcProto = Function.prototype, $601b50d99805b4be$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $601b50d99805b4be$var$funcToString = $601b50d99805b4be$var$funcProto.toString;
/** Used to check objects for own properties. */ var $601b50d99805b4be$var$hasOwnProperty = $601b50d99805b4be$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $601b50d99805b4be$var$objectCtorString = $601b50d99805b4be$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $601b50d99805b4be$var$isPlainObject(value) {
    if (!$iK9OP(value) || $jasl7(value) != $601b50d99805b4be$var$objectTag) return false;
    var proto = $cnQD5(value);
    if (proto === null) return true;
    var Ctor = $601b50d99805b4be$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $601b50d99805b4be$var$funcToString.call(Ctor) == $601b50d99805b4be$var$objectCtorString;
}
module.exports = $601b50d99805b4be$var$isPlainObject;

});

parcelRegister("1OdLr", function(module, exports) {

var $7qBU4 = parcelRequire("7qBU4");

var $6REps = parcelRequire("6REps");

var $1sJ0x = parcelRequire("1sJ0x");
/* Node.js helper references. */ var $15152340a0cf668a$var$nodeIsTypedArray = $1sJ0x && $1sJ0x.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $15152340a0cf668a$var$isTypedArray = $15152340a0cf668a$var$nodeIsTypedArray ? $6REps($15152340a0cf668a$var$nodeIsTypedArray) : $7qBU4;
module.exports = $15152340a0cf668a$var$isTypedArray;

});
parcelRegister("7qBU4", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $kpNNN = parcelRequire("kpNNN");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $56885ced9908a55e$var$argsTag = "[object Arguments]", $56885ced9908a55e$var$arrayTag = "[object Array]", $56885ced9908a55e$var$boolTag = "[object Boolean]", $56885ced9908a55e$var$dateTag = "[object Date]", $56885ced9908a55e$var$errorTag = "[object Error]", $56885ced9908a55e$var$funcTag = "[object Function]", $56885ced9908a55e$var$mapTag = "[object Map]", $56885ced9908a55e$var$numberTag = "[object Number]", $56885ced9908a55e$var$objectTag = "[object Object]", $56885ced9908a55e$var$regexpTag = "[object RegExp]", $56885ced9908a55e$var$setTag = "[object Set]", $56885ced9908a55e$var$stringTag = "[object String]", $56885ced9908a55e$var$weakMapTag = "[object WeakMap]";
var $56885ced9908a55e$var$arrayBufferTag = "[object ArrayBuffer]", $56885ced9908a55e$var$dataViewTag = "[object DataView]", $56885ced9908a55e$var$float32Tag = "[object Float32Array]", $56885ced9908a55e$var$float64Tag = "[object Float64Array]", $56885ced9908a55e$var$int8Tag = "[object Int8Array]", $56885ced9908a55e$var$int16Tag = "[object Int16Array]", $56885ced9908a55e$var$int32Tag = "[object Int32Array]", $56885ced9908a55e$var$uint8Tag = "[object Uint8Array]", $56885ced9908a55e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $56885ced9908a55e$var$uint16Tag = "[object Uint16Array]", $56885ced9908a55e$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $56885ced9908a55e$var$typedArrayTags = {};
$56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$float32Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$float64Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int8Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int16Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int32Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint8Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint8ClampedTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint16Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint32Tag] = true;
$56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$argsTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$arrayTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$arrayBufferTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$boolTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$dataViewTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$dateTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$errorTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$funcTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$mapTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$numberTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$objectTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$regexpTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$setTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$stringTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $56885ced9908a55e$var$baseIsTypedArray(value) {
    return $iK9OP(value) && $kpNNN(value.length) && !!$56885ced9908a55e$var$typedArrayTags[$jasl7(value)];
}
module.exports = $56885ced9908a55e$var$baseIsTypedArray;

});

parcelRegister("6REps", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4ff709cd0ee61334$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $4ff709cd0ee61334$var$baseUnary;

});


parcelRegister("7zKJO", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $58400e70064b05f6$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $58400e70064b05f6$var$safeGet;

});

parcelRegister("eBjvb", function(module, exports) {

var $59vT0 = parcelRequire("59vT0");

var $gG7av = parcelRequire("gG7av");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $aa13a615a6fde3ce$var$toPlainObject(value) {
    return $59vT0(value, $gG7av(value));
}
module.exports = $aa13a615a6fde3ce$var$toPlainObject;

});
parcelRegister("59vT0", function(module, exports) {

var $8uute = parcelRequire("8uute");

var $4b5Hj = parcelRequire("4b5Hj");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3c0686ee04ac7826$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $4b5Hj(object, key, newValue);
        else $8uute(object, key, newValue);
    }
    return object;
}
module.exports = $3c0686ee04ac7826$var$copyObject;

});
parcelRegister("8uute", function(module, exports) {

var $4b5Hj = parcelRequire("4b5Hj");

var $8z8Gw = parcelRequire("8z8Gw");
/** Used for built-in method references. */ var $62e8c2dc2549acb7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62e8c2dc2549acb7$var$hasOwnProperty = $62e8c2dc2549acb7$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $62e8c2dc2549acb7$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($62e8c2dc2549acb7$var$hasOwnProperty.call(object, key) && $8z8Gw(objValue, value)) || value === undefined && !(key in object)) $4b5Hj(object, key, value);
}
module.exports = $62e8c2dc2549acb7$var$assignValue;

});


parcelRegister("gG7av", function(module, exports) {

var $4pYGV = parcelRequire("4pYGV");

var $g1hXR = parcelRequire("g1hXR");

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $c246211643b1ea2a$var$keysIn(object) {
    return $gyLmc(object) ? $4pYGV(object, true) : $g1hXR(object);
}
module.exports = $c246211643b1ea2a$var$keysIn;

});
parcelRegister("4pYGV", function(module, exports) {

var $j65fp = parcelRequire("j65fp");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $hLa8L = parcelRequire("hLa8L");

var $kNhZg = parcelRequire("kNhZg");

var $1OdLr = parcelRequire("1OdLr");
/** Used for built-in method references. */ var $33789342229d1f99$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $33789342229d1f99$var$hasOwnProperty = $33789342229d1f99$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $33789342229d1f99$var$arrayLikeKeys(value, inherited) {
    var isArr = $3hHqY(value), isArg = !isArr && $17tLN(value), isBuff = !isArr && !isArg && $hLa8L(value), isType = !isArr && !isArg && !isBuff && $1OdLr(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $j65fp(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $33789342229d1f99$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $kNhZg(key, length)))) result.push(key);
    return result;
}
module.exports = $33789342229d1f99$var$arrayLikeKeys;

});
parcelRegister("j65fp", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $de72a5e683ee52dc$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $de72a5e683ee52dc$var$baseTimes;

});

parcelRegister("kNhZg", function(module, exports) {
/** Used as references for various `Number` constants. */ var $03e81a29ce5f05a1$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $03e81a29ce5f05a1$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $03e81a29ce5f05a1$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $03e81a29ce5f05a1$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $03e81a29ce5f05a1$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $03e81a29ce5f05a1$var$isIndex;

});


parcelRegister("g1hXR", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");

var $757xh = parcelRequire("757xh");

var $iTx9g = parcelRequire("iTx9g");
/** Used for built-in method references. */ var $ba9aacb805de176e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba9aacb805de176e$var$hasOwnProperty = $ba9aacb805de176e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ba9aacb805de176e$var$baseKeysIn(object) {
    if (!$ghHeQ(object)) return $iTx9g(object);
    var isProto = $757xh(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$ba9aacb805de176e$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $ba9aacb805de176e$var$baseKeysIn;

});
parcelRegister("iTx9g", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $dc1713a6a7009e20$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $dc1713a6a7009e20$var$nativeKeysIn;

});






parcelRegister("87EVA", function(module, exports) {

var $63hoU = parcelRequire("63hoU");

var $2bHYF = parcelRequire("2bHYF");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $5e9eb99b9243c3d0$var$createAssigner(assigner) {
    return $63hoU(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $2bHYF(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $5e9eb99b9243c3d0$var$createAssigner;

});
parcelRegister("63hoU", function(module, exports) {

var $hrfQh = parcelRequire("hrfQh");

var $57Xx2 = parcelRequire("57Xx2");

var $9o1BV = parcelRequire("9o1BV");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $4680854cd8f2123d$var$baseRest(func, start) {
    return $9o1BV($57Xx2(func, start, $hrfQh), func + "");
}
module.exports = $4680854cd8f2123d$var$baseRest;

});
parcelRegister("hrfQh", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $cb213f323a674370$var$identity(value) {
    return value;
}
module.exports = $cb213f323a674370$var$identity;

});

parcelRegister("57Xx2", function(module, exports) {

var $kPXrV = parcelRequire("kPXrV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3bbbc8f79e522a29$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3bbbc8f79e522a29$var$overRest(func, start, transform) {
    start = $3bbbc8f79e522a29$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3bbbc8f79e522a29$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $kPXrV(func, this, otherArgs);
    };
}
module.exports = $3bbbc8f79e522a29$var$overRest;

});
parcelRegister("kPXrV", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f2b6af8161d5d5b7$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $f2b6af8161d5d5b7$var$apply;

});


parcelRegister("9o1BV", function(module, exports) {

var $4nrw9 = parcelRequire("4nrw9");

var $7llC9 = parcelRequire("7llC9");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6d579ac686b8b6b3$var$setToString = $7llC9($4nrw9);
module.exports = $6d579ac686b8b6b3$var$setToString;

});
parcelRegister("4nrw9", function(module, exports) {

var $jVgXn = parcelRequire("jVgXn");

var $6l5GV = parcelRequire("6l5GV");

var $hrfQh = parcelRequire("hrfQh");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $32fea7ce67ef9053$var$baseSetToString = !$6l5GV ? $hrfQh : function(func, string) {
    return $6l5GV(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $jVgXn(string),
        "writable": true
    });
};
module.exports = $32fea7ce67ef9053$var$baseSetToString;

});
parcelRegister("jVgXn", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e8107e7163ddcdd1$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $e8107e7163ddcdd1$var$constant;

});


parcelRegister("7llC9", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $558b42bcae1d010a$var$HOT_COUNT = 800, $558b42bcae1d010a$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $558b42bcae1d010a$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $558b42bcae1d010a$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $558b42bcae1d010a$var$nativeNow(), remaining = $558b42bcae1d010a$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $558b42bcae1d010a$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $558b42bcae1d010a$var$shortOut;

});



parcelRegister("2bHYF", function(module, exports) {

var $8z8Gw = parcelRequire("8z8Gw");

var $gyLmc = parcelRequire("gyLmc");

var $kNhZg = parcelRequire("kNhZg");

var $ghHeQ = parcelRequire("ghHeQ");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $197eb8dc757049ae$var$isIterateeCall(value, index, object) {
    if (!$ghHeQ(object)) return false;
    var type = typeof index;
    if (type == "number" ? $gyLmc(object) && $kNhZg(index, object.length) : type == "string" && index in object) return $8z8Gw(object[index], value);
    return false;
}
module.exports = $197eb8dc757049ae$var$isIterateeCall;

});



parcelRegister("bIHE3", function(module, exports) {

var $laHY0 = parcelRequire("laHY0");

var $8Gn6t = parcelRequire("8Gn6t");

var $9PmZ6 = parcelRequire("9PmZ6");

var $3hHqY = parcelRequire("3hHqY");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $8885a8be14d38304$var$filter(collection, predicate) {
    var func = $3hHqY(collection) ? $laHY0 : $8Gn6t;
    return func(collection, $9PmZ6(predicate, 3));
}
module.exports = $8885a8be14d38304$var$filter;

});
parcelRegister("laHY0", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f69ca30aaa17c7a3$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $f69ca30aaa17c7a3$var$arrayFilter;

});

parcelRegister("8Gn6t", function(module, exports) {

var $erFZL = parcelRequire("erFZL");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $65242ad6a10a5316$var$baseFilter(collection, predicate) {
    var result = [];
    $erFZL(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $65242ad6a10a5316$var$baseFilter;

});
parcelRegister("erFZL", function(module, exports) {

var $dd9cd = parcelRequire("dd9cd");

var $c4ClI = parcelRequire("c4ClI");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a84429a7aa05d2b0$var$baseEach = $c4ClI($dd9cd);
module.exports = $a84429a7aa05d2b0$var$baseEach;

});
parcelRegister("dd9cd", function(module, exports) {

var $hIy2P = parcelRequire("hIy2P");

var $4MkDT = parcelRequire("4MkDT");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $99e39f636e05d6bf$var$baseForOwn(object, iteratee) {
    return object && $hIy2P(object, iteratee, $4MkDT);
}
module.exports = $99e39f636e05d6bf$var$baseForOwn;

});
parcelRegister("4MkDT", function(module, exports) {

var $4pYGV = parcelRequire("4pYGV");

var $3ERlS = parcelRequire("3ERlS");

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $37aba8405f912a95$var$keys(object) {
    return $gyLmc(object) ? $4pYGV(object) : $3ERlS(object);
}
module.exports = $37aba8405f912a95$var$keys;

});
parcelRegister("3ERlS", function(module, exports) {

var $757xh = parcelRequire("757xh");

var $gIutM = parcelRequire("gIutM");
/** Used for built-in method references. */ var $2a9e7e1700f9e886$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2a9e7e1700f9e886$var$hasOwnProperty = $2a9e7e1700f9e886$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2a9e7e1700f9e886$var$baseKeys(object) {
    if (!$757xh(object)) return $gIutM(object);
    var result = [];
    for(var key in Object(object))if ($2a9e7e1700f9e886$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $2a9e7e1700f9e886$var$baseKeys;

});
parcelRegister("gIutM", function(module, exports) {

var $4zjLY = parcelRequire("4zjLY");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2b865eff48146fb$var$nativeKeys = $4zjLY(Object.keys, Object);
module.exports = $c2b865eff48146fb$var$nativeKeys;

});




parcelRegister("c4ClI", function(module, exports) {

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $8ca39b189116e38e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$gyLmc(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $8ca39b189116e38e$var$createBaseEach;

});



parcelRegister("9PmZ6", function(module, exports) {

var $4V6fX = parcelRequire("4V6fX");

var $icPnl = parcelRequire("icPnl");

var $hrfQh = parcelRequire("hrfQh");

var $3hHqY = parcelRequire("3hHqY");

var $6luml = parcelRequire("6luml");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $727ab4bc49e27fdf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $hrfQh;
    if (typeof value == "object") return $3hHqY(value) ? $icPnl(value[0], value[1]) : $4V6fX(value);
    return $6luml(value);
}
module.exports = $727ab4bc49e27fdf$var$baseIteratee;

});
parcelRegister("4V6fX", function(module, exports) {

var $2yf2n = parcelRequire("2yf2n");

var $aKQmx = parcelRequire("aKQmx");

var $7DyzG = parcelRequire("7DyzG");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $395156b5014c4edd$var$baseMatches(source) {
    var matchData = $aKQmx(source);
    if (matchData.length == 1 && matchData[0][2]) return $7DyzG(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2yf2n(object, source, matchData);
    };
}
module.exports = $395156b5014c4edd$var$baseMatches;

});
parcelRegister("2yf2n", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $c2d0B = parcelRequire("c2d0B");
/** Used to compose bitmasks for value comparisons. */ var $1dba6bdee42845ae$var$COMPARE_PARTIAL_FLAG = 1, $1dba6bdee42845ae$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $1dba6bdee42845ae$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $29kQd;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $c2d0B(srcValue, objValue, $1dba6bdee42845ae$var$COMPARE_PARTIAL_FLAG | $1dba6bdee42845ae$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $1dba6bdee42845ae$var$baseIsMatch;

});
parcelRegister("c2d0B", function(module, exports) {

var $ljWXo = parcelRequire("ljWXo");

var $iK9OP = parcelRequire("iK9OP");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8c2fc32ff0e1a287$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$iK9OP(value) && !$iK9OP(other)) return value !== value && other !== other;
    return $ljWXo(value, other, bitmask, customizer, $8c2fc32ff0e1a287$var$baseIsEqual, stack);
}
module.exports = $8c2fc32ff0e1a287$var$baseIsEqual;

});
parcelRegister("ljWXo", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $cBpu1 = parcelRequire("cBpu1");

var $2JZFE = parcelRequire("2JZFE");

var $bI9Va = parcelRequire("bI9Va");

var $8J52P = parcelRequire("8J52P");

var $3hHqY = parcelRequire("3hHqY");

var $hLa8L = parcelRequire("hLa8L");

var $1OdLr = parcelRequire("1OdLr");
/** Used to compose bitmasks for value comparisons. */ var $f8591af7cf050940$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $f8591af7cf050940$var$argsTag = "[object Arguments]", $f8591af7cf050940$var$arrayTag = "[object Array]", $f8591af7cf050940$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f8591af7cf050940$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f8591af7cf050940$var$hasOwnProperty = $f8591af7cf050940$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f8591af7cf050940$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3hHqY(object), othIsArr = $3hHqY(other), objTag = objIsArr ? $f8591af7cf050940$var$arrayTag : $8J52P(object), othTag = othIsArr ? $f8591af7cf050940$var$arrayTag : $8J52P(other);
    objTag = objTag == $f8591af7cf050940$var$argsTag ? $f8591af7cf050940$var$objectTag : objTag;
    othTag = othTag == $f8591af7cf050940$var$argsTag ? $f8591af7cf050940$var$objectTag : othTag;
    var objIsObj = objTag == $f8591af7cf050940$var$objectTag, othIsObj = othTag == $f8591af7cf050940$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hLa8L(object)) {
        if (!$hLa8L(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $29kQd);
        return objIsArr || $1OdLr(object) ? $cBpu1(object, other, bitmask, customizer, equalFunc, stack) : $2JZFE(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $f8591af7cf050940$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $f8591af7cf050940$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $f8591af7cf050940$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $29kQd);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $29kQd);
    return $bI9Va(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $f8591af7cf050940$var$baseIsEqualDeep;

});
parcelRegister("cBpu1", function(module, exports) {

var $7TzSp = parcelRequire("7TzSp");

var $akGgj = parcelRequire("akGgj");

var $2oKLN = parcelRequire("2oKLN");
/** Used to compose bitmasks for value comparisons. */ var $92ccb52c2796c52a$var$COMPARE_PARTIAL_FLAG = 1, $92ccb52c2796c52a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $92ccb52c2796c52a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $92ccb52c2796c52a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $92ccb52c2796c52a$var$COMPARE_UNORDERED_FLAG ? new $7TzSp : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$akGgj(other, function(othValue, othIndex) {
                if (!$2oKLN(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $92ccb52c2796c52a$var$equalArrays;

});
parcelRegister("7TzSp", function(module, exports) {

var $dtBcs = parcelRequire("dtBcs");

var $kdtOH = parcelRequire("kdtOH");

var $gORv3 = parcelRequire("gORv3");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5bf97fd087bcc0a1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $dtBcs;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5bf97fd087bcc0a1$var$SetCache.prototype.add = $5bf97fd087bcc0a1$var$SetCache.prototype.push = $kdtOH;
$5bf97fd087bcc0a1$var$SetCache.prototype.has = $gORv3;
module.exports = $5bf97fd087bcc0a1$var$SetCache;

});
parcelRegister("kdtOH", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $eb7c268d76906ea4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $eb7c268d76906ea4$var$setCacheAdd(value) {
    this.__data__.set(value, $eb7c268d76906ea4$var$HASH_UNDEFINED);
    return this;
}
module.exports = $eb7c268d76906ea4$var$setCacheAdd;

});

parcelRegister("gORv3", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $c3ead0d15bdb1ea3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $c3ead0d15bdb1ea3$var$setCacheHas;

});


parcelRegister("akGgj", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $785c8e06039eed99$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $785c8e06039eed99$var$arraySome;

});

parcelRegister("2oKLN", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1bf21a2b54b87e0f$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1bf21a2b54b87e0f$var$cacheHas;

});


parcelRegister("2JZFE", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $7OcN3 = parcelRequire("7OcN3");

var $8z8Gw = parcelRequire("8z8Gw");

var $cBpu1 = parcelRequire("cBpu1");

var $4rhSW = parcelRequire("4rhSW");

var $8uHoR = parcelRequire("8uHoR");
/** Used to compose bitmasks for value comparisons. */ var $1fef9f4ce4d836ab$var$COMPARE_PARTIAL_FLAG = 1, $1fef9f4ce4d836ab$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $1fef9f4ce4d836ab$var$boolTag = "[object Boolean]", $1fef9f4ce4d836ab$var$dateTag = "[object Date]", $1fef9f4ce4d836ab$var$errorTag = "[object Error]", $1fef9f4ce4d836ab$var$mapTag = "[object Map]", $1fef9f4ce4d836ab$var$numberTag = "[object Number]", $1fef9f4ce4d836ab$var$regexpTag = "[object RegExp]", $1fef9f4ce4d836ab$var$setTag = "[object Set]", $1fef9f4ce4d836ab$var$stringTag = "[object String]", $1fef9f4ce4d836ab$var$symbolTag = "[object Symbol]";
var $1fef9f4ce4d836ab$var$arrayBufferTag = "[object ArrayBuffer]", $1fef9f4ce4d836ab$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $1fef9f4ce4d836ab$var$symbolProto = $lLnMZ ? $lLnMZ.prototype : undefined, $1fef9f4ce4d836ab$var$symbolValueOf = $1fef9f4ce4d836ab$var$symbolProto ? $1fef9f4ce4d836ab$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1fef9f4ce4d836ab$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $1fef9f4ce4d836ab$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $1fef9f4ce4d836ab$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7OcN3(object), new $7OcN3(other))) return false;
            return true;
        case $1fef9f4ce4d836ab$var$boolTag:
        case $1fef9f4ce4d836ab$var$dateTag:
        case $1fef9f4ce4d836ab$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $8z8Gw(+object, +other);
        case $1fef9f4ce4d836ab$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $1fef9f4ce4d836ab$var$regexpTag:
        case $1fef9f4ce4d836ab$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $1fef9f4ce4d836ab$var$mapTag:
            var convert = $4rhSW;
        case $1fef9f4ce4d836ab$var$setTag:
            var isPartial = bitmask & $1fef9f4ce4d836ab$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $8uHoR);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $1fef9f4ce4d836ab$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $cBpu1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $1fef9f4ce4d836ab$var$symbolTag:
            if ($1fef9f4ce4d836ab$var$symbolValueOf) return $1fef9f4ce4d836ab$var$symbolValueOf.call(object) == $1fef9f4ce4d836ab$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $1fef9f4ce4d836ab$var$equalByTag;

});
parcelRegister("4rhSW", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $33b78eaa4d121274$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $33b78eaa4d121274$var$mapToArray;

});

parcelRegister("8uHoR", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $62f2ca6c96117213$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $62f2ca6c96117213$var$setToArray;

});


parcelRegister("bI9Va", function(module, exports) {

var $cUoIl = parcelRequire("cUoIl");
/** Used to compose bitmasks for value comparisons. */ var $886b7fe1ec262c8f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $886b7fe1ec262c8f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $886b7fe1ec262c8f$var$hasOwnProperty = $886b7fe1ec262c8f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $886b7fe1ec262c8f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $886b7fe1ec262c8f$var$COMPARE_PARTIAL_FLAG, objProps = $cUoIl(object), objLength = objProps.length, othProps = $cUoIl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $886b7fe1ec262c8f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $886b7fe1ec262c8f$var$equalObjects;

});
parcelRegister("cUoIl", function(module, exports) {

var $jWJlU = parcelRequire("jWJlU");

var $hU878 = parcelRequire("hU878");

var $4MkDT = parcelRequire("4MkDT");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $965de2b6e3d9ea9c$var$getAllKeys(object) {
    return $jWJlU(object, $4MkDT, $hU878);
}
module.exports = $965de2b6e3d9ea9c$var$getAllKeys;

});
parcelRegister("jWJlU", function(module, exports) {

var $bhYL1 = parcelRequire("bhYL1");

var $3hHqY = parcelRequire("3hHqY");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e8569d209a3a13e5$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3hHqY(object) ? result : $bhYL1(result, symbolsFunc(object));
}
module.exports = $e8569d209a3a13e5$var$baseGetAllKeys;

});
parcelRegister("bhYL1", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $83806965a49037ae$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $83806965a49037ae$var$arrayPush;

});


parcelRegister("hU878", function(module, exports) {

var $laHY0 = parcelRequire("laHY0");

var $cVsbW = parcelRequire("cVsbW");
/** Used for built-in method references. */ var $d08df5eb5ec69d8f$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d08df5eb5ec69d8f$var$propertyIsEnumerable = $d08df5eb5ec69d8f$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d08df5eb5ec69d8f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d08df5eb5ec69d8f$var$getSymbols = !$d08df5eb5ec69d8f$var$nativeGetSymbols ? $cVsbW : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $laHY0($d08df5eb5ec69d8f$var$nativeGetSymbols(object), function(symbol) {
        return $d08df5eb5ec69d8f$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $d08df5eb5ec69d8f$var$getSymbols;

});
parcelRegister("cVsbW", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $9690ad2cd475fe68$var$stubArray() {
    return [];
}
module.exports = $9690ad2cd475fe68$var$stubArray;

});




parcelRegister("8J52P", function(module, exports) {

var $jopuT = parcelRequire("jopuT");

var $kbZZK = parcelRequire("kbZZK");

var $grM1S = parcelRequire("grM1S");

var $g4dZN = parcelRequire("g4dZN");

var $e0uiv = parcelRequire("e0uiv");

var $jasl7 = parcelRequire("jasl7");

var $kpFqz = parcelRequire("kpFqz");
/** `Object#toString` result references. */ var $65a67076761a57df$var$mapTag = "[object Map]", $65a67076761a57df$var$objectTag = "[object Object]", $65a67076761a57df$var$promiseTag = "[object Promise]", $65a67076761a57df$var$setTag = "[object Set]", $65a67076761a57df$var$weakMapTag = "[object WeakMap]";
var $65a67076761a57df$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $65a67076761a57df$var$dataViewCtorString = $kpFqz($jopuT), $65a67076761a57df$var$mapCtorString = $kpFqz($kbZZK), $65a67076761a57df$var$promiseCtorString = $kpFqz($grM1S), $65a67076761a57df$var$setCtorString = $kpFqz($g4dZN), $65a67076761a57df$var$weakMapCtorString = $kpFqz($e0uiv);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $65a67076761a57df$var$getTag = $jasl7;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($jopuT && $65a67076761a57df$var$getTag(new $jopuT(new ArrayBuffer(1))) != $65a67076761a57df$var$dataViewTag || $kbZZK && $65a67076761a57df$var$getTag(new $kbZZK) != $65a67076761a57df$var$mapTag || $grM1S && $65a67076761a57df$var$getTag($grM1S.resolve()) != $65a67076761a57df$var$promiseTag || $g4dZN && $65a67076761a57df$var$getTag(new $g4dZN) != $65a67076761a57df$var$setTag || $e0uiv && $65a67076761a57df$var$getTag(new $e0uiv) != $65a67076761a57df$var$weakMapTag) $65a67076761a57df$var$getTag = function(value) {
    var result = $jasl7(value), Ctor = result == $65a67076761a57df$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kpFqz(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $65a67076761a57df$var$dataViewCtorString:
            return $65a67076761a57df$var$dataViewTag;
        case $65a67076761a57df$var$mapCtorString:
            return $65a67076761a57df$var$mapTag;
        case $65a67076761a57df$var$promiseCtorString:
            return $65a67076761a57df$var$promiseTag;
        case $65a67076761a57df$var$setCtorString:
            return $65a67076761a57df$var$setTag;
        case $65a67076761a57df$var$weakMapCtorString:
            return $65a67076761a57df$var$weakMapTag;
    }
    return result;
};
module.exports = $65a67076761a57df$var$getTag;

});
parcelRegister("jopuT", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $e1e4096a2f7ca93a$var$DataView = $llv3Q($1sHSN, "DataView");
module.exports = $e1e4096a2f7ca93a$var$DataView;

});

parcelRegister("grM1S", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $bf946c8c43bd10a8$var$Promise = $llv3Q($1sHSN, "Promise");
module.exports = $bf946c8c43bd10a8$var$Promise;

});

parcelRegister("g4dZN", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $bb27e0553eb394e5$var$Set = $llv3Q($1sHSN, "Set");
module.exports = $bb27e0553eb394e5$var$Set;

});

parcelRegister("e0uiv", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $a328913a32963c19$var$WeakMap = $llv3Q($1sHSN, "WeakMap");
module.exports = $a328913a32963c19$var$WeakMap;

});





parcelRegister("aKQmx", function(module, exports) {

var $4hwVJ = parcelRequire("4hwVJ");

var $4MkDT = parcelRequire("4MkDT");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $7d46d1611abe2efd$var$getMatchData(object) {
    var result = $4MkDT(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $4hwVJ(value)
        ];
    }
    return result;
}
module.exports = $7d46d1611abe2efd$var$getMatchData;

});
parcelRegister("4hwVJ", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $31e24b2e633a030c$var$isStrictComparable(value) {
    return value === value && !$ghHeQ(value);
}
module.exports = $31e24b2e633a030c$var$isStrictComparable;

});


parcelRegister("7DyzG", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $58f6feb6c3f4718c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $58f6feb6c3f4718c$var$matchesStrictComparable;

});


parcelRegister("icPnl", function(module, exports) {

var $c2d0B = parcelRequire("c2d0B");

var $8TMnn = parcelRequire("8TMnn");

var $e3hfa = parcelRequire("e3hfa");

var $9Janb = parcelRequire("9Janb");

var $4hwVJ = parcelRequire("4hwVJ");

var $7DyzG = parcelRequire("7DyzG");

var $12Xds = parcelRequire("12Xds");
/** Used to compose bitmasks for value comparisons. */ var $d411331bd61e149b$var$COMPARE_PARTIAL_FLAG = 1, $d411331bd61e149b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d411331bd61e149b$var$baseMatchesProperty(path, srcValue) {
    if ($9Janb(path) && $4hwVJ(srcValue)) return $7DyzG($12Xds(path), srcValue);
    return function(object) {
        var objValue = $8TMnn(object, path);
        return objValue === undefined && objValue === srcValue ? $e3hfa(object, path) : $c2d0B(srcValue, objValue, $d411331bd61e149b$var$COMPARE_PARTIAL_FLAG | $d411331bd61e149b$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d411331bd61e149b$var$baseMatchesProperty;

});
parcelRegister("8TMnn", function(module, exports) {

var $knGp7 = parcelRequire("knGp7");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $67a8fc45e37aaa81$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $knGp7(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $67a8fc45e37aaa81$var$get;

});
parcelRegister("knGp7", function(module, exports) {

var $8yBOT = parcelRequire("8yBOT");

var $12Xds = parcelRequire("12Xds");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ed66d9325016cf13$var$baseGet(object, path) {
    path = $8yBOT(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$12Xds(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $ed66d9325016cf13$var$baseGet;

});
parcelRegister("8yBOT", function(module, exports) {

var $3hHqY = parcelRequire("3hHqY");

var $9Janb = parcelRequire("9Janb");

var $b5fom = parcelRequire("b5fom");

var $bvRke = parcelRequire("bvRke");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $63aed5ec56776805$var$castPath(value, object) {
    if ($3hHqY(value)) return value;
    return $9Janb(value, object) ? [
        value
    ] : $b5fom($bvRke(value));
}
module.exports = $63aed5ec56776805$var$castPath;

});
parcelRegister("9Janb", function(module, exports) {

var $3hHqY = parcelRequire("3hHqY");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used to match property names within property paths. */ var $71505cdc3090c042$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $71505cdc3090c042$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $71505cdc3090c042$var$isKey(value, object) {
    if ($3hHqY(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $jc3qQ(value)) return true;
    return $71505cdc3090c042$var$reIsPlainProp.test(value) || !$71505cdc3090c042$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $71505cdc3090c042$var$isKey;

});
parcelRegister("jc3qQ", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $df91ccd8442d8c6d$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $df91ccd8442d8c6d$var$isSymbol(value) {
    return typeof value == "symbol" || $iK9OP(value) && $jasl7(value) == $df91ccd8442d8c6d$var$symbolTag;
}
module.exports = $df91ccd8442d8c6d$var$isSymbol;

});


parcelRegister("b5fom", function(module, exports) {

var $2YpWy = parcelRequire("2YpWy");
/** Used to match property names within property paths. */ var $021519310294ba0c$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $021519310294ba0c$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $021519310294ba0c$var$stringToPath = $2YpWy(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($021519310294ba0c$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($021519310294ba0c$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $021519310294ba0c$var$stringToPath;

});
parcelRegister("2YpWy", function(module, exports) {

var $bYTRT = parcelRequire("bYTRT");
/** Used as the maximum memoize cache size. */ var $22a54f347b7679c9$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $22a54f347b7679c9$var$memoizeCapped(func) {
    var result = $bYTRT(func, function(key) {
        if (cache.size === $22a54f347b7679c9$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $22a54f347b7679c9$var$memoizeCapped;

});
parcelRegister("bYTRT", function(module, exports) {

var $dtBcs = parcelRequire("dtBcs");
/** Error message constants. */ var $8b90a292802686aa$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $8b90a292802686aa$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($8b90a292802686aa$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($8b90a292802686aa$var$memoize.Cache || $dtBcs);
    return memoized;
}
// Expose `MapCache`.
$8b90a292802686aa$var$memoize.Cache = $dtBcs;
module.exports = $8b90a292802686aa$var$memoize;

});



parcelRegister("bvRke", function(module, exports) {

var $kx9Gl = parcelRequire("kx9Gl");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $861bf4447806334f$var$toString(value) {
    return value == null ? "" : $kx9Gl(value);
}
module.exports = $861bf4447806334f$var$toString;

});
parcelRegister("kx9Gl", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $l4rgt = parcelRequire("l4rgt");

var $3hHqY = parcelRequire("3hHqY");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $ef2e665be0814403$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ef2e665be0814403$var$symbolProto = $lLnMZ ? $lLnMZ.prototype : undefined, $ef2e665be0814403$var$symbolToString = $ef2e665be0814403$var$symbolProto ? $ef2e665be0814403$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ef2e665be0814403$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($3hHqY(value)) // Recursively convert values (susceptible to call stack limits).
    return $l4rgt(value, $ef2e665be0814403$var$baseToString) + "";
    if ($jc3qQ(value)) return $ef2e665be0814403$var$symbolToString ? $ef2e665be0814403$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$ef2e665be0814403$var$INFINITY ? "-0" : result;
}
module.exports = $ef2e665be0814403$var$baseToString;

});
parcelRegister("l4rgt", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f56f1ee0fb8bb3c6$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $f56f1ee0fb8bb3c6$var$arrayMap;

});




parcelRegister("12Xds", function(module, exports) {

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $0c33e96a40b9e8d1$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0c33e96a40b9e8d1$var$toKey(value) {
    if (typeof value == "string" || $jc3qQ(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$0c33e96a40b9e8d1$var$INFINITY ? "-0" : result;
}
module.exports = $0c33e96a40b9e8d1$var$toKey;

});



parcelRegister("e3hfa", function(module, exports) {

var $kGnvI = parcelRequire("kGnvI");

var $fZcU0 = parcelRequire("fZcU0");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a3aeb8b62c81a9af$var$hasIn(object, path) {
    return object != null && $fZcU0(object, path, $kGnvI);
}
module.exports = $a3aeb8b62c81a9af$var$hasIn;

});
parcelRegister("kGnvI", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0e9f799458b3e31$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $f0e9f799458b3e31$var$baseHasIn;

});

parcelRegister("fZcU0", function(module, exports) {

var $8yBOT = parcelRequire("8yBOT");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $kNhZg = parcelRequire("kNhZg");

var $kpNNN = parcelRequire("kpNNN");

var $12Xds = parcelRequire("12Xds");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $ba368fa4f88a3445$var$hasPath(object, path, hasFunc) {
    path = $8yBOT(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $12Xds(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $kpNNN(length) && $kNhZg(key, length) && ($3hHqY(object) || $17tLN(object));
}
module.exports = $ba368fa4f88a3445$var$hasPath;

});



parcelRegister("6luml", function(module, exports) {

var $1tLeC = parcelRequire("1tLeC");

var $bmKii = parcelRequire("bmKii");

var $9Janb = parcelRequire("9Janb");

var $12Xds = parcelRequire("12Xds");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $49ec40f7192cef59$var$property(path) {
    return $9Janb(path) ? $1tLeC($12Xds(path)) : $bmKii(path);
}
module.exports = $49ec40f7192cef59$var$property;

});
parcelRegister("1tLeC", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $113d23b2b588ad64$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $113d23b2b588ad64$var$baseProperty;

});

parcelRegister("bmKii", function(module, exports) {

var $knGp7 = parcelRequire("knGp7");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8465a8d3738c173a$var$basePropertyDeep(path) {
    return function(object) {
        return $knGp7(object, path);
    };
}
module.exports = $8465a8d3738c173a$var$basePropertyDeep;

});




parcelRegister("l4qYG", function(module, exports) {

$parcel$export(module.exports, "useSchedulesContext", function () { return $f56ee5ee94a1f3cd$export$aa97cecf807fd79e; });
$parcel$export(module.exports, "ScreensaverRouter", function () { return $f56ee5ee94a1f3cd$export$f64fa00073e069b2; });
$parcel$export(module.exports, "SchedulesProvider", function () { return $f56ee5ee94a1f3cd$export$82e0b5cdd710a9bb; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $kvR7a = parcelRequire("kvR7a");

var $bIHE3 = parcelRequire("bIHE3");

var $lHglF = parcelRequire("lHglF");

var $38fbh = parcelRequire("38fbh");

var $j0zqp = parcelRequire("j0zqp");

var $49Iup = parcelRequire("49Iup");

var $9zEpM = parcelRequire("9zEpM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $70E8R = parcelRequire("70E8R");

var $cD0nt = parcelRequire("cD0nt");

var $cwDEq = parcelRequire("cwDEq");
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($38fbh))));
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($j0zqp))));
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($49Iup))));
const $f56ee5ee94a1f3cd$var$SchedulesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const { Provider: $f56ee5ee94a1f3cd$var$Provider } = $f56ee5ee94a1f3cd$var$SchedulesContext;
function $f56ee5ee94a1f3cd$var$createCron(schedule) {
    const cron = [
        "*",
        "*",
        "*",
        "*",
        "*"
    ];
    const { weekdays: weekdays, date: date, time: time } = schedule;
    if (time) {
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(time, "HH:mm");
        cron[0] = `${start.get("minute")}`;
        cron[1] = `${start.get("hour")}`;
    }
    if (date) {
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(date, "YYYY-MM-DD");
        cron[2] = `${start.get("date")}`;
        cron[3] = `${start.get("month") + 1}`;
    }
    if (Array.isArray(weekdays) && weekdays.length > 0) cron[4] = weekdays.join(",");
    return cron.join(" ");
}
function $f56ee5ee94a1f3cd$var$scheduleToCron(schedule) {
    const { weekdays: weekdays, startDate: startDate, startTime: startTime, endDate: endDate, endTime: endTime } = schedule;
    const start = $f56ee5ee94a1f3cd$var$createCron({
        weekdays: weekdays,
        date: startDate,
        time: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(startDate, "YYYY-MM-DD").startOf("day").format("HH:mm") : startTime
    });
    const end = $f56ee5ee94a1f3cd$var$createCron({
        weekdays: weekdays,
        date: endDate,
        time: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(endDate, "YYYY-MM-DD").endOf("day").format("HH:mm") : endTime
    });
    return [
        start,
        end
    ];
}
function $f56ee5ee94a1f3cd$var$postMessage(message) {
    if (!window.ReactNativeWebView) return;
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
}
const $f56ee5ee94a1f3cd$export$aa97cecf807fd79e = ()=>(0, $eZVvM.useContext)($f56ee5ee94a1f3cd$var$SchedulesContext);
const $f56ee5ee94a1f3cd$var$RESET_DURATION_MS = 600000;
const $f56ee5ee94a1f3cd$var$INACTIVITY_DURATION_MS = 120000;
const $f56ee5ee94a1f3cd$export$1b4374354aaa3b05 = ()=>{
    const { screensaver: screensaver, paused: paused, setPaused: setPaused } = (0, $eZVvM.useContext)($f56ee5ee94a1f3cd$var$SchedulesContext);
    const visible = screensaver && !paused;
    if (!visible) return null;
     // return ReactDOM.createPortal(
    //   <div
    //     className="position-absolute top-0 bottom-0 right-0 left-0 d-flex h-100 w-100"
    //     style={{ background: "#000" }}
    //     onClick={() => setPaused(true)}
    //   />,
    //   document.getElementById("root")!,
    // );
    return (0, $bhfvP.jsx)("div", {
        className: "position-absolute top-0 bottom-0 right-0 left-0 d-flex h-100 w-100",
        style: {
            background: "#000"
        },
        onClick: ()=>setPaused(true)
    });
};
const $f56ee5ee94a1f3cd$export$f64fa00073e069b2 = ()=>{
    var _a;
    const { screensaver: screensaver, setPaused: setPaused, scheduleScreensaver: scheduleScreensaver } = $f56ee5ee94a1f3cd$export$aa97cecf807fd79e();
    const { data: data } = (0, $cD0nt.default)();
    const { preview: preview } = (0, $cwDEq.useAppConfig)();
    const navigation = (0, $9B9bN.useNavigate)();
    const sleepSchedules = (0, (/*@__PURE__*/$parcel$interopDefault($bIHE3)))((_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.schedules, (item)=>item.type === "sleep" && !item.schedule.disabled);
    (0, (/*@__PURE__*/$parcel$interopDefault($lHglF)))(()=>{
        if (preview) return;
        scheduleScreensaver(sleepSchedules);
    }, [
        sleepSchedules,
        scheduleScreensaver
    ]);
    const onInteractionStateChange = (0, $eZVvM.useCallback)((state)=>{
        if (!screensaver) return;
        if (state === "active") setPaused(true);
        if (state === "idle") setPaused(false);
    }, [
        setPaused,
        screensaver
    ]);
    (0, $70E8R.default)((state)=>{
        if (state === "idle") navigation("/", {
            replace: true
        });
    }, $f56ee5ee94a1f3cd$var$RESET_DURATION_MS);
    (0, $70E8R.default)(onInteractionStateChange, $f56ee5ee94a1f3cd$var$INACTIVITY_DURATION_MS);
    return (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
        children: [
            (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                path: "/",
                element: (0, $bhfvP.jsx)($f56ee5ee94a1f3cd$export$1b4374354aaa3b05, {})
            }),
            (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                path: "*",
                element: (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {})
            })
        ]
    });
};
const $f56ee5ee94a1f3cd$export$82e0b5cdd710a9bb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const [paused, setPaused] = (0, $eZVvM.useState)(false);
    const [screensaver, setScreensaver] = (0, $eZVvM.useState)(false);
    const clearSchedule = (0, $eZVvM.useCallback)(()=>{
        (0, $9zEpM.Cron).scheduledJobs.forEach((job)=>job.stop());
    }, []);
    const scheduleScreensaver = (0, $eZVvM.useCallback)((schedules)=>{
        // console.log("[scheduleScreensaver]: ", schedules);
        clearSchedule();
        let nextScreensaver = false;
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))();
        const dateStart = now.startOf("day").toDate();
        schedules.forEach((item)=>{
            const { schedule: schedule } = item;
            const [startCronTab, endCronTab] = $f56ee5ee94a1f3cd$var$scheduleToCron(schedule);
            const startCron = (0, $9zEpM.Cron)(startCronTab);
            const endCron = (0, $9zEpM.Cron)(endCronTab);
            const start = startCron.nextRun(dateStart);
            if (now.isSame(start, "date") && now.isAfter(start)) nextScreensaver = true;
            startCron.schedule(()=>{
                setScreensaver(true);
            });
            endCron.schedule(()=>{
                setScreensaver(false);
            });
        });
        setScreensaver(nextScreensaver);
    }, [
        clearSchedule
    ]); // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eZVvM.useEffect)(()=>clearSchedule, []);
    (0, $eZVvM.useEffect)(()=>{
        $f56ee5ee94a1f3cd$var$postMessage({
            method: "brightness:change",
            value: screensaver ? 0 : 1
        });
    }, [
        screensaver
    ]);
    const value = (0, $eZVvM.useMemo)(()=>({
            paused: paused,
            setPaused: setPaused,
            screensaver: screensaver,
            scheduleScreensaver: scheduleScreensaver
        }), [
        paused,
        screensaver,
        scheduleScreensaver
    ]);
    return (0, $bhfvP.jsx)($f56ee5ee94a1f3cd$var$Provider, Object.assign({
        value: value
    }, {
        children: children
    }));
});

});
parcelRegister("lHglF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUWBZ = parcelRequire("iUWBZ");

var $fcba4b9d88687877$var$useCustomCompareEffect_1 = $iUWBZ.__importDefault((parcelRequire("99QKe")));

var $fcba4b9d88687877$var$isDeepEqual_1 = $iUWBZ.__importDefault((parcelRequire("aqTHk")));
var $fcba4b9d88687877$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $fcba4b9d88687877$var$useDeepCompareEffect = function(effect, deps) {
    $fcba4b9d88687877$var$useCustomCompareEffect_1.default(effect, deps, $fcba4b9d88687877$var$isDeepEqual_1.default);
};
module.exports.default = $fcba4b9d88687877$var$useDeepCompareEffect;

});

parcelRegister("38fbh", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

});

parcelRegister("j0zqp", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});

parcelRegister("49Iup", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("9zEpM", function(module, exports) {

$parcel$export(module.exports, "Cron", function () { return $6f86bb74ef2ac9fd$export$96f87a56bc1c6511; });
function $6f86bb74ef2ac9fd$var$minitz(y, m, d, h, i, s, tz, throwOnInvalid) {
    return $6f86bb74ef2ac9fd$var$minitz.fromTZ($6f86bb74ef2ac9fd$var$minitz.tp(y, m, d, h, i, s, tz), throwOnInvalid);
}
$6f86bb74ef2ac9fd$var$minitz.fromTZISO = (localTimeStr, tz, throwOnInvalid)=>{
    return $6f86bb74ef2ac9fd$var$minitz.fromTZ($6f86bb74ef2ac9fd$var$parseISOLocal(localTimeStr, tz), throwOnInvalid);
};
$6f86bb74ef2ac9fd$var$minitz.fromTZ = function(tp, throwOnInvalid) {
    const inDate = new Date(Date.UTC(tp.y, tp.m - 1, tp.d, tp.h, tp.i, tp.s)), offset = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, inDate), dateGuess = new Date(inDate.getTime() - offset), dateOffsGuess = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, dateGuess);
    if (dateOffsGuess - offset === 0) return dateGuess;
    else {
        const dateGuess2 = new Date(inDate.getTime() - dateOffsGuess), dateOffsGuess2 = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, dateGuess2);
        if (dateOffsGuess2 - dateOffsGuess === 0) return dateGuess2;
        else if (!throwOnInvalid && dateOffsGuess2 - dateOffsGuess > 0) return dateGuess2;
        else if (!throwOnInvalid) return dateGuess;
        else throw new Error("Invalid date passed to fromTZ()");
    }
};
$6f86bb74ef2ac9fd$var$minitz.toTZ = function(d, tzStr) {
    const localDateString = d.toLocaleString("en-US", {
        timeZone: tzStr
    }).replace(/[\u202f]/, " ");
    const td = new Date(localDateString);
    return {
        y: td.getFullYear(),
        m: td.getMonth() + 1,
        d: td.getDate(),
        h: td.getHours(),
        i: td.getMinutes(),
        s: td.getSeconds(),
        tz: tzStr
    };
};
$6f86bb74ef2ac9fd$var$minitz.tp = (y, m, d, h, i, s, tz)=>{
    return {
        y: y,
        m: m,
        d: d,
        h: h,
        i: i,
        s: s,
        tz: tz
    };
};
function $6f86bb74ef2ac9fd$var$getTimezoneOffset(timeZone, date = new Date) {
    const tz = date.toLocaleString("en-US", {
        timeZone: timeZone,
        timeZoneName: "short"
    }).split(" ").slice(-1)[0];
    const dateString = date.toLocaleString("en-US").replace(/[\u202f]/, " ");
    return Date.parse(`${dateString} GMT`) - Date.parse(`${dateString} ${tz}`);
}
function $6f86bb74ef2ac9fd$var$parseISOLocal(dtStr, tz) {
    const pd = new Date(Date.parse(dtStr));
    if (isNaN(pd)) throw new Error("minitz: Invalid ISO8601 passed to parser.");
    const stringEnd = dtStr.substring(9);
    if (dtStr.includes("Z") || stringEnd.includes("-") || stringEnd.includes("+")) return $6f86bb74ef2ac9fd$var$minitz.tp(pd.getUTCFullYear(), pd.getUTCMonth() + 1, pd.getUTCDate(), pd.getUTCHours(), pd.getUTCMinutes(), pd.getUTCSeconds(), "Etc/UTC");
    else return $6f86bb74ef2ac9fd$var$minitz.tp(pd.getFullYear(), pd.getMonth() + 1, pd.getDate(), pd.getHours(), pd.getMinutes(), pd.getSeconds(), tz);
}
$6f86bb74ef2ac9fd$var$minitz.minitz = $6f86bb74ef2ac9fd$var$minitz;
function $6f86bb74ef2ac9fd$var$CronOptions(options) {
    if (options === void 0) options = {};
    delete options.name;
    options.legacyMode = options.legacyMode === void 0 ? true : options.legacyMode;
    options.paused = options.paused === void 0 ? false : options.paused;
    options.maxRuns = options.maxRuns === void 0 ? Infinity : options.maxRuns;
    options.catch = options.catch === void 0 ? false : options.catch;
    options.interval = options.interval === void 0 ? 0 : parseInt(options.interval, 10);
    options.utcOffset = options.utcOffset === void 0 ? void 0 : parseInt(options.utcOffset, 10);
    options.unref = options.unref === void 0 ? false : options.unref;
    if (options.startAt) options.startAt = new $6f86bb74ef2ac9fd$var$CronDate(options.startAt, options.timezone);
    if (options.stopAt) options.stopAt = new $6f86bb74ef2ac9fd$var$CronDate(options.stopAt, options.timezone);
    if (options.interval !== null) {
        if (isNaN(options.interval)) throw new Error("CronOptions: Supplied value for interval is not a number");
        else if (options.interval < 0) throw new Error("CronOptions: Supplied value for interval can not be negative");
    }
    if (options.utcOffset !== void 0) {
        if (isNaN(options.utcOffset)) throw new Error("CronOptions: Invalid value passed for utcOffset, should be number representing minutes offset from UTC.");
        else if (options.utcOffset < -870 || options.utcOffset > 870) throw new Error("CronOptions: utcOffset out of bounds.");
        if (options.utcOffset !== void 0 && options.timezone) throw new Error("CronOptions: Combining 'utcOffset' with 'timezone' is not allowed.");
    }
    if (options.unref !== true && options.unref !== false) throw new Error("CronOptions: Unref should be either true, false or undefined(false).");
    return options;
}
const $6f86bb74ef2ac9fd$var$DaysOfMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $6f86bb74ef2ac9fd$var$RecursionSteps = [
    [
        "month",
        "year",
        0
    ],
    [
        "day",
        "month",
        -1
    ],
    [
        "hour",
        "day",
        0
    ],
    [
        "minute",
        "hour",
        0
    ],
    [
        "second",
        "minute",
        0
    ]
];
function $6f86bb74ef2ac9fd$var$CronDate(d, tz) {
    this.tz = tz;
    if (d && d instanceof Date) {
        if (!isNaN(d)) this.fromDate(d);
        else throw new TypeError("CronDate: Invalid date passed to CronDate constructor");
    } else if (d === void 0) this.fromDate(new Date);
    else if (d && typeof d === "string") this.fromString(d);
    else if (d instanceof $6f86bb74ef2ac9fd$var$CronDate) this.fromCronDate(d);
    else throw new TypeError("CronDate: Invalid type (" + typeof d + ") passed to CronDate constructor");
}
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromDate = function(inDate) {
    if (this.tz !== void 0) {
        if (typeof this.tz === "number") {
            this.ms = inDate.getUTCMilliseconds();
            this.second = inDate.getUTCSeconds();
            this.minute = inDate.getUTCMinutes() + this.tz;
            this.hour = inDate.getUTCHours();
            this.day = inDate.getUTCDate();
            this.month = inDate.getUTCMonth();
            this.year = inDate.getUTCFullYear();
            this.apply();
        } else {
            const d = $6f86bb74ef2ac9fd$var$minitz.toTZ(inDate, this.tz);
            this.ms = inDate.getMilliseconds();
            this.second = d.s;
            this.minute = d.i;
            this.hour = d.h;
            this.day = d.d;
            this.month = d.m - 1;
            this.year = d.y;
        }
    } else {
        this.ms = inDate.getMilliseconds();
        this.second = inDate.getSeconds();
        this.minute = inDate.getMinutes();
        this.hour = inDate.getHours();
        this.day = inDate.getDate();
        this.month = inDate.getMonth();
        this.year = inDate.getFullYear();
    }
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromCronDate = function(d) {
    this.tz = d.tz;
    this.year = d.year;
    this.month = d.month;
    this.day = d.day;
    this.hour = d.hour;
    this.minute = d.minute;
    this.second = d.second;
    this.ms = d.ms;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.apply = function() {
    if (this.month > 11 || this.day > $6f86bb74ef2ac9fd$var$DaysOfMonth[this.month] || this.hour > 59 || this.minute > 59 || this.second > 59 || this.hour < 0 || this.minute < 0 || this.second < 0) {
        const d = new Date(Date.UTC(this.year, this.month, this.day, this.hour, this.minute, this.second, this.ms));
        this.ms = d.getUTCMilliseconds();
        this.second = d.getUTCSeconds();
        this.minute = d.getUTCMinutes();
        this.hour = d.getUTCHours();
        this.day = d.getUTCDate();
        this.month = d.getUTCMonth();
        this.year = d.getUTCFullYear();
        return true;
    } else return false;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromString = function(str) {
    return this.fromDate($6f86bb74ef2ac9fd$var$minitz.fromTZISO(str, this.tz));
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.findNext = function(options, target, pattern, offset) {
    const originalTarget = this[target];
    let lastDayOfMonth;
    if (pattern.lastDayOfMonth || pattern.lastWeekdayOfMonth) {
        if (this.month !== 1) lastDayOfMonth = $6f86bb74ef2ac9fd$var$DaysOfMonth[this.month];
        else lastDayOfMonth = new Date(Date.UTC(this.year, this.month + 1, 0, 0, 0, 0, 0)).getUTCDate();
    }
    const fDomWeekDay = !pattern.starDOW && target == "day" ? new Date(Date.UTC(this.year, this.month, 1, 0, 0, 0, 0)).getUTCDay() : undefined;
    for(let i = this[target] + offset; i < pattern[target].length; i++){
        let match = pattern[target][i];
        if (target === "day" && pattern.lastDayOfMonth && i - offset == lastDayOfMonth) match = true;
        if (target === "day" && !pattern.starDOW) {
            let dowMatch = pattern.dayOfWeek[(fDomWeekDay + (i - offset - 1)) % 7];
            if (dowMatch && pattern.lastWeekdayOfMonth) dowMatch = dowMatch && i - offset > lastDayOfMonth - 7;
            if (options.legacyMode && !pattern.starDOM) match = match || dowMatch;
            else match = match && dowMatch;
        }
        if (match) {
            this[target] = i - offset;
            return originalTarget !== this[target] ? 2 : 1;
        }
    }
    return 3;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.recurse = function(pattern, options, doing) {
    const res = this.findNext(options, $6f86bb74ef2ac9fd$var$RecursionSteps[doing][0], pattern, $6f86bb74ef2ac9fd$var$RecursionSteps[doing][2]);
    if (res > 1) {
        let resetLevel = doing + 1;
        while(resetLevel < $6f86bb74ef2ac9fd$var$RecursionSteps.length){
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[resetLevel][0]] = -$6f86bb74ef2ac9fd$var$RecursionSteps[resetLevel][2];
            resetLevel++;
        }
        if (res === 3) {
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[doing][1]]++;
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[doing][0]] = -$6f86bb74ef2ac9fd$var$RecursionSteps[doing][2];
            this.apply();
            return this.recurse(pattern, options, 0);
        } else if (this.apply()) return this.recurse(pattern, options, doing - 1);
    }
    doing += 1;
    if (doing >= $6f86bb74ef2ac9fd$var$RecursionSteps.length) return this;
    else if (this.year >= 3e3) return null;
    else return this.recurse(pattern, options, doing);
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.increment = function(pattern, options, hasPreviousRun) {
    this.second += options.interval > 1 && hasPreviousRun ? options.interval : 1;
    this.ms = 0;
    this.apply();
    return this.recurse(pattern, options, 0);
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.getDate = function(internal) {
    if (internal || this.tz === void 0) return new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.ms);
    else {
        if (typeof this.tz === "number") return new Date(Date.UTC(this.year, this.month, this.day, this.hour, this.minute - this.tz, this.second, this.ms));
        else return $6f86bb74ef2ac9fd$var$minitz(this.year, this.month + 1, this.day, this.hour, this.minute, this.second, this.tz);
    }
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.getTime = function() {
    return this.getDate().getTime();
};
function $6f86bb74ef2ac9fd$var$CronPattern(pattern, timezone) {
    this.pattern = pattern;
    this.timezone = timezone;
    this.second = Array(60).fill(0);
    this.minute = Array(60).fill(0);
    this.hour = Array(24).fill(0);
    this.day = Array(31).fill(0);
    this.month = Array(12).fill(0);
    this.dayOfWeek = Array(8).fill(0);
    this.lastDayOfMonth = false;
    this.lastWeekdayOfMonth = false;
    this.starDOM = false;
    this.starDOW = false;
    this.parse();
}
$6f86bb74ef2ac9fd$var$CronPattern.prototype.parse = function() {
    if (!(typeof this.pattern === "string" || this.pattern.constructor === String)) throw new TypeError("CronPattern: Pattern has to be of type string.");
    if (this.pattern.indexOf("@") >= 0) this.pattern = this.handleNicknames(this.pattern).trim();
    const parts = this.pattern.replace(/\s+/g, " ").split(" ");
    if (parts.length < 5 || parts.length > 6) throw new TypeError("CronPattern: invalid configuration format ('" + this.pattern + "'), exacly five or six space separated parts required.");
    if (parts.length === 5) parts.unshift("0");
    if (parts[3].indexOf("L") >= 0) {
        parts[3] = parts[3].replace("L", "");
        this.lastDayOfMonth = true;
    }
    if (parts[5].indexOf("L") >= 0) {
        parts[5] = parts[5].replace("L", "");
        this.lastWeekdayOfMonth = true;
    }
    if (parts[3] == "*") this.starDOM = true;
    if (parts[4].length >= 3) parts[4] = this.replaceAlphaMonths(parts[4]);
    if (parts[5].length >= 3) parts[5] = this.replaceAlphaDays(parts[5]);
    if (parts[5] == "*") this.starDOW = true;
    if (this.pattern.indexOf("?") >= 0) {
        const initDate = new $6f86bb74ef2ac9fd$var$CronDate(new Date, this.timezone).getDate(true);
        parts[0] = parts[0].replace("?", initDate.getSeconds());
        parts[1] = parts[1].replace("?", initDate.getMinutes());
        parts[2] = parts[2].replace("?", initDate.getHours());
        if (!this.starDOM) parts[3] = parts[3].replace("?", initDate.getDate());
        parts[4] = parts[4].replace("?", initDate.getMonth() + 1);
        if (!this.starDOW) parts[5] = parts[5].replace("?", initDate.getDay());
    }
    this.throwAtIllegalCharacters(parts);
    this.partToArray("second", parts[0], 0);
    this.partToArray("minute", parts[1], 0);
    this.partToArray("hour", parts[2], 0);
    this.partToArray("day", parts[3], -1);
    this.partToArray("month", parts[4], -1);
    this.partToArray("dayOfWeek", parts[5], 0);
    if (this.dayOfWeek[7]) this.dayOfWeek[0] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.partToArray = function(type, conf, valueIndexOffset) {
    const arr = this[type];
    if (conf === "*") return arr.fill(1);
    const split = conf.split(",");
    if (split.length > 1) for(let i = 0; i < split.length; i++)this.partToArray(type, split[i], valueIndexOffset);
    else if (conf.indexOf("-") !== -1 && conf.indexOf("/") !== -1) this.handleRangeWithStepping(conf, type, valueIndexOffset);
    else if (conf.indexOf("-") !== -1) this.handleRange(conf, type, valueIndexOffset);
    else if (conf.indexOf("/") !== -1) this.handleStepping(conf, type, valueIndexOffset);
    else if (conf !== "") this.handleNumber(conf, type, valueIndexOffset);
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.throwAtIllegalCharacters = function(parts) {
    const reValidCron = /[^/*0-9,-]+/;
    for(let i = 0; i < parts.length; i++){
        if (reValidCron.test(parts[i])) throw new TypeError("CronPattern: configuration entry " + i + " (" + parts[i] + ") contains illegal characters.");
    }
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleNumber = function(conf, type, valueIndexOffset) {
    const i = parseInt(conf, 10) + valueIndexOffset;
    if (isNaN(i)) throw new TypeError("CronPattern: " + type + " is not a number: '" + conf + "'");
    if (i < 0 || i >= this[type].length) throw new TypeError("CronPattern: " + type + " value out of range: '" + conf + "'");
    this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleRangeWithStepping = function(conf, type, valueIndexOffset) {
    const matches = conf.match(/^(\d+)-(\d+)\/(\d+)$/);
    if (matches === null) throw new TypeError("CronPattern: Syntax error, illegal range with stepping: '" + conf + "'");
    let [, lower, upper, steps] = matches;
    lower = parseInt(lower, 10) + valueIndexOffset;
    upper = parseInt(upper, 10) + valueIndexOffset;
    steps = parseInt(steps, 10);
    if (isNaN(lower)) throw new TypeError("CronPattern: Syntax error, illegal lower range (NaN)");
    if (isNaN(upper)) throw new TypeError("CronPattern: Syntax error, illegal upper range (NaN)");
    if (isNaN(steps)) throw new TypeError("CronPattern: Syntax error, illegal stepping: (NaN)");
    if (steps === 0) throw new TypeError("CronPattern: Syntax error, illegal stepping: 0");
    if (steps > this[type].length) throw new TypeError("CronPattern: Syntax error, steps cannot be greater than maximum value of part (" + this[type].length + ")");
    if (lower < 0 || upper >= this[type].length) throw new TypeError("CronPattern: Value out of range: '" + conf + "'");
    if (lower > upper) throw new TypeError("CronPattern: From value is larger than to value: '" + conf + "'");
    for(let i = lower; i <= upper; i += steps)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleRange = function(conf, type, valueIndexOffset) {
    const split = conf.split("-");
    if (split.length !== 2) throw new TypeError("CronPattern: Syntax error, illegal range: '" + conf + "'");
    const lower = parseInt(split[0], 10) + valueIndexOffset, upper = parseInt(split[1], 10) + valueIndexOffset;
    if (isNaN(lower)) throw new TypeError("CronPattern: Syntax error, illegal lower range (NaN)");
    else if (isNaN(upper)) throw new TypeError("CronPattern: Syntax error, illegal upper range (NaN)");
    if (lower < 0 || upper >= this[type].length) throw new TypeError("CronPattern: Value out of range: '" + conf + "'");
    if (lower > upper) throw new TypeError("CronPattern: From value is larger than to value: '" + conf + "'");
    for(let i = lower; i <= upper; i++)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleStepping = function(conf, type) {
    const split = conf.split("/");
    if (split.length !== 2) throw new TypeError("CronPattern: Syntax error, illegal stepping: '" + conf + "'");
    let start = 0;
    if (split[0] !== "*") start = parseInt(split[0], 10);
    const steps = parseInt(split[1], 10);
    if (isNaN(steps)) throw new TypeError("CronPattern: Syntax error, illegal stepping: (NaN)");
    if (steps === 0) throw new TypeError("CronPattern: Syntax error, illegal stepping: 0");
    if (steps > this[type].length) throw new TypeError("CronPattern: Syntax error, max steps for part is (" + this[type].length + ")");
    for(let i = start; i < this[type].length; i += steps)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.replaceAlphaDays = function(conf) {
    return conf.replace(/-sun/gi, "-7").replace(/sun/gi, "0").replace(/mon/gi, "1").replace(/tue/gi, "2").replace(/wed/gi, "3").replace(/thu/gi, "4").replace(/fri/gi, "5").replace(/sat/gi, "6");
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.replaceAlphaMonths = function(conf) {
    return conf.replace(/jan/gi, "1").replace(/feb/gi, "2").replace(/mar/gi, "3").replace(/apr/gi, "4").replace(/may/gi, "5").replace(/jun/gi, "6").replace(/jul/gi, "7").replace(/aug/gi, "8").replace(/sep/gi, "9").replace(/oct/gi, "10").replace(/nov/gi, "11").replace(/dec/gi, "12");
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleNicknames = function(pattern) {
    const cleanPattern = pattern.trim().toLowerCase();
    if (cleanPattern === "@yearly" || cleanPattern === "@annually") return "0 0 1 1 *";
    else if (cleanPattern === "@monthly") return "0 0 1 * *";
    else if (cleanPattern === "@weekly") return "0 0 * * 0";
    else if (cleanPattern === "@daily") return "0 0 * * *";
    else if (cleanPattern === "@hourly") return "0 * * * *";
    else return pattern;
};
function $6f86bb74ef2ac9fd$var$isFunction(v) {
    return Object.prototype.toString.call(v) === "[object Function]" || "function" === typeof v || v instanceof Function;
}
function $6f86bb74ef2ac9fd$var$unrefTimer(timer) {
    if (typeof Deno !== "undefined" && typeof Deno.unrefTimer !== "undefined") Deno.unrefTimer(timer);
    else if (timer && typeof timer.unref !== "undefined") timer.unref();
}
const $6f86bb74ef2ac9fd$var$maxDelay = 30000;
const $6f86bb74ef2ac9fd$export$1dd82c9021421bb2 = [];
function $6f86bb74ef2ac9fd$export$96f87a56bc1c6511(pattern, fnOrOptions1, fnOrOptions2) {
    if (!(this instanceof $6f86bb74ef2ac9fd$export$96f87a56bc1c6511)) return new $6f86bb74ef2ac9fd$export$96f87a56bc1c6511(pattern, fnOrOptions1, fnOrOptions2);
    let options, func;
    if ($6f86bb74ef2ac9fd$var$isFunction(fnOrOptions1)) func = fnOrOptions1;
    else if (typeof fnOrOptions1 === "object") options = fnOrOptions1;
    else if (fnOrOptions1 !== void 0) throw new Error("Cron: Invalid argument passed for optionsIn. Should be one of function, or object (options).");
    if ($6f86bb74ef2ac9fd$var$isFunction(fnOrOptions2)) func = fnOrOptions2;
    else if (typeof fnOrOptions2 === "object") options = fnOrOptions2;
    else if (fnOrOptions2 !== void 0) throw new Error("Cron: Invalid argument passed for funcIn. Should be one of function, or object (options).");
    this.name = options ? options.name : void 0;
    this.options = $6f86bb74ef2ac9fd$var$CronOptions(options);
    this._states = {
        kill: false,
        blocking: false,
        previousRun: void 0,
        currentRun: void 0,
        once: void 0,
        currentTimeout: void 0,
        maxRuns: options ? options.maxRuns : void 0,
        paused: options ? options.paused : false,
        pattern: void 0
    };
    if (pattern && (pattern instanceof Date || typeof pattern === "string" && pattern.indexOf(":") > 0)) this._states.once = new $6f86bb74ef2ac9fd$var$CronDate(pattern, this.options.timezone || this.options.utcOffset);
    else this._states.pattern = new $6f86bb74ef2ac9fd$var$CronPattern(pattern, this.options.timezone);
    if (this.name) {
        const existing = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.find((j)=>j.name === this.name);
        if (existing) throw new Error("Cron: Tried to initialize new named job '" + this.name + "', but name already taken.");
        else $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.push(this);
    }
    if (func !== void 0) {
        this.fn = func;
        this.schedule();
    }
    return this;
}
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.nextRun = function(prev) {
    const next = this._next(prev);
    return next ? next.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.nextRuns = function(n, previous) {
    if (n > this._states.maxRuns) n = this._states.maxRuns;
    const enumeration = [];
    let prev = previous || this._states.currentRun;
    while(n-- && (prev = this.nextRun(prev)))enumeration.push(prev);
    return enumeration;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.getPattern = function() {
    return this._states.pattern ? this._states.pattern.pattern : void 0;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isRunning = function() {
    const msLeft = this.msToNext(this._states.currentRun);
    const isRunning = !this._states.paused;
    const isScheduled = this.fn !== void 0;
    const notIsKilled = !this._states.kill;
    return isRunning && isScheduled && notIsKilled && msLeft !== null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isStopped = function() {
    return this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isBusy = function() {
    return this._states.blocking;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.currentRun = function() {
    return this._states.currentRun ? this._states.currentRun.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.previousRun = function() {
    return this._states.previousRun ? this._states.previousRun.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.msToNext = function(prev) {
    const next = this._next(prev);
    prev = new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset);
    if (next) return next.getTime(true) - prev.getTime(true);
    else return null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.stop = function() {
    this._states.kill = true;
    if (this._states.currentTimeout) clearTimeout(this._states.currentTimeout);
    const jobIndex = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.indexOf(this);
    if (jobIndex >= 0) $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.splice(jobIndex, 1);
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.pause = function() {
    this._states.paused = true;
    return !this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.resume = function() {
    this._states.paused = false;
    return !this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.schedule = function(func, partial) {
    if (func && this.fn) throw new Error("Cron: It is not allowed to schedule two functions using the same Croner instance.");
    else if (func) this.fn = func;
    let waitMs = this.msToNext(partial ? partial : this._states.currentRun);
    const target = this.nextRun(partial ? partial : this._states.currentRun);
    if (waitMs === null || target === null) return this;
    if (waitMs > $6f86bb74ef2ac9fd$var$maxDelay) waitMs = $6f86bb74ef2ac9fd$var$maxDelay;
    this._states.currentTimeout = setTimeout(()=>this._checkTrigger(target), waitMs);
    if (this._states.currentTimeout && this.options.unref) $6f86bb74ef2ac9fd$var$unrefTimer(this._states.currentTimeout);
    return this;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._trigger = async function(initiationDate) {
    this._states.blocking = true;
    this._states.currentRun = new $6f86bb74ef2ac9fd$var$CronDate(void 0, this.options.timezone || this.options.utcOffset);
    if (this.options.catch) try {
        await this.fn(this, this.options.context);
    } catch (_e) {
        if ($6f86bb74ef2ac9fd$var$isFunction(this.options.catch)) this.options.catch(_e, this);
    }
    else await this.fn(this, this.options.context);
    this._states.previousRun = new $6f86bb74ef2ac9fd$var$CronDate(initiationDate, this.options.timezone || this.options.utcOffset);
    this._states.blocking = false;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.trigger = async function() {
    await this._trigger();
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._checkTrigger = function(target) {
    const now = new Date, shouldRun = !this._states.paused && now.getTime() >= target, isBlocked = this._states.blocking && this.options.protect;
    if (shouldRun && !isBlocked) {
        this._states.maxRuns--;
        this._trigger();
    } else if (shouldRun && isBlocked && $6f86bb74ef2ac9fd$var$isFunction(this.options.protect)) setTimeout(()=>this.options.protect(this), 0);
    this.schedule(undefined, now);
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._next = function(prev) {
    const hasPreviousRun = prev || this._states.currentRun ? true : false;
    prev = new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset);
    if (this.options.startAt && prev && prev.getTime() < this.options.startAt.getTime()) prev = this.options.startAt;
    const nextRun = this._states.once || new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset).increment(this._states.pattern, this.options, hasPreviousRun);
    if (this._states.once && this._states.once.getTime() <= prev.getTime()) return null;
    else if (nextRun === null || this._states.maxRuns <= 0 || this._states.kill || this.options.stopAt && nextRun.getTime() >= this.options.stopAt.getTime()) return null;
    else return nextRun;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.Cron = $6f86bb74ef2ac9fd$export$96f87a56bc1c6511;
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.scheduledJobs = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2;

});

parcelRegister("70E8R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51a7abd9cc2d10e7$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $k55lg = parcelRequire("k55lg");

var $8xLkR = parcelRequire("8xLkR");
const $51a7abd9cc2d10e7$var$useInteraction = (callback, timeout = 180000)=>{
    const idle = (0, (/*@__PURE__*/$parcel$interopDefault($k55lg)))(timeout, false);
    const prevIdle = (0, (/*@__PURE__*/$parcel$interopDefault($8xLkR)))(idle);
    (0, $eZVvM.useEffect)(()=>{
        if (!prevIdle && idle) callback("idle");
        if (prevIdle && !idle) callback("active");
    }, [
        idle,
        prevIdle,
        callback
    ]);
};
var $51a7abd9cc2d10e7$export$2e2bcd8739ae039 = $51a7abd9cc2d10e7$var$useInteraction;

});




parcelRegister("219y6", function(module, exports) {

$parcel$export(module.exports, "useOfflineContext", function () { return $178315026555ecf2$export$a2fa15de55d14150; });
$parcel$export(module.exports, "default", function () { return $178315026555ecf2$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $6lhov = parcelRequire("6lhov");

var $eZVvM = parcelRequire("eZVvM");

var $1PAIo = parcelRequire("1PAIo");

var $dsl2s = parcelRequire("dsl2s");
var $178315026555ecf2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $178315026555ecf2$export$46814dd5412c611c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $178315026555ecf2$export$a2fa15de55d14150 = ()=>(0, $eZVvM.useContext)($178315026555ecf2$export$46814dd5412c611c);
const $178315026555ecf2$export$5256df5912efd519 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const [online, setOnline] = (0, $eZVvM.useState)(true);
    const [locationHref, setLocationHref] = (0, $eZVvM.useState)();
    (0, $6lhov.onlineManager).setOnline(true);
    (0, $eZVvM.useEffect)(()=>{
        // service worker needs to be registered on a path
        // with a trailing slash because of scope issues
        // https://github.com/w3c/ServiceWorker/issues/1272
        //
        // This is a workaround to redirect the user to the
        // correct path for sw registration
        if (window.location.pathname.endsWith("/")) {
            (0, $dsl2s.registerServiceWorker)();
            return;
        }
        window.location.href = window.location.pathname + "/";
    }, []);
    const handleBeforeUnload = (0, $eZVvM.useCallback)((e)=>{
        // on beforeunload, check if the location is valid
        // (ends with a trailing slash and is not the root)
        // if not, redirect to the correct location saved in
        // locationHref otherwise redirect to the
        // [referer](https://developer.mozilla.org/en-US/docs/Web/API/Document/referrer)
        // (in case of manual refresh, referer is the url
        // that was in the address bar before the refresh)
        const locationValid = window.location.pathname.length > 2 && window.location.pathname.endsWith("/");
        if (locationValid) return;
        if (locationHref) window.location.href = window.location.pathname + "/";
        window.location.href = document.referrer + (document.referrer.endsWith("/") ? "" : "/");
    }, []);
    (0, $1PAIo.useBeforeUnload)(handleBeforeUnload);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("online", checkOnline);
        window.addEventListener("offline", checkOnline);
        checkOnline();
        return ()=>{
            window.removeEventListener("online", checkOnline);
            window.removeEventListener("offline", checkOnline);
        };
    }, []);
    const checkOnline = (0, $eZVvM.useCallback)(()=>$178315026555ecf2$var$__awaiter(void 0, void 0, void 0, function*() {
            setLocationHref(()=>{
                var _a;
                return (_a = window.location) === null || _a === void 0 ? void 0 : _a.href;
            });
            try {
                const response = yield fetch("https://api.digitalreception.app/favicon.ico");
                if (!response.ok || response.status === 503) throw new Error("Network not available");
                setOnline(()=>true);
            } catch (error) {
                setOnline(()=>false);
            }
        }), []);
    const storeData = (0, $eZVvM.useCallback)((key, data)=>$178315026555ecf2$var$__awaiter(void 0, void 0, void 0, function*() {
            if (!("caches" in window)) return new Promise((_, reject)=>{
                reject();
            });
            const cache = yield caches.open(undefined);
            yield cache.put(key, new Response(JSON.stringify(data)));
        }), []);
    const getData = (0, $eZVvM.useCallback)((key)=>$178315026555ecf2$var$__awaiter(void 0, void 0, void 0, function*() {
            if (!("caches" in window)) return new Promise((_, reject)=>{
                reject();
            });
            const cache = yield caches.open(undefined);
            const cacheData = yield cache.match(key);
            const data = yield cacheData === null || cacheData === void 0 ? void 0 : cacheData.text();
            if (data) return JSON.parse(data);
            return undefined;
        }), []);
    const value = (0, $eZVvM.useMemo)(()=>({
            online: online,
            storeData: storeData,
            getData: getData,
            setOnline: setOnline,
            checkOnline: checkOnline
        }), [
        online,
        storeData
    ]);
    return (0, $bhfvP.jsx)($178315026555ecf2$export$46814dd5412c611c.Provider, Object.assign({
        value: value
    }, {
        children: children
    }));
});
var $178315026555ecf2$export$2e2bcd8739ae039 = $178315026555ecf2$export$5256df5912efd519;

});
parcelRegister("dsl2s", function(module, exports) {

$parcel$export(module.exports, "registerServiceWorker", function () { return $9cbe35b906be240b$export$c6245babf0c60892; });
var $9cbe35b906be240b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $9cbe35b906be240b$var$serviceWorkerPath = new URL((parcelRequire("dx1bg")));
const $9cbe35b906be240b$var$serviceWorkerFilename = ($9cbe35b906be240b$var$serviceWorkerPath + "").split("/").pop();
const $9cbe35b906be240b$var$pathname = window.location.pathname;
const $9cbe35b906be240b$var$isDev = false;
const $9cbe35b906be240b$var$isActivationPage = $9cbe35b906be240b$var$pathname.includes("/activation");
const $9cbe35b906be240b$var$fullPath = $9cbe35b906be240b$var$pathname[$9cbe35b906be240b$var$pathname.length - 1] === "/" ? $9cbe35b906be240b$var$pathname.slice(0, $9cbe35b906be240b$var$pathname.length - 1) : $9cbe35b906be240b$var$pathname;
const $9cbe35b906be240b$var$isSwInstalled = localStorage.getItem(`sw-installed-${undefined}`) === "true";
function $9cbe35b906be240b$export$c6245babf0c60892() {
    return $9cbe35b906be240b$var$__awaiter(this, void 0, void 0, function*() {
        if (!("serviceWorker" in navigator) || window.top !== window.self || !$9cbe35b906be240b$var$serviceWorkerFilename || navigator.serviceWorker.controller || $9cbe35b906be240b$var$isDev || $9cbe35b906be240b$var$isActivationPage) // don't instantiate service worker:
        // [1] if service worker isn't supported
        // [2] in iframes
        // [3] if there is no service worker file
        // [4] if there is already a sw instance
        // [5] in development mode
        return;
        try {
            const registration = yield navigator.serviceWorker.register($9cbe35b906be240b$var$fullPath + "/" + $9cbe35b906be240b$var$serviceWorkerFilename, {
                // type: "module",
                scope: $9cbe35b906be240b$var$fullPath + "/"
            });
            setTimeout(()=>{
                if (registration.active && $9cbe35b906be240b$var$isSwInstalled) return;
                // reload the page if this is the first time the service worker is installed
                // record in localStorage to prevent multiple reloads
                localStorage.setItem(`sw-installed-${undefined}`, "true");
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error(`Registration failed with ${error}`);
        }
    });
}

});
parcelRegister("dx1bg", function(module, exports) {

module.exports = (parcelRequire("eDQ3p")).getBundleURL("eOfb6") + "sw.fb1d0028.js";

});






parcelRegister("3pTPw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27cf039483557762$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $e8m2I = parcelRequire("e8m2I");

var $16yak = parcelRequire("16yak");
const $27cf039483557762$var$StyledButton = (0, $e8m2I.default)("button")(({ theme: theme })=>({
        color: theme.palette.primary.main,
        path: {
            fill: theme.palette.primary.main
        }
    }));
const $27cf039483557762$var$BackButton = ({ to: to })=>{
    const navigate = (0, $9B9bN.useNavigate)(); // const { getPageData } = useContext(TrackingContext);
    // const { trackEvent } = useEventTracking();
    return (0, $bhfvP.jsx)($27cf039483557762$var$StyledButton, Object.assign({
        className: "back-button",
        onClick: ()=>{
            // const pageData = getPageData();
            // if (pageData) {
            // trackEvent({ type: "back_button_click", value: pageData.page });
            // }
            navigate(to);
        }
    }, {
        children: (0, $bhfvP.jsx)((0, $16yak.default), {
            width: "7rem"
        })
    }));
};
var $27cf039483557762$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($27cf039483557762$var$BackButton);

});
parcelRegister("16yak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cc332d9916a9a29$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $9cc332d9916a9a29$var$SvgBackArrow = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('681e1681150eeb90')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "m15 15.875-3.88-3.88L15 8.115a.996.996 0 1 0-1.41-1.41L9 11.295a.996.996 0 0 0 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42Z",
                fill: "#000"
            })
        })
    });
var $9cc332d9916a9a29$export$2e2bcd8739ae039 = $9cc332d9916a9a29$var$SvgBackArrow;

});


parcelRegister("ezhXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9b2435dfd882e2f$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $ljukC = parcelRequire("ljukC");

var $34EAI = parcelRequire("34EAI");

var $e8m2I = parcelRequire("e8m2I");

var $4yVoh = parcelRequire("4yVoh");

var $53K4z = parcelRequire("53K4z");

var $cD0nt = parcelRequire("cD0nt");
const $a9b2435dfd882e2f$var$transitionLogo = {
    initial: {
        opacity: 1
    },
    animate: {
        opacity: 0,
        top: -400,
        visibility: "hidden",
        transition: {
            duration: 0.5,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        },
        transitionEnd: {
            top: "47.5%"
        }
    },
    exit: {
        opacity: 1,
        visibility: "visible",
        top: "50%",
        transition: {
            duration: 0.4,
            delay: 0.2,
            ease: [
                0.33,
                1,
                0.68,
                1
            ]
        }
    }
};
const $a9b2435dfd882e2f$var$transitionCurve = (initialPath, targetPath)=>{
    return {
        initial: {
            d: initialPath
        },
        animate: {
            d: targetPath,
            transition: {
                duration: 0.5,
                delay: 0.3,
                ease: [
                    0.76,
                    0,
                    0.24,
                    1
                ]
            }
        },
        exit: {
            d: initialPath,
            transition: {
                duration: 0.2,
                ease: [
                    0.76,
                    0,
                    0.24,
                    1
                ]
            }
        }
    };
};
const $a9b2435dfd882e2f$var$transitionTranslate = {
    initial: {
        top: "-300px"
    },
    animate: {
        top: "-100vh",
        transition: {
            duration: 0.55,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        },
        transitionEnd: {
            top: "100vh"
        }
    },
    exit: {
        top: "-300px",
        transition: {
            duration: 0.2,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        }
    }
};
const $a9b2435dfd882e2f$var$MUITransitionSvg = (0, $e8m2I.default)((0, $ljukC.motion).svg)(({ theme: theme })=>({
        path: {
            fill: theme.palette.primary.main
        }
    }));
const $a9b2435dfd882e2f$var$SVG = ({ height: height, width: width })=>{
    const initialPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height + 300}
        Q${width / 2} ${height + 600} 0 ${height + 300}
        L0 0
      `;
    const targetPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height}
        Q${width / 2} ${height} 0 ${height}
        L0 0
    `;
    return (0, $bhfvP.jsx)($a9b2435dfd882e2f$var$MUITransitionSvg, Object.assign({}, (0, $4yVoh.anim)($a9b2435dfd882e2f$var$transitionTranslate), {
        className: "curve__svg"
    }, {
        children: (0, $bhfvP.jsx)((0, $ljukC.motion).path, Object.assign({}, (0, $4yVoh.anim)($a9b2435dfd882e2f$var$transitionCurve(initialPath, targetPath))))
    }));
};
const $a9b2435dfd882e2f$var$Curve = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { width: width, height: height } = (0, $34EAI.default)();
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (!animationsEnabled) return children;
    return (0, $bhfvP.jsxs)("div", Object.assign({
        className: "curve"
    }, {
        children: [
            (0, $bhfvP.jsx)("div", {
                style: {
                    opacity: !!width ? 1 : 0
                },
                className: "curve__background"
            }),
            (0, $bhfvP.jsx)((0, $ljukC.motion).div // @ts-ignore
            , Object.assign({}, (0, $4yVoh.anim)($a9b2435dfd882e2f$var$transitionLogo), {
                className: "curve__logo"
            }, {
                children: (0, $bhfvP.jsx)((0, $53K4z.default), {
                    width: "30rem"
                })
            })),
            !!width && (0, $bhfvP.jsx)($a9b2435dfd882e2f$var$SVG, {
                width: width,
                height: height
            }),
            children
        ]
    }));
});
var $a9b2435dfd882e2f$export$2e2bcd8739ae039 = $a9b2435dfd882e2f$var$Curve;

});
parcelRegister("34EAI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23d13b6059d874f6$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $cJdSx = parcelRequire("cJdSx");

var $1qfhS = parcelRequire("1qfhS");
var $23d13b6059d874f6$var$useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, $cJdSx.default)({
        width: (0, $1qfhS.isBrowser) ? window.innerWidth : initialWidth,
        height: (0, $1qfhS.isBrowser) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, $eZVvM.useEffect)(function() {
        if (0, $1qfhS.isBrowser) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            (0, $1qfhS.on)(window, "resize", handler_1);
            return function() {
                (0, $1qfhS.off)(window, "resize", handler_1);
            };
        }
    }, []);
    return state;
};
var $23d13b6059d874f6$export$2e2bcd8739ae039 = $23d13b6059d874f6$var$useWindowSize;

});
parcelRegister("cJdSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94447409307c79fa$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $logKa = parcelRequire("logKa");
var $94447409307c79fa$var$useRafState = function(initialState) {
    var frame = (0, $eZVvM.useRef)(0);
    var _a = (0, $eZVvM.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $eZVvM.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $logKa.default)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $94447409307c79fa$export$2e2bcd8739ae039 = $94447409307c79fa$var$useRafState;

});
parcelRegister("logKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f928d3cc22d91535$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $758JZ = parcelRequire("758JZ");
var $f928d3cc22d91535$var$useUnmount = function(fn) {
    var fnRef = (0, $eZVvM.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $758JZ.default)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $f928d3cc22d91535$export$2e2bcd8739ae039 = $f928d3cc22d91535$var$useUnmount;

});
parcelRegister("758JZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527fc7c8a06c512f$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");
var $527fc7c8a06c512f$var$useEffectOnce = function(effect) {
    (0, $eZVvM.useEffect)(effect, []);
};
var $527fc7c8a06c512f$export$2e2bcd8739ae039 = $527fc7c8a06c512f$var$useEffectOnce;

});



parcelRegister("1qfhS", function(module, exports) {

$parcel$export(module.exports, "on", function () { return $109413e3b0fe66f1$export$af631764ddc44097; });
$parcel$export(module.exports, "off", function () { return $109413e3b0fe66f1$export$8c8705df4a2dcec9; });
$parcel$export(module.exports, "isBrowser", function () { return $109413e3b0fe66f1$export$4e09c449d6c407f7; });
var $109413e3b0fe66f1$export$8793edee2d425525 = function() {};
function $109413e3b0fe66f1$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $109413e3b0fe66f1$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $109413e3b0fe66f1$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $109413e3b0fe66f1$export$42e7ac6120dd324e = typeof navigator !== "undefined";

});


parcelRegister("53K4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1145d194c528043b$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $1145d194c528043b$var$SvgTransitonLogo = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "TransitonLogo_svg__d-block TransitonLogo_svg__w-100",
        viewBox: "0 0 1000 295",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M39.92 226.368h20.254l3.937-20.253H43.858l-3.938 20.253z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "m150.962 219.221-4.259 21.993H22.449L57.633 59.413h22.364l3.575-18.518H42.363L0 259.732h161.973l7.835-40.511h-18.846zm202.091-108.504c10.09-4.257 18.401-10.382 24.936-18.373 6.532-7.99 10.849-17.587 12.95-28.786 2.45-12.25 1.75-23.125-2.101-32.634-3.849-9.507-10.236-16.974-19.16-22.399-8.925-5.424-19.862-8.137-32.81-8.137h-41.297l-22.748 116.716h45.497c13.063 0 24.643-2.127 34.733-6.387Zm-33.334-85.13h13.65c6.763 0 12.45 1.43 17.06 4.287 4.608 2.86 7.845 6.854 9.712 11.986 1.864 5.134 2.1 11.085.7 17.848-1.168 6.535-3.5 12.222-7 17.062-3.5 4.842-7.934 8.574-13.298 11.199-5.368 2.625-11.493 3.937-18.374 3.937H306.77l12.949-66.32Zm100.266 91.517 15.924-82.243h-27.473l-16.099 82.243h27.648zM442.908.213h-28.523l-4.549 23.274h28.523L442.908.213zm25.197 154.338c14.231 0 25.402-3.473 33.511-10.411 8.107-6.943 13.618-17.761 16.535-32.46l13.65-70.345c-5.599-2.914-11.725-5.162-18.373-6.736-6.65-1.576-13.186-2.363-19.6-2.363-9.448 0-17.966 1.604-25.548 4.812-7.584 3.21-13.884 7.904-18.897 14.087-5.019 6.184-8.4 13.765-10.15 22.748-1.517 8.048-1.373 15.398.437 22.047 1.808 6.65 5.075 11.93 9.8 15.836 4.724 3.91 10.701 5.863 17.936 5.863 6.299 0 11.925-1.603 16.887-4.812 2.78-1.8 5.165-3.997 7.23-6.514l-1.368 7.301c-1.4 7.231-3.998 12.424-7.787 15.574-3.794 3.15-8.898 4.724-15.313 4.724-3.967 0-8.137-.76-12.511-2.274a57.915 57.915 0 0 1-12.511-6.125l-11.025 18.548c5.132 3.5 10.79 6.125 16.974 7.875 6.182 1.75 12.89 2.625 20.123 2.625Zm18.638-60.982c-2.51 1.46-5.28 2.187-8.314 2.187-3.15 0-5.717-.875-7.699-2.625-1.984-1.75-3.297-4.228-3.937-7.437-.642-3.208-.555-6.912.262-11.111.815-4.2 2.275-7.758 4.375-10.675 2.1-2.915 4.753-5.132 7.962-6.649 3.208-1.515 6.913-2.275 11.111-2.275 2.801 0 5.365.35 7.7 1.05.87.261 1.761.652 2.663 1.107l-3.888 20.241c-.7 3.85-1.955 7.148-3.761 9.887-1.812 2.742-3.969 4.841-6.474 6.3ZM579.572.213h-28.523L546.5 23.487h28.521L579.572.213zm-22.924 116.891 15.923-82.243H545.1L529 117.104h27.648zm22.046-61.42h12.19l-5.539 28.348c-1.286 7.117-.994 13.359.876 18.723 1.864 5.367 5.132 9.537 9.797 12.512 4.665 2.975 10.44 4.462 17.325 4.462 5.014 0 9.65-.7 13.911-2.1 4.257-1.4 8.136-3.558 11.636-6.475l-7.875-16.973c-1.284 1.285-2.859 2.304-4.723 3.062-1.867.76-3.737 1.137-5.601 1.137-2.917 0-5.161-1.107-6.736-3.324-1.574-2.215-1.956-5.365-1.139-9.45l5.864-29.922h19.861l4.025-20.823H622.76l5.28-26.948h-27.82l-5.266 26.948H582.72l-4.025 20.823Zm75.506 60.019c3.909 2.683 8.896 4.026 14.961 4.026 4.9 0 9.302-.848 13.212-2.538 3.908-1.69 7.115-3.907 9.626-6.65a26.005 26.005 0 0 0 3.039-4.004l-.502 10.567h23.623l8.924-46.196c2.45-12.014.438-21.494-6.039-28.435-6.474-6.94-16.303-10.413-29.483-10.413-6.068 0-12.192.819-18.373 2.45-6.186 1.635-11.667 3.968-16.45 7l8.399 16.973a53.17 53.17 0 0 1 11.46-4.636c4.028-1.108 7.846-1.663 11.464-1.663 5.48 0 9.273 1.4 11.374 4.2 1.767 2.356 2.32 5.761 1.69 10.184-.712-.12-1.412-.278-2.127-.385-4.726-.7-9.13-1.05-13.212-1.05-11.316 0-20.62 2.306-27.912 6.912-7.291 4.61-11.695 10.879-13.21 18.811-.935 5.135-.555 9.887 1.137 14.26 1.69 4.376 4.49 7.905 8.4 10.587Zm16.361-25.897c.702-3.15 2.627-5.569 5.776-7.262 3.149-1.69 7.289-2.537 12.423-2.537 2.985 0 6.247.33 9.72.915l-1.32 7.134c-.467 2.218-1.575 4.318-3.326 6.3-1.748 1.984-3.879 3.586-6.387 4.811s-5.047 1.838-7.61 1.838c-3.619 0-6.272-1.05-7.962-3.15-1.693-2.099-2.13-4.782-1.314-8.05ZM779.926.388h-27.822l-22.748 116.716h27.822L779.926.388zM331.052 209.832c8.688-6.008 14.086-14.377 16.185-25.11 1.633-8.05.99-15.195-1.925-21.437-2.917-6.24-7.584-11.17-13.998-14.786-6.417-3.615-14.234-5.425-23.448-5.425h-40.072L245.046 259.79h28.523l7.976-40.947h14.01l13.011 40.947h30.098l-17.024-45.044c3.401-1.325 6.557-2.94 9.412-4.914Zm-39.11-44.36h11.024c3.85 0 7.114.7 9.8 2.1 2.682 1.4 4.607 3.325 5.774 5.775 1.164 2.45 1.4 5.31.7 8.575-.817 4.666-3.092 8.284-6.825 10.848-3.734 2.568-8.634 3.85-14.698 3.85h-11.843l6.068-31.147Zm121.963 15.049c-5.717-3.85-12.716-5.775-20.998-5.775-7.584 0-14.7 1.693-21.349 5.075-6.648 3.385-12.221 8.11-16.71 14.174-4.492 6.067-7.497 13.066-9.012 20.999-1.75 8.983-1.256 17.06 1.487 24.235 2.74 7.175 7.437 12.834 14.086 16.973 6.65 4.14 14.756 6.213 24.324 6.213 6.764 0 13.21-1.023 19.335-3.063s11.287-4.812 15.487-8.311l-9.8-16.974c-3.5 2.567-6.912 4.462-10.236 5.687-3.325 1.225-6.912 1.837-10.762 1.837-4.55 0-8.311-.844-11.287-2.537-2.975-1.69-5.017-4.113-6.123-7.262-.576-1.633-.896-3.446-.985-5.424h54.617l1.4-7.35c1.633-8.514 1.225-16.098-1.224-22.748-2.45-6.65-6.535-11.9-12.25-15.749Zm-30.972 18.111c2.682-1.69 5.54-2.537 8.574-2.537 3.032 0 5.482.787 7.35 2.363 1.864 1.574 3.12 3.762 3.761 6.561.389 1.7.5 3.643.396 5.774h-29.279c.622-1.897 1.408-3.623 2.374-5.16 1.864-2.976 4.139-5.308 6.824-7.001Zm103.851 38.672c-2.624 1.342-5.454 2.012-8.486 2.012-3.617 0-6.71-.962-9.274-2.887-2.567-1.924-4.375-4.55-5.425-7.875-1.05-3.324-1.168-7.2-.35-11.636.815-3.85 2.187-7.174 4.112-9.974 1.925-2.8 4.345-4.987 7.262-6.562 2.915-1.575 6.064-2.362 9.45-2.362 6.53 0 11.548 2.86 15.047 8.574l18.724-13.298c-3.5-5.95-8.08-10.5-13.737-13.65-5.659-3.149-12.22-4.724-19.686-4.724-8.049 0-15.516 1.662-22.397 4.986-6.884 3.326-12.658 7.963-17.324 13.912-4.667 5.95-7.816 12.949-9.448 20.999-1.635 8.866-.993 16.915 1.925 24.148 2.914 7.233 7.699 12.948 14.348 17.148 6.65 4.2 14.406 6.3 23.273 6.3 13.18 0 24.554-4.726 34.122-14.175l-13.998-17.148c-2.8 2.8-5.514 4.872-8.138 6.212Zm85.216 2.45c-3.325 1.225-6.912 1.837-10.762 1.837-4.549 0-8.31-.844-11.287-2.537-2.974-1.69-5.016-4.113-6.123-7.262-.576-1.633-.896-3.446-.984-5.424h54.618l1.4-7.35c1.632-8.514 1.224-16.098-1.226-22.748-2.45-6.65-6.535-11.9-12.247-15.749-5.718-3.85-12.719-5.775-21-5.775-7.584 0-14.699 1.693-21.35 5.075-6.648 3.385-12.22 8.11-16.709 14.174-4.493 6.067-7.497 13.066-9.013 20.999-1.749 8.983-1.255 17.06 1.487 24.235 2.74 7.175 7.437 12.834 14.087 16.973 6.649 4.14 14.755 6.213 24.323 6.213 6.764 0 13.212-1.023 19.338-3.063 6.123-2.04 11.284-4.812 15.485-8.311l-9.8-16.974c-3.499 2.567-6.911 4.462-10.237 5.687Zm-17.584-41.122c2.682-1.69 5.538-2.537 8.573-2.537 3.033 0 5.483.787 7.35 2.363 1.864 1.574 3.12 3.762 3.763 6.561.388 1.7.5 3.643.394 5.774h-29.28c.623-1.897 1.41-3.623 2.375-5.16 1.864-2.976 4.138-5.308 6.825-7.001Zm130.01-17.586c-4.667-4.082-10.384-6.124-17.149-6.124-6.3 0-12.104 1.634-17.41 4.9-3.533 2.173-6.522 5.032-8.994 8.546l.331-10.821h-24.496l-22.925 117.24h27.824l6.852-35.457c.079.033.156.078.234.11 5.074 2.1 10.528 3.149 16.361 3.149 8.165 0 15.662-1.692 22.487-5.074 6.822-3.382 12.598-8.225 17.323-14.524 4.723-6.3 7.901-13.763 9.536-22.398 1.633-8.282 1.545-15.923-.261-22.924-1.812-6.999-5.047-12.538-9.713-16.623Zm-17.848 38.497c-.701 4.085-2.101 7.612-4.2 10.587-2.1 2.975-4.668 5.221-7.698 6.736-3.036 1.518-6.477 2.275-10.325 2.275-3.903 0-7.746-.797-11.535-2.38l3.835-19.843c.701-3.964 1.952-7.349 3.763-10.15 1.807-2.799 3.993-4.926 6.561-6.386 2.564-1.457 5.306-2.188 8.225-2.188 3.15 0 5.686.876 7.611 2.625 1.925 1.75 3.239 4.23 3.937 7.437.7 3.21.641 6.973-.174 11.287Zm74.806-21.173h19.862l4.024-20.823h-19.805l5.28-26.948h-27.822l-5.265 26.948h-12.235L701.4 198.37h12.19l-5.54 28.347c-1.286 7.118-.993 13.36.876 18.724 1.865 5.367 5.132 9.537 9.797 12.512 4.666 2.975 10.44 4.462 17.326 4.462 5.014 0 9.65-.7 13.911-2.1 4.257-1.4 8.136-3.558 11.635-6.475l-7.874-16.974c-1.284 1.286-2.859 2.305-4.723 3.063-1.868.76-3.737 1.137-5.602 1.137-2.916 0-5.16-1.108-6.735-3.324-1.574-2.215-1.957-5.365-1.14-9.45l5.864-29.922Zm26.334 61.42h27.647l15.923-82.243h-27.471l-16.099 82.243zm22.049-116.891-4.549 23.274h28.52l4.552-23.274h-28.523zm97.553 38.41c-6.712-4.257-14.673-6.387-23.887-6.387-7.935 0-15.285 1.604-22.05 4.812-6.766 3.21-12.452 7.76-17.06 13.649-4.609 5.892-7.67 12.746-9.187 20.56-1.635 9.1-.904 17.323 2.189 24.673 3.088 7.35 7.988 13.154 14.697 17.412 6.709 4.256 14.67 6.387 23.887 6.387 7.932 0 15.25-1.635 21.96-4.9 6.708-3.265 12.365-7.844 16.974-13.737 4.607-5.889 7.67-12.744 9.186-20.56 1.75-9.214 1.078-17.438-2.013-24.673-3.09-7.232-7.99-12.976-14.697-17.236Zm-10.763 39.108c-.7 3.618-2.043 6.825-4.024 9.625-1.985 2.8-4.348 4.988-7.088 6.562-2.743 1.574-5.747 2.363-9.011 2.363-3.5 0-6.417-.903-8.75-2.712-2.334-1.808-3.967-4.375-4.9-7.7-.934-3.325-.992-7.202-.174-11.637.815-3.615 2.157-6.852 4.024-9.711 1.865-2.858 4.227-5.076 7.086-6.65s5.862-2.363 9.014-2.363c3.38 0 6.268.906 8.66 2.713 2.39 1.81 4.082 4.374 5.076 7.7.99 3.324 1.019 7.261.087 11.81Zm119.164-35.958c-4.198-6.357-10.675-9.537-19.422-9.537-6.65 0-12.748 1.634-18.286 4.9-3.907 2.302-7.185 5.247-9.902 8.767l.364-11.042h-24.497l-16.1 82.243h27.648l8.049-41.297c.815-3.965 2.102-7.407 3.85-10.324 1.751-2.914 3.908-5.19 6.474-6.825 2.566-1.632 5.309-2.45 8.225-2.45 3.732 0 6.3 1.373 7.7 4.113 1.399 2.742 1.575 6.737.526 11.987l-8.75 44.796h27.647l9.8-50.22c1.98-10.383.875-18.752-3.326-25.111Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M79.997 59.413 52.995 198.968h20.254l-3.938 20.253h81.651l30.896-159.808H79.997z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M233.098.384H91.421l-7.849 40.511h120.721l-34.485 178.326h41.223l38.383-198.584L253.351.384h-20.253z"
            })
        ]
    });
var $1145d194c528043b$export$2e2bcd8739ae039 = $1145d194c528043b$var$SvgTransitonLogo;

});


parcelRegister("bICkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8881898d796d8ce5$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");
var $g6uH4 = parcelRequire("g6uH4");

var $lM7US = parcelRequire("lM7US");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");
const $8881898d796d8ce5$var$MUTATION_ACCESS_EVENT_SEND_MESSAGE = (0, $g6uH4.gql)`
  mutation accessEventSendMessage($id: ID!) {
    accessEventSendMessage(id: $id) {
      id
    }
  }
`;
const $8881898d796d8ce5$var$Message = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)(); // const { trackEvent } = useEventTracking();
    const { status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/message`
    ], ()=>{
        return (0, $jnPOB.client).request($8881898d796d8ce5$var$MUTATION_ACCESS_EVENT_SEND_MESSAGE, {
            id: id
        });
    }, {
        retry: false,
        refetchOnWindowFocus: false,
        onSuccess () {
        //   type: "message_send",
        //   value: "success",
        // });
        },
        onError () {
        //   type: "message_send",
        //   value: "error",
        // });
        }
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        /**
     * Redirect to previous route in case of error so you can retry
     */ if (requestStatus === "error") return navigate(-1);
        return navigate(`/`, {
            replace: true
        });
    }, [
        requestStatus
    ]);
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    return (0, $bhfvP.jsx)((0, $lM7US.default), {
        title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `message:status.${status}.title`
        }),
        message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `message:status.${status}.message`
        }),
        status: status,
        onDismiss: onDismiss
    });
};
var $8881898d796d8ce5$export$2e2bcd8739ae039 = $8881898d796d8ce5$var$Message;

});
parcelRegister("lM7US", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fda438ae0bf3fbfd$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $ljukC = parcelRequire("ljukC");

var $81BVN = parcelRequire("81BVN");

var $9YZ1B = parcelRequire("9YZ1B");

var $cRA6X = parcelRequire("cRA6X");

var $4yVoh = parcelRequire("4yVoh");
const $fda438ae0bf3fbfd$var$Modal = (props)=>{
    const { title: title, message: message, status: status, onDismiss: onDismiss } = props;
    return (0, $bhfvP.jsxs)("div", Object.assign({
        className: "main-modal"
    }, {
        children: [
            (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({}, (0, $4yVoh.anim)((0, $4yVoh.modalIn)), {
                className: "main-modal__background"
            })),
            (0, $bhfvP.jsxs)((0, $ljukC.motion).div, Object.assign({}, (0, $4yVoh.anim)((0, $4yVoh.modalUp)), {
                className: "main-modal__content"
            }, {
                children: [
                    (0, $bhfvP.jsxs)("div", Object.assign({
                        className: "text-center mt-5"
                    }, {
                        children: [
                            title && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h1",
                                className: `text-${status}`
                            }, {
                                children: title
                            })),
                            message && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h2",
                                className: "mt-5"
                            }, {
                                children: message
                            }))
                        ]
                    })),
                    (0, $bhfvP.jsx)((0, $9YZ1B.default), {
                        status: status
                    }),
                    status !== "loading" && (0, $bhfvP.jsx)("div", Object.assign({
                        className: "main-modal__close",
                        onClick: onDismiss
                    }, {
                        children: (0, $bhfvP.jsx)((0, $cRA6X.default), {
                            width: "5.5rem"
                        })
                    }))
                ]
            }))
        ]
    }));
};
var $fda438ae0bf3fbfd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($fda438ae0bf3fbfd$var$Modal);

});
parcelRegister("9YZ1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74490de4da964138$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $lNlyW = parcelRequire("lNlyW");

var $bdKsX = parcelRequire("bdKsX");
const $74490de4da964138$var$StatusIcon = ({ status: status })=>{
    return (0, $bhfvP.jsxs)("div", Object.assign({
        className: `main-modal__icon-box text-${status}`
    }, {
        children: [
            status === "loading" && (0, $bhfvP.jsx)("div", {
                className: "spinner-border m-auto",
                role: "status"
            }),
            status === "success" && (0, $bhfvP.jsx)("div", Object.assign({
                className: "m-auto success"
            }, {
                children: (0, $bhfvP.jsx)((0, $bdKsX.default), {
                    width: "4.7rem",
                    height: "3.4rem"
                })
            })),
            status === "error" && (0, $bhfvP.jsx)("div", Object.assign({
                className: "m-auto error"
            }, {
                children: (0, $bhfvP.jsx)((0, $lNlyW.default), {
                    width: "1.1rem",
                    height: "4.6rem"
                })
            }))
        ]
    }));
};
var $74490de4da964138$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($74490de4da964138$var$StatusIcon);

});
parcelRegister("lNlyW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f4a49b3533c9276$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $7f4a49b3533c9276$var$SvgError = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        width: "1.1rem",
        height: "4.6rem",
        viewBox: "0 0 11 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M1.92 30.856 1.022.2h8.768l-.96 30.656H1.92Zm3.647 14.592c-1.536 0-2.794-.47-3.776-1.408-.938-.939-1.408-2.07-1.408-3.392 0-1.365.47-2.517 1.408-3.456.982-.939 2.24-1.408 3.776-1.408 1.45 0 2.646.47 3.584 1.408.982.939 1.472 2.09 1.472 3.456 0 1.323-.49 2.453-1.472 3.392-.938.939-2.133 1.408-3.584 1.408Z",
            fill: "#FF4E4E"
        })
    });
var $7f4a49b3533c9276$export$2e2bcd8739ae039 = $7f4a49b3533c9276$var$SvgError;

});

parcelRegister("bdKsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $535a39e60c31f2a1$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $535a39e60c31f2a1$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 15 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M5.233 9.82a.637.637 0 0 1-.24-.043.662.662 0 0 1-.216-.152l-3.93-3.93a.65.65 0 0 1-.196-.478.65.65 0 0 1 .196-.477.625.625 0 0 1 .456-.196c.173 0 .325.066.456.196l3.474 3.474L13.114.332a.637.637 0 0 1 .467-.195c.181 0 .337.065.467.195s.195.286.195.467c0 .18-.065.336-.195.467l-8.36 8.36a.662.662 0 0 1-.216.151.638.638 0 0 1-.24.044Z",
            fill: "#20BE75"
        })
    });
var $535a39e60c31f2a1$export$2e2bcd8739ae039 = $535a39e60c31f2a1$var$SvgSuccess;

});


parcelRegister("cRA6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56ba4849816b834d$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $56ba4849816b834d$var$SvgClose = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('6d2bef2ef2d02ca1')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M12.2 3.807a.664.664 0 0 0-.94 0L8 7.06 4.74 3.8a.664.664 0 1 0-.94.94L7.06 8 3.8 11.26a.664.664 0 1 0 .94.94L8 8.94l3.26 3.26a.664.664 0 1 0 .94-.94L8.94 8l3.26-3.26a.668.668 0 0 0 0-.933Z",
                fill: "#111"
            })
        })
    });
var $56ba4849816b834d$export$2e2bcd8739ae039 = $56ba4849816b834d$var$SvgClose;

});


parcelRegister("e7eqj", function(module, exports) {

$parcel$export(module.exports, "useDebounceStatus", function () { return $a46ce851cb8c4430$export$4d340688cbe434a5; });

var $eZVvM = parcelRequire("eZVvM");

var $dEN1C = parcelRequire("dEN1C");
function $a46ce851cb8c4430$export$4d340688cbe434a5(currentStatus = "idle", ms = 2000) {
    const [status, setStatus] = (0, $eZVvM.useState)(currentStatus);
    const [, cancel, reset] = (0, (/*@__PURE__*/$parcel$interopDefault($dEN1C)))(()=>{
        setStatus(currentStatus);
    }, ms);
    (0, $eZVvM.useEffect)(()=>{
        switch(currentStatus){
            case "success":
            case "error":
                reset();
                break;
            default:
                cancel();
                setStatus(currentStatus);
                break;
        }
    }, [
        currentStatus
    ]);
    return status;
}

});
parcelRegister("dEN1C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
function $9f150a284e68dfbb$var$useTimeoutFn(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = $eZVvM.useRef(false);
    var timeout = $eZVvM.useRef();
    var callback = $eZVvM.useRef(fn);
    var isReady = $eZVvM.useCallback(function() {
        return ready.current;
    }, []);
    var set = $eZVvM.useCallback(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = $eZVvM.useCallback(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    $eZVvM.useEffect(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    $eZVvM.useEffect(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}
module.exports.default = $9f150a284e68dfbb$var$useTimeoutFn;

});


parcelRegister("aOIYu", function(module, exports) {

$parcel$export(module.exports, "useTimeoutFunction", function () { return $7e0175e7d1b780ed$export$300a7784b83886c8; });

var $eZVvM = parcelRequire("eZVvM");

var $dEN1C = parcelRequire("dEN1C");
function $7e0175e7d1b780ed$export$300a7784b83886c8(fn = ()=>null, ms = 0) {
    const [, cancelTimeout, resetTimeout] = (0, (/*@__PURE__*/$parcel$interopDefault($dEN1C)))(fn, ms);
    const disabled = (0, $eZVvM.useMemo)(()=>!(typeof ms === "number" && ms > 0), []);
    (0, $eZVvM.useEffect)(()=>{
        if (disabled) cancelTimeout();
        else resetTimeout();
        return ()=>{
            cancelTimeout();
        };
    }, [
        disabled
    ]);
}

});


parcelRegister("bblWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8241bed9fec73b14$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $70Aln = parcelRequire("70Aln");
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");

var $1BSKa = parcelRequire("1BSKa");

var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");

var $5noJM = parcelRequire("5noJM");

var $219y6 = parcelRequire("219y6");

var $kCXUJ = parcelRequire("kCXUJ");
var $8241bed9fec73b14$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8241bed9fec73b14$var$isDev = false;
const $8241bed9fec73b14$var$CLIENT_TOKEN = $8241bed9fec73b14$var$isDev ? undefined : window.location.pathname.split("/")[2];
const $8241bed9fec73b14$var$api = (0, $a7H8f.default).create({
    baseURL: `${"https://api.digitalreception.app"}/api/v2`,
    headers: {
        "client-token": $8241bed9fec73b14$var$CLIENT_TOKEN
    }
});
const $8241bed9fec73b14$var$Calling = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ type: type })=>{
    var _a, _b, _c, _d, _e, _f;
    const navigate = (0, $9B9bN.useNavigate)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const { location: { pathname: pathname } } = window;
    const path = (0, $eZVvM.useMemo)(()=>{
        if (pathname.includes("delivery")) return `${pathname.includes("custom") ? "custom-" : ""}delivery/:action/contact/:id/:callType`;
        if (pathname.includes("access")) return `access/checkin/${pathname.includes("manual") ? "manual/" : ""}contact/:id/:callType`;
        return "contact/:id/:callType";
    }, []);
    const match = (0, $9B9bN.useMatch)({
        path: path
    });
    const id = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.id;
    const callType = (_b = match === null || match === void 0 ? void 0 : match.params) === null || _b === void 0 ? void 0 : _b.callType;
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    const { data: accessEventData } = (0, $dMu0R.useQuery)([
        `access/event/${id}`
    ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
            id: id
        }), {
        enabled: !!id && id !== "reception",
        retry: false,
        staleTime: 60000,
        onError: ()=>{
            navigate("/", {
                replace: true
            });
        }
    });
    const receiverPhone = ((_d = (_c = accessEventData === null || accessEventData === void 0 ? void 0 : accessEventData.accessEvent) === null || _c === void 0 ? void 0 : _c.receiver) === null || _d === void 0 ? void 0 : _d.phone) || ((_f = (_e = accessEventData === null || accessEventData === void 0 ? void 0 : accessEventData.accessEvent) === null || _e === void 0 ? void 0 : _e.customReceiver) === null || _f === void 0 ? void 0 : _f.phone);
    const phoneNumber = (0, $eZVvM.useMemo)(()=>{
        if (type === "reception") return receptionistPhone;
        return receiverPhone;
    }, [
        receptionistPhone,
        receiverPhone,
        type
    ]);
    const timerRef = (0, $eZVvM.useRef)();
    const call = (0, $eZVvM.useRef)();
    const device = (0, $eZVvM.useRef)();
    const [callingStatus, setCallingStatus] = (0, $eZVvM.useState)();
    const { data: data } = (0, $dMu0R.useQuery)([
        "token"
    ], ()=>$8241bed9fec73b14$var$api.get(`/twilio/token`).then(({ data: data })=>data).catch((error)=>{
            (0, $1BSKa.default).error(`[device] - disconnect`, error);
        }), {
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0
    });
    const onEndCall = (0, $eZVvM.useCallback)(()=>{
        var _a, _b;
        (_a = device.current) === null || _a === void 0 || _a.disconnectAll();
        (_b = device.current) === null || _b === void 0 || _b.destroy();
    }, []);
    const onClose = (0, $eZVvM.useCallback)(()=>{
        setCallingStatus(undefined);
        navigate("/", {
            replace: true
        });
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        const init = ()=>$8241bed9fec73b14$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!phoneNumber) {
                    navigate("/", {
                        replace: true
                    });
                    return;
                }
                if (!(data && data.token) || !online) return;
                device.current = new (0, $70Aln.Device)(data.token, {
                });
                (0, $1BSKa.default).debug(`[device] Device connected`);
                (0, $1BSKa.default).debug(`[call] Establishing a call`);
                setCallingStatus("connecting");
                let params = {
                    To: phoneNumber
                };
                if (callType === "ping") params = Object.assign(Object.assign({}, params), {
                    Timeout: "10"
                });
                call.current = yield device.current.connect({
                    params: params
                });
                call.current.on("ringing", (call)=>{
                    if (call) setCallingStatus("ringing");
                });
                call.current.on("accept", ()=>{
                    /**
         * If someone answers the "ping" call by chance,
         * end the call automatically
         */ if (callType === "ping") {
                        onEndCall();
                        return;
                    }
                    setCallingStatus("open");
                });
                call.current.on("cancel", ()=>{
                    (0, $1BSKa.default).debug(`[call] The call has been canceled.`);
                    setCallingStatus("close");
                });
                call.current.on("disconnect", (call)=>{
                    (0, $1BSKa.default).debug(`[call] The call has been disconnected.`, call);
                    setCallingStatus("close");
                });
                call.current.on("reject", ()=>{
                    (0, $1BSKa.default).debug(`[call] The call was rejected.`);
                    setCallingStatus("close");
                });
                call.current.on("error", (error)=>{
                    (0, $1BSKa.default).error(`[call] An error has occurred: `, error); // trackEvent({ type: "calling", value: "error" });
                    setCallingStatus("error");
                });
                call.current.on("reconnected", ()=>{
                    (0, $1BSKa.default).debug(`[call] The call has regained connectivity.`);
                });
                call.current.on("reconnecting", (error)=>{
                    (0, $1BSKa.default).debug(`[call] Connectivity error: `, error);
                });
                device.current.on("error", (twilioError)=>{
                    (0, $1BSKa.default).error(`[device] An error has occurred: `, twilioError); // trackEvent({ type: "calling", value: "error" });
                    setCallingStatus("error");
                });
            });
        init();
        return ()=>{
            if (!device.current) return;
            device.current.disconnectAll();
            device.current.destroy();
            (0, $1BSKa.default).debug(`[device] Device disconnected`);
        };
    }, [
        data,
        phoneNumber
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (callingStatus === "close" || callingStatus === "error") timerRef.current = setTimeout(()=>{
            return navigate("/", {
                replace: true
            });
        }, 5000);
        return ()=>{
            clearTimeout(timerRef.current);
        };
    }, [
        callingStatus
    ]);
    return (0, $bhfvP.jsx)((0, $5noJM.default), {
        status: callingStatus,
        isCallingReception: type === "reception",
        onEndCall: onEndCall,
        onClose: onClose
    });
});
var $8241bed9fec73b14$export$2e2bcd8739ae039 = $8241bed9fec73b14$var$Calling;

});
parcelRegister("70Aln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwilioError = module.exports.Logger = module.exports.PreflightTest = module.exports.Device = module.exports.Call = void 0;

var $idaJZ = parcelRequire("idaJZ");
module.exports.Call = $idaJZ.default;

var $fewY1 = parcelRequire("fewY1");
module.exports.Device = $fewY1.default;

var $dmfT0 = parcelRequire("dmfT0");
module.exports.TwilioError = $dmfT0;

var $8RS9P = parcelRequire("8RS9P");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $8RS9P.Logger;
    }
});

var $bFCWZ = parcelRequire("bFCWZ");
Object.defineProperty(module.exports, "PreflightTest", {
    enumerable: true,
    get: function() {
        return $bFCWZ.PreflightTest;
    }
});

});
parcelRegister("idaJZ", function(module, exports) {
"use strict";
var $d421c5c6d9b8d50a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d421c5c6d9b8d50a$var$__assign = module.exports && module.exports.__assign || function() {
    $d421c5c6d9b8d50a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d421c5c6d9b8d50a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $4sGX5 = parcelRequire("4sGX5");

var $fewY1 = parcelRequire("fewY1");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");

var $5Qlbh = parcelRequire("5Qlbh");

var $56Fj4 = parcelRequire("56Fj4");

var $82FG2 = parcelRequire("82FG2");

var $j8NvP = parcelRequire("j8NvP");

var $f8R8g = parcelRequire("f8R8g");

var $c5BfP = parcelRequire("c5BfP");

var $k4N4t = parcelRequire("k4N4t");
var $d421c5c6d9b8d50a$var$BACKOFF_CONFIG = {
    factor: 1.1,
    jitter: 0.5,
    max: 30000,
    min: 1
};
var $d421c5c6d9b8d50a$var$DTMF_INTER_TONE_GAP = 70;
var $d421c5c6d9b8d50a$var$DTMF_PAUSE_DURATION = 500;
var $d421c5c6d9b8d50a$var$DTMF_TONE_DURATION = 160;
var $d421c5c6d9b8d50a$var$METRICS_BATCH_SIZE = 10;
var $d421c5c6d9b8d50a$var$METRICS_DELAY = 5000;
var $d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR = {
    disconnect: true,
    info: {
        code: 31003,
        message: "Connection with Twilio was interrupted.",
        twilioError: new $dmfT0.MediaErrors.ConnectionError()
    }
};
var $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES = {
    // The stat `packetsLostFraction` is monitored by two separate thresholds,
    // `maxAverage` and `max`. Each threshold emits a different warning name.
    packetsLostFraction: {
        max: "packet-loss",
        maxAverage: "packets-lost-fraction"
    }
};
var $d421c5c6d9b8d50a$var$WARNING_NAMES = {
    audioInputLevel: "audio-input-level",
    audioOutputLevel: "audio-output-level",
    bytesReceived: "bytes-received",
    bytesSent: "bytes-sent",
    jitter: "jitter",
    mos: "mos",
    rtt: "rtt"
};
var $d421c5c6d9b8d50a$var$WARNING_PREFIXES = {
    max: "high-",
    maxAverage: "high-",
    maxDuration: "constant-",
    min: "low-",
    minStandardDeviation: "constant-"
};
/**
 * A {@link Call} represents a media and signaling connection to a TwiML application.
 * @publicapi
 */ var $d421c5c6d9b8d50a$var$Call = /** @class */ function(_super) {
    $d421c5c6d9b8d50a$var$__extends(Call, _super);
    /**
     * @constructor
     * @private
     * @param config - Mandatory configuration options
     * @param [options] - Optional settings
     */ function Call(config, options) {
        var _this = _super.call(this) || this;
        /**
         * Call parameters received from Twilio for an incoming call.
         */ _this.parameters = {};
        /**
         * The number of times input volume has been the same consecutively.
         */ _this._inputVolumeStreak = 0;
        /**
         * Whether the call has been answered.
         */ _this._isAnswered = false;
        /**
         * Whether the call has been cancelled.
         */ _this._isCancelled = false;
        /**
         * Whether the call has been rejected
         */ _this._isRejected = false;
        /**
         * The most recent public input volume value. 0 -> 1 representing -100 to -30 dB.
         */ _this._latestInputVolume = 0;
        /**
         * The most recent public output volume value. 0 -> 1 representing -100 to -30 dB.
         */ _this._latestOutputVolume = 0;
        /**
         * An instance of Logger to use.
         */ _this._log = new $8RS9P.default("Call");
        /**
         * State of the {@link Call}'s media.
         */ _this._mediaStatus = Call.State.Pending;
        /**
         * A map of messages sent via sendMessage API using voiceEventSid as the key.
         * The message will be deleted once an 'ack' or an error is received from the server.
         */ _this._messages = new Map();
        /**
         * A batch of metrics samples to send to Insights. Gets cleared after
         * each send and appended to on each new sample.
         */ _this._metricsSamples = [];
        /**
         * Options passed to this {@link Call}.
         */ _this._options = {
            MediaHandler: $5Qlbh.PeerConnection,
            enableImprovedSignalingErrorPrecision: false,
            offerSdp: null,
            shouldPlayDisconnect: function() {
                return true;
            },
            voiceEventSidGenerator: $c5BfP.generateVoiceEventSid
        };
        /**
         * The number of times output volume has been the same consecutively.
         */ _this._outputVolumeStreak = 0;
        /**
         * Whether the {@link Call} should send a hangup on disconnect.
         */ _this._shouldSendHangup = true;
        /**
         * State of the {@link Call}'s signaling.
         */ _this._signalingStatus = Call.State.Pending;
        /**
         * A Map of Sounds to play.
         */ _this._soundcache = new Map();
        /**
         * State of the {@link Call}.
         */ _this._status = Call.State.Pending;
        /**
         * Whether the {@link Call} has been connected. Used to determine if we are reconnected.
         */ _this._wasConnected = false;
        /**
         * String representation of {@link Call} instance.
         * @private
         */ _this.toString = function() {
            return "[Twilio.Call instance]";
        };
        _this._emitWarning = function(groupPrefix, warningName, threshold, value, wasCleared, warningData) {
            var groupSuffix = wasCleared ? "-cleared" : "-raised";
            var groupName = groupPrefix + "warning" + groupSuffix;
            // Ignore constant input if the Call is muted (Expected)
            if (warningName === "constant-audio-input-level" && _this.isMuted()) return;
            var level = wasCleared ? "info" : "warning";
            // Avoid throwing false positives as warnings until we refactor volume metrics
            if (warningName === "constant-audio-output-level") level = "info";
            var payloadData = {
                threshold: threshold
            };
            if (value) {
                if (value instanceof Array) payloadData.values = value.map(function(val) {
                    if (typeof val === "number") return Math.round(val * 100) / 100;
                    return value;
                });
                else payloadData.value = value;
            }
            _this._publisher.post(level, groupName, warningName, {
                data: payloadData
            }, _this);
            if (warningName !== "constant-audio-output-level") {
                var emitName = wasCleared ? "warning-cleared" : "warning";
                _this._log.debug("#" + emitName, warningName);
                _this.emit(emitName, warningName, warningData && !wasCleared ? warningData : null);
            }
        };
        /**
         * Called when the {@link Call} receives an ack from signaling
         * @param payload
         */ _this._onAck = function(payload) {
            var acktype = payload.acktype, callsid = payload.callsid, voiceeventsid = payload.voiceeventsid;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received ack from a different callsid: " + callsid);
                return;
            }
            if (acktype === "message") _this._onMessageSent(voiceeventsid);
        };
        /**
         * Called when the {@link Call} is answered.
         * @param payload
         */ _this._onAnswer = function(payload) {
            if (typeof payload.reconnect === "string") _this._signalingReconnectToken = payload.reconnect;
            // answerOnBridge=false will send a 183 which we need to catch in _onRinging when
            // the enableRingingState flag is disabled. In that case, we will receive a 200 after
            // the callee accepts the call firing a second `accept` event if we don't
            // short circuit here.
            if (_this._isAnswered && _this._status !== Call.State.Reconnecting) return;
            _this._setCallSid(payload);
            _this._isAnswered = true;
            _this._maybeTransitionToOpen();
        };
        /**
         * Called when the {@link Call} is cancelled.
         * @param payload
         */ _this._onCancel = function(payload) {
            // (rrowland) Is this check necessary? Verify, and if so move to pstream / VSP module.
            var callsid = payload.callsid;
            if (_this.parameters.CallSid === callsid) {
                _this._isCancelled = true;
                _this._publisher.info("connection", "cancel", null, _this);
                _this._cleanupEventListeners();
                _this._mediaHandler.close();
                _this._status = Call.State.Closed;
                _this._log.debug("#cancel");
                _this.emit("cancel");
                _this._pstream.removeListener("cancel", _this._onCancel);
            }
        };
        /**
         * Called when we receive a connected event from pstream.
         * Re-emits the event.
         */ _this._onConnected = function() {
            _this._log.info("Received connected from pstream");
            if (_this._signalingReconnectToken && _this._mediaHandler.version) _this._pstream.reconnect(_this._mediaHandler.version.getSDP(), _this.parameters.CallSid, _this._signalingReconnectToken);
        };
        /**
         * Called when the {@link Call} is hung up.
         * @param payload
         */ _this._onHangup = function(payload) {
            if (_this.status() === Call.State.Closed) return;
            /**
             *  see if callsid passed in message matches either callsid or outbound id
             *  call should always have either callsid or outbound id
             *  if no callsid passed hangup anyways
             */ if (payload.callsid && (_this.parameters.CallSid || _this.outboundConnectionId)) {
                if (payload.callsid !== _this.parameters.CallSid && payload.callsid !== _this.outboundConnectionId) return;
            } else if (payload.callsid) // hangup is for another call
            return;
            _this._log.info("Received HANGUP from gateway");
            if (payload.error) {
                var code = payload.error.code;
                var errorConstructor = $dmfT0.getPreciseSignalingErrorByCode(_this._options.enableImprovedSignalingErrorPrecision, code);
                var error = typeof errorConstructor !== "undefined" ? new errorConstructor(payload.error.message) : new $dmfT0.GeneralErrors.ConnectionError("Error sent from gateway in HANGUP");
                _this._log.error("Received an error from the gateway:", error);
                _this._log.debug("#error", error);
                _this.emit("error", error);
            }
            _this._shouldSendHangup = false;
            _this._publisher.info("connection", "disconnected-by-remote", null, _this);
            _this._disconnect(null, true);
            _this._cleanupEventListeners();
        };
        /**
         * Called when there is a media failure.
         * Manages all media-related states and takes action base on the states
         * @param type - Type of media failure
         */ _this._onMediaFailure = function(type) {
            var _a = Call.MediaFailure, ConnectionDisconnected = _a.ConnectionDisconnected, ConnectionFailed = _a.ConnectionFailed, IceGatheringFailed = _a.IceGatheringFailed, LowBytes = _a.LowBytes;
            // These types signifies the end of a single ICE cycle
            var isEndOfIceCycle = type === ConnectionFailed || type === IceGatheringFailed;
            // All browsers except chrome doesn't update pc.iceConnectionState and pc.connectionState
            // after issuing an ICE Restart, which we use to determine if ICE Restart is complete.
            // Since we cannot detect if ICE Restart is complete, we will not retry.
            if (!$f8R8g.isChrome(window, window.navigator) && type === ConnectionFailed) return _this._mediaHandler.onerror($d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR);
            // Ignore subsequent requests if ice restart is in progress
            if (_this._mediaStatus === Call.State.Reconnecting) {
                // This is a retry. Previous ICE Restart failed
                if (isEndOfIceCycle) {
                    // We already exceeded max retry time.
                    if (Date.now() - _this._mediaReconnectStartTime > $d421c5c6d9b8d50a$var$BACKOFF_CONFIG.max) {
                        _this._log.warn("Exceeded max ICE retries");
                        return _this._mediaHandler.onerror($d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR);
                    }
                    // Issue ICE restart with backoff
                    try {
                        _this._mediaReconnectBackoff.backoff();
                    } catch (error) {
                        // Catch and ignore 'Backoff in progress.' errors. If a backoff is
                        // ongoing and we try to start another one, there shouldn't be a
                        // problem.
                        if (!(error.message && error.message === "Backoff in progress.")) throw error;
                    }
                }
                return;
            }
            var pc = _this._mediaHandler.version.pc;
            var isIceDisconnected = pc && pc.iceConnectionState === "disconnected";
            var hasLowBytesWarning = _this._monitor.hasActiveWarning("bytesSent", "min") || _this._monitor.hasActiveWarning("bytesReceived", "min");
            // Only certain conditions can trigger media reconnection
            if (type === LowBytes && isIceDisconnected || type === ConnectionDisconnected && hasLowBytesWarning || isEndOfIceCycle) {
                var mediaReconnectionError = new $dmfT0.MediaErrors.ConnectionError("Media connection failed.");
                _this._log.warn("ICE Connection disconnected.");
                _this._publisher.warn("connection", "error", mediaReconnectionError, _this);
                _this._publisher.info("connection", "reconnecting", null, _this);
                _this._mediaReconnectStartTime = Date.now();
                _this._status = Call.State.Reconnecting;
                _this._mediaStatus = Call.State.Reconnecting;
                _this._mediaReconnectBackoff.reset();
                _this._mediaReconnectBackoff.backoff();
                _this._log.debug("#reconnecting");
                _this.emit("reconnecting", mediaReconnectionError);
            }
        };
        /**
         * Called when media call is restored
         */ _this._onMediaReconnected = function() {
            // Only trigger once.
            // This can trigger on pc.onIceConnectionChange and pc.onConnectionChange.
            if (_this._mediaStatus !== Call.State.Reconnecting) return;
            _this._log.info("ICE Connection reestablished.");
            _this._mediaStatus = Call.State.Open;
            if (_this._signalingStatus === Call.State.Open) {
                _this._publisher.info("connection", "reconnected", null, _this);
                _this._log.debug("#reconnected");
                _this.emit("reconnected");
                _this._status = Call.State.Open;
            }
        };
        /**
         * Raised when a Call receives a message from the backend.
         * @param payload - A record representing the payload of the message from the
         * Twilio backend.
         */ _this._onMessageReceived = function(payload) {
            var callsid = payload.callsid, content = payload.content, contenttype = payload.contenttype, messagetype = payload.messagetype, voiceeventsid = payload.voiceeventsid;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received a message from a different callsid: " + callsid);
                return;
            }
            var data = {
                content: content,
                contentType: contenttype,
                messageType: messagetype,
                voiceEventSid: voiceeventsid
            };
            _this._publisher.info("call-message", messagetype, {
                content_type: contenttype,
                event_type: "received",
                voice_event_sid: voiceeventsid
            }, _this);
            _this._log.debug("#messageReceived", JSON.stringify(data));
            _this.emit("messageReceived", data);
        };
        /**
         * Raised when a Call receives an 'ack' with an 'acktype' of 'message.
         * This means that the message sent via sendMessage API has been received by the signaling server.
         * @param voiceEventSid
         */ _this._onMessageSent = function(voiceEventSid) {
            if (!_this._messages.has(voiceEventSid)) {
                _this._log.warn("Received a messageSent with a voiceEventSid that doesn't exists: " + voiceEventSid);
                return;
            }
            var message = _this._messages.get(voiceEventSid);
            _this._messages.delete(voiceEventSid);
            _this._publisher.info("call-message", message === null || message === void 0 ? void 0 : message.messageType, {
                content_type: message === null || message === void 0 ? void 0 : message.contentType,
                event_type: "sent",
                voice_event_sid: voiceEventSid
            }, _this);
            _this._log.debug("#messageSent", JSON.stringify(message));
            _this.emit("messageSent", message);
        };
        /**
         * When we get a RINGING signal from PStream, update the {@link Call} status.
         * @param payload
         */ _this._onRinging = function(payload) {
            _this._setCallSid(payload);
            // If we're not in 'connecting' or 'ringing' state, this event was received out of order.
            if (_this._status !== Call.State.Connecting && _this._status !== Call.State.Ringing) return;
            var hasEarlyMedia = !!payload.sdp;
            _this._status = Call.State.Ringing;
            _this._publisher.info("connection", "outgoing-ringing", {
                hasEarlyMedia: hasEarlyMedia
            }, _this);
            _this._log.debug("#ringing");
            _this.emit("ringing", hasEarlyMedia);
        };
        /**
         * Called each time StatsMonitor emits a sample.
         * Emits stats event and batches the call stats metrics and sends them to Insights.
         * @param sample
         */ _this._onRTCSample = function(sample) {
            var callMetrics = $d421c5c6d9b8d50a$var$__assign($d421c5c6d9b8d50a$var$__assign({}, sample), {
                inputVolume: _this._latestInputVolume,
                outputVolume: _this._latestOutputVolume
            });
            _this._codec = callMetrics.codecName;
            _this._metricsSamples.push(callMetrics);
            if (_this._metricsSamples.length >= $d421c5c6d9b8d50a$var$METRICS_BATCH_SIZE) _this._publishMetrics();
            _this.emit("sample", sample);
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ _this._onSignalingError = function(payload) {
            var callsid = payload.callsid, voiceeventsid = payload.voiceeventsid, error = payload.error;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received an error from a different callsid: " + callsid);
                return;
            }
            if (voiceeventsid && _this._messages.has(voiceeventsid)) {
                // Do not emit an error here. Device is handling all signaling related errors.
                _this._messages.delete(voiceeventsid);
                _this._log.warn("Received an error while sending a message.", payload);
                _this._publisher.error("call-message", "error", {
                    code: error.code,
                    message: error.message,
                    voice_event_sid: voiceeventsid
                }, _this);
                var twilioError = void 0;
                var errorConstructor = $dmfT0.getPreciseSignalingErrorByCode(!!_this._options.enableImprovedSignalingErrorPrecision, error.code);
                if (typeof errorConstructor !== "undefined") twilioError = new errorConstructor(error);
                if (!twilioError) {
                    _this._log.error("Unknown Call Message Error: ", error);
                    twilioError = new $dmfT0.GeneralErrors.UnknownError(error.message, error);
                }
                _this._log.debug("#error", error, twilioError);
                _this.emit("error", twilioError);
            }
        };
        /**
         * Called when signaling is restored
         */ _this._onSignalingReconnected = function() {
            if (_this._signalingStatus !== Call.State.Reconnecting) return;
            _this._log.info("Signaling Connection reestablished.");
            _this._signalingStatus = Call.State.Open;
            if (_this._mediaStatus === Call.State.Open) {
                _this._publisher.info("connection", "reconnected", null, _this);
                _this._log.debug("#reconnected");
                _this.emit("reconnected");
                _this._status = Call.State.Open;
            }
        };
        /**
         * Called when we receive a transportClose event from pstream.
         * Re-emits the event.
         */ _this._onTransportClose = function() {
            _this._log.error("Received transportClose from pstream");
            _this._log.debug("#transportClose");
            _this.emit("transportClose");
            if (_this._signalingReconnectToken) {
                _this._status = Call.State.Reconnecting;
                _this._signalingStatus = Call.State.Reconnecting;
                _this._log.debug("#reconnecting");
                _this.emit("reconnecting", new $dmfT0.SignalingErrors.ConnectionDisconnected());
            } else {
                _this._status = Call.State.Closed;
                _this._signalingStatus = Call.State.Closed;
            }
        };
        /**
         * Re-emit an StatsMonitor warning as a {@link Call}.warning or .warning-cleared event.
         * @param warningData
         * @param wasCleared - Whether this is a -cleared or -raised event.
         */ _this._reemitWarning = function(warningData, wasCleared) {
            var groupPrefix = /^audio/.test(warningData.name) ? "audio-level-" : "network-quality-";
            var warningPrefix = $d421c5c6d9b8d50a$var$WARNING_PREFIXES[warningData.threshold.name];
            /**
             * NOTE: There are two "packet-loss" warnings: `high-packet-loss` and
             * `high-packets-lost-fraction`, so in this case we need to use a different
             * `WARNING_NAME` mapping.
             */ var warningName;
            if (warningData.name in $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES) warningName = $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES[warningData.name][warningData.threshold.name];
            else if (warningData.name in $d421c5c6d9b8d50a$var$WARNING_NAMES) warningName = $d421c5c6d9b8d50a$var$WARNING_NAMES[warningData.name];
            var warning = warningPrefix + warningName;
            _this._emitWarning(groupPrefix, warning, warningData.threshold.value, warningData.values || warningData.value, wasCleared, warningData);
        };
        /**
         * Re-emit an StatsMonitor warning-cleared as a .warning-cleared event.
         * @param warningData
         */ _this._reemitWarningCleared = function(warningData) {
            _this._reemitWarning(warningData, true);
        };
        _this._isUnifiedPlanDefault = config.isUnifiedPlanDefault;
        _this._soundcache = config.soundcache;
        if (typeof config.onIgnore === "function") _this._onIgnore = config.onIgnore;
        var message = options && options.twimlParams || {};
        _this.customParameters = new Map(Object.entries(message).map(function(_a) {
            var key = _a[0], val = _a[1];
            return [
                key,
                String(val)
            ];
        }));
        Object.assign(_this._options, options);
        if (_this._options.callParameters) _this.parameters = _this._options.callParameters;
        if (_this._options.reconnectToken) _this._signalingReconnectToken = _this._options.reconnectToken;
        _this._voiceEventSidGenerator = _this._options.voiceEventSidGenerator || $c5BfP.generateVoiceEventSid;
        _this._direction = _this.parameters.CallSid && !_this._options.reconnectCallSid ? Call.CallDirection.Incoming : Call.CallDirection.Outgoing;
        if (_this.parameters) _this.callerInfo = _this.parameters.StirStatus ? {
            isVerified: _this.parameters.StirStatus === "TN-Validation-Passed-A"
        } : null;
        else _this.callerInfo = null;
        _this._mediaReconnectBackoff = new $4sGX5.default($d421c5c6d9b8d50a$var$BACKOFF_CONFIG);
        _this._mediaReconnectBackoff.on("ready", function() {
            return _this._mediaHandler.iceRestart();
        });
        // temporary call sid to be used for outgoing calls
        _this.outboundConnectionId = $d421c5c6d9b8d50a$var$generateTempCallSid();
        var publisher = _this._publisher = config.publisher;
        if (_this._direction === Call.CallDirection.Incoming) publisher.info("connection", "incoming", null, _this);
        else publisher.info("connection", "outgoing", {
            preflight: _this._options.preflight,
            reconnect: !!_this._options.reconnectCallSid
        }, _this);
        var monitor = _this._monitor = new (_this._options.StatsMonitor || $j8NvP.default)();
        monitor.on("sample", _this._onRTCSample);
        // First 20 seconds or so are choppy, so let's not bother with these warnings.
        monitor.disableWarnings();
        setTimeout(function() {
            return monitor.enableWarnings();
        }, $d421c5c6d9b8d50a$var$METRICS_DELAY);
        monitor.on("warning", function(data, wasCleared) {
            if (data.name === "bytesSent" || data.name === "bytesReceived") _this._onMediaFailure(Call.MediaFailure.LowBytes);
            _this._reemitWarning(data, wasCleared);
        });
        monitor.on("warning-cleared", function(data) {
            _this._reemitWarningCleared(data);
        });
        _this._mediaHandler = new _this._options.MediaHandler(config.audioHelper, config.pstream, {
            RTCPeerConnection: _this._options.RTCPeerConnection,
            codecPreferences: _this._options.codecPreferences,
            dscp: _this._options.dscp,
            forceAggressiveIceNomination: _this._options.forceAggressiveIceNomination,
            isUnifiedPlan: _this._isUnifiedPlanDefault,
            maxAverageBitrate: _this._options.maxAverageBitrate
        });
        _this.on("volume", function(inputVolume, outputVolume) {
            _this._inputVolumeStreak = _this._checkVolume(inputVolume, _this._inputVolumeStreak, _this._latestInputVolume, "input");
            _this._outputVolumeStreak = _this._checkVolume(outputVolume, _this._outputVolumeStreak, _this._latestOutputVolume, "output");
            _this._latestInputVolume = inputVolume;
            _this._latestOutputVolume = outputVolume;
        });
        _this._mediaHandler.onaudio = function(remoteAudio) {
            _this._log.debug("#audio");
            _this.emit("audio", remoteAudio);
        };
        _this._mediaHandler.onvolume = function(inputVolume, outputVolume, internalInputVolume, internalOutputVolume) {
            // (rrowland) These values mock the 0 -> 32767 format used by legacy getStats. We should look into
            // migrating to a newer standard, either 0.0 -> linear or -127 to 0 in dB, matching the range
            // chosen below.
            monitor.addVolumes(internalInputVolume / 255 * 32767, internalOutputVolume / 255 * 32767);
            // (rrowland) 0.0 -> 1.0 linear
            _this.emit("volume", inputVolume, outputVolume);
        };
        _this._mediaHandler.ondtlstransportstatechange = function(state) {
            var level = state === "failed" ? "error" : "debug";
            _this._publisher.post(level, "dtls-transport-state", state, null, _this);
        };
        _this._mediaHandler.onpcconnectionstatechange = function(state) {
            var level = "debug";
            var dtlsTransport = _this._mediaHandler.getRTCDtlsTransport();
            if (state === "failed") level = dtlsTransport && dtlsTransport.state === "failed" ? "error" : "warning";
            _this._publisher.post(level, "pc-connection-state", state, null, _this);
        };
        _this._mediaHandler.onicecandidate = function(candidate) {
            var payload = new $56Fj4.IceCandidate(candidate).toPayload();
            _this._publisher.debug("ice-candidate", "ice-candidate", payload, _this);
        };
        _this._mediaHandler.onselectedcandidatepairchange = function(pair) {
            var localCandidatePayload = new $56Fj4.IceCandidate(pair.local).toPayload();
            var remoteCandidatePayload = new $56Fj4.IceCandidate(pair.remote, true).toPayload();
            _this._publisher.debug("ice-candidate", "selected-ice-candidate-pair", {
                local_candidate: localCandidatePayload,
                remote_candidate: remoteCandidatePayload
            }, _this);
        };
        _this._mediaHandler.oniceconnectionstatechange = function(state) {
            var level = state === "failed" ? "error" : "debug";
            _this._publisher.post(level, "ice-connection-state", state, null, _this);
        };
        _this._mediaHandler.onicegatheringfailure = function(type) {
            _this._publisher.warn("ice-gathering-state", type, null, _this);
            _this._onMediaFailure(Call.MediaFailure.IceGatheringFailed);
        };
        _this._mediaHandler.onicegatheringstatechange = function(state) {
            _this._publisher.debug("ice-gathering-state", state, null, _this);
        };
        _this._mediaHandler.onsignalingstatechange = function(state) {
            _this._publisher.debug("signaling-state", state, null, _this);
        };
        _this._mediaHandler.ondisconnected = function(msg) {
            _this._log.warn(msg);
            _this._publisher.warn("network-quality-warning-raised", "ice-connectivity-lost", {
                message: msg
            }, _this);
            _this._log.debug("#warning", "ice-connectivity-lost");
            _this.emit("warning", "ice-connectivity-lost");
            _this._onMediaFailure(Call.MediaFailure.ConnectionDisconnected);
        };
        _this._mediaHandler.onfailed = function(msg) {
            _this._onMediaFailure(Call.MediaFailure.ConnectionFailed);
        };
        _this._mediaHandler.onconnected = function() {
            // First time _mediaHandler is connected, but ICE Gathering issued an ICE restart and succeeded.
            if (_this._status === Call.State.Reconnecting) _this._onMediaReconnected();
        };
        _this._mediaHandler.onreconnected = function(msg) {
            _this._log.info(msg);
            _this._publisher.info("network-quality-warning-cleared", "ice-connectivity-lost", {
                message: msg
            }, _this);
            _this._log.debug("#warning-cleared", "ice-connectivity-lost");
            _this.emit("warning-cleared", "ice-connectivity-lost");
            _this._onMediaReconnected();
        };
        _this._mediaHandler.onerror = function(e) {
            if (e.disconnect === true) _this._disconnect(e.info && e.info.message);
            var error = e.info.twilioError || new $dmfT0.GeneralErrors.UnknownError(e.info.message);
            _this._log.error("Received an error from MediaStream:", e);
            _this._log.debug("#error", error);
            _this.emit("error", error);
        };
        _this._mediaHandler.onopen = function() {
            // NOTE(mroberts): While this may have been happening in previous
            // versions of Chrome, since Chrome 45 we have seen the
            // PeerConnection's onsignalingstatechange handler invoked multiple
            // times in the same signalingState 'stable'. When this happens, we
            // invoke this onopen function. If we invoke it twice without checking
            // for _status 'open', we'd accidentally close the PeerConnection.
            //
            // See <https://code.google.com/p/webrtc/issues/detail?id=4996>.
            if (_this._status === Call.State.Open || _this._status === Call.State.Reconnecting) return;
            else if (_this._status === Call.State.Ringing || _this._status === Call.State.Connecting) {
                _this.mute(_this._mediaHandler.isMuted);
                _this._mediaStatus = Call.State.Open;
                _this._maybeTransitionToOpen();
            } else // call was probably canceled sometime before this
            _this._mediaHandler.close();
        };
        _this._mediaHandler.onclose = function() {
            _this._status = Call.State.Closed;
            if (_this._options.shouldPlayDisconnect && _this._options.shouldPlayDisconnect() && !_this._isCancelled && !_this._isRejected) _this._soundcache.get($fewY1.default.SoundName.Disconnect).play();
            monitor.disable();
            _this._publishMetrics();
            if (!_this._isCancelled && !_this._isRejected) {
                // tslint:disable no-console
                _this._log.debug("#disconnect");
                _this.emit("disconnect", _this);
            }
        };
        _this._pstream = config.pstream;
        _this._pstream.on("ack", _this._onAck);
        _this._pstream.on("cancel", _this._onCancel);
        _this._pstream.on("error", _this._onSignalingError);
        _this._pstream.on("ringing", _this._onRinging);
        _this._pstream.on("transportClose", _this._onTransportClose);
        _this._pstream.on("connected", _this._onConnected);
        _this._pstream.on("message", _this._onMessageReceived);
        _this.on("error", function(error) {
            _this._publisher.error("connection", "error", {
                code: error.code,
                message: error.message
            }, _this);
            if (_this._pstream && _this._pstream.status === "disconnected") _this._cleanupEventListeners();
        });
        _this.on("disconnect", function() {
            _this._cleanupEventListeners();
        });
        return _this;
    }
    Object.defineProperty(Call.prototype, "direction", {
        /**
         * Whether this {@link Call} is incoming or outgoing.
         */ get: function() {
            return this._direction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "codec", {
        /**
         * Audio codec used for this {@link Call}. Expecting {@link Call.Codec} but
         * will copy whatever we get from RTC stats.
         */ get: function() {
            return this._codec;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "connectToken", {
        /**
         * The connect token is available as soon as the call is established
         * and connected to Twilio. Use this token to reconnect to a call via the {@link Device.connect}
         * method.
         *
         * For incoming calls, it is available in the call object after the {@link Device.incomingEvent} is emitted.
         * For outgoing calls, it is available after the {@link Call.acceptEvent} is emitted.
         */ get: function() {
            var _this = this;
            var signalingReconnectToken = this._signalingReconnectToken;
            var callSid = this.parameters && this.parameters.CallSid ? this.parameters.CallSid : undefined;
            if (!signalingReconnectToken || !callSid) return;
            var customParameters = this.customParameters && typeof this.customParameters.keys === "function" ? Array.from(this.customParameters.keys()).reduce(function(result, key) {
                result[key] = _this.customParameters.get(key);
                return result;
            }, {}) : {};
            var parameters = this.parameters || {};
            return btoa(encodeURIComponent(JSON.stringify({
                customParameters: customParameters,
                parameters: parameters,
                signalingReconnectToken: signalingReconnectToken
            })));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the audio input tracks from a given stream.
     * @param stream
     * @private
     */ Call.prototype._setInputTracksFromStream = function(stream) {
        return this._mediaHandler.setInputTracksFromStream(stream);
    };
    /**
     * Set the audio output sink IDs.
     * @param sinkIds
     * @private
     */ Call.prototype._setSinkIds = function(sinkIds) {
        return this._mediaHandler._setSinkIds(sinkIds);
    };
    /**
     * Accept the incoming {@link Call}.
     * @param [options]
     */ Call.prototype.accept = function(options) {
        var _this = this;
        this._log.debug(".accept", options);
        if (this._status !== Call.State.Pending) {
            this._log.debug(".accept noop. status is '" + this._status + "'");
            return;
        }
        options = options || {};
        var rtcConfiguration = options.rtcConfiguration || this._options.rtcConfiguration;
        var rtcConstraints = options.rtcConstraints || this._options.rtcConstraints || {};
        var audioConstraints = {
            audio: typeof rtcConstraints.audio !== "undefined" ? rtcConstraints.audio : true
        };
        this._status = Call.State.Connecting;
        var connect = function() {
            if (_this._status !== Call.State.Connecting) {
                // call must have been canceled
                _this._cleanupEventListeners();
                _this._mediaHandler.close();
                return;
            }
            var onAnswer = function(pc) {
                // Report that the call was answered, and directionality
                var eventName = _this._direction === Call.CallDirection.Incoming ? "accepted-by-local" : "accepted-by-remote";
                _this._publisher.info("connection", eventName, null, _this);
                // Report the preferred codec and params as they appear in the SDP
                var _a = $82FG2.getPreferredCodecInfo(_this._mediaHandler.version.getSDP()), codecName = _a.codecName, codecParams = _a.codecParams;
                _this._publisher.info("settings", "codec", {
                    codec_params: codecParams,
                    selected_codec: codecName
                }, _this);
                // Enable RTC monitoring
                _this._monitor.enable(pc);
            };
            var sinkIds = typeof _this._options.getSinkIds === "function" && _this._options.getSinkIds();
            if (Array.isArray(sinkIds)) _this._mediaHandler._setSinkIds(sinkIds).catch(function() {
            // (rrowland) We don't want this to throw to console since the customer
            // can't control this. This will most commonly be rejected on browsers
            // that don't support setting sink IDs.
            });
            _this._pstream.addListener("hangup", _this._onHangup);
            if (_this._direction === Call.CallDirection.Incoming) {
                _this._isAnswered = true;
                _this._pstream.on("answer", _this._onAnswer);
                _this._mediaHandler.answerIncomingCall(_this.parameters.CallSid, _this._options.offerSdp, rtcConfiguration, onAnswer);
            } else {
                var params = Array.from(_this.customParameters.entries()).map(function(pair) {
                    return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
                }).join("&");
                _this._pstream.on("answer", _this._onAnswer);
                _this._mediaHandler.makeOutgoingCall(params, _this._signalingReconnectToken, _this._options.reconnectCallSid || _this.outboundConnectionId, rtcConfiguration, onAnswer);
            }
        };
        if (this._options.beforeAccept) this._options.beforeAccept(this);
        var inputStream = typeof this._options.getInputStream === "function" && this._options.getInputStream();
        var promise = inputStream ? this._mediaHandler.setInputTracksFromStream(inputStream) : this._mediaHandler.openDefaultDeviceWithConstraints(audioConstraints);
        promise.then(function() {
            _this._publisher.info("get-user-media", "succeeded", {
                data: {
                    audioConstraints: audioConstraints
                }
            }, _this);
            connect();
        }, function(error) {
            var twilioError;
            if (error.code === 31208 || [
                "PermissionDeniedError",
                "NotAllowedError"
            ].indexOf(error.name) !== -1) {
                twilioError = new $dmfT0.UserMediaErrors.PermissionDeniedError();
                _this._publisher.error("get-user-media", "denied", {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, _this);
            } else {
                twilioError = new $dmfT0.UserMediaErrors.AcquisitionFailedError();
                _this._publisher.error("get-user-media", "failed", {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, _this);
            }
            _this._disconnect();
            _this._log.debug("#error", error);
            _this.emit("error", twilioError);
        });
    };
    /**
     * Disconnect from the {@link Call}.
     */ Call.prototype.disconnect = function() {
        this._log.debug(".disconnect");
        this._disconnect();
    };
    /**
     * Get the local MediaStream, if set.
     */ Call.prototype.getLocalStream = function() {
        return this._mediaHandler && this._mediaHandler.stream;
    };
    /**
     * Get the remote MediaStream, if set.
     */ Call.prototype.getRemoteStream = function() {
        return this._mediaHandler && this._mediaHandler._remoteStream;
    };
    /**
     * Ignore the incoming {@link Call}.
     */ Call.prototype.ignore = function() {
        this._log.debug(".ignore");
        if (this._status !== Call.State.Pending) {
            this._log.debug(".ignore noop. status is '" + this._status + "'");
            return;
        }
        this._status = Call.State.Closed;
        this._mediaHandler.ignore(this.parameters.CallSid);
        this._publisher.info("connection", "ignored-by-local", null, this);
        if (this._onIgnore) this._onIgnore();
    };
    /**
     * Check whether call is muted
     */ Call.prototype.isMuted = function() {
        return this._mediaHandler.isMuted;
    };
    /**
     * Mute incoming audio.
     * @param shouldMute - Whether the incoming audio should be muted. Defaults to true.
     */ Call.prototype.mute = function(shouldMute) {
        if (shouldMute === void 0) shouldMute = true;
        this._log.debug(".mute", shouldMute);
        var wasMuted = this._mediaHandler.isMuted;
        this._mediaHandler.mute(shouldMute);
        var isMuted = this._mediaHandler.isMuted;
        if (wasMuted !== isMuted) {
            this._publisher.info("connection", isMuted ? "muted" : "unmuted", null, this);
            this._log.debug("#mute", isMuted);
            this.emit("mute", isMuted, this);
        }
    };
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has given call quality feedback. Called without a score, this
     *   will report that the customer declined to give feedback.
     * @param score - The end-user's rating of the call; an
     *   integer 1 through 5. Or undefined if the user declined to give
     *   feedback.
     * @param issue - The primary issue the end user
     *   experienced on the call. Can be: ['one-way-audio', 'choppy-audio',
     *   'dropped-call', 'audio-latency', 'noisy-call', 'echo']
     */ Call.prototype.postFeedback = function(score, issue) {
        if (typeof score === "undefined" || score === null) return this._postFeedbackDeclined();
        if (!Object.values(Call.FeedbackScore).includes(score)) throw new $dmfT0.InvalidArgumentError("Feedback score must be one of: " + Object.values(Call.FeedbackScore));
        if (typeof issue !== "undefined" && issue !== null && !Object.values(Call.FeedbackIssue).includes(issue)) throw new $dmfT0.InvalidArgumentError("Feedback issue must be one of: " + Object.values(Call.FeedbackIssue));
        return this._publisher.info("feedback", "received", {
            issue_name: issue,
            quality_score: score
        }, this, true);
    };
    /**
     * Reject the incoming {@link Call}.
     */ Call.prototype.reject = function() {
        this._log.debug(".reject");
        if (this._status !== Call.State.Pending) {
            this._log.debug(".reject noop. status is '" + this._status + "'");
            return;
        }
        this._isRejected = true;
        this._pstream.reject(this.parameters.CallSid);
        this._mediaHandler.reject(this.parameters.CallSid);
        this._publisher.info("connection", "rejected-by-local", null, this);
        this._cleanupEventListeners();
        this._mediaHandler.close();
        this._status = Call.State.Closed;
        this._log.debug("#reject");
        this.emit("reject");
    };
    /**
     * Send a string of digits.
     * @param digits
     */ Call.prototype.sendDigits = function(digits) {
        var _this = this;
        this._log.debug(".sendDigits", digits);
        if (digits.match(/[^0-9*#w]/)) throw new $dmfT0.InvalidArgumentError("Illegal character passed into sendDigits");
        var customSounds = this._options.customSounds || {};
        var sequence = [];
        digits.split("").forEach(function(digit) {
            var dtmf = digit !== "w" ? "dtmf" + digit : "";
            if (dtmf === "dtmf*") dtmf = "dtmfs";
            if (dtmf === "dtmf#") dtmf = "dtmfh";
            sequence.push(dtmf);
        });
        var playNextDigit = function() {
            var digit = sequence.shift();
            if (digit) {
                if (_this._options.dialtonePlayer && !customSounds[digit]) _this._options.dialtonePlayer.play(digit);
                else _this._soundcache.get(digit).play();
            }
            if (sequence.length) setTimeout(function() {
                return playNextDigit();
            }, 200);
        };
        playNextDigit();
        var dtmfSender = this._mediaHandler.getOrCreateDTMFSender();
        function insertDTMF(dtmfs) {
            if (!dtmfs.length) return;
            var dtmf = dtmfs.shift();
            if (dtmf && dtmf.length) dtmfSender.insertDTMF(dtmf, $d421c5c6d9b8d50a$var$DTMF_TONE_DURATION, $d421c5c6d9b8d50a$var$DTMF_INTER_TONE_GAP);
            setTimeout(insertDTMF.bind(null, dtmfs), $d421c5c6d9b8d50a$var$DTMF_PAUSE_DURATION);
        }
        if (dtmfSender) {
            if (!("canInsertDTMF" in dtmfSender) || dtmfSender.canInsertDTMF) {
                this._log.info("Sending digits using RTCDTMFSender");
                // NOTE(mroberts): We can't just map 'w' to ',' since
                // RTCDTMFSender's pause duration is 2 s and Twilio's is more
                // like 500 ms. Instead, we will fudge it with setTimeout.
                insertDTMF(digits.split("w"));
                return;
            }
            this._log.info("RTCDTMFSender cannot insert DTMF");
        }
        // send pstream message to send DTMF
        this._log.info("Sending digits over PStream");
        if (this._pstream !== null && this._pstream.status !== "disconnected") this._pstream.dtmf(this.parameters.CallSid, digits);
        else {
            var error = new $dmfT0.GeneralErrors.ConnectionError("Could not send DTMF: Signaling channel is disconnected");
            this._log.debug("#error", error);
            this.emit("error", error);
        }
    };
    /**
     * Send a message to Twilio. Your backend application can listen for these
     * messages to allow communication between your frontend and backend applications.
     * <br/><br/>This feature is currently in Beta.
     * @param message - The message object to send.
     * @returns A voice event sid that uniquely identifies the message that was sent.
     */ Call.prototype.sendMessage = function(message) {
        this._log.debug(".sendMessage", JSON.stringify(message));
        var content = message.content, contentType = message.contentType, messageType = message.messageType;
        if (typeof content === "undefined" || content === null) throw new $dmfT0.InvalidArgumentError("`content` is empty");
        if (typeof messageType !== "string") throw new $dmfT0.InvalidArgumentError("`messageType` must be a string.");
        if (messageType.length === 0) throw new $dmfT0.InvalidArgumentError("`messageType` must be a non-empty string.");
        if (this._pstream === null) throw new $dmfT0.InvalidStateError("Could not send CallMessage; Signaling channel is disconnected");
        var callSid = this.parameters.CallSid;
        if (typeof this.parameters.CallSid === "undefined") throw new $dmfT0.InvalidStateError("Could not send CallMessage; Call has no CallSid");
        var voiceEventSid = this._voiceEventSidGenerator();
        this._messages.set(voiceEventSid, {
            content: content,
            contentType: contentType,
            messageType: messageType,
            voiceEventSid: voiceEventSid
        });
        this._pstream.sendMessage(callSid, content, contentType, messageType, voiceEventSid);
        return voiceEventSid;
    };
    /**
     * Get the current {@link Call} status.
     */ Call.prototype.status = function() {
        return this._status;
    };
    /**
     * Check the volume passed, emitting a warning if one way audio is detected or cleared.
     * @param currentVolume - The current volume for this direction
     * @param streakFieldName - The name of the field on the {@link Call} object that tracks how many times the
     *   current value has been repeated consecutively.
     * @param lastValueFieldName - The name of the field on the {@link Call} object that tracks the most recent
     *   volume for this direction
     * @param direction - The directionality of this audio track, either 'input' or 'output'
     * @returns The current streak; how many times in a row the same value has been polled.
     */ Call.prototype._checkVolume = function(currentVolume, currentStreak, lastValue, direction) {
        var wasWarningRaised = currentStreak >= 10;
        var newStreak = 0;
        if (lastValue === currentVolume) newStreak = currentStreak;
        if (newStreak >= 10) this._emitWarning("audio-level-", "constant-audio-" + direction + "-level", 10, newStreak, false);
        else if (wasWarningRaised) this._emitWarning("audio-level-", "constant-audio-" + direction + "-level", 10, newStreak, true);
        return newStreak;
    };
    /**
     * Clean up event listeners.
     */ Call.prototype._cleanupEventListeners = function() {
        var _this = this;
        var cleanup = function() {
            if (!_this._pstream) return;
            _this._pstream.removeListener("ack", _this._onAck);
            _this._pstream.removeListener("answer", _this._onAnswer);
            _this._pstream.removeListener("cancel", _this._onCancel);
            _this._pstream.removeListener("error", _this._onSignalingError);
            _this._pstream.removeListener("hangup", _this._onHangup);
            _this._pstream.removeListener("ringing", _this._onRinging);
            _this._pstream.removeListener("transportClose", _this._onTransportClose);
            _this._pstream.removeListener("connected", _this._onConnected);
            _this._pstream.removeListener("message", _this._onMessageReceived);
        };
        // This is kind of a hack, but it lets us avoid rewriting more code.
        // Basically, there's a sequencing problem with the way PeerConnection raises
        // the
        //
        //   Cannot establish call. SDK is disconnected
        //
        // error in Call#accept. It calls PeerConnection#onerror, which emits
        // the error event on Call. An error handler on Call then calls
        // cleanupEventListeners, but then control returns to Call#accept. It's
        // at this point that we add a listener for the answer event that never gets
        // removed. setTimeout will allow us to rerun cleanup again, _after_
        // Call#accept returns.
        cleanup();
        setTimeout(cleanup, 0);
    };
    /**
     * Create the payload wrapper for a batch of metrics to be sent to Insights.
     */ Call.prototype._createMetricPayload = function() {
        var payload = {
            call_sid: this.parameters.CallSid,
            dscp: !!this._options.dscp,
            sdk_version: $k4N4t.RELEASE_VERSION
        };
        if (this._options.gateway) payload.gateway = this._options.gateway;
        payload.direction = this._direction;
        return payload;
    };
    /**
     * Disconnect the {@link Call}.
     * @param message - A message explaining why the {@link Call} is being disconnected.
     * @param wasRemote - Whether the disconnect was triggered locally or remotely.
     */ Call.prototype._disconnect = function(message, wasRemote) {
        message = typeof message === "string" ? message : null;
        if (this._status !== Call.State.Open && this._status !== Call.State.Connecting && this._status !== Call.State.Reconnecting && this._status !== Call.State.Ringing) return;
        this._log.info("Disconnecting...");
        // send pstream hangup message
        if (this._pstream !== null && this._pstream.status !== "disconnected" && this._shouldSendHangup) {
            var callsid = this.parameters.CallSid || this.outboundConnectionId;
            if (callsid) this._pstream.hangup(callsid, message);
        }
        this._cleanupEventListeners();
        this._mediaHandler.close();
        if (!wasRemote) this._publisher.info("connection", "disconnected-by-local", null, this);
    };
    /**
     * Transition to {@link CallStatus.Open} if criteria is met.
     */ Call.prototype._maybeTransitionToOpen = function() {
        var wasConnected = this._wasConnected;
        if (this._isAnswered) {
            this._onSignalingReconnected();
            this._signalingStatus = Call.State.Open;
            if (this._mediaHandler && this._mediaHandler.status === "open") {
                this._status = Call.State.Open;
                if (!this._wasConnected) {
                    this._wasConnected = true;
                    this._log.debug("#accept");
                    this.emit("accept", this);
                }
            }
        }
    };
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has ignored a request for feedback.
     */ Call.prototype._postFeedbackDeclined = function() {
        return this._publisher.info("feedback", "received-none", null, this, true);
    };
    /**
     * Publish the current set of queued metrics samples to Insights.
     */ Call.prototype._publishMetrics = function() {
        var _this = this;
        if (this._metricsSamples.length === 0) return;
        this._publisher.postMetrics("quality-metrics-samples", "metrics-sample", this._metricsSamples.splice(0), this._createMetricPayload(), this).catch(function(e) {
            _this._log.warn("Unable to post metrics to Insights. Received error:", e);
        });
    };
    /**
     * Set the CallSid
     * @param payload
     */ Call.prototype._setCallSid = function(payload) {
        var callSid = payload.callsid;
        if (!callSid) return;
        this.parameters.CallSid = callSid;
        this._mediaHandler.callSid = callSid;
    };
    /**
     * String representation of the {@link Call} class.
     * @private
     */ Call.toString = function() {
        return "[Twilio.Call class]";
    };
    return Call;
}($11OXI.EventEmitter);
(function(Call) {
    /**
     * Possible states of the {@link Call}.
     */ var State;
    (function(State) {
        State["Closed"] = "closed";
        State["Connecting"] = "connecting";
        State["Open"] = "open";
        State["Pending"] = "pending";
        State["Reconnecting"] = "reconnecting";
        State["Ringing"] = "ringing";
    })(State = Call.State || (Call.State = {}));
    /**
     * Different issues that may have been experienced during a call, that can be
     * reported to Twilio Insights via {@link Call}.postFeedback().
     */ var FeedbackIssue;
    (function(FeedbackIssue) {
        FeedbackIssue["AudioLatency"] = "audio-latency";
        FeedbackIssue["ChoppyAudio"] = "choppy-audio";
        FeedbackIssue["DroppedCall"] = "dropped-call";
        FeedbackIssue["Echo"] = "echo";
        FeedbackIssue["NoisyCall"] = "noisy-call";
        FeedbackIssue["OneWayAudio"] = "one-way-audio";
    })(FeedbackIssue = Call.FeedbackIssue || (Call.FeedbackIssue = {}));
    /**
     * A rating of call quality experienced during a call, to be reported to Twilio Insights
     * via {@link Call}.postFeedback().
     */ var FeedbackScore;
    (function(FeedbackScore) {
        FeedbackScore[FeedbackScore["One"] = 1] = "One";
        FeedbackScore[FeedbackScore["Two"] = 2] = "Two";
        FeedbackScore[FeedbackScore["Three"] = 3] = "Three";
        FeedbackScore[FeedbackScore["Four"] = 4] = "Four";
        FeedbackScore[FeedbackScore["Five"] = 5] = "Five";
    })(FeedbackScore = Call.FeedbackScore || (Call.FeedbackScore = {}));
    /**
     * The directionality of the {@link Call}, whether incoming or outgoing.
     */ var CallDirection;
    (function(CallDirection) {
        CallDirection["Incoming"] = "INCOMING";
        CallDirection["Outgoing"] = "OUTGOING";
    })(CallDirection = Call.CallDirection || (Call.CallDirection = {}));
    /**
     * Valid audio codecs to use for the media connection.
     */ var Codec;
    (function(Codec) {
        Codec["Opus"] = "opus";
        Codec["PCMU"] = "pcmu";
    })(Codec = Call.Codec || (Call.Codec = {}));
    /**
     * Possible ICE Gathering failures
     */ var IceGatheringFailureReason;
    (function(IceGatheringFailureReason) {
        IceGatheringFailureReason["None"] = "none";
        IceGatheringFailureReason["Timeout"] = "timeout";
    })(IceGatheringFailureReason = Call.IceGatheringFailureReason || (Call.IceGatheringFailureReason = {}));
    /**
     * Possible media failures
     */ var MediaFailure;
    (function(MediaFailure) {
        MediaFailure["ConnectionDisconnected"] = "ConnectionDisconnected";
        MediaFailure["ConnectionFailed"] = "ConnectionFailed";
        MediaFailure["IceGatheringFailed"] = "IceGatheringFailed";
        MediaFailure["LowBytes"] = "LowBytes";
    })(MediaFailure = Call.MediaFailure || (Call.MediaFailure = {}));
})($d421c5c6d9b8d50a$var$Call || ($d421c5c6d9b8d50a$var$Call = {}));
function $d421c5c6d9b8d50a$var$generateTempCallSid() {
    return "TJSxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* tslint:disable:no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* tslint:enable:no-bitwise */ return v.toString(16);
    });
}
module.exports.default = $d421c5c6d9b8d50a$var$Call;

});
parcelRegister("11OXI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $0bfd6a77e39eae31$var$R = typeof Reflect === "object" ? Reflect : null;
var $0bfd6a77e39eae31$var$ReflectApply = $0bfd6a77e39eae31$var$R && typeof $0bfd6a77e39eae31$var$R.apply === "function" ? $0bfd6a77e39eae31$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $0bfd6a77e39eae31$var$ReflectOwnKeys;
if ($0bfd6a77e39eae31$var$R && typeof $0bfd6a77e39eae31$var$R.ownKeys === "function") $0bfd6a77e39eae31$var$ReflectOwnKeys = $0bfd6a77e39eae31$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $0bfd6a77e39eae31$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $0bfd6a77e39eae31$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $0bfd6a77e39eae31$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $0bfd6a77e39eae31$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $0bfd6a77e39eae31$var$EventEmitter() {
    $0bfd6a77e39eae31$var$EventEmitter.init.call(this);
}
module.exports = $0bfd6a77e39eae31$var$EventEmitter;
module.exports.once = $0bfd6a77e39eae31$var$once;
// Backwards-compat with node 0.10.x
$0bfd6a77e39eae31$var$EventEmitter.EventEmitter = $0bfd6a77e39eae31$var$EventEmitter;
$0bfd6a77e39eae31$var$EventEmitter.prototype._events = undefined;
$0bfd6a77e39eae31$var$EventEmitter.prototype._eventsCount = 0;
$0bfd6a77e39eae31$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $0bfd6a77e39eae31$var$defaultMaxListeners = 10;
function $0bfd6a77e39eae31$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($0bfd6a77e39eae31$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $0bfd6a77e39eae31$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $0bfd6a77e39eae31$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $0bfd6a77e39eae31$var$defaultMaxListeners = arg;
    }
});
$0bfd6a77e39eae31$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$0bfd6a77e39eae31$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $0bfd6a77e39eae31$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $0bfd6a77e39eae31$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $0bfd6a77e39eae31$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $0bfd6a77e39eae31$var$_getMaxListeners(this);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $0bfd6a77e39eae31$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $0bfd6a77e39eae31$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$0bfd6a77e39eae31$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $0bfd6a77e39eae31$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $0bfd6a77e39eae31$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $0bfd6a77e39eae31$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $0bfd6a77e39eae31$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $0bfd6a77e39eae31$var$_addListener(this, type, listener, false);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.on = $0bfd6a77e39eae31$var$EventEmitter.prototype.addListener;
$0bfd6a77e39eae31$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $0bfd6a77e39eae31$var$_addListener(this, type, listener, true);
};
function $0bfd6a77e39eae31$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $0bfd6a77e39eae31$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $0bfd6a77e39eae31$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.once = function once(type, listener) {
    $0bfd6a77e39eae31$var$checkListener(listener);
    this.on(type, $0bfd6a77e39eae31$var$_onceWrap(this, type, listener));
    return this;
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $0bfd6a77e39eae31$var$checkListener(listener);
    this.prependListener(type, $0bfd6a77e39eae31$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$0bfd6a77e39eae31$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $0bfd6a77e39eae31$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $0bfd6a77e39eae31$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.off = $0bfd6a77e39eae31$var$EventEmitter.prototype.removeListener;
$0bfd6a77e39eae31$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $0bfd6a77e39eae31$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $0bfd6a77e39eae31$var$unwrapListeners(evlistener) : $0bfd6a77e39eae31$var$arrayClone(evlistener, evlistener.length);
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $0bfd6a77e39eae31$var$_listeners(this, type, true);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $0bfd6a77e39eae31$var$_listeners(this, type, false);
};
$0bfd6a77e39eae31$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $0bfd6a77e39eae31$var$listenerCount.call(emitter, type);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.listenerCount = $0bfd6a77e39eae31$var$listenerCount;
function $0bfd6a77e39eae31$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $0bfd6a77e39eae31$var$ReflectOwnKeys(this._events) : [];
};
function $0bfd6a77e39eae31$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $0bfd6a77e39eae31$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $0bfd6a77e39eae31$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $0bfd6a77e39eae31$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $0bfd6a77e39eae31$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $0bfd6a77e39eae31$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("4sGX5", function(module, exports) {
"use strict";
var $33fb184fd4e2bd63$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");
var $33fb184fd4e2bd63$var$Backoff = /** @class */ function(_super) {
    $33fb184fd4e2bd63$var$__extends(Backoff, _super);
    /**
     * Construct a {@link Backoff}.
     * @param {object} options
     * @property {number} min - Initial timeout in milliseconds [100]
     * @property {number} max - Max timeout [10000]
     * @property {boolean} jitter - Apply jitter [0]
     * @property {number} factor - Multiplication factor for Backoff operation [2]
     */ function Backoff(options) {
        var _this = _super.call(this) || this;
        Object.defineProperties(_this, {
            _attempts: {
                value: 0,
                writable: true
            },
            _duration: {
                enumerable: false,
                get: function() {
                    var ms = this._min * Math.pow(this._factor, this._attempts);
                    if (this._jitter) {
                        var rand = Math.random();
                        var deviation = Math.floor(rand * this._jitter * ms);
                        // tslint:disable-next-line
                        ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
                    }
                    // tslint:disable-next-line
                    return Math.min(ms, this._max) | 0;
                }
            },
            _factor: {
                value: options.factor || 2
            },
            _jitter: {
                value: options.jitter > 0 && options.jitter <= 1 ? options.jitter : 0
            },
            _max: {
                value: options.max || 10000
            },
            _min: {
                value: options.min || 100
            },
            _timeoutID: {
                value: null,
                writable: true
            }
        });
        return _this;
    }
    Backoff.prototype.backoff = function() {
        var _this = this;
        var duration = this._duration;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
        this.emit("backoff", this._attempts, duration);
        this._timeoutID = setTimeout(function() {
            _this.emit("ready", _this._attempts, duration);
            _this._attempts++;
        }, duration);
    };
    Backoff.prototype.reset = function() {
        this._attempts = 0;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
    };
    return Backoff;
}($11OXI.EventEmitter);
module.exports.default = $33fb184fd4e2bd63$var$Backoff;

});

parcelRegister("fewY1", function(module, exports) {
"use strict";
var $b171bc6ab63df54e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b171bc6ab63df54e$var$__assign = module.exports && module.exports.__assign || function() {
    $b171bc6ab63df54e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b171bc6ab63df54e$var$__assign.apply(this, arguments);
};
var $b171bc6ab63df54e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b171bc6ab63df54e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $iR2W5 = parcelRequire("iR2W5");

var $7gvm7 = parcelRequire("7gvm7");

var $lworL = parcelRequire("lworL");

var $idaJZ = parcelRequire("idaJZ");

var $k4N4t = parcelRequire("k4N4t");

var $ewpvH = parcelRequire("ewpvH");

var $dmfT0 = parcelRequire("dmfT0");

var $7Bu6L = parcelRequire("7Bu6L");

var $8RS9P = parcelRequire("8RS9P");

var $bFCWZ = parcelRequire("bFCWZ");

var $3HdIH = parcelRequire("3HdIH");

var $cu2BD = parcelRequire("cu2BD");

var $5Qlbh = parcelRequire("5Qlbh");

var $bnoro = parcelRequire("bnoro");

var $gnRnx = parcelRequire("gnRnx");

var $f8R8g = parcelRequire("f8R8g");

var $c5BfP = parcelRequire("c5BfP");
var $b171bc6ab63df54e$var$REGISTRATION_INTERVAL = 30000;
var $b171bc6ab63df54e$var$RINGTONE_PLAY_TIMEOUT = 2000;
var $b171bc6ab63df54e$var$PUBLISHER_PRODUCT_NAME = "twilio-js-sdk";
var $b171bc6ab63df54e$var$INVALID_TOKEN_MESSAGE = 'Parameter "token" must be of type "string".';
/**
 * Twilio Device. Allows registration for incoming calls, and placing outgoing calls.
 * @publicapi
 */ var $b171bc6ab63df54e$var$Device = /** @class */ function(_super) {
    $b171bc6ab63df54e$var$__extends(Device, _super);
    /**
     * Construct a {@link Device} instance. The {@link Device} can be registered
     * to make and listen for calls using {@link Device.register}.
     * @constructor
     * @param options
     */ function Device(token, options) {
        var _a;
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The currently active {@link Call}, if there is one.
         */ _this._activeCall = null;
        /**
         * The AudioHelper instance associated with this {@link Device}.
         */ _this._audio = null;
        /**
         * The AudioProcessorEventObserver instance to use
         */ _this._audioProcessorEventObserver = null;
        /**
         * An audio input MediaStream to pass to new {@link Call} instances.
         */ _this._callInputStream = null;
        /**
         * An array of {@link Call}s. Though only one can be active, multiple may exist when there
         * are multiple incoming, unanswered {@link Call}s.
         */ _this._calls = [];
        /**
         * An array of {@link Device} IDs to be used to play sounds through, to be passed to
         * new {@link Call} instances.
         */ _this._callSinkIds = [
            "default"
        ];
        /**
         * The list of chunder URIs that will be passed to PStream
         */ _this._chunderURIs = [];
        /**
         * Default options used by {@link Device}.
         */ _this._defaultOptions = {
            allowIncomingWhileBusy: false,
            closeProtection: false,
            codecPreferences: [
                $idaJZ.default.Codec.PCMU,
                $idaJZ.default.Codec.Opus
            ],
            dscp: true,
            enableImprovedSignalingErrorPrecision: false,
            forceAggressiveIceNomination: false,
            logLevel: $iR2W5.levels.ERROR,
            maxCallSignalingTimeoutMs: 0,
            preflight: false,
            sounds: {},
            tokenRefreshMs: 10000,
            voiceEventSidGenerator: $c5BfP.generateVoiceEventSid
        };
        /**
         * The name of the edge the {@link Device} is connected to.
         */ _this._edge = null;
        /**
         * The name of the home region the {@link Device} is connected to.
         */ _this._home = null;
        /**
         * The identity associated with this Device.
         */ _this._identity = null;
        /**
         * An instance of Logger to use.
         */ _this._log = new $8RS9P.default("Device");
        /**
         * The internal promise created when calling {@link Device.makeCall}.
         */ _this._makeCallPromise = null;
        /**
         * The options passed to {@link Device} constructor or {@link Device.updateOptions}.
         */ _this._options = {};
        /**
         * The preferred URI to (re)-connect signaling to.
         */ _this._preferredURI = null;
        /**
         * An Insights Event Publisher.
         */ _this._publisher = null;
        /**
         * The region the {@link Device} is connected to.
         */ _this._region = null;
        /**
         * A timeout ID for a setTimeout schedule to re-register the {@link Device}.
         */ _this._regTimer = null;
        /**
         * Boolean representing whether or not the {@link Device} was registered when
         * receiving a signaling `offline`. Determines if the {@link Device} attempts
         * a `re-register` once signaling is re-established when receiving a
         * `connected` event from the stream.
         */ _this._shouldReRegister = false;
        /**
         * A Map of Sounds to play.
         */ _this._soundcache = new Map();
        /**
         * The current status of the {@link Device}.
         */ _this._state = Device.State.Unregistered;
        /**
         * A map from {@link Device.State} to {@link Device.EventName}.
         */ _this._stateEventMapping = (_a = {}, _a[Device.State.Destroyed] = Device.EventName.Destroyed, _a[Device.State.Unregistered] = Device.EventName.Unregistered, _a[Device.State.Registering] = Device.EventName.Registering, _a[Device.State.Registered] = Device.EventName.Registered, _a);
        /**
         * The Signaling stream.
         */ _this._stream = null;
        /**
         * A promise that will resolve when the Signaling stream is ready.
         */ _this._streamConnectedPromise = null;
        /**
         * A timeout to track when the current AccessToken will expire.
         */ _this._tokenWillExpireTimeout = null;
        /**
         * Create the default Insights payload
         * @param call
         */ _this._createDefaultPayload = function(call) {
            var payload = {
                aggressive_nomination: _this._options.forceAggressiveIceNomination,
                browser_extension: _this._isBrowserExtension,
                dscp: !!_this._options.dscp,
                ice_restart_enabled: true,
                platform: $5Qlbh.getMediaEngine(),
                sdk_version: $k4N4t.RELEASE_VERSION
            };
            function setIfDefined(propertyName, value) {
                if (value) payload[propertyName] = value;
            }
            if (call) {
                var callSid = call.parameters.CallSid;
                setIfDefined("call_sid", /^TJ/.test(callSid) ? undefined : callSid);
                setIfDefined("temp_call_sid", call.outboundConnectionId);
                setIfDefined("audio_codec", call.codec);
                payload.direction = call.direction;
            }
            setIfDefined("gateway", _this._stream && _this._stream.gateway);
            setIfDefined("region", _this._stream && _this._stream.region);
            return payload;
        };
        /**
         * Called when a 'close' event is received from the signaling stream.
         */ _this._onSignalingClose = function() {
            _this._stream = null;
            _this._streamConnectedPromise = null;
        };
        /**
         * Called when a 'connected' event is received from the signaling stream.
         */ _this._onSignalingConnected = function(payload) {
            var _a;
            var region = $cu2BD.getRegionShortcode(payload.region);
            _this._edge = payload.edge || $cu2BD.regionToEdge[region] || payload.region;
            _this._region = region || payload.region;
            _this._home = payload.home;
            (_a = _this._publisher) === null || _a === void 0 || _a.setHost($cu2BD.createEventGatewayURI(payload.home));
            if (payload.token) {
                _this._identity = payload.token.identity;
                if (typeof payload.token.ttl === "number" && typeof _this._options.tokenRefreshMs === "number") {
                    var ttlMs = payload.token.ttl * 1000;
                    var timeoutMs = Math.max(0, ttlMs - _this._options.tokenRefreshMs);
                    _this._tokenWillExpireTimeout = setTimeout(function() {
                        _this._log.debug("#tokenWillExpire");
                        _this.emit("tokenWillExpire", _this);
                        if (_this._tokenWillExpireTimeout) {
                            clearTimeout(_this._tokenWillExpireTimeout);
                            _this._tokenWillExpireTimeout = null;
                        }
                    }, timeoutMs);
                }
            }
            var preferredURIs = $cu2BD.getChunderURIs(_this._edge);
            if (preferredURIs.length > 0) {
                var preferredURI = preferredURIs[0];
                _this._preferredURI = $cu2BD.createSignalingEndpointURL(preferredURI);
            } else _this._log.warn("Could not parse a preferred URI from the stream#connected event.");
            // The signaling stream emits a `connected` event after reconnection, if the
            // device was registered before this, then register again.
            if (_this._shouldReRegister) _this.register();
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ _this._onSignalingError = function(payload) {
            if (typeof payload !== "object") {
                _this._log.warn("Invalid signaling error payload", payload);
                return;
            }
            var originalError = payload.error, callsid = payload.callsid, voiceeventsid = payload.voiceeventsid;
            // voiceeventsid is for call message events which are handled in the call object
            // missing originalError shouldn't be possible but check here to fail properly
            if (typeof originalError !== "object" || !!voiceeventsid) {
                _this._log.warn("Ignoring signaling error payload", {
                    originalError: originalError,
                    voiceeventsid: voiceeventsid
                });
                return;
            }
            var call = typeof callsid === "string" && _this._findCall(callsid) || undefined;
            var code = originalError.code, customMessage = originalError.message;
            var twilioError = originalError.twilioError;
            if (typeof code === "number") {
                if (code === 31201) twilioError = new $dmfT0.AuthorizationErrors.AuthenticationFailed(originalError);
                else if (code === 31204) twilioError = new $dmfT0.AuthorizationErrors.AccessTokenInvalid(originalError);
                else if (code === 31205) {
                    // Stop trying to register presence after token expires
                    _this._stopRegistrationTimer();
                    twilioError = new $dmfT0.AuthorizationErrors.AccessTokenExpired(originalError);
                } else {
                    var errorConstructor = $dmfT0.getPreciseSignalingErrorByCode(!!_this._options.enableImprovedSignalingErrorPrecision, code);
                    if (typeof errorConstructor !== "undefined") twilioError = new errorConstructor(originalError);
                }
            }
            if (!twilioError) {
                _this._log.error("Unknown signaling error: ", originalError);
                twilioError = new $dmfT0.GeneralErrors.UnknownError(customMessage, originalError);
            }
            _this._log.error("Received error: ", twilioError);
            _this._log.debug("#error", originalError);
            _this.emit(Device.EventName.Error, twilioError, call);
        };
        /**
         * Called when an 'invite' event is received from the signaling stream.
         */ _this._onSignalingInvite = function(payload) {
            return $b171bc6ab63df54e$var$__awaiter(_this, void 0, void 0, function() {
                var wasBusy, callParameters, customParameters, call, play;
                var _this = this;
                var _a;
                return $b171bc6ab63df54e$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            wasBusy = !!this._activeCall;
                            if (wasBusy && !this._options.allowIncomingWhileBusy) {
                                this._log.info("Device busy; ignoring incoming invite");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            if (!payload.callsid || !payload.sdp) {
                                this._log.debug("#error", payload);
                                this.emit(Device.EventName.Error, new $dmfT0.ClientErrors.BadRequest("Malformed invite from gateway"));
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            callParameters = payload.parameters || {};
                            callParameters.CallSid = callParameters.CallSid || payload.callsid;
                            customParameters = Object.assign({}, $f8R8g.queryToJson(callParameters.Params));
                            this._makeCallPromise = this._makeCall(customParameters, {
                                callParameters: callParameters,
                                enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                                offerSdp: payload.sdp,
                                reconnectToken: payload.reconnect,
                                voiceEventSidGenerator: this._options.voiceEventSidGenerator
                            });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this._makeCallPromise
                            ];
                        case 2:
                            call = _b.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            this._makeCallPromise = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            this._calls.push(call);
                            call.once("accept", function() {
                                _this._soundcache.get(Device.SoundName.Incoming).stop();
                                _this._publishNetworkChange();
                            });
                            play = ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.incoming()) && !wasBusy ? function() {
                                return _this._soundcache.get(Device.SoundName.Incoming).play();
                            } : function() {
                                return Promise.resolve();
                            };
                            this._showIncomingCall(call, play);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        /**
         * Called when an 'offline' event is received from the signaling stream.
         */ _this._onSignalingOffline = function() {
            _this._log.info("Stream is offline");
            _this._edge = null;
            _this._region = null;
            _this._shouldReRegister = _this.state !== Device.State.Unregistered;
            _this._setState(Device.State.Unregistered);
        };
        /**
         * Called when a 'ready' event is received from the signaling stream.
         */ _this._onSignalingReady = function() {
            _this._log.info("Stream is ready");
            _this._setState(Device.State.Registered);
        };
        /**
         * Publish a NetworkInformation#change event to Insights if there's an active {@link Call}.
         */ _this._publishNetworkChange = function() {
            if (!_this._activeCall) return;
            if (_this._networkInformation) _this._publisher.info("network-information", "network-change", {
                connection_type: _this._networkInformation.type,
                downlink: _this._networkInformation.downlink,
                downlinkMax: _this._networkInformation.downlinkMax,
                effective_type: _this._networkInformation.effectiveType,
                rtt: _this._networkInformation.rtt
            }, _this._activeCall);
        };
        /**
         * Update the input stream being used for calls so that any current call and all future calls
         * will use the new input stream.
         * @param inputStream
         */ _this._updateInputStream = function(inputStream) {
            var call = _this._activeCall;
            if (call && !inputStream) return Promise.reject(new $dmfT0.InvalidStateError("Cannot unset input device while a call is in progress."));
            _this._callInputStream = inputStream;
            return call ? call._setInputTracksFromStream(inputStream) : Promise.resolve();
        };
        /**
         * Update the device IDs of output devices being used to play sounds through.
         * @param type - Whether to update ringtone or speaker sounds
         * @param sinkIds - An array of device IDs
         */ _this._updateSinkIds = function(type, sinkIds) {
            var promise = type === "ringtone" ? _this._updateRingtoneSinkIds(sinkIds) : _this._updateSpeakerSinkIds(sinkIds);
            return promise.then(function() {
                _this._publisher.info("audio", type + "-devices-set", {
                    audio_device_ids: sinkIds
                }, _this._activeCall);
            }, function(error) {
                _this._publisher.error("audio", type + "-devices-set-failed", {
                    audio_device_ids: sinkIds,
                    message: error.message
                }, _this._activeCall);
                throw error;
            });
        };
        // Setup loglevel asap to avoid missed logs
        _this._setupLoglevel(options.logLevel);
        _this._logOptions("constructor", options);
        _this.updateToken(token);
        if ($f8R8g.isLegacyEdge()) throw new $dmfT0.NotSupportedError("Microsoft Edge Legacy (https://support.microsoft.com/en-us/help/4533505/what-is-microsoft-edge-legacy) is deprecated and will not be able to connect to Twilio to make or receive calls after September 1st, 2020. Please see this documentation for a list of supported browsers https://www.twilio.com/docs/voice/client/javascript#supported-browsers");
        if (!Device.isSupported && options.ignoreBrowserSupport) {
            if (window && window.location && window.location.protocol === "http:") throw new $dmfT0.NotSupportedError("twilio.js wasn't able to find WebRTC browser support.           This is most likely because this page is served over http rather than https,           which does not support WebRTC in many browsers. Please load this page over https and           try again.");
            throw new $dmfT0.NotSupportedError("twilio.js 1.3+ SDKs require WebRTC browser support.         For more information, see <https://www.twilio.com/docs/api/client/twilio-js>.         If you have any questions about this announcement, please contact         Twilio Support at <help@twilio.com>.");
        }
        var root = globalThis;
        var browser = root.msBrowser || root.browser || root.chrome;
        _this._isBrowserExtension = !!browser && !!browser.runtime && !!browser.runtime.id || !!root.safari && !!root.safari.extension;
        if (_this._isBrowserExtension) _this._log.info("Running as browser extension.");
        if (navigator) {
            var n = navigator;
            _this._networkInformation = n.connection || n.mozConnection || n.webkitConnection;
        }
        if (_this._networkInformation && typeof _this._networkInformation.addEventListener === "function") _this._networkInformation.addEventListener("change", _this._publishNetworkChange);
        Device._getOrCreateAudioContext();
        if (Device._audioContext) {
            if (!Device._dialtonePlayer) Device._dialtonePlayer = new $ewpvH.default(Device._audioContext);
        }
        if (typeof Device._isUnifiedPlanDefault === "undefined") Device._isUnifiedPlanDefault = typeof window !== "undefined" && typeof RTCPeerConnection !== "undefined" && typeof RTCRtpTransceiver !== "undefined" ? $f8R8g.isUnifiedPlanDefault(window, window.navigator, RTCPeerConnection, RTCRtpTransceiver) : false;
        _this._boundDestroy = _this.destroy.bind(_this);
        _this._boundConfirmClose = _this._confirmClose.bind(_this);
        if (typeof window !== "undefined" && window.addEventListener) {
            window.addEventListener("unload", _this._boundDestroy);
            window.addEventListener("pagehide", _this._boundDestroy);
        }
        _this.updateOptions(options);
        return _this;
    }
    Object.defineProperty(Device, "audioContext", {
        /**
         * The AudioContext to be used by {@link Device} instances.
         * @private
         */ get: function() {
            return Device._audioContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "extension", {
        /**
         * Which sound file extension is supported.
         * @private
         */ get: function() {
            // NOTE(mroberts): Node workaround.
            var a = typeof document !== "undefined" ? document.createElement("audio") : {
                canPlayType: false
            };
            var canPlayMp3;
            try {
                canPlayMp3 = a.canPlayType && !!a.canPlayType("audio/mpeg").replace(/no/, "");
            } catch (e) {
                canPlayMp3 = false;
            }
            var canPlayVorbis;
            try {
                canPlayVorbis = a.canPlayType && !!a.canPlayType("audio/ogg;codecs='vorbis'").replace(/no/, "");
            } catch (e) {
                canPlayVorbis = false;
            }
            return canPlayVorbis && !canPlayMp3 ? "ogg" : "mp3";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "isSupported", {
        /**
         * Whether or not this SDK is supported by the current browser.
         */ get: function() {
            return $5Qlbh.enabled();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "packageName", {
        /**
         * Package name of the SDK.
         */ get: function() {
            return $k4N4t.PACKAGE_NAME;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Run some tests to identify issues, if any, prohibiting successful calling.
     * @param token - A Twilio JWT token string
     * @param options
     */ Device.runPreflight = function(token, options) {
        return new $bFCWZ.PreflightTest(token, $b171bc6ab63df54e$var$__assign({
            audioContext: Device._getOrCreateAudioContext()
        }, options));
    };
    /**
     * String representation of {@link Device} class.
     * @private
     */ Device.toString = function() {
        return "[Twilio.Device class]";
    };
    Object.defineProperty(Device, "version", {
        /**
         * Current SDK version.
         */ get: function() {
            return $k4N4t.RELEASE_VERSION;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Initializes the AudioContext instance shared across the Voice SDK,
     * or returns the existing instance if one has already been initialized.
     */ Device._getOrCreateAudioContext = function() {
        if (!Device._audioContext) {
            if (typeof AudioContext !== "undefined") Device._audioContext = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Device._audioContext = new webkitAudioContext();
        }
        return Device._audioContext;
    };
    Object.defineProperty(Device.prototype, "audio", {
        /**
         * Return the {@link AudioHelper} used by this {@link Device}.
         */ get: function() {
            return this._audio;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Make an outgoing Call.
     * @param options
     */ Device.prototype.connect = function(options) {
        if (options === void 0) options = {};
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var customParameters, parameters, signalingReconnectToken, connectTokenParts, isReconnect, twimlParams, callOptions, activeCall, _a;
            return $b171bc6ab63df54e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this._log.debug(".connect", JSON.stringify(options));
                        this._throwIfDestroyed();
                        if (this._activeCall) throw new $dmfT0.InvalidStateError("A Call is already active");
                        if (options.connectToken) {
                            try {
                                connectTokenParts = JSON.parse(decodeURIComponent(atob(options.connectToken)));
                                customParameters = connectTokenParts.customParameters;
                                parameters = connectTokenParts.parameters;
                                signalingReconnectToken = connectTokenParts.signalingReconnectToken;
                            } catch (_c) {
                                throw new $dmfT0.InvalidArgumentError("Cannot parse connectToken");
                            }
                            if (!parameters || !parameters.CallSid || !signalingReconnectToken) throw new $dmfT0.InvalidArgumentError("Invalid connectToken");
                        }
                        isReconnect = false;
                        twimlParams = {};
                        callOptions = {
                            enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                            rtcConfiguration: options.rtcConfiguration,
                            voiceEventSidGenerator: this._options.voiceEventSidGenerator
                        };
                        if (signalingReconnectToken && parameters) {
                            isReconnect = true;
                            callOptions.callParameters = parameters;
                            callOptions.reconnectCallSid = parameters.CallSid;
                            callOptions.reconnectToken = signalingReconnectToken;
                            twimlParams = customParameters || twimlParams;
                        } else twimlParams = options.params || twimlParams;
                        this._makeCallPromise = this._makeCall(twimlParams, callOptions, isReconnect);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._makeCallPromise
                        ];
                    case 2:
                        activeCall = _a._activeCall = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        this._makeCallPromise = null;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        // Make sure any incoming calls are ignored
                        this._calls.splice(0).forEach(function(call) {
                            return call.ignore();
                        });
                        // Stop the incoming sound if it's playing
                        this._soundcache.get(Device.SoundName.Incoming).stop();
                        activeCall.accept({
                            rtcConstraints: options.rtcConstraints
                        });
                        this._publishNetworkChange();
                        return [
                            2 /*return*/ ,
                            activeCall
                        ];
                }
            });
        });
    };
    Object.defineProperty(Device.prototype, "calls", {
        /**
         * Return the calls that this {@link Device} is maintaining.
         */ get: function() {
            return this._calls;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy the {@link Device}, freeing references to be garbage collected.
     */ Device.prototype.destroy = function() {
        var _a;
        this._log.debug(".destroy");
        this._log.debug("Rejecting any incoming calls");
        var calls = this._calls.slice(0);
        calls.forEach(function(call) {
            return call.reject();
        });
        this.disconnectAll();
        this._stopRegistrationTimer();
        this._destroyStream();
        this._destroyPublisher();
        this._destroyAudioHelper();
        (_a = this._audioProcessorEventObserver) === null || _a === void 0 || _a.destroy();
        if (this._networkInformation && typeof this._networkInformation.removeEventListener === "function") this._networkInformation.removeEventListener("change", this._publishNetworkChange);
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("beforeunload", this._boundConfirmClose);
            window.removeEventListener("unload", this._boundDestroy);
            window.removeEventListener("pagehide", this._boundDestroy);
        }
        this._setState(Device.State.Destroyed);
        $11OXI.EventEmitter.prototype.removeAllListeners.call(this);
    };
    /**
     * Disconnect all {@link Call}s.
     */ Device.prototype.disconnectAll = function() {
        this._log.debug(".disconnectAll");
        var calls = this._calls.splice(0);
        calls.forEach(function(call) {
            return call.disconnect();
        });
        if (this._activeCall) this._activeCall.disconnect();
    };
    Object.defineProperty(Device.prototype, "edge", {
        /**
         * Returns the {@link Edge} value the {@link Device} is currently connected
         * to. The value will be `null` when the {@link Device} is offline.
         */ get: function() {
            return this._edge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "home", {
        /**
         * Returns the home value the {@link Device} is currently connected
         * to. The value will be `null` when the {@link Device} is offline.
         */ get: function() {
            return this._home;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "identity", {
        /**
         * Returns the identity associated with the {@link Device} for incoming calls. Only
         * populated when registered.
         */ get: function() {
            return this._identity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isBusy", {
        /**
         * Whether the Device is currently on an active Call.
         */ get: function() {
            return !!this._activeCall;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the `Device` to the Twilio backend, allowing it to receive calls.
     */ Device.prototype.register = function() {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this._log.debug(".register");
                        if (this.state !== Device.State.Unregistered) throw new $dmfT0.InvalidStateError('Attempt to register when device is in state "' + this.state + '". ' + ('Must be "' + Device.State.Unregistered + '".'));
                        this._shouldReRegister = false;
                        this._setState(Device.State.Registering);
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise || this._setupStream()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._sendPresence(true)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            $f8R8g.promisifyEvents(this, Device.State.Registered, Device.State.Unregistered)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(Device.prototype, "state", {
        /**
         * Get the state of this {@link Device} instance
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "token", {
        /**
         * Get the token used by this {@link Device}.
         */ get: function() {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * String representation of {@link Device} instance.
     * @private
     */ Device.prototype.toString = function() {
        return "[Twilio.Device instance]";
    };
    /**
     * Unregister the `Device` to the Twilio backend, disallowing it to receive
     * calls.
     */ Device.prototype.unregister = function() {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var stream, streamOfflinePromise;
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this._log.debug(".unregister");
                        if (this.state !== Device.State.Registered) throw new $dmfT0.InvalidStateError('Attempt to unregister when device is in state "' + this.state + '". ' + ('Must be "' + Device.State.Registered + '".'));
                        this._shouldReRegister = false;
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise
                        ];
                    case 1:
                        stream = _a.sent();
                        streamOfflinePromise = new Promise(function(resolve) {
                            stream.on("offline", resolve);
                        });
                        return [
                            4 /*yield*/ ,
                            this._sendPresence(false)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            streamOfflinePromise
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Set the options used within the {@link Device}.
     * @param options
     */ Device.prototype.updateOptions = function(options) {
        if (options === void 0) options = {};
        this._logOptions("updateOptions", options);
        if (this.state === Device.State.Destroyed) throw new $dmfT0.InvalidStateError('Attempt to "updateOptions" when device is in state "' + this.state + '".');
        this._options = $b171bc6ab63df54e$var$__assign($b171bc6ab63df54e$var$__assign($b171bc6ab63df54e$var$__assign({}, this._defaultOptions), this._options), options);
        var originalChunderURIs = new Set(this._chunderURIs);
        var chunderw = typeof this._options.chunderw === "string" ? [
            this._options.chunderw
        ] : Array.isArray(this._options.chunderw) && this._options.chunderw;
        var newChunderURIs = this._chunderURIs = (chunderw || $cu2BD.getChunderURIs(this._options.edge)).map($cu2BD.createSignalingEndpointURL);
        var hasChunderURIsChanged = originalChunderURIs.size !== newChunderURIs.length;
        if (!hasChunderURIsChanged) for(var _i = 0, newChunderURIs_1 = newChunderURIs; _i < newChunderURIs_1.length; _i++){
            var uri = newChunderURIs_1[_i];
            if (!originalChunderURIs.has(uri)) {
                hasChunderURIsChanged = true;
                break;
            }
        }
        if (this.isBusy && hasChunderURIsChanged) throw new $dmfT0.InvalidStateError("Cannot change Edge while on an active Call");
        this._setupLoglevel(this._options.logLevel);
        for(var _a = 0, _b = Object.keys(Device._defaultSounds); _a < _b.length; _a++){
            var name_1 = _b[_a];
            var soundDef = Device._defaultSounds[name_1];
            var defaultUrl = $k4N4t.SOUNDS_BASE_URL + "/" + soundDef.filename + "." + Device.extension + ("?cache=" + $k4N4t.RELEASE_VERSION);
            var soundUrl = this._options.sounds && this._options.sounds[name_1] || defaultUrl;
            var sound = new (this._options.Sound || $gnRnx.default)(name_1, soundUrl, {
                audioContext: this._options.disableAudioContextSounds ? null : Device.audioContext,
                maxDuration: soundDef.maxDuration,
                shouldLoop: soundDef.shouldLoop
            });
            this._soundcache.set(name_1, sound);
        }
        this._setupAudioHelper();
        this._setupPublisher();
        if (hasChunderURIsChanged && this._streamConnectedPromise) this._setupStream();
        // Setup close protection and make sure we clean up ongoing calls on unload.
        if (typeof window !== "undefined" && typeof window.addEventListener === "function" && this._options.closeProtection) {
            window.removeEventListener("beforeunload", this._boundConfirmClose);
            window.addEventListener("beforeunload", this._boundConfirmClose);
        }
    };
    /**
     * Update the token used by this {@link Device} to connect to Twilio.
     * It is recommended to call this API after [[Device.tokenWillExpireEvent]] is emitted,
     * and before or after a call to prevent a potential ~1s audio loss during the update process.
     * @param token
     */ Device.prototype.updateToken = function(token) {
        this._log.debug(".updateToken");
        if (this.state === Device.State.Destroyed) throw new $dmfT0.InvalidStateError('Attempt to "updateToken" when device is in state "' + this.state + '".');
        if (typeof token !== "string") throw new $dmfT0.InvalidArgumentError($b171bc6ab63df54e$var$INVALID_TOKEN_MESSAGE);
        this._token = token;
        if (this._stream) this._stream.setToken(this._token);
        if (this._publisher) this._publisher.setToken(this._token);
    };
    /**
     * Called on window's beforeunload event if closeProtection is enabled,
     * preventing users from accidentally navigating away from an active call.
     * @param event
     */ Device.prototype._confirmClose = function(event) {
        if (!this._activeCall) return "";
        var closeProtection = this._options.closeProtection || false;
        var confirmationMsg = typeof closeProtection !== "string" ? "A call is currently in-progress. Leaving or reloading this page will end the call." : closeProtection;
        (event || window.event).returnValue = confirmationMsg;
        return confirmationMsg;
    };
    /**
     * Destroy the AudioHelper.
     */ Device.prototype._destroyAudioHelper = function() {
        if (!this._audio) return;
        this._audio._destroy();
        this._audio = null;
    };
    /**
     * Destroy the publisher.
     */ Device.prototype._destroyPublisher = function() {
        // Attempt to destroy non-existent publisher.
        if (!this._publisher) return;
        this._publisher = null;
    };
    /**
     * Destroy the connection to the signaling server.
     */ Device.prototype._destroyStream = function() {
        if (this._stream) {
            this._stream.removeListener("close", this._onSignalingClose);
            this._stream.removeListener("connected", this._onSignalingConnected);
            this._stream.removeListener("error", this._onSignalingError);
            this._stream.removeListener("invite", this._onSignalingInvite);
            this._stream.removeListener("offline", this._onSignalingOffline);
            this._stream.removeListener("ready", this._onSignalingReady);
            this._stream.destroy();
            this._stream = null;
        }
        this._onSignalingOffline();
        this._streamConnectedPromise = null;
    };
    /**
     * Find a {@link Call} by its CallSid.
     * @param callSid
     */ Device.prototype._findCall = function(callSid) {
        return this._calls.find(function(call) {
            return call.parameters.CallSid === callSid || call.outboundConnectionId === callSid;
        }) || null;
    };
    /**
     * Utility function to log device options
     */ Device.prototype._logOptions = function(caller, options) {
        if (options === void 0) options = {};
        // Selectively log options that users can modify.
        // Also, convert user overrides.
        // This prevents potential app crash when calling JSON.stringify
        // and when sending log strings remotely
        var userOptions = [
            "allowIncomingWhileBusy",
            "appName",
            "appVersion",
            "closeProtection",
            "codecPreferences",
            "disableAudioContextSounds",
            "dscp",
            "edge",
            "enableImprovedSignalingErrorPrecision",
            "forceAggressiveIceNomination",
            "logLevel",
            "maxAverageBitrate",
            "maxCallSignalingTimeoutMs",
            "sounds",
            "tokenRefreshMs"
        ];
        var userOptionOverrides = [
            "RTCPeerConnection",
            "enumerateDevices",
            "getUserMedia"
        ];
        if (typeof options === "object") {
            var toLog_1 = $b171bc6ab63df54e$var$__assign({}, options);
            Object.keys(toLog_1).forEach(function(key) {
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog_1[key];
                if (userOptionOverrides.includes(key)) toLog_1[key] = true;
            });
            this._log.debug("." + caller, JSON.stringify(toLog_1));
        }
    };
    /**
     * Create a new {@link Call}.
     * @param twimlParams - A flat object containing key:value pairs to be sent to the TwiML app.
     * @param options - Options to be used to instantiate the {@link Call}.
     */ Device.prototype._makeCall = function(twimlParams, options, isReconnect) {
        var _a;
        if (isReconnect === void 0) isReconnect = false;
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var inputDevicePromise, config, maybeUnsetPreferredUri, call;
            var _b;
            var _this = this;
            return $b171bc6ab63df54e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (typeof Device._isUnifiedPlanDefault === "undefined") throw new $dmfT0.InvalidStateError("Device has not been initialized.");
                        inputDevicePromise = (_a = this._audio) === null || _a === void 0 ? void 0 : _a._getInputDevicePromise();
                        if (!inputDevicePromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._log.debug("inputDevicePromise detected, waiting...");
                        return [
                            4 /*yield*/ ,
                            inputDevicePromise
                        ];
                    case 1:
                        _c.sent();
                        this._log.debug("inputDevicePromise resolved");
                        _c.label = 2;
                    case 2:
                        _b = {
                            audioHelper: this._audio,
                            isUnifiedPlanDefault: Device._isUnifiedPlanDefault,
                            onIgnore: function() {
                                _this._soundcache.get(Device.SoundName.Incoming).stop();
                            }
                        };
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise || this._setupStream()
                        ];
                    case 3:
                        config = (_b.pstream = _c.sent(), _b.publisher = this._publisher, _b.soundcache = this._soundcache, _b);
                        options = Object.assign({
                            MediaStream: this._options.MediaStream || $5Qlbh.PeerConnection,
                            RTCPeerConnection: this._options.RTCPeerConnection,
                            beforeAccept: function(currentCall) {
                                if (!_this._activeCall || _this._activeCall === currentCall) return;
                                _this._activeCall.disconnect();
                                _this._removeCall(_this._activeCall);
                            },
                            codecPreferences: this._options.codecPreferences,
                            customSounds: this._options.sounds,
                            dialtonePlayer: Device._dialtonePlayer,
                            dscp: this._options.dscp,
                            // TODO(csantos): Remove forceAggressiveIceNomination option in 3.x
                            forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
                            getInputStream: function() {
                                return _this._options.fileInputStream || _this._callInputStream;
                            },
                            getSinkIds: function() {
                                return _this._callSinkIds;
                            },
                            maxAverageBitrate: this._options.maxAverageBitrate,
                            preflight: this._options.preflight,
                            rtcConstraints: this._options.rtcConstraints,
                            shouldPlayDisconnect: function() {
                                var _a;
                                return (_a = _this._audio) === null || _a === void 0 ? void 0 : _a.disconnect();
                            },
                            twimlParams: twimlParams,
                            voiceEventSidGenerator: this._options.voiceEventSidGenerator
                        }, options);
                        maybeUnsetPreferredUri = function() {
                            if (!_this._stream) {
                                _this._log.warn("UnsetPreferredUri called without a stream");
                                return;
                            }
                            if (_this._activeCall === null && _this._calls.length === 0) _this._stream.updatePreferredURI(null);
                        };
                        call = new (this._options.Call || $idaJZ.default)(config, options);
                        this._publisher.info("settings", "init", {
                            RTCPeerConnection: !!this._options.RTCPeerConnection,
                            enumerateDevices: !!this._options.enumerateDevices,
                            getUserMedia: !!this._options.getUserMedia
                        }, call);
                        call.once("accept", function() {
                            var _a, _b, _c;
                            _this._stream.updatePreferredURI(_this._preferredURI);
                            _this._removeCall(call);
                            _this._activeCall = call;
                            if (_this._audio) _this._audio._maybeStartPollingVolume();
                            if (call.direction === $idaJZ.default.CallDirection.Outgoing && ((_a = _this._audio) === null || _a === void 0 ? void 0 : _a.outgoing()) && !isReconnect) _this._soundcache.get(Device.SoundName.Outgoing).play();
                            var data = {
                                edge: _this._edge || _this._region
                            };
                            if (_this._options.edge) data["selected_edge"] = Array.isArray(_this._options.edge) ? _this._options.edge : [
                                _this._options.edge
                            ];
                            _this._publisher.info("settings", "edge", data, call);
                            if ((_b = _this._audio) === null || _b === void 0 ? void 0 : _b.processedStream) (_c = _this._audioProcessorEventObserver) === null || _c === void 0 || _c.emit("enabled");
                        });
                        call.addListener("error", function(error) {
                            if (call.status() === "closed") {
                                _this._removeCall(call);
                                maybeUnsetPreferredUri();
                            }
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._maybeStopIncomingSound();
                        });
                        call.once("cancel", function() {
                            _this._log.info("Canceled: " + call.parameters.CallSid);
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._maybeStopIncomingSound();
                        });
                        call.once("disconnect", function() {
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            /**
                             * NOTE(kamalbennani): We need to stop the incoming sound when the call is
                             * disconnected right after the user has accepted the call (activeCall.accept()), and before
                             * the call has been fully connected (i.e. before the `pstream.answer` event)
                             */ _this._maybeStopIncomingSound();
                        });
                        call.once("reject", function() {
                            _this._log.info("Rejected: " + call.parameters.CallSid);
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            _this._maybeStopIncomingSound();
                        });
                        call.on("transportClose", function() {
                            if (call.status() !== $idaJZ.default.State.Pending) return;
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            /**
                             * NOTE(mhuynh): We don't want to call `maybeUnsetPreferredUri` because
                             * a `transportClose` will happen during signaling reconnection.
                             */ _this._maybeStopIncomingSound();
                        });
                        return [
                            2 /*return*/ ,
                            call
                        ];
                }
            });
        });
    };
    /**
     * Stop the incoming sound if no {@link Call}s remain.
     */ Device.prototype._maybeStopIncomingSound = function() {
        if (!this._calls.length) this._soundcache.get(Device.SoundName.Incoming).stop();
    };
    /**
     * Remove a {@link Call} from device.calls by reference
     * @param call
     */ Device.prototype._removeCall = function(call) {
        if (this._activeCall === call) {
            this._activeCall = null;
            this._makeCallPromise = null;
        }
        for(var i = this._calls.length - 1; i >= 0; i--)if (call === this._calls[i]) this._calls.splice(i, 1);
    };
    /**
     * Register with the signaling server.
     */ Device.prototype._sendPresence = function(presence) {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise
                        ];
                    case 1:
                        stream = _a.sent();
                        if (!stream) return [
                            2 /*return*/ 
                        ];
                        stream.register({
                            audio: presence
                        });
                        if (presence) this._startRegistrationTimer();
                        else this._stopRegistrationTimer();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Helper function that sets and emits the state of the device.
     * @param state The new state of the device.
     */ Device.prototype._setState = function(state) {
        if (state === this.state) return;
        this._state = state;
        var name = this._stateEventMapping[state];
        this._log.debug("#" + name);
        this.emit(name);
    };
    /**
     * Set up an audio helper for usage by this {@link Device}.
     */ Device.prototype._setupAudioHelper = function() {
        var _this = this;
        if (!this._audioProcessorEventObserver) {
            this._audioProcessorEventObserver = new $lworL.AudioProcessorEventObserver();
            this._audioProcessorEventObserver.on("event", function(_a) {
                var name = _a.name, group = _a.group;
                _this._publisher.info(group, name, {}, _this._activeCall);
            });
        }
        var audioOptions = {
            audioContext: Device.audioContext,
            audioProcessorEventObserver: this._audioProcessorEventObserver,
            beforeSetInputDevice: function() {
                if (_this._makeCallPromise) {
                    _this._log.debug("beforeSetInputDevice pause detected");
                    return _this._makeCallPromise;
                } else {
                    _this._log.debug("beforeSetInputDevice pause not detected, setting default");
                    return Promise.resolve();
                }
            },
            enumerateDevices: this._options.enumerateDevices,
            getUserMedia: this._options.getUserMedia || $bnoro.default
        };
        if (this._audio) {
            this._log.info("Found existing audio helper; updating options...");
            this._audio._updateUserOptions(audioOptions);
            return;
        }
        this._audio = new (this._options.AudioHelper || $7gvm7.default)(this._updateSinkIds, this._updateInputStream, audioOptions);
        this._audio.on("deviceChange", function(lostActiveDevices) {
            var activeCall = _this._activeCall;
            var deviceIds = lostActiveDevices.map(function(device) {
                return device.deviceId;
            });
            _this._publisher.info("audio", "device-change", {
                lost_active_device_ids: deviceIds
            }, activeCall);
            if (activeCall) activeCall["_mediaHandler"]._onInputDevicesChanged();
        });
    };
    /**
     * Setup logger's loglevel
     */ Device.prototype._setupLoglevel = function(logLevel) {
        var level = typeof logLevel === "number" || typeof logLevel === "string" ? logLevel : $iR2W5.levels.ERROR;
        this._log.setDefaultLevel(level);
        this._log.info("Set logger default level to", level);
    };
    /**
     * Create and set a publisher for the {@link Device} to use.
     */ Device.prototype._setupPublisher = function() {
        var _this = this;
        if (this._publisher) {
            this._log.info("Found existing publisher; destroying...");
            this._destroyPublisher();
        }
        var publisherOptions = {
            defaultPayload: this._createDefaultPayload,
            metadata: {
                app_name: this._options.appName,
                app_version: this._options.appVersion
            }
        };
        if (this._options.eventgw) publisherOptions.host = this._options.eventgw;
        if (this._home) publisherOptions.host = $cu2BD.createEventGatewayURI(this._home);
        this._publisher = new (this._options.Publisher || $7Bu6L.default)($b171bc6ab63df54e$var$PUBLISHER_PRODUCT_NAME, this.token, publisherOptions);
        if (this._options.publishEvents === false) this._publisher.disable();
        else this._publisher.on("error", function(error) {
            _this._log.warn("Cannot connect to insights.", error);
        });
        return this._publisher;
    };
    /**
     * Set up the connection to the signaling server. Tears down an existing
     * stream if called while a stream exists.
     */ Device.prototype._setupStream = function() {
        var _this = this;
        if (this._stream) {
            this._log.info("Found existing stream; destroying...");
            this._destroyStream();
        }
        this._log.info("Setting up VSP");
        this._stream = new (this._options.PStream || $3HdIH.default)(this.token, this._chunderURIs, {
            backoffMaxMs: this._options.backoffMaxMs,
            maxPreferredDurationMs: this._options.maxCallSignalingTimeoutMs
        });
        this._stream.addListener("close", this._onSignalingClose);
        this._stream.addListener("connected", this._onSignalingConnected);
        this._stream.addListener("error", this._onSignalingError);
        this._stream.addListener("invite", this._onSignalingInvite);
        this._stream.addListener("offline", this._onSignalingOffline);
        this._stream.addListener("ready", this._onSignalingReady);
        return this._streamConnectedPromise = $f8R8g.promisifyEvents(this._stream, "connected", "close").then(function() {
            return _this._stream;
        });
    };
    /**
     * Start playing the incoming ringtone, and subsequently emit the incoming event.
     * @param call
     * @param play - The function to be used to play the sound. Must return a Promise.
     */ Device.prototype._showIncomingCall = function(call, play) {
        var _this = this;
        var timeout;
        return Promise.race([
            play(),
            new Promise(function(resolve, reject) {
                timeout = setTimeout(function() {
                    var msg = "Playing incoming ringtone took too long; it might not play. Continuing execution...";
                    reject(new Error(msg));
                }, $b171bc6ab63df54e$var$RINGTONE_PLAY_TIMEOUT);
            })
        ]).catch(function(reason) {
            _this._log.warn(reason.message);
        }).then(function() {
            clearTimeout(timeout);
            _this._log.debug("#incoming", JSON.stringify({
                customParameters: call.customParameters,
                parameters: call.parameters
            }));
            _this.emit(Device.EventName.Incoming, call);
        });
    };
    /**
     * Set a timeout to send another register message to the signaling server.
     */ Device.prototype._startRegistrationTimer = function() {
        var _this = this;
        this._stopRegistrationTimer();
        this._regTimer = setTimeout(function() {
            _this._sendPresence(true);
        }, $b171bc6ab63df54e$var$REGISTRATION_INTERVAL);
    };
    /**
     * Stop sending registration messages to the signaling server.
     */ Device.prototype._stopRegistrationTimer = function() {
        if (this._regTimer) clearTimeout(this._regTimer);
    };
    /**
     * Throw an error if the {@link Device} is destroyed.
     */ Device.prototype._throwIfDestroyed = function() {
        if (this.state === Device.State.Destroyed) throw new $dmfT0.InvalidStateError("Device has been destroyed.");
    };
    /**
     * Update the device IDs of output devices being used to play the incoming ringtone through.
     * @param sinkIds - An array of device IDs
     */ Device.prototype._updateRingtoneSinkIds = function(sinkIds) {
        return Promise.resolve(this._soundcache.get(Device.SoundName.Incoming).setSinkIds(sinkIds));
    };
    /**
     * Update the device IDs of output devices being used to play the non-ringtone sounds
     * and Call audio through.
     * @param sinkIds - An array of device IDs
     */ Device.prototype._updateSpeakerSinkIds = function(sinkIds) {
        Array.from(this._soundcache.entries()).filter(function(entry) {
            return entry[0] !== Device.SoundName.Incoming;
        }).forEach(function(entry) {
            return entry[1].setSinkIds(sinkIds);
        });
        this._callSinkIds = sinkIds;
        var call = this._activeCall;
        return call ? call._setSinkIds(sinkIds) : Promise.resolve();
    };
    Device._defaultSounds = {
        disconnect: {
            filename: "disconnect",
            maxDuration: 3000
        },
        dtmf0: {
            filename: "dtmf-0",
            maxDuration: 1000
        },
        dtmf1: {
            filename: "dtmf-1",
            maxDuration: 1000
        },
        dtmf2: {
            filename: "dtmf-2",
            maxDuration: 1000
        },
        dtmf3: {
            filename: "dtmf-3",
            maxDuration: 1000
        },
        dtmf4: {
            filename: "dtmf-4",
            maxDuration: 1000
        },
        dtmf5: {
            filename: "dtmf-5",
            maxDuration: 1000
        },
        dtmf6: {
            filename: "dtmf-6",
            maxDuration: 1000
        },
        dtmf7: {
            filename: "dtmf-7",
            maxDuration: 1000
        },
        dtmf8: {
            filename: "dtmf-8",
            maxDuration: 1000
        },
        dtmf9: {
            filename: "dtmf-9",
            maxDuration: 1000
        },
        dtmfh: {
            filename: "dtmf-hash",
            maxDuration: 1000
        },
        dtmfs: {
            filename: "dtmf-star",
            maxDuration: 1000
        },
        incoming: {
            filename: "incoming",
            shouldLoop: true
        },
        outgoing: {
            filename: "outgoing",
            maxDuration: 3000
        }
    };
    return Device;
}($11OXI.EventEmitter);
(function(Device) {
    /**
     * All valid {@link Device} event names.
     */ var EventName;
    (function(EventName) {
        EventName["Error"] = "error";
        EventName["Incoming"] = "incoming";
        EventName["Destroyed"] = "destroyed";
        EventName["Unregistered"] = "unregistered";
        EventName["Registering"] = "registering";
        EventName["Registered"] = "registered";
        EventName["TokenWillExpire"] = "tokenWillExpire";
    })(EventName = Device.EventName || (Device.EventName = {}));
    /**
     * All possible {@link Device} states.
     */ var State;
    (function(State) {
        State["Destroyed"] = "destroyed";
        State["Unregistered"] = "unregistered";
        State["Registering"] = "registering";
        State["Registered"] = "registered";
    })(State = Device.State || (Device.State = {}));
    /**
     * Names of all sounds handled by the {@link Device}.
     */ var SoundName;
    (function(SoundName) {
        SoundName["Incoming"] = "incoming";
        SoundName["Outgoing"] = "outgoing";
        SoundName["Disconnect"] = "disconnect";
        SoundName["Dtmf0"] = "dtmf0";
        SoundName["Dtmf1"] = "dtmf1";
        SoundName["Dtmf2"] = "dtmf2";
        SoundName["Dtmf3"] = "dtmf3";
        SoundName["Dtmf4"] = "dtmf4";
        SoundName["Dtmf5"] = "dtmf5";
        SoundName["Dtmf6"] = "dtmf6";
        SoundName["Dtmf7"] = "dtmf7";
        SoundName["Dtmf8"] = "dtmf8";
        SoundName["Dtmf9"] = "dtmf9";
        SoundName["DtmfS"] = "dtmfs";
        SoundName["DtmfH"] = "dtmfh";
    })(SoundName = Device.SoundName || (Device.SoundName = {}));
})($b171bc6ab63df54e$var$Device || ($b171bc6ab63df54e$var$Device = {}));
module.exports.default = $b171bc6ab63df54e$var$Device;

});
parcelRegister("iR2W5", function(module, exports) {
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === "function" && define.amd) define(definition);
    else if (0, module.exports) module.exports = definition();
    else root.log = definition();
})(module.exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === "function") return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === "debug") methodName = "log";
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === "trace" && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, "log");
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */ for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        var storageKey = "loglevel";
        if (name) storageKey += ":" + name;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || "silent").toUpperCase();
            if (typeof window === undefinedType) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            return currentLevel;
        };
        self.setLevel = function(level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) persistLevelIfPossible(level);
                replaceLoggingMethods.call(self, level, name);
                if (typeof console === undefinedType && level < self.levels.SILENT) return "No console available for logging";
            } else throw "log.setLevel() called with invalid level: " + level;
        };
        self.setDefaultLevel = function(level) {
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
        self.setLevel(initialLevel, false);
    }
    /*
     *
     * Top-level API
     *
     */ var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    return defaultLogger;
});

});

parcelRegister("7gvm7", function(module, exports) {
"use strict";
var $54a2599bd8145d0c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $54a2599bd8145d0c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $54a2599bd8145d0c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $fewY1 = parcelRequire("fewY1");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");

var $dGYKu = parcelRequire("dGYKu");

var $5d53a = parcelRequire("5d53a");

var $f8R8g = parcelRequire("f8R8g");
/**
 * Aliases for audio kinds, used for labelling.
 * @private
 */ var $54a2599bd8145d0c$var$kindAliases = {
    audioinput: "Audio Input",
    audiooutput: "Audio Output"
};
/**
 * Provides input and output audio-based functionality in one convenient class.
 * @publicapi
 */ var $54a2599bd8145d0c$var$AudioHelper = /** @class */ function(_super) {
    $54a2599bd8145d0c$var$__extends(AudioHelper, _super);
    /**
     * @constructor
     * @private
     * @param onActiveOutputsChanged - A callback to be called when the user changes the active output devices.
     * @param onActiveInputChanged - A callback to be called when the user changes the active input device.
     * @param [options]
     */ function AudioHelper(onActiveOutputsChanged, onActiveInputChanged, options) {
        var _a;
        var _this = _super.call(this) || this;
        /**
         * A Map of all audio input devices currently available to the browser by their device ID.
         */ _this.availableInputDevices = new Map();
        /**
         * A Map of all audio output devices currently available to the browser by their device ID.
         */ _this.availableOutputDevices = new Map();
        /**
         * The currently set audio constraints set by setAudioConstraints().
         */ _this._audioConstraints = null;
        /**
         * The audio stream of the default device.
         * This is populated when _openDefaultDeviceWithConstraints is called,
         * See _selectedInputDeviceStream for differences.
         * TODO: Combine these two workflows (3.x?)
         */ _this._defaultInputDeviceStream = null;
        /**
         * Whether each sound is enabled.
         */ _this._enabledSounds = (_a = {}, _a[$fewY1.default.SoundName.Disconnect] = true, _a[$fewY1.default.SoundName.Incoming] = true, _a[$fewY1.default.SoundName.Outgoing] = true, _a);
        /**
         * The current input device.
         */ _this._inputDevice = null;
        /**
         * The internal promise created when calling setInputDevice
         */ _this._inputDevicePromise = null;
        /**
         * Whether the {@link AudioHelper} is currently polling the input stream's volume.
         */ _this._isPollingInputVolume = false;
        /**
         * An instance of Logger to use.
         */ _this._log = new $8RS9P.default("AudioHelper");
        /**
         * Internal reference to the processed stream
         */ _this._processedStream = null;
        /**
         * The selected input stream coming from the microphone device.
         * This is populated when the setInputDevice is called, meaning,
         * the end user manually selected it, which is different than
         * the defaultInputDeviceStream.
         * TODO: Combine these two workflows (3.x?)
         */ _this._selectedInputDeviceStream = null;
        /**
         * A record of unknown devices (Devices without labels)
         */ _this._unknownDeviceIndexes = {
            audioinput: {},
            audiooutput: {}
        };
        /**
         * Update the available input and output devices
         * @private
         */ _this._updateAvailableDevices = function() {
            if (!_this._mediaDevices || !_this._enumerateDevices) return Promise.reject("Enumeration not supported");
            return _this._enumerateDevices().then(function(devices) {
                _this._updateDevices(devices.filter(function(d) {
                    return d.kind === "audiooutput";
                }), _this.availableOutputDevices, _this._removeLostOutput);
                _this._updateDevices(devices.filter(function(d) {
                    return d.kind === "audioinput";
                }), _this.availableInputDevices, _this._removeLostInput);
                var defaultDevice = _this.availableOutputDevices.get("default") || Array.from(_this.availableOutputDevices.values())[0];
                [
                    _this.speakerDevices,
                    _this.ringtoneDevices
                ].forEach(function(outputDevices) {
                    if (!outputDevices.get().size && _this.availableOutputDevices.size && _this.isOutputSelectionSupported) outputDevices.set(defaultDevice.deviceId).catch(function(reason) {
                        _this._log.warn("Unable to set audio output devices. " + reason);
                    });
                });
            });
        };
        /**
         * Remove an input device from inputs
         * @param lostDevice
         * @returns Whether the device was active
         */ _this._removeLostInput = function(lostDevice) {
            if (!_this.inputDevice || _this.inputDevice.deviceId !== lostDevice.deviceId) return false;
            _this._destroyProcessedStream();
            _this._replaceStream(null);
            _this._inputDevice = null;
            _this._maybeStopPollingVolume();
            var defaultDevice = _this.availableInputDevices.get("default") || Array.from(_this.availableInputDevices.values())[0];
            if (defaultDevice) _this.setInputDevice(defaultDevice.deviceId);
            return true;
        };
        /**
         * Remove an input device from outputs
         * @param lostDevice
         * @returns Whether the device was active
         */ _this._removeLostOutput = function(lostDevice) {
            var wasSpeakerLost = _this.speakerDevices.delete(lostDevice);
            var wasRingtoneLost = _this.ringtoneDevices.delete(lostDevice);
            return wasSpeakerLost || wasRingtoneLost;
        };
        options = Object.assign({
            AudioContext: typeof AudioContext !== "undefined" && AudioContext,
            setSinkId: typeof HTMLAudioElement !== "undefined" && HTMLAudioElement.prototype.setSinkId
        }, options);
        _this._beforeSetInputDevice = options.beforeSetInputDevice || function() {
            return Promise.resolve();
        };
        _this._updateUserOptions(options);
        _this._audioProcessorEventObserver = options.audioProcessorEventObserver;
        _this._mediaDevices = options.mediaDevices || navigator.mediaDevices;
        _this._onActiveInputChanged = onActiveInputChanged;
        _this._enumerateDevices = typeof options.enumerateDevices === "function" ? options.enumerateDevices : _this._mediaDevices && _this._mediaDevices.enumerateDevices.bind(_this._mediaDevices);
        var isAudioContextSupported = !!(options.AudioContext || options.audioContext);
        var isEnumerationSupported = !!_this._enumerateDevices;
        if (options.enabledSounds) _this._enabledSounds = options.enabledSounds;
        var isSetSinkSupported = typeof options.setSinkId === "function";
        _this.isOutputSelectionSupported = isEnumerationSupported && isSetSinkSupported;
        _this.isVolumeSupported = isAudioContextSupported;
        if (_this.isVolumeSupported) {
            _this._audioContext = options.audioContext || options.AudioContext && new options.AudioContext();
            if (_this._audioContext) {
                _this._inputVolumeAnalyser = _this._audioContext.createAnalyser();
                _this._inputVolumeAnalyser.fftSize = 32;
                _this._inputVolumeAnalyser.smoothingTimeConstant = 0.3;
            }
        }
        _this.ringtoneDevices = new $dGYKu.default("ringtone", _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);
        _this.speakerDevices = new $dGYKu.default("speaker", _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);
        _this.addListener("newListener", function(eventName) {
            if (eventName === "inputVolume") _this._maybeStartPollingVolume();
        });
        _this.addListener("removeListener", function(eventName) {
            if (eventName === "inputVolume") _this._maybeStopPollingVolume();
        });
        _this.once("newListener", function() {
            // NOTE (rrowland): Ideally we would only check isEnumerationSupported here, but
            //   in at least one browser version (Tested in FF48) enumerateDevices actually
            //   returns bad data for the listed devices. Instead, we check for
            //   isOutputSelectionSupported to avoid these quirks that may negatively affect customers.
            if (!_this.isOutputSelectionSupported) _this._log.warn("Warning: This browser does not support audio output selection.");
            if (!_this.isVolumeSupported) _this._log.warn("Warning: This browser does not support Twilio's volume indicator feature.");
        });
        if (isEnumerationSupported) _this._initializeEnumeration();
        // NOTE (kchoy): Currently microphone permissions are not supported in firefox, and Safari V15 and older.
        // https://github.com/mozilla/standards-positions/issues/19#issuecomment-370158947
        // https://caniuse.com/permissions-api
        if (navigator && navigator.permissions && typeof navigator.permissions.query === "function") navigator.permissions.query({
            name: "microphone"
        }).then(function(microphonePermissionStatus) {
            if (microphonePermissionStatus.state !== "granted") {
                var handleStateChange = function() {
                    _this._updateAvailableDevices();
                    _this._stopMicrophonePermissionListener();
                };
                microphonePermissionStatus.addEventListener("change", handleStateChange);
                _this._microphonePermissionStatus = microphonePermissionStatus;
                _this._onMicrophonePermissionStatusChanged = handleStateChange;
            }
        }).catch(function(reason) {
            return _this._log.warn("Warning: unable to listen for microphone permission changes. " + reason);
        });
        else _this._log.warn("Warning: current browser does not support permissions API.");
        return _this;
    }
    Object.defineProperty(AudioHelper.prototype, "audioConstraints", {
        /**
         * The currently set audio constraints set by setAudioConstraints(). Starts as null.
         */ get: function() {
            return this._audioConstraints;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "inputDevice", {
        /**
         * The active input device. Having no inputDevice specified by `setInputDevice()`
         * will disable input selection related functionality.
         */ get: function() {
            return this._inputDevice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "inputStream", {
        /**
         * The current input stream coming from the microphone device or
         * the processed audio stream if there is an {@link AudioProcessor}.
         */ get: function() {
            return this._processedStream || this._selectedInputDeviceStream;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "processedStream", {
        /**
         * The processed stream if an {@link AudioProcessor} was previously added.
         */ get: function() {
            return this._processedStream;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy this AudioHelper instance
     * @private
     */ AudioHelper.prototype._destroy = function() {
        this._stopDefaultInputDeviceStream();
        this._stopSelectedInputDeviceStream();
        this._destroyProcessedStream();
        this._maybeStopPollingVolume();
        this.removeAllListeners();
        this._stopMicrophonePermissionListener();
        this._unbind();
    };
    /**
     * Promise to wait for the input device, if setInputDevice is called outside of the SDK
     * @private
     */ AudioHelper.prototype._getInputDevicePromise = function() {
        return this._inputDevicePromise;
    };
    /**
     * Start polling volume if it's supported and there's an input stream to poll.
     * @private
     */ AudioHelper.prototype._maybeStartPollingVolume = function() {
        var _this = this;
        if (!this.isVolumeSupported || !this.inputStream) return;
        this._updateVolumeSource();
        if (this._isPollingInputVolume || !this._inputVolumeAnalyser) return;
        var bufferLength = this._inputVolumeAnalyser.frequencyBinCount;
        var buffer = new Uint8Array(bufferLength);
        this._isPollingInputVolume = true;
        var emitVolume = function() {
            if (!_this._isPollingInputVolume) return;
            if (_this._inputVolumeAnalyser) {
                _this._inputVolumeAnalyser.getByteFrequencyData(buffer);
                var inputVolume = $f8R8g.average(buffer);
                _this.emit("inputVolume", inputVolume / 255);
            }
            requestAnimationFrame(emitVolume);
        };
        requestAnimationFrame(emitVolume);
    };
    /**
     * Stop polling volume if it's currently polling and there are no listeners.
     * @private
     */ AudioHelper.prototype._maybeStopPollingVolume = function() {
        if (!this.isVolumeSupported) return;
        if (!this._isPollingInputVolume || this.inputStream && this.listenerCount("inputVolume")) return;
        if (this._inputVolumeSource) {
            this._inputVolumeSource.disconnect();
            delete this._inputVolumeSource;
        }
        this._isPollingInputVolume = false;
    };
    /**
     * Call getUserMedia with specified constraints
     * @private
     */ AudioHelper.prototype._openDefaultDeviceWithConstraints = function(constraints) {
        var _this = this;
        this._log.info("Opening default device with constraints", constraints);
        return this._getUserMedia(constraints).then(function(stream) {
            _this._log.info("Opened default device. Updating available devices.");
            // Ensures deviceId's and labels are populated after the gUM call
            // by calling enumerateDevices
            _this._updateAvailableDevices().catch(function(error) {
                // Ignore error, we don't want to break the call flow
                _this._log.warn("Unable to updateAvailableDevices after gUM call", error);
            });
            _this._defaultInputDeviceStream = stream;
            return _this._maybeCreateProcessedStream(stream);
        });
    };
    /**
     * Stop the default audio stream
     * @private
     */ AudioHelper.prototype._stopDefaultInputDeviceStream = function() {
        if (this._defaultInputDeviceStream) {
            this._log.info("stopping default device stream");
            this._defaultInputDeviceStream.getTracks().forEach(function(track) {
                return track.stop();
            });
            this._defaultInputDeviceStream = null;
            this._destroyProcessedStream();
        }
    };
    /**
     * Unbind the listeners from mediaDevices.
     * @private
     */ AudioHelper.prototype._unbind = function() {
        if (!this._mediaDevices || !this._enumerateDevices) throw new $dmfT0.NotSupportedError("Enumeration is not supported");
        if (this._mediaDevices.removeEventListener) this._mediaDevices.removeEventListener("devicechange", this._updateAvailableDevices);
    };
    /**
     * Update AudioHelper options that can be changed by the user
     * @private
     */ AudioHelper.prototype._updateUserOptions = function(options) {
        if (typeof options.enumerateDevices === "function") this._enumerateDevices = options.enumerateDevices;
        if (typeof options.getUserMedia === "function") this._getUserMedia = options.getUserMedia;
    };
    /**
     * Adds an {@link AudioProcessor} object. Once added, the AudioHelper will route
     * the input audio stream through the processor before sending the audio
     * stream to Twilio. Only one AudioProcessor can be added at this time.
     *
     * See the {@link AudioProcessor} interface for an example.
     *
     * @param processor The AudioProcessor to add.
     * @returns
     */ AudioHelper.prototype.addProcessor = function(processor) {
        this._log.debug(".addProcessor");
        if (this._processor) throw new $dmfT0.NotSupportedError("Adding multiple AudioProcessors is not supported at this time.");
        if (typeof processor !== "object" || processor === null) throw new $dmfT0.InvalidArgumentError("Missing AudioProcessor argument.");
        if (typeof processor.createProcessedStream !== "function") throw new $dmfT0.InvalidArgumentError("Missing createProcessedStream() method.");
        if (typeof processor.destroyProcessedStream !== "function") throw new $dmfT0.InvalidArgumentError("Missing destroyProcessedStream() method.");
        this._processor = processor;
        this._audioProcessorEventObserver.emit("add");
        return this._restartStreams();
    };
    /**
     * Enable or disable the disconnect sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.disconnect = function(doEnable) {
        this._log.debug(".disconnect", doEnable);
        return this._maybeEnableSound($fewY1.default.SoundName.Disconnect, doEnable);
    };
    /**
     * Enable or disable the incoming sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.incoming = function(doEnable) {
        this._log.debug(".incoming", doEnable);
        return this._maybeEnableSound($fewY1.default.SoundName.Incoming, doEnable);
    };
    /**
     * Enable or disable the outgoing sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.outgoing = function(doEnable) {
        this._log.debug(".outgoing", doEnable);
        return this._maybeEnableSound($fewY1.default.SoundName.Outgoing, doEnable);
    };
    /**
     * Removes an {@link AudioProcessor}. Once removed, the AudioHelper will start using
     * the audio stream from the selected input device for existing or future calls.
     *
     * @param processor The AudioProcessor to remove.
     * @returns
     */ AudioHelper.prototype.removeProcessor = function(processor) {
        this._log.debug(".removeProcessor");
        if (typeof processor !== "object" || processor === null) throw new $dmfT0.InvalidArgumentError("Missing AudioProcessor argument.");
        if (this._processor !== processor) throw new $dmfT0.InvalidArgumentError("Cannot remove an AudioProcessor that has not been previously added.");
        this._destroyProcessedStream();
        this._processor = null;
        this._audioProcessorEventObserver.emit("remove");
        return this._restartStreams();
    };
    /**
     * Set the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. Any deviceId specified here will be ignored. Instead, device IDs should
     * be specified using {@link AudioHelper#setInputDevice}. The returned Promise resolves
     * when the media is successfully reacquired, or immediately if no input device is set.
     * @param audioConstraints - The MediaTrackConstraints to apply.
     */ AudioHelper.prototype.setAudioConstraints = function(audioConstraints) {
        this._log.debug(".setAudioConstraints", audioConstraints);
        this._audioConstraints = Object.assign({}, audioConstraints);
        delete this._audioConstraints.deviceId;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    };
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     */ AudioHelper.prototype.setInputDevice = function(deviceId) {
        this._log.debug(".setInputDevice", deviceId);
        return this._setInputDevice(deviceId, false);
    };
    /**
     * Unset the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. The returned Promise resolves when the media is successfully reacquired,
     * or immediately if no input device is set.
     */ AudioHelper.prototype.unsetAudioConstraints = function() {
        this._log.debug(".unsetAudioConstraints");
        this._audioConstraints = null;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    };
    /**
     * Unset the input device, stopping the tracks. This should only be called when not in a connection, and
     *   will not allow removal of the input device during a live call.
     */ AudioHelper.prototype.unsetInputDevice = function() {
        var _this = this;
        this._log.debug(".unsetInputDevice", this.inputDevice);
        if (!this.inputDevice) return Promise.resolve();
        this._destroyProcessedStream();
        return this._onActiveInputChanged(null).then(function() {
            _this._replaceStream(null);
            _this._inputDevice = null;
            _this._maybeStopPollingVolume();
        });
    };
    /**
     * Destroys processed stream and update references
     */ AudioHelper.prototype._destroyProcessedStream = function() {
        if (this._processor && this._processedStream) {
            this._log.info("destroying processed stream");
            var processedStream = this._processedStream;
            this._processedStream.getTracks().forEach(function(track) {
                return track.stop();
            });
            this._processedStream = null;
            this._processor.destroyProcessedStream(processedStream);
            this._audioProcessorEventObserver.emit("destroy");
        }
    };
    /**
     * Get the index of an un-labeled Device.
     * @param mediaDeviceInfo
     * @returns The index of the passed MediaDeviceInfo
     */ AudioHelper.prototype._getUnknownDeviceIndex = function(mediaDeviceInfo) {
        var id = mediaDeviceInfo.deviceId;
        var kind = mediaDeviceInfo.kind;
        var index = this._unknownDeviceIndexes[kind][id];
        if (!index) {
            index = Object.keys(this._unknownDeviceIndexes[kind]).length + 1;
            this._unknownDeviceIndexes[kind][id] = index;
        }
        return index;
    };
    /**
     * Initialize output device enumeration.
     */ AudioHelper.prototype._initializeEnumeration = function() {
        var _this = this;
        if (!this._mediaDevices || !this._enumerateDevices) throw new $dmfT0.NotSupportedError("Enumeration is not supported");
        if (this._mediaDevices.addEventListener) this._mediaDevices.addEventListener("devicechange", this._updateAvailableDevices);
        this._updateAvailableDevices().then(function() {
            if (!_this.isOutputSelectionSupported) return;
            Promise.all([
                _this.speakerDevices.set("default"),
                _this.ringtoneDevices.set("default")
            ]).catch(function(reason) {
                _this._log.warn("Warning: Unable to set audio output devices. " + reason);
            });
        });
    };
    /**
     * Route input stream to the processor if it exists
     */ AudioHelper.prototype._maybeCreateProcessedStream = function(stream) {
        var _this = this;
        if (this._processor) {
            this._log.info("Creating processed stream");
            return this._processor.createProcessedStream(stream).then(function(processedStream) {
                _this._processedStream = processedStream;
                _this._audioProcessorEventObserver.emit("create");
                return _this._processedStream;
            });
        }
        return Promise.resolve(stream);
    };
    /**
     * Set whether the sound is enabled or not
     * @param soundName
     * @param doEnable
     * @returns Whether the sound is enabled or not
     */ AudioHelper.prototype._maybeEnableSound = function(soundName, doEnable) {
        if (typeof doEnable !== "undefined") this._enabledSounds[soundName] = doEnable;
        return this._enabledSounds[soundName];
    };
    /**
     * Stop the tracks on the current input stream before replacing it with the passed stream.
     * @param stream - The new stream
     */ AudioHelper.prototype._replaceStream = function(stream) {
        this._log.info("Replacing with new stream.");
        if (this._selectedInputDeviceStream) {
            this._log.info("Old stream detected. Stopping tracks.");
            this._stopSelectedInputDeviceStream();
        }
        this._selectedInputDeviceStream = stream;
    };
    /**
     * Restart the active streams
     */ AudioHelper.prototype._restartStreams = function() {
        if (this.inputDevice && this._selectedInputDeviceStream) {
            this._log.info("Restarting selected input device");
            return this._setInputDevice(this.inputDevice.deviceId, true);
        }
        if (this._defaultInputDeviceStream) {
            var defaultDevice = this.availableInputDevices.get("default") || Array.from(this.availableInputDevices.values())[0];
            this._log.info("Restarting default input device, now becoming selected.");
            return this._setInputDevice(defaultDevice.deviceId, true);
        }
        return Promise.resolve();
    };
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     * @param forceGetUserMedia - If true, getUserMedia will be called even if
     *   the specified device is already active.
     */ AudioHelper.prototype._setInputDevice = function(deviceId, forceGetUserMedia) {
        return $54a2599bd8145d0c$var$__awaiter(this, void 0, void 0, function() {
            var setInputDevice;
            var _this = this;
            return $54a2599bd8145d0c$var$__generator(this, function(_a) {
                setInputDevice = function() {
                    return $54a2599bd8145d0c$var$__awaiter(_this, void 0, void 0, function() {
                        var device, constraints;
                        var _this = this;
                        return $54a2599bd8145d0c$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this._beforeSetInputDevice()
                                    ];
                                case 1:
                                    _a.sent();
                                    if (typeof deviceId !== "string") return [
                                        2 /*return*/ ,
                                        Promise.reject(new $dmfT0.InvalidArgumentError("Must specify the device to set"))
                                    ];
                                    device = this.availableInputDevices.get(deviceId);
                                    if (!device) return [
                                        2 /*return*/ ,
                                        Promise.reject(new $dmfT0.InvalidArgumentError("Device not found: " + deviceId))
                                    ];
                                    this._log.info("Setting input device. ID: " + deviceId);
                                    if (this._inputDevice && this._inputDevice.deviceId === deviceId && this._selectedInputDeviceStream) {
                                        if (!forceGetUserMedia) return [
                                            2 /*return*/ ,
                                            Promise.resolve()
                                        ];
                                        // If the currently active track is still in readyState `live`, gUM may return the same track
                                        // rather than returning a fresh track.
                                        this._log.info("Same track detected on setInputDevice, stopping old tracks.");
                                        this._stopSelectedInputDeviceStream();
                                    }
                                    // Release the default device in case it was created previously
                                    this._stopDefaultInputDeviceStream();
                                    constraints = {
                                        audio: Object.assign({
                                            deviceId: {
                                                exact: deviceId
                                            }
                                        }, this.audioConstraints)
                                    };
                                    this._log.info("setInputDevice: getting new tracks.");
                                    return [
                                        2 /*return*/ ,
                                        this._getUserMedia(constraints).then(function(originalStream) {
                                            _this._destroyProcessedStream();
                                            return _this._maybeCreateProcessedStream(originalStream).then(function(newStream) {
                                                _this._log.info("setInputDevice: invoking _onActiveInputChanged.");
                                                return _this._onActiveInputChanged(newStream).then(function() {
                                                    _this._replaceStream(originalStream);
                                                    _this._inputDevice = device;
                                                    _this._maybeStartPollingVolume();
                                                });
                                            });
                                        })
                                    ];
                            }
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    this._inputDevicePromise = setInputDevice().finally(function() {
                        _this._inputDevicePromise = null;
                    })
                ];
            });
        });
    };
    /**
     * Remove event listener for microphone permissions
     */ AudioHelper.prototype._stopMicrophonePermissionListener = function() {
        var _a;
        if ((_a = this._microphonePermissionStatus) === null || _a === void 0 ? void 0 : _a.removeEventListener) this._microphonePermissionStatus.removeEventListener("change", this._onMicrophonePermissionStatusChanged);
    };
    /**
     * Stop the selected audio stream
     */ AudioHelper.prototype._stopSelectedInputDeviceStream = function() {
        if (this._selectedInputDeviceStream) {
            this._log.info("Stopping selected device stream");
            this._selectedInputDeviceStream.getTracks().forEach(function(track) {
                return track.stop();
            });
        }
    };
    /**
     * Update a set of devices.
     * @param updatedDevices - An updated list of available Devices
     * @param availableDevices - The previous list of available Devices
     * @param removeLostDevice - The method to call if a previously available Device is
     *   no longer available.
     */ AudioHelper.prototype._updateDevices = function(updatedDevices, availableDevices, removeLostDevice) {
        var _this = this;
        var updatedDeviceIds = updatedDevices.map(function(d) {
            return d.deviceId;
        });
        var knownDeviceIds = Array.from(availableDevices.values()).map(function(d) {
            return d.deviceId;
        });
        var lostActiveDevices = [];
        // Remove lost devices
        var lostDeviceIds = $f8R8g.difference(knownDeviceIds, updatedDeviceIds);
        lostDeviceIds.forEach(function(lostDeviceId) {
            var lostDevice = availableDevices.get(lostDeviceId);
            if (lostDevice) {
                availableDevices.delete(lostDeviceId);
                if (removeLostDevice(lostDevice)) lostActiveDevices.push(lostDevice);
            }
        });
        // Add any new devices, or devices with updated labels
        var deviceChanged = false;
        updatedDevices.forEach(function(newDevice) {
            var existingDevice = availableDevices.get(newDevice.deviceId);
            var newMediaDeviceInfo = _this._wrapMediaDeviceInfo(newDevice);
            if (!existingDevice || existingDevice.label !== newMediaDeviceInfo.label) {
                availableDevices.set(newDevice.deviceId, newMediaDeviceInfo);
                deviceChanged = true;
            }
        });
        if (deviceChanged || lostDeviceIds.length) {
            // Force a new gUM in case the underlying tracks of the active stream have changed. One
            //   reason this might happen is when `default` is selected and set to a USB device,
            //   then that device is unplugged or plugged back in. We can't check for the 'ended'
            //   event or readyState because it is asynchronous and may take upwards of 5 seconds,
            //   in my testing. (rrowland)
            var defaultId_1 = "default";
            // this.inputDevice is not null if audio.setInputDevice() was explicitly called
            var isInputDeviceSet = this.inputDevice && this.inputDevice.deviceId === defaultId_1;
            // If this.inputDevice is null, and default stream is not null, it means
            // the user is using the default stream and did not explicitly call audio.setInputDevice()
            var isDefaultDeviceSet = this._defaultInputDeviceStream && this.availableInputDevices.get(defaultId_1);
            if (isInputDeviceSet || isDefaultDeviceSet) {
                this._log.warn("Calling getUserMedia after device change to ensure that the           tracks of the active device (default) have not gone stale.");
                // NOTE(csantos): Updating the stream in the same execution context as the devicechange event
                // causes the new gUM call to fail silently. Meaning, the gUM call may succeed,
                // but it won't actually update the stream. We need to update the stream in a different
                // execution context (setTimeout) to properly update the stream.
                setTimeout(function() {
                    _this._setInputDevice(defaultId_1, true);
                }, 0);
            }
            this._log.debug("#deviceChange", lostActiveDevices);
            this.emit("deviceChange", lostActiveDevices);
        }
    };
    /**
     * Disconnect the old input volume source, and create and connect a new one with the current
     * input stream.
     */ AudioHelper.prototype._updateVolumeSource = function() {
        if (!this.inputStream || !this._audioContext || !this._inputVolumeAnalyser) return;
        if (this._inputVolumeSource) this._inputVolumeSource.disconnect();
        try {
            this._inputVolumeSource = this._audioContext.createMediaStreamSource(this.inputStream);
            this._inputVolumeSource.connect(this._inputVolumeAnalyser);
        } catch (ex) {
            this._log.warn("Unable to update volume source", ex);
            delete this._inputVolumeSource;
        }
    };
    /**
     * Convert a MediaDeviceInfo to a IMediaDeviceInfoShim.
     * @param mediaDeviceInfo - The info to convert
     * @returns The converted shim
     */ AudioHelper.prototype._wrapMediaDeviceInfo = function(mediaDeviceInfo) {
        var options = {
            deviceId: mediaDeviceInfo.deviceId,
            groupId: mediaDeviceInfo.groupId,
            kind: mediaDeviceInfo.kind,
            label: mediaDeviceInfo.label
        };
        if (!options.label) {
            if (options.deviceId === "default") options.label = "Default";
            else {
                var index = this._getUnknownDeviceIndex(mediaDeviceInfo);
                options.label = "Unknown " + $54a2599bd8145d0c$var$kindAliases[options.kind] + " Device " + index;
            }
        }
        return new $5d53a.default(options);
    };
    return AudioHelper;
}($11OXI.EventEmitter);
$54a2599bd8145d0c$var$AudioHelper || ($54a2599bd8145d0c$var$AudioHelper = {});
module.exports.default = $54a2599bd8145d0c$var$AudioHelper;

});
parcelRegister("dmfT0", function(module, exports) {
"use strict";
var $9b99a7197ac9a7b1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserMediaErrors = module.exports.TwilioError = module.exports.SIPServerErrors = module.exports.SignatureValidationErrors = module.exports.SignalingErrors = module.exports.MediaErrors = module.exports.MalformedRequestErrors = module.exports.GeneralErrors = module.exports.ClientErrors = module.exports.AuthorizationErrors = module.exports.hasErrorByCode = module.exports.getErrorByCode = module.exports.NotSupportedError = module.exports.InvalidStateError = module.exports.InvalidArgumentError = module.exports.getPreciseSignalingErrorByCode = void 0;

var $c4NAv = parcelRequire("c4NAv");
Object.defineProperty(module.exports, "AuthorizationErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.AuthorizationErrors;
    }
});
Object.defineProperty(module.exports, "ClientErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.ClientErrors;
    }
});
Object.defineProperty(module.exports, "GeneralErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.GeneralErrors;
    }
});
Object.defineProperty(module.exports, "MalformedRequestErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.MalformedRequestErrors;
    }
});
Object.defineProperty(module.exports, "MediaErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.MediaErrors;
    }
});
Object.defineProperty(module.exports, "SignalingErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.SignalingErrors;
    }
});
Object.defineProperty(module.exports, "SignatureValidationErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.SignatureValidationErrors;
    }
});
Object.defineProperty(module.exports, "SIPServerErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.SIPServerErrors;
    }
});
Object.defineProperty(module.exports, "TwilioError", {
    enumerable: true,
    get: function() {
        return $c4NAv.TwilioError;
    }
});
Object.defineProperty(module.exports, "UserMediaErrors", {
    enumerable: true,
    get: function() {
        return $c4NAv.UserMediaErrors;
    }
});
/**
 * NOTE(mhuynh): Replacing generic error codes with new (more specific) codes,
 * is a breaking change. If an error code is found in this set, we only perform
 * the transformation if the feature flag is enabled.
 *
 * With every major version bump, such that we are allowed to introduce breaking
 * changes as per semver specification, this array should be cleared.
 *
 * TODO: [VBLOCKS-2295] Remove this in 3.x
 */ var $9b99a7197ac9a7b1$var$PRECISE_SIGNALING_ERROR_CODES = new Set([
    /**
     * 310XX Errors
     */ 31001,
    31002,
    31003,
    /**
     * 311XX Errors
     */ 31101,
    31102,
    31103,
    31104,
    31105,
    31107,
    /**
     * 312XX Errors
     */ 31201,
    31202,
    31203,
    31204,
    31205,
    31207,
    /**
     * 314XX Errors
     */ 31404,
    31480,
    31486,
    /**
     * 316XX Errors
     */ 31603
]);
function $9b99a7197ac9a7b1$var$getPreciseSignalingErrorByCode(enableImprovedSignalingErrorPrecision, errorCode) {
    if (typeof errorCode !== "number") return;
    if (!$9b99a7197ac9a7b1$var$hasErrorByCode(errorCode)) return;
    var shouldTransform = enableImprovedSignalingErrorPrecision ? true : !$9b99a7197ac9a7b1$var$PRECISE_SIGNALING_ERROR_CODES.has(errorCode);
    if (!shouldTransform) return;
    return $9b99a7197ac9a7b1$var$getErrorByCode(errorCode);
}
module.exports.getPreciseSignalingErrorByCode = $9b99a7197ac9a7b1$var$getPreciseSignalingErrorByCode;
// Application errors that can be avoided by good app logic
var $9b99a7197ac9a7b1$var$InvalidArgumentError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(InvalidArgumentError, _super);
    function InvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "InvalidArgumentError";
        return _this;
    }
    return InvalidArgumentError;
}(Error);
module.exports.InvalidArgumentError = $9b99a7197ac9a7b1$var$InvalidArgumentError;
var $9b99a7197ac9a7b1$var$InvalidStateError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(InvalidStateError, _super);
    function InvalidStateError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "InvalidStateError";
        return _this;
    }
    return InvalidStateError;
}(Error);
module.exports.InvalidStateError = $9b99a7197ac9a7b1$var$InvalidStateError;
var $9b99a7197ac9a7b1$var$NotSupportedError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(NotSupportedError, _super);
    function NotSupportedError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "NotSupportedError";
        return _this;
    }
    return NotSupportedError;
}(Error);
module.exports.NotSupportedError = $9b99a7197ac9a7b1$var$NotSupportedError;
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
function $9b99a7197ac9a7b1$var$getErrorByCode(code) {
    var error = $c4NAv.errorsByCode.get(code);
    if (!error) throw new $9b99a7197ac9a7b1$var$InvalidArgumentError("Error code " + code + " not found");
    return error;
}
module.exports.getErrorByCode = $9b99a7197ac9a7b1$var$getErrorByCode;
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
function $9b99a7197ac9a7b1$var$hasErrorByCode(code) {
    return $c4NAv.errorsByCode.has(code);
}
module.exports.hasErrorByCode = $9b99a7197ac9a7b1$var$hasErrorByCode;

});
parcelRegister("c4NAv", function(module, exports) {
"use strict";
/* tslint:disable max-classes-per-file max-line-length */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $8cac52d96525625c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorsByCode = module.exports.MediaErrors = module.exports.SignalingErrors = module.exports.UserMediaErrors = module.exports.MalformedRequestErrors = module.exports.GeneralErrors = module.exports.SIPServerErrors = module.exports.ClientErrors = module.exports.SignatureValidationErrors = module.exports.AuthorizationErrors = module.exports.TwilioError = void 0;

var $lvzq1 = parcelRequire("lvzq1");
module.exports.TwilioError = $lvzq1.default;
var $8cac52d96525625c$var$AuthorizationErrors;
(function(AuthorizationErrors) {
    var AccessTokenInvalid = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenInvalid, _super);
        function AccessTokenInvalid(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20101;
            _this.description = "Invalid access token";
            _this.explanation = "Twilio was unable to validate your Access Token";
            _this.name = "AccessTokenInvalid";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AccessTokenInvalid.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenInvalid;
    }($lvzq1.default);
    AuthorizationErrors.AccessTokenInvalid = AccessTokenInvalid;
    var AccessTokenExpired = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenExpired, _super);
        function AccessTokenExpired(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20104;
            _this.description = "Access token expired or expiration date invalid";
            _this.explanation = "The Access Token provided to the Twilio API has expired, the expiration time specified in the token was invalid, or the expiration time specified was too far in the future";
            _this.name = "AccessTokenExpired";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AccessTokenExpired.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenExpired;
    }($lvzq1.default);
    AuthorizationErrors.AccessTokenExpired = AccessTokenExpired;
    var AuthenticationFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthenticationFailed, _super);
        function AuthenticationFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20151;
            _this.description = "Authentication Failed";
            _this.explanation = "The Authentication with the provided JWT failed";
            _this.name = "AuthenticationFailed";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AuthenticationFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthenticationFailed;
    }($lvzq1.default);
    AuthorizationErrors.AuthenticationFailed = AuthenticationFailed;
})($8cac52d96525625c$var$AuthorizationErrors = module.exports.AuthorizationErrors || (module.exports.AuthorizationErrors = {}));
var $8cac52d96525625c$var$SignatureValidationErrors;
(function(SignatureValidationErrors) {
    var AccessTokenSignatureValidationFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenSignatureValidationFailed, _super);
        function AccessTokenSignatureValidationFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The access token has an invalid Account SID, API Key, or API Key Secret."
            ];
            _this.code = 31202;
            _this.description = "Signature validation failed.";
            _this.explanation = "The provided access token failed signature validation.";
            _this.name = "AccessTokenSignatureValidationFailed";
            _this.solutions = [
                "Ensure the Account SID, API Key, and API Key Secret are valid when generating your access token."
            ];
            Object.setPrototypeOf(_this, SignatureValidationErrors.AccessTokenSignatureValidationFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenSignatureValidationFailed;
    }($lvzq1.default);
    SignatureValidationErrors.AccessTokenSignatureValidationFailed = AccessTokenSignatureValidationFailed;
})($8cac52d96525625c$var$SignatureValidationErrors = module.exports.SignatureValidationErrors || (module.exports.SignatureValidationErrors = {}));
var $8cac52d96525625c$var$ClientErrors;
(function(ClientErrors) {
    var BadRequest = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(BadRequest, _super);
        function BadRequest(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31400;
            _this.description = "Bad Request (HTTP/SIP)";
            _this.explanation = "The request could not be understood due to malformed syntax.";
            _this.name = "BadRequest";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.BadRequest.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return BadRequest;
    }($lvzq1.default);
    ClientErrors.BadRequest = BadRequest;
    var NotFound = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(NotFound, _super);
        function NotFound(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The outbound call was made to an invalid phone number.",
                "The TwiML application sid is missing a Voice URL."
            ];
            _this.code = 31404;
            _this.description = "Not Found (HTTP/SIP)";
            _this.explanation = "The server has not found anything matching the request.";
            _this.name = "NotFound";
            _this.solutions = [
                "Ensure the phone number dialed is valid.",
                "Ensure the TwiML application is configured correctly with a Voice URL link."
            ];
            Object.setPrototypeOf(_this, ClientErrors.NotFound.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return NotFound;
    }($lvzq1.default);
    ClientErrors.NotFound = NotFound;
    var TemporarilyUnavailable = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(TemporarilyUnavailable, _super);
        function TemporarilyUnavailable(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31480;
            _this.description = "Temporarily Unavailable (SIP)";
            _this.explanation = "The callee is currently unavailable.";
            _this.name = "TemporarilyUnavailable";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.TemporarilyUnavailable.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return TemporarilyUnavailable;
    }($lvzq1.default);
    ClientErrors.TemporarilyUnavailable = TemporarilyUnavailable;
    var BusyHere = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(BusyHere, _super);
        function BusyHere(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31486;
            _this.description = "Busy Here (SIP)";
            _this.explanation = "The callee is busy.";
            _this.name = "BusyHere";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.BusyHere.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return BusyHere;
    }($lvzq1.default);
    ClientErrors.BusyHere = BusyHere;
})($8cac52d96525625c$var$ClientErrors = module.exports.ClientErrors || (module.exports.ClientErrors = {}));
var $8cac52d96525625c$var$SIPServerErrors;
(function(SIPServerErrors) {
    var Decline = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(Decline, _super);
        function Decline(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31603;
            _this.description = "Decline (SIP)";
            _this.explanation = "The callee does not wish to participate in the call.";
            _this.name = "Decline";
            _this.solutions = [];
            Object.setPrototypeOf(_this, SIPServerErrors.Decline.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return Decline;
    }($lvzq1.default);
    SIPServerErrors.Decline = Decline;
})($8cac52d96525625c$var$SIPServerErrors = module.exports.SIPServerErrors || (module.exports.SIPServerErrors = {}));
var $8cac52d96525625c$var$GeneralErrors;
(function(GeneralErrors) {
    var UnknownError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(UnknownError, _super);
        function UnknownError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31000;
            _this.description = "Unknown Error";
            _this.explanation = "An unknown error has occurred. See error details for more information.";
            _this.name = "UnknownError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.UnknownError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return UnknownError;
    }($lvzq1.default);
    GeneralErrors.UnknownError = UnknownError;
    var ApplicationNotFoundError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ApplicationNotFoundError, _super);
        function ApplicationNotFoundError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31001;
            _this.description = "Application Not Found";
            _this.explanation = "";
            _this.name = "ApplicationNotFoundError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ApplicationNotFoundError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ApplicationNotFoundError;
    }($lvzq1.default);
    GeneralErrors.ApplicationNotFoundError = ApplicationNotFoundError;
    var ConnectionDeclinedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionDeclinedError, _super);
        function ConnectionDeclinedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31002;
            _this.description = "Connection Declined";
            _this.explanation = "";
            _this.name = "ConnectionDeclinedError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionDeclinedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionDeclinedError;
    }($lvzq1.default);
    GeneralErrors.ConnectionDeclinedError = ConnectionDeclinedError;
    var ConnectionTimeoutError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionTimeoutError, _super);
        function ConnectionTimeoutError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31003;
            _this.description = "Connection Timeout";
            _this.explanation = "The server could not produce a response within a suitable amount of time.";
            _this.name = "ConnectionTimeoutError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionTimeoutError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionTimeoutError;
    }($lvzq1.default);
    GeneralErrors.ConnectionTimeoutError = ConnectionTimeoutError;
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31005;
            _this.description = "Connection error";
            _this.explanation = "A connection error occurred during the call";
            _this.name = "ConnectionError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($lvzq1.default);
    GeneralErrors.ConnectionError = ConnectionError;
    var CallCancelledError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(CallCancelledError, _super);
        function CallCancelledError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity."
            ];
            _this.code = 31008;
            _this.description = "Call cancelled";
            _this.explanation = "Unable to answer because the call has ended";
            _this.name = "CallCancelledError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.CallCancelledError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return CallCancelledError;
    }($lvzq1.default);
    GeneralErrors.CallCancelledError = CallCancelledError;
    var TransportError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(TransportError, _super);
        function TransportError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31009;
            _this.description = "Transport error";
            _this.explanation = "No transport available to send or receive messages";
            _this.name = "TransportError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.TransportError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return TransportError;
    }($lvzq1.default);
    GeneralErrors.TransportError = TransportError;
})($8cac52d96525625c$var$GeneralErrors = module.exports.GeneralErrors || (module.exports.GeneralErrors = {}));
var $8cac52d96525625c$var$MalformedRequestErrors;
(function(MalformedRequestErrors) {
    var MalformedRequestError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MalformedRequestError, _super);
        function MalformedRequestError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Invalid content or MessageType passed to sendMessage method."
            ];
            _this.code = 31100;
            _this.description = "The request had malformed syntax.";
            _this.explanation = "The request could not be understood due to malformed syntax.";
            _this.name = "MalformedRequestError";
            _this.solutions = [
                "Ensure content and MessageType passed to sendMessage method are valid."
            ];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MalformedRequestError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MalformedRequestError;
    }($lvzq1.default);
    MalformedRequestErrors.MalformedRequestError = MalformedRequestError;
    var MissingParameterArrayError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MissingParameterArrayError, _super);
        function MissingParameterArrayError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31101;
            _this.description = "Missing parameter array in request";
            _this.explanation = "";
            _this.name = "MissingParameterArrayError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MissingParameterArrayError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MissingParameterArrayError;
    }($lvzq1.default);
    MalformedRequestErrors.MissingParameterArrayError = MissingParameterArrayError;
    var AuthorizationTokenMissingError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthorizationTokenMissingError, _super);
        function AuthorizationTokenMissingError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31102;
            _this.description = "Authorization token missing in request.";
            _this.explanation = "";
            _this.name = "AuthorizationTokenMissingError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.AuthorizationTokenMissingError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthorizationTokenMissingError;
    }($lvzq1.default);
    MalformedRequestErrors.AuthorizationTokenMissingError = AuthorizationTokenMissingError;
    var MaxParameterLengthExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MaxParameterLengthExceededError, _super);
        function MaxParameterLengthExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31103;
            _this.description = "Maximum parameter length has been exceeded.";
            _this.explanation = "Length of parameters cannot exceed MAX_PARAM_LENGTH.";
            _this.name = "MaxParameterLengthExceededError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MaxParameterLengthExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MaxParameterLengthExceededError;
    }($lvzq1.default);
    MalformedRequestErrors.MaxParameterLengthExceededError = MaxParameterLengthExceededError;
    var InvalidBridgeTokenError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidBridgeTokenError, _super);
        function InvalidBridgeTokenError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31104;
            _this.description = "Invalid bridge token";
            _this.explanation = "";
            _this.name = "InvalidBridgeTokenError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.InvalidBridgeTokenError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidBridgeTokenError;
    }($lvzq1.default);
    MalformedRequestErrors.InvalidBridgeTokenError = InvalidBridgeTokenError;
    var InvalidClientNameError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidClientNameError, _super);
        function InvalidClientNameError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Client name contains invalid characters."
            ];
            _this.code = 31105;
            _this.description = "Invalid client name";
            _this.explanation = "Client name should not contain control, space, delims, or unwise characters.";
            _this.name = "InvalidClientNameError";
            _this.solutions = [
                "Make sure that client name does not contain any of the invalid characters."
            ];
            Object.setPrototypeOf(_this, MalformedRequestErrors.InvalidClientNameError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidClientNameError;
    }($lvzq1.default);
    MalformedRequestErrors.InvalidClientNameError = InvalidClientNameError;
    var ReconnectParameterInvalidError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ReconnectParameterInvalidError, _super);
        function ReconnectParameterInvalidError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31107;
            _this.description = "The reconnect parameter is invalid";
            _this.explanation = "";
            _this.name = "ReconnectParameterInvalidError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.ReconnectParameterInvalidError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ReconnectParameterInvalidError;
    }($lvzq1.default);
    MalformedRequestErrors.ReconnectParameterInvalidError = ReconnectParameterInvalidError;
})($8cac52d96525625c$var$MalformedRequestErrors = module.exports.MalformedRequestErrors || (module.exports.MalformedRequestErrors = {}));
(function(AuthorizationErrors) {
    var AuthorizationError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthorizationError, _super);
        function AuthorizationError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31201;
            _this.description = "Authorization error";
            _this.explanation = "The request requires user authentication. The server understood the request, but is refusing to fulfill it.";
            _this.name = "AuthorizationError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AuthorizationError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthorizationError;
    }($lvzq1.default);
    AuthorizationErrors.AuthorizationError = AuthorizationError;
    var NoValidAccountError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(NoValidAccountError, _super);
        function NoValidAccountError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31203;
            _this.description = "No valid account";
            _this.explanation = "";
            _this.name = "NoValidAccountError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.NoValidAccountError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return NoValidAccountError;
    }($lvzq1.default);
    AuthorizationErrors.NoValidAccountError = NoValidAccountError;
    var InvalidJWTTokenError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidJWTTokenError, _super);
        function InvalidJWTTokenError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31204;
            _this.description = "Invalid JWT token";
            _this.explanation = "";
            _this.name = "InvalidJWTTokenError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.InvalidJWTTokenError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidJWTTokenError;
    }($lvzq1.default);
    AuthorizationErrors.InvalidJWTTokenError = InvalidJWTTokenError;
    var JWTTokenExpiredError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(JWTTokenExpiredError, _super);
        function JWTTokenExpiredError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31205;
            _this.description = "JWT token expired";
            _this.explanation = "";
            _this.name = "JWTTokenExpiredError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.JWTTokenExpiredError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return JWTTokenExpiredError;
    }($lvzq1.default);
    AuthorizationErrors.JWTTokenExpiredError = JWTTokenExpiredError;
    var RateExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(RateExceededError, _super);
        function RateExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Rate limit exceeded."
            ];
            _this.code = 31206;
            _this.description = "Rate exceeded authorized limit.";
            _this.explanation = "The request performed exceeds the authorized limit.";
            _this.name = "RateExceededError";
            _this.solutions = [
                "Ensure message send rate does not exceed authorized limits."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.RateExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return RateExceededError;
    }($lvzq1.default);
    AuthorizationErrors.RateExceededError = RateExceededError;
    var JWTTokenExpirationTooLongError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(JWTTokenExpirationTooLongError, _super);
        function JWTTokenExpirationTooLongError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31207;
            _this.description = "JWT token expiration too long";
            _this.explanation = "";
            _this.name = "JWTTokenExpirationTooLongError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.JWTTokenExpirationTooLongError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return JWTTokenExpirationTooLongError;
    }($lvzq1.default);
    AuthorizationErrors.JWTTokenExpirationTooLongError = JWTTokenExpirationTooLongError;
    var ReconnectAttemptError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ReconnectAttemptError, _super);
        function ReconnectAttemptError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31209;
            _this.description = "Reconnect attempt is not authorized.";
            _this.explanation = "";
            _this.name = "ReconnectAttemptError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.ReconnectAttemptError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ReconnectAttemptError;
    }($lvzq1.default);
    AuthorizationErrors.ReconnectAttemptError = ReconnectAttemptError;
    var CallMessageEventTypeInvalidError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(CallMessageEventTypeInvalidError, _super);
        function CallMessageEventTypeInvalidError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Call Message Event Type is invalid and is not understood by Twilio Voice."
            ];
            _this.code = 31210;
            _this.description = "Call Message Event Type is invalid.";
            _this.explanation = "The Call Message Event Type is invalid and is not understood by Twilio Voice.";
            _this.name = "CallMessageEventTypeInvalidError";
            _this.solutions = [
                "Ensure the Call Message Event Type is Valid and understood by Twilio Voice and try again."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.CallMessageEventTypeInvalidError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return CallMessageEventTypeInvalidError;
    }($lvzq1.default);
    AuthorizationErrors.CallMessageEventTypeInvalidError = CallMessageEventTypeInvalidError;
    var PayloadSizeExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(PayloadSizeExceededError, _super);
        function PayloadSizeExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The payload size of Call Message Event exceeds the authorized limit."
            ];
            _this.code = 31212;
            _this.description = "Call Message Event Payload size exceeded authorized limit.";
            _this.explanation = "The request performed to send a Call Message Event exceeds the payload size authorized limit";
            _this.name = "PayloadSizeExceededError";
            _this.solutions = [
                "Reduce payload size of Call Message Event to be within the authorized limit and try again."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.PayloadSizeExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return PayloadSizeExceededError;
    }($lvzq1.default);
    AuthorizationErrors.PayloadSizeExceededError = PayloadSizeExceededError;
})($8cac52d96525625c$var$AuthorizationErrors = module.exports.AuthorizationErrors || (module.exports.AuthorizationErrors = {}));
var $8cac52d96525625c$var$UserMediaErrors;
(function(UserMediaErrors) {
    var PermissionDeniedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(PermissionDeniedError, _super);
        function PermissionDeniedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The user denied the getUserMedia request.",
                "The browser denied the getUserMedia request."
            ];
            _this.code = 31401;
            _this.description = "UserMedia Permission Denied Error";
            _this.explanation = "The browser or end-user denied permissions to user media. Therefore we were unable to acquire input audio.";
            _this.name = "PermissionDeniedError";
            _this.solutions = [
                "The user should accept the request next time prompted. If the browser saved the deny, the user should change that permission in their browser.",
                "The user should to verify that the browser has permission to access the microphone at this address."
            ];
            Object.setPrototypeOf(_this, UserMediaErrors.PermissionDeniedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return PermissionDeniedError;
    }($lvzq1.default);
    UserMediaErrors.PermissionDeniedError = PermissionDeniedError;
    var AcquisitionFailedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AcquisitionFailedError, _super);
        function AcquisitionFailedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "NotFoundError - The deviceID specified was not found.",
                "The getUserMedia constraints were overconstrained and no devices matched."
            ];
            _this.code = 31402;
            _this.description = "UserMedia Acquisition Failed Error";
            _this.explanation = "The browser and end-user allowed permissions, however getting the media failed. Usually this is due to bad constraints, but can sometimes fail due to browser, OS or hardware issues.";
            _this.name = "AcquisitionFailedError";
            _this.solutions = [
                "Ensure the deviceID being specified exists.",
                "Try acquiring media with fewer constraints."
            ];
            Object.setPrototypeOf(_this, UserMediaErrors.AcquisitionFailedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AcquisitionFailedError;
    }($lvzq1.default);
    UserMediaErrors.AcquisitionFailedError = AcquisitionFailedError;
})($8cac52d96525625c$var$UserMediaErrors = module.exports.UserMediaErrors || (module.exports.UserMediaErrors = {}));
var $8cac52d96525625c$var$SignalingErrors;
(function(SignalingErrors) {
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 53000;
            _this.description = "Signaling connection error";
            _this.explanation = "Raised whenever a signaling connection error occurs that is not covered by a more specific error code.";
            _this.name = "ConnectionError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, SignalingErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($lvzq1.default);
    SignalingErrors.ConnectionError = ConnectionError;
    var ConnectionDisconnected = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionDisconnected, _super);
        function ConnectionDisconnected(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The device running your application lost its Internet connection."
            ];
            _this.code = 53001;
            _this.description = "Signaling connection disconnected";
            _this.explanation = "Raised whenever the signaling connection is unexpectedly disconnected.";
            _this.name = "ConnectionDisconnected";
            _this.solutions = [
                "Ensure the device running your application has access to a stable Internet connection."
            ];
            Object.setPrototypeOf(_this, SignalingErrors.ConnectionDisconnected.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionDisconnected;
    }($lvzq1.default);
    SignalingErrors.ConnectionDisconnected = ConnectionDisconnected;
})($8cac52d96525625c$var$SignalingErrors = module.exports.SignalingErrors || (module.exports.SignalingErrors = {}));
var $8cac52d96525625c$var$MediaErrors;
(function(MediaErrors) {
    var ClientLocalDescFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ClientLocalDescFailed, _super);
        function ClientLocalDescFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client may not be using a supported WebRTC implementation.",
                "The Client may not have the necessary resources to create or apply a new media description."
            ];
            _this.code = 53400;
            _this.description = "Client is unable to create or apply a local media description";
            _this.explanation = "Raised whenever a Client is unable to create or apply a local media description.";
            _this.name = "ClientLocalDescFailed";
            _this.solutions = [
                "If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ClientLocalDescFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ClientLocalDescFailed;
    }($lvzq1.default);
    MediaErrors.ClientLocalDescFailed = ClientLocalDescFailed;
    var ClientRemoteDescFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ClientRemoteDescFailed, _super);
        function ClientRemoteDescFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client may not be using a supported WebRTC implementation.",
                "The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.",
                "The Client may not have the necessary resources to apply a new media description."
            ];
            _this.code = 53402;
            _this.description = "Client is unable to apply a remote media description";
            _this.explanation = "Raised whenever the Client receives a remote media description but is unable to apply it.";
            _this.name = "ClientRemoteDescFailed";
            _this.solutions = [
                "If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ClientRemoteDescFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ClientRemoteDescFailed;
    }($lvzq1.default);
    MediaErrors.ClientRemoteDescFailed = ClientRemoteDescFailed;
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client was unable to establish a media connection.",
                "A media connection which was active failed liveliness checks."
            ];
            _this.code = 53405;
            _this.description = "Media connection failed";
            _this.explanation = "Raised by the Client or Server whenever a media connection fails.";
            _this.name = "ConnectionError";
            _this.solutions = [
                "If the problem persists, try connecting to another region.",
                "Check your Client's network connectivity.",
                "If you've provided custom ICE Servers then ensure that the URLs and credentials are valid."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($lvzq1.default);
    MediaErrors.ConnectionError = ConnectionError;
})($8cac52d96525625c$var$MediaErrors = module.exports.MediaErrors || (module.exports.MediaErrors = {}));
/**
 * @private
 */ module.exports.errorsByCode = new Map([
    [
        20101,
        $8cac52d96525625c$var$AuthorizationErrors.AccessTokenInvalid
    ],
    [
        20104,
        $8cac52d96525625c$var$AuthorizationErrors.AccessTokenExpired
    ],
    [
        20151,
        $8cac52d96525625c$var$AuthorizationErrors.AuthenticationFailed
    ],
    [
        31202,
        $8cac52d96525625c$var$SignatureValidationErrors.AccessTokenSignatureValidationFailed
    ],
    [
        31400,
        $8cac52d96525625c$var$ClientErrors.BadRequest
    ],
    [
        31404,
        $8cac52d96525625c$var$ClientErrors.NotFound
    ],
    [
        31480,
        $8cac52d96525625c$var$ClientErrors.TemporarilyUnavailable
    ],
    [
        31486,
        $8cac52d96525625c$var$ClientErrors.BusyHere
    ],
    [
        31603,
        $8cac52d96525625c$var$SIPServerErrors.Decline
    ],
    [
        31000,
        $8cac52d96525625c$var$GeneralErrors.UnknownError
    ],
    [
        31001,
        $8cac52d96525625c$var$GeneralErrors.ApplicationNotFoundError
    ],
    [
        31002,
        $8cac52d96525625c$var$GeneralErrors.ConnectionDeclinedError
    ],
    [
        31003,
        $8cac52d96525625c$var$GeneralErrors.ConnectionTimeoutError
    ],
    [
        31005,
        $8cac52d96525625c$var$GeneralErrors.ConnectionError
    ],
    [
        31008,
        $8cac52d96525625c$var$GeneralErrors.CallCancelledError
    ],
    [
        31009,
        $8cac52d96525625c$var$GeneralErrors.TransportError
    ],
    [
        31100,
        $8cac52d96525625c$var$MalformedRequestErrors.MalformedRequestError
    ],
    [
        31101,
        $8cac52d96525625c$var$MalformedRequestErrors.MissingParameterArrayError
    ],
    [
        31102,
        $8cac52d96525625c$var$MalformedRequestErrors.AuthorizationTokenMissingError
    ],
    [
        31103,
        $8cac52d96525625c$var$MalformedRequestErrors.MaxParameterLengthExceededError
    ],
    [
        31104,
        $8cac52d96525625c$var$MalformedRequestErrors.InvalidBridgeTokenError
    ],
    [
        31105,
        $8cac52d96525625c$var$MalformedRequestErrors.InvalidClientNameError
    ],
    [
        31107,
        $8cac52d96525625c$var$MalformedRequestErrors.ReconnectParameterInvalidError
    ],
    [
        31201,
        $8cac52d96525625c$var$AuthorizationErrors.AuthorizationError
    ],
    [
        31203,
        $8cac52d96525625c$var$AuthorizationErrors.NoValidAccountError
    ],
    [
        31204,
        $8cac52d96525625c$var$AuthorizationErrors.InvalidJWTTokenError
    ],
    [
        31205,
        $8cac52d96525625c$var$AuthorizationErrors.JWTTokenExpiredError
    ],
    [
        31206,
        $8cac52d96525625c$var$AuthorizationErrors.RateExceededError
    ],
    [
        31207,
        $8cac52d96525625c$var$AuthorizationErrors.JWTTokenExpirationTooLongError
    ],
    [
        31209,
        $8cac52d96525625c$var$AuthorizationErrors.ReconnectAttemptError
    ],
    [
        31210,
        $8cac52d96525625c$var$AuthorizationErrors.CallMessageEventTypeInvalidError
    ],
    [
        31212,
        $8cac52d96525625c$var$AuthorizationErrors.PayloadSizeExceededError
    ],
    [
        31401,
        $8cac52d96525625c$var$UserMediaErrors.PermissionDeniedError
    ],
    [
        31402,
        $8cac52d96525625c$var$UserMediaErrors.AcquisitionFailedError
    ],
    [
        53000,
        $8cac52d96525625c$var$SignalingErrors.ConnectionError
    ],
    [
        53001,
        $8cac52d96525625c$var$SignalingErrors.ConnectionDisconnected
    ],
    [
        53400,
        $8cac52d96525625c$var$MediaErrors.ClientLocalDescFailed
    ],
    [
        53402,
        $8cac52d96525625c$var$MediaErrors.ClientRemoteDescFailed
    ],
    [
        53405,
        $8cac52d96525625c$var$MediaErrors.ConnectionError
    ]
]);
Object.freeze(module.exports.errorsByCode);

});
parcelRegister("lvzq1", function(module, exports) {
"use strict";
var $fa87f7a283781910$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @publicapi
 * @internal
 */ var $fa87f7a283781910$var$TwilioError = /** @class */ function(_super) {
    $fa87f7a283781910$var$__extends(TwilioError, _super);
    function TwilioError(messageOrError, error) {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, TwilioError.prototype);
        var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
        var originalError = typeof messageOrError === "object" ? messageOrError : error;
        _this.message = _this.name + " (" + _this.code + "): " + message;
        _this.originalError = originalError;
        return _this;
    }
    return TwilioError;
}(Error);
module.exports.default = $fa87f7a283781910$var$TwilioError;

});



parcelRegister("8RS9P", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $674d4885484aa9f2$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $iR2W5 = parcelRequire("iR2W5");

var $k4N4t = parcelRequire("k4N4t");
/**
 * {@link Log} provides logging features throughout the sdk using loglevel module
 * See https://github.com/pimterry/loglevel for documentation
 * @private
 */ var $674d4885484aa9f2$var$Log = /** @class */ function() {
    /**
     * @constructor
     * @param [tag] - tag name for the logs
     * @param [options] - Optional settings
     */ function Log(tag, options) {
        this._log = Log.getLogLevelInstance(options);
        this._prefix = "[TwilioVoice][" + tag + "]";
    }
    /**
     * Return the `loglevel` instance maintained internally.
     * @param [options] - Optional settings
     * @returns The `loglevel` instance.
     */ Log.getLogLevelInstance = function(options) {
        if (!Log.loglevelInstance) try {
            Log.loglevelInstance = (options && options.LogLevelModule ? options.LogLevelModule : $iR2W5).getLogger($k4N4t.PACKAGE_NAME);
        } catch (_a) {
            // tslint:disable-next-line
            console.warn("Cannot create custom logger");
            Log.loglevelInstance = console;
        }
        return Log.loglevelInstance;
    };
    /**
     * Log a debug message
     * @param args - Any number of arguments to be passed to loglevel.debug
     */ Log.prototype.debug = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).debug.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log an error message
     * @param args - Any number of arguments to be passed to loglevel.error
     */ Log.prototype.error = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).error.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log an info message
     * @param args - Any number of arguments to be passed to loglevel.info
     */ Log.prototype.info = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).info.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Set a default log level to disable all logging below the given level
     */ Log.prototype.setDefaultLevel = function(level) {
        if (this._log.setDefaultLevel) this._log.setDefaultLevel(level);
        else // tslint:disable-next-line
        console.warn("Logger cannot setDefaultLevel");
    };
    /**
     * Log a warning message
     * @param args - Any number of arguments to be passed to loglevel.warn
     */ Log.prototype.warn = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).warn.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log levels
     */ Log.levels = $iR2W5.levels;
    return Log;
}();
module.exports.Logger = $674d4885484aa9f2$var$Log.getLogLevelInstance();
module.exports.default = $674d4885484aa9f2$var$Log;

});
parcelRegister("k4N4t", function(module, exports) {
"use strict";
/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SOUNDS_BASE_URL = module.exports.RELEASE_VERSION = module.exports.PACKAGE_NAME = module.exports.ECHO_TEST_DURATION = module.exports.COWBELL_AUDIO_URL = void 0;
var $e9da3ede67c59403$var$PACKAGE_NAME = "@twilio/voice-sdk";
module.exports.PACKAGE_NAME = $e9da3ede67c59403$var$PACKAGE_NAME;
var $e9da3ede67c59403$var$RELEASE_VERSION = "2.12.1";
module.exports.RELEASE_VERSION = $e9da3ede67c59403$var$RELEASE_VERSION;
var $e9da3ede67c59403$var$SOUNDS_BASE_URL = "https://sdk.twilio.com/js/client/sounds/releases/1.0.0";
module.exports.SOUNDS_BASE_URL = $e9da3ede67c59403$var$SOUNDS_BASE_URL;
var $e9da3ede67c59403$var$COWBELL_AUDIO_URL = $e9da3ede67c59403$var$SOUNDS_BASE_URL + "/cowbell.mp3?cache=" + $e9da3ede67c59403$var$RELEASE_VERSION;
module.exports.COWBELL_AUDIO_URL = $e9da3ede67c59403$var$COWBELL_AUDIO_URL;
var $e9da3ede67c59403$var$ECHO_TEST_DURATION = 20000;
module.exports.ECHO_TEST_DURATION = $e9da3ede67c59403$var$ECHO_TEST_DURATION;

});


parcelRegister("dGYKu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k4N4t = parcelRequire("k4N4t");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");
var $9f7e520c5c2d3314$var$DEFAULT_TEST_SOUND_URL = $k4N4t.SOUNDS_BASE_URL + "/outgoing.mp3";
/**
 * A smart collection containing a Set of active output devices.
 * @publicapi
 */ var $9f7e520c5c2d3314$var$OutputDeviceCollection = /** @class */ function() {
    /**
     * @private
     */ function OutputDeviceCollection(_name, _availableDevices, _beforeChange, _isSupported) {
        this._name = _name;
        this._availableDevices = _availableDevices;
        this._beforeChange = _beforeChange;
        this._isSupported = _isSupported;
        /**
         * The currently active output devices.
         */ this._activeDevices = new Set();
        /**
         * An instance of Logger to use.
         */ this._log = new $8RS9P.default("OutputDeviceCollection");
    }
    /**
     * Delete a device from the collection. If no devices remain, the 'default'
     * device will be added as the sole device. If no `default` device exists,
     * the first available device will be used.
     * @param device - The device to delete from the collection
     * @returns whether the device was present before it was deleted
     */ OutputDeviceCollection.prototype.delete = function(device) {
        this._log.debug(".delete", device);
        var wasDeleted = !!this._activeDevices.delete(device);
        var defaultDevice = this._availableDevices.get("default") || Array.from(this._availableDevices.values())[0];
        if (!this._activeDevices.size && defaultDevice) this._activeDevices.add(defaultDevice);
        // Call _beforeChange so that the implementation can react when a device is
        // removed or lost.
        var deviceIds = Array.from(this._activeDevices.values()).map(function(deviceInfo) {
            return deviceInfo.deviceId;
        });
        this._beforeChange(this._name, deviceIds);
        return !!wasDeleted;
    };
    /**
     * Get the current set of devices.
     */ OutputDeviceCollection.prototype.get = function() {
        return this._activeDevices;
    };
    /**
     * Replace the current set of devices with a new set of devices.
     * @param deviceIdOrIds - An ID or array of IDs of devices to replace the existing devices with.
     * @returns Rejects if this feature is not supported, any of the supplied IDs are not found,
     * or no IDs are passed.
     */ OutputDeviceCollection.prototype.set = function(deviceIdOrIds) {
        var _this = this;
        this._log.debug(".set", deviceIdOrIds);
        if (!this._isSupported) return Promise.reject(new $dmfT0.NotSupportedError("This browser does not support audio output selection"));
        var deviceIds = Array.isArray(deviceIdOrIds) ? deviceIdOrIds : [
            deviceIdOrIds
        ];
        if (!deviceIds.length) return Promise.reject(new $dmfT0.InvalidArgumentError("Must specify at least one device to set"));
        var missingIds = [];
        var devices = deviceIds.map(function(id) {
            var device = _this._availableDevices.get(id);
            if (!device) missingIds.push(id);
            return device;
        });
        if (missingIds.length) return Promise.reject(new $dmfT0.InvalidArgumentError("Devices not found: " + missingIds.join(", ")));
        return new Promise(function(resolve) {
            resolve(_this._beforeChange(_this._name, deviceIds));
        }).then(function() {
            _this._activeDevices.clear();
            devices.forEach(_this._activeDevices.add, _this._activeDevices);
        });
    };
    /**
     * Test the devices by playing audio through them.
     * @param [soundUrl] - An optional URL. If none is specified, we will
     *   play a default test tone.
     * @returns Resolves with the result of the underlying HTMLAudioElements' play() calls.
     */ OutputDeviceCollection.prototype.test = function(soundUrl) {
        if (soundUrl === void 0) soundUrl = $9f7e520c5c2d3314$var$DEFAULT_TEST_SOUND_URL;
        if (!this._isSupported) return Promise.reject(new $dmfT0.NotSupportedError("This browser does not support audio output selection"));
        if (!this._activeDevices.size) return Promise.reject(new $dmfT0.InvalidStateError("No active output devices to test"));
        return Promise.all(Array.from(this._activeDevices).map(function(device) {
            var el;
            // (rrowland) We need to wait for the oncanplay event because of a regression introduced
            // in Chrome M72: https://bugs.chromium.org/p/chromium/issues/detail?id=930876
            return new Promise(function(resolve) {
                el = new Audio(soundUrl);
                el.oncanplay = resolve;
            }).then(function() {
                return el.setSinkId(device.deviceId).then(function() {
                    return el.play();
                });
            });
        }));
    };
    return OutputDeviceCollection;
}();
module.exports.default = $9f7e520c5c2d3314$var$OutputDeviceCollection;

});

parcelRegister("5d53a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var $3cb2157746d27905$var$MediaDeviceInfoShim = /** @class */ function() {
    function MediaDeviceInfoShim(options) {
        Object.defineProperties(this, {
            deviceId: {
                get: function() {
                    return options.deviceId;
                }
            },
            groupId: {
                get: function() {
                    return options.groupId;
                }
            },
            kind: {
                get: function() {
                    return options.kind;
                }
            },
            label: {
                get: function() {
                    return options.label;
                }
            }
        });
    }
    return MediaDeviceInfoShim;
}();
module.exports.default = $3cb2157746d27905$var$MediaDeviceInfoShim;

});

parcelRegister("f8R8g", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promisifyEvents = module.exports.flatMap = module.exports.queryToJson = module.exports.isUnifiedPlanDefault = module.exports.isSafari = module.exports.isLegacyEdge = module.exports.isFirefox = module.exports.isChrome = module.exports.isElectron = module.exports.difference = module.exports.average = module.exports.Exception = void 0;
/**
 * Exception class.
 * @class
 * @name Exception
 * @exports Exception as Twilio.Exception
 * @memberOf Twilio
 * @param {string} message The exception message
 */ function $b060d15305f18a68$var$TwilioException(message) {
    if (!(this instanceof $b060d15305f18a68$var$TwilioException)) return new $b060d15305f18a68$var$TwilioException(message);
    this.message = message;
}
/**
 * Returns the exception message.
 *
 * @return {string} The exception message.
 */ $b060d15305f18a68$var$TwilioException.prototype.toString = function() {
    return "Twilio.Exception: " + this.message;
};
function $b060d15305f18a68$var$average(values) {
    return values && values.length ? values.reduce(function(t, v) {
        return t + v;
    }) / values.length : 0;
}
module.exports.average = $b060d15305f18a68$var$average;
function $b060d15305f18a68$var$difference(lefts, rights, getKey) {
    getKey = getKey || function(a) {
        return a;
    };
    var rightKeys = new Set(rights.map(getKey));
    return lefts.filter(function(left) {
        return !rightKeys.has(getKey(left));
    });
}
module.exports.difference = $b060d15305f18a68$var$difference;
function $b060d15305f18a68$var$isElectron(navigator) {
    return !!navigator.userAgent.match("Electron");
}
module.exports.isElectron = $b060d15305f18a68$var$isElectron;
function $b060d15305f18a68$var$isChrome(window1, navigator) {
    var isCriOS = !!navigator.userAgent.match("CriOS");
    var isHeadlessChrome = !!navigator.userAgent.match("HeadlessChrome");
    var isGoogle = typeof window1.chrome !== "undefined" && navigator.vendor === "Google Inc." && navigator.userAgent.indexOf("OPR") === -1 && navigator.userAgent.indexOf("Edge") === -1;
    return isCriOS || $b060d15305f18a68$var$isElectron(navigator) || isGoogle || isHeadlessChrome;
}
module.exports.isChrome = $b060d15305f18a68$var$isChrome;
function $b060d15305f18a68$var$isFirefox(navigator) {
    navigator = navigator || (typeof window === "undefined" ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === "string" && /firefox|fxios/i.test(navigator.userAgent);
}
module.exports.isFirefox = $b060d15305f18a68$var$isFirefox;
function $b060d15305f18a68$var$isLegacyEdge(navigator) {
    navigator = navigator || (typeof window === "undefined" ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === "string" && /edge\/\d+/i.test(navigator.userAgent);
}
module.exports.isLegacyEdge = $b060d15305f18a68$var$isLegacyEdge;
function $b060d15305f18a68$var$isSafari(navigator) {
    return !!navigator.vendor && navigator.vendor.indexOf("Apple") !== -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") === -1 && navigator.userAgent.indexOf("FxiOS") === -1;
}
module.exports.isSafari = $b060d15305f18a68$var$isSafari;
function $b060d15305f18a68$var$isUnifiedPlanDefault(window1, navigator, PeerConnection, RtpTransceiver) {
    if (typeof window1 === "undefined" || typeof navigator === "undefined" || typeof PeerConnection === "undefined" || typeof RtpTransceiver === "undefined" || typeof PeerConnection.prototype === "undefined" || typeof RtpTransceiver.prototype === "undefined") return false;
    if ($b060d15305f18a68$var$isChrome(window1, navigator) && PeerConnection.prototype.addTransceiver) {
        var pc = new PeerConnection();
        var isUnifiedPlan = true;
        try {
            pc.addTransceiver("audio");
        } catch (e) {
            isUnifiedPlan = false;
        }
        pc.close();
        return isUnifiedPlan;
    } else if ($b060d15305f18a68$var$isFirefox(navigator)) return true;
    else if ($b060d15305f18a68$var$isSafari(navigator)) return "currentDirection" in RtpTransceiver.prototype;
    // Edge currently does not support unified plan.
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/17733189/
    // https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/34451998-sdp-unified-plan
    return false;
}
module.exports.isUnifiedPlanDefault = $b060d15305f18a68$var$isUnifiedPlanDefault;
function $b060d15305f18a68$var$queryToJson(params) {
    if (!params) return "";
    return params.split("&").reduce(function(output, pair) {
        var parts = pair.split("=");
        var key = parts[0];
        var value = decodeURIComponent((parts[1] || "").replace(/\+/g, "%20"));
        if (key) output[key] = value;
        return output;
    }, {});
}
module.exports.queryToJson = $b060d15305f18a68$var$queryToJson;
/**
 * Map a list to an array of arrays, and return the flattened result.
 * @param {Array<*>|Set<*>|Map<*>} list
 * @param {function(*): Array<*>} [mapFn]
 * @returns Array<*>
 */ function $b060d15305f18a68$var$flatMap(list, mapFn) {
    var listArray = list instanceof Map || list instanceof Set ? Array.from(list.values()) : list;
    mapFn = mapFn || function(item) {
        return item;
    };
    return listArray.reduce(function(flattened, item) {
        var mapped = mapFn(item);
        return flattened.concat(mapped);
    }, []);
}
module.exports.flatMap = $b060d15305f18a68$var$flatMap;
/**
 * Converts an EventEmitter's events into a promise and automatically
 * cleans up handlers once the promise is resolved or rejected.
 */ function $b060d15305f18a68$var$promisifyEvents(emitter, resolveEventName, rejectEventName) {
    return new Promise(function(resolve, reject) {
        function resolveHandler() {
            emitter.removeListener(rejectEventName, rejectHandler);
            resolve();
        }
        function rejectHandler() {
            emitter.removeListener(resolveEventName, resolveHandler);
            reject();
        }
        emitter.once(resolveEventName, resolveHandler);
        emitter.once(rejectEventName, rejectHandler);
    });
}
module.exports.promisifyEvents = $b060d15305f18a68$var$promisifyEvents;
var $b060d15305f18a68$var$Exception = $b060d15305f18a68$var$TwilioException;
module.exports.Exception = $b060d15305f18a68$var$Exception;

});


parcelRegister("lworL", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $faaf8cc587ce2922$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioProcessorEventObserver = void 0;

var $11OXI = parcelRequire("11OXI");

var $8RS9P = parcelRequire("8RS9P");
/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @private
 */ var $faaf8cc587ce2922$var$AudioProcessorEventObserver = /** @class */ function(_super) {
    $faaf8cc587ce2922$var$__extends(AudioProcessorEventObserver, _super);
    function AudioProcessorEventObserver() {
        var _this = _super.call(this) || this;
        _this._log = new $8RS9P.default("AudioProcessorEventObserver");
        _this._log.info("Creating AudioProcessorEventObserver instance");
        _this.on("enabled", function() {
            return _this._reEmitEvent("enabled");
        });
        _this.on("add", function() {
            return _this._reEmitEvent("add");
        });
        _this.on("remove", function() {
            return _this._reEmitEvent("remove");
        });
        _this.on("create", function() {
            return _this._reEmitEvent("create-processed-stream");
        });
        _this.on("destroy", function() {
            return _this._reEmitEvent("destroy-processed-stream");
        });
        return _this;
    }
    AudioProcessorEventObserver.prototype.destroy = function() {
        this.removeAllListeners();
    };
    AudioProcessorEventObserver.prototype._reEmitEvent = function(name) {
        this._log.info("AudioProcessor:" + name);
        this.emit("event", {
            name: name,
            group: "audio-processor"
        });
    };
    return AudioProcessorEventObserver;
}($11OXI.EventEmitter);
module.exports.AudioProcessorEventObserver = $faaf8cc587ce2922$var$AudioProcessorEventObserver;

});

parcelRegister("ewpvH", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dmfT0 = parcelRequire("dmfT0");
/**
 * A Map of DTMF Sound Names to their mock frequency pairs.
 */ var $a927d7a97cfdd257$var$bandFrequencies = {
    dtmf0: [
        1360,
        960
    ],
    dtmf1: [
        1230,
        720
    ],
    dtmf2: [
        1360,
        720
    ],
    dtmf3: [
        1480,
        720
    ],
    dtmf4: [
        1230,
        790
    ],
    dtmf5: [
        1360,
        790
    ],
    dtmf6: [
        1480,
        790
    ],
    dtmf7: [
        1230,
        870
    ],
    dtmf8: [
        1360,
        870
    ],
    dtmf9: [
        1480,
        870
    ],
    dtmfh: [
        1480,
        960
    ],
    dtmfs: [
        1230,
        960
    ]
};
var $a927d7a97cfdd257$var$DialtonePlayer = /** @class */ function() {
    function DialtonePlayer(_context) {
        var _this = this;
        this._context = _context;
        /**
         * Gain nodes, reducing the frequency.
         */ this._gainNodes = [];
        this._gainNodes = [
            this._context.createGain(),
            this._context.createGain()
        ];
        this._gainNodes.forEach(function(gainNode) {
            gainNode.connect(_this._context.destination);
            gainNode.gain.value = 0.1;
            _this._gainNodes.push(gainNode);
        });
    }
    DialtonePlayer.prototype.cleanup = function() {
        this._gainNodes.forEach(function(gainNode) {
            gainNode.disconnect();
        });
    };
    /**
     * Play the dual frequency tone for the passed DTMF name.
     * @param sound
     */ DialtonePlayer.prototype.play = function(sound) {
        var _this = this;
        var frequencies = $a927d7a97cfdd257$var$bandFrequencies[sound];
        if (!frequencies) throw new $dmfT0.InvalidArgumentError("Invalid DTMF sound name");
        var oscillators = [
            this._context.createOscillator(),
            this._context.createOscillator()
        ];
        oscillators.forEach(function(oscillator, i) {
            oscillator.type = "sine";
            oscillator.frequency.value = frequencies[i];
            oscillator.connect(_this._gainNodes[i]);
            oscillator.start();
            oscillator.stop(_this._context.currentTime + 0.1);
            oscillator.addEventListener("ended", function() {
                return oscillator.disconnect();
            });
        });
    };
    return DialtonePlayer;
}();
module.exports.default = $a927d7a97cfdd257$var$DialtonePlayer;

});

parcelRegister("7Bu6L", function(module, exports) {
"use strict";
var $589357f68de838e6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $8RS9P = parcelRequire("8RS9P");

var $7ISSC = parcelRequire("7ISSC");
/**
 * Builds Endpoint Analytics (EA) event payloads and sends them to
 *   the EA server.
 * @constructor
 * @param {String} productName - Name of the product publishing events.
 * @param {String} token - The JWT token to use to authenticate with
 *   the EA server.
 * @param {EventPublisher.Options} options
 * @property {Boolean} isEnabled - Whether or not this publisher is publishing
 *   to the server. Currently ignores the request altogether, in the future this
 *   may store them in case publishing is re-enabled later. Defaults to true.
 */ /**
 * @typedef {Object} EventPublisher.Options
 * @property {Object} [metadata=undefined] - A publisher_metadata object to send
 *   with each payload.
 * @property {String} [host='eventgw.twilio.com'] - The host address of the EA
 *   server to publish to.
 * @property {Object|Function} [defaultPayload] - A default payload to extend
 *   when creating and sending event payloads. Also takes a function that
 *   should return an object representing the default payload. This is
 *   useful for fields that should always be present when they are
 *   available, but are not always available.
 */ var $589357f68de838e6$var$EventPublisher = /** @class */ function(_super) {
    $589357f68de838e6$var$__extends(EventPublisher, _super);
    function EventPublisher(productName, token, options) {
        var _this = _super.call(this) || this;
        if (!(_this instanceof EventPublisher)) return new EventPublisher(productName, token, options);
        // Apply default options
        options = Object.assign({
            defaultPayload: function() {
                return {};
            }
        }, options);
        var defaultPayload = options.defaultPayload;
        if (typeof defaultPayload !== "function") defaultPayload = function() {
            return Object.assign({}, options.defaultPayload);
        };
        var isEnabled = true;
        var metadata = Object.assign({
            app_name: undefined,
            app_version: undefined
        }, options.metadata);
        Object.defineProperties(_this, {
            _defaultPayload: {
                value: defaultPayload
            },
            _host: {
                value: options.host,
                writable: true
            },
            _isEnabled: {
                get: function() {
                    return isEnabled;
                },
                set: function(_isEnabled) {
                    isEnabled = _isEnabled;
                }
            },
            _log: {
                value: new $8RS9P.default("EventPublisher")
            },
            _request: {
                value: options.request || $7ISSC.default,
                writable: true
            },
            _token: {
                value: token,
                writable: true
            },
            isEnabled: {
                enumerable: true,
                get: function() {
                    return isEnabled;
                }
            },
            metadata: {
                enumerable: true,
                get: function() {
                    return metadata;
                }
            },
            productName: {
                enumerable: true,
                value: productName
            },
            token: {
                enumerable: true,
                get: function() {
                    return this._token;
                }
            }
        });
        return _this;
    }
    return EventPublisher;
}($11OXI.EventEmitter);
/**
 * Post to an EA server.
 * @private
 * @param {String} endpointName - Endpoint to post the event to
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @param {?Boolean} [force=false] - Whether or not to send this even if
 *    publishing is disabled.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype._post = function _post(endpointName, level, group, name, payload, connection, force) {
    var _this = this;
    if (!this.isEnabled && !force || !this._host) {
        this._log.debug("Publishing cancelled", JSON.stringify({
            isEnabled: this.isEnabled,
            force: force,
            host: this._host
        }));
        return Promise.resolve();
    }
    if (!connection || (!connection.parameters || !connection.parameters.CallSid) && !connection.outboundConnectionId) {
        if (!connection) this._log.debug("Publishing cancelled. Missing connection object");
        else this._log.debug("Publishing cancelled. Missing connection info", JSON.stringify({
            outboundConnectionId: connection.outboundConnectionId,
            parameters: connection.parameters
        }));
        return Promise.resolve();
    }
    var event = {
        group: group,
        level: level.toUpperCase(),
        name: name,
        payload: payload && payload.forEach ? payload.slice(0) : Object.assign(this._defaultPayload(connection), payload),
        payload_type: "application/json",
        private: false,
        publisher: this.productName,
        timestamp: new Date().toISOString()
    };
    if (this.metadata) event.publisher_metadata = this.metadata;
    if (endpointName === "EndpointEvents") this._log.debug("Publishing insights", JSON.stringify({
        endpointName: endpointName,
        event: event,
        force: force,
        host: this._host
    }));
    var requestParams = {
        body: event,
        headers: {
            "Content-Type": "application/json",
            "X-Twilio-Token": this.token
        },
        url: "https://" + this._host + "/v4/" + endpointName
    };
    return new Promise(function(resolve, reject) {
        _this._request.post(requestParams, function(err) {
            if (err) {
                _this.emit("error", err);
                reject(err);
            } else resolve();
        });
    }).catch(function(e) {
        _this._log.error("Unable to post " + group + " " + name + " event to Insights. Received error: " + e);
    });
};
/**
 * Post an event to the EA server. Use this method when the level
 *  is dynamic. Otherwise, it's better practice to use the sugar
 *  methods named for the specific level.
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.post = function post(level, group, name, payload, connection, force) {
    return this._post("EndpointEvents", level, group, name, payload, connection, force);
};
/**
 * Post a debug-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.debug = function debug(group, name, payload, connection) {
    return this.post("debug", group, name, payload, connection);
};
/**
 * Post an info-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.info = function info(group, name, payload, connection) {
    return this.post("info", group, name, payload, connection);
};
/**
 * Post a warning-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.warn = function warn(group, name, payload, connection) {
    return this.post("warning", group, name, payload, connection);
};
/**
 * Post an error-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.error = function error(group, name, payload, connection) {
    return this.post("error", group, name, payload, connection);
};
/**
 * Post a metrics event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {Array<Object>} metrics - The metrics to post.
 * @param {?Object} [customFields] - Custom fields to append to each payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.postMetrics = function postMetrics(group, name, metrics, customFields, connection) {
    var _this = this;
    return new Promise(function(resolve) {
        var samples = metrics.map($589357f68de838e6$var$formatMetric).map(function(sample) {
            return Object.assign(sample, customFields);
        });
        resolve(_this._post("EndpointMetrics", "info", group, name, samples, connection));
    });
};
/**
 * Update the host address of the insights server to publish to.
 * @param {String} host - The new host address of the insights server.
 */ $589357f68de838e6$var$EventPublisher.prototype.setHost = function setHost(host) {
    this._host = host;
};
/**
 * Update the token to use to authenticate requests.
 * @param {string} token
 * @returns {void}
 */ $589357f68de838e6$var$EventPublisher.prototype.setToken = function setToken(token) {
    this._token = token;
};
/**
 * Enable the publishing of events.
 */ $589357f68de838e6$var$EventPublisher.prototype.enable = function enable() {
    this._isEnabled = true;
};
/**
 * Disable the publishing of events.
 */ $589357f68de838e6$var$EventPublisher.prototype.disable = function disable() {
    this._isEnabled = false;
};
function $589357f68de838e6$var$formatMetric(sample) {
    return {
        audio_codec: sample.codecName,
        audio_level_in: sample.audioInputLevel,
        audio_level_out: sample.audioOutputLevel,
        bytes_received: sample.bytesReceived,
        bytes_sent: sample.bytesSent,
        call_volume_input: sample.inputVolume,
        call_volume_output: sample.outputVolume,
        jitter: sample.jitter,
        mos: sample.mos && Math.round(sample.mos * 100) / 100,
        packets_lost: sample.packetsLost,
        packets_lost_fraction: sample.packetsLostFraction && Math.round(sample.packetsLostFraction * 100) / 100,
        packets_received: sample.packetsReceived,
        rtt: sample.rtt,
        timestamp: new Date(sample.timestamp).toISOString(),
        total_bytes_received: sample.totals.bytesReceived,
        total_bytes_sent: sample.totals.bytesSent,
        total_packets_lost: sample.totals.packetsLost,
        total_packets_received: sample.totals.packetsReceived,
        total_packets_sent: sample.totals.packetsSent
    };
}
module.exports.default = $589357f68de838e6$var$EventPublisher;

});
parcelRegister("7ISSC", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $59f7367924b380b3$var$request(method, params, callback) {
    var body = JSON.stringify(params.body || {});
    var headers = new Headers();
    params.headers = params.headers || [];
    Object.entries(params.headers).forEach(function(_a) {
        var headerName = _a[0], headerBody = _a[1];
        return headers.append(headerName, headerBody);
    });
    fetch(params.url, {
        body: body,
        headers: headers,
        method: method
    }).then(function(response) {
        return response.text();
    }, callback).then(function(responseText) {
        return callback(null, responseText);
    }, callback);
}
/**
 * Use XMLHttpRequest to get a network resource.
 * @param {String} method - HTTP Method
 * @param {Object} params - Request parameters
 * @param {String} params.url - URL of the resource
 * @param {Array}  params.headers - An array of headers to pass [{ headerName : headerBody }]
 * @param {Object} params.body - A JSON body to send to the resource
 * @returns {response}
 */ var $59f7367924b380b3$var$Request = $59f7367924b380b3$var$request;
/**
 * Sugar function for request('GET', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~get} callback - The callback that handles the response.
 */ $59f7367924b380b3$var$Request.get = function get(params, callback) {
    return new this("GET", params, callback);
};
/**
 * Sugar function for request('POST', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~post} callback - The callback that handles the response.
 */ $59f7367924b380b3$var$Request.post = function post(params, callback) {
    return new this("POST", params, callback);
};
module.exports.default = $59f7367924b380b3$var$Request;

});


parcelRegister("bFCWZ", function(module, exports) {
"use strict";
var $87f1bccdd5744d30$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $87f1bccdd5744d30$var$__assign = module.exports && module.exports.__assign || function() {
    $87f1bccdd5744d30$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87f1bccdd5744d30$var$__assign.apply(this, arguments);
};
var $87f1bccdd5744d30$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $87f1bccdd5744d30$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PreflightTest = void 0;

var $11OXI = parcelRequire("11OXI");

var $idaJZ = parcelRequire("idaJZ");

var $fewY1 = parcelRequire("fewY1");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");

var $3rqOC = parcelRequire("3rqOC");

var $k4N4t = parcelRequire("k4N4t");
/**
 * Runs some tests to identify issues, if any, prohibiting successful calling.
 */ var $87f1bccdd5744d30$var$PreflightTest = /** @class */ function(_super) {
    $87f1bccdd5744d30$var$__extends(PreflightTest, _super);
    /**
     * Construct a {@link PreflightTest} instance.
     * @constructor
     * @param token - A Twilio JWT token string.
     * @param options
     */ function PreflightTest(token, options) {
        var _this = _super.call(this) || this;
        /**
         * Whether this test has already logged an insights-connection-warning.
         */ _this._hasInsightsErrored = false;
        /**
         * An instance of Logger to use.
         */ _this._log = new $8RS9P.default("PreflightTest");
        /**
         * Network related timing measurements for this test
         */ _this._networkTiming = {};
        /**
         * The options passed to {@link PreflightTest} constructor
         */ _this._options = {
            codecPreferences: [
                $idaJZ.default.Codec.PCMU,
                $idaJZ.default.Codec.Opus
            ],
            edge: "roaming",
            fakeMicInput: false,
            logLevel: "error",
            signalingTimeoutMs: 10000
        };
        /**
         * Current status of this test
         */ _this._status = PreflightTest.Status.Connecting;
        Object.assign(_this._options, options);
        _this._samples = [];
        _this._warnings = [];
        _this._startTime = Date.now();
        _this._initDevice(token, $87f1bccdd5744d30$var$__assign($87f1bccdd5744d30$var$__assign({}, _this._options), {
            fileInputStream: _this._options.fakeMicInput ? _this._getStreamFromFile() : undefined
        }));
        // Device sets the loglevel so start logging after initializing the device.
        // Then selectively log options that users can modify.
        var userOptions = [
            "codecPreferences",
            "edge",
            "fakeMicInput",
            "logLevel",
            "signalingTimeoutMs"
        ];
        var userOptionOverrides = [
            "audioContext",
            "deviceFactory",
            "fileInputStream",
            "getRTCIceCandidateStatsReport",
            "iceServers",
            "rtcConfiguration"
        ];
        if (typeof options === "object") {
            var toLog_1 = $87f1bccdd5744d30$var$__assign({}, options);
            Object.keys(toLog_1).forEach(function(key) {
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog_1[key];
                if (userOptionOverrides.includes(key)) toLog_1[key] = true;
            });
            _this._log.debug(".constructor", JSON.stringify(toLog_1));
        }
        return _this;
    }
    /**
     * Stops the current test and raises a failed event.
     */ PreflightTest.prototype.stop = function() {
        var _this = this;
        this._log.debug(".stop");
        var error = new $dmfT0.GeneralErrors.CallCancelledError();
        if (this._device) {
            this._device.once($fewY1.default.EventName.Unregistered, function() {
                return _this._onFailed(error);
            });
            this._device.destroy();
        } else this._onFailed(error);
    };
    /**
     * Emit a {PreflightTest.Warning}
     */ PreflightTest.prototype._emitWarning = function(name, description, rtcWarning) {
        var warning = {
            name: name,
            description: description
        };
        if (rtcWarning) warning.rtcWarning = rtcWarning;
        this._warnings.push(warning);
        this._log.debug("#" + PreflightTest.Events.Warning, JSON.stringify(warning));
        this.emit(PreflightTest.Events.Warning, warning);
    };
    /**
     * Returns call quality base on the RTC Stats
     */ PreflightTest.prototype._getCallQuality = function(mos) {
        if (mos > 4.2) return PreflightTest.CallQuality.Excellent;
        else if (mos >= 4.1 && mos <= 4.2) return PreflightTest.CallQuality.Great;
        else if (mos >= 3.7 && mos <= 4) return PreflightTest.CallQuality.Good;
        else if (mos >= 3.1 && mos <= 3.6) return PreflightTest.CallQuality.Fair;
        else return PreflightTest.CallQuality.Degraded;
    };
    /**
     * Returns the report for this test.
     */ PreflightTest.prototype._getReport = function() {
        var _a, _b, _c;
        var stats = this._getRTCStats();
        var testTiming = {
            start: this._startTime
        };
        if (this._endTime) {
            testTiming.end = this._endTime;
            testTiming.duration = this._endTime - this._startTime;
        }
        var report = {
            callSid: this._callSid,
            edge: this._edge,
            iceCandidateStats: (_b = (_a = this._rtcIceCandidateStatsReport) === null || _a === void 0 ? void 0 : _a.iceCandidateStats) !== null && _b !== void 0 ? _b : [],
            networkTiming: this._networkTiming,
            samples: this._samples,
            selectedEdge: this._options.edge,
            stats: stats,
            testTiming: testTiming,
            totals: this._getRTCSampleTotals(),
            warnings: this._warnings
        };
        var selectedIceCandidatePairStats = (_c = this._rtcIceCandidateStatsReport) === null || _c === void 0 ? void 0 : _c.selectedIceCandidatePairStats;
        if (selectedIceCandidatePairStats) {
            report.selectedIceCandidatePairStats = selectedIceCandidatePairStats;
            report.isTurnRequired = selectedIceCandidatePairStats.localCandidate.candidateType === "relay" || selectedIceCandidatePairStats.remoteCandidate.candidateType === "relay";
        }
        if (stats) report.callQuality = this._getCallQuality(stats.mos.average);
        return report;
    };
    /**
     * Returns RTC stats totals for this test
     */ PreflightTest.prototype._getRTCSampleTotals = function() {
        if (!this._latestSample) return;
        return $87f1bccdd5744d30$var$__assign({}, this._latestSample.totals);
    };
    /**
     * Returns RTC related stats captured during the test call
     */ PreflightTest.prototype._getRTCStats = function() {
        var firstMosSampleIdx = this._samples.findIndex(function(sample) {
            return typeof sample.mos === "number" && sample.mos > 0;
        });
        var samples = firstMosSampleIdx >= 0 ? this._samples.slice(firstMosSampleIdx) : [];
        if (!samples || !samples.length) return;
        return [
            "jitter",
            "mos",
            "rtt"
        ].reduce(function(statObj, stat) {
            var _a;
            var values = samples.map(function(s) {
                return s[stat];
            });
            return $87f1bccdd5744d30$var$__assign($87f1bccdd5744d30$var$__assign({}, statObj), (_a = {}, _a[stat] = {
                average: Number((values.reduce(function(total, value) {
                    return total + value;
                }) / values.length).toPrecision(5)),
                max: Math.max.apply(Math, values),
                min: Math.min.apply(Math, values)
            }, _a));
        }, {});
    };
    /**
     * Returns a MediaStream from a media file
     */ PreflightTest.prototype._getStreamFromFile = function() {
        var audioContext = this._options.audioContext;
        if (!audioContext) throw new $dmfT0.NotSupportedError("Cannot fake input audio stream: AudioContext is not supported by this browser.");
        var audioEl = new Audio($k4N4t.COWBELL_AUDIO_URL);
        audioEl.addEventListener("canplaythrough", function() {
            return audioEl.play();
        });
        if (typeof audioEl.setAttribute === "function") audioEl.setAttribute("crossorigin", "anonymous");
        var src = audioContext.createMediaElementSource(audioEl);
        var dest = audioContext.createMediaStreamDestination();
        src.connect(dest);
        return dest.stream;
    };
    /**
     * Initialize the device
     */ PreflightTest.prototype._initDevice = function(token, options) {
        var _this = this;
        try {
            this._device = new (options.deviceFactory || $fewY1.default)(token, {
                codecPreferences: options.codecPreferences,
                edge: options.edge,
                fileInputStream: options.fileInputStream,
                logLevel: options.logLevel,
                preflight: true
            });
            this._device.once($fewY1.default.EventName.Registered, function() {
                _this._onDeviceRegistered();
            });
            this._device.once($fewY1.default.EventName.Error, function(error) {
                _this._onDeviceError(error);
            });
            this._device.register();
        } catch (error) {
            // We want to return before failing so the consumer can capture the event
            setTimeout(function() {
                _this._onFailed(error);
            });
            return;
        }
        this._signalingTimeoutTimer = setTimeout(function() {
            _this._onDeviceError(new $dmfT0.SignalingErrors.ConnectionError("WebSocket Connection Timeout"));
        }, options.signalingTimeoutMs);
    };
    /**
     * Called on {@link Device} error event
     * @param error
     */ PreflightTest.prototype._onDeviceError = function(error) {
        this._device.destroy();
        this._onFailed(error);
    };
    /**
     * Called on {@link Device} ready event
     */ PreflightTest.prototype._onDeviceRegistered = function() {
        return $87f1bccdd5744d30$var$__awaiter(this, void 0, void 0, function() {
            var _a, audio, publisher;
            var _this = this;
            return $87f1bccdd5744d30$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clearTimeout(this._echoTimer);
                        clearTimeout(this._signalingTimeoutTimer);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._device.connect({
                                rtcConfiguration: this._options.rtcConfiguration
                            })
                        ];
                    case 1:
                        _a._call = _b.sent();
                        this._networkTiming.signaling = {
                            start: Date.now()
                        };
                        this._setupCallHandlers(this._call);
                        this._edge = this._device.edge || undefined;
                        if (this._options.fakeMicInput) {
                            this._echoTimer = setTimeout(function() {
                                return _this._device.disconnectAll();
                            }, $k4N4t.ECHO_TEST_DURATION);
                            audio = this._device.audio;
                            if (audio) {
                                audio.disconnect(false);
                                audio.outgoing(false);
                            }
                        }
                        this._call.once("disconnect", function() {
                            _this._device.once($fewY1.default.EventName.Unregistered, function() {
                                return _this._onUnregistered();
                            });
                            _this._device.destroy();
                        });
                        publisher = this._call["_publisher"];
                        publisher.on("error", function() {
                            if (!_this._hasInsightsErrored) _this._emitWarning("insights-connection-error", "Received an error when attempting to connect to Insights gateway");
                            _this._hasInsightsErrored = true;
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Called when there is a fatal error
     * @param error
     */ PreflightTest.prototype._onFailed = function(error) {
        clearTimeout(this._echoTimer);
        clearTimeout(this._signalingTimeoutTimer);
        this._releaseHandlers();
        this._endTime = Date.now();
        this._status = PreflightTest.Status.Failed;
        this._log.debug("#" + PreflightTest.Events.Failed, error);
        this.emit(PreflightTest.Events.Failed, error);
    };
    /**
     * Called when the device goes offline.
     * This indicates that the test has been completed, but we won't know if it failed or not.
     * The onError event will be the indicator whether the test failed.
     */ PreflightTest.prototype._onUnregistered = function() {
        var _this = this;
        // We need to make sure we always execute preflight.on('completed') last
        // as client SDK sometimes emits 'offline' event before emitting fatal errors.
        setTimeout(function() {
            if (_this._status === PreflightTest.Status.Failed) return;
            clearTimeout(_this._echoTimer);
            clearTimeout(_this._signalingTimeoutTimer);
            _this._releaseHandlers();
            _this._endTime = Date.now();
            _this._status = PreflightTest.Status.Completed;
            _this._report = _this._getReport();
            _this._log.debug("#" + PreflightTest.Events.Completed, JSON.stringify(_this._report));
            _this.emit(PreflightTest.Events.Completed, _this._report);
        }, 10);
    };
    /**
     * Clean up all handlers for device and call
     */ PreflightTest.prototype._releaseHandlers = function() {
        [
            this._device,
            this._call
        ].forEach(function(emitter) {
            if (emitter) emitter.eventNames().forEach(function(name) {
                return emitter.removeAllListeners(name);
            });
        });
    };
    /**
     * Setup the event handlers for the {@link Call} of the test call
     * @param call
     */ PreflightTest.prototype._setupCallHandlers = function(call) {
        var _this = this;
        if (this._options.fakeMicInput) // When volume events start emitting, it means all audio outputs have been created.
        // Let's mute them if we're using fake mic input.
        call.once("volume", function() {
            call["_mediaHandler"].outputs.forEach(function(output) {
                return output.audio.muted = true;
            });
        });
        call.on("warning", function(name, data) {
            _this._emitWarning(name, "Received an RTCWarning. See .rtcWarning for the RTCWarning", data);
        });
        call.once("accept", function() {
            _this._callSid = call["_mediaHandler"].callSid;
            _this._status = PreflightTest.Status.Connected;
            _this._log.debug("#" + PreflightTest.Events.Connected);
            _this.emit(PreflightTest.Events.Connected);
        });
        call.on("sample", function(sample) {
            return $87f1bccdd5744d30$var$__awaiter(_this, void 0, void 0, function() {
                var _a;
                return $87f1bccdd5744d30$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!!this._latestSample) return [
                                3 /*break*/ ,
                                2
                            ];
                            _a = this;
                            return [
                                4 /*yield*/ ,
                                (this._options.getRTCIceCandidateStatsReport || $3rqOC.getRTCIceCandidateStatsReport)(call["_mediaHandler"].version.pc)
                            ];
                        case 1:
                            _a._rtcIceCandidateStatsReport = _b.sent();
                            _b.label = 2;
                        case 2:
                            this._latestSample = sample;
                            this._samples.push(sample);
                            this._log.debug("#" + PreflightTest.Events.Sample, JSON.stringify(sample));
                            this.emit(PreflightTest.Events.Sample, sample);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        // TODO: Update the following once the SDK supports emitting these events
        // Let's shim for now
        [
            {
                reportLabel: "peerConnection",
                type: "pcconnection"
            },
            {
                reportLabel: "ice",
                type: "iceconnection"
            },
            {
                reportLabel: "dtls",
                type: "dtlstransport"
            },
            {
                reportLabel: "signaling",
                type: "signaling"
            }
        ].forEach(function(_a) {
            var type = _a.type, reportLabel = _a.reportLabel;
            var handlerName = "on" + type + "statechange";
            var originalHandler = call["_mediaHandler"][handlerName];
            call["_mediaHandler"][handlerName] = function(state) {
                var timing = _this._networkTiming[reportLabel] = _this._networkTiming[reportLabel] || {
                    start: 0
                };
                if (state === "connecting" || state === "checking") timing.start = Date.now();
                else if ((state === "connected" || state === "stable") && !timing.duration) {
                    timing.end = Date.now();
                    timing.duration = timing.end - timing.start;
                }
                originalHandler(state);
            };
        });
    };
    Object.defineProperty(PreflightTest.prototype, "callSid", {
        /**
         * The callsid generated for the test call.
         */ get: function() {
            return this._callSid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "endTime", {
        /**
         * A timestamp in milliseconds of when the test ended.
         */ get: function() {
            return this._endTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "latestSample", {
        /**
         * The latest WebRTC sample collected.
         */ get: function() {
            return this._latestSample;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "report", {
        /**
         * The report for this test.
         */ get: function() {
            return this._report;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "startTime", {
        /**
         * A timestamp in milliseconds of when the test started.
         */ get: function() {
            return this._startTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "status", {
        /**
         * The status of the test.
         */ get: function() {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    return PreflightTest;
}($11OXI.EventEmitter);
module.exports.PreflightTest = $87f1bccdd5744d30$var$PreflightTest;
(function(PreflightTest) {
    /**
     * The quality of the call determined by different mos ranges.
     * Mos is calculated base on the WebRTC stats - rtt, jitter, and packet lost.
     */ var CallQuality;
    (function(CallQuality) {
        /**
         * If the average mos is over 4.2.
         */ CallQuality["Excellent"] = "excellent";
        /**
         * If the average mos is between 4.1 and 4.2 both inclusive.
         */ CallQuality["Great"] = "great";
        /**
         * If the average mos is between 3.7 and 4.0 both inclusive.
         */ CallQuality["Good"] = "good";
        /**
         * If the average mos is between 3.1 and 3.6 both inclusive.
         */ CallQuality["Fair"] = "fair";
        /**
         * If the average mos is 3.0 or below.
         */ CallQuality["Degraded"] = "degraded";
    })(CallQuality = PreflightTest.CallQuality || (PreflightTest.CallQuality = {}));
    /**
     * Possible events that a [[PreflightTest]] might emit.
     */ var Events;
    (function(Events) {
        /**
         * See [[PreflightTest.completedEvent]]
         */ Events["Completed"] = "completed";
        /**
         * See [[PreflightTest.connectedEvent]]
         */ Events["Connected"] = "connected";
        /**
         * See [[PreflightTest.failedEvent]]
         */ Events["Failed"] = "failed";
        /**
         * See [[PreflightTest.sampleEvent]]
         */ Events["Sample"] = "sample";
        /**
         * See [[PreflightTest.warningEvent]]
         */ Events["Warning"] = "warning";
    })(Events = PreflightTest.Events || (PreflightTest.Events = {}));
    /**
     * Possible status of the test.
     */ var Status;
    (function(Status) {
        /**
         * Call to Twilio has initiated.
         */ Status["Connecting"] = "connecting";
        /**
         * Call to Twilio has been established.
         */ Status["Connected"] = "connected";
        /**
         * The connection to Twilio has been disconnected and the test call has completed.
         */ Status["Completed"] = "completed";
        /**
         * The test has stopped and failed.
         */ Status["Failed"] = "failed";
    })(Status = PreflightTest.Status || (PreflightTest.Status = {}));
})($87f1bccdd5744d30$var$PreflightTest = module.exports.PreflightTest || (module.exports.PreflightTest = {}));
module.exports.PreflightTest = $87f1bccdd5744d30$var$PreflightTest;

});
parcelRegister("3rqOC", function(module, exports) {
"use strict";
var $2818b1ada62f2007$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRTCIceCandidateStatsReport = module.exports.getRTCStats = void 0;

var $dmfT0 = parcelRequire("dmfT0");

var $5MHKr = parcelRequire("5MHKr");
var $2818b1ada62f2007$var$ERROR_PEER_CONNECTION_NULL = "PeerConnection is null";
var $2818b1ada62f2007$var$ERROR_WEB_RTC_UNSUPPORTED = "WebRTC statistics are unsupported";
/**
 * Helper function to find a specific stat from a report.
 * Some environment provide the stats report as a map (regular browsers)
 * but some provide stats report as an array (citrix vdi)
 * @private
 */ function $2818b1ada62f2007$var$findStatById(report, id) {
    if (typeof report.get === "function") return report.get(id);
    return report.find(function(s) {
        return s.id === id;
    });
}
/**
 * Generate WebRTC statistics report for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCStatsReport>} WebRTC RTCStatsReport object
 */ function $2818b1ada62f2007$var$getRTCStatsReport(peerConnection) {
    if (!peerConnection) return Promise.reject(new $dmfT0.InvalidArgumentError($2818b1ada62f2007$var$ERROR_PEER_CONNECTION_NULL));
    if (typeof peerConnection.getStats !== "function") return Promise.reject(new $dmfT0.NotSupportedError($2818b1ada62f2007$var$ERROR_WEB_RTC_UNSUPPORTED));
    var promise;
    try {
        promise = peerConnection.getStats();
    } catch (e) {
        promise = new Promise(function(resolve) {
            return peerConnection.getStats(resolve);
        }).then($5MHKr.default.fromRTCStatsResponse);
    }
    return promise;
}
/**
 * @typedef {Object} StatsOptions
 * Used for testing to inject and extract methods.
 * @property {function} [createRTCSample] - Method for parsing an RTCStatsReport
 */ /**
 * Collects any WebRTC statistics for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @param {StatsOptions} options - List of custom options.
 * @return {Promise<RTCSample>} Universally-formatted version of RTC stats.
 */ function $2818b1ada62f2007$var$getRTCStats(peerConnection, options) {
    options = Object.assign({
        createRTCSample: $2818b1ada62f2007$var$createRTCSample
    }, options);
    return $2818b1ada62f2007$var$getRTCStatsReport(peerConnection).then(options.createRTCSample);
}
module.exports.getRTCStats = $2818b1ada62f2007$var$getRTCStats;
/**
 * Generate WebRTC stats report containing relevant information about ICE candidates for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCIceCandidateStatsReport>} RTCIceCandidateStatsReport object
 */ function $2818b1ada62f2007$var$getRTCIceCandidateStatsReport(peerConnection) {
    return $2818b1ada62f2007$var$getRTCStatsReport(peerConnection).then(function(report) {
        // Find the relevant information needed to determine selected candidates later
        var _a = Array.from(report.values()).reduce(function(rval, stat) {
            [
                "candidatePairs",
                "localCandidates",
                "remoteCandidates"
            ].forEach(function(prop) {
                if (!rval[prop]) rval[prop] = [];
            });
            switch(stat.type){
                case "candidate-pair":
                    rval.candidatePairs.push(stat);
                    break;
                case "local-candidate":
                    rval.localCandidates.push(stat);
                    break;
                case "remote-candidate":
                    rval.remoteCandidates.push(stat);
                    break;
                case "transport":
                    // This transport is the one being used if selectedCandidatePairId is populated
                    if (stat.selectedCandidatePairId) rval.transport = stat;
                    break;
            }
            return rval;
        }, {}), candidatePairs = _a.candidatePairs, localCandidates = _a.localCandidates, remoteCandidates = _a.remoteCandidates, transport = _a.transport;
        // This is a report containing information about the selected candidates, such as IDs
        // This is coming from WebRTC stats directly and doesn't contain the actual ICE Candidates info
        var selectedCandidatePairReport = candidatePairs.find(function(pair) {
            // Firefox
            return pair.selected || // Spec-compliant way
            transport && pair.id === transport.selectedCandidatePairId;
        });
        var selectedIceCandidatePairStats;
        if (selectedCandidatePairReport) selectedIceCandidatePairStats = {
            localCandidate: localCandidates.find(function(candidate) {
                return candidate.id === selectedCandidatePairReport.localCandidateId;
            }),
            remoteCandidate: remoteCandidates.find(function(candidate) {
                return candidate.id === selectedCandidatePairReport.remoteCandidateId;
            })
        };
        // Build the return object
        return {
            iceCandidateStats: $2818b1ada62f2007$var$__spreadArrays(localCandidates, remoteCandidates),
            selectedIceCandidatePairStats: selectedIceCandidatePairStats
        };
    });
}
module.exports.getRTCIceCandidateStatsReport = $2818b1ada62f2007$var$getRTCIceCandidateStatsReport;
/**
 * @typedef {Object} RTCSample - A sample containing relevant WebRTC stats information.
 * @property {Number} [timestamp]
 * @property {String} [codecName] - MimeType name of the codec being used by the outbound audio stream
 * @property {Number} [rtt] - Round trip time
 * @property {Number} [jitter]
 * @property {Number} [packetsSent]
 * @property {Number} [packetsLost]
 * @property {Number} [packetsReceived]
 * @property {Number} [bytesReceived]
 * @property {Number} [bytesSent]
 * @property {Number} [localAddress]
 * @property {Number} [remoteAddress]
 */ function $2818b1ada62f2007$var$RTCSample() {}
/**
 * Create an RTCSample object from an RTCStatsReport
 * @private
 * @param {RTCStatsReport} statsReport
 * @returns {RTCSample}
 */ function $2818b1ada62f2007$var$createRTCSample(statsReport) {
    var activeTransportId = null;
    var sample = new $2818b1ada62f2007$var$RTCSample();
    var fallbackTimestamp;
    Array.from(statsReport.values()).forEach(function(stats) {
        // Skip isRemote tracks which will be phased out completely and break in FF66.
        if (stats.isRemote) return;
        // Firefox hack -- Older firefox doesn't have dashes in type names
        var type = stats.type.replace("-", "");
        fallbackTimestamp = fallbackTimestamp || stats.timestamp;
        // (rrowland) As I understand it, this is supposed to come in on remote-inbound-rtp but it's
        // currently coming in on remote-outbound-rtp, so I'm leaving this outside the switch until
        // the appropriate place to look is cleared up.
        if (stats.remoteId) {
            var remote = $2818b1ada62f2007$var$findStatById(statsReport, stats.remoteId);
            if (remote && remote.roundTripTime) sample.rtt = remote.roundTripTime * 1000;
        }
        switch(type){
            case "inboundrtp":
                sample.timestamp = sample.timestamp || stats.timestamp;
                sample.jitter = stats.jitter * 1000;
                sample.packetsLost = stats.packetsLost;
                sample.packetsReceived = stats.packetsReceived;
                sample.bytesReceived = stats.bytesReceived;
                break;
            case "outboundrtp":
                sample.timestamp = stats.timestamp;
                sample.packetsSent = stats.packetsSent;
                sample.bytesSent = stats.bytesSent;
                if (stats.codecId) {
                    var codec = $2818b1ada62f2007$var$findStatById(statsReport, stats.codecId);
                    sample.codecName = codec ? codec.mimeType && codec.mimeType.match(/(.*\/)?(.*)/)[2] : stats.codecId;
                }
                break;
            case "transport":
                activeTransportId = stats.id;
                break;
        }
    });
    if (!sample.timestamp) sample.timestamp = fallbackTimestamp;
    var activeTransport = $2818b1ada62f2007$var$findStatById(statsReport, activeTransportId);
    if (!activeTransport) return sample;
    var selectedCandidatePair = $2818b1ada62f2007$var$findStatById(statsReport, activeTransport.selectedCandidatePairId);
    if (!selectedCandidatePair) return sample;
    var localCandidate = $2818b1ada62f2007$var$findStatById(statsReport, selectedCandidatePair.localCandidateId);
    var remoteCandidate = $2818b1ada62f2007$var$findStatById(statsReport, selectedCandidatePair.remoteCandidateId);
    if (!sample.rtt) sample.rtt = selectedCandidatePair && selectedCandidatePair.currentRoundTripTime * 1000;
    Object.assign(sample, {
        // ip is deprecated. use address first then ip if on older versions of browser
        localAddress: localCandidate && (localCandidate.address || localCandidate.ip),
        remoteAddress: remoteCandidate && (remoteCandidate.address || remoteCandidate.ip)
    });
    return sample;
}

});
parcelRegister("5MHKr", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * This file was imported from another project. If making changes to this file, please don't
 * make them here. Make them on the linked repo below, then copy back:
 * https://code.hq.twilio.com/client/MockRTCStatsReport
 */ // The legacy max volume, which is the positive half of a signed short integer.
var $43635ee3f7940fdc$var$OLD_MAX_VOLUME = 32767;
var $43635ee3f7940fdc$var$NativeRTCStatsReport = typeof window !== "undefined" ? window.RTCStatsReport : undefined;
/**
 * Create a MockRTCStatsReport wrapper around a Map of RTCStats objects. If RTCStatsReport is available
 *   natively, it will be inherited so that instanceof checks pass.
 * @constructor
 * @extends RTCStatsReport
 * @param {Map<string, RTCStats>} statsMap - A Map of RTCStats objects to wrap
 *   with a MockRTCStatsReport object.
 */ function $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap) {
    if (!(this instanceof $43635ee3f7940fdc$var$MockRTCStatsReport)) return new $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap);
    var self = this;
    Object.defineProperties(this, {
        _map: {
            value: statsMap
        },
        size: {
            enumerable: true,
            get: function() {
                return self._map.size;
            }
        }
    });
    this[Symbol.iterator] = statsMap[Symbol.iterator];
}
// If RTCStatsReport is available natively, inherit it. Keep our constructor.
if ($43635ee3f7940fdc$var$NativeRTCStatsReport) {
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype = Object.create($43635ee3f7940fdc$var$NativeRTCStatsReport.prototype);
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype.constructor = $43635ee3f7940fdc$var$MockRTCStatsReport;
}
// Map the Map-like read methods to the underlying Map
[
    "entries",
    "forEach",
    "get",
    "has",
    "keys",
    "values"
].forEach(function(key) {
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype[key] = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._map)[key].apply(_a, args);
    };
});
/**
 * Convert an array of RTCStats objects into a mock RTCStatsReport object.
 * @param {Array<RTCStats>}
 * @return {MockRTCStatsReport}
 */ $43635ee3f7940fdc$var$MockRTCStatsReport.fromArray = function fromArray(array) {
    return new $43635ee3f7940fdc$var$MockRTCStatsReport(array.reduce(function(map, rtcStats) {
        map.set(rtcStats.id, rtcStats);
        return map;
    }, new Map()));
};
/**
 * Convert a legacy RTCStatsResponse object into a mock RTCStatsReport object.
 * @param {RTCStatsResponse} statsResponse - An RTCStatsResponse object returned by the
 *   legacy getStats(callback) method in Chrome.
 * @return {MockRTCStatsReport} A mock RTCStatsReport object.
 */ $43635ee3f7940fdc$var$MockRTCStatsReport.fromRTCStatsResponse = function fromRTCStatsResponse(statsResponse) {
    var activeCandidatePairId;
    var transportIds = new Map();
    var statsMap = statsResponse.result().reduce(function(map, report) {
        var id = report.id;
        switch(report.type){
            case "googCertificate":
                map.set(id, $43635ee3f7940fdc$var$createRTCCertificateStats(report));
                break;
            case "datachannel":
                map.set(id, $43635ee3f7940fdc$var$createRTCDataChannelStats(report));
                break;
            case "googCandidatePair":
                if ($43635ee3f7940fdc$var$getBoolean(report, "googActiveConnection")) activeCandidatePairId = id;
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidatePairStats(report));
                break;
            case "localcandidate":
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, false));
                break;
            case "remotecandidate":
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, true));
                break;
            case "ssrc":
                if ($43635ee3f7940fdc$var$isPresent(report, "packetsReceived")) map.set("rtp-" + id, $43635ee3f7940fdc$var$createRTCInboundRTPStreamStats(report));
                else map.set("rtp-" + id, $43635ee3f7940fdc$var$createRTCOutboundRTPStreamStats(report));
                map.set("track-" + id, $43635ee3f7940fdc$var$createRTCMediaStreamTrackStats(report));
                map.set("codec-" + id, $43635ee3f7940fdc$var$createRTCCodecStats(report));
                break;
            case "googComponent":
                var transportReport = $43635ee3f7940fdc$var$createRTCTransportStats(report);
                transportIds.set(transportReport.selectedCandidatePairId, id);
                map.set(id, $43635ee3f7940fdc$var$createRTCTransportStats(report));
                break;
        }
        return map;
    }, new Map());
    if (activeCandidatePairId) {
        var activeTransportId = transportIds.get(activeCandidatePairId);
        if (activeTransportId) statsMap.get(activeTransportId).dtlsState = "connected";
    }
    return new $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap);
};
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCTransportStats}
 */ function $43635ee3f7940fdc$var$createRTCTransportStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        dtlsState: undefined,
        id: report.id,
        localCertificateId: report.stat("localCertificateId"),
        remoteCertificateId: report.stat("remoteCertificateId"),
        rtcpTransportStatsId: undefined,
        selectedCandidatePairId: report.stat("selectedCandidatePairId"),
        timestamp: Date.parse(report.timestamp),
        type: "transport"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCCodecStats}
 */ function $43635ee3f7940fdc$var$createRTCCodecStats(report) {
    return {
        channels: undefined,
        clockRate: undefined,
        id: report.id,
        implementation: undefined,
        mimeType: report.stat("mediaType") + "/" + report.stat("googCodecName"),
        payloadType: undefined,
        sdpFmtpLine: undefined,
        timestamp: Date.parse(report.timestamp),
        type: "codec"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCMediaStreamTrackStats}
 */ function $43635ee3f7940fdc$var$createRTCMediaStreamTrackStats(report) {
    return {
        audioLevel: $43635ee3f7940fdc$var$isPresent(report, "audioOutputLevel") ? $43635ee3f7940fdc$var$getInt(report, "audioOutputLevel") / $43635ee3f7940fdc$var$OLD_MAX_VOLUME : ($43635ee3f7940fdc$var$getInt(report, "audioInputLevel") || 0) / $43635ee3f7940fdc$var$OLD_MAX_VOLUME,
        detached: undefined,
        echoReturnLoss: $43635ee3f7940fdc$var$getFloat(report, "googEchoCancellationReturnLoss"),
        echoReturnLossEnhancement: $43635ee3f7940fdc$var$getFloat(report, "googEchoCancellationReturnLossEnhancement"),
        ended: undefined,
        frameHeight: $43635ee3f7940fdc$var$isPresent(report, "googFrameHeightReceived") ? $43635ee3f7940fdc$var$getInt(report, "googFrameHeightReceived") : $43635ee3f7940fdc$var$getInt(report, "googFrameHeightSent"),
        frameWidth: $43635ee3f7940fdc$var$isPresent(report, "googFrameWidthReceived") ? $43635ee3f7940fdc$var$getInt(report, "googFrameWidthReceived") : $43635ee3f7940fdc$var$getInt(report, "googFrameWidthSent"),
        framesCorrupted: undefined,
        framesDecoded: $43635ee3f7940fdc$var$getInt(report, "framesDecoded"),
        framesDropped: undefined,
        framesPerSecond: undefined,
        framesReceived: undefined,
        framesSent: $43635ee3f7940fdc$var$getInt(report, "framesEncoded"),
        fullFramesLost: undefined,
        id: report.id,
        kind: report.stat("mediaType"),
        partialFramesLost: undefined,
        remoteSource: undefined,
        ssrcIds: undefined,
        timestamp: Date.parse(report.timestamp),
        trackIdentifier: report.stat("googTrackId"),
        type: "track"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isInbound - Whether to create an inbound stats object, or outbound.
 * @returns {RTCRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, isInbound) {
    return {
        associateStatsId: undefined,
        codecId: "codec-" + report.id,
        firCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googFirsSent") : undefined,
        id: report.id,
        isRemote: undefined,
        mediaType: report.stat("mediaType"),
        nackCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googNacksSent") : $43635ee3f7940fdc$var$getInt(report, "googNacksReceived"),
        pliCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googPlisSent") : $43635ee3f7940fdc$var$getInt(report, "googPlisReceived"),
        qpSum: $43635ee3f7940fdc$var$getInt(report, "qpSum"),
        sliCount: undefined,
        ssrc: report.stat("ssrc"),
        timestamp: Date.parse(report.timestamp),
        trackId: "track-" + report.id,
        transportId: report.stat("transportId")
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCInboundRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCInboundRTPStreamStats(report) {
    var rtp = $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, true);
    Object.assign(rtp, {
        burstDiscardCount: undefined,
        burstDiscardRate: undefined,
        burstLossCount: undefined,
        burstLossRate: undefined,
        burstPacketsDiscarded: undefined,
        burstPacketsLost: undefined,
        bytesReceived: $43635ee3f7940fdc$var$getInt(report, "bytesReceived"),
        fractionLost: undefined,
        framesDecoded: $43635ee3f7940fdc$var$getInt(report, "framesDecoded"),
        gapDiscardRate: undefined,
        gapLossRate: undefined,
        jitter: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googJitterReceived")),
        packetsDiscarded: undefined,
        packetsLost: $43635ee3f7940fdc$var$getInt(report, "packetsLost"),
        packetsReceived: $43635ee3f7940fdc$var$getInt(report, "packetsReceived"),
        packetsRepaired: undefined,
        roundTripTime: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googRtt")),
        type: "inbound-rtp"
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCOutboundRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCOutboundRTPStreamStats(report) {
    var rtp = $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, false);
    Object.assign(rtp, {
        bytesSent: $43635ee3f7940fdc$var$getInt(report, "bytesSent"),
        framesEncoded: $43635ee3f7940fdc$var$getInt(report, "framesEncoded"),
        packetsSent: $43635ee3f7940fdc$var$getInt(report, "packetsSent"),
        remoteTimestamp: undefined,
        targetBitrate: undefined,
        type: "outbound-rtp"
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isRemote - Whether to create for a remote candidate, or local candidate.
 * @returns {RTCIceCandidateStats}
 */ function $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, isRemote) {
    return {
        candidateType: $43635ee3f7940fdc$var$translateCandidateType(report.stat("candidateType")),
        deleted: undefined,
        id: report.id,
        ip: report.stat("ipAddress"),
        isRemote: isRemote,
        port: $43635ee3f7940fdc$var$getInt(report, "portNumber"),
        priority: $43635ee3f7940fdc$var$getFloat(report, "priority"),
        protocol: report.stat("transport"),
        relayProtocol: undefined,
        timestamp: Date.parse(report.timestamp),
        transportId: undefined,
        type: isRemote ? "remote-candidate" : "local-candidate",
        url: undefined
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCandidatePairStats}
 */ function $43635ee3f7940fdc$var$createRTCIceCandidatePairStats(report) {
    return {
        availableIncomingBitrate: undefined,
        availableOutgoingBitrate: undefined,
        bytesReceived: $43635ee3f7940fdc$var$getInt(report, "bytesReceived"),
        bytesSent: $43635ee3f7940fdc$var$getInt(report, "bytesSent"),
        consentRequestsSent: $43635ee3f7940fdc$var$getInt(report, "consentRequestsSent"),
        currentRoundTripTime: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googRtt")),
        id: report.id,
        lastPacketReceivedTimestamp: undefined,
        lastPacketSentTimestamp: undefined,
        localCandidateId: report.stat("localCandidateId"),
        nominated: undefined,
        priority: undefined,
        readable: undefined,
        remoteCandidateId: report.stat("remoteCandidateId"),
        requestsReceived: $43635ee3f7940fdc$var$getInt(report, "requestsReceived"),
        requestsSent: $43635ee3f7940fdc$var$getInt(report, "requestsSent"),
        responsesReceived: $43635ee3f7940fdc$var$getInt(report, "responsesReceived"),
        responsesSent: $43635ee3f7940fdc$var$getInt(report, "responsesSent"),
        retransmissionsReceived: undefined,
        retransmissionsSent: undefined,
        state: undefined,
        timestamp: Date.parse(report.timestamp),
        totalRoundTripTime: undefined,
        transportId: report.stat("googChannelId"),
        type: "candidate-pair",
        writable: $43635ee3f7940fdc$var$getBoolean(report, "googWritable")
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCertificateStats}
 */ function $43635ee3f7940fdc$var$createRTCCertificateStats(report) {
    return {
        base64Certificate: report.stat("googDerBase64"),
        fingerprint: report.stat("googFingerprint"),
        fingerprintAlgorithm: report.stat("googFingerprintAlgorithm"),
        id: report.id,
        issuerCertificateId: report.stat("googIssuerId"),
        timestamp: Date.parse(report.timestamp),
        type: "certificate"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCDataChannelStats}
 */ function $43635ee3f7940fdc$var$createRTCDataChannelStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        datachannelid: report.stat("datachannelid"),
        id: report.id,
        label: report.stat("label"),
        messagesReceived: undefined,
        messagesSent: undefined,
        protocol: report.stat("protocol"),
        state: report.stat("state"),
        timestamp: Date.parse(report.timestamp),
        transportId: report.stat("transportId"),
        type: "data-channel"
    };
}
/**
 * @param {number} inMs - A time in milliseconds
 * @returns {number} The time in seconds
 */ function $43635ee3f7940fdc$var$convertMsToSeconds(inMs) {
    return isNaN(inMs) || inMs === "" ? undefined : parseInt(inMs, 10) / 1000;
}
/**
 * @param {string} type - A type in the legacy format
 * @returns {string} The type adjusted to new standards for known naming changes
 */ function $43635ee3f7940fdc$var$translateCandidateType(type) {
    switch(type){
        case "peerreflexive":
            return "prflx";
        case "serverreflexive":
            return "srflx";
        case "host":
        case "relay":
        default:
            return type;
    }
}
function $43635ee3f7940fdc$var$getInt(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? parseInt(stat, 10) : undefined;
}
function $43635ee3f7940fdc$var$getFloat(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? parseFloat(stat) : undefined;
}
function $43635ee3f7940fdc$var$getBoolean(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? stat === "true" || stat === true : undefined;
}
function $43635ee3f7940fdc$var$isPresent(report, statName) {
    var stat = report.stat(statName);
    return typeof stat !== "undefined" && stat !== "";
}
module.exports.default = $43635ee3f7940fdc$var$MockRTCStatsReport;

});



parcelRegister("3HdIH", function(module, exports) {
"use strict";
var $2b1007c1151c9a8f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $k4N4t = parcelRequire("k4N4t");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");

var $3KLDz = parcelRequire("3KLDz");
var $2b1007c1151c9a8f$var$PSTREAM_VERSION = "1.6";
// In seconds
var $2b1007c1151c9a8f$var$MAX_RECONNECT_TIMEOUT_ALLOWED = 30;
/**
 * Constructor for PStream objects.
 *
 * @exports PStream as Twilio.PStream
 * @memberOf Twilio
 * @borrows EventEmitter#addListener as #addListener
 * @borrows EventEmitter#removeListener as #removeListener
 * @borrows EventEmitter#emit as #emit
 * @borrows EventEmitter#hasListener as #hasListener
 * @constructor
 * @param {string} token The Twilio capabilities JWT
 * @param {string[]} uris An array of PStream endpoint URIs
 * @param {object} [options]
 * @config {boolean} [options.backoffMaxMs=20000] Enable debugging
 */ var $2b1007c1151c9a8f$var$PStream = /** @class */ function(_super) {
    $2b1007c1151c9a8f$var$__extends(PStream, _super);
    function PStream(token, uris, options) {
        var _this = _super.call(this) || this;
        if (!(_this instanceof PStream)) return new PStream(token, uris, options);
        var defaults = {
            TransportFactory: $3KLDz.default
        };
        options = options || {};
        for(var prop in defaults){
            if (prop in options) continue;
            options[prop] = defaults[prop];
        }
        _this.options = options;
        _this.token = token || "";
        _this.status = "disconnected";
        _this.gateway = null;
        _this.region = null;
        _this._messageQueue = [];
        _this._preferredUri = null;
        _this._uris = uris;
        _this._handleTransportClose = _this._handleTransportClose.bind(_this);
        _this._handleTransportError = _this._handleTransportError.bind(_this);
        _this._handleTransportMessage = _this._handleTransportMessage.bind(_this);
        _this._handleTransportOpen = _this._handleTransportOpen.bind(_this);
        _this._log = new $8RS9P.default("PStream");
        // NOTE(mroberts): EventEmitter requires that we catch all errors.
        _this.on("error", function() {
            _this._log.warn("Unexpected error handled in pstream");
        });
        /*
         *events used by device
         *'invite',
         *'ready',
         *'error',
         *'offline',
         *
         *'cancel',
         *'presence',
         *'roster',
         *'answer',
         *'candidate',
         *'hangup'
         */ var self = _this;
        _this.addListener("ready", function() {
            self.status = "ready";
        });
        _this.addListener("offline", function() {
            self.status = "offline";
        });
        _this.addListener("close", function() {
            self._log.info('Received "close" from server. Destroying PStream...');
            self._destroy();
        });
        _this.transport = new _this.options.TransportFactory(_this._uris, {
            backoffMaxMs: _this.options.backoffMaxMs,
            maxPreferredDurationMs: _this.options.maxPreferredDurationMs
        });
        Object.defineProperties(_this, {
            uri: {
                enumerable: true,
                get: function() {
                    return this.transport.uri;
                }
            }
        });
        _this.transport.on("close", _this._handleTransportClose);
        _this.transport.on("error", _this._handleTransportError);
        _this.transport.on("message", _this._handleTransportMessage);
        _this.transport.on("open", _this._handleTransportOpen);
        _this.transport.open();
        return _this;
    }
    return PStream;
}($11OXI.EventEmitter);
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportClose = function() {
    this.emit("transportClose");
    if (this.status !== "disconnected") {
        if (this.status !== "offline") this.emit("offline", this);
        this.status = "disconnected";
    }
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportError = function(error) {
    if (!error) {
        this.emit("error", {
            error: {
                code: 31000,
                message: "Websocket closed without a provided reason",
                twilioError: new $dmfT0.SignalingErrors.ConnectionDisconnected()
            }
        });
        return;
    }
    // We receive some errors without call metadata (just the error). We need to convert these
    // to be contained within the 'error' field so that these errors match the expected format.
    this.emit("error", typeof error.code !== "undefined" ? {
        error: error
    } : error);
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportMessage = function(msg) {
    if (!msg || !msg.data || typeof msg.data !== "string") return;
    var _a = JSON.parse(msg.data), type = _a.type, _b = _a.payload, payload = _b === void 0 ? {} : _b;
    this.gateway = payload.gateway || this.gateway;
    this.region = payload.region || this.region;
    if (type === "error" && payload.error) payload.error.twilioError = new $dmfT0.SignalingErrors.ConnectionError();
    this.emit(type, payload);
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportOpen = function() {
    var _this = this;
    this.status = "connected";
    this.setToken(this.token);
    this.emit("transportOpen");
    var messages = this._messageQueue.splice(0, this._messageQueue.length);
    messages.forEach(function(message) {
        return _this._publish.apply(_this, message);
    });
};
/**
 * @return {string}
 */ $2b1007c1151c9a8f$var$PStream.toString = function() {
    return "[Twilio.PStream class]";
};
$2b1007c1151c9a8f$var$PStream.prototype.toString = function() {
    return "[Twilio.PStream instance]";
};
$2b1007c1151c9a8f$var$PStream.prototype.setToken = function(token) {
    this._log.info("Setting token and publishing listen");
    this.token = token;
    var reconnectTimeout = 0;
    var t = this.options.maxPreferredDurationMs;
    this._log.info("maxPreferredDurationMs:" + t);
    if (typeof t === "number" && t >= 0) reconnectTimeout = Math.min(Math.ceil(t / 1000), $2b1007c1151c9a8f$var$MAX_RECONNECT_TIMEOUT_ALLOWED);
    this._log.info("reconnectTimeout:" + reconnectTimeout);
    var payload = {
        browserinfo: $2b1007c1151c9a8f$var$getBrowserInfo(),
        reconnectTimeout: reconnectTimeout,
        token: token
    };
    this._publish("listen", payload);
};
$2b1007c1151c9a8f$var$PStream.prototype.sendMessage = function(callsid, content, contenttype, messagetype, voiceeventsid) {
    if (contenttype === void 0) contenttype = "application/json";
    var payload = {
        callsid: callsid,
        content: content,
        contenttype: contenttype,
        messagetype: messagetype,
        voiceeventsid: voiceeventsid
    };
    this._publish("message", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.register = function(mediaCapabilities) {
    var regPayload = {
        media: mediaCapabilities
    };
    this._publish("register", regPayload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.invite = function(sdp, callsid, params) {
    var payload = {
        callsid: callsid,
        sdp: sdp,
        twilio: params ? {
            params: params
        } : {}
    };
    this._publish("invite", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reconnect = function(sdp, callsid, reconnect) {
    var payload = {
        callsid: callsid,
        reconnect: reconnect,
        sdp: sdp,
        twilio: {}
    };
    this._publish("invite", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.answer = function(sdp, callsid) {
    this._publish("answer", {
        sdp: sdp,
        callsid: callsid
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.dtmf = function(callsid, digits) {
    this._publish("dtmf", {
        callsid: callsid,
        dtmf: digits
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.hangup = function(callsid, message) {
    var payload = message ? {
        callsid: callsid,
        message: message
    } : {
        callsid: callsid
    };
    this._publish("hangup", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reject = function(callsid) {
    this._publish("reject", {
        callsid: callsid
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reinvite = function(sdp, callsid) {
    this._publish("reinvite", {
        sdp: sdp,
        callsid: callsid
    }, false);
};
$2b1007c1151c9a8f$var$PStream.prototype._destroy = function() {
    this.transport.removeListener("close", this._handleTransportClose);
    this.transport.removeListener("error", this._handleTransportError);
    this.transport.removeListener("message", this._handleTransportMessage);
    this.transport.removeListener("open", this._handleTransportOpen);
    this.transport.close();
    this.emit("offline", this);
};
$2b1007c1151c9a8f$var$PStream.prototype.destroy = function() {
    this._log.info("PStream.destroy() called...");
    this._destroy();
    return this;
};
$2b1007c1151c9a8f$var$PStream.prototype.updatePreferredURI = function(uri) {
    this._preferredUri = uri;
    this.transport.updatePreferredURI(uri);
};
$2b1007c1151c9a8f$var$PStream.prototype.updateURIs = function(uris) {
    this._uris = uris;
    this.transport.updateURIs(this._uris);
};
$2b1007c1151c9a8f$var$PStream.prototype.publish = function(type, payload) {
    return this._publish(type, payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype._publish = function(type, payload, shouldRetry) {
    var msg = JSON.stringify({
        payload: payload,
        type: type,
        version: $2b1007c1151c9a8f$var$PSTREAM_VERSION
    });
    var isSent = !!this.transport.send(msg);
    if (!isSent) {
        this.emit("error", {
            error: {
                code: 31009,
                message: "No transport available to send or receive messages",
                twilioError: new $dmfT0.GeneralErrors.TransportError()
            }
        });
        if (shouldRetry) this._messageQueue.push([
            type,
            payload,
            true
        ]);
    }
};
function $2b1007c1151c9a8f$var$getBrowserInfo() {
    var nav = typeof navigator !== "undefined" ? navigator : {};
    var info = {
        browser: {
            platform: nav.platform || "unknown",
            userAgent: nav.userAgent || "unknown"
        },
        p: "browser",
        plugin: "rtc",
        v: $k4N4t.RELEASE_VERSION
    };
    return info;
}
module.exports.default = $2b1007c1151c9a8f$var$PStream;

});
parcelRegister("3KLDz", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ var $2bba9ec2604db348$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2bba9ec2604db348$var$__assign = module.exports && module.exports.__assign || function() {
    $2bba9ec2604db348$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2bba9ec2604db348$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WSTransportState = void 0;

var $11OXI = parcelRequire("11OXI");

var $4sGX5 = parcelRequire("4sGX5");

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");
var $2bba9ec2604db348$var$WebSocket = globalThis.WebSocket;
var $2bba9ec2604db348$var$CONNECT_SUCCESS_TIMEOUT = 10000;
var $2bba9ec2604db348$var$CONNECT_TIMEOUT = 5000;
var $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT = 15000;
var $2bba9ec2604db348$var$MAX_PREFERRED_DURATION = 15000;
var $2bba9ec2604db348$var$MAX_PRIMARY_DURATION = Infinity;
var $2bba9ec2604db348$var$MAX_PREFERRED_DELAY = 1000;
var $2bba9ec2604db348$var$MAX_PRIMARY_DELAY = 20000;
/**
 * All possible states of WSTransport.
 */ var $2bba9ec2604db348$var$WSTransportState;
(function(WSTransportState) {
    /**
     * The WebSocket is not open but is trying to connect.
     */ WSTransportState["Connecting"] = "connecting";
    /**
     * The WebSocket is not open and is not trying to connect.
     */ WSTransportState["Closed"] = "closed";
    /**
     * The underlying WebSocket is open and active.
     */ WSTransportState["Open"] = "open";
})($2bba9ec2604db348$var$WSTransportState = module.exports.WSTransportState || (module.exports.WSTransportState = {}));
/**
 * WebSocket Transport
 */ var $2bba9ec2604db348$var$WSTransport = /** @class */ function(_super) {
    $2bba9ec2604db348$var$__extends(WSTransport, _super);
    /**
     * @constructor
     * @param uris - List of URI of the endpoints to connect to.
     * @param [options] - Constructor options.
     */ function WSTransport(uris, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The current state of the WSTransport.
         */ _this.state = $2bba9ec2604db348$var$WSTransportState.Closed;
        /**
         * Start timestamp values for backoffs.
         */ _this._backoffStartTime = {
            preferred: null,
            primary: null
        };
        /**
         * The URI that the transport is connecting or connected to. The value of this
         * property is `null` if a connection attempt has not been made yet.
         */ _this._connectedUri = null;
        /**
         * An instance of Logger to use.
         */ _this._log = new $8RS9P.default("WSTransport");
        /**
         * Whether we should attempt to fallback if we receive an applicable error
         * when trying to connect to a signaling endpoint.
         */ _this._shouldFallback = false;
        /**
         * The current uri index that the transport is connected to.
         */ _this._uriIndex = 0;
        /**
         * Move the uri index to the next index
         * If the index is at the end, the index goes back to the first one.
         */ _this._moveUriIndex = function() {
            _this._uriIndex++;
            if (_this._uriIndex >= _this._uris.length) _this._uriIndex = 0;
        };
        /**
         * Called in response to WebSocket#close event.
         */ _this._onSocketClose = function(event) {
            _this._log.error("Received websocket close event code: " + event.code + ". Reason: " + event.reason);
            // 1006: Abnormal close. When the server is unreacheable
            // 1015: TLS Handshake error
            if (event.code === 1006 || event.code === 1015) {
                _this.emit("error", {
                    code: 31005,
                    message: event.reason || "Websocket connection to Twilio's signaling servers were unexpectedly ended. If this is happening consistently, there may be an issue resolving the hostname provided. If a region or an edge is being specified in Device setup, ensure it is valid.",
                    twilioError: new $dmfT0.SignalingErrors.ConnectionError()
                });
                var wasConnected = // Only in Safari and certain Firefox versions, on network interruption, websocket drops right away with 1006
                // Let's check current state if it's open, meaning we should not fallback
                // because we're coming from a previously connected session
                _this.state === $2bba9ec2604db348$var$WSTransportState.Open || // But on other browsers, websocket doesn't drop
                // but our heartbeat catches it, setting the internal state to "Connecting".
                // With this, we should check the previous state instead.
                _this._previousState === $2bba9ec2604db348$var$WSTransportState.Open;
                // Only fallback if this is not the first error
                // and if we were not connected previously
                if (_this._shouldFallback || !wasConnected) _this._moveUriIndex();
                _this._shouldFallback = true;
            }
            _this._closeSocket();
        };
        /**
         * Called in response to WebSocket#error event.
         */ _this._onSocketError = function(err) {
            _this._log.error("WebSocket received error: " + err.message);
            _this.emit("error", {
                code: 31000,
                message: err.message || "WSTransport socket error",
                twilioError: new $dmfT0.SignalingErrors.ConnectionDisconnected()
            });
        };
        /**
         * Called in response to WebSocket#message event.
         */ _this._onSocketMessage = function(message) {
            // Clear heartbeat timeout on any incoming message, as they
            // all indicate an active connection.
            _this._setHeartbeatTimeout();
            // Filter and respond to heartbeats
            if (_this._socket && message.data === "\n") {
                _this._socket.send("\n");
                _this._log.debug("heartbeat");
                return;
            }
            if (message && typeof message.data === "string") _this._log.debug("Received: " + message.data);
            _this.emit("message", message);
        };
        /**
         * Called in response to WebSocket#open event.
         */ _this._onSocketOpen = function() {
            _this._log.info("WebSocket opened successfully.");
            _this._timeOpened = Date.now();
            _this._shouldFallback = false;
            _this._setState($2bba9ec2604db348$var$WSTransportState.Open);
            clearTimeout(_this._connectTimeout);
            _this._resetBackoffs();
            _this._setHeartbeatTimeout();
            _this.emit("open");
        };
        _this._options = $2bba9ec2604db348$var$__assign($2bba9ec2604db348$var$__assign({}, WSTransport.defaultConstructorOptions), options);
        _this._uris = uris;
        _this._backoff = _this._setupBackoffs();
        return _this;
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ WSTransport.prototype.close = function() {
        this._log.info("WSTransport.close() called...");
        this._close();
    };
    /**
     * Attempt to open a WebSocket connection.
     */ WSTransport.prototype.open = function() {
        this._log.info("WSTransport.open() called...");
        if (this._socket && (this._socket.readyState === $2bba9ec2604db348$var$WebSocket.CONNECTING || this._socket.readyState === $2bba9ec2604db348$var$WebSocket.OPEN)) {
            this._log.info("WebSocket already open.");
            return;
        }
        if (this._preferredUri) this._connect(this._preferredUri);
        else this._connect(this._uris[this._uriIndex]);
    };
    /**
     * Send a message through the WebSocket connection.
     * @param message - A message to send to the endpoint.
     * @returns Whether the message was sent.
     */ WSTransport.prototype.send = function(message) {
        this._log.debug("Sending: " + message);
        // We can't send the message if the WebSocket isn't open
        if (!this._socket || this._socket.readyState !== $2bba9ec2604db348$var$WebSocket.OPEN) {
            this._log.debug("Cannot send message. WebSocket is not open.");
            return false;
        }
        try {
            this._socket.send(message);
        } catch (e) {
            // Some unknown error occurred. Reset the socket to get a fresh session.
            this._log.error("Error while sending message:", e.message);
            this._closeSocket();
            return false;
        }
        return true;
    };
    /**
     * Update the preferred URI to connect to. Useful for Call signaling
     * reconnection, which requires connecting on the same edge. If `null` is
     * passed, the preferred URI is unset and the original `uris` array and
     * `uriIndex` is used to determine the signaling URI to connect to.
     * @param uri
     */ WSTransport.prototype.updatePreferredURI = function(uri) {
        this._preferredUri = uri;
    };
    /**
     * Update acceptable URIs to reconnect to. Resets the URI index to 0.
     */ WSTransport.prototype.updateURIs = function(uris) {
        if (typeof uris === "string") uris = [
            uris
        ];
        this._uris = uris;
        this._uriIndex = 0;
    };
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ WSTransport.prototype._close = function() {
        this._setState($2bba9ec2604db348$var$WSTransportState.Closed);
        this._closeSocket();
    };
    /**
     * Close the WebSocket and remove all event listeners.
     */ WSTransport.prototype._closeSocket = function() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._heartbeatTimeout);
        this._log.info("Closing and cleaning up WebSocket...");
        if (!this._socket) {
            this._log.info("No WebSocket to clean up.");
            return;
        }
        this._socket.removeEventListener("close", this._onSocketClose);
        this._socket.removeEventListener("error", this._onSocketError);
        this._socket.removeEventListener("message", this._onSocketMessage);
        this._socket.removeEventListener("open", this._onSocketOpen);
        if (this._socket.readyState === $2bba9ec2604db348$var$WebSocket.CONNECTING || this._socket.readyState === $2bba9ec2604db348$var$WebSocket.OPEN) this._socket.close();
        // Reset backoff counter if connection was open for long enough to be considered successful
        if (this._timeOpened && Date.now() - this._timeOpened > $2bba9ec2604db348$var$CONNECT_SUCCESS_TIMEOUT) this._resetBackoffs();
        if (this.state !== $2bba9ec2604db348$var$WSTransportState.Closed) this._performBackoff();
        delete this._socket;
        this.emit("close");
    };
    /**
     * Attempt to connect to the endpoint via WebSocket.
     * @param [uri] - URI string to connect to.
     * @param [retryCount] - Retry number, if this is a retry. Undefined if
     *   first attempt, 1+ if a retry.
     */ WSTransport.prototype._connect = function(uri, retryCount) {
        var _this = this;
        this._log.info(typeof retryCount === "number" ? "Attempting to reconnect (retry #" + retryCount + ")..." : "Attempting to connect...");
        this._closeSocket();
        this._setState($2bba9ec2604db348$var$WSTransportState.Connecting);
        this._connectedUri = uri;
        try {
            this._socket = new this._options.WebSocket(this._connectedUri);
        } catch (e) {
            this._log.error("Could not connect to endpoint:", e.message);
            this._close();
            this.emit("error", {
                code: 31000,
                message: e.message || "Could not connect to " + this._connectedUri,
                twilioError: new $dmfT0.SignalingErrors.ConnectionDisconnected()
            });
            return;
        }
        this._socket.addEventListener("close", this._onSocketClose);
        this._socket.addEventListener("error", this._onSocketError);
        this._socket.addEventListener("message", this._onSocketMessage);
        this._socket.addEventListener("open", this._onSocketOpen);
        delete this._timeOpened;
        this._connectTimeout = setTimeout(function() {
            _this._log.info("WebSocket connection attempt timed out.");
            _this._moveUriIndex();
            _this._closeSocket();
        }, this._options.connectTimeoutMs);
    };
    /**
     * Perform a backoff. If a preferred URI is set (not null), then backoff
     * using the preferred mechanism. Otherwise, use the primary mechanism.
     */ WSTransport.prototype._performBackoff = function() {
        if (this._preferredUri) {
            this._log.info("Preferred URI set; backing off.");
            this._backoff.preferred.backoff();
        } else {
            this._log.info("Preferred URI not set; backing off.");
            this._backoff.primary.backoff();
        }
    };
    /**
     * Reset both primary and preferred backoff mechanisms.
     */ WSTransport.prototype._resetBackoffs = function() {
        this._backoff.preferred.reset();
        this._backoff.primary.reset();
        this._backoffStartTime.preferred = null;
        this._backoffStartTime.primary = null;
    };
    /**
     * Set a timeout to reconnect after HEARTBEAT_TIMEOUT milliseconds
     *   have passed without receiving a message over the WebSocket.
     */ WSTransport.prototype._setHeartbeatTimeout = function() {
        var _this = this;
        clearTimeout(this._heartbeatTimeout);
        this._heartbeatTimeout = setTimeout(function() {
            _this._log.info("No messages received in " + $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT / 1000 + " seconds. Reconnecting...");
            _this._shouldFallback = true;
            _this._closeSocket();
        }, $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT);
    };
    /**
     * Set the current and previous state
     */ WSTransport.prototype._setState = function(state) {
        this._previousState = this.state;
        this.state = state;
    };
    /**
     * Set up the primary and preferred backoff mechanisms.
     */ WSTransport.prototype._setupBackoffs = function() {
        var _this = this;
        var preferredBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPreferredDelayMs,
            min: 100
        };
        this._log.info("Initializing preferred transport backoff using config: ", preferredBackoffConfig);
        var preferredBackoff = new $4sGX5.default(preferredBackoffConfig);
        preferredBackoff.on("backoff", function(attempt, delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Preferred backoff initiated but transport state is closed; not attempting a connection.");
                return;
            }
            _this._log.info("Will attempt to reconnect Websocket to preferred URI in " + delay + "ms");
            if (attempt === 0) {
                _this._backoffStartTime.preferred = Date.now();
                _this._log.info("Preferred backoff start; " + _this._backoffStartTime.preferred);
            }
        });
        preferredBackoff.on("ready", function(attempt, _delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Preferred backoff ready but transport state is closed; not attempting a connection.");
                return;
            }
            if (_this._backoffStartTime.preferred === null) {
                _this._log.info("Preferred backoff start time invalid; not attempting a connection.");
                return;
            }
            if (Date.now() - _this._backoffStartTime.preferred > _this._options.maxPreferredDurationMs) {
                _this._log.info("Max preferred backoff attempt time exceeded; falling back to primary backoff.");
                _this._preferredUri = null;
                _this._backoff.primary.backoff();
                return;
            }
            if (typeof _this._preferredUri !== "string") {
                _this._log.info("Preferred URI cleared; falling back to primary backoff.");
                _this._preferredUri = null;
                _this._backoff.primary.backoff();
                return;
            }
            _this._connect(_this._preferredUri, attempt + 1);
        });
        var primaryBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPrimaryDelayMs,
            // We only want a random initial delay if there are any fallback edges
            // Initial delay between 1s and 5s both inclusive
            min: this._uris && this._uris.length > 1 ? Math.floor(Math.random() * 4001) + 1000 : 100
        };
        this._log.info("Initializing primary transport backoff using config: ", primaryBackoffConfig);
        var primaryBackoff = new $4sGX5.default(primaryBackoffConfig);
        primaryBackoff.on("backoff", function(attempt, delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Primary backoff initiated but transport state is closed; not attempting a connection.");
                return;
            }
            _this._log.info("Will attempt to reconnect WebSocket in " + delay + "ms");
            if (attempt === 0) {
                _this._backoffStartTime.primary = Date.now();
                _this._log.info("Primary backoff start; " + _this._backoffStartTime.primary);
            }
        });
        primaryBackoff.on("ready", function(attempt, _delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Primary backoff ready but transport state is closed; not attempting a connection.");
                return;
            }
            if (_this._backoffStartTime.primary === null) {
                _this._log.info("Primary backoff start time invalid; not attempting a connection.");
                return;
            }
            if (Date.now() - _this._backoffStartTime.primary > _this._options.maxPrimaryDurationMs) {
                _this._log.info("Max primary backoff attempt time exceeded; not attempting a connection.");
                return;
            }
            _this._connect(_this._uris[_this._uriIndex], attempt + 1);
        });
        return {
            preferred: preferredBackoff,
            primary: primaryBackoff
        };
    };
    Object.defineProperty(WSTransport.prototype, "uri", {
        /**
         * The uri the transport is currently connected to
         */ get: function() {
            return this._connectedUri;
        },
        enumerable: false,
        configurable: true
    });
    WSTransport.defaultConstructorOptions = {
        WebSocket: $2bba9ec2604db348$var$WebSocket,
        connectTimeoutMs: $2bba9ec2604db348$var$CONNECT_TIMEOUT,
        maxPreferredDelayMs: $2bba9ec2604db348$var$MAX_PREFERRED_DELAY,
        maxPreferredDurationMs: $2bba9ec2604db348$var$MAX_PREFERRED_DURATION,
        maxPrimaryDelayMs: $2bba9ec2604db348$var$MAX_PRIMARY_DELAY,
        maxPrimaryDurationMs: $2bba9ec2604db348$var$MAX_PRIMARY_DURATION
    };
    return WSTransport;
}($11OXI.EventEmitter);
module.exports.default = $2bba9ec2604db348$var$WSTransport;

});


parcelRegister("cu2BD", function(module, exports) {
"use strict";
var $916a4edaaacc98cf$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRegionShortcode = module.exports.getChunderURIs = module.exports.createSignalingEndpointURL = module.exports.createEventGatewayURI = module.exports.defaultEdge = module.exports.regionToEdge = module.exports.regionShortcodes = module.exports.Region = module.exports.Edge = void 0;

var $dmfT0 = parcelRequire("dmfT0");
/**
 * Valid edges.
 * @private
 */ var $916a4edaaacc98cf$var$Edge;
(function(Edge) {
    /**
     * Public edges
     */ Edge["Sydney"] = "sydney";
    Edge["SaoPaulo"] = "sao-paulo";
    Edge["Dublin"] = "dublin";
    Edge["Frankfurt"] = "frankfurt";
    Edge["Tokyo"] = "tokyo";
    Edge["Singapore"] = "singapore";
    Edge["Ashburn"] = "ashburn";
    Edge["Umatilla"] = "umatilla";
    Edge["Roaming"] = "roaming";
    /**
     * Interconnect edges
     */ Edge["AshburnIx"] = "ashburn-ix";
    Edge["SanJoseIx"] = "san-jose-ix";
    Edge["LondonIx"] = "london-ix";
    Edge["FrankfurtIx"] = "frankfurt-ix";
    Edge["SingaporeIx"] = "singapore-ix";
    Edge["SydneyIx"] = "sydney-ix";
    Edge["TokyoIx"] = "tokyo-ix";
})($916a4edaaacc98cf$var$Edge = module.exports.Edge || (module.exports.Edge = {}));
/**
 * Valid current regions.
 *
 * @deprecated
 *
 * CLIENT-6831
 * This is no longer used or updated for checking validity of regions in the
 * SDK. We now allow any string to be passed for region. Invalid regions won't
 * be able to connect, and won't throw an exception.
 *
 * CLIENT-7519
 * This is used again to temporarily convert edge values to regions as part of
 * Phase 1 Regional. This is still considered deprecated.
 *
 * @private
 */ var $916a4edaaacc98cf$var$Region;
(function(Region) {
    Region["Au1"] = "au1";
    Region["Au1Ix"] = "au1-ix";
    Region["Br1"] = "br1";
    Region["De1"] = "de1";
    Region["De1Ix"] = "de1-ix";
    Region["Gll"] = "gll";
    Region["Ie1"] = "ie1";
    Region["Ie1Ix"] = "ie1-ix";
    Region["Ie1Tnx"] = "ie1-tnx";
    Region["Jp1"] = "jp1";
    Region["Jp1Ix"] = "jp1-ix";
    Region["Sg1"] = "sg1";
    Region["Sg1Ix"] = "sg1-ix";
    Region["Sg1Tnx"] = "sg1-tnx";
    Region["Us1"] = "us1";
    Region["Us1Ix"] = "us1-ix";
    Region["Us1Tnx"] = "us1-tnx";
    Region["Us2"] = "us2";
    Region["Us2Ix"] = "us2-ix";
    Region["Us2Tnx"] = "us2-tnx";
})($916a4edaaacc98cf$var$Region = module.exports.Region || (module.exports.Region = {}));
/**
 * Region shortcodes. Maps the full region name from AWS to the Twilio shortcode.
 * @private
 */ module.exports.regionShortcodes = {
    ASIAPAC_SINGAPORE: $916a4edaaacc98cf$var$Region.Sg1,
    ASIAPAC_SYDNEY: $916a4edaaacc98cf$var$Region.Au1,
    ASIAPAC_TOKYO: $916a4edaaacc98cf$var$Region.Jp1,
    EU_FRANKFURT: $916a4edaaacc98cf$var$Region.De1,
    EU_IRELAND: $916a4edaaacc98cf$var$Region.Ie1,
    SOUTH_AMERICA_SAO_PAULO: $916a4edaaacc98cf$var$Region.Br1,
    US_EAST_VIRGINIA: $916a4edaaacc98cf$var$Region.Us1,
    US_WEST_OREGON: $916a4edaaacc98cf$var$Region.Us2
};
/**
 * Region to edge mapping, as part of Phase 1 Regional (CLIENT-7519).
 * Temporary.
 * @private
 */ module.exports.regionToEdge = ($916a4edaaacc98cf$var$_a = {}, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Au1] = $916a4edaaacc98cf$var$Edge.Sydney, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Br1] = $916a4edaaacc98cf$var$Edge.SaoPaulo, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1] = $916a4edaaacc98cf$var$Edge.Dublin, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.De1] = $916a4edaaacc98cf$var$Edge.Frankfurt, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Jp1] = $916a4edaaacc98cf$var$Edge.Tokyo, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1] = $916a4edaaacc98cf$var$Edge.Singapore, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1] = $916a4edaaacc98cf$var$Edge.Ashburn, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2] = $916a4edaaacc98cf$var$Edge.Umatilla, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Gll] = $916a4edaaacc98cf$var$Edge.Roaming, /**
     * Interconnect edges
     */ $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1Ix] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2Ix] = $916a4edaaacc98cf$var$Edge.SanJoseIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1Ix] = $916a4edaaacc98cf$var$Edge.LondonIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.De1Ix] = $916a4edaaacc98cf$var$Edge.FrankfurtIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1Ix] = $916a4edaaacc98cf$var$Edge.SingaporeIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Au1Ix] = $916a4edaaacc98cf$var$Edge.SydneyIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Jp1Ix] = $916a4edaaacc98cf$var$Edge.TokyoIx, /**
     * Tnx regions
     */ $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1Tnx] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2Tnx] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1Tnx] = $916a4edaaacc98cf$var$Edge.LondonIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1Tnx] = $916a4edaaacc98cf$var$Edge.SingaporeIx, $916a4edaaacc98cf$var$_a);
/**
 * The default edge to connect to and create a chunder uri from, if the edge
 * parameter is not specified during setup in `Device`.
 * @constant
 */ module.exports.defaultEdge = $916a4edaaacc98cf$var$Edge.Roaming;
/**
 * The default event gateway URI to publish to.
 * @constant
 * @private
 */ var $916a4edaaacc98cf$var$defaultEventGatewayURI = "eventgw.twilio.com";
/**
 * String template for an edge chunder URI
 * @param edge - The edge.
 */ function $916a4edaaacc98cf$var$createChunderEdgeURI(edge) {
    return "voice-js." + edge + ".twilio.com";
}
/**
 * String template for a region insights URI
 * @param region - The region.
 */ function $916a4edaaacc98cf$var$createEventGatewayURI(region) {
    return region ? "eventgw." + region + ".twilio.com" : $916a4edaaacc98cf$var$defaultEventGatewayURI;
}
module.exports.createEventGatewayURI = $916a4edaaacc98cf$var$createEventGatewayURI;
/**
 * Create a signaling endpoint URL to connect a websocket to from a chunder URI.
 * @param uri the chunder URI to create a signaling endpoint URL for
 */ function $916a4edaaacc98cf$var$createSignalingEndpointURL(uri) {
    return "wss://" + uri + "/signal";
}
module.exports.createSignalingEndpointURL = $916a4edaaacc98cf$var$createSignalingEndpointURL;
/**
 * Get the URI associated with the passed edge.
 * @private
 * @param edge - A string or an array of edge values
 * @returns An array of chunder URIs
 */ function $916a4edaaacc98cf$var$getChunderURIs(edge) {
    if (!!edge && typeof edge !== "string" && !Array.isArray(edge)) throw new $dmfT0.InvalidArgumentError("If `edge` is provided, it must be of type `string` or an array of strings.");
    var uris;
    if (edge) {
        var edgeParams = Array.isArray(edge) ? edge : [
            edge
        ];
        uris = edgeParams.map(function(param) {
            return $916a4edaaacc98cf$var$createChunderEdgeURI(param);
        });
    } else uris = [
        $916a4edaaacc98cf$var$createChunderEdgeURI(module.exports.defaultEdge)
    ];
    return uris;
}
module.exports.getChunderURIs = $916a4edaaacc98cf$var$getChunderURIs;
/**
 * Get the region shortcode by its full AWS region string.
 *
 * @private
 * @param region - The region's full AWS string.
 */ function $916a4edaaacc98cf$var$getRegionShortcode(region) {
    return module.exports.regionShortcodes[region] || null;
}
module.exports.getRegionShortcode = $916a4edaaacc98cf$var$getRegionShortcode;

});

parcelRegister("5Qlbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PeerConnection = module.exports.getMediaEngine = module.exports.enabled = void 0;

var $kuLKK = parcelRequire("kuLKK");
module.exports.PeerConnection = $kuLKK.default;

var $gCFre = parcelRequire("gCFre");
function $44123d2d42b91b4b$var$enabled() {
    return $gCFre.default.test();
}
module.exports.enabled = $44123d2d42b91b4b$var$enabled;
function $44123d2d42b91b4b$var$getMediaEngine() {
    return typeof RTCIceGatherer !== "undefined" ? "ORTC" : "WebRTC";
}
module.exports.getMediaEngine = $44123d2d42b91b4b$var$getMediaEngine;

});
parcelRegister("kuLKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dmfT0 = parcelRequire("dmfT0");

var $8RS9P = parcelRequire("8RS9P");

var $f8R8g = parcelRequire("f8R8g");

var $gCFre = parcelRequire("gCFre");

var $82FG2 = parcelRequire("82FG2");
var $eebba6bea300b063$var$ICE_GATHERING_TIMEOUT = 15000;
var $eebba6bea300b063$var$ICE_GATHERING_FAIL_NONE = "none";
var $eebba6bea300b063$var$ICE_GATHERING_FAIL_TIMEOUT = "timeout";
var $eebba6bea300b063$var$INITIAL_ICE_CONNECTION_STATE = "new";
var $eebba6bea300b063$var$VOLUME_INTERVAL_MS = 50;
/**
 * @typedef {Object} PeerConnection
 * @param audioHelper
 * @param pstream
 * @param options
 * @return {PeerConnection}
 * @constructor
 */ function $eebba6bea300b063$var$PeerConnection(audioHelper, pstream, options) {
    if (!audioHelper || !pstream) throw new $dmfT0.InvalidArgumentError("Audiohelper, and pstream are required arguments");
    if (!(this instanceof $eebba6bea300b063$var$PeerConnection)) return new $eebba6bea300b063$var$PeerConnection(audioHelper, pstream, options);
    this._log = new $8RS9P.default("PeerConnection");
    function noop() {
        this._log.warn("Unexpected noop call in peerconnection");
    }
    this.onaudio = noop;
    this.onopen = noop;
    this.onerror = noop;
    this.onclose = noop;
    this.ondisconnected = noop;
    this.onfailed = noop;
    this.onconnected = noop;
    this.onreconnected = noop;
    this.onsignalingstatechange = noop;
    this.ondtlstransportstatechange = noop;
    this.onicegatheringfailure = noop;
    this.onicegatheringstatechange = noop;
    this.oniceconnectionstatechange = noop;
    this.onpcconnectionstatechange = noop;
    this.onicecandidate = noop;
    this.onselectedcandidatepairchange = noop;
    this.onvolume = noop;
    this.version = null;
    this.pstream = pstream;
    this.stream = null;
    this.sinkIds = new Set([
        "default"
    ]);
    this.outputs = new Map();
    this.status = "connecting";
    this.callSid = null;
    this.isMuted = false;
    var AudioContext = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
    this._isSinkSupported = !!AudioContext && typeof HTMLAudioElement !== "undefined" && HTMLAudioElement.prototype.setSinkId;
    // NOTE(mmalavalli): Since each Connection creates its own AudioContext,
    // after 6 instances an exception is thrown. Refer https://www.w3.org/2011/audio/track/issues/3.
    // In order to get around it, we are re-using the Device's AudioContext.
    this._audioContext = AudioContext && audioHelper._audioContext;
    this._audioHelper = audioHelper;
    this._hasIceCandidates = false;
    this._hasIceGatheringFailures = false;
    this._iceGatheringTimeoutId = null;
    this._masterAudio = null;
    this._masterAudioDeviceId = null;
    this._mediaStreamSource = null;
    this._dtmfSender = null;
    this._dtmfSenderUnsupported = false;
    this._callEvents = [];
    this._nextTimeToPublish = Date.now();
    this._onAnswerOrRinging = noop;
    this._onHangup = noop;
    this._remoteStream = null;
    this._shouldManageStream = true;
    this._iceState = $eebba6bea300b063$var$INITIAL_ICE_CONNECTION_STATE;
    this._isUnifiedPlan = options.isUnifiedPlan;
    this.options = options = options || {};
    this.navigator = options.navigator || (typeof navigator !== "undefined" ? navigator : null);
    this.util = options.util || $f8R8g;
    this.codecPreferences = options.codecPreferences;
    return this;
}
$eebba6bea300b063$var$PeerConnection.prototype.uri = function() {
    return this._uri;
};
/**
 * Open the underlying RTCPeerConnection with a MediaStream obtained by
 *   passed constraints. The resulting MediaStream is created internally
 *   and will therefore be managed and destroyed internally.
 * @param {MediaStreamConstraints} constraints
 */ $eebba6bea300b063$var$PeerConnection.prototype.openDefaultDeviceWithConstraints = function(constraints) {
    return this._audioHelper._openDefaultDeviceWithConstraints(constraints).then(this._setInputTracksFromStream.bind(this, false));
};
/**
 * Replace the existing input audio tracks with the audio tracks from the
 *   passed input audio stream. We re-use the existing stream because
 *   the AnalyzerNode is bound to the stream.
 * @param {MediaStream} stream
 */ $eebba6bea300b063$var$PeerConnection.prototype.setInputTracksFromStream = function(stream) {
    var self = this;
    return this._setInputTracksFromStream(true, stream).then(function() {
        self._shouldManageStream = false;
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._createAnalyser = function(audioContext, options) {
    options = Object.assign({
        fftSize: 32,
        smoothingTimeConstant: 0.3
    }, options);
    var analyser = audioContext.createAnalyser();
    // tslint:disable-next-line
    for(var field in options)analyser[field] = options[field];
    return analyser;
};
$eebba6bea300b063$var$PeerConnection.prototype._setVolumeHandler = function(handler) {
    this.onvolume = handler;
};
$eebba6bea300b063$var$PeerConnection.prototype._startPollingVolume = function() {
    if (!this._audioContext || !this.stream || !this._remoteStream) return;
    var audioContext = this._audioContext;
    var inputAnalyser = this._inputAnalyser = this._createAnalyser(audioContext);
    var inputBufferLength = inputAnalyser.frequencyBinCount;
    var inputDataArray = new Uint8Array(inputBufferLength);
    this._inputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    var outputAnalyser = this._outputAnalyser = this._createAnalyser(audioContext);
    var outputBufferLength = outputAnalyser.frequencyBinCount;
    var outputDataArray = new Uint8Array(outputBufferLength);
    this._outputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    this._updateInputStreamSource(this.stream);
    this._updateOutputStreamSource(this._remoteStream);
    var self = this;
    setTimeout(function emitVolume() {
        if (!self._audioContext) return;
        else if (self.status === "closed") {
            self._inputAnalyser.disconnect();
            self._outputAnalyser.disconnect();
            self._inputAnalyser2.disconnect();
            self._outputAnalyser2.disconnect();
            return;
        }
        self._inputAnalyser.getByteFrequencyData(inputDataArray);
        var inputVolume = self.util.average(inputDataArray);
        self._inputAnalyser2.getByteFrequencyData(inputDataArray);
        var inputVolume2 = self.util.average(inputDataArray);
        self._outputAnalyser.getByteFrequencyData(outputDataArray);
        var outputVolume = self.util.average(outputDataArray);
        self._outputAnalyser2.getByteFrequencyData(outputDataArray);
        var outputVolume2 = self.util.average(outputDataArray);
        self.onvolume(inputVolume / 255, outputVolume / 255, inputVolume2, outputVolume2);
        setTimeout(emitVolume, $eebba6bea300b063$var$VOLUME_INTERVAL_MS);
    }, $eebba6bea300b063$var$VOLUME_INTERVAL_MS);
};
$eebba6bea300b063$var$PeerConnection.prototype._stopStream = function _stopStream() {
    // We shouldn't stop the tracks if they were not created inside
    //   this PeerConnection.
    if (!this._shouldManageStream) return;
    this._audioHelper._stopDefaultInputDeviceStream();
};
/**
 * Update the stream source with the new input audio stream.
 * @param {MediaStream} stream
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._updateInputStreamSource = function(stream) {
    if (this._inputStreamSource) this._inputStreamSource.disconnect();
    try {
        this._inputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._inputStreamSource.connect(this._inputAnalyser);
        this._inputStreamSource.connect(this._inputAnalyser2);
    } catch (ex) {
        this._log.warn("Unable to update input MediaStreamSource", ex);
        this._inputStreamSource = null;
    }
};
/**
 * Update the stream source with the new ouput audio stream.
 * @param {MediaStream} stream
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._updateOutputStreamSource = function(stream) {
    if (this._outputStreamSource) this._outputStreamSource.disconnect();
    try {
        this._outputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._outputStreamSource.connect(this._outputAnalyser);
        this._outputStreamSource.connect(this._outputAnalyser2);
    } catch (ex) {
        this._log.warn("Unable to update output MediaStreamSource", ex);
        this._outputStreamSource = null;
    }
};
/**
 * Replace the tracks of the current stream with new tracks. We do this rather than replacing the
 *   whole stream because AnalyzerNodes are bound to a stream.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksFromStream = function(shouldClone, newStream) {
    return this._isUnifiedPlan ? this._setInputTracksForUnifiedPlan(shouldClone, newStream) : this._setInputTracksForPlanB(shouldClone, newStream);
};
/**
 * Replace the tracks of the current stream with new tracks using the 'plan-b' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksForPlanB = function(shouldClone, newStream) {
    var _this = this;
    if (!newStream) return Promise.reject(new $dmfT0.InvalidArgumentError("Can not set input stream to null while in a call"));
    if (!newStream.getAudioTracks().length) return Promise.reject(new $dmfT0.InvalidArgumentError("Supplied input stream has no audio tracks"));
    var localStream = this.stream;
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
    else {
        this._stopStream();
        $eebba6bea300b063$var$removeStream(this.version.pc, localStream);
        localStream.getAudioTracks().forEach(localStream.removeTrack, localStream);
        newStream.getAudioTracks().forEach(localStream.addTrack, localStream);
        $eebba6bea300b063$var$addStream(this.version.pc, newStream);
        this._updateInputStreamSource(this.stream);
    }
    // Apply mute settings to new input track
    this.mute(this.isMuted);
    if (!this.version) return Promise.resolve(this.stream);
    return new Promise(function(resolve, reject) {
        _this.version.createOffer(_this.options.maxAverageBitrate, _this.codecPreferences, {
            audio: true
        }, function() {
            _this.version.processAnswer(_this.codecPreferences, _this._answerSdp, function() {
                resolve(_this.stream);
            }, reject);
        }, reject);
    });
};
/**
 * Replace the tracks of the current stream with new tracks using the 'unified-plan' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksForUnifiedPlan = function(shouldClone, newStream) {
    var _this = this;
    if (!newStream) return Promise.reject(new $dmfT0.InvalidArgumentError("Can not set input stream to null while in a call"));
    if (!newStream.getAudioTracks().length) return Promise.reject(new $dmfT0.InvalidArgumentError("Supplied input stream has no audio tracks"));
    var localStream = this.stream;
    var getStreamPromise = function() {
        // Apply mute settings to new input track
        _this.mute(_this.isMuted);
        return Promise.resolve(_this.stream);
    };
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
    else {
        // If the call was started with gUM, and we are now replacing that track with an
        // external stream's tracks, we should stop the old managed track.
        if (this._shouldManageStream) this._stopStream();
        if (!this._sender) this._sender = this.version.pc.getSenders()[0];
        return this._sender.replaceTrack(newStream.getAudioTracks()[0]).then(function() {
            _this._updateInputStreamSource(newStream);
            _this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
            return getStreamPromise();
        });
    }
    return getStreamPromise();
};
$eebba6bea300b063$var$PeerConnection.prototype._onInputDevicesChanged = function() {
    if (!this.stream) return;
    // If all of our active tracks are ended, then our active input was lost
    var activeInputWasLost = this.stream.getAudioTracks().every(function(track) {
        return track.readyState === "ended";
    });
    // We only want to act if we manage the stream in PeerConnection (It was created
    // here, rather than passed in.)
    if (activeInputWasLost && this._shouldManageStream) this.openDefaultDeviceWithConstraints({
        audio: true
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._onIceGatheringFailure = function(type) {
    this._hasIceGatheringFailures = true;
    this.onicegatheringfailure(type);
};
$eebba6bea300b063$var$PeerConnection.prototype._onMediaConnectionStateChange = function(newState) {
    var previousState = this._iceState;
    if (previousState === newState || newState !== "connected" && newState !== "disconnected" && newState !== "failed") return;
    this._iceState = newState;
    var message;
    switch(newState){
        case "connected":
            if (previousState === "disconnected" || previousState === "failed") {
                message = "ICE liveliness check succeeded. Connection with Twilio restored";
                this._log.info(message);
                this.onreconnected(message);
            } else {
                message = "Media connection established.";
                this._log.info(message);
                this.onconnected(message);
            }
            this._stopIceGatheringTimeout();
            this._hasIceGatheringFailures = false;
            break;
        case "disconnected":
            message = "ICE liveliness check failed. May be having trouble connecting to Twilio";
            this._log.warn(message);
            this.ondisconnected(message);
            break;
        case "failed":
            message = "Connection with Twilio was interrupted.";
            this._log.warn(message);
            this.onfailed(message);
            break;
    }
};
$eebba6bea300b063$var$PeerConnection.prototype._setSinkIds = function(sinkIds) {
    if (!this._isSinkSupported) return Promise.reject(new $dmfT0.NotSupportedError("Audio output selection is not supported by this browser"));
    this.sinkIds = new Set(sinkIds.forEach ? sinkIds : [
        sinkIds
    ]);
    return this.version ? this._updateAudioOutputs() : Promise.resolve();
};
/**
 * Start timeout for ICE Gathering
 */ $eebba6bea300b063$var$PeerConnection.prototype._startIceGatheringTimeout = function startIceGatheringTimeout() {
    var _this = this;
    this._stopIceGatheringTimeout();
    this._iceGatheringTimeoutId = setTimeout(function() {
        _this._onIceGatheringFailure($eebba6bea300b063$var$ICE_GATHERING_FAIL_TIMEOUT);
    }, $eebba6bea300b063$var$ICE_GATHERING_TIMEOUT);
};
/**
 * Stop timeout for ICE Gathering
 */ $eebba6bea300b063$var$PeerConnection.prototype._stopIceGatheringTimeout = function stopIceGatheringTimeout() {
    clearInterval(this._iceGatheringTimeoutId);
};
$eebba6bea300b063$var$PeerConnection.prototype._updateAudioOutputs = function updateAudioOutputs() {
    var addedOutputIds = Array.from(this.sinkIds).filter(function(id) {
        return !this.outputs.has(id);
    }, this);
    var removedOutputIds = Array.from(this.outputs.keys()).filter(function(id) {
        return !this.sinkIds.has(id);
    }, this);
    var self = this;
    var createOutputPromises = addedOutputIds.map(this._createAudioOutput, this);
    return Promise.all(createOutputPromises).then(function() {
        return Promise.all(removedOutputIds.map(self._removeAudioOutput, self));
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._createAudio = function createAudio(arr) {
    var audio = new Audio(arr);
    this.onaudio(audio);
    return audio;
};
$eebba6bea300b063$var$PeerConnection.prototype._createAudioOutput = function createAudioOutput(id) {
    var dest = null;
    if (this._mediaStreamSource) {
        dest = this._audioContext.createMediaStreamDestination();
        this._mediaStreamSource.connect(dest);
    }
    var audio = this._createAudio();
    $eebba6bea300b063$var$setAudioSource(audio, dest && dest.stream ? dest.stream : this.pcStream);
    var self = this;
    return audio.setSinkId(id).then(function() {
        return audio.play();
    }).then(function() {
        self.outputs.set(id, {
            audio: audio,
            dest: dest
        });
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._removeAudioOutputs = function removeAudioOutputs() {
    if (this._masterAudio && typeof this._masterAudioDeviceId !== "undefined") {
        this._disableOutput(this, this._masterAudioDeviceId);
        this.outputs.delete(this._masterAudioDeviceId);
        this._masterAudioDeviceId = null;
        // Release the audio resources before deleting the audio
        if (!this._masterAudio.paused) this._masterAudio.pause();
        if (typeof this._masterAudio.srcObject !== "undefined") this._masterAudio.srcObject = null;
        else this._masterAudio.src = "";
        this._masterAudio = null;
    }
    return Array.from(this.outputs.keys()).map(this._removeAudioOutput, this);
};
$eebba6bea300b063$var$PeerConnection.prototype._disableOutput = function disableOutput(pc, id) {
    var output = pc.outputs.get(id);
    if (!output) return;
    if (output.audio) {
        output.audio.pause();
        output.audio.src = "";
    }
    if (output.dest) output.dest.disconnect();
};
/**
 * Disable a non-master output, and update the master output to assume its state. This
 *   is called when the device ID assigned to the master output has been removed from
 *   active devices. We can not simply remove the master audio output, so we must
 *   instead reassign it.
 * @private
 * @param {PeerConnection} pc
 * @param {string} masterId - The current device ID assigned to the master audio element.
 */ $eebba6bea300b063$var$PeerConnection.prototype._reassignMasterOutput = function reassignMasterOutput(pc, masterId) {
    var masterOutput = pc.outputs.get(masterId);
    pc.outputs.delete(masterId);
    var self = this;
    var activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    var idToReplace = typeof activeDeviceId === "string" ? activeDeviceId : "default";
    return masterOutput.audio.setSinkId(idToReplace).then(function() {
        self._disableOutput(pc, idToReplace);
        pc.outputs.set(idToReplace, masterOutput);
        pc._masterAudioDeviceId = idToReplace;
    }).catch(function rollback() {
        pc.outputs.set(masterId, masterOutput);
        self._log.info("Could not reassign master output. Attempted to roll back.");
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._removeAudioOutput = function removeAudioOutput(id) {
    if (this._masterAudioDeviceId === id) return this._reassignMasterOutput(this, id);
    this._disableOutput(this, id);
    this.outputs.delete(id);
    return Promise.resolve();
};
/**
 * Use an AudioContext to potentially split our audio output stream to multiple
 *   audio devices. This is only available to browsers with AudioContext and
 *   HTMLAudioElement.setSinkId() available. We save the source stream in
 *   _masterAudio, and use it for one of the active audio devices. We keep
 *   track of its ID because we must replace it if we lose its initial device.
 */ $eebba6bea300b063$var$PeerConnection.prototype._onAddTrack = function onAddTrack(pc, stream) {
    var audio = pc._masterAudio = this._createAudio();
    $eebba6bea300b063$var$setAudioSource(audio, stream);
    audio.play();
    // Assign the initial master audio element to a random active output device
    var activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    var deviceId = typeof activeDeviceId === "string" ? activeDeviceId : "default";
    pc._masterAudioDeviceId = deviceId;
    pc.outputs.set(deviceId, {
        audio: audio
    });
    try {
        pc._mediaStreamSource = pc._audioContext.createMediaStreamSource(stream);
    } catch (ex) {
        this._log.warn("Unable to create a MediaStreamSource from onAddTrack", ex);
        this._mediaStreamSource = null;
    }
    pc.pcStream = stream;
    pc._updateAudioOutputs();
};
/**
 * Use a single audio element to play the audio output stream. This does not
 *   support multiple output devices, and is a fallback for when AudioContext
 *   and/or HTMLAudioElement.setSinkId() is not available to the client.
 */ $eebba6bea300b063$var$PeerConnection.prototype._fallbackOnAddTrack = function fallbackOnAddTrack(pc, stream) {
    var audio = document && document.createElement("audio");
    audio.autoplay = true;
    if (!$eebba6bea300b063$var$setAudioSource(audio, stream)) pc._log.info("Error attaching stream to element.");
    pc.outputs.set("default", {
        audio: audio
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._setEncodingParameters = function(enableDscp) {
    if (!enableDscp || !this._sender || typeof this._sender.getParameters !== "function" || typeof this._sender.setParameters !== "function") return;
    var params = this._sender.getParameters();
    if (!params.priority && !(params.encodings && params.encodings.length)) return;
    // This is how MDN's RTPSenderParameters defines priority
    params.priority = "high";
    // And this is how it's currently implemented in Chrome M72+
    if (params.encodings && params.encodings.length) params.encodings.forEach(function(encoding) {
        encoding.priority = "high";
        encoding.networkPriority = "high";
    });
    this._sender.setParameters(params);
};
$eebba6bea300b063$var$PeerConnection.prototype._setupPeerConnection = function(rtcConfiguration) {
    var _this = this;
    var self = this;
    var version = new (this.options.rtcpcFactory || $gCFre.default)({
        RTCPeerConnection: this.options.RTCPeerConnection
    });
    version.create(rtcConfiguration);
    $eebba6bea300b063$var$addStream(version.pc, this.stream);
    var eventName = "ontrack" in version.pc ? "ontrack" : "onaddstream";
    version.pc[eventName] = function(event) {
        var stream = self._remoteStream = event.stream || event.streams[0];
        if (typeof version.pc.getSenders === "function") _this._sender = version.pc.getSenders()[0];
        if (self._isSinkSupported) self._onAddTrack(self, stream);
        else self._fallbackOnAddTrack(self, stream);
        self._startPollingVolume();
    };
    return version;
};
$eebba6bea300b063$var$PeerConnection.prototype._maybeSetIceAggressiveNomination = function(sdp) {
    return this.options.forceAggressiveIceNomination ? $82FG2.setIceAggressiveNomination(sdp) : sdp;
};
$eebba6bea300b063$var$PeerConnection.prototype._setupChannel = function() {
    var _this = this;
    var pc = this.version.pc;
    // Chrome 25 supports onopen
    this.version.pc.onopen = function() {
        _this.status = "open";
        _this.onopen();
    };
    // Chrome 26 doesn't support onopen so must detect state change
    this.version.pc.onstatechange = function() {
        if (_this.version.pc && _this.version.pc.readyState === "stable") {
            _this.status = "open";
            _this.onopen();
        }
    };
    // Chrome 27 changed onstatechange to onsignalingstatechange
    this.version.pc.onsignalingstatechange = function() {
        var state = pc.signalingState;
        _this._log.info('signalingState is "' + state + '"');
        if (_this.version.pc && _this.version.pc.signalingState === "stable") {
            _this.status = "open";
            _this.onopen();
        }
        _this.onsignalingstatechange(pc.signalingState);
    };
    // Chrome 72+
    pc.onconnectionstatechange = function(event) {
        var state = pc.connectionState;
        if (!state && event && event.target) {
            // VDI environment
            var targetPc = event.target;
            state = targetPc.connectionState || targetPc.connectionState_;
            _this._log.info("pc.connectionState not detected. Using target PC. State=" + state);
        }
        if (!state) _this._log.warn('onconnectionstatechange detected but state is "' + state + '"');
        else _this._log.info('pc.connectionState is "' + state + '"');
        _this.onpcconnectionstatechange(state);
        _this._onMediaConnectionStateChange(state);
    };
    pc.onicecandidate = function(event) {
        var candidate = event.candidate;
        if (candidate) {
            _this._hasIceCandidates = true;
            _this.onicecandidate(candidate);
            _this._setupRTCIceTransportListener();
        }
        _this._log.info("ICE Candidate: " + JSON.stringify(candidate));
    };
    pc.onicegatheringstatechange = function() {
        var state = pc.iceGatheringState;
        if (state === "gathering") _this._startIceGatheringTimeout();
        else if (state === "complete") {
            _this._stopIceGatheringTimeout();
            // Fail if no candidates found
            if (!_this._hasIceCandidates) _this._onIceGatheringFailure($eebba6bea300b063$var$ICE_GATHERING_FAIL_NONE);
            // There was a failure mid-gathering phase. We want to start our timer and issue
            // an ice restart if we don't get connected after our timeout
            if (_this._hasIceCandidates && _this._hasIceGatheringFailures) _this._startIceGatheringTimeout();
        }
        _this._log.info('pc.iceGatheringState is "' + pc.iceGatheringState + '"');
        _this.onicegatheringstatechange(state);
    };
    pc.oniceconnectionstatechange = function() {
        _this._log.info('pc.iceConnectionState is "' + pc.iceConnectionState + '"');
        _this.oniceconnectionstatechange(pc.iceConnectionState);
        _this._onMediaConnectionStateChange(pc.iceConnectionState);
    };
};
$eebba6bea300b063$var$PeerConnection.prototype._initializeMediaStream = function(rtcConfiguration) {
    // if mediastream already open then do nothing
    if (this.status === "open") return false;
    if (this.pstream.status === "disconnected") {
        this.onerror({
            info: {
                code: 31000,
                message: "Cannot establish connection. Client is disconnected",
                twilioError: new $dmfT0.SignalingErrors.ConnectionDisconnected()
            }
        });
        this.close();
        return false;
    }
    this.version = this._setupPeerConnection(rtcConfiguration);
    this._setupChannel();
    return true;
};
/**
 * Remove reconnection-related listeners
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._removeReconnectionListeners = function() {
    if (this.pstream) {
        this.pstream.removeListener("answer", this._onAnswerOrRinging);
        this.pstream.removeListener("hangup", this._onHangup);
    }
};
/**
 * Setup a listener for RTCDtlsTransport to capture state changes events
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setupRTCDtlsTransportListener = function() {
    var _this = this;
    var dtlsTransport = this.getRTCDtlsTransport();
    if (!dtlsTransport || dtlsTransport.onstatechange) return;
    var handler = function() {
        _this._log.info('dtlsTransportState is "' + dtlsTransport.state + '"');
        _this.ondtlstransportstatechange(dtlsTransport.state);
    };
    // Publish initial state
    handler();
    dtlsTransport.onstatechange = handler;
};
/**
 * Setup a listener for RTCIceTransport to capture selected candidate pair changes
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setupRTCIceTransportListener = function() {
    var _this = this;
    var iceTransport = this._getRTCIceTransport();
    if (!iceTransport || iceTransport.onselectedcandidatepairchange) return;
    iceTransport.onselectedcandidatepairchange = function() {
        return _this.onselectedcandidatepairchange(iceTransport.getSelectedCandidatePair());
    };
};
/**
 * Restarts ICE for the current connection
 * ICE Restart failures are ignored. Retries are managed in Connection
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype.iceRestart = function() {
    var _this = this;
    this._log.info("Attempting to restart ICE...");
    this._hasIceCandidates = false;
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        iceRestart: true
    }).then(function() {
        _this._removeReconnectionListeners();
        _this._onAnswerOrRinging = function(payload) {
            _this._removeReconnectionListeners();
            if (!payload.sdp || _this.version.pc.signalingState !== "have-local-offer") {
                var message = "Invalid state or param during ICE Restart:" + ("hasSdp:" + !!payload.sdp + ", signalingState:" + _this.version.pc.signalingState);
                _this._log.warn(message);
                return;
            }
            var sdp = _this._maybeSetIceAggressiveNomination(payload.sdp);
            _this._answerSdp = sdp;
            if (_this.status !== "closed") _this.version.processAnswer(_this.codecPreferences, sdp, null, function(err) {
                var message = err && err.message ? err.message : err;
                _this._log.error("Failed to process answer during ICE Restart. Error: " + message);
            });
        };
        _this._onHangup = function() {
            _this._log.info("Received hangup during ICE Restart");
            _this._removeReconnectionListeners();
        };
        _this.pstream.on("answer", _this._onAnswerOrRinging);
        _this.pstream.on("hangup", _this._onHangup);
        _this.pstream.reinvite(_this.version.getSDP(), _this.callSid);
    }).catch(function(err) {
        var message = err && err.message ? err.message : err;
        _this._log.error("Failed to createOffer during ICE Restart. Error: " + message);
        // CreateOffer failures doesn't transition ice state to failed
        // We need trigger it so it can be picked up by retries
        _this.onfailed(message);
    });
};
$eebba6bea300b063$var$PeerConnection.prototype.makeOutgoingCall = function(params, signalingReconnectToken, callsid, rtcConfiguration, onMediaStarted) {
    var _this = this;
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    var self = this;
    this.callSid = callsid;
    function onAnswerSuccess() {
        if (self.options) self._setEncodingParameters(self.options.dscp);
        onMediaStarted(self.version.pc);
    }
    function onAnswerError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error processing answer: " + errMsg,
                twilioError: new $dmfT0.MediaErrors.ClientRemoteDescFailed()
            }
        });
    }
    this._onAnswerOrRinging = function(payload) {
        if (!payload.sdp) return;
        var sdp = _this._maybeSetIceAggressiveNomination(payload.sdp);
        self._answerSdp = sdp;
        if (self.status !== "closed") self.version.processAnswer(_this.codecPreferences, sdp, onAnswerSuccess, onAnswerError);
        self.pstream.removeListener("answer", self._onAnswerOrRinging);
        self.pstream.removeListener("ringing", self._onAnswerOrRinging);
    };
    this.pstream.on("answer", this._onAnswerOrRinging);
    this.pstream.on("ringing", this._onAnswerOrRinging);
    function onOfferSuccess() {
        if (self.status !== "closed") {
            if (signalingReconnectToken) self.pstream.reconnect(self.version.getSDP(), self.callSid, signalingReconnectToken);
            else self.pstream.invite(self.version.getSDP(), self.callSid, params);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onOfferError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error creating the offer: " + errMsg,
                twilioError: new $dmfT0.MediaErrors.ClientLocalDescFailed()
            }
        });
    }
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        audio: true
    }, onOfferSuccess, onOfferError);
};
$eebba6bea300b063$var$PeerConnection.prototype.answerIncomingCall = function(callSid, sdp, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    sdp = this._maybeSetIceAggressiveNomination(sdp);
    this._answerSdp = sdp.replace(/^a=setup:actpass$/gm, "a=setup:passive");
    this.callSid = callSid;
    var self = this;
    function onAnswerSuccess() {
        if (self.status !== "closed") {
            self.pstream.answer(self.version.getSDP(), callSid);
            if (self.options) self._setEncodingParameters(self.options.dscp);
            onMediaStarted(self.version.pc);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onAnswerError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error creating the answer: " + errMsg,
                twilioError: new $dmfT0.MediaErrors.ClientRemoteDescFailed()
            }
        });
    }
    this.version.processSDP(this.options.maxAverageBitrate, this.codecPreferences, sdp, {
        audio: true
    }, onAnswerSuccess, onAnswerError);
};
$eebba6bea300b063$var$PeerConnection.prototype.close = function() {
    if (this.version && this.version.pc) {
        if (this.version.pc.signalingState !== "closed") this.version.pc.close();
        this.version.pc = null;
    }
    if (this.stream) {
        this.mute(false);
        this._stopStream();
    }
    this.stream = null;
    this._removeReconnectionListeners();
    this._stopIceGatheringTimeout();
    Promise.all(this._removeAudioOutputs()).catch(function() {
    // We don't need to alert about failures here.
    });
    if (this._mediaStreamSource) this._mediaStreamSource.disconnect();
    if (this._inputAnalyser) this._inputAnalyser.disconnect();
    if (this._outputAnalyser) this._outputAnalyser.disconnect();
    if (this._inputAnalyser2) this._inputAnalyser2.disconnect();
    if (this._outputAnalyser2) this._outputAnalyser2.disconnect();
    this.status = "closed";
    this.onclose();
};
$eebba6bea300b063$var$PeerConnection.prototype.reject = function(callSid) {
    this.callSid = callSid;
};
$eebba6bea300b063$var$PeerConnection.prototype.ignore = function(callSid) {
    this.callSid = callSid;
};
/**
 * Mute or unmute input audio. If the stream is not yet present, the setting
 *   is saved and applied to future streams/tracks.
 * @params {boolean} shouldMute - Whether the input audio should
 *   be muted or unmuted.
 */ $eebba6bea300b063$var$PeerConnection.prototype.mute = function(shouldMute) {
    this.isMuted = shouldMute;
    if (!this.stream) return;
    if (this._sender && this._sender.track) this._sender.track.enabled = !shouldMute;
    else {
        var audioTracks = typeof this.stream.getAudioTracks === "function" ? this.stream.getAudioTracks() : this.stream.audioTracks;
        audioTracks.forEach(function(track) {
            track.enabled = !shouldMute;
        });
    }
};
/**
 * Get or create an RTCDTMFSender for the first local audio MediaStreamTrack
 * we can get from the RTCPeerConnection. Return null if unsupported.
 * @instance
 * @returns ?RTCDTMFSender
 */ $eebba6bea300b063$var$PeerConnection.prototype.getOrCreateDTMFSender = function getOrCreateDTMFSender() {
    if (this._dtmfSender || this._dtmfSenderUnsupported) return this._dtmfSender || null;
    var self = this;
    var pc = this.version.pc;
    if (!pc) {
        this._log.warn("No RTCPeerConnection available to call createDTMFSender on");
        return null;
    }
    if (typeof pc.getSenders === "function" && (typeof RTCDTMFSender === "function" || typeof RTCDtmfSender === "function")) {
        var chosenSender = pc.getSenders().find(function(sender) {
            return sender.dtmf;
        });
        if (chosenSender) {
            this._log.info("Using RTCRtpSender#dtmf");
            this._dtmfSender = chosenSender.dtmf;
            return this._dtmfSender;
        }
    }
    if (typeof pc.createDTMFSender === "function" && typeof pc.getLocalStreams === "function") {
        var track = pc.getLocalStreams().map(function(stream) {
            var tracks = self._getAudioTracks(stream);
            return tracks && tracks[0];
        })[0];
        if (!track) {
            this._log.warn("No local audio MediaStreamTrack available on the RTCPeerConnection to pass to createDTMFSender");
            return null;
        }
        this._log.info("Creating RTCDTMFSender");
        this._dtmfSender = pc.createDTMFSender(track);
        return this._dtmfSender;
    }
    this._log.info("RTCPeerConnection does not support RTCDTMFSender");
    this._dtmfSenderUnsupported = true;
    return null;
};
/**
 * Get the RTCDtlTransport object from the PeerConnection
 * @returns RTCDtlTransport
 */ $eebba6bea300b063$var$PeerConnection.prototype.getRTCDtlsTransport = function getRTCDtlsTransport() {
    var sender = this.version && this.version.pc && typeof this.version.pc.getSenders === "function" && this.version.pc.getSenders()[0];
    return sender && sender.transport || null;
};
$eebba6bea300b063$var$PeerConnection.prototype._canStopMediaStreamTrack = function() {
    return typeof MediaStreamTrack.prototype.stop === "function";
};
$eebba6bea300b063$var$PeerConnection.prototype._getAudioTracks = function(stream) {
    return typeof stream.getAudioTracks === "function" ? stream.getAudioTracks() : stream.audioTracks;
};
/**
 * Get the RTCIceTransport object from the PeerConnection
 * @returns RTCIceTransport
 */ $eebba6bea300b063$var$PeerConnection.prototype._getRTCIceTransport = function _getRTCIceTransport() {
    var dtlsTransport = this.getRTCDtlsTransport();
    return dtlsTransport && dtlsTransport.iceTransport || null;
};
// Is PeerConnection.protocol used outside of our SDK? We should remove this if not.
$eebba6bea300b063$var$PeerConnection.protocol = function() {
    return $gCFre.default.test() ? new $gCFre.default() : null;
}();
function $eebba6bea300b063$var$addStream(pc, stream) {
    if (typeof pc.addTrack === "function") stream.getAudioTracks().forEach(function(track) {
        // The second parameters, stream, should not be necessary per the latest editor's
        //   draft, but FF requires it. https://bugzilla.mozilla.org/show_bug.cgi?id=1231414
        pc.addTrack(track, stream);
    });
    else pc.addStream(stream);
}
function $eebba6bea300b063$var$cloneStream(oldStream) {
    var newStream = typeof MediaStream !== "undefined" ? new MediaStream() : new webkitMediaStream();
    oldStream.getAudioTracks().forEach(newStream.addTrack, newStream);
    return newStream;
}
function $eebba6bea300b063$var$removeStream(pc, stream) {
    if (typeof pc.removeTrack === "function") pc.getSenders().forEach(function(sender) {
        pc.removeTrack(sender);
    });
    else pc.removeStream(stream);
}
/**
 * Set the source of an HTMLAudioElement to the specified MediaStream
 * @param {HTMLAudioElement} audio
 * @param {MediaStream} stream
 * @returns {boolean} Whether the audio source was set successfully
 */ function $eebba6bea300b063$var$setAudioSource(audio, stream) {
    if (typeof audio.srcObject !== "undefined") audio.srcObject = stream;
    else if (typeof audio.mozSrcObject !== "undefined") audio.mozSrcObject = stream;
    else if (typeof audio.src !== "undefined") {
        var _window = audio.options.window || window;
        audio.src = (_window.URL || _window.webkitURL).createObjectURL(stream);
    } else return false;
    return true;
}
$eebba6bea300b063$var$PeerConnection.enabled = $gCFre.default.test();
module.exports.default = $eebba6bea300b063$var$PeerConnection;

});
parcelRegister("gCFre", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
// tslint:disable only-arrow-functions
/* global webkitRTCPeerConnection, mozRTCPeerConnection, mozRTCSessionDescription, mozRTCIceCandidate */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8RS9P = parcelRequire("8RS9P");

var $f8R8g = parcelRequire("f8R8g");

var $82FG2 = parcelRequire("82FG2");

var $6C8Tv = parcelRequire("6C8Tv");
function $c1a056b32fadc499$var$RTCPC(options) {
    if (typeof window === "undefined") {
        this.log.info("No RTCPeerConnection implementation available. The window object was not found.");
        return;
    }
    if (options && options.RTCPeerConnection) this.RTCPeerConnection = options.RTCPeerConnection;
    else if ($f8R8g.isLegacyEdge()) this.RTCPeerConnection = new $6C8Tv(typeof window !== "undefined" ? window : $parcel$global);
    else if (typeof window.RTCPeerConnection === "function") this.RTCPeerConnection = window.RTCPeerConnection;
    else if (typeof window.webkitRTCPeerConnection === "function") this.RTCPeerConnection = webkitRTCPeerConnection;
    else if (typeof window.mozRTCPeerConnection === "function") {
        this.RTCPeerConnection = mozRTCPeerConnection;
        window.RTCSessionDescription = mozRTCSessionDescription;
        window.RTCIceCandidate = mozRTCIceCandidate;
    } else this.log.info("No RTCPeerConnection implementation available");
}
$c1a056b32fadc499$var$RTCPC.prototype.create = function(rtcConfiguration) {
    this.log = new $8RS9P.default("RTCPC");
    this.pc = new this.RTCPeerConnection(rtcConfiguration);
};
$c1a056b32fadc499$var$RTCPC.prototype.createModernConstraints = function(c) {
    // createOffer differs between Chrome 23 and Chrome 24+.
    // See https://groups.google.com/forum/?fromgroups=#!topic/discuss-webrtc/JBDZtrMumyU
    // Unfortunately I haven't figured out a way to detect which format
    // is required ahead of time, so we'll first try the old way, and
    // if we get an exception, then we'll try the new way.
    if (typeof c === "undefined") return null;
    // NOTE(mroberts): As of Chrome 38, Chrome still appears to expect
    // constraints under the 'mandatory' key, and with the first letter of each
    // constraint capitalized. Firefox, on the other hand, has deprecated the
    // 'mandatory' key and does not expect the first letter of each constraint
    // capitalized.
    var nc = Object.assign({}, c);
    if (typeof webkitRTCPeerConnection !== "undefined" && !$f8R8g.isLegacyEdge()) {
        nc.mandatory = {};
        if (typeof c.audio !== "undefined") nc.mandatory.OfferToReceiveAudio = c.audio;
        if (typeof c.video !== "undefined") nc.mandatory.OfferToReceiveVideo = c.video;
    } else {
        if (typeof c.audio !== "undefined") nc.offerToReceiveAudio = c.audio;
        if (typeof c.video !== "undefined") nc.offerToReceiveVideo = c.video;
    }
    delete nc.audio;
    delete nc.video;
    return nc;
};
$c1a056b32fadc499$var$RTCPC.prototype.createOffer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    var _this = this;
    constraints = this.createModernConstraints(constraints);
    return $c1a056b32fadc499$var$promisifyCreate(this.pc.createOffer, this.pc)(constraints).then(function(offer) {
        if (!_this.pc) return Promise.resolve();
        var sdp = $82FG2.setMaxAverageBitrate(offer.sdp, maxAverageBitrate);
        return $c1a056b32fadc499$var$promisifySet(_this.pc.setLocalDescription, _this.pc)(new RTCSessionDescription({
            sdp: $82FG2.setCodecPreferences(sdp, codecPreferences),
            type: "offer"
        }));
    }).then(onSuccess, onError);
};
$c1a056b32fadc499$var$RTCPC.prototype.createAnswer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    var _this = this;
    constraints = this.createModernConstraints(constraints);
    return $c1a056b32fadc499$var$promisifyCreate(this.pc.createAnswer, this.pc)(constraints).then(function(answer) {
        if (!_this.pc) return Promise.resolve();
        var sdp = $82FG2.setMaxAverageBitrate(answer.sdp, maxAverageBitrate);
        return $c1a056b32fadc499$var$promisifySet(_this.pc.setLocalDescription, _this.pc)(new RTCSessionDescription({
            sdp: $82FG2.setCodecPreferences(sdp, codecPreferences),
            type: "answer"
        }));
    }).then(onSuccess, onError);
};
$c1a056b32fadc499$var$RTCPC.prototype.processSDP = function(maxAverageBitrate, codecPreferences, sdp, constraints, onSuccess, onError) {
    var _this = this;
    sdp = $82FG2.setCodecPreferences(sdp, codecPreferences);
    var desc = new RTCSessionDescription({
        sdp: sdp,
        type: "offer"
    });
    return $c1a056b32fadc499$var$promisifySet(this.pc.setRemoteDescription, this.pc)(desc).then(function() {
        _this.createAnswer(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError);
    });
};
$c1a056b32fadc499$var$RTCPC.prototype.getSDP = function() {
    return this.pc.localDescription.sdp;
};
$c1a056b32fadc499$var$RTCPC.prototype.processAnswer = function(codecPreferences, sdp, onSuccess, onError) {
    if (!this.pc) return Promise.resolve();
    sdp = $82FG2.setCodecPreferences(sdp, codecPreferences);
    return $c1a056b32fadc499$var$promisifySet(this.pc.setRemoteDescription, this.pc)(new RTCSessionDescription({
        sdp: sdp,
        type: "answer"
    })).then(onSuccess, onError);
};
/* NOTE(mroberts): Firefox 18 through 21 include a `mozRTCPeerConnection`
   object, but attempting to instantiate it will throw the error

       Error: PeerConnection not enabled (did you set the pref?)

   unless the `media.peerconnection.enabled` pref is enabled. So we need to test
   if we can actually instantiate `mozRTCPeerConnection`; however, if the user
   *has* enabled `media.peerconnection.enabled`, we need to perform the same
   test that we use to detect Firefox 24 and above, namely:

       typeof (new mozRTCPeerConnection()).getLocalStreams === 'function'

    NOTE(rrowland): We no longer support Legacy Edge as of Sep 1, 2020.
*/ $c1a056b32fadc499$var$RTCPC.test = function() {
    if (typeof navigator === "object") {
        var getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
        if ($f8R8g.isLegacyEdge(navigator)) return false;
        if (getUserMedia && typeof window.RTCPeerConnection === "function") return true;
        else if (getUserMedia && typeof window.webkitRTCPeerConnection === "function") return true;
        else if (getUserMedia && typeof window.mozRTCPeerConnection === "function") {
            try {
                var test_1 = new window.mozRTCPeerConnection();
                if (typeof test_1.getLocalStreams !== "function") return false;
            } catch (e) {
                return false;
            }
            return true;
        } else if (typeof RTCIceGatherer !== "undefined") return true;
    }
    return false;
};
function $c1a056b32fadc499$var$promisify(fn, ctx, areCallbacksFirst, checkRval) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return new Promise(function(resolve) {
            var returnValue = fn.apply(ctx, args);
            if (!checkRval) {
                resolve(returnValue);
                return;
            }
            if (typeof returnValue === "object" && typeof returnValue.then === "function") resolve(returnValue);
            else throw new Error();
        }).catch(function() {
            return new Promise(function(resolve, reject) {
                fn.apply(ctx, areCallbacksFirst ? [
                    resolve,
                    reject
                ].concat(args) : args.concat([
                    resolve,
                    reject
                ]));
            });
        });
    };
}
function $c1a056b32fadc499$var$promisifyCreate(fn, ctx) {
    return $c1a056b32fadc499$var$promisify(fn, ctx, true, true);
}
function $c1a056b32fadc499$var$promisifySet(fn, ctx) {
    return $c1a056b32fadc499$var$promisify(fn, ctx, false, false);
}
module.exports.default = $c1a056b32fadc499$var$RTCPC;

});
parcelRegister("82FG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setMaxAverageBitrate = module.exports.setIceAggressiveNomination = module.exports.setCodecPreferences = module.exports.getPreferredCodecInfo = void 0;

var $f8R8g = parcelRequire("f8R8g");
var $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName = {
    0: "PCMU",
    8: "PCMA"
};
var $5daed6d4af7231db$var$defaultOpusId = 111;
var $5daed6d4af7231db$var$BITRATE_MAX = 510000;
var $5daed6d4af7231db$var$BITRATE_MIN = 6000;
function $5daed6d4af7231db$var$getPreferredCodecInfo(sdp) {
    var _a = /a=rtpmap:(\d+) (\S+)/m.exec(sdp) || [
        null,
        "",
        ""
    ], codecId = _a[1], codecName = _a[2];
    var regex = new RegExp("a=fmtp:" + codecId + " (\\S+)", "m");
    var _b = regex.exec(sdp) || [
        null,
        ""
    ], codecParams = _b[1];
    return {
        codecName: codecName,
        codecParams: codecParams
    };
}
module.exports.getPreferredCodecInfo = $5daed6d4af7231db$var$getPreferredCodecInfo;
function $5daed6d4af7231db$var$setIceAggressiveNomination(sdp) {
    // This only works on Chrome. We don't want any side effects on other browsers
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1024096
    // https://issues.corp.twilio.com/browse/CLIENT-6911
    if (!$f8R8g.isChrome(window, window.navigator)) return sdp;
    return sdp.split("\n").filter(function(line) {
        return line.indexOf("a=ice-lite") === -1;
    }).join("\n");
}
module.exports.setIceAggressiveNomination = $5daed6d4af7231db$var$setIceAggressiveNomination;
function $5daed6d4af7231db$var$setMaxAverageBitrate(sdp, maxAverageBitrate) {
    if (typeof maxAverageBitrate !== "number" || maxAverageBitrate < $5daed6d4af7231db$var$BITRATE_MIN || maxAverageBitrate > $5daed6d4af7231db$var$BITRATE_MAX) return sdp;
    var matches = /a=rtpmap:(\d+) opus/m.exec(sdp);
    var opusId = matches && matches.length ? matches[1] : $5daed6d4af7231db$var$defaultOpusId;
    var regex = new RegExp("a=fmtp:" + opusId);
    var lines = sdp.split("\n").map(function(line) {
        return regex.test(line) ? line + (";maxaveragebitrate=" + maxAverageBitrate) : line;
    });
    return lines.join("\n");
}
module.exports.setMaxAverageBitrate = $5daed6d4af7231db$var$setMaxAverageBitrate;
/**
 * Return a new SDP string with the re-ordered codec preferences.
 * @param {string} sdp
 * @param {Array<AudioCodec>} preferredCodecs - If empty, the existing order
 *   of audio codecs is preserved
 * @returns {string} Updated SDP string
 */ function $5daed6d4af7231db$var$setCodecPreferences(sdp, preferredCodecs) {
    var mediaSections = $5daed6d4af7231db$var$getMediaSections(sdp);
    var session = sdp.split("\r\nm=")[0];
    return [
        session
    ].concat(mediaSections.map(function(section) {
        // Codec preferences should not be applied to m=application sections.
        if (!/^m=(audio|video)/.test(section)) return section;
        var kind = section.match(/^m=(audio|video)/)[1];
        var codecMap = $5daed6d4af7231db$var$createCodecMapForMediaSection(section);
        var payloadTypes = $5daed6d4af7231db$var$getReorderedPayloadTypes(codecMap, preferredCodecs);
        var newSection = $5daed6d4af7231db$var$setPayloadTypesInMediaSection(payloadTypes, section);
        var pcmaPayloadTypes = codecMap.get("pcma") || [];
        var pcmuPayloadTypes = codecMap.get("pcmu") || [];
        var fixedBitratePayloadTypes = kind === "audio" ? new Set(pcmaPayloadTypes.concat(pcmuPayloadTypes)) : new Set();
        return fixedBitratePayloadTypes.has(payloadTypes[0]) ? newSection.replace(/\r\nb=(AS|TIAS):([0-9]+)/g, "") : newSection;
    })).join("\r\n");
}
module.exports.setCodecPreferences = $5daed6d4af7231db$var$setCodecPreferences;
/**
 * Get the m= sections of a particular kind and direction from an sdp.
 * @param {string} sdp - SDP string
 * @param {string} [kind] - Pattern for matching kind
 * @param {string} [direction] - Pattern for matching direction
 * @returns {Array<string>} mediaSections
 */ function $5daed6d4af7231db$var$getMediaSections(sdp, kind, direction) {
    return sdp.replace(/\r\n\r\n$/, "\r\n").split("\r\nm=").slice(1).map(function(mediaSection) {
        return "m=" + mediaSection;
    }).filter(function(mediaSection) {
        var kindPattern = new RegExp("m=" + (kind || ".*"), "gm");
        var directionPattern = new RegExp("a=" + (direction || ".*"), "gm");
        return kindPattern.test(mediaSection) && directionPattern.test(mediaSection);
    });
}
/**
 * Create a Codec Map for the given m= section.
 * @param {string} section - The given m= section
 * @returns {Map<Codec, Array<PT>>}
 */ function $5daed6d4af7231db$var$createCodecMapForMediaSection(section) {
    return Array.from($5daed6d4af7231db$var$createPtToCodecName(section)).reduce(function(codecMap, pair) {
        var pt = pair[0];
        var codecName = pair[1];
        var pts = codecMap.get(codecName) || [];
        return codecMap.set(codecName, pts.concat(pt));
    }, new Map());
}
/**
 * Create the reordered Codec Payload Types based on the preferred Codec Names.
 * @param {Map<Codec, Array<PT>>} codecMap - Codec Map
 * @param {Array<Codec>} preferredCodecs - Preferred Codec Names
 * @returns {Array<PT>} Reordered Payload Types
 */ function $5daed6d4af7231db$var$getReorderedPayloadTypes(codecMap, preferredCodecs) {
    preferredCodecs = preferredCodecs.map(function(codecName) {
        return codecName.toLowerCase();
    });
    var preferredPayloadTypes = $f8R8g.flatMap(preferredCodecs, function(codecName) {
        return codecMap.get(codecName) || [];
    });
    var remainingCodecs = $f8R8g.difference(Array.from(codecMap.keys()), preferredCodecs);
    var remainingPayloadTypes = $f8R8g.flatMap(remainingCodecs, function(codecName) {
        return codecMap.get(codecName);
    });
    return preferredPayloadTypes.concat(remainingPayloadTypes);
}
/**
 * Set the given Codec Payload Types in the first line of the given m= section.
 * @param {Array<PT>} payloadTypes - Payload Types
 * @param {string} section - Given m= section
 * @returns {string} - Updated m= section
 */ function $5daed6d4af7231db$var$setPayloadTypesInMediaSection(payloadTypes, section) {
    var lines = section.split("\r\n");
    var mLine = lines[0];
    var otherLines = lines.slice(1);
    mLine = mLine.replace(/([0-9]+\s?)+$/, payloadTypes.join(" "));
    return [
        mLine
    ].concat(otherLines).join("\r\n");
}
/**
 * Create a Map from PTs to codec names for the given m= section.
 * @param {string} mediaSection - The given m= section.
 * @returns {Map<PT, Codec>} ptToCodecName
 */ function $5daed6d4af7231db$var$createPtToCodecName(mediaSection) {
    return $5daed6d4af7231db$var$getPayloadTypesInMediaSection(mediaSection).reduce(function(ptToCodecName, pt) {
        var rtpmapPattern = new RegExp("a=rtpmap:" + pt + " ([^/]+)");
        var matches = mediaSection.match(rtpmapPattern);
        var codecName = matches ? matches[1].toLowerCase() : $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName[pt] ? $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName[pt].toLowerCase() : "";
        return ptToCodecName.set(pt, codecName);
    }, new Map());
}
/**
 * Get the Codec Payload Types present in the first line of the given m= section
 * @param {string} section - The m= section
 * @returns {Array<PT>} Payload Types
 */ function $5daed6d4af7231db$var$getPayloadTypesInMediaSection(section) {
    var mLine = section.split("\r\n")[0];
    // In "m=<kind> <port> <proto> <payload_type_1> <payload_type_2> ... <payload_type_n>",
    // the regex matches <port> and the PayloadTypes.
    var matches = mLine.match(/([0-9]+)/g);
    // This should not happen, but in case there are no PayloadTypes in
    // the m= line, return an empty array.
    if (!matches) return [];
    // Since only the PayloadTypes are needed, we discard the <port>.
    return matches.slice(1).map(function(match) {
        return parseInt(match, 10);
    });
}

});

parcelRegister("6C8Tv", function(module, exports) {
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";

var $l3I5s = parcelRequire("l3I5s");
function $4d0d30e95648dedb$var$writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
    var sdp = $l3I5s.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $l3I5s.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $l3I5s.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : dtlsRole || "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
        transceiver.rtpSender._initialTrackId = trackId;
        // spec.
        var msid = "msid:" + (stream ? stream.id : "-") + " " + trackId + "\r\n";
        sdp += "a=" + msid;
        // for Chrome. Legacy should no longer be required.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        // RTX
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $l3I5s.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $l3I5s.localCName + "\r\n";
    return sdp;
}
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function $4d0d30e95648dedb$var$filterIceServers(iceServers, edgeVersion) {
    var hasTurn = false;
    iceServers = JSON.parse(JSON.stringify(iceServers));
    return iceServers.filter(function(server) {
        if (server && (server.urls || server.url)) {
            var urls = server.urls || server.url;
            if (server.url && !server.urls) console.warn("RTCIceServer.url is deprecated! Use urls instead.");
            var isString = typeof urls === "string";
            if (isString) urls = [
                urls
            ];
            urls = urls.filter(function(url) {
                var validTurn = url.indexOf("turn:") === 0 && url.indexOf("transport=udp") !== -1 && url.indexOf("turn:[") === -1 && !hasTurn;
                if (validTurn) {
                    hasTurn = true;
                    return true;
                }
                return url.indexOf("stun:") === 0 && edgeVersion >= 14393 && url.indexOf("?transport=udp") === -1;
            });
            delete server.url;
            server.urls = isString ? urls[0] : urls;
            return !!urls.length;
        }
    });
}
// Determines the intersection of local and remote capabilities.
function $4d0d30e95648dedb$var$getCommonCapabilities(localCapabilities, remoteCapabilities) {
    var commonCapabilities = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: []
    };
    var findCodecByPayloadType = function(pt, codecs) {
        pt = parseInt(pt, 10);
        for(var i = 0; i < codecs.length; i++){
            if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) return codecs[i];
        }
    };
    var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
        var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
        var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
        return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
    };
    localCapabilities.codecs.forEach(function(lCodec) {
        for(var i = 0; i < remoteCapabilities.codecs.length; i++){
            var rCodec = remoteCapabilities.codecs[i];
            if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
                if (lCodec.name.toLowerCase() === "rtx" && lCodec.parameters && rCodec.parameters.apt) {
                    // for RTX we need to find the local rtx that has a apt
                    // which points to the same local codec as the remote one.
                    if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) continue;
                }
                rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
                // number of channels is the highest common number of channels
                rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels);
                // push rCodec so we reply with offerer payload type
                commonCapabilities.codecs.push(rCodec);
                // determine common feedback mechanisms
                rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
                    for(var j = 0; j < lCodec.rtcpFeedback.length; j++){
                        if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) return true;
                    }
                    return false;
                });
                break;
            }
        }
    });
    localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
        for(var i = 0; i < remoteCapabilities.headerExtensions.length; i++){
            var rHeaderExtension = remoteCapabilities.headerExtensions[i];
            if (lHeaderExtension.uri === rHeaderExtension.uri) {
                commonCapabilities.headerExtensions.push(rHeaderExtension);
                break;
            }
        }
    });
    // FIXME: fecMechanisms
    return commonCapabilities;
}
// is action=setLocalDescription with type allowed in signalingState
function $4d0d30e95648dedb$var$isActionAllowedInSignalingState(action, type, signalingState) {
    return ({
        offer: {
            setLocalDescription: [
                "stable",
                "have-local-offer"
            ],
            setRemoteDescription: [
                "stable",
                "have-remote-offer"
            ]
        },
        answer: {
            setLocalDescription: [
                "have-remote-offer",
                "have-local-pranswer"
            ],
            setRemoteDescription: [
                "have-local-offer",
                "have-remote-pranswer"
            ]
        }
    })[type][action].indexOf(signalingState) !== -1;
}
function $4d0d30e95648dedb$var$maybeAddCandidate(iceTransport, candidate) {
    // Edge's internal representation adds some fields therefore
    // not all fieldѕ are taken into account.
    var alreadyAdded = iceTransport.getRemoteCandidates().find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
    });
    if (!alreadyAdded) iceTransport.addRemoteCandidate(candidate);
    return !alreadyAdded;
}
function $4d0d30e95648dedb$var$makeError(name, description) {
    var e = new Error(description);
    e.name = name;
    return e;
}
module.exports = function(window, edgeVersion) {
    // https://w3c.github.io/mediacapture-main/#mediastream
    // Helper function to add the track to the stream and
    // dispatch the event ourselves.
    function addTrackToStreamAndFireEvent(track, stream) {
        stream.addTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("addtrack", {
            track: track
        }));
    }
    function removeTrackFromStreamAndFireEvent(track, stream) {
        stream.removeTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("removetrack", {
            track: track
        }));
    }
    function fireAddTrack(pc, track, receiver, streams) {
        var trackEvent = new Event("track");
        trackEvent.track = track;
        trackEvent.receiver = receiver;
        trackEvent.transceiver = {
            receiver: receiver
        };
        trackEvent.streams = streams;
        window.setTimeout(function() {
            pc._dispatchEvent("track", trackEvent);
        });
    }
    var RTCPeerConnection = function(config) {
        var pc = this;
        var _eventTarget = document.createDocumentFragment();
        [
            "addEventListener",
            "removeEventListener",
            "dispatchEvent"
        ].forEach(function(method) {
            pc[method] = _eventTarget[method].bind(_eventTarget);
        });
        this.canTrickleIceCandidates = null;
        this.needNegotiation = false;
        this.localStreams = [];
        this.remoteStreams = [];
        this.localDescription = null;
        this.remoteDescription = null;
        this.signalingState = "stable";
        this.iceConnectionState = "new";
        this.iceGatheringState = "new";
        config = JSON.parse(JSON.stringify(config || {}));
        this.usingBundle = config.bundlePolicy === "max-bundle";
        if (config.rtcpMuxPolicy === "negotiate") throw $4d0d30e95648dedb$var$makeError("NotSupportedError", "rtcpMuxPolicy 'negotiate' is not supported");
        else if (!config.rtcpMuxPolicy) config.rtcpMuxPolicy = "require";
        switch(config.iceTransportPolicy){
            case "all":
            case "relay":
                break;
            default:
                config.iceTransportPolicy = "all";
                break;
        }
        switch(config.bundlePolicy){
            case "balanced":
            case "max-compat":
            case "max-bundle":
                break;
            default:
                config.bundlePolicy = "balanced";
                break;
        }
        config.iceServers = $4d0d30e95648dedb$var$filterIceServers(config.iceServers || [], edgeVersion);
        this._iceGatherers = [];
        if (config.iceCandidatePoolSize) for(var i = config.iceCandidatePoolSize; i > 0; i--)this._iceGatherers.push(new window.RTCIceGatherer({
            iceServers: config.iceServers,
            gatherPolicy: config.iceTransportPolicy
        }));
        else config.iceCandidatePoolSize = 0;
        this._config = config;
        // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
        // everything that is needed to describe a SDP m-line.
        this.transceivers = [];
        this._sdpSessionId = $l3I5s.generateSessionId();
        this._sdpSessionVersion = 0;
        this._dtlsRole = undefined; // role for a=setup to use in answers.
        this._isClosed = false;
    };
    // set up event handlers on prototype
    RTCPeerConnection.prototype.onicecandidate = null;
    RTCPeerConnection.prototype.onaddstream = null;
    RTCPeerConnection.prototype.ontrack = null;
    RTCPeerConnection.prototype.onremovestream = null;
    RTCPeerConnection.prototype.onsignalingstatechange = null;
    RTCPeerConnection.prototype.oniceconnectionstatechange = null;
    RTCPeerConnection.prototype.onicegatheringstatechange = null;
    RTCPeerConnection.prototype.onnegotiationneeded = null;
    RTCPeerConnection.prototype.ondatachannel = null;
    RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
        if (this._isClosed) return;
        this.dispatchEvent(event);
        if (typeof this["on" + name] === "function") this["on" + name](event);
    };
    RTCPeerConnection.prototype._emitGatheringStateChange = function() {
        var event = new Event("icegatheringstatechange");
        this._dispatchEvent("icegatheringstatechange", event);
    };
    RTCPeerConnection.prototype.getConfiguration = function() {
        return this._config;
    };
    RTCPeerConnection.prototype.getLocalStreams = function() {
        return this.localStreams;
    };
    RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this.remoteStreams;
    };
    // internal helper to create a transceiver object.
    // (whih is not yet the same as the WebRTC 1.0 transceiver)
    RTCPeerConnection.prototype._createTransceiver = function(kind) {
        var hasBundleTransport = this.transceivers.length > 0;
        var transceiver = {
            track: null,
            iceGatherer: null,
            iceTransport: null,
            dtlsTransport: null,
            localCapabilities: null,
            remoteCapabilities: null,
            rtpSender: null,
            rtpReceiver: null,
            kind: kind,
            mid: null,
            sendEncodingParameters: null,
            recvEncodingParameters: null,
            stream: null,
            associatedRemoteMediaStreams: [],
            wantReceive: true
        };
        if (this.usingBundle && hasBundleTransport) {
            transceiver.iceTransport = this.transceivers[0].iceTransport;
            transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
        } else {
            var transports = this._createIceAndDtlsTransports();
            transceiver.iceTransport = transports.iceTransport;
            transceiver.dtlsTransport = transports.dtlsTransport;
        }
        this.transceivers.push(transceiver);
        return transceiver;
    };
    RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (this._isClosed) throw $4d0d30e95648dedb$var$makeError("InvalidStateError", "Attempted to call addTrack on a closed peerconnection.");
        var alreadyExists = this.transceivers.find(function(s) {
            return s.track === track;
        });
        if (alreadyExists) throw $4d0d30e95648dedb$var$makeError("InvalidAccessError", "Track already exists.");
        var transceiver;
        for(var i = 0; i < this.transceivers.length; i++)if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) transceiver = this.transceivers[i];
        if (!transceiver) transceiver = this._createTransceiver(track.kind);
        this._maybeFireNegotiationNeeded();
        if (this.localStreams.indexOf(stream) === -1) this.localStreams.push(stream);
        transceiver.track = track;
        transceiver.stream = stream;
        transceiver.rtpSender = new window.RTCRtpSender(track, transceiver.dtlsTransport);
        return transceiver.rtpSender;
    };
    RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        if (edgeVersion >= 15025) stream.getTracks().forEach(function(track) {
            pc.addTrack(track, stream);
        });
        else {
            // Clone is necessary for local demos mostly, attaching directly
            // to two different senders does not work (build 10547).
            // Fixed in 15025 (or earlier)
            var clonedStream = stream.clone();
            stream.getTracks().forEach(function(track, idx) {
                var clonedTrack = clonedStream.getTracks()[idx];
                track.addEventListener("enabled", function(event) {
                    clonedTrack.enabled = event.enabled;
                });
            });
            clonedStream.getTracks().forEach(function(track) {
                pc.addTrack(track, clonedStream);
            });
        }
    };
    RTCPeerConnection.prototype.removeTrack = function(sender) {
        if (this._isClosed) throw $4d0d30e95648dedb$var$makeError("InvalidStateError", "Attempted to call removeTrack on a closed peerconnection.");
        if (!(sender instanceof window.RTCRtpSender)) throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
        var transceiver = this.transceivers.find(function(t) {
            return t.rtpSender === sender;
        });
        if (!transceiver) throw $4d0d30e95648dedb$var$makeError("InvalidAccessError", "Sender was not created by this connection.");
        var stream = transceiver.stream;
        transceiver.rtpSender.stop();
        transceiver.rtpSender = null;
        transceiver.track = null;
        transceiver.stream = null;
        // remove the stream from the set of local streams
        var localStreams = this.transceivers.map(function(t) {
            return t.stream;
        });
        if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) this.localStreams.splice(this.localStreams.indexOf(stream), 1);
        this._maybeFireNegotiationNeeded();
    };
    RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        stream.getTracks().forEach(function(track) {
            var sender = pc.getSenders().find(function(s) {
                return s.track === track;
            });
            if (sender) pc.removeTrack(sender);
        });
    };
    RTCPeerConnection.prototype.getSenders = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpSender;
        }).map(function(transceiver) {
            return transceiver.rtpSender;
        });
    };
    RTCPeerConnection.prototype.getReceivers = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpReceiver;
        }).map(function(transceiver) {
            return transceiver.rtpReceiver;
        });
    };
    RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex, usingBundle) {
        var pc = this;
        if (usingBundle && sdpMLineIndex > 0) return this.transceivers[0].iceGatherer;
        else if (this._iceGatherers.length) return this._iceGatherers.shift();
        var iceGatherer = new window.RTCIceGatherer({
            iceServers: this._config.iceServers,
            gatherPolicy: this._config.iceTransportPolicy
        });
        Object.defineProperty(iceGatherer, "state", {
            value: "new",
            writable: true
        });
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
        this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
            var end = !event.candidate || Object.keys(event.candidate).length === 0;
            // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            iceGatherer.state = end ? "completed" : "gathering";
            if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
        };
        iceGatherer.addEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        return iceGatherer;
    };
    // start gathering from an RTCIceGatherer.
    RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
        var pc = this;
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer.onlocalcandidate) return;
        var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
        iceGatherer.removeEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        iceGatherer.onlocalcandidate = function(evt) {
            if (pc.usingBundle && sdpMLineIndex > 0) // if we know that we use bundle we can drop candidates with
            // ѕdpMLineIndex > 0. If we don't do this then our state gets
            // confused since we dispose the extra ice gatherer.
            return;
            var event = new Event("icecandidate");
            event.candidate = {
                sdpMid: mid,
                sdpMLineIndex: sdpMLineIndex
            };
            var cand = evt.candidate;
            // Edge emits an empty object for RTCIceCandidateComplete‥
            var end = !cand || Object.keys(cand).length === 0;
            if (end) // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            {
                if (iceGatherer.state === "new" || iceGatherer.state === "gathering") iceGatherer.state = "completed";
            } else {
                if (iceGatherer.state === "new") iceGatherer.state = "gathering";
                // RTCIceCandidate doesn't have a component, needs to be added
                cand.component = 1;
                var serializedCandidate = $l3I5s.writeCandidate(cand);
                event.candidate = Object.assign(event.candidate, $l3I5s.parseCandidate(serializedCandidate));
                event.candidate.candidate = serializedCandidate;
            }
            // update local description.
            var sections = $l3I5s.getMediaSections(pc.localDescription.sdp);
            if (!end) sections[event.candidate.sdpMLineIndex] += "a=" + event.candidate.candidate + "\r\n";
            else sections[event.candidate.sdpMLineIndex] += "a=end-of-candidates\r\n";
            pc.localDescription.sdp = $l3I5s.getDescription(pc.localDescription.sdp) + sections.join("");
            var complete = pc.transceivers.every(function(transceiver) {
                return transceiver.iceGatherer && transceiver.iceGatherer.state === "completed";
            });
            if (pc.iceGatheringState !== "gathering") {
                pc.iceGatheringState = "gathering";
                pc._emitGatheringStateChange();
            }
            // Emit candidate. Also emit null candidate when all gatherers are
            // complete.
            if (!end) pc._dispatchEvent("icecandidate", event);
            if (complete) {
                pc._dispatchEvent("icecandidate", new Event("icecandidate"));
                pc.iceGatheringState = "complete";
                pc._emitGatheringStateChange();
            }
        };
        // emit already gathered candidates.
        window.setTimeout(function() {
            bufferedCandidateEvents.forEach(function(e) {
                iceGatherer.onlocalcandidate(e);
            });
        }, 0);
    };
    // Create ICE transport and DTLS transport.
    RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
        var pc = this;
        var iceTransport = new window.RTCIceTransport(null);
        iceTransport.onicestatechange = function() {
            pc._updateConnectionState();
        };
        var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
        dtlsTransport.ondtlsstatechange = function() {
            pc._updateConnectionState();
        };
        dtlsTransport.onerror = function() {
            // onerror does not set state to failed by itself.
            Object.defineProperty(dtlsTransport, "state", {
                value: "failed",
                writable: true
            });
            pc._updateConnectionState();
        };
        return {
            iceTransport: iceTransport,
            dtlsTransport: dtlsTransport
        };
    };
    // Destroy ICE gatherer, ICE transport and DTLS transport.
    // Without triggering the callbacks.
    RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(sdpMLineIndex) {
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer) {
            delete iceGatherer.onlocalcandidate;
            delete this.transceivers[sdpMLineIndex].iceGatherer;
        }
        var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
        if (iceTransport) {
            delete iceTransport.onicestatechange;
            delete this.transceivers[sdpMLineIndex].iceTransport;
        }
        var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
        if (dtlsTransport) {
            delete dtlsTransport.ondtlsstatechange;
            delete dtlsTransport.onerror;
            delete this.transceivers[sdpMLineIndex].dtlsTransport;
        }
    };
    // Start the RTP Sender and Receiver for a transceiver.
    RTCPeerConnection.prototype._transceive = function(transceiver, send, recv) {
        var params = $4d0d30e95648dedb$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
        if (send && transceiver.rtpSender) {
            params.encodings = transceiver.sendEncodingParameters;
            params.rtcp = {
                cname: $l3I5s.localCName,
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.recvEncodingParameters.length) params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
            transceiver.rtpSender.send(params);
        }
        if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
            // remove RTX field in Edge 14942
            if (transceiver.kind === "video" && transceiver.recvEncodingParameters && edgeVersion < 15019) transceiver.recvEncodingParameters.forEach(function(p) {
                delete p.rtx;
            });
            if (transceiver.recvEncodingParameters.length) params.encodings = transceiver.recvEncodingParameters;
            else params.encodings = [
                {}
            ];
            params.rtcp = {
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.rtcpParameters.cname) params.rtcp.cname = transceiver.rtcpParameters.cname;
            if (transceiver.sendEncodingParameters.length) params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
            transceiver.rtpReceiver.receive(params);
        }
    };
    RTCPeerConnection.prototype.setLocalDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($4d0d30e95648dedb$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$4d0d30e95648dedb$var$isActionAllowedInSignalingState("setLocalDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not set local " + description.type + " in state " + pc.signalingState));
        var sections;
        var sessionpart;
        if (description.type === "offer") {
            // VERY limited support for SDP munging. Limited to:
            // * changing the order of codecs
            sections = $l3I5s.splitSections(description.sdp);
            sessionpart = sections.shift();
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var caps = $l3I5s.parseRtpParameters(mediaSection);
                pc.transceivers[sdpMLineIndex].localCapabilities = caps;
            });
            pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                pc._gather(transceiver.mid, sdpMLineIndex);
            });
        } else if (description.type === "answer") {
            sections = $l3I5s.splitSections(pc.remoteDescription.sdp);
            sessionpart = sections.shift();
            var isIceLite = $l3I5s.matchPrefix(sessionpart, "a=ice-lite").length > 0;
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var transceiver = pc.transceivers[sdpMLineIndex];
                var iceGatherer = transceiver.iceGatherer;
                var iceTransport = transceiver.iceTransport;
                var dtlsTransport = transceiver.dtlsTransport;
                var localCapabilities = transceiver.localCapabilities;
                var remoteCapabilities = transceiver.remoteCapabilities;
                // treat bundle-only as not-rejected.
                var rejected = $l3I5s.isRejected(mediaSection) && $l3I5s.matchPrefix(mediaSection, "a=bundle-only").length === 0;
                if (!rejected && !transceiver.isDatachannel) {
                    var remoteIceParameters = $l3I5s.getIceParameters(mediaSection, sessionpart);
                    var remoteDtlsParameters = $l3I5s.getDtlsParameters(mediaSection, sessionpart);
                    if (isIceLite) remoteDtlsParameters.role = "server";
                    if (!pc.usingBundle || sdpMLineIndex === 0) {
                        pc._gather(transceiver.mid, sdpMLineIndex);
                        if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? "controlling" : "controlled");
                        if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                    }
                    // Calculate intersection of capabilities.
                    var params = $4d0d30e95648dedb$var$getCommonCapabilities(localCapabilities, remoteCapabilities);
                    // Start the RTCRtpSender. The RTCRtpReceiver for this
                    // transceiver has already been started in setRemoteDescription.
                    pc._transceive(transceiver, params.codecs.length > 0, false);
                }
            });
        }
        pc.localDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-local-offer");
        else pc._updateSignalingState("stable");
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.setRemoteDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($4d0d30e95648dedb$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$4d0d30e95648dedb$var$isActionAllowedInSignalingState("setRemoteDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not set remote " + description.type + " in state " + pc.signalingState));
        var streams = {};
        pc.remoteStreams.forEach(function(stream) {
            streams[stream.id] = stream;
        });
        var receiverList = [];
        var sections = $l3I5s.splitSections(description.sdp);
        var sessionpart = sections.shift();
        var isIceLite = $l3I5s.matchPrefix(sessionpart, "a=ice-lite").length > 0;
        var usingBundle = $l3I5s.matchPrefix(sessionpart, "a=group:BUNDLE ").length > 0;
        pc.usingBundle = usingBundle;
        var iceOptions = $l3I5s.matchPrefix(sessionpart, "a=ice-options:")[0];
        if (iceOptions) pc.canTrickleIceCandidates = iceOptions.substr(14).split(" ").indexOf("trickle") >= 0;
        else pc.canTrickleIceCandidates = false;
        sections.forEach(function(mediaSection, sdpMLineIndex) {
            var lines = $l3I5s.splitLines(mediaSection);
            var kind = $l3I5s.getKind(mediaSection);
            // treat bundle-only as not-rejected.
            var rejected = $l3I5s.isRejected(mediaSection) && $l3I5s.matchPrefix(mediaSection, "a=bundle-only").length === 0;
            var protocol = lines[0].substr(2).split(" ")[2];
            var direction = $l3I5s.getDirection(mediaSection, sessionpart);
            var remoteMsid = $l3I5s.parseMsid(mediaSection);
            var mid = $l3I5s.getMid(mediaSection) || $l3I5s.generateIdentifier();
            // Reject datachannels which are not implemented yet.
            if (kind === "application" && protocol === "DTLS/SCTP") {
                pc.transceivers[sdpMLineIndex] = {
                    mid: mid,
                    isDatachannel: true
                };
                return;
            }
            var transceiver;
            var iceGatherer;
            var iceTransport;
            var dtlsTransport;
            var rtpReceiver;
            var sendEncodingParameters;
            var recvEncodingParameters;
            var localCapabilities;
            var track;
            // FIXME: ensure the mediaSection has rtcp-mux set.
            var remoteCapabilities = $l3I5s.parseRtpParameters(mediaSection);
            var remoteIceParameters;
            var remoteDtlsParameters;
            if (!rejected) {
                remoteIceParameters = $l3I5s.getIceParameters(mediaSection, sessionpart);
                remoteDtlsParameters = $l3I5s.getDtlsParameters(mediaSection, sessionpart);
                remoteDtlsParameters.role = "client";
            }
            recvEncodingParameters = $l3I5s.parseRtpEncodingParameters(mediaSection);
            var rtcpParameters = $l3I5s.parseRtcpParameters(mediaSection);
            var isComplete = $l3I5s.matchPrefix(mediaSection, "a=end-of-candidates", sessionpart).length > 0;
            var cands = $l3I5s.matchPrefix(mediaSection, "a=candidate:").map(function(cand) {
                return $l3I5s.parseCandidate(cand);
            }).filter(function(cand) {
                return cand.component === 1;
            });
            // Check if we can use BUNDLE and dispose transports.
            if ((description.type === "offer" || description.type === "answer") && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
                pc._disposeIceAndDtlsTransports(sdpMLineIndex);
                pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
                pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
                pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;
                if (pc.transceivers[sdpMLineIndex].rtpSender) pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
                if (pc.transceivers[sdpMLineIndex].rtpReceiver) pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
            }
            if (description.type === "offer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
                transceiver.mid = mid;
                if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
                if (cands.length && transceiver.iceTransport.state === "new") {
                    if (isComplete && (!usingBundle || sdpMLineIndex === 0)) transceiver.iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);
                // filter RTX until additional stuff needed for RTX is implemented
                // in adapter.js
                if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                    return codec.name !== "rtx";
                });
                sendEncodingParameters = transceiver.sendEncodingParameters || [
                    {
                        ssrc: (2 * sdpMLineIndex + 2) * 1001
                    }
                ];
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                var isNewTrack = false;
                if (direction === "sendrecv" || direction === "sendonly") {
                    isNewTrack = !transceiver.rtpReceiver;
                    rtpReceiver = transceiver.rtpReceiver || new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                    if (isNewTrack) {
                        var stream;
                        track = rtpReceiver.track;
                        // FIXME: does not work with Plan B.
                        if (remoteMsid && remoteMsid.stream === "-") ;
                        else if (remoteMsid) {
                            if (!streams[remoteMsid.stream]) {
                                streams[remoteMsid.stream] = new window.MediaStream();
                                Object.defineProperty(streams[remoteMsid.stream], "id", {
                                    get: function() {
                                        return remoteMsid.stream;
                                    }
                                });
                            }
                            Object.defineProperty(track, "id", {
                                get: function() {
                                    return remoteMsid.track;
                                }
                            });
                            stream = streams[remoteMsid.stream];
                        } else {
                            if (!streams.default) streams.default = new window.MediaStream();
                            stream = streams.default;
                        }
                        if (stream) {
                            addTrackToStreamAndFireEvent(track, stream);
                            transceiver.associatedRemoteMediaStreams.push(stream);
                        }
                        receiverList.push([
                            track,
                            rtpReceiver,
                            stream
                        ]);
                    }
                } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
                    transceiver.associatedRemoteMediaStreams.forEach(function(s) {
                        var nativeTrack = s.getTracks().find(function(t) {
                            return t.id === transceiver.rtpReceiver.track.id;
                        });
                        if (nativeTrack) removeTrackFromStreamAndFireEvent(nativeTrack, s);
                    });
                    transceiver.associatedRemoteMediaStreams = [];
                }
                transceiver.localCapabilities = localCapabilities;
                transceiver.remoteCapabilities = remoteCapabilities;
                transceiver.rtpReceiver = rtpReceiver;
                transceiver.rtcpParameters = rtcpParameters;
                transceiver.sendEncodingParameters = sendEncodingParameters;
                transceiver.recvEncodingParameters = recvEncodingParameters;
                // Start the RTCRtpReceiver now. The RTPSender is started in
                // setLocalDescription.
                pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
            } else if (description.type === "answer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex];
                iceGatherer = transceiver.iceGatherer;
                iceTransport = transceiver.iceTransport;
                dtlsTransport = transceiver.dtlsTransport;
                rtpReceiver = transceiver.rtpReceiver;
                sendEncodingParameters = transceiver.sendEncodingParameters;
                localCapabilities = transceiver.localCapabilities;
                pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
                pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
                pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
                if (cands.length && iceTransport.state === "new") {
                    if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                if (!usingBundle || sdpMLineIndex === 0) {
                    if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, "controlling");
                    if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                }
                pc._transceive(transceiver, direction === "sendrecv" || direction === "recvonly", direction === "sendrecv" || direction === "sendonly");
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                if (rtpReceiver && (direction === "sendrecv" || direction === "sendonly")) {
                    track = rtpReceiver.track;
                    if (remoteMsid) {
                        if (!streams[remoteMsid.stream]) streams[remoteMsid.stream] = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams[remoteMsid.stream]
                        ]);
                    } else {
                        if (!streams.default) streams.default = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams.default);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams.default
                        ]);
                    }
                } else // FIXME: actually the receiver should be created later.
                delete transceiver.rtpReceiver;
            }
        });
        if (pc._dtlsRole === undefined) pc._dtlsRole = description.type === "offer" ? "active" : "passive";
        pc.remoteDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-remote-offer");
        else pc._updateSignalingState("stable");
        Object.keys(streams).forEach(function(sid) {
            var stream = streams[sid];
            if (stream.getTracks().length) {
                if (pc.remoteStreams.indexOf(stream) === -1) {
                    pc.remoteStreams.push(stream);
                    var event = new Event("addstream");
                    event.stream = stream;
                    window.setTimeout(function() {
                        pc._dispatchEvent("addstream", event);
                    });
                }
                receiverList.forEach(function(item) {
                    var track = item[0];
                    var receiver = item[1];
                    if (stream.id !== item[2].id) return;
                    fireAddTrack(pc, track, receiver, [
                        stream
                    ]);
                });
            }
        });
        receiverList.forEach(function(item) {
            if (item[2]) return;
            fireAddTrack(pc, item[0], item[1], []);
        });
        // check whether addIceCandidate({}) was called within four seconds after
        // setRemoteDescription.
        window.setTimeout(function() {
            if (!(pc && pc.transceivers)) return;
            pc.transceivers.forEach(function(transceiver) {
                if (transceiver.iceTransport && transceiver.iceTransport.state === "new" && transceiver.iceTransport.getRemoteCandidates().length > 0) {
                    console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification");
                    transceiver.iceTransport.addRemoteCandidate({});
                }
            });
        }, 4000);
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.close = function() {
        this.transceivers.forEach(function(transceiver) {
            /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */ if (transceiver.iceTransport) transceiver.iceTransport.stop();
            if (transceiver.dtlsTransport) transceiver.dtlsTransport.stop();
            if (transceiver.rtpSender) transceiver.rtpSender.stop();
            if (transceiver.rtpReceiver) transceiver.rtpReceiver.stop();
        });
        // FIXME: clean up tracks, local streams, remote streams, etc
        this._isClosed = true;
        this._updateSignalingState("closed");
    };
    // Update the signaling state.
    RTCPeerConnection.prototype._updateSignalingState = function(newState) {
        this.signalingState = newState;
        var event = new Event("signalingstatechange");
        this._dispatchEvent("signalingstatechange", event);
    };
    // Determine whether to fire the negotiationneeded event.
    RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
        var pc = this;
        if (this.signalingState !== "stable" || this.needNegotiation === true) return;
        this.needNegotiation = true;
        window.setTimeout(function() {
            if (pc.needNegotiation) {
                pc.needNegotiation = false;
                var event = new Event("negotiationneeded");
                pc._dispatchEvent("negotiationneeded", event);
            }
        }, 0);
    };
    // Update the connection state.
    RTCPeerConnection.prototype._updateConnectionState = function() {
        var newState;
        var states = {
            "new": 0,
            closed: 0,
            connecting: 0,
            checking: 0,
            connected: 0,
            completed: 0,
            disconnected: 0,
            failed: 0
        };
        this.transceivers.forEach(function(transceiver) {
            states[transceiver.iceTransport.state]++;
            states[transceiver.dtlsTransport.state]++;
        });
        // ICETransport.completed and connected are the same for this purpose.
        states.connected += states.completed;
        newState = "new";
        if (states.failed > 0) newState = "failed";
        else if (states.connecting > 0 || states.checking > 0) newState = "connecting";
        else if (states.disconnected > 0) newState = "disconnected";
        else if (states.new > 0) newState = "new";
        else if (states.connected > 0 || states.completed > 0) newState = "connected";
        if (newState !== this.iceConnectionState) {
            this.iceConnectionState = newState;
            var event = new Event("iceconnectionstatechange");
            this._dispatchEvent("iceconnectionstatechange", event);
        }
    };
    RTCPeerConnection.prototype.createOffer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not call createOffer after close"));
        var numAudioTracks = pc.transceivers.filter(function(t) {
            return t.kind === "audio";
        }).length;
        var numVideoTracks = pc.transceivers.filter(function(t) {
            return t.kind === "video";
        }).length;
        // Determine number of audio and video tracks we need to send/recv.
        var offerOptions = arguments[0];
        if (offerOptions) {
            // Reject Chrome legacy constraints.
            if (offerOptions.mandatory || offerOptions.optional) throw new TypeError("Legacy mandatory/optional constraints not supported.");
            if (offerOptions.offerToReceiveAudio !== undefined) {
                if (offerOptions.offerToReceiveAudio === true) numAudioTracks = 1;
                else if (offerOptions.offerToReceiveAudio === false) numAudioTracks = 0;
                else numAudioTracks = offerOptions.offerToReceiveAudio;
            }
            if (offerOptions.offerToReceiveVideo !== undefined) {
                if (offerOptions.offerToReceiveVideo === true) numVideoTracks = 1;
                else if (offerOptions.offerToReceiveVideo === false) numVideoTracks = 0;
                else numVideoTracks = offerOptions.offerToReceiveVideo;
            }
        }
        pc.transceivers.forEach(function(transceiver) {
            if (transceiver.kind === "audio") {
                numAudioTracks--;
                if (numAudioTracks < 0) transceiver.wantReceive = false;
            } else if (transceiver.kind === "video") {
                numVideoTracks--;
                if (numVideoTracks < 0) transceiver.wantReceive = false;
            }
        });
        // Create M-lines for recvonly streams.
        while(numAudioTracks > 0 || numVideoTracks > 0){
            if (numAudioTracks > 0) {
                pc._createTransceiver("audio");
                numAudioTracks--;
            }
            if (numVideoTracks > 0) {
                pc._createTransceiver("video");
                numVideoTracks--;
            }
        }
        var sdp = $l3I5s.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            // For each track, create an ice gatherer, ice transport,
            // dtls transport, potentially rtpsender and rtpreceiver.
            var track = transceiver.track;
            var kind = transceiver.kind;
            var mid = transceiver.mid || $l3I5s.generateIdentifier();
            transceiver.mid = mid;
            if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
            var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
            // filter RTX until additional stuff needed for RTX is implemented
            // in adapter.js
            if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                return codec.name !== "rtx";
            });
            localCapabilities.codecs.forEach(function(codec) {
                // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
                // by adding level-asymmetry-allowed=1
                if (codec.name === "H264" && codec.parameters["level-asymmetry-allowed"] === undefined) codec.parameters["level-asymmetry-allowed"] = "1";
                // for subsequent offers, we might have to re-use the payload
                // type of the last offer.
                if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
                    if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) codec.preferredPayloadType = remoteCodec.payloadType;
                });
            });
            localCapabilities.headerExtensions.forEach(function(hdrExt) {
                var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
                remoteExtensions.forEach(function(rHdrExt) {
                    if (hdrExt.uri === rHdrExt.uri) hdrExt.id = rHdrExt.id;
                });
            });
            // generate an ssrc now, to be used later in rtpSender.send
            var sendEncodingParameters = transceiver.sendEncodingParameters || [
                {
                    ssrc: (2 * sdpMLineIndex + 1) * 1001
                }
            ];
            if (track) // add RTX
            {
                if (edgeVersion >= 15019 && kind === "video" && !sendEncodingParameters[0].rtx) sendEncodingParameters[0].rtx = {
                    ssrc: sendEncodingParameters[0].ssrc + 1
                };
            }
            if (transceiver.wantReceive) transceiver.rtpReceiver = new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
            transceiver.localCapabilities = localCapabilities;
            transceiver.sendEncodingParameters = sendEncodingParameters;
        });
        // always offer BUNDLE and dispose on return if not supported.
        if (pc._config.bundlePolicy !== "max-compat") sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        sdp += "a=ice-options:trickle\r\n";
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            sdp += $4d0d30e95648dedb$var$writeMediaSection(transceiver, transceiver.localCapabilities, "offer", transceiver.stream, pc._dtlsRole);
            sdp += "a=rtcp-rsize\r\n";
            if (transceiver.iceGatherer && pc.iceGatheringState !== "new" && (sdpMLineIndex === 0 || !pc.usingBundle)) {
                transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
                    cand.component = 1;
                    sdp += "a=" + $l3I5s.writeCandidate(cand) + "\r\n";
                });
                if (transceiver.iceGatherer.state === "completed") sdp += "a=end-of-candidates\r\n";
            }
        });
        var desc = new window.RTCSessionDescription({
            type: "offer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.createAnswer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not call createAnswer after close"));
        var sdp = $l3I5s.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        if (pc.usingBundle) sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        var mediaSectionsInOffer = $l3I5s.getMediaSections(pc.remoteDescription.sdp).length;
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            if (sdpMLineIndex + 1 > mediaSectionsInOffer) return;
            if (transceiver.isDatachannel) {
                sdp += "m=application 0 DTLS/SCTP 5000\r\nc=IN IP4 0.0.0.0\r\na=mid:" + transceiver.mid + "\r\n";
                return;
            }
            // FIXME: look at direction.
            if (transceiver.stream) {
                var localTrack;
                if (transceiver.kind === "audio") localTrack = transceiver.stream.getAudioTracks()[0];
                else if (transceiver.kind === "video") localTrack = transceiver.stream.getVideoTracks()[0];
                if (localTrack) // add RTX
                {
                    if (edgeVersion >= 15019 && transceiver.kind === "video" && !transceiver.sendEncodingParameters[0].rtx) transceiver.sendEncodingParameters[0].rtx = {
                        ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
                    };
                }
            }
            // Calculate intersection of capabilities.
            var commonCapabilities = $4d0d30e95648dedb$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
            var hasRtx = commonCapabilities.codecs.filter(function(c) {
                return c.name.toLowerCase() === "rtx";
            }).length;
            if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
            sdp += $4d0d30e95648dedb$var$writeMediaSection(transceiver, commonCapabilities, "answer", transceiver.stream, pc._dtlsRole);
            if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
        });
        var desc = new window.RTCSessionDescription({
            type: "answer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
        var pc = this;
        var sections;
        if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) return Promise.reject(new TypeError("sdpMLineIndex or sdpMid required"));
        // TODO: needs to go into ops queue.
        return new Promise(function(resolve, reject) {
            if (!pc.remoteDescription) return reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not add ICE candidate without a remote description"));
            else if (!candidate || candidate.candidate === "") for(var j = 0; j < pc.transceivers.length; j++){
                if (pc.transceivers[j].isDatachannel) continue;
                pc.transceivers[j].iceTransport.addRemoteCandidate({});
                sections = $l3I5s.getMediaSections(pc.remoteDescription.sdp);
                sections[j] += "a=end-of-candidates\r\n";
                pc.remoteDescription.sdp = $l3I5s.getDescription(pc.remoteDescription.sdp) + sections.join("");
                if (pc.usingBundle) break;
            }
            else {
                var sdpMLineIndex = candidate.sdpMLineIndex;
                if (candidate.sdpMid) {
                    for(var i = 0; i < pc.transceivers.length; i++)if (pc.transceivers[i].mid === candidate.sdpMid) {
                        sdpMLineIndex = i;
                        break;
                    }
                }
                var transceiver = pc.transceivers[sdpMLineIndex];
                if (transceiver) {
                    if (transceiver.isDatachannel) return resolve();
                    var cand = Object.keys(candidate.candidate).length > 0 ? $l3I5s.parseCandidate(candidate.candidate) : {};
                    // Ignore Chrome's invalid candidates since Edge does not like them.
                    if (cand.protocol === "tcp" && (cand.port === 0 || cand.port === 9)) return resolve();
                    // Ignore RTCP candidates, we assume RTCP-MUX.
                    if (cand.component && cand.component !== 1) return resolve();
                    // when using bundle, avoid adding candidates to the wrong
                    // ice transport. And avoid adding candidates added in the SDP.
                    if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
                        if (!$4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, cand)) return reject($4d0d30e95648dedb$var$makeError("OperationError", "Can not add ICE candidate"));
                    }
                    // update the remoteDescription.
                    var candidateString = candidate.candidate.trim();
                    if (candidateString.indexOf("a=") === 0) candidateString = candidateString.substr(2);
                    sections = $l3I5s.getMediaSections(pc.remoteDescription.sdp);
                    sections[sdpMLineIndex] += "a=" + (cand.type ? candidateString : "end-of-candidates") + "\r\n";
                    pc.remoteDescription.sdp = sections.join("");
                } else return reject($4d0d30e95648dedb$var$makeError("OperationError", "Can not add ICE candidate"));
            }
            resolve();
        });
    };
    RTCPeerConnection.prototype.getStats = function() {
        var promises = [];
        this.transceivers.forEach(function(transceiver) {
            [
                "rtpSender",
                "rtpReceiver",
                "iceGatherer",
                "iceTransport",
                "dtlsTransport"
            ].forEach(function(method) {
                if (transceiver[method]) promises.push(transceiver[method].getStats());
            });
        });
        var fixStatsType = function(stat) {
            return ({
                inboundrtp: "inbound-rtp",
                outboundrtp: "outbound-rtp",
                candidatepair: "candidate-pair",
                localcandidate: "local-candidate",
                remotecandidate: "remote-candidate"
            })[stat.type] || stat.type;
        };
        return new Promise(function(resolve) {
            // shim getStats with maplike support
            var results = new Map();
            Promise.all(promises).then(function(res) {
                res.forEach(function(result) {
                    Object.keys(result).forEach(function(id) {
                        result[id].type = fixStatsType(result[id]);
                        results.set(id, result[id]);
                    });
                });
                resolve(results);
            });
        });
    };
    // legacy callback shims. Should be moved to adapter.js some days.
    var methods = [
        "createOffer",
        "createAnswer"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[0] === "function" || typeof args[1] === "function") return nativeMethod.apply(this, [
                arguments[2]
            ]).then(function(description) {
                if (typeof args[0] === "function") args[0].apply(null, [
                    description
                ]);
            }, function(error) {
                if (typeof args[1] === "function") args[1].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    methods = [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function" || typeof args[2] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            }, function(error) {
                if (typeof args[2] === "function") args[2].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    // getStats is special. It doesn't have a spec legacy method yet we support
    // getStats(something, cb) without error callbacks.
    [
        "getStats"
    ].forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    return RTCPeerConnection;
};

});
parcelRegister("l3I5s", function(module, exports) {
/* eslint-env node */ "use strict";
// SDP helpers.
var $f54c1386e6532a91$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$f54c1386e6532a91$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substr(2, 10);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$f54c1386e6532a91$var$SDPUtils.localCName = $f54c1386e6532a91$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$f54c1386e6532a91$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map(function(line) {
        return line.trim();
    });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$f54c1386e6532a91$var$SDPUtils.splitSections = function(blob) {
    var parts = blob.split("\nm=");
    return parts.map(function(part, index) {
        return (index > 0 ? "m=" + part : part).trim() + "\r\n";
    });
};
// returns the session description.
$f54c1386e6532a91$var$SDPUtils.getDescription = function(blob) {
    var sections = $f54c1386e6532a91$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// returns the individual media sections.
$f54c1386e6532a91$var$SDPUtils.getMediaSections = function(blob) {
    var sections = $f54c1386e6532a91$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$f54c1386e6532a91$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $f54c1386e6532a91$var$SDPUtils.splitLines(blob).filter(function(line) {
        return line.indexOf(prefix) === 0;
    });
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
$f54c1386e6532a91$var$SDPUtils.parseCandidate = function(line) {
    var parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    var candidate = {
        foundation: parts[0],
        component: parseInt(parts[1], 10),
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(var i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compability.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
$f54c1386e6532a91$var$SDPUtils.writeCandidate = function(candidate) {
    var sdp = [];
    sdp.push(candidate.foundation);
    sdp.push(candidate.component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    var type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
$f54c1386e6532a91$var$SDPUtils.parseIceOptions = function(line) {
    return line.substr(14).split(" ");
};
// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$f54c1386e6532a91$var$SDPUtils.parseRtpMap = function(line) {
    var parts = line.substr(9).split(" ");
    var parsed = {
        payloadType: parseInt(parts.shift(), 10) // was: id
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeRtpMap = function(codec) {
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    var channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$f54c1386e6532a91$var$SDPUtils.parseExtmap = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1]
    };
};
// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$f54c1386e6532a91$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + "\r\n";
};
// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$f54c1386e6532a91$var$SDPUtils.parseFmtp = function(line) {
    var parsed = {};
    var kv;
    var parts = line.substr(line.indexOf(" ") + 1).split(";");
    for(var j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeFmtp = function(codec) {
    var line = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        var params = [];
        Object.keys(codec.parameters).forEach(function(param) {
            if (codec.parameters[param]) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$f54c1386e6532a91$var$SDPUtils.parseRtcpFb = function(line) {
    var parts = line.substr(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeRtcpFb = function(codec) {
    var lines = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$f54c1386e6532a91$var$SDPUtils.parseSsrcMedia = function(line) {
    var sp = line.indexOf(" ");
    var parts = {
        ssrc: parseInt(line.substr(7, sp - 7), 10)
    };
    var colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substr(sp + 1, colon - sp - 1);
        parts.value = line.substr(colon + 1);
    } else parts.attribute = line.substr(sp + 1);
    return parts;
};
$f54c1386e6532a91$var$SDPUtils.parseSsrcGroup = function(line) {
    var parts = line.substr(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map(function(ssrc) {
            return parseInt(ssrc, 10);
        })
    };
};
// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
$f54c1386e6532a91$var$SDPUtils.getMid = function(mediaSection) {
    var mid = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substr(6);
};
$f54c1386e6532a91$var$SDPUtils.parseFingerprint = function(line) {
    var parts = line.substr(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1]
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$f54c1386e6532a91$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    var lines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role.
    // Note2: 'algorithm' is not case sensitive except in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($f54c1386e6532a91$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$f54c1386e6532a91$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    var sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach(function(fp) {
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$f54c1386e6532a91$var$SDPUtils.parseCryptoLine = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$f54c1386e6532a91$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $f54c1386e6532a91$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$f54c1386e6532a91$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    var parts = keyParams.substr(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$f54c1386e6532a91$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES paramters.
$f54c1386e6532a91$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    var lines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($f54c1386e6532a91$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$f54c1386e6532a91$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    var ufrag = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    var pwd = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substr(12),
        password: pwd.substr(10)
    };
};
// Serializes ICE parameters to SDP.
$f54c1386e6532a91$var$SDPUtils.writeIceParameters = function(params) {
    return "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
};
// Parses the SDP media section and returns RTCRtpParameters.
$f54c1386e6532a91$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    var description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    for(var i = 3; i < mline.length; i++){
        var pt = mline[i];
        var rtpmapline = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            var codec = $f54c1386e6532a91$var$SDPUtils.parseRtpMap(rtpmapline);
            var fmtps = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $f54c1386e6532a91$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($f54c1386e6532a91$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach(function(line) {
        description.headerExtensions.push($f54c1386e6532a91$var$SDPUtils.parseExtmap(line));
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$f54c1386e6532a91$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    var sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " UDP/TLS/RTP/SAVPF ";
    sdp += caps.codecs.map(function(codec) {
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach(function(codec) {
        sdp += $f54c1386e6532a91$var$SDPUtils.writeRtpMap(codec);
        sdp += $f54c1386e6532a91$var$SDPUtils.writeFmtp(codec);
        sdp += $f54c1386e6532a91$var$SDPUtils.writeRtcpFb(codec);
    });
    var maxptime = 0;
    caps.codecs.forEach(function(codec) {
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    sdp += "a=rtcp-mux\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach(function(extension) {
        sdp += $f54c1386e6532a91$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$f54c1386e6532a91$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    var encodingParameters = [];
    var description = $f54c1386e6532a91$var$SDPUtils.parseRtpParameters(mediaSection);
    var hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    var hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    var ssrcs = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(parts) {
        return parts.attribute === "cname";
    });
    var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    var secondarySsrc;
    var flows = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map(function(line) {
        var parts = line.substr(17).split(" ");
        return parts.map(function(part) {
            return parseInt(part, 10);
        });
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach(function(codec) {
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            var encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    var bandwidth = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substr(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substr(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach(function(params) {
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$f54c1386e6532a91$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    var rtcpParameters = {};
    // Gets the first SSRC. Note tha with RTX there might be multiple
    // SSRCs.
    var remoteSsrc = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(obj) {
        return obj.attribute === "cname";
    })[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    var rsize = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    var mux = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$f54c1386e6532a91$var$SDPUtils.parseMsid = function(mediaSection) {
    var parts;
    var spec = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substr(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    var planB = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(msidParts) {
        return msidParts.attribute === "msid";
    });
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$f54c1386e6532a91$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    var mline = $f54c1386e6532a91$var$SDPUtils.parseMLine(mediaSection);
    var maxSizeLine = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    var maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    var sctpPort = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substr(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    var sctpMapLines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        var parts = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:")[0].substr(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$f54c1386e6532a91$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    var output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$f54c1386e6532a91$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 21);
};
// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$f54c1386e6532a91$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    var sessionId;
    var version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $f54c1386e6532a91$var$SDPUtils.generateSessionId();
    var user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
$f54c1386e6532a91$var$SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
    var sdp = $f54c1386e6532a91$var$SDPUtils.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $f54c1386e6532a91$var$SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $f54c1386e6532a91$var$SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.direction) sdp += "a=" + transceiver.direction + "\r\n";
    else if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        // spec.
        var msid = "msid:" + stream.id + " " + transceiver.rtpSender.track.id + "\r\n";
        sdp += "a=" + msid;
        // for Chrome.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $f54c1386e6532a91$var$SDPUtils.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $f54c1386e6532a91$var$SDPUtils.localCName + "\r\n";
    return sdp;
};
// Gets the direction from the mediaSection or the sessionpart.
$f54c1386e6532a91$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    for(var i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substr(2);
        default:
    }
    if (sessionpart) return $f54c1386e6532a91$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$f54c1386e6532a91$var$SDPUtils.getKind = function(mediaSection) {
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    return mline[0].substr(2);
};
$f54c1386e6532a91$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$f54c1386e6532a91$var$SDPUtils.parseMLine = function(mediaSection) {
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var parts = lines[0].substr(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$f54c1386e6532a91$var$SDPUtils.parseOLine = function(mediaSection) {
    var line = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    var parts = line.substr(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$f54c1386e6532a91$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(blob);
    for(var i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
module.exports = $f54c1386e6532a91$var$SDPUtils;

});





parcelRegister("bnoro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dmfT0 = parcelRequire("dmfT0");

var $f8R8g = parcelRequire("f8R8g");
function $8484cd27499b985d$var$getUserMedia(constraints, options) {
    options = options || {};
    options.util = options.util || $f8R8g;
    options.navigator = options.navigator || (typeof navigator !== "undefined" ? navigator : null);
    return new Promise(function(resolve, reject) {
        if (!options.navigator) throw new $dmfT0.NotSupportedError("getUserMedia is not supported");
        switch("function"){
            case typeof (options.navigator.mediaDevices && options.navigator.mediaDevices.getUserMedia):
                return resolve(options.navigator.mediaDevices.getUserMedia(constraints));
            case typeof options.navigator.webkitGetUserMedia:
                return options.navigator.webkitGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.mozGetUserMedia:
                return options.navigator.mozGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.getUserMedia:
                return options.navigator.getUserMedia(constraints, resolve, reject);
            default:
                throw new $dmfT0.NotSupportedError("getUserMedia is not supported");
        }
    }).catch(function(e) {
        throw options.util.isFirefox() && e.name === "NotReadableError" ? new $dmfT0.NotSupportedError("Firefox does not currently support opening multiple audio input trackssimultaneously, even across different tabs.\nRelated Bugzilla thread: https://bugzilla.mozilla.org/show_bug.cgi?id=1299324") : e;
    });
}
module.exports.default = $8484cd27499b985d$var$getUserMedia;

});

parcelRegister("gnRnx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $84TYu = parcelRequire("84TYu");

var $gUasN = parcelRequire("gUasN");

var $dmfT0 = parcelRequire("dmfT0");
/**
 * @class
 * @param {string} name - Name of the sound
 * @param {string} url - URL of the sound
 * @param {Sound#ConstructorOptions} options
 * @property {boolean} isPlaying - Whether the Sound is currently playing audio.
 * @property {string} name - Name of the sound
 * @property {string} url - URL of the sound
 * @property {AudioContext} audioContext - The AudioContext to use if available for AudioPlayer.
 */ /**
 * @typedef {Object} Sound#ConstructorOptions
 * @property {number} [maxDuration=0] - The maximum length of time to play the sound
 *   before stopping it.
 * @property {Boolean} [shouldLoop=false] - Whether the sound should be looped.
 */ function $bed8333b6111cc0c$var$Sound(name, url, options) {
    if (!(this instanceof $bed8333b6111cc0c$var$Sound)) return new $bed8333b6111cc0c$var$Sound(name, url, options);
    if (!name || !url) throw new $dmfT0.InvalidArgumentError("name and url are required arguments");
    options = Object.assign({
        AudioFactory: typeof Audio !== "undefined" ? Audio : null,
        maxDuration: 0,
        shouldLoop: false
    }, options);
    options.AudioPlayer = options.audioContext ? $gUasN.default.bind($gUasN.default, options.audioContext) : options.AudioFactory;
    Object.defineProperties(this, {
        _Audio: {
            value: options.AudioPlayer
        },
        _activeEls: {
            value: new Map()
        },
        _isSinkSupported: {
            value: options.AudioFactory !== null && typeof options.AudioFactory.prototype.setSinkId === "function"
        },
        _maxDuration: {
            value: options.maxDuration
        },
        _maxDurationTimeout: {
            value: null,
            writable: true
        },
        _operations: {
            value: new $84TYu.AsyncQueue()
        },
        _playPromise: {
            value: null,
            writable: true
        },
        _shouldLoop: {
            value: options.shouldLoop
        },
        _sinkIds: {
            value: [
                "default"
            ]
        },
        isPlaying: {
            enumerable: true,
            get: function() {
                return !!this._playPromise;
            }
        },
        name: {
            enumerable: true,
            value: name
        },
        url: {
            enumerable: true,
            value: url
        }
    });
    if (this._Audio) // Play it (muted and should not loop) as soon as possible so that it does not get incorrectly caught by Chrome's
    // "gesture requirement for media playback" feature.
    // https://plus.google.com/+FrancoisBeaufort/posts/6PiJQqJzGqX
    this._play(true, false);
}
function $bed8333b6111cc0c$var$destroyAudioElement(audioElement) {
    if (audioElement) {
        audioElement.pause();
        audioElement.src = "";
        audioElement.srcObject = null;
        audioElement.load();
    }
}
/**
 * Plays the audio element that was initialized using the speficied sinkId
 */ $bed8333b6111cc0c$var$Sound.prototype._playAudioElement = function _playAudioElement(sinkId, isMuted, shouldLoop) {
    var _this = this;
    var audioElement = this._activeEls.get(sinkId);
    if (!audioElement) throw new $dmfT0.InvalidArgumentError('sinkId: "' + sinkId + "\" doesn't have an audio element");
    audioElement.muted = !!isMuted;
    audioElement.loop = !!shouldLoop;
    return audioElement.play().then(function() {
        return audioElement;
    }).catch(function(reason) {
        $bed8333b6111cc0c$var$destroyAudioElement(audioElement);
        _this._activeEls.delete(sinkId);
        throw reason;
    });
};
/**
 * Start playing the sound. Will stop the currently playing sound first.
 * If it exists, the audio element that was initialized for the sinkId will be used
 */ $bed8333b6111cc0c$var$Sound.prototype._play = function _play(forceIsMuted, forceShouldLoop) {
    if (this.isPlaying) this._stop();
    if (this._maxDuration > 0) this._maxDurationTimeout = setTimeout(this._stop.bind(this), this._maxDuration);
    forceShouldLoop = typeof forceShouldLoop === "boolean" ? forceShouldLoop : this._shouldLoop;
    var self = this;
    var playPromise = this._playPromise = Promise.all(this._sinkIds.map(function createAudioElement(sinkId) {
        if (!self._Audio) return Promise.resolve();
        var audioElement = self._activeEls.get(sinkId);
        if (audioElement) return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
        audioElement = new self._Audio(self.url);
        // Make sure the browser always retrieves the resource using CORS.
        // By default when using media tags, origin header is not sent to server
        // which causes the server to not return CORS headers. When this caches
        // on the CDN or browser, it causes issues to future requests that needs CORS,
        // which is true when using AudioContext. Please note that we won't have to do this
        // once we migrate to CloudFront.
        if (typeof audioElement.setAttribute === "function") audioElement.setAttribute("crossorigin", "anonymous");
        /**
         * (rrowland) Bug in Chrome 53 & 54 prevents us from calling Audio.setSinkId without
         *   crashing the tab. https://bugs.chromium.org/p/chromium/issues/detail?id=655342
         */ return new Promise(function(resolve) {
            audioElement.addEventListener("canplaythrough", resolve);
        }).then(function() {
            return (self._isSinkSupported ? audioElement.setSinkId(sinkId) : Promise.resolve()).then(function setSinkIdSuccess() {
                self._activeEls.set(sinkId, audioElement);
                // Stop has been called, bail out
                if (!self._playPromise) return Promise.resolve();
                return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
            });
        });
    }));
    return playPromise;
};
/**
 * Stop playing the sound.
 */ $bed8333b6111cc0c$var$Sound.prototype._stop = function _stop() {
    var _this = this;
    this._activeEls.forEach(function(audioEl, sinkId) {
        if (_this._sinkIds.includes(sinkId)) {
            audioEl.pause();
            audioEl.currentTime = 0;
        } else {
            // Destroy the ones that are not used anymore
            $bed8333b6111cc0c$var$destroyAudioElement(audioEl);
            _this._activeEls.delete(sinkId);
        }
    });
    clearTimeout(this._maxDurationTimeout);
    this._playPromise = null;
    this._maxDurationTimeout = null;
};
/**
 * Update the sinkIds of the audio output devices this sound should play through.
 */ $bed8333b6111cc0c$var$Sound.prototype.setSinkIds = function setSinkIds(ids) {
    if (!this._isSinkSupported) return;
    ids = ids.forEach ? ids : [
        ids
    ];
    [].splice.apply(this._sinkIds, [
        0,
        this._sinkIds.length
    ].concat(ids));
};
/**
 * Add a stop operation to the queue
 */ $bed8333b6111cc0c$var$Sound.prototype.stop = function stop() {
    var _this = this;
    this._operations.enqueue(function() {
        _this._stop();
        return Promise.resolve();
    });
};
/**
 * Add a play operation to the queue
 */ $bed8333b6111cc0c$var$Sound.prototype.play = function play() {
    var _this = this;
    return this._operations.enqueue(function() {
        return _this._play();
    });
};
module.exports.default = $bed8333b6111cc0c$var$Sound;

});
parcelRegister("84TYu", function(module, exports) {
"use strict";
var $5e1a1dd2be123335$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5e1a1dd2be123335$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncQueue = void 0;

var $atD7H = parcelRequire("atD7H");
/**
 * Queue async operations and executes them synchronously.
 */ var $5e1a1dd2be123335$var$AsyncQueue = /** @class */ function() {
    function AsyncQueue() {
        /**
         * The list of async operations in this queue
         */ this._operations = [];
    }
    /**
     * Adds the async operation to the queue
     * @param callback An async callback that returns a promise
     * @returns A promise that will get resolved or rejected after executing the callback
     */ AsyncQueue.prototype.enqueue = function(callback) {
        var hasPending = !!this._operations.length;
        var deferred = new $atD7H.default();
        this._operations.push({
            deferred: deferred,
            callback: callback
        });
        if (!hasPending) this._processQueue();
        return deferred.promise;
    };
    /**
     * Start processing the queue. This executes the first item and removes it after.
     * Then do the same for next items until the queue is emptied.
     */ AsyncQueue.prototype._processQueue = function() {
        return $5e1a1dd2be123335$var$__awaiter(this, void 0, void 0, function() {
            var _a, deferred, callback, result, error, hasResolved, e_1;
            return $5e1a1dd2be123335$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this._operations.length) return [
                            3 /*break*/ ,
                            5
                        ];
                        _a = this._operations[0], deferred = _a.deferred, callback = _a.callback;
                        result = void 0;
                        error = void 0;
                        hasResolved = void 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback()
                        ];
                    case 2:
                        result = _b.sent();
                        hasResolved = true;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        error = e_1;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        // Remove the item
                        this._operations.shift();
                        if (hasResolved) deferred.resolve(result);
                        else deferred.reject(error);
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AsyncQueue;
}();
module.exports.AsyncQueue = $5e1a1dd2be123335$var$AsyncQueue;

});
parcelRegister("atD7H", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Deferred Promise
 */ var $7a0af5df212bae23$var$Deferred = /** @class */ function() {
    /**
     * @constructor
     */ function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        /**
         * @returns The {@link Deferred} Promise
         */ get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Rejects this promise
     */ Deferred.prototype.reject = function(reason) {
        this._reject(reason);
    };
    /**
     * Resolves this promise
     */ Deferred.prototype.resolve = function(value) {
        this._resolve(value);
    };
    return Deferred;
}();
module.exports.default = $7a0af5df212bae23$var$Deferred;

});


parcelRegister("gUasN", function(module, exports) {
"use strict";
var $c4e9fe229c935929$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c4e9fe229c935929$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4e9fe229c935929$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gq4s2 = parcelRequire("gq4s2");

var $bwHPZ = parcelRequire("bwHPZ");
/**
 * An {@link AudioPlayer} is an HTMLAudioElement-like object that uses AudioContext
 *   to circumvent browser limitations.
 * @private
 */ var $c4e9fe229c935929$var$AudioPlayer = /** @class */ function(_super) {
    $c4e9fe229c935929$var$__extends(AudioPlayer, _super);
    /**
     * @private
     */ function AudioPlayer(audioContext, srcOrOptions, options) {
        if (srcOrOptions === void 0) srcOrOptions = {};
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The AudioBufferSourceNode of the actively loaded sound. Null if a sound
         *   has not been loaded yet. This is re-used for each time the sound is
         *   played.
         */ _this._audioNode = null;
        /**
         * Whether or not the audio element should loop. If disabled during playback,
         *   playing continues until the sound ends and then stops looping.
         */ _this._loop = false;
        /**
         * An Array of deferred-like objects for each pending `play` Promise. When
         *   .pause() is called or .src is set, all pending play Promises are
         *   immediately rejected.
         */ _this._pendingPlayDeferreds = [];
        /**
         * The current sinkId of the device audio is being played through.
         */ _this._sinkId = "default";
        /**
         * The source URL of the sound to play. When set, the currently playing sound will stop.
         */ _this._src = "";
        if (typeof srcOrOptions !== "string") options = srcOrOptions;
        _this._audioContext = audioContext;
        _this._audioElement = new (options.AudioFactory || Audio)();
        _this._bufferPromise = _this._createPlayDeferred().promise;
        _this._destination = _this._audioContext.destination;
        _this._gainNode = _this._audioContext.createGain();
        _this._gainNode.connect(_this._destination);
        _this._XMLHttpRequest = options.XMLHttpRequestFactory || XMLHttpRequest;
        _this.addEventListener("canplaythrough", function() {
            _this._resolvePlayDeferreds();
        });
        if (typeof srcOrOptions === "string") _this.src = srcOrOptions;
        return _this;
    }
    Object.defineProperty(AudioPlayer.prototype, "destination", {
        get: function() {
            return this._destination;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(shouldLoop) {
            var self = this;
            function pauseAfterPlaythrough() {
                self._audioNode.removeEventListener("ended", pauseAfterPlaythrough);
                self.pause();
            }
            // If a sound is already looping, it should continue playing
            //   the current playthrough and then stop.
            if (!shouldLoop && this.loop && !this.paused) this._audioNode.addEventListener("ended", pauseAfterPlaythrough);
            this._loop = shouldLoop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "muted", {
        /**
         * Whether the audio element is muted.
         */ get: function() {
            return this._gainNode.gain.value === 0;
        },
        set: function(shouldBeMuted) {
            this._gainNode.gain.value = shouldBeMuted ? 0 : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "paused", {
        /**
         * Whether the sound is paused. this._audioNode only exists when sound is playing;
         *   otherwise AudioPlayer is considered paused.
         */ get: function() {
            return this._audioNode === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "src", {
        get: function() {
            return this._src;
        },
        set: function(src) {
            this._load(src);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "srcObject", {
        /**
         * The srcObject of the HTMLMediaElement
         */ get: function() {
            return this._audioElement.srcObject;
        },
        set: function(srcObject) {
            this._audioElement.srcObject = srcObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "sinkId", {
        get: function() {
            return this._sinkId;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Stop any ongoing playback and reload the source file.
     */ AudioPlayer.prototype.load = function() {
        this._load(this._src);
    };
    /**
     * Pause the audio coming from this AudioPlayer. This will reject any pending
     *   play Promises.
     */ AudioPlayer.prototype.pause = function() {
        if (this.paused) return;
        this._audioElement.pause();
        this._audioNode.stop();
        this._audioNode.disconnect(this._gainNode);
        this._audioNode = null;
        this._rejectPlayDeferreds(new Error("The play() request was interrupted by a call to pause()."));
    };
    /**
     * Play the sound. If the buffer hasn't loaded yet, wait for the buffer to load. If
     *   the source URL is not set yet, this Promise will remain pending until a source
     *   URL is set.
     */ AudioPlayer.prototype.play = function() {
        return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
            var buffer;
            var _this = this;
            return $c4e9fe229c935929$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.paused) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._bufferPromise
                        ];
                    case 1:
                        _a.sent();
                        if (!this.paused) return [
                            2 /*return*/ 
                        ];
                        throw new Error("The play() request was interrupted by a call to pause().");
                    case 2:
                        this._audioNode = this._audioContext.createBufferSource();
                        this._audioNode.loop = this.loop;
                        this._audioNode.addEventListener("ended", function() {
                            if (_this._audioNode && _this._audioNode.loop) return;
                            _this.dispatchEvent("ended");
                        });
                        return [
                            4 /*yield*/ ,
                            this._bufferPromise
                        ];
                    case 3:
                        buffer = _a.sent();
                        if (this.paused) throw new Error("The play() request was interrupted by a call to pause().");
                        this._audioNode.buffer = buffer;
                        this._audioNode.connect(this._gainNode);
                        this._audioNode.start();
                        if (this._audioElement.srcObject) return [
                            2 /*return*/ ,
                            this._audioElement.play()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change which device the sound should play through.
     * @param sinkId - The sink of the device to play sound through.
     */ AudioPlayer.prototype.setSinkId = function(sinkId) {
        return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
            return $c4e9fe229c935929$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof this._audioElement.setSinkId !== "function") throw new Error("This browser does not support setSinkId.");
                        if (sinkId === this.sinkId) return [
                            2 /*return*/ 
                        ];
                        if (sinkId === "default") {
                            if (!this.paused) this._gainNode.disconnect(this._destination);
                            this._audioElement.srcObject = null;
                            this._destination = this._audioContext.destination;
                            this._gainNode.connect(this._destination);
                            this._sinkId = sinkId;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this._audioElement.setSinkId(sinkId)
                        ];
                    case 1:
                        _a.sent();
                        if (this._audioElement.srcObject) return [
                            2 /*return*/ 
                        ];
                        this._gainNode.disconnect(this._audioContext.destination);
                        this._destination = this._audioContext.createMediaStreamDestination();
                        this._audioElement.srcObject = this._destination.stream;
                        this._sinkId = sinkId;
                        this._gainNode.connect(this._destination);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create a Deferred for a Promise that will be resolved when .src is set or rejected
     *   when .pause is called.
     */ AudioPlayer.prototype._createPlayDeferred = function() {
        var deferred = new $gq4s2.default();
        this._pendingPlayDeferreds.push(deferred);
        return deferred;
    };
    /**
     * Stop current playback and load a sound file.
     * @param src - The source URL of the file to load
     */ AudioPlayer.prototype._load = function(src) {
        var _this = this;
        if (this._src && this._src !== src) this.pause();
        this._src = src;
        this._bufferPromise = new Promise(function(resolve, reject) {
            return $c4e9fe229c935929$var$__awaiter(_this, void 0, void 0, function() {
                var buffer;
                return $c4e9fe229c935929$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!src) return [
                                2 /*return*/ ,
                                this._createPlayDeferred().promise
                            ];
                            return [
                                4 /*yield*/ ,
                                $c4e9fe229c935929$var$bufferSound(this._audioContext, this._XMLHttpRequest, src)
                            ];
                        case 1:
                            buffer = _a.sent();
                            this.dispatchEvent("canplaythrough");
                            resolve(buffer);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    /**
     * Reject all deferreds for the Play promise.
     * @param reason
     */ AudioPlayer.prototype._rejectPlayDeferreds = function(reason) {
        var deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(function(_a) {
            var reject = _a.reject;
            return reject(reason);
        });
    };
    /**
     * Resolve all deferreds for the Play promise.
     * @param result
     */ AudioPlayer.prototype._resolvePlayDeferreds = function(result) {
        var deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(function(_a) {
            var resolve = _a.resolve;
            return resolve(result);
        });
    };
    return AudioPlayer;
}($bwHPZ.default);
/**
 * Use XMLHttpRequest to load the AudioBuffer of a remote audio asset.
 * @private
 * @param context - The AudioContext to use to decode the audio data
 * @param RequestFactory - The XMLHttpRequest factory to build
 * @param src - The URL of the audio asset to load.
 * @returns A Promise containing the decoded AudioBuffer.
 */ // tslint:disable-next-line:variable-name
function $c4e9fe229c935929$var$bufferSound(context, RequestFactory, src) {
    return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
        var request, event;
        return $c4e9fe229c935929$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    request = new RequestFactory();
                    request.open("GET", src, true);
                    request.responseType = "arraybuffer";
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            request.addEventListener("load", resolve);
                            request.send();
                        })
                    ];
                case 1:
                    event = _a.sent();
                    // Safari uses a callback here instead of a Promise.
                    try {
                        return [
                            2 /*return*/ ,
                            context.decodeAudioData(event.target.response)
                        ];
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                context.decodeAudioData(event.target.response, resolve);
                            })
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.default = $c4e9fe229c935929$var$AudioPlayer;

});
parcelRegister("gq4s2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var $bf4286f23b7e4663$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "reject", {
        get: function() {
            return this._reject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Deferred.prototype, "resolve", {
        get: function() {
            return this._resolve;
        },
        enumerable: false,
        configurable: true
    });
    return Deferred;
}();
module.exports.default = $bf4286f23b7e4663$var$Deferred;

});

parcelRegister("bwHPZ", function(module, exports) {
"use strict";
var $8644b01a35e59d4d$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");
var $8644b01a35e59d4d$var$EventTarget = /** @class */ function() {
    function EventTarget() {
        this._eventEmitter = new $11OXI.EventEmitter();
    }
    EventTarget.prototype.addEventListener = function(name, handler) {
        return this._eventEmitter.addListener(name, handler);
    };
    EventTarget.prototype.dispatchEvent = function(name) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return (_a = this._eventEmitter).emit.apply(_a, $8644b01a35e59d4d$var$__spreadArrays([
            name
        ], args));
    };
    EventTarget.prototype.removeEventListener = function(name, handler) {
        return this._eventEmitter.removeListener(name, handler);
    };
    return EventTarget;
}();
module.exports.default = $8644b01a35e59d4d$var$EventTarget;

});



parcelRegister("c5BfP", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateVoiceEventSid = void 0;

var $dbnFk = parcelRequire("dbnFk");

var $dmfT0 = parcelRequire("dmfT0");
// If imported as an ESM module, sometimes md5 is available by accessing
// the "default" property of the imported library.
// @ts-ignore
var $8cd2d998b29ee05f$var$md5 = typeof $dbnFk === "function" ? $dbnFk : $dbnFk.default;
function $8cd2d998b29ee05f$var$generateUuid() {
    if (typeof window !== "object") throw new $dmfT0.NotSupportedError("This platform is not supported.");
    var crypto = window.crypto;
    if (typeof crypto !== "object") throw new $dmfT0.NotSupportedError("The `crypto` module is not available on this platform.");
    if (typeof (crypto.randomUUID || crypto.getRandomValues) === "undefined") throw new $dmfT0.NotSupportedError("Neither `crypto.randomUUID` or `crypto.getRandomValues` are available on this platform.");
    var uInt32Arr = window.Uint32Array;
    if (typeof uInt32Arr === "undefined") throw new $dmfT0.NotSupportedError("The `Uint32Array` module is not available on this platform.");
    var generateRandomValues = typeof crypto.randomUUID === "function" ? function() {
        return crypto.randomUUID();
    } : function() {
        return crypto.getRandomValues(new Uint32Array(32)).toString();
    };
    return $8cd2d998b29ee05f$var$md5(generateRandomValues());
}
function $8cd2d998b29ee05f$var$generateVoiceEventSid() {
    return "KX" + $8cd2d998b29ee05f$var$generateUuid();
}
module.exports.generateVoiceEventSid = $8cd2d998b29ee05f$var$generateVoiceEventSid;

});
parcelRegister("dbnFk", function(module, exports) {




(function() {
    var crypt = (parcelRequire("1dirW")), utf8 = (parcelRequire("2uhSt")).utf8, isBuffer = (parcelRequire("bGeEO")), bin = (parcelRequire("2uhSt")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === "binary") message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    module.exports = function(message, options) {
        if (message === undefined || message === null) throw new Error("Illegal argument " + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();

});



parcelRegister("56Fj4", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IceCandidate = void 0;
/**
 * {@link RTCIceCandidate} parses an ICE candidate gathered by the browser
 * and returns a IceCandidate object
 */ var $3b7d8de69f288bc0$var$IceCandidate = /** @class */ function() {
    /**
     * @constructor
     * @param iceCandidate RTCIceCandidate coming from the browser
     */ function IceCandidate(iceCandidate, isRemote) {
        if (isRemote === void 0) isRemote = false;
        /**
         * Whether this is deleted from the list of candidate gathered
         */ this.deleted = false;
        var cost;
        var parts = iceCandidate.candidate.split("network-cost ");
        if (parts[1]) cost = parseInt(parts[1], 10);
        this.candidateType = iceCandidate.type;
        this.ip = iceCandidate.ip || iceCandidate.address;
        this.isRemote = isRemote;
        this.networkCost = cost;
        this.port = iceCandidate.port;
        this.priority = iceCandidate.priority;
        this.protocol = iceCandidate.protocol;
        this.relatedAddress = iceCandidate.relatedAddress;
        this.relatedPort = iceCandidate.relatedPort;
        this.tcpType = iceCandidate.tcpType;
        this.transportId = iceCandidate.sdpMid;
    }
    /**
     * Get the payload object for insights
     */ IceCandidate.prototype.toPayload = function() {
        return {
            "candidate_type": this.candidateType,
            "deleted": this.deleted,
            "ip": this.ip,
            "is_remote": this.isRemote,
            "network-cost": this.networkCost,
            "port": this.port,
            "priority": this.priority,
            "protocol": this.protocol,
            "related_address": this.relatedAddress,
            "related_port": this.relatedPort,
            "tcp_type": this.tcpType,
            "transport_id": this.transportId
        };
    };
    return IceCandidate;
}();
module.exports.IceCandidate = $3b7d8de69f288bc0$var$IceCandidate;

});

parcelRegister("j8NvP", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $def52bc890d25e83$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $def52bc890d25e83$var$__assign = module.exports && module.exports.__assign || function() {
    $def52bc890d25e83$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $def52bc890d25e83$var$__assign.apply(this, arguments);
};
var $def52bc890d25e83$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $11OXI = parcelRequire("11OXI");

var $dmfT0 = parcelRequire("dmfT0");

var $8kkx2 = parcelRequire("8kkx2");

var $3rqOC = parcelRequire("3rqOC");

var $f8R8g = parcelRequire("f8R8g");
// How many samples we use when testing metric thresholds
var $def52bc890d25e83$var$SAMPLE_COUNT_METRICS = 5;
// How many samples that need to cross the threshold to
// raise or clear a warning.
var $def52bc890d25e83$var$SAMPLE_COUNT_CLEAR = 0;
var $def52bc890d25e83$var$SAMPLE_COUNT_RAISE = 3;
var $def52bc890d25e83$var$SAMPLE_INTERVAL = 1000;
var $def52bc890d25e83$var$WARNING_TIMEOUT = 5000;
var $def52bc890d25e83$var$DEFAULT_THRESHOLDS = {
    audioInputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    audioOutputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    bytesReceived: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    bytesSent: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    jitter: {
        max: 30
    },
    mos: {
        min: 3
    },
    packetsLostFraction: [
        {
            max: 1
        },
        {
            clearValue: 1,
            maxAverage: 3,
            sampleCount: 7
        }
    ],
    rtt: {
        max: 400
    }
};
/**
 * Count the number of values that cross the max threshold.
 * @private
 * @param max - The max allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $def52bc890d25e83$var$countHigh(max, values) {
    return values.reduce(function(highCount, value) {
        return highCount += value > max ? 1 : 0;
    }, 0);
}
/**
 * Count the number of values that cross the min threshold.
 * @private
 * @param min - The minimum allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $def52bc890d25e83$var$countLow(min, values) {
    return values.reduce(function(lowCount, value) {
        return lowCount += value < min ? 1 : 0;
    }, 0);
}
/**
 * Calculate the standard deviation from a list of numbers.
 * @private
 * @param values The list of numbers to calculate the standard deviation from.
 * @returns The standard deviation of a list of numbers.
 */ function $def52bc890d25e83$var$calculateStandardDeviation(values) {
    if (values.length <= 0) return null;
    var valueAverage = values.reduce(function(partialSum, value) {
        return partialSum + value;
    }, 0) / values.length;
    var diffSquared = values.map(function(value) {
        return Math.pow(value - valueAverage, 2);
    });
    var stdDev = Math.sqrt(diffSquared.reduce(function(partialSum, value) {
        return partialSum + value;
    }, 0) / diffSquared.length);
    return stdDev;
}
/**
 * Flatten a set of numerical sample sets into a single array of samples.
 * @param sampleSets
 */ function $def52bc890d25e83$var$flattenSamples(sampleSets) {
    return sampleSets.reduce(function(flat, current) {
        return $def52bc890d25e83$var$__spreadArrays(flat, current);
    }, []);
}
/**
 * {@link StatsMonitor} polls a peerConnection via PeerConnection.getStats
 * and emits warnings when stats cross the specified threshold values.
 */ var $def52bc890d25e83$var$StatsMonitor = /** @class */ function(_super) {
    $def52bc890d25e83$var$__extends(StatsMonitor, _super);
    /**
     * @constructor
     * @param [options] - Optional settings
     */ function StatsMonitor(options) {
        var _this = _super.call(this) || this;
        /**
         * A map of warnings with their raised time
         */ _this._activeWarnings = new Map();
        /**
         * A map of stats with the number of exceeded thresholds
         */ _this._currentStreaks = new Map();
        /**
         * Keeps track of input volumes in the last second
         */ _this._inputVolumes = [];
        /**
         * Keeps track of output volumes in the last second
         */ _this._outputVolumes = [];
        /**
         * Sample buffer. Saves most recent samples
         */ _this._sampleBuffer = [];
        /**
         * Keeps track of supplemental sample values.
         *
         * Currently used for constant audio detection. Contains an array of volume
         * samples for each sample interval.
         */ _this._supplementalSampleBuffers = {
            audioInputLevel: [],
            audioOutputLevel: []
        };
        /**
         * Whether warnings should be enabled
         */ _this._warningsEnabled = true;
        options = options || {};
        _this._getRTCStats = options.getRTCStats || $3rqOC.getRTCStats;
        _this._mos = options.Mos || $8kkx2.default;
        _this._peerConnection = options.peerConnection;
        _this._thresholds = $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, $def52bc890d25e83$var$DEFAULT_THRESHOLDS), options.thresholds);
        var thresholdSampleCounts = Object.values(_this._thresholds).map(function(threshold) {
            return threshold.sampleCount;
        }).filter(function(sampleCount) {
            return !!sampleCount;
        });
        _this._maxSampleCount = Math.max.apply(Math, $def52bc890d25e83$var$__spreadArrays([
            $def52bc890d25e83$var$SAMPLE_COUNT_METRICS
        ], thresholdSampleCounts));
        if (_this._peerConnection) _this.enable(_this._peerConnection);
        return _this;
    }
    /**
     * Called when a volume sample is available
     * @param inputVolume - Input volume level from 0 to 32767
     * @param outputVolume - Output volume level from 0 to 32767
     */ StatsMonitor.prototype.addVolumes = function(inputVolume, outputVolume) {
        this._inputVolumes.push(inputVolume);
        this._outputVolumes.push(outputVolume);
    };
    /**
     * Stop sampling RTC statistics for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.disable = function() {
        if (this._sampleInterval) {
            clearInterval(this._sampleInterval);
            delete this._sampleInterval;
        }
        return this;
    };
    /**
     * Disable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.disableWarnings = function() {
        if (this._warningsEnabled) this._activeWarnings.clear();
        this._warningsEnabled = false;
        return this;
    };
    /**
     * Start sampling RTC statistics for this {@link StatsMonitor}.
     * @param peerConnection - A PeerConnection to monitor.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.enable = function(peerConnection) {
        if (peerConnection) {
            if (this._peerConnection && peerConnection !== this._peerConnection) throw new $dmfT0.InvalidArgumentError("Attempted to replace an existing PeerConnection in StatsMonitor.enable");
            this._peerConnection = peerConnection;
        }
        if (!this._peerConnection) throw new $dmfT0.InvalidArgumentError("Can not enable StatsMonitor without a PeerConnection");
        this._sampleInterval = this._sampleInterval || setInterval(this._fetchSample.bind(this), $def52bc890d25e83$var$SAMPLE_INTERVAL);
        return this;
    };
    /**
     * Enable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.enableWarnings = function() {
        this._warningsEnabled = true;
        return this;
    };
    /**
     * Check if there is an active warning for a specific stat and threshold
     * @param statName - The name of the stat to check
     * @param thresholdName - The name of the threshold to check
     * @returns Whether there is an active warning for a specific stat and threshold
     */ StatsMonitor.prototype.hasActiveWarning = function(statName, thresholdName) {
        var warningId = statName + ":" + thresholdName;
        return !!this._activeWarnings.get(warningId);
    };
    /**
     * Add a sample to our sample buffer and remove the oldest if we are over the limit.
     * @param sample - Sample to add
     */ StatsMonitor.prototype._addSample = function(sample) {
        var samples = this._sampleBuffer;
        samples.push(sample);
        // We store 1 extra sample so that we always have (current, previous)
        // available for all {sampleBufferSize} threshold validations.
        if (samples.length > this._maxSampleCount) samples.splice(0, samples.length - this._maxSampleCount);
    };
    /**
     * Clear an active warning.
     * @param statName - The name of the stat to clear.
     * @param thresholdName - The name of the threshold to clear
     * @param [data] - Any relevant sample data.
     */ StatsMonitor.prototype._clearWarning = function(statName, thresholdName, data) {
        var warningId = statName + ":" + thresholdName;
        var activeWarning = this._activeWarnings.get(warningId);
        if (!activeWarning || Date.now() - activeWarning.timeRaised < $def52bc890d25e83$var$WARNING_TIMEOUT) return;
        this._activeWarnings.delete(warningId);
        this.emit("warning-cleared", $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: this._thresholds[statName][thresholdName]
            }
        }));
    };
    /**
     * Create a sample object from a stats object using the previous sample, if available.
     * @param stats - Stats retrieved from getStatistics
     * @param [previousSample=null] - The previous sample to use to calculate deltas.
     * @returns A universally-formatted version of RTC stats.
     */ StatsMonitor.prototype._createSample = function(stats, previousSample) {
        var previousBytesSent = previousSample && previousSample.totals.bytesSent || 0;
        var previousBytesReceived = previousSample && previousSample.totals.bytesReceived || 0;
        var previousPacketsSent = previousSample && previousSample.totals.packetsSent || 0;
        var previousPacketsReceived = previousSample && previousSample.totals.packetsReceived || 0;
        var previousPacketsLost = previousSample && previousSample.totals.packetsLost || 0;
        var currentBytesSent = stats.bytesSent - previousBytesSent;
        var currentBytesReceived = stats.bytesReceived - previousBytesReceived;
        var currentPacketsSent = stats.packetsSent - previousPacketsSent;
        var currentPacketsReceived = stats.packetsReceived - previousPacketsReceived;
        var currentPacketsLost = stats.packetsLost - previousPacketsLost;
        var currentInboundPackets = currentPacketsReceived + currentPacketsLost;
        var currentPacketsLostFraction = currentInboundPackets > 0 ? currentPacketsLost / currentInboundPackets * 100 : 0;
        var totalInboundPackets = stats.packetsReceived + stats.packetsLost;
        var totalPacketsLostFraction = totalInboundPackets > 0 ? stats.packetsLost / totalInboundPackets * 100 : 100;
        var rttValue = typeof stats.rtt === "number" || !previousSample ? stats.rtt : previousSample.rtt;
        var audioInputLevelValues = this._inputVolumes.splice(0);
        this._supplementalSampleBuffers.audioInputLevel.push(audioInputLevelValues);
        var audioOutputLevelValues = this._outputVolumes.splice(0);
        this._supplementalSampleBuffers.audioOutputLevel.push(audioOutputLevelValues);
        return {
            audioInputLevel: Math.round($f8R8g.average(audioInputLevelValues)),
            audioOutputLevel: Math.round($f8R8g.average(audioOutputLevelValues)),
            bytesReceived: currentBytesReceived,
            bytesSent: currentBytesSent,
            codecName: stats.codecName,
            jitter: stats.jitter,
            mos: this._mos.calculate(rttValue, stats.jitter, previousSample && currentPacketsLostFraction),
            packetsLost: currentPacketsLost,
            packetsLostFraction: currentPacketsLostFraction,
            packetsReceived: currentPacketsReceived,
            packetsSent: currentPacketsSent,
            rtt: rttValue,
            timestamp: stats.timestamp,
            totals: {
                bytesReceived: stats.bytesReceived,
                bytesSent: stats.bytesSent,
                packetsLost: stats.packetsLost,
                packetsLostFraction: totalPacketsLostFraction,
                packetsReceived: stats.packetsReceived,
                packetsSent: stats.packetsSent
            }
        };
    };
    /**
     * Get stats from the PeerConnection and add it to our list of samples.
     */ StatsMonitor.prototype._fetchSample = function() {
        var _this = this;
        this._getSample().then(function(sample) {
            _this._addSample(sample);
            _this._raiseWarnings();
            _this.emit("sample", sample);
        }).catch(function(error) {
            _this.disable();
            // We only bubble up any errors coming from pc.getStats()
            // No need to attach a twilioError
            _this.emit("error", error);
        });
    };
    /**
     * Get stats from the PeerConnection.
     * @returns A universally-formatted version of RTC stats.
     */ StatsMonitor.prototype._getSample = function() {
        var _this = this;
        return this._getRTCStats(this._peerConnection).then(function(stats) {
            var previousSample = null;
            if (_this._sampleBuffer.length) previousSample = _this._sampleBuffer[_this._sampleBuffer.length - 1];
            return _this._createSample(stats, previousSample);
        });
    };
    /**
     * Raise a warning and log its raised time.
     * @param statName - The name of the stat to raise.
     * @param thresholdName - The name of the threshold to raise
     * @param [data] - Any relevant sample data.
     */ StatsMonitor.prototype._raiseWarning = function(statName, thresholdName, data) {
        var warningId = statName + ":" + thresholdName;
        if (this._activeWarnings.has(warningId)) return;
        this._activeWarnings.set(warningId, {
            timeRaised: Date.now()
        });
        var thresholds = this._thresholds[statName];
        var thresholdValue;
        if (Array.isArray(thresholds)) {
            var foundThreshold = thresholds.find(function(threshold) {
                return thresholdName in threshold;
            });
            if (foundThreshold) thresholdValue = foundThreshold[thresholdName];
        } else thresholdValue = this._thresholds[statName][thresholdName];
        this.emit("warning", $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: thresholdValue
            }
        }));
    };
    /**
     * Apply our thresholds to our array of RTCStat samples.
     */ StatsMonitor.prototype._raiseWarnings = function() {
        var _this = this;
        if (!this._warningsEnabled) return;
        Object.keys(this._thresholds).forEach(function(name) {
            return _this._raiseWarningsForStat(name);
        });
    };
    /**
     * Apply thresholds for a given stat name to our array of
     * RTCStat samples and raise or clear any associated warnings.
     * @param statName - Name of the stat to compare.
     */ StatsMonitor.prototype._raiseWarningsForStat = function(statName) {
        var _this = this;
        var limits = Array.isArray(this._thresholds[statName]) ? this._thresholds[statName] : [
            this._thresholds[statName]
        ];
        limits.forEach(function(limit) {
            var samples = _this._sampleBuffer;
            var clearCount = limit.clearCount || $def52bc890d25e83$var$SAMPLE_COUNT_CLEAR;
            var raiseCount = limit.raiseCount || $def52bc890d25e83$var$SAMPLE_COUNT_RAISE;
            var sampleCount = limit.sampleCount || _this._maxSampleCount;
            var relevantSamples = samples.slice(-sampleCount);
            var values = relevantSamples.map(function(sample) {
                return sample[statName];
            });
            // (rrowland) If we have a bad or missing value in the set, we don't
            // have enough information to throw or clear a warning. Bail out.
            var containsNull = values.some(function(value) {
                return typeof value === "undefined" || value === null;
            });
            if (containsNull) return;
            var count;
            if (typeof limit.max === "number") {
                count = $def52bc890d25e83$var$countHigh(limit.max, values);
                if (count >= raiseCount) _this._raiseWarning(statName, "max", {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) _this._clearWarning(statName, "max", {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.min === "number") {
                count = $def52bc890d25e83$var$countLow(limit.min, values);
                if (count >= raiseCount) _this._raiseWarning(statName, "min", {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) _this._clearWarning(statName, "min", {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.maxDuration === "number" && samples.length > 1) {
                relevantSamples = samples.slice(-2);
                var prevValue = relevantSamples[0][statName];
                var curValue = relevantSamples[1][statName];
                var prevStreak = _this._currentStreaks.get(statName) || 0;
                var streak = prevValue === curValue ? prevStreak + 1 : 0;
                _this._currentStreaks.set(statName, streak);
                if (streak >= limit.maxDuration) _this._raiseWarning(statName, "maxDuration", {
                    value: streak
                });
                else if (streak === 0) _this._clearWarning(statName, "maxDuration", {
                    value: prevStreak
                });
            }
            if (typeof limit.minStandardDeviation === "number") {
                var sampleSets = _this._supplementalSampleBuffers[statName];
                if (!sampleSets || sampleSets.length < limit.sampleCount) return;
                if (sampleSets.length > limit.sampleCount) sampleSets.splice(0, sampleSets.length - limit.sampleCount);
                var flatSamples = $def52bc890d25e83$var$flattenSamples(sampleSets.slice(-sampleCount));
                var stdDev = $def52bc890d25e83$var$calculateStandardDeviation(flatSamples);
                if (typeof stdDev !== "number") return;
                if (stdDev < limit.minStandardDeviation) _this._raiseWarning(statName, "minStandardDeviation", {
                    value: stdDev
                });
                else _this._clearWarning(statName, "minStandardDeviation", {
                    value: stdDev
                });
            }
            [
                [
                    "maxAverage",
                    function(x, y) {
                        return x > y;
                    }
                ],
                [
                    "minAverage",
                    function(x, y) {
                        return x < y;
                    }
                ]
            ].forEach(function(_a) {
                var thresholdName = _a[0], comparator = _a[1];
                if (typeof limit[thresholdName] === "number" && values.length >= sampleCount) {
                    var avg = $f8R8g.average(values);
                    if (comparator(avg, limit[thresholdName])) _this._raiseWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                    else if (!comparator(avg, limit.clearValue || limit[thresholdName])) _this._clearWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                }
            });
        });
    };
    return StatsMonitor;
}($11OXI.EventEmitter);
module.exports.default = $def52bc890d25e83$var$StatsMonitor;

});
parcelRegister("8kkx2", function(module, exports) {
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNonNegativeNumber = module.exports.calculate = void 0;
var $61001e332e3cd220$var$r0 = 94.768; // Constant used in computing "rFactor".
/**
 * Calculate the mos score of a stats object
 * @param {number} rtt
 * @param {number} jitter
 * @param {number} fractionLost - The fraction of packets that have been lost.
 * Calculated by packetsLost / totalPackets
 * @return {number | null} mos - Calculated MOS, `1.0` through roughly `4.5`.
 * Returns `null` when any of the input parameters are not a `non-negative`
 * number.
 */ function $61001e332e3cd220$var$calculate(rtt, jitter, fractionLost) {
    if (typeof rtt !== "number" || typeof jitter !== "number" || typeof fractionLost !== "number" || !$61001e332e3cd220$var$isNonNegativeNumber(rtt) || !$61001e332e3cd220$var$isNonNegativeNumber(jitter) || !$61001e332e3cd220$var$isNonNegativeNumber(fractionLost)) return null;
    // Compute the effective latency.
    var effectiveLatency = rtt + jitter * 2 + 10;
    // Compute the initial "rFactor" from effective latency.
    var rFactor = 0;
    switch(true){
        case effectiveLatency < 160:
            rFactor = $61001e332e3cd220$var$r0 - effectiveLatency / 40;
            break;
        case effectiveLatency < 1000:
            rFactor = $61001e332e3cd220$var$r0 - (effectiveLatency - 120) / 10;
            break;
    }
    // Adjust "rFactor" with the fraction of packets lost.
    switch(true){
        case fractionLost <= rFactor / 2.5:
            rFactor = Math.max(rFactor - fractionLost * 2.5, 6.52);
            break;
        default:
            rFactor = 0;
            break;
    }
    // Compute MOS from "rFactor".
    var mos = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
    return mos;
}
module.exports.calculate = $61001e332e3cd220$var$calculate;
/**
 * Returns true if and only if the parameter passed is a number, is not `NaN`,
 * is finite, and is greater than or equal to `0`.
 * @param n
 */ function $61001e332e3cd220$var$isNonNegativeNumber(n) {
    return typeof n === "number" && !isNaN(n) && isFinite(n) && n >= 0;
}
module.exports.isNonNegativeNumber = $61001e332e3cd220$var$isNonNegativeNumber;
module.exports.default = {
    calculate: $61001e332e3cd220$var$calculate,
    isNonNegativeNumber: $61001e332e3cd220$var$isNonNegativeNumber
};

});




parcelRegister("5noJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ea24a0c45994f7c$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $ljukC = parcelRequire("ljukC");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $81BVN = parcelRequire("81BVN");

var $i7gRp = parcelRequire("i7gRp");

var $cRA6X = parcelRequire("cRA6X");

var $1fnFn = parcelRequire("1fnFn");

var $cdOMG = parcelRequire("cdOMG");

var $9xCBz = parcelRequire("9xCBz");

var $k45I3 = parcelRequire("k45I3");

var $lNlyW = parcelRequire("lNlyW");

var $4yVoh = parcelRequire("4yVoh");
const $3ea24a0c45994f7c$var$IconComponent = {
    connecting: (0, $9xCBz.default),
    ringing: (0, $k45I3.default),
    open: (0, $1fnFn.default),
    close: (0, $cdOMG.default),
    error: (0, $lNlyW.default)
};
const $3ea24a0c45994f7c$var$StatusIcon = ({ status: status })=>{
    const StatusIconComponent = (0, $eZVvM.useMemo)(()=>$3ea24a0c45994f7c$var$IconComponent[status], [
        status
    ]);
    return (0, $bhfvP.jsx)(StatusIconComponent, {
        width: "6.4rem",
        height: "6.4rem"
    });
};
const $3ea24a0c45994f7c$var$CallingModal = ({ status: status, isCallingReception: isCallingReception, onEndCall: onEndCall, onClose: onClose })=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "call"
    ]);
    if (!status) return null;
    return (0, $bhfvP.jsxs)("div", Object.assign({
        className: "main-modal"
    }, {
        children: [
            (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({}, (0, $4yVoh.anim)((0, $4yVoh.modalIn)), {
                className: "main-modal__background"
            })),
            (0, $bhfvP.jsxs)((0, $ljukC.motion).div, Object.assign({}, (0, $4yVoh.anim)((0, $4yVoh.modalUp)), {
                className: "main-modal__content text-center"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                        variant: "h1",
                        className: `text-${status} mt-5`
                    }, {
                        children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `call:status.${// eslint-disable-next-line no-nested-ternary
                            isCallingReception && status === "close" ? "closeReception" : isCallingReception && status === "ringing" ? "ringingReception" : status}.title`
                        })
                    })),
                    status === "open" && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                        variant: "h2",
                        style: {
                            height: "7rem"
                        }
                    }, {
                        children: (0, $bhfvP.jsx)((0, $i7gRp.default), {})
                    })),
                    (0, $bhfvP.jsx)("div", Object.assign({
                        className: "main-modal__icon-box"
                    }, {
                        children: (0, $bhfvP.jsx)("div", Object.assign({
                            className: "m-auto call"
                        }, {
                            children: (0, $bhfvP.jsx)($3ea24a0c45994f7c$var$StatusIcon, {
                                status: status
                            })
                        }))
                    })),
                    status !== "close" && status !== "error" && (0, $bhfvP.jsx)("button", Object.assign({
                        className: "display-6 py-4 px-5 text-white bg-secondary fs-medium rounded",
                        onClick: onEndCall
                    }, {
                        children: t("call:cancelBtn")
                    })),
                    (status === "close" || status === "error") && (0, $bhfvP.jsx)("div", Object.assign({
                        className: "main-modal__close",
                        onClick: onClose
                    }, {
                        children: (0, $bhfvP.jsx)((0, $cRA6X.default), {})
                    }))
                ]
            }))
        ]
    }));
};
var $3ea24a0c45994f7c$export$2e2bcd8739ae039 = $3ea24a0c45994f7c$var$CallingModal;

});
parcelRegister("i7gRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d305f58fe82193c5$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $d7iwu = parcelRequire("d7iwu");

var $kvR7a = parcelRequire("kvR7a");

var $3V9AQ = parcelRequire("3V9AQ");
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($3V9AQ))));
const $d305f58fe82193c5$var$TimeDuration = ()=>{
    const started = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))().valueOf(), []);
    const [time, setTime] = (0, $eZVvM.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).duration((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))()).diff((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(started))).format("mm:ss"));
    (0, $d7iwu.default)(()=>{
        setTime((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).duration((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))()).diff((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(started))).format("mm:ss"));
    }, 1000);
    return (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: time
    });
};
var $d305f58fe82193c5$export$2e2bcd8739ae039 = $d305f58fe82193c5$var$TimeDuration;

});
parcelRegister("d7iwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98ca4c1b8d99238b$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $gVsDq = parcelRequire("gVsDq");
var $98ca4c1b8d99238b$var$useHarmonicIntervalFn = function(fn, delay) {
    if (delay === void 0) delay = 0;
    var latestCallback = (0, $eZVvM.useRef)(function() {});
    (0, $eZVvM.useEffect)(function() {
        latestCallback.current = fn;
    });
    (0, $eZVvM.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = (0, $gVsDq.setHarmonicInterval)(function() {
                return latestCallback.current();
            }, delay);
            return function() {
                return (0, $gVsDq.clearHarmonicInterval)(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
var $98ca4c1b8d99238b$export$2e2bcd8739ae039 = $98ca4c1b8d99238b$var$useHarmonicIntervalFn;

});
parcelRegister("gVsDq", function(module, exports) {

$parcel$export(module.exports, "setHarmonicInterval", function () { return $c5282e84bbfd10c8$export$1b5647019d6b9cab; });
$parcel$export(module.exports, "clearHarmonicInterval", function () { return $c5282e84bbfd10c8$export$f95833d4abc1f553; });
var $c5282e84bbfd10c8$var$counter = 0;
var $c5282e84bbfd10c8$var$buckets = {};
var $c5282e84bbfd10c8$export$1b5647019d6b9cab = function(fn, ms) {
    var _a;
    var id = $c5282e84bbfd10c8$var$counter++;
    if ($c5282e84bbfd10c8$var$buckets[ms]) $c5282e84bbfd10c8$var$buckets[ms].listeners[id] = fn;
    else {
        var timer = setInterval(function() {
            var listeners = $c5282e84bbfd10c8$var$buckets[ms].listeners;
            var didThrow = false;
            var lastError;
            for(var _i = 0, _a = Object.values(listeners); _i < _a.length; _i++){
                var listener = _a[_i];
                try {
                    listener();
                } catch (error) {
                    didThrow = true;
                    lastError = error;
                }
            }
            if (didThrow) throw lastError;
        }, ms);
        $c5282e84bbfd10c8$var$buckets[ms] = {
            ms: ms,
            timer: timer,
            listeners: (_a = {}, _a[id] = fn, _a)
        };
    }
    return {
        bucket: $c5282e84bbfd10c8$var$buckets[ms],
        id: id
    };
};
var $c5282e84bbfd10c8$export$f95833d4abc1f553 = function(_a) {
    var bucket = _a.bucket, id = _a.id;
    delete bucket.listeners[id];
    var hasListeners = false;
    for(var listener in bucket.listeners){
        hasListeners = true;
        break;
    }
    if (!hasListeners) {
        clearInterval(bucket.timer);
        delete $c5282e84bbfd10c8$var$buckets[bucket.ms];
    }
};

});


parcelRegister("3V9AQ", function(module, exports) {
!function(t, s) {
    module.exports = s();
}(module.exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

});


parcelRegister("1fnFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9195da5caeb5ffe$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c9195da5caeb5ffe$var$SvgOpenCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('9310b962156e51b9')",
            fill: "#4A4A4A",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.808 11.685c-.384-.4-.848-.615-1.34-.615-.488 0-.956.21-1.356.611l-1.254 1.25c-.103-.056-.206-.108-.305-.16a5.032 5.032 0 0 1-.392-.21c-1.174-.745-2.24-1.717-3.264-2.974-.496-.626-.829-1.154-1.07-1.689.324-.297.626-.607.92-.904.11-.111.221-.226.332-.337.833-.833.833-1.912 0-2.744L6.997 2.83c-.123-.123-.25-.25-.369-.377-.238-.246-.488-.5-.746-.737-.384-.38-.844-.583-1.328-.583-.484 0-.952.202-1.348.583l-.008.008-1.349 1.36a2.901 2.901 0 0 0-.86 1.844c-.095 1.158.246 2.236.508 2.942.642 1.733 1.602 3.34 3.033 5.06a18.66 18.66 0 0 0 6.214 4.866c.912.432 2.13.944 3.49 1.031.083.004.17.008.25.008.916 0 1.685-.33 2.288-.983.004-.008.012-.012.016-.02.206-.25.444-.476.694-.718.17-.163.345-.333.515-.512.393-.408.599-.884.599-1.372 0-.491-.21-.963-.61-1.36l-2.178-2.185Zm1.42 4.176c-.004 0-.004.004 0 0-.155.166-.313.317-.484.484-.258.245-.52.503-.765.793-.4.428-.873.63-1.491.63-.06 0-.123 0-.183-.004-1.178-.075-2.272-.535-3.093-.928a17.616 17.616 0 0 1-5.853-4.584c-1.352-1.63-2.256-3.137-2.855-4.754C2.135 6.51 2 5.74 2.06 5.015a1.82 1.82 0 0 1 .547-1.178l1.352-1.352c.194-.182.4-.281.603-.281.25 0 .452.15.579.277l.012.012c.242.226.472.46.714.71l.376.384L7.326 4.67c.42.42.42.809 0 1.23-.115.114-.226.23-.341.34-.333.341-.65.659-.995.968-.008.008-.016.012-.02.02-.341.34-.278.674-.207.9l.012.036c.282.682.678 1.324 1.281 2.09l.004.004c1.095 1.348 2.249 2.399 3.522 3.204.162.103.329.186.487.265.143.072.278.14.393.21.016.008.032.02.048.028a.86.86 0 0 0 .392.1c.33 0 .536-.207.603-.274l1.356-1.356c.135-.135.35-.298.599-.298.246 0 .448.155.571.29l.008.008 2.185 2.185c.408.404.408.82.004 1.24ZM11.113 4.515a5.029 5.029 0 0 1 2.736 1.42 5.055 5.055 0 0 1 1.42 2.736c.043.262.27.444.527.444.032 0 .06-.004.091-.008a.536.536 0 0 0 .44-.618 6.116 6.116 0 0 0-1.717-3.312A6.116 6.116 0 0 0 11.3 3.46a.538.538 0 0 0-.619.437.53.53 0 0 0 .433.618ZM19.726 8.334A10.063 10.063 0 0 0 16.9 2.881 10.062 10.062 0 0 0 11.446.054a.533.533 0 0 0-.615.436.538.538 0 0 0 .44.619 9.01 9.01 0 0 1 4.874 2.526 8.984 8.984 0 0 1 2.526 4.874c.044.261.27.444.528.444.031 0 .06-.004.09-.008a.525.525 0 0 0 .437-.61Z"
            })
        })
    });
var $c9195da5caeb5ffe$export$2e2bcd8739ae039 = $c9195da5caeb5ffe$var$SvgOpenCall;

});

parcelRegister("cdOMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9e4713e7e3526f7$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c9e4713e7e3526f7$var$SvgCloseCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        width: "6.4rem",
        height: "6.4rem",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "m14.675 11.698-1.833 1.859a6.503 6.503 0 0 0-1.27 7.54 71.657 71.657 0 0 0 13.108 17.94 1.92 1.92 0 1 1-2.711 2.72A75.492 75.492 0 0 1 8.152 22.842l-.01-.02a10.343 10.343 0 0 1 2-11.997l1.82-1.845a7.603 7.603 0 0 1 10.72 0l.003.004 4.024 4.023a7.604 7.604 0 0 1 0 10.72l-.004.004-2.223 2.223a75.077 75.077 0 0 0 6.218 7.07 1.92 1.92 0 0 1-2.719 2.712 78.923 78.923 0 0 1-7.583-8.816 1.92 1.92 0 0 1 .186-2.5l3.401-3.4a3.763 3.763 0 0 0 .002-5.304l-4.013-4.013-.002-.002a3.763 3.763 0 0 0-5.298-.004ZM45.352 38.646a3.71 3.71 0 0 0-2.64 1.103l-.009.009-3.405 3.405a1.92 1.92 0 0 1-2.489.193 105.487 105.487 0 0 1-2.866-2.194l-.028-.022a1.92 1.92 0 0 1 2.369-3.022c.5.391.992.777 1.478 1.15l2.222-2.222a7.548 7.548 0 0 1 8.28-1.656 7.548 7.548 0 0 1 2.46 1.66l3.978 3.978.004.004a7.551 7.551 0 0 1 .005 10.73l-1.81 1.835-.002.003a10.367 10.367 0 0 1-12.002 1.98l-.01-.005a73.6 73.6 0 0 1-13.144-8.543 1.92 1.92 0 1 1 2.424-2.979 69.759 69.759 0 0 0 12.451 8.095 6.528 6.528 0 0 0 7.55-1.248c.001 0 0 0 0 0l1.834-1.86a3.706 3.706 0 0 0 .817-4.07 3.716 3.716 0 0 0-.816-1.21l-.008-.009-4.002-4.002a3.711 3.711 0 0 0-2.64-1.103Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M58.958 4.837c.75.75.75 1.966 0 2.716l-51.2 51.2a1.92 1.92 0 0 1-2.715-2.716l51.2-51.2a1.92 1.92 0 0 1 2.715 0Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $c9e4713e7e3526f7$export$2e2bcd8739ae039 = $c9e4713e7e3526f7$var$SvgCloseCall;

});

parcelRegister("9xCBz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dee41ba920963cc7$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $dee41ba920963cc7$var$SvgEstablishCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M60.07 45.188c-.106-.088-12.084-8.676-15.334-8.098-1.562.276-2.456 1.34-4.246 3.474a61.081 61.081 0 0 1-1.518 1.752 24.919 24.919 0 0 1-3.302-1.344A27.4 27.4 0 0 1 23.028 28.33a24.919 24.919 0 0 1-1.344-3.302 63.181 63.181 0 0 1 1.764-1.528c2.122-1.78 3.186-2.674 3.462-4.238.566-3.238-8.01-15.226-8.098-15.334A4.578 4.578 0 0 0 15.4 2C11.924 2 2 14.872 2 17.042c0 .126.182 12.934 15.976 29C34.024 61.818 46.832 62 46.958 62 49.128 62 62 52.076 62 48.6a4.573 4.573 0 0 0-1.93-3.412Zm-13.332 12.8c-1.748-.144-12.496-1.562-25.934-14.764-13.27-13.51-14.652-24.288-14.79-25.958a54.109 54.109 0 0 1 9.412-11.122c.08.08.186.2.322.356a70.776 70.776 0 0 1 7.148 12.126 23.774 23.774 0 0 1-2.032 1.822 20.068 20.068 0 0 0-3.024 2.844 1.999 1.999 0 0 0-.342 1.502 22.836 22.836 0 0 0 1.93 5.282A31.42 31.42 0 0 0 33.924 44.57a22.779 22.779 0 0 0 5.282 1.932 1.988 1.988 0 0 0 1.502-.342 20.232 20.232 0 0 0 2.856-3.036c.626-.748 1.464-1.746 1.78-2.028A70.324 70.324 0 0 1 57.5 48.252c.166.14.282.248.36.318a54.061 54.061 0 0 1-11.122 9.414v.004ZM44.97 29l12.245-12.245v6.386H60v-9.748A1.393 1.393 0 0 0 58.607 12H48.86v2.785h6.386L43 27.031 44.97 29Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M49.03 3 36.786 15.245V8.86H34v9.748A1.393 1.393 0 0 0 35.393 20h9.748v-2.785h-6.386L51 4.969 49.03 3Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $dee41ba920963cc7$export$2e2bcd8739ae039 = $dee41ba920963cc7$var$SvgEstablishCall;

});

parcelRegister("k45I3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $756dda2289d9c53f$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $756dda2289d9c53f$var$SvgRingCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M60.07 45.188c-.106-.088-12.084-8.676-15.334-8.098-1.562.276-2.456 1.34-4.246 3.474a61.081 61.081 0 0 1-1.518 1.752 24.919 24.919 0 0 1-3.302-1.344A27.4 27.4 0 0 1 23.028 28.33a24.919 24.919 0 0 1-1.344-3.302 63.181 63.181 0 0 1 1.764-1.528c2.122-1.78 3.186-2.674 3.462-4.238.566-3.238-8.01-15.226-8.098-15.334A4.578 4.578 0 0 0 15.4 2C11.924 2 2 14.872 2 17.042c0 .126.182 12.934 15.976 29C34.024 61.818 46.832 62 46.958 62 49.128 62 62 52.076 62 48.6a4.573 4.573 0 0 0-1.93-3.412Zm-13.332 12.8c-1.748-.144-12.496-1.562-25.934-14.764-13.27-13.51-14.652-24.288-14.79-25.958a54.109 54.109 0 0 1 9.412-11.122c.08.08.186.2.322.356a70.776 70.776 0 0 1 7.148 12.126 23.774 23.774 0 0 1-2.032 1.822 20.068 20.068 0 0 0-3.024 2.844 1.999 1.999 0 0 0-.342 1.502 22.836 22.836 0 0 0 1.93 5.282A31.42 31.42 0 0 0 33.924 44.57a22.779 22.779 0 0 0 5.282 1.932 1.988 1.988 0 0 0 1.502-.342 20.232 20.232 0 0 0 2.856-3.036c.626-.748 1.464-1.746 1.78-2.028A70.324 70.324 0 0 1 57.5 48.252c.166.14.282.248.36.318a54.061 54.061 0 0 1-11.122 9.414v.004Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M37.414 29.414 55 11.828V21h4V7a2 2 0 0 0-2-2H43v4h9.172L34.586 26.586l2.828 2.828Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $756dda2289d9c53f$export$2e2bcd8739ae039 = $756dda2289d9c53f$var$SvgRingCall;

});



parcelRegister("euQZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8dcf9c12a903379$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $hr7Vj = parcelRequire("hr7Vj");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");

var $lM7US = parcelRequire("lM7US");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $hJePx = parcelRequire("hJePx");
const $a8dcf9c12a903379$var$VideoCalling = ()=>{
    var _a, _b;
    const navigate = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)(); // const { trackEvent } = useEventTracking();
    const { data: data, status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/video`
    ], ()=>{
        return (0, $jnPOB.client).request((0, $hJePx.MUTATION_CREATE_VIDEO_ROOM), {
            id: id
        });
    }, {
        retry: false,
        refetchOnWindowFocus: false
    });
    const roomId = (_a = data === null || data === void 0 ? void 0 : data.accessEventCreateVideoRoom) === null || _a === void 0 ? void 0 : _a.id;
    const roomUrl = (_b = data === null || data === void 0 ? void 0 : data.accessEventCreateVideoRoom) === null || _b === void 0 ? void 0 : _b.roomUrl;
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        /**
     * Redirect to previous route in case of error so you can retry
     */ if (requestStatus === "error") return navigate(-1);
        return navigate(`/video-call?${(0, (/*@__PURE__*/$parcel$interopDefault($hr7Vj))).stringify({
            roomId: roomId,
            roomUrl: roomUrl
        })}`, {
            replace: true
        });
    }, [
        requestStatus,
        roomId,
        roomUrl
    ]);
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    return (0, $bhfvP.jsx)((0, $lM7US.default), {
        title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `videoCall:status.${status}.title`
        }),
        message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `videoCall:status.${status}.message`
        }),
        status: status,
        onDismiss: onDismiss
    });
};
var $a8dcf9c12a903379$export$2e2bcd8739ae039 = $a8dcf9c12a903379$var$VideoCalling;

});
parcelRegister("hr7Vj", function(module, exports) {
"use strict";

var $fN2m8 = parcelRequire("fN2m8");

var $8cLtv = parcelRequire("8cLtv");

var $lJPQ8 = parcelRequire("lJPQ8");
module.exports = {
    formats: $lJPQ8,
    parse: $8cLtv,
    stringify: $fN2m8
};

});
parcelRegister("fN2m8", function(module, exports) {
"use strict";

var $2XK59 = parcelRequire("2XK59");

var $CDutP = parcelRequire("CDutP");

var $lJPQ8 = parcelRequire("lJPQ8");
var $b7ed427ebb72a7a9$var$has = Object.prototype.hasOwnProperty;
var $b7ed427ebb72a7a9$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $b7ed427ebb72a7a9$var$isArray = Array.isArray;
var $b7ed427ebb72a7a9$var$push = Array.prototype.push;
var $b7ed427ebb72a7a9$var$pushToArray = function(arr, valueOrArray) {
    $b7ed427ebb72a7a9$var$push.apply(arr, $b7ed427ebb72a7a9$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $b7ed427ebb72a7a9$var$toISO = Date.prototype.toISOString;
var $b7ed427ebb72a7a9$var$defaultFormat = $lJPQ8.default;
var $b7ed427ebb72a7a9$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $CDutP.encode,
    encodeValuesOnly: false,
    format: $b7ed427ebb72a7a9$var$defaultFormat,
    formatter: $lJPQ8.formatters[$b7ed427ebb72a7a9$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $b7ed427ebb72a7a9$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $b7ed427ebb72a7a9$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $b7ed427ebb72a7a9$var$sentinel = {};
var $b7ed427ebb72a7a9$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($b7ed427ebb72a7a9$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($b7ed427ebb72a7a9$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $b7ed427ebb72a7a9$var$isArray(obj)) obj = $CDutP.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $b7ed427ebb72a7a9$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($b7ed427ebb72a7a9$var$isNonNullishPrimitive(obj) || $CDutP.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $b7ed427ebb72a7a9$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $b7ed427ebb72a7a9$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $b7ed427ebb72a7a9$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $CDutP.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($b7ed427ebb72a7a9$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $b7ed427ebb72a7a9$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $b7ed427ebb72a7a9$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $b7ed427ebb72a7a9$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $2XK59();
        valueSideChannel.set($b7ed427ebb72a7a9$var$sentinel, sideChannel);
        $b7ed427ebb72a7a9$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $b7ed427ebb72a7a9$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $b7ed427ebb72a7a9$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $b7ed427ebb72a7a9$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $b7ed427ebb72a7a9$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $lJPQ8.default;
    if (typeof opts.format !== "undefined") {
        if (!$b7ed427ebb72a7a9$var$has.call($lJPQ8.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $lJPQ8.formatters[format];
    var filter = $b7ed427ebb72a7a9$var$defaults.filter;
    if (typeof opts.filter === "function" || $b7ed427ebb72a7a9$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $b7ed427ebb72a7a9$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $b7ed427ebb72a7a9$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $b7ed427ebb72a7a9$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $b7ed427ebb72a7a9$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $b7ed427ebb72a7a9$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $b7ed427ebb72a7a9$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $b7ed427ebb72a7a9$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $b7ed427ebb72a7a9$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $b7ed427ebb72a7a9$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $b7ed427ebb72a7a9$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $b7ed427ebb72a7a9$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $b7ed427ebb72a7a9$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $b7ed427ebb72a7a9$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $b7ed427ebb72a7a9$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $b7ed427ebb72a7a9$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($b7ed427ebb72a7a9$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $b7ed427ebb72a7a9$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $2XK59();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $b7ed427ebb72a7a9$var$pushToArray(keys, $b7ed427ebb72a7a9$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("2XK59", function(module, exports) {
"use strict";

var $SlCCR = parcelRequire("SlCCR");

var $a0uXT = parcelRequire("a0uXT");

var $4pxlU = parcelRequire("4pxlU");

var $aykVE = parcelRequire("aykVE");
var $2284d668277e6b69$var$$WeakMap = $SlCCR("%WeakMap%", true);
var $2284d668277e6b69$var$$Map = $SlCCR("%Map%", true);
var $2284d668277e6b69$var$$weakMapGet = $a0uXT("WeakMap.prototype.get", true);
var $2284d668277e6b69$var$$weakMapSet = $a0uXT("WeakMap.prototype.set", true);
var $2284d668277e6b69$var$$weakMapHas = $a0uXT("WeakMap.prototype.has", true);
var $2284d668277e6b69$var$$mapGet = $a0uXT("Map.prototype.get", true);
var $2284d668277e6b69$var$$mapSet = $a0uXT("Map.prototype.set", true);
var $2284d668277e6b69$var$$mapHas = $a0uXT("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $2284d668277e6b69$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $2284d668277e6b69$var$listGet = function(objects, key) {
    var node = $2284d668277e6b69$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $2284d668277e6b69$var$listSet = function(objects, key, value) {
    var node = $2284d668277e6b69$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $2284d668277e6b69$var$listHas = function(objects, key) {
    return !!$2284d668277e6b69$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aykVE("Side channel does not contain " + $4pxlU(key));
        },
        get: function(key) {
            if ($2284d668277e6b69$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $2284d668277e6b69$var$$weakMapGet($wm, key);
            } else if ($2284d668277e6b69$var$$Map) {
                if ($m) return $2284d668277e6b69$var$$mapGet($m, key);
            } else {
                if ($o) return $2284d668277e6b69$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($2284d668277e6b69$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $2284d668277e6b69$var$$weakMapHas($wm, key);
            } else if ($2284d668277e6b69$var$$Map) {
                if ($m) return $2284d668277e6b69$var$$mapHas($m, key);
            } else {
                if ($o) return $2284d668277e6b69$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($2284d668277e6b69$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $2284d668277e6b69$var$$WeakMap();
                $2284d668277e6b69$var$$weakMapSet($wm, key, value);
            } else if ($2284d668277e6b69$var$$Map) {
                if (!$m) $m = new $2284d668277e6b69$var$$Map();
                $2284d668277e6b69$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $2284d668277e6b69$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("SlCCR", function(module, exports) {
"use strict";
var $0a35d0f030a82056$var$undefined1;

var $kczPX = parcelRequire("kczPX");

var $fACYR = parcelRequire("fACYR");

var $1OfI9 = parcelRequire("1OfI9");

var $l00OC = parcelRequire("l00OC");

var $g9p66 = parcelRequire("g9p66");

var $aykVE = parcelRequire("aykVE");

var $fc5Cg = parcelRequire("fc5Cg");
var $0a35d0f030a82056$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0a35d0f030a82056$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0a35d0f030a82056$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $0a35d0f030a82056$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($0a35d0f030a82056$var$$gOPD) try {
    $0a35d0f030a82056$var$$gOPD({}, "");
} catch (e) {
    $0a35d0f030a82056$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $0a35d0f030a82056$var$throwTypeError = function() {
    throw new $aykVE();
};
var $0a35d0f030a82056$var$ThrowTypeError = $0a35d0f030a82056$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0a35d0f030a82056$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $0a35d0f030a82056$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $0a35d0f030a82056$var$throwTypeError;
        }
    }
}() : $0a35d0f030a82056$var$throwTypeError;

var $0a35d0f030a82056$var$hasSymbols = (parcelRequire("2aWX8"))();

var $0a35d0f030a82056$var$hasProto = (parcelRequire("8Rcsb"))();
var $0a35d0f030a82056$var$getProto = Object.getPrototypeOf || ($0a35d0f030a82056$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $0a35d0f030a82056$var$needsEval = {};
var $0a35d0f030a82056$var$TypedArray = typeof Uint8Array === "undefined" || !$0a35d0f030a82056$var$getProto ? undefined : $0a35d0f030a82056$var$getProto(Uint8Array);
var $0a35d0f030a82056$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $0a35d0f030a82056$var$hasSymbols && $0a35d0f030a82056$var$getProto ? $0a35d0f030a82056$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $0a35d0f030a82056$var$needsEval,
    "%AsyncGenerator%": $0a35d0f030a82056$var$needsEval,
    "%AsyncGeneratorFunction%": $0a35d0f030a82056$var$needsEval,
    "%AsyncIteratorPrototype%": $0a35d0f030a82056$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $kczPX,
    "%eval%": eval,
    "%EvalError%": $fACYR,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $0a35d0f030a82056$var$$Function,
    "%GeneratorFunction%": $0a35d0f030a82056$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $0a35d0f030a82056$var$hasSymbols && $0a35d0f030a82056$var$getProto ? $0a35d0f030a82056$var$getProto($0a35d0f030a82056$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$0a35d0f030a82056$var$hasSymbols || !$0a35d0f030a82056$var$getProto ? undefined : $0a35d0f030a82056$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $1OfI9,
    "%ReferenceError%": $l00OC,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$0a35d0f030a82056$var$hasSymbols || !$0a35d0f030a82056$var$getProto ? undefined : $0a35d0f030a82056$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $0a35d0f030a82056$var$hasSymbols && $0a35d0f030a82056$var$getProto ? $0a35d0f030a82056$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $0a35d0f030a82056$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $g9p66,
    "%ThrowTypeError%": $0a35d0f030a82056$var$ThrowTypeError,
    "%TypedArray%": $0a35d0f030a82056$var$TypedArray,
    "%TypeError%": $aykVE,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $fc5Cg,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($0a35d0f030a82056$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0a35d0f030a82056$var$errorProto = $0a35d0f030a82056$var$getProto($0a35d0f030a82056$var$getProto(e));
    $0a35d0f030a82056$var$INTRINSICS["%Error.prototype%"] = $0a35d0f030a82056$var$errorProto;
}
var $0a35d0f030a82056$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $0a35d0f030a82056$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $0a35d0f030a82056$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $0a35d0f030a82056$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $0a35d0f030a82056$var$getProto) value = $0a35d0f030a82056$var$getProto(gen.prototype);
    }
    $0a35d0f030a82056$var$INTRINSICS[name] = value;
    return value;
};
var $0a35d0f030a82056$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $8amm0 = parcelRequire("8amm0");

var $fjmFp = parcelRequire("fjmFp");
var $0a35d0f030a82056$var$$concat = $8amm0.call(Function.call, Array.prototype.concat);
var $0a35d0f030a82056$var$$spliceApply = $8amm0.call(Function.apply, Array.prototype.splice);
var $0a35d0f030a82056$var$$replace = $8amm0.call(Function.call, String.prototype.replace);
var $0a35d0f030a82056$var$$strSlice = $8amm0.call(Function.call, String.prototype.slice);
var $0a35d0f030a82056$var$$exec = $8amm0.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0a35d0f030a82056$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0a35d0f030a82056$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0a35d0f030a82056$var$stringToPath = function stringToPath(string) {
    var first = $0a35d0f030a82056$var$$strSlice(string, 0, 1);
    var last = $0a35d0f030a82056$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $g9p66("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $g9p66("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $0a35d0f030a82056$var$$replace(string, $0a35d0f030a82056$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0a35d0f030a82056$var$$replace(subString, $0a35d0f030a82056$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $0a35d0f030a82056$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($fjmFp($0a35d0f030a82056$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0a35d0f030a82056$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($fjmFp($0a35d0f030a82056$var$INTRINSICS, intrinsicName)) {
        var value = $0a35d0f030a82056$var$INTRINSICS[intrinsicName];
        if (value === $0a35d0f030a82056$var$needsEval) value = $0a35d0f030a82056$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $aykVE("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $g9p66("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $aykVE("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $aykVE('"allowMissing" argument must be a boolean');
    if ($0a35d0f030a82056$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $g9p66("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $0a35d0f030a82056$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $0a35d0f030a82056$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0a35d0f030a82056$var$$spliceApply(parts, $0a35d0f030a82056$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0a35d0f030a82056$var$$strSlice(part, 0, 1);
        var last = $0a35d0f030a82056$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $g9p66("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($fjmFp($0a35d0f030a82056$var$INTRINSICS, intrinsicRealName)) value = $0a35d0f030a82056$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aykVE("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($0a35d0f030a82056$var$$gOPD && i + 1 >= parts.length) {
                var desc = $0a35d0f030a82056$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $fjmFp(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0a35d0f030a82056$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("kczPX", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fACYR", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("1OfI9", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("l00OC", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("g9p66", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("aykVE", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("fc5Cg", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("2aWX8", function(module, exports) {
"use strict";
var $195a3ebc63cb3fad$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $2E3eU = parcelRequire("2E3eU");
module.exports = function hasNativeSymbols() {
    if (typeof $195a3ebc63cb3fad$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $195a3ebc63cb3fad$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $2E3eU();
};

});
parcelRegister("2E3eU", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8Rcsb", function(module, exports) {
"use strict";
var $672ceefe8796f088$var$test = {
    __proto__: null,
    foo: {}
};
var $672ceefe8796f088$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $672ceefe8796f088$var$test
    }).foo === $672ceefe8796f088$var$test.foo && !($672ceefe8796f088$var$test instanceof $672ceefe8796f088$var$$Object);
};

});

parcelRegister("8amm0", function(module, exports) {
"use strict";

var $6vzjO = parcelRequire("6vzjO");
module.exports = Function.prototype.bind || $6vzjO;

});
parcelRegister("6vzjO", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $4bd108d81c123bac$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $4bd108d81c123bac$var$toStr = Object.prototype.toString;
var $4bd108d81c123bac$var$max = Math.max;
var $4bd108d81c123bac$var$funcType = "[object Function]";
var $4bd108d81c123bac$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $4bd108d81c123bac$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $4bd108d81c123bac$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $4bd108d81c123bac$var$toStr.apply(target) !== $4bd108d81c123bac$var$funcType) throw new TypeError($4bd108d81c123bac$var$ERROR_MESSAGE + target);
    var args = $4bd108d81c123bac$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $4bd108d81c123bac$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $4bd108d81c123bac$var$concatty(args, arguments));
    };
    var boundLength = $4bd108d81c123bac$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $4bd108d81c123bac$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("fjmFp", function(module, exports) {
"use strict";
var $b25a3684d00c1ebc$var$call = Function.prototype.call;
var $b25a3684d00c1ebc$var$$hasOwn = Object.prototype.hasOwnProperty;

var $8amm0 = parcelRequire("8amm0");
/** @type {import('.')} */ module.exports = $8amm0.call($b25a3684d00c1ebc$var$call, $b25a3684d00c1ebc$var$$hasOwn);

});


parcelRegister("a0uXT", function(module, exports) {
"use strict";

var $SlCCR = parcelRequire("SlCCR");

var $42UtQ = parcelRequire("42UtQ");
var $7491ec747d4e60fe$var$$indexOf = $42UtQ($SlCCR("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $SlCCR(name, !!allowMissing);
    if (typeof intrinsic === "function" && $7491ec747d4e60fe$var$$indexOf(name, ".prototype.") > -1) return $42UtQ(intrinsic);
    return intrinsic;
};

});
parcelRegister("42UtQ", function(module, exports) {
"use strict";

var $8amm0 = parcelRequire("8amm0");

var $SlCCR = parcelRequire("SlCCR");

var $73uiQ = parcelRequire("73uiQ");

var $aykVE = parcelRequire("aykVE");
var $2f23292b42a8cecf$var$$apply = $SlCCR("%Function.prototype.apply%");
var $2f23292b42a8cecf$var$$call = $SlCCR("%Function.prototype.call%");
var $2f23292b42a8cecf$var$$reflectApply = $SlCCR("%Reflect.apply%", true) || $8amm0.call($2f23292b42a8cecf$var$$call, $2f23292b42a8cecf$var$$apply);

var $44Cdy = parcelRequire("44Cdy");
var $2f23292b42a8cecf$var$$max = $SlCCR("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $aykVE("a function is required");
    var func = $2f23292b42a8cecf$var$$reflectApply($8amm0, $2f23292b42a8cecf$var$$call, arguments);
    return $73uiQ(func, 1 + $2f23292b42a8cecf$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $2f23292b42a8cecf$var$applyBind = function applyBind() {
    return $2f23292b42a8cecf$var$$reflectApply($8amm0, $2f23292b42a8cecf$var$$apply, arguments);
};
if ($44Cdy) $44Cdy(module.exports, "apply", {
    value: $2f23292b42a8cecf$var$applyBind
});
else module.exports.apply = $2f23292b42a8cecf$var$applyBind;

});
parcelRegister("73uiQ", function(module, exports) {
"use strict";

var $SlCCR = parcelRequire("SlCCR");

var $cUpQX = parcelRequire("cUpQX");

var $523051c59e896900$var$hasDescriptors = (parcelRequire("7PSBn"))();

var $24yeK = parcelRequire("24yeK");

var $aykVE = parcelRequire("aykVE");
var $523051c59e896900$var$$floor = $SlCCR("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $aykVE("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $523051c59e896900$var$$floor(length) !== length) throw new $aykVE("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $24yeK) {
        var desc = $24yeK(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($523051c59e896900$var$hasDescriptors) $cUpQX(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $cUpQX(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("cUpQX", function(module, exports) {
"use strict";

var $44Cdy = parcelRequire("44Cdy");

var $g9p66 = parcelRequire("g9p66");

var $aykVE = parcelRequire("aykVE");

var $24yeK = parcelRequire("24yeK");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $aykVE("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $aykVE("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $aykVE("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $aykVE("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $aykVE("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $aykVE("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$24yeK && $24yeK(obj, property);
    if ($44Cdy) $44Cdy(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $g9p66("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("44Cdy", function(module, exports) {
"use strict";

var $SlCCR = parcelRequire("SlCCR");
/** @type {import('.')} */ var $2f752e5ac9597778$var$$defineProperty = $SlCCR("%Object.defineProperty%", true) || false;
if ($2f752e5ac9597778$var$$defineProperty) try {
    $2f752e5ac9597778$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $2f752e5ac9597778$var$$defineProperty = false;
}
module.exports = $2f752e5ac9597778$var$$defineProperty;

});

parcelRegister("24yeK", function(module, exports) {
"use strict";

var $SlCCR = parcelRequire("SlCCR");
var $1826833a4e9379ad$var$$gOPD = $SlCCR("%Object.getOwnPropertyDescriptor%", true);
if ($1826833a4e9379ad$var$$gOPD) try {
    $1826833a4e9379ad$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $1826833a4e9379ad$var$$gOPD = null;
}
module.exports = $1826833a4e9379ad$var$$gOPD;

});


parcelRegister("7PSBn", function(module, exports) {
"use strict";

var $44Cdy = parcelRequire("44Cdy");
var $5b47a69d2553ddb2$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$44Cdy;
};
$5b47a69d2553ddb2$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$44Cdy) return null;
    try {
        return $44Cdy([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $5b47a69d2553ddb2$var$hasPropertyDescriptors;

});




parcelRegister("4pxlU", function(module, exports) {
var $33635e551b79d758$var$hasMap = typeof Map === "function" && Map.prototype;
var $33635e551b79d758$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $33635e551b79d758$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $33635e551b79d758$var$mapSize = $33635e551b79d758$var$hasMap && $33635e551b79d758$var$mapSizeDescriptor && typeof $33635e551b79d758$var$mapSizeDescriptor.get === "function" ? $33635e551b79d758$var$mapSizeDescriptor.get : null;
var $33635e551b79d758$var$mapForEach = $33635e551b79d758$var$hasMap && Map.prototype.forEach;
var $33635e551b79d758$var$hasSet = typeof Set === "function" && Set.prototype;
var $33635e551b79d758$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $33635e551b79d758$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $33635e551b79d758$var$setSize = $33635e551b79d758$var$hasSet && $33635e551b79d758$var$setSizeDescriptor && typeof $33635e551b79d758$var$setSizeDescriptor.get === "function" ? $33635e551b79d758$var$setSizeDescriptor.get : null;
var $33635e551b79d758$var$setForEach = $33635e551b79d758$var$hasSet && Set.prototype.forEach;
var $33635e551b79d758$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $33635e551b79d758$var$weakMapHas = $33635e551b79d758$var$hasWeakMap ? WeakMap.prototype.has : null;
var $33635e551b79d758$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $33635e551b79d758$var$weakSetHas = $33635e551b79d758$var$hasWeakSet ? WeakSet.prototype.has : null;
var $33635e551b79d758$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $33635e551b79d758$var$weakRefDeref = $33635e551b79d758$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $33635e551b79d758$var$booleanValueOf = Boolean.prototype.valueOf;
var $33635e551b79d758$var$objectToString = Object.prototype.toString;
var $33635e551b79d758$var$functionToString = Function.prototype.toString;
var $33635e551b79d758$var$$match = String.prototype.match;
var $33635e551b79d758$var$$slice = String.prototype.slice;
var $33635e551b79d758$var$$replace = String.prototype.replace;
var $33635e551b79d758$var$$toUpperCase = String.prototype.toUpperCase;
var $33635e551b79d758$var$$toLowerCase = String.prototype.toLowerCase;
var $33635e551b79d758$var$$test = RegExp.prototype.test;
var $33635e551b79d758$var$$concat = Array.prototype.concat;
var $33635e551b79d758$var$$join = Array.prototype.join;
var $33635e551b79d758$var$$arrSlice = Array.prototype.slice;
var $33635e551b79d758$var$$floor = Math.floor;
var $33635e551b79d758$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $33635e551b79d758$var$gOPS = Object.getOwnPropertySymbols;
var $33635e551b79d758$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $33635e551b79d758$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $33635e551b79d758$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $33635e551b79d758$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $33635e551b79d758$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $33635e551b79d758$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $33635e551b79d758$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $33635e551b79d758$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$33635e551b79d758$var$$floor(-num) : $33635e551b79d758$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $33635e551b79d758$var$$slice.call(str, intStr.length + 1);
            return $33635e551b79d758$var$$replace.call(intStr, sepRegex, "$&_") + "." + $33635e551b79d758$var$$replace.call($33635e551b79d758$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $33635e551b79d758$var$$replace.call(str, sepRegex, "$&_");
}

var $cSe3c = parcelRequire("cSe3c");
var $33635e551b79d758$var$inspectCustom = $cSe3c.custom;
var $33635e551b79d758$var$inspectSymbol = $33635e551b79d758$var$isSymbol($33635e551b79d758$var$inspectCustom) ? $33635e551b79d758$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($33635e551b79d758$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($33635e551b79d758$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $33635e551b79d758$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($33635e551b79d758$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($33635e551b79d758$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $33635e551b79d758$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $33635e551b79d758$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $33635e551b79d758$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $33635e551b79d758$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $33635e551b79d758$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($33635e551b79d758$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $33635e551b79d758$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($33635e551b79d758$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$33635e551b79d758$var$isRegExp(obj)) {
        var name = $33635e551b79d758$var$nameOf(obj);
        var keys = $33635e551b79d758$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $33635e551b79d758$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($33635e551b79d758$var$isSymbol(obj)) {
        var symString = $33635e551b79d758$var$hasShammedSymbols ? $33635e551b79d758$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $33635e551b79d758$var$symToString.call(obj);
        return typeof obj === "object" && !$33635e551b79d758$var$hasShammedSymbols ? $33635e551b79d758$var$markBoxed(symString) : symString;
    }
    if ($33635e551b79d758$var$isElement(obj)) {
        var s = "<" + $33635e551b79d758$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $33635e551b79d758$var$wrapQuotes($33635e551b79d758$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $33635e551b79d758$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($33635e551b79d758$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $33635e551b79d758$var$arrObjKeys(obj, inspect);
        if (indent && !$33635e551b79d758$var$singleLineValues(xs)) return "[" + $33635e551b79d758$var$indentedJoin(xs, indent) + "]";
        return "[ " + $33635e551b79d758$var$$join.call(xs, ", ") + " ]";
    }
    if ($33635e551b79d758$var$isError(obj)) {
        var parts = $33635e551b79d758$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$33635e551b79d758$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $33635e551b79d758$var$$join.call($33635e551b79d758$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $33635e551b79d758$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($33635e551b79d758$var$inspectSymbol && typeof obj[$33635e551b79d758$var$inspectSymbol] === "function" && $cSe3c) return $cSe3c(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($33635e551b79d758$var$isMap(obj)) {
        var mapParts = [];
        if ($33635e551b79d758$var$mapForEach) $33635e551b79d758$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $33635e551b79d758$var$collectionOf("Map", $33635e551b79d758$var$mapSize.call(obj), mapParts, indent);
    }
    if ($33635e551b79d758$var$isSet(obj)) {
        var setParts = [];
        if ($33635e551b79d758$var$setForEach) $33635e551b79d758$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $33635e551b79d758$var$collectionOf("Set", $33635e551b79d758$var$setSize.call(obj), setParts, indent);
    }
    if ($33635e551b79d758$var$isWeakMap(obj)) return $33635e551b79d758$var$weakCollectionOf("WeakMap");
    if ($33635e551b79d758$var$isWeakSet(obj)) return $33635e551b79d758$var$weakCollectionOf("WeakSet");
    if ($33635e551b79d758$var$isWeakRef(obj)) return $33635e551b79d758$var$weakCollectionOf("WeakRef");
    if ($33635e551b79d758$var$isNumber(obj)) return $33635e551b79d758$var$markBoxed(inspect(Number(obj)));
    if ($33635e551b79d758$var$isBigInt(obj)) return $33635e551b79d758$var$markBoxed(inspect($33635e551b79d758$var$bigIntValueOf.call(obj)));
    if ($33635e551b79d758$var$isBoolean(obj)) return $33635e551b79d758$var$markBoxed($33635e551b79d758$var$booleanValueOf.call(obj));
    if ($33635e551b79d758$var$isString(obj)) return $33635e551b79d758$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$33635e551b79d758$var$isDate(obj) && !$33635e551b79d758$var$isRegExp(obj)) {
        var ys = $33635e551b79d758$var$arrObjKeys(obj, inspect);
        var isPlainObject = $33635e551b79d758$var$gPO ? $33635e551b79d758$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $33635e551b79d758$var$toStringTag && Object(obj) === obj && $33635e551b79d758$var$toStringTag in obj ? $33635e551b79d758$var$$slice.call($33635e551b79d758$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $33635e551b79d758$var$$join.call($33635e551b79d758$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $33635e551b79d758$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $33635e551b79d758$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $33635e551b79d758$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $33635e551b79d758$var$quote(s) {
    return $33635e551b79d758$var$$replace.call(String(s), /"/g, "&quot;");
}
function $33635e551b79d758$var$isArray(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object Array]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isDate(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object Date]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isRegExp(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object RegExp]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isError(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object Error]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isString(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object String]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isNumber(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object Number]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
function $33635e551b79d758$var$isBoolean(obj) {
    return $33635e551b79d758$var$toStr(obj) === "[object Boolean]" && (!$33635e551b79d758$var$toStringTag || !(typeof obj === "object" && $33635e551b79d758$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $33635e551b79d758$var$isSymbol(obj) {
    if ($33635e551b79d758$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$33635e551b79d758$var$symToString) return false;
    try {
        $33635e551b79d758$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$33635e551b79d758$var$bigIntValueOf) return false;
    try {
        $33635e551b79d758$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $33635e551b79d758$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $33635e551b79d758$var$has(obj, key) {
    return $33635e551b79d758$var$hasOwn.call(obj, key);
}
function $33635e551b79d758$var$toStr(obj) {
    return $33635e551b79d758$var$objectToString.call(obj);
}
function $33635e551b79d758$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $33635e551b79d758$var$$match.call($33635e551b79d758$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $33635e551b79d758$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $33635e551b79d758$var$isMap(x) {
    if (!$33635e551b79d758$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $33635e551b79d758$var$mapSize.call(x);
        try {
            $33635e551b79d758$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isWeakMap(x) {
    if (!$33635e551b79d758$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $33635e551b79d758$var$weakMapHas.call(x, $33635e551b79d758$var$weakMapHas);
        try {
            $33635e551b79d758$var$weakSetHas.call(x, $33635e551b79d758$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isWeakRef(x) {
    if (!$33635e551b79d758$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $33635e551b79d758$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isSet(x) {
    if (!$33635e551b79d758$var$setSize || !x || typeof x !== "object") return false;
    try {
        $33635e551b79d758$var$setSize.call(x);
        try {
            $33635e551b79d758$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isWeakSet(x) {
    if (!$33635e551b79d758$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $33635e551b79d758$var$weakSetHas.call(x, $33635e551b79d758$var$weakSetHas);
        try {
            $33635e551b79d758$var$weakMapHas.call(x, $33635e551b79d758$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $33635e551b79d758$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $33635e551b79d758$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $33635e551b79d758$var$inspectString($33635e551b79d758$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $33635e551b79d758$var$$replace.call($33635e551b79d758$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $33635e551b79d758$var$lowbyte);
    return $33635e551b79d758$var$wrapQuotes(s, "single", opts);
}
function $33635e551b79d758$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $33635e551b79d758$var$$toUpperCase.call(n.toString(16));
}
function $33635e551b79d758$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $33635e551b79d758$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $33635e551b79d758$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $33635e551b79d758$var$indentedJoin(entries, indent) : $33635e551b79d758$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $33635e551b79d758$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($33635e551b79d758$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $33635e551b79d758$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $33635e551b79d758$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $33635e551b79d758$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $33635e551b79d758$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $33635e551b79d758$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $33635e551b79d758$var$arrObjKeys(obj, inspect) {
    var isArr = $33635e551b79d758$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $33635e551b79d758$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $33635e551b79d758$var$gOPS === "function" ? $33635e551b79d758$var$gOPS(obj) : [];
    var symMap;
    if ($33635e551b79d758$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$33635e551b79d758$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($33635e551b79d758$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($33635e551b79d758$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $33635e551b79d758$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($33635e551b79d758$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("cSe3c", function(module, exports) {
"use strict";

});



parcelRegister("CDutP", function(module, exports) {
"use strict";

var $lJPQ8 = parcelRequire("lJPQ8");
var $07422ebcf5b0da31$var$has = Object.prototype.hasOwnProperty;
var $07422ebcf5b0da31$var$isArray = Array.isArray;
var $07422ebcf5b0da31$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $07422ebcf5b0da31$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($07422ebcf5b0da31$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $07422ebcf5b0da31$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $07422ebcf5b0da31$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($07422ebcf5b0da31$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$07422ebcf5b0da31$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($07422ebcf5b0da31$var$isArray(target) && !$07422ebcf5b0da31$var$isArray(source)) mergeTarget = $07422ebcf5b0da31$var$arrayToObject(target, options);
    if ($07422ebcf5b0da31$var$isArray(target) && $07422ebcf5b0da31$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($07422ebcf5b0da31$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($07422ebcf5b0da31$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $07422ebcf5b0da31$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $07422ebcf5b0da31$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $07422ebcf5b0da31$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $07422ebcf5b0da31$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $07422ebcf5b0da31$var$limit){
        var segment = string.length >= $07422ebcf5b0da31$var$limit ? string.slice(j, j + $07422ebcf5b0da31$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $lJPQ8.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $07422ebcf5b0da31$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $07422ebcf5b0da31$var$hexTable[0xC0 | c >> 6] + $07422ebcf5b0da31$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $07422ebcf5b0da31$var$hexTable[0xE0 | c >> 12] + $07422ebcf5b0da31$var$hexTable[0x80 | c >> 6 & 0x3F] + $07422ebcf5b0da31$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $07422ebcf5b0da31$var$hexTable[0xF0 | c >> 18] + $07422ebcf5b0da31$var$hexTable[0x80 | c >> 12 & 0x3F] + $07422ebcf5b0da31$var$hexTable[0x80 | c >> 6 & 0x3F] + $07422ebcf5b0da31$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $07422ebcf5b0da31$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $07422ebcf5b0da31$var$compactQueue(queue);
    return value;
};
var $07422ebcf5b0da31$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $07422ebcf5b0da31$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $07422ebcf5b0da31$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $07422ebcf5b0da31$var$maybeMap = function maybeMap(val, fn) {
    if ($07422ebcf5b0da31$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $07422ebcf5b0da31$var$arrayToObject,
    assign: $07422ebcf5b0da31$var$assign,
    combine: $07422ebcf5b0da31$var$combine,
    compact: $07422ebcf5b0da31$var$compact,
    decode: $07422ebcf5b0da31$var$decode,
    encode: $07422ebcf5b0da31$var$encode,
    isBuffer: $07422ebcf5b0da31$var$isBuffer,
    isRegExp: $07422ebcf5b0da31$var$isRegExp,
    maybeMap: $07422ebcf5b0da31$var$maybeMap,
    merge: $07422ebcf5b0da31$var$merge
};

});
parcelRegister("lJPQ8", function(module, exports) {
"use strict";
var $fd3603487394021b$var$replace = String.prototype.replace;
var $fd3603487394021b$var$percentTwenties = /%20/g;
var $fd3603487394021b$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $fd3603487394021b$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $fd3603487394021b$var$replace.call(value, $fd3603487394021b$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $fd3603487394021b$var$Format.RFC1738,
    RFC3986: $fd3603487394021b$var$Format.RFC3986
};

});



parcelRegister("8cLtv", function(module, exports) {
"use strict";

var $CDutP = parcelRequire("CDutP");
var $5f944540effa3f90$var$has = Object.prototype.hasOwnProperty;
var $5f944540effa3f90$var$isArray = Array.isArray;
var $5f944540effa3f90$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $CDutP.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $5f944540effa3f90$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $5f944540effa3f90$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $5f944540effa3f90$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $5f944540effa3f90$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $5f944540effa3f90$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $5f944540effa3f90$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $5f944540effa3f90$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $5f944540effa3f90$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $5f944540effa3f90$var$defaults.decoder, charset, "key");
            val = $CDutP.maybeMap($5f944540effa3f90$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $5f944540effa3f90$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $5f944540effa3f90$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $5f944540effa3f90$var$isArray(val) ? [
            val
        ] : val;
        var existing = $5f944540effa3f90$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $CDutP.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $5f944540effa3f90$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $5f944540effa3f90$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $5f944540effa3f90$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $5f944540effa3f90$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $5f944540effa3f90$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $5f944540effa3f90$var$parseObject(keys, val, options, valuesParsed);
};
var $5f944540effa3f90$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $5f944540effa3f90$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $5f944540effa3f90$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $5f944540effa3f90$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $5f944540effa3f90$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $5f944540effa3f90$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $5f944540effa3f90$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $5f944540effa3f90$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $5f944540effa3f90$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $5f944540effa3f90$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $5f944540effa3f90$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $5f944540effa3f90$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $5f944540effa3f90$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $CDutP.isRegExp(opts.delimiter) ? opts.delimiter : $5f944540effa3f90$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $5f944540effa3f90$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $5f944540effa3f90$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $5f944540effa3f90$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $5f944540effa3f90$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $5f944540effa3f90$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $5f944540effa3f90$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $5f944540effa3f90$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $5f944540effa3f90$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $5f944540effa3f90$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $CDutP.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $CDutP.compact(obj);
};

});


parcelRegister("hJePx", function(module, exports) {

$parcel$export(module.exports, "MUTATION_CREATE_DELIVERY_EVENT", function () { return $ce8224a0e58c958f$export$f7dc25f57197f6f8; });
$parcel$export(module.exports, "MUTATION_ACCESS_SCAN", function () { return $ce8224a0e58c958f$export$edf5bbf13b92c589; });
$parcel$export(module.exports, "MUTATION_CREATE_GUEST", function () { return $ce8224a0e58c958f$export$255003e9a28fdae2; });
$parcel$export(module.exports, "MUTATION_CHECKOUT_OWNER", function () { return $ce8224a0e58c958f$export$a4a94ec8659e687e; });
$parcel$export(module.exports, "MUTATION_CREATE_CUSTOM_DELIVERY_EVENT", function () { return $ce8224a0e58c958f$export$61dfaad73d5dbaea; });
$parcel$export(module.exports, "MUTATION_CREATE_VIDEO_ROOM", function () { return $ce8224a0e58c958f$export$c6b5d25ca0fed49a; });
$parcel$export(module.exports, "MUTATION_DELETE_VIDEO_ROOM", function () { return $ce8224a0e58c958f$export$c134e77194a5bf4b; });

var $g6uH4 = parcelRequire("g6uH4");

var $fQgQB = parcelRequire("fQgQB");
const $ce8224a0e58c958f$export$f7dc25f57197f6f8 = (0, $g6uH4.gql)`
  mutation createDeliveryEvent($input: CreateDeliverInput!) {
    createDeliveryEvent(input: $input) {
      id
      receiver {
        id
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_EMPLOYEE_PREFERENCES)}
`;
const $ce8224a0e58c958f$export$67cd3c48af49d8e3 = (0, $g6uH4.gql)`
  mutation createGuestVisitor($input: CreateGuestVisitor!) {
    createGuestVisitor(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $ce8224a0e58c958f$export$edf5bbf13b92c589 = (0, $g6uH4.gql)`
  mutation accessScan($input: MemberAccessCheckInInput!) {
    accessScan(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      metadata
      receiver {
        id
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $ce8224a0e58c958f$export$176c60b53e487d1a = (0, $g6uH4.gql)`
  mutation createScreenEvent($input: CreateScreenEventInput!) {
    createScreenEvent(input: $input) {
      id
    }
  }
`;
const $ce8224a0e58c958f$export$255003e9a28fdae2 = (0, $g6uH4.gql)`
  mutation createGuest($input: CreateGuest!) {
    createGuest(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $ce8224a0e58c958f$export$a4a94ec8659e687e = (0, $g6uH4.gql)`
  mutation checkOutOwner($id: ID!) {
    checkOutOwner(id: $id) {
      id
    }
  }
`;
const $ce8224a0e58c958f$export$61dfaad73d5dbaea = (0, $g6uH4.gql)`
  mutation createCustomDeliveryEvent($input: CreateCustomDeliveryInput!) {
    createCustomDeliveryEvent(input: $input) {
      id
      customReceiver {
        phone
      }
    }
  }
`;
const $ce8224a0e58c958f$export$c6b5d25ca0fed49a = (0, $g6uH4.gql)`
  mutation accessEventCreateVideoRoom($id: ID!) {
    accessEventCreateVideoRoom(id: $id) {
      id
      roomUrl
    }
  }
`;
const $ce8224a0e58c958f$export$c134e77194a5bf4b = (0, $g6uH4.gql)`
  mutation accessEventDeleteVideoRoom($id: ID!) {
    accessEventDeleteVideoRoom(id: $id)
  }
`;

});


parcelRegister("bzcXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86bd047242fe6f63$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $cpnWK = parcelRequire("cpnWK");

var $4yVoh = parcelRequire("4yVoh");

var $cD0nt = parcelRequire("cD0nt");
const $86bd047242fe6f63$var$bump = (delay)=>({
        initial: {
            opacity: 0.75,
            scale: 0.35
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 1,
                delay: delay,
                type: "spring",
                stiffness: 400,
                damping: 20
            }
        },
        tap: {
            scale: 0.95
        },
        exit: {
            scale: 1
        }
    });
const $86bd047242fe6f63$var$Bump = (props)=>{
    const { children: children, disabled: disabled } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, Object.assign({}, (0, $4yVoh.anim)($86bd047242fe6f63$var$bump((0, (/*@__PURE__*/$parcel$interopDefault($cpnWK)))(0.45, 0.65)))));
};
var $86bd047242fe6f63$export$2e2bcd8739ae039 = $86bd047242fe6f63$var$Bump;

});
parcelRegister("cpnWK", function(module, exports) {

var $lf0L4 = parcelRequire("lf0L4");

var $2bHYF = parcelRequire("2bHYF");

var $bSLev = parcelRequire("bSLev");
/** Built-in method references without a dependency on `root`. */ var $908a651fe55bae2a$var$freeParseFloat = parseFloat;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $908a651fe55bae2a$var$nativeMin = Math.min, $908a651fe55bae2a$var$nativeRandom = Math.random;
/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */ function $908a651fe55bae2a$var$random(lower, upper, floating) {
    if (floating && typeof floating != "boolean" && $2bHYF(lower, upper, floating)) upper = floating = undefined;
    if (floating === undefined) {
        if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined;
        } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined;
        }
    }
    if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
    } else {
        lower = $bSLev(lower);
        if (upper === undefined) {
            upper = lower;
            lower = 0;
        } else upper = $bSLev(upper);
    }
    if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
    }
    if (floating || lower % 1 || upper % 1) {
        var rand = $908a651fe55bae2a$var$nativeRandom();
        return $908a651fe55bae2a$var$nativeMin(lower + rand * (upper - lower + $908a651fe55bae2a$var$freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
    }
    return $lf0L4(lower, upper);
}
module.exports = $908a651fe55bae2a$var$random;

});
parcelRegister("lf0L4", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f76b96441ade902a$var$nativeFloor = Math.floor, $f76b96441ade902a$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $f76b96441ade902a$var$baseRandom(lower, upper) {
    return lower + $f76b96441ade902a$var$nativeFloor($f76b96441ade902a$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $f76b96441ade902a$var$baseRandom;

});

parcelRegister("bSLev", function(module, exports) {

var $hywEB = parcelRequire("hywEB");
/** Used as references for various `Number` constants. */ var $8a696056c6b9f3f3$var$INFINITY = 1 / 0, $8a696056c6b9f3f3$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $8a696056c6b9f3f3$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $hywEB(value);
    if (value === $8a696056c6b9f3f3$var$INFINITY || value === -$8a696056c6b9f3f3$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $8a696056c6b9f3f3$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $8a696056c6b9f3f3$var$toFinite;

});
parcelRegister("hywEB", function(module, exports) {

var $32Ip8 = parcelRequire("32Ip8");

var $ghHeQ = parcelRequire("ghHeQ");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $cc7ef0ffc70a3a71$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $cc7ef0ffc70a3a71$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $cc7ef0ffc70a3a71$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $cc7ef0ffc70a3a71$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $cc7ef0ffc70a3a71$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $cc7ef0ffc70a3a71$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($jc3qQ(value)) return $cc7ef0ffc70a3a71$var$NAN;
    if ($ghHeQ(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ghHeQ(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $32Ip8(value);
    var isBinary = $cc7ef0ffc70a3a71$var$reIsBinary.test(value);
    return isBinary || $cc7ef0ffc70a3a71$var$reIsOctal.test(value) ? $cc7ef0ffc70a3a71$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $cc7ef0ffc70a3a71$var$reIsBadHex.test(value) ? $cc7ef0ffc70a3a71$var$NAN : +value;
}
module.exports = $cc7ef0ffc70a3a71$var$toNumber;

});
parcelRegister("32Ip8", function(module, exports) {

var $hjEKx = parcelRequire("hjEKx");
/** Used to match leading whitespace. */ var $237400c6af36c8bd$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $237400c6af36c8bd$var$baseTrim(string) {
    return string ? string.slice(0, $hjEKx(string) + 1).replace($237400c6af36c8bd$var$reTrimStart, "") : string;
}
module.exports = $237400c6af36c8bd$var$baseTrim;

});
parcelRegister("hjEKx", function(module, exports) {
/** Used to match a single whitespace character. */ var $c9b3d20d36a4f975$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $c9b3d20d36a4f975$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $c9b3d20d36a4f975$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $c9b3d20d36a4f975$var$trimmedEndIndex;

});







parcelRegister("kP4GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f28c35ce6e611bf4$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $1BWAg = parcelRequire("1BWAg");

var $81BVN = parcelRequire("81BVN");

var $8YEKz = parcelRequire("8YEKz");

var $3pTPw = parcelRequire("3pTPw");

var $ezhXm = parcelRequire("ezhXm");
const $f28c35ce6e611bf4$var$ViewFinder = ()=>(0, $bhfvP.jsxs)("svg", Object.assign({
        viewBox: "0 0 100 100",
        style: {
            top: 0,
            left: 0,
            zIndex: 1,
            boxSizing: "border-box",
            position: "absolute",
            width: "100%",
            height: "100%"
        }
    }, {
        children: [
            (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M13,0 L0,0 L0,13",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M0,87 L0,100 L13,100",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M87,100 L100,100 L100,87",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M100,13 L100,0 87,0",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            })
        ]
    }));
const $f28c35ce6e611bf4$var$QRCodeScanner = ()=>{
    var _a;
    const match = (0, $9B9bN.useMatch)({
        path: "/scanner/:action"
    });
    const action = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.action;
    const navigate = (0, $9B9bN.useNavigate)(); // usePageTracking({
    //   page: "scanner",
    // });
    const [error, setError] = (0, $eZVvM.useState)();
    const onResult = (0, $eZVvM.useCallback)((result, error)=>{
        if (error) {
            setError(error);
            return;
        }
        if (!result) return;
        const data = result.getText();
        const regex = /^\d+$/;
        if (data && regex.test(data) && data.length === 6) navigate(`/access/${action}/${data}`);
    }, []);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $3pTPw.default), {
                        to: `/access/${action}`
                    }),
                    (0, $bhfvP.jsxs)((0, $8YEKz.default), {
                        children: [
                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h1"
                            }, {
                                children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "QRCodeScanner:title"
                                })
                            })),
                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h4",
                                className: "font-weight-regular mt-5"
                            }, {
                                children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "QRCodeScanner:subtitle"
                                })
                            }))
                        ]
                    }),
                    (0, $bhfvP.jsxs)("div", Object.assign({
                        className: "qr-scanner"
                    }, {
                        children: [
                            (0, $bhfvP.jsx)("div", Object.assign({
                                style: {
                                    width: "100%",
                                    margin: "auto"
                                }
                            }, {
                                children: (0, $bhfvP.jsx)((0, $1BWAg.QrReader), {
                                    onResult: onResult,
                                    scanDelay: 1000,
                                    constraints: {
                                        facingMode: "user",
                                        aspectRatio: 1
                                    },
                                    ViewFinder: $f28c35ce6e611bf4$var$ViewFinder
                                })
                            })),
                            error && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h3",
                                className: "position-absolute text-center text-danger p-4"
                            }, {
                                children: error === null || error === void 0 ? void 0 : error.message
                            }))
                        ]
                    }))
                ]
            })),
            (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $f28c35ce6e611bf4$export$2e2bcd8739ae039 = $f28c35ce6e611bf4$var$QRCodeScanner;

});
parcelRegister("1BWAg", function(module, exports) {

$parcel$export(module.exports, "QrReader", function () { return $12c6b0ab9da17bee$export$5d05a7e825dbf285; });

var $eZVvM = parcelRequire("eZVvM");
var $12c6b0ab9da17bee$var$n, $12c6b0ab9da17bee$var$o, $12c6b0ab9da17bee$var$i = ($12c6b0ab9da17bee$var$n = function(t, e) {
    return $12c6b0ab9da17bee$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
    }, $12c6b0ab9da17bee$var$n(t, e);
}, function(t, e) {
    function r() {
        this.constructor = t;
    }
    $12c6b0ab9da17bee$var$n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $12c6b0ab9da17bee$var$a = function(t) {
    function e(e) {
        var r, n, o, i = this.constructor, a = t.call(this, e) || this;
        return Object.defineProperty(a, "name", {
            value: i.name,
            enumerable: !1,
            configurable: !0
        }), r = a, n = i.prototype, (o = Object.setPrototypeOf) ? o(r, n) : r.__proto__ = n, function(t, e) {
            void 0 === e && (e = t.constructor);
            var r = Error.captureStackTrace;
            r && r(t, e);
        }(a), a;
    }
    return $12c6b0ab9da17bee$var$i(e, t), e;
}(Error), $12c6b0ab9da17bee$var$u = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$s = function(t) {
    function e(e) {
        void 0 === e && (e = void 0);
        var r = t.call(this, e) || this;
        return r.message = e, r;
    }
    return $12c6b0ab9da17bee$var$u(e, t), e.prototype.getKind = function() {
        return this.constructor.kind;
    }, e.kind = "Exception", e;
}($12c6b0ab9da17bee$var$a), $12c6b0ab9da17bee$var$c = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$f = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$c(e, t), e.kind = "ArgumentException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$h = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$l = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$h(e, t), e.kind = "IllegalArgumentException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$d = function() {
    function t(t) {
        if (this.binarizer = t, null === t) throw new $12c6b0ab9da17bee$var$l("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(t, e) {
        return this.binarizer.getBlackRow(t, e);
    }, t.prototype.getBlackMatrix = function() {
        return null !== this.matrix && void 0 !== this.matrix || (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, r, n, o) {
        var i = this.binarizer.getLuminanceSource().crop(e, r, n, o);
        return new t(this.binarizer.createBinarizer(i));
    }, t.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (t) {
            return "";
        }
    }, t;
}(), $12c6b0ab9da17bee$var$p = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$g = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$p(e, t), e.getChecksumInstance = function() {
        return new e;
    }, e.kind = "ChecksumException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$y = function() {
    function t(t) {
        this.source = t;
    }
    return t.prototype.getLuminanceSource = function() {
        return this.source;
    }, t.prototype.getWidth = function() {
        return this.source.getWidth();
    }, t.prototype.getHeight = function() {
        return this.source.getHeight();
    }, t;
}(), $12c6b0ab9da17bee$var$w = function() {
    function t() {}
    return t.arraycopy = function(t, e, r, n, o) {
        for(; o--;)r[n++] = t[e++];
    }, t.currentTimeMillis = function() {
        return Date.now();
    }, t;
}(), $12c6b0ab9da17bee$var$_ = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$v = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$_(e, t), e.kind = "IndexOutOfBoundsException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$m = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$A = function(t) {
    function e(e, r) {
        void 0 === e && (e = void 0), void 0 === r && (r = void 0);
        var n = t.call(this, r) || this;
        return n.index = e, n.message = r, n;
    }
    return $12c6b0ab9da17bee$var$m(e, t), e.kind = "ArrayIndexOutOfBoundsException", e;
}($12c6b0ab9da17bee$var$v), $12c6b0ab9da17bee$var$E = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$C = function() {
    function t() {}
    return t.fill = function(t, e) {
        for(var r = 0, n = t.length; r < n; r++)t[r] = e;
    }, t.fillWithin = function(e, r, n, o) {
        t.rangeCheck(e.length, r, n);
        for(var i = r; i < n; i++)e[i] = o;
    }, t.rangeCheck = function(t, e, r) {
        if (e > r) throw new $12c6b0ab9da17bee$var$l("fromIndex(" + e + ") > toIndex(" + r + ")");
        if (e < 0) throw new $12c6b0ab9da17bee$var$A(e);
        if (r > t) throw new $12c6b0ab9da17bee$var$A(r);
    }, t.asList = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return t;
    }, t.create = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Array.from({
                length: e
            }).fill(r);
        });
    }, t.createInt32Array = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Int32Array.from({
                length: e
            }).fill(r);
        });
    }, t.equals = function(t, e) {
        if (!t) return !1;
        if (!e) return !1;
        if (!t.length) return !1;
        if (!e.length) return !1;
        if (t.length !== e.length) return !1;
        for(var r = 0, n = t.length; r < n; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, t.hashCode = function(t) {
        var e, r;
        if (null === t) return 0;
        var n = 1;
        try {
            for(var o = $12c6b0ab9da17bee$var$E(t), i = o.next(); !i.done; i = o.next())n = 31 * n + i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.fillUint8Array = function(t, e) {
        for(var r = 0; r !== t.length; r++)t[r] = e;
    }, t.copyOf = function(t, e) {
        return t.slice(0, e);
    }, t.copyOfUint8Array = function(t, e) {
        if (t.length <= e) {
            var r = new Uint8Array(e);
            return r.set(t), r;
        }
        return t.slice(0, e);
    }, t.copyOfRange = function(t, e, r) {
        var n = r - e, o = new Int32Array(n);
        return $12c6b0ab9da17bee$var$w.arraycopy(t, e, o, 0, n), o;
    }, t.binarySearch = function(e, r, n) {
        void 0 === n && (n = t.numberComparator);
        for(var o = 0, i = e.length - 1; o <= i;){
            var a = i + o >> 1, u = n(r, e[a]);
            if (u > 0) o = a + 1;
            else {
                if (!(u < 0)) return a;
                i = a - 1;
            }
        }
        return -o - 1;
    }, t.numberComparator = function(t, e) {
        return t - e;
    }, t;
}(), $12c6b0ab9da17bee$var$I = function() {
    function t() {}
    return t.numberOfTrailingZeros = function(t) {
        var e;
        if (0 === t) return 32;
        var r = 31;
        return 0 !== (e = t << 16) && (r -= 16, t = e), 0 !== (e = t << 8) && (r -= 8, t = e), 0 !== (e = t << 4) && (r -= 4, t = e), 0 !== (e = t << 2) && (r -= 2, t = e), r - (t << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(t) {
        if (0 === t) return 32;
        var e = 1;
        return t >>> 16 == 0 && (e += 16, t <<= 16), t >>> 24 == 0 && (e += 8, t <<= 8), t >>> 28 == 0 && (e += 4, t <<= 4), t >>> 30 == 0 && (e += 2, t <<= 2), e -= t >>> 31;
    }, t.toHexString = function(t) {
        return t.toString(16);
    }, t.toBinaryString = function(t) {
        return String(parseInt(String(t), 2));
    }, t.bitCount = function(t) {
        return t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135, t += t >>> 8, 63 & (t += t >>> 16);
    }, t.truncDivision = function(t, e) {
        return Math.trunc(t / e);
    }, t.parseInt = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $12c6b0ab9da17bee$var$S = function() {
    function t(e, r) {
        void 0 === e ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, this.bits = null == r ? t.makeArray(e) : r);
    }
    return t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
        if (e > 32 * this.bits.length) {
            var r = t.makeArray(e);
            $12c6b0ab9da17bee$var$w.arraycopy(this.bits, 0, r, 0, this.bits.length), this.bits = r;
        }
    }, t.prototype.get = function(t) {
        return 0 != (this.bits[Math.floor(t / 32)] & 1 << (31 & t));
    }, t.prototype.set = function(t) {
        this.bits[Math.floor(t / 32)] |= 1 << (31 & t);
    }, t.prototype.flip = function(t) {
        this.bits[Math.floor(t / 32)] ^= 1 << (31 & t);
    }, t.prototype.getNextSet = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = r[n];
        }
        var a = 32 * n + $12c6b0ab9da17bee$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.getNextUnset = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = ~r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = ~r[n];
        }
        var a = 32 * n + $12c6b0ab9da17bee$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.setBulk = function(t, e) {
        this.bits[Math.floor(t / 32)] = e;
    }, t.prototype.setRange = function(t, e) {
        if (e < t || t < 0 || e > this.size) throw new $12c6b0ab9da17bee$var$l;
        if (e !== t) {
            e--;
            for(var r = Math.floor(t / 32), n = Math.floor(e / 32), o = this.bits, i = r; i <= n; i++){
                var a = (2 << (i < n ? 31 : 31 & e)) - (1 << (i > r ? 0 : 31 & t));
                o[i] |= a;
            }
        }
    }, t.prototype.clear = function() {
        for(var t = this.bits.length, e = this.bits, r = 0; r < t; r++)e[r] = 0;
    }, t.prototype.isRange = function(t, e, r) {
        if (e < t || t < 0 || e > this.size) throw new $12c6b0ab9da17bee$var$l;
        if (e === t) return !0;
        e--;
        for(var n = Math.floor(t / 32), o = Math.floor(e / 32), i = this.bits, a = n; a <= o; a++){
            var u = (2 << (a < o ? 31 : 31 & e)) - (1 << (a > n ? 0 : 31 & t)) & 4294967295;
            if ((i[a] & u) !== (r ? u : 0)) return !1;
        }
        return !0;
    }, t.prototype.appendBit = function(t) {
        this.ensureCapacity(this.size + 1), t && (this.bits[Math.floor(this.size / 32)] |= 1 << (31 & this.size)), this.size++;
    }, t.prototype.appendBits = function(t, e) {
        if (e < 0 || e > 32) throw new $12c6b0ab9da17bee$var$l("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + e);
        for(var r = e; r > 0; r--)this.appendBit(1 == (t >> r - 1 & 1));
    }, t.prototype.appendBitArray = function(t) {
        var e = t.size;
        this.ensureCapacity(this.size + e);
        for(var r = 0; r < e; r++)this.appendBit(t.get(r));
    }, t.prototype.xor = function(t) {
        if (this.size !== t.size) throw new $12c6b0ab9da17bee$var$l("Sizes don't match");
        for(var e = this.bits, r = 0, n = e.length; r < n; r++)e[r] ^= t.bits[r];
    }, t.prototype.toBytes = function(t, e, r, n) {
        for(var o = 0; o < n; o++){
            for(var i = 0, a = 0; a < 8; a++)this.get(t) && (i |= 1 << 7 - a), t++;
            e[r + o] = i;
        }
    }, t.prototype.getBitArray = function() {
        return this.bits;
    }, t.prototype.reverse = function() {
        for(var t = new Int32Array(this.bits.length), e = Math.floor((this.size - 1) / 32), r = e + 1, n = this.bits, o = 0; o < r; o++){
            var i = n[o];
            i = (i = (i = (i = (i = i >> 1 & 1431655765 | (1431655765 & i) << 1) >> 2 & 858993459 | (858993459 & i) << 2) >> 4 & 252645135 | (252645135 & i) << 4) >> 8 & 16711935 | (16711935 & i) << 8) >> 16 & 65535 | (65535 & i) << 16, t[e - o] = i;
        }
        if (this.size !== 32 * r) {
            var a = 32 * r - this.size, u = t[0] >>> a;
            for(o = 1; o < r; o++){
                var s = t[o];
                u |= s << 32 - a, t[o - 1] = u, u = s >>> a;
            }
            t[r - 1] = u;
        }
        this.bits = t;
    }, t.makeArray = function(t) {
        return new Int32Array(Math.floor((t + 31) / 32));
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.size === r.size && $12c6b0ab9da17bee$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        return 31 * this.size + $12c6b0ab9da17bee$var$C.hashCode(this.bits);
    }, t.prototype.toString = function() {
        for(var t = "", e = 0, r = this.size; e < r; e++)0 == (7 & e) && (t += " "), t += this.get(e) ? "X" : ".";
        return t;
    }, t.prototype.clone = function() {
        return new t(this.size, this.bits.slice());
    }, t;
}();
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
}($12c6b0ab9da17bee$var$o || ($12c6b0ab9da17bee$var$o = {}));
var $12c6b0ab9da17bee$var$O, $12c6b0ab9da17bee$var$T = $12c6b0ab9da17bee$var$o, $12c6b0ab9da17bee$var$b = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$R = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$b(e, t), e.getFormatInstance = function() {
        return new e;
    }, e.kind = "FormatException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$N = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
}($12c6b0ab9da17bee$var$O || ($12c6b0ab9da17bee$var$O = {}));
var $12c6b0ab9da17bee$var$D, $12c6b0ab9da17bee$var$P = function() {
    function t(e, r, n) {
        for(var o, i, a = [], u = 3; u < arguments.length; u++)a[u - 3] = arguments[u];
        this.valueIdentifier = e, this.name = n, this.values = "number" == typeof r ? Int32Array.from([
            r
        ]) : r, this.otherEncodingNames = a, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(n, this);
        for(var s = this.values, c = 0, f = s.length; c !== f; c++){
            var h = s[c];
            t.VALUES_TO_ECI.set(h, this);
        }
        try {
            for(var l = $12c6b0ab9da17bee$var$N(a), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                t.NAME_TO_ECI.set(p, this);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
    }
    return t.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    }, t.prototype.getName = function() {
        return this.name;
    }, t.prototype.getValue = function() {
        return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
        if (e < 0 || e >= 900) throw new $12c6b0ab9da17bee$var$R("incorect value");
        var r = t.VALUES_TO_ECI.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$R("incorect value");
        return r;
    }, t.getCharacterSetECIByName = function(e) {
        var r = t.NAME_TO_ECI.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$R("incorect value");
        return r;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.getName() === r.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = new Map, t.VALUES_TO_ECI = new Map, t.NAME_TO_ECI = new Map, t.Cp437 = new t($12c6b0ab9da17bee$var$O.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437"), t.ISO8859_1 = new t($12c6b0ab9da17bee$var$O.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t($12c6b0ab9da17bee$var$O.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t($12c6b0ab9da17bee$var$O.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t($12c6b0ab9da17bee$var$O.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t($12c6b0ab9da17bee$var$O.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t($12c6b0ab9da17bee$var$O.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t($12c6b0ab9da17bee$var$O.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t($12c6b0ab9da17bee$var$O.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t($12c6b0ab9da17bee$var$O.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t($12c6b0ab9da17bee$var$O.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t($12c6b0ab9da17bee$var$O.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t($12c6b0ab9da17bee$var$O.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t($12c6b0ab9da17bee$var$O.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t($12c6b0ab9da17bee$var$O.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t($12c6b0ab9da17bee$var$O.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t($12c6b0ab9da17bee$var$O.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t($12c6b0ab9da17bee$var$O.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t($12c6b0ab9da17bee$var$O.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t($12c6b0ab9da17bee$var$O.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t($12c6b0ab9da17bee$var$O.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t($12c6b0ab9da17bee$var$O.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t($12c6b0ab9da17bee$var$O.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t($12c6b0ab9da17bee$var$O.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII"), t.Big5 = new t($12c6b0ab9da17bee$var$O.Big5, 28, "Big5"), t.GB18030 = new t($12c6b0ab9da17bee$var$O.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t($12c6b0ab9da17bee$var$O.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
}(), $12c6b0ab9da17bee$var$M = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$B = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$M(e, t), e.kind = "UnsupportedOperationException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$L = function() {
    function t() {}
    return t.decode = function(t, e) {
        var r = this.encodingName(e);
        return this.customDecoder ? this.customDecoder(t, r) : "undefined" == typeof TextDecoder || this.shouldDecodeOnFallback(r) ? this.decodeFallback(t, r) : new TextDecoder(r).decode(t);
    }, t.shouldDecodeOnFallback = function(e) {
        return !t.isBrowser() && "ISO-8859-1" === e;
    }, t.encode = function(t, e) {
        var r = this.encodingName(e);
        return this.customEncoder ? this.customEncoder(t, r) : "undefined" == typeof TextEncoder ? this.encodeFallback(t) : (new TextEncoder).encode(t);
    }, t.isBrowser = function() {
        return "undefined" != typeof window && "[object Window]" === ({}).toString.call(window);
    }, t.encodingName = function(t) {
        return "string" == typeof t ? t : t.getName();
    }, t.encodingCharacterSet = function(t) {
        return t instanceof $12c6b0ab9da17bee$var$P ? t : $12c6b0ab9da17bee$var$P.getCharacterSetECIByName(t);
    }, t.decodeFallback = function(e, r) {
        var n = this.encodingCharacterSet(r);
        if (t.isDecodeFallbackSupported(n)) {
            for(var o = "", i = 0, a = e.length; i < a; i++){
                var u = e[i].toString(16);
                u.length < 2 && (u = "0" + u), o += "%" + u;
            }
            return decodeURIComponent(o);
        }
        if (n.equals($12c6b0ab9da17bee$var$P.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        throw new $12c6b0ab9da17bee$var$B("Encoding " + this.encodingName(r) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(t) {
        return t.equals($12c6b0ab9da17bee$var$P.UTF8) || t.equals($12c6b0ab9da17bee$var$P.ISO8859_1) || t.equals($12c6b0ab9da17bee$var$P.ASCII);
    }, t.encodeFallback = function(t) {
        for(var e = btoa(unescape(encodeURIComponent(t))).split(""), r = [], n = 0; n < e.length; n++)r.push(e[n].charCodeAt(0));
        return new Uint8Array(r);
    }, t;
}(), $12c6b0ab9da17bee$var$F = function() {
    function t() {}
    return t.castAsNonUtf8Char = function(t, e) {
        void 0 === e && (e = null);
        var r = e ? e.getName() : this.ISO88591;
        return $12c6b0ab9da17bee$var$L.decode(new Uint8Array([
            t
        ]), r);
    }, t.guessEncoding = function(e, r) {
        if (null != r && void 0 !== r.get($12c6b0ab9da17bee$var$T.CHARACTER_SET)) return r.get($12c6b0ab9da17bee$var$T.CHARACTER_SET).toString();
        for(var n = e.length, o = !0, i = !0, a = !0, u = 0, s = 0, c = 0, f = 0, h = 0, l = 0, d = 0, p = 0, g = 0, y = 0, w = 0, _ = e.length > 3 && 239 === e[0] && 187 === e[1] && 191 === e[2], v = 0; v < n && (o || i || a); v++){
            var m = 255 & e[v];
            a && (u > 0 ? 0 == (128 & m) ? a = !1 : u-- : 0 != (128 & m) && (0 == (64 & m) ? a = !1 : (u++, 0 == (32 & m) ? s++ : (u++, 0 == (16 & m) ? c++ : (u++, 0 == (8 & m) ? f++ : a = !1))))), o && (m > 127 && m < 160 ? o = !1 : m > 159 && (m < 192 || 215 === m || 247 === m) && w++), i && (h > 0 ? m < 64 || 127 === m || m > 252 ? i = !1 : h-- : 128 === m || 160 === m || m > 239 ? i = !1 : m > 160 && m < 224 ? (l++, p = 0, ++d > g && (g = d)) : m > 127 ? (h++, d = 0, ++p > y && (y = p)) : (d = 0, p = 0));
        }
        return a && u > 0 && (a = !1), i && h > 0 && (i = !1), a && (_ || s + c + f > 0) ? t.UTF8 : i && (t.ASSUME_SHIFT_JIS || g >= 3 || y >= 3) ? t.SHIFT_JIS : o && i ? 2 === g && 2 === l || 10 * w >= n ? t.SHIFT_JIS : t.ISO88591 : o ? t.ISO88591 : i ? t.SHIFT_JIS : a ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        var n = -1;
        function o(t, r, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++n]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[n];
                        break;
                    case "c":
                        s = e[n][0];
                        break;
                    case "f":
                        s = parseFloat(e[n]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[n]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[n]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[n]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[n], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== r ? s + h : h + s;
                return s;
            }
        }
        var i = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return t.replace(i, o);
    }, t.getBytes = function(t, e) {
        return $12c6b0ab9da17bee$var$L.encode(t, e);
    }, t.getCharCode = function(t, e) {
        return void 0 === e && (e = 0), t.charCodeAt(e);
    }, t.getCharAt = function(t) {
        return String.fromCharCode(t);
    }, t.SHIFT_JIS = $12c6b0ab9da17bee$var$P.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = $12c6b0ab9da17bee$var$P.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = $12c6b0ab9da17bee$var$P.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
}(), $12c6b0ab9da17bee$var$k = function() {
    function t(t) {
        void 0 === t && (t = ""), this.value = t;
    }
    return t.prototype.enableDecoding = function(t) {
        return this.encoding = t, this;
    }, t.prototype.append = function(t) {
        return "string" == typeof t ? this.value += t.toString() : this.encoding ? this.value += $12c6b0ab9da17bee$var$F.castAsNonUtf8Char(t, this.encoding) : this.value += String.fromCharCode(t), this;
    }, t.prototype.appendChars = function(t, e, r) {
        for(var n = e; e < e + r; n++)this.append(t[n]);
        return this;
    }, t.prototype.length = function() {
        return this.value.length;
    }, t.prototype.charAt = function(t) {
        return this.value.charAt(t);
    }, t.prototype.deleteCharAt = function(t) {
        this.value = this.value.substr(0, t) + this.value.substring(t + 1);
    }, t.prototype.setCharAt = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + 1);
    }, t.prototype.substring = function(t, e) {
        return this.value.substring(t, e);
    }, t.prototype.setLengthToZero = function() {
        this.value = "";
    }, t.prototype.toString = function() {
        return this.value;
    }, t.prototype.insert = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + e.length);
    }, t;
}(), $12c6b0ab9da17bee$var$x = function() {
    function t(t, e, r, n) {
        if (this.width = t, this.height = e, this.rowSize = r, this.bits = n, null == e && (e = t), this.height = e, t < 1 || e < 1) throw new $12c6b0ab9da17bee$var$l("Both dimensions must be greater than 0");
        null == r && (r = Math.floor((t + 31) / 32)), this.rowSize = r, null == n && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
        for(var r = e.length, n = e[0].length, o = new t(n, r), i = 0; i < r; i++)for(var a = e[i], u = 0; u < n; u++)a[u] && o.set(u, i);
        return o;
    }, t.parseFromString = function(e, r, n) {
        if (null === e) throw new $12c6b0ab9da17bee$var$l("stringRepresentation cannot be null");
        for(var o = new Array(e.length), i = 0, a = 0, u = -1, s = 0, c = 0; c < e.length;)if ("\n" === e.charAt(c) || "\r" === e.charAt(c)) {
            if (i > a) {
                if (-1 === u) u = i - a;
                else if (i - a !== u) throw new $12c6b0ab9da17bee$var$l("row lengths do not match");
                a = i, s++;
            }
            c++;
        } else if (e.substring(c, c + r.length) === r) c += r.length, o[i] = !0, i++;
        else {
            if (e.substring(c, c + n.length) !== n) throw new $12c6b0ab9da17bee$var$l("illegal character encountered: " + e.substring(c));
            c += n.length, o[i] = !1, i++;
        }
        if (i > a) {
            if (-1 === u) u = i - a;
            else if (i - a !== u) throw new $12c6b0ab9da17bee$var$l("row lengths do not match");
            s++;
        }
        for(var f = new t(u, s), h = 0; h < i; h++)o[h] && f.set(Math.floor(h % u), Math.floor(h / u));
        return f;
    }, t.prototype.get = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        return 0 != (this.bits[r] >>> (31 & t) & 1);
    }, t.prototype.set = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] |= 1 << (31 & t) & 4294967295;
    }, t.prototype.unset = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] &= ~(1 << (31 & t) & 4294967295);
    }, t.prototype.flip = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] ^= 1 << (31 & t) & 4294967295;
    }, t.prototype.xor = function(t) {
        if (this.width !== t.getWidth() || this.height !== t.getHeight() || this.rowSize !== t.getRowSize()) throw new $12c6b0ab9da17bee$var$l("input matrix dimensions do not match");
        for(var e = new $12c6b0ab9da17bee$var$S(Math.floor(this.width / 32) + 1), r = this.rowSize, n = this.bits, o = 0, i = this.height; o < i; o++)for(var a = o * r, u = t.getRow(o, e).getBitArray(), s = 0; s < r; s++)n[a + s] ^= u[s];
    }, t.prototype.clear = function() {
        for(var t = this.bits, e = t.length, r = 0; r < e; r++)t[r] = 0;
    }, t.prototype.setRegion = function(t, e, r, n) {
        if (e < 0 || t < 0) throw new $12c6b0ab9da17bee$var$l("Left and top must be nonnegative");
        if (n < 1 || r < 1) throw new $12c6b0ab9da17bee$var$l("Height and width must be at least 1");
        var o = t + r, i = e + n;
        if (i > this.height || o > this.width) throw new $12c6b0ab9da17bee$var$l("The region must fit inside the matrix");
        for(var a = this.rowSize, u = this.bits, s = e; s < i; s++)for(var c = s * a, f = t; f < o; f++)u[c + Math.floor(f / 32)] |= 1 << (31 & f) & 4294967295;
    }, t.prototype.getRow = function(t, e) {
        null == e || e.getSize() < this.width ? e = new $12c6b0ab9da17bee$var$S(this.width) : e.clear();
        for(var r = this.rowSize, n = this.bits, o = t * r, i = 0; i < r; i++)e.setBulk(32 * i, n[o + i]);
        return e;
    }, t.prototype.setRow = function(t, e) {
        $12c6b0ab9da17bee$var$w.arraycopy(e.getBitArray(), 0, this.bits, t * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
        for(var t = this.getWidth(), e = this.getHeight(), r = new $12c6b0ab9da17bee$var$S(t), n = new $12c6b0ab9da17bee$var$S(t), o = 0, i = Math.floor((e + 1) / 2); o < i; o++)r = this.getRow(o, r), n = this.getRow(e - 1 - o, n), r.reverse(), n.reverse(), this.setRow(o, n), this.setRow(e - 1 - o, r);
    }, t.prototype.getEnclosingRectangle = function() {
        for(var t = this.width, e = this.height, r = this.rowSize, n = this.bits, o = t, i = e, a = -1, u = -1, s = 0; s < e; s++)for(var c = 0; c < r; c++){
            var f = n[s * r + c];
            if (0 !== f) {
                if (s < i && (i = s), s > u && (u = s), 32 * c < o) {
                    for(var h = 0; 0 == (f << 31 - h & 4294967295);)h++;
                    32 * c + h < o && (o = 32 * c + h);
                }
                if (32 * c + 31 > a) {
                    for(h = 31; f >>> h == 0;)h--;
                    32 * c + h > a && (a = 32 * c + h);
                }
            }
        }
        return a < o || u < i ? null : Int32Array.from([
            o,
            i,
            a - o + 1,
            u - i + 1
        ]);
    }, t.prototype.getTopLeftOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = 0; r < e.length && 0 === e[r];)r++;
        if (r === e.length) return null;
        for(var n = r / t, o = r % t * 32, i = e[r], a = 0; 0 == (i << 31 - a & 4294967295);)a++;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getBottomRightOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = e.length - 1; r >= 0 && 0 === e[r];)r--;
        if (r < 0) return null;
        for(var n = Math.floor(r / t), o = 32 * Math.floor(r % t), i = e[r], a = 31; i >>> a == 0;)a--;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getRowSize = function() {
        return this.rowSize;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.width === r.width && this.height === r.height && this.rowSize === r.rowSize && $12c6b0ab9da17bee$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        var t = this.width;
        return t = 31 * (t = 31 * (t = 31 * (t = 31 * t + this.width) + this.height) + this.rowSize) + $12c6b0ab9da17bee$var$C.hashCode(this.bits);
    }, t.prototype.toString = function(t, e, r) {
        return void 0 === t && (t = "X "), void 0 === e && (e = "  "), void 0 === r && (r = "\n"), this.buildToString(t, e, r);
    }, t.prototype.buildToString = function(t, e, r) {
        for(var n = new $12c6b0ab9da17bee$var$k, o = 0, i = this.height; o < i; o++){
            for(var a = 0, u = this.width; a < u; a++)n.append(this.get(a, o) ? t : e);
            n.append(r);
        }
        return n.toString();
    }, t.prototype.clone = function() {
        return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
}(), $12c6b0ab9da17bee$var$V = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$U = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$V(e, t), e.getNotFoundInstance = function() {
        return new e;
    }, e.kind = "NotFoundException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$H = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$G = function(t) {
    function e(r) {
        var n = t.call(this, r) || this;
        return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return $12c6b0ab9da17bee$var$H(e, t), e.prototype.getBlackRow = function(t, r) {
        var n = this.getLuminanceSource(), o = n.getWidth();
        null == r || r.getSize() < o ? r = new $12c6b0ab9da17bee$var$S(o) : r.clear(), this.initArrays(o);
        for(var i = n.getRow(t, this.luminances), a = this.buckets, u = 0; u < o; u++)a[(255 & i[u]) >> e.LUMINANCE_SHIFT]++;
        var s = e.estimateBlackPoint(a);
        if (o < 3) for(u = 0; u < o; u++)(255 & i[u]) < s && r.set(u);
        else {
            var c = 255 & i[0], f = 255 & i[1];
            for(u = 1; u < o - 1; u++){
                var h = 255 & i[u + 1];
                (4 * f - c - h) / 2 < s && r.set(u), c = f, f = h;
            }
        }
        return r;
    }, e.prototype.getBlackMatrix = function() {
        var t = this.getLuminanceSource(), r = t.getWidth(), n = t.getHeight(), o = new $12c6b0ab9da17bee$var$x(r, n);
        this.initArrays(r);
        for(var i = this.buckets, a = 1; a < 5; a++)for(var u = Math.floor(n * a / 5), s = t.getRow(u, this.luminances), c = Math.floor(4 * r / 5), f = Math.floor(r / 5); f < c; f++)i[(255 & s[f]) >> e.LUMINANCE_SHIFT]++;
        var h = e.estimateBlackPoint(i), l = t.getMatrix();
        for(a = 0; a < n; a++){
            var d = a * r;
            for(f = 0; f < r; f++)(255 & l[d + f]) < h && o.set(f, a);
        }
        return o;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.prototype.initArrays = function(t) {
        this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
        for(var r = this.buckets, n = 0; n < e.LUMINANCE_BUCKETS; n++)r[n] = 0;
    }, e.estimateBlackPoint = function(t) {
        for(var r = t.length, n = 0, o = 0, i = 0, a = 0; a < r; a++)t[a] > i && (o = a, i = t[a]), t[a] > n && (n = t[a]);
        var u = 0, s = 0;
        for(a = 0; a < r; a++){
            var c = a - o;
            (d = t[a] * c * c) > s && (u = a, s = d);
        }
        if (o > u) {
            var f = o;
            o = u, u = f;
        }
        if (u - o <= r / 16) throw new $12c6b0ab9da17bee$var$U;
        var h = u - 1, l = -1;
        for(a = u - 1; a > o; a--){
            var d, p = a - o;
            (d = p * p * (u - a) * (n - t[a])) > l && (h = a, l = d);
        }
        return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([
        0
    ]), e;
}($12c6b0ab9da17bee$var$y), $12c6b0ab9da17bee$var$X = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$W = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.matrix = null, r;
    }
    return $12c6b0ab9da17bee$var$X(e, t), e.prototype.getBlackMatrix = function() {
        if (null !== this.matrix) return this.matrix;
        var r = this.getLuminanceSource(), n = r.getWidth(), o = r.getHeight();
        if (n >= e.MINIMUM_DIMENSION && o >= e.MINIMUM_DIMENSION) {
            var i = r.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
            0 != (n & e.BLOCK_SIZE_MASK) && a++;
            var u = o >> e.BLOCK_SIZE_POWER;
            0 != (o & e.BLOCK_SIZE_MASK) && u++;
            var s = e.calculateBlackPoints(i, a, u, n, o), c = new $12c6b0ab9da17bee$var$x(n, o);
            e.calculateThresholdForBlock(i, a, u, n, o, s, c), this.matrix = c;
        } else this.matrix = t.prototype.getBlackMatrix.call(this);
        return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.calculateThresholdForBlock = function(t, r, n, o, i, a, u) {
        for(var s = i - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, f = 0; f < n; f++){
            var h = f << e.BLOCK_SIZE_POWER;
            h > s && (h = s);
            for(var l = e.cap(f, 2, n - 3), d = 0; d < r; d++){
                var p = d << e.BLOCK_SIZE_POWER;
                p > c && (p = c);
                for(var g = e.cap(d, 2, r - 3), y = 0, w = -2; w <= 2; w++){
                    var _ = a[l + w];
                    y += _[g - 2] + _[g - 1] + _[g] + _[g + 1] + _[g + 2];
                }
                var v = y / 25;
                e.thresholdBlock(t, p, h, v, o, u);
            }
        }
    }, e.cap = function(t, e, r) {
        return t < e ? e : t > r ? r : t;
    }, e.thresholdBlock = function(t, r, n, o, i, a) {
        for(var u = 0, s = n * i + r; u < e.BLOCK_SIZE; u++, s += i)for(var c = 0; c < e.BLOCK_SIZE; c++)(255 & t[s + c]) <= o && a.set(r + c, n + u);
    }, e.calculateBlackPoints = function(t, r, n, o, i) {
        for(var a = i - e.BLOCK_SIZE, u = o - e.BLOCK_SIZE, s = new Array(n), c = 0; c < n; c++){
            s[c] = new Int32Array(r);
            var f = c << e.BLOCK_SIZE_POWER;
            f > a && (f = a);
            for(var h = 0; h < r; h++){
                var l = h << e.BLOCK_SIZE_POWER;
                l > u && (l = u);
                for(var d = 0, p = 255, g = 0, y = 0, w = f * o + l; y < e.BLOCK_SIZE; y++, w += o){
                    for(var _ = 0; _ < e.BLOCK_SIZE; _++){
                        var v = 255 & t[w + _];
                        d += v, v < p && (p = v), v > g && (g = v);
                    }
                    if (g - p > e.MIN_DYNAMIC_RANGE) for(y++, w += o; y < e.BLOCK_SIZE; y++, w += o)for(_ = 0; _ < e.BLOCK_SIZE; _++)d += 255 & t[w + _];
                }
                var m = d >> 2 * e.BLOCK_SIZE_POWER;
                if (g - p <= e.MIN_DYNAMIC_RANGE && (m = p / 2, c > 0 && h > 0)) {
                    var A = (s[c - 1][h] + 2 * s[c][h - 1] + s[c - 1][h - 1]) / 4;
                    p < A && (m = A);
                }
                s[c][h] = m;
            }
        }
        return s;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = 5 * e.BLOCK_SIZE, e.MIN_DYNAMIC_RANGE = 24, e;
}($12c6b0ab9da17bee$var$G), $12c6b0ab9da17bee$var$j = function() {
    function t(t, e) {
        this.width = t, this.height = e;
    }
    return t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.isCropSupported = function() {
        return !1;
    }, t.prototype.crop = function(t, e, r, n) {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
        return !1;
    }, t.prototype.rotateCounterClockwise = function() {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
        for(var t = new Uint8ClampedArray(this.width), e = new $12c6b0ab9da17bee$var$k, r = 0; r < this.height; r++){
            for(var n = this.getRow(r, t), o = 0; o < this.width; o++){
                var i = 255 & n[o], a = void 0;
                a = i < 64 ? "#" : i < 128 ? "+" : i < 192 ? "." : " ", e.append(a);
            }
            e.append("\n");
        }
        return e.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Y = function(t) {
    function e(e) {
        var r = t.call(this, e.getWidth(), e.getHeight()) || this;
        return r.delegate = e, r;
    }
    return $12c6b0ab9da17bee$var$z(e, t), e.prototype.getRow = function(t, e) {
        for(var r = this.delegate.getRow(t, e), n = this.getWidth(), o = 0; o < n; o++)r[o] = 255 - (255 & r[o]);
        return r;
    }, e.prototype.getMatrix = function() {
        for(var t = this.delegate.getMatrix(), e = this.getWidth() * this.getHeight(), r = new Uint8ClampedArray(e), n = 0; n < e; n++)r[n] = 255 - (255 & t[n]);
        return r;
    }, e.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.delegate.crop(t, r, n, o));
    }, e.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
        return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
        return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
        return new e(this.delegate.rotateCounterClockwise45());
    }, e;
}($12c6b0ab9da17bee$var$j), $12c6b0ab9da17bee$var$Z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$K = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $12c6b0ab9da17bee$var$Z(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d").getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(r.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement(), n = r.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, i = this.canvas.width, a = this.canvas.height, u = Math.ceil(Math.abs(Math.cos(o)) * i + Math.abs(Math.sin(o)) * a), s = Math.ceil(Math.abs(Math.sin(o)) * i + Math.abs(Math.cos(o)) * a);
        return r.width = u, r.height = s, n.translate(u / 2, s / 2), n.rotate(o), n.drawImage(this.canvas, i / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($12c6b0ab9da17bee$var$j), $12c6b0ab9da17bee$var$q = function() {
    function t(t, e, r) {
        this.deviceId = t, this.label = e, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    }, t;
}(), $12c6b0ab9da17bee$var$Q = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $12c6b0ab9da17bee$var$J = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $12c6b0ab9da17bee$var$$ = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$tt = function() {
    function t(t, e, r) {
        void 0 === e && (e = 500), this.reader = t, this.timeBetweenScansMillis = e, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
        get: function() {
            return "undefined" != typeof navigator;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
        get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
        get: function() {
            return !(!this.isMediaDevicesSuported || !navigator.mediaDevices.enumerateDevices);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
        get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        set: function(t) {
            this._timeBetweenDecodingAttempts = t < 0 ? 0 : t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
        get: function() {
            return this._hints;
        },
        set: function(t) {
            this._hints = t || null;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $12c6b0ab9da17bee$var$J(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $12c6b0ab9da17bee$var$$(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.getVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return [
                            2,
                            t.sent().map(function(t) {
                                return new $12c6b0ab9da17bee$var$q(t.deviceId, t.label);
                            })
                        ];
                }
            });
        });
    }, t.prototype.findDeviceById = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var e;
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return (e = r.sent()) ? [
                            2,
                            e.find(function(e) {
                                return e.deviceId === t;
                            })
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.decodeOnceFromVideoDevice(t, e)
                        ];
                    case 1:
                        return [
                            2,
                            r.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnce(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.decodeFromVideoDevice(t, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(n, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeFromStream(n, e, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeContinuously(n, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this.prepareVideoElement(e), this.addVideoSource(r, t), this.videoElement = r, this.stream = t, [
                            4,
                            this.playVideoOnLoadAsync(r)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.playVideoOnLoadAsync = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            return e.playVideoOnLoad(t, function() {
                return r();
            });
        });
    }, t.prototype.playVideoOnLoad = function(t, e) {
        var r = this;
        this.videoEndedListener = function() {
            return r.stopStreams();
        }, this.videoCanPlayListener = function() {
            return r.tryPlayVideo(t);
        }, t.addEventListener("ended", this.videoEndedListener), t.addEventListener("canplay", this.videoCanPlayListener), t.addEventListener("playing", e), this.tryPlayVideo(t);
    }, t.prototype.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && !t.ended && t.readyState > 2;
    }, t.prototype.tryPlayVideo = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.isVideoPlaying(t)) return console.warn("Trying to play video that is already playing."), [
                            2
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            t.play()
                        ];
                    case 2:
                        return e.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return e.sent(), console.warn("It was not possible to play the video."), [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.prototype.decodeFromImage = function(t, e) {
        if (!t && !e) throw new $12c6b0ab9da17bee$var$f("either imageElement with a src set or an url must be provided");
        return e && !t ? this.decodeFromImageUrl(e) : this.decodeFromImageElement(t);
    }, t.prototype.decodeFromVideo = function(t, e) {
        if (!t && !e) throw new $12c6b0ab9da17bee$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrl(e) : this.decodeFromVideoElement(t);
    }, t.prototype.decodeFromVideoContinuously = function(t, e, r) {
        if (void 0 === t && void 0 === e) throw new $12c6b0ab9da17bee$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrlContinuously(e, r) : this.decodeFromVideoElementContinuously(t, r);
    }, t.prototype.decodeFromImageElement = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An image element must be provided.");
        this.reset();
        var e = this.prepareImageElement(t);
        return this.imageElement = e, this.isImageLoaded(e) ? this.decodeOnce(e, !1, !0) : this._decodeOnLoadImage(e);
    }, t.prototype.decodeFromVideoElement = function(t) {
        var e = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideo(e);
    }, t.prototype.decodeFromVideoElementContinuously = function(t, e) {
        var r = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideoContinuously(r, e);
    }, t.prototype._decodeFromVideoElementSetup = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
        this.reset();
        var e = this.prepareVideoElement(t);
        return this.videoElement = e, e;
    }, t.prototype.decodeFromImageUrl = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareImageElement();
        this.imageElement = e;
        var r = this._decodeOnLoadImage(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrl = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareVideoElement(), r = this.decodeFromVideoElement(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(t, e) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var r = this.prepareVideoElement(), n = this.decodeFromVideoElementContinuously(r, e);
        return r.src = t, n;
    }, t.prototype._decodeOnLoadImage = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            e.imageLoadedListener = function() {
                return e.decodeOnce(t, !1, !0).then(r, n);
            }, t.addEventListener("load", e.imageLoadedListener);
        });
    }, t.prototype._decodeOnLoadVideo = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.decodeOnce(t)
                        ];
                    case 2:
                        return [
                            2,
                            e.sent()
                        ];
                }
            });
        });
    }, t.prototype._decodeOnLoadVideoContinuously = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return r.sent(), this.decodeContinuously(t, e), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.prototype.prepareImageElement = function(t) {
        var e;
        return void 0 === t && ((e = document.createElement("img")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "img")), t instanceof HTMLImageElement && (e = t), e;
    }, t.prototype.prepareVideoElement = function(t) {
        var e;
        return t || "undefined" == typeof document || ((e = document.createElement("video")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "video")), t instanceof HTMLVideoElement && (e = t), e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e;
    }, t.prototype.decodeOnce = function(t, e, r) {
        var n = this;
        void 0 === e && (e = !0), void 0 === r && (r = !0), this._stopAsyncDecode = !1;
        var o = function(i, a) {
            if (n._stopAsyncDecode) return a(new $12c6b0ab9da17bee$var$U("Video stream has ended before any code could be detected.")), void (n._stopAsyncDecode = void 0);
            try {
                i(n.decode(t));
            } catch (t) {
                if (e && t instanceof $12c6b0ab9da17bee$var$U || (t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R) && r) return setTimeout(o, n._timeBetweenDecodingAttempts, i, a);
                a(t);
            }
        };
        return new Promise(function(t, e) {
            return o(t, e);
        });
    }, t.prototype.decodeContinuously = function(t, e) {
        var r = this;
        this._stopContinuousDecode = !1;
        var n = function() {
            if (r._stopContinuousDecode) r._stopContinuousDecode = void 0;
            else try {
                var o = r.decode(t);
                e(o, null), setTimeout(n, r.timeBetweenScansMillis);
            } catch (t) {
                e(null, t), (t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$U) && setTimeout(n, r._timeBetweenDecodingAttempts);
            }
        };
        n();
    }, t.prototype.decode = function(t) {
        var e = this.createBinaryBitmap(t);
        return this.decodeBitmap(e);
    }, t.prototype.createBinaryBitmap = function(t) {
        var e = this.getCaptureCanvasContext(t);
        this.drawImageOnCanvas(e, t);
        var r = this.getCaptureCanvas(t), n = new $12c6b0ab9da17bee$var$K(r), o = new $12c6b0ab9da17bee$var$W(n);
        return new $12c6b0ab9da17bee$var$d(o);
    }, t.prototype.getCaptureCanvasContext = function(t) {
        if (!this.captureCanvasContext) {
            var e = this.getCaptureCanvas(t).getContext("2d");
            this.captureCanvasContext = e;
        }
        return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(t) {
        if (!this.captureCanvas) {
            var e = this.createCaptureCanvas(t);
            this.captureCanvas = e;
        }
        return this.captureCanvas;
    }, t.prototype.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this._hints);
    }, t.prototype.createCaptureCanvas = function(t) {
        if ("undefined" == typeof document) return this._destroyCaptureCanvas(), null;
        var e, r, n = document.createElement("canvas");
        return void 0 !== t && (t instanceof HTMLVideoElement ? (e = t.videoWidth, r = t.videoHeight) : t instanceof HTMLImageElement && (e = t.naturalWidth || t.width, r = t.naturalHeight || t.height)), n.style.width = e + "px", n.style.height = r + "px", n.width = e, n.height = r, n;
    }, t.prototype.stopStreams = function() {
        this.stream && (this.stream.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), this.stream = void 0), !1 === this._stopAsyncDecode && this.stopAsyncDecode(), !1 === this._stopContinuousDecode && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
        this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
        this.videoElement && (void 0 !== this.videoEndedListener && this.videoElement.removeEventListener("ended", this.videoEndedListener), void 0 !== this.videoPlayingEventListener && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), void 0 !== this.videoCanPlayListener && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
        this.imageElement && (void 0 !== this.imageLoadedListener && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
        this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.prototype.cleanVideoSource = function(t) {
        try {
            t.srcObject = null;
        } catch (e) {
            t.src = "";
        }
        this.videoElement.removeAttribute("src");
    }, t;
}(), $12c6b0ab9da17bee$var$et = function() {
    function t(t, e, r, n, o, i) {
        void 0 === r && (r = null == e ? 0 : 8 * e.length), void 0 === i && (i = $12c6b0ab9da17bee$var$w.currentTimeMillis()), this.text = t, this.rawBytes = e, this.numBits = r, this.resultPoints = n, this.format = o, this.timestamp = i, this.text = t, this.rawBytes = e, this.numBits = null == r ? null == e ? 0 : 8 * e.length : r, this.resultPoints = n, this.format = o, this.resultMetadata = null, this.timestamp = null == i ? $12c6b0ab9da17bee$var$w.currentTimeMillis() : i;
    }
    return t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
        return this.format;
    }, t.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    }, t.prototype.putMetadata = function(t, e) {
        null === this.resultMetadata && (this.resultMetadata = new Map), this.resultMetadata.set(t, e);
    }, t.prototype.putAllMetadata = function(t) {
        null !== t && (null === this.resultMetadata ? this.resultMetadata = t : this.resultMetadata = new Map(t));
    }, t.prototype.addResultPoints = function(t) {
        var e = this.resultPoints;
        if (null === e) this.resultPoints = t;
        else if (null !== t && t.length > 0) {
            var r = new Array(e.length + t.length);
            $12c6b0ab9da17bee$var$w.arraycopy(e, 0, r, 0, e.length), $12c6b0ab9da17bee$var$w.arraycopy(t, 0, r, e.length, t.length), this.resultPoints = r;
        }
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.toString = function() {
        return this.text;
    }, t;
}();
!function(t) {
    t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
}($12c6b0ab9da17bee$var$D || ($12c6b0ab9da17bee$var$D = {}));
var $12c6b0ab9da17bee$var$rt, $12c6b0ab9da17bee$var$nt = $12c6b0ab9da17bee$var$D;
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
}($12c6b0ab9da17bee$var$rt || ($12c6b0ab9da17bee$var$rt = {}));
var $12c6b0ab9da17bee$var$ot, $12c6b0ab9da17bee$var$it = $12c6b0ab9da17bee$var$rt, $12c6b0ab9da17bee$var$at = function() {
    function t(t, e, r, n, o, i) {
        void 0 === o && (o = -1), void 0 === i && (i = -1), this.rawBytes = t, this.text = e, this.byteSegments = r, this.ecLevel = n, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = i, this.numBits = null == t ? 0 : 8 * t.length;
    }
    return t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.setNumBits = function(t) {
        this.numBits = t;
    }, t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getByteSegments = function() {
        return this.byteSegments;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(t) {
        this.errorsCorrected = t;
    }, t.prototype.getErasures = function() {
        return this.erasures;
    }, t.prototype.setErasures = function(t) {
        this.erasures = t;
    }, t.prototype.getOther = function() {
        return this.other;
    }, t.prototype.setOther = function(t) {
        this.other = t;
    }, t.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    }, t;
}(), $12c6b0ab9da17bee$var$ut = function() {
    function t() {}
    return t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$l;
        return this.logTable[t];
    }, t.addOrSubtract = function(t, e) {
        return t ^ e;
    }, t;
}(), $12c6b0ab9da17bee$var$st = function() {
    function t(t, e) {
        if (0 === e.length) throw new $12c6b0ab9da17bee$var$l;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = Int32Array.from([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $12c6b0ab9da17bee$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        if (0 === t) return this.getCoefficient(0);
        var e, r = this.coefficients;
        if (1 === t) {
            e = 0;
            for(var n = 0, o = r.length; n !== o; n++){
                var i = r[n];
                e = $12c6b0ab9da17bee$var$ut.addOrSubtract(e, i);
            }
            return e;
        }
        e = r[0];
        var a = r.length, u = this.field;
        for(n = 1; n < a; n++)e = $12c6b0ab9da17bee$var$ut.addOrSubtract(u.multiply(t, e), r[n]);
        return e;
    }, t.prototype.addOrSubtract = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $12c6b0ab9da17bee$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = $12c6b0ab9da17bee$var$ut.addOrSubtract(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.multiply = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || e.isZero()) return this.field.getZero();
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = this.field, s = 0; s < n; s++)for(var c = r[s], f = 0; f < i; f++)a[s + f] = $12c6b0ab9da17bee$var$ut.addOrSubtract(a[s + f], u.multiply(c, o[f]));
        return new t(u, a);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return this.field.getZero();
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = this.field, o = new Int32Array(r), i = this.coefficients, a = 0; a < r; a++)o[a] = n.multiply(i[a], e);
        return new t(n, o);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === r) return this.field.getZero();
        for(var n = this.coefficients, o = n.length, i = new Int32Array(o + e), a = this.field, u = 0; u < o; u++)i[u] = a.multiply(n[u], r);
        return new t(a, i);
    }, t.prototype.divide = function(t) {
        if (!this.field.equals(t.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (t.isZero()) throw new $12c6b0ab9da17bee$var$l("Divide by 0");
        for(var e = this.field, r = e.getZero(), n = this, o = t.getCoefficient(t.getDegree()), i = e.inverse(o); n.getDegree() >= t.getDegree() && !n.isZero();){
            var a = n.getDegree() - t.getDegree(), u = e.multiply(n.getCoefficient(n.getDegree()), i), s = t.multiplyByMonomial(a, u), c = e.buildMonomial(a, u);
            r = r.addOrSubtract(c), n = n.addOrSubtract(s);
        }
        return [
            r,
            n
        ];
    }, t.prototype.toString = function() {
        for(var t = "", e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            if (0 !== r) {
                if (r < 0 ? (t += " - ", r = -r) : t.length > 0 && (t += " + "), 0 === e || 1 !== r) {
                    var n = this.field.log(r);
                    0 === n ? t += "1" : 1 === n ? t += "a" : (t += "a^", t += n);
                }
                0 !== e && (1 === e ? t += "x" : (t += "x^", t += e));
            }
        }
        return t;
    }, t;
}(), $12c6b0ab9da17bee$var$ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ft = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$ct(e, t), e.kind = "ArithmeticException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$lt = function(t) {
    function e(e, r, n) {
        var o = t.call(this) || this;
        o.primitive = e, o.size = r, o.generatorBase = n;
        for(var i = new Int32Array(r), a = 1, u = 0; u < r; u++)i[u] = a, (a *= 2) >= r && (a ^= e, a &= r - 1);
        o.expTable = i;
        var s = new Int32Array(r);
        for(u = 0; u < r - 1; u++)s[i[u]] = u;
        return o.logTable = s, o.zero = new $12c6b0ab9da17bee$var$st(o, Int32Array.from([
            0
        ])), o.one = new $12c6b0ab9da17bee$var$st(o, Int32Array.from([
            1
        ])), o;
    }
    return $12c6b0ab9da17bee$var$ht(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $12c6b0ab9da17bee$var$st(this, r);
    }, e.prototype.inverse = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$ft;
        return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
        return this.size;
    }, e.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    }, e.prototype.toString = function() {
        return "GF(0x" + $12c6b0ab9da17bee$var$I.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
        return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
}($12c6b0ab9da17bee$var$ut), $12c6b0ab9da17bee$var$dt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$pt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$dt(e, t), e.kind = "ReedSolomonException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$gt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$yt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$gt(e, t), e.kind = "IllegalStateException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$wt = function() {
    function t(t) {
        this.field = t;
    }
    return t.prototype.decode = function(t, e) {
        for(var r = this.field, n = new $12c6b0ab9da17bee$var$st(r, t), o = new Int32Array(e), i = !0, a = 0; a < e; a++){
            var u = n.evaluateAt(r.exp(a + r.getGeneratorBase()));
            o[o.length - 1 - a] = u, 0 !== u && (i = !1);
        }
        if (!i) {
            var s = new $12c6b0ab9da17bee$var$st(r, o), c = this.runEuclideanAlgorithm(r.buildMonomial(e, 1), s, e), f = c[0], h = c[1], l = this.findErrorLocations(f), d = this.findErrorMagnitudes(h, l);
            for(a = 0; a < l.length; a++){
                var p = t.length - 1 - r.log(l[a]);
                if (p < 0) throw new $12c6b0ab9da17bee$var$pt("Bad error location");
                t[p] = $12c6b0ab9da17bee$var$lt.addOrSubtract(t[p], d[a]);
            }
        }
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = this.field, i = t, a = e, u = o.getZero(), s = o.getOne(); a.getDegree() >= (r / 2 | 0);){
            var c = i, f = u;
            if (u = s, (i = a).isZero()) throw new $12c6b0ab9da17bee$var$pt("r_{i-1} was zero");
            a = c;
            for(var h = o.getZero(), l = i.getCoefficient(i.getDegree()), d = o.inverse(l); a.getDegree() >= i.getDegree() && !a.isZero();){
                var p = a.getDegree() - i.getDegree(), g = o.multiply(a.getCoefficient(a.getDegree()), d);
                h = h.addOrSubtract(o.buildMonomial(p, g)), a = a.addOrSubtract(i.multiplyByMonomial(p, g));
            }
            if (s = h.multiply(u).addOrSubtract(f), a.getDegree() >= i.getDegree()) throw new $12c6b0ab9da17bee$var$yt("Division algorithm failed to reduce polynomial?");
        }
        var y = s.getCoefficient(0);
        if (0 === y) throw new $12c6b0ab9da17bee$var$pt("sigmaTilde(0) was zero");
        var w = o.inverse(y);
        return [
            s.multiplyScalar(w),
            a.multiplyScalar(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        var e = t.getDegree();
        if (1 === e) return Int32Array.from([
            t.getCoefficient(1)
        ]);
        for(var r = new Int32Array(e), n = 0, o = this.field, i = 1; i < o.getSize() && n < e; i++)0 === t.evaluateAt(i) && (r[n] = o.inverse(i), n++);
        if (n !== e) throw new $12c6b0ab9da17bee$var$pt("Error locator degree does not match number of roots");
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e) {
        for(var r = e.length, n = new Int32Array(r), o = this.field, i = 0; i < r; i++){
            for(var a = o.inverse(e[i]), u = 1, s = 0; s < r; s++)if (i !== s) {
                var c = o.multiply(e[s], a), f = 0 == (1 & c) ? 1 | c : -2 & c;
                u = o.multiply(u, f);
            }
            n[i] = o.multiply(t.evaluateAt(a), o.inverse(u)), 0 !== o.getGeneratorBase() && (n[i] = o.multiply(n[i], a));
        }
        return n;
    }, t;
}();
!function(t) {
    t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
}($12c6b0ab9da17bee$var$ot || ($12c6b0ab9da17bee$var$ot = {}));
var $12c6b0ab9da17bee$var$_t = function() {
    function t() {}
    return t.prototype.decode = function(e) {
        this.ddata = e;
        var r = e.getBits(), n = this.extractBits(r), o = this.correctBits(n), i = t.convertBoolArrayToByteArray(o), a = t.getEncodedData(o), u = new $12c6b0ab9da17bee$var$at(i, a, null, null);
        return u.setNumBits(o.length), u;
    }, t.highLevelDecode = function(t) {
        return this.getEncodedData(t);
    }, t.getEncodedData = function(e) {
        for(var r = e.length, n = $12c6b0ab9da17bee$var$ot.UPPER, o = $12c6b0ab9da17bee$var$ot.UPPER, i = "", a = 0; a < r;)if (o === $12c6b0ab9da17bee$var$ot.BINARY) {
            if (r - a < 5) break;
            var u = t.readCode(e, a, 5);
            if (a += 5, 0 === u) {
                if (r - a < 11) break;
                u = t.readCode(e, a, 11) + 31, a += 11;
            }
            for(var s = 0; s < u; s++){
                if (r - a < 8) {
                    a = r;
                    break;
                }
                var c = t.readCode(e, a, 8);
                i += $12c6b0ab9da17bee$var$F.castAsNonUtf8Char(c), a += 8;
            }
            o = n;
        } else {
            var f = o === $12c6b0ab9da17bee$var$ot.DIGIT ? 4 : 5;
            if (r - a < f) break;
            c = t.readCode(e, a, f);
            a += f;
            var h = t.getCharacter(o, c);
            h.startsWith("CTRL_") ? (n = o, o = t.getTable(h.charAt(5)), "L" === h.charAt(6) && (n = o)) : (i += h, o = n);
        }
        return i;
    }, t.getTable = function(t) {
        switch(t){
            case "L":
                return $12c6b0ab9da17bee$var$ot.LOWER;
            case "P":
                return $12c6b0ab9da17bee$var$ot.PUNCT;
            case "M":
                return $12c6b0ab9da17bee$var$ot.MIXED;
            case "D":
                return $12c6b0ab9da17bee$var$ot.DIGIT;
            case "B":
                return $12c6b0ab9da17bee$var$ot.BINARY;
            default:
                return $12c6b0ab9da17bee$var$ot.UPPER;
        }
    }, t.getCharacter = function(e, r) {
        switch(e){
            case $12c6b0ab9da17bee$var$ot.UPPER:
                return t.UPPER_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.LOWER:
                return t.LOWER_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.MIXED:
                return t.MIXED_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.PUNCT:
                return t.PUNCT_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.DIGIT:
                return t.DIGIT_TABLE[r];
            default:
                throw new $12c6b0ab9da17bee$var$yt("Bad table");
        }
    }, t.prototype.correctBits = function(e) {
        var r, n;
        this.ddata.getNbLayers() <= 2 ? (n = 6, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_10) : (n = 12, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_12);
        var o = this.ddata.getNbDatablocks(), i = e.length / n;
        if (i < o) throw new $12c6b0ab9da17bee$var$R;
        for(var a = e.length % n, u = new Int32Array(i), s = 0; s < i; s++, a += n)u[s] = t.readCode(e, a, n);
        try {
            new $12c6b0ab9da17bee$var$wt(r).decode(u, i - o);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
        var c = (1 << n) - 1, f = 0;
        for(s = 0; s < o; s++){
            if (0 === (d = u[s]) || d === c) throw new $12c6b0ab9da17bee$var$R;
            1 !== d && d !== c - 1 || f++;
        }
        var h = new Array(o * n - f), l = 0;
        for(s = 0; s < o; s++){
            var d;
            if (1 === (d = u[s]) || d === c - 1) h.fill(d > 1, l, l + n - 1), l += n - 1;
            else for(var p = n - 1; p >= 0; --p)h[l++] = 0 != (d & 1 << p);
        }
        return h;
    }, t.prototype.extractBits = function(t) {
        var e = this.ddata.isCompact(), r = this.ddata.getNbLayers(), n = (e ? 11 : 14) + 4 * r, o = new Int32Array(n), i = new Array(this.totalBitsInLayer(r, e));
        if (e) for(var a = 0; a < o.length; a++)o[a] = a;
        else {
            var u = n + 1 + 2 * $12c6b0ab9da17bee$var$I.truncDivision($12c6b0ab9da17bee$var$I.truncDivision(n, 2) - 1, 15), s = n / 2, c = $12c6b0ab9da17bee$var$I.truncDivision(u, 2);
            for(a = 0; a < s; a++){
                var f = a + $12c6b0ab9da17bee$var$I.truncDivision(a, 15);
                o[s - a - 1] = c - f - 1, o[s + a] = c + f + 1;
            }
        }
        a = 0;
        for(var h = 0; a < r; a++){
            for(var l = 4 * (r - a) + (e ? 9 : 12), d = 2 * a, p = n - 1 - d, g = 0; g < l; g++)for(var y = 2 * g, w = 0; w < 2; w++)i[h + y + w] = t.get(o[d + w], o[d + g]), i[h + 2 * l + y + w] = t.get(o[d + g], o[p - w]), i[h + 4 * l + y + w] = t.get(o[p - w], o[p - g]), i[h + 6 * l + y + w] = t.get(o[p - g], o[d + w]);
            h += 8 * l;
        }
        return i;
    }, t.readCode = function(t, e, r) {
        for(var n = 0, o = e; o < e + r; o++)n <<= 1, t[o] && (n |= 1);
        return n;
    }, t.readByte = function(e, r) {
        var n = e.length - r;
        return n >= 8 ? t.readCode(e, r, 8) : t.readCode(e, r, n) << 8 - n;
    }, t.convertBoolArrayToByteArray = function(e) {
        for(var r = new Uint8Array((e.length + 7) / 8), n = 0; n < r.length; n++)r[n] = t.readByte(e, 8 * n);
        return r;
    }, t.prototype.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "	",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ], t.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ], t.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ], t;
}(), $12c6b0ab9da17bee$var$vt = function() {
    function t() {}
    return t.round = function(t) {
        return t <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : t >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t + (t < 0 ? -0.5 : .5) | 0;
    }, t.distance = function(t, e, r, n) {
        var o = t - r, i = e - n;
        return Math.sqrt(o * o + i * i);
    }, t.sum = function(t) {
        for(var e = 0, r = 0, n = t.length; r !== n; r++)e += t[r];
        return e;
    }, t;
}(), $12c6b0ab9da17bee$var$mt = function() {
    function t() {}
    return t.floatToIntBits = function(t) {
        return t;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $12c6b0ab9da17bee$var$At = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t.prototype.equals = function(e) {
        if (e instanceof t) {
            var r = e;
            return this.x === r.x && this.y === r.y;
        }
        return !1;
    }, t.prototype.hashCode = function() {
        return 31 * $12c6b0ab9da17bee$var$mt.floatToIntBits(this.x) + $12c6b0ab9da17bee$var$mt.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(t) {
        var e, r, n, o = this.distance(t[0], t[1]), i = this.distance(t[1], t[2]), a = this.distance(t[0], t[2]);
        if (i >= o && i >= a ? (r = t[0], e = t[1], n = t[2]) : a >= i && a >= o ? (r = t[1], e = t[0], n = t[2]) : (r = t[2], e = t[0], n = t[1]), this.crossProductZ(e, r, n) < 0) {
            var u = e;
            e = n, n = u;
        }
        t[0] = e, t[1] = r, t[2] = n;
    }, t.distance = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.x, t.y, e.x, e.y);
    }, t.crossProductZ = function(t, e, r) {
        var n = e.x, o = e.y;
        return (r.x - n) * (t.y - o) - (r.y - o) * (t.x - n);
    }, t;
}(), $12c6b0ab9da17bee$var$Et = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $12c6b0ab9da17bee$var$Ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$It = function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r) || this;
        return a.compact = n, a.nbDatablocks = o, a.nbLayers = i, a;
    }
    return $12c6b0ab9da17bee$var$Ct(e, t), e.prototype.getNbLayers = function() {
        return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
        return this.compact;
    }, e;
}($12c6b0ab9da17bee$var$Et), $12c6b0ab9da17bee$var$St = function() {
    function t(e, r, n, o) {
        this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), null == r && (r = t.INIT_SIZE), null == n && (n = e.getWidth() / 2 | 0), null == o && (o = e.getHeight() / 2 | 0);
        var i = r / 2 | 0;
        if (this.leftInit = n - i, this.rightInit = n + i, this.upInit = o - i, this.downInit = o + i, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new $12c6b0ab9da17bee$var$U;
    }
    return t.prototype.detect = function() {
        for(var t = this.leftInit, e = this.rightInit, r = this.upInit, n = this.downInit, o = !1, i = !0, a = !1, u = !1, s = !1, c = !1, f = !1, h = this.width, l = this.height; i;){
            i = !1;
            for(var d = !0; (d || !u) && e < h;)(d = this.containsBlackPoint(r, n, e, !1)) ? (e++, i = !0, u = !0) : u || e++;
            if (e >= h) {
                o = !0;
                break;
            }
            for(var p = !0; (p || !s) && n < l;)(p = this.containsBlackPoint(t, e, n, !0)) ? (n++, i = !0, s = !0) : s || n++;
            if (n >= l) {
                o = !0;
                break;
            }
            for(var g = !0; (g || !c) && t >= 0;)(g = this.containsBlackPoint(r, n, t, !1)) ? (t--, i = !0, c = !0) : c || t--;
            if (t < 0) {
                o = !0;
                break;
            }
            for(var y = !0; (y || !f) && r >= 0;)(y = this.containsBlackPoint(t, e, r, !0)) ? (r--, i = !0, f = !0) : f || r--;
            if (r < 0) {
                o = !0;
                break;
            }
            i && (a = !0);
        }
        if (!o && a) {
            for(var w = e - t, _ = null, v = 1; null === _ && v < w; v++)_ = this.getBlackPointOnSegment(t, n - v, t + v, n);
            if (null == _) throw new $12c6b0ab9da17bee$var$U;
            var m = null;
            for(v = 1; null === m && v < w; v++)m = this.getBlackPointOnSegment(t, r + v, t + v, r);
            if (null == m) throw new $12c6b0ab9da17bee$var$U;
            var A = null;
            for(v = 1; null === A && v < w; v++)A = this.getBlackPointOnSegment(e, r + v, e - v, r);
            if (null == A) throw new $12c6b0ab9da17bee$var$U;
            var E = null;
            for(v = 1; null === E && v < w; v++)E = this.getBlackPointOnSegment(e, n - v, e - v, n);
            if (null == E) throw new $12c6b0ab9da17bee$var$U;
            return this.centerEdges(E, _, A, m);
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.prototype.getBlackPointOnSegment = function(t, e, r, n) {
        for(var o = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$vt.distance(t, e, r, n)), i = (r - t) / o, a = (n - e) / o, u = this.image, s = 0; s < o; s++){
            var c = $12c6b0ab9da17bee$var$vt.round(t + s * i), f = $12c6b0ab9da17bee$var$vt.round(e + s * a);
            if (u.get(c, f)) return new $12c6b0ab9da17bee$var$At(c, f);
        }
        return null;
    }, t.prototype.centerEdges = function(e, r, n, o) {
        var i = e.getX(), a = e.getY(), u = r.getX(), s = r.getY(), c = n.getX(), f = n.getY(), h = o.getX(), l = o.getY(), d = t.CORR;
        return i < this.width / 2 ? [
            new $12c6b0ab9da17bee$var$At(h - d, l + d),
            new $12c6b0ab9da17bee$var$At(u + d, s + d),
            new $12c6b0ab9da17bee$var$At(c - d, f - d),
            new $12c6b0ab9da17bee$var$At(i + d, a - d)
        ] : [
            new $12c6b0ab9da17bee$var$At(h + d, l + d),
            new $12c6b0ab9da17bee$var$At(u + d, s - d),
            new $12c6b0ab9da17bee$var$At(c - d, f + d),
            new $12c6b0ab9da17bee$var$At(i - d, a - d)
        ];
    }, t.prototype.containsBlackPoint = function(t, e, r, n) {
        var o = this.image;
        if (n) {
            for(var i = t; i <= e; i++)if (o.get(i, r)) return !0;
        } else for(var a = t; a <= e; a++)if (o.get(r, a)) return !0;
        return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
}(), $12c6b0ab9da17bee$var$Ot = function() {
    function t() {}
    return t.checkAndNudgePoints = function(t, e) {
        for(var r = t.getWidth(), n = t.getHeight(), o = !0, i = 0; i < e.length && o; i += 2){
            var a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $12c6b0ab9da17bee$var$U;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
        o = !0;
        for(i = e.length - 2; i >= 0 && o; i -= 2){
            a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $12c6b0ab9da17bee$var$U;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
    }, t;
}(), $12c6b0ab9da17bee$var$Tt = function() {
    function t(t, e, r, n, o, i, a, u, s) {
        this.a11 = t, this.a21 = e, this.a31 = r, this.a12 = n, this.a22 = o, this.a32 = i, this.a13 = a, this.a23 = u, this.a33 = s;
    }
    return t.quadrilateralToQuadrilateral = function(e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y) {
        var w = t.quadrilateralToSquare(e, r, n, o, i, a, u, s);
        return t.squareToQuadrilateral(c, f, h, l, d, p, g, y).times(w);
    }, t.prototype.transformPoints = function(t) {
        for(var e = t.length, r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = 0; h < e; h += 2){
            var l = t[h], d = t[h + 1], p = o * l + u * d + f;
            t[h] = (r * l + i * d + s) / p, t[h + 1] = (n * l + a * d + c) / p;
        }
    }, t.prototype.transformPointsWithValues = function(t, e) {
        for(var r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = t.length, l = 0; l < h; l++){
            var d = t[l], p = e[l], g = o * d + u * p + f;
            t[l] = (r * d + i * p + s) / g, e[l] = (n * d + a * p + c) / g;
        }
    }, t.squareToQuadrilateral = function(e, r, n, o, i, a, u, s) {
        var c = e - n + i - u, f = r - o + a - s;
        if (0 === c && 0 === f) return new t(n - e, i - n, e, o - r, a - o, r, 0, 0, 1);
        var h = n - i, l = u - i, d = o - a, p = s - a, g = h * p - l * d, y = (c * p - l * f) / g, w = (h * f - c * d) / g;
        return new t(n - e + y * n, u - e + w * u, e, o - r + y * o, s - r + w * s, r, y, w, 1);
    }, t.quadrilateralToSquare = function(e, r, n, o, i, a, u, s) {
        return t.squareToQuadrilateral(e, r, n, o, i, a, u, s).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
        return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
        return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
}(), $12c6b0ab9da17bee$var$bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Rt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$bt(e, t), e.prototype.sampleGrid = function(t, e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _) {
        var v = $12c6b0ab9da17bee$var$Tt.quadrilateralToQuadrilateral(n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _);
        return this.sampleGridWithTransform(t, e, r, v);
    }, e.prototype.sampleGridWithTransform = function(t, e, r, n) {
        if (e <= 0 || r <= 0) throw new $12c6b0ab9da17bee$var$U;
        for(var o = new $12c6b0ab9da17bee$var$x(e, r), i = new Float32Array(2 * e), a = 0; a < r; a++){
            for(var u = i.length, s = a + .5, c = 0; c < u; c += 2)i[c] = c / 2 + .5, i[c + 1] = s;
            n.transformPoints(i), $12c6b0ab9da17bee$var$Ot.checkAndNudgePoints(t, i);
            try {
                for(c = 0; c < u; c += 2)t.get(Math.floor(i[c]), Math.floor(i[c + 1])) && o.set(c / 2, a);
            } catch (t) {
                throw new $12c6b0ab9da17bee$var$U;
            }
        }
        return o;
    }, e;
}($12c6b0ab9da17bee$var$Ot), $12c6b0ab9da17bee$var$Nt = function() {
    function t() {}
    return t.setGridSampler = function(e) {
        t.gridSampler = e;
    }, t.getInstance = function() {
        return t.gridSampler;
    }, t.gridSampler = new $12c6b0ab9da17bee$var$Rt, t;
}(), $12c6b0ab9da17bee$var$Dt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.toResultPoint = function() {
        return new $12c6b0ab9da17bee$var$At(this.getX(), this.getY());
    }, t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t;
}(), $12c6b0ab9da17bee$var$Pt = function() {
    function t(t) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            3808,
            476,
            2107,
            1799
        ]), this.image = t;
    }
    return t.prototype.detect = function() {
        return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(t) {
        var e = this.getMatrixCenter(), r = this.getBullsEyeCorners(e);
        if (t) {
            var n = r[0];
            r[0] = r[2], r[2] = n;
        }
        this.extractParameters(r);
        var o = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), i = this.getMatrixCornerPoints(r);
        return new $12c6b0ab9da17bee$var$It(o, i, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(t) {
        if (!(this.isValidPoint(t[0]) && this.isValidPoint(t[1]) && this.isValidPoint(t[2]) && this.isValidPoint(t[3]))) throw new $12c6b0ab9da17bee$var$U;
        var e = 2 * this.nbCenterLayers, r = new Int32Array([
            this.sampleLine(t[0], t[1], e),
            this.sampleLine(t[1], t[2], e),
            this.sampleLine(t[2], t[3], e),
            this.sampleLine(t[3], t[0], e)
        ]);
        this.shift = this.getRotation(r, e);
        for(var n = 0, o = 0; o < 4; o++){
            var i = r[(this.shift + o) % 4];
            this.compact ? (n <<= 7, n += i >> 1 & 127) : (n <<= 10, n += (i >> 2 & 992) + (i >> 1 & 31));
        }
        var a = this.getCorrectedParameterData(n, this.compact);
        this.compact ? (this.nbLayers = 1 + (a >> 6), this.nbDataBlocks = 1 + (63 & a)) : (this.nbLayers = 1 + (a >> 11), this.nbDataBlocks = 1 + (2047 & a));
    }, t.prototype.getRotation = function(t, e) {
        var r = 0;
        t.forEach(function(t, n, o) {
            r = (r << 3) + ((t >> e - 2 << 1) + (1 & t));
        }), r = ((1 & r) << 11) + (r >> 1);
        for(var n = 0; n < 4; n++)if ($12c6b0ab9da17bee$var$I.bitCount(r ^ this.EXPECTED_CORNER_BITS[n]) <= 2) return n;
        throw new $12c6b0ab9da17bee$var$U;
    }, t.prototype.getCorrectedParameterData = function(t, e) {
        var r, n;
        e ? (r = 7, n = 2) : (r = 10, n = 4);
        for(var o = r - n, i = new Int32Array(r), a = r - 1; a >= 0; --a)i[a] = 15 & t, t >>= 4;
        try {
            new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.AZTEC_PARAM).decode(i, o);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$U;
        }
        var u = 0;
        for(a = 0; a < n; a++)u = (u << 4) + i[a];
        return u;
    }, t.prototype.getBullsEyeCorners = function(t) {
        var e = t, r = t, n = t, o = t, i = !0;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var a = this.getFirstDifferent(e, i, 1, -1), u = this.getFirstDifferent(r, i, 1, 1), s = this.getFirstDifferent(n, i, -1, 1), c = this.getFirstDifferent(o, i, -1, -1);
            if (this.nbCenterLayers > 2) {
                var f = this.distancePoint(c, a) * this.nbCenterLayers / (this.distancePoint(o, e) * (this.nbCenterLayers + 2));
                if (f < .75 || f > 1.25 || !this.isWhiteOrBlackRectangle(a, u, s, c)) break;
            }
            e = a, r = u, n = s, o = c, i = !i;
        }
        if (5 !== this.nbCenterLayers && 7 !== this.nbCenterLayers) throw new $12c6b0ab9da17bee$var$U;
        this.compact = 5 === this.nbCenterLayers;
        var h = new $12c6b0ab9da17bee$var$At(e.getX() + .5, e.getY() - .5), l = new $12c6b0ab9da17bee$var$At(r.getX() + .5, r.getY() + .5), d = new $12c6b0ab9da17bee$var$At(n.getX() - .5, n.getY() + .5), p = new $12c6b0ab9da17bee$var$At(o.getX() - .5, o.getY() - .5);
        return this.expandSquare([
            h,
            l,
            d,
            p
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
        var t, e, r, n;
        try {
            t = (s = new $12c6b0ab9da17bee$var$St(this.image).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (a) {
            var o = this.image.getWidth() / 2, i = this.image.getHeight() / 2;
            t = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o + 7, i - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o + 7, i + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o - 7, i + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o - 7, i - 7), !1, -1, -1).toResultPoint();
        }
        var a = $12c6b0ab9da17bee$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $12c6b0ab9da17bee$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4);
        try {
            var s;
            t = (s = new $12c6b0ab9da17bee$var$St(this.image, 15, a, u).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (o) {
            t = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a + 7, u - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a + 7, u + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a - 7, u + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a - 7, u - 7), !1, -1, -1).toResultPoint();
        }
        return a = $12c6b0ab9da17bee$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $12c6b0ab9da17bee$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4), new $12c6b0ab9da17bee$var$Dt(a, u);
    }, t.prototype.getMatrixCornerPoints = function(t) {
        return this.expandSquare(t, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(t, e, r, n, o) {
        var i = $12c6b0ab9da17bee$var$Nt.getInstance(), a = this.getDimension(), u = a / 2 - this.nbCenterLayers, s = a / 2 + this.nbCenterLayers;
        return i.sampleGrid(t, a, a, u, u, s, u, s, s, u, s, e.getX(), e.getY(), r.getX(), r.getY(), n.getX(), n.getY(), o.getX(), o.getY());
    }, t.prototype.sampleLine = function(t, e, r) {
        for(var n = 0, o = this.distanceResultPoint(t, e), i = o / r, a = t.getX(), u = t.getY(), s = i * (e.getX() - t.getX()) / o, c = i * (e.getY() - t.getY()) / o, f = 0; f < r; f++)this.image.get($12c6b0ab9da17bee$var$vt.round(a + f * s), $12c6b0ab9da17bee$var$vt.round(u + f * c)) && (n |= 1 << r - f - 1);
        return n;
    }, t.prototype.isWhiteOrBlackRectangle = function(t, e, r, n) {
        t = new $12c6b0ab9da17bee$var$Dt(t.getX() - 3, t.getY() + 3), e = new $12c6b0ab9da17bee$var$Dt(e.getX() - 3, e.getY() - 3), r = new $12c6b0ab9da17bee$var$Dt(r.getX() + 3, r.getY() - 3), n = new $12c6b0ab9da17bee$var$Dt(n.getX() + 3, n.getY() + 3);
        var o = this.getColor(n, t);
        if (0 === o) return !1;
        var i = this.getColor(t, e);
        return i === o && (i = this.getColor(e, r)) === o && (i = this.getColor(r, n)) === o;
    }, t.prototype.getColor = function(t, e) {
        for(var r = this.distancePoint(t, e), n = (e.getX() - t.getX()) / r, o = (e.getY() - t.getY()) / r, i = 0, a = t.getX(), u = t.getY(), s = this.image.get(t.getX(), t.getY()), c = Math.ceil(r), f = 0; f < c; f++)a += n, u += o, this.image.get($12c6b0ab9da17bee$var$vt.round(a), $12c6b0ab9da17bee$var$vt.round(u)) !== s && i++;
        var h = i / r;
        return h > .1 && h < .9 ? 0 : h <= .1 === s ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(t, e, r, n) {
        for(var o = t.getX() + r, i = t.getY() + n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r, i += n;
        for(o -= r, i -= n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r;
        for(o -= r; this.isValid(o, i) && this.image.get(o, i) === e;)i += n;
        return new $12c6b0ab9da17bee$var$Dt(o, i -= n);
    }, t.prototype.expandSquare = function(t, e, r) {
        var n = r / (2 * e), o = t[0].getX() - t[2].getX(), i = t[0].getY() - t[2].getY(), a = (t[0].getX() + t[2].getX()) / 2, u = (t[0].getY() + t[2].getY()) / 2, s = new $12c6b0ab9da17bee$var$At(a + n * o, u + n * i), c = new $12c6b0ab9da17bee$var$At(a - n * o, u - n * i);
        return o = t[1].getX() - t[3].getX(), i = t[1].getY() - t[3].getY(), a = (t[1].getX() + t[3].getX()) / 2, u = (t[1].getY() + t[3].getY()) / 2, [
            s,
            new $12c6b0ab9da17bee$var$At(a + n * o, u + n * i),
            c,
            new $12c6b0ab9da17bee$var$At(a - n * o, u - n * i)
        ];
    }, t.prototype.isValid = function(t, e) {
        return t >= 0 && t < this.image.getWidth() && e > 0 && e < this.image.getHeight();
    }, t.prototype.isValidPoint = function(t) {
        var e = $12c6b0ab9da17bee$var$vt.round(t.getX()), r = $12c6b0ab9da17bee$var$vt.round(t.getY());
        return this.isValid(e, r);
    }, t.prototype.distancePoint = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.distanceResultPoint = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.getDimension = function() {
        return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * ($12c6b0ab9da17bee$var$I.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
}(), $12c6b0ab9da17bee$var$Mt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        void 0 === e && (e = null);
        var r = null, n = new $12c6b0ab9da17bee$var$Pt(t.getBlackMatrix()), o = null, i = null;
        try {
            o = (a = n.detectMirror(!1)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $12c6b0ab9da17bee$var$_t).decode(a);
        } catch (t) {
            r = t;
        }
        if (null == i) try {
            var a;
            o = (a = n.detectMirror(!0)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $12c6b0ab9da17bee$var$_t).decode(a);
        } catch (t) {
            if (null != r) throw r;
            throw t;
        }
        var u = new $12c6b0ab9da17bee$var$et(i.getText(), i.getRawBytes(), i.getNumBits(), o, $12c6b0ab9da17bee$var$nt.AZTEC, $12c6b0ab9da17bee$var$w.currentTimeMillis()), s = i.getByteSegments();
        null != s && u.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, s);
        var c = i.getECLevel();
        return null != c && u.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, c), u;
    }, t.prototype.reportFoundResultPoints = function(t, e) {
        if (null != t) {
            var r = t.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
            null != r && e.forEach(function(t, e, n) {
                r.foundPossibleResultPoint(t);
            });
        }
    }, t.prototype.reset = function() {}, t;
}(), $12c6b0ab9da17bee$var$Bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Mt, e) || this;
    }
    $12c6b0ab9da17bee$var$Bt(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$Lt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        try {
            return this.doDecode(t, e);
        } catch (c) {
            if (e && !0 === e.get($12c6b0ab9da17bee$var$T.TRY_HARDER) && t.isRotateSupported()) {
                var r = t.rotateCounterClockwise(), n = this.doDecode(r, e), o = n.getResultMetadata(), i = 270;
                null !== o && !0 === o.get($12c6b0ab9da17bee$var$it.ORIENTATION) && (i += o.get($12c6b0ab9da17bee$var$it.ORIENTATION) % 360), n.putMetadata($12c6b0ab9da17bee$var$it.ORIENTATION, i);
                var a = n.getResultPoints();
                if (null !== a) for(var u = r.getHeight(), s = 0; s < a.length; s++)a[s] = new $12c6b0ab9da17bee$var$At(u - a[s].getY() - 1, a[s].getX());
                return n;
            }
            throw new $12c6b0ab9da17bee$var$U;
        }
    }, t.prototype.reset = function() {}, t.prototype.doDecode = function(t, e) {
        var r, n = t.getWidth(), o = t.getHeight(), i = new $12c6b0ab9da17bee$var$S(n), a = e && !0 === e.get($12c6b0ab9da17bee$var$T.TRY_HARDER), u = Math.max(1, o >> (a ? 8 : 5));
        r = a ? o : 15;
        for(var s = Math.trunc(o / 2), c = 0; c < r; c++){
            var f = Math.trunc((c + 1) / 2), h = s + u * (0 == (1 & c) ? f : -f);
            if (h < 0 || h >= o) break;
            try {
                i = t.getBlackRow(h, i);
            } catch (t) {
                continue;
            }
            for(var l = function(t) {
                if (1 === t && (i.reverse(), e && !0 === e.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK))) {
                    var r = new Map;
                    e.forEach(function(t, e) {
                        return r.set(e, t);
                    }), r.delete($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK), e = r;
                }
                try {
                    var o = d.decodeRow(h, i, e);
                    if (1 === t) {
                        o.putMetadata($12c6b0ab9da17bee$var$it.ORIENTATION, 180);
                        var a = o.getResultPoints();
                        null !== a && (a[0] = new $12c6b0ab9da17bee$var$At(n - a[0].getX() - 1, a[0].getY()), a[1] = new $12c6b0ab9da17bee$var$At(n - a[1].getX() - 1, a[1].getY()));
                    }
                    return {
                        value: o
                    };
                } catch (t) {}
            }, d = this, p = 0; p < 2; p++){
                var g = l(p);
                if ("object" == typeof g) return g.value;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.recordPattern = function(t, e, r) {
        for(var n = r.length, o = 0; o < n; o++)r[o] = 0;
        var i = t.getSize();
        if (e >= i) throw new $12c6b0ab9da17bee$var$U;
        for(var a = !t.get(e), u = 0, s = e; s < i;){
            if (t.get(s) !== a) r[u]++;
            else {
                if (++u === n) break;
                r[u] = 1, a = !a;
            }
            s++;
        }
        if (u !== n && (u !== n - 1 || s !== i)) throw new $12c6b0ab9da17bee$var$U;
    }, t.recordPatternInReverse = function(e, r, n) {
        for(var o = n.length, i = e.get(r); r > 0 && o >= 0;)e.get(--r) !== i && (o--, i = !i);
        if (o >= 0) throw new $12c6b0ab9da17bee$var$U;
        t.recordPattern(e, r + 1, n);
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return Number.POSITIVE_INFINITY;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return Number.POSITIVE_INFINITY;
            s += l;
        }
        return s / o;
    }, t;
}(), $12c6b0ab9da17bee$var$Ft = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$kt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Ft(e, t), e.findStartPattern = function(t) {
        for(var r = t.getSize(), n = t.getNextSet(0), o = 0, i = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), a = n, u = !1, s = n; s < r; s++)if (t.get(s) !== u) i[o]++;
        else {
            if (5 === o) {
                for(var c = e.MAX_AVG_VARIANCE, f = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++){
                    var l = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
                    l < c && (c = l, f = h);
                }
                if (f >= 0 && t.isRange(Math.max(0, a - (s - a) / 2), a, !1)) return Int32Array.from([
                    a,
                    s,
                    f
                ]);
                a += i[0] + i[1], (i = i.slice(2, i.length - 1))[o - 1] = 0, i[o] = 0, o--;
            } else o++;
            i[o] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeCode = function(t, r, n) {
        $12c6b0ab9da17bee$var$Lt.recordPattern(t, n, r);
        for(var o = e.MAX_AVG_VARIANCE, i = -1, a = 0; a < e.CODE_PATTERNS.length; a++){
            var u = e.CODE_PATTERNS[a], s = this.patternMatchVariance(r, u, e.MAX_INDIVIDUAL_VARIANCE);
            s < o && (o = s, i = a);
        }
        if (i >= 0) return i;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.decodeRow = function(t, r, n) {
        var o, i = n && !0 === n.get($12c6b0ab9da17bee$var$T.ASSUME_GS1), a = e.findStartPattern(r), u = a[2], s = 0, c = new Uint8Array(20);
        switch(c[s++] = u, u){
            case e.CODE_START_A:
                o = e.CODE_CODE_A;
                break;
            case e.CODE_START_B:
                o = e.CODE_CODE_B;
                break;
            case e.CODE_START_C:
                o = e.CODE_CODE_C;
                break;
            default:
                throw new $12c6b0ab9da17bee$var$R;
        }
        for(var f = !1, h = !1, l = "", d = a[0], p = a[1], y = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), w = 0, _ = 0, v = u, m = 0, A = !0, E = !1, C = !1; !f;){
            var I = h;
            switch(h = !1, w = _, _ = e.decodeCode(r, y, p), c[s++] = _, _ !== e.CODE_STOP && (A = !0), _ !== e.CODE_STOP && (v += ++m * _), d = p, p += y.reduce(function(t, e) {
                return t + e;
            }, 0), _){
                case e.CODE_START_A:
                case e.CODE_START_B:
                case e.CODE_START_C:
                    throw new $12c6b0ab9da17bee$var$R;
            }
            switch(o){
                case e.CODE_CODE_A:
                    if (_ < 64) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else if (_ < 96) l += C === E ? String.fromCharCode(_ - 64) : String.fromCharCode(_ + 64), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_A:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_B:
                    if (_ < 96) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_B:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_C:
                    if (_ < 100) _ < 10 && (l += "0"), l += _;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
            }
            I && (o = o === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
        }
        var S = p - d;
        if (p = r.getNextUnset(p), !r.isRange(p, Math.min(r.getSize(), p + (p - d) / 2), !1)) throw new $12c6b0ab9da17bee$var$U;
        if ((v -= m * w) % 103 !== w) throw new $12c6b0ab9da17bee$var$g;
        var O = l.length;
        if (0 === O) throw new $12c6b0ab9da17bee$var$U;
        O > 0 && A && (l = o === e.CODE_CODE_C ? l.substring(0, O - 2) : l.substring(0, O - 1));
        for(var b = (a[1] + a[0]) / 2, N = d + S / 2, D = c.length, P = new Uint8Array(D), M = 0; M < D; M++)P[M] = c[M];
        var B = [
            new $12c6b0ab9da17bee$var$At(b, t),
            new $12c6b0ab9da17bee$var$At(N, t)
        ];
        return new $12c6b0ab9da17bee$var$et(l, P, 0, B, $12c6b0ab9da17bee$var$nt.CODE_128, (new Date).getTime());
    }, e.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ], e.MAX_AVG_VARIANCE = .25, e.MAX_INDIVIDUAL_VARIANCE = .7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$xt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Vt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ut = function(t) {
    function e(e, r) {
        void 0 === e && (e = !1), void 0 === r && (r = !1);
        var n = t.call(this) || this;
        return n.usingCheckDigit = e, n.extendedMode = r, n.decodeRowResult = "", n.counters = new Int32Array(9), n;
    }
    return $12c6b0ab9da17bee$var$xt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.counters;
        s.fill(0), this.decodeRowResult = "";
        var c, f, h = e.findAsteriskPattern(r, s), l = r.getNextSet(h[1]), d = r.getSize();
        do {
            e.recordPattern(r, l, s);
            var p = e.toNarrowWidePattern(s);
            if (p < 0) throw new $12c6b0ab9da17bee$var$U;
            c = e.patternToChar(p), this.decodeRowResult += c, f = l;
            try {
                for(var y = (o = void 0, $12c6b0ab9da17bee$var$Vt(s)), w = y.next(); !w.done; w = y.next())l += w.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (i = y.return) && i.call(y);
                } finally{
                    if (o) throw o.error;
                }
            }
            l = r.getNextSet(l);
        }while ("*" !== c);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var _, v = 0;
        try {
            for(var m = $12c6b0ab9da17bee$var$Vt(s), A = m.next(); !A.done; A = m.next())v += A.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (u = m.return) && u.call(m);
            } finally{
                if (a) throw a.error;
            }
        }
        if (l !== d && 2 * (l - f - v) < v) throw new $12c6b0ab9da17bee$var$U;
        if (this.usingCheckDigit) {
            for(var E = this.decodeRowResult.length - 1, C = 0, I = 0; I < E; I++)C += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(I));
            if (this.decodeRowResult.charAt(E) !== e.ALPHABET_STRING.charAt(C % 43)) throw new $12c6b0ab9da17bee$var$g;
            this.decodeRowResult = this.decodeRowResult.substring(0, E);
        }
        if (0 === this.decodeRowResult.length) throw new $12c6b0ab9da17bee$var$U;
        _ = this.extendedMode ? e.decodeExtended(this.decodeRowResult) : this.decodeRowResult;
        var S = (h[1] + h[0]) / 2, O = f + v / 2;
        return new $12c6b0ab9da17bee$var$et(_, null, 0, [
            new $12c6b0ab9da17bee$var$At(S, t),
            new $12c6b0ab9da17bee$var$At(O, t)
        ], $12c6b0ab9da17bee$var$nt.CODE_39, (new Date).getTime());
    }, e.findAsteriskPattern = function(t, r) {
        for(var n = t.getSize(), o = t.getNextSet(0), i = 0, a = o, u = !1, s = r.length, c = o; c < n; c++)if (t.get(c) !== u) r[i]++;
        else {
            if (i === s - 1) {
                if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, a - Math.floor((c - a) / 2)), a, !1)) return [
                    a,
                    c
                ];
                a += r[0] + r[1], r.copyWithin(0, 2, 2 + i - 1), r[i - 1] = 0, r[i] = 0, i--;
            } else i++;
            r[i] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.toNarrowWidePattern = function(t) {
        var e, r, n, o = t.length, i = 0;
        do {
            var a = 2147483647;
            try {
                for(var u = (e = void 0, $12c6b0ab9da17bee$var$Vt(t)), s = u.next(); !s.done; s = u.next())(l = s.value) < a && l > i && (a = l);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (r = u.return) && r.call(u);
                } finally{
                    if (e) throw e.error;
                }
            }
            i = a, n = 0;
            for(var c = 0, f = 0, h = 0; h < o; h++)(l = t[h]) > i && (f |= 1 << o - 1 - h, n++, c += l);
            if (3 === n) {
                for(h = 0; h < o && n > 0; h++){
                    var l;
                    if ((l = t[h]) > i && (n--, 2 * l >= c)) return -1;
                }
                return f;
            }
        }while (n > 3);
        return -1;
    }, e.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        if (t === e.ASTERISK_ENCODING) return "*";
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if ("+" === o || "$" === o || "%" === o || "/" === o) {
                var i = t.charAt(n + 1), a = "\0";
                switch(o){
                    case "+":
                        if (!(i >= "A" && i <= "Z")) throw new $12c6b0ab9da17bee$var$R;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "$":
                        if (!(i >= "A" && i <= "Z")) throw new $12c6b0ab9da17bee$var$R;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "%":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\0";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if ("X" !== i && "Y" !== i && "Z" !== i) throw new $12c6b0ab9da17bee$var$R;
                            a = "\x7f";
                        }
                        break;
                    case "/":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $12c6b0ab9da17bee$var$R;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
        52,
        289,
        97,
        352,
        49,
        304,
        112,
        37,
        292,
        100,
        265,
        73,
        328,
        25,
        280,
        88,
        13,
        268,
        76,
        28,
        259,
        67,
        322,
        19,
        274,
        82,
        7,
        262,
        70,
        22,
        385,
        193,
        448,
        145,
        400,
        208,
        133,
        388,
        196,
        168,
        162,
        138,
        42
    ], e.ASTERISK_ENCODING = 148, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$Ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Gt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Xt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.narrowLineWidth = -1, e;
    }
    return $12c6b0ab9da17bee$var$Ht(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a = this.decodeStart(r), u = this.decodeEnd(r), s = new $12c6b0ab9da17bee$var$k;
        e.decodeMiddle(r, a[1], u[0], s);
        var c = s.toString(), f = null;
        null != n && (f = n.get($12c6b0ab9da17bee$var$T.ALLOWED_LENGTHS)), null == f && (f = e.DEFAULT_ALLOWED_LENGTHS);
        var h = c.length, l = !1, d = 0;
        try {
            for(var p = $12c6b0ab9da17bee$var$Gt(f), g = p.next(); !g.done; g = p.next()){
                var y = g.value;
                if (h === y) {
                    l = !0;
                    break;
                }
                y > d && (d = y);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        if (!l && h > d && (l = !0), !l) throw new $12c6b0ab9da17bee$var$R;
        var w = [
            new $12c6b0ab9da17bee$var$At(a[1], t),
            new $12c6b0ab9da17bee$var$At(u[0], t)
        ];
        return new $12c6b0ab9da17bee$var$et(c, null, 0, w, $12c6b0ab9da17bee$var$nt.ITF, (new Date).getTime());
    }, e.decodeMiddle = function(t, r, n, o) {
        var i = new Int32Array(10), a = new Int32Array(5), u = new Int32Array(5);
        for(i.fill(0), a.fill(0), u.fill(0); r < n;){
            $12c6b0ab9da17bee$var$Lt.recordPattern(t, r, i);
            for(var s = 0; s < 5; s++){
                var c = 2 * s;
                a[s] = i[c], u[s] = i[c + 1];
            }
            var f = e.decodeDigit(a);
            o.append(f.toString()), f = this.decodeDigit(u), o.append(f.toString()), i.forEach(function(t) {
                r += t;
            });
        }
    }, e.prototype.decodeStart = function(t) {
        var r = e.skipWhiteSpace(t), n = e.findGuardPattern(t, r, e.START_PATTERN);
        return this.narrowLineWidth = (n[1] - n[0]) / 4, this.validateQuietZone(t, n[0]), n;
    }, e.prototype.validateQuietZone = function(t, e) {
        var r = 10 * this.narrowLineWidth;
        r = r < e ? r : e;
        for(var n = e - 1; r > 0 && n >= 0 && !t.get(n); n--)r--;
        if (0 !== r) throw new $12c6b0ab9da17bee$var$U;
    }, e.skipWhiteSpace = function(t) {
        var e = t.getSize(), r = t.getNextSet(0);
        if (r === e) throw new $12c6b0ab9da17bee$var$U;
        return r;
    }, e.prototype.decodeEnd = function(t) {
        t.reverse();
        try {
            var r = e.skipWhiteSpace(t), n = void 0;
            try {
                n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[0]);
            } catch (o) {
                o instanceof $12c6b0ab9da17bee$var$U && (n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[1]));
            }
            this.validateQuietZone(t, n[0]);
            var o = n[0];
            return n[0] = t.getSize() - n[1], n[1] = t.getSize() - o, n;
        } finally{
            t.reverse();
        }
    }, e.findGuardPattern = function(t, r, n) {
        var o = n.length, i = new Int32Array(o), a = t.getSize(), u = !1, s = 0, c = r;
        i.fill(0);
        for(var f = r; f < a; f++)if (t.get(f) !== u) i[s]++;
        else {
            if (s === o - 1) {
                if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, n, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return [
                    c,
                    f
                ];
                c += i[0] + i[1], $12c6b0ab9da17bee$var$w.arraycopy(i, 2, i, 0, s - 1), i[s - 1] = 0, i[s] = 0, s--;
            } else s++;
            i[s] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeDigit = function(t) {
        for(var r = e.MAX_AVG_VARIANCE, n = -1, o = e.PATTERNS.length, i = 0; i < o; i++){
            var a = e.PATTERNS[i], u = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(t, a, e.MAX_INDIVIDUAL_VARIANCE);
            u < r ? (r = u, n = i) : u === r && (n = -1);
        }
        if (n >= 0) return n % 10;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ])
    ], e.MAX_AVG_VARIANCE = .38, e.MAX_INDIVIDUAL_VARIANCE = .5, e.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ], e.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]), e.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ])
    ], e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$Wt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$jt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.decodeRowStringBuffer = "", e;
    }
    return $12c6b0ab9da17bee$var$Wt(e, t), e.findStartGuardPattern = function(t) {
        for(var r, n = !1, o = 0, i = Int32Array.from([
            0,
            0,
            0
        ]); !n;){
            i = Int32Array.from([
                0,
                0,
                0
            ]);
            var a = (r = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, i))[0], u = a - ((o = r[1]) - a);
            u >= 0 && (n = t.isRange(u, a, !1));
        }
        return r;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, e, r, n) {
        return this.findGuardPattern(t, e, r, n, new Int32Array(n.length));
    }, e.findGuardPattern = function(t, r, n, o, i) {
        for(var a = t.getSize(), u = 0, s = r = n ? t.getNextUnset(r) : t.getNextSet(r), c = o.length, f = n, h = r; h < a; h++)if (t.get(h) !== f) i[u]++;
        else {
            if (u === c - 1) {
                if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return Int32Array.from([
                    s,
                    h
                ]);
                s += i[0] + i[1];
                for(var l = i.slice(2, i.length - 1), d = 0; d < u - 1; d++)i[d] = l[d];
                i[u - 1] = 0, i[u] = 0, u--;
            } else u++;
            i[u] = 1, f = !f;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeDigit = function(t, r, n, o) {
        this.recordPattern(t, n, r);
        for(var i = this.MAX_AVG_VARIANCE, a = -1, u = o.length, s = 0; s < u; s++){
            var c = o[s], f = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(r, c, e.MAX_INDIVIDUAL_VARIANCE);
            f < i && (i = f, a = s);
        }
        if (a >= 0) return a;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.MAX_AVG_VARIANCE = .48, e.MAX_INDIVIDUAL_VARIANCE = .7, e.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]), e.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]), e.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ], e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Yt = function() {
    function t() {
        this.CHECK_DIGIT_ENCODINGS = [
            24,
            20,
            18,
            17,
            12,
            6,
            3,
            10,
            9,
            5
        ], this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $12c6b0ab9da17bee$var$At((n[0] + n[1]) / 2, e),
            new $12c6b0ab9da17bee$var$At(i, e)
        ], c = new $12c6b0ab9da17bee$var$et(a, null, 0, s, $12c6b0ab9da17bee$var$nt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(e, r, n) {
        var o, i, a = this.decodeMiddleCounters;
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = e.getSize(), s = r[1], c = 0, f = 0; f < 5 && s < u; f++){
            var h = $12c6b0ab9da17bee$var$jt.decodeDigit(e, a, s, $12c6b0ab9da17bee$var$jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $12c6b0ab9da17bee$var$zt(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 4 - f), 4 !== f && (s = e.getNextSet(s), s = e.getNextUnset(s));
        }
        if (5 !== n.length) throw new $12c6b0ab9da17bee$var$U;
        var p = this.determineCheckDigit(c);
        if (t.extensionChecksum(n.toString()) !== p) throw new $12c6b0ab9da17bee$var$U;
        return s;
    }, t.extensionChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 2; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        r *= 3;
        for(n = e - 1; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        return (r *= 3) % 10;
    }, t.prototype.determineCheckDigit = function(t) {
        for(var e = 0; e < 10; e++)if (t === this.CHECK_DIGIT_ENCODINGS[e]) return e;
        throw new $12c6b0ab9da17bee$var$U;
    }, t.parseExtensionString = function(e) {
        if (5 !== e.length) return null;
        var r = t.parseExtension5String(e);
        return null == r ? null : new Map([
            [
                $12c6b0ab9da17bee$var$it.SUGGESTED_PRICE,
                r
            ]
        ]);
    }, t.parseExtension5String = function(t) {
        var e;
        switch(t.charAt(0)){
            case "0":
                e = "\xa3";
                break;
            case "5":
                e = "$";
                break;
            case "9":
                switch(t){
                    case "90000":
                        return null;
                    case "99991":
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                e = "";
                break;
            default:
                e = "";
        }
        var r = parseInt(t.substring(1)), n = r % 100;
        return e + (r / 100).toString() + "." + (n < 10 ? "0" + n : n.toString());
    }, t;
}(), $12c6b0ab9da17bee$var$Zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Kt = function() {
    function t() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $12c6b0ab9da17bee$var$At((n[0] + n[1]) / 2, e),
            new $12c6b0ab9da17bee$var$At(i, e)
        ], c = new $12c6b0ab9da17bee$var$et(a, null, 0, s, $12c6b0ab9da17bee$var$nt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i = this.decodeMiddleCounters;
        i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
        for(var a = t.getSize(), u = e[1], s = 0, c = 0; c < 2 && u < a; c++){
            var f = $12c6b0ab9da17bee$var$jt.decodeDigit(t, i, u, $12c6b0ab9da17bee$var$jt.L_AND_G_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + f % 10);
            try {
                for(var h = (n = void 0, $12c6b0ab9da17bee$var$Zt(i)), l = h.next(); !l.done; l = h.next())u += l.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    l && !l.done && (o = h.return) && o.call(h);
                } finally{
                    if (n) throw n.error;
                }
            }
            f >= 10 && (s |= 1 << 1 - c), 1 !== c && (u = t.getNextSet(u), u = t.getNextUnset(u));
        }
        if (2 !== r.length) throw new $12c6b0ab9da17bee$var$U;
        if (parseInt(r.toString()) % 4 !== s) throw new $12c6b0ab9da17bee$var$U;
        return u;
    }, t.parseExtensionString = function(t) {
        return 2 !== t.length ? null : new Map([
            [
                $12c6b0ab9da17bee$var$it.ISSUE_NUMBER,
                parseInt(t)
            ]
        ]);
    }, t;
}(), $12c6b0ab9da17bee$var$qt = function() {
    function t() {}
    return t.decodeRow = function(t, e, r) {
        var n = $12c6b0ab9da17bee$var$jt.findGuardPattern(e, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            return (new $12c6b0ab9da17bee$var$Yt).decodeRow(t, e, n);
        } catch (r) {
            return (new $12c6b0ab9da17bee$var$Kt).decodeRow(t, e, n);
        }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]), t;
}(), $12c6b0ab9da17bee$var$Qt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Jt = function(t) {
    function e() {
        var r = t.call(this) || this;
        r.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(t) {
            return Int32Array.from(t);
        });
        for(var n = 10; n < 20; n++){
            for(var o = e.L_PATTERNS[n - 10], i = new Int32Array(o.length), a = 0; a < o.length; a++)i[a] = o[o.length - a - 1];
            e.L_AND_G_PATTERNS[n] = i;
        }
        return r;
    }
    return $12c6b0ab9da17bee$var$Qt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o = e.findStartGuardPattern(r), i = null == n ? null : n.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
        if (null != i) {
            var a = new $12c6b0ab9da17bee$var$At((o[0] + o[1]) / 2, t);
            i.foundPossibleResultPoint(a);
        }
        var u = this.decodeMiddle(r, o, this.decodeRowStringBuffer), s = u.rowOffset, c = u.resultString;
        if (null != i) {
            var f = new $12c6b0ab9da17bee$var$At(s, t);
            i.foundPossibleResultPoint(f);
        }
        var h = e.decodeEnd(r, s);
        if (null != i) {
            var l = new $12c6b0ab9da17bee$var$At((h[0] + h[1]) / 2, t);
            i.foundPossibleResultPoint(l);
        }
        var d = h[1], p = d + (d - h[0]);
        if (p >= r.getSize() || !r.isRange(d, p, !1)) throw new $12c6b0ab9da17bee$var$U;
        var y = c.toString();
        if (y.length < 8) throw new $12c6b0ab9da17bee$var$R;
        if (!e.checkChecksum(y)) throw new $12c6b0ab9da17bee$var$g;
        var w = (o[1] + o[0]) / 2, _ = (h[1] + h[0]) / 2, v = this.getBarcodeFormat(), m = [
            new $12c6b0ab9da17bee$var$At(w, t),
            new $12c6b0ab9da17bee$var$At(_, t)
        ], A = new $12c6b0ab9da17bee$var$et(y, null, 0, m, v, (new Date).getTime()), E = 0;
        try {
            var C = $12c6b0ab9da17bee$var$qt.decodeRow(t, r, h[1]);
            A.putMetadata($12c6b0ab9da17bee$var$it.UPC_EAN_EXTENSION, C.getText()), A.putAllMetadata(C.getResultMetadata()), A.addResultPoints(C.getResultPoints()), E = C.getText().length;
        } catch (t) {}
        var I = null == n ? null : n.get($12c6b0ab9da17bee$var$T.ALLOWED_EAN_EXTENSIONS);
        if (null != I) {
            var S = !1;
            for(var O in I)if (E.toString() === O) {
                S = !0;
                break;
            }
            if (!S) throw new $12c6b0ab9da17bee$var$U;
        }
        return v === $12c6b0ab9da17bee$var$nt.EAN_13 || $12c6b0ab9da17bee$var$nt.UPC_A, A;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
}($12c6b0ab9da17bee$var$jt), $12c6b0ab9da17bee$var$$t = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$te = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ee = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $12c6b0ab9da17bee$var$$t(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a, u, s = this.decodeMiddleCounters;
        s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
        for(var c = t.getSize(), f = r[1], h = 0, l = 0; l < 6 && f < c; l++){
            var d = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, s, f, $12c6b0ab9da17bee$var$Jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d % 10);
            try {
                for(var p = (o = void 0, $12c6b0ab9da17bee$var$te(s)), g = p.next(); !g.done; g = p.next())f += g.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (i = p.return) && i.call(p);
                } finally{
                    if (o) throw o.error;
                }
            }
            d >= 10 && (h |= 1 << 5 - l);
        }
        n = e.determineFirstDigit(n, h), f = $12c6b0ab9da17bee$var$Jt.findGuardPattern(t, f, !0, $12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN, new Int32Array($12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(l = 0; l < 6 && f < c; l++){
            d = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, s, f, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d);
            try {
                for(var y = (a = void 0, $12c6b0ab9da17bee$var$te(s)), w = y.next(); !w.done; w = y.next())f += w.value;
            } catch (t) {
                a = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (u = y.return) && u.call(y);
                } finally{
                    if (a) throw a.error;
                }
            }
        }
        return {
            rowOffset: f,
            resultString: n
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.EAN_13;
    }, e.determineFirstDigit = function(t, e) {
        for(var r = 0; r < 10; r++)if (e === this.FIRST_DIGIT_ENCODINGS[r]) return t = String.fromCharCode("0".charCodeAt(0) + r) + t;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.FIRST_DIGIT_ENCODINGS = [
        0,
        11,
        13,
        14,
        19,
        25,
        28,
        21,
        22,
        26
    ], e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$re = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ne = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$oe = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $12c6b0ab9da17bee$var$re(e, t), e.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i, a, u = this.decodeMiddleCounters;
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
        for(var s = t.getSize(), c = e[1], f = 0; f < 4 && c < s; f++){
            var h = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, u, c, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var l = (n = void 0, $12c6b0ab9da17bee$var$ne(u)), d = l.next(); !d.done; d = l.next())c += d.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (o = l.return) && o.call(l);
                } finally{
                    if (n) throw n.error;
                }
            }
        }
        c = $12c6b0ab9da17bee$var$Jt.findGuardPattern(t, c, !0, $12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN, new Int32Array($12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(f = 0; f < 4 && c < s; f++){
            h = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, u, c, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var p = (i = void 0, $12c6b0ab9da17bee$var$ne(u)), g = p.next(); !g.done; g = p.next())c += g.value;
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (a = p.return) && a.call(p);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return {
            rowOffset: c,
            resultString: r
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.EAN_8;
    }, e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$ie = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ae = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.ean13Reader = new $12c6b0ab9da17bee$var$ee, e;
    }
    return $12c6b0ab9da17bee$var$ie(e, t), e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.UPC_A;
    }, e.prototype.decode = function(t, e) {
        return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, e, r) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(t, e, r));
    }, e.prototype.decodeMiddle = function(t, e, r) {
        return this.ean13Reader.decodeMiddle(t, e, r);
    }, e.prototype.maybeReturnResult = function(t) {
        var e = t.getText();
        if ("0" === e.charAt(0)) {
            var r = new $12c6b0ab9da17bee$var$et(e.substring(1), null, null, t.getResultPoints(), $12c6b0ab9da17bee$var$nt.UPC_A);
            return null != t.getResultMetadata() && r.putAllMetadata(t.getResultMetadata()), r;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        this.ean13Reader.reset();
    }, e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$ue = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$se = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ce = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = new Int32Array(4), e;
    }
    return $12c6b0ab9da17bee$var$ue(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a = this.decodeMiddleCounters.map(function(t) {
            return t;
        });
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = t.getSize(), s = r[1], c = 0, f = 0; f < 6 && s < u; f++){
            var h = e.decodeDigit(t, a, s, e.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $12c6b0ab9da17bee$var$se(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 5 - f);
        }
        return e.determineNumSysAndCheckDigit(new $12c6b0ab9da17bee$var$k(n), c), s;
    }, e.prototype.decodeEnd = function(t, r) {
        return e.findGuardPatternWithoutCounters(t, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
        return $12c6b0ab9da17bee$var$Jt.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, e) {
        for(var r = 0; r <= 1; r++)for(var n = 0; n < 10; n++)if (e === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n]) return t.insert(0, "0" + r), void t.append("0" + n);
        throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
        var e = t.slice(1, 7).split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $12c6b0ab9da17bee$var$k;
        r.append(t.charAt(0));
        var n = e[5];
        switch(n){
            case 0:
            case 1:
            case 2:
                r.appendChars(e, 0, 2), r.append(n), r.append("0000"), r.appendChars(e, 2, 3);
                break;
            case 3:
                r.appendChars(e, 0, 3), r.append("00000"), r.appendChars(e, 3, 2);
                break;
            case 4:
                r.appendChars(e, 0, 4), r.append("00000"), r.append(e[4]);
                break;
            default:
                r.appendChars(e, 0, 5), r.append("0000"), r.append(n);
        }
        return t.length >= 8 && r.append(t.charAt(7)), r.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            56,
            52,
            50,
            49,
            44,
            38,
            35,
            42,
            41,
            37
        ]),
        Int32Array.from([
            7,
            11,
            13,
            14,
            19,
            25,
            28,
            21,
            22,
            1
        ])
    ], e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$fe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$he = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$le = function(t) {
    function e(e) {
        var r = t.call(this) || this, n = null == e ? null : e.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), o = [];
        return null != n && (n.indexOf($12c6b0ab9da17bee$var$nt.EAN_13) > -1 ? o.push(new $12c6b0ab9da17bee$var$ee) : n.indexOf($12c6b0ab9da17bee$var$nt.UPC_A) > -1 && o.push(new $12c6b0ab9da17bee$var$ae), n.indexOf($12c6b0ab9da17bee$var$nt.EAN_8) > -1 && o.push(new $12c6b0ab9da17bee$var$oe), n.indexOf($12c6b0ab9da17bee$var$nt.UPC_E) > -1 && o.push(new $12c6b0ab9da17bee$var$ce)), 0 === o.length && (o.push(new $12c6b0ab9da17bee$var$ee), o.push(new $12c6b0ab9da17bee$var$oe), o.push(new $12c6b0ab9da17bee$var$ce)), r.readers = o, r;
    }
    return $12c6b0ab9da17bee$var$fe(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n, o;
        try {
            for(var i = $12c6b0ab9da17bee$var$he(this.readers), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                try {
                    var s = u.decodeRow(t, e, r), c = s.getBarcodeFormat() === $12c6b0ab9da17bee$var$nt.EAN_13 && "0" === s.getText().charAt(0), f = null == r ? null : r.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), h = null == f || f.includes($12c6b0ab9da17bee$var$nt.UPC_A);
                    if (c && h) {
                        var l = s.getRawBytes(), d = new $12c6b0ab9da17bee$var$et(s.getText().substring(1), l, l.length, s.getResultPoints(), $12c6b0ab9da17bee$var$nt.UPC_A);
                        return d.putAllMetadata(s.getResultMetadata()), d;
                    }
                    return s;
                } catch (t) {}
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        var t, e;
        try {
            for(var r = $12c6b0ab9da17bee$var$he(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$de = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$pe = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ge = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeFinderCounters = new Int32Array(4), e.dataCharacterCounters = new Int32Array(8), e.oddRoundingErrors = new Array(4), e.evenRoundingErrors = new Array(4), e.oddCounts = new Array(e.dataCharacterCounters.length / 2), e.evenCounts = new Array(e.dataCharacterCounters.length / 2), e;
    }
    return $12c6b0ab9da17bee$var$de(e, t), e.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
        return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
        return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, r) {
        for(var n = 0; n < r.length; n++)if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(t, r[n], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return n;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.count = function(t) {
        return $12c6b0ab9da17bee$var$vt.sum(new Int32Array(t));
    }, e.increment = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] > n && (n = e[o], r = o);
        t[r]++;
    }, e.decrement = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] < n && (n = e[o], r = o);
        t[r]--;
    }, e.isFinderPattern = function(t) {
        var r, n, o = t[0] + t[1], i = o / (o + t[2] + t[3]);
        if (i >= e.MIN_FINDER_PATTERN_RATIO && i <= e.MAX_FINDER_PATTERN_RATIO) {
            var a = Number.MAX_SAFE_INTEGER, u = Number.MIN_SAFE_INTEGER;
            try {
                for(var s = $12c6b0ab9da17bee$var$pe(t), c = s.next(); !c.done; c = s.next()){
                    var f = c.value;
                    f > u && (u = f), f < a && (a = f);
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    c && !c.done && (n = s.return) && n.call(s);
                } finally{
                    if (r) throw r.error;
                }
            }
            return u < 10 * a;
        }
        return !1;
    }, e.MAX_AVG_VARIANCE = .2, e.MAX_INDIVIDUAL_VARIANCE = .45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$ye = function() {
    function t(t, e) {
        this.value = t, this.checksumPortion = e;
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    }, t.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value && this.checksumPortion === r.checksumPortion;
    }, t.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    }, t;
}(), $12c6b0ab9da17bee$var$we = function() {
    function t(t, e, r, n, o) {
        this.value = t, this.startEnd = e, this.value = t, this.startEnd = e, this.resultPoints = new Array, this.resultPoints.push(new $12c6b0ab9da17bee$var$At(r, o)), this.resultPoints.push(new $12c6b0ab9da17bee$var$At(n, o));
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getStartEnd = function() {
        return this.startEnd;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.hashCode = function() {
        return this.value;
    }, t;
}(), $12c6b0ab9da17bee$var$_e = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ve = function() {
    function t() {}
    return t.getRSSvalue = function(e, r, n) {
        var o, i, a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$_e(e), s = u.next(); !s.done; s = u.next())a += s.value;
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (i = u.return) && i.call(u);
            } finally{
                if (o) throw o.error;
            }
        }
        for(var c = 0, f = 0, h = e.length, l = 0; l < h - 1; l++){
            var d = void 0;
            for(d = 1, f |= 1 << l; d < e[l]; d++, f &= ~(1 << l)){
                var p = t.combins(a - d - 1, h - l - 2);
                if (n && 0 === f && a - d - (h - l - 1) >= h - l - 1 && (p -= t.combins(a - d - (h - l), h - l - 2)), h - l - 1 > 1) {
                    for(var g = 0, y = a - d - (h - l - 2); y > r; y--)g += t.combins(a - d - y - 1, h - l - 3);
                    p -= g * (h - 1 - l);
                } else a - d > r && p--;
                c += p;
            }
            a -= d;
        }
        return c;
    }, t.combins = function(t, e) {
        var r, n;
        t - e > e ? (n = e, r = t - e) : (n = t - e, r = e);
        for(var o = 1, i = 1, a = t; a > r; a--)o *= a, i <= n && (o /= i, i++);
        for(; i <= n;)o /= i, i++;
        return o;
    }, t;
}(), $12c6b0ab9da17bee$var$me = function() {
    function t() {}
    return t.buildBitArray = function(t) {
        var e = 2 * t.length - 1;
        null == t[t.length - 1].getRightChar() && (e -= 1);
        for(var r = new $12c6b0ab9da17bee$var$S(12 * e), n = 0, o = t[0].getRightChar().getValue(), i = 11; i >= 0; --i)0 != (o & 1 << i) && r.set(n), n++;
        for(i = 1; i < t.length; ++i){
            for(var a = t[i], u = a.getLeftChar().getValue(), s = 11; s >= 0; --s)0 != (u & 1 << s) && r.set(n), n++;
            if (null != a.getRightChar()) {
                var c = a.getRightChar().getValue();
                for(s = 11; s >= 0; --s)0 != (c & 1 << s) && r.set(n), n++;
            }
        }
        return r;
    }, t;
}(), $12c6b0ab9da17bee$var$Ae = function() {
    function t(t, e) {
        e ? this.decodedInformation = null : (this.finished = t, this.decodedInformation = e);
    }
    return t.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    }, t.prototype.isFinished = function() {
        return this.finished;
    }, t;
}(), $12c6b0ab9da17bee$var$Ee = function() {
    function t(t) {
        this.newPosition = t;
    }
    return t.prototype.getNewPosition = function() {
        return this.newPosition;
    }, t;
}(), $12c6b0ab9da17bee$var$Ce = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ie = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n.value = r, n;
    }
    return $12c6b0ab9da17bee$var$Ce(e, t), e.prototype.getValue = function() {
        return this.value;
    }, e.prototype.isFNC1 = function() {
        return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Se = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Oe = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return n ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = r, o;
    }
    return $12c6b0ab9da17bee$var$Se(e, t), e.prototype.getNewString = function() {
        return this.newString;
    }, e.prototype.isRemaining = function() {
        return this.remaining;
    }, e.prototype.getRemainingValue = function() {
        return this.remainingValue;
    }, e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Te = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$be = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        if (r < 0 || r > 10 || n < 0 || n > 10) throw new $12c6b0ab9da17bee$var$R;
        return o.firstDigit = r, o.secondDigit = n, o;
    }
    return $12c6b0ab9da17bee$var$Te(e, t), e.prototype.getFirstDigit = function() {
        return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
        return this.secondDigit;
    }, e.prototype.getValue = function() {
        return 10 * this.firstDigit + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
        return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Re = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ne = function() {
    function t() {}
    return t.parseFieldsInGeneralPurpose = function(e) {
        var r, n, o, i, a, u, s, c;
        if (!e) return null;
        if (e.length < 2) throw new $12c6b0ab9da17bee$var$U;
        var f = e.substring(0, 2);
        try {
            for(var h = $12c6b0ab9da17bee$var$Re(t.TWO_DIGIT_DATA_LENGTH), l = h.next(); !l.done; l = h.next()){
                if ((A = l.value)[0] === f) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, A[2], e) : t.processFixedAI(2, A[1], e);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        if (e.length < 3) throw new $12c6b0ab9da17bee$var$U;
        var d = e.substring(0, 3);
        try {
            for(var p = $12c6b0ab9da17bee$var$Re(t.THREE_DIGIT_DATA_LENGTH), g = p.next(); !g.done; g = p.next()){
                if ((A = g.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, A[2], e) : t.processFixedAI(3, A[1], e);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        try {
            for(var y = $12c6b0ab9da17bee$var$Re(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), w = y.next(); !w.done; w = y.next()){
                if ((A = w.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        if (e.length < 4) throw new $12c6b0ab9da17bee$var$U;
        var _ = e.substring(0, 4);
        try {
            for(var v = $12c6b0ab9da17bee$var$Re(t.FOUR_DIGIT_DATA_LENGTH), m = v.next(); !m.done; m = v.next()){
                var A;
                if ((A = m.value)[0] === _) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            s = {
                error: t
            };
        } finally{
            try {
                m && !m.done && (c = v.return) && c.call(v);
            } finally{
                if (s) throw s.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.processFixedAI = function(e, r, n) {
        if (n.length < e) throw new $12c6b0ab9da17bee$var$U;
        var o = n.substring(0, e);
        if (n.length < e + r) throw new $12c6b0ab9da17bee$var$U;
        var i = n.substring(e, e + r), a = n.substring(e + r), u = "(" + o + ")" + i, s = t.parseFieldsInGeneralPurpose(a);
        return null == s ? u : u + s;
    }, t.processVariableAI = function(e, r, n) {
        var o, i = n.substring(0, e);
        o = n.length < e + r ? n.length : e + r;
        var a = n.substring(e, o), u = n.substring(o), s = "(" + i + ")" + a, c = t.parseFieldsInGeneralPurpose(u);
        return null == c ? s : s + c;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            t.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "90",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            t.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.THREE_DIGIT_DATA_LENGTH = [
        [
            "240",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            t.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            t.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
        [
            "7001",
            13
        ],
        [
            "7002",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            t.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            t.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            t.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            t.VARIABLE_LENGTH,
            70
        ]
    ], t;
}(), $12c6b0ab9da17bee$var$De = function() {
    function t(t) {
        this.buffer = new $12c6b0ab9da17bee$var$k, this.information = t;
    }
    return t.prototype.decodeAllCodes = function(t, e) {
        for(var r = e, n = null;;){
            var o = this.decodeGeneralPurposeField(r, n), i = $12c6b0ab9da17bee$var$Ne.parseFieldsInGeneralPurpose(o.getNewString());
            if (null != i && t.append(i), n = o.isRemaining() ? "" + o.getRemainingValue() : null, r === o.getNewPosition()) break;
            r = o.getNewPosition();
        }
        return t.toString();
    }, t.prototype.isStillNumeric = function(t) {
        if (t + 7 > this.information.getSize()) return t + 4 <= this.information.getSize();
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !0;
        return this.information.get(t + 3);
    }, t.prototype.decodeNumeric = function(t) {
        if (t + 7 > this.information.getSize()) {
            var e = this.extractNumericValueFromBitArray(t, 4);
            return new $12c6b0ab9da17bee$var$be(this.information.getSize(), 0 === e ? $12c6b0ab9da17bee$var$be.FNC1 : e - 1, $12c6b0ab9da17bee$var$be.FNC1);
        }
        var r = this.extractNumericValueFromBitArray(t, 7);
        return new $12c6b0ab9da17bee$var$be(t + 7, (r - 8) / 11, (r - 8) % 11);
    }, t.prototype.extractNumericValueFromBitArray = function(e, r) {
        return t.extractNumericValueFromBitArray(this.information, e, r);
    }, t.extractNumericValueFromBitArray = function(t, e, r) {
        for(var n = 0, o = 0; o < r; ++o)t.get(e + o) && (n |= 1 << r - o - 1);
        return n;
    }, t.prototype.decodeGeneralPurposeField = function(t, e) {
        this.buffer.setLengthToZero(), null != e && this.buffer.append(e), this.current.setPosition(t);
        var r = this.parseBlocks();
        return null != r && r.isRemaining() ? new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
        var t, e;
        do {
            var r = this.current.getPosition();
            if (t = this.current.isAlpha() ? (e = this.parseAlphaBlock()).isFinished() : this.current.isIsoIec646() ? (e = this.parseIsoIec646Block()).isFinished() : (e = this.parseNumericBlock()).isFinished(), !(r !== this.current.getPosition()) && !t) break;
        }while (!t);
        return e.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
        for(; this.isStillNumeric(this.current.getPosition());){
            var t = this.decodeNumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFirstDigitFNC1()) {
                var e = void 0;
                return e = t.isSecondDigitFNC1() ? new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString()) : new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString(), t.getSecondDigit()), new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            if (this.buffer.append(t.getFirstDigit()), t.isSecondDigitFNC1()) {
                e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getSecondDigit());
        }
        return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.parseIsoIec646Block = function() {
        for(; this.isStillIsoIec646(this.current.getPosition());){
            var t = this.decodeIsoIec646(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.parseAlphaBlock = function() {
        for(; this.isStillAlpha(this.current.getPosition());){
            var t = this.decodeAlphanumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.isStillIsoIec646 = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 7 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 7);
        if (r >= 64 && r < 116) return !0;
        if (t + 8 > this.information.getSize()) return !1;
        var n = this.extractNumericValueFromBitArray(t, 8);
        return n >= 232 && n < 253;
    }, t.prototype.decodeIsoIec646 = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $12c6b0ab9da17bee$var$Ie(t + 5, $12c6b0ab9da17bee$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $12c6b0ab9da17bee$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 7);
        if (n >= 64 && n < 90) return new $12c6b0ab9da17bee$var$Ie(t + 7, "" + (n + 1));
        if (n >= 90 && n < 116) return new $12c6b0ab9da17bee$var$Ie(t + 7, "" + (n + 7));
        switch(this.extractNumericValueFromBitArray(t, 8)){
            case 232:
                r = "!";
                break;
            case 233:
                r = '"';
                break;
            case 234:
                r = "%";
                break;
            case 235:
                r = "&";
                break;
            case 236:
                r = "'";
                break;
            case 237:
                r = "(";
                break;
            case 238:
                r = ")";
                break;
            case 239:
                r = "*";
                break;
            case 240:
                r = "+";
                break;
            case 241:
                r = ",";
                break;
            case 242:
                r = "-";
                break;
            case 243:
                r = ".";
                break;
            case 244:
                r = "/";
                break;
            case 245:
                r = ":";
                break;
            case 246:
                r = ";";
                break;
            case 247:
                r = "<";
                break;
            case 248:
                r = "=";
                break;
            case 249:
                r = ">";
                break;
            case 250:
                r = "?";
                break;
            case 251:
                r = "_";
                break;
            case 252:
                r = " ";
                break;
            default:
                throw new $12c6b0ab9da17bee$var$R;
        }
        return new $12c6b0ab9da17bee$var$Ie(t + 8, r);
    }, t.prototype.isStillAlpha = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 6 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 6);
        return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $12c6b0ab9da17bee$var$Ie(t + 5, $12c6b0ab9da17bee$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $12c6b0ab9da17bee$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 6);
        if (n >= 32 && n < 58) return new $12c6b0ab9da17bee$var$Ie(t + 6, "" + (n + 33));
        switch(n){
            case 58:
                r = "*";
                break;
            case 59:
                r = ",";
                break;
            case 60:
                r = "-";
                break;
            case 61:
                r = ".";
                break;
            case 62:
                r = "/";
                break;
            default:
                throw new $12c6b0ab9da17bee$var$yt("Decoding invalid alphanumeric value: " + n);
        }
        return new $12c6b0ab9da17bee$var$Ie(t + 6, r);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 5 && e + t < this.information.getSize(); ++e)if (2 === e) {
            if (!this.information.get(t + 2)) return !1;
        } else if (this.information.get(t + e)) return !1;
        return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(t) {
        if (t + 3 > this.information.getSize()) return !1;
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !1;
        return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 4 && e + t < this.information.getSize(); ++e)if (this.information.get(t + e)) return !1;
        return !0;
    }, t;
}(), $12c6b0ab9da17bee$var$Pe = function() {
    function t(t) {
        this.information = t, this.generalDecoder = new $12c6b0ab9da17bee$var$De(t);
    }
    return t.prototype.getInformation = function() {
        return this.information;
    }, t.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    }, t;
}(), $12c6b0ab9da17bee$var$Me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Be = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Me(e, t), e.prototype.encodeCompressedGtin = function(t, e) {
        t.append("(01)");
        var r = t.length();
        t.append("9"), this.encodeCompressedGtinWithoutAI(t, e, r);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, r, n) {
        for(var o = 0; o < 4; ++o){
            var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * o, 10);
            i / 100 == 0 && t.append("0"), i / 10 == 0 && t.append("0"), t.append(i);
        }
        e.appendCheckDigit(t, n);
    }, e.appendCheckDigit = function(t, e) {
        for(var r = 0, n = 0; n < 13; n++){
            var o = t.charAt(n + e).charCodeAt(0) - "0".charCodeAt(0);
            r += 0 == (1 & n) ? 3 * o : o;
        }
        10 === (r = 10 - r % 10) && (r = 0), t.append(r);
    }, e.GTIN_SIZE = 40, e;
}($12c6b0ab9da17bee$var$Pe), $12c6b0ab9da17bee$var$Le = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Fe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Le(e, t), e.prototype.parseInformation = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        t.append("(01)");
        var r = t.length(), n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
        return t.append(n), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$xe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$ke(e, t), e.prototype.parseInformation = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
}($12c6b0ab9da17bee$var$Pe), $12c6b0ab9da17bee$var$Ve = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ue = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ve(e, t), e.prototype.encodeCompressedWeight = function(t, e, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e, r);
        this.addWeightCode(t, n);
        for(var o = this.checkWeight(n), i = 1e5, a = 0; a < 5; ++a)o / i == 0 && t.append("0"), i /= 10;
        t.append(o);
    }, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$He = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ge = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$He(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + $12c6b0ab9da17bee$var$Ue.GTIN_SIZE + e.WEIGHT_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + $12c6b0ab9da17bee$var$Ue.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
}($12c6b0ab9da17bee$var$Ue), $12c6b0ab9da17bee$var$Xe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$We = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Xe(e, t), e.prototype.addWeightCode = function(t, e) {
        t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
        return t;
    }, e;
}($12c6b0ab9da17bee$var$Ge), $12c6b0ab9da17bee$var$je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$je(e, t), e.prototype.addWeightCode = function(t, e) {
        e < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
        return t < 1e4 ? t : t - 1e4;
    }, e;
}($12c6b0ab9da17bee$var$Ge), $12c6b0ab9da17bee$var$Ye = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ye(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(392"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
        return t.append(n.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$Ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$qe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ke(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(393"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
        n / 100 == 0 && t.append("0"), n / 10 == 0 && t.append("0"), t.append(n);
        var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
        return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$Qe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Je = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.dateCode = n, o.firstAIdigits = r, o;
    }
    return $12c6b0ab9da17bee$var$Qe(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
        if (38400 != n) {
            t.append("("), t.append(this.dateCode), t.append(")");
            var o = n % 32, i = (n /= 32) % 12 + 1, a = n /= 12;
            a / 10 == 0 && t.append("0"), t.append(a), i / 10 == 0 && t.append("0"), t.append(i), o / 10 == 0 && t.append("0"), t.append(o);
        }
    }, e.prototype.addWeightCode = function(t, e) {
        t.append("("), t.append(this.firstAIdigits), t.append(e / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
        return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
}($12c6b0ab9da17bee$var$Ue);
var $12c6b0ab9da17bee$var$$e = function() {
    function t(t, e, r, n) {
        this.leftchar = t, this.rightchar = e, this.finderpattern = r, this.maybeLast = n;
    }
    return t.prototype.mayBeLast = function() {
        return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
        return this.leftchar;
    }, t.prototype.getRightChar = function() {
        return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
        return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
        return null == this.rightchar;
    }, t.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (null == this.finderpattern ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, r) {
        return e instanceof t && t.equalsOrNull(e.leftchar, r.leftchar) && t.equalsOrNull(e.rightchar, r.rightchar) && t.equalsOrNull(e.finderpattern, r.finderpattern);
    }, t.equalsOrNull = function(e, r) {
        return null === e ? null === r : t.equals(e, r);
    }, t.prototype.hashCode = function() {
        return this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
    }, t;
}(), $12c6b0ab9da17bee$var$tr = function() {
    function t(t, e, r) {
        this.pairs = t, this.rowNumber = e, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
        return this.pairs;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.isReversed = function() {
        return this.wasReversed;
    }, t.prototype.isEquivalent = function(t) {
        return this.checkEqualitity(this, t);
    }, t.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, r) {
        return e instanceof t && this.checkEqualitity(e, r) && e.wasReversed === r.wasReversed;
    }, t.prototype.checkEqualitity = function(t, e) {
        var r;
        if (t && e) return t.forEach(function(t, n) {
            e.forEach(function(e) {
                t.getLeftChar().getValue() === e.getLeftChar().getValue() && t.getRightChar().getValue() === e.getRightChar().getValue() && t.getFinderPatter().getValue() === e.getFinderPatter().getValue() && (r = !0);
            });
        }), r;
    }, t;
}(), $12c6b0ab9da17bee$var$er = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$rr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$nr = function(t) {
    function e() {
        var r = null !== t && t.apply(this, arguments) || this;
        return r.pairs = new Array(e.MAX_PAIRS), r.rows = new Array, r.startEnd = [
            2
        ], r;
    }
    return $12c6b0ab9da17bee$var$er(e, t), e.prototype.decodeRow = function(t, r, n) {
        this.pairs.length = 0, this.startFromEven = !1;
        try {
            return e.constructResult(this.decodeRow2pairs(t, r));
        } catch (t) {}
        return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, r));
    }, e.prototype.reset = function() {
        this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, e) {
        for(var r, n = !1; !n;)try {
            this.pairs.push(this.retrieveNextPair(e, this.pairs, t));
        } catch (t) {
            if (t instanceof $12c6b0ab9da17bee$var$U) {
                if (!this.pairs.length) throw new $12c6b0ab9da17bee$var$U;
                n = !0;
            }
        }
        if (this.checkChecksum()) return this.pairs;
        if (r = !!this.rows.length, this.storeRow(t, !1), r) {
            var o = this.checkRowsBoolean(!1);
            if (null != o) return o;
            if (null != (o = this.checkRowsBoolean(!0))) return o;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.checkRowsBoolean = function(t) {
        if (this.rows.length > 25) return this.rows.length = 0, null;
        this.pairs.length = 0, t && (this.rows = this.rows.reverse());
        var e = null;
        try {
            e = this.checkRows(new Array, 0);
        } catch (t) {
            console.log(t);
        }
        return t && (this.rows = this.rows.reverse()), e;
    }, e.prototype.checkRows = function(t, r) {
        for(var n, o, i = r; i < this.rows.length; i++){
            var a = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var u = (n = void 0, $12c6b0ab9da17bee$var$rr(t)), s = u.next(); !s.done; s = u.next()){
                    var c = s.value;
                    this.pairs.push(c.getPairs());
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (o = u.return) && o.call(u);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (this.pairs.push(a.getPairs()), e.isValidSequence(this.pairs)) {
                if (this.checkChecksum()) return this.pairs;
                var f = new Array(t);
                f.push(a);
                try {
                    return this.checkRows(f, i + 1);
                } catch (t) {
                    console.log(t);
                }
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.isValidSequence = function(t) {
        var r, n;
        try {
            for(var o = $12c6b0ab9da17bee$var$rr(e.FINDER_PATTERN_SEQUENCES), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (!(t.length > a.length)) {
                    for(var u = !0, s = 0; s < t.length; s++)if (t[s].getFinderPattern().getValue() != a[s]) {
                        u = !1;
                        break;
                    }
                    if (u) return !0;
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.storeRow = function(t, r) {
        for(var n = 0, o = !1, i = !1; n < this.rows.length;){
            var a = this.rows[n];
            if (a.getRowNumber() > t) {
                i = a.isEquivalent(this.pairs);
                break;
            }
            o = a.isEquivalent(this.pairs), n++;
        }
        i || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(n, new $12c6b0ab9da17bee$var$tr(this.pairs, t, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $12c6b0ab9da17bee$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value;
                if (f.getPairs().length !== t.length) try {
                    for(var h = (o = void 0, $12c6b0ab9da17bee$var$rr(f.getPairs())), l = h.next(); !l.done; l = h.next()){
                        var d = l.value, p = !1;
                        try {
                            for(var g = (a = void 0, $12c6b0ab9da17bee$var$rr(t)), y = g.next(); !y.done; y = g.next()){
                                var w = y.value;
                                if ($12c6b0ab9da17bee$var$$e.equals(d, w)) {
                                    p = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                y && !y.done && (u = g.return) && u.call(g);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        p;
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (i = h.return) && i.call(h);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.isPartialRow = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $12c6b0ab9da17bee$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = !0;
                try {
                    for(var l = (o = void 0, $12c6b0ab9da17bee$var$rr(t)), d = l.next(); !d.done; d = l.next()){
                        var p = d.value, g = !1;
                        try {
                            for(var y = (a = void 0, $12c6b0ab9da17bee$var$rr(f.getPairs())), w = y.next(); !w.done; w = y.next()){
                                var _ = w.value;
                                if (p.equals(_)) {
                                    g = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                w && !w.done && (u = y.return) && u.call(y);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        if (!g) {
                            h = !1;
                            break;
                        }
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (i = l.return) && i.call(l);
                    } finally{
                        if (o) throw o.error;
                    }
                }
                if (h) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.getRows = function() {
        return this.rows;
    }, e.constructResult = function(t) {
        var e = (function(t) {
            try {
                if (t.get(1)) return new $12c6b0ab9da17bee$var$Fe(t);
                if (!t.get(2)) return new $12c6b0ab9da17bee$var$xe(t);
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 4)){
                    case 4:
                        return new $12c6b0ab9da17bee$var$We(t);
                    case 5:
                        return new $12c6b0ab9da17bee$var$ze(t);
                }
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 5)){
                    case 12:
                        return new $12c6b0ab9da17bee$var$Ze(t);
                    case 13:
                        return new $12c6b0ab9da17bee$var$qe(t);
                }
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 7)){
                    case 56:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "11");
                    case 57:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "11");
                    case 58:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "13");
                    case 59:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "13");
                    case 60:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "15");
                    case 61:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "15");
                    case 62:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "17");
                    case 63:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "17");
                }
            } catch (e) {
                throw console.log(e), new $12c6b0ab9da17bee$var$yt("unknown decoder: " + t);
            }
        })($12c6b0ab9da17bee$var$me.buildBitArray(t)).parseInformation(), r = t[0].getFinderPattern().getResultPoints(), n = t[t.length - 1].getFinderPattern().getResultPoints(), o = [
            r[0],
            r[1],
            n[0],
            n[1]
        ];
        return new $12c6b0ab9da17bee$var$et(e, null, null, o, $12c6b0ab9da17bee$var$nt.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
        var t = this.pairs.get(0), e = t.getLeftChar(), r = t.getRightChar();
        if (null == r) return !1;
        for(var n = r.getChecksumPortion(), o = 2, i = 1; i < this.pairs.size(); ++i){
            var a = this.pairs.get(i);
            n += a.getLeftChar().getChecksumPortion(), o++;
            var u = a.getRightChar();
            null != u && (n += u.getChecksumPortion(), o++);
        }
        return 211 * (o - 4) + (n %= 211) == e.getValue();
    }, e.getNextSecondBar = function(t, e) {
        var r;
        return t.get(e) ? (r = t.getNextUnset(e), r = t.getNextSet(r)) : (r = t.getNextSet(e), r = t.getNextUnset(r)), r;
    }, e.prototype.retrieveNextPair = function(t, r, n) {
        var o, i = r.length % 2 == 0;
        this.startFromEven && (i = !i);
        var a = !0, u = -1;
        do this.findNextPair(t, r, u), null == (o = this.parseFoundFinderPattern(t, n, i)) ? u = e.getNextSecondBar(t, this.startEnd[0]) : a = !1;
        while (a);
        var s, c = this.decodeDataCharacter(t, o, i, !0);
        if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast()) throw new $12c6b0ab9da17bee$var$U;
        try {
            s = this.decodeDataCharacter(t, o, i, !1);
        } catch (t) {
            s = null, console.log(t);
        }
        return new $12c6b0ab9da17bee$var$$e(c, s, o, !0);
    }, e.prototype.isEmptyPair = function(t) {
        return 0 === t.length;
    }, e.prototype.findNextPair = function(t, r, n) {
        var o = this.getDecodeFinderCounters();
        o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
        var i, a = t.getSize();
        if (n >= 0) i = n;
        else if (this.isEmptyPair(r)) i = 0;
        else i = r[r.length - 1].getFinderPattern().getStartEnd()[1];
        var u = r.length % 2 != 0;
        this.startFromEven && (u = !u);
        for(var s = !1; i < a && (s = !t.get(i));)i++;
        for(var c = 0, f = i, h = i; h < a; h++)if (t.get(h) != s) o[c]++;
        else {
            if (3 == c) {
                if (u && e.reverseCounters(o), e.isFinderPattern(o)) return this.startEnd[0] = f, void (this.startEnd[1] = h);
                u && e.reverseCounters(o), f += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, c--;
            } else c++;
            o[c] = 1, s = !s;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.reverseCounters = function(t) {
        for(var e = t.length, r = 0; r < e / 2; ++r){
            var n = t[r];
            t[r] = t[e - r - 1], t[e - r - 1] = n;
        }
    }, e.prototype.parseFoundFinderPattern = function(t, r, n) {
        var o, i, a;
        if (n) {
            for(var u = this.startEnd[0] - 1; u >= 0 && !t.get(u);)u--;
            u++, o = this.startEnd[0] - u, i = u, a = this.startEnd[1];
        } else i = this.startEnd[0], o = (a = t.getNextUnset(this.startEnd[1] + 1)) - this.startEnd[1];
        var s, c = this.getDecodeFinderCounters();
        $12c6b0ab9da17bee$var$w.arraycopy(c, 0, c, 1, c.length - 1), c[0] = o;
        try {
            s = this.parseFinderValue(c, e.FINDER_PATTERNS);
        } catch (t) {
            return null;
        }
        return new $12c6b0ab9da17bee$var$we(s, [
            i,
            a
        ], i, a, r);
    }, e.prototype.decodeDataCharacter = function(t, r, n, o) {
        for(var i = this.getDataCharacterCounters(), a = 0; a < i.length; a++)i[a] = 0;
        if (o) e.recordPatternInReverse(t, r.getStartEnd()[0], i);
        else {
            e.recordPattern(t, r.getStartEnd()[1], i);
            for(var u = 0, s = i.length - 1; u < s; u++, s--){
                var c = i[u];
                i[u] = i[s], i[s] = c;
            }
        }
        var f = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(i)) / 17, h = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
        if (Math.abs(f - h) / h > .3) throw new $12c6b0ab9da17bee$var$U;
        var l = this.getOddCounts(), d = this.getEvenCounts(), p = this.getOddRoundingErrors(), g = this.getEvenRoundingErrors();
        for(u = 0; u < i.length; u++){
            var y = 1 * i[u] / f, w = y + .5;
            if (w < 1) {
                if (y < .3) throw new $12c6b0ab9da17bee$var$U;
                w = 1;
            } else if (w > 8) {
                if (y > 8.7) throw new $12c6b0ab9da17bee$var$U;
                w = 8;
            }
            var _ = u / 2;
            0 == (1 & u) ? (l[_] = w, p[_] = y - w) : (d[_] = w, g[_] = y - w);
        }
        this.adjustOddEvenCounts(17);
        var v = 4 * r.getValue() + (n ? 0 : 2) + (o ? 0 : 1) - 1, m = 0, A = 0;
        for(u = l.length - 1; u >= 0; u--){
            if (e.isNotA1left(r, n, o)) {
                var E = e.WEIGHTS[v][2 * u];
                A += l[u] * E;
            }
            m += l[u];
        }
        var C = 0;
        for(u = d.length - 1; u >= 0; u--)if (e.isNotA1left(r, n, o)) {
            E = e.WEIGHTS[v][2 * u + 1];
            C += d[u] * E;
        }
        var I = A + C;
        if (0 != (1 & m) || m > 13 || m < 4) throw new $12c6b0ab9da17bee$var$U;
        var S = (13 - m) / 2, O = e.SYMBOL_WIDEST[S], T = 9 - O, b = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, O, !0), R = $12c6b0ab9da17bee$var$ve.getRSSvalue(d, T, !1), N = e.EVEN_TOTAL_SUBSET[S], D = e.GSUM[S];
        return new $12c6b0ab9da17bee$var$ye(b * N + R + D, I);
    }, e.isNotA1left = function(t, e, r) {
        return !(0 == t.getValue() && e && r);
    }, e.prototype.adjustOddEvenCounts = function(t) {
        var r = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getOddCounts())), n = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1;
        r > 13 ? i = !0 : r < 4 && (o = !0);
        var a = !1, u = !1;
        n > 13 ? u = !0 : n < 4 && (a = !0);
        var s = r + n - t, c = 1 == (1 & r), f = 0 == (1 & n);
        if (1 == s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                i = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                u = !0;
            }
        } else if (-1 == s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                o = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                a = !0;
            }
        } else {
            if (0 != s) throw new $12c6b0ab9da17bee$var$U;
            if (c) {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $12c6b0ab9da17bee$var$U;
        }
        if (o) {
            if (i) throw new $12c6b0ab9da17bee$var$U;
            e.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $12c6b0ab9da17bee$var$U;
            e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ], e.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ], e.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ], e.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_C,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_C
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ]
    ], e.MAX_PAIRS = 11, e;
}($12c6b0ab9da17bee$var$ge), $12c6b0ab9da17bee$var$or = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ir = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.count = 0, o.finderPattern = n, o;
    }
    return $12c6b0ab9da17bee$var$or(e, t), e.prototype.getFinderPattern = function() {
        return this.finderPattern;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.incrementCount = function() {
        this.count++;
    }, e;
}($12c6b0ab9da17bee$var$ye), $12c6b0ab9da17bee$var$ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$sr = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.possibleLeftPairs = [], e.possibleRightPairs = [], e;
    }
    return $12c6b0ab9da17bee$var$ar(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.decodePair(r, !1, t, n);
        e.addOrTally(this.possibleLeftPairs, s), r.reverse();
        var c = this.decodePair(r, !0, t, n);
        e.addOrTally(this.possibleRightPairs, c), r.reverse();
        try {
            for(var f = $12c6b0ab9da17bee$var$ur(this.possibleLeftPairs), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (l.getCount() > 1) try {
                    for(var d = (a = void 0, $12c6b0ab9da17bee$var$ur(this.possibleRightPairs)), p = d.next(); !p.done; p = d.next()){
                        var g = p.value;
                        if (g.getCount() > 1 && e.checkChecksum(l, g)) return e.constructResult(l, g);
                    }
                } catch (t) {
                    a = {
                        error: t
                    };
                } finally{
                    try {
                        p && !p.done && (u = d.return) && u.call(d);
                    } finally{
                        if (a) throw a.error;
                    }
                }
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.addOrTally = function(t, e) {
        var r, n;
        if (null != e) {
            var o = !1;
            try {
                for(var i = $12c6b0ab9da17bee$var$ur(t), a = i.next(); !a.done; a = i.next()){
                    var u = a.value;
                    if (u.getValue() === e.getValue()) {
                        u.incrementCount(), o = !0;
                        break;
                    }
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    a && !a.done && (n = i.return) && n.call(i);
                } finally{
                    if (r) throw r.error;
                }
            }
            o || t.push(e);
        }
    }, e.prototype.reset = function() {
        this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, e) {
        for(var r = 4537077 * t.getValue() + e.getValue(), n = new String(r).toString(), o = new $12c6b0ab9da17bee$var$k, i = 13 - n.length; i > 0; i--)o.append("0");
        o.append(n);
        var a = 0;
        for(i = 0; i < 13; i++){
            var u = o.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            a += 0 == (1 & i) ? 3 * u : u;
        }
        10 === (a = 10 - a % 10) && (a = 0), o.append(a.toString());
        var s = t.getFinderPattern().getResultPoints(), c = e.getFinderPattern().getResultPoints();
        return new $12c6b0ab9da17bee$var$et(o.toString(), null, 0, [
            s[0],
            s[1],
            c[0],
            c[1]
        ], $12c6b0ab9da17bee$var$nt.RSS_14, (new Date).getTime());
    }, e.checkChecksum = function(t, e) {
        var r = (t.getChecksumPortion() + 16 * e.getChecksumPortion()) % 79, n = 9 * t.getFinderPattern().getValue() + e.getFinderPattern().getValue();
        return n > 72 && n--, n > 8 && n--, r === n;
    }, e.prototype.decodePair = function(t, e, r, n) {
        try {
            var o = this.findFinderPattern(t, e), i = this.parseFoundFinderPattern(t, r, e, o), a = null == n ? null : n.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
            if (null != a) {
                var u = (o[0] + o[1]) / 2;
                e && (u = t.getSize() - 1 - u), a.foundPossibleResultPoint(new $12c6b0ab9da17bee$var$At(u, r));
            }
            var s = this.decodeDataCharacter(t, i, !0), c = this.decodeDataCharacter(t, i, !1);
            return new $12c6b0ab9da17bee$var$ir(1597 * s.getValue() + c.getValue(), s.getChecksumPortion() + 4 * c.getChecksumPortion(), i);
        } catch (t) {
            return null;
        }
    }, e.prototype.decodeDataCharacter = function(t, r, n) {
        for(var o = this.getDataCharacterCounters(), i = 0; i < o.length; i++)o[i] = 0;
        if (n) $12c6b0ab9da17bee$var$Lt.recordPatternInReverse(t, r.getStartEnd()[0], o);
        else {
            $12c6b0ab9da17bee$var$Lt.recordPattern(t, r.getStartEnd()[1] + 1, o);
            for(var a = 0, u = o.length - 1; a < u; a++, u--){
                var s = o[a];
                o[a] = o[u], o[u] = s;
            }
        }
        var c = n ? 16 : 15, f = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(o)) / c, h = this.getOddCounts(), l = this.getEvenCounts(), d = this.getOddRoundingErrors(), p = this.getEvenRoundingErrors();
        for(a = 0; a < o.length; a++){
            var g = o[a] / f, y = Math.floor(g + .5);
            y < 1 ? y = 1 : y > 8 && (y = 8);
            var w = Math.floor(a / 2);
            0 == (1 & a) ? (h[w] = y, d[w] = g - y) : (l[w] = y, p[w] = g - y);
        }
        this.adjustOddEvenCounts(n, c);
        var _ = 0, v = 0;
        for(a = h.length - 1; a >= 0; a--)v *= 9, v += h[a], _ += h[a];
        var m = 0, A = 0;
        for(a = l.length - 1; a >= 0; a--)m *= 9, m += l[a], A += l[a];
        var E = v + 3 * m;
        if (n) {
            if (0 != (1 & _) || _ > 12 || _ < 4) throw new $12c6b0ab9da17bee$var$U;
            var C = (12 - _) / 2, I = 9 - (R = e.OUTSIDE_ODD_WIDEST[C]), S = $12c6b0ab9da17bee$var$ve.getRSSvalue(h, R, !1), O = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, I, !0), T = e.OUTSIDE_EVEN_TOTAL_SUBSET[C], b = e.OUTSIDE_GSUM[C];
            return new $12c6b0ab9da17bee$var$ye(S * T + O + b, E);
        }
        if (0 != (1 & A) || A > 10 || A < 4) throw new $12c6b0ab9da17bee$var$U;
        C = (10 - A) / 2, I = 9 - (R = e.INSIDE_ODD_WIDEST[C]), S = $12c6b0ab9da17bee$var$ve.getRSSvalue(h, R, !0), O = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, I, !1);
        var R, N = e.INSIDE_ODD_TOTAL_SUBSET[C];
        b = e.INSIDE_GSUM[C];
        return new $12c6b0ab9da17bee$var$ye(O * N + S + b, E);
    }, e.prototype.findFinderPattern = function(t, e) {
        var r = this.getDecodeFinderCounters();
        r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0;
        for(var n = t.getSize(), o = !1, i = 0; i < n && e !== (o = !t.get(i));)i++;
        for(var a = 0, u = i, s = i; s < n; s++)if (t.get(s) !== o) r[a]++;
        else {
            if (3 === a) {
                if ($12c6b0ab9da17bee$var$ge.isFinderPattern(r)) return [
                    u,
                    s
                ];
                u += r[0] + r[1], r[0] = r[2], r[1] = r[3], r[2] = 0, r[3] = 0, a--;
            } else a++;
            r[a] = 1, o = !o;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.parseFoundFinderPattern = function(t, r, n, o) {
        for(var i = t.get(o[0]), a = o[0] - 1; a >= 0 && i !== t.get(a);)a--;
        a++;
        var u = o[0] - a, s = this.getDecodeFinderCounters(), c = new Int32Array(s.length);
        $12c6b0ab9da17bee$var$w.arraycopy(s, 0, c, 1, s.length - 1), c[0] = u;
        var f = this.parseFinderValue(c, e.FINDER_PATTERNS), h = a, l = o[1];
        return n && (h = t.getSize() - 1 - h, l = t.getSize() - 1 - l), new $12c6b0ab9da17bee$var$we(f, [
            a,
            o[1]
        ], h, l, r);
    }, e.prototype.adjustOddEvenCounts = function(t, e) {
        var r = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getOddCounts())), n = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1, a = !1, u = !1;
        t ? (r > 12 ? i = !0 : r < 4 && (o = !0), n > 12 ? u = !0 : n < 4 && (a = !0)) : (r > 11 ? i = !0 : r < 5 && (o = !0), n > 10 ? u = !0 : n < 4 && (a = !0));
        var s = r + n - e, c = (1 & r) == (t ? 1 : 0), f = 1 == (1 & n);
        if (1 === s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                i = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                u = !0;
            }
        } else if (-1 === s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                o = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                a = !0;
            }
        } else {
            if (0 !== s) throw new $12c6b0ab9da17bee$var$U;
            if (c) {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $12c6b0ab9da17bee$var$U;
        }
        if (o) {
            if (i) throw new $12c6b0ab9da17bee$var$U;
            $12c6b0ab9da17bee$var$ge.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && $12c6b0ab9da17bee$var$ge.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $12c6b0ab9da17bee$var$U;
            $12c6b0ab9da17bee$var$ge.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && $12c6b0ab9da17bee$var$ge.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ], e.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ], e.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ], e.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ], e.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ], e.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ], e;
}($12c6b0ab9da17bee$var$ge), $12c6b0ab9da17bee$var$cr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$fr = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        r.readers = [];
        var n = e ? e.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS) : null, o = e && void 0 !== e.get($12c6b0ab9da17bee$var$T.ASSUME_CODE_39_CHECK_DIGIT);
        return n && ((n.includes($12c6b0ab9da17bee$var$nt.EAN_13) || n.includes($12c6b0ab9da17bee$var$nt.UPC_A) || n.includes($12c6b0ab9da17bee$var$nt.EAN_8) || n.includes($12c6b0ab9da17bee$var$nt.UPC_E)) && r.readers.push(new $12c6b0ab9da17bee$var$le(e)), n.includes($12c6b0ab9da17bee$var$nt.CODE_39) && r.readers.push(new $12c6b0ab9da17bee$var$Ut(o)), n.includes($12c6b0ab9da17bee$var$nt.CODE_128) && r.readers.push(new $12c6b0ab9da17bee$var$kt), n.includes($12c6b0ab9da17bee$var$nt.ITF) && r.readers.push(new $12c6b0ab9da17bee$var$Xt), n.includes($12c6b0ab9da17bee$var$nt.RSS_14) && r.readers.push(new $12c6b0ab9da17bee$var$sr), n.includes($12c6b0ab9da17bee$var$nt.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new $12c6b0ab9da17bee$var$nr))), 0 === r.readers.length && (r.readers.push(new $12c6b0ab9da17bee$var$le(e)), r.readers.push(new $12c6b0ab9da17bee$var$Ut), r.readers.push(new $12c6b0ab9da17bee$var$le(e)), r.readers.push(new $12c6b0ab9da17bee$var$kt), r.readers.push(new $12c6b0ab9da17bee$var$Xt), r.readers.push(new $12c6b0ab9da17bee$var$sr)), r;
    }
    return $12c6b0ab9da17bee$var$cr(e, t), e.prototype.decodeRow = function(t, e, r) {
        for(var n = 0; n < this.readers.length; n++)try {
            return this.readers[n].decodeRow(t, e, r);
        } catch (t) {}
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        this.readers.forEach(function(t) {
            return t.reset();
        });
    }, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$hr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$fr(r), e, r) || this;
    }
    $12c6b0ab9da17bee$var$hr(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$lr, $12c6b0ab9da17bee$var$dr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$pr = function() {
    function t(t, e, r) {
        this.ecCodewords = t, this.ecBlocks = [
            e
        ], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
        return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $12c6b0ab9da17bee$var$gr = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $12c6b0ab9da17bee$var$yr = function() {
    function t(t, e, r, n, o, i) {
        var a, u;
        this.versionNumber = t, this.symbolSizeRows = e, this.symbolSizeColumns = r, this.dataRegionSizeRows = n, this.dataRegionSizeColumns = o, this.ecBlocks = i;
        var s = 0, c = i.getECCodewords(), f = i.getECBlocks();
        try {
            for(var h = $12c6b0ab9da17bee$var$dr(f), l = h.next(); !l.done; l = h.next()){
                var d = l.value;
                s += d.getCount() * (d.getDataCodewords() + c);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (u = h.return) && u.call(h);
            } finally{
                if (a) throw a.error;
            }
        }
        this.totalCodewords = s;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, r) {
        var n, o;
        if (0 != (1 & e) || 0 != (1 & r)) throw new $12c6b0ab9da17bee$var$R;
        try {
            for(var i = $12c6b0ab9da17bee$var$dr(t.VERSIONS), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (u.symbolSizeRows === e && u.symbolSizeColumns === r) return u;
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.buildVersions = function() {
        return [
            new t(1, 10, 10, 8, 8, new $12c6b0ab9da17bee$var$pr(5, new $12c6b0ab9da17bee$var$gr(1, 3))),
            new t(2, 12, 12, 10, 10, new $12c6b0ab9da17bee$var$pr(7, new $12c6b0ab9da17bee$var$gr(1, 5))),
            new t(3, 14, 14, 12, 12, new $12c6b0ab9da17bee$var$pr(10, new $12c6b0ab9da17bee$var$gr(1, 8))),
            new t(4, 16, 16, 14, 14, new $12c6b0ab9da17bee$var$pr(12, new $12c6b0ab9da17bee$var$gr(1, 12))),
            new t(5, 18, 18, 16, 16, new $12c6b0ab9da17bee$var$pr(14, new $12c6b0ab9da17bee$var$gr(1, 18))),
            new t(6, 20, 20, 18, 18, new $12c6b0ab9da17bee$var$pr(18, new $12c6b0ab9da17bee$var$gr(1, 22))),
            new t(7, 22, 22, 20, 20, new $12c6b0ab9da17bee$var$pr(20, new $12c6b0ab9da17bee$var$gr(1, 30))),
            new t(8, 24, 24, 22, 22, new $12c6b0ab9da17bee$var$pr(24, new $12c6b0ab9da17bee$var$gr(1, 36))),
            new t(9, 26, 26, 24, 24, new $12c6b0ab9da17bee$var$pr(28, new $12c6b0ab9da17bee$var$gr(1, 44))),
            new t(10, 32, 32, 14, 14, new $12c6b0ab9da17bee$var$pr(36, new $12c6b0ab9da17bee$var$gr(1, 62))),
            new t(11, 36, 36, 16, 16, new $12c6b0ab9da17bee$var$pr(42, new $12c6b0ab9da17bee$var$gr(1, 86))),
            new t(12, 40, 40, 18, 18, new $12c6b0ab9da17bee$var$pr(48, new $12c6b0ab9da17bee$var$gr(1, 114))),
            new t(13, 44, 44, 20, 20, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(1, 144))),
            new t(14, 48, 48, 22, 22, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(1, 174))),
            new t(15, 52, 52, 24, 24, new $12c6b0ab9da17bee$var$pr(42, new $12c6b0ab9da17bee$var$gr(2, 102))),
            new t(16, 64, 64, 14, 14, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(2, 140))),
            new t(17, 72, 72, 16, 16, new $12c6b0ab9da17bee$var$pr(36, new $12c6b0ab9da17bee$var$gr(4, 92))),
            new t(18, 80, 80, 18, 18, new $12c6b0ab9da17bee$var$pr(48, new $12c6b0ab9da17bee$var$gr(4, 114))),
            new t(19, 88, 88, 20, 20, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(4, 144))),
            new t(20, 96, 96, 22, 22, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(4, 174))),
            new t(21, 104, 104, 24, 24, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(6, 136))),
            new t(22, 120, 120, 18, 18, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(6, 175))),
            new t(23, 132, 132, 20, 20, new $12c6b0ab9da17bee$var$pr(62, new $12c6b0ab9da17bee$var$gr(8, 163))),
            new t(24, 144, 144, 22, 22, new $12c6b0ab9da17bee$var$pr(62, new $12c6b0ab9da17bee$var$gr(8, 156), new $12c6b0ab9da17bee$var$gr(2, 155))),
            new t(25, 8, 18, 6, 16, new $12c6b0ab9da17bee$var$pr(7, new $12c6b0ab9da17bee$var$gr(1, 5))),
            new t(26, 8, 32, 6, 14, new $12c6b0ab9da17bee$var$pr(11, new $12c6b0ab9da17bee$var$gr(1, 10))),
            new t(27, 12, 26, 10, 24, new $12c6b0ab9da17bee$var$pr(14, new $12c6b0ab9da17bee$var$gr(1, 16))),
            new t(28, 12, 36, 10, 16, new $12c6b0ab9da17bee$var$pr(18, new $12c6b0ab9da17bee$var$gr(1, 22))),
            new t(29, 16, 36, 14, 16, new $12c6b0ab9da17bee$var$pr(24, new $12c6b0ab9da17bee$var$gr(1, 32))),
            new t(30, 16, 48, 14, 22, new $12c6b0ab9da17bee$var$pr(28, new $12c6b0ab9da17bee$var$gr(1, 49)))
        ];
    }, t.VERSIONS = t.buildVersions(), t;
}(), $12c6b0ab9da17bee$var$wr = function() {
    function t(e) {
        var r = e.getHeight();
        if (r < 8 || r > 144 || 0 != (1 & r)) throw new $12c6b0ab9da17bee$var$R;
        this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new $12c6b0ab9da17bee$var$x(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
        return this.version;
    }, t.readVersion = function(t) {
        var e = t.getHeight(), r = t.getWidth();
        return $12c6b0ab9da17bee$var$yr.getVersionForDimensions(e, r);
    }, t.prototype.readCodewords = function() {
        var t = new Int8Array(this.version.getTotalCodewords()), e = 0, r = 4, n = 0, o = this.mappingBitMatrix.getHeight(), i = this.mappingBitMatrix.getWidth(), a = !1, u = !1, s = !1, c = !1;
        do if (r !== o || 0 !== n || a) {
            if (r !== o - 2 || 0 !== n || 0 == (3 & i) || u) {
                if (r !== o + 4 || 2 !== n || 0 != (7 & i) || s) {
                    if (r !== o - 2 || 0 !== n || 4 != (7 & i) || c) {
                        do r < o && n >= 0 && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r -= 2, n += 2;
                        while (r >= 0 && n < i);
                        r += 1, n += 3;
                        do r >= 0 && n < i && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r += 2, n -= 2;
                        while (r < o && n >= 0);
                        r += 3, n += 1;
                    } else t[e++] = 255 & this.readCorner4(o, i), r -= 2, n += 2, c = !0;
                } else t[e++] = 255 & this.readCorner3(o, i), r -= 2, n += 2, s = !0;
            } else t[e++] = 255 & this.readCorner2(o, i), r -= 2, n += 2, u = !0;
        } else t[e++] = 255 & this.readCorner1(o, i), r -= 2, n += 2, a = !0;
        while (r < o || n < i);
        if (e !== this.version.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$R;
        return t;
    }, t.prototype.readModule = function(t, e, r, n) {
        return t < 0 && (t += r, e += 4 - (r + 4 & 7)), e < 0 && (e += n, t += 4 - (n + 4 & 7)), this.readMappingMatrix.set(e, t), this.mappingBitMatrix.get(e, t);
    }, t.prototype.readUtah = function(t, e, r, n) {
        var o = 0;
        return this.readModule(t - 2, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 2, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t, e, r, n) && (o |= 1), o;
    }, t.prototype.readCorner1 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 1, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 4, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(t) {
        var e = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
        if (t.getHeight() !== e) throw new $12c6b0ab9da17bee$var$l("Dimension of bitMatrix must match the version size");
        for(var n = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), i = e / n | 0, a = r / o | 0, u = new $12c6b0ab9da17bee$var$x(a * o, i * n), s = 0; s < i; ++s)for(var c = s * n, f = 0; f < a; ++f)for(var h = f * o, d = 0; d < n; ++d)for(var p = s * (n + 2) + 1 + d, g = c + d, y = 0; y < o; ++y){
            var w = f * (o + 2) + 1 + y;
            if (t.get(w, p)) {
                var _ = h + y;
                u.set(_, g);
            }
        }
        return u;
    }, t;
}(), $12c6b0ab9da17bee$var$_r = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$vr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r) {
        var n, o, i, a, u = r.getECBlocks(), s = 0, c = u.getECBlocks();
        try {
            for(var f = $12c6b0ab9da17bee$var$_r(c), h = f.next(); !h.done; h = f.next())s += (w = h.value).getCount();
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (o = f.return) && o.call(f);
            } finally{
                if (n) throw n.error;
            }
        }
        var d = new Array(s), p = 0;
        try {
            for(var g = $12c6b0ab9da17bee$var$_r(c), y = g.next(); !y.done; y = g.next())for(var w = y.value, _ = 0; _ < w.getCount(); _++){
                var v = w.getDataCodewords(), m = u.getECCodewords() + v;
                d[p++] = new t(v, new Uint8Array(m));
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (a = g.return) && a.call(g);
            } finally{
                if (i) throw i.error;
            }
        }
        var A = d[0].codewords.length - u.getECCodewords(), E = A - 1, C = 0;
        for(_ = 0; _ < E; _++)for(var I = 0; I < p; I++)d[I].codewords[_] = e[C++];
        var S = 24 === r.getVersionNumber(), O = S ? 8 : p;
        for(I = 0; I < O; I++)d[I].codewords[A - 1] = e[C++];
        var T = d[0].codewords.length;
        for(_ = A; _ < T; _++)for(I = 0; I < p; I++){
            var b = S ? (I + 8) % p : I, R = S && b > 7 ? _ - 1 : _;
            d[b].codewords[R] = e[C++];
        }
        if (C !== e.length) throw new $12c6b0ab9da17bee$var$l;
        return d;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}(), $12c6b0ab9da17bee$var$mr = function() {
    function t(t) {
        this.bytes = t, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
        return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
        return this.byteOffset;
    }, t.prototype.readBits = function(t) {
        if (t < 1 || t > 32 || t > this.available()) throw new $12c6b0ab9da17bee$var$l("" + t);
        var e = 0, r = this.bitOffset, n = this.byteOffset, o = this.bytes;
        if (r > 0) {
            var i = 8 - r, a = t < i ? t : i, u = 255 >> 8 - a << (s = i - a);
            e = (o[n] & u) >> s, t -= a, 8 === (r += a) && (r = 0, n++);
        }
        if (t > 0) {
            for(; t >= 8;)e = e << 8 | 255 & o[n], n++, t -= 8;
            if (t > 0) {
                var s;
                u = 255 >> (s = 8 - t) << s;
                e = e << t | (o[n] & u) >> s, r += t;
            }
        }
        return this.bitOffset = r, this.byteOffset = n, e;
    }, t.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
}();
!function(t) {
    t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
}($12c6b0ab9da17bee$var$lr || ($12c6b0ab9da17bee$var$lr = {}));
var $12c6b0ab9da17bee$var$Ar, $12c6b0ab9da17bee$var$Er = function() {
    function t() {}
    return t.decode = function(t) {
        var e = new $12c6b0ab9da17bee$var$mr(t), r = new $12c6b0ab9da17bee$var$k, n = new $12c6b0ab9da17bee$var$k, o = new Array, i = $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
        do if (i === $12c6b0ab9da17bee$var$lr.ASCII_ENCODE) i = this.decodeAsciiSegment(e, r, n);
        else {
            switch(i){
                case $12c6b0ab9da17bee$var$lr.C40_ENCODE:
                    this.decodeC40Segment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.TEXT_ENCODE:
                    this.decodeTextSegment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.BASE256_ENCODE:
                    this.decodeBase256Segment(e, r, o);
                    break;
                default:
                    throw new $12c6b0ab9da17bee$var$R;
            }
            i = $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
        }
        while (i !== $12c6b0ab9da17bee$var$lr.PAD_ENCODE && e.available() > 0);
        return n.length() > 0 && r.append(n.toString()), new $12c6b0ab9da17bee$var$at(t, r.toString(), 0 === o.length ? null : o, null);
    }, t.decodeAsciiSegment = function(t, e, r) {
        var n = !1;
        do {
            var o = t.readBits(8);
            if (0 === o) throw new $12c6b0ab9da17bee$var$R;
            if (o <= 128) return n && (o += 128), e.append(String.fromCharCode(o - 1)), $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
            if (129 === o) return $12c6b0ab9da17bee$var$lr.PAD_ENCODE;
            if (o <= 229) {
                var i = o - 130;
                i < 10 && e.append("0"), e.append("" + i);
            } else switch(o){
                case 230:
                    return $12c6b0ab9da17bee$var$lr.C40_ENCODE;
                case 231:
                    return $12c6b0ab9da17bee$var$lr.BASE256_ENCODE;
                case 232:
                    e.append(String.fromCharCode(29));
                    break;
                case 233:
                case 234:
                case 241:
                    break;
                case 235:
                    n = !0;
                    break;
                case 236:
                    e.append("[)>\x1e05\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 237:
                    e.append("[)>\x1e06\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $12c6b0ab9da17bee$var$lr.ANSIX12_ENCODE;
                case 239:
                    return $12c6b0ab9da17bee$var$lr.TEXT_ENCODE;
                case 240:
                    return $12c6b0ab9da17bee$var$lr.EDIFACT_ENCODE;
                default:
                    if (254 !== o || 0 !== t.available()) throw new $12c6b0ab9da17bee$var$R;
            }
        }while (t.available() > 0);
        return $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
    }, t.decodeC40Segment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.C40_BASIC_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                            var s = this.C40_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.C40_SHIFT2_SET_CHARS.length) {
                            s = this.C40_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                        o = 0;
                        break;
                    case 3:
                        r ? (e.append(String.fromCharCode(u + 224)), r = !1) : e.append(String.fromCharCode(u + 96)), o = 0;
                        break;
                    default:
                        throw new $12c6b0ab9da17bee$var$R;
                }
            }
        }while (t.available() > 0);
    }, t.decodeTextSegment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.TEXT_BASIC_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                            var s = this.TEXT_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.TEXT_SHIFT2_SET_CHARS.length) {
                            s = this.TEXT_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                        o = 0;
                        break;
                    case 3:
                        if (!(u < this.TEXT_SHIFT3_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                        s = this.TEXT_SHIFT3_SET_CHARS[u];
                        r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s), o = 0;
                        break;
                    default:
                        throw new $12c6b0ab9da17bee$var$R;
                }
            }
        }while (t.available() > 0);
    }, t.decodeAnsiX12Segment = function(t, e) {
        var r = [];
        do {
            if (8 === t.available()) return;
            var n = t.readBits(8);
            if (254 === n) return;
            this.parseTwoBytes(n, t.readBits(8), r);
            for(var o = 0; o < 3; o++){
                var i = r[o];
                switch(i){
                    case 0:
                        e.append("\r");
                        break;
                    case 1:
                        e.append("*");
                        break;
                    case 2:
                        e.append(">");
                        break;
                    case 3:
                        e.append(" ");
                        break;
                    default:
                        if (i < 14) e.append(String.fromCharCode(i + 44));
                        else {
                            if (!(i < 40)) throw new $12c6b0ab9da17bee$var$R;
                            e.append(String.fromCharCode(i + 51));
                        }
                }
            }
        }while (t.available() > 0);
    }, t.parseTwoBytes = function(t, e, r) {
        var n = (t << 8) + e - 1, o = Math.floor(n / 1600);
        r[0] = o, n -= 1600 * o, o = Math.floor(n / 40), r[1] = o, r[2] = n - 40 * o;
    }, t.decodeEdifactSegment = function(t, e) {
        do {
            if (t.available() <= 16) return;
            for(var r = 0; r < 4; r++){
                var n = t.readBits(6);
                if (31 === n) {
                    var o = 8 - t.getBitOffset();
                    return void (8 !== o && t.readBits(o));
                }
                0 == (32 & n) && (n |= 64), e.append(String.fromCharCode(n));
            }
        }while (t.available() > 0);
    }, t.decodeBase256Segment = function(t, e, r) {
        var n, o = 1 + t.getByteOffset(), i = this.unrandomize255State(t.readBits(8), o++);
        if ((n = 0 === i ? t.available() / 8 | 0 : i < 250 ? i : 250 * (i - 249) + this.unrandomize255State(t.readBits(8), o++)) < 0) throw new $12c6b0ab9da17bee$var$R;
        for(var a = new Uint8Array(n), u = 0; u < n; u++){
            if (t.available() < 8) throw new $12c6b0ab9da17bee$var$R;
            a[u] = this.unrandomize255State(t.readBits(8), o++);
        }
        r.push(a);
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(a, $12c6b0ab9da17bee$var$F.ISO88591));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$yt("Platform does not support required encoding: " + t.message);
        }
    }, t.unrandomize255State = function(t, e) {
        var r = t - (149 * e % 255 + 1);
        return r >= 0 ? r : r + 256;
    }, t.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ], t.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ], t;
}(), $12c6b0ab9da17bee$var$Cr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ir = function() {
    function t() {
        this.rsDecoder = new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(t) {
        var e, r, n = new $12c6b0ab9da17bee$var$wr(t), o = n.getVersion(), i = n.readCodewords(), a = $12c6b0ab9da17bee$var$vr.getDataBlocks(i, o), u = 0;
        try {
            for(var s = $12c6b0ab9da17bee$var$Cr(a), c = s.next(); !c.done; c = s.next())u += c.value.getNumDataCodewords();
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var f = new Uint8Array(u), h = a.length, l = 0; l < h; l++){
            var d = a[l], p = d.getCodewords(), g = d.getNumDataCodewords();
            this.correctErrors(p, g);
            for(var y = 0; y < g; y++)f[y * h + l] = p[y];
        }
        return $12c6b0ab9da17bee$var$Er.decode(f);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$g;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $12c6b0ab9da17bee$var$Sr = function() {
    function t(t) {
        this.image = t, this.rectangleDetector = new $12c6b0ab9da17bee$var$St(this.image);
    }
    return t.prototype.detect = function() {
        var e = this.rectangleDetector.detect(), r = this.detectSolid1(e);
        if ((r = this.detectSolid2(r))[3] = this.correctTopRight(r), !r[3]) throw new $12c6b0ab9da17bee$var$U;
        var n = (r = this.shiftToModuleCenter(r))[0], o = r[1], i = r[2], a = r[3], u = this.transitionsBetween(n, a) + 1, s = this.transitionsBetween(i, a) + 1;
        1 == (1 & u) && (u += 1), 1 == (1 & s) && (s += 1), 4 * u < 7 * s && 4 * s < 7 * u && (u = s = Math.max(u, s));
        var c = t.sampleGrid(this.image, n, o, i, a, u, s);
        return new $12c6b0ab9da17bee$var$Et(c, [
            n,
            o,
            i,
            a
        ]);
    }, t.shiftPoint = function(t, e, r) {
        var n = (e.getX() - t.getX()) / (r + 1), o = (e.getY() - t.getY()) / (r + 1);
        return new $12c6b0ab9da17bee$var$At(t.getX() + n, t.getY() + o);
    }, t.moveAway = function(t, e, r) {
        var n = t.getX(), o = t.getY();
        return n < e ? n -= 1 : n += 1, o < r ? o -= 1 : o += 1, new $12c6b0ab9da17bee$var$At(n, o);
    }, t.prototype.detectSolid1 = function(t) {
        var e = t[0], r = t[1], n = t[3], o = t[2], i = this.transitionsBetween(e, r), a = this.transitionsBetween(r, n), u = this.transitionsBetween(n, o), s = this.transitionsBetween(o, e), c = i, f = [
            o,
            e,
            r,
            n
        ];
        return c > a && (c = a, f[0] = e, f[1] = r, f[2] = n, f[3] = o), c > u && (c = u, f[0] = r, f[1] = n, f[2] = o, f[3] = e), c > s && (f[0] = n, f[1] = o, f[2] = e, f[3] = r), f;
    }, t.prototype.detectSolid2 = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = t.shiftPoint(n, o, 4 * (a + 1)), s = t.shiftPoint(o, n, 4 * (a + 1));
        return this.transitionsBetween(u, r) < this.transitionsBetween(s, i) ? (e[0] = r, e[1] = n, e[2] = o, e[3] = i) : (e[0] = n, e[1] = o, e[2] = i, e[3] = r), e;
    }, t.prototype.correctTopRight = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = this.transitionsBetween(n, i), s = t.shiftPoint(r, n, 4 * (u + 1)), c = t.shiftPoint(o, n, 4 * (a + 1));
        a = this.transitionsBetween(s, i), u = this.transitionsBetween(c, i);
        var f = new $12c6b0ab9da17bee$var$At(i.getX() + (o.getX() - n.getX()) / (a + 1), i.getY() + (o.getY() - n.getY()) / (a + 1)), h = new $12c6b0ab9da17bee$var$At(i.getX() + (r.getX() - n.getX()) / (u + 1), i.getY() + (r.getY() - n.getY()) / (u + 1));
        return this.isValid(f) ? this.isValid(h) ? this.transitionsBetween(s, f) + this.transitionsBetween(c, f) > this.transitionsBetween(s, h) + this.transitionsBetween(c, h) ? f : h : f : this.isValid(h) ? h : null;
    }, t.prototype.shiftToModuleCenter = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i) + 1, u = this.transitionsBetween(o, i) + 1, s = t.shiftPoint(r, n, 4 * u), c = t.shiftPoint(o, n, 4 * a);
        1 == (1 & (a = this.transitionsBetween(s, i) + 1)) && (a += 1), 1 == (1 & (u = this.transitionsBetween(c, i) + 1)) && (u += 1);
        var f, h, l = (r.getX() + n.getX() + o.getX() + i.getX()) / 4, d = (r.getY() + n.getY() + o.getY() + i.getY()) / 4;
        return r = t.moveAway(r, l, d), n = t.moveAway(n, l, d), o = t.moveAway(o, l, d), i = t.moveAway(i, l, d), s = t.shiftPoint(r, n, 4 * u), s = t.shiftPoint(s, i, 4 * a), f = t.shiftPoint(n, r, 4 * u), f = t.shiftPoint(f, o, 4 * a), c = t.shiftPoint(o, i, 4 * u), c = t.shiftPoint(c, n, 4 * a), h = t.shiftPoint(i, o, 4 * u), [
            s,
            f,
            c,
            h = t.shiftPoint(h, r, 4 * a)
        ];
    }, t.prototype.isValid = function(t) {
        return t.getX() >= 0 && t.getX() < this.image.getWidth() && t.getY() > 0 && t.getY() < this.image.getHeight();
    }, t.sampleGrid = function(t, e, r, n, o, i, a) {
        return $12c6b0ab9da17bee$var$Nt.getInstance().sampleGrid(t, i, a, .5, .5, i - .5, .5, i - .5, a - .5, .5, a - .5, e.getX(), e.getY(), o.getX(), o.getY(), n.getX(), n.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(t, e) {
        var r = Math.trunc(t.getX()), n = Math.trunc(t.getY()), o = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.abs(i - n) > Math.abs(o - r);
        if (a) {
            var u = r;
            r = n, n = u, u = o, o = i, i = u;
        }
        for(var s = Math.abs(o - r), c = Math.abs(i - n), f = -s / 2, h = n < i ? 1 : -1, l = r < o ? 1 : -1, d = 0, p = this.image.get(a ? n : r, a ? r : n), g = r, y = n; g !== o; g += l){
            var w = this.image.get(a ? y : g, a ? g : y);
            if (w !== p && (d++, p = w), (f += c) > 0) {
                if (y === i) break;
                y += h, f -= s;
            }
        }
        return d;
    }, t;
}(), $12c6b0ab9da17bee$var$Or = function() {
    function t() {
        this.decoder = new $12c6b0ab9da17bee$var$Ir;
    }
    return t.prototype.decode = function(e, r) {
        var n, o;
        if (void 0 === r && (r = null), null != r && r.has($12c6b0ab9da17bee$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decode(i), o = t.NO_POINTS;
        } else {
            var a = new $12c6b0ab9da17bee$var$Sr(e.getBlackMatrix()).detect();
            n = this.decoder.decode(a.getBits()), o = a.getPoints();
        }
        var u = n.getRawBytes(), s = new $12c6b0ab9da17bee$var$et(n.getText(), u, 8 * u.length, o, $12c6b0ab9da17bee$var$nt.DATA_MATRIX, $12c6b0ab9da17bee$var$w.currentTimeMillis()), c = n.getByteSegments();
        null != c && s.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, c);
        var f = n.getECLevel();
        return null != f && s.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, f), s;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null == e || null == r) throw new $12c6b0ab9da17bee$var$U;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = (r[0] - a + 1) / n, s = (i - o + 1) / n;
        if (u <= 0 || s <= 0) throw new $12c6b0ab9da17bee$var$U;
        var c = n / 2;
        o += c, a += c;
        for(var f = new $12c6b0ab9da17bee$var$x(u, s), h = 0; h < s; h++)for(var l = o + h * n, d = 0; d < u; d++)t.get(a + d * n, l) && f.set(d, h);
        return f;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getWidth(), n = t[0], o = t[1]; n < r && e.get(n, o);)n++;
        if (n === r) throw new $12c6b0ab9da17bee$var$U;
        var i = n - t[0];
        if (0 === i) throw new $12c6b0ab9da17bee$var$U;
        return i;
    }, t.NO_POINTS = [], t;
}(), $12c6b0ab9da17bee$var$Tr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Or, e) || this;
    }
    $12c6b0ab9da17bee$var$Tr(e, t);
}($12c6b0ab9da17bee$var$tt), function(t) {
    t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
}($12c6b0ab9da17bee$var$Ar || ($12c6b0ab9da17bee$var$Ar = {}));
var $12c6b0ab9da17bee$var$br, $12c6b0ab9da17bee$var$Rr = function() {
    function t(e, r, n) {
        this.value = e, this.stringValue = r, this.bits = n, t.FOR_BITS.set(n, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.fromString = function(e) {
        switch(e){
            case "L":
                return t.L;
            case "M":
                return t.M;
            case "Q":
                return t.Q;
            case "H":
                return t.H;
            default:
                throw new $12c6b0ab9da17bee$var$f(e + "not available");
        }
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.forBits = function(e) {
        if (e < 0 || e >= t.FOR_BITS.size) throw new $12c6b0ab9da17bee$var$l;
        return t.FOR_BITS.get(e);
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.L = new t($12c6b0ab9da17bee$var$Ar.L, "L", 1), t.M = new t($12c6b0ab9da17bee$var$Ar.M, "M", 0), t.Q = new t($12c6b0ab9da17bee$var$Ar.Q, "Q", 3), t.H = new t($12c6b0ab9da17bee$var$Ar.H, "H", 2), t;
}(), $12c6b0ab9da17bee$var$Nr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Dr = function() {
    function t(t) {
        this.errorCorrectionLevel = $12c6b0ab9da17bee$var$Rr.forBits(t >> 3 & 3), this.dataMask = 7 & t;
    }
    return t.numBitsDiffering = function(t, e) {
        return $12c6b0ab9da17bee$var$I.bitCount(t ^ e);
    }, t.decodeFormatInformation = function(e, r) {
        var n = t.doDecodeFormatInformation(e, r);
        return null !== n ? n : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, r ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, r) {
        var n, o, i = Number.MAX_SAFE_INTEGER, a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$Nr(t.FORMAT_INFO_DECODE_LOOKUP), s = u.next(); !s.done; s = u.next()){
                var c = s.value, f = c[0];
                if (f === e || f === r) return new t(c[1]);
                var h = t.numBitsDiffering(e, f);
                h < i && (a = c[1], i = h), e !== r && (h = t.numBitsDiffering(r, f)) < i && (a = c[1], i = h);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = u.return) && o.call(u);
            } finally{
                if (n) throw n.error;
            }
        }
        return i <= 3 ? new t(a) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
        return this.dataMask;
    }, t.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.errorCorrectionLevel === r.errorCorrectionLevel && this.dataMask === r.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            21522,
            0
        ]),
        Int32Array.from([
            20773,
            1
        ]),
        Int32Array.from([
            24188,
            2
        ]),
        Int32Array.from([
            23371,
            3
        ]),
        Int32Array.from([
            17913,
            4
        ]),
        Int32Array.from([
            16590,
            5
        ]),
        Int32Array.from([
            20375,
            6
        ]),
        Int32Array.from([
            19104,
            7
        ]),
        Int32Array.from([
            30660,
            8
        ]),
        Int32Array.from([
            29427,
            9
        ]),
        Int32Array.from([
            32170,
            10
        ]),
        Int32Array.from([
            30877,
            11
        ]),
        Int32Array.from([
            26159,
            12
        ]),
        Int32Array.from([
            25368,
            13
        ]),
        Int32Array.from([
            27713,
            14
        ]),
        Int32Array.from([
            26998,
            15
        ]),
        Int32Array.from([
            5769,
            16
        ]),
        Int32Array.from([
            5054,
            17
        ]),
        Int32Array.from([
            7399,
            18
        ]),
        Int32Array.from([
            6608,
            19
        ]),
        Int32Array.from([
            1890,
            20
        ]),
        Int32Array.from([
            597,
            21
        ]),
        Int32Array.from([
            3340,
            22
        ]),
        Int32Array.from([
            2107,
            23
        ]),
        Int32Array.from([
            13663,
            24
        ]),
        Int32Array.from([
            12392,
            25
        ]),
        Int32Array.from([
            16177,
            26
        ]),
        Int32Array.from([
            14854,
            27
        ]),
        Int32Array.from([
            9396,
            28
        ]),
        Int32Array.from([
            8579,
            29
        ]),
        Int32Array.from([
            11994,
            30
        ]),
        Int32Array.from([
            11245,
            31
        ])
    ], t;
}(), $12c6b0ab9da17bee$var$Pr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Mr = function() {
    function t(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        this.ecCodewordsPerBlock = t, this.ecBlocks = e;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
        var t, e, r = 0, n = this.ecBlocks;
        try {
            for(var o = $12c6b0ab9da17bee$var$Pr(n), i = o.next(); !i.done; i = o.next())r += i.value.getCount();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }, t.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $12c6b0ab9da17bee$var$Br = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $12c6b0ab9da17bee$var$Lr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Fr = function() {
    function t(t, e) {
        for(var r, n, o = [], i = 2; i < arguments.length; i++)o[i - 2] = arguments[i];
        this.versionNumber = t, this.alignmentPatternCenters = e, this.ecBlocks = o;
        var a = 0, u = o[0].getECCodewordsPerBlock(), s = o[0].getECBlocks();
        try {
            for(var c = $12c6b0ab9da17bee$var$Lr(s), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                a += h.getCount() * (h.getDataCodewords() + u);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (n = c.return) && n.call(c);
            } finally{
                if (r) throw r.error;
            }
        }
        this.totalCodewords = a;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(t) {
        return this.ecBlocks[t.getValue()];
    }, t.getProvisionalVersionForDimension = function(t) {
        if (t % 4 != 1) throw new $12c6b0ab9da17bee$var$R;
        try {
            return this.getVersionForNumber((t - 17) / 4);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R;
        }
    }, t.getVersionForNumber = function(e) {
        if (e < 1 || e > 40) throw new $12c6b0ab9da17bee$var$l;
        return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
        for(var r = Number.MAX_SAFE_INTEGER, n = 0, o = 0; o < t.VERSION_DECODE_INFO.length; o++){
            var i = t.VERSION_DECODE_INFO[o];
            if (i === e) return t.getVersionForNumber(o + 7);
            var a = $12c6b0ab9da17bee$var$Dr.numBitsDiffering(e, i);
            a < r && (n = o + 7, r = a);
        }
        return r <= 3 ? t.getVersionForNumber(n) : null;
    }, t.prototype.buildFunctionPattern = function() {
        var t = this.getDimensionForVersion(), e = new $12c6b0ab9da17bee$var$x(t);
        e.setRegion(0, 0, 9, 9), e.setRegion(t - 8, 0, 8, 9), e.setRegion(0, t - 8, 9, 8);
        for(var r = this.alignmentPatternCenters.length, n = 0; n < r; n++)for(var o = this.alignmentPatternCenters[n] - 2, i = 0; i < r; i++)0 === n && (0 === i || i === r - 1) || n === r - 1 && 0 === i || e.setRegion(this.alignmentPatternCenters[i] - 2, o, 5, 5);
        return e.setRegion(6, 9, 1, t - 17), e.setRegion(9, 6, t - 17, 1), this.versionNumber > 6 && (e.setRegion(t - 11, 0, 3, 6), e.setRegion(0, t - 11, 6, 3)), e;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
        31892,
        34236,
        39577,
        42195,
        48118,
        51042,
        55367,
        58893,
        63784,
        68472,
        70749,
        76311,
        79154,
        84390,
        87683,
        92361,
        96236,
        102084,
        102881,
        110507,
        110734,
        117786,
        119615,
        126325,
        127568,
        133589,
        136944,
        141498,
        145311,
        150283,
        152622,
        158308,
        161089,
        167017
    ]), t.VERSIONS = [
        new t(1, new Int32Array(0), new $12c6b0ab9da17bee$var$Mr(7, new $12c6b0ab9da17bee$var$Br(1, 19)), new $12c6b0ab9da17bee$var$Mr(10, new $12c6b0ab9da17bee$var$Br(1, 16)), new $12c6b0ab9da17bee$var$Mr(13, new $12c6b0ab9da17bee$var$Br(1, 13)), new $12c6b0ab9da17bee$var$Mr(17, new $12c6b0ab9da17bee$var$Br(1, 9))),
        new t(2, Int32Array.from([
            6,
            18
        ]), new $12c6b0ab9da17bee$var$Mr(10, new $12c6b0ab9da17bee$var$Br(1, 34)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(1, 28)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(1, 22)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 16))),
        new t(3, Int32Array.from([
            6,
            22
        ]), new $12c6b0ab9da17bee$var$Mr(15, new $12c6b0ab9da17bee$var$Br(1, 55)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(1, 44)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 17)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 13))),
        new t(4, Int32Array.from([
            6,
            26
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(1, 80)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 32)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(2, 24)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(4, 9))),
        new t(5, Int32Array.from([
            6,
            30
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(1, 108)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 43)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 15), new $12c6b0ab9da17bee$var$Br(2, 16)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 11), new $12c6b0ab9da17bee$var$Br(2, 12))),
        new t(6, Int32Array.from([
            6,
            34
        ]), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 68)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(4, 27)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 19)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 15))),
        new t(7, Int32Array.from([
            6,
            22,
            38
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(2, 78)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(4, 31)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(4, 15)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 13), new $12c6b0ab9da17bee$var$Br(1, 14))),
        new t(8, Int32Array.from([
            6,
            24,
            42
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 97)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 38), new $12c6b0ab9da17bee$var$Br(2, 39)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(4, 18), new $12c6b0ab9da17bee$var$Br(2, 19)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 14), new $12c6b0ab9da17bee$var$Br(2, 15))),
        new t(9, Int32Array.from([
            6,
            26,
            46
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(2, 116)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(3, 36), new $12c6b0ab9da17bee$var$Br(2, 37)), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(4, 16), new $12c6b0ab9da17bee$var$Br(4, 17)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 12), new $12c6b0ab9da17bee$var$Br(4, 13))),
        new t(10, Int32Array.from([
            6,
            28,
            50
        ]), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 68), new $12c6b0ab9da17bee$var$Br(2, 69)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 43), new $12c6b0ab9da17bee$var$Br(1, 44)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(6, 19), new $12c6b0ab9da17bee$var$Br(2, 20)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 15), new $12c6b0ab9da17bee$var$Br(2, 16))),
        new t(11, Int32Array.from([
            6,
            30,
            54
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(4, 81)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(1, 50), new $12c6b0ab9da17bee$var$Br(4, 51)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 22), new $12c6b0ab9da17bee$var$Br(4, 23)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(3, 12), new $12c6b0ab9da17bee$var$Br(8, 13))),
        new t(12, Int32Array.from([
            6,
            32,
            58
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 92), new $12c6b0ab9da17bee$var$Br(2, 93)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(6, 36), new $12c6b0ab9da17bee$var$Br(2, 37)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 20), new $12c6b0ab9da17bee$var$Br(6, 21)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(7, 14), new $12c6b0ab9da17bee$var$Br(4, 15))),
        new t(13, Int32Array.from([
            6,
            34,
            62
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 107)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(8, 37), new $12c6b0ab9da17bee$var$Br(1, 38)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(8, 20), new $12c6b0ab9da17bee$var$Br(4, 21)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(12, 11), new $12c6b0ab9da17bee$var$Br(4, 12))),
        new t(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 115), new $12c6b0ab9da17bee$var$Br(1, 116)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 40), new $12c6b0ab9da17bee$var$Br(5, 41)), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(11, 16), new $12c6b0ab9da17bee$var$Br(5, 17)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(11, 12), new $12c6b0ab9da17bee$var$Br(5, 13))),
        new t(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(5, 87), new $12c6b0ab9da17bee$var$Br(1, 88)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(5, 41), new $12c6b0ab9da17bee$var$Br(5, 42)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 24), new $12c6b0ab9da17bee$var$Br(7, 25)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(11, 12), new $12c6b0ab9da17bee$var$Br(7, 13))),
        new t(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(5, 98), new $12c6b0ab9da17bee$var$Br(1, 99)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(7, 45), new $12c6b0ab9da17bee$var$Br(3, 46)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(15, 19), new $12c6b0ab9da17bee$var$Br(2, 20)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 15), new $12c6b0ab9da17bee$var$Br(13, 16))),
        new t(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 107), new $12c6b0ab9da17bee$var$Br(5, 108)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 46), new $12c6b0ab9da17bee$var$Br(1, 47)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 22), new $12c6b0ab9da17bee$var$Br(15, 23)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(17, 15))),
        new t(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 120), new $12c6b0ab9da17bee$var$Br(1, 121)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(9, 43), new $12c6b0ab9da17bee$var$Br(4, 44)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 22), new $12c6b0ab9da17bee$var$Br(1, 23)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(19, 15))),
        new t(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 113), new $12c6b0ab9da17bee$var$Br(4, 114)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(3, 44), new $12c6b0ab9da17bee$var$Br(11, 45)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(17, 21), new $12c6b0ab9da17bee$var$Br(4, 22)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(9, 13), new $12c6b0ab9da17bee$var$Br(16, 14))),
        new t(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 107), new $12c6b0ab9da17bee$var$Br(5, 108)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(3, 41), new $12c6b0ab9da17bee$var$Br(13, 42)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(15, 24), new $12c6b0ab9da17bee$var$Br(5, 25)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(15, 15), new $12c6b0ab9da17bee$var$Br(10, 16))),
        new t(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 116), new $12c6b0ab9da17bee$var$Br(4, 117)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(17, 42)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 22), new $12c6b0ab9da17bee$var$Br(6, 23)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 16), new $12c6b0ab9da17bee$var$Br(6, 17))),
        new t(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 111), new $12c6b0ab9da17bee$var$Br(7, 112)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 24), new $12c6b0ab9da17bee$var$Br(16, 25)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(34, 13))),
        new t(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 121), new $12c6b0ab9da17bee$var$Br(5, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 47), new $12c6b0ab9da17bee$var$Br(14, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(16, 15), new $12c6b0ab9da17bee$var$Br(14, 16))),
        new t(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(6, 117), new $12c6b0ab9da17bee$var$Br(4, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 45), new $12c6b0ab9da17bee$var$Br(14, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 24), new $12c6b0ab9da17bee$var$Br(16, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(30, 16), new $12c6b0ab9da17bee$var$Br(2, 17))),
        new t(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(8, 106), new $12c6b0ab9da17bee$var$Br(4, 107)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(8, 47), new $12c6b0ab9da17bee$var$Br(13, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 24), new $12c6b0ab9da17bee$var$Br(22, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(22, 15), new $12c6b0ab9da17bee$var$Br(13, 16))),
        new t(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 114), new $12c6b0ab9da17bee$var$Br(2, 115)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(19, 46), new $12c6b0ab9da17bee$var$Br(4, 47)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(28, 22), new $12c6b0ab9da17bee$var$Br(6, 23)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(33, 16), new $12c6b0ab9da17bee$var$Br(4, 17))),
        new t(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(8, 122), new $12c6b0ab9da17bee$var$Br(4, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(22, 45), new $12c6b0ab9da17bee$var$Br(3, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(8, 23), new $12c6b0ab9da17bee$var$Br(26, 24)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(12, 15), new $12c6b0ab9da17bee$var$Br(28, 16))),
        new t(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 117), new $12c6b0ab9da17bee$var$Br(10, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 45), new $12c6b0ab9da17bee$var$Br(23, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 24), new $12c6b0ab9da17bee$var$Br(31, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 15), new $12c6b0ab9da17bee$var$Br(31, 16))),
        new t(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 116), new $12c6b0ab9da17bee$var$Br(7, 117)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(21, 45), new $12c6b0ab9da17bee$var$Br(7, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(1, 23), new $12c6b0ab9da17bee$var$Br(37, 24)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 15), new $12c6b0ab9da17bee$var$Br(26, 16))),
        new t(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 115), new $12c6b0ab9da17bee$var$Br(10, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(19, 47), new $12c6b0ab9da17bee$var$Br(10, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(15, 24), new $12c6b0ab9da17bee$var$Br(25, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(23, 15), new $12c6b0ab9da17bee$var$Br(25, 16))),
        new t(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(13, 115), new $12c6b0ab9da17bee$var$Br(3, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 46), new $12c6b0ab9da17bee$var$Br(29, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(42, 24), new $12c6b0ab9da17bee$var$Br(1, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(23, 15), new $12c6b0ab9da17bee$var$Br(28, 16))),
        new t(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 115)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 46), new $12c6b0ab9da17bee$var$Br(23, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(10, 24), new $12c6b0ab9da17bee$var$Br(35, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 15), new $12c6b0ab9da17bee$var$Br(35, 16))),
        new t(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 115), new $12c6b0ab9da17bee$var$Br(1, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(14, 46), new $12c6b0ab9da17bee$var$Br(21, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(29, 24), new $12c6b0ab9da17bee$var$Br(19, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 15), new $12c6b0ab9da17bee$var$Br(46, 16))),
        new t(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(13, 115), new $12c6b0ab9da17bee$var$Br(6, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(14, 46), new $12c6b0ab9da17bee$var$Br(23, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(44, 24), new $12c6b0ab9da17bee$var$Br(7, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(59, 16), new $12c6b0ab9da17bee$var$Br(1, 17))),
        new t(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(12, 121), new $12c6b0ab9da17bee$var$Br(7, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(12, 47), new $12c6b0ab9da17bee$var$Br(26, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(39, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(22, 15), new $12c6b0ab9da17bee$var$Br(41, 16))),
        new t(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(6, 121), new $12c6b0ab9da17bee$var$Br(14, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 47), new $12c6b0ab9da17bee$var$Br(34, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(46, 24), new $12c6b0ab9da17bee$var$Br(10, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(2, 15), new $12c6b0ab9da17bee$var$Br(64, 16))),
        new t(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 122), new $12c6b0ab9da17bee$var$Br(4, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(29, 46), new $12c6b0ab9da17bee$var$Br(14, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(49, 24), new $12c6b0ab9da17bee$var$Br(10, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(24, 15), new $12c6b0ab9da17bee$var$Br(46, 16))),
        new t(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 122), new $12c6b0ab9da17bee$var$Br(18, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(13, 46), new $12c6b0ab9da17bee$var$Br(32, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(48, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(42, 15), new $12c6b0ab9da17bee$var$Br(32, 16))),
        new t(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(20, 117), new $12c6b0ab9da17bee$var$Br(4, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(40, 47), new $12c6b0ab9da17bee$var$Br(7, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(43, 24), new $12c6b0ab9da17bee$var$Br(22, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(10, 15), new $12c6b0ab9da17bee$var$Br(67, 16))),
        new t(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 118), new $12c6b0ab9da17bee$var$Br(6, 119)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(18, 47), new $12c6b0ab9da17bee$var$Br(31, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(34, 24), new $12c6b0ab9da17bee$var$Br(34, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(20, 15), new $12c6b0ab9da17bee$var$Br(61, 16)))
    ], t;
}();
!function(t) {
    t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
}($12c6b0ab9da17bee$var$br || ($12c6b0ab9da17bee$var$br = {}));
var $12c6b0ab9da17bee$var$kr, $12c6b0ab9da17bee$var$xr = function() {
    function t(t, e) {
        this.value = t, this.isMasked = e;
    }
    return t.prototype.unmaskBitMatrix = function(t, e) {
        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)this.isMasked(r, n) && t.flip(n, r);
    }, t.values = new Map([
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_000,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_000, function(t, e) {
                return 0 == (t + e & 1);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_001,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_001, function(t, e) {
                return 0 == (1 & t);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_010,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_010, function(t, e) {
                return e % 3 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_011,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_011, function(t, e) {
                return (t + e) % 3 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_100,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_100, function(t, e) {
                return 0 == (Math.floor(t / 2) + Math.floor(e / 3) & 1);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_101,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_101, function(t, e) {
                return t * e % 6 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_110,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_110, function(t, e) {
                return t * e % 6 < 3;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_111,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_111, function(t, e) {
                return 0 == (t + e + t * e % 3 & 1);
            })
        ]
    ]), t;
}(), $12c6b0ab9da17bee$var$Vr = function() {
    function t(t) {
        var e = t.getHeight();
        if (e < 21 || 1 != (3 & e)) throw new $12c6b0ab9da17bee$var$R;
        this.bitMatrix = t;
    }
    return t.prototype.readFormatInformation = function() {
        if (null !== this.parsedFormatInfo && void 0 !== this.parsedFormatInfo) return this.parsedFormatInfo;
        for(var t = 0, e = 0; e < 6; e++)t = this.copyBit(e, 8, t);
        t = this.copyBit(7, 8, t), t = this.copyBit(8, 8, t), t = this.copyBit(8, 7, t);
        for(var r = 5; r >= 0; r--)t = this.copyBit(8, r, t);
        var n = this.bitMatrix.getHeight(), o = 0, i = n - 7;
        for(r = n - 1; r >= i; r--)o = this.copyBit(8, r, o);
        for(e = n - 8; e < n; e++)o = this.copyBit(e, 8, o);
        if (this.parsedFormatInfo = $12c6b0ab9da17bee$var$Dr.decodeFormatInformation(t, o), null !== this.parsedFormatInfo) return this.parsedFormatInfo;
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.readVersion = function() {
        if (null !== this.parsedVersion && void 0 !== this.parsedVersion) return this.parsedVersion;
        var t = this.bitMatrix.getHeight(), e = Math.floor((t - 17) / 4);
        if (e <= 6) return $12c6b0ab9da17bee$var$Fr.getVersionForNumber(e);
        for(var r = 0, n = t - 11, o = 5; o >= 0; o--)for(var i = t - 9; i >= n; i--)r = this.copyBit(i, o, r);
        var a = $12c6b0ab9da17bee$var$Fr.decodeVersionInformation(r);
        if (null !== a && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        r = 0;
        for(i = 5; i >= 0; i--)for(o = t - 9; o >= n; o--)r = this.copyBit(i, o, r);
        if (null !== (a = $12c6b0ab9da17bee$var$Fr.decodeVersionInformation(r)) && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.copyBit = function(t, e, r) {
        return (this.isMirror ? this.bitMatrix.get(e, t) : this.bitMatrix.get(t, e)) ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
        var t = this.readFormatInformation(), e = this.readVersion(), r = $12c6b0ab9da17bee$var$xr.values.get(t.getDataMask()), n = this.bitMatrix.getHeight();
        r.unmaskBitMatrix(this.bitMatrix, n);
        for(var o = e.buildFunctionPattern(), i = !0, a = new Uint8Array(e.getTotalCodewords()), u = 0, s = 0, c = 0, f = n - 1; f > 0; f -= 2){
            6 === f && f--;
            for(var h = 0; h < n; h++)for(var l = i ? n - 1 - h : h, d = 0; d < 2; d++)o.get(f - d, l) || (c++, s <<= 1, this.bitMatrix.get(f - d, l) && (s |= 1), 8 === c && (a[u++] = s, c = 0, s = 0));
            i = !i;
        }
        if (u !== e.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$R;
        return a;
    }, t.prototype.remask = function() {
        if (null !== this.parsedFormatInfo) {
            var t = $12c6b0ab9da17bee$var$xr.values[this.parsedFormatInfo.getDataMask()], e = this.bitMatrix.getHeight();
            t.unmaskBitMatrix(this.bitMatrix, e);
        }
    }, t.prototype.setMirror = function(t) {
        this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = t;
    }, t.prototype.mirror = function() {
        for(var t = this.bitMatrix, e = 0, r = t.getWidth(); e < r; e++)for(var n = e + 1, o = t.getHeight(); n < o; n++)t.get(e, n) !== t.get(n, e) && (t.flip(n, e), t.flip(e, n));
    }, t;
}(), $12c6b0ab9da17bee$var$Ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Hr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r, n) {
        var o, i, a, u;
        if (e.length !== r.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$l;
        var s = r.getECBlocksForLevel(n), c = 0, f = s.getECBlocks();
        try {
            for(var h = $12c6b0ab9da17bee$var$Ur(f), d = h.next(); !d.done; d = h.next())c += (_ = d.value).getCount();
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = h.return) && i.call(h);
            } finally{
                if (o) throw o.error;
            }
        }
        var p = new Array(c), g = 0;
        try {
            for(var y = $12c6b0ab9da17bee$var$Ur(f), w = y.next(); !w.done; w = y.next())for(var _ = w.value, v = 0; v < _.getCount(); v++){
                var m = _.getDataCodewords(), A = s.getECCodewordsPerBlock() + m;
                p[g++] = new t(m, new Uint8Array(A));
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        for(var E = p[0].codewords.length, C = p.length - 1; C >= 0;){
            if (p[C].codewords.length === E) break;
            C--;
        }
        C++;
        var I = E - s.getECCodewordsPerBlock(), S = 0;
        for(v = 0; v < I; v++)for(var O = 0; O < g; O++)p[O].codewords[v] = e[S++];
        for(O = C; O < g; O++)p[O].codewords[I] = e[S++];
        var T = p[0].codewords.length;
        for(v = I; v < T; v++)for(O = 0; O < g; O++){
            var b = O < C ? v : v + 1;
            p[O].codewords[b] = e[S++];
        }
        return p;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}();
!function(t) {
    t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
}($12c6b0ab9da17bee$var$kr || ($12c6b0ab9da17bee$var$kr = {}));
var $12c6b0ab9da17bee$var$Gr, $12c6b0ab9da17bee$var$Xr, $12c6b0ab9da17bee$var$Wr = function() {
    function t(e, r, n, o) {
        this.value = e, this.stringValue = r, this.characterCountBitsForVersions = n, this.bits = o, t.FOR_BITS.set(o, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
        var r = t.FOR_BITS.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$l;
        return r;
    }, t.prototype.getCharacterCountBits = function(t) {
        var e, r = t.getVersionNumber();
        return e = r <= 9 ? 0 : r <= 26 ? 1 : 2, this.characterCountBitsForVersions[e];
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.TERMINATOR = new t($12c6b0ab9da17bee$var$kr.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0), t.NUMERIC = new t($12c6b0ab9da17bee$var$kr.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 1), t.ALPHANUMERIC = new t($12c6b0ab9da17bee$var$kr.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 2), t.STRUCTURED_APPEND = new t($12c6b0ab9da17bee$var$kr.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 3), t.BYTE = new t($12c6b0ab9da17bee$var$kr.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 4), t.ECI = new t($12c6b0ab9da17bee$var$kr.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 7), t.KANJI = new t($12c6b0ab9da17bee$var$kr.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 8), t.FNC1_FIRST_POSITION = new t($12c6b0ab9da17bee$var$kr.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 5), t.FNC1_SECOND_POSITION = new t($12c6b0ab9da17bee$var$kr.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 9), t.HANZI = new t($12c6b0ab9da17bee$var$kr.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 13), t;
}(), $12c6b0ab9da17bee$var$jr = function() {
    function t() {}
    return t.decode = function(e, r, n, o) {
        var i = new $12c6b0ab9da17bee$var$mr(e), a = new $12c6b0ab9da17bee$var$k, u = new Array, s = -1, c = -1;
        try {
            var f = null, h = !1, l = void 0;
            do {
                if (i.available() < 4) l = $12c6b0ab9da17bee$var$Wr.TERMINATOR;
                else {
                    var d = i.readBits(4);
                    l = $12c6b0ab9da17bee$var$Wr.forBits(d);
                }
                switch(l){
                    case $12c6b0ab9da17bee$var$Wr.TERMINATOR:
                        break;
                    case $12c6b0ab9da17bee$var$Wr.FNC1_FIRST_POSITION:
                    case $12c6b0ab9da17bee$var$Wr.FNC1_SECOND_POSITION:
                        h = !0;
                        break;
                    case $12c6b0ab9da17bee$var$Wr.STRUCTURED_APPEND:
                        if (i.available() < 16) throw new $12c6b0ab9da17bee$var$R;
                        s = i.readBits(8), c = i.readBits(8);
                        break;
                    case $12c6b0ab9da17bee$var$Wr.ECI:
                        var p = t.parseECIValue(i);
                        if (null === (f = $12c6b0ab9da17bee$var$P.getCharacterSetECIByValue(p))) throw new $12c6b0ab9da17bee$var$R;
                        break;
                    case $12c6b0ab9da17bee$var$Wr.HANZI:
                        var g = i.readBits(4), y = i.readBits(l.getCharacterCountBits(r));
                        g === t.GB2312_SUBSET && t.decodeHanziSegment(i, a, y);
                        break;
                    default:
                        var w = i.readBits(l.getCharacterCountBits(r));
                        switch(l){
                            case $12c6b0ab9da17bee$var$Wr.NUMERIC:
                                t.decodeNumericSegment(i, a, w);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC:
                                t.decodeAlphanumericSegment(i, a, w, h);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.BYTE:
                                t.decodeByteSegment(i, a, w, f, u, o);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.KANJI:
                                t.decodeKanjiSegment(i, a, w);
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                }
            }while (l !== $12c6b0ab9da17bee$var$Wr.TERMINATOR);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R;
        }
        return new $12c6b0ab9da17bee$var$at(e, a.toString(), 0 === u.length ? null : u, null === n ? null : n.toString(), s, c);
    }, t.decodeHanziSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 96 << 8 & 4294967295 | i % 96;
            a += a < 959 ? 41377 : 42657, n[o] = a >> 8 & 255, n[o + 1] = 255 & a, o += 2, r--;
        }
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(n, $12c6b0ab9da17bee$var$F.GB2312));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
    }, t.decodeKanjiSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 192 << 8 & 4294967295 | i % 192;
            a += a < 7936 ? 33088 : 49472, n[o] = a >> 8, n[o + 1] = a, o += 2, r--;
        }
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(n, $12c6b0ab9da17bee$var$F.SHIFT_JIS));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
    }, t.decodeByteSegment = function(t, e, r, n, o, i) {
        if (8 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var a, u = new Uint8Array(r), s = 0; s < r; s++)u[s] = t.readBits(8);
        a = null === n ? $12c6b0ab9da17bee$var$F.guessEncoding(u, i) : n.getName();
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(u, a));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
        o.push(u);
    }, t.toAlphaNumericChar = function(e) {
        if (e >= t.ALPHANUMERIC_CHARS.length) throw new $12c6b0ab9da17bee$var$R;
        return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, r, n, o) {
        for(var i = r.length(); n > 1;){
            if (e.available() < 11) throw new $12c6b0ab9da17bee$var$R;
            var a = e.readBits(11);
            r.append(t.toAlphaNumericChar(Math.floor(a / 45))), r.append(t.toAlphaNumericChar(a % 45)), n -= 2;
        }
        if (1 === n) {
            if (e.available() < 6) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(e.readBits(6)));
        }
        if (o) for(var u = i; u < r.length(); u++)"%" === r.charAt(u) && (u < r.length() - 1 && "%" === r.charAt(u + 1) ? r.deleteCharAt(u + 1) : r.setCharAt(u, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, r, n) {
        for(; n >= 3;){
            if (e.available() < 10) throw new $12c6b0ab9da17bee$var$R;
            var o = e.readBits(10);
            if (o >= 1e3) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(Math.floor(o / 100))), r.append(t.toAlphaNumericChar(Math.floor(o / 10) % 10)), r.append(t.toAlphaNumericChar(o % 10)), n -= 3;
        }
        if (2 === n) {
            if (e.available() < 7) throw new $12c6b0ab9da17bee$var$R;
            var i = e.readBits(7);
            if (i >= 100) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(Math.floor(i / 10))), r.append(t.toAlphaNumericChar(i % 10));
        } else if (1 === n) {
            if (e.available() < 4) throw new $12c6b0ab9da17bee$var$R;
            var a = e.readBits(4);
            if (a >= 10) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(a));
        }
    }, t.parseECIValue = function(t) {
        var e = t.readBits(8);
        if (0 == (128 & e)) return 127 & e;
        if (128 == (192 & e)) return (63 & e) << 8 & 4294967295 | t.readBits(8);
        if (192 == (224 & e)) return (31 & e) << 16 & 4294967295 | t.readBits(16);
        throw new $12c6b0ab9da17bee$var$R;
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
}(), $12c6b0ab9da17bee$var$zr = function() {
    function t(t) {
        this.mirrored = t;
    }
    return t.prototype.isMirrored = function() {
        return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(t) {
        if (this.mirrored && null !== t && !(t.length < 3)) {
            var e = t[0];
            t[0] = t[2], t[2] = e;
        }
    }, t;
}(), $12c6b0ab9da17bee$var$Yr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Zr = function() {
    function t() {
        this.rsDecoder = new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(t, e) {
        return this.decodeBitMatrix($12c6b0ab9da17bee$var$x.parseFromBooleanArray(t), e);
    }, t.prototype.decodeBitMatrix = function(t, e) {
        var r = new $12c6b0ab9da17bee$var$Vr(t), n = null;
        try {
            return this.decodeBitMatrixParser(r, e);
        } catch (t) {
            n = t;
        }
        try {
            r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
            var o = this.decodeBitMatrixParser(r, e);
            return o.setOther(new $12c6b0ab9da17bee$var$zr(!0)), o;
        } catch (t) {
            if (null !== n) throw n;
            throw t;
        }
    }, t.prototype.decodeBitMatrixParser = function(t, e) {
        var r, n, o, i, a = t.readVersion(), u = t.readFormatInformation().getErrorCorrectionLevel(), s = t.readCodewords(), c = $12c6b0ab9da17bee$var$Hr.getDataBlocks(s, a, u), f = 0;
        try {
            for(var h = $12c6b0ab9da17bee$var$Yr(c), l = h.next(); !l.done; l = h.next())f += (w = l.value).getNumDataCodewords();
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        var d = new Uint8Array(f), p = 0;
        try {
            for(var g = $12c6b0ab9da17bee$var$Yr(c), y = g.next(); !y.done; y = g.next()){
                var w, _ = (w = y.value).getCodewords(), v = w.getNumDataCodewords();
                this.correctErrors(_, v);
                for(var m = 0; m < v; m++)d[p++] = _[m];
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (i = g.return) && i.call(g);
            } finally{
                if (o) throw o.error;
            }
        }
        return $12c6b0ab9da17bee$var$jr.decode(d, a, u, e);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$g;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $12c6b0ab9da17bee$var$Kr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$qr = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.estimatedModuleSize = n, o;
    }
    return $12c6b0ab9da17bee$var$Kr(e, t), e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        return new e((this.getX() + r) / 2, (this.getY() + t) / 2, (this.estimatedModuleSize + n) / 2);
    }, e;
}($12c6b0ab9da17bee$var$At), $12c6b0ab9da17bee$var$Qr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Jr = function() {
    function t(t, e, r, n, o, i, a) {
        this.image = t, this.startX = e, this.startY = r, this.width = n, this.height = o, this.moduleSize = i, this.resultPointCallback = a, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
        for(var t = this.startX, e = this.height, r = t + this.width, n = this.startY + e / 2, o = new Int32Array(3), i = this.image, a = 0; a < e; a++){
            var u = n + (0 == (1 & a) ? Math.floor((a + 1) / 2) : -Math.floor((a + 1) / 2));
            o[0] = 0, o[1] = 0, o[2] = 0;
            for(var s = t; s < r && !i.get(s, u);)s++;
            for(var c = 0; s < r;){
                if (i.get(s, u)) {
                    if (1 === c) o[1]++;
                    else if (2 === c) {
                        var f;
                        if (this.foundPatternCross(o)) {
                            if (null !== (f = this.handlePossibleCenter(o, u, s))) return f;
                        }
                        o[0] = o[2], o[1] = 1, o[2] = 0, c = 1;
                    } else o[++c]++;
                } else 1 === c && c++, o[c]++;
                s++;
            }
            if (this.foundPatternCross(o)) {
                if (null !== (f = this.handlePossibleCenter(o, u, r))) return f;
            }
        }
        if (0 !== this.possibleCenters.length) return this.possibleCenters[0];
        throw new $12c6b0ab9da17bee$var$U;
    }, t.centerFromEnd = function(t, e) {
        return e - t[2] - t[1] / 2;
    }, t.prototype.foundPatternCross = function(t) {
        for(var e = this.moduleSize, r = e / 2, n = 0; n < 3; n++)if (Math.abs(e - t[n]) >= r) return !1;
        return !0;
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        var i = this.image, a = i.getHeight(), u = this.crossCheckStateCount;
        u[0] = 0, u[1] = 0, u[2] = 0;
        for(var s = e; s >= 0 && i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s) && u[1] <= n;)u[1]++, s++;
        if (s === a || u[1] > n) return NaN;
        for(; s < a && !i.get(r, s) && u[2] <= n;)u[2]++, s++;
        if (u[2] > n) return NaN;
        var c = u[0] + u[1] + u[2];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : this.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n) {
        var o, i, a = e[0] + e[1] + e[2], u = t.centerFromEnd(e, n), s = this.crossCheckVertical(r, u, 2 * e[1], a);
        if (!isNaN(s)) {
            var c = (e[0] + e[1] + e[2]) / 3;
            try {
                for(var f = $12c6b0ab9da17bee$var$Qr(this.possibleCenters), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (l.aboutEquals(c, s, u)) return l.combineEstimate(s, u, c);
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
            var d = new $12c6b0ab9da17bee$var$qr(u, s, c);
            this.possibleCenters.push(d), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(d);
        }
        return null;
    }, t;
}(), $12c6b0ab9da17bee$var$$r = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$tn = function(t) {
    function e(e, r, n, o) {
        var i = t.call(this, e, r) || this;
        return i.estimatedModuleSize = n, i.count = o, void 0 === o && (i.count = 1), i;
    }
    return $12c6b0ab9da17bee$var$$r(e, t), e.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        var o = this.count + 1;
        return new e((this.count * this.getX() + r) / o, (this.count * this.getY() + t) / o, (this.count * this.estimatedModuleSize + n) / o, o);
    }, e;
}($12c6b0ab9da17bee$var$At), $12c6b0ab9da17bee$var$en = function() {
    function t(t) {
        this.bottomLeft = t[0], this.topLeft = t[1], this.topRight = t[2];
    }
    return t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t;
}(), $12c6b0ab9da17bee$var$rn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$nn = function() {
    function t(t, e) {
        this.image = t, this.resultPointCallback = e, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = e;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    }, t.prototype.find = function(e) {
        var r = null != e && void 0 !== e.get($12c6b0ab9da17bee$var$T.TRY_HARDER), n = null != e && void 0 !== e.get($12c6b0ab9da17bee$var$T.PURE_BARCODE), o = this.image, i = o.getHeight(), a = o.getWidth(), u = Math.floor(3 * i / (4 * t.MAX_MODULES));
        (u < t.MIN_SKIP || r) && (u = t.MIN_SKIP);
        for(var s = !1, c = new Int32Array(5), f = u - 1; f < i && !s; f += u){
            c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
            for(var h = 0, l = 0; l < a; l++)if (o.get(l, f)) 1 == (1 & h) && h++, c[h]++;
            else if (0 == (1 & h)) {
                if (4 === h) {
                    if (t.foundPatternCross(c)) {
                        if (!0 !== this.handlePossibleCenter(c, f, l, n)) {
                            c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                            continue;
                        }
                        if (u = 2, !0 === this.hasSkipped) s = this.haveMultiplyConfirmedCenters();
                        else {
                            var d = this.findRowSkip();
                            d > c[2] && (f += d - c[2] - u, l = a - 1);
                        }
                        h = 0, c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
                    } else c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                } else c[++h]++;
            } else c[h]++;
            if (t.foundPatternCross(c)) !0 === this.handlePossibleCenter(c, f, a, n) && (u = c[0], this.hasSkipped && (s = this.haveMultiplyConfirmedCenters()));
        }
        var p = this.selectBestPatterns();
        return $12c6b0ab9da17bee$var$At.orderBestPatterns(p), new $12c6b0ab9da17bee$var$en(p);
    }, t.centerFromEnd = function(t, e) {
        return e - t[4] - t[3] - t[2] / 2;
    }, t.foundPatternCross = function(t) {
        for(var e = 0, r = 0; r < 5; r++){
            var n = t[r];
            if (0 === n) return !1;
            e += n;
        }
        if (e < 7) return !1;
        var o = e / 7, i = o / 2;
        return Math.abs(o - t[0]) < i && Math.abs(o - t[1]) < i && Math.abs(3 * o - t[2]) < 3 * i && Math.abs(o - t[3]) < i && Math.abs(o - t[4]) < i;
    }, t.prototype.getCrossCheckStateCount = function() {
        var t = this.crossCheckStateCount;
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t;
    }, t.prototype.crossCheckDiagonal = function(e, r, n, o) {
        for(var i = this.getCrossCheckStateCount(), a = 0, u = this.image; e >= a && r >= a && u.get(r - a, e - a);)i[2]++, a++;
        if (e < a || r < a) return !1;
        for(; e >= a && r >= a && !u.get(r - a, e - a) && i[1] <= n;)i[1]++, a++;
        if (e < a || r < a || i[1] > n) return !1;
        for(; e >= a && r >= a && u.get(r - a, e - a) && i[0] <= n;)i[0]++, a++;
        if (i[0] > n) return !1;
        var s = u.getHeight(), c = u.getWidth();
        for(a = 1; e + a < s && r + a < c && u.get(r + a, e + a);)i[2]++, a++;
        if (e + a >= s || r + a >= c) return !1;
        for(; e + a < s && r + a < c && !u.get(r + a, e + a) && i[3] < n;)i[3]++, a++;
        if (e + a >= s || r + a >= c || i[3] >= n) return !1;
        for(; e + a < s && r + a < c && u.get(r + a, e + a) && i[4] < n;)i[4]++, a++;
        if (i[4] >= n) return !1;
        var f = i[0] + i[1] + i[2] + i[3] + i[4];
        return Math.abs(f - o) < 2 * o && t.foundPatternCross(i);
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        for(var i = this.image, a = i.getHeight(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(r, s);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(r, s) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(r, s) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, r, n, o) {
        for(var i = this.image, a = i.getWidth(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(s, r);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(s, r) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(s, r) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(s, r);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(s, r) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(s, r) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n, o) {
        var i = e[0] + e[1] + e[2] + e[3] + e[4], a = t.centerFromEnd(e, n), u = this.crossCheckVertical(r, Math.floor(a), e[2], i);
        if (!isNaN(u) && (a = this.crossCheckHorizontal(Math.floor(a), Math.floor(u), e[2], i), !isNaN(a) && (!o || this.crossCheckDiagonal(Math.floor(u), Math.floor(a), e[2], i)))) {
            for(var s = i / 7, c = !1, f = this.possibleCenters, h = 0, l = f.length; h < l; h++){
                var d = f[h];
                if (d.aboutEquals(s, u, a)) {
                    f[h] = d.combineEstimate(u, a, s), c = !0;
                    break;
                }
            }
            if (!c) {
                var p = new $12c6b0ab9da17bee$var$tn(a, u, s);
                f.push(p), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(p);
            }
            return !0;
        }
        return !1;
    }, t.prototype.findRowSkip = function() {
        var e, r;
        if (this.possibleCenters.length <= 1) return 0;
        var n = null;
        try {
            for(var o = $12c6b0ab9da17bee$var$rn(this.possibleCenters), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (a.getCount() >= t.CENTER_QUORUM) {
                    if (null != n) return this.hasSkipped = !0, Math.floor((Math.abs(n.getX() - a.getX()) - Math.abs(n.getY() - a.getY())) / 2);
                    n = a;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
        var e, r, n, o, i = 0, a = 0, u = this.possibleCenters.length;
        try {
            for(var s = $12c6b0ab9da17bee$var$rn(this.possibleCenters), c = s.next(); !c.done; c = s.next())(p = c.value).getCount() >= t.CENTER_QUORUM && (i++, a += p.getEstimatedModuleSize());
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        if (i < 3) return !1;
        var f = a / u, h = 0;
        try {
            for(var l = $12c6b0ab9da17bee$var$rn(this.possibleCenters), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h += Math.abs(p.getEstimatedModuleSize() - f);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (o = l.return) && o.call(l);
            } finally{
                if (n) throw n.error;
            }
        }
        return h <= .05 * a;
    }, t.prototype.selectBestPatterns = function() {
        var t, e, r, n, o = this.possibleCenters.length;
        if (o < 3) throw new $12c6b0ab9da17bee$var$U;
        var i, a = this.possibleCenters;
        if (o > 3) {
            var u = 0, s = 0;
            try {
                for(var c = $12c6b0ab9da17bee$var$rn(this.possibleCenters), f = c.next(); !f.done; f = c.next()){
                    var h = f.value.getEstimatedModuleSize();
                    u += h, s += h * h;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    f && !f.done && (e = c.return) && e.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            i = u / o;
            var l = Math.sqrt(s / o - i * i);
            a.sort(function(t, e) {
                var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                return r < n ? -1 : r > n ? 1 : 0;
            });
            for(var d = Math.max(.2 * i, l), p = 0; p < a.length && a.length > 3; p++){
                var g = a[p];
                Math.abs(g.getEstimatedModuleSize() - i) > d && (a.splice(p, 1), p--);
            }
        }
        if (a.length > 3) {
            u = 0;
            try {
                for(var y = $12c6b0ab9da17bee$var$rn(a), w = y.next(); !w.done; w = y.next())u += w.value.getEstimatedModuleSize();
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (n = y.return) && n.call(y);
                } finally{
                    if (r) throw r.error;
                }
            }
            i = u / a.length, a.sort(function(t, e) {
                if (e.getCount() === t.getCount()) {
                    var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                    return r < n ? 1 : r > n ? -1 : 0;
                }
                return e.getCount() - t.getCount();
            }), a.splice(3);
        }
        return [
            a[0],
            a[1],
            a[2]
        ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
}(), $12c6b0ab9da17bee$var$on = function() {
    function t(t) {
        this.image = t;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    }, t.prototype.detect = function(t) {
        this.resultPointCallback = null == t ? null : t.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
        var e = new $12c6b0ab9da17bee$var$nn(this.image, this.resultPointCallback).find(t);
        return this.processFinderPatternInfo(e);
    }, t.prototype.processFinderPatternInfo = function(e) {
        var r = e.getTopLeft(), n = e.getTopRight(), o = e.getBottomLeft(), i = this.calculateModuleSize(r, n, o);
        if (i < 1) throw new $12c6b0ab9da17bee$var$U("No pattern found in proccess finder.");
        var a = t.computeDimension(r, n, o, i), u = $12c6b0ab9da17bee$var$Fr.getProvisionalVersionForDimension(a), s = u.getDimensionForVersion() - 7, c = null;
        if (u.getAlignmentPatternCenters().length > 0) for(var f = n.getX() - r.getX() + o.getX(), h = n.getY() - r.getY() + o.getY(), l = 1 - 3 / s, d = Math.floor(r.getX() + l * (f - r.getX())), p = Math.floor(r.getY() + l * (h - r.getY())), g = 4; g <= 16; g <<= 1)try {
            c = this.findAlignmentInRegion(i, d, p, g);
            break;
        } catch (t) {
            if (!(t instanceof $12c6b0ab9da17bee$var$U)) throw t;
        }
        var y = t.createTransform(r, n, o, c, a), w = t.sampleGrid(this.image, y, a);
        return new $12c6b0ab9da17bee$var$Et(w, null === c ? [
            o,
            r,
            n
        ] : [
            o,
            r,
            n,
            c
        ]);
    }, t.createTransform = function(t, e, r, n, o) {
        var i, a, u, s, c = o - 3.5;
        return null !== n ? (i = n.getX(), a = n.getY(), s = u = c - 3) : (i = e.getX() - t.getX() + r.getX(), a = e.getY() - t.getY() + r.getY(), u = c, s = c), $12c6b0ab9da17bee$var$Tt.quadrilateralToQuadrilateral(3.5, 3.5, c, 3.5, u, s, 3.5, c, t.getX(), t.getY(), e.getX(), e.getY(), i, a, r.getX(), r.getY());
    }, t.sampleGrid = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Nt.getInstance().sampleGridWithTransform(t, r, r, e);
    }, t.computeDimension = function(t, e, r, n) {
        var o = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$At.distance(t, e) / n), i = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$At.distance(t, r) / n), a = Math.floor((o + i) / 2) + 7;
        switch(3 & a){
            case 0:
                a++;
                break;
            case 2:
                a--;
                break;
            case 3:
                throw new $12c6b0ab9da17bee$var$U("Dimensions could be not found.");
        }
        return a;
    }, t.prototype.calculateModuleSize = function(t, e, r) {
        return (this.calculateModuleSizeOneWay(t, e) + this.calculateModuleSizeOneWay(t, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(t, e) {
        var r = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()), Math.floor(t.getY()), Math.floor(e.getX()), Math.floor(e.getY())), n = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()), Math.floor(e.getY()), Math.floor(t.getX()), Math.floor(t.getY()));
        return isNaN(r) ? n / 7 : isNaN(n) ? r / 7 : (r + n) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(t, e, r, n) {
        var o = this.sizeOfBlackWhiteBlackRun(t, e, r, n), i = 1, a = t - (r - t);
        a < 0 ? (i = t / (t - a), a = 0) : a >= this.image.getWidth() && (i = (this.image.getWidth() - 1 - t) / (a - t), a = this.image.getWidth() - 1);
        var u = Math.floor(e - (n - e) * i);
        return i = 1, u < 0 ? (i = e / (e - u), u = 0) : u >= this.image.getHeight() && (i = (this.image.getHeight() - 1 - e) / (u - e), u = this.image.getHeight() - 1), a = Math.floor(t + (a - t) * i), (o += this.sizeOfBlackWhiteBlackRun(t, e, a, u)) - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(t, e, r, n) {
        var o = Math.abs(n - e) > Math.abs(r - t);
        if (o) {
            var i = t;
            t = e, e = i, i = r, r = n, n = i;
        }
        for(var a = Math.abs(r - t), u = Math.abs(n - e), s = -a / 2, c = t < r ? 1 : -1, f = e < n ? 1 : -1, h = 0, l = r + c, d = t, p = e; d !== l; d += c){
            var g = o ? p : d, y = o ? d : p;
            if (1 === h === this.image.get(g, y)) {
                if (2 === h) return $12c6b0ab9da17bee$var$vt.distance(d, p, t, e);
                h++;
            }
            if ((s += u) > 0) {
                if (p === n) break;
                p += f, s -= a;
            }
        }
        return 2 === h ? $12c6b0ab9da17bee$var$vt.distance(r + c, n, t, e) : NaN;
    }, t.prototype.findAlignmentInRegion = function(t, e, r, n) {
        var o = Math.floor(n * t), i = Math.max(0, e - o), a = Math.min(this.image.getWidth() - 1, e + o);
        if (a - i < 3 * t) throw new $12c6b0ab9da17bee$var$U("Alignment top exceeds estimated module size.");
        var u = Math.max(0, r - o), s = Math.min(this.image.getHeight() - 1, r + o);
        if (s - u < 3 * t) throw new $12c6b0ab9da17bee$var$U("Alignment bottom exceeds estimated module size.");
        return new $12c6b0ab9da17bee$var$Jr(this.image, i, u, a - i, s - u, t, this.resultPointCallback).find();
    }, t;
}(), $12c6b0ab9da17bee$var$an = function() {
    function t() {
        this.decoder = new $12c6b0ab9da17bee$var$Zr;
    }
    return t.prototype.getDecoder = function() {
        return this.decoder;
    }, t.prototype.decode = function(e, r) {
        var n, o;
        if (null != r && void 0 !== r.get($12c6b0ab9da17bee$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decodeBitMatrix(i, r), o = t.NO_POINTS;
        } else {
            var a = new $12c6b0ab9da17bee$var$on(e.getBlackMatrix()).detect(r);
            n = this.decoder.decodeBitMatrix(a.getBits(), r), o = a.getPoints();
        }
        n.getOther() instanceof $12c6b0ab9da17bee$var$zr && n.getOther().applyMirroredCorrection(o);
        var u = new $12c6b0ab9da17bee$var$et(n.getText(), n.getRawBytes(), void 0, o, $12c6b0ab9da17bee$var$nt.QR_CODE, void 0), s = n.getByteSegments();
        null !== s && u.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, s);
        var c = n.getECLevel();
        return null !== c && u.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, c), n.hasStructuredAppend() && (u.putMetadata($12c6b0ab9da17bee$var$it.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), u.putMetadata($12c6b0ab9da17bee$var$it.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), u;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null === e || null === r) throw new $12c6b0ab9da17bee$var$U;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = r[0];
        if (a >= u || o >= i) throw new $12c6b0ab9da17bee$var$U;
        if (i - o != u - a && (u = a + (i - o)) >= t.getWidth()) throw new $12c6b0ab9da17bee$var$U;
        var s = Math.round((u - a + 1) / n), c = Math.round((i - o + 1) / n);
        if (s <= 0 || c <= 0) throw new $12c6b0ab9da17bee$var$U;
        if (c !== s) throw new $12c6b0ab9da17bee$var$U;
        var f = Math.floor(n / 2);
        o += f;
        var h = (a += f) + Math.floor((s - 1) * n) - u;
        if (h > 0) {
            if (h > f) throw new $12c6b0ab9da17bee$var$U;
            a -= h;
        }
        var l = o + Math.floor((c - 1) * n) - i;
        if (l > 0) {
            if (l > f) throw new $12c6b0ab9da17bee$var$U;
            o -= l;
        }
        for(var d = new $12c6b0ab9da17bee$var$x(s, c), p = 0; p < c; p++)for(var g = o + Math.floor(p * n), y = 0; y < s; y++)t.get(a + Math.floor(y * n), g) && d.set(y, p);
        return d;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getHeight(), n = e.getWidth(), o = t[0], i = t[1], a = !0, u = 0; o < n && i < r;){
            if (a !== e.get(o, i)) {
                if (5 == ++u) break;
                a = !a;
            }
            o++, i++;
        }
        if (o === n || i === r) throw new $12c6b0ab9da17bee$var$U;
        return (o - t[0]) / 7;
    }, t.NO_POINTS = new Array, t;
}(), $12c6b0ab9da17bee$var$un = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$sn = function() {
    function t() {}
    return t.prototype.PDF417Common = function() {}, t.getBitCountSum = function(t) {
        return $12c6b0ab9da17bee$var$vt.sum(t);
    }, t.toIntArray = function(e) {
        var r, n;
        if (null == e || !e.length) return t.EMPTY_INT_ARRAY;
        var o = new Int32Array(e.length), i = 0;
        try {
            for(var a = $12c6b0ab9da17bee$var$un(e), u = a.next(); !u.done; u = a.next()){
                var s = u.value;
                o[i++] = s;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (n = a.return) && n.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return o;
    }, t.getCodeword = function(e) {
        var r = $12c6b0ab9da17bee$var$C.binarySearch(t.SYMBOL_TABLE, 262143 & e);
        return r < 0 ? -1 : (t.CODEWORD_TABLE[r] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
        66142,
        66170,
        66206,
        66236,
        66290,
        66292,
        66350,
        66382,
        66396,
        66454,
        66470,
        66476,
        66594,
        66600,
        66614,
        66626,
        66628,
        66632,
        66640,
        66654,
        66662,
        66668,
        66682,
        66690,
        66718,
        66720,
        66748,
        66758,
        66776,
        66798,
        66802,
        66804,
        66820,
        66824,
        66832,
        66846,
        66848,
        66876,
        66880,
        66936,
        66950,
        66956,
        66968,
        66992,
        67006,
        67022,
        67036,
        67042,
        67044,
        67048,
        67062,
        67118,
        67150,
        67164,
        67214,
        67228,
        67256,
        67294,
        67322,
        67350,
        67366,
        67372,
        67398,
        67404,
        67416,
        67438,
        67474,
        67476,
        67490,
        67492,
        67496,
        67510,
        67618,
        67624,
        67650,
        67656,
        67664,
        67678,
        67686,
        67692,
        67706,
        67714,
        67716,
        67728,
        67742,
        67744,
        67772,
        67782,
        67788,
        67800,
        67822,
        67826,
        67828,
        67842,
        67848,
        67870,
        67872,
        67900,
        67904,
        67960,
        67974,
        67992,
        68016,
        68030,
        68046,
        68060,
        68066,
        68068,
        68072,
        68086,
        68104,
        68112,
        68126,
        68128,
        68156,
        68160,
        68216,
        68336,
        68358,
        68364,
        68376,
        68400,
        68414,
        68448,
        68476,
        68494,
        68508,
        68536,
        68546,
        68548,
        68552,
        68560,
        68574,
        68582,
        68588,
        68654,
        68686,
        68700,
        68706,
        68708,
        68712,
        68726,
        68750,
        68764,
        68792,
        68802,
        68804,
        68808,
        68816,
        68830,
        68838,
        68844,
        68858,
        68878,
        68892,
        68920,
        68976,
        68990,
        68994,
        68996,
        69e3,
        69008,
        69022,
        69024,
        69052,
        69062,
        69068,
        69080,
        69102,
        69106,
        69108,
        69142,
        69158,
        69164,
        69190,
        69208,
        69230,
        69254,
        69260,
        69272,
        69296,
        69310,
        69326,
        69340,
        69386,
        69394,
        69396,
        69410,
        69416,
        69430,
        69442,
        69444,
        69448,
        69456,
        69470,
        69478,
        69484,
        69554,
        69556,
        69666,
        69672,
        69698,
        69704,
        69712,
        69726,
        69754,
        69762,
        69764,
        69776,
        69790,
        69792,
        69820,
        69830,
        69836,
        69848,
        69870,
        69874,
        69876,
        69890,
        69918,
        69920,
        69948,
        69952,
        70008,
        70022,
        70040,
        70064,
        70078,
        70094,
        70108,
        70114,
        70116,
        70120,
        70134,
        70152,
        70174,
        70176,
        70264,
        70384,
        70412,
        70448,
        70462,
        70496,
        70524,
        70542,
        70556,
        70584,
        70594,
        70600,
        70608,
        70622,
        70630,
        70636,
        70664,
        70672,
        70686,
        70688,
        70716,
        70720,
        70776,
        70896,
        71136,
        71180,
        71192,
        71216,
        71230,
        71264,
        71292,
        71360,
        71416,
        71452,
        71480,
        71536,
        71550,
        71554,
        71556,
        71560,
        71568,
        71582,
        71584,
        71612,
        71622,
        71628,
        71640,
        71662,
        71726,
        71732,
        71758,
        71772,
        71778,
        71780,
        71784,
        71798,
        71822,
        71836,
        71864,
        71874,
        71880,
        71888,
        71902,
        71910,
        71916,
        71930,
        71950,
        71964,
        71992,
        72048,
        72062,
        72066,
        72068,
        72080,
        72094,
        72096,
        72124,
        72134,
        72140,
        72152,
        72174,
        72178,
        72180,
        72206,
        72220,
        72248,
        72304,
        72318,
        72416,
        72444,
        72456,
        72464,
        72478,
        72480,
        72508,
        72512,
        72568,
        72588,
        72600,
        72624,
        72638,
        72654,
        72668,
        72674,
        72676,
        72680,
        72694,
        72726,
        72742,
        72748,
        72774,
        72780,
        72792,
        72814,
        72838,
        72856,
        72880,
        72894,
        72910,
        72924,
        72930,
        72932,
        72936,
        72950,
        72966,
        72972,
        72984,
        73008,
        73022,
        73056,
        73084,
        73102,
        73116,
        73144,
        73156,
        73160,
        73168,
        73182,
        73190,
        73196,
        73210,
        73226,
        73234,
        73236,
        73250,
        73252,
        73256,
        73270,
        73282,
        73284,
        73296,
        73310,
        73318,
        73324,
        73346,
        73348,
        73352,
        73360,
        73374,
        73376,
        73404,
        73414,
        73420,
        73432,
        73454,
        73498,
        73518,
        73522,
        73524,
        73550,
        73564,
        73570,
        73572,
        73576,
        73590,
        73800,
        73822,
        73858,
        73860,
        73872,
        73886,
        73888,
        73916,
        73944,
        73970,
        73972,
        73992,
        74014,
        74016,
        74044,
        74048,
        74104,
        74118,
        74136,
        74160,
        74174,
        74210,
        74212,
        74216,
        74230,
        74244,
        74256,
        74270,
        74272,
        74360,
        74480,
        74502,
        74508,
        74544,
        74558,
        74592,
        74620,
        74638,
        74652,
        74680,
        74690,
        74696,
        74704,
        74726,
        74732,
        74782,
        74784,
        74812,
        74992,
        75232,
        75288,
        75326,
        75360,
        75388,
        75456,
        75512,
        75576,
        75632,
        75646,
        75650,
        75652,
        75664,
        75678,
        75680,
        75708,
        75718,
        75724,
        75736,
        75758,
        75808,
        75836,
        75840,
        75896,
        76016,
        76256,
        76736,
        76824,
        76848,
        76862,
        76896,
        76924,
        76992,
        77048,
        77296,
        77340,
        77368,
        77424,
        77438,
        77536,
        77564,
        77572,
        77576,
        77584,
        77600,
        77628,
        77632,
        77688,
        77702,
        77708,
        77720,
        77744,
        77758,
        77774,
        77788,
        77870,
        77902,
        77916,
        77922,
        77928,
        77966,
        77980,
        78008,
        78018,
        78024,
        78032,
        78046,
        78060,
        78074,
        78094,
        78136,
        78192,
        78206,
        78210,
        78212,
        78224,
        78238,
        78240,
        78268,
        78278,
        78284,
        78296,
        78322,
        78324,
        78350,
        78364,
        78448,
        78462,
        78560,
        78588,
        78600,
        78622,
        78624,
        78652,
        78656,
        78712,
        78726,
        78744,
        78768,
        78782,
        78798,
        78812,
        78818,
        78820,
        78824,
        78838,
        78862,
        78876,
        78904,
        78960,
        78974,
        79072,
        79100,
        79296,
        79352,
        79368,
        79376,
        79390,
        79392,
        79420,
        79424,
        79480,
        79600,
        79628,
        79640,
        79664,
        79678,
        79712,
        79740,
        79772,
        79800,
        79810,
        79812,
        79816,
        79824,
        79838,
        79846,
        79852,
        79894,
        79910,
        79916,
        79942,
        79948,
        79960,
        79982,
        79988,
        80006,
        80024,
        80048,
        80062,
        80078,
        80092,
        80098,
        80100,
        80104,
        80134,
        80140,
        80176,
        80190,
        80224,
        80252,
        80270,
        80284,
        80312,
        80328,
        80336,
        80350,
        80358,
        80364,
        80378,
        80390,
        80396,
        80408,
        80432,
        80446,
        80480,
        80508,
        80576,
        80632,
        80654,
        80668,
        80696,
        80752,
        80766,
        80776,
        80784,
        80798,
        80800,
        80828,
        80844,
        80856,
        80878,
        80882,
        80884,
        80914,
        80916,
        80930,
        80932,
        80936,
        80950,
        80962,
        80968,
        80976,
        80990,
        80998,
        81004,
        81026,
        81028,
        81040,
        81054,
        81056,
        81084,
        81094,
        81100,
        81112,
        81134,
        81154,
        81156,
        81160,
        81168,
        81182,
        81184,
        81212,
        81216,
        81272,
        81286,
        81292,
        81304,
        81328,
        81342,
        81358,
        81372,
        81380,
        81384,
        81398,
        81434,
        81454,
        81458,
        81460,
        81486,
        81500,
        81506,
        81508,
        81512,
        81526,
        81550,
        81564,
        81592,
        81602,
        81604,
        81608,
        81616,
        81630,
        81638,
        81644,
        81702,
        81708,
        81722,
        81734,
        81740,
        81752,
        81774,
        81778,
        81780,
        82050,
        82078,
        82080,
        82108,
        82180,
        82184,
        82192,
        82206,
        82208,
        82236,
        82240,
        82296,
        82316,
        82328,
        82352,
        82366,
        82402,
        82404,
        82408,
        82440,
        82448,
        82462,
        82464,
        82492,
        82496,
        82552,
        82672,
        82694,
        82700,
        82712,
        82736,
        82750,
        82784,
        82812,
        82830,
        82882,
        82884,
        82888,
        82896,
        82918,
        82924,
        82952,
        82960,
        82974,
        82976,
        83004,
        83008,
        83064,
        83184,
        83424,
        83468,
        83480,
        83504,
        83518,
        83552,
        83580,
        83648,
        83704,
        83740,
        83768,
        83824,
        83838,
        83842,
        83844,
        83848,
        83856,
        83872,
        83900,
        83910,
        83916,
        83928,
        83950,
        83984,
        84e3,
        84028,
        84032,
        84088,
        84208,
        84448,
        84928,
        85040,
        85054,
        85088,
        85116,
        85184,
        85240,
        85488,
        85560,
        85616,
        85630,
        85728,
        85756,
        85764,
        85768,
        85776,
        85790,
        85792,
        85820,
        85824,
        85880,
        85894,
        85900,
        85912,
        85936,
        85966,
        85980,
        86048,
        86080,
        86136,
        86256,
        86496,
        86976,
        88160,
        88188,
        88256,
        88312,
        88560,
        89056,
        89200,
        89214,
        89312,
        89340,
        89536,
        89592,
        89608,
        89616,
        89632,
        89664,
        89720,
        89840,
        89868,
        89880,
        89904,
        89952,
        89980,
        89998,
        90012,
        90040,
        90190,
        90204,
        90254,
        90268,
        90296,
        90306,
        90308,
        90312,
        90334,
        90382,
        90396,
        90424,
        90480,
        90494,
        90500,
        90504,
        90512,
        90526,
        90528,
        90556,
        90566,
        90572,
        90584,
        90610,
        90612,
        90638,
        90652,
        90680,
        90736,
        90750,
        90848,
        90876,
        90884,
        90888,
        90896,
        90910,
        90912,
        90940,
        90944,
        91e3,
        91014,
        91020,
        91032,
        91056,
        91070,
        91086,
        91100,
        91106,
        91108,
        91112,
        91126,
        91150,
        91164,
        91192,
        91248,
        91262,
        91360,
        91388,
        91584,
        91640,
        91664,
        91678,
        91680,
        91708,
        91712,
        91768,
        91888,
        91928,
        91952,
        91966,
        92e3,
        92028,
        92046,
        92060,
        92088,
        92098,
        92100,
        92104,
        92112,
        92126,
        92134,
        92140,
        92188,
        92216,
        92272,
        92384,
        92412,
        92608,
        92664,
        93168,
        93200,
        93214,
        93216,
        93244,
        93248,
        93304,
        93424,
        93664,
        93720,
        93744,
        93758,
        93792,
        93820,
        93888,
        93944,
        93980,
        94008,
        94064,
        94078,
        94084,
        94088,
        94096,
        94110,
        94112,
        94140,
        94150,
        94156,
        94168,
        94246,
        94252,
        94278,
        94284,
        94296,
        94318,
        94342,
        94348,
        94360,
        94384,
        94398,
        94414,
        94428,
        94440,
        94470,
        94476,
        94488,
        94512,
        94526,
        94560,
        94588,
        94606,
        94620,
        94648,
        94658,
        94660,
        94664,
        94672,
        94686,
        94694,
        94700,
        94714,
        94726,
        94732,
        94744,
        94768,
        94782,
        94816,
        94844,
        94912,
        94968,
        94990,
        95004,
        95032,
        95088,
        95102,
        95112,
        95120,
        95134,
        95136,
        95164,
        95180,
        95192,
        95214,
        95218,
        95220,
        95244,
        95256,
        95280,
        95294,
        95328,
        95356,
        95424,
        95480,
        95728,
        95758,
        95772,
        95800,
        95856,
        95870,
        95968,
        95996,
        96008,
        96016,
        96030,
        96032,
        96060,
        96064,
        96120,
        96152,
        96176,
        96190,
        96220,
        96226,
        96228,
        96232,
        96290,
        96292,
        96296,
        96310,
        96322,
        96324,
        96328,
        96336,
        96350,
        96358,
        96364,
        96386,
        96388,
        96392,
        96400,
        96414,
        96416,
        96444,
        96454,
        96460,
        96472,
        96494,
        96498,
        96500,
        96514,
        96516,
        96520,
        96528,
        96542,
        96544,
        96572,
        96576,
        96632,
        96646,
        96652,
        96664,
        96688,
        96702,
        96718,
        96732,
        96738,
        96740,
        96744,
        96758,
        96772,
        96776,
        96784,
        96798,
        96800,
        96828,
        96832,
        96888,
        97008,
        97030,
        97036,
        97048,
        97072,
        97086,
        97120,
        97148,
        97166,
        97180,
        97208,
        97220,
        97224,
        97232,
        97246,
        97254,
        97260,
        97326,
        97330,
        97332,
        97358,
        97372,
        97378,
        97380,
        97384,
        97398,
        97422,
        97436,
        97464,
        97474,
        97476,
        97480,
        97488,
        97502,
        97510,
        97516,
        97550,
        97564,
        97592,
        97648,
        97666,
        97668,
        97672,
        97680,
        97694,
        97696,
        97724,
        97734,
        97740,
        97752,
        97774,
        97830,
        97836,
        97850,
        97862,
        97868,
        97880,
        97902,
        97906,
        97908,
        97926,
        97932,
        97944,
        97968,
        97998,
        98012,
        98018,
        98020,
        98024,
        98038,
        98618,
        98674,
        98676,
        98838,
        98854,
        98874,
        98892,
        98904,
        98926,
        98930,
        98932,
        98968,
        99006,
        99042,
        99044,
        99048,
        99062,
        99166,
        99194,
        99246,
        99286,
        99350,
        99366,
        99372,
        99386,
        99398,
        99416,
        99438,
        99442,
        99444,
        99462,
        99504,
        99518,
        99534,
        99548,
        99554,
        99556,
        99560,
        99574,
        99590,
        99596,
        99608,
        99632,
        99646,
        99680,
        99708,
        99726,
        99740,
        99768,
        99778,
        99780,
        99784,
        99792,
        99806,
        99814,
        99820,
        99834,
        99858,
        99860,
        99874,
        99880,
        99894,
        99906,
        99920,
        99934,
        99962,
        99970,
        99972,
        99976,
        99984,
        99998,
        1e5,
        100028,
        100038,
        100044,
        100056,
        100078,
        100082,
        100084,
        100142,
        100174,
        100188,
        100246,
        100262,
        100268,
        100306,
        100308,
        100390,
        100396,
        100410,
        100422,
        100428,
        100440,
        100462,
        100466,
        100468,
        100486,
        100504,
        100528,
        100542,
        100558,
        100572,
        100578,
        100580,
        100584,
        100598,
        100620,
        100656,
        100670,
        100704,
        100732,
        100750,
        100792,
        100802,
        100808,
        100816,
        100830,
        100838,
        100844,
        100858,
        100888,
        100912,
        100926,
        100960,
        100988,
        101056,
        101112,
        101148,
        101176,
        101232,
        101246,
        101250,
        101252,
        101256,
        101264,
        101278,
        101280,
        101308,
        101318,
        101324,
        101336,
        101358,
        101362,
        101364,
        101410,
        101412,
        101416,
        101430,
        101442,
        101448,
        101456,
        101470,
        101478,
        101498,
        101506,
        101508,
        101520,
        101534,
        101536,
        101564,
        101580,
        101618,
        101620,
        101636,
        101640,
        101648,
        101662,
        101664,
        101692,
        101696,
        101752,
        101766,
        101784,
        101838,
        101858,
        101860,
        101864,
        101934,
        101938,
        101940,
        101966,
        101980,
        101986,
        101988,
        101992,
        102030,
        102044,
        102072,
        102082,
        102084,
        102088,
        102096,
        102138,
        102166,
        102182,
        102188,
        102214,
        102220,
        102232,
        102254,
        102282,
        102290,
        102292,
        102306,
        102308,
        102312,
        102326,
        102444,
        102458,
        102470,
        102476,
        102488,
        102514,
        102516,
        102534,
        102552,
        102576,
        102590,
        102606,
        102620,
        102626,
        102632,
        102646,
        102662,
        102668,
        102704,
        102718,
        102752,
        102780,
        102798,
        102812,
        102840,
        102850,
        102856,
        102864,
        102878,
        102886,
        102892,
        102906,
        102936,
        102974,
        103008,
        103036,
        103104,
        103160,
        103224,
        103280,
        103294,
        103298,
        103300,
        103312,
        103326,
        103328,
        103356,
        103366,
        103372,
        103384,
        103406,
        103410,
        103412,
        103472,
        103486,
        103520,
        103548,
        103616,
        103672,
        103920,
        103992,
        104048,
        104062,
        104160,
        104188,
        104194,
        104196,
        104200,
        104208,
        104224,
        104252,
        104256,
        104312,
        104326,
        104332,
        104344,
        104368,
        104382,
        104398,
        104412,
        104418,
        104420,
        104424,
        104482,
        104484,
        104514,
        104520,
        104528,
        104542,
        104550,
        104570,
        104578,
        104580,
        104592,
        104606,
        104608,
        104636,
        104652,
        104690,
        104692,
        104706,
        104712,
        104734,
        104736,
        104764,
        104768,
        104824,
        104838,
        104856,
        104910,
        104930,
        104932,
        104936,
        104968,
        104976,
        104990,
        104992,
        105020,
        105024,
        105080,
        105200,
        105240,
        105278,
        105312,
        105372,
        105410,
        105412,
        105416,
        105424,
        105446,
        105518,
        105524,
        105550,
        105564,
        105570,
        105572,
        105576,
        105614,
        105628,
        105656,
        105666,
        105672,
        105680,
        105702,
        105722,
        105742,
        105756,
        105784,
        105840,
        105854,
        105858,
        105860,
        105864,
        105872,
        105888,
        105932,
        105970,
        105972,
        106006,
        106022,
        106028,
        106054,
        106060,
        106072,
        106100,
        106118,
        106124,
        106136,
        106160,
        106174,
        106190,
        106210,
        106212,
        106216,
        106250,
        106258,
        106260,
        106274,
        106276,
        106280,
        106306,
        106308,
        106312,
        106320,
        106334,
        106348,
        106394,
        106414,
        106418,
        106420,
        106566,
        106572,
        106610,
        106612,
        106630,
        106636,
        106648,
        106672,
        106686,
        106722,
        106724,
        106728,
        106742,
        106758,
        106764,
        106776,
        106800,
        106814,
        106848,
        106876,
        106894,
        106908,
        106936,
        106946,
        106948,
        106952,
        106960,
        106974,
        106982,
        106988,
        107032,
        107056,
        107070,
        107104,
        107132,
        107200,
        107256,
        107292,
        107320,
        107376,
        107390,
        107394,
        107396,
        107400,
        107408,
        107422,
        107424,
        107452,
        107462,
        107468,
        107480,
        107502,
        107506,
        107508,
        107544,
        107568,
        107582,
        107616,
        107644,
        107712,
        107768,
        108016,
        108060,
        108088,
        108144,
        108158,
        108256,
        108284,
        108290,
        108292,
        108296,
        108304,
        108318,
        108320,
        108348,
        108352,
        108408,
        108422,
        108428,
        108440,
        108464,
        108478,
        108494,
        108508,
        108514,
        108516,
        108520,
        108592,
        108640,
        108668,
        108736,
        108792,
        109040,
        109536,
        109680,
        109694,
        109792,
        109820,
        110016,
        110072,
        110084,
        110088,
        110096,
        110112,
        110140,
        110144,
        110200,
        110320,
        110342,
        110348,
        110360,
        110384,
        110398,
        110432,
        110460,
        110478,
        110492,
        110520,
        110532,
        110536,
        110544,
        110558,
        110658,
        110686,
        110714,
        110722,
        110724,
        110728,
        110736,
        110750,
        110752,
        110780,
        110796,
        110834,
        110836,
        110850,
        110852,
        110856,
        110864,
        110878,
        110880,
        110908,
        110912,
        110968,
        110982,
        111e3,
        111054,
        111074,
        111076,
        111080,
        111108,
        111112,
        111120,
        111134,
        111136,
        111164,
        111168,
        111224,
        111344,
        111372,
        111422,
        111456,
        111516,
        111554,
        111556,
        111560,
        111568,
        111590,
        111632,
        111646,
        111648,
        111676,
        111680,
        111736,
        111856,
        112096,
        112152,
        112224,
        112252,
        112320,
        112440,
        112514,
        112516,
        112520,
        112528,
        112542,
        112544,
        112588,
        112686,
        112718,
        112732,
        112782,
        112796,
        112824,
        112834,
        112836,
        112840,
        112848,
        112870,
        112890,
        112910,
        112924,
        112952,
        113008,
        113022,
        113026,
        113028,
        113032,
        113040,
        113054,
        113056,
        113100,
        113138,
        113140,
        113166,
        113180,
        113208,
        113264,
        113278,
        113376,
        113404,
        113416,
        113424,
        113440,
        113468,
        113472,
        113560,
        113614,
        113634,
        113636,
        113640,
        113686,
        113702,
        113708,
        113734,
        113740,
        113752,
        113778,
        113780,
        113798,
        113804,
        113816,
        113840,
        113854,
        113870,
        113890,
        113892,
        113896,
        113926,
        113932,
        113944,
        113968,
        113982,
        114016,
        114044,
        114076,
        114114,
        114116,
        114120,
        114128,
        114150,
        114170,
        114194,
        114196,
        114210,
        114212,
        114216,
        114242,
        114244,
        114248,
        114256,
        114270,
        114278,
        114306,
        114308,
        114312,
        114320,
        114334,
        114336,
        114364,
        114380,
        114420,
        114458,
        114478,
        114482,
        114484,
        114510,
        114524,
        114530,
        114532,
        114536,
        114842,
        114866,
        114868,
        114970,
        114994,
        114996,
        115042,
        115044,
        115048,
        115062,
        115130,
        115226,
        115250,
        115252,
        115278,
        115292,
        115298,
        115300,
        115304,
        115318,
        115342,
        115394,
        115396,
        115400,
        115408,
        115422,
        115430,
        115436,
        115450,
        115478,
        115494,
        115514,
        115526,
        115532,
        115570,
        115572,
        115738,
        115758,
        115762,
        115764,
        115790,
        115804,
        115810,
        115812,
        115816,
        115830,
        115854,
        115868,
        115896,
        115906,
        115912,
        115920,
        115934,
        115942,
        115948,
        115962,
        115996,
        116024,
        116080,
        116094,
        116098,
        116100,
        116104,
        116112,
        116126,
        116128,
        116156,
        116166,
        116172,
        116184,
        116206,
        116210,
        116212,
        116246,
        116262,
        116268,
        116282,
        116294,
        116300,
        116312,
        116334,
        116338,
        116340,
        116358,
        116364,
        116376,
        116400,
        116414,
        116430,
        116444,
        116450,
        116452,
        116456,
        116498,
        116500,
        116514,
        116520,
        116534,
        116546,
        116548,
        116552,
        116560,
        116574,
        116582,
        116588,
        116602,
        116654,
        116694,
        116714,
        116762,
        116782,
        116786,
        116788,
        116814,
        116828,
        116834,
        116836,
        116840,
        116854,
        116878,
        116892,
        116920,
        116930,
        116936,
        116944,
        116958,
        116966,
        116972,
        116986,
        117006,
        117048,
        117104,
        117118,
        117122,
        117124,
        117136,
        117150,
        117152,
        117180,
        117190,
        117196,
        117208,
        117230,
        117234,
        117236,
        117304,
        117360,
        117374,
        117472,
        117500,
        117506,
        117508,
        117512,
        117520,
        117536,
        117564,
        117568,
        117624,
        117638,
        117644,
        117656,
        117680,
        117694,
        117710,
        117724,
        117730,
        117732,
        117736,
        117750,
        117782,
        117798,
        117804,
        117818,
        117830,
        117848,
        117874,
        117876,
        117894,
        117936,
        117950,
        117966,
        117986,
        117988,
        117992,
        118022,
        118028,
        118040,
        118064,
        118078,
        118112,
        118140,
        118172,
        118210,
        118212,
        118216,
        118224,
        118238,
        118246,
        118266,
        118306,
        118312,
        118338,
        118352,
        118366,
        118374,
        118394,
        118402,
        118404,
        118408,
        118416,
        118430,
        118432,
        118460,
        118476,
        118514,
        118516,
        118574,
        118578,
        118580,
        118606,
        118620,
        118626,
        118628,
        118632,
        118678,
        118694,
        118700,
        118730,
        118738,
        118740,
        118830,
        118834,
        118836,
        118862,
        118876,
        118882,
        118884,
        118888,
        118902,
        118926,
        118940,
        118968,
        118978,
        118980,
        118984,
        118992,
        119006,
        119014,
        119020,
        119034,
        119068,
        119096,
        119152,
        119166,
        119170,
        119172,
        119176,
        119184,
        119198,
        119200,
        119228,
        119238,
        119244,
        119256,
        119278,
        119282,
        119284,
        119324,
        119352,
        119408,
        119422,
        119520,
        119548,
        119554,
        119556,
        119560,
        119568,
        119582,
        119584,
        119612,
        119616,
        119672,
        119686,
        119692,
        119704,
        119728,
        119742,
        119758,
        119772,
        119778,
        119780,
        119784,
        119798,
        119920,
        119934,
        120032,
        120060,
        120256,
        120312,
        120324,
        120328,
        120336,
        120352,
        120384,
        120440,
        120560,
        120582,
        120588,
        120600,
        120624,
        120638,
        120672,
        120700,
        120718,
        120732,
        120760,
        120770,
        120772,
        120776,
        120784,
        120798,
        120806,
        120812,
        120870,
        120876,
        120890,
        120902,
        120908,
        120920,
        120946,
        120948,
        120966,
        120972,
        120984,
        121008,
        121022,
        121038,
        121058,
        121060,
        121064,
        121078,
        121100,
        121112,
        121136,
        121150,
        121184,
        121212,
        121244,
        121282,
        121284,
        121288,
        121296,
        121318,
        121338,
        121356,
        121368,
        121392,
        121406,
        121440,
        121468,
        121536,
        121592,
        121656,
        121730,
        121732,
        121736,
        121744,
        121758,
        121760,
        121804,
        121842,
        121844,
        121890,
        121922,
        121924,
        121928,
        121936,
        121950,
        121958,
        121978,
        121986,
        121988,
        121992,
        122e3,
        122014,
        122016,
        122044,
        122060,
        122098,
        122100,
        122116,
        122120,
        122128,
        122142,
        122144,
        122172,
        122176,
        122232,
        122246,
        122264,
        122318,
        122338,
        122340,
        122344,
        122414,
        122418,
        122420,
        122446,
        122460,
        122466,
        122468,
        122472,
        122510,
        122524,
        122552,
        122562,
        122564,
        122568,
        122576,
        122598,
        122618,
        122646,
        122662,
        122668,
        122694,
        122700,
        122712,
        122738,
        122740,
        122762,
        122770,
        122772,
        122786,
        122788,
        122792,
        123018,
        123026,
        123028,
        123042,
        123044,
        123048,
        123062,
        123098,
        123146,
        123154,
        123156,
        123170,
        123172,
        123176,
        123190,
        123202,
        123204,
        123208,
        123216,
        123238,
        123244,
        123258,
        123290,
        123314,
        123316,
        123402,
        123410,
        123412,
        123426,
        123428,
        123432,
        123446,
        123458,
        123464,
        123472,
        123486,
        123494,
        123500,
        123514,
        123522,
        123524,
        123528,
        123536,
        123552,
        123580,
        123590,
        123596,
        123608,
        123630,
        123634,
        123636,
        123674,
        123698,
        123700,
        123740,
        123746,
        123748,
        123752,
        123834,
        123914,
        123922,
        123924,
        123938,
        123944,
        123958,
        123970,
        123976,
        123984,
        123998,
        124006,
        124012,
        124026,
        124034,
        124036,
        124048,
        124062,
        124064,
        124092,
        124102,
        124108,
        124120,
        124142,
        124146,
        124148,
        124162,
        124164,
        124168,
        124176,
        124190,
        124192,
        124220,
        124224,
        124280,
        124294,
        124300,
        124312,
        124336,
        124350,
        124366,
        124380,
        124386,
        124388,
        124392,
        124406,
        124442,
        124462,
        124466,
        124468,
        124494,
        124508,
        124514,
        124520,
        124558,
        124572,
        124600,
        124610,
        124612,
        124616,
        124624,
        124646,
        124666,
        124694,
        124710,
        124716,
        124730,
        124742,
        124748,
        124760,
        124786,
        124788,
        124818,
        124820,
        124834,
        124836,
        124840,
        124854,
        124946,
        124948,
        124962,
        124964,
        124968,
        124982,
        124994,
        124996,
        125e3,
        125008,
        125022,
        125030,
        125036,
        125050,
        125058,
        125060,
        125064,
        125072,
        125086,
        125088,
        125116,
        125126,
        125132,
        125144,
        125166,
        125170,
        125172,
        125186,
        125188,
        125192,
        125200,
        125216,
        125244,
        125248,
        125304,
        125318,
        125324,
        125336,
        125360,
        125374,
        125390,
        125404,
        125410,
        125412,
        125416,
        125430,
        125444,
        125448,
        125456,
        125472,
        125504,
        125560,
        125680,
        125702,
        125708,
        125720,
        125744,
        125758,
        125792,
        125820,
        125838,
        125852,
        125880,
        125890,
        125892,
        125896,
        125904,
        125918,
        125926,
        125932,
        125978,
        125998,
        126002,
        126004,
        126030,
        126044,
        126050,
        126052,
        126056,
        126094,
        126108,
        126136,
        126146,
        126148,
        126152,
        126160,
        126182,
        126202,
        126222,
        126236,
        126264,
        126320,
        126334,
        126338,
        126340,
        126344,
        126352,
        126366,
        126368,
        126412,
        126450,
        126452,
        126486,
        126502,
        126508,
        126522,
        126534,
        126540,
        126552,
        126574,
        126578,
        126580,
        126598,
        126604,
        126616,
        126640,
        126654,
        126670,
        126684,
        126690,
        126692,
        126696,
        126738,
        126754,
        126756,
        126760,
        126774,
        126786,
        126788,
        126792,
        126800,
        126814,
        126822,
        126828,
        126842,
        126894,
        126898,
        126900,
        126934,
        127126,
        127142,
        127148,
        127162,
        127178,
        127186,
        127188,
        127254,
        127270,
        127276,
        127290,
        127302,
        127308,
        127320,
        127342,
        127346,
        127348,
        127370,
        127378,
        127380,
        127394,
        127396,
        127400,
        127450,
        127510,
        127526,
        127532,
        127546,
        127558,
        127576,
        127598,
        127602,
        127604,
        127622,
        127628,
        127640,
        127664,
        127678,
        127694,
        127708,
        127714,
        127716,
        127720,
        127734,
        127754,
        127762,
        127764,
        127778,
        127784,
        127810,
        127812,
        127816,
        127824,
        127838,
        127846,
        127866,
        127898,
        127918,
        127922,
        127924,
        128022,
        128038,
        128044,
        128058,
        128070,
        128076,
        128088,
        128110,
        128114,
        128116,
        128134,
        128140,
        128152,
        128176,
        128190,
        128206,
        128220,
        128226,
        128228,
        128232,
        128246,
        128262,
        128268,
        128280,
        128304,
        128318,
        128352,
        128380,
        128398,
        128412,
        128440,
        128450,
        128452,
        128456,
        128464,
        128478,
        128486,
        128492,
        128506,
        128522,
        128530,
        128532,
        128546,
        128548,
        128552,
        128566,
        128578,
        128580,
        128584,
        128592,
        128606,
        128614,
        128634,
        128642,
        128644,
        128648,
        128656,
        128670,
        128672,
        128700,
        128716,
        128754,
        128756,
        128794,
        128814,
        128818,
        128820,
        128846,
        128860,
        128866,
        128868,
        128872,
        128886,
        128918,
        128934,
        128940,
        128954,
        128978,
        128980,
        129178,
        129198,
        129202,
        129204,
        129238,
        129258,
        129306,
        129326,
        129330,
        129332,
        129358,
        129372,
        129378,
        129380,
        129384,
        129398,
        129430,
        129446,
        129452,
        129466,
        129482,
        129490,
        129492,
        129562,
        129582,
        129586,
        129588,
        129614,
        129628,
        129634,
        129636,
        129640,
        129654,
        129678,
        129692,
        129720,
        129730,
        129732,
        129736,
        129744,
        129758,
        129766,
        129772,
        129814,
        129830,
        129836,
        129850,
        129862,
        129868,
        129880,
        129902,
        129906,
        129908,
        129930,
        129938,
        129940,
        129954,
        129956,
        129960,
        129974,
        130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2e3,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1e3,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]), t;
}(), $12c6b0ab9da17bee$var$cn = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $12c6b0ab9da17bee$var$fn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$hn = function() {
    function t() {}
    return t.detectMultiple = function(e, r, n) {
        var o = e.getBlackMatrix(), i = t.detect(n, o);
        return i.length || ((o = o.clone()).rotate180(), i = t.detect(n, o)), new $12c6b0ab9da17bee$var$cn(o, i);
    }, t.detect = function(e, r) {
        for(var n, o, i = new Array, a = 0, u = 0, s = !1; a < r.getHeight();){
            var c = t.findVertices(r, a, u);
            if (null != c[0] || null != c[3]) {
                if (s = !0, i.push(c), !e) break;
                null != c[2] ? (u = Math.trunc(c[2].getX()), a = Math.trunc(c[2].getY())) : (u = Math.trunc(c[4].getX()), a = Math.trunc(c[4].getY()));
            } else {
                if (!s) break;
                s = !1, u = 0;
                try {
                    for(var f = (n = void 0, $12c6b0ab9da17bee$var$fn(i)), h = f.next(); !h.done; h = f.next()){
                        var l = h.value;
                        null != l[1] && (a = Math.trunc(Math.max(a, l[1].getY()))), null != l[3] && (a = Math.max(a, Math.trunc(l[3].getY())));
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                a += t.ROW_STEP;
            }
        }
        return i;
    }, t.findVertices = function(e, r, n) {
        var o = e.getHeight(), i = e.getWidth(), a = new Array(8);
        return t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.START_PATTERN), t.INDEXES_START_PATTERN), null != a[4] && (n = Math.trunc(a[4].getX()), r = Math.trunc(a[4].getY())), t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), a;
    }, t.copyToResult = function(t, e, r) {
        for(var n = 0; n < r.length; n++)t[r[n]] = e[n];
    }, t.findRowsWithPattern = function(e, r, n, o, i, a) {
        for(var u = new Array(4), s = !1, c = new Int32Array(a.length); o < r; o += t.ROW_STEP)if (null != (d = t.findGuardPattern(e, i, o, n, !1, a, c))) {
            for(; o > 0;){
                if (null == (l = t.findGuardPattern(e, i, --o, n, !1, a, c))) {
                    o++;
                    break;
                }
                d = l;
            }
            u[0] = new $12c6b0ab9da17bee$var$At(d[0], o), u[1] = new $12c6b0ab9da17bee$var$At(d[1], o), s = !0;
            break;
        }
        var f = o + 1;
        if (s) {
            for(var h = 0, l = Int32Array.from([
                Math.trunc(u[0].getX()),
                Math.trunc(u[1].getX())
            ]); f < r; f++){
                var d;
                if (null != (d = t.findGuardPattern(e, l[0], f, n, !1, a, c)) && Math.abs(l[0] - d[0]) < t.MAX_PATTERN_DRIFT && Math.abs(l[1] - d[1]) < t.MAX_PATTERN_DRIFT) l = d, h = 0;
                else {
                    if (h > t.SKIPPED_ROW_COUNT_MAX) break;
                    h++;
                }
            }
            f -= h + 1, u[2] = new $12c6b0ab9da17bee$var$At(l[0], f), u[3] = new $12c6b0ab9da17bee$var$At(l[1], f);
        }
        return f - o < t.BARCODE_MIN_HEIGHT && $12c6b0ab9da17bee$var$C.fill(u, null), u;
    }, t.findGuardPattern = function(e, r, n, o, i, a, u) {
        $12c6b0ab9da17bee$var$C.fillWithin(u, 0, u.length, 0);
        for(var s = r, c = 0; e.get(s, n) && s > 0 && c++ < t.MAX_PIXEL_DRIFT;)s--;
        for(var f = s, h = 0, l = a.length, d = i; f < o; f++)if (e.get(f, n) !== d) u[h]++;
        else {
            if (h === l - 1) {
                if (t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE) return new Int32Array([
                    s,
                    f
                ]);
                s += u[0] + u[1], $12c6b0ab9da17bee$var$w.arraycopy(u, 2, u, 0, h - 1), u[h - 1] = 0, u[h] = 0, h--;
            } else h++;
            u[h] = 1, d = !d;
        }
        return h === l - 1 && t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([
            s,
            f - 1
        ]) : null;
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return 1 / 0;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return 1 / 0;
            s += l;
        }
        return s / o;
    }, t.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]), t.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]), t.MAX_AVG_VARIANCE = .42, t.MAX_INDIVIDUAL_VARIANCE = .8, t.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]), t.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
}(), $12c6b0ab9da17bee$var$ln = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$dn = function() {
    function t(t, e) {
        if (0 === e.length) throw new $12c6b0ab9da17bee$var$l;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = new Int32Array([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $12c6b0ab9da17bee$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        var e, r;
        if (0 === t) return this.getCoefficient(0);
        if (1 === t) {
            var n = 0;
            try {
                for(var o = $12c6b0ab9da17bee$var$ln(this.coefficients), i = o.next(); !i.done; i = o.next()){
                    var a = i.value;
                    n = this.field.add(n, a);
                }
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    i && !i.done && (r = o.return) && r.call(o);
                } finally{
                    if (e) throw e.error;
                }
            }
            return n;
        }
        for(var u = this.coefficients[0], s = this.coefficients.length, c = 1; c < s; c++)u = this.field.add(this.field.multiply(t, u), this.coefficients[c]);
        return u;
    }, t.prototype.add = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $12c6b0ab9da17bee$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = this.field.add(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.subtract = function(t) {
        if (!this.field.equals(t.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        return t.isZero() ? this : this.add(t.negative());
    }, t.prototype.multiply = function(e) {
        return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || e.isZero()) return new t(this.field, new Int32Array([
            0
        ]));
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = 0; u < n; u++)for(var s = r[u], c = 0; c < i; c++)a[u + c] = this.field.add(a[u + c], this.field.multiply(s, o[c]));
        return new t(this.field, a);
    }, t.prototype.negative = function() {
        for(var e = this.coefficients.length, r = new Int32Array(e), n = 0; n < e; n++)r[n] = this.field.subtract(0, this.coefficients[n]);
        return new t(this.field, r);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return new t(this.field, new Int32Array([
            0
        ]));
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = new Int32Array(r), o = 0; o < r; o++)n[o] = this.field.multiply(this.coefficients[o], e);
        return new t(this.field, n);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === r) return new t(this.field, new Int32Array([
            0
        ]));
        for(var n = this.coefficients.length, o = new Int32Array(n + e), i = 0; i < n; i++)o[i] = this.field.multiply(this.coefficients[i], r);
        return new t(this.field, o);
    }, t.prototype.toString = function() {
        for(var t = new $12c6b0ab9da17bee$var$k, e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            0 !== r && (r < 0 ? (t.append(" - "), r = -r) : t.length() > 0 && t.append(" + "), 0 !== e && 1 === r || t.append(r), 0 !== e && (1 === e ? t.append("x") : (t.append("x^"), t.append(e))));
        }
        return t.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$pn = function() {
    function t() {}
    return t.prototype.add = function(t, e) {
        return (t + e) % this.modulus;
    }, t.prototype.subtract = function(t, e) {
        return (this.modulus + t - e) % this.modulus;
    }, t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$l;
        return this.logTable[t];
    }, t.prototype.inverse = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$ft;
        return this.expTable[this.modulus - this.logTable[t] - 1];
    }, t.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
        return this.modulus;
    }, t.prototype.equals = function(t) {
        return t === this;
    }, t;
}(), $12c6b0ab9da17bee$var$gn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$yn = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        n.modulus = e, n.expTable = new Int32Array(e), n.logTable = new Int32Array(e);
        for(var o = 1, i = 0; i < e; i++)n.expTable[i] = o, o = o * r % e;
        for(i = 0; i < e - 1; i++)n.logTable[n.expTable[i]] = i;
        return n.zero = new $12c6b0ab9da17bee$var$dn(n, new Int32Array([
            0
        ])), n.one = new $12c6b0ab9da17bee$var$dn(n, new Int32Array([
            1
        ])), n;
    }
    return $12c6b0ab9da17bee$var$gn(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $12c6b0ab9da17bee$var$dn(this, r);
    }, e.PDF417_GF = new e($12c6b0ab9da17bee$var$sn.NUMBER_OF_CODEWORDS, 3), e;
}($12c6b0ab9da17bee$var$pn), $12c6b0ab9da17bee$var$wn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$_n = function() {
    function t() {
        this.field = $12c6b0ab9da17bee$var$yn.PDF417_GF;
    }
    return t.prototype.decode = function(t, e, r) {
        for(var n, o, i = new $12c6b0ab9da17bee$var$dn(this.field, t), a = new Int32Array(e), u = !1, s = e; s > 0; s--){
            var c = i.evaluateAt(this.field.exp(s));
            a[e - s] = c, 0 !== c && (u = !0);
        }
        if (!u) return 0;
        var f = this.field.getOne();
        if (null != r) try {
            for(var h = $12c6b0ab9da17bee$var$wn(r), l = h.next(); !l.done; l = h.next()){
                var d = l.value, p = this.field.exp(t.length - 1 - d), y = new $12c6b0ab9da17bee$var$dn(this.field, new Int32Array([
                    this.field.subtract(0, p),
                    1
                ]));
                f = f.multiply(y);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (o = h.return) && o.call(h);
            } finally{
                if (n) throw n.error;
            }
        }
        var w = new $12c6b0ab9da17bee$var$dn(this.field, a), _ = this.runEuclideanAlgorithm(this.field.buildMonomial(e, 1), w, e), v = _[0], m = _[1], A = this.findErrorLocations(v), E = this.findErrorMagnitudes(m, v, A);
        for(s = 0; s < A.length; s++){
            var C = t.length - 1 - this.field.log(A[s]);
            if (C < 0) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            t[C] = this.field.subtract(t[C], E[s]);
        }
        return A.length;
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = t, i = e, a = this.field.getZero(), u = this.field.getOne(); i.getDegree() >= Math.round(r / 2);){
            var s = o, c = a;
            if (a = u, (o = i).isZero()) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            i = s;
            for(var f = this.field.getZero(), h = o.getCoefficient(o.getDegree()), l = this.field.inverse(h); i.getDegree() >= o.getDegree() && !i.isZero();){
                var d = i.getDegree() - o.getDegree(), p = this.field.multiply(i.getCoefficient(i.getDegree()), l);
                f = f.add(this.field.buildMonomial(d, p)), i = i.subtract(o.multiplyByMonomial(d, p));
            }
            u = f.multiply(a).subtract(c).negative();
        }
        var y = u.getCoefficient(0);
        if (0 === y) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        var w = this.field.inverse(y);
        return [
            u.multiply(w),
            i.multiply(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        for(var e = t.getDegree(), r = new Int32Array(e), n = 0, o = 1; o < this.field.getSize() && n < e; o++)0 === t.evaluateAt(o) && (r[n] = this.field.inverse(o), n++);
        if (n !== e) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e, r) {
        for(var n = e.getDegree(), o = new Int32Array(n), i = 1; i <= n; i++)o[n - i] = this.field.multiply(i, e.getCoefficient(i));
        var a = new $12c6b0ab9da17bee$var$dn(this.field, o), u = r.length, s = new Int32Array(u);
        for(i = 0; i < u; i++){
            var c = this.field.inverse(r[i]), f = this.field.subtract(0, t.evaluateAt(c)), h = this.field.inverse(a.evaluateAt(c));
            s[i] = this.field.multiply(f, h);
        }
        return s;
    }, t;
}(), $12c6b0ab9da17bee$var$vn = function() {
    function t(e, r, n, o, i) {
        e instanceof t ? this.constructor_2(e) : this.constructor_1(e, r, n, o, i);
    }
    return t.prototype.constructor_1 = function(t, e, r, n, o) {
        var i = null == e || null == r, a = null == n || null == o;
        if (i && a) throw new $12c6b0ab9da17bee$var$U;
        i ? (e = new $12c6b0ab9da17bee$var$At(0, n.getY()), r = new $12c6b0ab9da17bee$var$At(0, o.getY())) : a && (n = new $12c6b0ab9da17bee$var$At(t.getWidth() - 1, e.getY()), o = new $12c6b0ab9da17bee$var$At(t.getWidth() - 1, r.getY())), this.image = t, this.topLeft = e, this.bottomLeft = r, this.topRight = n, this.bottomRight = o, this.minX = Math.trunc(Math.min(e.getX(), r.getX())), this.maxX = Math.trunc(Math.max(n.getX(), o.getX())), this.minY = Math.trunc(Math.min(e.getY(), n.getY())), this.maxY = Math.trunc(Math.max(r.getY(), o.getY()));
    }, t.prototype.constructor_2 = function(t) {
        this.image = t.image, this.topLeft = t.getTopLeft(), this.bottomLeft = t.getBottomLeft(), this.topRight = t.getTopRight(), this.bottomRight = t.getBottomRight(), this.minX = t.getMinX(), this.maxX = t.getMaxX(), this.minY = t.getMinY(), this.maxY = t.getMaxY();
    }, t.merge = function(e, r) {
        return null == e ? r : null == r ? e : new t(e.image, e.topLeft, e.bottomLeft, r.topRight, r.bottomRight);
    }, t.prototype.addMissingRows = function(e, r, n) {
        var o = this.topLeft, i = this.bottomLeft, a = this.topRight, u = this.bottomRight;
        if (e > 0) {
            var s = n ? this.topLeft : this.topRight, c = Math.trunc(s.getY() - e);
            c < 0 && (c = 0);
            var f = new $12c6b0ab9da17bee$var$At(s.getX(), c);
            n ? o = f : a = f;
        }
        if (r > 0) {
            var h = n ? this.bottomLeft : this.bottomRight, l = Math.trunc(h.getY() + r);
            l >= this.image.getHeight() && (l = this.image.getHeight() - 1);
            var d = new $12c6b0ab9da17bee$var$At(h.getX(), l);
            n ? i = d : u = d;
        }
        return new t(this.image, o, i, a, u);
    }, t.prototype.getMinX = function() {
        return this.minX;
    }, t.prototype.getMaxX = function() {
        return this.maxX;
    }, t.prototype.getMinY = function() {
        return this.minY;
    }, t.prototype.getMaxY = function() {
        return this.maxY;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
        return this.bottomRight;
    }, t;
}(), $12c6b0ab9da17bee$var$mn = function() {
    function t(t, e, r, n) {
        this.columnCount = t, this.errorCorrectionLevel = n, this.rowCountUpperPart = e, this.rowCountLowerPart = r, this.rowCount = e + r;
    }
    return t.prototype.getColumnCount = function() {
        return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
        return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    }, t;
}(), $12c6b0ab9da17bee$var$An = function() {
    function t() {
        this.buffer = "";
    }
    return t.form = function(t, e) {
        var r = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, n, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++r]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[r];
                        break;
                    case "c":
                        s = e[r][0];
                        break;
                    case "f":
                        s = parseFloat(e[r]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[r]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[r]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[r]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[r], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== n ? s + h : h + s;
                return s;
            }
        });
    }, t.prototype.format = function(e) {
        for(var r = [], n = 1; n < arguments.length; n++)r[n - 1] = arguments[n];
        this.buffer += t.form(e, r);
    }, t.prototype.toString = function() {
        return this.buffer;
    }, t;
}(), $12c6b0ab9da17bee$var$En = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Cn = function() {
    function t(t) {
        this.boundingBox = new $12c6b0ab9da17bee$var$vn(t), this.codewords = new Array(t.getMaxY() - t.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
        var r = this.getCodeword(e);
        if (null != r) return r;
        for(var n = 1; n < t.MAX_NEARBY_DISTANCE; n++){
            var o = this.imageRowToCodewordIndex(e) - n;
            if (o >= 0 && null != (r = this.codewords[o])) return r;
            if ((o = this.imageRowToCodewordIndex(e) + n) < this.codewords.length && null != (r = this.codewords[o])) return r;
        }
        return null;
    }, t.prototype.imageRowToCodewordIndex = function(t) {
        return t - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(t, e) {
        this.codewords[this.imageRowToCodewordIndex(t)] = e;
    }, t.prototype.getCodeword = function(t) {
        return this.codewords[this.imageRowToCodewordIndex(t)];
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.toString = function() {
        var t, e, r = new $12c6b0ab9da17bee$var$An, n = 0;
        try {
            for(var o = $12c6b0ab9da17bee$var$En(this.codewords), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                null != a ? r.format("%3d: %3d|%3d%n", n++, a.getRowNumber(), a.getValue()) : r.format("%3d:    |   %n", n++);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
}(), $12c6b0ab9da17bee$var$In = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Sn = function(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n, o, i = r.call(t), a = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(n = i.next()).done;)a.push(n.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            n && !n.done && (r = i.return) && r.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}, $12c6b0ab9da17bee$var$On = function() {
    function t() {
        this.values = new Map;
    }
    return t.prototype.setValue = function(t) {
        t = Math.trunc(t);
        var e = this.values.get(t);
        null == e && (e = 0), e++, this.values.set(t, e);
    }, t.prototype.getValue = function() {
        var t, e, r = -1, n = new Array, o = function(t, e) {
            var o = function() {
                return t;
            }, i = function() {
                return e;
            };
            i() > r ? (r = i(), (n = []).push(o())) : i() === r && n.push(o());
        };
        try {
            for(var i = $12c6b0ab9da17bee$var$In(this.values.entries()), a = i.next(); !a.done; a = i.next()){
                var u = $12c6b0ab9da17bee$var$Sn(a.value, 2);
                o(u[0], u[1]);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (e = i.return) && e.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return $12c6b0ab9da17bee$var$sn.toIntArray(n);
    }, t.prototype.getConfidence = function(t) {
        return this.values.get(t);
    }, t;
}(), $12c6b0ab9da17bee$var$Tn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$bn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Rn = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n._isLeft = r, n;
    }
    return $12c6b0ab9da17bee$var$Tn(e, t), e.prototype.setRowNumbers = function() {
        var t, e;
        try {
            for(var r = $12c6b0ab9da17bee$var$bn(this.getCodewords()), n = r.next(); !n.done; n = r.next()){
                var o = n.value;
                null != o && o.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
        var e = this.getCodewords();
        this.setRowNumbers(), this.removeIncorrectCodewords(e, t);
        for(var r = this.getBoundingBox(), n = this._isLeft ? r.getTopLeft() : r.getTopRight(), o = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.imageRowToCodewordIndex(Math.trunc(o.getY())), u = -1, s = 1, c = 0, f = i; f < a; f++)if (null != e[f]) {
            var h = e[f], l = h.getRowNumber() - u;
            if (0 === l) c++;
            else if (1 === l) s = Math.max(s, c), c = 1, u = h.getRowNumber();
            else if (l < 0 || h.getRowNumber() >= t.getRowCount() || l > f) e[f] = null;
            else {
                for(var d = void 0, p = (d = s > 2 ? (s - 2) * l : l) >= f, g = 1; g <= d && !p; g++)p = null != e[f - g];
                p ? e[f] = null : (u = h.getRowNumber(), c = 1);
            }
        }
    }, e.prototype.getRowHeights = function() {
        var t, e, r = this.getBarcodeMetadata();
        if (null == r) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(r);
        var n = new Int32Array(r.getRowCount());
        try {
            for(var o = $12c6b0ab9da17bee$var$bn(this.getCodewords()), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (null != a) {
                    var u = a.getRowNumber();
                    if (u >= n.length) continue;
                    n[u]++;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
        for(var e = this.getBoundingBox(), r = this._isLeft ? e.getTopLeft() : e.getTopRight(), n = this._isLeft ? e.getBottomLeft() : e.getBottomRight(), o = this.imageRowToCodewordIndex(Math.trunc(r.getY())), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.getCodewords(), u = -1, s = o; s < i; s++)if (null != a[s]) {
            var c = a[s];
            c.setRowNumberAsRowIndicatorColumn();
            var f = c.getRowNumber() - u;
            0 === f || (1 === f ? u = c.getRowNumber() : c.getRowNumber() >= t.getRowCount() ? a[s] = null : u = c.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
        var t, e, r = this.getCodewords(), n = new $12c6b0ab9da17bee$var$On, o = new $12c6b0ab9da17bee$var$On, i = new $12c6b0ab9da17bee$var$On, a = new $12c6b0ab9da17bee$var$On;
        try {
            for(var u = $12c6b0ab9da17bee$var$bn(r), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (null != c) {
                    c.setRowNumberAsRowIndicatorColumn();
                    var f = c.getValue() % 30, h = c.getRowNumber();
                    switch(this._isLeft || (h += 2), h % 3){
                        case 0:
                            o.setValue(3 * f + 1);
                            break;
                        case 1:
                            a.setValue(f / 3), i.setValue(f % 3);
                            break;
                        case 2:
                            n.setValue(f + 1);
                    }
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (e = u.return) && e.call(u);
            } finally{
                if (t) throw t.error;
            }
        }
        if (0 === n.getValue().length || 0 === o.getValue().length || 0 === i.getValue().length || 0 === a.getValue().length || n.getValue()[0] < 1 || o.getValue()[0] + i.getValue()[0] < $12c6b0ab9da17bee$var$sn.MIN_ROWS_IN_BARCODE || o.getValue()[0] + i.getValue()[0] > $12c6b0ab9da17bee$var$sn.MAX_ROWS_IN_BARCODE) return null;
        var l = new $12c6b0ab9da17bee$var$mn(n.getValue()[0], o.getValue()[0], i.getValue()[0], a.getValue()[0]);
        return this.removeIncorrectCodewords(r, l), l;
    }, e.prototype.removeIncorrectCodewords = function(t, e) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            if (null != t[r]) {
                var o = n.getValue() % 30, i = n.getRowNumber();
                if (i > e.getRowCount()) t[r] = null;
                else switch(this._isLeft || (i += 2), i % 3){
                    case 0:
                        3 * o + 1 !== e.getRowCountUpperPart() && (t[r] = null);
                        break;
                    case 1:
                        Math.trunc(o / 3) === e.getErrorCorrectionLevel() && o % 3 === e.getRowCountLowerPart() || (t[r] = null);
                        break;
                    case 2:
                        o + 1 !== e.getColumnCount() && (t[r] = null);
                }
            }
        }
    }, e.prototype.isLeft = function() {
        return this._isLeft;
    }, e.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + t.prototype.toString.call(this);
    }, e;
}($12c6b0ab9da17bee$var$Cn), $12c6b0ab9da17bee$var$Nn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Dn = function() {
    function t(t, e) {
        this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = t, this.barcodeColumnCount = t.getColumnCount(), this.boundingBox = e, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var t, e = $12c6b0ab9da17bee$var$sn.MAX_CODEWORDS_IN_BARCODE;
        do t = e, e = this.adjustRowNumbersAndGetCount();
        while (e > 0 && e < t);
        return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(t) {
        null != t && t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
        var t = this.adjustRowNumbersByRow();
        if (0 === t) return 0;
        for(var e = 1; e < this.barcodeColumnCount + 1; e++)for(var r = this.detectionResultColumns[e].getCodewords(), n = 0; n < r.length; n++)null != r[n] && (r[n].hasValidRowNumber() || this.adjustRowNumbers(e, n, r));
        return t;
    }, t.prototype.adjustRowNumbersByRow = function() {
        return this.adjustRowNumbersFromBothRI(), this.adjustRowNumbersFromLRI() + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
        if (null != this.detectionResultColumns[0] && null != this.detectionResultColumns[this.barcodeColumnCount + 1]) {
            for(var t = this.detectionResultColumns[0].getCodewords(), e = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < t.length; r++)if (null != t[r] && null != e[r] && t[r].getRowNumber() === e[r].getRowNumber()) for(var n = 1; n <= this.barcodeColumnCount; n++){
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o && (o.setRowNumber(t[r].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[n].getCodewords()[r] = null));
            }
        }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
        if (null == this.detectionResultColumns[this.barcodeColumnCount + 1]) return 0;
        for(var e = 0, r = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = this.barcodeColumnCount + 1; a > 0 && i < this.ADJUST_ROW_NUMBER_SKIP; a--){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
        if (null == this.detectionResultColumns[0]) return 0;
        for(var e = 0, r = this.detectionResultColumns[0].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = 1; a < this.barcodeColumnCount + 1 && i < this.ADJUST_ROW_NUMBER_SKIP; a++){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.adjustRowNumberIfValid = function(t, e, r) {
        return null == r || r.hasValidRowNumber() || (r.isValidRowNumber(t) ? (r.setRowNumber(t), e = 0) : ++e), e;
    }, t.prototype.adjustRowNumbers = function(e, r, n) {
        var o, i, a = n[r], u = this.detectionResultColumns[e - 1].getCodewords(), s = u;
        null != this.detectionResultColumns[e + 1] && (s = this.detectionResultColumns[e + 1].getCodewords());
        var c = new Array(14);
        c[2] = u[r], c[3] = s[r], r > 0 && (c[0] = n[r - 1], c[4] = u[r - 1], c[5] = s[r - 1]), r > 1 && (c[8] = n[r - 2], c[10] = u[r - 2], c[11] = s[r - 2]), r < n.length - 1 && (c[1] = n[r + 1], c[6] = u[r + 1], c[7] = s[r + 1]), r < n.length - 2 && (c[9] = n[r + 2], c[12] = u[r + 2], c[13] = s[r + 2]);
        try {
            for(var f = $12c6b0ab9da17bee$var$Nn(c), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (t.adjustRowNumber(a, l)) return;
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
    }, t.adjustRowNumber = function(t, e) {
        return null != e && !(!e.hasValidRowNumber() || e.getBucket() !== t.getBucket()) && (t.setRowNumber(e.getRowNumber()), !0);
    }, t.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(t) {
        this.boundingBox = t;
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(t, e) {
        this.detectionResultColumns[t] = e;
    }, t.prototype.getDetectionResultColumn = function(t) {
        return this.detectionResultColumns[t];
    }, t.prototype.toString = function() {
        var t = this.detectionResultColumns[0];
        null == t && (t = this.detectionResultColumns[this.barcodeColumnCount + 1]);
        for(var e = new $12c6b0ab9da17bee$var$An, r = 0; r < t.getCodewords().length; r++){
            e.format("CW %3d:", r);
            for(var n = 0; n < this.barcodeColumnCount + 2; n++)if (null != this.detectionResultColumns[n]) {
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o ? e.format(" %3d|%3d", o.getRowNumber(), o.getValue()) : e.format("    |   ");
            } else e.format("    |   ");
            e.format("%n");
        }
        return e.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$Pn = function() {
    function t(e, r, n, o) {
        this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(r), this.bucket = Math.trunc(n), this.value = Math.trunc(o);
    }
    return t.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
        return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(3 * Math.trunc(this.value / 30) + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
        return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
        return this.startX;
    }, t.prototype.getEndX = function() {
        return this.endX;
    }, t.prototype.getBucket = function() {
        return this.bucket;
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.setRowNumber = function(t) {
        this.rowNumber = t;
    }, t.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
}(), $12c6b0ab9da17bee$var$Mn = function() {
    function t() {}
    return t.initialize = function() {
        for(var e = 0; e < $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE.length; e++)for(var r = $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE[e], n = 1 & r, o = 0; o < $12c6b0ab9da17bee$var$sn.BARS_IN_MODULE; o++){
            for(var i = 0; (1 & r) === n;)i += 1, r >>= 1;
            n = 1 & r, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE)), t.RATIOS_TABLE[e][$12c6b0ab9da17bee$var$sn.BARS_IN_MODULE - o - 1] = Math.fround(i / $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD);
        }
        this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
        var r = t.getDecodedCodewordValue(t.sampleBitCounts(e));
        return -1 !== r ? r : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(t) {
        for(var e = $12c6b0ab9da17bee$var$vt.sum(t), r = new Int32Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE), n = 0, o = 0, i = 0; i < $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD; i++){
            var a = e / (2 * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD) + i * e / $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD;
            o + t[n] <= a && (o += t[n], n++), r[n]++;
        }
        return r;
    }, t.getDecodedCodewordValue = function(e) {
        var r = t.getBitValue(e);
        return -1 === $12c6b0ab9da17bee$var$sn.getCodeword(r) ? -1 : r;
    }, t.getBitValue = function(t) {
        for(var e = 0, r = 0; r < t.length; r++)for(var n = 0; n < t[r]; n++)e = e << 1 | (r % 2 == 0 ? 1 : 0);
        return Math.trunc(e);
    }, t.getClosestDecodedValue = function(e) {
        var r = $12c6b0ab9da17bee$var$vt.sum(e), n = new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE);
        if (r > 1) for(var o = 0; o < n.length; o++)n[o] = Math.fround(e[o] / r);
        var i = $12c6b0ab9da17bee$var$mt.MAX_VALUE, a = -1;
        this.bSymbolTableReady || t.initialize();
        for(var u = 0; u < t.RATIOS_TABLE.length; u++){
            for(var s = 0, c = t.RATIOS_TABLE[u], f = 0; f < $12c6b0ab9da17bee$var$sn.BARS_IN_MODULE; f++){
                var h = Math.fround(c[f] - n[f]);
                if ((s += Math.fround(h * h)) >= i) break;
            }
            s < i && (i = s, a = $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE[u]);
        }
        return a;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array($12c6b0ab9da17bee$var$sn.SYMBOL_TABLE.length).map(function(t) {
        return new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE);
    }), t;
}(), $12c6b0ab9da17bee$var$Bn = function() {
    function t() {
        this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(t) {
        this.segmentIndex = t;
    }, t.prototype.getFileId = function() {
        return this.fileId;
    }, t.prototype.setFileId = function(t) {
        this.fileId = t;
    }, t.prototype.getOptionalData = function() {
        return this.optionalData;
    }, t.prototype.setOptionalData = function(t) {
        this.optionalData = t;
    }, t.prototype.isLastSegment = function() {
        return this.lastSegment;
    }, t.prototype.setLastSegment = function(t) {
        this.lastSegment = t;
    }, t.prototype.getSegmentCount = function() {
        return this.segmentCount;
    }, t.prototype.setSegmentCount = function(t) {
        this.segmentCount = t;
    }, t.prototype.getSender = function() {
        return this.sender || null;
    }, t.prototype.setSender = function(t) {
        this.sender = t;
    }, t.prototype.getAddressee = function() {
        return this.addressee || null;
    }, t.prototype.setAddressee = function(t) {
        this.addressee = t;
    }, t.prototype.getFileName = function() {
        return this.fileName;
    }, t.prototype.setFileName = function(t) {
        this.fileName = t;
    }, t.prototype.getFileSize = function() {
        return this.fileSize;
    }, t.prototype.setFileSize = function(t) {
        this.fileSize = t;
    }, t.prototype.getChecksum = function() {
        return this.checksum;
    }, t.prototype.setChecksum = function(t) {
        this.checksum = t;
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.setTimestamp = function(t) {
        this.timestamp = t;
    }, t;
}(), $12c6b0ab9da17bee$var$Ln = function() {
    function t() {}
    return t.parseLong = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t;
}(), $12c6b0ab9da17bee$var$Fn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$kn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Fn(e, t), e.kind = "NullPointerException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$xn = function() {
    function t() {}
    return t.prototype.writeBytes = function(t) {
        this.writeBytesOffset(t, 0, t.length);
    }, t.prototype.writeBytesOffset = function(t, e, r) {
        if (null == t) throw new $12c6b0ab9da17bee$var$kn;
        if (e < 0 || e > t.length || r < 0 || e + r > t.length || e + r < 0) throw new $12c6b0ab9da17bee$var$v;
        if (0 !== r) for(var n = 0; n < r; n++)this.write(t[e + n]);
    }, t.prototype.flush = function() {}, t.prototype.close = function() {}, t;
}(), $12c6b0ab9da17bee$var$Vn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Un = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Vn(e, t), e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$Hn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Gn = function(t) {
    function e(e) {
        void 0 === e && (e = 32);
        var r = t.call(this) || this;
        if (r.count = 0, e < 0) throw new $12c6b0ab9da17bee$var$l("Negative initial size: " + e);
        return r.buf = new Uint8Array(e), r;
    }
    return $12c6b0ab9da17bee$var$Hn(e, t), e.prototype.ensureCapacity = function(t) {
        t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
        var e = this.buf.length << 1;
        if (e - t < 0 && (e = t), e < 0) {
            if (t < 0) throw new $12c6b0ab9da17bee$var$Un;
            e = $12c6b0ab9da17bee$var$I.MAX_VALUE;
        }
        this.buf = $12c6b0ab9da17bee$var$C.copyOfUint8Array(this.buf, e);
    }, e.prototype.write = function(t) {
        this.ensureCapacity(this.count + 1), this.buf[this.count] = t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, e, r) {
        if (e < 0 || e > t.length || r < 0 || e + r - t.length > 0) throw new $12c6b0ab9da17bee$var$v;
        this.ensureCapacity(this.count + r), $12c6b0ab9da17bee$var$w.arraycopy(t, e, this.buf, this.count, r), this.count += r;
    }, e.prototype.writeTo = function(t) {
        t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
        this.count = 0;
    }, e.prototype.toByteArray = function() {
        return $12c6b0ab9da17bee$var$C.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
        return this.count;
    }, e.prototype.toString = function(t) {
        return t ? "string" == typeof t ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
        return new String(this.buf).toString();
    }, e.prototype.toString_string = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.toString_number = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.close = function() {}, e;
}($12c6b0ab9da17bee$var$xn);
function $12c6b0ab9da17bee$var$Xn() {
    if ("undefined" != typeof window) return window.BigInt || null;
    if ("undefined" != typeof $parcel$global) return $parcel$global.BigInt || null;
    if ("undefined" != typeof self) return self.BigInt || null;
    throw new Error("Can't search globals for BigInt!");
}
function $12c6b0ab9da17bee$var$Wn(t) {
    if (void 0 === $12c6b0ab9da17bee$var$Xr && ($12c6b0ab9da17bee$var$Xr = $12c6b0ab9da17bee$var$Xn()), null === $12c6b0ab9da17bee$var$Xr) throw new Error("BigInt is not supported!");
    return $12c6b0ab9da17bee$var$Xr(t);
}
!function(t) {
    t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
}($12c6b0ab9da17bee$var$Gr || ($12c6b0ab9da17bee$var$Gr = {}));
var $12c6b0ab9da17bee$var$jn = function() {
    function t() {}
    return t.decode = function(e, r) {
        var n = new $12c6b0ab9da17bee$var$k(""), o = $12c6b0ab9da17bee$var$P.ISO8859_1;
        n.enableDecoding(o);
        for(var i = 1, a = e[i++], u = new $12c6b0ab9da17bee$var$Bn; i < e[0];){
            switch(a){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    i = t.textCompaction(e, i, n);
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                    i = t.byteCompaction(a, e, o, i, n);
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    n.append(e[i++]);
                    break;
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                    i = t.numericCompaction(e, i, n);
                    break;
                case t.ECI_CHARSET:
                    $12c6b0ab9da17bee$var$P.getCharacterSetECIByValue(e[i++]);
                    break;
                case t.ECI_GENERAL_PURPOSE:
                    i += 2;
                    break;
                case t.ECI_USER_DEFINED:
                    i++;
                    break;
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    i = t.decodeMacroBlock(e, i, u);
                    break;
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    throw new $12c6b0ab9da17bee$var$R;
                default:
                    i--, i = t.textCompaction(e, i, n);
            }
            if (!(i < e.length)) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
            a = e[i++];
        }
        if (0 === n.length()) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var s = new $12c6b0ab9da17bee$var$at(null, n.toString(), null, r);
        return s.setOther(u), s;
    }, t.decodeMacroBlock = function(e, r, n) {
        if (r + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0]) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        for(var o = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), i = 0; i < t.NUMBER_OF_SEQUENCE_CODEWORDS; i++, r++)o[i] = e[r];
        n.setSegmentIndex($12c6b0ab9da17bee$var$I.parseInt(t.decodeBase900toBase10(o, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var a = new $12c6b0ab9da17bee$var$k;
        r = t.textCompaction(e, r, a), n.setFileId(a.toString());
        var u = -1;
        for(e[r] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (u = r + 1); r < e[0];)switch(e[r]){
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                switch(e[++r]){
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var s = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, s), n.setFileName(s.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var c = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, c), n.setSender(c.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var f = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, f), n.setAddressee(f.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var h = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, h), n.setSegmentCount($12c6b0ab9da17bee$var$I.parseInt(h.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var l = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, l), n.setTimestamp($12c6b0ab9da17bee$var$Ln.parseLong(l.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var d = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, d), n.setChecksum($12c6b0ab9da17bee$var$I.parseInt(d.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var p = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, p), n.setFileSize($12c6b0ab9da17bee$var$Ln.parseLong(p.toString()));
                        break;
                    default:
                        throw $12c6b0ab9da17bee$var$R.getFormatInstance();
                }
                break;
            case t.MACRO_PDF417_TERMINATOR:
                r++, n.setLastSegment(!0);
                break;
            default:
                throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        }
        if (-1 !== u) {
            var g = r - u;
            n.isLastSegment() && g--, n.setOptionalData($12c6b0ab9da17bee$var$C.copyOfRange(e, u, u + g));
        }
        return r;
    }, t.textCompaction = function(e, r, n) {
        for(var o = new Int32Array(2 * (e[0] - r)), i = new Int32Array(2 * (e[0] - r)), a = 0, u = !1; r < e[0] && !u;){
            var s = e[r++];
            if (s < t.TEXT_COMPACTION_MODE_LATCH) o[a] = s / 30, o[a + 1] = s % 30, a += 2;
            else switch(s){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    o[a++] = t.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, u = !0;
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    o[a] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, s = e[r++], i[a] = s, a++;
            }
        }
        return t.decodeTextCompaction(o, i, a, n), r;
    }, t.decodeTextCompaction = function(e, r, n, o) {
        for(var i = $12c6b0ab9da17bee$var$Gr.ALPHA, a = $12c6b0ab9da17bee$var$Gr.ALPHA, u = 0; u < n;){
            var s = e[u], c = "";
            switch(i){
                case $12c6b0ab9da17bee$var$Gr.ALPHA:
                    if (s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $12c6b0ab9da17bee$var$Gr.LOWER;
                            break;
                        case t.ML:
                            i = $12c6b0ab9da17bee$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.LOWER:
                    if (s < 26) c = String.fromCharCode(97 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.AS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.ALPHA_SHIFT;
                            break;
                        case t.ML:
                            i = $12c6b0ab9da17bee$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.MIXED:
                    if (s < t.PL) c = t.MIXED_CHARS[s];
                    else switch(s){
                        case t.PL:
                            i = $12c6b0ab9da17bee$var$Gr.PUNCT;
                            break;
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $12c6b0ab9da17bee$var$Gr.LOWER;
                            break;
                        case t.AL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.PUNCT:
                    if (s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.ALPHA_SHIFT:
                    if (i = a, s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT:
                    if (i = a, s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
            }
            "" !== c && o.append(c), u++;
        }
    }, t.byteCompaction = function(e, r, n, o, i) {
        var a = new $12c6b0ab9da17bee$var$Gn, u = 0, s = 0, c = !1;
        switch(e){
            case t.BYTE_COMPACTION_MODE_LATCH:
                for(var f = new Int32Array(6), h = r[o++]; o < r[0] && !c;)switch(f[u++] = h, s = 900 * s + h, h = r[o++]){
                    case t.TEXT_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH:
                    case t.NUMERIC_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH_6:
                    case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case t.MACRO_PDF417_TERMINATOR:
                        o--, c = !0;
                        break;
                    default:
                        if (u % 5 == 0 && u > 0) {
                            for(var l = 0; l < 6; ++l)a.write(Number($12c6b0ab9da17bee$var$Wn(s) >> $12c6b0ab9da17bee$var$Wn(8 * (5 - l))));
                            s = 0, u = 0;
                        }
                }
                o === r[0] && h < t.TEXT_COMPACTION_MODE_LATCH && (f[u++] = h);
                for(var d = 0; d < u; d++)a.write(f[d]);
                break;
            case t.BYTE_COMPACTION_MODE_LATCH_6:
                for(; o < r[0] && !c;){
                    var p = r[o++];
                    if (p < t.TEXT_COMPACTION_MODE_LATCH) u++, s = 900 * s + p;
                    else switch(p){
                        case t.TEXT_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH:
                        case t.NUMERIC_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH_6:
                        case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case t.MACRO_PDF417_TERMINATOR:
                            o--, c = !0;
                    }
                    if (u % 5 == 0 && u > 0) {
                        for(l = 0; l < 6; ++l)a.write(Number($12c6b0ab9da17bee$var$Wn(s) >> $12c6b0ab9da17bee$var$Wn(8 * (5 - l))));
                        s = 0, u = 0;
                    }
                }
        }
        return i.append($12c6b0ab9da17bee$var$L.decode(a.toByteArray(), n)), o;
    }, t.numericCompaction = function(e, r, n) {
        for(var o = 0, i = !1, a = new Int32Array(t.MAX_NUMERIC_CODEWORDS); r < e[0] && !i;){
            var u = e[r++];
            if (r === e[0] && (i = !0), u < t.TEXT_COMPACTION_MODE_LATCH) a[o] = u, o++;
            else switch(u){
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, i = !0;
            }
            (o % t.MAX_NUMERIC_CODEWORDS == 0 || u === t.NUMERIC_COMPACTION_MODE_LATCH || i) && o > 0 && (n.append(t.decodeBase900toBase10(a, o)), o = 0);
        }
        return r;
    }, t.decodeBase900toBase10 = function(e, r) {
        for(var n = $12c6b0ab9da17bee$var$Wn(0), o = 0; o < r; o++)n += t.EXP900[r - o - 1] * $12c6b0ab9da17bee$var$Wn(e[o]);
        var i = n.toString();
        if ("1" !== i.charAt(0)) throw new $12c6b0ab9da17bee$var$R;
        return i.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'", t.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", t.EXP900 = $12c6b0ab9da17bee$var$Xn() ? function() {
        var t = [];
        t[0] = $12c6b0ab9da17bee$var$Wn(1);
        var e = $12c6b0ab9da17bee$var$Wn(900);
        t[1] = e;
        for(var r = 2; r < 16; r++)t[r] = t[r - 1] * e;
        return t;
    }() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
}(), $12c6b0ab9da17bee$var$zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Yn = function() {
    function t() {}
    return t.decode = function(e, r, n, o, i, a, u) {
        for(var s, c = new $12c6b0ab9da17bee$var$vn(e, r, n, o, i), f = null, h = null, l = !0;; l = !1){
            if (null != r && (f = t.getRowIndicatorColumn(e, c, r, !0, a, u)), null != o && (h = t.getRowIndicatorColumn(e, c, o, !1, a, u)), null == (s = t.merge(f, h))) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            var d = s.getBoundingBox();
            if (!l || null == d || !(d.getMinY() < c.getMinY() || d.getMaxY() > c.getMaxY())) break;
            c = d;
        }
        s.setBoundingBox(c);
        var p = s.getBarcodeColumnCount() + 1;
        s.setDetectionResultColumn(0, f), s.setDetectionResultColumn(p, h);
        for(var g = null != f, y = 1; y <= p; y++){
            var w = g ? y : p - y;
            if (void 0 === s.getDetectionResultColumn(w)) {
                var _ = void 0;
                _ = 0 === w || w === p ? new $12c6b0ab9da17bee$var$Rn(c, 0 === w) : new $12c6b0ab9da17bee$var$Cn(c), s.setDetectionResultColumn(w, _);
                for(var v = -1, m = v, A = c.getMinY(); A <= c.getMaxY(); A++){
                    if ((v = t.getStartColumn(s, w, A, g)) < 0 || v > c.getMaxX()) {
                        if (-1 === m) continue;
                        v = m;
                    }
                    var E = t.detectCodeword(e, c.getMinX(), c.getMaxX(), g, v, A, a, u);
                    null != E && (_.setCodeword(A, E), m = v, a = Math.min(a, E.getWidth()), u = Math.max(u, E.getWidth()));
                }
            }
        }
        return t.createDecoderResult(s);
    }, t.merge = function(e, r) {
        if (null == e && null == r) return null;
        var n = t.getBarcodeMetadata(e, r);
        if (null == n) return null;
        var o = $12c6b0ab9da17bee$var$vn.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(r));
        return new $12c6b0ab9da17bee$var$Dn(n, o);
    }, t.adjustBoundingBox = function(e) {
        var r, n;
        if (null == e) return null;
        var o = e.getRowHeights();
        if (null == o) return null;
        var i = t.getMax(o), a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$zn(o), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (a += i - c, c > 0) break;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
        for(var f = e.getCodewords(), h = 0; a > 0 && null == f[h]; h++)a--;
        var l = 0;
        for(h = o.length - 1; h >= 0 && (l += i - o[h], !(o[h] > 0)); h--);
        for(h = f.length - 1; l > 0 && null == f[h]; h--)l--;
        return e.getBoundingBox().addMissingRows(a, l, e.isLeft());
    }, t.getMax = function(t) {
        var e, r, n = -1;
        try {
            for(var o = $12c6b0ab9da17bee$var$zn(t), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                n = Math.max(n, a);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.getBarcodeMetadata = function(t, e) {
        var r, n;
        return null == t || null == (r = t.getBarcodeMetadata()) ? null == e ? null : e.getBarcodeMetadata() : null == e || null == (n = e.getBarcodeMetadata()) ? r : r.getColumnCount() !== n.getColumnCount() && r.getErrorCorrectionLevel() !== n.getErrorCorrectionLevel() && r.getRowCount() !== n.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, r, n, o, i, a) {
        for(var u = new $12c6b0ab9da17bee$var$Rn(r, o), s = 0; s < 2; s++)for(var c = 0 === s ? 1 : -1, f = Math.trunc(Math.trunc(n.getX())), h = Math.trunc(Math.trunc(n.getY())); h <= r.getMaxY() && h >= r.getMinY(); h += c){
            var l = t.detectCodeword(e, 0, e.getWidth(), o, f, h, i, a);
            null != l && (u.setCodeword(h, l), f = o ? l.getStartX() : l.getEndX());
        }
        return u;
    }, t.adjustCodewordCount = function(e, r) {
        var n = r[0][1], o = n.getValue(), i = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
        if (0 === o.length) {
            if (i < 1 || i > $12c6b0ab9da17bee$var$sn.MAX_CODEWORDS_IN_BARCODE) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            n.setValue(i);
        } else o[0] !== i && n.setValue(i);
    }, t.createDecoderResult = function(e) {
        var r = t.createBarcodeMatrix(e);
        t.adjustCodewordCount(e, r);
        for(var n = new Array, o = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), i = [], a = new Array, u = 0; u < e.getBarcodeRowCount(); u++)for(var s = 0; s < e.getBarcodeColumnCount(); s++){
            var c = r[u][s + 1].getValue(), f = u * e.getBarcodeColumnCount() + s;
            0 === c.length ? n.push(f) : 1 === c.length ? o[f] = c[0] : (a.push(f), i.push(c));
        }
        for(var h = new Array(i.length), l = 0; l < h.length; l++)h[l] = i[l];
        return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), o, $12c6b0ab9da17bee$var$sn.toIntArray(n), $12c6b0ab9da17bee$var$sn.toIntArray(a), h);
    }, t.createDecoderResultFromAmbiguousValues = function(e, r, n, o, i) {
        for(var a = new Int32Array(o.length), u = 100; u-- > 0;){
            for(var s = 0; s < a.length; s++)r[o[s]] = i[s][a[s]];
            try {
                return t.decodeCodewords(r, e, n);
            } catch (t) {
                if (!(t instanceof $12c6b0ab9da17bee$var$g)) throw t;
            }
            if (0 === a.length) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            for(s = 0; s < a.length; s++){
                if (a[s] < i[s].length - 1) {
                    a[s]++;
                    break;
                }
                if (a[s] = 0, s === a.length - 1) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            }
        }
        throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
    }, t.createBarcodeMatrix = function(t) {
        for(var e, r, n, o, i = Array.from({
            length: t.getBarcodeRowCount()
        }, function() {
            return new Array(t.getBarcodeColumnCount() + 2);
        }), a = 0; a < i.length; a++)for(var u = 0; u < i[a].length; u++)i[a][u] = new $12c6b0ab9da17bee$var$On;
        var s = 0;
        try {
            for(var c = $12c6b0ab9da17bee$var$zn(t.getDetectionResultColumns()), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                if (null != h) try {
                    for(var l = (n = void 0, $12c6b0ab9da17bee$var$zn(h.getCodewords())), d = l.next(); !d.done; d = l.next()){
                        var p = d.value;
                        if (null != p) {
                            var g = p.getRowNumber();
                            if (g >= 0) {
                                if (g >= i.length) continue;
                                i[g][s].setValue(p.getValue());
                            }
                        }
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (o = l.return) && o.call(l);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                s++;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (r = c.return) && r.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.isValidBarcodeColumn = function(t, e) {
        return e >= 0 && e <= t.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, r, n, o) {
        var i, a, u = o ? 1 : -1, s = null;
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodeword(n)), null != s) return o ? s.getEndX() : s.getStartX();
        if (null != (s = e.getDetectionResultColumn(r).getCodewordNearby(n))) return o ? s.getStartX() : s.getEndX();
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodewordNearby(n)), null != s) return o ? s.getEndX() : s.getStartX();
        for(var c = 0; t.isValidBarcodeColumn(e, r - u);){
            r -= u;
            try {
                for(var f = (i = void 0, $12c6b0ab9da17bee$var$zn(e.getDetectionResultColumn(r).getCodewords())), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (null != l) return (o ? l.getEndX() : l.getStartX()) + u * c * (l.getEndX() - l.getStartX());
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (a = f.return) && a.call(f);
                } finally{
                    if (i) throw i.error;
                }
            }
            c++;
        }
        return o ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, r, n, o, i, a, u, s) {
        i = t.adjustCodewordStartColumn(e, r, n, o, i, a);
        var c, f = t.getModuleBitCount(e, r, n, o, i, a);
        if (null == f) return null;
        var h = $12c6b0ab9da17bee$var$vt.sum(f);
        if (o) c = i + h;
        else {
            for(var l = 0; l < f.length / 2; l++){
                var d = f[l];
                f[l] = f[f.length - 1 - l], f[f.length - 1 - l] = d;
            }
            i = (c = i) - h;
        }
        if (!t.checkCodewordSkew(h, u, s)) return null;
        var p = $12c6b0ab9da17bee$var$Mn.getDecodedValue(f), g = $12c6b0ab9da17bee$var$sn.getCodeword(p);
        return -1 === g ? null : new $12c6b0ab9da17bee$var$Pn(i, c, t.getCodewordBucketNumber(p), g);
    }, t.getModuleBitCount = function(t, e, r, n, o, i) {
        for(var a = o, u = new Int32Array(8), s = 0, c = n ? 1 : -1, f = n; (n ? a < r : a >= e) && s < u.length;)t.get(a, i) === f ? (u[s]++, a += c) : (s++, f = !f);
        return s === u.length || a === (n ? r : e) && s === u.length - 1 ? u : null;
    }, t.getNumberOfECCodeWords = function(t) {
        return 2 << t;
    }, t.adjustCodewordStartColumn = function(e, r, n, o, i, a) {
        for(var u = i, s = o ? -1 : 1, c = 0; c < 2; c++){
            for(; (o ? u >= r : u < n) && o === e.get(u, a);){
                if (Math.abs(i - u) > t.CODEWORD_SKEW_SIZE) return i;
                u += s;
            }
            s = -s, o = !o;
        }
        return u;
    }, t.checkCodewordSkew = function(e, r, n) {
        return r - t.CODEWORD_SKEW_SIZE <= e && e <= n + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, r, n) {
        if (0 === e.length) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var o = 1 << r + 1, i = t.correctErrors(e, n, o);
        t.verifyCodewordCount(e, o);
        var a = $12c6b0ab9da17bee$var$jn.decode(e, "" + r);
        return a.setErrorsCorrected(i), a.setErasures(n.length), a;
    }, t.correctErrors = function(e, r, n) {
        if (null != r && r.length > n / 2 + t.MAX_ERRORS || n < 0 || n > t.MAX_EC_CODEWORDS) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        return t.errorCorrection.decode(e, n, r);
    }, t.verifyCodewordCount = function(t, e) {
        if (t.length < 4) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var r = t[0];
        if (r > t.length) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        if (0 === r) {
            if (!(e < t.length)) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
            t[0] = t.length - e;
        }
    }, t.getBitCountForCodeword = function(t) {
        for(var e = new Int32Array(8), r = 0, n = e.length - 1; !((1 & t) !== r && (r = 1 & t, --n < 0));)e[n]++, t >>= 1;
        return e;
    }, t.getCodewordBucketNumber = function(t) {
        return t instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(t) : this.getCodewordBucketNumber_number(t);
    }, t.getCodewordBucketNumber_number = function(e) {
        return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(t) {
        return (t[0] - t[2] + t[4] - t[6] + 9) % 9;
    }, t.toString = function(t) {
        for(var e = new $12c6b0ab9da17bee$var$An, r = 0; r < t.length; r++){
            e.format("Row %2d: ", r);
            for(var n = 0; n < t[r].length; n++){
                var o = t[r][n];
                0 === o.getValue().length ? e.format("        ", null) : e.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
            }
            e.format("%n");
        }
        return e.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new $12c6b0ab9da17bee$var$_n, t;
}(), $12c6b0ab9da17bee$var$Zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Kn = function() {
    function t() {}
    return t.prototype.decode = function(e, r) {
        void 0 === r && (r = null);
        var n = t.decode(e, r, !1);
        if (null == n || 0 === n.length || null == n[0]) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
        return n[0];
    }, t.prototype.decodeMultiple = function(e, r) {
        void 0 === r && (r = null);
        try {
            return t.decode(e, r, !0);
        } catch (t) {
            if (t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$g) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            throw t;
        }
    }, t.decode = function(e, r, n) {
        var o, i, a = new Array, u = $12c6b0ab9da17bee$var$hn.detectMultiple(e, r, n);
        try {
            for(var s = $12c6b0ab9da17bee$var$Zn(u.getPoints()), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = $12c6b0ab9da17bee$var$Yn.decode(u.getBits(), f[4], f[5], f[6], f[7], t.getMinCodewordWidth(f), t.getMaxCodewordWidth(f)), l = new $12c6b0ab9da17bee$var$et(h.getText(), h.getRawBytes(), void 0, f, $12c6b0ab9da17bee$var$nt.PDF_417);
                l.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, h.getECLevel());
                var d = h.getOther();
                null != d && l.putMetadata($12c6b0ab9da17bee$var$it.PDF417_EXTRA_METADATA, d), a.push(l);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (i = s.return) && i.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        return a.map(function(t) {
            return t;
        });
    }, t.getMaxWidth = function(t, e) {
        return null == t || null == e ? 0 : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMinWidth = function(t, e) {
        return null == t || null == e ? $12c6b0ab9da17bee$var$I.MAX_VALUE : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMaxCodewordWidth = function(e) {
        return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
        return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {}, t;
}(), $12c6b0ab9da17bee$var$qn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Qn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$qn(e, t), e.kind = "ReaderException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$Jn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$$n = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        return this.setHints(e), this.decodeInternal(t);
    }, t.prototype.decodeWithState = function(t) {
        return null !== this.readers && void 0 !== this.readers || this.setHints(null), this.decodeInternal(t);
    }, t.prototype.setHints = function(t) {
        this.hints = t;
        var e = null != t && void 0 !== t.get($12c6b0ab9da17bee$var$T.TRY_HARDER), r = null == t ? null : t.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), n = new Array;
        if (null != r) {
            var o = r.some(function(t) {
                return t === $12c6b0ab9da17bee$var$nt.UPC_A || t === $12c6b0ab9da17bee$var$nt.UPC_E || t === $12c6b0ab9da17bee$var$nt.EAN_13 || t === $12c6b0ab9da17bee$var$nt.EAN_8 || t === $12c6b0ab9da17bee$var$nt.CODABAR || t === $12c6b0ab9da17bee$var$nt.CODE_39 || t === $12c6b0ab9da17bee$var$nt.CODE_93 || t === $12c6b0ab9da17bee$var$nt.CODE_128 || t === $12c6b0ab9da17bee$var$nt.ITF || t === $12c6b0ab9da17bee$var$nt.RSS_14 || t === $12c6b0ab9da17bee$var$nt.RSS_EXPANDED;
            });
            o && !e && n.push(new $12c6b0ab9da17bee$var$fr(t)), r.includes($12c6b0ab9da17bee$var$nt.QR_CODE) && n.push(new $12c6b0ab9da17bee$var$an), r.includes($12c6b0ab9da17bee$var$nt.DATA_MATRIX) && n.push(new $12c6b0ab9da17bee$var$Or), r.includes($12c6b0ab9da17bee$var$nt.AZTEC) && n.push(new $12c6b0ab9da17bee$var$Mt), r.includes($12c6b0ab9da17bee$var$nt.PDF_417) && n.push(new $12c6b0ab9da17bee$var$Kn), o && e && n.push(new $12c6b0ab9da17bee$var$fr(t));
        }
        0 === n.length && (e || n.push(new $12c6b0ab9da17bee$var$fr(t)), n.push(new $12c6b0ab9da17bee$var$an), n.push(new $12c6b0ab9da17bee$var$Or), n.push(new $12c6b0ab9da17bee$var$Mt), n.push(new $12c6b0ab9da17bee$var$Kn), e && n.push(new $12c6b0ab9da17bee$var$fr(t))), this.readers = n;
    }, t.prototype.reset = function() {
        var t, e;
        if (null !== this.readers) try {
            for(var r = $12c6b0ab9da17bee$var$Jn(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype.decodeInternal = function(t) {
        var e, r;
        if (null === this.readers) throw new $12c6b0ab9da17bee$var$Qn("No readers where selected, nothing can be read.");
        try {
            for(var n = $12c6b0ab9da17bee$var$Jn(this.readers), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                try {
                    return i.decode(t, this.hints);
                } catch (t) {
                    if (t instanceof $12c6b0ab9da17bee$var$Qn) continue;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U("No MultiFormat Readers were able to detect the code.");
    }, t;
}(), $12c6b0ab9da17bee$var$to = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        void 0 === e && (e = null), void 0 === r && (r = 500);
        var n = new $12c6b0ab9da17bee$var$$n;
        return n.setHints(e), t.call(this, n, r) || this;
    }
    $12c6b0ab9da17bee$var$to(e, t), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    };
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Kn, e) || this;
    }
    $12c6b0ab9da17bee$var$eo(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$ro, $12c6b0ab9da17bee$var$no = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$an, e) || this;
    }
    $12c6b0ab9da17bee$var$no(e, t);
}($12c6b0ab9da17bee$var$tt), function(t) {
    t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.MIN_SIZE = 3] = "MIN_SIZE", t[t.MAX_SIZE = 4] = "MAX_SIZE", t[t.MARGIN = 5] = "MARGIN", t[t.PDF417_COMPACT = 6] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 7] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 8] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 9] = "AZTEC_LAYERS", t[t.QR_VERSION = 10] = "QR_VERSION";
}($12c6b0ab9da17bee$var$ro || ($12c6b0ab9da17bee$var$ro = {}));
var $12c6b0ab9da17bee$var$oo = $12c6b0ab9da17bee$var$ro, $12c6b0ab9da17bee$var$io = function() {
    function t(t) {
        this.field = t, this.cachedGenerators = [], this.cachedGenerators.push(new $12c6b0ab9da17bee$var$st(t, Int32Array.from([
            1
        ])));
    }
    return t.prototype.buildGenerator = function(t) {
        var e = this.cachedGenerators;
        if (t >= e.length) for(var r = e[e.length - 1], n = this.field, o = e.length; o <= t; o++){
            var i = r.multiply(new $12c6b0ab9da17bee$var$st(n, Int32Array.from([
                1,
                n.exp(o - 1 + n.getGeneratorBase())
            ])));
            e.push(i), r = i;
        }
        return e[t];
    }, t.prototype.encode = function(t, e) {
        if (0 === e) throw new $12c6b0ab9da17bee$var$l("No error correction bytes");
        var r = t.length - e;
        if (r <= 0) throw new $12c6b0ab9da17bee$var$l("No data bytes provided");
        var n = this.buildGenerator(e), o = new Int32Array(r);
        $12c6b0ab9da17bee$var$w.arraycopy(t, 0, o, 0, r);
        for(var i = new $12c6b0ab9da17bee$var$st(this.field, o), a = (i = i.multiplyByMonomial(e, 1)).divide(n)[1].getCoefficients(), u = e - a.length, s = 0; s < u; s++)t[r + s] = 0;
        $12c6b0ab9da17bee$var$w.arraycopy(a, 0, t, r + u, a.length);
    }, t;
}(), $12c6b0ab9da17bee$var$ao = function() {
    function t() {}
    return t.applyMaskPenaltyRule1 = function(e) {
        return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i - 1; a++)for(var u = n[a], s = 0; s < o - 1; s++){
            var c = u[s];
            c === u[s + 1] && c === n[a + 1][s] && c === n[a + 1][s + 1] && r++;
        }
        return t.N2 * r;
    }, t.applyMaskPenaltyRule3 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = 0; u < o; u++){
            var s = n[a];
            u + 6 < o && 1 === s[u] && 0 === s[u + 1] && 1 === s[u + 2] && 1 === s[u + 3] && 1 === s[u + 4] && 0 === s[u + 5] && 1 === s[u + 6] && (t.isWhiteHorizontal(s, u - 4, u) || t.isWhiteHorizontal(s, u + 7, u + 11)) && r++, a + 6 < i && 1 === n[a][u] && 0 === n[a + 1][u] && 1 === n[a + 2][u] && 1 === n[a + 3][u] && 1 === n[a + 4][u] && 0 === n[a + 5][u] && 1 === n[a + 6][u] && (t.isWhiteVertical(n, u, a - 4, a) || t.isWhiteVertical(n, u, a + 7, a + 11)) && r++;
        }
        return r * t.N3;
    }, t.isWhiteHorizontal = function(t, e, r) {
        e = Math.max(e, 0), r = Math.min(r, t.length);
        for(var n = e; n < r; n++)if (1 === t[n]) return !1;
        return !0;
    }, t.isWhiteVertical = function(t, e, r, n) {
        r = Math.max(r, 0), n = Math.min(n, t.length);
        for(var o = r; o < n; o++)if (1 === t[o][e]) return !1;
        return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = n[a], s = 0; s < o; s++)1 === u[s] && r++;
        var c = e.getHeight() * e.getWidth();
        return Math.floor(10 * Math.abs(2 * r - c) / c) * t.N4;
    }, t.getDataMaskBit = function(t, e, r) {
        var n, o;
        switch(t){
            case 0:
                n = r + e & 1;
                break;
            case 1:
                n = 1 & r;
                break;
            case 2:
                n = e % 3;
                break;
            case 3:
                n = (r + e) % 3;
                break;
            case 4:
                n = Math.floor(r / 2) + Math.floor(e / 3) & 1;
                break;
            case 5:
                n = (1 & (o = r * e)) + o % 3;
                break;
            case 6:
                n = (1 & (o = r * e)) + o % 3 & 1;
                break;
            case 7:
                n = (o = r * e) % 3 + (r + e & 1) & 1;
                break;
            default:
                throw new $12c6b0ab9da17bee$var$l("Invalid mask pattern: " + t);
        }
        return 0 === n;
    }, t.applyMaskPenaltyRule1Internal = function(e, r) {
        for(var n = 0, o = r ? e.getHeight() : e.getWidth(), i = r ? e.getWidth() : e.getHeight(), a = e.getArray(), u = 0; u < o; u++){
            for(var s = 0, c = -1, f = 0; f < i; f++){
                var h = r ? a[u][f] : a[f][u];
                h === c ? s++ : (s >= 5 && (n += t.N1 + (s - 5)), s = 1, c = h);
            }
            s >= 5 && (n += t.N1 + (s - 5));
        }
        return n;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
}(), $12c6b0ab9da17bee$var$uo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$so = function() {
    function t(t, e) {
        this.width = t, this.height = e;
        for(var r = new Array(e), n = 0; n !== e; n++)r[n] = new Uint8Array(t);
        this.bytes = r;
    }
    return t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.get = function(t, e) {
        return this.bytes[e][t];
    }, t.prototype.getArray = function() {
        return this.bytes;
    }, t.prototype.setNumber = function(t, e, r) {
        this.bytes[e][t] = r;
    }, t.prototype.setBoolean = function(t, e, r) {
        this.bytes[e][t] = r ? 1 : 0;
    }, t.prototype.clear = function(t) {
        var e, r;
        try {
            for(var n = $12c6b0ab9da17bee$var$uo(this.bytes), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                $12c6b0ab9da17bee$var$C.fill(i, t);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        if (this.width !== r.width) return !1;
        if (this.height !== r.height) return !1;
        for(var n = 0, o = this.height; n < o; ++n)for(var i = this.bytes[n], a = r.bytes[n], u = 0, s = this.width; u < s; ++u)if (i[u] !== a[u]) return !1;
        return !0;
    }, t.prototype.toString = function() {
        for(var t = new $12c6b0ab9da17bee$var$k, e = 0, r = this.height; e < r; ++e){
            for(var n = this.bytes[e], o = 0, i = this.width; o < i; ++o)switch(n[o]){
                case 0:
                    t.append(" 0");
                    break;
                case 1:
                    t.append(" 1");
                    break;
                default:
                    t.append("  ");
            }
            t.append("\n");
        }
        return t.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$co = function() {
    function t() {
        this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getVersion = function() {
        return this.version;
    }, t.prototype.getMaskPattern = function() {
        return this.maskPattern;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.toString = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        return t.append("<<\n"), t.append(" mode: "), t.append(this.mode ? this.mode.toString() : "null"), t.append("\n ecLevel: "), t.append(this.ecLevel ? this.ecLevel.toString() : "null"), t.append("\n version: "), t.append(this.version ? this.version.toString() : "null"), t.append("\n maskPattern: "), t.append(this.maskPattern.toString()), this.matrix ? (t.append("\n matrix:\n"), t.append(this.matrix.toString())) : t.append("\n matrix: null\n"), t.append(">>\n"), t.toString();
    }, t.prototype.setMode = function(t) {
        this.mode = t;
    }, t.prototype.setECLevel = function(t) {
        this.ecLevel = t;
    }, t.prototype.setVersion = function(t) {
        this.version = t;
    }, t.prototype.setMaskPattern = function(t) {
        this.maskPattern = t;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t.isValidMaskPattern = function(e) {
        return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
}(), $12c6b0ab9da17bee$var$fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ho = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$fo(e, t), e.kind = "WriterException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$lo = function() {
    function t() {}
    return t.clearMatrix = function(t) {
        t.clear(255);
    }, t.buildMatrix = function(e, r, n, o, i) {
        t.clearMatrix(i), t.embedBasicPatterns(n, i), t.embedTypeInfo(r, o, i), t.maybeEmbedVersionInfo(n, i), t.embedDataBits(e, o, i);
    }, t.embedBasicPatterns = function(e, r) {
        t.embedPositionDetectionPatternsAndSeparators(r), t.embedDarkDotAtLeftBottomCorner(r), t.maybeEmbedPositionAdjustmentPatterns(e, r), t.embedTimingPatterns(r);
    }, t.embedTypeInfo = function(e, r, n) {
        var o = new $12c6b0ab9da17bee$var$S;
        t.makeTypeInfoBits(e, r, o);
        for(var i = 0, a = o.getSize(); i < a; ++i){
            var u = o.get(o.getSize() - 1 - i), s = t.TYPE_INFO_COORDINATES[i], c = s[0], f = s[1];
            if (n.setBoolean(c, f, u), i < 8) {
                var h = n.getWidth() - i - 1, l = 8;
                n.setBoolean(h, l, u);
            } else {
                h = 8, l = n.getHeight() - 7 + (i - 8);
                n.setBoolean(h, l, u);
            }
        }
    }, t.maybeEmbedVersionInfo = function(e, r) {
        if (!(e.getVersionNumber() < 7)) {
            var n = new $12c6b0ab9da17bee$var$S;
            t.makeVersionInfoBits(e, n);
            for(var o = 17, i = 0; i < 6; ++i)for(var a = 0; a < 3; ++a){
                var u = n.get(o);
                o--, r.setBoolean(i, r.getHeight() - 11 + a, u), r.setBoolean(r.getHeight() - 11 + a, i, u);
            }
        }
    }, t.embedDataBits = function(e, r, n) {
        for(var o = 0, i = -1, a = n.getWidth() - 1, u = n.getHeight() - 1; a > 0;){
            for(6 === a && (a -= 1); u >= 0 && u < n.getHeight();){
                for(var s = 0; s < 2; ++s){
                    var c = a - s;
                    if (t.isEmpty(n.get(c, u))) {
                        var f = void 0;
                        o < e.getSize() ? (f = e.get(o), ++o) : f = !1, 255 !== r && $12c6b0ab9da17bee$var$ao.getDataMaskBit(r, c, u) && (f = !f), n.setBoolean(c, u, f);
                    }
                }
                u += i;
            }
            u += i = -i, a -= 2;
        }
        if (o !== e.getSize()) throw new $12c6b0ab9da17bee$var$ho("Not all bits consumed: " + o + "/" + e.getSize());
    }, t.findMSBSet = function(t) {
        return 32 - $12c6b0ab9da17bee$var$I.numberOfLeadingZeros(t);
    }, t.calculateBCHCode = function(e, r) {
        if (0 === r) throw new $12c6b0ab9da17bee$var$l("0 polynomial");
        var n = t.findMSBSet(r);
        for(e <<= n - 1; t.findMSBSet(e) >= n;)e ^= r << t.findMSBSet(e) - n;
        return e;
    }, t.makeTypeInfoBits = function(e, r, n) {
        if (!$12c6b0ab9da17bee$var$co.isValidMaskPattern(r)) throw new $12c6b0ab9da17bee$var$ho("Invalid mask pattern");
        var o = e.getBits() << 3 | r;
        n.appendBits(o, 5);
        var i = t.calculateBCHCode(o, t.TYPE_INFO_POLY);
        n.appendBits(i, 10);
        var a = new $12c6b0ab9da17bee$var$S;
        if (a.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), 15 !== n.getSize()) throw new $12c6b0ab9da17bee$var$ho("should not happen but we got: " + n.getSize());
    }, t.makeVersionInfoBits = function(e, r) {
        r.appendBits(e.getVersionNumber(), 6);
        var n = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
        if (r.appendBits(n, 12), 18 !== r.getSize()) throw new $12c6b0ab9da17bee$var$ho("should not happen but we got: " + r.getSize());
    }, t.isEmpty = function(t) {
        return 255 === t;
    }, t.embedTimingPatterns = function(e) {
        for(var r = 8; r < e.getWidth() - 8; ++r){
            var n = (r + 1) % 2;
            t.isEmpty(e.get(r, 6)) && e.setNumber(r, 6, n), t.isEmpty(e.get(6, r)) && e.setNumber(6, r, n);
        }
    }, t.embedDarkDotAtLeftBottomCorner = function(t) {
        if (0 === t.get(8, t.getHeight() - 8)) throw new $12c6b0ab9da17bee$var$ho;
        t.setNumber(8, t.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 8; ++o){
            if (!t.isEmpty(n.get(e + o, r))) throw new $12c6b0ab9da17bee$var$ho;
            n.setNumber(e + o, r, 0);
        }
    }, t.embedVerticalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o){
            if (!t.isEmpty(n.get(e, r + o))) throw new $12c6b0ab9da17bee$var$ho;
            n.setNumber(e, r + o, 0);
        }
    }, t.embedPositionAdjustmentPattern = function(e, r, n) {
        for(var o = 0; o < 5; ++o)for(var i = t.POSITION_ADJUSTMENT_PATTERN[o], a = 0; a < 5; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o)for(var i = t.POSITION_DETECTION_PATTERN[o], a = 0; a < 7; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
        var r = t.POSITION_DETECTION_PATTERN[0].length;
        t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - r, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - r, e);
        t.embedHorizontalSeparationPattern(0, 7, e), t.embedHorizontalSeparationPattern(e.getWidth() - 8, 7, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - 8, e);
        t.embedVerticalSeparationPattern(7, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - 7 - 1, 0, e), t.embedVerticalSeparationPattern(7, e.getHeight() - 7, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, r) {
        if (!(e.getVersionNumber() < 2)) for(var n = e.getVersionNumber() - 1, o = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], i = 0, a = o.length; i !== a; i++){
            var u = o[i];
            if (u >= 0) for(var s = 0; s !== a; s++){
                var c = o[s];
                c >= 0 && t.isEmpty(r.get(c, u)) && t.embedPositionAdjustmentPattern(c - 2, u - 2, r);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
}(), $12c6b0ab9da17bee$var$po = function() {
    function t(t, e) {
        this.dataBytes = t, this.errorCorrectionBytes = e;
    }
    return t.prototype.getDataBytes = function() {
        return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    }, t;
}(), $12c6b0ab9da17bee$var$go = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.calculateMaskPenalty = function(t) {
        return $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule1(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule2(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule3(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule4(t);
    }, t.encode = function(e, r, n) {
        void 0 === n && (n = null);
        var o = t.DEFAULT_BYTE_MODE_ENCODING, i = null !== n && void 0 !== n.get($12c6b0ab9da17bee$var$oo.CHARACTER_SET);
        i && (o = n.get($12c6b0ab9da17bee$var$oo.CHARACTER_SET).toString());
        var a = this.chooseMode(e, o), u = new $12c6b0ab9da17bee$var$S;
        if (a === $12c6b0ab9da17bee$var$Wr.BYTE && (i || t.DEFAULT_BYTE_MODE_ENCODING !== o)) {
            var s = $12c6b0ab9da17bee$var$P.getCharacterSetECIByName(o);
            void 0 !== s && this.appendECI(s, u);
        }
        this.appendModeInfo(a, u);
        var c, f = new $12c6b0ab9da17bee$var$S;
        if (this.appendBytes(e, a, f, o), null !== n && void 0 !== n.get($12c6b0ab9da17bee$var$oo.QR_VERSION)) {
            var h = Number.parseInt(n.get($12c6b0ab9da17bee$var$oo.QR_VERSION).toString(), 10);
            c = $12c6b0ab9da17bee$var$Fr.getVersionForNumber(h);
            var l = this.calculateBitsNeeded(a, u, f, c);
            if (!this.willFit(l, c, r)) throw new $12c6b0ab9da17bee$var$ho("Data too big for requested version");
        } else c = this.recommendVersion(r, a, u, f);
        var d = new $12c6b0ab9da17bee$var$S;
        d.appendBitArray(u);
        var p = a === $12c6b0ab9da17bee$var$Wr.BYTE ? f.getSizeInBytes() : e.length;
        this.appendLengthInfo(p, c, a, d), d.appendBitArray(f);
        var g = c.getECBlocksForLevel(r), y = c.getTotalCodewords() - g.getTotalECCodewords();
        this.terminateBits(y, d);
        var w = this.interleaveWithECBytes(d, c.getTotalCodewords(), y, g.getNumBlocks()), _ = new $12c6b0ab9da17bee$var$co;
        _.setECLevel(r), _.setMode(a), _.setVersion(c);
        var v = c.getDimensionForVersion(), m = new $12c6b0ab9da17bee$var$so(v, v), A = this.chooseMaskPattern(w, r, c, m);
        return _.setMaskPattern(A), $12c6b0ab9da17bee$var$lo.buildMatrix(w, r, c, A, m), _.setMatrix(m), _;
    }, t.recommendVersion = function(t, e, r, n) {
        var o = this.calculateBitsNeeded(e, r, n, $12c6b0ab9da17bee$var$Fr.getVersionForNumber(1)), i = this.chooseVersion(o, t), a = this.calculateBitsNeeded(e, r, n, i);
        return this.chooseVersion(a, t);
    }, t.calculateBitsNeeded = function(t, e, r, n) {
        return e.getSize() + t.getCharacterCountBits(n) + r.getSize();
    }, t.getAlphanumericCode = function(e) {
        return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
    }, t.chooseMode = function(e, r) {
        if (void 0 === r && (r = null), $12c6b0ab9da17bee$var$P.SJIS.getName() === r && this.isOnlyDoubleByteKanji(e)) return $12c6b0ab9da17bee$var$Wr.KANJI;
        for(var n = !1, o = !1, i = 0, a = e.length; i < a; ++i){
            var u = e.charAt(i);
            if (t.isDigit(u)) n = !0;
            else {
                if (-1 === this.getAlphanumericCode(u.charCodeAt(0))) return $12c6b0ab9da17bee$var$Wr.BYTE;
                o = !0;
            }
        }
        return o ? $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC : n ? $12c6b0ab9da17bee$var$Wr.NUMERIC : $12c6b0ab9da17bee$var$Wr.BYTE;
    }, t.isOnlyDoubleByteKanji = function(t) {
        var e;
        try {
            e = $12c6b0ab9da17bee$var$L.encode(t, $12c6b0ab9da17bee$var$P.SJIS);
        } catch (t) {
            return !1;
        }
        var r = e.length;
        if (r % 2 != 0) return !1;
        for(var n = 0; n < r; n += 2){
            var o = 255 & e[n];
            if ((o < 129 || o > 159) && (o < 224 || o > 235)) return !1;
        }
        return !0;
    }, t.chooseMaskPattern = function(t, e, r, n) {
        for(var o = Number.MAX_SAFE_INTEGER, i = -1, a = 0; a < $12c6b0ab9da17bee$var$co.NUM_MASK_PATTERNS; a++){
            $12c6b0ab9da17bee$var$lo.buildMatrix(t, e, r, a, n);
            var u = this.calculateMaskPenalty(n);
            u < o && (o = u, i = a);
        }
        return i;
    }, t.chooseVersion = function(e, r) {
        for(var n = 1; n <= 40; n++){
            var o = $12c6b0ab9da17bee$var$Fr.getVersionForNumber(n);
            if (t.willFit(e, o, r)) return o;
        }
        throw new $12c6b0ab9da17bee$var$ho("Data too big");
    }, t.willFit = function(t, e, r) {
        return e.getTotalCodewords() - e.getECBlocksForLevel(r).getTotalECCodewords() >= (t + 7) / 8;
    }, t.terminateBits = function(t, e) {
        var r = 8 * t;
        if (e.getSize() > r) throw new $12c6b0ab9da17bee$var$ho("data bits cannot fit in the QR Code" + e.getSize() + " > " + r);
        for(var n = 0; n < 4 && e.getSize() < r; ++n)e.appendBit(!1);
        var o = 7 & e.getSize();
        if (o > 0) for(n = o; n < 8; n++)e.appendBit(!1);
        var i = t - e.getSizeInBytes();
        for(n = 0; n < i; ++n)e.appendBits(0 == (1 & n) ? 236 : 17, 8);
        if (e.getSize() !== r) throw new $12c6b0ab9da17bee$var$ho("Bits size does not equal capacity");
    }, t.getNumDataBytesAndNumECBytesForBlockID = function(t, e, r, n, o, i) {
        if (n >= r) throw new $12c6b0ab9da17bee$var$ho("Block ID too large");
        var a = t % r, u = r - a, s = Math.floor(t / r), c = s + 1, f = Math.floor(e / r), h = f + 1, l = s - f, d = c - h;
        if (l !== d) throw new $12c6b0ab9da17bee$var$ho("EC bytes mismatch");
        if (r !== u + a) throw new $12c6b0ab9da17bee$var$ho("RS blocks mismatch");
        if (t !== (f + l) * u + (h + d) * a) throw new $12c6b0ab9da17bee$var$ho("Total bytes mismatch");
        n < u ? (o[0] = f, i[0] = l) : (o[0] = h, i[0] = d);
    }, t.interleaveWithECBytes = function(e, r, n, o) {
        var i, a, u, s;
        if (e.getSizeInBytes() !== n) throw new $12c6b0ab9da17bee$var$ho("Number of bits and data bytes does not match");
        for(var c = 0, f = 0, h = 0, l = new Array, d = 0; d < o; ++d){
            var p = new Int32Array(1), g = new Int32Array(1);
            t.getNumDataBytesAndNumECBytesForBlockID(r, n, o, d, p, g);
            var y = p[0], w = new Uint8Array(y);
            e.toBytes(8 * c, w, 0, y);
            var _ = t.generateECBytes(w, g[0]);
            l.push(new $12c6b0ab9da17bee$var$po(w, _)), f = Math.max(f, y), h = Math.max(h, _.length), c += p[0];
        }
        if (n !== c) throw new $12c6b0ab9da17bee$var$ho("Data bytes does not match offset");
        var v = new $12c6b0ab9da17bee$var$S;
        for(d = 0; d < f; ++d)try {
            for(var m = (i = void 0, $12c6b0ab9da17bee$var$go(l)), A = m.next(); !A.done; A = m.next())d < (w = A.value.getDataBytes()).length && v.appendBits(w[d], 8);
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (a = m.return) && a.call(m);
            } finally{
                if (i) throw i.error;
            }
        }
        for(d = 0; d < h; ++d)try {
            for(var E = (u = void 0, $12c6b0ab9da17bee$var$go(l)), C = E.next(); !C.done; C = E.next())d < (_ = C.value.getErrorCorrectionBytes()).length && v.appendBits(_[d], 8);
        } catch (t) {
            u = {
                error: t
            };
        } finally{
            try {
                C && !C.done && (s = E.return) && s.call(E);
            } finally{
                if (u) throw u.error;
            }
        }
        if (r !== v.getSizeInBytes()) throw new $12c6b0ab9da17bee$var$ho("Interleaving error: " + r + " and " + v.getSizeInBytes() + " differ.");
        return v;
    }, t.generateECBytes = function(t, e) {
        for(var r = t.length, n = new Int32Array(r + e), o = 0; o < r; o++)n[o] = 255 & t[o];
        new $12c6b0ab9da17bee$var$io($12c6b0ab9da17bee$var$lt.QR_CODE_FIELD_256).encode(n, e);
        var i = new Uint8Array(e);
        for(o = 0; o < e; o++)i[o] = n[r + o];
        return i;
    }, t.appendModeInfo = function(t, e) {
        e.appendBits(t.getBits(), 4);
    }, t.appendLengthInfo = function(t, e, r, n) {
        var o = r.getCharacterCountBits(e);
        if (t >= 1 << o) throw new $12c6b0ab9da17bee$var$ho(t + " is bigger than " + ((1 << o) - 1));
        n.appendBits(t, o);
    }, t.appendBytes = function(e, r, n, o) {
        switch(r){
            case $12c6b0ab9da17bee$var$Wr.NUMERIC:
                t.appendNumericBytes(e, n);
                break;
            case $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC:
                t.appendAlphanumericBytes(e, n);
                break;
            case $12c6b0ab9da17bee$var$Wr.BYTE:
                t.append8BitBytes(e, n, o);
                break;
            case $12c6b0ab9da17bee$var$Wr.KANJI:
                t.appendKanjiBytes(e, n);
                break;
            default:
                throw new $12c6b0ab9da17bee$var$ho("Invalid mode: " + r);
        }
    }, t.getDigit = function(t) {
        return t.charCodeAt(0) - 48;
    }, t.isDigit = function(e) {
        var r = t.getDigit(e);
        return r >= 0 && r <= 9;
    }, t.appendNumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getDigit(e.charAt(o));
            if (o + 2 < n) {
                var a = t.getDigit(e.charAt(o + 1)), u = t.getDigit(e.charAt(o + 2));
                r.appendBits(100 * i + 10 * a + u, 10), o += 3;
            } else if (o + 1 < n) {
                a = t.getDigit(e.charAt(o + 1));
                r.appendBits(10 * i + a, 7), o += 2;
            } else r.appendBits(i, 4), o++;
        }
    }, t.appendAlphanumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getAlphanumericCode(e.charCodeAt(o));
            if (-1 === i) throw new $12c6b0ab9da17bee$var$ho;
            if (o + 1 < n) {
                var a = t.getAlphanumericCode(e.charCodeAt(o + 1));
                if (-1 === a) throw new $12c6b0ab9da17bee$var$ho;
                r.appendBits(45 * i + a, 11), o += 2;
            } else r.appendBits(i, 6), o++;
        }
    }, t.append8BitBytes = function(t, e, r) {
        var n;
        try {
            n = $12c6b0ab9da17bee$var$L.encode(t, r);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$ho(t);
        }
        for(var o = 0, i = n.length; o !== i; o++){
            var a = n[o];
            e.appendBits(a, 8);
        }
    }, t.appendKanjiBytes = function(t, e) {
        var r;
        try {
            r = $12c6b0ab9da17bee$var$L.encode(t, $12c6b0ab9da17bee$var$P.SJIS);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$ho(t);
        }
        for(var n = r.length, o = 0; o < n; o += 2){
            var i = (255 & r[o]) << 8 & 4294967295 | 255 & r[o + 1], a = -1;
            if (i >= 33088 && i <= 40956 ? a = i - 33088 : i >= 57408 && i <= 60351 && (a = i - 49472), -1 === a) throw new $12c6b0ab9da17bee$var$ho("Invalid byte sequence");
            var u = 192 * (a >> 8) + (255 & a);
            e.appendBits(u, 13);
        }
    }, t.appendECI = function(t, e) {
        e.appendBits($12c6b0ab9da17bee$var$Wr.ECI.getBits(), 4), e.appendBits(t.getValue(), 8);
    }, t.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]), t.DEFAULT_BYTE_MODE_ENCODING = $12c6b0ab9da17bee$var$P.UTF8.getName();
}();
var $12c6b0ab9da17bee$var$yo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u, s) {
        var c = t.call(this, a, u) || this;
        if (c.yuvData = e, c.dataWidth = r, c.dataHeight = n, c.left = o, c.top = i, o + a > r || i + u > n) throw new $12c6b0ab9da17bee$var$l("Crop rectangle does not fit within image data.");
        return s && c.reverseHorizontal(a, u), c;
    }
    $12c6b0ab9da17bee$var$yo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.yuvData;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + r, n, o, !1);
    }, e.prototype.renderThumbnail = function() {
        for(var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, n = new Int32Array(t * r), o = this.yuvData, i = this.top * this.dataWidth + this.left, a = 0; a < r; a++){
            for(var u = a * t, s = 0; s < t; s++){
                var c = 255 & o[i + s * e.THUMBNAIL_SCALE_FACTOR];
                n[u + s] = 4278190080 | 65793 * c;
            }
            i += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
        }
        return n;
    }, e.prototype.getThumbnailWidth = function() {
        return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.getThumbnailHeight = function() {
        return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.reverseHorizontal = function(t, e) {
        for(var r = this.yuvData, n = 0, o = this.top * this.dataWidth + this.left; n < e; n++, o += this.dataWidth)for(var i = o + t / 2, a = o, u = o + t - 1; a < i; a++, u--){
            var s = r[a];
            r[a] = r[u], r[u] = s;
        }
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.THUMBNAIL_SCALE_FACTOR = 2;
}($12c6b0ab9da17bee$var$j);
var $12c6b0ab9da17bee$var$wo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u) {
        var s = t.call(this, r, n) || this;
        if (s.dataWidth = o, s.dataHeight = i, s.left = a, s.top = u, 4 === e.BYTES_PER_ELEMENT) {
            for(var c = r * n, f = new Uint8ClampedArray(c), h = 0; h < c; h++){
                var d = e[h], p = d >> 16 & 255, g = d >> 7 & 510, y = 255 & d;
                f[h] = (p + g + y) / 4 & 255;
            }
            s.luminances = f;
        } else s.luminances = e;
        if (void 0 === o && (s.dataWidth = r), void 0 === i && (s.dataHeight = n), void 0 === a && (s.left = 0), void 0 === u && (s.top = 0), s.left + r > s.dataWidth || s.top + n > s.dataHeight) throw new $12c6b0ab9da17bee$var$l("Crop rectangle does not fit within image data.");
        return s;
    }
    $12c6b0ab9da17bee$var$wo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.luminances;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.luminances, n, o, this.dataWidth, this.dataHeight, this.left + t, this.top + r);
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    };
}($12c6b0ab9da17bee$var$j);
var $12c6b0ab9da17bee$var$_o = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    $12c6b0ab9da17bee$var$_o(e, t), e.forName = function(t) {
        return this.getCharacterSetECIByName(t);
    };
}($12c6b0ab9da17bee$var$P);
var $12c6b0ab9da17bee$var$vo = function() {
    function t(t) {
        this.previous = t;
    }
    return t.prototype.getPrevious = function() {
        return this.previous;
    }, t;
}(), $12c6b0ab9da17bee$var$mo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ao = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.value = r, o.bitCount = n, o;
    }
    return $12c6b0ab9da17bee$var$mo(e, t), e.prototype.appendTo = function(t, e) {
        t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.addBinaryShift = function(t, r) {
        return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, r);
    }, e.prototype.toString = function() {
        var t = this.value & (1 << this.bitCount) - 1;
        return t |= 1 << this.bitCount, "<" + $12c6b0ab9da17bee$var$I.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
}($12c6b0ab9da17bee$var$vo), $12c6b0ab9da17bee$var$Eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, 0, 0) || this;
        return o.binaryShiftStart = r, o.binaryShiftByteCount = n, o;
    }
    $12c6b0ab9da17bee$var$Eo(e, t), e.prototype.appendTo = function(t, e) {
        for(var r = 0; r < this.binaryShiftByteCount; r++)(0 === r || 31 === r && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : 0 === r ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(e[this.binaryShiftStart + r], 8);
    }, e.prototype.addBinaryShift = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    };
}($12c6b0ab9da17bee$var$Ao);
new $12c6b0ab9da17bee$var$Ao(null, 0, 0);
var $12c6b0ab9da17bee$var$Co = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    var e, r;
    try {
        for(var n = $12c6b0ab9da17bee$var$Co(t), o = n.next(); !o.done; o = n.next()){
            var i = o.value;
            $12c6b0ab9da17bee$var$C.fill(i, -1);
        }
    } catch (t) {
        e = {
            error: t
        };
    } finally{
        try {
            o && !o.done && (r = n.return) && r.call(n);
        } finally{
            if (e) throw e.error;
        }
    }
    t[0][4] = 0, t[1][4] = 0, t[1][0] = 28, t[3][4] = 0, t[2][4] = 0, t[2][0] = 15;
}($12c6b0ab9da17bee$var$C.createInt32Array(6, 6)), function(t) {
    var e = $12c6b0ab9da17bee$var$F.getCharCode(" "), r = $12c6b0ab9da17bee$var$F.getCharCode("."), n = $12c6b0ab9da17bee$var$F.getCharCode(",");
    t[0][e] = 1;
    for(var o = $12c6b0ab9da17bee$var$F.getCharCode("Z"), i = $12c6b0ab9da17bee$var$F.getCharCode("A"), a = i; a <= o; a++)t[0][a] = a - i + 2;
    t[1][e] = 1;
    var u = $12c6b0ab9da17bee$var$F.getCharCode("z"), s = $12c6b0ab9da17bee$var$F.getCharCode("a");
    for(a = s; a <= u; a++)t[1][a] = a - s + 2;
    t[2][e] = 1;
    var c = $12c6b0ab9da17bee$var$F.getCharCode("9"), f = $12c6b0ab9da17bee$var$F.getCharCode("0");
    for(a = f; a <= c; a++)t[2][a] = a - f + 2;
    t[2][n] = 12, t[2][r] = 13;
    for(var h = [
        "\0",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ], l = 0; l < h.length; l++)t[3][$12c6b0ab9da17bee$var$F.getCharCode(h[l])] = l;
    var d = [
        "\0",
        "\r",
        "\0",
        "\0",
        "\0",
        "\0",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(l = 0; l < d.length; l++)$12c6b0ab9da17bee$var$F.getCharCode(d[l]) > 0 && (t[4][$12c6b0ab9da17bee$var$F.getCharCode(d[l])] = l);
}($12c6b0ab9da17bee$var$C.createInt32Array(5, 256));
var $12c6b0ab9da17bee$var$Io = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$So = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $12c6b0ab9da17bee$var$Io(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d");
        if (!r) throw new Error("Couldn't get canvas context.");
        var n = r.getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(n.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement();
        if (!r) throw new Error("Could not create a Canvas element.");
        var n = t * e.DEGREE_TO_RADIANS, o = this.canvas.width, i = this.canvas.height, a = Math.ceil(Math.abs(Math.cos(n)) * o + Math.abs(Math.sin(n)) * i), u = Math.ceil(Math.abs(Math.sin(n)) * o + Math.abs(Math.cos(n)) * i);
        r.width = a, r.height = u;
        var s = r.getContext("2d");
        if (!s) throw new Error("Could not create a Convas Context element.");
        return s.translate(a / 2, u / 2), s.rotate(n), s.drawImage(this.canvas, o / -2, i / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($12c6b0ab9da17bee$var$j);
function $12c6b0ab9da17bee$var$Oo() {
    return "undefined" != typeof navigator;
}
function $12c6b0ab9da17bee$var$To() {
    return !!($12c6b0ab9da17bee$var$Oo() && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
}
var $12c6b0ab9da17bee$var$bo = function() {
    return $12c6b0ab9da17bee$var$bo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $12c6b0ab9da17bee$var$bo.apply(this, arguments);
}, $12c6b0ab9da17bee$var$Ro = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $12c6b0ab9da17bee$var$No = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $12c6b0ab9da17bee$var$Do = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Po = {
    delayBetweenScanAttempts: 500,
    delayBetweenScanSuccess: 500,
    tryPlayVideoTimeout: 5e3
}, $12c6b0ab9da17bee$var$Mo = function() {
    function t(t, e, r) {
        void 0 === e && (e = new Map), void 0 === r && (r = {}), this.reader = t, this.hints = e, this.options = $12c6b0ab9da17bee$var$bo($12c6b0ab9da17bee$var$bo({}, $12c6b0ab9da17bee$var$Po), r);
    }
    return Object.defineProperty(t.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS, t);
        },
        enumerable: !1,
        configurable: !0
    }), t.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.mediaStreamSetTorch = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            t.applyConstraints({
                                advanced: [
                                    {
                                        fillLightMode: e ? "flash" : "off",
                                        torch: !!e
                                    }
                                ]
                            })
                        ];
                    case 1:
                        return r.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.mediaStreamIsTorchCompatible = function(e) {
        var r, n, o = e.getVideoTracks();
        try {
            for(var i = $12c6b0ab9da17bee$var$Do(o), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (t.mediaStreamIsTorchCompatibleTrack(u)) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (n = i.return) && n.call(i);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, t.mediaStreamIsTorchCompatibleTrack = function(t) {
        try {
            return "torch" in t.getCapabilities();
        } catch (t) {
            return console.error(t), console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."), !1;
        }
    }, t.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && t.readyState > 2;
    }, t.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.createVideoElement = function(e) {
        if (e instanceof HTMLVideoElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "video");
        if (!e && "undefined" != typeof document) {
            var r = document.createElement("video");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get videoElement from videoSource!");
    }, t.prepareImageElement = function(e) {
        if (e instanceof HTMLImageElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "img");
        if (void 0 === e) {
            var r = document.createElement("img");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get imageElement from imageSource!");
    }, t.prepareVideoElement = function(e) {
        var r = t.createVideoElement(e);
        return r.setAttribute("autoplay", "true"), r.setAttribute("muted", "true"), r.setAttribute("playsinline", "true"), r;
    }, t.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.createBinaryBitmapFromCanvas = function(t) {
        var e = new $12c6b0ab9da17bee$var$So(t), r = new $12c6b0ab9da17bee$var$W(e);
        return new $12c6b0ab9da17bee$var$d(r);
    }, t.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.getMediaElementDimensions = function(t) {
        if (t instanceof HTMLVideoElement) return {
            height: t.videoHeight,
            width: t.videoWidth
        };
        if (t instanceof HTMLImageElement) return {
            height: t.naturalHeight || t.height,
            width: t.naturalWidth || t.width
        };
        throw new Error("Couldn't find the Source's dimentions!");
    }, t.createCaptureCanvas = function(e) {
        if (!e) throw new $12c6b0ab9da17bee$var$f("Cannot create a capture canvas without a media element.");
        if ("undefined" == typeof document) throw new Error('The page "Document" is undefined, make sure you\'re running in a browser.');
        var r = document.createElement("canvas"), n = t.getMediaElementDimensions(e), o = n.width, i = n.height;
        return r.style.width = o + "px", r.style.height = i + "px", r.width = o, r.height = i, r;
    }, t.tryPlayVideo = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (null == e ? void 0 : e.ended) return console.error("Trying to play video that has ended."), [
                            2,
                            !1
                        ];
                        if (t.isVideoPlaying(e)) return console.warn("Trying to play video that is already playing."), [
                            2,
                            !0
                        ];
                        n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            e.play()
                        ];
                    case 2:
                        return n.sent(), [
                            2,
                            !0
                        ];
                    case 3:
                        return r = n.sent(), console.warn("It was not possible to play the video.", r), [
                            2,
                            !1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.createCanvasFromMediaElement = function(e) {
        var r = t.createCaptureCanvas(e), n = r.getContext("2d");
        if (!n) throw new Error("Couldn't find Canvas 2D Context.");
        return t.drawImageOnCanvas(n, e), r;
    }, t.createBinaryBitmapFromMediaElem = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return t.createBinaryBitmapFromCanvas(r);
    }, t.destroyImageElement = function(t) {
        t.src = "", t.removeAttribute("src"), t = void 0;
    }, t.listVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $12c6b0ab9da17bee$var$No(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!$12c6b0ab9da17bee$var$Oo()) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!$12c6b0ab9da17bee$var$To()) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $12c6b0ab9da17bee$var$Do(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.findDeviceById = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.listVideoInputDevices()
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            r.find(function(t) {
                                return t.deviceId === e;
                            })
                        ] : [
                            2
                        ];
                }
            });
        });
    }, t.cleanVideoSource = function(t) {
        if (t) {
            try {
                t.srcObject = null;
            } catch (e) {
                t.src = "";
            }
            t && t.removeAttribute("src");
        }
    }, t.playVideoOnLoadAsync = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.tryPlayVideo(e)
                        ];
                    case 1:
                        return n.sent() ? [
                            2,
                            !0
                        ] : [
                            2,
                            new Promise(function(n, o) {
                                var i = setTimeout(function() {
                                    t.isVideoPlaying(e) || (o(!1), e.removeEventListener("canplay", a));
                                }, r), a = function() {
                                    t.tryPlayVideo(e).then(function(t) {
                                        clearTimeout(i), e.removeEventListener("canplay", a), n(t);
                                    });
                                };
                                e.addEventListener("canplay", a);
                            })
                        ];
                }
            });
        });
    }, t.attachStreamToVideo = function(e, r, n) {
        return void 0 === n && (n = 5e3), $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return o = t.prepareVideoElement(r), t.addVideoSource(o, e), [
                            4,
                            t.playVideoOnLoadAsync(o, n)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            o
                        ];
                }
            });
        });
    }, t._waitImageLoad = function(e) {
        return new Promise(function(r, n) {
            var o = setTimeout(function() {
                t.isImageLoaded(e) || (e.removeEventListener("load", i), n());
            }, 1e4), i = function() {
                clearTimeout(o), e.removeEventListener("load", i), r();
            };
            e.addEventListener("load", i);
        });
    }, t.checkCallbackFnOrThrow = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("`callbackFn` is a required parameter, you cannot capture results without it.");
    }, t.disposeMediaStream = function(t) {
        t.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), t = void 0;
    }, t.prototype.decode = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return this.decodeFromCanvas(r);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this.hints);
    }, t.prototype.decodeFromCanvas = function(e) {
        var r = t.createBinaryBitmapFromCanvas(e);
        return this.decodeBitmap(r);
    }, t.prototype.decodeFromImageElement = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An image element must be provided.");
                        return r = t.prepareImageElement(e), [
                            4,
                            this._decodeOnLoadImage(r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromImageUrl = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        (r = t.prepareImageElement()).src = e, n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            this.decodeFromImageElement(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                    case 3:
                        return t.destroyImageElement(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o, i;
            return $12c6b0ab9da17bee$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), [
                            4,
                            navigator.mediaDevices.getUserMedia(e)
                        ];
                    case 1:
                        o = a.sent(), a.label = 2;
                    case 2:
                        return a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]), [
                            4,
                            this.decodeFromStream(o, r, n)
                        ];
                    case 3:
                        return [
                            2,
                            a.sent()
                        ];
                    case 4:
                        throw i = a.sent(), t.disposeMediaStream(o), i;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o, i, a, u, s, c, f, h, l, d, p = this;
            return $12c6b0ab9da17bee$var$No(this, function(g) {
                switch(g.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.attachStreamToVideo(e, r, o)
                        ];
                    case 1:
                        return i = g.sent(), a = function() {
                            var t, r;
                            try {
                                for(var n = $12c6b0ab9da17bee$var$Do(e.getVideoTracks()), o = n.next(); !o.done; o = n.next())o.value.stop();
                            } catch (e) {
                                t = {
                                    error: e
                                };
                            } finally{
                                try {
                                    o && !o.done && (r = n.return) && r.call(n);
                                } finally{
                                    if (t) throw t.error;
                                }
                            }
                            e = void 0;
                        }, u = function() {
                            a(), t.cleanVideoSource(i);
                        }, s = this.scan(i, n, u), c = e.getVideoTracks(), f = $12c6b0ab9da17bee$var$bo($12c6b0ab9da17bee$var$bo({}, s), {
                            stop: function() {
                                s.stop();
                            },
                            streamVideoConstraintsApply: function(t, e) {
                                return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
                                    var r, n, o, i, a, u;
                                    return $12c6b0ab9da17bee$var$No(this, function(s) {
                                        switch(s.label){
                                            case 0:
                                                r = e ? c.filter(e) : c, s.label = 1;
                                            case 1:
                                                s.trys.push([
                                                    1,
                                                    6,
                                                    7,
                                                    8
                                                ]), n = $12c6b0ab9da17bee$var$Do(r), o = n.next(), s.label = 2;
                                            case 2:
                                                return o.done ? [
                                                    3,
                                                    5
                                                ] : [
                                                    4,
                                                    o.value.applyConstraints(t)
                                                ];
                                            case 3:
                                                s.sent(), s.label = 4;
                                            case 4:
                                                return o = n.next(), [
                                                    3,
                                                    2
                                                ];
                                            case 5:
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 6:
                                                return i = s.sent(), a = {
                                                    error: i
                                                }, [
                                                    3,
                                                    8
                                                ];
                                            case 7:
                                                try {
                                                    o && !o.done && (u = n.return) && u.call(n);
                                                } finally{
                                                    if (a) throw a.error;
                                                }
                                                return [
                                                    7
                                                ];
                                            case 8:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            },
                            streamVideoConstraintsGet: function(t) {
                                return c.find(t).getConstraints();
                            },
                            streamVideoSettingsGet: function(t) {
                                return c.find(t).getSettings();
                            },
                            streamVideoCapabilitiesGet: function(t) {
                                return c.find(t).getCapabilities();
                            }
                        }), t.mediaStreamIsTorchCompatible(e) && (h = null == c ? void 0 : c.find(function(e) {
                            return t.mediaStreamIsTorchCompatibleTrack(e);
                        }), l = function(e) {
                            return $12c6b0ab9da17bee$var$Ro(p, void 0, void 0, function() {
                                return $12c6b0ab9da17bee$var$No(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return [
                                                4,
                                                t.mediaStreamSetTorch(h, e)
                                            ];
                                        case 1:
                                            return r.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, f.switchTorch = l, d = function() {
                            s.stop(), l(!1);
                        }, f.stop = d), [
                            2,
                            f
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = {
                            video: e ? {
                                deviceId: {
                                    exact: e
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(o, r, n)
                        ];
                    case 1:
                        return [
                            2,
                            i.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoElement = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
                        return n = t.prepareVideoElement(e), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, o)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            this.scan(n, r)
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoUrl = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o, i;
            return $12c6b0ab9da17bee$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        return (n = t.prepareVideoElement()).src = e, o = function() {
                            t.cleanVideoSource(n);
                        }, i = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, i)
                        ];
                    case 1:
                        return a.sent(), [
                            2,
                            this.scan(n, r, o)
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return n = Boolean(r), [
                            4,
                            t.attachStreamToVideo(e, r)
                        ];
                    case 1:
                        o = i.sent(), i.label = 2;
                    case 2:
                        return i.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]), [
                            4,
                            this.scanOneResult(o)
                        ];
                    case 3:
                        return [
                            2,
                            i.sent()
                        ];
                    case 4:
                        return n || t.cleanVideoSource(o), [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoElement = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $12c6b0ab9da17bee$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
                        return r = t.prepareVideoElement(e), n = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(r, n)
                        ];
                    case 1:
                        return o.sent(), [
                            4,
                            this.scanOneResult(r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoUrl = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $12c6b0ab9da17bee$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        (r = t.prepareVideoElement()).src = e, n = this.decodeOnceFromVideoElement(r), o.label = 1;
                    case 1:
                        return o.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            n
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                    case 3:
                        return t.cleanVideoSource(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.scanOneResult = function(t, e, r, n) {
        var o = this;
        return void 0 === e && (e = !0), void 0 === r && (r = !0), void 0 === n && (n = !0), new Promise(function(i, a) {
            o.scan(t, function(t, o, u) {
                if (t) return i(t), void u.stop();
                if (o) {
                    if (o instanceof $12c6b0ab9da17bee$var$U && e) return;
                    if (o instanceof $12c6b0ab9da17bee$var$g && r) return;
                    if (o instanceof $12c6b0ab9da17bee$var$R && n) return;
                    u.stop(), a(o);
                }
            });
        });
    }, t.prototype.scan = function(e, r, n) {
        var o = this;
        t.checkCallbackFnOrThrow(r);
        var i = t.createCaptureCanvas(e), a = i.getContext("2d");
        if (!a) throw new Error("Couldn't create canvas for visual element scan.");
        var u, s = function() {
            a = void 0, i = void 0;
        }, c = !1, f = {
            stop: function() {
                c = !0, clearTimeout(u), s(), n && n();
            }
        }, h = function() {
            if (!c) try {
                t.drawImageOnCanvas(a, e);
                var l = o.decodeFromCanvas(i);
                r(l, void 0, f), u = setTimeout(h, o.options.delayBetweenScanSuccess);
            } catch (t) {
                if (r(void 0, t, f), t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$U) return void (u = setTimeout(h, o.options.delayBetweenScanAttempts));
                s(), n && n(t);
            }
        };
        return h(), f;
    }, t.prototype._decodeOnLoadImage = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return t.isImageLoaded(e) ? [
                            3,
                            2
                        ] : [
                            4,
                            t._waitImageLoad(e)
                        ];
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return [
                            2,
                            this.decode(e)
                        ];
                }
            });
        });
    }, t;
}(), $12c6b0ab9da17bee$var$Bo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Mt, e, r) || this;
    }
    $12c6b0ab9da17bee$var$Bo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Lo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$fr(e), e, r) || this;
    }
    $12c6b0ab9da17bee$var$Lo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Or, e, r) || this;
    }
    $12c6b0ab9da17bee$var$Fo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$ko = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        var n = this, o = new $12c6b0ab9da17bee$var$$n;
        return o.setHints(e), (n = t.call(this, o, e, r) || this).reader = o, n;
    }
    $12c6b0ab9da17bee$var$ko(e, t), Object.defineProperty(e.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS, t), this.reader.setHints(this.hints);
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    }, e.prototype.setHints = function(t) {
        this.hints = t, this.reader.setHints(this.hints);
    };
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$xo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Kn, e, r) || this;
    }
    $12c6b0ab9da17bee$var$xo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Vo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Uo = function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$an, e, r) || this;
    }
    return $12c6b0ab9da17bee$var$Vo(e, t), e;
}($12c6b0ab9da17bee$var$Mo), $12c6b0ab9da17bee$var$Ho = function(t, e, r) {
    var n = typeof t === r;
    return n || console.warn('[ReactQrReader]: Expected "'.concat(e, '" to be a of type "').concat(r, '".')), n;
}, $12c6b0ab9da17bee$export$950f6bcb8267c4b = function(t) {
    var n = t.scanDelay, o = t.constraints, i = t.onResult, a = t.videoId, u = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(function() {
        var t = new $12c6b0ab9da17bee$var$Uo(null, {
            delayBetweenScanAttempts: n
        });
        if (!function() {
            var t = "undefined" != typeof navigator && !!navigator.mediaDevices;
            return t || console.warn('[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t;
        }() && $12c6b0ab9da17bee$var$Ho(i, "onResult", "function")) i(null, new Error('MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t);
        return $12c6b0ab9da17bee$var$Ho(o, "constraints", "object") && t.decodeFromConstraints({
            video: o
        }, a, function(e, r) {
            $12c6b0ab9da17bee$var$Ho(i, "onResult", "function") && i(e, r, t);
        }).then(function(t) {
            return u.current = t;
        }).catch(function(e) {
            $12c6b0ab9da17bee$var$Ho(i, "onResult", "function") && i(null, e, t);
        }), function() {
            var t;
            null === (t = u.current) || void 0 === t || t.stop();
        };
    }, []);
}, $12c6b0ab9da17bee$var$Xo = function() {
    return $12c6b0ab9da17bee$var$Xo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $12c6b0ab9da17bee$var$Xo.apply(this, arguments);
}, $12c6b0ab9da17bee$var$Wo = {
    container: {
        width: "100%",
        paddingTop: "100%",
        overflow: "hidden",
        position: "relative"
    },
    video: {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "block",
        overflow: "hidden",
        position: "absolute",
        transform: void 0
    }
}, $12c6b0ab9da17bee$export$5d05a7e825dbf285 = function(e) {
    var r = e.videoContainerStyle, n = e.containerStyle, o = e.videoStyle, i = e.constraints, a = e.ViewFinder, u = e.scanDelay, s = e.className, c = e.onResult, f = e.videoId;
    return $12c6b0ab9da17bee$export$950f6bcb8267c4b({
        constraints: i,
        scanDelay: u,
        onResult: c,
        videoId: f
    }), $eZVvM.createElement("section", {
        className: s,
        style: n
    }, $eZVvM.createElement("div", {
        style: $12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo({}, $12c6b0ab9da17bee$var$Wo.container), r)
    }, !!a && $eZVvM.createElement(a, null), $eZVvM.createElement("video", {
        muted: !0,
        id: f,
        style: $12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo({}, $12c6b0ab9da17bee$var$Wo.video), o), {
            transform: "user" === (null == i ? void 0 : i.facingMode) && "scaleX(-1)"
        })
    })));
};
$12c6b0ab9da17bee$export$5d05a7e825dbf285.displayName = "QrReader", $12c6b0ab9da17bee$export$5d05a7e825dbf285.defaultProps = {
    constraints: {
        facingMode: "user"
    },
    videoId: "video",
    scanDelay: 500
};

});


parcelRegister("gVSZ4", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("43uT6")).then(()=>parcelRequire("4vAM8"));

});
parcelRegister("irxbj", function(module, exports) {
"use strict";

var $iCvWv = parcelRequire("iCvWv");
module.exports = $iCvWv(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("iCvWv", function(module, exports) {
"use strict";
var $d8e48db9b2a0b275$var$cachedBundles = {};
var $d8e48db9b2a0b275$var$cachedPreloads = {};
var $d8e48db9b2a0b275$var$cachedPrefetches = {};
function $d8e48db9b2a0b275$var$getCache(type) {
    switch(type){
        case "preload":
            return $d8e48db9b2a0b275$var$cachedPreloads;
        case "prefetch":
            return $d8e48db9b2a0b275$var$cachedPrefetches;
        default:
            return $d8e48db9b2a0b275$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d8e48db9b2a0b275$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("94uGM", function(module, exports) {
module.exports = "#clip0_65_8725";

});

parcelRegister("gU6yI", function(module, exports) {
module.exports = "#clip0_63_8879";

});

parcelRegister("dayIQ", function(module, exports) {
module.exports = "#clip0_65_10363";

});


var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
var $5644a0fb91926e5b$export$882461b6382ed46c;
var $5644a0fb91926e5b$export$757ceba2d55c277e;
"use strict";

var $e4ZGj = parcelRequire("e4ZGj");
var $5644a0fb91926e5b$var$i;
$5644a0fb91926e5b$export$882461b6382ed46c = $e4ZGj.createRoot;
$5644a0fb91926e5b$export$757ceba2d55c277e = $e4ZGj.hydrateRoot;



var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $eZVvM = parcelRequire("eZVvM");
// src/index.ts

var $eZVvM = parcelRequire("eZVvM");
var $65cdbf7f8217658a$exports = {};
"use strict";

$65cdbf7f8217658a$exports = (parcelRequire("9H773"));


var $e2346a360d18792d$var$React = // prettier-ignore
// @ts-ignore
"default" in $eZVvM ? $eZVvM["default"] : $eZVvM;
// src/components/Context.ts
var $e2346a360d18792d$var$ContextKey = Symbol.for(`react-redux-context`);
var $e2346a360d18792d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $e2346a360d18792d$var$getContext() {
    if (!$e2346a360d18792d$var$React.createContext) return {};
    var _gT_ContextKey;
    const contextMap = (_gT_ContextKey = $e2346a360d18792d$var$gT[$e2346a360d18792d$var$ContextKey]) !== null && _gT_ContextKey !== void 0 ? _gT_ContextKey : $e2346a360d18792d$var$gT[$e2346a360d18792d$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($e2346a360d18792d$var$React.createContext);
    if (!realContext) {
        realContext = $e2346a360d18792d$var$React.createContext(null);
        contextMap.set($e2346a360d18792d$var$React.createContext, realContext);
    }
    return realContext;
}
var $e2346a360d18792d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $e2346a360d18792d$var$getContext();
// src/utils/useSyncExternalStore.ts
var $e2346a360d18792d$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $e2346a360d18792d$var$createReduxContextHook(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $e2346a360d18792d$var$React.useContext(context);
        return contextValue;
    };
}
var $e2346a360d18792d$var$useReduxContext = /* @__PURE__ */ $e2346a360d18792d$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $e2346a360d18792d$var$useSyncExternalStoreWithSelector = $e2346a360d18792d$var$notInitialized;
var $e2346a360d18792d$var$initializeUseSelector = (fn)=>{
    $e2346a360d18792d$var$useSyncExternalStoreWithSelector = fn;
};
var $e2346a360d18792d$var$refEquality = (a, b)=>a === b;
function $e2346a360d18792d$export$2b53f90d2bd1cbfb(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$var$useReduxContext : $e2346a360d18792d$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $e2346a360d18792d$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $e2346a360d18792d$var$React.useRef(true);
        const wrappedSelector = $e2346a360d18792d$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $e2346a360d18792d$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $e2346a360d18792d$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $e2346a360d18792d$export$2105062e25df4afe = /* @__PURE__ */ $e2346a360d18792d$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $e2346a360d18792d$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $e2346a360d18792d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $e2346a360d18792d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $e2346a360d18792d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $e2346a360d18792d$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $e2346a360d18792d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $e2346a360d18792d$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $e2346a360d18792d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $e2346a360d18792d$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $e2346a360d18792d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $e2346a360d18792d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $e2346a360d18792d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $e2346a360d18792d$var$ForwardRef = $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE;
var $e2346a360d18792d$var$Memo = $e2346a360d18792d$var$REACT_MEMO_TYPE;
function $e2346a360d18792d$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $e2346a360d18792d$var$REACT_FRAGMENT_TYPE || type === $e2346a360d18792d$var$REACT_PROFILER_TYPE || type === $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE || type === $e2346a360d18792d$var$REACT_SUSPENSE_TYPE || type === $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE || type === $e2346a360d18792d$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $e2346a360d18792d$var$REACT_LAZY_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_MEMO_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_PROVIDER_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_CONTEXT_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $e2346a360d18792d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $e2346a360d18792d$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $e2346a360d18792d$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $e2346a360d18792d$var$REACT_FRAGMENT_TYPE:
                        case $e2346a360d18792d$var$REACT_PROFILER_TYPE:
                        case $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE:
                        case $e2346a360d18792d$var$REACT_SUSPENSE_TYPE:
                        case $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $e2346a360d18792d$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $e2346a360d18792d$var$REACT_CONTEXT_TYPE:
                                    case $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE:
                                    case $e2346a360d18792d$var$REACT_LAZY_TYPE:
                                    case $e2346a360d18792d$var$REACT_MEMO_TYPE:
                                    case $e2346a360d18792d$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $e2346a360d18792d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $e2346a360d18792d$var$isContextConsumer(object) {
    return $e2346a360d18792d$var$typeOf(object) === $e2346a360d18792d$var$REACT_CONTEXT_TYPE;
}
function $e2346a360d18792d$var$isMemo(object) {
    return $e2346a360d18792d$var$typeOf(object) === $e2346a360d18792d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $e2346a360d18792d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $e2346a360d18792d$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $e2346a360d18792d$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $e2346a360d18792d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $e2346a360d18792d$var$verify(mapStateToProps, "mapStateToProps");
    $e2346a360d18792d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $e2346a360d18792d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $e2346a360d18792d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e2346a360d18792d$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e2346a360d18792d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $e2346a360d18792d$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $e2346a360d18792d$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $e2346a360d18792d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$e2346a360d18792d$var$isPlainObject(value)) $e2346a360d18792d$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $e2346a360d18792d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $e2346a360d18792d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $e2346a360d18792d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e2346a360d18792d$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e2346a360d18792d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $e2346a360d18792d$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $e2346a360d18792d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $e2346a360d18792d$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $e2346a360d18792d$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $e2346a360d18792d$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $e2346a360d18792d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $e2346a360d18792d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $e2346a360d18792d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $e2346a360d18792d$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $e2346a360d18792d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $e2346a360d18792d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $e2346a360d18792d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $e2346a360d18792d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $e2346a360d18792d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$e2346a360d18792d$var$defaultMergeProps : typeof mergeProps === "function" ? $e2346a360d18792d$var$wrapMergePropsFunc(mergeProps) : $e2346a360d18792d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $e2346a360d18792d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $e2346a360d18792d$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $e2346a360d18792d$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $e2346a360d18792d$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $e2346a360d18792d$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $e2346a360d18792d$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $e2346a360d18792d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $e2346a360d18792d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $e2346a360d18792d$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $e2346a360d18792d$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $e2346a360d18792d$var$useIsomorphicLayoutEffect = $e2346a360d18792d$var$canUseDOM || $e2346a360d18792d$var$isReactNative ? $e2346a360d18792d$var$React.useLayoutEffect : $e2346a360d18792d$var$React.useEffect;
// src/utils/shallowEqual.ts
function $e2346a360d18792d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e2346a360d18792d$export$d36bdfa510afb180(objA, objB) {
    if ($e2346a360d18792d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e2346a360d18792d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $e2346a360d18792d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e2346a360d18792d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e2346a360d18792d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e2346a360d18792d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e2346a360d18792d$var$TYPE_STATICS = {
    [$e2346a360d18792d$var$ForwardRef]: $e2346a360d18792d$var$FORWARD_REF_STATICS,
    [$e2346a360d18792d$var$Memo]: $e2346a360d18792d$var$MEMO_STATICS
};
function $e2346a360d18792d$var$getStatics(component) {
    if ($e2346a360d18792d$var$isMemo(component)) return $e2346a360d18792d$var$MEMO_STATICS;
    return $e2346a360d18792d$var$TYPE_STATICS[component["$$typeof"]] || $e2346a360d18792d$var$REACT_STATICS;
}
var $e2346a360d18792d$var$defineProperty = Object.defineProperty;
var $e2346a360d18792d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e2346a360d18792d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e2346a360d18792d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e2346a360d18792d$var$getPrototypeOf = Object.getPrototypeOf;
var $e2346a360d18792d$var$objectPrototype = Object.prototype;
function $e2346a360d18792d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($e2346a360d18792d$var$objectPrototype) {
            const inheritedComponent = $e2346a360d18792d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e2346a360d18792d$var$objectPrototype) $e2346a360d18792d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $e2346a360d18792d$var$getOwnPropertyNames(sourceComponent);
        if ($e2346a360d18792d$var$getOwnPropertySymbols) keys = keys.concat($e2346a360d18792d$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $e2346a360d18792d$var$getStatics(targetComponent);
        const sourceStatics = $e2346a360d18792d$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$e2346a360d18792d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $e2346a360d18792d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $e2346a360d18792d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $e2346a360d18792d$var$useSyncExternalStore = $e2346a360d18792d$var$notInitialized;
var $e2346a360d18792d$var$initializeConnect = (fn)=>{
    $e2346a360d18792d$var$useSyncExternalStore = fn;
};
var $e2346a360d18792d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $e2346a360d18792d$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $e2346a360d18792d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $e2346a360d18792d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $e2346a360d18792d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $e2346a360d18792d$var$strictEqual(a, b) {
    return a === b;
}
var $e2346a360d18792d$var$hasWarnedAboutDeprecatedPureOption = false;
function $e2346a360d18792d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $e2346a360d18792d$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $e2346a360d18792d$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $e2346a360d18792d$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $e2346a360d18792d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $e2346a360d18792d$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $e2346a360d18792d$var$React.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $e2346a360d18792d$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext === null || propsContext === void 0 ? void 0 : propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $e2346a360d18792d$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $e2346a360d18792d$var$React.useMemo(()=>{
                return $e2346a360d18792d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $e2346a360d18792d$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $e2346a360d18792d$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $e2346a360d18792d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $e2346a360d18792d$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $e2346a360d18792d$var$React.useRef(void 0);
            const lastWrapperProps = $e2346a360d18792d$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $e2346a360d18792d$var$React.useRef(void 0);
            const renderIsScheduled = $e2346a360d18792d$var$React.useRef(false);
            const isMounted = $e2346a360d18792d$var$React.useRef(false);
            const latestSubscriptionCallbackError = $e2346a360d18792d$var$React.useRef(void 0);
            $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $e2346a360d18792d$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $e2346a360d18792d$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $e2346a360d18792d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $e2346a360d18792d$var$useIsomorphicLayoutEffectWithArgs($e2346a360d18792d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $e2346a360d18792d$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $e2346a360d18792d$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $e2346a360d18792d$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $e2346a360d18792d$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $e2346a360d18792d$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $e2346a360d18792d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $e2346a360d18792d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $e2346a360d18792d$export$64605811ab45167f = $e2346a360d18792d$var$connect;
// src/components/Provider.tsx
function $e2346a360d18792d$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $e2346a360d18792d$var$React.useMemo(()=>{
        const subscription = $e2346a360d18792d$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $e2346a360d18792d$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $e2346a360d18792d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $e2346a360d18792d$export$2881499e37b75b9a = $e2346a360d18792d$var$Provider;
// src/hooks/useStore.ts
function $e2346a360d18792d$export$671dba69185d0304(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$var$useReduxContext : // @ts-ignore
    $e2346a360d18792d$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $e2346a360d18792d$export$6ccbb43953eebf8 = /* @__PURE__ */ $e2346a360d18792d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $e2346a360d18792d$export$bc9b55530897c558(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useStore2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$export$6ccbb43953eebf8 : $e2346a360d18792d$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $e2346a360d18792d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $e2346a360d18792d$export$bc9b55530897c558();
// src/exports.ts
var $e2346a360d18792d$export$712ea50be43a7858 = $e2346a360d18792d$var$defaultNoopBatch;
// src/index.ts
$e2346a360d18792d$var$initializeUseSelector((0, $65cdbf7f8217658a$exports.useSyncExternalStoreWithSelector));
$e2346a360d18792d$var$initializeConnect($eZVvM.useSyncExternalStore);


// src/index.ts
function $3714350acbe00f73$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


// src/utils/formatProdErrorMessage.ts
function $ac44486100bacc69$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $ac44486100bacc69$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $ac44486100bacc69$var$symbol_observable_default = $ac44486100bacc69$var$$$observable;
// src/utils/actionTypes.ts
var $ac44486100bacc69$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $ac44486100bacc69$var$ActionTypes = {
    INIT: `@@redux/INIT${$ac44486100bacc69$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$ac44486100bacc69$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$ac44486100bacc69$var$randomString()}`
};
var $ac44486100bacc69$export$4219e499db7ca678 = $ac44486100bacc69$var$ActionTypes;
// src/utils/isPlainObject.ts
function $ac44486100bacc69$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $ac44486100bacc69$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ac44486100bacc69$var$isDate(val)) return "date";
    if ($ac44486100bacc69$var$isError(val)) return "error";
    const constructorName = $ac44486100bacc69$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ac44486100bacc69$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ac44486100bacc69$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ac44486100bacc69$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ac44486100bacc69$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $ac44486100bacc69$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(1));
        return enhancer($ac44486100bacc69$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$ac44486100bacc69$export$53b83ca8eaab0383(action)) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $ac44486100bacc69$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$ac44486100bacc69$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $ac44486100bacc69$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$ac44486100bacc69$var$symbol_observable_default]: observable
    };
    return store;
}
function $ac44486100bacc69$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $ac44486100bacc69$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $ac44486100bacc69$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $ac44486100bacc69$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $ac44486100bacc69$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ac44486100bacc69$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$ac44486100bacc69$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ac44486100bacc69$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $ac44486100bacc69$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $ac44486100bacc69$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $ac44486100bacc69$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(13));
    });
}
function $ac44486100bacc69$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $ac44486100bacc69$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($ac44486100bacc69$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $ac44486100bacc69$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $ac44486100bacc69$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ac44486100bacc69$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ac44486100bacc69$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $ac44486100bacc69$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $ac44486100bacc69$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($ac44486100bacc69$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $ac44486100bacc69$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $ac44486100bacc69$export$b956e38827fca970(action) {
    return $ac44486100bacc69$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/utils/env.ts
var $7b8b56f7aa848e1e$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7b8b56f7aa848e1e$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7b8b56f7aa848e1e$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7b8b56f7aa848e1e$var$errors = [];
function $7b8b56f7aa848e1e$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7b8b56f7aa848e1e$var$getPrototypeOf = Object.getPrototypeOf;
function $7b8b56f7aa848e1e$export$541ac630993a4c84(value) {
    return !!value && !!value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
}
function $7b8b56f7aa848e1e$export$16e3aed3edb85946(value) {
    var _value_constructor;
    if (!value) return false;
    return $7b8b56f7aa848e1e$var$isPlainObject(value) || Array.isArray(value) || !!value[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee] || !!((_value_constructor = value.constructor) === null || _value_constructor === void 0 ? void 0 : _value_constructor[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee]) || $7b8b56f7aa848e1e$var$isMap(value) || $7b8b56f7aa848e1e$var$isSet(value);
}
var $7b8b56f7aa848e1e$var$objectCtorString = Object.prototype.constructor.toString();
function $7b8b56f7aa848e1e$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7b8b56f7aa848e1e$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7b8b56f7aa848e1e$var$objectCtorString;
}
function $7b8b56f7aa848e1e$export$22e8af3f75a010e3(value) {
    if (!$7b8b56f7aa848e1e$export$541ac630993a4c84(value)) $7b8b56f7aa848e1e$var$die(15, value);
    return value[$7b8b56f7aa848e1e$var$DRAFT_STATE].base_;
}
function $7b8b56f7aa848e1e$var$each(obj, iter) {
    if ($7b8b56f7aa848e1e$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7b8b56f7aa848e1e$var$getArchtype(thing) {
    const state = thing[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7b8b56f7aa848e1e$var$isMap(thing) ? 2 /* Map */  : $7b8b56f7aa848e1e$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7b8b56f7aa848e1e$var$has(thing, prop) {
    return $7b8b56f7aa848e1e$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7b8b56f7aa848e1e$var$get(thing, prop) {
    return $7b8b56f7aa848e1e$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7b8b56f7aa848e1e$var$set(thing, propOrOldValue, value) {
    const t = $7b8b56f7aa848e1e$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7b8b56f7aa848e1e$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7b8b56f7aa848e1e$var$isMap(target) {
    return target instanceof Map;
}
function $7b8b56f7aa848e1e$var$isSet(target) {
    return target instanceof Set;
}
function $7b8b56f7aa848e1e$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7b8b56f7aa848e1e$var$shallowCopy(base, strict) {
    if ($7b8b56f7aa848e1e$var$isMap(base)) return new Map(base);
    if ($7b8b56f7aa848e1e$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7b8b56f7aa848e1e$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7b8b56f7aa848e1e$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7b8b56f7aa848e1e$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7b8b56f7aa848e1e$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7b8b56f7aa848e1e$export$792f3d81ea979f55(obj, deep = false) {
    if ($7b8b56f7aa848e1e$var$isFrozen(obj) || $7b8b56f7aa848e1e$export$541ac630993a4c84(obj) || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(obj)) return obj;
    if ($7b8b56f7aa848e1e$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7b8b56f7aa848e1e$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7b8b56f7aa848e1e$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7b8b56f7aa848e1e$var$dontMutateFrozenCollections() {
    $7b8b56f7aa848e1e$var$die(2);
}
function $7b8b56f7aa848e1e$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7b8b56f7aa848e1e$var$plugins = {};
function $7b8b56f7aa848e1e$var$getPlugin(pluginKey) {
    const plugin = $7b8b56f7aa848e1e$var$plugins[pluginKey];
    if (!plugin) $7b8b56f7aa848e1e$var$die(0, pluginKey);
    return plugin;
}
function $7b8b56f7aa848e1e$var$loadPlugin(pluginKey, implementation) {
    if (!$7b8b56f7aa848e1e$var$plugins[pluginKey]) $7b8b56f7aa848e1e$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7b8b56f7aa848e1e$var$currentScope;
function $7b8b56f7aa848e1e$var$getCurrentScope() {
    return $7b8b56f7aa848e1e$var$currentScope;
}
function $7b8b56f7aa848e1e$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7b8b56f7aa848e1e$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7b8b56f7aa848e1e$var$revokeScope(scope) {
    $7b8b56f7aa848e1e$var$leaveScope(scope);
    scope.drafts_.forEach($7b8b56f7aa848e1e$var$revokeDraft);
    scope.drafts_ = null;
}
function $7b8b56f7aa848e1e$var$leaveScope(scope) {
    if (scope === $7b8b56f7aa848e1e$var$currentScope) $7b8b56f7aa848e1e$var$currentScope = scope.parent_;
}
function $7b8b56f7aa848e1e$var$enterScope(immer2) {
    return $7b8b56f7aa848e1e$var$currentScope = $7b8b56f7aa848e1e$var$createScope($7b8b56f7aa848e1e$var$currentScope, immer2);
}
function $7b8b56f7aa848e1e$var$revokeDraft(draft) {
    const state = draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7b8b56f7aa848e1e$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7b8b56f7aa848e1e$var$DRAFT_STATE].modified_) {
            $7b8b56f7aa848e1e$var$revokeScope(scope);
            $7b8b56f7aa848e1e$var$die(4);
        }
        if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(result)) {
            result = $7b8b56f7aa848e1e$var$finalize(scope, result);
            if (!scope.parent_) $7b8b56f7aa848e1e$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7b8b56f7aa848e1e$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7b8b56f7aa848e1e$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7b8b56f7aa848e1e$var$finalize(scope, baseDraft, []);
    $7b8b56f7aa848e1e$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7b8b56f7aa848e1e$export$45b790e32b2810ee ? result : void 0;
}
function $7b8b56f7aa848e1e$var$finalize(rootScope, value, path) {
    if ($7b8b56f7aa848e1e$var$isFrozen(value)) return value;
    const state = value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    if (!state) {
        $7b8b56f7aa848e1e$var$each(value, (key, childValue)=>$7b8b56f7aa848e1e$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7b8b56f7aa848e1e$var$each(resultEach, (key, childValue)=>$7b8b56f7aa848e1e$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7b8b56f7aa848e1e$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7b8b56f7aa848e1e$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7b8b56f7aa848e1e$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7b8b56f7aa848e1e$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7b8b56f7aa848e1e$var$finalize(rootScope, childValue, path);
        $7b8b56f7aa848e1e$var$set(targetObject, prop, res);
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(childValue) && !$7b8b56f7aa848e1e$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7b8b56f7aa848e1e$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, childValue);
    }
}
function $7b8b56f7aa848e1e$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7b8b56f7aa848e1e$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7b8b56f7aa848e1e$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7b8b56f7aa848e1e$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7b8b56f7aa848e1e$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7b8b56f7aa848e1e$var$objectTraps = {
    get (state, prop) {
        if (prop === $7b8b56f7aa848e1e$var$DRAFT_STATE) return state;
        const source = $7b8b56f7aa848e1e$var$latest(state);
        if (!$7b8b56f7aa848e1e$var$has(source, prop)) return $7b8b56f7aa848e1e$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) return value;
        if (value === $7b8b56f7aa848e1e$var$peek(state.base_, prop)) {
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            return state.copy_[prop] = $7b8b56f7aa848e1e$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7b8b56f7aa848e1e$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7b8b56f7aa848e1e$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7b8b56f7aa848e1e$var$getDescriptorFromProto($7b8b56f7aa848e1e$var$latest(state), prop);
        if (desc === null || desc === void 0 ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7b8b56f7aa848e1e$var$peek($7b8b56f7aa848e1e$var$latest(state), prop);
            const currentState = current2 === null || current2 === void 0 ? void 0 : current2[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7b8b56f7aa848e1e$var$is(value, current2) && (value !== void 0 || $7b8b56f7aa848e1e$var$has(state.base_, prop))) return true;
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7b8b56f7aa848e1e$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7b8b56f7aa848e1e$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7b8b56f7aa848e1e$var$die(11);
    },
    getPrototypeOf (state) {
        return $7b8b56f7aa848e1e$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7b8b56f7aa848e1e$var$die(12);
    }
};
var $7b8b56f7aa848e1e$var$arrayTraps = {};
$7b8b56f7aa848e1e$var$each($7b8b56f7aa848e1e$var$objectTraps, (key, fn)=>{
    $7b8b56f7aa848e1e$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7b8b56f7aa848e1e$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7b8b56f7aa848e1e$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7b8b56f7aa848e1e$var$arrayTraps.set = function(state, prop, value) {
    return $7b8b56f7aa848e1e$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7b8b56f7aa848e1e$var$peek(draft, prop) {
    const state = draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    const source = state ? $7b8b56f7aa848e1e$var$latest(state) : draft;
    return source[prop];
}
function $7b8b56f7aa848e1e$var$readPropFromProto(state, source, prop) {
    var // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    _desc_get;
    const desc = $7b8b56f7aa848e1e$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : (_desc_get = desc.get) === null || _desc_get === void 0 ? void 0 : _desc_get.call(state.draft_) : void 0;
}
function $7b8b56f7aa848e1e$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7b8b56f7aa848e1e$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7b8b56f7aa848e1e$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7b8b56f7aa848e1e$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7b8b56f7aa848e1e$var$markChanged(state.parent_);
    }
}
function $7b8b56f7aa848e1e$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7b8b56f7aa848e1e$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7b8b56f7aa848e1e$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(base)) $7b8b56f7aa848e1e$var$die(8);
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(base)) base = $7b8b56f7aa848e1e$export$97aac956da55dae9(base);
        const scope = $7b8b56f7aa848e1e$var$enterScope(this);
        const proxy = $7b8b56f7aa848e1e$var$createProxy(base, void 0);
        proxy[$7b8b56f7aa848e1e$var$DRAFT_STATE].isManual_ = true;
        $7b8b56f7aa848e1e$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7b8b56f7aa848e1e$var$die(9);
        const { scope_: scope } = state;
        $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener);
        return $7b8b56f7aa848e1e$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7b8b56f7aa848e1e$var$getPlugin("Patches").applyPatches_;
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7b8b56f7aa848e1e$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7b8b56f7aa848e1e$var$die(7);
            let result;
            if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(base)) {
                const scope = $7b8b56f7aa848e1e$var$enterScope(this);
                const proxy = $7b8b56f7aa848e1e$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7b8b56f7aa848e1e$var$revokeScope(scope);
                    else $7b8b56f7aa848e1e$var$leaveScope(scope);
                }
                $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener);
                return $7b8b56f7aa848e1e$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7b8b56f7aa848e1e$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7b8b56f7aa848e1e$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7b8b56f7aa848e1e$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7b8b56f7aa848e1e$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config === null || config === void 0 ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config === null || config === void 0 ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
};
function $7b8b56f7aa848e1e$var$createProxy(value, parent) {
    const draft = $7b8b56f7aa848e1e$var$isMap(value) ? $7b8b56f7aa848e1e$var$getPlugin("MapSet").proxyMap_(value, parent) : $7b8b56f7aa848e1e$var$isSet(value) ? $7b8b56f7aa848e1e$var$getPlugin("MapSet").proxySet_(value, parent) : $7b8b56f7aa848e1e$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7b8b56f7aa848e1e$export$97aac956da55dae9(value) {
    if (!$7b8b56f7aa848e1e$export$541ac630993a4c84(value)) $7b8b56f7aa848e1e$var$die(10, value);
    return $7b8b56f7aa848e1e$var$currentImpl(value);
}
function $7b8b56f7aa848e1e$var$currentImpl(value) {
    if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(value) || $7b8b56f7aa848e1e$var$isFrozen(value)) return value;
    const state = value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7b8b56f7aa848e1e$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7b8b56f7aa848e1e$var$shallowCopy(value, true);
    $7b8b56f7aa848e1e$var$each(copy, (key, childValue)=>{
        $7b8b56f7aa848e1e$var$set(copy, key, $7b8b56f7aa848e1e$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7b8b56f7aa848e1e$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7b8b56f7aa848e1e$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7b8b56f7aa848e1e$var$get(base_, key);
            const value = $7b8b56f7aa848e1e$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7b8b56f7aa848e1e$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7b8b56f7aa848e1e$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7b8b56f7aa848e1e$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7b8b56f7aa848e1e$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7b8b56f7aa848e1e$var$die(errorOffset + 3);
                base = $7b8b56f7aa848e1e$var$get(base, p);
                if (typeof base !== "object") $7b8b56f7aa848e1e$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7b8b56f7aa848e1e$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7b8b56f7aa848e1e$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7b8b56f7aa848e1e$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7b8b56f7aa848e1e$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7b8b56f7aa848e1e$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7b8b56f7aa848e1e$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7b8b56f7aa848e1e$var$has(obj, $7b8b56f7aa848e1e$export$6ee2082928bcb0ee)) cloned[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee] = obj[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7b8b56f7aa848e1e$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7b8b56f7aa848e1e$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7b8b56f7aa848e1e$var$latest(state).has(key) || $7b8b56f7aa848e1e$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7b8b56f7aa848e1e$var$latest(state).size) {
                prepareMapCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7b8b56f7aa848e1e$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            $7b8b56f7aa848e1e$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7b8b56f7aa848e1e$var$latest(state).get(key);
            if (state.finalized_ || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7b8b56f7aa848e1e$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7b8b56f7aa848e1e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$7b8b56f7aa848e1e$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7b8b56f7aa848e1e$var$latest(state).size) {
                prepareSetCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7b8b56f7aa848e1e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$7b8b56f7aa848e1e$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) {
                    const draft = $7b8b56f7aa848e1e$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7b8b56f7aa848e1e$var$die(3, JSON.stringify($7b8b56f7aa848e1e$var$latest(state)));
    }
    $7b8b56f7aa848e1e$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7b8b56f7aa848e1e$var$immer = new $7b8b56f7aa848e1e$export$aaadc6ff0f822719();
var $7b8b56f7aa848e1e$export$b46cabe22e78bc00 = $7b8b56f7aa848e1e$var$immer.produce;
var $7b8b56f7aa848e1e$export$4da66d41c9492c78 = $7b8b56f7aa848e1e$var$immer.produceWithPatches.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$573f26f60825c493 = $7b8b56f7aa848e1e$var$immer.setAutoFreeze.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$333ce65961cbe047 = $7b8b56f7aa848e1e$var$immer.setUseStrictShallowCopy.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$a8b8e03e6bbe5473 = $7b8b56f7aa848e1e$var$immer.applyPatches.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$3c3214997190395f = $7b8b56f7aa848e1e$var$immer.createDraft.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$c60f5e69c521b528 = $7b8b56f7aa848e1e$var$immer.finishDraft.bind($7b8b56f7aa848e1e$var$immer);
function $7b8b56f7aa848e1e$export$c05b21e3257751e5(value) {
    return value;
}
function $7b8b56f7aa848e1e$export$20f911b3f8cf0b74(value) {
    return value;
}


// src/devModeChecks/identityFunctionCheck.ts

var $f3a2896bcea9aa5e$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $f3a2896bcea9aa5e$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $f3a2896bcea9aa5e$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $f3a2896bcea9aa5e$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($f3a2896bcea9aa5e$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $f3a2896bcea9aa5e$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $f3a2896bcea9aa5e$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $f3a2896bcea9aa5e$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $f3a2896bcea9aa5e$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $f3a2896bcea9aa5e$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $f3a2896bcea9aa5e$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $f3a2896bcea9aa5e$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $f3a2896bcea9aa5e$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $f3a2896bcea9aa5e$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$f3a2896bcea9aa5e$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $f3a2896bcea9aa5e$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $f3a2896bcea9aa5e$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $f3a2896bcea9aa5e$var$$REVISION = 0;
var $f3a2896bcea9aa5e$var$CURRENT_TRACKER = null;
var $f3a2896bcea9aa5e$var$Cell = class {
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $f3a2896bcea9aa5e$var$CURRENT_TRACKER === null || $f3a2896bcea9aa5e$var$CURRENT_TRACKER === void 0 ? void 0 : $f3a2896bcea9aa5e$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$f3a2896bcea9aa5e$var$$REVISION;
    }
    constructor(initialValue, isEqual = $f3a2896bcea9aa5e$var$tripleEq){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "revision", $f3a2896bcea9aa5e$var$$REVISION);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_value", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_lastValue", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_isEqual", $f3a2896bcea9aa5e$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
};
function $f3a2896bcea9aa5e$var$tripleEq(a, b) {
    return a === b;
}
var $f3a2896bcea9aa5e$var$TrackingCache = class {
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $f3a2896bcea9aa5e$var$CURRENT_TRACKER;
            $f3a2896bcea9aa5e$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $f3a2896bcea9aa5e$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $f3a2896bcea9aa5e$var$CURRENT_TRACKER === null || $f3a2896bcea9aa5e$var$CURRENT_TRACKER === void 0 ? void 0 : $f3a2896bcea9aa5e$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
    constructor(fn){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_cachedValue", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_cachedRevision", -1);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_deps", []);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "hits", 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "fn", void 0);
        this.fn = fn;
    }
};
function $f3a2896bcea9aa5e$var$getValue(cell) {
    if (!(cell instanceof $f3a2896bcea9aa5e$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $f3a2896bcea9aa5e$var$setValue(storage, value) {
    if (!(storage instanceof $f3a2896bcea9aa5e$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $f3a2896bcea9aa5e$var$createCell(initialValue, isEqual = $f3a2896bcea9aa5e$var$tripleEq) {
    return new $f3a2896bcea9aa5e$var$Cell(initialValue, isEqual);
}
function $f3a2896bcea9aa5e$var$createCache(fn) {
    $f3a2896bcea9aa5e$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $f3a2896bcea9aa5e$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $f3a2896bcea9aa5e$var$neverEq = (a, b)=>false;
function $f3a2896bcea9aa5e$var$createTag() {
    return $f3a2896bcea9aa5e$var$createCell(null, $f3a2896bcea9aa5e$var$neverEq);
}
function $f3a2896bcea9aa5e$var$dirtyTag(tag, value) {
    $f3a2896bcea9aa5e$var$setValue(tag, value);
}
var $f3a2896bcea9aa5e$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $f3a2896bcea9aa5e$var$createTag();
    $f3a2896bcea9aa5e$var$getValue(tag);
};
var $f3a2896bcea9aa5e$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $f3a2896bcea9aa5e$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $f3a2896bcea9aa5e$var$REDUX_PROXY_LABEL = Symbol();
var $f3a2896bcea9aa5e$var$nextId = 0;
var $f3a2896bcea9aa5e$var$proto = Object.getPrototypeOf({});
var $f3a2896bcea9aa5e$var$ObjectTreeNode = class {
    constructor(value){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "proxy", new Proxy(this, $f3a2896bcea9aa5e$var$objectProxyHandler));
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tag", $f3a2896bcea9aa5e$var$createTag());
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tags", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "children", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "collectionTag", null);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "id", $f3a2896bcea9aa5e$var$nextId++);
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
};
var $f3a2896bcea9aa5e$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $f3a2896bcea9aa5e$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $f3a2896bcea9aa5e$var$createNode(childValue);
                if (childNode.tag) $f3a2896bcea9aa5e$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $f3a2896bcea9aa5e$var$createTag();
                    tag.value = childValue;
                }
                $f3a2896bcea9aa5e$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $f3a2896bcea9aa5e$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $f3a2896bcea9aa5e$var$ArrayTreeNode = class {
    constructor(value){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "proxy", new Proxy([
            this
        ], $f3a2896bcea9aa5e$var$arrayProxyHandler));
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tag", $f3a2896bcea9aa5e$var$createTag());
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tags", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "children", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "collectionTag", null);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "id", $f3a2896bcea9aa5e$var$nextId++);
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
};
var $f3a2896bcea9aa5e$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $f3a2896bcea9aa5e$var$consumeCollection(node);
        return $f3a2896bcea9aa5e$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.has(node, prop);
    }
};
function $f3a2896bcea9aa5e$var$createNode(value) {
    if (Array.isArray(value)) return new $f3a2896bcea9aa5e$var$ArrayTreeNode(value);
    return new $f3a2896bcea9aa5e$var$ObjectTreeNode(value);
}
function $f3a2896bcea9aa5e$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $f3a2896bcea9aa5e$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $f3a2896bcea9aa5e$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $f3a2896bcea9aa5e$var$dirtyCollection(node);
            $f3a2896bcea9aa5e$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $f3a2896bcea9aa5e$var$updateNode(childNode, newChildValue);
        else {
            $f3a2896bcea9aa5e$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $f3a2896bcea9aa5e$var$deleteNode(node) {
    if (node.tag) $f3a2896bcea9aa5e$var$dirtyTag(node.tag, null);
    $f3a2896bcea9aa5e$var$dirtyCollection(node);
    for(const key in node.tags)$f3a2896bcea9aa5e$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$f3a2896bcea9aa5e$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $f3a2896bcea9aa5e$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f3a2896bcea9aa5e$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $f3a2896bcea9aa5e$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $f3a2896bcea9aa5e$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f3a2896bcea9aa5e$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f3a2896bcea9aa5e$export$3f025202a230c6dd = (a, b)=>a === b;
function $f3a2896bcea9aa5e$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f3a2896bcea9aa5e$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $f3a2896bcea9aa5e$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $f3a2896bcea9aa5e$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $f3a2896bcea9aa5e$var$createSingletonCache(comparator) : $f3a2896bcea9aa5e$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $f3a2896bcea9aa5e$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $f3a2896bcea9aa5e$export$c8f9cf88d9fdee55(func) {
    const node = $f3a2896bcea9aa5e$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $f3a2896bcea9aa5e$var$createCacheKeyComparator($f3a2896bcea9aa5e$export$3f025202a230c6dd);
    const cache = $f3a2896bcea9aa5e$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $f3a2896bcea9aa5e$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $f3a2896bcea9aa5e$var$StrongRef = class {
    deref() {
        return this.value;
    }
    constructor(value){
        this.value = value;
    }
};
var $f3a2896bcea9aa5e$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $f3a2896bcea9aa5e$var$StrongRef;
var $f3a2896bcea9aa5e$var$UNTERMINATED = 0;
var $f3a2896bcea9aa5e$var$TERMINATED = 1;
function $f3a2896bcea9aa5e$var$createCacheNode() {
    return {
        s: $f3a2896bcea9aa5e$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $f3a2896bcea9aa5e$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $f3a2896bcea9aa5e$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $f3a2896bcea9aa5e$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $f3a2896bcea9aa5e$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $f3a2896bcea9aa5e$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var _lastResult_deref;
                var _lastResult_deref1;
                const lastResultValue = (_lastResult_deref1 = lastResult === null || lastResult === void 0 ? void 0 : (_lastResult_deref = lastResult.deref) === null || _lastResult_deref === void 0 ? void 0 : _lastResult_deref.call(lastResult)) !== null && _lastResult_deref1 !== void 0 ? _lastResult_deref1 : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $f3a2896bcea9aa5e$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $f3a2896bcea9aa5e$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $f3a2896bcea9aa5e$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $f3a2896bcea9aa5e$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $f3a2896bcea9aa5e$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $f3a2896bcea9aa5e$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $f3a2896bcea9aa5e$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $f3a2896bcea9aa5e$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $f3a2896bcea9aa5e$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $f3a2896bcea9aa5e$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $f3a2896bcea9aa5e$export$595d22ed68ca2841 = /* @__PURE__ */ $f3a2896bcea9aa5e$export$5943f4447f6ef248($f3a2896bcea9aa5e$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $f3a2896bcea9aa5e$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $f3a2896bcea9aa5e$export$595d22ed68ca2841)=>{
    $f3a2896bcea9aa5e$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$f3a2896bcea9aa5e$export$75979cfcd91bf38f
});


// src/index.ts
function $66e767ba7acb4f78$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $66e767ba7acb4f78$export$dd164f5517779f15 = $66e767ba7acb4f78$var$createThunkMiddleware();
var $66e767ba7acb4f78$export$16d06542a1949d9e = $66e767ba7acb4f78$var$createThunkMiddleware;



var $khNKv = parcelRequire("khNKv");
var $58dad493bd6ec980$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $f3a2896bcea9aa5e$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(value) ? (0, $7b8b56f7aa848e1e$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $58dad493bd6ec980$export$a5d3c27355e35910 = /* @__PURE__ */ $58dad493bd6ec980$export$aab6de9e3dbb1473((0, $f3a2896bcea9aa5e$export$8402dc26d96f6902));
var $58dad493bd6ec980$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ac44486100bacc69$export$f672e0b6f7222cd7;
    return (0, $ac44486100bacc69$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $58dad493bd6ec980$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $58dad493bd6ec980$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $58dad493bd6ec980$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $ac44486100bacc69$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $58dad493bd6ec980$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $58dad493bd6ec980$var$hasMatchFunction(action);
}
function $58dad493bd6ec980$export$ebd532f9034651f3(action) {
    return (0, $ac44486100bacc69$export$b956e38827fca970)(action) && Object.keys(action).every($58dad493bd6ec980$var$isValidKey);
}
function $58dad493bd6ec980$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $58dad493bd6ec980$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $58dad493bd6ec980$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $58dad493bd6ec980$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $58dad493bd6ec980$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $58dad493bd6ec980$export$1908877435b1d5e9 = class _Tuple extends Array {
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
};
function $58dad493bd6ec980$var$freezeDraftable(val) {
    return (0, $7b8b56f7aa848e1e$export$16e3aed3edb85946)(val) ? (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $58dad493bd6ec980$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $58dad493bd6ec980$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $58dad493bd6ec980$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $58dad493bd6ec980$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $58dad493bd6ec980$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $58dad493bd6ec980$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $58dad493bd6ec980$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $58dad493bd6ec980$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $ac44486100bacc69$export$53b83ca8eaab0383)(val);
}
function $58dad493bd6ec980$export$ada5dca0b571bc7(value, path = "", isSerializable = $58dad493bd6ec980$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $58dad493bd6ec980$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $58dad493bd6ec980$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $58dad493bd6ec980$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$58dad493bd6ec980$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $58dad493bd6ec980$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $58dad493bd6ec980$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $58dad493bd6ec980$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options !== null && options !== void 0 ? options : {};
        let middlewareArray = new $58dad493bd6ec980$export$1908877435b1d5e9();
        if (thunk) {
            if ($58dad493bd6ec980$var$isBoolean(thunk)) middlewareArray.push((0, $66e767ba7acb4f78$export$dd164f5517779f15));
            else middlewareArray.push((0, $66e767ba7acb4f78$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $58dad493bd6ec980$export$8fb31c0f05df007b = "RTK_autoBatch";
var $58dad493bd6ec980$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$58dad493bd6ec980$export$8fb31c0f05df007b]: true
            }
        });
var $58dad493bd6ec980$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $58dad493bd6ec980$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $58dad493bd6ec980$var$createQueueWithTimer(10);
var $58dad493bd6ec980$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $58dad493bd6ec980$var$rAF : options.type === "callback" ? options.queueNotification : $58dad493bd6ec980$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        var _action_meta;
                        notifying = !(action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta[$58dad493bd6ec980$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $58dad493bd6ec980$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options !== null && options !== void 0 ? options : {};
        let enhancerArray = new $58dad493bd6ec980$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($58dad493bd6ec980$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $58dad493bd6ec980$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $58dad493bd6ec980$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $ac44486100bacc69$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $ac44486100bacc69$export$66e4520cdb265d18)(reducer);
    else throw new Error($58dad493bd6ec980$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $ac44486100bacc69$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $58dad493bd6ec980$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $ac44486100bacc69$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $58dad493bd6ec980$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $ac44486100bacc69$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $58dad493bd6ec980$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $58dad493bd6ec980$var$isStateFunction(x) {
    return typeof x === "function";
}
function $58dad493bd6ec980$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $58dad493bd6ec980$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($58dad493bd6ec980$var$isStateFunction(initialState)) getInitialState = ()=>$58dad493bd6ec980$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $58dad493bd6ec980$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7b8b56f7aa848e1e$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $58dad493bd6ec980$var$matches = (matcher, action)=>{
    if ($58dad493bd6ec980$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $58dad493bd6ec980$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$58dad493bd6ec980$var$matches(matcher, action));
    };
}
function $58dad493bd6ec980$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$58dad493bd6ec980$var$matches(matcher, action));
    };
}
function $58dad493bd6ec980$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $58dad493bd6ec980$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $58dad493bd6ec980$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$872dec21e9a69476()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $58dad493bd6ec980$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $58dad493bd6ec980$export$9dd1fb32974da385($58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$fcc3388fb56de601()(asyncThunks[0]);
    return $58dad493bd6ec980$export$9dd1fb32974da385($58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $58dad493bd6ec980$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$1da80a6ef1307441()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $58dad493bd6ec980$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $58dad493bd6ec980$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $58dad493bd6ec980$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $58dad493bd6ec980$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $58dad493bd6ec980$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $58dad493bd6ec980$var$RejectWithValue = class {
    constructor(payload, meta){
        /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_type", void 0);
        this.payload = payload;
        this.meta = meta;
    }
};
var $58dad493bd6ec980$var$FulfillWithMeta = class {
    constructor(payload, meta){
        /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_type", void 0);
        this.payload = payload;
        this.meta = meta;
    }
};
var $58dad493bd6ec980$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $58dad493bd6ec980$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $58dad493bd6ec980$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $58dad493bd6ec980$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $58dad493bd6ec980$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        var _options_condition, _options_getPendingMeta;
                        let conditionResult = options === null || options === void 0 ? void 0 : (_options_condition = options.condition) === null || _options_condition === void 0 ? void 0 : _options_condition.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($58dad493bd6ec980$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options === null || options === void 0 ? void 0 : (_options_getPendingMeta = options.getPendingMeta) === null || _options_getPendingMeta === void 0 ? void 0 : _options_getPendingMeta.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $58dad493bd6ec980$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $58dad493bd6ec980$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $58dad493bd6ec980$var$RejectWithValue) throw result;
                                if (result instanceof $58dad493bd6ec980$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $58dad493bd6ec980$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($58dad493bd6ec980$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $58dad493bd6ec980$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $58dad493bd6ec980$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $58dad493bd6ec980$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $58dad493bd6ec980$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $58dad493bd6ec980$export$343355ed40c51c46 = {
    [$58dad493bd6ec980$var$asyncThunkSymbol]: $58dad493bd6ec980$export$6abd22dc03e5063f
};
var $58dad493bd6ec980$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($58dad493bd6ec980$export$23a094319a4b586 || {});
function $58dad493bd6ec980$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $58dad493bd6ec980$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _creators_asyncThunk;
    const cAT = creators === null || creators === void 0 ? void 0 : (_creators_asyncThunk = creators.asyncThunk) === null || _creators_asyncThunk === void 0 ? void 0 : _creators_asyncThunk[$58dad493bd6ec980$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(11));
        typeof $khNKv;
        const reducers = (typeof options.reducers === "function" ? options.reducers($58dad493bd6ec980$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $58dad493bd6ec980$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($58dad493bd6ec980$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $58dad493bd6ec980$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $58dad493bd6ec980$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $58dad493bd6ec980$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $58dad493bd6ec980$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $58dad493bd6ec980$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $58dad493bd6ec980$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        var _options_selectors;
                        for (const [name2, selector] of Object.entries((_options_selectors = options.selectors) !== null && _options_selectors !== void 0 ? _options_selectors : {}))map[name2] = $58dad493bd6ec980$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $58dad493bd6ec980$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $58dad493bd6ec980$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $58dad493bd6ec980$export$affdea4146de9cf5();
function $58dad493bd6ec980$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $58dad493bd6ec980$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$58dad493bd6ec980$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $58dad493bd6ec980$export$309c7a02b0b0bc62(type, prepareCallback) : $58dad493bd6ec980$export$309c7a02b0b0bc62(type));
}
function $58dad493bd6ec980$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $58dad493bd6ec980$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $58dad493bd6ec980$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $58dad493bd6ec980$var$noop,
        pending: pending || $58dad493bd6ec980$var$noop,
        rejected: rejected || $58dad493bd6ec980$var$noop,
        settled: settled || $58dad493bd6ec980$var$noop
    });
}
function $58dad493bd6ec980$var$noop() {}
// src/entities/entity_state.ts
function $58dad493bd6ec980$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $58dad493bd6ec980$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($58dad493bd6ec980$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $58dad493bd6ec980$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $58dad493bd6ec980$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $58dad493bd6ec980$var$isDraftTyped = (0, $7b8b56f7aa848e1e$export$541ac630993a4c84);
function $58dad493bd6ec980$var$createSingleArgumentStateOperator(mutator) {
    const operator = $58dad493bd6ec980$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $58dad493bd6ec980$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $58dad493bd6ec980$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($58dad493bd6ec980$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $58dad493bd6ec980$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $58dad493bd6ec980$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $58dad493bd6ec980$var$getCurrent(value) {
    return (0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(value) ? (0, $7b8b56f7aa848e1e$export$97aac956da55dae9)(value) : value;
}
function $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $58dad493bd6ec980$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $58dad493bd6ec980$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _updatesPerEntity_update_id;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...(_updatesPerEntity_update_id = updatesPerEntity[update.id]) === null || _updatesPerEntity_update_id === void 0 ? void 0 : _updatesPerEntity_update_id.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$58dad493bd6ec980$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $58dad493bd6ec980$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $58dad493bd6ec980$var$createStateOperator(addOneMutably),
        addMany: $58dad493bd6ec980$var$createStateOperator(addManyMutably),
        setOne: $58dad493bd6ec980$var$createStateOperator(setOneMutably),
        setMany: $58dad493bd6ec980$var$createStateOperator(setManyMutably),
        setAll: $58dad493bd6ec980$var$createStateOperator(setAllMutably),
        updateOne: $58dad493bd6ec980$var$createStateOperator(updateOneMutably),
        updateMany: $58dad493bd6ec980$var$createStateOperator(updateManyMutably),
        upsertOne: $58dad493bd6ec980$var$createStateOperator(upsertOneMutably),
        upsertMany: $58dad493bd6ec980$var$createStateOperator(upsertManyMutably),
        removeOne: $58dad493bd6ec980$var$createStateOperator(removeOneMutably),
        removeMany: $58dad493bd6ec980$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $58dad493bd6ec980$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $58dad493bd6ec980$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $58dad493bd6ec980$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $58dad493bd6ec980$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds !== null && existingIds !== void 0 ? existingIds : $58dad493bd6ec980$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($58dad493bd6ec980$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $58dad493bd6ec980$var$getCurrent(state.entities);
        const currentIds = $58dad493bd6ec980$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $58dad493bd6ec980$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $58dad493bd6ec980$var$createStateOperator(addOneMutably),
        updateOne: $58dad493bd6ec980$var$createStateOperator(updateOneMutably),
        upsertOne: $58dad493bd6ec980$var$createStateOperator(upsertOneMutably),
        setOne: $58dad493bd6ec980$var$createStateOperator(setOneMutably),
        setMany: $58dad493bd6ec980$var$createStateOperator(setManyMutably),
        setAll: $58dad493bd6ec980$var$createStateOperator(setAllMutably),
        addMany: $58dad493bd6ec980$var$createStateOperator(addManyMutably),
        updateMany: $58dad493bd6ec980$var$createStateOperator(updateManyMutably),
        upsertMany: $58dad493bd6ec980$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $58dad493bd6ec980$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $58dad493bd6ec980$var$createSortedStateAdapter(selectId, sortComparer) : $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $58dad493bd6ec980$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $58dad493bd6ec980$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $58dad493bd6ec980$var$task = "task";
var $58dad493bd6ec980$var$listener = "listener";
var $58dad493bd6ec980$var$completed = "completed";
var $58dad493bd6ec980$var$cancelled = "cancelled";
var $58dad493bd6ec980$var$taskCancelled = `task-${$58dad493bd6ec980$var$cancelled}`;
var $58dad493bd6ec980$var$taskCompleted = `task-${$58dad493bd6ec980$var$completed}`;
var $58dad493bd6ec980$var$listenerCancelled = `${$58dad493bd6ec980$var$listener}-${$58dad493bd6ec980$var$cancelled}`;
var $58dad493bd6ec980$var$listenerCompleted = `${$58dad493bd6ec980$var$listener}-${$58dad493bd6ec980$var$completed}`;
var $58dad493bd6ec980$export$cb1bdac908fed7f = class {
    constructor(code){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "name", "TaskAbortError");
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "message", void 0);
        this.code = code;
        this.message = `${$58dad493bd6ec980$var$task} ${$58dad493bd6ec980$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $58dad493bd6ec980$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($58dad493bd6ec980$export$378fa86b259c0280(32));
};
var $58dad493bd6ec980$var$noop2 = ()=>{};
var $58dad493bd6ec980$var$catchRejection = (promise, onError = $58dad493bd6ec980$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $58dad493bd6ec980$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $58dad493bd6ec980$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $58dad493bd6ec980$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $58dad493bd6ec980$export$cb1bdac908fed7f(reason);
    }
};
function $58dad493bd6ec980$var$raceWithSignal(signal, promise) {
    let cleanup = $58dad493bd6ec980$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $58dad493bd6ec980$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $58dad493bd6ec980$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $58dad493bd6ec980$var$noop2;
    });
}
var $58dad493bd6ec980$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $58dad493bd6ec980$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp === null || cleanUp === void 0 ? void 0 : cleanUp();
    }
};
var $58dad493bd6ec980$var$createPause = (signal)=>{
    return (promise)=>{
        return $58dad493bd6ec980$var$catchRejection($58dad493bd6ec980$var$raceWithSignal(signal, promise).then((output)=>{
            $58dad493bd6ec980$var$validateActive(signal);
            return output;
        }));
    };
};
var $58dad493bd6ec980$var$createDelay = (signal)=>{
    const pause = $58dad493bd6ec980$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $58dad493bd6ec980$var$assign } = Object;
var $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN = {};
var $58dad493bd6ec980$var$alm = "listenerMiddleware";
var $58dad493bd6ec980$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$58dad493bd6ec980$var$addAbortSignalListener(parentAbortSignal, ()=>$58dad493bd6ec980$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $58dad493bd6ec980$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $58dad493bd6ec980$var$runTask(async ()=>{
            $58dad493bd6ec980$var$validateActive(parentAbortSignal);
            $58dad493bd6ec980$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $58dad493bd6ec980$var$createPause(childAbortController.signal),
                delay: $58dad493bd6ec980$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $58dad493bd6ec980$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$58dad493bd6ec980$var$abortControllerWithReason(childAbortController, $58dad493bd6ec980$var$taskCompleted));
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($58dad493bd6ec980$var$noop2));
        return {
            result: $58dad493bd6ec980$var$createPause(parentAbortSignal)(result),
            cancel () {
                $58dad493bd6ec980$var$abortControllerWithReason(childAbortController, $58dad493bd6ec980$var$taskCancelled);
            }
        };
    };
};
var $58dad493bd6ec980$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $58dad493bd6ec980$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $58dad493bd6ec980$var$raceWithSignal(signal, Promise.race(promises));
            $58dad493bd6ec980$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$58dad493bd6ec980$var$catchRejection(take(predicate, timeout));
};
var $58dad493bd6ec980$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $58dad493bd6ec980$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($58dad493bd6ec980$export$378fa86b259c0280(21));
    $58dad493bd6ec980$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $58dad493bd6ec980$var$createListenerEntry = /* @__PURE__ */ $58dad493bd6ec980$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $58dad493bd6ec980$var$getListenerEntryPropsFrom(options);
    const id = $58dad493bd6ec980$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($58dad493bd6ec980$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$58dad493bd6ec980$var$createListenerEntry
});
var $58dad493bd6ec980$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $58dad493bd6ec980$var$abortControllerWithReason(controller, $58dad493bd6ec980$var$listenerCancelled);
    });
};
var $58dad493bd6ec980$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($58dad493bd6ec980$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $58dad493bd6ec980$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $58dad493bd6ec980$export$f03a6b845d3fb58b = /* @__PURE__ */ $58dad493bd6ec980$var$assign(/* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/add`), {
    withTypes: ()=>$58dad493bd6ec980$export$f03a6b845d3fb58b
});
var $58dad493bd6ec980$export$b1b8022855fb2b71 = /* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/removeAll`);
var $58dad493bd6ec980$export$b03e9483f936dccb = /* @__PURE__ */ $58dad493bd6ec980$var$assign(/* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/remove`), {
    withTypes: ()=>$58dad493bd6ec980$export$b03e9483f936dccb
});
var $58dad493bd6ec980$var$defaultErrorHandler = (...args)=>{
    console.error(`${$58dad493bd6ec980$var$alm}/error`, ...args);
};
var $58dad493bd6ec980$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $58dad493bd6ec980$var$defaultErrorHandler } = middlewareOptions;
    $58dad493bd6ec980$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $58dad493bd6ec980$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $58dad493bd6ec980$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $58dad493bd6ec980$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $58dad493bd6ec980$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $58dad493bd6ec980$var$getListenerEntryPropsFrom(options);
        const entry = $58dad493bd6ec980$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $58dad493bd6ec980$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $58dad493bd6ec980$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $58dad493bd6ec980$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $58dad493bd6ec980$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $58dad493bd6ec980$var$createDelay(internalTaskController.signal),
                pause: $58dad493bd6ec980$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $58dad493bd6ec980$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $58dad493bd6ec980$var$abortControllerWithReason(controller, $58dad493bd6ec980$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $58dad493bd6ec980$var$abortControllerWithReason(internalTaskController, $58dad493bd6ec980$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $58dad493bd6ec980$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $58dad493bd6ec980$export$cb1bdac908fed7f)) $58dad493bd6ec980$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $58dad493bd6ec980$var$abortControllerWithReason(internalTaskController, $58dad493bd6ec980$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $58dad493bd6ec980$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $ac44486100bacc69$export$b956e38827fca970)(action)) return next(action);
                if ($58dad493bd6ec980$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($58dad493bd6ec980$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($58dad493bd6ec980$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $58dad493bd6ec980$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $58dad493bd6ec980$var$createMiddlewareEntry = (middleware)=>({
        id: $58dad493bd6ec980$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $58dad493bd6ec980$var$matchInstance = (instanceId)=>(action)=>{
        var _action_meta;
        return (action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta.instanceId) === instanceId;
    };
var $58dad493bd6ec980$export$4bb1606a79445586 = ()=>{
    const instanceId = $58dad493bd6ec980$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($58dad493bd6ec980$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $58dad493bd6ec980$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $58dad493bd6ec980$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$58dad493bd6ec980$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $ac44486100bacc69$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $58dad493bd6ec980$export$9dd1fb32974da385(withMiddleware, $58dad493bd6ec980$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $58dad493bd6ec980$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $58dad493bd6ec980$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$58dad493bd6ec980$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $58dad493bd6ec980$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $58dad493bd6ec980$var$isStateProxy = (value)=>!!value && !!value[$58dad493bd6ec980$var$ORIGINAL_STATE];
var $58dad493bd6ec980$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $58dad493bd6ec980$var$createStateProxy = (state, reducerMap)=>$58dad493bd6ec980$var$emplace($58dad493bd6ec980$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $58dad493bd6ec980$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $58dad493bd6ec980$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($58dad493bd6ec980$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $58dad493bd6ec980$var$original = (state)=>{
    if (!$58dad493bd6ec980$var$isStateProxy(state)) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(25));
    return state[$58dad493bd6ec980$var$ORIGINAL_STATE];
};
var $58dad493bd6ec980$var$noopReducer = (state = {})=>state;
function $58dad493bd6ec980$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($58dad493bd6ec980$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $ac44486100bacc69$export$66e4520cdb265d18)(reducerMap) : $58dad493bd6ec980$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $khNKv;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($58dad493bd6ec980$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $58dad493bd6ec980$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $58dad493bd6ec980$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}



var $11OXI = parcelRequire("11OXI");
var $92a5db02d3c83225$exports = {};
"use strict";
var $92a5db02d3c83225$var$__createBinding = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92a5db02d3c83225$var$__setModuleDefault = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $92a5db02d3c83225$var$__importStar = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $92a5db02d3c83225$var$__createBinding(result, mod, k);
    }
    $92a5db02d3c83225$var$__setModuleDefault(result, mod);
    return result;
};
var $92a5db02d3c83225$var$__importDefault = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($92a5db02d3c83225$exports, "__esModule", {
    value: true
});
$92a5db02d3c83225$exports.debug = $92a5db02d3c83225$exports.parseScalabilityMode = $92a5db02d3c83225$exports.detectDevice = $92a5db02d3c83225$exports.Device = $92a5db02d3c83225$exports.version = $92a5db02d3c83225$exports.types = void 0;

const $92a5db02d3c83225$var$debug_1 = $92a5db02d3c83225$var$__importDefault((parcelRequire("8pLEx")));
$92a5db02d3c83225$exports.debug = $92a5db02d3c83225$var$debug_1.default;

var $46xMb = parcelRequire("46xMb");
Object.defineProperty($92a5db02d3c83225$exports, "Device", {
    enumerable: true,
    get: function() {
        return $46xMb.Device;
    }
});
Object.defineProperty($92a5db02d3c83225$exports, "detectDevice", {
    enumerable: true,
    get: function() {
        return $46xMb.detectDevice;
    }
});

const $92a5db02d3c83225$var$types = $92a5db02d3c83225$var$__importStar((parcelRequire("5Mrx3")));
$92a5db02d3c83225$exports.types = $92a5db02d3c83225$var$types;
/**
 * Expose mediasoup-client version.
 */ $92a5db02d3c83225$exports.version = "3.7.12";

var $2VyLC = parcelRequire("2VyLC");
Object.defineProperty($92a5db02d3c83225$exports, "parseScalabilityMode", {
    enumerable: true,
    get: function() {
        return $2VyLC.parse;
    }
});


/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
let $24d6efb1dadd4b9f$var$logDisabled_ = true;
let $24d6efb1dadd4b9f$var$deprecationWarnings_ = true;
function $24d6efb1dadd4b9f$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $24d6efb1dadd4b9f$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $24d6efb1dadd4b9f$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $24d6efb1dadd4b9f$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function $24d6efb1dadd4b9f$export$51516be4b019e41e(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $24d6efb1dadd4b9f$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $24d6efb1dadd4b9f$export$bef1f36f5486a6a3() {
    if (typeof window === "object") {
        if ($24d6efb1dadd4b9f$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
function $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$24d6efb1dadd4b9f$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function $24d6efb1dadd4b9f$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = "firefox";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = "safari";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $24d6efb1dadd4b9f$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $24d6efb1dadd4b9f$export$15384eac40dc88c8(data) {
    if (!$24d6efb1dadd4b9f$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $24d6efb1dadd4b9f$var$isObject(data[key]);
        const value = isObj ? $24d6efb1dadd4b9f$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $24d6efb1dadd4b9f$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $24d6efb1dadd4b9f$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $24d6efb1dadd4b9f$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $24d6efb1dadd4b9f$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $24d6efb1dadd4b9f$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $0f5f96d4bc674de6$exports = {};

$parcel$export($0f5f96d4bc674de6$exports, "shimMediaStream", function () { return $0f5f96d4bc674de6$export$33ee24e7a300bcd1; });
$parcel$export($0f5f96d4bc674de6$exports, "shimOnTrack", function () { return $0f5f96d4bc674de6$export$f358708f68ab068; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetSendersWithDtmf", function () { return $0f5f96d4bc674de6$export$a41a030a2842f5d6; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetStats", function () { return $0f5f96d4bc674de6$export$90608323826f0b17; });
$parcel$export($0f5f96d4bc674de6$exports, "shimSenderReceiverGetStats", function () { return $0f5f96d4bc674de6$export$f2f0f2338114eb4b; });
$parcel$export($0f5f96d4bc674de6$exports, "shimAddTrackRemoveTrackWithNative", function () { return $0f5f96d4bc674de6$export$30e3cdd46f8d5100; });
$parcel$export($0f5f96d4bc674de6$exports, "shimAddTrackRemoveTrack", function () { return $0f5f96d4bc674de6$export$9588259fcf4ebc91; });
$parcel$export($0f5f96d4bc674de6$exports, "shimPeerConnection", function () { return $0f5f96d4bc674de6$export$852a08dda9a55ea7; });
$parcel$export($0f5f96d4bc674de6$exports, "fixNegotiationNeeded", function () { return $0f5f96d4bc674de6$export$341293bbeaae37cb; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetUserMedia", function () { return $9a24537987145037$export$1ed4910f4d37dc5e; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetDisplayMedia", function () { return $924ae67a9c2d1ee2$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
const $9a24537987145037$var$logging = $24d6efb1dadd4b9f$export$bef1f36f5486a6a3;
function $9a24537987145037$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $9a24537987145037$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $9a24537987145037$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $924ae67a9c2d1ee2$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== "function") {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


"use strict";
function $0f5f96d4bc674de6$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $0f5f96d4bc674de6$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCPeerConnection && !("ontrack" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $0f5f96d4bc674de6$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === "object" && window.RTCPeerConnection && !("getSenders" in window.RTCPeerConnection.prototype) && "createDTMFSender" in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === "object" && window.RTCPeerConnection && "getSenders" in window.RTCPeerConnection.prototype && "createDTMFSender" in window.RTCPeerConnection.prototype && window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $0f5f96d4bc674de6$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === "function") return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: "local-candidate",
                        remotecandidate: "remote-candidate"
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $0f5f96d4bc674de6$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $24d6efb1dadd4b9f$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$24d6efb1dadd4b9f$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!("getStats" in window.RTCRtpSender.prototype && "getStats" in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $0f5f96d4bc674de6$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $0f5f96d4bc674de6$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $0f5f96d4bc674de6$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $0f5f96d4bc674de6$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $0f5f96d4bc674de6$export$341293bbeaae37cb(window, browserDetails) {
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}


var $c394a215b7aa1c4a$exports = {};

$parcel$export($c394a215b7aa1c4a$exports, "shimOnTrack", function () { return $c394a215b7aa1c4a$export$f358708f68ab068; });
$parcel$export($c394a215b7aa1c4a$exports, "shimPeerConnection", function () { return $c394a215b7aa1c4a$export$852a08dda9a55ea7; });
$parcel$export($c394a215b7aa1c4a$exports, "shimSenderGetStats", function () { return $c394a215b7aa1c4a$export$f0525502095c04ef; });
$parcel$export($c394a215b7aa1c4a$exports, "shimReceiverGetStats", function () { return $c394a215b7aa1c4a$export$83d69126527b1171; });
$parcel$export($c394a215b7aa1c4a$exports, "shimRemoveStream", function () { return $c394a215b7aa1c4a$export$825e523ef749bd8c; });
$parcel$export($c394a215b7aa1c4a$exports, "shimRTCDataChannel", function () { return $c394a215b7aa1c4a$export$ff9cb3bc8990e8f7; });
$parcel$export($c394a215b7aa1c4a$exports, "shimAddTransceiver", function () { return $c394a215b7aa1c4a$export$70c77533b6e9908d; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetParameters", function () { return $c394a215b7aa1c4a$export$66238223c298fbaa; });
$parcel$export($c394a215b7aa1c4a$exports, "shimCreateOffer", function () { return $c394a215b7aa1c4a$export$51beccf0e777b843; });
$parcel$export($c394a215b7aa1c4a$exports, "shimCreateAnswer", function () { return $c394a215b7aa1c4a$export$df0b46e7cef08150; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetUserMedia", function () { return $4f6e77f21e9dcaca$export$1ed4910f4d37dc5e; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetDisplayMedia", function () { return $575d447985d506b6$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
function $4f6e77f21e9dcaca$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $575d447985d506b6$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


"use strict";
function $c394a215b7aa1c4a$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c394a215b7aa1c4a$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== "object" || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c394a215b7aa1c4a$export$f0525502095c04ef(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c394a215b7aa1c4a$export$83d69126527b1171(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c394a215b7aa1c4a$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || "removeStream" in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c394a215b7aa1c4a$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $c394a215b7aa1c4a$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c394a215b7aa1c4a$export$66238223c298fbaa(window) {
    if (!(typeof window === "object" && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c394a215b7aa1c4a$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c394a215b7aa1c4a$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $beb18f76628524f9$exports = {};

$parcel$export($beb18f76628524f9$exports, "shimLocalStreamsAPI", function () { return $beb18f76628524f9$export$8df41282f4fdcea2; });
$parcel$export($beb18f76628524f9$exports, "shimRemoteStreamsAPI", function () { return $beb18f76628524f9$export$762aa4cbb4f2f857; });
$parcel$export($beb18f76628524f9$exports, "shimCallbacksAPI", function () { return $beb18f76628524f9$export$da31df245debdd3; });
$parcel$export($beb18f76628524f9$exports, "shimGetUserMedia", function () { return $beb18f76628524f9$export$1ed4910f4d37dc5e; });
$parcel$export($beb18f76628524f9$exports, "shimConstraints", function () { return $beb18f76628524f9$export$494a01ac68ba81ac; });
$parcel$export($beb18f76628524f9$exports, "shimRTCIceServerUrls", function () { return $beb18f76628524f9$export$671a8b47b41b6f41; });
$parcel$export($beb18f76628524f9$exports, "shimTrackEventTransceiver", function () { return $beb18f76628524f9$export$85d53da088cb1b14; });
$parcel$export($beb18f76628524f9$exports, "shimCreateOfferLegacy", function () { return $beb18f76628524f9$export$d444266503fdd2d4; });
$parcel$export($beb18f76628524f9$exports, "shimAudioContext", function () { return $beb18f76628524f9$export$857cd739a7b795d2; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
"use strict";
function $beb18f76628524f9$export$8df41282f4fdcea2(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getLocalStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $beb18f76628524f9$export$762aa4cbb4f2f857(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $beb18f76628524f9$export$da31df245debdd3(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $beb18f76628524f9$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($beb18f76628524f9$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $beb18f76628524f9$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $24d6efb1dadd4b9f$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $beb18f76628524f9$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $beb18f76628524f9$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $beb18f76628524f9$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio", {
                direction: "recvonly"
            });
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video", {
                direction: "recvonly"
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $beb18f76628524f9$export$857cd739a7b795d2(window) {
    if (typeof window !== "object" || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $73c182a18afe8a0b$exports = {};

$parcel$export($73c182a18afe8a0b$exports, "shimRTCIceCandidate", function () { return $73c182a18afe8a0b$export$cf133661e444ccfe; });
$parcel$export($73c182a18afe8a0b$exports, "shimRTCIceCandidateRelayProtocol", function () { return $73c182a18afe8a0b$export$fdafb8d8280e29b5; });
$parcel$export($73c182a18afe8a0b$exports, "shimMaxMessageSize", function () { return $73c182a18afe8a0b$export$a99147c78a56edc4; });
$parcel$export($73c182a18afe8a0b$exports, "shimSendThrowTypeError", function () { return $73c182a18afe8a0b$export$d461c8d5c5db5da7; });
$parcel$export($73c182a18afe8a0b$exports, "shimConnectionState", function () { return $73c182a18afe8a0b$export$63bb816cc75460; });
$parcel$export($73c182a18afe8a0b$exports, "removeExtmapAllowMixed", function () { return $73c182a18afe8a0b$export$a57d114344295149; });
$parcel$export($73c182a18afe8a0b$exports, "shimAddIceCandidateNullOrEmpty", function () { return $73c182a18afe8a0b$export$51d5e40b48c771c7; });
$parcel$export($73c182a18afe8a0b$exports, "shimParameterlessSetLocalDescription", function () { return $73c182a18afe8a0b$export$7170d04e59f9d553; });
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $7457294ed7ab71f3$exports = {};
/* eslint-env node */ "use strict";
// SDP helpers.
const $7457294ed7ab71f3$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$7457294ed7ab71f3$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$7457294ed7ab71f3$var$SDPUtils.localCName = $7457294ed7ab71f3$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$7457294ed7ab71f3$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$7457294ed7ab71f3$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split("\nm=");
    return parts.map((part, index)=>(index > 0 ? "m=" + part : part).trim() + "\r\n");
};
// Returns the session description.
$7457294ed7ab71f3$var$SDPUtils.getDescription = function(blob) {
    const sections = $7457294ed7ab71f3$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$7457294ed7ab71f3$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $7457294ed7ab71f3$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$7457294ed7ab71f3$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $7457294ed7ab71f3$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$7457294ed7ab71f3$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    const candidate = {
        foundation: parts[0],
        component: {
            1: "rtp",
            2: "rtcp"
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$7457294ed7ab71f3$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === "rtp") sdp.push(1);
    else if (component === "rtcp") sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$7457294ed7ab71f3$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(" ");
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$7457294ed7ab71f3$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(" ");
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$7457294ed7ab71f3$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1],
        attributes: parts.slice(2).join(" ")
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$7457294ed7ab71f3$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$7457294ed7ab71f3$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(" ") + 1).split(";");
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeFmtp = function(codec) {
    let line = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$7457294ed7ab71f3$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(" ");
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$7457294ed7ab71f3$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$7457294ed7ab71f3$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$7457294ed7ab71f3$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$7457294ed7ab71f3$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($7457294ed7ab71f3$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$7457294ed7ab71f3$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach((fp)=>{
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$7457294ed7ab71f3$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$7457294ed7ab71f3$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $7457294ed7ab71f3$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$7457294ed7ab71f3$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    const parts = keyParams.substring(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$7457294ed7ab71f3$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES parameters.
$7457294ed7ab71f3$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($7457294ed7ab71f3$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$7457294ed7ab71f3$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    const pwd = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$7457294ed7ab71f3$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
    if (params.iceLite) sdp += "a=ice-lite\r\n";
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$7457294ed7ab71f3$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            const codec = $7457294ed7ab71f3$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $7457294ed7ab71f3$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($7457294ed7ab71f3$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach((line)=>{
        description.headerExtensions.push($7457294ed7ab71f3$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:* ").map($7457294ed7ab71f3$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeRtpMap(codec);
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeFmtp(codec);
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$7457294ed7ab71f3$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $7457294ed7ab71f3$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === "cname");
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line)=>{
        const parts = line.substring(17).split(" ");
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$7457294ed7ab71f3$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === "cname")[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$7457294ed7ab71f3$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = "";
    if (rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
    if (rtcpParameters.mux) sdp += "a=rtcp-mux\r\n";
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$7457294ed7ab71f3$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === "msid");
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$7457294ed7ab71f3$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $7457294ed7ab71f3$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$7457294ed7ab71f3$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$7457294ed7ab71f3$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$7457294ed7ab71f3$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $7457294ed7ab71f3$var$SDPUtils.generateSessionId();
    const user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
// Gets the direction from the mediaSection or the sessionpart.
$7457294ed7ab71f3$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $7457294ed7ab71f3$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$7457294ed7ab71f3$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    return mline[0].substring(2);
};
$7457294ed7ab71f3$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$7457294ed7ab71f3$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$7457294ed7ab71f3$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    const parts = line.substring(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$7457294ed7ab71f3$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$7457294ed7ab71f3$exports = $7457294ed7ab71f3$var$SDPUtils;



"use strict";
function $73c182a18afe8a0b$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "foundation" in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $73c182a18afe8a0b$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "relayProtocol" in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === "relay") // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: "tls",
                1: "tcp",
                2: "udp"
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!("sctp" in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && "createDataChannel" in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $73c182a18afe8a0b$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || "connectionState" in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== "object" || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case "stable":
            case "have-local-offer":
            case "have-remote-pranswer":
                desc.type = "offer";
                break;
            default:
                desc.type = "answer";
                break;
        }
        if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $eda9b19400c11783$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $24d6efb1dadd4b9f$export$bef1f36f5486a6a3;
    const browserDetails = $24d6efb1dadd4b9f$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $73c182a18afe8a0b$exports,
        extractVersion: $24d6efb1dadd4b9f$export$e3c02be309be1f23,
        disableLog: $24d6efb1dadd4b9f$export$afbfee8cc06fd3e4,
        disableWarnings: $24d6efb1dadd4b9f$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $7457294ed7ab71f3$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$0f5f96d4bc674de6$exports || !$0f5f96d4bc674de6$exports.shimPeerConnection || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $0f5f96d4bc674de6$exports;
            // Must be called before shimPeerConnection.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetUserMedia(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimMediaStream(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimPeerConnection(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimOnTrack(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetSendersWithDtmf(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetStats(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimSenderReceiverGetStats(window, browserDetails);
            $0f5f96d4bc674de6$exports.fixNegotiationNeeded(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$fdafb8d8280e29b5(window, browserDetails);
            $73c182a18afe8a0b$export$63bb816cc75460(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails);
            break;
        case "firefox":
            if (!$c394a215b7aa1c4a$exports || !$c394a215b7aa1c4a$exports.shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c394a215b7aa1c4a$exports;
            // Must be called before shimPeerConnection.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimGetUserMedia(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimPeerConnection(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimOnTrack(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimRemoveStream(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimSenderGetStats(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimReceiverGetStats(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimRTCDataChannel(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimAddTransceiver(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimGetParameters(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimCreateOffer(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimCreateAnswer(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$63bb816cc75460(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case "safari":
            if (!$beb18f76628524f9$exports || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $beb18f76628524f9$exports;
            // Must be called before shimCallbackAPI.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $beb18f76628524f9$exports.shimRTCIceServerUrls(window, browserDetails);
            $beb18f76628524f9$exports.shimCreateOfferLegacy(window, browserDetails);
            $beb18f76628524f9$exports.shimCallbacksAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimLocalStreamsAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimRemoteStreamsAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimTrackEventTransceiver(window, browserDetails);
            $beb18f76628524f9$exports.shimGetUserMedia(window, browserDetails);
            $beb18f76628524f9$exports.shimAudioContext(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$fdafb8d8280e29b5(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}


"use strict";
const $c1c5c7a85a539550$var$adapter = (0, $eda9b19400c11783$export$e77bf46c04ac7d12)({
    window: typeof window === "undefined" ? undefined : window
});
var $c1c5c7a85a539550$export$2e2bcd8739ae039 = $c1c5c7a85a539550$var$adapter;


var $695e2205f7548c7a$exports = {};
"use strict";
// transforms a maplike to an object. Mostly for getStats +
// JSON.parse(JSON.stringify())
function $695e2205f7548c7a$var$map2obj(m) {
    if (!m.entries) return m;
    var o = {};
    m.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}
// apply a delta compression to the stats report. Reduces size by ~90%.
// To reduce further, report keys could be compressed.
function $695e2205f7548c7a$var$deltaCompression(oldStats, newStats) {
    newStats = JSON.parse(JSON.stringify(newStats));
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        delete report.id;
        if (!oldStats[id]) return;
        Object.keys(report).forEach(function(name) {
            if (report[name] === oldStats[id][name]) delete newStats[id][name];
            if (Object.keys(report).length === 0) delete newStats[id];
            else if (Object.keys(report).length === 1 && report.timestamp) delete newStats[id];
        });
    });
    var timestamp = -Infinity;
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        if (report.timestamp > timestamp) timestamp = report.timestamp;
    });
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        if (report.timestamp === timestamp) report.timestamp = 0;
    });
    newStats.timestamp = timestamp;
    return newStats;
}
function $695e2205f7548c7a$var$dumpStream(stream) {
    return {
        id: stream.id,
        tracks: stream.getTracks().map(function(track) {
            return {
                id: track.id,
                kind: track.kind,
                label: track.label,
                enabled: track.enabled,
                muted: track.muted,
                readyState: track.readyState
            };
        })
    };
}
/*
function filterBoringStats(results) {
  Object.keys(results).forEach(function(id) {
    switch (results[id].type) {
      case 'certificate':
      case 'codec':
        delete results[id];
        break;
      default:
        // noop
    }
  });
  return results;
}

function removeTimestamps(results) {
  // FIXME: does not work in FF since the timestamp can't be deleted.
  Object.keys(results).forEach(function(id) {
    delete results[id].timestamp;
  });
  return results;
}
*/ $695e2205f7548c7a$exports = function(trace, getStatsInterval, prefixesToWrap) {
    var peerconnectioncounter = 0;
    var isFirefox = !!window.mozRTCPeerConnection;
    var isEdge = !!window.RTCIceGatherer;
    var prevById = {};
    prefixesToWrap.forEach(function(prefix) {
        if (!window[prefix + "RTCPeerConnection"]) return;
        if (prefix === "webkit" && isEdge) // dont wrap webkitRTCPeerconnection in Edge.
        return;
        var origPeerConnection = window[prefix + "RTCPeerConnection"];
        var peerconnection = function(config, constraints) {
            var pc = new origPeerConnection(config, constraints);
            var id = "PC_" + peerconnectioncounter++;
            pc.__rtcStatsId = id;
            if (!config) config = {
                nullConfig: true
            };
            config = JSON.parse(JSON.stringify(config)); // deepcopy
            // don't log credentials
            (config && config.iceServers || []).forEach(function(server) {
                delete server.credential;
            });
            if (isFirefox) config.browserType = "moz";
            else if (isEdge) config.browserType = "edge";
            else config.browserType = "webkit";
            trace("create", id, config);
            // TODO: do we want to log constraints here? They are chrome-proprietary.
            // http://stackoverflow.com/questions/31003928/what-do-each-of-these-experimental-goog-rtcpeerconnectionconstraints-do
            if (constraints) trace("constraints", id, constraints);
            pc.addEventListener("icecandidate", function(e) {
                trace("onicecandidate", id, e.candidate);
            });
            pc.addEventListener("addstream", function(e) {
                trace("onaddstream", id, e.stream.id + " " + e.stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }));
            });
            pc.addEventListener("track", function(e) {
                trace("ontrack", id, e.track.kind + ":" + e.track.id + " " + e.streams.map(function(stream) {
                    return "stream:" + stream.id;
                }));
            });
            pc.addEventListener("removestream", function(e) {
                trace("onremovestream", id, e.stream.id + " " + e.stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }));
            });
            pc.addEventListener("signalingstatechange", function() {
                trace("onsignalingstatechange", id, pc.signalingState);
            });
            pc.addEventListener("iceconnectionstatechange", function() {
                trace("oniceconnectionstatechange", id, pc.iceConnectionState);
            });
            pc.addEventListener("icegatheringstatechange", function() {
                trace("onicegatheringstatechange", id, pc.iceGatheringState);
            });
            pc.addEventListener("connectionstatechange", function() {
                trace("onconnectionstatechange", id, pc.connectionState);
            });
            pc.addEventListener("negotiationneeded", function() {
                trace("onnegotiationneeded", id, undefined);
            });
            pc.addEventListener("datachannel", function(event) {
                trace("ondatachannel", id, [
                    event.channel.id,
                    event.channel.label
                ]);
            });
            var getStats = function() {
                pc.getStats(null).then(function(res) {
                    var now = $695e2205f7548c7a$var$map2obj(res);
                    var base = JSON.parse(JSON.stringify(now)); // our new prev
                    trace("getstats", id, $695e2205f7548c7a$var$deltaCompression(prevById[id] || {}, now));
                    prevById[id] = base;
                });
            };
            // TODO: do we want one big interval and all peerconnections
            //    queried in that or one setInterval per PC?
            //    we have to collect results anyway so...
            if (!isEdge && getStatsInterval) var interval = window.setInterval(function() {
                if (pc.signalingState === "closed") {
                    window.clearInterval(interval);
                    return;
                }
                getStats();
            }, getStatsInterval);
            if (!isEdge) pc.addEventListener("connectionstatechange", function() {
                if (pc.connectionState === "connected" || pc.connectionState === "failed") getStats();
            });
            return pc;
        };
        [
            "createDataChannel",
            "close"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                trace(method, this.__rtcStatsId, arguments);
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "addStream",
            "removeStream"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var stream = arguments[0];
                var streamInfo = stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }).join(",");
                trace(method, this.__rtcStatsId, stream.id + " " + streamInfo);
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "addTrack"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var track = arguments[0];
                var streams = [].slice.call(arguments, 1);
                trace(method, this.__rtcStatsId, track.kind + ":" + track.id + " " + (streams.map(function(s) {
                    return "stream:" + s.id;
                }).join(";") || "-"));
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "removeTrack"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var track = arguments[0].track;
                trace(method, this.__rtcStatsId, track ? track.kind + ":" + track.id : "null");
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "createOffer",
            "createAnswer"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var rtcStatsId = this.__rtcStatsId;
                var args = arguments;
                var opts;
                if (arguments.length === 1 && typeof arguments[0] === "object") opts = arguments[0];
                else if (arguments.length === 3 && typeof arguments[2] === "object") opts = arguments[2];
                trace(method, this.__rtcStatsId, opts);
                return nativeMethod.apply(this, opts ? [
                    opts
                ] : undefined).then(function(description) {
                    trace(method + "OnSuccess", rtcStatsId, description);
                    if (args.length > 0 && typeof args[0] === "function") {
                        args[0].apply(null, [
                            description
                        ]);
                        return undefined;
                    }
                    return description;
                }, function(err) {
                    trace(method + "OnFailure", rtcStatsId, err.toString());
                    if (args.length > 1 && typeof args[1] === "function") {
                        args[1].apply(null, [
                            err
                        ]);
                        return;
                    }
                    throw err;
                });
            };
        });
        [
            "setLocalDescription",
            "setRemoteDescription",
            "addIceCandidate"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var rtcStatsId = this.__rtcStatsId;
                var args = arguments;
                trace(method, this.__rtcStatsId, args[0]);
                return nativeMethod.apply(this, [
                    args[0]
                ]).then(function() {
                    trace(method + "OnSuccess", rtcStatsId, undefined);
                    if (args.length >= 2 && typeof args[1] === "function") {
                        args[1].apply(null, []);
                        return undefined;
                    }
                    return undefined;
                }, function(err) {
                    trace(method + "OnFailure", rtcStatsId, err.toString());
                    if (args.length >= 3 && typeof args[2] === "function") {
                        args[2].apply(null, [
                            err
                        ]);
                        return undefined;
                    }
                    throw err;
                });
            };
        });
        // wrap static methods. Currently just generateCertificate.
        if (origPeerConnection.generateCertificate) Object.defineProperty(peerconnection, "generateCertificate", {
            get: function() {
                return arguments.length ? origPeerConnection.generateCertificate.apply(null, arguments) : origPeerConnection.generateCertificate;
            }
        });
        window[prefix + "RTCPeerConnection"] = peerconnection;
        window[prefix + "RTCPeerConnection"].prototype = origPeerConnection.prototype;
    });
    // getUserMedia wrappers
    prefixesToWrap.forEach(function(prefix) {
        var name = prefix + (prefix.length ? "GetUserMedia" : "getUserMedia");
        if (!navigator[name]) return;
        var origGetUserMedia = navigator[name].bind(navigator);
        var gum = function() {
            trace("getUserMedia", null, arguments[0]);
            var cb = arguments[1];
            var eb = arguments[2];
            origGetUserMedia(arguments[0], function(stream) {
                // we log the stream id, track ids and tracks readystate since that is ended GUM fails
                // to acquire the cam (in chrome)
                trace("getUserMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                if (cb) cb(stream);
            }, function(err) {
                trace("getUserMediaOnFailure", null, err.name);
                if (eb) eb(err);
            });
        };
        navigator[name] = gum.bind(navigator);
    });
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        var gum = function() {
            trace("navigator.mediaDevices.getUserMedia", null, arguments[0]);
            return origGetUserMedia.apply(navigator.mediaDevices, arguments).then(function(stream) {
                trace("navigator.mediaDevices.getUserMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                return stream;
            }, function(err) {
                trace("navigator.mediaDevices.getUserMediaOnFailure", null, err.name);
                return Promise.reject(err);
            });
        };
        navigator.mediaDevices.getUserMedia = gum.bind(navigator.mediaDevices);
    }
    // getDisplayMedia
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        var origGetDisplayMedia = navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);
        var gdm = function() {
            trace("navigator.mediaDevices.getDisplayMedia", null, arguments[0]);
            return origGetDisplayMedia.apply(navigator.mediaDevices, arguments).then(function(stream) {
                trace("navigator.mediaDevices.getDisplayMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                return stream;
            }, function(err) {
                trace("navigator.mediaDevices.getDisplayMediaOnFailure", null, err.name);
                return Promise.reject(err);
            });
        };
        navigator.mediaDevices.getDisplayMedia = gdm.bind(navigator.mediaDevices);
    }
    // TODO: are there events defined on MST that would allow us to listen when enabled was set?
    //    no :-(
    /*
  Object.defineProperty(MediaStreamTrack.prototype, 'enabled', {
    set: function(value) {
      trace('MediaStreamTrackEnable', this, value);
    }
  });
  */ return {
        resetDelta () {
            prevById = {};
        }
    };
};


const $742fefc0f61b4bae$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $742fefc0f61b4bae$export$2e2bcd8739ae039 = {
    randomUUID: $742fefc0f61b4bae$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $f70786181090564b$var$getRandomValues;
const $f70786181090564b$var$rnds8 = new Uint8Array(16);
function $f70786181090564b$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$f70786181090564b$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $f70786181090564b$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$f70786181090564b$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $f70786181090564b$var$getRandomValues($f70786181090564b$var$rnds8);
}


var $bba49c18feaefd33$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $ea12533c10c1a23d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bba49c18feaefd33$export$2e2bcd8739ae039).test(uuid);
}
var $ea12533c10c1a23d$export$2e2bcd8739ae039 = $ea12533c10c1a23d$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5b80c61add9baf5e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5b80c61add9baf5e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5b80c61add9baf5e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5b80c61add9baf5e$var$byteToHex[arr[offset + 0]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 1]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 2]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 3]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 4]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 5]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 6]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 7]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 8]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 9]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 10]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 11]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 12]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 13]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 14]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 15]];
}
function $5b80c61add9baf5e$var$stringify(arr, offset = 0) {
    const uuid = $5b80c61add9baf5e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ea12533c10c1a23d$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5b80c61add9baf5e$export$2e2bcd8739ae039 = $5b80c61add9baf5e$var$stringify;


function $e247db96f48d686a$var$v4(options, buf, offset) {
    if ((0, $742fefc0f61b4bae$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $742fefc0f61b4bae$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $f70786181090564b$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5b80c61add9baf5e$export$8fb373d660548968)(rnds);
}
var $e247db96f48d686a$export$2e2bcd8739ae039 = $e247db96f48d686a$var$v4;




var $8j7qr = parcelRequire("8j7qr");
var $fcb6503f150ed464$exports = {};
"use strict";
var $fcb6503f150ed464$var$__createBinding = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fcb6503f150ed464$var$__setModuleDefault = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fcb6503f150ed464$var$__importStar = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fcb6503f150ed464$var$__createBinding(result, mod, k);
    }
    $fcb6503f150ed464$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fcb6503f150ed464$exports, "__esModule", {
    value: true
});
$fcb6503f150ed464$exports.v6 = $fcb6503f150ed464$exports.AddressError = $fcb6503f150ed464$exports.Address6 = $fcb6503f150ed464$exports.Address4 = void 0;
var $c27123c5c1023f74$exports = {};
"use strict";
/* eslint-disable no-param-reassign */ var $c27123c5c1023f74$var$__createBinding = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c27123c5c1023f74$var$__setModuleDefault = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c27123c5c1023f74$var$__importStar = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c27123c5c1023f74$var$__createBinding(result, mod, k);
    }
    $c27123c5c1023f74$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c27123c5c1023f74$exports, "__esModule", {
    value: true
});
$c27123c5c1023f74$exports.Address4 = void 0;

const $c27123c5c1023f74$var$common = $c27123c5c1023f74$var$__importStar((parcelRequire("23jSE")));

const $c27123c5c1023f74$var$constants = $c27123c5c1023f74$var$__importStar((parcelRequire("i0ccS")));
var $6a3bc47ac964004c$exports = {};
"use strict";
Object.defineProperty($6a3bc47ac964004c$exports, "__esModule", {
    value: true
});
$6a3bc47ac964004c$exports.AddressError = void 0;
class $6a3bc47ac964004c$var$AddressError extends Error {
    constructor(message, parseMessage){
        super(message);
        this.name = "AddressError";
        if (parseMessage !== null) this.parseMessage = parseMessage;
    }
}
$6a3bc47ac964004c$exports.AddressError = $6a3bc47ac964004c$var$AddressError;



var $cqjLs = parcelRequire("cqjLs");

var $krCXC = parcelRequire("krCXC");
/**
 * Represents an IPv4 address
 * @class Address4
 * @param {string} address - An IPv4 address string
 */ class $c27123c5c1023f74$var$Address4 {
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $c27123c5c1023f74$var$Address4(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /*
     * Parses a v4 address
     */ parse(address) {
        const groups = address.split(".");
        if (!address.match($c27123c5c1023f74$var$constants.RE_ADDRESS)) throw new $6a3bc47ac964004c$exports.AddressError("Invalid IPv4 address.");
        return groups;
    }
    /**
     * Returns the correct form of an address
     * @memberof Address4
     * @instance
     * @returns {String}
     */ correctForm() {
        return this.parsedAddress.map((part)=>parseInt(part, 10)).join(".");
    }
    /**
     * Converts a hex string to an IPv4 address object
     * @memberof Address4
     * @static
     * @param {string} hex - a hex string to convert
     * @returns {Address4}
     */ static fromHex(hex) {
        const padded = hex.replace(/:/g, "").padStart(8, "0");
        const groups = [];
        let i;
        for(i = 0; i < 8; i += 2){
            const h = padded.slice(i, i + 2);
            groups.push(parseInt(h, 16));
        }
        return new $c27123c5c1023f74$var$Address4(groups.join("."));
    }
    /**
     * Converts an integer into a IPv4 address object
     * @memberof Address4
     * @static
     * @param {integer} integer - a number to convert
     * @returns {Address4}
     */ static fromInteger(integer) {
        return $c27123c5c1023f74$var$Address4.fromHex(integer.toString(16));
    }
    /**
     * Return an address from in-addr.arpa form
     * @memberof Address4
     * @static
     * @param {string} arpaFormAddress - an 'in-addr.arpa' form ipv4 address
     * @returns {Adress4}
     * @example
     * var address = Address4.fromArpa(42.2.0.192.in-addr.arpa.)
     * address.correctForm(); // '192.0.2.42'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".in-addr.arpa." or just "."
        const leader = arpaFormAddress.replace(/(\.in-addr\.arpa)?\.$/, "");
        const address = leader.split(".").reverse().join(".");
        return new $c27123c5c1023f74$var$Address4(address);
    }
    /**
     * Converts an IPv4 address object to a hex string
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toHex() {
        return this.parsedAddress.map((part)=>(0, $krCXC.sprintf)("%02x", parseInt(part, 10))).join(":");
    }
    /**
     * Converts an IPv4 address object to an array of bytes
     * @memberof Address4
     * @instance
     * @returns {Array}
     */ toArray() {
        return this.parsedAddress.map((part)=>parseInt(part, 10));
    }
    /**
     * Converts an IPv4 address object to an IPv6 address group
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toGroup6() {
        const output = [];
        let i;
        for(i = 0; i < $c27123c5c1023f74$var$constants.GROUPS; i += 2){
            const hex = (0, $krCXC.sprintf)("%02x%02x", parseInt(this.parsedAddress[i], 10), parseInt(this.parsedAddress[i + 1], 10));
            output.push((0, $krCXC.sprintf)("%x", parseInt(hex, 16)));
        }
        return output.join(":");
    }
    /**
     * Returns the address as a BigInteger
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new $cqjLs.BigInteger(this.parsedAddress.map((n)=>(0, $krCXC.sprintf)("%02x", parseInt(n, 10))).join(""), 16);
    }
    /**
     * Helper function getting start address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new $cqjLs.BigInteger(this.mask() + "0".repeat($c27123c5c1023f74$var$constants.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet.
     * Often referred to as the Network Address.
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddress() {
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new $cqjLs.BigInteger(this.mask() + "1".repeat($c27123c5c1023f74$var$constants.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddress() {
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Converts a BigInteger to a v4 address object
     * @memberof Address4
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address4}
     */ static fromBigInteger(bigInteger) {
        return $c27123c5c1023f74$var$Address4.fromInteger(parseInt(bigInteger.toString(), 10));
    }
    /**
     * Returns the first n bits of the address, defaulting to the
     * subnet mask
     * @memberof Address4
     * @instance
     * @returns {String}
     */ mask(mask) {
        if (mask === undefined) mask = this.subnetMask;
        return this.getBitsBase2(0, mask);
    }
    /**
     * Returns the bits in the given range as a base-2 string
     * @memberof Address4
     * @instance
     * @returns {string}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address4
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "in-addr.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const reversed = this.correctForm().split(".").reverse().join(".");
        if (options.omitSuffix) return reversed;
        return (0, $krCXC.sprintf)("%s.in-addr.arpa.", reversed);
    }
    /**
     * Returns true if the given address is a multicast address
     * @memberof Address4
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.isInSubnet(new $c27123c5c1023f74$var$Address4("224.0.0.0/4"));
    }
    /**
     * Returns a zero-padded base-2 string representation of the address
     * @memberof Address4
     * @instance
     * @returns {string}
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($c27123c5c1023f74$var$constants.BITS, "0");
    }
    /**
     * Groups an IPv4 address for inclusion at the end of an IPv6 address
     * @returns {String}
     */ groupForV6() {
        const segments = this.parsedAddress;
        return this.address.replace($c27123c5c1023f74$var$constants.RE_ADDRESS, (0, $krCXC.sprintf)('<span class="hover-group group-v4 group-6">%s</span>.<span class="hover-group group-v4 group-7">%s</span>', segments.slice(0, 2).join("."), segments.slice(2, 4).join(".")));
    }
    constructor(address){
        this.groups = $c27123c5c1023f74$var$constants.GROUPS;
        this.parsedAddress = [];
        this.parsedSubnet = "";
        this.subnet = "/32";
        this.subnetMask = 32;
        this.v4 = true;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address4
         * @instance
         * @returns {Boolean}
         */ this.isCorrect = $c27123c5c1023f74$var$common.isCorrect($c27123c5c1023f74$var$constants.BITS);
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address4
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $c27123c5c1023f74$var$common.isInSubnet;
        this.address = address;
        const subnet = $c27123c5c1023f74$var$constants.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (this.subnetMask < 0 || this.subnetMask > $c27123c5c1023f74$var$constants.BITS) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
            address = address.replace($c27123c5c1023f74$var$constants.RE_SUBNET_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(address);
    }
}
$c27123c5c1023f74$exports.Address4 = $c27123c5c1023f74$var$Address4;


Object.defineProperty($fcb6503f150ed464$exports, "Address4", {
    enumerable: true,
    get: function() {
        return $c27123c5c1023f74$exports.Address4;
    }
});
var $2c67d28ffe370a60$exports = {};
"use strict";
/* eslint-disable prefer-destructuring */ /* eslint-disable no-param-reassign */ var $2c67d28ffe370a60$var$__createBinding = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c67d28ffe370a60$var$__setModuleDefault = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2c67d28ffe370a60$var$__importStar = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c67d28ffe370a60$var$__createBinding(result, mod, k);
    }
    $2c67d28ffe370a60$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2c67d28ffe370a60$exports, "__esModule", {
    value: true
});
$2c67d28ffe370a60$exports.Address6 = void 0;

const $2c67d28ffe370a60$var$common = $2c67d28ffe370a60$var$__importStar((parcelRequire("23jSE")));

const $2c67d28ffe370a60$var$constants4 = $2c67d28ffe370a60$var$__importStar((parcelRequire("i0ccS")));

const $2c67d28ffe370a60$var$constants6 = $2c67d28ffe370a60$var$__importStar((parcelRequire("oXAYb")));

const $2c67d28ffe370a60$var$helpers = $2c67d28ffe370a60$var$__importStar((parcelRequire("1Q0Pv")));

var $f28c18019c39fdf0$exports = {};
"use strict";
var $f28c18019c39fdf0$var$__createBinding = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f28c18019c39fdf0$var$__setModuleDefault = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f28c18019c39fdf0$var$__importStar = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f28c18019c39fdf0$var$__createBinding(result, mod, k);
    }
    $f28c18019c39fdf0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f28c18019c39fdf0$exports, "__esModule", {
    value: true
});
$f28c18019c39fdf0$exports.possibleElisions = $f28c18019c39fdf0$exports.simpleRegularExpression = $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY = $f28c18019c39fdf0$exports.padGroup = $f28c18019c39fdf0$exports.groupPossibilities = void 0;

const $f28c18019c39fdf0$var$v6 = $f28c18019c39fdf0$var$__importStar((parcelRequire("oXAYb")));

var $krCXC = parcelRequire("krCXC");
function $f28c18019c39fdf0$var$groupPossibilities(possibilities) {
    return (0, $krCXC.sprintf)("(%s)", possibilities.join("|"));
}
$f28c18019c39fdf0$exports.groupPossibilities = $f28c18019c39fdf0$var$groupPossibilities;
function $f28c18019c39fdf0$var$padGroup(group) {
    if (group.length < 4) return (0, $krCXC.sprintf)("0{0,%d}%s", 4 - group.length, group);
    return group;
}
$f28c18019c39fdf0$exports.padGroup = $f28c18019c39fdf0$var$padGroup;
$f28c18019c39fdf0$exports.ADDRESS_BOUNDARY = "[^A-Fa-f0-9:]";
function $f28c18019c39fdf0$var$simpleRegularExpression(groups) {
    const zeroIndexes = [];
    groups.forEach((group, i)=>{
        const groupInteger = parseInt(group, 16);
        if (groupInteger === 0) zeroIndexes.push(i);
    });
    // You can technically elide a single 0, this creates the regular expressions
    // to match that eventuality
    const possibilities = zeroIndexes.map((zeroIndex)=>groups.map((group, i)=>{
            if (i === zeroIndex) {
                const elision = i === 0 || i === $f28c18019c39fdf0$var$v6.GROUPS - 1 ? ":" : "";
                return $f28c18019c39fdf0$var$groupPossibilities([
                    $f28c18019c39fdf0$var$padGroup(group),
                    elision
                ]);
            }
            return $f28c18019c39fdf0$var$padGroup(group);
        }).join(":"));
    // The simplest case
    possibilities.push(groups.map($f28c18019c39fdf0$var$padGroup).join(":"));
    return $f28c18019c39fdf0$var$groupPossibilities(possibilities);
}
$f28c18019c39fdf0$exports.simpleRegularExpression = $f28c18019c39fdf0$var$simpleRegularExpression;
function $f28c18019c39fdf0$var$possibleElisions(elidedGroups, moreLeft, moreRight) {
    const left = moreLeft ? "" : ":";
    const right = moreRight ? "" : ":";
    const possibilities = [];
    // 1. elision of everything (::)
    if (!moreLeft && !moreRight) possibilities.push("::");
    // 2. complete elision of the middle
    if (moreLeft && moreRight) possibilities.push("");
    if (moreRight && !moreLeft || !moreRight && moreLeft) // 3. complete elision of one side
    possibilities.push(":");
    // 4. elision from the left side
    possibilities.push((0, $krCXC.sprintf)("%s(:0{1,4}){1,%d}", left, elidedGroups - 1));
    // 5. elision from the right side
    possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){1,%d}%s", elidedGroups - 1, right));
    // 6. no elision
    possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){%d}0{1,4}", elidedGroups - 1));
    // 7. elision (including sloppy elision) from the middle
    for(let groups = 1; groups < elidedGroups - 1; groups++)for(let position = 1; position < elidedGroups - groups; position++)possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){%d}:(0{1,4}:){%d}0{1,4}", position, elidedGroups - position - groups - 1));
    return $f28c18019c39fdf0$var$groupPossibilities(possibilities);
}
$f28c18019c39fdf0$exports.possibleElisions = $f28c18019c39fdf0$var$possibleElisions;




var $cqjLs = parcelRequire("cqjLs");

var $krCXC = parcelRequire("krCXC");
function $2c67d28ffe370a60$var$assert(condition) {
    if (!condition) throw new Error("Assertion failed.");
}
function $2c67d28ffe370a60$var$addCommas(number) {
    const r = /(\d+)(\d{3})/;
    while(r.test(number))number = number.replace(r, "$1,$2");
    return number;
}
function $2c67d28ffe370a60$var$spanLeadingZeroes4(n) {
    n = n.replace(/^(0{1,})([1-9]+)$/, '<span class="parse-error">$1</span>$2');
    n = n.replace(/^(0{1,})(0)$/, '<span class="parse-error">$1</span>$2');
    return n;
}
/*
 * A helper function to compact an array
 */ function $2c67d28ffe370a60$var$compact(address, slice) {
    const s1 = [];
    const s2 = [];
    let i;
    for(i = 0; i < address.length; i++){
        if (i < slice[0]) s1.push(address[i]);
        else if (i > slice[1]) s2.push(address[i]);
    }
    return s1.concat([
        "compact"
    ]).concat(s2);
}
function $2c67d28ffe370a60$var$paddedHex(octet) {
    return (0, $krCXC.sprintf)("%04x", parseInt(octet, 16));
}
function $2c67d28ffe370a60$var$unsignByte(b) {
    // eslint-disable-next-line no-bitwise
    return b & 0xff;
}
/**
 * Represents an IPv6 address
 * @class Address6
 * @param {string} address - An IPv6 address string
 * @param {number} [groups=8] - How many octets to parse
 * @example
 * var address = new Address6('2001::/32');
 */ class $2c67d28ffe370a60$var$Address6 {
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $2c67d28ffe370a60$var$Address6(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
     * Convert a BigInteger to a v6 address object
     * @memberof Address6
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address6}
     * @example
     * var bigInteger = new BigInteger('1000000000000');
     * var address = Address6.fromBigInteger(bigInteger);
     * address.correctForm(); // '::e8:d4a5:1000'
     */ static fromBigInteger(bigInteger) {
        const hex = bigInteger.toString(16).padStart(32, "0");
        const groups = [];
        let i;
        for(i = 0; i < $2c67d28ffe370a60$var$constants6.GROUPS; i++)groups.push(hex.slice(i * 4, (i + 1) * 4));
        return new $2c67d28ffe370a60$var$Address6(groups.join(":"));
    }
    /**
     * Convert a URL (with optional port number) to an address object
     * @memberof Address6
     * @static
     * @param {string} url - a URL with optional port number
     * @example
     * var addressAndPort = Address6.fromURL('http://[ffff::]:8080/foo/');
     * addressAndPort.address.correctForm(); // 'ffff::'
     * addressAndPort.port; // 8080
     */ static fromURL(url) {
        let host;
        let port = null;
        let result;
        // If we have brackets parse them and find a port
        if (url.indexOf("[") !== -1 && url.indexOf("]:") !== -1) {
            result = $2c67d28ffe370a60$var$constants6.RE_URL_WITH_PORT.exec(url);
            if (result === null) return {
                error: "failed to parse address with port",
                address: null,
                port: null
            };
            host = result[1];
            port = result[2];
        // If there's a URL extract the address
        } else if (url.indexOf("/") !== -1) {
            // Remove the protocol prefix
            url = url.replace(/^[a-z0-9]+:\/\//, "");
            // Parse the address
            result = $2c67d28ffe370a60$var$constants6.RE_URL.exec(url);
            if (result === null) return {
                error: "failed to parse address from URL",
                address: null,
                port: null
            };
            host = result[1];
        // Otherwise just assign the URL to the host and let the library parse it
        } else host = url;
        // If there's a port convert it to an integer
        if (port) {
            port = parseInt(port, 10);
            // squelch out of range ports
            if (port < 0 || port > 65536) port = null;
        } else // Standardize `undefined` to `null`
        port = null;
        return {
            address: new $2c67d28ffe370a60$var$Address6(host),
            port: port
        };
    }
    /**
     * Create an IPv6-mapped address given an IPv4 address
     * @memberof Address6
     * @static
     * @param {string} address - An IPv4 address string
     * @returns {Address6}
     * @example
     * var address = Address6.fromAddress4('192.168.0.1');
     * address.correctForm(); // '::ffff:c0a8:1'
     * address.to4in6(); // '::ffff:192.168.0.1'
     */ static fromAddress4(address) {
        const address4 = new $c27123c5c1023f74$exports.Address4(address);
        const mask6 = $2c67d28ffe370a60$var$constants6.BITS - ($2c67d28ffe370a60$var$constants4.BITS - address4.subnetMask);
        return new $2c67d28ffe370a60$var$Address6(`::ffff:${address4.correctForm()}/${mask6}`);
    }
    /**
     * Return an address from ip6.arpa form
     * @memberof Address6
     * @static
     * @param {string} arpaFormAddress - an 'ip6.arpa' form address
     * @returns {Adress6}
     * @example
     * var address = Address6.fromArpa(e.f.f.f.3.c.2.6.f.f.f.e.6.6.8.e.1.0.6.7.9.4.e.c.0.0.0.0.1.0.0.2.ip6.arpa.)
     * address.correctForm(); // '2001:0:ce49:7601:e866:efff:62c3:fffe'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".ip6.arpa." or just "."
        let address = arpaFormAddress.replace(/(\.ip6\.arpa)?\.$/, "");
        const semicolonAmount = 7;
        // correct ip6.arpa form with ending removed will be 63 characters
        if (address.length !== 63) throw new $6a3bc47ac964004c$exports.AddressError("Invalid 'ip6.arpa' form.");
        const parts = address.split(".").reverse();
        for(let i = semicolonAmount; i > 0; i--){
            const insertIndex = i * 4;
            parts.splice(insertIndex, 0, ":");
        }
        address = parts.join("");
        return new $2c67d28ffe370a60$var$Address6(address);
    }
    /**
     * Return the Microsoft UNC transcription of the address
     * @memberof Address6
     * @instance
     * @returns {String} the Microsoft UNC transcription of the address
     */ microsoftTranscription() {
        return (0, $krCXC.sprintf)("%s.ipv6-literal.net", this.correctForm().replace(/:/g, "-"));
    }
    /**
     * Return the first n bits of the address, defaulting to the subnet mask
     * @memberof Address6
     * @instance
     * @param {number} [mask=subnet] - the number of bits to mask
     * @returns {String} the first n bits of the address as a string
     */ mask(mask = this.subnetMask) {
        return this.getBitsBase2(0, mask);
    }
    /**
     * Return the number of possible subnets of a given size in the address
     * @memberof Address6
     * @instance
     * @param {number} [size=128] - the subnet size
     * @returns {String}
     */ // TODO: probably useful to have a numeric version of this too
    possibleSubnets(subnetSize = 128) {
        const availableBits = $2c67d28ffe370a60$var$constants6.BITS - this.subnetMask;
        const subnetBits = Math.abs(subnetSize - $2c67d28ffe370a60$var$constants6.BITS);
        const subnetPowers = availableBits - subnetBits;
        if (subnetPowers < 0) return "0";
        return $2c67d28ffe370a60$var$addCommas(new $cqjLs.BigInteger("2", 10).pow(subnetPowers).toString(10));
    }
    /**
     * Helper function getting start address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new $cqjLs.BigInteger(this.mask() + "0".repeat($2c67d28ffe370a60$var$constants6.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet
     * Often referred to as the Network Address.
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddress() {
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new $cqjLs.BigInteger(this.mask() + "1".repeat($2c67d28ffe370a60$var$constants6.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddress() {
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Return the scope of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getScope() {
        let scope = $2c67d28ffe370a60$var$constants6.SCOPES[this.getBits(12, 16).intValue()];
        if (this.getType() === "Global unicast" && scope !== "Link local") scope = "Global";
        return scope || "Unknown";
    }
    /**
     * Return the type of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getType() {
        for (const subnet of Object.keys($2c67d28ffe370a60$var$constants6.TYPES)){
            if (this.isInSubnet(new $2c67d28ffe370a60$var$Address6(subnet))) return $2c67d28ffe370a60$var$constants6.TYPES[subnet];
        }
        return "Global unicast";
    }
    /**
     * Return the bits in the given range as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ getBits(start, end) {
        return new $cqjLs.BigInteger(this.getBitsBase2(start, end), 2);
    }
    /**
     * Return the bits in the given range as a base-2 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the bits in the given range as a base-16 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase16(start, end) {
        const length = end - start;
        if (length % 4 !== 0) throw new Error("Length of bits to retrieve must be divisible by four");
        return this.getBits(start, end).toString(16).padStart(length / 4, "0");
    }
    /**
     * Return the bits that are set past the subnet mask length
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsPastSubnet() {
        return this.getBitsBase2(this.subnetMask, $2c67d28ffe370a60$var$constants6.BITS);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address6
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "ip6.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const characters = Math.floor(this.subnetMask / 4);
        const reversed = this.canonicalForm().replace(/:/g, "").split("").slice(0, characters).reverse().join(".");
        if (characters > 0) {
            if (options.omitSuffix) return reversed;
            return (0, $krCXC.sprintf)("%s.ip6.arpa.", reversed);
        }
        if (options.omitSuffix) return "";
        return "ip6.arpa.";
    }
    /**
     * Return the correct form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ correctForm() {
        let i;
        let groups = [];
        let zeroCounter = 0;
        const zeroes = [];
        for(i = 0; i < this.parsedAddress.length; i++){
            const value = parseInt(this.parsedAddress[i], 16);
            if (value === 0) zeroCounter++;
            if (value !== 0 && zeroCounter > 0) {
                if (zeroCounter > 1) zeroes.push([
                    i - zeroCounter,
                    i - 1
                ]);
                zeroCounter = 0;
            }
        }
        // Do we end with a string of zeroes?
        if (zeroCounter > 1) zeroes.push([
            this.parsedAddress.length - zeroCounter,
            this.parsedAddress.length - 1
        ]);
        const zeroLengths = zeroes.map((n)=>n[1] - n[0] + 1);
        if (zeroes.length > 0) {
            const index = zeroLengths.indexOf(Math.max(...zeroLengths));
            groups = $2c67d28ffe370a60$var$compact(this.parsedAddress, zeroes[index]);
        } else groups = this.parsedAddress;
        for(i = 0; i < groups.length; i++)if (groups[i] !== "compact") groups[i] = parseInt(groups[i], 16).toString(16);
        let correct = groups.join(":");
        correct = correct.replace(/^compact$/, "::");
        correct = correct.replace(/^compact|compact$/, ":");
        correct = correct.replace(/compact/, "");
        return correct;
    }
    /**
     * Return a zero-padded base-2 string representation of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     * @example
     * var address = new Address6('2001:4860:4001:803::1011');
     * address.binaryZeroPad();
     * // '0010000000000001010010000110000001000000000000010000100000000011
     * //  0000000000000000000000000000000000000000000000000001000000010001'
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($2c67d28ffe370a60$var$constants6.BITS, "0");
    }
    // TODO: Improve the semantics of this helper function
    parse4in6(address) {
        const groups = address.split(":");
        const lastGroup = groups.slice(-1)[0];
        const address4 = lastGroup.match($2c67d28ffe370a60$var$constants4.RE_ADDRESS);
        if (address4) {
            this.parsedAddress4 = address4[0];
            this.address4 = new $c27123c5c1023f74$exports.Address4(this.parsedAddress4);
            for(let i = 0; i < this.address4.groups; i++){
                if (/^0[0-9]+/.test(this.address4.parsedAddress[i])) throw new $6a3bc47ac964004c$exports.AddressError("IPv4 addresses can't have leading zeroes.", address.replace($2c67d28ffe370a60$var$constants4.RE_ADDRESS, this.address4.parsedAddress.map($2c67d28ffe370a60$var$spanLeadingZeroes4).join(".")));
            }
            this.v4 = true;
            groups[groups.length - 1] = this.address4.toGroup6();
            address = groups.join(":");
        }
        return address;
    }
    // TODO: Make private?
    parse(address) {
        address = this.parse4in6(address);
        const badCharacters = address.match($2c67d28ffe370a60$var$constants6.RE_BAD_CHARACTERS);
        if (badCharacters) throw new $6a3bc47ac964004c$exports.AddressError((0, $krCXC.sprintf)("Bad character%s detected in address: %s", badCharacters.length > 1 ? "s" : "", badCharacters.join("")), address.replace($2c67d28ffe370a60$var$constants6.RE_BAD_CHARACTERS, '<span class="parse-error">$1</span>'));
        const badAddress = address.match($2c67d28ffe370a60$var$constants6.RE_BAD_ADDRESS);
        if (badAddress) throw new $6a3bc47ac964004c$exports.AddressError((0, $krCXC.sprintf)("Address failed regex: %s", badAddress.join("")), address.replace($2c67d28ffe370a60$var$constants6.RE_BAD_ADDRESS, '<span class="parse-error">$1</span>'));
        let groups = [];
        const halves = address.split("::");
        if (halves.length === 2) {
            let first = halves[0].split(":");
            let last = halves[1].split(":");
            if (first.length === 1 && first[0] === "") first = [];
            if (last.length === 1 && last[0] === "") last = [];
            const remaining = this.groups - (first.length + last.length);
            if (!remaining) throw new $6a3bc47ac964004c$exports.AddressError("Error parsing groups");
            this.elidedGroups = remaining;
            this.elisionBegin = first.length;
            this.elisionEnd = first.length + this.elidedGroups;
            groups = groups.concat(first);
            for(let i = 0; i < remaining; i++)groups.push("0");
            groups = groups.concat(last);
        } else if (halves.length === 1) {
            groups = address.split(":");
            this.elidedGroups = 0;
        } else throw new $6a3bc47ac964004c$exports.AddressError("Too many :: groups found");
        groups = groups.map((group)=>(0, $krCXC.sprintf)("%x", parseInt(group, 16)));
        if (groups.length !== this.groups) throw new $6a3bc47ac964004c$exports.AddressError("Incorrect number of groups found");
        return groups;
    }
    /**
     * Return the canonical form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ canonicalForm() {
        return this.parsedAddress.map($2c67d28ffe370a60$var$paddedHex).join(":");
    }
    /**
     * Return the decimal form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ decimal() {
        return this.parsedAddress.map((n)=>(0, $krCXC.sprintf)("%05d", parseInt(n, 16))).join(":");
    }
    /**
     * Return the address as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new $cqjLs.BigInteger(this.parsedAddress.map($2c67d28ffe370a60$var$paddedHex).join(""), 16);
    }
    /**
     * Return the last two groups of this address as an IPv4 address string
     * @memberof Address6
     * @instance
     * @returns {Address4}
     * @example
     * var address = new Address6('2001:4860:4001::1825:bf11');
     * address.to4().correctForm(); // '24.37.191.17'
     */ to4() {
        const binary = this.binaryZeroPad().split("");
        return $c27123c5c1023f74$exports.Address4.fromHex(new $cqjLs.BigInteger(binary.slice(96, 128).join(""), 2).toString(16));
    }
    /**
     * Return the v4-in-v6 form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ to4in6() {
        const address4 = this.to4();
        const address6 = new $2c67d28ffe370a60$var$Address6(this.parsedAddress.slice(0, 6).join(":"), 6);
        const correct = address6.correctForm();
        let infix = "";
        if (!/:$/.test(correct)) infix = ":";
        return correct + infix + address4.address;
    }
    /**
     * Return an object containing the Teredo properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspectTeredo() {
        /*
        - Bits 0 to 31 are set to the Teredo prefix (normally 2001:0000::/32).
        - Bits 32 to 63 embed the primary IPv4 address of the Teredo server that
          is used.
        - Bits 64 to 79 can be used to define some flags. Currently only the
          higher order bit is used; it is set to 1 if the Teredo client is
          located behind a cone NAT, 0 otherwise. For Microsoft's Windows Vista
          and Windows Server 2008 implementations, more bits are used. In those
          implementations, the format for these 16 bits is "CRAAAAUG AAAAAAAA",
          where "C" remains the "Cone" flag. The "R" bit is reserved for future
          use. The "U" bit is for the Universal/Local flag (set to 0). The "G" bit
          is Individual/Group flag (set to 0). The A bits are set to a 12-bit
          randomly generated number chosen by the Teredo client to introduce
          additional protection for the Teredo node against IPv6-based scanning
          attacks.
        - Bits 80 to 95 contains the obfuscated UDP port number. This is the
          port number that is mapped by the NAT to the Teredo client with all
          bits inverted.
        - Bits 96 to 127 contains the obfuscated IPv4 address. This is the
          public IPv4 address of the NAT with all bits inverted.
        */ const prefix = this.getBitsBase16(0, 32);
        const udpPort = this.getBits(80, 96).xor(new $cqjLs.BigInteger("ffff", 16)).toString();
        const server4 = $c27123c5c1023f74$exports.Address4.fromHex(this.getBitsBase16(32, 64));
        const client4 = $c27123c5c1023f74$exports.Address4.fromHex(this.getBits(96, 128).xor(new $cqjLs.BigInteger("ffffffff", 16)).toString(16));
        const flags = this.getBits(64, 80);
        const flagsBase2 = this.getBitsBase2(64, 80);
        const coneNat = flags.testBit(15);
        const reserved = flags.testBit(14);
        const groupIndividual = flags.testBit(8);
        const universalLocal = flags.testBit(9);
        const nonce = new $cqjLs.BigInteger(flagsBase2.slice(2, 6) + flagsBase2.slice(8, 16), 2).toString(10);
        return {
            prefix: (0, $krCXC.sprintf)("%s:%s", prefix.slice(0, 4), prefix.slice(4, 8)),
            server4: server4.address,
            client4: client4.address,
            flags: flagsBase2,
            coneNat: coneNat,
            microsoft: {
                reserved: reserved,
                universalLocal: universalLocal,
                groupIndividual: groupIndividual,
                nonce: nonce
            },
            udpPort: udpPort
        };
    }
    /**
     * Return an object containing the 6to4 properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspect6to4() {
        /*
        - Bits 0 to 15 are set to the 6to4 prefix (2002::/16).
        - Bits 16 to 48 embed the IPv4 address of the 6to4 gateway that is used.
        */ const prefix = this.getBitsBase16(0, 16);
        const gateway = $c27123c5c1023f74$exports.Address4.fromHex(this.getBitsBase16(16, 48));
        return {
            prefix: (0, $krCXC.sprintf)("%s", prefix.slice(0, 4)),
            gateway: gateway.address
        };
    }
    /**
     * Return a v6 6to4 address from a v6 v4inv6 address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ to6to4() {
        if (!this.is4()) return null;
        const addr6to4 = [
            "2002",
            this.getBitsBase16(96, 112),
            this.getBitsBase16(112, 128),
            "",
            "/16"
        ].join(":");
        return new $2c67d28ffe370a60$var$Address6(addr6to4);
    }
    /**
     * Return a byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toByteArray() {
        const byteArray = this.bigInteger().toByteArray();
        // work around issue where `toByteArray` returns a leading 0 element
        if (byteArray.length === 17 && byteArray[0] === 0) return byteArray.slice(1);
        return byteArray;
    }
    /**
     * Return an unsigned byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toUnsignedByteArray() {
        return this.toByteArray().map($2c67d28ffe370a60$var$unsignByte);
    }
    /**
     * Convert a byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromByteArray(bytes) {
        return this.fromUnsignedByteArray(bytes.map($2c67d28ffe370a60$var$unsignByte));
    }
    /**
     * Convert an unsigned byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromUnsignedByteArray(bytes) {
        const BYTE_MAX = new $cqjLs.BigInteger("256", 10);
        let result = new $cqjLs.BigInteger("0", 10);
        let multiplier = new $cqjLs.BigInteger("1", 10);
        for(let i = bytes.length - 1; i >= 0; i--){
            result = result.add(multiplier.multiply(new $cqjLs.BigInteger(bytes[i].toString(10), 10)));
            multiplier = multiplier.multiply(BYTE_MAX);
        }
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(result);
    }
    /**
     * Returns true if the address is in the canonical form, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isCanonical() {
        return this.addressMinusSuffix === this.canonicalForm();
    }
    /**
     * Returns true if the address is a link local address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLinkLocal() {
        // Zeroes are required, i.e. we can't check isInSubnet with 'fe80::/10'
        if (this.getBitsBase2(0, 64) === "1111111010000000000000000000000000000000000000000000000000000000") return true;
        return false;
    }
    /**
     * Returns true if the address is a multicast address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.getType() === "Multicast";
    }
    /**
     * Returns true if the address is a v4-in-v6 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is4() {
        return this.v4;
    }
    /**
     * Returns true if the address is a Teredo address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isTeredo() {
        return this.isInSubnet(new $2c67d28ffe370a60$var$Address6("2001::/32"));
    }
    /**
     * Returns true if the address is a 6to4 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is6to4() {
        return this.isInSubnet(new $2c67d28ffe370a60$var$Address6("2002::/16"));
    }
    /**
     * Returns true if the address is a loopback address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLoopback() {
        return this.getType() === "Loopback";
    }
    // #endregion
    // #region HTML
    /**
     * @returns {String} the address in link form with a default port of 80
     */ href(optionalPort) {
        if (optionalPort === undefined) optionalPort = "";
        else optionalPort = (0, $krCXC.sprintf)(":%s", optionalPort);
        return (0, $krCXC.sprintf)("http://[%s]%s/", this.correctForm(), optionalPort);
    }
    /**
     * @returns {String} a link suitable for conveying the address via a URL hash
     */ link(options) {
        if (!options) options = {};
        if (options.className === undefined) options.className = "";
        if (options.prefix === undefined) options.prefix = "/#address=";
        if (options.v4 === undefined) options.v4 = false;
        let formFunction = this.correctForm;
        if (options.v4) formFunction = this.to4in6;
        if (options.className) return (0, $krCXC.sprintf)('<a href="%1$s%2$s" class="%3$s">%2$s</a>', options.prefix, formFunction.call(this), options.className);
        return (0, $krCXC.sprintf)('<a href="%1$s%2$s">%2$s</a>', options.prefix, formFunction.call(this));
    }
    /**
     * Groups an address
     * @returns {String}
     */ group() {
        if (this.elidedGroups === 0) // The simple case
        return $2c67d28ffe370a60$var$helpers.simpleGroup(this.address).join(":");
        $2c67d28ffe370a60$var$assert(typeof this.elidedGroups === "number");
        $2c67d28ffe370a60$var$assert(typeof this.elisionBegin === "number");
        // The elided case
        const output = [];
        const [left, right] = this.address.split("::");
        if (left.length) output.push(...$2c67d28ffe370a60$var$helpers.simpleGroup(left));
        else output.push("");
        const classes = [
            "hover-group"
        ];
        for(let i = this.elisionBegin; i < this.elisionBegin + this.elidedGroups; i++)classes.push((0, $krCXC.sprintf)("group-%d", i));
        output.push((0, $krCXC.sprintf)('<span class="%s"></span>', classes.join(" ")));
        if (right.length) output.push(...$2c67d28ffe370a60$var$helpers.simpleGroup(right, this.elisionEnd));
        else output.push("");
        if (this.is4()) {
            $2c67d28ffe370a60$var$assert(this.address4 instanceof $c27123c5c1023f74$exports.Address4);
            output.pop();
            output.push(this.address4.groupForV6());
        }
        return output.join(":");
    }
    // #endregion
    // #region Regular expressions
    /**
     * Generate a regular expression string that can be used to find or validate
     * all variations of this address
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {string}
     */ regularExpressionString(substringSearch = false) {
        let output = [];
        // TODO: revisit why this is necessary
        const address6 = new $2c67d28ffe370a60$var$Address6(this.correctForm());
        if (address6.elidedGroups === 0) // The simple case
        output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(address6.parsedAddress));
        else if (address6.elidedGroups === $2c67d28ffe370a60$var$constants6.GROUPS) // A completely elided address
        output.push((0, $f28c18019c39fdf0$exports.possibleElisions)($2c67d28ffe370a60$var$constants6.GROUPS));
        else {
            // A partially elided address
            const halves = address6.address.split("::");
            if (halves[0].length) output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(halves[0].split(":")));
            $2c67d28ffe370a60$var$assert(typeof address6.elidedGroups === "number");
            output.push((0, $f28c18019c39fdf0$exports.possibleElisions)(address6.elidedGroups, halves[0].length !== 0, halves[1].length !== 0));
            if (halves[1].length) output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(halves[1].split(":")));
            output = [
                output.join(":")
            ];
        }
        if (!substringSearch) output = [
            "(?=^|",
            $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY,
            "|[^\\w\\:])(",
            ...output,
            ")(?=[^\\w\\:]|",
            $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY,
            "|$)"
        ];
        return output.join("");
    }
    /**
     * Generate a regular expression that can be used to find or validate all
     * variations of this address.
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {RegExp}
     */ regularExpression(substringSearch = false) {
        return new RegExp(this.regularExpressionString(substringSearch), "i");
    }
    constructor(address, optionalGroups){
        this.addressMinusSuffix = "";
        this.parsedSubnet = "";
        this.subnet = "/128";
        this.subnetMask = 128;
        this.v4 = false;
        this.zone = "";
        // #region Attributes
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $2c67d28ffe370a60$var$common.isInSubnet;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isCorrect = $2c67d28ffe370a60$var$common.isCorrect($2c67d28ffe370a60$var$constants6.BITS);
        if (optionalGroups === undefined) this.groups = $2c67d28ffe370a60$var$constants6.GROUPS;
        else this.groups = optionalGroups;
        this.address = address;
        const subnet = $2c67d28ffe370a60$var$constants6.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (Number.isNaN(this.subnetMask) || this.subnetMask < 0 || this.subnetMask > $2c67d28ffe370a60$var$constants6.BITS) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
            address = address.replace($2c67d28ffe370a60$var$constants6.RE_SUBNET_STRING, "");
        } else if (/\//.test(address)) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
        const zone = $2c67d28ffe370a60$var$constants6.RE_ZONE_STRING.exec(address);
        if (zone) {
            this.zone = zone[0];
            address = address.replace($2c67d28ffe370a60$var$constants6.RE_ZONE_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(this.addressMinusSuffix);
    }
}
$2c67d28ffe370a60$exports.Address6 = $2c67d28ffe370a60$var$Address6;


Object.defineProperty($fcb6503f150ed464$exports, "Address6", {
    enumerable: true,
    get: function() {
        return $2c67d28ffe370a60$exports.Address6;
    }
});

Object.defineProperty($fcb6503f150ed464$exports, "AddressError", {
    enumerable: true,
    get: function() {
        return $6a3bc47ac964004c$exports.AddressError;
    }
});

const $fcb6503f150ed464$var$helpers = $fcb6503f150ed464$var$__importStar((parcelRequire("1Q0Pv")));
$fcb6503f150ed464$exports.v6 = {
    helpers: $fcb6503f150ed464$var$helpers
};


var $1ecbb2f73dbf2ce4$exports = {};
// Validation tool for IP addresses
var $36e3ec6447eae890$exports = {};

var $1nZXs = parcelRequire("1nZXs");
$36e3ec6447eae890$exports = $36e3ec6447eae890$var$check_many_cidrs;
function $36e3ec6447eae890$var$check_many_cidrs(addr, range) {
    if (typeof range === "string") return $36e3ec6447eae890$var$check_single_cidr(addr, range);
    else if (typeof range === "object") {
        var ip_is_in_range = false;
        for(var i = 0; i < range.length; i++)if ($36e3ec6447eae890$var$check_single_cidr(addr, range[i])) {
            ip_is_in_range = true;
            break;
        }
        return ip_is_in_range;
    }
}
function $36e3ec6447eae890$var$check_single_cidr(addr, cidr) {
    try {
        var parsed_addr = $1nZXs.process(addr);
        if (cidr.indexOf("/") === -1) {
            var parsed_cidr_as_ip = $1nZXs.process(cidr);
            if (parsed_addr.kind() === "ipv6" && parsed_cidr_as_ip.kind() === "ipv6") return parsed_addr.toNormalizedString() === parsed_cidr_as_ip.toNormalizedString();
            return parsed_addr.toString() == parsed_cidr_as_ip.toString();
        } else {
            var parsed_range = $1nZXs.parseCIDR(cidr);
            return parsed_addr.match(parsed_range);
        }
    } catch (e) {
        return false;
    }
}


var $1ecbb2f73dbf2ce4$var$validRegEx = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
// Bogons list from http://www.team-cymru.org/bogon-reference.html
var $1ecbb2f73dbf2ce4$var$bogonsArray = [
    "0.0.0.0/8",
    "10.0.0.0/8",
    "100.64.0.0/10",
    "127.0.0.0/8",
    "169.254.0.0/16",
    "172.16.0.0/12",
    "192.0.0.0/24",
    "192.0.2.0/24",
    "192.168.0.0/16",
    "198.18.0.0/15",
    "198.51.100.0/24",
    "203.0.113.0/24",
    "224.0.0.0/3"
];
// Private IP list.  Common RFC1918 IP addresses from https://tools.ietf.org/html/rfc1918
var $1ecbb2f73dbf2ce4$var$privateIpArray = [
    "10.0.0.0/8",
    "172.16.0.0/12",
    "192.168.0.0/16"
];
function $1ecbb2f73dbf2ce4$var$checkIp(ip) {
    // Set originalIp and reset other properties of answer.
    var boiledArray = [];
    var answer = {
        originalIp: ip,
        boiledIp: false,
        isValid: false,
        isBogon: false,
        isApipa: false,
        isMulticast: false,
        isRfc1918: false,
        isPublicIp: false
    };
    // Check to see if it is valid as per RegEx.
    if ($1ecbb2f73dbf2ce4$var$validRegEx.test(ip)) {
        answer.isValid = true;
        // Boil off any leading zeros in each octet.
        var octet = ip.split(".");
        for(var i = 0; i < 4; i++)boiledArray.push(parseInt(octet[i], 10));
        answer.boiledIp = boiledArray.join(".");
        // Check to see if it is on the bogons list.
        if ($36e3ec6447eae890$exports(answer.boiledIp, $1ecbb2f73dbf2ce4$var$bogonsArray)) answer.isBogon = true;
        // Check to see if IP address is an Automatic Private IP Addressing (APIPA aka auto-IP) IP.
        if ($36e3ec6447eae890$exports(answer.boiledIp, "169.254.0.0/16")) answer.isApipa = true;
        // Check to see if the IP address is a Multicast IP.
        if ($36e3ec6447eae890$exports(answer.boiledIp, "224.0.0.0/4")) answer.isMulticast = true;
        // Check to see if it is a public IP or private IP (RFC 1918).
        if ($36e3ec6447eae890$exports(answer.boiledIp, $1ecbb2f73dbf2ce4$var$privateIpArray)) answer.isRfc1918 = true;
        else if (answer.isBogon === false) answer.isPublicIp = true;
    }
    return answer;
}
$1ecbb2f73dbf2ce4$exports = $1ecbb2f73dbf2ce4$var$checkIp;


var $8c12fcb2a8b6be0e$exports = {};
// Regular expression used for basic parsing of the uuid.

var $437dT = parcelRequire("437dT");
var $8c12fcb2a8b6be0e$require$Buffer = $437dT.Buffer;
var $8c12fcb2a8b6be0e$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8c12fcb2a8b6be0e$var$_byteToHex = [];
for(var $8c12fcb2a8b6be0e$var$i = 0; $8c12fcb2a8b6be0e$var$i < 256; $8c12fcb2a8b6be0e$var$i++)$8c12fcb2a8b6be0e$var$_byteToHex[$8c12fcb2a8b6be0e$var$i] = ($8c12fcb2a8b6be0e$var$i + 0x100).toString(16).substr(1);
function $8c12fcb2a8b6be0e$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8c12fcb2a8b6be0e$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ $8c12fcb2a8b6be0e$exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8c12fcb2a8b6be0e$require$Buffer.isBuffer(uuid)) parsedUuid = $8c12fcb2a8b6be0e$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === "[object String]") parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8c12fcb2a8b6be0e$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8c12fcb2a8b6be0e$var$extractVersion(parsedUuid);
    else if ($8c12fcb2a8b6be0e$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                "8",
                "9",
                "a",
                "b"
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error("Invalid version provided.");
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8c12fcb2a8b6be0e$var$extractVersion = $8c12fcb2a8b6be0e$exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};


parcelRequire("9KvBE");
var $35Pvm = parcelRequire("35Pvm");

var $fbuXh = parcelRequire("fbuXh");
const $9a1c38584fe7f3e8$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();


function $0f4dd0cd5703ae1b$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $0f4dd0cd5703ae1b$var$NATIVE_SET_TIMEOUT = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).setTimeout;
const $0f4dd0cd5703ae1b$var$NATIVE_CLEAR_TIMEOUT = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).clearTimeout;
function $0f4dd0cd5703ae1b$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $0f4dd0cd5703ae1b$var$NATIVE_SET_TIMEOUT.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
        obj.clearTimeoutFn = $0f4dd0cd5703ae1b$var$NATIVE_CLEAR_TIMEOUT.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).setTimeout.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).clearTimeout.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $0f4dd0cd5703ae1b$var$BASE64_OVERHEAD = 1.33;
function $0f4dd0cd5703ae1b$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $0f4dd0cd5703ae1b$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $0f4dd0cd5703ae1b$var$BASE64_OVERHEAD);
}
function $0f4dd0cd5703ae1b$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $e01fce6500821742$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $e01fce6500821742$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $cefdafcabb98fcd0$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $cefdafcabb98fcd0$export$86495b081fef8e52 extends (0, $fbuXh.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $cefdafcabb98fcd0$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $35Pvm.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $e01fce6500821742$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}


// imported from https://github.com/unshiftio/yeast
"use strict";
const $0d4d25cab9a512e7$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $0d4d25cab9a512e7$var$length = 64, $0d4d25cab9a512e7$var$map = {};
let $0d4d25cab9a512e7$var$seed = 0, $0d4d25cab9a512e7$var$i = 0, $0d4d25cab9a512e7$var$prev;
function $0d4d25cab9a512e7$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $0d4d25cab9a512e7$var$alphabet[num % $0d4d25cab9a512e7$var$length] + encoded;
        num = Math.floor(num / $0d4d25cab9a512e7$var$length);
    }while (num > 0);
    return encoded;
}
function $0d4d25cab9a512e7$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($0d4d25cab9a512e7$var$i = 0; $0d4d25cab9a512e7$var$i < str.length; $0d4d25cab9a512e7$var$i++)decoded = decoded * $0d4d25cab9a512e7$var$length + $0d4d25cab9a512e7$var$map[str.charAt($0d4d25cab9a512e7$var$i)];
    return decoded;
}
function $0d4d25cab9a512e7$export$5bb64b92cb4135a() {
    const now = $0d4d25cab9a512e7$export$c564cdbbe6da493(+new Date());
    if (now !== $0d4d25cab9a512e7$var$prev) return $0d4d25cab9a512e7$var$seed = 0, $0d4d25cab9a512e7$var$prev = now;
    return now + "." + $0d4d25cab9a512e7$export$c564cdbbe6da493($0d4d25cab9a512e7$var$seed++);
}
//
// Map each character to its index.
//
for(; $0d4d25cab9a512e7$var$i < $0d4d25cab9a512e7$var$length; $0d4d25cab9a512e7$var$i++)$0d4d25cab9a512e7$var$map[$0d4d25cab9a512e7$var$alphabet[$0d4d25cab9a512e7$var$i]] = $0d4d25cab9a512e7$var$i;



var $9KvBE = parcelRequire("9KvBE");
// browser shim for xmlhttprequest module
// imported from https://github.com/component/has-cors
let $10a6ce9dbae11e7c$var$value = false;
try {
    $10a6ce9dbae11e7c$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $10a6ce9dbae11e7c$export$5235bbd4a1ef06e = $10a6ce9dbae11e7c$var$value;



function $9488728f5c331e33$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $10a6ce9dbae11e7c$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $9a1c38584fe7f3e8$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $9488728f5c331e33$export$19413efcf2fac759() {}



var $fbuXh = parcelRequire("fbuXh");


function $804e4955c9378a4f$var$empty() {}
const $804e4955c9378a4f$var$hasXHR2 = function() {
    const xhr = new (0, $9488728f5c331e33$export$a2d42eb087c10497)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $804e4955c9378a4f$export$265ee5eefd4c309b extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $9KvBE.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $9KvBE.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $0d4d25cab9a512e7$export$5bb64b92cb4135a)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $804e4955c9378a4f$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $804e4955c9378a4f$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $9488728f5c331e33$export$19413efcf2fac759)();
    }
}
class $804e4955c9378a4f$export$7fa6c5b6f8193917 extends (0, $fbuXh.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $0f4dd0cd5703ae1b$export$357523c63a2253b9)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $9488728f5c331e33$export$a2d42eb087c10497)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $804e4955c9378a4f$export$7fa6c5b6f8193917.requestsCount++;
            $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $804e4955c9378a4f$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$804e4955c9378a4f$export$7fa6c5b6f8193917.requestsCount = 0;
$804e4955c9378a4f$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $804e4955c9378a4f$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $9a1c38584fe7f3e8$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $804e4955c9378a4f$var$unloadHandler, false);
    }
}
function $804e4955c9378a4f$var$unloadHandler() {
    for(let i in $804e4955c9378a4f$export$7fa6c5b6f8193917.requests)if ($804e4955c9378a4f$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[i].abort();
}






const $0eaf8a89e59b3e47$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $0eaf8a89e59b3e47$export$3909fb301d3dc8c9 = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).WebSocket || (0, $9a1c38584fe7f3e8$export$394f9358f6231289).MozWebSocket;
const $0eaf8a89e59b3e47$export$3407ba5dfb7a683d = true;
const $0eaf8a89e59b3e47$export$790dcbc41e2d75d5 = "arraybuffer";


parcelRequire("9KvBE");
var $eB3mK = parcelRequire("eB3mK");

var $437dT = parcelRequire("437dT");
var $c63f89971b2ce9c8$require$Buffer = $437dT.Buffer;
// detect ReactNative environment
const $c63f89971b2ce9c8$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $c63f89971b2ce9c8$export$911baa0677ac404c extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $c63f89971b2ce9c8$var$isReactNative ? {} : (0, $0f4dd0cd5703ae1b$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d) && !$c63f89971b2ce9c8$var$isReactNative ? protocols ? new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri, protocols) : new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri) : new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eB3mK.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $c63f89971b2ce9c8$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $0d4d25cab9a512e7$export$5bb64b92cb4135a)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}





var $9KvBE = parcelRequire("9KvBE");
class $81251642ec6d652f$export$961c930859384407 extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $9KvBE.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $9KvBE.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}


const $9f93f040f63ed139$export$46dec00755c1153b = {
    websocket: (0, $c63f89971b2ce9c8$export$911baa0677ac404c),
    webtransport: (0, $81251642ec6d652f$export$961c930859384407),
    polling: (0, $804e4955c9378a4f$export$265ee5eefd4c309b)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $e71afb3c28816696$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $e71afb3c28816696$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $e71afb3c28816696$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $e71afb3c28816696$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$e71afb3c28816696$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $e71afb3c28816696$var$pathNames(uri, uri["path"]);
    uri.queryKey = $e71afb3c28816696$var$queryKey(uri, uri["query"]);
    return uri;
}
function $e71afb3c28816696$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $e71afb3c28816696$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}



var $fbuXh = parcelRequire("fbuXh");

var $9KvBE = parcelRequire("9KvBE");

class $515dcfe1978ff794$export$4798917dbf149b79 extends (0, $fbuXh.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $9KvBE.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $9f93f040f63ed139$export$46dec00755c1153b)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $0f4dd0cd5703ae1b$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $0eaf8a89e59b3e47$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $e71afb3c28816696$export$98e6a39c04603d36)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $e71afb3c28816696$export$98e6a39c04603d36)(opts.host).host;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $e01fce6500821742$export$2f872c0f2117be69)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$515dcfe1978ff794$export$4798917dbf149b79.protocol = (0, $9KvBE.protocol);







const $8df64043f3ed4d36$export$a51d6b395ff4c65a = (0, $515dcfe1978ff794$export$4798917dbf149b79).protocol;


function $b460b4e322b56074$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $e71afb3c28816696$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}




var $7zQLO = parcelRequire("7zQLO");
function $16188adeaa79efa6$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



var $fbuXh = parcelRequire("fbuXh");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $4728d6e983c9cda4$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $4728d6e983c9cda4$export$4798917dbf149b79 extends (0, $fbuXh.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($4728d6e983c9cda4$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $7zQLO.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $7zQLO.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $7zQLO.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $7zQLO.PacketType).EVENT:
            case (0, $7zQLO.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $7zQLO.PacketType).ACK:
            case (0, $7zQLO.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $7zQLO.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $7zQLO.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $7zQLO.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $7zQLO.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}



var $7zQLO = parcelRequire("7zQLO");

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3765b2853d7f821b$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



var $fbuXh = parcelRequire("fbuXh");
class $fbeb246c7e550d2d$export$d0d38e7dec7a1a61 extends (0, $fbuXh.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $515dcfe1978ff794$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $4728d6e983c9cda4$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3765b2853d7f821b$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $7zQLO;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}




var $7zQLO = parcelRequire("7zQLO");
/**
 * Managers cache.
 */ const $3e27f9daa0204a44$var$cache = {};
function $3e27f9daa0204a44$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $b460b4e322b56074$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $3e27f9daa0204a44$var$cache[id] && path in $3e27f9daa0204a44$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fbeb246c7e550d2d$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$3e27f9daa0204a44$var$cache[id]) $3e27f9daa0204a44$var$cache[id] = new (0, $fbeb246c7e550d2d$export$d0d38e7dec7a1a61)(source, opts);
        io = $3e27f9daa0204a44$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($3e27f9daa0204a44$export$841407ceb083bd74, {
    Manager: $fbeb246c7e550d2d$export$d0d38e7dec7a1a61,
    Socket: $4728d6e983c9cda4$export$4798917dbf149b79,
    io: $3e27f9daa0204a44$export$841407ceb083bd74,
    connect: $3e27f9daa0204a44$export$841407ceb083bd74
});


const $1622be301bae0161$var$debugOn = new URLSearchParams(window.location.search).has("debug");
class $1622be301bae0161$export$efa9a398d6368992 {
    isEnabled() {
        return this._isEnabled;
    }
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    info(...params) {
        if (!this._isEnabled) return;
        return console.info(...params);
    }
    warn(...params) {
        if (!this._isEnabled) return;
        return console.warn(...params);
    }
    error(...params) {
        if (!this._isEnabled) return;
        return console.error(...params);
    }
    withDebugLogger(myDebugger = null) {
        this._debugger = myDebugger;
        return this;
    }
    debug(...params) {
        if (!this._isEnabled || !this._debugger) return;
        const suppliedParams = [];
        params.forEach((param)=>{
            if (typeof param === "function") {
                const suppliedParam = param();
                suppliedParams.push(suppliedParam);
            } else suppliedParams.push(param);
        });
        this._debugger.print(...suppliedParams);
    }
    constructor(){
        this._isEnabled = false;
        this._debugger = null;
        this._isEnabled = $1622be301bae0161$var$debugOn;
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $1622be301bae0161$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $1622be301bae0161$export$e0d9ca86534ab48(cpMetrics, currentCptats, prevCptats, timeDiff, report) {
    const bytesReceivedDiff = currentCptats.bytesReceived - ((prevCptats === null || prevCptats === void 0 ? void 0 : prevCptats.bytesReceived) || 0);
    const bytesSentDiff = currentCptats.bytesSent - ((prevCptats === null || prevCptats === void 0 ? void 0 : prevCptats.bytesSent) || 0);
    cpMetrics.bitrateIn = 8000 * bytesReceivedDiff / timeDiff;
    cpMetrics.bitrateOut = 8000 * bytesSentDiff / timeDiff;
    cpMetrics.state = currentCptats.state;
    cpMetrics.roundTripTime = currentCptats.currentRoundTripTime;
    cpMetrics.requestsSent = currentCptats.requestsSent;
    cpMetrics.responsesReceived = currentCptats.responsesReceived;
    cpMetrics.requestsReceived = currentCptats.requestsReceived;
    cpMetrics.responsesSent = currentCptats.responsesSent;
    cpMetrics.availableOutgoingBitrate = currentCptats.availableOutgoingBitrate;
    cpMetrics.availableIncomingBitrate = currentCptats.availableIncomingBitrate;
    const remote = report.get(currentCptats.remoteCandidateId);
    const local = report.get(currentCptats.localCandidateId);
    cpMetrics.usingTurn = false;
    if (local) {
        if (/relay/i.test(local.candidateType || "")) {
            cpMetrics.usingTurn = true;
            cpMetrics.turnProtocol = local.relayProtocol;
        }
    }
    if (remote && local) {
        cpMetrics.localEp = `${local.protocol}:${local.address || local.ip}:${local.port} ${local.candidateType} (${local.networkType})`;
        cpMetrics.remoteEp = `${remote.protocol}:${remote.address || remote.ip}:${remote.port} ${remote.candidateType}`;
    }
}
function $1622be301bae0161$export$16f2e79b3a5401ad(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    if (ssrcMetrics.codec) return;
    ssrcMetrics.kind = currentSsrcStats.kind || currentSsrcStats.mediaType;
    ssrcMetrics.ssrc = currentSsrcStats.ssrc;
    ssrcMetrics.direction = currentSsrcStats.type === "inbound-rtp" ? "in" : "out";
    const codecStats = currentSsrcStats.codecId && report.get(currentSsrcStats.codecId);
    ssrcMetrics.codec = codecStats && [
        codecStats.mimeType,
        codecStats.channels && `${codecStats.channels}ch`,
        codecStats.clockRate,
        codecStats.payloadType,
        currentSsrcStats.encoderImplementation || currentSsrcStats.decoderImplementation,
        codecStats.sdpFmtpLine
    ].filter(Boolean).join(" ");
    ssrcMetrics.mid = currentSsrcStats.mid;
    ssrcMetrics.rid = currentSsrcStats.rid;
}
function $1622be301bae0161$export$68cf3afdddf059e2(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    const nackCountDiff = (currentSsrcStats.nackCount || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.nackCount) || 0);
    ssrcMetrics.nackCount = (ssrcMetrics.nackCount || 0) + nackCountDiff;
    ssrcMetrics.nackRate = 1000 * nackCountDiff / timeDiff;
    if (ssrcMetrics.direction === "in") {
        const packetCountDiff = currentSsrcStats.packetsReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsReceived) || 0);
        ssrcMetrics.packetCount = (ssrcMetrics.packetCount || 0) + packetCountDiff;
        ssrcMetrics.packetRate = 1000 * packetCountDiff / timeDiff;
        const packetLossCountDiff = currentSsrcStats.packetsLost - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsLost) || 0);
        ssrcMetrics.packetLossCount = (ssrcMetrics.packetLossCount || 0) + packetLossCountDiff;
        ssrcMetrics.packetLossRate = 1000 * packetLossCountDiff / timeDiff;
        ssrcMetrics.lossRatio = 1000 * (packetLossCountDiff / (packetLossCountDiff + packetCountDiff)) / timeDiff;
        const byteCountDiff = currentSsrcStats.bytesReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.bytesReceived) || 0);
        ssrcMetrics.byteCount = (ssrcMetrics.byteCount || 0) + byteCountDiff;
        let headerByteCountDiff = 0;
        if (currentSsrcStats.headerBytesReceived) {
            headerByteCountDiff = currentSsrcStats.headerBytesReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.headerBytesReceived) || 0);
            ssrcMetrics.headerByteCount = (ssrcMetrics.headerByteCount || 0) + headerByteCountDiff;
        }
        const totalBytesDiff = byteCountDiff + headerByteCountDiff;
        ssrcMetrics.bitrate = 8000 * totalBytesDiff / timeDiff;
        ssrcMetrics.mediaRatio = byteCountDiff / totalBytesDiff;
        if (currentSsrcStats.kind === "audio") {
            const fecBytesDiff = (currentSsrcStats.fecBytesReceived || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.fecBytesReceived) || 0);
            ssrcMetrics.fecRatio = fecBytesDiff / byteCountDiff;
        }
        const jitterBufferDelayDiff = (currentSsrcStats.jitterBufferDelay || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.jitterBufferDelay) || 0);
        const jitterBufferEmittedDiff = (currentSsrcStats.jitterBufferEmittedCount || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.jitterBufferEmittedCount) || 0);
        ssrcMetrics.jitter = jitterBufferEmittedDiff ? jitterBufferDelayDiff / jitterBufferEmittedDiff : 0;
    } else {
        const packetCountDiff = currentSsrcStats.packetsSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsSent) || 0);
        ssrcMetrics.packetCount = (ssrcMetrics.packetCount || 0) + packetCountDiff;
        ssrcMetrics.packetRate = 1000 * packetCountDiff / timeDiff;
        const byteCountDiff = currentSsrcStats.bytesSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.bytesSent) || 0);
        ssrcMetrics.byteCount = (ssrcMetrics.byteCount || 0) + byteCountDiff;
        let headerByteCountDiff = 0;
        if (currentSsrcStats.headerBytesSent) {
            headerByteCountDiff = currentSsrcStats.headerBytesSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.headerBytesSent) || 0);
            ssrcMetrics.headerByteCount = (ssrcMetrics.headerByteCount || 0) + headerByteCountDiff;
        }
        const totalBytesDiff = byteCountDiff + headerByteCountDiff;
        ssrcMetrics.bitrate = 8000 * totalBytesDiff / timeDiff;
        ssrcMetrics.mediaRatio = byteCountDiff / totalBytesDiff;
        const sendDelayDiff = currentSsrcStats.totalPacketSendDelay - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalPacketSendDelay) || 0);
        ssrcMetrics.sendDelay = sendDelayDiff / packetCountDiff;
        const retransDiff = currentSsrcStats.retransmittedPacketsSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.retransmittedPacketsSent) || 0);
        ssrcMetrics.retransRatio = 1000 * (retransDiff / packetCountDiff) / timeDiff;
        if (currentSsrcStats.remoteId) {
            const remoteReport = report.get(currentSsrcStats.remoteId);
            if (remoteReport) {
                ssrcMetrics.roundTripTime = remoteReport.roundTripTime || 0;
                ssrcMetrics.jitter = remoteReport.jitter || 0;
                ssrcMetrics.fractionLost = remoteReport.fractionLost || 0;
            }
        }
    }
}
function $1622be301bae0161$export$ae7525495638aed5(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    const packetsDiscardedDiff = currentSsrcStats.packetsDiscarded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsDiscarded) || 0);
    ssrcMetrics.packetsDiscarded = (ssrcMetrics.packetsDiscarded || 0) + packetsDiscardedDiff;
    if (ssrcMetrics.direction === "in") {
        const totalAudioEnergyDiff = currentSsrcStats.totalAudioEnergy - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalAudioEnergy) || 0);
        const totalSamplesDurationDiff = currentSsrcStats.totalSamplesDuration - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalSamplesDuration) || 0);
        ssrcMetrics.audioLevel = Math.sqrt(totalAudioEnergyDiff / totalSamplesDurationDiff);
        const samples = currentSsrcStats.totalSamplesReceived || 0;
        const concealmentEvents = currentSsrcStats.concealmentEvents || 0;
        const samplesDiff = samples - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalSamplesReceived) || 0);
        const concealedSamples = currentSsrcStats.concealedSamples || 0;
        const concealedDiff = concealedSamples - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.concealedSamples) || 0);
        const silentConcealedDiff = (currentSsrcStats.silentConcealedSamples || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.silentConcealedSamples) || 0);
        const insDiff = (currentSsrcStats.insertedSamplesForDeceleration || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.insertedSamplesForDeceleration) || 0);
        const remDiff = (currentSsrcStats.removedSamplesForAcceleration || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.removedSamplesForAcceleration) || 0);
        ssrcMetrics.audioSamples = samples;
        ssrcMetrics.audioConcealmentEvents = concealmentEvents;
        ssrcMetrics.audioConcealedSamples = concealedSamples;
        ssrcMetrics.audioConcealment = concealedDiff ? concealedDiff / samplesDiff : 0;
        ssrcMetrics.audioSilentConcealment = silentConcealedDiff ? silentConcealedDiff / samplesDiff : 0;
        ssrcMetrics.audioAcceleration = remDiff ? remDiff / samplesDiff : 0;
        ssrcMetrics.audioDeceleration = insDiff ? insDiff / samplesDiff : 0;
    }
}
function $1622be301bae0161$export$6f8e63161a499169(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    ssrcMetrics.width = currentSsrcStats.frameWidth;
    ssrcMetrics.height = currentSsrcStats.frameHeight;
    ssrcMetrics.qualityLimitationReason = currentSsrcStats.qualityLimitationReason || "";
    const pliCountDiff = currentSsrcStats.pliCount - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.pliCount) || 0);
    ssrcMetrics.pliCount = (ssrcMetrics.pliCount || 0) + pliCountDiff;
    ssrcMetrics.pliRate = 1000 * pliCountDiff / timeDiff;
    const firCountDiff = currentSsrcStats.firCount - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.firCount) || 0);
    ssrcMetrics.firCount = (ssrcMetrics.firCount || 0) + firCountDiff;
    ssrcMetrics.firRate = 1000 * firCountDiff / timeDiff;
    if (ssrcMetrics.direction === "in") {
        const kfCountDiff = currentSsrcStats.keyFramesDecoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.keyFramesDecoded) || 0);
        ssrcMetrics.kfCount = (ssrcMetrics.kfCount || 0) + kfCountDiff;
        ssrcMetrics.kfRate = 1000 * kfCountDiff / timeDiff;
        const frameCountDiff = currentSsrcStats.framesDecoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.framesDecoded) || 0);
        ssrcMetrics.frameCount = (ssrcMetrics.frameCount || 0) + frameCountDiff;
        const qpsumDiff = currentSsrcStats.qpSum - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.qpSum) || 0);
        ssrcMetrics.qpf = qpsumDiff / frameCountDiff;
        ssrcMetrics.fps = frameCountDiff * 1000 / timeDiff;
    } else {
        const kfCountDiff = currentSsrcStats.keyFramesEncoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.keyFramesEncoded) || 0);
        ssrcMetrics.kfCount = (ssrcMetrics.kfCount || 0) + kfCountDiff;
        ssrcMetrics.kfRate = 1000 * kfCountDiff / timeDiff;
        const frameCountDiff = currentSsrcStats.framesEncoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.framesEncoded) || 0);
        ssrcMetrics.frameCount = (ssrcMetrics.frameCount || 0) + frameCountDiff;
        const qpsumDiff = currentSsrcStats.qpSum - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.qpSum) || 0);
        ssrcMetrics.qpf = qpsumDiff / frameCountDiff;
        ssrcMetrics.fps = frameCountDiff * 1000 / timeDiff;
        const encodeTimeDiff = currentSsrcStats.totalEncodeTime - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalEncodeTime) || 0);
        ssrcMetrics.encodeTime = encodeTimeDiff / frameCountDiff;
        if (currentSsrcStats.mediaSourceId) {
            const mediaSourceReport = report.get(currentSsrcStats.mediaSourceId);
            if (mediaSourceReport) {
                ssrcMetrics.sourceWidth = mediaSourceReport.width || 0;
                ssrcMetrics.sourceHeight = mediaSourceReport.height || 0;
                ssrcMetrics.sourceFps = mediaSourceReport.framesPerSecond || 0;
            }
        }
    }
}
let $1622be301bae0161$var$peerConnections = [];
let $1622be301bae0161$var$peerConnectionCounter = 0;
const $1622be301bae0161$var$peerConnectionData = new WeakMap();
const $1622be301bae0161$export$b1f10c3e96f6558d = (pc)=>{
    $1622be301bae0161$var$peerConnections = $1622be301bae0161$var$peerConnections.filter((old)=>old !== pc);
};
if (window.RTCPeerConnection) {
    const OriginalRTCPeerConnection = window.RTCPeerConnection;
    function PatchedRTCPeerConnection(rtcConfig) {
        const pc = new OriginalRTCPeerConnection(rtcConfig);
        $1622be301bae0161$var$peerConnections.push(pc);
        $1622be301bae0161$var$peerConnectionData.set(pc, {
            index: $1622be301bae0161$var$peerConnectionCounter++
        });
        const onConnectionStateChange = ()=>{
            if (pc.connectionState === "closed") {
                $1622be301bae0161$export$b1f10c3e96f6558d(pc);
                pc.removeEventListener("connectionstatechange", onConnectionStateChange);
            }
        };
        pc.addEventListener("connectionstatechange", onConnectionStateChange);
        return pc;
    }
    PatchedRTCPeerConnection.prototype = OriginalRTCPeerConnection.prototype;
    window.RTCPeerConnection = PatchedRTCPeerConnection;
}
const $1622be301bae0161$export$7ebad8aba6d694ee = ()=>$1622be301bae0161$var$peerConnections;
const $1622be301bae0161$export$56866cc07fc6e61f = (pc)=>{
    var _a;
    return (_a = $1622be301bae0161$var$peerConnectionData.get(pc)) === null || _a === void 0 ? void 0 : _a.index;
};
const $1622be301bae0161$export$f0701262c33e50fa = (pcs)=>$1622be301bae0161$var$peerConnections = pcs;
const $1622be301bae0161$var$pcDataByPc = new WeakMap();
const $1622be301bae0161$var$getPeerConnectionsWithStatsReports = ()=>Promise.all($1622be301bae0161$export$7ebad8aba6d694ee().map((pc)=>$1622be301bae0161$var$__awaiter(void 0, void 0, void 0, function*() {
            let pcData = $1622be301bae0161$var$pcDataByPc.get(pc);
            if (!pcData) {
                pcData = {
                    ssrcToTrackId: {}
                };
                $1622be301bae0161$var$pcDataByPc.set(pc, pcData);
            }
            try {
                const report = yield pc.getStats();
                let missingSsrcs = null;
                report.forEach((stats)=>{
                    if (stats.type === "inbound-rtp" || stats.type === "outbound-rtp") {
                        if (!stats.trackIdentifier && !pcData.ssrcToTrackId[stats.ssrc]) {
                            if (stats.mediaSourceId) {
                                const mediaSourceStats = report.get(stats.mediaSourceId);
                                if (mediaSourceStats) {
                                    if (mediaSourceStats.trackIdentifier) pcData.ssrcToTrackId[stats.ssrc] = mediaSourceStats.trackIdentifier;
                                }
                            }
                            if (!pcData.ssrcToTrackId[stats.ssrc] && stats.trackId) {
                                const deprecatedTrackStats = report.get(stats.trackId);
                                if (deprecatedTrackStats) {
                                    if (deprecatedTrackStats.trackIdentifier) pcData.ssrcToTrackId[stats.ssrc] = deprecatedTrackStats.trackIdentifier;
                                }
                            }
                            if (!pcData.ssrcToTrackId[stats.ssrc]) {
                                if (!missingSsrcs) missingSsrcs = [];
                                missingSsrcs.push(stats.ssrc);
                            }
                        }
                    }
                });
                if (missingSsrcs) {
                    const sendersAndReceivers = [
                        ...pc.getSenders(),
                        ...pc.getReceivers()
                    ];
                    const reports = yield Promise.all(sendersAndReceivers.map((o)=>o.getStats()));
                    reports.forEach((tReport, index)=>{
                        tReport.forEach((stats)=>{
                            if (stats.type === "inbound-rtp" || stats.type === "outbound-rtp") pcData.ssrcToTrackId[stats.ssrc] = sendersAndReceivers[index].track.id;
                        });
                    });
                    missingSsrcs.forEach((ssrc)=>{
                        if (!pcData.ssrcToTrackId[ssrc]) pcData.ssrcToTrackId[ssrc] = "?" + ssrc;
                    });
                }
                return [
                    pc,
                    report,
                    pcData
                ];
            } catch (ex) {
                return [
                    pc,
                    [],
                    pcData
                ];
            }
        })));
const $1622be301bae0161$var$getOrCreateSsrcMetricsContainer = (statsByView, time, pcIndex, clientId, trackId, ssrc)=>{
    let viewStats = statsByView[clientId];
    if (!viewStats) {
        viewStats = {
            tracks: {},
            startTime: time,
            updated: time
        };
        statsByView[clientId] = viewStats;
    }
    viewStats.updated = time;
    let trackStats = viewStats.tracks[trackId];
    if (!trackStats) {
        trackStats = {
            ssrcs: {},
            startTime: time,
            updated: time
        };
        viewStats.tracks[trackId] = trackStats;
    }
    trackStats.updated = time;
    let ssrcStats = trackStats.ssrcs[ssrc];
    if (!ssrcStats) {
        ssrcStats = {
            startTime: time,
            updated: time,
            pcIndex: pcIndex
        };
        trackStats.ssrcs[ssrc] = ssrcStats;
    }
    ssrcStats.updated = time;
    return ssrcStats;
};
const $1622be301bae0161$var$removeNonUpdatedStats = (statsByView, time)=>{
    Object.entries(statsByView).forEach(([viewId, viewStats])=>{
        if (viewStats.updated < time) delete statsByView[viewId];
        else Object.entries(viewStats.tracks).forEach(([trackId, trackStats])=>{
            if (trackStats.updated < time) delete viewStats.tracks[trackId];
            else Object.entries(trackStats.ssrcs).forEach(([ssrc, ssrcStats])=>{
                if (ssrcStats.updated < time) delete trackStats.ssrcs[ssrc];
            });
        });
    });
};
function $1622be301bae0161$var$collectStats(state, { logger: logger, interval: interval }, immediate) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const collectStatsBound = $1622be301bae0161$var$collectStats.bind(null, state, {
            interval: interval,
            logger: logger
        });
        try {
            const clients = state.getClients();
            const defaultClient = clients.find((c)=>c.isLocalClient && !c.isPresentation) || {
                id: "unknown"
            };
            let defaultViewStats = state.statsByView[defaultClient.id];
            if (!defaultViewStats) {
                defaultViewStats = {
                    tracks: {},
                    candidatePairs: {},
                    pressure: null
                };
                state.statsByView[defaultClient.id] = defaultViewStats;
            }
            defaultViewStats.pressure = state.lastPressureObserverRecord;
            const timeSinceLastUpdate = Date.now() - state.lastUpdateTime;
            if (timeSinceLastUpdate < 400) {
                if (immediate) return state.statsByView;
                state.subscriptions.forEach((subscription)=>{
                    var _a;
                    return (_a = subscription.onUpdatedStats) === null || _a === void 0 ? void 0 : _a.call(subscription, state.statsByView, clients);
                });
                state.nextTimeout = setTimeout(collectStatsBound, interval);
                return;
            }
            state.lastUpdateTime = Date.now();
            (yield $1622be301bae0161$var$getPeerConnectionsWithStatsReports()).forEach(([pc, report, pcData])=>{
                const pcIndex = $1622be301bae0161$export$56866cc07fc6e61f(pc);
                if (pc.connectionState === "closed") {
                    report = new Map();
                    $1622be301bae0161$export$b1f10c3e96f6558d(pc);
                }
                pcData.previousSSRCs = pcData.currentSSRCs || {};
                pcData.currentSSRCs = {};
                report.forEach((currentRtcStats)=>{
                    var _a, _b, _c;
                    if (currentRtcStats.type === "candidate-pair" && /inprogress|succeeded/.test(currentRtcStats.state)) {
                        const prevRtcStats = (_a = pcData._oldReport) === null || _a === void 0 ? void 0 : _a.get(currentRtcStats.id);
                        const timeDiff = prevRtcStats ? currentRtcStats.timestamp - prevRtcStats.timestamp : interval;
                        const cpId = pcIndex + ":" + currentRtcStats.id;
                        let cpMetrics = defaultViewStats.candidatePairs[cpId];
                        if (!cpMetrics) {
                            cpMetrics = {
                                startTime: state.lastUpdateTime,
                                id: cpId
                            };
                            defaultViewStats.candidatePairs[cpId] = cpMetrics;
                        }
                        $1622be301bae0161$export$e0d9ca86534ab48(cpMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        cpMetrics.lastRtcStatsTime = state.lastUpdateTime;
                    }
                    if (currentRtcStats.type === "inbound-rtp" || currentRtcStats.type === "outbound-rtp") {
                        const kind = currentRtcStats.mediaType || currentRtcStats.kind;
                        const ssrc = currentRtcStats.ssrc;
                        let trackId = currentRtcStats.trackIdentifier || pcData.ssrcToTrackId[ssrc];
                        let prevRtcStats = (_b = pcData._oldReport) === null || _b === void 0 ? void 0 : _b.get(currentRtcStats.id);
                        if (prevRtcStats && prevRtcStats.mediaSourceId !== currentRtcStats.mediaSourceId) {
                            const mediaSourceStats = report.get(currentRtcStats.mediaSourceId);
                            if (mediaSourceStats && mediaSourceStats.trackIdentifier) {
                                trackId = mediaSourceStats.trackIdentifier;
                                pcData.ssrcToTrackId[ssrc] = trackId;
                            }
                        }
                        const client = clients.find((c)=>{
                            var _a;
                            return ((_a = c[kind].track) === null || _a === void 0 ? void 0 : _a.id) === trackId;
                        }) || defaultClient;
                        if (!currentRtcStats.trackIdentifier && pcData.ssrcToTrackId[ssrc] && ((_c = client[kind].track) === null || _c === void 0 ? void 0 : _c.id) && client[kind].track.id !== pcData.ssrcToTrackId[ssrc]) {
                            trackId = client[kind].track.id;
                            pcData.ssrcToTrackId[ssrc] = client[kind].track.id;
                        }
                        pcData.currentSSRCs[ssrc] = client.id;
                        if (prevRtcStats) {
                            const newTransport = report.get(currentRtcStats.transportId);
                            const oldTransport = pcData._oldReport.get(prevRtcStats.transportId);
                            if (oldTransport && (newTransport === null || newTransport === void 0 ? void 0 : newTransport.selectedCandidatePairId) !== oldTransport.selectedCandidatePairId) prevRtcStats = null;
                            else if (currentRtcStats.bytesReceived < prevRtcStats.bytesReceived || currentRtcStats.bytesSent < prevRtcStats.bytesSent) prevRtcStats = null;
                        }
                        const timeDiff = prevRtcStats ? currentRtcStats.timestamp - prevRtcStats.timestamp : interval;
                        const ssrcMetrics = $1622be301bae0161$var$getOrCreateSsrcMetricsContainer(state.statsByView, state.lastUpdateTime, pcIndex, client.id, trackId, ssrc);
                        $1622be301bae0161$export$16f2e79b3a5401ad(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        $1622be301bae0161$export$68cf3afdddf059e2(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        if (kind === "video") $1622be301bae0161$export$6f8e63161a499169(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        if (kind === "audio") $1622be301bae0161$export$ae7525495638aed5(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                    }
                });
                pcData._oldReport = report;
                Object.keys(pcData.previousSSRCs).filter((ssrc)=>!pcData.currentSSRCs[ssrc]).forEach((ssrc)=>{
                    const clientId = pcData.previousSSRCs[ssrc];
                    if (clientId) {
                        const clientView = state.statsByView[clientId];
                        if (clientView) Object.values(clientView.tracks).forEach((trackStats)=>{
                            if (trackStats.ssrcs[ssrc]) delete trackStats.ssrcs[ssrc];
                        });
                    }
                });
            });
            $1622be301bae0161$var$removeNonUpdatedStats(state.statsByView, state.lastUpdateTime);
            Object.entries(defaultViewStats.candidatePairs).forEach(([cpKey, cp])=>{
                const active = cp.lastRtcStatsTime === state.lastUpdateTime;
                cp.active = active;
                if (!active) {
                    cp.state = "old/inactive";
                    if (!cp.inactiveFromTime) cp.inactiveFromTime = state.lastUpdateTime;
                    else if (state.lastUpdateTime - cp.inactiveFromTime > 4000) delete defaultViewStats.candidatePairs[cpKey];
                }
            });
            if (immediate) return state.statsByView;
            else state.subscriptions.forEach((subscription)=>{
                var _a;
                return (_a = subscription.onUpdatedStats) === null || _a === void 0 ? void 0 : _a.call(subscription, state.statsByView, clients);
            });
        } catch (ex) {
            logger.warn(ex);
        }
        state.nextTimeout = setTimeout(collectStatsBound, interval);
    });
}
const $1622be301bae0161$var$REGISTERED_TRIALS = {};
function $1622be301bae0161$var$registerOriginTrials(trials, registeredTrials = $1622be301bae0161$var$REGISTERED_TRIALS, document1 = window.document) {
    trials.forEach(({ hostnamePattern: hostnamePattern, token: token })=>{
        const key = `${hostnamePattern}-${token}`;
        if (registeredTrials[key]) return;
        if (hostnamePattern.test(document1.location.hostname)) {
            const otMeta = document1.createElement("meta");
            otMeta.httpEquiv = "origin-trial";
            otMeta.content = token;
            document1.head.append(otMeta);
            registeredTrials[key] = true;
        }
    });
}
const $1622be301bae0161$var$CPU_OBSERVER_OPTIONS = {
    sampleRate: 1,
    originTrials: [
        {
            hostnamePattern: /hereby\.dev/,
            token: "AkSNPHJw6EK08X0QU7kORnK9NABzRLAC7dqfXOwk5JwFAQG4Ey7WxLXxsnhieCgC1QHUdevE2EFICy7uBGDANwUAAABqeyJvcmlnaW4iOiJodHRwczovL2hlcmVieS5kZXY6NDQ0MyIsImZlYXR1cmUiOiJDb21wdXRlUHJlc3N1cmVfdjIiLCJleHBpcnkiOjE3MTY5NDA3OTksImlzU3ViZG9tYWluIjp0cnVlfQ=="
        },
        {
            hostnamePattern: /whereby\.com/,
            token: "Asc2wu8KpSx648i932NICteQDFcB05yl2QUUSHD7AQo8JGP2Fp6FF91TvYVJBsKGzLMH349rysPw5q9tqPC/PAUAAABqeyJvcmlnaW4iOiJodHRwczovL3doZXJlYnkuY29tOjQ0MyIsImZlYXR1cmUiOiJDb21wdXRlUHJlc3N1cmVfdjIiLCJleHBpcnkiOjE3MTY5NDA3OTksImlzU3ViZG9tYWluIjp0cnVlfQ=="
        }
    ]
};
function $1622be301bae0161$var$startCpuObserver(cb, { sampleRate: sampleRate, originTrials: originTrials } = $1622be301bae0161$var$CPU_OBSERVER_OPTIONS, window1 = globalThis.window) {
    $1622be301bae0161$var$registerOriginTrials(originTrials);
    let pressureObserver;
    if ("PressureObserver" in window1) {
        pressureObserver = new window1.PressureObserver(cb, {
            sampleRate: sampleRate
        });
        pressureObserver.observe("cpu", {
            sampleInterval: sampleRate * 1000
        });
        return {
            stop: ()=>{
                pressureObserver.unobserve("cpu");
            }
        };
    }
}
const $1622be301bae0161$var$STATE = {
    currentMonitor: null,
    getClients: ()=>[],
    lastUpdateTime: 0,
    statsByView: {},
    subscriptions: []
};
const $1622be301bae0161$var$OPTIONS = {
    interval: 2000,
    logger: new $1622be301bae0161$export$efa9a398d6368992()
};
const $1622be301bae0161$export$432f698644f45d1 = ()=>{
    return Object.assign({}, $1622be301bae0161$var$STATE.statsByView);
};
const $1622be301bae0161$export$a95105d8b2471e00 = ()=>{
    var _a;
    return (_a = $1622be301bae0161$var$STATE.currentMonitor) === null || _a === void 0 ? void 0 : _a.getUpdatedStats();
};
const $1622be301bae0161$export$591e741f8b7f4720 = (provider)=>$1622be301bae0161$var$STATE.getClients = provider;
function $1622be301bae0161$var$startStatsMonitor(state, { interval: interval, logger: logger }) {
    const collectStatsBound = $1622be301bae0161$var$collectStats.bind(null, state, {
        interval: interval,
        logger: logger
    });
    let cpuObserver;
    try {
        cpuObserver = $1622be301bae0161$var$startCpuObserver((records)=>state.lastPressureObserverRecord = records.pop());
    } catch (ex) {
        logger.warn("Failed to observe CPU pressure", ex);
    }
    setTimeout(collectStatsBound, interval);
    return {
        getUpdatedStats: ()=>{
            return collectStatsBound(true);
        },
        stop: ()=>{
            clearTimeout(state.nextTimeout);
            if (cpuObserver) cpuObserver.stop();
        }
    };
}
function $1622be301bae0161$export$446568135c9b26ef(subscription, options = $1622be301bae0161$var$OPTIONS, state = $1622be301bae0161$var$STATE) {
    state.subscriptions.push(subscription);
    if (!state.currentMonitor) state.currentMonitor = $1622be301bae0161$var$startStatsMonitor(state, options);
    return {
        stop () {
            var _a;
            state.subscriptions = state.subscriptions.filter((s)=>s !== subscription);
            if (!state.subscriptions.length) {
                (_a = state.currentMonitor) === null || _a === void 0 || _a.stop();
                state.currentMonitor = null;
            }
        }
    };
}
const $1622be301bae0161$var$badNetworkIssueDetector = {
    id: "bad-network",
    enabled: ({ hasLiveTrack: hasLiveTrack, ssrcs: ssrcs })=>hasLiveTrack && ssrcs.length > 0,
    check: ({ client: client, clients: clients, kind: kind, ssrcs: ssrcs })=>{
        const hasPositiveBitrate = ssrcs.some((ssrc)=>ssrc.bitrate > 0);
        if (!hasPositiveBitrate && client.isLocalClient && kind === "video") {
            const remoteClients = clients.filter((c)=>!c.isLocalClient);
            if (remoteClients.length > 0) return !remoteClients.every((c)=>c.isAudioOnlyModeEnabled);
        }
        const ssrc0 = ssrcs[0];
        if (!ssrc0) return false;
        return ssrc0.bitrate === 0 || ssrc0.lossRatio > 0.03 || (ssrc0.fractionLost || 0) > 0.03 || !client.isPresentation && kind === "video" && ssrc0.bitrate < 30000 || ssrc0.direction === "in" && ssrc0.pliRate > 2;
    }
};
const $1622be301bae0161$var$dryTrackIssueDetector = {
    id: "dry-track",
    enabled: ({ hasLiveTrack: hasLiveTrack, ssrcs: ssrcs })=>!!(hasLiveTrack && ssrcs),
    check: ({ client: client, clients: clients, ssrcs: ssrcs })=>{
        let hasPositiveBitrate = false;
        ssrcs.forEach((ssrc)=>{
            hasPositiveBitrate = hasPositiveBitrate || ssrc.bitrate > 0;
        });
        if (!hasPositiveBitrate && client.isLocalClient) {
            const remoteClients = clients.filter((c)=>!c.isLocalClient);
            if (remoteClients.length > 0) return !remoteClients.every((c)=>c.isAudioOnlyModeEnabled);
        }
        return !hasPositiveBitrate;
    }
};
const $1622be301bae0161$var$noTrackIssueDetector = {
    id: "no-track",
    enabled: ()=>true,
    check: ({ client: client, clients: clients, kind: kind, track: track })=>{
        if (!track && !client.isLocalClient && kind === "video") {
            const localClient = clients.find((c)=>c.isLocalClient);
            if (localClient) return !localClient.isAudioOnlyModeEnabled;
        }
        return !track;
    }
};
const $1622be301bae0161$var$noTrackStatsIssueDetector = {
    id: "no-track-stats",
    enabled: ({ hasLiveTrack: hasLiveTrack })=>hasLiveTrack,
    check: ({ client: client, clients: clients, kind: kind, ssrcs: ssrcs })=>{
        if (ssrcs.length === 0 && !client.isLocalClient && kind === "video") {
            const localClient = clients.find((c)=>c.isLocalClient);
            if (localClient) return !localClient.isAudioOnlyModeEnabled;
        }
        return ssrcs.length === 0;
    }
};
const $1622be301bae0161$var$issueDetectors = [
    {
        id: "desync",
        enabled: ({ client: client, track: track, stats: stats })=>{
            return !client.isLocalClient && (track === null || track === void 0 ? void 0 : track.kind) === "audio" && typeof (stats === null || stats === void 0 ? void 0 : stats.tracks) === "object" && Object.keys(stats.tracks).length > 1;
        },
        check: ({ stats: { tracks: tracks } })=>{
            const jitter = {
                audio: 0,
                video: 0
            };
            Object.values(tracks).flatMap((t)=>Object.values(t.ssrcs)).forEach((ssrc)=>{
                if (ssrc.kind === "audio" && ssrc.jitter > jitter.audio) jitter.audio = ssrc.jitter;
                if (ssrc.kind === "video" && ssrc.jitter > jitter.video) jitter.video = ssrc.jitter;
            });
            const diff = Math.abs(jitter.audio * 1000 - jitter.video * 1000);
            return diff > 500;
        }
    },
    $1622be301bae0161$var$noTrackIssueDetector,
    {
        id: "ended-track",
        enabled: ({ track: track })=>!!track,
        check: ({ track: track })=>(track === null || track === void 0 ? void 0 : track.readyState) === "ended"
    },
    $1622be301bae0161$var$noTrackStatsIssueDetector,
    $1622be301bae0161$var$dryTrackIssueDetector,
    {
        id: "low-layer0-bitrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && kind === "video" && ssrc0 && ssrc0.height && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.height < 200 && ssrc0.bitrate < 30000
    },
    {
        id: "quality-limitation-bw",
        enabled: ({ hasLiveTrack: hasLiveTrack, stats: stats, client: client, kind: kind })=>hasLiveTrack && client.isLocalClient && kind === "video" && stats,
        check: ({ stats: stats })=>!!Object.values(stats.tracks).find((track)=>Object.values(track.ssrcs).find((ssrc)=>ssrc.qualityLimitationReason === "bandwidth"))
    },
    {
        id: "quality-limitation-cpu",
        enabled: ({ hasLiveTrack: hasLiveTrack, stats: stats, client: client, kind: kind })=>hasLiveTrack && client.isLocalClient && kind === "video" && stats,
        check: ({ stats: stats })=>!!Object.values(stats.tracks).find((track)=>Object.values(track.ssrcs).find((ssrc)=>ssrc.qualityLimitationReason === "cpu"))
    },
    {
        id: "high-plirate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.height,
        check: ({ ssrc0: ssrc0 })=>ssrc0.pliRate > 2
    },
    {
        id: "extreme-plirate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.height,
        check: ({ ssrc0: ssrc0 })=>ssrc0.pliRate > 5
    },
    {
        id: "high-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "in",
        check: ({ ssrc0: ssrc0 })=>ssrc0.lossRatio > 0.02
    },
    {
        id: "extreme-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "in",
        check: ({ ssrc0: ssrc0 })=>ssrc0.lossRatio > 0.1
    },
    {
        id: "high-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "out",
        check: ({ ssrc0: ssrc0 })=>(ssrc0.fractionLost || 0) > 0.02
    },
    {
        id: "extreme-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "out",
        check: ({ ssrc0: ssrc0 })=>(ssrc0.fractionLost || 0) > 0.1
    },
    {
        id: "fps-below-20",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && ssrc0 && ssrc0.height && kind === "video" && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.height > 180 && ssrc0.fps < 20
    },
    {
        id: "fps-below-10",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && ssrc0 && ssrc0.height && kind === "video" && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.fps < 10
    },
    $1622be301bae0161$var$badNetworkIssueDetector,
    {
        id: "cpu-pressure-serious",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        check: ({ stats: stats })=>stats.pressure.state === "serious"
    },
    {
        id: "cpu-pressure-critical",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        check: ({ stats: stats })=>stats.pressure.state === "critical"
    },
    {
        id: "concealed",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioConcealment >= 0.1
    },
    {
        id: "decelerated",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioDeceleration >= 0.1
    },
    {
        id: "accelerated",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioAcceleration >= 0.1
    }
];
let $1622be301bae0161$var$subscriptions = [];
let $1622be301bae0161$var$stopStats = null;
const $1622be301bae0161$var$metrics = [
    {
        id: "bitrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0 })=>hasLiveTrack && track && ssrc0,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + ssrc.bitrate, 0)
    },
    {
        id: "pixelrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + (ssrc.fps || 0) * (ssrc.width || 0) * (ssrc.height || 0), 0)
    },
    {
        id: "height",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((max, ssrc)=>Math.max(max, ssrc.fps > 0 ? ssrc.height : 0), 0)
    },
    {
        id: "sourceHeight",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.sourceHeight && ssrc0.direction === "out",
        value: ({ ssrc0: ssrc0 })=>ssrc0.sourceHeight
    },
    {
        id: "packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate,
        value: ({ ssrc0: ssrc0 })=>(ssrc0.direction === "in" ? ssrc0.lossRatio : ssrc0.fractionLost) || 0
    },
    {
        id: "jitter",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in",
        value: ({ ssrc0: ssrc0 })=>ssrc0.jitter
    },
    {
        id: "mos",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "out",
        value: ({ ssrc0: ssrc0 })=>{
            const averageLatency = ssrc0.roundTripTime || 0;
            const jitter = ssrc0.jitter || 0;
            const packetLoss = (ssrc0.fractionLost || 0) * 100;
            const effectiveLatency = averageLatency + jitter * 2 + 10;
            let r = effectiveLatency < 160 ? 93.2 - effectiveLatency / 40 : 93.2 - (effectiveLatency - 120) / 10;
            r = r - packetLoss * 2.5;
            const mos = 1 + 0.035 * r + 0.000007 * r * (r - 60) * (100 - r);
            return mos;
        }
    },
    {
        id: "rendered",
        value: ()=>1
    },
    {
        id: "active",
        value: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0 })=>hasLiveTrack && track && ssrc0 ? 1 : 0
    },
    {
        id: "cpu-pressure",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        value: ({ stats: stats })=>({
                nominal: 0.25,
                fair: 0.5,
                serious: 0.75,
                critical: 1
            })[stats.pressure.state] || 0
    },
    {
        id: "turn-usage",
        global: true,
        enabled: ({ stats: stats })=>!!Object.values(stats.candidatePairs).length,
        value: ({ stats: stats })=>Object.values(stats.candidatePairs).some((cp)=>cp.usingTurn)
    },
    {
        id: "turn-tls-usage",
        global: true,
        enabled: ({ stats: stats })=>!!Object.values(stats.candidatePairs).length,
        value: ({ stats: stats })=>Object.values(stats.candidatePairs).some((cp)=>cp.turnProtocol === "tls")
    },
    {
        id: "concealment",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioConcealment
    },
    {
        id: "deceleration",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioDeceleration
    },
    {
        id: "acceleration",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioAcceleration
    },
    {
        id: "qpf",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + (ssrc.qpf || 0), 0)
    }
];
let $1622be301bae0161$var$aggregatedMetrics;
let $1622be301bae0161$var$aggregatedIssues;
let $1622be301bae0161$var$issuesAndMetricsByView;
const $1622be301bae0161$var$initIssuesAndMetricsByView = ()=>{
    $1622be301bae0161$var$aggregatedMetrics = {};
    $1622be301bae0161$var$aggregatedIssues = {};
    $1622be301bae0161$var$issuesAndMetricsByView = {
        aggregated: {
            issues: $1622be301bae0161$var$aggregatedIssues,
            metrics: $1622be301bae0161$var$aggregatedMetrics
        }
    };
};
$1622be301bae0161$var$initIssuesAndMetricsByView();
const $1622be301bae0161$export$429e50c97404ad34 = ()=>{
    return Object.assign({}, $1622be301bae0161$var$issuesAndMetricsByView);
};
function $1622be301bae0161$var$onUpdatedStats(statsByView, clients) {
    Object.values($1622be301bae0161$var$aggregatedMetrics).forEach((metricData)=>{
        metricData.curTicks = 0;
        metricData.curSum = 0;
        metricData.curMax = 0;
        metricData.curMin = 0;
        metricData.curAvg = 0;
    });
    Object.values($1622be301bae0161$var$aggregatedIssues).forEach((issueData)=>{
        issueData.curTicks = 0;
        issueData.curRegistered = 0;
        issueData.active = false;
    });
    if (!clients.find((client)=>!client.isLocalClient)) return;
    clients.forEach((client)=>{
        const stats = statsByView[client.id];
        [
            "video",
            "audio",
            "global"
        ].forEach((kind)=>{
            var _a, _b;
            if (!(kind === "global" && !client.isPresentation) && !((_a = client[kind]) === null || _a === void 0 ? void 0 : _a.enabled)) return;
            if (kind === "global" && !client.isLocalClient) return;
            let issuesAndMetrics = $1622be301bae0161$var$issuesAndMetricsByView[client.id];
            if (!issuesAndMetrics) {
                issuesAndMetrics = {
                    issues: {},
                    metrics: {}
                };
                $1622be301bae0161$var$issuesAndMetricsByView[client.id] = issuesAndMetrics;
            }
            const track = (_b = client[kind]) === null || _b === void 0 ? void 0 : _b.track;
            const hasLiveTrack = !!track && track.readyState !== "ended";
            const trackStats = track && stats && stats.tracks[track.id];
            const ssrcs = trackStats ? Object.values(trackStats.ssrcs).sort((a, b)=>(a.height || Number.MAX_SAFE_INTEGER) - (b.height || Number.MAX_SAFE_INTEGER)) : [];
            const ssrc0 = ssrcs[0];
            const checkData = {
                client: client,
                clients: clients,
                kind: kind,
                track: track,
                trackStats: trackStats,
                stats: stats,
                hasLiveTrack: hasLiveTrack,
                ssrc0: ssrc0,
                ssrcs: ssrcs,
                issues: issuesAndMetrics.issues,
                metrics: issuesAndMetrics.metrics
            };
            const qualifierString = kind === "global" ? "global" : `${client.isLocalClient ? "loc" : "rem"}-${client.isPresentation ? "pres" : "cam"}-${kind}`;
            $1622be301bae0161$var$metrics.forEach((metric)=>{
                if (metric.global && kind !== "global") return;
                if (!metric.global && kind === "global") return;
                const enabled = metric.enabled ? metric.enabled(checkData) : true;
                if (enabled) {
                    const metricKey = `${qualifierString}-${metric.id}`;
                    let metricData = issuesAndMetrics.metrics[metricKey];
                    const value = metric.value(checkData);
                    if (!metricData) {
                        metricData = {
                            ticks: 0,
                            sum: 0,
                            avg: 0,
                            min: value,
                            max: value
                        };
                        issuesAndMetrics.metrics[metricKey] = metricData;
                    }
                    metricData.ticks++;
                    metricData.sum += value;
                    metricData.min = Math.min(metricData.min, value);
                    metricData.max = Math.max(metricData.max, value);
                    metricData.avg = metricData.sum / metricData.ticks;
                    let aggregatedMetricData = $1622be301bae0161$var$aggregatedMetrics[metricKey];
                    if (!aggregatedMetricData) {
                        aggregatedMetricData = {
                            ticks: 0,
                            sum: 0,
                            min: value,
                            max: value,
                            avg: 0,
                            curTicks: 0,
                            curMin: 0,
                            curMax: 0,
                            curAvg: 0,
                            curSum: 0,
                            totTicks: 0,
                            totMin: 0,
                            totMax: 0,
                            totAvg: 0,
                            totSum: 0
                        };
                        $1622be301bae0161$var$aggregatedMetrics[metricKey] = aggregatedMetricData;
                    }
                    aggregatedMetricData.ticks++;
                    aggregatedMetricData.sum += value;
                    aggregatedMetricData.min = Math.min(aggregatedMetricData.min, value);
                    aggregatedMetricData.max = Math.max(aggregatedMetricData.max, value);
                    aggregatedMetricData.avg = aggregatedMetricData.sum / aggregatedMetricData.ticks;
                    if (aggregatedMetricData.curTicks === 0) {
                        aggregatedMetricData.curMax = value;
                        aggregatedMetricData.curMin = value;
                        aggregatedMetricData.curSum = value;
                    } else {
                        aggregatedMetricData.curMax = Math.max(aggregatedMetricData.curMax, value);
                        aggregatedMetricData.curMin = Math.min(aggregatedMetricData.curMin, value);
                        aggregatedMetricData.curSum += value;
                    }
                    aggregatedMetricData.curTicks++;
                }
            });
            $1622be301bae0161$var$issueDetectors.forEach((issueDetector)=>{
                if (issueDetector.global && kind !== "global") return;
                if (!issueDetector.global && kind === "global") return;
                const issueKey = `${qualifierString}-${issueDetector.id}`;
                const enabled = issueDetector.enabled(checkData);
                let issueData = issuesAndMetrics.issues[issueKey];
                let aggregatedIssueData = $1622be301bae0161$var$aggregatedIssues[issueKey];
                if (enabled) {
                    if (!issueData) {
                        issueData = {
                            active: false,
                            ticks: 0,
                            registered: 0,
                            initial: 0,
                            periods: 0,
                            current: 0,
                            longest: 0
                        };
                        issuesAndMetrics.issues[issueKey] = issueData;
                    }
                    issueData.ticks++;
                    if (!aggregatedIssueData) {
                        aggregatedIssueData = {
                            active: false,
                            ticks: 0,
                            registered: 0,
                            initial: 0,
                            curTicks: 0,
                            curRegistered: 0
                        };
                        $1622be301bae0161$var$aggregatedIssues[issueKey] = aggregatedIssueData;
                    }
                    aggregatedIssueData.ticks++;
                    aggregatedIssueData.curTicks++;
                    const issueDetected = issueDetector.check(checkData);
                    if (issueDetected) {
                        issueData.registered++;
                        issueData.current++;
                        if (!issueData.active) {
                            issueData.active = true;
                            issueData.periods++;
                        }
                        if (issueData.ticks === issueData.initial + 1) {
                            issueData.initial++;
                            aggregatedIssueData.initial++;
                        }
                        if (issueData.current > issueData.longest) issueData.longest = issueData.current;
                        aggregatedIssueData.active = true;
                        aggregatedIssueData.registered++;
                        aggregatedIssueData.curRegistered++;
                    } else {
                        issueData.active = false;
                        issueData.current = 0;
                    }
                } else if (issueData) {
                    issueData.active = false;
                    issueData.current = 0;
                }
            });
        });
    });
    Object.values($1622be301bae0161$var$aggregatedMetrics).forEach((aggregatedMetricData)=>{
        if (aggregatedMetricData.curTicks) {
            aggregatedMetricData.curAvg = aggregatedMetricData.curSum / aggregatedMetricData.curTicks;
            if (aggregatedMetricData.totTicks === 0) {
                aggregatedMetricData.totMin = aggregatedMetricData.curSum;
                aggregatedMetricData.totMax = aggregatedMetricData.curSum;
            }
            aggregatedMetricData.totTicks++;
            aggregatedMetricData.totSum += aggregatedMetricData.curSum;
            aggregatedMetricData.totMin = Math.min(aggregatedMetricData.totMin, aggregatedMetricData.curSum);
            aggregatedMetricData.totMax = Math.max(aggregatedMetricData.totMax, aggregatedMetricData.curSum);
            aggregatedMetricData.totAvg = aggregatedMetricData.totSum / aggregatedMetricData.totTicks;
        }
    });
    Object.values($1622be301bae0161$var$aggregatedIssues).forEach((aggregateIssueData)=>{
        aggregateIssueData.curTicks;
    });
    $1622be301bae0161$var$subscriptions.forEach((subscription)=>{
        var _a;
        return (_a = subscription.onUpdatedIssues) === null || _a === void 0 ? void 0 : _a.call(subscription, $1622be301bae0161$var$issuesAndMetricsByView, statsByView, clients);
    });
}
function $1622be301bae0161$export$d2b2fe7aff003090(subscription) {
    $1622be301bae0161$var$subscriptions.push(subscription);
    if (!$1622be301bae0161$var$stopStats) $1622be301bae0161$var$stopStats = $1622be301bae0161$export$446568135c9b26ef({
        onUpdatedStats: $1622be301bae0161$var$onUpdatedStats
    }).stop;
    return {
        stop () {
            $1622be301bae0161$var$subscriptions = $1622be301bae0161$var$subscriptions.filter((s)=>s !== subscription);
            if (!$1622be301bae0161$var$subscriptions.length) {
                $1622be301bae0161$var$stopStats === null || $1622be301bae0161$var$stopStats === void 0 || $1622be301bae0161$var$stopStats();
                $1622be301bae0161$var$stopStats = null;
                $1622be301bae0161$var$initIssuesAndMetricsByView();
            }
        }
    };
}
const $1622be301bae0161$var$WINDOW_SIZE = 10;
const $1622be301bae0161$var$SET_TIMEOUT_INTERVAL = 500;
const $1622be301bae0161$var$RIC_TIMEOUT = 500;
const $1622be301bae0161$var$REPORTING_INTERVAL = 1000;
const $1622be301bae0161$var$buckets = [
    {
        name: "all",
        test: ({ avc: avc })=>avc >= 1
    },
    {
        name: "1",
        test: ({ avc: avc })=>avc === 1
    },
    {
        name: "2to4",
        test: ({ avc: avc })=>avc >= 2 && avc <= 4
    },
    {
        name: "5plus",
        test: ({ avc: avc })=>avc >= 5
    }
];
function $1622be301bae0161$export$a1839315f66842d4({ onMetricsUpdated: onMetricsUpdated, onTerminated: onTerminated, isHidden: isHidden }) {
    const decodedFpsSamplesByTrack = {};
    let currentMetrics = {};
    const aggregatedMetrics = {};
    let wasHidden = false;
    const reportingInterval = setInterval(()=>{
        if (wasHidden) {
            wasHidden = isHidden();
            return;
        }
        $1622be301bae0161$var$buckets.filter((bucket)=>bucket.test(currentMetrics)).forEach((bucket)=>{
            const bucketData = aggregatedMetrics[bucket.name] = aggregatedMetrics[bucket.name] || {};
            Object.entries(currentMetrics).forEach(([metric, value])=>{
                if (!bucketData[metric]) bucketData[metric] = {
                    min: value,
                    max: value,
                    avg: value,
                    sum: value,
                    cur: value,
                    count: 1
                };
                else {
                    const old = bucketData[metric];
                    bucketData[metric] = {
                        min: Math.min(old.min, value),
                        max: Math.max(old.max, value),
                        avg: (old.sum + value) / (old.count + 1),
                        sum: old.sum + value,
                        cur: value,
                        count: old.count + 1
                    };
                }
            });
        });
        onMetricsUpdated === null || onMetricsUpdated === void 0 || onMetricsUpdated(aggregatedMetrics);
    }, $1622be301bae0161$var$REPORTING_INTERVAL);
    let stHandle = 0;
    let ricHandle = 0;
    const measureScheduling = ()=>{
        const before = performance.now();
        stHandle = setTimeout(()=>{
            const delayed = Math.max(0, performance.now() - (before + $1622be301bae0161$var$SET_TIMEOUT_INTERVAL));
            currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                stLag: delayed
            });
            if (window.requestIdleCallback) {
                const beforeRic = performance.now();
                ricHandle = requestIdleCallback((idleDeadline)=>{
                    if (idleDeadline.didTimeout) currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                        ricLag: $1622be301bae0161$var$RIC_TIMEOUT
                    });
                    else currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                        ricLag: performance.now() - beforeRic
                    });
                }, {
                    timeout: $1622be301bae0161$var$RIC_TIMEOUT
                });
            }
            measureScheduling();
        }, $1622be301bae0161$var$SET_TIMEOUT_INTERVAL);
    };
    measureScheduling();
    return {
        registerDecodedFps: (fpsData)=>{
            if (wasHidden) return;
            const volatilityScores = fpsData.map(({ trackId: trackId, fps: fps })=>{
                const samples = decodedFpsSamplesByTrack[trackId] = decodedFpsSamplesByTrack[trackId] || [];
                samples.push(fps) > $1622be301bae0161$var$WINDOW_SIZE && samples.shift();
                const mean = samples.reduce((acc, val)=>acc + val, 0) / samples.length;
                const volatility = samples.reduce((acc, val)=>acc + Math.abs(val - mean), 0) / (samples.length * mean);
                return volatility;
            });
            if (volatilityScores.length) {
                const maxVolatility = Math.max(...volatilityScores);
                currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                    rrVol: maxVolatility,
                    avc: volatilityScores.length
                });
            }
        },
        terminate: ()=>{
            clearInterval(reportingInterval);
            clearTimeout(stHandle);
            if (ricHandle) cancelIdleCallback(ricHandle);
            onTerminated === null || onTerminated === void 0 || onTerminated();
        },
        updateHidden: ()=>{
            if (isHidden()) wasHidden = true;
        }
    };
}
class $1622be301bae0161$export$caeffa2537001230 {
    static parse(raw) {
        let object;
        try {
            object = JSON.parse(raw);
        } catch (error) {
            return;
        }
        if (typeof object !== "object" || Array.isArray(object)) return;
        if (object.request) return $1622be301bae0161$export$caeffa2537001230._handleRequest(object);
        else if (object.response) return $1622be301bae0161$export$caeffa2537001230._handleResponse(object);
        else if (object.message) return $1622be301bae0161$export$caeffa2537001230._handleMessage(object);
        else return;
    }
    static _handleRequest(rawMessage) {
        const message = {};
        message.request = true;
        if (typeof rawMessage.method !== "string") return;
        if (typeof rawMessage.id !== "number") return;
        message.id = rawMessage.id;
        message.method = rawMessage.method;
        message.data = rawMessage.data || {};
        return message;
    }
    static _handleResponse(rawMessage) {
        const message = {};
        message.response = true;
        if (typeof rawMessage.id !== "number") return;
        message.id = rawMessage.id;
        if (rawMessage.ok) {
            message.ok = true;
            message.data = rawMessage.data || {};
        } else {
            message.ok = false;
            message.errorCode = rawMessage.errorCode;
            message.errorReason = rawMessage.errorReason;
        }
        return message;
    }
    static _handleMessage(rawMessage) {
        const message = {};
        message.message = true;
        if (typeof rawMessage.method !== "string") return;
        message.method = rawMessage.method;
        message.data = rawMessage.data || {};
        return message;
    }
    static createRequest(method, data) {
        return {
            request: true,
            id: Math.round(Math.random() * 10000000),
            method: method,
            data: data || {}
        };
    }
    static createSuccessResponse(request, data) {
        return {
            response: true,
            id: request.id,
            ok: true,
            data: data || {}
        };
    }
    static createErrorResponse(request, errorCode, errorReason) {
        return {
            response: true,
            id: request.id,
            errorCode: errorCode,
            errorReason: errorReason
        };
    }
    static createMessage(method, data) {
        return {
            message: true,
            method: method,
            data: data || {}
        };
    }
}
const $1622be301bae0161$var$logger$9 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$b281e2872ffa0a70 extends (0, $11OXI.EventEmitter) {
    _setupSocket() {
        this.socket = new WebSocket(this.wsUrl, this.protocol);
        this.socket.onopen = this._onOpen.bind(this);
        this.socket.onmessage = this._onMessage.bind(this);
        this.socket.onclose = this._onClose.bind(this);
        this.socket.onerror = this._onError.bind(this);
    }
    _tearDown() {
        if (this.socket === null) return;
        this.socket.onopen = null;
        this.socket.onmessage = null;
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket = null;
        this.sents.forEach((sent)=>sent.close());
        this.emit("close");
    }
    close() {
        var _a;
        (_a = this.socket) === null || _a === void 0 || _a.close();
    }
    _onOpen() {
        $1622be301bae0161$var$logger$9.info("Connected");
        this.emit("open");
    }
    _onMessage(event) {
        const socketMessage = $1622be301bae0161$export$caeffa2537001230.parse(event.data);
        $1622be301bae0161$var$logger$9.info("Received message", socketMessage);
        if (socketMessage === null || socketMessage === void 0 ? void 0 : socketMessage.response) this._handleResponse(socketMessage);
        else if (socketMessage === null || socketMessage === void 0 ? void 0 : socketMessage.message) this.emit("message", socketMessage);
    }
    _onClose() {
        $1622be301bae0161$var$logger$9.info("Disconnected");
        this._tearDown();
    }
    _onError(error) {
        $1622be301bae0161$var$logger$9.info("Error", error);
    }
    _handleResponse(socketMessage) {
        const sent = this.sents.get(socketMessage.id);
        if (socketMessage.ok) sent.resolve(socketMessage.data);
        else {
            const error = new Error(socketMessage.errorReason);
            sent.reject(error);
        }
    }
    send(message) {
        try {
            if (this.socket) this.socket.send(JSON.stringify(message));
        } catch (error) {}
    }
    message(method, data = {}) {
        const message = $1622be301bae0161$export$caeffa2537001230.createMessage(method, data);
        this.send(message);
    }
    request(method, data = {}, timeout = 1500 * (15 + 0.1 * this.sents.size)) {
        const request = $1622be301bae0161$export$caeffa2537001230.createRequest(method, data);
        this.send(request);
        return new Promise((pResolve, pReject)=>{
            const sent = {
                id: request.id,
                method: request.method,
                resolve: (data2)=>{
                    if (!this.sents.delete(request.id)) return;
                    clearTimeout(sent.timer);
                    pResolve(data2);
                },
                reject: (error)=>{
                    if (!this.sents.delete(request.id)) return;
                    clearTimeout(sent.timer);
                    pReject(error);
                },
                timer: setTimeout(()=>{
                    if (!this.sents.delete(request.id)) return;
                    pReject(new Error("request timeout"));
                }, timeout),
                close: ()=>{
                    clearTimeout(sent.timer);
                    pReject(new Error("transport closed"));
                }
            };
            this.sents.set(request.id, sent);
        });
    }
    constructor(wsUrl, protocol = "whereby-sfu#v4"){
        super();
        this.socket = null;
        this.wsUrl = wsUrl;
        this.protocol = protocol;
        this.sents = new Map();
        this._setupSocket();
    }
}
const $1622be301bae0161$var$AUDIO_SETTINGS = {
    codecOptions: {
        opusDtx: true,
        opusFec: true
    },
    encodings: [
        {
            dtx: true
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_HD = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scaleResolutionDownBy: 4,
            maxBitrate: 150000
        },
        {
            scaleResolutionDownBy: 2,
            maxBitrate: 500000
        },
        {
            scaleResolutionDownBy: 1,
            maxBitrate: 1000000
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_SD = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scaleResolutionDownBy: 2,
            maxBitrate: 150000
        },
        {
            scaleResolutionDownBy: 1,
            maxBitrate: 500000
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_VP9 = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scalabilityMode: "L3T2_KEY"
        }
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SETTINGS = {
    encodings: [
        {}
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SIMULCAST_SETTINGS = {
    encodings: [
        {
            scaleResolutionDownBy: 2,
            dtx: true,
            maxBitrate: 500000
        },
        {
            scaleResolutionDownBy: 1,
            dtx: true,
            maxBitrate: 1500000
        }
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SETTINGS_VP9 = {
    encodings: [
        {
            dtx: true
        }
    ]
};
const $1622be301bae0161$export$71f7c171c9088ed4 = (kind, isScreenShare, features)=>{
    const { lowDataModeEnabled: lowDataModeEnabled, simulcastScreenshareOn: simulcastScreenshareOn, vp9On: vp9On } = features;
    if (kind === "audio") return $1622be301bae0161$var$AUDIO_SETTINGS;
    if (isScreenShare) {
        if (vp9On) return $1622be301bae0161$var$SCREEN_SHARE_SETTINGS_VP9;
        if (simulcastScreenshareOn) return $1622be301bae0161$var$SCREEN_SHARE_SIMULCAST_SETTINGS;
        return $1622be301bae0161$var$SCREEN_SHARE_SETTINGS;
    } else {
        if (vp9On) return $1622be301bae0161$var$VIDEO_SETTINGS_VP9;
        if (lowDataModeEnabled) return $1622be301bae0161$var$VIDEO_SETTINGS_SD;
        return $1622be301bae0161$var$VIDEO_SETTINGS_HD;
    }
};
const $1622be301bae0161$export$1cbfd4deae6f916f = (routerRtpCapabilities, features)=>{
    const { vp9On: vp9On, h264On: h264On } = features;
    if (vp9On) {
        const { preferredPayloadType: preferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/vp9");
        const { preferredPayloadType: aptPreferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/rtx" && codec.parameters.apt === preferredPayloadType);
        routerRtpCapabilities.codecs = routerRtpCapabilities.codecs.filter((codec)=>codec.kind === "audio" || codec.preferredPayloadType === preferredPayloadType || codec.preferredPayloadType === aptPreferredPayloadType);
    } else if (h264On) {
        const { preferredPayloadType: preferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/h264");
        const { preferredPayloadType: aptPreferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/rtx" && codec.parameters.apt === preferredPayloadType);
        routerRtpCapabilities.codecs = routerRtpCapabilities.codecs.filter((codec)=>codec.kind === "audio" || codec.preferredPayloadType === preferredPayloadType || codec.preferredPayloadType === aptPreferredPayloadType);
    }
};
const $1622be301bae0161$export$30afcaff46935060 = ()=>{
    let handlerName = (0, $92a5db02d3c83225$exports.detectDevice)() || (/applecoremedia|applewebkit|safari/i.test(navigator.userAgent) ? "Safari12" : undefined);
    if (/iphone|ipad/i.test(navigator.userAgent)) handlerName = "Safari12";
    return handlerName;
};
const $1622be301bae0161$var$logger$8 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$fc97fdee86457200 extends (0, (/*@__PURE__*/$parcel$interopDefault($11OXI))) {
    start(runTime = 15) {
        if (this.closed) return;
        if (runTime < 10) {
            this.emit("result", {
                error: true,
                details: {
                    timeout: true
                }
            });
            return this.close();
        }
        this._runTime = runTime;
        this._startTime = Date.now();
        const host = this._features.sfuServerOverrideHost || "any.sfu.whereby.com";
        const wsUrl = `wss://${host}`;
        this._vegaConnection = new $1622be301bae0161$export$b281e2872ffa0a70(wsUrl, "whereby-sfu#bw-test-v1");
        this._vegaConnection.on("open", ()=>this._start());
        this._vegaConnection.on("close", ()=>this.close());
        this._vegaConnection.on("message", (message)=>this._onMessage(message));
        this._startTimeout();
    }
    close() {
        $1622be301bae0161$var$logger$8.info("close()");
        this.closed = true;
        this._clearTimeouts();
        clearInterval(this._drawInterval);
        this._drawInterval = null;
        if (this._sendTransport) {
            this._sendTransport.removeAllListeners();
            this._sendTransport.close();
        }
        this._sendTransport = null;
        if (this._receiveTransport) {
            this._receiveTransport.removeAllListeners();
            this._receiveTransport.close();
        }
        this._receiveTransport = null;
        this._mediasoupDevice = null;
        if (this._vegaConnection) {
            this._vegaConnection.removeAllListeners();
            this._vegaConnection.close();
        }
        this._vegaConnection = null;
        this.emit("close");
    }
    _start() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$8.info("_start()");
            this._connectTime = Date.now() - this._startTime;
            if (this._connectTime > 5000) {
                this.emit("result", {
                    error: true,
                    details: {
                        timeout: true
                    }
                });
                return this.close();
            }
            this._clearTimeouts();
            try {
                const { routerRtpCapabilities: routerRtpCapabilities } = yield this._vegaConnection.request("getCapabilities");
                if (!this._routerRtpCapabilities) {
                    $1622be301bae0161$export$1cbfd4deae6f916f(routerRtpCapabilities, this._features);
                    this._routerRtpCapabilities = routerRtpCapabilities;
                    yield this._mediasoupDevice.load({
                        routerRtpCapabilities: routerRtpCapabilities
                    });
                }
                this._vegaConnection.message("setCapabilities", {
                    rtpCapabilities: this._mediasoupDevice.rtpCapabilities
                });
                yield Promise.all([
                    this._createTransport(true),
                    this._createTransport(false)
                ]);
                yield this._createProducer();
                this._mediaEstablishedTime = Date.now() - this._startTime;
                if (this._mediaEstablishedTime > 5000) {
                    this.emit("result", {
                        error: true,
                        details: {
                            timeout: true
                        }
                    });
                    return this.close();
                }
                this._resultTimeout = setTimeout(()=>{
                    this._reportResults();
                }, this._runTime * 1000 - this._mediaEstablishedTime);
            } catch (error) {
                $1622be301bae0161$var$logger$8.error("_start() [error:%o]", error);
                this.emit("result", {
                    error: true,
                    details: {
                        timeout: true
                    }
                });
                this.close();
            }
        });
    }
    _createTransport(send) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const creator = send ? "createSendTransport" : "createRecvTransport";
            const transportOptions = yield this._vegaConnection.request("createTransport", {
                producing: send,
                consuming: !send,
                enableTcp: true,
                enableUdp: true,
                preferUdp: true
            });
            transportOptions.iceServers = [
                {
                    urls: "stun:any.turn.whereby.com"
                }
            ];
            const transport = this._mediasoupDevice[creator](transportOptions);
            transport.on("connect", ({ dtlsParameters: dtlsParameters }, callback)=>{
                this._vegaConnection.message("connectTransport", {
                    transportId: transport.id,
                    dtlsParameters: dtlsParameters
                });
                callback();
            });
            if (send) {
                transport.on("produce", ({ kind: kind, rtpParameters: rtpParameters, appData: appData }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        try {
                            const { paused: paused } = appData;
                            const { id: id } = yield this._vegaConnection.request("produce", {
                                transportId: transport.id,
                                kind: kind,
                                rtpParameters: rtpParameters,
                                paused: paused,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                this._sendTransport = transport;
            } else this._receiveTransport = transport;
        });
    }
    _getTestTrack() {
        this._canvas = document.createElement("canvas");
        this._canvas.width = 1280;
        this._canvas.height = 720;
        document.body.appendChild(this._canvas);
        this._canvas.style.position = "absolute";
        this._canvas.style.right = "0";
        this._canvas.style.bottom = "0";
        this._canvas.style.width = "1px";
        this._canvas.style.height = "1px";
        this._canvas.style.opacity = "0";
        const context = this._canvas.getContext("2d");
        const ball = {
            x: 150,
            y: 150
        };
        const velocity = 50;
        const startingAngle = 70;
        const rad = 100;
        let moveX = Math.cos(Math.PI / 180 * startingAngle) * velocity;
        let moveY = Math.sin(Math.PI / 180 * startingAngle) * velocity;
        const draw = ()=>{
            if (this.closed) return;
            const now = Date.now();
            context.fillStyle = `rgb(
                ${Math.floor(255 - 0.35 * ball.y)},
                ${Math.floor(255 - 0.18 * ball.x)},
                0)`;
            context.fillRect(0, 0, this._canvas.width, this._canvas.height);
            context.fillStyle = "white";
            context.font = "30px Arial";
            context.fillText("Whereby", 10, 50);
            context.font = "20px Arial";
            context.fillText("Test", 10, 80);
            context.font = "20px Arial";
            context.fillText(`Time: ${now - this._startTime}ms`, 10, 110);
            context.font = "20px Arial";
            if (this._connectTime) context.fillText(`Connect: ${this._connectTime}ms`, 10, 140);
            if (this._mediaEstablishedTime) context.fillText(`Media: ${this._mediaEstablishedTime}ms`, 10, 170);
            if (ball.x > this._canvas.width - rad || ball.x < rad) moveX = -moveX;
            if (ball.y > this._canvas.height - rad || ball.y < rad) moveY = -moveY;
            ball.x += moveX;
            ball.y += moveY;
            context.beginPath();
            context.fillStyle = `rgb(
                ${Math.floor(255 - 0.18 * ball.x)},
                ${Math.floor(255 - 0.35 * ball.y)},
                0)`;
            context.arc(ball.x, ball.y, rad, 0, Math.PI * 2);
            context.fill();
            context.closePath();
        };
        this._drawInterval = setInterval(draw, 33);
        const fakeStream = this._canvas.captureStream(30);
        const [fakeVideoTrack] = fakeStream.getVideoTracks();
        return fakeVideoTrack;
    }
    _createProducer() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const track = this._getTestTrack();
            const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                track: track
            }, $1622be301bae0161$export$71f7c171c9088ed4("video", false, this._features)), {
                appData: {
                    paused: false
                }
            }));
            this._producer = producer;
            producer.observer.once("close", ()=>{
                $1622be301bae0161$var$logger$8.info('producer "close" event');
                this._producer = null;
            });
        });
    }
    _onMessage(message) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { method: method, data: data } = message;
            return Promise.resolve().then(()=>{
                switch(method){
                    case "consumerReady":
                        return this._onConsumerReady(data);
                    case "consumerClosed":
                        return this._onConsumerClosed(data);
                    default:
                        $1622be301bae0161$var$logger$8.info(`unknown message method "${method}"`);
                        return;
                }
            }).catch((error)=>{
                $1622be301bae0161$var$logger$8.error('"message" failed [error:%o]', error);
            });
        });
    }
    _onConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const consumer = yield this._receiveTransport.consume(options);
            consumer.once("close", ()=>{
                this._consumers.delete(consumer.id);
            });
            this._consumers.set(consumer.id, consumer);
            this._vegaConnection.message("resumeConsumers", {
                consumerIds: [
                    consumer.id
                ]
            });
        });
    }
    _onConsumerClosed({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$8.info("_onConsumerClosed()");
        const consumer = this._consumers.get(consumerId);
        if (consumer) consumer.close();
    }
    _reportResults() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const [localSendStats, localRecvStats] = yield Promise.all([
                this._sendTransport.getStats(),
                this._receiveTransport.getStats()
            ]);
            const { recvStats: [remoteRecvStats = null] = [] } = yield this._vegaConnection.request("getTransportStats");
            const { availableOutgoingBitrate: availableOutgoingBitrate = 5000000 } = remoteRecvStats || {};
            let outboundPackets = 0;
            let remotePacketsLost = 0;
            localSendStats.forEach((localSendStat)=>{
                if (localSendStat.type === "outbound-rtp" && typeof localSendStat.packetsSent === "number") outboundPackets += localSendStat.packetsSent;
                else if (localSendStat.type === "remote-inbound-rtp" && typeof localSendStat.packetsLost === "number") remotePacketsLost += localSendStat.packetsLost;
            });
            let inboundPackets = 0;
            let packetsLost = 0;
            localRecvStats.forEach((localRecvStat)=>{
                if (localRecvStat.type === "inbound-rtp" && typeof localRecvStat.packetsReceived === "number" && typeof localRecvStat.packetsLost === "number") {
                    inboundPackets += localRecvStat.packetsReceived;
                    packetsLost += localRecvStat.packetsLost;
                }
            });
            const recvAvailableBitrate = availableOutgoingBitrate / 1000000.0;
            const lowRecvAvailableBitrate = recvAvailableBitrate < 1.5;
            const sendLoss = remotePacketsLost / outboundPackets;
            const recvLoss = packetsLost / inboundPackets;
            const highSendLoss = sendLoss > 0.03;
            const highRecvLoss = recvLoss > 0.03;
            const testTime = Date.now() - this._startTime;
            const warning = lowRecvAvailableBitrate || highRecvLoss || highSendLoss;
            const success = !warning;
            this.emit("result", {
                warning: warning,
                success: success,
                details: {
                    testTime: testTime,
                    recvAvailableBitrate: recvAvailableBitrate,
                    lowRecvAvailableBitrate: lowRecvAvailableBitrate,
                    highSendLoss: highSendLoss,
                    highRecvLoss: highRecvLoss,
                    sendLoss: sendLoss,
                    recvLoss: recvLoss
                }
            });
            this.close();
        });
    }
    _startTimeout(seconds = 5) {
        this._timeout = setTimeout(()=>{
            this.emit("result", {
                error: true,
                details: {
                    timeout: true
                }
            });
            this.close();
        }, seconds * 1000);
    }
    _clearTimeouts() {
        clearTimeout(this._timeout);
        this._timeout = null;
        clearTimeout(this._reportTimeout);
        this._reportTimeout = null;
    }
    constructor({ features: features } = {}){
        super();
        this.closed = false;
        this._features = features || {};
        this._vegaConnection = null;
        this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerName: $1622be301bae0161$export$30afcaff46935060()
        });
        this._routerRtpCapabilities = null;
        this._sendTransport = null;
        this._receiveTransport = null;
        this._producer = null;
        this._consumers = new Map();
        this._startTime = null;
        this._connectTime = null;
        this._mediaEstablishedTime = null;
        this._runTime = null;
        this._endTime = null;
        this._timeout = null;
        this._canvas = null;
        this._drawInterval = null;
        this._resultTimeout = null;
    }
}
var $1622be301bae0161$var$_a$7;
const $1622be301bae0161$var$adapter$6 = ($1622be301bae0161$var$_a$7 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$7 !== void 0 ? $1622be301bae0161$var$_a$7 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
function $1622be301bae0161$export$60abf66a104f71b0(pc) {
    if ($1622be301bae0161$var$adapter$6.browserDetails.browser !== "chrome" || $1622be301bae0161$var$adapter$6.browserDetails.browser < 58 || pc.signalingState === "closed") return Promise.resolve(false);
    const sendingAudio = pc.getSenders().some((sender)=>sender.track && sender.track.kind === "audio");
    const receivingAudio = pc.getReceivers().some((receiver)=>receiver.track && receiver.track.kind === "audio");
    return pc.getStats(null).then((result)=>{
        let microphoneFailed = false;
        result.forEach((report)=>{
            if (report.type === "outbound-rtp" && (report.kind === "audio" || report.mediaType === "audio") && sendingAudio) {
                if (report.bytesSent === 0) microphoneFailed = "outbound";
            } else if (report.type === "inbound-rtp" && (report.kind === "audio" || report.mediaType === "audio") && receivingAudio) {
                if (report.bytesReceived === 0) microphoneFailed = "inbound";
            }
        });
        return microphoneFailed;
    });
}
const $1622be301bae0161$export$737bc7bda2eb5bf5 = 1280;
const $1622be301bae0161$export$6bb71afef3ab9ece = -1;
const $1622be301bae0161$export$87d0694e432db510 = 400;
var $1622be301bae0161$var$_a$6;
const $1622be301bae0161$var$adapter$5 = ($1622be301bae0161$var$_a$6 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$6 !== void 0 ? $1622be301bae0161$var$_a$6 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$isSafari = $1622be301bae0161$var$adapter$5.browserDetails.browser === "safari";
const $1622be301bae0161$var$parseResolution = (res)=>res.split(/[^\d]/g).map((n)=>parseInt(n, 10));
function $1622be301bae0161$export$f9017448876882a4({ disableAEC: disableAEC, disableAGC: disableAGC, hd: hd, lax: lax, lowDataMode: lowDataMode, preferredDeviceIds: preferredDeviceIds, resolution: resolution, simulcast: simulcast, widescreen: widescreen }) {
    var _a, _b;
    let HIGH_HEIGHT = 480;
    let LOW_HEIGHT = 240;
    if (hd) HIGH_HEIGHT = lax || $1622be301bae0161$var$isSafari ? 720 : {
        min: 360,
        ideal: 720
    };
    if (simulcast) {
        if (hd === false) {
            HIGH_HEIGHT = 360;
            LOW_HEIGHT = 270;
        } else LOW_HEIGHT = 360;
    }
    const constraints = {
        audio: Object.assign({}, preferredDeviceIds.audioId && {
            deviceId: preferredDeviceIds.audioId
        }),
        video: Object.assign(Object.assign({}, preferredDeviceIds.videoId ? {
            deviceId: preferredDeviceIds.videoId
        } : {
            facingMode: "user"
        }), {
            height: lowDataMode ? LOW_HEIGHT : HIGH_HEIGHT,
            frameRate: lowDataMode && !simulcast ? 15 : 24
        })
    };
    if (lax) {
        if (!((_a = constraints.audio) === null || _a === void 0 ? void 0 : _a.deviceId)) constraints.audio = true;
        (_b = constraints.video) === null || _b === void 0 || delete _b.facingMode;
        return constraints;
    }
    if (resolution) {
        const [w, h, fps] = $1622be301bae0161$var$parseResolution(resolution);
        if (w) constraints.video.width = {
            exact: w
        };
        if (h) constraints.video.height = {
            exact: h
        };
        if (fps) constraints.video.frameRate = {
            exact: fps
        };
        delete constraints.video.facingMode;
    } else constraints.video.aspectRatio = widescreen ? 16 / 9 : 4 / 3;
    if (disableAGC) constraints.audio.autoGainControl = false;
    if (disableAEC) constraints.audio.echoCancellation = false;
    return constraints;
}
function $1622be301bae0161$export$86f10caa3f7697c2({ devices: devices, videoId: videoId, audioId: audioId, options: options, type: type = "ideal" }) {
    const audioDevices = devices.filter((d)=>d.kind === "audioinput");
    const videoDevices = devices.filter((d)=>d.kind === "videoinput");
    const useDefaultAudio = !audioId || !audioDevices.some((d)=>d.deviceId === audioId);
    const useDefaultVideo = !videoId || !videoDevices.some((d)=>d.deviceId === videoId);
    const constraints = $1622be301bae0161$export$f9017448876882a4(Object.assign({
        preferredDeviceIds: {
            audioId: useDefaultAudio ? null : {
                [type]: audioId
            },
            videoId: useDefaultVideo ? null : {
                [type]: videoId
            }
        }
    }, options));
    if (audioId === false || !audioDevices.length) delete constraints.audio;
    if (videoId === false || !videoDevices.length) delete constraints.video;
    return constraints;
}
const $1622be301bae0161$var$logger$7 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$export$d0a8044dce8ff2fc = /mobi/i.test(navigator.userAgent);
class $1622be301bae0161$export$fbb4d6e7253c7ce9 extends Error {
    constructor(...args){
        super(...args);
        this.name = "nodevices";
    }
}
function $1622be301bae0161$var$removeDuplicates(devices) {
    return devices.filter((device, i, self)=>i === self.findIndex((d)=>d.deviceId === device.deviceId && d.kind === device.kind));
}
function $1622be301bae0161$export$45a3175d55604f4() {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const devices = yield navigator.mediaDevices.enumerateDevices();
        const filteredDevices = $1622be301bae0161$var$removeDuplicates(devices);
        return filteredDevices;
    });
}
const $1622be301bae0161$var$idFieldsByKind = {
    audioinput: "audioId",
    videoinput: "videoId",
    audiooutput: "speakerId"
};
function $1622be301bae0161$export$8c4ae462a632eefd({ busyDeviceIds: busyDeviceIds, devices: devices, kind: kind }) {
    const deviceList = devices && devices.length && devices.filter((d)=>d.kind === kind).map((d)=>({
            [$1622be301bae0161$var$idFieldsByKind[kind]]: d.deviceId,
            label: `${busyDeviceIds.includes(d.deviceId) ? "(busy) " : ""}${d.label || d.deviceId.slice(0, 5)}`,
            busy: busyDeviceIds.includes(d.deviceId)
        }));
    return deviceList && deviceList.length !== 0 ? deviceList : [
        {
            [$1622be301bae0161$var$idFieldsByKind[kind]]: "",
            label: "Default"
        }
    ];
}
function $1622be301bae0161$export$c396324ce11e3eef(constraints) {
    if (!constraints.audio && !constraints.video) return Promise.reject(new $1622be301bae0161$export$fbb4d6e7253c7ce9("No provided devices"));
    return navigator.mediaDevices.getUserMedia(constraints).catch((error)=>{
        const message = `${error}, ${JSON.stringify(constraints, null, 2)}`;
        $1622be301bae0161$var$logger$7.error(`getUserMedia ${message}`);
        throw error;
    });
}
function $1622be301bae0161$var$getSettingsFromTrack(kind, track, devices, lastUsedId) {
    var _a, _b, _c;
    let settings = {
        deviceId: null
    };
    if (!track) {
        if (lastUsedId && devices) settings.deviceId = (_a = devices.find((d)=>d.deviceId === lastUsedId && d.kind === kind)) === null || _a === void 0 ? void 0 : _a.deviceId;
        return settings;
    }
    settings.label = track.label;
    if (track.getSettings) settings = Object.assign(Object.assign({}, settings), track.getSettings());
    if (settings.deviceId) return settings;
    if (track.getCapabilities) settings.deviceId = track.getCapabilities().deviceId;
    if (settings.deviceId) return settings;
    if (track.label && devices) settings.deviceId = (_b = devices.find((d)=>track.label === d.label && d.kind === kind)) === null || _b === void 0 ? void 0 : _b.deviceId;
    if (settings.deviceId) return settings;
    settings.deviceId = (_c = track.getConstraints()) === null || _c === void 0 ? void 0 : _c.deviceId;
    settings.broken = 1;
    return settings;
}
function $1622be301bae0161$export$fb9ff29788bfaf04({ audioTrack: audioTrack, videoTrack: videoTrack, devices: devices, stoppedVideoTrack: stoppedVideoTrack, lastAudioId: lastAudioId, lastVideoId: lastVideoId }) {
    const usable = (d)=>(d === null || d === void 0 ? void 0 : d.readyState) === "live" ? d : null;
    videoTrack = usable(videoTrack) || stoppedVideoTrack;
    audioTrack = usable(audioTrack);
    const video = $1622be301bae0161$var$getSettingsFromTrack("videoinput", videoTrack, devices, lastVideoId);
    const audio = $1622be301bae0161$var$getSettingsFromTrack("audioinput", audioTrack, devices, lastAudioId);
    return {
        video: video,
        audio: audio
    };
}
function $1622be301bae0161$export$c9e077842bfa3912(stream, only) {
    if (!only || only === "audio") stream.getAudioTracks().forEach((t)=>t.stop());
    if (!only || only === "video") stream.getVideoTracks().forEach((t)=>t.stop());
}
function $1622be301bae0161$export$f0e52ad0c2c2903e(stream, newStream, only) {
    const replacedTracks = [];
    if (!only || only === "audio") {
        replacedTracks.push(...stream.getAudioTracks());
        newStream.getAudioTracks().forEach((track)=>{
            track.replacement = true;
            stream.addTrack(track);
        });
    }
    if (!only || only === "video") {
        replacedTracks.push(...stream.getVideoTracks());
        newStream.getVideoTracks().forEach((track)=>{
            track.replacement = true;
            stream.addTrack(track);
        });
    }
    replacedTracks.forEach((track)=>{
        track.replaced = true;
        stream.removeTrack(track);
    });
    return replacedTracks;
}
function $1622be301bae0161$var$getTrack({ kind: kind, deviceId: deviceId, type: type, fallback: fallback = true, primerTrack: primerTrack }) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const devId = (deviceId)=>type === "exact" ? {
                deviceId: {
                    exact: deviceId
                }
            } : {
                deviceId: deviceId
            };
        const constraints = {
            [kind]: deviceId ? devId(deviceId) : kind === "video" ? {
                facingMode: "user"
            } : true
        };
        let stream;
        try {
            stream = yield $1622be301bae0161$export$c396324ce11e3eef(constraints);
        } catch (e) {
            if (!fallback) {
                e.details = {
                    constraints: constraints,
                    constraint: e.constraint
                };
                throw e;
            }
            if (primerTrack) return primerTrack;
            stream = yield $1622be301bae0161$export$c396324ce11e3eef({
                [kind]: true
            });
        }
        return stream.getTracks()[0];
    });
}
function $1622be301bae0161$var$constrainTrack(track, constraints) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        while(constraints.length)try {
            yield track.applyConstraints(Object.assign({}, ...constraints));
            break;
        } catch (e) {
            const c = constraints.pop();
            $1622be301bae0161$var$logger$7.warn(`unable to apply ${JSON.stringify(c)}`, e);
        }
    });
}
function $1622be301bae0161$export$c598f98c12f8be34(constraintOpt, additionalOpts = {}) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const { audioId: audioId, videoId: videoId, devices: devices, type: type, options: options } = constraintOpt;
        const { replaceStream: replaceStream, fallback: fallback } = additionalOpts;
        const hasGrantedPermissions = !!devices.find((d)=>d.label !== "");
        let audioPrimerTrack;
        let videoPrimerTrack;
        if (!hasGrantedPermissions) try {
            const primerStream = yield $1622be301bae0161$export$c396324ce11e3eef({
                audio: constraintOpt.audioId !== false,
                video: constraintOpt.videoId !== false
            });
            audioPrimerTrack = primerStream.getAudioTracks()[0];
            videoPrimerTrack = primerStream.getVideoTracks()[0];
        } catch (err) {
            if (err.name === "NotAllowedError") throw err;
        }
        const getAudio = ()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                if (audioId === false) return false;
                if (replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, "audio");
                const audioTrack = yield $1622be301bae0161$var$getTrack({
                    deviceId: audioId,
                    type: type,
                    kind: "audio",
                    fallback: fallback,
                    primerTrack: audioPrimerTrack
                });
                if (audioPrimerTrack && audioTrack !== audioPrimerTrack) audioPrimerTrack.stop();
                const { disableAEC: disableAEC, disableAGC: disableAGC } = options;
                const changes = [];
                if (disableAGC) changes.push({
                    autoGainControl: false
                });
                if (disableAEC) changes.push({
                    echoCancellation: false
                });
                yield $1622be301bae0161$var$constrainTrack(audioTrack, changes);
                return audioTrack;
            });
        const getVideo = ()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                if (videoId === false) return false;
                if (replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, "video");
                const videoTrack = yield $1622be301bae0161$var$getTrack({
                    deviceId: videoId,
                    type: type,
                    kind: "video",
                    fallback: fallback,
                    primerTrack: videoPrimerTrack
                });
                if (videoPrimerTrack && videoTrack !== videoPrimerTrack) videoPrimerTrack.stop();
                const { lowDataMode: lowDataMode, simulcast: simulcast, usingAspectRatio16x9: usingAspectRatio16x9 } = options;
                const changes = [];
                if (lowDataMode) changes.push({
                    frameRate: simulcast ? 30 : 15
                });
                if (usingAspectRatio16x9) changes.push({
                    aspectRatio: 16 / 9
                });
                if (lowDataMode) changes.push({
                    width: {
                        max: simulcast ? 640 : 320
                    }
                });
                else changes.push({
                    width: {
                        max: 1280
                    }
                });
                yield $1622be301bae0161$var$constrainTrack(videoTrack, changes);
                return videoTrack;
            });
        const audioPromise = getAudio();
        const videoPromise = getVideo();
        let audioTrack;
        let videoTrack;
        let error;
        try {
            audioTrack = yield audioPromise;
        } catch (e) {
            error = e;
            if (type === "exact") throw e;
        }
        try {
            videoTrack = yield videoPromise;
        } catch (e) {
            error = e;
            if (type === "exact") throw e;
        }
        const newStream = new MediaStream([
            audioTrack,
            videoTrack
        ].filter(Boolean));
        let replacedTracks;
        if (replaceStream) {
            const only = audioId === false && "video" || videoId === false && "audio" || "audio";
            replacedTracks = $1622be301bae0161$export$f0e52ad0c2c2903e(replaceStream, newStream, only);
        }
        return {
            stream: replaceStream || newStream,
            error: error,
            replacedTracks: replacedTracks
        };
    });
}
function $1622be301bae0161$export$747191980cdf43e8(constraintOpt, { replaceStream: replaceStream, fallback: fallback = true } = {}) {
    var _a;
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        let error;
        let newConstraints;
        let retryConstraintOpt;
        let stream = null;
        const only = constraintOpt.audioId === false && "video" || constraintOpt.videoId === false && "audio";
        const stopTracks = $1622be301bae0161$export$d0a8044dce8ff2fc || only !== "video";
        const constraints = $1622be301bae0161$export$86f10caa3f7697c2(constraintOpt);
        const addDetails = (err, orgErr)=>{
            err.details = Object.assign({
                constraints: constraints,
                constraint: err.constraint || (orgErr === null || orgErr === void 0 ? void 0 : orgErr.constraint),
                newConstraints: newConstraints,
                fallback: fallback,
                stopTracks: stopTracks
            }, err !== error && {
                error: String(error)
            });
            return err;
        };
        if (stopTracks && replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
        try {
            stream = yield $1622be301bae0161$export$c396324ce11e3eef(constraints);
        } catch (e) {
            error = e;
            if (!fallback) throw addDetails(e);
            if (e.name === "OverconstrainedError") {
                const laxConstraints = {
                    deviceId: {
                        videoId: null,
                        audioId: null
                    },
                    width: {
                        lax: true
                    },
                    height: {
                        lax: true
                    },
                    "": {
                        audioId: null,
                        videoId: null,
                        lax: true
                    }
                };
                retryConstraintOpt = laxConstraints[e.constraint || ""];
            } else if (e.name === "NotFoundError") {
                if (constraints.audio && constraints.video) {
                    try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            audioId: false
                        })));
                    } catch (e2) {
                        if (e2.name !== "NotFoundError") throw addDetails(e2, e);
                    }
                    try {
                        if (!stream) stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            videoId: false
                        })));
                    } catch (e2) {
                        throw addDetails(e2, e);
                    }
                }
            } else if (e.name === "NotAllowedError" || e.name === "NotReadableError" || e.name === "AbortError") {
                if (replaceStream && !stopTracks) {
                    $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
                    retryConstraintOpt = constraintOpt;
                } else if (e.name !== "NotAllowedError") {
                    try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            options: Object.assign(Object.assign({}, constraintOpt.options), {
                                lax: true
                            })
                        })));
                    } catch (e2) {
                        $1622be301bae0161$var$logger$7.warn(`Tried getting stream again with laxer constraints, but failed: ${"" + e2}`);
                    }
                    const errMsg = ("" + e).toLowerCase();
                    const problemWith = {
                        audio: "audioId",
                        video: "videoId"
                    }[((_a = /(video|audio)/.exec(errMsg)) === null || _a === void 0 ? void 0 : _a[0]) || only || ""];
                    if (!stream && problemWith) try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            [problemWith]: null
                        })));
                    } catch (e2) {
                        $1622be301bae0161$var$logger$7.warn(`Re-tried ${problemWith} with no constraints, but failed: ${"" + e2}`);
                    }
                    if (!stream) {
                        const tryOnly = problemWith ? [
                            problemWith
                        ] : [
                            "videoId",
                            "audioId"
                        ];
                        for (const kind of tryOnly){
                            try {
                                stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                                    [kind]: false
                                })));
                            } catch (e2) {
                                $1622be301bae0161$var$logger$7.warn(`Re-tried without ${kind}, but failed: ${"" + e2}`);
                            }
                            if (stream) break;
                        }
                    }
                }
            }
        }
        if (retryConstraintOpt) {
            const onlyConstraints = only ? ({
                audio: {
                    videoId: false
                },
                video: {
                    audioId: false
                }
            })[only] : {};
            newConstraints = $1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign(Object.assign(Object.assign({}, constraintOpt), retryConstraintOpt), {
                options: Object.assign(Object.assign({}, constraintOpt.options), {
                    lax: retryConstraintOpt.lax
                })
            }), onlyConstraints));
            try {
                stream = yield $1622be301bae0161$export$c396324ce11e3eef(newConstraints);
            } catch (e) {
                throw addDetails(e, error);
            }
        }
        if (!stream) throw addDetails(error);
        let replacedTracks;
        if (replaceStream) {
            if (!stopTracks) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
            replacedTracks = $1622be301bae0161$export$f0e52ad0c2c2903e(replaceStream, stream, only);
            stream = replaceStream;
        }
        return {
            error: error && addDetails(error),
            stream: stream,
            replacedTracks: replacedTracks
        };
    });
}
function $1622be301bae0161$export$ec692da3ca415072() {
    if ($parcel$global.navigator.userAgent.includes("Android")) return false;
    return !!($parcel$global.navigator.mediaDevices || {}).getDisplayMedia;
}
const $1622be301bae0161$var$defaultDisplayMediaConstraints = {
    video: {
        width: {
            max: window.screen.width
        },
        height: {
            max: window.screen.height
        }
    }
};
function $1622be301bae0161$export$251c1161688ff522(constraints = $1622be301bae0161$var$defaultDisplayMediaConstraints, contentHint = "detail") {
    return navigator.mediaDevices.getDisplayMedia(constraints).then((stream)=>{
        stream.getVideoTracks().forEach((t)=>{
            if ("contentHint" in t) t.contentHint = contentHint;
        });
        return stream;
    });
}
function $1622be301bae0161$export$47595e93b87b07e9(before, after) {
    const [beforeByKind, afterByKind] = [
        before,
        after
    ].map((list)=>list.filter((device)=>device.kind && device.deviceId).reduce((result, device)=>Object.assign(Object.assign({}, result), {
                [device.kind]: Object.assign(Object.assign({}, result[device.kind]), {
                    [device.deviceId]: device
                })
            }), {}));
    const changesByKind = {};
    before.forEach((device)=>{
        if (!device.kind || !device.deviceId) return;
        if (!changesByKind[device.kind]) changesByKind[device.kind] = {
            added: {},
            removed: {},
            changed: {}
        };
        if (!afterByKind[device.kind] || !afterByKind[device.kind][device.deviceId]) changesByKind[device.kind].removed[device.deviceId] = device;
    });
    after.forEach((device)=>{
        if (!device.kind || !device.deviceId) return;
        if (!changesByKind[device.kind]) changesByKind[device.kind] = {
            added: {},
            removed: {},
            changed: {}
        };
        if (!beforeByKind[device.kind] || !beforeByKind[device.kind][device.deviceId]) changesByKind[device.kind].added[device.deviceId] = device;
        else if (beforeByKind[device.kind][device.deviceId].label && beforeByKind[device.kind][device.deviceId].label !== device.label) changesByKind[device.kind].changed[device.deviceId] = device;
    });
    return changesByKind;
}
function $1622be301bae0161$export$be9584734485c5e8({ oldDevices: oldDevices, newDevices: newDevices, currentAudioId: currentAudioId, currentVideoId: currentVideoId, currentSpeakerId: currentSpeakerId }) {
    const changesByKind = $1622be301bae0161$export$47595e93b87b07e9(oldDevices, newDevices);
    const changedDevices = {};
    const addedDevices = {};
    [
        [
            "audioinput",
            currentAudioId
        ],
        [
            "videoinput",
            currentVideoId
        ],
        [
            "audiooutput",
            currentSpeakerId
        ]
    ].forEach(([kind, currentDeviceId])=>{
        kind = kind || "";
        const changes = changesByKind[kind];
        if (!changes) return;
        if (currentDeviceId) {
            if (changes.removed[currentDeviceId]) {
                changedDevices[kind] = {
                    deviceId: null
                };
                if (kind === "audiooutput") {
                    const fallbackSpeakerDevice = newDevices.find((d)=>d.kind === "audiooutput");
                    changedDevices[kind] = {
                        deviceId: fallbackSpeakerDevice === null || fallbackSpeakerDevice === void 0 ? void 0 : fallbackSpeakerDevice.deviceId
                    };
                }
            }
            if (changes.changed[currentDeviceId]) changedDevices[kind] = {
                deviceId: currentDeviceId
            };
        }
        if (Object.keys(changes.added).length) {
            const [deviceAdded] = Object.keys(changes.added).slice(0, 1);
            const add = changes.added[deviceAdded];
            addedDevices[kind] = {
                deviceId: add.deviceId,
                label: add.label,
                kind: add.kind
            };
        }
    });
    return {
        addedDevices: addedDevices,
        changedDevices: changedDevices
    };
}
var $1622be301bae0161$var$_a$5;
($1622be301bae0161$var$_a$5 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$5 !== void 0 ? $1622be301bae0161$var$_a$5 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$RTCSTATS_PROTOCOL_VERSION = "1.0";
const $1622be301bae0161$var$GETSTATS_BUFFER_SIZE = 20;
const $1622be301bae0161$var$clientInfo = {
    id: (0, $e247db96f48d686a$export$2e2bcd8739ae039)(),
    connectionNumber: 0
};
const $1622be301bae0161$var$noop = ()=>{};
let $1622be301bae0161$var$resetDelta = $1622be301bae0161$var$noop;
function $1622be301bae0161$var$rtcStatsConnection(wsURL, logger = console) {
    const buffer = [];
    let ws;
    let organizationId;
    let clientId;
    let displayName;
    let userRole;
    let roomSessionId;
    let connectionShouldBeOpen;
    let connectionAttempt = 0;
    let hasPassedOnRoomSessionId = false;
    let getStatsBufferUsed = 0;
    let deviceId;
    let roomProduct;
    let roomMode;
    let sfuServer;
    let featureFlags;
    const connection = {
        connected: false,
        trace: (...args)=>{
            args.push(Date.now());
            if (args[0] === "customEvent" && args[2].type === "roomSessionId") {
                const oldRoomSessionIdValue = roomSessionId && roomSessionId[2].value.roomSessionId;
                const newRoomSessionIdValue = args[2].value.roomSessionId;
                roomSessionId = args;
                if (hasPassedOnRoomSessionId && newRoomSessionIdValue && newRoomSessionIdValue !== oldRoomSessionIdValue) ws === null || ws === void 0 || ws.close();
                if (newRoomSessionIdValue) hasPassedOnRoomSessionId = true;
            } else if (args[0] === "customEvent" && args[2].type === "clientId") clientId = args;
            else if (args[0] === "customEvent" && args[2].type === "organizationId") organizationId = args;
            else if (args[0] === "customEvent" && args[2].type === "displayName") displayName = args;
            else if (args[0] === "customEvent" && args[2].type === "userRole") userRole = args;
            else if (args[0] === "customEvent" && args[2].type === "deviceId") deviceId = args;
            else if (args[0] === "customEvent" && args[2].type === "roomProduct") roomProduct = args;
            else if (args[0] === "customEvent" && args[2].type === "roomMode") roomMode = args;
            else if (args[0] === "customEvent" && args[2].type === "sfuServer") sfuServer = args;
            else if (args[0] === "customEvent" && args[2].type === "featureFlags") featureFlags = args;
            if ((ws === null || ws === void 0 ? void 0 : ws.readyState) === WebSocket.OPEN) {
                connectionAttempt = 0;
                ws.send(JSON.stringify(args));
            } else if (args[0] === "getstats") {
                if (getStatsBufferUsed < $1622be301bae0161$var$GETSTATS_BUFFER_SIZE) {
                    getStatsBufferUsed++;
                    buffer.push(args);
                }
            } else if (args[0] === "customEvent" && args[2].type === "insightsStats") ;
            else buffer.push(args);
            if ((ws === null || ws === void 0 ? void 0 : ws.readyState) === WebSocket.CLOSED && connectionShouldBeOpen) setTimeout(()=>{
                if (ws.readyState === WebSocket.CLOSED && connectionShouldBeOpen) connection.connect();
            }, 1000 * connectionAttempt);
        },
        close: ()=>{
            connectionShouldBeOpen = false;
            ws === null || ws === void 0 || ws.close();
        },
        connect: ()=>{
            connectionShouldBeOpen = true;
            connectionAttempt += 1;
            ws === null || ws === void 0 || ws.close();
            connection.connected = true;
            ws = new WebSocket(wsURL + window.location.pathname, $1622be301bae0161$var$RTCSTATS_PROTOCOL_VERSION);
            ws.onerror = (e)=>{
                connection.connected = false;
                logger.warn(`[RTCSTATS] WebSocket error`, e);
            };
            ws.onclose = (e)=>{
                connection.connected = false;
                logger.info(`[RTCSTATS] Closed ${e.code}`);
                $1622be301bae0161$var$resetDelta();
            };
            ws.onopen = ()=>{
                $1622be301bae0161$var$clientInfo.connectionNumber++;
                ws.send(JSON.stringify([
                    "clientInfo",
                    null,
                    $1622be301bae0161$var$clientInfo
                ]));
                if (organizationId) ws.send(JSON.stringify(organizationId));
                if (clientId) ws.send(JSON.stringify(clientId));
                if (roomSessionId) ws.send(JSON.stringify(roomSessionId));
                if (displayName) ws.send(JSON.stringify(displayName));
                if (userRole) ws.send(JSON.stringify(userRole));
                if (deviceId) ws.send(JSON.stringify(deviceId));
                if (roomMode) ws.send(JSON.stringify(roomMode));
                if (roomProduct) ws.send(JSON.stringify(roomProduct));
                if (sfuServer) ws.send(JSON.stringify(sfuServer));
                if (featureFlags) ws.send(JSON.stringify(featureFlags));
                while(buffer.length)ws.send(JSON.stringify(buffer.shift()));
                getStatsBufferUsed = 0;
            };
        }
    };
    return connection;
}
const $1622be301bae0161$var$server = $1622be301bae0161$var$rtcStatsConnection("wss://rtcstats.srv.whereby.com");
const $1622be301bae0161$var$stats = (0, (/*@__PURE__*/$parcel$interopDefault($695e2205f7548c7a$exports)))($1622be301bae0161$var$server.trace, 10000, [
    ""
]);
$1622be301bae0161$var$resetDelta = ($1622be301bae0161$var$stats === null || $1622be301bae0161$var$stats === void 0 ? void 0 : $1622be301bae0161$var$stats.resetDelta) || $1622be301bae0161$var$noop;
const $1622be301bae0161$export$6e1a0bfe9f2f0cbe = {
    sendEvent: (type, value)=>{
        $1622be301bae0161$var$server.trace("customEvent", null, {
            type: type,
            value: value
        });
    },
    sendAudioMuted: (muted)=>{
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    },
    sendVideoMuted: (muted)=>{
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    },
    server: $1622be301bae0161$var$server
};
var $1622be301bae0161$var$_a$4;
const $1622be301bae0161$var$adapter$4 = ($1622be301bae0161$var$_a$4 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$4 !== void 0 ? $1622be301bae0161$var$_a$4 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$6 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$browserName$2 = $1622be301bae0161$var$adapter$4.browserDetails.browser;
const $1622be301bae0161$var$browserVersion$1 = $1622be301bae0161$var$adapter$4.browserDetails.version;
function $1622be301bae0161$export$e6fb7443cbdf2b8b(sdp, vp9On, redOn) {
    var _a, _b;
    try {
        const sdpObject = $8j7qr.parse(sdp);
        if (Array.isArray(sdpObject === null || sdpObject === void 0 ? void 0 : sdpObject.media)) {
            const mediaAudio = sdpObject.media.find((m)=>m.type === "audio");
            if (Array.isArray(mediaAudio === null || mediaAudio === void 0 ? void 0 : mediaAudio.rtp)) {
                const rtp = mediaAudio.rtp;
                for(let i = 0; i < rtp.length; i++)if (redOn && rtp[i].codec === "red") {
                    const payloads = (_a = mediaAudio.payloads) === null || _a === void 0 ? void 0 : _a.split(" ");
                    const pt = payloads === null || payloads === void 0 ? void 0 : payloads.indexOf("" + rtp[i].payload);
                    if (pt && pt !== -1 && pt >= 0) {
                        payloads === null || payloads === void 0 || payloads.unshift(payloads.splice(pt, 1)[0]);
                        mediaAudio.payloads = payloads === null || payloads === void 0 ? void 0 : payloads.join(" ");
                    }
                }
            }
            const mediaVideo = sdpObject.media.find((m)=>m.type === "video");
            if (Array.isArray(mediaVideo === null || mediaVideo === void 0 ? void 0 : mediaVideo.rtp)) {
                const rtp = mediaVideo.rtp;
                for(let i = 0; i < rtp.length; i++)if (vp9On && rtp[i].codec === "VP9") {
                    const payloads = (_b = mediaVideo.payloads) === null || _b === void 0 ? void 0 : _b.split(" ");
                    const pt = payloads === null || payloads === void 0 ? void 0 : payloads.indexOf("" + rtp[i].payload);
                    if (pt && pt !== -1 && pt >= 0) {
                        payloads === null || payloads === void 0 || payloads.unshift(payloads.splice(pt, 1)[0]);
                        mediaVideo.payloads = payloads === null || payloads === void 0 ? void 0 : payloads.join(" ");
                    }
                }
            }
        }
        const newSdp = $8j7qr.write(sdpObject);
        return newSdp;
    } catch (error) {
        $1622be301bae0161$var$logger$6.error("setCodecPreferenceSDP error:", error);
    }
}
function $1622be301bae0161$export$529db98703a04dea(sdp) {
    try {
        const sdpObject = $8j7qr.parse(sdp);
        sdpObject.media.forEach((mediaObject)=>{
            const usedPayloads = {};
            if (mediaObject.payloads) mediaObject.payloads = ("" + mediaObject.payloads).split(" ").filter((p)=>!usedPayloads[p] && (usedPayloads[p] = true)).join(" ");
            const usedRtps = {};
            mediaObject.rtp = mediaObject.rtp.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedRtps[p.payload] && (usedRtps[p.payload] = true));
            const usedFmtps = {};
            if (mediaObject.fmtp) mediaObject.fmtp = mediaObject.fmtp.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedFmtps[p.payload] && (usedFmtps[p.payload] = true));
            const usedRtcpFb = {};
            if (mediaObject.rtcpFb) mediaObject.rtcpFb = mediaObject.rtcpFb.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedRtcpFb[p.payload + p.type] && (usedRtcpFb[p.payload + p.type] = true));
        });
        return $8j7qr.write(sdpObject);
    } catch (_) {}
    return sdp;
}
function $1622be301bae0161$export$cd6d02be03104b8d(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "safari") return sdp;
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp);
    for(let i = 1; i < sections.length; i++){
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(sections[i]) !== "video") continue;
        const codecs = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(sections[i], "a=rtpmap:").map((line)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseRtpMap(line);
        }).map((codec)=>{
            return codec.name.toUpperCase();
        });
        if (codecs.indexOf("H264") === -1 && sections[i][8] === "9") sections[i] = sections[i].replace("m=video 9 ", "m=video 0 ");
    }
    return sections.join("");
}
function $1622be301bae0161$export$aabefb65e8880783(sdp) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp).map((section)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(section) !== "video") return section;
        const h264payloadTypes = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(section, "a=rtpmap:").map((line)=>(0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseRtpMap(line)).filter((codec)=>/h264/i.test(codec.name)).map((codec)=>"" + codec.payloadType);
        if (!h264payloadTypes.length) return section;
        const mline = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(section, "m=video")[0];
        const mlinePayloadsSectionExec = /(\s\d+)+$/i.exec(mline);
        const mlinePayloadsSection = mlinePayloadsSectionExec ? mlinePayloadsSectionExec[0] : "";
        const mlinePayloadsNonH264 = mlinePayloadsSection.split(" ").filter((payloadType)=>payloadType && !h264payloadTypes.includes(payloadType));
        const reorderedPayloads = [
            ...mlinePayloadsNonH264,
            ...h264payloadTypes
        ].join(" ");
        const newmline = mline.replace(mlinePayloadsSection, " " + reorderedPayloads);
        return section.replace(mline, newmline);
    }).join("");
}
function $1622be301bae0161$export$6cd2554db6b94584(currentDescription, newDescription) {
    let ssrcs = currentDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
    let newssrcs = newDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
    if (!ssrcs) {
        ssrcs = currentDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
        newssrcs = newDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
    }
    for(let i = 1; i < ssrcs.length; i++)newDescription = newDescription.replace(new RegExp(newssrcs[i], "g"), ssrcs[i]);
    return newDescription;
}
function $1622be301bae0161$export$5ac3fc986856d28f(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "safari" && ($1622be301bae0161$var$browserName$2 !== "firefox" || $1622be301bae0161$var$browserVersion$1 && $1622be301bae0161$var$browserVersion$1 >= 63 || $1622be301bae0161$var$browserVersion$1 === 60)) return sdp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitLines(sdp.trim()).filter((line)=>{
        if (!line.startsWith("a=extmap:")) return true;
        const extmap = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseExtmap(line);
        return extmap.uri !== "urn:ietf:params:rtp-hdrext:sdes:mid";
    }).join("\r\n") + "\r\n";
}
function $1622be301bae0161$export$29fb476286719545(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "firefox") return sdp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitLines(sdp.trim()).map((line)=>line.startsWith("a=msid-semantic:") ? "a=msid-semantic: WMS *" : line).join("\r\n") + "\r\n";
}
function $1622be301bae0161$export$e3830f4bcec0e79f(sdp, active) {
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp);
    return sections.shift() + sections.map((section)=>{
        const currentDirection = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getDirection(section, (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(section));
        return section.replace("a=" + currentDirection, "a=" + (active ? "recvonly" : "inactive"));
    }).join("");
}
function $1622be301bae0161$export$b7ea0cdabf789ea3(sdp, extmapUri, modifyAudio = false, modifyVideo = false) {
    var _a, _b;
    try {
        const sdpObj = $8j7qr.parse(sdp);
        if (((_a = sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.ext) === null || _a === void 0 ? void 0 : _a.length) && sdpObj.ext.length > 0) return sdp;
        if ((sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.media.length) < 1) return sdp;
        const allHeaderExtensions = sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.media.flatMap((section)=>section.ext || []);
        const extmapId = ((_b = allHeaderExtensions.find((ext)=>ext.uri === extmapUri)) === null || _b === void 0 ? void 0 : _b.value) || [
            ...new Set([
                0,
                15,
                ...allHeaderExtensions.map((ext)=>ext.value)
            ])
        ].sort((a, b)=>a - b).find((n, i, arr)=>n + 1 !== arr[i + 1]) + 1;
        sdpObj.media.forEach((mediaSection)=>{
            var _a;
            if (modifyAudio && mediaSection.type === "audio" || modifyVideo && mediaSection.type === "video") {
                if (!((_a = mediaSection.ext) === null || _a === void 0 ? void 0 : _a.find((e)=>e.uri === extmapUri))) {
                    if (Array.isArray(mediaSection.ext)) mediaSection["ext"].push({
                        value: extmapId,
                        uri: extmapUri
                    });
                    else mediaSection["ext"] = [
                        {
                            value: extmapId,
                            uri: extmapUri
                        }
                    ];
                }
            }
        });
        return $8j7qr.write(sdpObj);
    } catch (error) {
        console.error("Error during addAbsCaptureTimeExtMap: ", error);
    }
    return sdp;
}
function $1622be301bae0161$export$eb32cdfe1ef3eb9c(sdp) {
    const absCaptureTimeUri = "http://www.webrtc.org/experiments/rtp-hdrext/abs-capture-time";
    return $1622be301bae0161$export$b7ea0cdabf789ea3(sdp, absCaptureTimeUri, true, true);
}
function $1622be301bae0161$export$1af83275ca9f024e(pc) {
    return pc.getStats(null).then((result)=>{
        let localCandidateType;
        let remoteCandidateType;
        result.forEach((report)=>{
            if (report.type === "transport" && report.selectedCandidatePairId) {
                const transport = result.get(report.selectedCandidatePairId);
                if (!transport) return;
                localCandidateType = result.get(transport.localCandidateId).candidateType;
                remoteCandidateType = result.get(transport.remoteCandidateId).candidateType;
                return;
            }
            if (report.type === "candidate-pair" && report.selected) {
                localCandidateType = result.get(report.localCandidateId).candidateType;
                remoteCandidateType = result.get(report.remoteCandidateId).candidateType;
            }
        });
        return localCandidateType === "relay" || localCandidateType === "relayed" || remoteCandidateType === "relay" || remoteCandidateType === "relayed";
    });
}
function $1622be301bae0161$export$49b206b8681907c1(pc, bandwidth, logger = console) {
    const sender = pc.getSenders().find((s)=>s.track && s.track.kind === "video");
    if (!sender) return Promise.resolve();
    const parameters = sender.getParameters();
    if (parameters.encodings && parameters.encodings.length === 0) return Promise.resolve();
    if (!parameters.encodings) parameters.encodings = [
        {}
    ];
    if (bandwidth === 0) delete parameters.encodings[0].maxBitrate;
    else parameters.encodings[0].maxBitrate = bandwidth * 1000;
    return sender.setParameters(parameters).catch((err)=>{
        logger.error("setParameters err: ", err);
    });
}
var $1622be301bae0161$var$_a$3;
const $1622be301bae0161$var$adapter$3 = ($1622be301bae0161$var$_a$3 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$3 !== void 0 ? $1622be301bae0161$var$_a$3 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$5 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$1fb4852a55678982 {
    setAndGetPeerConnection({ clientId: clientId, constraints: constraints, peerConnectionConfig: peerConnectionConfig, shouldAddLocalVideo: shouldAddLocalVideo }) {
        this.peerConnectionConfig = peerConnectionConfig;
        this.shouldAddLocalVideo = shouldAddLocalVideo;
        this.clientId = clientId;
        this.pc = new RTCPeerConnection(peerConnectionConfig);
        this.signalingState = this.pc.signalingState;
        this.pc.addEventListener("signalingstatechange", ()=>{
            if (this.signalingState === this.pc.signalingState) return;
            this.signalingState = this.pc.signalingState;
            if (this.pc.signalingState === "stable") {
                this.isOperationPending = false;
                const action = this.pending.shift();
                if (action) action.apply();
            }
        });
        return this.pc;
    }
    addStream(stream) {
        this.streamIds.push(stream.id);
        this.streams.push(stream);
        if (RTCPeerConnection.prototype.addTrack) {
            stream.getAudioTracks().forEach((track)=>{
                this.pc.addTrack(track, stream);
            });
            stream.getVideoTracks().forEach((track)=>{
                this.pc.addTrack(track, stream);
            });
        } else this.pc.addStream(stream);
    }
    addTrack(track, stream) {
        if (!stream) stream = this.streams[0];
        stream === null || stream === void 0 || stream.addTrack(track);
        this.pc.addTrack(track, stream);
    }
    removeTrack(track) {
        const stream = this.streams[0];
        stream.removeTrack(track);
        const sender = this.pc.getSenders().find((sender)=>sender.track === track);
        if (sender) this.pc.removeTrack(sender);
    }
    removeStream(stream) {
        for(let i = 0; i < this.streamIds.length; i++)if (this.streamIds[i] === stream.id) {
            this.streamIds.splice(i, 1);
            this.streams.splice(i, 1);
        }
        if (this.pc) {
            if (this.pc.removeTrack) stream.getTracks().forEach((track)=>{
                const sender = this.pc.getSenders().find((sender)=>sender.track === track);
                if (sender) this.pc.removeTrack(sender);
            });
            else if (this.pc.removeStream) this.pc.removeStream(stream);
        }
    }
    _setRemoteDescription(desc) {
        if (this._deprioritizeH264Encoding) desc.sdp = $1622be301bae0161$export$aabefb65e8880783(desc.sdp);
        this.srdComplete = this.pc.setRemoteDescription(desc);
        return this.srdComplete.then(()=>{
            this.earlyIceCandidates.forEach((candidate)=>this.pc.addIceCandidate(candidate));
            this.earlyIceCandidates = [];
        });
    }
    handleOffer(message) {
        if (!this.canModifyPeerConnection()) return new Promise((resolve)=>{
            this.pending.push(()=>this.handleOffer(message).then(resolve));
        });
        this.isOperationPending = true;
        let sdp = message.sdp;
        sdp = $1622be301bae0161$export$5ac3fc986856d28f(sdp);
        sdp = $1622be301bae0161$export$29fb476286719545(sdp);
        const desc = {
            type: message.type,
            sdp: sdp
        };
        let answerToSignal;
        return this._setRemoteDescription(desc).then(()=>{
            return this.pc.createAnswer();
        }).then((answer)=>{
            answerToSignal = answer;
            return this.pc.setLocalDescription(answer);
        }).then(()=>{
            return $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
        }).then(()=>{
            return answerToSignal;
        });
    }
    handleAnswer(message) {
        const sdp = $1622be301bae0161$export$29fb476286719545(message.sdp);
        const desc = {
            type: message.type,
            sdp: sdp
        };
        return this._setRemoteDescription(desc).then(()=>{
            return $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
        }, (e)=>{
            $1622be301bae0161$var$logger$5.warn("Could not set remote description from remote answer: ", e);
        });
    }
    addIceCandidate(candidate) {
        if (!this.srdComplete) {
            this.earlyIceCandidates.push(candidate);
            return;
        }
        this.srdComplete.then(()=>{
            if (this.pc.signalingState === "closed") return;
            if ($1622be301bae0161$var$adapter$3.browserDetails.browser === "safari" && candidate && candidate.candidate === "") return;
            this.pc.addIceCandidate(candidate).catch((e)=>{
                $1622be301bae0161$var$logger$5.warn("Failed to add ICE candidate ('%s'): %s", candidate ? candidate.candidate : null, e);
            });
        });
    }
    canModifyPeerConnection() {
        return this.pc.signalingState === "stable" && !this.isOperationPending;
    }
    close() {
        const pc = this.pc;
        if (!pc) return;
        pc.oniceconnectionstatechange = null;
        pc.onicecandidate = null;
        pc.ontrack = null;
        try {
            pc.close();
        } catch (e) {
            $1622be301bae0161$var$logger$5.warn("failures during close of session", e);
        }
    }
    hasConnectedPeerConnection() {
        return this.pc && this.pc.connectionState === "connected";
    }
    replaceTrack(oldTrack, newTrack) {
        const pc = this.pc;
        if (!pc) return false;
        const senders = pc.getSenders();
        if (!oldTrack) oldTrack = (senders.find((s)=>s.track && s.track.kind === newTrack.kind) || {}).track;
        if (window.RTCRtpSender && window.RTCRtpSender.prototype.replaceTrack) {
            if (oldTrack) {
                const process = ()=>{
                    for(let i = 0; i < senders.length; i++){
                        const sender = senders[i];
                        const track = sender.track;
                        if ((track === null || track === void 0 ? void 0 : track.id) === newTrack.id) return Promise.resolve(newTrack);
                        if ((track === null || track === void 0 ? void 0 : track.id) === oldTrack.id) return senders[i].replaceTrack(newTrack);
                    }
                    return null;
                };
                let result = process();
                if (result) return result;
                let resolve = null;
                let reject = null;
                result = new Promise((_resolve, _reject)=>{
                    resolve = _resolve;
                    reject = _reject;
                });
                let retried = 0;
                let timer = setInterval(()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        const trackReplacedPromise = process();
                        if (!trackReplacedPromise) {
                            if (3 < ++retried) {
                                clearInterval(timer);
                                timer = null;
                                reject("No sender track to replace");
                            }
                            return;
                        }
                        clearInterval(timer);
                        timer = null;
                        const trackReplaced = yield trackReplacedPromise;
                        resolve(trackReplaced);
                    }), 1000);
                return result;
            }
            const stream = this.streams.find((s)=>s.getTracks().find((t)=>t.id === newTrack.id)) || this.streams[0];
            if (!stream) return Promise.reject(new Error("replaceTrack: No stream?"));
            return pc.addTrack(newTrack, stream);
        }
        if (!this.canModifyPeerConnection()) {
            this.pending.push(()=>{
                this.replaceTrack(oldTrack, newTrack);
            });
            return;
        }
        this.isOperationPending = true;
        const onn = pc.onnegotiationneeded;
        pc.onnegotiationneeded = null;
        this.removeTrack(oldTrack);
        this.addTrack(newTrack);
        setTimeout(()=>{
            pc.onnegotiationneeded = onn;
        }, 0);
        if (pc.localDescription.type === "offer") return pc.createOffer().then((offer)=>{
            offer.sdp = $1622be301bae0161$export$6cd2554db6b94584(pc.localDescription.sdp, offer.sdp);
            return pc.setLocalDescription(offer);
        }).then(()=>{
            return this._setRemoteDescription(pc.remoteDescription);
        });
        else return this._setRemoteDescription(pc.remoteDescription).then(()=>{
            return pc.createAnswer();
        }).then((answer)=>{
            answer.sdp = $1622be301bae0161$export$6cd2554db6b94584(pc.localDescription.sdp, answer.sdp);
            return pc.setLocalDescription(answer);
        });
    }
    maybeRestrictRelayBandwidth() {
        if (this.maximumTurnBandwidth === $1622be301bae0161$export$6bb71afef3ab9ece) return;
        if (!this.pc.getStats) return;
        $1622be301bae0161$export$1af83275ca9f024e(this.pc).then((isRelayed)=>{
            if (isRelayed && this.bandwidth === 0) this.changeBandwidth(this.maximumTurnBandwidth);
        });
    }
    changeBandwidth(bandwidth) {
        if (bandwidth === this.bandwidth) return;
        if (!this.canModifyPeerConnection()) {
            this.pending.push(()=>this.changeBandwidth(bandwidth));
            return;
        }
        this.bandwidth = bandwidth;
        if (!this.pc.localDescription || this.pc.localDescription.type === "") return;
        $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
    }
    setAudioOnly(enable, excludedTrackIds = []) {
        this.pc.getTransceivers().filter((videoTransceiver)=>{
            var _a, _b, _c, _d, _e, _f;
            return (videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.direction) !== "recvonly" && ((_b = (_a = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.receiver) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "video" && !excludedTrackIds.includes((_d = (_c = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.receiver) === null || _c === void 0 ? void 0 : _c.track) === null || _d === void 0 ? void 0 : _d.id) && !excludedTrackIds.includes((_f = (_e = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.sender) === null || _e === void 0 ? void 0 : _e.track) === null || _f === void 0 ? void 0 : _f.id);
        }).forEach((videoTransceiver)=>{
            videoTransceiver.direction = enable ? "sendonly" : "sendrecv";
        });
    }
    constructor({ peerConnectionId: peerConnectionId, bandwidth: bandwidth, maximumTurnBandwidth: maximumTurnBandwidth, deprioritizeH264Encoding: deprioritizeH264Encoding }){
        this.peerConnectionId = peerConnectionId;
        this.relayCandidateSeen = false;
        this.serverReflexiveCandidateSeen = false;
        this.publicHostCandidateSeen = false;
        this.ipv6HostCandidateSeen = false;
        this.ipv6HostCandidateTeredoSeen = false;
        this.ipv6HostCandidate6to4Seen = false;
        this.mdnsHostCandidateSeen = false;
        this.pc = null;
        this.wasEverConnected = false;
        this.connectionStatus = null;
        this.stats = {
            totalSent: 0,
            totalRecv: 0
        };
        this.bandwidth = bandwidth || 0;
        this.maximumTurnBandwidth = maximumTurnBandwidth;
        this.pending = [];
        this.isOperationPending = false;
        this.streamIds = [];
        this.streams = [];
        this.earlyIceCandidates = [];
        this.afterConnected = new Promise((resolve)=>{
            this.registerConnected = resolve;
        });
        this.offerOptions = {
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        };
        this._deprioritizeH264Encoding = deprioritizeH264Encoding;
    }
}
const $1622be301bae0161$export$1ea784ac1a0f1fca = {
    BLOCK_CLIENT: "block_client",
    CLAIM_ROOM: "claim_room",
    CLEAR_CHAT_HISTORY: "clear_chat_history",
    ENABLE_AUDIO: "enable_audio",
    ENABLE_VIDEO: "enable_video",
    END_STREAM: "end_stream",
    FETCH_MEDIASERVER_CONFIG: "fetch_mediaserver_config",
    HANDLE_KNOCK: "handle_knock",
    IDENTIFY_DEVICE: "identify_device",
    INVITE_CLIENT_AS_MEMBER: "invite_client_as_member",
    JOIN_ROOM: "join_room",
    KICK_CLIENT: "kick_client",
    KNOCK_ROOM: "knock_room",
    LEAVE_ROOM: "leave_room",
    SEND_CLIENT_METADATA: "send_client_metadata",
    SET_LOCK: "set_lock",
    SHARE_MEDIA: "share_media",
    START_NEW_STREAM: "start_new_stream",
    START_SCREENSHARE: "start_screenshare",
    STOP_SCREENSHARE: "stop_screenshare",
    START_URL_EMBED: "start_url_embed",
    STOP_URL_EMBED: "stop_url_embed",
    START_RECORDING: "start_recording",
    STOP_RECORDING: "stop_recording"
};
const $1622be301bae0161$export$f128bfe5688cdcff = {
    AUDIO_ENABLED: "audio_enabled",
    BACKGROUND_IMAGE_CHANGED: "background_image_changed",
    BLOCK_ADDED: "block_added",
    BLOCK_REMOVED: "block_removed",
    CHAT_HISTORY_CLEARED: "chat_history_cleared",
    CLIENT_BLOCKED: "client_blocked",
    CLIENT_INVITED_AS_MEMBER: "client_invited_as_member",
    CLIENT_KICKED: "client_kicked",
    CLIENT_LEFT: "client_left",
    CLIENT_METADATA_RECEIVED: "client_metadata_received",
    CLIENT_READY: "client_ready",
    CLIENT_ROLE_CHANGED: "client_role_changed",
    CLIENT_USER_ID_CHANGED: "client_user_id_changed",
    CONTACTS_UPDATED: "contacts_updated",
    DEVICE_IDENTIFIED: "device_identified",
    ROOM_ROLES_UPDATED: "room_roles_updated",
    KNOCK_HANDLED: "knock_handled",
    KNOCK_PAGE_BACKGROUND_CHANGED: "knock_page_background_changed",
    KNOCKER_LEFT: "knocker_left",
    MEDIASERVER_CONFIG: "mediaserver_config",
    MEDIA_SHARED: "media_shared",
    MEMBER_INVITE: "member_invite",
    NEW_CLIENT: "new_client",
    NEW_STREAM_STARTED: "new_stream_started",
    SCREENSHARE_STARTED: "screenshare_started",
    SCREENSHARE_STOPPED: "screenshare_stopped",
    OWNER_NOTIFIED: "owner_notified",
    OWNERS_CHANGED: "owners_changed",
    PLAY_CLIENT_STICKER: "play_client_sticker",
    ROOM_INTEGRATION_ENABLED: "room_integration_enabled",
    ROOM_INTEGRATION_DISABLED: "room_integration_disabled",
    ROOM_JOINED: "room_joined",
    ROOM_KNOCKED: "room_knocked",
    ROOM_LEFT: "room_left",
    ROOM_LOCKED: "room_locked",
    ROOM_PERMISSIONS_CHANGED: "room_permissions_changed",
    ROOM_LOGO_CHANGED: "room_logo_changed",
    ROOM_TYPE_CHANGED: "room_type_changed",
    ROOM_MODE_CHANGED: "room_mode_changed",
    SOCKET_USER_ID_CHANGED: "socket_user_id_changed",
    STICKERS_UNLOCKED: "stickers_unlocked",
    STREAM_ENDED: "stream_ended",
    URL_EMBED_STARTED: "url_embed_started",
    URL_EMBED_STOPPED: "url_embed_stopped",
    RECORDING_STARTED: "recording_started",
    RECORDING_STOPPED: "recording_stopped",
    USER_NOTIFIED: "user_notified",
    VIDEO_ENABLED: "video_enabled",
    CLIENT_UNABLE_TO_JOIN: "client_unable_to_join",
    LIVE_TRANSCRIPTION_STARTED: "live_transcription_started",
    LIVE_TRANSCRIPTION_STOPPED: "live_transcription_stopped"
};
const $1622be301bae0161$export$501d573e6762e730 = {
    CANNOT_INVITE_YOURSELF: "cannot_invite_yourself",
    CLIENT_MISSING_DEVICE_ID: "client_missing_device_id",
    FORBIDDEN: "forbidden",
    INTERNAL_SERVER_ERROR: "internal_server_error",
    INVALID_AVATAR: "invalid_avatar",
    INVALID_PARAMETERS: "invalid_parameters",
    INVALID_ROOM_NAME: "invalid_room_name",
    MISSING_PARAMETERS: "missing_parameters",
    MISSING_ROOM_NAME: "missing_room_name",
    NOT_AN_OWNER: "not_an_owner",
    NOT_IN_A_ROOM: "not_in_a_room",
    ROOM_ALREADY_CLAIMED: "room_already_claimed",
    ROOM_EMAIL_MISSING: "room_email_missing",
    ROOM_FULL: "room_full",
    ROOM_UNCLAIMED: "room_unclaimed",
    CLIENT_BLOCKED: "client_blocked",
    ROOM_LOCKED: "room_locked",
    TOO_LONG_TEXT: "too_long_text",
    VIDEO_STICKER_DOES_NOT_EXIST: "video_sticker_does_not_exist",
    VIDEO_STICKER_FORMAT_ERROR: "video_sticker_format_error",
    UNSUPPORTED_VIDEO_ENCODING: "unsupported_video_encoding"
};
const $1622be301bae0161$export$83849580da009913 = {
    CHAT_MESSAGE: "chat_message",
    CHAT_READ_STATE: "chat_read_state",
    CHAT_STATE: "chat_state",
    ICE_CANDIDATE: "ice_candidate",
    ICE_END_OF_CANDIDATES: "ice_endofcandidates",
    READY_TO_RECEIVE_OFFER: "ready_to_receive_offer",
    REMOTE_CLIENT_MEDIA_REQUEST: "remote_client_media_request",
    SDP_ANSWER: "sdp_answer",
    SDP_OFFER: "sdp_offer",
    VIDEO_STICKER: "video_sticker"
};
const $1622be301bae0161$export$c09e21f3212e33cd = {
    actions: {
        ACCEPT: "accept",
        HOLD: "hold",
        REJECT: "reject"
    },
    resolutions: {
        ACCEPTED: "accepted",
        ON_HOLD: "on_hold",
        REJECTED: "rejected"
    }
};
const $1622be301bae0161$export$c4a74f263978d610 = {
    PENDING_CLIENT_LEFT: "pending_client_left",
    MEDIA_QUALITY_CHANGED: "media_quality_changed"
};
const $1622be301bae0161$export$fa3d5b535a2458a1 = {
    CLIENT_CONNECTION_STATUS_CHANGED: "client_connection_status_changed",
    STREAM_ADDED: "stream_added",
    RTC_MANAGER_CREATED: "rtc_manager_created",
    RTC_MANAGER_DESTROYED: "rtc_manager_destroyed",
    LOCAL_STREAM_TRACK_ADDED: "local_stream_track_added",
    LOCAL_STREAM_TRACK_REMOVED: "local_stream_track_removed",
    REMOTE_STREAM_TRACK_ADDED: "remote_stream_track_added",
    REMOTE_STREAM_TRACK_REMOVED: "remote_stream_track_removed"
};
const $1622be301bae0161$export$426db7a6155b7a80 = {
    CONNECTING: "connecting",
    CONNECTION_FAILED: "connection_failed",
    CONNECTION_SUCCESSFUL: "connection_successful",
    CONNECTION_DISCONNECTED: "connection_disconnected"
};
const $1622be301bae0161$var$CAMERA_STREAM_ID$1 = "0";
const $1622be301bae0161$export$ec4891ba46e62598 = {
    CAMERA: "camera",
    SCREEN_SHARE: "screen_share"
};
class $1622be301bae0161$export$8be9f14711b4bbe1 {
    setup(stream) {
        this.stream = stream;
        this.streamId = stream.id;
        this.setVideoEnabled(this.isVideoEnabled && stream.getVideoTracks().length > 0);
        this.setAudioEnabled(this.isAudioEnabled && stream.getAudioTracks().length > 0);
        return this;
    }
    setStatus(status) {
        this.status = status;
        return this;
    }
    setVideoEnabled(isEnabled) {
        this.isVideoEnabled = isEnabled;
        if (!this.stream) return;
        this.stream.getVideoTracks().forEach((track)=>{
            track.enabled = isEnabled;
        });
    }
    setAudioEnabled(isEnabled) {
        this.isAudioEnabled = isEnabled;
        if (!this.stream) return;
        this.stream.getAudioTracks().forEach((track)=>{
            track.enabled = isEnabled;
        });
    }
    static getCameraId() {
        return $1622be301bae0161$var$CAMERA_STREAM_ID$1;
    }
    static getTypeFromId(id) {
        const streamId = "" + id;
        return streamId === $1622be301bae0161$var$CAMERA_STREAM_ID$1 ? $1622be301bae0161$export$ec4891ba46e62598.CAMERA : $1622be301bae0161$export$ec4891ba46e62598.SCREEN_SHARE;
    }
    constructor(id, type){
        this.id = "" + id;
        this.type = type;
        this.isEnabled = true;
        this.hasSupportForAutoSuperSize = false;
        this.isAudioEnabled = true;
        this.isVideoEnabled = true;
        this.status = $1622be301bae0161$export$426db7a6155b7a80.CONNECTING;
        this.stream = null;
        this.streamId = null;
    }
}
const $1622be301bae0161$var$lowPixelCount = 57600;
const $1622be301bae0161$var$lowBitratePerPixel = 150000 / $1622be301bae0161$var$lowPixelCount;
const $1622be301bae0161$var$highPixelCount = 921600;
const $1622be301bae0161$var$highBitratePerPixel = 1000000 / $1622be301bae0161$var$highPixelCount;
const $1622be301bae0161$var$bitrateChangePerPixel = ($1622be301bae0161$var$highBitratePerPixel - $1622be301bae0161$var$lowBitratePerPixel) / ($1622be301bae0161$var$highPixelCount - $1622be301bae0161$var$lowPixelCount);
function $1622be301bae0161$export$a7c2590c69aa3b06(width, height, frameRate) {
    let targetPixelCount = width * height;
    if (targetPixelCount < $1622be301bae0161$var$lowPixelCount) targetPixelCount = $1622be301bae0161$var$lowPixelCount;
    if (targetPixelCount > $1622be301bae0161$var$highPixelCount) targetPixelCount = $1622be301bae0161$var$highPixelCount;
    let targetBitratePerPixel = $1622be301bae0161$var$lowBitratePerPixel;
    if (targetPixelCount > $1622be301bae0161$var$highPixelCount) targetBitratePerPixel = $1622be301bae0161$var$highBitratePerPixel;
    else if (targetPixelCount > $1622be301bae0161$var$lowPixelCount) targetBitratePerPixel += (targetPixelCount - $1622be301bae0161$var$lowPixelCount) * $1622be301bae0161$var$bitrateChangePerPixel;
    let targetBitrate = width * height * targetBitratePerPixel;
    if (frameRate <= 15) targetBitrate = targetBitrate * 0.7;
    else if (frameRate <= 24) targetBitrate = targetBitrate * 0.9;
    return targetBitrate;
}
const $1622be301bae0161$var$word = "[a-fA-F\\d:]";
const $1622be301bae0161$var$boundry = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${$1622be301bae0161$var$word})|(?<=${$1622be301bae0161$var$word})(?=\\s|$))` : "";
const $1622be301bae0161$var$v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
const $1622be301bae0161$var$v6segment = "[a-fA-F\\d]{1,4}";
const $1622be301bae0161$var$v6 = `
(?:
(?:${$1622be301bae0161$var$v6segment}:){7}(?:${$1622be301bae0161$var$v6segment}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${$1622be301bae0161$var$v6segment}:){6}(?:${$1622be301bae0161$var$v4}|:${$1622be301bae0161$var$v6segment}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){5}(?::${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){4}(?:(?::${$1622be301bae0161$var$v6segment}){0,1}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){3}(?:(?::${$1622be301bae0161$var$v6segment}){0,2}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){2}(?:(?::${$1622be301bae0161$var$v6segment}){0,3}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){1}(?:(?::${$1622be301bae0161$var$v6segment}){0,4}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${$1622be301bae0161$var$v6segment}){0,5}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
const $1622be301bae0161$var$v46Exact = new RegExp(`(?:^${$1622be301bae0161$var$v4}$)|(?:^${$1622be301bae0161$var$v6}$)`);
const $1622be301bae0161$var$v4exact = new RegExp(`^${$1622be301bae0161$var$v4}$`);
const $1622be301bae0161$var$v6exact = new RegExp(`^${$1622be301bae0161$var$v6}$`);
const $1622be301bae0161$export$bdfe8a6e5369c106 = (options)=>options && options.exact ? $1622be301bae0161$var$v46Exact : new RegExp(`(?:${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v4}${$1622be301bae0161$var$boundry(options)})|(?:${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v6}${$1622be301bae0161$var$boundry(options)})`, "g");
$1622be301bae0161$export$bdfe8a6e5369c106.v4 = (options)=>options && options.exact ? $1622be301bae0161$var$v4exact : new RegExp(`${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v4}${$1622be301bae0161$var$boundry(options)}`, "g");
$1622be301bae0161$export$bdfe8a6e5369c106.v6 = (options)=>options && options.exact ? $1622be301bae0161$var$v6exact : new RegExp(`${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v6}${$1622be301bae0161$var$boundry(options)}`, "g");
var $1622be301bae0161$export$188476a9307fd26f = {
    CAMERA_NOT_WORKING: "camera_not_working",
    CONNECTION_BLOCKED_BY_NETWORK: "connection_blocked_by_network",
    ICE_IPV6_SEEN: "ice_ipv6_seen",
    ICE_MDNS_SEEN: "ice_mdns_seen",
    ICE_NO_PUBLIC_IP_GATHERED: "ice_no_public_ip_gathered",
    ICE_NO_PUBLIC_IP_GATHERED_3SEC: "ice_no_public_ip_gathered_3sec",
    ICE_RESTART: "ice_restart",
    MICROPHONE_NOT_WORKING: "microphone_not_working",
    MICROPHONE_STOPPED_WORKING: "microphone_stopped_working",
    CAMERA_STOPPED_WORKING: "camera_stopped_working",
    NEW_PC: "new_pc",
    SFU_CONNECTION_OPEN: "sfu_connection_open",
    SFU_CONNECTION_CLOSED: "sfu_connection_closed",
    COLOCATION_SPEAKER: "colocation_speaker",
    DOMINANT_SPEAKER: "dominant_speaker",
    PC_SLD_FAILURE: "pc_sld_failure",
    PC_ON_ANSWER_FAILURE: "pc_on_answer_failure",
    PC_ON_OFFER_FAILURE: "pc_on_offer_failure"
};
var $1622be301bae0161$var$_a$2, $1622be301bae0161$var$_b;
const $1622be301bae0161$var$adapter$2 = ($1622be301bae0161$var$_a$2 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$2 !== void 0 ? $1622be301bae0161$var$_a$2 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$4 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$ICE_PUBLIC_IP_GATHERING_TIMEOUT = 3000;
const $1622be301bae0161$var$CAMERA_STREAM_ID = $1622be301bae0161$export$8be9f14711b4bbe1.getCameraId();
const $1622be301bae0161$var$browserName$1 = $1622be301bae0161$var$adapter$2.browserDetails.browser;
const $1622be301bae0161$var$browserVersion = $1622be301bae0161$var$adapter$2.browserDetails.version;
if ($1622be301bae0161$var$browserName$1 === "firefox" && $1622be301bae0161$var$adapter$2.browserShim && "shimGetDisplayMedia" in $1622be301bae0161$var$adapter$2.browserShim) ($1622be301bae0161$var$_b = $1622be301bae0161$var$adapter$2.browserShim) === null || $1622be301bae0161$var$_b === void 0 || $1622be301bae0161$var$_b.shimGetDisplayMedia(window, "screen");
let $1622be301bae0161$var$unloading$1 = false;
if ($1622be301bae0161$var$browserName$1 === "chrome") window.document.addEventListener("beforeunload", ()=>{
    $1622be301bae0161$var$unloading$1 = true;
});
class $1622be301bae0161$export$c67bf4e001e6de2 {
    numberOfPeerconnections() {
        return Object.keys(this.peerConnections).length;
    }
    isInitializedWith({ selfId: selfId, roomName: roomName, isSfu: isSfu }) {
        return this._selfId === selfId && this._roomName === roomName && isSfu === !!this._sfuServer;
    }
    supportsScreenShareAudio() {
        return true;
    }
    maybeRestrictRelayBandwidth(session) {
        session.maybeRestrictRelayBandwidth();
    }
    addNewStream(streamId, stream, audioPaused, videoPaused, beforeEffectTracks = []) {
        if (stream === this.localStreams[streamId]) return;
        this._addLocalStream(streamId, stream);
        if (streamId === $1622be301bae0161$var$CAMERA_STREAM_ID) {
            this._addStreamToPeerConnections(stream);
            const audioTrack = stream.getAudioTracks()[0];
            const videoTrack = stream.getVideoTracks()[0];
            if (audioTrack) {
                if (!audioTrack.effectTrack) this._monitorAudioTrack(audioTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "audio");
                if (beforeEffectTrack) this._monitorAudioTrack(beforeEffectTrack);
            }
            if (videoTrack) {
                if (!videoTrack.effectTrack) this._monitorVideoTrack(videoTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "video");
                if (beforeEffectTrack) this._monitorVideoTrack(beforeEffectTrack);
            }
            if (this._localStreamDeregisterFunction) {
                this._localStreamDeregisterFunction();
                this._localStreamDeregisterFunction = null;
            }
            const localStreamHandler = (e)=>{
                const { enable: enable, track: track } = e.detail;
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            };
            stream.addEventListener("stopresumevideo", localStreamHandler);
            this._localStreamDeregisterFunction = ()=>{
                stream.removeEventListener("stopresumevideo", localStreamHandler);
            };
            return;
        }
        this._screenshareVideoTrackIds.push(stream.getVideoTracks()[0].id);
        this._shareScreen(streamId, stream);
        return;
    }
    replaceTrack(oldTrack, newTrack) {
        if (newTrack.kind === "audio" && !newTrack.effectTrack) this._monitorAudioTrack(newTrack);
        if (newTrack.kind === "video" && !newTrack.effectTrack) this._monitorVideoTrack(newTrack);
        return this._replaceTrackToPeerConnections(oldTrack, newTrack);
    }
    disconnectAll() {
        Object.keys(this.peerConnections).forEach((peerConnectionId)=>{
            this.disconnect(peerConnectionId);
        });
        this.peerConnections = {};
        this._socketListenerDeregisterFunctions.forEach((func)=>{
            func();
        });
        this._socketListenerDeregisterFunctions = [];
        if (this._localStreamDeregisterFunction) {
            this._localStreamDeregisterFunction();
            this._localStreamDeregisterFunction = null;
        }
    }
    fixChromeAudio(constraints) {
        if ($1622be301bae0161$var$browserName$1 !== "chrome") return;
        const localStream = this._getLocalCameraStream();
        const audioTrack = localStream.getAudioTracks()[0];
        if (!audioTrack || audioTrack.readyState !== "ended") return;
        return navigator.mediaDevices.getUserMedia({
            audio: constraints
        }).then((stream)=>{
            const track = stream.getAudioTracks()[0];
            track.enabled = audioTrack.enabled;
            localStream.removeTrack(audioTrack);
            localStream.addTrack(track);
            return this.replaceTrack(audioTrack, track);
        });
    }
    setupSocketListeners() {
        this._socketListenerDeregisterFunctions = [
            ()=>this._clearMediaServersRefresh(),
            this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.MEDIASERVER_CONFIG, (data)=>{
                if (data.error) {
                    $1622be301bae0161$var$logger$4.warn("FETCH_MEDIASERVER_CONFIG failed:", data.error);
                    return;
                }
                this._updateAndScheduleMediaServersRefresh(data);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.READY_TO_RECEIVE_OFFER, (data)=>{
                this._connect(data.clientId);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.ICE_CANDIDATE, (data)=>{
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on ICE_CANDIDATE", data);
                    return;
                }
                session.addIceCandidate(data.message);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.ICE_END_OF_CANDIDATES, (data)=>{
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on ICE_END_OF_CANDIDATES", data);
                    return;
                }
                session.addIceCandidate(null);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.SDP_OFFER, (data)=>{
                var _a, _b;
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on SDP_OFFER", data);
                    return;
                }
                const offer = this._transformIncomingSdp(data.message, session.pc);
                (_b = (_a = session.handleOffer(offer).then((answer)=>{
                    this._emitServerEvent($1622be301bae0161$export$83849580da009913.SDP_ANSWER, {
                        receiverId: data.clientId,
                        message: this._transformOutgoingSdp(answer)
                    });
                })).catch) === null || _b === void 0 || _b.call(_a, (e)=>{
                    this._emit($1622be301bae0161$export$188476a9307fd26f.PC_ON_OFFER_FAILURE, e);
                });
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.SDP_ANSWER, (data)=>{
                var _a, _b;
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on SDP_ANSWER", data);
                    return;
                }
                const answer = this._transformIncomingSdp(data.message, session.pc);
                (_b = (_a = session.handleAnswer(answer)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 || _b.call(_a, (e)=>{
                    this._emit($1622be301bae0161$export$188476a9307fd26f.PC_ON_ANSWER_FAILURE, e);
                });
            }),
            this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ({ room: { sfuServer: isSfu } })=>{
                if (isSfu || !this._wasScreenSharing) return;
                const screenShareStreamId = Object.keys(this.localStreams).find((id)=>id !== $1622be301bae0161$var$CAMERA_STREAM_ID);
                if (!screenShareStreamId) return;
                const screenshareStream = this.localStreams[screenShareStreamId];
                if (!screenshareStream) {
                    $1622be301bae0161$var$logger$4.warn("screenshare stream %s not found", screenShareStreamId);
                    return;
                }
                const hasAudioTrack = screenshareStream.getAudioTracks().length > 0;
                this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
                    streamId: screenShareStreamId,
                    hasAudioTrack: hasAudioTrack
                });
            })
        ];
    }
    sendAudioMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    }
    sendVideoMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    }
    sendStatsCustomEvent(eventName, data) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent(eventName, data);
    }
    rtcStatsDisconnect() {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.close();
    }
    rtcStatsReconnect() {
        if (!$1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connected) $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connect();
    }
    setAudioOnly(audioOnly) {
        this._isAudioOnlyMode = audioOnly;
        this._forEachPeerConnection((session)=>{
            if (session.hasConnectedPeerConnection()) this._withForcedRenegotiation(session, ()=>session.setAudioOnly(this._isAudioOnlyMode, this._screenshareVideoTrackIds));
        });
    }
    setRemoteScreenshareVideoTrackIds(remoteScreenshareVideoTrackIds = []) {
        const localScreenshareStream = this._getFirstLocalNonCameraStream();
        this._screenshareVideoTrackIds = [
            ...(localScreenshareStream === null || localScreenshareStream === void 0 ? void 0 : localScreenshareStream.track) ? [
                localScreenshareStream.track.id
            ] : [],
            ...remoteScreenshareVideoTrackIds
        ];
    }
    setRoomSessionId(roomSessionId) {
        this._roomSessionId = roomSessionId;
    }
    _setConnectionStatus(session, newStatus, clientId) {
        const previousStatus = session.connectionStatus;
        if (previousStatus === newStatus) return;
        if (session.peerConnectionId === this._selfId) return;
        if (previousStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_DISCONNECTED && newStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTING) return;
        session.connectionStatus = newStatus;
        setTimeout(()=>{
            this._emit($1622be301bae0161$export$fa3d5b535a2458a1.CLIENT_CONNECTION_STATUS_CHANGED, {
                streamIds: session.streamIds,
                clientId: clientId,
                status: newStatus,
                previous: previousStatus
            });
        }, 0);
    }
    _setJitterBufferTarget(pc) {
        try {
            const receivers = pc.getReceivers();
            receivers.forEach((receiver)=>{
                receiver.jitterBufferTarget = $1622be301bae0161$export$87d0694e432db510;
                receiver.playoutDelayHint = $1622be301bae0161$export$87d0694e432db510 / 1000;
            });
        } catch (error) {
            $1622be301bae0161$var$logger$4.error("Error during setting jitter buffer target:", error);
        }
    }
    _emitServerEvent(eventName, data, callback) {
        this._serverSocket.emit(eventName, data, callback);
    }
    _emit(eventName, data) {
        this._emitter.emit(eventName, data);
    }
    _addEnabledLocalStreamId(streamId) {
        this.enabledLocalStreamIds.push(streamId);
    }
    _deleteEnabledLocalStreamId(streamId) {
        const index = this.enabledLocalStreamIds.indexOf(streamId);
        if (index !== -1) this.enabledLocalStreamIds.splice(index, 1);
    }
    _getSession(peerConnectionId) {
        if (!(peerConnectionId in this.peerConnections)) return null;
        return this.peerConnections[peerConnectionId];
    }
    _getOrCreateSession(peerConnectionId, initialBandwidth) {
        let session = this.peerConnections[peerConnectionId];
        if (session === undefined) {
            const deprioritizeH264Encoding = $1622be301bae0161$var$browserName$1 === "safari" && $1622be301bae0161$var$browserVersion && $1622be301bae0161$var$browserVersion >= 14 && this._features.deprioritizeH264OnSafari;
            this.peerConnections[peerConnectionId] = session = new $1622be301bae0161$export$1fb4852a55678982({
                peerConnectionId: peerConnectionId,
                bandwidth: initialBandwidth,
                maximumTurnBandwidth: this._features.unlimitedBandwidthWhenUsingRelayP2POn ? $1622be301bae0161$export$6bb71afef3ab9ece : $1622be301bae0161$export$737bc7bda2eb5bf5,
                deprioritizeH264Encoding: deprioritizeH264Encoding
            });
            this.totalSessionsCreated++;
        }
        return session;
    }
    _getLocalCameraStream() {
        return this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
    }
    _getNonLocalCameraStreamIds() {
        return Object.keys(this.localStreams).filter((streamId)=>streamId !== $1622be301bae0161$var$CAMERA_STREAM_ID);
    }
    _isScreensharingLocally() {
        return this._getNonLocalCameraStreamIds().length > 0;
    }
    _getFirstLocalNonCameraStream() {
        const streamIds = this._getNonLocalCameraStreamIds();
        return streamIds.length === 0 ? null : this.localStreams[streamIds[0]];
    }
    _transformIncomingSdp(original, _) {
        return {
            type: original.type,
            sdp: original.sdpU
        };
    }
    _transformOutgoingSdp(original) {
        return {
            type: original.type,
            sdpU: original.sdp
        };
    }
    _createSession({ clientId: clientId, initialBandwidth: initialBandwidth, isOfferer: isOfferer, peerConnectionId: peerConnectionId, shouldAddLocalVideo: shouldAddLocalVideo }) {
        if (!peerConnectionId) throw new Error("peerConnectionId is missing");
        if (!clientId) throw new Error("clientId is missing");
        const session = this._getOrCreateSession(peerConnectionId, initialBandwidth);
        const constraints = {
            optional: []
        };
        if ($1622be301bae0161$var$browserName$1 === "chrome") constraints.optional.push({
            googCpuOveruseDetection: true
        });
        constraints.optional.push({
            rtcStatsRoomSessionId: this._roomSessionId
        });
        constraints.optional.push({
            rtcStatsClientId: this._selfId
        });
        constraints.optional.push({
            rtcStatsPeerId: peerConnectionId
        });
        constraints.optional.push({
            rtcStatsConferenceId: this._roomName
        });
        const peerConnectionConfig = {
            iceServers: this._iceServers
        };
        if (this._features.turnServerOverrideHost) {
            const host = this._features.turnServerOverrideHost;
            const port = host.indexOf(":") > 0 ? "" : ":443";
            const override = ":" + host + port;
            peerConnectionConfig.iceServers = peerConnectionConfig.iceServers.map((original)=>{
                const entry = Object.assign({}, original);
                if (entry.url) entry.url = entry.url.replace(/:[^?]*/, override);
                if (entry.urls) entry.urls = entry.urls.map((url)=>url.replace(/:[^?]*/, override));
                return entry;
            });
        }
        if (this._features.useOnlyTURN) {
            peerConnectionConfig.iceTransportPolicy = "relay";
            const filter = {
                onlyudp: /^turn:.*transport=udp$/,
                onlytcp: /^turn:.*transport=tcp$/,
                onlytls: /^turns:.*transport=tcp$/
            }[this._features.useOnlyTURN];
            if (filter) peerConnectionConfig.iceServers = peerConnectionConfig.iceServers.filter((entry)=>entry.url && entry.url.match(filter));
        }
        if ($1622be301bae0161$var$browserName$1 === "chrome") peerConnectionConfig.sdpSemantics = "unified-plan";
        const pc = session.setAndGetPeerConnection({
            constraints: constraints,
            peerConnectionConfig: peerConnectionConfig,
            shouldAddLocalVideo: shouldAddLocalVideo,
            clientId: clientId
        });
        setTimeout(()=>this._emit($1622be301bae0161$export$188476a9307fd26f.NEW_PC), 0);
        pc.ontrack = (event)=>{
            const stream = event.streams[0];
            if (stream.id === "default" && stream.getAudioTracks().length === 0) return;
            if (session.streamIds.indexOf(stream.id) === -1) {
                session.streamIds.push(stream.id);
                this._emit($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                    clientId: clientId,
                    stream: stream
                });
                if (session.connectionStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_SUCCESSFUL) setTimeout(()=>{
                    this._emit($1622be301bae0161$export$fa3d5b535a2458a1.CLIENT_CONNECTION_STATUS_CHANGED, {
                        streamIds: session.streamIds,
                        clientId: clientId,
                        status: session.connectionStatus,
                        previous: $1622be301bae0161$export$426db7a6155b7a80.CONNECTING
                    });
                }, 0);
            }
        };
        pc.oniceconnectionstatechange = ()=>{
            let newStatus;
            const currentStatus = session.connectionStatus;
            switch(pc.iceConnectionState){
                case "checking":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTING;
                    break;
                case "connected":
                case "completed":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_SUCCESSFUL;
                    if (!session.wasEverConnected) {
                        this._pendingActionsForConnectedPeerConnections.forEach((action)=>{
                            if (typeof action === "function") action();
                        });
                        this._pendingActionsForConnectedPeerConnections = [];
                    }
                    if (!session.wasEverConnected && (pc.iceConnectionState.match(/connected|completed/) || $1622be301bae0161$var$browserName$1 === "chrome" && pc.localDescription && pc.localDescription.type === "answer")) {
                        session.wasEverConnected = true;
                        if (this._features.bandwidth !== "false") this.maybeRestrictRelayBandwidth(session);
                    }
                    if (this._isAudioOnlyMode) session.setAudioOnly(true, this._screenshareVideoTrackIds);
                    session.registerConnected();
                    break;
                case "disconnected":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_DISCONNECTED;
                    setTimeout(()=>{
                        if (pc.iceConnectionState === "disconnected") this._maybeRestartIce(clientId, session);
                    }, 2000);
                    break;
                case "failed":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_FAILED;
                    if (currentStatus !== newStatus) this._maybeRestartIce(clientId, session);
                    if (session.relayCandidateSeen === null && !session.wasEverConnected) this._emit($1622be301bae0161$export$188476a9307fd26f.CONNECTION_BLOCKED_BY_NETWORK);
                    break;
                default:
                    return;
            }
            this._setConnectionStatus(session, newStatus, clientId);
        };
        pc.onconnectionstate = ()=>{
            switch(pc.connectionState){
                case "connected":
                    setTimeout(()=>{
                        $1622be301bae0161$export$60abf66a104f71b0(session.pc).then((failureDirection)=>{
                            if (failureDirection !== false) this._emit($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_NOT_WORKING, {
                                failureDirection: failureDirection,
                                clientId: clientId
                            });
                        });
                    }, 3000);
                    session.registerConnected();
                    break;
                case "failed":
                    const newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_FAILED;
                    if (session.relayCandidateSeen === null && !session.wasEverConnected) this._emit($1622be301bae0161$export$188476a9307fd26f.CONNECTION_BLOCKED_BY_NETWORK);
                    this._setConnectionStatus(session, newStatus, clientId);
                    break;
            }
        };
        const localCameraStream = this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
        if (shouldAddLocalVideo && localCameraStream) session.addStream(localCameraStream);
        if (shouldAddLocalVideo) Object.keys(this.localStreams).forEach((id)=>{
            if (id === $1622be301bae0161$var$CAMERA_STREAM_ID) return;
            const screenshareStream = this.localStreams[id];
            if (isOfferer) session.addStream(screenshareStream);
            else session.afterConnected.then(()=>{
                this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
                    receiverId: session.clientId,
                    streamId: screenshareStream.id,
                    hasAudioTrack: !!screenshareStream.getAudioTracks().length
                });
                this._withForcedRenegotiation(session, ()=>session.addStream(screenshareStream));
            });
        });
        return session;
    }
    _cleanup(peerConnectionId) {
        const session = this._getSession(peerConnectionId);
        if (!session) {
            $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection in RTCManager.disconnect()", peerConnectionId);
            return;
        }
        session.close();
        delete this.peerConnections[peerConnectionId];
    }
    _forEachPeerConnection(func) {
        Object.values(this.peerConnections).forEach((peerConnection)=>{
            func(peerConnection);
        });
    }
    _addStreamToPeerConnections(stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.addStream(stream));
        });
    }
    _addTrackToPeerConnections(track, stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.addTrack(track, stream));
        });
    }
    _replaceTrackToPeerConnections(oldTrack, newTrack) {
        const promises = [];
        this._forEachPeerConnection((session)=>{
            if (!session.hasConnectedPeerConnection()) {
                $1622be301bae0161$var$logger$4.info("Session doesn't have a connected PeerConnection, adding pending action!");
                const pendingActions = this._pendingActionsForConnectedPeerConnections;
                if (!pendingActions) {
                    $1622be301bae0161$var$logger$4.warn(`No pending action is created to repalce track, because the pending actions array is null`);
                    return;
                }
                const promise = new Promise((resolve, reject)=>{
                    const action = ()=>{
                        const replacedTrackPromise = session.replaceTrack(oldTrack, newTrack);
                        if (!replacedTrackPromise) {
                            $1622be301bae0161$var$logger$4.error("replaceTrack returned false!");
                            reject(`ReplaceTrack returned false`);
                            return;
                        }
                        replacedTrackPromise.then((track)=>resolve(track)).catch((error)=>reject(error));
                    };
                    pendingActions.push(action);
                });
                promises.push(promise);
                return;
            }
            const replacedTrackResult = session.replaceTrack(oldTrack, newTrack);
            if (!replacedTrackResult) {
                $1622be301bae0161$var$logger$4.error("replaceTrack returned false!");
                return;
            }
            promises.push(replacedTrackResult);
        });
        return Promise.all(promises);
    }
    _removeStreamFromPeerConnections(stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.removeStream(stream));
        });
    }
    _removeTrackFromPeerConnections(track) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.removeTrack(track));
        });
    }
    _addLocalStream(streamId, stream) {
        this._addEnabledLocalStreamId(streamId);
        this.localStreams[streamId] = stream;
    }
    _removeLocalStream(streamId) {
        delete this.localStreams[streamId];
        this._deleteEnabledLocalStreamId(streamId);
    }
    _updateAndScheduleMediaServersRefresh({ iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds }) {
        this._iceServers = iceServers;
        this._sfuServer = sfuServer;
        this._mediaserverConfigTtlSeconds = mediaserverConfigTtlSeconds;
        this._clearMediaServersRefresh();
        if (!mediaserverConfigTtlSeconds) return;
        this._fetchMediaServersTimer = setTimeout(()=>this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.FETCH_MEDIASERVER_CONFIG), mediaserverConfigTtlSeconds * 1000);
    }
    _clearMediaServersRefresh() {
        if (!this._fetchMediaServersTimer) return;
        clearTimeout(this._fetchMediaServersTimer);
        this._fetchMediaServersTimer = null;
    }
    _monitorAudioTrack(track) {
        var _a, _b;
        if (((_a = this._audioTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._audioTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._audioTrackOnEnded);
        track.addEventListener("ended", this._audioTrackOnEnded);
        this._audioTrackBeingMonitored = track;
    }
    _monitorVideoTrack(track) {
        var _a, _b;
        if (((_a = this._videoTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._videoTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._videoTrackOnEnded);
        track.addEventListener("ended", this._videoTrackOnEnded);
        this._videoTrackBeingMonitored = track;
    }
    _connect(clientId) {
        let session = this._getSession(clientId);
        let initialBandwidth = session && session.bandwidth || 0;
        if (session) {
            $1622be301bae0161$var$logger$4.warn("Replacing peer session", clientId);
            this._cleanup(clientId);
        } else initialBandwidth = this._changeBandwidthForAllClients(true);
        session = this._createP2pSession({
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: true,
            isOfferer: true
        });
        this._negotiatePeerConnection(clientId, session);
        return Promise.resolve(session);
    }
    _maybeRestartIce(clientId, session) {
        const pc = session.pc;
        if (!(pc.iceConnectionState === "disconnected" || pc.iceConnectionState === "failed")) return;
        if (pc.localDescription.type === "offer") {
            session.wasEverConnected = false;
            session.relayCandidateSeen = false;
            session.serverReflexiveCandidateSeen = false;
            session.publicHostCandidateSeen = false;
            session.ipv6HostCandidateSeen = false;
            this.ipv6HostCandidateTeredoSeen = false;
            this.ipv6HostCandidate6to4Seen = false;
            this.mdnsHostCandidateSeen = false;
            this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_RESTART);
            this._negotiatePeerConnection(clientId, session, Object.assign({}, this.offerOptions, {
                iceRestart: true
            }));
        }
    }
    _setCodecPreferences(pc, vp9On, av1On, redOn) {
        try {
            const audioTransceivers = pc.getTransceivers().filter((transceiver)=>{
                var _a, _b;
                return ((_b = (_a = transceiver === null || transceiver === void 0 ? void 0 : transceiver.sender) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "audio";
            });
            audioTransceivers.forEach((audioTransceiver)=>{
                if (typeof RTCRtpSender.getCapabilities === "undefined") return;
                const capabilities = RTCRtpSender.getCapabilities("audio");
                for(let i = 0; i < capabilities.codecs.length; i++)if (redOn && capabilities.codecs[i].mimeType.toLowerCase() === "audio/red") {
                    capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                    break;
                }
                if (typeof audioTransceiver.setCodecPreferences === "undefined") return;
                audioTransceiver.setCodecPreferences(capabilities.codecs);
            });
            const videoTransceivers = pc.getTransceivers().filter((transceiver)=>{
                var _a, _b;
                return ((_b = (_a = transceiver === null || transceiver === void 0 ? void 0 : transceiver.sender) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "video";
            });
            videoTransceivers.forEach((videoTransceiver)=>{
                if (RTCRtpSender.getCapabilities === undefined) return;
                const capabilities = RTCRtpSender.getCapabilities("video");
                for(let i = 0; i < capabilities.codecs.length; i++){
                    if (vp9On && capabilities.codecs[i].mimeType.toLowerCase() === "video/vp9") {
                        capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                        break;
                    }
                    if (av1On && capabilities.codecs[i].mimeType.toLowerCase() === "video/av1") {
                        capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                        break;
                    }
                }
                if (videoTransceiver.setCodecPreferences === undefined) return;
                videoTransceiver.setCodecPreferences(capabilities.codecs);
            });
        } catch (error) {
            $1622be301bae0161$var$logger$4.error("Error during setting setCodecPreferences:", error);
        }
    }
    _negotiatePeerConnection(clientId, session, constraints) {
        if (!session) {
            $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection in negotiatePeerConnection()", clientId);
            return;
        }
        const pc = session.pc;
        if (!session.canModifyPeerConnection()) {
            session.pending.push(()=>{
                this._negotiatePeerConnection(clientId, session, constraints);
            });
            return;
        }
        session.isOperationPending = true;
        const { vp9On: vp9On, av1On: av1On, redOn: redOn, rtpAbsCaptureTimeOn: rtpAbsCaptureTimeOn, cleanSdpOn: cleanSdpOn } = this._features;
        if (vp9On || av1On || redOn) this._setCodecPreferences(pc, vp9On, av1On, redOn);
        pc.createOffer(constraints || this.offerOptions).then((offer)=>{
            if (rtpAbsCaptureTimeOn) offer.sdp = $1622be301bae0161$export$eb32cdfe1ef3eb9c(offer.sdp);
            if ((vp9On || redOn) && $1622be301bae0161$var$browserName$1 === "firefox") offer.sdp = $1622be301bae0161$export$e6fb7443cbdf2b8b(offer.sdp, vp9On, redOn);
            if (cleanSdpOn) offer.sdp = $1622be301bae0161$export$529db98703a04dea(offer.sdp);
            pc.setLocalDescription(offer).catch((e)=>{
                $1622be301bae0161$var$logger$4.warn("RTCPeerConnection.setLocalDescription() failed with local offer", e);
                this._emit($1622be301bae0161$export$188476a9307fd26f.PC_SLD_FAILURE, e);
                throw e;
            }).then(()=>{
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.SDP_OFFER, {
                    receiverId: clientId,
                    message: this._transformOutgoingSdp(offer)
                });
            });
        }).catch((e)=>{
            $1622be301bae0161$var$logger$4.warn("RTCPeerConnection.createOffer() failed to create local offer", e);
        });
    }
    _withForcedRenegotiation(session, action) {
        const pc = session.pc;
        const originalOnnegotationneeded = pc.onnegotationneeded;
        pc.onnegotiationneeded = null;
        action();
        this._negotiatePeerConnection(session.clientId, session);
        setTimeout(()=>pc.onnegotiationneeded = originalOnnegotationneeded, 0);
    }
    _changeBandwidthForAllClients(isJoining) {
        let numPeers = this.numberOfPeerconnections();
        if (isJoining) numPeers += 1;
        if (numPeers === 0) return 0;
        if (numPeers > 7) numPeers = 7;
        let bandwidth = this._features.bandwidth ? parseInt(this._features.bandwidth, 10) : ({
            1: 0,
            2: this._features.highP2PBandwidth ? 768 : 384,
            3: this._features.highP2PBandwidth ? 512 : 256,
            4: 192,
            5: 128,
            6: 128,
            7: 64
        })[numPeers];
        if (bandwidth === undefined) return 0;
        if (this._features.adjustBitratesFromResolution) {
            const cameraStream = this._getLocalCameraStream();
            if (cameraStream) {
                const cameraTrack = cameraStream && cameraStream.getVideoTracks()[0];
                if (cameraTrack) {
                    const { width: width, height: height, frameRate: frameRate } = cameraTrack.getSettings();
                    if (width && height && frameRate) {
                        const optimalBandwidth = Math.round($1622be301bae0161$export$a7c2590c69aa3b06(width, height, frameRate) / 1000);
                        bandwidth = Math.min(optimalBandwidth, bandwidth || optimalBandwidth);
                    }
                }
            }
        }
        if (this._features.higherP2PBitrates) bandwidth = bandwidth * 1.5;
        this._forEachPeerConnection((session)=>{
            session.changeBandwidth(bandwidth);
        });
        return bandwidth;
    }
    _createP2pSession({ clientId: clientId, initialBandwidth: initialBandwidth, shouldAddLocalVideo: shouldAddLocalVideo = false, isOfferer: isOfferer = false }) {
        const session = this._createSession({
            peerConnectionId: clientId,
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: shouldAddLocalVideo,
            isOfferer: isOfferer
        });
        const pc = session.pc;
        if (this._features.increaseIncomingMediaBufferOn) this._setJitterBufferTarget(pc);
        const localCameraStream = this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
        if (shouldAddLocalVideo && localCameraStream && !localCameraStream.getVideoTracks().length && this._stoppedVideoTrack) pc.addTrack(this._stoppedVideoTrack, localCameraStream);
        pc.onicegatheringstatechange = (event)=>{
            const connection = event.target;
            switch(connection.iceGatheringState){
                case "gathering":
                    if (this.icePublicIPGatheringTimeoutID) clearTimeout(this.icePublicIPGatheringTimeoutID);
                    this.icePublicIPGatheringTimeoutID = setTimeout(()=>{
                        if (!session.publicHostCandidateSeen && !session.relayCandidateSeen && !session.serverReflexiveCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_NO_PUBLIC_IP_GATHERED_3SEC);
                    }, $1622be301bae0161$var$ICE_PUBLIC_IP_GATHERING_TIMEOUT);
                    break;
                case "complete":
                    if (this.icePublicIPGatheringTimeoutID) clearTimeout(this.icePublicIPGatheringTimeoutID);
                    this.icePublicIPGatheringTimeoutID = undefined;
                    break;
            }
        };
        pc.onicecandidate = (event)=>{
            var _a, _b;
            if (event.candidate) {
                switch((_a = event.candidate) === null || _a === void 0 ? void 0 : _a.type){
                    case "host":
                        const address = (_b = event === null || event === void 0 ? void 0 : event.candidate) === null || _b === void 0 ? void 0 : _b.address;
                        try {
                            if ($1622be301bae0161$export$bdfe8a6e5369c106.v4({
                                exact: true
                            }).test(address)) {
                                const ipv4 = (0, (/*@__PURE__*/$parcel$interopDefault($1ecbb2f73dbf2ce4$exports)))(address);
                                if (ipv4.isPublicIp) session.publicHostCandidateSeen = true;
                            } else if ($1622be301bae0161$export$bdfe8a6e5369c106.v6({
                                exact: true
                            }).test(address.replace(/^\[(.*)\]/, "$1"))) {
                                const ipv6 = new (0, $fcb6503f150ed464$exports.Address6)(address.replace(/^\[(.*)\]/, "$1"));
                                session.ipv6HostCandidateSeen = true;
                                if (ipv6.getScope() === "Global") session.publicHostCandidateSeen = true;
                                if (ipv6.isTeredo()) session.ipv6HostCandidateTeredoSeen = true;
                                if (ipv6.is6to4()) session.ipv6HostCandidate6to4Seen = true;
                            } else {
                                const uuidv4 = address.replace(/.local/, "");
                                if (uuidv4 && (0, (/*@__PURE__*/$parcel$interopDefault($8c12fcb2a8b6be0e$exports)))(uuidv4, 4)) session.mdnsHostCandidateSeen = true;
                            }
                        } catch (error) {
                            $1622be301bae0161$var$logger$4.info("Error during parsing candidates! Error: ", {
                                error: error
                            });
                        }
                        break;
                    case "srflx":
                        if (!session.serverReflexiveCandidateSeen) session.serverReflexiveCandidateSeen = true;
                        break;
                    case "relay":
                    case "relayed":
                        if (!session.relayCandidateSeen) session.relayCandidateSeen = true;
                        break;
                }
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.ICE_CANDIDATE, {
                    receiverId: clientId,
                    message: event.candidate
                });
            } else {
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.ICE_END_OF_CANDIDATES, {
                    receiverId: clientId
                });
                if (!session.publicHostCandidateSeen && !session.relayCandidateSeen && !session.serverReflexiveCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_NO_PUBLIC_IP_GATHERED);
                if (session.ipv6HostCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_IPV6_SEEN, {
                    teredoSeen: session.ipv6HostCandidateTeredoSeen,
                    sixtofourSeen: session.ipv6HostCandidate6to4Seen
                });
                if (session.mdnsHostCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_MDNS_SEEN);
            }
        };
        pc.onnegotiationneeded = ()=>{
            if (pc.iceConnectionState === "new" || !session.connectionStatus) return;
            this._negotiatePeerConnection(clientId, session);
        };
        return session;
    }
    acceptNewStream({ streamId: streamId, clientId: clientId, shouldAddLocalVideo: shouldAddLocalVideo }) {
        let session = this._getSession(clientId);
        if (session && streamId !== clientId) return session;
        let initialBandwidth = session && session.bandwidth || 0;
        if (session) {
            $1622be301bae0161$var$logger$4.warn("Replacing peer session", clientId);
            this._cleanup(clientId);
        } else initialBandwidth = this._changeBandwidthForAllClients(true);
        session = this._createP2pSession({
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: !!shouldAddLocalVideo,
            isOfferer: false
        });
        this._emitServerEvent($1622be301bae0161$export$83849580da009913.READY_TO_RECEIVE_OFFER, {
            receiverId: clientId
        });
        return session;
    }
    disconnect(clientId) {
        this._cleanup(clientId);
        this._changeBandwidthForAllClients(false);
        const numPeers = this.numberOfPeerconnections();
        if (numPeers === 0) setTimeout(()=>{
            const numPeers = this.numberOfPeerconnections();
            if (numPeers === 0) this.rtcStatsDisconnect();
        }, 60000);
    }
    updateStreamResolution() {}
    stopOrResumeAudio() {}
    _handleStopOrResumeVideo({ enable: enable, track: track }) {
        if (!enable) this._stoppedVideoTrack = track;
        else if (this._stoppedVideoTrack) {
            this._replaceTrackToPeerConnections(this._stoppedVideoTrack, track);
            delete this._stoppedVideoTrack;
        } else this._addTrackToPeerConnections(track);
    }
    stopOrResumeVideo(localStream, enable) {
        var _a;
        if (![
            "chrome",
            "safari"
        ].includes($1622be301bae0161$var$browserName$1)) return;
        if (enable === false) {
            const stopCameraDelay = ((_a = localStream.getVideoTracks().find((t)=>!t.enabled)) === null || _a === void 0 ? void 0 : _a.readyState) === "ended" ? 0 : 5000;
            setTimeout(()=>{
                localStream.getVideoTracks().forEach((track)=>{
                    if (track.enabled === false) {
                        track.stop();
                        localStream.removeTrack(track);
                        this._emit($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_REMOVED, {
                            stream: localStream,
                            track: track
                        });
                        this._handleStopOrResumeVideo({
                            enable: enable,
                            track: track
                        });
                    }
                });
            }, stopCameraDelay);
        } else if (localStream.getVideoTracks().length === 0) {
            const constraints = this._webrtcProvider.getMediaConstraints().video;
            if (!constraints) return;
            navigator.mediaDevices.getUserMedia({
                video: constraints
            }).then((stream)=>{
                const track = stream.getVideoTracks()[0];
                localStream.addTrack(track);
                this._monitorVideoTrack(track);
                this._emit($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_ADDED, {
                    streamId: localStream.id,
                    tracks: [
                        track
                    ],
                    screenShare: false
                });
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            });
        }
    }
    _shareScreen(streamId, stream) {
        this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
            streamId: streamId,
            hasAudioTrack: !!stream.getAudioTracks().length
        });
        this._wasScreenSharing = true;
        this._addStreamToPeerConnections(stream);
    }
    removeStream(streamId, stream, requestedByClientId) {
        this._removeLocalStream(streamId);
        this._removeStreamFromPeerConnections(stream);
        this._wasScreenSharing = false;
        this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.STOP_SCREENSHARE, {
            streamId: streamId,
            requestedByClientId: requestedByClientId
        });
    }
    hasClient(clientId) {
        return Object.keys(this.peerConnections).includes(clientId);
    }
    constructor({ selfId: selfId, room: room, emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features }){
        const { name: name, session: session, iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds } = room;
        this._selfId = selfId;
        this._roomName = name;
        this._roomSessionId = session && session.id;
        this.peerConnections = {};
        this.localStreams = {};
        this.enabledLocalStreamIds = [];
        this._screenshareVideoTrackIds = [];
        this._socketListenerDeregisterFunctions = [];
        this._localStreamDeregisterFunction = null;
        this._emitter = emitter;
        this._serverSocket = serverSocket;
        this._webrtcProvider = webrtcProvider;
        this._features = features || {};
        this._isAudioOnlyMode = false;
        this.offerOptions = {
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        };
        this._pendingActionsForConnectedPeerConnections = [];
        this._audioTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_ended", {
                unloading: $1622be301bae0161$var$unloading$1
            });
            this._emit($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_STOPPED_WORKING, {});
        };
        this._videoTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_ended", {
                unloading: $1622be301bae0161$var$unloading$1
            });
            this._emit($1622be301bae0161$export$188476a9307fd26f.CAMERA_STOPPED_WORKING, {});
        };
        this._updateAndScheduleMediaServersRefresh({
            sfuServer: sfuServer,
            iceServers: iceServers.iceServers || [],
            mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds
        });
        this.totalSessionsCreated = 0;
    }
}
class $1622be301bae0161$export$c449b73d128b1370 {
    filter(z, u = 0) {
        if (isNaN(this.x)) {
            this.x = 1 / this.C * z;
            this.cov = 1 / this.C * this.Q * (1 / this.C);
        } else {
            const predX = this.predict(u);
            const predCov = this.uncertainty();
            const K = predCov * this.C * (1 / (this.C * predCov * this.C + this.Q));
            this.x = predX + K * (z - this.C * predX);
            this.cov = predCov - K * this.C * predCov;
        }
        return this.x;
    }
    predict(u = 0) {
        return this.A * this.x + this.B * u;
    }
    uncertainty() {
        return this.A * this.cov * this.A + this.R;
    }
    lastMeasurement() {
        return this.x;
    }
    setMeasurementNoise(noise) {
        this.Q = noise;
    }
    setProcessNoise(noise) {
        this.R = noise;
    }
    constructor({ R: R = 0.01, Q: Q = 2, A: A = 1.1, B: B = 1, C: C = 1.2 } = {
        R: 0.01,
        Q: 2,
        A: 1.1,
        B: 1,
        C: 1.2
    }){
        this.R = R;
        this.Q = Q;
        this.A = A;
        this.C = C;
        this.B = B;
        this.cov = NaN;
        this.x = NaN;
    }
}
const $1622be301bae0161$export$9d693fe1516c2cb1 = ()=>{
    let ewma = -1;
    let lastMax = 0;
    let counter = 0;
    return (arr)=>{
        const max = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
        if (ewma < 0) ewma = max;
        else ewma = ewma * 0.95 + max * 0.05;
        if (++counter < 2) {
            lastMax = max;
            return 0;
        }
        const acf = (max - ewma) * (lastMax - ewma);
        lastMax = max;
        return acf;
    };
};
const $1622be301bae0161$export$2edc519377674578 = (arr)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return arr.reduce((acc, val)=>acc.concat(Math.pow(val - mean, 2)), []).reduce((acc, val)=>acc + val, 0) / arr.length;
};
const $1622be301bae0161$export$3cc65d9d108eb4e1 = (arr)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return {
        mean: mean,
        SD: Math.sqrt(arr.reduce((acc, val)=>acc + Math.pow(val - mean, 2), 0) / arr.length)
    };
};
const $1622be301bae0161$export$9b77da0927470c3d = (arr, usePopulation = false)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return arr.reduce((acc, val)=>acc.concat(Math.pow(val - mean, 2)), []).reduce((acc, val)=>acc + val, 0) / (arr.length - (usePopulation ? 0 : 1));
};
var $1622be301bae0161$var$scriptFunctions = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    KalmanFilter: $1622be301bae0161$export$c449b73d128b1370,
    calculateStd: $1622be301bae0161$export$2edc519377674578,
    createACFCalculator: $1622be301bae0161$export$9d693fe1516c2cb1,
    standardDeviation: $1622be301bae0161$export$3cc65d9d108eb4e1,
    variance: $1622be301bae0161$export$9b77da0927470c3d
});
const $1622be301bae0161$var$defaultParams = {
    minDecibels: -80,
    maxDecibels: -10,
    smoothingTimeConstant: 0.8,
    aggSize: 1,
    sampleRate: 10,
    reportRate: 2,
    bins: 32,
    bands: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ]
    ],
    separateTrack: {
        autoGainControl: false,
        noiseSupression: false
    },
    binFormula: "bin",
    scoreFormula: "300 * bands[1].avg / Math.max(bands[1].avg + bands[0].avg, 0.01)",
    outFormula: "score"
};
const $1622be301bae0161$var$logger$3 = new $1622be301bae0161$export$efa9a398d6368992();
function $1622be301bae0161$export$af9222748cc412c5({ micTrack: micTrack, params: params, onScoreUpdated: onScoreUpdated }) {
    const audioCtx = new AudioContext();
    let analyser = null;
    let source = null;
    let lastTrack = null;
    let lastTrackWasOurs = false;
    const setTrack = (track)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            if (lastTrack && lastTrackWasOurs) lastTrack.stop();
            lastTrackWasOurs = false;
            if (track && params.separateTrack) try {
                const stream = yield navigator.mediaDevices.getUserMedia({
                    audio: Object.assign({
                        deviceId: lastTrack === null || lastTrack === void 0 ? void 0 : lastTrack.getSettings().deviceId
                    }, params.separateTrack),
                    video: false
                });
                track = stream.getAudioTracks()[0];
                lastTrackWasOurs = true;
            } catch (ex) {
                $1622be301bae0161$var$logger$3.warn("unable to fetch new track for colocation speaker analysis, using current", ex);
            }
            lastTrack = track;
            if (source) {
                source.disconnect();
                source = null;
            }
            if (track) {
                const stream = new MediaStream([
                    track
                ]);
                source = audioCtx.createMediaStreamSource(stream);
                source.connect(analyser);
            }
        });
    let samplerInterval;
    const setParams = (newParams)=>{
        clearInterval(samplerInterval);
        params = Object.assign(Object.assign({}, $1622be301bae0161$var$defaultParams), newParams);
        if (!analyser || analyser.fftSize !== params.bins * 2) {
            let restoreTrack = null;
            if (analyser) {
                restoreTrack = lastTrack;
                setTrack(null);
            }
            analyser = audioCtx.createAnalyser();
            analyser.fftSize = params.bins * 2;
            if (restoreTrack) setTrack(restoreTrack);
        }
        const bins = new Uint8Array(analyser.frequencyBinCount);
        const scores = [];
        analyser.minDecibels = params.minDecibels;
        analyser.maxDecibels = params.maxDecibels;
        analyser.smoothingTimeConstant = params.smoothingTimeConstant;
        const initScriptFunc = params.initScript && new Function("f", "setTrack", "lastTrack", params.initScript.join("\n"));
        const scoreScriptFunc = params.scoreScript && new Function("bins", "g", "f", params.scoreScript.join("\n"));
        const calcScore = params.scoreFormula && new Function("bands", `return ${params.scoreFormula}`);
        const getOutValue = params.outFormula && new Function("score", "avg", "max", "scores", `return ${params.outFormula}`);
        const binMap = params.binFormula && new Function("bin", "index", `return ${params.binFormula}`);
        let reportRateCounter = 0;
        const globals = initScriptFunc && initScriptFunc($1622be301bae0161$var$scriptFunctions, setTrack, lastTrack);
        const sampler = ()=>{
            analyser.getByteFrequencyData(bins);
            let score = 0;
            if (calcScore) {
                const processedBands = params.bands.map((range)=>{
                    const bands = range.map((index)=>binMap(bins[index] / 255, index));
                    return {
                        avg: bands.reduce((sum, current)=>sum + current, 0) / range.length,
                        min: bands.reduce((min, current)=>Math.min(min, current / 255), Number.MAX_VALUE),
                        max: bands.reduce((max, current)=>Math.max(max, current / 255), 0)
                    };
                });
                score = calcScore(processedBands) || 0;
            } else if (scoreScriptFunc) {
                score = scoreScriptFunc(bins, globals, $1622be301bae0161$var$scriptFunctions);
                if (isNaN(score)) score = 0;
            }
            scores.push(score);
            if (scores.length > params.aggSize) scores.shift();
            reportRateCounter++;
            if (reportRateCounter >= params.reportRate) {
                reportRateCounter = 0;
                const max = scores.reduce((a, b)=>Math.max(a, b), 0);
                const avg = scores.reduce((a, b)=>a + b, 0) / scores.length;
                const out = getOutValue(score, avg, max, scores);
                onScoreUpdated({
                    bins: bins,
                    score: score,
                    max: max,
                    avg: avg,
                    out: out
                });
            }
        };
        samplerInterval = setInterval(sampler, 1000 / params.sampleRate);
    };
    setParams(params);
    setTrack(micTrack);
    return {
        setParams: setParams,
        setTrack: setTrack,
        close () {
            setTrack(null);
            clearInterval(samplerInterval);
            audioCtx.close();
        }
    };
}
const $1622be301bae0161$var$logger$2 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$MEDIA_QUALITY = Object.freeze({
    ok: "ok",
    warning: "warning",
    critical: "critical"
});
const $1622be301bae0161$var$MONITOR_INTERVAL = 600;
const $1622be301bae0161$var$TREND_HORIZON = 3;
const $1622be301bae0161$var$WARNING_SCORE = 9;
const $1622be301bae0161$var$CRITICAL_SCORE = 7;
class $1622be301bae0161$export$9a5481974d870db4 extends (0, (/*@__PURE__*/$parcel$interopDefault($11OXI))) {
    close() {
        clearInterval(this._intervalHandle);
        delete this._intervalHandle;
        this._producers = {};
        this._clients = {};
    }
    _startMonitor() {
        this._intervalHandle = setInterval(()=>{
            Object.entries(this._producers).forEach(([clientId, producers])=>{
                this._evaluateClient(clientId, producers);
            });
        }, $1622be301bae0161$var$MONITOR_INTERVAL);
    }
    _evaluateClient(clientId, producers) {
        if (!this._clients[clientId]) this._clients[clientId] = {
            audio: {
                currentQuality: $1622be301bae0161$var$MEDIA_QUALITY.ok,
                trend: []
            },
            video: {
                currentQuality: $1622be301bae0161$var$MEDIA_QUALITY.ok,
                trend: []
            }
        };
        this._evaluateProducer(clientId, Object.values(producers).filter((p)=>p.kind === "audio"), "audio");
        this._evaluateProducer(clientId, Object.values(producers).filter((p)=>p.kind === "video"), "video");
    }
    _evaluateProducer(clientId, producers, kind) {
        if (producers.length === 0) return;
        const avgScore = producers.reduce((prev, curr)=>prev + curr.score, 0) / producers.length;
        const newQuality = this._evaluateScore(avgScore);
        const qualityChanged = this._updateTrend(newQuality, this._clients[clientId][kind]);
        if (qualityChanged) this.emit($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, {
            clientId: clientId,
            kind: kind,
            quality: newQuality
        });
    }
    _updateTrend(newQuality, state) {
        state.trend.push(newQuality);
        if (state.trend.length > $1622be301bae0161$var$TREND_HORIZON) state.trend.shift();
        if (newQuality !== state.currentQuality && state.trend.every((t)=>t !== state.currentQuality)) {
            state.currentQuality = newQuality;
            return true;
        } else return false;
    }
    addProducer(clientId, producerId) {
        if (!clientId || !producerId || !(typeof clientId === "string" && typeof producerId === "string")) {
            $1622be301bae0161$var$logger$2.warn("Missing clientId or producerId");
            return;
        }
        if (!this._producers[clientId]) this._producers[clientId] = {};
        this._producers[clientId][producerId] = {};
    }
    removeProducer(clientId, producerId) {
        delete this._producers[clientId][producerId];
        if (Object.keys(this._producers[clientId]).length === 0) delete this._producers[clientId];
    }
    addConsumer(clientId, consumerId) {
        if (!clientId || !consumerId) {
            $1622be301bae0161$var$logger$2.warn("Missing clientId or consumerId");
            return;
        }
        if (!this._producers[clientId]) this._producers[clientId] = {};
        this._producers[clientId][consumerId] = {};
    }
    removeConsumer(clientId, consumerId) {
        delete this._producers[clientId][consumerId];
        if (Object.keys(this._producers[clientId]).length === 0) delete this._producers[clientId];
    }
    addProducerScore(clientId, producerId, kind, score) {
        if (!Array.isArray(score) || score.length === 0 || score.some((s)=>!s || !s.hasOwnProperty("score") || typeof s.score !== "number" || isNaN(s.score))) {
            $1622be301bae0161$var$logger$2.warn("Unexpected producer score format");
            return;
        }
        this._producers[clientId][producerId] = {
            kind: kind,
            score: this._calcAvgProducerScore(score.map((s)=>s.score))
        };
    }
    addConsumerScore(clientId, consumerId, kind, score) {
        if (!score || !score.hasOwnProperty("producerScores") || !Array.isArray(score.producerScores)) {
            $1622be301bae0161$var$logger$2.warn("Unexpected consumer score format");
            return;
        }
        this._producers[clientId][consumerId] = {
            kind: kind,
            score: this._calcAvgProducerScore(score.producerScores)
        };
    }
    _evaluateScore(score) {
        if (score <= $1622be301bae0161$var$WARNING_SCORE && score > $1622be301bae0161$var$CRITICAL_SCORE) return $1622be301bae0161$var$MEDIA_QUALITY.warning;
        else if (score <= $1622be301bae0161$var$CRITICAL_SCORE && score > 0) return $1622be301bae0161$var$MEDIA_QUALITY.critical;
        else return $1622be301bae0161$var$MEDIA_QUALITY.ok;
    }
    _calcAvgProducerScore(scores) {
        try {
            if (!Array.isArray(scores) || scores.length === 0) return 0;
            let totalScore = 0;
            let divisor = 0;
            scores.forEach((score)=>{
                if (score > 0) {
                    totalScore += score;
                    divisor++;
                }
            });
            if (totalScore === 0 || divisor === 0) return 0;
            else return totalScore / divisor;
        } catch (error) {
            $1622be301bae0161$var$logger$2.error(error);
            return 0;
        }
    }
    constructor(){
        super();
        this._clients = {};
        this._producers = {};
        this._startMonitor();
    }
}
const $1622be301bae0161$export$3a1d5401f2f6ef55 = (transportConfig, features)=>{
    if (!features.useOnlyTURN) return;
    transportConfig.iceTransportPolicy = "relay";
    const filter = {
        onlyudp: /^turn:.*transport=udp$/,
        onlytcp: /^turn:.*transport=tcp$/,
        onlytls: /^turns:.*transport=tcp$/
    }[features.useOnlyTURN];
    if (filter) transportConfig.iceServers = transportConfig.iceServers.filter((entry)=>entry.url && entry.url.match(filter));
};
function $1622be301bae0161$var$getLayers({ width: width, height: height }, { numberOfActiveVideos: numberOfActiveVideos, numberOfTemporalLayers: numberOfTemporalLayers, uncappedSingleRemoteVideoOn: uncappedSingleRemoteVideoOn }) {
    const maxSide = Math.max(width, height);
    let spatialLayer = maxSide >= 480 ? maxSide >= 960 ? 2 : 1 : 0;
    let temporalLayer = numberOfTemporalLayers - 1;
    if (maxSide < 100) temporalLayer = Math.max(numberOfTemporalLayers - 2, 0);
    if (numberOfActiveVideos > 8 && spatialLayer === 0) temporalLayer = Math.max(numberOfTemporalLayers - 2, 0);
    if (numberOfActiveVideos < 4 && maxSide > 300 && spatialLayer === 0) spatialLayer = 1;
    if (uncappedSingleRemoteVideoOn && numberOfActiveVideos === 1) {
        spatialLayer = 2;
        temporalLayer = numberOfTemporalLayers - 1;
    }
    return {
        spatialLayer: spatialLayer,
        temporalLayer: temporalLayer
    };
}
function $1622be301bae0161$var$getNumberOfActiveVideos(consumers) {
    let numberOfActiveVideos = 0;
    consumers.forEach((c)=>{
        var _a, _b;
        if (c._closed || c._paused) return;
        if (((_a = c._appData) === null || _a === void 0 ? void 0 : _a.source) === "webcam" || ((_b = c._appData) === null || _b === void 0 ? void 0 : _b.source) === "screenvideo") numberOfActiveVideos++;
    });
    return numberOfActiveVideos;
}
function $1622be301bae0161$var$getNumberOfTemporalLayers(consumer) {
    var _a, _b, _c;
    return /T3/.test(((_c = (_b = (_a = consumer._rtpParameters) === null || _a === void 0 ? void 0 : _a.encodings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.scalabilityMode) || "") ? 3 : 2;
}
var $1622be301bae0161$var$_a$1;
const $1622be301bae0161$var$adapter$1 = ($1622be301bae0161$var$_a$1 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$1 !== void 0 ? $1622be301bae0161$var$_a$1 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$1 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$browserName = $1622be301bae0161$var$adapter$1.browserDetails.browser;
let $1622be301bae0161$var$unloading = false;
const $1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS = 3500;
const $1622be301bae0161$var$RESTARTICE_ERROR_MAX_RETRY_COUNT = 5;
const $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID = (0, $e247db96f48d686a$export$2e2bcd8739ae039)();
const $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID = (0, $e247db96f48d686a$export$2e2bcd8739ae039)();
if ($1622be301bae0161$var$browserName === "chrome") window.document.addEventListener("beforeunload", ()=>$1622be301bae0161$var$unloading = true);
class $1622be301bae0161$export$b44cbfcf90b97eac {
    _updateAndScheduleMediaServersRefresh({ iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds }) {
        var _a, _b;
        this._iceServers = iceServers;
        this._sfuServer = sfuServer;
        this._mediaserverConfigTtlSeconds = mediaserverConfigTtlSeconds;
        (_a = this._sendTransport) === null || _a === void 0 || _a.updateIceServers({
            iceServers: this._iceServers
        });
        (_b = this._receiveTransport) === null || _b === void 0 || _b.updateIceServers({
            iceServers: this._iceServers
        });
        this._clearMediaServersRefresh();
        if (!mediaserverConfigTtlSeconds) return;
        this._fetchMediaServersTimer = setTimeout(()=>this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.FETCH_MEDIASERVER_CONFIG), mediaserverConfigTtlSeconds * 1000);
    }
    _clearMediaServersRefresh() {
        if (!this._fetchMediaServersTimer) return;
        clearTimeout(this._fetchMediaServersTimer);
        this._fetchMediaServersTimer = null;
    }
    setupSocketListeners() {
        this._socketListenerDeregisterFunctions.push(()=>this._clearMediaServersRefresh(), this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.MEDIASERVER_CONFIG, (data)=>{
            if (data.error) {
                $1622be301bae0161$var$logger$1.warn("FETCH_MEDIASERVER_CONFIG failed:", data.error);
                return;
            }
            this._updateAndScheduleMediaServersRefresh(data);
        }), this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ()=>{
            if (this._screenVideoTrack) this._emitScreenshareStarted();
            if (this._features.sfuReconnectV2On && !this._hasVegaConnection && this._reconnect) this._connect();
        }));
        this._connect();
    }
    _emitScreenshareStarted() {
        this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
            streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
            hasAudioTrack: Boolean(this._screenAudioTrack)
        });
    }
    _connect() {
        if (this._features.sfuReconnectV2On) {
            if (this._hasVegaConnection) return;
            if (!this._serverSocket.isConnected()) {
                const reconnectThresholdInMs = this._serverSocket.getReconnectThreshold();
                if (!reconnectThresholdInMs) return;
                if (Date.now() > (this._serverSocket.disconnectTimestamp || 0) + reconnectThresholdInMs) return;
            }
            if (this._reconnectTimeOut) clearTimeout(this._reconnectTimeOut);
        }
        const host = this._features.sfuServerOverrideHost || [
            this._sfuServer.url
        ];
        const searchParams = new URLSearchParams(Object.assign({
            clientId: this._selfId,
            organizationId: this._room.organizationId,
            roomName: this._room.name,
            eventClaim: this._room.isClaimed ? this._eventClaim : null,
            lowBw: "true"
        }, Object.keys(this._features || {}).filter((featureKey)=>this._features[featureKey] && /^sfu/.test(featureKey)).reduce((prev, current)=>Object.assign(Object.assign({}, prev), {
                [current]: this._features[current]
            }), {})));
        const queryString = searchParams.toString();
        const wsUrl = `wss://${host}?${queryString}`;
        this._vegaConnection = new $1622be301bae0161$export$b281e2872ffa0a70(wsUrl);
        this._hasVegaConnection = true;
        this._vegaConnection.on("open", ()=>this._join());
        this._vegaConnection.on("close", ()=>this._onClose());
        this._vegaConnection.on("message", (message)=>this._onMessage(message));
    }
    _onClose() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_onClose()");
        this._hasVegaConnection = false;
        (_a = this._sendTransport) === null || _a === void 0 || _a.close();
        (_b = this._receiveTransport) === null || _b === void 0 || _b.close();
        this._sendTransport = null;
        this._receiveTransport = null;
        this._streamIdToVideoConsumerId.clear();
        this._streamIdToVideoResolution.clear();
        if (this._reconnect) this._reconnectTimeOut = setTimeout(()=>this._connect(), 1000);
        this._qualityMonitor.close();
        this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.SFU_CONNECTION_CLOSED);
    }
    _join() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("join()");
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.SFU_CONNECTION_OPEN);
            try {
                const { routerRtpCapabilities: routerRtpCapabilities } = yield this._vegaConnection.request("getCapabilities");
                if (!this._routerRtpCapabilities) {
                    $1622be301bae0161$export$1cbfd4deae6f916f(routerRtpCapabilities, this._features);
                    this._routerRtpCapabilities = routerRtpCapabilities;
                    yield this._mediasoupDevice.load({
                        routerRtpCapabilities: routerRtpCapabilities
                    });
                }
                this._vegaConnection.message("setCapabilities", {
                    rtpCapabilities: this._mediasoupDevice.rtpCapabilities
                });
                if (this._colocation) this._vegaConnection.message("setColocation", {
                    colocation: this._colocation
                });
                yield Promise.all([
                    this._createTransport(true),
                    this._createTransport(false)
                ]);
                const mediaPromises = [];
                if (this._micTrack && !this._micProducer && !this._micProducerPromise) mediaPromises.push(this._internalSendMic());
                if (this._webcamTrack && !this._webcamProducer && !this._webcamProducerPromise) mediaPromises.push(this._internalSendWebcam());
                if (this._screenVideoTrack && !this._screenVideoProducer && !this._screenVideoProducerPromise) mediaPromises.push(this._internalSendScreenVideo());
                if (this._screenAudioTrack && !this._screenAudioProducer && !this._screenAudioProducerPromise) mediaPromises.push(this._internalSendScreenAudio());
                yield Promise.all(mediaPromises);
            } catch (error) {
                $1622be301bae0161$var$logger$1.error("_join() [error:%o]", error);
            }
        });
    }
    _createTransport(send) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const creator = send ? "createSendTransport" : "createRecvTransport";
            const transportOptions = yield this._vegaConnection.request("createTransport", {
                producing: send,
                consuming: !send,
                enableTcp: true,
                enableUdp: true,
                preferUdp: true,
                sctpParameters: {
                    enableSctp: true,
                    numSctpStreams: {
                        OS: 1024,
                        MIS: 1024
                    },
                    maxSctpMessageSize: 262144,
                    sctpSendBufferSize: 262144
                }
            });
            transportOptions.iceServers = this._iceServers;
            $1622be301bae0161$export$3a1d5401f2f6ef55(transportOptions, this._features);
            const transport = this._mediasoupDevice[creator](transportOptions);
            const onConnectionStateListener = (connectionState)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    $1622be301bae0161$var$logger$1.info(`Transport ConnectionStateChanged ${connectionState}`);
                    if (connectionState !== "disconnected" && connectionState !== "failed") return;
                    if (send) {
                        if (this._sndTransportIceRestartPromise) return;
                        this._sndTransportIceRestartPromise = this._restartIce(transport).finally(()=>{
                            this._sndTransportIceRestartPromise = null;
                        });
                    } else {
                        if (this._rcvTransportIceRestartPromise) return;
                        this._rcvTransportIceRestartPromise = this._restartIce(transport).finally(()=>{
                            this._rcvTransportIceRestartPromise = null;
                        });
                    }
                });
            transport.on("connect", ({ dtlsParameters: dtlsParameters }, callback)=>{
                var _a;
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("connectTransport", {
                    transportId: transport.id,
                    dtlsParameters: dtlsParameters
                });
                callback();
            }).on("connectionstatechange", onConnectionStateListener);
            transport.observer.once("close", ()=>{
                transport.removeListener(onConnectionStateListener);
            });
            if (send) {
                transport.on("produce", ({ kind: kind, rtpParameters: rtpParameters, appData: appData }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        try {
                            const { paused: paused } = appData;
                            const { id: id } = yield (_a = this._vegaConnection) === null || _a === void 0 ? void 0 : _a.request("produce", {
                                transportId: transport.id,
                                kind: kind,
                                rtpParameters: rtpParameters,
                                paused: paused,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                transport.on("producedata", ({ appData: appData, sctpStreamParameters: sctpStreamParameters }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        var _b;
                        try {
                            const { id: id } = yield (_b = this._vegaConnection) === null || _b === void 0 ? void 0 : _b.request("produceData", {
                                transportId: transport.id,
                                sctpStreamParameters: sctpStreamParameters,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                this._sendTransport = transport;
            } else this._receiveTransport = transport;
        });
    }
    _restartIce(transport, retried = 0) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            if (!transport || !("closed" in transport) || !("connectionState" in transport)) {
                $1622be301bae0161$var$logger$1.info("_restartIce: No transport or property closed or connectionState!");
                return;
            }
            if (transport.closed) {
                $1622be301bae0161$var$logger$1.info("_restartIce: Transport is closed!");
                return;
            }
            if (transport.connectionState !== "disconnected" && transport.connectionState !== "failed") {
                $1622be301bae0161$var$logger$1.info("_restartIce: Connection is healthy ICE restart no loneger needed!");
                return;
            }
            const { iceRestartStarted: iceRestartStarted } = transport.appData;
            const now = Date.now();
            if (Number.isFinite(iceRestartStarted) && now - iceRestartStarted < $1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS) return;
            transport.appData.iceRestartStarted = now;
            if ($1622be301bae0161$var$RESTARTICE_ERROR_MAX_RETRY_COUNT <= retried) {
                $1622be301bae0161$var$logger$1.info("_restartIce: Reached restart ICE  maximum retry count!");
                return;
            }
            if (!this._vegaConnection) {
                $1622be301bae0161$var$logger$1.info(`_restartIce: Connection is undefined`);
                return;
            }
            const { iceParameters: iceParameters } = yield this._vegaConnection.request("restartIce", {
                transportId: transport.id
            });
            $1622be301bae0161$var$logger$1.info("_restartIce: ICE restart iceParameters received from SFU: ", iceParameters);
            const error = yield transport.restartIce({
                iceParameters: iceParameters
            }).then(()=>null).catch((err)=>err);
            if (error) {
                $1622be301bae0161$var$logger$1.error(`_restartIce: ICE restart failed: ${error}`);
                switch(error.message){
                    case "missing transportId":
                    case "no such transport":
                        break;
                    default:
                        yield new Promise((resolve)=>{
                            setTimeout(()=>{
                                resolve(undefined);
                            }, Math.min($1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS * Math.pow(2, retried), 60000));
                        });
                        yield this._restartIce(transport, retried + 1);
                        break;
                }
                return;
            }
            yield new Promise((resolve)=>{
                setTimeout(()=>{
                    resolve(undefined);
                }, 60000 * Math.min(8, retried + 1));
            });
            if (transport.connectionState === "failed" || transport.connectionState === "disconnected") {
                yield this._restartIce(transport, retried + 1);
                return;
            }
        });
    }
    _internalSendMic() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendMic()");
            this._micProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._micTrack || !this._sendTransport || this._micProducer) {
                            this._micProducerPromise = null;
                            return;
                        }
                        const currentPaused = this._micPaused;
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._micTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("audio", false, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: false,
                                source: "mic",
                                paused: currentPaused
                            }
                        }));
                        currentPaused ? producer.pause() : producer.resume();
                        this._micProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('micProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._micProducer = null;
                            this._micProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._micTrack !== this._micProducer.track) yield this._replaceMicTrack();
                        if (this._micPaused !== this._micProducer.paused) this._pauseResumeMic();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("micProducer failed:%o", error);
                    } finally{
                        this._micProducerPromise = null;
                        if (!this._micTrack) {
                            this._stopProducer(this._micProducer);
                            this._micProducer = null;
                        }
                    }
                }))();
        });
    }
    _internalSetupMicScore() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSetupMicScore()");
            this._micScoreProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._micProducer || !this._colocation || this._micScoreProducer) {
                            this._micScoreProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produceData({
                            ordered: false,
                            maxPacketLifeTime: 3000,
                            label: "micscore",
                            appData: {
                                producerId: this._micProducer.id,
                                clientId: this._selfId
                            }
                        });
                        this._micScoreProducer = producer;
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('micScoreProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeDataProducers", {
                                dataProducerIds: [
                                    producer.id
                                ]
                            });
                            this._micScoreProducer = null;
                            this._micScoreProducerPromise = null;
                        });
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("micScoreProducer failed:%o", error);
                    } finally{
                        this._micScoreProducerPromise = null;
                        if (!this._micProducer || !this._colocation) this._stopMicScoreProducer();
                    }
                }))();
        });
    }
    _stopMicScoreProducer() {
        this._stopProducer(this._micScoreProducer);
        this._micScoreProducer = null;
    }
    _replaceMicTrack() {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceMicTrack()");
            if (!this._micTrack || !this._micProducer || this._micProducer.closed) return;
            if (this._micProducer.track !== this._micTrack) {
                yield this._micProducer.replaceTrack({
                    track: this._micTrack
                });
                (_a = this._micAnalyser) === null || _a === void 0 || _a.setTrack(this._micTrack);
                yield this._replaceMicTrack();
            }
        });
    }
    _pauseResumeMic() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_pauseResumeMic()");
        if (!this._micProducer || this._micProducer.closed) return;
        if (this._micPaused !== this._micProducer.paused) {
            if (this._micPaused) {
                this._micProducer.pause();
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseProducers", {
                    producerIds: [
                        this._micProducer.id
                    ]
                });
            } else {
                this._micProducer.resume();
                (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeProducers", {
                    producerIds: [
                        this._micProducer.id
                    ]
                });
            }
            this._pauseResumeMic();
        }
    }
    _sendMic(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendMic() [track:%o]", track);
            this._micTrack = track;
            if (this._micProducer) return yield this._replaceMicTrack();
            else if (this._micProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendMic();
        });
    }
    _sendMicScore(score) {
        if (isNaN(score)) return;
        if (!isFinite(score)) return;
        if (this._micScoreProducer) {
            if (this._micScoreProducer.closed) {
                this._stopMicScoreProducer();
                return;
            }
            try {
                this._micScoreProducer.send(JSON.stringify({
                    score: score
                }));
            } catch (ex) {
                $1622be301bae0161$var$logger$1.error("_sendMicScore failed [error:%o]", ex);
            }
            return;
        }
        if (!this._micScoreProducerPromise && this._micProducer && this._colocation && score !== 0) this._internalSetupMicScore();
    }
    _internalSendWebcam() {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendWebcam()");
            if (!this._sendTransport || this._webcamProducer || this._webcamProducerPromise || ((_a = this._webcamTrack) === null || _a === void 0 ? void 0 : _a.readyState) !== "live") return;
            this._webcamProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    var _b;
                    try {
                        const currentPaused = this._webcamPaused;
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._webcamTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("video", false, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: false,
                                source: "webcam",
                                paused: currentPaused
                            }
                        }));
                        currentPaused ? producer.pause() : producer.resume();
                        this._webcamProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('webcamProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._webcamProducer = null;
                            this._webcamProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._webcamTrack && this._webcamTrack !== ((_b = this._webcamProducer) === null || _b === void 0 ? void 0 : _b.track)) {
                            this._webcamProducerPromise = null;
                            this._replaceWebcamTrack();
                        }
                        if (this._webcamPaused !== this._webcamProducer.paused) this._pauseResumeWebcam();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("webcamProducer failed:%o", error);
                    } finally{
                        this._webcamProducerPromise = null;
                        if (!this._webcamTrack) {
                            this._stopProducer(this._webcamProducer);
                            this._webcamProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceWebcamTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceWebcamTrack()");
            if (!this._sendTransport || !this._webcamTrack || this._webcamProducerPromise) return;
            if (!this._webcamProducer && this._webcamTrack.enabled) {
                yield this._internalSendWebcam();
                return;
            }
            if (this._webcamProducer.track !== this._webcamTrack) {
                yield this._webcamProducer.replaceTrack({
                    track: this._webcamTrack
                });
                yield this._replaceWebcamTrack();
            }
        });
    }
    _pauseResumeWebcam() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_pauseResumeWebcam()");
        if (!this._webcamProducer || this._webcamProducer.closed) return;
        if (this._webcamPaused !== this._webcamProducer.paused) {
            if (this._webcamPaused) {
                this._webcamProducer.pause();
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseProducers", {
                    producerIds: [
                        this._webcamProducer.id
                    ]
                });
            } else {
                this._webcamProducer.resume();
                (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeProducers", {
                    producerIds: [
                        this._webcamProducer.id
                    ]
                });
            }
            this._pauseResumeWebcam();
        }
    }
    _sendWebcam(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendWebcam() [track:%o]", track);
            this._webcamTrack = track;
            if (this._webcamProducer) return yield this._replaceWebcamTrack();
            else if (this._webcamProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendWebcam();
        });
    }
    _internalSendScreenVideo() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendScreenVideo()");
            this._screenVideoProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._screenVideoTrack || !this._sendTransport || this._screenVideoProducer) {
                            this._screenVideoProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._screenVideoTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("video", true, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: true,
                                source: "screenvideo",
                                paused: false
                            }
                        }));
                        this._screenVideoProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('screenVideoProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._screenVideoProducer = null;
                            this._screenVideoProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._screenVideoTrack !== this._screenVideoProducer.track) yield this._replaceScreenVideoTrack();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("screenVideoProducer failed:%o", error);
                    } finally{
                        this._screenVideoProducerPromise = null;
                        if (!this._screenVideoTrack) {
                            yield this._stopProducer(this._screenVideoProducer);
                            this._screenVideoProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceScreenVideoTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceScreenVideoTrack()");
            if (!this._screenVideoTrack || !this._screenVideoProducer || this._screenVideoProducer.closed) return;
            if (this._screenVideoProducer.track !== this._screenVideoTrack) {
                yield this._screenVideoProducer.replaceTrack({
                    track: this._screenVideoTrack
                });
                yield this._replaceScreenVideoTrack();
            }
        });
    }
    _sendScreenVideo(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendScreenVideo() [track:%o]", track);
            this._screenVideoTrack = track;
            if (this._screenVideoProducer) return yield this._replaceScreenVideoTrack();
            else if (this._screenVideoProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendScreenVideo();
        });
    }
    _internalSendScreenAudio() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendScreenAudio()");
            this._screenAudioProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._screenAudioTrack || !this._sendTransport || this._screenAudioProducer) {
                            this._screenAudioProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._screenAudioTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("audio", true, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: true,
                                source: "screenaudio",
                                paused: false
                            }
                        }));
                        this._screenAudioProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('screenAudioProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._screenAudioProducer = null;
                            this._screenAudioProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._screenAudioTrack !== this._screenAudioProducer.track) yield this._replaceScreenAudioTrack();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("screenAudioProducer failed:%o", error);
                    } finally{
                        this._screenAudioProducerPromise = null;
                        if (!this._screenAudioTrack) {
                            yield this._stopProducer(this._screenAudioProducer);
                            this._screenAudioProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceScreenAudioTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceScreenAudioTrack()");
            if (!this._screenAudioTrack || !this._screenAudioProducer || this._screenAudioProducer.closed) return;
            if (this._screenAudioProducer.track !== this._screenAudioTrack) {
                yield this._screenAudioProducer.replaceTrack({
                    track: this._screenAudioTrack
                });
                yield this._replaceScreenAudioTrack();
            }
        });
    }
    _sendScreenAudio(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendScreenAudio() [track:%o]", track);
            this._screenAudioTrack = track;
            if (this._screenAudioProducer) return yield this._replaceScreenAudioTrack();
            else if (this._screenAudioProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendScreenAudio();
        });
    }
    _stopProducer(producer) {
        $1622be301bae0161$var$logger$1.info("_stopProducer()");
        if (!producer || producer.closed) return;
        producer.appData.localClosed = true;
        producer.close();
    }
    isInitializedWith({ selfId: selfId, roomName: roomName, isSfu: isSfu }) {
        return this._selfId === selfId && this._room.name === roomName && Boolean(isSfu);
    }
    setEventClaim(eventClaim) {
        var _a;
        this._eventClaim = eventClaim;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message("eventClaim", {
            eventClaim: eventClaim
        });
    }
    setColocation(colocation) {
        var _a;
        this._colocation = colocation;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message("setColocation", {
            colocation: colocation
        });
        if (!colocation && this._micScoreProducer && !this._micScoreProducerPromise) this._stopMicScoreProducer();
        this._syncMicAnalyser();
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("colocation_changed", {
            colocation: colocation
        });
    }
    setAudioOnly(audioOnly) {
        var _a;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message(audioOnly ? "enableAudioOnly" : "disableAudioOnly");
    }
    setRemoteScreenshareVideoTrackIds() {}
    setRoomSessionId(roomSessionId) {
        this._roomSessionId = roomSessionId;
    }
    disconnect(clientIdOrStreamId, _activeBreakout, eventClaim) {
        var _a;
        $1622be301bae0161$var$logger$1.info("disconnect() [clientIdOrStreamId:%s, eventClaim:%s]", clientIdOrStreamId, eventClaim);
        if (this._clientStates.has(clientIdOrStreamId)) {
            const clientState = this._clientStates.get(clientIdOrStreamId);
            clientState.hasAcceptedWebcamStream = false;
            clientState.hasAcceptedScreenStream = false;
            this._syncIncomingStreamsWithPWA(clientIdOrStreamId);
        }
        if (eventClaim) {
            this._eventClaim = eventClaim;
            (_a = this._vegaConnection) === null || _a === void 0 || _a.message("eventClaim", {
                eventClaim: eventClaim
            });
        }
    }
    replaceTrack(oldTrack, track) {
        if (track.kind === "audio") {
            if (!track.effectTrack) this._monitorAudioTrack(track);
            this._micTrack = track;
            this._replaceMicTrack();
        }
        if (track.kind === "video") {
            if (!track.effectTrack) this._monitorVideoTrack(track);
            this._webcamTrack = track;
            this._replaceWebcamTrack();
        }
    }
    removeStream(streamId, _stream, requestedByClientId) {
        $1622be301bae0161$var$logger$1.info("removeStream() [streamId:%s, requestedByClientId:%s]", streamId, requestedByClientId);
        this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.STOP_SCREENSHARE, {
            streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
            requestedByClientId: requestedByClientId
        });
        this._stopProducer(this._screenVideoProducer);
        this._screenVideoProducer = null;
        this._screenVideoTrack = null;
        this._stopProducer(this._screenAudioProducer);
        this._screenAudioProducer = null;
        this._screenAudioTrack = null;
    }
    _onMicAnalyserScoreUpdated(data) {
        var _a, _b;
        (_b = (_a = this._micAnalyserDebugger) === null || _a === void 0 ? void 0 : _a.onScoreUpdated) === null || _b === void 0 || _b.call(_a, data);
        this._sendMicScore(this._micPaused ? 0 : data.out);
    }
    addNewStream(streamId, stream, audioPaused, videoPaused, beforeEffectTracks = []) {
        if (streamId === "0") {
            this._micPaused = audioPaused;
            this._webcamPaused = videoPaused;
            const videoTrack = stream.getVideoTracks()[0];
            const audioTrack = stream.getAudioTracks()[0];
            if (videoTrack) {
                this._sendWebcam(videoTrack);
                if (!videoTrack.effectTrack) this._monitorVideoTrack(videoTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "video");
                if (beforeEffectTrack) this._monitorVideoTrack(beforeEffectTrack);
            }
            if (audioTrack) {
                this._sendMic(audioTrack);
                this._syncMicAnalyser();
                if (!audioTrack.effectTrack) this._monitorAudioTrack(audioTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "audio");
                if (beforeEffectTrack) this._monitorAudioTrack(beforeEffectTrack);
            }
            if (this._localStreamDeregisterFunction) {
                this._localStreamDeregisterFunction();
                this._localStreamDeregisterFunction = null;
            }
            const localStreamHandler = (e)=>{
                const { enable: enable, track: track } = e.detail;
                this._webcamPaused = !enable;
                this._pauseResumeWebcam();
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            };
            stream.addEventListener("stopresumevideo", localStreamHandler);
            this._localStreamDeregisterFunction = ()=>{
                stream.removeEventListener("stopresumevideo", localStreamHandler);
            };
        } else {
            const videoTrack = stream.getVideoTracks()[0];
            const audioTrack = stream.getAudioTracks()[0];
            if (videoTrack) this._sendScreenVideo(videoTrack);
            if (audioTrack) this._sendScreenAudio(audioTrack);
            this._emitScreenshareStarted();
        }
    }
    _syncMicAnalyser() {
        if (this._micTrack && this._colocation && !this._micAnalyser) {
            this._micAnalyser = $1622be301bae0161$export$af9222748cc412c5({
                micTrack: this._micTrack,
                onScoreUpdated: this._onMicAnalyserScoreUpdated.bind(this)
            });
            return;
        }
        if (this._micAnalyser && !this._colocation) {
            this._micAnalyser.close();
            this._micAnalyser = null;
            return;
        }
    }
    stopOrResumeAudio(stream, enabled) {
        $1622be301bae0161$var$logger$1.info("stopOrResumeAudio() [enabled:%s]", enabled);
        this._micPaused = !enabled;
        this._pauseResumeMic();
    }
    _handleStopOrResumeVideo({ enable: enable, track: track }) {
        if (!enable) {
            if (this._webcamProducer && !this._webcamProducer.closed && this._webcamProducer.track === track) {
                this._stopProducer(this._webcamProducer);
                this._webcamProducer = null;
                this._webcamTrack = null;
            }
        } else this._sendWebcam(track);
    }
    stopOrResumeVideo(localStream, enable) {
        var _a;
        $1622be301bae0161$var$logger$1.info("stopOrResumeVideo() [enable:%s]", enable);
        this._webcamPaused = !enable;
        this._pauseResumeWebcam();
        if (![
            "chrome",
            "safari"
        ].includes($1622be301bae0161$var$browserName)) return;
        if (!enable) {
            clearTimeout(this._stopCameraTimeout);
            const stopCameraDelay = ((_a = localStream.getVideoTracks().find((t)=>!t.enabled)) === null || _a === void 0 ? void 0 : _a.readyState) === "ended" ? 0 : 5000;
            this._stopCameraTimeout = setTimeout(()=>{
                localStream.getVideoTracks().forEach((track)=>{
                    if (track.enabled === false) {
                        track.stop();
                        localStream.removeTrack(track);
                        this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_REMOVED, {
                            stream: localStream,
                            track: track
                        });
                        this._handleStopOrResumeVideo({
                            enable: enable,
                            track: track
                        });
                    }
                });
            }, stopCameraDelay);
        } else if (localStream.getVideoTracks().length === 0) {
            const constraints = this._webrtcProvider.getMediaConstraints().video;
            navigator.mediaDevices.getUserMedia({
                video: constraints
            }).then((stream)=>{
                const track = stream.getVideoTracks()[0];
                localStream.addTrack(track);
                this._monitorVideoTrack(track);
                this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_ADDED, {
                    streamId: localStream.id,
                    tracks: [
                        track
                    ],
                    screenShare: false
                });
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            });
        }
    }
    supportsScreenShareAudio() {
        return true;
    }
    acceptNewStream({ streamId: streamId, clientId: clientId }) {
        $1622be301bae0161$var$logger$1.info("acceptNewStream()", {
            streamId: streamId,
            clientId: clientId
        });
        const clientState = this._getOrCreateClientState(clientId);
        const isScreenShare = streamId !== clientId;
        if (isScreenShare) {
            clientState.hasAcceptedScreenStream = true;
            clientState.hasEmittedScreenStream = false;
        } else {
            clientState.hasAcceptedWebcamStream = true;
            clientState.hasEmittedWebcamStream = false;
        }
        this._syncIncomingStreamsWithPWA(clientId);
    }
    updateStreamResolution(streamId, _ignored, { width: width, height: height }) {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("updateStreamResolution()", {
            streamId: streamId,
            width: width,
            height: height
        });
        const consumerId = this._streamIdToVideoConsumerId.get(streamId);
        const consumer = this._consumers.get(consumerId);
        if (!consumer) {
            this._streamIdToVideoResolution.set(streamId, {
                width: width,
                height: height
            });
            return;
        }
        const numberOfActiveVideos = $1622be301bae0161$var$getNumberOfActiveVideos(this._consumers);
        const numberOfTemporalLayers = $1622be301bae0161$var$getNumberOfTemporalLayers(consumer);
        const { spatialLayer: spatialLayer, temporalLayer: temporalLayer } = $1622be301bae0161$var$getLayers({
            width: width,
            height: height
        }, {
            numberOfActiveVideos: numberOfActiveVideos,
            numberOfTemporalLayers: numberOfTemporalLayers,
            uncappedSingleRemoteVideoOn: (_a = this._features) === null || _a === void 0 ? void 0 : _a.uncappedSingleRemoteVideoOn
        });
        if (consumer.appData.spatialLayer !== spatialLayer || consumer.appData.temporalLayer !== temporalLayer) {
            consumer.appData.spatialLayer = spatialLayer;
            consumer.appData.temporalLayer = temporalLayer;
            (_b = this._vegaConnection) === null || _b === void 0 || _b.message("setConsumersPreferredLayers", {
                consumerIds: [
                    consumerId
                ],
                spatialLayer: spatialLayer,
                temporalLayer: temporalLayer
            });
        }
    }
    disconnectAll() {
        var _a, _b, _c, _d;
        this._reconnect = false;
        if (this._reconnectTimeOut) {
            clearTimeout(this._reconnectTimeOut);
            this._reconnectTimeOut = null;
        }
        this._socketListenerDeregisterFunctions.forEach((func)=>{
            func();
        });
        if (this._localStreamDeregisterFunction) {
            this._localStreamDeregisterFunction();
            this._localStreamDeregisterFunction = null;
        }
        this._socketListenerDeregisterFunctions = [];
        (_a = this._vegaConnection) === null || _a === void 0 || _a.removeAllListeners();
        (_b = this._vegaConnection) === null || _b === void 0 || _b.close();
        (_c = this._sendTransport) === null || _c === void 0 || _c.close();
        (_d = this._receiveTransport) === null || _d === void 0 || _d.close();
        this._micTrack = null;
        this._webcamTrack = null;
        this._screenVideoTrack = null;
        this._screenAudioTrack = null;
        this._streamIdToVideoConsumerId.clear();
        this._mediasoupDevice = null;
    }
    sendAudioMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    }
    sendVideoMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    }
    sendStatsCustomEvent(eventName, data) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent(eventName, data);
    }
    rtcStatsDisconnect() {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.close();
    }
    rtcStatsReconnect() {
        if (!$1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connected) $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connect();
    }
    _monitorAudioTrack(track) {
        var _a, _b;
        if (((_a = this._audioTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._audioTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._audioTrackOnEnded);
        track.addEventListener("ended", this._audioTrackOnEnded);
        this._audioTrackBeingMonitored = track;
    }
    _monitorVideoTrack(track) {
        var _a, _b;
        if (((_a = this._videoTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._videoTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._videoTrackOnEnded);
        track.addEventListener("ended", this._videoTrackOnEnded);
        this._videoTrackBeingMonitored = track;
    }
    _onMessage(message) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { method: method, data: data } = message;
            return Promise.resolve().then(()=>{
                switch(method){
                    case "consumerReady":
                        return this._onConsumerReady(data);
                    case "consumerClosed":
                        return this._onConsumerClosed(data);
                    case "consumerPaused":
                        return this._onConsumerPaused(data);
                    case "consumerResumed":
                        return this._onConsumerResumed(data);
                    case "dataConsumerReady":
                        return this._onDataConsumerReady(data);
                    case "dataConsumerClosed":
                        return this._onDataConsumerClosed(data);
                    case "dominantSpeaker":
                        return this._onDominantSpeaker(data);
                    case "consumerScore":
                        return this._onConsumerScore(data);
                    case "producerScore":
                        return this._onProducerScore(data);
                    default:
                        $1622be301bae0161$var$logger$1.info(`unknown message method "${method}"`);
                        return;
                }
            }).catch((error)=>{
                $1622be301bae0161$var$logger$1.error('"message" failed [error:%o]', error);
            });
        });
    }
    _onConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onConsumerReady()", {
                id: options.id,
                producerId: options.producerId
            });
            const consumer = yield this._receiveTransport.consume(options);
            consumer.pause();
            consumer.appData.localPaused = true;
            consumer.appData.spatialLayer = 2;
            this._consumers.set(consumer.id, consumer);
            this._qualityMonitor.addConsumer(consumer.appData.sourceClientId, consumer.id);
            consumer.observer.once("close", ()=>{
                this._consumers.delete(consumer.id);
                this._qualityMonitor.removeConsumer(consumer.appData.sourceClientId, consumer.id);
                this._consumerClosedCleanup(consumer);
            });
            if (this._features.increaseIncomingMediaBufferOn && consumer.rtpReceiver) try {
                consumer.rtpReceiver.jitterBufferTarget = $1622be301bae0161$export$87d0694e432db510;
                consumer.rtpReceiver.playoutDelayHint = $1622be301bae0161$export$87d0694e432db510 / 1000;
            } catch (error) {
                $1622be301bae0161$var$logger$1.error("Error during setting jitter buffer target:", error);
            }
            const { sourceClientId: clientId, screenShare: screenShare, streamId: streamId } = consumer.appData;
            const clientState = this._getOrCreateClientState(clientId);
            if (screenShare) {
                clientState.hasEmittedScreenStream = false;
                clientState.screenShareStreamId = streamId;
            } else {
                clientState.hasEmittedWebcamStream = false;
                clientState.camStreamId = streamId;
            }
            let stream = screenShare ? clientState.screenStream : clientState.webcamStream;
            if (!stream || stream.inboundId !== streamId) {
                stream = new MediaStream();
                stream.inboundId = streamId;
                screenShare ? clientState.screenStream = stream : clientState.webcamStream = stream;
            }
            if (consumer.kind === "video") this._streamIdToVideoConsumerId.set(stream.id, consumer.id);
            stream.addTrack(consumer.track);
            this._syncIncomingStreamsWithPWA(clientId);
            const resolution = this._streamIdToVideoResolution.get(stream.id);
            if (resolution) {
                this.updateStreamResolution(stream.id, null, resolution);
                this._streamIdToVideoResolution.delete(stream.id);
            }
        });
    }
    _onConsumerClosed({ consumerId: consumerId, reason: reason }) {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onConsumerClosed()", {
                consumerId: consumerId,
                reason: reason
            });
            (_a = this._consumers.get(consumerId)) === null || _a === void 0 || _a.close();
        });
    }
    _onConsumerPaused({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerPaused()", {
            consumerId: consumerId
        });
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        consumer.appData.remotePaused = true;
        consumer.pause();
    }
    _onConsumerResumed({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerResumed()", {
            consumerId: consumerId
        });
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        consumer.appData.remotePaused = false;
        if (!consumer.appData.localPaused) consumer.resume();
    }
    _onConsumerScore({ consumerId: consumerId, kind: kind, score: score }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerScore()", {
            consumerId: consumerId,
            kind: kind,
            score: score
        });
        const { appData: { sourceClientId: sourceClientId } } = this._consumers.get(consumerId) || {
            appData: {}
        };
        if (sourceClientId) this._qualityMonitor.addConsumerScore(sourceClientId, consumerId, kind, score);
    }
    _onProducerScore({ producerId: producerId, kind: kind, score: score }) {
        $1622be301bae0161$var$logger$1.info("_onProducerScore()", {
            producerId: producerId,
            kind: kind,
            score: score
        });
        [
            this._micProducer,
            this._webcamProducer,
            this._screenVideoProducer,
            this._screenAudioProducer
        ].forEach((producer)=>{
            if ((producer === null || producer === void 0 ? void 0 : producer.id) === producerId) this._qualityMonitor.addProducerScore(this._selfId, producerId, kind, score);
        });
    }
    _onDataConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onDataConsumerReady()", {
                id: options.id,
                producerId: options.producerId
            });
            const consumer = yield this._receiveTransport.consumeData(options);
            this._dataConsumers.set(consumer.id, consumer);
            consumer.once("close", ()=>{
                this._dataConsumers.delete(consumer.id);
            });
            const { clientId: clientId } = consumer.appData;
            consumer.on("message", (message)=>{
                var _a;
                if (!this._micAnalyserDebugger) return;
                if (typeof message !== "string") return;
                const { score: score } = JSON.parse(message);
                if (score) (_a = this._micAnalyserDebugger) === null || _a === void 0 || _a.onConsumerScore(consumer.appData.clientId, score);
            });
            this._syncIncomingStreamsWithPWA(clientId);
        });
    }
    _onDataConsumerClosed({ dataConsumerId: dataConsumerId, reason: reason }) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onDataConsumerClosed()", {
                dataConsumerId: dataConsumerId,
                reason: reason
            });
            const consumer = this._dataConsumers.get(dataConsumerId);
            consumer === null || consumer === void 0 || consumer.close();
        });
    }
    _onDominantSpeaker({ consumerId: consumerId }) {
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        const { sourceClientId: clientId } = consumer.appData;
        this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.DOMINANT_SPEAKER, {
            clientId: clientId
        });
    }
    _consumerClosedCleanup(consumer) {
        const { sourceClientId: clientId, screenShare: screenShare } = consumer.appData;
        const clientState = this._getOrCreateClientState(clientId);
        const stream = screenShare ? clientState.screenStream : clientState.webcamStream;
        if (!stream) return;
        stream.removeTrack(consumer.track);
        if (stream.getTracks().length === 0) {
            this._streamIdToVideoConsumerId.delete(stream.id);
            this._streamIdToVideoResolution.delete(stream.id);
            if (screenShare) {
                clientState.screenStream = null;
                clientState.hasEmittedScreenStream = false;
                clientState.screenShareStreamId = null;
            } else {
                clientState.hasEmittedWebcamStream = false;
                clientState.camStreamId = null;
            }
        }
    }
    _syncIncomingStreamsWithPWA(clientId) {
        var _a, _b;
        const clientState = this._getOrCreateClientState(clientId);
        const { webcamStream: webcamStream, screenStream: screenStream, hasEmittedWebcamStream: hasEmittedWebcamStream, hasEmittedScreenStream: hasEmittedScreenStream, hasAcceptedWebcamStream: hasAcceptedWebcamStream, hasAcceptedScreenStream: hasAcceptedScreenStream, screenShareStreamId: screenShareStreamId, camStreamId: camStreamId } = clientState;
        const toPauseConsumers = [];
        const toResumeConsumers = [];
        this._consumers.forEach((consumer)=>{
            if (consumer.appData.sourceClientId !== clientId) return;
            const hasAccepted = consumer.appData.screenShare ? hasAcceptedScreenStream : hasAcceptedWebcamStream;
            if (!consumer.appData.localPaused !== hasAccepted) {
                if (hasAccepted) {
                    if (!consumer.appData.remotePaused) consumer.resume();
                    consumer.appData.localPaused = false;
                    toResumeConsumers.push(consumer.id);
                } else {
                    consumer.pause();
                    consumer.appData.localPaused = true;
                    toPauseConsumers.push(consumer.id);
                }
            }
        });
        if (toPauseConsumers.length > 0) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseConsumers", {
            consumerIds: toPauseConsumers
        });
        if (toResumeConsumers.length > 0) (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeConsumers", {
            consumerIds: toResumeConsumers
        });
        if (webcamStream && !hasEmittedWebcamStream && hasAcceptedWebcamStream) {
            this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                clientId: clientId,
                stream: webcamStream,
                streamId: camStreamId,
                streamType: "webcam"
            });
            clientState.hasEmittedWebcamStream = true;
        }
        if (screenStream && !hasEmittedScreenStream && hasAcceptedScreenStream) {
            this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                clientId: clientId,
                stream: screenStream,
                streamId: screenShareStreamId,
                streamType: "screenshare"
            });
            clientState.hasEmittedScreenStream = true;
        }
    }
    _getOrCreateClientState(clientId) {
        let clientState = this._clientStates.get(clientId);
        if (!clientState) {
            clientState = {
                hasAcceptedWebcamStream: false,
                hasAcceptedScreenStream: false,
                hasEmittedWebcamStream: false,
                hasEmittedScreenStream: false,
                webcamStream: null,
                screenStream: null,
                screenShareStreamId: null,
                camStreamId: null
            };
            this._clientStates.set(clientId, clientState);
        }
        return clientState;
    }
    _emitToPWA(eventName, data) {
        this._emitter.emit(eventName, data);
    }
    _emitToSignal(eventName, data, callback) {
        this._serverSocket.emit(eventName, data, callback);
    }
    shouldAcceptStreamsFromBothSides() {
        return true;
    }
    setMicAnalyserDebugger(analyserDebugger) {
        this._micAnalyserDebugger = analyserDebugger;
    }
    setMicAnalyserParams(params) {
        var _a;
        (_a = this._micAnalyser) === null || _a === void 0 || _a.setParams(params);
    }
    hasClient(clientId) {
        return this._clientStates.has(clientId);
    }
    constructor({ selfId: selfId, room: room, emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features, eventClaim: eventClaim, deviceHandlerFactory: deviceHandlerFactory }){
        const { session: session, iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds } = room;
        this._selfId = selfId;
        this._room = room;
        this._roomSessionId = session === null || session === void 0 ? void 0 : session.id;
        this._emitter = emitter;
        this._serverSocket = serverSocket;
        this._webrtcProvider = webrtcProvider;
        this._features = features || {};
        this._eventClaim = eventClaim;
        this._vegaConnection = null;
        this._micAnalyser = null;
        this._micAnalyserDebugger = null;
        if (deviceHandlerFactory) this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerFactory: deviceHandlerFactory
        });
        else this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerName: $1622be301bae0161$export$30afcaff46935060()
        });
        this._routerRtpCapabilities = null;
        this._sendTransport = null;
        this._receiveTransport = null;
        this._clientStates = new Map();
        this._streamIdToVideoConsumerId = new Map();
        this._streamIdToVideoResolution = new Map();
        this._consumers = new Map();
        this._dataConsumers = new Map();
        this._localStreamDeregisterFunction = null;
        this._micTrack = null;
        this._webcamTrack = null;
        this._screenVideoTrack = null;
        this._screenAudioTrack = null;
        this._micProducer = null;
        this._micProducerPromise = null;
        this._micPaused = false;
        this._micScoreProducer = null;
        this._micScoreProducerPromise = null;
        this._webcamProducer = null;
        this._webcamProducerPromise = null;
        this._webcamPaused = false;
        this._screenVideoProducer = null;
        this._screenVideoProducerPromise = null;
        this._screenAudioProducer = null;
        this._screenAudioProducerPromise = null;
        this._sndTransportIceRestartPromise = null;
        this._rcvTransportIceRestartPromise = null;
        this._colocation = null;
        this._stopCameraTimeout = null;
        this._audioTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_ended", {
                unloading: $1622be301bae0161$var$unloading
            });
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_STOPPED_WORKING, {});
        };
        this._videoTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_ended", {
                unloading: $1622be301bae0161$var$unloading
            });
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.CAMERA_STOPPED_WORKING, {});
        };
        this._updateAndScheduleMediaServersRefresh({
            sfuServer: sfuServer,
            iceServers: iceServers.iceServers || [],
            mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds
        });
        this._socketListenerDeregisterFunctions = [];
        this._reconnect = true;
        this._reconnectTimeOut = null;
        this._hasVegaConnection = false;
        this._qualityMonitor = new $1622be301bae0161$export$9a5481974d870db4();
        this._qualityMonitor.on($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, (payload)=>{
            this._emitToPWA($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, payload);
        });
    }
}
class $1622be301bae0161$export$b281485fb0422c89 {
    stopRtcManager() {
        if (this.currentManager) {
            this.currentManager.disconnectAll();
            this.emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_DESTROYED);
        }
    }
    constructor({ emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features }){
        this.emitter = emitter;
        this.currentManager = null;
        serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ({ room: room, selfId: selfId, error: error, eventClaim: eventClaim })=>{
            if (error) return;
            const config = {
                selfId: selfId,
                room: room,
                emitter: emitter,
                serverSocket: serverSocket,
                webrtcProvider: webrtcProvider,
                features: features,
                eventClaim: eventClaim,
                deviceHandlerFactory: features === null || features === void 0 ? void 0 : features.deviceHandlerFactory
            };
            const isSfu = !!room.sfuServer;
            if (this.currentManager) {
                if (this.currentManager.isInitializedWith({
                    selfId: selfId,
                    roomName: room.name,
                    isSfu: isSfu
                })) {
                    if (this.currentManager.setEventClaim && eventClaim) this.currentManager.setEventClaim(eventClaim);
                    return;
                }
                this.currentManager.disconnectAll();
                emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_DESTROYED);
            }
            let rtcManager = null;
            if (isSfu) rtcManager = new $1622be301bae0161$export$b44cbfcf90b97eac(config);
            else rtcManager = new $1622be301bae0161$export$c67bf4e001e6de2(config);
            rtcManager.rtcStatsReconnect();
            rtcManager.setupSocketListeners();
            emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_CREATED, {
                rtcManager: rtcManager
            });
            this.currentManager = rtcManager;
            serverSocket.setRtcManager(rtcManager);
        });
    }
}
var $1622be301bae0161$export$e781598da8ea5f70;
(function(RtcEventNames) {
    RtcEventNames["rtc_manager_created"] = "rtc_manager_created";
    RtcEventNames["stream_added"] = "stream_added";
})($1622be301bae0161$export$e781598da8ea5f70 || ($1622be301bae0161$export$e781598da8ea5f70 = {}));
class $1622be301bae0161$var$AssertionError extends Error {
    constructor(options){
        super(options.message);
        this.name = "AssertionError";
        this.code = "ERR_ASSERTION";
        this.actual = options.actual;
        this.expected = options.expected;
        this.operator = options.operator;
        if (Error.captureStackTrace) Error.captureStackTrace(this, options.stackStartFn);
    }
}
function $1622be301bae0161$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        let generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        const err = new $1622be301bae0161$var$AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
function $1622be301bae0161$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1622be301bae0161$var$AssertionError(obj);
}
function $1622be301bae0161$var$ok(...args) {
    $1622be301bae0161$var$innerOk($1622be301bae0161$var$ok, args.length, ...args);
}
const $1622be301bae0161$export$a7a9523472993e97 = {
    fail: (message)=>{
        $1622be301bae0161$var$innerFail({
            actual: "fail()",
            expected: "fail() should not be called",
            message: message,
            operator: "fail",
            stackStartFn: $1622be301bae0161$export$a7a9523472993e97.fail
        });
    },
    ok: $1622be301bae0161$var$ok
};
$1622be301bae0161$export$a7a9523472993e97.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new Error("'actual' and 'expected' arguments are required");
    if (actual == expected) $1622be301bae0161$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
$1622be301bae0161$export$a7a9523472993e97.ok = $1622be301bae0161$var$ok;
const $1622be301bae0161$export$208cffe87ba62b51 = (fn)=>{
    return new Worker(URL.createObjectURL(new Blob([
        "self.onmessage = ",
        fn.toString()
    ], {
        type: "text/javascript"
    })));
};
const $1622be301bae0161$export$318f15d7900e4898 = (count)=>{
    if (count === 0) return "";
    const count2 = count / 2;
    let result = "F";
    while(result.length <= count2)result += result;
    return result + result.substring(0, count - result.length);
};
const $1622be301bae0161$var$logger = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$7dedc58743a41a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($11OXI))) {
    _onRoomJoined(payload) {
        var _a, _b;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            this.reconnectThresholdInMs = (payload.disconnectTimeout || 0) * 0.8;
            if (!((_a = payload.room) === null || _a === void 0 ? void 0 : _a.clients)) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            if (!payload.selfId) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            const myDeviceId = (_b = payload.room.clients.find((c)=>payload.selfId === c.id)) === null || _b === void 0 ? void 0 : _b.deviceId;
            if (!myDeviceId) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            if (!this._signalDisconnectTime) {
                this._resetClientState(payload);
                payload.room.clients = payload.room.clients.filter((c)=>!(c.deviceId === myDeviceId && c.isPendingToLeave));
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            const RECONNECT_THRESHOLD = payload.disconnectTimeout * 0.8;
            const timeSinceDisconnect = Date.now() - this._signalDisconnectTime;
            if (timeSinceDisconnect > RECONNECT_THRESHOLD) {
                this._resetClientState(payload);
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                this.metrics.roomJoinedLate++;
                return;
            }
            payload.room.clients = payload.room.clients.filter((c)=>!(c.deviceId === myDeviceId && c.isPendingToLeave));
            const allStats = yield $1622be301bae0161$export$a95105d8b2471e00();
            payload.room.clients.forEach((client)=>{
                var _a;
                try {
                    if (client.id === payload.selfId) return;
                    if (!this._clients[client.id]) {
                        this._addClientToState(client);
                        return;
                    }
                    if (!((_a = this.rtcManager) === null || _a === void 0 ? void 0 : _a.hasClient(client.id))) return;
                    if (this._hasClientStateChanged({
                        clientId: client.id,
                        webcam: client.isVideoEnabled,
                        mic: client.isAudioEnabled,
                        screenShare: client.streams.length > 1
                    })) return;
                    if (this._wasClientSendingMedia(client.id)) {
                        if (!this._isClientMediaActive(allStats, client.id)) return;
                    }
                    client.mergeWithOldClientState = true;
                } catch (error) {
                    $1622be301bae0161$var$logger.error("Failed to evaluate if we should merge client state %o", error);
                    this.metrics.evaluationFailed++;
                }
            });
            payload.room.clients.forEach((c)=>{
                if (c.isPendingToLeave) this._onPendingClientLeft({
                    clientId: c.id
                });
            });
            this.metrics.roomJoined++;
            this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
        });
    }
    _onClientLeft(payload) {
        var _a;
        const { clientId: clientId } = payload;
        const client = this._clients[clientId];
        if (client) {
            clearTimeout(client.timeout);
            delete this._clients[clientId];
        }
        (_a = this.rtcManager) === null || _a === void 0 || _a.disconnect(clientId, null, payload.eventClaim);
        this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, payload);
    }
    _onPendingClientLeft(payload) {
        const { clientId: clientId } = payload;
        const client = this._clients[clientId];
        if (!client) {
            $1622be301bae0161$var$logger.warn(`client ${clientId} not found`);
            return;
        }
        if (client.isPendingToLeave) return;
        client.isPendingToLeave = true;
        if (this._wasClientSendingMedia(clientId)) {
            client.checkActiveMediaAttempts = 0;
            this._abortIfNotActive(payload);
        }
    }
    _onNewClient(payload) {
        const { client: { id: clientId, deviceId: deviceId } } = payload;
        const client = this._clients[clientId];
        if (client && client.isPendingToLeave) {
            clearTimeout(client.timeoutHandler);
            client.isPendingToLeave = false;
            this.metrics.pendingClientCanceled++;
            return;
        }
        this._getPendingClientsByDeviceId(deviceId).forEach((client)=>{
            clearTimeout(client.timeoutHandler);
            client.isPendingToLeave = undefined;
            this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, {
                clientId: client.clientId
            });
        });
        this._addClientToState(payload.client);
        this.emit($1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT, payload);
    }
    _abortIfNotActive(payload) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { clientId: clientId } = payload;
            let client = this._clients[clientId];
            if (!(client === null || client === void 0 ? void 0 : client.isPendingToLeave)) return;
            client.checkActiveMediaAttempts++;
            if (client.checkActiveMediaAttempts > 3) return;
            const stillActive = yield this._checkIsActive(clientId);
            if (stillActive) {
                client.timeoutHandler = setTimeout(()=>this._abortIfNotActive(payload), 500);
                return;
            }
            client = this._clients[clientId];
            if (client === null || client === void 0 ? void 0 : client.isPendingToLeave) {
                clearTimeout(client.timeoutHandler);
                delete this._clients[clientId];
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, payload);
            }
        });
    }
    _checkIsActive(clientId) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const allStats = yield $1622be301bae0161$export$a95105d8b2471e00();
            return this._isClientMediaActive(allStats, clientId);
        });
    }
    _isClientMediaActive(stats, clientId) {
        const clientStats = stats === null || stats === void 0 ? void 0 : stats[clientId];
        let isActive = false;
        if (clientStats) Object.entries(clientStats.tracks).forEach(([trackId, trackStats])=>{
            if (trackId !== "probator") Object.values(trackStats.ssrcs).forEach((ssrcStats)=>{
                if ((ssrcStats.bitrate || 0) > 0) isActive = true;
            });
        });
        return isActive;
    }
    _onAudioEnabled(payload) {
        const { clientId: clientId, isAudioEnabled: isAudioEnabled } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isAudioEnabled: isAudioEnabled
        });
    }
    _onVideoEnabled(payload) {
        const { clientId: clientId, isVideoEnabled: isVideoEnabled } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isVideoEnabled: isVideoEnabled
        });
    }
    _onScreenshareChanged(payload, action) {
        const { clientId: clientId } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isScreenshareEnabled: action
        });
    }
    _hasClientStateChanged({ clientId: clientId, webcam: webcam, mic: mic, screenShare: screenShare }) {
        const state = this._clients[clientId];
        if (!state) throw new Error(`Client ${clientId} not found in ReconnectManager state`);
        if (webcam !== state.isVideoEnabled) return true;
        if (mic !== state.isAudioEnabled) return true;
        if (screenShare !== state.isScreenshareEnabled) return true;
        return false;
    }
    _addClientToState(newClient) {
        this._clients[newClient.id] = Object.assign(Object.assign({}, this._clients[newClient.id] || {}), {
            isAudioEnabled: newClient.isAudioEnabled,
            isVideoEnabled: newClient.isVideoEnabled,
            isScreenshareEnabled: newClient.streams.length > 1,
            deviceId: newClient.deviceId,
            isPendingToLeave: newClient.isPendingToLeave,
            clientId: newClient.id
        });
    }
    _wasClientSendingMedia(clientId) {
        const client = this._clients[clientId];
        if (!client) throw new Error(`Client ${clientId} not found in ReconnectManager state`);
        return client.isAudioEnabled || client.isVideoEnabled || client.isScreenshareEnabled;
    }
    _getPendingClientsByDeviceId(deviceId) {
        return Object.values(this._clients).filter((clientState)=>{
            return clientState.deviceId === deviceId && clientState.isPendingToLeave;
        });
    }
    _resetClientState(payload) {
        this._clients = {};
        payload.room.clients.forEach((client)=>{
            if (client.id === payload.selfId) return;
            else this._addClientToState(client);
        });
    }
    constructor(socket){
        super();
        this.reconnectThresholdInMs = 0;
        this._socket = socket;
        this._clients = {};
        this._signalDisconnectTime = undefined;
        this.rtcManager = undefined;
        this.metrics = {
            roomJoinedLate: 0,
            pendingClientCanceled: 0,
            evaluationFailed: 0,
            roomJoined: 0
        };
        socket.on("disconnect", ()=>{
            this._signalDisconnectTime = Date.now();
        });
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, (payload)=>this._onRoomJoined(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT, (payload)=>this._onNewClient(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, (payload)=>this._onClientLeft(payload));
        socket.on($1622be301bae0161$export$c4a74f263978d610.PENDING_CLIENT_LEFT, (payload)=>this._onPendingClientLeft(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.AUDIO_ENABLED, (payload)=>this._onAudioEnabled(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.VIDEO_ENABLED, (payload)=>this._onVideoEnabled(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.SCREENSHARE_STARTED, (payload)=>this._onScreenshareChanged(payload, true));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.SCREENSHARE_STOPPED, (payload)=>this._onScreenshareChanged(payload, false));
    }
}
var $1622be301bae0161$var$_a;
const $1622be301bae0161$var$adapter = ($1622be301bae0161$var$_a = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a !== void 0 ? $1622be301bae0161$var$_a : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$DEFAULT_SOCKET_PATH = "/protocol/socket.io/v4";
const $1622be301bae0161$var$NOOP_KEEPALIVE_INTERVAL = 2000;
class $1622be301bae0161$export$f44d178d723e910b {
    setRtcManager(rtcManager) {
        if (this._reconnectManager) this._reconnectManager.rtcManager = rtcManager;
    }
    connect() {
        if (this.isConnected() || this.isConnecting()) return;
        this._socket.open();
    }
    disconnect() {
        this._socket.disconnect();
    }
    disconnectOnConnect() {
        this._socket.once("connect", ()=>{
            this._socket.disconnect();
        });
    }
    emit(eventName, ...args) {
        this._socket.emit.apply(this._socket, arguments);
    }
    emitIfConnected(eventName, data) {
        if (!this.isConnected()) return;
        this.emit(eventName, data);
    }
    getTransport() {
        return this._socket && this._socket.io && this._socket.io.engine && this._socket.io.engine.transport && this._socket.io.engine.transport.name;
    }
    getManager() {
        return this._socket.io;
    }
    isConnecting() {
        return this._socket && this._socket.connecting;
    }
    isConnected() {
        return this._socket && this._socket.connected;
    }
    on(eventName, handler) {
        const relayableEvents = [
            $1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED,
            $1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT,
            $1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT
        ];
        if (this._reconnectManager && relayableEvents.includes(eventName)) return this._interceptEvent(eventName, handler);
        this._socket.on(eventName, handler);
        return ()=>{
            this._socket.off(eventName, handler);
        };
    }
    once(eventName, handler) {
        this._socket.once(eventName, handler);
    }
    off(eventName, handler) {
        this._socket.off(eventName, handler);
    }
    _interceptEvent(eventName, handler) {
        if (this._reconnectManager) this._reconnectManager.on(eventName, handler);
        return ()=>{
            if (this._reconnectManager) this._reconnectManager.removeListener(eventName, handler);
        };
    }
    getGlitchFreeMetrics() {
        var _a;
        return (_a = this._reconnectManager) === null || _a === void 0 ? void 0 : _a.metrics;
    }
    getReconnectThreshold() {
        var _a;
        return (_a = this._reconnectManager) === null || _a === void 0 ? void 0 : _a.reconnectThresholdInMs;
    }
    constructor(hostName, optionsOverrides, glitchFree = false){
        this._wasConnectedUsingWebsocket = false;
        this._reconnectManager = null;
        this._socket = (0, $3e27f9daa0204a44$export$841407ceb083bd74)(hostName, Object.assign({
            path: $1622be301bae0161$var$DEFAULT_SOCKET_PATH,
            randomizationFactor: 0.5,
            reconnectionDelay: 250,
            reconnectionDelayMax: 5000,
            timeout: 5000,
            transports: [
                "websocket"
            ],
            withCredentials: true
        }, optionsOverrides));
        this._socket.io.on("reconnect", ()=>{
            this._socket.sendBuffer = [];
        });
        this._socket.io.on("reconnect_attempt", ()=>{
            if (this._wasConnectedUsingWebsocket) {
                this._socket.io.opts.transports = [
                    "websocket"
                ];
                if ($1622be301bae0161$var$adapter.browserDetails.browser !== "safari") delete this._wasConnectedUsingWebsocket;
            } else this._socket.io.opts.transports = [
                "websocket",
                "polling"
            ];
        });
        if (glitchFree) this._reconnectManager = new $1622be301bae0161$export$7dedc58743a41a9(this._socket);
        this._socket.on("connect", ()=>{
            const transport = this.getTransport();
            if (transport === "websocket") {
                this._wasConnectedUsingWebsocket = true;
                if (!this.noopKeepaliveInterval) this.noopKeepaliveInterval = setInterval(()=>{
                    try {
                        if (this._socket.connected) this._socket.io.engine.sendPacket("noop");
                    } catch (ex) {}
                }, $1622be301bae0161$var$NOOP_KEEPALIVE_INTERVAL);
            }
        });
        this._socket.on("disconnect", ()=>{
            this.disconnectTimestamp = Date.now();
            if (this.noopKeepaliveInterval) {
                clearInterval(this.noopKeepaliveInterval);
                this.noopKeepaliveInterval = null;
            }
        });
    }
}
const $1622be301bae0161$var$defaultSubdomainPattern = /^(?:([^.]+)[.])?((:?[^.]+[.]){1,}[^.]+)$/;
const $1622be301bae0161$var$localstackPattern = /^(?:([^.]+)-)?(ip-[^.]*[.](?:hereby[.]dev|rfc1918[.]disappear[.]at)(?::\d+|))$/;
const $1622be301bae0161$var$localhostPattern = /^(?:([^.]+)[.])?(localhost:?\d*)/;
const $1622be301bae0161$var$serverPattern = /^(?:([^.]+)[.])?(server:?\d*)/;
const $1622be301bae0161$var$ipv4Pattern = /^(?:([^.]+)[.])?((\d+[.]){3}:?\d*)$/;
const $1622be301bae0161$var$subdomainPatterns = [
    {
        pattern: $1622be301bae0161$var$serverPattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$localhostPattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$ipv4Pattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$localstackPattern,
        separator: "-"
    },
    {
        pattern: $1622be301bae0161$var$defaultSubdomainPattern,
        separator: "."
    }
];
function $1622be301bae0161$export$a08dede735aa5b41({ host: host = "whereby.com", protocol: protocol = "https:" } = {}) {
    let subdomain = "";
    let domain = host;
    let subdomainSeparator = ".";
    for (const { separator: separator, pattern: pattern } of $1622be301bae0161$var$subdomainPatterns){
        const match = pattern.exec(host);
        if (match) {
            subdomain = match[1] || "";
            domain = match[2];
            subdomainSeparator = separator;
            break;
        }
    }
    const organizationDomain = !subdomain ? domain : `${subdomain}${subdomainSeparator}${domain}`;
    return {
        domain: domain,
        domainWithSeparator: `${subdomainSeparator}${domain}`,
        organizationDomain: organizationDomain,
        organization: `${protocol}//${organizationDomain}`,
        service: `${protocol}//${domain}`,
        subdomain: subdomain
    };
}
$1622be301bae0161$export$a08dede735aa5b41(window && window.location);



var $cqkQU = parcelRequire("cqkQU");

var $11OXI = parcelRequire("11OXI");
var $029faa47ad838cc6$exports = {};

var $437dT = parcelRequire("437dT");
var $029faa47ad838cc6$require$Buffer = $437dT.Buffer;
(function() {
    "use strict";
    function btoa(str) {
        var buffer;
        if (str instanceof $029faa47ad838cc6$require$Buffer) buffer = str;
        else buffer = $029faa47ad838cc6$require$Buffer.from(str.toString(), "binary");
        return buffer.toString("base64");
    }
    $029faa47ad838cc6$exports = btoa;
})();


parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");
function $4fc09928452de42f$export$cdf9d0e702cbbe4b(typePrefix, payloadCreator) {
    return (0, $58dad493bd6ec980$export$6abd22dc03e5063f)(typePrefix, payloadCreator);
}
function $4fc09928452de42f$export$495454f275c5f192(thunk) {
    return thunk;
}
function $4fc09928452de42f$export$ba71e51cd1168d8d(authorizationSelector, thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const isAuthorized = authorizationSelector(getState());
            if (!isAuthorized) {
                console.warn("Not authorized to perform this action");
                return false;
            }
            return thunk(payload)(dispatch, getState, extra);
        });
}
function $4fc09928452de42f$export$f3d6a2157932333f(thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const connectionStatus = getState().roomConnection.status;
            if (connectionStatus !== "connected") {
                console.warn("Action cannot be performed outside of a connected room");
                return false;
            }
            return thunk(payload)(dispatch, getState, extra);
        });
}
function $4fc09928452de42f$export$7a92a3664c4cb7d1(typePrefix, payloadCreator) {
    return $4fc09928452de42f$export$cdf9d0e702cbbe4b(typePrefix, (arg, thunkApi)=>{
        const { getState: getState } = thunkApi;
        const connectionStatus = getState().roomConnection.status;
        if (connectionStatus !== "connected") {
            console.warn("Action cannot be performed outside of a connected room");
            return Promise.reject("Action cannot be performed outside of a connected room");
        }
        return payloadCreator(arg, thunkApi);
    });
}
function $4fc09928452de42f$export$8ffe952306980b53(authorizationSelector, thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const connectionStatus = getState().roomConnection.status;
            if (connectionStatus !== "connected") {
                console.warn("Action cannot be performed outside of a connected room");
                return false;
            }
            return $4fc09928452de42f$export$ba71e51cd1168d8d(authorizationSelector, thunk)(payload)(dispatch, getState, extra);
        });
}
const $4fc09928452de42f$export$1992b10a91137ec8 = (0, $58dad493bd6ec980$export$1228acebbbcb485b)();
const $4fc09928452de42f$export$4e3495129325ad89 = $4fc09928452de42f$export$1992b10a91137ec8.startListening;
const $4fc09928452de42f$export$12515b85036caad1 = (0, $58dad493bd6ec980$export$f03a6b845d3fb58b);
const $4fc09928452de42f$export$a818dc83df27d0f4 = (selectors, callback)=>{
    return $4fc09928452de42f$export$4e3495129325ad89({
        predicate: (_, currentState, previousState)=>{
            const previousValues = selectors.map((selector)=>selector(previousState));
            const currentValues = selectors.map((selector)=>selector(currentState));
            return previousValues.some((previousValue, index)=>previousValue !== currentValues[index]);
        },
        effect: (action, { dispatch: dispatch, getState: getState, extra: extra })=>{
            const selectorResults = selectors.map((selector)=>selector(getState()));
            callback({
                dispatch: dispatch,
                getState: getState,
                extra: extra
            }, ...selectorResults);
        }
    });
};
const $4fc09928452de42f$var$coreVersion = "0.28.2";
const $4fc09928452de42f$export$d4c72bab9d6cc13a = {
    isNodeSdk: false,
    isActive: false,
    isDialIn: false,
    roomName: null,
    roomUrl: null,
    displayName: null,
    userAgent: `core:${$4fc09928452de42f$var$coreVersion}`,
    externalId: null
};
const $4fc09928452de42f$export$7a3bdf7180628a3c = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "app",
    initialState: $4fc09928452de42f$export$d4c72bab9d6cc13a,
    reducers: {
        doAppStart: (state, action)=>{
            const url = new URL(action.payload.roomUrl);
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), {
                roomName: url.pathname,
                initialConfig: Object.assign({}, action.payload),
                isActive: true
            });
        },
        doAppStop: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isActive: false
            });
        }
    }
});
const { doAppStop: $4fc09928452de42f$export$d4d0f76450fb6374, doAppStart: $4fc09928452de42f$export$ca0cd7d9bebf6bc8 } = $4fc09928452de42f$export$7a3bdf7180628a3c.actions;
const $4fc09928452de42f$export$95809f86f8668b38 = (state)=>state.app;
const $4fc09928452de42f$export$ae5e487c0972282e = (state)=>state.app.isActive;
const $4fc09928452de42f$export$442c6682ecfaaef2 = (state)=>state.app.isDialIn;
const $4fc09928452de42f$export$2664cf73474d4255 = (state)=>state.app.roomName;
const $4fc09928452de42f$export$c6d654d892432c6b = (state)=>state.app.roomUrl;
const $4fc09928452de42f$export$b157fc4c059768ed = (state)=>state.app.displayName;
const $4fc09928452de42f$export$6f409a475b0c8c60 = (state)=>state.app.userAgent;
const $4fc09928452de42f$export$44202ee237048d77 = (state)=>state.app.externalId;
const $4fc09928452de42f$export$ab78798f462babdb = (state)=>state.app.isNodeSdk;
const $4fc09928452de42f$export$36ad109efa214adf = (state)=>state.app.initialConfig;
function $4fc09928452de42f$var$createSignalEventAction(name) {
    return (0, $58dad493bd6ec980$export$309c7a02b0b0bc62)(`signalConnection/event/${name}`);
}
const $4fc09928452de42f$export$6c507f583d588b9f = {
    audioEnabled: $4fc09928452de42f$var$createSignalEventAction("audioEnabled"),
    audioEnableRequested: $4fc09928452de42f$var$createSignalEventAction("audioEnableRequested"),
    chatMessage: $4fc09928452de42f$var$createSignalEventAction("chatMessage"),
    clientLeft: $4fc09928452de42f$var$createSignalEventAction("clientLeft"),
    clientKicked: $4fc09928452de42f$var$createSignalEventAction("clientKicked"),
    clientMetadataReceived: $4fc09928452de42f$var$createSignalEventAction("clientMetadataReceived"),
    clientUnableToJoin: $4fc09928452de42f$var$createSignalEventAction("clientUnableToJoin"),
    cloudRecordingStarted: $4fc09928452de42f$var$createSignalEventAction("cloudRecordingStarted"),
    cloudRecordingStopped: $4fc09928452de42f$var$createSignalEventAction("cloudRecordingStopped"),
    disconnect: $4fc09928452de42f$var$createSignalEventAction("disconnect"),
    knockerLeft: $4fc09928452de42f$var$createSignalEventAction("knockerLeft"),
    knockHandled: $4fc09928452de42f$var$createSignalEventAction("knockHandled"),
    newClient: $4fc09928452de42f$var$createSignalEventAction("newClient"),
    roomJoined: $4fc09928452de42f$var$createSignalEventAction("roomJoined"),
    roomKnocked: $4fc09928452de42f$var$createSignalEventAction("roomKnocked"),
    roomLeft: $4fc09928452de42f$var$createSignalEventAction("roomLeft"),
    roomLocked: $4fc09928452de42f$var$createSignalEventAction("roomLocked"),
    roomSessionEnded: $4fc09928452de42f$var$createSignalEventAction("roomSessionEnded"),
    screenshareStarted: $4fc09928452de42f$var$createSignalEventAction("screenshareStarted"),
    screenshareStopped: $4fc09928452de42f$var$createSignalEventAction("screenshareStopped"),
    spotlightAdded: $4fc09928452de42f$var$createSignalEventAction("spotlightAdded"),
    spotlightRemoved: $4fc09928452de42f$var$createSignalEventAction("spotlightRemoved"),
    streamingStopped: $4fc09928452de42f$var$createSignalEventAction("streamingStopped"),
    videoEnabled: $4fc09928452de42f$var$createSignalEventAction("videoEnabled"),
    videoEnableRequested: $4fc09928452de42f$var$createSignalEventAction("videoEnableRequested"),
    liveTranscriptionStarted: $4fc09928452de42f$var$createSignalEventAction("liveTranscriptionStarted"),
    liveTranscriptionStopped: $4fc09928452de42f$var$createSignalEventAction("liveTranscriptionStopped")
};
const $4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE = {
    canLockRoom: [
        "host"
    ],
    canRequestAudioEnable: [
        "host"
    ],
    canRequestVideoEnable: [
        "host"
    ],
    canKickClient: [
        "host"
    ],
    canEndMeeting: [
        "host"
    ],
    canAskToSpeak: [
        "host"
    ],
    canSpotlight: [
        "host"
    ]
};
const $4fc09928452de42f$var$initialState$f = {
    roomKey: null,
    roleName: "none"
};
const $4fc09928452de42f$export$a8061e375981838e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "authorization",
    initialState: $4fc09928452de42f$var$initialState$f,
    reducers: {
        setRoomKey: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                roomKey: action.payload
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                roomKey: action.payload.roomKey
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const client = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.clients.find((c)=>{
                var _a;
                return c.id === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.selfId);
            });
            return Object.assign(Object.assign({}, state), {
                roleName: (client === null || client === void 0 ? void 0 : client.role.roleName) || "none"
            });
        });
    }
});
const { setRoomKey: $4fc09928452de42f$export$4aa6cbb228087bb } = $4fc09928452de42f$export$a8061e375981838e.actions;
const $4fc09928452de42f$export$4040db2373332c60 = (state)=>state.authorization.roomKey;
const $4fc09928452de42f$export$c3921fe844b67c95 = (state)=>state.authorization.roleName;
const $4fc09928452de42f$export$dbb7a81a8f843adc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canLockRoom.includes(localParticipantRole));
const $4fc09928452de42f$export$a15ccd242dd0951b = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canRequestAudioEnable.includes(localParticipantRole));
const $4fc09928452de42f$export$84f3acf25e9c1055 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canRequestVideoEnable.includes(localParticipantRole));
const $4fc09928452de42f$export$e73be439ab5a8e31 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canKickClient.includes(localParticipantRole));
const $4fc09928452de42f$export$69a43832a7c34f54 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canEndMeeting.includes(localParticipantRole));
const $4fc09928452de42f$export$c53e10fe73bac35f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canAskToSpeak.includes(localParticipantRole));
const $4fc09928452de42f$export$7ad9182b247dbca0 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canSpotlight.includes(localParticipantRole));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $4fc09928452de42f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fc09928452de42f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $4fc09928452de42f$var$initialState$e = {
    isFetching: false,
    data: null
};
const $4fc09928452de42f$export$601059773552eb94 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "deviceCredentials",
    initialState: $4fc09928452de42f$var$initialState$e,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                data: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
    }
});
const $4fc09928452de42f$export$a9bace7063f4ee1e = $4fc09928452de42f$export$cdf9d0e702cbbe4b("deviceCredentials/doGetDeviceCredentials", (payload, { extra: extra })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const deviceCredentials = yield extra.services.credentialsService.getCredentials();
            return deviceCredentials;
        } catch (error) {
            console.error(error);
        }
    }));
const $4fc09928452de42f$export$658d1957bbe5d193 = (state)=>state.deviceCredentials;
const $4fc09928452de42f$export$1fabdcbf2ec44a8e = (state)=>{
    var _a;
    return !!((_a = state.deviceCredentials.data) === null || _a === void 0 ? void 0 : _a.credentials);
};
const $4fc09928452de42f$export$595744fa227922ad = (state)=>{
    var _a, _b;
    return (_b = (_a = state.deviceCredentials.data) === null || _a === void 0 ? void 0 : _a.credentials) === null || _b === void 0 ? void 0 : _b.uuid;
};
const $4fc09928452de42f$export$53b9c47f466bd445 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$658d1957bbe5d193, (appIsActive, deviceCredentials)=>{
    if (appIsActive && !deviceCredentials.isFetching && !deviceCredentials.data) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$53b9c47f466bd445
], ({ dispatch: dispatch }, shouldFetchDeviceCredentials)=>{
    if (shouldFetchDeviceCredentials) dispatch($4fc09928452de42f$export$a9bace7063f4ee1e());
});
function $4fc09928452de42f$var$forwardSocketEvents(socket, dispatch) {
    socket.on("room_joined", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomJoined(payload)));
    socket.on("new_client", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.newClient(payload)));
    socket.on("client_left", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientLeft(payload)));
    socket.on("client_kicked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientKicked(payload)));
    socket.on("client_unable_to_join", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientUnableToJoin(payload)));
    socket.on("audio_enabled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.audioEnabled(payload)));
    socket.on("video_enabled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.videoEnabled(payload)));
    socket.on("audio_enable_requested", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested(payload)));
    socket.on("client_metadata_received", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived(payload)));
    socket.on("chat_message", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.chatMessage(payload)));
    socket.on("disconnect", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.disconnect()));
    socket.on("room_knocked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomKnocked(payload)));
    socket.on("room_left", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomLeft()));
    socket.on("room_locked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomLocked(payload)));
    socket.on("room_session_ended", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded(payload)));
    socket.on("knocker_left", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.knockerLeft(payload)));
    socket.on("knock_handled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.knockHandled(payload)));
    socket.on("screenshare_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.screenshareStarted(payload)));
    socket.on("screenshare_stopped", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.screenshareStopped(payload)));
    socket.on("cloud_recording_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStarted(payload)));
    socket.on("cloud_recording_stopped", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStopped()));
    socket.on("streaming_stopped", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.streamingStopped()));
    socket.on("spotlight_added", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.spotlightAdded(payload)));
    socket.on("spotlight_removed", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.spotlightRemoved(payload)));
    socket.on("live_transcription_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.liveTranscriptionStarted(payload)));
    socket.on("live_transcription_stopped", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.liveTranscriptionStopped(payload)));
    socket.on("video_enable_requested", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested(payload)));
}
const $4fc09928452de42f$var$SIGNAL_BASE_URL = "wss://signal.appearin.net";
function $4fc09928452de42f$var$createSocket() {
    const parsedUrl = new URL($4fc09928452de42f$var$SIGNAL_BASE_URL);
    const socketHost = parsedUrl.origin;
    const socketOverrides = {
        autoConnect: false
    };
    return new (0, $1622be301bae0161$export$f44d178d723e910b)(socketHost, socketOverrides);
}
const $4fc09928452de42f$var$initialState$d = {
    deviceIdentified: false,
    isIdentifyingDevice: false,
    status: "ready",
    socket: null
};
const $4fc09928452de42f$export$1010602111efdae4 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "signalConnection",
    initialState: $4fc09928452de42f$var$initialState$d,
    reducers: {
        socketConnecting: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "connecting"
            });
        },
        socketConnected: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                socket: action.payload,
                status: "connected"
            });
        },
        socketDisconnected: (state)=>{
            return Object.assign(Object.assign({}, state), {
                socket: null,
                deviceIdentified: false,
                status: "disconnected"
            });
        },
        socketReconnecting: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        },
        deviceIdentifying: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isIdentifyingDevice: true
            });
        },
        deviceIdentified: (state)=>{
            return Object.assign(Object.assign({}, state), {
                deviceIdentified: true,
                isIdentifyingDevice: false
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.disconnect, (state)=>{
            return Object.assign(Object.assign({}, state), {
                deviceIdentified: false,
                status: "disconnected"
            });
        });
    }
});
const { deviceIdentifying: $4fc09928452de42f$export$bc51939d2f2cd4a, deviceIdentified: $4fc09928452de42f$export$57ca09c85670100e, socketConnected: $4fc09928452de42f$export$48b6ca2220db698a, socketConnecting: $4fc09928452de42f$export$d25d75f4bdc4482, socketDisconnected: $4fc09928452de42f$export$7b77b29673fc6d37, socketReconnecting: $4fc09928452de42f$export$fb604b2ee1249ba5 } = $4fc09928452de42f$export$1010602111efdae4.actions;
const $4fc09928452de42f$export$1ec5c2b17c26996e = $4fc09928452de42f$export$495454f275c5f192(()=>{
    return (dispatch, getState)=>{
        if ($4fc09928452de42f$export$efc69c8f0644aa20(getState())) return;
        dispatch($4fc09928452de42f$export$d25d75f4bdc4482());
        const socket = $4fc09928452de42f$var$createSocket();
        socket.on("connect", ()=>dispatch($4fc09928452de42f$export$48b6ca2220db698a(socket)));
        socket.on("device_identified", ()=>dispatch($4fc09928452de42f$export$57ca09c85670100e()));
        socket.getManager().on("reconnect", ()=>dispatch($4fc09928452de42f$export$fb604b2ee1249ba5()));
        $4fc09928452de42f$var$forwardSocketEvents(socket, dispatch);
        socket.connect();
    };
});
const $4fc09928452de42f$export$6313658c703ceaf8 = $4fc09928452de42f$export$495454f275c5f192(({ deviceCredentials: deviceCredentials })=>(dispatch, getState)=>{
        const state = getState();
        const signalSocket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        const deviceIdentified = $4fc09928452de42f$export$f861d0329c5966c4(state);
        if (!signalSocket) return;
        if (deviceIdentified) return;
        signalSocket.emit("identify_device", {
            deviceCredentials: deviceCredentials
        });
        dispatch($4fc09928452de42f$export$bc51939d2f2cd4a());
    });
const $4fc09928452de42f$export$662ce9a66e2e97d8 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const signalStatus = $4fc09928452de42f$export$fb9576bb0af6ec25(state);
        if (signalStatus === "connected") {
            const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
            socket === null || socket === void 0 || socket.disconnect();
            dispatch($4fc09928452de42f$export$7b77b29673fc6d37());
        }
    });
const $4fc09928452de42f$export$b12d0ae99b4b2470 = (state)=>state.signalConnection;
const $4fc09928452de42f$export$3ee4dc1d6a8ff538 = (state)=>state.signalConnection.isIdentifyingDevice;
const $4fc09928452de42f$export$f861d0329c5966c4 = (state)=>state.signalConnection.deviceIdentified;
const $4fc09928452de42f$export$fb9576bb0af6ec25 = (state)=>state.signalConnection.status;
const $4fc09928452de42f$export$efc69c8f0644aa20 = (state)=>state.signalConnection.socket;
const $4fc09928452de42f$export$e5344360f2c7d7e8 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$fb9576bb0af6ec25, (appIsActive, signalStatus)=>{
    if (appIsActive && [
        "ready",
        "reconnecting"
    ].includes(signalStatus)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e5344360f2c7d7e8
], ({ dispatch: dispatch }, shouldConnectSignal)=>{
    if (shouldConnectSignal) dispatch($4fc09928452de42f$export$1ec5c2b17c26996e());
});
const $4fc09928452de42f$export$d06c004c1bc5f59 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$658d1957bbe5d193, $4fc09928452de42f$export$fb9576bb0af6ec25, $4fc09928452de42f$export$f861d0329c5966c4, $4fc09928452de42f$export$3ee4dc1d6a8ff538, (deviceCredentialsRaw, signalStatus, deviceIdentified, isIdentifyingDevice)=>{
    if (deviceCredentialsRaw.data && signalStatus === "connected" && !deviceIdentified && !isIdentifyingDevice) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$d06c004c1bc5f59,
    $4fc09928452de42f$export$658d1957bbe5d193
], ({ dispatch: dispatch }, shouldIdentifyDevice, deviceCredentialsRaw)=>{
    if (shouldIdentifyDevice && deviceCredentialsRaw.data) dispatch($4fc09928452de42f$export$6313658c703ceaf8({
        deviceCredentials: deviceCredentialsRaw.data
    }));
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.roomLeft,
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$662ce9a66e2e97d8());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientKicked,
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$662ce9a66e2e97d8());
    }
});
const $4fc09928452de42f$var$initialState$c = {
    chatMessages: []
};
const $4fc09928452de42f$export$89f748d7b911fed0 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "chat",
    initialState: $4fc09928452de42f$var$initialState$c,
    reducers: {},
    extraReducers (builder) {
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.chatMessage, (state, action)=>{
            const message = {
                senderId: action.payload.senderId,
                timestamp: action.payload.timestamp,
                text: action.payload.text
            };
            return Object.assign(Object.assign({}, state), {
                chatMessages: [
                    ...state.chatMessages,
                    message
                ]
            });
        });
    }
});
const $4fc09928452de42f$export$24e3bf930d312b2b = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("chat_message", {
            text: payload.text
        });
    });
const $4fc09928452de42f$export$13f3ac2a728ceb8b = (state)=>state.chat;
const $4fc09928452de42f$export$e67c42ad18139770 = (state)=>state.chat.chatMessages;
const $4fc09928452de42f$export$b4be21ed3c586215 = {
    isRecording: false,
    error: null,
    startedAt: undefined
};
const $4fc09928452de42f$export$4a7c7275a23ed5bc = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "cloudRecording",
    initialState: $4fc09928452de42f$export$b4be21ed3c586215,
    reducers: {
        recordingRequestStarted: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "requested"
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStopped, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isRecording: false,
                status: undefined
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStarted, (state, action)=>{
            const { payload: payload } = action;
            if (!payload.error) return state;
            return Object.assign(Object.assign({}, state), {
                isRecording: false,
                status: "error",
                error: payload.error
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, { payload: payload })=>{
            var _a;
            const { client: client } = payload;
            if (((_a = client.role) === null || _a === void 0 ? void 0 : _a.roleName) === "recorder") return Object.assign(Object.assign({}, state), {
                isRecording: true,
                status: "recording",
                startedAt: client.startedCloudRecordingAt ? new Date(client.startedCloudRecordingAt).getTime() : new Date().getTime()
            });
            return state;
        });
    }
});
const { recordingRequestStarted: $4fc09928452de42f$export$5ec9485ce4da66d8 } = $4fc09928452de42f$export$4a7c7275a23ed5bc.actions;
const $4fc09928452de42f$export$8568c037c56c4692 = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const status = $4fc09928452de42f$export$2800027a639a1395(state);
        if (status && [
            "recording",
            "requested"
        ].includes(status)) return;
        socket === null || socket === void 0 || socket.emit("start_recording", {
            recording: "cloud"
        });
        dispatch($4fc09928452de42f$export$5ec9485ce4da66d8());
    });
const $4fc09928452de42f$export$579ffd5d4359613e = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("stop_recording");
    });
const $4fc09928452de42f$export$e8f9fec2fd38be7b = (state)=>state.cloudRecording;
const $4fc09928452de42f$export$2800027a639a1395 = (state)=>state.cloudRecording.status;
const $4fc09928452de42f$export$1c8c1e3b210ae980 = (state)=>state.cloudRecording.startedAt;
const $4fc09928452de42f$export$7fef72dec076388f = (state)=>state.cloudRecording.error;
const $4fc09928452de42f$export$71863674063f458c = (state)=>state.cloudRecording.isRecording;
const $4fc09928452de42f$var$initialState$b = {
    data: null,
    isFetching: false,
    error: null
};
const $4fc09928452de42f$export$351101b59484838e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$b,
    name: "organization",
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.fulfilled, (state, action)=>{
            if (!action.payload) return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                data: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                error: true
            });
        });
    }
});
const $4fc09928452de42f$export$1ed9272eed0ed03b = $4fc09928452de42f$export$cdf9d0e702cbbe4b("organization/doOrganizationFetch", (_, { extra: extra, getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const roomUrl = $4fc09928452de42f$export$c6d654d892432c6b(getState());
            const organization = yield extra.services.fetchOrganizationFromRoomUrl(roomUrl || "");
            if (!organization) throw new Error("Invalid room url");
            return organization;
        } catch (error) {
            console.error(error);
        }
    }));
const $4fc09928452de42f$export$149960cc946ace1e = (state)=>state.organization;
const $4fc09928452de42f$export$7ba530130176c5b4 = (state)=>{
    var _a;
    return (_a = state.organization.data) === null || _a === void 0 ? void 0 : _a.organizationId;
};
const $4fc09928452de42f$export$7090e7076d1b0f9f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$149960cc946ace1e, $4fc09928452de42f$export$658d1957bbe5d193, (appIsActive, organization, deviceCredentials)=>{
    if (appIsActive && !organization.data && !organization.isFetching && !organization.error && !deviceCredentials.isFetching) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$7090e7076d1b0f9f
], ({ dispatch: dispatch }, shouldFetchOrganization)=>{
    if (shouldFetchOrganization) dispatch($4fc09928452de42f$export$1ed9272eed0ed03b());
});
function $4fc09928452de42f$var$fakeAudioStream() {
    const audioCtx = new AudioContext();
    const oscillator = audioCtx.createOscillator();
    const destination = audioCtx.createMediaStreamDestination();
    oscillator.connect(destination);
    oscillator.start();
    return destination.stream;
}
let $4fc09928452de42f$var$rotationAngle = 0;
function $4fc09928452de42f$var$drawWebcamFrame(canvas) {
    const context = canvas.getContext("2d");
    if (!context) {
        console.error("Canvas context not available");
        return;
    }
    const wheelRadius = 100;
    const wheelCenterX = canvas.width / 2;
    const wheelCenterY = canvas.height / 2;
    context.fillStyle = "darkgreen";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.translate(wheelCenterX, wheelCenterY);
    context.rotate($4fc09928452de42f$var$rotationAngle);
    const numSlices = 12;
    const sliceAngle = 2 * Math.PI / numSlices;
    const colors = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "purple"
    ];
    for(let i = 0; i < numSlices; i++){
        context.beginPath();
        context.moveTo(0, 0);
        context.arc(0, 0, wheelRadius, i * sliceAngle, (i + 1) * sliceAngle);
        context.fillStyle = colors[i % colors.length];
        context.fill();
        context.closePath();
    }
    context.restore();
    context.fillStyle = "white";
    context.font = "42px Arial";
    const topText = "Whereby Media Stream";
    const topTextWidth = context.measureText(topText).width;
    context.fillText(topText, canvas.width / 2 - topTextWidth / 2, 50);
    context.font = "32px Arial";
    const now = new Date();
    const timeText = `time: ${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now.getSeconds().toString().padStart(2, "0")}.${now.getMilliseconds().toString().padStart(3, "0")}`;
    context.fillText(timeText, 10, canvas.height - 20);
    context.fillText(`rotation angle: ${$4fc09928452de42f$var$rotationAngle.toFixed(2)}`, canvas.width - canvas.width / 2, canvas.height - 20);
    $4fc09928452de42f$var$rotationAngle += 0.01;
}
function $4fc09928452de42f$var$fakeWebcamFrame(canvas) {
    $4fc09928452de42f$var$drawWebcamFrame(canvas);
    setInterval(()=>$4fc09928452de42f$var$drawWebcamFrame(canvas), 50);
}
const $4fc09928452de42f$var$CANVAS_VIDEO_FPS = 24;
function $4fc09928452de42f$export$2f40a00711eb9f5e() {
    const audioStream = $4fc09928452de42f$var$fakeAudioStream();
    return audioStream.getAudioTracks()[0];
}
function $4fc09928452de42f$export$50d8a22c2769f30b({ canvas: canvas }) {
    $4fc09928452de42f$var$fakeWebcamFrame(canvas);
    const videoStream = canvas.captureStream($4fc09928452de42f$var$CANVAS_VIDEO_FPS);
    return videoStream.getVideoTracks()[0];
}
function $4fc09928452de42f$export$189276e7b19b22c3({ canvas: canvas, hasAudio: hasAudio }) {
    const tracks = [
        $4fc09928452de42f$export$50d8a22c2769f30b({
            canvas: canvas
        }),
        ...hasAudio ? [
            $4fc09928452de42f$export$2f40a00711eb9f5e()
        ] : []
    ];
    return new MediaStream(tracks);
}
function $4fc09928452de42f$export$61fc7d43ac8f84b0(fn, { delay: delay = 500, edges: edges } = {}) {
    let timeout;
    let nCalls = 0;
    return (...args)=>{
        nCalls += 1;
        if (edges && nCalls === 1) fn(...args);
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            if (!edges || nCalls > 1) fn(...args);
            timeout = undefined;
            nCalls = 0;
        }, delay);
    };
}
function $4fc09928452de42f$export$83b87411fec6e66(roomAttribute, subdomainAttribute) {
    if (!roomAttribute) throw new Error("Missing room attribute");
    const m = /https:\/\/([^.]+)(\.whereby\.com|-ip-\d+-\d+-\d+-\d+.hereby.dev:4443)\/.+/.exec(roomAttribute);
    const subdomain = m && m[1] || subdomainAttribute;
    if (!subdomain) throw new Error("Missing subdomain attribute");
    if (!m) throw new Error("Could not parse room URL");
    const roomUrl = new URL(roomAttribute);
    return {
        subdomain: subdomain,
        roomUrl: roomUrl
    };
}
function $4fc09928452de42f$export$5a389667740ebcca(roomKey) {
    const [, roomKeyData] = /\.(.*)\./i.exec(roomKey) || [];
    if (!roomKeyData) return {};
    else try {
        const base64DecodedJwtData = atob(roomKeyData);
        return JSON.parse(base64DecodedJwtData);
    } catch (e) {
        return {};
    }
}
const $4fc09928452de42f$export$f6116eae9101e095 = {
    busyDeviceIds: [],
    cameraEnabled: false,
    currentSpeakerDeviceId: "default",
    devices: [],
    isSettingCameraDevice: false,
    isSettingMicrophoneDevice: false,
    isSettingSpeakerDevice: false,
    isTogglingCamera: false,
    lowDataMode: false,
    microphoneEnabled: false,
    status: "inactive",
    stream: undefined,
    isSwitchingStream: false
};
const $4fc09928452de42f$export$5bb3b96828f370d1 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localMedia",
    initialState: $4fc09928452de42f$export$f6116eae9101e095,
    reducers: {
        deviceBusy (state, action) {
            if (state.busyDeviceIds.includes(action.payload.deviceId)) return state;
            return Object.assign(Object.assign({}, state), {
                busyDeviceIds: [
                    ...state.busyDeviceIds,
                    action.payload.deviceId
                ]
            });
        },
        toggleCameraEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                cameraEnabled: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.cameraEnabled
            });
        },
        setCurrentCameraDeviceId (state, action) {
            return Object.assign(Object.assign({}, state), {
                currentCameraDeviceId: action.payload.deviceId
            });
        },
        toggleMicrophoneEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                microphoneEnabled: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.microphoneEnabled
            });
        },
        setCurrentMicrophoneDeviceId (state, action) {
            return Object.assign(Object.assign({}, state), {
                currentMicrophoneDeviceId: action.payload.deviceId
            });
        },
        setCurrentSpeakerDeviceId (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                currentSpeakerDeviceId: (_a = action.payload.deviceId) !== null && _a !== void 0 ? _a : "default"
            });
        },
        toggleLowDataModeEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                lowDataMode: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.lowDataMode
            });
        },
        setDevices (state, action) {
            return Object.assign(Object.assign({}, state), {
                devices: action.payload.devices
            });
        },
        setLocalMediaStream (state, action) {
            return Object.assign(Object.assign({}, state), {
                stream: action.payload.stream
            });
        },
        setLocalMediaOptions (state, action) {
            return Object.assign(Object.assign({}, state), {
                options: action.payload.options
            });
        },
        localMediaStopped (state) {
            return Object.assign(Object.assign({}, state), {
                status: "stopped",
                stream: undefined
            });
        },
        localStreamMetadataUpdated (state, action) {
            const { audio: audio, video: video } = action.payload;
            return Object.assign(Object.assign({}, state), {
                currentCameraDeviceId: video.deviceId,
                currentMicrophoneDeviceId: audio.deviceId,
                busyDeviceIds: state.busyDeviceIds.filter((id)=>id !== audio.deviceId && id !== video.deviceId)
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                options: action.payload.localMediaOptions
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.pending, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video,
                isSettingMicrophoneDevice: audio
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video ? false : state.isSettingCameraDevice,
                isSettingMicrophoneDevice: audio ? false : state.isSettingMicrophoneDevice
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.rejected, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video ? false : state.isSettingCameraDevice,
                isSettingMicrophoneDevice: audio ? false : state.isSettingMicrophoneDevice,
                cameraDeviceError: video ? action.error : state.cameraDeviceError,
                microphoneDeviceError: audio ? action.error : state.microphoneDeviceError
            });
        });
        builder.addCase($4fc09928452de42f$export$9933267781a720e.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isTogglingCamera: true
            });
        });
        builder.addCase($4fc09928452de42f$export$9933267781a720e.fulfilled, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isTogglingCamera: false
            });
        });
        builder.addCase($4fc09928452de42f$export$24ed9de9cfe6ab93.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                devices: action.payload.devices
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "starting"
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.fulfilled, (state, { payload: { stream: stream, onDeviceChange: onDeviceChange } })=>{
            let cameraDeviceId = undefined;
            let cameraEnabled = false;
            let microphoneDeviceId = undefined;
            let microphoneEnabled = false;
            const audioTrack = stream.getAudioTracks()[0];
            const videoTrack = stream.getVideoTracks()[0];
            if (audioTrack) {
                microphoneDeviceId = audioTrack.getSettings().deviceId;
                microphoneEnabled = audioTrack.enabled;
            }
            if (videoTrack) {
                cameraEnabled = videoTrack.enabled;
                cameraDeviceId = videoTrack.getSettings().deviceId;
            }
            return Object.assign(Object.assign({}, state), {
                stream: stream,
                status: "started",
                currentCameraDeviceId: cameraDeviceId,
                currentMicrophoneDeviceId: microphoneDeviceId,
                cameraEnabled: cameraEnabled,
                microphoneEnabled: microphoneEnabled,
                onDeviceChange: onDeviceChange
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.rejected, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                status: "error",
                startError: action.error
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: true
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.fulfilled, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: false
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: false
            });
        });
    }
});
const { deviceBusy: $4fc09928452de42f$export$b01847946e37298f, setCurrentCameraDeviceId: $4fc09928452de42f$export$ab12f9f2846e3448, setCurrentMicrophoneDeviceId: $4fc09928452de42f$export$2e1fc2200098f950, setCurrentSpeakerDeviceId: $4fc09928452de42f$export$1176f68d1d548ad3, toggleCameraEnabled: $4fc09928452de42f$export$93cdb5d3b5880a52, toggleMicrophoneEnabled: $4fc09928452de42f$export$11a7008b2ab330c2, toggleLowDataModeEnabled: $4fc09928452de42f$export$f8ccf9677d12adec, setLocalMediaOptions: $4fc09928452de42f$export$74044ec7ad05ecf5, setLocalMediaStream: $4fc09928452de42f$export$313da74df613e066, localMediaStopped: $4fc09928452de42f$export$9492753e9267457d, localStreamMetadataUpdated: $4fc09928452de42f$export$245247334d37072c } = $4fc09928452de42f$export$5bb3b96828f370d1.actions;
const $4fc09928452de42f$export$9933267781a720e = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doToggleCamera", (_, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        if (!stream) return;
        let track = stream.getVideoTracks()[0];
        const enabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
        try {
            if (enabled) {
                if (track) track.enabled = true;
                else {
                    const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
                    const cameraDeviceId = $4fc09928452de42f$export$9b07214a345a0c2b(state);
                    yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                        audioId: false,
                        videoId: cameraDeviceId,
                        type: "exact"
                    }), {
                        replaceStream: stream
                    });
                    track = stream.getVideoTracks()[0];
                }
            } else {
                if (!track) return;
                track.enabled = false;
                track.stop();
                stream.removeTrack(track);
            }
            stream.dispatchEvent(new CustomEvent("stopresumevideo", {
                detail: {
                    track: track,
                    enable: enabled
                }
            }));
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$var$doToggleMicrophone = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doToggleMicrophone", (_, { getState: getState })=>{
    var _a;
    const state = getState();
    const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
    if (!stream) return;
    const enabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
    const audioTrack = (_a = stream.getAudioTracks()) === null || _a === void 0 ? void 0 : _a[0];
    if (!audioTrack) return;
    audioTrack.enabled = enabled;
});
const $4fc09928452de42f$export$147a1219e0418788 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        if (!stream) return;
        const videoId = $4fc09928452de42f$export$9b07214a345a0c2b(state);
        const audioId = $4fc09928452de42f$export$15cb5bc234aa0b53(state);
        dispatch($4fc09928452de42f$export$128f34559d09c6da({
            audioId: audioId,
            videoId: videoId
        }));
    });
const $4fc09928452de42f$export$e35f65b306a0e8f6 = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/reactSetDevice", ({ audio: audio, video: video }, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const state = getState();
            const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
            if (!stream) throw new Error("No stream");
            const audioId = audio ? $4fc09928452de42f$export$15cb5bc234aa0b53(state) : false;
            const videoId = video ? $4fc09928452de42f$export$9b07214a345a0c2b(state) : false;
            const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
            const { replacedTracks: replacedTracks } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: audioId,
                videoId: videoId,
                type: "exact"
            }), {
                replaceStream: stream
            });
            const isAudioEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
            stream.getAudioTracks().forEach((track)=>track.enabled = isAudioEnabled);
            const isVideoEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
            stream.getVideoTracks().forEach((track)=>track.enabled = isVideoEnabled);
            return {
                replacedTracks: replacedTracks
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$24ed9de9cfe6ab93 = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doUpdateDeviceList", (_, { getState: getState, dispatch: dispatch, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a, _b, _c, _d;
        const state = getState();
        let newDevices = [];
        let oldDevices = [];
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        try {
            newDevices = yield navigator.mediaDevices.enumerateDevices();
            oldDevices = $4fc09928452de42f$export$1a9647721070cccc(state);
            const shouldHandleDeviceUpdate = stream && !$4fc09928452de42f$export$54d57059e4b0746a(state) && newDevices && oldDevices && oldDevices.find((d)=>d.deviceId);
            if (!shouldHandleDeviceUpdate) return {
                devices: newDevices
            };
            const { changedDevices: changedDevices, addedDevices: addedDevices } = (0, $1622be301bae0161$export$be9584734485c5e8)({
                oldDevices: oldDevices,
                newDevices: newDevices
            });
            let autoSwitchAudioId = (_a = changedDevices.audioinput) === null || _a === void 0 ? void 0 : _a.deviceId;
            let autoSwitchVideoId = (_b = changedDevices.videoinput) === null || _b === void 0 ? void 0 : _b.deviceId;
            if (autoSwitchAudioId === undefined) autoSwitchAudioId = (_c = addedDevices.audioinput) === null || _c === void 0 ? void 0 : _c.deviceId;
            if (autoSwitchVideoId === undefined) autoSwitchVideoId = (_d = addedDevices.videoinput) === null || _d === void 0 ? void 0 : _d.deviceId;
            if (autoSwitchAudioId !== undefined || autoSwitchVideoId !== undefined) dispatch($4fc09928452de42f$export$128f34559d09c6da({
                audioId: autoSwitchAudioId,
                videoId: autoSwitchVideoId
            }));
            return {
                devices: newDevices
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$128f34559d09c6da = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doSwitchLocalStream", ({ audioId: audioId, videoId: videoId }, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const replaceStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
        const onlySwitchingOne = !!(videoId && !audioId) || !!(!videoId && audioId);
        if (!replaceStream) return;
        try {
            const { replacedTracks: replacedTracks } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: audioId === undefined ? false : audioId,
                videoId: videoId === undefined ? false : videoId,
                type: "exact"
            }), {
                replaceStream: replaceStream
            });
            const deviceId = audioId || videoId;
            if (onlySwitchingOne && deviceId) dispatch($4fc09928452de42f$export$b01847946e37298f({
                deviceId: deviceId
            }));
            return {
                replacedTracks: replacedTracks
            };
        } catch (error) {
            console.error(error);
            const deviceId = audioId || videoId;
            if (onlySwitchingOne && deviceId) dispatch($4fc09928452de42f$export$b01847946e37298f({
                deviceId: deviceId
            }));
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$eb927cdec6bfaecd = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doStartLocalMedia", (payload, { getState: getState, dispatch: dispatch, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const onDeviceChange = $4fc09928452de42f$export$61fc7d43ac8f84b0(()=>{
            dispatch($4fc09928452de42f$export$24ed9de9cfe6ab93());
        }, {
            delay: 500
        });
        if (navigator.mediaDevices) navigator.mediaDevices.addEventListener("devicechange", onDeviceChange);
        if ("getTracks" in payload) return Promise.resolve({
            stream: payload,
            onDeviceChange: onDeviceChange
        });
        if (!(payload.audio || payload.video)) return {
            stream: new MediaStream(),
            onDeviceChange: onDeviceChange
        };
        else dispatch($4fc09928452de42f$export$74044ec7ad05ecf5({
            options: payload
        }));
        try {
            yield dispatch($4fc09928452de42f$export$24ed9de9cfe6ab93());
            const state = getState();
            const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
            const { stream: stream } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: payload.audio,
                videoId: payload.video
            }));
            return {
                stream: stream,
                onDeviceChange: onDeviceChange
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$85e2dd05688d27d9 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const onDeviceChange = $4fc09928452de42f$export$de402d29be2417a1(getState()).onDeviceChange;
        stream === null || stream === void 0 || stream.getTracks().forEach((track)=>{
            track.stop();
        });
        if (navigator.mediaDevices && onDeviceChange) navigator.mediaDevices.removeEventListener("devicechange", onDeviceChange);
        dispatch($4fc09928452de42f$export$9492753e9267457d());
    });
const $4fc09928452de42f$export$a49b90aaf35a8e5a = (state)=>state.localMedia.busyDeviceIds;
const $4fc09928452de42f$export$68025622922ffa26 = (state)=>state.localMedia.cameraDeviceError;
const $4fc09928452de42f$export$9b07214a345a0c2b = (state)=>state.localMedia.currentCameraDeviceId;
const $4fc09928452de42f$export$15cb5bc234aa0b53 = (state)=>state.localMedia.currentMicrophoneDeviceId;
const $4fc09928452de42f$export$356fc73355033f1b = (state)=>state.localMedia.currentSpeakerDeviceId;
const $4fc09928452de42f$export$c8e0d13b9d33fb32 = (state)=>state.localMedia.cameraEnabled;
const $4fc09928452de42f$export$ee30c1c2cc195652 = (state)=>state.localMedia.microphoneEnabled;
const $4fc09928452de42f$export$7c06101e124bf472 = (state)=>state.localMedia.lowDataMode;
const $4fc09928452de42f$export$53fdac895dbb6618 = (state)=>state.localMedia.isSettingCameraDevice;
const $4fc09928452de42f$export$6dd72f0a0b587d15 = (state)=>state.localMedia.isSettingMicrophoneDevice;
const $4fc09928452de42f$export$c94b2357b1d094f9 = (state)=>state.localMedia.isTogglingCamera;
const $4fc09928452de42f$export$1a9647721070cccc = (state)=>state.localMedia.devices;
const $4fc09928452de42f$export$5365e4b7f36eeda5 = (state)=>state.localMedia.options;
const $4fc09928452de42f$export$764b04f862de3618 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$5365e4b7f36eeda5, (options)=>!!options);
const $4fc09928452de42f$export$de402d29be2417a1 = (state)=>state.localMedia;
const $4fc09928452de42f$export$6a731d6bc230a245 = (state)=>state.localMedia.status;
const $4fc09928452de42f$export$e9c4b1bf93e7c80d = (state)=>state.localMedia.stream;
const $4fc09928452de42f$export$6dc516caa6efdffc = (state)=>state.localMedia.microphoneDeviceError;
const $4fc09928452de42f$export$c86c916bf575750b = (state)=>state.localMedia.startError;
const $4fc09928452de42f$export$54d57059e4b0746a = (state)=>state.localMedia.isSwitchingStream;
const $4fc09928452de42f$export$585cee7165e8d1fc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$9b07214a345a0c2b, $4fc09928452de42f$export$15cb5bc234aa0b53, $4fc09928452de42f$export$7c06101e124bf472, (devices, videoId, audioId, lowDataMode)=>({
        devices: devices,
        videoId: videoId,
        audioId: audioId,
        options: {
            disableAEC: false,
            disableAGC: false,
            hd: true,
            lax: false,
            lowDataMode: lowDataMode,
            simulcast: true,
            widescreen: true
        }
    }));
const $4fc09928452de42f$export$5353cfedea9c4a68 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6a731d6bc230a245, (status)=>status === "starting");
const $4fc09928452de42f$export$434a4c2926dbcbc8 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$a49b90aaf35a8e5a, (devices, busyDeviceIds)=>devices.filter((d)=>d.kind === "videoinput").filter((d)=>!busyDeviceIds.includes(d.deviceId)));
const $4fc09928452de42f$export$3622b5408789e593 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$a49b90aaf35a8e5a, (devices, busyDeviceIds)=>devices.filter((d)=>d.kind === "audioinput").filter((d)=>!busyDeviceIds.includes(d.deviceId)));
const $4fc09928452de42f$export$d743da980c7b249a = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, (devices)=>devices.filter((d)=>d.kind === "audiooutput"));
const $4fc09928452de42f$export$5b48ba01602df302 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$6a731d6bc230a245, $4fc09928452de42f$export$5365e4b7f36eeda5, (appIsActive, localMediaStatus, localMediaOptions)=>{
    if (appIsActive && [
        "inactive",
        "stopped"
    ].includes(localMediaStatus) && localMediaOptions) return localMediaOptions;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$5b48ba01602df302
], ({ dispatch: dispatch }, options)=>{
    if (options) dispatch($4fc09928452de42f$export$eb927cdec6bfaecd(options));
});
const $4fc09928452de42f$export$a8fc49bc491506d0 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$6a731d6bc230a245, $4fc09928452de42f$export$5365e4b7f36eeda5, (appIsActive, localMediaStatus, localMediaOptions)=>{
    return !appIsActive && localMediaStatus !== "inactive" && !!localMediaOptions;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$a8fc49bc491506d0
], ({ dispatch: dispatch }, localMediaShouldStop)=>{
    if (localMediaShouldStop) dispatch($4fc09928452de42f$export$85e2dd05688d27d9());
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$ee30c1c2cc195652(previousState);
        const newValue = $4fc09928452de42f$export$ee30c1c2cc195652(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$var$doToggleMicrophone());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$7c06101e124bf472(previousState);
        const newValue = $4fc09928452de42f$export$7c06101e124bf472(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$147a1219e0418788());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const isToggling = $4fc09928452de42f$export$c94b2357b1d094f9(currentState);
        if (isToggling) return false;
        const oldValue = $4fc09928452de42f$export$c8e0d13b9d33fb32(previousState);
        const newValue = $4fc09928452de42f$export$c8e0d13b9d33fb32(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$9933267781a720e());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$9b07214a345a0c2b(previousState);
        const newValue = $4fc09928452de42f$export$9b07214a345a0c2b(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$e35f65b306a0e8f6({
            audio: false,
            video: true
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$15cb5bc234aa0b53(previousState);
        const newValue = $4fc09928452de42f$export$15cb5bc234aa0b53(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$e35f65b306a0e8f6({
            audio: true,
            video: false
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    matcher: (0, $58dad493bd6ec980$export$2c3435c7647f7b0d)($4fc09928452de42f$export$eb927cdec6bfaecd.fulfilled, $4fc09928452de42f$export$24ed9de9cfe6ab93.fulfilled, $4fc09928452de42f$export$128f34559d09c6da.fulfilled, $4fc09928452de42f$export$128f34559d09c6da.rejected),
    effect: (_action, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        const devices = $4fc09928452de42f$export$1a9647721070cccc(state);
        if (!stream) return;
        const deviceData = (0, $1622be301bae0161$export$fb9ff29788bfaf04)({
            audioTrack: stream.getAudioTracks()[0],
            videoTrack: stream.getVideoTracks()[0],
            devices: devices
        });
        dispatch($4fc09928452de42f$export$245247334d37072c(deviceData));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch })=>{
        const { enable: enable } = payload;
        if (!enable) dispatch($4fc09928452de42f$export$11a7008b2ab330c2({
            enabled: false
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch })=>{
        const { enable: enable } = payload;
        if (!enable) dispatch($4fc09928452de42f$export$93cdb5d3b5880a52({
            enabled: false
        }));
    }
});
const $4fc09928452de42f$var$NON_PERSON_ROLES = [
    "recorder",
    "streamer"
];
const $4fc09928452de42f$var$initialState$a = {
    displayName: "",
    id: "",
    isAudioEnabled: true,
    isVideoEnabled: true,
    isLocalParticipant: true,
    stream: undefined,
    isScreenSharing: false,
    roleName: "none",
    clientClaim: undefined,
    stickyReaction: undefined,
    isDialIn: false
};
const $4fc09928452de42f$export$44a9bbc9e703cf3d = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localParticipant",
    initialState: $4fc09928452de42f$var$initialState$a,
    reducers: {
        setDisplayName: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                displayName: action.payload.displayName
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                displayName: action.payload.displayName
            });
        });
        builder.addCase($4fc09928452de42f$export$447462528605c694.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isAudioEnabled: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$5ce66a04faaa2854.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isVideoEnabled: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$5ae150f2ac8c6cf7.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                stickyReaction: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const client = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.clients.find((c)=>{
                var _a;
                return c.id === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.selfId);
            });
            return Object.assign(Object.assign({}, state), {
                id: action.payload.selfId,
                roleName: (client === null || client === void 0 ? void 0 : client.role.roleName) || "none",
                clientClaim: action.payload.clientClaim
            });
        });
    }
});
const { setDisplayName: $4fc09928452de42f$export$ce7d0f83c324f6cf } = $4fc09928452de42f$export$44a9bbc9e703cf3d.actions;
const $4fc09928452de42f$export$9708f9509a207de0 = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("send_client_metadata", {
            type: "UserData",
            payload: {
                displayName: payload.displayName
            }
        });
        dispatch($4fc09928452de42f$export$ce7d0f83c324f6cf({
            displayName: payload.displayName
        }));
    });
const $4fc09928452de42f$export$447462528605c694 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doEnableAudio", (payload, { dispatch: dispatch, getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("enable_audio", {
            enabled: payload.enabled
        });
        if (payload.enabled) dispatch($4fc09928452de42f$export$5ae150f2ac8c6cf7({
            enabled: false
        }));
        return payload.enabled;
    }));
const $4fc09928452de42f$export$5ce66a04faaa2854 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doEnableVideo", (payload, { getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("enable_video", {
            enabled: payload.enabled
        });
        return payload.enabled;
    }));
const $4fc09928452de42f$export$5ae150f2ac8c6cf7 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doSetLocalStickyReaction", (payload, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a;
        const state = getState();
        const currentStickyReaction = $4fc09928452de42f$export$48358a6c3a310d22(state);
        const stickyReactionCurrentlyEnabled = Boolean(currentStickyReaction);
        const enabled = (_a = payload.enabled) !== null && _a !== void 0 ? _a : !stickyReactionCurrentlyEnabled;
        if (enabled === stickyReactionCurrentlyEnabled) return rejectWithValue(currentStickyReaction);
        const stickyReaction = enabled ? {
            reaction: "\u270B",
            timestamp: new Date().toISOString()
        } : null;
        return stickyReaction;
    }));
const $4fc09928452de42f$export$9f6c6ec96c819f3a = $4fc09928452de42f$export$f3d6a2157932333f(()=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const payload = {
            displayName: $4fc09928452de42f$export$60acd18ba1d244f9(state),
            stickyReaction: $4fc09928452de42f$export$48358a6c3a310d22(state)
        };
        socket === null || socket === void 0 || socket.emit("send_client_metadata", {
            type: "UserData",
            payload: payload
        });
    });
const $4fc09928452de42f$export$b8c8b2aa1134778b = (state)=>state.localParticipant;
const $4fc09928452de42f$export$b5166f32e739efd8 = (state)=>state.localParticipant.id;
const $4fc09928452de42f$export$60acd18ba1d244f9 = (state)=>state.localParticipant.displayName;
const $4fc09928452de42f$export$5918f36689139a10 = (state)=>state.localParticipant.clientClaim;
const $4fc09928452de42f$export$c24bfac8c734bcd5 = (state)=>state.localParticipant.isScreenSharing;
const $4fc09928452de42f$export$48358a6c3a310d22 = (state)=>state.localParticipant.stickyReaction;
const $4fc09928452de42f$export$4833cdb2a0a243e3 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$e9c4b1bf93e7c80d, (participant, localStream)=>{
    const clientView = {
        id: participant.id,
        clientId: participant.id,
        displayName: participant.displayName,
        stream: localStream,
        isLocalClient: true,
        isAudioEnabled: participant.isAudioEnabled,
        isVideoEnabled: participant.isVideoEnabled
    };
    if ($4fc09928452de42f$var$NON_PERSON_ROLES.includes(participant.roleName)) return null;
    return clientView;
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$93cdb5d3b5880a52,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enabled: enabled } = payload;
        const { isVideoEnabled: isVideoEnabled } = $4fc09928452de42f$export$b8c8b2aa1134778b(getState());
        dispatch($4fc09928452de42f$export$5ce66a04faaa2854({
            enabled: enabled || !isVideoEnabled
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$11a7008b2ab330c2,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enabled: enabled } = payload;
        const { isAudioEnabled: isAudioEnabled } = $4fc09928452de42f$export$b8c8b2aa1134778b(getState());
        dispatch($4fc09928452de42f$export$447462528605c694({
            enabled: enabled || !isAudioEnabled
        }));
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$60acd18ba1d244f9,
    $4fc09928452de42f$export$48358a6c3a310d22
], ({ dispatch: dispatch })=>{
    dispatch($4fc09928452de42f$export$9f6c6ec96c819f3a());
});
const $4fc09928452de42f$var$initialState$9 = {
    session: null,
    status: "ready",
    error: null
};
const $4fc09928452de42f$export$b633f15c3886bdc9 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$9,
    name: "roomConnection",
    reducers: {
        connectionStatusChanged: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                status: action.payload
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const { error: error, isLocked: isLocked } = action.payload;
            if (error === "room_locked" && isLocked) return Object.assign(Object.assign({}, state), {
                status: "room_locked"
            });
            if (error) return Object.assign(Object.assign({}, state), {
                status: "disconnected",
                error: error
            });
            return Object.assign(Object.assign({}, state), {
                status: "connected",
                session: (_b = (_a = action.payload.room) === null || _a === void 0 ? void 0 : _a.session) !== null && _b !== void 0 ? _b : null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.disconnect, (state)=>{
            if ([
                "kicked",
                "left"
            ].includes(state.status)) return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), {
                status: "disconnected"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, action)=>{
            var _a, _b;
            return Object.assign(Object.assign({}, state), {
                session: (_b = (_a = action.payload.room) === null || _a === void 0 ? void 0 : _a.session) !== null && _b !== void 0 ? _b : null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded, (state, action)=>{
            var _a;
            if (((_a = state.session) === null || _a === void 0 ? void 0 : _a.id) !== action.payload.roomSessionId) return state;
            return Object.assign(Object.assign({}, state), {
                session: null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientKicked, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "kicked"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomLeft, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "left"
            });
        });
        builder.addCase($4fc09928452de42f$export$fb604b2ee1249ba5, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        });
    }
});
const { connectionStatusChanged: $4fc09928452de42f$var$connectionStatusChanged } = $4fc09928452de42f$export$b633f15c3886bdc9.actions;
const $4fc09928452de42f$export$76a4467872ffe125 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const roomName = $4fc09928452de42f$export$2664cf73474d4255(state);
        const roomKey = $4fc09928452de42f$export$4040db2373332c60(state);
        const displayName = $4fc09928452de42f$export$b157fc4c059768ed(state);
        const isDialIn = $4fc09928452de42f$export$442c6682ecfaaef2(state);
        const userAgent = $4fc09928452de42f$export$6f409a475b0c8c60(state);
        const externalId = $4fc09928452de42f$export$44202ee237048d77(state);
        const organizationId = $4fc09928452de42f$export$7ba530130176c5b4(state);
        const connectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
        if (connectionStatus !== "room_locked") {
            console.warn("Room is not locked, knock aborted");
            return;
        }
        socket === null || socket === void 0 || socket.emit("knock_room", {
            avatarUrl: null,
            config: {
                isAudioEnabled: true,
                isVideoEnabled: true
            },
            deviceCapabilities: {
                canScreenshare: true
            },
            displayName: displayName,
            isCoLocated: false,
            isDialIn: isDialIn,
            isDevicePermissionDenied: false,
            kickFromOtherRooms: false,
            organizationId: organizationId,
            roomKey: roomKey,
            roomName: roomName,
            userAgent: userAgent,
            externalId: externalId
        });
        dispatch($4fc09928452de42f$var$connectionStatusChanged("knocking"));
    });
const $4fc09928452de42f$export$1cae1f7f973558d2 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const roomName = $4fc09928452de42f$export$2664cf73474d4255(state);
        const roomKey = $4fc09928452de42f$export$4040db2373332c60(state);
        const displayName = $4fc09928452de42f$export$b157fc4c059768ed(state);
        const userAgent = $4fc09928452de42f$export$6f409a475b0c8c60(state);
        const externalId = $4fc09928452de42f$export$44202ee237048d77(state);
        const isDialIn = $4fc09928452de42f$export$442c6682ecfaaef2(state);
        const organizationId = $4fc09928452de42f$export$7ba530130176c5b4(state);
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(getState());
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(getState());
        const clientClaim = $4fc09928452de42f$export$5918f36689139a10(getState());
        socket === null || socket === void 0 || socket.emit("join_room", Object.assign({
            avatarUrl: null,
            config: {
                isAudioEnabled: isMicrophoneEnabled,
                isVideoEnabled: isCameraEnabled
            },
            deviceCapabilities: {
                canScreenshare: true
            },
            displayName: displayName,
            isCoLocated: false,
            isDialIn: isDialIn,
            isDevicePermissionDenied: false,
            kickFromOtherRooms: false,
            organizationId: organizationId,
            roomKey: roomKey,
            roomName: roomName,
            userAgent: userAgent,
            externalId: externalId
        }, clientClaim && {
            clientClaim: clientClaim
        }));
        dispatch($4fc09928452de42f$var$connectionStatusChanged("connecting"));
    });
const $4fc09928452de42f$export$a0307ec948127543 = (state)=>state.roomConnection;
const $4fc09928452de42f$export$227550b00aed9e8b = (state)=>state.roomConnection.session;
const $4fc09928452de42f$export$9b6909335b1f6412 = (state)=>{
    var _a;
    return (_a = state.roomConnection.session) === null || _a === void 0 ? void 0 : _a.id;
};
const $4fc09928452de42f$export$22f0decfe3c779cc = (state)=>state.roomConnection.status;
const $4fc09928452de42f$export$b21080781118639a = (state)=>state.roomConnection.error;
const $4fc09928452de42f$export$8c54b9eb079d5771 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)([
    $4fc09928452de42f$export$ae5e487c0972282e,
    $4fc09928452de42f$export$7ba530130176c5b4,
    $4fc09928452de42f$export$22f0decfe3c779cc,
    $4fc09928452de42f$export$f861d0329c5966c4,
    $4fc09928452de42f$export$6a731d6bc230a245,
    $4fc09928452de42f$export$b21080781118639a
], (appIsActive, hasOrganizationIdFetched, roomConnectionStatus, signalConnectionDeviceIdentified, localMediaStatus, roomConnectionError)=>{
    if (appIsActive && localMediaStatus === "started" && signalConnectionDeviceIdentified && !!hasOrganizationIdFetched && [
        "ready",
        "reconnecting",
        "disconnected"
    ].includes(roomConnectionStatus) && !roomConnectionError) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$8c54b9eb079d5771
], ({ dispatch: dispatch }, shouldConnectRoom)=>{
    if (shouldConnectRoom) dispatch($4fc09928452de42f$export$1cae1f7f973558d2());
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.knockHandled,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { clientId: clientId, resolution: resolution } = payload;
        const state = getState();
        const selfId = $4fc09928452de42f$export$b5166f32e739efd8(state);
        if (clientId !== selfId) return;
        if (resolution === "accepted") {
            dispatch($4fc09928452de42f$export$4aa6cbb228087bb(payload.metadata.roomKey));
            dispatch($4fc09928452de42f$export$1cae1f7f973558d2());
        } else if (resolution === "rejected") dispatch($4fc09928452de42f$var$connectionStatusChanged("knock_rejected"));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$d4d0f76450fb6374,
    effect: (_, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const roomConnectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
        if (roomConnectionStatus === "connected") {
            const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
            socket === null || socket === void 0 || socket.emit("leave_room");
            dispatch($4fc09928452de42f$var$connectionStatusChanged("leaving"));
        } else $4fc09928452de42f$export$662ce9a66e2e97d8();
    }
});
function $4fc09928452de42f$var$createRtcEventAction(name) {
    return (0, $58dad493bd6ec980$export$309c7a02b0b0bc62)(`rtcConnection/event/${name}`);
}
const $4fc09928452de42f$var$rtcEvents = {
    rtcManagerCreated: $4fc09928452de42f$var$createRtcEventAction("rtcManagerCreated"),
    rtcManagerDestroyed: $4fc09928452de42f$var$createRtcEventAction("rtcManagerDestroyed"),
    streamAdded: $4fc09928452de42f$var$createRtcEventAction("streamAdded")
};
function $4fc09928452de42f$var$createRemoteParticipant(client, newJoiner = false) {
    const { streams: streams, role: role } = client, rest = $4fc09928452de42f$var$__rest(client, [
        "streams",
        "role"
    ]);
    return Object.assign(Object.assign({}, rest), {
        stream: null,
        streams: streams.map((streamId)=>({
                id: streamId,
                state: newJoiner ? "new_accept" : "to_accept"
            })),
        isLocalParticipant: false,
        roleName: (role === null || role === void 0 ? void 0 : role.roleName) || "none",
        presentationStream: null,
        newJoiner: newJoiner
    });
}
function $4fc09928452de42f$var$findParticipant(state, participantId) {
    const index = state.remoteParticipants.findIndex((c)=>c.id === participantId);
    return {
        index: index,
        participant: state.remoteParticipants[index]
    };
}
function $4fc09928452de42f$var$updateParticipant(state, participantId, updates) {
    const { participant: participant, index: index } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`Did not find client for update ${participantId}`);
        return state;
    }
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: [
            ...state.remoteParticipants.slice(0, index),
            Object.assign(Object.assign({}, participant), updates),
            ...state.remoteParticipants.slice(index + 1)
        ]
    });
}
function $4fc09928452de42f$var$addParticipant(state, participant) {
    const { participant: foundParticipant } = $4fc09928452de42f$var$findParticipant(state, participant.id);
    if (foundParticipant) {
        console.warn(`Client already existing ${participant.id}. Ignoring`);
        return state;
    }
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: [
            ...state.remoteParticipants,
            participant
        ]
    });
}
function $4fc09928452de42f$var$updateStreamState(state, participantId, streamId, state_) {
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`No client ${participantId} found to update stream ${streamId} ${state_}`);
        return state;
    }
    const idIdx = participant.streams.findIndex((s)=>s.id === streamId);
    const streams = [
        ...participant.streams
    ];
    streams[idIdx] = Object.assign(Object.assign({}, streams[idIdx]), {
        state: state_
    });
    return $4fc09928452de42f$var$updateParticipant(state, participantId, {
        streams: streams
    });
}
function $4fc09928452de42f$var$removeClient(state, participantId) {
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: state.remoteParticipants.filter((c)=>c.id !== participantId)
    });
}
function $4fc09928452de42f$var$addStreamId(state, participantId, streamId) {
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant || participant.streams.find((s)=>s.id === streamId)) {
        console.warn(`No participant ${participantId} or stream ${streamId} already exists`);
        return state;
    }
    return $4fc09928452de42f$var$updateParticipant(state, participantId, {
        streams: [
            ...participant.streams,
            {
                id: streamId,
                state: "to_accept"
            }
        ]
    });
}
function $4fc09928452de42f$var$removeStreamId(state, participantId, streamId) {
    var _a, _b;
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`No participant ${participantId} found to remove stream ${streamId}`);
        return state;
    }
    const currentStreamId = participant.stream && participant.stream.id;
    const presentationId = ((_a = participant.presentationStream) === null || _a === void 0 ? void 0 : _a.inboundId) || ((_b = participant.presentationStream) === null || _b === void 0 ? void 0 : _b.id);
    const idIdx = participant.streams.findIndex((s)=>s.id === streamId);
    return $4fc09928452de42f$var$updateParticipant(state, participantId, Object.assign(Object.assign({
        streams: participant.streams.filter((_, i)=>i !== idIdx)
    }, currentStreamId === streamId && {
        stream: null
    }), presentationId === streamId && {
        presentationStream: null
    }));
}
function $4fc09928452de42f$var$addStream(state, payload) {
    const { clientId: clientId, stream: stream, streamType: streamType } = payload;
    let { streamId: streamId } = payload;
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, clientId);
    if (!participant) {
        console.error(`Did not find client ${clientId} for adding stream`);
        return state;
    }
    const remoteParticipants = state.remoteParticipants;
    if (!streamId) streamId = stream.id;
    const remoteParticipant = remoteParticipants.find((p)=>p.id === clientId);
    if (!remoteParticipant) return state;
    const remoteParticipantStream = remoteParticipant.streams.find((s)=>s.id === streamId);
    if (remoteParticipant.stream && (remoteParticipant.stream.id === streamId || remoteParticipant.stream.inboundId === streamId) || !remoteParticipant.stream && streamType === "webcam" || !remoteParticipant.stream && !streamType && !remoteParticipantStream) return $4fc09928452de42f$var$updateParticipant(state, clientId, {
        stream: stream
    });
    return $4fc09928452de42f$var$updateParticipant(state, clientId, {
        presentationStream: stream
    });
}
const $4fc09928452de42f$var$initialState$8 = {
    remoteParticipants: []
};
const $4fc09928452de42f$export$b64ee0f1b6392800 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "remoteParticipants",
    initialState: $4fc09928452de42f$var$initialState$8,
    reducers: {
        streamStatusUpdated: (state, action)=>{
            let newState = state;
            for (const { clientId: clientId, streamId: streamId, state: state } of action.payload)newState = $4fc09928452de42f$var$updateStreamState(newState, clientId, streamId, state);
            return newState;
        },
        participantStreamAdded: (state, action)=>{
            const { clientId: clientId, stream: stream } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                stream: stream
            });
        },
        participantStreamIdAdded: (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$addStreamId(state, clientId, streamId);
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a;
            if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.room)) return state;
            const selfId = action.payload.selfId;
            const { clients: clients } = action.payload.room;
            return Object.assign(Object.assign({}, state), {
                remoteParticipants: clients.filter((c)=>c.id !== selfId).map((c)=>$4fc09928452de42f$var$createRemoteParticipant(c))
            });
        });
        builder.addCase($4fc09928452de42f$var$rtcEvents.streamAdded, (state, action)=>{
            return $4fc09928452de42f$var$addStream(state, action.payload);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, action)=>{
            const { client: client } = action.payload;
            return $4fc09928452de42f$var$addParticipant(state, $4fc09928452de42f$var$createRemoteParticipant(client, true));
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientLeft, (state, action)=>{
            const { clientId: clientId } = action.payload;
            return $4fc09928452de42f$var$removeClient(state, clientId);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.audioEnabled, (state, action)=>{
            const { clientId: clientId, isAudioEnabled: isAudioEnabled } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                isAudioEnabled: isAudioEnabled
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.videoEnabled, (state, action)=>{
            const { clientId: clientId, isVideoEnabled: isVideoEnabled } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                isVideoEnabled: isVideoEnabled
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived, (state, action)=>{
            const { error: error, payload: payload } = action.payload;
            if (error || !payload) {
                console.warn(error || "Client metadata error received");
                return state;
            }
            const { clientId: clientId, displayName: displayName, stickyReaction: stickyReaction } = payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                displayName: displayName,
                stickyReaction: stickyReaction
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.screenshareStarted, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$addStreamId(state, clientId, streamId);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.screenshareStopped, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$removeStreamId(state, clientId, streamId);
        });
    }
});
const { participantStreamAdded: $4fc09928452de42f$export$c70b9874f9435dd5, participantStreamIdAdded: $4fc09928452de42f$export$60ba62dc71537bc0, streamStatusUpdated: $4fc09928452de42f$export$b7fd18e34f4b09b4 } = $4fc09928452de42f$export$b64ee0f1b6392800.actions;
const $4fc09928452de42f$export$d0f9ccaaa3a15b4c = $4fc09928452de42f$export$8ffe952306980b53((state)=>$4fc09928452de42f$export$a15ccd242dd0951b(state), (payload)=>(_, getState)=>{
        const state = getState();
        const canEnableRemoteAudio = $4fc09928452de42f$export$c53e10fe73bac35f(state);
        if (payload.enable && !canEnableRemoteAudio) {
            console.warn("Not authorized to perform this action");
            return;
        }
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("request_audio_enable", payload);
    });
const $4fc09928452de42f$export$f7fc15880c03e2a3 = $4fc09928452de42f$export$8ffe952306980b53((state)=>$4fc09928452de42f$export$84f3acf25e9c1055(state), (payload)=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("request_video_enable", payload);
    });
const $4fc09928452de42f$export$6e0231f052a79a5 = (state)=>state.remoteParticipants;
const $4fc09928452de42f$export$32b66667e0002c3f = (state)=>state.remoteParticipants.remoteParticipants;
const $4fc09928452de42f$export$f97faf20840c4b0c = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$32b66667e0002c3f, (clients)=>clients.filter((c)=>!$4fc09928452de42f$var$NON_PERSON_ROLES.includes(c.roleName)));
const $4fc09928452de42f$export$c46fa984baba97ca = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$32b66667e0002c3f, (clients)=>clients.length + 1);
const $4fc09928452de42f$export$2a789fd8acb91b21 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$f97faf20840c4b0c, $4fc09928452de42f$export$b8c8b2aa1134778b, (clients, localParticipant)=>{
    if ($4fc09928452de42f$var$NON_PERSON_ROLES.includes(localParticipant.roleName)) return clients.length;
    return clients.length + 1;
});
const $4fc09928452de42f$var$initialState$7 = {
    status: "inactive",
    stream: null,
    error: null
};
const $4fc09928452de42f$export$8e6b4a78bd959605 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localScreenshare",
    initialState: $4fc09928452de42f$var$initialState$7,
    reducers: {
        stopScreenshare (state, action) {
            return Object.assign(Object.assign({}, state), {
                status: "inactive",
                stream: null
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "starting"
            });
        });
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.fulfilled, (state, { payload: { stream: stream } })=>{
            return Object.assign(Object.assign({}, state), {
                status: "active",
                stream: stream
            });
        });
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.rejected, (state, { payload: payload })=>{
            return Object.assign(Object.assign({}, state), {
                error: payload,
                status: "inactive",
                stream: null
            });
        });
    }
});
const { stopScreenshare: $4fc09928452de42f$export$f8682e9675cc7fb7 } = $4fc09928452de42f$export$8e6b4a78bd959605.actions;
const $4fc09928452de42f$export$ad4f97fa7081697c = $4fc09928452de42f$export$7a92a3664c4cb7d1("localScreenshare/doStartScreenshare", (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a;
        try {
            const state = getState();
            const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
            if (screenshareStream) return {
                stream: screenshareStream
            };
            const stream = yield navigator.mediaDevices.getDisplayMedia();
            const onEnded = ()=>{
                dispatch($4fc09928452de42f$export$a42cf8a339c4d2f7());
            };
            if ("oninactive" in stream) stream.addEventListener("inactive", onEnded);
            else (_a = stream.getVideoTracks()[0]) === null || _a === void 0 || _a.addEventListener("ended", onEnded);
            return {
                stream: stream
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$a42cf8a339c4d2f7 = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
        if (!screenshareStream) return;
        screenshareStream.getTracks().forEach((track)=>track.stop());
        dispatch($4fc09928452de42f$export$f8682e9675cc7fb7({
            stream: screenshareStream
        }));
    });
const $4fc09928452de42f$export$a859939b0ddea87e = (state)=>state.localScreenshare;
const $4fc09928452de42f$export$ed90fffaa8c7fc13 = (state)=>state.localScreenshare.status;
const $4fc09928452de42f$export$6b29f1ceafb4e0c4 = (state)=>state.localScreenshare.stream;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$9492753e9267457d,
    effect: (_, { getState: getState })=>{
        const state = getState();
        const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
        if (!screenshareStream) return;
        screenshareStream === null || screenshareStream === void 0 || screenshareStream.getTracks().forEach((track)=>{
            track.stop();
        });
    }
});
const $4fc09928452de42f$export$4992adcf1f5b37c0 = (dispatch)=>{
    return {
        emit: (eventName, data)=>{
            if (eventName === "rtc_manager_created") dispatch($4fc09928452de42f$export$8b2ef60a5a8950d4(data));
            else if (eventName === "stream_added") dispatch($4fc09928452de42f$var$rtcEvents.streamAdded(data));
            else if (eventName === "rtc_manager_destroyed") dispatch($4fc09928452de42f$export$ba2a98274508d9fd());
        }
    };
};
const $4fc09928452de42f$var$initialState$6 = {
    dispatcherCreated: false,
    error: null,
    isCreatingDispatcher: false,
    reportedStreamResolutions: {},
    rtcManager: null,
    rtcManagerDispatcher: null,
    rtcManagerInitialized: false,
    status: "inactive",
    isAcceptingStreams: false
};
const $4fc09928452de42f$export$e0e4df945a3863bd = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "rtcConnection",
    initialState: $4fc09928452de42f$var$initialState$6,
    reducers: {
        isAcceptingStreams: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isAcceptingStreams: action.payload
            });
        },
        resolutionReported: (state, action)=>{
            const { streamId: streamId, width: width, height: height } = action.payload;
            return Object.assign(Object.assign({}, state), {
                reportedStreamResolutions: Object.assign(Object.assign({}, state.reportedStreamResolutions), {
                    [streamId]: {
                        width: width,
                        height: height
                    }
                })
            });
        },
        rtcDisconnected: ()=>{
            return Object.assign({}, $4fc09928452de42f$var$initialState$6);
        },
        rtcDispatcherCreated: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                dispatcherCreated: true,
                rtcManagerDispatcher: action.payload
            });
        },
        rtcManagerCreated: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManager: action.payload,
                status: "ready"
            });
        },
        rtcManagerDestroyed: (state)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManager: null
            });
        },
        rtcManagerInitialized: (state)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManagerInitialized: true
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$fb604b2ee1249ba5, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: state.status === "reconnecting" ? "ready" : state.status
            });
        });
    }
});
const { resolutionReported: $4fc09928452de42f$export$4cadac3c05692cdb, rtcDispatcherCreated: $4fc09928452de42f$export$7a0b43c0495fba52, rtcDisconnected: $4fc09928452de42f$export$5217960ace5421a9, rtcManagerCreated: $4fc09928452de42f$export$c62cff42a3450ffb, rtcManagerDestroyed: $4fc09928452de42f$export$ba2a98274508d9fd, rtcManagerInitialized: $4fc09928452de42f$export$11ea47042ef03feb, isAcceptingStreams: $4fc09928452de42f$export$4b7d734e80c97474 } = $4fc09928452de42f$export$e0e4df945a3863bd.actions;
const $4fc09928452de42f$export$57f3bfac00ca31be = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const dispatcher = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManagerDispatcher;
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
        const isNodeSdk = $4fc09928452de42f$export$ab78798f462babdb(state);
        if (dispatcher || !socket) return;
        const webrtcProvider = {
            getMediaConstraints: ()=>({
                    audio: isMicrophoneEnabled,
                    video: isCameraEnabled
                }),
            deferrable (clientId) {
                return !clientId;
            }
        };
        const rtcManagerDispatcher = new (0, $1622be301bae0161$export$b281485fb0422c89)({
            emitter: $4fc09928452de42f$export$4992adcf1f5b37c0(dispatch),
            serverSocket: socket,
            webrtcProvider: webrtcProvider,
            features: {
                isNodeSdk: isNodeSdk,
                lowDataModeEnabled: false,
                sfuServerOverrideHost: undefined,
                turnServerOverrideHost: undefined,
                useOnlyTURN: undefined,
                vp9On: false,
                h264On: false,
                simulcastScreenshareOn: false,
                deviceHandlerFactory: isNodeSdk ? (0, $cqkQU.Safari12).createFactory() : undefined
            }
        });
        dispatch($4fc09928452de42f$export$7a0b43c0495fba52(rtcManagerDispatcher));
    });
const $4fc09928452de42f$export$a699976615c38365 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        if (rtcManager) rtcManager.disconnectAll();
        dispatch($4fc09928452de42f$export$5217960ace5421a9());
    });
const $4fc09928452de42f$export$604759fde97f2d1e = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState)=>{
        var _a;
        dispatch($4fc09928452de42f$export$4b7d734e80c97474(true));
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        const remoteClients = $4fc09928452de42f$export$32b66667e0002c3f(state);
        if (!rtcManager) throw new Error("No rtc manager");
        const activeBreakout = false;
        const shouldAcceptNewClients = (_a = rtcManager.shouldAcceptStreamsFromBothSides) === null || _a === void 0 ? void 0 : _a.call(rtcManager);
        const updates = [];
        for (const { clientId: clientId, streamId: streamId, state: state } of payload){
            const participant = remoteClients.find((p)=>p.id === clientId);
            if (!participant) continue;
            if (state === "to_accept" || state === "new_accept" && shouldAcceptNewClients || state === "old_accept" && !shouldAcceptNewClients) rtcManager.acceptNewStream({
                streamId: streamId === "0" ? clientId : streamId,
                clientId: clientId,
                shouldAddLocalVideo: streamId === "0",
                activeBreakout: activeBreakout
            });
            else if (state === "new_accept" || state === "old_accept") ;
            else if (state === "to_unaccept") rtcManager === null || rtcManager === void 0 || rtcManager.disconnect(streamId === "0" ? clientId : streamId, activeBreakout);
            else if (state !== "done_accept") continue;
            updates.push({
                clientId: clientId,
                streamId: streamId,
                state: state.replace(/to_|new_|old_/, "done_")
            });
        }
        dispatch($4fc09928452de42f$export$b7fd18e34f4b09b4(updates));
        dispatch($4fc09928452de42f$export$4b7d734e80c97474(false));
    });
const $4fc09928452de42f$export$8e38e4b6fee98ae8 = $4fc09928452de42f$export$495454f275c5f192(({ streamId: streamId, width: width, height: height })=>(dispatch, getState)=>{
        const { reportedStreamResolutions: reportedStreamResolutions, rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        const localStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        if (!rtcManager || (localStream === null || localStream === void 0 ? void 0 : localStream.id) === streamId) return;
        const old = reportedStreamResolutions[streamId];
        if (!old || old.width !== width || old.height !== height) rtcManager.updateStreamResolution(streamId, null, {
            width: width || 1,
            height: height || 1
        });
        dispatch($4fc09928452de42f$export$4cadac3c05692cdb({
            streamId: streamId,
            width: width,
            height: height
        }));
    });
const $4fc09928452de42f$export$8b2ef60a5a8950d4 = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch)=>{
        const { rtcManager: rtcManager } = payload;
        dispatch($4fc09928452de42f$export$c62cff42a3450ffb(rtcManager));
    });
const $4fc09928452de42f$export$9ccbbc280e138aa0 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const localMediaStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(getState()).rtcManager;
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(getState());
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(getState());
        if (localMediaStream && rtcManager) rtcManager.addNewStream("0", localMediaStream, !isMicrophoneEnabled, !isCameraEnabled);
        dispatch($4fc09928452de42f$export$11ea47042ef03feb());
    });
const $4fc09928452de42f$export$a18c733277909ffc = (state)=>state.rtcConnection;
const $4fc09928452de42f$export$70908e8ca7bafd4f = (state)=>state.rtcConnection.rtcManagerInitialized;
const $4fc09928452de42f$export$e04886b22fca6173 = (state)=>state.rtcConnection.rtcManager;
const $4fc09928452de42f$export$49c8dd8411697335 = (state)=>state.rtcConnection.dispatcherCreated;
const $4fc09928452de42f$export$8472039214e0ccef = (state)=>state.rtcConnection.isCreatingDispatcher;
const $4fc09928452de42f$export$fea824bf20fd1f4d = (state)=>state.rtcConnection.status;
const $4fc09928452de42f$export$e4d4bbfda138e686 = (state)=>state.rtcConnection.isAcceptingStreams;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { replacedTracks: replacedTracks } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const replace = (kind, oldTrack)=>{
            const track = stream === null || stream === void 0 ? void 0 : stream.getTracks().find((t)=>t.kind === kind);
            return track && (rtcManager === null || rtcManager === void 0 ? void 0 : rtcManager.replaceTrack(oldTrack, track));
        };
        replacedTracks === null || replacedTracks === void 0 || replacedTracks.forEach((t)=>{
            replace(t.kind, t);
        });
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { stream: stream } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.addNewStream(stream.id, stream, false, true);
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$d4d0f76450fb6374,
    effect: (_, { getState: getState })=>{
        const rtcManager = $4fc09928452de42f$export$e04886b22fca6173(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.rtcStatsDisconnect();
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$f8682e9675cc7fb7,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { stream: stream } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.removeStream(stream.id, stream, null);
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$128f34559d09c6da.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        var _a;
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        if (stream && rtcManager) {
            const replace = (kind, oldTrack)=>{
                const track = stream.getTracks().find((t)=>t.kind === kind);
                return track && rtcManager.replaceTrack(oldTrack, track);
            };
            (_a = payload === null || payload === void 0 ? void 0 : payload.replacedTracks) === null || _a === void 0 || _a.forEach((t)=>{
                replace(t.kind, t);
            });
        }
    }
});
const $4fc09928452de42f$export$e94dcb9ad830cecb = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$49c8dd8411697335, $4fc09928452de42f$export$8472039214e0ccef, $4fc09928452de42f$export$efc69c8f0644aa20, (rtcStatus, appIsActive, dispatcherCreated, isCreatingDispatcher, signalSocket)=>{
    if (appIsActive && rtcStatus === "inactive" && !dispatcherCreated && !isCreatingDispatcher && signalSocket) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e94dcb9ad830cecb
], ({ dispatch: dispatch }, shouldConnectRtc)=>{
    if (shouldConnectRtc) dispatch($4fc09928452de42f$export$57f3bfac00ca31be());
});
const $4fc09928452de42f$export$44d04d69c6e600df = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$e04886b22fca6173, $4fc09928452de42f$export$70908e8ca7bafd4f, $4fc09928452de42f$export$6a731d6bc230a245, (rtcManager, rtcManagerInitialized, localMediaStatus)=>{
    if (localMediaStatus === "started" && rtcManager && !rtcManagerInitialized) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$44d04d69c6e600df
], ({ dispatch: dispatch }, shouldInitializeRtc)=>{
    if (shouldInitializeRtc) dispatch($4fc09928452de42f$export$9ccbbc280e138aa0());
});
const $4fc09928452de42f$export$10c6c710ffdd45f9 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$ae5e487c0972282e, (status, appIsActive)=>{
    if (!appIsActive && ![
        "inactive",
        "disconnected"
    ].includes(status)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$10c6c710ffdd45f9
], ({ dispatch: dispatch }, shouldDisconnectRtc)=>{
    if (shouldDisconnectRtc) dispatch($4fc09928452de42f$export$a699976615c38365());
});
const $4fc09928452de42f$export$e3dc5cd79b27652 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$32b66667e0002c3f, (rtcStatus, remoteParticipants)=>{
    if (rtcStatus !== "ready") return [];
    const upd = [];
    for (const client of remoteParticipants){
        const { streams: streams, id: clientId, newJoiner: newJoiner } = client;
        for(let i = 0; i < streams.length; i++){
            let streamId = streams[i].id;
            let state = streams[i].state;
            if ((streams === null || streams === void 0 ? void 0 : streams.length) > 1 && streams[1].id === "0") {
                if (i === 0) {
                    streamId = streams[1].id;
                    state = streams[1].state;
                } else if (i === 1) {
                    streamId = streams[0].id;
                    state = streams[0].state;
                }
            }
            if (state === "done_accept") continue;
            upd.push({
                clientId: clientId,
                streamId: streamId,
                state: `${newJoiner && streamId === "0" ? "new" : "to"}_accept`
            });
        }
    }
    return upd;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e3dc5cd79b27652,
    $4fc09928452de42f$export$e4d4bbfda138e686
], ({ dispatch: dispatch }, streamsToAccept, isAcceptingStreams)=>{
    if (0 < streamsToAccept.length && !isAcceptingStreams) dispatch($4fc09928452de42f$export$604759fde97f2d1e(streamsToAccept));
});
function $4fc09928452de42f$var$isStreamerClient(client) {
    return client.roleName === "streamer";
}
function $4fc09928452de42f$var$isRecorderClient(client) {
    return client.roleName === "recorder";
}
const $4fc09928452de42f$var$initialState$5 = {
    isLocked: false
};
const $4fc09928452de42f$export$9ce7dca4f26ff3bd = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "room",
    initialState: $4fc09928452de42f$var$initialState$5,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            const { error: error, isLocked: isLocked } = action.payload;
            if (error) return state;
            return Object.assign(Object.assign({}, state), {
                isLocked: Boolean(isLocked)
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomLocked, (state, action)=>{
            const { isLocked: isLocked } = action.payload;
            return Object.assign(Object.assign({}, state), {
                isLocked: Boolean(isLocked)
            });
        });
    }
});
const $4fc09928452de42f$export$9eb5fcf87b4704f2 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$dbb7a81a8f843adc(state), (payload)=>(_, getState)=>{
        const state = getState();
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        socket === null || socket === void 0 || socket.emit("set_lock", {
            locked: payload.locked
        });
    });
const $4fc09928452de42f$export$d5359451ea4b2b4a = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$e73be439ab5a8e31(state), (payload)=>(_, getState)=>{
        const state = getState();
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        socket === null || socket === void 0 || socket.emit("kick_client", {
            clientId: payload.clientId,
            reasonId: "kick"
        });
    });
const $4fc09928452de42f$export$50d90cb8a8eda648 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$69a43832a7c34f54(state), (payload)=>(dispatch, getState)=>{
        const state = getState();
        const clientsToKick = $4fc09928452de42f$export$32b66667e0002c3f(state).map((c)=>c.id);
        if (clientsToKick.length) {
            const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
            socket === null || socket === void 0 || socket.emit("kick_client", {
                clientIds: clientsToKick,
                reasonId: "end-meeting"
            });
        }
        if (!payload.stayBehind) dispatch($4fc09928452de42f$export$d4d0f76450fb6374());
    });
const $4fc09928452de42f$export$f01656cae83dc9e8 = (state)=>state.room.isLocked;
const $4fc09928452de42f$export$5d9bde7516ef4510 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6b29f1ceafb4e0c4, $4fc09928452de42f$export$f97faf20840c4b0c, (localScreenshareStream, remoteParticipants)=>{
    const screenshares = [];
    if (localScreenshareStream) screenshares.push({
        id: localScreenshareStream.id || "local-screenshare",
        participantId: "local",
        hasAudioTrack: localScreenshareStream.getTracks().some((track)=>track.kind === "audio"),
        stream: localScreenshareStream,
        isLocal: true
    });
    for (const participant of remoteParticipants)if (participant.presentationStream) screenshares.push({
        id: participant.presentationStream.id || `pres-${participant.id}`,
        participantId: participant.id,
        hasAudioTrack: participant.presentationStream.getTracks().some((track)=>track.kind === "audio"),
        stream: participant.presentationStream,
        isLocal: false
    });
    return screenshares;
});
const $4fc09928452de42f$export$a16d30bbc7ea403f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6b29f1ceafb4e0c4, $4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$f97faf20840c4b0c, (localScreenshareStream, localParticipant, remoteParticipants)=>{
    const views = [];
    if (localScreenshareStream) {
        const isScreenshareAudioEnabled = !!localScreenshareStream.getAudioTracks().length;
        views.push({
            clientId: localParticipant.id,
            displayName: "Your screenshare",
            id: "local-screenshare",
            isAudioEnabled: isScreenshareAudioEnabled,
            isLocalClient: true,
            isPresentation: true,
            isVideoEnabled: true,
            stream: localScreenshareStream
        });
    }
    for (const c of remoteParticipants){
        if ($4fc09928452de42f$var$isStreamerClient(c) || $4fc09928452de42f$var$isRecorderClient(c)) continue;
        const { presentationStream: presentationStream } = c, clientView = $4fc09928452de42f$var$__rest(c, [
            "presentationStream"
        ]);
        const displayName = c.displayName || "Guest";
        const isPresentationActive = presentationStream && presentationStream.active;
        const presentationId = "pres-" + c.id;
        const isStreamActive = c.stream && c.stream.active;
        const isVideoEnabled = c.isVideoEnabled;
        views.push(Object.assign(Object.assign(Object.assign({}, clientView), {
            clientId: c.id,
            displayName: displayName,
            hasActivePresentation: !!isPresentationActive
        }), c.isVideoEnabled ? {
            isVideoEnabled: isVideoEnabled
        } : {}));
        if (isPresentationActive) views.push(Object.assign(Object.assign(Object.assign({}, clientView), {
            clientId: c.id,
            stream: c.presentationStream,
            displayName: `Screenshare (${displayName})`,
            id: presentationId,
            isPresentation: true,
            isVideoEnabled: true
        }), isStreamActive && {
            isRecording: null
        }));
    }
    return views;
});
const $4fc09928452de42f$export$dc94230bce59ebc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$4833cdb2a0a243e3, $4fc09928452de42f$export$a16d30bbc7ea403f, (localParticipant, remoteParticipants)=>{
    return [
        ...localParticipant ? [
            localParticipant
        ] : [],
        ...remoteParticipants
    ];
});
const $4fc09928452de42f$var$initialState$4 = {
    running: false
};
const $4fc09928452de42f$export$f9b8189900b9396b = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "connectionMonitor",
    initialState: $4fc09928452de42f$var$initialState$4,
    reducers: {
        connectionMonitorStarted: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                running: true,
                stopCallbackFunction: action.payload.stopIssueSubscription
            });
        },
        connectionMonitorStopped: ()=>{
            return Object.assign({}, $4fc09928452de42f$var$initialState$4);
        }
    }
});
const { connectionMonitorStarted: $4fc09928452de42f$export$6e7b2c1ea42955c6, connectionMonitorStopped: $4fc09928452de42f$export$193ab7b33bc455e0 } = $4fc09928452de42f$export$f9b8189900b9396b.actions;
const $4fc09928452de42f$export$2ddc2b20a645263b = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        (0, $1622be301bae0161$export$591e741f8b7f4720)(()=>{
            const state = getState();
            const clientViews = $4fc09928452de42f$export$dc94230bce59ebc(state).map((clientView)=>{
                var _a, _b;
                return {
                    id: clientView.id,
                    clientId: clientView.clientId,
                    isLocalClient: clientView.isLocalClient,
                    audio: {
                        enabled: clientView.isAudioEnabled,
                        track: (_a = clientView.stream) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0]
                    },
                    video: {
                        enabled: clientView.isVideoEnabled,
                        track: (_b = clientView.stream) === null || _b === void 0 ? void 0 : _b.getVideoTracks()[0]
                    },
                    isPresentation: clientView.isPresentation
                };
            });
            return clientViews;
        });
        const issueMonitorSubscription = (0, $1622be301bae0161$export$d2b2fe7aff003090)({
            onUpdatedIssues: (issuesAndMetricsByClients)=>{
                var _a;
                const state = getState();
                const rtcManager = $4fc09928452de42f$export$e04886b22fca6173(state);
                if (!rtcManager) return;
                let lossSend = 0;
                let lossReceive = 0;
                let bitrateSend = 0;
                let bitrateReceive = 0;
                Object.entries(issuesAndMetricsByClients.aggregated.metrics).forEach(([key, value])=>{
                    if (/loc.*packetloss/.test(key)) lossSend = Math.max(lossSend, value.curMax);
                    if (/rem.*packetloss/.test(key)) lossReceive = Math.max(lossReceive, value.curMax);
                    if (/loc.*bitrate/.test(key)) bitrateSend += value.curSum;
                    if (/rem.*bitrate/.test(key)) bitrateReceive += value.curSum;
                });
                rtcManager.sendStatsCustomEvent("insightsStats", {
                    ls: Math.round(lossSend * 1000) / 1000,
                    lr: Math.round(lossReceive * 1000) / 1000,
                    bs: Math.round(bitrateSend),
                    br: Math.round(bitrateReceive),
                    cpu: (_a = issuesAndMetricsByClients.aggregated.metrics["global-cpu-pressure"]) === null || _a === void 0 ? void 0 : _a.curSum,
                    _time: Date.now()
                });
            }
        });
        dispatch($4fc09928452de42f$export$6e7b2c1ea42955c6({
            stopIssueSubscription: issueMonitorSubscription.stop
        }));
    });
const $4fc09928452de42f$export$54c371d7bcfcc11 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const stopCallbackFn = $4fc09928452de42f$export$be63b6e9f8d28401(state);
        if (stopCallbackFn) stopCallbackFn();
        dispatch($4fc09928452de42f$export$193ab7b33bc455e0());
    });
const $4fc09928452de42f$export$d2585f2d4e06cb7f = (state)=>state.connectionMonitor.running;
const $4fc09928452de42f$export$be63b6e9f8d28401 = (state)=>state.connectionMonitor.stopCallbackFunction;
const $4fc09928452de42f$export$565061e76fcf0d54 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$22f0decfe3c779cc, $4fc09928452de42f$export$d2585f2d4e06cb7f, (roomConnectionStatus, isRunning)=>{
    if (!isRunning && roomConnectionStatus === "connected") return true;
    return false;
});
const $4fc09928452de42f$export$73a5fd73575662ea = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$22f0decfe3c779cc, $4fc09928452de42f$export$d2585f2d4e06cb7f, (roomConnectionStatus, isRunning)=>{
    if (isRunning && [
        "kicked",
        "left"
    ].includes(roomConnectionStatus)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$565061e76fcf0d54
], ({ dispatch: dispatch }, shouldStartConnectionMonitor)=>{
    if (shouldStartConnectionMonitor) dispatch($4fc09928452de42f$export$2ddc2b20a645263b());
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$73a5fd73575662ea
], ({ dispatch: dispatch }, shouldStartConnectionMonitor)=>{
    if (shouldStartConnectionMonitor) dispatch($4fc09928452de42f$export$54c371d7bcfcc11());
});
const $4fc09928452de42f$var$emitter = new (0, $11OXI.EventEmitter)();
function $4fc09928452de42f$var$createNotificationEvent(payload) {
    const notificationEvent = Object.assign(Object.assign({}, payload), {
        timestamp: Date.now()
    });
    return notificationEvent;
}
const $4fc09928452de42f$export$8a538fbf06331f6d = {
    emitter: $4fc09928452de42f$var$emitter,
    events: []
};
const $4fc09928452de42f$export$d90e5af6f326b5f9 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "notifications",
    initialState: $4fc09928452de42f$export$8a538fbf06331f6d,
    reducers: {
        addNotification: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                events: [
                    ...state.events,
                    Object.assign({}, action.payload)
                ]
            });
        },
        doClearNotifications: (state)=>{
            return Object.assign(Object.assign({}, state), {
                events: []
            });
        }
    }
});
const { doClearNotifications: $4fc09928452de42f$export$5e5f72fa18e2653b } = $4fc09928452de42f$export$d90e5af6f326b5f9.actions;
const $4fc09928452de42f$export$af3829d1c396a88d = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState)=>{
        dispatch($4fc09928452de42f$export$d90e5af6f326b5f9.actions.addNotification(payload));
        const state = getState();
        const emitter = $4fc09928452de42f$export$d73c0f55214a186a(state);
        emitter.emit(payload.type, payload);
        emitter.emit("*", payload);
    });
const $4fc09928452de42f$export$d948b33042c2b6b0 = (state)=>state.notifications;
const $4fc09928452de42f$export$77602b842c31ed13 = (state)=>state.notifications.events;
const $4fc09928452de42f$export$d73c0f55214a186a = (state)=>state.notifications.emitter;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.chatMessage,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === payload.senderId);
        if (!client) {
            console.warn("Could not find remote client that sent chat message");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: "chatMessageReceived",
            message: `${client.displayName} says: ${payload.text}`,
            props: {
                client: client,
                chatMessage: {
                    senderId: payload.senderId,
                    timestamp: payload.timestamp,
                    text: payload.text
                }
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enable: enable, requestedByClientId: requestedByClientId } = payload;
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === requestedByClientId);
        if (!client) {
            console.warn("Could not find remote client that requested a local audio change");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: enable ? "requestAudioEnable" : "requestAudioDisable",
            message: enable ? `${client.displayName} has requested for you to speak` : `${client.displayName} has muted your microphone`,
            props: {
                client: client,
                enable: enable
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enable: enable, requestedByClientId: requestedByClientId } = payload;
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === requestedByClientId);
        if (!client) {
            console.warn("Could not find remote client that requested a local video change");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: enable ? "requestVideoEnable" : "requestVideoDisable",
            message: enable ? `${client.displayName} has requested for you to start video` : `${client.displayName} has stopped your video`,
            props: {
                client: client,
                enable: enable
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived,
    effect: (action, { dispatch: dispatch, getOriginalState: getOriginalState, getState: getState })=>{
        var _a;
        const { error: error, payload: payload } = action.payload;
        if (error || !payload) return;
        const { clientId: clientId, stickyReaction: stickyReaction } = payload;
        const state = getState();
        const canAskToSpeak = $4fc09928452de42f$export$c53e10fe73bac35f(state);
        if (!canAskToSpeak) return;
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === clientId);
        if (!client) {
            console.warn("Could not find remote client that provided updated metadata");
            return;
        }
        const previousState = getOriginalState();
        const previousClient = $4fc09928452de42f$export$f97faf20840c4b0c(previousState).find(({ id: id })=>id === clientId);
        if (!stickyReaction && !(previousClient === null || previousClient === void 0 ? void 0 : previousClient.stickyReaction) || (stickyReaction === null || stickyReaction === void 0 ? void 0 : stickyReaction.timestamp) === ((_a = previousClient === null || previousClient === void 0 ? void 0 : previousClient.stickyReaction) === null || _a === void 0 ? void 0 : _a.timestamp)) return;
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: stickyReaction ? "remoteHandRaised" : "remoteHandLowered",
            message: `${client.displayName} ${stickyReaction ? "raised" : "lowered"} their hand`,
            props: {
                client: client,
                stickyReaction: stickyReaction
            }
        })));
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$fb9576bb0af6ec25
], ({ dispatch: dispatch, getState: getState }, signalStatus)=>{
    const state = getState();
    const roomConnectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
    if ([
        "left",
        "kicked"
    ].includes(roomConnectionStatus)) return;
    if (signalStatus === "disconnected") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
        type: "signalTrouble",
        message: `Network connection lost. Trying to reconnect you...`,
        props: {}
    })));
    else if (signalStatus === "connected") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
        type: "signalOk",
        message: `Network connection available`,
        props: {}
    })));
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientUnableToJoin,
    effect: (action, { dispatch: dispatch })=>{
        var _a;
        if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.error) === "room_full") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: "clientUnableToJoinFullRoom",
            message: "Someone tried to join but the room is full and at capacity.",
            props: {}
        })));
    }
});
const $4fc09928452de42f$export$ab6ffac072dba6ff = {
    audioEnabled: {
        actions: [
            $4fc09928452de42f$export$447462528605c694.fulfilled
        ],
        rtcEventName: "audioEnabled",
        getValue: (state)=>$4fc09928452de42f$export$ee30c1c2cc195652(state),
        getOutput: (value)=>({
                enabled: value
            })
    },
    videoEnabled: {
        actions: [
            $4fc09928452de42f$export$5ce66a04faaa2854.fulfilled
        ],
        rtcEventName: "videoEnabled",
        getValue: (state)=>$4fc09928452de42f$export$c8e0d13b9d33fb32(state),
        getOutput: (value)=>({
                enabled: value
            })
    },
    localStream: {
        actions: [
            $4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled
        ],
        rtcEventName: "localStream",
        getValue: (state)=>{
            var _a;
            return (_a = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state)) === null || _a === void 0 ? void 0 : _a.getTracks().map((track)=>({
                    id: track.id,
                    kind: track.kind,
                    label: track.label
                }));
        },
        getOutput: (value)=>({
                stream: value
            })
    },
    localScreenshareStream: {
        actions: [
            $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled
        ],
        rtcEventName: "localScreenshareStream",
        getValue: (state)=>{
            var _a;
            return (_a = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state)) === null || _a === void 0 ? void 0 : _a.getTracks().map((track)=>({
                    id: track.id,
                    kind: track.kind,
                    label: track.label
                }));
        },
        getOutput: (value)=>({
                tracks: value
            })
    },
    localScreenshareStreamStopped: {
        actions: [
            $4fc09928452de42f$export$f8682e9675cc7fb7
        ],
        rtcEventName: "localScreenshareStream",
        getValue: ()=>()=>null,
        getOutput: ()=>({})
    },
    displayName: {
        actions: [
            $4fc09928452de42f$export$ce7d0f83c324f6cf
        ],
        rtcEventName: "displayName",
        getValue: (state)=>$4fc09928452de42f$export$b157fc4c059768ed(state),
        getOutput: (value)=>({
                displayName: value
            })
    },
    clientId: {
        actions: null,
        rtcEventName: "clientId",
        getValue: (state)=>$4fc09928452de42f$export$b5166f32e739efd8(state),
        getOutput: (value)=>({
                clientId: value
            })
    },
    deviceId: {
        actions: null,
        rtcEventName: "deviceId",
        getValue: (state)=>$4fc09928452de42f$export$595744fa227922ad(state),
        getOutput: (value)=>({
                deviceId: value
            })
    },
    externalId: {
        actions: null,
        rtcEventName: "externalId",
        getValue: (state)=>$4fc09928452de42f$export$44202ee237048d77(state),
        getOutput: (value)=>({
                externalId: value
            })
    },
    organizationId: {
        actions: null,
        rtcEventName: "organizationId",
        getValue: (state)=>$4fc09928452de42f$export$7ba530130176c5b4(state),
        getOutput: (value)=>({
                organizationId: value
            })
    },
    signalConnectionStatus: {
        actions: null,
        rtcEventName: "signalConnectionStatus",
        getValue: (state)=>$4fc09928452de42f$export$fb9576bb0af6ec25(state),
        getOutput: (value)=>({
                status: value
            })
    },
    roomSessionId: {
        actions: [
            $4fc09928452de42f$export$6c507f583d588b9f.newClient,
            $4fc09928452de42f$export$6c507f583d588b9f.roomJoined,
            $4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded,
            $4fc09928452de42f$export$6c507f583d588b9f.clientLeft
        ],
        rtcEventName: "roomSessionId",
        getValue: (state)=>$4fc09928452de42f$export$9b6909335b1f6412(state),
        getOutput: (value)=>({
                roomSessionId: value
            })
    },
    rtcConnectionStatus: {
        actions: null,
        rtcEventName: "rtcConnectionStatus",
        getValue: (state)=>$4fc09928452de42f$export$fea824bf20fd1f4d(state),
        getOutput: (value)=>({
                status: value
            })
    },
    userRole: {
        actions: null,
        rtcEventName: "userRole",
        getValue: (state)=>$4fc09928452de42f$export$c3921fe844b67c95(state),
        getOutput: (value)=>({
                userRole: value
            })
    }
};
const $4fc09928452de42f$var$rtcCustomEventActions = Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).flatMap(({ actions: actions })=>{
    var _a;
    return (_a = actions === null || actions === void 0 ? void 0 : actions.map((action)=>action)) !== null && _a !== void 0 ? _a : null;
}).filter((action)=>action !== null);
const $4fc09928452de42f$var$makeComparable = (value)=>{
    if (typeof value === "object") return JSON.stringify(value);
    return value;
};
const $4fc09928452de42f$var$initialState$3 = {
    reportedValues: {}
};
const $4fc09928452de42f$export$a42fe34f713ffe77 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$3,
    name: "rtcAnalytics",
    reducers: {
        updateReportedValues (state, action) {
            return Object.assign(Object.assign({}, state), {
                reportedValues: Object.assign(Object.assign({}, state.reportedValues), {
                    [action.payload.rtcEventName]: action.payload.value
                })
            });
        }
    }
});
const $4fc09928452de42f$export$b9e5ec038548823c = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        if (!rtcManager) return;
        rtcManager.sendStatsCustomEvent("insightsStats", {
            _time: Date.now(),
            ls: 0,
            lr: 0,
            bs: 0,
            br: 0,
            cpu: 0
        });
        Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).forEach(({ rtcEventName: rtcEventName, getValue: getValue, getOutput: getOutput })=>{
            var _a;
            const value = getValue(state);
            const output = Object.assign(Object.assign({}, getOutput(value)), {
                _time: Date.now()
            });
            const comparableValue = $4fc09928452de42f$var$makeComparable(value);
            if (((_a = state.rtcAnalytics.reportedValues) === null || _a === void 0 ? void 0 : _a[rtcEventName]) !== comparableValue) {
                rtcManager.sendStatsCustomEvent(rtcEventName, output);
                dispatch($4fc09928452de42f$export$3370c8e9ed370d6b({
                    rtcEventName: rtcEventName,
                    value: value
                }));
            }
        });
    });
const { updateReportedValues: $4fc09928452de42f$export$3370c8e9ed370d6b } = $4fc09928452de42f$export$a42fe34f713ffe77.actions;
$4fc09928452de42f$export$4e3495129325ad89({
    matcher: (0, $58dad493bd6ec980$export$2c3435c7647f7b0d)(...$4fc09928452de42f$var$rtcCustomEventActions),
    effect: ({ type: type }, { getState: getState, dispatch: dispatch })=>{
        var _a;
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        if (!rtcManager) return;
        const rtcCustomEvent = Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).find(({ actions: actions })=>actions === null || actions === void 0 ? void 0 : actions.map((a)=>a.type).includes(type));
        if (!rtcCustomEvent) return;
        const { getValue: getValue, getOutput: getOutput, rtcEventName: rtcEventName } = rtcCustomEvent;
        const value = getValue(state);
        const comparableValue = $4fc09928452de42f$var$makeComparable(value);
        const output = Object.assign(Object.assign({}, getOutput(value)), {
            _time: Date.now()
        });
        if (((_a = state.rtcAnalytics.reportedValues) === null || _a === void 0 ? void 0 : _a[rtcEventName]) !== comparableValue) {
            rtcManager.sendStatsCustomEvent(rtcEventName, output);
            dispatch($4fc09928452de42f$export$3370c8e9ed370d6b({
                rtcEventName: rtcEventName,
                value: value
            }));
        }
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$70908e8ca7bafd4f
], ({ dispatch: dispatch }, selectRtcManagerInitialized)=>{
    if (selectRtcManagerInitialized) dispatch($4fc09928452de42f$export$b9e5ec038548823c());
});
function $4fc09928452de42f$export$527315a678f53c03({ isPresentation: isPresentation, stream: stream }) {
    var _a, _b;
    return isPresentation ? (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.outboundId) !== null && _a !== void 0 ? _a : stream === null || stream === void 0 ? void 0 : stream.inboundId) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.id : "0";
}
function $4fc09928452de42f$export$da1ba6c57510a447({ spotlights: spotlights, isPresentation: isPresentation, clientId: clientId, stream: stream }) {
    return !!spotlights.find((s)=>{
        const streamId = $4fc09928452de42f$export$527315a678f53c03({
            isPresentation: isPresentation,
            stream: stream
        });
        return s.clientId === clientId && s.streamId === streamId;
    });
}
function $4fc09928452de42f$var$mergeSpotlight(spotlights, spotlight) {
    const found = spotlights.find((s)=>s.clientId === spotlight.clientId && s.streamId === spotlight.streamId);
    if (found) return spotlights;
    return spotlights.concat(spotlight);
}
function $4fc09928452de42f$var$mapSpotlightsToClientViews(spotlights, clientViews) {
    return spotlights.reduce((acc, s)=>{
        const clientView = clientViews.find((c)=>s.clientId === c.clientId && s.streamId === $4fc09928452de42f$export$527315a678f53c03(c));
        if (clientView && !acc.includes(clientView)) acc.push(clientView);
        return acc;
    }, []);
}
const $4fc09928452de42f$var$initialState$2 = {
    sorted: []
};
const $4fc09928452de42f$export$bdc852be842a0179 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "spotlights",
    initialState: $4fc09928452de42f$var$initialState$2,
    reducers: {
        addSpotlight (state, action) {
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: $4fc09928452de42f$var$mergeSpotlight(state.sorted, {
                    clientId: clientId,
                    streamId: streamId
                })
            });
        },
        removeSpotlight (state, action) {
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>!(s.clientId === clientId && s.streamId === streamId))
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            if (!action.payload.room) return state;
            const { spotlights: spotlights } = action.payload.room;
            return Object.assign(Object.assign({}, state), {
                sorted: spotlights
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.spotlightAdded, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: $4fc09928452de42f$var$mergeSpotlight(state.sorted, {
                    clientId: clientId,
                    streamId: streamId
                })
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.spotlightRemoved, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>!(s.clientId === clientId && s.streamId === streamId))
            });
        });
        builder.addMatcher((0, $58dad493bd6ec980$export$2c3435c7647f7b0d)($4fc09928452de42f$export$6c507f583d588b9f.clientKicked, $4fc09928452de42f$export$6c507f583d588b9f.clientLeft), (state, action)=>{
            const { clientId: clientId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>s.clientId !== clientId)
            });
        });
    }
});
const { addSpotlight: $4fc09928452de42f$export$fcc5db07d92855e0, removeSpotlight: $4fc09928452de42f$export$2da3c620a495f4c8 } = $4fc09928452de42f$export$bdc852be842a0179.actions;
const $4fc09928452de42f$export$4bf19d94733cc82e = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$7ad9182b247dbca0(state), ({ id: id })=>(_, getState)=>{
        const state = getState();
        const clientView = $4fc09928452de42f$export$dc94230bce59ebc(state).find((c)=>c.clientId === id);
        if (!clientView) return;
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        const streamId = $4fc09928452de42f$export$527315a678f53c03(clientView);
        const payload = {
            clientId: clientView.id,
            streamId: streamId !== null && streamId !== void 0 ? streamId : "0"
        };
        socket === null || socket === void 0 || socket.emit("add_spotlight", payload);
    });
const $4fc09928452de42f$export$65b4309b6edd4ad1 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$7ad9182b247dbca0(state), ({ id: id })=>(_, getState)=>{
        const state = getState();
        const clientView = $4fc09928452de42f$export$dc94230bce59ebc(state).find((c)=>c.clientId === id);
        if (!clientView) return;
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        const streamId = $4fc09928452de42f$export$527315a678f53c03(clientView);
        const payload = {
            clientId: clientView.id,
            streamId: streamId !== null && streamId !== void 0 ? streamId : "0"
        };
        socket === null || socket === void 0 || socket.emit("remove_spotlight", payload);
    });
const $4fc09928452de42f$export$30a40d8bb1242958 = (state)=>state.spotlights;
const $4fc09928452de42f$export$f9423c3be80cdebb = (state)=>state.spotlights.sorted;
const $4fc09928452de42f$export$1177c9e6c452b759 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$f9423c3be80cdebb, (localParticipant, spotlights)=>{
    return $4fc09928452de42f$export$da1ba6c57510a447({
        clientId: localParticipant.id,
        stream: localParticipant.stream,
        spotlights: spotlights
    });
});
const $4fc09928452de42f$export$622ce0f62fa78bbc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$dc94230bce59ebc, $4fc09928452de42f$export$f9423c3be80cdebb, (clientViews, spotlights)=>{
    return $4fc09928452de42f$var$mapSpotlightsToClientViews(spotlights, clientViews);
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled,
    effect: ({ payload: payload }, { getState: getState, dispatch: dispatch })=>{
        const { stream: stream } = payload;
        const state = getState();
        const localParticipant = $4fc09928452de42f$export$b8c8b2aa1134778b(state);
        if (!localParticipant) return;
        dispatch($4fc09928452de42f$export$fcc5db07d92855e0({
            clientId: localParticipant.id,
            streamId: stream.id
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$f8682e9675cc7fb7,
    effect: ({ payload: payload }, { getState: getState, dispatch: dispatch })=>{
        const { stream: stream } = payload;
        const state = getState();
        const localParticipant = $4fc09928452de42f$export$b8c8b2aa1134778b(state);
        if (!localParticipant) return;
        dispatch($4fc09928452de42f$export$2da3c620a495f4c8({
            clientId: localParticipant.id,
            streamId: stream.id
        }));
    }
});
const $4fc09928452de42f$var$initialState$1 = {
    isStreaming: false,
    error: null,
    startedAt: undefined
};
const $4fc09928452de42f$export$c231a66657b64e4c = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "streaming",
    initialState: $4fc09928452de42f$var$initialState$1,
    reducers: {
        doHandleStreamingStarted: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isStreaming: true,
                error: null,
                startedAt: new Date().getTime()
            });
        },
        doHandleStreamingStopped: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isStreaming: false
            });
        }
    }
});
const { doHandleStreamingStarted: $4fc09928452de42f$export$b0972c19c4c2ef31, doHandleStreamingStopped: $4fc09928452de42f$export$85c3199cbeef14e8 } = $4fc09928452de42f$export$c231a66657b64e4c.actions;
const $4fc09928452de42f$export$90baeb59ec142cd0 = (state)=>state.streaming;
const $4fc09928452de42f$var$initialState = {
    waitingParticipants: []
};
const $4fc09928452de42f$export$4a4178c929253d8e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "waitingParticipants",
    initialState: $4fc09928452de42f$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, { payload: payload })=>{
            var _a;
            if ((_a = payload.room) === null || _a === void 0 ? void 0 : _a.knockers.length) return Object.assign(Object.assign({}, state), {
                waitingParticipants: payload.room.knockers.map((knocker)=>({
                        id: knocker.clientId,
                        displayName: knocker.displayName
                    }))
            });
            else return state;
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomKnocked, (state, action)=>{
            const { clientId: clientId, displayName: displayName } = action.payload;
            return Object.assign(Object.assign({}, state), {
                waitingParticipants: [
                    ...state.waitingParticipants,
                    {
                        id: clientId,
                        displayName: displayName
                    }
                ]
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.knockerLeft, (state, action)=>{
            const { clientId: clientId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                waitingParticipants: state.waitingParticipants.filter((p)=>p.id !== clientId)
            });
        });
    }
});
const $4fc09928452de42f$export$1a5b93a56a313cfe = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const { participantId: participantId } = payload;
        const state = getState();
        const socket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        socket === null || socket === void 0 || socket.emit("handle_knock", {
            action: "accept",
            clientId: participantId,
            response: {}
        });
    });
const $4fc09928452de42f$export$dde035bd3d0904ac = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const { participantId: participantId } = payload;
        const state = getState();
        const socket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        socket === null || socket === void 0 || socket.emit("handle_knock", {
            action: "reject",
            clientId: participantId,
            response: {}
        });
    });
const $4fc09928452de42f$export$e99a87d20a064a78 = (state)=>state.waitingParticipants;
const $4fc09928452de42f$export$2a890977d27b6c75 = (state)=>state.waitingParticipants.waitingParticipants;
var $4fc09928452de42f$var$_a;
const $4fc09928452de42f$var$IS_DEV = ($4fc09928452de42f$var$_a = false, $4fc09928452de42f$var$_a !== void 0) ? $4fc09928452de42f$var$_a : false;
const $4fc09928452de42f$var$appReducer = (0, $ac44486100bacc69$export$66e4520cdb265d18)({
    app: $4fc09928452de42f$export$7a3bdf7180628a3c.reducer,
    authorization: $4fc09928452de42f$export$a8061e375981838e.reducer,
    chat: $4fc09928452de42f$export$89f748d7b911fed0.reducer,
    cloudRecording: $4fc09928452de42f$export$4a7c7275a23ed5bc.reducer,
    connectionMonitor: $4fc09928452de42f$export$f9b8189900b9396b.reducer,
    deviceCredentials: $4fc09928452de42f$export$601059773552eb94.reducer,
    localMedia: $4fc09928452de42f$export$5bb3b96828f370d1.reducer,
    localParticipant: $4fc09928452de42f$export$44a9bbc9e703cf3d.reducer,
    localScreenshare: $4fc09928452de42f$export$8e6b4a78bd959605.reducer,
    notifications: $4fc09928452de42f$export$d90e5af6f326b5f9.reducer,
    organization: $4fc09928452de42f$export$351101b59484838e.reducer,
    remoteParticipants: $4fc09928452de42f$export$b64ee0f1b6392800.reducer,
    room: $4fc09928452de42f$export$9ce7dca4f26ff3bd.reducer,
    roomConnection: $4fc09928452de42f$export$b633f15c3886bdc9.reducer,
    rtcAnalytics: $4fc09928452de42f$export$a42fe34f713ffe77.reducer,
    rtcConnection: $4fc09928452de42f$export$e0e4df945a3863bd.reducer,
    signalConnection: $4fc09928452de42f$export$1010602111efdae4.reducer,
    spotlights: $4fc09928452de42f$export$bdc852be842a0179.reducer,
    streaming: $4fc09928452de42f$export$c231a66657b64e4c.reducer,
    waitingParticipants: $4fc09928452de42f$export$4a4178c929253d8e.reducer
});
const $4fc09928452de42f$export$a8a69c316169e623 = (state, action)=>{
    var _a;
    if ($4fc09928452de42f$export$ca0cd7d9bebf6bc8.match(action)) {
        const resetState = {
            app: Object.assign(Object.assign({}, $4fc09928452de42f$export$7a3bdf7180628a3c.getInitialState()), {
                initialConfig: (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.initialConfig
            }),
            localMedia: Object.assign(Object.assign({}, $4fc09928452de42f$export$5bb3b96828f370d1.getInitialState()), state === null || state === void 0 ? void 0 : state.localMedia)
        };
        return $4fc09928452de42f$var$appReducer(resetState, action);
    }
    return $4fc09928452de42f$var$appReducer(state, action);
};
const $4fc09928452de42f$export$f51a9068ac82ea43 = ({ preloadedState: preloadedState, injectServices: injectServices })=>{
    return (0, $58dad493bd6ec980$export$7d8a5b498da695ac)({
        devTools: $4fc09928452de42f$var$IS_DEV,
        reducer: $4fc09928452de42f$export$a8a69c316169e623,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                thunk: {
                    extraArgument: {
                        services: injectServices
                    }
                },
                serializableCheck: false
            }).prepend($4fc09928452de42f$export$1992b10a91137ec8.middleware),
        preloadedState: preloadedState
    });
};
const $4fc09928452de42f$export$7eabfc5ef2a68f64 = (store, select, onChange)=>{
    let currentState;
    function handleChange() {
        const nextState = select(store.getState());
        if (nextState !== currentState) {
            currentState = nextState;
            onChange(currentState);
        }
    }
    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
};
class $4fc09928452de42f$var$Response {
    constructor(initialValues = {}){
        this.data = initialValues.data === undefined ? {} : initialValues.data;
        this.headers = initialValues.headers || {};
        this.status = initialValues.status || 200;
        this.statusText = initialValues.statusText || "OK";
        this.url = initialValues.url || null;
    }
}
function $4fc09928452de42f$var$assertTruthy(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(value, `${parameterName} is required`);
    return value;
}
function $4fc09928452de42f$var$assertBoolean(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "boolean", `${parameterName}<boolean> is required`);
    return value;
}
function $4fc09928452de42f$var$assertNumber(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "number", `${parameterName}<number> is required`);
    return value;
}
function $4fc09928452de42f$var$assertString(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "string", `${parameterName}<string> is required`);
    return value;
}
function $4fc09928452de42f$var$assertInstanceOf(value, type, parameterName) {
    const resolvedParameterName = parameterName || type.name[0].toLowerCase() + type.name.substring(1);
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(value instanceof type, `${resolvedParameterName}<${type.name}> is required`);
    return value;
}
function $4fc09928452de42f$var$assertRoomName(roomName, parameterName = "roomName") {
    $4fc09928452de42f$var$assertString(roomName, parameterName);
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof roomName === "string" && roomName[0] === "/", `${parameterName} must begin with a '/'`);
    return roomName;
}
function $4fc09928452de42f$var$assertArray(array, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(Array.isArray(array), `${parameterName}<array> is required`);
    return array;
}
function $4fc09928452de42f$var$assertOneOf(value, allowedValues, parameterName) {
    $4fc09928452de42f$var$assertTruthy(value, "value");
    $4fc09928452de42f$var$assertArray(allowedValues, "allowedValues");
    const isAllowed = allowedValues.includes(value);
    if (!isAllowed) throw new Error(`${parameterName}<string> must be one of the following: ${allowedValues.join(", ")}`);
    return value;
}
function $4fc09928452de42f$var$assertRecord(ref, name) {
    if (ref === null || ref === undefined || typeof ref !== "object" || Array.isArray(ref)) throw new Error(`${name} must be a record. ${JSON.stringify(ref)}`);
    return ref;
}
function $4fc09928452de42f$var$assertNullOrType(ref, type, name, message) {
    $4fc09928452de42f$var$assertString(name, "name");
    const errorMessage = message || `${name} must be null or of type ${type}`;
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(ref === null || typeof ref === type, errorMessage);
}
function $4fc09928452de42f$var$assertNullOrString(ref, name, message) {
    $4fc09928452de42f$var$assertString(name, "name");
    $4fc09928452de42f$var$assertNullOrType(ref, "string", name, message);
}
function $4fc09928452de42f$var$_getAbsoluteUrl({ baseUrl: baseUrl, url: url }) {
    return baseUrl ? baseUrl + url : url;
}
class $4fc09928452de42f$var$HttpClient {
    _requestAxios(url, options) {
        const axiosOptions = Object.assign({}, options, {
            url: url,
            baseURL: this._baseUrl
        });
        return (0, $a7H8f.default).request(axiosOptions);
    }
    request(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this._requestAxios(url, options).then((response)=>{
            const { data: data, headers: headers, status: status, statusText: statusText, config: config } = response;
            const requestUrl = config && config.url ? $4fc09928452de42f$var$_getAbsoluteUrl({
                baseUrl: config.baseURL,
                url: config.url
            }) : null;
            return new $4fc09928452de42f$var$Response({
                data: data,
                headers: headers,
                status: status,
                statusText: statusText,
                url: requestUrl
            });
        }).catch((error)=>{
            const responseObject = error.response;
            if (!responseObject) throw new Error("Could not make the request.");
            const { data: data, headers: headers, status: status, statusText: statusText, config: config } = responseObject;
            const requestUrl = config && config.url ? $4fc09928452de42f$var$_getAbsoluteUrl({
                baseUrl: config.baseURL,
                url: config.url
            }) : null;
            return Promise.reject(new $4fc09928452de42f$var$Response({
                data: data,
                headers: headers,
                status: status,
                statusText: statusText,
                url: requestUrl
            }));
        });
    }
    constructor({ baseUrl: baseUrl }){
        $4fc09928452de42f$var$assertString(baseUrl, "baseUrl");
        this._baseUrl = baseUrl;
    }
}
class $4fc09928452de42f$var$MultipartHttpClient {
    static dataToFormData(data) {
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(data, "data is required");
        const fd = new FormData();
        Object.keys(data).forEach((key)=>{
            const value = data[key];
            fd.append(key, value);
        });
        return fd;
    }
    request(url, options = {}) {
        const headers = Object.assign(options.headers || {}, {
            "Content-Type": undefined
        });
        return this._httpClient.request(url, Object.assign(options, {
            headers: headers,
            transformRequest: $4fc09928452de42f$var$MultipartHttpClient.dataToFormData
        }));
    }
    constructor({ httpClient: httpClient }){
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(httpClient, "httpClient is required");
        this._httpClient = httpClient;
    }
}
let $4fc09928452de42f$var$btoa;
if (typeof window === "object") $4fc09928452de42f$var$btoa = window.btoa || (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
else if (typeof $parcel$global === "object") $4fc09928452de42f$var$btoa = $parcel$global.btoa || (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
else $4fc09928452de42f$var$btoa = (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
function $4fc09928452de42f$var$_getAuthHeader(credentials) {
    if (credentials && credentials.credentials) {
        const btoaStr = `${credentials.credentials.uuid}:${credentials.hmac}`;
        return {
            Authorization: `Basic ${$4fc09928452de42f$var$btoa(btoaStr)}`
        };
    }
    return {};
}
const $4fc09928452de42f$var$noCredentials = ()=>Promise.resolve(null);
class $4fc09928452de42f$var$AuthenticatedHttpClient {
    request(url, options) {
        return this._fetchDeviceCredentials().then((credentials)=>{
            const headers = Object.assign({}, options.headers, $4fc09928452de42f$var$_getAuthHeader(credentials), {
                "X-Appearin-Device-Platform": "web"
            });
            const httpClientOptions = Object.assign({}, options, {
                headers: headers
            });
            return this._httpClient.request(url, httpClientOptions);
        });
    }
    constructor({ httpClient: httpClient, fetchDeviceCredentials: fetchDeviceCredentials }){
        this._httpClient = httpClient;
        this._fetchDeviceCredentials = fetchDeviceCredentials;
    }
}
class $4fc09928452de42f$export$dc890958d2b428da {
    request(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this.authenticatedHttpClient.request(url, options);
    }
    requestMultipart(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this.authenticatedFormDataHttpClient.request(url, options);
    }
    constructor({ baseUrl: baseUrl = "https://api.appearin.net", fetchDeviceCredentials: fetchDeviceCredentials = $4fc09928452de42f$var$noCredentials } = {}){
        this.authenticatedHttpClient = new $4fc09928452de42f$var$AuthenticatedHttpClient({
            httpClient: new $4fc09928452de42f$var$HttpClient({
                baseUrl: baseUrl
            }),
            fetchDeviceCredentials: fetchDeviceCredentials
        });
        this.authenticatedFormDataHttpClient = new $4fc09928452de42f$var$MultipartHttpClient({
            httpClient: this.authenticatedHttpClient
        });
    }
}
function $4fc09928452de42f$var$nullOrExtract(extract) {
    return (data, propertyName)=>{
        const record = $4fc09928452de42f$var$assertRecord(data, "data");
        const value = record[propertyName];
        return value === null || value === undefined ? null : extract(data, propertyName);
    };
}
function $4fc09928452de42f$var$extractString(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    return $4fc09928452de42f$var$assertString(record[propertyName], propertyName);
}
const $4fc09928452de42f$var$extractNullOrString = $4fc09928452de42f$var$nullOrExtract($4fc09928452de42f$var$extractString);
function $4fc09928452de42f$var$extractDate(data, propertyName) {
    const dateString = $4fc09928452de42f$var$extractString(data, propertyName);
    const d = new Date(dateString);
    if (isNaN(d.getTime())) throw new Error(`Invalid date for ${dateString}`);
    return d;
}
function $4fc09928452de42f$var$extractArrayOfJson(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    return $4fc09928452de42f$var$assertArray(record[propertyName], propertyName);
}
function $4fc09928452de42f$var$extractArray(data, propertyName, transformer) {
    return $4fc09928452de42f$var$extractArrayOfJson(data, propertyName).map((value)=>transformer(value));
}
function $4fc09928452de42f$var$extractJson(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    const value = record[propertyName];
    return value === undefined ? null : value;
}
class $4fc09928452de42f$export$a9627919734faa48 {
    toJson() {
        return Object.assign({
            credentials: this.credentials,
            hmac: this.hmac
        }, this.userId && {
            userId: this.userId
        });
    }
    static fromJson(json) {
        return new $4fc09928452de42f$export$a9627919734faa48($4fc09928452de42f$var$extractString($4fc09928452de42f$var$extractJson(json, "credentials"), "uuid"), $4fc09928452de42f$var$extractString(json, "hmac"), $4fc09928452de42f$var$extractNullOrString(json, "userId") || undefined);
    }
    constructor(uuid, hmac, userId){
        this.credentials = {
            uuid: uuid
        };
        this.hmac = hmac;
        this.userId = userId;
    }
}
class $4fc09928452de42f$var$DeviceService {
    getCredentials() {
        return this._apiClient.request("/devices", {
            method: "post"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$export$a9627919734faa48.fromJson(data);
        }).catch((error)=>{
            if (error.response) {
                if (error.response.status === 404) return null;
            }
            throw error;
        });
    }
    constructor({ apiClient: apiClient }){
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$var$ChromeStorageStore {
    loadOrDefault(defaultValue) {
        return new Promise((resolve)=>{
            this._chromeStorage.get(this._key, (result)=>{
                const unknownResult = result;
                resolve(unknownResult[this._key] || defaultValue);
            });
        });
    }
    save(value) {
        return new Promise((resolve)=>{
            this._chromeStorage.set({
                [this._key]: value
            }, ()=>{
                resolve();
            });
        });
    }
    constructor(key, chromeStorage){
        this._key = key;
        this._chromeStorage = chromeStorage;
    }
}
class $4fc09928452de42f$var$LocalStorageStore {
    loadOrDefault(defaultValue) {
        try {
            const value = this._localStorage.getItem(this._key);
            if (value) try {
                return Promise.resolve(JSON.parse(value));
            } catch (e) {}
            return Promise.resolve(defaultValue);
        } catch (e) {
            console.warn("Error getting access to storage. Are cookies blocked?", e);
            return Promise.resolve(defaultValue);
        }
    }
    save(value) {
        try {
            this._localStorage.setItem(this._key, JSON.stringify(value));
            return Promise.resolve();
        } catch (e) {
            console.warn("Error getting access to storage. Are cookies blocked?", e);
            return Promise.reject(e);
        }
    }
    constructor(key, localStorage){
        $4fc09928452de42f$var$assertTruthy(localStorage, "localStorage");
        this._key = $4fc09928452de42f$var$assertString(key, "key");
        this._localStorage = localStorage;
    }
}
let $4fc09928452de42f$var$localStorage;
try {
    $4fc09928452de42f$var$localStorage = self.localStorage;
} catch (e) {
    $4fc09928452de42f$var$localStorage = {
        getItem: ()=>undefined,
        key: ()=>undefined,
        setItem: ()=>undefined,
        removeItem: ()=>undefined,
        hasOwnProperty: ()=>undefined,
        length: 0
    };
}
var $4fc09928452de42f$var$localStorage$1 = $4fc09928452de42f$var$localStorage;
const $4fc09928452de42f$var$events = {
    CREDENTIALS_SAVED: "credentials_saved"
};
class $4fc09928452de42f$export$3977fa7307407ad9 extends (0, $11OXI.EventEmitter) {
    static create({ baseUrl: baseUrl, storeName: storeName = "CredentialsStorage", storeType: storeType = "localStorage" }) {
        const deviceService = new $4fc09928452de42f$var$DeviceService({
            apiClient: new $4fc09928452de42f$export$dc890958d2b428da({
                baseUrl: baseUrl
            })
        });
        let credentialsStore = null;
        if (storeType === "localStorage") credentialsStore = new $4fc09928452de42f$var$LocalStorageStore(storeName, $4fc09928452de42f$var$localStorage$1);
        else if (storeType === "chromeStorage") credentialsStore = new $4fc09928452de42f$var$ChromeStorageStore(storeName, window["chrome"].storage.local);
        else throw new Error(`Unknown store type: ${storeType}`);
        return new $4fc09928452de42f$export$3977fa7307407ad9({
            deviceService: deviceService,
            credentialsStore: credentialsStore
        });
    }
    _fetchNewCredentialsFromApi() {
        const credentialsStore = this._credentialsStore;
        return new Promise((resolve)=>{
            const fetchCredentials = ()=>{
                this._deviceService.getCredentials().then((credentials)=>{
                    return credentialsStore.save(credentials ? credentials.toJson() : null).then(()=>resolve(credentials));
                }).catch(()=>{
                    setTimeout(fetchCredentials, 2000);
                });
            };
            fetchCredentials();
        });
    }
    getCurrentCredentials() {
        return this._credentialsStore.loadOrDefault(null).then((json)=>json ? $4fc09928452de42f$export$a9627919734faa48.fromJson(json) : null);
    }
    getCredentials() {
        if (!this.credentialsPromise) this.credentialsPromise = this.getCurrentCredentials().then((storedCredentials)=>{
            if (storedCredentials) return storedCredentials;
            return this._fetchNewCredentialsFromApi();
        });
        return this.credentialsPromise;
    }
    saveCredentials(credentials) {
        this.credentialsPromise = undefined;
        return this._credentialsStore.save(credentials.toJson()).then(()=>{
            this.emit($4fc09928452de42f$var$events.CREDENTIALS_SAVED, credentials);
            return credentials;
        });
    }
    setUserId(userId) {
        return this.getCurrentCredentials().then((storedCredentials)=>{
            if (!storedCredentials) console.error("Illegal state: no credentials to set user id for.");
            const userIdChangedFromLocalStorage = storedCredentials === null || storedCredentials.userId !== userId;
            if (!userIdChangedFromLocalStorage) return undefined;
            return this._credentialsStore.save(Object.assign({}, storedCredentials === null || storedCredentials === void 0 ? void 0 : storedCredentials.toJson(), {
                userId: userId
            }));
        }).then(()=>undefined);
    }
    constructor({ deviceService: deviceService, credentialsStore: credentialsStore }){
        super();
        this._deviceService = deviceService;
        this._credentialsStore = credentialsStore;
    }
}
const $4fc09928452de42f$var$noOrganization = ()=>Promise.resolve(undefined);
class $4fc09928452de42f$export$6fe2794aa8aa0e05 {
    _callRequestMethod(method, url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this._fetchOrganization().then((organization)=>{
            if (!organization) return this._apiClient[method](url, options);
            const { organizationId: organizationId } = organization;
            return this._apiClient[method](`/organizations/${encodeURIComponent(organizationId)}${url}`, options);
        });
    }
    request(url, options) {
        return this._callRequestMethod("request", url, options);
    }
    requestMultipart(url, options) {
        return this._callRequestMethod("requestMultipart", url, options);
    }
    constructor({ apiClient: apiClient, fetchOrganization: fetchOrganization = $4fc09928452de42f$var$noOrganization }){
        this._apiClient = apiClient;
        this._fetchOrganization = fetchOrganization;
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$var$EmbeddedFreeTierStatus {
    static fromJson(data) {
        return new $4fc09928452de42f$var$EmbeddedFreeTierStatus({
            isExhausted: $4fc09928452de42f$var$assertBoolean(data.isExhausted, "isExhausted"),
            renewsAt: new Date($4fc09928452de42f$var$assertString(data.renewsAt, "renewsAt")),
            totalMinutesLimit: $4fc09928452de42f$var$assertNumber(data.totalMinutesLimit, "totalMinutesLimit"),
            totalMinutesUsed: $4fc09928452de42f$var$assertNumber(data.totalMinutesUsed, "totalMinutesUsed")
        });
    }
    constructor({ isExhausted: isExhausted, renewsAt: renewsAt, totalMinutesLimit: totalMinutesLimit, totalMinutesUsed: totalMinutesUsed }){
        this.isExhausted = isExhausted;
        this.renewsAt = renewsAt;
        this.totalMinutesLimit = totalMinutesLimit;
        this.totalMinutesUsed = totalMinutesUsed;
    }
}
class $4fc09928452de42f$var$Account {
    static fromJson(data) {
        return new $4fc09928452de42f$var$Account({
            basePlanId: typeof data.basePlanId === "string" ? data.basePlanId : null,
            isDeactivated: $4fc09928452de42f$var$assertBoolean(data.isDeactivated, "isDeactivated"),
            isOnTrial: $4fc09928452de42f$var$assertBoolean(data.isOnTrial, "isOnTrial"),
            onTrialUntil: typeof data.onTrialUntil === "string" ? new Date(data.onTrialUntil) : null,
            trialStatus: typeof data.trialStatus === "string" ? data.trialStatus : null,
            embeddedFreeTierStatus: data.embeddedFreeTierStatus ? $4fc09928452de42f$var$EmbeddedFreeTierStatus.fromJson(data.embeddedFreeTierStatus) : null
        });
    }
    constructor({ basePlanId: basePlanId, embeddedFreeTierStatus: embeddedFreeTierStatus, isDeactivated: isDeactivated, isOnTrial: isOnTrial, onTrialUntil: onTrialUntil, trialStatus: trialStatus }){
        this.basePlanId = basePlanId;
        this.isDeactivated = isDeactivated;
        this.isOnTrial = isOnTrial;
        this.onTrialUntil = onTrialUntil || null;
        this.trialStatus = trialStatus || null;
        this.embeddedFreeTierStatus = embeddedFreeTierStatus || null;
    }
}
function $4fc09928452de42f$export$96bdbc84526f3739(value) {
    return value !== null && value !== undefined;
}
function $4fc09928452de42f$var$createOrganizationLimits(limits = {}) {
    return {
        maxNumberOfInvitationsAndUsers: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfInvitationsAndUsers) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfInvitationsAndUsers) : null,
        maxNumberOfClaimedRooms: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfClaimedRooms) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfClaimedRooms) : null,
        maxRoomLimitPerOrganization: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxRoomLimitPerOrganization) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxRoomLimitPerOrganization) : null,
        trialMinutesLimit: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.trialMinutesLimit) ? Number(limits === null || limits === void 0 ? void 0 : limits.trialMinutesLimit) : null,
        includedUnits: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.includedUnits) ? Number(limits === null || limits === void 0 ? void 0 : limits.includedUnits) : null
    };
}
class $4fc09928452de42f$var$Organization {
    static fromJson(data) {
        const parsedData = $4fc09928452de42f$var$assertInstanceOf(data, Object, "data");
        const preferences = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.preferences) || {};
        const onboardingSurvey = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.onboardingSurvey) || null;
        const permissions = $4fc09928452de42f$var$assertInstanceOf(parsedData.permissions, Object, "permissions");
        return new $4fc09928452de42f$var$Organization({
            organizationId: $4fc09928452de42f$var$assertString(parsedData.organizationId, "organizationId"),
            organizationName: $4fc09928452de42f$var$assertString(parsedData.organizationName, "organizationName"),
            subdomain: $4fc09928452de42f$var$assertString(parsedData.subdomain, "subdomain"),
            permissions: permissions,
            limits: $4fc09928452de42f$var$createOrganizationLimits($4fc09928452de42f$var$assertInstanceOf(parsedData.limits, Object, "limits")),
            account: parsedData.account ? $4fc09928452de42f$var$Account.fromJson(parsedData.account) : null,
            logoImageUrl: typeof parsedData.logoImageUrl === "string" ? parsedData.logoImageUrl : null,
            roomBackgroundImageUrl: typeof parsedData.roomBackgroundImageUrl === "string" ? parsedData.roomBackgroundImageUrl : null,
            roomBackgroundThumbnailUrl: typeof parsedData.roomBackgroundThumbnailUrl === "string" ? parsedData.roomBackgroundThumbnailUrl : null,
            roomKnockPageBackgroundImageUrl: typeof parsedData.roomKnockPageBackgroundImageUrl === "string" ? parsedData.roomKnockPageBackgroundImageUrl : null,
            roomKnockPageBackgroundThumbnailUrl: typeof parsedData.roomKnockPageBackgroundThumbnailUrl === "string" ? parsedData.roomKnockPageBackgroundThumbnailUrl : null,
            preferences: preferences,
            onboardingSurvey: onboardingSurvey,
            type: typeof parsedData.type === "string" ? parsedData.type : null
        });
    }
    constructor(properties){
        this.logoImageUrl = null;
        this.roomBackgroundImageUrl = null;
        this.roomBackgroundThumbnailUrl = null;
        this.roomKnockPageBackgroundImageUrl = null;
        this.roomKnockPageBackgroundThumbnailUrl = null;
        this.preferences = null;
        this.onboardingSurvey = null;
        this.type = null;
        $4fc09928452de42f$var$assertInstanceOf(properties, Object, "properties");
        $4fc09928452de42f$var$assertString(properties.organizationId, "organizationId");
        $4fc09928452de42f$var$assertString(properties.organizationName, "organizationName");
        $4fc09928452de42f$var$assertString(properties.subdomain, "subdomain");
        $4fc09928452de42f$var$assertInstanceOf(properties.permissions, Object, "permissions");
        $4fc09928452de42f$var$assertInstanceOf(properties.limits, Object, "limits");
        this.organizationId = properties.organizationId;
        this.organizationName = properties.organizationName;
        this.subdomain = properties.subdomain;
        this.permissions = properties.permissions;
        this.limits = properties.limits;
        this.account = properties.account ? new $4fc09928452de42f$var$Account(properties.account) : null;
        this.logoImageUrl = properties.logoImageUrl;
        this.roomBackgroundImageUrl = properties.roomBackgroundImageUrl;
        this.roomBackgroundThumbnailUrl = properties.roomBackgroundThumbnailUrl;
        this.roomKnockPageBackgroundImageUrl = properties.roomKnockPageBackgroundImageUrl;
        this.roomKnockPageBackgroundThumbnailUrl = properties.roomKnockPageBackgroundThumbnailUrl;
        this.preferences = properties.preferences;
        this.onboardingSurvey = properties.onboardingSurvey;
        this.type = properties.type;
    }
}
$4fc09928452de42f$var$Organization.GLOBAL_ORGANIZATION_ID = "1";
class $4fc09928452de42f$export$abbf95a02a0c9d38 {
    createOrganization({ organizationName: organizationName, subdomain: subdomain, owner: owner }) {
        const { displayName: displayName, consents: consents } = owner || {};
        const email = "email" in owner ? {
            value: owner.email,
            verificationCode: $4fc09928452de42f$var$assertString(owner.verificationCode, "owner.verificationCode")
        } : null;
        const idToken = "idToken" in owner ? owner.idToken : null;
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        $4fc09928452de42f$var$assertString(organizationName, "organizationName");
        $4fc09928452de42f$var$assertString(displayName, "owner.displayName");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(email || idToken, "owner.email or owner.idToken is required");
        if (consents) {
            $4fc09928452de42f$var$assertArray(consents, "consents");
            for (const { consentRevisionId: consentRevisionId, action: action } of consents){
                $4fc09928452de42f$var$assertString(consentRevisionId, "consentRevisionId");
                $4fc09928452de42f$var$assertNullOrString(action, "action");
            }
        }
        return this._apiClient.request(`/organizations`, {
            method: "POST",
            data: {
                organizationName: organizationName,
                type: "private",
                subdomain: subdomain,
                owner: Object.assign(Object.assign(Object.assign(Object.assign({}, email && {
                    email: email
                }), idToken && {
                    idToken: idToken
                }), consents && {
                    consents: consents
                }), {
                    displayName: displayName
                })
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractString(data, "organizationId");
        });
    }
    getOrganizationBySubdomain(subdomain) {
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        return this._apiClient.request(`/organization-subdomains/${encodeURIComponent(subdomain)}/?fields=permissions,account,onboardingSurvey`, {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$Organization.fromJson(data);
        }).catch((res)=>{
            if (res instanceof $4fc09928452de42f$var$Response) {
                if (res.status === 404) return null;
                throw new Error(res.statusText);
            }
            throw res;
        });
    }
    getOrganizationByOrganizationId(organizationId) {
        $4fc09928452de42f$var$assertString(organizationId, "organizationId");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}?fields=permissions,account`, {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$Organization.fromJson(data);
        }).catch((res)=>{
            if (res instanceof $4fc09928452de42f$var$Response) {
                if (res.status === 404) return null;
                throw new Error(res.statusText);
            }
            throw res;
        });
    }
    getOrganizationsByContactPoint(options) {
        const { code: code } = options;
        const email = "email" in options ? options.email : null;
        const phoneNumber = "phoneNumber" in options ? options.phoneNumber : null;
        (0, $1622be301bae0161$export$a7a9523472993e97).ok((email || phoneNumber) && !(email && phoneNumber), "either email or phoneNumber is required");
        $4fc09928452de42f$var$assertString(code, "code");
        const contactPoint = email ? {
            type: "email",
            value: email
        } : {
            type: "phoneNumber",
            value: phoneNumber
        };
        return this._apiClient.request("/organization-queries", {
            method: "POST",
            data: {
                contactPoint: contactPoint,
                code: code
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (organization)=>$4fc09928452de42f$var$Organization.fromJson(organization));
        });
    }
    getOrganizationsByIdToken({ idToken: idToken }) {
        $4fc09928452de42f$var$assertString(idToken, "idToken");
        return this._apiClient.request("/organization-queries", {
            method: "POST",
            data: {
                idToken: idToken
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (organization)=>{
                return $4fc09928452de42f$var$Organization.fromJson(Object.assign({
                    permissions: {},
                    limits: {}
                }, $4fc09928452de42f$var$assertRecord(organization, "organization")));
            });
        });
    }
    getOrganizationsByLoggedInUser() {
        return this._apiClient.request("/user/organizations", {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (o)=>{
                return $4fc09928452de42f$var$Organization.fromJson(Object.assign({
                    permissions: {},
                    limits: {}
                }, $4fc09928452de42f$var$assertRecord(o, "organization")));
            });
        });
    }
    getSubdomainAvailability(subdomain) {
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        return this._apiClient.request(`/organization-subdomains/${encodeURIComponent(subdomain)}/availability`, {
            method: "GET"
        }).then(({ data: data })=>{
            $4fc09928452de42f$var$assertInstanceOf(data, Object, "data");
            return {
                status: $4fc09928452de42f$var$extractString(data, "status")
            };
        });
    }
    updatePreferences({ organizationId: organizationId, preferences: preferences }) {
        $4fc09928452de42f$var$assertTruthy(organizationId, "organizationId");
        $4fc09928452de42f$var$assertTruthy(preferences, "preferences");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}/preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    deleteOrganization({ organizationId: organizationId }) {
        $4fc09928452de42f$var$assertTruthy(organizationId, "organizationId");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}`, {
            method: "DELETE"
        }).then(()=>undefined);
    }
    constructor({ apiClient: apiClient }){
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$export$c93ff2f01d9e9b32 {
    initOrganization() {
        return this.fetchOrganization().then(()=>undefined);
    }
    fetchOrganization() {
        if (!this._organizationPromise) this._organizationPromise = this._organizationService.getOrganizationBySubdomain(this._subdomain);
        return this._organizationPromise;
    }
    constructor({ organizationService: organizationService, subdomain: subdomain }){
        this._organizationService = organizationService;
        this._subdomain = subdomain;
        this._organizationPromise = null;
    }
}
class $4fc09928452de42f$var$Room {
    constructor(properties = {}){
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(properties instanceof Object, "properties<object> must be empty or an object");
        this.isClaimed = false;
        this.isBanned = false;
        this.isLocked = false;
        this.knockPage = {
            backgroundImageUrl: null,
            backgroundThumbnailUrl: null
        };
        this.logoUrl = null;
        this.backgroundImageUrl = null;
        this.backgroundThumbnailUrl = null;
        this.type = null;
        this.legacyRoomType = null;
        this.mode = null;
        this.product = null;
        this.roomName = null;
        this.theme = null;
        this.preferences = {};
        this.protectedPreferences = {};
        this.publicProfile = null;
        const validProperties = {};
        Object.getOwnPropertyNames(properties).forEach((prop)=>{
            if (Object.getOwnPropertyNames(this).indexOf(prop) !== -1) validProperties[prop] = properties[prop];
        });
        if (properties.ownerId !== undefined) this.ownerId = properties.ownerId;
        if (properties.meeting !== undefined) this.meeting = properties.meeting;
        Object.assign(this, validProperties);
    }
}
class $4fc09928452de42f$var$Meeting {
    static fromJson(data) {
        return new $4fc09928452de42f$var$Meeting({
            meetingId: $4fc09928452de42f$var$extractString(data, "meetingId"),
            roomName: $4fc09928452de42f$var$extractString(data, "roomName"),
            roomUrl: $4fc09928452de42f$var$extractString(data, "roomUrl"),
            startDate: $4fc09928452de42f$var$extractDate(data, "startDate"),
            endDate: $4fc09928452de42f$var$extractDate(data, "endDate"),
            hostRoomUrl: $4fc09928452de42f$var$extractNullOrString(data, "hostRoomUrl"),
            viewerRoomUrl: $4fc09928452de42f$var$extractNullOrString(data, "viewerRoomUrl")
        });
    }
    constructor({ meetingId: meetingId, roomName: roomName, roomUrl: roomUrl, startDate: startDate, endDate: endDate, hostRoomUrl: hostRoomUrl, viewerRoomUrl: viewerRoomUrl }){
        $4fc09928452de42f$var$assertString(meetingId, "meetingId");
        $4fc09928452de42f$var$assertString(roomName, "roomName");
        $4fc09928452de42f$var$assertString(roomUrl, "roomUrl");
        $4fc09928452de42f$var$assertInstanceOf(startDate, Date, "startDate");
        $4fc09928452de42f$var$assertInstanceOf(endDate, Date, "endDate");
        this.meetingId = meetingId;
        this.roomName = roomName;
        this.roomUrl = roomUrl;
        this.startDate = startDate;
        this.endDate = endDate;
        this.hostRoomUrl = hostRoomUrl;
        this.viewerRoomUrl = viewerRoomUrl;
    }
}
function $4fc09928452de42f$var$createRoomUrl(roomName, path = "") {
    const encodedDisplayName = encodeURIComponent(roomName.substring(1));
    return `/room/${encodedDisplayName}${path}`;
}
class $4fc09928452de42f$export$a7d5657d420fa521 {
    getRooms({ types: types, fields: fields = [] } = {}) {
        $4fc09928452de42f$var$assertArray(types, "types");
        $4fc09928452de42f$var$assertArray(fields, "fields");
        return this._organizationApiClient.request("/room", {
            method: "GET",
            params: {
                types: types.join(","),
                fields: fields.join(","),
                includeOnlyLegacyRoomType: "false"
            }
        }).then(({ data: data })=>data.rooms.map((room)=>new $4fc09928452de42f$var$Room(room)));
    }
    getRoom({ roomName: roomName, fields: fields }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/rooms/${encodedDisplayName}`, {
            method: "GET",
            params: Object.assign({
                includeOnlyLegacyRoomType: "false"
            }, fields && {
                fields: fields.join(",")
            })
        }).then(({ data: data })=>new $4fc09928452de42f$var$Room(Object.assign({}, data, Object.assign({
                roomName: roomName
            }, data.meeting && {
                meeting: $4fc09928452de42f$var$Meeting.fromJson(data.meeting)
            })))).catch((response)=>{
            if (response.status === 404) return new $4fc09928452de42f$var$Room({
                roomName: roomName,
                isClaimed: false,
                mode: "normal",
                product: {
                    categoryName: "personal_free"
                },
                type: "personal",
                legacyRoomType: "free"
            });
            if (response.status === 400 && response.data.error === "Banned room") return new $4fc09928452de42f$var$Room({
                roomName: roomName,
                isBanned: true
            });
            throw new Error(response.data ? response.data.error : "Could not fetch room information");
        });
    }
    claimRoom({ roomName: roomName, type: type, mode: mode, isLocked: isLocked }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(type, "type");
        return this._organizationApiClient.request("/room/claim", {
            method: "POST",
            data: Object.assign(Object.assign({
                roomName: roomName,
                type: type
            }, typeof mode === "string" && {
                mode: mode
            }), typeof isLocked === "boolean" && {
                isLocked: isLocked
            })
        }).then(()=>undefined).catch((response)=>{
            throw new Error(response.data.error || "Failed to claim room");
        });
    }
    unclaimRoom(roomName) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}`, {
            method: "DELETE"
        }).then(()=>undefined);
    }
    renameRoom({ roomName: roomName, newRoomName: newRoomName }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(newRoomName, "newRoomName");
        const encodedRoomName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedRoomName}/roomName`, {
            method: "PUT",
            data: {
                newRoomName: newRoomName
            }
        }).then(()=>undefined);
    }
    changeMode({ roomName: roomName, mode: mode }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(mode, "mode");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/mode`, {
            method: "PUT",
            data: {
                mode: mode
            }
        }).then(()=>undefined);
    }
    updatePreferences({ roomName: roomName, preferences: preferences }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertInstanceOf(preferences, Object, "preferences");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    updateProtectedPreferences({ roomName: roomName, preferences: preferences }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertInstanceOf(preferences, Object, "preferences");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/protected-preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    getRoomPermissions(roomName, { roomKey: roomKey } = {}) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, "/permissions"), Object.assign({
            method: "GET"
        }, roomKey && {
            headers: {
                "X-Whereby-Room-Key": roomKey
            }
        })).then((response)=>{
            const { permissions: permissions, limits: limits } = response.data;
            return {
                permissions: permissions,
                limits: limits
            };
        });
    }
    getRoomMetrics({ roomName: roomName, metrics: metrics, from: from, to: to }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(metrics, "metrics");
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, "/metrics"), {
            method: "GET",
            params: {
                metrics: metrics,
                from: from,
                to: to
            }
        }).then((response)=>response.data);
    }
    changeType({ roomName: roomName, type: type }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertOneOf(type, [
            "personal",
            "personal_xl"
        ], "type");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/type`, {
            method: "PUT",
            data: {
                type: type
            }
        }).then(()=>undefined);
    }
    getForestSocialImage({ roomName: roomName, count: count }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertNumber(count, "count");
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, `/forest-social-image/${count}`), {
            method: "GET"
        }).then((response)=>response.data.imageUrl);
    }
    constructor({ organizationApiClient: organizationApiClient }){
        this._organizationApiClient = $4fc09928452de42f$var$assertInstanceOf(organizationApiClient, $4fc09928452de42f$export$6fe2794aa8aa0e05);
    }
}
class $4fc09928452de42f$var$RoomParticipant {
    constructor({ displayName: displayName, id: id, stream: stream, isAudioEnabled: isAudioEnabled, isVideoEnabled: isVideoEnabled, stickyReaction: stickyReaction, isDialIn: isDialIn }){
        this.isLocalParticipant = false;
        this.displayName = displayName;
        this.id = id;
        this.stream = stream;
        this.isAudioEnabled = isAudioEnabled;
        this.isVideoEnabled = isVideoEnabled;
        this.stickyReaction = stickyReaction;
        this.isDialIn = isDialIn;
    }
}
class $4fc09928452de42f$export$ed007fa30041dd89 extends $4fc09928452de42f$var$RoomParticipant {
    constructor({ displayName: displayName, id: id, stream: stream, isAudioEnabled: isAudioEnabled, isVideoEnabled: isVideoEnabled, stickyReaction: stickyReaction, isDialIn: isDialIn }){
        super({
            displayName: displayName,
            id: id,
            stream: stream,
            isAudioEnabled: isAudioEnabled,
            isVideoEnabled: isVideoEnabled,
            stickyReaction: stickyReaction,
            isDialIn: isDialIn
        });
        this.isLocalParticipant = true;
    }
}
const $4fc09928452de42f$var$API_BASE_URL = "https://api.whereby.dev";
function $4fc09928452de42f$export$1f39bff4033c2336() {
    const credentialsService = $4fc09928452de42f$export$3977fa7307407ad9.create({
        baseUrl: $4fc09928452de42f$var$API_BASE_URL
    });
    const apiClient = new $4fc09928452de42f$export$dc890958d2b428da({
        fetchDeviceCredentials: credentialsService.getCredentials.bind(credentialsService),
        baseUrl: $4fc09928452de42f$var$API_BASE_URL
    });
    const organizationService = new $4fc09928452de42f$export$abbf95a02a0c9d38({
        apiClient: apiClient
    });
    const fetchOrganizationFromRoomUrl = (roomUrl)=>{
        const roomUrlObj = new URL(roomUrl);
        const urls = (0, $1622be301bae0161$export$a08dede735aa5b41)({
            host: roomUrlObj.host
        });
        const organizationServiceCache = new $4fc09928452de42f$export$c93ff2f01d9e9b32({
            organizationService: organizationService,
            subdomain: urls.subdomain
        });
        return organizationServiceCache.fetchOrganization();
    };
    return {
        credentialsService: credentialsService,
        apiClient: apiClient,
        organizationService: organizationService,
        fetchOrganizationFromRoomUrl: fetchOrganizationFromRoomUrl
    };
}



var $72a1b7fe1c0aa35a$exports = {};
"use strict";
const $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START = 0xd800;
const $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_END = 0xdbff;
const $72a1b7fe1c0aa35a$var$LOW_SURROGATE_START = 0xdc00;
const $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_START = 0x1f1e6;
const $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_END = 0x1f1ff;
const $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_START = 0x1f3fb;
const $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_END = 0x1f3ff;
const $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_START = 0xfe00;
const $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_END = 0xfe0f;
const $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_START = 0x20d0;
const $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_END = 0x20ff;
const $72a1b7fe1c0aa35a$var$ZWJ = 0x200d;
const $72a1b7fe1c0aa35a$var$GRAPHEMS = [
    0x0308,
    0x0937,
    0x0937,
    0x093F,
    0x093F,
    0x0BA8,
    0x0BBF,
    0x0BCD,
    0x0E31,
    0x0E33,
    0x0E40,
    0x0E49,
    0x1100,
    0x1161,
    0x11A8 // ( ᆨ ) HANGUL JONGSEONG KIYEOK
];
function $72a1b7fe1c0aa35a$var$runes(string) {
    if (typeof string !== "string") throw new Error("string cannot be undefined or null");
    const result = [];
    let i = 0;
    let increment = 0;
    while(i < string.length){
        increment += $72a1b7fe1c0aa35a$var$nextUnits(i + increment, string);
        if ($72a1b7fe1c0aa35a$var$isGraphem(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isVariationSelector(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isDiacriticalMark(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isZeroWidthJoiner(string[i + increment])) {
            increment++;
            continue;
        }
        result.push(string.substring(i, i + increment));
        i += increment;
        increment = 0;
    }
    return result;
}
// Decide how many code units make up the current character.
// BMP characters: 1 code unit
// Non-BMP characters (represented by surrogate pairs): 2 code units
// Emoji with skin-tone modifiers: 4 code units (2 code points)
// Country flags: 4 code units (2 code points)
// Variations: 2 code units
function $72a1b7fe1c0aa35a$var$nextUnits(i, string) {
    const current = string[i];
    // If we don't have a value that is part of a surrogate pair, or we're at
    // the end, only take the value at i
    if (!$72a1b7fe1c0aa35a$var$isFirstOfSurrogatePair(current) || i === string.length - 1) return 1;
    const currentPair = current + string[i + 1];
    let nextPair = string.substring(i + 2, i + 5);
    // Country flags are comprised of two regional indicator symbols,
    // each represented by a surrogate pair.
    // See http://emojipedia.org/flags/
    // If both pairs are regional indicator symbols, take 4
    if ($72a1b7fe1c0aa35a$var$isRegionalIndicator(currentPair) && $72a1b7fe1c0aa35a$var$isRegionalIndicator(nextPair)) return 4;
    // If the next pair make a Fitzpatrick skin tone
    // modifier, take 4
    // See http://emojipedia.org/modifiers/
    // Technically, only some code points are meant to be
    // combined with the skin tone modifiers. This function
    // does not check the current pair to see if it is
    // one of them.
    if ($72a1b7fe1c0aa35a$var$isFitzpatrickModifier(nextPair)) return 4;
    return 2;
}
function $72a1b7fe1c0aa35a$var$isFirstOfSurrogatePair(string) {
    return string && $72a1b7fe1c0aa35a$var$betweenInclusive(string[0].charCodeAt(0), $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START, $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_END);
}
function $72a1b7fe1c0aa35a$var$isRegionalIndicator(string) {
    return $72a1b7fe1c0aa35a$var$betweenInclusive($72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(string), $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_START, $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_END);
}
function $72a1b7fe1c0aa35a$var$isFitzpatrickModifier(string) {
    return $72a1b7fe1c0aa35a$var$betweenInclusive($72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(string), $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_START, $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_END);
}
function $72a1b7fe1c0aa35a$var$isVariationSelector(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$betweenInclusive(string.charCodeAt(0), $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_START, $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_END);
}
function $72a1b7fe1c0aa35a$var$isDiacriticalMark(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$betweenInclusive(string.charCodeAt(0), $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_START, $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_END);
}
function $72a1b7fe1c0aa35a$var$isGraphem(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$GRAPHEMS.indexOf(string.charCodeAt(0)) !== -1;
}
function $72a1b7fe1c0aa35a$var$isZeroWidthJoiner(string) {
    return typeof string === "string" && string.charCodeAt(0) === $72a1b7fe1c0aa35a$var$ZWJ;
}
function $72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(pair) {
    const highOffset = pair.charCodeAt(0) - $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START;
    const lowOffset = pair.charCodeAt(1) - $72a1b7fe1c0aa35a$var$LOW_SURROGATE_START;
    return (highOffset << 10) + lowOffset + 0x10000;
}
function $72a1b7fe1c0aa35a$var$betweenInclusive(value, lower, upper) {
    return value >= lower && value <= upper;
}
function $72a1b7fe1c0aa35a$var$substring(string, start, width) {
    const chars = $72a1b7fe1c0aa35a$var$runes(string);
    if (start === undefined) return string;
    if (start >= chars.length) return "";
    const rest = chars.length - start;
    const stringWidth = width === undefined ? rest : width;
    let endIndex = start + stringWidth;
    if (endIndex > start + rest) endIndex = undefined;
    return chars.slice(start, endIndex).join("");
}
$72a1b7fe1c0aa35a$exports = $72a1b7fe1c0aa35a$var$runes;
$72a1b7fe1c0aa35a$exports.substr = $72a1b7fe1c0aa35a$var$substring;



var $eZVvM = parcelRequire("eZVvM");
// packages/core/primitive/src/primitive.tsx
function $d56aa65487310417$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $eZVvM = parcelRequire("eZVvM");
function $da3ef91b9f88cf6d$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $da3ef91b9f88cf6d$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$da3ef91b9f88cf6d$var$setRef(ref, node));
}
function $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05(...refs) {
    return $eZVvM.useCallback($da3ef91b9f88cf6d$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");
function $e6270c096fd5048f$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $eZVvM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $eZVvM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $eZVvM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $e6270c096fd5048f$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $eZVvM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            var _scope_scopeName;
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const value = $eZVvM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            var _scope_scopeName;
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const context = $eZVvM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $eZVvM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $eZVvM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e6270c096fd5048f$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e6270c096fd5048f$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $eZVvM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $eZVvM = parcelRequire("eZVvM");

// packages/react/primitive/src/Primitive.tsx

var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
// packages/react/slot/src/Slot.tsx

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
var $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $eZVvM.Children.toArray(children);
    const slottable = childrenArray.find($bbe7ec9b0e1df2a2$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($eZVvM.Children.count(newElement) > 1) return $eZVvM.Children.only(null);
                return $eZVvM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $3pI8R.jsx)($bbe7ec9b0e1df2a2$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $eZVvM.isValidElement(newElement) ? $eZVvM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $3pI8R.jsx)($bbe7ec9b0e1df2a2$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360.displayName = "Slot";
var $bbe7ec9b0e1df2a2$var$SlotClone = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($eZVvM.isValidElement(children)) {
        const childrenRef = $bbe7ec9b0e1df2a2$var$getElementRef(children);
        return $eZVvM.cloneElement(children, {
            ...$bbe7ec9b0e1df2a2$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $da3ef91b9f88cf6d$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $eZVvM.Children.count(children) > 1 ? $eZVvM.Children.only(null) : null;
});
$bbe7ec9b0e1df2a2$var$SlotClone.displayName = "SlotClone";
var $bbe7ec9b0e1df2a2$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $3pI8R.Fragment), {
        children: children
    });
};
function $bbe7ec9b0e1df2a2$var$isSlottable(child) {
    return $eZVvM.isValidElement(child) && child.type === $bbe7ec9b0e1df2a2$export$d9f1ccf0bdb05d45;
}
function $bbe7ec9b0e1df2a2$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $bbe7ec9b0e1df2a2$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $bbe7ec9b0e1df2a2$export$be92b6f5f03c0fe9 = $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360;



var $3pI8R = parcelRequire("3pI8R");
var $f8aef97de159082a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $f8aef97de159082a$export$250ffa63cdc0d034 = $f8aef97de159082a$var$NODES.reduce((primitive, node)=>{
    const Node = $eZVvM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $f8aef97de159082a$export$6d1a0317bde7de7f(target, event) {
    if (target) $e4ZGj.flushSync(()=>target.dispatchEvent(event));
}
var $f8aef97de159082a$export$be92b6f5f03c0fe9 = $f8aef97de159082a$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $eZVvM = parcelRequire("eZVvM");
function $4f278f864fa95caf$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $eZVvM.useRef(callback);
    $eZVvM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $eZVvM.useMemo(()=>(...args)=>{
            var _callbackRef_current;
            return (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 ? void 0 : _callbackRef_current.call(callbackRef, ...args);
        }, []);
}


// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $eZVvM = parcelRequire("eZVvM");

function $5821aae492c28aef$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const onEscapeKeyDown = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $eZVvM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $927c851443b37d6c$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $927c851443b37d6c$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $927c851443b37d6c$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $927c851443b37d6c$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $927c851443b37d6c$var$originalBodyPointerEvents;
var $927c851443b37d6c$var$DismissableLayerContext = $eZVvM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $927c851443b37d6c$export$177fb62ff3ec1f22 = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _globalThis;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $eZVvM.useContext($927c851443b37d6c$var$DismissableLayerContext);
    const [node, setNode] = $eZVvM.useState(null);
    var _node_ownerDocument;
    const ownerDocument = (_node_ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node_ownerDocument !== void 0 ? _node_ownerDocument : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    const [, force] = $eZVvM.useState({});
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $927c851443b37d6c$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 ? void 0 : onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = $927c851443b37d6c$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 ? void 0 : onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    (0, $5821aae492c28aef$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $eZVvM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $927c851443b37d6c$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $927c851443b37d6c$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $927c851443b37d6c$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $927c851443b37d6c$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $eZVvM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($927c851443b37d6c$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($927c851443b37d6c$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$927c851443b37d6c$export$177fb62ff3ec1f22.displayName = $927c851443b37d6c$var$DISMISSABLE_LAYER_NAME;
var $927c851443b37d6c$var$BRANCH_NAME = "DismissableLayerBranch";
var $927c851443b37d6c$export$4d5eb2109db14228 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $eZVvM.useContext($927c851443b37d6c$var$DismissableLayerContext);
    const ref = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $eZVvM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$927c851443b37d6c$export$4d5eb2109db14228.displayName = $927c851443b37d6c$var$BRANCH_NAME;
function $927c851443b37d6c$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handlePointerDownOutside = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $eZVvM.useRef(false);
    const handleClickRef = $eZVvM.useRef(()=>{});
    $eZVvM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $927c851443b37d6c$var$handleAndDispatchCustomEvent($927c851443b37d6c$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $927c851443b37d6c$var$useFocusOutside(onFocusOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handleFocusOutside = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $927c851443b37d6c$var$handleAndDispatchCustomEvent($927c851443b37d6c$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $927c851443b37d6c$var$dispatchUpdate() {
    const event = new CustomEvent($927c851443b37d6c$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $927c851443b37d6c$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $f8aef97de159082a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $927c851443b37d6c$export$be92b6f5f03c0fe9 = $927c851443b37d6c$export$177fb62ff3ec1f22;
var $927c851443b37d6c$export$aecb2ddcb55c95be = $927c851443b37d6c$export$4d5eb2109db14228;



var $eZVvM = parcelRequire("eZVvM");
"use client";
var $8a88dc3631ad332b$var$count = 0;
function $8a88dc3631ad332b$export$ac5b58043b79449b(props) {
    $8a88dc3631ad332b$export$b7ece24a22aeda8c();
    return props.children;
}
function $8a88dc3631ad332b$export$b7ece24a22aeda8c() {
    $eZVvM.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        var _edgeGuards_;
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards_ = edgeGuards[0]) !== null && _edgeGuards_ !== void 0 ? _edgeGuards_ : $8a88dc3631ad332b$var$createFocusGuard());
        var _edgeGuards_1;
        document.body.insertAdjacentElement("beforeend", (_edgeGuards_1 = edgeGuards[1]) !== null && _edgeGuards_1 !== void 0 ? _edgeGuards_1 : $8a88dc3631ad332b$var$createFocusGuard());
        $8a88dc3631ad332b$var$count++;
        return ()=>{
            if ($8a88dc3631ad332b$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $8a88dc3631ad332b$var$count--;
        };
    }, []);
}
function $8a88dc3631ad332b$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $8a88dc3631ad332b$export$be92b6f5f03c0fe9 = $8a88dc3631ad332b$export$ac5b58043b79449b;



var $eZVvM = parcelRequire("eZVvM");




var $3pI8R = parcelRequire("3pI8R");
"use client";
var $5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $5fa700d9aec4b79b$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $5fa700d9aec4b79b$var$FOCUS_SCOPE_NAME = "FocusScope";
var $5fa700d9aec4b79b$export$20e40289641fbbb6 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $eZVvM.useState(null);
    const onMountAutoFocus = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $eZVvM.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $eZVvM.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $5fa700d9aec4b79b$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $5fa700d9aec4b79b$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $5fa700d9aec4b79b$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $eZVvM.useEffect(()=>{
        if (container) {
            $5fa700d9aec4b79b$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, $5fa700d9aec4b79b$var$EVENT_OPTIONS);
                container.addEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $5fa700d9aec4b79b$var$focusFirst($5fa700d9aec4b79b$var$removeLinks($5fa700d9aec4b79b$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $5fa700d9aec4b79b$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, $5fa700d9aec4b79b$var$EVENT_OPTIONS);
                    container.addEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $5fa700d9aec4b79b$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    container.removeEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $5fa700d9aec4b79b$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $eZVvM.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $5fa700d9aec4b79b$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $5fa700d9aec4b79b$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $5fa700d9aec4b79b$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$5fa700d9aec4b79b$export$20e40289641fbbb6.displayName = $5fa700d9aec4b79b$var$FOCUS_SCOPE_NAME;
function $5fa700d9aec4b79b$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $5fa700d9aec4b79b$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $5fa700d9aec4b79b$var$getTabbableEdges(container) {
    const candidates = $5fa700d9aec4b79b$var$getTabbableCandidates(container);
    const first = $5fa700d9aec4b79b$var$findVisible(candidates, container);
    const last = $5fa700d9aec4b79b$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $5fa700d9aec4b79b$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $5fa700d9aec4b79b$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$5fa700d9aec4b79b$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $5fa700d9aec4b79b$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $5fa700d9aec4b79b$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $5fa700d9aec4b79b$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $5fa700d9aec4b79b$var$isSelectableInput(element) && select) element.select();
    }
}
var $5fa700d9aec4b79b$var$focusScopesStack = $5fa700d9aec4b79b$var$createFocusScopesStack();
function $5fa700d9aec4b79b$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            stack = $5fa700d9aec4b79b$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack_;
            stack = $5fa700d9aec4b79b$var$arrayRemove(stack, focusScope);
            (_stack_ = stack[0]) === null || _stack_ === void 0 ? void 0 : _stack_.resume();
        }
    };
}
function $5fa700d9aec4b79b$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $5fa700d9aec4b79b$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $5fa700d9aec4b79b$export$be92b6f5f03c0fe9 = $5fa700d9aec4b79b$export$20e40289641fbbb6;


// packages/react/id/src/id.tsx

var $eZVvM = parcelRequire("eZVvM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $eZVvM = parcelRequire("eZVvM");
var $9260723ef1eb7b27$var$_globalThis;
var $9260723ef1eb7b27$export$e5c5a5f917a5871c = Boolean(($9260723ef1eb7b27$var$_globalThis = globalThis) === null || $9260723ef1eb7b27$var$_globalThis === void 0 ? void 0 : $9260723ef1eb7b27$var$_globalThis.document) ? $eZVvM.useLayoutEffect : ()=>{};


var $92fce9891f0372ca$var$useReactId = $eZVvM["useId".toString()] || (()=>void 0);
var $92fce9891f0372ca$var$count = 0;
function $92fce9891f0372ca$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $eZVvM.useState($92fce9891f0372ca$var$useReactId());
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($92fce9891f0372ca$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e43d3a7503668d03$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $e43d3a7503668d03$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $e43d3a7503668d03$export$803cd8101b6c182b = /*#__PURE__*/ $e43d3a7503668d03$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e43d3a7503668d03$export$27b07d8a310ed8b5[0], side + "-" + $e43d3a7503668d03$export$27b07d8a310ed8b5[1]), []);
const $e43d3a7503668d03$export$96ec731ed4dcb222 = Math.min;
const $e43d3a7503668d03$export$8960430cfd85939f = Math.max;
const $e43d3a7503668d03$export$2077e0241d6afd3c = Math.round;
const $e43d3a7503668d03$export$a3fe094919f356fd = Math.floor;
const $e43d3a7503668d03$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e43d3a7503668d03$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $e43d3a7503668d03$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $e43d3a7503668d03$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e43d3a7503668d03$export$8960430cfd85939f(start, $e43d3a7503668d03$export$96ec731ed4dcb222(value, end));
}
function $e43d3a7503668d03$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $e43d3a7503668d03$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $e43d3a7503668d03$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $e43d3a7503668d03$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $e43d3a7503668d03$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $e43d3a7503668d03$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($e43d3a7503668d03$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $e43d3a7503668d03$export$2b57e0052a6d6d4c(placement) {
    return $e43d3a7503668d03$export$8a000a963141ac32($e43d3a7503668d03$export$f28e8f882010718a(placement));
}
function $e43d3a7503668d03$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e43d3a7503668d03$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e43d3a7503668d03$export$2b57e0052a6d6d4c(placement);
    const length = $e43d3a7503668d03$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e43d3a7503668d03$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e43d3a7503668d03$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e43d3a7503668d03$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e43d3a7503668d03$export$9c5e28bad23365fa(placement);
    return [
        $e43d3a7503668d03$export$2b182c584985588b(placement),
        oppositePlacement,
        $e43d3a7503668d03$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e43d3a7503668d03$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$e43d3a7503668d03$var$oppositeAlignmentMap[alignment]);
}
function $e43d3a7503668d03$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $e43d3a7503668d03$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e43d3a7503668d03$export$f0989780f32bfcda(placement);
    let list = $e43d3a7503668d03$var$getSideList($e43d3a7503668d03$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e43d3a7503668d03$export$2b182c584985588b));
    }
    return list;
}
function $e43d3a7503668d03$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$e43d3a7503668d03$var$oppositeSideMap[side]);
}
function $e43d3a7503668d03$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $e43d3a7503668d03$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $e43d3a7503668d03$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e43d3a7503668d03$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $04abf95d0af710a5$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $e43d3a7503668d03$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $e43d3a7503668d03$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $04abf95d0af710a5$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $04abf95d0af710a5$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $04abf95d0af710a5$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $04abf95d0af710a5$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $04abf95d0af710a5$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $e43d3a7503668d03$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $e43d3a7503668d03$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $04abf95d0af710a5$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $e43d3a7503668d03$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $04abf95d0af710a5$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $e43d3a7503668d03$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $e43d3a7503668d03$export$803cd8101b6c182b) ? $04abf95d0af710a5$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $e43d3a7503668d03$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $e43d3a7503668d03$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $e43d3a7503668d03$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $04abf95d0af710a5$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $e43d3a7503668d03$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $e43d3a7503668d03$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $e43d3a7503668d03$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $e43d3a7503668d03$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $04abf95d0af710a5$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $04abf95d0af710a5$var$isAnySideFullyClipped(overflow) {
    return (0, $e43d3a7503668d03$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $04abf95d0af710a5$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $04abf95d0af710a5$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $04abf95d0af710a5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $04abf95d0af710a5$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $04abf95d0af710a5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $04abf95d0af710a5$var$getBoundingRect(rects) {
    const minX = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $04abf95d0af710a5$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $e43d3a7503668d03$export$ee05aea0aeecbad4)($04abf95d0af710a5$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $04abf95d0af710a5$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $04abf95d0af710a5$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)($04abf95d0af710a5$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $04abf95d0af710a5$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $04abf95d0af710a5$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $04abf95d0af710a5$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $04abf95d0af710a5$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)((0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $e43d3a7503668d03$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $04abf95d0af710a5$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $e43d3a7503668d03$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $04abf95d0af710a5$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $cf420724ebafb241$var$hasWindow() {
    return typeof window !== "undefined";
}
function $cf420724ebafb241$export$651544f548703224(node) {
    if ($cf420724ebafb241$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $cf420724ebafb241$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $cf420724ebafb241$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($cf420724ebafb241$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $cf420724ebafb241$export$8ee0fc9ee280b4ee(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).Node;
}
function $cf420724ebafb241$export$45a5e7f76e0caa8d(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).Element;
}
function $cf420724ebafb241$export$1b3bfaa9684536aa(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).HTMLElement;
}
function $cf420724ebafb241$export$af51f0f06c0f328a(value) {
    if (!$cf420724ebafb241$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $cf420724ebafb241$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $cf420724ebafb241$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $cf420724ebafb241$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($cf420724ebafb241$export$651544f548703224(element));
}
function $cf420724ebafb241$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $cf420724ebafb241$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $cf420724ebafb241$export$78551043582a6a98();
    const css = $cf420724ebafb241$export$45a5e7f76e0caa8d(elementOrCss) ? $cf420724ebafb241$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $cf420724ebafb241$export$940d8225183e1404(element) {
    let currentNode = $cf420724ebafb241$export$4e12058fc4d51d56(element);
    while($cf420724ebafb241$export$1b3bfaa9684536aa(currentNode) && !$cf420724ebafb241$export$d1162fb0b6d4cd51(currentNode)){
        if ($cf420724ebafb241$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($cf420724ebafb241$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $cf420724ebafb241$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $cf420724ebafb241$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $cf420724ebafb241$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($cf420724ebafb241$export$651544f548703224(node));
}
function $cf420724ebafb241$export$3735103072e4a80(element) {
    return $cf420724ebafb241$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $cf420724ebafb241$export$dc8fc79fa2800137(element) {
    if ($cf420724ebafb241$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $cf420724ebafb241$export$4e12058fc4d51d56(node) {
    if ($cf420724ebafb241$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $cf420724ebafb241$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $cf420724ebafb241$export$e495491855dc5418(node);
    return $cf420724ebafb241$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $cf420724ebafb241$export$7cd01a57c8ca906c(node) {
    const parentNode = $cf420724ebafb241$export$4e12058fc4d51d56(node);
    if ($cf420724ebafb241$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($cf420724ebafb241$export$1b3bfaa9684536aa(parentNode) && $cf420724ebafb241$export$989e911fa9af580a(parentNode)) return parentNode;
    return $cf420724ebafb241$export$7cd01a57c8ca906c(parentNode);
}
function $cf420724ebafb241$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $cf420724ebafb241$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $cf420724ebafb241$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $cf420724ebafb241$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $cf420724ebafb241$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $cf420724ebafb241$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $cf420724ebafb241$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $cf420724ebafb241$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $6502644ced543179$var$getCssDimensions(element) {
    const css = (0, $cf420724ebafb241$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $6502644ced543179$var$unwrapElement(element) {
    return !(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $6502644ced543179$var$getScale(element) {
    const domElement = $6502644ced543179$var$unwrapElement(element);
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(domElement)) return (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $6502644ced543179$var$getCssDimensions(domElement);
    let x = ($ ? (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $6502644ced543179$var$noOffsets = /*#__PURE__*/ (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
function $6502644ced543179$var$getVisualOffsets(element) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    if (!(0, $cf420724ebafb241$export$78551043582a6a98)() || !win.visualViewport) return $6502644ced543179$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $6502644ced543179$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $6502644ced543179$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $6502644ced543179$var$unwrapElement(element);
    let scale = (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(offsetParent)) scale = $6502644ced543179$var$getScale(offsetParent);
        } else scale = $6502644ced543179$var$getScale(element);
    }
    const visualOffsets = $6502644ced543179$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $6502644ced543179$var$getVisualOffsets(domElement) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $cf420724ebafb241$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $cf420724ebafb241$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $6502644ced543179$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $cf420724ebafb241$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $cf420724ebafb241$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $6502644ced543179$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $6502644ced543179$var$getBoundingClientRect((0, $cf420724ebafb241$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $6502644ced543179$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $6502644ced543179$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $6502644ced543179$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $cf420724ebafb241$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $cf420724ebafb241$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const offsets = (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cf420724ebafb241$export$651544f548703224)(offsetParent) !== "body" || (0, $cf420724ebafb241$export$989e911fa9af580a)(documentElement)) scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $6502644ced543179$var$getBoundingClientRect(offsetParent);
            scale = $6502644ced543179$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6502644ced543179$var$getHTMLOffset(documentElement, scroll, true) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $6502644ced543179$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $6502644ced543179$var$getDocumentRect(element) {
    const html = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    const scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $6502644ced543179$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $cf420724ebafb241$export$3735103072e4a80)(body).direction === "rtl") x += (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6502644ced543179$var$getViewportRect(element, strategy) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    const html = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $cf420724ebafb241$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $6502644ced543179$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $6502644ced543179$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element) ? $6502644ced543179$var$getScale(element) : (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6502644ced543179$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $6502644ced543179$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $6502644ced543179$var$getDocumentRect((0, $cf420724ebafb241$export$e495491855dc5418)(element));
    else if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $6502644ced543179$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $6502644ced543179$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(rect);
}
function $6502644ced543179$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(parentNode) || (0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $cf420724ebafb241$export$3735103072e4a80)(parentNode).position === "fixed" || $6502644ced543179$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $6502644ced543179$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $cf420724ebafb241$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(el) && (0, $cf420724ebafb241$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(currentNode) && !(0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $cf420724ebafb241$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $cf420724ebafb241$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $cf420724ebafb241$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $6502644ced543179$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $6502644ced543179$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $cf420724ebafb241$export$89e651af02346cd4)(element) ? [] : $6502644ced543179$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $6502644ced543179$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $e43d3a7503668d03$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $e43d3a7503668d03$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $6502644ced543179$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $6502644ced543179$var$getDimensions(element) {
    const { width: width, height: height } = $6502644ced543179$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $6502644ced543179$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $cf420724ebafb241$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $6502644ced543179$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cf420724ebafb241$export$651544f548703224)(offsetParent) !== "body" || (0, $cf420724ebafb241$export$989e911fa9af580a)(documentElement)) scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $6502644ced543179$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $6502644ced543179$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6502644ced543179$var$getHTMLOffset(documentElement, scroll) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $6502644ced543179$var$isStaticPositioned(element) {
    return (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "static";
}
function $6502644ced543179$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element) || (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $cf420724ebafb241$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $6502644ced543179$var$getOffsetParent(element, polyfill) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    if ((0, $cf420724ebafb241$export$89e651af02346cd4)(element)) return win;
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$6502644ced543179$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $6502644ced543179$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $cf420724ebafb241$export$71535ffaa902797f)(offsetParent) && $6502644ced543179$var$isStaticPositioned(offsetParent))offsetParent = $6502644ced543179$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(offsetParent) && $6502644ced543179$var$isStaticPositioned(offsetParent) && !(0, $cf420724ebafb241$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $cf420724ebafb241$export$940d8225183e1404)(element) || win;
}
const $6502644ced543179$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $6502644ced543179$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $6502644ced543179$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $6502644ced543179$var$isRTL(element) {
    return (0, $cf420724ebafb241$export$3735103072e4a80)(element).direction === "rtl";
}
const $6502644ced543179$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $6502644ced543179$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $cf420724ebafb241$export$e495491855dc5418,
    getClippingRect: $6502644ced543179$var$getClippingRect,
    getOffsetParent: $6502644ced543179$var$getOffsetParent,
    getElementRects: $6502644ced543179$var$getElementRects,
    getClientRects: $6502644ced543179$var$getClientRects,
    getDimensions: $6502644ced543179$var$getDimensions,
    getScale: $6502644ced543179$var$getScale,
    isElement: $cf420724ebafb241$export$45a5e7f76e0caa8d,
    isRTL: $6502644ced543179$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $6502644ced543179$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(top);
        const insetRight = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $e43d3a7503668d03$export$8960430cfd85939f)(0, (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $6502644ced543179$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $6502644ced543179$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $cf420724ebafb241$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $cf420724ebafb241$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $6502644ced543179$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $6502644ced543179$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $6502644ced543179$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $6502644ced543179$export$37b6bde19b108ecc = (0, $04abf95d0af710a5$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6502644ced543179$export$cc800923e997bb8 = (0, $04abf95d0af710a5$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6502644ced543179$export$91fb6ecbd551914 = (0, $04abf95d0af710a5$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6502644ced543179$export$fba63a578e423eb = (0, $04abf95d0af710a5$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6502644ced543179$export$8a83211c878a3f1f = (0, $04abf95d0af710a5$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6502644ced543179$export$346677f925de839c = (0, $04abf95d0af710a5$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6502644ced543179$export$fe8985bb6374093c = (0, $04abf95d0af710a5$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6502644ced543179$export$f2120bbfa5450bd2 = (0, $04abf95d0af710a5$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6502644ced543179$export$18c8ad048e32c7d5 = (0, $04abf95d0af710a5$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6502644ced543179$export$7bf07e38f3dc4b69 = (0, $04abf95d0af710a5$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $6502644ced543179$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $6502644ced543179$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $04abf95d0af710a5$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
var $9912140e987fac9e$var$index = typeof document !== "undefined" ? (0, $eZVvM.useLayoutEffect) : (0, $eZVvM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $9912140e987fac9e$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$9912140e987fac9e$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$9912140e987fac9e$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $9912140e987fac9e$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $9912140e987fac9e$var$roundByDPR(element, value) {
    const dpr = $9912140e987fac9e$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $9912140e987fac9e$var$useLatestRef(value) {
    const ref = $eZVvM.useRef(value);
    $9912140e987fac9e$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9912140e987fac9e$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $eZVvM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $eZVvM.useState(middleware);
    if (!$9912140e987fac9e$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $eZVvM.useState(null);
    const [_floating, _setFloating] = $eZVvM.useState(null);
    const setReference = $eZVvM.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $eZVvM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $eZVvM.useRef(null);
    const floatingRef = $eZVvM.useRef(null);
    const dataRef = $eZVvM.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $9912140e987fac9e$var$useLatestRef(whileElementsMounted);
    const platformRef = $9912140e987fac9e$var$useLatestRef(platform);
    const openRef = $9912140e987fac9e$var$useLatestRef(open);
    const update = $eZVvM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $6502644ced543179$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$9912140e987fac9e$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $e4ZGj.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $9912140e987fac9e$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $eZVvM.useRef(false);
    $9912140e987fac9e$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $9912140e987fac9e$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $eZVvM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $eZVvM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $eZVvM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $9912140e987fac9e$var$roundByDPR(elements.floating, data.x);
        const y = $9912140e987fac9e$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$9912140e987fac9e$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $eZVvM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9912140e987fac9e$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $6502644ced543179$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $6502644ced543179$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9912140e987fac9e$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $6502644ced543179$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9912140e987fac9e$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $6502644ced543179$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9912140e987fac9e$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $6502644ced543179$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9912140e987fac9e$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $6502644ced543179$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9912140e987fac9e$export$346677f925de839c = (options, deps)=>({
        ...(0, $6502644ced543179$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9912140e987fac9e$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $6502644ced543179$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9912140e987fac9e$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $6502644ced543179$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9912140e987fac9e$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $6502644ced543179$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9912140e987fac9e$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$9912140e987fac9e$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


// packages/react/arrow/src/Arrow.tsx

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
var $4d5ebdb6606821b3$var$NAME = "Arrow";
var $4d5ebdb6606821b3$export$21b07c8f274aebd5 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $3pI8R.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$4d5ebdb6606821b3$export$21b07c8f274aebd5.displayName = $4d5ebdb6606821b3$var$NAME;
var $4d5ebdb6606821b3$export$be92b6f5f03c0fe9 = $4d5ebdb6606821b3$export$21b07c8f274aebd5;



// packages/react/context/src/createContext.tsx

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");
function $a3d7715a4bb999f3$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $eZVvM.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $eZVvM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $eZVvM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $a3d7715a4bb999f3$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $eZVvM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const value = $eZVvM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = $eZVvM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $eZVvM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $eZVvM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $a3d7715a4bb999f3$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $a3d7715a4bb999f3$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $eZVvM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}





// packages/react/use-size/src/useSize.tsx

var $eZVvM = parcelRequire("eZVvM");

function $416ecf6d578e0a29$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $eZVvM.useState(void 0);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $1d6744c3033b8e6e$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $1d6744c3033b8e6e$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $1d6744c3033b8e6e$var$POPPER_NAME = "Popper";
var [$1d6744c3033b8e6e$var$createPopperContext, $1d6744c3033b8e6e$export$722aac194ae923] = (0, $a3d7715a4bb999f3$export$50c7b4e9d9f19c1)($1d6744c3033b8e6e$var$POPPER_NAME);
var [$1d6744c3033b8e6e$var$PopperProvider, $1d6744c3033b8e6e$var$usePopperContext] = $1d6744c3033b8e6e$var$createPopperContext($1d6744c3033b8e6e$var$POPPER_NAME);
var $1d6744c3033b8e6e$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $eZVvM.useState(null);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$1d6744c3033b8e6e$export$badac9ada3a0bdf9.displayName = $1d6744c3033b8e6e$var$POPPER_NAME;
var $1d6744c3033b8e6e$var$ANCHOR_NAME = "PopperAnchor";
var $1d6744c3033b8e6e$export$ecd4e1ccab6ed6d = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $1d6744c3033b8e6e$var$usePopperContext($1d6744c3033b8e6e$var$ANCHOR_NAME, __scopePopper);
    const ref = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $eZVvM.useEffect(()=>{
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$1d6744c3033b8e6e$export$ecd4e1ccab6ed6d.displayName = $1d6744c3033b8e6e$var$ANCHOR_NAME;
var $1d6744c3033b8e6e$var$CONTENT_NAME = "PopperContent";
var [$1d6744c3033b8e6e$var$PopperContentProvider, $1d6744c3033b8e6e$var$useContentContext] = $1d6744c3033b8e6e$var$createPopperContext($1d6744c3033b8e6e$var$CONTENT_NAME);
var $1d6744c3033b8e6e$export$bc4ae5855d3c4fc = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2, _middlewareData_transformOrigin, _middlewareData_transformOrigin1, _middlewareData_hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $1d6744c3033b8e6e$var$usePopperContext($1d6744c3033b8e6e$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $eZVvM.useState(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $eZVvM.useState(null);
    const arrowSize = (0, $416ecf6d578e0a29$export$1ab7ae714698c4b8)(arrow);
    var _arrowSize_width;
    const arrowWidth = (_arrowSize_width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize_width !== void 0 ? _arrowSize_width : 0;
    var _arrowSize_height;
    const arrowHeight = (_arrowSize_height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize_height !== void 0 ? _arrowSize_height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($1d6744c3033b8e6e$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $9912140e987fac9e$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $6502644ced543179$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $9912140e987fac9e$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $9912140e987fac9e$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $9912140e987fac9e$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $9912140e987fac9e$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $9912140e987fac9e$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $9912140e987fac9e$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $1d6744c3033b8e6e$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $9912140e987fac9e$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onPlaced);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 ? void 0 : handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.x;
    const arrowY = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.y;
    const cannotCenterArrow = ((_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = $eZVvM.useState();
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData_transformOrigin = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin === void 0 ? void 0 : _middlewareData_transformOrigin.x,
                (_middlewareData_transformOrigin1 = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin1 === void 0 ? void 0 : _middlewareData_transformOrigin1.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.referenceHidden) && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$1d6744c3033b8e6e$export$bc4ae5855d3c4fc.displayName = $1d6744c3033b8e6e$var$CONTENT_NAME;
var $1d6744c3033b8e6e$var$ARROW_NAME = "PopperArrow";
var $1d6744c3033b8e6e$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $1d6744c3033b8e6e$export$79d62cd4e10a3fd0 = $eZVvM.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $1d6744c3033b8e6e$var$useContentContext($1d6744c3033b8e6e$var$ARROW_NAME, __scopePopper);
    const baseSide = $1d6744c3033b8e6e$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $3pI8R.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($4d5ebdb6606821b3$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$1d6744c3033b8e6e$export$79d62cd4e10a3fd0.displayName = $1d6744c3033b8e6e$var$ARROW_NAME;
function $1d6744c3033b8e6e$var$isNotNull(value) {
    return value !== null;
}
var $1d6744c3033b8e6e$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var _middlewareData_arrow_x;
            const arrowXCenter = ((_middlewareData_arrow_x = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.x) !== null && _middlewareData_arrow_x !== void 0 ? _middlewareData_arrow_x : 0) + arrowWidth / 2;
            var _middlewareData_arrow_y;
            const arrowYCenter = ((_middlewareData_arrow_y = (_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.y) !== null && _middlewareData_arrow_y !== void 0 ? _middlewareData_arrow_y : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $1d6744c3033b8e6e$export$be92b6f5f03c0fe9 = $1d6744c3033b8e6e$export$badac9ada3a0bdf9;
var $1d6744c3033b8e6e$export$b688253958b8dfe7 = $1d6744c3033b8e6e$export$ecd4e1ccab6ed6d;
var $1d6744c3033b8e6e$export$7c6e2c02157bb7d2 = $1d6744c3033b8e6e$export$bc4ae5855d3c4fc;
var $1d6744c3033b8e6e$export$21b07c8f274aebd5 = $1d6744c3033b8e6e$export$79d62cd4e10a3fd0;



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a76ffa8483cdf241$var$PORTAL_NAME = "Portal";
var $a76ffa8483cdf241$export$602eac185826482c = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _globalThis_document, _globalThis;
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $eZVvM.useState(false);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body);
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).createPortal(/* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$a76ffa8483cdf241$export$602eac185826482c.displayName = $a76ffa8483cdf241$var$PORTAL_NAME;
var $a76ffa8483cdf241$export$be92b6f5f03c0fe9 = $a76ffa8483cdf241$export$602eac185826482c;



var $eZVvM = parcelRequire("eZVvM");


"use client";
function $cf4ccb043a5a8762$var$useStateMachine(initialState, machine) {
    return $eZVvM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $cf4ccb043a5a8762$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $cf4ccb043a5a8762$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $eZVvM.Children.only(children);
    const ref = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(presence.ref, $cf4ccb043a5a8762$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $eZVvM.cloneElement(child, {
        ref: ref
    }) : null;
};
$cf4ccb043a5a8762$export$99c2b779aa4e8b8b.displayName = "Presence";
function $cf4ccb043a5a8762$var$usePresence(present) {
    const [node, setNode] = $eZVvM.useState();
    const stylesRef = $eZVvM.useRef({});
    const prevPresentRef = $eZVvM.useRef(present);
    const prevAnimationNameRef = $eZVvM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $cf4ccb043a5a8762$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $eZVvM.useEffect(()=>{
        const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            var _node_ownerDocument_defaultView;
            const ownerWindow = (_node_ownerDocument_defaultView = node.ownerDocument.defaultView) !== null && _node_ownerDocument_defaultView !== void 0 ? _node_ownerDocument_defaultView : window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $eZVvM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $cf4ccb043a5a8762$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
function $cf4ccb043a5a8762$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




// packages/react/use-controllable-state/src/useControllableState.tsx

var $eZVvM = parcelRequire("eZVvM");

function $15fe1a9c6448dfe8$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $15fe1a9c6448dfe8$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onChange);
    const setValue = $eZVvM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $15fe1a9c6448dfe8$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $eZVvM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $eZVvM.useRef(value);
    const handleChange = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onChange);
    $eZVvM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


var $aa2805cf61430e06$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $aa2805cf61430e06$var$counterMap = new WeakMap();
var $aa2805cf61430e06$var$uncontrolledNodes = new WeakMap();
var $aa2805cf61430e06$var$markerMap = {};
var $aa2805cf61430e06$var$lockCount = 0;
var $aa2805cf61430e06$var$unwrapHost = function(node) {
    return node && (node.host || $aa2805cf61430e06$var$unwrapHost(node.parentNode));
};
var $aa2805cf61430e06$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $aa2805cf61430e06$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $aa2805cf61430e06$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $aa2805cf61430e06$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$aa2805cf61430e06$var$markerMap[markerName]) $aa2805cf61430e06$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $aa2805cf61430e06$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($aa2805cf61430e06$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $aa2805cf61430e06$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $aa2805cf61430e06$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $aa2805cf61430e06$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $aa2805cf61430e06$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $aa2805cf61430e06$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$aa2805cf61430e06$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $aa2805cf61430e06$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $aa2805cf61430e06$var$lockCount--;
        if (!$aa2805cf61430e06$var$lockCount) {
            // clear
            $aa2805cf61430e06$var$counterMap = new WeakMap();
            $aa2805cf61430e06$var$counterMap = new WeakMap();
            $aa2805cf61430e06$var$uncontrolledNodes = new WeakMap();
            $aa2805cf61430e06$var$markerMap = {};
        }
    };
};
var $aa2805cf61430e06$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $aa2805cf61430e06$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $aa2805cf61430e06$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $aa2805cf61430e06$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $aa2805cf61430e06$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $aa2805cf61430e06$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $aa2805cf61430e06$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $aa2805cf61430e06$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($aa2805cf61430e06$export$cc95fea82d705fca() ? $aa2805cf61430e06$export$59151cc8db999a24 : $aa2805cf61430e06$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");

var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");
var $36980812ffa15784$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $36980812ffa15784$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $36980812ffa15784$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $36980812ffa15784$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $eZVvM = parcelRequire("eZVvM");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $713dd8676ce4eb23$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $eZVvM = parcelRequire("eZVvM");
function $fa63e2d41de72700$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $eZVvM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $2b5d694d1654c02a$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $eZVvM.useLayoutEffect : $eZVvM.useEffect;
var $2b5d694d1654c02a$var$currentValues = new WeakMap();
function $2b5d694d1654c02a$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $fa63e2d41de72700$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $2b5d694d1654c02a$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $2b5d694d1654c02a$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $2b5d694d1654c02a$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $iUWBZ = parcelRequire("iUWBZ");
function $8ff640b44f4f5bb9$var$ItoI(a) {
    return a;
}
function $8ff640b44f4f5bb9$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $8ff640b44f4f5bb9$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $8ff640b44f4f5bb9$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $8ff640b44f4f5bb9$var$ItoI;
    return $8ff640b44f4f5bb9$var$innerCreateMedium(defaults, middleware);
}
function $8ff640b44f4f5bb9$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $8ff640b44f4f5bb9$var$innerCreateMedium(null);
    medium.options = (0, $iUWBZ.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $3c81697596d3d7c5$export$e27363444bedfeac = (0, $8ff640b44f4f5bb9$export$e13ec7dd7a14088d)();


var $2df8ab0d18f28fcc$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $2df8ab0d18f28fcc$export$22940b497e769dee = $eZVvM.forwardRef(function(props, parentRef) {
    var ref = $eZVvM.useRef(null);
    var _a = $eZVvM.useState({
        onScrollCapture: $2df8ab0d18f28fcc$var$nothing,
        onWheelCapture: $2df8ab0d18f28fcc$var$nothing,
        onTouchMoveCapture: $2df8ab0d18f28fcc$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $iUWBZ.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2b5d694d1654c02a$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $iUWBZ.__assign)((0, $iUWBZ.__assign)({}, rest), callbacks);
    return $eZVvM.createElement($eZVvM.Fragment, null, enabled && $eZVvM.createElement(SideCar, {
        sideCar: (0, $3c81697596d3d7c5$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $eZVvM.cloneElement($eZVvM.Children.only(children), (0, $iUWBZ.__assign)((0, $iUWBZ.__assign)({}, containerProps), {
        ref: containerRef
    })) : $eZVvM.createElement(Container, (0, $iUWBZ.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$2df8ab0d18f28fcc$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$2df8ab0d18f28fcc$export$22940b497e769dee.classNames = {
    fullWidth: (0, $36980812ffa15784$export$898e37bbd2a0ae4e),
    zeroRight: (0, $36980812ffa15784$export$1da7500147d4bc3)
};



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");
var $2a109d0481166e06$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $iUWBZ.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $eZVvM.createElement(Target, (0, $iUWBZ.__assign)({}, rest));
};
$2a109d0481166e06$var$SideCar.isSideCarExport = true;
function $2a109d0481166e06$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $2a109d0481166e06$var$SideCar;
}



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
var $97cad7e43f6615ca$var$currentNonce;
var $97cad7e43f6615ca$export$c5f670b24c0ae95a = function(nonce) {
    $97cad7e43f6615ca$var$currentNonce = nonce;
};
var $97cad7e43f6615ca$export$2b85b721e524d74b = function() {
    if ($97cad7e43f6615ca$var$currentNonce) return $97cad7e43f6615ca$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $dc297644307a4751$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $97cad7e43f6615ca$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $dc297644307a4751$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $dc297644307a4751$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $dc297644307a4751$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $dc297644307a4751$var$makeStyleTag()) {
                    $dc297644307a4751$var$injectStyles(stylesheet, style);
                    $dc297644307a4751$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $88eb0de48099155e$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $dc297644307a4751$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $eZVvM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $1943c50733f82794$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $88eb0de48099155e$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $e81a80eceffa9fbb$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $e81a80eceffa9fbb$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $e81a80eceffa9fbb$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $e81a80eceffa9fbb$var$parse(left),
        $e81a80eceffa9fbb$var$parse(top),
        $e81a80eceffa9fbb$var$parse(right)
    ];
};
var $e81a80eceffa9fbb$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $e81a80eceffa9fbb$export$efed13b5d0ca3386;
    var offsets = $e81a80eceffa9fbb$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $545793c299e71b41$var$Style = (0, $1943c50733f82794$export$c1248ee86ba532c8)();
var $545793c299e71b41$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $545793c299e71b41$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $36980812ffa15784$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($545793c299e71b41$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($545793c299e71b41$export$65254d5f26cb9564, "] {\n    ").concat((0, $36980812ffa15784$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $545793c299e71b41$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($545793c299e71b41$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $545793c299e71b41$export$a1939b1f9f9b02dc = function() {
    $eZVvM.useEffect(function() {
        document.body.setAttribute($545793c299e71b41$export$65254d5f26cb9564, ($545793c299e71b41$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $545793c299e71b41$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($545793c299e71b41$export$65254d5f26cb9564);
            else document.body.setAttribute($545793c299e71b41$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $545793c299e71b41$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $545793c299e71b41$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $eZVvM.useMemo(function() {
        return (0, $e81a80eceffa9fbb$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $eZVvM.createElement($545793c299e71b41$var$Style, {
        styles: $545793c299e71b41$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $b5f667d2968c2a1d$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $b5f667d2968c2a1d$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $b5f667d2968c2a1d$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $b5f667d2968c2a1d$var$options, $b5f667d2968c2a1d$var$options);
    // @ts-ignore
    window.removeEventListener("test", $b5f667d2968c2a1d$var$options, $b5f667d2968c2a1d$var$options);
} catch (err) {
    $b5f667d2968c2a1d$var$passiveSupported = false;
}
var $b5f667d2968c2a1d$export$10a6e88623fa9454 = $b5f667d2968c2a1d$var$passiveSupported ? {
    passive: false
} : false;


var $5374cafeb6c79dfa$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $5374cafeb6c79dfa$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$5374cafeb6c79dfa$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $5374cafeb6c79dfa$var$elementCouldBeVScrolled = function(node) {
    return $5374cafeb6c79dfa$var$elementCanBeScrolled(node, "overflowY");
};
var $5374cafeb6c79dfa$var$elementCouldBeHScrolled = function(node) {
    return $5374cafeb6c79dfa$var$elementCanBeScrolled(node, "overflowX");
};
var $5374cafeb6c79dfa$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $5374cafeb6c79dfa$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $5374cafeb6c79dfa$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $5374cafeb6c79dfa$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $5374cafeb6c79dfa$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $5374cafeb6c79dfa$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $5374cafeb6c79dfa$var$elementCouldBeVScrolled(node) : $5374cafeb6c79dfa$var$elementCouldBeHScrolled(node);
};
var $5374cafeb6c79dfa$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $5374cafeb6c79dfa$var$getVScrollVariables(node) : $5374cafeb6c79dfa$var$getHScrollVariables(node);
};
var $5374cafeb6c79dfa$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $5374cafeb6c79dfa$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $5374cafeb6c79dfa$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $5374cafeb6c79dfa$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($5374cafeb6c79dfa$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $40252af699c089cd$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $40252af699c089cd$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $40252af699c089cd$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $40252af699c089cd$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $40252af699c089cd$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $40252af699c089cd$var$idCounter = 0;
var $40252af699c089cd$var$lockStack = [];
function $40252af699c089cd$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $eZVvM.useRef([]);
    var touchStartRef = $eZVvM.useRef([
        0,
        0
    ]);
    var activeAxis = $eZVvM.useRef();
    var id = $eZVvM.useState($40252af699c089cd$var$idCounter++)[0];
    var Style = $eZVvM.useState((0, $1943c50733f82794$export$c1248ee86ba532c8))[0];
    var lastProps = $eZVvM.useRef(props);
    $eZVvM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $eZVvM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $iUWBZ.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($40252af699c089cd$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $eZVvM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $40252af699c089cd$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $5374cafeb6c79dfa$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $5374cafeb6c79dfa$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $5374cafeb6c79dfa$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $eZVvM.useCallback(function(_event) {
        var event = _event;
        if (!$40252af699c089cd$var$lockStack.length || $40252af699c089cd$var$lockStack[$40252af699c089cd$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $40252af699c089cd$export$39efaa2ca254a28d(event) : $40252af699c089cd$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $40252af699c089cd$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($40252af699c089cd$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $eZVvM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $40252af699c089cd$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $eZVvM.useCallback(function(event) {
        touchStartRef.current = $40252af699c089cd$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $eZVvM.useCallback(function(event) {
        shouldCancel(event.type, $40252af699c089cd$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $eZVvM.useCallback(function(event) {
        shouldCancel(event.type, $40252af699c089cd$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $eZVvM.useEffect(function() {
        $40252af699c089cd$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        return function() {
            $40252af699c089cd$var$lockStack = $40252af699c089cd$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $eZVvM.createElement($eZVvM.Fragment, null, inert ? $eZVvM.createElement(Style, {
        styles: $40252af699c089cd$var$generateStyle(id)
    }) : null, removeScrollBar ? $eZVvM.createElement((0, $545793c299e71b41$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $40252af699c089cd$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $248e13baa32989a0$export$2e2bcd8739ae039 = (0, $2a109d0481166e06$export$6cacc8fb0a9b94ce)((0, $3c81697596d3d7c5$export$e27363444bedfeac), (0, $40252af699c089cd$export$a09dbff87b5da2d));


var $a6d74da6d6d2ca17$var$ReactRemoveScroll = $eZVvM.forwardRef(function(props, ref) {
    return $eZVvM.createElement((0, $2df8ab0d18f28fcc$export$22940b497e769dee), (0, $iUWBZ.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $248e13baa32989a0$export$2e2bcd8739ae039)
    }));
});
$a6d74da6d6d2ca17$var$ReactRemoveScroll.classNames = (0, $2df8ab0d18f28fcc$export$22940b497e769dee).classNames;
var $a6d74da6d6d2ca17$export$2e2bcd8739ae039 = $a6d74da6d6d2ca17$var$ReactRemoveScroll;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d30790ce46109715$var$POPOVER_NAME = "Popover";
var [$d30790ce46109715$var$createPopoverContext, $d30790ce46109715$export$c8393c9e73286932] = (0, $e6270c096fd5048f$export$50c7b4e9d9f19c1)($d30790ce46109715$var$POPOVER_NAME, [
    (0, $1d6744c3033b8e6e$export$722aac194ae923)
]);
var $d30790ce46109715$var$usePopperScope = (0, $1d6744c3033b8e6e$export$722aac194ae923)();
var [$d30790ce46109715$var$PopoverProvider, $d30790ce46109715$var$usePopoverContext] = $d30790ce46109715$var$createPopoverContext($d30790ce46109715$var$POPOVER_NAME);
var $d30790ce46109715$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const triggerRef = $eZVvM.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $eZVvM.useState(false);
    const [open = false, setOpen] = (0, $15fe1a9c6448dfe8$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $92fce9891f0372ca$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $eZVvM.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $eZVvM.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $eZVvM.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$d30790ce46109715$export$5b6b19405a83ff9d.displayName = $d30790ce46109715$var$POPOVER_NAME;
var $d30790ce46109715$var$ANCHOR_NAME = "PopoverAnchor";
var $d30790ce46109715$export$96e5381f42521a79 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $eZVvM.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$d30790ce46109715$export$96e5381f42521a79.displayName = $d30790ce46109715$var$ANCHOR_NAME;
var $d30790ce46109715$var$TRIGGER_NAME = "PopoverTrigger";
var $d30790ce46109715$export$7dacb05d26466c3 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d30790ce46109715$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$d30790ce46109715$export$7dacb05d26466c3.displayName = $d30790ce46109715$var$TRIGGER_NAME;
var $d30790ce46109715$var$PORTAL_NAME = "PopoverPortal";
var [$d30790ce46109715$var$PortalProvider, $d30790ce46109715$var$usePortalContext] = $d30790ce46109715$var$createPopoverContext($d30790ce46109715$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d30790ce46109715$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $cf4ccb043a5a8762$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $a76ffa8483cdf241$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$d30790ce46109715$export$dd679ffb4362d2d4.displayName = $d30790ce46109715$var$PORTAL_NAME;
var $d30790ce46109715$var$CONTENT_NAME = "PopoverContent";
var $d30790ce46109715$export$d7e1f420b25549ff = $eZVvM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d30790ce46109715$var$usePortalContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $cf4ccb043a5a8762$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$d30790ce46109715$export$d7e1f420b25549ff.displayName = $d30790ce46109715$var$CONTENT_NAME;
var $d30790ce46109715$var$PopoverContentModal = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $aa2805cf61430e06$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $a6d74da6d6d2ca17$export$2e2bcd8739ae039), {
        as: (0, $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                var _context_triggerRef_current;
                event.preventDefault();
                if (!isRightClickOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            }),
            onPointerDownOutside: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $d30790ce46109715$var$PopoverContentNonModal = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $eZVvM.useRef(false);
    const hasPointerDownOutsideRef = $eZVvM.useRef(false);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $d30790ce46109715$var$PopoverContentImpl = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    (0, $8a88dc3631ad332b$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $5fa700d9aec4b79b$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $927c851443b37d6c$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$7c6e2c02157bb7d2, {
                "data-state": $d30790ce46109715$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $d30790ce46109715$var$CLOSE_NAME = "PopoverClose";
var $d30790ce46109715$export$d6ac43ebaa40d53e = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$d30790ce46109715$export$d6ac43ebaa40d53e.displayName = $d30790ce46109715$var$CLOSE_NAME;
var $d30790ce46109715$var$ARROW_NAME = "PopoverArrow";
var $d30790ce46109715$export$3152841115e061b2 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$d30790ce46109715$export$3152841115e061b2.displayName = $d30790ce46109715$var$ARROW_NAME;
function $d30790ce46109715$var$getState(open) {
    return open ? "open" : "closed";
}
var $d30790ce46109715$export$be92b6f5f03c0fe9 = $d30790ce46109715$export$5b6b19405a83ff9d;
var $d30790ce46109715$export$b688253958b8dfe7 = $d30790ce46109715$export$96e5381f42521a79;
var $d30790ce46109715$export$41fb9f06171c75f4 = $d30790ce46109715$export$7dacb05d26466c3;
var $d30790ce46109715$export$602eac185826482c = $d30790ce46109715$export$dd679ffb4362d2d4;
var $d30790ce46109715$export$7c6e2c02157bb7d2 = $d30790ce46109715$export$d7e1f420b25549ff;
var $d30790ce46109715$export$f39c2d165cd861fe = $d30790ce46109715$export$d6ac43ebaa40d53e;
var $d30790ce46109715$export$21b07c8f274aebd5 = $d30790ce46109715$export$3152841115e061b2;


function $de9b795dde6747fa$export$1ac4a28ba936c3b0({ children: children }) {
    const services = (0, $4fc09928452de42f$export$1f39bff4033c2336)();
    const store = (0, $4fc09928452de42f$export$f51a9068ac82ea43)({
        injectServices: services
    });
    return $eZVvM.createElement((0, $e2346a360d18792d$export$2881499e37b75b9a), {
        store: store
    }, children);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $de9b795dde6747fa$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
const $de9b795dde6747fa$var$useAppDispatch = (0, $e2346a360d18792d$export$8ad76b76a4c905f8).withTypes();
const $de9b795dde6747fa$var$useAppSelector = (0, $e2346a360d18792d$export$2105062e25df4afe).withTypes();
const $de9b795dde6747fa$export$5da49f1f3cbe3742 = $eZVvM.forwardRef((_a, ref)=>{
    var { muted: muted, mirror: mirror = false, stream: stream, onVideoResize: onVideoResize } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "muted",
        "mirror",
        "stream",
        "onVideoResize"
    ]);
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const currentSpeakerId = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$356fc73355033f1b));
    const videoEl = $eZVvM.useRef(null);
    const audioEl = $eZVvM.useRef(null);
    $eZVvM.useImperativeHandle(ref, ()=>{
        return Object.assign(videoEl.current, {
            captureAspectRatio: ()=>{
                if (!videoEl.current) return null;
                const h = videoEl.current.videoHeight;
                const w = videoEl.current.videoWidth;
                if (w && h && w + h > 20) return w / h;
                return null;
            }
        });
    });
    $eZVvM.useEffect(()=>{
        if (!videoEl.current) return;
        const resizeObserver = new ResizeObserver((0, $4fc09928452de42f$export$61fc7d43ac8f84b0)(()=>{
            if (videoEl.current && (stream === null || stream === void 0 ? void 0 : stream.id)) {
                const width = videoEl.current.clientWidth;
                const height = videoEl.current.clientHeight;
                dispatch((0, $4fc09928452de42f$export$8e38e4b6fee98ae8)({
                    streamId: stream.id,
                    width: width,
                    height: height
                }));
                if (onVideoResize) onVideoResize({
                    width: width,
                    height: height,
                    stream: stream
                });
            }
        }, {
            delay: 1000,
            edges: true
        }));
        resizeObserver.observe(videoEl.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        stream
    ]);
    $eZVvM.useEffect(()=>{
        if (!videoEl.current) return;
        if (videoEl.current.srcObject !== stream) videoEl.current.srcObject = stream;
        if (videoEl.current.muted !== muted) videoEl.current.muted = Boolean(muted);
    }, [
        muted,
        stream,
        videoEl
    ]);
    $eZVvM.useEffect(()=>{
        if (!audioEl.current || muted || !stream || !currentSpeakerId) return;
        if (audioEl.current.srcObject !== stream) audioEl.current.srcObject = stream;
        if (audioEl.current.setSinkId) audioEl.current.setSinkId(currentSpeakerId);
    }, [
        stream,
        audioEl,
        currentSpeakerId,
        muted
    ]);
    return $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement("video", Object.assign({
        ref: videoEl,
        autoPlay: true,
        playsInline: true
    }, rest, {
        style: Object.assign({
            transform: mirror ? "scaleX(-1)" : "none",
            width: "100%",
            height: "100%"
        }, rest.style)
    })), $eZVvM.createElement("audio", {
        ref: audioEl,
        autoPlay: true,
        playsInline: true
    }));
});
$de9b795dde6747fa$export$5da49f1f3cbe3742.displayName = "VideoView";
const $de9b795dde6747fa$var$selectRoomConnectionState = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)((0, $4fc09928452de42f$export$e67c42ad18139770), (0, $4fc09928452de42f$export$e8f9fec2fd38be7b), (0, $4fc09928452de42f$export$b8c8b2aa1134778b), (0, $4fc09928452de42f$export$e9c4b1bf93e7c80d), (0, $4fc09928452de42f$export$f97faf20840c4b0c), (0, $4fc09928452de42f$export$5d9bde7516ef4510), (0, $4fc09928452de42f$export$22f0decfe3c779cc), (0, $4fc09928452de42f$export$90baeb59ec142cd0), (0, $4fc09928452de42f$export$2a890977d27b6c75), (0, $4fc09928452de42f$export$d73c0f55214a186a), (0, $4fc09928452de42f$export$622ce0f62fa78bbc), (chatMessages, cloudRecording, localParticipant, localMediaStream, remoteParticipants, screenshares, connectionStatus, streaming, waitingParticipants, notificationsEmitter, spotlightedClientViews)=>{
    const state = {
        chatMessages: chatMessages,
        cloudRecording: cloudRecording.isRecording ? {
            status: "recording"
        } : undefined,
        connectionStatus: connectionStatus,
        events: notificationsEmitter,
        liveStream: streaming.isStreaming ? {
            status: "streaming",
            startedAt: streaming.startedAt
        } : undefined,
        localScreenshareStatus: localParticipant.isScreenSharing ? "active" : undefined,
        localParticipant: Object.assign(Object.assign({}, localParticipant), {
            stream: localMediaStream
        }),
        remoteParticipants: remoteParticipants,
        screenshares: screenshares,
        waitingParticipants: waitingParticipants,
        spotlightedParticipants: spotlightedClientViews
    };
    return state;
});
const $de9b795dde6747fa$var$browserSdkVersion = "3.9.5";
const $de9b795dde6747fa$var$defaultRoomConnectionOptions = {
    localMediaOptions: {
        audio: true,
        video: true
    }
};
function $de9b795dde6747fa$export$e7be2adb7d898233(roomUrl, roomConnectionOptions = $de9b795dde6747fa$var$defaultRoomConnectionOptions) {
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const roomConnectionState = $de9b795dde6747fa$var$useAppSelector($de9b795dde6747fa$var$selectRoomConnectionState);
    const roomConfig = $eZVvM.useMemo(()=>{
        const url = new URL(roomUrl);
        const searchParams = new URLSearchParams(url.search);
        const roomKey = roomConnectionOptions.roomKey || searchParams.get("roomKey");
        return {
            displayName: roomConnectionOptions.displayName || "Guest",
            localMediaOptions: roomConnectionOptions.localMedia ? undefined : roomConnectionOptions.localMediaOptions,
            roomKey: roomKey,
            roomUrl: roomUrl,
            userAgent: `browser-sdk:${$de9b795dde6747fa$var$browserSdkVersion}`,
            externalId: roomConnectionOptions.externalId || null
        };
    }, [
        roomUrl,
        roomConnectionOptions
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            dispatch((0, $4fc09928452de42f$export$d4d0f76450fb6374)());
        };
    }, []);
    const sendChatMessage = $eZVvM.useCallback((text)=>dispatch((0, $4fc09928452de42f$export$24e3bf930d312b2b)({
            text: text
        })), [
        dispatch
    ]);
    const knock = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$76a4467872ffe125)()), [
        dispatch
    ]);
    const setDisplayName = $eZVvM.useCallback((displayName)=>dispatch((0, $4fc09928452de42f$export$9708f9509a207de0)({
            displayName: displayName
        })), [
        dispatch
    ]);
    const toggleCamera = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$93cdb5d3b5880a52)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleMicrophone = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$11a7008b2ab330c2)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleLowDataMode = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$f8ccf9677d12adec)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleRaiseHand = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$5ae150f2ac8c6cf7)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const askToSpeak = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$d0f9ccaaa3a15b4c)({
            clientIds: [
                participantId
            ],
            enable: true
        })), [
        dispatch
    ]);
    const askToTurnOnCamera = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$f7fc15880c03e2a3)({
            clientIds: [
                participantId
            ],
            enable: true
        })), [
        dispatch
    ]);
    const acceptWaitingParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$1a5b93a56a313cfe)({
            participantId: participantId
        })), [
        dispatch
    ]);
    const rejectWaitingParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$dde035bd3d0904ac)({
            participantId: participantId
        })), [
        dispatch
    ]);
    const startCloudRecording = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$8568c037c56c4692)()), [
        dispatch
    ]);
    const startScreenshare = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$ad4f97fa7081697c)()), [
        dispatch
    ]);
    const stopCloudRecording = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$579ffd5d4359613e)()), [
        dispatch
    ]);
    const stopScreenshare = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$a42cf8a339c4d2f7)()), [
        dispatch
    ]);
    const joinRoom = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$ca0cd7d9bebf6bc8)(roomConfig)), [
        dispatch
    ]);
    const leaveRoom = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$d4d0f76450fb6374)()), [
        dispatch
    ]);
    const lockRoom = $eZVvM.useCallback((locked)=>dispatch((0, $4fc09928452de42f$export$9eb5fcf87b4704f2)({
            locked: locked
        })), [
        dispatch
    ]);
    const muteParticipants = $eZVvM.useCallback((participantIds)=>dispatch((0, $4fc09928452de42f$export$d0f9ccaaa3a15b4c)({
            clientIds: participantIds,
            enable: false
        })), [
        dispatch
    ]);
    const turnOffParticipantCameras = $eZVvM.useCallback((participantIds)=>dispatch((0, $4fc09928452de42f$export$f7fc15880c03e2a3)({
            clientIds: participantIds,
            enable: false
        })), [
        dispatch
    ]);
    const spotlightParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$4bf19d94733cc82e)({
            id: participantId
        })), [
        dispatch
    ]);
    const removeSpotlight = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$65b4309b6edd4ad1)({
            id: participantId
        })), [
        dispatch
    ]);
    const kickParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$d5359451ea4b2b4a)({
            clientId: participantId
        })), [
        dispatch
    ]);
    const endMeeting = $eZVvM.useCallback((stayBehind)=>dispatch((0, $4fc09928452de42f$export$50d90cb8a8eda648)({
            stayBehind: stayBehind
        })), [
        dispatch
    ]);
    const { events: events } = roomConnectionState, state = $de9b795dde6747fa$var$__rest(roomConnectionState, [
        "events"
    ]);
    return {
        state: state,
        events: events,
        actions: {
            toggleLowDataMode: toggleLowDataMode,
            toggleRaiseHand: toggleRaiseHand,
            askToSpeak: askToSpeak,
            askToTurnOnCamera: askToTurnOnCamera,
            acceptWaitingParticipant: acceptWaitingParticipant,
            knock: knock,
            joinRoom: joinRoom,
            leaveRoom: leaveRoom,
            lockRoom: lockRoom,
            muteParticipants: muteParticipants,
            turnOffParticipantCameras: turnOffParticipantCameras,
            kickParticipant: kickParticipant,
            endMeeting: endMeeting,
            rejectWaitingParticipant: rejectWaitingParticipant,
            sendChatMessage: sendChatMessage,
            setDisplayName: setDisplayName,
            startCloudRecording: startCloudRecording,
            startScreenshare: startScreenshare,
            stopCloudRecording: stopCloudRecording,
            stopScreenshare: stopScreenshare,
            toggleCamera: toggleCamera,
            toggleMicrophone: toggleMicrophone,
            spotlightParticipant: spotlightParticipant,
            removeSpotlight: removeSpotlight
        }
    };
}
const $de9b795dde6747fa$var$selectLocalMediaState = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)((0, $4fc09928452de42f$export$68025622922ffa26), (0, $4fc09928452de42f$export$434a4c2926dbcbc8), (0, $4fc09928452de42f$export$9b07214a345a0c2b), (0, $4fc09928452de42f$export$15cb5bc234aa0b53), (0, $4fc09928452de42f$export$356fc73355033f1b), (0, $4fc09928452de42f$export$53fdac895dbb6618), (0, $4fc09928452de42f$export$6dd72f0a0b587d15), (0, $4fc09928452de42f$export$5353cfedea9c4a68), (0, $4fc09928452de42f$export$e9c4b1bf93e7c80d), (0, $4fc09928452de42f$export$6dc516caa6efdffc), (0, $4fc09928452de42f$export$3622b5408789e593), (0, $4fc09928452de42f$export$d743da980c7b249a), (0, $4fc09928452de42f$export$c86c916bf575750b), (cameraDeviceError, cameraDevices, currentCameraDeviceId, currentMicrophoneDeviceId, currentSpeakerDeviceId, isSettingCameraDevice, isSettingMicrophoneDevice, isStarting, localStream, microphoneDeviceError, microphoneDevices, speakerDevices, startError)=>{
    const state = {
        cameraDeviceError: cameraDeviceError,
        cameraDevices: cameraDevices,
        currentCameraDeviceId: currentCameraDeviceId,
        currentMicrophoneDeviceId: currentMicrophoneDeviceId,
        currentSpeakerDeviceId: currentSpeakerDeviceId,
        isSettingCameraDevice: isSettingCameraDevice,
        isSettingMicrophoneDevice: isSettingMicrophoneDevice,
        isStarting: isStarting,
        localStream: localStream,
        microphoneDeviceError: microphoneDeviceError,
        microphoneDevices: microphoneDevices,
        speakerDevices: speakerDevices,
        startError: startError
    };
    return state;
});
function $de9b795dde6747fa$export$4139b14dad9cc31b(optionsOrStream = {
    audio: true,
    video: true
}) {
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const localMediaState = $de9b795dde6747fa$var$useAppSelector($de9b795dde6747fa$var$selectLocalMediaState);
    $eZVvM.useEffect(()=>{
        dispatch((0, $4fc09928452de42f$export$eb927cdec6bfaecd)(optionsOrStream));
        return ()=>{
            dispatch((0, $4fc09928452de42f$export$85e2dd05688d27d9)());
        };
    }, []);
    const setCameraDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$ab12f9f2846e3448)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const setMicrophoneDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$2e1fc2200098f950)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const setSpeakerDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$1176f68d1d548ad3)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const toggleCamera = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$93cdb5d3b5880a52)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleMicrophone = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$11a7008b2ab330c2)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleLowDataMode = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$f8ccf9677d12adec)({
            enabled: enabled
        })), [
        dispatch
    ]);
    return {
        state: localMediaState,
        actions: {
            setCameraDevice: setCameraDevice,
            setMicrophoneDevice: setMicrophoneDevice,
            setSpeakerDevice: setSpeakerDevice,
            toggleCameraEnabled: toggleCamera,
            toggleMicrophoneEnabled: toggleMicrophone,
            toggleLowDataModeEnabled: toggleLowDataMode
        }
    };
}
const $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1 = 420;
var $de9b795dde6747fa$var$layoutConstants = {
    MIN_WINDOW_HEIGHT: 320,
    MIN_WINDOW_WIDTH: 320,
    DESKTOP_BREAKPOINT: 1025,
    TABLET_BREAKPOINT: 750,
    PHONE_BREAKPOINT: 500,
    TOP_TOOLBAR_HEIGHT: 56,
    BOTTOM_TOOLBAR_HEIGHT: 82,
    SIDEBAR_WIDTH: 375,
    VIDEO_CONTROLS_MIN_WIDTH: $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1,
    ROOM_FOOTER_MIN_WIDTH: 180 + $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1,
    FLOATING_VIDEO_CONTROLS_BOTTOM_MARGIN: 20,
    WATERMARK_BAR_HEIGHT: 32,
    BREAKOUT_STAGE_BACKDROP_HEADER_HEIGHT: 28,
    BREAKOUT_STAGE_BACKDROP_FOOTER_HEIGHT: 56,
    SUBGRID_EMPTY_STAGE_MAX_WIDTH: 800,
    GROUPS_CELL_MARGIN: 8,
    GROUPS_CELL_PADDING: 12,
    GROUPS_CELL_NAV_HEIGHT: 56,
    GROUPS_CELL_AVATAR_WRAPPER_BOTTOM_MARGIN: 8,
    GROUPS_CELL_AVATAR_GRID_GAP: 8,
    GROUPS_CELL_MIN_WIDTH: 360,
    GROUPS_CELL_MAX_WIDTH: 600,
    GROUPS_ROW_HEIGHT: 72,
    GROUPS_ROW_GAP: 1,
    FOLDABLE_SCREEN_STAGE_PADDING: 8
};
function $de9b795dde6747fa$var$makeOrigin({ top: top = 0, left: left = 0 } = {}) {
    return {
        top: top,
        left: left
    };
}
function $de9b795dde6747fa$var$makeBounds({ width: width = 0, height: height = 0 } = {}) {
    return {
        width: Math.max(width, 0),
        height: Math.max(height, 0)
    };
}
function $de9b795dde6747fa$var$makeFrame({ top: top = 0, left: left = 0, width: width = 0, height: height = 0 } = {}) {
    return {
        bounds: $de9b795dde6747fa$var$makeBounds({
            width: width,
            height: height
        }),
        origin: $de9b795dde6747fa$var$makeOrigin({
            top: top,
            left: left
        })
    };
}
function $de9b795dde6747fa$var$makeBox({ top: top = 0, left: left = 0, bottom: bottom = 0, right: right = 0 } = {}) {
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
}
function $de9b795dde6747fa$var$hasBounds(bounds) {
    if (!bounds) return false;
    return !(bounds.width <= 0 || bounds.height <= 0);
}
function $de9b795dde6747fa$var$insetBounds({ bounds: bounds, fromBounds: fromBounds }) {
    return {
        width: Math.max(fromBounds.width - bounds.width, 0),
        height: Math.max(fromBounds.height - bounds.height, 0)
    };
}
function $de9b795dde6747fa$var$fitToBounds(aspectRatio, containerSize) {
    const { width: width, height: height } = containerSize;
    const contentHeight = height;
    const contentWidth = contentHeight * aspectRatio;
    const scale = Math.min(width / contentWidth, height / contentHeight);
    const adjustedWidth = contentWidth * scale;
    const adjustedHeight = contentHeight * scale;
    return {
        width: adjustedWidth,
        height: adjustedHeight
    };
}
const $de9b795dde6747fa$var$cellContentArea = ({ width: width, height: height, rows: rows, cols: cols, aspectRatio: aspectRatio })=>{
    const bounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
        width: width / cols,
        height: height / rows
    });
    return Math.round(bounds.width * bounds.height);
};
const $de9b795dde6747fa$var$getWeightedSplitCount = ({ vertical: vertical, width: width, height: height, count: count, aspectRatio: aspectRatio })=>{
    const choices = [
        1,
        2,
        3
    ].map((rowCols)=>$de9b795dde6747fa$var$cellContentArea({
            width: width,
            height: height,
            rows: vertical ? Math.ceil(count / rowCols) : rowCols,
            cols: vertical ? rowCols : Math.ceil(count / rowCols),
            aspectRatio: aspectRatio
        }));
    const closest = Math.max(...choices);
    const splits = choices.indexOf(closest) + 1;
    return {
        splits: splits,
        weight: closest
    };
};
const $de9b795dde6747fa$var$getGridSplits = ({ width: width, height: height, count: count, aspectRatio: aspectRatio })=>{
    const verticalPick = $de9b795dde6747fa$var$getWeightedSplitCount({
        vertical: true,
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    const horizontalPick = $de9b795dde6747fa$var$getWeightedSplitCount({
        vertical: false,
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    if (verticalPick.weight > horizontalPick.weight) return {
        splits: verticalPick.splits,
        vertical: true
    };
    return {
        splits: horizontalPick.splits,
        vertical: false
    };
};
function $de9b795dde6747fa$var$getGridSizeForCount({ count: count, width: width, height: height, aspectRatio: aspectRatio }) {
    if (count <= 1) return {
        rows: 1,
        cols: 1
    };
    const { splits: splits, vertical: vertical } = $de9b795dde6747fa$var$getGridSplits({
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    if (vertical) return {
        rows: Math.ceil(count / splits),
        cols: splits
    };
    return {
        rows: splits,
        cols: Math.ceil(count / splits)
    };
}
function $de9b795dde6747fa$var$VideoCell(_a) {
    var { aspectRatio: aspectRatio, children: children, className: className, height: height, style: style, width: width, withRoundedCorners: withRoundedCorners = false, withShadow: withShadow = true } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "aspectRatio",
        "children",
        "className",
        "height",
        "style",
        "width",
        "withRoundedCorners",
        "withShadow"
    ]);
    let contentWidth = width;
    let contentHeight = height;
    let leftOffset = 0;
    let topOffset = 0;
    if (aspectRatio) {
        ({ width: contentWidth, height: contentHeight } = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: width,
            height: height
        }));
        leftOffset = (width - contentWidth) / 2;
        topOffset = (height - contentHeight) / 2;
    }
    const contentStyle = Object.assign({
        width: `${Math.round(contentWidth)}px`,
        height: `${Math.round(contentHeight)}px`
    }, leftOffset || topOffset ? {
        transform: `translate3d(${Math.round(leftOffset)}px, ${Math.round(topOffset)}px, 0)`
    } : {});
    return $eZVvM.createElement("div", {
        className: className,
        style: Object.assign({
            position: "absolute",
            top: 0,
            left: 0
        }, style)
    }, $eZVvM.createElement("div", Object.assign({
        style: contentStyle
    }, rest), $eZVvM.cloneElement(children, {
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        withRoundedCorners: withRoundedCorners,
        withShadow: withShadow
    })));
}
function $de9b795dde6747fa$var$generateStylesFromFrame({ origin: origin, bounds: bounds }) {
    return {
        top: Math.round(origin.top),
        left: Math.round(origin.left),
        height: Math.round(bounds.height),
        width: Math.round(bounds.width)
    };
}
function $de9b795dde6747fa$var$renderVideoCell({ cell: cell, child: child, clientId: clientId, style: style = {}, withRoundedCorners: withRoundedCorners = false, withShadow: withShadow = false }) {
    const isHidden = !$de9b795dde6747fa$var$hasBounds(cell.bounds);
    return $eZVvM.createElement($de9b795dde6747fa$var$VideoCell, {
        width: cell.bounds.width,
        height: cell.bounds.height,
        aspectRatio: cell.aspectRatio,
        style: isHidden ? {
            width: 0,
            height: 0
        } : style,
        withRoundedCorners: withRoundedCorners,
        withShadow: withShadow,
        key: clientId
    }, child);
}
function $de9b795dde6747fa$var$renderSubgridVideoCells({ content: content, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    const cells = stageLayout.subgrid.cells;
    return content.map((child, index)=>{
        var _a, _b, _c, _d;
        const cell = cells[index];
        const style = {
            height: Math.round(cell.bounds.height),
            width: Math.round(cell.bounds.width),
            transform: ""
        };
        const origin = {
            top: stageLayout.subgrid.origin.top + cell.origin.top,
            left: stageLayout.subgrid.origin.left + cell.origin.left
        };
        style.transform = `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`;
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const leftPaddings = ((_c = cell.paddings) === null || _c === void 0 ? void 0 : _c.left) || 0;
        const rightPaddings = ((_d = cell.paddings) === null || _d === void 0 ? void 0 : _d.right) || 0;
        const childWithProps = $eZVvM.cloneElement(child, {
            avatarSize: cell.bounds.width - leftPaddings - rightPaddings,
            canZoom: false,
            cellPaddings: cell.paddings,
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: false,
            key: clientId || `subgrid-${index}`,
            style: style
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `subgrid-${index}`,
            style: style,
            withRoundedCorners: withRoundedCorners,
            withShadow: withShadow
        });
    });
}
function $de9b795dde6747fa$var$renderPresentationGridVideoCells({ content: content, isConstrained: isConstrained, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    var _a;
    const cells = ((_a = stageLayout.presentationGrid) === null || _a === void 0 ? void 0 : _a.cells) || [];
    return content.map((child, index)=>{
        var _a, _b;
        if (!stageLayout.presentationGrid) return null;
        const cell = cells[index];
        const origin = {
            top: stageLayout.presentationGrid.origin.top + stageLayout.presentationGrid.paddings.top + cell.origin.top,
            left: stageLayout.presentationGrid.origin.left + stageLayout.presentationGrid.paddings.left + cell.origin.left
        };
        const style = {
            width: Math.round(cell.bounds.width),
            height: Math.round(cell.bounds.height),
            transform: `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`
        };
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const childWithProps = $eZVvM.cloneElement(child, {
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: !!isConstrained && !(child === null || child === void 0 ? void 0 : child.props.participant.isPresentation),
            canZoom: !!isConstrained,
            key: clientId || `presentation-${index}`
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `presentation-${index}`,
            style: style,
            withRoundedCorners: withRoundedCorners,
            withShadow: withShadow
        });
    });
}
function $de9b795dde6747fa$var$renderGridVideoCells({ content: content, isConstrained: isConstrained, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    var _a;
    const cells = ((_a = stageLayout.videoGrid) === null || _a === void 0 ? void 0 : _a.cells) || [];
    const gridVideoCells = content.map((child, index)=>{
        var _a, _b;
        if (!stageLayout.videoGrid) return null;
        const cell = cells[index];
        const origin = {
            top: stageLayout.videoGrid.origin.top + stageLayout.videoGrid.paddings.top + cell.origin.top,
            left: stageLayout.videoGrid.origin.left + stageLayout.videoGrid.paddings.left + cell.origin.left
        };
        const style = {
            width: Math.round(cell.bounds.width),
            height: Math.round(cell.bounds.height),
            transform: `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`
        };
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const childWithProps = $eZVvM.cloneElement(child, {
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: !!isConstrained && !(child === null || child === void 0 ? void 0 : child.props.participant.isPresentation),
            canZoom: !!isConstrained,
            key: clientId || `video-${index}`
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `video-${index}`,
            withRoundedCorners: withRoundedCorners,
            style: style,
            withShadow: withShadow
        });
    });
    return gridVideoCells;
}
function $de9b795dde6747fa$var$renderFloatingVideoCell({ content: content, containerFrame: containerFrame, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners }) {
    var _a;
    if (!stageLayout.floatingContent) return null;
    const cell = stageLayout.floatingContent;
    const origin = {
        top: cell.origin.top,
        left: cell.origin.left
    };
    const style = {
        width: Math.round(cell.bounds.width),
        height: Math.round(cell.bounds.height),
        transform: `translate3d(${Math.round(containerFrame.origin.left + origin.left)}px, ${Math.round(containerFrame.origin.top + origin.top)}px, 0)`,
        position: "fixed",
        top: cell.bounds.height / 2,
        left: 0,
        zIndex: 40
    };
    const clientId = ((_a = content.props.client) === null || _a === void 0 ? void 0 : _a.id) || "floating";
    const childWithProps = $eZVvM.cloneElement(content, {
        isSmallCell: cell.isSmallCell,
        isZoomedByDefault: false,
        canZoom: false,
        key: clientId,
        isDraggable: false
    });
    return $de9b795dde6747fa$var$renderVideoCell({
        cell: cell,
        child: childWithProps,
        clientId: clientId,
        style: style,
        withRoundedCorners: withRoundedCorners,
        withShadow: false
    });
}
function $de9b795dde6747fa$var$VideoStageLayout({ containerFrame: containerFrame, debug: debug = false, featureRoundedCornersOff: featureRoundedCornersOff = false, floatingContent: floatingContent, gridContent: gridContent = [], isConstrained: isConstrained = false, layoutOverflowBackdropFrame: layoutOverflowBackdropFrame = $de9b795dde6747fa$var$makeFrame(), layoutVideoStage: stageLayout, presentationGridContent: presentationGridContent = [], subgridContent: subgridContent = [] }) {
    const withRoundedCorners = !featureRoundedCornersOff && !isConstrained;
    const cells = [];
    if (gridContent.length) cells.push(...$de9b795dde6747fa$var$renderGridVideoCells({
        content: gridContent,
        isConstrained: isConstrained,
        stageLayout: stageLayout,
        withRoundedCorners: withRoundedCorners,
        withShadow: !isConstrained
    }));
    if (presentationGridContent.length) cells.push(...$de9b795dde6747fa$var$renderPresentationGridVideoCells({
        content: presentationGridContent,
        isConstrained: isConstrained,
        stageLayout: stageLayout,
        withRoundedCorners: withRoundedCorners,
        withShadow: !isConstrained
    }));
    if (floatingContent) cells.push($de9b795dde6747fa$var$renderFloatingVideoCell({
        content: floatingContent,
        containerFrame: containerFrame,
        stageLayout: stageLayout,
        withRoundedCorners: !featureRoundedCornersOff
    }));
    if (subgridContent.length) cells.push(...$de9b795dde6747fa$var$renderSubgridVideoCells({
        content: subgridContent,
        stageLayout: stageLayout,
        withRoundedCorners: !featureRoundedCornersOff,
        withShadow: true
    }));
    return $eZVvM.createElement("div", {
        key: "video-stage-layout",
        style: {
            width: "100%",
            height: "100%",
            position: "relative"
        }
    }, $de9b795dde6747fa$var$hasBounds(layoutOverflowBackdropFrame.bounds) && $eZVvM.createElement("div", {
        style: $de9b795dde6747fa$var$generateStylesFromFrame(layoutOverflowBackdropFrame)
    }), cells, debug && $eZVvM.createElement($eZVvM.Fragment, null));
}
const $de9b795dde6747fa$var$WIDE_AR = 16 / 9;
const $de9b795dde6747fa$var$NORMAL_AR = 4 / 3;
const $de9b795dde6747fa$var$clamp = ({ value: value, min: min, max: max })=>Math.min(Math.max(value, min), max);
function $de9b795dde6747fa$var$hasDuplicates(...array) {
    return new Set(array).size !== array.length;
}
function $de9b795dde6747fa$var$findMostCommon(arr) {
    return arr.sort((a, b)=>arr.filter((v)=>v === a).length - arr.filter((v)=>v === b).length).pop();
}
function $de9b795dde6747fa$var$pickCellAspectRatio({ choices: choices = [] }) {
    const minAr = Math.min(...choices);
    const maxAr = Math.max(...choices);
    let chosenAr = null;
    if (minAr === maxAr) chosenAr = minAr;
    else {
        const dominantAr = $de9b795dde6747fa$var$hasDuplicates(choices) ? $de9b795dde6747fa$var$findMostCommon(choices) : maxAr;
        chosenAr = $de9b795dde6747fa$var$clamp({
            value: dominantAr || maxAr,
            min: $de9b795dde6747fa$var$NORMAL_AR,
            max: $de9b795dde6747fa$var$WIDE_AR
        });
    }
    return {
        minAr: minAr,
        maxAr: maxAr,
        chosenAr: chosenAr
    };
}
function $de9b795dde6747fa$var$getCenterPadding$1({ rows: rows, cols: cols, cellWidth: cellWidth, index: index, cellCount: cellCount, gridGap: gridGap }) {
    const max = rows * cols;
    const leftOver = max - cellCount;
    if (!leftOver) return 0;
    const lastIndex = max - leftOver - 1;
    const firstIndex = lastIndex - (cols - leftOver) + 1;
    const lastRowPadding = leftOver * cellWidth / 2 + gridGap;
    return index >= firstIndex && index <= lastIndex ? lastRowPadding : 0;
}
function $de9b795dde6747fa$var$getCellBounds({ width: width, height: height, rows: rows, cols: cols, gridGap: gridGap, aspectRatio: aspectRatio }) {
    const cellWidth = (width - (cols - 1) * gridGap) / cols;
    const cellHeight = (height - (rows - 1) * gridGap) / rows;
    const ar = cellWidth / cellHeight;
    let horizontalCorrection = 0;
    let verticalCorrection = 0;
    if (aspectRatio < ar) horizontalCorrection = cellWidth - cellHeight * aspectRatio;
    else if (aspectRatio > ar) verticalCorrection = cellHeight - cellWidth / aspectRatio;
    const totalHorizontalCorrection = horizontalCorrection * cols;
    const totalVerticalCorrection = verticalCorrection * rows;
    return {
        cellWidth: cellWidth - horizontalCorrection,
        cellHeight: cellHeight - verticalCorrection,
        extraHorizontalPadding: totalHorizontalCorrection / 2,
        extraVerticalPadding: totalVerticalCorrection / 2
    };
}
function $de9b795dde6747fa$var$calculateLayout$3({ width: width, height: height, cellCount: cellCount, gridGap: gridGap, cellAspectRatios: cellAspectRatios = [
    $de9b795dde6747fa$var$NORMAL_AR
], paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    if (!cellCount) return {
        cellCount: cellCount,
        cellHeight: 0,
        cellWidth: 0,
        cols: 0,
        rows: 0,
        extraHorizontalPadding: 0,
        extraVerticalPadding: 0,
        gridGap: gridGap,
        paddings: paddings
    };
    const contentWidth = width - (paddings.left + paddings.right);
    const contentHeight = height - (paddings.top + paddings.bottom);
    const cellAspectRatioTuple = $de9b795dde6747fa$var$pickCellAspectRatio({
        choices: cellAspectRatios
    });
    let cellAspectRatio = cellAspectRatioTuple.chosenAr;
    const { rows: rows, cols: cols } = $de9b795dde6747fa$var$getGridSizeForCount({
        count: cellCount,
        width: contentWidth,
        height: contentHeight,
        aspectRatio: cellAspectRatio
    });
    if (rows === 1) cellAspectRatio = $de9b795dde6747fa$var$clamp({
        value: contentWidth / cols / contentHeight,
        min: Math.min(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr),
        max: Math.max(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr)
    });
    else if (cols === 1) cellAspectRatio = $de9b795dde6747fa$var$clamp({
        value: contentWidth / (contentHeight / rows),
        min: Math.min(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr),
        max: Math.max(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr)
    });
    const { cellWidth: cellWidth, cellHeight: cellHeight, extraHorizontalPadding: extraHorizontalPadding, extraVerticalPadding: extraVerticalPadding } = $de9b795dde6747fa$var$getCellBounds({
        width: contentWidth,
        height: contentHeight,
        rows: rows,
        cols: cols,
        gridGap: gridGap,
        aspectRatio: cellAspectRatio
    });
    return {
        cellCount: cellCount,
        cellHeight: cellHeight,
        cellWidth: cellWidth,
        cols: cols,
        rows: rows,
        extraHorizontalPadding: extraHorizontalPadding,
        extraVerticalPadding: extraVerticalPadding,
        gridGap: gridGap,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$2({ index: index, layout: layout }) {
    const { cellWidth: cellWidth, cellHeight: cellHeight, rows: rows, cols: cols, cellCount: cellCount, gridGap: gridGap } = layout;
    const top = Math.floor(index / cols);
    const left = Math.floor(index % cols);
    const leftPadding = $de9b795dde6747fa$var$getCenterPadding$1({
        rows: rows,
        cols: cols,
        cellWidth: cellWidth,
        index: index,
        cellCount: cellCount,
        gridGap: gridGap
    });
    return {
        top: top * cellHeight + top * gridGap,
        left: left * cellWidth + left * gridGap + leftPadding,
        width: cellWidth,
        height: cellHeight
    };
}
const $de9b795dde6747fa$var$ROWS = "rows";
const $de9b795dde6747fa$var$COLUMNS = "columns";
function $de9b795dde6747fa$var$getPortraitLayoutGridForCount(count) {
    return ({
        1: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                1
            ]
        },
        2: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                1,
                1
            ]
        },
        3: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                1
            ]
        },
        4: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2
            ]
        },
        5: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                1
            ]
        },
        6: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                2
            ]
        },
        7: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2,
                2
            ]
        },
        8: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                2,
                2
            ]
        },
        9: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2,
                2,
                2
            ]
        },
        10: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                2,
                2
            ]
        },
        11: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                2
            ]
        },
        12: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3
            ]
        },
        13: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3
            ]
        },
        14: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3
            ]
        },
        15: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3
            ]
        },
        16: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3
            ]
        },
        17: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3
            ]
        },
        18: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        19: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3,
                3
            ]
        },
        20: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        21: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        22: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        23: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        24: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        }
    })[count] || {
        type: $de9b795dde6747fa$var$ROWS,
        lines: [
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3
        ]
    };
}
function $de9b795dde6747fa$var$getLandscapeLayoutGridForCount(count) {
    return ({
        1: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                1
            ]
        },
        2: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                1,
                1
            ]
        },
        3: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                1
            ]
        },
        4: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2
            ]
        },
        5: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2
            ],
            fractions: [
                0.45,
                0.55
            ]
        },
        6: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2,
                2
            ]
        },
        7: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                4,
                3
            ],
            fractions: [
                0.45,
                0.55
            ]
        },
        8: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2,
                2,
                2
            ]
        },
        9: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                2,
                2,
                2
            ]
        },
        10: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                2,
                2
            ]
        },
        11: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                2
            ]
        },
        12: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                3
            ]
        },
        13: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                3,
                3,
                3
            ]
        },
        14: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                3,
                3
            ]
        },
        15: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                3,
                3
            ]
        },
        16: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                3,
                3,
                3,
                3
            ]
        },
        17: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                3,
                3,
                3
            ]
        },
        18: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                3,
                3
            ]
        },
        19: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                4,
                3
            ]
        },
        20: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                4,
                4
            ]
        },
        21: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                4,
                4,
                4,
                4
            ]
        },
        22: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                4,
                4,
                4
            ]
        },
        23: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                5,
                4,
                4
            ]
        },
        24: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                5,
                5,
                4
            ]
        }
    })[count] || {
        type: $de9b795dde6747fa$var$COLUMNS,
        lines: [
            5,
            5,
            5,
            5,
            5
        ]
    };
}
function $de9b795dde6747fa$var$calcCellDimensions({ layoutGrid: layoutGrid, dim: dim, secDim: secDim, index: index, count: count, gridGap: gridGap }) {
    const adjustedDim = dim - gridGap * (count - 1);
    const cellDim = adjustedDim * (layoutGrid.fractions ? layoutGrid.fractions[index] : 1 / count);
    const secCount = layoutGrid.lines[index];
    const adjustedSecDim = secDim - gridGap * (secCount - 1);
    const secCellDim = adjustedSecDim / secCount;
    return [
        cellDim,
        secCellDim
    ];
}
function $de9b795dde6747fa$var$partitionRectBy({ isHorizontal: isHorizontal, layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    const cellRects = [];
    const origin = {
        x: 0,
        y: 0
    };
    const cellOrigin = {
        x: 0,
        y: 0
    };
    const count = layoutGrid.lines.length;
    const dim = isHorizontal ? height : width;
    const secDim = isHorizontal ? width : height;
    for(let index = 0; index < count; index++){
        const cellDims = $de9b795dde6747fa$var$calcCellDimensions({
            layoutGrid: layoutGrid,
            dim: dim,
            secDim: secDim,
            index: index,
            count: count,
            gridGap: gridGap
        });
        const width = isHorizontal ? cellDims[1] : cellDims[0];
        const height = isHorizontal ? cellDims[0] : cellDims[1];
        const cellBounds = {
            width: width,
            height: height
        };
        const linesCount = layoutGrid.lines[index];
        for(let lineIndex = 0; lineIndex < linesCount; lineIndex++){
            cellRects.push({
                origin: Object.assign({}, cellOrigin),
                bounds: cellBounds
            });
            if (isHorizontal) cellOrigin.x += cellBounds.width + gridGap;
            else cellOrigin.y += cellBounds.height + gridGap;
        }
        if (isHorizontal) {
            cellOrigin.y += cellBounds.height + gridGap;
            cellOrigin.x = origin.x;
        } else {
            cellOrigin.x += cellBounds.width + gridGap;
            cellOrigin.y = origin.y;
        }
    }
    return cellRects;
}
function $de9b795dde6747fa$var$partitionRectByRows({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    return $de9b795dde6747fa$var$partitionRectBy({
        isHorizontal: true,
        layoutGrid: layoutGrid,
        width: width,
        height: height,
        gridGap: gridGap
    });
}
function $de9b795dde6747fa$var$partitionRectByColumns({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    return $de9b795dde6747fa$var$partitionRectBy({
        isHorizontal: false,
        layoutGrid: layoutGrid,
        width: width,
        height: height,
        gridGap: gridGap
    });
}
function $de9b795dde6747fa$var$partitionRect({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    switch(layoutGrid.type){
        case $de9b795dde6747fa$var$ROWS:
            return $de9b795dde6747fa$var$partitionRectByRows({
                layoutGrid: layoutGrid,
                width: width,
                height: height,
                gridGap: gridGap
            });
        case $de9b795dde6747fa$var$COLUMNS:
            return $de9b795dde6747fa$var$partitionRectByColumns({
                layoutGrid: layoutGrid,
                width: width,
                height: height,
                gridGap: gridGap
            });
    }
}
function $de9b795dde6747fa$var$calculateLayout$2({ width: width, height: height, cellCount: cellCount, gridGap: gridGap = 0, paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    const contentWidth = width - (paddings.left + paddings.right);
    const contentHeight = height - (paddings.top + paddings.bottom);
    const isPortrait = Math.round(contentWidth / contentHeight * 10) / 10 <= 1.0;
    const layoutGrid = isPortrait ? $de9b795dde6747fa$var$getPortraitLayoutGridForCount(cellCount) : $de9b795dde6747fa$var$getLandscapeLayoutGridForCount(cellCount);
    const cellRects = $de9b795dde6747fa$var$partitionRect({
        layoutGrid: layoutGrid,
        width: contentWidth,
        height: contentHeight,
        gridGap: gridGap
    }) || [];
    return {
        cellRects: cellRects,
        cellCount: cellCount,
        gridGap: gridGap,
        extraHorizontalPadding: 0,
        extraVerticalPadding: 0,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$1({ index: index, layout: layout }) {
    const { cellRects: cellRects } = layout;
    const frame = cellRects[index] || $de9b795dde6747fa$var$makeFrame();
    return {
        top: frame.origin.y,
        left: frame.origin.x,
        width: frame.bounds.width,
        height: frame.bounds.height
    };
}
function $de9b795dde6747fa$var$getCenterPadding({ index: index, isPortrait: isPortrait, rows: rows, cols: cols, cellBounds: cellBounds, cellCount: cellCount }) {
    const canFit = rows * cols;
    const leftOver = canFit - cellCount;
    if (!leftOver) return 0;
    const lastIndex = canFit - leftOver - 1;
    const dimension = isPortrait ? cols : rows;
    const firstIndex = lastIndex - (dimension - leftOver) + 1;
    if (index < firstIndex || index > lastIndex) return 0;
    return leftOver * (isPortrait ? cellBounds.width : cellBounds.height) / 2;
}
function $de9b795dde6747fa$var$calculateLayout$1({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellBounds: cellBounds, paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    let width = 0;
    let height = 0;
    let rows = 0;
    let cols = 0;
    let extraHorizontalPadding = 0;
    let extraVerticalPadding = 0;
    const contentWidth = containerBounds.width - paddings.left - paddings.right;
    const contentHeight = containerBounds.height - paddings.top - paddings.bottom;
    if (cellCount) {
        if (isPortrait) {
            cols = Math.floor(contentWidth / cellBounds.width);
            rows = Math.ceil(cellCount / cols);
            width = contentWidth;
            height = rows * cellBounds.height;
            extraHorizontalPadding = (contentWidth - cols * cellBounds.width) / 2;
        } else {
            rows = Math.floor(contentHeight / cellBounds.height);
            cols = Math.ceil(cellCount / rows);
            width = cols * cellBounds.width;
            height = contentHeight;
            extraVerticalPadding = (contentHeight - rows * cellBounds.height) / 2;
        }
    }
    return {
        isPortrait: isPortrait,
        width: width + paddings.left + paddings.right,
        height: height + paddings.top + paddings.bottom,
        cellBounds: cellBounds,
        cellCount: cellCount,
        rows: rows,
        cols: cols,
        extraHorizontalPadding: extraHorizontalPadding,
        extraVerticalPadding: extraVerticalPadding,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout({ index: index, layout: layout }) {
    const { isPortrait: isPortrait, rows: rows, cols: cols, cellCount: cellCount, cellBounds: cellBounds, extraHorizontalPadding: extraHorizontalPadding, extraVerticalPadding: extraVerticalPadding, paddings: paddings } = layout;
    const top = isPortrait ? Math.floor(index / cols) : Math.floor(index % rows);
    const left = isPortrait ? Math.floor(index % cols) : Math.floor(index / rows);
    const centerPadding = $de9b795dde6747fa$var$getCenterPadding({
        index: index,
        isPortrait: isPortrait,
        rows: rows,
        cols: cols,
        cellBounds: cellBounds,
        cellCount: cellCount
    });
    return {
        top: paddings.top + extraVerticalPadding + top * cellBounds.height + (isPortrait ? 0 : centerPadding),
        left: paddings.left + extraHorizontalPadding + left * cellBounds.width + (isPortrait ? centerPadding : 0),
        width: cellBounds.width,
        height: cellBounds.height
    };
}
const { BOTTOM_TOOLBAR_HEIGHT: $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT, VIDEO_CONTROLS_MIN_WIDTH: $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH, TABLET_BREAKPOINT: $de9b795dde6747fa$var$TABLET_BREAKPOINT, SUBGRID_EMPTY_STAGE_MAX_WIDTH: $de9b795dde6747fa$var$SUBGRID_EMPTY_STAGE_MAX_WIDTH } = $de9b795dde6747fa$var$layoutConstants;
const $de9b795dde6747fa$var$MIN_GRID_HEIGHT = 200;
const $de9b795dde6747fa$var$MIN_GRID_WIDTH = 300;
const $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE = 200;
const $de9b795dde6747fa$var$OVERFLOW_ROOM_SUBGRID_TOP_PADDING = 20;
const $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER = 12;
const $de9b795dde6747fa$var$SUBGRID_CELL_PADDING_BOX = $de9b795dde6747fa$var$makeBox({
    top: 4,
    bottom: 28,
    left: 8,
    right: 8
});
function $de9b795dde6747fa$var$getSubgridSizeOptions({ hasOverflow: hasOverflow, hasStage: hasStage }) {
    if (hasOverflow && hasStage) return [
        80
    ];
    return [
        80,
        60
    ];
}
function $de9b795dde6747fa$var$getMinGridBounds({ cellCount: cellCount }) {
    const isSmallGrid = cellCount <= 6;
    const minGridHeight = isSmallGrid ? $de9b795dde6747fa$var$MIN_GRID_HEIGHT - 50 : $de9b795dde6747fa$var$MIN_GRID_HEIGHT;
    const minGridWidth = isSmallGrid ? $de9b795dde6747fa$var$MIN_GRID_WIDTH - 50 : $de9b795dde6747fa$var$MIN_GRID_WIDTH;
    return $de9b795dde6747fa$var$makeBounds({
        width: minGridWidth,
        height: minGridHeight
    });
}
function $de9b795dde6747fa$var$fitSupersizedContent({ bounds: bounds, aspectRatio: aspectRatio, minGridContainerBounds: minGridContainerBounds, hasPresentationGrid: hasPresentationGrid }) {
    const { width: width, height: height } = bounds;
    const hasVideoGrid = minGridContainerBounds.width > 0;
    if (!hasVideoGrid) return {
        isPortrait: width <= height,
        supersizedContentBounds: bounds
    };
    const minHorizontalSupersizedContentWidth = Math.round(width / 2);
    const minVerticalSupersizedContentHeight = Math.round(height / 2);
    const maxHorizontalSupersizedContentWidth = Math.max(width - minGridContainerBounds.width, 0);
    const maxVerticalSupersizedContentHeight = Math.max(height - minGridContainerBounds.height, 0);
    let isPortrait = maxHorizontalSupersizedContentWidth <= maxVerticalSupersizedContentHeight;
    let horizontalCorrection = 0;
    let verticalCorrection = 0;
    if (aspectRatio) {
        const horizontalContentBounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: maxHorizontalSupersizedContentWidth,
            height: height
        });
        const verticalContentBounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: width,
            height: maxVerticalSupersizedContentHeight
        });
        const isPortraitContent = aspectRatio <= 1.0;
        isPortrait = isPortraitContent ? verticalContentBounds.height > horizontalContentBounds.height : verticalContentBounds.width > horizontalContentBounds.width;
        if (isPortrait) {
            const wastedSpace = maxVerticalSupersizedContentHeight - Math.max(verticalContentBounds.height, minVerticalSupersizedContentHeight);
            verticalCorrection = Math.max(wastedSpace, 0);
        } else {
            const wastedSpace = maxHorizontalSupersizedContentWidth - Math.max(horizontalContentBounds.width, minHorizontalSupersizedContentWidth);
            horizontalCorrection = Math.max(wastedSpace, 0);
        }
    } else if (hasPresentationGrid) isPortrait = maxHorizontalSupersizedContentWidth / maxVerticalSupersizedContentHeight >= 5;
    const supersizedContentBounds = {
        width: isPortrait ? width : maxHorizontalSupersizedContentWidth - horizontalCorrection,
        height: isPortrait ? maxVerticalSupersizedContentHeight - verticalCorrection : height
    };
    return {
        isPortrait: isPortrait,
        supersizedContentBounds: supersizedContentBounds
    };
}
function $de9b795dde6747fa$var$findBestSubgridLayout({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellSizeOptions: cellSizeOptions, cellPaddings: cellPaddings, paddings: paddings }) {
    let layout;
    for(let i = 0; i < cellSizeOptions.length; i++){
        const cellSize = cellSizeOptions[i];
        layout = $de9b795dde6747fa$var$calculateLayout$1({
            containerBounds: containerBounds,
            isPortrait: isPortrait,
            cellCount: cellCount,
            cellBounds: $de9b795dde6747fa$var$makeBounds({
                width: cellSize + cellPaddings.left + cellPaddings.right,
                height: cellSize + cellPaddings.top + cellPaddings.bottom
            }),
            paddings: paddings
        });
        if (layout.width <= containerBounds.width && layout.height <= containerBounds.height) return layout;
    }
    return layout;
}
function $de9b795dde6747fa$var$calculateSubgridLayout({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellSizeOptions: cellSizeOptions, cellPaddings: cellPaddings, paddings: paddings }) {
    const layout = $de9b795dde6747fa$var$findBestSubgridLayout({
        containerBounds: containerBounds,
        isPortrait: isPortrait,
        cellCount: cellCount,
        cellSizeOptions: cellSizeOptions,
        cellPaddings: cellPaddings,
        paddings: paddings
    });
    const isSmallCell = layout.cellBounds.width - cellPaddings.left - cellPaddings.right === cellSizeOptions[cellSizeOptions.length - 1];
    const bounds = $de9b795dde6747fa$var$makeBounds({
        width: Math.min(layout.width, containerBounds.width),
        height: Math.min(layout.height, containerBounds.height)
    });
    const contentBounds = $de9b795dde6747fa$var$makeBounds({
        width: layout.width,
        height: layout.height
    });
    if (cellCount === 0) return {
        bounds: bounds,
        contentBounds: contentBounds,
        videoCells: []
    };
    return {
        bounds: bounds,
        contentBounds: contentBounds,
        videoCells: [
            ...Array(cellCount)
        ].map((_, index)=>{
            const { top: top, left: left, width: width, height: height } = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout({
                index: index,
                layout: layout
            });
            return {
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: top,
                    left: left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: width,
                    height: height
                }),
                paddings: cellPaddings,
                isSmallCell: isSmallCell
            };
        })
    };
}
function $de9b795dde6747fa$var$calculateStageLayout({ cellPaddings: cellPaddings, cellSizeOptions: cellSizeOptions, containerBounds: containerBounds, containerOrigin: containerOrigin, gridGap: gridGap, hasConstrainedOverflow: hasConstrainedOverflow, hasPresentationContent: hasPresentationContent, hasVideoContent: hasVideoContent, isConstrained: isConstrained, isMaximizeMode: isMaximizeMode, isPortrait: isPortrait, isSmallScreen: isSmallScreen, maxGridWidth: maxGridWidth, shouldOverflowSubgrid: shouldOverflowSubgrid, subgridVideos: subgridVideos }) {
    const { width: width, height: height } = containerBounds;
    const hasVideos = hasPresentationContent || hasVideoContent;
    const hasSubgrid = subgridVideos.length > 0;
    if (!hasSubgrid && !hasVideos) return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame()), {
            contentBounds: $de9b795dde6747fa$var$makeBounds(),
            cells: []
        }),
        hasOverflow: false
    };
    if (!hasSubgrid) return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, containerBounds), containerOrigin)),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame()), {
            contentBounds: $de9b795dde6747fa$var$makeBounds(),
            cells: []
        }),
        hasOverflow: hasConstrainedOverflow
    };
    const topSubgridPadding = shouldOverflowSubgrid ? $de9b795dde6747fa$var$OVERFLOW_ROOM_SUBGRID_TOP_PADDING : 0;
    let _containerBounds = null;
    if (!hasVideos) _containerBounds = $de9b795dde6747fa$var$makeBounds({
        width: Math.min($de9b795dde6747fa$var$SUBGRID_EMPTY_STAGE_MAX_WIDTH, containerBounds.width),
        height: containerBounds.height
    });
    else if (shouldOverflowSubgrid) {
        const cellSize = cellSizeOptions[0];
        let visibleSubgridHeight = isMaximizeMode ? $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT : $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT + cellPaddings.top + (isConstrained || isSmallScreen ? cellSize / 2 : cellSize) + cellPaddings.bottom;
        if (containerBounds.height - visibleSubgridHeight < $de9b795dde6747fa$var$MIN_GRID_HEIGHT) visibleSubgridHeight = 0;
        _containerBounds = $de9b795dde6747fa$var$makeBounds({
            width: containerBounds.width,
            height: visibleSubgridHeight
        });
    } else if (isMaximizeMode) _containerBounds = $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width,
        height: cellSizeOptions[0] + cellPaddings.top + cellPaddings.bottom
    });
    else _containerBounds = isPortrait ? $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width,
        height: containerBounds.height / 2
    }) : $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width / 2,
        height: containerBounds.height
    });
    let leftSubgridPadding = 0;
    if (_containerBounds.width > maxGridWidth) leftSubgridPadding = (_containerBounds.width - maxGridWidth) / 2;
    const subgridLayout = $de9b795dde6747fa$var$calculateSubgridLayout({
        containerBounds: _containerBounds,
        isPortrait: isPortrait,
        cellCount: subgridVideos.length,
        cellSizeOptions: cellSizeOptions,
        cellPaddings: cellPaddings,
        paddings: $de9b795dde6747fa$var$makeBox({
            top: topSubgridPadding,
            left: leftSubgridPadding,
            right: leftSubgridPadding
        })
    });
    const overflowNeedBounds = $de9b795dde6747fa$var$makeBounds({
        width: subgridLayout.contentBounds.width - _containerBounds.width,
        height: subgridLayout.contentBounds.height - _containerBounds.height
    });
    const hasOverflow = overflowNeedBounds.width > 0 || overflowNeedBounds.height > 0;
    let subgridBounds = null;
    if (!hasVideos || shouldOverflowSubgrid || hasOverflow) subgridBounds = subgridLayout.contentBounds;
    else subgridBounds = subgridLayout.bounds;
    let videosContainerBounds;
    let _subgridContainerShareBounds = subgridBounds;
    if (hasVideos) {
        if (shouldOverflowSubgrid) _subgridContainerShareBounds = $de9b795dde6747fa$var$makeBounds({
            width: 0,
            height: _containerBounds.height + topSubgridPadding + gridGap
        });
        else _subgridContainerShareBounds = isPortrait ? $de9b795dde6747fa$var$makeBounds({
            width: 0,
            height: subgridLayout.bounds.height + gridGap
        }) : $de9b795dde6747fa$var$makeBounds({
            width: subgridLayout.bounds.width + gridGap,
            height: 0
        });
        videosContainerBounds = $de9b795dde6747fa$var$insetBounds({
            bounds: _subgridContainerShareBounds,
            fromBounds: containerBounds
        });
    } else videosContainerBounds = $de9b795dde6747fa$var$makeBounds();
    const videosContainerOrigin = Object.assign({}, containerOrigin);
    let subgridOrigin;
    if (hasVideos) subgridOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: isPortrait ? Math.max(containerOrigin.top + height - _subgridContainerShareBounds.height + gridGap, 0) : containerOrigin.top,
        left: isPortrait ? containerOrigin.left : Math.max(containerOrigin.left + width - subgridBounds.width, 0)
    });
    else subgridOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: containerOrigin.top + Math.max(0, (height - subgridBounds.height) / 2),
        left: containerOrigin.left + Math.max(0, (width - subgridBounds.width) / 2)
    });
    return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, videosContainerBounds), videosContainerOrigin)),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, subgridBounds), subgridOrigin))), {
            cells: subgridLayout.videoCells.map((cell, index)=>{
                var _a, _b;
                return Object.assign({
                    aspectRatio: ((_a = subgridVideos[index]) === null || _a === void 0 ? void 0 : _a.aspectRatio) || 1,
                    type: "video",
                    clientId: (_b = subgridVideos[index]) === null || _b === void 0 ? void 0 : _b.clientId
                }, cell);
            }),
            contentBounds: subgridLayout.contentBounds
        }),
        hasOverflow: hasOverflow || shouldOverflowSubgrid || hasConstrainedOverflow,
        overflowNeedBounds: shouldOverflowSubgrid ? $de9b795dde6747fa$var$makeBounds() : overflowNeedBounds
    };
}
function $de9b795dde6747fa$var$calculateVideosContainerLayout({ containerBounds: containerBounds, containerOrigin: containerOrigin, gridGap: gridGap, supersizedContentAspectRatio: supersizedContentAspectRatio, hasPresentationContent: hasPresentationContent, hasPresentationGrid: hasPresentationGrid, hasVideoContent: hasVideoContent, minGridBounds: minGridBounds }) {
    const { width: width, height: height } = containerBounds;
    let isPortrait = width <= height;
    let presentationGridBounds = $de9b795dde6747fa$var$makeBounds();
    let presentationGridOrigin = $de9b795dde6747fa$var$makeOrigin();
    let videoGridBounds = hasVideoContent ? Object.assign({}, containerBounds) : $de9b795dde6747fa$var$makeBounds();
    let videoGridOrigin = hasVideoContent ? Object.assign({}, containerOrigin) : $de9b795dde6747fa$var$makeOrigin();
    if (hasPresentationContent) {
        const minGridContainerBounds = $de9b795dde6747fa$var$makeBounds({
            width: hasVideoContent ? minGridBounds.width + gridGap : 0,
            height: hasVideoContent ? minGridBounds.height + gridGap : 0
        });
        const supersizedContentLayout = $de9b795dde6747fa$var$fitSupersizedContent({
            bounds: containerBounds,
            aspectRatio: supersizedContentAspectRatio || 1,
            minGridContainerBounds: minGridContainerBounds,
            hasPresentationGrid: hasPresentationGrid
        });
        isPortrait = supersizedContentLayout.isPortrait;
        presentationGridBounds = supersizedContentLayout.supersizedContentBounds;
        presentationGridOrigin = Object.assign({}, containerOrigin);
        if (hasVideoContent) {
            videoGridBounds = $de9b795dde6747fa$var$makeBounds({
                width: isPortrait ? containerBounds.width : containerBounds.width - presentationGridBounds.width - gridGap,
                height: isPortrait ? containerBounds.height - presentationGridBounds.height - gridGap : containerBounds.height
            });
            videoGridOrigin = $de9b795dde6747fa$var$makeOrigin({
                top: isPortrait ? containerOrigin.top + presentationGridBounds.height + gridGap : containerOrigin.top,
                left: isPortrait ? containerOrigin.left : containerOrigin.left + presentationGridBounds.width + gridGap
            });
        }
    }
    return {
        isPortrait: isPortrait,
        presentationGrid: Object.assign({}, $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, presentationGridBounds), presentationGridOrigin))),
        videoGrid: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, videoGridBounds), videoGridOrigin))
    };
}
function $de9b795dde6747fa$var$calculateGridLayout({ containerBounds: containerBounds, paddings: paddings = $de9b795dde6747fa$var$makeBox(), videos: videos, isConstrained: isConstrained, maxGridWidth: maxGridWidth, gridGap: gridGap }) {
    const { width: width, height: height } = containerBounds;
    const cappedWidth = maxGridWidth ? Math.min(width, maxGridWidth) : width;
    const cellCount = videos.length;
    let gridLayout = null;
    let videoCells = null;
    if (isConstrained) {
        const constrainedGridLayout = $de9b795dde6747fa$var$calculateLayout$2({
            width: width,
            height: height,
            cellCount: cellCount,
            gridGap: gridGap,
            paddings: paddings
        });
        const isSmallCell = cellCount > 4;
        videoCells = videos.map((video, index)=>{
            const cellProps = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$1({
                index: index,
                layout: constrainedGridLayout
            });
            return {
                clientId: video.clientId,
                isDraggable: video.isDraggable,
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: cellProps.top,
                    left: cellProps.left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: cellProps.width,
                    height: cellProps.height
                }),
                aspectRatio: cellProps.width / cellProps.height,
                isSmallCell: isSmallCell,
                type: "video"
            };
        });
        gridLayout = constrainedGridLayout;
    } else {
        const cellAspectRatios = videos.map((video)=>video.aspectRatio || 1);
        const minGridBounds = $de9b795dde6747fa$var$getMinGridBounds({
            cellCount: cellCount
        });
        const centerGridLayout = $de9b795dde6747fa$var$calculateLayout$3({
            width: cappedWidth,
            height: height,
            cellCount: cellCount,
            gridGap: gridGap,
            cellAspectRatios: cellAspectRatios,
            paddings: paddings
        });
        videoCells = videos.map((video, index)=>{
            const cellProps = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$2({
                index: index,
                layout: centerGridLayout
            });
            const isSmallCell = centerGridLayout.cellWidth < minGridBounds.width;
            const shouldZoom = isConstrained || isSmallCell;
            const aspectRatio = shouldZoom ? centerGridLayout.cellWidth / centerGridLayout.cellHeight : video.aspectRatio || 1;
            return {
                clientId: video.clientId,
                isDraggable: video.isDraggable,
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: cellProps.top,
                    left: cellProps.left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: cellProps.width,
                    height: cellProps.height
                }),
                aspectRatio: aspectRatio,
                isSmallCell: isSmallCell,
                type: "video"
            };
        });
        gridLayout = centerGridLayout;
    }
    return {
        videoCells: videoCells,
        extraHorizontalPadding: width !== cappedWidth ? gridLayout.extraHorizontalPadding + (width - cappedWidth) / 2 : gridLayout.extraHorizontalPadding,
        extraVerticalPadding: gridLayout.extraVerticalPadding,
        paddings: gridLayout.paddings,
        gridGap: gridGap
    };
}
function $de9b795dde6747fa$var$calculateFloatingLayout({ roomBounds: roomBounds, containerFrame: containerFrame, floatingVideo: floatingVideo, videoControlsHeight: videoControlsHeight, margin: margin = 8 }) {
    if (!floatingVideo) return null;
    const bounds = $de9b795dde6747fa$var$fitToBounds(floatingVideo.aspectRatio || 0, {
        width: $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE,
        height: $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE
    });
    const isFloating = !(roomBounds.height - containerFrame.bounds.height - containerFrame.origin.top);
    const isConstrained = containerFrame.bounds.width - (bounds.width + margin) * 2 < $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH;
    let verticalOffset = 0;
    if (isFloating && isConstrained) verticalOffset = videoControlsHeight * -1;
    else if (!isFloating && !isConstrained) verticalOffset = videoControlsHeight;
    const origin = $de9b795dde6747fa$var$makeOrigin({
        top: containerFrame.origin.top + (containerFrame.bounds.height - bounds.height - margin) + verticalOffset,
        left: containerFrame.origin.left + (containerFrame.bounds.width - bounds.width - margin)
    });
    const videoCell = {
        clientId: floatingVideo.clientId,
        isDraggable: floatingVideo.isDraggable,
        origin: origin,
        bounds: bounds,
        aspectRatio: floatingVideo.aspectRatio,
        isSmallCell: true
    };
    return videoCell;
}
function $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({ a: a, b: b, gridGap: gridGap, isPortrait: isPortrait }) {
    const aPad = isPortrait ? a.vertical : a.horizontal;
    const bPad = isPortrait ? b.vertical : b.horizontal;
    if (aPad === bPad) return {
        a: 0,
        b: 0
    };
    const sArea = aPad < bPad ? a : b;
    const sAreaPad = isPortrait ? sArea.vertical : sArea.horizontal;
    const spaceBetween = gridGap + (aPad + bPad);
    const offset = (spaceBetween + sAreaPad) / 2 - sAreaPad;
    return {
        a: sArea === a ? offset : 0,
        b: sArea === b ? offset : 0
    };
}
function $de9b795dde6747fa$var$rebalanceLayoutInPlace({ videosContainerLayout: videosContainerLayout, gridLayout: gridLayout, presentationGridLayout: presentationGridLayout, stageLayout: stageLayout, gridGap: gridGap, shouldOverflowSubgrid: shouldOverflowSubgrid }) {
    const hasPresentationGrid = videosContainerLayout.presentationGrid.bounds.width > 0;
    const hasVideoGrid = videosContainerLayout.videoGrid.bounds.width > 0;
    const hasSubgrid = stageLayout.subgrid.bounds.width > 0;
    const videoGridRebalanceOffset = {
        vertical: 0,
        horizontal: 0
    };
    if (hasPresentationGrid && hasVideoGrid) {
        const correction = $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({
            a: {
                horizontal: presentationGridLayout.extraHorizontalPadding,
                vertical: presentationGridLayout.extraVerticalPadding
            },
            b: {
                horizontal: gridLayout.extraHorizontalPadding,
                vertical: gridLayout.extraVerticalPadding
            },
            gridGap: gridGap,
            isPortrait: videosContainerLayout.isPortrait
        });
        if (videosContainerLayout.isPortrait) {
            videosContainerLayout.presentationGrid.origin.top += correction.a;
            videosContainerLayout.videoGrid.origin.top -= correction.b;
            videoGridRebalanceOffset.vertical = correction.b;
        } else {
            videosContainerLayout.presentationGrid.origin.left += correction.a;
            videosContainerLayout.videoGrid.origin.left -= correction.b;
            videoGridRebalanceOffset.horizontal = correction.b;
        }
    }
    if (hasSubgrid && (hasPresentationGrid || hasVideoGrid) && !shouldOverflowSubgrid) {
        const presentationGridArea = {
            horizontal: presentationGridLayout.extraHorizontalPadding,
            vertical: presentationGridLayout.extraVerticalPadding
        };
        const gridArea = {
            horizontal: gridLayout.extraHorizontalPadding + videoGridRebalanceOffset.horizontal,
            vertical: gridLayout.extraVerticalPadding + videoGridRebalanceOffset.vertical
        };
        let area;
        const hasBothGrids = hasPresentationGrid && hasVideoGrid;
        if (hasBothGrids && videosContainerLayout.isPortrait && !stageLayout.isPortrait) area = presentationGridArea.horizontal < gridArea.horizontal ? presentationGridArea : gridArea;
        else if (hasBothGrids && !videosContainerLayout.isPortrait && stageLayout.isPortrait) area = presentationGridArea.vertical < gridArea.vertical ? presentationGridArea : gridArea;
        else if (hasVideoGrid) area = gridArea;
        else area = presentationGridArea;
        const correction = $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({
            a: area,
            b: {
                horizontal: 0,
                vertical: 0
            },
            gridGap: gridGap,
            isPortrait: stageLayout.isPortrait
        });
        if (stageLayout.isPortrait) stageLayout.subgrid.origin.top -= correction.b;
        else stageLayout.subgrid.origin.left -= correction.b;
    }
}
function $de9b795dde6747fa$var$redistributeEmptySpaceToSubgridInPlace({ vPaddings: vPaddings, hPaddings: hPaddings, stageLayout: stageLayout, videosContainerLayout: videosContainerLayout }) {
    if (stageLayout.isPortrait && (vPaddings.presentationGrid || vPaddings.grid)) {
        const totalVPadding = videosContainerLayout.isPortrait ? vPaddings.presentationGrid * 2 + vPaddings.grid * 2 : vPaddings.presentationGrid + vPaddings.grid;
        stageLayout.videosContainer.bounds.height -= totalVPadding;
        stageLayout.subgrid.origin.top -= totalVPadding;
        stageLayout.subgrid.bounds.height += totalVPadding;
        videosContainerLayout.presentationGrid.bounds.height -= vPaddings.presentationGrid * 2;
        videosContainerLayout.videoGrid.bounds.height -= vPaddings.grid * 2;
        if (videosContainerLayout.isPortrait) videosContainerLayout.videoGrid.origin.top -= vPaddings.presentationGrid;
    }
    if (!stageLayout.isPortrait && (hPaddings.presentationGrid || hPaddings.grid)) {
        const totalHPadding = videosContainerLayout.isPortrait ? hPaddings.presentationGrid + hPaddings.grid : hPaddings.presentationGrid * 2 + hPaddings.grid * 2;
        stageLayout.videosContainer.bounds.width -= totalHPadding;
        stageLayout.subgrid.origin.left -= totalHPadding;
        stageLayout.subgrid.bounds.width += totalHPadding;
        videosContainerLayout.presentationGrid.bounds.width -= hPaddings.presentationGrid * 2;
        videosContainerLayout.videoGrid.bounds.width -= hPaddings.grid * 2;
        if (!videosContainerLayout.isPortrait) videosContainerLayout.videoGrid.origin.left -= hPaddings.grid;
    }
}
function $de9b795dde6747fa$var$findGridsEmptySpaceToRedistribute({ need: need, stageLayout: stageLayout, gridLayout: gridLayout, presentationGridLayout: presentationGridLayout, videosContainerLayout: videosContainerLayout }) {
    let vPaddings = {
        presentationGrid: 0,
        grid: 0
    };
    let hPaddings = {
        presentationGrid: 0,
        grid: 0
    };
    if (stageLayout.isPortrait) {
        const minDim = Math.min(gridLayout.extraVerticalPadding, presentationGridLayout.extraVerticalPadding);
        vPaddings = {
            presentationGrid: Math.min(videosContainerLayout.isPortrait ? presentationGridLayout.extraVerticalPadding : minDim, need.height),
            grid: Math.min(videosContainerLayout.isPortrait ? gridLayout.extraVerticalPadding : minDim, need.height)
        };
    } else {
        const minDim = Math.min(gridLayout.extraHorizontalPadding, presentationGridLayout.extraHorizontalPadding);
        hPaddings = {
            presentationGrid: Math.min(videosContainerLayout.isPortrait ? minDim : presentationGridLayout.extraHorizontalPadding, need.width),
            grid: Math.min(videosContainerLayout.isPortrait ? minDim : gridLayout.extraHorizontalPadding, need.width)
        };
    }
    return {
        vPaddings: vPaddings,
        hPaddings: hPaddings
    };
}
function $de9b795dde6747fa$var$calculateGridLayouts({ gridGap: gridGap, isConstrained: isConstrained, presentationVideos: presentationVideos, videos: videos, videosContainerLayout: videosContainerLayout, gridLayoutPaddings: gridLayoutPaddings = $de9b795dde6747fa$var$makeBox(), presentationGridLayoutPaddings: presentationGridLayoutPaddings = $de9b795dde6747fa$var$makeBox(), maxGridWidth: maxGridWidth }) {
    const gridLayout = $de9b795dde6747fa$var$calculateGridLayout({
        containerBounds: videosContainerLayout.videoGrid.bounds,
        gridGap: gridGap,
        isConstrained: isConstrained,
        maxGridWidth: maxGridWidth,
        paddings: gridLayoutPaddings,
        videos: videos
    });
    const presentationGridLayout = $de9b795dde6747fa$var$calculateGridLayout({
        containerBounds: videosContainerLayout.presentationGrid.bounds,
        gridGap: gridGap,
        isConstrained: isConstrained,
        maxGridWidth: maxGridWidth,
        paddings: presentationGridLayoutPaddings,
        videos: presentationVideos
    });
    return {
        gridLayout: gridLayout,
        presentationGridLayout: presentationGridLayout
    };
}
function $de9b795dde6747fa$var$calculateLayout({ floatingVideo: floatingVideo, frame: frame, gridGap: gridGap, isConstrained: isConstrained, isMaximizeMode: isMaximizeMode = false, isXLMeetingSize: isXLMeetingSize = false, paddings: paddings = $de9b795dde6747fa$var$makeBox(), presentationVideos: presentationVideos = [], rebalanceLayout: rebalanceLayout = false, roomBounds: roomBounds, roomLayoutHasOverlow: roomLayoutHasOverlow = false, subgridCellPaddings: subgridCellPaddings = $de9b795dde6747fa$var$SUBGRID_CELL_PADDING_BOX, subgridVideos: subgridVideos = [], videoControlsHeight: videoControlsHeight = 0, videos: videos = [], videoGridGap: videoGridGap }) {
    let shouldOverflowSubgrid = isXLMeetingSize && (screen ? screen.width <= 2048 : true);
    const hasPresentationContent = !!presentationVideos.length;
    const hasPresentationGrid = presentationVideos.length > 1;
    const supersizedContentAspectRatio = hasPresentationContent && !hasPresentationGrid ? presentationVideos[0].aspectRatio : null;
    const hasVideoContent = !!videos.length;
    const width = frame.bounds.width - paddings.left - paddings.right;
    let height = frame.bounds.height - paddings.top - paddings.bottom;
    const maxGridWidth = Math.max(2200, 0.8 * width);
    const hasConstrainedOverflow = isConstrained && videos.length > $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER;
    const lineHeight = height / 4;
    const extraLines = Math.ceil((videos.length - $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER) / 3);
    height = hasConstrainedOverflow ? height + lineHeight * extraLines : height;
    const stageBounds = $de9b795dde6747fa$var$makeBounds({
        width: width,
        height: height
    });
    const stageOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: paddings.top,
        left: paddings.left
    });
    const _minBounds = $de9b795dde6747fa$var$getMinGridBounds({
        cellCount: videos.length
    });
    const minGridBounds = _minBounds;
    const isSmallScreen = roomBounds.width < $de9b795dde6747fa$var$TABLET_BREAKPOINT || roomBounds.height < $de9b795dde6747fa$var$TABLET_BREAKPOINT;
    const forceStageLayoutPortrait = isMaximizeMode;
    const stageLayoutIsPortrait = forceStageLayoutPortrait || shouldOverflowSubgrid || !(hasPresentationContent || hasVideoContent) || stageBounds.width <= stageBounds.height;
    const stableStageLayoutProps = {
        cellPaddings: subgridCellPaddings,
        containerBounds: stageBounds,
        containerOrigin: stageOrigin,
        gridGap: gridGap,
        hasPresentationContent: hasPresentationContent,
        hasVideoContent: hasVideoContent,
        isConstrained: isConstrained,
        isMaximizeMode: isMaximizeMode,
        isSmallScreen: isSmallScreen,
        subgridVideos: subgridVideos,
        maxGridWidth: maxGridWidth
    };
    let stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
        cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
            hasOverflow: shouldOverflowSubgrid,
            hasStage: hasPresentationContent || hasVideoContent
        }),
        isPortrait: stageLayoutIsPortrait,
        shouldOverflowSubgrid: shouldOverflowSubgrid,
        hasConstrainedOverflow: hasConstrainedOverflow
    }));
    let forceRerunAsOverflow = false;
    if (!shouldOverflowSubgrid && roomLayoutHasOverlow && !stageLayout.hasOverflow) {
        const _stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
            containerBounds: $de9b795dde6747fa$var$makeBounds({
                width: stageBounds.width,
                height: stageBounds.height - $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT
            }),
            cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
                hasOverflow: shouldOverflowSubgrid,
                hasStage: hasPresentationContent || hasVideoContent
            }),
            isPortrait: stageLayoutIsPortrait,
            shouldOverflowSubgrid: shouldOverflowSubgrid,
            hasConstrainedOverflow: hasConstrainedOverflow
        }));
        if (_stageLayout.hasOverflow) forceRerunAsOverflow = true;
    }
    if (forceRerunAsOverflow || stageLayout.hasOverflow && !shouldOverflowSubgrid) {
        shouldOverflowSubgrid = true;
        stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
            cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
                hasOverflow: true,
                hasStage: hasPresentationContent || hasVideoContent
            }),
            isPortrait: true,
            shouldOverflowSubgrid: shouldOverflowSubgrid,
            hasConstrainedOverflow: hasConstrainedOverflow
        }));
    }
    const videosContainerLayout = $de9b795dde6747fa$var$calculateVideosContainerLayout({
        containerBounds: stageLayout.videosContainer.bounds,
        containerOrigin: stageLayout.videosContainer.origin,
        gridGap: gridGap,
        supersizedContentAspectRatio: supersizedContentAspectRatio || 1,
        hasPresentationContent: hasPresentationContent,
        hasPresentationGrid: hasPresentationGrid,
        hasVideoContent: hasVideoContent,
        minGridBounds: minGridBounds
    });
    let { gridLayout: gridLayout, presentationGridLayout: presentationGridLayout } = $de9b795dde6747fa$var$calculateGridLayouts({
        gridGap: videoGridGap || gridGap,
        isConstrained: isConstrained,
        presentationVideos: presentationVideos,
        videos: videos,
        videosContainerLayout: videosContainerLayout,
        maxGridWidth: maxGridWidth
    });
    if (stageLayout.hasOverflow && !shouldOverflowSubgrid) {
        const { vPaddings: vPaddings, hPaddings: hPaddings } = $de9b795dde6747fa$var$findGridsEmptySpaceToRedistribute({
            need: stageLayout.overflowNeedBounds || $de9b795dde6747fa$var$makeBounds(),
            stageLayout: stageLayout,
            gridLayout: gridLayout,
            presentationGridLayout: presentationGridLayout,
            videosContainerLayout: videosContainerLayout
        });
        if (vPaddings.presentationGrid || vPaddings.grid || hPaddings.presentationGrid || hPaddings.grid) {
            $de9b795dde6747fa$var$redistributeEmptySpaceToSubgridInPlace({
                vPaddings: vPaddings,
                hPaddings: hPaddings,
                stageLayout: stageLayout,
                videosContainerLayout: videosContainerLayout
            });
            ({ gridLayout: gridLayout, presentationGridLayout: presentationGridLayout } = $de9b795dde6747fa$var$calculateGridLayouts({
                gridGap: videoGridGap || gridGap,
                isConstrained: isConstrained,
                presentationVideos: presentationVideos,
                videos: videos,
                videosContainerLayout: videosContainerLayout,
                maxGridWidth: maxGridWidth
            }));
        }
    }
    const floatingLayout = $de9b795dde6747fa$var$calculateFloatingLayout({
        roomBounds: roomBounds,
        containerFrame: frame,
        floatingVideo: floatingVideo || null,
        videoControlsHeight: videoControlsHeight
    });
    if (rebalanceLayout) $de9b795dde6747fa$var$rebalanceLayoutInPlace({
        videosContainerLayout: videosContainerLayout,
        gridLayout: gridLayout,
        presentationGridLayout: presentationGridLayout,
        stageLayout: stageLayout,
        gridGap: gridGap,
        shouldOverflowSubgrid: shouldOverflowSubgrid
    });
    let overflowBoundsHeight = paddings.top + stageLayout.videosContainer.bounds.height + stageLayout.subgrid.bounds.height + paddings.bottom;
    if (hasPresentationContent || hasVideoContent) overflowBoundsHeight += gridGap;
    return {
        isPortrait: stageLayout.isPortrait,
        hasOverflow: stageLayout.hasOverflow,
        videosContainer: Object.assign(Object.assign({}, videosContainerLayout), {
            bounds: $de9b795dde6747fa$var$makeBounds({
                width: stageLayout.videosContainer.bounds.width,
                height: stageLayout.videosContainer.bounds.height
            }),
            origin: $de9b795dde6747fa$var$makeOrigin({
                top: stageLayout.videosContainer.origin.top,
                left: stageLayout.videosContainer.origin.left
            })
        }),
        bounds: $de9b795dde6747fa$var$makeBounds({
            height: shouldOverflowSubgrid ? overflowBoundsHeight : frame.bounds.height,
            width: frame.bounds.width
        }),
        gridGap: gridGap,
        presentationGrid: Object.assign(Object.assign({}, videosContainerLayout.presentationGrid), {
            cells: presentationGridLayout.videoCells,
            paddings: $de9b795dde6747fa$var$makeBox({
                top: presentationGridLayout.paddings.top + presentationGridLayout.extraVerticalPadding,
                bottom: presentationGridLayout.paddings.bottom + presentationGridLayout.extraVerticalPadding,
                left: presentationGridLayout.paddings.left + presentationGridLayout.extraHorizontalPadding,
                right: presentationGridLayout.paddings.right + presentationGridLayout.extraHorizontalPadding
            })
        }),
        videoGrid: Object.assign(Object.assign({}, videosContainerLayout.videoGrid), {
            cells: gridLayout.videoCells,
            paddings: $de9b795dde6747fa$var$makeBox({
                top: gridLayout.paddings.top + gridLayout.extraVerticalPadding,
                bottom: gridLayout.paddings.bottom + gridLayout.extraVerticalPadding,
                left: gridLayout.paddings.left + gridLayout.extraHorizontalPadding,
                right: gridLayout.paddings.right + gridLayout.extraHorizontalPadding
            })
        }),
        subgrid: stageLayout.subgrid,
        floatingContent: Object.assign(Object.assign(Object.assign({}, floatingLayout), floatingVideo), {
            origin: (floatingLayout === null || floatingLayout === void 0 ? void 0 : floatingLayout.origin) || $de9b795dde6747fa$var$makeOrigin(),
            bounds: (floatingLayout === null || floatingLayout === void 0 ? void 0 : floatingLayout.bounds) || $de9b795dde6747fa$var$makeBounds(),
            aspectRatio: (floatingVideo === null || floatingVideo === void 0 ? void 0 : floatingVideo.aspectRatio) || 1
        })
    };
}
function $de9b795dde6747fa$var$makeVideoCellView({ aspectRatio: aspectRatio, avatarSize: avatarSize, cellPaddings: cellPaddings, client: client, isDraggable: isDraggable = true, isPlaceholder: isPlaceholder = false, isSubgrid: isSubgrid = false }) {
    return {
        aspectRatio: aspectRatio || 16 / 9,
        avatarSize: avatarSize,
        cellPaddings: cellPaddings,
        client: client,
        clientId: (client === null || client === void 0 ? void 0 : client.id) || "",
        isDraggable: isDraggable,
        isPlaceholder: isPlaceholder,
        isSubgrid: isSubgrid,
        type: "video"
    };
}
const $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT = 12;
const $de9b795dde6747fa$var$ACTIVE_VIDEO_SUBGRID_TRIGGER = 12;
const $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT = 24;
function $de9b795dde6747fa$var$calculateSubgridViews({ clientViews: clientViews, activeVideosSubgridTrigger: activeVideosSubgridTrigger, shouldShowSubgrid: shouldShowSubgrid, spotlightedParticipants: spotlightedParticipants, maximizedParticipant: maximizedParticipant, isPhoneResolution: isPhoneResolution }) {
    if (!shouldShowSubgrid) return [];
    const hasSpotlights = spotlightedParticipants.length > 0;
    const hasPresentationStage = hasSpotlights;
    const notMaximized = maximizedParticipant ? clientViews.filter((client)=>client.id !== maximizedParticipant.id) : clientViews;
    const notSpotlighted = notMaximized.filter((client)=>!client.isPresentation && !spotlightedParticipants.includes(client));
    const noVideoViews = notSpotlighted.filter((client)=>!client.isVideoEnabled);
    const videoLimitReached = notSpotlighted.filter((client)=>client.isVideoEnabled).length > activeVideosSubgridTrigger;
    const unmutedVideos = notSpotlighted.filter((client)=>!noVideoViews.includes(client) && client.isAudioEnabled);
    const mutedVideos = notSpotlighted.filter((client)=>!noVideoViews.includes(client) && !client.isAudioEnabled);
    if (noVideoViews.length && hasPresentationStage) return [
        ...mutedVideos,
        ...noVideoViews
    ];
    if (isPhoneResolution && notSpotlighted.length > $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT) {
        const sorted = [
            ...unmutedVideos,
            ...mutedVideos
        ];
        const inGrid = sorted.slice(0, $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT);
        if (inGrid.length <= $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT) return [
            ...sorted.filter((client)=>!inGrid.includes(client)),
            ...noVideoViews
        ];
        else return [
            ...mutedVideos,
            ...noVideoViews
        ];
    }
    if (videoLimitReached && mutedVideos.length) {
        const sorted = [
            ...unmutedVideos,
            ...mutedVideos
        ];
        const inGrid = sorted.slice(0, activeVideosSubgridTrigger);
        if (inGrid.length <= activeVideosSubgridTrigger) return [
            ...mutedVideos.filter((client)=>!inGrid.includes(client)),
            ...noVideoViews
        ];
        else return [
            ...mutedVideos,
            ...noVideoViews
        ];
    }
    return noVideoViews;
}
function $de9b795dde6747fa$var$useGridParticipants({ activeVideosSubgridTrigger: activeVideosSubgridTrigger = $de9b795dde6747fa$var$ACTIVE_VIDEO_SUBGRID_TRIGGER, stageParticipantLimit: stageParticipantLimit = $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT, forceSubgrid: forceSubgrid = true, enableSubgrid: enableSubgrid = true, maximizedParticipant: maximizedParticipant, floatingParticipant: floatingParticipant, isConstrained: isConstrained = false } = {}) {
    const allClientViews = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$dc94230bce59ebc));
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const numParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$2a789fd8acb91b21));
    const floatingClientView = $eZVvM.useMemo(()=>{
        return floatingParticipant;
    }, [
        floatingParticipant
    ]);
    const clientViewsNotFloating = $eZVvM.useMemo(()=>{
        if (floatingClientView) return allClientViews.filter((c)=>c.id !== floatingClientView.id);
        return allClientViews;
    }, [
        allClientViews,
        floatingClientView
    ]);
    const shouldShowSubgrid = $eZVvM.useMemo(()=>{
        if (!enableSubgrid) return false;
        return forceSubgrid ? true : numParticipants > stageParticipantLimit;
    }, [
        forceSubgrid,
        numParticipants,
        stageParticipantLimit,
        enableSubgrid
    ]);
    const clientViewsInSubgrid = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$calculateSubgridViews({
            clientViews: clientViewsNotFloating,
            activeVideosSubgridTrigger: activeVideosSubgridTrigger,
            shouldShowSubgrid: shouldShowSubgrid,
            spotlightedParticipants: spotlightedParticipants,
            maximizedParticipant: maximizedParticipant,
            isPhoneResolution: isConstrained
        });
    }, [
        clientViewsNotFloating,
        shouldShowSubgrid,
        activeVideosSubgridTrigger,
        spotlightedParticipants,
        isConstrained
    ]);
    const clientViewsOnStage = $eZVvM.useMemo(()=>{
        return clientViewsNotFloating.filter((client)=>!clientViewsInSubgrid.includes(client));
    }, [
        clientViewsNotFloating,
        clientViewsInSubgrid
    ]);
    const clientViewsInPresentationGrid = $eZVvM.useMemo(()=>{
        if (maximizedParticipant) return [
            maximizedParticipant
        ];
        return spotlightedParticipants;
    }, [
        spotlightedParticipants,
        maximizedParticipant
    ]);
    const clientViewsInGrid = $eZVvM.useMemo(()=>{
        return clientViewsOnStage.filter((client)=>!clientViewsInPresentationGrid.includes(client));
    }, [
        clientViewsOnStage,
        clientViewsInPresentationGrid
    ]);
    return {
        floatingClientView: floatingClientView,
        clientViewsInGrid: clientViewsInGrid,
        clientViewsInPresentationGrid: clientViewsInPresentationGrid,
        clientViewsInSubgrid: clientViewsInSubgrid
    };
}
function $de9b795dde6747fa$var$useGrid({ activeVideosSubgridTrigger: activeVideosSubgridTrigger, forceSubgrid: forceSubgrid, stageParticipantLimit: stageParticipantLimit = $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT, gridGap: gridGap = 8, videoGridGap: videoGridGap = 8, enableSubgrid: enableSubgrid = true, enableConstrainedGrid: enableConstrainedGrid = true } = {}) {
    const [containerBounds, setContainerBounds] = $eZVvM.useState({
        width: 0,
        height: 0
    });
    const [isConstrained, setIsConstrained] = $eZVvM.useState(false);
    const [clientAspectRatios, setClientAspectRatios] = $eZVvM.useState({});
    const [maximizedParticipant, setMaximizedParticipant] = $eZVvM.useState(null);
    const [floatingParticipant, setFloatingParticipant] = $eZVvM.useState(null);
    const { clientViewsInGrid: clientViewsInGrid, clientViewsInPresentationGrid: clientViewsInPresentationGrid, clientViewsInSubgrid: clientViewsInSubgrid, floatingClientView: floatingClientView } = $de9b795dde6747fa$var$useGridParticipants({
        activeVideosSubgridTrigger: activeVideosSubgridTrigger,
        forceSubgrid: forceSubgrid,
        stageParticipantLimit: stageParticipantLimit,
        enableSubgrid: enableSubgrid,
        maximizedParticipant: maximizedParticipant,
        floatingParticipant: floatingParticipant,
        isConstrained: !!enableConstrainedGrid && !!isConstrained
    });
    const cellViewsFloating = $eZVvM.useMemo(()=>{
        return floatingClientView ? [
            $de9b795dde6747fa$var$makeVideoCellView({
                client: floatingClientView,
                aspectRatio: clientAspectRatios[floatingClientView.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            })
        ] : [];
    }, [
        floatingClientView,
        clientAspectRatios
    ]);
    const cellViewsVideoGrid = $eZVvM.useMemo(()=>{
        return clientViewsInGrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            });
        });
    }, [
        clientViewsInGrid,
        clientAspectRatios
    ]);
    const cellViewsInPresentationGrid = $eZVvM.useMemo(()=>{
        return clientViewsInPresentationGrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            });
        });
    }, [
        clientViewsInPresentationGrid,
        clientAspectRatios
    ]);
    const cellViewsInSubgrid = $eZVvM.useMemo(()=>{
        return clientViewsInSubgrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                },
                isSubgrid: true
            });
        });
    }, [
        clientViewsInSubgrid,
        clientAspectRatios
    ]);
    const containerFrame = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$makeFrame(containerBounds);
    }, [
        containerBounds
    ]);
    $eZVvM.useEffect(()=>{
        if (!enableConstrainedGrid) return;
        setIsConstrained(containerBounds.width < 500 || containerBounds.height < 500);
    }, [
        containerBounds,
        enableConstrainedGrid
    ]);
    const videoStage = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$calculateLayout({
            floatingVideo: cellViewsFloating[0],
            frame: containerFrame,
            gridGap: gridGap,
            isConstrained: isConstrained,
            roomBounds: containerFrame.bounds,
            videos: cellViewsVideoGrid,
            videoGridGap: videoGridGap,
            presentationVideos: cellViewsInPresentationGrid,
            subgridVideos: cellViewsInSubgrid
        });
    }, [
        containerFrame,
        cellViewsFloating,
        cellViewsVideoGrid,
        cellViewsInPresentationGrid,
        cellViewsInSubgrid,
        gridGap,
        videoGridGap
    ]);
    return {
        containerFrame: containerFrame,
        cellViewsFloating: cellViewsFloating,
        cellViewsVideoGrid: cellViewsVideoGrid,
        cellViewsInPresentationGrid: cellViewsInPresentationGrid,
        cellViewsInSubgrid: cellViewsInSubgrid,
        clientAspectRatios: clientAspectRatios,
        videoStage: videoStage,
        setContainerBounds: setContainerBounds,
        setClientAspectRatios: setClientAspectRatios,
        maximizedParticipant: maximizedParticipant,
        setMaximizedParticipant: setMaximizedParticipant,
        floatingParticipant: floatingParticipant,
        setFloatingParticipant: setFloatingParticipant,
        isConstrained: isConstrained
    };
}
const $de9b795dde6747fa$var$getInitialsFromName = (name = "")=>{
    name = name.trim();
    if (name) {
        const initials = name.split(/-| /).map((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($72a1b7fe1c0aa35a$exports)))(n)[0]);
        return initials.slice(0, 3);
    }
    return [];
};
const $de9b795dde6747fa$var$Initials = ({ name: name })=>{
    const initials = $de9b795dde6747fa$var$getInitialsFromName(name);
    const fontSize = [
        0,
        56,
        48,
        40
    ][initials.length] || 32;
    const initialsStr = initials.join("").toUpperCase();
    return $eZVvM.createElement("svg", {
        viewBox: "-60 -60 120 120",
        "aria-hidden": "true",
        style: {
            height: "100%",
            pointerEvents: "none",
            width: "100%"
        }
    }, $eZVvM.createElement("text", {
        x: 0,
        y: 0,
        textAnchor: "middle",
        dominantBaseline: "central",
        fontSize: fontSize
    }, initialsStr));
};
function $de9b795dde6747fa$var$Avatar(_a) {
    var { avatarUrl: avatarUrl, className: className, size: size = 40, name: name, variant: variant = "round" } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "avatarUrl",
        "className",
        "size",
        "name",
        "variant"
    ]);
    return $eZVvM.createElement("div", Object.assign({
        style: {
            height: `${size}px`,
            width: `${size}px`,
            userSelect: "none",
            overflow: "hidden",
            borderRadius: variant === "round" ? "50%" : "4px",
            backgroundColor: "#f8e3c8"
        },
        className: className,
        title: name
    }, rest), !avatarUrl && name ? $eZVvM.createElement($de9b795dde6747fa$var$Initials, {
        name: name
    }) : $eZVvM.createElement("img", {
        src: avatarUrl || "",
        alt: "",
        style: {
            height: "100%",
            width: "100%",
            objectFit: "cover",
            maxWidth: "initial"
        }
    }));
}
function $de9b795dde6747fa$var$VideoMutedIndicator({ avatarUrl: avatarUrl, displayName: displayName, isSmallCell: isSmallCell, withRoundedCorners: withRoundedCorners }) {
    return $eZVvM.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            borderRadius: withRoundedCorners ? "8px" : "0"
        }
    }, $eZVvM.createElement("div", {
        style: {
            height: isSmallCell ? 60 : 80,
            width: isSmallCell ? 60 : 80,
            pointerEvents: "none",
            position: "relative"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$Avatar, {
        variant: "square",
        avatarUrl: avatarUrl,
        name: displayName,
        size: isSmallCell ? 60 : 80
    })));
}
const $de9b795dde6747fa$var$Popover = $d30790ce46109715$export$be92b6f5f03c0fe9;
const $de9b795dde6747fa$var$PopoverTrigger = $d30790ce46109715$export$41fb9f06171c75f4;
const $de9b795dde6747fa$var$PopoverContent = $eZVvM.forwardRef((_a, ref)=>{
    var { style: style, align: align = "center", sideOffset: sideOffset = 4 } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "style",
        "align",
        "sideOffset"
    ]);
    return $eZVvM.createElement($d30790ce46109715$export$602eac185826482c, null, $eZVvM.createElement($d30790ce46109715$export$7c6e2c02157bb7d2, Object.assign({
        ref: ref,
        align: align,
        sideOffset: sideOffset,
        style: Object.assign({
            width: "200px",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "0.375rem",
            boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            color: "#333",
            fontSize: "14px",
            lineHeight: "1.5",
            padding: "16px",
            zIndex: 50,
            outline: "none"
        }, style)
    }, props)));
});
$de9b795dde6747fa$var$PopoverContent.displayName = $d30790ce46109715$export$7c6e2c02157bb7d2.displayName;
const $de9b795dde6747fa$var$GridContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$GridCellContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$useGridCell = ()=>{
    const gridContext = $eZVvM.useContext($de9b795dde6747fa$var$GridContext);
    const gridCellContext = $eZVvM.useContext($de9b795dde6747fa$var$GridCellContext);
    if (!gridCellContext) throw new Error("useGridCell must be used within a GridCell");
    return Object.assign(Object.assign({}, gridContext), gridCellContext);
};
const $de9b795dde6747fa$var$ParticipantMenuContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$useParticipantMenu = ()=>{
    const context = $eZVvM.useContext($de9b795dde6747fa$var$ParticipantMenuContext);
    const gridCellContext = $de9b795dde6747fa$var$useGridCell();
    if (!context) throw new Error("useParticipantMenu must be used within a ParticipantMenu");
    return Object.assign(Object.assign({}, context), gridCellContext);
};
const $de9b795dde6747fa$export$5e4296a99c887f6d = (props)=>{
    const { children: children } = props, rest = $de9b795dde6747fa$var$__rest(props, [
        "children"
    ]);
    const [open, setOpen] = $eZVvM.useState(false);
    return $eZVvM.createElement($de9b795dde6747fa$var$ParticipantMenuContext.Provider, {
        value: {
            open: open,
            setOpen: setOpen
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$Popover, Object.assign({}, rest, {
        open: open,
        onOpenChange: setOpen
    }), children));
};
const $de9b795dde6747fa$export$b1dac2119cac8cb2 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style"
    ]);
    return $eZVvM.createElement($de9b795dde6747fa$var$PopoverContent, Object.assign({
        ref: ref,
        style: Object.assign({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "180px",
            maxWidth: "300px",
            maxHeight: "100vh",
            overflowY: "auto",
            padding: 0
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$b1dac2119cac8cb2.displayName = "ParticipantMenuContent";
const $de9b795dde6747fa$export$f6ea8009f49c9769 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style"
    ]);
    return $eZVvM.createElement($de9b795dde6747fa$var$PopoverTrigger, Object.assign({
        ref: ref,
        style: Object.assign({
            position: "absolute",
            top: "10px",
            right: "20px",
            textDecoration: "none",
            whiteSpace: "nowrap",
            border: "none",
            cursor: "pointer"
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$f6ea8009f49c9769.displayName = $de9b795dde6747fa$var$PopoverTrigger.displayName;
const $de9b795dde6747fa$export$2296c43061a9fca3 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style, participantAction: participantAction } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style",
        "participantAction"
    ]);
    const { participant: participant, setOpen: setOpen, maximizedParticipant: maximizedParticipant, setMaximizedParticipant: setMaximizedParticipant, setFloatingParticipant: setFloatingParticipant, floatingParticipant: floatingParticipant } = $de9b795dde6747fa$var$useParticipantMenu();
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const isSpotlighted = spotlightedParticipants.find((p)=>p.id === participant.id);
    const isMaximized = (maximizedParticipant === null || maximizedParticipant === void 0 ? void 0 : maximizedParticipant.id) === participant.id;
    const isFloating = (floatingParticipant === null || floatingParticipant === void 0 ? void 0 : floatingParticipant.id) === participant.id;
    let onClick;
    switch(participantAction){
        case "maximize":
            onClick = ()=>{
                if (isMaximized) setMaximizedParticipant(null);
                else setMaximizedParticipant(participant);
                setOpen(false);
            };
            break;
        case "spotlight":
            onClick = ()=>{
                if (isSpotlighted) dispatch((0, $4fc09928452de42f$export$65b4309b6edd4ad1)({
                    id: participant.id
                }));
                else dispatch((0, $4fc09928452de42f$export$4bf19d94733cc82e)({
                    id: participant.id
                }));
                setOpen(false);
            };
            break;
        case "float":
            onClick = ()=>{
                if (isFloating) setFloatingParticipant(null);
                else setFloatingParticipant(participant);
                setOpen(false);
            };
            break;
    }
    return $eZVvM.createElement("button", Object.assign({
        ref: ref,
        role: "menuitem",
        tabIndex: -1,
        onClick: onClick !== null && onClick !== void 0 ? onClick : props.onClick,
        style: Object.assign({
            alignItems: "stretch",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            height: "40px",
            lineHeight: "40px",
            minWidth: "140px",
            padding: "0 12px",
            textAlign: "left",
            textDecoration: "none",
            whiteSpace: "nowrap",
            width: "100%"
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$2296c43061a9fca3.displayName = "ParticipantMenuItem";
function $de9b795dde6747fa$var$EllipsisIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("g", null, $eZVvM.createElement("circle", {
        cx: "6",
        cy: "12",
        r: "2"
    }), $eZVvM.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), $eZVvM.createElement("circle", {
        cx: "18",
        cy: "12",
        r: "2"
    })));
}
function $de9b795dde6747fa$var$MaximizeOnIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13.875 3c0 .62132.5037 1.125 1.125 1.125h3.284l-4.0795 4.0795c-.4393.43934-.4393 1.15166 0 1.591.4393.4393 1.1517.4393 1.591 0l4.0795-4.07951v3.28401c0 .62132.5037 1.125 1.125 1.125s1.125-.50368 1.125-1.125v-6c0-.15254-.0304-.29799-.0854-.43063-.0536-.12968-.1326-.25135-.2368-.35749l-.0147-.01469c-.203-.19928-.4812-.32219-.7881-.32219h-6c-.6213 0-1.125.50368-1.125 1.125zm-9.75 12c0-.6213-.50368-1.125-1.125-1.125s-1.125.5037-1.125 1.125v6c0 .3069.12291.5851.32219.7881.00486.005.00975.0099.01469.0147.10614.1042.22781.1832.35749.2368.13264.055.27809.0854.43063.0854h6c.62132 0 1.125-.5037 1.125-1.125s-.50368-1.125-1.125-1.125h-3.28401l4.07951-4.0795c.4393-.4393.4393-1.1517 0-1.591-.43934-.4393-1.15166-.4393-1.591 0l-4.0795 4.0795z"
    }));
}
function $de9b795dde6747fa$var$SpotlightIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.241.146691c-.1011-.1955882-.3809-.1955879-.482 0l-1.1063 2.139639c-.0258.04991-.0665.09058-.1164.11639l-2.1396 1.10629c-.1956.10113-.1956.38085 0 .48198l2.1396 1.10629c.0499.02581.0906.06648.1164.11639l1.1063 2.13964c.1011.19559.3809.19559.482 0l1.1063-2.13964c.0258-.04991.0665-.09058.1164-.11639l2.1396-1.10629c.1956-.10113.1956-.38085 0-.48198l-2.1396-1.10629c-.0499-.02581-.0906-.06648-.1164-.11639zm-13.741 2.900259v14.67495c0 .0511.00116.1018.00345.1523-.00229.0418-.00345.0837-.00345.1258 0 .5674.21005 1.1103.59339 1.6103.24265.3472.55042.6455.90566.8773 1.61225 1.213 4.36988 2.0124 7.50095 2.0124 4.3315 0 7.9484-1.53 8.8068-3.5681.0651-.1472.1148-.3024.1455-.4658.0315-.1532.0477-.3087.0477-.4661 0-.6032-.2374-1.1788-.668-1.7045-.1377-.1975-.2995-.4017-.4877-.6127l-14.22219-13.74809c-.28845-.27884-.67396-.43471-1.07516-.43471-.85436 0-1.54695.69259-1.54695 1.54695zm19.2646 4.59631c.0988-.19101.372-.19101.4708 0l.8546 1.65303c.0253.04874.065.08846.1137.11366l1.653.85465c.1911.0988.1911.372 0 .4708l-1.653.8546c-.0487.0253-.0884.065-.1137.1137l-.8546 1.653c-.0988.1911-.372.1911-.4708 0l-.8546-1.653c-.0253-.0487-.065-.0884-.1137-.1137l-1.653-.8546c-.1911-.0988-.1911-.372 0-.4708l1.653-.85465c.0487-.0252.0884-.06492.1137-.11366zm-3.2651 10.35684c0 .0769-.1144.6851-1.5305 1.3931-1.2964.6482-3.2274 1.1069-5.4695 1.1069s-4.17308-.4587-5.46952-1.1069c-1.41607-.708-1.53047-1.3162-1.53047-1.3931 0-.077.1144-.6851 1.53047-1.3932 1.29644-.6482 3.22742-1.1068 5.46952-1.1068s4.1731.4586 5.4695 1.1068c1.4161.7081 1.5305 1.3162 1.5305 1.3932z"
    }));
}
function $de9b795dde6747fa$var$PopOutIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        clipRule: "evenodd",
        fillRule: "evenodd",
        d: "m2.25 3v4.5c0 .41421.33579.75.75.75h4.5c.41421 0 .75-.33579.75-.75v-4.5c0-.41421-.33579-.75-.75-.75h-4.5c-.41421 0-.75.33579-.75.75zm-2.25 4.5v-4.5c0-1.65685 1.34315-3 3-3h4.5c1.65685 0 3 1.34315 3 3v4.5c0 1.65685-1.34315 3-3 3h-4.5c-1.65685 0-3-1.34315-3-3zm2.25 9v4.5c0 .4142.33579.75.75.75h4.5c.41421 0 .75-.3358.75-.75v-4.5c0-.4142-.33579-.75-.75-.75h-4.5c-.41421 0-.75.3358-.75.75zm-2.25 4.5v-4.5c0-1.6569 1.34315-3 3-3h4.5c1.65685 0 3 1.3431 3 3v4.5c0 1.6569-1.34315 3-3 3h-4.5c-1.65685 0-3-1.3431-3-3zm15.75-13.5v-4.5c0-.41421.3358-.75.75-.75h4.5c.4142 0 .75.33579.75.75v4.5c0 .41421-.3358.75-.75.75h-4.5c-.4142 0-.75-.33579-.75-.75zm-2.25-4.5v4.5c0 1.65685 1.3431 3 3 3h4.5c1.6569 0 3-1.34315 3-3v-4.5c0-1.65685-1.3431-3-3-3h-4.5c-1.6569 0-3 1.34315-3 3zm1.875 19.5c0-.6213.5037-1.125 1.125-1.125h3.284l-5.5795-5.5795c-.4393-.4393-.4393-1.1517 0-1.591s1.1517-.4393 1.591 0l5.5795 5.5795v-3.284c0-.6213.5037-1.125 1.125-1.125s1.125.5037 1.125 1.125v6c0 .308-.1238.5872-.3244.7903-.0033.0034-.0067.0068-.0101.0102-.1067.1054-.2292.1851-.3599.2391-.1326.055-.2781.0854-.4306.0854h-6c-.6213 0-1.125-.5037-1.125-1.125z"
    }));
}
function $de9b795dde6747fa$var$PopInIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        clipRule: "evenodd",
        fillRule: "evenodd",
        d: "m2.25 3v4.5c0 .41421.33579.75.75.75h4.5c.41421 0 .75-.33579.75-.75v-4.5c0-.41421-.33579-.75-.75-.75h-4.5c-.41421 0-.75.33579-.75.75zm-2.25 4.5v-4.5c0-1.65685 1.34315-3 3-3h4.5c1.65685 0 3 1.34315 3 3v4.5c0 1.65685-1.34315 3-3 3h-4.5c-1.65685 0-3-1.34315-3-3zm2.25 9v4.5c0 .4142.33579.75.75.75h4.5c.41421 0 .75-.3358.75-.75v-4.5c0-.4142-.33579-.75-.75-.75h-4.5c-.41421 0-.75.3358-.75.75zm-2.25 4.5v-4.5c0-1.6569 1.34315-3 3-3h4.5c1.65685 0 3 1.3431 3 3v4.5c0 1.6569-1.34315 3-3 3h-4.5c-1.65685 0-3-1.3431-3-3zm15.75-13.5v-4.5c0-.41421.3358-.75.75-.75h4.5c.4142 0 .75.33579.75.75v4.5c0 .41421-.3358.75-.75.75h-4.5c-.4142 0-.75-.33579-.75-.75zm-2.25-4.5v4.5c0 1.65685 1.3431 3 3 3h4.5c1.6569 0 3-1.34315 3-3v-4.5c0-1.65685-1.3431-3-3-3h-4.5c-1.6569 0-3 1.34315-3 3zm8.625 12c0 .6213-.5037 1.125-1.125 1.125h-3.284l5.5795 5.5795c.4393.4393.4393 1.1517 0 1.591s-1.1517.4393-1.591 0l-5.5795-5.5795v3.284c0 .6213-.5037 1.125-1.125 1.125s-1.125-.5037-1.125-1.125v-6c0-.3081.1238-.5872.3244-.7904.0034-.0034.0068-.0068.0102-.0102.1067-.1053.2292-.185.3598-.239.1326-.055.2781-.0854.4306-.0854h6c.6213 0 1.125.5037 1.125 1.125z"
    }));
}
function $de9b795dde6747fa$var$DefaultParticipantMenu({ participant: participant }) {
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const isSpotlighted = spotlightedParticipants.find((p)=>p.id === participant.id);
    const { isHovered: isHovered, maximizedParticipant: maximizedParticipant, floatingParticipant: floatingParticipant } = $de9b795dde6747fa$var$useGridCell();
    const isMaximized = (maximizedParticipant === null || maximizedParticipant === void 0 ? void 0 : maximizedParticipant.id) === participant.id;
    const isFloating = (floatingParticipant === null || floatingParticipant === void 0 ? void 0 : floatingParticipant.id) === participant.id;
    if (!isHovered) return null;
    return $eZVvM.createElement($de9b795dde6747fa$export$5e4296a99c887f6d, null, $eZVvM.createElement($de9b795dde6747fa$export$f6ea8009f49c9769, {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: "6px",
            padding: "4px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$EllipsisIcon, {
        height: 20,
        width: 20,
        transform: "rotate(90)"
    })), $eZVvM.createElement($de9b795dde6747fa$export$b1dac2119cac8cb2, null, participant.isLocalClient ? $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "float",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, isFloating ? $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$var$PopInIcon, {
        height: 16,
        width: 16
    }), "Move to grid") : $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$var$PopOutIcon, {
        height: 16,
        width: 16
    }), "Pop out")) : null, $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "maximize",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$MaximizeOnIcon, {
        height: 16,
        width: 16
    }), isMaximized ? "Minimize" : "Maximize"), $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "spotlight",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$SpotlightIcon, {
        height: 16,
        width: 16
    }), isSpotlighted ? "Remove spotlight" : "Spotlight")));
}
const $de9b795dde6747fa$export$1ce951ee41d30605 = $eZVvM.forwardRef(({ className: className, participant: participant, children: children }, ref)=>{
    const [isHovered, setIsHovered] = $eZVvM.useState(false);
    const handleMouseEnter = $eZVvM.useCallback(()=>{
        setIsHovered(true);
    }, []);
    const handleMouseLeave = $eZVvM.useCallback(()=>{
        setIsHovered(false);
    }, []);
    return $eZVvM.createElement($de9b795dde6747fa$var$GridCellContext.Provider, {
        value: {
            participant: participant,
            isHovered: isHovered
        }
    }, $eZVvM.createElement("div", {
        ref: ref,
        className: className,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        style: {
            height: "100%",
            width: "100%"
        }
    }, children));
});
$de9b795dde6747fa$export$1ce951ee41d30605.displayName = "GridCell";
const $de9b795dde6747fa$export$db6594055fbff7ab = $eZVvM.forwardRef((_a, ref)=>{
    var { stream: stream, style: style } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "stream",
        "style"
    ]);
    const videoEl = $eZVvM.useRef(null);
    const { onSetClientAspectRatio: onSetClientAspectRatio, clientAspectRatios: clientAspectRatios, participant: participant, isConstrained: isConstrained } = $de9b795dde6747fa$var$useGridCell();
    if (!participant) return null;
    const aspectRatio = clientAspectRatios[participant.id];
    $eZVvM.useImperativeHandle(ref, ()=>{
        return videoEl.current;
    });
    const handleResize = $eZVvM.useCallback(()=>{
        const ar = videoEl.current && videoEl.current.captureAspectRatio();
        if (ar && ar !== aspectRatio && participant.id) onSetClientAspectRatio({
            aspectRatio: ar,
            clientId: participant.id
        });
    }, [
        clientAspectRatios,
        participant.id,
        onSetClientAspectRatio
    ]);
    const s = stream || participant.stream;
    if (!s) return null;
    return $eZVvM.createElement($de9b795dde6747fa$export$5da49f1f3cbe3742, Object.assign({
        ref: videoEl,
        style: Object.assign(Object.assign({
            borderRadius: isConstrained ? 0 : "8px"
        }, isConstrained ? {
            objectFit: "cover"
        } : {}), style)
    }, rest, {
        stream: s,
        onVideoResize: handleResize
    }));
});
$de9b795dde6747fa$export$db6594055fbff7ab.displayName = "GridVideoView";
function $de9b795dde6747fa$var$renderCellView({ cellView: cellView, enableParticipantMenu: enableParticipantMenu, render: render }) {
    const participant = cellView === null || cellView === void 0 ? void 0 : cellView.client;
    if (!participant) return undefined;
    switch(cellView.type){
        case "video":
            return $eZVvM.createElement($de9b795dde6747fa$export$1ce951ee41d30605, {
                participant: participant
            }, participant.isVideoEnabled ? $eZVvM.createElement($eZVvM.Fragment, null, render ? render({
                participant: participant
            }) : $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$export$db6594055fbff7ab, null), enableParticipantMenu ? $eZVvM.createElement($de9b795dde6747fa$var$DefaultParticipantMenu, {
                participant: participant
            }) : null)) : $eZVvM.createElement($de9b795dde6747fa$var$VideoMutedIndicator, {
                isSmallCell: false,
                displayName: (participant === null || participant === void 0 ? void 0 : participant.displayName) || "Guest",
                withRoundedCorners: true
            }));
    }
}
function $de9b795dde6747fa$export$9ca22f48fddba890({ renderParticipant: renderParticipant, renderFloatingParticipant: renderFloatingParticipant, stageParticipantLimit: stageParticipantLimit, gridGap: gridGap, videoGridGap: videoGridGap, enableSubgrid: enableSubgrid, enableParticipantMenu: enableParticipantMenu, enableConstrainedGrid: enableConstrainedGrid }) {
    const gridRef = $eZVvM.useRef(null);
    const { containerFrame: containerFrame, cellViewsFloating: cellViewsFloating, cellViewsVideoGrid: cellViewsVideoGrid, cellViewsInPresentationGrid: cellViewsInPresentationGrid, cellViewsInSubgrid: cellViewsInSubgrid, clientAspectRatios: clientAspectRatios, videoStage: videoStage, setContainerBounds: setContainerBounds, setClientAspectRatios: setClientAspectRatios, maximizedParticipant: maximizedParticipant, setMaximizedParticipant: setMaximizedParticipant, isConstrained: isConstrained, floatingParticipant: floatingParticipant, setFloatingParticipant: setFloatingParticipant } = $de9b795dde6747fa$var$useGrid({
        activeVideosSubgridTrigger: 12,
        stageParticipantLimit: stageParticipantLimit,
        gridGap: gridGap,
        videoGridGap: videoGridGap,
        enableSubgrid: enableSubgrid,
        enableConstrainedGrid: enableConstrainedGrid
    });
    const handleSetClientAspectRatio = $eZVvM.useCallback(({ aspectRatio: aspectRatio, clientId: clientId })=>{
        setClientAspectRatios((prev)=>Object.assign(Object.assign({}, prev), {
                [clientId]: aspectRatio
            }));
    }, [
        setClientAspectRatios
    ]);
    const floatingContent = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$renderCellView(Object.assign({
            cellView: cellViewsFloating[0],
            enableParticipantMenu: enableParticipantMenu
        }, renderFloatingParticipant ? {
            render: ({ participant: participant })=>renderFloatingParticipant({
                    participant: participant
                })
        } : {}));
    }, [
        cellViewsFloating
    ]);
    const presentationGridContent = $eZVvM.useMemo(()=>cellViewsInPresentationGrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView(Object.assign({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            }, renderParticipant ? {
                render: ({ participant: participant })=>renderParticipant({
                        participant: participant
                    })
            } : {}))), [
        cellViewsInPresentationGrid
    ]);
    const gridContent = $eZVvM.useMemo(()=>cellViewsVideoGrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView(Object.assign({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            }, renderParticipant ? {
                render: ({ participant: participant })=>renderParticipant({
                        participant: participant
                    })
            } : {}))), [
        cellViewsVideoGrid
    ]);
    const subgridContent = $eZVvM.useMemo(()=>cellViewsInSubgrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            })), [
        cellViewsInSubgrid
    ]);
    $eZVvM.useEffect(()=>{
        if (!gridRef.current) return;
        const resizeObserver = new ResizeObserver((0, $4fc09928452de42f$export$61fc7d43ac8f84b0)(()=>{
            var _a, _b, _c, _d;
            setContainerBounds({
                width: (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 640,
                height: (_d = (_c = gridRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 480
            });
        }, {
            delay: 60,
            edges: false
        }));
        resizeObserver.observe(gridRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return $eZVvM.createElement($de9b795dde6747fa$var$GridContext.Provider, {
        value: {
            onSetClientAspectRatio: handleSetClientAspectRatio,
            cellViewsVideoGrid: cellViewsVideoGrid,
            cellViewsInPresentationGrid: cellViewsInPresentationGrid,
            cellViewsInSubgrid: cellViewsInSubgrid,
            clientAspectRatios: clientAspectRatios,
            maximizedParticipant: maximizedParticipant,
            setMaximizedParticipant: setMaximizedParticipant,
            floatingParticipant: floatingParticipant,
            setFloatingParticipant: setFloatingParticipant,
            isConstrained: isConstrained
        }
    }, $eZVvM.createElement("div", {
        ref: gridRef,
        style: {
            width: "100%",
            height: "100%",
            position: "relative"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$VideoStageLayout, {
        containerFrame: containerFrame,
        floatingContent: floatingContent,
        layoutVideoStage: videoStage,
        presentationGridContent: presentationGridContent,
        gridContent: gridContent,
        subgridContent: subgridContent
    })));
}



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $ivlTt = parcelRequire("ivlTt");

var $bU7jb = parcelRequire("bU7jb");

var $9HTTf = parcelRequire("9HTTf");


var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");
parcelRequire("eZVvM");

var $gnWEo = parcelRequire("gnWEo");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");
"use client";
function $271479f5a10767b7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $271479f5a10767b7$var$useTheme(defaultTheme = null) {
    const contextTheme = $eZVvM.useContext((0, $8kMfp.T));
    return !contextTheme || $271479f5a10767b7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $271479f5a10767b7$export$2e2bcd8739ae039 = $271479f5a10767b7$var$useTheme;


"use client";
const $123cc06973765126$export$35e57303dbd8a66 = (0, $gnWEo.default)();
function $123cc06973765126$var$useTheme(defaultTheme = $123cc06973765126$export$35e57303dbd8a66) {
    return (0, $271479f5a10767b7$export$2e2bcd8739ae039)(defaultTheme);
}
var $123cc06973765126$export$2e2bcd8739ae039 = $123cc06973765126$var$useTheme;



var $2Uans = parcelRequire("2Uans");

var $hDdqv = parcelRequire("hDdqv");
"use client";
function $22960e5129fa60d7$export$2e2bcd8739ae039() {
    const theme = (0, $123cc06973765126$export$2e2bcd8739ae039)((0, $2Uans.default));
    return theme[0, $hDdqv.default] || theme;
}



var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $29929049563c8878$var$GridContext = /*#__PURE__*/ $eZVvM.createContext();
var $29929049563c8878$export$2e2bcd8739ae039 = $29929049563c8878$var$GridContext;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $7f215ca4d84aade2$export$9973ac5fd0181f33(slot) {
    return (0, $8QgsE.default)("MuiGrid", slot);
}
const $7f215ca4d84aade2$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $7f215ca4d84aade2$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $7f215ca4d84aade2$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $7f215ca4d84aade2$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $7f215ca4d84aade2$var$gridClasses = (0, $dvQev.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$7f215ca4d84aade2$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$7f215ca4d84aade2$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$7f215ca4d84aade2$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $7f215ca4d84aade2$export$2e2bcd8739ae039 = $7f215ca4d84aade2$var$gridClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $23610b7fd899719e$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $23610b7fd899719e$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $23610b7fd899719e$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $ivlTt.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$23610b7fd899719e$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $65o8X.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $23610b7fd899719e$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $ivlTt.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $ivlTt.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $23610b7fd899719e$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $23610b7fd899719e$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $ivlTt.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $23610b7fd899719e$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $ivlTt.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$23610b7fd899719e$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $23610b7fd899719e$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $23610b7fd899719e$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $ivlTt.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $23610b7fd899719e$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $ivlTt.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$23610b7fd899719e$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$23610b7fd899719e$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $23610b7fd899719e$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $23610b7fd899719e$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $23610b7fd899719e$var$GridRoot = (0, $e8m2I.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $23610b7fd899719e$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $23610b7fd899719e$export$71d4225eeb1bc13e, $23610b7fd899719e$export$380604d7c79f9e8f, $23610b7fd899719e$export$4315fba5128fb4a1, $23610b7fd899719e$export$ca2a698f6020fda);
function $23610b7fd899719e$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $23610b7fd899719e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $23610b7fd899719e$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $7f215ca4d84aade2$export$9973ac5fd0181f33), classes);
};
const $23610b7fd899719e$var$Grid = /*#__PURE__*/ $eZVvM.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const props = (0, $bU7jb.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $7Z8DW.default)(props, $23610b7fd899719e$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $eZVvM.useContext((0, $29929049563c8878$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $65o8X.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $23610b7fd899719e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $29929049563c8878$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($23610b7fd899719e$var$GridRoot, (0, $65o8X.default)({
            ownerState: ownerState,
            className: (0, $fmwLG.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $23610b7fd899719e$export$2e2bcd8739ae039 = $23610b7fd899719e$var$Grid;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $7Z8DW = parcelRequire("7Z8DW");

var $3XZxQ = parcelRequire("3XZxQ");
function $fb26d559f651f364$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3XZxQ.default)(t, o);
}




var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
var $6c4db6b27121d531$export$2e2bcd8739ae039 = {
    disabled: false
};




var $eZVvM = parcelRequire("eZVvM");
var $1dbe22997e33b48b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);


var $7502c9e61d0d4ec3$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $61e7b8c7fcb92c69$export$bb38bb9a1161268 = "unmounted";
var $61e7b8c7fcb92c69$export$84cbff306f539230 = "exited";
var $61e7b8c7fcb92c69$export$df38205c966be359 = "entering";
var $61e7b8c7fcb92c69$export$78e9e6e3e014d60a = "entered";
var $61e7b8c7fcb92c69$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $61e7b8c7fcb92c69$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $fb26d559f651f364$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $61e7b8c7fcb92c69$export$84cbff306f539230;
                _this.appearStatus = $61e7b8c7fcb92c69$export$df38205c966be359;
            } else initialStatus = $61e7b8c7fcb92c69$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $61e7b8c7fcb92c69$export$bb38bb9a1161268;
        else initialStatus = $61e7b8c7fcb92c69$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $61e7b8c7fcb92c69$export$bb38bb9a1161268) return {
            status: $61e7b8c7fcb92c69$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $61e7b8c7fcb92c69$export$df38205c966be359 && status !== $61e7b8c7fcb92c69$export$78e9e6e3e014d60a) nextStatus = $61e7b8c7fcb92c69$export$df38205c966be359;
            } else if (status === $61e7b8c7fcb92c69$export$df38205c966be359 || status === $61e7b8c7fcb92c69$export$78e9e6e3e014d60a) nextStatus = $61e7b8c7fcb92c69$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $61e7b8c7fcb92c69$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7502c9e61d0d4ec3$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $61e7b8c7fcb92c69$export$84cbff306f539230) this.setState({
            status: $61e7b8c7fcb92c69$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $6c4db6b27121d531$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e7b8c7fcb92c69$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $61e7b8c7fcb92c69$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $61e7b8c7fcb92c69$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $6c4db6b27121d531$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e7b8c7fcb92c69$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $61e7b8c7fcb92c69$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $61e7b8c7fcb92c69$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $61e7b8c7fcb92c69$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $7Z8DW.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Component);
$61e7b8c7fcb92c69$var$Transition.contextType = (0, $1dbe22997e33b48b$export$2e2bcd8739ae039);
$61e7b8c7fcb92c69$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $61e7b8c7fcb92c69$var$noop() {}
$61e7b8c7fcb92c69$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $61e7b8c7fcb92c69$var$noop,
    onEntering: $61e7b8c7fcb92c69$var$noop,
    onEntered: $61e7b8c7fcb92c69$var$noop,
    onExit: $61e7b8c7fcb92c69$var$noop,
    onExiting: $61e7b8c7fcb92c69$var$noop,
    onExited: $61e7b8c7fcb92c69$var$noop
};
$61e7b8c7fcb92c69$var$Transition.UNMOUNTED = $61e7b8c7fcb92c69$export$bb38bb9a1161268;
$61e7b8c7fcb92c69$var$Transition.EXITED = $61e7b8c7fcb92c69$export$84cbff306f539230;
$61e7b8c7fcb92c69$var$Transition.ENTERING = $61e7b8c7fcb92c69$export$df38205c966be359;
$61e7b8c7fcb92c69$var$Transition.ENTERED = $61e7b8c7fcb92c69$export$78e9e6e3e014d60a;
$61e7b8c7fcb92c69$var$Transition.EXITING = $61e7b8c7fcb92c69$export$4aacc83d4d59139f;
var $61e7b8c7fcb92c69$export$2e2bcd8739ae039 = $61e7b8c7fcb92c69$var$Transition;




const $a87adae6755df26f$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $a87adae6755df26f$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $54e94fe5aedb285c$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $ff7ab293f0b0d361$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $eZVvM.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $f19448b4821cb7b2$export$2e2bcd8739ae039 = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039);



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $db075bdb02672c7e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $db075bdb02672c7e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $db075bdb02672c7e$var$Fade = /*#__PURE__*/ $eZVvM.forwardRef(function Fade(props, ref) {
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $db075bdb02672c7e$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                style: (0, $65o8X.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $db075bdb02672c7e$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $db075bdb02672c7e$export$2e2bcd8739ae039 = $db075bdb02672c7e$var$Fade;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");


var $9HTTf = parcelRequire("9HTTf");

var $aNuUP = parcelRequire("aNuUP");

var $iDCHz = parcelRequire("iDCHz");

var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $99562f5127c565e6$export$29cad1383b3f235d(slot) {
    return (0, $8QgsE.default)("MuiCircularProgress", slot);
}
const $99562f5127c565e6$var$circularProgressClasses = (0, $dvQev.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $99562f5127c565e6$export$2e2bcd8739ae039 = $99562f5127c565e6$var$circularProgressClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $046757d70188c03a$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $046757d70188c03a$var$_ = (t)=>t, $046757d70188c03a$var$_t, $046757d70188c03a$var$_t2, $046757d70188c03a$var$_t3, $046757d70188c03a$var$_t4;
const $046757d70188c03a$var$SIZE = 44;
const $046757d70188c03a$var$circularRotateKeyframe = (0, $aNuUP.keyframes)($046757d70188c03a$var$_t || ($046757d70188c03a$var$_t = $046757d70188c03a$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $046757d70188c03a$var$circularDashKeyframe = (0, $aNuUP.keyframes)($046757d70188c03a$var$_t2 || ($046757d70188c03a$var$_t2 = $046757d70188c03a$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $046757d70188c03a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $iDCHz.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $iDCHz.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $99562f5127c565e6$export$29cad1383b3f235d), classes);
};
const $046757d70188c03a$var$CircularProgressRoot = (0, $e8m2I.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $iDCHz.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $aNuUP.css)($046757d70188c03a$var$_t3 || ($046757d70188c03a$var$_t3 = $046757d70188c03a$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $046757d70188c03a$var$circularRotateKeyframe));
const $046757d70188c03a$var$CircularProgressSVG = (0, $e8m2I.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $046757d70188c03a$var$CircularProgressCircle = (0, $e8m2I.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $iDCHz.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $aNuUP.css)($046757d70188c03a$var$_t4 || ($046757d70188c03a$var$_t4 = $046757d70188c03a$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $046757d70188c03a$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $046757d70188c03a$var$CircularProgress = /*#__PURE__*/ $eZVvM.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $7Z8DW.default)(props, $046757d70188c03a$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $046757d70188c03a$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($046757d70188c03a$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        style: (0, $65o8X.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$046757d70188c03a$var$SIZE / 2} ${$046757d70188c03a$var$SIZE / 2} ${$046757d70188c03a$var$SIZE} ${$046757d70188c03a$var$SIZE}`,
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $046757d70188c03a$var$SIZE,
                cy: $046757d70188c03a$var$SIZE,
                r: ($046757d70188c03a$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $046757d70188c03a$export$2e2bcd8739ae039 = $046757d70188c03a$var$CircularProgress;



var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $4J6gH = parcelRequire("4J6gH");

var $gRpev = parcelRequire("gRpev");

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $iqmSy = parcelRequire("iqmSy");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $3442de3c7263c06c$var$PopChildMeasure extends $eZVvM.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $3442de3c7263c06c$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $eZVvM.useId)();
    const ref = (0, $eZVvM.useRef)(null);
    const size = (0, $eZVvM.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $eZVvM.useContext)((0, $iqmSy.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $eZVvM.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $3pI8R.jsx)($3442de3c7263c06c$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $eZVvM.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $d765126604c1d19a$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $gRpev.useConstant)($d765126604c1d19a$var$newChildrenMap);
    const id = (0, $eZVvM.useId)();
    const memoizedOnExitComplete = (0, $eZVvM.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $eZVvM.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $eZVvM.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $eZVvM.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $3pI8R.jsx)((0, $3442de3c7263c06c$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $3pI8R.jsx)((0, $4J6gH.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $d765126604c1d19a$var$newChildrenMap() {
    return new Map();
}



var $heYxd = parcelRequire("heYxd");

var $anHVs = parcelRequire("anHVs");

var $gRpev = parcelRequire("gRpev");

var $eZVvM = parcelRequire("eZVvM");
const $3f5df461b4189bd2$export$10e61aed958678dd = (child)=>child.key || "";
function $3f5df461b4189bd2$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $eZVvM.Children).forEach(children, (child)=>{
        if ((0, $eZVvM.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



var $btbVU = parcelRequire("btbVU");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $315036d4e04024b7$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $anHVs.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $eZVvM.useMemo)(()=>(0, $3f5df461b4189bd2$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $3f5df461b4189bd2$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $eZVvM.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $eZVvM.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $gRpev.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $eZVvM.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $eZVvM.useState)(presentChildren);
    (0, $btbVU.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $3f5df461b4189bd2$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $eZVvM.useContext)((0, $heYxd.LayoutGroupContext));
    return (0, $3pI8R.jsx)((0, $3pI8R.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $3pI8R.jsx)((0, $d765126604c1d19a$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};



var $e8m2I = parcelRequire("e8m2I");

var $kvR7a = parcelRequire("kvR7a");
var $2029d0a4fc5b48e8$exports = {};

!function(e, a) {
    $2029d0a4fc5b48e8$exports = a((parcelRequire("kvR7a")));
}($2029d0a4fc5b48e8$exports, function(e) {
    "use strict";
    function a(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var d = a(e), n = {
        name: "nl",
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
        ordinal: function(e) {
            return "[" + e + (1 === e || 8 === e || e >= 20 ? "ste" : "de") + "]";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            m: "een minuut",
            mm: "%d minuten",
            h: "een uur",
            hh: "%d uur",
            d: "een dag",
            dd: "%d dagen",
            M: "een maand",
            MM: "%d maanden",
            y: "een jaar",
            yy: "%d jaar"
        }
    };
    return d.default.locale(n, null, !0), n;
});


var $b55c0778d0239c08$exports = {};
!function(e, n) {
    $b55c0778d0239c08$exports = n();
}($b55c0778d0239c08$exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).locale("nl");
var $1b16ced07092d70b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)));


//

var $aZjGj = parcelRequire("aZjGj");
parcelRequire("4NAAR");
var $9yd0C = parcelRequire("9yd0C");
var $86cde84932c5b025$exports = {};
$86cde84932c5b025$exports = JSON.parse('{"language":{"title":"Choose your language","en":"English","nl":"Dutch","sr":"Serbian","fr":"French","de":"German","pt":"Portuguese"},"home":{"welcomeMessage":"Hello there, what brings you here today?","checkIn":"Check in","independentManualCheckIn":"No Appointment","integratedManualCheckIn":"Check in manually","checkOut":"Check out","manualCheckOut":"Check out manually","parcelDelivery":"Parcel delivery","foodDelivery":"Food delivery","callReception":"Call reception","overview":"Overview","unavailable":"The reception is currently unavailable."},"check":{"option":{"checkin":{"title":"Choose an option to check in","manual":"Check in manually","code":"Check in with PIN/QR code"},"checkout":{"title":"Choose an option to check out","manual":"Check out with name","code":"Check out with PIN/QR code"}},"title":"Waiting to scan your QR code.<br/>No QR code? No problem.","orText":"OR","qrScanner":{"checkin":{"title":"Choose an option to check in"},"checkout":{"title":"Choose an option to check out"},"btn":"Scan your QR code"},"pinCode":"Enter your PIN code","manually":{"checkin":"Don\'t have credentials?"},"status":{"idle":{"title":"Your code is scanning.","message":"Please wait..."},"loading":{"title":"Your code is scanning.","message":"Please wait..."},"error":{"title":"Your code is invalid.","message":"Please try again!"},"success":{"checkin":{"default":{"title":"You have successfully checked in.","message":"Thank you."},"MeetingAttendee":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have succesfully checked in.","message":"Your contact person is notified."},"call-ping":{"title":"You have successfully checked in.","message":"A telephone connection will now be made to your contact person."}},"Employee":{"title":"You have successfully checked in.","message":"Thank you."},"Visitor":{"title":"You have successfully checked in.","message":"Thank you."}},"checkout":{"default":{"title":"You have successfully checked out.<br/>","message":"See you again soon."},"MeetingAttendee":{"title":"You have successfully checked out.","message":"See you again soon."},"Employee":{"title":"You have successfully checked out.","message":"See you again soon."},"Visitor":{"title":"You have successfully checked out.","message":"See you again soon."}}}}},"manualCheckin":{"title":"Please fill in.","subtitle":"Note - Every field * is required to be filled in","noOption":"No option","btn":"Check in","placeholder":{"name":"Your name *","email":"Your e-mail *","phone":"Mobile number","contactName":"Your contact name *"},"error":{"required":"You didn\'t fill in this field","name":"Invalid name","email":"Invalid email address","phone":"Invalid mobile number"},"status":{"loading":{"title":"Please wait...","message":"Your contact is being notified."},"success":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have succesfully checked in.","message":"Your contact person is notified."},"call-ping":{"title":"You are successfully checked in.","message":"A telephone connection will now be made to your contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"manualCheckout":{"title":"Enter your name to checkout","btn":"Check out","form":{"placeholder":{"name":"Your full name *"},"loading":"Loading...","noOptions":"No options"},"error":{"required":"You didn\'t fill in this field","name":"Invalid name"},"status":{"loading":{"title":"We are scanning your information.","message":"Please wait..."},"success":{"title":"You have successfully checked out.","message":"Thank you and have a nice day."},"error":{"title":"An error occurred while checking out.","message":"Please try again!"}}},"call":{"title":{"no-email-sms":"Do you want to notify your contact?","email-sms":"We sent an email/sms to your contact.<br/>Do you want to notify them additionally?"},"callBtn":"Call","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Video call","noBtn":"Cancel","cancelBtn":"Cancel call","status":{"connecting":{"title":"Establishing call.<br/>Please wait...","message":""},"ringing":{"title":"Calling your contact<br/>Please wait...","message":""},"ringingReception":{"title":"Calling reception.<br/>Please wait...","message":""},"open":{"title":"Call in progress.","message":""},"close":{"title":"Call ended.<br/>Please wait for your contact.","message":""},"closeReception":{"title":"Call is ended.","message":""},"error":{"title":"Call is not established.<br/>Call again?","message":""}}},"message":{"status":{"idle":{"title":"We are notifying the contact.","message":"Please wait..."},"loading":{"title":"We are notifying the contact.","message":"Please wait..."},"success":{"title":"SMS is sent. The contact is notified.","message":"Thank you!"},"error":{"title":"SMS not sent.","message":"Please try again!"}}},"videoCall":{"title":"Video call","endCall":"END CALL","status":{"idle":{"title":"We are creating a video room.","message":"Please wait..."},"loading":{"title":"We are creating a video room.","message":"Please wait..."},"success":{"title":"The video room has been successfully created.","message":"Joining room..."},"error":{"title":"The video room was not created successfully.","message":"Please try again!"}}},"packageDelivery":{"title":"How nice of you to deliver a package!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"You can leave the package at the counter.","input":{"label":{"contact":"Who is the parcel for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact.","message":"Please wait..."},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact is notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to your contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"foodDelivery":{"title":"How nice of you to deliver food!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"You can leave the food at the counter.","input":{"label":{"contact":"Who is the food for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact.","message":"Please wait!"},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact is notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to your contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"QRCodeScanner":{"title":"Please scan your QR code","subtitle":"Line up the QR code inside the red corners and keep your phone steady."},"common":{"backBtn":"Back"},"previewPDF":{"page":{"of":"of","previous":"Previous","next":"Next"},"button":{"cancel":"Cancel","accept":"Accept","next":"Next"},"title":{"consent":"Consent required"}},"offline":{"title":"Offline","receptionMessage":"The reception is offline at the moment and can not be used, the internet connection must be checked!","check":"Are you a visitor and do you want to speak to an employee directly? Please call {{receptionistPhone}}"},"overview":{"title":"Enter the code to open the overview!","noUsers":"No users","status":{"success":{"title":"The code is valid.","message":""},"error":{"title":"The code isn\'t valid.","message":"Please try again!"}},"checkoutStatus":{"loading":{"title":"Please wait...","message":""},"success":{"title":"Successful check out.","message":""},"error":{"title":"Something went wrong.","message":"Please try again!"}},"listTitle":"List of persons who checked in today but didn\'t check out","page":"Page ","table":{"head":{"fullName":"Name","type":"Type","checkedinAt":"Checked in at","host":"Host"},"type":{"Package":"Package delivery","Food":"Food delivery","Visitor":"Visitor","MeetingAttendee":"Invited visitor","Employee":"Employee","Guest":"Guest"}},"confirmModal":{"title":"Are you sure you want to check out {{fullName}}?","cancel":"Cancel","checkout":"Check out"}},"wifi":{"title":"Connect to the Wi-Fi network"}}');


var $e426d47f6742296e$exports = {};
$e426d47f6742296e$exports = JSON.parse('{"language":{"title":"Kies uw taal","en":"Engels","nl":"Nederlands","sr":"Servisch","fr":"Frans","de":"Duits","pt":"Portugees"},"home":{"welcomeMessage":"Hi! Waar kan ik u mee helpen?","checkIn":"Check in","independentManualCheckIn":"Geen afspraak","integratedManualCheckIn":"Handmatig inchecken","checkOut":"Check uit","manualCheckOut":"Handmatig uitchecken","parcelDelivery":"Pakketbezorging","foodDelivery":"Maaltijdbezorging","callReception":"Receptie bellen","overview":"Overzicht","unavailable":"De receptie is momenteel niet beschikbaar."},"check":{"option":{"checkin":{"title":"Selecteer een optie om in te checken","manual":"Check handmatig in","code":"Check in met uw QR of PIN code"},"checkout":{"title":"Selecteer een optie om uit te checken","manual":"Check uit met uw naam","code":"Check uit met uw QR of PIN code"}},"title":"Wachten om uw QR-code te scannen.<br/>Geen QR-code? Geen probleem.","orText":"OF","qrScanner":{"checkin":{"title":"Kies een optie om in te checken"},"checkout":{"title":"Kies een optie om uit te checken"},"btn":"Scan uw QR code"},"pinCode":"Voer uw pincode in","manually":{"checkin":"Heeft u geen inloggegevens? <0>Handmatig inchecken</0>"},"status":{"idle":{"title":"Even geduld...","message":"Uw code wordt gescand."},"loading":{"title":"Even geduld...","message":"Uw code wordt gescand."},"error":{"title":"Probeer het opnieuw!","message":"Uw code is ongeldig."},"success":{"checkin":{"default":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"MeetingAttendee":{"no-email-sms":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"email-sms":{"title":"Bedankt voor het inchecken!","message":"Uw contactpersoon is op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."}},"Employee":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"Visitor":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"}},"checkout":{"default":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"Employee":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"MeetingAttendee":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"Visitor":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"}}}}},"manualCheckin":{"title":"Vul de gegevens hieronder in.","subtitle":"Elk veld * moet worden ingevuld","noOption":"Geen optie","btn":"Check in","placeholder":{"name":"Uw naam *","email":"Uw e-mail *","phone":"Uw telefoonnummer","contactName":"De naam van uw contact *"},"error":{"required":"U heeft dit veld niet ingevuld","name":"Ongeldige naam","email":"Ongeldig e-mailadres","phone":"Ongeldig telefoonnummer"},"status":{"loading":{"title":"Even geduld...","message":"Uw contactpersoon wordt op de hoogte gebracht."},"success":{"no-email-sms":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"email-sms":{"title":"Bedankt voor het inchecken!","message":"Uw contactpersoon is op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu een telefonische verbinding gemaakt met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}}},"manualCheckout":{"title":"Voer uw naam in om uit te checken","btn":"Check uit","form":{"placeholder":{"name":"Uw volledige naam*"},"loading":"Laden...","noOptions":"Geen opties "},"error":{"required":"Je hebt dit veld niet ingevuld","name":"Ongeldige naam"},"status":{"loading":{"title":"We scannen uw informatie...","message":""},"success":{"title":"Bedankt voor het uitchecken!","message":"Fijne dag!"},"error":{"title":"Er heeft zich een probleem voorgedaan tijdens het uitchecken.","message":"Probeer het opnieuw."}}},"call":{"title":{"no-email-sms":"Wilt u uw contactpersoon informeren?","email-sms":"We hebben een notificatie naar uw contactpersoon verstuurd.<br/>Wilt u een telefonische verbinding maken?"},"callBtn":"Bellen","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videogesprek","noBtn":"Terug","cancelBtn":"Gesprek stoppen","status":{"connecting":{"title":"Gesprek initi\xebren","message":"Even geduld."},"ringing":{"title":"Er wordt verbinding gemaakt.<br/>Even geduld...","message":""},"ringingReception":{"title":"Receptie bellen.<br/>Even geduld...","message":""},"open":{"title":"Gesprek bezig.","message":""},"close":{"title":"Gesprek afgelopen.<br/>E\xe9n moment geduld astublieft. Uw contactpersoon is onderweg.","message":""},"closeReception":{"title":"Gesprek is afgelopen.","message":""},"error":{"title":"Error!<br/>Er ging iets verkeerd.","message":""}}},"message":{"status":{"idle":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"loading":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"success":{"title":"De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"Bedankt!"},"error":{"title":"SMS niet verzonden.","message":"Probeer het opnieuw!"}}},"videoCall":{"title":"Videogesprek","endCall":"EINDE GESPREK","status":{"idle":{"title":"We zijn een video room aan het cre\xebren.","message":"Een moment geduld alstublieft..."},"loading":{"title":"We zijn een video room aan het cre\xebren.","message":"Een moment geduld alstublieft..."},"success":{"title":"De video room is succesvol aangemaakt.","message":"We gaan de room binnen..."},"error":{"title":"De video room kon niet succesvol worden aangemaakt.","message":"Probeer het alstublieft opnieuw!"}}},"packageDelivery":{"title":"Wat fijn dat u een pakket komt bezorgen!","subtitle":"Selecteer en breng de ontvanger op de hoogte","subtitle1":"Klik op onderstaande knop zodat we weten dat u er bent!","subtitle2":"U kunt het pakket bij de balie achterlaten.","input":{"label":{"contact":"Voor wie is het pakket?"},"error":{"contact":{"required":"U heeft dit veld niet ingevuld"}}},"button":{"submit":"Breng op de hoogte"},"status":{"loading":{"title":"De ontvanger wordt op de hoogte gebracht.","message":"Even geduld."},"success":{"no-email-sms":{"title":"Bedankt voor het bezorgen!","message":""},"email-sms":{"title":"Bedankt voor het bezorgen!","message":"De ontvanger wordt op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu  telefonisch verbinding gemaakt met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}}},"foodDelivery":{"title":"Wat fijn dat u eten komt bezorgen!","subtitle":"Selecteer en breng de ontvanger op de hoogte","subtitle1":"Klik op onderstaande knop zodat we weten dat u er bent!","subtitle2":"U kunt het eten bij de balie achterlaten.","input":{"label":{"contact":"Voor wie is het eten?"},"error":{"contact":{"required":"U heeft dit veld niet ingevuld"}}},"button":{"submit":"Breng op de hoogte"},"status":{"loading":{"title":"De ontvanger wordt op de hoogte gebracht.","message":"Even geduld."},"success":{"no-email-sms":{"title":"Bedankt voor het bezorgen!","message":""},"email-sms":{"title":"Bedankt voor het bezorgen!","message":"De ontvanger wordt op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}}},"QRCodeScanner":{"title":"Scan uw QR-code","subtitle":"Plaats de QR-code in de rode hoeken en houd uw telefoon stil."},"common":{"backBtn":"Terug"},"previewPDF":{"page":{"previous":"Vorige pagina","next":"Volgende pagina","of":"van"},"button":{"cancel":"Annuleren","accept":"Accepteren","next":"Volgende"},"title":{"consent":"Toestemming vereist"}},"offline":{"title":"Offline","receptionMessage":"De receptie is momenteel offline en kan niet worden gebruikt, de internetverbinding moet worden gecontroleerd!","check":"Bent u een bezoeker en wilt u direct met een medewerker spreken? Bel dan {{receptionistPhone}}"},"overview":{"title":"Voer de code in om het overzicht te openen!","noUsers":"Geen gebruikers","status":{"success":{"title":"De code is geldig.","message":""},"error":{"title":"De code is niet geldig.","message":"Probeer het opnieuw!"}},"checkoutStatus":{"loading":{"title":"Even geduld...","message":""},"success":{"title":"Succesvol uitgecheckt!","message":""},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}},"listTitle":"Lijst van personen die vandaag zijn ingecheckt maar nog niet zijn uitgecheckt","page":"Pagina ","table":{"head":{"fullName":"Naam","type":"Type","checkedinAt":"Ingecheckt op","host":"Gastheer"},"type":{"Package":"Pakketbezorging","Food":"Maaltijdbezorging","Visitor":"Bezoeker","MeetingAttendee":"Uitgenodigde bezoeker","Employee":"Medewerker","Guest":"Gast"}},"confirmModal":{"title":"Weet u zeker dat u {{fullName}} wilt uitchecken?","cancel":"Annuleren","checkout":"Uitchecken"}},"wifi":{"title":"Verbind met het wifi-netwerk"}}');


var $a18874184f267ca0$exports = {};
$a18874184f267ca0$exports = JSON.parse('{"language":{"title":"Izaberite jezik","en":"Engleski","nl":"Holandski","sr":"Srpski","fr":"Francuski","de":"Nema\u010Dki","pt":"Portugalski"},"home":{"welcomeMessage":"Zdravo, \u0161ta vas danas dovodi ovde?","checkIn":"Prijava","independentManualCheckIn":"Bez sastanka","integratedManualCheckIn":"Prijavite se ru\u010Dno","checkOut":"Odjava","manualCheckOut":"Odjavite se ru\u010Dno","parcelDelivery":"Dostava paketa","foodDelivery":"Dostava hrane","callReception":"Pozovi recepciju","overview":"Pregled","unavailable":"Recepcija trenutno nije dostupna."},"check":{"option":{"checkin":{"title":"Izaberite opciju za prijavu","manual":"Prijavite se ru\u010Dno","code":"Prijavite se pomo\u0107u PIN/QR koda"},"checkout":{"title":"Izaberite opciju za odjavu","manual":"Odjavite se po imenu","code":"Odjavite se pomo\u0107u PIN/QR koda"}},"title":"\u010Cekamo da skenirate va\u0161 QR kod.<br/>Nemate QR kod? Nema problema.","orText":"ILI","qrScanner":{"checkin":{"title":"Izaberite opciju za prijavu"},"checkout":{"title":"Izaberite opciju za odjavu"},"btn":"Skenirajte va\u0161 QR kod"},"pinCode":"Unesite va\u0161 PIN kod","manually":{"checkin":"Nemate podatke za prijavu?"},"status":{"idle":{"title":"Va\u0161 kod se skenira.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Va\u0161 kod se skenira.","message":"Molimo sa\u010Dekajte..."},"error":{"title":"Va\u0161 kod nije va\u017Ee\u0107i.","message":"Poku\u0161ajte ponovo!"},"success":{"checkin":{"default":{"title":"Uspe\u0161no ste prijavljeni.","message":"Hvala vam."},"MeetingAttendee":{"no-email-sms":{"title":"Uspe\u0161no ste prijavljeni.","message":"Hvala vam."},"email-sms":{"title":"Uspe\u0161no ste prijavljeni.","message":"Va\u0161 kontakt je obave\u0161ten."},"call-ping":{"title":"Uspe\u0161no ste prijavljeni.","message":"Sada \u0107e biti uspostavljena telefonska veza sa va\u0161im kontaktom."}},"Employee":{"title":"Uspe\u0161no ste prijavljeni.","message":"Hvala vam."},"Visitor":{"title":"Uspe\u0161no ste prijavljeni.","message":"Hvala vam."}},"checkout":{"default":{"title":"Uspe\u0161no ste odjavljeni.<br/>","message":"Vidimo se uskoro."},"MeetingAttendee":{"title":"Uspe\u0161no ste odjavljeni.","message":"Vidimo se uskoro."},"Employee":{"title":"Uspe\u0161no ste odjavljeni.","message":"Vidimo se uskoro."},"Visitor":{"title":"Uspe\u0161no ste odjavljeni.","message":"Vidimo se uskoro."}}}}},"manualCheckin":{"title":"Molimo popunite.","subtitle":"Napomena - Svako polje * je obavezno","noOption":"Nema opcije","btn":"Prijavite se","placeholder":{"name":"Va\u0161e ime *","email":"Va\u0161 e-mail *","phone":"Broj mobilnog telefona","contactName":"Ime va\u0161eg kontakta *"},"error":{"required":"Niste popunili ovo polje","name":"Neva\u017Ee\u0107e ime","email":"Neva\u017Ee\u0107a e-mail adresa","phone":"Neva\u017Ee\u0107i broj mobilnog telefona"},"status":{"loading":{"title":"Molimo sa\u010Dekajte...","message":"Va\u0161 kontakt se obave\u0161tava."},"success":{"no-email-sms":{"title":"Uspe\u0161no ste prijavljeni.","message":"Hvala vam."},"email-sms":{"title":"Uspe\u0161no ste prijavljeni.","message":"Va\u0161 kontakt je obave\u0161ten."},"call-ping":{"title":"Uspe\u0161no ste prijavljeni.","message":"Sada \u0107e biti uspostavljena telefonska veza sa va\u0161im kontaktom."}},"error":{"title":"Do\u0161lo je do gre\u0161ke.","message":"Poku\u0161ajte ponovo!"}}},"manualCheckout":{"title":"Unesite svoje ime za odjavu","btn":"Odjavite se","form":{"placeholder":{"name":"Va\u0161e puno ime *"},"loading":"U\u010Ditavanje...","noOptions":"Nema opcija"},"error":{"required":"Niste popunili ovo polje","name":"Neva\u017Ee\u0107e ime"},"status":{"loading":{"title":"Skeniramo va\u0161e podatke.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"Uspe\u0161no ste odjavljeni.","message":"Hvala vam i prijatan dan."},"error":{"title":"Do\u0161lo je do gre\u0161ke prilikom odjavljivanja.","message":"Poku\u0161ajte ponovo!"}}},"call":{"title":{"no-email-sms":"Da li \u017Eelite da obavestite svoj kontakt?","email-sms":"Poslali smo e-mail/sms va\u0161em kontaktu.<br/>\u017Delite li dodatno da ih obavestite?"},"callBtn":"Pozovi","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Video poziv","noBtn":"Otka\u017Ei","cancelBtn":"Otka\u017Ei poziv","status":{"connecting":{"title":"Uspostavljanje poziva.<br/>Molimo sa\u010Dekajte...","message":""},"ringing":{"title":"Pozivanje va\u0161eg kontakta<br/>Molimo sa\u010Dekajte...","message":""},"ringingReception":{"title":"Pozivanje recepcije.<br/>Molimo sa\u010Dekajte...","message":""},"open":{"title":"Poziv je u toku.","message":""},"close":{"title":"Poziv je zavr\u0161en.<br/>Molimo sa\u010Dekajte svog kontakta.","message":""},"closeReception":{"title":"Poziv je zavr\u0161en.","message":""},"error":{"title":"Poziv nije uspostavljen.<br/>Ponovo pozvati?","message":""}}},"message":{"status":{"idle":{"title":"Obave\u0161tavamo kontakt.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Obave\u0161tavamo kontakt.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"SMS je poslat. Kontakt je obave\u0161ten.","message":"Hvala vam!"},"error":{"title":"SMS nije poslat.","message":"Poku\u0161ajte ponovo!"}}},"videoCall":{"title":"Video poziv","endCall":"KRAJ POZIVA","status":{"idle":{"title":"Kreiramo video sobu.","message":"Molimo vas, sa\u010Dekajte..."},"loading":{"title":"Kreiramo video sobu.","message":"Molimo vas, sa\u010Dekajte..."},"success":{"title":"Video soba je uspe\u0161no kreirana.","message":"Ulazimo u sobu..."},"error":{"title":"Video soba nije uspe\u0161no kreirana.","message":"Molimo poku\u0161ajte ponovo!"}}},"packageDelivery":{"title":"Kako je lepo \u0161to dostavljate paket!","subtitle":"Odaberite primaoca i obavestite ga","subtitle1":"Pritisnite dugme ispod da nas obavestite da ste ovde!","subtitle2":"Paket mo\u017Eete ostaviti na recepciji.","input":{"label":{"contact":"Za koga je paket"},"error":{"contact":{"required":"Niste popunili ovo polje"}}},"button":{"submit":"Obavesti"},"status":{"loading":{"title":"Obave\u0161tavamo kontakt.","message":"Molimo sa\u010Dekajte..."},"success":{"no-email-sms":{"title":"Hvala vam na isporuci!","message":""},"email-sms":{"title":"Kontakt je obave\u0161ten.","message":"Hvala vam na isporuci!"},"call-ping":{"title":"Hvala vam na isporuci!","message":"Sada \u0107e biti uspostavljena telefonska veza sa va\u0161im kontaktom."}},"error":{"title":"Do\u0161lo je do gre\u0161ke.","message":"Poku\u0161ajte ponovo!"}}},"foodDelivery":{"title":"Kako je lepo \u0161to dostavljate hranu!","subtitle":"Odaberite primaoca i obavestite ga","subtitle1":"Pritisnite dugme ispod da nas obavestite da ste ovde!","subtitle2":"Hranu mo\u017Eete ostaviti na recepciji.","input":{"label":{"contact":"Za koga je hrana"},"error":{"contact":{"required":"Niste popunili ovo polje"}}},"button":{"submit":"Obavesti"},"status":{"loading":{"title":"Obave\u0161tavamo kontakt.","message":"Molimo sa\u010Dekajte!"},"success":{"no-email-sms":{"title":"Hvala vam na isporuci!","message":""},"email-sms":{"title":"Kontakt je obave\u0161ten.","message":"Hvala vam na isporuci!"},"call-ping":{"title":"Hvala vam na isporuci!","message":"Sada \u0107e biti uspostavljena telefonska veza sa va\u0161im kontaktom."}},"error":{"title":"Do\u0161lo je do gre\u0161ke.","message":"Poku\u0161ajte ponovo!"}}},"QRCodeScanner":{"title":"Molimo skenirajte va\u0161 QR kod","subtitle":"Poravnajte QR kod unutar crvenih uglova i dr\u017Eite telefon mirno."},"common":{"backBtn":"Nazad"},"previewPDF":{"page":{"of":"od","previous":"Prethodna","next":"Slede\u0107a"},"button":{"cancel":"Otka\u017Ei","accept":"Prihvati","next":"Dalje"},"title":{"consent":"Potrebna je saglasnost"}},"offline":{"title":"Van mre\u017Ee","receptionMessage":"Recepcija je trenutno van mre\u017Ee i ne mo\u017Ee se koristiti, potrebno je proveriti internet vezu!","check":"Da li ste posetilac i \u017Eelite li direktno da razgovarate sa zaposlenim? Pozovite {{receptionistPhone}}"},"overview":{"title":"Unesite kod da otvorite pregled!","noUsers":"Nema korisnika","status":{"success":{"title":"Kod je va\u017Ee\u0107i.","message":""},"error":{"title":"Kod nije va\u017Ee\u0107i.","message":"Poku\u0161ajte ponovo!"}},"checkoutStatus":{"loading":{"title":"Molimo sa\u010Dekajte...","message":""},"success":{"title":"Uspe\u0161no odjavljen.","message":""},"error":{"title":"Do\u0161lo je do gre\u0161ke.","message":"Poku\u0161ajte ponovo!"}},"listTitle":"Lista osoba koje su danas prijavljene, ali nisu odjavljene","page":"Strana ","table":{"head":{"fullName":"Ime","type":"Tip","checkedinAt":"Prijavljen u","host":"Doma\u0107in"},"type":{"Package":"Dostava paketa","Food":"Dostava hrane","Visitor":"Posetilac","MeetingAttendee":"Pozvani posetilac","Employee":"Zaposleni","Guest":"Gost"}},"confirmModal":{"title":"Da li ste sigurni da \u017Eelite da odjavite {{fullName}}?","cancel":"Otka\u017Ei","checkout":"Odjavi"}},"wifi":{"title":"Pove\u017Eite se na Wi-Fi mre\u017Eu"}}');


var $4ef112052723529f$exports = {};
$4ef112052723529f$exports = JSON.parse('{"language":{"title":"Choisissez votre langue","en":"Anglais","nl":"N\xe9erlandais","sr":"Serbe","fr":"Fran\xe7ais","de":"Allemand","pt":"Portugais"},"home":{"welcomeMessage":"Bonjour, que venez-vous faire aujourd\'hui?","checkIn":"Enregistrement","independentManualCheckIn":"Pas de rendez-vous","integratedManualCheckIn":"Enregistrement manuel","checkOut":"D\xe9part","manualCheckOut":"D\xe9part manuel","parcelDelivery":"Livraison de colis","foodDelivery":"Livraison de nourriture","callReception":"Appeler la r\xe9ception","overview":"Aper\xe7u","unavailable":"La r\xe9ception est actuellement indisponible."},"check":{"option":{"checkin":{"title":"Choisissez une option pour vous enregistrer","manual":"Enregistrement manuel","code":"Enregistrement avec code PIN/QR"},"checkout":{"title":"Choisissez une option pour partir","manual":"D\xe9part avec nom","code":"D\xe9part avec code PIN/QR"}},"title":"En attente de scanner votre code QR.<br/>Pas de code QR? Pas de probl\xe8me.","orText":"OU","qrScanner":{"checkin":{"title":"Choisissez une option pour vous enregistrer"},"checkout":{"title":"Choisissez une option pour partir"},"btn":"Scannez votre code QR"},"pinCode":"Entrez votre code PIN","manually":{"checkin":"Pas d\'identifiants?"},"status":{"idle":{"title":"Votre code est en cours de scan.","message":"Veuillez patienter..."},"loading":{"title":"Votre code est en cours de scan.","message":"Veuillez patienter..."},"error":{"title":"Votre code est invalide.","message":"Veuillez r\xe9essayer!"},"success":{"checkin":{"default":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"MeetingAttendee":{"no-email-sms":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"email-sms":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Votre contact a \xe9t\xe9 notifi\xe9."},"call-ping":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Une connexion t\xe9l\xe9phonique est \xe9tablie avec votre contact."}},"Employee":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"Visitor":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."}},"checkout":{"default":{"title":"Vous \xeates parti avec succ\xe8s.<br/>","message":"\xc0 bient\xf4t."},"MeetingAttendee":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."},"Employee":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."},"Visitor":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."}}}}},"manualCheckin":{"title":"Veuillez remplir.","subtitle":"Remarque - Tous les champs marqu\xe9s d\'un * doivent \xeatre remplis","noOption":"Aucune option","btn":"Enregistrement","placeholder":{"name":"Votre nom *","email":"Votre e-mail *","phone":"Num\xe9ro de mobile","contactName":"Nom de votre contact *"},"error":{"required":"Vous n\'avez pas rempli ce champ","name":"Nom invalide","email":"Adresse e-mail invalide","phone":"Num\xe9ro de mobile invalide"},"status":{"loading":{"title":"Veuillez patienter...","message":"Votre contact est en cours de notification."},"success":{"no-email-sms":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"email-sms":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Votre contact a \xe9t\xe9 notifi\xe9."},"call-ping":{"title":"Vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Une connexion t\xe9l\xe9phonique est \xe9tablie avec votre contact."}},"error":{"title":"Une erreur s\'est produite.","message":"Veuillez r\xe9essayer!"}}},"manualCheckout":{"title":"Entrez votre nom pour partir","btn":"D\xe9part","form":{"placeholder":{"name":"Votre nom complet *"},"loading":"Chargement...","noOptions":"Aucune option"},"error":{"required":"Vous n\'avez pas rempli ce champ","name":"Nom invalide"},"status":{"loading":{"title":"Nous scannons vos informations.","message":"Veuillez patienter..."},"success":{"title":"Vous \xeates parti avec succ\xe8s.","message":"Merci et bonne journ\xe9e."},"error":{"title":"Une erreur est survenue lors du d\xe9part.","message":"Veuillez r\xe9essayer!"}}},"call":{"title":{"no-email-sms":"Voulez-vous notifier votre contact?","email-sms":"Nous avons envoy\xe9 un e-mail/SMS \xe0 votre contact.<br/>Voulez-vous les notifier en plus?"},"callBtn":"Appel","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Appel vid\xe9o","noBtn":"Annuler","cancelBtn":"Annuler l\'appel","status":{"connecting":{"title":"\xc9tablissement de la connexion.<br/>Veuillez patienter...","message":""},"ringing":{"title":"Appel en cours<br/>Veuillez patienter...","message":""},"ringingReception":{"title":"Appel en cours avec la r\xe9ception.<br/>Veuillez patienter...","message":""},"open":{"title":"Appel en cours.","message":""},"close":{"title":"Appel termin\xe9.<br/>Veuillez attendre votre contact.","message":""},"closeReception":{"title":"Appel termin\xe9.","message":""},"error":{"title":"\xc9chec de l\'appel.<br/>Ressayer?","message":""}}},"message":{"status":{"idle":{"title":"Nous notifiions le contact.","message":"Veuillez patienter..."},"loading":{"title":"Nous notifiions le contact.","message":"Veuillez patienter..."},"success":{"title":"SMS envoy\xe9. Le contact est notifi\xe9.","message":"Merci!"},"error":{"title":"SMS non envoy\xe9.","message":"Veuillez r\xe9essayer!"}}},"videoCall":{"title":"Appel vid\xe9o","endCall":"TERMINER L\'APPEL","status":{"idle":{"title":"Nous cr\xe9ons une salle vid\xe9o.","message":"Veuillez patienter..."},"loading":{"title":"Nous cr\xe9ons une salle vid\xe9o.","message":"Veuillez patienter..."},"success":{"title":"La salle vid\xe9o a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.","message":"Entr\xe9e dans la salle..."},"error":{"title":"La salle vid\xe9o n\'a pas pu \xeatre cr\xe9\xe9e avec succ\xe8s.","message":"Veuillez r\xe9essayer !"}}},"packageDelivery":{"title":"C\'est gentil de votre part de livrer un colis !","subtitle":"S\xe9lectionnez et informez le destinataire","subtitle1":"Appuyez sur le bouton ci-dessous pour nous faire savoir que vous \xeates ici !","subtitle2":"Vous pouvez laisser le colis au comptoir.","input":{"label":{"contact":"Pour qui est le colis"},"error":{"contact":{"required":"Vous n\'avez pas rempli ce champ"}}},"button":{"submit":"Notifier"},"status":{"loading":{"title":"Nous informons le contact.<br/>Veuillez patienter...","message":""},"success":{"no-email-sms":{"title":"Merci pour votre livraison !","message":""},"email-sms":{"title":"Le contact a \xe9t\xe9 inform\xe9.<br/>Merci pour votre livraison !","message":""},"call-ping":{"title":"Merci pour votre livraison !","message":"Une connexion t\xe9l\xe9phonique va maintenant \xeatre \xe9tablie avec votre personne de contact."}},"error":{"title":"Une erreur s\'est produite.<br/>Veuillez r\xe9essayer !","message":""}}},"foodDelivery":{"title":"Quelle gentillesse de votre part de livrer de la nourriture !","subtitle":"S\xe9lectionnez et informez le destinataire","subtitle1":"Appuyez sur le bouton ci-dessous pour nous faire savoir que vous \xeates ici !","subtitle2":"Vous pouvez laisser la nourriture au comptoir.","input":{"label":{"contact":"Pour qui est la nourriture"},"error":{"contact":{"required":"Vous n\'avez pas rempli ce champ"}}},"button":{"submit":"Notifier"},"status":{"loading":{"title":"Nous informons le contact.<br/>Veuillez patienter !","message":""},"success":{"no-email-sms":{"title":"Merci pour votre livraison !","message":""},"email-sms":{"title":"Le contact a \xe9t\xe9 inform\xe9.<br/>Merci pour votre livraison !","message":""},"call-ping":{"title":"Merci pour votre livraison !","message":"Une connexion t\xe9l\xe9phonique va maintenant \xeatre \xe9tablie avec votre personne de contact."}},"error":{"title":"Une erreur s\'est produite.<br/>Veuillez r\xe9essayer !","message":""}}},"QRCodeScanner":{"title":"Veuillez scanner votre code QR","subtitle":"Alignez le code QR \xe0 l\'int\xe9rieur des coins rouges et gardez votre t\xe9l\xe9phone stable."},"common":{"backBtn":"Retour"},"previewPDF":{"page":{"of":"de","previous":"Pr\xe9c\xe9dent","next":"Suivant"},"button":{"cancel":"Annuler","accept":"Accepter","next":"Suivant"},"title":{"consent":"Consentement requis"}},"offline":{"title":"Hors ligne","receptionMessage":"La r\xe9ception est hors ligne pour le moment et ne peut pas \xeatre utilis\xe9e, veuillez v\xe9rifier la connexion Internet !","check":"\xcates-vous un visiteur et souhaitez-vous parler directement \xe0 un employ\xe9 ? Veuillez appeler {{receptionistPhone}}"},"overview":{"title":"Entrez le code pour ouvrir l\'aper\xe7u !","noUsers":"Aucun utilisateur","status":{"success":{"title":"Le code est valide.","message":""},"error":{"title":"Le code n\'est pas valide.<br/>Veuillez r\xe9essayer !","message":""}},"checkoutStatus":{"loading":{"title":"S\'il vous pla\xeet, attendez...","message":""},"success":{"title":"Paiement r\xe9ussi.","message":""},"error":{"title":"Quelque chose s\'est mal pass\xe9.<br/>Veuillez r\xe9essayer!","message":""}},"listTitle":"Liste des personnes qui se sont enregistr\xe9es aujourd\'hui mais n\'ont pas effectu\xe9 leur d\xe9part.","page":"Page ","table":{"head":{"fullName":"Nom","type":"Type","checkedinAt":"Enregistr\xe9 \xe0","host":"H\xf4te"},"type":{"Package":"Livraison de colis","Food":"Livraison de nourriture","Visitor":"Visiteur","MeetingAttendee":"Participant \xe0 une r\xe9union","Employee":"Employ\xe9","Guest":"Invit\xe9"}},"confirmModal":{"title":"\xcates-vous s\xfbr de vouloir proc\xe9der au d\xe9part de {{fullName}}?","cancel":"Annuler","checkout":"D\xe9part"}},"wifi":{"title":"Connectez-vous au r\xe9seau Wi-Fi"}}');


var $002a7e1c39b40840$exports = {};
$002a7e1c39b40840$exports = JSON.parse('{"language":{"title":"W\xe4hlen Sie Ihre Sprache","en":"Englisch","nl":"Niederl\xe4ndisch","sr":"Serbisch","fr":"Franz\xf6sisch","de":"Deutsch","pt":"Portugiesisch"},"home":{"welcomeMessage":"Hallo, was f\xfchrt Sie heute hierher?","checkIn":"Einchecken","independentManualCheckIn":"Kein Termin","integratedManualCheckIn":"Manuell einchecken","checkOut":"Auschecken","manualCheckOut":"Manuell auschecken","parcelDelivery":"Paketlieferung","foodDelivery":"Essenslieferung","callReception":"Rezeption anrufen","overview":"\xdcbersicht","unavailable":"Die Rezeption ist derzeit nicht verf\xfcgbar."},"check":{"option":{"checkin":{"title":"W\xe4hlen Sie eine Option zum Einchecken","manual":"Manuell einchecken","code":"Mit PIN/QR-Code einchecken"},"checkout":{"title":"W\xe4hlen Sie eine Option zum Auschecken","manual":"Mit Namen auschecken","code":"Mit PIN/QR-Code auschecken"}},"title":"Warten auf das Scannen Ihres QR-Codes.<br/>Kein QR-Code? Kein Problem.","orText":"ODER","qrScanner":{"checkin":{"title":"W\xe4hlen Sie eine Option zum Einchecken"},"checkout":{"title":"W\xe4hlen Sie eine Option zum Auschecken"},"btn":"Scannen Sie Ihren QR-Code"},"pinCode":"Geben Sie Ihren PIN-Code ein","manually":{"checkin":"Keine Anmeldedaten?"},"status":{"idle":{"title":"Ihr Code wird gescannt.","message":"Bitte warten..."},"loading":{"title":"Ihr Code wird gescannt.","message":"Bitte warten..."},"error":{"title":"Ihr Code ist ung\xfcltig.","message":"Bitte versuchen Sie es erneut!"},"success":{"checkin":{"default":{"title":"Sie haben erfolgreich eingecheckt.","message":"Danke."},"MeetingAttendee":{"no-email-sms":{"title":"Sie haben erfolgreich eingecheckt.","message":"Danke."},"email-sms":{"title":"Sie haben erfolgreich eingecheckt.","message":"Ihr Ansprechpartner wurde benachrichtigt."},"call-ping":{"title":"Sie haben erfolgreich eingecheckt.","message":"Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."}},"Employee":{"title":"Sie haben erfolgreich eingecheckt.","message":"Danke."},"Visitor":{"title":"Sie haben erfolgreich eingecheckt.","message":"Danke."}},"checkout":{"default":{"title":"Sie haben erfolgreich ausgecheckt.<br/>","message":"Bis bald."},"MeetingAttendee":{"title":"Sie haben erfolgreich ausgecheckt.","message":"Bis bald."},"Employee":{"title":"Sie haben erfolgreich ausgecheckt.","message":"Bis bald."},"Visitor":{"title":"Sie haben erfolgreich ausgecheckt.","message":"Bis bald."}}}}},"manualCheckin":{"title":"Bitte f\xfcllen Sie das Formular aus.","subtitle":"Hinweis - Alle Felder * m\xfcssen ausgef\xfcllt werden","noOption":"Keine Option","btn":"Einchecken","placeholder":{"name":"Ihr Name *","email":"Ihre E-Mail *","phone":"Handynummer","contactName":"Name Ihres Ansprechpartners *"},"error":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt","name":"Ung\xfcltiger Name","email":"Ung\xfcltige E-Mail-Adresse","phone":"Ung\xfcltige Handynummer"},"status":{"loading":{"title":"Bitte warten...","message":"Ihr Ansprechpartner wird benachrichtigt."},"success":{"no-email-sms":{"title":"Sie haben erfolgreich eingecheckt.","message":"Danke."},"email-sms":{"title":"Sie haben erfolgreich eingecheckt.","message":"Ihr Ansprechpartner wurde benachrichtigt."},"call-ping":{"title":"Sie haben erfolgreich eingecheckt.","message":"Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."}},"error":{"title":"Ein Fehler ist aufgetreten.","message":"Bitte versuchen Sie es erneut!"}}},"manualCheckout":{"title":"Geben Sie Ihren Namen ein, um auszuchecken","btn":"Auschecken","form":{"placeholder":{"name":"Ihr vollst\xe4ndiger Name *"},"loading":"Laden...","noOptions":"Keine Optionen"},"error":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt","name":"Ung\xfcltiger Name"},"status":{"loading":{"title":"Wir scannen Ihre Informationen.","message":"Bitte warten..."},"success":{"title":"Sie haben erfolgreich ausgecheckt.","message":"Vielen Dank und einen sch\xf6nen Tag."},"error":{"title":"Beim Auschecken ist ein Fehler aufgetreten.","message":"Bitte versuchen Sie es erneut!"}}},"call":{"title":{"no-email-sms":"M\xf6chten Sie Ihren Ansprechpartner benachrichtigen?","email-sms":"Wir haben Ihrem Ansprechpartner eine E-Mail/SMS gesendet.<br/>M\xf6chten Sie ihn zus\xe4tzlich benachrichtigen?"},"callBtn":"Anrufen","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videoanruf","noBtn":"Abbrechen","cancelBtn":"Anruf abbrechen","status":{"connecting":{"title":"Anruf wird hergestellt.<br/>Bitte warten...","message":""},"ringing":{"title":"Ihr Ansprechpartner wird angerufen<br/>Bitte warten...","message":""},"ringingReception":{"title":"Rezeption wird angerufen.<br/>Bitte warten...","message":""},"open":{"title":"Anruf l\xe4uft.","message":""},"close":{"title":"Anruf beendet.<br/>Bitte warten Sie auf Ihren Ansprechpartner.","message":""},"closeReception":{"title":"Anruf ist beendet.","message":""},"error":{"title":"Anruf nicht hergestellt.<br/>Nochmals anrufen?","message":""}}},"message":{"status":{"idle":{"title":"Wir benachrichtigen den Kontakt.","message":"Bitte warten..."},"loading":{"title":"Wir benachrichtigen den Kontakt.","message":"Bitte warten..."},"success":{"title":"SMS wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Vielen Dank!"},"error":{"title":"SMS wurde nicht gesendet.","message":"Bitte versuchen Sie es erneut!"}}},"videoCall":{"title":"Videoanruf","endCall":"ANRUF BEENDEN","status":{"idle":{"title":"Wir erstellen einen Video-Raum.","message":"Bitte warten..."},"loading":{"title":"Wir erstellen einen Video-Raum.","message":"Bitte warten..."},"success":{"title":"Der Video-Raum wurde erfolgreich erstellt.","message":"Betrete den Raum..."},"error":{"title":"Der Video-Raum konnte nicht erfolgreich erstellt werden.","message":"Bitte versuchen Sie es erneut!"}}},"packageDelivery":{"title":"Wie sch\xf6n, dass Sie ein Paket liefern!","subtitle":"W\xe4hlen Sie den Empf\xe4nger und benachrichtigen Sie ihn","subtitle1":"Dr\xfccken Sie den unten stehenden Knopf, um uns mitzuteilen, dass Sie hier sind!","subtitle2":"Sie k\xf6nnen das Paket am Empfang abgeben.","input":{"label":{"contact":"F\xfcr wen ist das Paket"},"error":{"contact":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt"}}},"button":{"submit":"Benachrichtigen"},"status":{"loading":{"title":"Wir benachrichtigen den Kontakt.","message":"Bitte warten..."},"success":{"no-email-sms":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":""},"email-sms":{"title":"Der Kontakt wurde benachrichtigt.","message":"Vielen Dank f\xfcr Ihre Lieferung!"},"call-ping":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."}},"error":{"title":"Etwas ist schief gelaufen.","message":"Bitte versuchen Sie es erneut!"}}},"foodDelivery":{"title":"Wie sch\xf6n, dass Sie Essen liefern!","subtitle":"W\xe4hlen Sie den Empf\xe4nger und benachrichtigen Sie ihn","subtitle1":"Dr\xfccken Sie den unten stehenden Knopf, um uns mitzuteilen, dass Sie hier sind!","subtitle2":"Sie k\xf6nnen das Essen am Empfang abgeben.","input":{"label":{"contact":"F\xfcr wen ist das Essen"},"error":{"contact":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt"}}},"button":{"submit":"Benachrichtigen"},"status":{"loading":{"title":"Wir benachrichtigen den Kontakt.","message":"Bitte warten!"},"success":{"no-email-sms":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":""},"email-sms":{"title":"Der Kontakt wurde benachrichtigt.","message":"Vielen Dank f\xfcr Ihre Lieferung!"},"call-ping":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."}},"error":{"title":"Etwas ist schief gelaufen.","message":"Bitte versuchen Sie es erneut!"}}},"QRCodeScanner":{"title":"Bitte scannen Sie Ihren QR-Code","subtitle":"Richten Sie den QR-Code innerhalb der roten Ecken aus und halten Sie Ihr Telefon ruhig."},"common":{"backBtn":"Zur\xfcck"},"previewPDF":{"page":{"of":"von","previous":"Vorherige","next":"N\xe4chste"},"button":{"cancel":"Abbrechen","accept":"Akzeptieren","next":"Weiter"},"title":{"consent":"Einwilligung erforderlich"}},"offline":{"title":"Offline","receptionMessage":"Die Rezeption ist momentan offline und kann nicht genutzt werden. Die Internetverbindung muss \xfcberpr\xfcft werden!","check":"Sind Sie ein Besucher und m\xf6chten direkt mit einem Mitarbeiter sprechen? Bitte rufen Sie {{receptionistPhone}} an."},"overview":{"title":"Geben Sie den Code ein, um die \xdcbersicht zu \xf6ffnen!","noUsers":"Keine Benutzer","status":{"success":{"title":"Der Code ist g\xfcltig.","message":""},"error":{"title":"Der Code ist ung\xfcltig.","message":"Bitte versuchen Sie es erneut!"}},"checkoutStatus":{"loading":{"title":"Bitte warten...","message":""},"success":{"title":"Erfolgreich ausgecheckt.","message":""},"error":{"title":"Etwas ist schief gelaufen.","message":"Bitte versuchen Sie es erneut!"}},"listTitle":"Liste der Personen, die heute eingecheckt, aber nicht ausgecheckt haben","page":"Seite ","table":{"head":{"fullName":"Name","type":"Typ","checkedinAt":"Eingecheckt um","host":"Gastgeber"},"type":{"Package":"Paketlieferung","Food":"Essenslieferung","Visitor":"Besucher","MeetingAttendee":"Eingeladener Besucher","Employee":"Mitarbeiter","Guest":"Gast"}},"confirmModal":{"title":"Sind Sie sicher, dass Sie {{fullName}} auschecken m\xf6chten?","cancel":"Abbrechen","checkout":"Auschecken"}},"wifi":{"title":"Verbinden Sie sich mit dem WLAN-Netzwerk"}}');


var $b19f380faffe50d1$exports = {};
$b19f380faffe50d1$exports = JSON.parse('{"language":{"title":"Escolha seu idioma","en":"Ingl\xeas","nl":"Holand\xeas","sr":"S\xe9rvio","fr":"Franc\xeas","de":"Alem\xe3o","pt":"Portugu\xeas"},"home":{"welcomeMessage":"Ol\xe1, o que traz voc\xea aqui hoje?","checkIn":"Check-in","independentManualCheckIn":"Sem Agendamento","integratedManualCheckIn":"Check-in manual","checkOut":"Check-out","manualCheckOut":"Check-out manual","parcelDelivery":"Entrega de encomenda","foodDelivery":"Entrega de comida","callReception":"Ligar para a recep\xe7\xe3o","overview":"Vis\xe3o geral","unavailable":"A recep\xe7\xe3o est\xe1 indispon\xedvel no momento."},"check":{"option":{"checkin":{"title":"Escolha uma op\xe7\xe3o para fazer check-in","manual":"Check-in manual","code":"Check-in com c\xf3digo PIN/QR"},"checkout":{"title":"Escolha uma op\xe7\xe3o para fazer check-out","manual":"Check-out com nome","code":"Check-out com c\xf3digo PIN/QR"}},"title":"Aguardando para escanear seu c\xf3digo QR.<br/>Sem c\xf3digo QR? Sem problemas.","orText":"OU","qrScanner":{"checkin":{"title":"Escolha uma op\xe7\xe3o para fazer check-in"},"checkout":{"title":"Escolha uma op\xe7\xe3o para fazer check-out"},"btn":"Escaneie seu c\xf3digo QR"},"pinCode":"Digite seu c\xf3digo PIN","manually":{"checkin":"N\xe3o tem credenciais?"},"status":{"idle":{"title":"Seu c\xf3digo est\xe1 sendo escaneado.","message":"Por favor, aguarde..."},"loading":{"title":"Seu c\xf3digo est\xe1 sendo escaneado.","message":"Por favor, aguarde..."},"error":{"title":"Seu c\xf3digo \xe9 inv\xe1lido.","message":"Por favor, tente novamente!"},"success":{"checkin":{"default":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"MeetingAttendee":{"no-email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Seu contato foi notificado."},"call-ping":{"title":"Voc\xea fez check-in com sucesso.","message":"Uma liga\xe7\xe3o ser\xe1 feita para o seu contato."}},"Employee":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"Visitor":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."}},"checkout":{"default":{"title":"Voc\xea fez check-out com sucesso.<br/>","message":"At\xe9 a pr\xf3xima."},"MeetingAttendee":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 a pr\xf3xima."},"Employee":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 a pr\xf3xima."},"Visitor":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 a pr\xf3xima."}}}}},"manualCheckin":{"title":"Por favor, preencha.","subtitle":"Nota - Todos os campos * s\xe3o obrigat\xf3rios","noOption":"Sem op\xe7\xe3o","btn":"Check-in","placeholder":{"name":"Seu nome *","email":"Seu e-mail *","phone":"N\xfamero de celular","contactName":"Nome do seu contato *"},"error":{"required":"Voc\xea n\xe3o preencheu este campo","name":"Nome inv\xe1lido","email":"Endere\xe7o de e-mail inv\xe1lido","phone":"N\xfamero de celular inv\xe1lido"},"status":{"loading":{"title":"Por favor, aguarde...","message":"Seu contato est\xe1 sendo notificado."},"success":{"no-email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Seu contato foi notificado."},"call-ping":{"title":"Voc\xea fez check-in com sucesso.","message":"Uma liga\xe7\xe3o ser\xe1 feita para o seu contato."}},"error":{"title":"Algo deu errado.","message":"Por favor, tente novamente!"}}},"manualCheckout":{"title":"Digite seu nome para fazer check-out","btn":"Check-out","form":{"placeholder":{"name":"Seu nome completo *"},"loading":"Carregando...","noOptions":"Sem op\xe7\xf5es"},"error":{"required":"Voc\xea n\xe3o preencheu este campo","name":"Nome inv\xe1lido"},"status":{"loading":{"title":"Estamos escaneando suas informa\xe7\xf5es.","message":"Por favor, aguarde..."},"success":{"title":"Voc\xea fez check-out com sucesso.","message":"Obrigado e tenha um bom dia."},"error":{"title":"Ocorreu um erro ao fazer check-out.","message":"Por favor, tente novamente!"}}},"call":{"title":{"no-email-sms":"Deseja notificar seu contato?","email-sms":"Enviamos um e-mail/SMS para seu contato.<br/>Deseja notific\xe1-lo adicionalmente?"},"callBtn":"Ligar","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videochamada","noBtn":"Cancelar","cancelBtn":"Cancelar chamada","status":{"connecting":{"title":"Estabelecendo chamada.<br/>Por favor, aguarde...","message":""},"ringing":{"title":"Chamando seu contato<br/>Por favor, aguarde...","message":""},"ringingReception":{"title":"Chamando a recep\xe7\xe3o.<br/>Por favor, aguarde...","message":""},"open":{"title":"Chamada em andamento.","message":""},"close":{"title":"Chamada encerrada.<br/>Por favor, aguarde seu contato.","message":""},"closeReception":{"title":"Chamada encerrada.","message":""},"error":{"title":"A chamada n\xe3o foi estabelecida.<br/>Chamar novamente?","message":""}}},"message":{"status":{"idle":{"title":"Estamos notificando o contato.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos notificando o contato.","message":"Por favor, aguarde..."},"success":{"title":"SMS enviado. O contato foi notificado.","message":"Obrigado!"},"error":{"title":"SMS n\xe3o enviado.","message":"Por favor, tente novamente!"}}},"videoCall":{"title":"Videochamada","endCall":"ENCERRAR CHAMADA","status":{"idle":{"title":"Estamos criando uma sala de v\xeddeo.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos criando uma sala de v\xeddeo.","message":"Por favor, aguarde..."},"success":{"title":"A sala de v\xeddeo foi criada com sucesso.","message":"Entrando na sala..."},"error":{"title":"A sala de v\xeddeo n\xe3o foi criada com sucesso.","message":"Por favor, tente novamente!"}}},"packageDelivery":{"title":"Que bom que voc\xea trouxe uma encomenda!","subtitle":"Selecione e notifique o destinat\xe1rio","subtitle1":"Pressione o bot\xe3o abaixo para avisar que voc\xea chegou!","subtitle2":"Voc\xea pode deixar o pacote na recep\xe7\xe3o.","input":{"label":{"contact":"Para quem \xe9 a encomenda"},"error":{"contact":{"required":"Voc\xea n\xe3o preencheu este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando o contato.","message":"Por favor, aguarde..."},"success":{"no-email-sms":{"title":"Obrigado pela entrega!","message":""},"email-sms":{"title":"O contato foi notificado.","message":"Obrigado pela entrega!"},"call-ping":{"title":"Obrigado pela entrega!","message":"Ser\xe1 feita uma conex\xe3o telef\xf4nica com o seu contato."}},"error":{"title":"Algo deu errado.","message":"Por favor, tente novamente!"}}},"foodDelivery":{"title":"Que bom que voc\xea trouxe uma entrega de comida!","subtitle":"Selecione e notifique o destinat\xe1rio","subtitle1":"Pressione o bot\xe3o abaixo para avisar que voc\xea chegou!","subtitle2":"Voc\xea pode deixar a comida na recep\xe7\xe3o.","input":{"label":{"contact":"Para quem \xe9 a comida"},"error":{"contact":{"required":"Voc\xea n\xe3o preencheu este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando o contato.","message":"Por favor, aguarde!"},"success":{"no-email-sms":{"title":"Obrigado pela entrega!","message":""},"email-sms":{"title":"O contato foi notificado.","message":"Obrigado pela entrega!"},"call-ping":{"title":"Obrigado pela entrega!","message":"Ser\xe1 feita uma conex\xe3o telef\xf4nica com o seu contato."}},"error":{"title":"Algo deu errado.","message":"Por favor, tente novamente!"}}},"QRCodeScanner":{"title":"Por favor, escaneie seu c\xf3digo QR","subtitle":"Alinhe o c\xf3digo QR dentro dos cantos vermelhos e mantenha o celular firme."},"common":{"backBtn":"Voltar"},"previewPDF":{"page":{"of":"de","previous":"Anterior","next":"Pr\xf3ximo"},"button":{"cancel":"Cancelar","accept":"Aceitar","next":"Pr\xf3ximo"},"title":{"consent":"Consentimento necess\xe1rio"}},"offline":{"title":"Offline","receptionMessage":"A recep\xe7\xe3o est\xe1 offline no momento e n\xe3o pode ser usada, a conex\xe3o de internet deve ser verificada!","check":"Voc\xea \xe9 um visitante e deseja falar diretamente com um funcion\xe1rio? Por favor, ligue para {{receptionistPhone}}"},"overview":{"title":"Digite o c\xf3digo para abrir a vis\xe3o geral!","noUsers":"Nenhum usu\xe1rio","status":{"success":{"title":"O c\xf3digo \xe9 v\xe1lido.","message":""},"error":{"title":"O c\xf3digo n\xe3o \xe9 v\xe1lido.","message":"Por favor, tente novamente!"}},"checkoutStatus":{"loading":{"title":"Por favor, aguarde...","message":""},"success":{"title":"Check-out bem-sucedido.","message":""},"error":{"title":"Algo deu errado.","message":"Por favor, tente novamente!"}},"listTitle":"Lista de pessoas que fizeram check-in hoje, mas n\xe3o fizeram check-out","page":"P\xe1gina ","table":{"head":{"fullName":"Nome","type":"Tipo","checkedinAt":"Check-in \xe0s","host":"Anfitri\xe3o"},"type":{"Package":"Entrega de pacote","Food":"Entrega de comida","Visitor":"Visitante","MeetingAttendee":"Visitante convidado","Employee":"Funcion\xe1rio","Guest":"H\xf3spede"}},"confirmModal":{"title":"Tem certeza de que deseja fazer o check-out de {{fullName}}?","cancel":"Cancelar","checkout":"Check-out"}},"wifi":{"title":"Conecte-se \xe0 rede Wi-Fi"}}');


const $b3774605281e3a2a$var$resources = {
    en: (/*@__PURE__*/$parcel$interopDefault($86cde84932c5b025$exports)),
    nl: (/*@__PURE__*/$parcel$interopDefault($e426d47f6742296e$exports)),
    sr: (/*@__PURE__*/$parcel$interopDefault($a18874184f267ca0$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($4ef112052723529f$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($002a7e1c39b40840$exports)),
    pt: (/*@__PURE__*/$parcel$interopDefault($b19f380faffe50d1$exports))
};
(0, $aZjGj.default).use((0, $9yd0C.initReactI18next)).init({
    resources: $b3774605281e3a2a$var$resources,
    debug: false,
    lng: "en",
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
        escapeValue: false
    }
});



var $cwDEq = parcelRequire("cwDEq");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $jcEiP = parcelRequire("jcEiP");
var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");
parcelRequire("eZVvM");


var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $eZVvM = parcelRequire("eZVvM");
const $4b8298b1f6c5cce2$var$ThemeContext = /*#__PURE__*/ $eZVvM.createContext(null);
var $4b8298b1f6c5cce2$export$2e2bcd8739ae039 = $4b8298b1f6c5cce2$var$ThemeContext;



var $eZVvM = parcelRequire("eZVvM");

function $89fbd7ac34e17c52$export$2e2bcd8739ae039() {
    const theme = $eZVvM.useContext((0, $4b8298b1f6c5cce2$export$2e2bcd8739ae039));
    return theme;
}


const $da629066958e80aa$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $da629066958e80aa$export$2e2bcd8739ae039 = $da629066958e80aa$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $3pI8R = parcelRequire("3pI8R");
function $81172fa088d605a5$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $65o8X.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $81172fa088d605a5$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $89fbd7ac34e17c52$export$2e2bcd8739ae039)();
    const theme = $eZVvM.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $81172fa088d605a5$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $da629066958e80aa$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4b8298b1f6c5cce2$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $81172fa088d605a5$export$2e2bcd8739ae039 = $81172fa088d605a5$var$ThemeProvider;



parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
const $d97d98e83b9fa62c$var$_excluded = [
    "value"
];
const $d97d98e83b9fa62c$var$RtlContext = /*#__PURE__*/ $eZVvM.createContext();
function $d97d98e83b9fa62c$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $7Z8DW.default)(_ref, $d97d98e83b9fa62c$var$_excluded);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($d97d98e83b9fa62c$var$RtlContext.Provider, (0, $65o8X.default)({
        value: value != null ? value : true
    }, props));
}
const $d97d98e83b9fa62c$export$b2dd014b6c321cb = ()=>{
    const value = $eZVvM.useContext($d97d98e83b9fa62c$var$RtlContext);
    return value != null ? value : false;
};
var $d97d98e83b9fa62c$export$2e2bcd8739ae039 = $d97d98e83b9fa62c$var$RtlProvider;



var $tqb3u = parcelRequire("tqb3u");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $faab1ee4ed77fef9$var$EMPTY_THEME = {};
function $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $eZVvM.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $65o8X.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $65o8X.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $65o8X.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $faab1ee4ed77fef9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $271479f5a10767b7$export$2e2bcd8739ae039)($faab1ee4ed77fef9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $89fbd7ac34e17c52$export$2e2bcd8739ae039)() || $faab1ee4ed77fef9$var$EMPTY_THEME;
    const engineTheme = $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $81172fa088d605a5$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8kMfp.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d97d98e83b9fa62c$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $tqb3u.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $faab1ee4ed77fef9$export$2e2bcd8739ae039 = $faab1ee4ed77fef9$var$ThemeProvider;



var $hDdqv = parcelRequire("hDdqv");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $43d941f371727f67$var$_excluded = [
    "theme"
];
function $43d941f371727f67$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $7Z8DW.default)(_ref, $43d941f371727f67$var$_excluded);
    const scopedTheme = themeInput[0, $hDdqv.default];
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $faab1ee4ed77fef9$export$2e2bcd8739ae039), (0, $65o8X.default)({}, props, {
        themeId: scopedTheme ? (0, $hDdqv.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $2EcOP = parcelRequire("2EcOP");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1PAIo = parcelRequire("1PAIo");
var $e44740008f325af1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e44740008f325af1$var$LinkBehavior = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((props, ref)=>{
    const { href: href } = props, other = $e44740008f325af1$var$__rest(props, [
        "href"
    ]);
    // Map href (MUI) -> to (react-router)
    return (0, $bhfvP.jsx)((0, $1PAIo.Link), Object.assign({
        ref: ref,
        to: href
    }, other));
});
var $e44740008f325af1$export$2e2bcd8739ae039 = $e44740008f325af1$var$LinkBehavior;



var $cD0nt = parcelRequire("cD0nt");
function $180ef2721521e747$var$createReceptionTheme(theme, fields) {
    var _a, _b, _c, _d, _e, _f;
    const primary = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : "#2D9CCA";
    const primaryLight = (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(primary).lighten(0.8).hex();
    const primaryDark = (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(primary).darken(0.25).hex();
    const background = (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.background) !== null && _d !== void 0 ? _d : "#FFFFFF";
    const textPrimary = (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.textPrimary) !== null && _f !== void 0 ? _f : "#1A242F";
    const contrastText = "#FCFCFC";
    return {
        typography: {
            fontFamily: [
                "DM Sans"
            ].join(","),
            h1: {
                fontSize: "4.4rem",
                fontWeight: "700",
                color: textPrimary
            },
            h2: {
                fontSize: "3.7rem",
                fontWeight: "700",
                color: textPrimary
            },
            h3: {
                fontSize: "3.2rem",
                fontWeight: "700",
                color: textPrimary
            },
            h4: {
                fontSize: "2.4rem",
                fontWeight: "700",
                color: textPrimary
            }
        },
        palette: {
            primary: {
                main: primary,
                dark: primaryDark,
                light: primaryLight,
                contrastText: contrastText
            },
            secondary: {
                main: "#666666"
            },
            error: {
                main: "#e13c3c"
            },
            success: {
                main: "#05c00c"
            },
            text: {
                primary: textPrimary
            },
            background: {
                default: background
            }
        },
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        width: "100%"
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        fontSize: "3.2rem",
                        color: textPrimary,
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(background).lighten(0.1).hex(),
                        border: `0.2rem solid ${textPrimary} !important`,
                        "fieldset.MuiOutlinedInput-notchedOutline": {
                            border: "none"
                        }
                    },
                    input: {
                        padding: "1.4rem 3.4rem !important"
                    },
                    inputAdornedStart: {
                        marginLeft: "-2rem "
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "3.2rem",
                        padding: "0 1rem",
                        transform: "translate(1.4rem, 1.5rem) scale(1)",
                        color: textPrimary
                    },
                    shrink: {
                        transform: "translate(2rem, -2.5rem) scale(0.75)",
                        backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(background).lighten(0.1).hex(),
                        padding: "0.4rem 2.5rem 0 1.5rem",
                        borderRadius: "0.7rem"
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontSize: "2rem",
                        paddingLeft: "1rem"
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    inputRoot: {
                        padding: "0"
                    },
                    endAdornment: {
                        display: "none"
                    },
                    popper: {
                        marginTop: "0.8rem !important",
                        borderRadius: "1rem"
                    },
                    paper: {
                        margin: "0",
                        boxShadow: `0px 0px 4px -1px ${textPrimary}`,
                        border: `1px solid ${textPrimary}`,
                        borderRadius: "1rem",
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(background).lighten(0.1).hex()
                    },
                    listbox: {
                        padding: "0 0 0.5rem",
                        maxHeight: "21.8rem"
                    },
                    option: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 3.2rem !important",
                        color: textPrimary,
                        minHeight: "auto !important",
                        '&[aria-selected="true"]': {
                            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(background).lighten(0.08).hex()
                        }
                    },
                    noOptions: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 2.8rem",
                        color: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(textPrimary).lighten(0.2).hex()
                    },
                    loading: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 2.8rem",
                        color: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(textPrimary).lighten(0.2).hex()
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 700,
                        fontSize: "3.2rem",
                        textTransform: "none",
                        borderRadius: "1rem",
                        boxShadow: "none",
                        color: background,
                        "&:hover": {
                            boxShadow: "none"
                        }
                    },
                    sizeMedium: {
                        fontSize: "3.2rem",
                        padding: "1.45rem 2rem"
                    },
                    outlined: {
                        color: primary
                    }
                }
            },
            MuiButtonGroup: {
                styleOverrides: {
                    root: {
                        ".MuiButton-root:first-of-type": {
                            borderBottomLeftRadius: 0
                        },
                        ".MuiButton-root:last-of-type": {
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            MuiLink: {
                defaultProps: {
                    component: (0, $e44740008f325af1$export$2e2bcd8739ae039)
                }
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        marginTop: "-3rem!important",
                        width: "56.5rem",
                        height: "38rem",
                        margin: "0",
                        boxShadow: `0px 0px 4px -1px ${textPrimary}`,
                        border: `1px solid ${textPrimary}`,
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(background).lighten(0.1).hex(),
                        li: {
                            padding: "1.2rem 3.2rem !important",
                            color: textPrimary,
                            minHeight: "auto !important",
                            img: {
                                width: "4rem",
                                marginRight: "3rem"
                            },
                            span: {
                                fontSize: "3.2rem"
                            },
                            p: {
                                fontSize: "3.2rem",
                                fontWeight: "600"
                            }
                        }
                    }
                }
            },
            MuiInputAdornment: {
                styleOverrides: {
                    root: {
                        button: {
                            marginLeft: "1rem",
                            paddingRight: "0",
                            img: {
                                width: "4rem"
                            }
                        }
                    }
                }
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        marginTop: "3rem",
                        width: "90%"
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        width: `${100 / ((fields === null || fields === void 0 ? void 0 : fields.length) || 3)}%`,
                        textAlign: "center",
                        fontSize: "2.4rem",
                        padding: "2rem 0"
                    },
                    head: {
                        fontSize: "2.75rem",
                        fontWeight: "700"
                    }
                }
            },
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        ".MuiInputBase-root": {
                            display: "none"
                        }
                    },
                    selectLabel: {
                        display: "none"
                    },
                    displayedRows: {
                        display: "none"
                    },
                    actions: {
                        marginLeft: "0",
                        svg: {
                            width: "5rem",
                            height: "5rem"
                        }
                    }
                }
            }
        }
    };
}
const $180ef2721521e747$export$d8964aec282183a3 = (props)=>{
    const { children: children, dataUpdatedAt: dataUpdatedAt, theme: theme } = props;
    const { fields: fields } = (0, $cD0nt.useOverview)();
    const MUItheme = (0, $eZVvM.useMemo)(()=>{
        const options = $180ef2721521e747$var$createReceptionTheme(theme, fields);
        return (0, $jcEiP.default)(options);
    }, [
        theme,
        dataUpdatedAt
    ]);
    return (0, $bhfvP.jsx)((0, $43d941f371727f67$export$2e2bcd8739ae039), Object.assign({
        theme: MUItheme
    }, {
        children: children
    }));
};



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $kvR7a = parcelRequire("kvR7a");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $gdPnm = parcelRequire("gdPnm");

var $cwDEq = parcelRequire("cwDEq");
var $3adb49bfa33db486$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3adb49bfa33db486$var$getBrowserLanguage = ()=>navigator.languages.find((language)=>language.length === 2);
const $3adb49bfa33db486$var$defaultLanguages = [
    "en",
    "nl",
    "sr",
    "fr",
    "de",
    "pt"
];
const $3adb49bfa33db486$var$LanguageContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const { Provider: $3adb49bfa33db486$var$Provider } = $3adb49bfa33db486$var$LanguageContext;
const $3adb49bfa33db486$export$c1fd9f444a3dc711 = ()=>{
    const { language: language, onChange: onChange } = (0, $eZVvM.useContext)($3adb49bfa33db486$var$LanguageContext);
    return [
        language,
        onChange
    ];
};
const $3adb49bfa33db486$export$38be4353f99148d = ()=>{
    const { languages: languages } = (0, $eZVvM.useContext)($3adb49bfa33db486$var$LanguageContext);
    return languages;
};
const $3adb49bfa33db486$var$isActivationScreen = window.location.pathname.includes("/activation");
const $3adb49bfa33db486$export$195746d839abd8b5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children, language: defaultLanguage = $3adb49bfa33db486$var$isActivationScreen ? $3adb49bfa33db486$var$getBrowserLanguage() : "en", languages: languages = $3adb49bfa33db486$var$defaultLanguages } = props;
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { screenId: screenId } = (0, $cwDEq.useAppContext)();
    const { i18n: i18n } = (0, $9GLBV.useTranslation)();
    const [language, setLanguage] = (0, $eZVvM.useState)(defaultLanguage);
    (0, $eZVvM.useEffect)(()=>{
        setLanguage(()=>defaultLanguage);
    }, [
        defaultLanguage
    ]);
    (0, $eZVvM.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).locale(language);
        i18n.changeLanguage(language);
    }, [
        language
    ]);
    const onChange = (0, $eZVvM.useCallback)((next)=>{
        setLanguage(next);
    }, [
        i18n
    ]);
    const onMessage = (0, $eZVvM.useCallback)((event)=>$3adb49bfa33db486$var$__awaiter(void 0, void 0, void 0, function*() {
            const { data: rawMessage } = event;
            try {
                const message = JSON.parse(rawMessage);
                if (!(message && message.action && message.action === "update-language")) return;
                const { data: data } = message;
                yield queryClient.refetchQueries([
                    "digitalReception",
                    {
                        id: screenId,
                        language: data
                    }
                ]);
                setLanguage(data);
            } catch (_a) {}
        }), []);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            language: language,
            languages: languages,
            onChange: onChange
        }), [
        languages,
        language,
        onChange
    ]);
    return (0, $bhfvP.jsx)($3adb49bfa33db486$var$Provider, Object.assign({
        value: value
    }, {
        children: children
    }));
});
var $3adb49bfa33db486$export$2e2bcd8739ae039 = $3adb49bfa33db486$var$LanguageContext;



var $l4qYG = parcelRequire("l4qYG");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $2EcOP = parcelRequire("2EcOP");

var $ljukC = parcelRequire("ljukC");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $e8m2I = parcelRequire("e8m2I");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $8XBeX = parcelRequire("8XBeX");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");


var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $b625618202e2da7b$var$useEnhancedEffect = typeof window !== "undefined" ? $eZVvM.useLayoutEffect : $eZVvM.useEffect;
var $b625618202e2da7b$export$2e2bcd8739ae039 = $b625618202e2da7b$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $7fad5769266b0294$var$useEventCallback(fn) {
    const ref = $eZVvM.useRef(fn);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $eZVvM.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $7fad5769266b0294$export$2e2bcd8739ae039 = $7fad5769266b0294$var$useEventCallback;


"use client";
var $11ca5a3145a6ac50$export$2e2bcd8739ae039 = (0, $7fad5769266b0294$export$2e2bcd8739ae039);



var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $336476351ccef725$var$UNINITIALIZED = {};
function $336476351ccef725$export$2e2bcd8739ae039(init, initArg) {
    const ref = $eZVvM.useRef($336476351ccef725$var$UNINITIALIZED);
    if (ref.current === $336476351ccef725$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $eZVvM = parcelRequire("eZVvM");
"use client";
const $7b1e513b9973bd82$var$EMPTY = [];
function $7b1e513b9973bd82$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $eZVvM.useEffect(fn, $7b1e513b9973bd82$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $dbc2a71359ae6439$export$786b4da70f00938b {
    static create() {
        return new $dbc2a71359ae6439$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $dbc2a71359ae6439$export$2e2bcd8739ae039() {
    const timeout = (0, $336476351ccef725$export$2e2bcd8739ae039)($dbc2a71359ae6439$export$786b4da70f00938b.create).current;
    (0, $7b1e513b9973bd82$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $cf5c6886a3f12002$var$hadKeyboardEvent = true;
let $cf5c6886a3f12002$var$hadFocusVisibleRecently = false;
const $cf5c6886a3f12002$var$hadFocusVisibleRecentlyTimeout = new (0, $dbc2a71359ae6439$export$786b4da70f00938b)();
const $cf5c6886a3f12002$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $cf5c6886a3f12002$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $cf5c6886a3f12002$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $cf5c6886a3f12002$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $cf5c6886a3f12002$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $cf5c6886a3f12002$var$handlePointerDown() {
    $cf5c6886a3f12002$var$hadKeyboardEvent = false;
}
function $cf5c6886a3f12002$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($cf5c6886a3f12002$var$hadFocusVisibleRecently) $cf5c6886a3f12002$var$hadKeyboardEvent = true;
    }
}
function $cf5c6886a3f12002$var$prepare(doc) {
    doc.addEventListener("keydown", $cf5c6886a3f12002$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $cf5c6886a3f12002$var$handleVisibilityChange, true);
}
function $cf5c6886a3f12002$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $cf5c6886a3f12002$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $cf5c6886a3f12002$var$handleVisibilityChange, true);
}
function $cf5c6886a3f12002$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $cf5c6886a3f12002$var$hadKeyboardEvent || $cf5c6886a3f12002$var$focusTriggersKeyboardModality(target);
}
function $cf5c6886a3f12002$export$2e2bcd8739ae039() {
    const ref = $eZVvM.useCallback((node)=>{
        if (node != null) $cf5c6886a3f12002$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $eZVvM.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $cf5c6886a3f12002$var$hadFocusVisibleRecently = true;
            $cf5c6886a3f12002$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $cf5c6886a3f12002$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($cf5c6886a3f12002$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $6a538cd1be632e86$export$2e2bcd8739ae039 = (0, $cf5c6886a3f12002$export$2e2bcd8739ae039);



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $3Vxa5 = parcelRequire("3Vxa5");



var $eZVvM = parcelRequire("eZVvM");


var $eZVvM = parcelRequire("eZVvM");
function $4fd9b26b177b9e61$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $eZVvM.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $eZVvM.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4fd9b26b177b9e61$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4fd9b26b177b9e61$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4fd9b26b177b9e61$export$fa71e2345c31d7a2(props, onExited) {
    return $4fd9b26b177b9e61$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4fd9b26b177b9e61$var$getProp(child, "appear", props),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", props),
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", props)
        });
    });
}
function $4fd9b26b177b9e61$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4fd9b26b177b9e61$export$bbc8a025727ea824(nextProps.children);
    var children = $4fd9b26b177b9e61$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $eZVvM.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $eZVvM.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", nextProps),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $eZVvM.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", nextProps),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $955311a93601fb86$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $955311a93601fb86$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $955311a93601fb86$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $fb26d559f651f364$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3Vxa5.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $4fd9b26b177b9e61$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $4fd9b26b177b9e61$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $4fd9b26b177b9e61$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $65o8X.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $7Z8DW.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $955311a93601fb86$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Component);
$955311a93601fb86$var$TransitionGroup.propTypes = {};
$955311a93601fb86$var$TransitionGroup.defaultProps = $955311a93601fb86$var$defaultProps;
var $955311a93601fb86$export$2e2bcd8739ae039 = $955311a93601fb86$var$TransitionGroup;



var $fmwLG = parcelRequire("fmwLG");

var $aNuUP = parcelRequire("aNuUP");


var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $3pI8R = parcelRequire("3pI8R");
"use client";
function $10956df88f5537e9$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $eZVvM.useState(false);
    const rippleClassName = (0, $fmwLG.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fmwLG.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $eZVvM.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
            className: childClassName
        })
    });
}
var $10956df88f5537e9$export$2e2bcd8739ae039 = $10956df88f5537e9$var$Ripple;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $be89b43511df88e2$export$b464606f735ab902(slot) {
    return (0, $8QgsE.default)("MuiTouchRipple", slot);
}
const $be89b43511df88e2$var$touchRippleClasses = (0, $dvQev.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $be89b43511df88e2$export$2e2bcd8739ae039 = $be89b43511df88e2$var$touchRippleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $6e20985d142d5a66$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $6e20985d142d5a66$var$_ = (t)=>t, $6e20985d142d5a66$var$_t, $6e20985d142d5a66$var$_t2, $6e20985d142d5a66$var$_t3, $6e20985d142d5a66$var$_t4;
const $6e20985d142d5a66$var$DURATION = 550;
const $6e20985d142d5a66$export$95d0c9356b2231a3 = 80;
const $6e20985d142d5a66$var$enterKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t || ($6e20985d142d5a66$var$_t = $6e20985d142d5a66$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $6e20985d142d5a66$var$exitKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t2 || ($6e20985d142d5a66$var$_t2 = $6e20985d142d5a66$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $6e20985d142d5a66$var$pulsateKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t3 || ($6e20985d142d5a66$var$_t3 = $6e20985d142d5a66$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $6e20985d142d5a66$export$f6b7418508c72c25 = (0, $e8m2I.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $6e20985d142d5a66$export$676cfe7b12693c4b = (0, $e8m2I.default)((0, $10956df88f5537e9$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($6e20985d142d5a66$var$_t4 || ($6e20985d142d5a66$var$_t4 = $6e20985d142d5a66$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $be89b43511df88e2$export$2e2bcd8739ae039).rippleVisible, $6e20985d142d5a66$var$enterKeyframe, $6e20985d142d5a66$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $be89b43511df88e2$export$2e2bcd8739ae039).child, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childLeaving, $6e20985d142d5a66$var$exitKeyframe, $6e20985d142d5a66$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childPulsate, $6e20985d142d5a66$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $6e20985d142d5a66$var$TouchRipple = /*#__PURE__*/ $eZVvM.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $7Z8DW.default)(props, $6e20985d142d5a66$var$_excluded);
    const [ripples, setRipples] = $eZVvM.useState([]);
    const nextKey = $eZVvM.useRef(0);
    const rippleCallback = $eZVvM.useRef(null);
    $eZVvM.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $eZVvM.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $eZVvM.useRef(null);
    const container = $eZVvM.useRef(null);
    const startCommit = $eZVvM.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $3pI8R.jsx)($6e20985d142d5a66$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fmwLG.default)(classes.ripple, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $fmwLG.default)(classes.rippleVisible, (0, $be89b43511df88e2$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $fmwLG.default)(classes.ripplePulsate, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $fmwLG.default)(classes.child, (0, $be89b43511df88e2$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $fmwLG.default)(classes.childLeaving, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $fmwLG.default)(classes.childPulsate, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $6e20985d142d5a66$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $eZVvM.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($6e20985d142d5a66$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $eZVvM.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $eZVvM.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $eZVvM.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($6e20985d142d5a66$export$f6b7418508c72c25, (0, $65o8X.default)({
        className: (0, $fmwLG.default)((0, $be89b43511df88e2$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $955311a93601fb86$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $6e20985d142d5a66$export$2e2bcd8739ae039 = $6e20985d142d5a66$var$TouchRipple;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $4af6f561b7116851$export$fccb0498dcd99783(slot) {
    return (0, $8QgsE.default)("MuiButtonBase", slot);
}
const $4af6f561b7116851$var$buttonBaseClasses = (0, $dvQev.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $4af6f561b7116851$export$2e2bcd8739ae039 = $4af6f561b7116851$var$buttonBaseClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4a8b8bf1c0ac0824$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a8b8bf1c0ac0824$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $4af6f561b7116851$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a8b8bf1c0ac0824$export$7ec0dcc5e3cdcd36 = (0, $e8m2I.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $4af6f561b7116851$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a8b8bf1c0ac0824$var$ButtonBase = /*#__PURE__*/ $eZVvM.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $7Z8DW.default)(props, $4a8b8bf1c0ac0824$var$_excluded);
    const buttonRef = $eZVvM.useRef(null);
    const rippleRef = $eZVvM.useRef(null);
    const handleRippleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $6a538cd1be632e86$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $eZVvM.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $eZVvM.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $eZVvM.useState(false);
    $eZVvM.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $eZVvM.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $eZVvM.useRef(false);
    const handleKeyDown = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $65o8X.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a8b8bf1c0ac0824$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($4a8b8bf1c0ac0824$export$7ec0dcc5e3cdcd36, (0, $65o8X.default)({
        as: ComponentProp,
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $3pI8R.jsx)((0, $6e20985d142d5a66$export$2e2bcd8739ae039), (0, $65o8X.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a8b8bf1c0ac0824$export$2e2bcd8739ae039 = $4a8b8bf1c0ac0824$var$ButtonBase;



var $iDCHz = parcelRequire("iDCHz");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $1fb0df7e1a4ded0d$export$5a6f9035944c8119(slot) {
    return (0, $8QgsE.default)("MuiButton", slot);
}
const $1fb0df7e1a4ded0d$var$buttonClasses = (0, $dvQev.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $1fb0df7e1a4ded0d$export$2e2bcd8739ae039 = $1fb0df7e1a4ded0d$var$buttonClasses;



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $2ead2aabe9a84af4$var$ButtonGroupContext = /*#__PURE__*/ $eZVvM.createContext({});
var $2ead2aabe9a84af4$export$2e2bcd8739ae039 = $2ead2aabe9a84af4$var$ButtonGroupContext;



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $1c0fa3646ade5325$var$ButtonGroupButtonContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
var $1c0fa3646ade5325$export$2e2bcd8739ae039 = $1c0fa3646ade5325$var$ButtonGroupButtonContext;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $d1dc812927743fa6$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $d1dc812927743fa6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $iDCHz.default)(color)}`,
            `size${(0, $iDCHz.default)(size)}`,
            `${variant}Size${(0, $iDCHz.default)(size)}`,
            `color${(0, $iDCHz.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $iDCHz.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $iDCHz.default)(size)}`
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $1fb0df7e1a4ded0d$export$5a6f9035944c8119), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $d1dc812927743fa6$var$commonIconStyles = (ownerState)=>(0, $65o8X.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $d1dc812927743fa6$var$ButtonRoot = (0, $e8m2I.default)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iDCHz.default)(ownerState.color)}`],
            styles[`size${(0, $iDCHz.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $iDCHz.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $65o8X.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $65o8X.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $65o8X.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).focusVisible}`]: (0, $65o8X.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).disabled}`]: (0, $65o8X.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $9b0pf.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $d1dc812927743fa6$var$ButtonStartIcon = (0, $e8m2I.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $iDCHz.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $d1dc812927743fa6$var$commonIconStyles(ownerState)));
const $d1dc812927743fa6$var$ButtonEndIcon = (0, $e8m2I.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $iDCHz.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $d1dc812927743fa6$var$commonIconStyles(ownerState)));
const $d1dc812927743fa6$var$Button = /*#__PURE__*/ $eZVvM.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $eZVvM.useContext((0, $2ead2aabe9a84af4$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $eZVvM.useContext((0, $1c0fa3646ade5325$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8XBeX.default)(contextProps, inProps);
    const props = (0, $8C83T.useDefaultProps)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $7Z8DW.default)(props, $d1dc812927743fa6$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $d1dc812927743fa6$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $3pI8R.jsx)($d1dc812927743fa6$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $3pI8R.jsx)($d1dc812927743fa6$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($d1dc812927743fa6$var$ButtonRoot, (0, $65o8X.default)({
        ownerState: ownerState,
        className: (0, $fmwLG.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fmwLG.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $d1dc812927743fa6$export$2e2bcd8739ae039 = $d1dc812927743fa6$var$Button;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $eZVvM = parcelRequire("eZVvM");
function $05f8386e46a60a51$export$2e2bcd8739ae039(children) {
    return $eZVvM.Children.toArray(children).filter((child)=>/*#__PURE__*/ $eZVvM.isValidElement(child));
}



var $iDCHz = parcelRequire("iDCHz");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $3e8c170683421297$export$b85c003f960b1f3a(slot) {
    return (0, $8QgsE.default)("MuiButtonGroup", slot);
}
const $3e8c170683421297$var$buttonGroupClasses = (0, $dvQev.default)("MuiButtonGroup", [
    "root",
    "contained",
    "outlined",
    "text",
    "disableElevation",
    "disabled",
    "firstButton",
    "fullWidth",
    "vertical",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "groupedText",
    "groupedTextHorizontal",
    "groupedTextVertical",
    "groupedTextPrimary",
    "groupedTextSecondary",
    "groupedOutlined",
    "groupedOutlinedHorizontal",
    "groupedOutlinedVertical",
    "groupedOutlinedPrimary",
    "groupedOutlinedSecondary",
    "groupedContained",
    "groupedContainedHorizontal",
    "groupedContainedVertical",
    "groupedContainedPrimary",
    "groupedContainedSecondary",
    "lastButton",
    "middleButton"
]);
var $3e8c170683421297$export$2e2bcd8739ae039 = $3e8c170683421297$var$buttonGroupClasses;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $dd44097e65f4cd5a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $dd44097e65f4cd5a$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iDCHz.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iDCHz.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iDCHz.default)(ownerState.variant)}${(0, $iDCHz.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iDCHz.default)(ownerState.variant)}${(0, $iDCHz.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === "vertical" && styles.vertical
    ];
};
const $dd44097e65f4cd5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth",
            disableElevation && "disableElevation"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $iDCHz.default)(orientation)}`,
            `grouped${(0, $iDCHz.default)(variant)}`,
            `grouped${(0, $iDCHz.default)(variant)}${(0, $iDCHz.default)(orientation)}`,
            `grouped${(0, $iDCHz.default)(variant)}${(0, $iDCHz.default)(color)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $3e8c170683421297$export$b85c003f960b1f3a), classes);
};
const $dd44097e65f4cd5a$var$ButtonGroupRoot = (0, $e8m2I.default)("div", {
    name: "MuiButtonGroup",
    slot: "Root",
    overridesResolver: $dd44097e65f4cd5a$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "contained" && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: "none"
    }, ownerState.fullWidth && {
        width: "100%"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, {
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: (0, $65o8X.default)({
            minWidth: 40,
            "&:hover": (0, $65o8X.default)({}, ownerState.variant === "contained" && {
                boxShadow: "none"
            })
        }, ownerState.variant === "contained" && {
            boxShadow: "none"
        }),
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).firstButton},& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: (0, $65o8X.default)({}, ownerState.orientation === "horizontal" && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === "text" && ownerState.orientation === "horizontal" && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.orientation === "vertical" && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            borderRightColor: "transparent"
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            borderBottomColor: "transparent"
        }, ownerState.variant === "contained" && ownerState.orientation === "horizontal" && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.orientation === "vertical" && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            "&:hover": (0, $65o8X.default)({}, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
                borderRightColor: "currentColor"
            }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
                borderBottomColor: "currentColor"
            })
        }),
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).lastButton},& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: (0, $65o8X.default)({}, ownerState.orientation === "horizontal" && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            marginLeft: -1
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            marginTop: -1
        })
    }));
const $dd44097e65f4cd5a$var$ButtonGroup = /*#__PURE__*/ $eZVvM.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiButtonGroup"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = "horizontal", size: size = "medium", variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $dd44097e65f4cd5a$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $dd44097e65f4cd5a$var$useUtilityClasses(ownerState);
    const context = $eZVvM.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $05f8386e46a60a51$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)($dd44097e65f4cd5a$var$ButtonGroupRoot, (0, $65o8X.default)({
        as: component,
        role: "group",
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ead2aabe9a84af4$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $1c0fa3646ade5325$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $dd44097e65f4cd5a$export$2e2bcd8739ae039 = $dd44097e65f4cd5a$var$ButtonGroup;



var $81BVN = parcelRequire("81BVN");

var $cD0nt = parcelRequire("cD0nt");


var $4yVoh = parcelRequire("4yVoh");

var $bhfvP = parcelRequire("bhfvP");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $aac849b99e70d441$var$SvgEn = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('cd466b68880ea3e5')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M3.307 6.259a15.942 15.942 0 0 0-2.756 5.567h8.323L3.307 6.26ZM31.448 11.826a15.944 15.944 0 0 0-2.756-5.567l-5.567 5.567h8.323ZM.55 20.174a15.945 15.945 0 0 0 2.757 5.567l5.567-5.567H.551ZM25.741 3.308A15.942 15.942 0 0 0 20.174.55v8.324l5.567-5.567ZM6.259 28.693a15.944 15.944 0 0 0 5.567 2.756v-8.324l-5.567 5.568ZM11.826.551a15.943 15.943 0 0 0-5.567 2.757l5.567 5.567V.55ZM20.174 31.449a15.944 15.944 0 0 0 5.567-2.756l-5.567-5.568v8.324ZM23.125 20.174l5.567 5.567a15.943 15.943 0 0 0 2.756-5.567h-8.323Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M31.865 13.913H18.087V.135a16.16 16.16 0 0 0-4.174 0v13.778H.135a16.16 16.16 0 0 0 0 4.174h13.778v13.778a16.166 16.166 0 0 0 4.174 0V18.087h13.778a16.166 16.166 0 0 0 0-4.174Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "m20.174 20.174 7.14 7.14c.328-.329.641-.672.94-1.027l-6.113-6.113h-1.967ZM11.826 20.174l-7.14 7.14c.329.328.672.641 1.028.94l6.112-6.113v-1.967ZM11.826 11.826l-7.14-7.14c-.328.328-.641.671-.94 1.027l6.113 6.113h1.967ZM20.174 11.826l7.14-7.14a16.017 16.017 0 0 0-1.027-.94l-6.113 6.113v1.967Z",
                    fill: "#D80027"
                })
            ]
        })
    });
var $aac849b99e70d441$export$2e2bcd8739ae039 = $aac849b99e70d441$var$SvgEn;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $a01c6f1bcfe7003c$var$SvgNl = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('6255d14cef0be76e')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0Z",
                    fill: "#A2001D"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c6.88 0 12.744-4.342 15.005-10.435H.995C3.255 27.658 9.12 32 16 32Z",
                    fill: "#0052B4"
                })
            ]
        })
    });
var $a01c6f1bcfe7003c$export$2e2bcd8739ae039 = $a01c6f1bcfe7003c$var$SvgNl;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $3f8a02afc7fd58be$var$SvgDe = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('f383e8461bdab344')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M1 21.565C3.26 27.658 9.125 32 16.005 32c6.88 0 12.744-4.342 15.005-10.435l-15.005-1.391L1 21.565Z",
                    fill: "#FFDA44"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16.005 0C9.125 0 3.26 4.342 1 10.435l15.005 1.391 15.005-1.391C28.749 4.342 22.884 0 16.005 0Z",
                    fill: "#000"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M.995 10.435A15.965 15.965 0 0 0 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16c0-1.957-.352-3.832-.995-5.565H.995Z",
                    fill: "#D80027"
                })
            ]
        })
    });
var $3f8a02afc7fd58be$export$2e2bcd8739ae039 = $3f8a02afc7fd58be$var$SvgDe;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $453b90f50adb1cf2$var$SvgFr = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('75cb4dc47f9508c6')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M32 16C32 9.12 27.658 3.256 21.565.995v30.01C27.658 28.745 32 22.879 32 16Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M0 16c0 6.88 4.342 12.744 10.435 15.005V.995C4.342 3.255 0 9.12 0 16Z",
                    fill: "#0052B4"
                })
            ]
        })
    });
var $453b90f50adb1cf2$export$2e2bcd8739ae039 = $453b90f50adb1cf2$var$SvgFr;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $747d7715f39884f2$var$SvgRs = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('45230c8e20f63d66')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C7.163 0 0 7.163 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16c0-8.837-7.163-16-16-16Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M4.137 9.043v7.982c0 4.54 5.932 5.932 5.932 5.932s5.93-1.392 5.93-5.932V9.044H4.138Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M6.59 10.435h6.957V7.652l-1.391.696-2.087-2.087-2.087 2.087-1.392-.696v2.783ZM14.609 18.136l-4.522-4.521-4.522 4.521 1.476 1.476 3.046-3.046 3.046 3.046 1.476-1.476Z",
                    fill: "#FFDA44"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M14.609 13.913h-2.11a1.391 1.391 0 1 0-2.43-1.352 1.39 1.39 0 1 0-2.43 1.352H5.564c0 .768.67 1.391 1.438 1.391h-.046c0 .769.622 1.392 1.39 1.392 0 .68.49 1.245 1.135 1.366l-1.096 2.475a4.507 4.507 0 0 0 3.403 0l-1.097-2.475a1.391 1.391 0 0 0 1.134-1.366c.769 0 1.391-.623 1.391-1.392h-.046c.768 0 1.438-.623 1.438-1.39Z",
                    fill: "#F0F0F0"
                })
            ]
        })
    });
var $747d7715f39884f2$export$2e2bcd8739ae039 = $747d7715f39884f2$var$SvgRs;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $5c451989d277fba4$var$SvgPt = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M23.5 1.863A15.93 15.93 0 0 0 16 0c-2.71 0-5.263.674-7.5 1.863v28.274A15.93 15.93 0 0 0 16 32c2.71 0 5.263-.674 7.5-1.863V1.863Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M21.5.97C27.627 3.214 32 9.097 32 16s-4.373 12.787-10.5 15.03V.97Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.5.97v30.06C4.373 28.787 0 22.904 0 16S4.373 3.213 10.5.97Z",
                fill: "#496E2D"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.435 21.565a5.565 5.565 0 1 0 0-11.13 5.565 5.565 0 0 0 0 11.13Z",
                fill: "#FFDA44"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M7.304 13.217v3.478a3.13 3.13 0 1 0 6.261 0v-3.478h-6.26Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.435 17.739a1.045 1.045 0 0 1-1.044-1.044v-1.39h2.087v1.39c0 .576-.468 1.044-1.043 1.044Z",
                fill: "#EEE"
            })
        ]
    });
var $5c451989d277fba4$export$2e2bcd8739ae039 = $5c451989d277fba4$var$SvgPt;


var $fc131733a17f1801$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fc131733a17f1801$var$iconTypes = {
    en: (0, $aac849b99e70d441$export$2e2bcd8739ae039),
    nl: (0, $a01c6f1bcfe7003c$export$2e2bcd8739ae039),
    sr: (0, $747d7715f39884f2$export$2e2bcd8739ae039),
    de: (0, $3f8a02afc7fd58be$export$2e2bcd8739ae039),
    fr: (0, $453b90f50adb1cf2$export$2e2bcd8739ae039),
    pt: (0, $5c451989d277fba4$export$2e2bcd8739ae039)
};
const $fc131733a17f1801$var$LocaleIcon = (_a)=>{
    var { name: name } = _a, props = $fc131733a17f1801$var$__rest(_a, [
        "name"
    ]);
    const Icon = $fc131733a17f1801$var$iconTypes[name];
    return (0, $bhfvP.jsx)(Icon, Object.assign({}, props));
};
var $fc131733a17f1801$export$2e2bcd8739ae039 = $fc131733a17f1801$var$LocaleIcon;



var $cRA6X = parcelRequire("cRA6X");

var $bhfvP = parcelRequire("bhfvP");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $cgitS = parcelRequire("cgitS");

var $hWP8m = parcelRequire("hWP8m");



var $gnWEo = parcelRequire("gnWEo");

var $34Ozv = parcelRequire("34Ozv");
const $c188b0b6cf7ccc98$var$_excluded = [
    "ownerState"
], $c188b0b6cf7ccc98$var$_excluded2 = [
    "variants"
], $c188b0b6cf7ccc98$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $c188b0b6cf7ccc98$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c188b0b6cf7ccc98$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $c188b0b6cf7ccc98$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $c188b0b6cf7ccc98$export$35e57303dbd8a66 = (0, $gnWEo.default)();
const $c188b0b6cf7ccc98$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $c188b0b6cf7ccc98$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $c188b0b6cf7ccc98$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $c188b0b6cf7ccc98$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $c188b0b6cf7ccc98$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $7Z8DW.default)(_ref, $c188b0b6cf7ccc98$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $65o8X.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$c188b0b6cf7ccc98$var$processStyleArg(resolvedStyle, (0, $65o8X.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $7Z8DW.default)(resolvedStylesArg, $c188b0b6cf7ccc98$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $65o8X.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $65o8X.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $c188b0b6cf7ccc98$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c188b0b6cf7ccc98$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $c188b0b6cf7ccc98$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $c188b0b6cf7ccc98$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $34Ozv.default)((0, $65o8X.default)({}, props, {
            theme: $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $cgitS.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c188b0b6cf7ccc98$var$defaultOverridesResolver($c188b0b6cf7ccc98$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $7Z8DW.default)(inputOptions, $c188b0b6cf7ccc98$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $c188b0b6cf7ccc98$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c188b0b6cf7ccc98$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $cgitS.default)(tag, (0, $65o8X.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $hWP8m.isPlainObject)(stylesArg)) return (props)=>$c188b0b6cf7ccc98$var$processStyleArg(stylesArg, (0, $65o8X.default)({}, props, {
                    theme: $c188b0b6cf7ccc98$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $c188b0b6cf7ccc98$var$processStyleArg(slotStyle, (0, $65o8X.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $c188b0b6cf7ccc98$var$processStyleArg({
                    variants: themeVariants
                }, (0, $65o8X.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $4d9b9f946ff41bcb$var$styled = (0, $c188b0b6cf7ccc98$export$2e2bcd8739ae039)();
var $4d9b9f946ff41bcb$export$2e2bcd8739ae039 = $4d9b9f946ff41bcb$var$styled;


var $6a423ef368c5058d$exports = {};

$6a423ef368c5058d$exports = (parcelRequire("eDQ3p")).getBundleURL("eOfb6") + "logo.8864f7c9.png";


const $dc76dca562a3565e$var$logo = new URL($6a423ef368c5058d$exports);
const $dc76dca562a3565e$var$MUILogoImage = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)("div")({
    backgroundImage: `url("${$dc76dca562a3565e$var$logo}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "32rem",
    height: "18rem",
    marginBottom: "6rem",
    "@media screen and (orientation: landscape)": {
        marginBottom: "2rem",
        width: "20rem",
        height: "11.25rem"
    }
});
const $dc76dca562a3565e$var$LogoImage = (props)=>(0, $bhfvP.jsx)($dc76dca562a3565e$var$MUILogoImage, Object.assign({}, props));
var $dc76dca562a3565e$export$2e2bcd8739ae039 = $dc76dca562a3565e$var$LogoImage;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $0882abbd7705f7c9$var$SvgAiSparkle = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "328.496 186.769 21 22",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                className: "AISparkle_svg__st0",
                d: "M342.496 208.769c-.5-3.4-1.9-6.5-7-7 5.1-.5 6.5-3.6 7-7 .5 3.4 1.9 6.5 7 7-5.2.5-6.6 3.6-7 7Z",
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                className: "AISparkle_svg__st2",
                d: "M345.896 191.769c-.1-1-.5-1.9-2-2 1.5-.1 1.9-1 2-2 .1 1 .5 1.9 2 2-1.5.1-1.9 1-2 2Zm-11.9 6c-.4-2.7-1.5-5.1-5.5-5.5 4-.4 5.1-2.8 5.5-5.5.4 2.7 1.5 5.1 5.5 5.5-4.1.4-5.2 2.8-5.5 5.5Z",
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
                strokeWidth: 1.8
            })
        ]
    });
var $0882abbd7705f7c9$export$2e2bcd8739ae039 = $0882abbd7705f7c9$var$SvgAiSparkle;



const $fff02e413e096509$var$logo = new URL($6a423ef368c5058d$exports);
const $fff02e413e096509$var$MUIFooterLanguageButton = (0, $e8m2I.default)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        width: "42rem",
        borderRadius: "2rem",
        borderWidth: "0.2rem",
        "&:active": {
            borderWidth: "0.2rem"
        },
        "&:hover": {
            borderWidth: "0.2rem"
        }
    }));
const $fff02e413e096509$var$MUIModalLanguageButton = (0, $e8m2I.default)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(({ theme: theme })=>({
        marginBottom: "1.5rem",
        borderRadius: "2rem",
        borderColor: `${theme.palette.primary.main} !important`
    }));
const $fff02e413e096509$var$MUILanguageModal = (0, $e8m2I.default)("div")(({ theme: theme })=>({
        ".language-modal__content": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.background.default).darken(0.025).hex()
        }
    }));
const $fff02e413e096509$var$ConversationButton = (0, $e8m2I.default)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        position: "absolute",
        right: 0,
        bottom: 0,
        width: "12rem",
        borderRadius: "2rem 0rem 0rem 0rem",
        borderWidth: "0.2rem",
        "&:active": {
            borderWidth: "0.2rem"
        },
        "&:hover": {
            borderWidth: "0.2rem"
        }
    }));
const $fff02e413e096509$var$Footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    var _a, _b, _c, _d;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "language"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const languages = (0, $3adb49bfa33db486$export$38be4353f99148d)();
    const [locale, setLocale] = (0, $3adb49bfa33db486$export$c1fd9f444a3dc711)();
    const [languageModal, setLanguageModal] = (0, $eZVvM.useState)(false);
    const { data: data, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const imageURL = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.logo) === null || _d === void 0 ? void 0 : _d.absolutePath;
    const isAIConversationEnabled = (0, $eZVvM.useMemo)(()=>{
        var _a, _b;
        return ((_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.aiConversation) || false;
    }, []);
    const isConversationPage = (0, $eZVvM.useMemo)(()=>window.location.pathname === "/conversation", [
        window.location.pathname
    ]);
    const renderModalLanguage = (0, $eZVvM.useCallback)((key)=>(0, $bhfvP.jsxs)($fff02e413e096509$var$MUIModalLanguageButton, Object.assign({
            "data-value": key,
            variant: locale === key ? "contained" : "outlined",
            onClick: ()=>{
                setLocale(key);
                setLanguageModal(false);
            },
            className: "border"
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $fc131733a17f1801$export$2e2bcd8739ae039), {
                    name: key,
                    width: "3.2rem",
                    height: "3.2rem",
                    className: "position-absolute start-0 ms-5"
                }),
                t(`language:${key}`)
            ]
        }), key), [
        t,
        locale
    ]);
    const renderLanguage = (0, $eZVvM.useCallback)((key)=>(0, $bhfvP.jsx)($fff02e413e096509$var$MUIFooterLanguageButton, Object.assign({
            "data-value": key,
            variant: locale === key ? "contained" : "outlined",
            onClick: ()=>{
                setLocale(key);
            }
        }, {
            children: t(`language:${key}`)
        }), key), [
        t,
        locale,
        setLocale
    ]);
    const onClose = (0, $eZVvM.useCallback)(()=>{
        setLanguageModal(false);
    }, []);
    return (0, $bhfvP.jsxs)("footer", Object.assign({
        className: "d-flex flex-column align-items-center w-100 position-relative"
    }, {
        children: [
            (0, $bhfvP.jsx)((0, $dc76dca562a3565e$export$2e2bcd8739ae039), {
                style: {
                    backgroundImage: `url("${imageURL !== null && imageURL !== void 0 ? imageURL : $fff02e413e096509$var$logo}")`
                }
            }),
            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                variant: "h4",
                className: "text-center text-secondary font-weight-regular mb-4"
            }, {
                children: t(`language:title`)
            })),
            (0, $bhfvP.jsx)((0, $dd44097e65f4cd5a$export$2e2bcd8739ae039), {
                children: languages.length > 2 ? (0, $bhfvP.jsxs)($fff02e413e096509$var$MUIFooterLanguageButton, Object.assign({
                    variant: "contained",
                    onClick: ()=>setLanguageModal(true)
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $fc131733a17f1801$export$2e2bcd8739ae039), {
                            name: locale,
                            width: "3.2rem",
                            className: "position-absolute start-0 ms-5"
                        }),
                        t(`language:${locale}`)
                    ]
                })) : languages.map(renderLanguage)
            }),
            (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                mode: "wait"
            }, {
                children: languageModal && (0, $bhfvP.jsx)($fff02e413e096509$var$MUILanguageModal, Object.assign({
                    className: "language-modal"
                }, {
                    children: (0, $bhfvP.jsxs)((0, $ljukC.motion).div, Object.assign({}, (0, $4yVoh.anim)((0, $4yVoh.modalUp)), {
                        className: "language-modal__content"
                    }, {
                        children: [
                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h2",
                                className: "text-center pt-5"
                            }, {
                                children: t(`language:title`)
                            })),
                            (0, $bhfvP.jsx)("div", Object.assign({
                                className: "language-modal__list"
                            }, {
                                children: languages.map(renderModalLanguage)
                            })),
                            (0, $bhfvP.jsx)("div", Object.assign({
                                className: "language-modal__close",
                                onClick: onClose
                            }, {
                                children: (0, $bhfvP.jsx)((0, $cRA6X.default), {
                                    width: "6rem"
                                })
                            }))
                        ]
                    }))
                }))
            })),
            isAIConversationEnabled && !isConversationPage && (0, $bhfvP.jsx)($fff02e413e096509$var$ConversationButton, Object.assign({
                variant: "contained",
                onClick: ()=>navigate("/conversation")
            }, {
                children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                    fontSize: "3.6rem"
                }, {
                    children: (0, $bhfvP.jsx)((0, $0882abbd7705f7c9$export$2e2bcd8739ae039), {})
                }))
            }))
        ]
    }));
});
var $fff02e413e096509$export$2e2bcd8739ae039 = $fff02e413e096509$var$Footer;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $e8m2I = parcelRequire("e8m2I");

var $cD0nt = parcelRequire("cD0nt");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9u6aw = parcelRequire("9u6aw");

var $3WZeB = parcelRequire("3WZeB");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $086519bbae812ae3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3WZeB.default)(value, min, max);
}
function $086519bbae812ae3$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $086519bbae812ae3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $086519bbae812ae3$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $086519bbae812ae3$export$677b39864803984e($086519bbae812ae3$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $9u6aw.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $9u6aw.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $086519bbae812ae3$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $086519bbae812ae3$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $086519bbae812ae3$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $086519bbae812ae3$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $086519bbae812ae3$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $086519bbae812ae3$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $086519bbae812ae3$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$086519bbae812ae3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $086519bbae812ae3$export$29fb7152bd3f781a(color) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $086519bbae812ae3$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $086519bbae812ae3$export$c852d90bf7403b62(color) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $086519bbae812ae3$export$677b39864803984e($086519bbae812ae3$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $086519bbae812ae3$export$d061e26956a60b0a(foreground, background) {
    const lumA = $086519bbae812ae3$export$c852d90bf7403b62(foreground);
    const lumB = $086519bbae812ae3$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $086519bbae812ae3$export$58f0f39f63f3cf42(color, value) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    value = $086519bbae812ae3$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $086519bbae812ae3$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$4b073707ff63303(color, coefficient) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    coefficient = $086519bbae812ae3$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$c0816ed86df316af(color, coefficient) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    coefficient = $086519bbae812ae3$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $086519bbae812ae3$export$c852d90bf7403b62(color) > 0.5 ? $086519bbae812ae3$export$4b073707ff63303(color, coefficient) : $086519bbae812ae3$export$c0816ed86df316af(color, coefficient);
}
function $086519bbae812ae3$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $086519bbae812ae3$export$677b39864803984e(background);
    const overlayColor = $086519bbae812ae3$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $086519bbae812ae3$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
function $dc40de7e626e5d14$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $dc40de7e626e5d14$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $dc40de7e626e5d14$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $dc40de7e626e5d14$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $dc40de7e626e5d14$export$2e2bcd8739ae039 = $dc40de7e626e5d14$export$4f5d2d50c9deca37;



var $cgitS = parcelRequire("cgitS");

var $34Ozv = parcelRequire("34Ozv");
var $bU7jb = parcelRequire("bU7jb");


var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9ef1d716f5f043a0$var$_excluded = [
    "className",
    "component"
];
function $9ef1d716f5f043a0$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $cgitS.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $34Ozv.default));
    const Box = /*#__PURE__*/ $eZVvM.forwardRef(function Box(inProps, ref) {
        const theme = (0, $123cc06973765126$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $bU7jb.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $7Z8DW.default)(_extendSxProp, $9ef1d716f5f043a0$var$_excluded);
        return /*#__PURE__*/ (0, $3pI8R.jsx)(BoxRoot, (0, $65o8X.default)({
            as: component,
            ref: ref,
            className: (0, $dc40de7e626e5d14$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $hI2HT = parcelRequire("hI2HT");

var $jcEiP = parcelRequire("jcEiP");

var $hDdqv = parcelRequire("hDdqv");

var $dvQev = parcelRequire("dvQev");
const $0681a36e30dd9b48$var$boxClasses = (0, $dvQev.default)("MuiBox", [
    "root"
]);
var $0681a36e30dd9b48$export$2e2bcd8739ae039 = $0681a36e30dd9b48$var$boxClasses;


"use client";
const $0176c5dd89354b80$var$defaultTheme = (0, $jcEiP.default)();
const $0176c5dd89354b80$var$Box = (0, $9ef1d716f5f043a0$export$2e2bcd8739ae039)({
    themeId: (0, $hDdqv.default),
    defaultTheme: $0176c5dd89354b80$var$defaultTheme,
    defaultClassName: (0, $0681a36e30dd9b48$export$2e2bcd8739ae039).root,
    generateClassName: (0, $hI2HT.default).generate
});
var $0176c5dd89354b80$export$2e2bcd8739ae039 = $0176c5dd89354b80$var$Box;


var $e8m2I = parcelRequire("e8m2I");
var $81BVN = parcelRequire("81BVN");

var $cD0nt = parcelRequire("cD0nt");
const $770e86d7ccc6806c$var$TimeWrapper = (0, $e8m2I.default)((0, $0176c5dd89354b80$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        position: "fixed",
        width: "100%"
    }));
const $770e86d7ccc6806c$var$Time = (0, $e8m2I.default)((0, $81BVN.default))(({ theme: theme })=>({
        minWidth: "28rem",
        padding: "0 5rem",
        fontSize: "6rem",
        borderRadius: "0 0 2rem 2rem",
        borderWidth: "0.2rem",
        display: "flex",
        justifyContent: "center",
        color: theme.palette.common.white
    }));
const $770e86d7ccc6806c$var$formatTime = (number)=>number.toString().padStart(2, "0");
const $770e86d7ccc6806c$var$TimeDisplay = ({ opacity: opacity })=>{
    const [timeString, setTimeString] = (0, $eZVvM.useState)();
    (0, $eZVvM.useEffect)(()=>{
        const interval = setInterval(()=>{
            const date = new Date();
            const currentTimeString = `${$770e86d7ccc6806c$var$formatTime(date.getHours())}:${$770e86d7ccc6806c$var$formatTime(date.getMinutes())}`;
            setTimeString(()=>currentTimeString);
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    if (!timeString) return null;
    return (0, $bhfvP.jsx)($770e86d7ccc6806c$var$Time, Object.assign({
        sx: {
            backgroundColor: (theme)=>{
                if (opacity === 0) return "transparent";
                return (0, $086519bbae812ae3$export$58f0f39f63f3cf42)(theme.palette.common.black, (opacity !== null && opacity !== void 0 ? opacity : 100) / 100);
            }
        }
    }, {
        children: timeString
    }));
};
const $770e86d7ccc6806c$var$Clock = ()=>{
    const clock = (0, $cD0nt.useClock)();
    if (!(clock === null || clock === void 0 ? void 0 : clock.enabled)) return null;
    return (0, $bhfvP.jsx)($770e86d7ccc6806c$var$TimeWrapper, {
        children: (0, $bhfvP.jsx)($770e86d7ccc6806c$var$TimeDisplay, {
            opacity: clock === null || clock === void 0 ? void 0 : clock.opacity
        })
    });
};
var $770e86d7ccc6806c$export$2e2bcd8739ae039 = $770e86d7ccc6806c$var$Clock;


var $e862c03565450e65$exports = {};

$e862c03565450e65$exports = (parcelRequire("eDQ3p")).getBundleURL("eOfb6") + "background.0e8c0738.png";


const $b755228935a0d77c$var$logo = new URL($e862c03565450e65$exports);
const $b755228935a0d77c$var$MUIHeroImage = (0, $e8m2I.default)("header")({
    height: "54.5rem",
    "@media screen and (orientation: landscape)": {
        height: "38rem"
    },
    "& div": {
        height: "100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        "@media screen and (orientation: landscape)": {
            backgroundSize: "100% auto",
            backgroundPosition: "50% 77%"
        }
    }
});
const $b755228935a0d77c$var$Header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    var _a, _b, _c, _d;
    const { data: data, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const imageURL = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.hero) === null || _d === void 0 ? void 0 : _d.absolutePath;
    return (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            (0, $bhfvP.jsx)((0, $770e86d7ccc6806c$export$2e2bcd8739ae039), {}),
            (0, $bhfvP.jsx)($b755228935a0d77c$var$MUIHeroImage, {
                children: (0, $bhfvP.jsx)("div", {
                    className: "h-100 hero__image",
                    style: {
                        backgroundImage: `url("${imageURL !== null && imageURL !== void 0 ? imageURL : $b755228935a0d77c$var$logo}")`
                    }
                })
            }, dataUpdatedAt)
        ]
    });
});
var $b755228935a0d77c$export$2e2bcd8739ae039 = $b755228935a0d77c$var$Header;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");


var $65o8X = parcelRequire("65o8X");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $9bcff6e41ffd69d5$var$isHostComponent(element) {
    return typeof element === "string";
}
var $9bcff6e41ffd69d5$export$2e2bcd8739ae039 = $9bcff6e41ffd69d5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $83048e33da74ce9f$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $65o8X.default)({}, otherProps, {
        ownerState: (0, $65o8X.default)({}, otherProps.ownerState, ownerState)
    });
}
var $83048e33da74ce9f$export$2e2bcd8739ae039 = $83048e33da74ce9f$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $c4f71c307399daa8$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $c4f71c307399daa8$export$2e2bcd8739ae039 = $c4f71c307399daa8$var$resolveComponentProps;



var $65o8X = parcelRequire("65o8X");
function $496b4aec7d03021f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $496b4aec7d03021f$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $496b4aec7d03021f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $496b4aec7d03021f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $496b4aec7d03021f$export$2e2bcd8739ae039 = $496b4aec7d03021f$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $fa9bbc157eb2c0a8$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fa9bbc157eb2c0a8$export$2e2bcd8739ae039 = $fa9bbc157eb2c0a8$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $77ff8b158dc6cef0$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $77ff8b158dc6cef0$export$2e2bcd8739ae039 = $77ff8b158dc6cef0$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $199ddfc215453045$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $496b4aec7d03021f$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $65o8X.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $65o8X.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)((0, $65o8X.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $77ff8b158dc6cef0$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $77ff8b158dc6cef0$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $496b4aec7d03021f$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $65o8X.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $65o8X.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $199ddfc215453045$export$2e2bcd8739ae039 = $199ddfc215453045$var$mergeSlotProps;


"use client";
const $d63981feaa800455$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $d63981feaa800455$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $d63981feaa800455$var$_excluded3 = [
    "component"
];
function $d63981feaa800455$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $7Z8DW.default)(parameters, $d63981feaa800455$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $7Z8DW.default)(externalForwardedProps, $d63981feaa800455$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $c4f71c307399daa8$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $199ddfc215453045$export$2e2bcd8739ae039)((0, $65o8X.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $7Z8DW.default)(_mergeSlotProps.props, $d63981feaa800455$var$_excluded3);
    const ref = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $65o8X.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $83048e33da74ce9f$export$2e2bcd8739ae039)(elementType, (0, $65o8X.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $iDCHz = parcelRequire("iDCHz");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $fe285c32ecd88e3f$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $fe285c32ecd88e3f$export$2e2bcd8739ae039 = $fe285c32ecd88e3f$var$getOverlayAlpha;



var $8C83T = parcelRequire("8C83T");


var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $a73e2fb78f54fe9e$export$29cdb466b9b6f20b(slot) {
    return (0, $8QgsE.default)("MuiPaper", slot);
}
const $a73e2fb78f54fe9e$var$paperClasses = (0, $dvQev.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $a73e2fb78f54fe9e$export$2e2bcd8739ae039 = $a73e2fb78f54fe9e$var$paperClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $08c3c2df346a18c6$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $08c3c2df346a18c6$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $a73e2fb78f54fe9e$export$29cdb466b9b6f20b), classes);
};
const $08c3c2df346a18c6$var$PaperRoot = (0, $e8m2I.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $65o8X.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $65o8X.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $9b0pf.alpha)("#fff", (0, $fe285c32ecd88e3f$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $9b0pf.alpha)("#fff", (0, $fe285c32ecd88e3f$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $08c3c2df346a18c6$var$Paper = /*#__PURE__*/ $eZVvM.forwardRef(function Paper(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $7Z8DW.default)(props, $08c3c2df346a18c6$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $08c3c2df346a18c6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($08c3c2df346a18c6$var$PaperRoot, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref
    }, other));
});
var $08c3c2df346a18c6$export$2e2bcd8739ae039 = $08c3c2df346a18c6$var$Paper;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $21a0aaa51c86f87a$export$69aecd24bc2cf7e3(slot) {
    return (0, $8QgsE.default)("MuiAlert", slot);
}
const $21a0aaa51c86f87a$var$alertClasses = (0, $dvQev.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $21a0aaa51c86f87a$export$2e2bcd8739ae039 = $21a0aaa51c86f87a$var$alertClasses;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");


var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");


var $iDCHz = parcelRequire("iDCHz");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $81fcec22c7c6ebd5$export$5e8702d71474f093(slot) {
    return (0, $8QgsE.default)("MuiIconButton", slot);
}
const $81fcec22c7c6ebd5$var$iconButtonClasses = (0, $dvQev.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $81fcec22c7c6ebd5$export$2e2bcd8739ae039 = $81fcec22c7c6ebd5$var$iconButtonClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b4f1e2b6883d2123$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $b4f1e2b6883d2123$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $iDCHz.default)(color)}`,
            edge && `edge${(0, $iDCHz.default)(edge)}`,
            `size${(0, $iDCHz.default)(size)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $81fcec22c7c6ebd5$export$5e8702d71474f093), classes);
};
const $b4f1e2b6883d2123$var$IconButtonRoot = (0, $e8m2I.default)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $iDCHz.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $iDCHz.default)(ownerState.edge)}`],
            styles[`size${(0, $iDCHz.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $65o8X.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $65o8X.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $65o8X.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $81fcec22c7c6ebd5$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $b4f1e2b6883d2123$var$IconButton = /*#__PURE__*/ $eZVvM.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $7Z8DW.default)(props, $b4f1e2b6883d2123$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $b4f1e2b6883d2123$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b4f1e2b6883d2123$var$IconButtonRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $b4f1e2b6883d2123$export$2e2bcd8739ae039 = $b4f1e2b6883d2123$var$IconButton;


parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $iDCHz = parcelRequire("iDCHz");

var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $2fade45bdc736673$export$c7c50641356bdfa5(slot) {
    return (0, $8QgsE.default)("MuiSvgIcon", slot);
}
const $2fade45bdc736673$var$svgIconClasses = (0, $dvQev.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $2fade45bdc736673$export$2e2bcd8739ae039 = $2fade45bdc736673$var$svgIconClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $1fd924c4c188e5f7$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $1fd924c4c188e5f7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $iDCHz.default)(color)}`,
            `fontSize${(0, $iDCHz.default)(fontSize)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $2fade45bdc736673$export$c7c50641356bdfa5), classes);
};
const $1fd924c4c188e5f7$var$SvgIconRoot = (0, $e8m2I.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $iDCHz.default)(ownerState.color)}`],
            styles[`fontSize${(0, $iDCHz.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $1fd924c4c188e5f7$var$SvgIcon = /*#__PURE__*/ $eZVvM.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $7Z8DW.default)(props, $1fd924c4c188e5f7$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $eZVvM.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $1fd924c4c188e5f7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($1fd924c4c188e5f7$var$SvgIconRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $fmwLG.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $3pI8R.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$1fd924c4c188e5f7$var$SvgIcon.muiName = "SvgIcon";
var $1fd924c4c188e5f7$export$2e2bcd8739ae039 = $1fd924c4c188e5f7$var$SvgIcon;



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $7c53f9f4c83b6b0b$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $1fd924c4c188e5f7$export$2e2bcd8739ae039), (0, $65o8X.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $1fd924c4c188e5f7$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $eZVvM.memo(/*#__PURE__*/ $eZVvM.forwardRef(Component));
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a926ba753c7f46bd$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d7b048ba3ccda7a5$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $e912761aa747c4e6$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $b6e4a26f234550f6$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $12bec17d627bfb46$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9f5b72beddf4b2af$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $9f5b72beddf4b2af$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $iDCHz.default)(color || severity)}`,
            `${variant}${(0, $iDCHz.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $21a0aaa51c86f87a$export$69aecd24bc2cf7e3), classes);
};
const $9f5b72beddf4b2af$var$AlertRoot = (0, $e8m2I.default)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iDCHz.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $9b0pf.darken) : (0, $9b0pf.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $9b0pf.lighten) : (0, $9b0pf.darken);
    return (0, $65o8X.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $21a0aaa51c86f87a$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $21a0aaa51c86f87a$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, $65o8X.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $9f5b72beddf4b2af$var$AlertIcon = (0, $e8m2I.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $9f5b72beddf4b2af$var$AlertMessage = (0, $e8m2I.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $9f5b72beddf4b2af$var$AlertAction = (0, $e8m2I.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $9f5b72beddf4b2af$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a926ba753c7f46bd$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d7b048ba3ccda7a5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $e912761aa747c4e6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $b6e4a26f234550f6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $9f5b72beddf4b2af$var$Alert = /*#__PURE__*/ $eZVvM.forwardRef(function Alert(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $9f5b72beddf4b2af$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $9f5b72beddf4b2af$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $9f5b72beddf4b2af$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $65o8X.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $65o8X.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $d63981feaa800455$export$2e2bcd8739ae039)("closeButton", {
        elementType: (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $d63981feaa800455$export$2e2bcd8739ae039)("closeIcon", {
        elementType: (0, $12bec17d627bfb46$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($9f5b72beddf4b2af$var$AlertRoot, (0, $65o8X.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $9f5b72beddf4b2af$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)(CloseButtonSlot, (0, $65o8X.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $3pI8R.jsx)(CloseIconSlot, (0, $65o8X.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $9f5b72beddf4b2af$export$2e2bcd8739ae039 = $9f5b72beddf4b2af$var$Alert;


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $81BVN = parcelRequire("81BVN");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $793f95c9fe77780b$export$5269a5bce2c2f987(slot) {
    return (0, $8QgsE.default)("MuiAlertTitle", slot);
}
const $793f95c9fe77780b$var$alertTitleClasses = (0, $dvQev.default)("MuiAlertTitle", [
    "root"
]);
var $793f95c9fe77780b$export$2e2bcd8739ae039 = $793f95c9fe77780b$var$alertTitleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $5f8470a21fce7db8$var$_excluded = [
    "className"
];
const $5f8470a21fce7db8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $793f95c9fe77780b$export$5269a5bce2c2f987), classes);
};
const $5f8470a21fce7db8$var$AlertTitleRoot = (0, $e8m2I.default)((0, $81BVN.default), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $5f8470a21fce7db8$var$AlertTitle = /*#__PURE__*/ $eZVvM.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $7Z8DW.default)(props, $5f8470a21fce7db8$var$_excluded);
    const ownerState = props;
    const classes = $5f8470a21fce7db8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($5f8470a21fce7db8$var$AlertTitleRoot, (0, $65o8X.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $fmwLG.default)(classes.root, className)
    }, other));
});
var $5f8470a21fce7db8$export$2e2bcd8739ae039 = $5f8470a21fce7db8$var$AlertTitle;


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $9HTTf = parcelRequire("9HTTf");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");




"use client";
const $903cc469e8b3c0b5$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $903cc469e8b3c0b5$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $7Z8DW.default)(parameters, $903cc469e8b3c0b5$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $c4f71c307399daa8$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $199ddfc215453045$export$2e2bcd8739ae039)((0, $65o8X.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $83048e33da74ce9f$export$2e2bcd8739ae039)(elementType, (0, $65o8X.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $903cc469e8b3c0b5$export$2e2bcd8739ae039 = $903cc469e8b3c0b5$var$useSlotProps;



var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


"use client";
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $4e2553e6b5bfc776$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    $eZVvM.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, "timeout");
        });
    });
    $eZVvM.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $eZVvM.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $eZVvM.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $65o8X.default)({}, (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(parameters), (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(externalProps));
        return (0, $65o8X.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $4e2553e6b5bfc776$export$2e2bcd8739ae039 = $4e2553e6b5bfc776$var$useSnackbar;



var $eZVvM = parcelRequire("eZVvM");

function $f99b0b65b9b991aa$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $5b7a50565d709b45$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $5b7a50565d709b45$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $5b7a50565d709b45$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $eZVvM.useRef(false);
    const nodeRef = $eZVvM.useRef(null);
    const activatedRef = $eZVvM.useRef(false);
    const syntheticEventRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $5b7a50565d709b45$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $eZVvM.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $5b7a50565d709b45$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $eZVvM.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $5b7a50565d709b45$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: /*#__PURE__*/ $eZVvM.cloneElement(children, childrenProps)
    });
}



var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $iDCHz = parcelRequire("iDCHz");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c673d3c31a06f300$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $c673d3c31a06f300$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $c673d3c31a06f300$var$styles = {
    entering: {
        opacity: 1,
        transform: $c673d3c31a06f300$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $c673d3c31a06f300$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $c673d3c31a06f300$var$Grow = /*#__PURE__*/ $eZVvM.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $c673d3c31a06f300$var$_excluded);
    const timer = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    const autoTimeout = $eZVvM.useRef();
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const nodeRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $c673d3c31a06f300$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $c673d3c31a06f300$var$isWebKit154 ? duration : duration * 0.666,
                delay: $c673d3c31a06f300$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $c673d3c31a06f300$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                style: (0, $65o8X.default)({
                    opacity: 0,
                    transform: $c673d3c31a06f300$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $c673d3c31a06f300$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$c673d3c31a06f300$var$Grow.muiSupportAuto = true;
var $c673d3c31a06f300$export$2e2bcd8739ae039 = $c673d3c31a06f300$var$Grow;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");


var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $5252cdc0c67e5f55$export$def81488db1a3216(slot) {
    return (0, $8QgsE.default)("MuiSnackbarContent", slot);
}
const $5252cdc0c67e5f55$var$snackbarContentClasses = (0, $dvQev.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $5252cdc0c67e5f55$export$2e2bcd8739ae039 = $5252cdc0c67e5f55$var$snackbarContentClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $8238c2fc66c9a170$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $8238c2fc66c9a170$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $5252cdc0c67e5f55$export$def81488db1a3216), classes);
};
const $8238c2fc66c9a170$var$SnackbarContentRoot = (0, $e8m2I.default)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $9b0pf.emphasize)(theme.palette.background.default, emphasis);
    return (0, $65o8X.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $8238c2fc66c9a170$var$SnackbarContentMessage = (0, $e8m2I.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $8238c2fc66c9a170$var$SnackbarContentAction = (0, $e8m2I.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $8238c2fc66c9a170$var$SnackbarContent = /*#__PURE__*/ $eZVvM.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $7Z8DW.default)(props, $8238c2fc66c9a170$var$_excluded);
    const ownerState = props;
    const classes = $8238c2fc66c9a170$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($8238c2fc66c9a170$var$SnackbarContentRoot, (0, $65o8X.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($8238c2fc66c9a170$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $3pI8R.jsx)($8238c2fc66c9a170$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $8238c2fc66c9a170$export$2e2bcd8739ae039 = $8238c2fc66c9a170$var$SnackbarContent;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $ffaba9ddbc2c83d9$export$6cb096457f5926f4(slot) {
    return (0, $8QgsE.default)("MuiSnackbar", slot);
}
const $ffaba9ddbc2c83d9$var$snackbarClasses = (0, $dvQev.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $ffaba9ddbc2c83d9$export$2e2bcd8739ae039 = $ffaba9ddbc2c83d9$var$snackbarClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9e69d8ac72f40e0c$var$_excluded = [
    "onEnter",
    "onExited"
], $9e69d8ac72f40e0c$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $9e69d8ac72f40e0c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $iDCHz.default)(anchorOrigin.vertical)}${(0, $iDCHz.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $ffaba9ddbc2c83d9$export$6cb096457f5926f4), classes);
};
const $9e69d8ac72f40e0c$var$SnackbarRoot = (0, $e8m2I.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $iDCHz.default)(ownerState.anchorOrigin.vertical)}${(0, $iDCHz.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $65o8X.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $65o8X.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $9e69d8ac72f40e0c$var$Snackbar = /*#__PURE__*/ $eZVvM.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $c673d3c31a06f300$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $9e69d8ac72f40e0c$var$_excluded), other = (0, $7Z8DW.default)(props, $9e69d8ac72f40e0c$var$_excluded2);
    const ownerState = (0, $65o8X.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $9e69d8ac72f40e0c$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $4e2553e6b5bfc776$export$2e2bcd8739ae039)((0, $65o8X.default)({}, ownerState));
    const [exited, setExited] = $eZVvM.useState(true);
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: $9e69d8ac72f40e0c$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5b7a50565d709b45$export$58385c17fee43f89), (0, $65o8X.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($9e69d8ac72f40e0c$var$SnackbarRoot, (0, $65o8X.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8238c2fc66c9a170$export$2e2bcd8739ae039), (0, $65o8X.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $9e69d8ac72f40e0c$export$2e2bcd8739ae039 = $9e69d8ac72f40e0c$var$Snackbar;


var $81BVN = parcelRequire("81BVN");

var $e8m2I = parcelRequire("e8m2I");

var $219y6 = parcelRequire("219y6");

var $cD0nt = parcelRequire("cD0nt");
const $c2e305494bbce9cc$var$StyledSnackbar = (0, $e8m2I.default)((0, $9e69d8ac72f40e0c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        right: 0,
        bottom: 0,
        left: 0,
        [theme.breakpoints.up("sm")]: {
            right: 0,
            bottom: 0,
            left: 0
        }
    }));
const $c2e305494bbce9cc$var$OfflineAlert = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "offline"
    ]);
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    const isRoot = pathname === "/";
    return (0, $bhfvP.jsx)($c2e305494bbce9cc$var$StyledSnackbar, Object.assign({
        open: !(online || !isRoot),
        sx: {
            right: 0,
            bottom: 0,
            left: 0
        }
    }, {
        children: (0, $bhfvP.jsxs)((0, $9f5b72beddf4b2af$export$2e2bcd8739ae039), Object.assign({
            severity: "error",
            sx: {
                "& .MuiAlert-icon": {
                    fontSize: "8rem"
                }
            }
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $5f8470a21fce7db8$export$2e2bcd8739ae039), Object.assign({
                    sx: {
                        fontSize: "5rem"
                    }
                }, {
                    children: t("offline:title")
                })),
                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                    variant: "h2"
                }, {
                    children: t("offline:receptionMessage")
                })),
                receptionistPhone && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                    variant: "h2"
                }, {
                    children: t("offline:check", {
                        receptionistPhone: receptionistPhone
                    })
                }))
            ]
        }))
    }));
};
var $c2e305494bbce9cc$export$2e2bcd8739ae039 = $c2e305494bbce9cc$var$OfflineAlert;



var $bhfvP = parcelRequire("bhfvP");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");



var $e8m2I = parcelRequire("e8m2I");

var $81BVN = parcelRequire("81BVN");

var $ljukC = parcelRequire("ljukC");

var $34EAI = parcelRequire("34EAI");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $cb55aa05ae3abc5a$var$SvgCheckIn = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('34cb41a7f0e15623')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M26.38 36.192H3.784a1.785 1.785 0 0 1 0-3.568H26.38a1.785 1.785 0 0 1 0 3.568Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M17.174 45.818a1.902 1.902 0 0 1-1.344-3.247l8.164-8.163-8.163-8.161a1.902 1.902 0 0 1 2.69-2.69l9.506 9.507a1.902 1.902 0 0 1 0 2.69L18.52 45.26c-.372.373-.86.558-1.346.558ZM40.666 80A6.673 6.673 0 0 1 34 73.335v-60a6.71 6.71 0 0 1 4.513-6.33L58.54.327c4.48-1.373 8.793 1.95 8.793 6.34v60a6.712 6.712 0 0 1-4.51 6.327l-20.033 6.68a6.976 6.976 0 0 1-2.124.327Zm20-75c-.216 0-.4.028-.596.087l-19.943 6.65A1.719 1.719 0 0 0 39 13.334v60c0 1.137 1.233 1.903 2.263 1.58l19.943-6.65a1.724 1.724 0 0 0 1.127-1.596v-60A1.67 1.67 0 0 0 60.666 5Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16.5 16.667a2.5 2.5 0 0 1-2.5-2.5v-5C14 4.11 18.11 0 23.166 0h37.5a2.5 2.5 0 0 1 0 5h-37.5A4.172 4.172 0 0 0 19 9.167v5a2.5 2.5 0 0 1-2.5 2.5ZM36.5 70H23.166C18.11 70 14 65.89 14 60.833v-5a2.5 2.5 0 0 1 5 0v5A4.172 4.172 0 0 0 23.166 65H36.5a2.5 2.5 0 0 1 0 5Z"
                })
            ]
        })
    });
var $cb55aa05ae3abc5a$export$2e2bcd8739ae039 = $cb55aa05ae3abc5a$var$SvgCheckIn;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $04e6c4987292f3cf$var$SvgCheckOut = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('ee6f29dd85baa145')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M49.953 36.192H72.55a1.785 1.785 0 0 0 0-3.568H49.953a1.785 1.785 0 0 0 0 3.568Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M62.9 45.818a1.902 1.902 0 0 1-1.344-3.247l8.164-8.163-8.163-8.161a1.902 1.902 0 0 1 2.69-2.69l9.507 9.507a1.902 1.902 0 0 1 0 2.69l-9.507 9.506c-.373.373-.86.558-1.346.558ZM37.667 80a6.673 6.673 0 0 0 6.666-6.666v-60a6.709 6.709 0 0 0-4.513-6.33L19.793.327C15.313-1.046 11 2.277 11 6.667v60a6.712 6.712 0 0 0 4.51 6.327l20.033 6.68c.73.227 1.407.327 2.124.327Zm-20-75c.216 0 .4.028.596.087l19.943 6.65a1.719 1.719 0 0 1 1.127 1.597v60c0 1.137-1.233 1.903-2.263 1.58l-19.943-6.65A1.724 1.724 0 0 1 16 66.668v-60A1.67 1.67 0 0 1 17.667 5Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M61.833 16.667a2.5 2.5 0 0 0 2.5-2.5v-5C64.333 4.11 60.223 0 55.167 0h-37.5a2.5 2.5 0 0 0 0 5h37.5a4.172 4.172 0 0 1 4.166 4.167v5a2.5 2.5 0 0 0 2.5 2.5ZM41.833 70h13.334c5.056 0 9.166-4.11 9.166-9.167v-5a2.5 2.5 0 0 0-5 0v5A4.172 4.172 0 0 1 55.167 65H41.833a2.5 2.5 0 0 0 0 5Z"
                })
            ]
        })
    });
var $04e6c4987292f3cf$export$2e2bcd8739ae039 = $04e6c4987292f3cf$var$SvgCheckOut;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $930fa341f898fffa$var$SvgFood = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('244df584b480ef85')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M77.656 37.5h-2.5V20.613a8.511 8.511 0 0 0-3.906-7.186V2.344A2.344 2.344 0 0 0 68.906 0h-9.375a2.344 2.344 0 0 0-2.343 2.344v11.083a8.511 8.511 0 0 0-3.907 7.186V25h-4.687v-.781a2.33 2.33 0 0 0-.387-1.288l-.007-.012-.004-.007-.005-.006-5.847-8.772V5.47A2.344 2.344 0 0 0 40 3.125H24.519A11.672 11.672 0 0 0 16.563 0C10.1 0 4.842 5.257 4.842 11.719V37.5h-2.5A2.344 2.344 0 0 0 0 39.844v9.375a2.344 2.344 0 0 0 2.344 2.343h1.18l2.284 20.783A8.583 8.583 0 0 0 14.351 80h51.298c4.39 0 8.063-3.29 8.543-7.655l2.283-20.782h1.181A2.344 2.344 0 0 0 80 49.218v-9.375a2.344 2.344 0 0 0-2.344-2.344ZM61.875 4.687h4.688v3.125h-4.688V4.688Zm-3.906 15.926c0-1.591.955-3.002 2.433-3.593a2.343 2.343 0 0 0 1.473-2.176V12.5h4.688v2.344c0 .958.583 1.82 1.473 2.176a3.852 3.852 0 0 1 2.433 3.593V37.5h-12.5V20.613Zm-4.688 9.075V37.5h-4.687v-7.813h4.687Zm-9.375-3.125V37.5H28.281V26.562h15.625Zm-2.035-4.688H28.28v-4.688h10.465l3.125 4.688ZM37.656 7.812V12.5h-9.375v-.781c0-1.37-.238-2.684-.672-3.906h10.047Zm-28.125 25H15a2.344 2.344 0 0 0 0-4.687H9.531v-4.688H15a2.344 2.344 0 0 0 0-4.687H9.531v-4.688H15a2.344 2.344 0 0 0 0-4.687H9.934c.968-2.728 3.573-4.688 6.629-4.688a7.04 7.04 0 0 1 7.03 7.032V37.5H9.532v-4.688Zm-4.844 9.376h70.626v4.687H4.686v-4.688Zm64.845 29.645a3.901 3.901 0 0 1-3.883 3.48H14.351a3.902 3.902 0 0 1-3.883-3.48L8.24 51.563h63.52l-2.228 20.27Z"
            })
        })
    });
var $930fa341f898fffa$export$2e2bcd8739ae039 = $930fa341f898fffa$var$SvgFood;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $b81cb4882ba767c6$var$SvgParcel = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M68.653 2H10.347a8.535 8.535 0 0 0-5.9 2.447A8.333 8.333 0 0 0 2 10.348v58.306A8.358 8.358 0 0 0 10.348 77h58.305A8.358 8.358 0 0 0 77 68.653V10.347A8.358 8.358 0 0 0 68.653 2ZM49.5 7v21.308L43 25.71a9.375 9.375 0 0 0-7 0l-6.5 2.598V7h20ZM72 68.653A3.352 3.352 0 0 1 68.653 72H10.347A3.352 3.352 0 0 1 7 68.653V10.347A3.352 3.352 0 0 1 10.348 7H24.5v25a2.502 2.502 0 0 0 3.43 2.322l9.925-3.972a4.393 4.393 0 0 1 3.29 0l9.925 3.97A2.5 2.5 0 0 0 54.5 32V7h14.153A3.353 3.353 0 0 1 72 10.348v58.305Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M12 53h10a2.5 2.5 0 0 0 0-5H12a2.5 2.5 0 0 0 0 5ZM32 58H12a2.5 2.5 0 0 0 0 5h20a2.5 2.5 0 0 0 0-5Z"
            })
        ]
    });
var $b81cb4882ba767c6$export$2e2bcd8739ae039 = $b81cb4882ba767c6$var$SvgParcel;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $88bc8aefc62faa68$var$SvgCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('9c117f4f3b274fd8')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.808 11.685c-.384-.4-.848-.615-1.34-.615-.488 0-.956.21-1.356.611l-1.254 1.25c-.103-.056-.206-.108-.305-.16a5.032 5.032 0 0 1-.392-.21c-1.174-.745-2.24-1.717-3.264-2.974-.496-.626-.829-1.154-1.07-1.689.324-.297.626-.607.92-.904.11-.111.221-.226.332-.337.833-.833.833-1.912 0-2.744L6.997 2.83c-.123-.123-.25-.25-.369-.377-.238-.246-.488-.5-.746-.737-.384-.38-.844-.583-1.328-.583-.484 0-.952.202-1.348.583l-.008.008-1.349 1.36a2.901 2.901 0 0 0-.86 1.844c-.095 1.158.246 2.236.508 2.942.642 1.733 1.602 3.34 3.033 5.06a18.66 18.66 0 0 0 6.214 4.866c.912.432 2.13.944 3.49 1.031.083.004.17.008.25.008.916 0 1.685-.33 2.288-.983.004-.008.012-.012.016-.02.206-.25.444-.476.694-.718.17-.163.345-.333.515-.512.393-.408.599-.884.599-1.372 0-.491-.21-.963-.61-1.36l-2.178-2.185Zm1.42 4.176c-.004 0-.004.004 0 0-.155.166-.313.317-.484.484-.258.245-.52.503-.765.793-.4.428-.873.63-1.491.63-.06 0-.123 0-.183-.004-1.178-.075-2.272-.535-3.093-.928a17.616 17.616 0 0 1-5.853-4.584c-1.352-1.63-2.256-3.137-2.855-4.754C2.135 6.51 2 5.74 2.06 5.015a1.82 1.82 0 0 1 .547-1.178l1.352-1.352c.194-.182.4-.281.603-.281.25 0 .452.15.579.277l.012.012c.242.226.472.46.714.71l.376.384L7.326 4.67c.42.42.42.809 0 1.23-.115.114-.226.23-.341.34-.333.341-.65.659-.995.968-.008.008-.016.012-.02.02-.341.34-.278.674-.207.9l.012.036c.282.682.678 1.324 1.281 2.09l.004.004c1.095 1.348 2.249 2.399 3.522 3.204.162.103.329.186.487.265.143.072.278.14.393.21.016.008.032.02.048.028a.86.86 0 0 0 .392.1c.33 0 .536-.207.603-.274l1.356-1.356c.135-.135.35-.298.599-.298.246 0 .448.155.571.29l.008.008 2.185 2.185c.408.404.408.82.004 1.24ZM11.113 4.515a5.029 5.029 0 0 1 2.736 1.42 5.055 5.055 0 0 1 1.42 2.736c.043.262.27.444.527.444.032 0 .06-.004.091-.008a.536.536 0 0 0 .44-.618 6.116 6.116 0 0 0-1.717-3.312A6.116 6.116 0 0 0 11.3 3.46a.538.538 0 0 0-.619.437.53.53 0 0 0 .433.618ZM19.726 8.334A10.063 10.063 0 0 0 16.9 2.881 10.062 10.062 0 0 0 11.446.054a.533.533 0 0 0-.615.436.538.538 0 0 0 .44.619 9.01 9.01 0 0 1 4.874 2.526 8.984 8.984 0 0 1 2.526 4.874c.044.261.27.444.528.444.031 0 .06-.004.09-.008a.525.525 0 0 0 .437-.61Z"
            })
        })
    });
var $88bc8aefc62faa68$export$2e2bcd8739ae039 = $88bc8aefc62faa68$var$SvgCall;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $a41e9611bd61d575$var$SvgNoAppointment = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 122.84 122.88",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M81.49 4.71c0-2.62 2.58-4.71 5.77-4.71 3.2 0 5.77 2.13 5.77 4.71V25.4c0 2.62-2.58 4.71-5.77 4.71-3.2 0-5.77-2.13-5.77-4.71V4.71zM51.43 99.74c-1.24 1.33-3.33 1.42-4.71.18-1.33-1.24-1.42-3.33-.18-4.71l10.35-11.06-11.06-10.3c-1.33-1.24-1.42-3.33-.18-4.71 1.24-1.33 3.33-1.42 4.71-.18l11.06 10.35 10.3-11.06c1.24-1.33 3.33-1.42 4.71-.18 1.33 1.24 1.42 3.33.18 4.71L66.26 83.84l11.06 10.35c1.33 1.24 1.42 3.33.18 4.71-1.24 1.33-3.33 1.42-4.71.18L61.73 88.73 51.38 99.79l.05-.05zM29.53 4.71C29.53 2.09 32.11 0 35.3 0c3.2 0 5.77 2.13 5.77 4.71V25.4c0 2.62-2.58 4.71-5.77 4.71-3.2 0-5.77-2.13-5.77-4.71V4.71zM6.35 45.3H116.4V21.45c0-.8-.31-1.55-.84-2.04-.53-.53-1.24-.84-2.04-.84h-10.53c-1.78 0-3.2-1.42-3.2-3.2 0-1.78 1.42-3.2 3.2-3.2h10.53c2.58 0 4.88 1.07 6.57 2.75 1.69 1.69 2.75 4.04 2.75 6.57v92.06c0 2.58-1.07 4.88-2.75 6.57-1.69 1.69-4.04 2.75-6.57 2.75H9.34c-2.58 0-4.88-1.07-6.57-2.75-1.7-1.68-2.77-4.04-2.77-6.57V21.49c0-2.58 1.07-4.88 2.75-6.57 1.69-1.69 4.04-2.75 6.57-2.75H20.6c1.78 0 3.2 1.42 3.2 3.2 0 1.78-1.42 3.2-3.2 3.2H9.33c-.8 0-1.55.31-2.09.84-.53.53-.84 1.24-.84 2.09v23.85l-.05-.05zm110.05 6.39H6.35v61.82c0 .8.31 1.55.84 2.09.53.53 1.24.84 2.09.84h104.18c.8 0 1.55-.31 2.09-.84.53-.53.84-1.24.84-2.09V51.69h.01zM50.36 18.52c-1.78 0-3.2-1.42-3.2-3.2 0-1.78 1.42-3.2 3.2-3.2h21.49c1.78 0 3.2 1.42 3.2 3.2 0 1.78-1.42 3.2-3.2 3.2H50.36z"
        })
    });
var $a41e9611bd61d575$export$2e2bcd8739ae039 = $a41e9611bd61d575$var$SvgNoAppointment;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $2865f1f1d57bf7c5$var$SvgOverview = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M214.5 10h-173C37.1 10 10 10 10 41.5v173.1C10 246 41.5 246 41.5 246h173.1c31.5 0 31.5-31.5 31.5-31.5v-173C246 10 218.9 10 214.5 10zm15.8 204.5s0 15.7-15.7 15.7H41.5s-15.7 0-15.7-15.7v-173c0-15.7 11.4-15.7 15.7-15.7h173.1c4.3 0 15.7 0 15.7 15.7v173zM59.4 88.7h137V72.9h-137v15.8zm0 47.2h137v-15.7h-137v15.7zm0 47.2h137v-15.7h-137v15.7z"
        })
    });
var $2865f1f1d57bf7c5$export$2e2bcd8739ae039 = $2865f1f1d57bf7c5$var$SvgOverview;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $102d9630099e4e02$var$SvgWifi = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "Wifi_svg__bi Wifi_svg__bi-wifi",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.384 6.115a.485.485 0 0 0-.047-.736A12.44 12.44 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M13.229 8.271a.482.482 0 0 0-.063-.745A9.46 9.46 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065m-2.183 2.183c.226-.226.185-.605-.1-.75A6.5 6.5 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.5 5.5 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091zM9.06 12.44c.196-.196.198-.52-.04-.66A2 2 0 0 0 8 11.5a2 2 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"
            })
        ]
    });
var $102d9630099e4e02$export$2e2bcd8739ae039 = $102d9630099e4e02$var$SvgWifi;



var $8YEKz = parcelRequire("8YEKz");

var $bzcXF = parcelRequire("bzcXF");

var $ezhXm = parcelRequire("ezhXm");

var $6CFWV = parcelRequire("6CFWV");

var $cD0nt = parcelRequire("cD0nt");

var $219y6 = parcelRequire("219y6");
const $e9f2e051dd9c1e05$var$WifiButton = (0, $e8m2I.default)((0, $ljukC.motion).button)(({ theme: theme })=>({
        position: "absolute",
        right: "3rem",
        bottom: "21rem",
        display: "flex",
        alignItems: "center",
        margin: "2rem",
        padding: "2.5rem 3rem",
        borderRadius: "0.5rem",
        backgroundColor: theme.palette.primary.main,
        zIndex: 1000,
        svg: {
            fill: theme.palette.background.default,
            marginRight: "2rem"
        },
        h4: {
            color: theme.palette.background.default
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: theme.palette.grey[400]
        },
        "@media screen and (orientation: landscape)": {
            bottom: "14rem"
        }
    }));
const $e9f2e051dd9c1e05$export$f8129065ddb0063d = (0, $e8m2I.default)("div")({
    maxWidth: "90.4rem",
    width: "96%",
    display: "flex",
    flexDirection: "column",
    padding: "4.8rem 0",
    "@media screen and (orientation: landscape)": {
        maxWidth: "180.8rem",
        flexDirection: "row",
        padding: "0",
        "> div": {
            width: "50%"
        }
    }
});
const $e9f2e051dd9c1e05$var$HomeGrid = (0, $e8m2I.default)((0, $23610b7fd899719e$export$2e2bcd8739ae039))({
    height: "68%",
    margin: "3rem",
    alignItems: "stretch",
    "@media screen and (orientation: landscape)": {
        margin: "0",
        height: "80%"
    }
});
const $e9f2e051dd9c1e05$export$303a06dd7cf7ccd0 = (0, $e8m2I.default)((0, $ljukC.motion).button)(({ theme: theme })=>({
        display: "block",
        width: "40rem",
        margin: "3.2rem",
        padding: "4rem 1.5rem",
        borderRadius: "1rem",
        backgroundColor: theme.palette.primary.main,
        svg: {
            fill: theme.palette.background.default,
            marginBottom: "3.2rem"
        },
        h2: {
            color: theme.palette.background.default
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: theme.palette.grey[400]
        },
        "@media screen and (orientation: landscape)": {
            margin: "0 3.2rem"
        }
    }));
const $e9f2e051dd9c1e05$export$df8147d39a367a0e = (0, $e8m2I.default)((0, $ljukC.motion).button)(({ theme: theme })=>({
        margin: "2rem auto",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1rem",
        borderRadius: "1rem",
        backgroundColor: theme.palette.primary.main,
        width: "65%",
        svg: {
            fill: theme.palette.background.default,
            position: "absolute",
            left: "4rem"
        },
        h3: {
            color: theme.palette.background.default
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "@media screen and (orientation: landscape)": {
            width: "30%",
            margin: "0.5rem 3rem",
            maxWidth: "70rem"
        }
    }));
const $e9f2e051dd9c1e05$var$HomePage = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { width: width, height: height } = (0, $34EAI.default)();
    const orientation = width < height ? "portrait" : "landscape";
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = pathname === "/";
    const { data: data, isLoading: isLoading } = (0, $cD0nt.default)();
    const { t: t } = (0, $9GLBV.useTranslation)([
        "home"
    ]);
    const { online: online } = (0, $219y6.useOfflineContext)();
    const { welcomeMessage: welcomeMessage, checkin: checkin, independentManualCheckin: independentManualCheckin, integratedManualCheckin: integratedManualCheckin, checkout: checkout, manualCheckout: manualCheckout, packageDelivery: packageDelivery, foodDelivery: foodDelivery, callReception: callReception, overview: overview, wifi: wifi } = (0, $cD0nt.useLayout)();
    const welcomeMessageText = (welcomeMessage === null || welcomeMessage === void 0 ? void 0 : welcomeMessage.text) || t("home:welcomeMessage");
    const checkinText = (checkin === null || checkin === void 0 ? void 0 : checkin.text) || t("home:checkIn");
    const independentManualCheckinText = (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.text) || t("home:independentManualCheckIn");
    const checkoutText = (checkout === null || checkout === void 0 ? void 0 : checkout.text) || t("home:checkOut");
    const manualCheckoutText = (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.text) || t("home:manualCheckOut");
    const packageDeliveryText = (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.text) || t("home:parcelDelivery");
    const foodDeliveryText = (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.text) || t("home:foodDelivery");
    const callReceptionText = (callReception === null || callReception === void 0 ? void 0 : callReception.text) || t("home:callReception");
    const overviewText = (overview === null || overview === void 0 ? void 0 : overview.text) || t("home:overview");
    const wifiText = (wifi === null || wifi === void 0 ? void 0 : wifi.text) || "Wi-Fi";
    const moreThan4Buttons = [
        checkin === null || checkin === void 0 ? void 0 : checkin.enabled,
        independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled,
        (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled),
        packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled,
        foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled,
        callReception === null || callReception === void 0 ? void 0 : callReception.enabled,
        overview === null || overview === void 0 ? void 0 : overview.enabled
    ].filter(Boolean).length > 4; // usePageTracking({
    //   page: "home",
    // });
    // const { trackEvent } = useEventTracking();
    (0, $6CFWV.default)(()=>{
        // we check the pathname for a trailing slash
        // because of service worker scope issue
        // https://github.com/w3c/ServiceWorker/issues/1272
        //
        // if there is no trailing slash, we redirect the user
        if (window.location.pathname.endsWith("/")) {
            window.location.reload();
            return;
        }
        window.location.href = `${window.location.pathname}/`;
    }, 300000); // useEffect(() => {
    //   if (isDev) {
    //     return;
    //   }
    //
    //   navigate(`${pathname}/`, { replace: true });
    // }, []);
    if (!data && !isLoading) return (0, $bhfvP.jsx)((0, $0176c5dd89354b80$export$2e2bcd8739ae039), Object.assign({
        className: "d-flex align-items-center justify-content-center h-100"
    }, {
        children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
            variant: "h1"
        }, {
            children: t("home:unavailable")
        }))
    }));
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column h-100"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                        className: "p-0 mx-3",
                        disableAnimation: !mainRoute
                    }, {
                        children: (welcomeMessage === null || welcomeMessage === void 0 ? void 0 : welcomeMessage.enabled) && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h1"
                        }, {
                            children: welcomeMessageText
                        }))
                    })),
                    (0, $bhfvP.jsx)($e9f2e051dd9c1e05$var$HomeGrid, Object.assign({
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: orientation === "landscape" ? 4 : 0
                    }, {
                        children: !moreThan4Buttons ? (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return navigate("/access/option/checkin", {
                                                replace: true
                                            });
                                            return navigate("/access/checkin", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: checkinText
                                            }))
                                        ]
                                    }))
                                })),
                                (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            return navigate("/access/checkin/manual", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $a41e9611bd61d575$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: independentManualCheckinText
                                            }))
                                        ]
                                    }))
                                })),
                                ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkout" });
                                            if ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return navigate("/access/option/checkout", {
                                                replace: true
                                            });
                                            if (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled) return navigate("/access/checkout/manual", {
                                                replace: true
                                            });
                                            return navigate("/access/checkout", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $04e6c4987292f3cf$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? checkoutText : manualCheckoutText
                                            }))
                                        ]
                                    }))
                                })),
                                (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "package" });
                                            if (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.isCustom) return navigate("/custom-delivery/package", {
                                                replace: true
                                            });
                                            return navigate("/delivery/package", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $b81cb4882ba767c6$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: packageDeliveryText
                                            }))
                                        ]
                                    }))
                                })),
                                (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "food" });
                                            if (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.isCustom) return navigate("/custom-delivery/food", {
                                                replace: true
                                            });
                                            return navigate("/delivery/food", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $930fa341f898fffa$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: foodDeliveryText
                                            }))
                                        ]
                                    }))
                                })),
                                (overview === null || overview === void 0 ? void 0 : overview.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        onClick: ()=>{
                                            return navigate("/overview", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $2865f1f1d57bf7c5$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: overviewText
                                            }))
                                        ]
                                    }))
                                })),
                                (callReception === null || callReception === void 0 ? void 0 : callReception.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$303a06dd7cf7ccd0, Object.assign({
                                        disabled: !online,
                                        onClick: ()=>{
                                            return navigate("/contact/reception/call", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $88bc8aefc62faa68$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h2"
                                            }, {
                                                children: callReceptionText
                                            }))
                                        ]
                                    }))
                                }))
                            ]
                        }) : (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return navigate("/access/option/checkin", {
                                                replace: true
                                            });
                                            return navigate("/access/checkin", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: checkinText
                                            }))
                                        ]
                                    }))
                                })),
                                (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            return navigate("/access/checkin/manual", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $a41e9611bd61d575$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: independentManualCheckinText
                                            }))
                                        ]
                                    }))
                                })),
                                ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkout" });
                                            if ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return navigate("/access/option/checkout", {
                                                replace: true
                                            });
                                            if (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled) return navigate("/access/checkout/manual", {
                                                replace: true
                                            });
                                            return navigate("/access/checkout", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $04e6c4987292f3cf$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? checkoutText : manualCheckoutText
                                            }))
                                        ]
                                    }))
                                })),
                                (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "package" });
                                            if (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.isCustom) return navigate("/custom-delivery/package", {
                                                replace: true
                                            });
                                            return navigate("/delivery/package", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $b81cb4882ba767c6$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: packageDeliveryText
                                            }))
                                        ]
                                    }))
                                })),
                                (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "food" });
                                            if (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.isCustom) return navigate("/custom-delivery/food", {
                                                replace: true
                                            });
                                            return navigate("/delivery/food", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $930fa341f898fffa$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: foodDeliveryText
                                            }))
                                        ]
                                    }))
                                })),
                                (overview === null || overview === void 0 ? void 0 : overview.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            return navigate("/overview", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $2865f1f1d57bf7c5$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: overviewText
                                            }))
                                        ]
                                    }))
                                })),
                                (callReception === null || callReception === void 0 ? void 0 : callReception.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                    disabled: !mainRoute
                                }, {
                                    children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$export$df8147d39a367a0e, Object.assign({
                                        onClick: ()=>{
                                            return navigate("/contact/reception/call", {
                                                replace: true
                                            });
                                        }
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)((0, $88bc8aefc62faa68$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h3"
                                            }, {
                                                children: callReceptionText
                                            }))
                                        ]
                                    }))
                                }))
                            ]
                        })
                    })),
                    (wifi === null || wifi === void 0 ? void 0 : wifi.enabled) && (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                        disabled: !mainRoute
                    }, {
                        children: (0, $bhfvP.jsxs)($e9f2e051dd9c1e05$var$WifiButton, Object.assign({
                            onClick: ()=>{
                                navigate("/wifi", {
                                    replace: true
                                });
                            }
                        }, {
                            children: [
                                (0, $bhfvP.jsx)((0, $102d9630099e4e02$export$2e2bcd8739ae039), {
                                    width: "5.5rem"
                                }),
                                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                    variant: "h4"
                                }, {
                                    children: wifiText
                                }))
                            ]
                        }))
                    }))
                ]
            })),
            (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $e9f2e051dd9c1e05$export$2e2bcd8739ae039 = $e9f2e051dd9c1e05$var$HomePage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $e8m2I = parcelRequire("e8m2I");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");
function $d7e92066a4c80f19$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $d7e92066a4c80f19$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $d7e92066a4c80f19$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $d7e92066a4c80f19$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d7e92066a4c80f19$export$2e2bcd8739ae039 = $d7e92066a4c80f19$export$4f5d2d50c9deca37;



var $2EcOP = parcelRequire("2EcOP");

var $ljukC = parcelRequire("ljukC");
var $e93d02b5708fd941$exports = {};

var $j65fp = parcelRequire("j65fp");
var $17632f4d9fdf581d$exports = {};

var $hrfQh = parcelRequire("hrfQh");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $17632f4d9fdf581d$var$castFunction(value) {
    return typeof value == "function" ? value : $hrfQh;
}
$17632f4d9fdf581d$exports = $17632f4d9fdf581d$var$castFunction;


var $97229332f73e6ab6$exports = {};

var $bSLev = parcelRequire("bSLev");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $97229332f73e6ab6$var$toInteger(value) {
    var result = $bSLev(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$97229332f73e6ab6$exports = $97229332f73e6ab6$var$toInteger;


/** Used as references for various `Number` constants. */ var $e93d02b5708fd941$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $e93d02b5708fd941$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e93d02b5708fd941$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $e93d02b5708fd941$var$times(n, iteratee) {
    n = $97229332f73e6ab6$exports(n);
    if (n < 1 || n > $e93d02b5708fd941$var$MAX_SAFE_INTEGER) return [];
    var index = $e93d02b5708fd941$var$MAX_ARRAY_LENGTH, length = $e93d02b5708fd941$var$nativeMin(n, $e93d02b5708fd941$var$MAX_ARRAY_LENGTH);
    iteratee = $17632f4d9fdf581d$exports(iteratee);
    n -= $e93d02b5708fd941$var$MAX_ARRAY_LENGTH;
    var result = $j65fp(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$e93d02b5708fd941$exports = $e93d02b5708fd941$var$times;


var $f896ef6492898da5$exports = {};
var $bdbf73d0efdb0126$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $bdbf73d0efdb0126$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$bdbf73d0efdb0126$exports = $bdbf73d0efdb0126$var$arrayReduce;



var $erFZL = parcelRequire("erFZL");

var $9PmZ6 = parcelRequire("9PmZ6");
var $9d5c1be225cf5bc6$exports = {};
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $9d5c1be225cf5bc6$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
$9d5c1be225cf5bc6$exports = $9d5c1be225cf5bc6$var$baseReduce;



var $3hHqY = parcelRequire("3hHqY");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $f896ef6492898da5$var$reduce(collection, iteratee, accumulator) {
    var func = $3hHqY(collection) ? $bdbf73d0efdb0126$exports : $9d5c1be225cf5bc6$exports, initAccum = arguments.length < 3;
    return func(collection, $9PmZ6(iteratee, 4), accumulator, initAccum, $erFZL);
}
$f896ef6492898da5$exports = $f896ef6492898da5$var$reduce;




var $81BVN = parcelRequire("81BVN");
var $ff7bcb23a771808b$exports = {};
"use strict";
Object.defineProperty($ff7bcb23a771808b$exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
var $ff7bcb23a771808b$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = $eZVvM.useState(initialState), state = _a[0], set = _a[1];
    var setState = $eZVvM.useCallback(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
$ff7bcb23a771808b$exports.default = $ff7bcb23a771808b$var$useSetState;


var $3f6387fdaa5c88ea$exports = {};
"use strict";
Object.defineProperty($3f6387fdaa5c88ea$exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $5rwF9 = parcelRequire("5rwF9");
var $3f6387fdaa5c88ea$var$defaultEvents = [
    "mousedown",
    "touchstart"
];
var $3f6387fdaa5c88ea$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $3f6387fdaa5c88ea$var$defaultEvents;
    var savedCallback = $eZVvM.useRef(onClickAway);
    $eZVvM.useEffect(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    $eZVvM.useEffect(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            $5rwF9.on(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                $5rwF9.off(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
$3f6387fdaa5c88ea$exports.default = $3f6387fdaa5c88ea$var$useClickAway;



var $b275P = parcelRequire("b275P");

var $cD0nt = parcelRequire("cD0nt");

var $8YEKz = parcelRequire("8YEKz");

var $3pTPw = parcelRequire("3pTPw");

var $bhfvP = parcelRequire("bhfvP");

var $7a86233f32729561$exports = {};
/*!
 * 
 *   react-simple-keyboard v3.8.19
 *   https://github.com/hodgef/react-simple-keyboard
 *
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef) and project contributors.
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */ 
!function(t, e) {
    $7a86233f32729561$exports = e((parcelRequire("eZVvM")));
}($7a86233f32729561$exports, function(t) {
    return function() {
        var e = {
            981: function() {
                "undefined" == typeof Element || "remove" in Element.prototype || (Element.prototype.remove = function() {
                    this.parentNode && this.parentNode.removeChild(this);
                }), "undefined" != typeof self && "document" in self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(t) {
                    "use strict";
                    if ("Element" in t) {
                        var e = "classList", n = "prototype", o = t.Element[n], r = Object, i = String[n].trim || function() {
                            return this.replace(/^\s+|\s+$/g, "");
                        }, a = Array[n].indexOf || function(t) {
                            for(var e = 0, n = this.length; e < n; e++)if (e in this && this[e] === t) return e;
                            return -1;
                        }, s = function(t, e) {
                            this.name = t, this.code = DOMException[t], this.message = e;
                        }, u = function(t, e) {
                            if ("" === e) throw new s("SYNTAX_ERR", "The token must not be empty.");
                            if (/\s/.test(e)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                            return a.call(t, e);
                        }, c = function(t) {
                            for(var e = i.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], o = 0, r = n.length; o < r; o++)this.push(n[o]);
                            this._updateClassName = function() {
                                t.setAttribute("class", this.toString());
                            };
                        }, l = c[n] = [], f = function() {
                            return new c(this);
                        };
                        if (s[n] = Error[n], l.item = function(t) {
                            return this[t] || null;
                        }, l.contains = function(t) {
                            return ~u(this, t + "");
                        }, l.add = function() {
                            var t, e = arguments, n = 0, o = e.length, r = !1;
                            do ~u(this, t = e[n] + "") || (this.push(t), r = !0);
                            while (++n < o);
                            r && this._updateClassName();
                        }, l.remove = function() {
                            var t, e, n = arguments, o = 0, r = n.length, i = !1;
                            do for(e = u(this, t = n[o] + ""); ~e;)this.splice(e, 1), i = !0, e = u(this, t);
                            while (++o < r);
                            i && this._updateClassName();
                        }, l.toggle = function(t, e) {
                            var n = this.contains(t), o = n ? !0 !== e && "remove" : !1 !== e && "add";
                            return o && this[o](t), !0 === e || !1 === e ? e : !n;
                        }, l.replace = function(t, e) {
                            var n = u(t + "");
                            ~n && (this.splice(n, 1, e), this._updateClassName());
                        }, l.toString = function() {
                            return this.join(" ");
                        }, r.defineProperty) {
                            var d = {
                                get: f,
                                enumerable: !0,
                                configurable: !0
                            };
                            try {
                                r.defineProperty(o, e, d);
                            } catch (t) {
                                void 0 !== t.number && -2146823252 !== t.number || (d.enumerable = !1, r.defineProperty(o, e, d));
                            }
                        } else r[n].__defineGetter__ && o.__defineGetter__(e, f);
                    }
                }(self), function() {
                    "use strict";
                    var t = document.createElement("_");
                    if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
                        var e = function(t) {
                            var e = DOMTokenList.prototype[t];
                            DOMTokenList.prototype[t] = function(t) {
                                var n, o = arguments.length;
                                for(n = 0; n < o; n++)t = arguments[n], e.call(this, t);
                            };
                        };
                        e("add"), e("remove");
                    }
                    if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
                        var n = DOMTokenList.prototype.toggle;
                        DOMTokenList.prototype.toggle = function(t, e) {
                            return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
                        };
                    }
                    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function(t, e) {
                        var n = this.toString().split(" "), o = n.indexOf(t + "");
                        ~o && (n = n.slice(o), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
                    }), t = null;
                }());
            },
            548: function(t) {
                t.exports = function() {
                    "use strict";
                    var t = {
                        9306: function(t, e, n) {
                            var o = n(4901), r = n(6823), i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not a function");
                            };
                        },
                        5548: function(t, e, n) {
                            var o = n(3517), r = n(6823), i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not a constructor");
                            };
                        },
                        3506: function(t, e, n) {
                            var o = n(3925), r = String, i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i("Can't set " + r(t) + " as a prototype");
                            };
                        },
                        6469: function(t, e, n) {
                            var o = n(8227), r = n(2360), i = n(4913).f, a = o("unscopables"), s = Array.prototype;
                            void 0 === s[a] && i(s, a, {
                                configurable: !0,
                                value: r(null)
                            }), t.exports = function(t) {
                                s[a][t] = !0;
                            };
                        },
                        7829: function(t, e, n) {
                            var o = n(8183).charAt;
                            t.exports = function(t, e, n) {
                                return e + (n ? o(t, e).length : 1);
                            };
                        },
                        8551: function(t, e, n) {
                            var o = n(34), r = String, i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not an object");
                            };
                        },
                        235: function(t, e, n) {
                            var o = n(9213).forEach, r = n(4598)("forEach");
                            t.exports = r ? [].forEach : function(t) {
                                return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                            };
                        },
                        7916: function(t, e, n) {
                            var o = n(6080), r = n(9565), i = n(8981), a = n(6319), s = n(4209), u = n(3517), c = n(6198), l = n(4659), f = n(81), d = n(851), p = Array;
                            t.exports = function(t) {
                                var e = i(t), n = u(this), h = arguments.length, v = h > 1 ? arguments[1] : void 0, y = void 0 !== v;
                                y && (v = o(v, h > 2 ? arguments[2] : void 0));
                                var g, m, b, w, x, E, O = d(e), S = 0;
                                if (!O || this === p && s(O)) for(g = c(e), m = n ? new this(g) : p(g); g > S; S++)E = y ? v(e[S], S) : e[S], l(m, S, E);
                                else for(m = n ? new this : [], x = (w = f(e, O)).next; !(b = r(x, w)).done; S++)E = y ? a(w, v, [
                                    b.value,
                                    S
                                ], !0) : b.value, l(m, S, E);
                                return m.length = S, m;
                            };
                        },
                        9617: function(t, e, n) {
                            var o = n(5397), r = n(5610), i = n(6198), a = function(t) {
                                return function(e, n, a) {
                                    var s = o(e), u = i(s);
                                    if (0 === u) return !t && -1;
                                    var c, l = r(a, u);
                                    if (t && n != n) {
                                        for(; u > l;)if ((c = s[l++]) != c) return !0;
                                    } else for(; u > l; l++)if ((t || l in s) && s[l] === n) return t || l || 0;
                                    return !t && -1;
                                };
                            };
                            t.exports = {
                                includes: a(!0),
                                indexOf: a(!1)
                            };
                        },
                        9213: function(t, e, n) {
                            var o = n(6080), r = n(9504), i = n(7055), a = n(8981), s = n(6198), u = n(1469), c = r([].push), l = function(t) {
                                var e = 1 === t, n = 2 === t, r = 3 === t, l = 4 === t, f = 6 === t, d = 7 === t, p = 5 === t || f;
                                return function(h, v, y, g) {
                                    for(var m, b, w = a(h), x = i(w), E = s(x), O = o(v, y), S = 0, k = g || u, P = e ? k(h, E) : n || d ? k(h, 0) : void 0; E > S; S++)if ((p || S in x) && (b = O(m = x[S], S, w), t)) {
                                        if (e) P[S] = b;
                                        else if (b) switch(t){
                                            case 3:
                                                return !0;
                                            case 5:
                                                return m;
                                            case 6:
                                                return S;
                                            case 2:
                                                c(P, m);
                                        }
                                        else switch(t){
                                            case 4:
                                                return !1;
                                            case 7:
                                                c(P, m);
                                        }
                                    }
                                    return f ? -1 : r || l ? l : P;
                                };
                            };
                            t.exports = {
                                forEach: l(0),
                                map: l(1),
                                filter: l(2),
                                some: l(3),
                                every: l(4),
                                find: l(5),
                                findIndex: l(6),
                                filterReject: l(7)
                            };
                        },
                        597: function(t, e, n) {
                            var o = n(9039), r = n(8227), i = n(9519), a = r("species");
                            t.exports = function(t) {
                                return i >= 51 || !o(function() {
                                    var e = [];
                                    return (e.constructor = {})[a] = function() {
                                        return {
                                            foo: 1
                                        };
                                    }, 1 !== e[t](Boolean).foo;
                                });
                            };
                        },
                        4598: function(t, e, n) {
                            var o = n(9039);
                            t.exports = function(t, e) {
                                var n = [][t];
                                return !!n && o(function() {
                                    n.call(null, e || function() {
                                        return 1;
                                    }, 1);
                                });
                            };
                        },
                        926: function(t, e, n) {
                            var o = n(9306), r = n(8981), i = n(7055), a = n(6198), s = TypeError, u = "Reduce of empty array with no initial value", c = function(t) {
                                return function(e, n, c, l) {
                                    var f = r(e), d = i(f), p = a(f);
                                    if (o(n), 0 === p && c < 2) throw new s(u);
                                    var h = t ? p - 1 : 0, v = t ? -1 : 1;
                                    if (c < 2) for(;;){
                                        if (h in d) {
                                            l = d[h], h += v;
                                            break;
                                        }
                                        if (h += v, t ? h < 0 : p <= h) throw new s(u);
                                    }
                                    for(; t ? h >= 0 : p > h; h += v)h in d && (l = n(l, d[h], h, f));
                                    return l;
                                };
                            };
                            t.exports = {
                                left: c(!1),
                                right: c(!0)
                            };
                        },
                        4527: function(t, e, n) {
                            var o = n(3724), r = n(4376), i = TypeError, a = Object.getOwnPropertyDescriptor, s = o && !function() {
                                if (void 0 !== this) return !0;
                                try {
                                    Object.defineProperty([], "length", {
                                        writable: !1
                                    }).length = 1;
                                } catch (t) {
                                    return t instanceof TypeError;
                                }
                            }();
                            t.exports = s ? function(t, e) {
                                if (r(t) && !a(t, "length").writable) throw new i("Cannot set read only .length");
                                return t.length = e;
                            } : function(t, e) {
                                return t.length = e;
                            };
                        },
                        7680: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o([].slice);
                        },
                        4488: function(t, e, n) {
                            var o = n(7680), r = Math.floor, i = function(t, e) {
                                var n = t.length;
                                if (n < 8) for(var a, s, u = 1; u < n;){
                                    for(s = u, a = t[u]; s && e(t[s - 1], a) > 0;)t[s] = t[--s];
                                    s !== u++ && (t[s] = a);
                                }
                                else for(var c = r(n / 2), l = i(o(t, 0, c), e), f = i(o(t, c), e), d = l.length, p = f.length, h = 0, v = 0; h < d || v < p;)t[h + v] = h < d && v < p ? e(l[h], f[v]) <= 0 ? l[h++] : f[v++] : h < d ? l[h++] : f[v++];
                                return t;
                            };
                            t.exports = i;
                        },
                        7433: function(t, e, n) {
                            var o = n(4376), r = n(3517), i = n(34), a = n(8227)("species"), s = Array;
                            t.exports = function(t) {
                                var e;
                                return o(t) && (e = t.constructor, (r(e) && (e === s || o(e.prototype)) || i(e) && null === (e = e[a])) && (e = void 0)), void 0 === e ? s : e;
                            };
                        },
                        1469: function(t, e, n) {
                            var o = n(7433);
                            t.exports = function(t, e) {
                                return new (o(t))(0 === e ? 0 : e);
                            };
                        },
                        6319: function(t, e, n) {
                            var o = n(8551), r = n(9539);
                            t.exports = function(t, e, n, i) {
                                try {
                                    return i ? e(o(n)[0], n[1]) : e(n);
                                } catch (e) {
                                    r(t, "throw", e);
                                }
                            };
                        },
                        4428: function(t, e, n) {
                            var o = n(8227)("iterator"), r = !1;
                            try {
                                var i = 0, a = {
                                    next: function() {
                                        return {
                                            done: !!i++
                                        };
                                    },
                                    return: function() {
                                        r = !0;
                                    }
                                };
                                a[o] = function() {
                                    return this;
                                }, Array.from(a, function() {
                                    throw 2;
                                });
                            } catch (t) {}
                            t.exports = function(t, e) {
                                try {
                                    if (!e && !r) return !1;
                                } catch (t) {
                                    return !1;
                                }
                                var n = !1;
                                try {
                                    var i = {};
                                    i[o] = function() {
                                        return {
                                            next: function() {
                                                return {
                                                    done: n = !0
                                                };
                                            }
                                        };
                                    }, t(i);
                                } catch (t) {}
                                return n;
                            };
                        },
                        2195: function(t, e, n) {
                            var o = n(9504), r = o({}.toString), i = o("".slice);
                            t.exports = function(t) {
                                return i(r(t), 8, -1);
                            };
                        },
                        6955: function(t, e, n) {
                            var o = n(2140), r = n(4901), i = n(2195), a = n(8227)("toStringTag"), s = Object, u = "Arguments" === i(function() {
                                return arguments;
                            }());
                            t.exports = o ? i : function(t) {
                                var e, n, o;
                                return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                                    try {
                                        return t[e];
                                    } catch (t) {}
                                }(e = s(t), a)) ? n : u ? i(e) : "Object" === (o = i(e)) && r(e.callee) ? "Arguments" : o;
                            };
                        },
                        7740: function(t, e, n) {
                            var o = n(9297), r = n(5031), i = n(7347), a = n(4913);
                            t.exports = function(t, e, n) {
                                for(var s = r(e), u = a.f, c = i.f, l = 0; l < s.length; l++){
                                    var f = s[l];
                                    o(t, f) || n && o(n, f) || u(t, f, c(e, f));
                                }
                            };
                        },
                        1436: function(t, e, n) {
                            var o = n(8227)("match");
                            t.exports = function(t) {
                                var e = /./;
                                try {
                                    "/./"[t](e);
                                } catch (n) {
                                    try {
                                        return e[o] = !1, "/./"[t](e);
                                    } catch (t) {}
                                }
                                return !1;
                            };
                        },
                        2211: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                function t() {}
                                return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
                            });
                        },
                        2529: function(t) {
                            t.exports = function(t, e) {
                                return {
                                    value: t,
                                    done: e
                                };
                            };
                        },
                        6699: function(t, e, n) {
                            var o = n(3724), r = n(4913), i = n(6980);
                            t.exports = o ? function(t, e, n) {
                                return r.f(t, e, i(1, n));
                            } : function(t, e, n) {
                                return t[e] = n, t;
                            };
                        },
                        6980: function(t) {
                            t.exports = function(t, e) {
                                return {
                                    enumerable: !(1 & t),
                                    configurable: !(2 & t),
                                    writable: !(4 & t),
                                    value: e
                                };
                            };
                        },
                        4659: function(t, e, n) {
                            var o = n(3724), r = n(4913), i = n(6980);
                            t.exports = function(t, e, n) {
                                o ? r.f(t, e, i(0, n)) : t[e] = n;
                            };
                        },
                        3640: function(t, e, n) {
                            var o = n(8551), r = n(4270), i = TypeError;
                            t.exports = function(t) {
                                if (o(this), "string" === t || "default" === t) t = "string";
                                else if ("number" !== t) throw new i("Incorrect hint");
                                return r(this, t);
                            };
                        },
                        2106: function(t, e, n) {
                            var o = n(283), r = n(4913);
                            t.exports = function(t, e, n) {
                                return n.get && o(n.get, e, {
                                    getter: !0
                                }), n.set && o(n.set, e, {
                                    setter: !0
                                }), r.f(t, e, n);
                            };
                        },
                        6840: function(t, e, n) {
                            var o = n(4901), r = n(4913), i = n(283), a = n(9433);
                            t.exports = function(t, e, n, s) {
                                s || (s = {});
                                var u = s.enumerable, c = void 0 !== s.name ? s.name : e;
                                if (o(n) && i(n, c, s), s.global) u ? t[e] = n : a(e, n);
                                else {
                                    try {
                                        s.unsafe ? t[e] && (u = !0) : delete t[e];
                                    } catch (t) {}
                                    u ? t[e] = n : r.f(t, e, {
                                        value: n,
                                        enumerable: !1,
                                        configurable: !s.nonConfigurable,
                                        writable: !s.nonWritable
                                    });
                                }
                                return t;
                            };
                        },
                        9433: function(t, e, n) {
                            var o = n(4576), r = Object.defineProperty;
                            t.exports = function(t, e) {
                                try {
                                    r(o, t, {
                                        value: e,
                                        configurable: !0,
                                        writable: !0
                                    });
                                } catch (n) {
                                    o[t] = e;
                                }
                                return e;
                            };
                        },
                        4606: function(t, e, n) {
                            var o = n(6823), r = TypeError;
                            t.exports = function(t, e) {
                                if (!delete t[e]) throw new r("Cannot delete property " + o(e) + " of " + o(t));
                            };
                        },
                        3724: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                return 7 !== Object.defineProperty({}, 1, {
                                    get: function() {
                                        return 7;
                                    }
                                })[1];
                            });
                        },
                        4055: function(t, e, n) {
                            var o = n(4576), r = n(34), i = o.document, a = r(i) && r(i.createElement);
                            t.exports = function(t) {
                                return a ? i.createElement(t) : {};
                            };
                        },
                        6837: function(t) {
                            var e = TypeError;
                            t.exports = function(t) {
                                if (t > 9007199254740991) throw e("Maximum allowed index exceeded");
                                return t;
                            };
                        },
                        7400: function(t) {
                            t.exports = {
                                CSSRuleList: 0,
                                CSSStyleDeclaration: 0,
                                CSSValueList: 0,
                                ClientRectList: 0,
                                DOMRectList: 0,
                                DOMStringList: 0,
                                DOMTokenList: 1,
                                DataTransferItemList: 0,
                                FileList: 0,
                                HTMLAllCollection: 0,
                                HTMLCollection: 0,
                                HTMLFormElement: 0,
                                HTMLSelectElement: 0,
                                MediaList: 0,
                                MimeTypeArray: 0,
                                NamedNodeMap: 0,
                                NodeList: 1,
                                PaintRequestList: 0,
                                Plugin: 0,
                                PluginArray: 0,
                                SVGLengthList: 0,
                                SVGNumberList: 0,
                                SVGPathSegList: 0,
                                SVGPointList: 0,
                                SVGStringList: 0,
                                SVGTransformList: 0,
                                SourceBufferList: 0,
                                StyleSheetList: 0,
                                TextTrackCueList: 0,
                                TextTrackList: 0,
                                TouchList: 0
                            };
                        },
                        9296: function(t, e, n) {
                            var o = n(4055)("span").classList, r = o && o.constructor && o.constructor.prototype;
                            t.exports = r === Object.prototype ? void 0 : r;
                        },
                        8727: function(t) {
                            t.exports = [
                                "constructor",
                                "hasOwnProperty",
                                "isPrototypeOf",
                                "propertyIsEnumerable",
                                "toLocaleString",
                                "toString",
                                "valueOf"
                            ];
                        },
                        3709: function(t, e, n) {
                            var o = n(2839).match(/firefox\/(\d+)/i);
                            t.exports = !!o && +o[1];
                        },
                        3763: function(t, e, n) {
                            var o = n(2839);
                            t.exports = /MSIE|Trident/.test(o);
                        },
                        6193: function(t, e, n) {
                            var o = n(4215);
                            t.exports = "NODE" === o;
                        },
                        2839: function(t, e, n) {
                            var o = n(4576).navigator, r = o && o.userAgent;
                            t.exports = r ? String(r) : "";
                        },
                        9519: function(t, e, n) {
                            var o, r, i = n(4576), a = n(2839), s = i.process, u = i.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                            l && (r = (o = l.split("."))[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !r && a && (!(o = a.match(/Edge\/(\d+)/)) || o[1] >= 74) && (o = a.match(/Chrome\/(\d+)/)) && (r = +o[1]), t.exports = r;
                        },
                        3607: function(t, e, n) {
                            var o = n(2839).match(/AppleWebKit\/(\d+)\./);
                            t.exports = !!o && +o[1];
                        },
                        4215: function(t, e, n) {
                            var o = n(4576), r = n(2839), i = n(2195), a = function(t) {
                                return r.slice(0, t.length) === t;
                            };
                            t.exports = a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : o.Bun && "string" == typeof Bun.version ? "BUN" : o.Deno && "object" == typeof Deno.version ? "DENO" : "process" === i(o.process) ? "NODE" : o.window && o.document ? "BROWSER" : "REST";
                        },
                        6518: function(t, e, n) {
                            var o = n(4576), r = n(7347).f, i = n(6699), a = n(6840), s = n(9433), u = n(7740), c = n(2796);
                            t.exports = function(t, e) {
                                var n, l, f, d, p, h = t.target, v = t.global, y = t.stat;
                                if (n = v ? o : y ? o[h] || s(h, {}) : o[h] && o[h].prototype) for(l in e){
                                    if (d = e[l], f = t.dontCallGetSet ? (p = r(n, l)) && p.value : n[l], !c(v ? l : h + (y ? "." : "#") + l, t.forced) && void 0 !== f) {
                                        if (typeof d == typeof f) continue;
                                        u(d, f);
                                    }
                                    (t.sham || f && f.sham) && i(d, "sham", !0), a(n, l, d, t);
                                }
                            };
                        },
                        9039: function(t) {
                            t.exports = function(t) {
                                try {
                                    return !!t();
                                } catch (t) {
                                    return !0;
                                }
                            };
                        },
                        9228: function(t, e, n) {
                            n(7495);
                            var o = n(9565), r = n(6840), i = n(7323), a = n(9039), s = n(8227), u = n(6699), c = s("species"), l = RegExp.prototype;
                            t.exports = function(t, e, n, f) {
                                var d = s(t), p = !a(function() {
                                    var e = {};
                                    return e[d] = function() {
                                        return 7;
                                    }, 7 !== ""[t](e);
                                }), h = p && !a(function() {
                                    var e = !1, n = /a/;
                                    return "split" === t && ((n = {}).constructor = {}, n.constructor[c] = function() {
                                        return n;
                                    }, n.flags = "", n[d] = /./[d]), n.exec = function() {
                                        return e = !0, null;
                                    }, n[d](""), !e;
                                });
                                if (!p || !h || n) {
                                    var v = /./[d], y = e(d, ""[t], function(t, e, n, r, a) {
                                        var s = e.exec;
                                        return s === i || s === l.exec ? p && !a ? {
                                            done: !0,
                                            value: o(v, e, n, r)
                                        } : {
                                            done: !0,
                                            value: o(t, n, e, r)
                                        } : {
                                            done: !1
                                        };
                                    });
                                    r(String.prototype, t, y[0]), r(l, d, y[1]);
                                }
                                f && u(l[d], "sham", !0);
                            };
                        },
                        8745: function(t, e, n) {
                            var o = n(616), r = Function.prototype, i = r.apply, a = r.call;
                            t.exports = "object" == typeof Reflect && Reflect.apply || (o ? a.bind(i) : function() {
                                return a.apply(i, arguments);
                            });
                        },
                        6080: function(t, e, n) {
                            var o = n(7476), r = n(9306), i = n(616), a = o(o.bind);
                            t.exports = function(t, e) {
                                return r(t), void 0 === e ? t : i ? a(t, e) : function() {
                                    return t.apply(e, arguments);
                                };
                            };
                        },
                        616: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                var t = (function() {}).bind();
                                return "function" != typeof t || t.hasOwnProperty("prototype");
                            });
                        },
                        9565: function(t, e, n) {
                            var o = n(616), r = Function.prototype.call;
                            t.exports = o ? r.bind(r) : function() {
                                return r.apply(r, arguments);
                            };
                        },
                        350: function(t, e, n) {
                            var o = n(3724), r = n(9297), i = Function.prototype, a = o && Object.getOwnPropertyDescriptor, s = r(i, "name"), u = s && "something" === (function() {}).name, c = s && (!o || o && a(i, "name").configurable);
                            t.exports = {
                                EXISTS: s,
                                PROPER: u,
                                CONFIGURABLE: c
                            };
                        },
                        6706: function(t, e, n) {
                            var o = n(9504), r = n(9306);
                            t.exports = function(t, e, n) {
                                try {
                                    return o(r(Object.getOwnPropertyDescriptor(t, e)[n]));
                                } catch (t) {}
                            };
                        },
                        7476: function(t, e, n) {
                            var o = n(2195), r = n(9504);
                            t.exports = function(t) {
                                if ("Function" === o(t)) return r(t);
                            };
                        },
                        9504: function(t, e, n) {
                            var o = n(616), r = Function.prototype, i = r.call, a = o && r.bind.bind(i, i);
                            t.exports = o ? a : function(t) {
                                return function() {
                                    return i.apply(t, arguments);
                                };
                            };
                        },
                        7751: function(t, e, n) {
                            var o = n(4576), r = n(4901);
                            t.exports = function(t, e) {
                                var n;
                                return arguments.length < 2 ? (n = o[t], r(n) ? n : void 0) : o[t] && o[t][e];
                            };
                        },
                        851: function(t, e, n) {
                            var o = n(6955), r = n(5966), i = n(4117), a = n(6269), s = n(8227)("iterator");
                            t.exports = function(t) {
                                if (!i(t)) return r(t, s) || r(t, "@@iterator") || a[o(t)];
                            };
                        },
                        81: function(t, e, n) {
                            var o = n(9565), r = n(9306), i = n(8551), a = n(6823), s = n(851), u = TypeError;
                            t.exports = function(t, e) {
                                var n = arguments.length < 2 ? s(t) : e;
                                if (r(n)) return i(o(n, t));
                                throw new u(a(t) + " is not iterable");
                            };
                        },
                        6933: function(t, e, n) {
                            var o = n(9504), r = n(4376), i = n(4901), a = n(2195), s = n(655), u = o([].push);
                            t.exports = function(t) {
                                if (i(t)) return t;
                                if (r(t)) {
                                    for(var e = t.length, n = [], o = 0; o < e; o++){
                                        var c = t[o];
                                        "string" == typeof c ? u(n, c) : "number" != typeof c && "Number" !== a(c) && "String" !== a(c) || u(n, s(c));
                                    }
                                    var l = n.length, f = !0;
                                    return function(t, e) {
                                        if (f) return f = !1, e;
                                        if (r(this)) return e;
                                        for(var o = 0; o < l; o++)if (n[o] === t) return e;
                                    };
                                }
                            };
                        },
                        5966: function(t, e, n) {
                            var o = n(9306), r = n(4117);
                            t.exports = function(t, e) {
                                var n = t[e];
                                return r(n) ? void 0 : o(n);
                            };
                        },
                        2478: function(t, e, n) {
                            var o = n(9504), r = n(8981), i = Math.floor, a = o("".charAt), s = o("".replace), u = o("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                            t.exports = function(t, e, n, o, f, d) {
                                var p = n + t.length, h = o.length, v = l;
                                return void 0 !== f && (f = r(f), v = c), s(d, v, function(r, s) {
                                    var c;
                                    switch(a(s, 0)){
                                        case "$":
                                            return "$";
                                        case "&":
                                            return t;
                                        case "`":
                                            return u(e, 0, n);
                                        case "'":
                                            return u(e, p);
                                        case "<":
                                            c = f[u(s, 1, -1)];
                                            break;
                                        default:
                                            var l = +s;
                                            if (0 === l) return r;
                                            if (l > h) {
                                                var d = i(l / 10);
                                                return 0 === d ? r : d <= h ? void 0 === o[d - 1] ? a(s, 1) : o[d - 1] + a(s, 1) : r;
                                            }
                                            c = o[l - 1];
                                    }
                                    return void 0 === c ? "" : c;
                                });
                            };
                        },
                        4576: function(t, e, n) {
                            var o = function(t) {
                                return t && t.Math === Math && t;
                            };
                            t.exports = o("object" == typeof globalThis && globalThis) || o("object" == typeof window && window) || o("object" == typeof self && self) || o("object" == typeof n.g && n.g) || o("object" == typeof this && this) || function() {
                                return this;
                            }() || Function("return this")();
                        },
                        9297: function(t, e, n) {
                            var o = n(9504), r = n(8981), i = o({}.hasOwnProperty);
                            t.exports = Object.hasOwn || function(t, e) {
                                return i(r(t), e);
                            };
                        },
                        421: function(t) {
                            t.exports = {};
                        },
                        397: function(t, e, n) {
                            var o = n(7751);
                            t.exports = o("document", "documentElement");
                        },
                        5917: function(t, e, n) {
                            var o = n(3724), r = n(9039), i = n(4055);
                            t.exports = !o && !r(function() {
                                return 7 !== Object.defineProperty(i("div"), "a", {
                                    get: function() {
                                        return 7;
                                    }
                                }).a;
                            });
                        },
                        7055: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(2195), a = Object, s = o("".split);
                            t.exports = r(function() {
                                return !a("z").propertyIsEnumerable(0);
                            }) ? function(t) {
                                return "String" === i(t) ? s(t, "") : a(t);
                            } : a;
                        },
                        3167: function(t, e, n) {
                            var o = n(4901), r = n(34), i = n(2967);
                            t.exports = function(t, e, n) {
                                var a, s;
                                return i && o(a = e.constructor) && a !== n && r(s = a.prototype) && s !== n.prototype && i(t, s), t;
                            };
                        },
                        3706: function(t, e, n) {
                            var o = n(9504), r = n(4901), i = n(7629), a = o(Function.toString);
                            r(i.inspectSource) || (i.inspectSource = function(t) {
                                return a(t);
                            }), t.exports = i.inspectSource;
                        },
                        1181: function(t, e, n) {
                            var o, r, i, a = n(8622), s = n(4576), u = n(34), c = n(6699), l = n(9297), f = n(7629), d = n(6119), p = n(421), h = "Object already initialized", v = s.TypeError, y = s.WeakMap;
                            if (a || f.state) {
                                var g = f.state || (f.state = new y);
                                g.get = g.get, g.has = g.has, g.set = g.set, o = function(t, e) {
                                    if (g.has(t)) throw new v(h);
                                    return e.facade = t, g.set(t, e), e;
                                }, r = function(t) {
                                    return g.get(t) || {};
                                }, i = function(t) {
                                    return g.has(t);
                                };
                            } else {
                                var m = d("state");
                                p[m] = !0, o = function(t, e) {
                                    if (l(t, m)) throw new v(h);
                                    return e.facade = t, c(t, m, e), e;
                                }, r = function(t) {
                                    return l(t, m) ? t[m] : {};
                                }, i = function(t) {
                                    return l(t, m);
                                };
                            }
                            t.exports = {
                                set: o,
                                get: r,
                                has: i,
                                enforce: function(t) {
                                    return i(t) ? r(t) : o(t, {});
                                },
                                getterFor: function(t) {
                                    return function(e) {
                                        var n;
                                        if (!u(e) || (n = r(e)).type !== t) throw new v("Incompatible receiver, " + t + " required");
                                        return n;
                                    };
                                }
                            };
                        },
                        4209: function(t, e, n) {
                            var o = n(8227), r = n(6269), i = o("iterator"), a = Array.prototype;
                            t.exports = function(t) {
                                return void 0 !== t && (r.Array === t || a[i] === t);
                            };
                        },
                        4376: function(t, e, n) {
                            var o = n(2195);
                            t.exports = Array.isArray || function(t) {
                                return "Array" === o(t);
                            };
                        },
                        4901: function(t) {
                            var e = "object" == typeof document && document.all;
                            t.exports = void 0 === e && void 0 !== e ? function(t) {
                                return "function" == typeof t || t === e;
                            } : function(t) {
                                return "function" == typeof t;
                            };
                        },
                        3517: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(4901), a = n(6955), s = n(7751), u = n(3706), c = function() {}, l = s("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = o(f.exec), p = !f.test(c), h = function(t) {
                                if (!i(t)) return !1;
                                try {
                                    return l(c, [], t), !0;
                                } catch (t) {
                                    return !1;
                                }
                            }, v = function(t) {
                                if (!i(t)) return !1;
                                switch(a(t)){
                                    case "AsyncFunction":
                                    case "GeneratorFunction":
                                    case "AsyncGeneratorFunction":
                                        return !1;
                                }
                                try {
                                    return p || !!d(f, u(t));
                                } catch (t) {
                                    return !0;
                                }
                            };
                            v.sham = !0, t.exports = !l || r(function() {
                                var t;
                                return h(h.call) || !h(Object) || !h(function() {
                                    t = !0;
                                }) || t;
                            }) ? v : h;
                        },
                        2796: function(t, e, n) {
                            var o = n(9039), r = n(4901), i = /#|\.prototype\./, a = function(t, e) {
                                var n = u[s(t)];
                                return n === l || n !== c && (r(e) ? o(e) : !!e);
                            }, s = a.normalize = function(t) {
                                return String(t).replace(i, ".").toLowerCase();
                            }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                            t.exports = a;
                        },
                        2087: function(t, e, n) {
                            var o = n(34), r = Math.floor;
                            t.exports = Number.isInteger || function(t) {
                                return !o(t) && isFinite(t) && r(t) === t;
                            };
                        },
                        4117: function(t) {
                            t.exports = function(t) {
                                return null == t;
                            };
                        },
                        34: function(t, e, n) {
                            var o = n(4901);
                            t.exports = function(t) {
                                return "object" == typeof t ? null !== t : o(t);
                            };
                        },
                        3925: function(t, e, n) {
                            var o = n(34);
                            t.exports = function(t) {
                                return o(t) || null === t;
                            };
                        },
                        6395: function(t) {
                            t.exports = !1;
                        },
                        788: function(t, e, n) {
                            var o = n(34), r = n(2195), i = n(8227)("match");
                            t.exports = function(t) {
                                var e;
                                return o(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" === r(t));
                            };
                        },
                        757: function(t, e, n) {
                            var o = n(7751), r = n(4901), i = n(1625), a = n(7040), s = Object;
                            t.exports = a ? function(t) {
                                return "symbol" == typeof t;
                            } : function(t) {
                                var e = o("Symbol");
                                return r(e) && i(e.prototype, s(t));
                            };
                        },
                        9539: function(t, e, n) {
                            var o = n(9565), r = n(8551), i = n(5966);
                            t.exports = function(t, e, n) {
                                var a, s;
                                r(t);
                                try {
                                    if (!(a = i(t, "return"))) {
                                        if ("throw" === e) throw n;
                                        return n;
                                    }
                                    a = o(a, t);
                                } catch (t) {
                                    s = !0, a = t;
                                }
                                if ("throw" === e) throw n;
                                if (s) throw a;
                                return r(a), n;
                            };
                        },
                        3994: function(t, e, n) {
                            var o = n(7657).IteratorPrototype, r = n(2360), i = n(6980), a = n(687), s = n(6269), u = function() {
                                return this;
                            };
                            t.exports = function(t, e, n, c) {
                                var l = e + " Iterator";
                                return t.prototype = r(o, {
                                    next: i(+!c, n)
                                }), a(t, l, !1, !0), s[l] = u, t;
                            };
                        },
                        1088: function(t, e, n) {
                            var o = n(6518), r = n(9565), i = n(6395), a = n(350), s = n(4901), u = n(3994), c = n(2787), l = n(2967), f = n(687), d = n(6699), p = n(6840), h = n(8227), v = n(6269), y = n(7657), g = a.PROPER, m = a.CONFIGURABLE, b = y.IteratorPrototype, w = y.BUGGY_SAFARI_ITERATORS, x = h("iterator"), E = "keys", O = "values", S = "entries", k = function() {
                                return this;
                            };
                            t.exports = function(t, e, n, a, h, y, P) {
                                u(n, e, a);
                                var I, C, A, M = function(t) {
                                    if (t === h && R) return R;
                                    if (!w && t && t in N) return N[t];
                                    switch(t){
                                        case E:
                                        case O:
                                        case S:
                                            return function() {
                                                return new n(this, t);
                                            };
                                    }
                                    return function() {
                                        return new n(this);
                                    };
                                }, D = e + " Iterator", T = !1, N = t.prototype, j = N[x] || N["@@iterator"] || h && N[h], R = !w && j || M(h), L = "Array" === e && N.entries || j;
                                if (L && (I = c(L.call(new t))) !== Object.prototype && I.next && (i || c(I) === b || (l ? l(I, b) : s(I[x]) || p(I, x, k)), f(I, D, !0, !0), i && (v[D] = k)), g && h === O && j && j.name !== O && (!i && m ? d(N, "name", O) : (T = !0, R = function() {
                                    return r(j, this);
                                })), h) {
                                    if (C = {
                                        values: M(O),
                                        keys: y ? R : M(E),
                                        entries: M(S)
                                    }, P) for(A in C)(w || T || !(A in N)) && p(N, A, C[A]);
                                    else o({
                                        target: e,
                                        proto: !0,
                                        forced: w || T
                                    }, C);
                                }
                                return i && !P || N[x] === R || p(N, x, R, {
                                    name: h
                                }), v[e] = R, C;
                            };
                        },
                        7657: function(t, e, n) {
                            var o, r, i, a = n(9039), s = n(4901), u = n(34), c = n(2360), l = n(2787), f = n(6840), d = n(8227), p = n(6395), h = d("iterator"), v = !1;
                            [].keys && ("next" in (i = [].keys()) ? (r = l(l(i))) !== Object.prototype && (o = r) : v = !0), !u(o) || a(function() {
                                var t = {};
                                return o[h].call(t) !== t;
                            }) ? o = {} : p && (o = c(o)), s(o[h]) || f(o, h, function() {
                                return this;
                            }), t.exports = {
                                IteratorPrototype: o,
                                BUGGY_SAFARI_ITERATORS: v
                            };
                        },
                        6269: function(t) {
                            t.exports = {};
                        },
                        6198: function(t, e, n) {
                            var o = n(8014);
                            t.exports = function(t) {
                                return o(t.length);
                            };
                        },
                        283: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(4901), a = n(9297), s = n(3724), u = n(350).CONFIGURABLE, c = n(3706), l = n(1181), f = l.enforce, d = l.get, p = String, h = Object.defineProperty, v = o("".slice), y = o("".replace), g = o([].join), m = s && !r(function() {
                                return 8 !== h(function() {}, "length", {
                                    value: 8
                                }).length;
                            }), b = String(String).split("String"), w = t.exports = function(t, e, n) {
                                "Symbol(" === v(p(e), 0, 7) && (e = "[" + y(p(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n && n.getter && (e = "get " + e), n && n.setter && (e = "set " + e), (!a(t, "name") || u && t.name !== e) && (s ? h(t, "name", {
                                    value: e,
                                    configurable: !0
                                }) : t.name = e), m && n && a(n, "arity") && t.length !== n.arity && h(t, "length", {
                                    value: n.arity
                                });
                                try {
                                    n && a(n, "constructor") && n.constructor ? s && h(t, "prototype", {
                                        writable: !1
                                    }) : t.prototype && (t.prototype = void 0);
                                } catch (t) {}
                                var o = f(t);
                                return a(o, "source") || (o.source = g(b, "string" == typeof e ? e : "")), t;
                            };
                            Function.prototype.toString = w(function() {
                                return i(this) && d(this).source || c(this);
                            }, "toString");
                        },
                        741: function(t) {
                            var e = Math.ceil, n = Math.floor;
                            t.exports = Math.trunc || function(t) {
                                var o = +t;
                                return (o > 0 ? n : e)(o);
                            };
                        },
                        5749: function(t, e, n) {
                            var o = n(788), r = TypeError;
                            t.exports = function(t) {
                                if (o(t)) throw new r("The method doesn't accept regular expressions");
                                return t;
                            };
                        },
                        4213: function(t, e, n) {
                            var o = n(3724), r = n(9504), i = n(9565), a = n(9039), s = n(1072), u = n(3717), c = n(8773), l = n(8981), f = n(7055), d = Object.assign, p = Object.defineProperty, h = r([].concat);
                            t.exports = !d || a(function() {
                                if (o && 1 !== d({
                                    b: 1
                                }, d(p({}, "a", {
                                    enumerable: !0,
                                    get: function() {
                                        p(this, "b", {
                                            value: 3,
                                            enumerable: !1
                                        });
                                    }
                                }), {
                                    b: 2
                                })).b) return !0;
                                var t = {}, e = {}, n = Symbol("assign detection"), r = "abcdefghijklmnopqrst";
                                return t[n] = 7, r.split("").forEach(function(t) {
                                    e[t] = t;
                                }), 7 !== d({}, t)[n] || s(d({}, e)).join("") !== r;
                            }) ? function(t, e) {
                                for(var n = l(t), r = arguments.length, a = 1, d = u.f, p = c.f; r > a;)for(var v, y = f(arguments[a++]), g = d ? h(s(y), d(y)) : s(y), m = g.length, b = 0; m > b;)v = g[b++], o && !i(p, y, v) || (n[v] = y[v]);
                                return n;
                            } : d;
                        },
                        2360: function(t, e, n) {
                            var o, r = n(8551), i = n(6801), a = n(8727), s = n(421), u = n(397), c = n(4055), l = n(6119), f = "prototype", d = "script", p = l("IE_PROTO"), h = function() {}, v = function(t) {
                                return "<" + d + ">" + t + "</" + d + ">";
                            }, y = function(t) {
                                t.write(v("")), t.close();
                                var e = t.parentWindow.Object;
                                return t = null, e;
                            }, g = function() {
                                try {
                                    o = new ActiveXObject("htmlfile");
                                } catch (t) {}
                                var t, e, n;
                                g = "undefined" != typeof document ? document.domain && o ? y(o) : (e = c("iframe"), n = "java" + d + ":", e.style.display = "none", u.appendChild(e), e.src = String(n), (t = e.contentWindow.document).open(), t.write(v("document.F=Object")), t.close(), t.F) : y(o);
                                for(var r = a.length; r--;)delete g[f][a[r]];
                                return g();
                            };
                            s[p] = !0, t.exports = Object.create || function(t, e) {
                                var n;
                                return null !== t ? (h[f] = r(t), n = new h, h[f] = null, n[p] = t) : n = g(), void 0 === e ? n : i.f(n, e);
                            };
                        },
                        6801: function(t, e, n) {
                            var o = n(3724), r = n(8686), i = n(4913), a = n(8551), s = n(5397), u = n(1072);
                            e.f = o && !r ? Object.defineProperties : function(t, e) {
                                a(t);
                                for(var n, o = s(e), r = u(e), c = r.length, l = 0; c > l;)i.f(t, n = r[l++], o[n]);
                                return t;
                            };
                        },
                        4913: function(t, e, n) {
                            var o = n(3724), r = n(5917), i = n(8686), a = n(8551), s = n(6969), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", d = "configurable", p = "writable";
                            e.f = o ? i ? function(t, e, n) {
                                if (a(t), e = s(e), a(n), "function" == typeof t && "prototype" === e && "value" in n && p in n && !n[p]) {
                                    var o = l(t, e);
                                    o && o[p] && (t[e] = n.value, n = {
                                        configurable: d in n ? n[d] : o[d],
                                        enumerable: f in n ? n[f] : o[f],
                                        writable: !1
                                    });
                                }
                                return c(t, e, n);
                            } : c : function(t, e, n) {
                                if (a(t), e = s(e), a(n), r) try {
                                    return c(t, e, n);
                                } catch (t) {}
                                if ("get" in n || "set" in n) throw new u("Accessors not supported");
                                return "value" in n && (t[e] = n.value), t;
                            };
                        },
                        7347: function(t, e, n) {
                            var o = n(3724), r = n(9565), i = n(8773), a = n(6980), s = n(5397), u = n(6969), c = n(9297), l = n(5917), f = Object.getOwnPropertyDescriptor;
                            e.f = o ? f : function(t, e) {
                                if (t = s(t), e = u(e), l) try {
                                    return f(t, e);
                                } catch (t) {}
                                if (c(t, e)) return a(!r(i.f, t, e), t[e]);
                            };
                        },
                        298: function(t, e, n) {
                            var o = n(2195), r = n(5397), i = n(8480).f, a = n(7680), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                            t.exports.f = function(t) {
                                return s && "Window" === o(t) ? function(t) {
                                    try {
                                        return i(t);
                                    } catch (t) {
                                        return a(s);
                                    }
                                }(t) : i(r(t));
                            };
                        },
                        8480: function(t, e, n) {
                            var o = n(1828), r = n(8727).concat("length", "prototype");
                            e.f = Object.getOwnPropertyNames || function(t) {
                                return o(t, r);
                            };
                        },
                        3717: function(t, e) {
                            e.f = Object.getOwnPropertySymbols;
                        },
                        2787: function(t, e, n) {
                            var o = n(9297), r = n(4901), i = n(8981), a = n(6119), s = n(2211), u = a("IE_PROTO"), c = Object, l = c.prototype;
                            t.exports = s ? c.getPrototypeOf : function(t) {
                                var e = i(t);
                                if (o(e, u)) return e[u];
                                var n = e.constructor;
                                return r(n) && e instanceof n ? n.prototype : e instanceof c ? l : null;
                            };
                        },
                        1625: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o({}.isPrototypeOf);
                        },
                        1828: function(t, e, n) {
                            var o = n(9504), r = n(9297), i = n(5397), a = n(9617).indexOf, s = n(421), u = o([].push);
                            t.exports = function(t, e) {
                                var n, o = i(t), c = 0, l = [];
                                for(n in o)!r(s, n) && r(o, n) && u(l, n);
                                for(; e.length > c;)r(o, n = e[c++]) && (~a(l, n) || u(l, n));
                                return l;
                            };
                        },
                        1072: function(t, e, n) {
                            var o = n(1828), r = n(8727);
                            t.exports = Object.keys || function(t) {
                                return o(t, r);
                            };
                        },
                        8773: function(t, e) {
                            var n = {}.propertyIsEnumerable, o = Object.getOwnPropertyDescriptor, r = o && !n.call({
                                1: 2
                            }, 1);
                            e.f = r ? function(t) {
                                var e = o(this, t);
                                return !!e && e.enumerable;
                            } : n;
                        },
                        2551: function(t, e, n) {
                            var o = n(6395), r = n(4576), i = n(9039), a = n(3607);
                            t.exports = o || !i(function() {
                                if (!(a && a < 535)) {
                                    var t = Math.random();
                                    __defineSetter__.call(null, t, function() {}), delete r[t];
                                }
                            });
                        },
                        2967: function(t, e, n) {
                            var o = n(6706), r = n(34), i = n(7750), a = n(3506);
                            t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                                var t, e = !1, n = {};
                                try {
                                    (t = o(Object.prototype, "__proto__", "set"))(n, []), e = n instanceof Array;
                                } catch (t) {}
                                return function(n, o) {
                                    return i(n), a(o), r(n) ? (e ? t(n, o) : n.__proto__ = o, n) : n;
                                };
                            }() : void 0);
                        },
                        3179: function(t, e, n) {
                            var o = n(2140), r = n(6955);
                            t.exports = o ? ({}).toString : function() {
                                return "[object " + r(this) + "]";
                            };
                        },
                        4270: function(t, e, n) {
                            var o = n(9565), r = n(4901), i = n(34), a = TypeError;
                            t.exports = function(t, e) {
                                var n, s;
                                if ("string" === e && r(n = t.toString) && !i(s = o(n, t))) return s;
                                if (r(n = t.valueOf) && !i(s = o(n, t))) return s;
                                if ("string" !== e && r(n = t.toString) && !i(s = o(n, t))) return s;
                                throw new a("Can't convert object to primitive value");
                            };
                        },
                        5031: function(t, e, n) {
                            var o = n(7751), r = n(9504), i = n(8480), a = n(3717), s = n(8551), u = r([].concat);
                            t.exports = o("Reflect", "ownKeys") || function(t) {
                                var e = i.f(s(t)), n = a.f;
                                return n ? u(e, n(t)) : e;
                            };
                        },
                        9167: function(t, e, n) {
                            var o = n(4576);
                            t.exports = o;
                        },
                        1056: function(t, e, n) {
                            var o = n(4913).f;
                            t.exports = function(t, e, n) {
                                n in t || o(t, n, {
                                    configurable: !0,
                                    get: function() {
                                        return e[n];
                                    },
                                    set: function(t) {
                                        e[n] = t;
                                    }
                                });
                            };
                        },
                        6682: function(t, e, n) {
                            var o = n(9565), r = n(8551), i = n(4901), a = n(2195), s = n(7323), u = TypeError;
                            t.exports = function(t, e) {
                                var n = t.exec;
                                if (i(n)) {
                                    var c = o(n, t, e);
                                    return null !== c && r(c), c;
                                }
                                if ("RegExp" === a(t)) return o(s, t, e);
                                throw new u("RegExp#exec called on incompatible receiver");
                            };
                        },
                        7323: function(t, e, n) {
                            var o, r, i = n(9565), a = n(9504), s = n(655), u = n(7979), c = n(8429), l = n(5745), f = n(2360), d = n(1181).get, p = n(3635), h = n(8814), v = l("native-string-replace", String.prototype.replace), y = RegExp.prototype.exec, g = y, m = a("".charAt), b = a("".indexOf), w = a("".replace), x = a("".slice), E = (r = /b*/g, i(y, o = /a/, "a"), i(y, r, "a"), 0 !== o.lastIndex || 0 !== r.lastIndex), O = c.BROKEN_CARET, S = void 0 !== /()??/.exec("")[1];
                            (E || S || O || p || h) && (g = function(t) {
                                var e, n, o, r, a, c, l, p = this, h = d(p), k = s(t), P = h.raw;
                                if (P) return P.lastIndex = p.lastIndex, e = i(g, P, k), p.lastIndex = P.lastIndex, e;
                                var I = h.groups, C = O && p.sticky, A = i(u, p), M = p.source, D = 0, T = k;
                                if (C && (A = w(A, "y", ""), -1 === b(A, "g") && (A += "g"), T = x(k, p.lastIndex), p.lastIndex > 0 && (!p.multiline || p.multiline && "\n" !== m(k, p.lastIndex - 1)) && (M = "(?: " + M + ")", T = " " + T, D++), n = new RegExp("^(?:" + M + ")", A)), S && (n = new RegExp("^" + M + "$(?!\\s)", A)), E && (o = p.lastIndex), r = i(y, C ? n : p, T), C ? r ? (r.input = x(r.input, D), r[0] = x(r[0], D), r.index = p.lastIndex, p.lastIndex += r[0].length) : p.lastIndex = 0 : E && r && (p.lastIndex = p.global ? r.index + r[0].length : o), S && r && r.length > 1 && i(v, r[0], n, function() {
                                    for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (r[a] = void 0);
                                }), r && I) for(r.groups = c = f(null), a = 0; a < I.length; a++)c[(l = I[a])[0]] = r[l[1]];
                                return r;
                            }), t.exports = g;
                        },
                        7979: function(t, e, n) {
                            var o = n(8551);
                            t.exports = function() {
                                var t = o(this), e = "";
                                return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
                            };
                        },
                        1034: function(t, e, n) {
                            var o = n(9565), r = n(9297), i = n(1625), a = n(7979), s = RegExp.prototype;
                            t.exports = function(t) {
                                var e = t.flags;
                                return void 0 !== e || "flags" in s || r(t, "flags") || !i(s, t) ? e : o(a, t);
                            };
                        },
                        8429: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp, i = o(function() {
                                var t = r("a", "y");
                                return t.lastIndex = 2, null !== t.exec("abcd");
                            }), a = i || o(function() {
                                return !r("a", "y").sticky;
                            }), s = i || o(function() {
                                var t = r("^r", "gy");
                                return t.lastIndex = 2, null !== t.exec("str");
                            });
                            t.exports = {
                                BROKEN_CARET: s,
                                MISSED_STICKY: a,
                                UNSUPPORTED_Y: i
                            };
                        },
                        3635: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp;
                            t.exports = o(function() {
                                var t = r(".", "s");
                                return !(t.dotAll && t.test("\n") && "s" === t.flags);
                            });
                        },
                        8814: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp;
                            t.exports = o(function() {
                                var t = r("(?<a>b)", "g");
                                return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c");
                            });
                        },
                        7750: function(t, e, n) {
                            var o = n(4117), r = TypeError;
                            t.exports = function(t) {
                                if (o(t)) throw new r("Can't call method on " + t);
                                return t;
                            };
                        },
                        7633: function(t, e, n) {
                            var o = n(7751), r = n(2106), i = n(8227), a = n(3724), s = i("species");
                            t.exports = function(t) {
                                var e = o(t);
                                a && e && !e[s] && r(e, s, {
                                    configurable: !0,
                                    get: function() {
                                        return this;
                                    }
                                });
                            };
                        },
                        687: function(t, e, n) {
                            var o = n(4913).f, r = n(9297), i = n(8227)("toStringTag");
                            t.exports = function(t, e, n) {
                                t && !n && (t = t.prototype), t && !r(t, i) && o(t, i, {
                                    configurable: !0,
                                    value: e
                                });
                            };
                        },
                        6119: function(t, e, n) {
                            var o = n(5745), r = n(3392), i = o("keys");
                            t.exports = function(t) {
                                return i[t] || (i[t] = r(t));
                            };
                        },
                        7629: function(t, e, n) {
                            var o = n(6395), r = n(4576), i = n(9433), a = "__core-js_shared__", s = t.exports = r[a] || i(a, {});
                            (s.versions || (s.versions = [])).push({
                                version: "3.39.0",
                                mode: o ? "pure" : "global",
                                copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
                                license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
                                source: "https://github.com/zloirock/core-js"
                            });
                        },
                        5745: function(t, e, n) {
                            var o = n(7629);
                            t.exports = function(t, e) {
                                return o[t] || (o[t] = e || {});
                            };
                        },
                        2293: function(t, e, n) {
                            var o = n(8551), r = n(5548), i = n(4117), a = n(8227)("species");
                            t.exports = function(t, e) {
                                var n, s = o(t).constructor;
                                return void 0 === s || i(n = o(s)[a]) ? e : r(n);
                            };
                        },
                        8183: function(t, e, n) {
                            var o = n(9504), r = n(1291), i = n(655), a = n(7750), s = o("".charAt), u = o("".charCodeAt), c = o("".slice), l = function(t) {
                                return function(e, n) {
                                    var o, l, f = i(a(e)), d = r(n), p = f.length;
                                    return d < 0 || d >= p ? t ? "" : void 0 : (o = u(f, d)) < 55296 || o > 56319 || d + 1 === p || (l = u(f, d + 1)) < 56320 || l > 57343 ? t ? s(f, d) : o : t ? c(f, d, d + 2) : l - 56320 + (o - 55296 << 10) + 65536;
                                };
                            };
                            t.exports = {
                                codeAt: l(!1),
                                charAt: l(!0)
                            };
                        },
                        706: function(t, e, n) {
                            var o = n(350).PROPER, r = n(9039), i = n(7452);
                            t.exports = function(t) {
                                return r(function() {
                                    return !!i[t]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[t]() || o && i[t].name !== t;
                                });
                            };
                        },
                        3802: function(t, e, n) {
                            var o = n(9504), r = n(7750), i = n(655), a = n(7452), s = o("".replace), u = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(t) {
                                return function(e) {
                                    var n = i(r(e));
                                    return 1 & t && (n = s(n, u, "")), 2 & t && (n = s(n, c, "$1")), n;
                                };
                            };
                            t.exports = {
                                start: l(1),
                                end: l(2),
                                trim: l(3)
                            };
                        },
                        4495: function(t, e, n) {
                            var o = n(9519), r = n(9039), i = n(4576).String;
                            t.exports = !!Object.getOwnPropertySymbols && !r(function() {
                                var t = Symbol("symbol detection");
                                return !i(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && o && o < 41;
                            });
                        },
                        8242: function(t, e, n) {
                            var o = n(9565), r = n(7751), i = n(8227), a = n(6840);
                            t.exports = function() {
                                var t = r("Symbol"), e = t && t.prototype, n = e && e.valueOf, s = i("toPrimitive");
                                e && !e[s] && a(e, s, function(t) {
                                    return o(n, this);
                                }, {
                                    arity: 1
                                });
                            };
                        },
                        1296: function(t, e, n) {
                            var o = n(4495);
                            t.exports = o && !!Symbol.for && !!Symbol.keyFor;
                        },
                        1240: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o(1..valueOf);
                        },
                        5610: function(t, e, n) {
                            var o = n(1291), r = Math.max, i = Math.min;
                            t.exports = function(t, e) {
                                var n = o(t);
                                return n < 0 ? r(n + e, 0) : i(n, e);
                            };
                        },
                        5397: function(t, e, n) {
                            var o = n(7055), r = n(7750);
                            t.exports = function(t) {
                                return o(r(t));
                            };
                        },
                        1291: function(t, e, n) {
                            var o = n(741);
                            t.exports = function(t) {
                                var e = +t;
                                return e != e || 0 === e ? 0 : o(e);
                            };
                        },
                        8014: function(t, e, n) {
                            var o = n(1291), r = Math.min;
                            t.exports = function(t) {
                                var e = o(t);
                                return e > 0 ? r(e, 9007199254740991) : 0;
                            };
                        },
                        8981: function(t, e, n) {
                            var o = n(7750), r = Object;
                            t.exports = function(t) {
                                return r(o(t));
                            };
                        },
                        2777: function(t, e, n) {
                            var o = n(9565), r = n(34), i = n(757), a = n(5966), s = n(4270), u = n(8227), c = TypeError, l = u("toPrimitive");
                            t.exports = function(t, e) {
                                if (!r(t) || i(t)) return t;
                                var n, u = a(t, l);
                                if (u) {
                                    if (void 0 === e && (e = "default"), n = o(u, t, e), !r(n) || i(n)) return n;
                                    throw new c("Can't convert object to primitive value");
                                }
                                return void 0 === e && (e = "number"), s(t, e);
                            };
                        },
                        6969: function(t, e, n) {
                            var o = n(2777), r = n(757);
                            t.exports = function(t) {
                                var e = o(t, "string");
                                return r(e) ? e : e + "";
                            };
                        },
                        2140: function(t, e, n) {
                            var o = {};
                            o[n(8227)("toStringTag")] = "z", t.exports = "[object z]" === String(o);
                        },
                        655: function(t, e, n) {
                            var o = n(6955), r = String;
                            t.exports = function(t) {
                                if ("Symbol" === o(t)) throw new TypeError("Cannot convert a Symbol value to a string");
                                return r(t);
                            };
                        },
                        6823: function(t) {
                            var e = String;
                            t.exports = function(t) {
                                try {
                                    return e(t);
                                } catch (t) {
                                    return "Object";
                                }
                            };
                        },
                        3392: function(t, e, n) {
                            var o = n(9504), r = 0, i = Math.random(), a = o(1..toString);
                            t.exports = function(t) {
                                return "Symbol(" + (void 0 === t ? "" : t) + ")_" + a(++r + i, 36);
                            };
                        },
                        7040: function(t, e, n) {
                            var o = n(4495);
                            t.exports = o && !Symbol.sham && "symbol" == typeof Symbol.iterator;
                        },
                        8686: function(t, e, n) {
                            var o = n(3724), r = n(9039);
                            t.exports = o && r(function() {
                                return 42 !== Object.defineProperty(function() {}, "prototype", {
                                    value: 42,
                                    writable: !1
                                }).prototype;
                            });
                        },
                        8622: function(t, e, n) {
                            var o = n(4576), r = n(4901), i = o.WeakMap;
                            t.exports = r(i) && /native code/.test(String(i));
                        },
                        511: function(t, e, n) {
                            var o = n(9167), r = n(9297), i = n(1951), a = n(4913).f;
                            t.exports = function(t) {
                                var e = o.Symbol || (o.Symbol = {});
                                r(e, t) || a(e, t, {
                                    value: i.f(t)
                                });
                            };
                        },
                        1951: function(t, e, n) {
                            var o = n(8227);
                            e.f = o;
                        },
                        8227: function(t, e, n) {
                            var o = n(4576), r = n(5745), i = n(9297), a = n(3392), s = n(4495), u = n(7040), c = o.Symbol, l = r("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                            t.exports = function(t) {
                                return i(l, t) || (l[t] = s && i(c, t) ? c[t] : f("Symbol." + t)), l[t];
                            };
                        },
                        7452: function(t) {
                            t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
                        },
                        8706: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(4376), a = n(34), s = n(8981), u = n(6198), c = n(6837), l = n(4659), f = n(1469), d = n(597), p = n(8227), h = n(9519), v = p("isConcatSpreadable"), y = h >= 51 || !r(function() {
                                var t = [];
                                return t[v] = !1, t.concat()[0] !== t;
                            }), g = function(t) {
                                if (!a(t)) return !1;
                                var e = t[v];
                                return void 0 !== e ? !!e : i(t);
                            };
                            o({
                                target: "Array",
                                proto: !0,
                                arity: 1,
                                forced: !y || !d("concat")
                            }, {
                                concat: function(t) {
                                    var e, n, o, r, i, a = s(this), d = f(a, 0), p = 0;
                                    for(e = -1, o = arguments.length; e < o; e++)if (g(i = -1 === e ? a : arguments[e])) for(r = u(i), c(p + r), n = 0; n < r; n++, p++)n in i && l(d, p, i[n]);
                                    else c(p + 1), l(d, p++, i);
                                    return d.length = p, d;
                                }
                            });
                        },
                        2008: function(t, e, n) {
                            var o = n(6518), r = n(9213).filter;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(597)("filter")
                            }, {
                                filter: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        3418: function(t, e, n) {
                            var o = n(6518), r = n(7916);
                            o({
                                target: "Array",
                                stat: !0,
                                forced: !n(4428)(function(t) {
                                    Array.from(t);
                                })
                            }, {
                                from: r
                            });
                        },
                        4423: function(t, e, n) {
                            var o = n(6518), r = n(9617).includes, i = n(9039), a = n(6469);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: i(function() {
                                    return !Array(1).includes();
                                })
                            }, {
                                includes: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            }), a("includes");
                        },
                        5276: function(t, e, n) {
                            var o = n(6518), r = n(7476), i = n(9617).indexOf, a = n(4598), s = r([].indexOf), u = !!s && 1 / s([
                                1
                            ], 1, -0) < 0;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: u || !a("indexOf")
                            }, {
                                indexOf: function(t) {
                                    var e = arguments.length > 1 ? arguments[1] : void 0;
                                    return u ? s(this, t, e) || 0 : i(this, t, e);
                                }
                            });
                        },
                        3792: function(t, e, n) {
                            var o = n(5397), r = n(6469), i = n(6269), a = n(1181), s = n(4913).f, u = n(1088), c = n(2529), l = n(6395), f = n(3724), d = "Array Iterator", p = a.set, h = a.getterFor(d);
                            t.exports = u(Array, "Array", function(t, e) {
                                p(this, {
                                    type: d,
                                    target: o(t),
                                    index: 0,
                                    kind: e
                                });
                            }, function() {
                                var t = h(this), e = t.target, n = t.index++;
                                if (!e || n >= e.length) return t.target = null, c(void 0, !0);
                                switch(t.kind){
                                    case "keys":
                                        return c(n, !1);
                                    case "values":
                                        return c(e[n], !1);
                                }
                                return c([
                                    n,
                                    e[n]
                                ], !1);
                            }, "values");
                            var v = i.Arguments = i.Array;
                            if (r("keys"), r("values"), r("entries"), !l && f && "values" !== v.name) try {
                                s(v, "name", {
                                    value: "values"
                                });
                            } catch (t) {}
                        },
                        8598: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(7055), a = n(5397), s = n(4598), u = r([].join);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: i !== Object || !s("join", ",")
                            }, {
                                join: function(t) {
                                    return u(a(this), void 0 === t ? "," : t);
                                }
                            });
                        },
                        2062: function(t, e, n) {
                            var o = n(6518), r = n(9213).map;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(597)("map")
                            }, {
                                map: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        2712: function(t, e, n) {
                            var o = n(6518), r = n(926).left, i = n(4598), a = n(9519);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(6193) && a > 79 && a < 83 || !i("reduce")
                            }, {
                                reduce: function(t) {
                                    var e = arguments.length;
                                    return r(this, t, e, e > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        4782: function(t, e, n) {
                            var o = n(6518), r = n(4376), i = n(3517), a = n(34), s = n(5610), u = n(6198), c = n(5397), l = n(4659), f = n(8227), d = n(597), p = n(7680), h = d("slice"), v = f("species"), y = Array, g = Math.max;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !h
                            }, {
                                slice: function(t, e) {
                                    var n, o, f, d = c(this), h = u(d), m = s(t, h), b = s(void 0 === e ? h : e, h);
                                    if (r(d) && (n = d.constructor, (i(n) && (n === y || r(n.prototype)) || a(n) && null === (n = n[v])) && (n = void 0), n === y || void 0 === n)) return p(d, m, b);
                                    for(o = new (void 0 === n ? y : n)(g(b - m, 0)), f = 0; m < b; m++, f++)m in d && l(o, f, d[m]);
                                    return o.length = f, o;
                                }
                            });
                        },
                        6910: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(9306), a = n(8981), s = n(6198), u = n(4606), c = n(655), l = n(9039), f = n(4488), d = n(4598), p = n(3709), h = n(3763), v = n(9519), y = n(3607), g = [], m = r(g.sort), b = r(g.push), w = l(function() {
                                g.sort(void 0);
                            }), x = l(function() {
                                g.sort(null);
                            }), E = d("sort"), O = !l(function() {
                                if (v) return v < 70;
                                if (!(p && p > 3)) {
                                    if (h) return !0;
                                    if (y) return y < 603;
                                    var t, e, n, o, r = "";
                                    for(t = 65; t < 76; t++){
                                        switch(e = String.fromCharCode(t), t){
                                            case 66:
                                            case 69:
                                            case 70:
                                            case 72:
                                                n = 3;
                                                break;
                                            case 68:
                                            case 71:
                                                n = 4;
                                                break;
                                            default:
                                                n = 2;
                                        }
                                        for(o = 0; o < 47; o++)g.push({
                                            k: e + o,
                                            v: n
                                        });
                                    }
                                    for(g.sort(function(t, e) {
                                        return e.v - t.v;
                                    }), o = 0; o < g.length; o++)e = g[o].k.charAt(0), r.charAt(r.length - 1) !== e && (r += e);
                                    return "DGBEFHACIJK" !== r;
                                }
                            });
                            o({
                                target: "Array",
                                proto: !0,
                                forced: w || !x || !E || !O
                            }, {
                                sort: function(t) {
                                    void 0 !== t && i(t);
                                    var e = a(this);
                                    if (O) return void 0 === t ? m(e) : m(e, t);
                                    var n, o, r = [], l = s(e);
                                    for(o = 0; o < l; o++)o in e && b(r, e[o]);
                                    for(f(r, function(t) {
                                        return function(e, n) {
                                            return void 0 === n ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, n) || 0 : c(e) > c(n) ? 1 : -1;
                                        };
                                    }(t)), n = s(r), o = 0; o < n;)e[o] = r[o++];
                                    for(; o < l;)u(e, o++);
                                    return e;
                                }
                            });
                        },
                        4554: function(t, e, n) {
                            var o = n(6518), r = n(8981), i = n(5610), a = n(1291), s = n(6198), u = n(4527), c = n(6837), l = n(1469), f = n(4659), d = n(4606), p = n(597)("splice"), h = Math.max, v = Math.min;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !p
                            }, {
                                splice: function(t, e) {
                                    var n, o, p, y, g, m, b = r(this), w = s(b), x = i(t, w), E = arguments.length;
                                    for(0 === E ? n = o = 0 : 1 === E ? (n = 0, o = w - x) : (n = E - 2, o = v(h(a(e), 0), w - x)), c(w + n - o), p = l(b, o), y = 0; y < o; y++)(g = x + y) in b && f(p, y, b[g]);
                                    if (p.length = o, n < o) {
                                        for(y = x; y < w - o; y++)m = y + n, (g = y + o) in b ? b[m] = b[g] : d(b, m);
                                        for(y = w; y > w - o + n; y--)d(b, y - 1);
                                    } else if (n > o) for(y = w - o; y > x; y--)m = y + n - 1, (g = y + o - 1) in b ? b[m] = b[g] : d(b, m);
                                    for(y = 0; y < n; y++)b[y + x] = arguments[y + 2];
                                    return u(b, w - o + n), p;
                                }
                            });
                        },
                        739: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(8981), a = n(2777);
                            o({
                                target: "Date",
                                proto: !0,
                                arity: 1,
                                forced: r(function() {
                                    return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
                                        toISOString: function() {
                                            return 1;
                                        }
                                    });
                                })
                            }, {
                                toJSON: function(t) {
                                    var e = i(this), n = a(e, "number");
                                    return "number" != typeof n || isFinite(n) ? e.toISOString() : null;
                                }
                            });
                        },
                        9572: function(t, e, n) {
                            var o = n(9297), r = n(6840), i = n(3640), a = n(8227)("toPrimitive"), s = Date.prototype;
                            o(s, a) || r(s, a, i);
                        },
                        2010: function(t, e, n) {
                            var o = n(3724), r = n(350).EXISTS, i = n(9504), a = n(2106), s = Function.prototype, u = i(s.toString), c = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, l = i(c.exec);
                            o && !r && a(s, "name", {
                                configurable: !0,
                                get: function() {
                                    try {
                                        return l(c, u(this))[1];
                                    } catch (t) {
                                        return "";
                                    }
                                }
                            });
                        },
                        3110: function(t, e, n) {
                            var o = n(6518), r = n(7751), i = n(8745), a = n(9565), s = n(9504), u = n(9039), c = n(4901), l = n(757), f = n(7680), d = n(6933), p = n(4495), h = String, v = r("JSON", "stringify"), y = s(/./.exec), g = s("".charAt), m = s("".charCodeAt), b = s("".replace), w = s(1..toString), x = /[\uD800-\uDFFF]/g, E = /^[\uD800-\uDBFF]$/, O = /^[\uDC00-\uDFFF]$/, S = !p || u(function() {
                                var t = r("Symbol")("stringify detection");
                                return "[null]" !== v([
                                    t
                                ]) || "{}" !== v({
                                    a: t
                                }) || "{}" !== v(Object(t));
                            }), k = u(function() {
                                return '"\udf06\ud834"' !== v("\udf06\ud834") || '"\udead"' !== v("\udead");
                            }), P = function(t, e) {
                                var n = f(arguments), o = d(e);
                                if (c(o) || void 0 !== t && !l(t)) return n[1] = function(t, e) {
                                    if (c(o) && (e = a(o, this, h(t), e)), !l(e)) return e;
                                }, i(v, null, n);
                            }, I = function(t, e, n) {
                                var o = g(n, e - 1), r = g(n, e + 1);
                                return y(E, t) && !y(O, r) || y(O, t) && !y(E, o) ? "\\u" + w(m(t, 0), 16) : t;
                            };
                            v && o({
                                target: "JSON",
                                stat: !0,
                                arity: 3,
                                forced: S || k
                            }, {
                                stringify: function(t, e, n) {
                                    var o = f(arguments), r = i(S ? P : v, null, o);
                                    return k && "string" == typeof r ? b(r, x, I) : r;
                                }
                            });
                        },
                        2892: function(t, e, n) {
                            var o = n(6518), r = n(6395), i = n(3724), a = n(4576), s = n(9167), u = n(9504), c = n(2796), l = n(9297), f = n(3167), d = n(1625), p = n(757), h = n(2777), v = n(9039), y = n(8480).f, g = n(7347).f, m = n(4913).f, b = n(1240), w = n(3802).trim, x = "Number", E = a[x], O = s[x], S = E.prototype, k = a.TypeError, P = u("".slice), I = u("".charCodeAt), C = function(t) {
                                var e, n, o, r, i, a, s, u, c = h(t, "number");
                                if (p(c)) throw new k("Cannot convert a Symbol value to a number");
                                if ("string" == typeof c && c.length > 2) {
                                    if (c = w(c), 43 === (e = I(c, 0)) || 45 === e) {
                                        if (88 === (n = I(c, 2)) || 120 === n) return NaN;
                                    } else if (48 === e) {
                                        switch(I(c, 1)){
                                            case 66:
                                            case 98:
                                                o = 2, r = 49;
                                                break;
                                            case 79:
                                            case 111:
                                                o = 8, r = 55;
                                                break;
                                            default:
                                                return +c;
                                        }
                                        for(a = (i = P(c, 2)).length, s = 0; s < a; s++)if ((u = I(i, s)) < 48 || u > r) return NaN;
                                        return parseInt(i, o);
                                    }
                                }
                                return +c;
                            }, A = c(x, !E(" 0o1") || !E("0b1") || E("+0x1")), M = function(t) {
                                var e, n = arguments.length < 1 ? 0 : E(function(t) {
                                    var e = h(t, "number");
                                    return "bigint" == typeof e ? e : C(e);
                                }(t));
                                return d(S, e = this) && v(function() {
                                    b(e);
                                }) ? f(Object(n), this, M) : n;
                            };
                            M.prototype = S, A && !r && (S.constructor = M), o({
                                global: !0,
                                constructor: !0,
                                wrap: !0,
                                forced: A
                            }, {
                                Number: M
                            });
                            var D = function(t, e) {
                                for(var n, o = i ? y(e) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), r = 0; o.length > r; r++)l(e, n = o[r]) && !l(t, n) && m(t, n, g(e, n));
                            };
                            r && O && D(s[x], O), (A || r) && D(s[x], E);
                        },
                        2637: function(t, e, n) {
                            n(6518)({
                                target: "Number",
                                stat: !0
                            }, {
                                isInteger: n(2087)
                            });
                        },
                        9085: function(t, e, n) {
                            var o = n(6518), r = n(4213);
                            o({
                                target: "Object",
                                stat: !0,
                                arity: 2,
                                forced: Object.assign !== r
                            }, {
                                assign: r
                            });
                        },
                        7427: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(2551), a = n(9306), s = n(8981), u = n(4913);
                            r && o({
                                target: "Object",
                                proto: !0,
                                forced: i
                            }, {
                                __defineGetter__: function(t, e) {
                                    u.f(s(this), t, {
                                        get: a(e),
                                        enumerable: !0,
                                        configurable: !0
                                    });
                                }
                            });
                        },
                        3851: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(5397), a = n(7347).f, s = n(3724);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: !s || r(function() {
                                    a(1);
                                }),
                                sham: !s
                            }, {
                                getOwnPropertyDescriptor: function(t, e) {
                                    return a(i(t), e);
                                }
                            });
                        },
                        1278: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(5031), a = n(5397), s = n(7347), u = n(4659);
                            o({
                                target: "Object",
                                stat: !0,
                                sham: !r
                            }, {
                                getOwnPropertyDescriptors: function(t) {
                                    for(var e, n, o = a(t), r = s.f, c = i(o), l = {}, f = 0; c.length > f;)void 0 !== (n = r(o, e = c[f++])) && u(l, e, n);
                                    return l;
                                }
                            });
                        },
                        1480: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(298).f;
                            o({
                                target: "Object",
                                stat: !0,
                                forced: r(function() {
                                    return !Object.getOwnPropertyNames(1);
                                })
                            }, {
                                getOwnPropertyNames: i
                            });
                        },
                        9773: function(t, e, n) {
                            var o = n(6518), r = n(4495), i = n(9039), a = n(3717), s = n(8981);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: !r || i(function() {
                                    a.f(1);
                                })
                            }, {
                                getOwnPropertySymbols: function(t) {
                                    var e = a.f;
                                    return e ? e(s(t)) : [];
                                }
                            });
                        },
                        9432: function(t, e, n) {
                            var o = n(6518), r = n(8981), i = n(1072);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: n(9039)(function() {
                                    i(1);
                                })
                            }, {
                                keys: function(t) {
                                    return i(r(t));
                                }
                            });
                        },
                        6099: function(t, e, n) {
                            var o = n(2140), r = n(6840), i = n(3179);
                            o || r(Object.prototype, "toString", i, {
                                unsafe: !0
                            });
                        },
                        4864: function(t, e, n) {
                            var o = n(3724), r = n(4576), i = n(9504), a = n(2796), s = n(3167), u = n(6699), c = n(2360), l = n(8480).f, f = n(1625), d = n(788), p = n(655), h = n(1034), v = n(8429), y = n(1056), g = n(6840), m = n(9039), b = n(9297), w = n(1181).enforce, x = n(7633), E = n(8227), O = n(3635), S = n(8814), k = E("match"), P = r.RegExp, I = P.prototype, C = r.SyntaxError, A = i(I.exec), M = i("".charAt), D = i("".replace), T = i("".indexOf), N = i("".slice), j = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, R = /a/g, L = /a/g, B = new P(R) !== R, K = v.MISSED_STICKY, _ = v.UNSUPPORTED_Y;
                            if (a("RegExp", o && (!B || K || O || S || m(function() {
                                return L[k] = !1, P(R) !== R || P(L) === L || "/a/i" !== String(P(R, "i"));
                            })))) {
                                for(var F = function(t, e) {
                                    var n, o, r, i, a, l, v = f(I, this), y = d(t), g = void 0 === e, m = [], x = t;
                                    if (!v && y && g && t.constructor === F) return t;
                                    if ((y || f(I, t)) && (t = t.source, g && (e = h(x))), t = void 0 === t ? "" : p(t), e = void 0 === e ? "" : p(e), x = t, O && ("dotAll" in R) && (o = !!e && T(e, "s") > -1) && (e = D(e, /s/g, "")), n = e, K && ("sticky" in R) && (r = !!e && T(e, "y") > -1) && _ && (e = D(e, /y/g, "")), S && (i = function(t) {
                                        for(var e, n = t.length, o = 0, r = "", i = [], a = c(null), s = !1, u = !1, l = 0, f = ""; o <= n; o++){
                                            if ("\\" === (e = M(t, o))) e += M(t, ++o);
                                            else if ("]" === e) s = !1;
                                            else if (!s) switch(!0){
                                                case "[" === e:
                                                    s = !0;
                                                    break;
                                                case "(" === e:
                                                    if (r += e, "?:" === N(t, o + 1, o + 3)) continue;
                                                    A(j, N(t, o + 1)) && (o += 2, u = !0), l++;
                                                    continue;
                                                case ">" === e && u:
                                                    if ("" === f || b(a, f)) throw new C("Invalid capture group name");
                                                    a[f] = !0, i[i.length] = [
                                                        f,
                                                        l
                                                    ], u = !1, f = "";
                                                    continue;
                                            }
                                            u ? f += e : r += e;
                                        }
                                        return [
                                            r,
                                            i
                                        ];
                                    }(t), t = i[0], m = i[1]), a = s(P(t, e), v ? this : I, F), (o || r || m.length) && (l = w(a), o && (l.dotAll = !0, l.raw = F(function(t) {
                                        for(var e, n = t.length, o = 0, r = "", i = !1; o <= n; o++)"\\" !== (e = M(t, o)) ? i || "." !== e ? ("[" === e ? i = !0 : "]" === e && (i = !1), r += e) : r += "[\\s\\S]" : r += e + M(t, ++o);
                                        return r;
                                    }(t), n)), r && (l.sticky = !0), m.length && (l.groups = m)), t !== x) try {
                                        u(a, "source", "" === x ? "(?:)" : x);
                                    } catch (t) {}
                                    return a;
                                }, U = l(P), H = 0; U.length > H;)y(F, P, U[H++]);
                                I.constructor = F, F.prototype = I, g(r, "RegExp", F, {
                                    constructor: !0
                                });
                            }
                            x("RegExp");
                        },
                        7495: function(t, e, n) {
                            var o = n(6518), r = n(7323);
                            o({
                                target: "RegExp",
                                proto: !0,
                                forced: /./.exec !== r
                            }, {
                                exec: r
                            });
                        },
                        8781: function(t, e, n) {
                            var o = n(350).PROPER, r = n(6840), i = n(8551), a = n(655), s = n(9039), u = n(1034), c = "toString", l = RegExp.prototype, f = l[c], d = s(function() {
                                return "/a/b" !== f.call({
                                    source: "a",
                                    flags: "b"
                                });
                            }), p = o && f.name !== c;
                            (d || p) && r(l, c, function() {
                                var t = i(this);
                                return "/" + a(t.source) + "/" + a(u(t));
                            }, {
                                unsafe: !0
                            });
                        },
                        1699: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(5749), a = n(7750), s = n(655), u = n(1436), c = r("".indexOf);
                            o({
                                target: "String",
                                proto: !0,
                                forced: !u("includes")
                            }, {
                                includes: function(t) {
                                    return !!~c(s(a(this)), s(i(t)), arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        7764: function(t, e, n) {
                            var o = n(8183).charAt, r = n(655), i = n(1181), a = n(1088), s = n(2529), u = "String Iterator", c = i.set, l = i.getterFor(u);
                            a(String, "String", function(t) {
                                c(this, {
                                    type: u,
                                    string: r(t),
                                    index: 0
                                });
                            }, function() {
                                var t, e = l(this), n = e.string, r = e.index;
                                return r >= n.length ? s(void 0, !0) : (t = o(n, r), e.index += t.length, s(t, !1));
                            });
                        },
                        8543: function(t, e, n) {
                            var o = n(6518), r = n(9565), i = n(7476), a = n(3994), s = n(2529), u = n(7750), c = n(8014), l = n(655), f = n(8551), d = n(4117), p = n(2195), h = n(788), v = n(1034), y = n(5966), g = n(6840), m = n(9039), b = n(8227), w = n(2293), x = n(7829), E = n(6682), O = n(1181), S = n(6395), k = b("matchAll"), P = "RegExp String", I = P + " Iterator", C = O.set, A = O.getterFor(I), M = RegExp.prototype, D = TypeError, T = i("".indexOf), N = i("".matchAll), j = !!N && !m(function() {
                                N("a", /./);
                            }), R = a(function(t, e, n, o) {
                                C(this, {
                                    type: I,
                                    regexp: t,
                                    string: e,
                                    global: n,
                                    unicode: o,
                                    done: !1
                                });
                            }, P, function() {
                                var t = A(this);
                                if (t.done) return s(void 0, !0);
                                var e = t.regexp, n = t.string, o = E(e, n);
                                return null === o ? (t.done = !0, s(void 0, !0)) : t.global ? ("" === l(o[0]) && (e.lastIndex = x(n, c(e.lastIndex), t.unicode)), s(o, !1)) : (t.done = !0, s(o, !1));
                            }), L = function(t) {
                                var e, n, o, r = f(this), i = l(t), a = w(r, RegExp), s = l(v(r));
                                return e = new a(a === RegExp ? r.source : r, s), n = !!~T(s, "g"), o = !!~T(s, "u"), e.lastIndex = c(r.lastIndex), new R(e, i, n, o);
                            };
                            o({
                                target: "String",
                                proto: !0,
                                forced: j
                            }, {
                                matchAll: function(t) {
                                    var e, n, o, i, a = u(this);
                                    if (d(t)) {
                                        if (j) return N(a, t);
                                    } else {
                                        if (h(t) && (e = l(u(v(t))), !~T(e, "g"))) throw new D("`.matchAll` does not allow non-global regexes");
                                        if (j) return N(a, t);
                                        if (void 0 === (o = y(t, k)) && S && "RegExp" === p(t) && (o = L), o) return r(o, t, a);
                                    }
                                    return n = l(a), i = new RegExp(t, "g"), S ? r(L, i, n) : i[k](n);
                                }
                            }), S || k in M || g(M, k, L);
                        },
                        1761: function(t, e, n) {
                            var o = n(9565), r = n(9228), i = n(8551), a = n(4117), s = n(8014), u = n(655), c = n(7750), l = n(5966), f = n(7829), d = n(6682);
                            r("match", function(t, e, n) {
                                return [
                                    function(e) {
                                        var n = c(this), r = a(e) ? void 0 : l(e, t);
                                        return r ? o(r, e, n) : new RegExp(e)[t](u(n));
                                    },
                                    function(t) {
                                        var o = i(this), r = u(t), a = n(e, o, r);
                                        if (a.done) return a.value;
                                        if (!o.global) return d(o, r);
                                        var c = o.unicode;
                                        o.lastIndex = 0;
                                        for(var l, p = [], h = 0; null !== (l = d(o, r));){
                                            var v = u(l[0]);
                                            p[h] = v, "" === v && (o.lastIndex = f(r, s(o.lastIndex), c)), h++;
                                        }
                                        return 0 === h ? null : p;
                                    }
                                ];
                            });
                        },
                        5440: function(t, e, n) {
                            var o = n(8745), r = n(9565), i = n(9504), a = n(9228), s = n(9039), u = n(8551), c = n(4901), l = n(4117), f = n(1291), d = n(8014), p = n(655), h = n(7750), v = n(7829), y = n(5966), g = n(2478), m = n(6682), b = n(8227)("replace"), w = Math.max, x = Math.min, E = i([].concat), O = i([].push), S = i("".indexOf), k = i("".slice), P = "$0" === "a".replace(/./, "$0"), I = !!/./[b] && "" === /./[b]("a", "$0");
                            a("replace", function(t, e, n) {
                                var i = I ? "$" : "$0";
                                return [
                                    function(t, n) {
                                        var o = h(this), i = l(t) ? void 0 : y(t, b);
                                        return i ? r(i, t, o, n) : r(e, p(o), t, n);
                                    },
                                    function(t, r) {
                                        var a = u(this), s = p(t);
                                        if ("string" == typeof r && -1 === S(r, i) && -1 === S(r, "$<")) {
                                            var l = n(e, a, s, r);
                                            if (l.done) return l.value;
                                        }
                                        var h = c(r);
                                        h || (r = p(r));
                                        var y, b = a.global;
                                        b && (y = a.unicode, a.lastIndex = 0);
                                        for(var P, I = []; null !== (P = m(a, s)) && (O(I, P), b);)"" === p(P[0]) && (a.lastIndex = v(s, d(a.lastIndex), y));
                                        for(var C, A = "", M = 0, D = 0; D < I.length; D++){
                                            for(var T, N = p((P = I[D])[0]), j = w(x(f(P.index), s.length), 0), R = [], L = 1; L < P.length; L++)O(R, void 0 === (C = P[L]) ? C : String(C));
                                            var B = P.groups;
                                            if (h) {
                                                var K = E([
                                                    N
                                                ], R, j, s);
                                                void 0 !== B && O(K, B), T = p(o(r, void 0, K));
                                            } else T = g(N, s, j, R, B, r);
                                            j >= M && (A += k(s, M, j) + T, M = j + N.length);
                                        }
                                        return A + k(s, M);
                                    }
                                ];
                            }, !!s(function() {
                                var t = /./;
                                return t.exec = function() {
                                    var t = [];
                                    return t.groups = {
                                        a: "7"
                                    }, t;
                                }, "7" !== "".replace(t, "$<a>");
                            }) || !P || I);
                        },
                        744: function(t, e, n) {
                            var o = n(9565), r = n(9504), i = n(9228), a = n(8551), s = n(4117), u = n(7750), c = n(2293), l = n(7829), f = n(8014), d = n(655), p = n(5966), h = n(6682), v = n(8429), y = n(9039), g = v.UNSUPPORTED_Y, m = Math.min, b = r([].push), w = r("".slice), x = !y(function() {
                                var t = /(?:)/, e = t.exec;
                                t.exec = function() {
                                    return e.apply(this, arguments);
                                };
                                var n = "ab".split(t);
                                return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
                            }), E = "c" === "abbc".split(/(b)*/)[1] || 4 !== "test".split(/(?:)/, -1).length || 2 !== "ab".split(/(?:ab)*/).length || 4 !== ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length;
                            i("split", function(t, e, n) {
                                var r = "0".split(void 0, 0).length ? function(t, n) {
                                    return void 0 === t && 0 === n ? [] : o(e, this, t, n);
                                } : e;
                                return [
                                    function(e, n) {
                                        var i = u(this), a = s(e) ? void 0 : p(e, t);
                                        return a ? o(a, e, i, n) : o(r, d(i), e, n);
                                    },
                                    function(t, o) {
                                        var i = a(this), s = d(t);
                                        if (!E) {
                                            var u = n(r, i, s, o, r !== e);
                                            if (u.done) return u.value;
                                        }
                                        var p = c(i, RegExp), v = i.unicode, y = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (g ? "g" : "y"), x = new p(g ? "^(?:" + i.source + ")" : i, y), O = void 0 === o ? 4294967295 : o >>> 0;
                                        if (0 === O) return [];
                                        if (0 === s.length) return null === h(x, s) ? [
                                            s
                                        ] : [];
                                        for(var S = 0, k = 0, P = []; k < s.length;){
                                            x.lastIndex = g ? 0 : k;
                                            var I, C = h(x, g ? w(s, k) : s);
                                            if (null === C || (I = m(f(x.lastIndex + (g ? k : 0)), s.length)) === S) k = l(s, k, v);
                                            else {
                                                if (b(P, w(s, S, k)), P.length === O) return P;
                                                for(var A = 1; A <= C.length - 1; A++)if (b(P, C[A]), P.length === O) return P;
                                                k = S = I;
                                            }
                                        }
                                        return b(P, w(s, S)), P;
                                    }
                                ];
                            }, E || !x, g);
                        },
                        2762: function(t, e, n) {
                            var o = n(6518), r = n(3802).trim;
                            o({
                                target: "String",
                                proto: !0,
                                forced: n(706)("trim")
                            }, {
                                trim: function() {
                                    return r(this);
                                }
                            });
                        },
                        6761: function(t, e, n) {
                            var o = n(6518), r = n(4576), i = n(9565), a = n(9504), s = n(6395), u = n(3724), c = n(4495), l = n(9039), f = n(9297), d = n(1625), p = n(8551), h = n(5397), v = n(6969), y = n(655), g = n(6980), m = n(2360), b = n(1072), w = n(8480), x = n(298), E = n(3717), O = n(7347), S = n(4913), k = n(6801), P = n(8773), I = n(6840), C = n(2106), A = n(5745), M = n(6119), D = n(421), T = n(3392), N = n(8227), j = n(1951), R = n(511), L = n(8242), B = n(687), K = n(1181), _ = n(9213).forEach, F = M("hidden"), U = "Symbol", H = "prototype", $ = K.set, G = K.getterFor(U), V = Object[H], z = r.Symbol, Y = z && z[H], W = r.RangeError, J = r.TypeError, X = r.QObject, q = O.f, Q = S.f, Z = x.f, tt = P.f, et = a([].push), nt = A("symbols"), ot = A("op-symbols"), rt = A("wks"), it = !X || !X[H] || !X[H].findChild, at = function(t, e, n) {
                                var o = q(V, e);
                                o && delete V[e], Q(t, e, n), o && t !== V && Q(V, e, o);
                            }, st = u && l(function() {
                                return 7 !== m(Q({}, "a", {
                                    get: function() {
                                        return Q(this, "a", {
                                            value: 7
                                        }).a;
                                    }
                                })).a;
                            }) ? at : Q, ut = function(t, e) {
                                var n = nt[t] = m(Y);
                                return $(n, {
                                    type: U,
                                    tag: t,
                                    description: e
                                }), u || (n.description = e), n;
                            }, ct = function(t, e, n) {
                                t === V && ct(ot, e, n), p(t);
                                var o = v(e);
                                return p(n), f(nt, o) ? (n.enumerable ? (f(t, F) && t[F][o] && (t[F][o] = !1), n = m(n, {
                                    enumerable: g(0, !1)
                                })) : (f(t, F) || Q(t, F, g(1, m(null))), t[F][o] = !0), st(t, o, n)) : Q(t, o, n);
                            }, lt = function(t, e) {
                                p(t);
                                var n = h(e), o = b(n).concat(ht(n));
                                return _(o, function(e) {
                                    u && !i(ft, n, e) || ct(t, e, n[e]);
                                }), t;
                            }, ft = function(t) {
                                var e = v(t), n = i(tt, this, e);
                                return !(this === V && f(nt, e) && !f(ot, e)) && (!(n || !f(this, e) || !f(nt, e) || f(this, F) && this[F][e]) || n);
                            }, dt = function(t, e) {
                                var n = h(t), o = v(e);
                                if (n !== V || !f(nt, o) || f(ot, o)) {
                                    var r = q(n, o);
                                    return !r || !f(nt, o) || f(n, F) && n[F][o] || (r.enumerable = !0), r;
                                }
                            }, pt = function(t) {
                                var e = Z(h(t)), n = [];
                                return _(e, function(t) {
                                    f(nt, t) || f(D, t) || et(n, t);
                                }), n;
                            }, ht = function(t) {
                                var e = t === V, n = Z(e ? ot : h(t)), o = [];
                                return _(n, function(t) {
                                    !f(nt, t) || e && !f(V, t) || et(o, nt[t]);
                                }), o;
                            };
                            c || (z = function() {
                                if (d(Y, this)) throw new J("Symbol is not a constructor");
                                var t = arguments.length && void 0 !== arguments[0] ? y(arguments[0]) : void 0, e = T(t), n = function(t) {
                                    var o = void 0 === this ? r : this;
                                    o === V && i(n, ot, t), f(o, F) && f(o[F], e) && (o[F][e] = !1);
                                    var a = g(1, t);
                                    try {
                                        st(o, e, a);
                                    } catch (t) {
                                        if (!(t instanceof W)) throw t;
                                        at(o, e, a);
                                    }
                                };
                                return u && it && st(V, e, {
                                    configurable: !0,
                                    set: n
                                }), ut(e, t);
                            }, I(Y = z[H], "toString", function() {
                                return G(this).tag;
                            }), I(z, "withoutSetter", function(t) {
                                return ut(T(t), t);
                            }), P.f = ft, S.f = ct, k.f = lt, O.f = dt, w.f = x.f = pt, E.f = ht, j.f = function(t) {
                                return ut(N(t), t);
                            }, u && (C(Y, "description", {
                                configurable: !0,
                                get: function() {
                                    return G(this).description;
                                }
                            }), s || I(V, "propertyIsEnumerable", ft, {
                                unsafe: !0
                            }))), o({
                                global: !0,
                                constructor: !0,
                                wrap: !0,
                                forced: !c,
                                sham: !c
                            }, {
                                Symbol: z
                            }), _(b(rt), function(t) {
                                R(t);
                            }), o({
                                target: U,
                                stat: !0,
                                forced: !c
                            }, {
                                useSetter: function() {
                                    it = !0;
                                },
                                useSimple: function() {
                                    it = !1;
                                }
                            }), o({
                                target: "Object",
                                stat: !0,
                                forced: !c,
                                sham: !u
                            }, {
                                create: function(t, e) {
                                    return void 0 === e ? m(t) : lt(m(t), e);
                                },
                                defineProperty: ct,
                                defineProperties: lt,
                                getOwnPropertyDescriptor: dt
                            }), o({
                                target: "Object",
                                stat: !0,
                                forced: !c
                            }, {
                                getOwnPropertyNames: pt
                            }), L(), B(z, U), D[F] = !0;
                        },
                        9463: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(4576), a = n(9504), s = n(9297), u = n(4901), c = n(1625), l = n(655), f = n(2106), d = n(7740), p = i.Symbol, h = p && p.prototype;
                            if (r && u(p) && (!("description" in h) || void 0 !== p().description)) {
                                var v = {}, y = function() {
                                    var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : l(arguments[0]), e = c(h, this) ? new p(t) : void 0 === t ? p() : p(t);
                                    return "" === t && (v[e] = !0), e;
                                };
                                d(y, p), y.prototype = h, h.constructor = y;
                                var g = "Symbol(description detection)" === String(p("description detection")), m = a(h.valueOf), b = a(h.toString), w = /^Symbol\((.*)\)[^)]+$/, x = a("".replace), E = a("".slice);
                                f(h, "description", {
                                    configurable: !0,
                                    get: function() {
                                        var t = m(this);
                                        if (s(v, t)) return "";
                                        var e = b(t), n = g ? E(e, 7, -1) : x(e, w, "$1");
                                        return "" === n ? void 0 : n;
                                    }
                                }), o({
                                    global: !0,
                                    constructor: !0,
                                    forced: !0
                                }, {
                                    Symbol: y
                                });
                            }
                        },
                        1510: function(t, e, n) {
                            var o = n(6518), r = n(7751), i = n(9297), a = n(655), s = n(5745), u = n(1296), c = s("string-to-symbol-registry"), l = s("symbol-to-string-registry");
                            o({
                                target: "Symbol",
                                stat: !0,
                                forced: !u
                            }, {
                                for: function(t) {
                                    var e = a(t);
                                    if (i(c, e)) return c[e];
                                    var n = r("Symbol")(e);
                                    return c[e] = n, l[n] = e, n;
                                }
                            });
                        },
                        2259: function(t, e, n) {
                            n(511)("iterator");
                        },
                        2675: function(t, e, n) {
                            n(6761), n(1510), n(7812), n(3110), n(9773);
                        },
                        7812: function(t, e, n) {
                            var o = n(6518), r = n(9297), i = n(757), a = n(6823), s = n(5745), u = n(1296), c = s("symbol-to-string-registry");
                            o({
                                target: "Symbol",
                                stat: !0,
                                forced: !u
                            }, {
                                keyFor: function(t) {
                                    if (!i(t)) throw new TypeError(a(t) + " is not a symbol");
                                    if (r(c, t)) return c[t];
                                }
                            });
                        },
                        5700: function(t, e, n) {
                            var o = n(511), r = n(8242);
                            o("toPrimitive"), r();
                        },
                        8344: function(t, e, n) {
                            n(8543);
                        },
                        3500: function(t, e, n) {
                            var o = n(4576), r = n(7400), i = n(9296), a = n(235), s = n(6699), u = function(t) {
                                if (t && t.forEach !== a) try {
                                    s(t, "forEach", a);
                                } catch (e) {
                                    t.forEach = a;
                                }
                            };
                            for(var c in r)r[c] && u(o[c] && o[c].prototype);
                            u(i);
                        },
                        2953: function(t, e, n) {
                            var o = n(4576), r = n(7400), i = n(9296), a = n(3792), s = n(6699), u = n(687), c = n(8227)("iterator"), l = a.values, f = function(t, e) {
                                if (t) {
                                    if (t[c] !== l) try {
                                        s(t, c, l);
                                    } catch (e) {
                                        t[c] = l;
                                    }
                                    if (u(t, e, !0), r[e]) {
                                        for(var n in a)if (t[n] !== a[n]) try {
                                            s(t, n, a[n]);
                                        } catch (e) {
                                            t[n] = a[n];
                                        }
                                    }
                                }
                            };
                            for(var d in r)f(o[d] && o[d].prototype, d);
                            f(i, "DOMTokenList");
                        }
                    }, e = {};
                    function n(o) {
                        var r = e[o];
                        if (void 0 !== r) return r.exports;
                        var i = e[o] = {
                            exports: {}
                        };
                        return t[o].call(i.exports, i, i.exports, n), i.exports;
                    }
                    n.d = function(t, e) {
                        for(var o in e)n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
                            enumerable: !0,
                            get: e[o]
                        });
                    }, n.g = function() {
                        if ("object" == typeof globalThis) return globalThis;
                        try {
                            return this || new Function("return this")();
                        } catch (t) {
                            if ("object" == typeof window) return window;
                        }
                    }(), n.o = function(t, e) {
                        return Object.prototype.hasOwnProperty.call(t, e);
                    }, n.r = function(t) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    };
                    var o = {};
                    function r(t) {
                        return function(t) {
                            if (Array.isArray(t)) return a(t);
                        }(t) || function(t) {
                            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                        }(t) || i(t) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }
                    function i(t, e) {
                        if (t) {
                            if ("string" == typeof t) return a(t, e);
                            var n = ({}).toString.call(t).slice(8, -1);
                            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
                        }
                    }
                    function a(t, e) {
                        (null == e || e > t.length) && (e = t.length);
                        for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
                        return o;
                    }
                    function s(t) {
                        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, s(t);
                    }
                    function u(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, l(o.key), o);
                        }
                    }
                    function c(t, e, n) {
                        return (e = l(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function l(t) {
                        var e = function(t, e) {
                            if ("object" != s(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != s(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == s(e) ? e : e + "";
                    }
                    n.r(o), n.d(o, {
                        SimpleKeyboard: function() {
                            return T;
                        },
                        default: function() {
                            return N;
                        }
                    }), n(5276), n(8598), n(4782), n(4554), n(2010), n(7427), n(6099), n(7495), n(8781), n(5440), n(744), n(2762), "undefined" == typeof Element || "remove" in Element.prototype || (Element.prototype.remove = function() {
                        this.parentNode && this.parentNode.removeChild(this);
                    }), "undefined" != typeof self && "document" in self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(t) {
                        if ("Element" in t) {
                            var e = "classList", n = "prototype", o = t.Element[n], r = Object, i = String[n].trim || function() {
                                return this.replace(/^\s+|\s+$/g, "");
                            }, a = Array[n].indexOf || function(t) {
                                for(var e = 0, n = this.length; e < n; e++)if (e in this && this[e] === t) return e;
                                return -1;
                            }, s = function(t, e) {
                                this.name = t, this.code = DOMException[t], this.message = e;
                            }, u = function(t, e) {
                                if ("" === e) throw new s("SYNTAX_ERR", "The token must not be empty.");
                                if (/\s/.test(e)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                                return a.call(t, e);
                            }, c = function(t) {
                                for(var e = i.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], o = 0, r = n.length; o < r; o++)this.push(n[o]);
                                this._updateClassName = function() {
                                    t.setAttribute("class", this.toString());
                                };
                            }, l = c[n] = [], f = function() {
                                return new c(this);
                            };
                            if (s[n] = Error[n], l.item = function(t) {
                                return this[t] || null;
                            }, l.contains = function(t) {
                                return ~u(this, t + "");
                            }, l.add = function() {
                                var t, e = arguments, n = 0, o = e.length, r = !1;
                                do ~u(this, t = e[n] + "") || (this.push(t), r = !0);
                                while (++n < o);
                                r && this._updateClassName();
                            }, l.remove = function() {
                                var t, e, n = arguments, o = 0, r = n.length, i = !1;
                                do for(e = u(this, t = n[o] + ""); ~e;)this.splice(e, 1), i = !0, e = u(this, t);
                                while (++o < r);
                                i && this._updateClassName();
                            }, l.toggle = function(t, e) {
                                var n = this.contains(t), o = n ? !0 !== e && "remove" : !1 !== e && "add";
                                return o && this[o](t), !0 === e || !1 === e ? e : !n;
                            }, l.replace = function(t, e) {
                                var n = u(t + "");
                                ~n && (this.splice(n, 1, e), this._updateClassName());
                            }, l.toString = function() {
                                return this.join(" ");
                            }, r.defineProperty) {
                                var d = {
                                    get: f,
                                    enumerable: !0,
                                    configurable: !0
                                };
                                try {
                                    r.defineProperty(o, e, d);
                                } catch (t) {
                                    void 0 !== t.number && -2146823252 !== t.number || (d.enumerable = !1, r.defineProperty(o, e, d));
                                }
                            } else r[n].__defineGetter__ && o.__defineGetter__(e, f);
                        }
                    }(self), function() {
                        var t = document.createElement("_");
                        if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
                            var e = function(t) {
                                var e = DOMTokenList.prototype[t];
                                DOMTokenList.prototype[t] = function(t) {
                                    var n, o = arguments.length;
                                    for(n = 0; n < o; n++)t = arguments[n], e.call(this, t);
                                };
                            };
                            e("add"), e("remove");
                        }
                        if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
                            var n = DOMTokenList.prototype.toggle;
                            DOMTokenList.prototype.toggle = function(t, e) {
                                return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
                            };
                        }
                        "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function(t, e) {
                            var n = this.toString().split(" "), o = n.indexOf(t + "");
                            ~o && (n = n.slice(o), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
                        }), t = null;
                    }()), n(2675), n(9463), n(2259), n(5700), n(8706), n(2008), n(3418), n(4423), n(3792), n(2062), n(6910), n(739), n(9572), n(2892), n(9085), n(3851), n(1278), n(9432), n(4864), n(1699), n(7764), n(8344), n(3500), n(2953), n(2712), n(2637), n(1480), n(1761);
                    var f = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = e.getOptions, o = e.getCaretPosition, r = e.getCaretPositionEnd, i = e.dispatch;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), c(this, "getOptions", void 0), c(this, "getCaretPosition", void 0), c(this, "getCaretPositionEnd", void 0), c(this, "dispatch", void 0), c(this, "maxLengthReached", void 0), c(this, "isStandardButton", function(t) {
                                return t && !("{" === t[0] && "}" === t[t.length - 1]);
                            }), this.getOptions = n, this.getCaretPosition = o, this.getCaretPositionEnd = r, this.dispatch = i, t.bindMethods(t, this);
                        }, e = [
                            {
                                key: "getButtonType",
                                value: function(t) {
                                    return t.includes("{") && t.includes("}") && "{//}" !== t ? "functionBtn" : "standardBtn";
                                }
                            },
                            {
                                key: "getButtonClass",
                                value: function(t) {
                                    var e = this.getButtonType(t), n = t.replace("{", "").replace("}", ""), o = "";
                                    return "standardBtn" !== e && (o = " hg-button-".concat(n)), "hg-".concat(e).concat(o);
                                }
                            },
                            {
                                key: "getDefaultDiplay",
                                value: function() {
                                    return {
                                        "{bksp}": "backspace",
                                        "{backspace}": "backspace",
                                        "{enter}": "< enter",
                                        "{shift}": "shift",
                                        "{shiftleft}": "shift",
                                        "{shiftright}": "shift",
                                        "{alt}": "alt",
                                        "{s}": "shift",
                                        "{tab}": "tab",
                                        "{lock}": "caps",
                                        "{capslock}": "caps",
                                        "{accept}": "Submit",
                                        "{space}": " ",
                                        "{//}": " ",
                                        "{esc}": "esc",
                                        "{escape}": "esc",
                                        "{f1}": "f1",
                                        "{f2}": "f2",
                                        "{f3}": "f3",
                                        "{f4}": "f4",
                                        "{f5}": "f5",
                                        "{f6}": "f6",
                                        "{f7}": "f7",
                                        "{f8}": "f8",
                                        "{f9}": "f9",
                                        "{f10}": "f10",
                                        "{f11}": "f11",
                                        "{f12}": "f12",
                                        "{numpaddivide}": "/",
                                        "{numlock}": "lock",
                                        "{arrowup}": "\u2191",
                                        "{arrowleft}": "\u2190",
                                        "{arrowdown}": "\u2193",
                                        "{arrowright}": "\u2192",
                                        "{prtscr}": "print",
                                        "{scrolllock}": "scroll",
                                        "{pause}": "pause",
                                        "{insert}": "ins",
                                        "{home}": "home",
                                        "{pageup}": "up",
                                        "{delete}": "del",
                                        "{forwarddelete}": "del",
                                        "{end}": "end",
                                        "{pagedown}": "down",
                                        "{numpadmultiply}": "*",
                                        "{numpadsubtract}": "-",
                                        "{numpadadd}": "+",
                                        "{numpadenter}": "enter",
                                        "{period}": ".",
                                        "{numpaddecimal}": ".",
                                        "{numpad0}": "0",
                                        "{numpad1}": "1",
                                        "{numpad2}": "2",
                                        "{numpad3}": "3",
                                        "{numpad4}": "4",
                                        "{numpad5}": "5",
                                        "{numpad6}": "6",
                                        "{numpad7}": "7",
                                        "{numpad8}": "8",
                                        "{numpad9}": "9"
                                    };
                                }
                            },
                            {
                                key: "getButtonDisplayName",
                                value: function(t, e) {
                                    return (e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? Object.assign({}, this.getDefaultDiplay(), e) : e || this.getDefaultDiplay())[t] || t;
                                }
                            },
                            {
                                key: "getUpdatedInput",
                                value: function(t, e, n) {
                                    var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], i = this.getOptions(), a = [
                                        n,
                                        o,
                                        r
                                    ], s = e;
                                    return ("{bksp}" === t || "{backspace}" === t) && s.length > 0 ? s = this.removeAt.apply(this, [
                                        s
                                    ].concat(a)) : ("{delete}" === t || "{forwarddelete}" === t) && s.length > 0 ? s = this.removeForwardsAt.apply(this, [
                                        s
                                    ].concat(a)) : "{space}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        " "
                                    ].concat(a)) : "{tab}" !== t || "boolean" == typeof i.tabCharOnTab && !1 === i.tabCharOnTab ? "{enter}" !== t && "{numpadenter}" !== t || !i.newLineOnEnter ? t.includes("numpad") && Number.isInteger(Number(t[t.length - 2])) ? s = this.addStringAt.apply(this, [
                                        s,
                                        t[t.length - 2]
                                    ].concat(a)) : "{numpaddivide}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "/"
                                    ].concat(a)) : "{numpadmultiply}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "*"
                                    ].concat(a)) : "{numpadsubtract}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "-"
                                    ].concat(a)) : "{numpadadd}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "+"
                                    ].concat(a)) : "{numpaddecimal}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "."
                                    ].concat(a)) : "{" === t || "}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        t
                                    ].concat(a)) : t.includes("{") || t.includes("}") || (s = this.addStringAt.apply(this, [
                                        s,
                                        t
                                    ].concat(a))) : s = this.addStringAt.apply(this, [
                                        s,
                                        "\n"
                                    ].concat(a)) : s = this.addStringAt.apply(this, [
                                        s,
                                        "	"
                                    ].concat(a)), i.debug && console.log("Input will be: " + s), s;
                                }
                            },
                            {
                                key: "updateCaretPos",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.updateCaretPosAction(t, e);
                                    this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    });
                                }
                            },
                            {
                                key: "updateCaretPosAction",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.getOptions(), o = this.getCaretPosition();
                                    return null != o && (e ? o > 0 && (o -= t) : o += t), n.debug && console.log("Caret at:", o), o;
                                }
                            },
                            {
                                key: "addStringAt",
                                value: function(t, e) {
                                    var n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length, i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                                    return o || 0 === o ? (n = [
                                        t.slice(0, o),
                                        e,
                                        t.slice(r)
                                    ].join(""), this.isMaxLengthReached() || i && this.updateCaretPos(e.length)) : n = t + e, n;
                                }
                            },
                            {
                                key: "removeAt",
                                value: function(t) {
                                    var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                                    if (0 === n && 0 === o) return t;
                                    if (n === o) {
                                        var i = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                                        n && n >= 0 ? t.substring(n - 2, n).match(i) ? (e = t.substr(0, n - 2) + t.substr(n), r && this.updateCaretPos(2, !0)) : (e = t.substr(0, n - 1) + t.substr(n), r && this.updateCaretPos(1, !0)) : t.slice(-2).match(i) ? (e = t.slice(0, -2), r && this.updateCaretPos(2, !0)) : (e = t.slice(0, -1), r && this.updateCaretPos(1, !0));
                                    } else e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    });
                                    return e;
                                }
                            },
                            {
                                key: "removeForwardsAt",
                                value: function(t) {
                                    var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                                    return null != t && t.length && null !== n ? (n === o ? e = t.substring(n, n + 2).match(/([\uD800-\uDBFF][\uDC00-\uDFFF])/g) ? t.substr(0, n) + t.substr(n + 2) : t.substr(0, n) + t.substr(n + 1) : (e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    })), e) : t;
                                }
                            },
                            {
                                key: "handleMaxLength",
                                value: function(t, e) {
                                    var n = this.getOptions(), o = n.maxLength, r = t[n.inputName || "default"], i = e.length - 1 >= o;
                                    if (e.length <= r.length) return !1;
                                    if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", i), i ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                    if ("object" === s(o)) {
                                        var a = e.length - 1 >= o[n.inputName || "default"];
                                        return n.debug && console.log("maxLength (obj) reached:", a), a ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                    }
                                }
                            },
                            {
                                key: "isMaxLengthReached",
                                value: function() {
                                    return Boolean(this.maxLengthReached);
                                }
                            },
                            {
                                key: "isTouchDevice",
                                value: function() {
                                    return "ontouchstart" in window || navigator.maxTouchPoints;
                                }
                            },
                            {
                                key: "pointerEventsSupported",
                                value: function() {
                                    return !!window.PointerEvent;
                                }
                            },
                            {
                                key: "camelCase",
                                value: function(t) {
                                    return t ? t.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function(t, e) {
                                        return e.length ? t + e[0].toUpperCase() + e.slice(1) : t;
                                    }) : "";
                                }
                            },
                            {
                                key: "chunkArray",
                                value: function(t, e) {
                                    return r(Array(Math.ceil(t.length / e))).map(function(n, o) {
                                        return t.slice(e * o, e + e * o);
                                    });
                                }
                            },
                            {
                                key: "escapeRegex",
                                value: function(t) {
                                    return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                                }
                            },
                            {
                                key: "getRtlOffset",
                                value: function(t, e) {
                                    var n = t, o = e.indexOf("\u202B");
                                    return o < t && -1 != o && n--, e.indexOf("\u202C") < t && -1 != o && n--, n < 0 ? 0 : n;
                                }
                            }
                        ], n = [
                            {
                                key: "bindMethods",
                                value: function(t, e) {
                                    var n, o = function(t, e) {
                                        var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                                        if (!n) {
                                            if (Array.isArray(t) || (n = i(t)) || e && t && "number" == typeof t.length) {
                                                n && (t = n);
                                                var o = 0, r = function() {};
                                                return {
                                                    s: r,
                                                    n: function() {
                                                        return o >= t.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: t[o++]
                                                        };
                                                    },
                                                    e: function(t) {
                                                        throw t;
                                                    },
                                                    f: r
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var a, s = !0, u = !1;
                                        return {
                                            s: function() {
                                                n = n.call(t);
                                            },
                                            n: function() {
                                                var t = n.next();
                                                return s = t.done, t;
                                            },
                                            e: function(t) {
                                                u = !0, a = t;
                                            },
                                            f: function() {
                                                try {
                                                    s || null == n.return || n.return();
                                                } finally{
                                                    if (u) throw a;
                                                }
                                            }
                                        };
                                    }(Object.getOwnPropertyNames(t.prototype));
                                    try {
                                        for(o.s(); !(n = o.n()).done;){
                                            var r = n.value;
                                            "constructor" === r || "bindMethods" === r || (e[r] = e[r].bind(e));
                                        }
                                    } catch (t) {
                                        o.e(t);
                                    } finally{
                                        o.f();
                                    }
                                }
                            }
                        ], e && u(t.prototype, e), n && u(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }();
                    c(f, "noop", function() {});
                    var d = f;
                    function p(t) {
                        return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, p(t);
                    }
                    function h(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, y(o.key), o);
                        }
                    }
                    function v(t, e, n) {
                        return (e = y(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function y(t) {
                        var e = function(t, e) {
                            if ("object" != p(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != p(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == p(e) ? e : e + "";
                    }
                    var g = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = this, o = e.dispatch, r = e.getOptions;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), v(this, "getOptions", void 0), v(this, "dispatch", void 0), v(this, "isModifierKey", function(t) {
                                return t.altKey || t.ctrlKey || t.shiftKey || [
                                    "Tab",
                                    "CapsLock",
                                    "Esc",
                                    "ArrowUp",
                                    "ArrowDown",
                                    "ArrowLeft",
                                    "ArrowRight"
                                ].includes(t.code || t.key || n.keyCodeToKey(null == t ? void 0 : t.keyCode));
                            }), this.dispatch = o, this.getOptions = r, d.bindMethods(t, this);
                        }, e = [
                            {
                                key: "handleHighlightKeyDown",
                                value: function(t) {
                                    var e = this.getOptions();
                                    e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                                    var n = this.getSimpleKeyboardLayoutKey(t);
                                    this.dispatch(function(o) {
                                        var r, i, a = o.getButtonElement(n), s = o.getButtonElement("{".concat(n, "}"));
                                        if (a) r = a, i = n;
                                        else {
                                            if (!s) return;
                                            r = s, i = "{".concat(n, "}");
                                        }
                                        var u, c, l, f, d = function(t) {
                                            t.style.background = e.physicalKeyboardHighlightBgColor || "#dadce4", t.style.color = e.physicalKeyboardHighlightTextColor || "black";
                                        };
                                        if (r) {
                                            if (Array.isArray(r)) {
                                                if (r.forEach(function(t) {
                                                    return d(t);
                                                }), e.physicalKeyboardHighlightPress) {
                                                    if (e.physicalKeyboardHighlightPressUsePointerEvents) null === (u = r[0]) || void 0 === u || null === (c = u.onpointerdown) || void 0 === c || c.call(u, t);
                                                    else if (e.physicalKeyboardHighlightPressUseClick) {
                                                        var p;
                                                        null === (p = r[0]) || void 0 === p || p.click();
                                                    } else o.handleButtonClicked(i, t);
                                                }
                                            } else d(r), e.physicalKeyboardHighlightPress && (e.physicalKeyboardHighlightPressUsePointerEvents ? null === (l = r) || void 0 === l || null === (f = l.onpointerdown) || void 0 === f || f.call(l, t) : e.physicalKeyboardHighlightPressUseClick ? r.click() : o.handleButtonClicked(i, t));
                                        }
                                    });
                                }
                            },
                            {
                                key: "handleHighlightKeyUp",
                                value: function(t) {
                                    var e = this.getOptions();
                                    e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                                    var n = this.getSimpleKeyboardLayoutKey(t);
                                    this.dispatch(function(o) {
                                        var r, i, a, s = o.getButtonElement(n) || o.getButtonElement("{".concat(n, "}")), u = function(t) {
                                            t.removeAttribute && t.removeAttribute("style");
                                        };
                                        s && (Array.isArray(s) ? (s.forEach(function(t) {
                                            return u(t);
                                        }), e.physicalKeyboardHighlightPressUsePointerEvents && (null === (r = s[0]) || void 0 === r || null === (i = r.onpointerup) || void 0 === i || i.call(r, t))) : (u(s), e.physicalKeyboardHighlightPressUsePointerEvents && (null == s || null === (a = s.onpointerup) || void 0 === a || a.call(s, t))));
                                    });
                                }
                            },
                            {
                                key: "getSimpleKeyboardLayoutKey",
                                value: function(t) {
                                    var e, n = "", o = t.code || t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode);
                                    return (n = null != o && o.includes("Numpad") || null != o && o.includes("Shift") || null != o && o.includes("Space") || null != o && o.includes("Backspace") || null != o && o.includes("Control") || null != o && o.includes("Alt") || null != o && o.includes("Meta") ? t.code || "" : t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode) || "").length > 1 ? null === (e = n) || void 0 === e ? void 0 : e.toLowerCase() : n;
                                }
                            },
                            {
                                key: "keyCodeToKey",
                                value: function(t) {
                                    return ({
                                        8: "Backspace",
                                        9: "Tab",
                                        13: "Enter",
                                        16: "Shift",
                                        17: "Ctrl",
                                        18: "Alt",
                                        19: "Pause",
                                        20: "CapsLock",
                                        27: "Esc",
                                        32: "Space",
                                        33: "PageUp",
                                        34: "PageDown",
                                        35: "End",
                                        36: "Home",
                                        37: "ArrowLeft",
                                        38: "ArrowUp",
                                        39: "ArrowRight",
                                        40: "ArrowDown",
                                        45: "Insert",
                                        46: "Delete",
                                        48: "0",
                                        49: "1",
                                        50: "2",
                                        51: "3",
                                        52: "4",
                                        53: "5",
                                        54: "6",
                                        55: "7",
                                        56: "8",
                                        57: "9",
                                        65: "A",
                                        66: "B",
                                        67: "C",
                                        68: "D",
                                        69: "E",
                                        70: "F",
                                        71: "G",
                                        72: "H",
                                        73: "I",
                                        74: "J",
                                        75: "K",
                                        76: "L",
                                        77: "M",
                                        78: "N",
                                        79: "O",
                                        80: "P",
                                        81: "Q",
                                        82: "R",
                                        83: "S",
                                        84: "T",
                                        85: "U",
                                        86: "V",
                                        87: "W",
                                        88: "X",
                                        89: "Y",
                                        90: "Z",
                                        91: "Meta",
                                        96: "Numpad0",
                                        97: "Numpad1",
                                        98: "Numpad2",
                                        99: "Numpad3",
                                        100: "Numpad4",
                                        101: "Numpad5",
                                        102: "Numpad6",
                                        103: "Numpad7",
                                        104: "Numpad8",
                                        105: "Numpad9",
                                        106: "NumpadMultiply",
                                        107: "NumpadAdd",
                                        109: "NumpadSubtract",
                                        110: "NumpadDecimal",
                                        111: "NumpadDivide",
                                        112: "F1",
                                        113: "F2",
                                        114: "F3",
                                        115: "F4",
                                        116: "F5",
                                        117: "F6",
                                        118: "F7",
                                        119: "F8",
                                        120: "F9",
                                        121: "F10",
                                        122: "F11",
                                        123: "F12",
                                        144: "NumLock",
                                        145: "ScrollLock",
                                        186: ";",
                                        187: "=",
                                        188: ",",
                                        189: "-",
                                        190: ".",
                                        191: "/",
                                        192: "`",
                                        219: "[",
                                        220: "\\",
                                        221: "]",
                                        222: "'"
                                    })[t] || "";
                                }
                            }
                        ], e && h(t.prototype, e), n && h(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }();
                    function m(t) {
                        return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, m(t);
                    }
                    function b(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, x(o.key), o);
                        }
                    }
                    function w(t, e, n) {
                        return (e = x(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function x(t) {
                        var e = function(t, e) {
                            if ("object" != m(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != m(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == m(e) ? e : e + "";
                    }
                    var E = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = e.utilities, o = e.options;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), w(this, "utilities", void 0), w(this, "options", void 0), w(this, "candidateBoxElement", void 0), w(this, "pageIndex", 0), w(this, "pageSize", void 0), this.utilities = n, this.options = o, d.bindMethods(t, this), this.pageSize = this.utilities.getOptions().layoutCandidatesPageSize || 5;
                        }, e = [
                            {
                                key: "destroy",
                                value: function() {
                                    this.candidateBoxElement && (this.candidateBoxElement.remove(), this.pageIndex = 0);
                                }
                            },
                            {
                                key: "show",
                                value: function(t) {
                                    var e = this, n = t.candidateValue, o = t.targetElement, r = t.onSelect;
                                    if (n && n.length) {
                                        var i = this.utilities.chunkArray(n.split(" "), this.pageSize);
                                        this.renderPage({
                                            candidateListPages: i,
                                            targetElement: o,
                                            pageIndex: this.pageIndex,
                                            nbPages: i.length,
                                            onItemSelected: function(t, n) {
                                                r(t, n), e.destroy();
                                            }
                                        });
                                    }
                                }
                            },
                            {
                                key: "renderPage",
                                value: function(t) {
                                    var e, n = this, o = t.candidateListPages, r = t.targetElement, i = t.pageIndex, a = t.nbPages, s = t.onItemSelected;
                                    null === (e = this.candidateBoxElement) || void 0 === e || e.remove(), this.candidateBoxElement = document.createElement("div"), this.candidateBoxElement.className = "hg-candidate-box";
                                    var u = document.createElement("ul");
                                    u.className = "hg-candidate-box-list", o[i].forEach(function(t) {
                                        var e, o = document.createElement("li"), r = function() {
                                            var t = new (n.options.useTouchEvents ? TouchEvent : MouseEvent)("click");
                                            return Object.defineProperty(t, "target", {
                                                value: o
                                            }), t;
                                        };
                                        o.className = "hg-candidate-box-list-item", o.innerHTML = (null === (e = n.options.display) || void 0 === e ? void 0 : e[t]) || t, n.options.useTouchEvents ? o.ontouchstart = function(e) {
                                            return s(t, e || r());
                                        } : o.onclick = function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r();
                                            return s(t, e);
                                        }, u.appendChild(o);
                                    });
                                    var c = i > 0, l = document.createElement("div");
                                    l.classList.add("hg-candidate-box-prev"), c && l.classList.add("hg-candidate-box-btn-active");
                                    var f = function() {
                                        c && n.renderPage({
                                            candidateListPages: o,
                                            targetElement: r,
                                            pageIndex: i - 1,
                                            nbPages: a,
                                            onItemSelected: s
                                        });
                                    };
                                    this.options.useTouchEvents ? l.ontouchstart = f : l.onclick = f, this.candidateBoxElement.appendChild(l), this.candidateBoxElement.appendChild(u);
                                    var d = i < a - 1, p = document.createElement("div");
                                    p.classList.add("hg-candidate-box-next"), d && p.classList.add("hg-candidate-box-btn-active");
                                    var h = function() {
                                        d && n.renderPage({
                                            candidateListPages: o,
                                            targetElement: r,
                                            pageIndex: i + 1,
                                            nbPages: a,
                                            onItemSelected: s
                                        });
                                    };
                                    this.options.useTouchEvents ? p.ontouchstart = h : p.onclick = h, this.candidateBoxElement.appendChild(p), r.prepend(this.candidateBoxElement);
                                }
                            }
                        ], e && b(t.prototype, e), n && b(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }(), O = E;
                    function S(t) {
                        return function(t) {
                            if (Array.isArray(t)) return k(t);
                        }(t) || function(t) {
                            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                        }(t) || function(t, e) {
                            if (t) {
                                if ("string" == typeof t) return k(t, e);
                                var n = ({}).toString.call(t).slice(8, -1);
                                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? k(t, e) : void 0;
                            }
                        }(t) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }
                    function k(t, e) {
                        (null == e || e > t.length) && (e = t.length);
                        for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
                        return o;
                    }
                    function P(t) {
                        return P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, P(t);
                    }
                    function I(t, e) {
                        var n = Object.keys(t);
                        if (Object.getOwnPropertySymbols) {
                            var o = Object.getOwnPropertySymbols(t);
                            e && (o = o.filter(function(e) {
                                return Object.getOwnPropertyDescriptor(t, e).enumerable;
                            })), n.push.apply(n, o);
                        }
                        return n;
                    }
                    function C(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, M(o.key), o);
                        }
                    }
                    function A(t, e, n) {
                        return (e = M(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function M(t) {
                        var e = function(t, e) {
                            if ("object" != P(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != P(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == P(e) ? e : e + "";
                    }
                    var D = function() {
                        var t, e, n;
                        return t = function t(e, n) {
                            var o = this;
                            if (function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), A(this, "input", void 0), A(this, "options", void 0), A(this, "utilities", void 0), A(this, "caretPosition", void 0), A(this, "caretPositionEnd", void 0), A(this, "keyboardDOM", void 0), A(this, "keyboardPluginClasses", void 0), A(this, "keyboardDOMClass", void 0), A(this, "buttonElements", void 0), A(this, "currentInstanceName", void 0), A(this, "allKeyboardInstances", void 0), A(this, "keyboardInstanceNames", void 0), A(this, "isFirstKeyboardInstance", void 0), A(this, "physicalKeyboard", void 0), A(this, "modules", void 0), A(this, "activeButtonClass", void 0), A(this, "holdInteractionTimeout", void 0), A(this, "holdTimeout", void 0), A(this, "isMouseHold", void 0), A(this, "initialized", void 0), A(this, "candidateBox", void 0), A(this, "keyboardRowsDOM", void 0), A(this, "defaultName", "default"), A(this, "activeInputElement", null), A(this, "handleParams", function(t, e) {
                                var n, o, r;
                                if ("string" == typeof t) n = t.split(".").join(""), o = document.querySelector(".".concat(n)), r = e;
                                else if (t instanceof HTMLDivElement) {
                                    if (!t.className) throw console.warn("Any DOM element passed as parameter must have a class."), new Error("KEYBOARD_DOM_CLASS_ERROR");
                                    n = t.className.split(" ")[0], o = t, r = e;
                                } else n = "simple-keyboard", o = document.querySelector(".".concat(n)), r = t;
                                return {
                                    keyboardDOMClass: n,
                                    keyboardDOM: o,
                                    options: r
                                };
                            }), A(this, "getOptions", function() {
                                return o.options;
                            }), A(this, "getCaretPosition", function() {
                                return o.caretPosition;
                            }), A(this, "getCaretPositionEnd", function() {
                                return o.caretPositionEnd;
                            }), A(this, "registerModule", function(t, e) {
                                o.modules[t] || (o.modules[t] = {}), e(o.modules[t]);
                            }), A(this, "getKeyboardClassString", function() {
                                for(var t = arguments.length, e = new Array(t), n = 0; n < t; n++)e[n] = arguments[n];
                                return [
                                    o.keyboardDOMClass
                                ].concat(e).filter(function(t) {
                                    return !!t;
                                }).join(" ");
                            }), "undefined" != typeof window) {
                                var r = this.handleParams(e, n), i = r.keyboardDOMClass, a = r.keyboardDOM, s = r.options, u = void 0 === s ? {} : s;
                                this.utilities = new d({
                                    getOptions: this.getOptions,
                                    getCaretPosition: this.getCaretPosition,
                                    getCaretPositionEnd: this.getCaretPositionEnd,
                                    dispatch: this.dispatch
                                }), this.caretPosition = null, this.caretPositionEnd = null, this.keyboardDOM = a, this.options = function(t) {
                                    for(var e = 1; e < arguments.length; e++){
                                        var n = null != arguments[e] ? arguments[e] : {};
                                        e % 2 ? I(Object(n), !0).forEach(function(e) {
                                            A(t, e, n[e]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function(e) {
                                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                                        });
                                    }
                                    return t;
                                }({
                                    layoutName: "default",
                                    theme: "hg-theme-default",
                                    inputName: "default",
                                    preventMouseDownDefault: !1,
                                    enableLayoutCandidates: !0,
                                    excludeFromLayout: {}
                                }, u), this.keyboardPluginClasses = "", d.bindMethods(t, this);
                                var c = this.options.inputName, l = void 0 === c ? this.defaultName : c;
                                if (this.input = {}, this.input[l] = "", this.keyboardDOMClass = i, this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), window.SimpleKeyboardInstances[this.currentInstanceName] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new g({
                                    dispatch: this.dispatch,
                                    getOptions: this.getOptions
                                }), this.candidateBox = this.options.enableLayoutCandidates ? new O({
                                    utilities: this.utilities,
                                    options: this.options
                                }) : null, !this.keyboardDOM) throw console.warn('".'.concat(i, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
                                this.render(), this.modules = {}, this.loadModules();
                            }
                        }, e = [
                            {
                                key: "setCaretPosition",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                                    this.caretPosition = t, this.caretPositionEnd = e;
                                }
                            },
                            {
                                key: "getInputCandidates",
                                value: function(t) {
                                    var e = this, n = this.options, o = n.layoutCandidates, r = n.layoutCandidatesCaseSensitiveMatch;
                                    if (!o || "object" !== P(o)) return {};
                                    var i = Object.keys(o).filter(function(n) {
                                        var o = t.substring(0, e.getCaretPositionEnd() || 0) || t, i = new RegExp("".concat(e.utilities.escapeRegex(n), "$"), r ? "g" : "gi");
                                        return !!S(o.matchAll(i)).length;
                                    });
                                    if (i.length > 1) {
                                        var a = i.sort(function(t, e) {
                                            return e.length - t.length;
                                        })[0];
                                        return {
                                            candidateKey: a,
                                            candidateValue: o[a]
                                        };
                                    }
                                    if (i.length) {
                                        var s = i[0];
                                        return {
                                            candidateKey: s,
                                            candidateValue: o[s]
                                        };
                                    }
                                    return {};
                                }
                            },
                            {
                                key: "showCandidatesBox",
                                value: function(t, e, n) {
                                    var o = this;
                                    this.candidateBox && this.candidateBox.show({
                                        candidateValue: e,
                                        targetElement: n,
                                        onSelect: function(e, n) {
                                            var r = o.options, i = r.layoutCandidatesCaseSensitiveMatch, a = r.disableCandidateNormalization, s = r.enableLayoutCandidatesKeyPress, u = e;
                                            a || (u = e.normalize("NFD")), "function" == typeof o.options.beforeInputUpdate && o.options.beforeInputUpdate(o);
                                            var c = o.getInput(o.options.inputName, !0), l = o.getCaretPositionEnd() || 0, f = c.substring(0, l || 0) || c, d = new RegExp("".concat(o.utilities.escapeRegex(t), "$"), i ? "g" : "gi"), p = f.replace(d, u), h = c.replace(f, p), v = p.length - f.length, y = (l || c.length) + v;
                                            y < 0 && (y = 0), o.setInput(h, o.options.inputName, !0), o.setCaretPosition(y), s && "function" == typeof o.options.onKeyPress && o.options.onKeyPress(e, n), "function" == typeof o.options.onChange && o.options.onChange(o.getInput(o.options.inputName, !0), n), "function" == typeof o.options.onChangeAll && o.options.onChangeAll(o.getAllInputs(), n);
                                        }
                                    });
                                }
                            },
                            {
                                key: "handleButtonClicked",
                                value: function(t, e) {
                                    var n = this.options, o = n.inputName, r = void 0 === o ? this.defaultName : o, i = n.debug;
                                    if ("{//}" !== t) {
                                        this.input[r] || (this.input[r] = ""), "function" == typeof this.options.beforeInputUpdate && this.options.beforeInputUpdate(this);
                                        var a = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd);
                                        if (this.utilities.isStandardButton(t) && this.activeInputElement && this.input[r] && this.input[r] === a && 0 === this.caretPosition && this.caretPositionEnd === a.length) return this.setInput("", this.options.inputName, !0), this.setCaretPosition(0), this.activeInputElement.value = "", this.activeInputElement.setSelectionRange(0, 0), void this.handleButtonClicked(t, e);
                                        if ("function" == typeof this.options.onKeyPress && this.options.onKeyPress(t, e), this.input[r] !== a && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(a))) {
                                            if (this.options.maxLength && this.utilities.handleMaxLength(this.input, a)) return;
                                            var s = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd, !0);
                                            if (this.setInput(s, this.options.inputName, !0), i && console.log("Input changed:", this.getAllInputs()), this.options.debug && console.log("Caret at: ", this.getCaretPosition(), this.getCaretPositionEnd(), "(".concat(this.keyboardDOMClass, ")"), null == e ? void 0 : e.type), this.options.syncInstanceInputs && this.syncInstanceInputs(), "function" == typeof this.options.onChange && this.options.onChange(this.getInput(this.options.inputName, !0), e), "function" == typeof this.options.onChangeAll && this.options.onChangeAll(this.getAllInputs(), e), null != e && e.target && this.options.enableLayoutCandidates) {
                                                var u, c = this.getInputCandidates(a), l = c.candidateKey, f = c.candidateValue;
                                                l && f ? this.showCandidatesBox(l, f, this.keyboardDOM) : null === (u = this.candidateBox) || void 0 === u || u.destroy();
                                            }
                                        }
                                        this.caretPositionEnd && this.caretPosition !== this.caretPositionEnd && (this.setCaretPosition(this.caretPositionEnd, this.caretPositionEnd), this.activeInputElement && this.activeInputElement.setSelectionRange(this.caretPositionEnd, this.caretPositionEnd), this.options.debug && console.log("Caret position aligned", this.caretPosition)), i && console.log("Key pressed:", t);
                                    }
                                }
                            },
                            {
                                key: "getMouseHold",
                                value: function() {
                                    return this.isMouseHold;
                                }
                            },
                            {
                                key: "setMouseHold",
                                value: function(t) {
                                    this.options.syncInstanceInputs ? this.dispatch(function(e) {
                                        e.isMouseHold = t;
                                    }) : this.isMouseHold = t;
                                }
                            },
                            {
                                key: "handleButtonMouseDown",
                                value: function(t, e) {
                                    var n = this;
                                    e && (this.options.preventMouseDownDefault && e.preventDefault(), this.options.stopMouseDownPropagation && e.stopPropagation(), e.target.classList.add(this.activeButtonClass)), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.setMouseHold(!0), this.options.disableButtonHold || (this.holdTimeout = window.setTimeout(function() {
                                        (n.getMouseHold() && (!t.includes("{") && !t.includes("}") || "{delete}" === t || "{backspace}" === t || "{bksp}" === t || "{space}" === t || "{tab}" === t) || "{arrowright}" === t || "{arrowleft}" === t || "{arrowup}" === t || "{arrowdown}" === t) && (n.options.debug && console.log("Button held:", t), n.handleButtonHold(t)), clearTimeout(n.holdTimeout);
                                    }, 500));
                                }
                            },
                            {
                                key: "handleButtonMouseUp",
                                value: function(t, e) {
                                    var n = this;
                                    e && (this.options.preventMouseUpDefault && e.preventDefault && e.preventDefault(), this.options.stopMouseUpPropagation && e.stopPropagation && e.stopPropagation(), !(e.target === this.keyboardDOM || e.target && this.keyboardDOM.contains(e.target) || this.candidateBox && this.candidateBox.candidateBoxElement && (e.target === this.candidateBox.candidateBoxElement || e.target && this.candidateBox.candidateBoxElement.contains(e.target))) && this.candidateBox && this.candidateBox.destroy()), this.recurseButtons(function(t) {
                                        t.classList.remove(n.activeButtonClass);
                                    }), this.setMouseHold(!1), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), t && "function" == typeof this.options.onKeyReleased && this.options.onKeyReleased(t, e);
                                }
                            },
                            {
                                key: "handleKeyboardContainerMouseDown",
                                value: function(t) {
                                    this.options.preventMouseDownDefault && t.preventDefault();
                                }
                            },
                            {
                                key: "handleButtonHold",
                                value: function(t) {
                                    var e = this;
                                    this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = window.setTimeout(function() {
                                        e.getMouseHold() ? (e.handleButtonClicked(t), e.handleButtonHold(t)) : clearTimeout(e.holdInteractionTimeout);
                                    }, 100);
                                }
                            },
                            {
                                key: "syncInstanceInputs",
                                value: function() {
                                    var t = this;
                                    this.dispatch(function(e) {
                                        e.replaceInput(t.input), e.setCaretPosition(t.caretPosition, t.caretPositionEnd);
                                    });
                                }
                            },
                            {
                                key: "clearInput",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName;
                                    this.input[t] = "", this.setCaretPosition(0), this.options.syncInstanceInputs && this.syncInstanceInputs();
                                }
                            },
                            {
                                key: "getInput",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName, e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    return this.options.syncInstanceInputs && !e && this.syncInstanceInputs(), this.options.rtl ? "\u202B" + this.input[t].replace("\u202B", "").replace("\u202C", "") + "\u202C" : this.input[t];
                                }
                            },
                            {
                                key: "getAllInputs",
                                value: function() {
                                    var t = this, e = {};
                                    return Object.keys(this.input).forEach(function(n) {
                                        e[n] = t.getInput(n, !0);
                                    }), e;
                                }
                            },
                            {
                                key: "setInput",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.inputName || this.defaultName, n = arguments.length > 2 ? arguments[2] : void 0;
                                    this.input[e] = t, !n && this.options.syncInstanceInputs && this.syncInstanceInputs();
                                }
                            },
                            {
                                key: "replaceInput",
                                value: function(t) {
                                    this.input = t;
                                }
                            },
                            {
                                key: "setOptions",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = this.changedOptions(t);
                                    this.options = Object.assign(this.options, t), e.length && (this.options.debug && console.log("changedOptions", e), this.onSetOptions(e), this.render());
                                }
                            },
                            {
                                key: "changedOptions",
                                value: function(t) {
                                    var e = this;
                                    return Object.keys(t).filter(function(n) {
                                        return JSON.stringify(t[n]) !== JSON.stringify(e.options[n]);
                                    });
                                }
                            },
                            {
                                key: "onSetOptions",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                                    t.includes("layoutName") && this.candidateBox && this.candidateBox.destroy(), (t.includes("layoutCandidatesPageSize") || t.includes("layoutCandidates")) && this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = new O({
                                        utilities: this.utilities,
                                        options: this.options
                                    }));
                                }
                            },
                            {
                                key: "resetRows",
                                value: function() {
                                    this.keyboardRowsDOM && this.keyboardRowsDOM.remove(), this.keyboardDOM.className = this.keyboardDOMClass, this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.buttonElements = {};
                                }
                            },
                            {
                                key: "dispatch",
                                value: function(t) {
                                    if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                                    return Object.keys(window.SimpleKeyboardInstances).forEach(function(e) {
                                        t(window.SimpleKeyboardInstances[e], e);
                                    });
                                }
                            },
                            {
                                key: "addButtonTheme",
                                value: function(t, e) {
                                    var n = this;
                                    e && t && (t.split(" ").forEach(function(o) {
                                        e.split(" ").forEach(function(e) {
                                            n.options.buttonTheme || (n.options.buttonTheme = []);
                                            var r = !1;
                                            n.options.buttonTheme.map(function(t) {
                                                if (null != t && t.class.split(" ").includes(e)) {
                                                    r = !0;
                                                    var n = t.buttons.split(" ");
                                                    n.includes(o) || (r = !0, n.push(o), t.buttons = n.join(" "));
                                                }
                                                return t;
                                            }), r || n.options.buttonTheme.push({
                                                class: e,
                                                buttons: t
                                            });
                                        });
                                    }), this.render());
                                }
                            },
                            {
                                key: "removeButtonTheme",
                                value: function(t, e) {
                                    var n = this;
                                    if (!t && !e) return this.options.buttonTheme = [], void this.render();
                                    t && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (t.split(" ").forEach(function(t) {
                                        var o;
                                        null === (o = n.options) || void 0 === o || null === (o = o.buttonTheme) || void 0 === o || o.map(function(o, r) {
                                            if (o && e && e.includes(o.class) || !e) {
                                                var i, a, s = null === (i = o) || void 0 === i ? void 0 : i.buttons.split(" ").filter(function(e) {
                                                    return e !== t;
                                                });
                                                o && null != s && s.length ? o.buttons = s.join(" ") : (null === (a = n.options.buttonTheme) || void 0 === a || a.splice(r, 1), o = null);
                                            }
                                            return o;
                                        });
                                    }), this.render());
                                }
                            },
                            {
                                key: "getButtonElement",
                                value: function(t) {
                                    var e, n = this.buttonElements[t];
                                    return n && (e = n.length > 1 ? n : n[0]), e;
                                }
                            },
                            {
                                key: "inputPatternIsValid",
                                value: function(t) {
                                    var e, n = this.options.inputPattern;
                                    if ((e = n instanceof RegExp ? n : n[this.options.inputName || this.defaultName]) && t) {
                                        var o = e.test(t);
                                        return this.options.debug && console.log('inputPattern ("'.concat(e, '"): ').concat(o ? "passed" : "did not pass!")), o;
                                    }
                                    return !0;
                                }
                            },
                            {
                                key: "setEventListeners",
                                value: function() {
                                    if (this.isFirstKeyboardInstance || !this.allKeyboardInstances) {
                                        this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")"));
                                        var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                                        document.addEventListener("keyup", this.handleKeyUp, e), document.addEventListener("keydown", this.handleKeyDown, e), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd), this.options.updateCaretOnSelectionChange && document.addEventListener("selectionchange", this.handleSelectionChange), document.addEventListener("select", this.handleSelect);
                                    }
                                }
                            },
                            {
                                key: "handleKeyUp",
                                value: function(t) {
                                    this.caretEventHandler(t), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(t);
                                }
                            },
                            {
                                key: "handleKeyDown",
                                value: function(t) {
                                    this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(t);
                                }
                            },
                            {
                                key: "handleMouseUp",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleTouchEnd",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleSelect",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleSelectionChange",
                                value: function(t) {
                                    navigator.userAgent.includes("Firefox") || this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "caretEventHandler",
                                value: function(t) {
                                    var e, n = this;
                                    t.target.tagName && (e = t.target.tagName.toLowerCase()), this.dispatch(function(o) {
                                        var r = t.target === o.keyboardDOM || t.target && o.keyboardDOM.contains(t.target);
                                        if (n.options.syncInstanceInputs && Array.isArray(t.path) && (r = t.path.some(function(t) {
                                            var e;
                                            return null == t || null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-skInstance");
                                        })), ("textarea" === e || "input" === e && [
                                            "text",
                                            "search",
                                            "url",
                                            "tel",
                                            "password"
                                        ].includes(t.target.type)) && !o.options.disableCaretPositioning) {
                                            var i = t.target.selectionStart, a = t.target.selectionEnd;
                                            o.options.rtl && (i = o.utilities.getRtlOffset(i, o.getInput()), a = o.utilities.getRtlOffset(a, o.getInput())), o.setCaretPosition(i, a), o.activeInputElement = t.target, o.options.debug && console.log("Caret at: ", o.getCaretPosition(), o.getCaretPositionEnd(), t && t.target.tagName.toLowerCase(), "(".concat(o.keyboardDOMClass, ")"), null == t ? void 0 : t.type);
                                        } else !o.options.disableCaretPositioning && r || "selectionchange" === (null == t ? void 0 : t.type) || (o.setCaretPosition(null), o.activeInputElement = null, o.options.debug && console.log('Caret position reset due to "'.concat(null == t ? void 0 : t.type, '" event'), t));
                                    });
                                }
                            },
                            {
                                key: "recurseButtons",
                                value: function(t) {
                                    var e = this;
                                    t && Object.keys(this.buttonElements).forEach(function(n) {
                                        return e.buttonElements[n].forEach(t);
                                    });
                                }
                            },
                            {
                                key: "destroy",
                                value: function() {
                                    this.options.debug && console.log("Destroying simple-keyboard instance: ".concat(this.currentInstanceName));
                                    var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                                    document.removeEventListener("keyup", this.handleKeyUp, e), document.removeEventListener("keydown", this.handleKeyDown, e), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), document.removeEventListener("select", this.handleSelect), this.options.updateCaretOnSelectionChange && document.removeEventListener("selectionchange", this.handleSelectionChange), document.onpointerup = null, document.ontouchend = null, document.ontouchcancel = null, document.onmouseup = null, this.recurseButtons(function(t) {
                                        t && (t.onpointerdown = null, t.onpointerup = null, t.onpointercancel = null, t.ontouchstart = null, t.ontouchend = null, t.ontouchcancel = null, t.onclick = null, t.onmousedown = null, t.onmouseup = null, t.remove(), t = null);
                                    }), this.keyboardDOM.onpointerdown = null, this.keyboardDOM.ontouchstart = null, this.keyboardDOM.onmousedown = null, this.resetRows(), this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = null), this.activeInputElement = null, this.keyboardDOM.removeAttribute("data-skInstance"), this.keyboardDOM.innerHTML = "", window.SimpleKeyboardInstances[this.currentInstanceName] = null, delete window.SimpleKeyboardInstances[this.currentInstanceName], this.initialized = !1;
                                }
                            },
                            {
                                key: "getButtonThemeClasses",
                                value: function(t) {
                                    var e = this.options.buttonTheme, n = [];
                                    return Array.isArray(e) && e.forEach(function(e) {
                                        if (e && e.class && "string" == typeof e.class && e.buttons && "string" == typeof e.buttons) {
                                            var o = e.class.split(" ");
                                            e.buttons.split(" ").includes(t) && (n = [].concat(S(n), S(o)));
                                        } else console.warn('Incorrect "buttonTheme". Please check the documentation.', e);
                                    }), n;
                                }
                            },
                            {
                                key: "setDOMButtonAttributes",
                                value: function(t, e) {
                                    var n = this.options.buttonAttributes;
                                    Array.isArray(n) && n.forEach(function(n) {
                                        n.attribute && "string" == typeof n.attribute && n.value && "string" == typeof n.value && n.buttons && "string" == typeof n.buttons ? n.buttons.split(" ").includes(t) && e(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                                    });
                                }
                            },
                            {
                                key: "onTouchDeviceDetected",
                                value: function() {
                                    this.processAutoTouchEvents(), this.disableContextualWindow();
                                }
                            },
                            {
                                key: "disableContextualWindow",
                                value: function() {
                                    window.oncontextmenu = function(t) {
                                        if (t.target.classList.contains("hg-button")) return t.preventDefault(), t.stopPropagation(), !1;
                                    };
                                }
                            },
                            {
                                key: "processAutoTouchEvents",
                                value: function() {
                                    this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
                                }
                            },
                            {
                                key: "onInit",
                                value: function() {
                                    this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" == typeof this.options.onInit && this.options.onInit(this);
                                }
                            },
                            {
                                key: "beforeFirstRender",
                                value: function() {
                                    this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" == typeof this.options.beforeFirstRender && this.options.beforeFirstRender(this), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
                                }
                            },
                            {
                                key: "beforeRender",
                                value: function() {
                                    "function" == typeof this.options.beforeRender && this.options.beforeRender(this);
                                }
                            },
                            {
                                key: "onRender",
                                value: function() {
                                    "function" == typeof this.options.onRender && this.options.onRender(this);
                                }
                            },
                            {
                                key: "onModulesLoaded",
                                value: function() {
                                    "function" == typeof this.options.onModulesLoaded && this.options.onModulesLoaded(this);
                                }
                            },
                            {
                                key: "loadModules",
                                value: function() {
                                    var t = this;
                                    Array.isArray(this.options.modules) && (this.options.modules.forEach(function(e) {
                                        var n = new e(t);
                                        n.init && n.init(t);
                                    }), this.keyboardPluginClasses = "modules-loaded", this.render(), this.onModulesLoaded());
                                }
                            },
                            {
                                key: "getModuleProp",
                                value: function(t, e) {
                                    return !!this.modules[t] && this.modules[t][e];
                                }
                            },
                            {
                                key: "getModulesList",
                                value: function() {
                                    return Object.keys(this.modules);
                                }
                            },
                            {
                                key: "parseRowDOMContainers",
                                value: function(t, e, n, o) {
                                    var r = this, i = Array.from(t.children), a = 0;
                                    return i.length && n.forEach(function(n, s) {
                                        var u = o[s];
                                        if (!(u && u > n)) return !1;
                                        var c = n - a, l = u - a, f = document.createElement("div");
                                        f.className += "hg-button-container";
                                        var d = "".concat(r.options.layoutName, "-r").concat(e, "c").concat(s);
                                        f.setAttribute("data-skUID", d);
                                        var p = i.splice(c, l - c + 1);
                                        a = l - c, p.forEach(function(t) {
                                            return f.appendChild(t);
                                        }), i.splice(c, 0, f), t.innerHTML = "", i.forEach(function(e) {
                                            return t.appendChild(e);
                                        }), r.options.debug && console.log("rowDOMContainer", p, c, l, a + 1);
                                    }), t;
                                }
                            },
                            {
                                key: "render",
                                value: function() {
                                    var t = this;
                                    this.resetRows(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                                    var e = "hg-layout-".concat(this.options.layoutName), n = this.options.layout || {
                                        default: [
                                            "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                                            "{tab} q w e r t y u i o p [ ] \\",
                                            "{lock} a s d f g h j k l ; ' {enter}",
                                            "{shift} z x c v b n m , . / {shift}",
                                            ".com @ {space}"
                                        ],
                                        shift: [
                                            "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                                            "{tab} Q W E R T Y U I O P { } |",
                                            '{lock} A S D F G H J K L : " {enter}',
                                            "{shift} Z X C V B N M < > ? {shift}",
                                            ".com @ {space}"
                                        ]
                                    }, o = this.options.useTouchEvents || !1, r = o ? "hg-touch-events" : "", i = this.options.useMouseEvents || !1, a = this.options.disableRowButtonContainers;
                                    this.keyboardDOM.className = this.getKeyboardClassString(this.options.theme, e, this.keyboardPluginClasses, r), this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.keyboardRowsDOM = document.createElement("div"), this.keyboardRowsDOM.className = "hg-rows", n[this.options.layoutName || this.defaultName].forEach(function(e, n) {
                                        var r = e.split(" ");
                                        t.options.excludeFromLayout && t.options.excludeFromLayout[t.options.layoutName || t.defaultName] && (r = r.filter(function(e) {
                                            return t.options.excludeFromLayout && !t.options.excludeFromLayout[t.options.layoutName || t.defaultName].includes(e);
                                        }));
                                        var s = document.createElement("div");
                                        s.className += "hg-row";
                                        var u = [], c = [];
                                        r.forEach(function(e, r) {
                                            var l, f = !a && "string" == typeof e && e.length > 1 && 0 === e.indexOf("["), d = !a && "string" == typeof e && e.length > 1 && e.indexOf("]") === e.length - 1;
                                            f && (u.push(r), e = e.replace(/\[/g, "")), d && (c.push(r), e = e.replace(/\]/g, ""));
                                            var p = t.utilities.getButtonClass(e), h = t.utilities.getButtonDisplayName(e, t.options.display, t.options.mergeDisplay), v = t.options.useButtonTag ? "button" : "div", y = document.createElement(v);
                                            y.className += "hg-button ".concat(p), (l = y.classList).add.apply(l, S(t.getButtonThemeClasses(e))), t.setDOMButtonAttributes(e, function(t, e) {
                                                y.setAttribute(t, e);
                                            }), t.activeButtonClass = "hg-activeButton", !t.utilities.pointerEventsSupported() || o || i ? o ? (y.ontouchstart = function(n) {
                                                t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.ontouchend = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }, y.ontouchcancel = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }) : (y.onclick = function(n) {
                                                t.setMouseHold(!1), "function" != typeof t.options.onKeyReleased && t.handleButtonClicked(e, n);
                                            }, y.onmousedown = function(n) {
                                                "function" != typeof t.options.onKeyReleased || t.isMouseHold || t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.onmouseup = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }) : (y.onpointerdown = function(n) {
                                                t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.onpointerup = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }, y.onpointercancel = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }), y.setAttribute("data-skBtn", e);
                                            var g = "".concat(t.options.layoutName, "-r").concat(n, "b").concat(r);
                                            y.setAttribute("data-skBtnUID", g);
                                            var m = document.createElement("span");
                                            m.innerHTML = h, y.appendChild(m), t.buttonElements[e] || (t.buttonElements[e] = []), t.buttonElements[e].push(y), s.appendChild(y);
                                        }), s = t.parseRowDOMContainers(s, n, u, c), t.keyboardRowsDOM.appendChild(s);
                                    }), this.keyboardDOM.appendChild(this.keyboardRowsDOM), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || i ? o ? (document.ontouchend = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, document.ontouchcancel = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.ontouchstart = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }) : o || (document.onmouseup = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.onmousedown = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }) : (document.onpointerup = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.onpointerdown = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }), this.onInit());
                                }
                            }
                        ], e && C(t.prototype, e), n && C(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }(), T = D, N = T;
                    return o;
                }();
            },
            442: function(e) {
                "use strict";
                e.exports = t;
            }
        }, n = {};
        function o(t) {
            var r = n[t];
            if (void 0 !== r) return r.exports;
            var i = n[t] = {
                exports: {}
            };
            return e[t].call(i.exports, i, i.exports, o), i.exports;
        }
        o.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return o.d(e, {
                a: e
            }), e;
        }, o.d = function(t, e) {
            for(var n in e)o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, o.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, o.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            o.r(r), o.d(r, {
                KeyboardReact: function() {
                    return l;
                },
                default: function() {
                    return f;
                }
            });
            o(981);
            var t = o(442), e = o(548), n = o.n(e);
            function i(t) {
                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, i(t);
            }
            function a(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(t);
                    e && (o = o.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, o);
                }
                return n;
            }
            function s(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? a(Object(n), !0).forEach(function(e) {
                        u(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function u(t, e, n) {
                return (e = function(t) {
                    var e = function(t, e) {
                        if ("object" != i(t) || !t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(t, e || "default");
                            if ("object" != i(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === e ? String : Number)(t);
                    }(t, "string");
                    return "symbol" == i(e) ? e : e + "";
                }(e)) in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var c = function(t) {
                return s(s({}, t), {}, {
                    keyboardRef: null
                });
            }, l = function(e) {
                var o = e.baseClass || "react-simple-keyboard", r = t.useRef(null), i = t.useRef(null), a = t.useRef(null), u = t.useRef(e);
                return t.useEffect(function() {
                    return function() {
                        a.current && a.current.destroy(), r.current = !1;
                    };
                }, []), t.useEffect(function() {
                    var t = function(t) {
                        return s(s({}, t), {}, {
                            theme: "simple-keyboard ".concat(t.theme || "hg-theme-default")
                        });
                    }(e);
                    if (!r.current) {
                        r.current = !0, t.debug && console.log("ReactSimpleKeyboard: Init");
                        var l = i.current, f = ".".concat(o);
                        a.current = new (n())(l || f, t), t.keyboardRef && t.keyboardRef(a.current);
                    }
                    var d = function(t, e) {
                        var n = c(e), o = c(t);
                        return Object.keys(n).filter(function(t) {
                            return n[t] !== o[t];
                        });
                    }(u.current, t);
                    if (d.length) {
                        var p = a.current;
                        u.current = t, null == p || p.setOptions(t), t.debug && console.log("ReactSimpleKeyboard - setOptions called due to updated props:", d);
                    }
                }, [
                    r,
                    o,
                    u,
                    e
                ]), t.createElement("div", {
                    className: o,
                    ref: i
                });
            }, f = l;
        }(), r;
    }();
});



var $eZVvM = parcelRequire("eZVvM");
const $d0f9aa612dc769dd$export$86757e9fe5e12048 = {
    "phone-pad": {
        "{space}": "space",
        "{bksp}": "\u232B",
        "{enter}": "\u21B5"
    },
    default: {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "default-shift": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "default-alt": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "abc",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    email: {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "email-shift": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "email-alt": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "abc",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    pin: {}
};
const $d0f9aa612dc769dd$export$78ca07932ec5b059 = {
    default: [
        // "+ 1 2 3 4 5 6 7 8 9 0",
        "q w e r t y u i o p",
        "a s d f g h j k l",
        "{shift} z x c v b n m {bksp}",
        "{alt} , {space} . {enter}"
    ],
    "default-alt": [
        "1 2 3 4 5 6 7 8 9 0",
        "@ # $ _ & - + ( ) /",
        `* " ' : ; ! ? {bksp}`,
        "{alt} , {space} . {enter}"
    ],
    "default-shift": [
        // "~ ! @ # $ % ^ &amp; * ( ) _ ` {bksp}",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "{shift} Z X C V B N M {bksp}",
        "{alt} , {space} . {enter}"
    ],
    "phone-pad": [
        "1 2 3 {//}",
        "4 5 6 {//}",
        "7 8 9 {bksp}",
        "+ 0 # {enter}" //
    ],
    email: [
        "q w e r t y u i o p",
        "a s d f g h j k l",
        "{shift} z x c v b n m {bksp}",
        "{alt} {space} @ . {enter}"
    ],
    "email-alt": [
        "1 2 3 4 5 6 7 8 9 0",
        "@ # $ _ & - + ( ) /",
        `* " ' : ; ! ? {bksp}`,
        "{alt} {space} . {enter}"
    ],
    "email-shift": [
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "{shift} Z X C V B N M {bksp}",
        "{alt} {space} @ . {enter}"
    ],
    pin: [
        "1 2 3",
        "4 5 6",
        "7 8 9",
        "{//} 0 {//}",
        "{bksp}" //
    ]
};


const $bfea531d91d8f260$var$VirtualKeyboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((props, ref)=>{
    const { layoutName: layoutName = "default" } = props;
    const keyboardRef = (0, $eZVvM.useRef)();
    (0, $eZVvM.useImperativeHandle)(ref, ()=>({
            setInput: (input, inputName, skipSync)=>{
                if (!keyboardRef.current) return;
                keyboardRef.current.setInput(input, inputName, skipSync);
            },
            setCaretPosition: (position, endPosition)=>{
                if (!keyboardRef.current) return;
                keyboardRef.current.setCaretPosition(position, endPosition);
            }
        }));
    return (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7a86233f32729561$exports))), Object.assign({}, props, {
        keyboardRef: (ref)=>{
            keyboardRef.current = ref;
        },
        tabCharOnTab: false,
        mergeDisplay: true,
        layout: (0, $d0f9aa612dc769dd$export$78ca07932ec5b059),
        display: (0, $d0f9aa612dc769dd$export$86757e9fe5e12048)[layoutName],
        preventMouseDownDefault: true
    }));
});
var $bfea531d91d8f260$export$2e2bcd8739ae039 = $bfea531d91d8f260$var$VirtualKeyboard;



var $ezhXm = parcelRequire("ezhXm");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $eZVvM = parcelRequire("eZVvM");
"use client";
let $a2ea28bfa453c5f2$var$globalId = 0;
function $a2ea28bfa453c5f2$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $eZVvM.useState(idOverride);
    const id = idOverride || defaultId;
    $eZVvM.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a2ea28bfa453c5f2$var$globalId += 1;
            setDefaultId(`mui-${$a2ea28bfa453c5f2$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $a2ea28bfa453c5f2$var$maybeReactUseId = $eZVvM["useId".toString()];
function $a2ea28bfa453c5f2$export$2e2bcd8739ae039(idOverride) {
    if ($a2ea28bfa453c5f2$var$maybeReactUseId !== undefined) {
        const reactId = $a2ea28bfa453c5f2$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a2ea28bfa453c5f2$var$useGlobalId(idOverride);
}



var $iDCHz = parcelRequire("iDCHz");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");


var $eZVvM = parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $9a735760a312790a$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $9a735760a312790a$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $9a735760a312790a$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $9a735760a312790a$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $9a735760a312790a$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $9a735760a312790a$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($9a735760a312790a$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $9a735760a312790a$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$9a735760a312790a$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $9a735760a312790a$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $9a735760a312790a$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $9a735760a312790a$var$defaultGetTabbable, isEnabled: isEnabled = $9a735760a312790a$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $eZVvM.useRef(false);
    const sentinelStart = $eZVvM.useRef(null);
    const sentinelEnd = $eZVvM.useRef(null);
    const nodeToRestore = $eZVvM.useRef(null);
    const reactFocusEventTarget = $eZVvM.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $eZVvM.useRef(false);
    const rootRef = $eZVvM.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $eZVvM.useRef(null);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $eZVvM.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $3pI8R.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $9a735760a312790a$export$2e2bcd8739ae039 = $9a735760a312790a$var$FocusTrap;



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $d431bbc85d36d423$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $d431bbc85d36d423$var$Portal = /*#__PURE__*/ $eZVvM.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $eZVvM.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(/*#__PURE__*/ $eZVvM.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($d431bbc85d36d423$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $eZVvM.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $eZVvM.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: mountNode ? /*#__PURE__*/ $e4ZGj.createPortal(children, mountNode) : mountNode
    });
});
var $d431bbc85d36d423$export$2e2bcd8739ae039 = $d431bbc85d36d423$var$Portal;



var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");


var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $5513df1d16403230$export$9927a91fd93152bd(slot) {
    return (0, $8QgsE.default)("MuiBackdrop", slot);
}
const $5513df1d16403230$var$backdropClasses = (0, $dvQev.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5513df1d16403230$export$2e2bcd8739ae039 = $5513df1d16403230$var$backdropClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $d323689de65b1dad$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $d323689de65b1dad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $5513df1d16403230$export$9927a91fd93152bd), classes);
};
const $d323689de65b1dad$var$BackdropRoot = (0, $e8m2I.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $d323689de65b1dad$var$Backdrop = /*#__PURE__*/ $eZVvM.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $db075bdb02672c7e$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $7Z8DW.default)(props, $d323689de65b1dad$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $d323689de65b1dad$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($d323689de65b1dad$var$BackdropRoot, (0, $65o8X.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $fmwLG.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $65o8X.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $d323689de65b1dad$export$2e2bcd8739ae039 = $d323689de65b1dad$var$Backdrop;



var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c9bdc9b352c474f0$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $2b883556515dfdf6$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $95b4fb93ac7ed8b4$export$2e2bcd8739ae039(node) {
    const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $03d55f7ae7b30e86$var$isOverflowing(container) {
    const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $03d55f7ae7b30e86$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $03d55f7ae7b30e86$var$getPaddingRight(element) {
    return parseInt((0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $03d55f7ae7b30e86$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $03d55f7ae7b30e86$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$03d55f7ae7b30e86$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(element, show);
    });
}
function $03d55f7ae7b30e86$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $03d55f7ae7b30e86$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($03d55f7ae7b30e86$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $2b883556515dfdf6$export$2e2bcd8739ae039)((0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$03d55f7ae7b30e86$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$03d55f7ae7b30e86$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $03d55f7ae7b30e86$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $03d55f7ae7b30e86$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $03d55f7ae7b30e86$var$getHiddenSiblings(container);
        $03d55f7ae7b30e86$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $03d55f7ae7b30e86$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $03d55f7ae7b30e86$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $03d55f7ae7b30e86$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


"use client";
function $02aadfc08eed2b96$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $02aadfc08eed2b96$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $02aadfc08eed2b96$var$defaultManager = new (0, $03d55f7ae7b30e86$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $02aadfc08eed2b96$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $02aadfc08eed2b96$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $eZVvM.useRef({});
    const mountNodeRef = $eZVvM.useRef(null);
    const modalRef = $eZVvM.useRef(null);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $eZVvM.useState(!open);
    const hasTransition = $02aadfc08eed2b96$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $02aadfc08eed2b96$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $eZVvM.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $03d55f7ae7b30e86$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $eZVvM.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $eZVvM.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $65o8X.default)({}, propsEventHandlers, otherHandlers);
        return (0, $65o8X.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $65o8X.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $c9bdc9b352c474f0$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $c9bdc9b352c474f0$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $02aadfc08eed2b96$export$2e2bcd8739ae039 = $02aadfc08eed2b96$var$useModal;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $1b5279c4e884991d$export$67960e22b12a638d(slot) {
    return (0, $8QgsE.default)("MuiModal", slot);
}
const $1b5279c4e884991d$var$modalClasses = (0, $dvQev.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $1b5279c4e884991d$export$2e2bcd8739ae039 = $1b5279c4e884991d$var$modalClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $010e20fed2f5ff9a$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $010e20fed2f5ff9a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $1b5279c4e884991d$export$67960e22b12a638d), classes);
};
const $010e20fed2f5ff9a$var$ModalRoot = (0, $e8m2I.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $010e20fed2f5ff9a$var$ModalBackdrop = (0, $e8m2I.default)((0, $d323689de65b1dad$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $010e20fed2f5ff9a$var$Modal = /*#__PURE__*/ $eZVvM.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $8C83T.useDefaultProps)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $010e20fed2f5ff9a$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $7Z8DW.default)(props, $010e20fed2f5ff9a$var$_excluded);
    const propsWithDefaults = (0, $65o8X.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $02aadfc08eed2b96$export$2e2bcd8739ae039)((0, $65o8X.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $65o8X.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $010e20fed2f5ff9a$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $010e20fed2f5ff9a$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $fmwLG.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $65o8X.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $fmwLG.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d431bbc85d36d423$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)(RootSlot, (0, $65o8X.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $3pI8R.jsx)(BackdropSlot, (0, $65o8X.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $3pI8R.jsx)((0, $9a735760a312790a$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $eZVvM.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $010e20fed2f5ff9a$export$2e2bcd8739ae039 = $010e20fed2f5ff9a$var$Modal;





var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $2adbfb2c9b461f68$export$2177af0aa15c34c2(slot) {
    return (0, $8QgsE.default)("MuiDialog", slot);
}
const $2adbfb2c9b461f68$var$dialogClasses = (0, $dvQev.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $2adbfb2c9b461f68$export$2e2bcd8739ae039 = $2adbfb2c9b461f68$var$dialogClasses;



var $eZVvM = parcelRequire("eZVvM");
const $c6eb0b1012d622bb$var$DialogContext = /*#__PURE__*/ $eZVvM.createContext({});
var $c6eb0b1012d622bb$export$2e2bcd8739ae039 = $c6eb0b1012d622bb$var$DialogContext;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b7efd849c463cc27$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $b7efd849c463cc27$var$DialogBackdrop = (0, $e8m2I.default)((0, $d323689de65b1dad$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $b7efd849c463cc27$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $iDCHz.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $iDCHz.default)(scroll)}`,
            `paperWidth${(0, $iDCHz.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $2adbfb2c9b461f68$export$2177af0aa15c34c2), classes);
};
const $b7efd849c463cc27$var$DialogRoot = (0, $e8m2I.default)((0, $010e20fed2f5ff9a$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $b7efd849c463cc27$var$DialogContainer = (0, $e8m2I.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $iDCHz.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $b7efd849c463cc27$var$DialogPaper = (0, $e8m2I.default)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $iDCHz.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $iDCHz.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $b7efd849c463cc27$var$Dialog = /*#__PURE__*/ $eZVvM.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $08c3c2df346a18c6$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $db075bdb02672c7e$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $7Z8DW.default)(props, $b7efd849c463cc27$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $b7efd849c463cc27$var$useUtilityClasses(ownerState);
    const backdropClick = $eZVvM.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $eZVvM.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $b7efd849c463cc27$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $65o8X.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogContainer, {
                className: (0, $fmwLG.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogPaper, (0, $65o8X.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $fmwLG.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $c6eb0b1012d622bb$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $b7efd849c463cc27$export$2e2bcd8739ae039 = $b7efd849c463cc27$var$Dialog;


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $50a704ab66e6eab1$export$61b0ee1f05fb344e(slot) {
    return (0, $8QgsE.default)("MuiDialogContent", slot);
}
const $50a704ab66e6eab1$var$dialogContentClasses = (0, $dvQev.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $50a704ab66e6eab1$export$2e2bcd8739ae039 = $50a704ab66e6eab1$var$dialogContentClasses;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $5b54c0043a945c99$export$f5d2ec7e4c47e088(slot) {
    return (0, $8QgsE.default)("MuiDialogTitle", slot);
}
const $5b54c0043a945c99$var$dialogTitleClasses = (0, $dvQev.default)("MuiDialogTitle", [
    "root"
]);
var $5b54c0043a945c99$export$2e2bcd8739ae039 = $5b54c0043a945c99$var$dialogTitleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4baac96c69466163$var$_excluded = [
    "className",
    "dividers"
];
const $4baac96c69466163$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $50a704ab66e6eab1$export$61b0ee1f05fb344e), classes);
};
const $4baac96c69466163$var$DialogContentRoot = (0, $e8m2I.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $5b54c0043a945c99$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4baac96c69466163$var$DialogContent = /*#__PURE__*/ $eZVvM.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $7Z8DW.default)(props, $4baac96c69466163$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        dividers: dividers
    });
    const classes = $4baac96c69466163$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($4baac96c69466163$var$DialogContentRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4baac96c69466163$export$2e2bcd8739ae039 = $4baac96c69466163$var$DialogContent;


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");





// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $cdd9f8889be8e555$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $c67a96687a400a99$export$2e2bcd8739ae039 = (0, $cdd9f8889be8e555$export$2e2bcd8739ae039);






var $173ff66374ad2b51$export$2e2bcd8739ae039 = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039);



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9ebd66ad6ae55237$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $9ebd66ad6ae55237$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $9ebd66ad6ae55237$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $9ebd66ad6ae55237$var$resolveContainer(containerProp);
    const transform = $9ebd66ad6ae55237$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $9ebd66ad6ae55237$var$Slide = /*#__PURE__*/ $eZVvM.forwardRef(function Slide(props, ref) {
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $9ebd66ad6ae55237$var$_excluded);
    const childrenRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $65o8X.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $65o8X.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $eZVvM.useCallback(()=>{
        if (childrenRef.current) $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $eZVvM.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $c67a96687a400a99$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $eZVvM.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                ref: handleRef,
                style: (0, $65o8X.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $9ebd66ad6ae55237$export$2e2bcd8739ae039 = $9ebd66ad6ae55237$var$Slide;


var $81BVN = parcelRequire("81BVN");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $219y6 = parcelRequire("219y6");

var $cD0nt = parcelRequire("cD0nt");
const $648bc4d76c5ac4a8$var$Transition = /*#__PURE__*/ (0, $eZVvM.forwardRef)(function Transition(props, ref) {
    return (0, $bhfvP.jsx)((0, $9ebd66ad6ae55237$export$2e2bcd8739ae039), Object.assign({
        direction: "up",
        ref: ref
    }, props));
});
const $648bc4d76c5ac4a8$var$OfflineModal = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "offline"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    if (online) return null;
    return (0, $bhfvP.jsx)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), Object.assign({
        fullScreen: true,
        open: true,
        onClose: ()=>{
            navigate("/");
        },
        TransitionComponent: $648bc4d76c5ac4a8$var$Transition,
        sx: {
            p: 3,
            "& .MuiPaper-root": {
                borderRadius: 2
            }
        }
    }, {
        children: (0, $bhfvP.jsxs)((0, $4baac96c69466163$export$2e2bcd8739ae039), Object.assign({
            sx: {
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100%"
            }
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                    variant: "h1",
                    sx: {
                        px: 4
                    }
                }, {
                    children: t("offline:receptionMessage")
                })),
                receptionistPhone && (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                    variant: "h1",
                    sx: {
                        px: 4
                    }
                }, {
                    children: t("offline:check", {
                        receptionistPhone: receptionistPhone
                    })
                }))
            ]
        }))
    }));
};
var $648bc4d76c5ac4a8$export$2e2bcd8739ae039 = $648bc4d76c5ac4a8$var$OfflineModal;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $ljukC = parcelRequire("ljukC");




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $ebaaf8db826d1cf9$export$5e57a444791c63be(slot) {
    return (0, $8QgsE.default)("MuiDialogActions", slot);
}
const $ebaaf8db826d1cf9$var$dialogActionsClasses = (0, $dvQev.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $ebaaf8db826d1cf9$export$2e2bcd8739ae039 = $ebaaf8db826d1cf9$var$dialogActionsClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $04c04e378ccee6ce$var$_excluded = [
    "className",
    "disableSpacing"
];
const $04c04e378ccee6ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $ebaaf8db826d1cf9$export$5e57a444791c63be), classes);
};
const $04c04e378ccee6ce$var$DialogActionsRoot = (0, $e8m2I.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $04c04e378ccee6ce$var$DialogActions = /*#__PURE__*/ $eZVvM.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $7Z8DW.default)(props, $04c04e378ccee6ce$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $04c04e378ccee6ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($04c04e378ccee6ce$var$DialogActionsRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $04c04e378ccee6ce$export$2e2bcd8739ae039 = $04c04e378ccee6ce$var$DialogActions;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");

var $81BVN = parcelRequire("81BVN");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $69d1bef0f647023a$export$d9c6dc45f75b0e4f(slot) {
    return (0, $8QgsE.default)("MuiDialogContentText", slot);
}
const $69d1bef0f647023a$var$dialogContentTextClasses = (0, $dvQev.default)("MuiDialogContentText", [
    "root"
]);
var $69d1bef0f647023a$export$2e2bcd8739ae039 = $69d1bef0f647023a$var$dialogContentTextClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c094567c9dcd56f3$var$_excluded = [
    "children",
    "className"
];
const $c094567c9dcd56f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $69d1bef0f647023a$export$d9c6dc45f75b0e4f), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $c094567c9dcd56f3$var$DialogContentTextRoot = (0, $e8m2I.default)((0, $81BVN.default), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c094567c9dcd56f3$var$DialogContentText = /*#__PURE__*/ $eZVvM.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $7Z8DW.default)(props, $c094567c9dcd56f3$var$_excluded);
    const classes = $c094567c9dcd56f3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c094567c9dcd56f3$var$DialogContentTextRoot, (0, $65o8X.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $c094567c9dcd56f3$export$2e2bcd8739ae039 = $c094567c9dcd56f3$var$DialogContentText;



var $4yVoh = parcelRequire("4yVoh");
// <PreviewPDF pdfLink={aggrement.file.absolutePath} />
const $481129126104bb44$var$animateAgreement = {
    initial: {
        x: "100%"
    },
    animate: {
        x: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        x: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $481129126104bb44$var$AgreementDialog = (props)=>{
    var _a, _b, _c, _d;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "previewPDF"
    ]);
    const { aggrements: aggrements, onDismiss: onDismiss, onSubmit: onSubmit } = props;
    const aggrement = aggrements[0];
    return (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
        mode: "wait"
    }, {
        children: !!aggrement && (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), Object.assign({
            fullScreen: true,
            open: !!aggrement,
            transitionDuration: 0,
            component: (0, $ljukC.motion).div
        }, (0, $4yVoh.anim)($481129126104bb44$var$animateAgreement), {
            children: [
                (0, $bhfvP.jsxs)((0, $4baac96c69466163$export$2e2bcd8739ae039), Object.assign({
                    dividers: true,
                    className: "p-0"
                }, {
                    children: [
                        !!aggrement.text && (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), Object.assign({
                                    className: "mb-5",
                                    style: {
                                        fontSize: "5rem",
                                        color: "#000000"
                                    }
                                }, {
                                    children: aggrement.title
                                })),
                                (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), Object.assign({
                                    style: {
                                        fontSize: "3rem",
                                        color: "#000000"
                                    }
                                }, {
                                    children: aggrement.text
                                }))
                            ]
                        }),
                        ((_b = (_a = aggrement === null || aggrement === void 0 ? void 0 : aggrement.file) === null || _a === void 0 ? void 0 : _a.absolutePath) === null || _b === void 0 ? void 0 : _b.endsWith("pdf")) && (0, $bhfvP.jsx)("iframe", {
                            title: "aggrement",
                            src: `${aggrement.file.absolutePath}#toolbar=0`,
                            width: "100%",
                            height: "98%"
                        }),
                        !((_d = (_c = aggrement === null || aggrement === void 0 ? void 0 : aggrement.file) === null || _c === void 0 ? void 0 : _c.absolutePath) === null || _d === void 0 ? void 0 : _d.endsWith("pdf")) && (0, $bhfvP.jsx)("div", {
                            className: "ea-image h-100",
                            style: {
                                backgroundImage: `url("${aggrement.file.absolutePath}#toolbar=0")`
                            }
                        })
                    ]
                })),
                (0, $bhfvP.jsxs)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), Object.assign({
                    className: "p-5"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                            variant: "contained",
                            className: "px-5 me-5 w",
                            onClick: onDismiss
                        }, {
                            children: t("previewPDF:button.cancel")
                        })),
                        (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                            variant: "contained",
                            className: "px-5",
                            onClick: ()=>onSubmit(aggrement.id)
                        }, {
                            children: aggrement.approvalRequired ? t("previewPDF:button.accept") : t("previewPDF:button.next")
                        }))
                    ]
                }))
            ]
        }))
    }));
};
var $481129126104bb44$export$2e2bcd8739ae039 = $481129126104bb44$var$AgreementDialog;



var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $cD0nt = parcelRequire("cD0nt");
const $537fa6077f9ab8f6$export$991b23a188dc1bb5 = ()=>{
    var _a, _b, _c;
    const { data: data } = (0, $cD0nt.default)();
    const { state: state } = (0, $9B9bN.useLocation)();
    const entranceAgreement = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.entranceAgreement;
    const showFirst = (_b = entranceAgreement === null || entranceAgreement === void 0 ? void 0 : entranceAgreement.showFirst) !== null && _b !== void 0 ? _b : false;
    const unacceptedAgreements = !(entranceAgreement === null || entranceAgreement === void 0 ? void 0 : entranceAgreement.disabled) ? (_c = entranceAgreement === null || entranceAgreement === void 0 ? void 0 : entranceAgreement.files) === null || _c === void 0 ? void 0 : _c.filter((file)=>!file.disabled) : [];
    const value = (0, $eZVvM.useMemo)(()=>{
        var _a;
        return {
            screen: ((_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.id) || "",
            showFirst: showFirst,
            unacceptedAgreements: unacceptedAgreements
        };
    }, [
        state,
        unacceptedAgreements,
        data
    ]);
    return value;
};



var $k9qks = parcelRequire("k9qks");

var $219y6 = parcelRequire("219y6");

var $eGmvL = parcelRequire("eGmvL");

var $bzcXF = parcelRequire("bzcXF");

var $eZVvM = parcelRequire("eZVvM");

var $4yVoh = parcelRequire("4yVoh");

var $cD0nt = parcelRequire("cD0nt");
const $9c5b8dd9cccd80bb$var$moveUp = (delay)=>({
        initial: {
            y: 150,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.35,
                delay: delay,
                ease: "easeOut"
            }
        }
    });
const $9c5b8dd9cccd80bb$var$MoveUp = (props)=>{
    const { children: children, disabled: disabled, delay: delay } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, Object.assign({}, (0, $4yVoh.anim)($9c5b8dd9cccd80bb$var$moveUp(delay))));
};
var $9c5b8dd9cccd80bb$export$2e2bcd8739ae039 = $9c5b8dd9cccd80bb$var$MoveUp;


const $4f24c342e6539ecf$var$Divider = (0, $e8m2I.default)("div")(({ theme: theme })=>({
        backgroundColor: theme.palette.text.primary
    }));
const $4f24c342e6539ecf$var$ScannerButton = (0, $e8m2I.default)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        fontSize: "2.5rem"
    }));
const $4f24c342e6539ecf$export$75ee337032588709 = (0, $e8m2I.default)((0, $ljukC.motion).input)(({ theme: theme })=>({
        color: theme.palette.text.primary,
        borderColor: theme.palette.primary.main,
        background: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.background.default).lighten(0.1).hex(),
        "&:focus": {
            borderColor: theme.palette.primary.main,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.background.default).darken(0.07).hex()
        },
        "&.error": {
            borderColor: theme.palette.error.main
        }
    }));
const $4f24c342e6539ecf$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $4f24c342e6539ecf$var$isMediaDevicesSupported = ()=>{
    const isMediaDevicesSupported = typeof navigator !== "undefined" && !!navigator.mediaDevices;
    return isMediaDevicesSupported;
};
const $4f24c342e6539ecf$var$CheckPage = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "check"
    ]);
    const { action: action, code: code } = (0, $9B9bN.useParams)();
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/access\/${action}\/?$`).test(pathname);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const isCameraFeatureEnabled = (0, $eZVvM.useMemo)(()=>{
        const isNotFree = clientPlan && clientPlan !== "free";
        if (!isNotFree) return false;
        return $4f24c342e6539ecf$var$isMediaDevicesSupported();
    }, [
        clientPlan
    ]);
    const { integratedManualCheckin: integratedManualCheckin, checkout: checkout, manualCheckout: manualCheckout } = (0, $cD0nt.useLayout)();
    const [pinCode, setPinCode] = (0, (/*@__PURE__*/$parcel$interopDefault($ff7bcb23a771808b$exports)))($4f24c342e6539ecf$var$defaultPinCode);
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const navigate = (0, $9B9bN.useNavigate)();
    const { showFirst: showFirst, unacceptedAgreements: unacceptedAgreements } = (0, $537fa6077f9ab8f6$export$991b23a188dc1bb5)();
    const [pendingAgreements, setPendingAgreements] = (0, $eZVvM.useState)(action === "checkin" && showFirst && mainRoute && unacceptedAgreements ? unacceptedAgreements : []); // usePageTracking({
    //   page: action,
    // });
    // const { trackEvent } = useEventTracking();
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        var _a;
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode({
                [focusedInput]: value
            });
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                if (document.activeElement) (_a = document.activeElement) === null || _a === void 0 || _a.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            setPinCode(()=>({
                    [focusedInput]: ""
                }));
            const nextFocusedInput = Math.max(1, +focusedInput - 1);
            setFocusedInput(`${nextFocusedInput}`);
        }
    }, [
        focusedInput
    ]);
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, (/*@__PURE__*/$parcel$interopDefault($f896ef6492898da5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e93d02b5708fd941$exports)))(6), (acc, key)=>Object.assign(Object.assign({}, acc), {
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, []);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event; // trackEvent({ type: "input_focus", value: `pin_${action}` });
        setFocusedInput(`${+name}`);
        if (keyboard.current) keyboard.current.setInput("", name);
    }, []);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; /**
                * Blur when setting last input is set form keyboard
                */ 
        if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, []);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault(); // eslint-disable-next-line prefer-destructuring
                    const name = (event === null || event === void 0 ? void 0 : event.currentTarget).name;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($4f24c342e6539ecf$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 || element.addEventListener("beforeinput", onBeforeInput);
        }); // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 || element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                {
                    event.preventDefault();
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _a;
        if (event.target && ((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    }); /**
       * Auto-focus input
       */ 
    (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]); /**
                       * Re-focus first input after we go back to this page.
                       * Useful when we get back from code scan with an error
                       */ 
    (0, $eZVvM.useEffect)(()=>{
        if (!code && !focusedInput) setFocusedInput("1");
    }, [
        code
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const pinCodeArr = Object.values(pinCode);
        const timeout = setTimeout(()=>{
            var _a;
            if (pinCodeArr.every((input)=>input !== "")) {
                navigate({
                    pathname: `${pinCodeArr.join("")}`
                }); // setPinCode(defaultPinCode);
                setFocusedInput(undefined);
                if (document.activeElement) (_a = document.activeElement) === null || _a === void 0 || _a.blur();
            }
        }, 500);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pinCode
    ]);
    const backLink = (0, $eZVvM.useMemo)(()=>{
        if (action === "checkin" && (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled)) return "/access/option/checkin";
        if (action === "checkout" && (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return "/access/option/checkout";
        return "/";
    }, []);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $3pTPw.default), {
                        to: backLink
                    }),
                    (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                        disableAnimation: !mainRoute
                    }, {
                        children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h1"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: isCameraFeatureEnabled ? `check:qrScanner.${action}.title` : "check:title"
                            })
                        }))
                    })),
                    (0, $bhfvP.jsxs)("div", Object.assign({
                        className: "check-options"
                    }, {
                        children: [
                            isCameraFeatureEnabled && (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                children: [
                                    (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                                        disabled: !mainRoute
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, {
                                            children: (0, $bhfvP.jsx)($4f24c342e6539ecf$var$ScannerButton, Object.assign({
                                                variant: "contained",
                                                disabled: !online,
                                                onClick: ()=>{
                                                    // trackEvent({ type: "scan_button_click", value: action });
                                                    navigate(`/scanner/${action}`);
                                                }
                                            }, {
                                                children: t("check:qrScanner.btn")
                                            }))
                                        })
                                    })),
                                    (0, $bhfvP.jsxs)("div", Object.assign({
                                        className: "divider d-flex align-items-center mx-auto"
                                    }, {
                                        children: [
                                            (0, $bhfvP.jsx)($4f24c342e6539ecf$var$Divider, {
                                                className: "col dropdown-divider"
                                            }),
                                            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                                variant: "h4",
                                                className: "col-auto px-5"
                                            }, {
                                                children: t("check:orText")
                                            })),
                                            (0, $bhfvP.jsx)($4f24c342e6539ecf$var$Divider, {
                                                className: "col dropdown-divider"
                                            })
                                        ]
                                    }))
                                ]
                            }),
                            (0, $bhfvP.jsxs)("form", Object.assign({
                                className: "pin__wrapper",
                                autoComplete: "off"
                            }, {
                                children: [
                                    (0, $bhfvP.jsx)((0, $eGmvL.default), Object.assign({
                                        className: "mx-auto",
                                        disabled: !mainRoute
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                            variant: "h4",
                                            className: "font-weight-regular pin__title w-100"
                                        }, {
                                            children: t("check:pinCode")
                                        }))
                                    })),
                                    [
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ].map((i)=>(0, $bhfvP.jsx)((0, $9c5b8dd9cccd80bb$export$2e2bcd8739ae039), Object.assign({
                                            disabled: !mainRoute,
                                            delay: 0.15 + 0.05 * i
                                        }, {
                                            children: (0, $bhfvP.jsx)($4f24c342e6539ecf$export$75ee337032588709, {
                                                id: `${i}`,
                                                name: `${i}`,
                                                min: 0,
                                                max: 9,
                                                type: (0, $k9qks.isVirtualKeyboardEnabled) ? "text" : "number",
                                                className: "pin__input",
                                                autoComplete: "chrome-off",
                                                onFocus: onFocus,
                                                onChange: onChange,
                                                onKeyDown: onKeyDown,
                                                onPasteCapture: onPasteCapture,
                                                value: pinCode[i],
                                                maxLength: 1,
                                                pattern: "[0-9]*"
                                            })
                                        }), i))
                                ]
                            }))
                        ]
                    })),
                    (0, $k9qks.isVirtualKeyboardEnabled) && (0, $bhfvP.jsx)("div", Object.assign({
                        ref: keyboardBox,
                        className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                            keyboard__out: !focusedInput
                        }),
                        onClick: (e)=>{
                            e.stopPropagation();
                        }
                    }, {
                        children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                            ref: keyboard,
                            disableButtonHold: true,
                            layoutName: "pin",
                            inputName: focusedInput,
                            onChange: onKeyboardChange,
                            onKeyPress: onKeyboardKeyPress
                        })
                    }))
                ]
            })),
            (0, $bhfvP.jsx)((0, $481129126104bb44$export$2e2bcd8739ae039), {
                aggrements: pendingAgreements,
                onDismiss: ()=>{
                    navigate("/");
                },
                onSubmit: ()=>{
                    setPendingAgreements((prev)=>{
                        const [_accepted, ...rest] = prev;
                        return rest;
                    });
                }
            }),
            (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4f24c342e6539ecf$export$2e2bcd8739ae039 = $4f24c342e6539ecf$var$CheckPage;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");


var $81BVN = parcelRequire("81BVN");

var $ljukC = parcelRequire("ljukC");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $bf84313ce63ae7d0$var$SvgCode = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M73.333 23.333H6.667A6.673 6.673 0 0 0 0 30v20a6.673 6.673 0 0 0 6.667 6.667h66.666A6.673 6.673 0 0 0 80 50V30a6.673 6.673 0 0 0-6.667-6.667ZM76.667 50a3.338 3.338 0 0 1-3.334 3.333H6.667A3.338 3.338 0 0 1 3.333 50V30a3.338 3.338 0 0 1 3.334-3.333h66.666A3.338 3.338 0 0 1 76.667 30v20Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M20.773 36.667a1.667 1.667 0 0 0-2.277-.61l-1.83 1.056V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.829-1.057a1.666 1.666 0 1 0-1.667 2.887L11.667 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45a1.666 1.666 0 1 0 3.333 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.611-2.278L18.333 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277ZM37.44 36.667a1.667 1.667 0 0 0-2.277-.61l-1.83 1.056V35A1.666 1.666 0 1 0 30 35v2.113l-1.83-1.057a1.666 1.666 0 1 0-1.667 2.887L28.334 40l-1.829 1.056a1.667 1.667 0 1 0 1.667 2.888L30 42.887V45a1.666 1.666 0 1 0 3.332 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.61-2.278L35 40l1.83-1.056a1.666 1.666 0 0 0 .61-2.277ZM54.106 36.667a1.667 1.667 0 0 0-2.277-.61L50 37.112V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.83-1.057a1.666 1.666 0 1 0-1.667 2.887L45 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45A1.666 1.666 0 1 0 50 45v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.61-2.278L51.666 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277ZM70.773 36.667a1.666 1.666 0 0 0-2.277-.61l-1.83 1.056V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.829-1.057a1.666 1.666 0 1 0-1.667 2.887L61.667 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45a1.666 1.666 0 1 0 3.333 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.611-2.278L68.333 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277Z"
            })
        ]
    });
var $bf84313ce63ae7d0$export$2e2bcd8739ae039 = $bf84313ce63ae7d0$var$SvgCode;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $290a81f72ffb3053$var$SvgManual = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 81 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M33.125 55.932c2.8-1.774 4.675-4.879 4.675-8.432 0-5.515-4.486-10-10-10s-10 4.485-10 10c0 3.553 1.875 6.658 4.674 8.432a17.09 17.09 0 0 0-9.358 7.852 2.5 2.5 0 1 0 4.368 2.432C19.619 62.383 23.57 60 27.8 60c4.228 0 8.181 2.383 10.316 6.216.651 1.169 2.204 1.63 3.4.969a2.5 2.5 0 0 0 .968-3.401 17.09 17.09 0 0 0-9.359-7.852ZM27.8 42.5c2.757 0 5 2.244 5 5s-2.243 5-5 5c-2.758 0-5-2.244-5-5s2.242-5 5-5Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M70.3 15h-20V7.5c0-2.756-2.243-5-5-5h-10c-2.758 0-5 2.244-5 5V15h-20c-4.136 0-7.5 3.364-7.5 7.5V70c0 4.136 3.364 7.5 7.5 7.5h60c4.136 0 7.5-3.364 7.5-7.5V22.5c0-4.136-3.364-7.5-7.5-7.5Zm-35-7.5h10l.004 9.982c0 .006-.004.012-.004.018h-10v-10ZM30.996 20c.867 1.487 2.461 2.5 4.304 2.5h10c1.842 0 3.437-1.013 4.304-2.5H52.8v5c0 1.38-1.122 2.5-2.5 2.5h-20c-1.378 0-2.5-1.12-2.5-2.5v-5h3.196ZM72.8 70c0 1.38-1.122 2.5-2.5 2.5h-60c-1.378 0-2.5-1.12-2.5-2.5V22.5c0-1.38 1.122-2.5 2.5-2.5h12.5v5c0 4.136 3.364 7.5 7.5 7.5h20c4.136 0 7.5-3.364 7.5-7.5v-5h12.5c1.378 0 2.5 1.12 2.5 2.5V70Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M65.3 40H47.8a2.5 2.5 0 1 0 0 5h17.5a2.5 2.5 0 1 0 0-5ZM65.3 50h-15a2.5 2.5 0 1 0 0 5h15a2.5 2.5 0 1 0 0-5ZM65.3 60H52.8a2.5 2.5 0 1 0 0 5h12.5a2.5 2.5 0 1 0 0-5Z"
            })
        ]
    });
var $290a81f72ffb3053$export$2e2bcd8739ae039 = $290a81f72ffb3053$var$SvgManual;



var $8YEKz = parcelRequire("8YEKz");

var $3pTPw = parcelRequire("3pTPw");

var $b275P = parcelRequire("b275P");


var $ezhXm = parcelRequire("ezhXm");

var $bzcXF = parcelRequire("bzcXF");
const $994dc2c1c556f1d6$var$MUIOptionButtonGroup = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)("div")({
    maxWidth: "90.4rem",
    width: "96%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "4.8rem 0 2.4rem",
    "@media screen and (orientation: landscape)": {
        maxWidth: "180.8rem",
        flexDirection: "row",
        padding: "0",
        "> div": {
            width: "50%"
        }
    }
});
const $994dc2c1c556f1d6$export$7a47e935b0481fac = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)((0, $ljukC.motion).button)(({ theme: theme })=>({
        position: "relative",
        width: "90%",
        height: "16rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "2.25rem 0 3.5rem",
        borderRadius: "1rem",
        border: `0.2rem solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
        ":hover": {
            backgroundColor: theme.palette.primary.dark,
            border: `0.2rem solid ${theme.palette.primary.dark}`
        },
        svg: {
            position: "absolute",
            left: "4rem",
            fill: theme.palette.background.default
        },
        h3: {
            color: theme.palette.background.default,
            margin: "0 12rem"
        },
        "@media screen and (orientation: landscape)": {
            height: "14rem",
            margin: "0 1rem 6.4rem 6rem"
        }
    }));
const $994dc2c1c556f1d6$var$CheckOptions = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { action: action } = (0, $9B9bN.useParams)();
    const { t: t } = (0, $9GLBV.useTranslation)();
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $3pTPw.default), {
                        to: "/"
                    }),
                    (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                        className: "page-title home"
                    }, {
                        children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h1"
                        }, {
                            children: t(`check:option.${action}.title`)
                        }))
                    })),
                    (0, $bhfvP.jsxs)($994dc2c1c556f1d6$var$MUIOptionButtonGroup, {
                        children: [
                            (0, $bhfvP.jsx)((0, $bzcXF.default), {
                                children: (0, $bhfvP.jsxs)($994dc2c1c556f1d6$export$7a47e935b0481fac, Object.assign({
                                    onClick: ()=>{
                                        return navigate(`/access/${action}`, {
                                            replace: true
                                        });
                                    }
                                }, {
                                    children: [
                                        (0, $bhfvP.jsx)((0, $bf84313ce63ae7d0$export$2e2bcd8739ae039), {
                                            width: "8rem"
                                        }),
                                        (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                            variant: "h3"
                                        }, {
                                            children: t(`check:option.${action}.code`)
                                        }))
                                    ]
                                }))
                            }),
                            (0, $bhfvP.jsx)((0, $bzcXF.default), {
                                children: (0, $bhfvP.jsxs)($994dc2c1c556f1d6$export$7a47e935b0481fac, Object.assign({
                                    onClick: ()=>{
                                        return navigate(`/access/${action}/manual`, {
                                            replace: true
                                        });
                                    }
                                }, {
                                    children: [
                                        (0, $bhfvP.jsx)((0, $290a81f72ffb3053$export$2e2bcd8739ae039), {
                                            width: "8rem"
                                        }),
                                        (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                            variant: "h3"
                                        }, {
                                            children: t(`check:option.${action}.manual`)
                                        }))
                                    ]
                                }))
                            })
                        ]
                    })
                ]
            })),
            (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $994dc2c1c556f1d6$export$2e2bcd8739ae039 = $994dc2c1c556f1d6$var$CheckOptions;



var $aNuUP = parcelRequire("aNuUP");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $eZVvM = parcelRequire("eZVvM");
var $afb237382692687d$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $afb237382692687d$var$isDateObject = (value1)=>value1 instanceof Date;
var $afb237382692687d$var$isNullOrUndefined = (value1)=>value1 == null;
const $afb237382692687d$var$isObjectType = (value1)=>typeof value1 === "object";
var $afb237382692687d$var$isObject = (value1)=>!$afb237382692687d$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $afb237382692687d$var$isObjectType(value1) && !$afb237382692687d$var$isDateObject(value1);
var $afb237382692687d$var$getEventValue = (event)=>$afb237382692687d$var$isObject(event) && event.target ? $afb237382692687d$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $afb237382692687d$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $afb237382692687d$var$isNameInFieldArray = (names, name)=>names.has($afb237382692687d$var$getNodeParentName(name));
var $afb237382692687d$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $afb237382692687d$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $afb237382692687d$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $afb237382692687d$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($afb237382692687d$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $afb237382692687d$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$afb237382692687d$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $afb237382692687d$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $afb237382692687d$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $afb237382692687d$var$isUndefined = (val)=>val === undefined;
var $afb237382692687d$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$afb237382692687d$var$isObject(object)) return defaultValue;
    const result = $afb237382692687d$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$afb237382692687d$var$isNullOrUndefined(result) ? result : result[key], object);
    return $afb237382692687d$var$isUndefined(result) || result === object ? $afb237382692687d$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $afb237382692687d$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $afb237382692687d$var$isKey = (value1)=>/^\w*$/.test(value1);
var $afb237382692687d$var$stringToPath = (input)=>$afb237382692687d$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $afb237382692687d$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $afb237382692687d$var$isKey(path) ? [
        path
    ] : $afb237382692687d$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $afb237382692687d$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $afb237382692687d$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $afb237382692687d$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $afb237382692687d$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $afb237382692687d$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afb237382692687d$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useContext($afb237382692687d$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afb237382692687d$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement($afb237382692687d$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $afb237382692687d$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $afb237382692687d$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $afb237382692687d$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $afb237382692687d$var$isEmptyObject = (value1)=>$afb237382692687d$var$isObject(value1) && !Object.keys(value1).length;
var $afb237382692687d$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $afb237382692687d$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $afb237382692687d$var$VALIDATION_MODE.all));
};
var $afb237382692687d$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $afb237382692687d$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $afb237382692687d$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $afb237382692687d$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$606f11b2eb45ecc6(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    _name.current = name;
    $afb237382692687d$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $afb237382692687d$var$shouldSubscribeByName(_name.current, value1.name, exact) && $afb237382692687d$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $afb237382692687d$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $afb237382692687d$var$isString = (value1)=>typeof value1 === "string";
var $afb237382692687d$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($afb237382692687d$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $afb237382692687d$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $afb237382692687d$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $afb237382692687d$export$3c773aa2b84f29e0(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    _name.current = name;
    $afb237382692687d$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($afb237382692687d$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($afb237382692687d$var$cloneObject($afb237382692687d$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$e8c786024a2b0a79(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $afb237382692687d$var$isNameInFieldArray(control._names.array, name);
    const value1 = $afb237382692687d$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $afb237382692687d$export$3988ae62b71be9a3(control._formValues, name, $afb237382692687d$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $afb237382692687d$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$afb237382692687d$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $afb237382692687d$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($afb237382692687d$var$isUndefined($afb237382692687d$export$3988ae62b71be9a3(control._formValues, name))) $afb237382692687d$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $afb237382692687d$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$afb237382692687d$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $afb237382692687d$var$getEventValue(event),
                        name: name
                    },
                    type: $afb237382692687d$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $afb237382692687d$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $afb237382692687d$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((elm)=>{
                const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$afb237382692687d$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $afb237382692687d$export$bd0bf19f25da8474 = (props)=>props.render($afb237382692687d$export$e8c786024a2b0a79(props));
const $afb237382692687d$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($afb237382692687d$var$isObjectType(obj[key])) {
        const nested = $afb237382692687d$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $afb237382692687d$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$a7fed597f4b8afd8(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $afb237382692687d$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $afb237382692687d$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $afb237382692687d$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $afb237382692687d$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $afb237382692687d$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $afb237382692687d$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$afb237382692687d$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $afb237382692687d$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $afb237382692687d$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $afb237382692687d$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $afb237382692687d$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $afb237382692687d$var$VALIDATION_MODE.all,
        isOnTouch: mode === $afb237382692687d$var$VALIDATION_MODE.onTouched
    });
var $afb237382692687d$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $afb237382692687d$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $afb237382692687d$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($afb237382692687d$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($afb237382692687d$var$isObject(currentField)) {
                if ($afb237382692687d$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $afb237382692687d$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$export$3988ae62b71be9a3(errors, name));
    $afb237382692687d$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $afb237382692687d$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $afb237382692687d$var$isFileInput = (element)=>element.type === "file";
var $afb237382692687d$var$isFunction = (value1)=>typeof value1 === "function";
var $afb237382692687d$var$isHTMLElement = (value1)=>{
    if (!$afb237382692687d$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $afb237382692687d$var$isMessage = (value1)=>$afb237382692687d$var$isString(value1);
var $afb237382692687d$var$isRadioInput = (element)=>element.type === "radio";
var $afb237382692687d$var$isRegex = (value1)=>value1 instanceof RegExp;
const $afb237382692687d$var$defaultResult = {
    value: false,
    isValid: false
};
const $afb237382692687d$var$validResult = {
    value: true,
    isValid: true
};
var $afb237382692687d$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$afb237382692687d$var$isUndefined(options[0].attributes.value) ? $afb237382692687d$var$isUndefined(options[0].value) || options[0].value === "" ? $afb237382692687d$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $afb237382692687d$var$validResult : $afb237382692687d$var$defaultResult;
    }
    return $afb237382692687d$var$defaultResult;
};
const $afb237382692687d$var$defaultReturn = {
    isValid: false,
    value: null
};
var $afb237382692687d$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $afb237382692687d$var$defaultReturn) : $afb237382692687d$var$defaultReturn;
function $afb237382692687d$var$getValidateError(result, ref, type = "validate") {
    if ($afb237382692687d$var$isMessage(result) || Array.isArray(result) && result.every($afb237382692687d$var$isMessage) || $afb237382692687d$var$isBoolean(result) && !result) return {
        type: type,
        message: $afb237382692687d$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $afb237382692687d$var$getValueAndMessage = (validationData)=>$afb237382692687d$var$isObject(validationData) && !$afb237382692687d$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $afb237382692687d$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $afb237382692687d$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($afb237382692687d$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $afb237382692687d$var$isRadioInput(ref);
    const isCheckBox = $afb237382692687d$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $afb237382692687d$var$isFileInput(ref)) && $afb237382692687d$var$isUndefined(ref.value) && $afb237382692687d$var$isUndefined(inputValue) || $afb237382692687d$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $afb237382692687d$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $afb237382692687d$var$INPUT_VALIDATION_RULES.maxLength, minType = $afb237382692687d$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $afb237382692687d$var$isNullOrUndefined(inputValue)) || $afb237382692687d$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$afb237382692687d$var$getCheckboxValue(refs).isValid || isRadio && !$afb237382692687d$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $afb237382692687d$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $afb237382692687d$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $afb237382692687d$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$afb237382692687d$var$isNullOrUndefined(min) || !$afb237382692687d$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $afb237382692687d$var$getValueAndMessage(max);
        const minOutput = $afb237382692687d$var$getValueAndMessage(min);
        if (!$afb237382692687d$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$afb237382692687d$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$afb237382692687d$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($afb237382692687d$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($afb237382692687d$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $afb237382692687d$var$INPUT_VALIDATION_RULES.max, $afb237382692687d$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($afb237382692687d$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $afb237382692687d$var$getValueAndMessage(maxLength);
        const minLengthOutput = $afb237382692687d$var$getValueAndMessage(minLength);
        const exceedMax = !$afb237382692687d$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$afb237382692687d$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $afb237382692687d$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $afb237382692687d$var$getValueAndMessage(pattern);
        if ($afb237382692687d$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $afb237382692687d$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($afb237382692687d$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $afb237382692687d$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($afb237382692687d$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$afb237382692687d$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $afb237382692687d$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$afb237382692687d$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $afb237382692687d$var$appendAt = (data, value1)=>[
        ...data,
        ...$afb237382692687d$var$convertToArrayPayload(value1)
    ];
var $afb237382692687d$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $afb237382692687d$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$afb237382692687d$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $afb237382692687d$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($afb237382692687d$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $afb237382692687d$var$prependAt = (data, value1)=>[
        ...$afb237382692687d$var$convertToArrayPayload(value1),
        ...$afb237382692687d$var$convertToArrayPayload(data)
    ];
function $afb237382692687d$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $afb237382692687d$var$compact(temp).length ? temp : [];
}
var $afb237382692687d$var$removeArrayAt = (data, index)=>$afb237382692687d$var$isUndefined(index) ? [] : $afb237382692687d$var$removeAtIndexes(data, $afb237382692687d$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $afb237382692687d$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $afb237382692687d$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $afb237382692687d$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $afb237382692687d$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$afb237382692687d$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $afb237382692687d$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $afb237382692687d$var$isKey(path) ? [
        path
    ] : $afb237382692687d$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $afb237382692687d$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($afb237382692687d$var$isObject(childObject) && $afb237382692687d$var$isEmptyObject(childObject) || Array.isArray(childObject) && $afb237382692687d$var$isEmptyArray(childObject))) $afb237382692687d$var$unset(object, paths.slice(0, -1));
    return object;
}
var $afb237382692687d$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$310131896651d559(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(control._getFieldArray(name).map($afb237382692687d$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $afb237382692687d$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $afb237382692687d$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($afb237382692687d$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $afb237382692687d$var$appendAt(ids.current, appendValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$appendAt, {
            argA: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, 0, options);
        ids.current = $afb237382692687d$var$prependAt(ids.current, prependValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$prependAt, {
            argA: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $afb237382692687d$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $afb237382692687d$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, index, options);
        ids.current = $afb237382692687d$var$insert(ids.current, index, insertValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$insert, {
            argA: index,
            argB: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afb237382692687d$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $afb237382692687d$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afb237382692687d$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $afb237382692687d$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $afb237382692687d$var$cloneObject(value1);
        const updatedFieldArrayValues = $afb237382692687d$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $afb237382692687d$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($afb237382692687d$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        control._state.action = false;
        $afb237382692687d$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$afb237382692687d$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $afb237382692687d$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $afb237382692687d$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $afb237382692687d$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $afb237382692687d$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($afb237382692687d$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $afb237382692687d$var$getValidationModes(control._options.mode).isOnSubmit)) $afb237382692687d$var$validateField(field, control._formValues, control._options.criteriaMode === $afb237382692687d$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$afb237382692687d$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $afb237382692687d$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $afb237382692687d$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        !$afb237382692687d$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $afb237382692687d$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $afb237382692687d$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $afb237382692687d$var$isPrimitive = (value1)=>$afb237382692687d$var$isNullOrUndefined(value1) || !$afb237382692687d$var$isObjectType(value1);
function $afb237382692687d$var$deepEqual(object1, object2) {
    if ($afb237382692687d$var$isPrimitive(object1) || $afb237382692687d$var$isPrimitive(object2)) return object1 === object2;
    if ($afb237382692687d$var$isDateObject(object1) && $afb237382692687d$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($afb237382692687d$var$isDateObject(val1) && $afb237382692687d$var$isDateObject(val2) || $afb237382692687d$var$isObject(val1) && $afb237382692687d$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$afb237382692687d$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $afb237382692687d$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $afb237382692687d$var$isRadioOrCheckbox = (ref)=>$afb237382692687d$var$isRadioInput(ref) || $afb237382692687d$var$isCheckBoxInput(ref);
var $afb237382692687d$var$live = (ref)=>$afb237382692687d$var$isHTMLElement(ref) && ref.isConnected;
var $afb237382692687d$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($afb237382692687d$var$isFunction(data[key])) return true;
    }
    return false;
};
function $afb237382692687d$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($afb237382692687d$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $afb237382692687d$var$isObject(data[key]) && !$afb237382692687d$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $afb237382692687d$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$afb237382692687d$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $afb237382692687d$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($afb237382692687d$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $afb237382692687d$var$isObject(data[key]) && !$afb237382692687d$var$objectHasFunction(data[key])) {
            if ($afb237382692687d$var$isUndefined(formValues) || $afb237382692687d$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $afb237382692687d$var$markFieldsDirty(data[key], []) : {
                ...$afb237382692687d$var$markFieldsDirty(data[key])
            };
            else $afb237382692687d$var$getDirtyFieldsFromDefaultValues(data[key], $afb237382692687d$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$afb237382692687d$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $afb237382692687d$var$getDirtyFields = (defaultValues, formValues)=>$afb237382692687d$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $afb237382692687d$var$markFieldsDirty(formValues));
var $afb237382692687d$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$afb237382692687d$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $afb237382692687d$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $afb237382692687d$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($afb237382692687d$var$isFileInput(ref)) return ref.files;
    if ($afb237382692687d$var$isRadioInput(ref)) return $afb237382692687d$var$getRadioValue(_f.refs).value;
    if ($afb237382692687d$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($afb237382692687d$var$isCheckBoxInput(ref)) return $afb237382692687d$var$getCheckboxValue(_f.refs).value;
    return $afb237382692687d$var$getFieldValueAs($afb237382692687d$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $afb237382692687d$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        field && $afb237382692687d$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $afb237382692687d$var$getRuleValue = (rule)=>$afb237382692687d$var$isUndefined(rule) ? rule : $afb237382692687d$var$isRegex(rule) ? rule.source : $afb237382692687d$var$isObject(rule) ? $afb237382692687d$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $afb237382692687d$var$ASYNC_FUNCTION = "AsyncFunction";
var $afb237382692687d$var$hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!($afb237382692687d$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $afb237382692687d$var$ASYNC_FUNCTION || $afb237382692687d$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $afb237382692687d$var$ASYNC_FUNCTION));
var $afb237382692687d$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $afb237382692687d$var$schemaErrorLookup(errors, _fields, name) {
    const error = $afb237382692687d$export$3988ae62b71be9a3(errors, name);
    if (error || $afb237382692687d$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $afb237382692687d$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $afb237382692687d$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $afb237382692687d$var$unsetEmptyArray = (ref, name)=>!$afb237382692687d$var$compact($afb237382692687d$export$3988ae62b71be9a3(ref, name)).length && $afb237382692687d$var$unset(ref, name);
const $afb237382692687d$var$defaultOptions = {
    mode: $afb237382692687d$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $afb237382692687d$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $afb237382692687d$var$createFormControl(props = {}) {
    let _options = {
        ...$afb237382692687d$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $afb237382692687d$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $afb237382692687d$var$isObject(_options.defaultValues) || $afb237382692687d$var$isObject(_options.values) ? $afb237382692687d$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $afb237382692687d$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $afb237382692687d$var$createSubject(),
        array: $afb237382692687d$var$createSubject(),
        state: $afb237382692687d$var$createSubject()
    };
    const validationModeBeforeSubmit = $afb237382692687d$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $afb237382692687d$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $afb237382692687d$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!props.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $afb237382692687d$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!props.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $afb237382692687d$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$afb237382692687d$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !props.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($afb237382692687d$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $afb237382692687d$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $afb237382692687d$export$3988ae62b71be9a3(_formValues, name, $afb237382692687d$var$isUndefined(value1) ? $afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $afb237382692687d$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $afb237382692687d$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!props.disabled) {
            const disabledField = !!($afb237382692687d$export$3988ae62b71be9a3(_fields, name) && $afb237382692687d$export$3988ae62b71be9a3(_fields, name)._f && $afb237382692687d$export$3988ae62b71be9a3(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || $afb237382692687d$var$deepEqual($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && $afb237382692687d$export$3988ae62b71be9a3(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? $afb237382692687d$var$unset(_formState.dirtyFields, name) : $afb237382692687d$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $afb237382692687d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $afb237382692687d$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afb237382692687d$var$unset(_formState.errors, name);
        }
        if ((error ? !$afb237382692687d$var$deepEqual(previousFieldError, error) : previousFieldError) || !$afb237382692687d$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $afb237382692687d$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $afb237382692687d$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $afb237382692687d$export$3988ae62b71be9a3(errors, name);
            error ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afb237382692687d$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $afb237382692687d$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $afb237382692687d$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($afb237382692687d$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $afb237382692687d$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $afb237382692687d$var$unset(_formState.errors, _f.name));
                }
                !$afb237382692687d$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$afb237382692687d$var$live(ref)) : !$afb237382692687d$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!props.disabled && (name && data && $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, data), !$afb237382692687d$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$afb237382692687d$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $afb237382692687d$var$isUndefined(defaultValue) ? _defaultValues : $afb237382692687d$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$afb237382692687d$var$compact($afb237382692687d$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, $afb237382692687d$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $afb237382692687d$var$isHTMLElement(fieldReference.ref) && $afb237382692687d$var$isNullOrUndefined(value1) ? "" : value1;
                if ($afb237382692687d$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($afb237382692687d$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($afb237382692687d$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $afb237382692687d$var$isObject(fieldValue) || field && !field._f) && !$afb237382692687d$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $afb237382692687d$var$cloneObject(value1);
        $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$afb237382692687d$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $afb237382692687d$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $afb237382692687d$var$getFieldValue(field._f) : $afb237382692687d$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $afb237382692687d$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $afb237382692687d$var$deepEqual(fieldValue, $afb237382692687d$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $afb237382692687d$var$EVENTS.BLUR || event.type === $afb237382692687d$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$afb237382692687d$var$hasValidation(field._f) && !_options.resolver && !$afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $afb237382692687d$var$skipValidation(isBlurEvent, $afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $afb237382692687d$var$isWatched(name, _names, isBlurEvent);
            $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$afb237382692687d$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === "onBlur") {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $afb237382692687d$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $afb237382692687d$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $afb237382692687d$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $afb237382692687d$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $afb237382692687d$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($afb237382692687d$var$isUndefined(name) ? name : fieldNames);
            isValid = $afb237382692687d$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$afb237382692687d$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$afb237382692687d$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $afb237382692687d$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $afb237382692687d$var$isUndefined(fieldNames) ? values : $afb237382692687d$var$isString(fieldNames) ? $afb237382692687d$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$afb237382692687d$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $afb237382692687d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$afb237382692687d$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $afb237382692687d$var$convertToArrayPayload(name).forEach((inputName)=>$afb237382692687d$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($afb237382692687d$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$afb237382692687d$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $afb237382692687d$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $afb237382692687d$var$unset(_fields, fieldName);
                $afb237382692687d$var$unset(_formValues, fieldName);
            }
            !options.keepError && $afb237382692687d$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $afb237382692687d$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $afb237382692687d$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $afb237382692687d$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $afb237382692687d$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($afb237382692687d$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $afb237382692687d$var$isUndefined(value1) ? $afb237382692687d$var$getFieldValue(field ? field._f : $afb237382692687d$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $afb237382692687d$var$isBoolean(options.disabled) || $afb237382692687d$var$isBoolean(props.disabled);
        $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $afb237382692687d$var$isBoolean(options.disabled) ? options.disabled : props.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || props.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $afb237382692687d$var$getRuleValue(options.min),
                max: $afb237382692687d$var$getRuleValue(options.max),
                minLength: $afb237382692687d$var$getRuleValue(options.minLength),
                maxLength: $afb237382692687d$var$getRuleValue(options.maxLength),
                pattern: $afb237382692687d$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $afb237382692687d$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $afb237382692687d$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($afb237382692687d$var$live),
                                    fieldRef,
                                    ...Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($afb237382692687d$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $afb237382692687d$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($afb237382692687d$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $afb237382692687d$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $afb237382692687d$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $afb237382692687d$var$unset(_formState.errors, "root");
            if ($afb237382692687d$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $afb237382692687d$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(_fields, name)) {
            if ($afb237382692687d$var$isUndefined(options.defaultValue)) setValue(name, $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $afb237382692687d$export$adaa4cf7ef1b65be(_defaultValues, name, $afb237382692687d$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $afb237382692687d$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $afb237382692687d$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $afb237382692687d$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $afb237382692687d$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $afb237382692687d$var$cloneObject(updatedValues);
        const isEmptyResetValues = $afb237382692687d$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($afb237382692687d$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$afb237382692687d$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $afb237382692687d$export$adaa4cf7ef1b65be(values, fieldName, $afb237382692687d$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $afb237382692687d$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($afb237382692687d$var$isWeb && $afb237382692687d$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($afb237382692687d$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $afb237382692687d$var$cloneObject(_defaultValues) : {} : $afb237382692687d$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$afb237382692687d$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $afb237382692687d$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($afb237382692687d$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$afb237382692687d$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $afb237382692687d$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $afb237382692687d$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$afb237382692687d$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $afb237382692687d$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($afb237382692687d$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (props.values && !$afb237382692687d$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (_formControl.current) _formControl.current.watch = _formControl.current.watch.bind({});
    }, [
        formState
    ]);
    _formControl.current.formState = $afb237382692687d$var$getProxyFormState(formState, control);
    return _formControl.current;
}


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $4e50f7ec0625ce58$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $bd8175273c79c979$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4e50f7ec0625ce58$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $4d6e350a05862563$var$objectConstructor = {}.constructor;
function $4d6e350a05862563$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $4d6e350a05862563$var$objectConstructor;
}


function $5b2a4ba64c315cbc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b2a4ba64c315cbc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b2a4ba64c315cbc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b2a4ba64c315cbc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b2a4ba64c315cbc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b2a4ba64c315cbc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b2a4ba64c315cbc$var$_slicedToArray(arr, i) {
    return $5b2a4ba64c315cbc$var$_arrayWithHoles(arr) || $5b2a4ba64c315cbc$var$_iterableToArrayLimit(arr, i) || $5b2a4ba64c315cbc$var$_unsupportedIterableToArray(arr, i) || $5b2a4ba64c315cbc$var$_nonIterableRest();
}
function $5b2a4ba64c315cbc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b2a4ba64c315cbc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5b2a4ba64c315cbc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5b2a4ba64c315cbc$var$_arrayLikeToArray(o, minLen);
}
function $5b2a4ba64c315cbc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5b2a4ba64c315cbc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5b2a4ba64c315cbc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5b2a4ba64c315cbc$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $5b2a4ba64c315cbc$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $5b2a4ba64c315cbc$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $4d6e350a05862563$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $bb091544218c2422$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $bb091544218c2422$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $bb091544218c2422$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $bb091544218c2422$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $bb091544218c2422$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $bb091544218c2422$var$SLASHES = "\uFF0F/";
var $bb091544218c2422$var$DOTS = "\uFF0E.";
var $bb091544218c2422$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $bb091544218c2422$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $bb091544218c2422$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $bb091544218c2422$export$7f01587e28f9194 = "".concat($bb091544218c2422$var$DASHES).concat($bb091544218c2422$var$SLASHES).concat($bb091544218c2422$var$DOTS).concat($bb091544218c2422$export$20542845033f576e).concat($bb091544218c2422$var$BRACKETS).concat($bb091544218c2422$var$TILDES);
var $bb091544218c2422$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $d3d926b62f621051$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d3d926b62f621051$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d3d926b62f621051$var$_typeof(obj);
}
function $d3d926b62f621051$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d3d926b62f621051$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d3d926b62f621051$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d3d926b62f621051$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d3d926b62f621051$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d3d926b62f621051$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d3d926b62f621051$var$_setPrototypeOf(subClass, superClass);
}
function $d3d926b62f621051$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d3d926b62f621051$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d3d926b62f621051$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d3d926b62f621051$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d3d926b62f621051$var$_possibleConstructorReturn(this, result);
    };
}
function $d3d926b62f621051$var$_possibleConstructorReturn(self, call) {
    if (call && ($d3d926b62f621051$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d3d926b62f621051$var$_assertThisInitialized(self);
}
function $d3d926b62f621051$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d3d926b62f621051$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $d3d926b62f621051$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d3d926b62f621051$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $d3d926b62f621051$var$_construct(Class, arguments, $d3d926b62f621051$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $d3d926b62f621051$var$_setPrototypeOf(Wrapper, Class);
    };
    return $d3d926b62f621051$var$_wrapNativeSuper(Class);
}
function $d3d926b62f621051$var$_construct(Parent, args, Class) {
    if ($d3d926b62f621051$var$_isNativeReflectConstruct()) $d3d926b62f621051$var$_construct = Reflect.construct;
    else $d3d926b62f621051$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $d3d926b62f621051$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $d3d926b62f621051$var$_construct.apply(null, arguments);
}
function $d3d926b62f621051$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d3d926b62f621051$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $d3d926b62f621051$var$_setPrototypeOf(o, p) {
    $d3d926b62f621051$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d3d926b62f621051$var$_setPrototypeOf(o, p);
}
function $d3d926b62f621051$var$_getPrototypeOf(o) {
    $d3d926b62f621051$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d3d926b62f621051$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $d3d926b62f621051$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $d3d926b62f621051$var$_inherits(ParseError, _Error);
    var _super = $d3d926b62f621051$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $d3d926b62f621051$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($d3d926b62f621051$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $d3d926b62f621051$var$_createClass(ParseError);
}(/*#__PURE__*/ $d3d926b62f621051$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $13ffcff4e5ead5fe$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $e6fbb5d84511f017$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e6fbb5d84511f017$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e6fbb5d84511f017$var$_typeof(obj);
}
function $e6fbb5d84511f017$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6fbb5d84511f017$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e6fbb5d84511f017$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e6fbb5d84511f017$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e6fbb5d84511f017$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $e6fbb5d84511f017$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $e6fbb5d84511f017$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $e6fbb5d84511f017$var$V4 = "1.7.35";
var $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX = " ext. ";
var $e6fbb5d84511f017$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $e6fbb5d84511f017$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Metadata);
        $e6fbb5d84511f017$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $e6fbb5d84511f017$var$setVersion.call(this, metadata);
    }
    $e6fbb5d84511f017$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $e6fbb5d84511f017$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $e6fbb5d84511f017$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $e6fbb5d84511f017$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $e6fbb5d84511f017$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $e6fbb5d84511f017$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $e6fbb5d84511f017$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $e6fbb5d84511f017$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $e6fbb5d84511f017$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $e6fbb5d84511f017$var$getType(this.types(), _type2)) return new $e6fbb5d84511f017$var$Type($e6fbb5d84511f017$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $e6fbb5d84511f017$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $e6fbb5d84511f017$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$e6fbb5d84511f017$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $e6fbb5d84511f017$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $e6fbb5d84511f017$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $e6fbb5d84511f017$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $e6fbb5d84511f017$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $e6fbb5d84511f017$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata) || !(0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $e6fbb5d84511f017$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $e6fbb5d84511f017$var$typeOf = function typeOf(_) {
    return $e6fbb5d84511f017$var$_typeof(_);
};
function $e6fbb5d84511f017$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $e6fbb5d84511f017$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
}
function $e6fbb5d84511f017$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $e6fbb5d84511f017$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $e6fbb5d84511f017$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $e6fbb5d84511f017$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $13ffcff4e5ead5fe$export$2e2bcd8739ae039)(version, $e6fbb5d84511f017$var$V3) === -1) this.v2 = true;
        else if ((0, $13ffcff4e5ead5fe$export$2e2bcd8739ae039)(version, $e6fbb5d84511f017$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $58e1772fb891efdb$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $58e1772fb891efdb$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $bb091544218c2422$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $58e1772fb891efdb$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $58e1772fb891efdb$var$RFC3966_EXTN_PREFIX + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $d22af7acfc2f0108$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]{" + (0, $bb091544218c2422$export$cd8355bcbe13154) + "}"; //
var $d22af7acfc2f0108$export$a77dd7471651eee = "[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + "]*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + (0, $bb091544218c2422$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + "]*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $d22af7acfc2f0108$export$a2d12a04749c087d = $d22af7acfc2f0108$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $58e1772fb891efdb$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $d22af7acfc2f0108$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $d22af7acfc2f0108$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $d22af7acfc2f0108$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $bb091544218c2422$export$cd8355bcbe13154) && $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $d22af7acfc2f0108$export$4c3f76c95c05197c(number) {
    return $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $f65265fe1e6db889$var$EXTN_PATTERN = new RegExp("(?:" + (0, $58e1772fb891efdb$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $f65265fe1e6db889$export$2e2bcd8739ae039(number) {
    var start = number.search($f65265fe1e6db889$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($f65265fe1e6db889$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $f88cd79102f734e2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f88cd79102f734e2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f88cd79102f734e2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f88cd79102f734e2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f88cd79102f734e2$var$_arrayLikeToArray(o, minLen);
}
function $f88cd79102f734e2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f88cd79102f734e2$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $f88cd79102f734e2$export$1d16fddea1437169(character) {
    return $f88cd79102f734e2$export$2848f3d68c08fe69[character];
}
function $f88cd79102f734e2$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $f88cd79102f734e2$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $f88cd79102f734e2$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $af1822d55479411a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $af1822d55479411a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af1822d55479411a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af1822d55479411a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af1822d55479411a$var$_arrayLikeToArray(o, minLen);
}
function $af1822d55479411a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af1822d55479411a$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $af1822d55479411a$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $af1822d55479411a$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $af1822d55479411a$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $f88cd79102f734e2$export$1d16fddea1437169)(character);
}




function $4ce6c7f0c8a3e783$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4ce6c7f0c8a3e783$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4ce6c7f0c8a3e783$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4ce6c7f0c8a3e783$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4ce6c7f0c8a3e783$var$_arrayLikeToArray(o, minLen);
}
function $4ce6c7f0c8a3e783$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4ce6c7f0c8a3e783$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $4ce6c7f0c8a3e783$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $a3a086b198e80566$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $4ce6c7f0c8a3e783$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $a8f2dd648e97fe5b$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $a8f2dd648e97fe5b$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $a8f2dd648e97fe5b$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $13401f55428d37e4$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $28c8a560eb0c7641$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $28c8a560eb0c7641$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $28c8a560eb0c7641$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $28c8a560eb0c7641$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $28c8a560eb0c7641$var$_arrayLikeToArray(o, minLen);
}
function $28c8a560eb0c7641$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $28c8a560eb0c7641$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $28c8a560eb0c7641$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $28c8a560eb0c7641$var$_createForOfIteratorHelperLoose($28c8a560eb0c7641$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $49e490fc864cb6d6$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $28c8a560eb0c7641$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $52850ae2cabd2045$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $52850ae2cabd2045$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $52850ae2cabd2045$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $f8ea06b400de8cbe$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $bb091544218c2422$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $113045d9ca8c8c9c$export$4f32ad1c51a7a6be = /(\$\d)/;
function $113045d9ca8c8c9c$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($113045d9ca8c8c9c$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $f8ea06b400de8cbe$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $3dd63edf7677d390$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $3dd63edf7677d390$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($3dd63edf7677d390$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $fec889cd5135fee1$var$_slicedToArray(arr, i) {
    return $fec889cd5135fee1$var$_arrayWithHoles(arr) || $fec889cd5135fee1$var$_iterableToArrayLimit(arr, i) || $fec889cd5135fee1$var$_unsupportedIterableToArray(arr, i) || $fec889cd5135fee1$var$_nonIterableRest();
}
function $fec889cd5135fee1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fec889cd5135fee1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fec889cd5135fee1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fec889cd5135fee1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fec889cd5135fee1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fec889cd5135fee1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fec889cd5135fee1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fec889cd5135fee1$var$_arrayLikeToArray(o, minLen);
}
function $fec889cd5135fee1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fec889cd5135fee1$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $fec889cd5135fee1$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $fec889cd5135fee1$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $d22af7acfc2f0108$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $fec889cd5135fee1$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $3cb3e9a16ec57e92$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $3cb3e9a16ec57e92$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb3e9a16ec57e92$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cb3e9a16ec57e92$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cb3e9a16ec57e92$var$_arrayLikeToArray(o, minLen);
}
function $3cb3e9a16ec57e92$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cb3e9a16ec57e92$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3cb3e9a16ec57e92$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3cb3e9a16ec57e92$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3cb3e9a16ec57e92$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3cb3e9a16ec57e92$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3cb3e9a16ec57e92$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $3cb3e9a16ec57e92$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $3cb3e9a16ec57e92$var$_objectSpread($3cb3e9a16ec57e92$var$_objectSpread({}, $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS), options);
    else options = $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS;
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $3cb3e9a16ec57e92$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $3cb3e9a16ec57e92$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $fec889cd5135fee1$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $3cb3e9a16ec57e92$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $3cb3e9a16ec57e92$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $3cb3e9a16ec57e92$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $3cb3e9a16ec57e92$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $113045d9ca8c8c9c$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $3cb3e9a16ec57e92$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $3cb3e9a16ec57e92$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $3cb3e9a16ec57e92$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $3cb3e9a16ec57e92$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $3dd63edf7677d390$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $a1f8752c4f3cd32b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a1f8752c4f3cd32b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a1f8752c4f3cd32b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a1f8752c4f3cd32b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a1f8752c4f3cd32b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a1f8752c4f3cd32b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a1f8752c4f3cd32b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a1f8752c4f3cd32b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a1f8752c4f3cd32b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a1f8752c4f3cd32b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a1f8752c4f3cd32b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a1f8752c4f3cd32b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $a1f8752c4f3cd32b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $a1f8752c4f3cd32b$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $a1f8752c4f3cd32b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $a1f8752c4f3cd32b$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $52850ae2cabd2045$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $a8f2dd648e97fe5b$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $49e490fc864cb6d6$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $28c8a560eb0c7641$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $3cb3e9a16ec57e92$export$2e2bcd8739ae039)(this, _format, options ? $a1f8752c4f3cd32b$var$_objectSpread($a1f8752c4f3cd32b$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $a1f8752c4f3cd32b$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $a1f8752c4f3cd32b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($a1f8752c4f3cd32b$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($a1f8752c4f3cd32b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $a4ed7c3839145d19$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $bb091544218c2422$export$852d1d4a47329634) + "])");
function $a4ed7c3839145d19$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($a4ed7c3839145d19$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $83f6ec74aec660d0$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $d650e373b3dd0ea7$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $83f6ec74aec660d0$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$d650e373b3dd0ea7$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$d650e373b3dd0ea7$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $d650e373b3dd0ea7$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $d650e373b3dd0ea7$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $6fdd253f41c7c10e$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $13401f55428d37e4$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $2c1edb3f7d3b8cef$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $a4ed7c3839145d19$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $6fdd253f41c7c10e$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $bb091544218c2422$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $ae7386ec57b9d14a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ae7386ec57b9d14a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ae7386ec57b9d14a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ae7386ec57b9d14a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ae7386ec57b9d14a$var$_arrayLikeToArray(o, minLen);
}
function $ae7386ec57b9d14a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ae7386ec57b9d14a$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $ae7386ec57b9d14a$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $28c8a560eb0c7641$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $b4570bb92b85ccdd$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $b4570bb92b85ccdd$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($b4570bb92b85ccdd$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $ae7386ec57b9d14a$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $46b70126e6497d26$export$1ddc7eed78155f68 = "+";
var $46b70126e6497d26$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "|" + $46b70126e6497d26$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $46b70126e6497d26$export$1ddc7eed78155f68 + $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $46b70126e6497d26$var$ALPHANUM_ = (0, $bb091544218c2422$export$852d1d4a47329634);
var $46b70126e6497d26$var$RFC3966_DOMAINLABEL_ = "[" + $46b70126e6497d26$var$ALPHANUM_ + "]+((\\-)*[" + $46b70126e6497d26$var$ALPHANUM_ + "])*";
var $46b70126e6497d26$var$VALID_ALPHA_ = "a-zA-Z";
var $46b70126e6497d26$var$RFC3966_TOPLABEL_ = "[" + $46b70126e6497d26$var$VALID_ALPHA_ + "]+((\\-)*[" + $46b70126e6497d26$var$ALPHANUM_ + "])*";
var $46b70126e6497d26$var$RFC3966_DOMAINNAME_ = "^(" + $46b70126e6497d26$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $46b70126e6497d26$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $46b70126e6497d26$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($46b70126e6497d26$var$RFC3966_DOMAINNAME_, "g");
var $46b70126e6497d26$export$70d485ce3f6de783 = "tel:";
var $46b70126e6497d26$export$f6d5879d582c3a27 = ";phone-context=";
var $46b70126e6497d26$export$9e356e12edb00a81 = ";isub=";
function $46b70126e6497d26$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($46b70126e6497d26$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $46b70126e6497d26$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $46b70126e6497d26$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $46b70126e6497d26$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $4ade84d9b7b6a594$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $46b70126e6497d26$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $46b70126e6497d26$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $46b70126e6497d26$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $46b70126e6497d26$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $46b70126e6497d26$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $46b70126e6497d26$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $46b70126e6497d26$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $ca0c84384b8b23d5$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $ca0c84384b8b23d5$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + (0, $bb091544218c2422$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $ca0c84384b8b23d5$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $bb091544218c2422$export$852d1d4a47329634) + "#" + "]+$");
var $ca0c84384b8b23d5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $ca0c84384b8b23d5$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $ca0c84384b8b23d5$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $ca0c84384b8b23d5$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $bb091544218c2422$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $bb091544218c2422$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $a1f8752c4f3cd32b$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $ca0c84384b8b23d5$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $a8f2dd648e97fe5b$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $ca0c84384b8b23d5$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $ca0c84384b8b23d5$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($ca0c84384b8b23d5$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($ca0c84384b8b23d5$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $ca0c84384b8b23d5$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $4ade84d9b7b6a594$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $ca0c84384b8b23d5$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $d22af7acfc2f0108$export$2e2bcd8739ae039)(number)) {
        if ((0, $d22af7acfc2f0108$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $f65265fe1e6db889$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $ca0c84384b8b23d5$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $ca0c84384b8b23d5$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $2c1edb3f7d3b8cef$export$2e2bcd8739ae039)((0, $af1822d55479411a$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($ca0c84384b8b23d5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)((0, $af1822d55479411a$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $b4570bb92b85ccdd$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $d61da0a7a8d3e218$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d61da0a7a8d3e218$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d61da0a7a8d3e218$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d61da0a7a8d3e218$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d61da0a7a8d3e218$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d61da0a7a8d3e218$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d61da0a7a8d3e218$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $ca0c84384b8b23d5$export$2e2bcd8739ae039)(text, $d61da0a7a8d3e218$var$_objectSpread($d61da0a7a8d3e218$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $67075222c993894d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $67075222c993894d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $67075222c993894d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $67075222c993894d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $67075222c993894d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $67075222c993894d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $67075222c993894d$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $e6fbb5d84511f017$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $67075222c993894d$var$_objectSpread($67075222c993894d$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $d61da0a7a8d3e218$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $d3d926b62f621051$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $6eaeaad4ed665394$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6eaeaad4ed665394$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6eaeaad4ed665394$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6eaeaad4ed665394$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6eaeaad4ed665394$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6eaeaad4ed665394$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6eaeaad4ed665394$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $5b2a4ba64c315cbc$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $6eaeaad4ed665394$var$_objectSpread($6eaeaad4ed665394$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $67075222c993894d$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $4b02a3aa0d676adb$export$992e2df24bec72ba() {
    return (0, $bd8175273c79c979$export$2e2bcd8739ae039)((0, $6eaeaad4ed665394$export$2e2bcd8739ae039), arguments);
}




function $75098892ab1d2130$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $5b2a4ba64c315cbc$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $d61da0a7a8d3e218$export$2e2bcd8739ae039)(text, options, metadata);
}


function $2bc546ee6dbb8ac5$export$176bb591929cc9a8() {
    return (0, $bd8175273c79c979$export$2e2bcd8739ae039)((0, $75098892ab1d2130$export$2e2bcd8739ae039), arguments);
}


var $2f526e07c519dc18$export$d3305692eb3e9a81;
var $2f526e07c519dc18$export$9a0a9c75ccef13fb;
var $2f526e07c519dc18$export$7d9f7e9c1c02b41e;
var $2f526e07c519dc18$export$dc8de070e3f64a1a;
var $2f526e07c519dc18$export$c606acb2d9bafce;
var $2f526e07c519dc18$export$5e172d3d07078e9e;
var $2f526e07c519dc18$export$55418e842cf62482;
var $2f526e07c519dc18$export$7a171f172be0782e;
"use strict";
var $985979d475adc8c1$exports = {};
$985979d475adc8c1$exports = JSON.parse('[{"code":"AD","name":"Andorra"},{"code":"AE","name":"United Arab Emirates"},{"code":"AF","name":"Afghanistan"},{"code":"AG","name":"Antigua and Barbuda"},{"code":"AI","name":"Anguilla"},{"code":"AL","name":"Albania"},{"code":"AM","name":"Armenia"},{"code":"AO","name":"Angola"},{"code":"AQ","name":"Antarctica"},{"code":"AR","name":"Argentina"},{"code":"AS","name":"American Samoa"},{"code":"AT","name":"Austria"},{"code":"AU","name":"Australia"},{"code":"AW","name":"Aruba"},{"code":"AX","name":"\xc5land Islands"},{"code":"AZ","name":"Azerbaijan"},{"code":"BA","name":"Bosnia and Herzegovina"},{"code":"BB","name":"Barbados"},{"code":"BD","name":"Bangladesh"},{"code":"BE","name":"Belgium"},{"code":"BF","name":"Burkina Faso"},{"code":"BG","name":"Bulgaria"},{"code":"BH","name":"Bahrain"},{"code":"BI","name":"Burundi"},{"code":"BJ","name":"Benin"},{"code":"BL","name":"Saint Barth\xe9lemy"},{"code":"BM","name":"Bermuda"},{"code":"BN","name":"Brunei Darussalam"},{"code":"BO","name":"Bolivia, Plurinational State of"},{"code":"BQ","name":"Bonaire, Sint Eustatius and Saba"},{"code":"BR","name":"Brazil"},{"code":"BS","name":"Bahamas"},{"code":"BT","name":"Bhutan"},{"code":"BV","name":"Bouvet Island"},{"code":"BW","name":"Botswana"},{"code":"BY","name":"Belarus"},{"code":"BZ","name":"Belize"},{"code":"CA","name":"Canada"},{"code":"CC","name":"Cocos (Keeling) Islands"},{"code":"CD","name":"Congo, Democratic Republic of the"},{"code":"CF","name":"Central African Republic"},{"code":"CG","name":"Congo"},{"code":"CH","name":"Switzerland"},{"code":"CI","name":"C\xf4te d\'Ivoire"},{"code":"CK","name":"Cook Islands"},{"code":"CL","name":"Chile"},{"code":"CM","name":"Cameroon"},{"code":"CN","name":"China"},{"code":"CO","name":"Colombia"},{"code":"CR","name":"Costa Rica"},{"code":"CU","name":"Cuba"},{"code":"CV","name":"Cabo Verde"},{"code":"CW","name":"Cura\xe7ao"},{"code":"CX","name":"Christmas Island"},{"code":"CY","name":"Cyprus"},{"code":"CZ","name":"Czechia"},{"code":"DE","name":"Germany"},{"code":"DJ","name":"Djibouti"},{"code":"DK","name":"Denmark"},{"code":"DM","name":"Dominica"},{"code":"DO","name":"Dominican Republic"},{"code":"DZ","name":"Algeria"},{"code":"EC","name":"Ecuador"},{"code":"EE","name":"Estonia"},{"code":"EG","name":"Egypt"},{"code":"EH","name":"Western Sahara"},{"code":"ER","name":"Eritrea"},{"code":"ES","name":"Spain"},{"code":"ET","name":"Ethiopia"},{"code":"FI","name":"Finland"},{"code":"FJ","name":"Fiji"},{"code":"FK","name":"Falkland Islands (Malvinas)"},{"code":"FM","name":"Micronesia, Federated States of"},{"code":"FO","name":"Faroe Islands"},{"code":"FR","name":"France"},{"code":"GA","name":"Gabon"},{"code":"GB","name":"United Kingdom of Great Britain and Northern Ireland"},{"code":"GD","name":"Grenada"},{"code":"GE","name":"Georgia"},{"code":"GF","name":"French Guiana"},{"code":"GG","name":"Guernsey"},{"code":"GH","name":"Ghana"},{"code":"GI","name":"Gibraltar"},{"code":"GL","name":"Greenland"},{"code":"GM","name":"Gambia"},{"code":"GN","name":"Guinea"},{"code":"GP","name":"Guadeloupe"},{"code":"GQ","name":"Equatorial Guinea"},{"code":"GR","name":"Greece"},{"code":"GS","name":"South Georgia and the South Sandwich Islands"},{"code":"GT","name":"Guatemala"},{"code":"GU","name":"Guam"},{"code":"GW","name":"Guinea-Bissau"},{"code":"GY","name":"Guyana"},{"code":"HK","name":"Hong Kong"},{"code":"HM","name":"Heard Island and McDonald Islands"},{"code":"HN","name":"Honduras"},{"code":"HR","name":"Croatia"},{"code":"HT","name":"Haiti"},{"code":"HU","name":"Hungary"},{"code":"ID","name":"Indonesia"},{"code":"IE","name":"Ireland"},{"code":"IL","name":"Israel"},{"code":"IM","name":"Isle of Man"},{"code":"IN","name":"India"},{"code":"IO","name":"British Indian Ocean Territory"},{"code":"IQ","name":"Iraq"},{"code":"IR","name":"Iran, Islamic Republic of"},{"code":"IS","name":"Iceland"},{"code":"IT","name":"Italy"},{"code":"JE","name":"Jersey"},{"code":"JM","name":"Jamaica"},{"code":"JO","name":"Jordan"},{"code":"JP","name":"Japan"},{"code":"KE","name":"Kenya"},{"code":"KG","name":"Kyrgyzstan"},{"code":"KH","name":"Cambodia"},{"code":"KI","name":"Kiribati"},{"code":"KM","name":"Comoros"},{"code":"KN","name":"Saint Kitts and Nevis"},{"code":"KP","name":"Korea, Democratic People\'s Republic of"},{"code":"KR","name":"Korea, Republic of"},{"code":"KW","name":"Kuwait"},{"code":"KY","name":"Cayman Islands"},{"code":"KZ","name":"Kazakhstan"},{"code":"LA","name":"Lao People\'s Democratic Republic"},{"code":"LB","name":"Lebanon"},{"code":"LC","name":"Saint Lucia"},{"code":"LI","name":"Liechtenstein"},{"code":"LK","name":"Sri Lanka"},{"code":"LR","name":"Liberia"},{"code":"LS","name":"Lesotho"},{"code":"LT","name":"Lithuania"},{"code":"LU","name":"Luxembourg"},{"code":"LV","name":"Latvia"},{"code":"LY","name":"Libya"},{"code":"MA","name":"Morocco"},{"code":"MC","name":"Monaco"},{"code":"MD","name":"Moldova, Republic of"},{"code":"ME","name":"Montenegro"},{"code":"MF","name":"Saint Martin, (French part)"},{"code":"MG","name":"Madagascar"},{"code":"MH","name":"Marshall Islands"},{"code":"MK","name":"North Macedonia"},{"code":"ML","name":"Mali"},{"code":"MM","name":"Myanmar"},{"code":"MN","name":"Mongolia"},{"code":"MO","name":"Macao"},{"code":"MP","name":"Northern Mariana Islands"},{"code":"MQ","name":"Martinique"},{"code":"MR","name":"Mauritania"},{"code":"MS","name":"Montserrat"},{"code":"MT","name":"Malta"},{"code":"MU","name":"Mauritius"},{"code":"MV","name":"Maldives"},{"code":"MW","name":"Malawi"},{"code":"MX","name":"Mexico"},{"code":"MY","name":"Malaysia"},{"code":"MZ","name":"Mozambique"},{"code":"NA","name":"Namibia"},{"code":"NC","name":"New Caledonia"},{"code":"NE","name":"Niger"},{"code":"NF","name":"Norfolk Island"},{"code":"NG","name":"Nigeria"},{"code":"NI","name":"Nicaragua"},{"code":"NL","name":"Netherlands"},{"code":"NO","name":"Norway"},{"code":"NP","name":"Nepal"},{"code":"NR","name":"Nauru"},{"code":"NU","name":"Niue"},{"code":"NZ","name":"New Zealand"},{"code":"OM","name":"Oman"},{"code":"PA","name":"Panama"},{"code":"PE","name":"Peru"},{"code":"PF","name":"French Polynesia"},{"code":"PG","name":"Papua New Guinea"},{"code":"PH","name":"Philippines"},{"code":"PK","name":"Pakistan"},{"code":"PL","name":"Poland"},{"code":"PM","name":"Saint Pierre and Miquelon"},{"code":"PN","name":"Pitcairn"},{"code":"PR","name":"Puerto Rico"},{"code":"PS","name":"Palestine, State of"},{"code":"PT","name":"Portugal"},{"code":"PW","name":"Palau"},{"code":"PY","name":"Paraguay"},{"code":"QA","name":"Qatar"},{"code":"RE","name":"R\xe9union"},{"code":"RO","name":"Romania"},{"code":"RS","name":"Serbia"},{"code":"RU","name":"Russian Federation"},{"code":"RW","name":"Rwanda"},{"code":"SA","name":"Saudi Arabia"},{"code":"SB","name":"Solomon Islands"},{"code":"SC","name":"Seychelles"},{"code":"SD","name":"Sudan"},{"code":"SE","name":"Sweden"},{"code":"SG","name":"Singapore"},{"code":"SH","name":"Saint Helena, Ascension and Tristan da Cunha"},{"code":"SI","name":"Slovenia"},{"code":"SJ","name":"Svalbard and Jan Mayen"},{"code":"SK","name":"Slovakia"},{"code":"SL","name":"Sierra Leone"},{"code":"SM","name":"San Marino"},{"code":"SN","name":"Senegal"},{"code":"SO","name":"Somalia"},{"code":"SR","name":"Suriname"},{"code":"SS","name":"South Sudan"},{"code":"ST","name":"Sao Tome and Principe"},{"code":"SV","name":"El Salvador"},{"code":"SX","name":"Sint Maarten, (Dutch part)"},{"code":"SY","name":"Syrian Arab Republic"},{"code":"SZ","name":"Eswatini"},{"code":"TC","name":"Turks and Caicos Islands"},{"code":"TD","name":"Chad"},{"code":"TF","name":"French Southern Territories"},{"code":"TG","name":"Togo"},{"code":"TH","name":"Thailand"},{"code":"TJ","name":"Tajikistan"},{"code":"TK","name":"Tokelau"},{"code":"TL","name":"Timor-Leste"},{"code":"TM","name":"Turkmenistan"},{"code":"TN","name":"Tunisia"},{"code":"TO","name":"Tonga"},{"code":"TR","name":"T\xfcrkiye"},{"code":"TT","name":"Trinidad and Tobago"},{"code":"TV","name":"Tuvalu"},{"code":"TW","name":"Taiwan, Province of China"},{"code":"TZ","name":"Tanzania, United Republic of"},{"code":"UA","name":"Ukraine"},{"code":"UG","name":"Uganda"},{"code":"UM","name":"United States Minor Outlying Islands"},{"code":"US","name":"United States of America"},{"code":"UY","name":"Uruguay"},{"code":"UZ","name":"Uzbekistan"},{"code":"VA","name":"Holy See"},{"code":"VC","name":"Saint Vincent and the Grenadines"},{"code":"VE","name":"Venezuela, Bolivarian Republic of"},{"code":"VG","name":"Virgin Islands, British"},{"code":"VI","name":"Virgin Islands, U.S."},{"code":"VN","name":"Viet Nam"},{"code":"VU","name":"Vanuatu"},{"code":"WF","name":"Wallis and Futuna"},{"code":"WS","name":"Samoa"},{"code":"YE","name":"Yemen"},{"code":"YT","name":"Mayotte"},{"code":"ZA","name":"South Africa"},{"code":"ZM","name":"Zambia"},{"code":"ZW","name":"Zimbabwe"}]');


/** Precompute name and code lookups. */ var $2f526e07c519dc18$var$nameMap = {};
var $2f526e07c519dc18$var$codeMap = {};
$985979d475adc8c1$exports.forEach($2f526e07c519dc18$var$mapCodeAndName);
function $2f526e07c519dc18$var$mapCodeAndName(country) {
    $2f526e07c519dc18$var$nameMap[country.name.toLowerCase()] = country.code;
    $2f526e07c519dc18$var$codeMap[country.code.toLowerCase()] = country.name;
}
$2f526e07c519dc18$export$d3305692eb3e9a81 = function overwrite(countries) {
    if (!countries || !countries.length) return;
    countries.forEach(function(country) {
        var foundIndex = $985979d475adc8c1$exports.findIndex(function(item) {
            return item.code === country.code;
        });
        $985979d475adc8c1$exports[foundIndex] = country;
        $2f526e07c519dc18$var$mapCodeAndName(country);
    });
};
$2f526e07c519dc18$export$9a0a9c75ccef13fb = function getCode(name) {
    return $2f526e07c519dc18$var$nameMap[name.toLowerCase()];
};
$2f526e07c519dc18$export$7d9f7e9c1c02b41e = function getName(code) {
    return $2f526e07c519dc18$var$codeMap[code.toLowerCase()];
};
$2f526e07c519dc18$export$dc8de070e3f64a1a = function getNames() {
    return $985979d475adc8c1$exports.map(function(country) {
        return country.name;
    });
};
$2f526e07c519dc18$export$c606acb2d9bafce = function getCodes() {
    return $985979d475adc8c1$exports.map(function(country) {
        return country.code;
    });
};
$2f526e07c519dc18$export$5e172d3d07078e9e = function getCodeList() {
    return $2f526e07c519dc18$var$codeMap;
};
$2f526e07c519dc18$export$55418e842cf62482 = function getNameList() {
    return $2f526e07c519dc18$var$nameMap;
};
$2f526e07c519dc18$export$7a171f172be0782e = function getData() {
    return $985979d475adc8c1$exports;
};



var $eZVvM = parcelRequire("eZVvM");

var $30Kai = parcelRequire("30Kai");

var $bq3DV = parcelRequire("bq3DV");

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
// CLASS
class $6a981849e8378921$export$d3c1860ee66f291a extends (0, $4QcTI.Subscribable) {
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $g3yHX.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $30Kai.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $bq3DV.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
}


var $bq3DV = parcelRequire("bq3DV");
var $g3yHX = parcelRequire("g3yHX");

var $l7YCt = parcelRequire("l7YCt");

var $gdPnm = parcelRequire("gdPnm");

var $gCLDX = parcelRequire("gCLDX");
"use client";
function $084aaf38c3338203$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $g3yHX.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, $gdPnm.useQueryClient)({
        context: options.context
    });
    const [observer] = $eZVvM.useState(()=>new (0, $6a981849e8378921$export$d3c1860ee66f291a)(queryClient, options));
    $eZVvM.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $l7YCt.useSyncExternalStore)($eZVvM.useCallback((onStoreChange)=>observer.subscribe((0, $bq3DV.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $eZVvM.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($084aaf38c3338203$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $gCLDX.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $084aaf38c3338203$var$noop() {}


var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");

var $72bd4d366489160d$exports = {};

var $l4rgt = parcelRequire("l4rgt");

var $9PmZ6 = parcelRequire("9PmZ6");
var $8419c3e14ec60841$exports = {};

var $erFZL = parcelRequire("erFZL");

var $gyLmc = parcelRequire("gyLmc");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $8419c3e14ec60841$var$baseMap(collection, iteratee) {
    var index = -1, result = $gyLmc(collection) ? Array(collection.length) : [];
    $erFZL(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$8419c3e14ec60841$exports = $8419c3e14ec60841$var$baseMap;



var $3hHqY = parcelRequire("3hHqY");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $72bd4d366489160d$var$map(collection, iteratee) {
    var func = $3hHqY(collection) ? $l4rgt : $8419c3e14ec60841$exports;
    return func(collection, $9PmZ6(iteratee, 3));
}
$72bd4d366489160d$exports = $72bd4d366489160d$var$map;


var $8fab9d099c4589dd$exports = {};

var $akGgj = parcelRequire("akGgj");

var $9PmZ6 = parcelRequire("9PmZ6");
var $9752f1763fe4f119$exports = {};

var $erFZL = parcelRequire("erFZL");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9752f1763fe4f119$var$baseSome(collection, predicate) {
    var result;
    $erFZL(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$9752f1763fe4f119$exports = $9752f1763fe4f119$var$baseSome;



var $3hHqY = parcelRequire("3hHqY");

var $2bHYF = parcelRequire("2bHYF");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $8fab9d099c4589dd$var$some(collection, predicate, guard) {
    var func = $3hHqY(collection) ? $akGgj : $9752f1763fe4f119$exports;
    if (guard && $2bHYF(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9PmZ6(predicate, 3));
}
$8fab9d099c4589dd$exports = $8fab9d099c4589dd$var$some;





var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");



var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $9HTTf = parcelRequire("9HTTf");

var $hWP8m = parcelRequire("hWP8m");


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $9u6aw = parcelRequire("9u6aw");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $32e460333a0042c0$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $32e460333a0042c0$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $32e460333a0042c0$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $32e460333a0042c0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $32e460333a0042c0$var$TextareaAutosize = /*#__PURE__*/ $eZVvM.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $7Z8DW.default)(props, $32e460333a0042c0$var$_excluded);
    const { current: isControlled } = $eZVvM.useRef(value != null);
    const inputRef = $eZVvM.useRef(null);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $eZVvM.useRef(null);
    const shadowRef = $eZVvM.useRef(null);
    const calculateTextareaStyles = $eZVvM.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $32e460333a0042c0$var$getStyleValue(computedStyle.paddingBottom) + $32e460333a0042c0$var$getStyleValue(computedStyle.paddingTop);
        const border = $32e460333a0042c0$var$getStyleValue(computedStyle.borderBottomWidth) + $32e460333a0042c0$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $eZVvM.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($32e460333a0042c0$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $cdd9f8889be8e555$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)("textarea", (0, $65o8X.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $3pI8R.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $65o8X.default)({}, $32e460333a0042c0$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $32e460333a0042c0$export$2e2bcd8739ae039 = $32e460333a0042c0$var$TextareaAutosize;


function $444c1dee43ac56ee$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $8ff433bd507b8393$var$FormControlContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
var $8ff433bd507b8393$export$2e2bcd8739ae039 = $8ff433bd507b8393$var$FormControlContext;



var $eZVvM = parcelRequire("eZVvM");

"use client";
function $25d70ea28a10b810$export$2e2bcd8739ae039() {
    return $eZVvM.useContext((0, $8ff433bd507b8393$export$2e2bcd8739ae039));
}



var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $iDCHz = parcelRequire("iDCHz");


"use client";
var $56e26d0f2548c6fe$export$2e2bcd8739ae039 = (0, $b625618202e2da7b$export$2e2bcd8739ae039);



var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");

parcelRequire("eZVvM");


var $jDDa9 = parcelRequire("jDDa9");


var $3pI8R = parcelRequire("3pI8R");
"use client";
function $7c8bdbbc0ef0e3aa$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $123cc06973765126$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $jDDa9.default), {
        styles: globalStyles
    });
}
var $7c8bdbbc0ef0e3aa$export$2e2bcd8739ae039 = $7c8bdbbc0ef0e3aa$var$GlobalStyles;



var $2Uans = parcelRequire("2Uans");

var $hDdqv = parcelRequire("hDdqv");

var $3pI8R = parcelRequire("3pI8R");
"use client";
function $d11e3b02afa92310$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7c8bdbbc0ef0e3aa$export$2e2bcd8739ae039), (0, $65o8X.default)({}, props, {
        defaultTheme: (0, $2Uans.default),
        themeId: (0, $hDdqv.default)
    }));
}
var $d11e3b02afa92310$export$2e2bcd8739ae039 = $d11e3b02afa92310$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $2a36f652fefb4086$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $2a36f652fefb4086$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($2a36f652fefb4086$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $2a36f652fefb4086$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $2a36f652fefb4086$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $10069671872fbce9$export$ef57d5c8ca2278f6(slot) {
    return (0, $8QgsE.default)("MuiInputBase", slot);
}
const $10069671872fbce9$var$inputBaseClasses = (0, $dvQev.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $10069671872fbce9$export$2e2bcd8739ae039 = $10069671872fbce9$var$inputBaseClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $2ae777ca6f95078f$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $2ae777ca6f95078f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $iDCHz.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $2ae777ca6f95078f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $2ae777ca6f95078f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $iDCHz.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $iDCHz.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $10069671872fbce9$export$ef57d5c8ca2278f6), classes);
};
const $2ae777ca6f95078f$export$298a043133d72a38 = (0, $e8m2I.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $2ae777ca6f95078f$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $10069671872fbce9$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $2ae777ca6f95078f$export$a1ad29c901026019 = (0, $e8m2I.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $2ae777ca6f95078f$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $65o8X.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $65o8X.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $10069671872fbce9$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $10069671872fbce9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $2ae777ca6f95078f$var$inputGlobalStyles = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d11e3b02afa92310$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $2ae777ca6f95078f$var$InputBase = /*#__PURE__*/ $eZVvM.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $7Z8DW.default)(props, $2ae777ca6f95078f$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $eZVvM.useRef(value != null);
    const inputRef = $eZVvM.useRef();
    const handleInputRefWarning = $eZVvM.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $eZVvM.useState(false);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $eZVvM.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $eZVvM.useCallback((obj)=>{
        if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9u6aw.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $eZVvM.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $65o8X.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $65o8X.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $32e460333a0042c0$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $eZVvM.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $2ae777ca6f95078f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $2ae777ca6f95078f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $2ae777ca6f95078f$export$a1ad29c901026019;
    inputProps = (0, $65o8X.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $2ae777ca6f95078f$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $3pI8R.jsxs)(Root, (0, $65o8X.default)({}, rootProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $65o8X.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $fmwLG.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $3pI8R.jsx)(Input, (0, $65o8X.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $65o8X.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $fmwLG.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $65o8X.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $2ae777ca6f95078f$export$2e2bcd8739ae039 = $2ae777ca6f95078f$var$InputBase;



var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");

var $65o8X = parcelRequire("65o8X");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");

function $6ed1fa5c66b8a143$export$cdb270390122322b(slot) {
    return (0, $8QgsE.default)("MuiInput", slot);
}
const $6ed1fa5c66b8a143$var$inputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $dvQev.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $6ed1fa5c66b8a143$export$2e2bcd8739ae039 = $6ed1fa5c66b8a143$var$inputClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $746043b2897ffa7d$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $746043b2897ffa7d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $6ed1fa5c66b8a143$export$cdb270390122322b), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $746043b2897ffa7d$var$InputRoot = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $2ae777ca6f95078f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $65o8X.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).disabled}, .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $746043b2897ffa7d$var$InputInput = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})({});
const $746043b2897ffa7d$var$Input = /*#__PURE__*/ $eZVvM.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $746043b2897ffa7d$var$_excluded);
    const classes = $746043b2897ffa7d$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hWP8m.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $746043b2897ffa7d$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $746043b2897ffa7d$var$InputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$746043b2897ffa7d$var$Input.muiName = "Input";
var $746043b2897ffa7d$export$2e2bcd8739ae039 = $746043b2897ffa7d$var$Input;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $hWP8m = parcelRequire("hWP8m");



var $9HTTf = parcelRequire("9HTTf");


var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");

var $65o8X = parcelRequire("65o8X");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");

function $d04b109876522ebe$export$3331e419f1a48437(slot) {
    return (0, $8QgsE.default)("MuiFilledInput", slot);
}
const $d04b109876522ebe$var$filledInputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $dvQev.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $d04b109876522ebe$export$2e2bcd8739ae039 = $d04b109876522ebe$var$filledInputClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4f39814fc95716c5$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $4f39814fc95716c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $d04b109876522ebe$export$3331e419f1a48437), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $4f39814fc95716c5$var$FilledInputRoot = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $2ae777ca6f95078f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $65o8X.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}, .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $4f39814fc95716c5$var$FilledInputInput = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $4f39814fc95716c5$var$FilledInput = /*#__PURE__*/ $eZVvM.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $4f39814fc95716c5$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $4f39814fc95716c5$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hWP8m.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $4f39814fc95716c5$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $4f39814fc95716c5$var$FilledInputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$4f39814fc95716c5$var$FilledInput.muiName = "Input";
var $4f39814fc95716c5$export$2e2bcd8739ae039 = $4f39814fc95716c5$var$FilledInput;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $9HTTf = parcelRequire("9HTTf");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");


var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $3pI8R = parcelRequire("3pI8R");
"use client";
var $c78151445c4daad2$var$_span;
const $c78151445c4daad2$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $c78151445c4daad2$var$NotchedOutlineRoot = (0, $e8m2I.default)("fieldset", {
    shouldForwardProp: (0, $gW9L2.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $c78151445c4daad2$var$NotchedOutlineLegend = (0, $e8m2I.default)("legend", {
    shouldForwardProp: (0, $gW9L2.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $65o8X.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $c78151445c4daad2$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $7Z8DW.default)(props, $c78151445c4daad2$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $65o8X.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c78151445c4daad2$var$NotchedOutlineRoot, (0, $65o8X.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($c78151445c4daad2$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                children: label
            }) : $c78151445c4daad2$var$_span || ($c78151445c4daad2$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $65o8X = parcelRequire("65o8X");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");

function $02e8718168a8e608$export$89922944c7227687(slot) {
    return (0, $8QgsE.default)("MuiOutlinedInput", slot);
}
const $02e8718168a8e608$var$outlinedInputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $dvQev.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $02e8718168a8e608$export$2e2bcd8739ae039 = $02e8718168a8e608$var$outlinedInputClasses;




var $8C83T = parcelRequire("8C83T");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $361c4111f560ec07$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $361c4111f560ec07$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $02e8718168a8e608$export$89922944c7227687), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $361c4111f560ec07$var$OutlinedInputRoot = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $2ae777ca6f95078f$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $65o8X.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).focused} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).error} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).disabled} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $361c4111f560ec07$var$NotchedOutlineRoot = (0, $e8m2I.default)((0, $c78151445c4daad2$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $361c4111f560ec07$var$OutlinedInputInput = (0, $e8m2I.default)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $361c4111f560ec07$var$OutlinedInput = /*#__PURE__*/ $eZVvM.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $361c4111f560ec07$var$_excluded);
    const classes = $361c4111f560ec07$var$useUtilityClasses(props);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $361c4111f560ec07$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $361c4111f560ec07$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $3pI8R.jsx)($361c4111f560ec07$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $65o8X.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$361c4111f560ec07$var$OutlinedInput.muiName = "Input";
var $361c4111f560ec07$export$2e2bcd8739ae039 = $361c4111f560ec07$var$OutlinedInput;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $9HTTf = parcelRequire("9HTTf");

var $fmwLG = parcelRequire("fmwLG");



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");



var $iDCHz = parcelRequire("iDCHz");

var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $df9a99952c00e9b4$export$f7d501e40371cd17(slot) {
    return (0, $8QgsE.default)("MuiFormLabel", slot);
}
const $df9a99952c00e9b4$var$formLabelClasses = (0, $dvQev.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $df9a99952c00e9b4$export$2e2bcd8739ae039 = $df9a99952c00e9b4$var$formLabelClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $baec0adc5cc19b6f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $baec0adc5cc19b6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $iDCHz.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $df9a99952c00e9b4$export$f7d501e40371cd17), classes);
};
const $baec0adc5cc19b6f$export$aa5bc7f8a4705b27 = (0, $e8m2I.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $65o8X.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $baec0adc5cc19b6f$var$AsteriskComponent = (0, $e8m2I.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $baec0adc5cc19b6f$var$FormLabel = /*#__PURE__*/ $eZVvM.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $7Z8DW.default)(props, $baec0adc5cc19b6f$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $baec0adc5cc19b6f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($baec0adc5cc19b6f$export$aa5bc7f8a4705b27, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $3pI8R.jsxs)($baec0adc5cc19b6f$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $baec0adc5cc19b6f$export$2e2bcd8739ae039 = $baec0adc5cc19b6f$var$FormLabel;



var $8C83T = parcelRequire("8C83T");

var $iDCHz = parcelRequire("iDCHz");

var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $e5dfedf4cc54a909$export$c1c4b4545ad2ea5f(slot) {
    return (0, $8QgsE.default)("MuiInputLabel", slot);
}
const $e5dfedf4cc54a909$var$inputLabelClasses = (0, $dvQev.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $e5dfedf4cc54a909$export$2e2bcd8739ae039 = $e5dfedf4cc54a909$var$inputLabelClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $a75413bd2bd509d5$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $a75413bd2bd509d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $iDCHz.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $e5dfedf4cc54a909$export$c1c4b4545ad2ea5f), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $a75413bd2bd509d5$var$InputLabelRoot = (0, $e8m2I.default)((0, $baec0adc5cc19b6f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $65o8X.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $65o8X.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $65o8X.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $a75413bd2bd509d5$var$InputLabel = /*#__PURE__*/ $eZVvM.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $7Z8DW.default)(props, $a75413bd2bd509d5$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $a75413bd2bd509d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($a75413bd2bd509d5$var$InputLabelRoot, (0, $65o8X.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fmwLG.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $a75413bd2bd509d5$export$2e2bcd8739ae039 = $a75413bd2bd509d5$var$InputLabel;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");


var $iDCHz = parcelRequire("iDCHz");

var $eZVvM = parcelRequire("eZVvM");
function $ed5347ce345f45b7$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $eZVvM.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $3d74c99d23f8a3b2$export$2e2bcd8739ae039 = (0, $ed5347ce345f45b7$export$2e2bcd8739ae039);




var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $573390ea71e0f4b6$export$149c8b8bab2289d1(slot) {
    return (0, $8QgsE.default)("MuiFormControl", slot);
}
const $573390ea71e0f4b6$var$formControlClasses = (0, $dvQev.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $573390ea71e0f4b6$export$2e2bcd8739ae039 = $573390ea71e0f4b6$var$formControlClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $0fad4ddd6eb88026$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $0fad4ddd6eb88026$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $iDCHz.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $573390ea71e0f4b6$export$149c8b8bab2289d1), classes);
};
const $0fad4ddd6eb88026$var$FormControlRoot = (0, $e8m2I.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $65o8X.default)({}, styles.root, styles[`margin${(0, $iDCHz.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $0fad4ddd6eb88026$var$FormControl = /*#__PURE__*/ $eZVvM.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $0fad4ddd6eb88026$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $0fad4ddd6eb88026$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $eZVvM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $eZVvM.Children.forEach(children, (child)=>{
            if (!(0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $2a36f652fefb4086$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $eZVvM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $eZVvM.Children.forEach(children, (child)=>{
            if (!(0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)(child.props, true) || (0, $2a36f652fefb4086$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $eZVvM.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $eZVvM.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($0fad4ddd6eb88026$var$FormControlRoot, (0, $65o8X.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fmwLG.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $0fad4ddd6eb88026$export$2e2bcd8739ae039 = $0fad4ddd6eb88026$var$FormControl;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");



var $e8m2I = parcelRequire("e8m2I");

var $iDCHz = parcelRequire("iDCHz");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $d93508d3cebe561c$export$a394fa61b1d583a9(slot) {
    return (0, $8QgsE.default)("MuiFormHelperText", slot);
}
const $d93508d3cebe561c$var$formHelperTextClasses = (0, $dvQev.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $d93508d3cebe561c$export$2e2bcd8739ae039 = $d93508d3cebe561c$var$formHelperTextClasses;



var $8C83T = parcelRequire("8C83T");

var $3pI8R = parcelRequire("3pI8R");
"use client";
var $3e2316ee7e27c519$var$_span;
const $3e2316ee7e27c519$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $3e2316ee7e27c519$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $iDCHz.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $d93508d3cebe561c$export$a394fa61b1d583a9), classes);
};
const $3e2316ee7e27c519$var$FormHelperTextRoot = (0, $e8m2I.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $iDCHz.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $d93508d3cebe561c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $d93508d3cebe561c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $3e2316ee7e27c519$var$FormHelperText = /*#__PURE__*/ $eZVvM.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $7Z8DW.default)(props, $3e2316ee7e27c519$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $3e2316ee7e27c519$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($3e2316ee7e27c519$var$FormHelperTextRoot, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $3e2316ee7e27c519$var$_span || ($3e2316ee7e27c519$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $3e2316ee7e27c519$export$2e2bcd8739ae039 = $3e2316ee7e27c519$var$FormHelperText;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $hWP8m = parcelRequire("hWP8m");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");



var $815e6328e9787b0a$export$2e2bcd8739ae039 = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039);



var $iDCHz = parcelRequire("iDCHz");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");




var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $4650e5b1f00f8b80$var$ListContext = /*#__PURE__*/ $eZVvM.createContext({});
var $4650e5b1f00f8b80$export$2e2bcd8739ae039 = $4650e5b1f00f8b80$var$ListContext;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $1e420068fcdd564f$export$c6bd6795ed6e3203(slot) {
    return (0, $8QgsE.default)("MuiList", slot);
}
const $1e420068fcdd564f$var$listClasses = (0, $dvQev.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $1e420068fcdd564f$export$2e2bcd8739ae039 = $1e420068fcdd564f$var$listClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b4c754b766f3049c$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $b4c754b766f3049c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $1e420068fcdd564f$export$c6bd6795ed6e3203), classes);
};
const $b4c754b766f3049c$var$ListRoot = (0, $e8m2I.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $b4c754b766f3049c$var$List = /*#__PURE__*/ $eZVvM.forwardRef(function List(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $7Z8DW.default)(props, $b4c754b766f3049c$var$_excluded);
    const context = $eZVvM.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $b4c754b766f3049c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)($b4c754b766f3049c$var$ListRoot, (0, $65o8X.default)({
            as: component,
            className: (0, $fmwLG.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $b4c754b766f3049c$export$2e2bcd8739ae039 = $b4c754b766f3049c$var$List;



var $332af7b06d6ba7e1$export$2e2bcd8739ae039 = (0, $2b883556515dfdf6$export$2e2bcd8739ae039);





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c899ace137ef326b$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $c899ace137ef326b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $c899ace137ef326b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $c899ace137ef326b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$c899ace137ef326b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $c899ace137ef326b$var$MenuList = /*#__PURE__*/ $eZVvM.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $7Z8DW.default)(props, $c899ace137ef326b$var$_excluded);
    const listRef = $eZVvM.useRef(null);
    const textCriteriaRef = $eZVvM.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $eZVvM.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $332af7b06d6ba7e1$export$2e2bcd8739ae039)((0, $815e6328e9787b0a$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $c899ace137ef326b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $c899ace137ef326b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $c899ace137ef326b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eZVvM.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $eZVvM.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $eZVvM.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $b4c754b766f3049c$export$2e2bcd8739ae039), (0, $65o8X.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $c899ace137ef326b$export$2e2bcd8739ae039 = $c899ace137ef326b$var$MenuList;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");








var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");








var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $dca460790b1f8f85$export$88f455dd56c95edb(slot) {
    return (0, $8QgsE.default)("MuiPopover", slot);
}
const $dca460790b1f8f85$var$popoverClasses = (0, $dvQev.default)("MuiPopover", [
    "root",
    "paper"
]);
var $dca460790b1f8f85$export$2e2bcd8739ae039 = $dca460790b1f8f85$var$popoverClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $a2e02f582907f016$var$_excluded = [
    "onEntering"
], $a2e02f582907f016$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $a2e02f582907f016$var$_excluded3 = [
    "slotProps"
];
function $a2e02f582907f016$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $a2e02f582907f016$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $a2e02f582907f016$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $a2e02f582907f016$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $a2e02f582907f016$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $dca460790b1f8f85$export$88f455dd56c95edb), classes);
};
const $a2e02f582907f016$export$bcce13685275fc99 = (0, $e8m2I.default)((0, $010e20fed2f5ff9a$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $a2e02f582907f016$export$821346c38a2d9390 = (0, $e8m2I.default)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $a2e02f582907f016$var$Popover = /*#__PURE__*/ $eZVvM.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $c673d3c31a06f300$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $a2e02f582907f016$var$_excluded), other = (0, $7Z8DW.default)(props, $a2e02f582907f016$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $eZVvM.useRef();
    const handlePaperRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $65o8X.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $a2e02f582907f016$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $eZVvM.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $a2e02f582907f016$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $a2e02f582907f016$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $a2e02f582907f016$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $eZVvM.useCallback((elemRect)=>{
        return {
            vertical: $a2e02f582907f016$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $a2e02f582907f016$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $eZVvM.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $a2e02f582907f016$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)($a2e02f582907f016$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $a2e02f582907f016$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $eZVvM.useState(open);
    const setPositioningStyles = $eZVvM.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $eZVvM.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $eZVvM.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $eZVvM.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $eZVvM.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $c67a96687a400a99$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $815e6328e9787b0a$export$2e2bcd8739ae039)($a2e02f582907f016$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $a2e02f582907f016$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $a2e02f582907f016$export$821346c38a2d9390;
    const paperProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $65o8X.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $65o8X.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $7Z8DW.default)(_useSlotProps, $a2e02f582907f016$var$_excluded3);
    return /*#__PURE__*/ (0, $3pI8R.jsx)(RootSlot, (0, $65o8X.default)({}, rootProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)(PaperSlot, (0, $65o8X.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $a2e02f582907f016$export$2e2bcd8739ae039 = $a2e02f582907f016$var$Popover;



var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $d77a4c1a4ae2ec6f$export$2cf86a63a84fe23d(slot) {
    return (0, $8QgsE.default)("MuiMenu", slot);
}
const $d77a4c1a4ae2ec6f$var$menuClasses = (0, $dvQev.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $d77a4c1a4ae2ec6f$export$2e2bcd8739ae039 = $d77a4c1a4ae2ec6f$var$menuClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $99e7ab0961a065f0$var$_excluded = [
    "onEntering"
], $99e7ab0961a065f0$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $99e7ab0961a065f0$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $99e7ab0961a065f0$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $99e7ab0961a065f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $d77a4c1a4ae2ec6f$export$2cf86a63a84fe23d), classes);
};
const $99e7ab0961a065f0$var$MenuRoot = (0, $e8m2I.default)((0, $a2e02f582907f016$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $99e7ab0961a065f0$export$4f7c51a5920c9f33 = (0, $e8m2I.default)((0, $a2e02f582907f016$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $99e7ab0961a065f0$var$MenuMenuList = (0, $e8m2I.default)((0, $c899ace137ef326b$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $99e7ab0961a065f0$var$Menu = /*#__PURE__*/ $eZVvM.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $99e7ab0961a065f0$var$_excluded), other = (0, $7Z8DW.default)(props, $99e7ab0961a065f0$var$_excluded2);
    const isRtl = (0, $d97d98e83b9fa62c$export$b2dd014b6c321cb)();
    const ownerState = (0, $65o8X.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $99e7ab0961a065f0$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $eZVvM.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eZVvM.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $99e7ab0961a065f0$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)($99e7ab0961a065f0$var$MenuRoot, (0, $65o8X.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $99e7ab0961a065f0$var$RTL_ORIGIN : $99e7ab0961a065f0$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $65o8X.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($99e7ab0961a065f0$var$MenuMenuList, (0, $65o8X.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $fmwLG.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $99e7ab0961a065f0$export$2e2bcd8739ae039 = $99e7ab0961a065f0$var$Menu;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");


var $9HTTf = parcelRequire("9HTTf");

var $iDCHz = parcelRequire("iDCHz");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $1c01fc5556175c1c$export$1ee13051fd9e2ab5(slot) {
    return (0, $8QgsE.default)("MuiNativeSelect", slot);
}
const $1c01fc5556175c1c$var$nativeSelectClasses = (0, $dvQev.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $1c01fc5556175c1c$export$2e2bcd8739ae039 = $1c01fc5556175c1c$var$nativeSelectClasses;



var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $708fde035a2604fb$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $708fde035a2604fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $iDCHz.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $1c01fc5556175c1c$export$1ee13051fd9e2ab5), classes);
};
const $708fde035a2604fb$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $65o8X.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $708fde035a2604fb$var$NativeSelectSelect = (0, $e8m2I.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $gW9L2.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($708fde035a2604fb$export$c1eccd1617458c87);
const $708fde035a2604fb$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $708fde035a2604fb$var$NativeSelectIcon = (0, $e8m2I.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iDCHz.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($708fde035a2604fb$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $708fde035a2604fb$var$NativeSelectInput = /*#__PURE__*/ $eZVvM.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $708fde035a2604fb$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $708fde035a2604fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($708fde035a2604fb$var$NativeSelectSelect, (0, $65o8X.default)({
                ownerState: ownerState,
                className: (0, $fmwLG.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $3pI8R.jsx)($708fde035a2604fb$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $708fde035a2604fb$export$2e2bcd8739ae039 = $708fde035a2604fb$var$NativeSelectInput;




var $e8m2I = parcelRequire("e8m2I");
var $7Ocfa = parcelRequire("7Ocfa");


var $eZVvM = parcelRequire("eZVvM");
"use client";
function $c06b8889293cbc6c$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $eZVvM.useRef(controlled !== undefined);
    const [valueState, setValue] = $eZVvM.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $eZVvM.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $5fc2b53e4d223165$export$2e2bcd8739ae039 = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039);



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $4ee8094de686c7d7$export$2c0c1ee5a3392e(slot) {
    return (0, $8QgsE.default)("MuiSelect", slot);
}
const $4ee8094de686c7d7$var$selectClasses = (0, $dvQev.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $4ee8094de686c7d7$export$2e2bcd8739ae039 = $4ee8094de686c7d7$var$selectClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $8ccecd0152d75a10$var$_span;
const $8ccecd0152d75a10$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8ccecd0152d75a10$var$SelectSelect = (0, $e8m2I.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $708fde035a2604fb$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8ccecd0152d75a10$var$SelectIcon = (0, $e8m2I.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iDCHz.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $708fde035a2604fb$export$e7a817afd12a40d0));
const $8ccecd0152d75a10$var$SelectNativeInput = (0, $e8m2I.default)("input", {
    shouldForwardProp: (prop)=>(0, $7Ocfa.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8ccecd0152d75a10$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8ccecd0152d75a10$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8ccecd0152d75a10$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $iDCHz.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $4ee8094de686c7d7$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8ccecd0152d75a10$var$SelectInput = /*#__PURE__*/ $eZVvM.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $8ccecd0152d75a10$var$_excluded);
    const [value, setValueState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $eZVvM.useRef(null);
    const displayRef = $eZVvM.useRef(null);
    const [displayNode, setDisplayNode] = $eZVvM.useState(null);
    const { current: isOpenControlled } = $eZVvM.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $eZVvM.useState();
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $eZVvM.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $eZVvM.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $eZVvM.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $eZVvM.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $eZVvM.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $eZVvM.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9u6aw.default)(2));
            selected = value.some((v)=>$8ccecd0152d75a10$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8ccecd0152d75a10$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $eZVvM.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $65o8X.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8ccecd0152d75a10$var$useUtilityClasses(ownerState);
    const paperProps = (0, $65o8X.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectSelect, (0, $65o8X.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $fmwLG.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8ccecd0152d75a10$var$isEmpty(display) ? $8ccecd0152d75a10$var$_span || ($8ccecd0152d75a10$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectNativeInput, (0, $65o8X.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3pI8R.jsx)((0, $99e7ab0961a065f0$export$2e2bcd8739ae039), (0, $65o8X.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $65o8X.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $65o8X.default)({}, MenuProps.slotProps, {
                    paper: (0, $65o8X.default)({}, paperProps, {
                        style: (0, $65o8X.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8ccecd0152d75a10$export$2e2bcd8739ae039 = $8ccecd0152d75a10$var$SelectInput;




parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a75f8309f0ea897a$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $8C83T = parcelRequire("8C83T");


var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $22932f6b5a031346$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $22932f6b5a031346$var$_excluded2 = [
    "root"
];
const $22932f6b5a031346$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $22932f6b5a031346$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $22932f6b5a031346$var$StyledInput = (0, $e8m2I.default)((0, $746043b2897ffa7d$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$StyledOutlinedInput = (0, $e8m2I.default)((0, $361c4111f560ec07$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$StyledFilledInput = (0, $e8m2I.default)((0, $4f39814fc95716c5$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$Select = /*#__PURE__*/ $eZVvM.forwardRef(function Select(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $a75f8309f0ea897a$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $7Z8DW.default)(props, $22932f6b5a031346$var$_excluded);
    const inputComponent = native ? (0, $708fde035a2604fb$export$2e2bcd8739ae039) : (0, $8ccecd0152d75a10$export$2e2bcd8739ae039);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $65o8X.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $22932f6b5a031346$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $7Z8DW.default)(classes, $22932f6b5a031346$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: /*#__PURE__*/ $eZVvM.cloneElement(InputComponent, (0, $65o8X.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $65o8X.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $65o8X.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $hWP8m.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $fmwLG.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$22932f6b5a031346$var$Select.muiName = "Select";
var $22932f6b5a031346$export$2e2bcd8739ae039 = $22932f6b5a031346$var$Select;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $d4174659c1bfcace$export$c1bdcbaf0596aeda(slot) {
    return (0, $8QgsE.default)("MuiTextField", slot);
}
const $d4174659c1bfcace$var$textFieldClasses = (0, $dvQev.default)("MuiTextField", [
    "root"
]);
var $d4174659c1bfcace$export$2e2bcd8739ae039 = $d4174659c1bfcace$var$textFieldClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $ebb4e6a14e6dbf24$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $ebb4e6a14e6dbf24$var$variantComponent = {
    standard: (0, $746043b2897ffa7d$export$2e2bcd8739ae039),
    filled: (0, $4f39814fc95716c5$export$2e2bcd8739ae039),
    outlined: (0, $361c4111f560ec07$export$2e2bcd8739ae039)
};
const $ebb4e6a14e6dbf24$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $d4174659c1bfcace$export$c1bdcbaf0596aeda), classes);
};
const $ebb4e6a14e6dbf24$var$TextFieldRoot = (0, $e8m2I.default)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $ebb4e6a14e6dbf24$var$TextField = /*#__PURE__*/ $eZVvM.forwardRef(function TextField(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $ebb4e6a14e6dbf24$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $ebb4e6a14e6dbf24$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $ebb4e6a14e6dbf24$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $3pI8R.jsx)(InputComponent, (0, $65o8X.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($ebb4e6a14e6dbf24$var$TextFieldRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a75413bd2bd509d5$export$2e2bcd8739ae039), (0, $65o8X.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $22932f6b5a031346$export$2e2bcd8739ae039), (0, $65o8X.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $3pI8R.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), (0, $65o8X.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $ebb4e6a14e6dbf24$export$2e2bcd8739ae039 = $ebb4e6a14e6dbf24$var$TextField;



var $81BVN = parcelRequire("81BVN");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $22a6c89cdb3425e5$var$usePreviousProps = (value)=>{
    const ref = $eZVvM.useRef({});
    $eZVvM.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $22a6c89cdb3425e5$export$2e2bcd8739ae039 = $22a6c89cdb3425e5$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $282f8ba67d45d941$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $282f8ba67d45d941$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $282f8ba67d45d941$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $282f8ba67d45d941$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $282f8ba67d45d941$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $282f8ba67d45d941$var$defaultFilterOptions = $282f8ba67d45d941$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $282f8ba67d45d941$var$pageSize = 5;
const $282f8ba67d45d941$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $282f8ba67d45d941$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $282f8ba67d45d941$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $282f8ba67d45d941$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $eZVvM.useRef(false);
    const firstFocus = $eZVvM.useRef(true);
    const inputRef = $eZVvM.useRef(null);
    const listboxRef = $eZVvM.useRef(null);
    const [anchorEl, setAnchorEl] = $eZVvM.useState(null);
    const [focusedTag, setFocusedTag] = $eZVvM.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $eZVvM.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $eZVvM.useState(false);
    const resetInputValue = $eZVvM.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $eZVvM.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $22a6c89cdb3425e5$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $eZVvM.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $eZVvM.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $282f8ba67d45d941$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $eZVvM.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $282f8ba67d45d941$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $282f8ba67d45d941$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((node)=>{
        (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $eZVvM.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $eZVvM.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $282f8ba67d45d941$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$282f8ba67d45d941$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $282f8ba67d45d941$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $65o8X.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $65o8X.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $282f8ba67d45d941$export$2e2bcd8739ae039 = $282f8ba67d45d941$var$useAutocomplete;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");
var $ad13676242e47154$exports = {};
"use strict";
"use client";
Object.defineProperty($ad13676242e47154$exports, "__esModule", {
    value: true
});
$ad13676242e47154$exports.default = void 0;

var $ad13676242e47154$var$React = $ad13676242e47154$var$_interopRequireWildcard((parcelRequire("eZVvM")));
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");
function $ad13676242e47154$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ad13676242e47154$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ad13676242e47154$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ad13676242e47154$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $ad13676242e47154$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $ad13676242e47154$var$useTheme(defaultTheme = null) {
    const contextTheme = $ad13676242e47154$var$React.useContext($8kMfp.T);
    return !contextTheme || $ad13676242e47154$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $ad13676242e47154$var$_default = $ad13676242e47154$exports.default = $ad13676242e47154$var$useTheme;






var $eZVvM = parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");

function $d0ce3738840a2408$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $92b65ec046e98f4d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $92b65ec046e98f4d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $92b65ec046e98f4d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $ad3f7a5a8482840f$export$8960430cfd85939f = Math.max;
var $ad3f7a5a8482840f$export$96ec731ed4dcb222 = Math.min;
var $ad3f7a5a8482840f$export$2077e0241d6afd3c = Math.round;



function $4b26ed5ce8100ea6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
}


function $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $eebe817f20e734af$export$2e2bcd8739ae039(node) {
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $b9b075552c2ee2ee$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $a9cc91b11697ab72$export$2e2bcd8739ae039(node) {
    if (node === (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node) || !(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(node)) return (0, $eebe817f20e734af$export$2e2bcd8739ae039)(node);
    else return (0, $b9b075552c2ee2ee$export$2e2bcd8739ae039)(node);
}


function $7d7193fe56f182d8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $52c660cda767c7d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e59b09d2eb8bea89$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)((0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element)).left + (0, $eebe817f20e734af$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $b8946eb1ad0de2f1$export$2e2bcd8739ae039(element) {
    return (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $8d0fcb165fc13a08$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d0f350e126e8de99$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d0f350e126e8de99$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent) && $d0f350e126e8de99$var$isElementScaled(offsetParent);
    var documentElement = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $a9cc91b11697ab72$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $8ac7236a7bdef816$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $2b8f424b5adba263$export$2e2bcd8739ae039(element) {
    if ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $a574c050346a8ac4$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(node) && (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(node)) return node;
    return $a574c050346a8ac4$export$2e2bcd8739ae039((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(node));
}





function $0e12a92913d4c423$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a574c050346a8ac4$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($0e12a92913d4c423$export$2e2bcd8739ae039((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(target)));
}







function $96699daebcf0ac6c$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) >= 0;
}




function $79e7fa5afa96173f$var$getTrueOffsetParent(element) {
    if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $79e7fa5afa96173f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
    if (isIE && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $2b8f424b5adba263$export$2e2bcd8739ae039)(element);
    if ((0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $79e7fa5afa96173f$export$2e2bcd8739ae039(element) {
    var window = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element);
    var offsetParent = $79e7fa5afa96173f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $96699daebcf0ac6c$export$2e2bcd8739ae039)(offsetParent) && (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $79e7fa5afa96173f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $79e7fa5afa96173f$var$getContainingBlock(element) || window;
}


var $6f22ac8331a483e2$export$1e95b668f3b82d = "top";
var $6f22ac8331a483e2$export$40e543e69a8b3fbb = "bottom";
var $6f22ac8331a483e2$export$79ffe56a765070d2 = "right";
var $6f22ac8331a483e2$export$eabcd2c8791e7bf4 = "left";
var $6f22ac8331a483e2$export$dfb5619354ba860 = "auto";
var $6f22ac8331a483e2$export$aec2ce47c367b8c3 = [
    $6f22ac8331a483e2$export$1e95b668f3b82d,
    $6f22ac8331a483e2$export$40e543e69a8b3fbb,
    $6f22ac8331a483e2$export$79ffe56a765070d2,
    $6f22ac8331a483e2$export$eabcd2c8791e7bf4
];
var $6f22ac8331a483e2$export$b3571188c770cc5a = "start";
var $6f22ac8331a483e2$export$bd5df0f255a350f8 = "end";
var $6f22ac8331a483e2$export$390fd549c5303b4d = "clippingParents";
var $6f22ac8331a483e2$export$d7b7311ec04a3e8f = "viewport";
var $6f22ac8331a483e2$export$ae5ab1c730825774 = "popper";
var $6f22ac8331a483e2$export$ca50aac9f3ba507f = "reference";
var $6f22ac8331a483e2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6f22ac8331a483e2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6f22ac8331a483e2$export$b3571188c770cc5a,
        placement + "-" + $6f22ac8331a483e2$export$bd5df0f255a350f8
    ]);
}, []);
var $6f22ac8331a483e2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6f22ac8331a483e2$export$aec2ce47c367b8c3, [
    $6f22ac8331a483e2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6f22ac8331a483e2$export$b3571188c770cc5a,
        placement + "-" + $6f22ac8331a483e2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6f22ac8331a483e2$export$421679a7c3d56e = "beforeRead";
var $6f22ac8331a483e2$export$aafa59e2e03f2942 = "read";
var $6f22ac8331a483e2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $6f22ac8331a483e2$export$c65e99957a05207c = "beforeMain";
var $6f22ac8331a483e2$export$f22da7240b7add18 = "main";
var $6f22ac8331a483e2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6f22ac8331a483e2$export$8d4d2d70e7d46032 = "beforeWrite";
var $6f22ac8331a483e2$export$68d8715fc104d294 = "write";
var $6f22ac8331a483e2$export$70a6e5159acce2e6 = "afterWrite";
var $6f22ac8331a483e2$export$d087d3878fdf71d5 = [
    $6f22ac8331a483e2$export$421679a7c3d56e,
    $6f22ac8331a483e2$export$aafa59e2e03f2942,
    $6f22ac8331a483e2$export$6964f6c886723980,
    $6f22ac8331a483e2$export$c65e99957a05207c,
    $6f22ac8331a483e2$export$f22da7240b7add18,
    $6f22ac8331a483e2$export$bab79516f2d662fe,
    $6f22ac8331a483e2$export$8d4d2d70e7d46032,
    $6f22ac8331a483e2$export$68d8715fc104d294,
    $6f22ac8331a483e2$export$70a6e5159acce2e6
];


function $603713de06d15020$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $603713de06d15020$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $603713de06d15020$var$order(modifiers); // order based on phase
    return (0, $6f22ac8331a483e2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $bc094e3784c45654$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7be418f0773d1592$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2abb20d7ea296a1b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $2abb20d7ea296a1b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $2abb20d7ea296a1b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2abb20d7ea296a1b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $2abb20d7ea296a1b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(reference) ? (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $603713de06d15020$export$2e2bcd8739ae039)((0, $7be418f0773d1592$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2abb20d7ea296a1b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d0f350e126e8de99$export$2e2bcd8739ae039)(reference, (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bc094e3784c45654$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2abb20d7ea296a1b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2abb20d7ea296a1b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2abb20d7ea296a1b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ee6b3e5d1222bd05$var$passive = {
    passive: true
};
function $ee6b3e5d1222bd05$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ee6b3e5d1222bd05$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ee6b3e5d1222bd05$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ee6b3e5d1222bd05$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ee6b3e5d1222bd05$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ee6b3e5d1222bd05$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ee6b3e5d1222bd05$var$effect,
    data: {}
};



function $87559d8954c2621c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6501fafdaa9fbf80$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $efeabed7f1253daf$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $036f2738b316629f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $6f22ac8331a483e2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $6f22ac8331a483e2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $6f22ac8331a483e2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $6f22ac8331a483e2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $6f22ac8331a483e2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $9f7f079db3eb0441$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $036f2738b316629f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9f7f079db3eb0441$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $9f7f079db3eb0441$var$popperOffsets,
    data: {}
};










var $ba6260f5a8d7d967$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ba6260f5a8d7d967$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ba6260f5a8d7d967$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
    var sideY = (0, $6f22ac8331a483e2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(popper);
            if ((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $6f22ac8331a483e2$export$1e95b668f3b82d) || (placement === (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) || placement === (0, $6f22ac8331a483e2$export$79ffe56a765070d2)) && variation === (0, $6f22ac8331a483e2$export$bd5df0f255a350f8)) {
            sideY = (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) || (placement === (0, $6f22ac8331a483e2$export$1e95b668f3b82d) || placement === (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)) && variation === (0, $6f22ac8331a483e2$export$bd5df0f255a350f8)) {
            sideX = (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ba6260f5a8d7d967$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ba6260f5a8d7d967$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $ba6260f5a8d7d967$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ba6260f5a8d7d967$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ba6260f5a8d7d967$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ba6260f5a8d7d967$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $ba6260f5a8d7d967$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $3518c1e74083d57a$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || !(0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $3518c1e74083d57a$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || !(0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3518c1e74083d57a$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $3518c1e74083d57a$var$applyStyles,
    effect: $3518c1e74083d57a$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $3c1dca40ee13caa5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $3c1dca40ee13caa5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $6f22ac8331a483e2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $3c1dca40ee13caa5$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3c1dca40ee13caa5$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $3c1dca40ee13caa5$var$offset
};


var $da09f54b256866ad$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $da09f54b256866ad$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $da09f54b256866ad$var$hash[matched];
    });
}



var $f7c35de4d48611a4$var$hash = {
    start: "end",
    end: "start"
};
function $f7c35de4d48611a4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f7c35de4d48611a4$var$hash[matched];
    });
}







function $0dc71baccd59e88b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element);
    var html = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f106b29f65555188$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $eebe817f20e734af$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4e82368a640c40d5$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $8c9ef49674af264e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $01683c672f46903f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $01683c672f46903f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $6f22ac8331a483e2$export$d7b7311ec04a3e8f) ? (0, $8c9ef49674af264e$export$2e2bcd8739ae039)((0, $0dc71baccd59e88b$export$2e2bcd8739ae039)(element, strategy)) : (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clippingParent) ? $01683c672f46903f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8c9ef49674af264e$export$2e2bcd8739ae039)((0, $f106b29f65555188$export$2e2bcd8739ae039)((0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $01683c672f46903f$var$getClippingParents(element) {
    var clippingParents = (0, $0e12a92913d4c423$export$2e2bcd8739ae039)((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) ? (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4e82368a640c40d5$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $01683c672f46903f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $01683c672f46903f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $01683c672f46903f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $01683c672f46903f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $baddc6c5521d5e15$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $89c0491d5a2636c8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $baddc6c5521d5e15$export$2e2bcd8739ae039)(), paddingObject);
}


function $4389887f9718103c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $190a711189c6b251$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $6f22ac8331a483e2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $6f22ac8331a483e2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $6f22ac8331a483e2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $89c0491d5a2636c8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4389887f9718103c$export$2e2bcd8739ae039)(padding, (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) ? (0, $6f22ac8331a483e2$export$ca50aac9f3ba507f) : (0, $6f22ac8331a483e2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $01683c672f46903f$export$2e2bcd8739ae039)((0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $036f2738b316629f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $8c9ef49674af264e$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $6f22ac8331a483e2$export$79ffe56a765070d2),
                (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
                (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $fa38cbc56ce873f6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $6f22ac8331a483e2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $6f22ac8331a483e2$export$368f9a87e87fa4e1) : (0, $6f22ac8331a483e2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $bf633ea20b60f266$var$getExpandedFallbackPlacements(placement) {
    if ((0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f7c35de4d48611a4$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f7c35de4d48611a4$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $bf633ea20b60f266$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $da09f54b256866ad$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $bf633ea20b60f266$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$dfb5619354ba860) ? (0, $fa38cbc56ce873f6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
            (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $6f22ac8331a483e2$export$79ffe56a765070d2) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bf633ea20b60f266$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $bf633ea20b60f266$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $b62df35d662a501c$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $d164fcd4acbd6bc6$export$f28d906d67a997f3(min, value, max) {
    return (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(min, (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(value, max));
}
function $d164fcd4acbd6bc6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d164fcd4acbd6bc6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $63491105a13ee82c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b62df35d662a501c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $6f22ac8331a483e2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $6f22ac8331a483e2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $baddc6c5521d5e15$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(tether ? (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
            (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d164fcd4acbd6bc6$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $63491105a13ee82c$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $63491105a13ee82c$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $2935d5367238fc80$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $89c0491d5a2636c8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4389887f9718103c$export$2e2bcd8739ae039)(padding, (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3)));
};
function $2935d5367238fc80$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2935d5367238fc80$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2935d5367238fc80$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4e82368a640c40d5$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2935d5367238fc80$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $2935d5367238fc80$var$arrow,
    effect: $2935d5367238fc80$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $b6b199cccd8b0717$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b6b199cccd8b0717$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2),
        (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb),
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b6b199cccd8b0717$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b6b199cccd8b0717$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b6b199cccd8b0717$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b6b199cccd8b0717$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b6b199cccd8b0717$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b6b199cccd8b0717$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $b6b199cccd8b0717$var$hide
};




var $216a443298308e45$export$d34966752335dd47 = [
    (0, $ee6b3e5d1222bd05$export$2e2bcd8739ae039),
    (0, $9f7f079db3eb0441$export$2e2bcd8739ae039),
    (0, $ba6260f5a8d7d967$export$2e2bcd8739ae039),
    (0, $3518c1e74083d57a$export$2e2bcd8739ae039),
    (0, $3c1dca40ee13caa5$export$2e2bcd8739ae039),
    (0, $bf633ea20b60f266$export$2e2bcd8739ae039),
    (0, $63491105a13ee82c$export$2e2bcd8739ae039),
    (0, $2935d5367238fc80$export$2e2bcd8739ae039),
    (0, $b6b199cccd8b0717$export$2e2bcd8739ae039)
];
var $216a443298308e45$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2abb20d7ea296a1b$export$ed5e13716264f202)({
    defaultModifiers: $216a443298308e45$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $9HTTf = parcelRequire("9HTTf");



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $324dac256b289ae8$export$1b69b6cd0fa638a1(slot) {
    return (0, $8QgsE.default)("MuiPopper", slot);
}
const $324dac256b289ae8$var$popperClasses = (0, $dvQev.default)("MuiPopper", [
    "root"
]);
var $324dac256b289ae8$export$2e2bcd8739ae039 = $324dac256b289ae8$var$popperClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $64d0853836321eb3$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $64d0853836321eb3$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $64d0853836321eb3$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $64d0853836321eb3$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $64d0853836321eb3$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $64d0853836321eb3$var$isVirtualElement(element) {
    return !$64d0853836321eb3$var$isHTMLElement(element);
}
const $64d0853836321eb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $324dac256b289ae8$export$1b69b6cd0fa638a1), classes);
};
const $64d0853836321eb3$var$defaultPopperOptions = {};
const $64d0853836321eb3$var$PopperTooltip = /*#__PURE__*/ $eZVvM.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $7Z8DW.default)(props, $64d0853836321eb3$var$_excluded);
    const tooltipRef = $eZVvM.useRef(null);
    const ownRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $eZVvM.useRef(null);
    const handlePopperRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $eZVvM.useRef(handlePopperRef);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $eZVvM.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $64d0853836321eb3$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $eZVvM.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $eZVvM.useState($64d0853836321eb3$var$resolveAnchorEl(anchorEl));
    $eZVvM.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $eZVvM.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($64d0853836321eb3$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $216a443298308e45$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $65o8X.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $64d0853836321eb3$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)(Root, (0, $65o8X.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $64d0853836321eb3$var$Popper = /*#__PURE__*/ $eZVvM.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $64d0853836321eb3$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7Z8DW.default)(props, $64d0853836321eb3$var$_excluded2);
    const [exited, setExited] = $eZVvM.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $64d0853836321eb3$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $64d0853836321eb3$var$isHTMLElement(resolvedAnchorEl) ? (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d431bbc85d36d423$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($64d0853836321eb3$var$PopperTooltip, (0, $65o8X.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $65o8X.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $64d0853836321eb3$export$2e2bcd8739ae039 = $64d0853836321eb3$var$Popper;



var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $3pI8R = parcelRequire("3pI8R");
"use client";
const $1760f7053664752f$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $1760f7053664752f$var$PopperRoot = (0, $e8m2I.default)((0, $64d0853836321eb3$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $1760f7053664752f$var$Popper = /*#__PURE__*/ $eZVvM.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($ad13676242e47154$exports)))();
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $7Z8DW.default)(props, $1760f7053664752f$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $65o8X.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($1760f7053664752f$var$PopperRoot, (0, $65o8X.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $1760f7053664752f$export$2e2bcd8739ae039 = $1760f7053664752f$var$Popper;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $iDCHz = parcelRequire("iDCHz");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $d67041776ab2240e$export$6816d4fc0981ec7(slot) {
    return (0, $8QgsE.default)("MuiListSubheader", slot);
}
const $d67041776ab2240e$var$listSubheaderClasses = (0, $dvQev.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $d67041776ab2240e$export$2e2bcd8739ae039 = $d67041776ab2240e$var$listSubheaderClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $582c74c86fa27313$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $582c74c86fa27313$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $iDCHz.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $d67041776ab2240e$export$6816d4fc0981ec7), classes);
};
const $582c74c86fa27313$var$ListSubheaderRoot = (0, $e8m2I.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $iDCHz.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $582c74c86fa27313$var$ListSubheader = /*#__PURE__*/ $eZVvM.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $7Z8DW.default)(props, $582c74c86fa27313$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $582c74c86fa27313$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($582c74c86fa27313$var$ListSubheaderRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$582c74c86fa27313$var$ListSubheader.muiSkipListHighlight = true;
var $582c74c86fa27313$export$2e2bcd8739ae039 = $582c74c86fa27313$var$ListSubheader;





var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");
parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d6f52fd6c316c042$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $iDCHz = parcelRequire("iDCHz");


var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $dfc2caa43c166e10$export$31444911e4ee6fdd(slot) {
    return (0, $8QgsE.default)("MuiChip", slot);
}
const $dfc2caa43c166e10$var$chipClasses = (0, $dvQev.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $dfc2caa43c166e10$export$2e2bcd8739ae039 = $dfc2caa43c166e10$var$chipClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $39eec2a383e148e0$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $39eec2a383e148e0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $iDCHz.default)(size)}`,
            `color${(0, $iDCHz.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $iDCHz.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $iDCHz.default)(color)}`,
            `${variant}${(0, $iDCHz.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $iDCHz.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $iDCHz.default)(size)}`,
            `avatarColor${(0, $iDCHz.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $iDCHz.default)(size)}`,
            `iconColor${(0, $iDCHz.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $iDCHz.default)(size)}`,
            `deleteIconColor${(0, $iDCHz.default)(color)}`,
            `deleteIcon${(0, $iDCHz.default)(variant)}Color${(0, $iDCHz.default)(color)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $dfc2caa43c166e10$export$31444911e4ee6fdd), classes);
};
const $39eec2a383e148e0$var$ChipRoot = (0, $e8m2I.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $iDCHz.default)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $iDCHz.default)(color)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $iDCHz.default)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $iDCHz.default)(iconColor)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iDCHz.default)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $iDCHz.default)(color)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iDCHz.default)(variant)}Color${(0, $iDCHz.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $iDCHz.default)(size)}`],
            styles[`color${(0, $iDCHz.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $iDCHz.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $iDCHz.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $iDCHz.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $65o8X.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: (0, $65o8X.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $65o8X.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: (0, $65o8X.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $9b0pf.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $9b0pf.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $9b0pf.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $9b0pf.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $9b0pf.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $9b0pf.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $39eec2a383e148e0$var$ChipLabel = (0, $e8m2I.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $iDCHz.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $39eec2a383e148e0$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $39eec2a383e148e0$var$Chip = /*#__PURE__*/ $eZVvM.forwardRef(function Chip(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $7Z8DW.default)(props, $39eec2a383e148e0$var$_excluded);
    const chipRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $39eec2a383e148e0$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $39eec2a383e148e0$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $eZVvM.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $39eec2a383e148e0$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039) ? (0, $65o8X.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $eZVvM.isValidElement(deleteIconProp) ? /*#__PURE__*/ $eZVvM.cloneElement(deleteIconProp, {
        className: (0, $fmwLG.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d6f52fd6c316c042$export$2e2bcd8739ae039), {
        className: (0, $fmwLG.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $eZVvM.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $eZVvM.cloneElement(avatarProp, {
        className: (0, $fmwLG.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $eZVvM.isValidElement(iconProp)) icon = /*#__PURE__*/ $eZVvM.cloneElement(iconProp, {
        className: (0, $fmwLG.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($39eec2a383e148e0$var$ChipRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $fmwLG.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $3pI8R.jsx)($39eec2a383e148e0$var$ChipLabel, {
                className: (0, $fmwLG.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $39eec2a383e148e0$export$2e2bcd8739ae039 = $39eec2a383e148e0$var$Chip;









var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $6f6b068b68b5f599$export$8ee01529667e66d9(slot) {
    return (0, $8QgsE.default)("MuiAutocomplete", slot);
}
const $6f6b068b68b5f599$var$autocompleteClasses = (0, $dvQev.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $6f6b068b68b5f599$export$2e2bcd8739ae039 = $6f6b068b68b5f599$var$autocompleteClasses;



var $iDCHz = parcelRequire("iDCHz");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $ac6c22b4d4537c6c$var$_ClearIcon, $ac6c22b4d4537c6c$var$_ArrowDropDownIcon;
const $ac6c22b4d4537c6c$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $ac6c22b4d4537c6c$var$_excluded2 = [
    "ref"
], $ac6c22b4d4537c6c$var$_excluded3 = [
    "key"
], $ac6c22b4d4537c6c$var$_excluded4 = [
    "key"
];
const $ac6c22b4d4537c6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $iDCHz.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $6f6b068b68b5f599$export$8ee01529667e66d9), classes);
};
const $ac6c22b4d4537c6c$var$AutocompleteRoot = (0, $e8m2I.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $iDCHz.default)(size)}`]
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused} .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: "visible"
    },
    /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
        [`&:hover .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        }
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: "calc(100% - 6px)"
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        "& .MuiInput-input": {
            padding: "4px 4px 4px 0px"
        }
    },
    [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).input}`]: {
            padding: "2px 4px 3px 0"
        }
    },
    [`& .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            padding: "7.5px 4px 7.5px 5px"
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px 2.5px 8px"
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).input}`]: {
            padding: "7px 4px"
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px"
        }
    },
    [`& .${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: "ellipsis",
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: "calc(100% - 4px)"
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: "wrap"
                }
            }
        }
    ]
});
const $ac6c22b4d4537c6c$var$AutocompleteEndAdornment = (0, $e8m2I.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $ac6c22b4d4537c6c$var$AutocompleteClearIndicator = (0, $e8m2I.default)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $ac6c22b4d4537c6c$var$AutocompletePopupIndicator = (0, $e8m2I.default)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $65o8X.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $ac6c22b4d4537c6c$var$AutocompletePopper = (0, $e8m2I.default)((0, $1760f7053664752f$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: "absolute"
                }
            }
        ]
    }));
const $ac6c22b4d4537c6c$var$AutocompletePaper = (0, $e8m2I.default)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteLoading = (0, $e8m2I.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteNoOptions = (0, $e8m2I.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteListbox = (0, $e8m2I.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $ac6c22b4d4537c6c$var$AutocompleteGroupLabel = (0, $e8m2I.default)((0, $582c74c86fa27313$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $ac6c22b4d4537c6c$var$AutocompleteGroupUl = (0, $e8m2I.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $ac6c22b4d4537c6c$var$Autocomplete = /*#__PURE__*/ $eZVvM.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $ac6c22b4d4537c6c$var$_ClearIcon || ($ac6c22b4d4537c6c$var$_ClearIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $12bec17d627bfb46$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $08c3c2df346a18c6$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $1760f7053664752f$export$2e2bcd8739ae039), popupIcon: popupIcon = $ac6c22b4d4537c6c$var$_ArrowDropDownIcon || ($ac6c22b4d4537c6c$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a75f8309f0ea897a$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $7Z8DW.default)(props, $ac6c22b4d4537c6c$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $282f8ba67d45d941$export$2e2bcd8739ae039)((0, $65o8X.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $7Z8DW.default)(_getListboxProps, $ac6c22b4d4537c6c$var$_excluded2);
    const combinedListboxRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $65o8X.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $ac6c22b4d4537c6c$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $65o8X.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $7Z8DW.default)(_getCustomizedTagProp, $ac6c22b4d4537c6c$var$_excluded3);
            return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $39eec2a383e148e0$export$2e2bcd8739ae039), (0, $65o8X.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $3pI8R.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $7Z8DW.default)(props2, $ac6c22b4d4537c6c$var$_excluded4);
        return /*#__PURE__*/ (0, $3pI8R.jsx)("li", (0, $65o8X.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $65o8X.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePopper, (0, $65o8X.default)({
            as: PopperComponent,
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            ownerState: ownerState,
            role: "presentation",
            anchorEl: anchorEl,
            open: popupOpen
        }, popperSlotProps, {
            className: (0, $fmwLG.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePaper, (0, $65o8X.default)({
                ownerState: ownerState,
                as: PaperComponent
            }, paperSlotProps, {
                className: (0, $fmwLG.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                children: children
            }))
        }));
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteListbox, (0, $65o8X.default)({
        as: ListboxComponent,
        className: classes.listbox,
        ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
        ref: combinedListboxRef,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    })));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteRoot, (0, $65o8X.default)({
                ref: ref,
                className: (0, $fmwLG.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $65o8X.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $3pI8R.jsxs)($ac6c22b4d4537c6c$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteClearIndicator, (0, $65o8X.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $fmwLG.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePopupIndicator, (0, $65o8X.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $fmwLG.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $65o8X.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? autocompletePopper : null
        ]
    });
});
var $ac6c22b4d4537c6c$export$2e2bcd8739ae039 = $ac6c22b4d4537c6c$var$Autocomplete;



var $e8m2I = parcelRequire("e8m2I");

var $ljukC = parcelRequire("ljukC");

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $e8m2I = parcelRequire("e8m2I");


var $2Hfls = parcelRequire("2Hfls");

var $81BVN = parcelRequire("81BVN");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $e8m2I = parcelRequire("e8m2I");
var $gW9L2 = parcelRequire("gW9L2");

var $8C83T = parcelRequire("8C83T");





var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $b643b5f13809fc1c$export$46f01d01378ec5a2(slot) {
    return (0, $8QgsE.default)("MuiDivider", slot);
}
const $b643b5f13809fc1c$var$dividerClasses = (0, $dvQev.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $b643b5f13809fc1c$export$2e2bcd8739ae039 = $b643b5f13809fc1c$var$dividerClasses;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $5e9fb9532a3d4425$export$81478e24460c57f2(slot) {
    return (0, $8QgsE.default)("MuiListItemIcon", slot);
}
const $5e9fb9532a3d4425$var$listItemIconClasses = (0, $dvQev.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $5e9fb9532a3d4425$export$2e2bcd8739ae039 = $5e9fb9532a3d4425$var$listItemIconClasses;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $12bfc73a3b0677c5$export$1061006a0db3aeb5(slot) {
    return (0, $8QgsE.default)("MuiListItemText", slot);
}
const $12bfc73a3b0677c5$var$listItemTextClasses = (0, $dvQev.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $12bfc73a3b0677c5$export$2e2bcd8739ae039 = $12bfc73a3b0677c5$var$listItemTextClasses;



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $0258ddb2b5125a4d$export$515f8c67b5305377(slot) {
    return (0, $8QgsE.default)("MuiMenuItem", slot);
}
const $0258ddb2b5125a4d$var$menuItemClasses = (0, $dvQev.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $0258ddb2b5125a4d$export$2e2bcd8739ae039 = $0258ddb2b5125a4d$var$menuItemClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $0f9712359a52dd90$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $0f9712359a52dd90$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $0f9712359a52dd90$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $9HTTf.default)(slots, (0, $0258ddb2b5125a4d$export$515f8c67b5305377), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $0f9712359a52dd90$var$MenuItemRoot = (0, $e8m2I.default)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gW9L2.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $0f9712359a52dd90$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $b643b5f13809fc1c$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $b643b5f13809fc1c$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $5e9fb9532a3d4425$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $65o8X.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $5e9fb9532a3d4425$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $0f9712359a52dd90$var$MenuItem = /*#__PURE__*/ $eZVvM.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $7Z8DW.default)(props, $0f9712359a52dd90$var$_excluded);
    const context = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    const childContext = $eZVvM.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $eZVvM.useRef(null);
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $0f9712359a52dd90$var$useUtilityClasses(props);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($0f9712359a52dd90$var$MenuItemRoot, (0, $65o8X.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fmwLG.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fmwLG.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $0f9712359a52dd90$export$2e2bcd8739ae039 = $0f9712359a52dd90$var$MenuItem;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b8d8870a92540e83$var$_excluded = [
    "className"
];
const $b8d8870a92540e83$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $5e9fb9532a3d4425$export$81478e24460c57f2), classes);
};
const $b8d8870a92540e83$var$ListItemIconRoot = (0, $e8m2I.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $b8d8870a92540e83$var$ListItemIcon = /*#__PURE__*/ $eZVvM.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $7Z8DW.default)(props, $b8d8870a92540e83$var$_excluded);
    const context = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    const ownerState = (0, $65o8X.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $b8d8870a92540e83$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b8d8870a92540e83$var$ListItemIconRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b8d8870a92540e83$export$2e2bcd8739ae039 = $b8d8870a92540e83$var$ListItemIcon;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $81BVN = parcelRequire("81BVN");


var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");


var $3pI8R = parcelRequire("3pI8R");
"use client";
const $f4c2a1be62dbd0c3$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $f4c2a1be62dbd0c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $12bfc73a3b0677c5$export$1061006a0db3aeb5), classes);
};
const $f4c2a1be62dbd0c3$var$ListItemTextRoot = (0, $e8m2I.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $f4c2a1be62dbd0c3$var$ListItemText = /*#__PURE__*/ $eZVvM.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $7Z8DW.default)(props, $f4c2a1be62dbd0c3$var$_excluded);
    const { dense: dense } = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $65o8X.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $f4c2a1be62dbd0c3$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $81BVN.default) && !disableTypography) primary = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $81BVN.default), (0, $65o8X.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $81BVN.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $81BVN.default), (0, $65o8X.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($f4c2a1be62dbd0c3$var$ListItemTextRoot, (0, $65o8X.default)({
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $f4c2a1be62dbd0c3$export$2e2bcd8739ae039 = $f4c2a1be62dbd0c3$var$ListItemText;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $iDCHz = parcelRequire("iDCHz");

var $81BVN = parcelRequire("81BVN");



var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $28bffe0f438cff3e$export$4b135a4b3a6c4550(slot) {
    return (0, $8QgsE.default)("MuiInputAdornment", slot);
}
const $28bffe0f438cff3e$var$inputAdornmentClasses = (0, $dvQev.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $28bffe0f438cff3e$export$2e2bcd8739ae039 = $28bffe0f438cff3e$var$inputAdornmentClasses;



var $8C83T = parcelRequire("8C83T");

var $3pI8R = parcelRequire("3pI8R");
"use client";
var $2716b83202966b50$var$_span;
const $2716b83202966b50$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $2716b83202966b50$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $iDCHz.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $2716b83202966b50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $iDCHz.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $iDCHz.default)(size)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $28bffe0f438cff3e$export$4b135a4b3a6c4550), classes);
};
const $2716b83202966b50$var$InputAdornmentRoot = (0, $e8m2I.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $2716b83202966b50$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $28bffe0f438cff3e$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $28bffe0f438cff3e$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $2716b83202966b50$var$InputAdornment = /*#__PURE__*/ $eZVvM.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $7Z8DW.default)(props, $2716b83202966b50$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $65o8X.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $2716b83202966b50$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($2716b83202966b50$var$InputAdornmentRoot, (0, $65o8X.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fmwLG.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $81BVN.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $2716b83202966b50$var$_span || ($2716b83202966b50$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $2716b83202966b50$export$2e2bcd8739ae039 = $2716b83202966b50$var$InputAdornment;



const $bb50b4d24b214940$var$Dn = {
    Flag: (0, $e8m2I.default)("span")(()=>({
            display: "flex",
            alignItems: "center"
        }))
}, $bb50b4d24b214940$var$Re = "MuiTelInput-Flag", $bb50b4d24b214940$var$_e = ({ isoCode: t, children: n })=>/* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Dn.Flag, {
        "data-testid": t,
        className: $bb50b4d24b214940$var$Re,
        children: n
    }), $bb50b4d24b214940$var$q = "en", $bb50b4d24b214940$var$St = {
    EU: [
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    AS: [
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CC",
        "CN",
        "CX",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IO",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    NA: [
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    SA: [
        "AR",
        "BO",
        "BR",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    OC: [
        "AS",
        "AU",
        "CK",
        "FJ",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PW",
        "SB",
        "TK",
        "TL",
        "TO",
        "TV",
        "VU",
        "WF",
        "WS"
    ],
    AF: [
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ]
}, $bb50b4d24b214940$var$Tt = {
    version: 4,
    country_calling_codes: {
        1: [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        7: [
            "RU",
            "KZ"
        ],
        20: [
            "EG"
        ],
        27: [
            "ZA"
        ],
        30: [
            "GR"
        ],
        31: [
            "NL"
        ],
        32: [
            "BE"
        ],
        33: [
            "FR"
        ],
        34: [
            "ES"
        ],
        36: [
            "HU"
        ],
        39: [
            "IT",
            "VA"
        ],
        40: [
            "RO"
        ],
        41: [
            "CH"
        ],
        43: [
            "AT"
        ],
        44: [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        45: [
            "DK"
        ],
        46: [
            "SE"
        ],
        47: [
            "NO",
            "SJ"
        ],
        48: [
            "PL"
        ],
        49: [
            "DE"
        ],
        51: [
            "PE"
        ],
        52: [
            "MX"
        ],
        53: [
            "CU"
        ],
        54: [
            "AR"
        ],
        55: [
            "BR"
        ],
        56: [
            "CL"
        ],
        57: [
            "CO"
        ],
        58: [
            "VE"
        ],
        60: [
            "MY"
        ],
        61: [
            "AU",
            "CC",
            "CX"
        ],
        62: [
            "ID"
        ],
        63: [
            "PH"
        ],
        64: [
            "NZ"
        ],
        65: [
            "SG"
        ],
        66: [
            "TH"
        ],
        81: [
            "JP"
        ],
        82: [
            "KR"
        ],
        84: [
            "VN"
        ],
        86: [
            "CN"
        ],
        90: [
            "TR"
        ],
        91: [
            "IN"
        ],
        92: [
            "PK"
        ],
        93: [
            "AF"
        ],
        94: [
            "LK"
        ],
        95: [
            "MM"
        ],
        98: [
            "IR"
        ],
        211: [
            "SS"
        ],
        212: [
            "MA",
            "EH"
        ],
        213: [
            "DZ"
        ],
        216: [
            "TN"
        ],
        218: [
            "LY"
        ],
        220: [
            "GM"
        ],
        221: [
            "SN"
        ],
        222: [
            "MR"
        ],
        223: [
            "ML"
        ],
        224: [
            "GN"
        ],
        225: [
            "CI"
        ],
        226: [
            "BF"
        ],
        227: [
            "NE"
        ],
        228: [
            "TG"
        ],
        229: [
            "BJ"
        ],
        230: [
            "MU"
        ],
        231: [
            "LR"
        ],
        232: [
            "SL"
        ],
        233: [
            "GH"
        ],
        234: [
            "NG"
        ],
        235: [
            "TD"
        ],
        236: [
            "CF"
        ],
        237: [
            "CM"
        ],
        238: [
            "CV"
        ],
        239: [
            "ST"
        ],
        240: [
            "GQ"
        ],
        241: [
            "GA"
        ],
        242: [
            "CG"
        ],
        243: [
            "CD"
        ],
        244: [
            "AO"
        ],
        245: [
            "GW"
        ],
        246: [
            "IO"
        ],
        247: [
            "AC"
        ],
        248: [
            "SC"
        ],
        249: [
            "SD"
        ],
        250: [
            "RW"
        ],
        251: [
            "ET"
        ],
        252: [
            "SO"
        ],
        253: [
            "DJ"
        ],
        254: [
            "KE"
        ],
        255: [
            "TZ"
        ],
        256: [
            "UG"
        ],
        257: [
            "BI"
        ],
        258: [
            "MZ"
        ],
        260: [
            "ZM"
        ],
        261: [
            "MG"
        ],
        262: [
            "RE",
            "YT"
        ],
        263: [
            "ZW"
        ],
        264: [
            "NA"
        ],
        265: [
            "MW"
        ],
        266: [
            "LS"
        ],
        267: [
            "BW"
        ],
        268: [
            "SZ"
        ],
        269: [
            "KM"
        ],
        290: [
            "SH",
            "TA"
        ],
        291: [
            "ER"
        ],
        297: [
            "AW"
        ],
        298: [
            "FO"
        ],
        299: [
            "GL"
        ],
        350: [
            "GI"
        ],
        351: [
            "PT"
        ],
        352: [
            "LU"
        ],
        353: [
            "IE"
        ],
        354: [
            "IS"
        ],
        355: [
            "AL"
        ],
        356: [
            "MT"
        ],
        357: [
            "CY"
        ],
        358: [
            "FI",
            "AX"
        ],
        359: [
            "BG"
        ],
        370: [
            "LT"
        ],
        371: [
            "LV"
        ],
        372: [
            "EE"
        ],
        373: [
            "MD"
        ],
        374: [
            "AM"
        ],
        375: [
            "BY"
        ],
        376: [
            "AD"
        ],
        377: [
            "MC"
        ],
        378: [
            "SM"
        ],
        380: [
            "UA"
        ],
        381: [
            "RS"
        ],
        382: [
            "ME"
        ],
        383: [
            "XK"
        ],
        385: [
            "HR"
        ],
        386: [
            "SI"
        ],
        387: [
            "BA"
        ],
        389: [
            "MK"
        ],
        420: [
            "CZ"
        ],
        421: [
            "SK"
        ],
        423: [
            "LI"
        ],
        500: [
            "FK"
        ],
        501: [
            "BZ"
        ],
        502: [
            "GT"
        ],
        503: [
            "SV"
        ],
        504: [
            "HN"
        ],
        505: [
            "NI"
        ],
        506: [
            "CR"
        ],
        507: [
            "PA"
        ],
        508: [
            "PM"
        ],
        509: [
            "HT"
        ],
        590: [
            "GP",
            "BL",
            "MF"
        ],
        591: [
            "BO"
        ],
        592: [
            "GY"
        ],
        593: [
            "EC"
        ],
        594: [
            "GF"
        ],
        595: [
            "PY"
        ],
        596: [
            "MQ"
        ],
        597: [
            "SR"
        ],
        598: [
            "UY"
        ],
        599: [
            "CW",
            "BQ"
        ],
        670: [
            "TL"
        ],
        672: [
            "NF"
        ],
        673: [
            "BN"
        ],
        674: [
            "NR"
        ],
        675: [
            "PG"
        ],
        676: [
            "TO"
        ],
        677: [
            "SB"
        ],
        678: [
            "VU"
        ],
        679: [
            "FJ"
        ],
        680: [
            "PW"
        ],
        681: [
            "WF"
        ],
        682: [
            "CK"
        ],
        683: [
            "NU"
        ],
        685: [
            "WS"
        ],
        686: [
            "KI"
        ],
        687: [
            "NC"
        ],
        688: [
            "TV"
        ],
        689: [
            "PF"
        ],
        690: [
            "TK"
        ],
        691: [
            "FM"
        ],
        692: [
            "MH"
        ],
        850: [
            "KP"
        ],
        852: [
            "HK"
        ],
        853: [
            "MO"
        ],
        855: [
            "KH"
        ],
        856: [
            "LA"
        ],
        880: [
            "BD"
        ],
        886: [
            "TW"
        ],
        960: [
            "MV"
        ],
        961: [
            "LB"
        ],
        962: [
            "JO"
        ],
        963: [
            "SY"
        ],
        964: [
            "IQ"
        ],
        965: [
            "KW"
        ],
        966: [
            "SA"
        ],
        967: [
            "YE"
        ],
        968: [
            "OM"
        ],
        970: [
            "PS"
        ],
        971: [
            "AE"
        ],
        972: [
            "IL"
        ],
        973: [
            "BH"
        ],
        974: [
            "QA"
        ],
        975: [
            "BT"
        ],
        976: [
            "MN"
        ],
        977: [
            "NP"
        ],
        992: [
            "TJ"
        ],
        993: [
            "TM"
        ],
        994: [
            "AZ"
        ],
        995: [
            "GE"
        ],
        996: [
            "KG"
        ],
        998: [
            "UZ"
        ]
    },
    countries: {
        AC: [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        AD: [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        AE: [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AF: [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AG: [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        AI: [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        AL: [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AM: [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AO: [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        AR: [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        AS: [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        AT: [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AU: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        AW: [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        AX: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        AZ: [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BA: [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BB: [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        BD: [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BE: [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BF: [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        BG: [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BH: [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        BI: [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        BJ: [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        BL: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        BM: [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        BN: [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        BO: [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        BQ: [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        BR: [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        BS: [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        BT: [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        BW: [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        BY: [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        BZ: [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CA: [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        CC: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CD: [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CF: [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        CG: [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        CH: [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CI: [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CK: [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        CL: [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        CM: [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        CN: [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        CO: [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        CR: [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        CU: [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CV: [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        CW: [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        CX: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CY: [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        CZ: [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        DE: [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        DJ: [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        DK: [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        DM: [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        DO: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        DZ: [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EC: [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        EE: [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        EG: [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EH: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        ER: [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ES: [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        ET: [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        FI: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        FJ: [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        FK: [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        FM: [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        FO: [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        FR: [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GA: [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        GB: [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        GD: [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        GE: [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GF: [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GG: [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        GH: [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GI: [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        GL: [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        GM: [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        GN: [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        GP: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        GQ: [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        GR: [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        GT: [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        GU: [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        GW: [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        GY: [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        HK: [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        HN: [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        HR: [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        HT: [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        HU: [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        ID: [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IE: [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IL: [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        IM: [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        IN: [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        IO: [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        IQ: [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IR: [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IS: [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        IT: [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        JE: [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        JM: [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        JO: [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        JP: [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        KE: [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KG: [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KH: [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        KI: [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        KM: [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        KN: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        KP: [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KR: [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        KW: [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        KY: [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        KZ: [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        LA: [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LB: [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        LC: [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        LI: [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        LK: [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LR: [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LS: [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        LT: [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        LU: [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        LV: [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        LY: [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MA: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        MC: [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MD: [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ME: [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MF: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        MG: [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        MH: [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        MK: [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ML: [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        MM: [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MN: [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MO: [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        MP: [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        MQ: [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MR: [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        MS: [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        MT: [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        MU: [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        MV: [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        MW: [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MX: [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        MY: [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MZ: [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NA: [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NC: [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        NE: [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        NF: [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        NG: [
            "234",
            "009",
            "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NI: [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        NL: [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NO: [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        NP: [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        NR: [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        NU: [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NZ: [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        OM: [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        PA: [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PE: [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        PF: [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PG: [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        PH: [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PK: [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        PL: [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PM: [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        PR: [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        PS: [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PT: [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        PW: [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        PY: [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        QA: [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        RE: [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        RO: [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        RS: [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        RU: [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        RW: [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SA: [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        SB: [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        SC: [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SD: [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SE: [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        SG: [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        SH: [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        SI: [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SJ: [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        SK: [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SL: [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        SM: [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        SN: [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        SO: [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        SR: [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        SS: [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ST: [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        SV: [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        SX: [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        SY: [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        SZ: [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        TA: [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        TC: [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        TD: [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        TG: [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        TH: [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        TJ: [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TK: [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        TL: [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TM: [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TN: [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        TO: [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        TR: [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        TT: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        TV: [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TW: [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        TZ: [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        UA: [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        UG: [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        US: [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        UY: [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        UZ: [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        VA: [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        VC: [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        VE: [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        VG: [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        VI: [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        VN: [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        VU: [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        WF: [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        WS: [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        XK: [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YE: [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YT: [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        ZA: [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZM: [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZW: [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    nonGeographic: {
        800: [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        808: [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        870: [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        878: [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        881: [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        882: [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        883: [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        888: [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        979: [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};
function $bb50b4d24b214940$var$Mn(t) {
    return typeof t == "object" && !Array.isArray(t) && t !== null;
}
const $bb50b4d24b214940$var$Rn = Object.keys, $bb50b4d24b214940$var$B = $bb50b4d24b214940$var$Tt.countries, $bb50b4d24b214940$var$_n = $bb50b4d24b214940$var$Rn($bb50b4d24b214940$var$B), $bb50b4d24b214940$var$Ln = "US";
function $bb50b4d24b214940$var$S(t, n) {
    const e = Array.isArray(t);
    return n ? e && t.length > 0 : e;
}
function $bb50b4d24b214940$var$kn(t, n) {
    return t.find((e)=>n.includes(e)) || null;
}
function $bb50b4d24b214940$var$tt(t) {
    var _B_t;
    return (_B_t = $bb50b4d24b214940$var$B[t]) === null || _B_t === void 0 ? void 0 : _B_t[0];
}
function $bb50b4d24b214940$var$Gn(t) {
    return t || $bb50b4d24b214940$var$Ln;
}
function $bb50b4d24b214940$var$Lt(t, n) {
    return [
        ...new Set(n.concat(t))
    ];
}
function $bb50b4d24b214940$var$Bn(t) {
    return t.flatMap((n)=>$bb50b4d24b214940$var$St[n]);
}
function $bb50b4d24b214940$var$Le(t, n) {
    return t.filter((e)=>n.includes(e));
}
function $bb50b4d24b214940$var$ke(t, n) {
    return $bb50b4d24b214940$var$S(n, !0) ? t.filter((e)=>!n.includes(e)) : t;
}
function $bb50b4d24b214940$var$jn(t, n) {
    const { onlyCountries: e, excludedCountries: r, continents: d, preferredCountries: i } = n;
    if ($bb50b4d24b214940$var$S(e, !0)) {
        const u = $bb50b4d24b214940$var$Le(t, e);
        return $bb50b4d24b214940$var$S(i, !0) ? $bb50b4d24b214940$var$Lt(u, i) : u;
    }
    const a = $bb50b4d24b214940$var$S(d, !0) ? $bb50b4d24b214940$var$Bn(d) : t, o = $bb50b4d24b214940$var$S(i, !0) ? $bb50b4d24b214940$var$Lt(a, i) : a;
    return $bb50b4d24b214940$var$S(r, !0) ? $bb50b4d24b214940$var$ke(o, r) : o;
}
function $bb50b4d24b214940$var$Ge(t, n) {
    return t.some((e)=>$bb50b4d24b214940$var$St[e].includes(n));
}
function $bb50b4d24b214940$var$Un(t, n) {
    return [
        ...t
    ].sort((e, r)=>{
        const d = n.of(e), i = n.of(r);
        return d.localeCompare(i);
    });
}
const $bb50b4d24b214940$var$Wn = "data:image/png;base64,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", $bb50b4d24b214940$var$kt = {
    AC: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 513 342'%3e%3cpath fill='%230052B4' d='M0 0h513v342H0z'/%3e%3cpath fill='white' d='M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z'/%3e%3cpath fill='%2329DBFF' d='M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9'/%3e%3cpath fill='white' d='M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4'/%3e%3cpath fill='%2329DBFF' d='M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53'/%3e%3cpath fill='white' d='M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1'/%3e%3cpath fill='%2329DBFF' d='M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5'/%3e%3cpath fill='%235CC85C' d='M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z'/%3e%3cellipse transform='rotate(-82.3 291.431 225.686)' fill='%23F7A226' cx='291.4' cy='225.7' rx='48.7' ry='15.7'/%3e%3cellipse transform='rotate(-68.099 303.087 164.67)' fill='%23DDC7AB' cx='303.1' cy='164.7' rx='11.7' ry='7.2'/%3e%3cellipse transform='rotate(-81.738 291.697 271.697)' fill='%23DDC7AB' cx='291.7' cy='271.7' rx='11.4' ry='3.3'/%3e%3cellipse transform='matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)' fill='%23DDC7AB' cx='299.6' cy='269.4' rx='3.3' ry='11'/%3e%3cellipse transform='rotate(-21.518 314.54 201.06)' fill='%23DDC7AB' cx='314.5' cy='201.1' rx='4.1' ry='13.7'/%3e%3cellipse transform='rotate(-21.518 317.511 178.077)' fill='%23DDC7AB' cx='317.5' cy='178.1' rx='13.7' ry='4.1'/%3e%3cellipse transform='rotate(-7.7 473.781 225.857)' fill='%23F7A226' cx='473.6' cy='225.9' rx='15.7' ry='48.7'/%3e%3cellipse transform='rotate(-21.901 462.057 164.866)' fill='%23DDC7AB' cx='462' cy='164.9' rx='7.2' ry='11.7'/%3e%3cellipse transform='rotate(-8.27 473.27 271.908)' fill='%23DDC7AB' cx='473.4' cy='271.9' rx='3.3' ry='11.4'/%3e%3cellipse transform='matrix(.05353 -.9986 .9986 .05353 171.34 719.998)' fill='%23DDC7AB' cx='465.5' cy='269.6' rx='11' ry='3.3'/%3e%3cellipse transform='rotate(-68.482 450.552 201.247)' fill='%23DDC7AB' cx='450.6' cy='201.2' rx='13.7' ry='4.1'/%3e%3cellipse transform='rotate(-68.482 447.58 178.265)' fill='%23DDC7AB' cx='447.6' cy='178.3' rx='4.1' ry='13.7'/%3e%3cpath fill='%23B0C6CC' d='M373.3 130.3L356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z'/%3e%3cpath fill='white' d='M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z'/%3e%3cpath fill='%23D80027' d='M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z'/%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath fill='%23D80027' d='M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6l-77.8-53.3h22.6l62.5 42.3v11z'/%3e%3c/svg%3e",
    TA: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 341.3'%3e%3cpath fill='%230052B4' d='M0 0h512v341.3H0z'/%3e%3cpath fill='white' d='M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z'/%3e%3cg fill='%23D80027'%3e%3cpath d='M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z'/%3e%3cpath d='M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z'/%3e%3c/g%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath d='M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z' fill='%23D80027'/%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath d='M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z' fill='%23D80027'/%3e%3cpath fill='%2329DBFF' d='M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z'/%3e%3cpath fill='white' d='M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9'/%3e%3cpath fill='%2329DBFF' d='M385.4 251.7l-22.9-43h45.8z'/%3e%3cpath fill='white' d='M385.4 165.8l-22.9 42.9h45.8z'/%3e%3cellipse fill='%23FFBE57' cx='474.8' cy='236.8' rx='16.8' ry='43.3'/%3e%3cellipse fill='%23FFBE57' cx='295.3' cy='236.8' rx='16.8' ry='43.3'/%3e%3cpath fill='white' d='M385.4 31.5l-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z'/%3e%3cellipse fill='%23A5A5A5' cx='386.3' cy='104.3' rx='34.3' ry='23.3'/%3e%3c/svg%3e"
}, $bb50b4d24b214940$var$Hn = (t)=>t === "TA" || t === "AC" ? ({
        TA: $bb50b4d24b214940$var$kt.TA,
        AC: $bb50b4d24b214940$var$kt.AC
    })[t] : `https://flagcdn.com/w40/${t.toLowerCase()}.webp`, $bb50b4d24b214940$var$Ft = "MuiTelInput-FlagImg", $bb50b4d24b214940$var$wt = ({ isoCode: t, countryName: n })=>({
        src: $bb50b4d24b214940$var$Hn(t),
        loading: "lazy",
        width: 26,
        alt: n,
        className: $bb50b4d24b214940$var$Ft
    }), $bb50b4d24b214940$var$Vn = (t, { countryName: n })=>/* @__PURE__ */ (0, $3pI8R.jsx)("img", {
        ...$bb50b4d24b214940$var$wt({
            isoCode: t,
            countryName: n
        })
    }), $bb50b4d24b214940$var$Zn = /* @__PURE__ */ (0, $3pI8R.jsx)("img", {
    src: $bb50b4d24b214940$var$Wn,
    loading: "lazy",
    width: 26,
    alt: "unknown",
    className: $bb50b4d24b214940$var$Ft
});
function $bb50b4d24b214940$var$G(...t) {}
function $bb50b4d24b214940$var$Be(t = $bb50b4d24b214940$var$q) {
    try {
        return new Intl.DisplayNames(t, {
            type: "region"
        });
    } catch (n) {
        return $bb50b4d24b214940$var$G(n), new Intl.DisplayNames($bb50b4d24b214940$var$q, {
            type: "region"
        });
    }
}
const $bb50b4d24b214940$var$Yn = {
    CallingCodeSplitted: (0, $e8m2I.default)((0, $81BVN.default))({
        borderRight: `1px solid ${(0, $2Hfls.default)[300]}`,
        paddingRight: 10,
        cursor: "default",
        pointerEvents: "none"
    })
}, $bb50b4d24b214940$var$yt = "MuiTelInput-IconButton", $bb50b4d24b214940$var$zn = ({ disableDropdown: t = !1, forceCallingCode: n = !1, langOfCountryName: e = $bb50b4d24b214940$var$q, isFlagsMenuOpened: r = !1, getFlagElement: d, unknownFlagElement: i, isoCode: a, ...o })=>{
    const u = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>$bb50b4d24b214940$var$Be(e), [
        e
    ]), l = /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$_e, {
        isoCode: a,
        children: a ? d(a, {
            countryName: u.of(a) || "",
            isSelected: !0,
            imgProps: $bb50b4d24b214940$var$wt({
                isoCode: a,
                countryName: u.of(a) || ""
            })
        }) : i
    });
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $3pI8R.Fragment), {
        children: [
            t ? /* @__PURE__ */ (0, $3pI8R.jsx)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
                tabIndex: -1,
                className: $bb50b4d24b214940$var$yt,
                role: "",
                disableRipple: !0,
                sx: {
                    pointerEvents: "none",
                    aspectRatio: "1 / 1"
                },
                component: "span",
                children: l
            }) : /* @__PURE__ */ (0, $3pI8R.jsx)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
                ...o,
                "aria-label": "Select country",
                className: $bb50b4d24b214940$var$yt,
                "aria-haspopup": "listbox",
                sx: {
                    aspectRatio: "1 / 1"
                },
                "aria-controls": r ? "select-country" : void 0,
                "aria-expanded": r ? "true" : "false",
                children: l
            }),
            n && a ? /* @__PURE__ */ (0, $3pI8R.jsxs)($bb50b4d24b214940$var$Yn.CallingCodeSplitted, {
                children: [
                    "+",
                    $bb50b4d24b214940$var$tt(a)
                ]
            }) : null
        ]
    });
}, $bb50b4d24b214940$var$Gt = {
    ListItemIcon: (0, $e8m2I.default)((0, $b8d8870a92540e83$export$2e2bcd8739ae039))({
        marginRight: "10px"
    }),
    ListItemText: (0, $e8m2I.default)((0, $f4c2a1be62dbd0c3$export$2e2bcd8739ae039))({
        marginRight: "10px"
    })
}, $bb50b4d24b214940$var$je = "MuiTelInput-MenuItem", $bb50b4d24b214940$var$Ue = "MuiTelInput-ListItemIcon-flag", $bb50b4d24b214940$var$We = "MuiTelInput-ListItemText-country", $bb50b4d24b214940$var$He = "MuiTelInput-Typography-calling-code", $bb50b4d24b214940$var$Xn = ({ isoCode: t, onSelectCountry: n, countryName: e, getFlagElement: r, ...d })=>{
    var _B_t;
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
        ...d,
        onClick: (a)=>{
            a.preventDefault(), n(t);
        },
        role: "option",
        "data-testid": `option-${t}`,
        className: $bb50b4d24b214940$var$je,
        children: [
            /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Gt.ListItemIcon, {
                className: $bb50b4d24b214940$var$Ue,
                children: /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$_e, {
                    isoCode: t,
                    children: r(t, {
                        countryName: e,
                        isSelected: !1,
                        imgProps: $bb50b4d24b214940$var$wt({
                            isoCode: t,
                            countryName: e
                        })
                    })
                })
            }),
            /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Gt.ListItemText, {
                className: $bb50b4d24b214940$var$We,
                children: e
            }),
            /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $81BVN.default), {
                variant: "body2",
                color: "text.secondary",
                className: $bb50b4d24b214940$var$He,
                children: [
                    "+",
                    (_B_t = $bb50b4d24b214940$var$B[t]) === null || _B_t === void 0 ? void 0 : _B_t[0]
                ]
            })
        ]
    });
}, $bb50b4d24b214940$var$Kn = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($bb50b4d24b214940$var$Xn), $bb50b4d24b214940$var$Qn = [], $bb50b4d24b214940$var$Jn = [], $bb50b4d24b214940$var$qn = [], $bb50b4d24b214940$var$tr = [], $bb50b4d24b214940$var$Ve = "MuiTelInput-Menu", $bb50b4d24b214940$var$er = ({ anchorEl: t, isoCode: n, onSelectCountry: e, excludedCountries: r = $bb50b4d24b214940$var$Qn, onlyCountries: d = $bb50b4d24b214940$var$Jn, langOfCountryName: i = $bb50b4d24b214940$var$q, continents: a = $bb50b4d24b214940$var$qn, preferredCountries: o = $bb50b4d24b214940$var$tr, className: u, getFlagElement: l, ...$ })=>{
    const c = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>$bb50b4d24b214940$var$Be(i), [
        i
    ]), f = $bb50b4d24b214940$var$Un($bb50b4d24b214940$var$_n, c), h = $bb50b4d24b214940$var$jn(f, {
        onlyCountries: d,
        excludedCountries: r,
        continents: a,
        preferredCountries: o
    });
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $99e7ab0961a065f0$export$2e2bcd8739ae039), {
        anchorEl: t,
        open: !!t,
        id: "select-country",
        className: `${$bb50b4d24b214940$var$Ve} ${u || ""}`,
        MenuListProps: {
            role: "listbox",
            "aria-activedescendant": n ? `country-${n}` : "",
            "aria-labelledby": "select-country"
        },
        ...$,
        children: h.map((g)=>/* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Kn, {
                onSelectCountry: e,
                isoCode: g,
                countryName: c.of(g) || "",
                selected: g === n,
                id: `country-${g}`,
                getFlagElement: l
            }, g))
    });
};
function $bb50b4d24b214940$var$nr(t) {
    const { length: n } = t.value;
    t.setSelectionRange(n, n);
}
function $bb50b4d24b214940$var$st(t, n) {
    typeof n == "function" ? n(t) : n && $bb50b4d24b214940$var$Mn(n) && "current" in n && (n.current = t);
}
function $bb50b4d24b214940$var$Ze(t, n) {
    return t.replace(n, "");
}
function $bb50b4d24b214940$var$rr(t) {
    const { defaultCountry: n, onlyCountries: e, excludedCountries: r, continents: d, forceCallingCode: i } = t;
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (e && r) {
            const a = $bb50b4d24b214940$var$kn(e, r);
            a && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have the country ${a} to be included in the 'onlyCountries' AND 'excludedCountries' props`);
        }
    }, [
        e,
        r
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && r && r.includes(n) && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have the 'defaultCountry' (${n}) prop excluded by the 'excludedCountries' prop`);
    }, [
        n,
        r
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && e && !e.includes(n) && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have a 'defaultCountry' prop (${n}) and a 'onlyCountries' prop but without included the 'defaultCountry' (${n})`);
    }, [
        n,
        e
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && d && d.length > 0 && (d.some((o)=>$bb50b4d24b214940$var$St[o].includes(n)) || $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have a 'defaultCountry' prop (${n}) and a 'continents' prop that are not contain the country (${n})`));
    }, [
        n,
        d
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        i && !n && $bb50b4d24b214940$var$G("[mui-tel-input] 'forceCallingCode' needs 'defaultCountry' defined. Will default to US.");
    }, [
        n,
        i
    ]);
}
function $bb50b4d24b214940$var$Ye(t, n) {
    var e = Array.prototype.slice.call(n);
    return e.push($bb50b4d24b214940$var$Tt), t.apply(this, e);
}
function $bb50b4d24b214940$var$pt(t) {
    "@babel/helpers - typeof";
    return $bb50b4d24b214940$var$pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
    } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, $bb50b4d24b214940$var$pt(t);
}
function $bb50b4d24b214940$var$Bt(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$dr(t, n, e) {
    return n && $bb50b4d24b214940$var$Bt(t.prototype, n), e && $bb50b4d24b214940$var$Bt(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function $bb50b4d24b214940$var$ir(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$ar(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), n && $bb50b4d24b214940$var$Z(t, n);
}
function $bb50b4d24b214940$var$or(t) {
    var n = $bb50b4d24b214940$var$Xe();
    return function() {
        var r = $bb50b4d24b214940$var$Y(t), d;
        if (n) {
            var i = $bb50b4d24b214940$var$Y(this).constructor;
            d = Reflect.construct(r, arguments, i);
        } else d = r.apply(this, arguments);
        return $bb50b4d24b214940$var$ur(this, d);
    };
}
function $bb50b4d24b214940$var$ur(t, n) {
    if (n && ($bb50b4d24b214940$var$pt(n) === "object" || typeof n == "function")) return n;
    if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bb50b4d24b214940$var$ze(t);
}
function $bb50b4d24b214940$var$ze(t) {
    if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function $bb50b4d24b214940$var$vt(t) {
    var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return $bb50b4d24b214940$var$vt = function(r) {
        if (r === null || !$bb50b4d24b214940$var$lr(r)) return r;
        if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof n < "u") {
            if (n.has(r)) return n.get(r);
            n.set(r, d);
        }
        function d() {
            return $bb50b4d24b214940$var$K(r, arguments, $bb50b4d24b214940$var$Y(this).constructor);
        }
        return d.prototype = Object.create(r.prototype, {
            constructor: {
                value: d,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $bb50b4d24b214940$var$Z(d, r);
    }, $bb50b4d24b214940$var$vt(t);
}
function $bb50b4d24b214940$var$K(t, n, e) {
    return $bb50b4d24b214940$var$Xe() ? $bb50b4d24b214940$var$K = Reflect.construct : $bb50b4d24b214940$var$K = function(d, i, a) {
        var o = [
            null
        ];
        o.push.apply(o, i);
        var u = Function.bind.apply(d, o), l = new u();
        return a && $bb50b4d24b214940$var$Z(l, a.prototype), l;
    }, $bb50b4d24b214940$var$K.apply(null, arguments);
}
function $bb50b4d24b214940$var$Xe() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (e) {
        return !1;
    }
}
function $bb50b4d24b214940$var$lr(t) {
    return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function $bb50b4d24b214940$var$Z(t, n) {
    return $bb50b4d24b214940$var$Z = Object.setPrototypeOf || function(r, d) {
        return r.__proto__ = d, r;
    }, $bb50b4d24b214940$var$Z(t, n);
}
function $bb50b4d24b214940$var$Y(t) {
    return $bb50b4d24b214940$var$Y = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, $bb50b4d24b214940$var$Y(t);
}
var $bb50b4d24b214940$var$E = /* @__PURE__ */ function(t) {
    $bb50b4d24b214940$var$ar(e, t);
    var n = $bb50b4d24b214940$var$or(e);
    function e(r) {
        var d;
        return $bb50b4d24b214940$var$ir(this, e), d = n.call(this, r), Object.setPrototypeOf($bb50b4d24b214940$var$ze(d), e.prototype), d.name = d.constructor.name, d;
    }
    return $bb50b4d24b214940$var$dr(e);
}(/* @__PURE__ */ $bb50b4d24b214940$var$vt(Error)), $bb50b4d24b214940$var$Dt = 2, $bb50b4d24b214940$var$$r = 17, $bb50b4d24b214940$var$sr = 3, $bb50b4d24b214940$var$N = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9", $bb50b4d24b214940$var$fr = "-\u2010-\u2015\u2212\u30FC\uFF0D", $bb50b4d24b214940$var$cr = "\uFF0F/", $bb50b4d24b214940$var$hr = "\uFF0E.", $bb50b4d24b214940$var$gr = " \xa0\xad\u200B\u2060\u3000", $bb50b4d24b214940$var$mr = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]", $bb50b4d24b214940$var$yr = "~\u2053\u223C\uFF5E", $bb50b4d24b214940$var$x = "".concat($bb50b4d24b214940$var$fr).concat($bb50b4d24b214940$var$cr).concat($bb50b4d24b214940$var$hr).concat($bb50b4d24b214940$var$gr).concat($bb50b4d24b214940$var$mr).concat($bb50b4d24b214940$var$yr), $bb50b4d24b214940$var$rt = "+\uFF0B";
function $bb50b4d24b214940$var$jt(t, n) {
    t = t.split("-"), n = n.split("-");
    for(var e = t[0].split("."), r = n[0].split("."), d = 0; d < 3; d++){
        var i = Number(e[d]), a = Number(r[d]);
        if (i > a) return 1;
        if (a > i) return -1;
        if (!isNaN(i) && isNaN(a)) return 1;
        if (isNaN(i) && !isNaN(a)) return -1;
    }
    return t[1] && n[1] ? t[1] > n[1] ? 1 : t[1] < n[1] ? -1 : 0 : !t[1] && n[1] ? 1 : t[1] && !n[1] ? -1 : 0;
}
var $bb50b4d24b214940$var$pr = {}.constructor;
function $bb50b4d24b214940$var$R(t) {
    return t != null && t.constructor === $bb50b4d24b214940$var$pr;
}
function $bb50b4d24b214940$var$Ct(t) {
    "@babel/helpers - typeof";
    return $bb50b4d24b214940$var$Ct = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
    } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, $bb50b4d24b214940$var$Ct(t);
}
function $bb50b4d24b214940$var$dt(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Ut(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$it(t, n, e) {
    return n && $bb50b4d24b214940$var$Ut(t.prototype, n), e && $bb50b4d24b214940$var$Ut(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$vr = "1.2.0", $bb50b4d24b214940$var$Cr = "1.7.35", $bb50b4d24b214940$var$Wt = " ext. ", $bb50b4d24b214940$var$Nr = /^\d+$/, $bb50b4d24b214940$var$v = /* @__PURE__ */ function() {
    function t(n) {
        $bb50b4d24b214940$var$dt(this, t), $bb50b4d24b214940$var$Ir(n), this.metadata = n, $bb50b4d24b214940$var$Ke.call(this, n);
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "getCountries",
            value: function() {
                return Object.keys(this.metadata.countries).filter(function(e) {
                    return e !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function(e) {
                return this.metadata.countries[e];
            }
        },
        {
            key: "nonGeographic",
            value: function() {
                if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function(e) {
                return this.getCountryMetadata(e) !== void 0;
            }
        },
        {
            key: "hasCallingCode",
            value: function(e) {
                if (this.getCountryCodesForCallingCode(e)) return !0;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[e]) return !0;
                } else {
                    var r = this.countryCallingCodes()[e];
                    if (r && r.length === 1 && r[0] === "001") return !0;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function(e) {
                return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
            }
        },
        {
            key: "country",
            value: function(e) {
                return this.selectNumberingPlan(e);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function(e, r) {
                if (e && $bb50b4d24b214940$var$Nr.test(e) && (r = e, e = null), e && e !== "001") {
                    if (!this.hasCountry(e)) throw new Error("Unknown country: ".concat(e));
                    this.numberingPlan = new $bb50b4d24b214940$var$Ht(this.getCountryMetadata(e), this);
                } else if (r) {
                    if (!this.hasCallingCode(r)) throw new Error("Unknown calling code: ".concat(r));
                    this.numberingPlan = new $bb50b4d24b214940$var$Ht(this.getNumberingPlanMetadata(r), this);
                } else this.numberingPlan = void 0;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function(e) {
                var r = this.countryCallingCodes()[e];
                if (r) return r.length === 1 && r[0].length === 3 ? void 0 : r;
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function(e) {
                var r = this.getCountryCodesForCallingCode(e);
                if (r) return r[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function(e) {
                var r = this.getCountryCodeForCallingCode(e);
                if (r) return this.getCountryMetadata(r);
                if (this.nonGeographic()) {
                    var d = this.nonGeographic()[e];
                    if (d) return d;
                } else {
                    var i = this.countryCallingCodes()[e];
                    if (i && i.length === 1 && i[0] === "001") return this.metadata.countries["001"];
                }
            }
        },
        {
            key: "countryCallingCode",
            value: function() {
                return this.numberingPlan.callingCode();
            }
        },
        {
            key: "IDDPrefix",
            value: function() {
                return this.numberingPlan.IDDPrefix();
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function() {
                return this.numberingPlan.defaultIDDPrefix();
            }
        },
        {
            key: "nationalNumberPattern",
            value: function() {
                return this.numberingPlan.nationalNumberPattern();
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                return this.numberingPlan.possibleLengths();
            }
        },
        {
            key: "formats",
            value: function() {
                return this.numberingPlan.formats();
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function() {
                return this.numberingPlan.nationalPrefixForParsing();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function() {
                return this.numberingPlan.nationalPrefixTransformRule();
            }
        },
        {
            key: "leadingDigits",
            value: function() {
                return this.numberingPlan.leadingDigits();
            }
        },
        {
            key: "hasTypes",
            value: function() {
                return this.numberingPlan.hasTypes();
            }
        },
        {
            key: "type",
            value: function(e) {
                return this.numberingPlan.type(e);
            }
        },
        {
            key: "ext",
            value: function() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function() {
                return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
            }
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function(e) {
                return this.selectNumberingPlan(e);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function() {
                return this.numberingPlan !== void 0;
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$Ht = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this.globalMetadataObject = e, this.metadata = n, $bb50b4d24b214940$var$Ke.call(this, e.metadata);
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "callingCode",
            value: function() {
                return this.metadata[0];
            }
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            }
        },
        {
            key: "IDDPrefix",
            value: function() {
                if (!(this.v1 || this.v2)) return this.metadata[1];
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function() {
                if (!(this.v1 || this.v2)) return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function() {
                return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function(e) {
                return e[this.v1 ? 2 : this.v2 ? 3 : 4];
            }
        },
        {
            key: "formats",
            value: function() {
                var e = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return r.map(function(d) {
                    return new $bb50b4d24b214940$var$br(d, e);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function(e) {
                return e[this.v1 ? 4 : this.v2 ? 5 : 6];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function() {
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function() {
                return this.types() && this.types().length === 0 ? !1 : !!this.types();
            }
        },
        {
            key: "type",
            value: function(e) {
                if (this.hasTypes() && $bb50b4d24b214940$var$Vt(this.types(), e)) return new $bb50b4d24b214940$var$Ar($bb50b4d24b214940$var$Vt(this.types(), e), this);
            }
        },
        {
            key: "ext",
            value: function() {
                return this.v1 || this.v2 ? $bb50b4d24b214940$var$Wt : this.metadata[13] || $bb50b4d24b214940$var$Wt;
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$br = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this._format = n, this.metadata = e;
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "pattern",
            value: function() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function() {
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "usesNationalPrefix",
            value: function() {
                return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$bb50b4d24b214940$var$Pr.test(this.nationalPrefixFormattingRule()));
            }
        },
        {
            key: "internationalFormat",
            value: function() {
                return this._format[5] || this.format();
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$Pr = /^\(?\$1\)?$/, $bb50b4d24b214940$var$Ar = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this.type = n, this.metadata = e;
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "pattern",
            value: function() {
                return this.metadata.v1 ? this.type : this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Vt(t, n) {
    switch(n){
        case "FIXED_LINE":
            return t[0];
        case "MOBILE":
            return t[1];
        case "TOLL_FREE":
            return t[2];
        case "PREMIUM_RATE":
            return t[3];
        case "PERSONAL_NUMBER":
            return t[4];
        case "VOICEMAIL":
            return t[5];
        case "UAN":
            return t[6];
        case "PAGER":
            return t[7];
        case "VOIP":
            return t[8];
        case "SHARED_COST":
            return t[9];
    }
}
function $bb50b4d24b214940$var$Ir(t) {
    if (!t) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
    if (!$bb50b4d24b214940$var$R(t) || !$bb50b4d24b214940$var$R(t.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($bb50b4d24b214940$var$R(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + $bb50b4d24b214940$var$xr(t) + ": " + t, "."));
}
var $bb50b4d24b214940$var$xr = function(n) {
    return $bb50b4d24b214940$var$Ct(n);
};
function $bb50b4d24b214940$var$Mt(t, n) {
    if (n = new $bb50b4d24b214940$var$v(n), n.hasCountry(t)) return n.country(t).countryCallingCode();
    throw new Error("Unknown country: ".concat(t));
}
function $bb50b4d24b214940$var$Or(t, n) {
    return n.countries.hasOwnProperty(t);
}
function $bb50b4d24b214940$var$Ke(t) {
    var n = t.version;
    typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? $bb50b4d24b214940$var$jt(n, $bb50b4d24b214940$var$vr) === -1 ? this.v2 = !0 : $bb50b4d24b214940$var$jt(n, $bb50b4d24b214940$var$Cr) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var $bb50b4d24b214940$var$Er = ";ext=", $bb50b4d24b214940$var$k = function(n) {
    return "([".concat($bb50b4d24b214940$var$N, "]{1,").concat(n, "})");
};
function $bb50b4d24b214940$var$Qe(t) {
    var n = "20", e = "15", r = "9", d = "6", i = "[ \xa0\\t,]*", a = "[:\\.\uFF0E]?[ \xa0\\t,-]*", o = "#?", u = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)", l = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)", $ = "[- ]+", c = "[ \xa0\\t]*", f = "(?:,{2}|;)", h = $bb50b4d24b214940$var$Er + $bb50b4d24b214940$var$k(n), g = i + u + a + $bb50b4d24b214940$var$k(n) + o, b = i + l + a + $bb50b4d24b214940$var$k(r) + o, p = $ + $bb50b4d24b214940$var$k(d) + "#", D = c + f + a + $bb50b4d24b214940$var$k(e) + o, j = c + "(?:,)+" + a + $bb50b4d24b214940$var$k(r) + o;
    return h + "|" + g + "|" + b + "|" + p + "|" + D + "|" + j;
}
var $bb50b4d24b214940$var$Sr = "[" + $bb50b4d24b214940$var$N + "]{" + $bb50b4d24b214940$var$Dt + "}", $bb50b4d24b214940$var$Tr = "[" + $bb50b4d24b214940$var$rt + "]{0,1}(?:[" + $bb50b4d24b214940$var$x + "]*[" + $bb50b4d24b214940$var$N + "]){3,}[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]*", $bb50b4d24b214940$var$Fr = new RegExp("^[" + $bb50b4d24b214940$var$rt + "]{0,1}(?:[" + $bb50b4d24b214940$var$x + "]*[" + $bb50b4d24b214940$var$N + "]){1,2}$", "i"), $bb50b4d24b214940$var$wr = $bb50b4d24b214940$var$Tr + // Phone number extensions
"(?:" + $bb50b4d24b214940$var$Qe() + ")?", $bb50b4d24b214940$var$Dr = new RegExp(// Either a short two-digit-only phone number
"^" + $bb50b4d24b214940$var$Sr + "$|^" + $bb50b4d24b214940$var$wr + "$", "i");
function $bb50b4d24b214940$var$Nt(t) {
    return t.length >= $bb50b4d24b214940$var$Dt && $bb50b4d24b214940$var$Dr.test(t);
}
function $bb50b4d24b214940$var$Mr(t) {
    return $bb50b4d24b214940$var$Fr.test(t);
}
var $bb50b4d24b214940$var$Zt = new RegExp("(?:" + $bb50b4d24b214940$var$Qe() + ")$", "i");
function $bb50b4d24b214940$var$Rr(t) {
    var n = t.search($bb50b4d24b214940$var$Zt);
    if (n < 0) return {};
    for(var e = t.slice(0, n), r = t.match($bb50b4d24b214940$var$Zt), d = 1; d < r.length;){
        if (r[d]) return {
            number: e,
            ext: r[d]
        };
        d++;
    }
}
function $bb50b4d24b214940$var$_r(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Lr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Lr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Yt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Yt(t, n);
    }
}
function $bb50b4d24b214940$var$Yt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$kr = {
    0: "0",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9"
};
function $bb50b4d24b214940$var$Je(t) {
    return $bb50b4d24b214940$var$kr[t];
}
function $bb50b4d24b214940$var$et(t) {
    for(var n = "", e = $bb50b4d24b214940$var$_r(t.split("")), r; !(r = e()).done;){
        var d = r.value, i = $bb50b4d24b214940$var$Je(d);
        i && (n += i);
    }
    return n;
}
function $bb50b4d24b214940$var$Gr(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Br(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Br(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$zt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$zt(t, n);
    }
}
function $bb50b4d24b214940$var$zt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Xt(t) {
    for(var n = "", e = $bb50b4d24b214940$var$Gr(t.split("")), r; !(r = e()).done;){
        var d = r.value;
        n += $bb50b4d24b214940$var$jr(d, n) || "";
    }
    return n;
}
function $bb50b4d24b214940$var$jr(t, n, e) {
    if (t === "+") {
        if (n) {
            typeof e == "function" && e("end");
            return;
        }
        return "+";
    }
    return $bb50b4d24b214940$var$Je(t);
}
function $bb50b4d24b214940$var$Ur(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Wr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Wr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Kt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Kt(t, n);
    }
}
function $bb50b4d24b214940$var$Kt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Hr(t, n) {
    for(var e = t.slice(), r = $bb50b4d24b214940$var$Ur(n), d; !(d = r()).done;){
        var i = d.value;
        t.indexOf(i) < 0 && e.push(i);
    }
    return e.sort(function(a, o) {
        return a - o;
    });
}
function $bb50b4d24b214940$var$at(t, n) {
    return $bb50b4d24b214940$var$qe(t, void 0, n);
}
function $bb50b4d24b214940$var$qe(t, n, e) {
    var r = e.type(n), d = r && r.possibleLengths() || e.possibleLengths();
    if (!d) return "IS_POSSIBLE";
    if (n === "FIXED_LINE_OR_MOBILE") {
        if (!e.type("FIXED_LINE")) return $bb50b4d24b214940$var$qe(t, "MOBILE", e);
        var i = e.type("MOBILE");
        i && (d = $bb50b4d24b214940$var$Hr(d, i.possibleLengths()));
    } else if (n && !r) return "INVALID_LENGTH";
    var a = t.length, o = d[0];
    return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : d[d.length - 1] < a ? "TOO_LONG" : d.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function $bb50b4d24b214940$var$Vr(t, n, e) {
    if (n === void 0 && (n = {}), e = new $bb50b4d24b214940$var$v(e), n.v2) {
        if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
        e.selectNumberingPlan(t.countryCallingCode);
    } else {
        if (!t.phone) return !1;
        if (t.country) {
            if (!e.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
            e.country(t.country);
        } else {
            if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
            e.selectNumberingPlan(t.countryCallingCode);
        }
    }
    if (e.possibleLengths()) return $bb50b4d24b214940$var$tn(t.phone || t.nationalNumber, e);
    if (t.countryCallingCode && e.isNonGeographicCallingCode(t.countryCallingCode)) return !0;
    throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function $bb50b4d24b214940$var$tn(t, n) {
    switch($bb50b4d24b214940$var$at(t, n)){
        case "IS_POSSIBLE":
            return !0;
        default:
            return !1;
    }
}
function $bb50b4d24b214940$var$T(t, n) {
    return t = t || "", new RegExp("^(?:" + n + ")$").test(t);
}
function $bb50b4d24b214940$var$Zr(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Yr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Yr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Qt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Qt(t, n);
    }
}
function $bb50b4d24b214940$var$Qt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$zr = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
];
function $bb50b4d24b214940$var$ot(t, n, e) {
    if (n = n || {}, !(!t.country && !t.countryCallingCode)) {
        e = new $bb50b4d24b214940$var$v(e), e.selectNumberingPlan(t.country, t.countryCallingCode);
        var r = n.v2 ? t.nationalNumber : t.phone;
        if ($bb50b4d24b214940$var$T(r, e.nationalNumberPattern())) {
            if ($bb50b4d24b214940$var$ft(r, "FIXED_LINE", e)) return e.type("MOBILE") && e.type("MOBILE").pattern() === "" || !e.type("MOBILE") || $bb50b4d24b214940$var$ft(r, "MOBILE", e) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
            for(var d = $bb50b4d24b214940$var$Zr($bb50b4d24b214940$var$zr), i; !(i = d()).done;){
                var a = i.value;
                if ($bb50b4d24b214940$var$ft(r, a, e)) return a;
            }
        }
    }
}
function $bb50b4d24b214940$var$ft(t, n, e) {
    return n = e.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(t.length) < 0 ? !1 : $bb50b4d24b214940$var$T(t, n.pattern());
}
function $bb50b4d24b214940$var$Xr(t, n, e) {
    if (n = n || {}, e = new $bb50b4d24b214940$var$v(e), e.selectNumberingPlan(t.country, t.countryCallingCode), e.hasTypes()) return $bb50b4d24b214940$var$ot(t, n, e.metadata) !== void 0;
    var r = n.v2 ? t.nationalNumber : t.phone;
    return $bb50b4d24b214940$var$T(r, e.nationalNumberPattern());
}
function $bb50b4d24b214940$var$Kr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e), d = r.getCountryCodesForCallingCode(t);
    return d ? d.filter(function(i) {
        return $bb50b4d24b214940$var$Qr(n, i, e);
    }) : [];
}
function $bb50b4d24b214940$var$Qr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e);
    return r.selectNumberingPlan(n), r.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
function $bb50b4d24b214940$var$en(t) {
    return t.replace(new RegExp("[".concat($bb50b4d24b214940$var$x, "]+"), "g"), " ").trim();
}
var $bb50b4d24b214940$var$nn = /(\$\d)/;
function $bb50b4d24b214940$var$rn(t, n, e) {
    var r = e.useInternationalFormat, d = e.withNationalPrefix;
    e.carrierCode, e.metadata;
    var i = t.replace(new RegExp(n.pattern()), r ? n.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    d && n.nationalPrefixFormattingRule() ? n.format().replace($bb50b4d24b214940$var$nn, n.nationalPrefixFormattingRule()) : n.format());
    return r ? $bb50b4d24b214940$var$en(i) : i;
}
var $bb50b4d24b214940$var$Jr = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function $bb50b4d24b214940$var$qr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e);
    if (r.selectNumberingPlan(t, n), r.defaultIDDPrefix()) return r.defaultIDDPrefix();
    if ($bb50b4d24b214940$var$Jr.test(r.IDDPrefix())) return r.IDDPrefix();
}
function $bb50b4d24b214940$var$td(t) {
    var n = t.number, e = t.ext;
    if (!n) return "";
    if (n[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(n).concat(e ? ";ext=" + e : "");
}
function $bb50b4d24b214940$var$ed(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$nd(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$nd(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Jt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Jt(t, n);
    }
}
function $bb50b4d24b214940$var$Jt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$qt(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$te(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$qt(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$rd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$qt(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$rd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
var $bb50b4d24b214940$var$ee = {
    formatExtension: function(n, e, r) {
        return "".concat(n).concat(r.ext()).concat(e);
    }
};
function $bb50b4d24b214940$var$dd(t, n, e, r) {
    if (e ? e = $bb50b4d24b214940$var$te($bb50b4d24b214940$var$te({}, $bb50b4d24b214940$var$ee), e) : e = $bb50b4d24b214940$var$ee, r = new $bb50b4d24b214940$var$v(r), t.country && t.country !== "001") {
        if (!r.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
        r.country(t.country);
    } else if (t.countryCallingCode) r.selectNumberingPlan(t.countryCallingCode);
    else return t.phone || "";
    var d = r.countryCallingCode(), i = e.v2 ? t.nationalNumber : t.phone, a;
    switch(n){
        case "NATIONAL":
            return i ? (a = $bb50b4d24b214940$var$nt(i, t.carrierCode, "NATIONAL", r, e), $bb50b4d24b214940$var$ct(a, t.ext, r, e.formatExtension)) : "";
        case "INTERNATIONAL":
            return i ? (a = $bb50b4d24b214940$var$nt(i, null, "INTERNATIONAL", r, e), a = "+".concat(d, " ").concat(a), $bb50b4d24b214940$var$ct(a, t.ext, r, e.formatExtension)) : "+".concat(d);
        case "E.164":
            return "+".concat(d).concat(i);
        case "RFC3966":
            return $bb50b4d24b214940$var$td({
                number: "+".concat(d).concat(i),
                ext: t.ext
            });
        case "IDD":
            if (!e.fromCountry) return;
            var o = $bb50b4d24b214940$var$ad(i, t.carrierCode, d, e.fromCountry, r);
            return $bb50b4d24b214940$var$ct(o, t.ext, r, e.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
    }
}
function $bb50b4d24b214940$var$nt(t, n, e, r, d) {
    var i = $bb50b4d24b214940$var$id(r.formats(), t);
    return i ? $bb50b4d24b214940$var$rn(t, i, {
        useInternationalFormat: e === "INTERNATIONAL",
        withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && d && d.nationalPrefix === !1),
        carrierCode: n,
        metadata: r
    }) : t;
}
function $bb50b4d24b214940$var$id(t, n) {
    for(var e = $bb50b4d24b214940$var$ed(t), r; !(r = e()).done;){
        var d = r.value;
        if (d.leadingDigitsPatterns().length > 0) {
            var i = d.leadingDigitsPatterns()[d.leadingDigitsPatterns().length - 1];
            if (n.search(i) !== 0) continue;
        }
        if ($bb50b4d24b214940$var$T(n, d.pattern())) return d;
    }
}
function $bb50b4d24b214940$var$ct(t, n, e, r) {
    return n ? r(t, n, e) : t;
}
function $bb50b4d24b214940$var$ad(t, n, e, r, d) {
    var i = $bb50b4d24b214940$var$Mt(r, d.metadata);
    if (i === e) {
        var a = $bb50b4d24b214940$var$nt(t, n, "NATIONAL", d);
        return e === "1" ? e + " " + a : a;
    }
    var o = $bb50b4d24b214940$var$qr(r, void 0, d.metadata);
    if (o) return "".concat(o, " ").concat(e, " ").concat($bb50b4d24b214940$var$nt(t, null, "INTERNATIONAL", d));
}
function $bb50b4d24b214940$var$ne(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$re(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$ne(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$od(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$ne(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$od(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$ud(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$de(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$ld(t, n, e) {
    return n && $bb50b4d24b214940$var$de(t.prototype, n), e && $bb50b4d24b214940$var$de(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$dn = /* @__PURE__ */ function() {
    function t(n, e, r) {
        if ($bb50b4d24b214940$var$ud(this, t), !n) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!e) throw new TypeError("`nationalNumber` not passed");
        if (!r) throw new TypeError("`metadata` not passed");
        var d = $bb50b4d24b214940$var$sd(n, r), i = d.country, a = d.countryCallingCode;
        this.country = i, this.countryCallingCode = a, this.nationalNumber = e, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
            return r;
        };
    }
    return $bb50b4d24b214940$var$ld(t, [
        {
            key: "setExt",
            value: function(e) {
                this.ext = e;
            }
        },
        {
            key: "getPossibleCountries",
            value: function() {
                return this.country ? [
                    this.country
                ] : $bb50b4d24b214940$var$Kr(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function() {
                return $bb50b4d24b214940$var$Vr(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function() {
                return $bb50b4d24b214940$var$Xr(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function() {
                var e = new $bb50b4d24b214940$var$v(this.getMetadata());
                return e.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function(e) {
                return this.number === e.number && this.ext === e.ext;
            }
        },
        {
            key: "getType",
            value: function() {
                return $bb50b4d24b214940$var$ot(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function(e, r) {
                return $bb50b4d24b214940$var$dd(this, e, r ? $bb50b4d24b214940$var$re($bb50b4d24b214940$var$re({}, r), {}, {
                    v2: !0
                }) : {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function(e) {
                return this.format("NATIONAL", e);
            }
        },
        {
            key: "formatInternational",
            value: function(e) {
                return this.format("INTERNATIONAL", e);
            }
        },
        {
            key: "getURI",
            value: function(e) {
                return this.format("RFC3966", e);
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$$d = function(n) {
    return /^[A-Z]{2}$/.test(n);
};
function $bb50b4d24b214940$var$sd(t, n) {
    var e, r, d = new $bb50b4d24b214940$var$v(n);
    return $bb50b4d24b214940$var$$d(t) ? (e = t, d.selectNumberingPlan(e), r = d.countryCallingCode()) : r = t, {
        country: e,
        countryCallingCode: r
    };
}
var $bb50b4d24b214940$var$fd = new RegExp("([" + $bb50b4d24b214940$var$N + "])");
function $bb50b4d24b214940$var$an(t, n, e, r) {
    if (n) {
        var d = new $bb50b4d24b214940$var$v(r);
        d.selectNumberingPlan(n, e);
        var i = new RegExp(d.IDDPrefix());
        if (t.search(i) === 0) {
            t = t.slice(t.match(i)[0].length);
            var a = t.match($bb50b4d24b214940$var$fd);
            if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0")) return t;
        }
    }
}
function $bb50b4d24b214940$var$bt(t, n) {
    if (t && n.numberingPlan.nationalPrefixForParsing()) {
        var e = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), r = e.exec(t);
        if (r) {
            var d, i, a = r.length - 1, o = a > 0 && r[a];
            if (n.nationalPrefixTransformRule() && o) d = t.replace(e, n.nationalPrefixTransformRule()), a > 1 && (i = r[1]);
            else {
                var u = r[0];
                d = t.slice(u.length), o && (i = r[1]);
            }
            var l;
            if (o) {
                var $ = t.indexOf(r[1]), c = t.slice(0, $);
                c === n.numberingPlan.nationalPrefix() && (l = n.numberingPlan.nationalPrefix());
            } else l = r[0];
            return {
                nationalNumber: d,
                nationalPrefix: l,
                carrierCode: i
            };
        }
    }
    return {
        nationalNumber: t
    };
}
function $bb50b4d24b214940$var$Pt(t, n) {
    var e = $bb50b4d24b214940$var$bt(t, n), r = e.carrierCode, d = e.nationalNumber;
    if (d !== t) {
        if (!$bb50b4d24b214940$var$cd(t, d, n)) return {
            nationalNumber: t
        };
        if (n.possibleLengths() && !$bb50b4d24b214940$var$hd(d, n)) return {
            nationalNumber: t
        };
    }
    return {
        nationalNumber: d,
        carrierCode: r
    };
}
function $bb50b4d24b214940$var$cd(t, n, e) {
    return !($bb50b4d24b214940$var$T(t, e.nationalNumberPattern()) && !$bb50b4d24b214940$var$T(n, e.nationalNumberPattern()));
}
function $bb50b4d24b214940$var$hd(t, n) {
    switch($bb50b4d24b214940$var$at(t, n)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            return !1;
        default:
            return !0;
    }
}
function $bb50b4d24b214940$var$on(t, n, e, r) {
    var d = n ? $bb50b4d24b214940$var$Mt(n, r) : e;
    if (t.indexOf(d) === 0) {
        r = new $bb50b4d24b214940$var$v(r), r.selectNumberingPlan(n, e);
        var i = t.slice(d.length), a = $bb50b4d24b214940$var$Pt(i, r), o = a.nationalNumber, u = $bb50b4d24b214940$var$Pt(t, r), l = u.nationalNumber;
        if (!$bb50b4d24b214940$var$T(l, r.nationalNumberPattern()) && $bb50b4d24b214940$var$T(o, r.nationalNumberPattern()) || $bb50b4d24b214940$var$at(l, r) === "TOO_LONG") return {
            countryCallingCode: d,
            number: i
        };
    }
    return {
        number: t
    };
}
function $bb50b4d24b214940$var$un(t, n, e, r) {
    if (!t) return {};
    var d;
    if (t[0] !== "+") {
        var i = $bb50b4d24b214940$var$an(t, n, e, r);
        if (i && i !== t) d = !0, t = "+" + i;
        else {
            if (n || e) {
                var a = $bb50b4d24b214940$var$on(t, n, e, r), o = a.countryCallingCode, u = a.number;
                if (o) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: o,
                    number: u
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: t
            };
        }
    }
    if (t[1] === "0") return {};
    r = new $bb50b4d24b214940$var$v(r);
    for(var l = 2; l - 1 <= $bb50b4d24b214940$var$sr && l <= t.length;){
        var $ = t.slice(1, l);
        if (r.hasCallingCode($)) return r.selectNumberingPlan($), {
            countryCallingCodeSource: d ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
            countryCallingCode: $,
            number: t.slice(l)
        };
        l++;
    }
    return {};
}
function $bb50b4d24b214940$var$gd(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$md(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$md(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$ie(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$ie(t, n);
    }
}
function $bb50b4d24b214940$var$ie(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$ln(t, n) {
    var e = n.countries, r = n.defaultCountry, d = n.metadata;
    d = new $bb50b4d24b214940$var$v(d);
    for(var i = [], a = $bb50b4d24b214940$var$gd(e), o; !(o = a()).done;){
        var u = o.value;
        if (d.country(u), d.leadingDigits()) {
            if (t && t.search(d.leadingDigits()) === 0) return u;
        } else if ($bb50b4d24b214940$var$ot({
            phone: t,
            country: u
        }, void 0, d.metadata)) {
            if (r) {
                if (u === r) return u;
                i.push(u);
            } else return u;
        }
    }
    if (i.length > 0) return i[0];
}
var $bb50b4d24b214940$var$yd = !1;
function $bb50b4d24b214940$var$$n(t, n) {
    var e = n.nationalNumber, r = n.defaultCountry, d = n.metadata;
    if ($bb50b4d24b214940$var$yd && d.isNonGeographicCallingCode(t)) return "001";
    var i = d.getCountryCodesForCallingCode(t);
    if (i) return i.length === 1 ? i[0] : $bb50b4d24b214940$var$ln(e, {
        countries: i,
        defaultCountry: r,
        metadata: d.metadata
    });
}
var $bb50b4d24b214940$var$sn = "+", $bb50b4d24b214940$var$pd = "[\\-\\.\\(\\)]?", $bb50b4d24b214940$var$ae = "([" + $bb50b4d24b214940$var$N + "]|" + $bb50b4d24b214940$var$pd + ")", $bb50b4d24b214940$var$vd = "^\\" + $bb50b4d24b214940$var$sn + $bb50b4d24b214940$var$ae + "*[" + $bb50b4d24b214940$var$N + "]" + $bb50b4d24b214940$var$ae + "*$", $bb50b4d24b214940$var$Cd = new RegExp($bb50b4d24b214940$var$vd, "g"), $bb50b4d24b214940$var$At = $bb50b4d24b214940$var$N, $bb50b4d24b214940$var$Nd = "[" + $bb50b4d24b214940$var$At + "]+((\\-)*[" + $bb50b4d24b214940$var$At + "])*", $bb50b4d24b214940$var$bd = "a-zA-Z", $bb50b4d24b214940$var$Pd = "[" + $bb50b4d24b214940$var$bd + "]+((\\-)*[" + $bb50b4d24b214940$var$At + "])*", $bb50b4d24b214940$var$Ad = "^(" + $bb50b4d24b214940$var$Nd + "\\.)*" + $bb50b4d24b214940$var$Pd + "\\.?$", $bb50b4d24b214940$var$Id = new RegExp($bb50b4d24b214940$var$Ad, "g"), $bb50b4d24b214940$var$oe = "tel:", $bb50b4d24b214940$var$It = ";phone-context=", $bb50b4d24b214940$var$xd = ";isub=";
function $bb50b4d24b214940$var$Od(t) {
    var n = t.indexOf($bb50b4d24b214940$var$It);
    if (n < 0) return null;
    var e = n + $bb50b4d24b214940$var$It.length;
    if (e >= t.length) return "";
    var r = t.indexOf(";", e);
    return r >= 0 ? t.substring(e, r) : t.substring(e);
}
function $bb50b4d24b214940$var$Ed(t) {
    return t === null ? !0 : t.length === 0 ? !1 : $bb50b4d24b214940$var$Cd.test(t) || $bb50b4d24b214940$var$Id.test(t);
}
function $bb50b4d24b214940$var$Sd(t, n) {
    var e = n.extractFormattedPhoneNumber, r = $bb50b4d24b214940$var$Od(t);
    if (!$bb50b4d24b214940$var$Ed(r)) throw new $bb50b4d24b214940$var$E("NOT_A_NUMBER");
    var d;
    if (r === null) d = e(t) || "";
    else {
        d = "", r.charAt(0) === $bb50b4d24b214940$var$sn && (d += r);
        var i = t.indexOf($bb50b4d24b214940$var$oe), a;
        i >= 0 ? a = i + $bb50b4d24b214940$var$oe.length : a = 0;
        var o = t.indexOf($bb50b4d24b214940$var$It);
        d += t.substring(a, o);
    }
    var u = d.indexOf($bb50b4d24b214940$var$xd);
    if (u > 0 && (d = d.substring(0, u)), d !== "") return d;
}
var $bb50b4d24b214940$var$Td = 250, $bb50b4d24b214940$var$Fd = new RegExp("[" + $bb50b4d24b214940$var$rt + $bb50b4d24b214940$var$N + "]"), $bb50b4d24b214940$var$wd = new RegExp("[^" + $bb50b4d24b214940$var$N + "#]+$");
function $bb50b4d24b214940$var$xt(t, n, e) {
    if (n = n || {}, e = new $bb50b4d24b214940$var$v(e), n.defaultCountry && !e.hasCountry(n.defaultCountry)) throw n.v2 ? new $bb50b4d24b214940$var$E("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
    var r = $bb50b4d24b214940$var$Md(t, n.v2, n.extract), d = r.number, i = r.ext, a = r.error;
    if (!d) {
        if (n.v2) throw a === "TOO_SHORT" ? new $bb50b4d24b214940$var$E("TOO_SHORT") : new $bb50b4d24b214940$var$E("NOT_A_NUMBER");
        return {};
    }
    var o = $bb50b4d24b214940$var$_d(d, n.defaultCountry, n.defaultCallingCode, e), u = o.country, l = o.nationalNumber, $ = o.countryCallingCode, c = o.countryCallingCodeSource, f = o.carrierCode;
    if (!e.hasSelectedNumberingPlan()) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("INVALID_COUNTRY");
        return {};
    }
    if (!l || l.length < $bb50b4d24b214940$var$Dt) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("TOO_SHORT");
        return {};
    }
    if (l.length > $bb50b4d24b214940$var$$r) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("TOO_LONG");
        return {};
    }
    if (n.v2) {
        var h = new $bb50b4d24b214940$var$dn($, l, e.metadata);
        return u && (h.country = u), f && (h.carrierCode = f), i && (h.ext = i), h.__countryCallingCodeSource = c, h;
    }
    var g = (n.extended ? e.hasSelectedNumberingPlan() : u) ? $bb50b4d24b214940$var$T(l, e.nationalNumberPattern()) : !1;
    return n.extended ? {
        country: u,
        countryCallingCode: $,
        carrierCode: f,
        valid: g,
        possible: g ? !0 : !!(n.extended === !0 && e.possibleLengths() && $bb50b4d24b214940$var$tn(l, e)),
        phone: l,
        ext: i
    } : g ? $bb50b4d24b214940$var$Rd(u, l, i) : {};
}
function $bb50b4d24b214940$var$Dd(t, n, e) {
    if (t) {
        if (t.length > $bb50b4d24b214940$var$Td) {
            if (e) throw new $bb50b4d24b214940$var$E("TOO_LONG");
            return;
        }
        if (n === !1) return t;
        var r = t.search($bb50b4d24b214940$var$Fd);
        if (!(r < 0)) return t.slice(r).replace($bb50b4d24b214940$var$wd, "");
    }
}
function $bb50b4d24b214940$var$Md(t, n, e) {
    var r = $bb50b4d24b214940$var$Sd(t, {
        extractFormattedPhoneNumber: function(a) {
            return $bb50b4d24b214940$var$Dd(a, e, n);
        }
    });
    if (!r) return {};
    if (!$bb50b4d24b214940$var$Nt(r)) return $bb50b4d24b214940$var$Mr(r) ? {
        error: "TOO_SHORT"
    } : {};
    var d = $bb50b4d24b214940$var$Rr(r);
    return d.ext ? d : {
        number: r
    };
}
function $bb50b4d24b214940$var$Rd(t, n, e) {
    var r = {
        country: t,
        phone: n
    };
    return e && (r.ext = e), r;
}
function $bb50b4d24b214940$var$_d(t, n, e, r) {
    var d = $bb50b4d24b214940$var$un($bb50b4d24b214940$var$Xt(t), n, e, r.metadata), i = d.countryCallingCodeSource, a = d.countryCallingCode, o = d.number, u;
    if (a) r.selectNumberingPlan(a);
    else if (o && (n || e)) r.selectNumberingPlan(n, e), n && (u = n), a = e || $bb50b4d24b214940$var$Mt(n, r.metadata);
    else return {};
    if (!o) return {
        countryCallingCodeSource: i,
        countryCallingCode: a
    };
    var l = $bb50b4d24b214940$var$Pt($bb50b4d24b214940$var$Xt(o), r), $ = l.nationalNumber, c = l.carrierCode, f = $bb50b4d24b214940$var$$n(a, {
        nationalNumber: $,
        defaultCountry: n,
        metadata: r
    });
    return f && (u = f, f === "001" || r.country(u)), {
        country: u,
        countryCallingCode: a,
        countryCallingCodeSource: i,
        nationalNumber: $,
        carrierCode: c
    };
}
function $bb50b4d24b214940$var$ue(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$le(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$ue(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Ld(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$ue(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Ld(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$kd(t, n, e) {
    return $bb50b4d24b214940$var$xt(t, $bb50b4d24b214940$var$le($bb50b4d24b214940$var$le({}, n), {}, {
        v2: !0
    }), e);
}
function $bb50b4d24b214940$var$$e(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$Gd(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$$e(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Bd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$$e(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Bd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$jd(t, n) {
    return $bb50b4d24b214940$var$Vd(t) || $bb50b4d24b214940$var$Hd(t, n) || $bb50b4d24b214940$var$Wd(t, n) || $bb50b4d24b214940$var$Ud();
}
function $bb50b4d24b214940$var$Ud() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Wd(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$se(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$se(t, n);
    }
}
function $bb50b4d24b214940$var$se(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Hd(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Vd(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$Zd(t) {
    var n = Array.prototype.slice.call(t), e = $bb50b4d24b214940$var$jd(n, 4), r = e[0], d = e[1], i = e[2], a = e[3], o, u, l;
    if (typeof r == "string") o = r;
    else throw new TypeError("A text for parsing must be a string.");
    if (!d || typeof d == "string") a ? (u = i, l = a) : (u = void 0, l = i), d && (u = $bb50b4d24b214940$var$Gd({
        defaultCountry: d
    }, u));
    else if ($bb50b4d24b214940$var$R(d)) i ? (u = d, l = i) : l = d;
    else throw new Error("Invalid second argument: ".concat(d));
    return {
        text: o,
        options: u,
        metadata: l
    };
}
function $bb50b4d24b214940$var$fe(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$ce(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$fe(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Yd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$fe(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Yd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$zd(t, n, e) {
    n && n.defaultCountry && !$bb50b4d24b214940$var$Or(n.defaultCountry, e) && (n = $bb50b4d24b214940$var$ce($bb50b4d24b214940$var$ce({}, n), {}, {
        defaultCountry: void 0
    }));
    try {
        return $bb50b4d24b214940$var$kd(t, n, e);
    } catch (r) {
        if (!(r instanceof $bb50b4d24b214940$var$E)) throw r;
    }
}
function $bb50b4d24b214940$var$he(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$ge(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$he(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Xd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$he(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Xd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$Kd() {
    var t = $bb50b4d24b214940$var$Zd(arguments), n = t.text, e = t.options, r = t.metadata;
    e = $bb50b4d24b214940$var$ge($bb50b4d24b214940$var$ge({}, e), {}, {
        extract: !1
    });
    var d = $bb50b4d24b214940$var$zd(n, e, r);
    return d && d.isValid() || !1;
}
function $bb50b4d24b214940$var$Qd(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$me(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Jd(t, n, e) {
    return n && $bb50b4d24b214940$var$me(t.prototype, n), e && $bb50b4d24b214940$var$me(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$qd = /* @__PURE__ */ function() {
    function t(n) {
        var e = n.onCountryChange, r = n.onCallingCodeChange;
        $bb50b4d24b214940$var$Qd(this, t), this.onCountryChange = e, this.onCallingCodeChange = r;
    }
    return $bb50b4d24b214940$var$Jd(t, [
        {
            key: "reset",
            value: function(e) {
                var r = e.country, d = e.callingCode;
                this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, d);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function() {
                this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
            }
        },
        {
            key: "update",
            value: function(e) {
                for(var r = 0, d = Object.keys(e); r < d.length; r++){
                    var i = d[r];
                    this[i] = e[i];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function(e, r) {
                this.setCountry(e), this.setCallingCode(r);
            }
        },
        {
            key: "setCountry",
            value: function(e) {
                this.country = e, this.onCountryChange(e);
            }
        },
        {
            key: "setCallingCode",
            value: function(e) {
                this.callingCode = e, this.onCallingCodeChange(e, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function(e, r) {
                this.international = !0, this.initCountryAndCallingCode(e, r);
            }
        },
        {
            key: "appendDigits",
            value: function(e) {
                this.digits += e;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function(e) {
                this.nationalSignificantNumber += e;
            }
        },
        {
            key: "getNationalDigits",
            value: function() {
                return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function() {
                return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$ti(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$ei(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$ei(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$ye(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$ye(t, n);
    }
}
function $bb50b4d24b214940$var$ye(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$I = "x", $bb50b4d24b214940$var$ht = new RegExp($bb50b4d24b214940$var$I);
function $bb50b4d24b214940$var$Q(t, n) {
    if (n < 1) return "";
    for(var e = ""; n > 1;)n & 1 && (e += t), n >>= 1, t += t;
    return e + t;
}
function $bb50b4d24b214940$var$pe(t, n) {
    return t[n] === ")" && n++, $bb50b4d24b214940$var$ni(t.slice(0, n));
}
function $bb50b4d24b214940$var$ni(t) {
    for(var n = [], e = 0; e < t.length;)t[e] === "(" ? n.push(e) : t[e] === ")" && n.pop(), e++;
    var r = 0, d = "";
    n.push(t.length);
    for(var i = 0, a = n; i < a.length; i++){
        var o = a[i];
        d += t.slice(r, o), r = o + 1;
    }
    return d;
}
function $bb50b4d24b214940$var$ri(t, n, e) {
    for(var r = $bb50b4d24b214940$var$ti(e.split("")), d; !(d = r()).done;){
        var i = d.value;
        if (t.slice(n + 1).search($bb50b4d24b214940$var$ht) < 0) return;
        n = t.search($bb50b4d24b214940$var$ht), t = t.replace($bb50b4d24b214940$var$ht, i);
    }
    return [
        t,
        n
    ];
}
function $bb50b4d24b214940$var$di(t, n, e) {
    var r = e.metadata, d = e.shouldTryNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix, a = new RegExp("^(?:".concat(n.pattern(), ")$"));
    if (a.test(t.nationalSignificantNumber)) return $bb50b4d24b214940$var$ai(t, n, {
        metadata: r,
        shouldTryNationalPrefixFormattingRule: d,
        getSeparatorAfterNationalPrefix: i
    });
}
function $bb50b4d24b214940$var$ii(t, n) {
    return $bb50b4d24b214940$var$at(t, n) === "IS_POSSIBLE";
}
function $bb50b4d24b214940$var$ai(t, n, e) {
    var r = e.metadata, d = e.shouldTryNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix;
    if (t.nationalSignificantNumber, t.international, t.nationalPrefix, t.carrierCode, d(n)) {
        var a = $bb50b4d24b214940$var$ve(t, n, {
            useNationalPrefixFormattingRule: !0,
            getSeparatorAfterNationalPrefix: i,
            metadata: r
        });
        if (a) return a;
    }
    return $bb50b4d24b214940$var$ve(t, n, {
        useNationalPrefixFormattingRule: !1,
        getSeparatorAfterNationalPrefix: i,
        metadata: r
    });
}
function $bb50b4d24b214940$var$ve(t, n, e) {
    var r = e.metadata, d = e.useNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix, a = $bb50b4d24b214940$var$rn(t.nationalSignificantNumber, n, {
        carrierCode: t.carrierCode,
        useInternationalFormat: t.international,
        withNationalPrefix: d,
        metadata: r
    });
    if (d || (t.nationalPrefix ? a = t.nationalPrefix + i(n) + a : t.complexPrefixBeforeNationalSignificantNumber && (a = t.complexPrefixBeforeNationalSignificantNumber + " " + a)), $bb50b4d24b214940$var$oi(a, t)) return a;
}
function $bb50b4d24b214940$var$oi(t, n) {
    return $bb50b4d24b214940$var$et(t) === n.getNationalDigits();
}
function $bb50b4d24b214940$var$ui(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Ce(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$li(t, n, e) {
    return n && $bb50b4d24b214940$var$Ce(t.prototype, n), e && $bb50b4d24b214940$var$Ce(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$$i = /* @__PURE__ */ function() {
    function t() {
        $bb50b4d24b214940$var$ui(this, t);
    }
    return $bb50b4d24b214940$var$li(t, [
        {
            key: "parse",
            value: function(e) {
                if (this.context = [
                    {
                        or: !0,
                        instructions: []
                    }
                ], this.parsePattern(e), this.context.length !== 1) throw new Error("Non-finalized contexts left when pattern parse ended");
                var r = this.context[0], d = r.branches, i = r.instructions;
                if (d) return {
                    op: "|",
                    args: d.concat([
                        $bb50b4d24b214940$var$gt(i)
                    ])
                };
                if (i.length === 0) throw new Error("Pattern is required");
                return i.length === 1 ? i[0] : i;
            }
        },
        {
            key: "startContext",
            value: function(e) {
                this.context.push(e);
            }
        },
        {
            key: "endContext",
            value: function() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function(e) {
                if (!e) throw new Error("Pattern is required");
                var r = e.match($bb50b4d24b214940$var$ci);
                if (!r) {
                    if ($bb50b4d24b214940$var$fi.test(e)) throw new Error("Illegal characters found in a pattern: ".concat(e));
                    this.getContext().instructions = this.getContext().instructions.concat(e.split(""));
                    return;
                }
                var d = r[1], i = e.slice(0, r.index), a = e.slice(r.index + d.length);
                switch(d){
                    case "(?:":
                        i && this.parsePattern(i), this.startContext({
                            or: !0,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ")":
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (i && this.parsePattern(i), this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var o = this.getContext(), u = o.branches;
                        u.push($bb50b4d24b214940$var$gt(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
                            op: "|",
                            args: u
                        });
                        break;
                    case "|":
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (i && this.parsePattern(i), !this.getContext().branches) {
                            if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($bb50b4d24b214940$var$gt(this.getContext().instructions)), this.getContext().instructions = [];
                        break;
                    case "[":
                        i && this.parsePattern(i), this.startContext({
                            oneOfSet: !0
                        });
                        break;
                    case "]":
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext(), this.getContext().instructions.push({
                            op: "[]",
                            args: $bb50b4d24b214940$var$si(i)
                        });
                        break;
                    default:
                        throw new Error("Unknown operator: ".concat(d));
                }
                a && this.parsePattern(a);
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$si(t) {
    for(var n = [], e = 0; e < t.length;){
        if (t[e] === "-") {
            if (e === 0 || e === t.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(t));
            for(var r = t[e - 1].charCodeAt(0) + 1, d = t[e + 1].charCodeAt(0) - 1, i = r; i <= d;)n.push(String.fromCharCode(i)), i++;
        } else n.push(t[e]);
        e++;
    }
    return n;
}
var $bb50b4d24b214940$var$fi = /[\(\)\[\]\?\:\|]/, $bb50b4d24b214940$var$ci = new RegExp(// any of:
"(\\||\\(\\?\\:|\\)|\\[|\\])");
function $bb50b4d24b214940$var$gt(t) {
    return t.length === 1 ? t[0] : t;
}
function $bb50b4d24b214940$var$Ne(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$hi(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$hi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$be(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$be(t, n);
    }
}
function $bb50b4d24b214940$var$be(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$gi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Pe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$mi(t, n, e) {
    return n && $bb50b4d24b214940$var$Pe(t.prototype, n), e && $bb50b4d24b214940$var$Pe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$yi = /* @__PURE__ */ function() {
    function t(n) {
        $bb50b4d24b214940$var$gi(this, t), this.matchTree = new $bb50b4d24b214940$var$$i().parse(n);
    }
    return $bb50b4d24b214940$var$mi(t, [
        {
            key: "match",
            value: function(e) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = r.allowOverflow;
                if (!e) throw new Error("String is required");
                var i = $bb50b4d24b214940$var$Ot(e.split(""), this.matchTree, !0);
                if (i && i.match && delete i.matchedChars, !(i && i.overflow && !d)) return i;
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Ot(t, n, e) {
    if (typeof n == "string") {
        var r = t.join("");
        return n.indexOf(r) === 0 ? t.length === n.length ? {
            match: !0,
            matchedChars: t
        } : {
            partialMatch: !0
        } : r.indexOf(n) === 0 ? e && t.length > n.length ? {
            overflow: !0
        } : {
            match: !0,
            matchedChars: t.slice(0, n.length)
        } : void 0;
    }
    if (Array.isArray(n)) {
        for(var d = t.slice(), i = 0; i < n.length;){
            var a = n[i], o = $bb50b4d24b214940$var$Ot(d, a, e && i === n.length - 1);
            if (o) {
                if (o.overflow) return o;
                if (o.match) {
                    if (d = d.slice(o.matchedChars.length), d.length === 0) return i === n.length - 1 ? {
                        match: !0,
                        matchedChars: t
                    } : {
                        partialMatch: !0
                    };
                } else {
                    if (o.partialMatch) return {
                        partialMatch: !0
                    };
                    throw new Error(`Unsupported match result:
`.concat(JSON.stringify(o, null, 2)));
                }
            } else return;
            i++;
        }
        return e ? {
            overflow: !0
        } : {
            match: !0,
            matchedChars: t.slice(0, t.length - d.length)
        };
    }
    switch(n.op){
        case "|":
            for(var u, l = $bb50b4d24b214940$var$Ne(n.args), $; !($ = l()).done;){
                var c = $.value, f = $bb50b4d24b214940$var$Ot(t, c, e);
                if (f) {
                    if (f.overflow) return f;
                    if (f.match) return {
                        match: !0,
                        matchedChars: f.matchedChars
                    };
                    if (f.partialMatch) u = !0;
                    else throw new Error(`Unsupported match result:
`.concat(JSON.stringify(f, null, 2)));
                }
            }
            return u ? {
                partialMatch: !0
            } : void 0;
        case "[]":
            for(var h = $bb50b4d24b214940$var$Ne(n.args), g; !(g = h()).done;){
                var b = g.value;
                if (t[0] === b) return t.length === 1 ? {
                    match: !0,
                    matchedChars: t
                } : e ? {
                    overflow: !0
                } : {
                    match: !0,
                    matchedChars: [
                        b
                    ]
                };
            }
            return;
        default:
            throw new Error("Unsupported instruction tree: ".concat(n));
    }
}
function $bb50b4d24b214940$var$Ae(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$pi(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$pi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Ie(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Ie(t, n);
    }
}
function $bb50b4d24b214940$var$Ie(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$vi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$xe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Ci(t, n, e) {
    return n && $bb50b4d24b214940$var$xe(t.prototype, n), e && $bb50b4d24b214940$var$xe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$Et = "9", $bb50b4d24b214940$var$Ni = 15, $bb50b4d24b214940$var$bi = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$Et, $bb50b4d24b214940$var$Ni), $bb50b4d24b214940$var$Pi = /[- ]/, $bb50b4d24b214940$var$Ai = function() {
    return /\[([^\[\]])*\]/g;
}, $bb50b4d24b214940$var$Ii = function() {
    return /\d(?=[^,}][^,}])/g;
}, $bb50b4d24b214940$var$xi = new RegExp("[" + $bb50b4d24b214940$var$x + "]*\\$1[" + $bb50b4d24b214940$var$x + "]*(\\$\\d[" + $bb50b4d24b214940$var$x + "]*)*$"), $bb50b4d24b214940$var$Oe = 3, $bb50b4d24b214940$var$Oi = /* @__PURE__ */ function() {
    function t(n) {
        n.state;
        var e = n.metadata;
        $bb50b4d24b214940$var$vi(this, t), this.metadata = e, this.resetFormat();
    }
    return $bb50b4d24b214940$var$Ci(t, [
        {
            key: "resetFormat",
            value: function() {
                this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function(e, r) {
                this.resetFormat(), e ? (this.isNANP = e.callingCode() === "1", this.matchingFormats = e.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
            }
        },
        {
            key: "format",
            value: function(e, r) {
                var d = this;
                if ($bb50b4d24b214940$var$ii(r.nationalSignificantNumber, this.metadata)) for(var i = $bb50b4d24b214940$var$Ae(this.matchingFormats), a; !(a = i()).done;){
                    var o = a.value, u = $bb50b4d24b214940$var$di(r, o, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function($) {
                            return d.shouldTryNationalPrefixFormattingRule($, {
                                international: r.international,
                                nationalPrefix: r.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function($) {
                            return d.getSeparatorAfterNationalPrefix($);
                        }
                    });
                    if (u) return this.resetFormat(), this.chosenFormat = o, this.setNationalNumberTemplate(u.replace(/\d/g, $bb50b4d24b214940$var$I), r), this.populatedNationalNumberTemplate = u, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf($bb50b4d24b214940$var$I), u;
                }
                return this.formatNationalNumberWithNextDigits(e, r);
            }
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function(e, r) {
                var d = this.chosenFormat, i = this.chooseFormat(r);
                if (i) return i === d ? this.formatNextNationalNumberDigits(e) : this.formatNextNationalNumberDigits(r.getNationalDigits());
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function(e) {
                var r = this, d = e.nationalSignificantNumber, i = e.nationalPrefix, a = e.international, o = d, u = o.length - $bb50b4d24b214940$var$Oe;
                u < 0 && (u = 0), this.matchingFormats = this.matchingFormats.filter(function(l) {
                    return r.formatSuits(l, a, i) && r.formatMatches(l, o, u);
                }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function(e, r, d) {
                return !(d && !e.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !e.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !d && e.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
            }
        },
        {
            key: "formatMatches",
            value: function(e, r, d) {
                var i = e.leadingDigitsPatterns().length;
                if (i === 0) return !0;
                d = Math.min(d, i - 1);
                var a = e.leadingDigitsPatterns()[d];
                if (r.length < $bb50b4d24b214940$var$Oe) try {
                    return new $bb50b4d24b214940$var$yi(a).match(r, {
                        allowOverflow: !0
                    }) !== void 0;
                } catch (o) {
                    return console.error(o), !0;
                }
                return new RegExp("^(".concat(a, ")")).test(r);
            }
        },
        {
            key: "getFormatFormat",
            value: function(e, r) {
                return r ? e.internationalFormat() : e.format();
            }
        },
        {
            key: "chooseFormat",
            value: function(e) {
                for(var r = this, d = function() {
                    var l = a.value;
                    return r.chosenFormat === l ? "break" : $bb50b4d24b214940$var$xi.test(r.getFormatFormat(l, e.international)) ? r.createTemplateForFormat(l, e) ? (r.chosenFormat = l, "break") : (r.matchingFormats = r.matchingFormats.filter(function($) {
                        return $ !== l;
                    }), "continue") : "continue";
                }, i = $bb50b4d24b214940$var$Ae(this.matchingFormats.slice()), a; !(a = i()).done;){
                    var o = d();
                    if (o === "break") break;
                }
                return this.chosenFormat || this.resetFormat(), this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function(e, r) {
                if (!(e.pattern().indexOf("|") >= 0)) {
                    var d = this.getTemplateForFormat(e, r);
                    if (d) return this.setNationalNumberTemplate(d, r), !0;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function(e) {
                return this.isNANP || e && e.nationalPrefixFormattingRule() && $bb50b4d24b214940$var$Pi.test(e.nationalPrefixFormattingRule()) ? " " : "";
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function(e, r) {
                var d = e.IDDPrefix, i = e.missingPlus;
                return d ? r && r.spacing === !1 ? d : d + " " : i ? "" : "+";
            }
        },
        {
            key: "getTemplate",
            value: function(e) {
                if (this.template) {
                    for(var r = -1, d = 0, i = e.international ? this.getInternationalPrefixBeforeCountryCallingCode(e, {
                        spacing: !1
                    }) : ""; d < i.length + e.getDigitsWithoutInternationalPrefix().length;)r = this.template.indexOf($bb50b4d24b214940$var$I, r + 1), d++;
                    return $bb50b4d24b214940$var$pe(this.template, r + 1);
                }
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function(e, r) {
                this.nationalNumberTemplate = e, this.populatedNationalNumberTemplate = e, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, $bb50b4d24b214940$var$I) + $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, r.callingCode.length) + " " + e : this.template = e;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function(e, r) {
                var d = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, o = r.complexPrefixBeforeNationalSignificantNumber, u = e.pattern();
                u = u.replace($bb50b4d24b214940$var$Ai(), "\\d").replace($bb50b4d24b214940$var$Ii(), "\\d");
                var l = $bb50b4d24b214940$var$bi.match(u)[0];
                if (!(d.length > l.length)) {
                    var $ = new RegExp("^" + u + "$"), c = d.replace(/\d/g, $bb50b4d24b214940$var$Et);
                    $.test(c) && (l = c);
                    var f = this.getFormatFormat(e, i), h;
                    if (this.shouldTryNationalPrefixFormattingRule(e, {
                        international: i,
                        nationalPrefix: a
                    })) {
                        var g = f.replace($bb50b4d24b214940$var$nn, e.nationalPrefixFormattingRule());
                        if ($bb50b4d24b214940$var$et(e.nationalPrefixFormattingRule()) === (a || "") + $bb50b4d24b214940$var$et("$1") && (f = g, h = !0, a)) for(var b = a.length; b > 0;)f = f.replace(/\d/, $bb50b4d24b214940$var$I), b--;
                    }
                    var p = l.replace(new RegExp(u), f).replace(new RegExp($bb50b4d24b214940$var$Et, "g"), $bb50b4d24b214940$var$I);
                    return h || (o ? p = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, o.length) + " " + p : a && (p = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, a.length) + this.getSeparatorAfterNationalPrefix(e) + p)), i && (p = $bb50b4d24b214940$var$en(p)), p;
                }
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function(e) {
                var r = $bb50b4d24b214940$var$ri(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, e);
                if (!r) {
                    this.resetFormat();
                    return;
                }
                return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], $bb50b4d24b214940$var$pe(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function(e, r) {
                var d = r.international, i = r.nationalPrefix;
                if (e.nationalPrefixFormattingRule()) {
                    var a = e.usesNationalPrefix();
                    if (a && i || !a && !d) return !0;
                }
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$fn(t, n) {
    return $bb50b4d24b214940$var$Fi(t) || $bb50b4d24b214940$var$Ti(t, n) || $bb50b4d24b214940$var$Si(t, n) || $bb50b4d24b214940$var$Ei();
}
function $bb50b4d24b214940$var$Ei() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Si(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Ee(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Ee(t, n);
    }
}
function $bb50b4d24b214940$var$Ee(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Ti(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Fi(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$wi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Se(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Di(t, n, e) {
    return n && $bb50b4d24b214940$var$Se(t.prototype, n), e && $bb50b4d24b214940$var$Se(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$Mi = "[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+", $bb50b4d24b214940$var$Ri = new RegExp("^" + $bb50b4d24b214940$var$Mi + "$", "i"), $bb50b4d24b214940$var$_i = "(?:[" + $bb50b4d24b214940$var$rt + "][" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]*|[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+)", $bb50b4d24b214940$var$Li = new RegExp("[^" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+.*$"), $bb50b4d24b214940$var$ki = /[^\d\[\]]/, $bb50b4d24b214940$var$Gi = /* @__PURE__ */ function() {
    function t(n) {
        var e = n.defaultCountry, r = n.defaultCallingCode, d = n.metadata, i = n.onNationalSignificantNumberChange;
        $bb50b4d24b214940$var$wi(this, t), this.defaultCountry = e, this.defaultCallingCode = r, this.metadata = d, this.onNationalSignificantNumberChange = i;
    }
    return $bb50b4d24b214940$var$Di(t, [
        {
            key: "input",
            value: function(e, r) {
                var d = $bb50b4d24b214940$var$Ui(e), i = $bb50b4d24b214940$var$fn(d, 2), a = i[0], o = i[1], u = $bb50b4d24b214940$var$et(a), l;
                return o && (r.digits || (r.startInternationalNumber(), u || (l = !0))), u && this.inputDigits(u, r), {
                    digits: u,
                    justLeadingPlus: l
                };
            }
        },
        {
            key: "inputDigits",
            value: function(e, r) {
                var d = r.digits, i = d.length < 3 && d.length + e.length >= 3;
                if (r.appendDigits(e), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
                    if (!this.extractCountryCallingCode(r)) return;
                } else r.appendNationalSignificantNumberDigits(e);
                r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
                    return r.update(a);
                });
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function(e) {
                var r = e.international, d = e.callingCode;
                return r && !d;
            }
        },
        {
            key: "extractCountryCallingCode",
            value: function(e) {
                var r = $bb50b4d24b214940$var$un("+" + e.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), d = r.countryCallingCode, i = r.number;
                if (d) return e.setCallingCode(d), e.update({
                    nationalSignificantNumber: i
                }), !0;
            }
        },
        {
            key: "reset",
            value: function(e) {
                if (e) {
                    this.hasSelectedNumberingPlan = !0;
                    var r = e._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = r && $bb50b4d24b214940$var$ki.test(r);
                } else this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function(e, r) {
                if (this.hasSelectedNumberingPlan) {
                    var d = $bb50b4d24b214940$var$bt(e, this.metadata), i = d.nationalPrefix, a = d.nationalNumber, o = d.carrierCode;
                    if (a !== e) return this.onExtractedNationalNumber(i, o, a, e, r), !0;
                }
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function(e, r, d) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(e, d);
                if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
                    var i = $bb50b4d24b214940$var$bt(e, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, u = i.carrierCode;
                    if (o !== r) return this.onExtractedNationalNumber(a, u, o, e, d), !0;
                }
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function(e, r, d, i, a) {
                var o, u, l = i.lastIndexOf(d);
                if (l >= 0 && l === i.length - d.length) {
                    u = !0;
                    var $ = i.slice(0, l);
                    $ !== e && (o = $);
                }
                a({
                    nationalPrefix: e,
                    carrierCode: r,
                    nationalSignificantNumber: d,
                    nationalSignificantNumberMatchesInput: u,
                    complexPrefixBeforeNationalSignificantNumber: o
                }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function(e) {
                if (this.extractAnotherNationalSignificantNumber(e.getNationalDigits(), e.nationalSignificantNumber, function(r) {
                    return e.update(r);
                })) return !0;
                if (this.extractIddPrefix(e)) return this.extractCallingCodeAndNationalSignificantNumber(e), !0;
                if (this.fixMissingPlus(e)) return this.extractCallingCodeAndNationalSignificantNumber(e), !0;
            }
        },
        {
            key: "extractIddPrefix",
            value: function(e) {
                var r = e.international, d = e.IDDPrefix, i = e.digits;
                if (e.nationalSignificantNumber, !(r || d)) {
                    var a = $bb50b4d24b214940$var$an(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                    if (a !== void 0 && a !== i) return e.update({
                        IDDPrefix: i.slice(0, i.length - a.length)
                    }), this.startInternationalNumber(e, {
                        country: void 0,
                        callingCode: void 0
                    }), !0;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function(e) {
                if (!e.international) {
                    var r = $bb50b4d24b214940$var$on(e.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), d = r.countryCallingCode;
                    if (r.number, d) return e.update({
                        missingPlus: !0
                    }), this.startInternationalNumber(e, {
                        country: e.country,
                        callingCode: d
                    }), !0;
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function(e, r) {
                var d = r.country, i = r.callingCode;
                e.startInternationalNumber(d, i), e.nationalSignificantNumber && (e.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function(e) {
                this.extractCountryCallingCode(e) && this.extractNationalSignificantNumber(e.getNationalDigits(), function(r) {
                    return e.update(r);
                });
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Bi(t) {
    var n = t.search($bb50b4d24b214940$var$_i);
    if (!(n < 0)) {
        t = t.slice(n);
        var e;
        return t[0] === "+" && (e = !0, t = t.slice(1)), t = t.replace($bb50b4d24b214940$var$Li, ""), e && (t = "+" + t), t;
    }
}
function $bb50b4d24b214940$var$ji(t) {
    var n = $bb50b4d24b214940$var$Bi(t) || "";
    return n[0] === "+" ? [
        n.slice(1),
        !0
    ] : [
        n
    ];
}
function $bb50b4d24b214940$var$Ui(t) {
    var n = $bb50b4d24b214940$var$ji(t), e = $bb50b4d24b214940$var$fn(n, 2), r = e[0], d = e[1];
    return $bb50b4d24b214940$var$Ri.test(r) || (r = ""), [
        r,
        d
    ];
}
function $bb50b4d24b214940$var$Wi(t, n) {
    return $bb50b4d24b214940$var$Yi(t) || $bb50b4d24b214940$var$Zi(t, n) || $bb50b4d24b214940$var$Vi(t, n) || $bb50b4d24b214940$var$Hi();
}
function $bb50b4d24b214940$var$Hi() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Vi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Te(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Te(t, n);
    }
}
function $bb50b4d24b214940$var$Te(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Zi(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Yi(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$zi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Fe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Xi(t, n, e) {
    return n && $bb50b4d24b214940$var$Fe(t.prototype, n), e && $bb50b4d24b214940$var$Fe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$cn = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$zi(this, t), this.metadata = new $bb50b4d24b214940$var$v(e);
        var r = this.getCountryAndCallingCode(n), d = $bb50b4d24b214940$var$Wi(r, 2), i = d[0], a = d[1];
        this.defaultCountry = i, this.defaultCallingCode = a, this.reset();
    }
    return $bb50b4d24b214940$var$Xi(t, [
        {
            key: "getCountryAndCallingCode",
            value: function(e) {
                var r, d;
                return e && ($bb50b4d24b214940$var$R(e) ? (r = e.defaultCountry, d = e.defaultCallingCode) : r = e), r && !this.metadata.hasCountry(r) && (r = void 0), [
                    r,
                    d
                ];
            }
        },
        {
            key: "input",
            value: function(e) {
                var r = this.parser.input(e, this.state), d = r.digits, i = r.justLeadingPlus;
                if (i) this.formattedOutput = "+";
                else if (d) {
                    this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
                    var a;
                    if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(d, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
                        this.determineTheCountryIfNeeded();
                        var o = this.state.getNationalDigits();
                        o && (a = this.formatter.format(o, this.state));
                    }
                    this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function() {
                var e = this;
                return this.state = new $bb50b4d24b214940$var$qd({
                    onCountryChange: function(d) {
                        e.country = d;
                    },
                    onCallingCodeChange: function(d, i) {
                        e.metadata.selectNumberingPlan(i, d), e.formatter.reset(e.metadata.numberingPlan, e.state), e.parser.reset(e.metadata.numberingPlan);
                    }
                }), this.formatter = new $bb50b4d24b214940$var$Oi({
                    state: this.state,
                    metadata: this.metadata
                }), this.parser = new $bb50b4d24b214940$var$Gi({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function() {
                        e.determineTheCountryIfNeeded(), e.formatter.reset(e.metadata.numberingPlan, e.state);
                    }
                }), this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                }), this.formattedOutput = "", this;
            }
        },
        {
            key: "isInternational",
            value: function() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function() {
                if (this.isInternational()) return this.state.callingCode;
            }
        },
        {
            key: "getCountryCallingCode",
            value: function() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function() {
                var e = this.state.digits;
                if (e) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function() {
                var e = this.state.country;
                return e;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function() {
                (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
            }
        },
        {
            key: "getFullNumber",
            value: function(e) {
                var r = this;
                if (this.isInternational()) {
                    var d = function(o) {
                        return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
                            spacing: !!o
                        }) + o;
                    }, i = this.state.callingCode;
                    return d(i ? e ? "".concat(i, " ").concat(e) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
                }
                return e;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function() {
                var e = this.state, r = e.nationalSignificantNumber, d = e.complexPrefixBeforeNationalSignificantNumber, i = e.nationalPrefix, a = r, o = d || i;
                return o && (a = o + a), a;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function() {
                var e = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(e ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function() {
                var e = this.getNonFormattedNumber();
                if (e) return e.replace(/[\+\d]/g, $bb50b4d24b214940$var$I);
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function() {
                var e = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(e);
                return r && r.length > 1;
            }
        },
        {
            key: "determineTheCountry",
            value: function() {
                this.state.setCountry($bb50b4d24b214940$var$$n(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function() {
                var e = this.state, r = e.digits, d = e.callingCode, i = e.country, a = e.nationalSignificantNumber;
                if (r) {
                    if (this.isInternational()) return d ? "+" + d + a : "+" + r;
                    if (i || d) {
                        var o = i ? this.metadata.countryCallingCode() : d;
                        return "+" + o + a;
                    }
                }
            }
        },
        {
            key: "getNumber",
            value: function() {
                var e = this.state, r = e.nationalSignificantNumber, d = e.carrierCode, i = e.callingCode, a = this._getCountry();
                if (r && !(!a && !i)) {
                    if (a && a === this.defaultCountry) {
                        var o = new $bb50b4d24b214940$var$v(this.metadata.metadata);
                        o.selectNumberingPlan(a);
                        var u = o.numberingPlan.callingCode(), l = this.metadata.getCountryCodesForCallingCode(u);
                        if (l.length > 1) {
                            var $ = $bb50b4d24b214940$var$ln(r, {
                                countries: l,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            $ && (a = $);
                        }
                    }
                    var c = new $bb50b4d24b214940$var$dn(a || i, r, this.metadata.metadata);
                    return d && (c.carrierCode = d), c;
                }
            }
        },
        {
            key: "isPossible",
            value: function() {
                var e = this.getNumber();
                return e ? e.isPossible() : !1;
            }
        },
        {
            key: "isValid",
            value: function() {
                var e = this.getNumber();
                return e ? e.isValid() : !1;
            }
        },
        {
            key: "getNationalNumber",
            value: function() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function() {
                return (this.state.international ? "+" : "") + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Ki() {
    return $bb50b4d24b214940$var$Ye($bb50b4d24b214940$var$Kd, arguments);
}
function $bb50b4d24b214940$export$80d8c6912928a4eb(t) {
    return $bb50b4d24b214940$var$cn.call(this, t, $bb50b4d24b214940$var$Tt);
}
$bb50b4d24b214940$export$80d8c6912928a4eb.prototype = Object.create($bb50b4d24b214940$var$cn.prototype, {});
$bb50b4d24b214940$export$80d8c6912928a4eb.prototype.constructor = $bb50b4d24b214940$export$80d8c6912928a4eb;
function $bb50b4d24b214940$var$Qi(t, n) {
    return $bb50b4d24b214940$var$e1(t) || $bb50b4d24b214940$var$t1(t, n) || $bb50b4d24b214940$var$qi(t, n) || $bb50b4d24b214940$var$Ji();
}
function $bb50b4d24b214940$var$Ji() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$qi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$we(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$we(t, n);
    }
}
function $bb50b4d24b214940$var$we(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$t1(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$e1(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$n1() {
    var t = $bb50b4d24b214940$var$r1(arguments), n = t.input, e = t.options, r = t.metadata;
    if (n.phone) return $bb50b4d24b214940$var$ot(n, e, r);
}
function $bb50b4d24b214940$var$r1(t) {
    var n = Array.prototype.slice.call(t), e = $bb50b4d24b214940$var$Qi(n, 4), r = e[0], d = e[1], i = e[2], a = e[3], o, u = {}, l;
    if (typeof r == "string") $bb50b4d24b214940$var$R(d) ? (i ? (u = d, l = i) : l = d, $bb50b4d24b214940$var$Nt(r) ? o = $bb50b4d24b214940$var$xt(r, void 0, l) : o = {}) : (a ? (u = i, l = a) : l = i, $bb50b4d24b214940$var$Nt(r) ? o = $bb50b4d24b214940$var$xt(r, {
        defaultCountry: d
    }, l) : o = {});
    else if ($bb50b4d24b214940$var$R(r)) o = r, i ? (u = d, l = i) : l = d;
    else throw new TypeError("A phone number must either be a string or an object of shape { phone, [country] }.");
    return {
        input: o,
        options: u,
        metadata: l
    };
}
function $bb50b4d24b214940$export$f1c97bcb220031e2() {
    return $bb50b4d24b214940$var$Ye($bb50b4d24b214940$var$n1, arguments);
}
function $bb50b4d24b214940$var$mt(t) {
    var _B_n, _B_n1;
    const { defaultCountry: n, initialValue: e, disableFormatting: r, forceCallingCode: d } = t, i = n ? `+${(_B_n = $bb50b4d24b214940$var$B[n]) === null || _B_n === void 0 ? void 0 : _B_n[0]}` : "", a = new $bb50b4d24b214940$export$80d8c6912928a4eb(n);
    let o = a.input(e);
    d && o === "+" && n && (o = `+${(_B_n1 = $bb50b4d24b214940$var$B[n]) === null || _B_n1 === void 0 ? void 0 : _B_n1[0]}`);
    const u = a.getNumberValue();
    return r && u && (o = u), {
        inputValue: o || i,
        isoCode: a.getCountry() || n || null
    };
}
function $bb50b4d24b214940$var$d1(t, n) {
    const { excludedCountries: e, onlyCountries: r, continents: d } = n;
    return !($bb50b4d24b214940$var$S(e, !0) && e.includes(t) || $bb50b4d24b214940$var$S(r) && !r.includes(t) || $bb50b4d24b214940$var$S(d) && !$bb50b4d24b214940$var$Ge(d, t));
}
function $bb50b4d24b214940$var$i1({ value: t, onChange: n, defaultCountry: e, onlyCountries: r, excludedCountries: d, continents: i, disableFormatting: a, forceCallingCode: o }) {
    const u = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(e || null), l = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(new $bb50b4d24b214940$export$80d8c6912928a4eb(e)), $ = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(null), [c, f] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(e), [h, g] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(()=>$bb50b4d24b214940$var$mt({
            initialValue: t,
            defaultCountry: e,
            disableFormatting: a,
            forceCallingCode: o
        })), [b, p] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(t), D = (s)=>{
        var _l_current_getNumber;
        var _l_current_getNumber_getType;
        return {
            countryCallingCode: l.current.getCallingCode() || null,
            countryCode: l.current.getCountry() || null,
            nationalNumber: l.current.getNationalNumber(),
            numberType: (_l_current_getNumber_getType = (_l_current_getNumber = l.current.getNumber()) === null || _l_current_getNumber === void 0 ? void 0 : _l_current_getNumber.getType()) !== null && _l_current_getNumber_getType !== void 0 ? _l_current_getNumber_getType : null,
            numberValue: l.current.getNumberValue() || null,
            reason: s
        };
    }, j = (s)=>s && $bb50b4d24b214940$var$d1(s, {
            onlyCountries: r,
            excludedCountries: d,
            continents: i
        }), U = (s)=>(l.current.reset(), l.current.input(s)), ut = (s)=>s.startsWith("+") || s === "" ? s : `+${s}`, lt = (s, O)=>`+${$bb50b4d24b214940$var$tt(O)}${s}`, $t = (s)=>{
        const O = o ? lt(s.target.value, h.isoCode) : ut(s.target.value), F = U(O), M = l.current.getCountry(), A = o ? // always the same country, can't change
        h.isoCode : M || u.current, P = l.current.getNumberValue() || "";
        u.current = A;
        const W = D("input");
        if (P && (!A || !j(A))) n === null || n === void 0 ? void 0 : n(P, {
            ...W,
            // we show the input value but without any formatting, or country..
            countryCode: null,
            countryCallingCode: null,
            nationalNumber: null
        }), p(P), g({
            isoCode: null,
            inputValue: P
        });
        else {
            const w = a ? P : F;
            n === null || n === void 0 ? void 0 : n(w, W), p(w), g({
                isoCode: A,
                inputValue: w
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (t !== b) {
            p(t);
            const s = $bb50b4d24b214940$var$mt({
                initialValue: t,
                defaultCountry: e,
                forceCallingCode: o,
                disableFormatting: a
            });
            u.current = s.isoCode, g(s);
        }
    }, [
        t,
        b,
        e,
        o,
        a
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (e !== c) {
            f(e), l.current = new $bb50b4d24b214940$export$80d8c6912928a4eb(e);
            const { inputValue: s, isoCode: O } = $bb50b4d24b214940$var$mt({
                initialValue: "",
                defaultCountry: e,
                forceCallingCode: o,
                disableFormatting: a
            });
            p(s), l.current.input(s), u.current = l.current.getCountry() || null, n === null || n === void 0 ? void 0 : n(s, D("country")), g({
                inputValue: s,
                isoCode: O
            });
        }
    }, [
        e,
        c,
        n,
        o,
        a
    ]);
    const z = (s)=>{
        var _B_s;
        if (s === h.isoCode) return;
        const O = (_B_s = $bb50b4d24b214940$var$B[s]) === null || _B_s === void 0 ? void 0 : _B_s[0], { inputValue: F, isoCode: M } = h;
        let A = F;
        if (M) {
            const w = `+${$bb50b4d24b214940$var$tt(M)}`;
            A = F.startsWith(w) ? $bb50b4d24b214940$var$Ze(F, w) : "";
        }
        let P = `+${O}${A}`;
        a || (P = U(P)), n === null || n === void 0 ? void 0 : n(P, {
            ...D("country"),
            // Some country have the same calling code, so we choose what the user has selected
            countryCode: s
        }), u.current = s, p(P), g({
            isoCode: s,
            inputValue: P
        });
    };
    return {
        inputValue: h.inputValue,
        isoCode: h.isoCode,
        onInputChange: $t,
        onCountryChange: z,
        inputRef: $
    };
}
function $bb50b4d24b214940$export$ba16fc01b090027c(t, n) {
    const e = new $bb50b4d24b214940$export$80d8c6912928a4eb();
    e.input(t);
    const r = e.getCountry();
    if (!r || (n === null || n === void 0 ? void 0 : n.continents) && n.continents.length > 0 && !$bb50b4d24b214940$var$Ge(n.continents, r)) return !1;
    if ((n === null || n === void 0 ? void 0 : n.onlyCountries) && n.onlyCountries.length > 0) {
        const [d] = $bb50b4d24b214940$var$Le([
            r
        ], n.onlyCountries);
        if (!d) return !1;
    }
    if ((n === null || n === void 0 ? void 0 : n.excludedCountries) && n.excludedCountries.length > 0) {
        const [d] = $bb50b4d24b214940$var$ke([
            r
        ], n.excludedCountries);
        if (!d) return !1;
    }
    return $bb50b4d24b214940$var$Ki(t);
}
const $bb50b4d24b214940$export$7b08a25ee27059c2 = "MuiTelInput-TextField", $bb50b4d24b214940$export$5d5d29ff8b7e8a02 = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((t, n)=>{
    const { forceCallingCode: e = !1, onlyCountries: r, excludedCountries: d, defaultCountry: i, onDoubleClick: a, onFocus: o, onCopy: u, value: l = "", inputProps: $, InputProps: c, inputRef: f, disabled: h, onChange: g, disableDropdown: b, disableFormatting: p = !1, focusOnSelectCountry: D, langOfCountryName: j, continents: U, preferredCountries: ut, MenuProps: lt, className: $t, getFlagElement: z = $bb50b4d24b214940$var$Vn, unknownFlagElement: s = $bb50b4d24b214940$var$Zn, ...O } = t, F = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(null), [M, A] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(null), P = e ? $bb50b4d24b214940$var$Gn(i) : i;
    $bb50b4d24b214940$var$rr(t);
    const { onInputChange: W, onCountryChange: w, inputRef: L, isoCode: X, inputValue: Rt } = $bb50b4d24b214940$var$i1({
        forceCallingCode: e,
        defaultCountry: P,
        value: l !== null && l !== void 0 ? l : "",
        onChange: g,
        excludedCountries: d,
        onlyCountries: r,
        disableFormatting: p,
        continents: U
    }), gn = (y)=>{
        y.preventDefault(), (!h || !b) && A(F.current);
    }, mn = (y)=>{
        A(null), w(y), D && L.current && L.current.focus();
    }, yn = (y)=>{
        L.current && $bb50b4d24b214940$var$nr(L.current), o === null || o === void 0 ? void 0 : o(y);
    }, pn = (y)=>{
        const H = L.current;
        H.setSelectionRange(0, H.value.length), a === null || a === void 0 ? void 0 : a(y);
    }, vn = (y)=>{
        if (u) {
            u(y);
            return;
        }
        const H = window.getSelection();
        if (H) {
            const In = H.toString().replaceAll(" ", "");
            y.clipboardData.setData("text/plain", In), y.preventDefault();
        }
    }, Cn = (y)=>{
        L.current = y, (c === null || c === void 0 ? void 0 : c.inputRef) && $bb50b4d24b214940$var$st(y, c.inputRef), f && $bb50b4d24b214940$var$st(y, f);
    }, Nn = (y)=>{
        F.current = y, n && $bb50b4d24b214940$var$st(y, n);
    }, bn = ()=>{
        A(null);
    }, Pn = X ? `+${$bb50b4d24b214940$var$tt(X)}` : "", An = e ? // We removed the isoCode but no necessarily the space after
    $bb50b4d24b214940$var$Ze(Rt, Pn).trimStart() : Rt;
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $3pI8R.Fragment), {
        children: [
            /* @__PURE__ */ (0, $3pI8R.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                type: "tel",
                disabled: h,
                value: An,
                ref: Nn,
                onDoubleClick: pn,
                inputRef: Cn,
                className: `${$bb50b4d24b214940$export$7b08a25ee27059c2} ${$t || ""}`,
                onChange: W,
                inputProps: {
                    onCopy: vn,
                    ...$
                },
                onFocus: yn,
                InputProps: {
                    startAdornment: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $2716b83202966b50$export$2e2bcd8739ae039), {
                        position: "start",
                        sx: {
                            flexShrink: 0
                        },
                        children: /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$zn, {
                            isFlagsMenuOpened: !!M,
                            isoCode: X,
                            forceCallingCode: e,
                            onClick: gn,
                            disabled: h,
                            getFlagElement: z,
                            unknownFlagElement: s,
                            disableDropdown: !!b
                        })
                    }),
                    ...c
                },
                ...O
            }),
            b ? null : /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$er, {
                onlyCountries: r,
                excludedCountries: d,
                continents: U,
                anchorEl: M,
                isoCode: X,
                preferredCountries: ut,
                onClose: bn,
                langOfCountryName: j,
                onSelectCountry: mn,
                getFlagElement: z,
                ...lt
            })
        ]
    });
}), $bb50b4d24b214940$export$188d75d71883854a = {
    textField: $bb50b4d24b214940$export$7b08a25ee27059c2,
    flagContainer: $bb50b4d24b214940$var$Re,
    flagImg: $bb50b4d24b214940$var$Ft,
    flagButton: $bb50b4d24b214940$var$yt,
    menu: $bb50b4d24b214940$var$Ve,
    menuItem: $bb50b4d24b214940$var$je,
    listItemIconFlag: $bb50b4d24b214940$var$Ue,
    listItemTextCountry: $bb50b4d24b214940$var$We,
    callingCode: $bb50b4d24b214940$var$He
};




var $8YEKz = parcelRequire("8YEKz");

var $lM7US = parcelRequire("lM7US");

var $3pTPw = parcelRequire("3pTPw");


var $ezhXm = parcelRequire("ezhXm");



var $b275P = parcelRequire("b275P");

var $cD0nt = parcelRequire("cD0nt");

var $aOIYu = parcelRequire("aOIYu");

var $e7eqj = parcelRequire("e7eqj");

var $jnPOB = parcelRequire("jnPOB");


var $k9qks = parcelRequire("k9qks");

var $kCXUJ = parcelRequire("kCXUJ");

var $hJePx = parcelRequire("hJePx");


var $eZVvM = parcelRequire("eZVvM");

var $4yVoh = parcelRequire("4yVoh");

var $cD0nt = parcelRequire("cD0nt");
const $88e948d6321fcc02$var$moveLeft = (delay)=>({
        initial: {
            x: 200,
            opacity: 0
        },
        animate: {
            x: 0,
            opacity: 1,
            transition: {
                duration: 0.35,
                delay: delay,
                ease: "easeOut"
            }
        }
    });
const $88e948d6321fcc02$var$MoveLeft = (props)=>{
    const { children: children, disabled: disabled, delay: delay } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, Object.assign({}, (0, $4yVoh.anim)($88e948d6321fcc02$var$moveLeft(delay))));
};
var $88e948d6321fcc02$export$2e2bcd8739ae039 = $88e948d6321fcc02$var$MoveLeft;


var $db45dfc051e0ec4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $db45dfc051e0ec4c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $db45dfc051e0ec4c$var$ManualCheckinGrid = (0, $e8m2I.default)((0, $23610b7fd899719e$export$2e2bcd8739ae039))({});
const $db45dfc051e0ec4c$var$ManualCheckinField = (0, $e8m2I.default)((0, $ljukC.motion).div)(({ theme: theme })=>({
        marginBottom: "1.75rem",
        width: "56.5rem",
        "@media screen and (orientation: landscape)": {
            width: "50rem"
        }
    }));
const $db45dfc051e0ec4c$var$getFieldType = (code, fields)=>{
    var _a;
    return (_a = fields.find((field)=>field.name === code || field.code === code)) === null || _a === void 0 ? void 0 : _a.type;
};
const $db45dfc051e0ec4c$var$ManualCheckin = ()=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { t: t } = (0, $9GLBV.useTranslation)();
    const navigate = (0, $9B9bN.useNavigate)();
    const { pathname: pathname, state: locationState } = (0, $9B9bN.useLocation)();
    const mainRoute = /^\/access\/checkin\/manual\/?$/.test(pathname);
    const [language] = (0, $3adb49bfa33db486$export$c1fd9f444a3dc711)();
    const languages = (0, $3adb49bfa33db486$export$38be4353f99148d)();
    const { integratedManualCheckin: integratedManualCheckin, independentManualCheckin: independentManualCheckin } = (0, $cD0nt.useLayout)();
    const registrationFields = (0, $eZVvM.useMemo)(()=>{
        var _a, _b, _c, _d;
        if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return (_b = (_a = integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.registration) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : [];
        if (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) return (_d = (_c = independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.registration) === null || _c === void 0 ? void 0 : _c.fields) !== null && _d !== void 0 ? _d : [];
        return [];
    }, [
        integratedManualCheckin,
        independentManualCheckin
    ]);
    const hasContact = (0, $eZVvM.useMemo)(()=>registrationFields.some((field)=>field.type === "EmployeeList"), [
        registrationFields
    ]);
    const defaultFormValues = (0, $eZVvM.useMemo)(()=>({
            info: registrationFields.reduce((acc, item)=>{
                acc[item.name || item.code] = "";
                if (locationState === null || locationState === void 0 ? void 0 : locationState[item.name || item.code]) acc[item.name || item.code] = locationState === null || locationState === void 0 ? void 0 : locationState[item.name || item.code];
                return acc;
            }, {}),
            contact: {
                label: ""
            }
        }), [
        registrationFields,
        locationState
    ]);
    const drCountry = (0, $cD0nt.useDigitalReceptionCountry)();
    const drCountryCode = (0, $eZVvM.useMemo)(()=>drCountry ? (0, $2f526e07c519dc18$export$9a0a9c75ccef13fb)(drCountry) : null, [
        drCountry
    ]);
    const defaultCountry = (0, $eZVvM.useMemo)(()=>{
        if (!!drCountryCode) return drCountryCode;
        if ([
            "nl",
            "fr",
            "de",
            "pt"
        ].includes(language)) return language.toUpperCase();
        if (language === "sr") return "RS";
        if (language === "en") return "US";
        return undefined;
    }, [
        language
    ]);
    const preferredCountries = (0, $eZVvM.useMemo)(()=>{
        return (drCountryCode ? [
            drCountryCode
        ] : []).concat(languages.flatMap((language)=>{
            if ([
                "nl",
                "fr",
                "de",
                "pt"
            ].includes(language)) return [
                language.toUpperCase()
            ];
            if (language === "sr") return [
                "RS"
            ];
            if (language === "en") return [
                "US"
            ];
            return [];
        }));
    }, [
        languages
    ]);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const { screen: screen, showFirst: showFirst, unacceptedAgreements: unacceptedAgreements } = (0, $537fa6077f9ab8f6$export$991b23a188dc1bb5)();
    const [pendingAgreements, setPendingAgreements] = (0, $eZVvM.useState)(showFirst && unacceptedAgreements ? unacceptedAgreements : []);
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const queryClient = (0, $gdPnm.useQueryClient)(); // usePageTracking({
    //   page: "manual_checkin",
    // });
    // const { trackEvent } = useEventTracking();
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const { data: employeesData } = (0, $dMu0R.useQuery)([
        "employees",
        {
            filter: {
                preferences: {
                    visitor: {
                        enabled: {
                            EQ: true
                        }
                    }
                }
            },
            pagination: {
                limit: 99999
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_EMPLOYEES), variables), {
        enabled: hasContact
    });
    const employees = (0, $eZVvM.useMemo)(()=>employeesData === null || employeesData === void 0 ? void 0 : employeesData.employees, [
        employeesData
    ]);
    const contactList = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(employees, (employee)=>({
                id: employee.id,
                label: employee.fullName
            })), [
        employees
    ]);
    const [layout, setLayout] = (0, $eZVvM.useState)("default-shift");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)(`info.${((_a = registrationFields[0]) === null || _a === void 0 ? void 0 : _a.name) || ((_b = registrationFields[0]) === null || _b === void 0 ? void 0 : _b.code)}`);
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: defaultFormValues,
        mode: "onSubmit"
    });
    const { setValue: setValue, handleSubmit: handleSubmit } = methods;
    (0, $eZVvM.useEffect)(()=>{
        methods.register("files");
    }, []);
    const { data: data, status: requestStatus, mutate: mutate, reset: reset } = (0, $084aaf38c3338203$export$609860bf8b0084c)((input)=>{
        return (0, $jnPOB.client).request((0, $hJePx.MUTATION_CREATE_GUEST), {
            input: input
        });
    });
    const receiver = (_c = data === null || data === void 0 ? void 0 : data.createGuest) === null || _c === void 0 ? void 0 : _c.receiver;
    const autoEmail = (_f = (_e = (_d = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _d === void 0 ? void 0 : _d.visitor) === null || _e === void 0 ? void 0 : _e.autoChannel) === null || _f === void 0 ? void 0 : _f.email;
    const autoSMS = (_j = (_h = (_g = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _g === void 0 ? void 0 : _g.visitor) === null || _h === void 0 ? void 0 : _h.autoChannel) === null || _j === void 0 ? void 0 : _j.sms;
    const autoCall = (_m = (_l = (_k = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _k === void 0 ? void 0 : _k.visitor) === null || _l === void 0 ? void 0 : _l.autoChannel) === null || _m === void 0 ? void 0 : _m.call;
    const autoPing = (_q = (_p = (_o = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _o === void 0 ? void 0 : _o.visitor) === null || _p === void 0 ? void 0 : _p.autoChannel) === null || _q === void 0 ? void 0 : _q.ping;
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `manualCheckin:status.${status}`;
        if (status !== "success") return key;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        status,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>$db45dfc051e0ec4c$var$__awaiter(void 0, void 0, void 0, function*() {
            var _r, _s, _t;
            const id = (_r = data === null || data === void 0 ? void 0 : data.createGuest) === null || _r === void 0 ? void 0 : _r.id;
            const isFree = clientPlan && clientPlan === "free"; // const autoSMS = receiver?.availablePreferences?.visitor?.autoChannel?.sms;
            /**
     * Prefetch access event so we don't wait when on calling page
     */ yield queryClient.prefetchQuery([
                `access/event/${id}`
            ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                    id: id
                })).catch(()=>null); /**
                            * Can the user be navigated to contact page based on permissions and cations
                            *
                            * - Has to be non free user
                            * - Access must belong to a visitor that is checking in
                            * - Employee has to have a phone number set
                            * - Employee has to have at least one notification channel enabled
                            */ 
            const canContinue = !isFree && id && status === "success" && (receiver === null || receiver === void 0 ? void 0 : receiver.phone);
            if (canContinue) {
                if (autoCall || autoPing) {
                    setCalling(true);
                    return navigate(`/access/checkin/manual/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                        replace: true
                    });
                } // if (!!autoSMS) {
                //   return navigate("/", { replace: true });
                // }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))((_t = (_s = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _s === void 0 ? void 0 : _s.visitor) === null || _t === void 0 ? void 0 : _t.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                    replace: true
                });
            } /**
       * Reset modal on error state
       */ 
            if (status === "error") return reset();
            return navigate("/", {
                replace: true
            });
        }), [
        status,
        data
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", field = "", value = "")=>{
        switch(field){
            case "EmployeeList":
            case "Text":
                if (!value || value.slice(-1) === " ") return "default-shift";
                return "default";
            case "Phone":
                return "phone-pad";
            case "Number":
                return "pin";
            case "Email":
                return "email";
            default:
                return layout;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, registrationFields[0].type, ""));
    }, [
        registrationFields
    ]);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        var _a;
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        let prevValue = methods.getValues(focusedInput) || "";
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $db45dfc051e0ec4c$var$getFieldType((focusedInput === null || focusedInput === void 0 ? void 0 : focusedInput.split(".").pop()) || "Text", registrationFields), value));
        if (focusedInput === "contact") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            setValue("contact", {
                label: value
            });
        } else setValue(focusedInput, value);
         /**
       * Update caret position of text input
       */ 
        if (input) {
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            const type = $db45dfc051e0ec4c$var$getFieldType((focusedInput === null || focusedInput === void 0 ? void 0 : focusedInput.split(".").pop()) || "Text", registrationFields);
            if (type === "Phone" || type === "Number") (_a = keyboard.current) === null || _a === void 0 || _a.setCaretPosition(prevValue.length < value.length ? prevValue.length + 1 : value.length, prevValue.length < value.length ? prevValue.length + 1 : value.length);
            else input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _a;
        if (event.target && [
            "INPUT",
            "TEXTAREA"
        ].includes((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName)) return;
        setFocusedInput(undefined);
    });
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; // trackEvent({ type: "input_focus", value: `visitor_${name}` });
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $db45dfc051e0ec4c$var$getFieldType((name === null || name === void 0 ? void 0 : name.split(".").pop()) || "Text", registrationFields), value));
        setFocusedInput(name);
    }, []);
    const onSubmit = (0, $eZVvM.useCallback)(({ info: info, contact: contact, files: files })=>{
        // trackEvent({ type: "notify_button_click", value: "visitor" });
        let input = {
            info: Object.fromEntries(Object.entries(info).filter(([key, value])=>value !== "").map(([key, value])=>{
                const type = $db45dfc051e0ec4c$var$getFieldType(key, registrationFields);
                if (type === "Phone") return [
                    key,
                    (0, $2bc546ee6dbb8ac5$export$176bb591929cc9a8)(value).number
                ];
                return [
                    key,
                    value
                ];
            })),
            employee: contact === null || contact === void 0 ? void 0 : contact.id
        };
        if (files) input = Object.assign(Object.assign({}, input), {
            screen: screen,
            acceptedAgreements: files
        });
        mutate(input, {
            onSuccess () {},
            onError () {}
        });
    }, [
        mutate
    ]); // eslint-disable-next-line consistent-return
    const onBeforeSubmit = (0, $eZVvM.useCallback)((variables)=>{
        if (Array.isArray(unacceptedAgreements) && unacceptedAgreements.length > 0) {
            if (showFirst) return onSubmit(Object.assign(Object.assign({}, variables), {
                files: unacceptedAgreements.map((a)=>a.id)
            }));
            return setPendingAgreements(unacceptedAgreements);
        }
        onSubmit(variables);
    }, []); /**
           * Synchronize text caret position with virtual keyboard
           */ 
    const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []); /**
           * Synchronize text input with virtual keyboard
           */ 
    const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event; /**
                * Skip if there is no virtual keyboard
                */ 
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $db45dfc051e0ec4c$var$getFieldType((name === null || name === void 0 ? void 0 : name.split(".").pop()) || "Text", registrationFields), value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onCountryInputChange = (0, $eZVvM.useCallback)((value)=>{
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $db45dfc051e0ec4c$var$getFieldType("Phone", registrationFields), value));
        keyboard.current.setInput(value, "phone");
        keyboard.current.setCaretPosition(value.length, value.length);
        setValue("info.phone", value);
        setFocusedInput("info.phone");
    }, []);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), Object.assign({}, methods, {
                children: (0, $bhfvP.jsxs)("div", Object.assign({
                    className: "d-flex align-items-center flex-column"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $3pTPw.default), {
                            to: (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) ? "/access/option/checkin" : "/"
                        }),
                        (0, $bhfvP.jsxs)((0, $8YEKz.default), Object.assign({
                            disableAnimation: !mainRoute
                        }, {
                            children: [
                                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                    variant: "h1"
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                        i18nKey: "manualCheckin:title"
                                    })
                                })),
                                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                    variant: "h4",
                                    className: "font-weight-regular"
                                }, {
                                    children: t("manualCheckin:subtitle")
                                }))
                            ]
                        })),
                        (0, $bhfvP.jsx)("div", {
                            children: (0, $bhfvP.jsxs)("form", Object.assign({
                                className: "form d-flex flex-column",
                                autoComplete: "off",
                                onSubmit: handleSubmit(onBeforeSubmit)
                            }, {
                                children: [
                                    (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinGrid, Object.assign({
                                        container: true,
                                        justifyContent: "center",
                                        alignItems: "center",
                                        columnGap: 4
                                    }, {
                                        children: registrationFields.map((field, i)=>{
                                            if (field.type === "Text" || field.type === "Number") return (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06
                                            }, {
                                                children: (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinField, {
                                                    children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: Object.assign({}, field.required && {
                                                            required: t("manualCheckin:error.required")
                                                        }),
                                                        render: (_a)=>{
                                                            var _b;
                                                            var _c = _a.field, { onChange: onChange, ref: ref, value: value } = _c, rest = $db45dfc051e0ec4c$var$__rest(_c, [
                                                                "onChange",
                                                                "ref",
                                                                "value"
                                                            ]), { fieldState: { error: error } } = _a;
                                                            return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, rest, {
                                                                error: !!error,
                                                                helperText: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : " ",
                                                                type: field.type.toLowerCase(),
                                                                autoFocus: i === 0,
                                                                inputRef: ref,
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: value,
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus
                                                            }));
                                                        }
                                                    })
                                                })
                                            }), field.code);
                                            if (field.type === "Email") return (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06
                                            }, {
                                                children: (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinField, {
                                                    children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: Object.assign(Object.assign({}, field.required && {
                                                            required: t("manualCheckin:error.required")
                                                        }), {
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                                message: t("manualCheckin:error.email")
                                                            }
                                                        }),
                                                        render: (_a)=>{
                                                            var _b;
                                                            var _c = _a.field, { onChange: onChange, ref: ref } = _c, rest = $db45dfc051e0ec4c$var$__rest(_c, [
                                                                "onChange",
                                                                "ref"
                                                            ]), { fieldState: { error: error } } = _a;
                                                            return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, rest, {
                                                                error: !!error,
                                                                helperText: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : " ",
                                                                inputRef: ref,
                                                                autoFocus: i === 0,
                                                                type: (0, $k9qks.isVirtualKeyboardEnabled) ? "text" : "email",
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: rest.value || "",
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus
                                                            }));
                                                        }
                                                    })
                                                })
                                            }), field.code);
                                            if (field.type === "Phone") return (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06
                                            }, {
                                                children: (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinField, {
                                                    children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: Object.assign(Object.assign({}, field.required && {
                                                            required: t("manualCheckin:error.required")
                                                        }), {
                                                            validate: (value)=>{
                                                                return !value || (0, $4b02a3aa0d676adb$export$992e2df24bec72ba)(value) || t("manualCheckin:error.phone");
                                                            }
                                                        }),
                                                        render: (_a)=>{
                                                            var _b;
                                                            var _c = _a.field, { ref: ref, onChange: onChange } = _c, rest = $db45dfc051e0ec4c$var$__rest(_c, [
                                                                "ref",
                                                                "onChange"
                                                            ]), { fieldState: { error: error } } = _a;
                                                            return (0, $bhfvP.jsx)((0, $bb50b4d24b214940$export$5d5d29ff8b7e8a02), Object.assign({}, rest, {
                                                                error: !!error,
                                                                inputRef: ref,
                                                                variant: "outlined",
                                                                autoFocus: i === 0,
                                                                helperText: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : " ",
                                                                defaultCountry: defaultCountry,
                                                                preferredCountries: preferredCountries,
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: rest.value || "",
                                                                onSelect: (e)=>{
                                                                    onInputChange(e);
                                                                    onChange(e.target.value);
                                                                },
                                                                onChange: (input)=>{
                                                                    onChange(input);
                                                                    onCountryInputChange(input);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus
                                                            }));
                                                        }
                                                    })
                                                })
                                            }), field.code);
                                            if (field.type === "EmployeeList") return (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06
                                            }, {
                                                children: (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinField, {
                                                    children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: "contact",
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: t("manualCheckin:error.required")
                                                            },
                                                            validate: {
                                                                exists: (value)=>{
                                                                    if (!(value && (value === null || value === void 0 ? void 0 : value.id))) return t("manualCheckin:error.required");
                                                                    return true;
                                                                }
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                            return (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                                clearOnBlur: true,
                                                                blurOnSelect: true,
                                                                disableClearable: true,
                                                                disablePortal: true,
                                                                autoFocus: i === 0,
                                                                noOptionsText: t("manualCheckin:noOption"),
                                                                // PopperComponent={PopperTop}
                                                                value: !!(value && value.id) ? value : null,
                                                                options: contactList,
                                                                getOptionLabel: (option)=>option.label || "",
                                                                isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                                renderOption: (props, option)=>(0, $aNuUP.createElement)("li", Object.assign({}, props, {
                                                                        key: option.id
                                                                    }), option.label),
                                                                onChange: (_event, newValue, reason)=>{
                                                                    if (reason === "selectOption") onChange(newValue); // trackEvent({
                                                                },
                                                                onBlur: ()=>{
                                                                    const currentValue = methods.getValues(name);
                                                                    if (!!(currentValue && currentValue.id)) return;
                                                                    if (keyboard.current) keyboard.current.setInput("", name);
                                                                    onChange(undefined);
                                                                },
                                                                inputValue: !!(value && value.label) ? value.label : "",
                                                                renderInput: (params)=>{
                                                                    var _a;
                                                                    return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, params, {
                                                                        error: !!error,
                                                                        helperText: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : " ",
                                                                        type: "text",
                                                                        name: "contact",
                                                                        variant: "outlined",
                                                                        autoCapitalize: "sentences",
                                                                        label: t("manualCheckin:placeholder.contactName"),
                                                                        className: error && "error__field",
                                                                        onChange: (event)=>{
                                                                            const { target: { value: value } } = event;
                                                                            onInputChange(event);
                                                                            onChange({
                                                                                label: value
                                                                            });
                                                                        },
                                                                        onFocus: onInputFocus,
                                                                        onSelect: onInputSelect
                                                                    }));
                                                                }
                                                            });
                                                        }
                                                    })
                                                })
                                            }), field.code);
                                            return (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06
                                            }, {
                                                children: (0, $bhfvP.jsx)($db45dfc051e0ec4c$var$ManualCheckinField, {
                                                    children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: Object.assign({}, field.required && {
                                                            required: t("manualCheckin:error.required")
                                                        }),
                                                        render: (_a)=>{
                                                            var _b;
                                                            var _c = _a.field, { onChange: onChange, ref: ref, value: value } = _c, rest = $db45dfc051e0ec4c$var$__rest(_c, [
                                                                "onChange",
                                                                "ref",
                                                                "value"
                                                            ]), { fieldState: { error: error } } = _a;
                                                            return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, rest, {
                                                                error: !!error,
                                                                helperText: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : " ",
                                                                inputRef: ref,
                                                                autoFocus: i === 0,
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: value,
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus,
                                                                autoComplete: "chrome-off"
                                                            }));
                                                        }
                                                    })
                                                })
                                            }), field.code);
                                        })
                                    })),
                                    (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                        disabled: !mainRoute,
                                        delay: 0.6
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                                            className: "mx-auto",
                                            style: {
                                                width: "56.5rem"
                                            }
                                        }, {
                                            children: (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                                                variant: "contained",
                                                className: "w-100",
                                                onClick: handleSubmit(onBeforeSubmit)
                                            }, {
                                                children: t("manualCheckin:btn")
                                            }))
                                        }))
                                    }))
                                ]
                            }))
                        }),
                        status !== "idle" && !calling && (0, $bhfvP.jsx)((0, $lM7US.default), {
                            status: status,
                            // @ts-ignore
                            title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${translationKey}.title`
                            }),
                            // @ts-ignore
                            message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${translationKey}.message`
                            }),
                            onDismiss: onDismiss
                        }),
                        (0, $k9qks.isVirtualKeyboardEnabled) && (0, $bhfvP.jsx)("div", Object.assign({
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            }
                        }, {
                            children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        }))
                    ]
                }))
            })),
            (0, $bhfvP.jsx)((0, $481129126104bb44$export$2e2bcd8739ae039), {
                aggrements: pendingAgreements,
                onDismiss: ()=>{
                    return navigate("/");
                },
                onSubmit: (id)=>{
                    setPendingAgreements((prev)=>{
                        const [accepted, ...rest] = prev;
                        methods.setValue("files", [
                            ...methods.getValues("files") || [],
                            id
                        ]);
                        if (!showFirst && !rest.length) methods.handleSubmit(onSubmit)();
                        return rest;
                    });
                }
            }),
            (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $db45dfc051e0ec4c$export$2e2bcd8739ae039 = $db45dfc051e0ec4c$var$ManualCheckin;



var $aNuUP = parcelRequire("aNuUP");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $dMu0R = parcelRequire("dMu0R");



var $8TMnn = parcelRequire("8TMnn");


var $ljukC = parcelRequire("ljukC");




var $81BVN = parcelRequire("81BVN");


var $b275P = parcelRequire("b275P");

var $8YEKz = parcelRequire("8YEKz");

var $lM7US = parcelRequire("lM7US");

var $3pTPw = parcelRequire("3pTPw");


var $ezhXm = parcelRequire("ezhXm");

var $jnPOB = parcelRequire("jnPOB");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $hJePx = parcelRequire("hJePx");

var $kCXUJ = parcelRequire("kCXUJ");

var $cD0nt = parcelRequire("cD0nt");


var $44b1f2a8401da349$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $44b1f2a8401da349$var$ManualCheckout = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)();
    const navigate = (0, $9B9bN.useNavigate)();
    const [layout, setLayout] = (0, $eZVvM.useState)("default");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("name");
    const identificationCode = (0, $cD0nt.useIdentificationCode)();
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const [nameForList, setNameForList] = (0, $eZVvM.useState)("");
    const [checkoutList, setCheckoutList] = (0, $eZVvM.useState)([]);
    const { checkout: checkout } = (0, $cD0nt.useLayout)();
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: {
            name: undefined
        },
        mode: "onSubmit"
    });
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const { isLoading: isLoading } = (0, $dMu0R.useQuery)([
        "currentlyCheckedIn",
        {
            filter: {
                owner: {
                    fullName: nameForList,
                    guestMatch: {
                        code: identificationCode,
                        value: nameForList
                    }
                }
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_CURRENTLY_CHECKED_IN), variables), {
        enabled: nameForList.length === 2,
        onSuccess: (data)=>{
            var _a;
            const list = (0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))((_a = data === null || data === void 0 ? void 0 : data.currentlyCheckedIn) === null || _a === void 0 ? void 0 : _a.events, (accessEvent)=>{
                var _a;
                const owner = (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "owner");
                let label = "";
                if ("fullName" in owner) label = owner.fullName;
                else if ("fields" in owner) label = ((_a = owner.fields.find((field)=>field.name === "fullName" || field.name === identificationCode)) === null || _a === void 0 ? void 0 : _a.value) || "";
                return {
                    label: label,
                    id: accessEvent.owner.id
                };
            });
            setCheckoutList(list);
        }
    });
    (0, $eZVvM.useEffect)(()=>{
        if (nameForList.length < 3) setCheckoutList([]);
    }, [
        nameForList
    ]);
    const { data: data, status: requestStatus, mutate: onCheckoutOwner, reset: reset } = (0, $084aaf38c3338203$export$609860bf8b0084c)((id)=>$44b1f2a8401da349$var$__awaiter(void 0, void 0, void 0, function*() {
            return (0, $jnPOB.client).request((0, $hJePx.MUTATION_CHECKOUT_OWNER), {
                id: id
            });
        }));
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (status === "success") return navigate("/", {
            replace: true
        });
        if (status === "error") return reset();
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", _field = "", value = "")=>{
        if (layout === "default-alt") return layout;
         // Capitalize after whitespace and at start
        if (!value || value.slice(-1) === " ") return "default-shift";
        return "default";
    }, []);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        if (value.length === 2) setNameForList(value);
        if (value.length === 1) setNameForList("");
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        if (!focusedInput) return;
        let prevValue = methods.getValues(focusedInput);
        setLayout((prevLayout)=>{
            const nextLayout = getLayoutForFieldAndValue(prevLayout, focusedInput, value);
            return nextLayout;
        });
        if (focusedInput === "name") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            methods.setValue("name", {
                label: value
            });
        } else methods.setValue(focusedInput, value);
        if (!prevValue) return;
         /**
       * Update caret position of text input
       */ 
        if (input) {
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _a;
        if (event.target && ((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    const onSubmit = (0, $eZVvM.useCallback)((variables)=>{
        return onCheckoutOwner(variables.name.id);
    }, []); /**
           * Synchronize text caret position with virtual keyboard
           */ 
    const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; /**
                * Skip if there is no virtual keyboard
                */ 
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        setFocusedInput(name);
    }, []); /**
           * Synchronize text input with virtual keyboard
           */ 
    const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event; /**
                * Skip if there is no virtual keyboard
                */ 
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), Object.assign({}, methods, {
                children: (0, $bhfvP.jsxs)("div", Object.assign({
                    className: "d-flex align-items-center flex-column"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $3pTPw.default), {
                            to: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? "/access/option/checkout" : "/"
                        }),
                        (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                            className: "page-title"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h1"
                            }, {
                                children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "manualCheckout:title"
                                })
                            }))
                        })),
                        (0, $bhfvP.jsxs)("form", Object.assign({
                            className: "form d-flex flex-column",
                            autoComplete: "off",
                            onSubmit: methods.handleSubmit(onSubmit)
                        }, {
                            children: [
                                (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                    delay: 0.55
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                                        className: "search-input"
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                            name: "name",
                                            rules: {
                                                required: {
                                                    value: true,
                                                    message: t("manualCheckout:error.required")
                                                },
                                                validate: {
                                                    exists: (value)=>{
                                                        if (!(value && value.id)) return t("manualCheckout:error.required");
                                                        return true;
                                                    }
                                                }
                                            },
                                            render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                return (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                    clearOnBlur: true,
                                                    blurOnSelect: true,
                                                    disableClearable: true,
                                                    loading: isLoading,
                                                    loadingText: t("manualCheckout:form.loading"),
                                                    noOptionsText: t("manualCheckout:form.noOptions"),
                                                    open: nameForList.length > 0,
                                                    onClose: ()=>{
                                                        setNameForList("");
                                                    },
                                                    value: !!(value && value.id) ? value : null,
                                                    options: checkoutList,
                                                    getOptionLabel: (option)=>option.label || "",
                                                    isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                    renderOption: (props, option)=>(0, $aNuUP.createElement)("li", Object.assign({}, props, {
                                                            key: option.id
                                                        }), option.label),
                                                    onChange: (_event, newValue, reason)=>{
                                                        if (reason === "selectOption") onChange(newValue);
                                                    },
                                                    onBlur: ()=>{
                                                        const currentValue = methods.getValues(name);
                                                        if (!!(currentValue && currentValue.id)) return;
                                                        if (keyboard.current) keyboard.current.setInput("", name);
                                                        onChange(undefined);
                                                    },
                                                    inputValue: !!(value && value.label) ? value.label : "",
                                                    renderInput: (params)=>{
                                                        var _a;
                                                        return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, params, {
                                                            type: "text",
                                                            name: "name",
                                                            variant: "outlined",
                                                            autoFocus: true,
                                                            error: !!error,
                                                            helperText: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : " ",
                                                            label: t("manualCheckout:form.placeholder.name"),
                                                            onChange: (event)=>{
                                                                const { target: { value: value } } = event;
                                                                if (value.length === 2) setNameForList(value);
                                                                if (value.length === 1) setNameForList("");
                                                                onInputChange(event);
                                                                onChange({
                                                                    label: value
                                                                });
                                                            },
                                                            onFocus: onInputFocus,
                                                            onSelect: onInputSelect
                                                        }));
                                                    }
                                                });
                                            }
                                        })
                                    }))
                                })),
                                (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                    delay: 0.65
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                                        className: "w-100"
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                                            variant: "contained",
                                            onClick: methods.handleSubmit(onSubmit),
                                            className: "mt-4 w-100"
                                        }, {
                                            children: t("manualCheckout:btn")
                                        }))
                                    }))
                                }))
                            ]
                        })),
                        (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                            mode: "wait"
                        }, {
                            children: status !== "idle" && (0, $bhfvP.jsx)((0, $lM7US.default), {
                                title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `manualCheckout:status.${status}.title`
                                }),
                                message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `manualCheckout:status.${status}.message`
                                }),
                                status: status,
                                onDismiss: onDismiss
                            })
                        })),
                        (0, $bhfvP.jsx)("div", Object.assign({
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            }
                        }, {
                            children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        }))
                    ]
                }))
            })),
            (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $44b1f2a8401da349$export$2e2bcd8739ae039 = $44b1f2a8401da349$var$ManualCheckout;



var $aNuUP = parcelRequire("aNuUP");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");





var $ljukC = parcelRequire("ljukC");




var $81BVN = parcelRequire("81BVN");


var $b275P = parcelRequire("b275P");

var $8YEKz = parcelRequire("8YEKz");

var $lM7US = parcelRequire("lM7US");

var $3pTPw = parcelRequire("3pTPw");


var $ezhXm = parcelRequire("ezhXm");

var $jnPOB = parcelRequire("jnPOB");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $k9qks = parcelRequire("k9qks");

var $hJePx = parcelRequire("hJePx");

var $kCXUJ = parcelRequire("kCXUJ");


var $219y6 = parcelRequire("219y6");

var $cD0nt = parcelRequire("cD0nt");

var $d00d6a5c0ee9ff60$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d00d6a5c0ee9ff60$var$DeliveryPage = ()=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const match = (0, $9B9bN.useMatch)({
        path: "/delivery/:action"
    });
    const action = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.action;
    const namespace = action === "food" ? "foodDelivery" : "packageDelivery";
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/delivery\/${action}\/?$`).test(pathname);
    const { t: t } = (0, $9GLBV.useTranslation)([
        namespace
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const clientPlan = (0, $cD0nt.useClientPlan)(); // usePageTracking({
    //   page: action,
    // });
    // const { trackEvent } = useEventTracking();
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const [layout, setLayout] = (0, $eZVvM.useState)("default");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)(undefined);
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: {
            contact: undefined
        },
        mode: "onSubmit"
    });
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const { data: employeesData } = (0, $dMu0R.useQuery)([
        "employees",
        {
            filter: {
                preferences: {
                    [namespace]: {
                        enabled: {
                            EQ: true
                        }
                    }
                }
            },
            pagination: {
                limit: 99999
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_EMPLOYEES), variables));
    const employees = (0, $eZVvM.useMemo)(()=>employeesData === null || employeesData === void 0 ? void 0 : employeesData.employees, [
        employeesData
    ]);
    const contactList = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(employees, (employee)=>({
                id: employee.id,
                label: employee.fullName
            })), [
        employeesData
    ]);
    const { data: data, status: requestStatus, mutate: onCreateDeliveryEvent } = (0, $084aaf38c3338203$export$609860bf8b0084c)((input)=>$d00d6a5c0ee9ff60$var$__awaiter(void 0, void 0, void 0, function*() {
            var _q;
            const response = yield (0, $jnPOB.client).request((0, $hJePx.MUTATION_CREATE_DELIVERY_EVENT), {
                input: input
            });
            const accessScanId = (_q = response === null || response === void 0 ? void 0 : response.createDeliveryEvent) === null || _q === void 0 ? void 0 : _q.id; /**
                                                                                                                                                              * Prefetch access event so we don't wait when on contact page
                                                                                                                                                              */ 
            yield queryClient.prefetchQuery([
                `access/event/${accessScanId}`
            ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                    id: accessScanId
                })).catch(()=>null);
            return response;
        }));
    const receiver = (_b = data === null || data === void 0 ? void 0 : data.createDeliveryEvent) === null || _b === void 0 ? void 0 : _b.receiver;
    const autoEmail = (_e = (_d = (_c = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _c === void 0 ? void 0 : _c[`${action}Delivery`]) === null || _d === void 0 ? void 0 : _d.autoChannel) === null || _e === void 0 ? void 0 : _e.email;
    const autoSMS = (_h = (_g = (_f = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _f === void 0 ? void 0 : _f[`${action}Delivery`]) === null || _g === void 0 ? void 0 : _g.autoChannel) === null || _h === void 0 ? void 0 : _h.sms;
    const autoCall = (_l = (_k = (_j = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _j === void 0 ? void 0 : _j[`${action}Delivery`]) === null || _k === void 0 ? void 0 : _k.autoChannel) === null || _l === void 0 ? void 0 : _l.call;
    const autoPing = (_p = (_o = (_m = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _m === void 0 ? void 0 : _m[`${action}Delivery`]) === null || _o === void 0 ? void 0 : _o.autoChannel) === null || _p === void 0 ? void 0 : _p.ping;
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `${namespace}:status.${status}`;
        if (status !== "success") return key;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        namespace,
        status,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        var _a, _b, _c;
        const id = (_a = data === null || data === void 0 ? void 0 : data.createDeliveryEvent) === null || _a === void 0 ? void 0 : _a.id;
        const isFree = clientPlan && clientPlan === "free"; /**
                                                         * Can the user be navigated to contact page based on permissions and cations
                                                         *
                                                         * - Has to be non free user
                                                         * - Employee has to have a phone number set
                                                         * - Employee has to have at least one notification channel enabled
                                                         */ 
        const canContinue = !isFree && !!id && status === "success" && !!(receiver === null || receiver === void 0 ? void 0 : receiver.phone);
        if (canContinue) {
            if (!!autoCall || !!autoPing) {
                setCalling(true);
                return navigate(`/delivery/${action}/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                    replace: true
                });
            } // if (!!autoSMS) {
            //   return navigate("/", { replace: true });
            // }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))((_c = (_b = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _b === void 0 ? void 0 : _b[namespace]) === null || _c === void 0 ? void 0 : _c.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                replace: true
            });
        }
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", _field = "", value = "")=>{
        if (layout === "default-alt") return layout;
         // Capitalize after whitespace and at start
        if (!value || value.slice(-1) === " ") return "default-shift";
        return "default";
    }, []);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        if (!focusedInput) return;
        let prevValue = methods.getValues(focusedInput);
        setLayout((prevLayout)=>{
            const nextLayout = getLayoutForFieldAndValue(prevLayout, focusedInput, value);
            return nextLayout;
        });
        if (focusedInput === "contact") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            methods.setValue("contact", {
                label: value
            });
        } else methods.setValue(focusedInput, value);
        if (!prevValue) return;
         /**
       * Update caret position of text input
       */ 
        if (input) {
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _a;
        if (event.target && ((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    const onSubmit = (0, $eZVvM.useCallback)((variables)=>{
        const input = {
            type: action === "package" ? "Package" : "Food",
            employee: variables.contact.id
        }; // trackEvent({ type: "notify_button_click", value: action });
        return onCreateDeliveryEvent(input, {
            onSuccess () {},
            onError () {}
        });
    }, []); /**
           * Synchronize text caret position with virtual keyboard
           */ 
    const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; /**
                * Skip if there is no virtual keyboard
                */ 
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        setFocusedInput(name);
    }, []); /**
           * Synchronize text input with virtual keyboard
           */ 
    const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event; /**
                * Skip if there is no virtual keyboard
                */ 
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    return (0, $bhfvP.jsxs)((0, $ezhXm.default), {
        children: [
            (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), Object.assign({}, methods, {
                children: (0, $bhfvP.jsxs)("div", Object.assign({
                    className: "d-flex align-items-center flex-column"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $3pTPw.default), {
                            to: "/"
                        }),
                        (0, $bhfvP.jsxs)((0, $8YEKz.default), Object.assign({
                            disableAnimation: !mainRoute
                        }, {
                            children: [
                                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                    variant: "h1"
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                        i18nKey: `${namespace}:title`
                                    })
                                })),
                                (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                    variant: "h3",
                                    className: "font-weight-regular mt-3"
                                }, {
                                    children: t(`${namespace}:subtitle`)
                                }))
                            ]
                        })),
                        (0, $bhfvP.jsxs)("form", Object.assign({
                            className: "form d-flex flex-column",
                            autoComplete: "off",
                            onSubmit: methods.handleSubmit(onSubmit)
                        }, {
                            children: [
                                (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                    disabled: !mainRoute,
                                    delay: 0.5
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                                        className: "search-input"
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                            name: "contact",
                                            rules: {
                                                required: {
                                                    value: true,
                                                    message: t(`${namespace}:input.error.contact.required`)
                                                },
                                                validate: {
                                                    exists: (value)=>{
                                                        if (!(value && value.id)) return t(`${namespace}:input.error.contact.required`);
                                                        return true;
                                                    }
                                                }
                                            },
                                            render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                return (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                    clearOnBlur: true,
                                                    blurOnSelect: true,
                                                    disableClearable: true,
                                                    value: !!(value && value.id) ? value : null,
                                                    options: contactList,
                                                    getOptionLabel: (option)=>option.label || "",
                                                    isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                    renderOption: (props, option)=>(0, $aNuUP.createElement)("li", Object.assign({}, props, {
                                                            key: option.id
                                                        }), option.label),
                                                    onChange: (_event, newValue, reason)=>{
                                                        if (reason === "selectOption") onChange(newValue); // trackEvent({ type: "contact_select", value: action });
                                                    },
                                                    onBlur: ()=>{
                                                        const currentValue = methods.getValues(name);
                                                        if (!!(currentValue && currentValue.id)) return;
                                                        if (keyboard.current) keyboard.current.setInput("", name);
                                                        onChange(undefined);
                                                    },
                                                    inputValue: !!(value && value.label) ? value.label : "",
                                                    renderInput: (params)=>{
                                                        var _a;
                                                        return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), Object.assign({}, params, {
                                                            type: "text",
                                                            name: "contact",
                                                            variant: "outlined",
                                                            error: !!error,
                                                            helperText: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : " ",
                                                            label: t(`${namespace}:input.label.contact`),
                                                            className: error && "error__field",
                                                            onChange: (event)=>{
                                                                const { target: { value: value } } = event;
                                                                onInputChange(event);
                                                                onChange({
                                                                    label: value
                                                                });
                                                            },
                                                            onFocus: onInputFocus,
                                                            onSelect: onInputSelect
                                                        }));
                                                    }
                                                });
                                            }
                                        })
                                    }))
                                })),
                                (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                    disabled: !mainRoute,
                                    delay: 0.6
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                                        className: "w-100"
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                                            variant: "contained",
                                            className: "mx-1 w-100",
                                            disabled: !online,
                                            onClick: methods.handleSubmit(onSubmit)
                                        }, {
                                            children: t(`${namespace}:button.submit`)
                                        }))
                                    }))
                                }))
                            ]
                        })),
                        (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                            mode: "wait"
                        }, {
                            children: status !== "idle" && !calling && (0, $bhfvP.jsx)((0, $lM7US.default), {
                                status: status,
                                // @ts-ignore
                                title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `${translationKey}.title`
                                }),
                                // @ts-ignore
                                message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `${translationKey}.message`
                                }),
                                onDismiss: onDismiss
                            })
                        })),
                        (0, $k9qks.isVirtualKeyboardEnabled) && (0, $bhfvP.jsx)("div", Object.assign({
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            }
                        }, {
                            children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        }))
                    ]
                }))
            })),
            (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d00d6a5c0ee9ff60$export$2e2bcd8739ae039 = $d00d6a5c0ee9ff60$var$DeliveryPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $gdPnm = parcelRequire("gdPnm");

var $ljukC = parcelRequire("ljukC");


var $81BVN = parcelRequire("81BVN");

var $b275P = parcelRequire("b275P");

var $cD0nt = parcelRequire("cD0nt");

var $8YEKz = parcelRequire("8YEKz");

var $lM7US = parcelRequire("lM7US");

var $3pTPw = parcelRequire("3pTPw");

var $jnPOB = parcelRequire("jnPOB");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $hJePx = parcelRequire("hJePx");

var $kCXUJ = parcelRequire("kCXUJ");


var $ezhXm = parcelRequire("ezhXm");

var $bzcXF = parcelRequire("bzcXF");

var $eGmvL = parcelRequire("eGmvL");
var $d5a11803cc5f787b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d5a11803cc5f787b$var$CustomDeliveryPage = ()=>{
    var _a, _b;
    const match = (0, $9B9bN.useMatch)({
        path: "/custom-delivery/:action"
    });
    const action = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.action;
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/custom-delivery\/${action}\/?$`).test(pathname);
    const namespace = action === "food" ? "foodDelivery" : "packageDelivery";
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { t: t } = (0, $9GLBV.useTranslation)([
        namespace
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const deliveryReceiver = (0, $cD0nt.useDeliveryReceiver)();
    const { data: data, status: requestStatus, mutate: onCreateCustomDeliveryEvent } = (0, $084aaf38c3338203$export$609860bf8b0084c)((input)=>$d5a11803cc5f787b$var$__awaiter(void 0, void 0, void 0, function*() {
            var _c;
            const response = yield (0, $jnPOB.client).request((0, $hJePx.MUTATION_CREATE_CUSTOM_DELIVERY_EVENT), {
                input: input
            });
            const accessScanId = (_c = response === null || response === void 0 ? void 0 : response.createCustomDeliveryEvent) === null || _c === void 0 ? void 0 : _c.id; /**
                                                                                                                                                                    * Prefetch access event so we don't wait when on contact page
                                                                                                                                                                    */ 
            yield queryClient.prefetchQuery([
                `access/event/${accessScanId}`
            ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                    id: accessScanId
                })).catch(()=>null);
            return response;
        }));
    const receiver = (_b = data === null || data === void 0 ? void 0 : data.createCustomDeliveryEvent) === null || _b === void 0 ? void 0 : _b.customReceiver;
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `${namespace}:status.${status}`;
        if (status !== "success") return key;
        let messageType = "no-email-sms";
        if (!!(receiver === null || receiver === void 0 ? void 0 : receiver.phone)) messageType = "call-ping";
        else messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        namespace,
        status,
        receiver === null || receiver === void 0 ? void 0 : receiver.phone
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        var _a;
        const id = (_a = data === null || data === void 0 ? void 0 : data.createCustomDeliveryEvent) === null || _a === void 0 ? void 0 : _a.id;
        const isFree = clientPlan && clientPlan === "free";
        const canContinue = !isFree && !!id && status === "success" && !!(receiver === null || receiver === void 0 ? void 0 : receiver.phone);
        if (canContinue) {
            setCalling(true);
            return navigate(`/custom-delivery/${action}/contact/${id}/call`, {
                replace: true
            });
        }
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 6000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    const onSubmit = (0, $eZVvM.useCallback)(()=>{
        if (!((deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email) || (deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.fullName))) return;
        const input = {
            type: action === "package" ? "Package" : "Food",
            receiver: Object.assign({
                fullName: deliveryReceiver.fullName,
                email: deliveryReceiver.email
            }, deliveryReceiver.phone && {
                phone: deliveryReceiver.phone
            })
        };
        onCreateCustomDeliveryEvent(input);
    }, [
        onCreateCustomDeliveryEvent,
        deliveryReceiver,
        action
    ]);
    return (0, $bhfvP.jsx)((0, $ezhXm.default), {
        children: (0, $bhfvP.jsxs)("div", Object.assign({
            className: "d-flex align-items-center flex-column"
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $3pTPw.default), {
                    to: "/"
                }),
                (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                    disableAnimation: !mainRoute
                }, {
                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                        variant: "h1",
                        className: "delivery-title"
                    }, {
                        children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${namespace}:title`
                        })
                    }))
                })),
                (0, $bhfvP.jsxs)((0, $eGmvL.default), Object.assign({
                    className: "text-center"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h3",
                            className: "font-weight-regular mt-5"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${namespace}:subtitle1`
                            })
                        })),
                        (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h4",
                            className: "font-weight-regular mt-4 mb-5"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${namespace}:subtitle2`
                            })
                        }))
                    ]
                })),
                (0, $bhfvP.jsx)((0, $bzcXF.default), Object.assign({
                    disabled: !mainRoute
                }, {
                    children: (0, $bhfvP.jsx)((0, $ljukC.motion).div, Object.assign({
                        style: {
                            width: "54rem"
                        }
                    }, {
                        children: (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                            variant: "contained",
                            className: "mx-1 mt-5 py-5 w-100",
                            onClick: onSubmit
                        }, {
                            children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h3",
                                className: "text-white"
                            }, {
                                children: t(`${namespace}:button.submit`)
                            }))
                        }))
                    }))
                })),
                (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                    mode: "wait"
                }, {
                    children: status !== "idle" && !calling && (0, $bhfvP.jsx)((0, $lM7US.default), {
                        status: status,
                        // @ts-ignore
                        title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${translationKey}.title`
                        }),
                        // @ts-ignore
                        message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${translationKey}.message`
                        }),
                        onDismiss: onDismiss
                    })
                })),
                (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
                (0, $bhfvP.jsx)((0, $648bc4d76c5ac4a8$export$2e2bcd8739ae039), {})
            ]
        }))
    });
};
var $d5a11803cc5f787b$export$2e2bcd8739ae039 = $d5a11803cc5f787b$var$CustomDeliveryPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $jnPOB = parcelRequire("jnPOB");

var $lM7US = parcelRequire("lM7US");

var $cD0nt = parcelRequire("cD0nt");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $hJePx = parcelRequire("hJePx");

var $kCXUJ = parcelRequire("kCXUJ");


var $e8b4810c61f91d9e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e8b4810c61f91d9e$var$Scanning = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const navigate = (0, $9B9bN.useNavigate)(); // const { search } = useLocation();
    const { code: code, action: action } = (0, $9B9bN.useParams)(); // const query = useMemo(() => qs.parse(search), [search]);
    // const qr = query.qr ? "qr_" : "";
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const queryClient = (0, $gdPnm.useQueryClient)(); // const { trackEvent } = useEventTracking();
    const { screen: screen, unacceptedAgreements: unacceptedAgreements } = (0, $537fa6077f9ab8f6$export$991b23a188dc1bb5)();
    const { data: data, status: requestStatus } = (0, $dMu0R.useQuery)([
        `scan/${code}`
    ], ()=>$e8b4810c61f91d9e$var$__awaiter(void 0, void 0, void 0, function*() {
            var _u;
            let input = {
                code: code
            };
            if (action) input = Object.assign(Object.assign({}, input), {
                action: action === "checkout" ? "checkOut" : "checkIn"
            });
            if (Array.isArray(unacceptedAgreements) && unacceptedAgreements.length > 0) input = Object.assign(Object.assign({}, input), {
                acceptedAgreements: unacceptedAgreements.map((agreement)=>agreement.id),
                screen: screen
            });
            const response = yield (0, $jnPOB.client).request((0, $hJePx.MUTATION_ACCESS_SCAN), {
                input: input
            });
            const accessScanId = (_u = response === null || response === void 0 ? void 0 : response.accessScan) === null || _u === void 0 ? void 0 : _u.id; /**
                                                                                                                                                     * Prefetch access event so we don't wait when on contact page
                                                                                                                                                     */ 
            yield queryClient.prefetchQuery([
                `access/event/${accessScanId}`
            ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                    id: accessScanId
                })).catch(()=>null);
            return response;
        }), {
        cacheTime: 0,
        staleTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
        onSuccess () {
        //   type: `${qr}code_scan`,
        //   value: `${data?.accessScan?.type
        //     ?.replace(/([a-z])([A-Z])/, "$1_$2")
        //     .toLowerCase()}_${action || "checkin"}_success`,
        // });
        },
        onError () {
        //   type: `${qr}code_scan`,
        //   value: `${action || "checkin"}_error`,
        // });
        }
    });
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const id = (_a = data === null || data === void 0 ? void 0 : data.accessScan) === null || _a === void 0 ? void 0 : _a.id;
    const type = (_b = data === null || data === void 0 ? void 0 : data.accessScan) === null || _b === void 0 ? void 0 : _b.type;
    const metadata = (_c = data === null || data === void 0 ? void 0 : data.accessScan) === null || _c === void 0 ? void 0 : _c.metadata;
    const fullName = (_e = (_d = data === null || data === void 0 ? void 0 : data.accessScan) === null || _d === void 0 ? void 0 : _d.owner) === null || _e === void 0 ? void 0 : _e.fullName;
    const receiver = (_f = data === null || data === void 0 ? void 0 : data.accessScan) === null || _f === void 0 ? void 0 : _f.receiver;
    const autoEmail = (_j = (_h = (_g = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _g === void 0 ? void 0 : _g.meetingAttendee) === null || _h === void 0 ? void 0 : _h.autoChannel) === null || _j === void 0 ? void 0 : _j.email;
    const autoSMS = (_m = (_l = (_k = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _k === void 0 ? void 0 : _k.meetingAttendee) === null || _l === void 0 ? void 0 : _l.autoChannel) === null || _m === void 0 ? void 0 : _m.sms;
    const autoCall = (_q = (_p = (_o = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _o === void 0 ? void 0 : _o.meetingAttendee) === null || _p === void 0 ? void 0 : _p.autoChannel) === null || _q === void 0 ? void 0 : _q.call;
    const autoPing = (_t = (_s = (_r = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _r === void 0 ? void 0 : _r.meetingAttendee) === null || _s === void 0 ? void 0 : _s.autoChannel) === null || _t === void 0 ? void 0 : _t.ping;
    const direction = (0, $eZVvM.useMemo)(()=>{
        if (data) return !!(metadata && "checkOut" in metadata) ? "checkout" : "checkin";
        return action || "checkin";
    }, [
        data
    ]);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `check:status.${status}`;
        if (!(status === "success" && type)) return key;
        if (direction === "checkout" || type !== "MeetingAttendee") return `${key}.${direction}.${type}`;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${direction}.${type}.${messageType}`;
    }, [
        status,
        direction,
        type,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        var _a, _b;
        /**
     * If attendee employee check in successfully,
     * redirect him to the contact screen
     */ const isFree = clientPlan && clientPlan === "free"; /**
                                                         * Can the user be navigated to contact page based on permissions and cations
                                                         *
                                                         * - Has to be non free user
                                                         * - Access must belong to a visitor that is checking in
                                                         * - Employee has to have a phone number set
                                                         * - Employee has to have at least one notification channel enabled
                                                         */ 
        const canContinue = !isFree && id && direction === "checkin" && status === "success" && type === "MeetingAttendee" && (receiver === null || receiver === void 0 ? void 0 : receiver.phone);
        if (canContinue) {
            if (autoCall || autoPing) return navigate(`/access/checkin/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                replace: true
            });
             // if (!!autoSMS) {
            //   return navigate("/", { replace: true });
            // }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))((_b = (_a = receiver === null || receiver === void 0 ? void 0 : receiver.availablePreferences) === null || _a === void 0 ? void 0 : _a.meetingAttendee) === null || _b === void 0 ? void 0 : _b.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                replace: true
            });
        } /**
       * In case there was an error, try to redirect the user to where he came from in order to retry the action
       */ 
        if (status === "error") return navigate(-1);
        return navigate("/");
    }, [
        id,
        direction,
        status,
        type,
        action
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 3000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    return (0, $bhfvP.jsx)((0, $lM7US.default), {
        title: // @ts-expect-error
        (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `${translationKey}.title`,
            values: {
                fullName: fullName
            }
        }),
        message: // @ts-expect-error
        (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `${translationKey}.message`,
            values: {
                fullName: fullName
            }
        }),
        status: status,
        onDismiss: onDismiss
    });
});
const $e8b4810c61f91d9e$var$ScanningWithAgreement = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { unacceptedAgreements: unacceptedAgreements, showFirst: showFirst } = (0, $537fa6077f9ab8f6$export$991b23a188dc1bb5)(); // prettier-ignore
    const [pendingAgreements, setPendingAgreements] = (0, $eZVvM.useState)(!showFirst && unacceptedAgreements ? unacceptedAgreements : []);
    if (!!(Array.isArray(pendingAgreements) && pendingAgreements.length > 0)) return (0, $bhfvP.jsx)((0, $481129126104bb44$export$2e2bcd8739ae039), {
        aggrements: pendingAgreements,
        onDismiss: ()=>{
            navigate("/");
        },
        onSubmit: ()=>{
            setPendingAgreements((prev)=>{
                const [_accepted, ...rest] = prev;
                return rest;
            });
        }
    });
    return (0, $bhfvP.jsx)($e8b4810c61f91d9e$var$Scanning, {});
};
var $e8b4810c61f91d9e$export$2e2bcd8739ae039 = $e8b4810c61f91d9e$var$ScanningWithAgreement;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");


var $kvR7a = parcelRequire("kvR7a");

var $8TMnn = parcelRequire("8TMnn");




var $81BVN = parcelRequire("81BVN");



var $b275P = parcelRequire("b275P");

var $cD0nt = parcelRequire("cD0nt");

var $aOIYu = parcelRequire("aOIYu");

var $jnPOB = parcelRequire("jnPOB");

var $lM7US = parcelRequire("lM7US");

var $8YEKz = parcelRequire("8YEKz");

var $3pTPw = parcelRequire("3pTPw");


var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $34EAI = parcelRequire("34EAI");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $ljukC = parcelRequire("ljukC");

var $e8m2I = parcelRequire("e8m2I");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $2825253bc8f618b1$var$TableContext = /*#__PURE__*/ $eZVvM.createContext();
var $2825253bc8f618b1$export$2e2bcd8739ae039 = $2825253bc8f618b1$var$TableContext;



var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $14df835c08c4cfc5$export$315cb19215f77ce0(slot) {
    return (0, $8QgsE.default)("MuiTable", slot);
}
const $14df835c08c4cfc5$var$tableClasses = (0, $dvQev.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $14df835c08c4cfc5$export$2e2bcd8739ae039 = $14df835c08c4cfc5$var$tableClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $db79de1a297ed967$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $db79de1a297ed967$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $14df835c08c4cfc5$export$315cb19215f77ce0), classes);
};
const $db79de1a297ed967$var$TableRoot = (0, $e8m2I.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $65o8X.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $db79de1a297ed967$var$defaultComponent = "table";
const $db79de1a297ed967$var$Table = /*#__PURE__*/ $eZVvM.forwardRef(function Table(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $db79de1a297ed967$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $7Z8DW.default)(props, $db79de1a297ed967$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $db79de1a297ed967$var$useUtilityClasses(ownerState);
    const table = $eZVvM.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2825253bc8f618b1$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($db79de1a297ed967$var$TableRoot, (0, $65o8X.default)({
            as: component,
            role: component === $db79de1a297ed967$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $fmwLG.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $db79de1a297ed967$export$2e2bcd8739ae039 = $db79de1a297ed967$var$Table;






var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $81BVN = parcelRequire("81BVN");

var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c1362b6727a9c743$var$_excluded = [
    "className",
    "id"
];
const $c1362b6727a9c743$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $5b54c0043a945c99$export$f5d2ec7e4c47e088), classes);
};
const $c1362b6727a9c743$var$DialogTitleRoot = (0, $e8m2I.default)((0, $81BVN.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $c1362b6727a9c743$var$DialogTitle = /*#__PURE__*/ $eZVvM.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $7Z8DW.default)(props, $c1362b6727a9c743$var$_excluded);
    const ownerState = props;
    const classes = $c1362b6727a9c743$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $eZVvM.useContext((0, $c6eb0b1012d622bb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c1362b6727a9c743$var$DialogTitleRoot, (0, $65o8X.default)({
        component: "h2",
        className: (0, $fmwLG.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $c1362b6727a9c743$export$2e2bcd8739ae039 = $c1362b6727a9c743$var$DialogTitle;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $7f83dacee02c3385$var$Tablelvl2Context = /*#__PURE__*/ $eZVvM.createContext();
var $7f83dacee02c3385$export$2e2bcd8739ae039 = $7f83dacee02c3385$var$Tablelvl2Context;



var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $39fe9b73ab291a1b$export$98bd2a9b566ec665(slot) {
    return (0, $8QgsE.default)("MuiTableBody", slot);
}
const $39fe9b73ab291a1b$var$tableBodyClasses = (0, $dvQev.default)("MuiTableBody", [
    "root"
]);
var $39fe9b73ab291a1b$export$2e2bcd8739ae039 = $39fe9b73ab291a1b$var$tableBodyClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9fcfd65a6f660c02$var$_excluded = [
    "className",
    "component"
];
const $9fcfd65a6f660c02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $39fe9b73ab291a1b$export$98bd2a9b566ec665), classes);
};
const $9fcfd65a6f660c02$var$TableBodyRoot = (0, $e8m2I.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $9fcfd65a6f660c02$var$tablelvl2 = {
    variant: "body"
};
const $9fcfd65a6f660c02$var$defaultComponent = "tbody";
const $9fcfd65a6f660c02$var$TableBody = /*#__PURE__*/ $eZVvM.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $9fcfd65a6f660c02$var$defaultComponent } = props, other = (0, $7Z8DW.default)(props, $9fcfd65a6f660c02$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component
    });
    const classes = $9fcfd65a6f660c02$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7f83dacee02c3385$export$2e2bcd8739ae039).Provider, {
        value: $9fcfd65a6f660c02$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($9fcfd65a6f660c02$var$TableBodyRoot, (0, $65o8X.default)({
            className: (0, $fmwLG.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $9fcfd65a6f660c02$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $9fcfd65a6f660c02$export$2e2bcd8739ae039 = $9fcfd65a6f660c02$var$TableBody;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");

var $iDCHz = parcelRequire("iDCHz");



var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $a419e745007941da$export$33a0f07a16a10b1b(slot) {
    return (0, $8QgsE.default)("MuiTableCell", slot);
}
const $a419e745007941da$var$tableCellClasses = (0, $dvQev.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $a419e745007941da$export$2e2bcd8739ae039 = $a419e745007941da$var$tableCellClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $44fabe1c086da0e8$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $44fabe1c086da0e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $iDCHz.default)(align)}`,
            padding !== "normal" && `padding${(0, $iDCHz.default)(padding)}`,
            `size${(0, $iDCHz.default)(size)}`
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $a419e745007941da$export$33a0f07a16a10b1b), classes);
};
const $44fabe1c086da0e8$var$TableCellRoot = (0, $e8m2I.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $iDCHz.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $iDCHz.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $iDCHz.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $9b0pf.lighten)((0, $9b0pf.alpha)(theme.palette.divider, 1), 0.88) : (0, $9b0pf.darken)((0, $9b0pf.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $a419e745007941da$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $44fabe1c086da0e8$var$TableCell = /*#__PURE__*/ $eZVvM.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $7Z8DW.default)(props, $44fabe1c086da0e8$var$_excluded);
    const table = $eZVvM.useContext((0, $2825253bc8f618b1$export$2e2bcd8739ae039));
    const tablelvl2 = $eZVvM.useContext((0, $7f83dacee02c3385$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $65o8X.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $44fabe1c086da0e8$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $3pI8R.jsx)($44fabe1c086da0e8$var$TableCellRoot, (0, $65o8X.default)({
        as: component,
        ref: ref,
        className: (0, $fmwLG.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $44fabe1c086da0e8$export$2e2bcd8739ae039 = $44fabe1c086da0e8$var$TableCell;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");


var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $2413846fa386dab9$export$2e731cea2d1c2392(slot) {
    return (0, $8QgsE.default)("MuiTableHead", slot);
}
const $2413846fa386dab9$var$tableHeadClasses = (0, $dvQev.default)("MuiTableHead", [
    "root"
]);
var $2413846fa386dab9$export$2e2bcd8739ae039 = $2413846fa386dab9$var$tableHeadClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $ccb518d543a08c0b$var$_excluded = [
    "className",
    "component"
];
const $ccb518d543a08c0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $2413846fa386dab9$export$2e731cea2d1c2392), classes);
};
const $ccb518d543a08c0b$var$TableHeadRoot = (0, $e8m2I.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $ccb518d543a08c0b$var$tablelvl2 = {
    variant: "head"
};
const $ccb518d543a08c0b$var$defaultComponent = "thead";
const $ccb518d543a08c0b$var$TableHead = /*#__PURE__*/ $eZVvM.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $ccb518d543a08c0b$var$defaultComponent } = props, other = (0, $7Z8DW.default)(props, $ccb518d543a08c0b$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component
    });
    const classes = $ccb518d543a08c0b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7f83dacee02c3385$export$2e2bcd8739ae039).Provider, {
        value: $ccb518d543a08c0b$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($ccb518d543a08c0b$var$TableHeadRoot, (0, $65o8X.default)({
            as: component,
            className: (0, $fmwLG.default)(classes.root, className),
            ref: ref,
            role: component === $ccb518d543a08c0b$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $ccb518d543a08c0b$export$2e2bcd8739ae039 = $ccb518d543a08c0b$var$TableHead;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $9b0pf = parcelRequire("9b0pf");


var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $55a199f1d3fd1128$export$ba0a6d6c28940107(slot) {
    return (0, $8QgsE.default)("MuiTableRow", slot);
}
const $55a199f1d3fd1128$var$tableRowClasses = (0, $dvQev.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $55a199f1d3fd1128$export$2e2bcd8739ae039 = $55a199f1d3fd1128$var$tableRowClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4c0efebf189cf88c$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $4c0efebf189cf88c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $55a199f1d3fd1128$export$ba0a6d6c28940107), classes);
};
const $4c0efebf189cf88c$var$TableRowRoot = (0, $e8m2I.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $55a199f1d3fd1128$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $55a199f1d3fd1128$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $9b0pf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $4c0efebf189cf88c$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $4c0efebf189cf88c$var$TableRow = /*#__PURE__*/ $eZVvM.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $4c0efebf189cf88c$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $7Z8DW.default)(props, $4c0efebf189cf88c$var$_excluded);
    const tablelvl2 = $eZVvM.useContext((0, $7f83dacee02c3385$export$2e2bcd8739ae039));
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $4c0efebf189cf88c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($4c0efebf189cf88c$var$TableRowRoot, (0, $65o8X.default)({
        as: component,
        ref: ref,
        className: (0, $fmwLG.default)(classes.root, className),
        role: component === $4c0efebf189cf88c$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $4c0efebf189cf88c$export$2e2bcd8739ae039 = $4c0efebf189cf88c$var$TableRow;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");



var $9HTTf = parcelRequire("9HTTf");


var $e8m2I = parcelRequire("e8m2I");

var $8C83T = parcelRequire("8C83T");





var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $fmwLG = parcelRequire("fmwLG");

var $9HTTf = parcelRequire("9HTTf");

var $8C83T = parcelRequire("8C83T");

var $e8m2I = parcelRequire("e8m2I");

var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $6561b46deff9f921$export$b12cb262231eef32(slot) {
    return (0, $8QgsE.default)("MuiToolbar", slot);
}
const $6561b46deff9f921$var$toolbarClasses = (0, $dvQev.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $6561b46deff9f921$export$2e2bcd8739ae039 = $6561b46deff9f921$var$toolbarClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $22d70a0651fbcda7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $22d70a0651fbcda7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $6561b46deff9f921$export$b12cb262231eef32), classes);
};
const $22d70a0651fbcda7$var$ToolbarRoot = (0, $e8m2I.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $22d70a0651fbcda7$var$Toolbar = /*#__PURE__*/ $eZVvM.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $7Z8DW.default)(props, $22d70a0651fbcda7$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $22d70a0651fbcda7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($22d70a0651fbcda7$var$ToolbarRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $fmwLG.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $22d70a0651fbcda7$export$2e2bcd8739ae039 = $22d70a0651fbcda7$var$Toolbar;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $21257f7b239802c1$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $49723fd6a07cbebb$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");



parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $093d0b931c936d4d$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $bd17771ae11f0f75$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4fbe1ba91e0af990$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $4fbe1ba91e0af990$var$TablePaginationActions = /*#__PURE__*/ $eZVvM.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $7Z8DW.default)(props, $4fbe1ba91e0af990$var$_excluded);
    const isRtl = (0, $d97d98e83b9fa62c$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $bd17771ae11f0f75$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $093d0b931c936d4d$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $49723fd6a07cbebb$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $21257f7b239802c1$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $3pI8R.jsxs)("div", (0, $65o8X.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonSlot, (0, $65o8X.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonIcon, (0, $65o8X.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonIcon, (0, $65o8X.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonSlot, (0, $65o8X.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonIcon, (0, $65o8X.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonIcon, (0, $65o8X.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonSlot, (0, $65o8X.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonIcon, (0, $65o8X.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonIcon, (0, $65o8X.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonSlot, (0, $65o8X.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonIcon, (0, $65o8X.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonIcon, (0, $65o8X.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $4fbe1ba91e0af990$export$2e2bcd8739ae039 = $4fbe1ba91e0af990$var$TablePaginationActions;



"use client";
var $a58721cd01f32473$export$2e2bcd8739ae039 = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039);



var $dvQev = parcelRequire("dvQev");

var $8QgsE = parcelRequire("8QgsE");
function $d2e1a6cb1af65901$export$909e637b22246f4c(slot) {
    return (0, $8QgsE.default)("MuiTablePagination", slot);
}
const $d2e1a6cb1af65901$var$tablePaginationClasses = (0, $dvQev.default)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
var $d2e1a6cb1af65901$export$2e2bcd8739ae039 = $d2e1a6cb1af65901$var$tablePaginationClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $e537ef0a6120e2f7$var$_InputBase;
const $e537ef0a6120e2f7$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $e537ef0a6120e2f7$var$TablePaginationRoot = (0, $e8m2I.default)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const $e537ef0a6120e2f7$var$TablePaginationToolbar = (0, $e8m2I.default)((0, $22d70a0651fbcda7$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, $65o8X.default)({
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $e537ef0a6120e2f7$var$TablePaginationSpacer = (0, $e8m2I.default)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const $e537ef0a6120e2f7$var$TablePaginationSelectLabel = (0, $e8m2I.default)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $e537ef0a6120e2f7$var$TablePaginationSelect = (0, $e8m2I.default)((0, $22932f6b5a031346$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, $65o8X.default)({
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const $e537ef0a6120e2f7$var$TablePaginationMenuItem = (0, $e8m2I.default)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $e537ef0a6120e2f7$var$TablePaginationDisplayedRows = (0, $e8m2I.default)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $e537ef0a6120e2f7$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $e537ef0a6120e2f7$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $e537ef0a6120e2f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, $9HTTf.default)(slots, (0, $d2e1a6cb1af65901$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $e537ef0a6120e2f7$var$TablePagination = /*#__PURE__*/ $eZVvM.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $8C83T.useDefaultProps)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent: ActionsComponent = (0, $4fbe1ba91e0af990$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $44fabe1c086da0e8$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $e537ef0a6120e2f7$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $e537ef0a6120e2f7$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = "Rows per page:", nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7Z8DW.default)(props, $e537ef0a6120e2f7$var$_excluded);
    const ownerState = props;
    const classes = $e537ef0a6120e2f7$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : $e537ef0a6120e2f7$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $44fabe1c086da0e8$export$2e2bcd8739ae039) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $a58721cd01f32473$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $a58721cd01f32473$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationRoot, (0, $65o8X.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $fmwLG.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)($e537ef0a6120e2f7$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSelect, (0, $65o8X.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $e537ef0a6120e2f7$var$_InputBase || ($e537ef0a6120e2f7$var$_InputBase = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $65o8X.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $fmwLG.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $fmwLG.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $fmwLG.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $eZVvM.createElement)(MenuItemComponent, (0, $65o8X.default)({}, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $3pI8R.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $e537ef0a6120e2f7$export$2e2bcd8739ae039 = $e537ef0a6120e2f7$var$TablePagination;



var $gdPnm = parcelRequire("gdPnm");

var $hJePx = parcelRequire("hJePx");

var $lM7US = parcelRequire("lM7US");

var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");

var $e7eqj = parcelRequire("e7eqj");

var $aOIYu = parcelRequire("aOIYu");

var $0b4fc5fb7d0293d6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $0b4fc5fb7d0293d6$var$CheckoutButton = (0, $e8m2I.default)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        fontSize: "2.5rem",
        width: "15rem",
        marginLeft: "2rem"
    }));
const $0b4fc5fb7d0293d6$var$List = (props)=>{
    const { rows: rows } = props;
    const { fields: fields } = (0, $cD0nt.useOverview)();
    const { width: width, height: height } = (0, $34EAI.default)();
    const rowsPerPage = width < height ? 7 : 2;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "overview"
    ]);
    const [page, setPage] = (0, $eZVvM.useState)(0);
    const [open, setOpen] = (0, $eZVvM.useState)(true);
    const [confirmModalId, setConfirmModalId] = (0, $eZVvM.useState)();
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const numberOfPages = Math.ceil(rows.length / rowsPerPage);
    const { status: requestStatus, mutate: onCheckoutOwner } = (0, $084aaf38c3338203$export$609860bf8b0084c)((id)=>$0b4fc5fb7d0293d6$var$__awaiter(void 0, void 0, void 0, function*() {
            return (0, $jnPOB.client).request((0, $hJePx.MUTATION_CHECKOUT_OWNER), {
                id: id
            });
        }));
    const status = (0, $e7eqj.useDebounceStatus)(requestStatus, 1500);
    const queryClient = (0, $gdPnm.useQueryClient)();
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (status === "success" || status === "error") {
            setOpen(false);
            queryClient.invalidateQueries({
                queryKey: [
                    "currentlyCheckedIn"
                ],
                refetchType: "all"
            });
        }
    }, [
        status
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 4000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    return (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            (0, $bhfvP.jsxs)((0, $db79de1a297ed967$export$2e2bcd8739ae039), {
                children: [
                    (0, $bhfvP.jsx)((0, $ccb518d543a08c0b$export$2e2bcd8739ae039), {
                        children: (0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                            delay: 0.1
                        }, {
                            children: (0, $bhfvP.jsxs)((0, $4c0efebf189cf88c$export$2e2bcd8739ae039), Object.assign({
                                component: (0, $ljukC.motion).tr
                            }, {
                                children: [
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("NAME")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        children: t(`overview:table.head.fullName`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("TYPE")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        children: t(`overview:table.head.type`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKIN_TIME")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        children: t(`overview:table.head.checkedinAt`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("HOST")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        children: t(`overview:table.head.host`)
                                    }),
                                    (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {})
                                ]
                            }))
                        }))
                    }),
                    (0, $bhfvP.jsx)((0, $9fcfd65a6f660c02$export$2e2bcd8739ae039), {
                        children: (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                            children: rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i)=>(0, $bhfvP.jsx)((0, $88e948d6321fcc02$export$2e2bcd8739ae039), Object.assign({
                                    delay: 0.15 + i * 0.05
                                }, {
                                    children: (0, $bhfvP.jsxs)((0, $4c0efebf189cf88c$export$2e2bcd8739ae039), Object.assign({
                                        component: (0, $ljukC.motion).tr
                                    }, {
                                        children: [
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("NAME")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), Object.assign({
                                                component: "th",
                                                scope: "row",
                                                className: "text-secondary"
                                            }, {
                                                children: row.fullName
                                            })),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("TYPE")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: t(`overview:table.type.${row.type}`)
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKIN_TIME")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: row.checkinAt
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("HOST")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: row.host || "/"
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKOUT")) && (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: (0, $bhfvP.jsx)($0b4fc5fb7d0293d6$var$CheckoutButton, Object.assign({
                                                    variant: "contained",
                                                    size: "small",
                                                    onClick: ()=>{
                                                        setConfirmModalId(row.id);
                                                    }
                                                }, {
                                                    children: t("home:checkOut")
                                                }))
                                            }),
                                            (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), Object.assign({
                                                open: confirmModalId === row.id,
                                                onClose: ()=>{
                                                    setConfirmModalId(undefined);
                                                },
                                                sx: {
                                                    ".MuiPaper-root": {
                                                        paddingX: 5,
                                                        paddingY: 3,
                                                        animation: "moveUp 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)"
                                                    }
                                                }
                                            }, {
                                                children: [
                                                    (0, $bhfvP.jsx)((0, $c1362b6727a9c743$export$2e2bcd8739ae039), Object.assign({
                                                        className: "text-center mb-5",
                                                        fontSize: 32
                                                    }, {
                                                        children: t("overview:confirmModal.title", {
                                                            fullName: row.fullName
                                                        })
                                                    })),
                                                    (0, $bhfvP.jsxs)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), Object.assign({
                                                        className: "justify-content-center"
                                                    }, {
                                                        children: [
                                                            (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                                                                variant: "contained",
                                                                size: "small",
                                                                className: "mx-4 px-5",
                                                                onClick: ()=>{
                                                                    setConfirmModalId(undefined);
                                                                }
                                                            }, {
                                                                children: t("overview:confirmModal.cancel")
                                                            })),
                                                            (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), Object.assign({
                                                                variant: "contained",
                                                                size: "small",
                                                                className: "px-5",
                                                                onClick: ()=>{
                                                                    onCheckoutOwner(row.id);
                                                                    setConfirmModalId(undefined);
                                                                    setOpen(true);
                                                                }
                                                            }, {
                                                                children: t("overview:confirmModal.checkout")
                                                            }))
                                                        ]
                                                    }))
                                                ]
                                            }))
                                        ]
                                    }))
                                }), row.id))
                        })
                    })
                ]
            }),
            numberOfPages !== 1 && (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center mt-5 pt-3"
            }, {
                children: [
                    (0, $bhfvP.jsxs)("div", Object.assign({
                        style: {
                            fontSize: "2.7rem"
                        }
                    }, {
                        children: [
                            t("overview:page"),
                            " ",
                            (0, $bhfvP.jsxs)("span", Object.assign({
                                className: "ms-4"
                            }, {
                                children: [
                                    page + 1,
                                    " / ",
                                    numberOfPages
                                ]
                            }))
                        ]
                    })),
                    (0, $bhfvP.jsx)((0, $e537ef0a6120e2f7$export$2e2bcd8739ae039), {
                        component: "div",
                        count: rows.length,
                        rowsPerPage: rowsPerPage,
                        page: page,
                        onPageChange: handleChangePage
                    })
                ]
            })),
            (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                mode: "wait"
            }, {
                children: open && status !== "idle" && (0, $bhfvP.jsx)((0, $lM7US.default), {
                    title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `overview:checkoutStatus.${status}.title`
                    }),
                    message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `overview:checkoutStatus.${status}.message`
                    }),
                    status: status,
                    onDismiss: onDismiss
                })
            }))
        ]
    });
};
var $0b4fc5fb7d0293d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($0b4fc5fb7d0293d6$var$List);



var $ezhXm = parcelRequire("ezhXm");



var $kCXUJ = parcelRequire("kCXUJ");

var $k9qks = parcelRequire("k9qks");
var $9728bf3945e1f727$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9728bf3945e1f727$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $9728bf3945e1f727$var$getOwnerField = (owner, fieldName, identificationCode)=>{
    if (!owner) return "";
    if (fieldName in owner) return (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(owner, [
        fieldName
    ]);
    if ("fields" in owner) {
        const field = owner.fields.find((field)=>field.name === fieldName || field.name === identificationCode);
        return field ? field.value : "";
    }
    return "";
};
const $9728bf3945e1f727$var$OverviewPage = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "overview"
    ]);
    const [pinCode, setPinCode] = (0, (/*@__PURE__*/$parcel$interopDefault($ff7bcb23a771808b$exports)))($9728bf3945e1f727$var$defaultPinCode);
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    const [status, setStatus] = (0, $eZVvM.useState)();
    const [queryEnabled, setQueryEnabled] = (0, $eZVvM.useState)(false);
    const identificationCode = (0, $cD0nt.useIdentificationCode)();
    const [overviewList, setOverviewList] = (0, $eZVvM.useState)();
    (0, $dMu0R.useQuery)([
        "currentlyCheckedIn"
    ], ({ queryKey: [_key] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_CURRENTLY_CHECKED_IN), {
            pagination: {
                limit: 100000
            }
        }), {
        enabled: queryEnabled,
        onSuccess: (data)=>{
            var _a;
            const list = (0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))((_a = data === null || data === void 0 ? void 0 : data.currentlyCheckedIn) === null || _a === void 0 ? void 0 : _a.events, (accessEvent)=>{
                const checkinAt = (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "metadata.checkIn.date");
                return {
                    id: accessEvent.owner.id,
                    fullName: $9728bf3945e1f727$var$getOwnerField(accessEvent.owner, "fullName", identificationCode),
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "type"),
                    checkinAt: (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(checkinAt).format("DD-MM-YYYY / HH:mm"),
                    host: (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "receiver.fullName") || ""
                };
            });
            setOverviewList(list);
        }
    });
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const navigate = (0, $9B9bN.useNavigate)();
    const { code: overviewCode } = (0, $cD0nt.useOverview)();
    (0, $b275P.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        var _a;
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode({
                [focusedInput]: value
            });
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                if (document.activeElement) (_a = document.activeElement) === null || _a === void 0 || _a.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            if (pinCode[+focusedInput]) setPinCode({
                [focusedInput]: ""
            });
            else {
                setPinCode({
                    [+focusedInput - 1]: ""
                });
                const nextFocusedInput = Math.max(1, +focusedInput - 1);
                setFocusedInput(`${nextFocusedInput}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, (/*@__PURE__*/$parcel$interopDefault($f896ef6492898da5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e93d02b5708fd941$exports)))(6), (acc, key)=>Object.assign(Object.assign({}, acc), {
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, []);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event;
        setFocusedInput(`${+name}`);
        if (keyboard.current) keyboard.current.setInput("", name);
    }, []);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; /**
                * Blur when setting last input is set form keyboard
                */ 
        if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, []);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault();
                    const { name: name } = event === null || event === void 0 ? void 0 : event.currentTarget;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($9728bf3945e1f727$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 || element.addEventListener("beforeinput", onBeforeInput);
        }); // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 || element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                event.preventDefault();
                if (pinCode[+name]) setPinCode({
                    [name]: ""
                });
                else {
                    setPinCode({
                        [+name - 1]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                }
                break;
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        pinCode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _a;
        if (event.target && ((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    }); /**
       * Auto-focus input
       */ 
    (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const pinCodeArr = Object.values(pinCode);
        const timeout = setTimeout(()=>{
            if (pinCodeArr.every((input)=>input !== "")) {
                if (pinCodeArr.join("") === overviewCode) {
                    setStatus("success");
                    setQueryEnabled(true);
                    return;
                }
                setStatus("error");
            }
        }, 500);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pinCode
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>$9728bf3945e1f727$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            if (status === "success") setStatus(undefined);
            if (status === "error") {
                setStatus(undefined);
                setPinCode($9728bf3945e1f727$var$defaultPinCode);
                setFocusedInput("1");
                if (document.activeElement) (_a = document.activeElement) === null || _a === void 0 || _a.blur();
            }
        }), [
        status
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 4000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $aOIYu.useTimeoutFunction)(onDismiss, timeout);
    return (0, $bhfvP.jsx)((0, $ezhXm.default), {
        children: (0, $bhfvP.jsxs)("div", Object.assign({
            className: "d-flex align-items-center flex-column"
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $3pTPw.default), {
                    to: "/"
                }),
                !overviewList ? (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                            className: "page-title"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h1"
                            }, {
                                children: t(`overview:title`)
                            }))
                        })),
                        (0, $bhfvP.jsx)("form", Object.assign({
                            className: "pin__wrapper",
                            autoComplete: "off"
                        }, {
                            children: [
                                1,
                                2,
                                3,
                                4,
                                5,
                                6
                            ].map((i)=>(0, $bhfvP.jsx)((0, $9c5b8dd9cccd80bb$export$2e2bcd8739ae039), Object.assign({
                                    delay: 0.15 + 0.05 * i
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $4f24c342e6539ecf$export$75ee337032588709), {
                                        id: `${i}`,
                                        name: `${i}`,
                                        min: 0,
                                        max: 9,
                                        type: "password",
                                        className: "pin__input",
                                        autoComplete: "off",
                                        onFocus: onFocus,
                                        onChange: onChange,
                                        onKeyDown: onKeyDown,
                                        onPasteCapture: onPasteCapture,
                                        value: pinCode[i],
                                        maxLength: 1,
                                        pattern: "[0-9]*"
                                    })
                                }), i))
                        }))
                    ]
                }) : (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        (0, $bhfvP.jsx)((0, $8YEKz.default), Object.assign({
                            className: "page-title mb-5"
                        }, {
                            children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                variant: "h3"
                            }, {
                                children: t(`overview:listTitle`)
                            }))
                        })),
                        overviewList.length !== 0 ? (0, $bhfvP.jsx)((0, $0b4fc5fb7d0293d6$export$2e2bcd8739ae039), {
                            rows: overviewList
                        }) : (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                            variant: "h3",
                            className: "text-secondary"
                        }, {
                            children: t(`overview:noUsers`)
                        }))
                    ]
                }),
                (0, $bhfvP.jsx)("div", Object.assign({
                    ref: keyboardBox,
                    className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                        keyboard__out: !focusedInput
                    }),
                    onClick: (e)=>{
                        e.stopPropagation();
                    }
                }, {
                    children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                        ref: keyboard,
                        disableButtonHold: true,
                        layoutName: "pin",
                        inputName: focusedInput,
                        onChange: onKeyboardChange,
                        onKeyPress: onKeyboardKeyPress
                    })
                })),
                (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
                    mode: "wait"
                }, {
                    children: !!status && (0, $bhfvP.jsx)((0, $lM7US.default), {
                        title: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `overview:status.${status}.title`
                        }),
                        message: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `overview:status.${status}.message`
                        }),
                        status: status,
                        onDismiss: onDismiss
                    })
                }))
            ]
        }))
    });
};
var $9728bf3945e1f727$export$2e2bcd8739ae039 = $9728bf3945e1f727$var$OverviewPage;



var $bblWJ = parcelRequire("bblWJ");

var $bhfvP = parcelRequire("bhfvP");

var $81BVN = parcelRequire("81BVN");

var $dMu0R = parcelRequire("dMu0R");


var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $eZVvM = parcelRequire("eZVvM");
var $fbb21c0271b7a945$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, $eZVvM.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0, $eZVvM.useCallback)(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
var $fbb21c0271b7a945$export$2e2bcd8739ae039 = $fbb21c0271b7a945$var$useSetState;



var $jnPOB = parcelRequire("jnPOB");

var $bhfvP = parcelRequire("bhfvP");

var $e8m2I = parcelRequire("e8m2I");
var $81BVN = parcelRequire("81BVN");

var $eZVvM = parcelRequire("eZVvM");

var $k9qks = parcelRequire("k9qks");

var $jXblK = parcelRequire("jXblK");

var $2EcOP = parcelRequire("2EcOP");
const $1207bd3cae4cd5e9$var$PinInputField = (0, $e8m2I.default)("input")(({ theme: theme })=>({
        color: theme.palette.text.primary,
        borderColor: theme.palette.primary.main,
        background: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.background.default).lighten(0.1).hex(),
        "&:focus": {
            borderColor: theme.palette.primary.main,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($2EcOP)))(theme.palette.background.default).darken(0.07).hex()
        },
        "&.error": {
            borderColor: theme.palette.error.main
        }
    }));
const $1207bd3cae4cd5e9$var$DebugComponent = ({ value: value, children: children })=>{
    return (0, $bhfvP.jsxs)((0, $81BVN.default), Object.assign({
        variant: "h1"
    }, {
        children: [
            children,
            JSON.stringify(value, null, 2) + ""
        ]
    }));
};
const $1207bd3cae4cd5e9$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $1207bd3cae4cd5e9$var$PinInputs = ({ showValues: showValues = true, focusedInput: focusedInput, setFocusedInput: setFocusedInput, pinCode: pinCode, setPinCode: setPinCode, keyboard: keyboard })=>{
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, $jXblK.reduce)((0, $jXblK.times)(6), (acc, key)=>Object.assign(Object.assign({}, acc), {
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, [
        setPinCode
    ]);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event;
        setFocusedInput(`${+name}`);
        if (keyboard === null || keyboard === void 0 ? void 0 : keyboard.current) keyboard === null || keyboard === void 0 || keyboard.current.setInput("", name);
    }, [
        setFocusedInput
    ]);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event; /**
                * Blur when setting last input is set form keyboard
                */ 
        if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, [
        setFocusedInput
    ]);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                {
                    event.preventDefault();
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, []); /**
           * Auto-focus input
           */ 
    (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault(); // eslint-disable-next-line prefer-destructuring
                    const name = (event === null || event === void 0 ? void 0 : event.currentTarget).name;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($1207bd3cae4cd5e9$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 || element.addEventListener("beforeinput", onBeforeInput);
        }); // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 || element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    return (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: [
            1,
            2,
            3,
            4,
            5,
            6
        ].map((i)=>{
            const isPinBlank = pinCode[i].toString() === "";
            return (0, $bhfvP.jsx)($1207bd3cae4cd5e9$var$PinInputField, {
                id: `${i}`,
                name: `${i}`,
                min: 0,
                max: 9,
                inputMode: "numeric",
                type: (0, $k9qks.isVirtualKeyboardEnabled) || !showValues ? "text" : "number",
                className: "pin__input",
                autoComplete: "chrome-off",
                onFocus: onFocus,
                onChange: onChange,
                onKeyDown: onKeyDown,
                onPasteCapture: onPasteCapture,
                value: isPinBlank ? "" : showValues ? pinCode[i] : "*",
                maxLength: 1,
                pattern: "[0-9]*"
            }, i);
        })
    });
};
var $1207bd3cae4cd5e9$export$2e2bcd8739ae039 = $1207bd3cae4cd5e9$var$PinInputs;




var $k9qks = parcelRequire("k9qks");

var $kCXUJ = parcelRequire("kCXUJ");

var $219y6 = parcelRequire("219y6");
var $f211111843b79ac3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f211111843b79ac3$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $f211111843b79ac3$var$Activation = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "check"
    ]);
    const { storeData: storeData, getData: getData } = (0, $219y6.useOfflineContext)();
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    // inputted by user
    const [pinCode, setPinCode] = (0, $fbb21c0271b7a945$export$2e2bcd8739ae039)($f211111843b79ac3$var$defaultPinCode);
    const [code, setCode] = (0, $eZVvM.useState)("");
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        var _a;
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode(()=>({
                    [focusedInput]: value
                }));
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                if (document.activeElement) (_a = document.activeElement) === null || _a === void 0 || _a.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            setPinCode(()=>({
                    [focusedInput]: ""
                }));
            const nextFocusedInput = Math.max(1, +focusedInput - 1);
            setFocusedInput(`${nextFocusedInput}`);
        }
    }, [
        focusedInput
    ]);
    // const code = Object.values(pinCode).join("");
    const getCachedCode = (0, $eZVvM.useCallback)(()=>$f211111843b79ac3$var$__awaiter(void 0, void 0, void 0, function*() {
            return yield getData("/activation-code");
        }), []);
    (0, $eZVvM.useEffect)(()=>{
        const getCode = ()=>$f211111843b79ac3$var$__awaiter(void 0, void 0, void 0, function*() {
                const enteredCode = Object.values(pinCode).join("");
                if (!enteredCode) {
                    // get code from cache if the user has not entered any code
                    const { code: code } = (yield getCachedCode()) || {};
                    setCode(()=>code);
                    return;
                }
                setCode(()=>Object.values(pinCode).join(""));
            });
        getCode();
    }, [
        pinCode
    ]);
    (0, $dMu0R.useQuery)([
        "activation",
        code
    ], ()=>$f211111843b79ac3$var$__awaiter(void 0, void 0, void 0, function*() {
            try {
                const { digitalReceptionPublic: digitalReceptionPublic } = yield (0, $jnPOB.client).request((0, $kCXUJ.QUERY_DIGITAL_RECEPTION_PUBLIC), {
                    input: {
                        code: code
                    }
                });
                storeData("/activation-code", {
                    code: code
                });
                window.location.replace(digitalReceptionPublic.playerUrl);
            } catch (error) {
                setPinCode($f211111843b79ac3$var$defaultPinCode);
                setFocusedInput("1");
            }
        }), {
        enabled: !!code && code.length === 6,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnReconnect: true
    });
    return (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                variant: "h4",
                className: "font-weight-regular pin__title"
            }, {
                children: t("check:pinCode")
            })),
            (0, $bhfvP.jsx)("div", {
                children: (0, $bhfvP.jsx)((0, $1207bd3cae4cd5e9$export$2e2bcd8739ae039), {
                    showValues: false,
                    focusedInput: focusedInput,
                    setFocusedInput: setFocusedInput,
                    pinCode: pinCode,
                    setPinCode: setPinCode,
                    keyboard: keyboard
                })
            }),
            ((0, $k9qks.isVirtualKeyboardEnabled) || !(0, $k9qks.isPWA)) && (0, $bhfvP.jsx)("div", Object.assign({
                ref: keyboardBox,
                className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                    keyboard__out: !focusedInput
                }),
                onClick: (e)=>{
                    e.stopPropagation();
                }
            }, {
                children: (0, $bhfvP.jsx)((0, $bfea531d91d8f260$export$2e2bcd8739ae039), {
                    ref: keyboard,
                    disableButtonHold: true,
                    layoutName: "pin",
                    inputName: focusedInput,
                    onChange: onKeyboardChange,
                    onKeyPress: onKeyboardKeyPress
                })
            }))
        ]
    });
};
var $f211111843b79ac3$export$2e2bcd8739ae039 = $f211111843b79ac3$var$Activation;



var $dBZzI = parcelRequire("dBZzI");

var $kP4GY = parcelRequire("kP4GY");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $34EAI = parcelRequire("34EAI");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");



var $e8m2I = parcelRequire("e8m2I");

var $81BVN = parcelRequire("81BVN");

var $8YEKz = parcelRequire("8YEKz");

var $ezhXm = parcelRequire("ezhXm");

var $3pTPw = parcelRequire("3pTPw");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $ef2af67617581a1f$var$SvgMicrophone = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "Microphone_svg__bi Microphone_svg__bi-mic-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"
            })
        ]
    });
var $ef2af67617581a1f$export$2e2bcd8739ae039 = $ef2af67617581a1f$var$SvgMicrophone;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $52b2059741142620$var$SvgMicrophoneOff = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "MicrophoneOff_svg__bi MicrophoneOff_svg__bi-mic-mute-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z"
            })
        ]
    });
var $52b2059741142620$export$2e2bcd8739ae039 = $52b2059741142620$var$SvgMicrophoneOff;



var $hJePx = parcelRequire("hJePx");

var $jnPOB = parcelRequire("jnPOB");
var $2bf5abfadc040ec3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2bf5abfadc040ec3$var$MuiGridCell = (0, $e8m2I.default)((0, $de9b795dde6747fa$export$1ce951ee41d30605))(({ theme: theme })=>({
        borderRadius: "1rem",
        border: `0.5rem solid ${theme.palette.primary.main}`,
        background: "black"
    }));
const $2bf5abfadc040ec3$var$Controls = (0, $e8m2I.default)("div")({
    display: "flex",
    transform: "translateY(-100%)"
});
const $2bf5abfadc040ec3$var$ControlsButton = (0, $e8m2I.default)("div")(({ theme: theme })=>({
        display: "flex",
        padding: "2rem",
        margin: "1rem",
        border: "2px solid white",
        borderRadius: "1rem",
        background: "rgba(35, 35, 35, 0.725)",
        h1: {
            color: "white",
            marginRight: "1rem"
        }
    }));
const $2bf5abfadc040ec3$var$Room = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ roomUrl: roomUrl })=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { width: width, height: height } = (0, $34EAI.default)();
    const [isMicActive, setIsMicActive] = (0, $eZVvM.useState)(true);
    const orientation = width < height ? "portrait" : "landscape";
    const { state: state, actions: actions } = (0, $de9b795dde6747fa$export$e7be2adb7d898233)(roomUrl, {
        localMediaOptions: {
            audio: true,
            video: true
        }
    });
    const { remoteParticipants: remoteParticipants, connectionStatus: connectionStatus } = state;
    const { joinRoom: joinRoom, leaveRoom: leaveRoom, toggleCamera: toggleCamera, toggleMicrophone: toggleMicrophone } = actions;
    (0, $eZVvM.useEffect)(()=>{
        joinRoom();
        return ()=>{
            leaveRoom();
        };
    }, [
        joinRoom,
        leaveRoom
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (connectionStatus === "left") navigate("/");
    }, [
        connectionStatus
    ]);
    return (0, $bhfvP.jsx)("div", Object.assign({
        className: `${remoteParticipants.length === 0 && orientation === "landscape" ? "w-25" : "w-50"} ${remoteParticipants.length === 0 && orientation !== "landscape" ? "h-50" : "h-100"} p-5`
    }, {
        children: (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$9ca22f48fddba890), {
            videoGridGap: 10,
            renderParticipant: ({ participant: participant })=>{
                return (0, $bhfvP.jsxs)($2bf5abfadc040ec3$var$MuiGridCell, Object.assign({
                    participant: participant,
                    className: "video-grid-cell"
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$db6594055fbff7ab), {
                            muted: participant.isLocalClient
                        }),
                        connectionStatus === "connected" && participant.isLocalClient && (0, $bhfvP.jsxs)($2bf5abfadc040ec3$var$Controls, Object.assign({
                            className: "d-flex justify-content-between p-3"
                        }, {
                            children: [
                                (0, $bhfvP.jsx)($2bf5abfadc040ec3$var$ControlsButton, Object.assign({
                                    onClick: ()=>{
                                        leaveRoom();
                                    }
                                }, {
                                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                                        variant: "h3",
                                        className: "text-white"
                                    }, {
                                        children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                            i18nKey: "videoCall:endCall"
                                        })
                                    }))
                                })),
                                (0, $bhfvP.jsx)($2bf5abfadc040ec3$var$ControlsButton, Object.assign({
                                    onClick: ()=>{
                                        setIsMicActive((prev)=>!prev);
                                        toggleMicrophone();
                                    }
                                }, {
                                    children: isMicActive ? (0, $bhfvP.jsx)((0, $ef2af67617581a1f$export$2e2bcd8739ae039), {
                                        width: "3.5rem",
                                        fill: "white"
                                    }) : (0, $bhfvP.jsx)((0, $52b2059741142620$export$2e2bcd8739ae039), {
                                        width: "3.5rem",
                                        fill: "white"
                                    })
                                }))
                            ]
                        }))
                    ]
                }));
            }
        })
    }));
});
const $2bf5abfadc040ec3$var$VideoCall = ()=>{
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const roomId = query.roomId;
    const roomUrl = query.roomUrl;
    const { mutate: onLeaveRoom } = (0, $084aaf38c3338203$export$609860bf8b0084c)((id)=>$2bf5abfadc040ec3$var$__awaiter(void 0, void 0, void 0, function*() {
            return (0, $jnPOB.client).request((0, $hJePx.MUTATION_DELETE_VIDEO_ROOM), {
                id: id
            });
        }));
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            if (roomId) onLeaveRoom(roomId);
        };
    }, []);
    if (!(roomUrl && roomId)) return (0, $9B9bN.Navigate)({
        to: "/"
    });
    return (0, $bhfvP.jsx)((0, $ezhXm.default), {
        children: (0, $bhfvP.jsxs)("div", Object.assign({
            className: "d-flex align-items-center flex-column h-100"
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $3pTPw.default), {
                    to: "/"
                }),
                (0, $bhfvP.jsx)((0, $8YEKz.default), {
                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                        variant: "h1"
                    }, {
                        children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "videoCall:title"
                        })
                    }))
                }),
                (0, $bhfvP.jsx)($2bf5abfadc040ec3$var$Room, {
                    roomUrl: roomUrl
                })
            ]
        }))
    });
};
var $2bf5abfadc040ec3$export$2e2bcd8739ae039 = $2bf5abfadc040ec3$var$VideoCall;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $81BVN = parcelRequire("81BVN");

var $cD0nt = parcelRequire("cD0nt");

var $8YEKz = parcelRequire("8YEKz");

var $ezhXm = parcelRequire("ezhXm");

var $3pTPw = parcelRequire("3pTPw");

var $6CFWV = parcelRequire("6CFWV");
const $0affa3b06af5de24$var$Wifi = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const wifiQrCode = (0, $cD0nt.useWifiQrCode)();
    (0, $6CFWV.default)(()=>{
        navigate("/", {
            replace: true
        });
    }, 60000);
    if (!wifiQrCode) return (0, $9B9bN.Navigate)({
        to: "/"
    });
    return (0, $bhfvP.jsx)((0, $ezhXm.default), {
        children: (0, $bhfvP.jsxs)("div", Object.assign({
            className: "d-flex align-items-center flex-column h-100"
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $3pTPw.default), {
                    to: "/"
                }),
                (0, $bhfvP.jsx)((0, $8YEKz.default), {
                    children: (0, $bhfvP.jsx)((0, $81BVN.default), Object.assign({
                        variant: "h1"
                    }, {
                        children: (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "wifi:title"
                        })
                    }))
                }),
                (0, $bhfvP.jsx)("img", {
                    width: "80%",
                    alt: "Wi-Fi QR code",
                    src: wifiQrCode
                })
            ]
        }))
    });
});
var $0affa3b06af5de24$export$2e2bcd8739ae039 = $0affa3b06af5de24$var$Wifi;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

/**
 * Raw wav audio file contents
 * @typedef {Object} WavPackerAudioType
 * @property {Blob} blob
 * @property {string} url
 * @property {number} channelCount
 * @property {number} sampleRate
 * @property {number} duration
 */ /**
 * Utility class for assembling PCM16 "audio/wav" data
 * @class
 */ class $3b1d40bc464e20d1$export$13afda237b1c9846 {
    /**
   * Converts Float32Array of amplitude data to ArrayBuffer in Int16Array format
   * @param {Float32Array} float32Array
   * @returns {ArrayBuffer}
   */ static floatTo16BitPCM(float32Array) {
        const buffer = new ArrayBuffer(float32Array.length * 2);
        const view = new DataView(buffer);
        let offset = 0;
        for(let i = 0; i < float32Array.length; i++, offset += 2){
            let s = Math.max(-1, Math.min(1, float32Array[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
        return buffer;
    }
    /**
   * Concatenates two ArrayBuffers
   * @param {ArrayBuffer} leftBuffer
   * @param {ArrayBuffer} rightBuffer
   * @returns {ArrayBuffer}
   */ static mergeBuffers(leftBuffer, rightBuffer) {
        const tmpArray = new Uint8Array(leftBuffer.byteLength + rightBuffer.byteLength);
        tmpArray.set(new Uint8Array(leftBuffer), 0);
        tmpArray.set(new Uint8Array(rightBuffer), leftBuffer.byteLength);
        return tmpArray.buffer;
    }
    /**
   * Packs data into an Int16 format
   * @private
   * @param {number} size 0 = 1x Int16, 1 = 2x Int16
   * @param {number} arg value to pack
   * @returns
   */ _packData(size, arg) {
        return [
            new Uint8Array([
                arg,
                arg >> 8
            ]),
            new Uint8Array([
                arg,
                arg >> 8,
                arg >> 16,
                arg >> 24
            ])
        ][size];
    }
    /**
   * Packs audio into "audio/wav" Blob
   * @param {number} sampleRate
   * @param {{bitsPerSample: number, channels: Array<Float32Array>, data: Int16Array}} audio
   * @returns {WavPackerAudioType}
   */ pack(sampleRate, audio) {
        if (!(audio === null || audio === void 0 ? void 0 : audio.bitsPerSample)) throw new Error(`Missing "bitsPerSample"`);
        else if (!(audio === null || audio === void 0 ? void 0 : audio.channels)) throw new Error(`Missing "channels"`);
        else if (!(audio === null || audio === void 0 ? void 0 : audio.data)) throw new Error(`Missing "data"`);
        const { bitsPerSample: bitsPerSample, channels: channels, data: data } = audio;
        const output = [
            // Header
            "RIFF",
            this._packData(1, 52),
            // Length
            "WAVE",
            // chunk 1
            "fmt ",
            // Sub-chunk identifier
            this._packData(1, 16),
            // Chunk length
            this._packData(0, 1),
            // Audio format (1 is linear quantization)
            this._packData(0, channels.length),
            this._packData(1, sampleRate),
            this._packData(1, sampleRate * channels.length * bitsPerSample / 8),
            // Byte rate
            this._packData(0, channels.length * bitsPerSample / 8),
            this._packData(0, bitsPerSample),
            // chunk 2
            "data",
            // Sub-chunk identifier
            this._packData(1, channels[0].length * channels.length * bitsPerSample / 8),
            // Chunk length
            data
        ];
        const blob = new Blob(output, {
            type: "audio/mpeg"
        });
        const url = URL.createObjectURL(blob);
        return {
            blob: blob,
            url: url,
            channelCount: channels.length,
            sampleRate: sampleRate,
            duration: data.byteLength / (channels.length * sampleRate * 2)
        };
    }
}
globalThis.WavPacker = $3b1d40bc464e20d1$export$13afda237b1c9846;


/**
 * Constants for help with visualization
 * Helps map frequency ranges from Fast Fourier Transform
 * to human-interpretable ranges, notably music ranges and
 * human vocal ranges.
 */ // Eighth octave frequencies
const $7e36ff710ba19f08$var$octave8Frequencies = [
    4186.01,
    4434.92,
    4698.63,
    4978.03,
    5274.04,
    5587.65,
    5919.91,
    6271.93,
    6644.88,
    7040.0,
    7458.62,
    7902.13
];
// Labels for each of the above frequencies
const $7e36ff710ba19f08$var$octave8FrequencyLabels = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
const $7e36ff710ba19f08$export$776c63898ae5b636 = [];
const $7e36ff710ba19f08$export$facd167cc27ea9b0 = [];
for(let i = 1; i <= 8; i++)for(let f = 0; f < $7e36ff710ba19f08$var$octave8Frequencies.length; f++){
    const freq = $7e36ff710ba19f08$var$octave8Frequencies[f];
    $7e36ff710ba19f08$export$776c63898ae5b636.push(freq / Math.pow(2, 8 - i));
    $7e36ff710ba19f08$export$facd167cc27ea9b0.push($7e36ff710ba19f08$var$octave8FrequencyLabels[f] + i);
}
/**
 * Subset of the note frequencies between 32 and 2000 Hz
 * 6 octave range: C1 to B6
 */ const $7e36ff710ba19f08$var$voiceFrequencyRange = [
    32.0,
    2000.0
];
const $7e36ff710ba19f08$export$dbc1581ed2cfa183 = $7e36ff710ba19f08$export$776c63898ae5b636.filter((_, i)=>{
    return $7e36ff710ba19f08$export$776c63898ae5b636[i] > $7e36ff710ba19f08$var$voiceFrequencyRange[0] && $7e36ff710ba19f08$export$776c63898ae5b636[i] < $7e36ff710ba19f08$var$voiceFrequencyRange[1];
});
const $7e36ff710ba19f08$export$30a6f2881311088f = $7e36ff710ba19f08$export$facd167cc27ea9b0.filter((_, i)=>{
    return $7e36ff710ba19f08$export$776c63898ae5b636[i] > $7e36ff710ba19f08$var$voiceFrequencyRange[0] && $7e36ff710ba19f08$export$776c63898ae5b636[i] < $7e36ff710ba19f08$var$voiceFrequencyRange[1];
});


class $e3157d5b373e8220$export$2c3136da0bf130f9 {
    /**
   * Retrieves frequency domain data from an AnalyserNode adjusted to a decibel range
   * returns human-readable formatting and labels
   * @param {AnalyserNode} analyser
   * @param {number} sampleRate
   * @param {Float32Array} [fftResult]
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {AudioAnalysisOutputType}
   */ static getFrequencies(analyser, sampleRate, fftResult, analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!fftResult) {
            fftResult = new Float32Array(analyser.frequencyBinCount);
            analyser.getFloatFrequencyData(fftResult);
        }
        const nyquistFrequency = sampleRate / 2;
        const frequencyStep = 1 / fftResult.length * nyquistFrequency;
        let outputValues;
        let frequencies;
        let labels;
        if (analysisType === "music" || analysisType === "voice") {
            const useFrequencies = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$dbc1581ed2cfa183) : (0, $7e36ff710ba19f08$export$776c63898ae5b636);
            const aggregateOutput = Array(useFrequencies.length).fill(minDecibels);
            for(let i = 0; i < fftResult.length; i++){
                const frequency = i * frequencyStep;
                const amplitude = fftResult[i];
                for(let n = useFrequencies.length - 1; n >= 0; n--)if (frequency > useFrequencies[n]) {
                    aggregateOutput[n] = Math.max(aggregateOutput[n], amplitude);
                    break;
                }
            }
            outputValues = aggregateOutput;
            frequencies = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$dbc1581ed2cfa183) : (0, $7e36ff710ba19f08$export$776c63898ae5b636);
            labels = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$30a6f2881311088f) : (0, $7e36ff710ba19f08$export$facd167cc27ea9b0);
        } else {
            outputValues = Array.from(fftResult);
            frequencies = outputValues.map((_, i)=>frequencyStep * i);
            labels = frequencies.map((f)=>`${f.toFixed(2)} Hz`);
        }
        // We normalize to {0, 1}
        const normalizedOutput = outputValues.map((v)=>{
            return Math.max(0, Math.min((v - minDecibels) / (maxDecibels - minDecibels), 1));
        });
        const values = new Float32Array(normalizedOutput);
        return {
            values: values,
            frequencies: frequencies,
            labels: labels
        };
    }
    /**
   * Gets the current frequency domain data from the playing audio track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        let fftResult = null;
        if (this.audioBuffer && this.fftResults.length) {
            const pct = this.audio.currentTime / this.audio.duration;
            const index = Math.min(pct * this.fftResults.length | 0, this.fftResults.length - 1);
            fftResult = this.fftResults[index];
        }
        return $e3157d5b373e8220$export$2c3136da0bf130f9.getFrequencies(this.analyser, this.sampleRate, fftResult, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Resume the internal AudioContext if it was suspended due to the lack of
   * user interaction when the AudioAnalysis was instantiated.
   * @returns {Promise<true>}
   */ async resumeIfSuspended() {
        if (this.context.state === "suspended") await this.context.resume();
        return true;
    }
    /**
   * Creates a new AudioAnalysis instance for an HTMLAudioElement
   * @param {HTMLAudioElement} audioElement
   * @param {AudioBuffer|null} [audioBuffer] If provided, will cache all frequency domain data from the buffer
   * @returns {AudioAnalysis}
   */ constructor(audioElement, audioBuffer = null){
        this.fftResults = [];
        if (audioBuffer) {
            /**
       * Modified from
       * https://stackoverflow.com/questions/75063715/using-the-web-audio-api-to-analyze-a-song-without-playing
       *
       * We do this to populate FFT values for the audio if provided an `audioBuffer`
       * The reason to do this is that Safari fails when using `createMediaElementSource`
       * This has a non-zero RAM cost so we only opt-in to run it on Safari, Chrome is better
       */ const { length: length, sampleRate: sampleRate } = audioBuffer;
            const offlineAudioContext = new OfflineAudioContext({
                length: length,
                sampleRate: sampleRate
            });
            const source = offlineAudioContext.createBufferSource();
            source.buffer = audioBuffer;
            const analyser = offlineAudioContext.createAnalyser();
            analyser.fftSize = 8192;
            analyser.smoothingTimeConstant = 0.1;
            source.connect(analyser);
            // limit is :: 128 / sampleRate;
            // but we just want 60fps - cuts ~1s from 6MB to 1MB of RAM
            const renderQuantumInSeconds = 1 / 60;
            const durationInSeconds = length / sampleRate;
            const analyze = (index)=>{
                const suspendTime = renderQuantumInSeconds * index;
                if (suspendTime < durationInSeconds) offlineAudioContext.suspend(suspendTime).then(()=>{
                    const fftResult = new Float32Array(analyser.frequencyBinCount);
                    analyser.getFloatFrequencyData(fftResult);
                    this.fftResults.push(fftResult);
                    analyze(index + 1);
                });
                if (index === 1) offlineAudioContext.startRendering();
                else offlineAudioContext.resume();
            };
            source.start(0);
            analyze(1);
            this.audio = audioElement;
            this.context = offlineAudioContext;
            this.analyser = analyser;
            this.sampleRate = sampleRate;
            this.audioBuffer = audioBuffer;
        } else {
            const audioContext = new AudioContext();
            const track = audioContext.createMediaElementSource(audioElement);
            const analyser = audioContext.createAnalyser();
            analyser.fftSize = 8192;
            analyser.smoothingTimeConstant = 0.1;
            track.connect(analyser);
            analyser.connect(audioContext.destination);
            this.audio = audioElement;
            this.context = audioContext;
            this.analyser = analyser;
            this.sampleRate = this.context.sampleRate;
            this.audioBuffer = null;
        }
    }
}
globalThis.AudioAnalysis = $e3157d5b373e8220$export$2c3136da0bf130f9;


const $85d2d12e7041fe80$export$50b76700e2b15e9 = `
class StreamProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.hasStarted = false;
    this.hasInterrupted = false;
    this.outputBuffers = [];
    this.bufferLength = 128;
    this.write = { buffer: new Float32Array(this.bufferLength), trackId: null };
    this.writeOffset = 0;
    this.trackSampleOffsets = {};
    this.port.onmessage = (event) => {
      if (event.data) {
        const payload = event.data;
        if (payload.event === 'write') {
          const int16Array = payload.buffer;
          const float32Array = new Float32Array(int16Array.length);
          for (let i = 0; i < int16Array.length; i++) {
            float32Array[i] = int16Array[i] / 0x8000; // Convert Int16 to Float32
          }
          this.writeData(float32Array, payload.trackId);
        } else if (
          payload.event === 'offset' ||
          payload.event === 'interrupt'
        ) {
          const requestId = payload.requestId;
          const trackId = this.write.trackId;
          const offset = this.trackSampleOffsets[trackId] || 0;
          this.port.postMessage({
            event: 'offset',
            requestId,
            trackId,
            offset,
          });
          if (payload.event === 'interrupt') {
            this.hasInterrupted = true;
          }
        } else {
          throw new Error(\`Unhandled event "\${payload.event}"\`);
        }
      }
    };
  }

  writeData(float32Array, trackId = null) {
    let { buffer } = this.write;
    let offset = this.writeOffset;
    for (let i = 0; i < float32Array.length; i++) {
      buffer[offset++] = float32Array[i];
      if (offset >= buffer.length) {
        this.outputBuffers.push(this.write);
        this.write = { buffer: new Float32Array(this.bufferLength), trackId };
        buffer = this.write.buffer;
        offset = 0;
      }
    }
    this.writeOffset = offset;
    return true;
  }

  process(inputs, outputs, parameters) {
    const output = outputs[0];
    const outputChannelData = output[0];
    const outputBuffers = this.outputBuffers;
    if (this.hasInterrupted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else if (outputBuffers.length) {
      this.hasStarted = true;
      const { buffer, trackId } = outputBuffers.shift();
      for (let i = 0; i < outputChannelData.length; i++) {
        outputChannelData[i] = buffer[i] || 0;
      }
      if (trackId) {
        this.trackSampleOffsets[trackId] =
          this.trackSampleOffsets[trackId] || 0;
        this.trackSampleOffsets[trackId] += buffer.length;
      }
      return true;
    } else if (this.hasStarted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else {
      return true;
    }
  }
}

registerProcessor('stream_processor', StreamProcessor);
`;
const $85d2d12e7041fe80$var$script = new Blob([
    $85d2d12e7041fe80$export$50b76700e2b15e9
], {
    type: "application/javascript"
});
const $85d2d12e7041fe80$var$src = URL.createObjectURL($85d2d12e7041fe80$var$script);
const $85d2d12e7041fe80$export$bfa8c596114d74df = $85d2d12e7041fe80$var$src;



class $4f776511e84ede8b$export$9698d62c78b8f366 {
    /**
   * Connects the audio context and enables output to speakers
   * @returns {Promise<true>}
   */ async connect() {
        this.context = new AudioContext({
            sampleRate: this.sampleRate
        });
        if (this.context.state === "suspended") await this.context.resume();
        try {
            await this.context.audioWorklet.addModule(this.scriptSrc);
        } catch (e) {
            console.error(e);
            throw new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        const analyser = this.context.createAnalyser();
        analyser.fftSize = 8192;
        analyser.smoothingTimeConstant = 0.1;
        this.analyser = analyser;
        return true;
    }
    /**
   * Gets the current frequency domain data from the playing track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {import('./analysis/audio_analysis.js').AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!this.analyser) throw new Error("Not connected, please call .connect() first");
        return (0, $e3157d5b373e8220$export$2c3136da0bf130f9).getFrequencies(this.analyser, this.sampleRate, null, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Starts audio streaming
   * @private
   * @returns {Promise<true>}
   */ _start() {
        const streamNode = new AudioWorkletNode(this.context, "stream_processor");
        streamNode.connect(this.context.destination);
        streamNode.port.onmessage = (e)=>{
            const { event: event } = e.data;
            if (event === "stop") {
                streamNode.disconnect();
                this.stream = null;
            } else if (event === "offset") {
                const { requestId: requestId, trackId: trackId, offset: offset } = e.data;
                const currentTime = offset / this.sampleRate;
                this.trackSampleOffsets[requestId] = {
                    trackId: trackId,
                    offset: offset,
                    currentTime: currentTime
                };
            }
        };
        this.analyser.disconnect();
        streamNode.connect(this.analyser);
        this.stream = streamNode;
        return true;
    }
    /**
   * Adds 16BitPCM data to the currently playing audio stream
   * You can add chunks beyond the current play point and they will be queued for play
   * @param {ArrayBuffer|Int16Array} arrayBuffer
   * @param {string} [trackId]
   * @returns {Int16Array}
   */ add16BitPCM(arrayBuffer, trackId = "default") {
        if (typeof trackId !== "string") throw new Error(`trackId must be a string`);
        else if (this.interruptedTrackIds[trackId]) return;
        if (!this.stream) this._start();
        let buffer;
        if (arrayBuffer instanceof Int16Array) buffer = arrayBuffer;
        else if (arrayBuffer instanceof ArrayBuffer) buffer = new Int16Array(arrayBuffer);
        else throw new Error(`argument must be Int16Array or ArrayBuffer`);
        this.stream.port.postMessage({
            event: "write",
            buffer: buffer,
            trackId: trackId
        });
        return buffer;
    }
    /**
   * Gets the offset (sample count) of the currently playing stream
   * @param {boolean} [interrupt]
   * @returns {{trackId: string|null, offset: number, currentTime: number}}
   */ async getTrackSampleOffset(interrupt = false) {
        if (!this.stream) return null;
        const requestId = crypto.randomUUID();
        this.stream.port.postMessage({
            event: interrupt ? "interrupt" : "offset",
            requestId: requestId
        });
        let trackSampleOffset;
        while(!trackSampleOffset){
            trackSampleOffset = this.trackSampleOffsets[requestId];
            await new Promise((r)=>setTimeout(()=>r(), 1));
        }
        const { trackId: trackId } = trackSampleOffset;
        if (interrupt && trackId) this.interruptedTrackIds[trackId] = true;
        return trackSampleOffset;
    }
    /**
   * Strips the current stream and returns the sample offset of the audio
   * @param {boolean} [interrupt]
   * @returns {{trackId: string|null, offset: number, currentTime: number}}
   */ async interrupt() {
        return this.getTrackSampleOffset(true);
    }
    /**
   * Creates a new WavStreamPlayer instance
   * @param {{sampleRate?: number}} options
   * @returns {WavStreamPlayer}
   */ constructor({ sampleRate: sampleRate = 44100 } = {}){
        this.scriptSrc = (0, $85d2d12e7041fe80$export$bfa8c596114d74df);
        this.sampleRate = sampleRate;
        this.context = null;
        this.stream = null;
        this.analyser = null;
        this.trackSampleOffsets = {};
        this.interruptedTrackIds = {};
    }
}
globalThis.WavStreamPlayer = $4f776511e84ede8b$export$9698d62c78b8f366;


const $3e2b3e2b8d57a0ca$var$AudioProcessorWorklet = `
class AudioProcessor extends AudioWorkletProcessor {

  constructor() {
    super();
    this.port.onmessage = this.receive.bind(this);
    this.initialize();
  }

  initialize() {
    this.foundAudio = false;
    this.recording = false;
    this.chunks = [];
  }

  /**
   * Concatenates sampled chunks into channels
   * Format is chunk[Left[], Right[]]
   */
  readChannelData(chunks, channel = -1, maxChannels = 9) {
    let channelLimit;
    if (channel !== -1) {
      if (chunks[0] && chunks[0].length - 1 < channel) {
        throw new Error(
          \`Channel \${channel} out of range: max \${chunks[0].length}\`
        );
      }
      channelLimit = channel + 1;
    } else {
      channel = 0;
      channelLimit = Math.min(chunks[0] ? chunks[0].length : 1, maxChannels);
    }
    const channels = [];
    for (let n = channel; n < channelLimit; n++) {
      const length = chunks.reduce((sum, chunk) => {
        return sum + chunk[n].length;
      }, 0);
      const buffers = chunks.map((chunk) => chunk[n]);
      const result = new Float32Array(length);
      let offset = 0;
      for (let i = 0; i < buffers.length; i++) {
        result.set(buffers[i], offset);
        offset += buffers[i].length;
      }
      channels[n] = result;
    }
    return channels;
  }

  /**
   * Combines parallel audio data into correct format,
   * channels[Left[], Right[]] to float32Array[LRLRLRLR...]
   */
  formatAudioData(channels) {
    if (channels.length === 1) {
      // Simple case is only one channel
      const float32Array = channels[0].slice();
      const meanValues = channels[0].slice();
      return { float32Array, meanValues };
    } else {
      const float32Array = new Float32Array(
        channels[0].length * channels.length
      );
      const meanValues = new Float32Array(channels[0].length);
      for (let i = 0; i < channels[0].length; i++) {
        const offset = i * channels.length;
        let meanValue = 0;
        for (let n = 0; n < channels.length; n++) {
          float32Array[offset + n] = channels[n][i];
          meanValue += channels[n][i];
        }
        meanValues[i] = meanValue / channels.length;
      }
      return { float32Array, meanValues };
    }
  }

  /**
   * Converts 32-bit float data to 16-bit integers
   */
  floatTo16BitPCM(float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
  }

  /**
   * Retrieves the most recent amplitude values from the audio stream
   * @param {number} channel
   */
  getValues(channel = -1) {
    const channels = this.readChannelData(this.chunks, channel);
    const { meanValues } = this.formatAudioData(channels);
    return { meanValues, channels };
  }

  /**
   * Exports chunks as an audio/wav file
   */
  export() {
    const channels = this.readChannelData(this.chunks);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const audioData = this.floatTo16BitPCM(float32Array);
    return {
      meanValues: meanValues,
      audio: {
        bitsPerSample: 16,
        channels: channels,
        data: audioData,
      },
    };
  }

  receive(e) {
    const { event, id } = e.data;
    let receiptData = {};
    switch (event) {
      case 'start':
        this.recording = true;
        break;
      case 'stop':
        this.recording = false;
        break;
      case 'clear':
        this.initialize();
        break;
      case 'export':
        receiptData = this.export();
        break;
      case 'read':
        receiptData = this.getValues();
        break;
      default:
        break;
    }
    // Always send back receipt
    this.port.postMessage({ event: 'receipt', id, data: receiptData });
  }

  sendChunk(chunk) {
    const channels = this.readChannelData([chunk]);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const rawAudioData = this.floatTo16BitPCM(float32Array);
    const monoAudioData = this.floatTo16BitPCM(meanValues);
    this.port.postMessage({
      event: 'chunk',
      data: {
        mono: monoAudioData,
        raw: rawAudioData,
      },
    });
  }

  process(inputList, outputList, parameters) {
    // Copy input to output (e.g. speakers)
    // Note that this creates choppy sounds with Mac products
    const sourceLimit = Math.min(inputList.length, outputList.length);
    for (let inputNum = 0; inputNum < sourceLimit; inputNum++) {
      const input = inputList[inputNum];
      const output = outputList[inputNum];
      const channelCount = Math.min(input.length, output.length);
      for (let channelNum = 0; channelNum < channelCount; channelNum++) {
        input[channelNum].forEach((sample, i) => {
          output[channelNum][i] = sample;
        });
      }
    }
    const inputs = inputList[0];
    // There's latency at the beginning of a stream before recording starts
    // Make sure we actually receive audio data before we start storing chunks
    let sliceIndex = 0;
    if (!this.foundAudio) {
      for (const channel of inputs) {
        sliceIndex = 0; // reset for each channel
        if (this.foundAudio) {
          break;
        }
        if (channel) {
          for (const value of channel) {
            if (value !== 0) {
              // find only one non-zero entry in any channel
              this.foundAudio = true;
              break;
            } else {
              sliceIndex++;
            }
          }
        }
      }
    }
    if (inputs && inputs[0] && this.foundAudio && this.recording) {
      // We need to copy the TypedArray, because the \`process\`
      // internals will reuse the same buffer to hold each input
      const chunk = inputs.map((input) => input.slice(sliceIndex));
      this.chunks.push(chunk);
      this.sendChunk(chunk);
    }
    return true;
  }
}

registerProcessor('audio_processor', AudioProcessor);
`;
const $3e2b3e2b8d57a0ca$var$script = new Blob([
    $3e2b3e2b8d57a0ca$var$AudioProcessorWorklet
], {
    type: "application/javascript"
});
const $3e2b3e2b8d57a0ca$var$src = URL.createObjectURL($3e2b3e2b8d57a0ca$var$script);
const $3e2b3e2b8d57a0ca$export$1f65f50a8cbff43c = $3e2b3e2b8d57a0ca$var$src;




class $4f413f56eb918468$export$439b217ca659a877 {
    /**
   * Decodes audio data from multiple formats to a Blob, url, Float32Array and AudioBuffer
   * @param {Blob|Float32Array|Int16Array|ArrayBuffer|number[]} audioData
   * @param {number} sampleRate
   * @param {number} fromSampleRate
   * @returns {Promise<DecodedAudioType>}
   */ static async decode(audioData, sampleRate = 44100, fromSampleRate = -1) {
        const context = new AudioContext({
            sampleRate: sampleRate
        });
        let arrayBuffer;
        let blob;
        if (audioData instanceof Blob) {
            if (fromSampleRate !== -1) throw new Error(`Can not specify "fromSampleRate" when reading from Blob`);
            blob = audioData;
            arrayBuffer = await blob.arrayBuffer();
        } else if (audioData instanceof ArrayBuffer) {
            if (fromSampleRate !== -1) throw new Error(`Can not specify "fromSampleRate" when reading from ArrayBuffer`);
            arrayBuffer = audioData;
            blob = new Blob([
                arrayBuffer
            ], {
                type: "audio/wav"
            });
        } else {
            let float32Array;
            let data;
            if (audioData instanceof Int16Array) {
                data = audioData;
                float32Array = new Float32Array(audioData.length);
                for(let i = 0; i < audioData.length; i++)float32Array[i] = audioData[i] / 0x8000;
            } else if (audioData instanceof Float32Array) float32Array = audioData;
            else if (audioData instanceof Array) float32Array = new Float32Array(audioData);
            else throw new Error(`"audioData" must be one of: Blob, Float32Arrray, Int16Array, ArrayBuffer, Array<number>`);
            if (fromSampleRate === -1) throw new Error(`Must specify "fromSampleRate" when reading from Float32Array, In16Array or Array`);
            else if (fromSampleRate < 3000) throw new Error(`Minimum "fromSampleRate" is 3000 (3kHz)`);
            if (!data) data = (0, $3b1d40bc464e20d1$export$13afda237b1c9846).floatTo16BitPCM(float32Array);
            const audio = {
                bitsPerSample: 16,
                channels: [
                    float32Array
                ],
                data: data
            };
            const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
            const result = packer.pack(fromSampleRate, audio);
            blob = result.blob;
            arrayBuffer = await blob.arrayBuffer();
        }
        const audioBuffer = await context.decodeAudioData(arrayBuffer);
        const values = audioBuffer.getChannelData(0);
        const url = URL.createObjectURL(blob);
        return {
            blob: blob,
            url: url,
            values: values,
            audioBuffer: audioBuffer
        };
    }
    /**
   * Logs data in debug mode
   * @param {...any} arguments
   * @returns {true}
   */ log() {
        if (this.debug) this.log(...arguments);
        return true;
    }
    /**
   * Retrieves the current sampleRate for the recorder
   * @returns {number}
   */ getSampleRate() {
        return this.sampleRate;
    }
    /**
   * Retrieves the current status of the recording
   * @returns {"ended"|"paused"|"recording"}
   */ getStatus() {
        if (!this.processor) return "ended";
        else if (!this.recording) return "paused";
        else return "recording";
    }
    /**
   * Sends an event to the AudioWorklet
   * @private
   * @param {string} name
   * @param {{[key: string]: any}} data
   * @param {AudioWorkletNode} [_processor]
   * @returns {Promise<{[key: string]: any}>}
   */ async _event(name, data = {}, _processor = null) {
        _processor = _processor || this.processor;
        if (!_processor) throw new Error("Can not send events without recording first");
        const message = {
            event: name,
            id: this._lastEventId++,
            data: data
        };
        _processor.port.postMessage(message);
        const t0 = new Date().valueOf();
        while(!this.eventReceipts[message.id]){
            if (new Date().valueOf() - t0 > this.eventTimeout) throw new Error(`Timeout waiting for "${name}" event`);
            await new Promise((res)=>setTimeout(()=>res(true), 1));
        }
        const payload = this.eventReceipts[message.id];
        delete this.eventReceipts[message.id];
        return payload;
    }
    /**
   * Sets device change callback, remove if callback provided is `null`
   * @param {(Array<MediaDeviceInfo & {default: boolean}>): void|null} callback
   * @returns {true}
   */ listenForDeviceChange(callback) {
        if (callback === null && this._deviceChangeCallback) {
            navigator.mediaDevices.removeEventListener("devicechange", this._deviceChangeCallback);
            this._deviceChangeCallback = null;
        } else if (callback !== null) {
            // Basically a debounce; we only want this called once when devices change
            // And we only want the most recent callback() to be executed
            // if a few are operating at the same time
            let lastId = 0;
            let lastDevices = [];
            const serializeDevices = (devices)=>devices.map((d)=>d.deviceId).sort().join(",");
            const cb = async ()=>{
                let id = ++lastId;
                const devices = await this.listDevices();
                if (id === lastId) {
                    if (serializeDevices(lastDevices) !== serializeDevices(devices)) {
                        lastDevices = devices;
                        callback(devices.slice());
                    }
                }
            };
            navigator.mediaDevices.addEventListener("devicechange", cb);
            cb();
            this._deviceChangeCallback = cb;
        }
        return true;
    }
    /**
   * Manually request permission to use the microphone
   * @returns {Promise<true>}
   */ async requestPermission() {
        const permissionStatus = await navigator.permissions.query({
            name: "microphone"
        });
        if (permissionStatus.state === "denied") window.alert("You must grant microphone access to use this feature.");
        else if (permissionStatus.state === "prompt") try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
            const tracks = stream.getTracks();
            tracks.forEach((track)=>track.stop());
        } catch (e) {
            window.alert("You must grant microphone access to use this feature.");
        }
        return true;
    }
    /**
   * List all eligible devices for recording, will request permission to use microphone
   * @returns {Promise<Array<MediaDeviceInfo & {default: boolean}>>}
   */ async listDevices() {
        if (!navigator.mediaDevices || !("enumerateDevices" in navigator.mediaDevices)) throw new Error("Could not request user devices");
        await this.requestPermission();
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter((device)=>device.kind === "audioinput");
        const defaultDeviceIndex = audioDevices.findIndex((device)=>device.deviceId === "default");
        const deviceList = [];
        if (defaultDeviceIndex !== -1) {
            let defaultDevice = audioDevices.splice(defaultDeviceIndex, 1)[0];
            let existingIndex = audioDevices.findIndex((device)=>device.groupId === defaultDevice.groupId);
            if (existingIndex !== -1) defaultDevice = audioDevices.splice(existingIndex, 1)[0];
            defaultDevice.default = true;
            deviceList.push(defaultDevice);
        }
        return deviceList.concat(audioDevices);
    }
    /**
   * Begins a recording session and requests microphone permissions if not already granted
   * Microphone recording indicator will appear on browser tab but status will be "paused"
   * @param {string} [deviceId] if no device provided, default device will be used
   * @returns {Promise<true>}
   */ async begin(deviceId) {
        if (this.processor) throw new Error(`Already connected: please call .end() to start a new session`);
        if (!navigator.mediaDevices || !("getUserMedia" in navigator.mediaDevices)) throw new Error("Could not request user media");
        try {
            const config = {
                audio: true
            };
            if (deviceId) config.audio = {
                deviceId: {
                    exact: deviceId
                }
            };
            this.stream = await navigator.mediaDevices.getUserMedia(config);
        } catch (err) {
            throw new Error("Could not start media stream");
        }
        const context = new AudioContext({
            sampleRate: this.sampleRate
        });
        const source = context.createMediaStreamSource(this.stream);
        // Load and execute the module script.
        try {
            await context.audioWorklet.addModule(this.scriptSrc);
        } catch (e) {
            console.error(e);
            throw new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        const processor = new AudioWorkletNode(context, "audio_processor");
        processor.port.onmessage = (e)=>{
            const { event: event, id: id, data: data } = e.data;
            if (event === "receipt") this.eventReceipts[id] = data;
            else if (event === "chunk") {
                if (this._chunkProcessorSize) {
                    const buffer = this._chunkProcessorBuffer;
                    this._chunkProcessorBuffer = {
                        raw: (0, $3b1d40bc464e20d1$export$13afda237b1c9846).mergeBuffers(buffer.raw, data.raw),
                        mono: (0, $3b1d40bc464e20d1$export$13afda237b1c9846).mergeBuffers(buffer.mono, data.mono)
                    };
                    if (this._chunkProcessorBuffer.mono.byteLength >= this._chunkProcessorSize) {
                        this._chunkProcessor(this._chunkProcessorBuffer);
                        this._chunkProcessorBuffer = {
                            raw: new ArrayBuffer(0),
                            mono: new ArrayBuffer(0)
                        };
                    }
                } else this._chunkProcessor(data);
            }
        };
        const node = source.connect(processor);
        const analyser = context.createAnalyser();
        analyser.fftSize = 8192;
        analyser.smoothingTimeConstant = 0.1;
        node.connect(analyser);
        if (this.outputToSpeakers) {
            // eslint-disable-next-line no-console
            console.warn("Warning: Output to speakers may affect sound quality,\nespecially due to system audio feedback preventative measures.\nuse only for debugging");
            analyser.connect(context.destination);
        }
        this.source = source;
        this.node = node;
        this.analyser = analyser;
        this.processor = processor;
        return true;
    }
    /**
   * Gets the current frequency domain data from the recording track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {import('./analysis/audio_analysis.js').AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        return (0, $e3157d5b373e8220$export$2c3136da0bf130f9).getFrequencies(this.analyser, this.sampleRate, null, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Pauses the recording
   * Keeps microphone stream open but halts storage of audio
   * @returns {Promise<true>}
   */ async pause() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        else if (!this.recording) throw new Error("Already paused: please call .record() first");
        if (this._chunkProcessorBuffer.raw.byteLength) this._chunkProcessor(this._chunkProcessorBuffer);
        this.log("Pausing ...");
        await this._event("stop");
        this.recording = false;
        return true;
    }
    /**
   * Start recording stream and storing to memory from the connected audio source
   * @param {(data: { mono: Int16Array; raw: Int16Array }) => any} [chunkProcessor]
   * @param {number} [chunkSize] chunkProcessor will not be triggered until this size threshold met in mono audio
   * @returns {Promise<true>}
   */ async record(chunkProcessor = ()=>{}, chunkSize = 8192) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        else if (this.recording) throw new Error("Already recording: please call .pause() first");
        else if (typeof chunkProcessor !== "function") throw new Error(`chunkProcessor must be a function`);
        this._chunkProcessor = chunkProcessor;
        this._chunkProcessorSize = chunkSize;
        this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        };
        this.log("Recording ...");
        await this._event("start");
        this.recording = true;
        return true;
    }
    /**
   * Clears the audio buffer, empties stored recording
   * @returns {Promise<true>}
   */ async clear() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        await this._event("clear");
        return true;
    }
    /**
   * Reads the current audio stream data
   * @returns {Promise<{meanValues: Float32Array, channels: Array<Float32Array>}>}
   */ async read() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        this.log("Reading ...");
        const result = await this._event("read");
        return result;
    }
    /**
   * Saves the current audio stream to a file
   * @param {boolean} [force] Force saving while still recording
   * @returns {Promise<import('./wav_packer.js').WavPackerAudioType>}
   */ async save(force = false) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        if (!force && this.recording) throw new Error("Currently recording: please call .pause() first, or call .save(true) to force");
        this.log("Exporting ...");
        const exportData = await this._event("export");
        const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
        const result = packer.pack(this.sampleRate, exportData.audio);
        return result;
    }
    /**
   * Ends the current recording session and saves the result
   * @returns {Promise<import('./wav_packer.js').WavPackerAudioType>}
   */ async end() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        const _processor = this.processor;
        this.log("Stopping ...");
        await this._event("stop");
        this.recording = false;
        const tracks = this.stream.getTracks();
        tracks.forEach((track)=>track.stop());
        this.log("Exporting ...");
        const exportData = await this._event("export", {}, _processor);
        this.processor.disconnect();
        this.source.disconnect();
        this.node.disconnect();
        this.analyser.disconnect();
        this.stream = null;
        this.processor = null;
        this.source = null;
        this.node = null;
        const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
        const result = packer.pack(this.sampleRate, exportData.audio);
        return result;
    }
    /**
   * Performs a full cleanup of WavRecorder instance
   * Stops actively listening via microphone and removes existing listeners
   * @returns {Promise<true>}
   */ async quit() {
        this.listenForDeviceChange(null);
        if (this.processor) await this.end();
        return true;
    }
    /**
   * Create a new WavRecorder instance
   * @param {{sampleRate?: number, outputToSpeakers?: boolean, debug?: boolean}} [options]
   * @returns {WavRecorder}
   */ constructor({ sampleRate: sampleRate = 44100, outputToSpeakers: outputToSpeakers = false, debug: debug = false } = {}){
        // Script source
        this.scriptSrc = (0, $3e2b3e2b8d57a0ca$export$1f65f50a8cbff43c);
        // Config
        this.sampleRate = sampleRate;
        this.outputToSpeakers = outputToSpeakers;
        this.debug = !!debug;
        this._deviceChangeCallback = null;
        this._devices = [];
        // State variables
        this.stream = null;
        this.processor = null;
        this.source = null;
        this.node = null;
        this.recording = false;
        // Event handling with AudioWorklet
        this._lastEventId = 0;
        this.eventReceipts = {};
        this.eventTimeout = 5000;
        // Process chunks of audio
        this._chunkProcessor = ()=>{};
        this._chunkProcessorSize = void 0;
        this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        };
    }
}
globalThis.WavRecorder = $4f413f56eb918468$export$439b217ca659a877;




/**
 * Converts Float32Array of amplitude data to ArrayBuffer in Int16Array format
 * @param {Float32Array} float32Array
 * @returns {ArrayBuffer}
 */ const $e19773ab4c6417d5$var$floatTo16BitPCM = (float32Array)=>{
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for(let i = 0; i < float32Array.length; i++, offset += 2){
        let s = Math.max(-1, Math.min(1, float32Array[i]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
};
const $e19773ab4c6417d5$export$70c4ae293293ca1e = (arrayBuffer)=>{
    if (arrayBuffer instanceof Float32Array) arrayBuffer = $e19773ab4c6417d5$var$floatTo16BitPCM(arrayBuffer);
    else if (arrayBuffer instanceof Int16Array) arrayBuffer = arrayBuffer.buffer;
    let binary = "";
    let bytes = new Uint8Array(arrayBuffer);
    const chunkSize = 0x8000; // 32KB chunk size
    for(let i = 0; i < bytes.length; i += chunkSize){
        let chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, [
            ...chunk
        ]);
    }
    return btoa(binary);
};
const $e19773ab4c6417d5$export$a7a17e76664e3e44 = (base64)=>{
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes.buffer;
};


parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $3pTPw = parcelRequire("3pTPw");
var $0250c0d005ab1da1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $0250c0d005ab1da1$var$API_URL = "https://api.digitalreception.app";
const $0250c0d005ab1da1$var$Conversation = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const [isRecording, setIsRecording] = (0, $eZVvM.useState)(false);
    const ws = (0, $eZVvM.useRef)(null);
    const wavRecorderRef = (0, $eZVvM.useRef)(new (0, $4f413f56eb918468$export$439b217ca659a877)({
        sampleRate: 24000
    }));
    const wavStreamPlayerRef = (0, $eZVvM.useRef)(new (0, $4f776511e84ede8b$export$9698d62c78b8f366)({
        sampleRate: 24000
    }));
    (0, $eZVvM.useEffect)(()=>{
        let userData = null;
        ws.current = new WebSocket($0250c0d005ab1da1$var$API_URL + "/network/conversation");
        ws.current.onopen = ()=>{
            startRecord();
        };
        ws.current.onmessage = (event)=>{
            const data = JSON.parse(event.data);
            const wavStreamPlayer = wavStreamPlayerRef.current;
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.audio.delta") {
                const arrayBuffer = (0, $e19773ab4c6417d5$export$a7a17e76664e3e44)(data.delta);
                const audioBuffer = new Int16Array(arrayBuffer);
                wavStreamPlayer.add16BitPCM(audioBuffer);
            }
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.function_call_arguments.done") {
                const isCheckin = data.name === "checkin_visitor";
                const argumentsData = JSON.parse(data.arguments);
                if (!userData) userData = Object.assign({
                    isCheckin: isCheckin
                }, argumentsData);
            }
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.done" && !!userData) {
                navigate(`/access/${userData.isCheckin ? "checkin" : "checkout"}/manual`, {
                    state: userData
                });
                userData = null;
            }
        };
        ws.current.onerror = (error)=>$0250c0d005ab1da1$var$__awaiter(void 0, void 0, void 0, function*() {
                const wavRecorder = wavRecorderRef.current;
                const wavStreamPlayer = wavStreamPlayerRef.current;
                yield wavRecorder.end();
                yield wavStreamPlayer.interrupt();
                setIsRecording(()=>false);
            });
        return ()=>{
            const wavRecorder = wavRecorderRef.current;
            const wavStreamPlayer = wavStreamPlayerRef.current;
            ws.current.close();
            wavRecorder.end();
            wavStreamPlayer.interrupt();
            userData = null;
            setIsRecording(()=>false);
        };
    }, []);
    const startRecord = ()=>$0250c0d005ab1da1$var$__awaiter(void 0, void 0, void 0, function*() {
            const recorder = wavRecorderRef.current;
            const streamPlayer = wavStreamPlayerRef.current;
            yield recorder.begin();
            yield streamPlayer.connect();
            setIsRecording(()=>true);
            yield recorder.record((data)=>{
                if (ws.current.readyState !== WebSocket.OPEN) return;
                ws.current.send(data.mono);
            });
        });
    (0, $eZVvM.useEffect)(()=>{
        if (ws.current.readyState === WebSocket.OPEN) {
            startRecord();
            return ()=>{
                if (!isRecording) return;
                const recorder = wavRecorderRef.current;
                const streamPlayer = wavStreamPlayerRef.current;
                setIsRecording(()=>false);
                recorder.end();
                streamPlayer.interrupt();
                ws.current.close();
            };
        }
    }, []);
    return (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            (0, $bhfvP.jsx)("style", {
                children: `
        .animated-circle {
          aspect-ratio: 1.3;
          height: 25vh;
          background-color: #3498db;
          border-radius: 50%;
          animation: wobble 1s infinite;
          filter: blur(5px);
        }

        @keyframes wobble {
          25% {
            transform: scale(1.1) rotate(5deg);
            filter: blur(2px);
          }
          50% {
            transform: scale(1.2) rotate(-5deg);
          }
          75% {
            transform: scale(1.1) rotate(5deg);
          }
          100% {
            transform: scale(1) rotate(0deg);
            filter: blur(5px);
          }
        }
      `
            }),
            (0, $bhfvP.jsxs)("div", Object.assign({
                className: "d-flex align-items-center flex-column h-100"
            }, {
                children: [
                    (0, $bhfvP.jsx)((0, $3pTPw.default), {
                        to: "/"
                    }),
                    (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), Object.assign({
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%"
                    }, {
                        children: (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), Object.assign({
                            item: true
                        }, {
                            children: (0, $bhfvP.jsx)("div", {
                                className: "animated-circle"
                            })
                        }))
                    }))
                ]
            }))
        ]
    });
};
var $0250c0d005ab1da1$export$2e2bcd8739ae039 = $0250c0d005ab1da1$var$Conversation;




var $bblWJ = parcelRequire("bblWJ");
var $dBZzI = parcelRequire("dBZzI");
var $kP4GY = parcelRequire("kP4GY");

var $cD0nt = parcelRequire("cD0nt");

var $219y6 = parcelRequire("219y6");


var $eZVvM = parcelRequire("eZVvM");

var $cD0nt = parcelRequire("cD0nt");
const $4f8fd08485951888$var$isDev = false;
const $4f8fd08485951888$var$useCursorVisibility = ()=>{
    var _a, _b;
    const { data: data } = (0, $cD0nt.default)();
    const showCursor = ((_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.showCursor) || false; /**
                                                                                                                                                                                                                      * We're attaching a class to disable the hidden cursor
                                                                                                                                                                                                                      * directly to the body in order not to pass refs from the
                                                                                                                                                                                                                      * top level component to the cursor visibility hook
                                                                                                                                                                                                                      */ 
    (0, $eZVvM.useEffect)(()=>{
        if ($4f8fd08485951888$var$isDev || showCursor) {
            document.body.classList.add("cursor-none-disabled");
            return;
        }
        document.body.classList.remove("cursor-none-disabled");
    }, [
        showCursor
    ]);
    return $4f8fd08485951888$var$isDev || showCursor;
};
var $4f8fd08485951888$export$2e2bcd8739ae039 = $4f8fd08485951888$var$useCursorVisibility;


const $5b269012e369b2e4$var$isDev = false;

const $5b269012e369b2e4$var$Contact = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>Promise.resolve((parcelRequire("dBZzI"))));

const $5b269012e369b2e4$var$QRCodeScanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>Promise.resolve((parcelRequire("kP4GY"))));

const $5b269012e369b2e4$var$ScannerProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("gVSZ4")));
const $5b269012e369b2e4$var$Container = (0, $e8m2I.default)("div")(({ theme: theme })=>({
        backgroundColor: theme.palette.background.default
    }));
const $5b269012e369b2e4$var$LazyScannerProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { data: data } = (0, $cD0nt.default)();
    const socketURL = (0, $eZVvM.useMemo)(()=>{
        var _a, _b, _c;
        return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.socket) === null || _c === void 0 ? void 0 : _c.url;
    }, [
        data
    ]);
    if (!socketURL) return (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: children
    });
    return (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Suspense, {
        children: (0, $bhfvP.jsx)($5b269012e369b2e4$var$ScannerProvider, Object.assign({
            url: socketURL
        }, {
            children: children
        }))
    });
});
const $5b269012e369b2e4$var$Activation = ()=>(0, $bhfvP.jsx)($5b269012e369b2e4$var$Container, Object.assign({
        className: "w-100 d-flex flex-column position-relative overflow-hidden"
    }, {
        children: (0, $bhfvP.jsxs)("div", Object.assign({
            className: "flex-grow-1 d-flex flex-column justify-content-center align-items-center",
            style: {
                marginTop: "-5%"
            }
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $dc76dca562a3565e$export$2e2bcd8739ae039), {}),
                (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
                    children: [
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: $5b269012e369b2e4$var$isDev ? "/activation" : "/",
                            element: (0, $bhfvP.jsx)($f211111843b79ac3$export$2e2bcd8739ae039, {})
                        }),
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "*",
                            element: (0, $bhfvP.jsx)((0, $9B9bN.Navigate), {
                                to: $5b269012e369b2e4$var$isDev ? "/activation" : "/",
                                replace: true
                            })
                        })
                    ]
                })
            ]
        }))
    }));
const $5b269012e369b2e4$var$AppRouter = ()=>{
    const location = (0, $9B9bN.useLocation)();
    const { data: data } = (0, $cD0nt.default)();
    const isAIConversationEnabled = (0, $eZVvM.useMemo)(()=>{
        var _a, _b;
        return ((_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.aiConversation) || false;
    }, []);
    const isPremium = (0, $eZVvM.useMemo)(()=>{
        var _a, _b;
        const plan = (_b = (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.plan;
        return plan && plan !== "free";
    }, [
        data
    ]);
    return (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), Object.assign({
        mode: "wait"
    }, {
        children: (0, $bhfvP.jsxs)((0, $9B9bN.Routes), Object.assign({
            location: location
        }, {
            children: [
                (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/access/option/:action",
                    element: (0, $bhfvP.jsx)($994dc2c1c556f1d6$export$2e2bcd8739ae039, {})
                }),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), Object.assign({
                    path: "/access/checkin/manual",
                    element: (0, $bhfvP.jsx)($db45dfc051e0ec4c$export$2e2bcd8739ae039, {})
                }, {
                    children: (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "contact/:id/:callType",
                        element: (0, $bhfvP.jsx)($bblWJ.default, {
                            type: "employee"
                        })
                    })
                })),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/access/checkout/manual",
                    element: (0, $bhfvP.jsx)($44b1f2a8401da349$export$2e2bcd8739ae039, {})
                }),
                (0, $bhfvP.jsxs)((0, $9B9bN.Route), Object.assign({
                    path: "/access/:action",
                    element: (0, $bhfvP.jsx)($4f24c342e6539ecf$export$2e2bcd8739ae039, {})
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: ":code",
                            element: (0, $bhfvP.jsx)($e8b4810c61f91d9e$export$2e2bcd8739ae039, {})
                        }),
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: (0, $bhfvP.jsx)($bblWJ.default, {
                                type: "employee"
                            })
                        })
                    ]
                })),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), Object.assign({
                    path: "/delivery/:action",
                    element: (0, $bhfvP.jsx)($d00d6a5c0ee9ff60$export$2e2bcd8739ae039, {})
                }, {
                    children: (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "contact/:id/:callType",
                        element: (0, $bhfvP.jsx)($bblWJ.default, {
                            type: "employee"
                        })
                    })
                })),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), Object.assign({
                    path: "/custom-delivery/:action",
                    element: (0, $bhfvP.jsx)($d5a11803cc5f787b$export$2e2bcd8739ae039, {})
                }, {
                    children: (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "contact/:id/:callType",
                        element: (0, $bhfvP.jsx)($bblWJ.default, {
                            type: "employee"
                        })
                    })
                })),
                isPremium && (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/contact/:id/*",
                            element: (0, $bhfvP.jsx)($dBZzI.default, {})
                        }),
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/video-call",
                            element: (0, $bhfvP.jsx)($2bf5abfadc040ec3$export$2e2bcd8739ae039, {})
                        }),
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/scanner/:action",
                            element: (0, $bhfvP.jsx)($kP4GY.default, {})
                        })
                    ]
                }),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/overview",
                    element: (0, $bhfvP.jsx)($9728bf3945e1f727$export$2e2bcd8739ae039, {})
                }),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/wifi",
                    element: (0, $bhfvP.jsx)($0affa3b06af5de24$export$2e2bcd8739ae039, {})
                }),
                isAIConversationEnabled && (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/conversation",
                    element: (0, $bhfvP.jsx)($0250c0d005ab1da1$export$2e2bcd8739ae039, {})
                }),
                (0, $bhfvP.jsxs)((0, $9B9bN.Route), Object.assign({
                    path: "/",
                    element: (0, $bhfvP.jsx)($e9f2e051dd9c1e05$export$2e2bcd8739ae039, {})
                }, {
                    children: [
                        (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "scan/:code",
                            element: (0, $bhfvP.jsx)($e8b4810c61f91d9e$export$2e2bcd8739ae039, {})
                        }),
                        isPremium && (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/reception/call",
                            element: (0, $bhfvP.jsx)($bblWJ.default, {
                                type: "reception"
                            })
                        })
                    ]
                })),
                (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "*",
                    element: (0, $bhfvP.jsx)((0, $9B9bN.Navigate), {
                        to: "/",
                        replace: true
                    })
                })
            ]
        }), location.pathname)
    }));
};
const $5b269012e369b2e4$var$Providers = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    var _a, _b, _c;
    const { children: children } = props;
    const { data: data, isLoading: isLoading, isError: isError, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const { online: online } = (0, $219y6.useOfflineContext)(); // hide the cursor in production
    (0, $4f8fd08485951888$export$2e2bcd8739ae039)();
    const isActivation = window.location.pathname.includes("/activation");
    const isLoadingOnline = online && isLoading && !isError && !isActivation;
    return (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            (0, $bhfvP.jsx)((0, $180ef2721521e747$export$d8964aec282183a3), Object.assign({
                theme: (_a = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _a === void 0 ? void 0 : _a.theme,
                dataUpdatedAt: dataUpdatedAt
            }, {
                children: (0, $bhfvP.jsx)((0, $3adb49bfa33db486$export$195746d839abd8b5), Object.assign({
                    language: (_b = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _b === void 0 ? void 0 : _b.language,
                    languages: (_c = data === null || data === void 0 ? void 0 : data.digitalReception) === null || _c === void 0 ? void 0 : _c.languages
                }, {
                    children: isActivation ? (0, $bhfvP.jsx)($5b269012e369b2e4$var$Activation, {}) : (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
                        children: (0, $bhfvP.jsxs)($5b269012e369b2e4$var$LazyScannerProvider, {
                            children: [
                                (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$1ac4a28ba936c3b0), {
                                    children: children
                                }),
                                (0, $bhfvP.jsx)((0, $l4qYG.ScreensaverRouter), {})
                            ]
                        })
                    })
                }))
            })),
            (0, $bhfvP.jsx)((0, $c2e305494bbce9cc$export$2e2bcd8739ae039), {}),
            (0, $bhfvP.jsx)((0, $db075bdb02672c7e$export$2e2bcd8739ae039), Object.assign({
                in: isLoadingOnline,
                appear: false,
                unmountOnExit: true
            }, {
                children: (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), Object.assign({
                    container: true,
                    alignItems: "center",
                    justifyContent: "center",
                    className: "position-absolute top-0 bottom-0 left-0 right-0 bg-white"
                }, {
                    children: (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), Object.assign({
                        item: true
                    }, {
                        children: (0, $bhfvP.jsx)((0, $046757d70188c03a$export$2e2bcd8739ae039), {
                            size: "8rem"
                        })
                    }))
                }))
            }))
        ]
    });
});
const $5b269012e369b2e4$var$App = ()=>(0, $bhfvP.jsx)((0, $l4qYG.SchedulesProvider), {
        children: (0, $bhfvP.jsx)((0, $219y6.default), {
            children: (0, $bhfvP.jsx)((0, $cwDEq.default), {
                children: (0, $bhfvP.jsx)($5b269012e369b2e4$var$Providers, {
                    children: (0, $bhfvP.jsxs)($5b269012e369b2e4$var$Container, Object.assign({
                        className: "w-100 d-flex flex-column position-relative overflow-hidden"
                    }, {
                        children: [
                            (0, $bhfvP.jsx)((0, $b755228935a0d77c$export$2e2bcd8739ae039), {}),
                            (0, $bhfvP.jsx)("main", Object.assign({
                                className: "flex-grow-1"
                            }, {
                                children: (0, $bhfvP.jsx)($5b269012e369b2e4$var$AppRouter, {})
                            })),
                            (0, $bhfvP.jsx)((0, $fff02e413e096509$export$2e2bcd8739ae039), {})
                        ]
                    }))
                })
            })
        })
    });
document.addEventListener("contextmenu", (event)=>event.preventDefault());
const $5b269012e369b2e4$var$container = document.getElementById("root");
const $5b269012e369b2e4$var$root = (0, $5644a0fb91926e5b$export$882461b6382ed46c)($5b269012e369b2e4$var$container);
$5b269012e369b2e4$var$root.render((0, $bhfvP.jsx)($5b269012e369b2e4$var$App, {}));

})();
//# sourceMappingURL=index.84531734.js.map
